/*!
 *
 * Bryntum Scheduler 4.0.3
 *
 * Copyright(c) 2020 Bryntum AB
 * https://bryntum.com/contact
 * https://bryntum.com/license
 *
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("scheduler", [], factory);
	else if(typeof exports === 'object')
		exports["scheduler"] = factory();
	else
		root["bryntum"] = root["bryntum"] || {}, root["bryntum"]["scheduler"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./webpack.entry.umd.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../node_modules/process/browser.js":
/*!******************************************!*\
  !*** ../node_modules/process/browser.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../node_modules/webpack/buildin/global.js":
/*!*************************************************!*\
  !*** ../node_modules/webpack/buildin/global.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "../scripts/js/bundle-polyfills.js":
/*!*****************************************!*\
  !*** ../scripts/js/bundle-polyfills.js ***!
  \*****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var whatwg_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! whatwg-fetch */ "./node_modules/whatwg-fetch/fetch.js");
/* harmony import */ var abortcontroller_polyfill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! abortcontroller-polyfill */ "./node_modules/abortcontroller-polyfill/dist/umd-polyfill.js");
/* harmony import */ var abortcontroller_polyfill__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(abortcontroller_polyfill__WEBPACK_IMPORTED_MODULE_1__);
var productName = 'scheduler'; // Polyfills used for bundles




/***/ }),

/***/ "./lib/ChronoGraph/chrono/CycleResolver.js":
/*!*************************************************!*\
  !*** ./lib/ChronoGraph/chrono/CycleResolver.js ***!
  \*************************************************/
/*! exports provided: CycleResolutionInputChrono */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CycleResolutionInputChrono", function() { return CycleResolutionInputChrono; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _Effect_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var CycleResolutionInputChrono = /*#__PURE__*/function (_CycleResolutionInput) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CycleResolutionInputChrono, _CycleResolutionInput);

  var _super = _createSuper(CycleResolutionInputChrono);

  function CycleResolutionInputChrono() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, CycleResolutionInputChrono);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(CycleResolutionInputChrono, [{
    key: "collectInfo",
    value: function collectInfo(Y, identifier, symbol) {
      if (Y(Object(_Effect_js__WEBPACK_IMPORTED_MODULE_9__["PreviousValueOf"])(identifier)) != null) this.addPreviousValueFlag(symbol);
      if (Y(Object(_Effect_js__WEBPACK_IMPORTED_MODULE_9__["HasProposedValue"])(identifier))) this.addProposedValueFlag(symbol);
    }
  }]);

  return CycleResolutionInputChrono;
}(_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_8__["CycleResolutionInput"]);

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Effect.js":
/*!******************************************!*\
  !*** ./lib/ChronoGraph/chrono/Effect.js ***!
  \******************************************/
/*! exports provided: BreakCurrentStackExecution, Effect, ProposedOrPreviousSymbol, ProposedOrPrevious, RejectSymbol, RejectEffect, Reject, TransactionSymbol, GetTransaction, OwnQuarkSymbol, OwnQuark, OwnIdentifierSymbol, OwnIdentifier, WriteSymbol, WriteEffect, Write, WriteSeveralSymbol, WriteSeveralEffect, WriteSeveral, PreviousValueOfSymbol, PreviousValueOfEffect, PreviousValueOf, ProposedValueOfSymbol, ProposedValueOfEffect, ProposedValueOf, HasProposedValueSymbol, HasProposedValueEffect, HasProposedValue, ProposedOrPreviousValueOfSymbol, ProposedOrPreviousValueOfEffect, ProposedOrPreviousValueOf, ProposedArgumentsOfSymbol, ProposedArgumentsOfEffect, ProposedArgumentsOf, UnsafeProposedOrPreviousValueOfSymbol, UnsafeProposedOrPreviousValueOfEffect, UnsafeProposedOrPreviousValueOf, UnsafePreviousValueOfSymbol, UnsafePreviousValueOfEffect, UnsafePreviousValueOf */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BreakCurrentStackExecution", function() { return BreakCurrentStackExecution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Effect", function() { return Effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousSymbol", function() { return ProposedOrPreviousSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPrevious", function() { return ProposedOrPrevious; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RejectSymbol", function() { return RejectSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RejectEffect", function() { return RejectEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reject", function() { return Reject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransactionSymbol", function() { return TransactionSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GetTransaction", function() { return GetTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OwnQuarkSymbol", function() { return OwnQuarkSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OwnQuark", function() { return OwnQuark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OwnIdentifierSymbol", function() { return OwnIdentifierSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OwnIdentifier", function() { return OwnIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteSymbol", function() { return WriteSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteEffect", function() { return WriteEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Write", function() { return Write; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteSeveralSymbol", function() { return WriteSeveralSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteSeveralEffect", function() { return WriteSeveralEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WriteSeveral", function() { return WriteSeveral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviousValueOfSymbol", function() { return PreviousValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviousValueOfEffect", function() { return PreviousValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviousValueOf", function() { return PreviousValueOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedValueOfSymbol", function() { return ProposedValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedValueOfEffect", function() { return ProposedValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedValueOf", function() { return ProposedValueOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasProposedValueSymbol", function() { return HasProposedValueSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasProposedValueEffect", function() { return HasProposedValueEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasProposedValue", function() { return HasProposedValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousValueOfSymbol", function() { return ProposedOrPreviousValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousValueOfEffect", function() { return ProposedOrPreviousValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedOrPreviousValueOf", function() { return ProposedOrPreviousValueOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedArgumentsOfSymbol", function() { return ProposedArgumentsOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedArgumentsOfEffect", function() { return ProposedArgumentsOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProposedArgumentsOf", function() { return ProposedArgumentsOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafeProposedOrPreviousValueOfSymbol", function() { return UnsafeProposedOrPreviousValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafeProposedOrPreviousValueOfEffect", function() { return UnsafeProposedOrPreviousValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafeProposedOrPreviousValueOf", function() { return UnsafeProposedOrPreviousValueOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafePreviousValueOfSymbol", function() { return UnsafePreviousValueOfSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafePreviousValueOfEffect", function() { return UnsafePreviousValueOfEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsafePreviousValueOf", function() { return UnsafePreviousValueOf; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var BreakCurrentStackExecution = Symbol('BreakCurrentStackExecution');
var Effect = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Effect, _Base);

  var _super = _createSuper(Effect);

  function Effect() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Effect);

    return _super.apply(this, arguments);
  }

  return Effect;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_12__["Base"]);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_13__["prototypeValue"])(true)], Effect.prototype, "sync", void 0);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_13__["prototypeValue"])(true)], Effect.prototype, "pure", void 0);

var ProposedOrPreviousSymbol = Symbol('ProposedOrPreviousSymbol');
var ProposedOrPrevious = Effect.new({
  handler: ProposedOrPreviousSymbol
});
var RejectSymbol = Symbol('RejectSymbol');
var RejectEffect = /*#__PURE__*/function (_Effect) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(RejectEffect, _Effect);

  var _super2 = _createSuper(RejectEffect);

  function RejectEffect() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, RejectEffect);

    _this = _super2.apply(this, arguments);
    _this.handler = RejectSymbol;
    return _this;
  }

  return RejectEffect;
}(Effect);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_13__["prototypeValue"])(false)], RejectEffect.prototype, "pure", void 0);

var Reject = function Reject(reason) {
  return RejectEffect.new({
    reason: reason
  });
};
var TransactionSymbol = Symbol('TransactionSymbol');
var GetTransaction = Effect.new({
  handler: TransactionSymbol
});
var OwnQuarkSymbol = Symbol('OwnQuarkSymbol');
var OwnQuark = Effect.new({
  handler: OwnQuarkSymbol
});
var OwnIdentifierSymbol = Symbol('OwnIdentifierSymbol');
var OwnIdentifier = Effect.new({
  handler: OwnIdentifierSymbol
});
var WriteSymbol = Symbol('WriteSymbol');
var WriteEffect = /*#__PURE__*/function (_Effect2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(WriteEffect, _Effect2);

  var _super3 = _createSuper(WriteEffect);

  function WriteEffect() {
    var _this2;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, WriteEffect);

    _this2 = _super3.apply(this, arguments);
    _this2.handler = WriteSymbol;
    return _this2;
  }

  return WriteEffect;
}(Effect);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_13__["prototypeValue"])(false)], WriteEffect.prototype, "pure", void 0);

var Write = function Write(identifier, proposedValue) {
  for (var _len = arguments.length, proposedArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    proposedArgs[_key - 2] = arguments[_key];
  }

  return WriteEffect.new({
    identifier: identifier,
    proposedArgs: [proposedValue].concat(proposedArgs)
  });
};
var WriteSeveralSymbol = Symbol('WriteSeveralSymbol');
var WriteSeveralEffect = /*#__PURE__*/function (_Effect3) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(WriteSeveralEffect, _Effect3);

  var _super4 = _createSuper(WriteSeveralEffect);

  function WriteSeveralEffect() {
    var _this3;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, WriteSeveralEffect);

    _this3 = _super4.apply(this, arguments);
    _this3.handler = WriteSeveralSymbol;
    return _this3;
  }

  return WriteSeveralEffect;
}(Effect);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_13__["prototypeValue"])(false)], WriteSeveralEffect.prototype, "pure", void 0);

var WriteSeveral = function WriteSeveral(writes) {
  return WriteSeveralEffect.new({
    writes: writes
  });
};
var PreviousValueOfSymbol = Symbol('PreviousValueOfSymbol');
var PreviousValueOfEffect = /*#__PURE__*/function (_Effect4) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(PreviousValueOfEffect, _Effect4);

  var _super5 = _createSuper(PreviousValueOfEffect);

  function PreviousValueOfEffect() {
    var _this4;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, PreviousValueOfEffect);

    _this4 = _super5.apply(this, arguments);
    _this4.handler = PreviousValueOfSymbol;
    return _this4;
  }

  return PreviousValueOfEffect;
}(Effect);
var PreviousValueOf = function PreviousValueOf(identifier) {
  return PreviousValueOfEffect.new({
    identifier: identifier
  });
};
var ProposedValueOfSymbol = Symbol('ProposedValueOfSymbol');
var ProposedValueOfEffect = /*#__PURE__*/function (_Effect5) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ProposedValueOfEffect, _Effect5);

  var _super6 = _createSuper(ProposedValueOfEffect);

  function ProposedValueOfEffect() {
    var _this5;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ProposedValueOfEffect);

    _this5 = _super6.apply(this, arguments);
    _this5.handler = ProposedValueOfSymbol;
    return _this5;
  }

  return ProposedValueOfEffect;
}(Effect);
var ProposedValueOf = function ProposedValueOf(identifier) {
  return ProposedValueOfEffect.new({
    identifier: identifier
  });
};
var HasProposedValueSymbol = Symbol('HasProposedValueSymbol');
var HasProposedValueEffect = /*#__PURE__*/function (_Effect6) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(HasProposedValueEffect, _Effect6);

  var _super7 = _createSuper(HasProposedValueEffect);

  function HasProposedValueEffect() {
    var _this6;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, HasProposedValueEffect);

    _this6 = _super7.apply(this, arguments);
    _this6.handler = HasProposedValueSymbol;
    return _this6;
  }

  return HasProposedValueEffect;
}(Effect);
var HasProposedValue = function HasProposedValue(identifier) {
  return HasProposedValueEffect.new({
    identifier: identifier
  });
};
var ProposedOrPreviousValueOfSymbol = Symbol('ProposedOrPreviousValueOfSymbol');
var ProposedOrPreviousValueOfEffect = /*#__PURE__*/function (_Effect7) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ProposedOrPreviousValueOfEffect, _Effect7);

  var _super8 = _createSuper(ProposedOrPreviousValueOfEffect);

  function ProposedOrPreviousValueOfEffect() {
    var _this7;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ProposedOrPreviousValueOfEffect);

    _this7 = _super8.apply(this, arguments);
    _this7.handler = ProposedOrPreviousValueOfSymbol;
    return _this7;
  }

  return ProposedOrPreviousValueOfEffect;
}(Effect);
var ProposedOrPreviousValueOf = function ProposedOrPreviousValueOf(identifier) {
  return ProposedOrPreviousValueOfEffect.new({
    identifier: identifier
  });
};
var ProposedArgumentsOfSymbol = Symbol('ProposedArgumentsOfSymbol');
var ProposedArgumentsOfEffect = /*#__PURE__*/function (_Effect8) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ProposedArgumentsOfEffect, _Effect8);

  var _super9 = _createSuper(ProposedArgumentsOfEffect);

  function ProposedArgumentsOfEffect() {
    var _this8;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ProposedArgumentsOfEffect);

    _this8 = _super9.apply(this, arguments);
    _this8.handler = ProposedArgumentsOfSymbol;
    return _this8;
  }

  return ProposedArgumentsOfEffect;
}(Effect);
var ProposedArgumentsOf = function ProposedArgumentsOf(identifier) {
  return ProposedArgumentsOfEffect.new({
    identifier: identifier
  });
};
var UnsafeProposedOrPreviousValueOfSymbol = Symbol('UnsafeProposedOrPreviousValueOfSymbol');
var UnsafeProposedOrPreviousValueOfEffect = /*#__PURE__*/function (_Effect9) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(UnsafeProposedOrPreviousValueOfEffect, _Effect9);

  var _super10 = _createSuper(UnsafeProposedOrPreviousValueOfEffect);

  function UnsafeProposedOrPreviousValueOfEffect() {
    var _this9;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, UnsafeProposedOrPreviousValueOfEffect);

    _this9 = _super10.apply(this, arguments);
    _this9.handler = UnsafeProposedOrPreviousValueOfSymbol;
    return _this9;
  }

  return UnsafeProposedOrPreviousValueOfEffect;
}(Effect);
var UnsafeProposedOrPreviousValueOf = function UnsafeProposedOrPreviousValueOf(identifier) {
  return UnsafeProposedOrPreviousValueOfEffect.new({
    identifier: identifier
  });
};
var UnsafePreviousValueOfSymbol = Symbol('UnsafePreviousValueOfSymbol');
var UnsafePreviousValueOfEffect = /*#__PURE__*/function (_Effect10) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(UnsafePreviousValueOfEffect, _Effect10);

  var _super11 = _createSuper(UnsafePreviousValueOfEffect);

  function UnsafePreviousValueOfEffect() {
    var _this10;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, UnsafePreviousValueOfEffect);

    _this10 = _super11.apply(this, arguments);
    _this10.handler = UnsafePreviousValueOfSymbol;
    return _this10;
  }

  return UnsafePreviousValueOfEffect;
}(Effect);
var UnsafePreviousValueOf = function UnsafePreviousValueOf(identifier) {
  return UnsafePreviousValueOfEffect.new({
    identifier: identifier
  });
};

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Graph.js":
/*!*****************************************!*\
  !*** ./lib/ChronoGraph/chrono/Graph.js ***!
  \*****************************************/
/*! exports provided: CommitZero, Listener, ChronoGraph */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommitZero", function() { return CommitZero; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Listener", function() { return Listener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoGraph", function() { return ChronoGraph; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.promise.finally */ "./node_modules/core-js/modules/es.promise.finally.js");
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_59___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_59__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Effect_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _Quark_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _Revision_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ./Revision.js */ "./lib/ChronoGraph/chrono/Revision.js");
/* harmony import */ var _Transaction_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ./Transaction.js */ "./lib/ChronoGraph/chrono/Transaction.js");





























































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_59___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_59___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_58___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';









var CommitZero = {
  rejectedWith: null
};
var Listener = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_57___default()(Listener, _Base);

  var _super = _createSuper(Listener);

  function Listener() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_55___default()(this, Listener);

    _this = _super.apply(this, arguments);
    _this.handlers = [];
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_56___default()(Listener, [{
    key: "trigger",
    value: function trigger(value) {
      for (var i = 0; i < this.handlers.length; i++) {
        this.handlers[i](value);
      }
    }
  }]);

  return Listener;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_60__["Base"]);
var ChronoGraph = /*#__PURE__*/function (_Base2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_57___default()(ChronoGraph, _Base2);

  var _super2 = _createSuper(ChronoGraph);

  function ChronoGraph() {
    var _this2;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_55___default()(this, ChronoGraph);

    _this2 = _super2.apply(this, arguments);
    _this2.baseRevisionStable = undefined;
    _this2.baseRevisionTentative = undefined;
    _this2.baseRevision = _Revision_js__WEBPACK_IMPORTED_MODULE_67__["Revision"].new();
    _this2.topRevision = undefined;
    _this2.historyLimit = 0;
    _this2.listeners = new Map();
    _this2.$activeTransaction = undefined;
    _this2.isCommitting = false;
    _this2.enableProgressNotifications = false;
    _this2.ongoing = Promise.resolve();
    _this2._isInitialCommit = true;
    _this2.autoCommitTimeoutId = null;
    _this2.autoCommit = false;
    _this2.autoCommitMode = 'sync';
    _this2.autoCommitHandler = null;
    _this2.onWriteDuringCommit = 'throw';
    _this2.onComputationCycle = 'throw';
    _this2.transactionClass = _Transaction_js__WEBPACK_IMPORTED_MODULE_68__["Transaction"];
    _this2.$followingRevision = undefined;
    return _this2;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_56___default()(ChronoGraph, [{
    key: "initialize",
    value: function initialize() {
      var _get2,
          _this3 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_54___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_59___default()(ChronoGraph.prototype), "initialize", this)).call.apply(_get2, [this].concat(args));

      if (!this.topRevision) this.topRevision = this.baseRevision;

      if (this.autoCommit) {
        this.autoCommitHandler = this.autoCommitMode === 'sync' ? function (arg) {
          return _this3.commit(arg);
        } : /*#__PURE__*/function () {
          var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_53___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.mark(function _callee(arg) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", _this3.commitAsync(arg));

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }

      this.markAndSweep();
    }
  }, {
    key: "hasPendingAutoCommit",
    value: function hasPendingAutoCommit() {
      return this.autoCommitTimeoutId !== null;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.reject();
      this.unScheduleAutoCommit();
      this.baseRevision.scope && this.baseRevision.scope.clear();
      this.baseRevision.previous = null;
      this.listeners.clear();
      this.topRevision = this.baseRevision;
      this.$followingRevision = undefined;
      this.$activeTransaction = undefined;
      this.markAndSweep();
    }
  }, {
    key: "eachReachableRevision",
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.mark(function eachReachableRevision() {
      var isBetweenTopBottom, counter, _iterator, _step, revision;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.wrap(function eachReachableRevision$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isBetweenTopBottom = true;
              counter = 0;
              _iterator = _createForOfIteratorHelper(this.topRevision.previousAxis());
              _context2.prev = 3;

              _iterator.s();

            case 5:
              if ((_step = _iterator.n()).done) {
                _context2.next = 12;
                break;
              }

              revision = _step.value;
              _context2.next = 9;
              return [revision, isBetweenTopBottom || counter < this.historyLimit];

            case 9:
              if (revision === this.baseRevision) {
                isBetweenTopBottom = false;
              } else {
                if (!isBetweenTopBottom) counter++;
              }

            case 10:
              _context2.next = 5;
              break;

            case 12:
              _context2.next = 17;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](3);

              _iterator.e(_context2.t0);

            case 17:
              _context2.prev = 17;

              _iterator.f();

              return _context2.finish(17);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, eachReachableRevision, this, [[3, 14, 17, 20]]);
    })
  }, {
    key: "markAndSweep",
    value: function markAndSweep() {
      var lastReferencedRevision;
      var unreachableRevisions = [];

      var _iterator2 = _createForOfIteratorHelper(this.eachReachableRevision()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_50___default()(_step2.value, 2),
              revision = _step2$value[0],
              isReachable = _step2$value[1];

          if (isReachable) {
            revision.reachableCount++;
            lastReferencedRevision = revision;
          } else unreachableRevisions.push(revision);

          revision.referenceCount++;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      unreachableRevisions.unshift(lastReferencedRevision);

      for (var i = unreachableRevisions.length - 1; i >= 1 && unreachableRevisions[i].reachableCount === 0; i--) {
        this.compactRevisions(unreachableRevisions[i - 1], unreachableRevisions[i]);
      }
    }
  }, {
    key: "compactRevisions",
    value: function compactRevisions(newRev, prevRev) {
      if (prevRev.reachableCount > 0 || newRev.previous !== prevRev) throw new Error("Invalid compact operation");

      if (prevRev.referenceCount <= 1) {
        var _iterator3 = _createForOfIteratorHelper(newRev.scope),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_50___default()(_step3.value, 2),
                identifier = _step3$value[0],
                entry = _step3$value[1];

            if (entry.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_66__["TombStone"]) {
              prevRev.scope.delete(identifier);
            } else {
              var prevQuark = prevRev.scope.get(identifier);

              if (entry.origin === entry) {
                if (prevQuark) {
                  prevQuark.clear();
                  prevQuark.clearProperties();
                }
              } else if (prevQuark && entry.origin === prevQuark) {
                entry.mergePreviousOrigin(newRev.scope);
              } else if (identifier.lazy && !entry.origin && prevQuark && prevQuark.origin) {
                entry.startOrigin().proposedValue = prevQuark.origin.value !== undefined ? prevQuark.origin.value : prevQuark.origin.proposedValue;
              }

              entry.previous = undefined;
              prevRev.scope.set(identifier, entry);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_63__["copySetInto"])(newRev.selfDependent, prevRev.selfDependent);
        newRev.scope = prevRev.scope;
        prevRev.scope = null;
      } else {
        newRev.scope = new Map(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_61__["concat"])(prevRev.scope, newRev.scope));
        newRev.selfDependent = new Set(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_61__["concat"])(prevRev.selfDependent, newRev.selfDependent));
        prevRev.referenceCount--;
      }

      newRev.previous = null;
    }
  }, {
    key: "branch",
    value: function branch(config) {
      var Constructor = this.constructor;
      return Constructor.new(Object.assign({}, config, {
        baseRevision: this.baseRevision
      }));
    }
  }, {
    key: "propagate",
    value: function propagate(args) {
      return this.commit(args);
    }
  }, {
    key: "reject",
    value: function reject(reason) {
      this.activeTransaction.reject(_Effect_js__WEBPACK_IMPORTED_MODULE_64__["RejectEffect"].new({
        reason: reason
      }));
      this.ongoing = Promise.resolve();
      this.$activeTransaction = undefined;
      this.baseRevisionTentative = undefined;

      if (this.baseRevisionStable) {
        this.baseRevision = this.baseRevisionStable;
        this.baseRevisionStable = undefined;
      }
    }
  }, {
    key: "commit",
    value: function commit(args) {
      this.unScheduleAutoCommit();
      this.baseRevisionStable = this.baseRevision;
      var activeTransaction = this.activeTransaction;
      var transactionCommitResult = activeTransaction.commit(args);
      this.$activeTransaction = undefined;
      var result = this.finalizeCommit(transactionCommitResult);
      this.baseRevisionStable = undefined;
      this.isInitialCommit = false;
      return result;
    }
  }, {
    key: "propagateAsync",
    value: function () {
      var _propagateAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_53___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.mark(function _callee2(args) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.commitAsync(args));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function propagateAsync(_x2) {
        return _propagateAsync.apply(this, arguments);
      }

      return propagateAsync;
    }()
  }, {
    key: "commitAsync",
    value: function () {
      var _commitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_53___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.mark(function _callee3(args) {
        var _this4 = this;

        var result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.isCommitting) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", this.ongoing);

              case 2:
                this.isCommitting = true;
                this.baseRevisionStable = this.baseRevision;
                return _context4.abrupt("return", this.ongoing = this.ongoing.then(function () {
                  return _this4.doCommitAsync(args);
                }).then(function (res) {
                  result = res;
                  return res;
                }).finally(function () {
                  _this4.baseRevisionStable = undefined;
                  _this4.baseRevisionTentative = undefined;
                  _this4.isInitialCommit = false;
                  _this4.isCommitting = false;
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this);
      }));

      function commitAsync(_x3) {
        return _commitAsync.apply(this, arguments);
      }

      return commitAsync;
    }()
  }, {
    key: "doCommitAsync",
    value: function () {
      var _doCommitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_53___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.mark(function _callee4(args) {
        var activeTransaction, transactionResult, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.unScheduleAutoCommit();
                activeTransaction = this.activeTransaction;
                _context5.next = 4;
                return activeTransaction.commitAsync(args);

              case 4:
                transactionResult = _context5.sent;
                this.baseRevisionTentative = activeTransaction.candidate;
                this.$activeTransaction = undefined;
                result = this.finalizeCommit(transactionResult);
                _context5.next = 10;
                return this.finalizeCommitAsync(transactionResult);

              case 10:
                if (!this.activeTransaction.dirty) {
                  _context5.next = 16;
                  break;
                }

                _context5.next = 13;
                return this.doCommitAsync(args);

              case 13:
                return _context5.abrupt("return", _context5.sent);

              case 16:
                return _context5.abrupt("return", result);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4, this);
      }));

      function doCommitAsync(_x4) {
        return _doCommitAsync.apply(this, arguments);
      }

      return doCommitAsync;
    }()
  }, {
    key: "finalizeCommit",
    value: function finalizeCommit(transactionResult) {
      var revision = transactionResult.revision,
          entries = transactionResult.entries,
          transaction = transactionResult.transaction;

      if (!transaction.rejectedWith) {
        if (revision.previous !== this.baseRevision) throw new Error('Invalid revisions chain');

        var _iterator4 = _createForOfIteratorHelper(this.eachReachableRevision()),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_50___default()(_step4.value, 2),
                _revision = _step4$value[0],
                isReachable = _step4$value[1];

            if (isReachable) _revision.reachableCount--;
            _revision.referenceCount--;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.baseRevision = this.topRevision = revision;

        var _iterator5 = _createForOfIteratorHelper(entries),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _step5$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_50___default()(_step5.value, 2),
                identifier = _step5$value[0],
                quarkEntry = _step5$value[1];

            quarkEntry.cleanup();
            if (quarkEntry.isShadow() || !quarkEntry.hasValue()) continue;
            var listener = this.listeners.get(identifier);
            if (listener) listener.trigger(quarkEntry.getValue());
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        this.$followingRevision = undefined;
        this.markAndSweep();
      } else {
        if (this.baseRevisionStable) this.baseRevision = this.baseRevisionStable;
        this.baseRevisionStable = undefined;
        this.baseRevisionTentative = undefined;
      }

      return {
        rejectedWith: transaction.rejectedWith
      };
    }
  }, {
    key: "finalizeCommitAsync",
    value: function () {
      var _finalizeCommitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_53___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.mark(function _callee5(transactionResult) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_51___default.a.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5);
      }));

      function finalizeCommitAsync(_x5) {
        return _finalizeCommitAsync.apply(this, arguments);
      }

      return finalizeCommitAsync;
    }()
  }, {
    key: "onComputationCycleHandler",
    value: function onComputationCycleHandler(activeEntry, requestedEntry, cycle) {
      var exception = new Error("Computation cycle:\n" + cycle);
      exception.cycle = cycle;

      switch (this.onComputationCycle) {
        case 'ignore':
          console.log(exception.message);
          return activeEntry.continueCalculation(requestedEntry.proposedValue !== undefined ? requestedEntry.proposedValue : requestedEntry.value);

        case 'throw':
          throw exception;

        case 'reject':
          this.reject(exception);
          break;

        case 'warn':
          Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_62__["warn"])(exception);
          break;
      }
    }
  }, {
    key: "scheduleAutoCommit",
    value: function scheduleAutoCommit() {
      if (this.autoCommitTimeoutId === null) {
        this.autoCommitTimeoutId = setTimeout(this.autoCommitHandler, 10);
      }
    }
  }, {
    key: "unScheduleAutoCommit",
    value: function unScheduleAutoCommit() {
      if (this.autoCommitTimeoutId !== null) {
        clearTimeout(this.autoCommitTimeoutId);
        this.autoCommitTimeoutId = null;
      }
    }
  }, {
    key: "variable",
    value: function variable(value) {
      var variable = Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_65__["VariableC"])();
      return this.addIdentifier(variable, value === undefined ? null : value);
    }
  }, {
    key: "variableNamed",
    value: function variableNamed(name, value) {
      var variable = Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_65__["VariableC"])({
        name: name
      });
      return this.addIdentifier(variable, value === undefined ? null : value);
    }
  }, {
    key: "identifier",
    value: function identifier(calculation, context) {
      var identifier = Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_63__["isGeneratorFunction"])(calculation) ? Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_65__["CalculatedValueGenC"])({
        calculation: calculation,
        context: context
      }) : Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_65__["CalculatedValueSyncC"])({
        calculation: calculation,
        context: context
      });
      return this.addIdentifier(identifier);
    }
  }, {
    key: "identifierNamed",
    value: function identifierNamed(name, calculation, context) {
      var identifier = calculation.constructor.name === 'GeneratorFunction' ? Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_65__["CalculatedValueGenC"])({
        name: name,
        calculation: calculation,
        context: context
      }) : Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_65__["CalculatedValueSyncC"])({
        name: name,
        calculation: calculation,
        context: context
      });
      return this.addIdentifier(identifier);
    }
  }, {
    key: "addIdentifier",
    value: function addIdentifier(identifier, proposedValue) {
      var _this$activeTransacti;

      if (this.isCommitting) {
        if (this.onWriteDuringCommit === 'throw') throw new Error('Adding identifier during commit');else if (this.onWriteDuringCommit === 'warn') Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_62__["warn"])(new Error('Adding identifier during commit'));
      }

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      (_this$activeTransacti = this.activeTransaction).addIdentifier.apply(_this$activeTransacti, [identifier, proposedValue].concat(args));

      if (this.autoCommit) this.scheduleAutoCommit();
      return identifier;
    }
  }, {
    key: "removeIdentifier",
    value: function removeIdentifier(identifier) {
      if (this.isCommitting) {
        if (this.onWriteDuringCommit === 'throw') throw new Error('Removing identifier during commit');else if (this.onWriteDuringCommit === 'warn') Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_62__["warn"])(new Error('Removinfg identifier during commit'));
      }

      this.activeTransaction.removeIdentifier(identifier);
      this.listeners.delete(identifier);
      if (this.autoCommit) this.scheduleAutoCommit();
    }
  }, {
    key: "hasIdentifier",
    value: function hasIdentifier(identifier) {
      return this.activeTransaction.hasIdentifier(identifier);
    }
  }, {
    key: "write",
    value: function write(identifier, proposedValue) {
      var _this$activeTransacti2;

      if (this.isCommitting) {
        if (this.onWriteDuringCommit === 'throw') throw new Error('Write during commit');else if (this.onWriteDuringCommit === 'warn') Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_62__["warn"])(new Error('Write during commit'));
      }

      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      (_this$activeTransacti2 = this.activeTransaction).write.apply(_this$activeTransacti2, [identifier, proposedValue].concat(args));

      if (this.autoCommit) this.scheduleAutoCommit();
    }
  }, {
    key: "readPrevious",
    value: function readPrevious(identifier) {
      return this.activeTransaction.readPrevious(identifier);
    }
  }, {
    key: "readPreviousAsync",
    value: function readPreviousAsync(identifier) {
      return this.activeTransaction.readPreviousAsync(identifier);
    }
  }, {
    key: "read",
    value: function read(identifier) {
      return this.activeTransaction.read(identifier);
    }
  }, {
    key: "readAsync",
    value: function readAsync(identifier) {
      return this.activeTransaction.readAsync(identifier);
    }
  }, {
    key: "get",
    value: function get(identifier) {
      return this.activeTransaction.get(identifier);
    }
  }, {
    key: "observe",
    value: function observe(observerFunc, onUpdated) {
      var identifier = this.addIdentifier(_Identifier_js__WEBPACK_IMPORTED_MODULE_65__["CalculatedValueGen"].new({
        lazy: false,
        calculation: observerFunc
      }));
      this.addListener(identifier, onUpdated);
      return identifier;
    }
  }, {
    key: "observeContext",
    value: function observeContext(observerFunc, context, onUpdated) {
      var identifier = this.addIdentifier(_Identifier_js__WEBPACK_IMPORTED_MODULE_65__["CalculatedValueGen"].new({
        lazy: false,
        calculation: observerFunc,
        context: context
      }));
      this.addListener(identifier, onUpdated);
      return identifier;
    }
  }, {
    key: "addListener",
    value: function addListener(identifier, onUpdated) {
      var listener = this.listeners.get(identifier);

      if (!listener) {
        listener = Listener.new();
        this.listeners.set(identifier, listener);
      }

      listener.handlers.push(onUpdated);
    }
  }, {
    key: "undo",
    value: function undo() {
      var baseRevision = this.baseRevision;
      var previous = baseRevision.previous;
      if (!previous) return false;
      this.baseRevision = previous;
      this.$activeTransaction = undefined;
      return true;
    }
  }, {
    key: "redo",
    value: function redo() {
      var baseRevision = this.baseRevision;
      if (baseRevision === this.topRevision) return false;
      var nextRevision = this.followingRevision.get(baseRevision);
      this.baseRevision = nextRevision;
      this.$activeTransaction = undefined;
      return true;
    }
  }, {
    key: "onPropagationProgressNotification",
    value: function onPropagationProgressNotification(notification) {}
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["ProposedOrPreviousSymbol"],
    value: function value(effect, transaction) {
      var activeEntry = transaction.getActiveEntry();
      activeEntry.usedProposedOrPrevious = true;
      var proposedValue = activeEntry.getProposedValue(transaction);
      if (proposedValue !== undefined) return proposedValue;
      if (!activeEntry.previous) return undefined;
      var identifier = activeEntry.identifier;

      if (identifier.lazy) {
        if (activeEntry.previous.hasValue()) return activeEntry.previous.getValue();
        if (activeEntry.previous.hasProposedValue()) return activeEntry.previous.getProposedValue(transaction);
        return null;
      }

      return transaction.readPrevious(activeEntry.identifier);
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["RejectSymbol"],
    value: function value(effect, transaction) {
      this.reject(effect.reason);
      return _Effect_js__WEBPACK_IMPORTED_MODULE_64__["BreakCurrentStackExecution"];
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["TransactionSymbol"],
    value: function value(effect, transaction) {
      return transaction;
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["OwnQuarkSymbol"],
    value: function value(effect, transaction) {
      return transaction.getActiveEntry();
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["OwnIdentifierSymbol"],
    value: function value(effect, transaction) {
      var activeEntry = transaction.getActiveEntry();
      return activeEntry.identifier;
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["WriteSymbol"],
    value: function value(effect, transaction) {
      var activeEntry = transaction.getActiveEntry();
      if (activeEntry.identifier.lazy) throw new Error('Lazy identifiers can not use `Write` effect');
      var writeToHigherLevel = effect.identifier.level > activeEntry.identifier.level;
      if (!writeToHigherLevel) transaction.walkContext.startNewEpoch();
      transaction.write.apply(transaction, [effect.identifier].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_49___default()(effect.proposedArgs)));
      return writeToHigherLevel ? undefined : _Effect_js__WEBPACK_IMPORTED_MODULE_64__["BreakCurrentStackExecution"];
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["WriteSeveralSymbol"],
    value: function value(effect, transaction) {
      var activeEntry = transaction.getActiveEntry();
      if (activeEntry.identifier.lazy) throw new Error('Lazy identifiers can not use `Write` effect');
      var writeToHigherLevel = true;
      effect.writes.forEach(function (writeInfo) {
        if (writeInfo.identifier.level <= activeEntry.identifier.level && writeToHigherLevel) {
          transaction.walkContext.startNewEpoch();
          writeToHigherLevel = false;
        }

        transaction.write.apply(transaction, [writeInfo.identifier].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_49___default()(writeInfo.proposedArgs)));
      });
      return writeToHigherLevel ? undefined : _Effect_js__WEBPACK_IMPORTED_MODULE_64__["BreakCurrentStackExecution"];
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["PreviousValueOfSymbol"],
    value: function value(effect, transaction) {
      var activeEntry = transaction.getActiveEntry();
      var source = effect.identifier;
      transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_68__["EdgeTypePast"]);
      return transaction.readPrevious(source);
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["ProposedValueOfSymbol"],
    value: function value(effect, transaction) {
      var activeEntry = transaction.getActiveEntry();
      var source = effect.identifier;
      transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_68__["EdgeTypePast"]);
      var quark = transaction.entries.get(source);
      var proposedValue = quark && !quark.isShadow() ? quark.getProposedValue(transaction) : undefined;
      return proposedValue;
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["HasProposedValueSymbol"],
    value: function value(effect, transaction) {
      var activeEntry = transaction.getActiveEntry();
      var source = effect.identifier;
      transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_68__["EdgeTypePast"]);
      var quark = transaction.entries.get(source);
      return quark ? quark.hasProposedValue() : false;
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["ProposedOrPreviousValueOfSymbol"],
    value: function value(effect, transaction) {
      var activeEntry = transaction.getActiveEntry();
      var source = effect.identifier;
      transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_68__["EdgeTypePast"]);
      return transaction.readProposedOrPrevious(source);
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["UnsafeProposedOrPreviousValueOfSymbol"],
    value: function value(effect, transaction) {
      return transaction.readProposedOrPrevious(effect.identifier);
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["UnsafePreviousValueOfSymbol"],
    value: function value(effect, transaction) {
      return transaction.readPrevious(effect.identifier);
    }
  }, {
    key: _Effect_js__WEBPACK_IMPORTED_MODULE_64__["ProposedArgumentsOfSymbol"],
    value: function value(effect, transaction) {
      var activeEntry = transaction.getActiveEntry();
      var source = effect.identifier;
      transaction.addEdge(source, activeEntry, _Transaction_js__WEBPACK_IMPORTED_MODULE_68__["EdgeTypePast"]);
      var quark = transaction.entries.get(source);
      return quark && !quark.isShadow() ? quark.proposedArguments : undefined;
    }
  }, {
    key: "dirty",
    get: function get() {
      return this.activeTransaction.dirty;
    }
  }, {
    key: "isInitialCommit",
    get: function get() {
      return this._isInitialCommit;
    },
    set: function set(value) {
      this._isInitialCommit = value;
    }
  }, {
    key: "followingRevision",
    get: function get() {
      if (this.$followingRevision !== undefined) return this.$followingRevision;
      var revisions = Array.from(this.topRevision.previousAxis());
      var entries = [];

      for (var i = revisions.length - 1; i > 0; i--) {
        entries.push([revisions[i], revisions[i - 1]]);
      }

      return this.$followingRevision = new Map(entries);
    }
  }, {
    key: "activeTransaction",
    get: function get() {
      if (this.$activeTransaction) return this.$activeTransaction;
      return this.$activeTransaction = this.transactionClass.new({
        baseRevision: this.baseRevisionTentative || this.baseRevision,
        graph: this
      });
    }
  }]);

  return ChronoGraph;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_60__["Base"]);

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Identifier.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/chrono/Identifier.js ***!
  \**********************************************/
/*! exports provided: Levels, Meta, Identifier, IdentifierC, QuarkSync, QuarkGen, Variable, VariableC, CalculatedValueSync, CalculatedValueSyncC, CalculatedValueGen, CalculatedValueGenC, throwUnknownIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Levels", function() { return Levels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Meta", function() { return Meta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Identifier", function() { return Identifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IdentifierC", function() { return IdentifierC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuarkSync", function() { return QuarkSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuarkGen", function() { return QuarkGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Variable", function() { return Variable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VariableC", function() { return VariableC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueSync", function() { return CalculatedValueSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueSyncC", function() { return CalculatedValueSyncC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueGen", function() { return CalculatedValueGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculatedValueGenC", function() { return CalculatedValueGenC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwUnknownIdentifier", function() { return throwUnknownIdentifier; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../primitives/Calculation.js */ "./lib/ChronoGraph/primitives/Calculation.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Effect_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _Quark_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_30___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var Levels;

(function (Levels) {
  Levels[Levels["UserInput"] = 0] = "UserInput";
  Levels[Levels["DependsOnlyOnUserInput"] = 1] = "DependsOnlyOnUserInput";
  Levels[Levels["DependsOnlyOnDependsOnlyOnUserInput"] = 2] = "DependsOnlyOnDependsOnlyOnUserInput";
  Levels[Levels["DependsOnSelfKind"] = 3] = "DependsOnSelfKind";
})(Levels || (Levels = {}));

var Meta = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(Meta, _Base);

  var _super = _createSuper(Meta);

  function Meta() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, Meta);

    _this = _super.apply(this, arguments);
    _this.name = undefined;
    _this.lazy = false;
    _this.total = true;
    _this.pure = true;
    _this.proposedValueIsBuilt = false;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(Meta, [{
    key: "calculation",
    value: function calculation(Y) {
      throw new Error("Abstract method `calculation` called");
    }
  }, {
    key: "equality",
    value: function equality(v1, v2) {
      return v1 === v2;
    }
  }]);

  return Meta;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_31__["Base"]);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_33__["prototypeValue"])(Levels.DependsOnSelfKind)], Meta.prototype, "level", void 0);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_33__["prototypeValue"])(true)], Meta.prototype, "sync", void 0);

var Identifier = /*#__PURE__*/function (_Meta) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(Identifier, _Meta);

  var _super2 = _createSuper(Identifier);

  function Identifier() {
    var _this2;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, Identifier);

    _this2 = _super2.apply(this, arguments);
    _this2.context = undefined;
    return _this2;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(Identifier, [{
    key: "newQuark",
    value: function newQuark(createdAt) {
      var newQuark = this.quarkClass.new();
      newQuark.createdAt = createdAt;
      newQuark.identifier = this;
      newQuark.needToBuildProposedValue = this.proposedValueIsBuilt;
      return newQuark;
    }
  }, {
    key: "write",
    value: function write(me, transaction, quark, proposedValue) {
      quark = quark || transaction.getWriteTarget(me);
      quark.proposedValue = proposedValue;

      for (var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        args[_key - 4] = arguments[_key];
      }

      quark.proposedArguments = args.length > 0 ? args : undefined;
    }
  }, {
    key: "writeToTransaction",
    value: function writeToTransaction(transaction, proposedValue) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      transaction.write.apply(transaction, [this, proposedValue].concat(args));
    }
  }, {
    key: "writeToGraph",
    value: function writeToGraph(graph, proposedValue) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      graph.write.apply(graph, [this, proposedValue].concat(args));
    }
  }, {
    key: "readFromGraphAsync",
    value: function readFromGraphAsync(graph) {
      return graph.readAsync(this);
    }
  }, {
    key: "readFromGraph",
    value: function readFromGraph(graph) {
      return graph.read(this);
    }
  }, {
    key: "readFromTransaction",
    value: function readFromTransaction(transaction) {
      return transaction.read(this);
    }
  }, {
    key: "readFromTransactionAsync",
    value: function readFromTransactionAsync(transaction) {
      return transaction.readAsync(this);
    }
  }, {
    key: "buildProposedValue",
    value: function buildProposedValue(me, quark, transaction) {
      return undefined;
    }
  }, {
    key: "enterGraph",
    value: function enterGraph(graph) {}
  }, {
    key: "leaveGraph",
    value: function leaveGraph(graph) {}
  }]);

  return Identifier;
}(Meta);
var IdentifierC = function IdentifierC(config) {
  return Identifier.new(config);
};
var QuarkSync = _Quark_js__WEBPACK_IMPORTED_MODULE_35__["Quark"].mix(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_32__["CalculationSync"].mix(Map));
var QuarkGen = _Quark_js__WEBPACK_IMPORTED_MODULE_35__["Quark"].mix(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_32__["CalculationGen"].mix(Map));
var Variable = /*#__PURE__*/function (_Identifier) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(Variable, _Identifier);

  var _super3 = _createSuper(Variable);

  function Variable() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, Variable);

    return _super3.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(Variable, [{
    key: "calculation",
    value: function calculation(YIELD) {
      throw new Error("The 'calculation' method of the variables will never be called. Instead the value will be set directly to quark");
    }
  }, {
    key: "write",
    value: function write(me, transaction, quark, proposedValue) {
      quark = quark || transaction.getWriteTarget(me);
      quark.value = proposedValue;

      for (var _len4 = arguments.length, args = new Array(_len4 > 4 ? _len4 - 4 : 0), _key4 = 4; _key4 < _len4; _key4++) {
        args[_key4 - 4] = arguments[_key4];
      }

      quark.proposedArguments = args.length > 0 ? args : undefined;
    }
  }]);

  return Variable;
}(Identifier);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_33__["prototypeValue"])(Levels.UserInput)], Variable.prototype, "level", void 0);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_33__["prototypeValue"])(QuarkSync)], Variable.prototype, "quarkClass", void 0);

function VariableC() {
  return Variable.new.apply(Variable, arguments);
}
var CalculatedValueSync = /*#__PURE__*/function (_Identifier2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(CalculatedValueSync, _Identifier2);

  var _super4 = _createSuper(CalculatedValueSync);

  function CalculatedValueSync() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, CalculatedValueSync);

    return _super4.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(CalculatedValueSync, [{
    key: "calculation",
    value: function calculation(YIELD) {
      return YIELD(_Effect_js__WEBPACK_IMPORTED_MODULE_34__["ProposedOrPrevious"]);
    }
  }]);

  return CalculatedValueSync;
}(Identifier);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_33__["prototypeValue"])(QuarkSync)], CalculatedValueSync.prototype, "quarkClass", void 0);

function CalculatedValueSyncC() {
  return CalculatedValueSync.new.apply(CalculatedValueSync, arguments);
}
var CalculatedValueGen = /*#__PURE__*/function (_Identifier3) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(CalculatedValueGen, _Identifier3);

  var _super5 = _createSuper(CalculatedValueGen);

  function CalculatedValueGen() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, CalculatedValueGen);

    return _super5.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(CalculatedValueGen, [{
    key: "calculation",
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_23___default.a.mark(function calculation(YIELD) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_23___default.a.wrap(function calculation$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _Effect_js__WEBPACK_IMPORTED_MODULE_34__["ProposedOrPrevious"];

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, calculation);
    })
  }]);

  return CalculatedValueGen;
}(Identifier);

__decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_33__["prototypeValue"])(QuarkGen)], CalculatedValueGen.prototype, "quarkClass", void 0);

function CalculatedValueGenC() {
  return CalculatedValueGen.new.apply(CalculatedValueGen, arguments);
}
var throwUnknownIdentifier = function throwUnknownIdentifier(identifier) {
  throw new Error("Unknown identifier ".concat(identifier));
};

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Quark.js":
/*!*****************************************!*\
  !*** ./lib/ChronoGraph/chrono/Quark.js ***!
  \*****************************************/
/*! exports provided: EdgeType, Quark, TombStone */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeType", function() { return EdgeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Quark", function() { return Quark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TombStone", function() { return TombStone; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");


































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var EdgeType;

(function (EdgeType) {
  EdgeType[EdgeType["Normal"] = 1] = "Normal";
  EdgeType[EdgeType["Past"] = 2] = "Past";
})(EdgeType || (EdgeType = {}));

var ORIGIN_ID = 0;
var Quark = /*#__PURE__*/function (_MixinAny) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default()(Quark, _MixinAny);

  var _super = _createSuper(Quark);

  function Quark() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29___default()(this, Quark);

    return _super.apply(this, arguments);
  }

  return Quark;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_33__["MixinAny"])([Map], function (base) {
  return /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default()(Quark, _base);

    var _super2 = _createSuper(Quark);

    function Quark() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29___default()(this, Quark);

      _this = _super2.apply(this, arguments);
      _this.createdAt = undefined;
      _this.identifier = undefined;
      _this.value = undefined;
      _this.proposedValue = undefined;
      _this.proposedArguments = undefined;
      _this.usedProposedOrPrevious = false;
      _this.previous = undefined;
      _this.origin = undefined;
      _this.originId = _util_Helpers_js__WEBPACK_IMPORTED_MODULE_35__["MIN_SMI"];
      _this.needToBuildProposedValue = false;
      _this.edgesFlow = 0;
      _this.visitedAt = _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_34__["NOT_VISITED"];
      _this.visitEpoch = 0;
      _this.promise = undefined;
      _this.$outgoingPast = undefined;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default()(Quark, [{
      key: "forceCalculation",
      value: function forceCalculation() {
        this.edgesFlow = _util_Helpers_js__WEBPACK_IMPORTED_MODULE_35__["MAX_SMI"];
      }
    }, {
      key: "cleanup",
      value: function cleanup() {
        this.cleanupCalculation();
      }
    }, {
      key: "isShadow",
      value: function isShadow() {
        return Boolean(this.origin && this.origin !== this);
      }
    }, {
      key: "resetToEpoch",
      value: function resetToEpoch(epoch) {
        this.visitEpoch = epoch;
        this.visitedAt = _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_34__["NOT_VISITED"];
        if (this.edgesFlow < 0) this.edgesFlow = 0;
        this.usedProposedOrPrevious = false;
        this.cleanupCalculation();
        if (this.value !== undefined) this.clearOutgoing();
        this.promise = undefined;

        if (this.origin && this.origin === this) {
          this.proposedArguments = undefined;

          if (this.value !== undefined) {
            this.proposedValue = this.value;
          }

          this.value = undefined;
        } else {
          this.origin = undefined;
          this.value = undefined;
        }

        if (this.identifier.proposedValueIsBuilt && this.proposedValue !== TombStone) {
          this.needToBuildProposedValue = true;
          this.proposedValue = undefined;
        }
      }
    }, {
      key: "copyFrom",
      value: function copyFrom(origin) {
        this.value = origin.value;
        this.proposedValue = origin.proposedValue;
        this.proposedArguments = origin.proposedArguments;
        this.usedProposedOrPrevious = origin.usedProposedOrPrevious;
      }
    }, {
      key: "clearProperties",
      value: function clearProperties() {
        this.value = undefined;
        this.proposedValue = undefined;
        this.proposedArguments = undefined;
      }
    }, {
      key: "mergePreviousOrigin",
      value: function mergePreviousOrigin(latestScope) {
        var origin = this.origin;
        if (origin !== this.previous) throw new Error("Invalid state");
        this.copyFrom(origin);
        var outgoing = this.getOutgoing();

        var _iterator = _createForOfIteratorHelper(origin.getOutgoing()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27___default()(_step.value, 2),
                _identifier = _step$value[0],
                _quark = _step$value[1];

            var _ownOutgoing = outgoing.get(_identifier);

            if (!_ownOutgoing) {
              var _latest = latestScope.get(_identifier);

              if (!_latest || _latest.originId === _quark.originId) outgoing.set(_identifier, _latest || _quark);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (origin.$outgoingPast !== undefined) {
          var outgoingPast = this.getOutgoingPast();

          var _iterator2 = _createForOfIteratorHelper(origin.getOutgoingPast()),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27___default()(_step2.value, 2),
                  identifier = _step2$value[0],
                  quark = _step2$value[1];

              var ownOutgoing = outgoingPast.get(identifier);

              if (!ownOutgoing) {
                var latest = latestScope.get(identifier);
                if (!latest || latest.originId === quark.originId) outgoingPast.set(identifier, latest || quark);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        this.origin = this;
        origin.clearProperties();
        origin.clear();
      }
    }, {
      key: "setOrigin",
      value: function setOrigin(origin) {
        this.origin = origin;
        this.originId = origin.originId;
      }
    }, {
      key: "getOrigin",
      value: function getOrigin() {
        if (this.origin) return this.origin;
        return this.startOrigin();
      }
    }, {
      key: "startOrigin",
      value: function startOrigin() {
        this.originId = ORIGIN_ID++;
        return this.origin = this;
      }
    }, {
      key: "getOutgoing",
      value: function getOutgoing() {
        return this;
      }
    }, {
      key: "getOutgoingPast",
      value: function getOutgoingPast() {
        if (this.$outgoingPast !== undefined) return this.$outgoingPast;
        return this.$outgoingPast = new Map();
      }
    }, {
      key: "addOutgoingTo",
      value: function addOutgoingTo(toQuark, type) {
        var outgoing = type === EdgeType.Normal ? this : this.getOutgoingPast();
        outgoing.set(toQuark.identifier, toQuark);
      }
    }, {
      key: "clearOutgoing",
      value: function clearOutgoing() {
        this.clear();
        if (this.$outgoingPast !== undefined) this.$outgoingPast.clear();
      }
    }, {
      key: "getValue",
      value: function getValue() {
        return this.origin ? this.origin.value : undefined;
      }
    }, {
      key: "setValue",
      value: function setValue(value) {
        if (this.origin && this.origin !== this) throw new Error('Can not set value to the shadow entry');
        this.getOrigin().value = value;
      }
    }, {
      key: "hasValue",
      value: function hasValue() {
        return this.getValue() !== undefined;
      }
    }, {
      key: "hasProposedValue",
      value: function hasProposedValue() {
        if (this.isShadow()) return false;
        return this.hasProposedValueInner();
      }
    }, {
      key: "hasProposedValueInner",
      value: function hasProposedValueInner() {
        return this.proposedValue !== undefined;
      }
    }, {
      key: "getProposedValue",
      value: function getProposedValue(transaction) {
        if (this.needToBuildProposedValue) {
          this.needToBuildProposedValue = false;
          this.proposedValue = this.identifier.buildProposedValue.call(this.identifier.context || this.identifier, this.identifier, this, transaction);
        }

        return this.proposedValue;
      }
    }, {
      key: "outgoingInTheFutureCb",
      value: function outgoingInTheFutureCb(revision, forEach) {
        var current = this;

        while (current) {
          var _iterator3 = _createForOfIteratorHelper(current.getOutgoing().values()),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _outgoing = _step3.value;
              if (_outgoing.originId === revision.getLatestEntryFor(_outgoing.identifier).originId) forEach(_outgoing);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          if (current.isShadow()) current = current.previous;else current = null;
        }
      }
    }, {
      key: "outgoingInTheFutureAndPastCb",
      value: function outgoingInTheFutureAndPastCb(revision, forEach) {
        var current = this;

        while (current) {
          var _iterator4 = _createForOfIteratorHelper(current.getOutgoing().values()),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _outgoing3 = _step4.value;

              var _latestEntry = revision.getLatestEntryFor(_outgoing3.identifier);

              if (_latestEntry && _outgoing3.originId === _latestEntry.originId) forEach(_outgoing3);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          if (current.$outgoingPast !== undefined) {
            var _iterator5 = _createForOfIteratorHelper(current.$outgoingPast.values()),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _outgoing2 = _step5.value;
                var latestEntry = revision.getLatestEntryFor(_outgoing2.identifier);
                if (latestEntry && _outgoing2.originId === latestEntry.originId) forEach(_outgoing2);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }

          if (current.isShadow()) current = current.previous;else current = null;
        }
      }
    }, {
      key: "outgoingInTheFutureAndPastTransactionCb",
      value: function outgoingInTheFutureAndPastTransactionCb(transaction, forEach) {
        var current = this;

        while (current) {
          var _iterator6 = _createForOfIteratorHelper(current.getOutgoing().values()),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _outgoing5 = _step6.value;

              var _latestEntry2 = transaction.getLatestStableEntryFor(_outgoing5.identifier);

              if (_latestEntry2 && _outgoing5.originId === _latestEntry2.originId) forEach(_outgoing5);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          if (current.$outgoingPast !== undefined) {
            var _iterator7 = _createForOfIteratorHelper(current.$outgoingPast.values()),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _outgoing4 = _step7.value;
                var latestEntry = transaction.getLatestStableEntryFor(_outgoing4.identifier);
                if (latestEntry && _outgoing4.originId === latestEntry.originId) forEach(_outgoing4);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }

          if (current.isShadow()) current = current.previous;else current = null;
        }
      }
    }, {
      key: "outgoingInTheFutureTransactionCb",
      value: function outgoingInTheFutureTransactionCb(transaction, forEach) {
        var current = this;

        while (current) {
          var _iterator8 = _createForOfIteratorHelper(current.getOutgoing().values()),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _outgoing6 = _step8.value;
              var latestEntry = transaction.getLatestEntryFor(_outgoing6.identifier);
              if (latestEntry && _outgoing6.originId === latestEntry.originId) forEach(_outgoing6);
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          if (current.isShadow()) current = current.previous;else current = null;
        }
      }
    }, {
      key: "level",
      get: function get() {
        return this.identifier.level;
      }
    }, {
      key: "calculation",
      get: function get() {
        return this.identifier.calculation;
      }
    }, {
      key: "context",
      get: function get() {
        return this.identifier.context || this.identifier;
      }
    }], [{
      key: "new",
      value: function _new(props) {
        var instance = new this();
        props && Object.assign(instance, props);
        return instance;
      }
    }]);

    return Quark;
  }(base);
}));
var TombStone = Symbol('Tombstone');

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Revision.js":
/*!********************************************!*\
  !*** ./lib/ChronoGraph/chrono/Revision.js ***!
  \********************************************/
/*! exports provided: Revision */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Revision", function() { return Revision; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _Quark_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");














































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var CLOCK = 0;
var Revision = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42___default()(Revision, _Base);

  var _super = _createSuper(Revision);

  function Revision() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40___default()(this, Revision);

    _this = _super.apply(this, arguments);
    _this.createdAt = CLOCK++;
    _this.name = 'revision-' + _this.createdAt;
    _this.previous = undefined;
    _this.scope = new Map();
    _this.reachableCount = 0;
    _this.referenceCount = 0;
    _this.selfDependent = new Set();
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41___default()(Revision, [{
    key: "getLatestEntryFor",
    value: function getLatestEntryFor(identifier) {
      var revision = this;

      while (revision) {
        var entry = revision.scope.get(identifier);
        if (entry) return entry;
        revision = revision.previous;
      }

      return null;
    }
  }, {
    key: "hasIdentifier",
    value: function hasIdentifier(identifier) {
      var latestEntry = this.getLatestEntryFor(identifier);
      return Boolean(latestEntry && latestEntry.getValue() !== _Quark_js__WEBPACK_IMPORTED_MODULE_46__["TombStone"]);
    }
  }, {
    key: "previousAxis",
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_38___default.a.mark(function previousAxis() {
      var revision;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_38___default.a.wrap(function previousAxis$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              revision = this;

            case 1:
              if (!revision) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return revision;

            case 4:
              revision = revision.previous;
              _context.next = 1;
              break;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, previousAxis, this);
    })
  }]);

  return Revision;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_45__["Base"]);

/***/ }),

/***/ "./lib/ChronoGraph/chrono/Transaction.js":
/*!***********************************************!*\
  !*** ./lib/ChronoGraph/chrono/Transaction.js ***!
  \***********************************************/
/*! exports provided: EdgeTypeNormal, EdgeTypePast, Transaction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeTypeNormal", function() { return EdgeTypeNormal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeTypePast", function() { return EdgeTypePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return Transaction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
/* harmony import */ var _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../primitives/Calculation.js */ "./lib/ChronoGraph/primitives/Calculation.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _util_LeveledQueue_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../util/LeveledQueue.js */ "./lib/ChronoGraph/util/LeveledQueue.js");
/* harmony import */ var _Effect_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _Quark_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _Revision_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./Revision.js */ "./lib/ChronoGraph/chrono/Revision.js");
/* harmony import */ var _TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./TransactionCycleDetectionWalkContext.js */ "./lib/ChronoGraph/chrono/TransactionCycleDetectionWalkContext.js");
/* harmony import */ var _TransactionWalkDepth_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./TransactionWalkDepth.js */ "./lib/ChronoGraph/chrono/TransactionWalkDepth.js");









































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_38___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';












var EdgeTypeNormal = _Quark_js__WEBPACK_IMPORTED_MODULE_48__["EdgeType"].Normal;
var EdgeTypePast = _Quark_js__WEBPACK_IMPORTED_MODULE_48__["EdgeType"].Past;
var Transaction = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_37___default()(Transaction, _Base);

  var _super = _createSuper(Transaction);

  function Transaction() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34___default()(this, Transaction);

    _this = _super.apply(this, arguments);
    _this.baseRevision = undefined;
    _this.candidateClass = _Revision_js__WEBPACK_IMPORTED_MODULE_49__["Revision"];
    _this.candidate = undefined;
    _this.graph = undefined;
    _this.isClosed = false;
    _this.walkContext = undefined;
    _this.entries = new Map();
    _this.stackGen = new _util_LeveledQueue_js__WEBPACK_IMPORTED_MODULE_45__["LeveledQueue"]();
    _this.activeStack = [];
    _this.onEffectSync = undefined;
    _this.onEffectAsync = undefined;
    _this.propagationStartDate = 0;
    _this.lastProgressNotificationDate = 0;
    _this.startProgressNotificationsAfterMs = 500;
    _this.emitProgressNotificationsEveryMs = 200;
    _this.emitProgressNotificationsEveryCalculations = 100;
    _this.plannedTotalIdentifiersToCalculate = 0;
    _this.ongoing = Promise.resolve();
    _this.selfDependedMarked = false;
    _this.rejectedWith = undefined;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35___default()(Transaction, [{
    key: "initialize",
    value: function initialize() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_36___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39___default()(Transaction.prototype), "initialize", this)).call.apply(_get2, [this].concat(args));

      this.walkContext = _TransactionWalkDepth_js__WEBPACK_IMPORTED_MODULE_51__["TransactionWalkDepth"].new({
        visited: this.entries,
        transaction: this,
        baseRevision: this.baseRevision,
        pushTo: this.stackGen
      });
      if (!this.candidate) this.candidate = this.candidateClass.new({
        previous: this.baseRevision
      });
      this.onEffectSync = this.read.bind(this);
      this.onEffectAsync = this.readAsync.bind(this);
    }
  }, {
    key: "markSelfDependent",
    value: function markSelfDependent() {
      if (this.selfDependedMarked) return;
      this.selfDependedMarked = true;

      var _iterator = _createForOfIteratorHelper(this.baseRevision.selfDependent),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var selfDependentIden = _step.value;
          var existing = this.entries.get(selfDependentIden);
          if (existing && existing.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) continue;
          this.touch(selfDependentIden);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "getActiveEntry",
    value: function getActiveEntry() {
      return this.activeStack[this.activeStack.length - 1];
    }
  }, {
    key: "yieldAsync",
    value: function yieldAsync(effect) {
      if (effect instanceof Promise) return effect;
      return this.graph[effect.handler](effect, this);
    }
  }, {
    key: "yieldSync",
    value: function yieldSync(effect) {
      if (effect instanceof Promise) {
        throw new Error("Can not yield a promise in the synchronous context");
      }

      return this.graph[effect.handler](effect, this);
    }
  }, {
    key: "readAsync",
    value: function () {
      var _readAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_33___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31___default.a.mark(function _callee(identifier) {
        var _this2 = this;

        var entry, activeEntry, previousEntry;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (identifier instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_47__["Identifier"]) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.yieldAsync(identifier));

              case 2:
                activeEntry = this.getActiveEntry();

                if (activeEntry) {
                  entry = this.addEdge(identifier, activeEntry, EdgeTypeNormal);
                } else {
                  entry = this.entries.get(identifier);

                  if (!entry) {
                    previousEntry = this.baseRevision.getLatestEntryFor(identifier);
                    if (!previousEntry) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifier);
                    entry = previousEntry.hasValue() ? previousEntry : this.touch(identifier);
                  }
                }

                if (!entry.hasValue()) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", entry.getValue());

              case 6:
                if (!entry.promise) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", entry.promise);

              case 8:
                if (!entry.previous || !entry.previous.hasValue()) entry.forceCalculation();

              case 9:
                if (!(this.stackGen.lowestLevel < identifier.level)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_43__["runGeneratorAsyncWithEffect"])(this.onEffectAsync, this.calculateTransitionsStackGen, [this.onEffectAsync, this.stackGen.takeLowestLevel()], this);

              case 12:
                _context.next = 9;
                break;

              case 14:
                this.markSelfDependent();
                return _context.abrupt("return", this.ongoing = entry.promise = this.ongoing.then(function () {
                  if (entry.getValue() === undefined) return Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_43__["runGeneratorAsyncWithEffect"])(_this2.onEffectAsync, _this2.calculateTransitionsStackGen, [_this2.onEffectAsync, [entry]], _this2);
                }).then(function () {
                  if (_this2.rejectedWith) throw new Error("Transaction rejected: ".concat(String(_this2.rejectedWith.reason)));
                  if (!entry.hasValue()) throw new Error('Computation cycle. Sync');
                  return entry.getValue();
                }));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function readAsync(_x) {
        return _readAsync.apply(this, arguments);
      }

      return readAsync;
    }()
  }, {
    key: "get",
    value: function get(identifier) {
      var _this3 = this;

      if (!(identifier instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_47__["Identifier"])) return this.yieldSync(identifier);
      var entry;
      var activeEntry = this.getActiveEntry();

      if (activeEntry) {
        entry = this.addEdge(identifier, activeEntry, EdgeTypeNormal);
      } else {
        entry = this.entries.get(identifier);

        if (!entry) {
          var previousEntry = this.baseRevision.getLatestEntryFor(identifier);
          if (!previousEntry) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifier);
          entry = previousEntry.hasValue() ? previousEntry : this.touch(identifier);
        }
      }

      var value1 = entry.getValue();
      if (value1 === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifier);
      if (value1 !== undefined && entry.hasValue()) return value1;
      if (entry.promise) return entry.promise;
      if (!entry.previous || !entry.previous.hasValue()) entry.forceCalculation();

      while (this.stackGen.getLowestLevel() < identifier.level) {
        this.calculateTransitionsStackSync(this.onEffectSync, this.stackGen.takeLowestLevel());
      }

      this.markSelfDependent();

      if (identifier.sync) {
        this.calculateTransitionsStackSync(this.onEffectSync, [entry]);
        var value = entry.getValue();
        if (value === undefined) throw new Error('Cycle during synchronous computation');
        if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifier);
        return value;
      } else {
        var promise = this.ongoing = entry.promise = this.ongoing.then(function () {
          if (entry.getValue() === undefined) return Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_43__["runGeneratorAsyncWithEffect"])(_this3.onEffectAsync, _this3.calculateTransitionsStackGen, [_this3.onEffectAsync, [entry]], _this3);
        }).then(function () {
          if (_this3.rejectedWith) throw new Error("Transaction rejected: ".concat(String(_this3.rejectedWith.reason)));
          var value = entry.getValue();
          if (value === undefined) throw new Error('Computation cycle. Async get');
          if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifier);
          return value;
        });

        if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_41__["DEBUG"]) {
          promise.quark = entry;
        }

        return promise;
      }
    }
  }, {
    key: "read",
    value: function read(identifier) {
      if (!(identifier instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_47__["Identifier"])) return this.yieldSync(identifier);
      var entry;
      var activeEntry = this.getActiveEntry();

      if (activeEntry) {
        entry = this.addEdge(identifier, activeEntry, EdgeTypeNormal);
      } else {
        entry = this.entries.get(identifier);

        if (!entry) {
          var previousEntry = this.baseRevision.getLatestEntryFor(identifier);
          if (!previousEntry) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifier);
          entry = previousEntry.hasValue() ? previousEntry : this.touch(identifier);
        }
      }

      var value1 = entry.getValue();
      if (value1 === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifier);
      if (value1 !== undefined) return value1;
      if (!entry.previous || !entry.previous.hasValue()) entry.forceCalculation();

      while (this.stackGen.getLowestLevel() < identifier.level) {
        this.calculateTransitionsStackSync(this.onEffectSync, this.stackGen.takeLowestLevel());
      }

      this.markSelfDependent();
      this.calculateTransitionsStackSync(this.onEffectSync, [entry]);
      var value = entry.getValue();
      if (value === undefined) throw new Error('Cycle during synchronous computation');
      if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifier);
      return value;
    }
  }, {
    key: "readCurrentOrProposedOrPrevious",
    value: function readCurrentOrProposedOrPrevious(identifier) {
      var dirtyQuark = this.entries.get(identifier);

      if (dirtyQuark) {
        var value = dirtyQuark.getValue();
        if (value !== undefined) return value;
        if (dirtyQuark.proposedValue !== undefined) return dirtyQuark.proposedValue;
      }

      return this.readPrevious(identifier);
    }
  }, {
    key: "readCurrentOrProposedOrPreviousAsync",
    value: function readCurrentOrProposedOrPreviousAsync(identifier) {
      var dirtyQuark = this.entries.get(identifier);

      if (dirtyQuark) {
        var value = dirtyQuark.getValue();
        if (value !== undefined) return value;
        if (dirtyQuark.proposedValue !== undefined) return dirtyQuark.proposedValue;
      }

      return this.readPreviousAsync(identifier);
    }
  }, {
    key: "readPrevious",
    value: function readPrevious(identifier) {
      var previousEntry = this.baseRevision.getLatestEntryFor(identifier);
      if (!previousEntry) return undefined;
      var value = previousEntry.getValue();
      return value !== _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"] ? value !== undefined ? value : this.read(identifier) : undefined;
    }
  }, {
    key: "readPreviousAsync",
    value: function readPreviousAsync(identifier) {
      var previousEntry = this.baseRevision.getLatestEntryFor(identifier);
      if (!previousEntry) return undefined;
      var value = previousEntry.getValue();
      return value !== _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"] ? value !== undefined ? value : this.readAsync(identifier) : undefined;
    }
  }, {
    key: "readProposedOrPrevious",
    value: function readProposedOrPrevious(identifier) {
      var dirtyQuark = this.entries.get(identifier);

      if (dirtyQuark && dirtyQuark.proposedValue !== undefined) {
        return dirtyQuark.proposedValue;
      } else {
        return this.readPrevious(identifier);
      }
    }
  }, {
    key: "readProposedOrPreviousAsync",
    value: function readProposedOrPreviousAsync(identifier) {
      var dirtyQuark = this.entries.get(identifier);

      if (dirtyQuark && dirtyQuark.proposedValue !== undefined) {
        return dirtyQuark.proposedValue;
      } else {
        return this.readPreviousAsync(identifier);
      }
    }
  }, {
    key: "write",
    value: function write(identifier, proposedValue) {
      var _identifier$write;

      if (proposedValue === undefined) proposedValue = null;

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      (_identifier$write = identifier.write).call.apply(_identifier$write, [identifier.context || identifier, identifier, this, null, proposedValue].concat(args));
    }
  }, {
    key: "getWriteTarget",
    value: function getWriteTarget(identifier) {
      return this.touch(identifier).startOrigin();
    }
  }, {
    key: "acquireQuarkIfExists",
    value: function acquireQuarkIfExists(identifier) {
      var entry = this.entries.get(identifier);
      return entry && entry.origin === entry ? entry.origin : undefined;
    }
  }, {
    key: "touch",
    value: function touch(identifier) {
      var existingEntry = this.entries.get(identifier);
      if (!existingEntry || existingEntry.visitEpoch < this.walkContext.currentEpoch) this.walkContext.continueFrom([identifier]);
      var entry = existingEntry || this.entries.get(identifier);
      entry.forceCalculation();
      return entry;
    }
  }, {
    key: "hasIdentifier",
    value: function hasIdentifier(identifier) {
      var activeEntry = this.entries.get(identifier);
      if (activeEntry && activeEntry.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) return false;
      return Boolean(activeEntry || this.baseRevision.getLatestEntryFor(identifier));
    }
  }, {
    key: "addIdentifier",
    value: function addIdentifier(identifier, proposedValue) {
      var entry = this.entries.get(identifier);
      var isVariable = identifier.level === _Identifier_js__WEBPACK_IMPORTED_MODULE_47__["Levels"].UserInput;

      if (!entry) {
        entry = identifier.newQuark(this.baseRevision);
        entry.previous = this.baseRevision.getLatestEntryFor(identifier);
        entry.forceCalculation();
        this.entries.set(identifier, entry);
        if (!identifier.lazy && !isVariable) this.stackGen.push(entry);
      }

      if (proposedValue !== undefined || isVariable) {
        var _identifier$write2;

        entry.startOrigin();

        for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          args[_key3 - 2] = arguments[_key3];
        }

        (_identifier$write2 = identifier.write).call.apply(_identifier$write2, [identifier.context || identifier, identifier, this, entry, proposedValue === undefined && isVariable ? null : proposedValue].concat(args));
      }

      if (entry.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) entry.value = undefined;
      identifier.enterGraph(this.graph);
      return entry;
    }
  }, {
    key: "removeIdentifier",
    value: function removeIdentifier(identifier) {
      identifier.leaveGraph(this.graph);
      var entry = this.touch(identifier).startOrigin();
      entry.setValue(_Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]);
    }
  }, {
    key: "populateCandidateScopeFromTransitions",
    value: function populateCandidateScopeFromTransitions(candidate, scope) {
      if (candidate.scope.size === 0) {
        candidate.scope = scope;
      } else {
        var _iterator2 = _createForOfIteratorHelper(scope),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_30___default()(_step2.value, 2),
                identifier = _step2$value[0],
                quark = _step2$value[1];

            if (quark.isShadow()) {
              (function () {
                var latestEntry = candidate.getLatestEntryFor(identifier);
                quark.getOutgoing().forEach(function (toQuark, toIdentifier) {
                  return latestEntry.getOutgoing().set(toIdentifier, toQuark);
                });
              })();
            } else {
              candidate.scope.set(identifier, quark);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "preCommit",
    value: function preCommit(args) {
      if (this.isClosed) throw new Error('Can not propagate closed revision');
      this.markSelfDependent();
      this.isClosed = true;
      this.propagationStartDate = Date.now();
      this.plannedTotalIdentifiersToCalculate = this.stackGen.length;
    }
  }, {
    key: "postCommit",
    value: function postCommit() {
      this.populateCandidateScopeFromTransitions(this.candidate, this.entries);
      var entries = this.entries;
      this.walkContext = undefined;
      return {
        revision: this.candidate,
        entries: entries,
        transaction: this
      };
    }
  }, {
    key: "commit",
    value: function commit(args) {
      this.preCommit(args);
      this.calculateTransitionsSync(this.onEffectSync);
      return this.postCommit();
    }
  }, {
    key: "reject",
    value: function reject() {
      var rejection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Effect_js__WEBPACK_IMPORTED_MODULE_46__["RejectEffect"].new();
      this.rejectedWith = rejection;

      var _iterator3 = _createForOfIteratorHelper(this.entries.values()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var quark = _step3.value;
          quark.cleanup();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this.entries.clear();
      this.walkContext = undefined;
    }
  }, {
    key: "commitAsync",
    value: function () {
      var _commitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_33___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31___default.a.mark(function _callee2(args) {
        var _this4 = this;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.preCommit(args);
                return _context2.abrupt("return", this.ongoing = this.ongoing.then(function () {
                  return Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_43__["runGeneratorAsyncWithEffect"])(_this4.onEffectAsync, _this4.calculateTransitions, [_this4.onEffectAsync], _this4);
                }).then(function () {
                  return _this4.postCommit();
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function commitAsync(_x2) {
        return _commitAsync.apply(this, arguments);
      }

      return commitAsync;
    }()
  }, {
    key: "getLatestEntryFor",
    value: function getLatestEntryFor(identifier) {
      var entry = this.entries.get(identifier) || this.baseRevision.getLatestEntryFor(identifier);
      if (entry.getValue() === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) return undefined;
      return entry;
    }
  }, {
    key: "getLatestStableEntryFor",
    value: function getLatestStableEntryFor(identifier) {
      var entry = this.entries.get(identifier);

      if (entry) {
        var value = entry.getValue();
        if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) return undefined;
        return value === undefined ? this.baseRevision.getLatestEntryFor(identifier) : entry;
      } else {
        return this.baseRevision.getLatestEntryFor(identifier);
      }
    }
  }, {
    key: "addEdge",
    value: function addEdge(identifierRead, activeEntry, type) {
      var identifier = activeEntry.identifier;
      if (identifier.level < identifierRead.level) throw new Error('Identifier can not read from higher level identifier');
      var entry = this.entries.get(identifierRead);

      if (!entry) {
        var previousEntry = this.baseRevision.getLatestEntryFor(identifierRead);
        if (!previousEntry) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifierRead);
        entry = identifierRead.newQuark(this.baseRevision);
        previousEntry.origin && entry.setOrigin(previousEntry.origin);
        entry.previous = previousEntry;
        this.entries.set(identifierRead, entry);
      }

      entry.addOutgoingTo(activeEntry, type);
      return entry;
    }
  }, {
    key: "onQuarkCalculationCompleted",
    value: function onQuarkCalculationCompleted(entry, value) {
      var _this5 = this;

      entry.cleanup();
      var identifier = entry.identifier;
      var previousEntry = entry.previous;
      var sameAsPrevious = Boolean(previousEntry && previousEntry.hasValue() && identifier.equality(value, previousEntry.getValue()));

      if (sameAsPrevious) {
        previousEntry.outgoingInTheFutureAndPastTransactionCb(this, function (previousOutgoingEntry) {
          var outgoingEntry = _this5.entries.get(previousOutgoingEntry.identifier);

          if (outgoingEntry) outgoingEntry.edgesFlow--;
        });
        entry.edgesFlow = _util_Helpers_js__WEBPACK_IMPORTED_MODULE_44__["MAX_SMI"];
        entry.setOrigin(previousEntry.origin);
        entry.value = value;
      } else {
        entry.startOrigin();
        entry.setValue(value);
      }

      var ignoreSelfDependency = false;

      if (entry.usedProposedOrPrevious) {
        if (entry.proposedValue !== undefined) {
          if (identifier.equality(value, entry.proposedValue)) ignoreSelfDependency = true;
        } else {
          if (sameAsPrevious || !previousEntry && value === null) ignoreSelfDependency = true;
        }

        if (!ignoreSelfDependency) this.candidate.selfDependent.add(identifier);
      }
    }
  }, {
    key: "onReadIdentifier",
    value: function onReadIdentifier(identifierRead, activeEntry, stack) {
      var requestedEntry = this.addEdge(identifierRead, activeEntry, EdgeTypeNormal);

      if (requestedEntry.hasValue() || requestedEntry.value !== undefined) {
        var value = requestedEntry.getValue();
        if (value === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) Object(_Identifier_js__WEBPACK_IMPORTED_MODULE_47__["throwUnknownIdentifier"])(identifierRead);
        return activeEntry.continueCalculation(value);
      } else if (requestedEntry.isShadow()) {
        requestedEntry.startOrigin();
        requestedEntry.forceCalculation();
        stack.push(requestedEntry);
        return undefined;
      } else {
        if (!requestedEntry.isCalculationStarted()) {
          stack.push(requestedEntry);
          if (!requestedEntry.previous || !requestedEntry.previous.hasValue()) requestedEntry.forceCalculation();
          return undefined;
        } else {
          var cycle;
          var walkContext = _TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_50__["TransactionCycleDetectionWalkContext"].new({
            transaction: this,
            onCycle: function onCycle(node, stack) {
              cycle = _TransactionCycleDetectionWalkContext_js__WEBPACK_IMPORTED_MODULE_50__["ComputationCycle"].new({
                cycle: Object(_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_42__["cycleInfo"])(stack)
              });
              return _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_42__["OnCycleAction"].Cancel;
            }
          });
          walkContext.startFrom([requestedEntry.identifier]);
          this.graph.onComputationCycleHandler(activeEntry, requestedEntry, cycle);
        }
      }
    }
  }, {
    key: "calculateTransitions",
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31___default.a.mark(function calculateTransitions(context) {
      var queue;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31___default.a.wrap(function calculateTransitions$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              queue = this.stackGen;

            case 1:
              if (!queue.length) {
                _context3.next = 5;
                break;
              }

              return _context3.delegateYield(this.calculateTransitionsStackGen(context, queue.takeLowestLevel()), "t0", 3);

            case 3:
              _context3.next = 1;
              break;

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, calculateTransitions, this);
    })
  }, {
    key: "calculateTransitionsSync",
    value: function calculateTransitionsSync(context) {
      var queue = this.stackGen;

      while (queue.length) {
        this.calculateTransitionsStackSync(context, queue.takeLowestLevel());
      }
    }
  }, {
    key: "calculateTransitionsStackGen",
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31___default.a.mark(function calculateTransitionsStackGen(context, stack) {
      var entries, propagationStartDate, enableProgressNotifications, counter, prevActiveStack, now, elapsed, lastProgressNotificationDate, entry, identifier, ownEntry, previousEntry, startedAtEpoch, iterationResult, value, effectResult;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_31___default.a.wrap(function calculateTransitionsStackGen$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.rejectedWith) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              this.walkContext.startNewEpoch();
              entries = this.entries;
              propagationStartDate = this.propagationStartDate;
              enableProgressNotifications = this.graph ? this.graph.enableProgressNotifications : false;
              counter = 0;
              prevActiveStack = this.activeStack;
              this.activeStack = stack;

            case 9:
              if (!(stack.length && !this.rejectedWith)) {
                _context4.next = 72;
                break;
              }

              if (!(enableProgressNotifications && !(counter++ % this.emitProgressNotificationsEveryCalculations))) {
                _context4.next = 20;
                break;
              }

              now = Date.now();
              elapsed = now - propagationStartDate;

              if (!(elapsed > this.startProgressNotificationsAfterMs)) {
                _context4.next = 20;
                break;
              }

              lastProgressNotificationDate = this.lastProgressNotificationDate;

              if (!(!lastProgressNotificationDate || now - lastProgressNotificationDate > this.emitProgressNotificationsEveryMs)) {
                _context4.next = 20;
                break;
              }

              this.lastProgressNotificationDate = now;
              this.graph.onPropagationProgressNotification({
                total: this.plannedTotalIdentifiersToCalculate,
                remaining: stack.length,
                phase: 'propagating'
              });
              _context4.next = 20;
              return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_44__["delay"])(0);

            case 20:
              entry = stack[stack.length - 1];
              identifier = entry.identifier;
              ownEntry = entries.get(identifier);

              if (!(ownEntry !== entry)) {
                _context4.next = 27;
                break;
              }

              entry.cleanup();
              stack.pop();
              return _context4.abrupt("continue", 9);

            case 27:
              if (entry.edgesFlow == 0) {
                entry.edgesFlow--;
                previousEntry = entry.previous;
                previousEntry && previousEntry.outgoingInTheFutureAndPastTransactionCb(this, function (outgoing) {
                  var outgoingEntry = entries.get(outgoing.identifier);
                  if (outgoingEntry) outgoingEntry.edgesFlow--;
                });
              }

              if (!(entry.edgesFlow < 0 && entry.previous && entry.previous.origin)) {
                _context4.next = 34;
                break;
              }

              entry.setOrigin(entry.previous.origin);

              if (entry.size === 0) {
                entries.delete(identifier);
              }

              entry.cleanup();
              stack.pop();
              return _context4.abrupt("continue", 9);

            case 34:
              if (!(entry.hasValue() || entry.proposedValue === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"])) {
                _context4.next = 38;
                break;
              }

              entry.cleanup();
              stack.pop();
              return _context4.abrupt("continue", 9);

            case 38:
              startedAtEpoch = entry.visitEpoch;
              iterationResult = entry.isCalculationStarted() ? entry.iterationResult : entry.startCalculation(this.onEffectSync);

            case 40:
              if (!iterationResult) {
                _context4.next = 70;
                break;
              }

              value = iterationResult.value === undefined ? null : iterationResult.value;

              if (!entry.isCalculationCompleted()) {
                _context4.next = 48;
                break;
              }

              if (entry.visitEpoch == startedAtEpoch) {
                this.onQuarkCalculationCompleted(entry, value);
              }

              stack.pop();
              return _context4.abrupt("break", 70);

            case 48:
              if (!(value instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_47__["Identifier"])) {
                _context4.next = 52;
                break;
              }

              iterationResult = this.onReadIdentifier(value, entry, stack);
              _context4.next = 68;
              break;

            case 52:
              if (!(value === _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_43__["SynchronousCalculationStarted"])) {
                _context4.next = 57;
                break;
              }

              stack.pop();
              return _context4.abrupt("break", 70);

            case 57:
              _context4.next = 59;
              return value;

            case 59:
              effectResult = _context4.sent;

              if (!(effectResult === _Effect_js__WEBPACK_IMPORTED_MODULE_46__["BreakCurrentStackExecution"])) {
                _context4.next = 62;
                break;
              }

              return _context4.abrupt("break", 70);

            case 62:
              if (!(entry.visitEpoch === startedAtEpoch)) {
                _context4.next = 66;
                break;
              }

              iterationResult = entry.continueCalculation(effectResult);
              _context4.next = 68;
              break;

            case 66:
              stack.pop();
              return _context4.abrupt("break", 70);

            case 68:
              _context4.next = 40;
              break;

            case 70:
              _context4.next = 9;
              break;

            case 72:
              this.activeStack = prevActiveStack;

            case 73:
            case "end":
              return _context4.stop();
          }
        }
      }, calculateTransitionsStackGen, this);
    })
  }, {
    key: "calculateTransitionsStackSync",
    value: function calculateTransitionsStackSync(context, stack) {
      if (this.rejectedWith) return;
      this.walkContext.startNewEpoch();
      var entries = this.entries;
      var prevActiveStack = this.activeStack;
      this.activeStack = stack;

      while (stack.length && !this.rejectedWith) {
        var entry = stack[stack.length - 1];
        var identifier = entry.identifier;
        var ownEntry = entries.get(identifier);

        if (ownEntry !== entry) {
          entry.cleanup();
          stack.pop();
          continue;
        }

        if (entry.edgesFlow == 0) {
          entry.edgesFlow--;
          var previousEntry = entry.previous;
          previousEntry && previousEntry.outgoingInTheFutureAndPastTransactionCb(this, function (outgoing) {
            var outgoingEntry = entries.get(outgoing.identifier);
            if (outgoingEntry) outgoingEntry.edgesFlow--;
          });
        }

        if (entry.edgesFlow < 0 && entry.previous && entry.previous.origin) {
          entry.setOrigin(entry.previous.origin);

          if (entry.size === 0) {
            entries.delete(identifier);
          }

          entry.cleanup();
          stack.pop();
          continue;
        }

        if (entry.hasValue() || entry.proposedValue === _Quark_js__WEBPACK_IMPORTED_MODULE_48__["TombStone"]) {
          entry.cleanup();
          stack.pop();
          continue;
        }

        var startedAtEpoch = entry.visitEpoch;
        var iterationResult = entry.isCalculationStarted() ? entry.iterationResult : entry.startCalculation(this.onEffectSync);

        while (iterationResult) {
          var value = iterationResult.value === undefined ? null : iterationResult.value;

          if (entry.isCalculationCompleted()) {
            if (entry.visitEpoch == startedAtEpoch) {
              this.onQuarkCalculationCompleted(entry, value);
            }

            stack.pop();
            break;
          } else if (value instanceof _Identifier_js__WEBPACK_IMPORTED_MODULE_47__["Identifier"]) {
            iterationResult = this.onReadIdentifier(value, entry, stack);
          } else if (value === _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_43__["SynchronousCalculationStarted"]) {
            stack.pop();
            break;
          } else {
            var effectResult = context(value);
            if (effectResult instanceof Promise) throw new Error("Effect resolved to promise in the synchronous context, check that you marked the asynchronous calculations accordingly");
            if (effectResult === _Effect_js__WEBPACK_IMPORTED_MODULE_46__["BreakCurrentStackExecution"]) break;

            if (entry.visitEpoch === startedAtEpoch) {
              iterationResult = entry.continueCalculation(effectResult);
            } else {
              stack.pop();
              break;
            }
          }
        }
      }

      this.activeStack = prevActiveStack;
    }
  }, {
    key: "dirty",
    get: function get() {
      return this.entries.size > 0;
    }
  }]);

  return Transaction;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_40__["Base"]);

/***/ }),

/***/ "./lib/ChronoGraph/chrono/TransactionCycleDetectionWalkContext.js":
/*!************************************************************************!*\
  !*** ./lib/ChronoGraph/chrono/TransactionCycleDetectionWalkContext.js ***!
  \************************************************************************/
/*! exports provided: ComputationCycle, TransactionCycleDetectionWalkContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComputationCycle", function() { return ComputationCycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransactionCycleDetectionWalkContext", function() { return TransactionCycleDetectionWalkContext; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var ComputationCycle = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(ComputationCycle, _Base);

  var _super = _createSuper(ComputationCycle);

  function ComputationCycle() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ComputationCycle);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(ComputationCycle, [{
    key: "toString",
    value: function toString() {
      var cycleIdentifiers = [];
      var cycleEvents = [];
      this.cycle.forEach(function (_ref) {
        var name = _ref.name,
            context = _ref.context;
        cycleIdentifiers.push(name);
        if (cycleEvents[cycleEvents.length - 1] !== context) cycleEvents.push(context);
      });
      return 'events: \n' + cycleEvents.map(function (event) {
        return '#' + event.id;
      }).join(' => ') + '\n\nidentifiers: \n' + cycleIdentifiers.join('\n');
    }
  }]);

  return ComputationCycle;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_13__["Base"]);
var TransactionCycleDetectionWalkContext = /*#__PURE__*/function (_WalkContext) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(TransactionCycleDetectionWalkContext, _WalkContext);

  var _super2 = _createSuper(TransactionCycleDetectionWalkContext);

  function TransactionCycleDetectionWalkContext() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, TransactionCycleDetectionWalkContext);

    _this = _super2.apply(this, arguments);
    _this.transaction = undefined;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(TransactionCycleDetectionWalkContext, [{
    key: "onCycle",
    value: function onCycle(node, stack) {
      return _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__["OnCycleAction"].Cancel;
    }
  }, {
    key: "doCollectNext",
    value: function doCollectNext(from, to, toVisit) {
      var visit = this.visited.get(to);

      if (!visit) {
        visit = {
          visitedAt: _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__["NOT_VISITED"],
          visitEpoch: this.currentEpoch
        };
        this.visited.set(to, visit);
      }

      toVisit.push({
        node: to,
        from: from,
        label: undefined
      });
    }
  }, {
    key: "collectNext",
    value: function collectNext(from, toVisit) {
      var _this2 = this;

      var latestEntry = this.transaction.getLatestEntryFor(from);

      if (latestEntry) {
        latestEntry.outgoingInTheFutureTransactionCb(this.transaction, function (outgoingEntry) {
          _this2.doCollectNext(from, outgoingEntry.identifier, toVisit);
        });
      }
    }
  }]);

  return TransactionCycleDetectionWalkContext;
}(_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_14__["WalkContext"]);

/***/ }),

/***/ "./lib/ChronoGraph/chrono/TransactionWalkDepth.js":
/*!********************************************************!*\
  !*** ./lib/ChronoGraph/chrono/TransactionWalkDepth.js ***!
  \********************************************************/
/*! exports provided: TransactionWalkDepth */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransactionWalkDepth", function() { return TransactionWalkDepth; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var TransactionWalkDepth = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28___default()(TransactionWalkDepth, _Base);

  var _super = _createSuper(TransactionWalkDepth);

  function TransactionWalkDepth() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, TransactionWalkDepth);

    _this = _super.apply(this, arguments);
    _this.visited = new Map();
    _this.transaction = undefined;
    _this.baseRevision = undefined;
    _this.pushTo = undefined;
    _this.toVisit = [];
    _this.currentEpoch = 0;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27___default()(TransactionWalkDepth, [{
    key: "startFrom",
    value: function startFrom(sourceNodes) {
      this.continueFrom(sourceNodes);
    }
  }, {
    key: "continueFrom",
    value: function continueFrom(sourceNodes) {
      this.toVisit.push.apply(this.toVisit, sourceNodes);
      this.walkDepth();
    }
  }, {
    key: "startNewEpoch",
    value: function startNewEpoch() {
      if (this.toVisit.length) throw new Error("Can not start new walk epoch in the middle of the walk");
      this.currentEpoch++;
    }
  }, {
    key: "onTopologicalNode",
    value: function onTopologicalNode(identifier, visitInfo) {
      if (!identifier.lazy && identifier.level !== _Identifier_js__WEBPACK_IMPORTED_MODULE_33__["Levels"].UserInput) this.pushTo.push(visitInfo);
    }
  }, {
    key: "onCycle",
    value: function onCycle(node, stack) {
      return _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_32__["OnCycleAction"].Resume;
    }
  }, {
    key: "doCollectNext",
    value: function doCollectNext(from, to, toVisit) {
      var quark = this.visited.get(to);

      if (!quark) {
        quark = to.newQuark(this.baseRevision);
        quark.visitEpoch = this.currentEpoch;
        this.visited.set(to, quark);
      }

      toVisit.push(to);
    }
  }, {
    key: "collectNext",
    value: function collectNext(from, toVisit, visitInfo) {
      var _this2 = this;

      var latestEntry = this.baseRevision.getLatestEntryFor(from);

      if (latestEntry) {
        visitInfo.previous = latestEntry;
        latestEntry.outgoingInTheFutureAndPastTransactionCb(this.transaction, function (outgoingEntry) {
          _this2.doCollectNext(from, outgoingEntry.identifier, toVisit);
        });
      }

      var _iterator = _createForOfIteratorHelper(visitInfo.getOutgoing().keys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _outgoingIdentifier = _step.value;
          this.doCollectNext(from, _outgoingIdentifier, toVisit);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (visitInfo.$outgoingPast !== undefined) {
        var _iterator2 = _createForOfIteratorHelper(visitInfo.getOutgoingPast().keys()),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var outgoingIdentifier = _step2.value;
            this.doCollectNext(from, outgoingIdentifier, toVisit);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "walkDepth",
    value: function walkDepth() {
      var visited = this.visited;
      var toVisit = this.toVisit;
      var depth;

      while (depth = toVisit.length) {
        var node = toVisit[depth - 1];
        var visitInfo = visited.get(node);

        if (visitInfo && visitInfo.visitedAt === _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_32__["VISITED_TOPOLOGICALLY"] && visitInfo.visitEpoch === this.currentEpoch) {
          visitInfo.edgesFlow++;
          toVisit.pop();
          continue;
        }

        if (visitInfo && visitInfo.visitEpoch === this.currentEpoch && visitInfo.visitedAt !== _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_32__["NOT_VISITED"]) {
          if (visitInfo.visitedAt < depth) {
            if (this.onCycle(node, toVisit) !== _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_32__["OnCycleAction"].Resume) break;
            visitInfo.edgesFlow++;
          } else {
            visitInfo.visitedAt = _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_32__["VISITED_TOPOLOGICALLY"];
            this.onTopologicalNode(node, visitInfo);
          }

          toVisit.pop();
        } else {
          var lengthBefore = toVisit.length;

          if (!visitInfo) {
            visitInfo = node.newQuark(this.baseRevision);
            visitInfo.visitEpoch = this.currentEpoch;
            visited.set(node, visitInfo);
          }

          this.collectNext(node, toVisit, visitInfo);

          if (visitInfo.visitEpoch < this.currentEpoch) {
            visitInfo.resetToEpoch(this.currentEpoch);
          }

          visitInfo.visitedAt = depth;
          visitInfo.edgesFlow++;

          if (toVisit.length === lengthBefore) {
            visitInfo.visitedAt = _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_32__["VISITED_TOPOLOGICALLY"];
            this.onTopologicalNode(node, visitInfo);
            toVisit.pop();
          }
        }
      }
    }
  }]);

  return TransactionWalkDepth;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_31__["Base"]);

/***/ }),

/***/ "./lib/ChronoGraph/class/Base.js":
/*!***************************************!*\
  !*** ./lib/ChronoGraph/class/Base.js ***!
  \***************************************/
/*! exports provided: Base */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return Base; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);



var productName = 'scheduler';
var Base = /*#__PURE__*/function () {
  function Base() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Base);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Base, [{
    key: "initialize",
    value: function initialize(props) {
      props && Object.assign(this, props);
    }
  }], [{
    key: "new",
    value: function _new(props) {
      var instance = new this();
      instance.initialize(props);
      return instance;
    }
  }]);

  return Base;
}();

/***/ }),

/***/ "./lib/ChronoGraph/class/BetterMixin.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/class/BetterMixin.js ***!
  \**********************************************/
/*! exports provided: identity, ZeroBaseClass, isInstanceOf, Mixin, MixinAny, Base */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["identity"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ZeroBaseClass", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["ZeroBaseClass"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isInstanceOf", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mixin", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MixinAny", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["MixinAny"]; });

/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _Base_js__WEBPACK_IMPORTED_MODULE_1__["Base"]; });

var productName = 'scheduler';



/***/ }),

/***/ "./lib/ChronoGraph/class/Mixin.js":
/*!****************************************!*\
  !*** ./lib/ChronoGraph/class/Mixin.js ***!
  \****************************************/
/*! exports provided: identity, ZeroBaseClass, isInstanceOf, Mixin, MixinAny */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return identity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZeroBaseClass", function() { return ZeroBaseClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInstanceOf", function() { return isInstanceOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mixin", function() { return Mixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MixinAny", function() { return MixinAny; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_has_instance__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.has-instance */ "./node_modules/core-js/modules/es.symbol.has-instance.js");
/* harmony import */ var core_js_modules_es_symbol_has_instance__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_has_instance__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_has_instance__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.has-instance */ "./node_modules/core-js/modules/es.function.has-instance.js");
/* harmony import */ var core_js_modules_es_function_has_instance__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_has_instance__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_59___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_59__);
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");





























































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_53___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var MixinInstanceOfProperty = Symbol('MixinIdentity');
var MixinStateProperty = Symbol('MixinStateProperty');

var MixinWalkDepthState = /*#__PURE__*/function () {
  function MixinWalkDepthState() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, MixinWalkDepthState);

    this.baseEl = undefined;
    this.sourceEl = undefined;
    this.$elementsByTopoLevel = undefined;
    this.$topoLevels = undefined;
    this.linearizedByTopoLevelsSource = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_60__["MI"])(this.linearizedByTopoLevels());
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_59___default()(MixinWalkDepthState, [{
    key: "buildTopoLevels",
    value: function buildTopoLevels() {
      return Array.from(this.elementsByTopoLevel.keys()).sort(function (level1, level2) {
        return level1 - level2;
      });
    }
  }, {
    key: "getOrCreateLevel",
    value: function getOrCreateLevel(map, topoLevel) {
      var elementsAtLevel = map.get(topoLevel);

      if (!elementsAtLevel) {
        elementsAtLevel = [];
        map.set(topoLevel, elementsAtLevel);
      }

      return elementsAtLevel;
    }
  }, {
    key: "buildElementsByTopoLevel",
    value: function buildElementsByTopoLevel() {
      var _this = this;

      var maxTopoLevel = 0;
      var baseElements = this.baseEl ? Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_60__["CI"])(this.baseEl.walkDepthState.elementsByTopoLevel.values()).concat().toSet() : new Set();
      var map = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_60__["CI"])(this.sourceEl.requirements).map(function (mixin) {
        return mixin.walkDepthState.elementsByTopoLevel;
      }).concat().reduce(function (elementsByTopoLevel, _ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_57___default()(_ref, 2),
            topoLevel = _ref2[0],
            mixins = _ref2[1];

        if (topoLevel > maxTopoLevel) maxTopoLevel = topoLevel;

        _this.getOrCreateLevel(elementsByTopoLevel, topoLevel).push(mixins);

        return elementsByTopoLevel;
      }, new Map());
      this.getOrCreateLevel(map, maxTopoLevel + 1).push([this.sourceEl]);
      return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_60__["CI"])(map).map(function (_ref3) {
        var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_57___default()(_ref3, 2),
            level = _ref4[0],
            elements = _ref4[1];

        return [level, Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_60__["CI"])(elements).concat().uniqueOnly().filter(function (mixin) {
          return !baseElements.has(mixin);
        }).sort(function (mixin1, mixin2) {
          return mixin1.id - mixin2.id;
        })];
      }).toMap();
    }
  }, {
    key: "linearizedByTopoLevels",
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_55___default.a.mark(function linearizedByTopoLevels() {
      var _this2 = this;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_55___default.a.wrap(function linearizedByTopoLevels$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_60__["CI"])(this.topoLevels).map(function (level) {
                return _this2.elementsByTopoLevel.get(level);
              }).concat(), "t0", 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, linearizedByTopoLevels, this);
    })
  }, {
    key: "topoLevels",
    get: function get() {
      if (this.$topoLevels !== undefined) return this.$topoLevels;
      return this.$topoLevels = this.buildTopoLevels();
    }
  }, {
    key: "elementsByTopoLevel",
    get: function get() {
      if (this.$elementsByTopoLevel !== undefined) return this.$elementsByTopoLevel;
      return this.$elementsByTopoLevel = this.buildElementsByTopoLevel();
    }
  }], [{
    key: "new",
    value: function _new(props) {
      var me = new this();
      props && Object.assign(me, props);
      return me;
    }
  }]);

  return MixinWalkDepthState;
}();

var MIXIN_ID = 1;
var identity = function identity(a) {
  return /*#__PURE__*/function (_a) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_52___default()(_class, _a);

    var _super = _createSuper(_class);

    function _class() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, _class);

      return _super.apply(this, arguments);
    }

    return _class;
  }(a);
};
var ZeroBaseClass = function ZeroBaseClass() {
  _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, ZeroBaseClass);
};

var MixinState = /*#__PURE__*/function () {
  function MixinState() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, MixinState);

    this.id = MIXIN_ID++;
    this.requirements = [];
    this.baseClass = ZeroBaseClass;
    this.identitySymbol = undefined;
    this.mixinLambda = identity;
    this.walkDepthState = undefined;
    this.$minimalClass = undefined;
    this.name = '';
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_59___default()(MixinState, [{
    key: "getBaseClassMixinId",
    value: function getBaseClassMixinId(baseClass) {
      var constructor = this.constructor;
      var mixinId = constructor.baseClassesIds.get(baseClass);
      if (mixinId !== undefined) return mixinId;
      var newId = MIXIN_ID++;
      constructor.baseClassesIds.set(baseClass, newId);
      return newId;
    }
  }, {
    key: "buildMinimalClass",
    value: function buildMinimalClass() {
      var _Object$assign;

      var self = this.constructor;
      var baseCls = this.baseClass;
      var minimalClassConstructor = this.walkDepthState.linearizedByTopoLevelsSource.reduce(function (acc, mixin) {
        var cls = acc.cls,
            hash = acc.hash;
        var nextHash = hash + String.fromCharCode(mixin.id);
        var wrapperCls = self.minimalClassesByLinearHash.get(nextHash);

        if (!wrapperCls) {
          wrapperCls = mixin.mixinLambda(cls);
          mixin.name = wrapperCls.name;
          self.minimalClassesByLinearHash.set(nextHash, wrapperCls);
        }

        acc.cls = wrapperCls;
        acc.hash = nextHash;
        return acc;
      }, {
        cls: baseCls,
        hash: String.fromCharCode(this.getBaseClassMixinId(baseCls))
      }).cls;
      var minimalClass = Object.assign(minimalClassConstructor, (_Object$assign = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51___default()(_Object$assign, MixinInstanceOfProperty, this.identitySymbol), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51___default()(_Object$assign, MixinStateProperty, this), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51___default()(_Object$assign, "mix", this.mixinLambda), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51___default()(_Object$assign, "derive", function derive(base) {
        return Mixin([minimalClass, base], function (base) {
          return /*#__PURE__*/function (_base) {
            _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_52___default()(_class2, _base);

            var _super2 = _createSuper(_class2);

            function _class2() {
              _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, _class2);

              return _super2.apply(this, arguments);
            }

            return _class2;
          }(base);
        });
      }), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51___default()(_Object$assign, "$", this), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51___default()(_Object$assign, "toString", this.toString.bind(this)), _Object$assign));
      Object.defineProperty(minimalClass, Symbol.hasInstance, {
        value: isInstanceOfStatic
      });
      return minimalClass;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.walkDepthState.linearizedByTopoLevelsSource.reduce(function (acc, mixin) {
        return "".concat(mixin.name, "(").concat(acc, ")");
      }, this.baseClass.name);
    }
  }, {
    key: "minimalClass",
    get: function get() {
      if (this.$minimalClass !== undefined) return this.$minimalClass;
      return this.$minimalClass = this.buildMinimalClass();
    }
  }], [{
    key: "new",
    value: function _new(props) {
      var _Object$assign2;

      var me = new this();
      props && Object.assign(me, props);
      me.walkDepthState = MixinWalkDepthState.new({
        sourceEl: me,
        baseEl: getMixinState(me.baseClass)
      });
      var mixinLambda = me.mixinLambda;
      var symbol = me.identitySymbol = Symbol(mixinLambda.name);
      var mixinLambdaWrapper = Object.assign(function (base) {
        var extendedClass = mixinLambda(base);
        extendedClass.prototype[symbol] = true;
        return extendedClass;
      }, (_Object$assign2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51___default()(_Object$assign2, MixinInstanceOfProperty, symbol), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_51___default()(_Object$assign2, MixinStateProperty, me), _Object$assign2));
      Object.defineProperty(mixinLambdaWrapper, Symbol.hasInstance, {
        value: isInstanceOfStatic
      });
      me.mixinLambda = mixinLambdaWrapper;
      return me;
    }
  }]);

  return MixinState;
}();

MixinState.minimalClassesByLinearHash = new Map();
MixinState.baseClassesIds = new Map();

var isMixinClass = function isMixinClass(func) {
  return Object.getPrototypeOf(func.prototype).constructor.hasOwnProperty(MixinStateProperty);
};

var getMixinState = function getMixinState(func) {
  return Object.getPrototypeOf(func.prototype).constructor[MixinStateProperty];
};

var mixin = function mixin(required, mixinLambda) {
  var baseClass;

  if (required.length > 0) {
    var lastRequirement = required[required.length - 1];
    if (!isMixinClass(lastRequirement) && lastRequirement !== ZeroBaseClass) baseClass = lastRequirement;
  }

  var requirements = [];
  required.forEach(function (requirement, index) {
    var mixinState = requirement[MixinStateProperty];

    if (mixinState !== undefined) {
      var currentBaseClass = mixinState.baseClass;

      if (currentBaseClass !== ZeroBaseClass) {
        if (baseClass) {
          if (baseClass !== currentBaseClass) {
            var currentIsSub = currentBaseClass.prototype.isPrototypeOf(baseClass.prototype);
            var currentIsSuper = baseClass.prototype.isPrototypeOf(currentBaseClass.prototype);
            if (!currentIsSub && !currentIsSuper) throw new Error("Base class mismatch");
            baseClass = currentIsSuper ? currentBaseClass : baseClass;
          }
        } else baseClass = currentBaseClass;
      }

      requirements.push(mixinState);
    } else {
      if (index !== required.length - 1) throw new Error("Base class should be provided as the last element of the requirements array");
    }
  });
  var mixinState = MixinState.new({
    requirements: requirements,
    mixinLambda: mixinLambda,
    baseClass: baseClass || ZeroBaseClass
  });
  return mixinState.minimalClass;
};

var isInstanceOfStatic = function isInstanceOfStatic(instance) {
  return Boolean(instance && instance[this[MixinInstanceOfProperty]]);
};

var isInstanceOf = function isInstanceOf(instance, func) {
  return Boolean(instance && instance[func[MixinInstanceOfProperty]]);
};
var Mixin = mixin;
var MixinAny = mixin;

/***/ }),

/***/ "./lib/ChronoGraph/class/RequiredProperty.js":
/*!***************************************************!*\
  !*** ./lib/ChronoGraph/class/RequiredProperty.js ***!
  \***************************************************/
/*! exports provided: required, validateRequiredProperties */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "required", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateRequiredProperties", function() { return validateRequiredProperties; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");



var productName = 'scheduler';

var RequiredProperties = Symbol('RequiredProperties');

var emptyFn = function emptyFn() {
  return undefined;
};

var required = Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_3__["DEBUG_ONLY"])(function (proto, propertyKey) {
  var required = proto[RequiredProperties];
  if (!required) required = proto[RequiredProperties] = [];
  required.push(propertyKey);
});
var validateRequiredProperties = Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_3__["DEBUG_ONLY"])(function (context) {
  var required = context[RequiredProperties];

  if (required) {
    for (var i = 0; i < required.length; i++) {
      if (context[required[i]] === undefined) throw new Error("Required attribute [".concat(String(required[i]), "] is not provided"));
    }
  }
});

/***/ }),

/***/ "./lib/ChronoGraph/collection/Iterator.js":
/*!************************************************!*\
  !*** ./lib/ChronoGraph/collection/Iterator.js ***!
  \************************************************/
/*! exports provided: split, inBatchesBySize, filter, drop, every, some, map, reduce, uniqueOnly, uniqueOnlyBy, reverse, takeWhile, takeUntilIncluding, takeUntilExcluding, concat, concatIterable, ChainedIteratorClass, ChainedIterator, CI, MemoizedIteratorClass, MemoizedIterator, MI */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "split", function() { return _split; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inBatchesBySize", function() { return _inBatchesBySize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return _filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return _drop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "every", function() { return _every; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "some", function() { return _some; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return _map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return _reduce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueOnly", function() { return _uniqueOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueOnlyBy", function() { return _uniqueOnlyBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reverse", function() { return reverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeWhile", function() { return _takeWhile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeUntilIncluding", function() { return takeUntilIncluding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeUntilExcluding", function() { return takeUntilExcluding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concatIterable", function() { return concatIterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainedIteratorClass", function() { return ChainedIteratorClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainedIterator", function() { return ChainedIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CI", function() { return CI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MemoizedIteratorClass", function() { return MemoizedIteratorClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MemoizedIterator", function() { return MemoizedIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MI", function() { return MI; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_50__);




















































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _marked = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(_inBatchesBySize),
    _marked2 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(_filter),
    _marked3 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(_drop),
    _marked4 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(_map),
    _marked5 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(_uniqueOnly),
    _marked6 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(_uniqueOnlyBy),
    _marked7 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(reverse),
    _marked8 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(_takeWhile),
    _marked9 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(takeUntilIncluding),
    _marked10 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(takeUntilExcluding),
    _marked11 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(concat),
    _marked12 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(concatIterable);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';

function _split(iterable) {
  var gen1Pending = [];
  var gen2Pending = [];
  var iterator;

  var gen1 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(function gen1() {
    var _iterator$next, value, done;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function gen1$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!iterator) iterator = iterable[Symbol.iterator]();

          case 1:
            if (false) {}

            if (!gen1Pending.length) {
              _context.next = 5;
              break;
            }

            return _context.delegateYield(gen1Pending, "t0", 4);

          case 4:
            gen1Pending.length = 0;

          case 5:
            if (iterator) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("break", 17);

          case 7:
            _iterator$next = iterator.next(), value = _iterator$next.value, done = _iterator$next.done;

            if (!done) {
              _context.next = 12;
              break;
            }

            iterator = null;
            iterable = null;
            return _context.abrupt("break", 17);

          case 12:
            gen2Pending.push(value);
            _context.next = 15;
            return value;

          case 15:
            _context.next = 1;
            break;

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, gen1);
  });

  var gen2 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(function gen2() {
    var _iterator$next2, value, done;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function gen2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!iterator) iterator = iterable[Symbol.iterator]();

          case 1:
            if (false) {}

            if (!gen2Pending.length) {
              _context2.next = 5;
              break;
            }

            return _context2.delegateYield(gen2Pending, "t0", 4);

          case 4:
            gen2Pending.length = 0;

          case 5:
            if (iterator) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("break", 17);

          case 7:
            _iterator$next2 = iterator.next(), value = _iterator$next2.value, done = _iterator$next2.done;

            if (!done) {
              _context2.next = 12;
              break;
            }

            iterator = null;
            iterable = null;
            return _context2.abrupt("break", 17);

          case 12:
            gen1Pending.push(value);
            _context2.next = 15;
            return value;

          case 15:
            _context2.next = 1;
            break;

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, gen2);
  });

  return [gen1(), gen2()];
}



function _inBatchesBySize(iterator, batchSize) {
  var runningBatch, _iterator, _step, el;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function inBatchesBySize$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!(batchSize < 0)) {
            _context3.next = 2;
            break;
          }

          throw new Error("Batch size needs to a natural number");

        case 2:
          batchSize = batchSize | 0;
          runningBatch = [];
          _iterator = _createForOfIteratorHelper(iterator);
          _context3.prev = 5;

          _iterator.s();

        case 7:
          if ((_step = _iterator.n()).done) {
            _context3.next = 16;
            break;
          }

          el = _step.value;

          if (!(runningBatch.length === batchSize)) {
            _context3.next = 13;
            break;
          }

          _context3.next = 12;
          return runningBatch;

        case 12:
          runningBatch.length = 0;

        case 13:
          runningBatch.push(el);

        case 14:
          _context3.next = 7;
          break;

        case 16:
          _context3.next = 21;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3["catch"](5);

          _iterator.e(_context3.t0);

        case 21:
          _context3.prev = 21;

          _iterator.f();

          return _context3.finish(21);

        case 24:
          if (!(runningBatch.length > 0)) {
            _context3.next = 27;
            break;
          }

          _context3.next = 27;
          return runningBatch;

        case 27:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked, null, [[5, 18, 21, 24]]);
}



function _filter(iterator, func) {
  var i, _iterator2, _step2, el;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function filter$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          i = 0;
          _iterator2 = _createForOfIteratorHelper(iterator);
          _context4.prev = 2;

          _iterator2.s();

        case 4:
          if ((_step2 = _iterator2.n()).done) {
            _context4.next = 11;
            break;
          }

          el = _step2.value;

          if (!func(el, i++)) {
            _context4.next = 9;
            break;
          }

          _context4.next = 9;
          return el;

        case 9:
          _context4.next = 4;
          break;

        case 11:
          _context4.next = 16;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](2);

          _iterator2.e(_context4.t0);

        case 16:
          _context4.prev = 16;

          _iterator2.f();

          return _context4.finish(16);

        case 19:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked2, null, [[2, 13, 16, 19]]);
}



function _drop(iterator, howMany) {
  var i, _iterator3, _step3, el;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function drop$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          i = 0;
          _iterator3 = _createForOfIteratorHelper(iterator);
          _context5.prev = 2;

          _iterator3.s();

        case 4:
          if ((_step3 = _iterator3.n()).done) {
            _context5.next = 11;
            break;
          }

          el = _step3.value;

          if (!(++i > howMany)) {
            _context5.next = 9;
            break;
          }

          _context5.next = 9;
          return el;

        case 9:
          _context5.next = 4;
          break;

        case 11:
          _context5.next = 16;
          break;

        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](2);

          _iterator3.e(_context5.t0);

        case 16:
          _context5.prev = 16;

          _iterator3.f();

          return _context5.finish(16);

        case 19:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked3, null, [[2, 13, 16, 19]]);
}



function _every(iterator, func) {
  var i = 0;

  var _iterator4 = _createForOfIteratorHelper(iterator),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var el = _step4.value;
      if (!func(el, i++)) return false;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return true;
}



function _some(iterator, func) {
  var i = 0;

  var _iterator5 = _createForOfIteratorHelper(iterator),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var el = _step5.value;
      if (func(el, i++)) return true;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return false;
}



function _map(iterator, func) {
  var i, _iterator6, _step6, el;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function map$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          i = 0;
          _iterator6 = _createForOfIteratorHelper(iterator);
          _context6.prev = 2;

          _iterator6.s();

        case 4:
          if ((_step6 = _iterator6.n()).done) {
            _context6.next = 10;
            break;
          }

          el = _step6.value;
          _context6.next = 8;
          return func(el, i++);

        case 8:
          _context6.next = 4;
          break;

        case 10:
          _context6.next = 15;
          break;

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);

          _iterator6.e(_context6.t0);

        case 15:
          _context6.prev = 15;

          _iterator6.f();

          return _context6.finish(15);

        case 18:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked4, null, [[2, 12, 15, 18]]);
}



function _reduce(iterator, func, initialAcc) {
  var i = 0;
  var acc = initialAcc;

  var _iterator7 = _createForOfIteratorHelper(iterator),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var el = _step7.value;
      acc = func(acc, el, i++);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return acc;
}



function _uniqueOnly(iterator) {
  var seen, _iterator8, _step8, el;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function uniqueOnly$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          seen = new Set();
          _iterator8 = _createForOfIteratorHelper(iterator);
          _context7.prev = 2;

          _iterator8.s();

        case 4:
          if ((_step8 = _iterator8.n()).done) {
            _context7.next = 12;
            break;
          }

          el = _step8.value;

          if (seen.has(el)) {
            _context7.next = 10;
            break;
          }

          seen.add(el);
          _context7.next = 10;
          return el;

        case 10:
          _context7.next = 4;
          break;

        case 12:
          _context7.next = 17;
          break;

        case 14:
          _context7.prev = 14;
          _context7.t0 = _context7["catch"](2);

          _iterator8.e(_context7.t0);

        case 17:
          _context7.prev = 17;

          _iterator8.f();

          return _context7.finish(17);

        case 20:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked5, null, [[2, 14, 17, 20]]);
}



function _uniqueOnlyBy(iterator, func) {
  var seen, _iterator9, _step9, el, uniqueBy;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function uniqueOnlyBy$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          seen = new Set();
          _iterator9 = _createForOfIteratorHelper(iterator);
          _context8.prev = 2;

          _iterator9.s();

        case 4:
          if ((_step9 = _iterator9.n()).done) {
            _context8.next = 13;
            break;
          }

          el = _step9.value;
          uniqueBy = func(el);

          if (seen.has(uniqueBy)) {
            _context8.next = 11;
            break;
          }

          seen.add(uniqueBy);
          _context8.next = 11;
          return el;

        case 11:
          _context8.next = 4;
          break;

        case 13:
          _context8.next = 18;
          break;

        case 15:
          _context8.prev = 15;
          _context8.t0 = _context8["catch"](2);

          _iterator9.e(_context8.t0);

        case 18:
          _context8.prev = 18;

          _iterator9.f();

          return _context8.finish(18);

        case 21:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked6, null, [[2, 15, 18, 21]]);
}


function reverse(iterator) {
  var all, i;
  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function reverse$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          all = Array.from(iterator);
          i = all.length - 1;

        case 2:
          if (!(i >= 0)) {
            _context9.next = 8;
            break;
          }

          _context9.next = 5;
          return all[i];

        case 5:
          i--;
          _context9.next = 2;
          break;

        case 8:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked7);
}

function _takeWhile(iterator, func) {
  var i, _iterator10, _step10, el;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function takeWhile$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          i = 0;
          _iterator10 = _createForOfIteratorHelper(iterator);
          _context10.prev = 2;

          _iterator10.s();

        case 4:
          if ((_step10 = _iterator10.n()).done) {
            _context10.next = 14;
            break;
          }

          el = _step10.value;

          if (!func(el, i++)) {
            _context10.next = 11;
            break;
          }

          _context10.next = 9;
          return el;

        case 9:
          _context10.next = 12;
          break;

        case 11:
          return _context10.abrupt("return");

        case 12:
          _context10.next = 4;
          break;

        case 14:
          _context10.next = 19;
          break;

        case 16:
          _context10.prev = 16;
          _context10.t0 = _context10["catch"](2);

          _iterator10.e(_context10.t0);

        case 19:
          _context10.prev = 19;

          _iterator10.f();

          return _context10.finish(19);

        case 22:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked8, null, [[2, 16, 19, 22]]);
}


function takeUntilIncluding(iterator, func) {
  var i, _iterator11, _step11, el;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function takeUntilIncluding$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          i = 0;
          _iterator11 = _createForOfIteratorHelper(iterator);
          _context11.prev = 2;

          _iterator11.s();

        case 4:
          if ((_step11 = _iterator11.n()).done) {
            _context11.next = 12;
            break;
          }

          el = _step11.value;
          _context11.next = 8;
          return el;

        case 8:
          if (!func(el, i++)) {
            _context11.next = 10;
            break;
          }

          return _context11.abrupt("return");

        case 10:
          _context11.next = 4;
          break;

        case 12:
          _context11.next = 17;
          break;

        case 14:
          _context11.prev = 14;
          _context11.t0 = _context11["catch"](2);

          _iterator11.e(_context11.t0);

        case 17:
          _context11.prev = 17;

          _iterator11.f();

          return _context11.finish(17);

        case 20:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked9, null, [[2, 14, 17, 20]]);
}
function takeUntilExcluding(iterator, func) {
  var i, _iterator12, _step12, el;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function takeUntilExcluding$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          i = 0;
          _iterator12 = _createForOfIteratorHelper(iterator);
          _context12.prev = 2;

          _iterator12.s();

        case 4:
          if ((_step12 = _iterator12.n()).done) {
            _context12.next = 12;
            break;
          }

          el = _step12.value;

          if (!func(el, i++)) {
            _context12.next = 8;
            break;
          }

          return _context12.abrupt("return");

        case 8:
          _context12.next = 10;
          return el;

        case 10:
          _context12.next = 4;
          break;

        case 12:
          _context12.next = 17;
          break;

        case 14:
          _context12.prev = 14;
          _context12.t0 = _context12["catch"](2);

          _iterator12.e(_context12.t0);

        case 17:
          _context12.prev = 17;

          _iterator12.f();

          return _context12.finish(17);

        case 20:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked10, null, [[2, 14, 17, 20]]);
}
function concat() {
  var i,
      _args13 = arguments;
  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function concat$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          i = 0;

        case 1:
          if (!(i < _args13.length)) {
            _context13.next = 6;
            break;
          }

          return _context13.delegateYield(i < 0 || _args13.length <= i ? undefined : _args13[i], "t0", 3);

        case 3:
          i++;
          _context13.next = 1;
          break;

        case 6:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked11);
}
function concatIterable(iteratorsProducer) {
  var _iterator13, _step13, iterator;

  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function concatIterable$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _iterator13 = _createForOfIteratorHelper(iteratorsProducer);
          _context14.prev = 1;

          _iterator13.s();

        case 3:
          if ((_step13 = _iterator13.n()).done) {
            _context14.next = 8;
            break;
          }

          iterator = _step13.value;
          return _context14.delegateYield(iterator, "t0", 6);

        case 6:
          _context14.next = 3;
          break;

        case 8:
          _context14.next = 13;
          break;

        case 10:
          _context14.prev = 10;
          _context14.t1 = _context14["catch"](1);

          _iterator13.e(_context14.t1);

        case 13:
          _context14.prev = 13;

          _iterator13.f();

          return _context14.finish(13);

        case 16:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked12, null, [[1, 10, 13, 16]]);
}
var ChainedIteratorClass = /*#__PURE__*/function () {
  function ChainedIteratorClass(iterable) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_47___default()(this, ChainedIteratorClass);

    this.iterable = undefined;
    if (!iterable) throw new Error("Require an iterable instance for chaining");
    this.iterable = iterable;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_48___default()(ChainedIteratorClass, [{
    key: "derive",
    value: function derive(iterable) {
      this.iterable = undefined;
      return new ChainedIteratorClass(iterable);
    }
  }, {
    key: "copy",
    value: function copy() {
      var _split2 = _split(this.iterable),
          _split3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_46___default()(_split2, 2),
          iter1 = _split3[0],
          iter2 = _split3[1];

      this.iterable = iter2;
      return new ChainedIteratorClass(iter1);
    }
  }, {
    key: "split",
    value: function split() {
      var _split4 = _split(this.iterable),
          _split5 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_46___default()(_split4, 2),
          iter1 = _split5[0],
          iter2 = _split5[1];

      return [new ChainedIteratorClass(iter1), this.derive(iter2)];
    }
  }, {
    key: "inBatchesBySize",
    value: function inBatchesBySize(batchSize) {
      return this.derive(_inBatchesBySize(this.iterable, batchSize));
    }
  }, {
    key: "filter",
    value: function filter(func) {
      return this.derive(_filter(this.iterable, func));
    }
  }, {
    key: "drop",
    value: function drop(howMany) {
      return this.derive(_drop(this.iterable, howMany));
    }
  }, {
    key: "map",
    value: function map(func) {
      return this.derive(_map(this.iterable, func));
    }
  }, {
    key: "reduce",
    value: function reduce(func, initialAcc) {
      return _reduce(this, func, initialAcc);
    }
  }, {
    key: "concat",
    value: function concat() {
      return this.derive(concatIterable(this.iterable));
    }
  }, {
    key: "uniqueOnly",
    value: function uniqueOnly() {
      return this.derive(_uniqueOnly(this.iterable));
    }
  }, {
    key: "uniqueOnlyBy",
    value: function uniqueOnlyBy(func) {
      return this.derive(_uniqueOnlyBy(this.iterable, func));
    }
  }, {
    key: "every",
    value: function every(func) {
      return _every(this, func);
    }
  }, {
    key: "some",
    value: function some(func) {
      return _some(this, func);
    }
  }, {
    key: "takeWhile",
    value: function takeWhile(func) {
      return this.derive(_takeWhile(this.iterable, func));
    }
  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(function value() {
      var iterable;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function value$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              iterable = this.iterable;

              if (iterable) {
                _context15.next = 3;
                break;
              }

              throw new Error("Chained iterator already exhausted or used to derive the new one");

            case 3:
              this.iterable = undefined;
              return _context15.delegateYield(iterable, "t0", 5);

            case 5:
              iterable = undefined;

            case 6:
            case "end":
              return _context15.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "toArray",
    value: function toArray() {
      return Array.from(this);
    }
  }, {
    key: "sort",
    value: function sort(order) {
      return Array.from(this).sort(order);
    }
  }, {
    key: "toSet",
    value: function toSet() {
      return new Set(this);
    }
  }, {
    key: "toMap",
    value: function toMap() {
      return new Map(this);
    }
  }, {
    key: "flush",
    value: function flush() {
      var _iterator14 = _createForOfIteratorHelper(this),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var element = _step14.value;
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
  }, {
    key: "memoize",
    value: function memoize() {
      return new MemoizedIteratorClass(this);
    }
  }]);

  return ChainedIteratorClass;
}();
var ChainedIterator = function ChainedIterator(iterator) {
  return new ChainedIteratorClass(iterator);
};
var CI = ChainedIterator;
var MemoizedIteratorClass = /*#__PURE__*/function (_ChainedIteratorClass) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43___default()(MemoizedIteratorClass, _ChainedIteratorClass);

  var _super = _createSuper(MemoizedIteratorClass);

  function MemoizedIteratorClass() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_47___default()(this, MemoizedIteratorClass);

    _this = _super.apply(this, arguments);
    _this.elements = [];
    _this.$iterator = undefined;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_48___default()(MemoizedIteratorClass, [{
    key: "derive",
    value: function derive(iterable) {
      return new ChainedIteratorClass(iterable);
    }
  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.mark(function value() {
      var elements, iterator, alreadyConsumed, i, _iterator$next3, _value, done;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_49___default.a.wrap(function value$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              elements = this.elements;

              if (!this.$iterable) {
                _context16.next = 33;
                break;
              }

              if (!this.$iterator) this.$iterator = this.$iterable[Symbol.iterator]();
              iterator = this.$iterator;
              alreadyConsumed = elements.length;

              if (!(alreadyConsumed > 0)) {
                _context16.next = 7;
                break;
              }

              return _context16.delegateYield(elements, "t0", 7);

            case 7:
              if (false) {}

              if (!(elements.length > alreadyConsumed)) {
                _context16.next = 17;
                break;
              }

              i = alreadyConsumed;

            case 10:
              if (!(i < elements.length)) {
                _context16.next = 16;
                break;
              }

              _context16.next = 13;
              return elements[i];

            case 13:
              i++;
              _context16.next = 10;
              break;

            case 16:
              alreadyConsumed = elements.length;

            case 17:
              if (iterator) {
                _context16.next = 19;
                break;
              }

              return _context16.abrupt("break", 31);

            case 19:
              _iterator$next3 = iterator.next(), _value = _iterator$next3.value, done = _iterator$next3.done;

              if (!done) {
                _context16.next = 25;
                break;
              }

              iterator = this.$iterator = null;
              this.$iterable = null;
              _context16.next = 29;
              break;

            case 25:
              elements.push(_value);
              alreadyConsumed++;
              _context16.next = 29;
              return _value;

            case 29:
              _context16.next = 7;
              break;

            case 31:
              _context16.next = 34;
              break;

            case 33:
              return _context16.delegateYield(elements, "t1", 34);

            case 34:
            case "end":
              return _context16.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "iterable",
    set: function set(iterable) {
      this.$iterable = iterable;
    },
    get: function get() {
      return this;
    }
  }]);

  return MemoizedIteratorClass;
}(ChainedIteratorClass);
var MemoizedIterator = function MemoizedIterator(iterator) {
  return new MemoizedIteratorClass(iterator);
};
var MI = MemoizedIterator;

/***/ }),

/***/ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js":
/*!*********************************************************!*\
  !*** ./lib/ChronoGraph/cycle_resolver/CycleResolver.js ***!
  \*********************************************************/
/*! exports provided: CalculateProposed, Formula, VariableWalkContext, FormulasCache, CycleDescription, CycleResolution, VariableInputState, CycleResolutionInput, WalkState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculateProposed", function() { return CalculateProposed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Formula", function() { return Formula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VariableWalkContext", function() { return VariableWalkContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormulasCache", function() { return FormulasCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CycleDescription", function() { return CycleDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CycleResolution", function() { return CycleResolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VariableInputState", function() { return VariableInputState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CycleResolutionInput", function() { return CycleResolutionInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WalkState", function() { return WalkState; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_reduce_right__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.reduce-right */ "./node_modules/core-js/modules/es.array.reduce-right.js");
/* harmony import */ var core_js_modules_es_array_reduce_right__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_right__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_60___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_60__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_61___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_61__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_62___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_62__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _class_RequiredProperty_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../class/RequiredProperty.js */ "./lib/ChronoGraph/class/RequiredProperty.js");
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");
/* harmony import */ var _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../graph/WalkDepth.js */ "./lib/ChronoGraph/graph/WalkDepth.js");
































































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_61___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_61___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_60___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_62___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var FORMULA_ID = 0;
var CalculateProposed = FORMULA_ID++;
var Formula = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59___default()(Formula, _Base);

  var _super = _createSuper(Formula);

  function Formula() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, Formula);

    _this = _super.apply(this, arguments);
    _this.formulaId = FORMULA_ID++;
    _this.inputs = new Set();
    return _this;
  }

  return Formula;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_63__["Base"]);
var VariableWalkContext = /*#__PURE__*/function (_WalkContext) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59___default()(VariableWalkContext, _WalkContext);

  var _super2 = _createSuper(VariableWalkContext);

  function VariableWalkContext() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, VariableWalkContext);

    return _super2.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_57___default()(VariableWalkContext, [{
    key: "collectNext",
    value: function collectNext(sourceNode, toVisit) {
      if (sourceNode instanceof Formula) {
        toVisit.push({
          node: sourceNode.output,
          from: sourceNode,
          label: undefined
        });
      } else {
        var formulas = this.cache.formulasByInput.get(sourceNode);
        formulas && formulas.forEach(function (formula) {
          return toVisit.push({
            node: formula,
            from: sourceNode,
            label: undefined
          });
        });
      }
    }
  }]);

  return VariableWalkContext;
}(_graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_68__["WalkContext"]);
var FormulasCache = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59___default()(FormulasCache, _Mixin);

  var _super3 = _createSuper(FormulasCache);

  function FormulasCache() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, FormulasCache);

    return _super3.apply(this, arguments);
  }

  return FormulasCache;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_64__["Mixin"])([_class_Base_js__WEBPACK_IMPORTED_MODULE_63__["Base"]], function (base) {
  return /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59___default()(FormulasCache, _base);

    var _super4 = _createSuper(FormulasCache);

    function FormulasCache() {
      var _this2;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, FormulasCache);

      _this2 = _super4.apply(this, arguments);
      _this2.variables = new Set();
      _this2.formulas = new Set();
      _this2.$formulasByInput = undefined;
      _this2.$formulasByOutput = undefined;
      return _this2;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_57___default()(FormulasCache, [{
      key: "add",
      value: function add(formula) {
        this.$formulasByInput = undefined;
        this.$formulasByOutput = undefined;
        this.formulas.add(formula);
      }
    }, {
      key: "has",
      value: function has(formula) {
        return this.formulas.has(formula);
      }
    }, {
      key: "fillCache",
      value: function fillCache() {
        var _this3 = this;

        this.$formulasByInput = new Map();
        this.$formulasByOutput = new Map();
        this.formulas.forEach(function (formula) {
          var formulasByOutput = _this3.$formulasByOutput.get(formula.output);

          if (!formulasByOutput) {
            formulasByOutput = new Set();

            _this3.$formulasByOutput.set(formula.output, formulasByOutput);
          }

          formulasByOutput.add(formula);
          formula.inputs.forEach(function (input) {
            var formulasByInput = _this3.$formulasByInput.get(input);

            if (!formulasByInput) {
              formulasByInput = new Set();

              _this3.$formulasByInput.set(input, formulasByInput);
            }

            formulasByInput.add(formula);
          });
        });
      }
    }, {
      key: "allInputVariables",
      value: function allInputVariables() {
        return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["uniqueOnly"])(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["concatIterable"])(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["map"])(this.formulas, function (formula) {
          return formula.inputs.values();
        })));
      }
    }, {
      key: "isCyclic",
      value: function isCyclic() {
        var isCyclic = false;
        var walkContext = VariableWalkContext.new({
          cache: this,
          onCycle: function onCycle() {
            isCyclic = true;
            return _graph_WalkDepth_js__WEBPACK_IMPORTED_MODULE_68__["OnCycleAction"].Cancel;
          }
        });
        walkContext.startFrom(Array.from(this.allInputVariables()));
        return isCyclic;
      }
    }, {
      key: "formulasByInput",
      get: function get() {
        if (this.$formulasByInput !== undefined) return this.$formulasByInput;
        this.fillCache();
        return this.$formulasByInput;
      }
    }, {
      key: "formulasByOutput",
      get: function get() {
        if (this.$formulasByOutput !== undefined) return this.$formulasByOutput;
        this.fillCache();
        return this.$formulasByOutput;
      }
    }]);

    return FormulasCache;
  }(base);
}));
var CycleDescription = /*#__PURE__*/function (_FormulasCache) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59___default()(CycleDescription, _FormulasCache);

  var _super5 = _createSuper(CycleDescription);

  function CycleDescription() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, CycleDescription);

    return _super5.apply(this, arguments);
  }

  return CycleDescription;
}(FormulasCache);
var CycleResolution = /*#__PURE__*/function (_Base2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59___default()(CycleResolution, _Base2);

  var _super6 = _createSuper(CycleResolution);

  function CycleResolution() {
    var _this4;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, CycleResolution);

    _this4 = _super6.apply(this, arguments);
    _this4.description = undefined;
    _this4.defaultResolutionFormulas = new Set();
    _this4.resolutionsByInputHash = new Map();
    return _this4;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_57___default()(CycleResolution, [{
    key: "clear",
    value: function clear() {
      this.resolutionsByInputHash.clear();
    }
  }, {
    key: "resolve",
    value: function resolve(input) {
      var cached = this.resolutionsByInputHash.get(input.hash);
      if (cached !== undefined) return cached;
      var resolution = this.buildResolution(input);
      this.resolutionsByInputHash.set(input.hash, resolution);
      return resolution;
    }
  }, {
    key: "buildResolution",
    value: function buildResolution(input) {
      var walkContext = WalkState.new({
        context: this,
        input: input
      });
      var allResolutions = Array.from(walkContext.next()).map(function (state) {
        return {
          resolution: state.asResolution(),
          nbrOfDefaultFormulas: Array.from(state.activatedFormulas.formulas).reduce(function (count, formula) {
            return state.formulaIsDefault(formula) ? count + 1 : count;
          }, 0),
          unCoveredInputWeight: state.unCoveredInputWeight()
        };
      });
      allResolutions.sort(function (res1, res2) {
        if (res1.unCoveredInputWeight < res2.unCoveredInputWeight) return -1;
        if (res1.unCoveredInputWeight > res2.unCoveredInputWeight) return 1;
        return res2.nbrOfDefaultFormulas - res1.nbrOfDefaultFormulas;
      });
      if (allResolutions.length > 0) return allResolutions[0].resolution;else debugger;
    }
  }]);

  return CycleResolution;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_63__["Base"]);
var VariableInputState;

(function (VariableInputState) {
  VariableInputState[VariableInputState["NoInput"] = 0] = "NoInput";
  VariableInputState[VariableInputState["HasPreviousValue"] = 1] = "HasPreviousValue";
  VariableInputState[VariableInputState["HasProposedValue"] = 2] = "HasProposedValue";
  VariableInputState[VariableInputState["KeepIfPossible"] = 4] = "KeepIfPossible";
})(VariableInputState || (VariableInputState = {}));

var CycleResolutionInput = /*#__PURE__*/function (_Base3) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59___default()(CycleResolutionInput, _Base3);

  var _super7 = _createSuper(CycleResolutionInput);

  function CycleResolutionInput() {
    var _this5;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, CycleResolutionInput);

    _this5 = _super7.apply(this, arguments);
    _this5.context = undefined;
    _this5.input = undefined;
    _this5.$hash = '';
    return _this5;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_57___default()(CycleResolutionInput, [{
    key: "initialize",
    value: function initialize() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_56___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_61___default()(CycleResolutionInput.prototype), "initialize", this)).call.apply(_get2, [this].concat(args));

      Object(_class_RequiredProperty_js__WEBPACK_IMPORTED_MODULE_65__["validateRequiredProperties"])(this);
      this.input = new Map(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["CI"])(this.description.variables).map(function (variable) {
        return [variable, VariableInputState.NoInput];
      }));
    }
  }, {
    key: "buildHash",
    value: function buildHash() {
      var _this6 = this;

      return String.fromCharCode.apply(String, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_55___default()(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["CI"])(this.description.variables).inBatchesBySize(5).map(function (batch) {
        return _this6.batchToCharCode(batch);
      })));
    }
  }, {
    key: "batchToCharCode",
    value: function batchToCharCode(batch) {
      var _this7 = this;

      return batch.reduceRight(function (charCode, variable, index) {
        return charCode | _this7.input.get(variable) << index * 3;
      }, 0);
    }
  }, {
    key: "addProposedValueFlag",
    value: function addProposedValueFlag(variable) {
      if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_67__["DEBUG"]) {
        if (!this.description.variables.has(variable)) throw new Error('Unknown variable');
        if (this.$hash !== '') throw new Error('Already hashed');
      }

      var input = this.input.get(variable);
      this.input.set(variable, input | VariableInputState.HasProposedValue);
    }
  }, {
    key: "hasProposedValue",
    value: function hasProposedValue(variable) {
      return Boolean(this.input.get(variable) & VariableInputState.HasProposedValue);
    }
  }, {
    key: "hasProposedValueVars",
    value: function hasProposedValueVars() {
      var _this8 = this;

      return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["CI"])(this.description.variables).filter(function (variable) {
        return _this8.hasProposedValue(variable);
      });
    }
  }, {
    key: "addPreviousValueFlag",
    value: function addPreviousValueFlag(variable) {
      if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_67__["DEBUG"]) {
        if (!this.description.variables.has(variable)) throw new Error('Unknown variable');
        if (this.$hash !== '') throw new Error('Already hashed');
      }

      var input = this.input.get(variable);
      this.input.set(variable, input | VariableInputState.HasPreviousValue);
    }
  }, {
    key: "hasPreviousValue",
    value: function hasPreviousValue(variable) {
      return Boolean(this.input.get(variable) & VariableInputState.HasPreviousValue);
    }
  }, {
    key: "hasPreviousValueVars",
    value: function hasPreviousValueVars() {
      var _this9 = this;

      return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["CI"])(this.description.variables).filter(function (variable) {
        return _this9.hasPreviousValue(variable);
      });
    }
  }, {
    key: "addKeepIfPossibleFlag",
    value: function addKeepIfPossibleFlag(variable) {
      if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_67__["DEBUG"]) {
        if (!this.description.variables.has(variable)) throw new Error('Unknown variable');
        if (this.$hash !== '') throw new Error('Already hashed');
      }

      var input = this.input.get(variable);
      this.input.set(variable, input | VariableInputState.KeepIfPossible);
    }
  }, {
    key: "keepIfPossible",
    value: function keepIfPossible(variable) {
      return Boolean(this.input.get(variable) & VariableInputState.KeepIfPossible);
    }
  }, {
    key: "keepIfPossibleVars",
    value: function keepIfPossibleVars() {
      var _this10 = this;

      return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["CI"])(this.description.variables).filter(function (variable) {
        return _this10.keepIfPossible(variable);
      });
    }
  }, {
    key: "hash",
    get: function get() {
      if (this.$hash !== '') return this.$hash;
      return this.$hash = this.buildHash();
    }
  }, {
    key: "description",
    get: function get() {
      return this.context.description;
    }
  }, {
    key: "resolution",
    get: function get() {
      return this.context.resolve(this);
    }
  }]);

  return CycleResolutionInput;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_63__["Base"]);

__decorate([_class_RequiredProperty_js__WEBPACK_IMPORTED_MODULE_65__["required"]], CycleResolutionInput.prototype, "context", void 0);

var WalkState = /*#__PURE__*/function (_Base4) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_59___default()(WalkState, _Base4);

  var _super8 = _createSuper(WalkState);

  function WalkState() {
    var _this11;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_58___default()(this, WalkState);

    _this11 = _super8.apply(this, arguments);
    _this11.context = undefined;
    _this11.input = undefined;
    _this11.previous = undefined;
    _this11.activatedFormula = undefined;
    _this11.$activatedFormulas = undefined;
    return _this11;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_57___default()(WalkState, [{
    key: "thisAndPreviousStates",
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_53___default.a.mark(function thisAndPreviousStates() {
      var current;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_53___default.a.wrap(function thisAndPreviousStates$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              current = this;

            case 1:
              if (!(current && current.activatedFormula)) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return current;

            case 4:
              current = current.previous;
              _context.next = 1;
              break;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, thisAndPreviousStates, this);
    })
  }, {
    key: "formulaHasProposedValueInInput",
    value: function formulaHasProposedValueInInput(formula) {
      var _this12 = this;

      return Array.from(formula.inputs).some(function (variable) {
        return _this12.input.hasProposedValue(variable);
      });
    }
  }, {
    key: "unCoveredInputWeight",
    value: function unCoveredInputWeight() {
      var _this13 = this;

      var proposedVars = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["map"])(this.input.hasProposedValueVars(), function (variable) {
        return {
          variable: variable,
          isProposed: true
        };
      });
      var keepIfPossibleVars = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["map"])(this.input.keepIfPossibleVars(), function (variable) {
        return {
          variable: variable,
          isProposed: false
        };
      });
      var allInputVars = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["CI"])([proposedVars, keepIfPossibleVars]).concat().uniqueOnlyBy(function (el) {
        return el.variable;
      });
      return allInputVars.reduce(function (totalWeight, _ref) {
        var variable = _ref.variable,
            isProposed = _ref.isProposed;
        var weight = 0;

        var isOverwrittenByFormulas = _this13.activatedFormulas.formulasByOutput.get(variable);

        if (isOverwrittenByFormulas) {
          var formula = isOverwrittenByFormulas.size === 1 ? Array.from(isOverwrittenByFormulas)[0] : null;

          if (formula && _this13.formulaIsDefault(formula) && _this13.formulaHasProposedValueInInput(formula)) {
            if (isProposed) weight += 1e6;else weight += 1e4;
          } else {
            if (isProposed) weight += 1e7;else weight += 1e5;
          }
        }

        var usedInFormulas = _this13.activatedFormulas.formulasByInput.get(variable);

        if (!(usedInFormulas && usedInFormulas.size > 0)) {
          if (isProposed) weight += 1e3;else weight += 1e2;
        }

        return totalWeight + weight;
      }, 0);
    }
  }, {
    key: "preferFormula",
    value: function preferFormula(formula1, formula2) {
      var allInputsHasProposed1 = this.formulaAllInputsHasProposed(formula1);
      var allInputsHasProposed2 = this.formulaAllInputsHasProposed(formula2);
      if (allInputsHasProposed1 && !allInputsHasProposed2) return -1;
      if (allInputsHasProposed2 && !allInputsHasProposed1) return 1;
      var countInputsWithProposedOrKeep1 = this.formulaCountInputsWithProposedOrKeep(formula1);
      var countInputsWithProposedOrKeep2 = this.formulaCountInputsWithProposedOrKeep(formula2);
      if (countInputsWithProposedOrKeep1 > countInputsWithProposedOrKeep2) return -1;
      if (countInputsWithProposedOrKeep1 < countInputsWithProposedOrKeep2) return 1;
      if (this.formulaIsDefault(formula1) && !this.formulaIsDefault(formula2)) return -1;
      if (this.formulaIsDefault(formula2) && !this.formulaIsDefault(formula1)) return 1;
      return 0;
    }
  }, {
    key: "formulaIsDefault",
    value: function formulaIsDefault(formula) {
      return this.context.defaultResolutionFormulas.has(formula);
    }
  }, {
    key: "formulaCountInputsWithProposedOrKeep",
    value: function formulaCountInputsWithProposedOrKeep(formula) {
      var _this14 = this;

      var count = 0;
      Array.from(formula.inputs).forEach(function (variable) {
        if (_this14.input.hasProposedValue(variable) || _this14.input.keepIfPossible(variable)) count++;
      });
      return count;
    }
  }, {
    key: "formulaAllInputsHasProposedOrKeep",
    value: function formulaAllInputsHasProposedOrKeep(formula) {
      var _this15 = this;

      return Array.from(formula.inputs).every(function (variable) {
        return _this15.input.hasProposedValue(variable) || _this15.input.keepIfPossible(variable);
      });
    }
  }, {
    key: "formulaAllInputsHasProposed",
    value: function formulaAllInputsHasProposed(formula) {
      var _this16 = this;

      return Array.from(formula.inputs).every(function (variable) {
        return _this16.input.hasProposedValue(variable);
      });
    }
  }, {
    key: "formulaIsApplicable",
    value: function formulaIsApplicable(formula) {
      var _this17 = this;

      var everyFormulaInputHasValue = Array.from(formula.inputs).every(function (variable) {
        return _this17.input.hasProposedValue(variable) || _this17.input.hasPreviousValue(variable) || _this17.activatedFormulas.formulasByOutput.has(variable);
      });
      var cache = FormulasCache.new({
        formulas: new Set(this.activatedFormulas.formulas)
      });
      cache.add(formula);
      return everyFormulaInputHasValue && !cache.isCyclic();
    }
  }, {
    key: "formulaIsInsignificant",
    value: function formulaIsInsignificant(formula) {
      var _this18 = this;

      var outputVariableAlreadyCalculated = this.activatedFormulas.formulasByOutput.has(formula.output);
      var outputVariableHasPreviousValue = this.input.hasPreviousValue(formula.output);
      return outputVariableAlreadyCalculated || outputVariableHasPreviousValue && Array.from(formula.inputs).some(function (variable) {
        return !_this18.input.hasPreviousValue(variable) && !_this18.input.hasProposedValue(variable);
      });
    }
  }, {
    key: "unvisitedFormulas",
    value: function unvisitedFormulas() {
      var _this19 = this;

      return Array.from(this.description.formulas).filter(function (formula) {
        return !_this19.activatedFormulas.has(formula);
      });
    }
  }, {
    key: "next",
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_53___default.a.mark(function next() {
      var unvisitedFormulas, isFinal, _iterator, _step, formula, nextState;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_53___default.a.wrap(function next$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              unvisitedFormulas = this.unvisitedFormulas();
              unvisitedFormulas.sort(this.preferFormula.bind(this));
              isFinal = true;
              _iterator = _createForOfIteratorHelper(unvisitedFormulas);
              _context2.prev = 4;

              _iterator.s();

            case 6:
              if ((_step = _iterator.n()).done) {
                _context2.next = 15;
                break;
              }

              formula = _step.value;

              if (!(!this.formulaIsApplicable(formula) || this.formulaIsInsignificant(formula))) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("continue", 13);

            case 10:
              nextState = WalkState.new({
                previous: this,
                context: this.context,
                input: this.input,
                activatedFormula: formula
              });
              return _context2.delegateYield(nextState.next(), "t0", 12);

            case 12:
              isFinal = false;

            case 13:
              _context2.next = 6;
              break;

            case 15:
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t1 = _context2["catch"](4);

              _iterator.e(_context2.t1);

            case 20:
              _context2.prev = 20;

              _iterator.f();

              return _context2.finish(20);

            case 23:
              if (!isFinal) {
                _context2.next = 26;
                break;
              }

              _context2.next = 26;
              return this;

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, next, this, [[4, 17, 20, 23]]);
    })
  }, {
    key: "asResolution",
    value: function asResolution() {
      var _this20 = this;

      return new Map(Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["CI"])(this.description.variables).map(function (variable) {
        var formulas = _this20.activatedFormulas.formulasByOutput.get(variable);

        if (formulas) {
          var _iterator2 = _createForOfIteratorHelper(formulas),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var firstFormula = _step2.value;
              return [variable, firstFormula.formulaId];
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        return [variable, CalculateProposed];
      }));
    }
  }, {
    key: "activatedFormulas",
    get: function get() {
      if (this.$activatedFormulas !== undefined) return this.$activatedFormulas;
      var cache = FormulasCache.new({
        variables: this.description.variables,
        formulas: Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_66__["CI"])(this.thisAndPreviousStates()).map(function (state) {
          return state.activatedFormula;
        }).toSet()
      });
      return this.$activatedFormulas = cache;
    }
  }, {
    key: "description",
    get: function get() {
      return this.context.description;
    }
  }]);

  return WalkState;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_63__["Base"]);

/***/ }),

/***/ "./lib/ChronoGraph/environment/Debug.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/environment/Debug.js ***!
  \**********************************************/
/*! exports provided: DEBUG, DEBUG_ONLY, debug, warn, StackEntry, SourceLinePoint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEBUG", function() { return DEBUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEBUG_ONLY", function() { return DEBUG_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debug", function() { return debug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warn", function() { return warn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StackEntry", function() { return StackEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SourceLinePoint", function() { return SourceLinePoint; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var DEBUG = false;

var emptyFn = function emptyFn() {
  return undefined;
};

var DEBUG_ONLY = function DEBUG_ONLY(func) {
  return DEBUG ? func : emptyFn;
};
var debug = DEBUG_ONLY(function (e) {
  debugger;
});
var warn = DEBUG_ONLY(function (e) {
  if (typeof console !== 'undefined') console.warn(e);
});
var StackEntry = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(StackEntry, _Base);

  var _super = _createSuper(StackEntry);

  function StackEntry() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, StackEntry);

    return _super.apply(this, arguments);
  }

  return StackEntry;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_11__["Base"]);
var SourceLinePoint = /*#__PURE__*/function (_Base2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(SourceLinePoint, _Base2);

  var _super2 = _createSuper(SourceLinePoint);

  function SourceLinePoint() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, SourceLinePoint);

    _this = _super2.apply(this, arguments);
    _this.stackEntries = [];
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(SourceLinePoint, null, [{
    key: "fromError",
    value: function fromError(e) {
      var res = SourceLinePoint.new({
        exception: e,
        stackEntries: parseErrorStack(e.stack)
      });
      return res;
    }
  }, {
    key: "fromThisCall",
    value: function fromThisCall() {
      var sourceLinePoint = this.fromError(new Error());
      sourceLinePoint.stackEntries.splice(0, 2);
      return sourceLinePoint;
    }
  }]);

  return SourceLinePoint;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_11__["Base"]);

var parseErrorStack = function parseErrorStack(stack) {
  return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_12__["CI"])(Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_13__["matchAll"])(/^   +at\s*(.*?)\s*\((https?:\/\/.*?):(\d+):(\d+)/gm, stack)).map(function (match) {
    return StackEntry.new({
      statement: match[1],
      sourceFile: match[2],
      sourceLine: Number(match[3]),
      sourceCharPos: Number(match[4])
    });
  }).toArray();
};

/***/ }),

/***/ "./lib/ChronoGraph/graph/WalkDepth.js":
/*!********************************************!*\
  !*** ./lib/ChronoGraph/graph/WalkDepth.js ***!
  \********************************************/
/*! exports provided: OnCycleAction, WalkSource, NOT_VISITED, VISITED_TOPOLOGICALLY, WalkContext, cycleInfo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OnCycleAction", function() { return OnCycleAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WalkSource", function() { return WalkSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOT_VISITED", function() { return NOT_VISITED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VISITED_TOPOLOGICALLY", function() { return VISITED_TOPOLOGICALLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WalkContext", function() { return WalkContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cycleInfo", function() { return cycleInfo; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");





























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var OnCycleAction;

(function (OnCycleAction) {
  OnCycleAction["Cancel"] = "Cancel";
  OnCycleAction["Resume"] = "Resume";
})(OnCycleAction || (OnCycleAction = {}));

var WalkSource = Symbol('WalkSource');
var NOT_VISITED = -1;
var VISITED_TOPOLOGICALLY = -2;
var WalkContext = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default()(WalkContext, _Base);

  var _super = _createSuper(WalkContext);

  function WalkContext() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23___default()(this, WalkContext);

    _this = _super.apply(this, arguments);
    _this.visited = new Map();
    _this.toVisit = [];
    _this.currentEpoch = 0;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24___default()(WalkContext, [{
    key: "startFrom",
    value: function startFrom(sourceNodes) {
      this.continueFrom(sourceNodes);
    }
  }, {
    key: "continueFrom",
    value: function continueFrom(sourceNodes) {
      this.toVisit.push.apply(this.toVisit, sourceNodes.map(function (node) {
        return {
          node: node,
          from: WalkSource,
          label: undefined
        };
      }));
      this.walkDepth();
    }
  }, {
    key: "onNode",
    value: function onNode(node, walkStep) {}
  }, {
    key: "onTopologicalNode",
    value: function onTopologicalNode(node) {}
  }, {
    key: "onCycle",
    value: function onCycle(node, stack) {
      return OnCycleAction.Cancel;
    }
  }, {
    key: "forEachNext",
    value: function forEachNext(node, func) {
      throw new Error("Abstract method called");
    }
  }, {
    key: "collectNext",
    value: function collectNext(node, toVisit, visitInfo) {
      throw new Error("Abstract method called");
    }
  }, {
    key: "getVisitedInfo",
    value: function getVisitedInfo(node) {
      return this.visited.get(node);
    }
  }, {
    key: "setVisitedInfo",
    value: function setVisitedInfo(node, visitedAt, info) {
      if (!info) {
        info = {
          visitedAt: visitedAt,
          visitEpoch: this.currentEpoch
        };
        this.visited.set(node, info);
      } else {
        info.visitedAt = visitedAt;
        info.visitEpoch = this.currentEpoch;
      }

      return info;
    }
  }, {
    key: "walkDepth",
    value: function walkDepth() {
      var visited = this.visited;
      var toVisit = this.toVisit;
      var depth;

      while (depth = toVisit.length) {
        var node = toVisit[depth - 1].node;
        var visitedInfo = this.getVisitedInfo(node);

        if (visitedInfo && visitedInfo.visitedAt === VISITED_TOPOLOGICALLY && visitedInfo.visitEpoch === this.currentEpoch) {
          toVisit.pop();
          continue;
        }

        if (visitedInfo && visitedInfo.visitEpoch === this.currentEpoch && visitedInfo.visitedAt !== NOT_VISITED) {
          if (visitedInfo.visitedAt < depth) {
            if (this.onCycle(node, toVisit) !== OnCycleAction.Resume) break;
          } else {
            visitedInfo.visitedAt = VISITED_TOPOLOGICALLY;
            this.onTopologicalNode(node);
          }

          toVisit.pop();
        } else {
          if (this.onNode(node, toVisit[depth - 1]) === false) break;
          var visitedInfo2 = this.setVisitedInfo(node, depth, visitedInfo);
          var lengthBefore = toVisit.length;
          this.collectNext(node, toVisit, visitedInfo2);

          if (toVisit.length === lengthBefore) {
            visitedInfo2.visitedAt = VISITED_TOPOLOGICALLY;
            this.onTopologicalNode(node);
            toVisit.pop();
          }
        }
      }
    }
  }]);

  return WalkContext;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_28__["Base"]);
function cycleInfo(stack) {
  var length = stack.length;
  if (length === 0) return [];
  var cycleSource = stack[length - 1].node;
  var cycle = [cycleSource];
  var current = length - 1;
  var cursor = current;

  while (current >= 0 && stack[current].from !== cycleSource) {
    while (current >= 0 && stack[current].from === stack[cursor].from) {
      current--;
    }

    if (current >= 0) {
      cycle.push(stack[current].node);
      cursor = current;
    }
  }

  if (current < 0) return [];
  cycle.push(cycleSource);
  return cycle.reverse();
}

/***/ }),

/***/ "./lib/ChronoGraph/primitives/Calculation.js":
/*!***************************************************!*\
  !*** ./lib/ChronoGraph/primitives/Calculation.js ***!
  \***************************************************/
/*! exports provided: ContextSync, ContextGen, CalculationGen, SynchronousCalculationStarted, CalculationSync, runGeneratorSyncWithEffect, runGeneratorAsyncWithEffect */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContextSync", function() { return ContextSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContextGen", function() { return ContextGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculationGen", function() { return CalculationGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SynchronousCalculationStarted", function() { return SynchronousCalculationStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculationSync", function() { return CalculationSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runGeneratorSyncWithEffect", function() { return runGeneratorSyncWithEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runGeneratorAsyncWithEffect", function() { return runGeneratorAsyncWithEffect; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var ContextSync = Symbol('ContextSync');
var ContextGen = Symbol('ContextGen');
var CalculationGen = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(CalculationGen, _Mixin);

  var _super = _createSuper(CalculationGen);

  function CalculationGen() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, CalculationGen);

    return _super.apply(this, arguments);
  }

  return CalculationGen;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_15__["Mixin"])([], function (base) {
  return /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(CalculationGen, _base);

    var _super2 = _createSuper(CalculationGen);

    function CalculationGen() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, CalculationGen);

      _this = _super2.apply(this, arguments);
      _this.iterator = undefined;
      _this.iterationResult = undefined;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(CalculationGen, [{
      key: "isCalculationStarted",
      value: function isCalculationStarted() {
        return Boolean(this.iterator || this.iterationResult);
      }
    }, {
      key: "isCalculationCompleted",
      value: function isCalculationCompleted() {
        return Boolean(this.iterationResult && this.iterationResult.done);
      }
    }, {
      key: "startCalculation",
      value: function startCalculation(onEffect) {
        var _this$calculation;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var iterator = this.iterator = (_this$calculation = this.calculation).call.apply(_this$calculation, [this.context || this, onEffect].concat(args));

        return this.iterationResult = iterator.next();
      }
    }, {
      key: "continueCalculation",
      value: function continueCalculation(value) {
        return this.iterationResult = this.iterator.next(value);
      }
    }, {
      key: "cleanupCalculation",
      value: function cleanupCalculation() {
        this.iterationResult = undefined;
        this.iterator = undefined;
      }
    }, {
      key: "calculation",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function calculation(onEffect) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function calculation$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error("Abstract method `calculation` called");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, calculation);
      })
    }, {
      key: "runSyncWithEffect",
      value: function runSyncWithEffect(onEffect) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        this.startCalculation.apply(this, [onEffect].concat(args));

        while (!this.isCalculationCompleted()) {
          this.continueCalculation(onEffect(this.iterationResult.value));
        }

        this.iterator = undefined;
        return this.result;
      }
    }, {
      key: "runAsyncWithEffect",
      value: function () {
        var _runAsyncWithEffect = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee(onEffect) {
          var _len3,
              args,
              _key3,
              _args2 = arguments;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  for (_len3 = _args2.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                    args[_key3 - 1] = _args2[_key3];
                  }

                  this.startCalculation.apply(this, [onEffect].concat(args));

                case 2:
                  if (this.isCalculationCompleted()) {
                    _context2.next = 10;
                    break;
                  }

                  _context2.t0 = this;
                  _context2.next = 6;
                  return onEffect(this.iterationResult.value);

                case 6:
                  _context2.t1 = _context2.sent;

                  _context2.t0.continueCalculation.call(_context2.t0, _context2.t1);

                  _context2.next = 2;
                  break;

                case 10:
                  this.iterator = undefined;
                  return _context2.abrupt("return", this.result);

                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee, this);
        }));

        function runAsyncWithEffect(_x) {
          return _runAsyncWithEffect.apply(this, arguments);
        }

        return runAsyncWithEffect;
      }()
    }, {
      key: "result",
      get: function get() {
        return this.iterationResult && this.iterationResult.done ? this.iterationResult.value : undefined;
      }
    }]);

    return CalculationGen;
  }(base);
}));
var SynchronousCalculationStarted = Symbol('SynchronousCalculationStarted');
var calculationStartedConstant = {
  value: SynchronousCalculationStarted
};
var CalculationSync = /*#__PURE__*/function (_Mixin2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(CalculationSync, _Mixin2);

  var _super3 = _createSuper(CalculationSync);

  function CalculationSync() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, CalculationSync);

    return _super3.apply(this, arguments);
  }

  return CalculationSync;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_15__["Mixin"])([], function (base) {
  return /*#__PURE__*/function (_base2) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(CalculationSync, _base2);

    var _super4 = _createSuper(CalculationSync);

    function CalculationSync() {
      var _this2;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, CalculationSync);

      _this2 = _super4.apply(this, arguments);
      _this2.iterationResult = undefined;
      return _this2;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(CalculationSync, [{
      key: "isCalculationStarted",
      value: function isCalculationStarted() {
        return Boolean(this.iterationResult);
      }
    }, {
      key: "isCalculationCompleted",
      value: function isCalculationCompleted() {
        return Boolean(this.iterationResult && this.iterationResult.done);
      }
    }, {
      key: "startCalculation",
      value: function startCalculation(onEffect) {
        var _this$calculation2;

        this.iterationResult = calculationStartedConstant;

        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        return this.iterationResult = {
          done: true,
          value: (_this$calculation2 = this.calculation).call.apply(_this$calculation2, [this.context || this, onEffect].concat(args))
        };
      }
    }, {
      key: "continueCalculation",
      value: function continueCalculation(value) {
        throw new Error("Can not continue synchronous calculation");
      }
    }, {
      key: "cleanupCalculation",
      value: function cleanupCalculation() {
        this.iterationResult = undefined;
      }
    }, {
      key: "calculation",
      value: function calculation(onEffect) {
        throw new Error("Abstract method `calculation` called");
      }
    }, {
      key: "runSyncWithEffect",
      value: function runSyncWithEffect(onEffect) {
        for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          args[_key5 - 1] = arguments[_key5];
        }

        this.startCalculation.apply(this, [onEffect].concat(args));
        return this.result;
      }
    }, {
      key: "runAsyncWithEffect",
      value: function () {
        var _runAsyncWithEffect2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee2(onEffect) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee2$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  throw new Error('Can not run synchronous calculation asynchronously');

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee2);
        }));

        function runAsyncWithEffect(_x2) {
          return _runAsyncWithEffect2.apply(this, arguments);
        }

        return runAsyncWithEffect;
      }()
    }, {
      key: "result",
      get: function get() {
        return this.iterationResult && this.iterationResult.done ? this.iterationResult.value : undefined;
      }
    }]);

    return CalculationSync;
  }(base);
}));
function runGeneratorSyncWithEffect(effect, func, args, scope) {
  var gen = func.apply(scope || null, args);
  var iteration = gen.next();

  while (!iteration.done) {
    iteration = gen.next(effect(iteration.value));
  }

  return iteration.value;
}
function runGeneratorAsyncWithEffect(_x3, _x4, _x5, _x6) {
  return _runGeneratorAsyncWithEffect.apply(this, arguments);
}

function _runGeneratorAsyncWithEffect() {
  _runGeneratorAsyncWithEffect = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee3(effect, func, args, scope) {
    var gen, iteration, effectResolution;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            gen = func.apply(scope || null, args);
            iteration = gen.next();

          case 2:
            if (iteration.done) {
              _context4.next = 15;
              break;
            }

            effectResolution = effect(iteration.value);

            if (!(effectResolution instanceof Promise)) {
              _context4.next = 12;
              break;
            }

            _context4.t0 = gen;
            _context4.next = 8;
            return effectResolution;

          case 8:
            _context4.t1 = _context4.sent;
            iteration = _context4.t0.next.call(_context4.t0, _context4.t1);
            _context4.next = 13;
            break;

          case 12:
            iteration = gen.next(effectResolution);

          case 13:
            _context4.next = 2;
            break;

          case 15:
            return _context4.abrupt("return", iteration.value);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _runGeneratorAsyncWithEffect.apply(this, arguments);
}

/***/ }),

/***/ "./lib/ChronoGraph/replica/Entity.js":
/*!*******************************************!*\
  !*** ./lib/ChronoGraph/replica/Entity.js ***!
  \*******************************************/
/*! exports provided: Entity, createEntityOnPrototype, ensureEntityOnPrototype, generic_field, field, calculate, write, build_proposed */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Entity", function() { return Entity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEntityOnPrototype", function() { return createEntityOnPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ensureEntityOnPrototype", function() { return ensureEntityOnPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generic_field", function() { return generic_field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "field", function() { return field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculate", function() { return calculate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "write", function() { return write; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "build_proposed", function() { return build_proposed; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _chrono_Graph_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../chrono/Graph.js */ "./lib/ChronoGraph/chrono/Graph.js");
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _environment_Debug_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../environment/Debug.js */ "./lib/ChronoGraph/environment/Debug.js");
/* harmony import */ var _primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../primitives/Calculation.js */ "./lib/ChronoGraph/primitives/Calculation.js");
/* harmony import */ var _schema_EntityMeta_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../schema/EntityMeta.js */ "./lib/ChronoGraph/schema/EntityMeta.js");
/* harmony import */ var _schema_Field_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../schema/Field.js */ "./lib/ChronoGraph/schema/Field.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");



















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';









var isEntityMarker = Symbol('isEntity');
var Entity = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(Entity, _Mixin);

  var _super = _createSuper(Entity);

  function Entity() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, Entity);

    return _super.apply(this, arguments);
  }

  return Entity;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_20__["Mixin"])([], function (base) {
  var Entity = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(Entity, _base);

    var _super2 = _createSuper(Entity);

    function Entity() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, Entity);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default()(Entity, [{
      key: isEntityMarker,
      value: function value() {}
    }, {
      key: "calculateSelf",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function calculateSelf() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function calculateSelf$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, calculateSelf, this);
      })
    }, {
      key: "createFieldIdentifier",
      value: function createFieldIdentifier(field) {
        var name = field.name;
        var entity = this.$entity;
        var constructor = this.constructor;
        var skeleton = entity.$skeleton;
        if (!skeleton[name]) skeleton[name] = constructor.getIdentifierTemplateClass(this, field);
        var identifier = new skeleton[name]();
        identifier.context = this;
        identifier.self = this;
        identifier.name = "".concat(this.$$.name, ".$.").concat(field.name);
        return identifier;
      }
    }, {
      key: "forEachFieldIdentifier",
      value: function forEachFieldIdentifier(func) {
        var _this = this;

        this.$entity.forEachField(function (field, name) {
          return func(_this.$[name], name);
        });
      }
    }, {
      key: "enterGraph",
      value: function enterGraph(replica) {
        var _this2 = this;

        if (this.graph) throw new Error('Already entered replica');
        this.graph = replica;
        replica.addIdentifier(this.$$);
        this.$entity.forEachField(function (field, name) {
          var identifier = _this2.$[name];
          replica.addIdentifier(identifier, identifier.DATA);
          identifier.DATA = undefined;
        });
      }
    }, {
      key: "leaveGraph",
      value: function leaveGraph(graph) {
        var _this3 = this;

        var ownGraph = this.graph;
        var removeFrom = graph || ownGraph;
        if (!removeFrom) return;
        this.$entity.forEachField(function (field, name) {
          return removeFrom.removeIdentifier(_this3.$[name]);
        });
        removeFrom.removeIdentifier(this.$$);
        if (removeFrom === ownGraph) this.graph = undefined;
      }
    }, {
      key: "propagate",
      value: function propagate(arg) {
        return this.commit(arg);
      }
    }, {
      key: "commit",
      value: function commit(arg) {
        var graph = this.graph;
        if (!graph) return _chrono_Graph_js__WEBPACK_IMPORTED_MODULE_18__["CommitZero"];
        return graph.commit(arg);
      }
    }, {
      key: "propagateAsync",
      value: function () {
        var _propagateAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", this.commitAsync());

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee, this);
        }));

        function propagateAsync() {
          return _propagateAsync.apply(this, arguments);
        }

        return propagateAsync;
      }()
    }, {
      key: "commitAsync",
      value: function () {
        var _commitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee2(arg) {
          var graph;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee2$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  graph = this.graph;

                  if (graph) {
                    _context3.next = 3;
                    break;
                  }

                  return _context3.abrupt("return", Promise.resolve(_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_18__["CommitZero"]));

                case 3:
                  return _context3.abrupt("return", graph.commitAsync(arg));

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee2, this);
        }));

        function commitAsync(_x) {
          return _commitAsync.apply(this, arguments);
        }

        return commitAsync;
      }()
    }, {
      key: "run",
      value: function run(methodName) {
        var _this4 = this;

        var onEffect = function onEffect(effect) {
          if (effect instanceof _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_19__["Identifier"]) return _this4.graph.read(effect);
          throw new Error("Helper methods can not yield effects during computation");
        };

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return Object(_primitives_Calculation_js__WEBPACK_IMPORTED_MODULE_22__["runGeneratorSyncWithEffect"])(onEffect, this[methodName], args, this);
      }
    }, {
      key: "$entity",
      get: function get() {
        return createEntityOnPrototype(this.constructor.prototype);
      }
    }, {
      key: "$",
      get: function get() {
        var _this5 = this;

        var $ = {};
        this.$entity.forEachField(function (field, name) {
          $[name] = _this5.createFieldIdentifier(field);
        });

        if (_environment_Debug_js__WEBPACK_IMPORTED_MODULE_21__["DEBUG"]) {
          var proxy = new Proxy($, {
            get: function get(entity, property, receiver) {
              if (!entity[property]) Object(_environment_Debug_js__WEBPACK_IMPORTED_MODULE_21__["debug"])(new Error("Attempt to read a missing field ".concat(String(property), " on ").concat(entity)));
              entity[property].SOURCE_POINT = _environment_Debug_js__WEBPACK_IMPORTED_MODULE_21__["SourceLinePoint"].fromThisCall();
              return entity[property];
            }
          });
          return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["defineProperty"])(this, '$', proxy);
        } else {
          return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["defineProperty"])(this, '$', $);
        }
      }
    }, {
      key: "$$",
      get: function get() {
        return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["defineProperty"])(this, '$$', _Identifier_js__WEBPACK_IMPORTED_MODULE_26__["MinimalEntityIdentifier"].new({
          name: this.$entityName,
          entity: this.$entity,
          calculation: this.calculateSelf,
          context: this,
          self: this
        }));
      }
    }, {
      key: "$entityName",
      get: function get() {
        return this.constructor.name || this.$entity.name;
      }
    }], [{
      key: "getIdentifierTemplateClass",
      value: function getIdentifierTemplateClass(me, field) {
        var name = field.name;
        var config = {
          name: "".concat(me.$$.name, ".$.").concat(name),
          field: field
        };
        if (field.hasOwnProperty('sync')) config.sync = field.sync;
        if (field.hasOwnProperty('lazy')) config.lazy = field.lazy;
        if (field.hasOwnProperty('equality')) config.equality = field.equality;
        var calculationFunction = me.$calculations && me[me.$calculations[name]];
        if (calculationFunction) config.calculation = calculationFunction;
        var writeFunction = me.$writes && me[me.$writes[name]];
        if (writeFunction) config.write = writeFunction;
        var buildProposedFunction = me.$buildProposed && me[me.$buildProposed[name]];

        if (buildProposedFunction) {
          config.buildProposedValue = buildProposedFunction;
          config.proposedValueIsBuilt = true;
        }

        var template = field.getIdentifierClass(calculationFunction).new(config);

        var TemplateClass = function TemplateClass() {};

        TemplateClass.prototype = template;
        return TemplateClass;
      }
    }, {
      key: "createPropertyAccessorsFor",
      value: function createPropertyAccessorsFor(fieldName) {
        var propertyKey = fieldName;
        var target = this.prototype;
        Object.defineProperty(target, propertyKey, {
          get: function get() {
            return this.$[propertyKey].getFromGraph(this.graph);
          },
          set: function set(value) {
            this.$[propertyKey].writeToGraph(this.graph, value);
          }
        });
      }
    }, {
      key: "createMethodAccessorsFor",
      value: function createMethodAccessorsFor(fieldName) {
        var propertyKey = fieldName;
        var target = this.prototype;
        var getterFnName = "get".concat(Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["uppercaseFirst"])(propertyKey));
        var setterFnName = "set".concat(Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["uppercaseFirst"])(propertyKey));
        var putterFnName = "put".concat(Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["uppercaseFirst"])(propertyKey));

        if (!(getterFnName in target)) {
          target[getterFnName] = function () {
            return this.$[propertyKey].getFromGraph(this.graph);
          };
        }

        if (!(setterFnName in target)) {
          target[setterFnName] = function (value) {
            var _this$$$propertyKey;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$$$propertyKey = this.$[propertyKey]).writeToGraph.apply(_this$$$propertyKey, [this.graph, value].concat(args));

            return this.graph ? this.graph.autoCommitMode === 'sync' ? this.graph.commit() : this.graph.commitAsync() : Promise.resolve(_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_18__["CommitZero"]);
          };
        }

        if (!(putterFnName in target)) {
          target[putterFnName] = function (value) {
            var _this$$$propertyKey2;

            for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              args[_key3 - 1] = arguments[_key3];
            }

            (_this$$$propertyKey2 = this.$[propertyKey]).writeToGraph.apply(_this$$$propertyKey2, [this.graph, value].concat(args));
          };
        }
      }
    }, {
      key: "$entity",
      get: function get() {
        return ensureEntityOnPrototype(this.prototype);
      }
    }]);

    return Entity;
  }(base);

  return Entity;
}));
var createEntityOnPrototype = function createEntityOnPrototype(proto) {
  var parent = Object.getPrototypeOf(proto);
  return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["defineProperty"])(proto, '$entity', _schema_EntityMeta_js__WEBPACK_IMPORTED_MODULE_23__["EntityMeta"].new({
    parentEntity: parent.hasOwnProperty(isEntityMarker) ? null : parent.$entity,
    name: proto.constructor.name
  }));
};
var ensureEntityOnPrototype = function ensureEntityOnPrototype(proto) {
  if (!proto.hasOwnProperty('$entity')) createEntityOnPrototype(proto);
  return proto.$entity;
};
var generic_field = function generic_field(fieldConfig) {
  var fieldCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _schema_Field_js__WEBPACK_IMPORTED_MODULE_24__["Field"];
  return function (target, fieldName) {
    var entity = ensureEntityOnPrototype(target);
    var field = entity.addField(fieldCls.new(Object.assign(fieldConfig || {}, {
      name: fieldName
    })));
    var cons = target.constructor;
    cons.createPropertyAccessorsFor(fieldName);
    cons.createMethodAccessorsFor(fieldName);
  };
};
var field = generic_field;
var calculate = function calculate(fieldName) {
  return function (target, propertyKey, _descriptor) {
    ensureEntityOnPrototype(target);
    var calculations;

    if (!target.$calculations) {
      calculations = target.$calculations = {};
    } else {
      if (!target.hasOwnProperty('$calculations')) {
        calculations = target.$calculations = Object.create(target.$calculations);
      } else calculations = target.$calculations;
    }

    calculations[fieldName] = propertyKey;
  };
};
var write = function write(fieldName) {
  return function (target, propertyKey, _descriptor) {
    ensureEntityOnPrototype(target);
    var writes;

    if (!target.$writes) {
      writes = target.$writes = {};
    } else {
      if (!target.hasOwnProperty('$writes')) {
        writes = target.$writes = Object.create(target.$writes);
      } else writes = target.$writes;
    }

    writes[fieldName] = propertyKey;
  };
};
var build_proposed = function build_proposed(fieldName) {
  return function (target, propertyKey, _descriptor) {
    ensureEntityOnPrototype(target);
    var buildProposed;

    if (!target.$buildProposed) {
      buildProposed = target.$buildProposed = {};
    } else {
      if (!target.hasOwnProperty('$buildProposed')) {
        buildProposed = target.$buildProposed = Object.create(target.$buildProposed);
      } else buildProposed = target.$buildProposed;
    }

    buildProposed[fieldName] = propertyKey;
  };
};

/***/ }),

/***/ "./lib/ChronoGraph/replica/Identifier.js":
/*!***********************************************!*\
  !*** ./lib/ChronoGraph/replica/Identifier.js ***!
  \***********************************************/
/*! exports provided: FieldIdentifier, MinimalFieldIdentifierSync, MinimalFieldIdentifierGen, MinimalFieldVariable, EntityIdentifier, MinimalEntityIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FieldIdentifier", function() { return FieldIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalFieldIdentifierSync", function() { return MinimalFieldIdentifierSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalFieldIdentifierGen", function() { return MinimalFieldIdentifierGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalFieldVariable", function() { return MinimalFieldVariable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntityIdentifier", function() { return EntityIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalEntityIdentifier", function() { return MinimalEntityIdentifier; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _Replica_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Replica.js */ "./lib/ChronoGraph/replica/Replica.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var FieldIdentifier = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(FieldIdentifier, _Mixin);

  var _super = _createSuper(FieldIdentifier);

  function FieldIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, FieldIdentifier);

    return _super.apply(this, arguments);
  }

  return FieldIdentifier;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__["Identifier"]], function (base) {
  return /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(FieldIdentifier, _base);

    var _super2 = _createSuper(FieldIdentifier);

    function FieldIdentifier() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, FieldIdentifier);

      _this = _super2.apply(this, arguments);
      _this.field = undefined;
      _this.self = undefined;
      _this.DATA = undefined;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(FieldIdentifier, [{
      key: "getFromGraph",
      value: function getFromGraph(graph) {
        if (graph) {
          if (graph.readMode === _Replica_js__WEBPACK_IMPORTED_MODULE_13__["ReadMode"].Current) return graph.get(this);
          if (graph.readMode === _Replica_js__WEBPACK_IMPORTED_MODULE_13__["ReadMode"].Previous) return graph.activeTransaction.readPrevious(this);
          if (graph.readMode === _Replica_js__WEBPACK_IMPORTED_MODULE_13__["ReadMode"].ProposedOrPrevious) graph.activeTransaction.readProposedOrPrevious(this);
          return graph.activeTransaction.readCurrentOrProposedOrPrevious(this);
        } else return this.DATA;
      }
    }, {
      key: "readFromGraph",
      value: function readFromGraph(graph) {
        if (graph) return graph.read(this);else return this.DATA;
      }
    }, {
      key: "writeToGraph",
      value: function writeToGraph(graph, proposedValue) {
        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        if (graph) graph.write.apply(graph, [this, proposedValue].concat(args));else this.DATA = proposedValue;
      }
    }, {
      key: "leaveGraph",
      value: function leaveGraph(graph) {
        var entry = graph.activeTransaction.getLatestStableEntryFor(this);
        if (entry) this.DATA = entry.getValue();

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(FieldIdentifier.prototype), "leaveGraph", this).call(this, graph);
      }
    }, {
      key: "toString",
      value: function toString() {
        return this.name;
      }
    }]);

    return FieldIdentifier;
  }(base);
}));
var MinimalFieldIdentifierSync = /*#__PURE__*/function (_FieldIdentifier$mix) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(MinimalFieldIdentifierSync, _FieldIdentifier$mix);

  var _super3 = _createSuper(MinimalFieldIdentifierSync);

  function MinimalFieldIdentifierSync() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, MinimalFieldIdentifierSync);

    return _super3.apply(this, arguments);
  }

  return MinimalFieldIdentifierSync;
}(FieldIdentifier.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__["CalculatedValueSync"]));
var MinimalFieldIdentifierGen = /*#__PURE__*/function (_FieldIdentifier$mix2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(MinimalFieldIdentifierGen, _FieldIdentifier$mix2);

  var _super4 = _createSuper(MinimalFieldIdentifierGen);

  function MinimalFieldIdentifierGen() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, MinimalFieldIdentifierGen);

    return _super4.apply(this, arguments);
  }

  return MinimalFieldIdentifierGen;
}(FieldIdentifier.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__["CalculatedValueGen"]));
var MinimalFieldVariable = /*#__PURE__*/function (_FieldIdentifier$mix3) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(MinimalFieldVariable, _FieldIdentifier$mix3);

  var _super5 = _createSuper(MinimalFieldVariable);

  function MinimalFieldVariable() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, MinimalFieldVariable);

    return _super5.apply(this, arguments);
  }

  return MinimalFieldVariable;
}(FieldIdentifier.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__["Variable"]));
var EntityIdentifier = /*#__PURE__*/function (_Mixin2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(EntityIdentifier, _Mixin2);

  var _super6 = _createSuper(EntityIdentifier);

  function EntityIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, EntityIdentifier);

    return _super6.apply(this, arguments);
  }

  return EntityIdentifier;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__["Identifier"]], function (base) {
  return /*#__PURE__*/function (_base2) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(EntityIdentifier, _base2);

    var _super7 = _createSuper(EntityIdentifier);

    function EntityIdentifier() {
      var _this2;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, EntityIdentifier);

      _this2 = _super7.apply(this, arguments);
      _this2.entity = undefined;
      _this2.self = undefined;
      return _this2;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(EntityIdentifier, [{
      key: "equality",
      value: function equality() {
        return false;
      }
    }, {
      key: "toString",
      value: function toString() {
        return "Entity identifier [".concat(this.self, "]");
      }
    }]);

    return EntityIdentifier;
  }(base);
}));
var MinimalEntityIdentifier = /*#__PURE__*/function (_EntityIdentifier$mix) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(MinimalEntityIdentifier, _EntityIdentifier$mix);

  var _super8 = _createSuper(MinimalEntityIdentifier);

  function MinimalEntityIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, MinimalEntityIdentifier);

    return _super8.apply(this, arguments);
  }

  return MinimalEntityIdentifier;
}(EntityIdentifier.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__["CalculatedValueGen"]));

/***/ }),

/***/ "./lib/ChronoGraph/replica/Reference.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/replica/Reference.js ***!
  \**********************************************/
/*! exports provided: ReferenceField, reference, ReferenceIdentifier, MinimalReferenceIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceField", function() { return ReferenceField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reference", function() { return reference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceIdentifier", function() { return ReferenceIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalReferenceIdentifier", function() { return MinimalReferenceIdentifier; });
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _schema_Field_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../schema/Field.js */ "./lib/ChronoGraph/schema/Field.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Entity_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var ReferenceField = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ReferenceField, _Mixin);

  var _super = _createSuper(ReferenceField);

  function ReferenceField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, ReferenceField);

    return _super.apply(this, arguments);
  }

  return ReferenceField;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_schema_Field_js__WEBPACK_IMPORTED_MODULE_13__["Field"]], function (base) {
  return /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ReferenceField, _base);

    var _super2 = _createSuper(ReferenceField);

    function ReferenceField() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, ReferenceField);

      _this = _super2.apply(this, arguments);
      _this.identifierCls = MinimalReferenceIdentifier;
      return _this;
    }

    return ReferenceField;
  }(base);
}));
var reference = function reference(fieldConfig) {
  var fieldCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ReferenceField;
  return Object(_Entity_js__WEBPACK_IMPORTED_MODULE_15__["generic_field"])(fieldConfig, fieldCls);
};
var ReferenceIdentifier = /*#__PURE__*/function (_Mixin2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ReferenceIdentifier, _Mixin2);

  var _super3 = _createSuper(ReferenceIdentifier);

  function ReferenceIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, ReferenceIdentifier);

    return _super3.apply(this, arguments);
  }

  return ReferenceIdentifier;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_Identifier_js__WEBPACK_IMPORTED_MODULE_16__["FieldIdentifier"]], function (base) {
  var ReferenceIdentifier = /*#__PURE__*/function (_base2) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ReferenceIdentifier, _base2);

    var _super4 = _createSuper(ReferenceIdentifier);

    function ReferenceIdentifier() {
      var _this2;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, ReferenceIdentifier);

      _this2 = _super4.apply(this, arguments);
      _this2.field = undefined;
      _this2.proposedValueIsBuilt = true;
      return _this2;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ReferenceIdentifier, [{
      key: "hasBucket",
      value: function hasBucket() {
        return Boolean(this.field.bucket);
      }
    }, {
      key: "getBucket",
      value: function getBucket(entity) {
        return entity.$[this.field.bucket];
      }
    }, {
      key: "buildProposedValue",
      value: function buildProposedValue(me, quark, transaction) {
        var proposedValue = quark.proposedValue;
        if (proposedValue === null) return null;
        var value = Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_12__["isInstanceOf"])(proposedValue, _Entity_js__WEBPACK_IMPORTED_MODULE_15__["Entity"]) ? proposedValue : me.resolve(proposedValue);

        if (value && me.hasBucket()) {
          me.getBucket(value).addToBucket(transaction, me.self);
        }

        return value;
      }
    }, {
      key: "resolve",
      value: function resolve(locator) {
        var resolver = this.field.resolver;
        return resolver ? resolver.call(this.self, locator) : null;
      }
    }, {
      key: "enterGraph",
      value: function enterGraph(graph) {
        if (this.hasBucket()) {
          var value = graph.activeTransaction.readProposedOrPrevious(this);

          if (value instanceof _Entity_js__WEBPACK_IMPORTED_MODULE_15__["Entity"]) {
            this.getBucket(value).addToBucket(graph.activeTransaction, this.self);
          }
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ReferenceIdentifier.prototype), "enterGraph", this).call(this, graph);
      }
    }, {
      key: "leaveGraph",
      value: function leaveGraph(graph) {
        if (this.hasBucket()) {
          var value = graph.activeTransaction.readProposedOrPrevious(this);

          if (value instanceof _Entity_js__WEBPACK_IMPORTED_MODULE_15__["Entity"]) {
            this.getBucket(value).removeFromBucket(graph.activeTransaction, this.self);
          }
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ReferenceIdentifier.prototype), "leaveGraph", this).call(this, graph);
      }
    }, {
      key: "write",
      value: function write(me, transaction, q, proposedValue) {
        var quark = q || transaction.acquireQuarkIfExists(me);

        if (me.hasBucket()) {
          if (quark) {
            var prevValue = quark.getValue();

            if (prevValue instanceof _Entity_js__WEBPACK_IMPORTED_MODULE_15__["Entity"]) {
              me.getBucket(prevValue).removeFromBucket(transaction, me.self);
            }
          } else if (transaction.baseRevision.hasIdentifier(me)) {
            var value = transaction.readPrevious(me);

            if (value instanceof _Entity_js__WEBPACK_IMPORTED_MODULE_15__["Entity"]) {
              me.getBucket(value).removeFromBucket(transaction, me.self);
            }
          }
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ReferenceIdentifier.prototype), "write", this).call(this, me, transaction, q, proposedValue);
      }
    }]);

    return ReferenceIdentifier;
  }(base);

  __decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_14__["prototypeValue"])(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__["Levels"].DependsOnlyOnUserInput)], ReferenceIdentifier.prototype, "level", void 0);

  __decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_14__["prototypeValue"])(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__["QuarkSync"])], ReferenceIdentifier.prototype, "quarkClass", void 0);

  return ReferenceIdentifier;
}));
var MinimalReferenceIdentifier = /*#__PURE__*/function (_ReferenceIdentifier$) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(MinimalReferenceIdentifier, _ReferenceIdentifier$);

  var _super5 = _createSuper(MinimalReferenceIdentifier);

  function MinimalReferenceIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, MinimalReferenceIdentifier);

    return _super5.apply(this, arguments);
  }

  return MinimalReferenceIdentifier;
}(ReferenceIdentifier.mix(_Identifier_js__WEBPACK_IMPORTED_MODULE_16__["FieldIdentifier"].mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_11__["CalculatedValueSync"])));

/***/ }),

/***/ "./lib/ChronoGraph/replica/ReferenceBucket.js":
/*!****************************************************!*\
  !*** ./lib/ChronoGraph/replica/ReferenceBucket.js ***!
  \****************************************************/
/*! exports provided: ReferenceBucketField, bucket, ReferenceBucketQuark, MinimalReferenceBucketQuark, ReferenceBucketIdentifier, MinimalReferenceBucketIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceBucketField", function() { return ReferenceBucketField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bucket", function() { return bucket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceBucketQuark", function() { return ReferenceBucketQuark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalReferenceBucketQuark", function() { return MinimalReferenceBucketQuark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceBucketIdentifier", function() { return ReferenceBucketIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalReferenceBucketIdentifier", function() { return MinimalReferenceBucketIdentifier; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _chrono_Quark_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../chrono/Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _schema_Field_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../schema/Field.js */ "./lib/ChronoGraph/schema/Field.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Entity_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Identifier_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_30___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var ReferenceBucketField = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(ReferenceBucketField, _Mixin);

  var _super = _createSuper(ReferenceBucketField);

  function ReferenceBucketField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, ReferenceBucketField);

    return _super.apply(this, arguments);
  }

  return ReferenceBucketField;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_33__["Mixin"])([_schema_Field_js__WEBPACK_IMPORTED_MODULE_34__["Field"]], function (base) {
  return /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(ReferenceBucketField, _base);

    var _super2 = _createSuper(ReferenceBucketField);

    function ReferenceBucketField() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, ReferenceBucketField);

      _this = _super2.apply(this, arguments);
      _this.persistent = false;
      _this.identifierCls = MinimalReferenceBucketIdentifier;
      return _this;
    }

    return ReferenceBucketField;
  }(base);
}));
var bucket = function bucket(fieldConfig) {
  var fieldCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ReferenceBucketField;
  return Object(_Entity_js__WEBPACK_IMPORTED_MODULE_36__["generic_field"])(fieldConfig, fieldCls);
};
var BucketMutationType;

(function (BucketMutationType) {
  BucketMutationType["Add"] = "Add";
  BucketMutationType["Remove"] = "Remove";
})(BucketMutationType || (BucketMutationType = {}));

var ReferenceBucketQuark = /*#__PURE__*/function (_Mixin2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(ReferenceBucketQuark, _Mixin2);

  var _super3 = _createSuper(ReferenceBucketQuark);

  function ReferenceBucketQuark() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, ReferenceBucketQuark);

    return _super3.apply(this, arguments);
  }

  return ReferenceBucketQuark;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_33__["Mixin"])([_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_32__["Quark"]], function (base) {
  return /*#__PURE__*/function (_base2) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(ReferenceBucketQuark, _base2);

    var _super4 = _createSuper(ReferenceBucketQuark);

    function ReferenceBucketQuark() {
      var _this2;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, ReferenceBucketQuark);

      _this2 = _super4.apply(this, arguments);
      _this2.mutations = [];
      _this2.previousValue = undefined;
      return _this2;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25___default()(ReferenceBucketQuark, [{
      key: "hasProposedValueInner",
      value: function hasProposedValueInner() {
        return this.mutations.length > 0;
      }
    }]);

    return ReferenceBucketQuark;
  }(base);
}));
var MinimalReferenceBucketQuark = ReferenceBucketQuark.mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_31__["QuarkSync"]);
var ReferenceBucketIdentifier = /*#__PURE__*/function (_Mixin3) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(ReferenceBucketIdentifier, _Mixin3);

  var _super5 = _createSuper(ReferenceBucketIdentifier);

  function ReferenceBucketIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, ReferenceBucketIdentifier);

    return _super5.apply(this, arguments);
  }

  return ReferenceBucketIdentifier;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_33__["Mixin"])([_Identifier_js__WEBPACK_IMPORTED_MODULE_37__["FieldIdentifier"]], function (base) {
  var ReferenceBucketIdentifier = /*#__PURE__*/function (_base3) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(ReferenceBucketIdentifier, _base3);

    var _super6 = _createSuper(ReferenceBucketIdentifier);

    function ReferenceBucketIdentifier() {
      var _this3;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, ReferenceBucketIdentifier);

      _this3 = _super6.apply(this, arguments);
      _this3.proposedValueIsBuilt = true;
      return _this3;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25___default()(ReferenceBucketIdentifier, [{
      key: "addToBucket",
      value: function addToBucket(transaction, entity) {
        var quark = transaction.getWriteTarget(this);
        quark.mutations.push({
          type: BucketMutationType.Add,
          entity: entity
        });
        var baseRevision = transaction.baseRevision;
        if (!quark.previousValue && baseRevision.hasIdentifier(this)) quark.previousValue = transaction.readPrevious(this);
      }
    }, {
      key: "removeFromBucket",
      value: function removeFromBucket(transaction, entity) {
        var preQuark = transaction.entries.get(this);
        if (preQuark && preQuark.getValue() === _chrono_Quark_js__WEBPACK_IMPORTED_MODULE_32__["TombStone"]) return;
        var quark = transaction.getWriteTarget(this);
        quark.mutations.push({
          type: BucketMutationType.Remove,
          entity: entity
        });
        var baseRevision = transaction.baseRevision;
        if (!quark.previousValue && baseRevision.hasIdentifier(this)) quark.previousValue = transaction.readPrevious(this);
      }
    }, {
      key: "buildProposedValue",
      value: function buildProposedValue(me, quarkArg, transaction) {
        var quark = quarkArg;
        var newValue = new Set(quark.previousValue);

        for (var i = 0; i < quark.mutations.length; i++) {
          var _quark$mutations$i = quark.mutations[i],
              type = _quark$mutations$i.type,
              entity = _quark$mutations$i.entity;

          if (type === BucketMutationType.Remove) {
            newValue.delete(entity);
          } else if (type === BucketMutationType.Add) {
            newValue.add(entity);
          }
        }

        return newValue;
      }
    }, {
      key: "leaveGraph",
      value: function leaveGraph(graph) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(ReferenceBucketIdentifier.prototype), "leaveGraph", this).call(this, graph);

        this.DATA = undefined;
      }
    }]);

    return ReferenceBucketIdentifier;
  }(base);

  __decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_35__["prototypeValue"])(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_31__["Levels"].DependsOnlyOnDependsOnlyOnUserInput)], ReferenceBucketIdentifier.prototype, "level", void 0);

  __decorate([Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_35__["prototypeValue"])(MinimalReferenceBucketQuark)], ReferenceBucketIdentifier.prototype, "quarkClass", void 0);

  return ReferenceBucketIdentifier;
}));
var MinimalReferenceBucketIdentifier = /*#__PURE__*/function (_ReferenceBucketIdent) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(MinimalReferenceBucketIdentifier, _ReferenceBucketIdent);

  var _super7 = _createSuper(MinimalReferenceBucketIdentifier);

  function MinimalReferenceBucketIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, MinimalReferenceBucketIdentifier);

    return _super7.apply(this, arguments);
  }

  return MinimalReferenceBucketIdentifier;
}(ReferenceBucketIdentifier.mix(_Identifier_js__WEBPACK_IMPORTED_MODULE_37__["FieldIdentifier"].mix(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_31__["CalculatedValueSync"])));

/***/ }),

/***/ "./lib/ChronoGraph/replica/Replica.js":
/*!********************************************!*\
  !*** ./lib/ChronoGraph/replica/Replica.js ***!
  \********************************************/
/*! exports provided: ReadMode, Replica */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadMode", function() { return ReadMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Replica", function() { return Replica; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _chrono_Graph_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../chrono/Graph.js */ "./lib/ChronoGraph/chrono/Graph.js");
/* harmony import */ var _class_Mixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var ReadMode;

(function (ReadMode) {
  ReadMode[ReadMode["Current"] = 0] = "Current";
  ReadMode[ReadMode["Previous"] = 1] = "Previous";
  ReadMode[ReadMode["ProposedOrPrevious"] = 2] = "ProposedOrPrevious";
  ReadMode[ReadMode["CurrentOrProposedOrPrevious"] = 3] = "CurrentOrProposedOrPrevious";
})(ReadMode || (ReadMode = {}));

var Replica = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Replica, _Mixin);

  var _super = _createSuper(Replica);

  function Replica() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Replica);

    return _super.apply(this, arguments);
  }

  return Replica;
}(Object(_class_Mixin_js__WEBPACK_IMPORTED_MODULE_11__["Mixin"])([_chrono_Graph_js__WEBPACK_IMPORTED_MODULE_10__["ChronoGraph"]], function (base) {
  return /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Replica, _base);

    var _super2 = _createSuper(Replica);

    function Replica() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Replica);

      _this = _super2.apply(this, arguments);
      _this.autoCommit = true;
      _this.readMode = ReadMode.Current;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(Replica, [{
      key: "addEntity",
      value: function addEntity(entity) {
        entity.enterGraph(this);
      }
    }, {
      key: "addEntities",
      value: function addEntities(entities) {
        var _this2 = this;

        entities.forEach(function (entity) {
          return _this2.addEntity(entity);
        });
      }
    }, {
      key: "removeEntity",
      value: function removeEntity(entity) {
        entity.leaveGraph(this);
      }
    }, {
      key: "removeEntities",
      value: function removeEntities(entities) {
        var _this3 = this;

        entities.forEach(function (entity) {
          return _this3.removeEntity(entity);
        });
      }
    }]);

    return Replica;
  }(base);
}));

/***/ }),

/***/ "./lib/ChronoGraph/schema/EntityMeta.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/schema/EntityMeta.js ***!
  \**********************************************/
/*! exports provided: EntityMeta */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntityMeta", function() { return EntityMeta; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");














































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var EntityMeta = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42___default()(EntityMeta, _Base);

  var _super = _createSuper(EntityMeta);

  function EntityMeta() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40___default()(this, EntityMeta);

    _this = _super.apply(this, arguments);
    _this.name = undefined;
    _this.ownFields = new Map();
    _this.schema = undefined;
    _this.$skeleton = {};
    _this.$allFields = undefined;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41___default()(EntityMeta, [{
    key: "hasField",
    value: function hasField(name) {
      return this.getField(name) !== undefined;
    }
  }, {
    key: "getField",
    value: function getField(name) {
      return this.allFields.get(name);
    }
  }, {
    key: "addField",
    value: function addField(field) {
      var name = field.name;
      if (!name) throw new Error("Field must have a name");
      if (this.ownFields.has(name)) throw new Error("Field with name [".concat(name, "] already exists"));
      field.entity = this;
      this.ownFields.set(name, field);
      return field;
    }
  }, {
    key: "forEachParent",
    value: function forEachParent(func) {
      var entity = this;

      while (entity) {
        func(entity);
        entity = entity.parentEntity;
      }
    }
  }, {
    key: "forEachField",
    value: function forEachField(func) {
      this.allFields.forEach(func);
    }
  }, {
    key: "allFields",
    get: function get() {
      if (this.$allFields !== undefined) return this.$allFields;
      var allFields = new Map();
      var visited = new Set();
      this.forEachParent(function (entity) {
        entity.ownFields.forEach(function (field, name) {
          if (!visited.has(name)) {
            visited.add(name);
            allFields.set(name, field);
          }
        });
      });
      return this.$allFields = allFields;
    }
  }]);

  return EntityMeta;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_45__["Base"]);

/***/ }),

/***/ "./lib/ChronoGraph/schema/Field.js":
/*!*****************************************!*\
  !*** ./lib/ChronoGraph/schema/Field.js ***!
  \*****************************************/
/*! exports provided: Field */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return Field; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _replica_Identifier_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../replica/Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
/* harmony import */ var _util_Helpers_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var Field = /*#__PURE__*/function (_Meta) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Field, _Meta);

  var _super = _createSuper(Field);

  function Field() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Field);

    _this = _super.apply(this, arguments);
    _this.persistent = true;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Field, [{
    key: "getIdentifierClass",
    value: function getIdentifierClass(calculationFunction) {
      if (this.identifierCls) return this.identifierCls;
      if (!calculationFunction) return _replica_Identifier_js__WEBPACK_IMPORTED_MODULE_9__["MinimalFieldVariable"];
      return Object(_util_Helpers_js__WEBPACK_IMPORTED_MODULE_10__["isGeneratorFunction"])(calculationFunction) ? _replica_Identifier_js__WEBPACK_IMPORTED_MODULE_9__["MinimalFieldIdentifierGen"] : _replica_Identifier_js__WEBPACK_IMPORTED_MODULE_9__["MinimalFieldIdentifierSync"];
    }
  }]);

  return Field;
}(_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_8__["Meta"]);

/***/ }),

/***/ "./lib/ChronoGraph/schema/Schema.js":
/*!******************************************!*\
  !*** ./lib/ChronoGraph/schema/Schema.js ***!
  \******************************************/
/*! exports provided: Schema, entityDecoratorBody, entity */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Schema", function() { return Schema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entityDecoratorBody", function() { return entityDecoratorBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entity", function() { return entity; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _class_Base_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../class/Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony import */ var _replica_Entity_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");



























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var Schema = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default()(Schema, _Base);

  var _super = _createSuper(Schema);

  function Schema() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21___default()(this, Schema);

    _this = _super.apply(this, arguments);
    _this.entities = new Map();
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22___default()(Schema, [{
    key: "hasEntity",
    value: function hasEntity(name) {
      return this.entities.has(name);
    }
  }, {
    key: "getEntity",
    value: function getEntity(name) {
      return this.entities.get(name);
    }
  }, {
    key: "addEntity",
    value: function addEntity(entity) {
      var name = entity.name;
      if (!name) throw new Error("Entity must have a name");
      if (this.hasEntity(name)) throw new Error("Entity with name [".concat(String(name), "] already exists"));
      entity.schema = this;
      this.entities.set(name, entity);
      return entity;
    }
  }, {
    key: "getEntityDecorator",
    value: function getEntityDecorator() {
      var _this2 = this;

      return function (target) {
        var entity = entityDecoratorBody(target);

        _this2.addEntity(entity);

        return target;
      };
    }
  }]);

  return Schema;
}(_class_Base_js__WEBPACK_IMPORTED_MODULE_26__["Base"]);
var entityDecoratorBody = function entityDecoratorBody(target) {
  var name = target.name;
  if (!name) throw new Error("Can't add entity - the target class has no name");
  return Object(_replica_Entity_js__WEBPACK_IMPORTED_MODULE_27__["ensureEntityOnPrototype"])(target.prototype);
};
var entity = function entity() {
  return function (target) {
    entityDecoratorBody(target);
    return target;
  };
};

/***/ }),

/***/ "./lib/ChronoGraph/util/Helpers.js":
/*!*****************************************!*\
  !*** ./lib/ChronoGraph/util/Helpers.js ***!
  \*****************************************/
/*! exports provided: MIN_SMI, MAX_SMI, uppercaseFirst, isAtomicValue, typeOf, defineProperty, prototypeValue, copyMapInto, copySetInto, delay, matchAll, allMatches, isGeneratorFunction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIN_SMI", function() { return MIN_SMI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_SMI", function() { return MAX_SMI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uppercaseFirst", function() { return uppercaseFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAtomicValue", function() { return isAtomicValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typeOf", function() { return typeOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineProperty", function() { return defineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prototypeValue", function() { return prototypeValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyMapInto", function() { return copyMapInto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copySetInto", function() { return copySetInto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return delay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matchAll", function() { return matchAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allMatches", function() { return allMatches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isGeneratorFunction", function() { return isGeneratorFunction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");



















function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';

var MIN_SMI = -Math.pow(2, 30);
var MAX_SMI = Math.pow(2, 30) - 1;
var uppercaseFirst = function uppercaseFirst(str) {
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};
var isAtomicValue = function isAtomicValue(value) {
  return Object(value) !== value;
};
var typeOf = function typeOf(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
};
var defineProperty = function defineProperty(target, property, value) {
  Object.defineProperty(target, property, {
    value: value,
    enumerable: true,
    configurable: true
  });
  return value;
};
var prototypeValue = function prototypeValue(value) {
  return function (target, propertyKey) {
    target[propertyKey] = value;
  };
};
var copyMapInto = function copyMapInto(sourceMap, targetMap) {
  var _iterator = _createForOfIteratorHelper(sourceMap),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_17___default()(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      targetMap.set(key, value);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return targetMap;
};
var copySetInto = function copySetInto(sourceSet, targetSet) {
  var _iterator2 = _createForOfIteratorHelper(sourceSet),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var value = _step2.value;
      targetSet.add(value);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return targetSet;
};
var delay = function delay(timeout) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, timeout);
  });
};
var matchAll = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function matchAll(regexp, testStr) {
  var match;
  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function matchAll$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!((match = regexp.exec(testStr)) !== null)) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return match;

        case 3:
          _context.next = 0;
          break;

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, matchAll);
});
var allMatches = function allMatches(regexp, testStr) {
  return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_18__["CI"])(matchAll(regexp, testStr)).map(function (match) {
    return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_18__["CI"])(match).drop(1);
  }).concat().toArray();
};
var isRegeneratorRuntime = null;
var isGeneratorFunction = function isGeneratorFunction(func) {
  if (isRegeneratorRuntime === null) isRegeneratorRuntime = typeof _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a !== 'undefined';

  if (isRegeneratorRuntime === true) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.isGeneratorFunction(func);
  } else {
    return func.constructor.name === 'GeneratorFunction';
  }
};

/***/ }),

/***/ "./lib/ChronoGraph/util/LeveledQueue.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/util/LeveledQueue.js ***!
  \**********************************************/
/*! exports provided: LeveledQueue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LeveledQueue", function() { return LeveledQueue; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");











var productName = 'scheduler';

var LeveledQueue = /*#__PURE__*/function () {
  function LeveledQueue() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, LeveledQueue);

    this.length = 0;
    this.levels = [];
    this.lowestLevel = _Helpers_js__WEBPACK_IMPORTED_MODULE_11__["MAX_SMI"];
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(LeveledQueue, [{
    key: "getLowestLevel",
    value: function getLowestLevel() {
      for (var i = this.lowestLevel !== _Helpers_js__WEBPACK_IMPORTED_MODULE_11__["MAX_SMI"] ? this.lowestLevel : 0; i < this.levels.length; i++) {
        if (this.levels[i]) return this.lowestLevel = i;
      }

      return this.lowestLevel = _Helpers_js__WEBPACK_IMPORTED_MODULE_11__["MAX_SMI"];
    }
  }, {
    key: "takeLowestLevel",
    value: function takeLowestLevel() {
      for (var i = this.lowestLevel !== _Helpers_js__WEBPACK_IMPORTED_MODULE_11__["MAX_SMI"] ? this.lowestLevel : 0; i < this.levels.length; i++) {
        var level = this.levels[i];

        if (level) {
          this.length -= level.length;
          this.levels[i] = null;
          this.lowestLevel = i + 1;
          return level;
        }
      }
    }
  }, {
    key: "pop",
    value: function pop() {
      for (var i = this.lowestLevel !== _Helpers_js__WEBPACK_IMPORTED_MODULE_11__["MAX_SMI"] ? this.lowestLevel : 0; i < this.levels.length; i++) {
        var level = this.levels[i];
        this.lowestLevel = i;

        if (level && level.length > 0) {
          this.length--;
          return level.pop();
        }
      }

      this.lowestLevel = _Helpers_js__WEBPACK_IMPORTED_MODULE_11__["MAX_SMI"];
    }
  }, {
    key: "push",
    value: function push(el) {
      var elLevel = el.level;
      var level = this.levels[elLevel];

      if (!level) {
        for (var i = this.levels.length; i < elLevel; i++) {
          this.levels[i] = null;
        }

        level = this.levels[elLevel] = [];
      }

      level.push(el);
      this.length++;
      if (elLevel < this.lowestLevel) this.lowestLevel = elLevel;
    }
  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function value() {
      var i, level;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              i = 0;

            case 1:
              if (!(i < this.levels.length)) {
                _context.next = 8;
                break;
              }

              level = this.levels[i];

              if (!level) {
                _context.next = 5;
                break;
              }

              return _context.delegateYield(level, "t0", 5);

            case 5:
              i++;
              _context.next = 1;
              break;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }]);

  return LeveledQueue;
}();

/***/ }),

/***/ "./lib/Core/Base.js":
/*!**************************!*\
  !*** ./lib/Core/Base.js ***!
  \**************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Base; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_is_frozen__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.is-frozen */ "./node_modules/core-js/modules/es.object.is-frozen.js");
/* harmony import */ var core_js_modules_es_object_is_frozen__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_is_frozen__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Config_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./Config.js */ "./lib/Core/Config.js");






















var productName = 'scheduler';
/**
* @module Core/Base
*/







var MetaClass = /*#__PURE__*/function () {
  function MetaClass(options) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default()(this, MetaClass);

    options && Object.assign(this, options);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(MetaClass, [{
    key: "getInherited",
    value: function getInherited(name) {
      var _this$super;

      return this[name] || (this[name] = Object.create(((_this$super = this.super) === null || _this$super === void 0 ? void 0 : _this$super.getInherited(name)) || null));
    }
  }]);

  return MetaClass;
}();

// Using Object.getPrototypeOf instead of Reflect.getPrototypeOf because:
// 1. The are almost the same, according to the MDN difference is handling getPrototypeOf('string')
// 2. It allows to pass security check in SalesForce environment
var getPrototypeOf = Object.getPrototypeOf,
    defineProperty = Reflect.defineProperty,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    metaSymbol = Symbol('classMetaData'),
    mixinTagSymbol = Symbol('mixinTag'),
    originalConfigSymbol = Symbol('originalConfig'),
    createdAtSymbol = Symbol('createdAt'),
    configuringSymbol = _Config_js__WEBPACK_IMPORTED_MODULE_26__["default"].symbols.configuring,
    instancePropertiesSymbol = _Config_js__WEBPACK_IMPORTED_MODULE_26__["default"].symbols.instanceProperties,
    defaultConfigOptions = {
  merge: 'replace',
  simple: true
},
    emptyFn = function emptyFn() {},
    newMeta = function newMeta(o) {
  return new MetaClass(o);
},
    setupNames = {
  /* foo : 'setupFoo' */
};
/**
 * Base class for all configurable classes.
 *
 * Subclasses do not have to implement a constructor with its restriction of having to call super()
 * before there is a `this` reference. Subclasses instead implement a `construct` method which is
 * called by the `Base` constructor. This may call its `super` implementation at any time.
 *
 * The `Base` constructor applies all configs to properties of the new instance. The instance
 * will have been configured after the `super.construct(config)` is called.
 *
 * See the Class System documentation in the guides for more information.
 *
 * @abstract
 */


var Base = /*#__PURE__*/function () {
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(Base, [{
    key: "isBase",
    get: function get() {
      return true;
    } // defaultConfig & properties made private to not spam all other classes

    /**
     * A class property getter to add additional, special class properties.
     *
     * For example, a class adds a `declarable` class property like so:
     * ```
     *  class Something extends Base {
     *      static get declarable() {
     *          return ['extra'];
     *      }
     *
     *      static setupExtra(cls, meta) {
     *          // use cls.extra
     *      }
     *  }
     * ```
     * A derived class can then specify this property like so:
     * ```
     *  class Derived extends Something {
     *      static get extra() {
     *          // return extra information
     *      }
     *  }
     * ```
     * When the `Derived` class is initialized, the `setupExtra()` method is called and `Derived` is passed as the
     * argument. It is also the `this` pointer, but the parameter is minifiable. The second argument passed is the
     * `$meta` object for the class.
     *
     * Classes are initialized at the first occurrence of the following:
     *
     * - An instance is created
     * - The class `$meta` property is accessed
     *
     * @member {String[]} declarable
     * @static
     * @category Configuration
     * @internal
     */

  }], [{
    key: "isBase",
    get: function get() {
      return true;
    }
  }, {
    key: "declarable",
    get: function get() {
      return ['declarable',
      /**
       * A class property getter for the configuration properties of the class, which can be overridden by
       * configurations passed at construction time.
       *
       * Unlike a normal `static` property, this property is only ever used for the class that defines it (as in,
       * `hasOwnProperty`). It is retrieved for all classes in a class hierarchy, to gather their configs
       * individually and then combine them with those of derived classes.
       *
       * For example, a `Label` might declare a `text` config like so:
       * ```javascript
       *  class Label extends Base {
       *      static get configurable() {
       *          return {
       *              text : null
       *          };
       *      }
       *  }
       * ```
       * The `text` config is automatically inherited by classes derived from Label. By implementing
       * `get configurable()`, derived classes can change the default value of inherited configs, or define new
       * configs, or both.
       *
       * When a config property is declared in this way, the class author can also implement either of two
       * special methods that will be called when the config property is assigned a new value:
       *
       *  - `changeText()`
       *  - `updateText()`
       *
       * In the example above, the `Label` class could implement a `changeText()` method, an `updateText()`
       * method, or both. The generated property setter ensures these methods will be called when the `text`
       * property is assigned.
       *
       * The generated setter (for `text` in this example) performs the following steps:
       *
       *  - If the class defines a `changeText()` method, call it passing the new value and the current value:
       *    `changeText(newText, oldText)`.<br>
       *    Then:
       *    * If `changeText()` exits without returning a value (i.e., `undefined`), exit and do nothing
       *      further. The assumption is that the changer method has done all that is required.
       *    * Otherwise, the return value of `changeText()` replaces the incoming value passed to the setter.
       *  - If the new value (or the value returned by `changeText()`) is `!==` to the current value:
       *    * Update the stored config value in `this._text`.
       *    * If the class defines an `updateText()` method, call it passing the new value and the previous value.
       *      `updateText(newText, oldText)`
       *
       * #### Resolving a value from an owner
       * By specifying a value starting with `'up.'` for a config, the config system will resolve that value by
       * examining the ownership hierarchy. It will walk up the hierarchy looking for a property matching the name
       * (or dot separated path) after 'up.'. If one is found, the value will be read and used as the initial
       * value.
       *
       * ```javascript
       * class Parent extends Base {
       *     static get configurable() {
       *         return [
       *           'importantValue'
       *         ]
       *     }
       * }
       *
       * class Child extends Base {
       *     static get configurable() {
       *         return [
       *           'value'
       *         ]
       *     }
       * }
       *
       * const parent = new Parent({
       *     importantValue : 123
       * });
       *
       * const child = new Child({
       *     owner : parent,
       *     // Will be resolved from the owner
       *     value : 'up.importantValue'
       * });
       *
       * console.log(child.value); // logs 123
       * ```
        * Please note that this is for now a one way one time binding, the value will only be read initially and
       * not kept up to date on later changes.
       *
       * #### Value Merging
       * When a config property value is an object, the value declared by the base class is merged with values
       * declared by derived classes and the value passed to the constructor.
       * ```javascript
       *  class Example extends Base {
       *      static get configurable() {
       *          return {
       *              config : {
       *                  foo : 1,
       *                  bar : 2
       *              }
       *          };
       *      }
       *  }
       *
       *  class Example2 extends Example {
       *      static get configurable() {
       *          return {
       *              config : {
       *                  bar : 42,
       *                  zip : 'abc'
       *              }
       *          };
       *      }
       *  }
       *
       *  let ex = new Example2({
       *      config : {
       *          zip : 'xyz'
       *      }
       *  });
       * ```
       * The result of the merge would set `config` to:
       * ```javascript
       *  ex.foo = {
       *      foo : 1,    // from Example
       *      bar : 42,   // from Example2
       *      zip : 'xyz' // from constructor
       *  }
       * ```
       *
       * #### Config Options
       * Some config properties require additional options such as declarative information about the config that
       * may be useful to automate some operation. Consider a `Button`. It could declare that its `text` config
       * affects the rendered HTML by applying a `render` property to the config definition. Its base class could
       * then examine the config definition to find this property.
       *
       * To support this, config options ca be declared like so:
       * ```javascript
       *  class Button extends Widget {
       *      static get configurable() {
       *          return {
       *              text : {
       *                  value   : null,
       *                  $config : {
       *                      render : true
       *                  }
       *              }
       *          };
       *      }
       *  }
       * ```
       * The `$config` property can alternatively be just the names of the options that should be enabled (set
       * to `true`).
       *
       * For example, the following is equivalent to the above:
       * ```javascript
       *  class Button extends Widget {
       *      static get configurable() {
       *          return {
       *              text : {
       *                  value   : null,
       *                  $config : 'render'
       *              }
       *          };
       *  }
       * ```
       *
       * #### Default Value
       * It is common to set a config to a `null` value to take advantage of internal optimizations for `null`
       * values. In most cases the fact that this produces `undefined` as the actual initial value of the config
       * is acceptable. When this is not acceptable, a config can be declared like so:
       * ```javascript
       *  class Widget {
       *      static get configurable() {
       *          return {
       *              disabled : {
       *                  $config : null,
       *                  value   : null,
       *                  default : false
       *              }
       *          };
       *  }
       * ```
       * The `default` property above determines the value of the config while still gaining the benefits of
       * minimal processing due to the `null` value of the `value` property.
       * @member {Object} configurable
       * @static
       * @category Configuration
       * @internal
       */
      'configurable',
      /**
       * A class property getter for the default configuration of the class, which can be overridden by
       * configurations passed at construction time.
       *
       * Unlike a normal `static` property, this property is only ever used for the class that defines it (as in,
       * `hasOwnProperty`). It is retrieved for all classes in a class hierarchy, to gather their configs
       * individually and then combine them with those of derived classes.
       *
       * For example, a `Store` might declare its `url` config like so:
       * ```
       *  class Store extends Base {
       *      static get defaultConfig() {
       *          return {
       *              url : null
       *          };
       *      }
       *  }
       * ```
       * The `url` config is automatically inherited by classes derived from Store. By implementing
       * `get defaultConfig()`, derived classes can change the default value of inherited configs, or define new
       * configs, or both. When defining new configs, however, `configurable` is preferred.
       *
       * Config properties introduced to a class by this declaration do not participate in value merging and do
       * not get a generated setter. Config properties introduced by a base class using `configurable` can be
       * set to a different value using `defaultConfig` and in doing so, the values will be merged as appropriate
       * for `configurable`.
       *
       * @member {Object} defaultConfig
       * @static
       * @category Configuration
       * @internal
       */
      'defaultConfig',
      /**
       * A class property getter for the default values of internal properties for this class.
       * @member {Object} properties
       * @static
       * @category Configuration
       * @internal
       */
      'properties',
      /**
       * A class property getter for properties that will be applied to the class prototype.
       * @member {Object} prototypeProperties
       * @static
       * @category Configuration
       * @internal
       */
      'prototypeProperties'];
    }
    /**
     * Base constructor, passes arguments to {@link #function-construct}.
     * @param args
     * @function constructor
     * @category Lifecycle
     */

  }]);

  function Base() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default()(this, Base);

    var me = this,
        C = me.constructor;

    if (me.$meta.class !== C) {
      // This will happen only once for each class. We need to call the C.$meta getter which puts $meta on our
      // prototype. Since that alone would be optimized away (and would generate IDE and lint warnings), we call
      // emptyFn and simply pass the value.
      emptyFn(C.$meta);
    } // Allow subclasses to have a pseudo constructor with "this" already set:


    me.construct.apply(me, arguments);
    me.afterConstruct();
  }
  /**
   * Base implementation applies configuration.
   *
   * Subclasses need only implement this if they have to initialize instance specific
   * properties required by the class. Often a `construct` method is
   * unnecessary. All initialization of incoming configuration properties can be
   * done in a `set propName` implementation.
   * @param {...Object} [config] Usually called with a config object, but accepts any params
   * @category Lifecycle
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(Base, [{
    key: "construct",
    value: function construct() {
      // Passing null to base construct means bypass the config system and stack creation (to gain performance)
      if ((arguments.length <= 0 ? undefined : arguments[0]) !== null) {
        this.configure.apply(this, arguments);
      }

      this.afterConfigure();
    }
    /**
     * Destroys the provided objects by calling their {@link #function-destroy} method.
     * Skips empty values or objects that are already destroyed.
     *
     * ```javascript
     * Base.destroy(myButton, toolbar1, helloWorldMessageBox);
     * ```
     *
     * @category Lifecycle
     */

  }, {
    key: "destroy",

    /**
     * Destroys the object.
     * Do not override this in subclasses. To provide class-specific destruction, implement a
     * doDestroy method. It is a lifecycle hook that will be called during destruction.
     * @category Lifecycle
     */
    value: function destroy() {
      var me = this; // Let everyone know the object is going inert:

      me.isDestroying = true; // Make calling destroy() harmless:

      me.destroy = emptyFn;
      me.doDestroy();
      Object.setPrototypeOf(me, null); // Clear all remaining instance properties.

      for (var key in me) {
        if (key !== 'destroy' && key !== 'isDestroying') {
          delete me[key];
        }
      }

      delete me[originalConfigSymbol]; // Let everyone know the object is inert:

      me.isDestroyed = true;
    }
    /**
     * This method is required to help `unused` getters to survive production build process. Some tools, like angular,
     * will remove `unused` code in production build, making our side-effected getters behind, breaking code heavily.
     * @internal
     * @param getter Getter to evaluate
     */

  }, {
    key: "_thisIsAUsedExpression",
    value: function _thisIsAUsedExpression(getter) {}
  }, {
    key: "startConfigure",

    /**
     * Base implementation so that all subclasses and mixins may safely call super.startConfigure.
     *
     * This is called by the Base class before setting configuration properties, but after
     * the active initial getters have been set, so all configurations are available.
     *
     * This method allows all classes in the hierarchy to force some configs to be evaluated before others.
     * @internal
     * @category Lifecycle
     * @params {Object} config The configuration object use to set the initial state.
     */
    value: function startConfigure(config) {}
    /**
     * Base implementation so that all subclasses and mixins may safely call super.finishConfigure.
     *
     * This is called by the Base class before exiting the {@link #function-configure} method.
     *
     * At this point, all configs have been applied, but the `isConfiguring` property is still set.
     *
     * This method allows all classes in the hierarchy to inject functionality
     * into the config phase.
     * @internal
     * @category Lifecycle
     * @params {Object} config The configuration object use to set the initial state.
     */

  }, {
    key: "finishConfigure",
    value: function finishConfigure(config) {}
    /**
     * Base implementation so that all subclasses and mixins may safely call `super.afterConfigure`. This is called by the Base class after the {@link #function-configure} method has been
     * called. At this point, all configs have been applied.
     *
     * This method allows all classes in the hierarchy to inject functionality
     * either before or after the super.afterConstruct();
     * @internal
     * @category Lifecycle
     */

  }, {
    key: "afterConfigure",
    value: function afterConfigure() {}
    /**
     * Base implementation so that all subclasses and mixins may safely call super.afterConstruct.
     *
     * This is called by the Base class after the {@link #function-construct} method has been
     * called.
     *
     * At this point, all configs have been applied.
     *
     * This method allows all classes in the hierarchy to inject functionality
     * either before or after the super.afterConstruct();
     * @internal
     * @function afterConstructor
     * @category Lifecycle
     */

  }, {
    key: "afterConstruct",
    value: function afterConstruct() {}
    /**
     * Provides a way of calling callbacks which may have been specified as the _name_ of a function
     * and optionally adds scope resolution.
     *
     * For example, if the callback is specified as a string, then if it is prefixed with `'this.'`
     * then the function is resolved in this object. This is useful when configuring listeners
     * at the class level.
     *
     * If the callback name is prefixed with `'up.'` then the ownership hierarchy is queried
     * using the `owner` property until an object with the named function is present, then the
     * named function is called upon that object.
     * @param {String|Function} handler The function to call, or the name of the function to call.
     * @param {Object} thisObj The `this` object of the function.
     * @param {Object[]} args The argument list to pass.
     */

  }, {
    key: "callback",
    value: function callback(fn, thisObject, args) {
      // Maintainer: do not make args ...args. This method may acquire more arguments
      if (thisObject === 'this') {
        thisObject = this;
      }

      var _this$resolveCallback = this.resolveCallback(fn, thisObject),
          handler = _this$resolveCallback.handler,
          thisObj = _this$resolveCallback.thisObj;

      return args ? handler.apply(thisObj, args) : handler.call(thisObj);
    }
  }, {
    key: "resolveProperty",
    value: function resolveProperty(propertyPath) {
      var thisObj = this;

      while (thisObj) {
        if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].hasPath(thisObj, propertyPath)) {
          return _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].getPath(thisObj, propertyPath);
        }

        thisObj = thisObj.owner;
      }

      return undefined;
    }
    /**
     * Provides a way of locating callbacks which may have been specified as the _name_ of a function
     * and optionally adds scope resolution.
     *
     * For example, if the callback is specified as a string, then if it is prefixed with `'this.'`
     * then the function is resolved in this object. This is useful when configuring listeners
     * at the class level.
     *
     * If the callback name is prefixed with `'up.'` then the ownership hierarchy is queried
     * using the `owner` property until an object with the named function is present, then the
     * named function is called upon that object.
     * @param {String|Function} handler The function to call, or the name of the function to call.
     * @param {Object} thisObj The `this` object of the function.
     * @param {Boolean} [enforceCallability = true] Pass `false` if the function may not exist, and a null return value is acceptable.
     * @returns {Object} `{ handler, thisObj }`
     */

  }, {
    key: "resolveCallback",
    value: function resolveCallback(handler) {
      var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var enforceCallability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      // It's a string, we find it in its own thisObj
      if (handler.substr) {
        if (handler.startsWith('up.')) {
          handler = handler.substr(3); // Empty loop until we find the function owner

          for (thisObj = this.owner; thisObj && !thisObj[handler]; thisObj = thisObj.owner) {
            ;
          }

          if (!thisObj) {
            return;
          }
        } else if (handler.startsWith('this.')) {
          handler = handler.substr(5);
          thisObj = this;
        }

        if (!thisObj || !(thisObj instanceof Object)) {
          return;
        }

        if (typeof thisObj[handler] !== 'function') {
          return;
        }

        handler = thisObj[handler];
      }

      return {
        handler: handler,
        thisObj: thisObj
      };
    }
  }, {
    key: "bindCallback",
    value: function bindCallback(inHandler) {
      var inThisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;

      if (inHandler) {
        var _this$resolveCallback2 = this.resolveCallback(inHandler, inThisObj),
            handler = _this$resolveCallback2.handler,
            thisObj = _this$resolveCallback2.thisObj;

        if (handler) {
          return handler.bind(thisObj);
        }
      }
    }
    /**
     * Delays the execution of the passed function by the passed time quantum, or if the time is omitted
     * or not a number, delays until the next animation frame. Note that this will use
     * {@link Core.mixin.Delayable#function-setTimeout} || {@link Core.mixin.Delayable#function-requestAnimationFrame}
     * if this class mixes in `Delayable`, otherwise it uses the global methods. The function will
     * be called using `this` object as its execution scope.
     * @param {Function} fn The function to call on a delay.
     * @param {Number} [by] The number of milliseconds to delay.
     * @private
     */

  }, {
    key: "delay",
    value: function delay(fn, by) {
      // Force scope on the fn if we are not a Delayable
      fn = this.setTimeout ? fn : fn.bind(this);
      var invoker = this.setTimeout ? this : window;
      invoker[typeof by === 'number' ? 'setTimeout' : 'requestAnimationFrame'](fn, by);
    }
    /**
     * Base implementation so that all subclasses and mixins may safely call super.
     * doDestroy is how all subclasses must clean themselves up. It is called by the
     * Base class *before* final destruction of the object.
     * @internal
     * @category Lifecycle
     */

  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var nullify = this.$meta.nullify;

      if (nullify) {
        for (var i = 0; i < nullify.length; ++i) {
          this[nullify[i].name] = null;
        }
      }
    }
    /**
     * Destroys the named properties if they have been initialized, and if they have a `destroy` method.
     * Deletes the property from this object. For example:
     *
     *      this.destroyProperties('store', 'resourceStore', 'eventStore', 'dependencyStore', 'assignmentStore');
     *
     * @param {String} properties The names of the properties to destroy.
     * @internal
     * @category Lifecycle
     */

  }, {
    key: "destroyProperties",
    value: function destroyProperties() {
      var me = this;
      var key, propertyValue;

      for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
        properties[_key] = arguments[_key];
      }

      for (var _i = 0, _properties = properties; _i < _properties.length; _i++) {
        key = _properties[_i];

        // If the value has *not* been pulled in from the configuration object yet
        // we must not try to access it, as that will cause the property to be initialized.
        if (key in me && (!me[configuringSymbol] || !me[configuringSymbol][key])) {
          propertyValue = me[key];

          if (propertyValue && propertyValue.destroy) {
            propertyValue.destroy();
          }

          delete me[key];
        }
      }
    }
    /**
     * Called by the Base constructor to apply configs to this instance. This must not be called.
     * @param {Object} config The configuration object from which instance properties are initialized.
     * @private
     * @category Lifecycle
     */

  }, {
    key: "configure",
    value: function configure() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this,
          beforeConfigure = config.beforeConfigure,
          configs = me.$meta.configs,
          fullConfig = me.getDefaultConfiguration();
      var cfg, key, value;
      me.initialConfig = config; // Important flag for setters to know whether they are being called during
      // configuration when this object is not fully alive, or whether it's being reconfgured.

      me.isConfiguring = true; // Assign any instance properties declared by the class.

      Object.assign(me, me.getProperties()); // Apply configuration to default from class definition. This is safe because it's either chained from or a
      // fork of the class values.

      for (key in config) {
        value = config[key];
        cfg = configs[key];
        fullConfig[key] = cfg ? cfg.merge(value, fullConfig[key], null) : value;
      }

      if (beforeConfigure) {
        delete fullConfig.beforeConfigure; // noinspection JSValidateTypes

        beforeConfigure(me, fullConfig);
      } // Cache me.config for use by get config.


      me.setConfig(me[originalConfigSymbol] = fullConfig, true);
      me.isConfiguring = false;
    }
    /**
     * Returns the value of the specified config property. This is a method to allow
     * property getters to be explicitly called in a way that does not get optimized out.
     *
     * The following triggers the getter call, but optimizers will remove it:
     *
     *      inst.foo;   // also raises "expression has no side-effects" warning
     *
     * Instead, do the following to trigger a getter:
     *
     *      inst.getConfig('foo');
     *
     * @param {String} name
     * @internal
     * @category Configuration
     */

  }, {
    key: "getConfig",
    value: function getConfig(name) {
      return this[name];
    }
    /**
     * Sets configuration options this object with all the properties passed in the parameter object.
     * Timing is taken care of. If the setter of one config is called first, and references
     * the value of another config which has not yet been set, that config will be set just
     * in time, and the *new* value will be used.
     * @param {Object} config An object containing configurations to change.
     * @category Configuration
     */

  }, {
    key: "setConfig",
    value: function setConfig(config, isConstructing) {
      var me = this,
          wasConfiguring = me[configuringSymbol],
          configDone = wasConfiguring ? me.configDone : me.configDone = {},
          configs = me.$meta.configs;
      var cfg, key;
      me[instancePropertiesSymbol] = {}; // Cache configuration for use by injected property initializers.

      me[configuringSymbol] = wasConfiguring ? Object.setPrototypeOf(Object.assign({}, config), wasConfiguring) : config; // For each incoming non-null configuration, create a temporary getter which will
      // pull the value in from the initialConfig so that it doesn't matter in
      // which order properties are set. You can access any property at any time.

      for (key in config) {
        // Don't default null configs in unless it's a direct property of the
        // the passed configuration. When used at construct time, defaultConfigs
        // will be prototype-chained onto the config.
        if (config[key] != null || hasOwnProperty.call(config, key)) {
          cfg = configs[key] || _Config_js__WEBPACK_IMPORTED_MODULE_26__["default"].get(key);
          cfg.defineInitter(me, config[key]);

          if (!isConstructing) {
            configDone[key] = false;
          } else if (cfg.lazy) {
            configDone[key] = true;
          }
        } else {
          configDone[key] = true;
        }
      }

      if (isConstructing) {
        me.startConfigure(config);
      } // Set all our properties from the config object.
      // If one of the properties needs to access a property that has not
      // yet been set, the above temporary property will pull it through.
      // Can't use Object.assign because that only uses own properties.
      // config value blocks are prototype chained subclass->superclass


      for (key in config) {
        // Only push the value through if the property initializer is still present.
        // If it gets triggered to pull the configuration value in, it deleted itself.
        if (!configDone[key]) {
          me[key] = config[key];
        }
      }

      if (wasConfiguring) {
        me[configuringSymbol] = wasConfiguring;
      } else {
        delete me[configuringSymbol];
      }

      if (isConstructing) {
        me.finishConfigure(config);
      }

      return me;
    }
    /**
     * Ensures that the specified config is initialized if it is needed. If there is a config value specified, and it
     * was initialized by this call, this method returns `true`. If there was a config value specified, and it was
     * already initialized, this method returns `false`. If there was no value specified for the given config, this
     * method returns `null`.
     *
     * This is different than just reading the property because some property getters exist that do not actually just
     * read the config value back, but instead produce some result. Reading such properties to incidentally trigger a
     * possible config initializer can lead to incorrect results. For example, the Combo items config.
     *
     * @param {String} name The name of the config property.
     * @returns {Boolean}
     * @internal
     */

  }, {
    key: "triggerConfig",
    value: function triggerConfig(name) {
      var configDone = this.configDone,
          config = this[configuringSymbol],
          triggered = config && (config[name] != null || hasOwnProperty.call(config, name)) ? !configDone[name] : null;

      if (triggered) {
        this.getConfig(name);
      }

      return triggered;
    }
  }, {
    key: "onConfigChange",
    value: function onConfigChange() {} // declared above because lint/IDE get angry about not declaring the args...

    /**
     * This method is called when any config changes.
     * @param {Object} info Object containing information regarding the config change.
     * @param {String} info.name The name of the config that changed.
     * @param {*} info.value The new value of the config.
     * @param {*} info.was The previous value of the config.
     * @param {Core.Config} info.config The `Config` object for the changed config property.
     * @method onConfigChange
     * @internal
     * @category Configuration
     */

    /**
     * Returns a *copy* of the full configuration which was used to configure this object.
     * @returns {Object} All configuration properties which were used to configure this object.
     * @category Configuration
     */

  }, {
    key: "getDefaultConfiguration",

    /**
     * Gets the full {@link #property-defaultConfig-static} block for this object's entire inheritance chain
     * all the way up to but not including {@link Core.Base}
     * @return {Object} All default config values for this class.
     * @private
     * @category Configuration
     */
    value: function getDefaultConfiguration() {
      return this.constructor.getDefaultConfiguration();
    }
    /**
     * Gets the full {@link #property-defaultConfig-static} block for the entire inheritance chain for this class
     * all the way up to but not including {@link Core.Base}
     * @return {Object} All default config values for this class.
     * @private
     * @category Configuration
     */

  }, {
    key: "getProperties",

    /**
     * Gets the full {@link #property-properties-static} block for this class's entire inheritance chain
     * all the way up to but not including {@link Core.Base}
     * @return {Object} All default config values for this class.
     * @private
     * @category Configuration
     */
    value: function getProperties() {
      var // The meta.properties array is an array of classes that define "static get properties()"
      hierarchy = this.$meta.properties,
          result = {}; // TODO: if properties block does not change this could be cached? would speed up loading of big data sets
      //  into grid. The problem is that this call creates new (i.e., non-shared) instances of objects, arrays and
      //  Map objects that apply to each instance. These would all need to be cloned so it may be better to just
      //  call the properties getter each time and let it create new instances of whatever types.
      //for (cls of hierarchy) { // for-of transpiles badly and this is called a lot

      for (var i = 0; i < hierarchy.length; i++) {
        // Gather the class result in top-down order so that subclass properties override superclass properties
        Object.assign(result, hierarchy[i].properties);
      }

      return result;
    }
  }, {
    key: "classHierarchy",

    /**
     * Used by the Widget and GridFeatureManager class internally. Returns the class hierarchy of this object
     * starting from the `topClass` class (which defaults to `Base`).
     *
     * For example `classHierarchy(Widget)` on a Combo would yield `[Widget, Field, TextField, PickerField, Combo]`
     * @param {Function} [topClass] The topmost class constructor to start from.
     * @returns {Function[]} The class hierarchy of this instance.
     * @private
     * @category Configuration
     */
    value: function classHierarchy(topClass) {
      var hierarchy = this.$meta.hierarchy,
          index = topClass ? hierarchy.indexOf(topClass) : 0;
      return index > 0 ? hierarchy.slice(index) : hierarchy;
    }
    /**
     * Checks if an obj is of type using object's $$name property and doing string comparison of the property with the
     * type parameter.
     *
     * @param {String} type
     * @return {Boolean}
     */

  }, {
    key: "detachListeners",

    /**
     * Removes all event listeners that were registered with the given `name`.
     * @param {String} name The name of the event listeners to be removed.
     * @category Events
     */
    value: function detachListeners(name) {
      var detachers = this.$detachers;
      detachers = detachers && detachers[name];

      if (detachers) {
        while (detachers.length) {
          detachers.pop()();
        }
      }
    }
    /**
     * Tracks a detacher function for the specified listener name.
     * @param {String} name The name assigned to the associated listeners.
     * @param {Function} detacher The detacher function.
     * @private
     */

  }, {
    key: "trackDetacher",
    value: function trackDetacher(name, detacher) {
      var detachers = this.$detachers || (this.$detachers = {}),
          bucket = detachers[name] || (detachers[name] = []);
      bucket.push(detacher);
    }
    /**
     * Removes all detacher functions for the specified `Events` object. This is called
     * by the `removeAllListeners` method on that object which is typically called by its
     * `destroy` invocation.
     * @param {Core.mixin.Events} eventer The `Events` instance to untrack.
     * @private
     */

  }, {
    key: "untrackDetachers",
    value: function untrackDetachers(eventer) {
      var detachers = this.$detachers;

      if (detachers) {
        for (var name in detachers) {
          var bucket = detachers[name];

          for (var i = bucket.length; i-- > 0;)
          /* empty */
          {
            if (bucket[i].eventer === eventer) {
              bucket.splice(i, 1);
            }
          }
        }
      }
    }
  }, {
    key: "$$name",
    get: function get() {
      return this.constructor.$$name;
    }
  }, {
    key: "config",
    get: function get() {
      var result = {},
          myConfig = this[originalConfigSymbol]; // The configuration was created as a prototype chain of the class hierarchy's
      // defaultConfig values hanging off a copy of the initialConfig object, so
      // we must loop and copy since Object.assign only copies own properties.

      for (var key in myConfig) {
        result[key] = myConfig[key];
      }

      return result;
    }
    /**
     * Registers this class type with its Factory
     */

  }], [{
    key: "destroy",
    value: function destroy() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      args.forEach(function (object) {
        if (object && object.destroy && !object.isDestroyed) {
          object.destroy();
        }
      });
    }
  }, {
    key: "initClass",
    value: function initClass() {
      return this.$meta.class;
    }
    /**
     * The class's {@link #property-$meta-static meta} object.
     * @property {Object}
     * @name $meta
     * @internal
     * @category Misc
     */

    /**
     * An object owned by this class that does not share properties with its super class.
     *
     * This object may contain other properties which are added as needed and are not documented here.
     *
     * @property {Object} $meta The class meta object.
     * @property {Function} $meta.class The class constructor that owns the meta object.
     * @property {Object} $meta.super The `$meta` object for the super class. This is `null` for `Base`.
     * @property {Object} $meta.config The object holding the default configuration values for this class.
     * @property {Object} $meta.configs An object keyed by config name that holds the defined configs for the class.
     * The value of each property is a {@link Core/Config} instance.
     * @property {Boolean} $meta.forkConfigs This will be `true` if the default configuration values for this class
     * (in the `config` property of the meta object) must be forked to avoid object sharing, or if the object can be
     * passed to `Object.create()` for efficiency.
     * @property {Array} $meta.hierarchy The array of classes in the ancestry of this class. This will start with
     * `Base` at index 0 and ends with this class.
     * @property {Array} $meta.properties The array of classes that define a "static get properties()" getter.
     * @internal
     * @static
     * @category Misc
     */

  }, {
    key: "onClassMixedIn",

    /**
     * This optional class method is called when a class is mixed in using the {@link #function-mixin-static mixin()}
     * method.
     * @internal
     */
    value: function onClassMixedIn() {// empty
    }
    /**
     * Returns the merge of the `baseConfig` and `config` config objects based on the configs defined by this class.
     * @param {Object} baseConfig The base config or defaults.
     * @param {...Object} configs One or more config objects that takes priority over `baseConfig`.
     * @returns {Object}
     * @internal
     */

  }, {
    key: "mergeConfigs",
    value: function mergeConfigs(baseConfig) {
      var classConfigs = this.$meta.configs,
          result = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].clone(baseConfig) || {};
      var config, i, key, value;

      for (var _len3 = arguments.length, configs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        configs[_key3 - 1] = arguments[_key3];
      }

      for (i = 0; i < configs.length; ++i) {
        config = configs[i];

        if (config) {
          for (key in config) {
            value = config[key];

            if (classConfigs[key]) {
              value = classConfigs[key].merge(value, result[key]);
            } else if (result[key] && value) {
              value = _Config_js__WEBPACK_IMPORTED_MODULE_26__["default"].merge(value, result[key]);
            }

            result[key] = value;
          }
        }
      }

      return result;
    }
    /**
     * Applies one or more `mixins` to this class and returns the produced class constructor.
     *
     * For example, instead of writing this:
     * ```
     *  class A extends Delayable(Events(Localizable(Base))) {
     *      // ...
     *  }
     * ```
     *
     * Using this method, one would write this:
     * ```
     *  class A extends Base.mixin(Localizable, Events, Delayable) {
     *      // ...
     *  }
     * ```
     * If one of the mixins specified has already been mixed into the class, it will be ignored and not mixed in a
     * second time.
     * @param {...Function} mixins
     * @returns {Function}
     */

  }, {
    key: "mixin",
    value: function mixin() {
      // Starting w/the first class C = this
      var C = this,
          i; // wrap each class C using mixins[i] to produce the next class

      for (var _len4 = arguments.length, mixins = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        mixins[_key4] = arguments[_key4];
      }

      for (i = 0; i < mixins.length; ++i) {
        var mixin = mixins[i],
            // Grab or create a unique Symbol for this mixin so we can tell if we've already mixed it in
        tag = mixin[mixinTagSymbol] || (mixin[mixinTagSymbol] = Symbol('mixinTag'));

        if (C[tag]) {
          continue;
        }

        C = mixin(C);
        C[tag] = true; // properties on the constructor are inherited to subclass constructors...

        if (hasOwnProperty.call(C, 'onClassMixedIn')) {
          C.onClassMixedIn();
        }
      }

      return C;
    }
    /**
     * This method is called only once for any class. This can occur when the first instance is created or when the
     * `$meta` object is first requested.
     * @param {Object} meta The `$meta` object for the class.
     * @internal
     * @category Misc
     */

  }, {
    key: "setupClass",
    value: function setupClass(meta) {
      var _base$nullify;

      var cls = meta.class,
          // Trigger setupClass on the super class (if it has yet to happen):
      base = getPrototypeOf(cls).$meta,
          name = cls.$$name,
          names = base.names,
          proto = cls.prototype;
      defineProperty(proto, '$meta', {
        value: meta
      });
      Object.assign(meta, {
        super: base,
        config: Object.create(base.config),
        configs: Object.create(base.configs),
        declarables: base.declarables,
        forkConfigs: base.forkConfigs,
        hierarchy: Object.freeze([].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_19___default()(base.hierarchy), [cls])),
        names: names.includes(name) ? names : Object.freeze([].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_19___default()(names), [name])),
        properties: base.properties,
        nullify: (_base$nullify = base.nullify) === null || _base$nullify === void 0 ? void 0 : _base$nullify.slice()
      });

      if (names !== meta.names) {
        var is = 'is' + name;

        if (!hasOwnProperty.call(proto, is)) {
          defineProperty(proto, is, {
            value: true
          });
        }

        if (!hasOwnProperty.call(cls, is)) {
          defineProperty(cls, is, {
            value: true
          });
        }
      } // NOTE: we always use meta.declarables because setupDeclarable() can replace the array on the meta object
      // when new declarable properties are added...


      for (var decl, setupName, i = 0; i < meta.declarables.length; ++i) {
        decl = meta.declarables[i];

        if (hasOwnProperty.call(cls, decl)) {
          setupName = setupNames[decl] || (setupNames[decl] = "setup".concat(_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].capitalize(decl)));
          cls[setupName](cls, meta);
        }
      }
      /*  Add slash to the front of this line to enable the diagnostic block:
      
      /**/

    }
    /**
     * This method is called as part of `setupClass()`. It will process the `configurable()` return object and the
     * `defaultConfig` return object.
     * @param {Object} meta The `meta` object for this class.
     * @param {Object} configs The config definition object.
     * @param {Boolean} simple `true` when processing `defaultConfig` and `false` when processing `configurable`.
     * @private
     * @category Configuration
     */

  }, {
    key: "setupConfigs",
    value: function setupConfigs(meta, configs, simple) {
      var classConfigValues = meta.config,
          classConfigs = meta.configs,
          proto = meta.class.prototype;
      var cfg, nullify, options, value, wasNullify;

      for (var name in configs) {
        value = configs[name];

        if (simple) {
          // Using "defaultConfig"
          if (!(cfg = classConfigs[name])) {
            cfg = _Config_js__WEBPACK_IMPORTED_MODULE_26__["default"].get(name, defaultConfigOptions);
          } else {
            // The property may be declared in a base class using configurable(), so it may have special
            // merge processing:
            value = cfg.merge(value, classConfigValues[name], meta);
          }
          /*  Add slash to the front of this line to enable the diagnostic block:
          
          /**/

        } else {
          // Using "configurable"
          options = null;

          if (value && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18___default()(value) === 'object' && '$config' in value) {
            options = value.$config;

            if (options && !_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].isObject(options)) {
              options = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].createTruthyKeys(options);
            }

            if ('default' in value) {
              defineProperty(proto, _Config_js__WEBPACK_IMPORTED_MODULE_26__["default"].get(name).field, {
                configurable: true,
                writable: true,
                // or else "this._value = x" will fail
                value: value.default
              });
            }

            value = value.value;
          }

          if (!(cfg = classConfigs[name])) {
            cfg = _Config_js__WEBPACK_IMPORTED_MODULE_26__["default"].get(name, options);
            cfg.define(meta.class.prototype);
            wasNullify = false;
          } else {
            wasNullify = cfg.nullify;

            if (options) {
              // Defined by a base class, but maybe being adjusted by derived.
              cfg = cfg.extend(options); // In the future, we may need to redefine the property here if options affect the descriptor (such
              // as event firing)
            }

            value = cfg.merge(value, classConfigValues[name], meta);
          }

          if (cfg.nullify && !wasNullify) {
            (nullify || (meta.nullify = nullify = [])).push(cfg);
          }
        } // If any default properties are *mutable* Objects or Array we need to clone them.
        // so that instances do not share configured values.


        if (value && (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].isObject(value) || Array.isArray(value)) && !Object.isFrozen(value)) {
          meta.forkConfigs = true;
        }

        classConfigs[name] = cfg;
        classConfigValues[name] = value;
      }
    }
  }, {
    key: "setupConfigurable",
    value: function setupConfigurable(cls, meta) {
      cls.setupConfigs(meta, cls.configurable, false);
    }
  }, {
    key: "setupDefaultConfig",
    value: function setupDefaultConfig(cls, meta) {
      cls.setupConfigs(meta, cls.defaultConfig, true);
    }
  }, {
    key: "setupDeclarable",
    value: function setupDeclarable(cls, meta) {
      var declarable = cls.declarable;
      var all = meta.declarables,
          forked,
          i;

      for (i = 0; i < declarable.length; ++i) {
        if (!all.includes(declarable[i])) {
          if (!forked) {
            meta.declarables = forked = all = all.slice();
          }

          all.push(declarable[i]);
        }
      }
    }
  }, {
    key: "setupProperties",
    value: function setupProperties(cls, meta) {
      meta.properties = meta.super.properties.slice();
      meta.properties.push(cls);
      Object.freeze(meta.properties);
    }
  }, {
    key: "setupPrototypeProperties",
    value: function setupPrototypeProperties(cls) {
      Object.assign(cls.prototype, cls.prototypeProperties);
    }
  }, {
    key: "getDefaultConfiguration",
    value: function getDefaultConfiguration() {
      var meta = this.$meta,
          config = meta.forkConfigs ? Base.fork(meta.config) : Object.create(meta.config);

      if (_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isTestEnv && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isBrowserEnv && config.testConfig && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].global.__applyTestConfigs) {
        for (var o in config.testConfig) {
          config[o] = config.testConfig[o];
        }
      }

      return config;
    }
  }, {
    key: "fork",
    value: function fork(obj) {
      var ret = obj,
          key,
          value;

      if (obj && _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].isObject(obj) && !Object.isFrozen(obj)) {
        ret = Object.create(obj);

        for (key in obj) {
          value = obj[key];

          if (value) {
            if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].isObject(value)) {
              ret[key] = Base.fork(value);
            } else if (Array.isArray(value)) {
              ret[key] = value.slice();
            }
          }
        }
      }

      return ret;
    }
  }, {
    key: "isOfTypeName",
    value: function isOfTypeName(type) {
      return this.$meta.names.includes(type);
    }
  }, {
    key: "$$name",
    get: function get() {
      return hasOwnProperty.call(this, '$name') && this.$name || // _$name is filled by webpack for every class (cls._$name = '...')
      hasOwnProperty.call(this, '_$name') && this._$name || this.name;
    }
  }, {
    key: "$meta",
    get: function get() {
      var me = this;
      var meta = me[metaSymbol];

      if (!hasOwnProperty.call(me, metaSymbol)) {
        me[metaSymbol] = meta = newMeta();
        meta.class = me;
        me.setupClass(meta);
      }

      return meta;
    }
  }, {
    key: "superclass",
    get: function get() {
      return getPrototypeOf(this);
    }
  }]);

  return Base;
}();


var proto = Base.prototype; // Informs the standard config setter there is no need to call this fn:

proto.onConfigChange.$nullFn = true;
Base[metaSymbol] = proto.$meta = newMeta({
  class: Base,
  config: Object.freeze({}),
  configs: Object.create(null),
  declarables: Base.declarable,
  forkConfigs: false,
  hierarchy: Object.freeze([Base]),
  names: Object.freeze(['Base']),
  nullify: null,
  properties: Object.freeze([]),
  super: null
}); // Avoid some object shape changes:

Object.assign(proto, {
  $detachers: null,

  /**
   * This property is set to `true` by {@link #function-destroy} after the {@link #function-doDestroy} method returns.
   * It is also one of the few properties that remains on the object after returning from `destroy()`. This property
   * is often checked in code paths that may encounter a destroyed object (like some event handlers) or in the
   * destruction path during cleanup.
   * @member {Boolean}
   * @internal
   */
  isDestroyed: false,

  /**
   * This property is set to `true` on entry to the {@link #function-destroy} method. It remains on the objects after
   * returning from `destroy()`. If {@link #property-isDestroyed} is `true`, this property will also be `true`, so
   * there is no need to test for both (for example, `comp.isDestroying || comp.isDestroyed`).
   * @member {Boolean}
   * @internal
   */
  isDestroying: false
});
_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].setVersion('core', '0.0.0');
Base._$name = 'Base';

/***/ }),

/***/ "./lib/Core/Config.js":
/*!****************************!*\
  !*** ./lib/Core/Config.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Config; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.get-own-property-descriptor */ "./node_modules/core-js/modules/es.reflect.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");






















var productName = 'scheduler';
 // We cannot import ObjectHelper because of the import cycle:
//  ObjectHelper -> DateHelper -> LocaleManager -> Base -> us

/**
 * @module Core/Config
 */

var defineProperty = Reflect.defineProperty,
    getOwnPropertyDescriptor = Reflect.getOwnPropertyDescriptor,
    _Object$prototype = Object.prototype,
    hasOwnProperty = _Object$prototype.hasOwnProperty,
    toString = _Object$prototype.toString,
    instancePropertiesSymbol = Symbol('instanceProperties'),
    configuringSymbol = Symbol('configuring'),
    lazyConfigValues = Symbol('lazyConfigValues'),
    DATE_TYPE = toString.call(new Date());
/**
 * This class holds the description of a config property. Only one instance of this class is needed for each config
 * name (e.g., "text"). If config options are supplied, however, they also contribute to the cached instance.
 *
 * Instances should always be retrieved by calling `Config.get()`.
 *
 * The **Configs** of this class correspond to `options` that can be supplied to the `get()` method. These affect the
 * behavior of the config property in some way, as descried by their respective documentation.
 *
 * This class is not used directly.
 *
 * ## The Setter
 * The primary functionality provided by `Config` is its standard setter. This setter function ensures consistent
 * behavior when modifying config properties.
 *
 * The standard setter algorithm is as follows (using the `'text'` config for illustration):
 *
 *  - If the class defines a `changeText()` method, call it passing the new value and the current value:
 *    `changeText(newText, oldText)`.<br>
 *    Then:
 *    * If `changeText()` exits without returning a value (i.e., `undefined`), exit and do nothing further. The
 *      assumption is that the changer method has done all that is required.
 *    * Otherwise, the return value of `changeText()` replaces the incoming value passed to the setter.
 *  - If the new value (or the value returned by `changeText()`) is `!==` to the current value:
 *    * Update the stored config value in `this._text`.
 *    * If the class defines an `updateText()` method, call it passing the new value and the previous value.
 *      `updateText(newText, oldText)`
 *    * If the class defines an `onConfigChange()` method, call it passing an object with the following properties:
 *        - `name` - The config's name
 *        - `value` - The new value
 *        - `was` - The previous value
 *        - `config` - The `Config` instance.
 *
 * NOTE: unlike `changeText()` and `updateText()`, the name of the `onConfigChange()` method is unaffected by the
 * config's name.
 *
 * @internal
 */

var Config = /*#__PURE__*/function () {
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(Config, null, [{
    key: "get",

    /**
     * Returns the `Config` instance for the given `name` and `options`.
     * @param {String} name The name of the config (e.g., 'text' for the text config).
     * @param {Object} [options] Config behavior options.
     * @returns {Core.Config}
     * @internal
     */
    value: function get(name, options) {
      var cache = this.cache,
          baseCfg = cache[name] || (cache[name] = new Config(name));
      var cfg = baseCfg,
          key;

      if (options) {
        key = Config.makeCacheKey(name, options);

        if (!(cfg = key && cache[key])) {
          cfg = baseCfg.extend(options);

          if (key) {
            cache[key] = cfg;
          }
        }
      }

      return cfg;
    }
  }]);

  function Config(name) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default()(this, Config);

    var me = this,
        cap = name[0].toUpperCase() + name.substr(1);
    me.base = me; // so extend()ed configs have a link to the base definition

    me.name = name;
    me.field = '_' + name;
    me.capName = cap;
    me.changer = 'change' + cap;
    me.initializing = 'initializing' + cap;
    me.updater = 'update' + cap;
  }
  /**
   * The descriptor to use with `Reflect.defineProperty()` for defining this config's getter and setter.
   * @property {Object}
   * @private
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(Config, [{
    key: "equal",

    /**
     * This method compares two values for semantic equality. By default, this is based on the `===` operator. This
     * is often overridden for configs that accept `Date` or array values.
     * @param {*} value1
     * @param {*} value2
     * @returns {Boolean}
     * @internal
     */
    value: function equal(value1, value2) {
      return value1 === value2;
    }
    /**
     * Extends this config with a given additional set of options. These objects are just prototype extensions of this
     * instance.
     * @param {Object} options
     * @returns {Core.Config}
     * @internal
     */

  }, {
    key: "extend",
    value: function extend(options) {
      var cfg = Object.assign(Object.create(this), options),
          equal = options.equal,
          merge = options.merge,
          equalityMethods = Config.equalityMethods;

      if (typeof equal === 'string') {
        if (equal.endsWith('[]')) {
          cfg.equal = Config.makeArrayEquals(equalityMethods[equal.substr(0, equal.length - 2)]);
        } else {
          cfg.equal = equalityMethods[equal];
        }
      }

      if (typeof merge === 'string') {
        // Base uses { merge : 'replace' } for defaultConfig properties
        cfg.merge = Config.mergeMethods[merge];
      }

      return cfg;
    }
    /**
     * Defines the property on a given target object via `Reflect.defineProperty()`. If the object has its own getter,
     * it will be preserved. It is invalid to define a setter.
     * @param {Object} target
     * @internal
     */

  }, {
    key: "define",
    value: function define(target) {
      var existing = getOwnPropertyDescriptor(target, this.name);
      var descriptor = this.descriptor;

      if (existing && existing.get) {
        descriptor = Object.assign({}, descriptor);
        descriptor.get = existing.get;
      }

      defineProperty(target, this.name, descriptor);
    }
    /**
     * Defines the property initter on the `target`. This is a property getter/setter that propagates the configured
     * value when the property is read.
     * @param {Object} target
     * @param {*} value
     * @internal
     */

  }, {
    key: "defineInitter",
    value: function defineInitter(target, value) {
      var name = this.name,
          properties = target[instancePropertiesSymbol];
      var lazyValues, prop; // If there is an existing property with a getter/setter, *not* a value
      // defined on the object for this config we must call it in our injected getter/setter.

      if (!properties[name] && (
      /* assign */
      prop = getOwnPropertyDescriptor(target, name)) && !('value' in prop)) {
        properties[name] = prop;
      } // Set up a temporary instance property which will pull in the value from the initialConfig if the getter
      // is called first.


      defineProperty(target, name, this.initDescriptor);

      if (this.lazy) {
        lazyValues = target[lazyConfigValues] || (target[lazyConfigValues] = {
          $counter_: 0
        });
        lazyValues[name] = value;
        ++lazyValues.$counter_;
      }
    }
    /**
     * Returns an equality function for arrays of a base type, for example `'date'`.
     * @param {Function} [fn] The function to use to compare array elements. By default, operator `===` is used.
     * @returns {Function}
     * @private
     */

  }, {
    key: "makeDescriptor",

    /**
     * Creates and returns a property descriptor for this config suitable to be passed to `Reflect.defineProperty()`.
     * @returns {Object}
     * @private
     */
    value: function makeDescriptor() {
      var config = this,
          base = config.base,
          field = config.field,
          changer = config.changer,
          updater = config.updater,
          name = config.name;

      if (base !== config && base.equal === config.equal) {
        // At present only the equal option affects the setter, so all configs can share the
        // descriptor of the base-most config definition unless their equality test fns differ.
        return base.descriptor;
      }

      return {
        get: function get() {
          return this[field];
        },
        set: function set(value) {
          var me = this;
          var was = me[field]; // Resolve values starting with 'up.' by traversing owners to find it

          if (typeof value === 'string' && value.startsWith('up.')) {
            var ownerValue = me.resolveProperty(value.substr(3)); // TODO: Ignoring functions for now, we need to handle scope to make those work

            if (typeof ownerValue !== 'function') {
              value = ownerValue;
            }
          } // If the "changeTitle()" fellow falls off the end, it must have changed all the needful things.
          // Otherwise, it returned the final config value (it may have changed it instead, for example, making
          // an instance from a config object).


          if (me[changer]) {
            value = me[changer](value, was);

            if (value === undefined) {
              return;
            }

            was = me[field]; // in case it was modified by the changer fn...
          } // inline the default equal() for better perf:


          if (config.equal === equal ? was !== value : !config.equal(was, value)) {
            me[field] = value; // Check for a "syncTitle()" method and call it if present.

            if (me[updater]) {
              me[updater](value, was);
            }

            if (!me.onConfigChange.$nullFn) {
              me.onConfigChange({
                name: name,
                value: value,
                was: was,
                config: config
              });
            }
          }
        }
      };
    }
    /**
     * Creates and returns a property descriptor for this config's initter suitable to pass to
     * `Reflect.defineProperty()`.
     * @returns {Object}
     * @private
     */

  }, {
    key: "makeInitter",
    value: function makeInitter() {
      var config = this;

      if (config !== config.base) {
        if (config.lazy) {
          return config.makeLazyInitter();
        } // At present no other options affect the setter, so all configs can share the descriptor of the base-most
        // config definition.


        return config.base.initDescriptor;
      }

      return config.makeBasicInitter();
    }
  }, {
    key: "makeBasicInitter",
    value: function makeBasicInitter() {
      var config = this,
          initializing = config.initializing,
          name = config.name;
      return {
        configurable: true,
        get: function get() {
          var me = this;
          config.removeInitter(me); // Set the value from the configuration.

          me[initializing] = true;
          me[name] = me[configuringSymbol][name];
          me[initializing] = false; // The property has been *pulled* from the configuration.
          // Prevent the setting loop in configure from setting it again.

          me.configDone[name] = true; // Finally, allow the prototype getter to return the value.

          return me[name];
        },
        set: function set(value) {
          config.removeInitter(this); // The config has been set (some internal code may have called the setter)
          // so prevent it from being called again and overwritten with data from initialConfig.

          this.configDone[name] = true; // Set the property normally (Any prototype setter will be invoked)

          this[name] = value;
        }
      };
    }
  }, {
    key: "makeLazyInitter",
    value: function makeLazyInitter() {
      var config = this,
          initializing = config.initializing,
          name = config.name;
      return {
        configurable: true,
        get: function get() {
          var me = this,
              value = me[lazyConfigValues][name];
          config.removeInitter(me); // Set the value from the lazy config object.

          me[initializing] = true;
          me[name] = value;
          me[initializing] = false; // Finally, allow the prototype getter to return the value.

          return me[name];
        },
        set: function set(value) {
          config.removeInitter(this); // Set the property normally (Any prototype setter will be invoked)

          this[name] = value;
        }
      };
    }
    /**
     * Removes the property initter and restores the instance to its original form.
     * @param {Object} instance
     * @private
     */

  }, {
    key: "removeInitter",
    value: function removeInitter(instance) {
      var name = this.name,
          instanceProperty = instance[instancePropertiesSymbol][name]; // If we took over from an instance property, replace it

      if (instanceProperty) {
        defineProperty(instance, name, instanceProperty);
      } // Otherwise just delete the instance property who's getter we are in.
      else {
          delete instance[name];
        }

      if (this.lazy) {
        if (! --instance[lazyConfigValues].$counter_) {
          delete instance[lazyConfigValues];
        }
      }
    }
    /**
     * This method combines (merges) two config values. This is called in two cases:
     *
     *  - When a derived class specifies the value of a config defined in a super class.
     *  - When a value is specified in the instance config object.
     *
     * @param {*} newValue In the case of derived classes, this is the config value of the derived class. In the case
     * of the instance config, this is the instance config value.
     * @param {*} currentValue In the case of derived classes, this is the config value of the super class. In the case
     * of the instance config, this is the class config value.
     * @param {Object} meta The class meta object from which the `newValue` is coming. This parameter is `null` if the
     * `newValue` is from an instance configuration.
     * @returns {*}
     * @internal
     */

  }, {
    key: "merge",
    value: function merge(newValue, currentValue) {
      if (currentValue && newValue && _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].isObject(currentValue) && _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].isObject(newValue)) {
        newValue = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].merge(_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_22__["default"].clone(currentValue), newValue);
      }

      return newValue;
    }
  }, {
    key: "descriptor",
    get: function get() {
      var descriptor = this._descriptor;

      if (!descriptor || !hasOwnProperty.call(this, '_descriptor')) {
        // lazily make the descriptor
        this._descriptor = descriptor = this.makeDescriptor();
      }

      return descriptor;
    }
    /**
     * The descriptor to use with `Reflect.defineProperty()` for defining this config's initter.
     * @property {Object}
     * @private
     */

  }, {
    key: "initDescriptor",
    get: function get() {
      var descriptor = this._initDescriptor;

      if (!descriptor || !hasOwnProperty.call(this, '_initDescriptor')) {
        // lazily make the descriptor
        this._initDescriptor = descriptor = this.makeInitter();
      }

      return descriptor;
    }
  }], [{
    key: "makeArrayEquals",
    value: function makeArrayEquals(fn) {
      return function (value1, value2) {
        var i,
            equal = value1 && value2 && value1.length === (i = value2.length);

        if (equal && Array.isArray(value1) && Array.isArray(value2)) {
          if (fn) {
            while (equal && i-- > 0) {
              equal = fn(value1[i], value2[i]);
            }
          } else {
            while (equal && i-- > 0) {
              equal = value1[i] === value2[i];
            }
          }
        } else {
          equal = fn ? fn(value1, value2) : value1 === value2;
        }

        return equal;
      };
    }
    /**
     * Returns the key to use in the Config `cache`.
     * @param {String} name The name of the config property.
     * @param {Object} options The config property options.
     * @returns {String}
     * @private
     */

  }, {
    key: "makeCacheKey",
    value: function makeCacheKey(name, options) {
      var keys = Object.keys(options).sort();

      for (var key, type, value, i = keys.length; i-- > 0;)
      /* empty */
      {
        value = options[key = keys[i]];

        if (value == null && value === false) {
          keys.splice(i, 1);
        } else {
          type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_19___default()(value);

          if (type === 'function') {
            return null;
          }

          if (type === 'string') {
            keys[i] = "".concat(key, ":\"").concat(value, "\"");
          } else if (type === 'number') {
            keys[i] = "".concat(key, ":").concat(value);
          } // that leaves bool and object, but there are no (valid) config options that are objects... so ignore

        }
      }

      return keys.length ? "".concat(name, ">").concat(keys.join('|')) : name; // eg: 'text>render|merge:v => v|bar'
    }
  }]);

  return Config;
}();


var prototype = Config.prototype,
    equal = prototype.equal;
Config.symbols = {
  configuring: configuringSymbol,
  instanceProperties: instancePropertiesSymbol
};
/**
 * This object holds `Config` instances keyed by their name. For example:
 * ```
 *  Config.cache = {
 *      disabled : Config.get('disabled'),
 *      text     : Config.get('text'),
 *      title    : Config.get('title')
 *  };
 * ```
 * @member {Object} cache
 * @static
 * @private
 */

Config.cache = Object.create(null); // object w/no properties not even inherited ones

/**
 * This object holds config value equality methods. By default, the `===` operator is used to compare config values for
 * semantic equality. When an `equal` option is specified as a string, that string is used as a key into this object.
 *
 * All equality methods in this object have the same signature as the {@link #function-equal equal()} method.
 *
 * This object has the following merge methods:
 *
 * - `array` : Compares arrays of values using `===` on each element.
 * - `date` : Compares values of `Date` type.
 * - `strict` : The default equal algorithm based on `===` operator.
 * @member {Object} equalityMethods
 * @static
 * @private
 */

Config.equalityMethods = {
  array: Config.makeArrayEquals(),
  date: function date(value1, value2) {
    if (value1 === value2) {
      return true;
    } // see DateHelper.isDate() but cannot import due to circularity


    if (value1 && value2 && toString.call(value1) === DATE_TYPE && toString.call(value2) === DATE_TYPE) {
      // https://jsbench.me/ltkb3vk0ji/1 - getTime is >2x faster vs valueOf/Number/op+
      return value1.getTime() === value2.getTime();
    }

    return false;
  },
  strict: Config.equal = equal
};
/**
 * This object holds config value merge methods. By default, {@link Core.helper.ObjectHelper#function-merge-static} is
 * used to merge object's by their properties. Config merge methods are used to combine config values from derived
 * classes with config values from super classes, as well as instance config values with those of the class.
 *
 * All merge methods in this object have the same signature as the {@link #function-merge merge()} method.
 *
 * This object has the following merge methods:
 *
 * - `distinct` : Combines arrays of values ensuring that no value is duplicated.
 * - `merge` : The default merge algorithm for `configurable()` properties, based on
 *   {@link Core.helper.ObjectHelper#function-merge-static}.
 * - `objects` : The same as to `merge` except this method promotes `true` to an empty object.
 * - `replace` : Always returns `newValue` to replace the super class value with the derived class value, or the
 *   class value with the instance value.
 * @member {Object} mergeMethods
 * @static
 * @private
 */

Config.mergeMethods = {
  distinct: function distinct(newValue, oldValue) {
    var ret = oldValue ? oldValue.slice() : [];

    if (newValue != null) {
      (Array.isArray(newValue) ? newValue : [newValue]).forEach(function (v) {
        return !ret.includes(v) && ret.push(v);
      });
    }

    return ret;
  },
  merge: Config.merge = prototype.merge,
  objects: function objects(newValue, oldValue) {
    return newValue === true ? oldValue || {} : Config.merge(newValue, oldValue);
  },
  replace: function replace(newValue) {
    return newValue;
  }
};
Object.assign(prototype, {
  _descriptor: null,
  _initDescriptor: null,

  /**
   * A function that compares values for equality. This test is used to determine if the `update` method should be
   * called when the setter is invoked.
   *
   * To handle `Date` values:
   * ```
   *  class Foo extends Base {
   *      static get configurable() {
   *          return {
   *              date : {
   *                  $config : {
   *                      equal : 'date'
   *                  },
   *
   *                  value : null
   *              }
   *          }
   *      }
   *
   *      updateDate(date) {
   *          // date has changed
   *      }
   *  }
   * ```
   *
   * Also useful for some configs:
   * ```
   *  class Foo extends Base {
   *      static get configurable() {
   *          return {
   *              bar : {
   *                  $config : {
   *                      equal : ObjectHelper.isEqual
   *                  },
   *
   *                  value : null
   *              }
   *          }
   *      }
   *
   *      updateBar(value) {
   *          // value has changed
   *      }
   *  }
   * ```
   * @config {Function} equal
   * @internal
   */

  /**
   * Indicates that this config property should not automatically initialize during construction, but instead should
   * wait for the first explicit use of the property getter.
   * @config {Boolean}
   * @default
   * @internal
   */
  lazy: false,

  /**
   * Indicates that this config property should automatically be set to `null` on destroy.
   * @config {Boolean}
   * @default
   * @internal
   */
  nullify: false,

  /**
   * Indicates that this config participates in rendering. This has does not affect the behavior of the property
   * directly, but allows classes that perform rendering to detect which config changes will affect the rendered
   * result.
   * @config {Boolean}
   * @default
   * @internal
   */
  render: false // TODO FUTURES
  // clear   (bool - set to null during cleanup)
  // destroy (bool - destroy value during cleanup)
  // evented (bool - fire event on change / after updater)

});
Config._$name = 'Config';

/***/ }),

/***/ "./lib/Core/GlobalEvents.js":
/*!**********************************!*\
  !*** ./lib/Core/GlobalEvents.js ***!
  \**********************************/
/*! exports provided: default, setupFocusListeners */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setupFocusListeners", function() { return setupFocusListeners; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/GlobalEvents
 */

var GlobalEvents = (window.bryntum || (window.bryntum = {})).GlobalEvents = new ( /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(_class, _Base$mixin);

  var _super = _createSuper(_class);

  function _class() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, _class);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(_class, [{
    key: "suspendFocusEvents",
    value: function suspendFocusEvents() {
      focusEventsSuspended = true;
    }
  }, {
    key: "resumeFocusEvents",
    value: function resumeFocusEvents() {
      focusEventsSuspended = false;
    }
  }, {
    key: "lastInteractionType",
    get: function get() {
      return lastInteractionType;
    }
  }]);

  return _class;
}(_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_9__["default"])))(),
    isTopVisibleModal = function isTopVisibleModal(w) {
  return w.isVisible && w.isTopModal;
};
/**
 * Fired after the theme is changed
 * @event theme
 * @param {GlobalEvents} source
 * @param {String} theme The new theme name
 */


var globaltouchStart,
    focusEventsSuspended = false,
    lastInteractionType,
    detacher;

function createWidgetEvent(eventName, target, relatedTarget, fromWidget, toWidget, backwards, options) {
  var result = new CustomEvent(eventName, options); // Workaround for Salesforce. They use strict mode and define non-configurable property `target`. We use this
  // CustomEvent as a syntetic one, feels fine to use non-standard handle for target.

  Object.defineProperty(result, '_target', {
    get: function get() {
      return target;
    }
  });
  Object.defineProperty(result, 'relatedTarget', {
    get: function get() {
      return relatedTarget;
    }
  });
  result.fromWidget = fromWidget;
  result.toWidget = toWidget;
  result.backwards = backwards;
  return result;
}

function getCommonAncestor(from, to) {
  return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getCommonAncestor(from, to);
} // This is imported by EventHelper and that makes the call to set up the listeners
// `detach` argument is required to not setup more listeners than we need to. In case of salesforce we include floatroot
// inside the webcomponent element and thus don't need default listeners on document. In regular webcomponents demo we
// don't need to do it, because with multiple components on one page that would force us to make more complex lookups.


function setupFocusListeners() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var EventHelper = arguments.length > 1 ? arguments[1] : undefined;
  var detach = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var listeners = {
    element: element,
    touchstart: function touchstart(_touchstart) {
      if (!globaltouchStart && _touchstart.changedTouches.length === 1) {
        globaltouchStart = _touchstart.changedTouches[0];
      } else {
        globaltouchStart = null;
      }
    },
    // Just this one has to be passive: false so that we are allowed to preventDefault
    // if we are part of a contextmenu longpres emulation. Otherwise the gesture will
    // proceed to cause a mousedown event.
    touchend: {
      handler: function handler(event) {
        if (globaltouchStart) {
          // If the touchstart was used to synthesize a contextmenu event
          // stop the touch gesture processing right now.
          // Also prevent the conversion of the touch into  click.
          if (globaltouchStart.identifier === EventHelper.contextMenuTouchId) {
            event.stopImmediatePropagation();
            event.preventDefault();
          } else if (event.changedTouches.length === 1 && event.changedTouches[0].identifier === globaltouchStart.identifier) {
            GlobalEvents.trigger('globaltap', {
              event: event
            });
          }

          globaltouchStart = null;
        }
      },
      passive: false
    },
    mousedown: {
      handler: function handler(event) {
        lastInteractionType = 'mouse';

        if (!globaltouchStart) {
          GlobalEvents.trigger('globaltap', {
            event: event
          });
        }
      },
      passive: false
    },
    keydown: function keydown() {
      lastInteractionType = 'key';
    },
    keypress: function keypress() {
      lastInteractionType = 'key';
    },
    focusin: function focusin(_focusin) {
      // https://app.assembla.com/spaces/bryntum/tickets/5503
      // Caused by the browser scrolling a focused element into view. The browser will do *whatever it takes*
      // to scroll a focused element so that as much of it is in view as possible. Its first point of scrolling will
      // be the float containing element. That must never scroll.
      GlobalEvents.Widget.floatRoot.scrollTop = GlobalEvents.Widget.floatRoot.scrollLeft = 0;

      if (focusEventsSuspended) {
        return;
      }

      var fromElement = !_focusin.relatedTarget ? null : _focusin.relatedTarget instanceof HTMLElement ? _focusin.relatedTarget : document.body,
          toElement = _focusin.target || document.body,
          fromWidget = GlobalEvents.Widget.fromElement(fromElement),
          toWidget = GlobalEvents.Widget.fromElement(toElement),
          commonAncestor = getCommonAncestor(fromWidget, toWidget),
          // Flag if the fromElement is DOCUMENT_POSITION_FOLLOWING toElement
      backwards = !!(fromElement && toElement.compareDocumentPosition(fromElement) & 4),
          topVisibleModal = GlobalEvents.Widget.query(isTopVisibleModal),
          currentFocus = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].activeElement; // If there is a topmost modal, and the focus is moving to somewhere *not* a descendant of that
      // modal then we enforce modality and sweep focus back into the modal. By default the Container
      // class will yield the first focusable descendant widget's focusEl as its focusEl, so
      // that will be out of the box behaviour for Popups.

      if (topVisibleModal && (!toWidget || !topVisibleModal.owns(toWidget))) {
        topVisibleModal.focus();
        return;
      }

      var event = createWidgetEvent('focusout', fromElement, _focusin.target, fromWidget, toWidget, backwards); // Bubble focusout event up the "from" side of the tree

      for (var target = fromWidget; target && target !== commonAncestor; target = target.owner) {
        if (!target.isDestroying && target.onFocusOut) {
          target.onFocusOut(event); // It is possible for focusout handlers to refocus themselves (editor's invalidAction='block'), so
          // check if the focus is still where it was when we started unless we are in a document
          // loss of focus situation (no target)

          if (_focusin.target && currentFocus !== _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].activeElement) {
            // If the focus has moved, that movement would have kicked off a nested sequence of focusin/out
            // notifications, so everyone has already been notified... no more to do here.
            return;
          }
        }
      } // Focus is moving upwards to the ancestor widget.
      // Its focus method might delegate focus to a focusable descendant.


      if (commonAncestor && _focusin.target === commonAncestor.element) {
        // If one of the handlers above has not moved focus onwards
        // and the common ancestor is a container which delegates
        // focus inwards to a descendant, then give it the opportunity to do that.
        if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].activeElement === toElement && commonAncestor.focusElement && commonAncestor.focusElement !== commonAncestor.element) {
          // Wait until out of the focusin handler to move focus on.
          commonAncestor.setTimeout(function () {
            return commonAncestor.focus && commonAncestor.focus();
          }, 0);
        }
      } // Focus is moving between two branches of a subtree.
      // Bubble focusin event up the "to" side of the tree
      else {
          event = createWidgetEvent('focusin', toElement, fromElement, fromWidget, toWidget, backwards);

          for (var _target = toWidget; _target && _target !== commonAncestor; _target = _target.owner) {
            if (!_target.isDestroying) {
              _target.onFocusIn && _target.onFocusIn(event);
            }
          }
        } // Fire element focusmove event. Grid navigation will use  this when cells are focusable.


      var commonAncestorEl = getCommonAncestor(fromElement && fromElement.nodeType === 1 ? fromElement : null, toElement) || toElement.parentNode;
      event = createWidgetEvent('focusmove', toElement, fromElement, fromWidget, toWidget, backwards, {
        bubbles: true
      });
      commonAncestorEl.dispatchEvent(event);
    },
    focusout: function focusout(_focusout) {
      if (focusEventsSuspended) {
        return;
      }

      if (!_focusout.relatedTarget || !GlobalEvents.Widget.fromElement(_focusout.relatedTarget)) {
        // When switching between tabs in Salesforce app `relatedTarget` of the focusout event might be not an instance of
        // HTMLElement.
        var target = _focusout.relatedTarget && _focusout.relatedTarget instanceof HTMLElement ? _focusout.relatedTarget : null;
        listeners.focusin({
          target: target,
          relatedTarget: _focusout.target
        });
      }
    },
    capture: true,
    passive: true
  }; // detach previous listeners

  if (detach && detacher) {
    detacher();
  }

  detacher = EventHelper.on(listeners);
}
/**
 * A singleton firing global application level events like 'theme'.
 * It is automatically exposed to `window` as `bryntum.GlobalEvents`:
 *
 * ```javascript
 * window.bryntum.GlobalEvents.on({
 *    theme() {
 *        // react to theme changes here
 *    }
 * });
 * ```
 *
 * @class
 * @singleton
 * @mixes Core/mixin/Events
 */


/* harmony default export */ __webpack_exports__["default"] = (GlobalEvents);


/***/ }),

/***/ "./lib/Core/data/AjaxStore.js":
/*!************************************!*\
  !*** ./lib/Core/data/AjaxStore.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AjaxStore; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");




































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/data/AjaxStore
 */

var processParamEntry = function processParamEntry(paramArray, entry) {
  if (Array.isArray(entry[1])) {
    entry[1].forEach(function (value) {
      return paramArray.push(encodeURIComponent(entry[0]) + '=' + encodeURIComponent(value));
    });
  } else {
    paramArray.push(encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]));
  }

  return paramArray;
},
    immediatePromise = Promise.resolve();
/**
 * Store that uses the Fetch API to read data from a remote server, and optionally sends synchronization
 * requests to the server containing information about locally created, modified and deleted records.
 *
 * ## Create
 * Posts array of JSON data for newly added records to {@link #config-createUrl}, expects response containing an array of JSON objects
 * in same order with id set (uses Model#idField as id).
 *
 * ## Read
 * Reads array of JSON data from the data packet returned from the {@link #config-readUrl}. Unique id for each row is required.
 * By default looks in field 'id' but can be configured by setting {@link Core.data.Model#property-idField-static}.
 *
 * ## Update
 * Posts array of JSON data for newly modified records to {@link #config-updateUrl}.
 *
 * ## Delete
 * Posts to {@link #config-deleteUrl} with removed records ids (for example id=1,4,7).
 *
 * ```javascript
 * new AjaxStore({
 *   createUrl  : 'php/create',
 *   readUrl    : 'php/read',
 *   updateUrl  : 'php/update',
 *   deleteUrl  : 'php/delete',
 *   modelClass : Customer
 * });
 * ```
 *
 * ## Pagination
 * Configuring an `AjaxStore` with {@link #config-pageParamName} or {@link #config-pageStartParamName} means that the store requests **pages**
 * of data from the remote source, sending the configured {@link #config-pageParamName} or {@link #config-pageStartParamName} to request the page
 * along with the {@link #config-pageSizeParamName}.
 *
 * If `pageParamName` is set, that is passed with the requested page number **(one based)**, along with the {@link #config-pageSizeParamName}.
 *
 * If `pageStartParamName` is set, that is passed with the requested page starting record index **(zero based)**, along with the {@link #config-pageSizeParamName}.
 *
 * ## Remote filtering
 * To specify that filtering is the responsibility of the server, configure the store with
 * `{@link #config-filterParamName}: 'nameOfFilterParameter'`
 *
 * When this is set, any {@link Core.data.mixin.StoreFilter#function-filter} operation causes the store to
 * reload itself, encoding the filters as JSON representations in the {@link #config-filterParamName} HTTP
 * parameter.
 *
 * The filters will look like this:
 * ```javascript
 * {
 *     "field": "country",
 *     "operator": "=",
 *     "value": "sweden",
 *     "caseSensitive": false
 * }
 * ```
 *
 * The encoding may be overridden by configuring an implementation of {@link #function-encodeFilterParams}
 * into the store which returns the value for the {@link #config-filterParamName} when passed an _Iterable_ of filters.
 *
 * ## Remote sorting
 * To specify that sorting is the responsibility of the server, configure the store with
 * `{@link #config-sortParamName}: 'nameOfSortParameter'`
 *
 * When this is set, any {@link Core.data.mixin.StoreSort#function-sort} operation causes the store to
 * reload itself, encoding the sorters as JSON representations in the {@link #config-sortParamName} HTTP
 * parameter.
 *
 * The sorters will look like this:
 * ```javascript
 * {
 *     "field": "name",
 *     "ascending": true
 * }
 * ```
 *
 * The encoding may be overridden by configuring an implementation of {@link #function-encodeSorterParams}
 * into the store which returns the value for the {@link #config-sortParamName} when passed an _Iterable_ of sorters.
 *
 * @extends Core/data/Store
 */


var AjaxStore = /*#__PURE__*/function (_Store) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default()(AjaxStore, _Store);

  var _super = _createSuper(AjaxStore);

  function AjaxStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29___default()(this, AjaxStore);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_30___default()(AjaxStore, [{
    key: "afterConstruct",

    /**
     * Url to post newly created records to.
     *
     * The response must be in the form:
     *
     *     {
     *         "success": true,
     *         "data": [{
     *             "id": 0, "name": "General Motors"
     *         }, {
     *             "id": 1, "name": "Apple"
     *         }]
     *     }
     *
     * Just the array of data may be returned, however that precludes the
     * orderly handling of errors encountered at the server.
     *
     * If the server encountered an error, the packet would look like this:
     *
     *     {
     *         "success": false,
     *         "message": "Some kind of database error"
     *     }
     *
     * And that packet would be available in the {@link #event-exception} handler
     * in the `response` property of the event.
     *
     * The `success` property may be omitted, it defaults to `true`.
     *
     * @config {String} createUrl
     * @category CRUD
     */

    /**
     * Url to read data from.
     *
     * The response must be in the form:
     *
     *     {
     *         "success": true,
     *         "data": [{
     *             "id": 0, "name": "General Motors"
     *         }, {
     *             "id": 1, "name": "Apple"
     *         }]
     *     }
     *
     * If the store {@link #property-isPaged is paged}, the total dataset size must be returned
     * in the {@link #config-responseTotalProperty} property:
     *
     *     {
     *         "success": true,
     *         "data": [{
     *             "id": 0, "name": "General Motors"
     *         }, {
     *             "id": 1, "name": "Apple"
     *         }],
     *         "total": 65535
     *     }
     *
     * Just the array of data may be returned, however that precludes the
     * orderly handling of errors encountered at the server.
     *
     * If the server encountered an error, the packet would look like this:
     *
     *     {
     *         "success": false,
     *         "message": "Some kind of database error"
     *     }
     *
     * And that packet would be available in the {@link #event-exception} handler
     * in the `response` property of the event.
     *
     * The `success` property may be omitted, it defaults to `true`.
     *
     * @config {String} readUrl
     * @category CRUD
     */

    /**
     * Url to post record modifications to.
     *
     * The response must be in the form:
     *
     *     {
     *         "success": true,
     *         "data": [{
     *             "id": 0, "name": "General Motors"
     *         }, {
     *             "id": 1, "name": "Apple"
     *         }]
     *     }
     *
     * Just the array of data may be returned, however that precludes the
     * orderly handling of errors encountered at the server.
     *
     * If the server encountered an error, the packet would look like this:
     *
     *     {
     *         "success": false,
     *         "message": "Some kind of database error"
     *     }
     *
     * And that packet would be available in the {@link #event-exception} handler
     * in the `response` property of the event.
     *
     * The `success` property may be omitted, it defaults to `true`.
     *
     * @config {String} updateUrl
     * @category CRUD
     */

    /**
     * Url for deleting records.
     *
     * The response must be in the form:
     *
     *     {
     *         "success": true
     *     }
     *
     * If the server encountered an error, the packet would look like this:
     *
     *     {
     *         "success": false,
     *         "message": "Some kind of database error"
     *     }
     *
     * And that packet would be available in the {@link #event-exception} handler
     * in the `response` property of the event.
     *
     * The `success` property may be omitted, it defaults to `true`.
     *
     * @config {String} deleteUrl
     * @category CRUD
     */

    /**
     * True to initiate a load when the store is instantiated
     * @config {Boolean} autoLoad
     * @category Common
     */
    //endregion
    value: function afterConstruct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_31___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(AjaxStore.prototype), "afterConstruct", this).call(this, config);

      if (this.autoLoad) {
        this.load().catch(function () {});
      }
    }
    /**
     * Returns true if the Store is currently loading
     * @property {Boolean}
     * @readonly
     * @category CRUD
     */

  }, {
    key: "buildQueryString",
    value: function buildQueryString() {
      for (var _len = arguments.length, paramObjects = new Array(_len), _key = 0; _key < _len; _key++) {
        paramObjects[_key] = arguments[_key];
      }

      var queryString = Object.entries(Object.assign.apply(Object, [{}].concat(paramObjects))).reduce(processParamEntry, []).join('&');
      return queryString ? '?' + queryString : '';
    }
  }, {
    key: "performSort",
    value: function performSort(silent) {
      var me = this;

      if (me.sortParamName) {
        var groupRecords = me.groupRecords,
            collapsed = {}; // Temporarily remove group headers, will be re-added after sort

        if (me.isGrouped && groupRecords && groupRecords.length) {
          groupRecords.forEach(function (r) {
            if (r.meta.collapsed) {
              me.includeGroupRecords(r);
              collapsed[r.id] = true;
            }
          });
        } // TODO: Should we cache lastParams from the load call and use them here?


        return me.internalLoad({}, '', function (event) {
          me.data = event.data;
          me.afterPerformSort(silent, collapsed);
        });
      } else {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_31___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(AjaxStore.prototype), "performSort", this).call(this, silent);
      }
    }
  }, {
    key: "performFilter",
    value: function performFilter(silent) {
      var me = this; // For remote filtering, the dataset cannot be preserved. The size may be completely different.
      // This is a reload operation.

      if (me.remoteFilter) {
        var oldCount = me.count,
            filters = me.filters; // load should default to page 1

        me.currentPage = 1; // TODO: Should we cache lastParams from the load call and use them here?

        return me.internalLoad({}, '', function (event) {
          me.data = event.data;
          me.afterPerformFilter(silent ? null : {
            action: 'filter',
            filters: filters,
            oldCount: oldCount,
            records: me.storage.values
          });
        });
      } else {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_31___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(AjaxStore.prototype), "performFilter", this).call(this, silent);
      }
    }
    /**
     * A provided function which creates an array of values for the {#config-filterParamName} to pass
     * any filters to the server upon load.
     *
     * By default, this creates a JSON string containing the following properties:
     *
     * ```javascript
     *    [{
     *        field         : <theFieldName>
     *        operator      : May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`
     *        value         : The value to compare
     *        caseSensitive : true for case sensitive comparisons
     *    }]
     * ```
     * @param {Core.util.CollectionFilter[]} filters The filters to encode.
     */

  }, {
    key: "encodeFilterParams",
    value: function encodeFilterParams(filters) {
      var result = [];

      var _iterator = _createForOfIteratorHelper(filters),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _step.value,
              property = _step$value.property,
              operator = _step$value.operator,
              value = _step$value.value,
              caseSensitive = _step$value.caseSensitive;
          result.push({
            field: property,
            operator: operator,
            value: value,
            caseSensitive: caseSensitive
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return JSON.stringify(result);
    }
    /**
     * A provided function which creates an array of values for the {#config-sortParamName} to pass
     * any sorters to the server upon load.
     *
     * By default, this creates a JSON string containing the following properties:
     *
     * ```javascript
     *    [{
     *        field     : <theFieldName>
     *        ascending : true/false
     *    }]
     * ```
     *
     * @param {Object[]} sorters The sorters to encode.
     */

  }, {
    key: "encodeSorterParams",
    value: function encodeSorterParams(sorters) {
      return JSON.stringify(sorters.filter(function (sorter) {
        return !sorter.sortFn;
      }).map(function (sorter) {
        return sorter;
      }));
    }
  }, {
    key: "buildReadUrl",
    value: function buildReadUrl() {
      var readUrl = this.readUrl;

      if (this.restfulFilter) {
        var url = readUrl.endsWith('/') ? readUrl : readUrl + '/';
        return url + this.filters.first.value;
      } else {
        return readUrl;
      }
    }
  }, {
    key: "internalLoad",
    value: function internalLoad(params, eventName, successFn) {
      var me = this,
          allParams = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].assign({}, me.params, params),
          url = me.buildReadUrl(),
          event = {
        action: 'read' + eventName,
        params: allParams,
        url: url
      };
      return url ? new Promise(function (resolve, reject) {
        if (me.trigger('beforeLoad' + eventName, event) === false) {
          return reject(false); // eslint-disable-line
        }

        me._isLoading = true; // This may look redundant, but it allows for two levels of event listening.
        // Granular, where the observer observes only the events of interest, and
        // catch-all, where the observer is interested in all requests.

        me.trigger("load".concat(eventName, "Start"), event);
        me.trigger('beforeRequest', event); // Add filter information to the request parameters

        if (me.filterParamName && me.isFiltered) {
          allParams[me.filterParamName] = me.encodeFilterParams(me.filters.values);
        } // Add sorter information to the request parameters.
        // isSorted includes grouping in its evaluation.


        if (me.sortParamName && me.isSorted) {
          allParams[me.sortParamName] = me.encodeSorterParams(me.groupers ? me.groupers.concat(me.sorters) : me.sorters);
        } // Ensure our next page is passed to the server in the params if not already set.
        // Ensure our page size is always passed.


        if (me.isPaged) {
          if (!(allParams[me.pageParamName] || allParams[me.pageStartParamName])) {
            var page = Math.min(me.currentPage || 1, me.allCount ? me.lastPage : Infinity);

            if (me.pageParamName) {
              allParams[me.pageParamName] = page;
            } else {
              allParams[me.pageStartParamName] = (page - 1) * me.pageSize;
            }
          }

          allParams[me.pageSizeParamName] = me.pageSize;
        }

        var options = {
          headers: me.headers,
          parseJson: true
        };

        if (me.useRestfulMethods) {
          options.method = me.httpMethods.read;
        }

        _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].get(event.url + me.buildQueryString(allParams), _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].assign(options, me.fetchOptions)).then( /*#__PURE__*/function () {
          var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.mark(function _callee(response) {
            var data, isArray, success, remoteTotal, requestedPage;
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    data = response.parsedJson, isArray = Array.isArray(data), success = isArray || data && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getPath(data, me.responseSuccessProperty) !== false, remoteTotal = isArray ? null : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getPath(data, me.responseTotalProperty);
                    me._isLoading = false;
                    event.response = response;
                    event.json = data;

                    if (!success) {
                      _context.next = 20;
                      break;
                    }

                    if (remoteTotal != null) {
                      me.remoteTotal = parseInt(remoteTotal, 10);
                    } // If we are issuing paged requests, work out what page we are on based
                    // on the requested page and the size of the dataset declared.


                    if (!me.isPaged) {
                      _context.next = 13;
                      break;
                    }

                    if (!(me.remoteTotal >= 0)) {
                      _context.next = 12;
                      break;
                    }

                    requestedPage = me.pageParamName ? allParams[me.pageParamName] : allParams[me.pageStartParamName] / me.pageSize + 1;
                    me.currentPage = Math.min(requestedPage, me.lastPage);
                    _context.next = 13;
                    break;

                  case 12:
                    throw new Error('A paged store must receive its responseTotalProperty in each data packet');

                  case 13:
                    event.data = isArray ? data : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getPath(data, me.responseDataProperty);
                    _context.next = 16;
                    return successFn(event);

                  case 16:
                    me.trigger('load' + eventName, event);
                    resolve(event);
                    _context.next = 24;
                    break;

                  case 20:
                    event.exception = true;
                    event.exceptionType = 'server';
                    me.trigger('exception', event);
                    reject(event);

                  case 24:
                    // finally
                    me.trigger('afterRequest', event);

                  case 25:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (responseOrError) {
          me._isLoading = false;
          event.exception = true;

          if (responseOrError instanceof Response) {
            event.exceptionType = responseOrError.ok ? 'server' : 'network';
            event.response = responseOrError;
            event.error = responseOrError.error;
          } else {
            event.exceptionType = 'server';
            event.error = responseOrError;
          }

          me.trigger('exception', event);
          reject(event); // finally

          me.trigger('afterRequest', event);
        });
      }) : null;
    }
    /**
     * Load data from the {@link #config-readUrl}.
     * @param {Object} params A hash of parameters to append to querystring (will also append Store#params)
     * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
     * vetoed by a {@link #event-beforeLoad} handler, or if an {@link #event-exception} is detected.
     * The resolved function is passed the event object passed to any event handlers.
     * The rejected function is passed the {@link #event-exception} event if an exception occurred,
     * or `false` if the load was vetoed by a {@link #event-beforeLoad} handler.
     * @fires beforeLoad
     * @fires loadStart
     * @fires beforeRequest
     * @fires load
     * @fires exception
     * @fires afterRequest
     * @category CRUD
     * @async
     * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
     */

  }, {
    key: "load",
    value: function () {
      var _load = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.mark(function _callee2(params) {
        var me;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                me = this;

                if (!me.isPaged) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", me.loadPage((me.currentPage || 0) + 1, params));

              case 5:
                return _context2.abrupt("return", me.internalLoad(params, '', function (event) {
                  // The set Data setter will trigger the refresh event with { action: 'dataset' }
                  me.data = event.data;
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function load(_x2) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
    /**
     * Loads children into specified parent record. Parent records id is sent as a param (param name configured with
     * {@link #config-parentIdParamName}.
     * @param {Core.data.Model} parentRecord Parent record
     * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
     * vetoed by a {@link #event-beforeLoadChildren} handler, or if an {@link #event-exception} is detected.
     * The resolved function is passed the event object passed to any event handlers.
     * The rejected function is passed the {@link #event-exception} event if an exception occurred,
     * or `false` if the load was vetoed by a {@link #event-beforeLoadChildren} handler.
     * @fires beforeLoadChildren
     * @fires loadChildrenStart
     * @fires beforeRequest
     * @fires loadChildren
     * @fires exception
     * @fires afterRequest
     * @category CRUD
     * @async
     * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
     */

  }, {
    key: "loadChildren",
    value: function () {
      var _loadChildren = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.mark(function _callee3(parentRecord) {
        var me;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                me = this;
                return _context3.abrupt("return", me.internalLoad(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default()({}, me.parentIdParamName, parentRecord.id), 'Children', function (event) {
                  event.parentRecord = parentRecord; // Append received children

                  parentRecord.data[parentRecord.constructor.childrenField] = event.data;
                  parentRecord.processChildren(parentRecord.stores);
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadChildren(_x3) {
        return _loadChildren.apply(this, arguments);
      }

      return loadChildren;
    }()
    /**
     * Loads a page of data from the {@link #config-readUrl}.
     * @param {Number} page The *one based* page number to load.
     * @param {Object} params A hash of parameters to append to querystring (will also append Store#params)
     * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
     * vetoed by a {@link #event-beforeLoadPage} handler, or if an {@link #event-exception} is detected.
     * The resolved function is passed the event object passed to any event handlers.
     * The rejected function is passed the {@link #event-exception} event if an exception occurred,
     * or `false` if the load was vetoed by a {@link #event-beforeLoadPage} handler.
     * @fires beforeLoadPage
     * @fires loadPageStart
     * @fires beforeRequest
     * @fires loadPage
     * @fires exception
     * @fires afterRequest
     * @category CRUD
     * @async
     * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
     */

  }, {
    key: "loadPage",
    value: function () {
      var _loadPage = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.mark(function _callee4(page, params) {
        var me, pageParam;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.allCount) {
                  page = Math.min(page, this.lastPage);
                }

                me = this, pageParam = me.pageParamName ? _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default()({}, me.pageParamName, page) : _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default()({}, me.pageStartParamName, (page - 1) * me.pageSize);
                pageParam[me.pageSizeParamName] = me.pageSize;
                return _context4.abrupt("return", me.internalLoad(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].assign(pageParam, params), 'Page', function (event) {
                  // We go directly to loadPage because paging a tree store is unsupportable.
                  // loadPage will trigger the refresh event with { action: 'pageLoad' }
                  me.loadData(event.data, 'pageLoad');
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadPage(_x4, _x5) {
        return _loadPage.apply(this, arguments);
      }

      return loadPage;
    }()
    /**
     * If this store {@link #property-isPaged is paged}, and is not already at the {@link #property-lastPage}
     * then this will load the next page of data.
     * @fires beforeLoadPage
     * @fires loadPageStart
     * @fires beforeRequest
     * @fires loadPage
     * @fires exception
     * @fires afterRequest
     * @category CRUD
     * @async
     * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
     */

  }, {
    key: "nextPage",
    value: function () {
      var _nextPage = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.mark(function _callee5(params) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.isPaged && this.currentPage !== this.lastPage ? this.loadPage(this.currentPage + 1, params) : immediatePromise);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function nextPage(_x6) {
        return _nextPage.apply(this, arguments);
      }

      return nextPage;
    }()
    /**
     * If this store {@link #property-isPaged is paged}, and is not already at the first page
     * then this will load the previous page of data.
     * @fires beforeLoadPage
     * @fires loadPageStart
     * @fires beforeRequest
     * @fires loadPage
     * @fires exception
     * @fires afterRequest
     * @category CRUD
     * @async
     * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
     */

  }, {
    key: "previousPage",
    value: function () {
      var _previousPage = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.mark(function _callee6(params) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.isPaged && this.currentPage !== 1 ? this.loadPage(this.currentPage - 1, params) : immediatePromise);

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function previousPage(_x7) {
        return _previousPage.apply(this, arguments);
      }

      return previousPage;
    }()
    /**
     * Commits all changes (added, modified and removed) using corresponding urls ({@link #config-createUrl},
     * {@link #config-updateUrl} and {@link #config-deleteUrl})
     * @fires beforeCommit
     * @returns {Promise} A Promise which is resolved only if all pending changes (Create, Update and Delete) successfully resolve.
     * Both the resolve and reject functions are passed a `commitState` object which is stored the {@link #event-afterRequest}
     * event for each request. Each event contains the `exception`, `request` and `response` properties eg:
     *
     *     {
     *          success: true,                  // If *all* commits succeeded
     *          changes: {
     *              added: [records...],
     *              modified: [records...],
     *              removed: [records...],
     *          },
     *          added: {
     *              source: theStore,
     *              exception: true,            // Only if the add request triggered an exception
     *              exceptionType: 'server'/'network', // Only if the add request triggered an exception
     *              response: Response,
     *              json: parsedResponseObject
     *          },
     *          modified: {},                   // Same format as added
     *          removed: {}                     // Same format as added
     *     }
     *
     * If there were no pending changes, the resolve and reject functions are passed no parameters.
     *
     * Returns `false` if a commit operation is already in progress.
     * The resolved function is passed the event object passed to any event handlers.
     * The rejected function is passed the {@link #event-exception} event if an exception occurred,
     * @category CRUD
     * @async
     * @returns {Promise} A promise which is resolved when all the Ajax requests complete and have been processed.
     */

  }, {
    key: "commit",
    value: function () {
      var _commit = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_28___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.mark(function _callee7() {
        var me, changes, allPromises, commitState, p;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_26___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                me = this, changes = me.changes, allPromises = []; // not allowing additional commits while in progress
                // TODO: should queue

                if (!me.commitPromise) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return", false);

              case 3:
                if (changes) {
                  _context7.next = 6;
                  break;
                }

                // Special handling of modified. If only non-persistable fields have been modified, it wont count among
                // `changes`, but still needs to be cleared
                if (me.modified.count) {
                  me.modified.forEach(function (record) {
                    return record.clearChanges(false);
                  });
                  me.modified.clear();
                }

                return _context7.abrupt("return", immediatePromise);

              case 6:
                // Flag all affected records as being committed
                [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24___default()(changes.added), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24___default()(changes.modified), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24___default()(changes.removed)).forEach(function (record) {
                  return record.meta.committing = true;
                });

                if (!(me.trigger('beforeCommit', {
                  changes: changes
                }) !== false)) {
                  _context7.next = 25;
                  break;
                }

                commitState = {
                  action: 'commit',
                  exception: false,
                  changes: changes
                };
                p = me.commitRemoved(commitState);

                if (p) {
                  allPromises.push(p);
                }

                p = me.commitAdded(commitState);

                if (p) {
                  allPromises.push(p);
                }

                p = me.commitModified(commitState);

                if (p) {
                  allPromises.push(p);
                } // If there were no urls configured, behave as a local store


                if (allPromises.length) {
                  _context7.next = 23;
                  break;
                }

                me.modified.forEach(function (r) {
                  return r.clearChanges(false);
                });
                me.modified.clear();
                me.added.forEach(function (r) {
                  return r.clearChanges(false);
                });
                me.added.clear();
                me.removed.clear();
                me.trigger('commit', {
                  changes: changes
                });
                return _context7.abrupt("return", immediatePromise);

              case 23:
                // The Promises from the commit methods all resolve whether the request
                // succeeded or not. They each contribute their afterrequest event to the
                // commitState which can be used to detect overall success or failure
                // and granular inspection of which operations succeeded or failed.
                // If there's only one operation, wait for it.
                // If there's more than one operation, we have to wait for allPromises to resolve.
                p = allPromises.length === 1 ? allPromises[0] : Promise.all(allPromises);
                return _context7.abrupt("return", me.commitPromise = new Promise(function (resolve, reject) {
                  p.then(function () {
                    me.commitPromise = null;

                    if (commitState.exception) {
                      me.trigger('exception', commitState);
                      reject(commitState);
                    } else {
                      me.trigger('commit', {
                        changes: changes
                      });
                      resolve(commitState);
                    }
                  }).catch(function () {
                    me.commitPromise = null;
                    reject(commitState);
                  });
                }));

              case 25:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function commit() {
        return _commit.apply(this, arguments);
      }

      return commit;
    }() // Performs background autocommit with reject checking

  }, {
    key: "doAutoCommit",
    value: function doAutoCommit() {
      if (this.suspendCount <= 0) {
        this.commit().catch(function (commitState) {
          var response = commitState.response; // Skip throw if response is `ok` or `status` is 500 or 404 and request is successfully parsed
          // These errors are notified by API events

          if (!(response && (response.ok && response.parsedJson || [500, 404].includes(response.status)))) {
            throw commitState;
          }
        });
      }
    } // TODO: need a way to abort commits

    /**
     * Commits added records by posting to {@link #config-createUrl}.
     * Server should return a JSON object with a 'success' property indicating whether the operation was succesful.
     * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
     * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
     * succeeds or fails. The resulting event is placed into the `add` property of the passed `commitState`
     * parameter. If there are no added records, `null` is returned.
     * The resolved function is passed the event object passed to any event handlers.
     * @private
     * @fires beforeRequest
     * @fires commitAdded
     * @fires refresh
     * @fires exception
     * @fires afterRequest
     * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
     * @async
     */

  }, {
    key: "commitAdded",
    value: function commitAdded(commitState) {
      var me = this,
          added = me.added,
          event = {
        action: 'create',
        params: me.params
      };
      return added.count && me.createUrl ? new Promise(function (resolve) {
        var toAdd = added.values.map(function (r) {
          return r.persistableData;
        });
        commitState.create = event;
        var dataToSend = event.body = {
          data: toAdd
        };
        me.trigger('beforeRequest', event);

        if (me.sendAsFormData) {
          var formData = new FormData();
          formData.append('data', JSON.stringify(toAdd));
          dataToSend = formData;
        }

        var options = {
          headers: me.headers,
          parseJson: true
        };

        if (me.useRestfulMethods) {
          options.method = me.httpMethods.create;
        }

        _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].post(me.createUrl + me.buildQueryString(me.params), dataToSend, _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].assign(options, me.fetchOptions)).then(function (response) {
          var data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && data.success !== false;
          commitState.response = response;
          event.json = data;
          event.response = response;

          if (success) {
            // Copy updated fields and updated ID back into records.
            // This also calls clearChanges on each record.
            me.processReturnedData(added.values, isArray ? data : data[me.responseDataProperty]); // Clear down added records cache

            added.clear();
            me.trigger('commitAdded'); // We must signal a full refresh because any number of records could have recieved any number of field updates
            // back from the server, so a refresh is more efficient than picking through the received updates.

            me.trigger('refresh', event);
            resolve(commitState);
          } else {
            // Clear committing flag
            added.forEach(function (r) {
              return r.meta.committing = false;
            });
            commitState.exception = event.exception = true;
            commitState.exceptionType = event.exceptionType = 'server';
            me.trigger('exception', event);
            resolve(commitState);
          } // finally


          me.trigger('afterRequest', event);
        }).catch(function (responseOrError) {
          // Clear committing flag
          added.forEach(function (r) {
            return r.meta.committing = false;
          });
          commitState.exception = event.exception = true;

          if (responseOrError instanceof Response) {
            commitState.response = responseOrError;
            event.exceptionType = responseOrError.ok ? 'server' : 'network';
            event.response = responseOrError;
            event.error = responseOrError.error;
          } else {
            event.exceptionType = 'server';
            event.error = responseOrError;
          }

          me.trigger('exception', event);
          resolve(commitState); // finally

          me.trigger('afterRequest', event);
        });
      }) : null;
    }
    /**
     * Commits modified records by posting to {@link #config-updateUrl}.
     * Server should return a JSON object with a 'success' property indicating whether the operation was succesful.
     * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
     * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
     * succeeds or fails. The resulting event is placed into the `update` property of the passed `commitState`
     * parameter. If there are no added records, `null` is returned.
     * The resolved function is passed the event object passed to any event handlers.
     * @private
     * @fires beforeRequest
     * @fires commitModified
     * @fires refresh
     * @fires exception
     * @fires afterRequest
     * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
     * @async
     */

  }, {
    key: "commitModified",
    value: function commitModified(commitState) {
      var me = this,
          modified = me.changes.modified,
          event = {
        action: 'update',
        params: me.params
      },
          result = modified.length && me.updateUrl ? new Promise(function (resolve) {
        // Use the record's modificationData, not modifications.
        // modifications returns a map using *field names*
        // The server will expect a map using the original dataSource properties.
        var modifications = modified.map(function (r) {
          return me.writeAllFields ? r.persistableData : r.modificationData;
        }).filter(function (el) {
          return !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].isEmpty(el);
        }); // Check if modifications are empty and don't make request

        if (modifications.length === 0) {
          me.modified.clear();
          modified.forEach(function (r) {
            return r.meta.committing = false;
          });
          resolve();
          return;
        }

        commitState.update = event;
        var dataToSend = event.body = {
          data: modifications
        };
        me.trigger('beforeRequest', event);

        if (me.sendAsFormData) {
          var formData = new FormData();
          formData.append('data', JSON.stringify(modifications));
          dataToSend = formData;
        }

        var options = {
          headers: me.headers,
          parseJson: true
        };

        if (me.useRestfulMethods) {
          options.method = me.httpMethods.update;
        }

        _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].post(me.updateUrl + me.buildQueryString(me.params), dataToSend, _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].assign(options, me.fetchOptions)).then(function (response) {
          var data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && data.success !== false;
          commitState.response = response;
          event.json = data;
          event.response = response;

          if (success) {
            // Copy updated fields and updated ID back into records.
            // This also calls clearChanges on each record.
            me.processReturnedData(modified, isArray ? data : data[me.responseDataProperty], true); // Clear down modified records cache

            me.modified.clear();
            me.trigger('commitModified'); // We must signal a full refresh because any number of records could have recieved any number of field updates
            // back from the server, so a refresh is more efficient than picking through the received updates.

            me.trigger('refresh', event);
            resolve(commitState);
          } else {
            // Clear committing flag
            modified.forEach(function (r) {
              return r.meta.committing = false;
            });
            commitState.exception = event.exception = true;
            event.exceptionType = 'server';
            me.trigger('exception', event);
            resolve(commitState);
          } // finally


          me.trigger('afterRequest', event);
        }).catch(function (responseOrError) {
          // Clear committing flag
          modified.forEach(function (r) {
            return r.meta.committing = false;
          });
          commitState.exception = event.exception = true;

          if (responseOrError instanceof Response) {
            commitState.response = responseOrError;
            event.exceptionType = responseOrError.ok ? 'server' : 'network';
            event.response = responseOrError;
            event.error = responseOrError.error;
          } else {
            event.exceptionType = 'server';
            event.error = responseOrError;
          }

          me.trigger('exception', event);
          resolve(commitState); // finally

          me.trigger('afterRequest', event);
        });
      }) : null; // Also clear non-persistable changes

      if (!modified.length && me.modified.count) {
        me.modified.clear();
      }

      return result;
    }
  }, {
    key: "processReturnedData",
    value: function processReturnedData(localRecords, returnedData) {
      var isUpdating = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          Model = me.modelClass,
          idDataSource = Model.fieldMap.id.dataSource;
      returnedData.forEach(function (recData, i) {
        var record = localRecords[i]; // Must clear changed state before syncId goes through store.onModelChange

        record.clearChanges(false); // Using syncId to update record's id with no flagging the property as modified.

        record.syncId(recData[idDataSource]); // When updating, only want to apply the actual changes and not reapply defaults. When adding, also
        // apply the defaults

        Object.assign(localRecords[i].data, Model.processData(recData, isUpdating));
      });
    }
    /**
     * Commits removed records by posting to {@link #config-deleteUrl}.
     * Server should return a JSON object with a 'success' property indicating whether the operation was successful.
     * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
     * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
     * succeeds or fails. The resulting event is placed into the `delete` property of the passed `commitState`
     * parameter. If there are no added records, `null` is returned.
     * The resolved function is passed the event object passed to any event handlers.
     * @private
     * @fires beforerequest
     * @fires commitremoved
     * @fires refresh
     * @fires exception
     * @fires afterrequest
     * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
     * @async
     */

  }, {
    key: "commitRemoved",
    value: function commitRemoved(commitState) {
      var me = this,
          removed = me.removed,
          event = {
        action: 'delete',
        params: me.params
      };
      return removed.count && me.deleteUrl ? new Promise(function (resolve) {
        commitState.delete = event;
        var dataToSend = event.body = {
          ids: removed.map(function (r) {
            return r.id;
          })
        };
        me.trigger('beforeRequest', event);

        if (me.sendAsFormData) {
          var formData = new FormData();
          formData.append('id', JSON.stringify(dataToSend.ids));
          dataToSend = formData;
        }

        var options = {
          headers: me.headers,
          parseJson: true
        };

        if (me.useRestfulMethods) {
          options.method = me.httpMethods.delete;
        }

        _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].post(me.deleteUrl + me.buildQueryString(me.params), dataToSend, _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].assign(options, me.fetchOptions)).then(function (response) {
          var data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && data.success !== false;
          commitState.response = response;
          event.json = data;
          event.response = response;

          if (success) {
            removed.forEach(function (record) {
              return record.meta.committing = false;
            }); // In case used by other store etc.

            removed.clear();
            me.trigger('commitRemoved');
            me.trigger('refresh', event);
            resolve(commitState);
          } else {
            // Clear committing flag
            removed.forEach(function (r) {
              return r.meta.committing = false;
            });
            commitState.exception = event.exception = true;
            event.exceptionType = 'server';
            me.trigger('exception', event);
            resolve(commitState);
          } // finally


          me.trigger('afterRequest', event);
        }).catch(function (responseOrError) {
          // Clear committing flag
          removed.forEach(function (r) {
            return r.meta.committing = false;
          });
          commitState.exception = event.exception = true;

          if (responseOrError instanceof Response) {
            commitState.response = responseOrError;
            event.exceptionType = responseOrError.ok ? 'server' : 'network';
            event.response = responseOrError;
            event.error = responseOrError.error;
          } else {
            event.exceptionType = 'server';
            event.error = responseOrError;
          }

          me.trigger('exception', event);
          resolve(commitState); // finally

          me.trigger('afterRequest', event);
        });
      }) : null;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this._isLoading;
    }
    /**
     * Returns true if the Store is currently committing
     * @property {Boolean}
     * @readonly
     * @category CRUD
     */

  }, {
    key: "isCommitting",
    get: function get() {
      return Boolean(this.commitPromise);
    }
  }, {
    key: "pageParamName",
    set: function set(pageParamName) {
      if (this.tree) {
        throw new Error('Paging cannot be supported for tree stores');
      }

      if (this.pageStartParamName) {
        throw new Error('Configs pageStartParamName and pageParamName are mutually exclusive');
      }

      this._pageParamName = pageParamName;
    },
    get: function get() {
      return this._pageParamName;
    }
  }, {
    key: "pageStartParamName",
    set: function set(pageStartParamName) {
      if (this.tree) {
        throw new Error('Paging cannot be supported for tree stores');
      }

      if (this.pageParamName) {
        throw new Error('Configs pageParamName and pageStartParamName are mutually exclusive');
      }

      this._pageStartParamName = pageStartParamName;
    },
    get: function get() {
      return this._pageStartParamName;
    }
    /**
     * Yields true if this Store is loaded page by page. This yields `true` if either of the {@link #config-pageParamName}
     * of {@link #config-pageStartParamName} configs are set.
     * @property {Boolean}
     * @readonly
     * @category Paging
     */

  }, {
    key: "isPaged",
    get: function get() {
      return this.pageParamName || this.pageStartParamName;
    }
    /**
     * Yields the complete dataset size. If the store is {@link #property-isPaged is paged} this is the value
     * returned in the last loaded data block in the {@link #config-responseTotalProperty} property. Otherwise it is
     * the number of records in the store's underlying storage collection.
     * @property {Number}
     * @readonly
     * @category Paging
     */

  }, {
    key: "allCount",
    get: function get() {
      return 'remoteTotal' in this ? this.remoteTotal : _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_31___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(AjaxStore.prototype), "allCount", this);
    }
    /**
     * **If the store {@link #property-isPaged is paged}**, yields the highest page number in the dataset as calculated from the {@link #config-responseTotalProperty}
     * returned in the last page data block loaded.
     * @property {Number}
     * @readonly
     * @category Paging
     */

  }, {
    key: "lastPage",
    get: function get() {
      if (this.isPaged) {
        return Math.floor((this.allCount + this.pageSize - 1) / this.pageSize);
      }
    }
  }, {
    key: "remoteFilter",
    get: function get() {
      return Boolean(this.filterParamName || this.restfulFilter);
    }
  }], [{
    key: "defaultConfig",
    // region Events

    /**
     * Fired when a remote request fails, either at the network level, or the server returns a failure, or an invalid response.
     *
     * Note that when a {@link #function-commit} fails, more than one exception event will be triggered. The individual operation,
     * `create`, `update` or `delete` will trigger their own `exception` event, but the encapsulating commit operation will also
     * trigger an `exception` event when all the operations have finished, so if exceptions are going to be handled gracefully,
     * the event's `action` property must be examined, and the constituent operations of the event must be examined.
     * @event exception
     * @param {Core.data.Store} source This Store
     * @param {Boolean} exception `true`
     * @param {String} action Action that failed, `'create'`, `'read'`, `'update'` or `'delete'`. May also be fired
     * with '`commit'` to indicate the failure of an aggregated `create`, `update` and `delete` operation. In this case,
     * the event will contain a property for each operation of the commit named `'create'`, `'update'` and `'delete'`,
     * each containing the individual `exception` events.
     * @param {String} exceptionType The type of failure, `'network'` or `'server'`
     * @param {Response} response the `Response` object
     * @param {Object} json The decoded response object *if the exceptionType is `'server'`*
     */

    /**
     * Fired after committing added records
     * @event commitAdded
     * @param {Core.data.Store} source This Store
     */

    /**
     * Fired after committing modified records
     * @event commitModified
     * @param {Core.data.Store} source This Store
     */

    /**
     * Fired on successful load
     * @event load
     * @param {Core.data.Store} source This Store
     * @param {Object[]} data Data loaded
     * @param {Response} response the `Response` object
     * @param {Object} json The decoded response object.
     */

    /**
     * Fired on successful load of remote child nodes for a tree node.
     * @event loadChildren
     * @param {Core.data.Store} source This Store
     * @param {Object[]} data Data loaded
     * @param {Object} json The decoded response object.
     */

    /**
     * Fired after committing removed records
     * @event commitRemoved
     * @param {Core.data.Store} source This Store
     */

    /**
     * Fired before loading starts. Allows altering parameters and is cancelable
     * @event beforeLoad
     * @preventable
     * @param {Core.data.Store} source This Store
     * @param {Object} params An object containing property/name pairs which are the parameters.
     * This may be mutated to affect the parameters used in the Ajax request.
     */

    /**
     * Fired before loading of remote child nodes of a tree node starts. Allows altering parameters and is cancelable
     * @event beforeLoadChildren
     * @preventable
     * @param {Core.data.Store} source This Store
     * @param {Object} params An object containing property/name pairs which are the parameters.
     * This may be mutated to affect the parameters used in the Ajax request.
     */

    /**
     * When the store {@link #property-isPaged is paged}, this is fired before loading a page and is cancelable
     * @event beforeLoadPage
     * @preventable
     * @param {Core.data.Store} source This Store
     * @param {Object} params An object containing property/name pairs which are the parameters.
     * This may be mutated to affect the parameters used in the Ajax request.
     */

    /**
     * Fired when loading is beginning. This is not cancelable. Parameters in the event may still be
     * mutated at this stage.
     * @event loadStart
     * @param {Core.data.Store} source This Store
     * @param {Object} params An object containing property/name pairs which are the parameters.
     * This may be mutated to affect the parameters used in the Ajax request.
     */

    /**
     * Fired when loading of remote child nodes into a tree node is beginning. This is not cancelable. Parameters in the event may still be
     * mutated at this stage.
     * @event loadChildrenStart
     * @param {Core.data.Store} source This Store
     * @param {Object} params An object containing property/name pairs which are the parameters.
     * This may be mutated to affect the parameters used in the Ajax request.
     */

    /**
     * Fired before any remote request is initiated.
     * @event beforeRequest
     * @param {Core.data.Store} source This Store
     * @param {Object} params An object containing property/name pairs which are the parameters.
     * @param {Object} body The body of the request to be posted to the server.
     * @param {String} action Action that is making the request, `'create'`, `'read'`, `'update'` or `'delete'`
     */

    /**
     * Fired after any remote request has finished whether successfully or unsuccessfully.
     * @event afterRequest
     * @param {Boolean} exception `true`. *Only present if the request triggered an exception.*
     * @param {String} action Action that has finished, `'create'`, `'read'`, `'update'` or `'delete'`
     * @param {String} exceptionType The type of failure, `'network'` or `'server'`. *Only present if the request triggered an exception.*
     * @param {Response} response The `Response` object
     * @param {Object} json The decoded response object if there was no `'network'` exception.
     */
    // endregion
    //region Config
    get: function get() {
      return {
        /**
         * An object containing the HTTP headers to add to each server request issued by this Store.
         * @config {Object}
         * @default
         * @category Remote
         */
        headers: null,

        /**
         * An object containing the Fetch options to pass to each server request issued by this Store. Use this to control if credentials are sent
         * and other options, read more at [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch).
         * @config {Object}
         * @default
         * @category Remote
         */
        fetchOptions: null,

        /**
         * Specify `true` to send payloads as form data, `false` to send as regular JSON.
         * @config {Boolean}
         * @default
         * @category Remote
         */
        sendAsFormData: false,

        /**
         * Specify `true` to send all model fields when committing modified records (as opposed to just the modified fields)
         * @config {Boolean}
         * @default
         * @category Remote
         */
        writeAllFields: null,

        /**
         * The name of the HTTP parameter passed to this Store's {@link #config-readUrl} to indicate the node `id` to
         * load when loading child nodes on demand if the node being expanded was created with data containing `children: true`.
         * @config {String}
         * @default
         * @category Remote
         */
        parentIdParamName: 'id',

        /**
         * The optional property name in JSON responses from the server that contains a boolean
         * success/fail status.
         * ```
         * {
         *   "responseMeta" : {
         *   {
         *     "success" : true,
         *     "count" : 100
         *   },
         *   // The property name used here should match that of 'reponseDataProperty'
         *   "data" : [
         *     ...
         *   ]
         * }
         * ```
         *
         * The store would be configured with:
         * ```javascript
         *  {
         *      ...
         *      successDataProperty : 'responseMeta.success',
         *      responseTotalProperty : 'responseMeta.count'
         *      ...
         *  }
         *
         * ```
         * @config {String}
         * @default
         * @category Remote
         */
        responseSuccessProperty: 'success',

        /**
         * The property name in JSON responses from the server that contains the data for the records
         * ```
         * {
         *   "success" : true,
         *   // The property name used here should match that of 'reponseDataProperty'
         *   "data" : [
         *     ...
         *   ]
         * }
         * ```
         * @config {String}
         * @default
         * @category Remote
         */
        responseDataProperty: 'data',

        /**
         * The property name in JSON responses from the server that contains the dataset total size
         * **when this store {@link #property-isPaged is paged}**
         * ```
         * {
         *   "success" : true,
         *   // The property name used here should match that of 'reponseDataProperty'
         *   "data" : [
         *     ...
         *   ],
         *   // The property name used here should match that of 'responseTotalProperty'
         *   "total" : 65535
         * }
         * ```
         * @config {String}
         * @default
         * @category Remote
         */
        responseTotalProperty: 'total',

        /**
         * The name of the HTTP parameter to use to pass any encoded filters when loading data from the server and a filtered response is required.
         *
         * **Note:** When this is set, filters must be defined using a field name, an operator and a value
         * to compare, **not** a comparison function.
         * @config {String}
         * @category Remote
         */
        filterParamName: null,

        /**
         * Set this flag to true if you are filtering remote using restful URLs (e.g. https://nominatim.openstreetmap.org/search/paris?format=json)
         *
         * **Note:** When this is set, the filter string is appended to the readUrl.
         * @config {String}
         */
        restfulFilter: false,

        /**
         * The name of the HTTP parameter to use to pass any encoded sorters when loading data from the server and a sorted response is required.
         *
         * **Note:** When this is set, sorters must be defined using a field name and an ascending flag,
         * **not** a sort function.
         * @config {String}
         * @category Remote
         */
        sortParamName: null,

        /**
         * The name of the HTTP parameter to use when requesting pages of data using the **one based** page number required.
         * @config {String}
         * @category Paging
         */
        pageParamName: null,

        /**
         * The name of the HTTP parameter to use when requesting pages of data using the **zero based** index of the required page's starting record.
         * @config {String}
         * @category Paging
         */
        pageStartParamName: null,

        /**
         * The name of the HTTP parameter to use when requesting pages of data using the **zero based** index of the required page's starting record.
         * @config {String}
         * @default
         * @category Paging
         */
        pageSizeParamName: 'pageSize',

        /**
         * When paging of data is requested by setting _either_ the {@link #config-pageParamName} _or_ the {@link #config-pageStartParamName},
         * this is the value to send in the {@link #config-pageSizeParamName}
         * @config {String}
         * @default
         * @category Paging
         */
        pageSize: 50,

        /**
         * Set to ´true´ to use restful {@link #config-httpMethods}
         * @config {String}
         * @default
         * @category Remote
         */
        useRestfulMethods: false,

        /**
         * The HTTP methods to use for CRUD requests when {@link #config-useRestfulMethods} is enabled.
         *
         * ```
         * new AjaxStore({
         *    useRestfulMethods : true,
         *    httpMethods : {
         *        create : 'POST',
         *        read : 'POST',
         *        update : 'PATCH',
         *        delete : 'DELETE'
         *    }
         * });
         *
         * ```
         * @config {Object}
         * @default
         * @category Remote
         */
        httpMethods: {
          create: 'POST',
          read: 'GET',
          update: 'PUT',
          delete: 'DELETE'
        }
      };
    }
  }]);

  return AjaxStore;
}(_Store_js__WEBPACK_IMPORTED_MODULE_35__["default"]);


AjaxStore._$name = 'AjaxStore';

/***/ }),

/***/ "./lib/Core/data/DomDataStore.js":
/*!***************************************!*\
  !*** ./lib/Core/data/DomDataStore.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomDataStore; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);



var productName = 'scheduler';
/**
* @module Core/data/DomDataStore
*/

/**
 * Stores data on a dom element (by setting element._domData).
 * Instead of using HTML5:s element.dataset, which turned out to be slow.
 * @internal
 */

var DomDataStore = /*#__PURE__*/function () {
  function DomDataStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, DomDataStore);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(DomDataStore, null, [{
    key: "get",

    /**
     * Get data that is connected to specified element.
     * @param {HTMLElement} element DOM element
     * @param {String} [key] The name of the property in the element data to return
     * @returns {Object} Data
     */
    value: function get(element, key) {
      var result = element._domData || (element._domData = {});
      return key != null ? result[key] : result;
    }
    /**
     * Remove data connected to specified element.
     * @param {HTMLElement} element DOM element
     * @param {String} key The name of the property in the element data to remove.
     */

  }, {
    key: "remove",
    value: function remove(element, key) {
      var _domData = element._domData,
          was = _domData === null || _domData === void 0 ? void 0 : _domData[key];
      _domData === null || _domData === void 0 ? true : delete _domData[key];
      return was;
    }
    /**
     * Set data connected to specified element (completely replacing any existing).
     * To update data, use DomDataStore#assign instead.
     * @param {HTMLElement} element DOM element
     * @param {Object|String} data Data object to set, or property name to set
     * @param {*} [value] If the previous parameter was a property name, this is the value to set.
     */

  }, {
    key: "set",
    value: function set(element, data, value) {
      if (arguments.length === 3) {
        (element._domData || (element._domData = {}))[data] = value;
      } else {
        element._domData = data;
      }
    }
    /**
     * Updates data connected to specified element.
     * @param element DOM element
     * @param data Data to assign
     */

  }, {
    key: "assign",
    value: function assign(element, data) {
      Object.assign(element._domData || (element._domData = {}), data);
    }
  }]);

  return DomDataStore;
}();


DomDataStore._$name = 'DomDataStore';

/***/ }),

/***/ "./lib/Core/data/Duration.js":
/*!***********************************!*\
  !*** ./lib/Core/data/Duration.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Duration; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");





var productName = 'scheduler';

/**
 * @module Core/data/Duration
 */

/**
 * Class which represents a duration object.
 * ```javascript
 * {
 *    unit      : String,
 *    magnitude : Number
 * }
 * ```
 */

var Duration = /*#__PURE__*/function () {
  /**
   * Duration constructor.
   * @param {Number} magnitude Duration magnitude value
   * @param {String} unit Duration unit value
   */
  function Duration(magnitude, unit) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Duration);

    if (typeof magnitude === 'number') {
      this._magnitude = magnitude;
      this._unit = unit;
    } else {
      if (typeof magnitude === 'string') {
        magnitude = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].parseDuration(magnitude);
      }

      if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(magnitude) === 'object') {
        Object.assign(this, magnitude);
      }
    }
  }
  /**
   * Get/Set numeric magnitude `value`.
   * @property {Number}
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Duration, [{
    key: "isEqual",

    /**
     * Returns truthy value if this Duration equals to passed value
     * @param value
     * @return {Boolean}
     */
    value: function isEqual(value) {
      return Boolean(value && this.milliseconds === value.milliseconds);
    }
  }, {
    key: "toString",
    value: function toString(useAbbreviation) {
      var me = this,
          abbreviationFn = me.useAbbreviation ? 'getShortNameOfUnit' : 'getLocalizedNameOfUnit';
      return me.isValid ? "".concat(me._magnitude, " ").concat(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"][abbreviationFn](me._unit, me._magnitude !== 1)) : '';
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      return this.milliseconds;
    }
  }, {
    key: "magnitude",
    get: function get() {
      return this._magnitude;
    },
    set: function set(value) {
      this._magnitude = typeof value === 'number' && value;
    }
    /**
     * Get/Set duration unit to use with the current magnitude value.
     * Valid values are:
     * - "millisecond" - Milliseconds
     * - "second" - Seconds
     * - "minute" - Minutes
     * - "hour" - Hours
     * - "day" - Days
     * - "week" - Weeks
     * - "month" - Months
     * - "quarter" - Quarters
     * - "year"- Years
     *
     * @property {String}
     */

  }, {
    key: "unit",
    get: function get() {
      return this._unit;
    },
    set: function set(value) {
      this._unit = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].parseTimeUnit(value);
    }
  }, {
    key: "isValid",
    get: function get() {
      return this._magnitude != null && this._unit;
    }
    /**
     * The `milliseconds` property is a read only property which returns the number of milliseconds in this Duration
     * @property {Number}
     * @readonly
     */

  }, {
    key: "milliseconds",
    get: function get() {
      // There's no smaller time unit in the Date class than milliseconds, so round any divided values
      return this.isValid ? Math.round(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].asMilliseconds(this._magnitude, this._unit)) : 0;
    }
  }]);

  return Duration;
}();


;
Duration._$name = 'Duration';

/***/ }),

/***/ "./lib/Core/data/Model.js":
/*!********************************!*\
  !*** ./lib/Core/data/Model.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Model; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_reflect_delete_property__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.reflect.delete-property */ "./node_modules/core-js/modules/es.reflect.delete-property.js");
/* harmony import */ var core_js_modules_es_reflect_delete_property__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_delete_property__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_reflect_own_keys__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.reflect.own-keys */ "./node_modules/core-js/modules/es.reflect.own-keys.js");
/* harmony import */ var core_js_modules_es_reflect_own_keys__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_own_keys__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_web_url_to_json__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/web.url.to-json */ "./node_modules/core-js/modules/web.url.to-json.js");
/* harmony import */ var core_js_modules_web_url_to_json__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_to_json__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./stm/mixin/ModelStm.js */ "./lib/Core/data/stm/mixin/ModelStm.js");
/* harmony import */ var _mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./mixin/TreeNode.js */ "./lib/Core/data/mixin/TreeNode.js");
/* harmony import */ var _field_DataField_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./field/DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony import */ var _field_BooleanDataField_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./field/BooleanDataField.js */ "./lib/Core/data/field/BooleanDataField.js");
/* harmony import */ var _field_DateDataField_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./field/DateDataField.js */ "./lib/Core/data/field/DateDataField.js");
/* harmony import */ var _field_IntegerDataField_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./field/IntegerDataField.js */ "./lib/Core/data/field/IntegerDataField.js");
/* harmony import */ var _field_ModelDataField_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./field/ModelDataField.js */ "./lib/Core/data/field/ModelDataField.js");
/* harmony import */ var _field_NumberDataField_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./field/NumberDataField.js */ "./lib/Core/data/field/NumberDataField.js");
/* harmony import */ var _field_ObjectDataField_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./field/ObjectDataField.js */ "./lib/Core/data/field/ObjectDataField.js");
/* harmony import */ var _field_StringDataField_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./field/StringDataField.js */ "./lib/Core/data/field/StringDataField.js");





































function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






 // The built-in model field types:








var defineProperty = Reflect.defineProperty,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    _undefined = undefined,
    internalProps = {
  children: 1,
  data: 1,
  meta: 1
},
    abbreviationFields = ['name', 'title', 'text', 'label', 'description'];
/**
 * @module Core/data/Model
 */

/**
 * A Model is a definition for a record in a store. It defines which fields the data contains and exposes an interface
 * to access and manipulate that data.
 *
 * Models are created from json objects, the input json is stored in `Model#data`. By default it stores a shallow copy of
 * the raw json, but for records in stores configured with `useRawData: true` it stores the supplied json object as is.
 *
 * ## Defining Fields
 * A Model can either define its fields explicitly (see {@link #property-fields-static}) or have them created from its
 * data (see {@link #property-autoExposeFields-static}). This snippet shows a model with 4 fields defined explicitly:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'birthday', type : 'date', format : 'YYYY-MM-DD' },
 *             { name : 'shoeSize', type : 'number', defaultValue : 11 },
 *             { name : 'age', readOnly : true }
 *         ];
 *     }
 * }
 * ```
 *
 * The first field (name) has an unspecified type, which means the field's value is held as received with no conversion
 * applied. The second field (birthday) is defined to be a date, which will make the model parse any supplied value into
 * an actual date. The parsing is handled by {@link Core/helper/DateHelper#function-parse-static DateHelper.parse()}
 * using the specified `format`, or if no format is specified using
 * {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat}.
 *
 * The set of standard field types is as follows:
 *
 *  - {@link Core.data.field.BooleanDataField `boolean`}
 *  - {@link Core.data.field.DateDataField `date`}
 *  - {@link Core.data.field.IntegerDataField `integer`}
 *  - {@link Core.data.field.NumberDataField `number`}
 *  - {@link Core.data.field.StringDataField `string`}
 *
 * You can also set a `defaultValue` that will be used if the data does not contain a value for the field:
 *
 * ```javascript
 * { name : 'shoeSize', type : 'number', defaultValue : 11 }
 * ```
 *
 * To create a record from a Model, supply data to its constructor:
 *
 * ```javascript
 * let guy = new Person({
 *   id       : 1,
 *   name     : 'Dude',
 *   birthday : '2014-09-01'
 * });
 * ```
 *
 * If no id is specified, a temporary id will be generated.
 *
 * ## Persisting Fields
 * By default all fields are persisted. If you don't want particular field to get saved to the server, configure it with
 * `persist: false`. In this case field will not be among changes which are sent by
 * {@link Core/data/AjaxStore#function-commit store.commit()}, otherwise its behavior doesn't change.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', persist : false }
 *         ];
 *     }
 * }
 * ```
 *
 * ## The `idField`
 * By default Model expects its id to be stored in a field named "id". The name of the field can be customized by
 * setting {@link #property-idField-static}:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', persist : false },
 *             { name : 'personId' },
 *             { name : 'birthday', type : 'date' }
 *         ];
 *     }
 * }
 *
 * // Id drawn from 'id' property by default; use custom field here
 * Person.idField = 'personId';
 *
 * let girl = new Person({
 *    personId : 2,
 *    name     : 'Lady',
 *    birthday : '2011-11-05'
 * });
 * ```
 *
 * ## Getting and Setting Values
 * Fields are used to generate getters and setters on the records. Use them to access or modify values (they are
 * reactive):
 *
 * ```javascript
 * console.log(guy.name);
 * girl.birthday = new Date(2011,10,6);
 * ```
 *
 * NOTE: In an application with multiple different models you should subclass Model, since the prototype is decorated
 * with getters and setters. Otherwise you might get unforeseen collisions.
 *
 * ## Field Data Mapping
 * By default fields are mapped to data using their name. If you for example have a "name" field it expects data to be
 * `{ name: 'Some name' }`. If you need to map it to some other property, specify `dataSource` in your field definition:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields {
 *         return [
 *             { name : 'name', dataSource : 'TheName' }
 *         ];
 *     }
 * }
 *
 * // This is now OK:
 * let dude = new Person({ TheName : 'Manfred' });
 * console.log(dude.name); // --> Manfred
 * ```
 * ## Field Inheritance
 * Fields declared in a derived model class are added to those from its superclass. If a field declared by a derived
 * class has also been declared by its super class, the field properties of the super class are merged with those of
 * the derived class.
 *
 * For example:
 * ```javascript
 *  class Person extends Model {
 *      static get fields() {
 *          return [
 *              'name',
 *              { name : 'birthday', type : 'date', format : 'YYYY-MM-DD' }
 *          ];
 *      }
 *  }
 *
 *  class User extends Person {
 *      static get fields() {
 *          return [
 *              { name : 'birthday', dataSource : 'dob' },
 *              { name : 'lastLogin', type : 'date' }
 *          ];
 *      }
 *  }
 * ```
 * In the above, the `Person` model declares the `birthday` field as a `date` with a specified `format`. The `User`
 * model extends `Person` and also declares the `birthday` field. This redeclared field only specifies `dataSource`, so
 * all of the other fields are preserved from `Person`. The `User` model also adds a `lastLogin` field.
 *
 * The `User` from above could have been declared like so to achieve the same `fields`:
 * ```javascript
 *  class User extends Model {
 *      static get fields() {
 *          return [
 *              'name',
 *              { name : 'birthday', type : 'date', format : 'YYYY-MM-DD', dataSource : 'dob' },
 *              { name : 'lastLogin', type : 'date' }
 *          ];
 *      }
 *  }
 * ```
 *
 * ## Override default values
 *
 * In case you need to define default value for a specific field, or override an existing default value, you can
 * define a new or re-define an existing field definition in {@link #property-fields-static} static getter:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             { name : 'username', defaultValue : 'New person' },
 *             { name : 'birthdate', type : 'date' }
 *         ];
 *     }
 * }
 *
 * class Bot extends Person {
 *     static get fields() {
 *         return [
 *             { name : 'username', defaultValue : 'Bot' } // default value of 'username' field is overridden
 *         ];
 *     }
 * }
 * ```
 *
 * ## Tree API
 * This class mixes in the {@link Core/data/mixin/TreeNode TreeNode} mixin which provides an API for tree related functionality (only relevant if your
 * store is configured to be a {@link Core/data/Store#config-tree tree}).
 *
 * @mixes Core/data/mixin/TreeNode
 * @mixes Core/data/stm/mixin/ModelStm
 */

var Model = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default()(Model, _Base$mixin);

  var _super = _createSuper(Model);

  function Model() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default()(this, Model);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default()(Model, [{
    key: "construct",

    /**
     * Unique identifier for the record. Might be mapped to another dataSource using idField, but always exposed as
     * record.id. Will get a generated value if none is specified in records data.
     * @member {String|Number} id
     * @category Identification
     */
    //region Init

    /**
     * Constructs a new record from the supplied data.
     * @param {Object} [data] Raw data
     * @param {Core.data.Store} [store] Data store
     * @param {Object} [meta] Meta data
     * @function constructor
     * @category Lifecycle
     */
    value: function construct() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var skipExpose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var me = this,
          stores = store ? Array.isArray(store) ? store : [store] : [],
          constructor = me.constructor,
          fieldMap = me.fieldMap; // null passed to Base construct inhibits config processing.

      var configs = null;
      store = stores[0];
      me.meta = _objectSpread(_objectSpread({
        modified: {}
      }, constructor.metaConfig), meta); // Should apply configs?

      if (constructor.applyConfigs) {
        // Extract from data and combine with defaultConfigs
        for (var key in me.$meta.config) {
          if (!configs) {
            // if (first config)
            configs = {};

            if (!me.useRawData || !me.useRawData.enabled) {
              // Shallow copy of data to not mutate incoming object
              data = _objectSpread({}, data);
            }
          }

          if (key in data) {
            // Use as config
            configs[key] = data[key]; // Remove from data

            delete data[key];
          }
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Model.prototype), "construct", this).call(this, configs); // make getters/setters for fields, needs to be done before processing data to make sure defaults are available


      if (!skipExpose) {
        constructor.exposeProperties(data);
      } // It's only valid to do this once, on construction of the first instance


      if (!hasOwnProperty.call(constructor, 'idFieldProcessed')) {
        // idField can be overridden from meta, or from the store if we have not had an idField set programmatically
        // and if we have not had an id field defined above the base Model class level.
        var overriddenIdField = me.meta.idField;

        if (!overriddenIdField) {
          // Might have been set to Model after construction but before load
          if (constructor._assignedIdField) {
            overriddenIdField = constructor.idField;
          } // idField on store was deprecated, but should still work to not break code
          // TODO: Remove in 3.0? Or reintroduce it...
          else if (store) {
              overriddenIdField = store.idField;
            }
        } // If it's overridden to something different than we already have, replace the 'id' field in the fieldMap


        if (overriddenIdField && overriddenIdField !== fieldMap.id.dataSource) {
          constructor.addField({
            name: 'id',
            dataSource: overriddenIdField
          });
        }

        constructor.idFieldProcessed = true;
      } // assign internalId, unique among all records


      me._internalId = Model._internalIdCounter++; // relation code expects store to be available for relation lookup, but actual join done below

      me.stores = [];
      me.unjoinedStores = []; // Superclass constructors may set this in their own way before this is called.

      if (!me.originalData) {
        me.originalData = data;
      }

      me.data = constructor.processData(data, false, store); // Consider undefined and null as missing id and generate one

      if (me.id == null) {
        // Assign a generated id silently, record should not be considered modified
        me.setData('id', me.generateId(store));
      }

      if (me.data[constructor.childrenField]) {
        me.processChildren(stores);
      }

      me.generation = 0;
    }
    /**
     * Compares this Model instance to the passed instance. If they are of the same type, and all fields
     * (except, obviously, `id`) are equal, this returns `true`.
     * @param {Core.data.Model} other The record to compare this record with.
     * @returns {Boolean} `true` if the other is of the same class and has all fields equal.
     */

  }, {
    key: "equals",
    value: function equals(other) {
      if (other instanceof this.constructor) {
        for (var fields = this.$meta.fields.defs, i = 0, length = fields.length; i < length; i++) {
          var field = fields[i],
              name = field.name;

          if (name !== 'id' && !field.isEqual(this[name], other[name])) {
            return false;
          }
        }

        return true;
      }

      return false;
    }
  }, {
    key: "getFieldDefinition",

    /**
     * Convenience function to get the definition for a field from class.
     * @param {String} fieldName Field name
     * @returns {Core.data.field.DataField}
     * @category Fields
     */
    value: function getFieldDefinition(fieldName) {
      return this.$meta.fields.map[fieldName];
    }
  }, {
    key: "getFieldDefinitionFromDataSource",
    value: function getFieldDefinitionFromDataSource(dataSource) {
      return this.$meta.fields.sources[dataSource];
    }
    /**
     * Get the names of all fields in data.
     * @returns {String[]} Field names
     * @readonly
     * @category Fields
     */

  }, {
    key: "getDataSource",

    /**
     * Get the data source used by specified field. Returns the fieldName if no data source specified.
     * @param {String} fieldName Field name
     * @returns {String}
     * @category Fields
     */
    value: function getDataSource(fieldName) {
      var def = this.constructor.getFieldDefinition(fieldName);
      return (def === null || def === void 0 ? void 0 : def.dataSource) || (def === null || def === void 0 ? void 0 : def.name);
    }
    /**
     * Processes input to a field, converting to expected type.
     * @param {String} fieldName Field dataSource
     * @param {*} value Value to process
     * @returns {*} Converted value
     * @category Fields
     */

  }, {
    key: "initRelations",
    //endregion
    //region Relations

    /**
     * Initializes model relations. Called from store when adding a record.
     * @private
     * @category Relations
     */
    value: function initRelations() {
      var me = this,
          relations = me.constructor.relations;
      if (!relations) return; // TODO: feels strange to have to look at the store for relation config but didn't figure out anything better.
      // TODO: because other option would be to store it on each model instance, not better...

      me.stores.forEach(function (store) {
        var _store$modelRelations;

        if (!store.modelRelations) {
          store.initRelations();
        } // TODO: not at all tested for multiple stores, can't imagine it works as is


        var relatedRecords = [];
        (_store$modelRelations = store.modelRelations) === null || _store$modelRelations === void 0 ? void 0 : _store$modelRelations.forEach(function (config) {
          relatedRecords.push({
            related: me.initRelation(config),
            config: config
          });
        });
        store.updateRecordRelationCache(me, relatedRecords);
      });
    }
    /**
     * Initializes/updates a single relation.
     * @param config Relation config
     * @returns {Core.data.Model} Related record
     * @private
     * @category Relations
     */

  }, {
    key: "initRelation",
    value: function initRelation(config) {
      var me = this,
          keyValue = me.get(config.fieldName),
          foreign = keyValue !== _undefined && typeof config.store !== 'string' && config.store.getById(keyValue),
          placeHolder = {
        id: keyValue,
        placeHolder: true
      };

      if (!me.meta.relationCache) {
        me.meta.relationCache = {};
      } // apparently scheduler tests expect cache to work without matched related record, thus the placeholder


      me.meta.relationCache[config.relationName] = foreign || (keyValue != null ? placeHolder : null);
      return foreign;
    }
  }, {
    key: "removeRelation",
    value: function removeRelation(config) {
      // (have to check for existence before deleting to work in Safari)
      if (this.meta.relationCache[config.relationName]) {
        delete this.meta.relationCache[config.relationName];

        if (config.nullFieldOnRemove) {
          // Setting to null silently, to not trigger additional relation behaviour
          this.setData(config.fieldName, null);
        }
      }
    }
  }, {
    key: "getForeign",
    value: function getForeign(name) {
      var _this$meta$relationCa;

      return (_this$meta$relationCa = this.meta.relationCache) === null || _this$meta$relationCa === void 0 ? void 0 : _this$meta$relationCa[name];
    }
  }, {
    key: "setForeign",
    value: function setForeign(name, value, config) {
      var id = Model.asId(value);
      return this.set(config.fieldName, id);
    } //endregion
    //region Get/set values, data handling

    /**
     * Get value for specified field name. You can also use the generated getters if loading through a Store.
     * If model is currently in batch operation this will return updated batch values which are not applied to Model
     * until endBatch() is called.
     * @param {String} fieldName Field name to get value from
     * @returns {*} Fields value
     * @category Fields
     */

  }, {
    key: "get",
    value: function get(fieldName) {
      var me = this,
          batchChanges = me.meta.batchChanges,
          fieldMap = me.fieldMap,
          recData = me.data;
      var field = fieldMap[fieldName];
      var dataSource = field ? field.dataSource : fieldName; // When changes are batched, they get stored by field name, not dataSource

      if (batchChanges && fieldName in batchChanges) {
        return batchChanges[fieldName];
      } // If changes are not batched, it should be resolved from the data using dataSource


      if (dataSource) {
        var _field;

        // Getting property of nested record?
        if (!field && fieldName.includes('.')) {
          var nestedName = fieldName.split('.')[0];
          field = fieldMap[nestedName];
        }

        if ((_field = field) === null || _field === void 0 ? void 0 : _field.complexMapping) {
          return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getPath(recData, dataSource);
        }

        return dataSource in recData ? recData[dataSource] : recData[fieldName];
      }
    }
    /**
     * Internal function used to update a records underlying data block (record.data) while still respecting field
     * mappings. Needed in cases where a field needs setting without triggering any associated behaviour and it has a
     * dataSource with a different name.
     *
     * For example:
     * ```javascript
     * // startDate mapped to data.beginDate
     * { name : 'startDate', dataSource : 'beginDate' }
     *
     * // Some parts of our code needs to update the data block without triggering any of the behaviour associated with
     * // calling set. This would then not update "beginDate":
     * record.data.startDate = xx;
     *
     * // But this would
     * record.setData('startDate', xx);
     * ```
     * @internal
     * @category Editing
     */

  }, {
    key: "setData",
    value: function setData(toSet, value) {
      var data = this.data,
          fieldMap = this.fieldMap; // Two separate paths for performance reasons
      // setData('name', 'Quicksilver');

      if (typeof toSet === 'string') {
        var _field$dataSource;

        var field = fieldMap[toSet],
            dataSource = (_field$dataSource = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource !== void 0 ? _field$dataSource : toSet;

        if (field === null || field === void 0 ? void 0 : field.complexMapping) {
          _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setPath(data, dataSource, value);
        } else {
          data[dataSource] = value;
        }
      } // setData({ name : 'Magneto', power : 'Magnetism' });
      else {
          var keys = Object.keys(toSet);

          for (var i = 0; i < keys.length; i++) {
            var _field2$dataSource;

            var fieldName = keys[i],
                _field2 = fieldMap[fieldName],
                _dataSource = (_field2$dataSource = _field2 === null || _field2 === void 0 ? void 0 : _field2.dataSource) !== null && _field2$dataSource !== void 0 ? _field2$dataSource : fieldName;

            if (_dataSource) {
              if (_field2 === null || _field2 === void 0 ? void 0 : _field2.complexMapping) {
                _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setPath(data, _dataSource, toSet[fieldName]);
              } else {
                data[_dataSource] = toSet[fieldName];
              }
            }
          }
        }
    }
    /**
     * Returns raw data from the encapsulated data object for the passed field name
     * @param {String} fieldName The field to get data for.
     * @returns {*} The raw data value for the field.
     */

  }, {
    key: "getData",
    value: function getData(fieldName) {
      var _field$dataSource2;

      var field = this.fieldMap[fieldName],
          dataSource = (_field$dataSource2 = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource2 !== void 0 ? _field$dataSource2 : fieldName;

      if (dataSource) {
        if (field === null || field === void 0 ? void 0 : field.complexMapping) {
          return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getPath(this.data, dataSource);
        }

        return this.data[dataSource];
      }
    }
    /**
     * Silently updates record's id with no flagging the property as modified.
     * Triggers onModelChange event for changed id.
     * @param {String|Number} value id value
     * @private
     */

  }, {
    key: "syncId",
    value: function syncId(value) {
      var oldValue = this.id;

      if (oldValue !== value) {
        this.setData('id', value);
        var data = {
          id: {
            value: value,
            oldValue: oldValue
          }
        };
        this.afterChange(data, data);
      }
    }
    /**
     * Set value for the specified field. You can also use the generated setters if loading through a Store.
     *
     * Setting a single field, supplying name and value:
     *
     * ```javascript
     * record.set('name', 'Clark');
     * ```
     *
     * Setting multiple fields, supplying an object:
     *
     * ```javascript
     * record.set({
     *    name : 'Clark',
     *    city : 'Metropolis'
     * });
     * ```
     *
     * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
     * @param {*} value Value to set
     * @param {Boolean} [silent] Set to true to not trigger events. If event is recurring, occurrences won't be updated automatically.
     * @fires Store#idChange
     * @fires Store#update
     * @fires Store#change
     * @category Editing
     */

  }, {
    key: "set",
    value: function set(field, value) {
      var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var fromRelationUpdate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var skipAccessors = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var me = this; // We use beforeSet/inSet/afterSet approach here because mixin interested in overriding set() method
      // like STM, for example, might be mixed before Model class or after. In general I have no control over this.
      // STM mixed before, so the only option to wrap set() method body is actually to call
      // beforeSet()/afterSet().

      if (me.isBatchUpdating) {
        me.inBatchSet(field, value);
        return null;
      } else {
        var _me$afterSet;

        var preResult = me.beforeSet ? me.beforeSet(field, value, silent, fromRelationUpdate) : _undefined,
            wasSet = me.inSet(field, value, silent, fromRelationUpdate, skipAccessors);
        (_me$afterSet = me.afterSet) === null || _me$afterSet === void 0 ? void 0 : _me$afterSet.call(me, field, value, silent, fromRelationUpdate, preResult, wasSet);
        return wasSet;
      }
    }
  }, {
    key: "fieldToKeys",
    value: function fieldToKeys(field, value) {
      if (typeof field !== 'string') {
        // will get in trouble when setting same field on multiple models without this
        return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].assign({}, field);
      }

      return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()({}, field, value);
    }
  }, {
    key: "inBatchSet",
    value: function inBatchSet(field, value) {
      var meta = this.meta,
          constructor = this.constructor;
      var changed = false;

      if (typeof field !== 'string') {
        Object.keys(this.fieldToKeys(field, value)).forEach(function (key) {
          value = constructor.processField(key, field[key]); // Store batch changes

          if (meta.batchChanges[key] !== value) {
            meta.batchChanges[key] = value;
            changed = true;
          }
        });
      } else {
        // Minor optimization for engine writing back a lot of changes
        if (meta.batchChanges[field] !== value) {
          meta.batchChanges[field] = value;
          changed = true;
        }
      } // Callers need to be able to detect changes


      if (changed) {
        this.generation++;
      }
    }
  }, {
    key: "inSet",
    value: function inSet(field, value, silent, fromRelationUpdate) {
      var skipAccessors = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var me = this,
          data = me.data,
          meta = me.meta,
          fieldMap = me.fieldMap,
          constructor = me.constructor,
          myProto = constructor.prototype,
          childrenField = constructor.childrenField,
          wasSet = {},
          toSet = me.fieldToKeys(field, value),
          keys = Object.keys(toSet);
      var changed = false; // Give a chance to cancel action before records updated.

      if (!silent && !me.triggerBeforeUpdate(toSet)) {
        return null;
      }

      var _loop = function _loop(i) {
        var _field$dataSource3;

        var key = keys[i]; // Currently not allowed to set children in a TreeNode this way, will be ignored

        if (key === childrenField) {
          return "continue";
        }

        var field = fieldMap[key],
            cmp = field || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"],
            readOnly = field === null || field === void 0 ? void 0 : field.readOnly,
            mapping = (_field$dataSource3 = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource3 !== void 0 ? _field$dataSource3 : key,
            useProp = !skipAccessors && !field && key in myProto,
            oldValue = useProp ? me[mapping] : (field === null || field === void 0 ? void 0 : field.complexMapping) ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getPath(data, mapping) : data[mapping],
            value = constructor.processField(key, toSet[key]),
            val = toSet[key] = {
          value: value
        },
            relation = me.getRelationConfig(key);

        if (!readOnly && !cmp.isEqual(oldValue, value)) {
          // Indicate to observers that data has changed.
          me.generation++;
          val.oldValue = oldValue;
          changed = true; // Update `modified` state which is used in sync request

          if (cmp.isEqual(me.meta.modified[key], value)) {
            // Remove changes if values are the same
            Reflect.deleteProperty(meta.modified, key);
          } else if (!me.ignoreBag) {
            // Private flag in engine, speeds initial commit up by not recording changes
            // Cache its original value
            if (!(key in meta.modified)) {
              meta.modified[key] = oldValue;
            }

            if (val.oldValue === _undefined) {
              Reflect.deleteProperty(val, 'oldValue');
            }
          } // The wasSet object keys must be the field *name*, not its dataSource.


          wasSet[key] = val;
          me.applyValue(useProp, mapping, value, skipAccessors, field); // changing foreign key

          if (relation && !fromRelationUpdate) {
            me.initRelation(relation);
            me.stores.forEach(function (store) {
              return store.cacheRelatedRecord(me, value, relation.relationName, val.oldValue);
            });
          }
        }
      };

      for (var i = 0; i < keys.length; i++) {
        var _ret = _loop(i);

        if (_ret === "continue") continue;
      }

      if (changed) {
        me.afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors);
      }

      return changed ? wasSet : null;
    } // Provided as a hook for SchedulingEngine to do what needs to be done which ever way a field value is changed

  }, {
    key: "applyValue",
    value: function applyValue(useProp, key, value, skipAccessors, field) {
      var _field3;

      // If we don't have a field, but we have a property defined
      // eg, the fullDuration property defined in TaskModel, then
      // use the property
      if (useProp) {
        this[key] = value;
        return;
      } // Might be setting value of nested object


      if (!field && key.includes('.')) {
        var nestedName = key.split('.')[0];
        field = this.constructor.fieldMap[nestedName];
      } // Use complex mapping?


      if ((_field3 = field) === null || _field3 === void 0 ? void 0 : _field3.complexMapping) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setPath(this.data, key, value);
      } // Otherwise, push the value through into the data.
      else {
          this.data[key] = value;
        }
    } // skipAccessors argument is used in the engine override

  }, {
    key: "afterChange",
    value: function afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors) {
      var _this = this;

      this.stores.forEach(function (store) {
        store.onModelChange(_this, toSet, wasSet, silent, fromRelationUpdate);
      });
    }
  }, {
    key: "isFieldModified",

    /**
     * Returns true if this model has uncommitted changes for the provided field.
     * @param {String} fieldName Field name
     * @returns {Boolean} True if the field is changed
     */
    value: function isFieldModified(fieldName) {
      return this.isModified && this.meta.modified[fieldName];
    }
    /**
     * Returns field value that should be persisted, or `undefined` if field is configured with `persist: false`.
     * @param {String|Core.data.field.DataField} nameOrField Name of the field to get value for, or its field definition
     * @private
     * @category Fields
     */

  }, {
    key: "getFieldPersistentValue",
    value: function getFieldPersistentValue(nameOrField) {
      var field = typeof nameOrField === 'string' ? this.getFieldDefinition(nameOrField) : nameOrField,
          name = (field === null || field === void 0 ? void 0 : field.name) || nameOrField;
      var result;

      if (!field || field.persist) {
        result = this[name]; // if serialize function is provided we use it to prepare the persistent value

        if (field === null || field === void 0 ? void 0 : field.serialize) {
          result = field.serialize(result, this);
        }
      }

      return result;
    }
    /**
     * Get a map of the modified fields in form of an object. The field *names* are used as the property names
     * in the returned object.
     * @property {Object}
     * @readonly
     * @category Editing
     */

  }, {
    key: "clearChanges",

    /**
     * Clear stored changes, used on commit. Does not revert changes.
     * @privateparam {Boolean} [removeFromStoreChanges] Update related stores modified collection or not
     * @privateparam {Boolean} [includeDescendants] Set true to clear store descendants
     * @category Editing
     */
    value: function clearChanges() {
      var removeFromStoreChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var includeDescendants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var me = this,
          meta = me.meta;
      meta.modified = {};
      meta.committing = false;

      if (removeFromStoreChanges) {
        me.stores.forEach(function (store) {
          store.modified.remove(me);
          store.added.remove(me);

          if (includeDescendants) {
            var descendants = store.collectDescendants(me).all;
            store.added.remove(descendants);
            store.modified.remove(descendants);
          }
        });
      }
    }
    /**
     * Reverts changes in this back to their original values.
     * @category Editing
     */

  }, {
    key: "revertChanges",
    value: function revertChanges() {
      this.set(this.meta.modified);
    } //endregion
    //region Id

    /**
     * Gets the records internalId. It is assigned during creation, guaranteed to be globally unique among models.
     * @property {Number}
     * @category Identification
     */

  }, {
    key: "generateId",

    /**
     * Generates id for new record which starts with _generated.
     * @category Identification
     */
    value: function generateId() {
      return this.constructor.generateId();
    }
    /**
     * Gets the id of specified model or the value if passed string/Number.
     * @param {Core.data.Model|String|Number} model
     * @returns {String|Number} id
     * @category Identification
     */

  }, {
    key: "toJSON",

    /**
     * Used by `JSON.stringify()` to correctly convert this record to json.
     *
     * In most cases no point in calling it directly.
     *
     * ```
     * // This will call `toJSON()`
     * const json = JSON.stringify(record);
     * ```
     *
     * If called manually, the resulting object is a clone of `record.data` + the data of any children:
     *
     * ```
     * const record = new Model({
     *   title    : 'Hello',
     *   children : [
     *     ...
     *   ]
     * });
     *
     * const jsonObject = record.toJSON();
     *
     * // jsonObject:
     * {
     *   title : 'Hello',
     *   children : [
     *       ...
     *   ]
     * }
     * ```
     *
     * @returns {Object}
     * @category JSON
     */
    value: function toJSON() {
      var children = this.children,
          jsonData = this.persistableData;

      if (children) {
        jsonData[this.constructor.childrenField] = children.map(function (c) {
          return c.toJSON();
        });
      }

      return jsonData;
    }
    /**
     * Represent the record as a string, by default as a JSON string. Tries to use an abbreviated version of the objects
     * data, using id + name/title/text/label/description. If no such field exists, the full data is used.
     *
     * ```javascript
     * const record = new Model({ id : 1, name : 'Steve Rogers', alias : 'Captain America' });
     * console.log(record.toString()); // logs { "id" : 1, "name" : "Steve Rogers" }
     * ```
     *
     * @returns {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      var _ref2;

      var me = this,
          nameField = abbreviationFields.find(function (field) {
        return field in me.constructor.fieldMap;
      }),
          data = nameField ? (_ref2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_ref2, me.constructor.idField, me.id), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_ref2, nameField, me[nameField]), _ref2) : me.data;
      return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].safeJsonStringify(data);
    } //endregion
    //region Batch

    /**
     * True if this Model is currently batching its changes.
     * @property {Boolean}
     * @readonly
     * @category Editing
     */

  }, {
    key: "beginBatch",

    /**
     * Begin a batch, which stores changes and commits them when the batch ends.
     * Prevents events from being fired during batch.
     * ```
     * record.beginBatch();
     * record.name = 'Mr Smith';
     * record.team = 'Golden Knights';
     * record.endBatch();
     * ```
     * Please note that you can also set multiple fields in a single call using {@link #function-set}, which in many
     * cases can replace using a batch:
     * ```
     * record.set({
     *   name : 'Mr Smith',
     *   team : 'Golden Knights'
     * });
     * ```
     * @category Editing
     */
    value: function beginBatch() {
      var me = this;

      if (!me.batching) {
        me.batching = 0;
        me.meta.batchChanges = {};
      }

      me.batching++;
    }
    /**
     * End a batch, triggering events if data has changed.
     * @param {Boolean} [silent] Specify `true` to not trigger events. If event is recurring, occurrences won't be updated automatically.
     * @category Editing
    */

  }, {
    key: "endBatch",
    value: function endBatch() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var skipAccessors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          parentIdField = me.constructor.parentIdField;

      if (!me.batching) {
        return;
      }

      me.batching--;

      if (me.batching > 0) {
        return;
      } // Set pending batch changes


      if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].isEmpty(me.meta.batchChanges)) {
        var batchChanges = _objectSpread({}, me.meta.batchChanges);

        me.meta.batchChanges = null; // Move to its new parent before applying the other changes.

        if (batchChanges[parentIdField]) {
          me.parentId = batchChanges[parentIdField];
          delete batchChanges[parentIdField];
        }

        me.set(batchChanges, _undefined, silent, false, skipAccessors);
        me.cancelBatch();
      }
    }
    /**
     * Cancels current batch operation. Any changes during the batch are discarded.
     * @category Editing
     */

  }, {
    key: "cancelBatch",
    value: function cancelBatch() {
      this.batching = null;
      this.meta.batchChanges = null;
    } //endregion
    //region Events

    /**
     * Triggers beforeUpdate event for each store and checks if changes can be made from event return value.
     * @param {Object} changes Data changes
     * @returns {Boolean} returns true if data changes are accepted
     * @private
     */

  }, {
    key: "triggerBeforeUpdate",
    value: function triggerBeforeUpdate(changes) {
      var _this2 = this;

      return !this.stores.some(function (s) {
        if (s.trigger('beforeUpdate', {
          record: _this2,
          changes: changes
        }) === false) {
          return true;
        }
      });
    } //endregion
    //region Additional functionality

    /**
     * Makes a copy of this model, assigning the specified id or a generated id and also allowing you to pass field values to
     * the created copy.
     *
     * ```
     * const record = new Model({ name : 'Super model', hairColor : 'Brown' });
     * const clone = new record.copy({ name : 'Super model clone' });
     * ```
     * @param {Number|String|Object} [newId] The id for the copied instance, or any field values to apply
     * (overriding the values from the source record). If no id provided, one will be auto-generated
     * @param {Number|String} [newId.id] DEPRECATED: Id to set, leave out to use generated id or specify false to also copy id
     * @param {Boolean} [newId.deep] DEPRECATED: true to also clone children (use separate argument)
     * @param {Boolean} [deep] True to also clone children
     * @returns {Core.data.Model} Copy of this model
     * @category Editing
     */

  }, {
    key: "copy",
    value: function copy() {
      var newId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var params = arguments.length > 1 ? arguments[1] : undefined;

      var me = this,
          data = _objectSpread({}, me.data),
          idField = me.constructor.idField;

      var deep, id; // Chrono model is adding more logic to copy and that logic should be manageable from arguments. So there is
      // option to pass object as a last argument to switch method behavior. Used internally only, shouldn't be public.

      deep = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].isObject(params) ? params.deep : params; // We do not include the id from this record

      if (newId !== false) {
        delete data[idField];
      }

      if (newId && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_28___default()(newId) === 'object') {
        id = newId.id;

        if ('deep' in newId) {
          deep = newId.deep;
          _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].deprecate('Grid', '5.0.0', '`deep` attribute deprecated, in favor of a separate second parameter'); // Only use id once to avoid collisions

          delete newId.id;
          delete newId.deep;
        } else {
          Object.assign(data, newId);
        }
      } else {
        id = newId;
      } // Iterate over instance children, because data may not reflect actual children state


      if (deep && me.children) {
        data.children = me.children.map(function (child) {
          return child.copy(undefined, params);
        });
      } else {
        delete data.children;
        delete data.expanded;
      } // No id dataSource value in the data copy.
      // We can use the value from the 'id' property, but as a fallback, generate the id.


      if (data[idField] == null) {
        data[idField] = id || me.generateId(me.firstStore);
      }

      var copy = new me.constructor(data); // Store original record internal id to lookup from copy later

      copy.originalInternalId = me.internalId;
      return copy;
    }
    /**
     * Removes this record from all stores (and in a tree structure, also from its parent if it has one).
     * @param {Boolean} [silent] Specify `true` to not trigger events. If event is recurring, occurrences won't be updated automatically.
     * @category Editing
     */

  }, {
    key: "remove",
    value: function remove() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          parent = this.parent; // Remove from parent if we're in a tree structure.
      // This informs the owning store(s)

      if (parent) {
        parent.removeChild(me);
      } // Store handles remove
      else if (me.stores.length) {
          // Not sure what should happen if you try to remove a special row (group row for example), bailing out
          if (!me.isSpecialRow) {
            me.stores.forEach(function (s) {
              return s.remove(me, silent, false, true);
            });
          }
        }
    }
    /**
     * Get the first store that this model is assigned to.
     * @returns {Core.data.Store}
     * @category Misc
     */

  }, {
    key: "getRelationConfig",

    /**
     * Get a relation config by name, from the first store.
     * @param {String} name
     * @returns {Object}
     * @private
     * @category Relations
     */
    value: function getRelationConfig(name) {
      var _this$firstStore, _this$firstStore$mode;

      // using first store for relations, might have to revise later..
      return (_this$firstStore = this.firstStore) === null || _this$firstStore === void 0 ? void 0 : (_this$firstStore$mode = _this$firstStore.modelRelations) === null || _this$firstStore$mode === void 0 ? void 0 : _this$firstStore$mode.find(function (r) {
        return r.fieldName === name;
      });
    } //endregion
    //region Validation

    /**
     * Check if record has valid data. Default implementation returns true, override in your model to do actual validation.
     * @returns {Boolean}
     * @category Editing
     */

  }, {
    key: "joinStore",
    //endregion
    //region Store

    /**
     * Joins this record and any children to specified store, if not already joined.
     * @internal
     * @param {Core.data.Store} store Store to join
     * @category Misc
     */
    value: function joinStore(store) {
      var me = this,
          stores = me.stores,
          unjoinedStores = me.unjoinedStores;

      if (!stores.includes(store)) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Model.prototype), "joinStore", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Model.prototype), "joinStore", this).call(this, store);
        store.register(me);
        stores.push(store);

        if (unjoinedStores.includes(store)) {
          unjoinedStores.splice(unjoinedStores.indexOf(store), 1);
        }

        me.isLoaded && me.children.forEach(function (child) {
          return child.joinStore(store);
        });
        me.initRelations();

        if (store.tree && !me.isRoot) {
          me.instanceMeta(store.id).collapsed = !me.expanded;
        }
      }
    }
    /**
     * Unjoins this record and any children from specified store, if already joined.
     * @internal
     * @param {Core.data.Store} store Store to join
     * @param {Boolean} [isReplacing] `true` if this record is being replaced
     * @category Misc
     */

  }, {
    key: "unJoinStore",
    value: function unJoinStore(store) {
      var isReplacing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          stores = me.stores,
          unjoinedStores = me.unjoinedStores;

      if (stores.includes(store)) {
        var _me$children;

        store.unregister(me);
        (_me$children = me.children) === null || _me$children === void 0 ? void 0 : _me$children.forEach(function (child) {
          return child.unJoinStore(store, isReplacing);
        });
        stores.splice(stores.indexOf(store), 1); // keep the cord to allow removed records to reach the store when needed

        unjoinedStores.push(store);
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Model.prototype), "unJoinStore", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Model.prototype), "unJoinStore", this).call(this, store, isReplacing); // remove from relation cache

        store.uncacheRelatedRecord(me);
      }
    }
    /**
     * Returns true if this record is contained in the specified store, or in any store if store param is omitted.
     * @internal
     * @param {Core.data.Store} store Store to join
     * @returns {Boolean}
     * @category Misc
     */

  }, {
    key: "isPartOfStore",
    value: function isPartOfStore(store) {
      if (store) {
        return store.includes(this);
      }

      return this.stores.length > 0;
    }
    /**
     * Returns true if this record is not part of any store.
     * @property {Boolean}
     * @readonly
     * @internal
     */

  }, {
    key: "instanceMeta",
    //endregion
    //region Per instance meta

    /**
     * Used to set per external instance meta data. For example useful when using a record in multiple grids to store some state
     * per grid.
     * @param {String|Object} instanceOrId External instance id or the instance itself, if it has id property
     * @private
     * @category Misc
     */
    value: function instanceMeta(instanceOrId) {
      var meta = this.meta,
          id = instanceOrId.id || instanceOrId;

      if (!meta.map) {
        meta.map = {};
      }

      return meta.map[id] || (meta.map[id] = {});
    }
  }, {
    key: "indexPath",

    /**
     * Returns index path to this node. This is the index of each node in the node path
     * starting from the topmost parent. (only relevant when its part of a tree store).
     * @returns {Number[]} The index of each node in the path from the topmost parent to this node.
     * @category Parent & children
     * @private
     */
    get: function get() {
      var indices = [];
      var node = this,
          depth = node.childLevel;

      for (node = this; node && !node.isRoot; node = node.parent) {
        indices[depth--] = node.parentIndex + 1;
      }

      return indices;
    }
  }, {
    key: "subclass",
    get: function get() {
      return new this.constructor(Object.setPrototypeOf({
        id: _undefined
      }, this.data), this.stores[0], null, true);
    }
    /**
     * Processes raw data, converting values and setting defaults.
     * @private
     * @param {Object} data Raw data
     * @param {Boolean} [ignoreDefaults] Ignore setting default values, used when updating
     * @returns {Object} Processed data
     * @category Fields
     */

  }, {
    key: "fieldMap",

    /**
     * Same as {@link #property-fieldMap-static}.
     * @property {Object}
     * @readonly
     * @category Fields
     */
    get: function get() {
      return this.$meta.fields.map;
    }
  }, {
    key: "fields",

    /**
     * Convenience getter to get field definitions from class.
     * @returns {Core.data.field.DataField[]}
     * @category Fields
     */
    get: function get() {
      return this.$meta.fields.defs;
    }
  }, {
    key: "fieldNames",
    get: function get() {
      return Object.keys(this.data);
    }
    /**
     * Get the definition for a field by name. Caches results.
     * @param {String} fieldName Field name
     * @returns {Core.data.field.DataField} Field definition or null if none found
     * @category Fields
     */

  }, {
    key: "isPersistable",
    get: function get() {
      return true;
    }
    /**
     * True if this model has any uncommitted changes.
     * @property {Boolean}
     * @readonly
     * @category Editing
     */

  }, {
    key: "isModified",
    get: function get() {
      return Boolean(this.meta.modified && Object.keys(this.meta.modified).length > 0);
    } // TODO: Make this the behaviour of isModified?

  }, {
    key: "hasPersistableChanges",
    get: function get() {
      return this.isPersistable && !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].isEmpty(this.rawModificationData);
    }
  }, {
    key: "modifications",
    get: function get() {
      var data = this.rawModifications;

      if (data && Object.keys(data).length) {
        data[this.constructor.idField] = this.id;
      }

      return data;
    }
  }, {
    key: "rawModifications",
    get: function get() {
      var me = this,
          data = {};

      if (!me.isModified) {
        return null;
      }

      var keySet = false;
      Object.keys(me.meta.modified).forEach(function (key) {
        // TODO: isModified will report record as modified even if a modification wont be persisted here. Should it?
        var value = me.getFieldPersistentValue(key);

        if (value !== _undefined) {
          data[key] = value;
          keySet = true;
        }
      });
      return keySet ? data : null;
    }
    /**
     * Get a map of the modified fields in form of an object. The field *dataSources* are used as the property names
     * in the returned object.
     * @property {Object}
     * @readonly
     * @category Editing
     */

  }, {
    key: "modificationData",
    get: function get() {
      var data = this.rawModificationData; // If there are some persistable field changes, append record id

      if (data && Object.keys(data).length) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setPath(data, this.constructor.getFieldDefinition(this.constructor.idField).dataSource, this.id);
      }

      return data;
    }
  }, {
    key: "rawModificationData",
    get: function get() {
      var me = this,
          fieldMap = me.constructor.fieldMap,
          data = {};

      if (!me.isModified) {
        return null;
      }

      var keySet = false;
      Object.keys(me.meta.modified).forEach(function (fieldName) {
        // TODO: isModified will report record as modified even if a modification wont be persisted here. Should it?
        var field = fieldMap[fieldName]; // No field definition means there's no original dataSource to update

        if (field === null || field === void 0 ? void 0 : field.persist) {
          var value = me.getFieldPersistentValue(fieldName);

          if (value !== _undefined) {
            _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setPath(data, field.dataSource, value);
            keySet = true;
          }
        }
      });
      return keySet ? data : null;
    }
    /**
     * Get persistable data in form of an object.
     * @property {Object}
     * @internal
     * @readonly
     * @category Editing
     */

  }, {
    key: "persistableData",
    get: function get() {
      var me = this,
          data = {};
      me.fields.forEach(function (field) {
        var value = me.getFieldPersistentValue(field);

        if (value !== _undefined) {
          if (field === null || field === void 0 ? void 0 : field.complexMapping) {
            _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setPath(data, field.dataSource, value);
          } else {
            data[field.dataSource] = value;
          }
        }
      });
      return data;
    }
    /**
     * True if this models changes are currently being committed.
     * @property {boolean}
     * @category Editing
     */

  }, {
    key: "isCommitting",
    get: function get() {
      return Boolean(this.meta.committing);
    }
  }, {
    key: "internalId",
    get: function get() {
      return this._internalId;
    }
    /**
     * Returns true if the record is new and has not been persisted (and received a proper id).
     * @property {Boolean}
     * @readonly
     * @category Identification
     */

  }, {
    key: "isPhantom",
    get: function get() {
      return this.id === '' || this.id == null || this.hasGeneratedId;
    }
  }, {
    key: "isModel",
    get: function get() {
      return true;
    }
    /**
     * Checks if record has a generated id. New records are assigned a generated id (starting with _generated), which should be
     * replaced on commit.
     * @property {Boolean}
     * @category Identification
     */

  }, {
    key: "hasGeneratedId",
    get: function get() {
      return typeof this.id === 'string' && this.id.startsWith('_generated');
    }
  }, {
    key: "json",
    //endregion
    //region JSON

    /**
     * Get the records data as a json string.
     *
     * ```javascript
     * const record = new Model({
     *   title    : 'Hello',
     *   children : [
     *     ...
     *   ]
     * });
     *
     * const jsonString = record.json;
     *
     * //jsonString:
     * '{"title":"Hello","children":[...]}'
     * ```
     *
     * @member {String}
     * @category JSON
     */
    get: function get() {
      return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].safeJsonStringify(this); // calls our toJSON() method
    }
  }, {
    key: "isBatchUpdating",
    get: function get() {
      return Boolean(this.batching);
    }
  }, {
    key: "firstStore",
    get: function get() {
      return this.stores.length > 0 && this.stores[0];
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }, {
    key: "isRemoved",
    get: function get() {
      return !this.isPartOfStore();
    }
  }, {
    key: "isSpecialRow",
    get: function get() {
      return this.meta.specialRow;
    } //endregion

  }], [{
    key: "processData",
    value: function processData(data) {
      var ignoreDefaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = arguments.length > 2 ? arguments[2] : undefined;

      var fieldMap = this.fieldMap,
          defaultValues = this.defaultValues,
          _ref3 = store || {},
          _ref3$useRawData = _ref3.useRawData,
          useRawData = _ref3$useRawData === void 0 ? {
        enabled: false
      } : _ref3$useRawData,
          processed = useRawData.enabled ? data : _objectSpread({}, data);

      var fieldName;
      ignoreDefaults = ignoreDefaults || useRawData.disableDefaultValue;

      if (!ignoreDefaults) {
        for (fieldName in defaultValues) {
          if (processed[fieldName] === _undefined) {
            processed[fieldName] = defaultValues[fieldName];
          }
        }
      }

      if (!useRawData.disableTypeConversion) {
        // Convert field types which need converting
        for (fieldName in fieldMap) {
          var field = fieldMap[fieldName],
              name = field.name,
              dataSource = field.dataSource,
              hasSource = dataSource !== name,
              sourceExists = hasSource && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].pathExists(data, dataSource),
              useNameForValue = name in data && (!hasSource || !sourceExists),
              convert = !useRawData.disableTypeConversion && field.convert; // Only action field definitions which have a convert function or remap data

          if (useNameForValue || convert) {
            // When ignoringDefaults, do not convert unspecified values
            if (!ignoreDefaults || useNameForValue || sourceExists) {
              var value = useNameForValue ? processed[name] : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getPath(processed, dataSource);
              _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setPath(processed, dataSource, convert ? field.convert(value) : value); // Remove [startDate] from internal data holder, only keeping [myStartDate]

              if (hasSource) {
                delete processed[name];
              }
            }
          }
        }
      }

      return processed;
    }
  }, {
    key: "setupClass",
    value: function setupClass(meta) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Model), "setupClass", this).call(this, meta);

      if (!meta.fields) {
        // Normally setupFields will only run when a Model defines a fields getter, but we want to always run it:
        this.setupFields(this, meta);
      }
    }
  }, {
    key: "setupFields",
    value: function setupFields(cls, meta) {
      var _base$defs$slice, _base$exposed, _base$ordinals, _base$map, _base$sources;

      var classFields = hasOwnProperty.call(cls, 'fields') && cls.fields,
          base = meta.super.fields,
          fieldsInfo = meta.fields = {
        defs: (_base$defs$slice = base === null || base === void 0 ? void 0 : base.defs.slice()) !== null && _base$defs$slice !== void 0 ? _base$defs$slice : [],
        // Set to true when an instance's data object is run through exposeProperties
        exposedData: false,
        // These objects are all keyed by field name:
        defaults: base ? _objectSpread({}, base.defaults) : {},
        // value=field.defaultValue
        exposed: Object.create((_base$exposed = base === null || base === void 0 ? void 0 : base.exposed) !== null && _base$exposed !== void 0 ? _base$exposed : null),
        // value=true if we've done defineProperty
        ordinals: Object.create((_base$ordinals = base === null || base === void 0 ? void 0 : base.ordinals) !== null && _base$ordinals !== void 0 ? _base$ordinals : null),
        // value=index in the defs array
        map: Object.create((_base$map = base === null || base === void 0 ? void 0 : base.map) !== null && _base$map !== void 0 ? _base$map : null),
        // value=definition object
        sources: Object.create((_base$sources = base === null || base === void 0 ? void 0 : base.sources) !== null && _base$sources !== void 0 ? _base$sources : null) // value=source definition object

      }; // We use Object.create(null) as the base for these maps because some models declare "constructor" as a field
      // NOTE: instead of chaining the defaults, we copy them so the defaults object can be used with Object.assign
      // in other contexts (since it does not copy inherited properties from the prototype chain)
      // Clone the superclass's defaults, and override that with our own defaults.
      // As we find fields with a defaultValue, more defaults may be added

      if (hasOwnProperty.call(cls, 'defaults')) {
        Object.assign(fieldsInfo.defaults, cls.defaults);
      } // Hook up our field maps with the class hierarchy's fieldMaps.
      // We need to be able to look up field definitions by the name, or by the dataSource property name
      // If the idField is overridden at this level, create a new field


      if (hasOwnProperty.call(cls, 'idField')) {
        cls.addField({
          name: 'id',
          dataSource: cls.idField
        });
        fieldsInfo.exposed[cls.idField] = true;
      } // Process fields defined in the class definition


      if (classFields === null || classFields === void 0 ? void 0 : classFields.length) {
        classFields.map(cls.addField, cls);
      }

      cls.exposeRelations();
    }
  }, {
    key: "exposeProperties",

    /**
     * Makes getters and setters for fields (from definitions and data). Called once when class is defined and once when
     * data is loaded first time.
     * @internal
     * @param {Object} [data] Raw data
     * @category Fields
     */
    value: function exposeProperties(data) {
      var me = this,
          fieldsInfo = me.$meta.fields; // Process the raw data properties and expose them as fields unless the property name
      // has already been used by the "dataSource" of a defined field.

      if (data && me.autoExposeFields && !fieldsInfo.exposedData) {
        var dataProperty, fieldDef, type;

        for (dataProperty in data) {
          if (!fieldsInfo.exposed[dataProperty]) {
            type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_28___default()(data[dataProperty]); // Create a field definition in our fieldMap with the flag that it's from data

            fieldDef = {
              name: dataProperty,
              dataSource: dataProperty,
              fromData: true
            };

            if (type === 'boolean' || type === 'number') {
              fieldDef.type = type;
            }

            me.addField(fieldDef);
          }
        }

        fieldsInfo.exposedData = true;
      }

      me.exposeRelations();
    }
    /**
     * Add a field definition in addition to those predefined in `fields`.
     * @param {String|Object} fieldDef A field name or definition
     */

  }, {
    key: "addField",
    value: function addField(fieldDef) {
      if (fieldDef == null) {
        return;
      }

      if (typeof fieldDef === 'string') {
        fieldDef = {
          name: fieldDef
        };
      }

      var me = this.initClass(),
          fieldsInfo = me.$meta.fields,
          ordinals = fieldsInfo.ordinals,
          propertiesExposed = fieldsInfo.exposed,
          _fieldDef = fieldDef,
          name = _fieldDef.name,
          existing = fieldsInfo.map[name],
          dataSource = fieldDef.dataSource || (fieldDef.dataSource = name);
      var field, key;

      if (!existing || fieldDef.type && fieldDef.type !== existing.type) {
        field = _field_DataField_js__WEBPACK_IMPORTED_MODULE_42__["default"].create(fieldDef);
        field.definedBy = existing ? existing.definedBy : me;
        field.ordinal = existing ? existing.ordinal : ordinals[name] = fieldsInfo.defs.length;
      } else {
        field = Object.create(existing);

        for (key in fieldDef) {
          if (key !== 'type') {
            field[key] = fieldDef[key];
          }
        }
      }

      field.owner = me;
      fieldsInfo.defs[field.ordinal] = field;
      fieldsInfo.map[name] = field;

      if (!fieldsInfo.sources[dataSource]) {
        fieldsInfo.sources[dataSource] = field;
      } // With complex mapping avoid exposing object as model field


      if (dataSource.includes('.')) {
        field.complexMapping = true;
      }

      if (field.complexMapping) {
        // model fields have this set on their prototype...
        propertiesExposed[dataSource.split('.')[0]] = true;
      } else {
        // When iterating through the raw data, if autoExposeFields is set
        // We do not need to create properties for raw property names we've processed here
        propertiesExposed[dataSource] = true;
      } // Maintain an object of defaultValues for fields.


      if ('defaultValue' in field) {
        fieldsInfo.defaults[dataSource] = field.defaultValue;
      } // Create a property on this Model's prototype, named for the defined field name
      // which reads the correct property out of the raw data object.


      if (!internalProps[name]) {
        field.defineAccessor(me.prototype);
      }

      return field;
    }
    /**
     * Remove a field definition by name.
     * @param {String} fieldName Field name
     */

  }, {
    key: "removeField",
    value: function removeField(fieldName) {
      var me = this.initClass(),
          fieldsInfo = me.$meta.fields,
          definition = fieldsInfo.map[fieldName],
          ordinals = fieldsInfo.ordinals,
          index = ordinals[fieldName];

      if (definition) {
        fieldsInfo.defs.splice(index, 1);
        delete ordinals[fieldName];
        delete fieldsInfo.defaults[fieldName];
        delete fieldsInfo.exposed[fieldName];
        delete fieldsInfo.map[fieldName];
        delete fieldsInfo.sources[definition.dataSource];

        for (var name in ordinals) {
          if (ordinals[name] > index) {
            --ordinals[name];
          }
        } // Note: if field was exposed by superclass, this won't do anything...


        delete me.prototype[fieldName];
      }
    }
    /**
     * Makes getters and setters for related records. Populates a Model#relation array with the relations, to allow it
     * to be modified later when assigning stores.
     * @internal
     * @category Relations
     */

  }, {
    key: "exposeRelations",
    value: function exposeRelations() {
      var me = this;

      if (hasOwnProperty.call(me, 'relationsExposed')) {
        return;
      }

      if (me.relationConfig) {
        me.relationsExposed = true;
        me.relations = [];
        me.relationConfig.forEach(function (relation) {
          me.relations.push(relation);
          var name = relation.relationName; // getter and setter for related object

          if (!Reflect.ownKeys(me.prototype).includes(name)) {
            defineProperty(me.prototype, name, {
              enumerable: true,
              get: function get() {
                // noinspection JSPotentiallyInvalidUsageOfClassThis
                return this.getForeign(name);
              },
              set: function set(value) {
                // noinspection JSPotentiallyInvalidUsageOfClassThis
                this.setForeign(name, value, relation);
              }
            });
          }
        });
      }
    } //endregion
    //region Fields

    /**
     * Flag checked from Store when loading data that determines if fields found in first records should be exposed in
     * same way as predefined fields.
     * @returns {Boolean}
     * @category Fields
     */

  }, {
    key: "getFieldDefinition",
    value: function getFieldDefinition(fieldName) {
      return this.$meta.fields.map[fieldName];
    }
    /**
     * Returns dataSource configuration for a given field name
     * @param {String} fieldName
     * @returns {String} Field `dataSource` mapping
     * @internal
     */

  }, {
    key: "getFieldDataSource",
    value: function getFieldDataSource(fieldName) {
      return this.getFieldDefinition(fieldName).dataSource;
    }
  }, {
    key: "processField",
    value: function processField(fieldName, value) {
      var field = this.fieldMap[fieldName];
      return (field === null || field === void 0 ? void 0 : field.convert) ? field.convert(value) : value;
    }
  }, {
    key: "generateId",
    value: function generateId() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$$name;

      if (!this.generatedIdIndex) {
        this.generatedIdIndex = 0;
      }

      return "_generated".concat(text).concat(++this.generatedIdIndex);
    }
  }, {
    key: "asId",
    value: function asId(model) {
      return (model === null || model === void 0 ? void 0 : model.isModel) ? model.id : model;
    }
  }, {
    key: "$name",
    get: function get() {
      return 'Model';
    }
  }, {
    key: "declarable",
    get: function get() {
      return [
      /**
       * Array of defined fields for this model class. Subclasses add new fields by implementing this static
       * getter:
       *
       * ```javascript
       * // Model defining two fields
       * class Person extends Model {
       *     static get fields() {
       *         return [
       *             { name : 'username', defaultValue : 'New person' },
       *             { name : 'birthdate', type : 'date' }
       *         ];
       *     }
       * }
       *
       * // Subclass overriding one of the fields
       * class Bot extends Person {
       *     static get fields() {
       *         return [
       *             // Default value of 'username' field is overridden, any other setting from the parents
       *             // definition is preserved
       *             { name : 'username', defaultValue : 'Bot' }
       *         ];
       *     }
       * }
       * ```
       *
       * Fields in a subclass are merged with those from the parent class, making it easy to override mappings,
       * formats etc.
       *
       * @member {Object[]|Core.data.field.DataField[]} fields
       * @readonly
       * @static
       * @category Fields
       */
      'fields'];
    }
  }, {
    key: "fields",
    get: function get() {
      return [// The index of this item in its parent (respects filtering)
      {
        name: 'parentIndex',
        type: 'number',
        persist: false
      }];
    }
    /**
     * Template static getter which is supposed to be overridden to define default field values for the Model class.
     * Overrides `defaultValue` config specified by the {@link #property-fields-static} getter.
     * Returns a named object where key is a field name and value is a default value for the field.
     *
     * NOTE: This is a legacy way of defining default values, we recommend using {@link #property-fields-static} moving
     * forward.
     *
     * ```javascript
     * class Person extends Model {
     *     static get fields() {
     *         return [
     *             { name : 'username', defaultValue : 'New person' }
     *         ];
     *     }
     * }
     *
     * class Bot extends Person {
     *     static get defaults() {
     *         return {
     *             username : 'Bot' // default value of 'username' field is overridden
     *         };
     *     }
     * }
     * ```
     *
     * @member {Object[]} defaults
     * @static
     * @category Fields
     */
    // TODO: deprecate in 5.0 in favor of static fields getter
    // static get defaults() {
    //     return {};
    // }

    /**
     * The name of the data field which provides the ID of instances of this Model.
     * @property {String}
     * @category Fields
     */

  }, {
    key: "idField",
    set: function set(idField) {
      this._assignedIdField = true;
      this._idField = idField;
    },
    get: function get() {
      return this._idField;
    }
    /**
     * The name of the data field which holds children of this Model when used in a tree structure
     * ```javascript
     * MyModel.childrenField = 'kids';
     * const parent = new MyModel({
     *   name : 'Dad',
     *   kids : [
     *     { name : 'Daughter' },
     *     { name : 'Son' }
     *   ]
     * });
     * ```
     * @property {String}
     * @category Fields
     */

  }, {
    key: "childrenField",
    set: function set(childrenField) {
      this._childrenField = childrenField;
    },
    get: function get() {
      return this._childrenField || 'children';
    }
  }, {
    key: "defaultValues",
    get: function get() {
      return this.$meta.fields.defaults;
    }
    /**
     * An object containing all the _defined_ fields for this Model class. This will include all superclass's
     * defined fields through its prototype chain. So be aware that `Object.keys` and `Object.entries` will only
     * access this class's defined fields.
     * @property {Object}
     * @static
     * @readonly
     * @category Fields
     */

  }, {
    key: "fieldMap",
    get: function get() {
      return this.$meta.fields.map;
    }
  }, {
    key: "fieldDataSourceMap",
    get: function get() {
      return this.$meta.fields.sources;
    }
  }, {
    key: "autoExposeFields",
    get: function get() {
      return true;
    }
  }]);

  return Model;
}(_Base_js__WEBPACK_IMPORTED_MODULE_36__["default"].mixin(_stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_40__["default"], _mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_41__["default"]));


Model._idField = 'id';
Model._internalIdCounter = 1;
Model._assignedIdField = false;
Model.exposeProperties();
Model._$name = 'Model';

/***/ }),

/***/ "./lib/Core/data/Store.js":
/*!********************************!*\
  !*** ./lib/Core/data/Store.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Store; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_web_url_to_json__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/web.url.to-json */ "./node_modules/core-js/modules/web.url.to-json.js");
/* harmony import */ var core_js_modules_web_url_to_json__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_to_json__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../mixin/Pluggable.js */ "./lib/Core/mixin/Pluggable.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_State_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../mixin/State.js */ "./lib/Core/mixin/State.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _Model_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _StoreBag_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./StoreBag.js */ "./lib/Core/data/StoreBag.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./mixin/StoreCRUD.js */ "./lib/Core/data/mixin/StoreCRUD.js");
/* harmony import */ var _mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./mixin/StoreFilter.js */ "./lib/Core/data/mixin/StoreFilter.js");
/* harmony import */ var _mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./mixin/StoreGroup.js */ "./lib/Core/data/mixin/StoreGroup.js");
/* harmony import */ var _mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./mixin/StoreProxy.js */ "./lib/Core/data/mixin/StoreProxy.js");
/* harmony import */ var _mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./mixin/StoreRelation.js */ "./lib/Core/data/mixin/StoreRelation.js");
/* harmony import */ var _mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./mixin/StoreSum.js */ "./lib/Core/data/mixin/StoreSum.js");
/* harmony import */ var _mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./mixin/StoreSearch.js */ "./lib/Core/data/mixin/StoreSearch.js");
/* harmony import */ var _mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./mixin/StoreSort.js */ "./lib/Core/data/mixin/StoreSort.js");
/* harmony import */ var _mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ./mixin/StoreChained.js */ "./lib/Core/data/mixin/StoreChained.js");
/* harmony import */ var _mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ./mixin/StoreState.js */ "./lib/Core/data/mixin/StoreState.js");
/* harmony import */ var _mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ./mixin/StoreTree.js */ "./lib/Core/data/mixin/StoreTree.js");
/* harmony import */ var _mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ./mixin/StoreSync.js */ "./lib/Core/data/mixin/StoreSync.js");
/* harmony import */ var _stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ./stm/mixin/StoreStm.js */ "./lib/Core/data/stm/mixin/StoreStm.js");

















































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_47___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_47___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_46___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/* eslint-disable no-unused-expressions */

/**
 * @module Core/data/Store
 */

























/**
 * The Store represents a data container which holds flat data or tree structures. An item in the Store is often called a ´record´ and it is simply an instance of the
 * {@link Core.data.Model} (or any subclass thereof). Typically you load data into a store to display it in a Grid or a ComboBox. The Store is the backing data component for any component that is showing data in a list style UI.
 *
 * * {@link Grid.view.Grid}
 * * {@link Grid.view.TreeGrid}
 * * {@link Core.widget.List}
 * * {@link Core.widget.Combo}
 *
 * ## Data format
 * Data is store in a JSON array the Store offers an API to edit, filter, group and sort the records.
 *
 * ## Store with flat data
 * To create a flat store simply provide an array of objects that describe your records
 *
 * ```javascript
 * let store = new Store({
 *   data : [
 *     { id : 1, name : 'ABBA', country : 'Sweden' },
 *     { id : 2, name : 'Beatles', country : 'UK' }
 *   ]
 * });
 *
 * // retrieve record by id
 * let beatles = store.getById(2);
 * ```
 *
 * ## Store with tree data
 * To create a tree store use `children` property for descendant records
 *
 * ```javascript
 * let store = new Store({
 *   tree: true,
 *   data : [
 *     { id : 1, name : 'ABBA', country : 'Sweden', children: [
 *       { id: 2, name: 'Agnetha' },
 *       { id: 3, name: 'Bjorn' },
 *       { id: 4, name: 'Benny' },
 *       { id: 5, name: 'Anni-Frid' }
 *     ]},
 *   ]
 * });
 *
 * // retrieve record by id
 * let benny = store.getById(4);
 * ```
 *
 * ### Retrieving and consuming JSON
 * For both flat stores or tree stores it is possible to retrieve the data of all records in JSON format:
 *
 * ```javascript
 * const jsonString = store.json;
 *
 * // or
 *
 * const jsonArray = store.toJSON();
 * ```
 *
 * To plug the JSON data back in later:
 *
 * ```javascript
 * store.data = JSON.parse(jsonString);
 *
 * // or
 *
 * store.data = jsonArray;
 * ```
 *
 * ## Sharing stores
 * You cannot directly share a Store between widgets, but the data in a Store can be shared. There are two different
 * approaches depending on your needs, sharing data and chaining stores:
 *
 * ### Shared data
 * To create 2 widgets that share data, you can create 2 separate stores and pass records of the first store as the
 * dataset of the second store.
 *
 * ```javascript
 * let combo1 = new Combo({
 *     appendTo : document.body,
 *     store    : new Store({
 *         data : [
 *             { id : 1, name : 'ABBA', country : 'Sweden' },
 *             { id : 2, name : 'Beatles', country : 'UK' }
 *         ]
 *     }),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * let combo2 = new Combo({
 *     appendTo : document.body,
 *     store    : new Store({
 *         data : combo1.store.records
 *     }),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * combo1.store.first.name = 'foo';
 * combo2.store.first.name; // "foo"
 * ```
 *
 * ### Chained stores
 * Another more powerful option to share data between widgets is to create {@link Core.data.mixin.StoreChained chained stores}.
 * The easiest way to create a chained store is to call {@link #function-chain} function.
 *
 * ```javascript
 * let combo1 = new Combo({
 *     appendTo : document.body,
 *     store    : new Store({
 *         data : [
 *             { id : 1, name : 'ABBA', country : 'Sweden' },
 *             { id : 2, name : 'Beatles', country : 'UK' }
 *         ]
 *     }),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * let combo2 = new Combo({
 *     appendTo : document.body,
 *     store    : combo1.store.chain(),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * combo1.store.first.name = 'foo';
 * combo2.store.first.name; // "foo"
 * ```
 *
 * A chained store can optionally be created with a filtering function, to only contain a subset of the records from
 * the main store. In addition, the chained store will reflect record removals/additions to the master store, something
 * the shared data approach will not.
 *
 * @mixes Core/data/mixin/StoreChained
 * @mixes Core/data/mixin/StoreCRUD
 * @mixes Core/data/mixin/StoreFilter
 * @mixes Core/data/mixin/StoreGroup
 * @mixes Core/data/mixin/StoreSearch
 * @mixes Core/data/mixin/StoreSort
 * @mixes Core/data/mixin/StoreState
 * @mixes Core/data/mixin/StoreSum
 * @mixes Core/data/mixin/StoreTree
 * @mixes Core/mixin/Events
 * @mixes Core/data/stm/mixin/StoreStm
 *
 * @extends Core/Base
 */

var Store = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_45___default()(Store, _Base$mixin);

  var _super = _createSuper(Store);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_44___default()(Store, null, [{
    key: "properties",
    //region Config & properties
    get: function get() {
      return {
        relationCache: {},
        dependentStoreConfigs: new Map()
      };
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Store's unique identifier. When set the store is added to a store map accessible through Store#getStore(id)
         * @config {String|Number}
         * @category Common
         */
        id: true,

        /**
         * An array of field definitions used to create a Model (modelClass) subclass. Optional. If the Model
         * already has fields defined, these fields will extend those.
         * @config {Object[]}
         * @category Common
         */
        fields: null,

        /**
         * Automatically detect from set data if used as tree store or flat store
         * @config {Boolean}
         * @default
         * @category Tree
         */
        autoTree: true,

        /**
         * Class used to represent records
         * @config {Core.data.Model}
         * @default
         * @category Common
         * @typings { new(data: object): Model }
         */
        modelClass: _Model_js__WEBPACK_IMPORTED_MODULE_53__["default"],

        /**
         * Raw data to load initially
         * @config {Object[]}
         * @category Common
         */
        data: null,

        /**
         * `true` to act as a tree store.
         * @config {Boolean}
         * @category Tree
         */
        tree: false,
        callOnFunctions: true,

        /**
         * A {@link Core.util.Collection Collection}, or Collection config object
         * to use to contain this Store's constituent records.
         * @config {Core.util.Collection|Object}
         */
        storage: null,

        /**
         * Retools the loaded data objects instead of making shallow copies of them. This increases performance but
         * pollutes the incoming data and does not allow remapping of fields (dataSource).
         *
         * Also allows disabling certain steps in data loading, to further improve performance. Either accepts an
         * object with the params described below or `true` which equals `disableDuplicateIdCheck` and
         * `disableTypeConversion`.
         *
         * ```javascript
         * // No duplicate id checking, no type conversions
         * new Store({ useRawData : true });
         *
         * new Store({
         *   // No type conversions only
         *   useRawData : {
         *     disableTypeConversion : true
         *   }
         * });
         * ```
         *
         * @config {Boolean|Object}
         * @param {Boolean} [disableDuplicateIdCheck] Data must not contain duplicate ids, check is bypassed.
         * @param {Boolean} [disableDefaultValue] Default values will not be applied to record fields.
         * @param {Boolean} [disableTypeConversion] No type conversions will be performed on record data.
         * @category Advanced
         */
        useRawData: false,

        /**
         * Specify `false` to prevent loading records without ids, a good practise to enforce when syncing with a
         * backend. By default Store allows loading records without ids, in which case a generated id will be
         * assigned.
         * @config {Boolean}
         * @default true
         * @category Advanced
         */
        allowNoId: true,

        /**
         * Prevent dynamically subclassing the modelClass. It does so by default to not pollute it when exposing
         * properties. Should rarely need to be used.
         * @config {Boolean}
         * @default false
         * @private
         * @category Advanced
         */
        preventSubClassingModel: null
      };
    }
  }, {
    key: "identifiable",
    get: function get() {
      return {};
    } //endregion
    //region Events

    /**
     * Fired when the id of a record has changed
     * @event idChange
     * @param {Core.data.Store} source This Store
     * @param {Core.data.Model} record Modified record
     * @param {String|Number} oldValue Old id
     * @param {String|Number} value New id
     */

    /**
     * Fired before record is modified in this store.
     * Modification may be vetoed by returning `false` from a handler.
     * @event beforeUpdate
     * @param {Core.data.Store} source This Store
     * @param {Core.data.Model} record Modified record
     * @param {Object} changes Modification data
     */

    /**
     * Fired when a record is modified
     * @event update
     * @param {Core.data.Store} source This Store
     * @param {Core.data.Model} record Modified record
     * @param {Object} changes Modification data
     */

    /**
     * Fired when the root node is set
     * @event rootChange
     * @param {Core.data.Store} source This Store
     * @param {Core.data.Model} oldRoot The old root node.
     * @param {Core.data.Model} rootNode The new root node.
     */

    /**
     * Data in the store was changed. This is a catch-all event which is fired for all changes
     * which take place to the store's data.
     *
     * This includes mutation of individual records, adding and removal of records, as well as
     * setting a new data payload using the {@link #property-data} property, sorting, filtering,
     * and calling {@link Core.data.mixin.StoreCRUD#function-removeAll}.
     *
     * Simple databound widgets may use to the `change` event to refresh their UI without having to add multiple
     * listeners to the {@link #event-update}, {@link Core.data.mixin.StoreCRUD#event-add}, {@link Core.data.mixin.StoreCRUD#event-remove}, {@link #event-refresh}
     * and {@link Core.data.mixin.StoreCRUD#event-removeAll} events.
     *
     * A more complex databound widget such as a grid may use the more granular events to perform less
     * destructive updates more appropriate to each type of change. The properties will depend upon the value of the `action` property.
     * @event change
     * @param {Core.data.Store} source This Store.
     * @param {String} action Name of action which triggered the change. May be one of:
     * * `'remove'`
     * * `'removeAll'`
     * * `'add'`
     * * `'updatemultiple'`
     * * `'clearchanges'`
     * * `'filter'`
     * * `'sort'`
     * * `'update'`
     * * `'dataset'`
     * * `'replace'`
     */

    /**
     * Data in the store has completely changed, such as by a filter, or sort or load operation.
     * @event refresh
     * @param {Core.data.Store} source This Store.
     * @param {Boolean} batch Flag set to `true` when the refresh is triggered by ending a batch
     * @param {String} action Name of action which triggered the change. May be one of:
     * * `'dataset'`
     * * `'sort'`
     * * `'filter'`
     * * `'create'`
     * * `'update'`
     * * `'delete'`
     * * `'group'`.
     */
    //endregion
    //region Init

  }]);

  function Store() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42___default()(this, Store);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args)); // When using a Proxy, the Proxy is returned instead of the actual Store

    if (_this.objectify) {
      return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_46___default()(_this, _this.initProxy());
    }

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_44___default()(Store, [{
    key: "construct",
    value: function construct() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this;
      Object.assign(me, {
        added: new _StoreBag_js__WEBPACK_IMPORTED_MODULE_57__["default"](),
        removed: new _StoreBag_js__WEBPACK_IMPORTED_MODULE_57__["default"](),
        modified: new _StoreBag_js__WEBPACK_IMPORTED_MODULE_57__["default"](),
        idRegister: {},
        internalIdRegister: {}
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_43___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_47___default()(Store.prototype), "construct", this).call(this, config);

      me.initRelations();
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this,
          allRecords = me.registeredRecords;

      for (var i = allRecords.length - 1, rec; i >= 0; i--) {
        var _rec;

        rec = allRecords[i];

        if (!((_rec = rec) === null || _rec === void 0 ? void 0 : _rec.isDestroyed)) {
          rec.unJoinStore(me);
        }
      }

      me.storage.destroy(); // Remove from STM if added there

      if (me.stm) {
        me.stm.removeStore(me);
      } // Events superclass fires destroy event.


      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_43___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_47___default()(Store.prototype), "doDestroy", this).call(this); //TODO abort any ongoing loads

    }
    /**
     * Stops this store from firing events until {@link #function-endBatch} is called. Multiple calls to `beginBatch`
     * stack up, and will require an equal number of `endBatch` calls to resume events.
     *
     * Upon call of {@link #function-endBatch}, a {@link #event-refresh} event is triggered to allow UIs to
     * update themselves based upon the new state of the store.
     *
     * This is extremely useful when making a large number of changes to a store. It is important not to trigger
     * too many UI updates for performance reasons. Batching the changes ensures that UIs attached to this
     * store are only updated once at the end of the updates.
     */

  }, {
    key: "beginBatch",
    value: function beginBatch() {
      this.suspendEvents();
    }
    /**
     * Ends event suspension started by {@link #function-beginBatch}. Multiple calls to {@link #function-beginBatch}
     * stack up, and will require an equal number of `endBatch` calls to resume events.
     *
     * Upon call of `endBatch`, a {@link #event-refresh} event with `action: batch` is triggered to allow UIs to update
     * themselves based upon the new state of the store.
     *
     * This is extremely useful when making a large number of changes to a store. It is important not to trigger
     * too many UI updates for performance reasons. Batching the changes ensures that UIs attached to this
     * store are only updated once at the end of the updates.
     */

  }, {
    key: "endBatch",
    value: function endBatch() {
      if (this.resumeEvents()) {
        this.trigger('refresh', {
          action: 'batch',
          data: this.storage.values,
          records: this.storage.values
        });
      }
    }
  }, {
    key: "onDataChange",

    /**
     * Responds to mutations of the underlying storage Collection
     * @param {Object} event
     * @protected
     */
    value: function onDataChange(_ref) {
      var storage = _ref.source,
          action = _ref.action,
          added = _ref.added,
          removed = _ref.removed,
          replaced = _ref.replaced,
          oldCount = _ref.oldCount,
          item = _ref.item,
          from = _ref.from,
          to = _ref.to;
      var me = this,
          addedCount = added === null || added === void 0 ? void 0 : added.length,
          removedCount = removed === null || removed === void 0 ? void 0 : removed.length;
      var filtersWereReapplied;
      me._idMap = null;

      if (addedCount) {
        added.forEach(function (added) {
          added.joinStore(me);
        });
      }

      replaced === null || replaced === void 0 ? void 0 : replaced.forEach(function (_ref2) {
        var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_41___default()(_ref2, 2),
            oldRecord = _ref3[0],
            newRecord = _ref3[1];

        oldRecord.unJoinStore(me, true);
        newRecord.joinStore(me);
      }); // Allow mixins to mutate the storage before firing events.
      // StoreGroup does this to introduce group records into the mix.

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_43___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_47___default()(Store.prototype), "onDataChange", this).apply(this, arguments); // Join/unjoin incoming/outgoing records unless its as a result of TreeNode operations.
      // If we are a tree, joining is done when nodes are added/removed
      // as child nodes of a joined parent.


      if (!me.isTree) {
        if (addedCount) {
          var _iterator = _createForOfIteratorHelper(added),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var record = _step.value;

              // If was removed, remove from `removed` list
              if (me.removed.includes(record)) {
                me.removed.remove(record);
              } // Else add to `added` list
              else {
                  me.added.add(record);
                }
            } // Re-evaluate the current *local* filter set silently so that the
            // information we are broadcasting below is up to date.

          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          filtersWereReapplied = !me.remoteFilter && me.filtered && me.reapplyFilterOnAdd;

          if (filtersWereReapplied) {
            me.filter({
              silent: true
            });
          }
        }

        if (removedCount) {
          var _iterator2 = _createForOfIteratorHelper(removed),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _record = _step2.value;

              _record.unJoinStore(me); // If was newly added, remove from `added` list


              if (me.added.includes(_record)) {
                me.added.remove(_record);
              } // Else add to `removed` list
              // (unless it's StateTrackingManager reverting the record insertion)
              else if (!_record._undoingInsertion) {
                  me.removed.add(_record);
                }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          me.modified.remove(removed); // Re-evaluate the current *local* filter set silently so that the
          // information we are broadcasting below is up to date.

          filtersWereReapplied = !me.remoteFilter && me.filtered;

          if (filtersWereReapplied) {
            me.filter({
              silent: true
            });
          }
        }
      }

      switch (action) {
        case 'clear':
          // Clear our own relationCache, since we will be empty
          me.relationCache = {}; // Signal to stores that depend on us

          me.updateDependentStores('removeall');
          me.trigger('removeAll');
          me.trigger('change', {
            action: 'removeall'
          });
          break;

        case 'splice':
          if (addedCount) {
            me.updateDependentStores('add', added);
            var // Collection does not handle moves, figure out if and where a record was moved from by checking
            // previous index value stored in meta
            oldIndex = added.reduce(function (lowest, record) {
              var previousIndex = record.meta.previousIndex;
              if (previousIndex > -1 && previousIndex < lowest) lowest = previousIndex;
              return lowest;
            }, added[0].meta.previousIndex),
                index = storage.indexOf(added[0], !storage.autoFilter),
                params = {
              records: added,
              index: index
            }; // Only include param oldIndex when used

            if (oldIndex > -1) {
              params.oldIndex = oldIndex;
            }

            me.trigger('add', params);
            me.trigger('change', Object.assign({
              action: 'add'
            }, params));

            if (filtersWereReapplied) {
              me.triggerFilterEvent({
                action: 'filter',
                filters: me.filters,
                oldCount: oldCount,
                records: me.storage.allValues
              });
            }
          }

          if (removed.length) {
            me.updateDependentStores('remove', removed);
            me.trigger('remove', {
              records: removed
            });
            me.trigger('change', {
              action: 'remove',
              records: removed
            });
          }

          if (replaced.length) {
            // TODO: Remove in 2.2 if no problems til then
            // me.trigger('updateMultiple', {
            //     records : removed,
            //     all     : me.records.length === replaced.length
            // });
            me.trigger('replace', {
              records: replaced,
              all: me.records.length === replaced.length
            });
            me.trigger('change', {
              action: 'replace',
              replaced: replaced,
              all: me.records.length === replaced.length
            });
          }

          break;

        case 'filter':
          // Reapply grouping/sorting to make sure unfiltered records get sorted correctly
          if (me.isGrouped) {
            me.group(null, null, null, null, true);
          } else if (me.isSorted) {
            me.performSort(true);
          }

          break;

        case 'move':
          // silently update parentIndex of records affected
          for (var allRecords = me.storage.allValues, i = Math.min(from, to); i <= Math.max(from, to); i++) {
            allRecords[i].setData('parentIndex', i);
          }
          /**
           * Fired when a record has been moved within this Store
           * @event move
           * @param {Core.data.Store} source This Store
           * @param {Core.data.Model} record The record moved.
           * @param {Number} from The index from which the record was removed.
           * @param {Number} to The index at which the record was inserted.
           */


          me.trigger('move', {
            record: item,
            from: from,
            to: to
          });
          me.trigger('change', {
            action: action,
            record: item,
            from: from,
            to: to
          });
          break;
      }
    }
  }, {
    key: "onDataReplaced",
    value: function onDataReplaced(action, data) {
      var _me$afterLoadData;

      var me = this;
      me.storage.allValues.forEach(function (r) {
        r.joinStore(me);
      }); // Need to update group records info (headers and footers)

      me.prepareGroupRecords(me.storage.values); // Restore collapsed state

      me.restoreCollapsedGroups(); // The three operations below, filter, store and sort, all are passed
      // the "silent" parameter meaning they do not fire their own events.
      // The 'refresh' and 'change' events after are used to update UIs.

      if (!me.remoteFilter && me.isFiltered) {
        me.filter({
          silent: true
        });
      } // TODO: groupers must just be promoted to be the primary sorters.


      if (me.isGrouped) {
        me.group(null, null, false, !me.sorters.length, true);
      }

      if (!me.sortParamName && me.sorters.length) {
        me.sort(null, null, false, true);
      } // Check for duplicate ids, unless user guarantees data validity


      if (!me.useRawData.disableDuplicateIdCheck) {
        var idMap = me.idMap;

        if (Object.keys(idMap).length < me.storage.values.length) {
          // idMap has fewer entries than expected, a duplicate id was used. pick idMap apart to find out which
          var collisions = [];
          me.storage.values.forEach(function (r) {
            return idMap[r.id] ? delete idMap[r.id] : collisions.push(r);
          });
          throw new Error("Id collision on ".concat(collisions.map(function (r) {
            return r.id;
          })));
        }
      }

      var event = {
        action: action,
        data: data,
        records: me.storage.values
      };
      me.updateDependentStores(action, event.records); // Allow subclasses to postprocess a new dataset

      (_me$afterLoadData = me.afterLoadData) === null || _me$afterLoadData === void 0 ? void 0 : _me$afterLoadData.call(me);
      me.trigger('refresh', event);
      me.trigger('change', event);
    }
    /**
     * This is called from Model after mutating any fields so that Stores can take any actions necessary
     * at that point, and distribute mutation event information through events.
     * @param {Core.data.Model} record The record which has just changed
     * @param {Object} toSet A map of the field names and values that were passed to be set
     * @param {Object} wasSet A map of the fields that were set. Each property is a field name, and
     * the property value is an object containing two properties: `oldValue` and `value` eg:
     * ```javascript
     *     {
     *         name {
     *             oldValue : 'Rigel',
     *             value : 'Nigel'
     *         }
     *     }
     *
     * @param {Boolean} silent Do not trigger events
     * @param {Boolean} fromRelationUpdate Update caused by a change in related model
     * @private
     */

  }, {
    key: "onModelChange",
    value: function onModelChange(record, toSet, wasSet, silent, fromRelationUpdate) {
      var me = this,
          idField = record.constructor.idField,
          event = {
        record: record,
        changes: wasSet,
        // Cannot use isBatching, since change is triggered when batching has reached 0
        // (but before it is set to null)
        batch: record.batching != null,
        fromRelationUpdate: fromRelationUpdate
      },
          committable = record.ignoreBag ? false : me.updateModifiedBagForRecord(record); // Inform underlying collection of the changes, allowing it to keep any indices up to date

      this.storage.onItemMutation(record, wasSet);

      if (!silent) {
        if (idField in wasSet) {
          var _toSet$idField = toSet[idField],
              oldValue = _toSet$idField.oldValue,
              value = _toSet$idField.value;
          me.updateDependentRecordIds(oldValue, value);
          me.onRecordIdChange({
            record: record,
            oldValue: oldValue,
            value: value
          });
          me.trigger('idChange', {
            store: me,
            record: record,
            oldValue: oldValue,
            value: value
          });
        }

        me.onUpdateRecord(record, wasSet);
        me.trigger('update', event);
        me.trigger('change', Object.assign({
          action: 'update'
        }, event));
      }

      if (me.autoCommit && committable) {
        me.doAutoCommit();
      }
    }
  }, {
    key: "updateModifiedBagForRecord",
    value: function updateModifiedBagForRecord(record) {
      var me = this;
      var addedToBag = false; // Add or remove from our modified Bag

      if (record.isModified) {
        if (!me.modified.includes(record) && !me.added.includes(record) && record.isPartOfStore(me) && !record.isAutoRoot) {
          // When we add a new model first time and the model is not persistable (for example when the model is not valid),
          // it is not added to the "added" collection (StoreBag), but only joined to the store.
          // So if the record is not added neither to "modified" nor "added",
          // need to check if this record is phantom. If so, add it to the "added", otherwise to the "modified".
          if (record.isPhantom) {
            me.added.add(record);
          } else {
            me.modified.add(record);
          }

          addedToBag = true;
        }
      } else {
        me.modified.remove(record);
      }

      return addedToBag;
    }
  }, {
    key: "buildRootNode",
    // a hook to build a customized root node
    value: function buildRootNode() {
      return {};
    }
    /**
     * Get a store from the store map by id.
     * @param {String|Number|Object[]} id The id of the store to retrieve, or an array of objects
     * from which to create the contents of a new Store.
     * @returns {Core.data.Store} The store with the specified id
     */

  }, {
    key: "setStoreData",
    // For overridability in engine
    value: function setStoreData(data) {
      var me = this; // Make sure that if the plugins have not been processed yet, we call
      // the temporary property getter which configuration injects to
      // process plugins at this point. Some plugins are required to
      // operate on incoming data.

      me.getConfig('plugins'); // In case data is loaded during configuration before configuredListeners have been processed

      me.processConfiguredListeners(); // Allow data as a "named object", using keys as ids

      if (data && !Array.isArray(data)) {
        data = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_55__["default"].transformNamedObjectToArray(data, me.modelClass.idField);
      } // Convert to being a tree store if any of the new rows have a children property


      me.tree = !me.isChained && (me.tree || Boolean(me.autoTree && data && data.some(function (r) {
        return r[me.modelClass.childrenField];
      }))); // Always load a new dataset initially

      if (!me.syncDataOnLoad || !me._data) {
        me._data = data; // This means load the root node

        if (me.tree) {
          var root = me.rootNode; // Should signal stores to clear which clears UIs

          root.clearChildren(true);
          root.isLoading = true; // Append child will detect that this is a dataset operation and trigger sort + events needed

          root.appendChild(data);
          me.updateDependentStores('dataset', [root]);
          root.isLoading = false;

          if (data.length === 0) {
            me.trigger('refresh', {
              action: 'dataset',
              data: [],
              records: []
            });
          } // we must re-apply filters for the filtered tree store
          else if (me.isFiltered) {
              me.filter();
            }
        } else {
          me.loadData(data);
        } // loading the store discards all tracked changes


        me.added.clear();
        me.removed.clear();
        me.modified.clear();
      } // Sync dataset if configured to do so
      else {
          me.syncDataset(data);
        }
    }
  }, {
    key: "loadData",
    value: function loadData(data) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataset';
      var me = this,
          storage = me.storage,
          allowNoId = me.allowNoId,
          idField = me.modelClass.fieldMap.id.dataSource; // Having any of groups collapsed at the time of data reloading using the same dataset
      // makes new data look differ comparing to the data which is already in the store.
      // So here we expand all groups and save the state to collapse them later.
      // This might be expensive, but it helps to prevent Id collision failure for now.

      me.storeCollapsedGroups(); // Need to unregister all groups

      me.removeHeadersAndFooters(me.storage.values);
      me._idMap = null;

      if (data) {
        var isRaw = !(data[0] instanceof _Model_js__WEBPACK_IMPORTED_MODULE_53__["default"]);

        if (isRaw) {
          me.modelClass.exposeProperties(data[0]);
          var count = data.length,
              records = new Array(count);

          for (var i = 0; i < count; i++) {
            var recordData = data[i];

            if (!allowNoId && recordData[idField] == null) {
              throw new Error("Id required but not found on row ".concat(i));
            }

            records[i] = me.processRecord(me.createRecord(recordData, true), true);
            records[i].setData('parentIndex', i);
          }

          if (me.allCount) {
            // clear without marking as removed
            me.clear(false);
          } // Allow Collection's own filters to work on the Collection by
          // passing the isNewDataset param as true.
          // The storage Collection may have been set up with its own filters
          // while we are doing remote filtering. An example is ComboBox
          // with filterSelected: true. Records which are in the selection are
          // filtered out of visibility using a filter directly in the Combobox's
          // Store's Collection.


          storage.replaceValues({
            values: records,
            isNewDataset: true,
            silent: true
          });
        } else {
          if (me.allCount) {
            // clear without marking as removed
            me.clear(false);
          }

          storage.replaceValues({
            values: data.slice(),
            isNewDataset: true,
            silent: true
          });
        }

        me.onDataReplaced(action, data);
      } else {
        if (me.allCount) {
          // clear without marking as removed
          me.clear(false);
        }

        me._data = null;
      }
    }
  }, {
    key: "getRange",

    /**
     * Creates an array of records from this store from the `start` to the `end' - 1
     * @param {Number} [start] The index of the first record to return
     * @param {Number} [end] The index *after* the last record to return `(start + length)`
     * @return {Core.data.Model[]} The requested records.
     * @category Records
     */
    value: function getRange(start, end) {
      var all = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return (all ? this.storage.allValues : this.storage.values).slice(start, end);
    }
    /**
     * Creates a model instance, used internally when data is set/added. Override this in a subclass to do your own custom
     * conversion from data to record.
     * @param data Json data
     * @param skipExpose Supply true when batch setting to not expose properties multiple times
     * @category Records
     */

  }, {
    key: "createRecord",
    value: function createRecord(data) {
      var skipExpose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new this.modelClass(data, this, null, skipExpose);
    }
  }, {
    key: "processRecord",
    value: function processRecord(record) {
      var isDataset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return record;
    }
  }, {
    key: "refreshData",
    value: function refreshData() {
      this.filter();
      this.sort();
    }
  }, {
    key: "onRecordIdChange",
    value: function onRecordIdChange(_ref4) {
      var record = _ref4.record,
          oldValue = _ref4.oldValue,
          value = _ref4.value;
      var me = this,
          idMap = me._idMap,
          idRegister = me.idRegister;
      me.storage._indicesInvalid = true;

      if (idMap) {
        delete idMap[oldValue];
        idMap[value] = record;
      }

      me.added.changeId(oldValue, value);
      me.removed.changeId(oldValue, value);
      me.modified.changeId(oldValue, value);
      delete idRegister[oldValue];
      idRegister[value] = record;
      record.index = me.storage.indexOf(record);
    }
  }, {
    key: "onUpdateRecord",
    value: function onUpdateRecord(record, changes) {
      var internalId = changes.internalId,
          internalIdRegister = this.internalIdRegister;

      if (internalId) {
        this.storage._indicesInvalid = true;
        delete internalIdRegister[internalId.oldValue];
        internalIdRegister[internalId.value] = record;
      } // Reapply filters when records change?


      if (this.reapplyFilterOnUpdate && this.isFiltered) {
        this.filter();
      }
    }
  }, {
    key: "getCount",
    //endregion
    //region Count

    /**
     * Number of records in the store
     * @param countProcessed Count processed (true) or real records (false)
     * @returns {Number} Record count
     * @category Records
     */
    value: function getCount() {
      var countProcessed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return countProcessed ? this.count : this.originalCount;
    }
    /**
     * Record count, for data records. Not including records added for group headers etc.
     * @property {Number}
     * @readonly
     * @category Records
     */

  }, {
    key: "getAt",

    /**
     * Get the record at the specified index
     * @param {Number} index Index for the record
     * @returns {Core.data.Model} Record at the specified index
     * @category Records
     */
    value: function getAt(index) {
      var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // all means include filtered out records
      return this.storage.getAt(index, all);
    } // These are called by Model#join and Model#unjoin
    // register a record as a findable member keyed by id and internalId

  }, {
    key: "register",
    value: function register(record) {
      var me = this,
          // Test for duplicate IDs on register only when a tree store.
      // loadData does it in the case of a non-tree
      existingRec = me.isTree && me.idRegister[record.id];

      if (existingRec && existingRec !== record) {
        throw new Error("Id collision on ".concat(record.id));
      }

      me.idRegister[record.id] = record;
      me.internalIdRegister[record.internalId] = record;
    }
  }, {
    key: "unregister",
    value: function unregister(record) {
      delete this.idRegister[record.id];
      delete this.internalIdRegister[record.internalId];
    }
  }, {
    key: "getById",

    /**
     * Get a record by id. Find the record even if filtered out, part of collapsed group or collapsed node
     * @param {Core.data.Model|String|Number} id Id of record to return.
     * @returns {Core.data.Model} A record with the specified id
     * @category Records
     */
    value: function getById(id) {
      // In case `id` is a record, we use its ID to try to find the record in the store,
      // because if the record is removed from the store it shouldn't be found.
      // if (id instanceof Model) {
      //     id = id.id;
      // }
      if (id === null || id === void 0 ? void 0 : id.isModel) {
        return id;
      } //return this.tree ? this.idRegister[id] : this.storage.get(id);


      return this.idRegister[id];
    }
    /**
     * Checks if a record is available, in the sense that it is not filtered out,
     * hidden in a collapsed group or in a collapsed node.
     * @param {Core.data.Model|String|Number} recordOrId Record to check
     * @returns {Boolean}
     * @category Records
     */

  }, {
    key: "isAvailable",
    value: function isAvailable(recordOrId) {
      var record = this.getById(recordOrId);
      return record && this.storage.includes(record) || false;
    }
    /**
     * Get a record by internalId.
     * @param {Number} internalId The internalId of the record to return
     * @returns {Core.data.Model} A record with the specified internalId
     * @category Records
     */

  }, {
    key: "getByInternalId",
    value: function getByInternalId(internalId) {
      return this.internalIdRegister[internalId];
    }
    /**
     * Checks if the specified record is contained in the store
     * @param {Core.data.Model|String|Number} recordOrId Record, or `id` of record
     * @returns {Boolean}
     * @category Records
     */

  }, {
    key: "includes",
    value: function includes(recordOrId) {
      if (this.isTree) {
        return this.idRegister[_Model_js__WEBPACK_IMPORTED_MODULE_53__["default"].asId(recordOrId)] != null;
      }

      return this.indexOf(recordOrId) > -1;
    } //endregion
    //region Get index

    /**
     * Returns the index of the specified record/id, or `-1` if not found.
     * @param {Core.data.Model|String|Number} recordOrId Record, or `id` of record to return the index of.
     * @param {Boolean} [visibleRecords] Pass `true` to find the visible index.
     * as opposed to the dataset index. This omits group header records.
     * @returns {Number} Index for the record/id, or `-1` if not found.
     * @category Records
     */

  }, {
    key: "indexOf",
    value: function indexOf(recordOrId) {
      var visibleRecords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var id = _Model_js__WEBPACK_IMPORTED_MODULE_53__["default"].asId(recordOrId);

      if (id == null) {
        return -1;
      } // When a tree, indexOf is always in the visible records - filtering is different in trees.


      if (this.isTree) {
        return this.storage.indexOf(id);
      }

      var found = this.idMap[id];
      return found ? found[visibleRecords ? 'visibleIndex' : 'index'] : -1;
    }
  }, {
    key: "allIndexOf",
    value: function allIndexOf(recordOrId) {
      var _this2 = this;

      if (this.isTree) {
        var record = this.getById(recordOrId);
        var result = -1; // Use the tree structure to get the index in tree walk order

        if (record) {
          record.bubble(function (n) {
            if (n.parent) {
              result += n.parentIndex + 1;
            } else if (n === _this2.rootNode && _this2.rootVisible) {
              result += 1;
            }
          });
        }

        return result;
      } else {
        return this.storage.indexOf(recordOrId, true);
      }
    } //endregion
    //region Get values

    /**
     * Gets distinct values for the specified field.
     * @param field Field to extract values for
     * @returns {Array} Array of values
     * @category Values
     */

  }, {
    key: "getDistinctValues",
    value: function getDistinctValues(field) {
      var me = this,
          values = [],
          keys = {};
      var value;
      me.forEach(function (r) {
        if (!r.isSpecialRow && !r.isRoot) {
          value = r.get(field);

          if (!keys[value]) {
            values.push(value);
            keys[value] = 1;
          }
        }
      });
      return values;
    }
    /**
     * Counts how many times specified value appears in the store
     * @param field Field to look in
     * @param value Value to look for
     * @returns {Number} Found count
     * @category Values
     */

  }, {
    key: "getValueCount",
    value: function getValueCount(field, value) {
      var count = 0;
      this.forEach(function (r) {
        if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_55__["default"].isEqual(r.get(field), value)) count++;
      });
      return count;
    } //endregion
    //region JSON & console

    /**
     * Retrieve or set the data of all records as a JSON string
     *
     * ```javascript
     * const store = new Store({
     *     data : [
     *         { id : 1, name : 'Superman' },
     *         { id : 2, name : 'Batman' }
     *     ]
     * });
     *
     * const jsonString = store.json;
     *
     * //jsonString:
     * '[{"id":1,"name":"Superman"},{"id":2,"name":"Batman"}]
     * ```
     *
     * @property {String}
     */

  }, {
    key: "toJSON",

    /**
     * Retrieve the data of all records as an array of JSON objects
     *
     * ```javascript
     * const store = new Store({
     *     data : [
     *         { id : 1, name : 'Superman' },
     *         { id : 2, name : 'Batman' }
     *     ]
     * });
     *
     * const jsonArray = store.toJSON();
     *
     * //jsonArray:
     * [{id:1,name:"Superman"},{id:2,name:"Batman"}]
     * ```
     *
     * @returns {Object[]}
     */
    value: function toJSON() {
      // extract entire structure.
      // If we're a tree, then that consists of the payload of the rootNode.
      return (this.isTree ? this.rootNode.children : this).map(function (record) {
        return record.toJSON();
      });
    } //endregion
    //region Iteration & traversing

    /**
     * Iterates over all normal records in store. Omits group header and footer records
     * if this store is grouped.
     * @param {Function} fn A function that is called for each record. Returning false from that function cancels iteration
     * @param {Object} [thisObj] `this` reference for the function
     * @category Iteration
     */

  }, {
    key: "forEach",
    value: function forEach(fn) {
      var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;

      var callback = function callback(r, i) {
        if (!r.isRoot && !r.isSpecialRow) {
          return fn.call(thisObj, r, i);
        }
      };

      if (this.isTree) {
        this.rootNode.traverseWhile(callback);
      } else {
        // native forEach cannot be aborted by returning false, have to loop "manually"
        var records = this.storage.values;

        for (var i = 0; i < records.length; i++) {
          if (callback(records[i], i) === false) {
            return;
          }
        }
      }
    }
    /**
     * Equivalent to Array.map(). Creates a new array with the results of calling a provided function on every record
     * @param {Function} fn
     * @returns {Array}
     * @category Iteration
     */

  }, {
    key: "map",
    value: function map(fn) {
      var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      return this.storage.values.map(fn, thisObj);
    }
    /**
     * Equivalent to Array.reduce(). Applies a function against an accumulator and each record (from left to right) to
     * reduce it to a single value.
     * @param {Function} fn
     * @param initialValue
     * @returns {*}
     * @category Iteration
     */

  }, {
    key: "reduce",
    value: function reduce(fn) {
      var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

      if (thisObj !== this) {
        fn = fn.bind(thisObj);
      }

      return this.storage.values.reduce(fn, initialValue, thisObj);
    }
    /**
     * Iterator that allows you to do for (let record of store)
     * @category Iteration
     */

  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.storage.values[Symbol.iterator]();
    }
    /**
     * Traverse all tree nodes
     * @param {Function} fn The function to call on visiting each node.
     * @param {Core.data.Model} [topNode=this.rootNode] The top node to start the traverse at.
     * @param {Boolean} [skipTopNode] Pass true to not call `fn` on the top node, but proceed directly to its children.
     * @category Traverse
     */

  }, {
    key: "traverse",
    value: function traverse(fn) {
      var topNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.rootNode;
      var skipTopNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : topNode === this.rootNode;
      var me = this;

      if (me.isTree) {
        // Allow store.traverse(fn, true) to start from rootNode
        if (typeof topNode === 'boolean') {
          skipTopNode = topNode;
          topNode = me.rootNode;
        }

        if (me.isChained) {
          var passedFn = fn;

          fn = function fn(node) {
            if (me.chainedFilterFn(node)) {
              passedFn(node);
            }
          };
        }

        topNode.traverse(fn, skipTopNode);
      } else {
        var _iterator3 = _createForOfIteratorHelper(me.storage),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var record = _step3.value;
            record.traverse(fn);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
    /**
     * Traverse all tree nodes while the passed `fn` returns true
     * @param {Function} fn The function to call on visiting each node. Returning `false` from it stops the traverse.
     * @param {Core.data.Model} [topNode=this.rootNode] The top node to start the traverse at.
     * @param {Boolean} [skipTopNode] Pass true to not call `fn` on the top node, but proceed directly to its children.
     * @category Traverse
     */

  }, {
    key: "traverseWhile",
    value: function traverseWhile(fn) {
      var topNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.rootNode;
      var skipTopNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : topNode === this.rootNode;
      var me = this;

      if (me.isTree) {
        // Allow store.traverse(fn, true) to start from rootNode
        if (typeof topNode === 'boolean') {
          skipTopNode = topNode;
          topNode = me.rootNode;
        }

        if (me.isChained) {
          var passedFn = fn;

          fn = function fn(node) {
            if (me.chainedFilterFn(node)) {
              passedFn(node);
            }
          };
        }

        topNode.traverseWhile(fn, skipTopNode);
      } else {
        var _iterator4 = _createForOfIteratorHelper(me.storage),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var record = _step4.value;

            if (record.traverse(fn) === false) {
              break;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
    /**
     * Finds the next record.
     * @param recordOrId Current record or its id
     * @param {Boolean} wrap Wrap at start/end or stop there
     * @returns {Core.data.Model} Next record or null if current is the last one
     * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
     * @category Traverse
     */

  }, {
    key: "getNext",
    value: function getNext(recordOrId) {
      var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var skipSpecialRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          records = me.storage.values;
      var idx = me.indexOf(recordOrId);

      if (idx >= records.length - 1) {
        if (wrap) {
          idx = -1;
        } else {
          return null;
        }
      }

      var record = records[idx + 1]; // Skip the result if it's a specialRow and we are told to skip them

      if (skipSpecialRows && record && record.isSpecialRow) {
        return me.getNext(records[idx + 1], wrap, true);
      }

      return record;
    }
    /**
     * Finds the previous record.
     * @param recordOrId Current record or id
     * @param {Boolean} wrap Wrap at start/end or stop there
     * @returns {Core.data.Model} Previous record or null if current is the last one
     * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
     * @category Traverse
     */

  }, {
    key: "getPrev",
    value: function getPrev(recordOrId) {
      var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var skipSpecialRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          records = me.storage.values;
      var idx = me.indexOf(recordOrId);

      if (idx === 0) {
        if (wrap) {
          idx = records.length;
        } else {
          return null;
        }
      }

      var record = records[idx - 1]; // Skip the result if it's a specialRow and we are told to skip them

      if (skipSpecialRows && record && record.isSpecialRow) {
        return me.getNext(records[idx + 1], wrap, true);
      }

      return record;
    }
    /**
     * Gets the next or the previous record. Optionally wraps from first -> last and vice versa
     * @param {String|Model} recordOrId Record or records id
     * @param {Boolean} next Next (true) or previous (false)
     * @param {Boolean} wrap Wrap at start/end or stop there
     * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
     * @returns {Core.data.Model}
     * @category Traverse
     * @internal
     */

  }, {
    key: "getAdjacent",
    value: function getAdjacent(recordOrId) {
      var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var skipSpecialRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return next ? this.getNext(recordOrId, wrap, skipSpecialRows) : this.getPrev(recordOrId, wrap, skipSpecialRows);
    }
    /**
     * Finds the next record among leaves (in a tree structure)
     * @param recordOrId Current record or its id
     * @param {Boolean} wrap Wrap at start/end or stop there
     * @returns {Core.data.Model} Next record or null if current is the last one
     * @category Traverse
     * @internal
     */

  }, {
    key: "getNextLeaf",
    value: function getNextLeaf(recordOrId) {
      var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          records = me.leaves,
          record = me.getById(recordOrId);
      var idx = records.indexOf(record);

      if (idx >= records.length - 1) {
        if (wrap) {
          idx = -1;
        } else {
          return null;
        }
      }

      return records[idx + 1];
    }
    /**
     * Finds the previous record among leaves (in a tree structure)
     * @param recordOrId Current record or id
     * @param {Boolean} wrap Wrap at start/end or stop there
     * @returns {Core.data.Model} Previous record or null if current is the last one
     * @category Traverse
     * @internal
     */

  }, {
    key: "getPrevLeaf",
    value: function getPrevLeaf(recordOrId) {
      var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          records = me.leaves,
          record = me.getById(recordOrId);
      var idx = records.indexOf(record);

      if (idx === 0) {
        if (wrap) {
          idx = records.length;
        } else {
          return null;
        }
      }

      return records[idx - 1];
    }
    /**
     * Gets the next or the previous record among leaves (in a tree structure). Optionally wraps from first -> last and
     * vice versa
     * @param {String|Core.data.Model} recordOrId Record or record id
     * @param {Boolean} next Next (true) or previous (false)
     * @param {Boolean} wrap Wrap at start/end or stop there
     * @returns {Core.data.Model}
     * @category Traverse
     * @internal
     */

  }, {
    key: "getAdjacentLeaf",
    value: function getAdjacentLeaf(recordOrId) {
      var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return next ? this.getNextLeaf(recordOrId, wrap) : this.getPrevLeaf(recordOrId, wrap);
    } //endregion
    //region Chained store

    /**
     * Creates a chained store, a new Store instance that contains a subset of the records from current store.
     * Which records is determined by a filtering function, which is reapplied when data in the base store changes.
     *
     * If this store is a {@link Core.data.mixin.StoreTree#property-isTree tree} store, then the resulting
     * chained store will be a tree store sharing the same root node, but only child nodes which pass
     * the `chainedFilterFn` will be considered when iterating the tree through the methods such as
     * {@link #function-traverse} or {@link #function-forEach}.
     *
     * @param {Function} chainedFilterFn Function called for each records that determines if it should be included
     * (return true) or not (return false). Defaults to including all records (fn always returning true)
     * @param {String[]} chainedFields Array of fields that trigger filtering when they are updated
     * @param {Object} config Additional chained store configuration
     * @returns {Core.data.Store}
     * @example
     * let oldies = store.makeChained(record => record.age > 40);
     */

  }, {
    key: "makeChained",
    value: function makeChained() {
      var chainedFilterFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return true;
      };
      var chainedFields = arguments.length > 1 ? arguments[1] : undefined;
      var config = arguments.length > 2 ? arguments[2] : undefined;
      return new this.constructor(Object.assign(config || {}, {
        tree: false,
        autoTree: false,
        masterStore: this,
        modelClass: this.modelClass,
        chainedFilterFn: chainedFilterFn,
        chainedFields: chainedFields
      }));
    }
    /**
     * Alias for {@link #function-makeChained}
     * @param {Function} chainedFilterFn Function called for each records that determines if it should be included
     * (return true) or not (return false). Defaults to including all records (fn always returning true)
     * @param {String[]} chainedFields Array of fields that trigger filtering when they are updated
     * @param {Object} config Additional chained store configuration
     * @returns {Core.data.Store}
     */

  }, {
    key: "chain",
    value: function chain() {
      return this.makeChained.apply(this, arguments);
    } //endregion

  }, {
    key: "storage",
    set: function set(storage) {
      var me = this;

      if (storage === null || storage === void 0 ? void 0 : storage.isCollection) {
        me._storage = storage;
      } else {
        me._storage = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_58__["default"](storage);
      }

      me._storage.autoFilter = me.reapplyFilterOnAdd; // Join all the constituent records to this Store

      var _iterator5 = _createForOfIteratorHelper(me._storage),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var r = _step5.value;
          r.joinStore(me);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      me._storage.on({
        change: 'onDataChange',
        thisObj: me
      });
    },
    get: function get() {
      if (!this._storage) {
        this.storage = {};
      }

      return this._storage;
    }
    /**
     * Returns all records (not filtered) from the store.
     * @property {Core.data.Model[]}
     * @readonly
     * @category Records
     */

  }, {
    key: "allRecords",
    get: function get() {
      var me = this;

      if (me.isTree) {
        var result = me.collectDescendants(me.rootNode, undefined, undefined, {
          unfiltered: true
        }).all;

        if (me.rootVisible) {
          result.unshift(me.rootNode);
        }

        return result;
      } else {
        return me.isGrouped ? me.collectGroupRecords() : me.storage.allValues;
      }
    }
  }, {
    key: "idMap",
    get: function get() {
      var me = this,
          processedRecords = me.storage.values,
          needsRebuild = !me._idMap,
          idMap = me._idMap || (me._idMap = {});

      if (needsRebuild) {
        for (var record, index = 0, visibleIndex = 0; index < processedRecords.length; index++) {
          record = processedRecords[index];
          idMap[record.id] = {
            index: index,
            visibleIndex: visibleIndex,
            record: record
          };

          if (!record.isSpecialRow) {
            visibleIndex++;
          }
        }
      }

      return idMap;
    }
    /**
     * Class used to represent records. Defaults to class Model.
     * @property {Core.data.Model}
     * @category Records
     * @typings { new(data: object): Model }
     */

  }, {
    key: "modelClass",
    get: function get() {
      return this._modelClass;
    },
    set: function set(ClassDef) {
      var fields = this.fields; // noinspection JSRedeclarationOfBlockScope

      var ClassDefEx = null; // Ensure our modelClass is exchanged for an extended of modelClass decorated with any configured fields.

      if (fields === null || fields === void 0 ? void 0 : fields.length) {
        ClassDefEx = /*#__PURE__*/function (_ClassDef) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_45___default()(ClassDefEx, _ClassDef);

          var _super2 = _createSuper(ClassDefEx);

          function ClassDefEx() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42___default()(this, ClassDefEx);

            return _super2.apply(this, arguments);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_44___default()(ClassDefEx, null, [{
            key: "fields",
            get: function get() {
              return fields;
            }
          }]);

          return ClassDefEx;
        }(ClassDef);
      } // If we expose properties on Model we will pollute all other models, use internal subclass instead
      else if (!this.preventSubClassingModel) {
          ClassDefEx = /*#__PURE__*/function (_ClassDef2) {
            _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_45___default()(ClassDefEx, _ClassDef2);

            var _super3 = _createSuper(ClassDefEx);

            function ClassDefEx() {
              _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42___default()(this, ClassDefEx);

              return _super3.apply(this, arguments);
            }

            return ClassDefEx;
          }(ClassDef);
        } else {
          ClassDefEx = ClassDef;
        } // Need to properly expose relations on this new subclass


      ClassDefEx.initClass();
      this._modelClass = ClassDefEx;
    } //endregion
    //region Store id & map
    // Deprecated.
    // TODO: Remove in 2.0 when all references have been removed from Scheduler and Gantt

  }, {
    key: "storeId",
    set: function set(storeId) {
      this.id = storeId;
    },
    get: function get() {
      return this.id;
    }
    /**
     * Get/set id, an unique identifier for the store.
     * Used to build a store map, use Store#getStore() to retrieve a store from the map.
     * @property {String|Number}
     * @category Store
     */

  }, {
    key: "id",
    set: function set(id) {
      var me = this;

      if (me._id) {
        Store.unregisterInstance(me);
      }

      me._id = id === true ? id = Store.generateId('store-') : id;

      if (id) {
        // Store code always did just evict any other instance by that ID.
        // TODO: Should we tighten this up?
        var duplicate = Store.getById(id);

        if (duplicate) {
          Store.unregisterInstance(duplicate);
        }

        Store.registerInstance(me);
      }
    },
    get: function get() {
      return this._id;
    }
  }, {
    key: "tree",
    get: function get() {
      return this._tree;
    },
    set: function set(tree) {
      this._tree = tree;

      if (tree && !this.rootNode) {
        this.rootNode = this.buildRootNode();
        this.rootNode.isAutoRoot = true;
      }
    }
  }, {
    key: "rootNode",
    //endregion
    //region Data

    /**
     * The invisible root node of this tree.
     * @property {Core.data.Model}
     * @readonly
     * @category Tree
     */
    get: function get() {
      return this.masterStore ? this.masterStore.rootNode : this._rootNode;
    },
    set: function set(rootNode) {
      var _rootNode$children;

      var me = this,
          oldRoot = me._rootNode; // No change

      if (rootNode === oldRoot) {
        return;
      }

      if (oldRoot) {
        me.clear(false);
      }

      if (rootNode instanceof _Model_js__WEBPACK_IMPORTED_MODULE_53__["default"]) {
        // We insist that the rootNode is expanded otherwise no children will be added
        rootNode.instanceMeta(me).collapsed = false;
        me._rootNode = rootNode;
      } else {
        me._rootNode = rootNode = new me.modelClass(Object.assign(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_40___default()({
          expanded: true
        }, me.modelClass.idField, "".concat(me.id, "-rootNode")), rootNode), me, null, true);
      }

      me._tree = true;
      rootNode.isRoot = true;
      rootNode.joinStore(me); // If there are nodes to be inserted into the flat storage
      // then onNodeAddChild knows how to do that and what events
      // to fire based upon rootNode.isLoading.

      if (((_rootNode$children = rootNode.children) === null || _rootNode$children === void 0 ? void 0 : _rootNode$children.length) || me.rootVisible) {
        rootNode.isLoading = true;
        me.onNodeAddChild(rootNode, rootNode.children || [], 0);
        rootNode.isLoading = false;
      }

      me.trigger('rootChange', {
        oldRoot: oldRoot,
        rootNode: rootNode
      });
    }
    /**
     * Sets data in the store, called on initialization if data is in config otherwise call it yourself after
     * ajax call etc. Can also be used to get the raw original data.
     * @property {Object[]}
     * @fires refresh
     * @fires change
     * @category Records
     */

  }, {
    key: "data",
    set: function set(data) {
      this.setStoreData(data);
    },
    get: function get() {
      return this._data;
    }
  }, {
    key: "useRawData",
    get: function get() {
      return this._useRawData;
    },
    set: function set(options) {
      if (options === true) {
        this._useRawData = {
          enabled: true,
          disableDuplicateIdCheck: true,
          disableTypeConversion: true,
          disableDefaultValue: false
        };
      } else {
        this._useRawData = options ? Object.assign(options, {
          enabled: true
        }) : {
          enabled: false
        };
      }
    }
  }, {
    key: "originalCount",
    get: function get() {
      return this.storage.totalCount;
    }
    /**
     * Record count, including records added for group headers etc.
     * @property {Number}
     * @readonly
     * @category Records
     */

  }, {
    key: "count",
    get: function get() {
      return this.storage.count;
    }
    /**
     * Returns the complete dataset size regardless of tree node collapsing or filtering
     * @property {Number}
     * @readonly
     * @category Records
     */

  }, {
    key: "allCount",
    get: function get() {
      return this.isTree ? this.rootNode.descendantCount : this.storage.totalCount;
    } //endregion
    //region Get record(s)
    // TODO: Implement immutable tag for docs #1206

    /**
     * Returns all "visible" records.
     * **Note:** The returned value **may not** be mutated!
     * @property {Core.data.Model[]}
     * @readonly
     * @immutable
     * @category Records
     */

  }, {
    key: "records",
    get: function get() {
      return this.storage.values;
    }
    /**
     * Get the first record in the store.
     * @property {Core.data.Model}
     * @readonly
     * @category Records
     */

  }, {
    key: "first",
    get: function get() {
      return this.storage.values[0];
    }
    /**
     * Get the last record in the store.
     * @property {Core.data.Model}
     * @readonly
     * @category Records
     */

  }, {
    key: "last",
    get: function get() {
      return this.storage.values[this.storage.values.length - 1];
    }
  }, {
    key: "registeredRecords",
    get: function get() {
      return Object.values(this.idRegister);
    }
  }, {
    key: "json",
    set: function set(json) {
      if (typeof json === 'string') {
        json = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_56__["default"].safeJsonParse(json);
      }

      this.data = json;
    },
    get: function get() {
      return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_56__["default"].safeJsonStringify(this);
    }
    /**
     * Pretty printed version of {@link #property-json}
     * @returns {String}
     */

  }, {
    key: "formattedJSON",
    get: function get() {
      return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_56__["default"].safeJsonStringify(this, null, 4);
    }
  }], [{
    key: "getStore",
    value: function getStore(id, storeClass) {
      if (id instanceof Store) {
        return id;
      }

      if (this.getById(id)) {
        return this.getById(id);
      }

      if (Array.isArray(id)) {
        var storeModel;
        var storeData = id.map(function (item) {
          if (item instanceof _Model_js__WEBPACK_IMPORTED_MODULE_53__["default"]) {
            storeModel = item.constructor;
          } else if (typeof item === 'string') {
            item = {
              text: item
            };
          } else {}

          return item;
        });
        id = {
          autoCreated: true,
          data: storeData,
          modelClass: storeModel || /*#__PURE__*/function (_Model) {
            _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_45___default()(_class, _Model);

            var _super4 = _createSuper(_class);

            function _class() {
              _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42___default()(this, _class);

              return _super4.apply(this, arguments);
            }

            return _class;
          }(_Model_js__WEBPACK_IMPORTED_MODULE_53__["default"]),
          allowNoId: true // String items have no id and are not guaranteed to be unique

        };

        if (!storeClass) {
          storeClass = Store;
        }
      }

      if (storeClass) {
        return new storeClass(id);
      }
    }
    /**
     * Get all registered stores
     * @returns {Core.data.Store[]}
     */

  }, {
    key: "stores",
    get: function get() {
      return Store.registeredInstances;
    }
  }]);

  return Store;
}(_Base_js__WEBPACK_IMPORTED_MODULE_48__["default"].mixin(_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_52__["default"], _mixin_Events_js__WEBPACK_IMPORTED_MODULE_50__["default"], _mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_49__["default"], _mixin_State_js__WEBPACK_IMPORTED_MODULE_51__["default"], _mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_60__["default"], _mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_59__["default"], _mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_63__["default"], _mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_64__["default"], _mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_65__["default"], _mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_66__["default"], _mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_61__["default"], _mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_67__["default"], _mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_68__["default"], _mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_69__["default"], _stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_71__["default"], _mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_70__["default"], _mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_62__["default"] // Private for now, thus not mentioned in @mixes block above
));


Store.storeMap = {};
Store._$name = 'Store';

/***/ }),

/***/ "./lib/Core/data/StoreBag.js":
/*!***********************************!*\
  !*** ./lib/Core/data/StoreBag.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreBag; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _util_Bag_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../util/Bag.js */ "./lib/Core/util/Bag.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/StoreBag
 */

var StoreBag = /*#__PURE__*/function (_Bag) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(StoreBag, _Bag);

  var _super = _createSuper(StoreBag);

  function StoreBag() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, StoreBag);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(StoreBag, [{
    key: "add",
    value: function add() {
      var _get2;

      for (var _len = arguments.length, toAdd = new Array(_len), _key = 0; _key < _len; _key++) {
        toAdd[_key] = arguments[_key];
      }

      if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
        toAdd = toAdd[0];
      } // ignore unpersistable records


      return (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(StoreBag.prototype), "add", this)).call.apply(_get2, [this].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5___default()(toAdd.filter(function (record) {
        return record.isPersistable;
      }))));
    }
  }]);

  return StoreBag;
}(_util_Bag_js__WEBPACK_IMPORTED_MODULE_12__["default"]);


;
StoreBag._$name = 'StoreBag';

/***/ }),

/***/ "./lib/Core/data/field/BooleanDataField.js":
/*!*************************************************!*\
  !*** ./lib/Core/data/field/BooleanDataField.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BooleanDataField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/field/BooleanDataField
 */

/**
 * This field class handles field of type `Boolean`.
 * ```
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'active', type : 'boolean' }
 *         ];
 *     }
 * }
 * ```
 * When a field is declared as a `'boolean'`, non-null values are promoted to `Boolean` type. This is seldom required,
 * but can be useful if a field value is received as a number but should be treated as a boolean.
 * @extends Core/data/field/DataField
 * @classtype boolean
 */

var BooleanDataField = /*#__PURE__*/function (_DataField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(BooleanDataField, _DataField);

  var _super = _createSuper(BooleanDataField);

  function BooleanDataField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, BooleanDataField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(BooleanDataField, [{
    key: "convert",
    value: function convert(value) {
      return value == null ? this.nullable ? value : this.nullValue : Boolean(value);
    }
  }], [{
    key: "type",
    get: function get() {
      return 'boolean';
    }
  }, {
    key: "alias",
    get: function get() {
      return 'bool';
    }
  }, {
    key: "prototypeProperties",
    get: function get() {
      return {
        /**
         * The value to replace `null` when the field is not `nullable`.
         * @config {Boolean}
         * @default
         */
        nullValue: false
      };
    }
  }]);

  return BooleanDataField;
}(_DataField_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


BooleanDataField.initClass();
BooleanDataField._$name = 'BooleanDataField';

/***/ }),

/***/ "./lib/Core/data/field/DataField.js":
/*!******************************************!*\
  !*** ./lib/Core/data/field/DataField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DataField; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/data/field/DataField
 */

/**
 * This is the base class for Model field classes. A field class defines how to handle the data for a particular type
 * of field. Many of these behaviors can be configured on individual field instances.
 *
 * @extends Core/Base
 */

var DataField = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(DataField, _Base$mixin);

  var _super = _createSuper(DataField);

  function DataField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, DataField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(DataField, [{
    key: "construct",

    /**
     * The class that first defined this field. Derived classes that override a field do not change this property.
     * @member {Core.data.Model} definedBy
     * @private
     * @readonly
     */

    /**
     * The class that most specifically defined this field. Derived classes that override a field set this property to
     * themselves.
     * @member {Core.data.Model} owner
     * @private
     * @readonly
     */
    // NOTE: Since we create lots of instances, they have no life cycle (they are not destroyed) and are readonly after
    // creation, this class does not use configurable.
    value: function construct(config) {
      var me = this;

      if (config) {
        me.name = config.name; // assign name first for diagnostic reasons

        Object.assign(me, config);
      }

      if (me.compare) {
        // We wrap in this way to allow compareItems() to be used as an array sorter fn (which gets no "this"):
        me.compareItems = function (itemA, itemB) {
          return me.compare(itemA === null || itemA === void 0 ? void 0 : itemA[me.name], itemB === null || itemB === void 0 ? void 0 : itemB[me.name]);
        };
      }
    }
    /**
     * This method transforms a data value into the desired form for storage in the record's data object.
     * @method convert
     * @param {*} value The value to convert for storage in a record.
     * @returns {*} The converted value.
     */

    /**
     * This method transforms a data value into the desired form for transmitting to a server.
     * @method serialize
     * @param {*} value The value to serialize
     * @param {Core.data.Model} record The record that contains the value being serialized.
     * @returns {*} The serialized value.
     */

    /**
     * Create getter and setter functions for the specified field name under the specified key.
     * @internal
     */

  }, {
    key: "defineAccessor",
    value: function defineAccessor(target, force) {
      var name = this.name;

      if (force || !(name in target)) {
        Reflect.defineProperty(target, name, {
          configurable: true,
          // To allow removing it later
          enumerable: true,
          // no arrow functions here, need `this` to change to instance
          get: function get() {
            return this.get(name);
          },
          // no arrow functions here, need `this` to change to instance
          set: function set(value) {
            // Since the accessor is defined on a base class, we dip into the fields map for the actual
            // calling class to get the correct field definition
            var field = this.$meta.fields.map[name]; // Only set if field is read/write. Privately, we use setData to set its value

            if (!(field && field.readOnly)) {
              this.set(name, value);
            }
          }
        });
      }
    }
    /**
     * Compares two values for this field and returns `true` if they are equal, and `false` if not.
     * @param {*} first The first value to compare for equality.
     * @param {*} second The second value to compare for equality.
     * @returns {Boolean} `true` if `first` and `second` are equal.
     */

  }, {
    key: "isEqual",
    value: function isEqual(first, second) {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isEqual(first, second);
    }
    /**
     * Returns the given field value as a `String`. If `value` is `null` or `undefined`, the value specified by
     * {@link #config-nullText} is returned.
     * @param {*} value The value to convert to a string.
     * @returns {String}
     */

  }, {
    key: "print",
    value: function print(value) {
      return value == null ? this.nullText : this.printValue(value);
    }
    /**
     * Returns the given, non-null field value as a `String`.
     * @param {*} value The value to convert to a string (will not be `null` or `undefined`).
     * @returns {String}
     * @protected
     */

  }, {
    key: "printValue",
    value: function printValue(value) {
      return String(value);
    }
  }], [{
    key: "type",
    get: function get() {
      return 'auto';
    }
  }, {
    key: "factoryable",
    get: function get() {
      return {
        defaultType: 'auto'
      };
    }
  }, {
    key: "prototypeProperties",
    get: function get() {
      return {
        /**
         * The name of the field.
         * @config {String} name
         */

        /**
         * A function that compares two values and returns a value < 0 if the first is less than the second, or 0
         * if the values are equal, or a value > 0 if the first is greater than the second.
         * @config {Function}
         * @default
         */
        compare: null,

        /**
         * A function that compares two objects or records using the `compare` function on the properties of each
         * objects based on the `name` of this field.
         * @config {Function}
         * @default
         * @internal
         */
        compareItems: null,

        /**
         * The property in a record's data object that contains the field's value.
         * Defaults to the field's `name`.
         * @config {String}
         * @default
         */
        dataSource: null,

        /**
         * The default value to assign to this field in a record if no value is provided.
         * @config {*} defaultValue
         */

        /**
         * Setting to `false` indicates that `null` is not a valid value.
         * @config {Boolean}
         * @default
         */
        nullable: true,

        /**
         * The value to return from {@link #function-print} for a `null` or `undefined` value.
         * @config {String}
         * @default
         */
        nullText: null,

        /**
         * The value to replace `null` when the field is not `nullable`.
         * @config {*}
         * @default
         */
        nullValue: undefined,

        /**
         * Set to `false` to exclude this field when saving records to a server.
         * @config {Boolean}
         * @default
         */
        persist: true,

        /**
         * Set to `true` for the field's set accessor to ignore attempts to set this field.
         * @config {Boolean}
         * @default
         */
        readOnly: false
      };
    }
  }]);

  return DataField;
}(_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"].mixin(_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_13__["default"]));


DataField._$name = 'DataField';

/***/ }),

/***/ "./lib/Core/data/field/DateDataField.js":
/*!**********************************************!*\
  !*** ./lib/Core/data/field/DateDataField.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateDataField; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/data/field/DateDataField
 */

/**
 * This field class handles field of type `Date`.
 * ```
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'birthday', type : 'date', format : 'YYYY-MM-DD' },
 *             { name : 'age', readOnly : true }
 *         ];
 *     }
 * }
 * ```
 * When a field is declared as a `'date'`, non-null values are promoted to `Date` type. This is frequently needed due
 * to how date types are serialized to JSON strings.
 *
 * Date fields can have a special `defaultValue` of `'now'` which will convert to the current date/time.
 * @extends Core/data/field/DataField
 * @classtype date
 */

var DateDataField = /*#__PURE__*/function (_DataField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(DateDataField, _DataField);

  var _super = _createSuper(DateDataField);

  function DateDataField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, DateDataField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(DateDataField, [{
    key: "convert",
    value: function convert(value) {
      if (value == null) {
        if (!this.nullable) {
          value = this.nullValue;
        }
      } else if (value === 'now') {
        value = new Date();
      } else if (!(value instanceof Date)) {
        // Use configured format, if null/undefined use DateHelpers default format
        value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].parse(value, this.format || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].defaultParseFormat); // if parsing has failed, we would like to return `undefined` to indicate the "absence" of data
        // instead of `null` (presence of "empty" data)

        value = value || undefined;
      }

      return value;
    }
  }, {
    key: "serialize",
    value: function serialize(value) {
      if (value instanceof Date) {
        // Use configured format or DateHelpers default one
        value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(value, this.format || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].defaultFormat);
      }

      return value;
    }
  }, {
    key: "printValue",
    value: function printValue(value) {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(value, this.format || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].defaultFormat);
    }
  }, {
    key: "dateFormat",
    get: function get() {
      return this.format;
    },
    set: function set(v) {
      _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].deprecate('Core', '5.0.0', "DateDataField \"".concat(this.name, "\": dateFormat config has been renamed to \"format\""));
      this.format = v;
    }
  }], [{
    key: "type",
    get: function get() {
      return 'date';
    }
  }, {
    key: "prototypeProperties",
    get: function get() {
      return {
        /**
         * The format of the date field. *Deprecated*: use {@link #config-format} instead.
         *
         * @config {String} dateFormat
         * @deprecated Use {@link #config-format} instead.
         */

        /**
         * The format of the date field.
         *
         * See {@link Core.helper.DateHelper DateHelper} for details.
         * @config {String} format
         * @default DateHelper.defaultFormat
         */
        format: null
      };
    }
  }]);

  return DateDataField;
}(_DataField_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


DateDataField.initClass();
DateDataField._$name = 'DateDataField';

/***/ }),

/***/ "./lib/Core/data/field/IntegerDataField.js":
/*!*************************************************!*\
  !*** ./lib/Core/data/field/IntegerDataField.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return IntegerDataField; });
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/field/IntegerDataField
 */

/**
 * This field class handles field of type `Number` with no decimal digits.
 * ```
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', type : 'int' }
 *         ];
 *     }
 * }
 * ```
 * When a field is declared as a `'int'`, non-null values are promoted to `Number` type and decimals are removed using
 * a specified `rounding`. This field type can be useful if a field value is received as a string but should be stored
 * as a number or has a fractional component that must be rounded or truncated.
 * @extends Core/data/field/DataField
 * @classtype integer
 */

var IntegerDataField = /*#__PURE__*/function (_DataField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(IntegerDataField, _DataField);

  var _super = _createSuper(IntegerDataField);

  function IntegerDataField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, IntegerDataField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(IntegerDataField, [{
    key: "convert",
    value: function convert(value) {
      return value == null ? this.nullable ? value : this.nullValue : Math[this.rounding](Number(value));
    }
  }], [{
    key: "type",
    get: function get() {
      return 'integer';
    }
  }, {
    key: "alias",
    get: function get() {
      return 'int';
    }
  }, {
    key: "prototypeProperties",
    get: function get() {
      return {
        /**
         * The value to replace `null` when the field is not `nullable`.
         * @config {Number}
         * @default
         */
        nullValue: 0,

        /**
         * The `Math` method to use to ensure fractional component is removed.
         * This can be `'round'` (the default value), `'floor'` or `'ceil'`.
         * @config {String}
         * @default
         */
        rounding: 'round'
      };
    }
  }]);

  return IntegerDataField;
}(_DataField_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


IntegerDataField.initClass();
IntegerDataField._$name = 'IntegerDataField';

/***/ }),

/***/ "./lib/Core/data/field/ModelDataField.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/field/ModelDataField.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ModelDataField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/field/ModelDataField
 */

/**
 * This field class handles fields that hold other records.
 * ```
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'address', type : 'model' }
 *         ];
 *     }
 * }
 * ```
 * @internal
 * @extends Core/data/field/DataField
 * @classtype model
 */

var ModelDataField = /*#__PURE__*/function (_DataField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ModelDataField, _DataField);

  var _super = _createSuper(ModelDataField);

  function ModelDataField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ModelDataField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ModelDataField, null, [{
    key: "type",
    get: function get() {
      return 'model';
    }
  }, {
    key: "prototypeProperties",
    get: function get() {
      return {
        complexMapping: true
      };
    }
  }]);

  return ModelDataField;
}(_DataField_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


ModelDataField.initClass();
ModelDataField._$name = 'ModelDataField';

/***/ }),

/***/ "./lib/Core/data/field/NumberDataField.js":
/*!************************************************!*\
  !*** ./lib/Core/data/field/NumberDataField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberDataField; });
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/field/NumberDataField
 */

/**
 * This field class handles field of type `Number`.
 * ```
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', type : 'number' }
 *         ];
 *     }
 * }
 * ```
 * When a field is declared as a `'number'`, non-null values are promoted to `Number` type. This is seldom required, but
 * can be useful if a field value is received as a string but should be treated as a number.
 * @extends Core/data/field/DataField
 * @classtype number
 */

var NumberDataField = /*#__PURE__*/function (_DataField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(NumberDataField, _DataField);

  var _super = _createSuper(NumberDataField);

  function NumberDataField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, NumberDataField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(NumberDataField, [{
    key: "convert",
    value: function convert(value) {
      if (value == null) {
        return this.nullable ? value : this.nullValue;
      }

      value = Number(value);
      var scale = this.precision;

      if (scale) {
        scale = Math.pow(10, scale);
        value = Math.round(value * scale) / scale;
      } else if (scale === 0) {
        value = Math.round(value);
      }

      return value;
    }
  }], [{
    key: "type",
    get: function get() {
      return 'number';
    }
  }, {
    key: "alias",
    get: function get() {
      return 'float';
    }
  }, {
    key: "prototypeProperties",
    get: function get() {
      return {
        /**
         * The value to replace `null` when the field is not `nullable`.
         * @config {Number}
         * @default
         */
        nullValue: 0,

        /**
         * The numeric precision of this field. Values are rounded to the specified number of digits. If `null`,
         * the default, no rounding is performed.
         * @config {Number}
         * @default
         */
        precision: null
      };
    }
  }]);

  return NumberDataField;
}(_DataField_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


NumberDataField.initClass();
NumberDataField._$name = 'NumberDataField';

/***/ }),

/***/ "./lib/Core/data/field/ObjectDataField.js":
/*!************************************************!*\
  !*** ./lib/Core/data/field/ObjectDataField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ObjectDataField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/field/ObjectDataField
 */

/**
 * This field class handles fields that hold an object.
 * ```
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'address', type : 'object' }
 *         ];
 *     }
 * }
 * ```
 * @internal
 * @extends Core/data/field/DataField
 * @classtype object
 */

var ObjectDataField = /*#__PURE__*/function (_DataField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ObjectDataField, _DataField);

  var _super = _createSuper(ObjectDataField);

  function ObjectDataField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ObjectDataField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ObjectDataField, null, [{
    key: "type",
    get: function get() {
      return 'object';
    }
  }, {
    key: "prototypeProperties",
    get: function get() {
      return {
        complexMapping: true
      };
    }
  }]);

  return ObjectDataField;
}(_DataField_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


ObjectDataField.initClass();
ObjectDataField._$name = 'ObjectDataField';

/***/ }),

/***/ "./lib/Core/data/field/StringDataField.js":
/*!************************************************!*\
  !*** ./lib/Core/data/field/StringDataField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StringDataField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/field/StringDataField
 */

/**
 * This field class handles field of type `String`.
 * ```
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             { name : 'name', type : 'string' }
 *         ];
 *     }
 * }
 * ```
 * When a field is declared as a `'string'`, non-null values are promoted to `String` type. This is seldom required, but
 * can be useful if a field value is received as a number but should be treated as a string.
 * @extends Core/data/field/DataField
 * @classtype string
 */

var StringDataField = /*#__PURE__*/function (_DataField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(StringDataField, _DataField);

  var _super = _createSuper(StringDataField);

  function StringDataField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, StringDataField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(StringDataField, [{
    key: "convert",
    value: function convert(value) {
      return value == null ? this.nullable ? value : this.nullValue : String(value);
    }
  }], [{
    key: "type",
    get: function get() {
      return 'string';
    }
  }, {
    key: "prototypeProperties",
    get: function get() {
      return {
        /**
         * The value to replace `null` when the field is not `nullable`.
         * @config {String}
         * @default
         */
        nullValue: ''
      };
    }
  }]);

  return StringDataField;
}(_DataField_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


StringDataField.initClass();
StringDataField._$name = 'StringDataField';

/***/ }),

/***/ "./lib/Core/data/mixin/StoreCRUD.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreCRUD.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");



























































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_57___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_57___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_56___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/data/mixin/StoreCRUD
 */

/**
 * Mixin for Store that handles modifying records (add, remove etc).
 *
 * @example
 * // add new record to store
 * store.add({ id: 1, team: 'FC Krasnodar' });
 *
 * // remove a record from store, using id
 * store.remove(1);
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_55___default()(StoreCRUD, _ref);

    var _super = _createSuper(StoreCRUD);

    function StoreCRUD() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53___default()(this, StoreCRUD);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_54___default()(StoreCRUD, [{
      key: "remove",
      //endregion
      //region Events

      /**
       * Fired after removing all records
       * @event removeAll
       * @param {Core.data.Store} source This Store
       */

      /**
       * Fired before committing changes. Return false from handler to abort commit
       * @event beforeCommit
       * @param {Core.data.Store} source This Store
       * @param {Object} changes Modification data
       */

      /**
       * Fired after committing changes
       * @event commit
       * @param {Core.data.Store} source This Store
       * @param {Object} changes Modification data
       */

      /**
       * Fired before records are removed from this store by the {@link #function-remove} or {@link #function-removeAll}.
       * Also fired when removing a child record in a tree store using {@link Core.data.mixin.TreeNode#function-removeChild}.
       * The remove may be vetoed by returning `false` from a handler.
       * @event beforeRemove
       * @param {Core.data.Store} source This Store
       * @param {Core.data.Model[]} records The records which are to be removed.
       * @param {Core.data.Model} parent The record from which children are being removed when using a tree store
       * @param {Boolean} isMove Set to `true` if the child node is being removed by
       * {@link Core.data.mixin.TreeNode#function-appendChild appendChild} to be moved
       * _within the same tree_.
       * @param {Boolean} removingAll Set to `true` if the operation is removing the store's entire data set.
       */

      /**
       * Fired before records are added to this store by the {@link #function-add} or {@link #function-insert}. In a tree
       * store, also fired by {@link Core.data.mixin.TreeNode#function-appendChild} and
       * {@link Core.data.mixin.TreeNode#function-insertChild}. The add or insert may be vetoed by returning `false`
       * from a handler.
       * @event beforeAdd
       * @param {Core.data.Store} source This Store
       * @param {Core.data.Model[]} records The records which are to be added
       * @param {Core.data.Model} parent The parent node when using a tree store
       * @preventable
       */

      /**
       * Fired after adding/inserting record(s). If the record was added to a parent, the `isChild` flag is set on the
       * event. If it was inserted, event contains `index`
       * @event add
       * @param {Core.data.Store} source This Store
       * @param {Core.data.Model[]} records Added records. In case of tree store, if branch is added, only branch root
       * is returned
       * @param {Core.data.Model[]} [allRecords] Flat list of all added records. In case of tree store, if branch is
       * added, all new records are returned, not only branch root
       * @param {Core.data.Model} [parent] If due to an {@link Core.data.mixin.TreeNode#function-appendChild appendChild}
       * call, this is the parent node added to.
       * @param {Number} [index] Insertion point in the store's {@link Core.data.Store#config-storage Collection}.
       * @param {Number} [oldIndex] Not used for tree stores. The index of the first record moved.
       * @param {Boolean} [isChild] Flag which is set to true if the records are added to a parent record
       * @param {Boolean} [isExpand] Flag which is set to true if records are added to the store by expanding parent
       * @param {Object} [isMove] An object keyed by the ids of the records which were moved from another
       * position in the store, or from another parent node in the store. The ids of moved records will be
       * property names with a value `true`.
       */

      /**
       * Fired when a record has been removed
       * @event remove
       * @param {Core.data.Store} source This Store
       * @param {Core.data.Model[]} records Removed records. In case of tree store, if branch is removed, only branch root
       * is returned
       * @param {Core.data.Model[]} [allRecords] Flat list of all removed records. In case of tree store, if branch is
       * removed, all removed records are returned, not only branch root
       * @param {Core.data.Model} [parent] If due to a {@link Core.data.mixin.TreeNode#function-removeChild removeChild}
       * call, this is the parent node removed from.
       * @param {Number} [index] Visible index at which record was removed. In case record is removed from the collapsed
       * branch -1 is returned.
       * @param {Boolean} [isChild] Flag which is set to true if the record is added to a parent record
       * @param {Boolean} [isCollapse] Flag which is set to true if records are removed from the store by collapsing parent
       * @param {Boolean} [isMove] Passed as `true` if the remove was part of a move operation within this Store.
       */
      //endregion
      //region Add, insert & remove

      /**
       * Removes a record from this store.
       * @param {String|String[]|Number|Number[]|Core.data.Model|Core.data.Model[]} records Record/array of records (or record ids) to remove
       * @param {Boolean} [silent] Specify `true` to suppress events/autoCommit
       * @returns {Core.data.Model[]} Removed records
       * @fires beforeRemove
       * @fires remove
       * @fires change
       * @category CRUD
       */
      value: function remove(records) {
        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var me = this,
            storage = me.storage;

        if (records instanceof Set) {
          records = Array.from(records);
        } // Ensure we have an array of records in case we are passed IDs


        records = (Array.isArray(records) ? records : [records]).reduce(function (result, r) {
          r = me.getById(r);

          if (r) {
            result.push(r);
          }

          return result;
        }, []);

        if (records.length) {
          // Flag that can be checked in linked store to determine if removal is ongoing
          me.isRemoving = true;

          if (me.tree) {
            // In case it's a set of records from different parents, group them by parent
            var removeChildArgs = records.reduce(function (result, child) {
              var parent = child.parent;

              if (parent) {
                if (!result[parent.id]) {
                  result[parent.id] = [parent, []];
                }

                result[parent.id][1].push(child);
              }

              return result;
            }, {}); // Remove the records each from their correct parent

            for (var _i = 0, _Object$values = Object.values(removeChildArgs); _i < _Object$values.length; _i++) {
              var argBlock = _Object$values[_i];
              argBlock[0].removeChild(argBlock[1], false, silent);
            }

            me.isRemoving = false;
            return records;
          } // Ensure that records in collapsed groups are removed and events fired.
          else if (me.isGrouped) {
              var oldCount = storage.count,
                  recordsInCollapsedGroups = [],
                  changedGroupParents = new Set(); // Collect any records which are in collapsed groups which will not be in the storage
              // Collection, and so will not cause a store change.
              // If we find some, we must fire the event which the store will react to and update itself.

              var _iterator = _createForOfIteratorHelper(records),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var rec = _step.value;

                  var _rec$instanceMeta = rec.instanceMeta(me),
                      groupParent = _rec$instanceMeta.groupParent;

                  if (groupParent && groupParent.meta.collapsed) {
                    recordsInCollapsedGroups.push(rec);
                  } // Collect group header records which change so they can announce this to cause UI updates.


                  _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_59__["default"].remove(groupParent.groupChildren, rec);
                  groupParent.meta.childCount--;
                  changedGroupParents.add(groupParent);
                } // The changed group parents must announce their changes, otherwise the group headers
                // in a UI will not refresh to reflect the change.

              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              var _iterator2 = _createForOfIteratorHelper(changedGroupParents),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _groupParent = _step2.value;
                  me.onModelChange(_groupParent, {}, {});
                } // The store must react as if these records in collapsed groups have been removed from storage

              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }

              if (recordsInCollapsedGroups.length) {
                storage.trigger('change', {
                  action: 'splice',
                  removed: recordsInCollapsedGroups,
                  added: [],
                  replaced: [],
                  oldCount: oldCount
                });
              }
            } // Give chance to veto or take action before records disappear.


          if (!records.length || !silent && me.trigger('beforeRemove', {
            records: records
          }) === false) {
            me.isRemoving = false;
            return null;
          }

          if (silent) {
            me.suspendEvents();
          }

          storage.remove(records);

          if (silent) {
            me.resumeEvents();
          }

          if (me.autoCommit) {
            me.doAutoCommit();
          }

          me.isRemoving = false;
        }

        return records;
      }
      /**
       * Clears store data. Used by removeAll, separate function for using with chained stores.
       * @private
       * @category CRUD
       */

    }, {
      key: "clear",
      value: function clear() {
        var removing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var me = this,
            storage = me.storage;

        if (me.storage.totalCount) {
          // Give chance to veto or take action before records disappear.
          if (removing && me.trigger('beforeRemove', {
            records: storage.allValues,
            removingAll: true
          }) === false) {
            return null;
          }

          if (!removing) {
            // If !removing, we suspend events, and Store#onDataChange won't get to
            // do all this stuff.
            var allRecords = me.registeredRecords;

            for (var i = allRecords.length - 1, rec; i >= 0; i--) {
              rec = allRecords[i];

              if (rec && !rec.isDestroyed) {
                rec.unJoinStore(me);
              }
            }

            me.removed.clear();
          }

          if (!removing) storage.suspendEvents(); // Clearing the storage will trigger 'removeAll' and 'change' if `removing`

          storage.clear();
          if (!removing) storage.resumeEvents();
          me.added.clear();
          me.modified.clear();
        }
      }
      /**
       * Removes all records from the store.
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Boolean} `true` unless the action was prevented, in which case it returns `false`
       * @fires beforeRemove
       * @fires removeAll
       * @fires change
       * @category CRUD
       */

    }, {
      key: "removeAll",
      value: function removeAll() {
        var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var me = this,
            storage = me.storage;
        var result;
        me.isRemoving = true; // No reaction to the storage Collection's change event.

        if (silent) {
          storage.suspendEvents(); // If silent, the storage Collection won't fire the event we react to
          // to unjoin, and we allow the removing flag in remove() to be true,
          // so *it* will not do the unJoin, so if silent, so do it here.

          var allRecords = me.registeredRecords;

          for (var i = allRecords.length - 1, rec; i >= 0; i--) {
            rec = allRecords[i];

            if (rec && !rec.isDestroyed) {
              rec.unJoinStore(me);
            }
          }
        }

        if (me.tree) {
          result = me.rootNode.clear() !== false;
        } else {
          result = me.clear() !== null;
        }

        if (silent) {
          storage.resumeEvents();
        }

        me.isRemoving = false;
        return result;
      }
      /**
       * Add records to store.
       * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} records Array of records/data or a single record/data to add to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Core.data.Model[]} Added records
       * @fires add
       * @fires change
       * @category CRUD
       */

    }, {
      key: "add",
      value: function add(records) {
        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var me = this,
            storage = me.storage,
            added = [];

        if (!Array.isArray(records)) {
          records = [records];
        } else if (!records.length) {
          // Adding zero records, bail out
          return;
        }

        me.tree = me.tree || Boolean(me.autoTree && records[0].children);

        if (me.tree) {
          var // Map and not Object to allow keys to keep their type
          parentIdMap = new Map(),
              _added = [];
          records.forEach(function (node) {
            var parentId = node[me.modelClass.parentIdField];

            if (!parentIdMap.has(parentId)) {
              parentIdMap.set(parentId, []);
            }

            parentIdMap.get(parentId).push(node);
          });
          parentIdMap.forEach(function (nodes, parentId) {
            var parentNode = parentId == null ? me.rootNode : me.getById(parentId);

            if (!parentNode) {
              throw new Error("Parent node with id ".concat(parentId, " not found, cannot add children."));
            }

            _added.push.apply(_added, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_52___default()(parentNode.appendChild(nodes, silent)));
          });
          return _added;
        } // Give chance to cancel action before records added.


        if (!silent) {
          if (me.trigger('beforeAdd', {
            records: records
          }) === false) {
            return null;
          }
        }

        me.tree = me.tree || Boolean(me.autoTree && records[0].children);

        if (me.tree) {
          return me.rootNode.appendChild(records);
        }

        records.forEach(function (data) {
          added.push(me.processRecord(data.isModel ? data : me.createRecord(data)));
        });

        if (silent) {
          me.suspendEvents();
        }

        storage.add(added);

        if (silent) {
          me.resumeEvents();
        }

        if (me.autoCommit) {
          me.doAutoCommit();
        }

        return added;
      }
      /**
       * Insert records to store.
       * @param {Number} index Index to insert at
       * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} records Array of records/data or a single record/data to insert to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Core.data.Model[]} Inserted records
       * @fires add
       * @fires change
       * @category CRUD
       */

    }, {
      key: "insert",
      value: function insert(index, records) {
        var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var me = this,
            storage = me.storage,
            added = [],
            insertBefore = me.getAt(index),
            _records = storage.values,
            removeIndices = [];
        if (!Array.isArray(records)) records = [records]; // Give chance to cancel action before records added.

        if (me.trigger('beforeAdd', {
          records: records
        }) === false) {
          return null;
        }

        var isNoop, start, i; // If the records starting at index or (index - 1), are the same sequence
        // that we are being asked to add, this is a no-op.

        if (_records[start = index] === records[0] || _records[start = index - 1] === records[0]) {
          for (isNoop = true, i = 0; isNoop && i < records.length; i++) {
            if (records[i] !== _records[start + i]) {
              isNoop = false;
            }
          }
        }

        if (isNoop) {
          return null;
        }

        records.forEach(function (data) {
          var record = me.processRecord(data.isModel ? data : me.createRecord(data)),
              removedAtIndex = storage.indexOf(record);

          if (record.children && record.children.length && me.autoTree) {
            me.tree = true;
          }

          added.push(record); // already in store, do some cleanup

          if (removedAtIndex > -1) {
            if (removedAtIndex < index && insertBefore) index--;
            removeIndices.push(removedAtIndex);
          } // Store previous index to be able to determine that it is a move, since Collection does not handle that


          record.meta.previousIndex = removedAtIndex;
        });

        if (me.tree) {
          var root = me.rootNode;
          return root.insertChild(records, root.children && root.children[index]);
        } // Silently remove them, so that they will be inserted into place.
        // Collection is stable by default, and inserting an existing item
        // is a no-op.


        me.suspendEvents();
        me.storage.remove(removeIndices);
        me.resumeEvents();

        if (silent) {
          me.suspendEvents();
        }

        storage.splice.apply(storage, [index, 0].concat(added));

        if (silent) {
          me.resumeEvents();
        }

        if (me.autoCommit) {
          me.doAutoCommit();
        }

        return added;
      }
      /**
       * Moves an individual item to another location.
       * @param {Object} item The item to move.
       * @param {Object} beforeItem the item to insert the first item before.
       * @category CRUD
       */

    }, {
      key: "move",
      value: function move(item, beforeItem) {
        this.storage.move(item, beforeItem);
      } //endregion
      //region Update multiple

    }, {
      key: "setMultiple",
      value: function setMultiple(filterFn, field, value) {
        var me = this,
            records = [],
            changes = [];
        me.forEach(function (r) {
          if (filterFn(r)) {
            changes.push(r.set(field, value, true));
            records.push(r);
          }
        }); // TODO: should consolidate with update, make it take an array instead? to only have to listen for one event outside of store?

        me.trigger('updateMultiple', {
          records: records,
          all: me.records.length === records.length
        });
        me.trigger('change', {
          action: 'updatemultiple',
          records: records,
          all: me.records.length === records.length
        });
        if (me.reapplyFilterOnUpdate && me.isFiltered) me.filter();
      }
    }, {
      key: "setAll",
      value: function setAll(field, value) {
        var me = this,
            changes = [];
        me.forEach(function (r) {
          changes.push(r.set(field, value, true));
        });
        me.trigger('updateMultiple', {
          records: me.records,
          all: true
        });
        me.trigger('change', {
          action: 'updatemultiple',
          records: me.records,
          all: true
        });
        if (me.reapplyFilterOnUpdate && me.isFiltered) me.filter();
      } //endregion
      //region Commit

      /**
       * Accepts all changes, resets the modification tracking:
       * * Clears change tracking for all records
       * * Clears added
       * * Clears modified
       * * Clears removed
       * Leaves the store in an "unmodified" state.
       * @internal
       */

    }, {
      key: "acceptChanges",
      value: function acceptChanges() {
        var me = this; // Clear record change tracking

        me.added.forEach(function (r) {
          return r.clearChanges(false);
        });
        me.modified.forEach(function (r) {
          return r.clearChanges(false);
        }); // Clear store change tracking

        me.added.clear();
        me.modified.clear();
        me.removed.clear();
      }
      /**
       * Commits changes, per default only returns changes and resets tracking.
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Object} Changes, see {@link #property-changes}
       * @fires beforeCommit
       * @fires commit
       * @category CRUD
       */

    }, {
      key: "commit",
      value: function commit() {
        var _this = this;

        var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        // resets stores tracking of changed records, doesn't store changes, only returns them
        var changes = this.changes;
        return this.callPreventable('commit', {
          changes: changes
        }, function () {
          _this.acceptChanges();

          return changes;
        }, [], silent);
      }
      /**
       * Discards changes in the store.
       * @fires change
       * @category CRUD
       * @private
       */
      // TODO: Need to think of its name. `reject` is a candidate.

    }, {
      key: "clearChanges",
      value: function clearChanges() {
        var me = this,
            changes = me.changes;
        me.remove(me.added.values, true);
        me.modified.forEach(function (r) {
          return r.clearChanges(false);
        }); // TODO: removed records should be restored

        me.added.clear();
        me.modified.clear();
        me.removed.clear();
        me.trigger('change', {
          action: 'clearchanges',
          changes: changes
        });
      }
      /**
       * Get uncommitted changes as an object of added/modified/removed arrays of records.
       *
       * ```javascript
       * // Format:
       * {
       *      added: [], // array of Core.data.Model
       *      modified: [], // array of Core.data.Model
       *      removed: [] // array of Core.data.Model
       * }
       * ```
       *
       * @property {Object} changes
       * @property {Array} changes.added Records that have been added
       * @property {Array} changes.modified Records that have changes to persistable fields
       * @property {Array} changes.removed Records that have been removed
       * @readonly
       * @category Records
       */

    }, {
      key: "suspendAutoCommit",

      /**
       * Suspends automatic commits upon store changes. Can be called multiple times (it uses an internal counter).
       * @category Records
       */
      value: function suspendAutoCommit() {
        this.suspendCount++;
      }
      /**
       * Resumes automatic commits upon store changes. Will trigger commit if the internal counter is 0.
       * @category Records
       */

    }, {
      key: "resumeAutoCommit",
      value: function resumeAutoCommit() {
        var doCommit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.suspendCount--;

        if (this.autoCommit && doCommit) {
          this.doAutoCommit();
        }
      }
    }, {
      key: "doAutoCommit",
      value: function doAutoCommit() {
        if (this.suspendCount <= 0) {
          this.commit();
        }
      } //endregion
      //region Changes from other store

      /**
       * Applies changes from another store to this store. Useful if cloning records in one store to display in a
       * grid in a popup etc. to reflect back changes.
       * @param {Core.data.Store} otherStore
       * @category CRUD
       */

    }, {
      key: "applyChangesFromStore",
      value: function applyChangesFromStore(otherStore) {
        var me = this,
            changes = otherStore.changes;
        if (!changes) return;

        if (changes.added) {
          me.add(changes.added);
        }

        if (changes.removed) {
          // Remove using id, otherwise indexOf in remove fn won't yield correct result
          me.remove(changes.removed.map(function (r) {
            return r.id;
          }));
        }

        if (changes.modified) {
          changes.modified.forEach(function (record) {
            var localRecord = me.getById(record.id);
            localRecord.set(record.modifications);
          });
        }
      } //endregion

    }, {
      key: "changes",
      get: function get() {
        var me = this,
            // Only include modified records that has persistable changes
        modified = me.modified.values.filter(function (r) {
          return r.rawModifications;
        });
        return me.added.count || modified.length || me.removed.count ? {
          // Slicing to have changes intact when triggering commit
          added: me.added.values.slice(),
          modified: modified,
          removed: me.removed.values.slice()
        } : null;
      }
      /**
       * Setting autoCommit to true automatically commits changes to records.
       * @property {Boolean}
       * @category Records
       */

    }, {
      key: "autoCommit",
      get: function get() {
        return this._autoCommit;
      },
      set: function set(auto) {
        this._autoCommit = auto;

        if (auto && this.changes) {
          this.commit();
        }
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreCRUD';
      } //region Config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Commit changes automatically
           * @config {Boolean}
           * @default
           * @category Common
           */
          autoCommit: false,
          suspendCount: 0
        };
      }
    }]);

    return StoreCRUD;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_58__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreChained.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/mixin/StoreChained.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");




















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
 // TODO: turn into plugin instead?

/**
 * @module Core/data/mixin/StoreChained
 */

var returnTrue = function returnTrue() {
  return true;
};
/**
 * A chained Store contains a subset of records from a master store. Which records to include is determined by a
 * filtering function, {@link #config-chainedFilterFn}.
 *
 * @example
 * masterStore.makeChained(record => record.percent < 10);
 *
 * // or
 *
 * new Store({
 *   masterStore     : masterStore,
 *   chainedFilterFn : record => record.percent < 10
 * });
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(StoreChained, _ref);

    var _super = _createSuper(StoreChained);

    function StoreChained() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, StoreChained);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(StoreChained, [{
      key: "construct",
      //endregion
      value: function construct(config) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(StoreChained.prototype), "construct", this).call(this, config);

        var me = this,
            masterStore = me.masterStore;

        if (masterStore) {
          me.methodNamesToRelay.forEach(function (fnName) {
            return me[fnName] = function () {
              for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
                params[_key] = arguments[_key];
              }

              return me.relayToMaster(fnName, params);
            };
          });

          me.removeAll = function () {
            for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              params[_key2] = arguments[_key2];
            }

            masterStore.remove.apply(masterStore, [me.getRange()].concat(params));
          }; // TODO: prevent other functions?


          masterStore.on({
            // HACK to have chained stores react early in a async events scenario (with engine). Could be turned
            // into a config, but this way one does not have to think about it
            changePreCommit: me.onMasterDataChangedPreCommit,
            change: me.onMasterDataChanged,
            prio: 1,
            thisObj: me
          });

          if (!masterStore.chainedStores) {
            masterStore.chainedStores = [];
          }

          masterStore.chainedStores.push(me);
          me.fillFromMaster();
        }
      } //region Properties

      /**
       * Is this a chained store?
       * @property {Boolean}
       * @readonly
       * @category Store
       */

    }, {
      key: "updateChainedStores",
      //endregion
      //region Internal
      value: function updateChainedStores() {
        if (this.chainedStores) {
          this.chainedStores.forEach(function (store) {
            return store.fillFromMaster();
          });
        }
      }
      /**
       * Updates records available in a chained store by filtering the master store records using
       * {@link #config-chainedFilterFn}
       */

    }, {
      key: "fillFromMaster",
      value: function fillFromMaster() {
        var me = this,
            masterStore = me.masterStore,
            isTree = me.isTree;

        if (!me.isChained) {
          throw new Error('fillFromMaster only allowed on chained store');
        }

        if (me.keepUncommittedChanges) {
          if (isTree) {
            throw new Error('Cannot use keepUncommittedChanges on a chained tree store');
          }

          me.data = [].concat(me.added.values.filter(function (r) {
            return !me.removed.includes(r);
          }), masterStore.allRecords.filter(function (r) {
            return !me.removed.includes(r) && !me.added.includes(r) && me.chainedFilterFn(r);
          }));
        } else {
          var records = masterStore.allRecords.filter(me.chainedFilterFn);

          if (isTree) {
            // All nodes will be registered
            me.idRegister = {};
            me.internalIdRegister = {}; // *all* owned records have to join, as they would have done if they'd all gone through
            // the appendChild route for this store.

            records.forEach(function (r) {
              if (r.stores.includes(me)) {
                me.register(r);
              } else {
                r.joinStore(me);
              }
            }); // We exclude collapsed records by default. It's used in Columns Store.
            // Because grid columns is a tree store when subgrid columns is just a chained store of the columns store.
            // And we don't need to include collapsed column.
            // If we need to show collapsed nodes in Combo we need to chain tree store and set `excludeCollapsedRecords` to `false`.

            if (me.excludeCollapsedRecords) {
              var children = me.getChildren(me.rootNode);
              records = me.doIncludeExclude(children, true);
            }
          }

          me.data = records;
        }
      }
      /**
       * Commits changes back to master.
       * - the records deleted from chained store and present in master will be deleted from master
       * - the records added to chained store and missing in master will added to master
       * Internally calls {Store#function-commit commit()}.
       * @returns {Object} Changes, see Store#changes
       * @internal
       */

    }, {
      key: "commitToMaster",
      value: function commitToMaster() {
        var me = this,
            master = me.masterStore;

        if (!me.isChained) {
          throw new Error('commitToMaster only allowed on chained store');
        }

        master.beginBatch();
        master.remove(me.removed.values);
        master.add(me.added.values);
        master.endBatch();
        return me.commit();
      }
      /**
       * Relays some function calls to the master store
       * @private
       */

    }, {
      key: "relayToMaster",
      value: function relayToMaster(fnName, params) {
        var _this$masterStore;

        return (_this$masterStore = this.masterStore)[fnName].apply(_this$masterStore, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12___default()(params));
      } // HACK, when used with engine the chained store will catch events early (sync) and prevent late (async) listeners

    }, {
      key: "onMasterDataChangedPreCommit",
      value: function onMasterDataChangedPreCommit(event) {
        this.onMasterDataChanged(event);
        this.$masterEventhandled = true;
      }
      /**
       * Handles changes in master stores data. Updates the chained store accordingly
       * @private
       */

    }, {
      key: "onMasterDataChanged",
      value: function onMasterDataChanged(_ref2) {
        var _this$chainedFields;

        var action = _ref2.action,
            changes = _ref2.changes,
            $handled = _ref2.$handled;

        // Handled early in engine store (above), bail out
        if (this.$masterEventhandled) {
          this.$masterEventhandled = false;
          return;
        } // if a field not defined in chainedFields is changed, ignore the change.
        // there is no need to refilter the store in such cases, the change will be available anyhow since data is
        // shared


        if (action !== 'update' || ((_this$chainedFields = this.chainedFields) === null || _this$chainedFields === void 0 ? void 0 : _this$chainedFields.some(function (field) {
          return field in changes;
        }))) {
          this.fillFromMaster();
        }
      } //endregion

    }, {
      key: "isChained",
      get: function get() {
        return Boolean(this.masterStore);
      }
    }, {
      key: "chainedFilterFn",
      set: function set(chainedFilterFn) {
        this._chainedFilterFn = this.thisObj ? chainedFilterFn.bind(this.thisObj) : chainedFilterFn;
      },
      get: function get() {
        return this._chainedFilterFn || returnTrue;
      }
    }, {
      key: "methodNamesToRelay",
      get: function get() {
        var _this = this;

        var doIsArray = Array.isArray(this.doRelayToMaster),
            dontIsArray = Array.isArray(this.dontRelayToMaster);
        return doIsArray && this.doRelayToMaster.filter(function (name) {
          return !dontIsArray || !_this.dontRelayToMaster.includes(name);
        }) || [];
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreChained';
      } //region Config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Function used to filter records in the masterStore into a chained store
           * @config {Function}
           * @default () => true
           * @category Chained store
           */
          chainedFilterFn: null,

          /**
           * Array of fields that should trigger filtering of chained store when the fields are updated.
           * @config {String[]}
           * @category Chained store
           */
          chainedFields: null,

          /**
           * Master store that a chained store gets its records from.
           * @config {Store}
           * @category Chained store
           */
          masterStore: null,

          /**
           * Method names calls to which should be relayed to master store.
           * @config {String[]}
           * @category Chained store
           */
          doRelayToMaster: ['add', 'remove', 'insert'],

          /**
           * Method names calls to which shouldn't be relayed to master store.
           * @config {String}
           * @category Chained store
           */
          dontRelayToMaster: [],

          /**
           * Flag showing whether to keep added/removed uncommitted records when filling the store from master.
           * @config {Boolean}
           * @category Chained store
           */
          keepUncommittedChanges: false,

          /**
           * If true, collapsed records in original tree will be excluded from the chained store.
           * @config {Boolean}
           * @category Chained store
           * @internal
           */
          excludeCollapsedRecords: true
        };
      }
    }]);

    return StoreChained;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_19__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreFilter.js":
/*!********************************************!*\
  !*** ./lib/Core/data/mixin/StoreFilter.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Core/data/mixin/StoreFilter
 */

/**
 * Mixin for Store that handles filtering.
 * Filters are instances of {@link Core.util.CollectionFilter CollectionFilter} class.
 *
 * - Adding a filter for the same property will replace the current one (unless a unique {@link Core.util.CollectionFilter#config-id Id} is specified),
 * but will not clear any other filters.
 * - Adding a filter through the {@link #function-filterBy} function is ultimate.
 * It will clear all the property based filters and replace the current filterBy function if present.
 * - Removing records from the store does not remove filters!
 * The filters will be reapplied if {@link #config-reapplyFilterOnAdd}/{@link #config-reapplyFilterOnUpdate} are true and you add new records or update current.
 *
 * ```
 * // Add a filter
 * store.filter({
 *     property : 'score',
 *     value    : 10,
 *     operator : '>'
 * });
 *
 * // Add filter as a function
 * store.filter(record => record.score > 10);
 *
 * // Add named filter as a function
 * store.filter({
 *     id : 'my filter',
 *     filterBy : record => record.score > 10
 * });
 *
 * // Replace any filter set with new filters
 * store.filter({
 *     filters : {
 *         property : 'score',
 *         value    : 10,
 *         operator : '>'
 *     },
 *     replace : true
 * });
 *
 * // Remove this one specific filter, leaving any possible others in place.
 * // A filter's id defaults to the property name that it's filtering on.
 * store.removeFilter('score');
 *
 * // Reapply filters without firing an event.
 * // Use if making multiple data mutations with the
 * // intention of updating UIs when all finished.
 * store.filter({
 *     silent : true
 * });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(StoreFilter, _ref);

    var _super = _createSuper(StoreFilter);

    function StoreFilter() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, StoreFilter);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(StoreFilter, [{
      key: "traverseFilter",
      //endregion
      value: function traverseFilter(record) {
        var me = this,
            hitsCurrent = !record.isRoot && me.filtersFunction(record),
            children = record.unfilteredChildren || record.children; // leaf, bail out

        if (!children || !children.length) {
          return hitsCurrent;
        }

        if (!record.unfilteredChildren) {
          record.unfilteredChildren = record.children.slice();
        }

        record.children = record.unfilteredChildren.filter(function (r) {
          return me.traverseFilter(r);
        }); // unfilteredIndex must be set for child elements

        record.updateChildrenIndices(record.unfilteredChildren, true); // parentIndex must be set for visible child elements

        record.updateChildrenIndices(record.children, false);
        return hitsCurrent || Boolean(record.children.length);
      }
    }, {
      key: "traverseClearFilter",
      value: function traverseClearFilter(record) {
        var me = this;

        if (record.unfilteredChildren) {
          record.children = record.unfilteredChildren.slice();
          record.unfilteredChildren = null;
        }

        if (record.children) {
          record.children.forEach(function (r) {
            return me.traverseClearFilter(r);
          });
        }
      } // TODO: Get rid of this.
      // The Filter feature of a Grid pokes around in the Store to ask this question.

    }, {
      key: "addFilter",

      /**
       * Adds a single filter to the {@link #config-filters} collection. By default, filters are reevaluated
       * and a Store change event fired.
       *
       * If the `silent` parameter is passed as `true`, multiple filters can be added without causing data changes.
       *
       * When the filters are as required, call {@link #function-filter} with no parameters
       * to apply the filters to the store.
       *
       * @param {Object|Function} newFilters A {@link Core.util.CollectionFilter filter} config,
       * or a function to use for filtering.
       * @param {Boolean} [silent] Pass `true` to *not* refilter the store immediately. Such as when
       * adding multiple filters.
       * @returns {Core.util.CollectionFilter} The Filter instance that was added.
       * @category Sort, group & filter
       */
      value: function addFilter(filter) {
        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        filter = filter instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"] ? filter : new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"](filter); // We want notification upon change of field, value or operator

        filter.owner = this; // Collection will replace any already existing filter on the field, unless it has id specified

        this.filters.add(filter);

        if (!silent) {
          this.filter();
        }

        return filter;
      }
      /**
       * Filters the store by **adding** the specified filter(s) to the existing filters collection applied to this Store.
       * If a filter has an {@link Core.util.CollectionFilter#config-id id} specified,
       * or a {@link Core.util.CollectionFilter#config-property property} specified,
       * it will search for corresponding filter(s) in the existing filters first and replace it with a new filter.
       * **It will not remove other filters applied to the store!**
       *
       * To **add** a new filter:
       * ```
       * // Filter using simple object
       * store.filter({
       *     property : 'age',
       *     operator : '>',
       *     value    : 90
       * });
       *
       * // Filter using function
       * store.filter(r => r.age < 90);
       *
       * // Filter using a named filter as a function
       * store.filter({
       *     id : 'my-filter',
       *     filterBy : record => record.score > 10
       * });
       * ```
       *
       * To **remove** a specific filter, but keep other filters applied
       * ```
       * // Remove by filter `id` or `property`. Filter `id` defaults to the `property` name.
       * store.removeFilter('age');
       * store.removeFilter('my-filter');
       * ```
       *
       * To **replace** all existing filters with a new filter
       * ```
       * // Remove all filters and filter using simple object
       * store.filter({
       *     filters : {
       *         property : 'age',
       *         operator : '<',
       *         value    : 90
       *     },
       *     replace : true
       * });
       *
       * // Remove all filters and filter using function
       * store.filter({
       *     filters : r => r.age > 90,
       *     replace : true
       * });
       *
       * // Remove all filters and filter using a named filter as a function
       * store.filter({
       *     filters : {
       *         id : 'my-filter',
       *         filterBy : record => record.score > 10
       *     },
       *     replace : true
       * });
       * ```
       *
       * Basically filters replacing is an equivalent of having two sequenced calls:
       * {@link #function-clearFilters clearFilters} and {@link #function-filter filter}.
       *
       * Call without arguments to reapply filters.
       * ```
       * // Re-filter the store
       * store.filter();
       * ```
       *
       * @param {Object|Object[]|Function} newFilters
       *        A {@link Core.util.CollectionFilter filter} config,
       *        or an array of {@link Core.util.CollectionFilter filter} configs,
       *        or a function to use for filtering,
       *        or a special object like: ```{ replace : true, filters : newFilters }```
       * @param {Boolean} [newFilters.replace]
       *        A flag, indicating whether or not the previous filters should be removed.
       * @param {Object|Object[]|Function} [newFilters.filters]
       *        If `newFilters` is an object and `replace` property is defined in the `newFilters`,
       *        it means that special object is used and real filter configuration must be nested down to this `filters` property.
       *        It can be:
       *        A {@link Core.util.CollectionFilter filter} config,
       *        or an array of {@link Core.util.CollectionFilter filter} configs,
       *        or a function to use for filtering.
       * @fires filter
       * @fires change
       * @category Sort, group & filter
       */

    }, {
      key: "filter",
      value: function filter(newFilters) {
        var me = this,
            filters = me.filters;
        var silent = false;

        if (newFilters) {
          var fieldType = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17___default()(newFilters);

          if (fieldType === 'object') {
            if ('silent' in newFilters || 'replace' in newFilters) {
              silent = newFilters.silent;

              if (newFilters.replace) {
                filters.clear();
              }

              newFilters = newFilters.filters;
              fieldType = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17___default()(newFilters);
            }
          } // If it was just a config object containing no filters, this will be null


          if (newFilters) {
            // We will not be informed about Filter mutations while configuring.
            me.isConfiguring = true; // If we provide array of objects looking like :
            //  {
            //      property  : 'fieldName',
            //      value     : 'someValue',
            //      [operator : '>']
            //  }
            //  or ...
            //  {
            //      property : 'fieldName',
            //      filterBy : function (value, record) {
            //          return value > 50;
            //      }
            //  }

            if (Array.isArray(newFilters)) {
              newFilters.forEach(function (f) {
                return me.addFilter(f, true);
              }, me);
            } else if (fieldType === 'function') {
              me.addFilter(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"](newFilters), true);
            } // Old signature of fieldname, value with implicit equality test.
            // Not documented, but still tested.
            else if (fieldType === 'string') {
                me.addFilter({
                  property: newFilters,
                  value: arguments[1]
                }, true);
              } // An object-based filter definition
              else {
                  me.addFilter(newFilters, true);
                } // Open up to recieving Filter mutation notifications again


            me.isConfiguring = false; // We added a disabled filter to either no filters, or all disabled filters, so no change.

            if (!me.isFiltered) {
              return;
            }
          }
        } // Invalidate the filtersFunction so that it has to be recalculated upon next access


        me.filtersFunction = null; // Implemented here for local filtering, and AjaxStore implements for remote.

        me.performFilter(silent);
      }
      /**
       * Perform filtering according to the {@link #property-filters} Collection.
       * This is the internal implementation which is overridden in {@link Core.data.AjaxStore} and
       * must not be overridden.
       * @private
       */

    }, {
      key: "performFilter",
      value: function performFilter(silent) {
        var me = this,
            storage = me.storage,
            filters = me.filters,
            rootNode = me.rootNode,
            oldCount = me.count;

        if (me.tree) {
          if (me.isFiltered) {
            me.traverseFilter(rootNode);
          } else {
            me.traverseClearFilter(rootNode);
          }

          storage.replaceValues({
            values: me.collectDescendants(rootNode).visible,
            silent: true
          });
        } else {
          if (me.isFiltered) {
            storage.addFilter({
              id: 'primary-filter',
              filterBy: me.filtersFunction
            });
          } else {
            storage.filters.clear();
          }
        }

        me.afterPerformFilter(silent ? null : {
          action: 'filter',
          filters: filters,
          oldCount: oldCount,
          records: me.storage.values
        });
      }
    }, {
      key: "afterPerformFilter",
      value: function afterPerformFilter(event) {
        this.resetRelationCache();

        if (event) {
          this.triggerFilterEvent(event);
        }
      }
    }, {
      key: "triggerFilterEvent",
      // Used from filter() and StoreCRUD when reapplying filters
      value: function triggerFilterEvent(event) {
        this.trigger('filter', event); // Only fire these events if it's a local filter.
        // If we are configured with filterParamName, the loadData will fire them.

        if (!this.remoteFilter) {
          this.trigger('refresh', event);
          this.trigger('change', event);
        }
      }
      /**
       * *Adds* a function used to filter the store. Alias for calling `filter(fn)`. Return `true` from the function to
       * include record in filtered set
       *
       * ```javascript
       * store.filterBy(record => record.age > 25 && record.name.startsWith('A'));
       * ```
       *
       * @param {Function} fn Function used to test records
       * @category Sort, group & filter
       */

    }, {
      key: "filterBy",
      value: function filterBy(fn) {
        this.filter(fn);
      }
      /**
       * Removes the passed filter, or the filter by the passed ID from the {@link #config-filters} collection.
       * By default, filters are reevaluated and a Store change event fired.
       *
       * If the `silent` parameter is passed as `true`, multiple filters can be removed without causing data changes.
       *
       * When the filters are as required, call {@link #function-filter} with no parameters
       * to apply the filters to the store.
       *
       * @param {String|Core.util.CollectionFilter} idOrInstance Filter to remove, or ID of the filter to remove. By default,
       * filtera are reevaluated and a change event fired.
       * @param {Boolean} [silent] Pass `true` to *not* refilter the store immediately. Such as when
       * removing multiple filters.
       * @returns {Core.util.CollectionFilter} The Filter instance that was removed.
       *
       *```javascript
       *  // Only view top priority events
       *  myEventStore.filter({
       *      id       : 'priorityFilter',
       *      property : 'priority',
       *      value    : 1,
       *      operator : '='
       *  });
       *
       * // That individual filter can be removed like this
       *  myEventStore.removeFilter('priorityFilter');
       *
       * // Add named filter as a function
       * store.filter({
       *     id : 'my filter',
       *     filterBy : record => record.score > 10
       * });
       *
       * // Remove named filter function
       * store.removeFilter('my filter');
       *```
       * @category Sort, group & filter
       */

    }, {
      key: "removeFilter",
      value: function removeFilter(idOrInstance) {
        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var me = this,
            filter = idOrInstance instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"] ? idOrInstance : me.filters.get(idOrInstance); // If we have such a filter, remove it.

        if (filter) {
          me.filters.remove(filter); // Invalidate the filtersFunction so that it has to be recalculated upon next access

          me._filtersFunction = null;

          if (!silent) {
            me.filter();
          }

          return filter;
        }
      }
      /**
       * Removes all filters from the store.
       * @category Sort, group & filter
       */

    }, {
      key: "clearFilters",
      value: function clearFilters() {
        this.filters.clear();
        this.filter();
      }
    }, {
      key: "convertFilterToString",
      value: function convertFilterToString(field) {
        var filter = this.filters.getBy('property', field);
        return filter && !filter.filterBy ? String(filter) : '';
      }
    }, {
      key: "reapplyFilterOnAdd",
      //endregion
      //region Events

      /**
       * Fired after applying filters to the store
       * @event filter
       * @param {Core.data.Store} source This Store
       * @param {Core.util.Collection} filters Filters used by this Store
       * @param {Core.data.Model[]} records Filtered records
       */
      //endregion
      //region Properties
      set: function set(enable) {
        this.storage.autoFilter = enable;
      },
      get: function get() {
        return this.storage.autoFilter;
      }
      /**
       * Currently applied filters. A collection of {@link Core.util.CollectionFilter} instances.
       * @type {Core.util.Collection}
       * @readonly
       * @category Sort, group & filter
       */

    }, {
      key: "filters",
      set: function set(filters) {
        var me = this,
            collection = me.filters;
        collection.clear(); // Invalidate the filtersFunction so that it has to be recalculated upon next access

        me._filtersFunction = null; // If we are being asked to filter, parse the filters.

        if (filters) {
          if (filters.constructor.name === 'Object') {
            for (var _i = 0, _Object$entries = Object.entries(filters); _i < _Object$entries.length; _i++) {
              var f = _Object$entries[_i];

              // Entry keys are either a field name with its value being the filter value
              // or, there may be one filterBy property which specifies a filering function.
              if (f[0] === 'filterBy' && typeof f[1] === 'function') {
                collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"]({
                  filterBy: f[1]
                }));
              } else {
                collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"](f[1].constructor.name === 'Object' ? Object.assign({
                  property: f[0]
                }, f[1]) : {
                  property: f[0],
                  value: f[1]
                }));
              }
            }
          } else if (Array.isArray(filters)) {
            // Make sure we are adding CollectionFilters
            collection.add.apply(collection, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_16___default()(filters.map(function (filterConfig) {
              if (filterConfig instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"]) {
                return filterConfig;
              }

              return new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"](filterConfig);
            })));
          } else if (filters.isCollection) {
            // Use supplied collection? Opting to use items from it currently
            collection.add.apply(collection, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_16___default()(filters.values));
          } else {
            collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"]({
              filterBy: filters
            }));
          }

          collection.forEach(function (item) {
            return item.owner = me;
          });
        }
      },
      get: function get() {
        return this._filters || (this._filters = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_26__["default"]({
          extraKeys: ['property']
        }));
      }
    }, {
      key: "filtersFunction",
      set: function set(filtersFunction) {
        this._filtersFunction = filtersFunction;
      },
      get: function get() {
        var me = this,
            filters = me.filters,
            isGrouped = me.isGrouped;

        if (!me._filtersFunction) {
          if (filters.count) {
            var generatedFilterFunction = _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_24__["default"].generateFiltersFunction(filters);

            me._filtersFunction = function (candidate) {
              // A group record is filtered in if it has passing groupChildren.
              if (isGrouped && candidate.isSpecialRow) {
                return candidate.groupChildren.some(generatedFilterFunction);
              } else {
                return generatedFilterFunction(candidate);
              }
            };
          } else {
            me._filtersFunction = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].returnTrue;
          }
        }

        return me._filtersFunction;
      }
      /**
       * Check if store is filtered
       * @returns {Boolean}
       * @readonly
       * @category Sort, group & filter
       */

    }, {
      key: "isFiltered",
      get: function get() {
        return this.filters.values.some(function (filter) {
          return !filter.disabled;
        });
      }
    }, {
      key: "latestFilterField",
      get: function get() {
        return this.filters.last ? this.filters.last.property : null;
      }
    }, {
      key: "filtered",
      get: function get() {
        return this.storage.isFiltered;
      }
    }, {
      key: "filterState",
      get: function get() {
        return this.filters.values.map(function (filter) {
          return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].cleanupProperties(filter.config);
        });
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreFilter';
      } //region Config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Specify a filter config to use initial filtering
           * @config {Object}
           * @category Filtering
           */
          filters: null,

          /**
           * Specify true to reapply filters when a record is added to the store.
           * @config {Boolean}
           * @default
           * @category Filtering
           */
          reapplyFilterOnAdd: false,

          /**
           * Specify true to reapply filters when a record is updated in the store.
           * @config {Boolean}
           * @default
           * @category Filtering
           */
          reapplyFilterOnUpdate: false
        };
      }
    }]);

    return StoreFilter;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_23__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreGroup.js":
/*!*******************************************!*\
  !*** ./lib/Core/data/mixin/StoreGroup.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");

























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/data/mixin/StoreGroup
 */

var resortActions = {
  add: 1,
  replace: 1
};
/**
 * Mixin for Store that handles grouping.
 *
 * ```javascript
 * // simple grouper
 * store.group('city');
 *
 * // grouper as object, descending order
 * store.group({ field : 'city', ascending : false });
 *
 * // using custom sorting function
 * store.group({
 *     field : 'city',
 *     fn : (recordA, recordB) => {
 *         // apply custom logic, for example:
 *         return recordA.city.length < recordB.city.length ? -1 : 1;
 *     }
 * });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default()(StoreGroup, _ref);

    var _super = _createSuper(StoreGroup);

    function StoreGroup() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, StoreGroup);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(StoreGroup, [{
      key: "construct",
      //endregion
      //region Init
      value: function construct(config) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(StoreGroup.prototype), "construct", this).call(this, config); // For handling record mutation, *not* add/remove of records.
        // Sorts dataset if necessary.


        this.on('change', this.onDataChanged);
      }
      /**
       * Currently used groupers
       * @property {Object[]}
       * @category Sort, group & filter
       */

    }, {
      key: "storeCollapsedGroups",
      value: function storeCollapsedGroups() {
        var me = this;
        me.collapsedGroupsHash = {}; // Remember which groups are collapsed

        if (me.groupRecords && me.groupRecords.length) {
          me.groupRecords.forEach(function (rec) {
            if (me.expand(rec)) {
              me.collapsedGroupsHash[rec.id] = true;
            }
          });
          return true;
        }

        return false;
      }
    }, {
      key: "restoreCollapsedGroups",
      value: function restoreCollapsedGroups() {
        var me = this,
            collapsedGroupsHash = me.collapsedGroupsHash;
        collapsedGroupsHash && Object.keys(collapsedGroupsHash).forEach(function (id) {
          return me.collapse(me.getById(id));
        });
      }
    }, {
      key: "onDataChange",
      value: function onDataChange(_ref2) {
        var storage = _ref2.source,
            action = _ref2.action,
            removed = _ref2.removed;
        var me = this,
            groupers = me.groupers; // Only do grouping transformations if we have groupers to apply.
        // In stores which never use grouping, this code is superfluous and will reduce performance.
        // The else side will simply replace the ungrouped data with itself.

        if (groupers) {
          var records = storage.values; // When records are added or removed, re-evaluate the group records
          // so that when the events are fired by the super call, the group
          // records are in place.

          if (groupers.length) {
            if (action === 'splice' && removed && removed.length) {
              // Remember which groups are collapsed
              if (me.storeCollapsedGroups()) {
                me.storage.replaceValues({
                  values: me.removeHeadersAndFooters(records),
                  silent: true
                });
              }

              me.storage.replaceValues({
                values: me.prepareGroupRecords(records),
                silent: true
              }); // Re-collapse the groups

              me.restoreCollapsedGroups();
            }
          } // Remove all group headers and footers
          else {
              storage.replaceValues({
                values: me.removeHeadersAndFooters(records),
                silent: true
              });
            }
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(StoreGroup.prototype), "onDataChange", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(StoreGroup.prototype), "onDataChange", this).apply(this, arguments);
      } // private function that collapses on the data level
      // TODO: make public and trigger events for grid to react to?

    }, {
      key: "collapse",
      value: function collapse(groupRecord) {
        if (groupRecord && !groupRecord.meta.collapsed) {
          this.excludeGroupRecords(groupRecord);
          groupRecord.meta.collapsed = true;
          return true;
        }

        return false;
      } // private function that expands on the data level
      // TODO: make public and trigger events for grid to react to?

    }, {
      key: "expand",
      value: function expand(groupRecord) {
        if (groupRecord && groupRecord.meta.collapsed) {
          this.includeGroupRecords(groupRecord);
          groupRecord.meta.collapsed = false;
          return true;
        }

        return false;
      }
    }, {
      key: "removeHeadersAndFooters",
      value: function removeHeadersAndFooters(records) {
        var me = this;
        return records.filter(function (r) {
          if (r.isSpecialRow) {
            me.unregister(r);
            return false;
          } else {
            return true;
          }
        }, true);
      }
    }, {
      key: "prepareGroupRecords",
      value: function prepareGroupRecords(records) {
        var me = this;
        records = me.removeHeadersAndFooters(records);

        if (!me.isGrouped) {
          return records;
        }

        var groupedRecords = [],
            field = me.groupers[0].field,
            groupRecords = [];
        var curGroup = null,
            curGroupRecord = null,
            childCount = 0;

        function addFooter() {
          var val = curGroupRecord.meta.groupRowFor,
              id = "group-footer-".concat(typeof val === 'number' ? val : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].createId(val)),
              footer = me.getById(id) || new me.modelClass({
            id: id
          }, me, {
            specialRow: true,
            groupFooterFor: val,
            groupRecord: curGroupRecord
          });
          me.register(footer);
          footer.groupChildren = curGroupRecord.groupChildren;
          groupRecords.push(footer);
          groupedRecords.push(footer);
          me.allRecords.push(footer);
          curGroupRecord.groupChildren.push(footer);
          childCount++;
          return footer;
        }

        records.forEach(function (record) {
          var val = record[field] == undefined ? '__novalue__' : record[field],
              id = "group-header-".concat(typeof val === 'number' ? val : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].createId(val)); // A group header or footer record of an empty group.
          // Remove from the data

          if (record.groupChildren && !record.groupChildren.length) {
            me.unregister(record);
            return;
          }

          if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isEqual(val, curGroup)) {
            if (curGroupRecord) {
              // also add group footer? used by GroupSummary feature
              if (me.useGroupFooters) {
                addFooter(curGroupRecord);
              }

              curGroupRecord.meta.childCount = childCount;
            }

            curGroupRecord = me.getById(id) || new me.modelClass({
              id: id
            }, me, {
              specialRow: true,
              groupRowFor: val,
              groupField: field
            });
            me.register(curGroupRecord);
            curGroupRecord.groupChildren = [];
            groupedRecords.push(curGroupRecord);
            me.allRecords.push(curGroupRecord);
            groupRecords.push(curGroupRecord);
            curGroup = val;
            childCount = 0;
          }

          record.instanceMeta(me.id).groupParent = curGroupRecord;
          groupedRecords.push(record);
          curGroupRecord.groupChildren.push(record);
          childCount++;
        }); // misses for last group without this

        if (curGroupRecord) {
          // footer for last group
          if (me.useGroupFooters) {
            addFooter();
          }

          curGroupRecord.meta.childCount = childCount;
        }

        me.groupRecords = groupRecords;
        return groupedRecords;
      } //endregion
      //region Group and ungroup

      /**
       * Is store currently grouped?
       * @property {Boolean}
       * @readonly
       * @category Sort, group & filter
       */

    }, {
      key: "group",

      /**
       * Group records, either by replacing current sorters or by adding to them.
       * A grouper can specify a **_custom sorting function_** which will be called with arguments (recordA, recordB).
       * Works in the same way as a standard array sorter, except that returning `null` triggers the stores
       * normal sorting routine. Grouped store **must** always be sorted by the same field.
       *
       * ```javascript
       * // simple grouper
       * store.group('city');
       *
       * // grouper as object, descending order
       * store.group({ field : 'city', ascending : false });
       *
       * // using custom sorting function
       * store.group({
       *     field : 'city',
       *     fn : (recordA, recordB) => {
       *         // apply custom logic, for example:
       *         return recordA.city.length < recordB.city.length ? -1 : 1;
       *     }
       * });
       * ```
       *
       * @param {String|Object} field Field to group by.
       * Can also be a config containing a field to group by and a custom sorting function called `fn`.
       * @param {Boolean} [ascending] Sort order of the group titles
       * @param {Boolean} [add] Add a grouper (true) or use only this grouper (false)
       * @param {Boolean} [performSort] Trigger sort directly, which does the actual grouping
       * @param {Boolean} [silent] Set as true to not fire events
       * @category Sort, group & filter
       * @fires group
       * @fires refresh
       */
      value: function group(field, ascending) {
        var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var performSort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var me = this;
        var newGrouper;

        if (add) {
          me.groupers.push(newGrouper = {
            field: field,
            ascending: ascending,
            complexMapping: field.includes('.')
          });
        } else if (field) {
          if (ascending == undefined) {
            ascending = me.groupInfo && me.groupInfo.field === field ? !me.groupInfo.ascending : true;
          }

          me.groupInfo = newGrouper = {
            field: field,
            ascending: ascending,
            complexMapping: field.includes('.')
          };
          me.groupers = [me.groupInfo];
        }

        if (newGrouper) {
          var prototype = me.modelClass.prototype; // Create a getter for complex field names like "get resource.city"

          if (newGrouper.complexMapping && !Object.prototype.hasOwnProperty.call(prototype, field)) {
            Object.defineProperty(prototype, field, {
              get: function get() {
                return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].getPath(this, field);
              }
            });
          }
        } // as far as the store is concerned, grouping is just more sorting. so trigger sort


        if (performSort !== false) {
          me.sort(null, null, false, true);
        }

        if (!silent) {
          /**
           * Fired when grouping changes
           * @event group
           * @param {Core.data.Store} source This Store
           * @param {Object[]} groupers Applied groupers
           * @param {Core.data.Model[]} records Grouped records
           */
          me.trigger('group', {
            isGrouped: me.isGrouped,
            groupers: me.groupers,
            records: me.storage.values
          });
          me.trigger('refresh', {
            action: 'group',
            isGrouped: me.isGrouped,
            groupers: me.groupers,
            records: me.storage.values
          });
        }
      } // Internal since UI does not support multi grouping yet

      /**
       * Add a grouping level (a grouper).
       * @param {String} field Field to group by
       * @param {Boolean} ascending Group direction
       * @category Sort, group & filter
       * @internal
       */

    }, {
      key: "addGrouper",
      value: function addGrouper(field) {
        var ascending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        this.group(field, ascending, true);
      } // Internal since UI does not support multi grouping yet

      /**
       * Removes a grouping level (a grouper)
       * @param {String} field Grouper to remove
       * @category Sort, group & filter
       * @internal
       */

    }, {
      key: "removeGrouper",
      value: function removeGrouper(field) {
        var me = this,
            index = me.groupers.findIndex(function (grouper) {
          return grouper.field === field;
        });

        if (index > -1) {
          me.groupers.splice(index, 1);

          if (!me.groupers.length) {
            me.clearGroupers();
          } else {
            me.group();
          }
        }
      }
      /**
       * Removes all groupers, turning store grouping off.
       * @category Sort, group & filter
       */

    }, {
      key: "clearGroupers",
      value: function clearGroupers() {
        this.groupers = null;
      } //endregion
      //region Get and check

      /**
       * Check if a record belongs to a certain group (only for the first grouping level)
       * @param {Core.data.Model} record Record
       * @param groupValue Groups value
       * @returns {Boolean} True if the record belongs to the group, otherwise false
       * @category Sort, group & filter
       */

    }, {
      key: "isRecordInGroup",
      value: function isRecordInGroup(record, groupValue) {
        if (!this.isGrouped) return null;
        var me = this,
            groupField = me.groupers[0] && me.groupers[0].field;
        return record[groupField] === groupValue && !record.isSpecialRow;
      }
    }, {
      key: "isInCollapsedGroup",
      value: function isInCollapsedGroup(record) {
        var parentGroupRec = record.instanceMeta(this).groupParent;
        return parentGroupRec && parentGroupRec.meta.collapsed;
      }
      /**
       * Returns all records in the group with specified groupValue.
       * @param groupValue
       * @returns {Core.data.Model[]} Records in specified group or null if store not grouped
       * @category Sort, group & filter
       */

    }, {
      key: "getGroupRecords",
      value: function getGroupRecords(groupValue) {
        var me = this;
        if (!me.isGrouped) return null;
        return me.storage.values.filter(function (record) {
          return me.isRecordInGroup(record, groupValue);
        });
      }
      /**
       * Get all group titles.
       * @returns {String[]} Group titles
       * @category Sort, group & filter
       */

    }, {
      key: "getGroupTitles",
      value: function getGroupTitles() {
        var me = this;
        if (!me.isGrouped) return null;
        return me.getDistinctValues(me.groupers[0] && me.groupers[0].field);
      } //endregion

    }, {
      key: "onDataChanged",
      value: function onDataChanged(_ref3) {
        var changes = _ref3.changes,
            action = _ref3.action;

        if (this.isGrouped && ( // If an action flagged as requiring resort is performed...
        !changes && resortActions[action] || // ...or if the group field has changes...
        changes && this.groupers.some(function (grouper) {
          return grouper.field in changes;
        }))) {
          // ...then re-sort
          this.sort();
        }
      }
      /**
       * Adds or removes records in a group from storage. Used when expanding/collapsing groups.
       * @private
       * @param {Core.data.Model} groupRecord Group which records should be added or removed
       * @param {Boolean} include Include (true) or exclude (false) records
       * @category Grouping
       */

    }, {
      key: "internalIncludeExcludeGroupRecords",
      value: function internalIncludeExcludeGroupRecords(groupRecord, include) {
        var me = this,
            index = me.indexOf(groupRecord),
            mapId = me.id; // Skip if group record is not found, otherwise it removes records from wrong position

        if (index === -1) {
          return;
        } // Prevent removing from already collapsed and vice versa


        if (groupRecord.meta.collapsed && !include || !groupRecord.meta.collapsed && include) {
          return;
        }

        groupRecord.groupChildren.forEach(function (child) {
          return child.instanceMeta(mapId).hiddenByCollapse = !include;
        });

        if (include) {
          var _me$storage$values;

          // Avoid adding record duplicates which may already have been reinserted by clearing filters
          var groupChildren = groupRecord.groupChildren.filter(function (r) {
            return !me.isAvailable(r);
          });

          (_me$storage$values = me.storage.values).splice.apply(_me$storage$values, [index + 1, 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default()(groupChildren)));
        } else {
          me.storage.values.splice(index + 1, groupRecord.groupChildren.length);
        }

        me.storage._indicesInvalid = true;
        me._idMap = null;
      }
      /**
       * Removes records in a group from storage. Used when collapsing a group.
       * @private
       * @param groupRecord Group which records should be removed
       * @category Grouping
       */

    }, {
      key: "excludeGroupRecords",
      value: function excludeGroupRecords(groupRecord) {
        this.internalIncludeExcludeGroupRecords(groupRecord, false);
      }
      /**
       * Adds records in a group to storage. Used when expanding a group.
       * @private
       * @param groupRecord Group which records should be added
       * @category Grouping
       */

    }, {
      key: "includeGroupRecords",
      value: function includeGroupRecords(groupRecord) {
        this.internalIncludeExcludeGroupRecords(groupRecord, true);
      }
      /**
       * Collects all group headers + children, whether expanded or not
       * @private
       * @param {Boolean} allRecords True to include filtered out records
       * @param {Boolean} includeHeaders True to also include group headers
       * @returns {Core.data.Model[]}
       */

    }, {
      key: "collectGroupRecords",
      value: function collectGroupRecords(allRecords) {
        var includeHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var records = allRecords ? this.storage.allValues : this.storage.values;
        return records.reduce(function (records, record) {
          if (record.isSpecialRow) {
            if (includeHeaders) {
              records.push(record);
            }

            if ('groupRowFor' in record.meta) {
              records.push.apply(records, record.groupChildren);
            }
          }

          return records;
        }, []);
      }
    }, {
      key: "groupers",
      get: function get() {
        return this._groupers;
      },
      set: function set(groupers) {
        var me = this;

        if (groupers && groupers.length) {
          me._groupers = groupers;
        } else if (me.groupers) {
          delete me._groupers;
          me.groupRecords.forEach(function (r) {
            if (r.meta.collapsed) {
              me.includeGroupRecords(r);
            }
          });
          me.storage.replaceValues({
            values: me.removeHeadersAndFooters(me.storage._values),
            filteredValues: me.storage.isFiltered ? me.removeHeadersAndFooters(me.storage._filteredValues) : null,
            silent: true
          });
          me.group(null, null, null, false);

          if ('groupRecords' in me) {
            delete me.groupRecords;
          }
        }
      }
    }, {
      key: "isGrouped",
      get: function get() {
        return Boolean(this.groupers && this.groupers.length);
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreGroup';
      } //region Config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Initial groupers, specify to have store grouped automatically after initially setting data
           * @config {Object[]}
           * @category Common
           */
          groupers: null
        };
      }
    }]);

    return StoreGroup;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_24__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreProxy.js":
/*!*******************************************!*\
  !*** ./lib/Core/data/mixin/StoreProxy.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");





















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/data/mixin/StoreProxy
 */

/**
 * Object-like interaction with a Store by using a Proxy. To enable, configure the store with `objectify : true`.
 *
 * ```javascript
 * const store = new Store({
 *    objectify : true,
 *    data      : [
 *        { id : 'batman', name : 'Bruce' }
 *    ]
 * });
 * ```
 *
 * Access records using their ids as Store properties:
 * ```javascript
 * console.log(store.batman.name); // logs Bruce
 * ```
 *
 * Add records by assigning properties to the Store:
 * ```javascript
 * store.superman = { name : 'Clark' }; // Id will be 'superman'
 * ```
 *
 * Remove records by removing their property:
 * ```javascript
 * delete store.batman;
 * ```
 *
 * Check if a certain id existing in the store by using `in`:
 * ```javascript
 * console.log('superman' in store): // logs true
 * ```
 *
 * Please note that this approach:
 * * Will affect performance slightly, not recommended for larger datasets.
 * * Uses native Proxy, which cannot be polyfilled. Not possible to get it working in IE11.
 * * Preserves predefined Store properties, records cannot use ids that match those.
 * * Might have other limitations preventing the use of it in some scenarios where a normal Store can be used.
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default()(StoreProxy, _ref);

    var _super = _createSuper(StoreProxy);

    function StoreProxy() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default()(this, StoreProxy);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default()(StoreProxy, [{
      key: "initProxy",
      value: function initProxy() {
        if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].global.Proxy) {
          throw new Error('Proxy not supported');
        }

        return new Proxy(this, {
          // Support getting records using `store[id/index]
          get: function get(target, property) {
            // Stores own properties take precedence
            if (property in target) {
              return target[property];
            } // Then ids


            var record = target.getById(property); // And finally index

            if (!record && !isNaN(parseInt(property))) {
              record = target.getAt(parseInt(property));
            }

            return record;
          },
          // Support adding/replacing records using `store.id = { ...data }`
          set: function set(target, property, value) {
            // Pass through when using names of existing properties or when destroyed/ing
            if (property in target || target.isDestroying) {
              target[property] = value;
            } // Otherwise add/replace a record
            else {
                target.add(_objectSpread(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()({}, target.modelClass.idField, property), value));
              }

            return true;
          },
          // Support deleting records using `delete store.id`
          deleteProperty: function deleteProperty(target, property) {
            // Properties are deleted on destroy
            if (target.isDestroying) {
              delete target[property];
              return true;
            }

            return Boolean(target.remove(property).length);
          },
          // Support `id in store`
          has: function has(target, property) {
            // Actual property
            if (property in target) {
              return true;
            } // Threat { ... } as JSON representation of a record (likely from toString())


            if (property.startsWith('{') && property.endsWith('}')) {
              var data = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].safeJsonParse(property);
              property = data === null || data === void 0 ? void 0 : data.id;
            }

            return target.includes(property);
          }
        });
      }
    }], [{
      key: "configurable",
      get: function get() {
        return {
          /**
           * Allow object like interaction with the Store. For example:
           *
           * ```javascript
           * const store = new Store({
           *    objectify : true,
           *    data      : [
           *        { id : 'batman', name : 'Bruce' }
           *    ]
           * });
           *
           * // retreive using id as property
           * const record = store.batman;
           *
           * // add as property
           * store.superman = { name : 'Clark' };
           *
           * // delete to remove
           * delete store.batman;
           * ``
           *
           * @config {Boolean}
           * @default false
           * @private
           */
          objectify: null
        };
      }
    }]);

    return StoreProxy;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_20__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreRelation.js":
/*!**********************************************!*\
  !*** ./lib/Core/data/mixin/StoreRelation.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Model_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../Model.js */ "./lib/Core/data/Model.js");




















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/data/mixin/StoreRelation
 */

/**
 * Mixin for Store that handles relations with other stores (actually defined on model).
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(StoreRelation, _ref);

    var _super = _createSuper(StoreRelation);

    function StoreRelation() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, StoreRelation);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(StoreRelation, [{
      key: "initRelations",
      //region Init

      /**
       * Initialized relations, called from constructor
       * @private
       */
      value: function initRelations(reset) {
        var me = this,
            relations = me.modelClass.relations;

        if (reset && me.modelRelations) {
          // reset will reinit all relations, stop listening for store events on existing ones
          me.modelRelations.forEach(function (relation) {
            relation.storeDetacher && relation.storeDetacher();
          });
        }

        if ((!me.modelRelations || me.modelRelations.length === 0 || reset) && relations) {
          me.modelRelations = []; // foreignKeys is filled when model exposes its properties

          relations && relations.forEach(function (modelRelationConfig) {
            var config = Object.assign({}, modelRelationConfig),
                relatedStore = typeof config.store === 'string' ? me[config.store] : config.store;
            config.dependentStore = me;
            me.modelRelations.push(config);

            if (relatedStore) {
              config.storeProperty = config.store;
              config.store = relatedStore; // repeated from initRelationStores, needed if stored is assigned late

              var dependentStoreConfigs = relatedStore.dependentStoreConfigs; // Add link to dependent store

              if (dependentStoreConfigs.has(me)) {
                var dependentConfigs = dependentStoreConfigs.get(me); // Remove existing config on reset

                if (reset) {
                  var existingConfig = dependentConfigs.find(function (c) {
                    return c.relationName === config.relationName;
                  });

                  if (existingConfig) {
                    _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].remove(dependentConfigs, existingConfig);
                  }
                }

                dependentConfigs.push(config);
              } else {
                dependentStoreConfigs.set(me, [config]);
              } // if foreign key specifies collectionName the related store should also be configured


              if (config.collectionName) {
                relatedStore.initRelationCollection(config, me);
              }

              if (relatedStore.count > 0) {
                relatedStore.updateDependentStores('dataset', relatedStore.records);
              }
            }
          });
        }
      }
      /**
       * Called from other end of an relation when this store should hold a collection of related records.
       * @private
       * @param config
       * @param collectionStore
       */

    }, {
      key: "initRelationCollection",
      value: function initRelationCollection(config, collectionStore) {
        // TODO: parts of this should move to model?
        var me = this,
            name = config.collectionName;

        if (!me.collectionStores) {
          me.collectionStores = {};
        }

        me.collectionStores[name] = {
          store: collectionStore,
          config: config
        };

        if (!me[name + 'Store']) {
          me[name + 'Store'] = collectionStore;
        }

        if (me.count > 0) {
          me.initModelRelationCollection(name, me.records);
        }
      }
    }, {
      key: "initModelRelationCollection",
      value: function initModelRelationCollection(name, records) {
        var me = this; // add collection getter to each model

        records.forEach(function (record) {
          // Needs to work in trees also, if not a tree traverse just calls fn on self
          record.traverse(function (node) {
            // Add/replace $relatedAssignments (or similar) if assignments already exists on target
            var useName = name in node ? "$related".concat(_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].capitalize(name)) : name;
            Object.defineProperty(node, useName, {
              enumerable: true,
              configurable: true,
              get: function get() {
                return me.getCollection(this, name);
              },
              set: function set(value) {
                return me.setCollection(this, name, value);
              }
            });
          });
        });
      } //TODO: Do diff update, this is called on filtering and will be heavy with lots of records

      /**
       * Updates relationCache for all records.
       * @private
       */

    }, {
      key: "resetRelationCache",
      value: function resetRelationCache() {
        this.relationCache = {};
        this.forEach(function (record) {
          return record.initRelations();
        });
      }
      /**
       * Caches related records from related store on the local store.
       * @private
       * @param record Local record
       * @param relations Relations to related store
       */

    }, {
      key: "updateRecordRelationCache",
      value: function updateRecordRelationCache(record, relations) {
        var me = this;
        relations && relations.forEach(function (relation) {
          // use related records id, or if called before "binding" is complete use foreign key
          var foreignId = relation.related ? relation.related.id : record.get(relation.config.fieldName); // cache on that id, removing previously cached value if any

          foreignId !== undefined && me.cacheRelatedRecord(record, foreignId, relation.config.relationName, foreignId);
        });
      } //endregion
      //region Getters

      /**
       * Returns records the relation cache. Same result as if retrieving the collection on the dependent store, but
       * without the need of accessing that store.
       * @internal
       * @param {String} name
       * @param {Core.data.Model|String|Number} recordOrId
       * @returns {Array}
       */

    }, {
      key: "getRelationCollection",
      value: function getRelationCollection(name, recordOrId) {
        var id = _Model_js__WEBPACK_IMPORTED_MODULE_22__["default"].asId(recordOrId);
        return this.relationCache[name] && this.relationCache[name][id] || [];
      }
      /**
       * Returns records from a collection of related records. Not to be called directly, called from Model getter.
       * TODO: Move to Model?
       * @private
       * @param {Core.data.Model} record
       * @param {String} name
       * @returns {Array}
       */

    }, {
      key: "getCollection",
      value: function getCollection(record, name) {
        var _this$collectionStore = this.collectionStores[name],
            config = _this$collectionStore.config,
            store = _this$collectionStore.store;
        return store.relationCache[config.relationName] && store.relationCache[config.relationName][record.id] || [];
      }
      /**
       * Sets a collection of related records. Will updated the related store and trigger events from it. Not to be called
       * directly, called from Model setter.
       * @private
       */

    }, {
      key: "setCollection",
      value: function setCollection(model, name, records) {
        var _this$collectionStore2 = this.collectionStores[name],
            config = _this$collectionStore2.config,
            store = _this$collectionStore2.store;
        if (!store.relationCache[config.relationName]) store.relationCache[config.relationName] = {};
        var old = (store.relationCache[config.relationName][model.id] || []).slice(),
            added = [],
            removed = [];
        store.suspendEvents(); // Remove any related records not in the new collection

        old.forEach(function (record) {
          if (!records.includes(record)) {
            record[config.fieldName] = null;
            store.remove(record);
            removed.push(record);
          }
        }); // Add records from the new collection not already in store

        records.forEach(function (record) {
          if (record instanceof _Model_js__WEBPACK_IMPORTED_MODULE_22__["default"]) {
            if (!record.stores.includes(store)) {
              store.add(record);
              added.push(record);
            }
          } else {
            var _store$add = store.add(record);

            var _store$add2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_13___default()(_store$add, 1);

            record = _store$add2[0];
            added.push(record);
          } // Init relation


          record[config.fieldName] = model.id;
        });
        store.resumeEvents();

        if (removed.length) {
          store.trigger('remove', {
            records: removed
          });
          store.trigger('change', {
            action: 'remove',
            records: removed
          });
        }

        if (added.length) {
          store.trigger('add', {
            records: added
          });
          store.trigger('change', {
            action: 'add',
            records: added
          });
        }
      } //endregion
      //region Caching

      /**
       * Adds a record to relation cache, optionally removing it if already there.
       * @private
       * @param record
       * @param id
       * @param name
       * @param uncacheId
       */

    }, {
      key: "cacheRelatedRecord",
      value: function cacheRelatedRecord(record, id, name) {
        var uncacheId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var me = this,
            cache = me.relationCache[name] || (me.relationCache[name] = {});

        if (uncacheId !== null) {
          me.uncacheRelatedRecord(record, name, uncacheId);
        }

        if (id != null) {
          // Only include of not already in relation cache, which might happen when removing and re-adding the same instance
          _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].include(cache[id] || (cache[id] = []), record);
        }
      }
      /**
       * Removes a record from relation cache, for a specific relation (specifiy relation name and id) or for all relations
       * @private
       * @param record Record to remove from cache
       * @param name Optional, relation name
       * @param id Optional, id
       */

    }, {
      key: "uncacheRelatedRecord",
      value: function uncacheRelatedRecord(record) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var me = this;

        function remove(relationName, relatedId) {
          var cache = me.relationCache[relationName],
              oldCache = cache && cache[relatedId]; // When unjoining a record from a filtered store the relationCache will also be filtered
          // and might give us nothing, in which case we have nothing to clean up and bail out

          if (oldCache) {
            var uncacheIndex = oldCache.indexOf(record);
            uncacheIndex >= 0 && oldCache.splice(uncacheIndex, 1);

            if (oldCache.length === 0) {
              delete cache[relatedId];
            }
          }
        }

        if (id != null) {
          remove(name, id);
        } else {
          if (record.meta.relationCache) {
            Object.entries(record.meta.relationCache).forEach(function (_ref2) {
              var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_13___default()(_ref2, 2),
                  relationName = _ref3[0],
                  relatedRecord = _ref3[1];

              var relatedId = relatedRecord && relatedRecord.id;
              remove(relationName, relatedId);
            });
          }
        }
      }
      /**
       * Updates related stores when store is cleared, a record is removed or added.
       * @private
       * @param {String} action
       * @param {Core.data.Model[]} records
       */

    }, {
      key: "updateDependentStores",
      value: function updateDependentStores(action, records) {
        var _this = this;

        this.dependentStoreConfigs.forEach(function (configs) {
          configs.forEach(function (config) {
            var dependentStore = config.dependentStore,
                cache = dependentStore.relationCache[config.relationName];

            if (action === 'dataset') {
              config.collectionName && _this.initModelRelationCollection(config.collectionName, records);
              dependentStore.forEach(function (record) {
                var foreign = record.initRelation(config);
                foreign && dependentStore.cacheRelatedRecord(record, foreign.id, config.relationName, foreign.id);
              });
              return;
            }

            if (action === 'removeall') {
              dependentStore.forEach(function (record) {
                record.removeRelation(config);
              });
              delete dependentStore.relationCache[config.relationName];
              return;
            }

            if (action === 'add') {
              config.collectionName && _this.initModelRelationCollection(config.collectionName, records);
            }

            if (action === 'add' || action === 'remove') {
              records.forEach(function (record) {
                var dependentRecords = cache && cache[record.id];

                switch (action) {
                  case 'remove':
                    // removing related record removes from cache on model and store
                    if (dependentRecords) {
                      dependentRecords.forEach(function (dependentRecord) {
                        return dependentRecord.removeRelation(config);
                      }); // Altered to not delete on self, simplifies taking actions on related records after remove if relation still lives
                      //delete cache[relatedRecord.id];
                    } // TODO: Should removing related set foreign key to null? (removing Team sets Player.teamId to null)


                    break;

                  case 'add':
                    // adding a new record in related store checks if any foreign keys match the new id,
                    // and if so it sets up the relation
                    dependentStore.forEach(function (dependentRecord) {
                      if (dependentRecord.get(config.fieldName) == record.id) {
                        dependentRecord.initRelation(config);
                        dependentStore.cacheRelatedRecord(dependentRecord, record.id, config.relationName);
                      }
                    });
                    break;
                }
              });
            }
          });
        });
      }
      /**
       * Updates relation cache and foreign key value when a related objects id is changed.
       * @private
       */

    }, {
      key: "updateDependentRecordIds",
      value: function updateDependentRecordIds(oldValue, value) {
        this.dependentStoreConfigs && this.dependentStoreConfigs.forEach(function (configs) {
          configs.forEach(function (config) {
            var dependentStore = config.dependentStore,
                cache = dependentStore.relationCache[config.relationName],
                localRecords = cache && cache[oldValue] && cache[oldValue].slice();
            localRecords && localRecords.forEach(function (localRecord) {
              // First update cache
              dependentStore.cacheRelatedRecord(localRecord, value, config.relationName, oldValue); // Then update & announce, otherwise relations wont be up to date in listeners

              localRecord.set(config.fieldName, value, false, true);
            });
          });
        });
      } //endregion

    }], [{
      key: "$name",
      get: function get() {
        return 'StoreRelation';
      }
    }]);

    return StoreRelation;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_19__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSearch.js":
/*!********************************************!*\
  !*** ./lib/Core/data/mixin/StoreSearch.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");

























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/data/mixin/StoreSearch
 */

var stringFound = function stringFound(value, find) {
  return String(value).toLowerCase().indexOf(find) !== -1;
},
    comparisons = {
  string: stringFound,
  number: stringFound,
  boolean: stringFound,
  date: function date(value, find) {
    if (value instanceof Date && find instanceof Date) {
      return String(value) === String(find);
    }

    return String(value.getMonth() + 1).indexOf(find) !== -1 || String(value.getDate()).indexOf(find) !== -1 || String(value.getFullYear()).indexOf(find) !== -1;
  }
};
/**
 * Mixin for Store that handles searching (multiple records) and finding (single record).
 *
 * @example
 * // find all records that has a field containing the string john
 * let hits = store.search('john');
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default()(StoreSearch, _ref);

    var _super = _createSuper(StoreSearch);

    function StoreSearch() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default()(this, StoreSearch);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20___default()(StoreSearch, [{
      key: "search",
      //region Search (multiple hits)

      /**
       * Find all hits.
       * @param find Value to search for
       * @param {Object[]} fields Fields to search value in
       * @returns {*} Array of hits, in the format { index: x, data: record }
       * @category Search
       */
      value: function search(find) {
        var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var records = this.storage.values,
            len = records.length,
            found = [];

        if (find == null) {
          return null;
        }

        if (typeof find === 'string') {
          find = String(find).toLowerCase();
        }

        var i, record, value, valueType, comparison;

        for (i = 0; i < len; i++) {
          record = records[i];

          var _iterator = _createForOfIteratorHelper(fields || record.fieldNames),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var key = _step.value;
              value = record[key];
              valueType = value instanceof Date ? 'date' : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18___default()(value);
              comparison = comparisons[valueType];

              if (value && comparison && comparison(value, find)) {
                found.push({
                  index: i,
                  data: record,
                  field: key,
                  id: record.id
                });
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        return found;
      }
      /**
       * Find all hits in a column
       * @param field The store field to search in
       * @param value Value to search for
       * @returns {*} Array of hits, in the format { index: x, data: record }
       * @category Search
       */

    }, {
      key: "findByField",
      value: function findByField(field, value) {
        var records = this.storage.values,
            i,
            len = records.length,
            record,
            found = [],
            fieldValue;

        if (value !== null && value !== undefined) {
          value = String(value).toLowerCase();
        }

        for (i = 0; i < len; i++) {
          record = records[i];
          fieldValue = record[field];
          var type = fieldValue instanceof Date ? 'date' : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18___default()(fieldValue),
              comparison = {
            date: function date() {
              return Boolean(fieldValue) && fieldValue.toLocaleString().includes(value);
            },
            string: function string() {
              return Boolean(fieldValue) && fieldValue.toLowerCase().includes(value);
            },
            number: function number() {
              return typeof fieldValue === 'number' && fieldValue.toString().includes(value);
            },
            object: function object() {
              return fieldValue === value;
            },
            // typeof null === object
            undefined: function undefined() {
              return fieldValue === value;
            }
          };

          if ((value === null || value === undefined) && fieldValue === value || value && comparison[type]()) {
            found.push({
              id: record.id,
              index: i,
              data: record
            });
          }
        }

        return found;
      } //endregion
      //region Find (single hit)

      /**
       * Finds the first record for which the specified function returns true
       * @param {Function} fn Comparison function, called with record as parameter
       * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
       * @returns {Core.data.Model} Record or undefined if none found
       *
       * @example
       * store.find(record => record.color === 'blue');
       * @category Search
       */

    }, {
      key: "find",
      value: function find(fn) {
        var searchAllRecords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var records = searchAllRecords ? this.storage.allValues : this.storage.values;

        if (this.isGrouped) {
          records = this.collectGroupRecords(searchAllRecords, false);
        }

        return records.find(fn);
      }
      /**
       * Finds the first record for which the specified field has the specified value
       * @param {String} fieldName Field name
       * @param {*} value Value to find
       * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
       * @returns {Core.data.Model} Record or undefined if none found
       * @category Search
       */

    }, {
      key: "findRecord",
      value: function findRecord(fieldName, value) {
        var searchAllRecords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var matchFn = function matchFn(r) {
          return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isEqual(r[fieldName], value);
        };

        if (this.tree) {
          return this.query(matchFn)[0];
        }

        return (searchAllRecords ? this.storage.allValues : this.storage.values).find(matchFn);
      }
      /**
       * Searches the Store records using the passed function.
       * @param {Function} fn A function that is called for each record. Return true to indicate a match
       * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
       * @returns {Core.data.Model[]} An array of the matching Records
       * @category Search
       */

    }, {
      key: "query",
      value: function query(fn) {
        var searchAllRecords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var records = searchAllRecords ? this.storage.allValues : this.storage.values;

        if (this.isTree) {
          var matches = [];
          this.traverse(function (node) {
            if (fn(node)) {
              matches.push(node);
            }
          });
          return matches;
        } else if (this.isGrouped) {
          records = this.collectGroupRecords(searchAllRecords, false);
        }

        return records.filter(fn);
      } //endregion
      //region Others

      /**
       * Returns true if the supplied function returns true for any record in the store
       * @param {Function} fn A function that should return true to indicate a match
       * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
       * @returns {Boolean}
       *
       * @example
       * store.some(record => record.age > 95); // true if any record has age > 95
       * @category Search
       */

    }, {
      key: "some",
      value: function some(fn) {
        var searchAllRecords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var records = searchAllRecords ? this.storage.allValues : this.storage.values;

        if (this.isGrouped) {
          records = this.collectGroupRecords(searchAllRecords, false);
        }

        return records.some(fn);
      } //endregion

    }], [{
      key: "$name",
      get: function get() {
        return 'StoreSearch';
      }
    }]);

    return StoreSearch;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_24__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSort.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreSort.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/mixin/StoreSort
 */

/**
 * Mixin for Store that handles simple sorting as well as multi-level sorting.
 *
 * ```javascript
 * // single sorter
 * store.sort('age');
 *
 * // single sorter as object, descending order
 * store.sort({ field : 'age', ascending : false });
 *
 * // multiple sorters
 * store.sort(['age', 'name']);
 *
 * // using custom sorting function
 * store.sort({
 *     fn : (recordA, recordB) => {
 *         // apply custom logic, for example:
 *         return recordA.name.length < recordB.name.length ? -1 : 1;
 *     }
 * });
 *
 * // using locale specific sort (slow)
 * store.sort({ field : 'name', useLocaleSort : 'sv-SE' });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(StoreSort, _ref);

    var _super = _createSuper(StoreSort);

    function StoreSort() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default()(this, StoreSort);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default()(StoreSort, [{
      key: "sort",
      //endregion
      //region Add & remove sorters

      /**
       * Sort records, either by replacing current sorters or by adding to them.
       * A sorter can specify a **_custom sorting function_** which will be called with arguments (recordA, recordB).
       * Works in the same way as a standard array sorter, except that returning `null` triggers the stores
       * normal sorting routine.
       *
       * ```javascript
       * // single sorter
       * store.sort('age');
       *
       * // single sorter as object, descending order
       * store.sort({ field : 'age', ascending : false });
       *
       * // multiple sorters
       * store.sort(['age', 'name']);
       *
       * // using custom sorting function
       * store.sort((recordA, recordB) => {
       *     // apply custom logic, for example:
       *     return recordA.name.length < recordB.name.length ? -1 : 1;
       * });
       *
       * // using locale specific sort (slow)
       * store.sort({ field : 'name', useLocaleSort : 'sv-SE' });
       * ```
       *
       * @param {String|Array|Object|Function} field Field to sort by.
       * Can also be an array of sorters, or a sorting function, or a {@link Core.util.CollectionSorter sorter} config.
       * @param {Boolean} [ascending] Sort order.
       * Applicable when the `field` is a string (if not specified and already sorted by the field, reverts direction),
       * or an object and `ascending` property is not specified for the object. `true` by default.
       * Not applicable when `field` is a function. `ascending` is always `true` in this case.
       * @param {Boolean} [add] If `true`, adds a sorter to the sorters collection.
       * Not applicable when `field` is an array. In this case always replaces active sorters.
       * @param {Boolean} [silent] Set as true to not fire events
       * @category Sort, group & filter
       * @fires beforeSort
       * @fires sort
       * @fires refresh
       */
      value: function sort(field, ascending) {
        var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var silent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var me = this,
            records = me.allRecords,
            currentSorters = me.sorters ? me.sorters.slice() : [];
        var currentDir = null,
            curSort;

        if (field) {
          if (Array.isArray(field)) {
            // array of strings make fields always be sorted ascending
            me.sorters = field.map(function (sorter) {
              return me.normalizeSorterConfig(sorter, typeof sorter === 'string' ? true : ascending);
            });
          } else {
            var sorter = me.normalizeSorterConfig(field, ascending);

            if (add) {
              curSort = me.getCurrentSorterByField(sorter.field); // Field already among sorters? change sort direction instead of adding new sorter

              if (curSort) {
                currentDir = curSort.ascending;
                curSort.ascending = sorter.ascending;
              } else {
                me.sorters.push(sorter);
              }
            } else {
              me.sorters = [sorter];
            }
          }
        }

        if (!silent && me.trigger('beforeSort', {
          sorters: me.sorters,
          records: records,
          currentSorters: currentSorters
        }) === false) {
          // Restore sorters
          me.sorters = currentSorters; // Restore sorting direction if toggled

          if (currentDir !== null) {
            curSort.ascending = currentDir;
          }

          return;
        }

        return me.performSort(silent);
      }
    }, {
      key: "normalizeSorterConfig",
      value: function normalizeSorterConfig(field, ascending) {
        var me = this,
            sorter = {
          ascending: ascending
        };

        if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(field) === 'object') {
          sorter.field = field.field;
          sorter.sortFn = field.fn || field.sortFn;
          sorter.useLocaleSort = field.useLocaleSort;
          sorter.ascending = field.ascending != null ? field.ascending : ascending;
        } else if (typeof field === 'function') {
          sorter.sortFn = field;
        } else {
          sorter.field = field;
        } // sort in opposite direction if not specified and already sorted, default to sorting ascending


        if (sorter.ascending == null) {
          var curSort = me.getCurrentSorterByField(sorter.field);
          sorter.ascending = curSort ? !curSort.ascending : true;
        }

        if (sorter.sortFn == null) {
          var _me$modelClass, _me$modelClass$$meta$;

          var compareItems = (_me$modelClass = me.modelClass) === null || _me$modelClass === void 0 ? void 0 : (_me$modelClass$$meta$ = _me$modelClass.$meta.fields.map[sorter.field]) === null || _me$modelClass$$meta$ === void 0 ? void 0 : _me$modelClass$$meta$.compareItems;

          if (compareItems) {
            // These sorters will be ignored by AjaxStore when remoting...
            sorter.sortFn = compareItems;
          }
        }

        return sorter;
      }
    }, {
      key: "getCurrentSorterByField",
      value: function getCurrentSorterByField(field) {
        return typeof field === 'string' && this.sorters.find(function (s) {
          return s.field === field;
        }) || null;
      }
      /**
       * Add a sorting level (a sorter).
       * @param {String|Object} field Field to sort by (can also be an array of sorters or a config containing a custom sort fn)
       * @param {Boolean} ascending Sort order (used only if field specified as string)
       * @category Sort, group & filter
       */

    }, {
      key: "addSorter",
      value: function addSorter(field) {
        var ascending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        this.sort(field, ascending, true);
      }
      /**
       * Remove a sorting level (a sorter)
       * @param field Stop sorting by this field
       * @category Sort, group & filter
       */

    }, {
      key: "removeSorter",
      value: function removeSorter(field) {
        var me = this,
            sorterIndex = me.sorters.findIndex(function (sorter) {
          return sorter.field === field;
        });

        if (sorterIndex > -1) {
          me.sorters.splice(sorterIndex, 1);
          me.sort();
        }
      }
      /**
       * Removes all sorters, turning store sorting off.
       * @category Sort, group & filter
       */

    }, {
      key: "clearSorters",
      value: function clearSorters() {
        var me = this;
        me.sorters.length = 0;
        me.sort();
      } //region
      //region Sorting logic

      /**
       * Creates a function used with Array#sort when sorting the store. Override to use your own custom sorting logic.
       * @param sorters
       * @returns {Function}
       * @category Sort, group & filter
       */

    }, {
      key: "createSorterFn",
      value: function createSorterFn(sorters) {
        var storeLocaleSort = this.useLocaleSort;
        return function (lhs, rhs) {
          // Cannot use `for ... of` here, breaks a test in IE11 were this fn is called from transpiled test code
          // which leads to iterator symbol mismatch
          for (var i = 0; i < sorters.length; i++) {
            var sorter = sorters[i],
                field = sorter.field,
                _sorter$ascending = sorter.ascending,
                ascending = _sorter$ascending === void 0 ? true : _sorter$ascending,
                _sorter$useLocaleSort = sorter.useLocaleSort,
                useLocaleSort = _sorter$useLocaleSort === void 0 ? storeLocaleSort : _sorter$useLocaleSort,
                fn = sorter.fn || sorter.sortFn,
                direction = ascending ? 1 : -1;

            if (fn) {
              var val = fn(lhs, rhs);

              if (val !== null) {
                return val * direction;
              }
            }

            var lhsValue = lhs[field],
                rhsValue = rhs[field];

            if (lhsValue === rhsValue) {
              continue;
            }

            if (lhsValue == null) {
              return -direction;
            }

            if (rhsValue == null) {
              return direction;
            }

            if (useLocaleSort) {
              // Use systems locale
              if (useLocaleSort === true) {
                return String(lhsValue).localeCompare(rhsValue) * direction;
              } // Use specified locale


              if (typeof useLocaleSort === 'string') {
                return String(lhsValue).localeCompare(rhsValue, useLocaleSort) * direction;
              } // Use locale config


              if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(useLocaleSort) === 'object') {
                return String(lhsValue).localeCompare(rhsValue, useLocaleSort.locale, useLocaleSort) * direction;
              }
            }

            if (lhsValue > rhsValue) {
              return direction;
            }

            if (lhsValue < rhsValue) {
              return -direction;
            }
          }

          return 0;
        };
      }
      /**
       * Perform sorting according to the {@link #config-sorters} configured.
       * This is the internal implementation which is overridden in {@link Core.data.AjaxStore} and
       * must not be overridden.
       * @private
       * @category Sort, group & filter
       */

    }, {
      key: "performSort",
      value: function performSort(silent) {
        var me = this,
            rootNode = me.rootNode,
            storage = me.storage,
            sorters = me.sorters,
            sorter = me.createSorterFn(me.isGrouped ? me.groupers.concat(sorters) : sorters); // Temporarily remove group headers, will be re-added after sort

        if (me.isGrouped) {
          // Remember which groups are collapsed
          if (me.storeCollapsedGroups()) {
            storage.replaceValues({
              values: me.removeHeadersAndFooters(storage.values),
              silent: true
            });
          }
        }

        if (me.tree) {
          rootNode.traverse(function (node) {
            if (node.isLoaded && node.isParent) {
              node.children.sort(sorter); // Since child nodes change order their parentIndex needs to be updated.
              // Update is silent, records wont be considered modified because of the sort

              node.updateChildrenIndices(node.children, false, true);
            }
          });
          storage.replaceValues({
            values: me.collectDescendants(rootNode).visible,
            silent: true
          });
        } else {
          storage.replaceValues({
            values: storage.values.sort(sorter),
            silent: true
          });
        }

        me.afterPerformSort(silent);
      }
    }, {
      key: "afterPerformSort",
      value: function afterPerformSort(silent) {
        var me = this,
            storage = me.storage;
        me._idMap = null; // Apply grouping

        if (me.isGrouped) {
          storage.replaceValues({
            values: me.prepareGroupRecords(storage.values),
            silent: true
          }); // Re-collapse the groups

          me.restoreCollapsedGroups();
        }

        if (!silent) {
          var event = {
            action: 'sort',
            sorters: me.sorters,
            records: me.allRecords
          };
          me.trigger('sort', event); // Only fire this event if it's a local sort.
          // If we are configured with sortParamName, the loadData will fire it.

          if (!me.sortParamName) {
            me.trigger('refresh', event);
          }
        }
      } //endregion

    }, {
      key: "isSorted",
      //endregion
      //region Events

      /**
       * Fired before sorting
       * @event beforeSort
       * @param {Core.data.Store} source This Store
       * @param {Object[]} sorters Sorter configs
       * @param {Core.data.Model[]} records Records to sort
       */

      /**
       * Fired after sorting
       * @event sort
       * @param {Core.data.Store} source This Store
       * @param {Object[]} sorters Sorter configs
       * @param {Core.data.Model[]} records Sorted records
       */
      //endregion
      //region Properties

      /**
       * Currently applied sorters
       * @member {Object[]} sorters
       * @readonly
       * @category Sort, group & filter
       */

      /**
       * Is store sorted?
       * true
       * @property {Boolean}
       * @readonly
       * @category Sort, group & filter
       */
      get: function get() {
        return Boolean(this.sorters.length) || this.isGrouped;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreSort';
      } //region Config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Default sorters, format is [{ field: '', ascending: false }, ...]
           * @config {Object[]|string[]}
           * @category Common
           */
          sorters: [],

          /**
           * Use `localeCompare()` when sorting, which lets the browser sort in a locale specific order. Set to `true`,
           * a locale string or a locale config to enable.
           *
           * Enabling this has big negative impact on sorting
           * performance. For more info on `localeCompare()`, see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare).
           *
           * Examples:
           *
           * ```javascript
           * const store = new Store({
           *     // Swedish sorting
           *     useLocaleSort : 'sv-SE'
           * });
           *
           * const store = new Store({
           *     // Swedish sorting with custom casing order
           *     useLocaleSort : {
           *         locale    : 'sv-SE',
           *         caseFirst : 'upper'
           *     }
           * });
           * ```
           *
           * Can also be configured on a per sorter basis:
           *
           * ```javascript
           * store.sort({ field: 'name', useLocaleSort : 'sv-SE' });
           * ```
           *
           * @config {Boolean|String|Object}
           * @default false
           * @category Advanced
           */
          useLocaleSort: null
        };
      }
    }]);

    return StoreSort;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_17__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreState.js":
/*!*******************************************!*\
  !*** ./lib/Core/data/mixin/StoreState.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/mixin/StoreState
 */

/**
 * Mixin for Store that handles store state.
 *  * sorters
 *  * groupers
 *  * filters
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(StoreState, _ref);

    var _super = _createSuper(StoreState);

    function StoreState() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, StoreState);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(StoreState, [{
      key: "getState",

      /**
       * Get store state. Used by State-plugin to serialize state
       * @private
       * @returns {{ sorters, groupers }}
       */
      value: function getState() {
        var me = this,
            state = {};
        if (me.sorters && me.sorters.length) state.sorters = me.sorters.slice();
        if (me.groupers && me.groupers.length) state.groupers = me.groupers.slice();
        if (me.filters && me.filters.values.length) state.filters = me.filterState;
        return state;
      }
      /**
       * Apply store state. Used by State-plugin to restore a previously serialized state
       * @private
       * @param {{ sorters, groupers }} state
       */

    }, {
      key: "applyState",
      value: function applyState(state) {
        var me = this;
        if ('sorters' in state) me.sorters = state.sorters.slice();
        if ('groupers' in state) me.groupers = state.groupers.slice();
        if ('sorters' in state || 'groupers' in state) me.sort();

        if ('filters' in state) {
          me.filters = state.filters.slice();
          me.filter();
        }
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreState';
      }
    }]);

    return StoreState;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSum.js":
/*!*****************************************!*\
  !*** ./lib/Core/data/mixin/StoreSum.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/mixin/StoreSum
 */

/**
 * Mixin for Store that handles summaries.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(StoreSum, _ref);

    var _super = _createSuper(StoreSum);

    function StoreSum() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, StoreSum);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(StoreSum, [{
      key: "sum",

      /**
       * Returns sum calculated by adding value of specified field for specified records. Defaults to using all records
       * in store
       * @param {String} field Field to summarize by
       * @param {Core.data.Model[]} records Records to summarize, uses all records if unspecified.
       * @returns {Number}
       * @category Sum
       */
      value: function sum(field) {
        var records = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.storage.values;
        if (!records) return 0;
        return records.reduce(function (sum, record) {
          if (record.isSpecialRow) return sum;
          var v = Number(record[field]);
          return isNaN(v) ? sum : sum + v;
        }, 0);
      }
      /**
       * Returns min value for the specified field. Defaults to look through all records in store
       * @param {String} field Field to find min value for
       * @param {Core.data.Model[]} records Records to process, uses all records if unspecified
       * @returns {Number}
       * @category Sum
       */

    }, {
      key: "min",
      value: function min(field) {
        var records = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.storage.values;
        if (!records || !records.length) return 0;
        return records.reduce(function (min, record) {
          if (typeof record[field] === 'number' && record[field] < min) min = record[field];
          return min;
        }, records[0][field]);
      }
      /**
       * Returns max value for the specified field. Defaults to look through all records in store
       * @param {String} field Field to find max value for
       * @param {Core.data.Model[]} records Records to process, uses all records if unspecified
       * @returns {Number}
       * @category Sum
       */

    }, {
      key: "max",
      value: function max(field) {
        var records = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.storage.values;
        if (!records || !records.length) return 0;
        return records.reduce(function (max, record) {
          if (typeof record[field] === 'number' && record[field] > max) max = record[field];
          return max;
        }, records[0][field]);
      }
      /**
       * Returns the average value for the specified field. Defaults to look through all records in store
       * @param {String} field Field to calculate average value for
       * @param {Core.data.Model[]} records Records to process, uses all records if unspecified
       * @returns {Number}
       * @category Sum
       */

    }, {
      key: "average",
      value: function average(field) {
        var records = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.storage.values;
        if (!records || !records.length) return 0;
        var count = 0;
        var sum = records.reduce(function (sum, record) {
          if (record.isSpecialRow) return sum;
          var v = parseFloat(record[field]);

          if (!isNaN(v)) {
            count++;
            return sum + v;
          } else {
            return sum;
          }
        }, 0);
        return count > 0 ? sum / count : 0;
      }
      /**
       * Returns sum by adding value of specified field for records in the group with the specified groupValue.
       * @param groupValue Group to summarize
       * @param {String} field Field to summarize by
       * @returns {Number} Sum or null if store not grouped
       * @category Sum
       */

    }, {
      key: "groupSum",
      value: function groupSum(groupValue, field) {
        return this.sum(field, this.getGroupRecords(groupValue));
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreSum';
      }
    }]);

    return StoreSum;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSync.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreSync.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../helper/WalkHelper.js */ "./lib/Core/helper/WalkHelper.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/data/mixin/StoreSync
 */

/**
 * Mixin that allows Store to sync a new dataset with its existing records, instead of fully replacing everything.
 * Configure Store with `syncDataOnLoad: true` to activate the functionality. Sync is performed when a new dataset
 * is loaded, either by directly assigning it to `store.data` or by loading it using Ajax (if using an AjaxStore).
 *
 * ```javascript
 * const store = new Store({
 *   syncDataOnLoad : true,
 *   data           : [
 *     { id : 1, name : 'Saitama' },
 *     { id : 2, name : 'Genos' },
 *     { id : 3, name : 'Mumen Rider' }
 *   ]
 * });
 *
 * // Sync a new dataset by assigning to data:
 * store.data = [
 *   { id : 1, name : 'Caped Baldy' },
 *   { id : 4, name : 'Horse-Bone' }
 * ];
 *
 *  // Result : Record 1 updated, record 2 & 3 removed, record 4 added
 * ```
 *
 * For more details, please see {@link #config-syncDataOnLoad}.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(StoreSync, _ref);

    var _super = _createSuper(StoreSync);

    function StoreSync() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, StoreSync);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(StoreSync, [{
      key: "syncDataset",

      /**
       * Syncs a new dataset against the already loaded one, only applying changes.
       * Not intended to be called directly, please configure store with `syncDataOnLoad: true` and assign to
       * `store.data` as usual instead.
       *
       * ```
       * const store = new Store({
       *    syncDataOnLoad : true,
       *    data : [
       *        // initial data
       *    ]
       * });
       *
       * store.data = [ // new data ]; //  Difference between initial data and new data will be applied
       * ```
       *
       * @param {Object[]} data New dataset
       * @private
       */
      value: function syncDataset(data) {
        var me = this,
            storage = me.storage,
            _ref2 = me.tree ? me.syncTreeDataset(data) : me.syncFlatDataset(data),
            toAdd = _ref2.toAdd,
            toRemove = _ref2.toRemove,
            updated = _ref2.updated;

        var threshold = me.syncDataOnLoad.threshold,
            surpassed = false; // Check if threshold is surpassed

        if (threshold) {
          // Any string is treated as a percentage
          if (typeof threshold === 'string') {
            threshold = parseInt(threshold, 10) / 100 * me.count;
          }

          surpassed = toAdd.length + toRemove.length + updated.length > threshold;
        }

        if (me.tree) {
          // Flat data is spliced into/out of the collection, but in a tree it has to be added/removed from store
          // to end up on correct parents
          if (toAdd.length) {
            // Add all new nodes in one go, will be added to correct parent using `parentId`. Triggering multiple times
            var added = me.add(toAdd, surpassed); // parentId was tucked on in syncTreeDataset() to allow the single flat add above, clean it out

            added.forEach(function (node) {
              return node.clearParentId();
            });
          } // Remove in one go, removing from each parent. Triggering multiple times


          me.remove(toRemove, surpassed);
        } else {
          if (surpassed) {
            storage.suspendEvents();
          } // Add and remove, will trigger if below threshold/no threshold


          storage.splice(me.count - toRemove.length, toRemove, toAdd);

          if (surpassed) {
            storage.resumeEvents();
          }
        } // Trigger updates if using threshold, but have not surpassed it. If threshold is not used, the updates
        // are triggered when data is set (avoiding another iteration)


        if (threshold && !surpassed) {
          updated.forEach(function (_ref3) {
            var record = _ref3.record,
                toSet = _ref3.toSet,
                wasSet = _ref3.wasSet;
            return me.onModelChange(record, toSet, wasSet);
          });
        } // Clear change-tracking


        me.acceptChanges();
        var event = {
          added: toAdd,
          removed: toRemove,
          updated: updated,
          thresholdSurpassed: surpassed
        }; // Trigger `batch` if threshold is surpassed, more similar to a batch than a full `dataset`

        if (surpassed) {
          this.trigger('refresh', {
            action: 'batch',
            data: data,
            records: storage.values,
            syncInfo: event
          });
        }

        if (me.isFiltered) {
          // Announced filter
          me.filter();
        }

        if (me.isGrouped) {
          // Announced sort
          me.group();
        } else if (me.isSorted) {
          // Announced sort
          me.sort();
        }

        me.trigger('loadSync', event);
      } // Used by syncDataset()

    }, {
      key: "syncFlatDataset",
      value: function syncFlatDataset(data) {
        if (!data) {
          return;
        }

        var me = this,
            idField = me.modelClass.idField,
            toRemove = [],
            toAdd = [],
            updated = [],
            usedIds = {};
        var threshold = me.syncDataOnLoad.threshold,
            hitCount = 0;
        data.forEach(function (rawData) {
          var id = rawData[idField],
              record = me.getById(id); // Record exists, might be an update

          if (record) {
            // Update silently if using threshold, otherwise trigger away
            var wasSet = record.set(rawData, null, Boolean(threshold));

            if (wasSet) {
              updated.push({
                record: record,
                wasSet: wasSet,
                toSet: rawData
              });
            }

            hitCount++;
          } // Does not exist, add
          else {
              toAdd.push(me.processRecord(me.createRecord(rawData)));
            }

          usedIds[id] = 1;
        }); // Check removals, unless all records were visited above

        if (hitCount < me.allCount) {
          me.forEach(function (record) {
            if (!usedIds[record.id]) {
              toRemove.push(record);
            }
          });
        }

        return {
          toAdd: toAdd,
          toRemove: toRemove,
          updated: updated
        };
      } // Used by syncDataset()

    }, {
      key: "syncTreeDataset",
      value: function syncTreeDataset(data) {
        if (!data) {
          return;
        }

        var me = this,
            _me$modelClass = me.modelClass,
            idField = _me$modelClass.idField,
            parentIdField = _me$modelClass.parentIdField,
            toRemove = [],
            toAdd = [],
            updated = [],
            usedIds = {};
        var threshold = me.syncDataOnLoad.threshold;
        _helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].preWalkWithParent({
          isRoot: true,
          children: data
        }, function (n) {
          return n.children;
        }, function (parent, rawData) {
          if (parent) {
            var id = rawData[idField],
                node = me.getById(id); // Record exists, might be an update

            if (node) {
              // Update silently if using threshold, otherwise trigger away
              var wasSet = node.set(rawData, null, Boolean(threshold));

              if (wasSet) {
                updated.push({
                  record: node,
                  wasSet: wasSet,
                  toSet: rawData
                });
              }
            } // Does not exist, add
            else {
                rawData[parentIdField] = parent[idField];
                toAdd.push(rawData);
              }

            usedIds[id] = 1;
          }
        });
        me.traverse(function (node) {
          if (!usedIds[node.id]) {
            toRemove.push(node);
          }
        });
        return {
          toAdd: toAdd,
          toRemove: toRemove,
          updated: updated
        };
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreSync';
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Configure with `true` to sync loaded data instead of replacing existing with a new dataset.
           *
           * By default (or when configured with `false`) assigning to `store.data` replaces the entire dataset
           * with a new one, creating all new records:
           *
           * ```javascript
           * store.data = [ { id : 1, name : 'Saitama' } ];
           *
           * const first = store.first;
           *
           * store.data = [ { id : 1, name : 'One-Punch man' } ];
           *
           * store.first !== first;
           * ```
           *
           * When configured with `true` the new dataset is instead synced against the old, figuring out what was
           * added, removed and updated:
           *
           * ```javascript
           * store.data = [ { id : 1, name : 'Saitama' } ];
           *
           * const first = store.first;
           *
           * store.data = [ { id : 1, name : 'One-Punch man' } ];
           *
           * store.first === first;
           * ```
           *
           * After the sync, any configured sorters, groupers and filters will be reapplied.
           *
           * The sync operation has a configurable threshold, above which the operation will be treated as a
           * batch/refresh and only trigger a single `refresh` event. If threshold is not reached, individual events
           * will be triggered (single `add`, `remove` and possible multiple `update`). To enable the threshold,
           * supply a config object with a `threshold` property instead of `true`:
           *
           * ```javascript
           * const store = new Store({
           *     syncDataOnLoad : {
           *         threshold : '20%'
           *     }
           * });
           * ```
           *
           * `threshold` accepts numbers or strings. A numeric threshold means number of affected records, while a
           * string is used as a percentage of the whole dataset (appending `%` is optional). By default no threshold
           * is used.
           *
           * @config {Boolean|Object}
           * @default false
           */
          syncDataOnLoad: null
        };
      }
    }]);

    return StoreSync;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_14__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreTree.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreTree.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/mixin/StoreTree
 */

var emptyArray = Object.freeze([]);
/**
 * Mixin for store with tree related functionality. To learn more about working with tree nodes please see the {@link Core/data/mixin/TreeNode} class and [this guide](#guides/data/treedata.md).
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(StoreTree, _ref);

    var _super = _createSuper(StoreTree);

    function StoreTree() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, StoreTree);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(StoreTree, [{
      key: "loadChildren",
      //endregion
      //region Children

      /**
       * Loads children for a parent node that uses load on demand (when expanding it). Base implementation does nothing,
       * either use AjaxStore which implements it, create your own subclass with an implementation or listen for
       * `toggleNode` and insert records when you have them available.
       * @param {Core.data.Model} parentRecord
       * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
       * @category Tree
       */
      value: function () {
        var _loadChildren = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_24___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22___default.a.mark(function _callee(parentRecord) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function loadChildren(_x) {
          return _loadChildren.apply(this, arguments);
        }

        return loadChildren;
      }()
      /**
       * Called from Model when adding children. Not to be called directly, use Model#appendChild() instead.
       * @internal
       * @param {Core.data.mixin.TreeNode} parent
       * @param {Core.data.mixin.TreeNode[]} children
       * @param {Number} index
       * @param {Object} isMove
       * @param {Boolean} [silent]
       * @fires add
       * @fires change
       * @category Tree
       */

    }, {
      key: "onNodeAddChild",
      value: function onNodeAddChild(parent, children, index, isMove) {
        var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var me = this,
            isRootLoad = parent === me.rootNode && parent.isLoading,
            storage = me.storage,
            toAddToUI = [],
            toAdd = [],
            previousSibling = children[0].previousSibling;
        var storeInsertionPoint;
        me.collectDescendants(children, toAddToUI, toAdd, {
          inCollapsedBranch: !(parent.isExpanded(me) && parent.ancestorsExpanded(me))
        }); // Keep CRUD caches up to date unless it's a root load

        if (!isRootLoad && toAdd.length) {
          var _iterator = _createForOfIteratorHelper(toAdd),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var record = _step.value;

              // Only considered an add if not modified or moved
              if (!me.modified.includes(record) && !isMove[record.id]) {
                // If was removed, remove from `removed` list
                if (me.removed.includes(record)) {
                  me.removed.remove(record);
                } // Else add to `added` list
                else {
                    me.added.add(record);
                  }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } // Root node inserted first


        if (isRootLoad && me.rootVisible) {
          toAddToUI.unshift(parent);
          toAdd.unshift(parent);
        }

        if (toAddToUI.length) {
          // Calculate the insertion point into the flat store.
          // If the new node is the first, then it goes after the parent node.
          if (index === 0 || !previousSibling) {
            storeInsertionPoint = storage.indexOf(parent);
          } // Otherwise it has to go after the previous visible node which has
          // to be calculated. See indexOfPreviousVisibleNode for explanation.
          else {
              storeInsertionPoint = storage.indexOf(previousSibling) + previousSibling.getDescendantCount(true, me);
            } // Insert added child nodes at correct location in storage.
          // We must not react to change - we fire the events here.


          storage.suspendEvents();
          me.storage.splice(++storeInsertionPoint, 0, toAddToUI);
          storage.resumeEvents();
        } // Since we do not pass through Store#onDataChange we have to handle relations manually here. And since they are
        // not tied to flat part of store, use all children


        me.updateDependentStores('add', children); // If it's a root level set data op, then signal 'dataset'

        if (isRootLoad && toAddToUI.length) {
          var _me$afterLoadData;

          // If we have initial sorters, perform a silent sort before triggering `dataset`
          // NOTE: Records in toAddToUI will be in the original order, not affected by the sort
          if (me.sorters.length) {
            me.sort(null, null, false, true);
          }

          (_me$afterLoadData = me.afterLoadData) === null || _me$afterLoadData === void 0 ? void 0 : _me$afterLoadData.call(me);

          if (!silent) {
            var event = {
              action: 'dataset',
              data: me._data,
              records: toAddToUI
            };
            me.trigger('refresh', event);
            me.trigger('change', event);
          }
        } // Else, continue as before to signal a bizarre "isChild" add.
        else if (!silent) {
            var _event = {
              action: 'add',
              parent: parent,
              isChild: true,
              isMove: isMove,
              records: children,
              allRecords: toAdd,
              index: storeInsertionPoint
            };
            me.trigger('add', _event);
            me.trigger('change', _event);
          }
      }
    }, {
      key: "onNodeRemoveChild",
      value: function onNodeRemoveChild(parent, children, index) {
        var flags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
          isMove: false,
          silent: false,
          unfiltered: false
        };
        var me = this,
            storage = me.storage,
            toRemoveFromUI = [],
            toRemove = [],
            isMove = flags.isMove,
            silent = flags.silent,
            unfiltered = flags.unfiltered,
            removeUnfiltered = unfiltered && me.isFiltered,
            childrenToRemove = removeUnfiltered && parent.unfilteredChildren ? parent.unfilteredChildren : children;
        me.collectDescendants(childrenToRemove, toRemoveFromUI, toRemove, {
          inCollapsedBranch: !(parent.isExpanded(me) && parent.ancestorsExpanded(me)),
          unfiltered: removeUnfiltered
        }); // test StoreTree.t.js should fail if the next line replaces the above line
        // me.collectDescendants(children, toRemoveFromUI, toRemove, { inCollapsedBranch : !(parent.isExpanded(me) && parent.ancestorsExpanded(me)) });

        if (!isMove) {
          // Unjoin is recursive, use flat children array
          var _iterator2 = _createForOfIteratorHelper(children),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _record = _step2.value;

              _record.unJoinStore(me);
            } // Keep CRUD caches up to date

          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (toRemove.length) {
            var _iterator3 = _createForOfIteratorHelper(toRemove),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var record = _step3.value;

                if (record.stores.includes(me)) {
                  record.unJoinStore(me);
                } // If was newly added, remove from `added` list


                if (me.added.includes(record)) {
                  me.added.remove(record);
                } // Else add to `removed` list
                else {
                    me.removed.add(record);
                  }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            me.modified.remove(toRemove);
          }
        } // Remove removed child nodes at correct location in storage


        if (toRemoveFromUI.length) {
          index = storage.indexOf(toRemoveFromUI[0]); // We must not react to change - we fire the events here.

          if (index > -1) {
            storage.suspendEvents();
            storage.splice(index, toRemoveFromUI.length);
            storage.resumeEvents();
          }
        } else {
          // If nothing is removed from UI (storage) return -1, showing that removed node was in the collapsed branch
          index = -1;
        }

        if (!silent) {
          var event = {
            action: 'remove',
            parent: parent,
            isChild: true,
            isMove: isMove,
            records: children,
            allRecords: toRemove,
            index: index
          };
          me.trigger('remove', event);
          me.trigger('change', event);
        }
      }
    }, {
      key: "collectDescendants",
      value: function collectDescendants(node) {
        var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var all = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var flags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
          inCollapsedBranch: false,
          unfiltered: false
        };
        var me = this,
            inCollapsedBranch = flags.inCollapsedBranch,
            unfiltered = flags.unfiltered,
            children = Array.isArray(node) ? node : me.getChildren(node, unfiltered);

        if (children) {
          for (var i = 0, len = children.length, child; i < len; i++) {
            child = children[i];

            if (!inCollapsedBranch) {
              visible.push(child);
            }

            all.push(child);
            me.collectDescendants(child, visible, all, {
              inCollapsedBranch: inCollapsedBranch || !child.isExpanded(me),
              unfiltered: unfiltered
            });
          }
        }

        return {
          visible: visible,
          all: all
        };
      }
      /**
       * Returns the children of the passed branch node which this store owns. By default, this
       * is the entire `children` array.
       *
       * **If this store {@link Core.data.mixin.StoreChained#property-isChained isChained}**, then
       * this returns only the subset of children which are filtered into this store by the
       * {@link Core.data.mixin.StoreChained#config-chainedFilterFn chainedFilterFn}.
       * @param {Core.data.Model} parent The node to return the children of.
       * @category Tree
       */

    }, {
      key: "getChildren",
      value: function getChildren(parent) {
        var unfiltered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        // In case of chained store we need to apply chainedFilterFn to all records
        var children = (unfiltered || this.isChained) && parent.unfilteredChildren || parent.children;
        return children && children.length ? this.isChained ? children.filter(this.chainedFilterFn) : children : emptyArray;
      }
      /**
       * Includes or excludes all records beneath parentRecord in storage. Used when expanding or collapsing
       * nodes.
       * @private
       * @param parentRecord Parent record
       * @param include Include (true) or exclude (false)
       * @category Tree
       */

    }, {
      key: "internalToggleTreeSubRecords",
      value: function internalToggleTreeSubRecords(parentRecord, include) {
        var me = this,
            storage = me.storage,
            index = storage.indexOf(parentRecord),
            children = me.doIncludeExclude(me.getChildren(parentRecord), include); // If we expanded a node which is yet to load children, the collected children
        // array will be empty, so do not broadcast any change event.
        // If we are collapsing a record which isn't visible (because parent is collapsed) we won't get an index,
        // which is fine since it is already removed from processedRecords

        if (children.length && index !== false) {
          // We must not react to change - we fire the events here with a flag
          // to tell responders that it's due to an expoand or collapse.
          storage.suspendEvents();

          if (include) {
            storage.splice.apply(storage, [index + 1, 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_21___default()(children)));
            var event = {
              action: 'add',
              isExpand: true,
              records: children,
              index: index + 1
            };
            me.trigger('add', event);
            me.trigger('change', event);
          } else {
            storage.splice(index + 1, children.length);
            var _event2 = {
              action: 'remove',
              isCollapse: true,
              records: children,
              index: index + 1
            };
            me.trigger('remove', _event2);
            me.trigger('change', _event2);
          }

          storage.resumeEvents();
        }
      }
    }, {
      key: "doIncludeExclude",
      value: function doIncludeExclude(children, include) {
        var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var me = this,
            childCount = children && children.length;

        for (var i = 0; i < childCount; i++) {
          var child = children[i]; // Only consider child nodes who we own.
          // If we are a chained store, skip nodes that are not ours.

          if (!me.isChained || me.chainedFilterFn(child)) {
            var mapMeta = child.instanceMeta(me.id);

            if (include) {
              // if including subrecords, add those who are not hidden by a collapsed sub parent
              result.push(child);
            } else if (!mapMeta.hidden) {
              result.push(child);
            }

            mapMeta.hidden = !include;

            if (child.isExpanded(me)) {
              me.doIncludeExclude(me.getChildren(child), include, result);
            }
          }
        }

        return result;
      }
      /**
       * Collapse an expanded record or expand a collapsed. Optionally forcing a certain state.
       * @param {String|Number|Core.data.Model} idOrRecord Record (the record itself) or id of a record to toggle
       * @param {Boolean} [collapse] Force collapse (true) or expand (false)
       * @returns {Promise}
       * @async
       * @category Tree
       */

    }, {
      key: "toggleCollapse",
      value: function () {
        var _toggleCollapse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_24___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22___default.a.mark(function _callee2(idOrRecord, collapse) {
          var me, record, meta, success;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  me = this, record = me.getById(idOrRecord), meta = record.instanceMeta(me);

                  if (collapse === undefined) {
                    collapse = !meta.collapsed;
                  } // Reject if we're in the middle of loading children, or it's a leaf, or it's a no-op


                  if (!(!meta.isLoadingChildren && !record.isLeaf && record.isExpanded(me) === collapse)) {
                    _context2.next = 28;
                    break;
                  }

                  me.trigger('beforeToggleNode', {
                    record: record,
                    collapse: collapse
                  });
                  meta.collapsed = collapse;

                  if (!meta.collapsed) {
                    _context2.next = 10;
                    break;
                  }

                  me.onNodeCollapse(record);
                  return _context2.abrupt("return", true);

                case 10:
                  me.onNodeExpand(record);
                  success = true; // Children not yet loaded, ask store for them.
                  // It will append them. Appending to a node which
                  // is expandded will insert the children into the UI.

                  if (record.isLoaded) {
                    _context2.next = 27;
                    break;
                  }

                  meta.isLoadingChildren = true;
                  _context2.prev = 14;
                  _context2.next = 17;
                  return me.loadChildren(record);

                case 17:
                  _context2.next = 24;
                  break;

                case 19:
                  _context2.prev = 19;
                  _context2.t0 = _context2["catch"](14);
                  // Revert to being collapsed
                  meta.collapsed = true;
                  success = false;
                  me.trigger('loadChildrenException', {
                    record: record,
                    exception: _context2.t0
                  });

                case 24:
                  _context2.prev = 24;
                  meta.isLoadingChildren = false;
                  return _context2.finish(24);

                case 27:
                  return _context2.abrupt("return", success);

                case 28:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[14, 19, 24, 27]]);
        }));

        function toggleCollapse(_x2, _x3) {
          return _toggleCollapse.apply(this, arguments);
        }

        return toggleCollapse;
      }()
      /**
       * Remove all records beneath parentRecord from storage.
       * @private
       * @param parentRecord Parent record
       * @category Tree
       */

    }, {
      key: "onNodeCollapse",
      value: function onNodeCollapse(parentRecord) {
        // We don't care about collapse if it's inside a collapsed subtree
        if (parentRecord.ancestorsExpanded(this)) {
          return this.internalToggleTreeSubRecords(parentRecord, false);
        }
      }
      /**
       * Add all records beneath parentRecord from storage.
       * @private
       * @param parentRecord Parent record
       * @category Tree
       */

    }, {
      key: "onNodeExpand",
      value: function onNodeExpand(parentRecord) {
        // We don't care about expand if it's inside a collapsed subtree
        if (parentRecord.ancestorsExpanded(this)) {
          return this.internalToggleTreeSubRecords(parentRecord, true);
        }
      } //endregion

    }, {
      key: "isTree",
      //region Getters

      /**
       * True if this Store is configured to handle tree data (with `tree : true`) or if this is a
       * {@link Core.data.Store#function-makeChained chained store} and the master store is a tree store.
       * @property {Boolean}
       * @readonly
       * @category Tree
       */
      get: function get() {
        return this.tree || this.masterStore && this.masterStore.tree;
      }
      /**
       * Get all leaves in store with tree data
       * @returns {Core.data.Model[]}
       * @category Tree
       */

    }, {
      key: "leaves",
      get: function get() {
        var me = this,
            result = [];

        if (me.isTree) {
          me.traverse(function (record) {
            if (record.isLeaf) {
              result.push(record);
            }
          });
          return result;
        } else {
          me.allRecords.forEach(function (r) {
            if (r.isLeaf) {
              result.push(r);
            }

            r.traverse(function (record) {
              if (record.isLeaf) {
                result.push(record);
              }
            }, true);
          });
        }

        return result;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreTree';
      }
    }]);

    return StoreTree;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_30__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/mixin/TreeNode.js":
/*!*****************************************!*\
  !*** ./lib/Core/data/mixin/TreeNode.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_reflect_delete_property__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.reflect.delete-property */ "./node_modules/core-js/modules/es.reflect.delete-property.js");
/* harmony import */ var core_js_modules_es_reflect_delete_property__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_delete_property__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/data/mixin/TreeNode
 */

/**
 * Mixin for Model with tree node related functionality. This class is mixed into the {@link Core/data/Model} class.
 *
 * ## Adding and removing child nodes
 * ```
 * const parent = store.getById(1),
 *
 * firstBorn = parent.insertChild({
 *      name : 'Child node'
 *  }, parent.children[0]); // Insert a child at a specific place in the children array
 *
 * parent.removeChild(parent.children[0]); // Removes a child node
 * parent.appendChild({ name : 'New child node' }); // Appends a child node
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(TreeNode, _ref);

    var _super = _createSuper(TreeNode);

    function TreeNode() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, TreeNode);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(TreeNode, [{
      key: "ingestChildren",

      /**
       * This is a read-only property providing access to the parent node.
       * @member {Core.data.Model} parent
       * @readonly
       * @category Parent & children
       */

      /**
       * This is a read-only field provided in server synchronization packets to specify
       * which record id is the parent of the record.
       * @readonly
       * @field {String|Number} parentId
       * @category Tree
       */

      /**
       * This is a read-only field provided in server synchronization packets to specify
       * which position the node takes in the parent's children array.
       * This index is set on load and gets updated automatically after row reordering, sorting, etc.
       * To save the order, need to persist the field on the server and when data is fetched to be loaded,
       * need to sort by this field.
       * @readonly
       * @field {Number} parentIndex
       * @category Tree
       */
      value: function ingestChildren(childRecord) {
        var stores = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.stores;
        var inProcessChildren = this.inProcessChildren,
            MyClass = this.constructor,
            store = stores[0];

        if (childRecord === true) {
          if (inProcessChildren) {
            return true;
          }

          return [];
        }

        if (childRecord) {
          if (!Array.isArray(childRecord)) {
            childRecord = [childRecord];
          }

          var len = childRecord.length,
              result = [];

          for (var i = 0, child; i < len; i++) {
            child = childRecord[i];
            child = child.isModel ? child : store ? store.createRecord(child) : new MyClass(child, null, null, true);
            child = store ? store.processRecord(child) : child;
            result.push(child);
          }

          return result;
        }
      }
      /**
       * Child nodes. To allow loading children on demand, specify `children : true` in your data.
       * @member {Core.data.Model[]} children
       * @category Parent & children
       */

      /**
       * Called during creation to also turn any children into Models joined to the same stores as this model
       * @internal
       * @category Parent & children
       */

    }, {
      key: "processChildren",
      value: function processChildren() {
        var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.stores;
        var me = this,
            meta = me.meta;
        me.inProcessChildren = true;
        var children = me.ingestChildren(me.data[me.constructor.childrenField], stores);

        if (children) {
          if (children.length) {
            meta.isLeaf = false; // We are processing a remote load

            if (me.children === true) {
              me.children = [];
            }

            me.appendChild(children);
          } // Flagged for load on demand
          else if (children === true) {
              meta.isLeaf = false;
              me.children = true;
            } // Empty child array, flag is leaf if configured to do so
            else if (!me.isRoot) {
                meta.isLeaf = me.constructor.convertEmptyParentToLeaf.onLoad;
              }
        }

        me.inProcessChildren = false;
      }
      /**
       * This property is `true` if this record has all expanded ancestors and is therefore
       * eligible for inclusion in a UI.
       * @property {Boolean}
       * @readonly
       * @category Parent & children
       */

    }, {
      key: "ancestorsExpanded",
      value: function ancestorsExpanded(store) {
        var parent = this.parent;
        return !parent || parent.isExpanded(store) && parent.ancestorsExpanded(store);
      }
      /**
       * Used by stores to assess the record's collapsed/expanded state in that store.
       * @param {Core.data.Store} store
       * @category Parent & children
       */

    }, {
      key: "isExpanded",
      value: function isExpanded(store) {
        var mapMeta = this.instanceMeta(store.id); // Default initial expanded/collapsed state when in the store
        // to the record's original expanded property.

        if (!Object.prototype.hasOwnProperty.call(mapMeta, 'collapsed')) {
          mapMeta.collapsed = !this.expanded;
        }

        return !mapMeta.collapsed;
      } // A read-only property. It provides the initial state upon load
      // The UI's expanded/collapsed state is in the store's meta map.

    }, {
      key: "getDescendantCount",

      /**
       * Count visible (expanded)/all children for this node, optionally specifying for which store.
       * @param {Boolean} [onlyVisible] Specify `true` to only count visible (expanded) children.
       * @param {Core.data.Store} [store] A Store to which this node belongs
       * @returns {Number}
       * @category Parent & children
       */
      value: function getDescendantCount() {
        var onlyVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.firstStore;
        var children = this.children;

        if (!children || !Array.isArray(children) || onlyVisible && !this.isExpanded(store)) {
          return 0;
        }

        return children.reduce(function (count, child) {
          return count + child.getDescendantCount(onlyVisible);
        }, children.length);
      }
      /**
       * Retrieve all children (by traversing sub nodes)
       * @returns {Core.data.Model[]}
       * @category Parent & children
       */

    }, {
      key: "traverse",

      /**
       * Traverses all child nodes recursively calling the passed function
       * on a target node **before** iterating the child nodes.
       * @param fn
       * @category Parent & children
       */
      value: function traverse(fn) {
        var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var children = this.children;

        if (!skipSelf) {
          fn.call(this, this);
        } // Simply testing whether there is non-zero children length
        // is 10x faster than using this.isLoaded


        for (var i = 0, l = children && children.length; i < l; i++) {
          children[i].traverse(fn);
        }
      }
      /**
       * Traverses all child nodes recursively calling the passed function
       * on child nodes of a target **before** calling it it on the node.
       * @param fn
       * @category Parent & children
       */

    }, {
      key: "traverseBefore",
      value: function traverseBefore(fn) {
        var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var children = this.children; // Simply testing whether there is non-zero children length
        // is 10x faster than using this.isLoaded

        for (var i = 0, l = children && children.length; i < l; i++) {
          children[i].traverse(fn);
        }

        if (!skipSelf) {
          fn.call(this, this);
        }
      }
      /**
       * Traverses child nodes recursively while fn returns true
       * @param {Function} fn
       * @category Parent & children
       * @returns {Boolean}
       */

    }, {
      key: "traverseWhile",
      value: function traverseWhile(fn) {
        var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var me = this;
        var goOn = true;

        if (!skipSelf) {
          goOn = fn.call(me, me) !== false;
        }

        if (goOn && me.isLoaded) {
          goOn = me.children.every(function (child) {
            return child.traverseWhile(fn);
          });
        }

        return goOn;
      }
      /**
       * Bubbles up from this node, calling the specified function with each node.
       *
       * @param {Function} fn
       * @category Parent & children
       */

    }, {
      key: "bubble",
      value: function bubble(fn) {
        var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var me = this;

        if (!skipSelf) {
          fn.call(me, me);
        }

        while (me.parent) {
          me = me.parent;
          fn.call(me, me);
        }
      }
      /**
       * Bubbles up from this node, calling the specified function with each node,
       * while the function returns true.
       *
       * @param {Function} fn
       * @category Parent & children
       * @return {Boolean}
       */

    }, {
      key: "bubbleWhile",
      value: function bubbleWhile(fn) {
        var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var me = this,
            goOn = true;

        if (!skipSelf) {
          goOn = fn.call(me, me);
        }

        while (goOn && me.parent) {
          me = me.parent;
          goOn = fn.call(me, me);
        }

        return goOn;
      }
      /**
       * Checks if this model contain another model as one of it's descendants
       *
       * @param {Core.data.Model|String|Number} childOrId child node or id
       * @category Parent & children
       * @returns {Boolean}
       */

    }, {
      key: "contains",
      value: function contains(childOrId) {
        if (childOrId && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_24___default()(childOrId) === 'object') {
          childOrId = childOrId.id;
        }

        return !this.traverseWhile(function (node) {
          return node.id != childOrId;
        });
      }
    }, {
      key: "getTopParent",
      value: function getTopParent(all) {
        var result;

        if (all) {
          result = [];
          this.bubbleWhile(function (t) {
            result.push(t);
            return t.parent && !t.parent.isRoot;
          });
        } else {
          result = null;
          this.bubbleWhile(function (t) {
            if (!t.parent) {
              result = t;
            }

            return t.parent && !t.parent.isRoot;
          });
        }

        return result;
      }
      /**
       * Append a child record(s) to any current children.
       * @param {Core.data.Model|Core.data.Model[]} childRecord Record or array of records to append
       * @param {Boolean} [silent] Pass `true` to not trigger events during append
       * @returns {Core.data.Model|Core.data.Model[]}
       * @category Parent & children
       */

    }, {
      key: "appendChild",
      value: function appendChild(childRecord) {
        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return this.insertChild(childRecord, null, silent);
      }
      /**
       * Insert a child record(s) before an existing child record.
       * @param {Core.data.Model|Core.data.Model[]} childRecord Record or array of records to insert
       * @param {Core.data.Model} [before] Optional record to insert before, leave out to append to the end
       * @param {Boolean} [silent] Pass `true` to not trigger events during append
       * @returns {Core.data.Model|Core.data.Model[]}
       * @category Parent & children
       */

    }, {
      key: "insertChild",
      value: function insertChild(childRecord) {
        var beforeRecord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        // Handle deprecated signature
        if (typeof childRecord === 'number') {
          var _index = childRecord;
          childRecord = beforeRecord;
          beforeRecord = this.children[_index];
        }

        var me = this,
            wasLeaf = me.isLeaf,
            returnArray = Array.isArray(childRecord);
        if (!Array.isArray(childRecord)) childRecord = [childRecord];

        if (!silent) {
          if (!me.stores.every(function (s) {
            return s.trigger('beforeAdd', {
              records: childRecord,
              parent: me
            }) !== false;
          })) {
            return null;
          }
        } // This call makes child record an array containing Models


        childRecord = me.ingestChildren(childRecord); // NOTE: see comment in Model::set() about before/in/after calls approach.

        var index = beforeRecord ? beforeRecord.parentIndex : me.children ? me.children.length : 0,
            preResult = me.beforeInsertChild ? me.beforeInsertChild(childRecord) : undefined,
            inserted = me.internalAppendInsert(childRecord, beforeRecord, silent); // Turn into a parent if not already one

        if (wasLeaf && inserted.length) {
          me.meta.isLeaf = false;
        } // If we've transitioned to being a branch node, signal a change event
        // so that the UI updates.
        // Not if it's due to root node loading. StoreTree#onNodeAddChild
        // for the rootNode will fire a store refresh.


        if (me.isLeaf !== wasLeaf && !me.root.isLoading && !silent) {
          me.stores.forEach(function (s) {
            var changes = {
              isLeaf: {
                value: false,
                oldValue: true
              }
            };
            s.trigger('update', {
              record: me,
              changes: changes
            });
            s.trigger('change', {
              action: 'update',
              record: me,
              changes: changes
            });
          });
        }

        me.afterInsertChild && me.afterInsertChild(index, childRecord, preResult, inserted);
        return returnArray || !inserted ? inserted : inserted[0];
      }
    }, {
      key: "tryInsertChild",
      value: function tryInsertChild() {
        return this.insertChild.apply(this, arguments);
      }
    }, {
      key: "internalAppendInsert",
      value: function internalAppendInsert(recordsToInsert, beforeRecord, silent) {
        var me = this,
            stores = me.stores,
            root = me.root,
            rootStore = root.firstStore,
            parentIdField = me.constructor.parentIdField,
            parentId = me.isAutoRoot ? null : me.id,
            isMove = {};
        var isNoop, start, i, newRecordsCloned; // The reference node must be one of our children. If not, fall back to an append.

        if (beforeRecord && beforeRecord.parent !== me) {
          beforeRecord = null;
        } // If the records starting at insertAt or (insertAt - 1), are the same sequence
        // that we are being asked to add, this is a no-op.


        if (me.children) {
          var children = me.children,
              insertAt = beforeRecord ? beforeRecord.parentIndex : children.length;

          if (children[start = insertAt] === recordsToInsert[0] || children[start = insertAt - 1] === recordsToInsert[0]) {
            for (isNoop = true, i = 0; isNoop && i < recordsToInsert.length; i++) {
              if (recordsToInsert[i] !== children[start + i]) {
                isNoop = false;
              }
            }
          }
        } // Fulfill the contract of appendChild/insertChild even if we did not have to do anything.
        // Callers must be able to correctly postprocess the returned value as an array.


        if (isNoop) {
          return recordsToInsert;
        } // Remove incoming child nodes from any current parent.


        for (i = 0; i < recordsToInsert.length; i++) {
          var newRecord = recordsToInsert[i],
              oldParent = newRecord.parent; // Store added should not be modified for adds
          // caused by moving.

          isMove[newRecord.id] = newRecord.root === root; // Check if any descendants of the added node are moves.

          rootStore && newRecord.traverse(function (r) {
            if (r.root === root) {
              isMove[r.id] = true;
            }
          }); // If the new record has a parent, remove from that parent.
          // This operation may be vetoed by listeners.
          // If it is vetoed, then remove from the newRecords and do not
          // set the parent property

          if (oldParent && oldParent.removeChild(newRecord, isMove[newRecord.id]) === false) {
            if (!newRecordsCloned) {
              recordsToInsert = recordsToInsert.slice();
              newRecordsCloned = true;
            }

            recordsToInsert.splice(i--, 1);
          } else {
            newRecord.parent = me; // Set parentId directly to data, record.parentId uses a getter to return record.parent.id

            newRecord.data[parentIdField] = parentId;

            if (oldParent) {
              newRecord.meta.oldParentId = oldParent.id;
            }
          }
        } // Still records to insert after beforeRemove listeners may have vetoed some


        if (recordsToInsert.length) {
          // Add to the children
          var _insertAt = me.addToChildren(me.children || (me.children = []), beforeRecord, recordsToInsert); // When filter is used add to the unfiltered children


          me.addToChildren(me.unfilteredChildren, beforeRecord, recordsToInsert, true);
          stores.forEach(function (store) {
            if (!store.isChained) {
              recordsToInsert.forEach(function (record) {
                // Initialize context for newly added records
                record.joinStore(store);
              }); // Add to store (will also add any child records and trigger events)

              store.onNodeAddChild(me, recordsToInsert, _insertAt, isMove, silent);
              recordsToInsert.forEach(function (record) {
                // If we are in the recursive inclusion of children at construction
                // time, or in a store load, that must not be a data modification.
                // Otherwise, we have to signal a change
                if (record.meta.oldParentId != null && !(me.inProcessChildren || me.isLoading)) {
                  var _toSet;

                  var toSet = (_toSet = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23___default()(_toSet, parentIdField, parentId), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23___default()(_toSet, me.getDataSource('parentIndex'), record.parentIndex), _toSet),
                      wasSet = {},
                      _record$meta = record.meta,
                      modified = _record$meta.modified,
                      oldParentId = _record$meta.oldParentId,
                      oldParentIndex = modified.parentIndex;
                  delete record.meta.oldParentId;

                  if (me.id !== oldParentId) {
                    wasSet[parentIdField] = {
                      value: parentId,
                      oldValue: oldParentId
                    };
                  }

                  if (record.parentIndex !== oldParentIndex) {
                    wasSet.parentIndex = {
                      value: record.parentIndex,
                      oldValue: oldParentIndex
                    };
                  } // Changing back to its original value


                  if (modified[parentIdField] === me.id) {
                    Reflect.deleteProperty(modified, parentIdField);
                  } // Cache its original value
                  else if (!(parentIdField in modified)) {
                      modified[parentIdField] = oldParentId;
                    }

                  record.afterChange(toSet, wasSet);
                }
              });
            }
          });
        }

        return recordsToInsert;
      }
      /**
       * Remove a child record. Only direct children of this node can be removed, others are ignored.
       * @param {Core.data.Model|Core.data.Model[]} childRecords The record(s) to remove.
       * @param {Boolean} [isMove] Pass `true` if the record is being moved within the same store.
       * @param {Boolean} [silent] Pass `true` to not trigger events during remove.
       * @category Parent & children
       */

    }, {
      key: "removeChild",
      value: function removeChild(childRecords) {
        var isMove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var me = this,
            wasLeaf = me.isLeaf,
            children = me.children,
            stores = me.stores;

        if (!Array.isArray(childRecords)) {
          childRecords = [childRecords];
        }

        childRecords = childRecords.filter(function (r) {
          return r.parent === me;
        });

        if (!silent) {
          // Allow store listeners to veto the beforeRemove event
          var _iterator = _createForOfIteratorHelper(stores),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var store = _step.value;

              if (!store.isChained) {
                if (store.trigger('beforeRemove', {
                  parent: me,
                  records: childRecords,
                  isMove: isMove
                }) === false) {
                  return false;
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        var preResult = me.beforeRemoveChild ? me.beforeRemoveChild(childRecords, isMove) : undefined;

        var _iterator2 = _createForOfIteratorHelper(childRecords),
            _step2;

        try {
          var _loop = function _loop() {
            var childRecord = _step2.value;
            var parentIdField = childRecord.constructor.parentIdField,
                modified = childRecord.meta.modified,
                oldParentId = childRecord.parent ? childRecord.parent.id : null; // Cache its original value

            if (!(parentIdField in modified)) {
              modified[parentIdField] = oldParentId;
            }

            var index = me.removeFromChildren(children, childRecord);
            me.removeFromChildren(me.unfilteredChildren, childRecord, true);
            stores.forEach(function (store) {
              if (!store.isChained) {
                store.onNodeRemoveChild(me, [childRecord], index, {
                  isMove: isMove,
                  silent: silent
                });
              }
            }); // No need to clean up the node parent info and other meta data in case it is "move" operation. The info will be updated after "insert" operation.

            if (!isMove) {
              childRecord.parent = childRecord.parentIndex = childRecord.unfilteredIndex = childRecord.nextSibling = childRecord.previousSibling = null; // Reset parentId in data, record.parentId uses a getter to return record.parent.id

              childRecord.data[parentIdField] = null;
            }
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          } // Convert emptied parent into leaf if configured to do so

        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (!children.length && me.constructor.convertEmptyParentToLeaf.onRemove && !me.isRoot) {
          me.meta.isLeaf = true;
        } // If we've transitioned to being a leaf node, signal a change event
        // so that the UI updates


        if (me.isLeaf !== wasLeaf && !silent) {
          me.stores.forEach(function (s) {
            var changes = {
              isLeaf: {
                value: true,
                oldValue: false
              }
            };
            s.trigger('update', {
              record: me,
              changes: changes
            });
            s.trigger('change', {
              action: 'update',
              record: me,
              changes: changes
            });
          });
        }

        me.afterRemoveChild && me.afterRemoveChild(childRecords, preResult, isMove);
      }
    }, {
      key: "clearParentId",
      value: function clearParentId() {
        var me = this;
        Reflect.deleteProperty(me.data, me.parentIdField);
        Reflect.deleteProperty(me.originalData, me.parentIdField);

        if (me.meta.modified) {
          Reflect.deleteProperty(me.meta.modified, me.parentIdField);
        }
      }
    }, {
      key: "clearChildren",
      value: function clearChildren() {
        var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var me = this,
            children = me.children,
            stores = me.stores;

        if (children) {
          me.children = [];
          stores.forEach(function (store) {
            if (!store.isChained) {
              // unfiltered:true to unregister children on filtered stores
              store.onNodeRemoveChild(me, children, 0, {
                unfiltered: true,
                silent: silent
              });
            }
          }); // clear unfilteredChildren (must be after the above loop)

          if (me.unfilteredChildren) {
            me.unfilteredChildren = [];
          }
        }
      }
      /**
       * Removes all records from the rootNode
       * @private
       */

    }, {
      key: "clear",
      value: function clear() {
        var me = this,
            stores = me.stores,
            children = me.children && me.children.slice(); // Only allow for root node and if data is present

        if (!me.isRoot || !children) {
          return;
        }

        var _iterator3 = _createForOfIteratorHelper(stores),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var store = _step3.value;

            if (!store.isChained) {
              if (store.trigger('beforeRemove', {
                parent: me,
                records: children,
                isMove: false,
                removingAll: true
              }) === false) {
                return false;
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        me.children.length = 0;
        stores.forEach(function (store) {
          children.forEach(function (child) {
            if (child.stores.includes(store)) {
              // this will drill down the child, unregistering whole branch
              child.unJoinStore(store);
            }

            child.parent = child.parentIndex = child.nextSibling = child.previousSibling = null;
          });
          store.storage.suspendEvents();
          store.storage.clear();
          store.storage.resumeEvents();
          store.added.clear();
          store.modified.clear();
          store.trigger('removeAll');
          store.trigger('change', {
            action: 'removeall'
          });
        });
      }
    }, {
      key: "updateChildrenIndices",
      value: function updateChildrenIndices(children) {
        var unfiltered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex';
        var previousSibling = null;

        for (var i = 0; i < children.length; i++) {
          var child = children[i],
              oldValue = child[indexName];

          if (indexName === 'parentIndex') {
            // Record should not be considered modified by initial assignment of parentIndex
            if (oldValue === undefined || silent) {
              child.setData('parentIndex', i);
            } // Check to avoid pointless beforeUpdates from inSet
            else if (oldValue !== i) {
                // Silent set, do not want to trigger events from updated indices
                child.set('parentIndex', i, true);
              }
          } else {
            child[indexName] = i;
          }

          if (!unfiltered) {
            child.previousSibling = previousSibling;

            if (previousSibling) {
              previousSibling.nextSibling = child;
            } // Last child never has a nextSibling


            if (i === children.length - 1) {
              child.nextSibling = null;
            }

            previousSibling = child;
          }
        }
      }
    }, {
      key: "addToChildren",
      value: function addToChildren(children, beforeRecord, newRecords) {
        var unfiltered = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        if (children) {
          var indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex',
              index = beforeRecord ? beforeRecord[indexName] : children.length;
          children.splice.apply(children, [index, 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_22___default()(newRecords)));
          this.updateChildrenIndices(children, unfiltered);
          return index;
        }
      }
    }, {
      key: "removeFromChildren",
      value: function removeFromChildren(children, childRecord) {
        var unfiltered = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (children) {
          var indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex',
              index = childRecord[indexName];

          if (index > -1) {
            children.splice(index, 1);
            this.updateChildrenIndices(children, unfiltered);
          }

          return index;
        }
      }
    }, {
      key: "expanded",
      get: function get() {
        return this.data.expanded;
      }
      /**
       * Depth in the tree at which this node exists. First visual level of nodes are at level 0, their direct children at
       * level 1 and so on.
       * @property {Number}
       * @readonly
       * @category Parent & children
       */

    }, {
      key: "childLevel",
      get: function get() {
        var node = this,
            ret = -1;

        while (node && !node.isRoot) {
          ++ret;
          node = node.parent;
        }

        return ret;
      }
      /**
       * Is a leaf node in a tree structure?
       * @property {Boolean}
       * @readonly
       * @category Parent & children
       */

    }, {
      key: "isLeaf",
      get: function get() {
        return this.meta.isLeaf !== false && !this.isRoot;
      }
      /**
       * Is a parent node in a tree structure?
       * @property {Boolean}
       * @readonly
       * @category Parent & children
       */

    }, {
      key: "isParent",
      get: function get() {
        return !this.isLeaf;
      }
      /**
       * Returns true for parent nodes with children loaded (there might still be no children)
       * @property {Boolean}
       * @readonly
       * @category Parent & children
       */

    }, {
      key: "isLoaded",
      get: function get() {
        return this.isParent && Array.isArray(this.children);
      }
      /**
       * Count all children (including sub-children) for a node (in its `firstStore´)
       * @member {Number}
       * @category Parent & children
       */

    }, {
      key: "descendantCount",
      get: function get() {
        return this.getDescendantCount();
      }
      /**
       * Count visible (expanded) children (including sub-children) for a node (in its `firstStore`)
       * @member {Number}
       * @category Parent & children
       */

    }, {
      key: "visibleDescendantCount",
      get: function get() {
        return this.getDescendantCount(true);
      }
    }, {
      key: "allChildren",
      get: function get() {
        var children = this.children;
        if (!children) return [];
        return children.reduce(function (all, child) {
          all.push(child); // push.apply is faster than push with array spread:
          // https://jsperf.com/push-apply-vs-push-with-array-spread/1

          all.push.apply(all, child.allChildren);
          return all;
        }, []);
      }
      /**
       * Get the first child of this node
       * @returns {Core.data.Model}
       * @category Parent & children
       */

    }, {
      key: "firstChild",
      get: function get() {
        var children = this.children;
        return children && children.length && children[0] || null;
      }
      /**
       * Get the last child of this node
       * @returns {Core.data.Model}
       * @category Parent & children
       */

    }, {
      key: "lastChild",
      get: function get() {
        var children = this.children;
        return children && children.length && children[children.length - 1] || null;
      }
      /**
       * Returns count of all preceding sibling nodes (including their children).
       * @property {Number}
       * @category Parent & children
       */

    }, {
      key: "previousSiblingsTotalCount",
      get: function get() {
        var task = this.previousSibling,
            count = this.parentIndex;

        while (task) {
          count += task.descendantCount;
          task = task.previousSibling;
        }

        return count;
      }
    }, {
      key: "root",
      get: function get() {
        return this.parent && this.parent.root || this;
      }
      /**
       * Reading this property returns the id of the parent node, if this record is a child of a node.
       *
       * Setting this property appends this record to the record with the passed
       * id **in the same store that this record is already in**.
       *
       * Note that setting this property is **only valid if this record is already
       * part of a tree store**.
       *
       * This is not intended for general use. This is for when a server responds to a record
       * mutation and the server decides to move a record to a new parent. If a `parentId` property
       * is passed in the response data for a record, that record will be moved.
       * @property {Number|String}
       * @category Parent & children
       */

    }, {
      key: "parentId",
      get: function get() {
        return this.parent && !this.parent.isAutoRoot ? this.parent.id : null;
      },
      set: function set(parentId) {
        var me = this,
            parent = me.parent,
            newParent = parentId && me.firstStore.getById(parentId); // Handle exact equality of parent.
        // Also handle one being null and the other being undefined meaning no change.

        if (!(newParent === parent || !parent && !newParent)) {
          // If we are batching, we do not trigger a change immediately.
          // endBatch will set the field which will set the property again.
          if (me.isBatchUpdating) {
            me.meta.batchChanges.parentId = parentId;
          } else {
            if (newParent) {
              newParent.appendChild(me);
            } else {
              me.parent.removeChild(me);
            }
          }
        }
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'TreeNode';
      }
      /**
       * This static configuration option allows you to control whether an empty parent task should be converted into a
       * leaf. Enable/disable it for a whole class:
       *
       * ```javascript
       * Model.convertEmptyParentToLeaf = false;
       * ```
       *
       * By specifying `true`, all empty parents will be considered leafs. Can also be assigned a configuration object
       * with with the following Boolean properties to customize the behaviour:
       *
       * * `onLoad` - Apply the transformation on load to any parents without children (`children : []`)
       * * `onRemove` - Apply the transformation when all children have been removed from a parent
       *
       * ```javascript
       * Model.convertEmptyParentToLeaf = {
       *     onLoad   : false,
       *     onRemove : true
       * }
       * ```
       *
       * @property {Boolean|Object}
       * @default false
       * @category Parent & children
       */

    }, {
      key: "convertEmptyParentToLeaf",
      set: function set(value) {
        if (value === true) {
          value = {
            onLoad: true,
            onRemove: true
          };
        } else if (value === false) {
          value = {
            onLoad: false,
            onRemove: false
          };
        }

        this._convertEmptyParentToLeaf = value;
      },
      get: function get() {
        return this._convertEmptyParentToLeaf || {
          onLoad: false,
          onRemove: false
        };
      }
    }, {
      key: "parentIdField",
      set: function set(parentIdField) {
        // Maintainer: the "this" references in here reference two different contexts.
        // Outside of the property definition, it's the Model Class.
        // In the getter and setter, it's the record instance.
        this._parentIdField = parentIdField;
        Object.defineProperty(this.prototype, parentIdField, {
          set: function set(parentId) {
            // no arrow functions here, need `this` to change to instance
            // noinspection JSPotentiallyInvalidUsageOfClassThis
            this.parentId = parentId;
          },
          get: function get() {
            // no arrow functions here, need `this` to change to instance
            // noinspection JSPotentiallyInvalidUsageOfClassThis
            return this.parentId;
          }
        });
      },
      get: function get() {
        return this._parentIdField || 'parentId';
      }
    }]);

    return TreeNode;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_30__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/stm/Helpers.js":
/*!**************************************!*\
  !*** ./lib/Core/data/stm/Helpers.js ***!
  \**************************************/
/*! exports provided: resetQueue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetQueue", function() { return resetQueue; });
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Props.js */ "./lib/Core/data/stm/Props.js");


var productName = 'scheduler';

var resetQueue = function resetQueue(stm, options) {
  var undo = options.undo,
      redo = options.redo;
  var newProps;

  if (undo && !redo) {
    var _newProps;

    newProps = (_newProps = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_newProps, _Props_js__WEBPACK_IMPORTED_MODULE_2__["QUEUE_PROP"], stm[_Props_js__WEBPACK_IMPORTED_MODULE_2__["QUEUE_PROP"]].slice(stm.position)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_newProps, _Props_js__WEBPACK_IMPORTED_MODULE_2__["POS_PROP"], 0), _newProps);
  } else if (redo && !undo) {
    newProps = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_2__["QUEUE_PROP"], stm[_Props_js__WEBPACK_IMPORTED_MODULE_2__["QUEUE_PROP"]].slice(0, stm.position));
  } else {
    var _newProps3;

    newProps = (_newProps3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_newProps3, _Props_js__WEBPACK_IMPORTED_MODULE_2__["QUEUE_PROP"], []), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_newProps3, _Props_js__WEBPACK_IMPORTED_MODULE_2__["POS_PROP"], 0), _newProps3);
  }

  ;
  return [newProps, function () {
    stm.notifyStoresAboutQueueReset(options);
  }];
};

/***/ }),

/***/ "./lib/Core/data/stm/Props.js":
/*!************************************!*\
  !*** ./lib/Core/data/stm/Props.js ***!
  \************************************/
/*! exports provided: STATE_PROP, STORES_PROP, QUEUE_PROP, POS_PROP, TRANSACTION_PROP, TRANSACTION_TIMER_PROP, AUTO_RECORD_PROP, PROPS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATE_PROP", function() { return STATE_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORES_PROP", function() { return STORES_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUEUE_PROP", function() { return QUEUE_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POS_PROP", function() { return POS_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSACTION_PROP", function() { return TRANSACTION_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSACTION_TIMER_PROP", function() { return TRANSACTION_TIMER_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTO_RECORD_PROP", function() { return AUTO_RECORD_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROPS", function() { return PROPS; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);




var productName = 'scheduler';
/**
* @module Core/data/stm/Props.js
* @internal
*/

var STATE_PROP = Symbol('STATE_PROP');
var STORES_PROP = Symbol('STORES_PROP');
var QUEUE_PROP = Symbol('QUEUE_PROP');
var POS_PROP = Symbol('POS_PROP');
var TRANSACTION_PROP = Symbol('TRANSACTION_PROP');
var TRANSACTION_TIMER_PROP = Symbol('TRANSACTION_TIMER_PROP');
var AUTO_RECORD_PROP = Symbol('AUTO_RECORD_PROP');
var PROPS = Object.freeze([STATE_PROP, STORES_PROP, QUEUE_PROP, POS_PROP, TRANSACTION_PROP, TRANSACTION_TIMER_PROP, AUTO_RECORD_PROP]);

/***/ }),

/***/ "./lib/Core/data/stm/StateTrackingManager.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/StateTrackingManager.js ***!
  \***************************************************/
/*! exports provided: makeModelUpdateAction, makeModelInsertChildAction, makeModelRemoveChildAction, makeStoreModelAddAction, makeStoreModelInsertAction, makeStoreModelRemoveAction, makeStoreRemoveAllAction, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeModelUpdateAction", function() { return makeModelUpdateAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeModelInsertChildAction", function() { return makeModelInsertChildAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeModelRemoveChildAction", function() { return makeModelRemoveChildAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreModelAddAction", function() { return makeStoreModelAddAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreModelInsertAction", function() { return makeStoreModelInsertAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreModelRemoveAction", function() { return makeStoreModelRemoveAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreRemoveAllAction", function() { return makeStoreRemoveAllAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StateTrackingManager; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _state_StateBase_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./state/StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _state_DisabledState_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./state/DisabledState.js */ "./lib/Core/data/stm/state/DisabledState.js");
/* harmony import */ var _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./state/ReadyState.js */ "./lib/Core/data/stm/state/ReadyState.js");
/* harmony import */ var _state_RecordingState_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./state/RecordingState.js */ "./lib/Core/data/stm/state/RecordingState.js");
/* harmony import */ var _state_RestoringState_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./state/RestoringState.js */ "./lib/Core/data/stm/state/RestoringState.js");
/* harmony import */ var _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./state/AutoReadyState.js */ "./lib/Core/data/stm/state/AutoReadyState.js");
/* harmony import */ var _state_AutoRecordingState_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./state/AutoRecordingState.js */ "./lib/Core/data/stm/state/AutoRecordingState.js");
/* harmony import */ var _state_Registry_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./state/Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _action_UpdateAction_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./action/UpdateAction.js */ "./lib/Core/data/stm/action/UpdateAction.js");
/* harmony import */ var _action_InsertChildAction_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./action/InsertChildAction.js */ "./lib/Core/data/stm/action/InsertChildAction.js");
/* harmony import */ var _action_RemoveChildAction_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./action/RemoveChildAction.js */ "./lib/Core/data/stm/action/RemoveChildAction.js");
/* harmony import */ var _action_AddAction_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./action/AddAction.js */ "./lib/Core/data/stm/action/AddAction.js");
/* harmony import */ var _action_InsertAction_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./action/InsertAction.js */ "./lib/Core/data/stm/action/InsertAction.js");
/* harmony import */ var _action_RemoveAction_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./action/RemoveAction.js */ "./lib/Core/data/stm/action/RemoveAction.js");
/* harmony import */ var _action_RemoveAllAction_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./action/RemoveAllAction.js */ "./lib/Core/data/stm/action/RemoveAllAction.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./Props.js */ "./lib/Core/data/stm/Props.js");























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/StateTrackingManager
*/



















var makeModelUpdateAction = function makeModelUpdateAction(model, newData, oldData) {
  return new _action_UpdateAction_js__WEBPACK_IMPORTED_MODULE_32__["default"]({
    model: model,
    newData: newData,
    oldData: oldData
  });
};
var makeModelInsertChildAction = function makeModelInsertChildAction(parentModel, insertIndex, childModels, context) {
  return new _action_InsertChildAction_js__WEBPACK_IMPORTED_MODULE_33__["default"]({
    parentModel: parentModel,
    childModels: childModels,
    insertIndex: insertIndex,
    context: context
  });
};
var makeModelRemoveChildAction = function makeModelRemoveChildAction(parentModel, childModels, context) {
  return new _action_RemoveChildAction_js__WEBPACK_IMPORTED_MODULE_34__["default"]({
    parentModel: parentModel,
    childModels: childModels,
    context: context
  });
};
var makeStoreModelAddAction = function makeStoreModelAddAction(store, modelList, silent) {
  return new _action_AddAction_js__WEBPACK_IMPORTED_MODULE_35__["default"]({
    store: store,
    modelList: modelList,
    silent: silent
  });
};
var makeStoreModelInsertAction = function makeStoreModelInsertAction(store, insertIndex, modelList, context, silent) {
  return new _action_InsertAction_js__WEBPACK_IMPORTED_MODULE_36__["default"]({
    store: store,
    insertIndex: insertIndex,
    modelList: modelList,
    context: context,
    silent: silent
  });
};
var makeStoreModelRemoveAction = function makeStoreModelRemoveAction(store, modelList, context, silent) {
  return new _action_RemoveAction_js__WEBPACK_IMPORTED_MODULE_37__["default"]({
    store: store,
    modelList: modelList,
    context: context,
    silent: silent
  });
};
var makeStoreRemoveAllAction = function makeStoreRemoveAllAction(store, allRecords, silent) {
  return new _action_RemoveAllAction_js__WEBPACK_IMPORTED_MODULE_38__["default"]({
    store: store,
    allRecords: allRecords,
    silent: silent
  });
};

var stateTransition = function stateTransition(stm, event) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var newState = event.call.apply(event, [stm[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]], stm].concat(args));

  if (typeof newState === 'string') {
    stm[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_31__["default"].resolveStmState(newState);
  } else if (newState instanceof _state_StateBase_js__WEBPACK_IMPORTED_MODULE_24__["default"]) {
    stm[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]] = newState;
  } else if (Array.isArray(newState)) {
    var _newState = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_21___default()(newState, 2),
        state = _newState[0],
        next = _newState[1];

    if (typeof state === 'string') {
      stm[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_31__["default"].resolveStmState(state);
    } else if (state instanceof _state_StateBase_js__WEBPACK_IMPORTED_MODULE_24__["default"]) {
      stm[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]] = state;
    } else if (state && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20___default()(state) === 'object') {
      stm = Object.assign(stm, state);
      stm[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_31__["default"].resolveStmState(stm[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]]);
    }

    if (typeof next === 'function') {
      stateTransition.apply(void 0, [stm, next].concat(args));
    }
  } else if (newState && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20___default()(newState) === 'object') {
    stm = Object.assign(stm, newState);
    stm[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_31__["default"].resolveStmState(stm[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]]);
  }
};
/**
 * When enabled tracks state of every store registered via {@link #function-addStore}.
 * Use {@link #function-undo} / {@link #function-redo} method calls to restore state to a particular
 * point in time
 *
 * ```javascript
 * stm = new StateTrackingManager({
 *     autoRecord : true,
 *     listeners  : {
 *        'recordingstop' : () => {
 *            // your custom code to update undo/redo GUI controls
 *            updateUndoRedoControls();
 *        },
 *        'restoringstop' : ({ stm }) => {
 *            // your custom code to update undo/redo GUI controls
 *            updateUndoRedoControls();
 *        }
 *    },
 *    getTransactionTitle : (transaction) => {
 *        // your custom code to analyze the transaction and return custom transaction title
 *        const lastAction = transaction.queue[transaction.queue.length - 1];
 *
 *        if (lastAction instanceof AddAction) {
 *            let title = 'Add new record';
 *        }
 *
 *        return title;
 *    }
 * });
 *
 * stm.addStore(userStore);
 * stm.addStore(companyStore);
 * stm.addStore(otherStore);
 *
 * stm.enable();
 * ```
 *
 * @mixes Core/mixin/Events
 * @extends Core/Base
 */


var StateTrackingManager = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default()(StateTrackingManager, _Events);

  var _super = _createSuper(StateTrackingManager);

  function StateTrackingManager() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, StateTrackingManager);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(StateTrackingManager, [{
    key: "construct",
    value: function construct() {
      var _Object$assign, _get2;

      var me = this;
      Object.assign(me, (_Object$assign = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"], _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_26__["default"]), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_39__["STORES_PROP"], []), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_39__["QUEUE_PROP"], []), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_39__["POS_PROP"], 0), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_39__["TRANSACTION_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_39__["TRANSACTION_TIMER_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_39__["AUTO_RECORD_PROP"], false), _Object$assign));

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(StateTrackingManager.prototype), "construct", this)).call.apply(_get2, [this].concat(args));
    } // TODO: This destroys the current state, which makes successive tests fail. Not sure what should be done
    // doDestroy() {
    //     super.doDestroy();
    //     this.destroyProperties(STATE_PROP);
    // }

    /**
     * Gets current state of the manager
     *
     * @return {Core.data.stm.state.StateBase}
     */

  }, {
    key: "hasStore",

    /**
     * Checks if a store has been added to the manager
     *
     * @param  {Core.data.Store} store
     * @return {Boolean}
     */
    value: function hasStore(store) {
      return this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STORES_PROP"]].includes(store);
    }
    /**
     * Adds a store to the manager
     *
     * @param {Core.data.Store} store
     */

  }, {
    key: "addStore",
    value: function addStore(store) {
      if (!this.hasStore(store)) {
        this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STORES_PROP"]].push(store);
        store.stm = this;
      }
    }
    /**
     * Removes a store from the manager
     *
     * @param {Core.data.Store} store
     */

  }, {
    key: "removeStore",
    value: function removeStore(store) {
      if (this.hasStore(store)) {
        this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STORES_PROP"]] = this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STORES_PROP"]].filter(function (s) {
          return s !== store;
        });
        store.stm = null;
      }
    }
    /**
     * Calls `fn` for each store registered in STM.
     *
     * @param {Function} fn (store, id) => ...
     */

  }, {
    key: "forEachStore",
    value: function forEachStore(fn) {
      this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STORES_PROP"]].forEach(function (s) {
        return fn(s, s.id);
      });
    }
    /**
     * Get/set manager disabled state
     *
     * @property {Boolean}
     */

  }, {
    key: "enable",

    /**
     * Enables manager
     */
    value: function enable() {
      this.disabled = false;
    }
    /**
     * Disables manager
     */

  }, {
    key: "disable",
    value: function disable() {
      this.disabled = true;
    }
    /**
     * Checks manager ready state
     *
     * @return {Boolean}
     */

  }, {
    key: "startTransaction",

    /**
     * Starts undo/redo recording transaction.
     *
     * @param {String} [title=nul]
     */
    value: function startTransaction() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      stateTransition(this, this.state.onStartTransaction, title);
    }
    /**
     * Stops undo/redo recording transaction
     *
     * @param {String} [title=null]
     */

  }, {
    key: "stopTransaction",
    value: function stopTransaction() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      stateTransition(this, this.state.onStopTransaction, title);
    }
    /**
     * Stops undo/redo recording transaction after {@link #config-autoRecordTransactionStopTimeout} delay.
     *
     * @private
     */

  }, {
    key: "stopTransactionDelayed",
    value: function stopTransactionDelayed() {
      stateTransition(this, this.state.onStopTransactionDelayed);
    }
    /**
     * Rejects currently recorded transaction.
     */

  }, {
    key: "rejectTransaction",
    value: function rejectTransaction() {
      stateTransition(this, this.state.onRejectTransaction);
    }
    /**
     * Gets currently recording STM transaction.
     *
     * @return {Core.data.stm.Transaction}
     */

  }, {
    key: "undo",

    /**
     * Undoes current undo/redo transaction.
     *
     * @param {Number} [steps=1]
     */
    value: function undo() {
      var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      stateTransition(this, this.state.onUndo, steps);
    }
    /**
     * Undoes all transactions.
     */

  }, {
    key: "undoAll",
    value: function undoAll() {
      this.undo(this.length);
    }
    /**
     * Redoes current undo/redo transaction.
     *
     * @param {Number} [steps=1]
     */

  }, {
    key: "redo",
    value: function redo() {
      var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      stateTransition(this, this.state.onRedo, steps);
    }
    /**
     * Redoes all transactions.
     */

  }, {
    key: "redoAll",
    value: function redoAll() {
      this.redo(this.length);
    }
    /**
     * Resets undo/redo queue.
     */

  }, {
    key: "resetQueue",
    value: function resetQueue() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        undo: true,
        redo: true
      };
      stateTransition(this, this.state.onResetQueue, options);
    }
    /**
     * Resets undo queue.
     */

  }, {
    key: "resetUndoQueue",
    value: function resetUndoQueue() {
      this.resetQueue({
        undo: true
      });
    }
    /**
     * Resets redo queue.
     */

  }, {
    key: "resetRedoQueue",
    value: function resetRedoQueue() {
      this.resetQueue({
        redo: true
      });
    }
  }, {
    key: "notifyStoresAboutStateRecordingStart",
    value: function notifyStoresAboutStateRecordingStart(transaction) {
      var _this = this;

      this.forEachStore(function (store) {
        store.onStmRecordingStart && store.onStmRecordingStart(_this, transaction);
      });
      /**
       * Fired upon state recording operation starts.
       *
       * @event recordingStart
       * @param {Core.data.stm.StateTrackingManager} stm
       * @param {Core.data.stm.Transaction} transaction
       */

      this.trigger('recordingStart', {
        stm: this,
        transaction: transaction
      });
    }
  }, {
    key: "notifyStoresAboutStateRecordingStop",
    value: function notifyStoresAboutStateRecordingStop(transaction, reason) {
      var _this2 = this;

      this.forEachStore(function (store) {
        store.onStmRecordingStop && store.onStmRecordingStop(_this2, transaction, reason);
      });
      /**
       * Fired upon state recording operation stops.
       *
       * @event recordingStop
       * @param {Core.data.stm.StateTrackingManager} stm
       * @param {Core.data.stm.Transaction} transaction
       * @param {Object} reason Transaction stop reason
       * @param {Boolean} reason.stop Transaction recording has been stopped in a normal way.
       * @param {Boolean} reason.disabled Transaction recording has been stopped due to STM has been disabled.
       * @param {Boolean} reason.rejected Transaction recording has been stopped due to transaction has been rejected.
       */

      this.trigger('recordingStop', {
        stm: this,
        transaction: transaction,
        reason: reason
      });
    }
  }, {
    key: "notifyStoresAboutStateRestoringStart",
    value: function notifyStoresAboutStateRestoringStart() {
      var _this3 = this;

      this.forEachStore(function (store) {
        store.onStmRestoringStart && store.onStmRestoringStart(_this3);
      });
      /**
       * Fired upon state restoration operation starts.
       *
       * @event restoringStart
       * @param {Core.data.stm.StateTrackingManager} stm
       */

      this.trigger('restoringStart', {
        stm: this
      });
    }
  }, {
    key: "notifyStoresAboutStateRestoringStop",
    value: function notifyStoresAboutStateRestoringStop() {
      var _this4 = this;

      this.forEachStore(function (store) {
        store.onStmRestoringStop && store.onStmRestoringStop(_this4);
      });
      /**
       * Fired upon state restoration operation stops.
       *
       * @event restoringStop
       * @param {Core.data.stm.StateTrackingManager} stm
       */

      this.trigger('restoringStop', {
        stm: this
      });
    }
  }, {
    key: "notifyStoresAboutQueueReset",
    value: function notifyStoresAboutQueueReset(options) {
      var _this5 = this;

      this.forEachStore(function (store) {
        store.onStmQueueReset && store.onStmQueueReset(_this5, options);
      });
      /**
       * Fired upon state undo/redo queue reset.
       *
       * @event queueReset
       * @param {Core.data.stm.StateTrackingManager} stm
       */

      this.trigger('queueReset', {
        stm: this,
        options: options
      });
    }
    /**
     * Method to call from model STM mixin upon model update
     *
     * @param {Core.data.Model} model
     * @param {Object} newData
     * @param {Object} oldData
     *
     * @private
     */

  }, {
    key: "onModelUpdate",
    value: function onModelUpdate(model, newData, oldData) {
      stateTransition(this, this.state.onModelUpdate, model, newData, oldData);
    }
    /**
     * Method to call from model STM mixin upon tree model child insertion
     *
     * @param {Core.data.Model} parentModel Parent model
     * @param {Number} index Insertion index
     * @param {Core.data.Model[]} childModels Array of models inserted
     * @param {Map} context Map with inserted models as keys and objects with previous parent,
     *                      and index at previous parent.
     *
     * @private
     */

  }, {
    key: "onModelInsertChild",
    value: function onModelInsertChild(parentModel, index, childModels, context) {
      stateTransition(this, this.state.onModelInsertChild, parentModel, index, childModels, context);
    }
    /**
     * Method to call from model STM mixin upon tree model child removal
     *
     * @param {Core.data.Model} parentModel
     * @param {Core.data.Model[]} childModels
     * @param {Map} context
     *
     * @private
     */

  }, {
    key: "onModelRemoveChild",
    value: function onModelRemoveChild(parentModel, childModels, context) {
      stateTransition(this, this.state.onModelRemoveChild, parentModel, childModels, context);
    }
    /**
     * Method to call from store STM mixin upon store models adding
     *
     * @param {Core.data.Store} store
     * @param {Core.data.Model[]} models
     * @param {Boolean} silent
     *
     * @private
     */

  }, {
    key: "onStoreModelAdd",
    value: function onStoreModelAdd(store, models, silent) {
      stateTransition(this, this.state.onStoreModelAdd, store, models, silent);
    }
    /**
     * Method to call from store STM mixin upon store models insertion
     *
     * @param {Core.data.Store} store
     * @param {Number} index
     * @param {Core.data.Model[]} models
     * @param {Map} context
     * @param {Boolean} silent
     *
     * @private
     */

  }, {
    key: "onStoreModelInsert",
    value: function onStoreModelInsert(store, index, models, context, silent) {
      stateTransition(this, this.state.onStoreModelInsert, store, index, models, context, silent);
    }
    /**
     * Method to call from store STM mixin upon store models removal
     *
     * @param {Core.data.Store} store
     * @param {Core.data.Model[]} models
     * @param {Object} context
     * @param {Boolean} silent
     *
     * @private
     */

  }, {
    key: "onStoreModelRemove",
    value: function onStoreModelRemove(store, models, context, silent) {
      stateTransition(this, this.state.onStoreModelRemove, store, models, context, silent);
    }
    /**
     * Method to call from store STM mixin upon store clear
     *
     * @param {Core.data.Store} store
     * @param {Core.data.Model[]} allRecords
     * @param {Boolean} silent
     *
     * @private
     */

  }, {
    key: "onStoreRemoveAll",
    value: function onStoreRemoveAll(store, allRecords, silent) {
      stateTransition(this, this.state.onStoreRemoveAll, store, allRecords, silent);
    }
  }, {
    key: "state",
    get: function get() {
      return this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STATE_PROP"]];
    }
    /**
     * Gets current undo/redo queue position
     *
     * @return {Number}
     */

  }, {
    key: "position",
    get: function get() {
      return this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["POS_PROP"]];
    }
    /**
     * Gets current undo/redo queue length
     *
     * @return {Number}
     */

  }, {
    key: "length",
    get: function get() {
      return this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["QUEUE_PROP"]].length;
    }
    /**
     * Gets all the stores registered in STM
     *
     * @return {Core.data.Store[]}
     */

  }, {
    key: "stores",
    get: function get() {
      return Array.from(this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["STORES_PROP"]]);
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.state === _state_DisabledState_js__WEBPACK_IMPORTED_MODULE_25__["default"];
    },
    set: function set(val) {
      var me = this;

      if (me.disabled != val) {
        if (val) {
          stateTransition(me, me.state.onDisable, me);
        } else {
          stateTransition(me, me.state.onEnable, me);
        }

        me.trigger('stmDisabled', {
          disabled: val
        });
        /**
         * Fired when the disabled state of the STM changes
         *
         * @event disabled
         * @param {Core.data.stm.StateTrackingManager} source
         * @param {Boolean} disabled The current disabled state of the STM
         */

        me.trigger('disabled', {
          disabled: val
        });
      }
    }
  }, {
    key: "isReady",
    get: function get() {
      return this.state === _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_26__["default"] || this.state === _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_29__["default"];
    }
    /**
     * Checks manager recording state
     *
     * @return {Boolean}
     */

  }, {
    key: "isRecording",
    get: function get() {
      return this.state === _state_RecordingState_js__WEBPACK_IMPORTED_MODULE_27__["default"] || this.state === _state_AutoRecordingState_js__WEBPACK_IMPORTED_MODULE_30__["default"];
    }
    /**
     * Gets/sets manager auto record option
     *
     * @property {Boolean}
     */

  }, {
    key: "autoRecord",
    get: function get() {
      return this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["AUTO_RECORD_PROP"]];
    },
    set: function set(value) {
      var me = this;

      if (me.autoRecord != value) {
        if (value) {
          stateTransition(me, me.state.onAutoRecordOn, me);
        } else {
          stateTransition(me, me.state.onAutoRecordOff, me);
        }
      }
    }
  }, {
    key: "transaction",
    get: function get() {
      return this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["TRANSACTION_PROP"]];
    }
    /**
     * Gets titles of all recorded undo/redo transactions
     *
     * @return {String[]}
     */

  }, {
    key: "queue",
    get: function get() {
      return this[_Props_js__WEBPACK_IMPORTED_MODULE_39__["QUEUE_PROP"]].map(function (t) {
        return t.title;
      });
    }
    /**
     * Gets manager restoring state.
     *
     * @return {Boolean}
     */

  }, {
    key: "isRestoring",
    get: function get() {
      return this.state === _state_RestoringState_js__WEBPACK_IMPORTED_MODULE_28__["default"];
    }
    /**
     * Checks if the manager can undo.
     *
     * @return {Boolean}
     */

  }, {
    key: "canUndo",
    get: function get() {
      return this.state.canUndo(this);
    }
    /**
     * Checks if the manager can redo.
     *
     * @return {Boolean}
     */

  }, {
    key: "canRedo",
    get: function get() {
      return this.state.canRedo(this);
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Default manager disabled state
         *
         * @config {Boolean}
         * @default
         */
        disabled: true,

        /**
         * Whether to start transaction recording automatically in case the Manager is enabled.
         *
         * In the auto recording mode, the manager waits for the first change in any store being managed and starts a transaction, i.e.
         * records any changes in its monitored stores. The transaction lasts for {@link #config-autoRecordTransactionStopTimeout} and
         * afterwards creates one undo/redo step, including all changes in the stores during that period of time.
         *
         * In non auto recording mode you have to call {@link #function-startTransaction} / {@link #function-stopTransaction} to start and end
         * a transaction.
         *
         * @config {Boolean}
         * @default
         */
        autoRecord: false,

        /**
         * The transaction duration (in ms) for the auto recording mode {@link #config-autoRecord}
         *
         * @config {Number}
         * @default
         */
        autoRecordTransactionStopTimeout: 100,

        /**
         * Store model update action factory
         *
         * @config {Function}
         * @default
         * @private
         */
        makeModelUpdateAction: makeModelUpdateAction,

        /**
         * Store insert child model action factory.
         *
         * @config {Function}
         * @default
         * @private
         */
        makeModelInsertChildAction: makeModelInsertChildAction,

        /**
         * Store remove child model action factory.
         *
         * @config {Function}
         * @default
         * @private
         */
        makeModelRemoveChildAction: makeModelRemoveChildAction,

        /**
         * Store add model action factory.
         *
         * @config {Function}
         * @default
         * @private
         */
        makeStoreModelAddAction: makeStoreModelAddAction,

        /**
         * Store insert model action factory.
         *
         * @config {Function}
         * @default
         * @private
         */
        makeStoreModelInsertAction: makeStoreModelInsertAction,

        /**
         * Store remove model action factory.
         *
         * @config {Function}
         * @default
         * @private
         */
        makeStoreModelRemoveAction: makeStoreModelRemoveAction,

        /**
         * Store remove all models action factory.
         *
         * @config {Function}
         * @default
         * @private
         */
        makeStoreRemoveAllAction: makeStoreRemoveAllAction,

        /**
         * Function to create a transaction title if none is provided.
         *
         * The function receives a transaction and should return a title.
         *
         * @config {Function}
         * @default
         */
        getTransactionTitle: null
      };
    }
  }]);

  return StateTrackingManager;
}(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_23__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_22__["default"]));


StateTrackingManager._$name = 'StateTrackingManager';

/***/ }),

/***/ "./lib/Core/data/stm/Transaction.js":
/*!******************************************!*\
  !*** ./lib/Core/data/stm/Transaction.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Transaction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/Transaction
*/


var ACTION_QUEUE_PROP = Symbol('ACTION_QUEUE_PROP');
/**
 * STM transaction class, holds list of actions constituting a transaction.
 *
 * A transaction can be undone and redone. Upon undo all the actions being held
 * are undone in reverse order. Upon redo all the actions being held are redone
 * in forward order.
 */

var Transaction = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(Transaction, _Base);

  var _super = _createSuper(Transaction);

  function Transaction() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Transaction);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Transaction, [{
    key: "construct",
    value: function construct() {
      var _get2;

      this[ACTION_QUEUE_PROP] = [];

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Transaction.prototype), "construct", this)).call.apply(_get2, [this].concat(args));
    }
    /**
     * Gets transaction's actions queue
     *
     * @property {Core.data.stm.action.ActionBase[]}
     */

  }, {
    key: "addAction",

    /**
     * Adds an action to the transaction.
     *
     * @param {Core.data.stm.action.ActionBase|Object} action
     */
    value: function addAction(action) {
      this[ACTION_QUEUE_PROP].push(action);
    }
    /**
     * Undoes actions held
     */

  }, {
    key: "undo",
    value: function undo() {
      var queue = this[ACTION_QUEUE_PROP];

      for (var i = queue.length - 1; i >= 0; --i) {
        queue[i].undo();
      }
    }
    /**
     * Redoes actions held
     */

  }, {
    key: "redo",
    value: function redo() {
      var queue = this[ACTION_QUEUE_PROP];

      for (var i = 0, len = queue.length; i < len; ++i) {
        queue[i].redo();
      }
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Transaction title
         *
         * @config {String}
         * @default
         */
        title: null
      };
    }
  }, {
    key: "queue",
    get: function get() {
      return this[ACTION_QUEUE_PROP].slice(0);
    }
    /**
     * Gets transaction's actions queue length
     *
     * @property {Number}
     */

  }, {
    key: "length",
    get: function get() {
      return this[ACTION_QUEUE_PROP].length;
    }
  }]);

  return Transaction;
}(_Base_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


Transaction._$name = 'Transaction';

/***/ }),

/***/ "./lib/Core/data/stm/action/ActionBase.js":
/*!************************************************!*\
  !*** ./lib/Core/data/stm/action/ActionBase.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ActionBase; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/action/ActionBase
*/



var throwAbstractMethodCall = function throwAbstractMethodCall() {
  throw new Error('Abstract method call!');
};
/**
 * Base class for STM actions.
 *
 * @abstract
 */


var ActionBase = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ActionBase, _Base);

  var _super = _createSuper(ActionBase);

  function ActionBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ActionBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ActionBase, [{
    key: "undo",

    /**
     * Undoes an action
     */
    value: function undo() {
      throwAbstractMethodCall();
    }
    /**
     * Redoes an action
     */

  }, {
    key: "redo",
    value: function redo() {
      throwAbstractMethodCall();
    }
  }, {
    key: "type",

    /**
     * Gets the type of the action (stringified class name).
     *
     * @return {String}
     */
    get: function get() {
      return this.constructor.name;
    }
  }]);

  return ActionBase;
}(_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


ActionBase._$name = 'ActionBase';

/***/ }),

/***/ "./lib/Core/data/stm/action/AddAction.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/stm/action/AddAction.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AddAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/data/stm/action/AddAction
 */

var STORE_PROP = Symbol('STORE_PROP');
var MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
/**
 * Action to record the fact of models adding to a store.
 */

var AddAction = /*#__PURE__*/function (_ActionBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AddAction, _ActionBase);

  var _super = _createSuper(AddAction);

  function AddAction() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, AddAction);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(AddAction, [{
    key: "undo",
    value: function undo() {
      var me = this;
      me.store.remove(me.modelList, me.silent);
    }
  }, {
    key: "redo",
    value: function redo() {
      var me = this;
      me.store.add(me.modelList, me.silent);
    }
  }, {
    key: "type",
    get: function get() {
      return 'AddAction';
    }
  }, {
    key: "store",
    get: function get() {
      return this[STORE_PROP];
    },
    set: function set(store) {
      this[STORE_PROP] = store;
    }
  }, {
    key: "modelList",
    get: function get() {
      return this[MODEL_LIST_PROP];
    },
    set: function set(list) {
      this[MODEL_LIST_PROP] = list.slice(0);
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Reference to a store models have been added into.
         *
         * @config {Core.data.Store}
         * @default
         */
        store: undefined,

        /**
         * List of models added into the store.
         *
         * @config {Core.data.Model[]}
         * @default
         */
        modelList: undefined,

        /**
         * Flag showing if undo/redo should be done silently i.e. with events suppressed
         *
         * @config {Boolean}
         * @default
         */
        silent: false
      };
    }
  }]);

  return AddAction;
}(_ActionBase_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


AddAction._$name = 'AddAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/InsertAction.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/action/InsertAction.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InsertAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/data/stm/action/InsertAction
 */

var STORE_PROP = Symbol('STORE_PROP');
var MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
var INSERT_INDEX_PROP = Symbol('INSERT_INDEX_PROP');
var CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record the fact of models inserting into a store.
 */

var InsertAction = /*#__PURE__*/function (_ActionBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(InsertAction, _ActionBase);

  var _super = _createSuper(InsertAction);

  function InsertAction() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, InsertAction);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(InsertAction, [{
    key: "undo",
    value: function undo() {
      var store = this.store,
          modelList = this.modelList,
          context = this.context,
          silent = this.silent; // Let's sort models by index such that models with lesser index
      // were inserted back first, thus making valid index of models following.

      modelList.sort(function (lhs, rhs) {
        var lhsIndex = context.get(lhs),
            rhsIndex = context.get(rhs);
        return lhsIndex !== undefined && rhsIndex !== undefined ? lhsIndex - rhsIndex : 0;
      });
      modelList.forEach(function (m) {
        var index = context.get(m); // Flag the inserted record that we undo to skip adding it to "store.removed"

        m._undoingInsertion = true;

        if (index !== undefined) {
          // Insert at previous index
          store.insert(index, m, silent);
        } else {
          // Just remove
          store.remove(m, silent);
        }

        m._undoingInsertion = false;
      });
    }
  }, {
    key: "redo",
    value: function redo() {
      var me = this;
      me.store.insert(me.insertIndex, me.modelList, me.silent);
    }
  }, {
    key: "type",
    get: function get() {
      return 'InsertAction';
    }
  }, {
    key: "store",
    get: function get() {
      return this[STORE_PROP];
    },
    set: function set(store) {
      this[STORE_PROP] = store;
    }
  }, {
    key: "modelList",
    get: function get() {
      return this[MODEL_LIST_PROP];
    },
    set: function set(list) {
      this[MODEL_LIST_PROP] = list.slice(0);
    }
  }, {
    key: "insertIndex",
    get: function get() {
      return this[INSERT_INDEX_PROP];
    },
    set: function set(index) {
      this[INSERT_INDEX_PROP] = index;
    }
  }, {
    key: "context",
    get: function get() {
      return this[CONTEXT_PROP];
    },
    set: function set(context) {
      this[CONTEXT_PROP] = context;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Reference to a store models have been inserted into.
         *
         * @config {Core.data.Store}
         * @default
         */
        store: undefined,

        /**
         * List of models inserted into the store.
         *
         * @config {Core.data.Model[]}
         * @default
         */
        modelList: undefined,

        /**
         * Index the models have been inserted at.
         *
         * @config {Number}
         * @default
         */
        insertIndex: undefined,

        /**
         * Models move context (if models has been moved), if any.
         * Map this {@link Core/data/Model} instances as keys and their
         * previous index as values
         *
         * @config {Map}
         * @default
         */
        context: undefined,

        /**
         * Flag showing if undo/redo should be done silently i.e. with events suppressed
         *
         * @config {Boolean}
         * @default
         */
        silent: false
      };
    }
  }]);

  return InsertAction;
}(_ActionBase_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


InsertAction._$name = 'InsertAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/InsertChildAction.js":
/*!*******************************************************!*\
  !*** ./lib/Core/data/stm/action/InsertChildAction.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InsertChildAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/action/InsertChildAction
*/


var PARENT_MODEL_PROP = Symbol('PARENT_MODEL_PROP');
var CHILD_MODELS_PROP = Symbol('CHILD_MODELS_PROP');
var INSERT_INDEX_PROP = Symbol('INSERT_INDEX_PROP');
var CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record the fact of adding a children models into a parent model.
 */

var InsertChildAction = /*#__PURE__*/function (_ActionBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(InsertChildAction, _ActionBase);

  var _super = _createSuper(InsertChildAction);

  function InsertChildAction() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, InsertChildAction);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(InsertChildAction, [{
    key: "undo",
    value: function undo() {
      var parentModel = this.parentModel,
          context = this.context,
          childModels = this.childModels; // Let's sort models by parent index such that models with lesser index
      // were inserted back first, thus making valid parent index of models following.

      childModels.sort(function (lhs, rhs) {
        var _ref = context.get(lhs) || {},
            lhsParent = _ref.lhsParent,
            lhsIndex = _ref.lhsIndex,
            _ref2 = context.get(rhs) || {},
            rhsParent = _ref2.rhsParent,
            rhsIndex = _ref2.rhsIndex;

        return lhsParent && lhsParent === rhsParent ? lhsIndex - rhsIndex : 0;
      }); // Now let's re-insert records back to where they were or remove them
      // if they weren't anywhere

      childModels.forEach(function (m) {
        var _ref3 = context.get(m) || {},
            parent = _ref3.parent,
            index = _ref3.index;

        if (parent) {
          // If we move within same parent then index must be adjusted
          if (parent === parentModel) {
            var adjustedIndex; // we need to increment index if the node was moved up

            adjustedIndex = index > m.parentIndex ? index + 1 : index; // null index if we need to move to the end

            adjustedIndex = index === parent.children.length - 1 ? null : adjustedIndex; // if insertBefore is undefined the node will be appended to the end

            var insertBefore = parent.children[adjustedIndex];
            parent.insertChild(m, insertBefore);
          } else {
            // Insert at previous index
            parent.insertChild(m, parent.children[index]);
          }
        } else {
          // Just remove
          parentModel.removeChild(m);
        }
      });
    }
  }, {
    key: "redo",
    value: function redo() {
      var parentModel = this.parentModel,
          insertIndex = this.insertIndex,
          childModels = this.childModels,
          insertBefore = parentModel.children[insertIndex];
      parentModel.insertChild(childModels, insertBefore);
    }
  }, {
    key: "type",
    get: function get() {
      return 'InsertChildAction';
    }
  }, {
    key: "parentModel",
    get: function get() {
      return this[PARENT_MODEL_PROP];
    },
    set: function set(model) {
      this[PARENT_MODEL_PROP] = model;
    }
  }, {
    key: "childModels",
    get: function get() {
      return this[CHILD_MODELS_PROP];
    },
    set: function set(models) {
      this[CHILD_MODELS_PROP] = models.slice(0);
    }
  }, {
    key: "insertIndex",
    get: function get() {
      return this[INSERT_INDEX_PROP];
    },
    set: function set(index) {
      this[INSERT_INDEX_PROP] = index;
    }
  }, {
    key: "context",
    get: function get() {
      return this[CONTEXT_PROP];
    },
    set: function set(ctx) {
      this[CONTEXT_PROP] = ctx;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Reference to a parent model a child model has been added to.
         *
         * @config {Core.data.Model}
         * @default
         */
        parentModel: undefined,

        /**
         * Children models inserted.
         *
         * @config {Core.data.Model[]}
         * @default
         */
        childModels: undefined,

        /**
         * Index a children models are inserted at
         *
         * @config {Number}
         * @default
         */
        insertIndex: undefined,

        /**
         * Map having children models as keys and values containing previous parent
         * of each model and index at the previous parent.
         *
         * @config {Object}
         * @default
         */
        context: undefined
      };
    }
  }]);

  return InsertChildAction;
}(_ActionBase_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


InsertChildAction._$name = 'InsertChildAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/RemoveAction.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/action/RemoveAction.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RemoveAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/action/RemoveAction
*/



var STORE_PROP = Symbol('STORE_PROP');
var MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
var CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record the fact of models removed from a store.
 */

var RemoveAction = /*#__PURE__*/function (_ActionBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(RemoveAction, _ActionBase);

  var _super = _createSuper(RemoveAction);

  function RemoveAction() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, RemoveAction);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(RemoveAction, [{
    key: "undo",
    value: function undo() {
      var store = this.store,
          context = this.context,
          modelList = this.modelList,
          silent = this.silent; // Let's sort models by index such that models with lesser index
      // were inserted back first, thus making valid index of models following.

      modelList.sort(function (lhs, rhs) {
        var lhsIndex = context.get(lhs),
            rhsIndex = context.get(rhs); // Here, in contrast to InsertAction, index is always present

        return lhsIndex - rhsIndex;
      });
      modelList.forEach(function (m) {
        var index = context.get(m); // Insert at previous index

        store.insert(index, m, silent);
      });
    }
  }, {
    key: "redo",
    value: function redo() {
      var me = this;
      me.store.remove(me.modelList, me.silent);
    }
  }, {
    key: "type",
    get: function get() {
      return 'RemoveAction';
    }
  }, {
    key: "store",
    get: function get() {
      return this[STORE_PROP];
    },
    set: function set(store) {
      this[STORE_PROP] = store;
    }
  }, {
    key: "modelList",
    get: function get() {
      return this[MODEL_LIST_PROP];
    },
    set: function set(list) {
      this[MODEL_LIST_PROP] = list.slice(0);
    }
  }, {
    key: "context",
    get: function get() {
      return this[CONTEXT_PROP];
    },
    set: function set(context) {
      this[CONTEXT_PROP] = context;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Reference to a store models have been removed from.
         *
         * @config {Core.data.Store}
         * @default
         */
        store: undefined,

        /**
         * List of models removed from the store.
         *
         * @config {Core.data.Model[]}
         * @default
         */
        modelList: undefined,

        /**
         * Models removing context.
         *
         * @config {Object}
         * @default
         */
        context: undefined,

        /**
         * Flag showing if undo/redo should be done silently i.e. with events suppressed
         *
         * @config {Boolean}
         * @default
         */
        silent: false
      };
    }
  }]);

  return RemoveAction;
}(_ActionBase_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


RemoveAction._$name = 'RemoveAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/RemoveAllAction.js":
/*!*****************************************************!*\
  !*** ./lib/Core/data/stm/action/RemoveAllAction.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RemoveAllAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/action/RemoveAllAction
*/



var STORE_PROP = Symbol('STORE_PROP');
var ALL_RECORDS_PROP = Symbol('ALL_RECORDS_PROP');
/**
 * Action to record store remove all operation.
 */

var RemoveAllAction = /*#__PURE__*/function (_ActionBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(RemoveAllAction, _ActionBase);

  var _super = _createSuper(RemoveAllAction);

  function RemoveAllAction() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, RemoveAllAction);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(RemoveAllAction, [{
    key: "undo",
    value: function undo() {
      var store = this.store,
          allRecords = this.allRecords,
          silent = this.silent;
      store.add(allRecords, silent);
    }
  }, {
    key: "redo",
    value: function redo() {
      var me = this;
      me.store.removeAll(me.silent);
    }
  }, {
    key: "type",
    get: function get() {
      return 'RemoveAllAction';
    }
  }, {
    key: "store",
    get: function get() {
      return this[STORE_PROP];
    },
    set: function set(store) {
      this[STORE_PROP] = store;
    }
  }, {
    key: "allRecords",
    get: function get() {
      return this[ALL_RECORDS_PROP];
    },
    set: function set(records) {
      this[ALL_RECORDS_PROP] = records.slice(0);
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Reference to a store cleared.
         *
         * @config {Core.data.Store}
         * @default
         */
        store: undefined,

        /**
         * All store records removed
         *
         * @config {Core.data.Model[]}
         * @default
         */
        allRecords: undefined,

        /**
         * Flag showing if undo/redo should be done silently i.e. with events suppressed
         *
         * @config {Boolean}
         * @default
         */
        silent: false
      };
    }
  }]);

  return RemoveAllAction;
}(_ActionBase_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


RemoveAllAction._$name = 'RemoveAllAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/RemoveChildAction.js":
/*!*******************************************************!*\
  !*** ./lib/Core/data/stm/action/RemoveChildAction.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RemoveChildAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var PARENT_MODEL_PROP = Symbol('PARENT_MODEL_PROP');
var CHILD_MODELS_PROP = Symbol('CHILD_MODELS_PROP');
var CONTEXT_PROP = Symbol('CONTEXT_PROP');

var RemoveChildAction = /*#__PURE__*/function (_ActionBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(RemoveChildAction, _ActionBase);

  var _super = _createSuper(RemoveChildAction);

  function RemoveChildAction() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, RemoveChildAction);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(RemoveChildAction, [{
    key: "undo",
    value: function undo() {
      var parentModel = this.parentModel,
          context = this.context,
          childModels = this.childModels; // Let's sort models by parent index such that models with lesser index
      // were inserted back first, thus making valid parent index of models following.

      childModels.sort(function (lhs, rhs) {
        var lhsIndex = context.get(lhs),
            rhsIndex = context.get(rhs);
        return lhsIndex - rhsIndex;
      }); // Now let's re-insert records back to where they were

      childModels.forEach(function (m) {
        parentModel.insertChild(context.get(m), m);
      });
    }
  }, {
    key: "redo",
    value: function redo() {
      this.parentModel.removeChild(this.childModels);
    }
  }, {
    key: "type",
    get: function get() {
      return 'RemoveChildAction';
    }
  }, {
    key: "parentModel",
    get: function get() {
      return this[PARENT_MODEL_PROP];
    },
    set: function set(model) {
      this[PARENT_MODEL_PROP] = model;
    }
  }, {
    key: "childModels",
    get: function get() {
      return this[CHILD_MODELS_PROP];
    },
    set: function set(models) {
      this[CHILD_MODELS_PROP] = models.slice(0);
    }
  }, {
    key: "context",
    get: function get() {
      return this[CONTEXT_PROP];
    },
    set: function set(ctx) {
      this[CONTEXT_PROP] = ctx;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Reference to a parent model a child model has been removed to.
         *
         * @config {Core.data.Model}
         * @default
         */
        parentModel: undefined,

        /**
         * Children models removed.
         *
         * @config {Core.data.Model[]}
         * @default
         */
        childModels: undefined,

        /**
         * Map having children models as keys and values containing previous parent
         * index at the parent.
         *
         * @config {Object}
         * @default
         */
        context: undefined
      };
    }
  }]);

  return RemoveChildAction;
}(_ActionBase_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


RemoveChildAction._$name = 'RemoveChildAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/UpdateAction.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/action/UpdateAction.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UpdateAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/action/UpdateAction
*/


var MODEL_PROP = Symbol('MODEL_PROP');
var NEW_DATA_PROP = Symbol('NEW_DATA_PROP');
var OLD_DATA_PROP = Symbol('OLD_DATA_PROP');
/**
 * Action to record the fact that a model has been updated.
 */

var UpdateAction = /*#__PURE__*/function (_ActionBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(UpdateAction, _ActionBase);

  var _super = _createSuper(UpdateAction);

  function UpdateAction() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, UpdateAction);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(UpdateAction, [{
    key: "undo",
    value: function undo() {
      // it seems STM has to use `model.set()` because of `model.inSet` overrides or smth
      // w/o this call, just with `Object.assign()` below, the view is not refreshed
      // Since invoking accessor will just forward change to the engine, we need to pass `skipAccessors = true`
      // to this call to make this change on data level. Engine will be updated below.
      // Covered by TaskEdit.t `autoSync` subtest
      this.model.set(this.oldData, null, null, null, true); // in the same time, engine needs the setters to be activated, since there's some
      // additional logic (for example, invalidate dispatcher)
      // This will make change in the engine

      if (this.model.$) {
        Object.assign(this.model, this.oldData);
      }
    }
  }, {
    key: "redo",
    value: function redo() {
      this.model.set(this.newData, null, null, null, true); // see comments above

      if (this.model.$) {
        Object.assign(this.model, this.newData);
      }
    }
  }, {
    key: "type",
    get: function get() {
      return 'UpdateAction';
    }
  }, {
    key: "model",
    get: function get() {
      return this[MODEL_PROP];
    },
    set: function set(value) {
      this[MODEL_PROP] = value;
    }
  }, {
    key: "newData",
    get: function get() {
      return this[NEW_DATA_PROP];
    },
    set: function set(value) {
      this[NEW_DATA_PROP] = Object.assign({}, value);
    }
  }, {
    key: "oldData",
    get: function get() {
      return this[OLD_DATA_PROP];
    },
    set: function set(value) {
      this[OLD_DATA_PROP] = Object.assign({}, value);
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Reference to a model which has been updated.
         *
         * @config {Core.data.Model}
         * @default
         */
        model: undefined,

        /**
         * Map of updated properties with new values.
         *
         * @config {Object}
         * @default
         */
        newData: undefined,

        /**
         * Map of updated properties with old values.
         *
         * @config {Object}
         * @default
         */
        oldData: undefined
      };
    }
  }]);

  return UpdateAction;
}(_ActionBase_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


UpdateAction._$name = 'UpdateAction';

/***/ }),

/***/ "./lib/Core/data/stm/mixin/ModelStm.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/stm/mixin/ModelStm.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");


































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/mixin/ModelStm
*/


var STM_PROP = Symbol('STM_PROP'),
    unrecordedFields = {
  // This field's value is a by product of node insertion and must not be recorded here.
  // It's the node insertion operation which is recorded by STM.
  parentIndex: 1
};
/**
 * Mixin making a model compatible with {@link Core/data/stm/StateTrackingManager}
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default()(ModelStm, _ref);

    var _super = _createSuper(ModelStm);

    function ModelStm() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27___default()(this, ModelStm);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default()(ModelStm, [{
      key: "joinStore",
      value: function joinStore(store) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "joinStore", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "joinStore", this).call(this, store);

        if (!this.stm) {
          this.stm = store.stm;
        }
      }
    }, {
      key: "unJoinStore",
      value: function unJoinStore(store) {
        if (this.stm === store.stm) {
          this.stm = null;
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "unJoinStore", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "unJoinStore", this).call(this, store);
      }
      /**
       * Reference to STM manager, if used
       * @member {Core.data.stm.StateTrackingManager}
       * @category Misc
       */

    }, {
      key: "beforeSet",

      /**
       * Overridden to collect initial data for the fields about to be changed.
       * The method is called from within {@link Core/data/Model#function-set} method.
       *
       * @private
       */
      value: function beforeSet(field, value, silent, fromRelationUpdate) {
        var _this = this;

        var preResult = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "beforeSet", this) ? _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "beforeSet", this).call(this, field, value, silent, fromRelationUpdate) : [];
        var stm = this.stm;

        if (stm && !stm.disabled && !unrecordedFields[field]) {
          var newDataCandidate, oldDataCandidate;

          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_26___default()(field) == 'object') {
            var _Object$keys$reduce = Object.keys(field).reduce(function (data, fName) {
              data[0][fName] = field[fName];
              data[1][fName] = _this.get(fName);
              return data;
            }, [{}, {}]);

            var _Object$keys$reduce2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_25___default()(_Object$keys$reduce, 2);

            newDataCandidate = _Object$keys$reduce2[0];
            oldDataCandidate = _Object$keys$reduce2[1];
          } else {
            newDataCandidate = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()({}, field, value);
            oldDataCandidate = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()({}, field, this.get(field));
          }

          preResult.push([newDataCandidate, oldDataCandidate]);
        }

        return preResult;
      }
      /**
       * Overridden to store initial data of the changed fields and to notify STM
       * manager about the change action if anything has been changed in result.
       *
       * The method is called from within {@link Core/data/Model#function-set} method.
       *
       * @private
       */

    }, {
      key: "afterSet",
      value: function afterSet(field, value, silent, fromRelationUpdate, beforeResult, wasSet) {
        var stm = this.stm;

        if (stm && !stm.disabled && !unrecordedFields[field]) {
          var preResult = beforeResult.pop();

          if (wasSet) {
            var _preResult = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_25___default()(preResult, 2),
                newDataCandidate = _preResult[0],
                oldDataCandidate = _preResult[1];

            var _Object$keys$reduce3 = Object.keys(wasSet).reduce(function (data, fName) {
              data[0][fName] = newDataCandidate[fName];
              data[1][fName] = oldDataCandidate[fName];
              return data;
            }, [{}, {}]),
                _Object$keys$reduce4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_25___default()(_Object$keys$reduce3, 2),
                newData = _Object$keys$reduce4[0],
                oldData = _Object$keys$reduce4[1];

            stm.onModelUpdate(this, newData, oldData);
          }
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "afterSet", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "afterSet", this).call(this, field, value, silent, fromRelationUpdate, beforeResult, wasSet);
      }
      /**
       * Called from {@link Core/data/mixin/TreeNode#function-insertChild} to obtain inserted
       * records initial parents and parent index, to be able to restore the state back upon undo.
       *
       * @param {Core.data.Model[]} childRecords
       * @return {Array} Array of results from this call and any of super calls if any.
       *               This result is consumed by {@link #function-afterInsertChild} which pops
       *               from the result array to take only results of this method call and leave
       *               results from super calls untouched.
       *
       * @private
       */

    }, {
      key: "beforeInsertChild",
      value: function beforeInsertChild(childRecords) {
        var _this2 = this;

        var preResult = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "beforeInsertChild", this) ? _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "beforeInsertChild", this).call(this, childRecords) : [];
        var stm = this.stm;

        if (stm && !stm.disabled) {
          preResult.push(childRecords.reduce(function (result, childRecord) {
            // We are interested only in records from the same root node.
            // Removing (which is done before insertion) of the records
            // from another root (and store) should
            // be handled by that store STM instance.
            if (childRecord.root === _this2.root) {
              result.set(childRecord, {
                parent: childRecord.parent,
                index: childRecord.parent ? childRecord.parentIndex : undefined
              });
            }

            return result;
          }, new Map()));
        }

        return preResult;
      }
      /**
       * Called from {@link Core/data/mixin/TreeNode#function-insertChild} to notify {@link Core/data/stm/StateTrackingManager}
       * about children insertion. Provides it with all necessary context information collected
       * in {@link #function-beforeInsertChild} required to undo/redo the action.
       *
       * @private
       */

    }, {
      key: "afterInsertChild",
      value: function afterInsertChild(index, childRecords, beforeResult, inserted) {
        var stm = this.stm;

        if (stm && !stm.disabled) {
          var context = beforeResult.pop();

          if (inserted) {
            stm.onModelInsertChild(this, index, inserted, context);
          }
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "afterInsertChild", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "afterInsertChild", this).call(this, index, childRecords, beforeResult, inserted);
      }
      /**
       * Called from {@link Core/data/mixin/TreeNode#function-removeChild} to obtain removed
       * records initial parent index, to be able to restore the state back upon undo.
       *
       * @param {Core.data.Model[]} childRecords
       * @param {Boolean} isMove
       * @return {Array} Array of results from this call and any of super calls if any.
       *               This result is consumed by {@link #function-afterRemoveChild} which pops
       *               from the result array to take only results of this method call and leave
       *               results from super calls untouched.
       *
       * @private
       */

    }, {
      key: "beforeRemoveChild",
      value: function beforeRemoveChild(childRecords, isMove) {
        var preResult = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "beforeRemoveChild", this) ? _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "beforeRemoveChild", this).call(this, childRecords, isMove) : [];
        var stm = this.stm; // If it's move then InsertChildAction will handle this case

        if (stm && !stm.disabled && !isMove) {
          // Child records we receive are guaranteed to be direct children
          // of this node, see Core/data/mixin/TreeNode#removeChild method
          // Here we interested in the original index for each child removed,
          // we collect it and store for future use in RemoveChildAction
          preResult.push(childRecords.reduce(function (result, childRecord) {
            result.set(childRecord, childRecord.parentIndex);
            return result;
          }, new Map()));
        }

        return preResult;
      }
      /**
       * Called from {@link Core/data/mixin/TreeNode#function-removeChild} to notify {@link Core/data/stm/StateTrackingManager}
       * about children removing. Provides it with all necessary context information collected
       * in {@link #function-beforeRemoveChild} required to undo/redo the action.
       *
       * @private
       */

    }, {
      key: "afterRemoveChild",
      value: function afterRemoveChild(childRecords, beforeResult, isMove) {
        var stm = this.stm; // If it's move then InsertChildAction will handle this case

        if (stm && !stm.disabled && !isMove) {
          var context = beforeResult.pop();

          if (childRecords && childRecords.length) {
            stm.onModelRemoveChild(this, childRecords, context);
          }
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "afterRemoveChild", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(ModelStm.prototype), "afterRemoveChild", this).call(this, childRecords, beforeResult, isMove);
      }
    }, {
      key: "stm",
      get: function get() {
        return this[STM_PROP];
      },
      set: function set(stm) {
        this[STM_PROP] = stm;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'ModelStm';
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          stm: null
        };
      }
    }]);

    return ModelStm;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_33__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/stm/mixin/StoreStm.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/stm/mixin/StoreStm.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _data_Model_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../../../data/Model.js */ "./lib/Core/data/Model.js");


































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/mixin/StoreStm
*/



var STM_PROP = Symbol('STM_PROP');
/**
 * Store mixin to make it compatible with {@link Core.data.stm.StateTrackingManager}.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default()(StoreStm, _ref);

    var _super = _createSuper(StoreStm);

    function StoreStm() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27___default()(this, StoreStm);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default()(StoreStm, [{
      key: "add",
      // Overridden to notify STM about flat add action
      value: function add(records) {
        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var result;
        var stm = this.stm; // Tree adding is routed via rootNode.appendChild() it has it's own
        // STM override thus if the store is tree we ignore the action

        if (!this.tree && stm && !stm.disabled) {
          // Flat adding here only, the only data needed to undo/redo the action
          // is the list of records added.
          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(StoreStm.prototype), "add", this).call(this, records, silent); // If adding wasn't vetoed and something has been added then
          // notifying the STM about the fact.

          if (result && result.length) {
            stm.onStoreModelAdd(this, result, silent);
          }
        } else {
          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(StoreStm.prototype), "add", this).call(this, records, silent);
        }

        return result;
      } // Overridden to notify STM about flat insert action

    }, {
      key: "insert",
      value: function insert(index, records) {
        var _this = this;

        var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var result;
        var stm = this.stm; // Tree inserting is routed via rootNode.insertChild() it has it's own
        // STM override thus if the store is tree we ignore the action

        if (!this.tree && stm && !stm.disabled) {
          // Flat inserting here only, the only data needed to undo/redo the action is:
          // - the list of record inserted
          // - index they are inserted at
          // - index they have been at if they are part of this store already and are moved
          // Here we are getting indexes of records which are in this store already
          // not all records might be from this store, some might be new or from another store
          var context = (Array.isArray(records) ? records : [records]).reduce(function (context, r) {
            var index = r instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_34__["default"] ? _this.indexOf(r) : undefined;

            if (index !== undefined && index !== -1) {
              context.set(r, index);
            }

            return context;
          }, new Map()); // Result here is the array of Models inserted or undefined,
          // and it might be different from `records` we received as argument.

          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(StoreStm.prototype), "insert", this).call(this, index, records); // Here we check if anything has been actually inserted.
          // The insertion action might be vetoed by event handler or something

          if (result && result.length) {
            // We can't rely on `index` we've got as argument since `result` might
            // differ from records.
            index = this.indexOf(result[0]); // Notifying STM manager about the insertion action providing all
            // the required data to undo/redo.

            stm.onStoreModelInsert(this, index, result, context, silent);
          }
        } else {
          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(StoreStm.prototype), "insert", this).call(this, index, records, silent);
        }

        return result;
      } // Overridden to notify STM about flat removing action

    }, {
      key: "remove",
      value: function remove(recordsOrIds) {
        var _this2 = this;

        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var fromRemoveChild = arguments.length > 2 ? arguments[2] : undefined;
        var result;
        var stm = this.stm; // Tree removing is routed via rootNode.removeChild() it has it's own
        // STM override thus if the store is tree we ignore the action

        if (!this.tree && stm && !stm.disabled) {
          // Flat removing here only, the only date needed to undo/redo the actions is:
          // - the list of records removed
          // - their original index to re-insert them back correctly
          var recordsOrIdsNormalized = (Array.isArray(recordsOrIds) ? recordsOrIds : [recordsOrIds]).map(function (r) {
            return _this2.getById(r);
          }).filter(function (r) {
            return !!r;
          });
          var context = recordsOrIdsNormalized.reduce(function (context, r) {
            var index = _this2.indexOf(r);

            if (index !== undefined && index != -1) {
              context.set(r, index);
            }

            return context;
          }, new Map()); // Calling original store method

          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(StoreStm.prototype), "remove", this).call(this, recordsOrIds, silent, fromRemoveChild); // Here we check if anything has been actually removed.
          // The removing action might be vetoed by event handler or something

          if (result && result.length) {
            stm.onStoreModelRemove(this, result, context, silent);
          }
        } else {
          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(StoreStm.prototype), "remove", this).call(this, recordsOrIds, silent, fromRemoveChild);
        }

        return result;
      } // Overridden to notify STM about flat clear action

    }, {
      key: "removeAll",
      value: function removeAll(silent) {
        var stm = this.stm;
        var result;

        if (stm && !stm.disabled) {
          // Here we are to detect if anything has been removed
          // the only way is to check if store has anything before removing all
          // and has nothing after.
          var tree = this.tree,
              rootNode = this.rootNode,
              allRecords = this.allRecords,
              wasNotEmpty = allRecords.length,
              records = tree ? rootNode.children.slice() : allRecords.slice();
          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(StoreStm.prototype), "removeAll", this).call(this, silent); // The trick here is to distinguish tree and flat case
          // For the flat case it's simple we just store all records
          // For the tree we are to store root node children only
          // Upon restoring store.add() will do the right thing for the flat case and tree case regardless.

          if (wasNotEmpty && this.count === 0) {
            stm.onStoreRemoveAll(this, records, silent);
          }
        } else {
          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(StoreStm.prototype), "removeAll", this).call(this, silent);
        }

        return result;
      }
    }, {
      key: "stm",
      get: function get() {
        return this[STM_PROP];
      },
      set: function set(stm) {
        var me = this;

        if (me.stm != stm) {
          if (me.stm && me.stm.hasStore(me)) {
            me.stm.removeStore(me);
          }

          me[STM_PROP] = stm;

          if (me.stm && !me.stm.hasStore(me)) {
            me.stm.addStore(me);
          }
        }
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'StoreStm';
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Reference to STM manager
           *
           * @config {Core.data.stm.StateTrackingManager}
           * @default
           * @category Advanced
           */
          stm: null
        };
      }
    }]);

    return StoreStm;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_33__["default"]);
});

/***/ }),

/***/ "./lib/Core/data/stm/state/AutoReadyState.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/state/AutoReadyState.js ***!
  \***************************************************/
/*! exports provided: AutoReadyStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutoReadyStateClass", function() { return AutoReadyStateClass; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Transaction_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Transaction.js */ "./lib/Core/data/stm/Transaction.js");
/* harmony import */ var _ReadyState_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./ReadyState.js */ "./lib/Core/data/stm/state/ReadyState.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/state/AutoReadyState
*/






/**
 * STM transaction autostart ready state class.
 *
 * @internal
 */

var AutoReadyStateClass = /*#__PURE__*/function (_ReadyStateClass) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(AutoReadyStateClass, _ReadyStateClass);

  var _super = _createSuper(AutoReadyStateClass);

  function AutoReadyStateClass() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, AutoReadyStateClass);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(AutoReadyStateClass, [{
    key: "onAutoRecordOn",
    value: function onAutoRecordOn() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onAutoRecordOff",
    value: function onAutoRecordOff() {
      var _ref;

      return _ref = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_12__["STATE_PROP"], 'readystate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_12__["AUTO_RECORD_PROP"], false), _ref;
    }
  }, {
    key: "onStartTransaction",
    value: function onStartTransaction(stm, title) {
      var _ref2;

      var transaction = new _Transaction_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
        title: title
      });
      return [(_ref2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_12__["STATE_PROP"], 'autorecordingstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_12__["TRANSACTION_PROP"], transaction), _ref2), function () {
        stm.notifyStoresAboutStateRecordingStart(transaction);
        stm.stopTransactionDelayed();
      }];
    }
  }, {
    key: "onModelUpdate",
    value: function onModelUpdate(stm, model, newData, oldData) {
      stm.startTransaction();
      stm.onModelUpdate(model, newData, oldData);
    }
  }, {
    key: "onModelInsertChild",
    value: function onModelInsertChild(stm, parentModel, index, childModels, context) {
      stm.startTransaction();
      stm.onModelInsertChild(parentModel, index, childModels, context);
    }
  }, {
    key: "onModelRemoveChild",
    value: function onModelRemoveChild(stm, parentModel, childModels, context) {
      stm.startTransaction();
      stm.onModelRemoveChild(parentModel, childModels, context);
    }
  }, {
    key: "onStoreModelAdd",
    value: function onStoreModelAdd(stm, store, models, silent) {
      stm.startTransaction();
      stm.onStoreModelAdd(store, models, silent);
    }
  }, {
    key: "onStoreModelInsert",
    value: function onStoreModelInsert(stm, store, index, models, context, silent) {
      stm.startTransaction();
      stm.onStoreModelInsert(store, index, models, silent);
    }
  }, {
    key: "onStoreModelRemove",
    value: function onStoreModelRemove(stm, store, models, context, silent) {
      stm.startTransaction();
      stm.onStoreModelRemove(store, models, context, silent);
    }
  }, {
    key: "onStoreRemoveAll",
    value: function onStoreRemoveAll(stm, store, allRecords, silent) {
      stm.startTransaction();
      stm.onStoreRemoveAll(store, allRecords, silent);
    }
  }]);

  return AutoReadyStateClass;
}(_ReadyState_js__WEBPACK_IMPORTED_MODULE_11__["ReadyStateClass"]);
/**
 * STM transaction autostart ready state.
 *
 * @internal
 */

var AutoReadyState = new AutoReadyStateClass();
/* harmony default export */ __webpack_exports__["default"] = (AutoReadyState);
_Registry_js__WEBPACK_IMPORTED_MODULE_13__["default"].registerStmState('autoreadystate', AutoReadyState);

/***/ }),

/***/ "./lib/Core/data/stm/state/AutoRecordingState.js":
/*!*******************************************************!*\
  !*** ./lib/Core/data/stm/state/AutoRecordingState.js ***!
  \*******************************************************/
/*! exports provided: AutoRecordingStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutoRecordingStateClass", function() { return AutoRecordingStateClass; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _RecordingState_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./RecordingState.js */ "./lib/Core/data/stm/state/RecordingState.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/state/AutoRecordingState
*/






/**
 * STM recording state class.
 *
 * @internal
 */

var AutoRecordingStateClass = /*#__PURE__*/function (_RecordingStateClass$) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AutoRecordingStateClass, _RecordingStateClass$);

  var _super = _createSuper(AutoRecordingStateClass);

  function AutoRecordingStateClass() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, AutoRecordingStateClass);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(AutoRecordingStateClass, [{
    key: "onDisable",
    value: function onDisable(stm) {
      var _ref;

      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_PROP"]];
      var timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"]];

      if (timer) {
        this.clearTimeout(timer);
      }

      stm.notifyStoresAboutStateRecordingStop(transaction, {
        disabled: true
      });
      return _ref = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_14__["STATE_PROP"], 'disabledstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"], null), _ref;
    }
  }, {
    key: "onAutoRecordOn",
    value: function onAutoRecordOn(stm) {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_12__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onAutoRecordOff",
    value: function onAutoRecordOff(stm) {
      var _ref2;

      var timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"]];

      if (timer) {
        this.clearTimeout(timer);
      }

      return _ref2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_14__["STATE_PROP"], 'recordingstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_14__["AUTO_RECORD_PROP"], false), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"], null), _ref2;
    }
  }, {
    key: "onStopTransaction",
    value: function onStopTransaction(stm, title) {
      var _ref3;

      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_PROP"]];
      var timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"]];
      var position = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["POS_PROP"]];
      var queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["QUEUE_PROP"]];

      if (timer) {
        this.clearTimeout(timer);
      }

      if (transaction.length) {
        if (!transaction.title && !title && stm.getTransactionTitle) {
          transaction.title = stm.getTransactionTitle(transaction);
        } else if (title) {
          transaction.title = title;
        }

        queue[position] = transaction;
        queue.length = ++position;
      }

      return [(_ref3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_14__["STATE_PROP"], 'autoreadystate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_14__["POS_PROP"], position), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"], null), _ref3), function () {
        stm.notifyStoresAboutStateRecordingStop(transaction, {
          stop: true
        });
      }];
    }
  }, {
    key: "onStopTransactionDelayed",
    value: function onStopTransactionDelayed(stm) {
      var _ref4;

      var timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"]];

      if (timer) {
        this.clearTimeout(timer);
      }

      timer = this.setTimeout(function () {
        stm.stopTransaction();
      }, stm.autoRecordTransactionStopTimeout);
      return _ref4 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_14__["STATE_PROP"], AutoRecordingState), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"], timer), _ref4;
    }
  }, {
    key: "onRejectTransaction",
    value: function onRejectTransaction(stm) {
      var _ref5;

      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_PROP"]],
          timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"]];

      if (timer) {
        this.clearTimeout(timer);
      }

      return [(_ref5 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref5, _Props_js__WEBPACK_IMPORTED_MODULE_14__["STATE_PROP"], 'restoringstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref5, _Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_ref5, _Props_js__WEBPACK_IMPORTED_MODULE_14__["TRANSACTION_TIMER_PROP"], null), _ref5), function () {
        if (transaction.length) {
          transaction.undo();
        }

        return ['autoreadystate', function () {
          stm.notifyStoresAboutStateRecordingStop(transaction, {
            rejected: true
          });
        }];
      }];
    }
  }, {
    key: "onModelUpdate",
    value: function onModelUpdate(stm) {
      var _get2;

      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(AutoRecordingStateClass.prototype), "onModelUpdate", this)).call.apply(_get2, [this, stm].concat(rest));

      stm.stopTransactionDelayed();
    }
  }, {
    key: "onModelInsertChild",
    value: function onModelInsertChild(stm) {
      var _get3;

      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }

      (_get3 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(AutoRecordingStateClass.prototype), "onModelInsertChild", this)).call.apply(_get3, [this, stm].concat(rest));

      stm.stopTransactionDelayed();
    }
  }, {
    key: "onModelRemoveChild",
    value: function onModelRemoveChild(stm) {
      var _get4;

      for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        rest[_key3 - 1] = arguments[_key3];
      }

      (_get4 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(AutoRecordingStateClass.prototype), "onModelRemoveChild", this)).call.apply(_get4, [this, stm].concat(rest));

      stm.stopTransactionDelayed();
    }
  }, {
    key: "onStoreModelAdd",
    value: function onStoreModelAdd(stm) {
      var _get5;

      for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        rest[_key4 - 1] = arguments[_key4];
      }

      (_get5 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(AutoRecordingStateClass.prototype), "onStoreModelAdd", this)).call.apply(_get5, [this, stm].concat(rest));

      stm.stopTransactionDelayed();
    }
  }, {
    key: "onStoreModelInsert",
    value: function onStoreModelInsert(stm) {
      var _get6;

      for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        rest[_key5 - 1] = arguments[_key5];
      }

      (_get6 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(AutoRecordingStateClass.prototype), "onStoreModelInsert", this)).call.apply(_get6, [this, stm].concat(rest));

      stm.stopTransactionDelayed();
    }
  }, {
    key: "onStoreModelRemove",
    value: function onStoreModelRemove(stm) {
      var _get7;

      for (var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        rest[_key6 - 1] = arguments[_key6];
      }

      (_get7 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(AutoRecordingStateClass.prototype), "onStoreModelRemove", this)).call.apply(_get7, [this, stm].concat(rest));

      stm.stopTransactionDelayed();
    }
  }, {
    key: "onStoreRemoveAll",
    value: function onStoreRemoveAll(stm) {
      var _get8;

      for (var _len7 = arguments.length, rest = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        rest[_key7 - 1] = arguments[_key7];
      }

      (_get8 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(AutoRecordingStateClass.prototype), "onStoreRemoveAll", this)).call.apply(_get8, [this, stm].concat(rest));

      stm.stopTransactionDelayed();
    }
  }]);

  return AutoRecordingStateClass;
}(_RecordingState_js__WEBPACK_IMPORTED_MODULE_13__["RecordingStateClass"].mixin(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_11__["default"]));
/**
 * STM recording state.
 *
 * @internal
 */

var AutoRecordingState = new AutoRecordingStateClass();
/* harmony default export */ __webpack_exports__["default"] = (AutoRecordingState);
_Registry_js__WEBPACK_IMPORTED_MODULE_15__["default"].registerStmState('autorecordingstate', AutoRecordingState);

/***/ }),

/***/ "./lib/Core/data/stm/state/DisabledState.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/state/DisabledState.js ***!
  \**************************************************/
/*! exports provided: DisabledStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DisabledStateClass", function() { return DisabledStateClass; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/state/DisabledState
*/





/**
 * STM disabled state class.
 *
 * @internal
 */

var DisabledStateClass = /*#__PURE__*/function (_StateBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(DisabledStateClass, _StateBase);

  var _super = _createSuper(DisabledStateClass);

  function DisabledStateClass() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, DisabledStateClass);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(DisabledStateClass, [{
    key: "canUndo",
    value: function canUndo() {
      return false;
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return false;
    }
  }, {
    key: "onUndo",
    value: function onUndo() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onRedo",
    value: function onRedo() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onEnable",
    value: function onEnable(stm) {
      return stm.autoRecord ? 'autoreadystate' : 'readystate';
    }
  }, {
    key: "onDisable",
    value: function onDisable() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onAutoRecordOn",
    value: function onAutoRecordOn() {
      return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_10__["AUTO_RECORD_PROP"], true);
    }
  }, {
    key: "onAutoRecordOff",
    value: function onAutoRecordOff() {
      return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_10__["AUTO_RECORD_PROP"], false);
    }
  }, {
    key: "onStartTransaction",
    value: function onStartTransaction() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onStopTransaction",
    value: function onStopTransaction() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onStopTransactionDelayed",
    value: function onStopTransactionDelayed() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onRejectTransaction",
    value: function onRejectTransaction() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onResetQueue",
    value: function onResetQueue(stm, options) {
      return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_12__["resetQueue"])(stm, options);
    }
  }, {
    key: "onModelUpdate",
    value: function onModelUpdate() {}
  }, {
    key: "onModelInsertChild",
    value: function onModelInsertChild() {}
  }, {
    key: "onModelRemoveChild",
    value: function onModelRemoveChild() {}
  }, {
    key: "onStoreModelAdd",
    value: function onStoreModelAdd() {}
  }, {
    key: "onStoreModelInsert",
    value: function onStoreModelInsert() {}
  }, {
    key: "onStoreModelRemove",
    value: function onStoreModelRemove() {}
  }, {
    key: "onStoreRemoveAll",
    value: function onStoreRemoveAll() {}
  }]);

  return DisabledStateClass;
}(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
/**
 * STM disabled state.
 *
 * @internal
 */

var DisabledState = new DisabledStateClass();
/* harmony default export */ __webpack_exports__["default"] = (DisabledState);
_Registry_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerStmState('disabledstate', DisabledState);

/***/ }),

/***/ "./lib/Core/data/stm/state/ReadyState.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/stm/state/ReadyState.js ***!
  \***********************************************/
/*! exports provided: ReadyStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadyStateClass", function() { return ReadyStateClass; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Transaction_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Transaction.js */ "./lib/Core/data/stm/Transaction.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/state/ReadyState
*/






/**
 * STM ready state class.
 *
 * @internal
 */

var ReadyStateClass = /*#__PURE__*/function (_StateBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ReadyStateClass, _StateBase);

  var _super = _createSuper(ReadyStateClass);

  function ReadyStateClass() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ReadyStateClass);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ReadyStateClass, [{
    key: "canUndo",
    value: function canUndo(stm) {
      //      v
      // |*|*|
      return 0 < stm.position && stm.position <= stm.length;
    }
  }, {
    key: "canRedo",
    value: function canRedo(stm) {
      //  v
      // |*|*|
      return 0 <= stm.position && stm.position < stm.length;
    }
  }, {
    key: "onUndo",
    value: function onUndo(stm, steps) {
      var _ref;

      var queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_11__["QUEUE_PROP"]];
      var curPos = stm.position,
          newPos = Math.max(0, curPos - steps);

      var next = function next() {
        stm.notifyStoresAboutStateRestoringStart();

        while (curPos != newPos) {
          queue[--curPos].undo();
        }

        return [stm.autoRecord ? 'autoreadystate' : 'readystate', function () {
          stm.notifyStoresAboutStateRestoringStop();
        }];
      };

      return [(_ref = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_11__["STATE_PROP"], 'restoringstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_11__["POS_PROP"], newPos), _ref), next];
    }
  }, {
    key: "onRedo",
    value: function onRedo(stm, steps) {
      var _ref2;

      var queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_11__["QUEUE_PROP"]];
      var curPos = stm.position,
          newPos = Math.min(queue.length, curPos + steps);

      var next = function next() {
        stm.notifyStoresAboutStateRestoringStart();

        do {
          queue[curPos++].redo();
        } while (curPos != newPos);

        return [stm.autoRecord ? 'autoreadystate' : 'readystate', function () {
          stm.notifyStoresAboutStateRestoringStop();
        }];
      };

      return [(_ref2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_11__["STATE_PROP"], 'restoringstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_11__["POS_PROP"], newPos), _ref2), next];
    }
  }, {
    key: "onEnable",
    value: function onEnable() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onDisable",
    value: function onDisable() {
      return 'disabledstate';
    }
  }, {
    key: "onAutoRecordOn",
    value: function onAutoRecordOn() {
      var _ref3;

      return _ref3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_11__["STATE_PROP"], 'autoreadystate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_11__["AUTO_RECORD_PROP"], true), _ref3;
    }
  }, {
    key: "onAutoRecordOff",
    value: function onAutoRecordOff() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onStartTransaction",
    value: function onStartTransaction(stm, title) {
      var _ref4;

      var transaction = new _Transaction_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
        title: title
      });
      return [(_ref4 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_11__["STATE_PROP"], 'recordingstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_11__["TRANSACTION_PROP"], transaction), _ref4), function () {
        stm.notifyStoresAboutStateRecordingStart(transaction);
      }];
    }
  }, {
    key: "onStopTransaction",
    value: function onStopTransaction() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onStopTransactionDelayed",
    value: function onStopTransactionDelayed() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onRejectTransaction",
    value: function onRejectTransaction() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onResetQueue",
    value: function onResetQueue(stm, options) {
      return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_13__["resetQueue"])(stm, options);
    }
  }, {
    key: "onModelUpdate",
    value: function onModelUpdate() {}
  }, {
    key: "onModelInsertChild",
    value: function onModelInsertChild() {}
  }, {
    key: "onModelRemoveChild",
    value: function onModelRemoveChild() {}
  }, {
    key: "onStoreModelAdd",
    value: function onStoreModelAdd() {}
  }, {
    key: "onStoreModelInsert",
    value: function onStoreModelInsert() {}
  }, {
    key: "onStoreModelRemove",
    value: function onStoreModelRemove() {}
  }, {
    key: "onStoreRemoveAll",
    value: function onStoreRemoveAll() {}
  }]);

  return ReadyStateClass;
}(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
/**
 * STM ready state.
 *
 * @internal
 */

var ReadyState = new ReadyStateClass();
/* harmony default export */ __webpack_exports__["default"] = (ReadyState);
_Registry_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerStmState('readystate', ReadyState);

/***/ }),

/***/ "./lib/Core/data/stm/state/RecordingState.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/state/RecordingState.js ***!
  \***************************************************/
/*! exports provided: RecordingStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecordingStateClass", function() { return RecordingStateClass; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/state/RecordingState
*/




/**
 * STM recording state class.
 *
 * @internal
 */

var RecordingStateClass = /*#__PURE__*/function (_StateBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(RecordingStateClass, _StateBase);

  var _super = _createSuper(RecordingStateClass);

  function RecordingStateClass() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, RecordingStateClass);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(RecordingStateClass, [{
    key: "canUndo",
    value: function canUndo() {
      return false;
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return false;
    }
  }, {
    key: "onEnable",
    value: function onEnable() {}
  }, {
    key: "onDisable",
    value: function onDisable(stm) {
      var _ref;

      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      stm.notifyStoresAboutStateRecordingStop(transaction, {
        disabled: true
      });
      return _ref = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_10__["STATE_PROP"], 'disabledstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"], null), _ref;
    }
  }, {
    key: "onAutoRecordOn",
    value: function onAutoRecordOn(stm) {
      var _ref2;

      return [(_ref2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_10__["STATE_PROP"], 'autorecordingstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_10__["AUTO_RECORD_PROP"], true), _ref2), function () {
        stm.stopTransactionDelayed();
      }];
    }
  }, {
    key: "onAutoRecordOff",
    value: function onAutoRecordOff() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onStartTransaction",
    value: function onStartTransaction() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onStopTransaction",
    value: function onStopTransaction(stm, title) {
      var _ref3;

      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      var position = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["POS_PROP"]];
      var queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["QUEUE_PROP"]];

      if (transaction.length) {
        if (!transaction.title && !title && stm.getTransactionTitle) {
          transaction.title = stm.getTransactionTitle(transaction);
        } else if (title) {
          transaction.title = title;
        }

        queue[position] = transaction;
        queue.length = ++position;
      }

      return [(_ref3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_10__["STATE_PROP"], 'readystate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_10__["POS_PROP"], position), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"], null), _ref3), function () {
        stm.notifyStoresAboutStateRecordingStop(transaction, {
          stop: true
        });
      }];
    }
  }, {
    key: "onRejectTransaction",
    value: function onRejectTransaction(stm) {
      var _ref4;

      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      return [(_ref4 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_10__["STATE_PROP"], 'restoringstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"], null), _ref4), function () {
        if (transaction.length) {
          transaction.undo();
        }

        return ['readystate', function () {
          stm.notifyStoresAboutStateRecordingStop(transaction, {
            rejected: true
          });
        }];
      }];
    }
  }, {
    key: "onStopTransactionDelayed",
    value: function onStopTransactionDelayed() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onQueueReset",
    value: function onQueueReset() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onModelUpdate",
    value: function onModelUpdate(stm, model, newData, oldData) {
      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      transaction.addAction(stm.makeModelUpdateAction(model, newData, oldData));
    }
  }, {
    key: "onModelInsertChild",
    value: function onModelInsertChild(stm, parentModel, index, childModel, previousParent, previousIndex) {
      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      transaction.addAction(stm.makeModelInsertChildAction(parentModel, index, childModel, previousParent, previousIndex));
    }
  }, {
    key: "onModelRemoveChild",
    value: function onModelRemoveChild(stm, parentModel, childModels, context) {
      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      transaction.addAction(stm.makeModelRemoveChildAction(parentModel, childModels, context));
    }
  }, {
    key: "onStoreModelAdd",
    value: function onStoreModelAdd(stm, store, models, silent) {
      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      transaction.addAction(stm.makeStoreModelAddAction(store, models, silent));
    }
  }, {
    key: "onStoreModelInsert",
    value: function onStoreModelInsert(stm, store, index, models, context, silent) {
      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      transaction.addAction(stm.makeStoreModelInsertAction(store, index, models, context, silent));
    }
  }, {
    key: "onStoreModelRemove",
    value: function onStoreModelRemove(stm, store, models, context, silent) {
      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      transaction.addAction(stm.makeStoreModelRemoveAction(store, models, context, silent));
    }
  }, {
    key: "onStoreRemoveAll",
    value: function onStoreRemoveAll(stm, store, allRecords, silent) {
      var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
      transaction.addAction(stm.makeStoreRemoveAllAction(store, allRecords, silent));
    }
  }]);

  return RecordingStateClass;
}(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
/**
 * STM recording state.
 *
 * @internal
 */

var RecordingState = new RecordingStateClass();
/* harmony default export */ __webpack_exports__["default"] = (RecordingState);
_Registry_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerStmState('recordingstate', RecordingState);

/***/ }),

/***/ "./lib/Core/data/stm/state/Registry.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/stm/state/Registry.js ***!
  \*********************************************/
/*! exports provided: registerStmState, resolveStmState, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerStmState", function() { return registerStmState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveStmState", function() { return resolveStmState; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");


















var productName = 'scheduler';

/**
 * @module Core/data/stm/state/Registry
 *
 * Provides map of registered STM states.
 *
 * Needed to remove states circular dependency.
 *
 * @internal
 */

var registry = new Map();
/**
 * Registers STM state class with the given name.
 *
 * @private
 *
 * @param {string} name
 * @param {Core.data.stm.state.StateBase} state
 */

var registerStmState = function registerStmState(name, state) {
  registry.set(name, state);
};
/**
 * Resolves STM state class with the given name.
 *
 * @private
 *
 * @param {string} name
 * @return {Core.data.stm.state.StateBase} state
 */

var resolveStmState = function resolveStmState(state) {
  if (typeof state === 'string') {
    state = registry.get(state);
  }

  return state;
}; // UMD/module compatible export
// NOTE: the most compatible way of exporting is:
//       import registry from './Registry.js';
//       { registerStmState, resolveStmState } = registry;
//          or
//       registry.registerStmState(...);

/* harmony default export */ __webpack_exports__["default"] = ({
  registerStmState: registerStmState,
  resolveStmState: resolveStmState
});

/***/ }),

/***/ "./lib/Core/data/stm/state/RestoringState.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/state/RestoringState.js ***!
  \***************************************************/
/*! exports provided: RestoringStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestoringStateClass", function() { return RestoringStateClass; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/state/RestoringState
*/




/**
 * STM restoring state class.
 *
 * @internal
 */

var RestoringStateClass = /*#__PURE__*/function (_StateBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(RestoringStateClass, _StateBase);

  var _super = _createSuper(RestoringStateClass);

  function RestoringStateClass() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, RestoringStateClass);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(RestoringStateClass, [{
    key: "canUndo",
    value: function canUndo() {
      return false;
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return false;
    }
  }, {
    key: "onUndo",
    value: function onUndo() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onRedo",
    value: function onRedo() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onEnable",
    value: function onEnable() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onDisable",
    value: function onDisable() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onAutoRecordOn",
    value: function onAutoRecordOn() {
      return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_10__["AUTO_RECORD_PROP"], true);
    }
  }, {
    key: "onAutoRecordOff",
    value: function onAutoRecordOff() {
      return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_10__["AUTO_RECORD_PROP"], false);
    }
  }, {
    key: "onStartTransaction",
    value: function onStartTransaction() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onStopTransaction",
    value: function onStopTransaction() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onStopTransactionDelayed",
    value: function onStopTransactionDelayed() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onRejectTransaction",
    value: function onRejectTransaction() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onQueueReset",
    value: function onQueueReset() {
      Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["throwInvalidMethodCall"])();
    }
  }, {
    key: "onModelUpdate",
    value: function onModelUpdate() {}
  }, {
    key: "onModelInsertChild",
    value: function onModelInsertChild() {}
  }, {
    key: "onModelRemoveChild",
    value: function onModelRemoveChild() {}
  }, {
    key: "onStoreModelAdd",
    value: function onStoreModelAdd() {}
  }, {
    key: "onStoreModelInsert",
    value: function onStoreModelInsert() {}
  }, {
    key: "onStoreModelRemove",
    value: function onStoreModelRemove() {}
  }, {
    key: "onStoreRemoveAll",
    value: function onStoreRemoveAll() {}
  }]);

  return RestoringStateClass;
}(_StateBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
/**
 * STM restoring state.
 *
 * @internal
 */

var RestoringState = new RestoringStateClass();
/* harmony default export */ __webpack_exports__["default"] = (RestoringState);
_Registry_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerStmState('restoringstate', RestoringState);

/***/ }),

/***/ "./lib/Core/data/stm/state/StateBase.js":
/*!**********************************************!*\
  !*** ./lib/Core/data/stm/state/StateBase.js ***!
  \**********************************************/
/*! exports provided: throwAbstractMethodCall, throwInvalidMethodCall, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwAbstractMethodCall", function() { return throwAbstractMethodCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwInvalidMethodCall", function() { return throwInvalidMethodCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StateBase; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/data/stm/state/StateBase
*/


var throwAbstractMethodCall = function throwAbstractMethodCall() {
  throw new Error('Abstract method call!');
};
var throwInvalidMethodCall = function throwInvalidMethodCall() {
  throw new Error('Method cannot be called at this state!');
};
/**
 * Abstract class for STM states
 *
 * Every on* method should return a state for the STM which it should switch to
 * or throw an exception that this call at this state is illegal.
 *
 * Interface of this class mirrors interface of {@link Core.data.stm.StateTrackingManager}.
 *
 * @abstract
 */

var StateBase = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(StateBase, _Base);

  var _super = _createSuper(StateBase);

  function StateBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, StateBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(StateBase, [{
    key: "canUndo",
    value: function canUndo(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "canRedo",
    value: function canRedo(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onUndo",
    value: function onUndo(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onRedo",
    value: function onRedo(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onStartTransaction",
    value: function onStartTransaction(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onStopTransaction",
    value: function onStopTransaction(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onStopTransactionDelayed",
    value: function onStopTransactionDelayed(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onRejectTransaction",
    value: function onRejectTransaction(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onEnable",
    value: function onEnable(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onDisable",
    value: function onDisable(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onAutoRecordOn",
    value: function onAutoRecordOn(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onAutoRecordOff",
    value: function onAutoRecordOff(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onResetQueue",
    value: function onResetQueue(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onModelUpdate",
    value: function onModelUpdate(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onStoreModelAdd",
    value: function onStoreModelAdd(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onStoreModelInsert",
    value: function onStoreModelInsert(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onStoreModelRemove",
    value: function onStoreModelRemove(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onStoreModelRemoveAll",
    value: function onStoreModelRemoveAll(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onModelInsertChild",
    value: function onModelInsertChild(stm) {
      throwAbstractMethodCall();
    }
  }, {
    key: "onModelRemoveChild",
    value: function onModelRemoveChild(stm) {
      throwAbstractMethodCall();
    }
  }]);

  return StateBase;
}(_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


StateBase._$name = 'StateBase';

/***/ }),

/***/ "./lib/Core/helper/AjaxHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/AjaxHelper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AjaxHelper; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");

























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';
/**
* @module Core/helper/AjaxHelper
*/



var paramValueRegExp = /^(\w+)=(.*)$/,
    // For CodePens, adjust URLs to be absolute
resourceRoot = _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].queryString.__resourceRoot || '',
    parseParams = function parseParams(paramString) {
  var result = {},
      params = paramString.split('&'); // loop through each 'filter={"field":"name","operator":"=","value":"Sweden","caseSensitive":true}' string
  // So we cannot use .split('=')

  var _iterator = _createForOfIteratorHelper(params),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var nameValuePair = _step.value;

      var _paramValueRegExp$exe = paramValueRegExp.exec(nameValuePair),
          _paramValueRegExp$exe2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23___default()(_paramValueRegExp$exe, 3),
          match = _paramValueRegExp$exe2[0],
          name = _paramValueRegExp$exe2[1],
          value = _paramValueRegExp$exe2[2],
          decodedName = decodeURIComponent(name),
          decodedValue = decodeURIComponent(value);

      if (match) {
        var paramValue = result[decodedName];

        if (paramValue) {
          if (!Array.isArray(paramValue)) {
            paramValue = result[decodedName] = [paramValue];
          }

          paramValue.push(decodedValue);
        } else {
          result[decodedName] = decodedValue;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
};
/**
 * Simplifies Ajax requests. Uses fetch & promises.
 *
 * ```javascript
 * AjaxHelper.get('some-url').then(response => {
 *     // process request response here
 * });
 * ```
 *
 * Uploading file to server via FormData interface.
 * Please visit <https://developer.mozilla.org/en-US/docs/Web/API/FormData> for details.
 *
 * ```javascript
 * const formData = new FormData();
 * formData.append('file', 'fileNameToUpload');
 * AjaxHelper.post('file-upload-url', formData).then(response => {
 *     // process request response here
 * });
 * ```
 *
 */


var AjaxHelper = /*#__PURE__*/function () {
  function AjaxHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21___default()(this, AjaxHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22___default()(AjaxHelper, null, [{
    key: "get",

    /**
     * Make a request (using GET) to the specified url.
     * @param {String} url Url
     * @param {Object} [options] The options for the `fetch` API. Please see <https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch> for details
     * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
     * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
     * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
     * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
     * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
     * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
     * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
     */
    value: function get(url, options) {
      return this.fetch(url, options);
    }
    /**
     * POST data to the specified URL.
     * @param {String} url The URL
     * @param {String|Object|FormData} payload The data to post. If an object is supplied, it will be stringified
     * @param {Object} options The options for the `fetch` API. Please see <https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch> for details
     * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
     * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
     * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
     * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
     * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
     * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
     * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
     */

  }, {
    key: "post",
    value: function post(url, payload) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!(payload instanceof FormData) && !(typeof payload === 'string')) {
        payload = JSON.stringify(payload);
        options.headers = options.headers || {};
        options.headers['Content-Type'] = options.headers['Content-Type'] || 'application/json';
      }

      return this.fetch(url, Object.assign({
        method: 'POST',
        body: payload
      }, options));
    }
    /**
     * Fetch the specified resource using the `fetch` API.
     * @param {String} url object to fetch
     * @param {Object} options The options for the `fetch` API. Please see <https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch> for details
     * @param {Object} [options.method] The request method, e.g., GET, POST
     * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
     * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
     * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
     * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
     * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
     * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
     * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
     */

  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var controller = new AbortController(); // Need to assign AbortController individually, because IE11 polyfill of the Fetch API deletes 'signal' property on fetchOptions object

      Object.assign(options, {
        abortController: controller,
        signal: controller.signal
      });

      if (!('credentials' in options)) {
        options.credentials = 'include';
      }

      if (options.queryParams) {
        var params = Object.entries(options.queryParams);

        if (params.length) {
          url += (url.includes('?') ? '&' : '?') + params.map(function (_ref) {
            var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23___default()(_ref, 2),
                param = _ref2[0],
                value = _ref2[1];

            return "".concat(param, "=").concat(encodeURIComponent(value));
          }).join('&');
        }
      } // Promise that will be resolved either when network request is finished or when json is parsed


      var promise = new Promise(function (resolve, reject) {
        fetch(resourceRoot + url, options).then(function (response) {
          if (options.parseJson) {
            response.json().then(function (json) {
              response.parsedJson = json;
              resolve(response);
            }).catch(function (error) {
              response.parsedJson = null;
              response.error = error;
              reject(response);
            });
          } else {
            resolve(response);
          }
        }).catch(function (error) {
          error.stack = promise.stack; // Unless calling code aborted the request, reject this operation

          if (error.name !== 'AbortError') {
            reject(error);
          }
        });
      });
      promise.stack = new Error().stack;

      promise.abort = function () {
        controller.abort();
      };

      return promise;
    })
    /**
     * Registers the passed URL to return the passed mocked up Fetch Response object to the
     * AjaxHelper's promise resolve function.
     * @param {String} url The url to return mock data for
     * @param {Object|Function} response A mocked up Fetch Response object which must contain
     * at least a `responseText` property, or a function to which the `url` and a `params` object
     * and the `Fetch` `options` object is passed which returns that.
     * @param {String} response.responseText The data to return.
     * @param {Boolean} [response.synchronous] resolve the Promise immediately
     * @param {Number} [response.delay=100] resolve the Promise after this number of milliseconds.
     */

  }, {
    key: "mockUrl",
    value: function mockUrl(url, response) {
      var me = this;
      (me.mockAjaxMap || (me.mockAjaxMap = {}))[url] = response; // Inject the override into the AjaxHelper instance

      if (!AjaxHelper.originalFetch) {
        AjaxHelper.originalFetch = AjaxHelper.fetch;
      }

      AjaxHelper.fetch = me.mockAjaxFetch.bind(me);
    }
  }, {
    key: "mockAjaxFetch",
    value: function mockAjaxFetch(url, options) {
      var urlAndParams = url.split('?'),
          result = this.mockAjaxMap[urlAndParams[0]],
          parsedJson = null;

      if (result) {
        if (typeof result === 'function') {
          result = result(urlAndParams[0], urlAndParams[1] && parseParams(urlAndParams[1]), options);
        }

        try {
          parsedJson = options.parseJson && JSON.parse(result.responseText);
        } catch (error) {
          parsedJson = null;
          result.error = error;
        }

        result = Object.assign({
          status: 200,
          ok: true,
          headers: new Headers(),
          statusText: 'OK',
          url: url,
          parsedJson: parsedJson,
          text: function text() {
            return new Promise(function (resolve) {
              resolve(result.responseText);
            });
          },
          json: function json() {
            return new Promise(function (resolve) {
              resolve(parsedJson);
            });
          }
        }, result);
        return new Promise(function (resolve, reject) {
          if (result.synchronous) {
            resolve(result);
          } else {
            setTimeout(function () {
              resolve(result);
            }, 'delay' in result ? result.delay : 100);
          }
        });
      } else {
        return AjaxHelper.originalFetch(url, options);
      }
    }
  }]);

  return AjaxHelper;
}();


AjaxHelper._$name = 'AjaxHelper';

/***/ }),

/***/ "./lib/Core/helper/ArrayHelper.js":
/*!****************************************!*\
  !*** ./lib/Core/helper/ArrayHelper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ArrayHelper; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_number_is_nan__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.number.is-nan */ "./node_modules/core-js/modules/es.number.is-nan.js");
/* harmony import */ var core_js_modules_es_number_is_nan__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_is_nan__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_reflect_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.reflect.get */ "./node_modules/core-js/modules/es.reflect.get.js");
/* harmony import */ var core_js_modules_es_reflect_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_reflect_set__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.reflect.set */ "./node_modules/core-js/modules/es.reflect.set.js");
/* harmony import */ var core_js_modules_es_reflect_set__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_set__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_40__);










































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';
/**
* @module Core/helper/ArrayHelper
*/

/**
 * Helper with useful functions for handling Arrays
 * @internal
 */

var ArrayHelper = /*#__PURE__*/function () {
  function ArrayHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_39___default()(this, ArrayHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_40___default()(ArrayHelper, [{
    key: "magnitudeCompare",
    value: function magnitudeCompare(lhs, rhs) {
      return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
    }
  }, {
    key: "lexicalCompare",
    value: function lexicalCompare(lhs, rhs) {
      lhs = String(lhs);
      rhs = String(rhs);
      return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
    }
    /**
     * Similar to Array.prototype.fill(), but constructs a new array with the specified item count and fills it with
     * clones of the supplied item.
     * @param {Number} count Number of entries to create
     * @param {Object|Array} itemOrArray Item or array of items to clone (uses object spread to create shallow clone)
     * @param {Function} [fn] An optional function that is called for each item added, to allow processing
     * @returns {Array} A new populated array
     */

  }], [{
    key: "clean",
    value: function clean(array) {
      return array.reduce(function (res, item) {
        if (item !== null && item !== undefined && !(Array.isArray(item) && item.length === 0) && item !== '') res.push(item);
        return res;
      }, []);
    }
    /**
     * Remove one or more items from an array
     * @param {Array} array Array to remove from
     * @param {Object} items One or more items to remove
     * @returns {boolean} Returns true if any item was removed
     */

  }, {
    key: "remove",
    value: function remove(array) {
      var index,
          item,
          removed = false;

      for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
        item = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

        if ((index = array.indexOf(item)) !== -1) {
          array.splice(index, 1);
          removed = true;
        }
      }

      return removed;
    }
    /*
     * Calculates the insertion index of a passed object into the passed Array according
     * to the passed comparator function. Note that the passed Array *MUST* already be ordered.
     * @param {Object} item The item to calculate the insertion index for.
     * @param {Array} The array into which the item is to be inserted.
     * @param {Function} comparatorFn The comparison function. Must return -1 or 0 or 1.
     * @param {Object} comparatorFn.lhs The left object to compare.
     * @param {Object} comparatorFn.rhs The right object to compare.
     * @param {Number} index The possible correct index to try first before a binary
     * search is instigated.
     */

  }, {
    key: "findInsertionIndex",
    value: function findInsertionIndex(item, array) {
      var comparatorFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.lexicalCompare;
      var index = arguments.length > 3 ? arguments[3] : undefined;
      var len = array.length;
      var beforeCheck, afterCheck;

      if (index < len) {
        beforeCheck = index > 0 ? comparatorFn(array[index - 1], item) : 0;
        afterCheck = index < len - 1 ? comparatorFn(item, array[index]) : 0;

        if (beforeCheck < 1 && afterCheck < 1) {
          return index;
        }
      }

      return this.binarySearch(array, item, comparatorFn);
    }
    /**
     * Similar to the native Array.find call, but this finds the *last* element in the array for which
     * the passed function returns a truthy value.
     * @param {Object[]} array The array to find in.
     * @param {Function} fn The testing function.
     * @param {Object} [thisObj] The scope (`this` reference) in which to call the function.
     */

  }, {
    key: "findLast",
    value: function findLast(array, fn, thisObj) {
      for (var length = array.length, i = length - 1; i >= 0; i--) {
        if (fn.call(thisObj, array[i], i, array)) {
          return array[i];
        }
      }
    }
    /**
     * This method returns the index that a given item would be inserted into the
     * given (sorted) `array`. Note that the given `item` may or may not be in the
     * array. This method will return the index of where the item *should* be.
     *
     * For example:
     *
     *      var array = [ 'A', 'D', 'G', 'K', 'O', 'R', 'X' ];
     *      var index = ArrayHelper.binarySearch(array, 'E');
     *
     *      console.log('index: ' + index);
     *      // logs "index: 2"
     *
     *      array.splice(index, 0, 'E');
     *
     *      console.log('array : ' + array.join(''));
     *      // logs "array: ADEGKORX"
     *
     * @param {Object[]} array The array to search.
     * @param {Object} item The item that you want to insert into the `array`.
     * @param {Number} [begin=0] The first index in the `array` to consider.
     * @param {Number} [end=array.length] The index that marks the end of the range
     * to consider. The item at this index is *not* considered.
     * @param {Function} [compareFn] The comparison function that matches the sort
     * order of the `array`. The default `compareFn` compares items using less-than
     * and greater-than operators.
     * @return {Number} The index for the given item in the given array based on
     * the passed `compareFn`.
     */

  }, {
    key: "binarySearch",
    value: function binarySearch(array, item) {
      var begin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : array.length;
      var compareFn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.lexicalCompare;
      var length = array.length;
      var middle, comparison;

      if (begin instanceof Function) {
        compareFn = begin;
        begin = 0;
      } else if (end instanceof Function) {
        compareFn = end;
        end = length;
      }

      --end;

      while (begin <= end) {
        middle = begin + end >> 1;
        comparison = compareFn(item, array[middle]);

        if (comparison >= 0) {
          begin = middle + 1;
        } else if (comparison < 0) {
          end = middle - 1;
        }
      }

      return begin;
    }
  }, {
    key: "fill",
    value: function fill(count) {
      var itemOrArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var result = [],
          items = Array.isArray(itemOrArray) ? itemOrArray : [itemOrArray];

      for (var i = 0; i < count; i++) {
        var _iterator = _createForOfIteratorHelper(items),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            // Using object spread here forces us to use more babel plugins and will make
            // react_typescript demo very difficult to setup
            var processedItem = Object.assign({}, item);

            if (fn) {
              fn(processedItem, i);
            }

            result.push(processedItem);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return result;
    }
    /**
     * Populates an array with the return value from `fn`.
     * @param {Number} count Number of entries to create
     * @param {Function} fn A function that is called `count` times, return value is added to array
     * @param {Number} fn.index Current index in the array
     * @returns {Array} A new populated array
     */

  }, {
    key: "populate",
    value: function populate(count, fn) {
      var items = [];

      for (var i = 0; i < count; i++) {
        items.push(fn(i));
      }

      return items;
    }
    /**
     * Pushes `item` on to the `array` if not already included
     * @param {Array}  array Array to push to
     * @param {Object} item Item to push if not already included
     */

  }, {
    key: "include",
    value: function include(array, item) {
      if (!array.includes(item)) {
        array.push(item);
      }
    }
    /**
     * Returns a new array with the unique items from the supplied array.
     * @param {Array} array Input array
     * @returns {Array} New array with unique items
     */

  }, {
    key: "unique",
    value: function unique(array) {
      return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default()(new Set(array));
    } // Wanted to create an indexer on Stores, based on this. But turns out Proxy cannot be transpiled/polyfill for IE11
    // Keeping it for future reference

  }, {
    key: "allowNegative",
    value: function allowNegative(array) {
      // From https://github.com/sindresorhus/negative-array
      return new Proxy(array, {
        get: function get(target, name, receiver) {
          if (typeof name !== 'string') {
            return Reflect.get(target, name, receiver);
          }

          var index = Number(name);

          if (Number.isNaN(index)) {
            return Reflect.get(target, name, receiver);
          }

          return target[index < 0 ? target.length + index : index];
        },
        set: function set(target, name, value, receiver) {
          if (typeof name !== 'string') {
            return Reflect.set(target, name, value, receiver);
          }

          var index = Number(name);

          if (Number.isNaN(index)) {
            return Reflect.set(target, name, value, receiver);
          }

          target[index < 0 ? target.length + index : index] = value;
          return true;
        }
      });
    }
  }, {
    key: "delta",
    value: function delta(a, b) {
      var useRelativeNaming = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // Nicer syntax but about 40% slower (an extra iteration)
      // const
      //     onlyInA = a.filter(item => !b.includes(item)),
      //     onlyInB = b.filter(item => !a.includes(item)),
      //     inBoth  = a.filter(item => b.includes(item));
      // Quick bailout for nonexisting target array
      if (!b) {
        return useRelativeNaming ? {
          toAdd: a,
          toRemove: [],
          toKeep: []
        } : {
          onlyInA: a,
          onlyInB: [],
          inBoth: []
        };
      }

      var onlyInA = [],
          onlyInB = [],
          inBoth = [];

      for (var i = 0; i < a.length; i++) {
        var item = a[i];

        if (b.includes(item)) {
          inBoth.push(item);
        } else {
          onlyInA.push(item);
        }
      }

      for (var _i = 0; _i < b.length; _i++) {
        var _item = b[_i];

        if (!inBoth.includes(_item)) {
          onlyInB.push(_item);
        }
      }

      if (useRelativeNaming) {
        return {
          toAdd: onlyInA,
          toRemove: onlyInB,
          toKeep: inBoth
        };
      }

      return {
        onlyInA: onlyInA,
        onlyInB: onlyInB,
        inBoth: inBoth
      };
    }
  }]);

  return ArrayHelper;
}();


ArrayHelper._$name = 'ArrayHelper';

/***/ }),

/***/ "./lib/Core/helper/AsyncHelper.js":
/*!****************************************!*\
  !*** ./lib/Core/helper/AsyncHelper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AsyncHelper; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);




var productName = 'scheduler';
/**
 * @module Core/helper/AsyncHelper
 */

/**
 * A helper class to make asynchronous tasks `await` friendly.
 */

var AsyncHelper = /*#__PURE__*/function () {
  function AsyncHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, AsyncHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(AsyncHelper, null, [{
    key: "animationFrame",

    /**
     * Returns a promise that resolves on next animation frame.
     * ```
     *  async method() {
     *      // do work
     *      await AsyncHelper.animationFrame();
     *      // do more work
     *  }
     * ```
     * @returns {Promise}
     */
    value: function animationFrame() {
      return new Promise(function (resolve) {
        requestAnimationFrame(resolve);
      });
    }
    /**
     * Returns a promise that resolves after a specified number of milliseconds.
     * ```
     *  async method() {
     *      await AsyncHelper.sleep(10);
     *      // ...
     *  }
     * ```
     * @param {Number} millis The number of milliseconds to sleep.
     * @returns {Promise}
     */

  }, {
    key: "sleep",
    value: function sleep(millis) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, millis);
      });
    }
    /**
     * Returns a promise that resolves as soon as possible, allowing the browser to minimally process other messages.
     * This is the shortest possible delay the browser offers, so be aware that it does not necessarily allow the
     * browser to paint or reflow if used in a long loop. It does, however, allow other async methods to execute.
     * ```
     *  async method() {
     *      await AsyncHelper.yield();
     *      // ...
     *  }
     * ```
     * @returns {Promise}
     */

  }, {
    key: "yield",
    value: function _yield() {
      return Promise.resolve();
    }
  }]);

  return AsyncHelper;
}();


AsyncHelper._$name = 'AsyncHelper';

/***/ }),

/***/ "./lib/Core/helper/BrowserHelper.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/BrowserHelper.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BrowserHelper; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_global_this__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.global-this */ "./node_modules/core-js/modules/es.global-this.js");
/* harmony import */ var core_js_modules_es_global_this__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_global_this__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_from_entries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.from-entries */ "./node_modules/core-js/modules/es.object.from-entries.js");
/* harmony import */ var core_js_modules_es_object_from_entries__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_from_entries__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.search */ "./node_modules/core-js/modules/es.string.search.js");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_global_this__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.global-this */ "./node_modules/core-js/modules/esnext.global-this.js");
/* harmony import */ var core_js_modules_esnext_global_this__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.url */ "./node_modules/core-js/modules/web.url.js");
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__);


















var productName = 'scheduler';
/**
* @module Core/helper/BrowserHelper
*/

/**
 * Static helper class that does browser/feature detection.
 * @internal
 */

var BrowserHelper = /*#__PURE__*/function () {
  function BrowserHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, BrowserHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default()(BrowserHelper, null, [{
    key: "cacheFlags",
    value: function cacheFlags() {
      var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.platform;
      var userAgent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : navigator.userAgent;
      var me = this; // os

      me._isLinux = Boolean(platform.match(/Linux/));
      me._isMac = Boolean(platform.match(/Mac/));
      me._isWindows = Boolean(platform.match(/Win32/)); // browser

      me._isIE11 = Boolean(userAgent.match(/rv:11/));
      me._edgeVersion = me.getVersion(userAgent, /Edge?\/(\d+)\./);
      me._isEdge = me._edgeVersion > 0 && me._edgeVersion < 80;

      if (!me._isEdge) {
        me._edgeVersion = 0;
      } // Edge user agent contain webkit too


      me._isWebkit = Boolean(userAgent.match(/WebKit/)) && !me._isEdge;
      me._firefoxVersion = me.getVersion(userAgent, /Firefox\/(\d+)\./);
      me._isFirefox = me._firefoxVersion > 0;
      me._chromeVersion = !me._isEdge ? me.getVersion(userAgent, /Chrom(?:e|ium)\/(\d+)\./) : 0;
      me._isChrome = me._chromeVersion > 0;
      me._isSafari = Boolean(userAgent.match(/Safari/)) && !me._isChrome && !me._isEdge;
      me._isMobileSafari = Boolean(userAgent.match(/Mobile.*Safari/));
      me._isAndroid = Boolean(userAgent.match(/Android/g));

      try {
        document.querySelector(':scope'); // Scoped queries are not supported for custom element polyfill in firefox
        // https://app.assembla.com/spaces/bryntum/tickets/6781

        me.supportsQueryScope = !me._isFirefox;
      } catch (e) {
        me.supportsQueryScope = false;
      }

      me._supportsPassive = false;

      try {
        // If the browser asks the options object to yield its passive
        // property, we know it supports the object form options object
        // and passive listeners.
        document.addEventListener('__notvalid__', null, {
          get passive() {
            me._supportsPassive = true;
          }

        });
      } catch (e) {} //document.addEventListener("DOMContentLoaded", me.onDocumentReady);

    } // NOTE: Not allowed with CSP, moved to Grid#render()
    // /**
    //  * Feature and browser detection which requires the document to be loaded.
    //  * @private
    //  */
    // static onDocumentReady() {
    //     // Firefox includes a part of the Y scroller jutting up which is not needed.
    //     // Also need to "mitre" the horizontal scrollbar to leave the gap at the end.
    //     if (BrowserHelper.isFirefox) {
    //         CSSHelper.insertRule(`.b-virtual-scroller {height: ${DomHelper.scrollBarWidth}px;}`);
    //         CSSHelper.insertRule(`.b-virtual-scrollers {padding-right: ${DomHelper.scrollBarWidth}px;}`);
    //     }
    // }

    /**
     * Returns matched version for userAgent
     * @param String versionRe version match regular expression
     * @returns {Number} matched version
     * @readonly
     * @private
     */

  }, {
    key: "getVersion",
    value: function getVersion(userAgent, versionRe) {
      var match = userAgent.match(versionRe);
      return match ? parseInt(match[1]) : 0;
    }
    /**
     * Tries to determine if the user is using a touch device
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "setLocalStorageItem",
    value: function setLocalStorageItem(key, value) {
      this.storageAvailable && localStorage.setItem(key, value);
    }
  }, {
    key: "getLocalStorageItem",
    value: function getLocalStorageItem(key) {
      return this.storageAvailable && localStorage.getItem(key);
    }
  }, {
    key: "removeLocalStorageItem",
    value: function removeLocalStorageItem(key) {
      this.storageAvailable && localStorage.removeItem(key);
    }
    /**
     * Returns parameter value from search string by parameter name.
     * @param {String} paramName search parameter name
     * @param {*} [defaultValue] default value if parameter not found
     * @param {String} [search] search string. Defaults to `document.location.search`
     */

  }, {
    key: "searchParam",
    value: function searchParam(paramName) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document.location.search;
      var re = new RegExp("[?&]".concat(paramName, "=([^&]*)")),
          match = search.match(re);
      return match && match[1] || defaultValue;
    }
  }, {
    key: "getCookie",
    value: function getCookie(name) {
      var nameEq = encodeURIComponent(name) + '=',
          cookieItems = document.cookie.split(';');

      for (var i = 0; i < cookieItems.length; i++) {
        var c = cookieItems[i];

        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEq) === 0) {
          return decodeURIComponent(c.substring(nameEq.length, c.length));
        }
      }

      return '';
    }
    /**
     * Triggers a download of a file with the specified name / URL.
     * @param {String} filename The filename of the file to be downloaded
     * @param {String} [url] The URL where the file is to be downloaded from
     */

  }, {
    key: "download",
    value: function download(filename, url) {
      var a = document.createElement('a');
      a.download = filename;
      a.href = url || filename;
      a.style.cssText = 'display:none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    /**
     * Triggers a download of a Blob with the specified name.
     * @param {Blob} blob The Blob to be downloaded
     * @param {String} filename The filename of the file to be downloaded
     */

  }, {
    key: "downloadBlob",
    value: function downloadBlob(blob, filename) {
      var url = window.URL.createObjectURL(blob);
      this.download(filename, url);
      window.URL.revokeObjectURL(url);
    }
  }, {
    key: "copyToClipboard",
    value: function copyToClipboard(code) {
      var success = true;
      var textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.style.height = textArea.style.width = 0;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (e) {
        success = false;
      }

      textArea.remove();
      return success;
    }
  }, {
    key: "isTouchDevice",
    get: function get() {
      if ('_isTouchDevice' in this) return this._isTouchDevice;
      return 'ontouchstart' in window || // edge tends to always have this with a value 2
      !this.isEdge && navigator.maxTouchPoints > 0 || // but if env is actually touchable, then window has this class present
      this.isEdge && window.TouchEvent || navigator.msMaxTouchPoints > 0;
    },
    // Since touch screen detection is unreliable we should allow client to configure it, or detect first touch
    set: function set(value) {
      this._isTouchDevice = value;
    }
    /**
     * Checks if platform is mac
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "supportsPointerEvents",
    get: function get() {
      return Boolean(window.PointerEvent || window.MSPointerEvent);
    }
  }, {
    key: "isMac",
    get: function get() {
      return this._isMac;
    }
    /**
     * Checks if platform is windows
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "isWindows",
    get: function get() {
      return this._isWindows;
    }
    /**
     * Checks if platform is linux
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "isLinux",
    get: function get() {
      return this._isLinux;
    }
    /**
     * Checks if browser is IE11
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "isIE11",
    get: function get() {
      return this._isIE11;
    }
    /**
     * Checks if browser is Edge
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "isEdge",
    get: function get() {
      return this._isEdge;
    }
    /**
     * Find the major Edge version
     * @returns {Number} Edge version or 0 for other browsers
     * @readonly
     */

  }, {
    key: "edgeVersion",
    get: function get() {
      return this._edgeVersion;
    }
    /**
     * Checks if browser is Webkit
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "isWebkit",
    get: function get() {
      return this._isWebkit;
    }
    /**
     * Checks if browser is Chrome
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "isChrome",
    get: function get() {
      return this._isChrome;
    }
    /**
     * Find the major Chrome version
     * @returns {Number} Chrome version or 0 for other browsers
     * @readonly
     */

  }, {
    key: "chromeVersion",
    get: function get() {
      return this._chromeVersion;
    }
    /**
     * Checks if browser is Firefox
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "isFirefox",
    get: function get() {
      return this._isFirefox;
    }
    /**
     * Find the major Firefox version.
     * @returns {Number} Firefox version or 0 for other browsers
     * @readonly
     */

  }, {
    key: "firefoxVersion",
    get: function get() {
      return this._firefoxVersion;
    }
    /**
     * Checks if browser is Safari
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "isSafari",
    get: function get() {
      return this._isSafari;
    }
    /**
     * Checks if browser is mobile Safari
     * @returns {Boolean}
     * @readonly
     */

  }, {
    key: "isMobileSafari",
    get: function get() {
      return this._isMobileSafari;
    }
  }, {
    key: "isAndroid",
    get: function get() {
      return this._isAndroid;
    }
    /**
     * Returns `true` if the browser supports passive event listeners.
     */

  }, {
    key: "supportsPassive",
    get: function get() {
      return this._supportsPassive;
    } // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API

  }, {
    key: "storageAvailable",
    get: function get() {
      var storage, x;

      try {
        storage = localStorage;
        x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (e) {
        return e instanceof DOMException && ( // everything except Firefox
        e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage.length !== 0;
      }
    }
  }, {
    key: "queryString",
    get: function get() {
      // new URLSearchParams throws in salesforce
      // https://github.com/salesforce/lwc/issues/1812
      var params = new URL(window.location.href).searchParams;
      return Object.fromEntries(params.entries());
    }
  }, {
    key: "isBrowserEnv",
    get: function get() {
      return typeof window !== 'undefined';
    }
  }, {
    key: "global",
    get: function get() {
      return typeof window !== 'undefined' ? window // eslint-disable-next-line no-undef
      : typeof global !== 'undefined' ? global : globalThis || {};
    }
  }]);

  return BrowserHelper;
}();



if (BrowserHelper.isBrowserEnv) {
  BrowserHelper.cacheFlags();
}

BrowserHelper._$name = 'BrowserHelper';
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../node_modules/webpack/buildin/global.js */ "../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./lib/Core/helper/CSSHelper.js":
/*!**************************************!*\
  !*** ./lib/Core/helper/CSSHelper.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CSSHelper; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");



var productName = 'scheduler';

/**
 * @module Core/helper/CSSHelper
 */

/**
 * Provides methods to add and manipulate CSS style rules.
 *
 * Note that this class is incompatible with [CSP](https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP)
 *
 * ```
 * this.criticalRule = CSSHelper.insertRule(`#${this.id} .b-sch-event.critical {background-color:${this.criticalColor}}`);
 * ```
 */

var CSSHelper = /*#__PURE__*/function () {
  function CSSHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, CSSHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(CSSHelper, null, [{
    key: "insertRule",

    /**
     * Inserts a CSS style rule based upon the passed text
     * @param {String} cssText The text of the rule including selector and rule body just as it would
     * be specified in a CSS file.
     * @returns {CSSRule} The resulting CSS Rule object if the add was successful.
     */
    value: function insertRule(cssText) {
      var styleSheet = this.styleSheet,
          oldCount = styleSheet.cssRules.length;
      styleSheet.insertRule(cssText, 0); // Only return element zero if the add was successful.

      if (styleSheet.cssRules.length > oldCount) {
        return styleSheet.cssRules[0];
      }
    }
    /**
     * Looks up the first rule which matched the passed selector.
     * @param {String|Function} selector Either the selector string to exactly match or a function which
     * when passed a required selector, returns `true`.
     * @returns {CSSRule} The first matching CSS Rule object if any found.
     */

  }, {
    key: "findRule",
    value: function findRule(selector) {
      var result,
          isFn = typeof selector === 'function'; // Array#find will stop when the function returns true, stop when the inner
      // find call yields a value from the search string.
      // Array#find better: to http://www.andygup.net/fastest-way-to-find-an-item-in-a-javascript-array/

      Array.prototype.find.call(document.head.querySelectorAll('link[rel=stylesheet],style[type*=css]'), function (element) {
        result = Array.prototype.find.call(element.sheet.rules || element.sheet.cssRules, function (r) {
          return isFn ? selector(r) : r.selectorText === selector;
        });

        if (result) {
          return true;
        }
      });
      return result;
    }
  }, {
    key: "styleSheet",
    get: function get() {
      if (!this._stylesheet) {
        this._stylesheet = _DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
          tag: 'style',
          id: 'bryntum-private-styles',
          type: 'text/css',
          parent: document.head
        }).sheet;
      }

      return this._stylesheet;
    }
  }]);

  return CSSHelper;
}();


CSSHelper._$name = 'CSSHelper';

/***/ }),

/***/ "./lib/Core/helper/DateHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/DateHelper.js ***!
  \***************************************/
/*! exports provided: unitMagnitudes, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unitMagnitudes", function() { return unitMagnitudes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateHelper; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_math_sign__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.math.sign */ "./node_modules/core-js/modules/es.math.sign.js");
/* harmony import */ var core_js_modules_es_math_sign__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_math_sign__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_math_trunc__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.math.trunc */ "./node_modules/core-js/modules/es.math.trunc.js");
/* harmony import */ var core_js_modules_es_math_trunc__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_math_trunc__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_string_pad_end__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/es.string.pad-end */ "./node_modules/core-js/modules/es.string.pad-end.js");
/* harmony import */ var core_js_modules_es_string_pad_end__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_pad_end__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/es.string.pad-start */ "./node_modules/core-js/modules/es.string.pad-start.js");
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/construct */ "./node_modules/@babel/runtime/helpers/construct.js");
/* harmony import */ var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");










































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var toString = Object.prototype.toString,
    DATE_TYPE = toString.call(new Date()),
    enOrdinalSuffix = function enOrdinalSuffix(number) {
  return number + ({
    1: 'st',
    2: 'nd',
    3: 'rd'
  }[number[number.length - 1]] || 'th');
},
    LTRSymbolRegexp = new RegExp("\u200E", 'g'),
    defaultValue = function defaultValue(value, defValue) {
  return isNaN(value) || value == null ? defValue : value;
},
    useIntlFormat = function useIntlFormat(name, options, date) {
  var formatter = intlFormatterCache[name] || (intlFormatterCache[name] = new Intl.DateTimeFormat(locale, options));
  var result = formatter.format(date); // IE11 inserts direction control characters to the string
  // This removes the characters

  if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].isIE11) {
    result = result.replace(LTRSymbolRegexp, '');
  }

  return result;
},
    formatTime = function formatTime(name, options, date) {
  var isShort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var strTime = useIntlFormat(name, options, date); // remove "0" from time when has AM/PM (from 01:00 PM to 1:00 PM): https://github.com/bryntum/support/issues/1483

  if (/am|pm/i.test(strTime)) {
    // remove first character only if is 0
    strTime = strTime.replace(/^0/, ''); // if isShort is true, remove minutes if is :00

    if (isShort) {
      strTime = strTime.replace(/:00/, '');
    }
  }

  return strTime;
},
    getDayDiff = function getDayDiff(end, start) {
  return Math.floor((end.getTime() - start.getTime() - (end.getTimezoneOffset() - start.getTimezoneOffset()) * validConversions.minute.millisecond) / validConversions.day.millisecond) + 1;
},
    normalizeDay = function normalizeDay(day) {
  return day >= 0 ? day : day + 7;
}; // These vars are set when changing locale


var locale = 'en-US',
    ordinalSuffix = enOrdinalSuffix,
    // Used to cache used formats, to not have to parse format string each time
formatCache = {},
    intlFormatterCache = {},
    parserCache = {};

var DEFAULT_YEAR = 2020,
    // 2020 is the year that has no issues in Safari and Edge, see: https://github.com/bryntum/support/issues/554
DEFAULT_MONTH = 0,
    DEFAULT_DAY = 1,
    formats = {
  // 1, 2, ... 11, 12
  M: function M(date) {
    return date.getMonth() + 1;
  },
  //date.toLocaleDateString(locale, { month : 'numeric' }),
  // 1st, 2nd, 3rd, 4th, ... 11th, 12th
  Mo: function Mo(date) {
    return ordinalSuffix(formats.M(date).toString());
  },
  // 01, 02, ...
  MM: function MM(date) {
    return (date.getMonth() + 1).toString().padStart(2, '0');
  },
  //date.toLocaleDateString(locale, { month : '2-digit' }),
  // Jan, Feb, ...
  MMM: function MMM(date) {
    return useIntlFormat('MMM', {
      month: 'short'
    }, date);
  },
  // January, February, ...
  MMMM: function MMMM(date) {
    return useIntlFormat('MMMM', {
      month: 'long'
    }, date);
  },
  // 1, 2, ...
  Q: function Q(date) {
    return Math.ceil((date.getMonth() + 1) / 3);
  },
  // 1st, 2nd, ...
  Qo: function Qo(date) {
    return ordinalSuffix(formats.Q(date).toString());
  },
  // 1, 2, ...
  D: function D(date) {
    return date.getDate();
  },
  //date.toLocaleDateString(locale, { day : 'numeric' }),
  // 1st, 2nd, ...
  Do: function Do(date) {
    return ordinalSuffix(formats.D(date).toString());
  },
  // 01, 02, ...
  DD: function DD(date) {
    return date.getDate().toString().padStart(2, '0');
  },
  //date.toLocaleDateString(locale, { day : '2-digit' }),
  // 1, 2, ..., 365, 365
  DDD: function DDD(date) {
    return Math.ceil((new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0) - new Date(date.getFullYear(), 0, 0, 12, 0, 0)) / validConversions.day.millisecond);
  },
  // 1st, 2nd, ...
  DDDo: function DDDo(date) {
    return ordinalSuffix(formats.DDD(date).toString());
  },
  // 001, 002, ...
  DDDD: function DDDD(date) {
    return formats.DDD(date).toString().padStart(3, '0');
  },
  // 0, 1, ..., 6
  d: function d(date) {
    return date.getDay();
  },
  // 0th, 1st, ...
  do: function _do(date) {
    return ordinalSuffix(date.getDay().toString());
  },
  // S, M, ...
  d1: function d1(date) {
    return formats.ddd(date).substring(0, 1);
  },
  // Su, Mo, ...
  dd: function dd(date) {
    return formats.ddd(date).substring(0, 2);
  },
  // Sun, Mon, ...
  ddd: function ddd(date) {
    return useIntlFormat('ddd', {
      weekday: 'short'
    }, date);
  },
  // Sunday, Monday, ...
  dddd: function dddd(date) {
    return useIntlFormat('dddd', {
      weekday: 'long'
    }, date);
  },
  e: function e(date) {
    return date.getDay();
  },
  E: function E(date) {
    return date.getDay() + 1;
  },
  // ISO week, 1, 2, ...
  W: function W(date) {
    return DateHelper.getWeekNumber(date)[1];
  },
  Wo: function Wo(date) {
    return ordinalSuffix(formats.W(date).toString());
  },
  WW: function WW(date) {
    return formats.W(date).toString().padStart(2, '0');
  },
  // 1979, 2018
  Y: function Y(date) {
    return date.getFullYear();
  },
  //date.toLocaleDateString(locale, { year : 'numeric' }),
  // 79, 18
  YY: function YY(date) {
    return date.getFullYear() % 100;
  },
  //date.toLocaleDateString(locale, { year : '2-digit' }),
  // 1979, 2018
  YYYY: function YYYY(date) {
    return date.getFullYear();
  },
  //date.toLocaleDateString(locale, { year : 'numeric' }),
  // AM, PM
  A: function A(date) {
    return date.getHours() < 12 ? 'AM' : 'PM';
  },
  a: function a(date) {
    return date.getHours() < 12 ? 'am' : 'pm';
  },
  // 0, 1, ... 23
  H: function H(date) {
    return date.getHours();
  },
  // 00, 01, ...
  HH: function HH(date) {
    return date.getHours().toString().padStart(2, '0');
  },
  // 1, 2, ... 12
  h: function h(date) {
    return date.getHours() % 12 || 12;
  },
  // 01, 02, ...
  hh: function hh(date) {
    return formats.h(date).toString().padStart(2, '0');
  },
  // 1, 2, ... 24
  k: function k(date) {
    return date.getHours() + 1;
  },
  // 01, 02, ...
  kk: function kk(date) {
    return formats.k(date).toString().padStart(2, '0');
  },
  // Locale specific (0 -> 24 or 1 AM -> 12 PM)
  K: function K(date) {
    return formatTime('K', {
      hour: 'numeric'
    }, date);
  },
  // Locale specific (00 -> 24 or 1 AM -> 12 PM)
  KK: function KK(date) {
    return formatTime('KK', {
      hour: '2-digit'
    }, date);
  },
  // 0, 1, ... 59
  m: function m(date) {
    return date.getMinutes();
  },
  //date.toLocaleTimeString(locale, { minute : 'numeric' }),
  // 00, 01, ...
  mm: function mm(date) {
    return formats.m(date).toString().padStart(2, '0');
  },
  // 0, 1, ... 59
  s: function s(date) {
    return date.getSeconds();
  },
  //date.toLocaleTimeString(locale, { second : 'numeric' }),
  // 00, 01, ...
  ss: function ss(date) {
    return formats.s(date).toString().padStart(2, '0');
  },
  // 0, 1, ... 9
  S: function S(date) {
    return date.getMilliseconds().toString().substr(0, 1);
  },
  // 00, 01, ... 99
  SS: function SS(date) {
    return date.getMilliseconds().toString().substr(0, 2).padEnd(2, '0');
  },
  // 000, 001, ... 999
  SSS: function SSS(date) {
    return date.getMilliseconds().toString().substr(0, 3).padEnd(3, '0');
  },
  z: function z(date) {
    return useIntlFormat('z', {
      timeZoneName: 'short'
    }, date);
  },
  zz: function zz(date) {
    return useIntlFormat('zz', {
      timeZoneName: 'long'
    }, date);
  },
  Z: function Z(date) {
    return DH.getGMTOffset(date);
  },
  LT: function LT(date) {
    return formatTime('LT', {
      hour: '2-digit',
      minute: '2-digit'
    }, date);
  },
  // if minutes is 0, doesn't show it
  LST: function LST(date) {
    return formatTime('LST', {
      hour: 'numeric',
      minute: '2-digit'
    }, date, true);
  },
  LTS: function LTS(date) {
    return formatTime('LTS', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }, date);
  },
  L: function L(date) {
    return useIntlFormat('L', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }, date);
  },
  l: function l(date) {
    return useIntlFormat('l', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }, date);
  },
  LL: function LL(date) {
    return useIntlFormat('LL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }, date);
  },
  ll: function ll(date) {
    return useIntlFormat('ll', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }, date);
  },
  LLL: function LLL(date) {
    return useIntlFormat('LLL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    }, date);
  },
  lll: function lll(date) {
    return useIntlFormat('lll', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    }, date);
  },
  LLLL: function LLLL(date) {
    return useIntlFormat('LLLL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      weekday: 'long'
    }, date);
  },
  llll: function llll(date) {
    return useIntlFormat('llll', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      weekday: 'short'
    }, date);
  }
},
    // Want longest keys first, to not stop match at L of LTS etc.
formatKeys = Object.keys(formats).sort(function (a, b) {
  return b.length - a.length;
}),
    formatRegexp = "^(?:".concat(formatKeys.join('|'), ")"),
    // return empty object, meaning value cannot be processed to a valuable date part
emptyFn = function emptyFn() {
  return {};
},
    isNumber = function isNumber(str) {
  return numberRegex.test(str);
},
    parseMilliseconds = function parseMilliseconds(str) {
  return isNumber(str) && {
    milliseconds: parseInt(str.padEnd(3, '0').substring(0, 3))
  };
},
    parsers = {
  YYYY: function YYYY(str) {
    return {
      year: parseInt(str)
    };
  },
  Y: function Y(str) {
    return {
      year: parseInt(str)
    };
  },
  YY: function YY(str) {
    var year = parseInt(str);
    return {
      year: year + (year > 1968 ? 1900 : 2000)
    };
  },
  MM: function MM(str) {
    return {
      month: parseInt(str) - 1
    };
  },
  Mo: function Mo(str) {
    return {
      month: parseInt(str) - 1
    };
  },
  DD: function DD(str) {
    return {
      date: parseInt(str)
    };
  },
  M: function M(str) {
    return {
      month: parseInt(str) - 1
    };
  },
  D: function D(str) {
    return {
      date: parseInt(str)
    };
  },
  Do: function Do(str) {
    return {
      date: parseInt(str)
    };
  },
  DDD: emptyFn,
  MMM: emptyFn,
  MMMM: emptyFn,
  DDDo: emptyFn,
  DDDD: emptyFn,
  d: emptyFn,
  do: emptyFn,
  d1: emptyFn,
  dd: emptyFn,
  ddd: emptyFn,
  dddd: emptyFn,
  Q: emptyFn,
  Qo: emptyFn,
  W: emptyFn,
  Wo: emptyFn,
  WW: emptyFn,
  e: emptyFn,
  E: emptyFn,
  HH: function HH(str) {
    return {
      hours: parseInt(str)
    };
  },
  hh: function hh(str) {
    return {
      hours: parseInt(str)
    };
  },
  mm: function mm(str) {
    return {
      minutes: parseInt(str)
    };
  },
  H: function H(str) {
    return {
      hours: parseInt(str)
    };
  },
  m: function m(str) {
    return {
      minutes: parseInt(str)
    };
  },
  ss: function ss(str) {
    return {
      seconds: parseInt(str)
    };
  },
  s: function s(str) {
    return {
      seconds: parseInt(str)
    };
  },
  S: parseMilliseconds,
  SS: parseMilliseconds,
  SSS: parseMilliseconds,
  A: function A(str) {
    return {
      amPm: str.toLowerCase()
    };
  },
  a: function a(str) {
    return {
      amPm: str.toLowerCase()
    };
  },
  L: 'MM/DD/YYYY',
  LT: 'HH:mm A',
  // Can either be Z (=UTC, 0) or +-HH:MM
  Z: function Z(str) {
    if (!str || !timeZoneRegEx.test(str) && str !== 'Z') {
      return null;
    }

    var timeZone = 0; // If string being parsed is more "detailed" than the format specified we can have more chars left,
    // thus check the last (for example HH:mmZ with input HH:mm:ssZ -> ssZ)

    if (str !== 'Z') {
      var matches = timeZoneRegEx.exec(str); // If timezone regexp matches, sting has time zone offset like '+02:00'

      if (matches) {
        var sign = matches[1] === '+' ? 1 : -1,
            hours = parseInt(matches[2]) || 0,
            minutes = parseInt(matches[3]) || 0;
        timeZone = sign * (hours * 60 + minutes);
      } // otherwise we just return current time zone, because there's a Z key in the input
      else {
          timeZone = -1 * new Date().getTimezoneOffset();
        }
    }

    return {
      timeZone: timeZone
    };
  }
},
    parserKeys = Object.keys(parsers).sort(function (a, b) {
  return b.length - a.length;
}),
    parserRegexp = new RegExp("(".concat(parserKeys.join('|'), ")")),
    // Following regexp includes all formats that should be handled by Date class
localeStrRegExp = new RegExp('(l|LL|ll|LLL|lll|LLLL|llll)'),
    //    ISODateRegExp             = new RegExp('YYYY-MM-DD[T ]HH:mm:ss(.s+)?Z'),
// Some validConversions are negative to show that it's not an exact conversion, just an estimate.
validConversions = {
  // The units below assume:
  // 30 days in a month, 91 days for a quarter and 365 for a year
  // 52 weeks per year, 4 per month, 13 per quarter
  year: {
    year: 1,
    quarter: 4,
    month: 12,
    week: 52,
    day: 365,
    hour: 24 * 365,
    minute: 1440 * 365,
    second: 86400 * 365,
    millisecond: 86400000 * 365
  },
  quarter: {
    year: 1 / 4,
    quarter: 1,
    month: 3,
    week: 4,
    day: 91,
    hour: 24 * 91,
    minute: 1440 * 91,
    second: 86400 * 91,
    millisecond: 86400000 * 91
  },
  month: {
    year: 1 / 12,
    quarter: 1 / 3,
    month: 1,
    week: 4,
    day: -30,
    hour: -24 * 30,
    minute: -1440 * 30,
    second: -86400 * 30,
    millisecond: -86400000 * 30
  },
  week: {
    year: -1 / 52,
    quarter: -1 / 13,
    month: -1 / 4,
    day: 7,
    hour: 168,
    minute: 10080,
    second: 604800,
    millisecond: 604800000
  },
  day: {
    year: -1 / 365,
    quarter: -1 / 91,
    month: -1 / 30,
    week: 1 / 7,
    hour: 24,
    minute: 1440,
    second: 86400,
    millisecond: 86400000
  },
  hour: {
    year: -1 / (365 * 24),
    quarter: -1 / (91 * 24),
    month: -1 / (30 * 24),
    week: 1 / 168,
    day: 1 / 24,
    minute: 60,
    second: 3600,
    millisecond: 3600000
  },
  minute: {
    year: -1 / (365 * 1440),
    quarter: -1 / (91 * 1440),
    month: -1 / (30 * 1440),
    week: 1 / 10080,
    day: 1 / 1440,
    hour: 1 / 60,
    second: 60,
    millisecond: 60000
  },
  second: {
    year: -1 / (365 * 86400),
    quarter: -1 / (91 * 86400),
    month: -1 / (30 * 86400),
    week: 1 / 604800,
    day: 1 / 86400,
    hour: 1 / 3600,
    minute: 1 / 60,
    millisecond: 1000
  },
  millisecond: {
    year: -1 / (365 * 86400000),
    quarter: -1 / (91 * 86400000),
    month: -1 / (30 * 86400000),
    week: 1 / 604800000,
    day: 1 / 86400000,
    hour: 1 / 3600000,
    minute: 1 / 60000,
    second: 1 / 1000
  }
},
    normalizedUnits = {
  ms: 'millisecond',
  milliseconds: 'millisecond',
  s: 'second',
  seconds: 'second',
  m: 'minute',
  minutes: 'minute',
  h: 'hour',
  hours: 'hour',
  d: 'day',
  days: 'day',
  w: 'week',
  weeks: 'week',
  M: 'month',
  months: 'month',
  q: 'quarter',
  quarters: 'quarter',
  y: 'year',
  years: 'year'
},
    withDecimalsDurationRegex = /^\s*([-+]?\d+(?:[.,]\d*)?|[-+]?(?:[.,]\d+))\s*([^\s]+)?/i,
    noDecimalsDurationRegex = /^\s*([-+]?\d+)(?![.,])\s*([^\s]+)?/i,
    canonicalUnitNames = ['millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'],
    canonicalUnitAbbreviations = [['mil'], ['s', 'sec'], ['m', 'min'], ['h', 'hr'], ['d'], ['w', 'wk'], ['mo', 'mon', 'mnt'], ['q', 'quar', 'qrt'], ['y', 'yr']],
    deltaUnits = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'],
    // Used when creating a date from an object, to fill in any blanks
dateProperties = ['milliseconds', 'seconds', 'minutes', 'hours', 'date', 'month', 'year'],
    // TODO: Should we provide special number parsing?
parseNumber = function parseNumber(n) {
  var result = parseFloat(n);
  return isNaN(result) ? null : result;
},
    numberRegex = /^[0-9]+$/,
    timeZoneRegEx = /([+-])(\d\d):*(\d\d)*$/,
    unitMagnitudes = {
  millisecond: 0,
  second: 1,
  minute: 2,
  hour: 3,
  day: 4,
  week: 5,
  month: 6,
  quarter: 7,
  year: 8
},
    snapFns = {
  round: function round(number) {
    var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Math.round(number / step) * step;
  },
  floor: function floor(number) {
    var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Math.floor(number / step) * step;
  },
  ceil: function ceil(number) {
    var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Math.ceil(number / step) * step;
  }
},
    keyCache = {};


/**
 * @module Core/helper/DateHelper
 */

/**
 * Helps with date manipulation, comparison, parsing, formatting etc.
 *
 * ## Parsing strings
 * Use `DateHelper.parse()` to parse strings into dates. It accepts a date string and a format specifier.
 * The format specifier is string built up using the following tokens:
 *
 * | Unit        | Token | Description                |
 * |-------------|-------|----------------------------|
 * | Year        | YYYY  | 2018                       |
 * |             | YY    | < 68 -> 2000, > 68 -> 1900 |
 * | Month       | MM    | 01 - 12                    |
 * | Date        | DD    | 01 - 31                    |
 * | Hour        | HH    | 00 - 23 or 1 - 12          |
 * | Minute      | mm    | 00 - 59                    |
 * | Second      | ss    | 00 - 59                    |
 * | Millisecond | S     | 0 - 9                      |
 * |             | SS    | 00 - 99                    |
 * |             | SSS   | 000 - 999                  |
 * | AM/PM       | A     | AM or PM                   |
 * |             | a     | am or pm                   |
 * | TimeZone    | Z     | Z for UTC or +-HH:mm       |
 * | Predefined  | L     | Long date, MM/DD/YYYY      |
 * |             | LT    | Long time, HH:mm A         |
 *
 * Default parse format is: `'YYYY-MM-DDTHH:mm:ss.SSSZ'` see {@link #property-defaultParseFormat-static}
 *
 * For example:
 * ```
 * DateHelper.parse('2018-11-06', 'YYYY-MM-DD');
 * DateHelper.parse('13:14', 'HH:mm');
 * DateHelper.parse('6/11/18', 'DD/MM/YY');
 * ```
 *
 * ## Formatting dates
 * Use `DateHelper.format()` to create a string from a date using a format specifier. The format specifier is similar to
 * that used when parsing strings. It can use the following tokens (input used for output below is
 * `new Date(2018,8,9,18,7,8,145)`):
 *
 * | Unit                  | Token | Description & output                  |
 * |-----------------------|-------|---------------------------------------|
 * | Year                  | YYYY  | 2018                                  |
 * |                       | YY    | 18                                    |
 * |                       | Y     | 2018                                  |
 * | Quarter               | Q     | 3                                     |
 * |                       | Qo    | 3rd                                   |
 * | Month                 | MMMM  | September                             |
 * |                       | MMM   | Sep                                   |
 * |                       | MM    | 09                                    |
 * |                       | Mo    | 9th                                   |
 * |                       | M     | 9                                     |
 * | Week (iso)            | WW    | 36 (2 digit)                          |
 * |                       | Wo    | 36th                                  |
 * |                       | W     | 36                                    |
 * | Date                  | DDDD  | Day of year, 3 digits                 |
 * |                       | DDDo  | Day of year, ordinal                  |
 * |                       | DDD   | Day of year                           |
 * |                       | DD    | 09                                    |
 * |                       | Do    | 9th                                   |
 * |                       | D     | 9                                     |
 * | Weekday               | dddd  | Sunday                                |
 * |                       | ddd   | Sun                                   |
 * |                       | dd    | Su                                    |
 * |                       | do    | 0th                                   |
 * |                       | d     | 0                                     |
 * | Hour                  | HH    | 18 (00 - 23)                          |
 * |                       | H     | 18 (0 - 23)                           |
 * |                       | hh    | 06 (00 - 12)                          |
 * |                       | h     | 6 (0 - 12)                            |
 * |                       | KK    | 19 (01 - 24)                          |
 * |                       | K     | 19 (1 - 24)                           |
 * |                       | kk    | 06 or 18, locale determines           |
 * |                       | k     | 6 or 18, locale determines            |
 * | Minute                | mm    | 07                                    |
 * |                       | m     | 7                                     |
 * | Second                | ss    | 08                                    |
 * |                       | s     | 8                                     |
 * | Millisecond           | S     | 1                                     |
 * |                       | SS    | 14                                    |
 * |                       | SSS   | 145                                   |
 * | AM/PM                 | A     | AM or PM                              |
 * |                       | a     | am or pm                              |
 * | Predefined            | LT    | H: 2-digit (2d), m: 2d                |
 * | (uses browser locale) | LTS   | H: 2d, m: 2d, s : 2d                  |
 * |                       | LST   | Depends on 12 or 24 hour clock        |
 * |                       |       | 12h, H : 1d, m : 0 or 2d              |
 * |                       |       | 24h, H : 2d, m : 2d                   |
 * |                       | L     | Y: numeric (n), M : 2d, D : 2d        |
 * |                       | l     | Y: n, M : n, D : n                    |
 * |                       | LL    | Y: n, M : long (l), D : n             |
 * |                       | ll    | Y: n, M : short (s), D : n            |
 * |                       | LLL   | Y: n, M : l, D : n, H: n, m: 2d       |
 * |                       | lll   | Y: n, M : s, D : n, H: n, m: 2d       |
 * |                       | LLLL  | Y: n, M : l, D : n, H: n, m: 2d, d: l |
 * |                       | llll  | Y: n, M : s, D : n, H: n, m: 2d, d: s |
 *
 *
 * Default format is: `'YYYY-MM-DDTHH:mm:ssZ'` see {@link #property-defaultFormat-static}
 *
 * For example:
 *
 * ```javascript
 * DateHelper.format(new Date(2018,10,6), 'YYYY-MM-DD'); // 2018-11-06
 * DateHelper.format(new Date(2018,10,6), 'M/D/YY'); // 11/6/18
 * ```
 *
 * Arbitrary text can be embedded in the format string by wrapping it with {}:
 *
 * ```javascript
 * DateHelper.format(new Date(2019, 7, 16), '{It is }dddd{, yay!}') -> It is Friday, yay!
 * ```
 *
 * ## Unit names
 * Many DateHelper functions (for example add, as, set) accepts a unit among their params. The following units are
 * available:
 *
 * | Unit        | Aliases                       |
 * |-------------|-------------------------------|
 * | millisecond | millisecond, milliseconds, ms |
 * | second      | second, seconds, s            |
 * | minute      | minute, minutes, m            |
 * | hour        | hour, hours, h                |
 * | day         | day, days, d                  |
 * | week        | week, weeks, w                |
 * | month       | month, months, M              |
 * | quarter     | quarter, quarters, q          |
 * | year        | year, years, y                |
 *
 * For example:
 * ```javascript
 * DateHelper.add(date, 2, 'days');
 * DateHelper.as('hour', 7200, 'seconds');
 * ```
 */

var DateHelper = /*#__PURE__*/function (_Localizable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default()(DateHelper, _Localizable);

  var _super = _createSuper(DateHelper);

  function DateHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_36___default()(this, DateHelper);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_37___default()(DateHelper, null, [{
    key: "buildParser",
    value: function buildParser(format) {
      var _this = this;

      // Split input format by regexp, which includes predefined patterns. Normally format would have some
      // splitters, like 'YYYY-MM-DD' or 'D/M YYYY' so output will contain matched patterns as well as splitters
      // which would serve as anchors. E.g. provided format is 'D/M!YYYY' and input is `11/6!2019` algorithm would work like:
      // 1. split format by regexp                // ['', 'D', '/', 'M', '!', 'YYYY', '']
      // 2. find splitters                        // ['/', '!']
      // 3. split input by seps, step by step     // ['11', ['6', ['2019']]]
      // Inputs like 'YYYYY' (5*Y) means 'YYYY' + 'Y', because it matches patterns from longer to shorter,
      // but if few patterns describe same unit the last one is applied, for example
      // DH.parse('20182015', 'YYYYY') equals to new Date(2015, 0, 0)
      var parts = format.split(parserRegexp),
          parser = []; // if length of the parts array is 1 - there are no regexps in the input string. thus - no parsers
      // do same if there are patterns matching locale strings (l, ll, LLLL etc.)
      // returning empty array to use new Date() as parser

      if (parts.length === 1 || localeStrRegExp.test(format)) {
        return [];
      } else {
        parts.reduce(function (prev, curr, index, array) {
          // ignore first and last empty string
          if (index !== 0 || curr !== '') {
            // if current element matches parser regexp store it as a parser
            if (parserRegexp.test(curr)) {
              var localeParsers = _this.localize('L{parsers}') || {},
                  fn = localeParsers[curr] || parsers[curr]; // Z should be last element in the string that matches regexp. Last array element is always either
              // an empty string (if format ends with Z) or splitter (everything that doesn't match regexp after Z)
              // If there is a pattern after Z, then Z index will be lower than length - 2

              if (curr === 'Z' && index < array.length - 2) {
                throw new Error("Invalid format ".concat(format, " TimeZone (Z) must be last token"));
              } // If fn is a string, we found an alias (L, LLL, l etc.).
              // Need to build parsers from mapped format and merge with existing


              if (typeof fn === 'string') {
                // we are going to merge nested parsers with current, some cleanup required:
                // 1. last element is no longer last
                // 2. need to pass last parser to the next step
                var nestedParsers = DH.buildParser(fn),
                    lastItem = nestedParsers.pop();
                delete lastItem.last; // elevate nested parsers

                parser.push.apply(parser, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_35___default()(nestedParsers));
                prev = lastItem;
              } else {
                prev.pattern = curr;
                prev.fn = parsers[curr];
              }
            } // if it doesn't match - we've found a splitter
            else {
                prev.splitter = curr;
                parser.push(prev);
                prev = {};
              }
          } else if (Object.prototype.hasOwnProperty.call(prev, 'pattern')) {
            parser.push(prev);
          }

          return prev;
        }, {});
      }

      parser[parser.length - 1].last = true;
      return parser;
    }
    /**
     * A utility function to create a sortable string key for the passed date or ms timestamp using the `'YYYY-MM-DD'`
     * format.
     * @param {Number|Date} ms The Date instance or ms timestamp to generate a key for
     * @returns {String} Date/timestamp as a string with `'YYYY-MM-DD'` format
     * @internal
     */

  }, {
    key: "makeKey",
    value: function makeKey(ms) {
      // Convert Date to ms timestamp
      if (ms.getTime) {
        ms = ms.getTime();
      } // Cache holds ms -> YYYY-MM-DD


      var cached = keyCache[ms];

      if (cached) {
        return cached;
      }

      return keyCache[ms] = DH.format(new Date(ms), 'YYYY-MM-DD');
    }
    /**
     * A utility function to parse a sortable string to a date date using the `'YYYY-MM-DD'` format.
     * @param {String} key The string to return a date for.
     * @internal
     */

  }, {
    key: "parseKey",
    value: function parseKey(key) {
      return DH.parse(key, 'YYYY-MM-DD');
    }
    /**
     * Returns a date created from the supplied string using the specified format. Will try to create even if format
     * is left out, by first using the default format (see {@link #property-defaultFormat-static}, by default
     * `YYYY-MM-DDTHH:mm:ssZ`) and then using `new Date(dateString)`.
     * Supported tokens:
     *
     * | Unit        | Token | Description                |
     * |-------------|-------|----------------------------|
     * | Year        | YYYY  | 2018                       |
     * |             | YY    | < 68 -> 2000, > 68 -> 1900 |
     * | Month       | MM    | 01 - 12                    |
     * | Date        | DD    | 01 - 31                    |
     * | Hour        | HH    | 00 - 23 or 1 - 12          |
     * | Minute      | mm    | 00 - 59                    |
     * | Second      | ss    | 00 - 59                    |
     * | Millisecond | S     | 0 - 9                      |
     * |             | SS    | 00 - 99                    |
     * |             | SSS   | 000 - 999                  |
     * | AM/PM       | A     | AM or PM                   |
     * |             | a     | am or pm                   |
     * | TimeZone    | Z     | Z for UTC or +-HH:mm       |
     * | Predefined  | L     | Long date, MM/DD/YYYY      |
     * |             | LT    | Long time, HH:mm A         |
     *
     * Predefined formats and functions used to parse tokens can be localized, see for example the swedish locale SvSE.js
     *
     * NOTE: If no date parameters are provided then `Jan 01 2020` is used as a default date
     *
     * @param {String} dateString Date string
     * @param {String} format Date format (or {@link #property-defaultParseFormat-static} if left out)
     * @returns {Date}
     * @category Parse & format
     */

  }, {
    key: "parse",
    value: function parse(dateString) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DH.defaultParseFormat;

      if (dateString instanceof Date) {
        return dateString;
      }

      if (typeof dateString !== 'string' || !dateString) {
        return null;
      } // // For ISO 8601 native is faster, but not very forgiving
      // if (format === defaultFormat) {
      //     const dt = new Date(dateString);
      //     if (!isNaN(dt)) {
      //         return dt;
      //     }
      // }


      var config = {
        year: null,
        month: null,
        date: null,
        hours: null,
        minutes: null,
        seconds: null,
        milliseconds: null
      }; // Milliseconds parser is the same for S, SS, SSS

      format = format.replace(/S+/gm, 'SSS');
      var parser = parserCache[format],
          result;

      if (!parser) {
        parser = parserCache[format] = DH.buildParser(format);
      } // Each parser knows its pattern and splitter. It looks for splitter in the
      // input string, takes first substring and tries to process it. Remaining string
      // is passed to the next parser.


      parser.reduce(function (dateString, parser) {
        if (parser.last) {
          Object.assign(config, parser.fn(dateString));
        } else {
          var splitAt; // ISO 8601 says that T symbol can be replaced with a space

          if (parser.splitter === 'T' && dateString.indexOf('T') === -1) {
            splitAt = dateString.indexOf(' ');
          } else {
            // If splitter specified find its position, otherwise try to determine pattern length
            splitAt = parser.splitter !== '' ? dateString.indexOf(parser.splitter) : parser.pattern && parser.pattern.length || -1;
          }

          var part, rest; // If splitter is not found in the current string we may be dealing with
          // 1. partial input - in that case we just feed all string to current parser and move on
          // 2. time zone (ssZ - splitter is empty string) and pattern is not specified, see comment below
          // 3. parse milliseconds before Z

          if (splitAt === -1 || parser.pattern === 'SSS' && dateString.match(/^\d+Z$/)) {
            // NOTE: parentheses are required here as + and - signs hold valuable information
            // with parentheses we get array like ['00','+','01:00'], omitting them we won't get
            // regexp match in result, loosing information
            var chunks = dateString.split(/([Z\-+])/); // If splitter is not found in the string, we may be dealing with string that contains info about TZ.
            // For instance, if format contains Z as last arg which is not separated (normally it is not indeed),
            // like 'YYYY-MM-DD HH:mm:ssZ', then second to last parser will have string that it cannot just parse, like
            // '2010-01-01 10:00:00'        -> '00'
            // '2010-01-01 10:00:00Z'       -> '00Z'
            // '2010-01-01 10:00:00-01'     -> '00-01'
            // '2010-01-01 10:00:00+01:30'  -> '00+01:30'
            // this cannot be processed by date parsers, so we need to process that additionally. So we
            // split string by symbols that can be found around timezone info: Z,-,+

            if (chunks.length === 1) {
              part = dateString;
              rest = '';
            } else {
              part = chunks[0];
              rest = "".concat(chunks[1]).concat(chunks[2]);
            }
          } else {
            part = dateString.substring(0, splitAt) || dateString;
            rest = dateString.substring(splitAt + parser.splitter.length);
          }

          if (parser.fn) {
            // Run parser and add result to config on successful parse otherwise continue parsing
            var res = parser.fn(part);

            if (res) {
              Object.assign(config, res);
            } else {
              rest = part + rest;
            }
          }

          return rest;
        }
      }, dateString); // If year is specified date has to be greater than 0

      if (config.year && !config.date) {
        config.date = 1;
      }

      var date = DH.create(config);

      if (date) {
        result = date;
      } else {
        // Last resort, try if native passing can do it
        result = new Date(dateString);
      }

      return result;
    }
    /**
     * Creates a date from a date definition object. The object can have the following properties:
     * - year
     * - month
     * - date (day in month)
     * - hours
     * - minutes
     * - seconds
     * - milliseconds
     * - amPm : 'am' or 'pm', implies 12 hour clock
     * - timeZone : offset from UTC in minutes
     * @param {Object} definition
     * @returns {Date}
     * @category Parse & format
     */

  }, {
    key: "create",
    value: function create(definition) {
      // Shallow clone to not alter input
      var def = Object.assign({}, definition);
      var invalid = isNaN(def.year),
          useUTC = false; // Not much validation yet, only considered invalid if all properties are null

      if (!invalid) {
        var allNull = true;
        dateProperties.forEach(function (property) {
          if (!(property in def) || isNaN(def[property])) {
            def[property] = 0;
          }

          allNull = allNull && def[property] === null;
        });
        invalid = allNull;
      }

      if (def.amPm === 'pm') {
        def.hours = def.hours % 12 + 12;
      }

      if ('timeZone' in def) {
        useUTC = true;
        def.minutes -= def.timeZone;
      }

      if (invalid) {
        return null;
      }

      var args = [defaultValue(def.year, DEFAULT_YEAR), defaultValue(def.month, DEFAULT_MONTH), defaultValue(def.date, DEFAULT_DAY), def.hours, def.minutes, def.seconds, def.milliseconds];
      return useUTC ? new Date(Date.UTC.apply(Date, args)) : _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_34___default()(Date, args);
    }
  }, {
    key: "toUTC",
    value: function toUTC(date) {
      return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()));
    }
    /**
     * Converts a date to string with the specified format. Formats heavily inspired by https://momentjs.com.
     * Available formats (input used for output below is `new Date(2018,8,9,18,7,8,145)`):
     *
     * | Unit                  | Token | Description & output                  |
     * |-----------------------|-------|---------------------------------------|
     * | Year                  | YYYY  | 2018                                  |
     * |                       | YY    | 18                                    |
     * |                       | Y     | 2018                                  |
     * | Quarter               | Q     | 3                                     |
     * |                       | Qo    | 3rd                                   |
     * | Month                 | MMMM  | September                             |
     * |                       | MMM   | Sep                                   |
     * |                       | MM    | 09                                    |
     * |                       | Mo    | 9th                                   |
     * |                       | M     | 9                                     |
     * | Week (iso)            | WW    | 36 (2 digit)                          |
     * |                       | Wo    | 36th                                  |
     * |                       | W     | 36                                    |
     * | Date                  | DDDD  | Day of year, 3 digits                 |
     * |                       | DDDo  | Day of year, ordinal                  |
     * |                       | DDD   | Day of year                           |
     * |                       | DD    | 09                                    |
     * |                       | Do    | 9th                                   |
     * |                       | D     | 9                                     |
     * | Weekday               | dddd  | Sunday                                |
     * |                       | ddd   | Sun                                   |
     * |                       | dd    | Su                                    |
     * |                       | do    | 0th                                   |
     * |                       | d     | 0                                     |
     * | Hour                  | HH    | 18 (00 - 23)                          |
     * |                       | H     | 18 (0 - 23)                           |
     * |                       | hh    | 06 (00 - 12)                          |
     * |                       | h     | 6 (0 - 12)                            |
     * |                       | KK    | 19 (01 - 24)                          |
     * |                       | K     | 19 (1 - 24)                           |
     * |                       | kk    | 06 or 18, locale determines           |
     * |                       | k     | 6 or 18, locale determines            |
     * | Minute                | mm    | 07                                    |
     * |                       | m     | 7                                     |
     * | Second                | ss    | 08                                    |
     * |                       | s     | 8                                     |
     * | Millisecond           | S     | 1                                     |
     * |                       | SS    | 14                                    |
     * |                       | SSS   | 145                                   |
     * | AM/PM                 | A     | AM or PM                              |
     * |                       | a     | am or pm                              |
     * | Predefined            | LT    | H: 2-digit (2d), m: 2d                |
     * | (uses browser locale) | LTS   | H: 2d, m: 2d, s : 2d                  |
     * |                       | LST   | Depends on 12 or 24 hour clock        |
     * |                       |       | 12h, H : 1d, m : 0 or 2d              |
     * |                       |       | 24h, H : 2d, m : 2d                   |
     * |                       | L     | Y: numeric (n), M : 2d, D : 2d        |
     * |                       | l     | Y: n, M : n, D : n                    |
     * |                       | LL    | Y: n, M : long (l), D : n             |
     * |                       | ll    | Y: n, M : short (s), D : n            |
     * |                       | LLL   | Y: n, M : l, D : n, H: n, m: 2d       |
     * |                       | lll   | Y: n, M : s, D : n, H: n, m: 2d       |
     * |                       | LLLL  | Y: n, M : l, D : n, H: n, m: 2d, d: l |
     * |                       | llll  | Y: n, M : s, D : n, H: n, m: 2d, d: s |
     *
     * Some examples:
     *
     * ```
     * DateHelper.format(new Date(2019, 7, 16), 'dddd') -> Friday
     * DateHelper.format(new Date(2019, 7, 16, 14, 27), 'HH:mm') --> 14:27
     * DateHelper.format(new Date(2019, 7, 16, 14, 27), 'L HH') --> 2019-07-16 14
     * ```
     *
     * Arbitrary text can be embedded in the format string by wrapping it with {}:
     *
     * ```
     * DateHelper.format(new Date(2019, 7, 16), '{It is }dddd{, yay!}') -> It is Friday, yay!
     * ```
     *
     * @param {Date} date Date
     * @param {String} format Desired format (uses `defaultFormat` if left out)
     * @returns {String} Formatted string
     * @category Parse & format
     */

  }, {
    key: "format",
    value: function format(date) {
      var _format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DH.defaultFormat;

      // Bail out if no date or invalid date
      if (!date || isNaN(date)) {
        return null;
      }

      var formatter = formatCache[_format],
          output = '';

      if (!formatter) {
        formatter = formatCache[_format] = []; // Build formatter array with the steps needed to format the date

        for (var i = 0; i < _format.length; i++) {
          // Matches a predefined format?
          var formatMatch = _format.substr(i).match(formatRegexp),
              predefined = formatMatch && formatMatch[0];

          if (predefined) {
            var localeFormats = this.localize('L{formats}') || {},
                fn = localeFormats[predefined] || formats[predefined];
            formatter.push(fn);
            i += predefined.length - 1;
          } // Start of text block? Append it
          else if (_format[i] === '{') {
              // Find closing brace
              var index = _format.indexOf('}', i + 1); // No closing brace, grab rest of string


              if (index === -1) {
                formatter.push(_format.substr(i + 1));
                i = _format.length;
              } // Closing brace found
              else {
                  formatter.push(_format.substring(i + 1, index)); // Carry on after closing brace

                  i = index;
                }
            } // Otherwise append to output (for example - / : etc)
            else {
                formatter.push(_format[i]);
              }
        }
      }

      formatter.forEach(function (step) {
        if (typeof step === 'string') {
          output += step;
        } else {
          output += step(date);
        }
      }); // MS inserts a Left-to-right control char between localized date parts, remove it to have the expected string
      // output. Otherwise comparision with typed strings will fail

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].isIE11) {
        output = output.replace(/\u200E/g, '');
      }

      return output;
    }
    /**
     * Converts the specified amount of desired unit into milliseconds. Can be called by only specifying a unit as the
     * first argument, it then uses amount = 1. For example: asMilliseconds('hour') == asMilliseconds(1, 'hour')
     * @param {Number|String} amount Amount, what of is decided by specifying unit (also takes a unit which implies an amount of 1)
     * @param {String} unit Time unit (s, hour, months etc.)
     * @returns {Number}
     * @category Parse & format
     */

  }, {
    key: "asMilliseconds",
    value: function asMilliseconds(amount) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof amount === 'string') {
        unit = amount;
        amount = 1;
      }

      return DH.as('millisecond', amount, unit);
    }
    /**
     * Converts the passed Date to an accurate number of months passed since the epoch start.
     * @param {Date} time The Date to find the month value of.
     * @returns {Number} The number of months since the system time epoch start. May be a fractional value.
     */

  }, {
    key: "asMonths",
    value: function asMonths(time) {
      var monthLength = DH.as('ms', DH.daysInMonth(time), 'day'),
          fraction = (time.valueOf() - DH.startOf(time, 'month').valueOf()) / monthLength;
      return time.getYear() * 12 + time.getMonth() + fraction;
    }
  }, {
    key: "monthsToDate",
    value: function monthsToDate(months) {
      var intMonths = Math.floor(months),
          fraction = months - intMonths,
          result = new Date(0, intMonths),
          msInMonth = DH.as('ms', DH.daysInMonth(result), 'days');
      result.setTime(result.getTime() + fraction * msInMonth);
      return result;
    }
    /**
     * Converts a millisecond time delta to a human readable form. For example `1000 * 60 * 60 * 50`
     * milliseconds would be rendered as "2 days, 2 hours"
     * @param {Number} delta The millisecond delta value.
     * @param {Object} [options] Formatting options.
     * @param {Boolean} [options.abbrev] Pass `true` to use abbreviated unit names, eg "2d, 2h" for the above example.
     * @param {String} [options.precision] The minimum precision unit.
     * @param {Boolean} [options.asString] Pass `false` to return the result as an array, eg ['2d', '2h'] for the above example.
     * @category Parse & format
     */

  }, {
    key: "formatDelta",
    value: function formatDelta(delta, options) {
      var abbrev, unitName;

      if (typeof options === 'boolean') {
        abbrev = options;
      } else if (options) {
        abbrev = options.abbrev;
      }

      var deltaObj = this.getDelta(delta, options),
          result = [],
          sep = abbrev ? '' : ' ';

      for (unitName in deltaObj) {
        result.push("".concat(deltaObj[unitName]).concat(sep).concat(unitName));
      }

      return (options === null || options === void 0 ? void 0 : options.asString) === false ? result : result.join(', ');
    }
    /**
     * Converts a millisecond time delta to an object structure. For example `1000 * 60 * 60 * 50`
     * milliseconds the result would be as:
     * {
     *     day: 2,
     *     hour: 2
     * }
     *
     * @param {Number} delta The millisecond delta value.
     * @param {Object} [options] Formatting options.
     * @param {Boolean} [options.abbrev] Pass `true` to use abbreviated unit names, eg "{ d: 2, h: 2 }" for the above example.
     * @param {String} [options.precision] The minimum precision unit.
     * @returns {Object} The object with the values for each unit.
     */

  }, {
    key: "getDelta",
    value: function getDelta(delta, options) {
      var abbrev, d, done, precision, unitName;

      if (typeof options === 'boolean') {
        abbrev = options;
      } else if (options) {
        abbrev = options.abbrev;
        precision = DH.normalizeUnit(options.precision);
      }

      var result = {},
          getUnit = abbrev ? DH.getShortNameOfUnit : DH.getLocalizedNameOfUnit; // Loop downwards through the magnitude of units from year -> ms

      var _iterator = _createForOfIteratorHelper(deltaUnits),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          unitName = _step.value;
          d = DH.as(unitName, delta);
          done = precision === unitName;
          d = Math[done ? 'round' : 'floor'](d); // If there's a non-zero integer quantity of this unit, add it to result
          // and subtract from the delta, then go round to next unit down.

          if (d || done && !result.length) {
            result[getUnit.call(DH, unitName, d !== 1)] = d; // TODO 0 is plural in EN but...?

            delta -= DH.as('ms', d, unitName);
          }

          if (done || !delta) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
    /**
     * Converts the specified amount of one unit (fromUnit) into an amount of another unit (toUnit)
     * @param {String} toUnit The name of units to convert to, eg: `'ms'`
     * @param {Number|String} amount The time to convert. Either the magnitude number form
     * or a duration string such as '2d'.
     * @param {string} [fromUnit] If the amount was passed as a number, the units to use to convert from.
     * @returns {Number}
     * @category Parse & format
     */

  }, {
    key: "as",
    value: function as(toUnit, amount) {
      var fromUnit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ms';

      // Allow DH.as('ms', '2d')
      if (typeof amount === 'string') {
        amount = DH.parseDuration(amount);
      } // Allow DH.as('ms', myDurationObject)


      if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_33___default()(amount) === 'object') {
        fromUnit = amount.unit;
        amount = amount.magnitude;
      }

      if (toUnit === fromUnit) {
        return amount;
      }

      toUnit = DH.normalizeUnit(toUnit);
      fromUnit = DH.normalizeUnit(fromUnit); // validConversions[][] can be negative to signal that conversion is not exact, ignore sign here

      if (unitMagnitudes[fromUnit] > unitMagnitudes[toUnit]) {
        return amount * Math.abs(validConversions[fromUnit][toUnit]);
      } else {
        return amount / Math.abs(validConversions[toUnit][fromUnit]);
      }
    }
  }, {
    key: "formatContainsHourInfo",
    value: function formatContainsHourInfo(format) {
      var stripEscapeRe = /(\\.)/g,
          hourInfoRe = /([HhKkmSsAa]|LT|L{3,}|l{3,})/;
      return hourInfoRe.test(format.replace(stripEscapeRe, ''));
    }
    /**
     * Returns true for 24 hour format.
     * @param {String} format Date format
     * @returns {Boolean}
     * @category Parse & format
     */

  }, {
    key: "is24HourFormat",
    value: function is24HourFormat(format) {
      return DH.format(DH.getTime(13, 0, 0), format).includes('13');
    } //endregion
    //region Manipulate

    /**
     * Add days, hours etc. to a date. Always clones the date, original will be left unaffected.
     * @param {Date|String} date Original date
     * @param {Number} amount Amount of days, hours etc
     * @param {String} unit Unit for amount
     * @returns {Date} New calculated date
     * @category Manipulate
     */

  }, {
    key: "add",
    value: function add(date, amount) {
      var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ms';
      var d;

      if (typeof date === 'string') {
        d = DH.parse(date);
      } else {
        d = new Date(date.getTime());
      }

      if (!unit || amount === 0) return d;
      unit = DH.normalizeUnit(unit);

      switch (unit) {
        case 'millisecond':
          d = new Date(d.getTime() + amount);
          break;

        case 'second':
          d = new Date(d.getTime() + amount * 1000);
          break;

        case 'minute':
          d = new Date(d.getTime() + amount * 60000);
          break;

        case 'hour':
          d = new Date(d.getTime() + amount * 3600000);
          break;

        case 'day':
          // Integer value added, do calendar calculation to correctly handle DST etc.
          if (amount % 1 === 0) {
            d.setDate(d.getDate() + amount);
          } // No browsers support fractional values for dates any longer, do time based calculation
          else {
              d = new Date(d.getTime() + amount * 86400000);
            } // When crossing DST in Brazil, we expect hours to end up the same


          if (d.getHours() === 23 && date.getHours() === 0) {
            d = DH.add(d, 1, 'hour');
          }

          break;

        case 'week':
          d.setDate(d.getDate() + amount * 7);
          break;

        case 'month':
          {
            var day = d.getDate();

            if (day > 28) {
              day = Math.min(day, DH.getLastDateOfMonth(DH.add(DH.getFirstDateOfMonth(d), amount, 'month')).getDate());
            }

            d.setDate(day);
            d.setMonth(d.getMonth() + amount);
            break;
          }

        case 'quarter':
          d = DH.add(d, amount * 3, 'month');
          break;

        case 'year':
          d.setFullYear(d.getFullYear() + amount);
          break;
      }

      return d;
    }
    /**
     * Calculates the difference between two dates, in the specified unit.
     * @param {Date} start First date
     * @param {Date} end Second date
     * @param {String} unit Unit to calculate difference in
     * @param {Boolean} fractional Specify false to round result
     * @returns {Number} Difference in the specified unit
     * @category Manipulate
     */

  }, {
    key: "diff",
    value: function diff(start, end) {
      var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ms';
      var fractional = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      unit = DH.normalizeUnit(unit);
      if (!start || !end) return 0;
      var amount;

      switch (unit) {
        case 'year':
          amount = DH.diff(start, end, 'month') / 12;
          break;

        case 'quarter':
          amount = DH.diff(start, end, 'month') / 3;
          break;

        case 'month':
          amount = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
          break;

        case 'week':
          amount = DH.diff(start, end, 'day') / 7;
          break;

        case 'day':
          {
            var dstDiff = start.getTimezoneOffset() - end.getTimezoneOffset();
            amount = (end - start + dstDiff * 60 * 1000) / 86400000;
            break;
          }

        case 'hour':
          amount = (end - start) / 3600000;
          break;

        case 'minute':
          amount = (end - start) / 60000;
          break;

        case 'second':
          amount = (end - start) / 1000;
          break;

        case 'millisecond':
          amount = end - start;
          break;
      }

      return fractional ? amount : Math.round(amount);
    }
    /**
     * Sets the date to the start of the specified unit, by default returning a clone of the date instead of changing it
     * inplace.
     * @param {Date} date Original date
     * @param {String} unit Start of this unit, 'day', 'month' etc.
     * @param {Boolean} clone Manipulate a copy of the date
     * @returns {Date} Manipulated date
     * @category Manipulate
     */

  }, {
    key: "startOf",
    value: function startOf(date) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';
      var clone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!date) {
        return null;
      }

      unit = DH.normalizeUnit(unit);
      if (clone) date = DH.clone(date);
      var toSet = {},
          index = unitMagnitudes[unit];

      for (var i = 0; i < index; i++) {
        var currentUnit = canonicalUnitNames[i]; // Week and quarter are not part of the date

        if (currentUnit !== 'quarter' && currentUnit !== 'week') {
          toSet[currentUnit] = currentUnit === 'day' ? 1 : 0; // day is 1 based
        }
      } // Special handling of quarter and week


      if (unit === 'quarter') {
        toSet.month = (DH.get(date, 'quarter') - 1) * 3;
      } else if (unit === 'week') {
        var delta = date.getDay() - DH.weekStartDay;
        toSet.day = date.getDate() - delta;
      }

      return DH.set(date, toSet);
    }
    /**
     * Returns the end point of the passed date, that is 00:00:00 of the day after the passed date.
     * @param {Date} date The date to return the end point of.
     */

  }, {
    key: "endOf",
    value: function endOf(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    }
    /**
     * Creates a clone of the specified date
     * @param {Date} date Original date
     * @returns {Date} Cloned date
     * @category Manipulate
     */

  }, {
    key: "clone",
    value: function clone(date) {
      return new Date(date.getTime());
    }
    /**
     * Removes time from a date (same as calling #startOf(date, 'day'))
     * @param {Date} date Date to remove time from
     * @param {Boolean} clone Manipulate a copy of the date
     * @returns {Date} Manipulated date
     * @category Manipulate
     */

  }, {
    key: "clearTime",
    value: function clearTime(date) {
      var clone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return DH.startOf(date, 'day', clone);
    }
  }, {
    key: "midnight",
    value: function midnight(date, inclusive) {
      var ret = DH.clearTime(date);

      if (inclusive && ret < date) {
        ret = DH.add(ret, 1, 'd');
      }

      return ret;
    }
    /**
     * Returns the elapsed milliseconds from the start of the specified date.
     * @param {Date} date Date to remove date from.
     * @returns {Number} The elapsed milliseconds from the start of the specified date
     * @category Manipulate
     */

  }, {
    key: "getTimeOfDay",
    value: function getTimeOfDay(date) {
      return date.getHours() * validConversions.hour.millisecond + date.getMinutes() * validConversions.minute.millisecond + date.getSeconds() * validConversions.second.millisecond + date.getMilliseconds();
    }
    /**
     * Sets a part of a date (in place)
     * @param {Date} date Date to manipulate
     * @param {String|Object} unit Part of date to set, for example 'minute'. Or an object like { second: 1, minute: 1 }
     * @param {Number} amount Value to set
     * @returns {Date} Modified date
     * @category Manipulate
     */

  }, {
    key: "set",
    value: function set(date, unit, amount) {
      if (!unit) {
        return date;
      }

      if (typeof unit === 'string') {
        switch (DH.normalizeUnit(unit)) {
          case 'millisecond':
            // Setting value to 0 when it is 0 at DST crossing messes it up
            if (amount !== 0 || date.getMilliseconds() > 0) {
              date.setMilliseconds(amount);
            }

            break;

          case 'second':
            // Setting value to 0 when it is 0 at DST crossing messes it up
            if (amount !== 0 || date.getSeconds() > 0) {
              date.setSeconds(amount);
            }

            break;

          case 'minute':
            // Setting value to 0 when it is 0 at DST crossing messes it up
            if (amount !== 0 || date.getMinutes() > 0) {
              date.setMinutes(amount);
            }

            break;

          case 'hour':
            date.setHours(amount);
            break;

          case 'day':
          case 'date':
            date.setDate(amount);
            break;

          case 'week':
            throw new Error('week not implemented');

          case 'month':
            date.setMonth(amount);
            break;

          case 'quarter':
            // Setting quarter = first day of first month of that quarter
            date.setDate(1);
            date.setMonth((amount - 1) * 3);
            break;

          case 'year':
            date.setFullYear(amount);
            break;
        }
      } else {
        Object.entries(unit) // Make sure smallest unit goes first, to not change month before changing day
        .sort(function (a, b) {
          return unitMagnitudes[a[0]] - unitMagnitudes[b[0]];
        }).forEach(function (_ref) {
          var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_32___default()(_ref, 2),
              unit = _ref2[0],
              amount = _ref2[1];

          DH.set(date, unit, amount);
        });
      }

      return date;
    }
  }, {
    key: "setDateToMidday",
    value: function setDateToMidday(date) {
      var clone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return DH.set(DH.clearTime(date, clone), 'hour', 12);
    }
    /**
     * Constrains the date within a min and a max date
     * @param {Date} date The date to constrain
     * @param {Date} [min] Min date
     * @param {Date} [max] Max date
     * @return {Date} The constrained date
     * @category Manipulate
     */

  }, {
    key: "constrain",
    value: function constrain(date, min, max) {
      if (min != null) {
        date = DH.max(date, min);
      }

      return max == null ? date : DH.min(date, max);
    }
    /**
     * Returns time with default year, month, and day (Jan 1, 2020)
     * @param {Number|Date} hours Hours value or the full date to extract the time of.
     * @param {Number} minutes Minutes value
     * @param {Number} seconds Seconds value
     * @param {Number} ms Milliseconds value
     * @returns {Date} A new default date with the time extracted from the given date or from the time values provided individually.
     * @category Manipulate
     */

  }, {
    key: "getTime",
    value: function getTime(hours) {
      var minutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var ms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      if (hours instanceof Date) {
        ms = hours.getMilliseconds();
        seconds = hours.getSeconds();
        minutes = hours.getMinutes();
        hours = hours.getHours();
      }

      return new Date(DEFAULT_YEAR, DEFAULT_MONTH, DEFAULT_DAY, hours, minutes, seconds, ms);
    }
    /**
     * Copies hours, minutes, seconds, milliseconds from one date to another
     *
     * @param {Date} targetDate The target date
     * @param {Date} sourceDate The source date
     * @return {Date} The adjusted target date
     * @category Manipulate
     * @static
     */

  }, {
    key: "copyTimeValues",
    value: function copyTimeValues(targetDate, sourceDate) {
      targetDate.setHours(sourceDate.getHours());
      targetDate.setMinutes(sourceDate.getMinutes());
      targetDate.setSeconds(sourceDate.getSeconds());
      targetDate.setMilliseconds(sourceDate.getMilliseconds());
      return targetDate;
    } //endregion
    //region Comparison

  }, {
    key: "isDST",
    value: function isDST(date) {
      var year = date.getFullYear(),
          jan = new Date(year, 0, 1),
          jul = new Date(year, 6, 1);
      return date.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }
    /**
     * Determines if a date precedes another.
     * @param first First date
     * @param second Second date
     * @returns {Boolean} true if first precedes second, otherwise false
     * @category Comparison
     */

  }, {
    key: "isBefore",
    value: function isBefore(first, second) {
      return first < second;
    }
    /**
     * Determines if a date succeeds another.
     * @param first First date
     * @param second Second date
     * @returns {Boolean} true if first succeeds second, otherwise false
     * @category Comparison
     */

  }, {
    key: "isAfter",
    value: function isAfter(first, second) {
      return first > second;
    }
    /**
     * Checks if two dates are equal.
     * @param first First date
     * @param second Second date
     * @param unit If not given, the comparison will be done up to a millisecond
     * @returns {Boolean} true if the dates are equal
     * @category Comparison
     */

  }, {
    key: "isEqual",
    value: function isEqual(first, second) {
      var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (unit === null) {
        // https://jsbench.me/3jk2bom2r3/1
        // https://jsbench.me/ltkb3vk0ji/1 (more flavors) - getTime is >2x faster vs valueOf/Number/op+
        return first && second && first.getTime() === second.getTime();
      }

      return DH.startOf(first, unit) - DH.startOf(second, unit) === 0;
    }
    /**
     * Compares two dates using the specified precision
     * @param {Date} first
     * @param {Date} second
     * @param {String} unit
     * @returns {Number} 0 = equal, -1 first before second, 1 first after second
     * @category Comparison
     */

  }, {
    key: "compare",
    value: function compare(first, second) {
      var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      // Unit specified, cut the rest out
      if (unit) {
        first = DH.startOf(first, unit);
        second = DH.startOf(second, unit);
      } // Comparision on ms level


      if (DH.isBefore(first, second)) return -1;
      if (DH.isAfter(first, second)) return 1;
      return 0;
    }
    /**
     * Checks if date is the start of specified unit
     * @param {Date} date
     * @param {String} unit
     * @returns {Boolean}
     * @category Comparison
     */

  }, {
    key: "isStartOf",
    value: function isStartOf(date, unit) {
      return DH.isEqual(date, DH.startOf(date, unit));
    }
    /**
     * Checks if this date is >= start and < end.
     * @param {Date} date The source date
     * @param {Date} start Start date
     * @param {Date} end End date
     * @return {Boolean} true if this date falls on or between the given start and end dates.
     * @category Comparison
     */

  }, {
    key: "betweenLesser",
    value: function betweenLesser(date, start, end) {
      //return start <= date && date < end;
      return start.getTime() <= date.getTime() && date.getTime() < end.getTime();
    }
    /**
     * Checks if this date is >= start and <= end.
     * @param {Date} date The source date
     * @param {Date} start Start date
     * @param {Date} end End date
     * @return {Boolean} true if this date falls on or between the given start and end dates.
     * @category Comparison
     */

  }, {
    key: "betweenLesserEqual",
    value: function betweenLesserEqual(date, start, end) {
      return start.getTime() <= date.getTime() && date.getTime() <= end.getTime();
    }
    /**
     * Returns true if dates intersect
     * @param {Date} date1Start
     * @param {Date} date1End
     * @param {Date} date2Start
     * @param {Date} date2End
     * @return {Boolean} Returns true if dates intersect
     * @category Comparison
     */

  }, {
    key: "intersectSpans",
    value: function intersectSpans(date1Start, date1End, date2Start, date2End) {
      return DH.betweenLesser(date1Start, date2Start, date2End) || DH.betweenLesser(date2Start, date1Start, date1End);
    }
    /**
     * Returns 1 if first param is a greater unit than second param, -1 if the opposite is true or 0 if they're equal
     * @param {String} unit1 The 1st unit
     * @param {String} unit2 The 2nd unit
     * @category Comparison
     */

  }, {
    key: "compareUnits",
    value: function compareUnits(unit1, unit2) {
      return Math.sign(unitMagnitudes[unit1] - unitMagnitudes[unit2]);
    }
    /**
     * Returns true if the first time span completely 'covers' the second time span.
     * @example
     * DateHelper.timeSpanContains(new Date(2010, 1, 2), new Date(2010, 1, 5), new Date(2010, 1, 3), new Date(2010, 1, 4)) ==> true
     * DateHelper.timeSpanContains(new Date(2010, 1, 2), new Date(2010, 1, 5), new Date(2010, 1, 3), new Date(2010, 1, 6)) ==> false
     * @param {Date} spanStart The start date for initial time span
     * @param {Date} spanEnd The end date for initial time span
     * @param {Date} otherSpanStart The start date for the 2nd time span
     * @param {Date} otherSpanEnd The end date for the 2nd time span
     * @return {Boolean}
     * @category Comparison
     */

  }, {
    key: "timeSpanContains",
    value: function timeSpanContains(spanStart, spanEnd, otherSpanStart, otherSpanEnd) {
      return otherSpanStart - spanStart >= 0 && spanEnd - otherSpanEnd >= 0;
    } //endregion
    //region Query

    /**
     * Get the first day of week, 0-6 (Sunday-Saturday).
     * This is determined by the current locale's `DateHelper.weekStartDay` parameter.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "get",

    /**
     * Get the specified part of a date
     * @param {Date} date
     * @param {String} unit Part of date, hour, minute etc.
     * @category Query
     */
    value: function get(date, unit) {
      switch (DH.normalizeUnit(unit)) {
        case 'millisecond':
          return date.getMilliseconds();

        case 'second':
          return date.getSeconds();

        case 'minute':
          return date.getMinutes();

        case 'hour':
          return date.getHours();

        case 'date':
        case 'day':
          // Scheduler has a lot of calculations expecting this to work
          return date.getDate();

        case 'week':
          return formats.W(date);

        case 'month':
          return date.getMonth();

        case 'quarter':
          return Math.floor(date.getMonth() / 3) + 1;

        case 'year':
          return date.getFullYear();
      }

      return null;
    }
    /**
     * Get number of days in the current month for the supplied date
     * @param {Date} date Date which month should be checked
     * @returns {Number} Days in month
     * @category Query
     */

  }, {
    key: "daysInMonth",
    value: function daysInMonth(date) {
      var d = DH.clone(date);
      d.setDate(1);
      d.setMonth(date.getMonth() + 1);
      d.setDate(0);
      return d.getDate();
    }
    /**
     * Get the first date of the month for the supplied date
     * @param {Date} date
     * @returns {Date}
     * @category Query
     */

  }, {
    key: "getFirstDateOfMonth",
    value: function getFirstDateOfMonth(date) {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    }
    /**
     * Get the last date of the month for the supplied date
     * @param {Date} date
     * @returns {Date}
     * @category Query
     */

  }, {
    key: "getLastDateOfMonth",
    value: function getLastDateOfMonth(date) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }
    /**
     * Get the earliest of two dates
     * @param {Date} first
     * @param {Date} second
     * @returns {Date} Earliest date
     * @category Query
     */

  }, {
    key: "min",
    value: function min(first, second) {
      return first.getTime() < second.getTime() ? first : second;
    }
    /**
     * Get the latest of two dates
     * @param {Date} first
     * @param {Date} second
     * @returns {Date} Latest date
     * @category Query
     */

  }, {
    key: "max",
    value: function max(first, second) {
      return first.getTime() > second.getTime() ? first : second;
    }
    /**
     * Get an incremented date. Incrementation based on specified unit and optional amount
     * @param {Date} date
     * @param {String} unit
     * @param {Number} [increment]
     * @param {Number} [weekStartDay] Will default to what is set in locale
     * @returns {Date}
     * @category Query
     */

  }, {
    key: "getNext",
    value: function getNext(date, unit) {
      var increment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var weekStartDay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DH.weekStartDay;

      if (unit === 'week') {
        var dt = DH.clone(date);
        var day = dt.getDay();
        dt = DH.startOf(dt, 'day');
        dt = DH.add(dt, weekStartDay - day + 7 * (increment - (weekStartDay <= day ? 0 : 1)), 'day'); // For south american timezones, midnight does not exist on DST transitions, adjust...

        if (dt.getDay() !== weekStartDay) DH.add(dt, 1, 'hour');
        return dt;
      }

      return DH.startOf(DH.add(date, increment, unit), unit);
    }
    /**
     * Checks if date object is valid.
     *
     * For example:
     *
     * ```javascript
     * date = new Date('foo')
     * date instanceof Date // true
     * date.toString() // "Invalid Date"
     * isNaN(date) // true
     * DateHelper.isValidDate(date) // false
     *
     * date = new Date()
     * date instanceof Date // true
     * date.toString() // "Mon Jan 13 2020 18:27:38 GMT+0300 (GMT+03:00)"
     * isNaN(date) // false
     * DateHelper.isValidDate(date) // true
     * ```
     *
     * @param date
     * @returns {boolean}
     */

  }, {
    key: "isValidDate",
    value: function isValidDate(date) {
      return DH.isDate(date) && !isNaN(date);
    }
    /**
     * Checks if value is a date object. Allows to recognize date object even from another context,
     * like the top frame when used in an iframe.
     *
     * @param value
     * @returns {boolean}
     */

  }, {
    key: "isDate",
    value: function isDate(value) {
      // see https://jsbench.me/s7kb49w83j/1 (cannot use instanceof cross-frame):
      return value && toString.call(value) === DATE_TYPE;
    }
    /**
     * Get the start of the next day
     * @param {Date} date
     * @param {Boolean} clone
     * @param {Boolean} noNeedToClearTime
     * @returns {Date}
     * @category Query
     */

  }, {
    key: "getStartOfNextDay",
    value: function getStartOfNextDay(date, clone, noNeedToClearTime) {
      var nextDay = DH.add(noNeedToClearTime ? date : DH.clearTime(date, clone), 1, 'day'); // DST case

      if (nextDay.getDate() === date.getDate()) {
        var offsetNextDay = DH.add(DH.clearTime(date, clone), 2, 'day').getTimezoneOffset(),
            offsetDate = date.getTimezoneOffset();
        nextDay = DH.add(nextDay, offsetDate - offsetNextDay, 'minute');
      }

      return nextDay;
    }
    /**
     * Get the end of previous day
     * @param {Date} date
     * @param {Boolean} noNeedToClearTime
     * @returns {Date}
     * @category Query
     */

  }, {
    key: "getEndOfPreviousDay",
    value: function getEndOfPreviousDay(date, noNeedToClearTime) {
      var dateOnly = noNeedToClearTime ? date : DH.clearTime(date, true); // dates are different

      if (dateOnly - date) {
        return dateOnly;
      } else {
        return DH.add(dateOnly, -1, 'day');
      }
    }
    /**
     * Get week number for the date.
     * @param {Date} date date
     * @param {Number} weekStartDay first day of week, 0-6 (Sunday-Saturday). Defaults to the {@link #property-weekStartDay-static}.
     * @returns {Number[]} year and week number
     * @category Query
     */

  }, {
    key: "getWeekNumber",
    value: function getWeekNumber(date) {
      var weekStartDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DateHelper.weekStartDay;
      var jan01 = new Date(date.getFullYear(), 0, 1),
          dec31 = new Date(date.getFullYear(), 11, 31),
          firstDay = normalizeDay(jan01.getDay() - weekStartDay),
          lastDay = normalizeDay(dec31.getDay() - weekStartDay),
          dayNumber = getDayDiff(date, jan01);
      var weekNumber; // Check if the year starts before the middle of a week

      if (firstDay < 4) {
        weekNumber = Math.floor((dayNumber + firstDay - 1) / 7) + 1;
      } else {
        weekNumber = Math.floor((dayNumber + firstDay - 1) / 7);
      }

      if (weekNumber) {
        var year = date.getFullYear(); // Might be week 1 of next year if the year ends before day 3 (0 based)

        if (weekNumber === 53 && lastDay < 3) {
          year++;
          weekNumber = 1;
        }

        return [year, weekNumber];
      } // We're in week zero which is the last week of the previous year, so ask what
      // week encapsulates 31 Dec in the previous year.


      var lastWeekOfLastYear = DateHelper.getWeekNumber(new Date(date.getFullYear() - 1, 11, 31))[1];
      return [date.getFullYear() - 1, lastWeekOfLastYear];
    } //endregion
    //region Unit helpers

    /**
     * Turns (10, 'day') into '10 days' etc.
     * @param {Number} count Amount of unit
     * @param {String} unit Unit, will be normalizes (days, d -> day etc.)
     * @returns {String}
     * @category Unit helpers
     */

  }, {
    key: "formatCount",
    value: function formatCount(count, unit) {
      unit = DH.normalizeUnit(unit);
      if (count !== 1) unit += 's';
      return count + ' ' + unit;
    }
    /**
     * Get the ratio between two units ( year, month -> 1/12 )
     * @param {String} baseUnit
     * @param {String} unit
     * @param {Boolean} acceptEstimate If true, process negative values of validConversions. Defaults to false.
     * @returns {Number} Ratio
     * @category Unit helpers
     */

  }, {
    key: "getUnitToBaseUnitRatio",
    value: function getUnitToBaseUnitRatio(baseUnit, unit) {
      var acceptEstimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      baseUnit = DH.normalizeUnit(baseUnit);
      unit = DH.normalizeUnit(unit);
      if (baseUnit === unit) return 1; // Some validConversions have negative sign to signal that it is not an exact conversion.
      // Ignore those here unless acceptEstimate is provided.

      if (validConversions[baseUnit] && validConversions[baseUnit][unit] && (acceptEstimate || validConversions[baseUnit][unit] > 0)) {
        return 1 / DH.as(unit, 1, baseUnit);
      }

      if (validConversions[unit] && validConversions[unit][baseUnit] && (acceptEstimate || validConversions[unit][baseUnit] > 0)) {
        return DH.as(baseUnit, 1, unit);
      }

      return -1;
    }
    /**
     * Get unit suitable to use in calculations (?)
     * @param unit
     * @returns {*}
     * @category Unit helpers
     */

  }, {
    key: "getMeasuringUnit",
    value: function getMeasuringUnit(unit) {
      if (unit === 'week') return 'day';
      return unit;
    }
    /**
     * Returns a localized abbreviated form of the name of the duration unit.
     * For example in the `EN` locale, for `"qrt"` it will return `"q"`.
     * @param {String} unit Duration unit
     * @return {String}
     * @category Unit helpers
     */

  }, {
    key: "getShortNameOfUnit",
    value: function getShortNameOfUnit(unit) {
      // Convert abbreviations to the canonical name.
      // See locale file and the applyLocale method below.
      unit = DH.parseTimeUnit(unit); // unitLookup is keyed by eg 'DAY', 'day', 'MILLISECOND', 'millisecond' etc

      return DH.unitLookup[unit].abbrev;
    }
    /**
     * Returns a localized full name of the duration unit.
     * For for example in the `EN` locale, for `"d"` it will return either
     * `"day"` or `"days"`, depending from the `plural` argument
     * @static
     * @param {String} unit Time unit
     * @param {Boolean} plural Whether to return a plural name or singular
     * @return {String}
     * @category Unit helpers
     */

  }, {
    key: "getLocalizedNameOfUnit",
    value: function getLocalizedNameOfUnit(unit, plural) {
      // Normalize to not have to have translations for each variation used in code
      unit = DH.normalizeUnit(unit); // Convert abbreviations to the canonical name.
      // See locale file and the applyLocale method below.

      unit = DH.parseTimeUnit(unit); // unitLookup is keyed by eg 'DAY', 'day', 'MILLISECOND', 'millisecond' etc

      return DH.unitLookup[unit][plural ? 'plural' : 'single'];
    }
    /**
     * Normalizes a unit for easier usage in conditionals. For example year, years, y -> year
     * @param {String} unit
     * @returns {String}
     * @category Unit helpers
     */

  }, {
    key: "normalizeUnit",
    value: function normalizeUnit(unit) {
      if (!unit) {
        return null;
      }

      var unitLower = unit.toLowerCase();

      if (unitLower === 'date') {
        return unitLower;
      }

      return canonicalUnitNames.includes(unitLower) // Already valid
      ? unitLower // Trying specified case first, since we have both "M" for month and "m" for minute
      : normalizedUnits[unit] || normalizedUnits[unitLower];
    }
  }, {
    key: "getUnitByName",
    value: function getUnitByName(name) {
      // Allow either a canonical name to be passed, or, if that fails, parse it as a localized name or abbreviation.
      return DH.normalizeUnit(name) || DH.normalizeUnit(DH.parseTimeUnit(name));
    }
    /**
     * Returns a duration of the timeframe in the given unit.
     * @param {Date} start The start date of the timeframe
     * @param {Date} end The end date of the timeframe
     * @param {String} unit Duration unit
     * @return {Number} The duration in the units
     * @category Unit helpers
     * @ignore
     */

  }, {
    key: "getDurationInUnit",
    value: function getDurationInUnit(start, end, unit, doNotRound) {
      return DH.diff(start, end, unit, doNotRound);
    }
    /**
     * Checks if two date units align
     * @private
     * @param {String} majorUnit
     * @param {String} minorUnit
     * @returns {Boolean}
     * @category Unit helpers
     */

  }, {
    key: "doesUnitsAlign",
    value: function doesUnitsAlign(majorUnit, minorUnit) {
      // TODO: probably needs some fleshing out to be generally useful, otherwise move to TimeAxisViewModel?
      // Maybe also use getUnitToBaseUnitRatio() for assertion?
      return !(majorUnit !== minorUnit && minorUnit === 'week');
    }
  }, {
    key: "getSmallerUnit",
    value: function getSmallerUnit(unit) {
      return canonicalUnitNames[unitMagnitudes[DH.normalizeUnit(unit)] - 1] || null;
    }
  }, {
    key: "getLargerUnit",
    value: function getLargerUnit(unit) {
      return canonicalUnitNames[unitMagnitudes[DH.normalizeUnit(unit)] + 1] || null;
    }
    /**
     *
     * Rounds the passed Date value to the nearest `increment` value.
     *
     * Optionally may round relative to a certain base time point.
     *
     * For example `DH.round(new Date('2020-01-01T09:35), '30 min', new Date('2020-01-01T09:15))`
     * would round to 9:45 because that's the nearest integer number of 30 minute increments
     * from the base.
     *
     * Note that `base` is ignored when rounding to weeks. The configured {@link #property-weekStartDay-static}
     * dictates what the base of a week is.
     *
     * @param {Date} time The time to round
     * @param {String|Number} increment A millisecond value by which to round the time.
     * May be specified in string form eg: `'15 minutes'`
     * @param {Date} [base] The "start" from which to apply the rounding.
     */

  }, {
    key: "round",
    value: function round(time, increment, base) {
      return DH.snap('round', time, increment, base);
    }
    /**
     *
     * Floor the passed Date value to the nearest `increment` value.
     *
     * Optionally may floor relative to a certain base time point.
     *
     * For example `DH.floor(new Date('2020-01-01T09:35), '30 min', new Date('2020-01-01T09:15))`
     * would floor to 9:15 because that's the closest lower integer number of 30 minute increments
     * from the base.
     *
     * Note that `base` is ignored when flooring to weeks. The configured {@link #property-weekStartDay-static}
     * dictates what the base of a week is.
     *
     * @param {Date} time The time to floor
     * @param {String|Number} increment A millisecond value by which to floor the time.
     * May be specified in string form eg: `'15 minutes'`
     * @param {Date} [base] The "start" from which to apply the flooring.
     */

  }, {
    key: "floor",
    value: function floor(time, increment, base) {
      return DH.snap('floor', time, increment, base);
    }
    /**
     *
     * Ceils the passed Date value to the nearest `increment` value.
     *
     * Optionally may ceil relative to a certain base time point.
     *
     * For example `DH.ceil(new Date('2020-01-01T09:35), '30 min', new Date('2020-01-01T09:15))`
     * would ceil to 9:45 because that's the closest higher integer number of 30 minute increments
     * from the base.
     *
     * Note that `base` is ignored when ceiling to weeks. The configured {@link #property-weekStartDay-static}
     * dictates what the base of a week is.
     *
     * @param {Date} time The time to ceil
     * @param {String|Number} increment A millisecond value by which to ceil the time.
     * May be specified in string form eg: `'15 minutes'`
     * @param {Date} [base] The "start" from which to apply the ceiling.
     */

  }, {
    key: "ceil",
    value: function ceil(time, increment, base) {
      return DH.snap('ceil', time, increment, base);
    }
    /**
     * Implementation for round, floor and ceil.
     * @internal
     */

  }, {
    key: "snap",
    value: function snap(operation, time, increment, base) {
      var snapFn = snapFns[operation];

      if (typeof increment === 'string') {
        increment = DH.parseDuration(increment); // increment is in weeks, months, quarters or years, then it can't be handled
        // using millisecond arithmetic.

        switch (increment.unit) {
          case 'week':
            {
              var weekStartDay = DH.weekStartDay,
                  weekDay = time.getDay(); // weekStartDay gives our base
              // Our base is the start of the week

              base = DH.add(DH.clearTime(time), weekDay >= weekStartDay ? weekStartDay - weekDay : -(weekDay - weekStartDay + 7), 'day');
              return DH[operation](time, "".concat(increment.magnitude * 7, " days"), base);
            }

          case 'month':
            {
              // Express the time as a number of months from epoch start.
              // May be a fraction, eg the 15th will be 0.5 through a month.
              time = DH.asMonths(time);
              var resultMonths; // Snap the month count in the way requested

              if (base) {
                base = DH.asMonths(base);
                resultMonths = time + snapFn(time - base, increment.magnitude);
              } else {
                resultMonths = snapFn(time, increment.magnitude);
              } // Convert resulting month value back to a date


              return DH.monthsToDate(resultMonths);
            }

          case 'quarter':
            return DH[operation](time, "".concat(increment.magnitude * 3, " months"), base);

          case 'year':
            return DH[operation](time, "".concat(increment.magnitude * 12, " months"), base);
        } // Convert to a millisecond value


        increment = DH.as('ms', increment.magnitude, increment.unit);
      } // It's a simple round to milliseconds


      if (base) {
        var tzChange = DH.as('ms', base.getTimezoneOffset() - time.getTimezoneOffset(), 'ms');
        return new Date(base.valueOf() + snapFn(DH.diff(base, time, 'ms') + tzChange, increment));
      } else {
        var offset = time.getTimezoneOffset() * 60 * 1000; // Assuming current TZ is GMT+3
        // new Date(2000, 0, 1) / 86400000      -> 10956.875
        // new Date(2000, 0, 1, 3) / 86400000   -> 10957
        // Before calculation we need to align time value of the current timezone to GMT+0
        // And after calculate we need to adjust time back

        return new Date(snapFn(time.valueOf() - offset, increment) + offset);
      }
    } //endregion
    //region Date picker format

    /**
     * Parses a typed duration value according to locale rules.
     *
     * The value is taken to be a string consisting of the numeric magnitude and the units.
     * The units may be a recognised unit abbreviation of this locale or the full local unit name.
     *
     * For example: "2d", "2 d", "2 day", "2 days" will be turned into `{ magnitude : 2, unit : "day" }`
     *
     * **NOTE:** Doesn't work with complex values like "2 days, 2 hours"
     *
     * @param {String} value The value to parse.
     * @param {Boolean} [allowDecimals=true] Decimals are allowed in the magnitude.
     * @param {String} [defaultUnit] Default unit to use if only magnitude passed.
     * @returns {Object} If successfully parsed, the result contains two properties,
     * `magnitude` being a number, and `unit` being the canonical unit name, *NOT*
     * a localized name. If parsing was unsuccessful, `null` is returned.
     * @category Parse & format
     */

  }, {
    key: "parseDuration",
    value: function parseDuration(value) {
      var allowDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var defaultUnit = arguments.length > 2 ? arguments[2] : undefined;
      var durationRegEx = allowDecimals ? withDecimalsDurationRegex : noDecimalsDurationRegex,
          match = durationRegEx.exec(value);

      if (value == null || !match) {
        return null;
      }

      var magnitude = parseNumber(match[1]),
          unit = DH.parseTimeUnit(match[2]) || defaultUnit;

      if (!unit) {
        return null;
      }

      return {
        magnitude: magnitude,
        unit: unit
      };
    }
    /**
     * Parses a typed unit name, for example `"ms"` or `"hr"` or `"yr"` into the
     * canonical form of the unit name which may be passed to {@link #function-add-static}
     * or {@link #function-diff-static}
     * @param {*} unitName
     * @category Parse & format
     */

  }, {
    key: "parseTimeUnit",
    value: function parseTimeUnit(unitName) {
      // NOTE: In case you get a crash here when running tests, it is caused by missing locale. Build locales
      // using `scripts/build.js locales` to resolve.
      var unitMatch = unitName == null ? null : DH.durationRegEx.exec(unitName.toLowerCase());

      if (!unitMatch) {
        return null;
      } // See which group in the unitAbbrRegEx matched match[2]


      for (var unitOrdinal = 0; unitOrdinal < canonicalUnitNames.length; unitOrdinal++) {
        if (unitMatch[unitOrdinal + 1]) {
          return canonicalUnitNames[unitOrdinal];
        }
      }
    } //endregion
    //region Internal

  }, {
    key: "getGMTOffset",
    value: function getGMTOffset() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

      if (!date) {
        return;
      }

      var offsetInMinutes = date.getTimezoneOffset(); // return 'Z' for UTC

      if (!offsetInMinutes) return 'Z';
      return (offsetInMinutes > 0 ? '-' : '+') + Math.abs(Math.trunc(offsetInMinutes / 60)).toString().padStart(2, '0') + ':' + Math.abs(offsetInMinutes % 60).toString().padStart(2, '0');
    }
  }, {
    key: "fillDayNames",
    value: function fillDayNames() {
      var tempDate = new Date('2000-01-01T12:00:00'),
          dayNames = DH._dayNames || [],
          dayShortNames = DH._dayShortNames || [];
      dayNames.length = 0;
      dayShortNames.length = 0;

      for (var day = 2; day < 9; day++) {
        tempDate.setDate(day);
        dayNames.push(DH.format(tempDate, 'dddd'));
        dayShortNames.push(DH.format(tempDate, 'ddd'));
      }

      DH._dayNames = dayNames;
      DH._dayShortNames = dayShortNames;
    }
  }, {
    key: "getDayNames",
    value: function getDayNames() {
      return DH._dayNames;
    }
  }, {
    key: "getDayName",
    value: function getDayName(day) {
      return DH._dayNames[day];
    }
  }, {
    key: "getDayShortNames",
    value: function getDayShortNames() {
      return DH._dayShortNames;
    }
  }, {
    key: "getDayShortName",
    value: function getDayShortName(day) {
      return DH._dayShortNames[day];
    }
  }, {
    key: "fillMonthNames",
    value: function fillMonthNames() {
      var tempDate = new Date('2000-01-15T12:00:00'),
          monthNames = DH._monthNames || [],
          monthShortNames = DH._monthShortNames || [];
      monthNames.length = 0;
      monthShortNames.length = 0;

      for (var month = 0; month < 12; month++) {
        tempDate.setMonth(month);
        monthNames.push(DH.format(tempDate, 'MMMM'));
        monthShortNames.push(DH.format(tempDate, 'MMM'));
      }

      DH._monthNames = monthNames;
      DH._monthShortNames = monthShortNames;
    }
  }, {
    key: "getMonthShortNames",
    value: function getMonthShortNames() {
      return DH._monthShortNames;
    }
  }, {
    key: "getMonthShortName",
    value: function getMonthShortName(month) {
      return DH._monthShortNames[month];
    }
  }, {
    key: "getMonthNames",
    value: function getMonthNames() {
      return DH._monthNames;
    }
  }, {
    key: "getMonthName",
    value: function getMonthName(month) {
      return DH._monthNames[month];
    }
  }, {
    key: "setupDurationRegEx",
    value: function setupDurationRegEx() {
      var unitNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var unitAbbreviations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var me = this,
          unitLookup = {};
      var unitAbbrRegEx = '';

      for (var i = 0; i < unitAbbreviations.length; i++) {
        var // for example ['s', 'sec']
        abbreviations = unitAbbreviations[i],
            // for example { single : 'second', plural : 'seconds', abbrev : 's' }
        unitNamesCfg = unitNames[i];
        unitNamesCfg.canonicalUnitName = canonicalUnitNames[i]; // Create a unitLookup object keyed by unit full names
        // both lower and upper case to be able to look up plurals or abbreviations
        // also always include english names, since those are used in sources

        unitLookup[unitNamesCfg.single] = unitLookup[unitNamesCfg.single.toUpperCase()] = unitLookup[unitNamesCfg.canonicalUnitName] = unitLookup[unitNamesCfg.canonicalUnitName.toUpperCase()] = unitNamesCfg;
        unitAbbrRegEx += "".concat(i ? '|' : '', "(");

        for (var j = 0; j < abbreviations.length; j++) {
          unitAbbrRegEx += "".concat(abbreviations[j], "|");
        }

        locale = me.localize('L{locale}') || 'en-US';

        if (locale !== 'en-US') {
          // Add canonical values to be able to parse durations specified in configs
          var canonicalAbbreviations = canonicalUnitAbbreviations[i];

          for (var _j = 0; _j < canonicalAbbreviations.length; _j++) {
            unitAbbrRegEx += "".concat(canonicalAbbreviations[_j], "|");
          }
        }

        unitAbbrRegEx += "".concat(unitNamesCfg.single, "|").concat(unitNamesCfg.plural, "|").concat(unitNamesCfg.canonicalUnitName, "|").concat(unitNamesCfg.canonicalUnitName, "s)");
      }

      me.unitLookup = unitLookup;
      me.durationRegEx = new RegExp("^(?:".concat(unitAbbrRegEx, ")$"));
    }
  }, {
    key: "applyLocale",
    value: function applyLocale() {
      var me = this,
          unitAbbreviations = me.localize('L{unitAbbreviations}') || [],
          unitNames = me.unitNames = me.localize('L{unitNames}'); // This happens when applying an incomplete locale, as done in Localizable.t.js.
      // Invalid usecase, but return to prevent a crash in that test.

      if (unitNames === 'unitNames') {
        return;
      }

      locale = me.localize('L{locale}') || 'en-US';

      if (locale === 'en-US') {
        // TODO: Include in En locale instead?
        ordinalSuffix = enOrdinalSuffix;
      } else {
        ordinalSuffix = me.localize('L{ordinalSuffix}') || ordinalSuffix;
      }

      formatCache = {};
      parserCache = {};
      intlFormatterCache = {};
      DH.setupDurationRegEx(unitNames, unitAbbreviations); // rebuild day/month names cache

      DH.fillDayNames();
      DH.fillMonthNames();
    } //endregion

  }, {
    key: "$name",
    get: function get() {
      return 'DateHelper';
    } //region Parse & format

    /**
     * Get/set the default format used by `format()` and `parse()`. Defaults to `'YYYY-MM-DDTHH:mm:ssZ'`
     * (~ISO 8601 Date and time, `'1962-06-17T09:21:34Z'`).
     * @member {String}
     */

  }, {
    key: "defaultFormat",
    set: function set(format) {
      DH._defaultFormat = format;
    },
    get: function get() {
      return DH._defaultFormat || 'YYYY-MM-DDTHH:mm:ssZ';
    }
    /**
     * Get/set the default format used by `parse()`. Defaults to `'YYYY-MM-DDTHH:mm:ss.SSSZ'` or {@link #property-defaultFormat-static}
     * (~ISO 8601 Date and time, `'1962-06-17T09:21:34.123Z'`).
     * @member {String}
     */

  }, {
    key: "defaultParseFormat",
    set: function set(parseFormat) {
      this._defaultParseFormat = parseFormat;
    },
    get: function get() {
      return this._defaultParseFormat || this._defaultFormat || 'YYYY-MM-DDTHH:mm:ss.SSSZ';
    }
  }, {
    key: "weekStartDay",
    get: function get() {
      // Defaults to 0, should not need to happen in real world scenarios when a locale is always loaded
      return this.localize('L{weekStartDay}') || 0;
    }
  }, {
    key: "locale",
    set: function set(name) {
      locale = name;
    },
    get: function get() {
      return locale;
    }
  }]);

  return DateHelper;
}(Object(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_41__["default"])());


var DH = DateHelper;
DH.useIntlFormat = useIntlFormat; // to use on tests

/*  */
// Update when changing locale

_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_42__["default"].on({
  locale: 'applyLocale',
  prio: 1000,
  thisObj: DH
}); // Apply default locale

if (_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_42__["default"].locale) {
  DH.applyLocale();
}

DateHelper._$name = 'DateHelper';

/***/ }),

/***/ "./lib/Core/helper/DomHelper.js":
/*!**************************************!*\
  !*** ./lib/Core/helper/DomHelper.js ***!
  \**************************************/
/*! exports provided: hasLayout, isVisible, isInDocument, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLayout", function() { return hasLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVisible", function() { return _isVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInDocument", function() { return isInDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomHelper; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");





































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';
/* eslint-disable standard/no-callback-literal */





 // Point must be imported because it needs to inject itself into the Rectangle class
//import './util/Point.js';
// TODO import VersionHelper from './VersionHelper.js';
// Gives circular dependencies which I could not solve, called from global scope instead
//import GlobalEvents from '../GlobalEvents.js';
// https://app.assembla.com/spaces/bryntum/tickets/7903-rendering-fails
// HACK: this value is required to calculate width if it was configured relative to font size (em) but no element is set

var DEFAULT_FONT_SIZE = 14,
    t0t0 = {
  align: 't0-t0'
},
    // eslint-disable-next-line no-undef
ELEMENT_NODE = Node.ELEMENT_NODE,
    // eslint-disable-next-line no-undef
TEXT_NODE = Node.TEXT_NODE; // We only do the measurement once, if the value is null

var scrollBarWidth = null,
    idCounter = 0,
    themeInfo = null,
    root;

var // Transform matrix parse Regex. CSS transform computed style looks like this:
// matrix(scaleX(), skewY(), skewX(), scaleY(), translateX(), translateY())
// or
// matrix3d(scaleX(), skewY(), 0, 0, skewX(), scaleY(), 0, 0, 0, 0, 1, 0, translateX(), translateY())
// This is more reliable than using the style literal which may include
// relative styles such as "translateX(-20em)", or not include the translation at all if it's from a CSS rule.
// Use a const so as to only compile RexExp once
// Extract repeating number regexp to simplify next expressions. Available values are: https://developer.mozilla.org/en-US/docs/Web/CSS/number
numberRe = /[+-]?\d*\.?\d+[eE]?-?\d*/g,
    // -2.4492935982947064e-16 should be supported
numberReSrc = numberRe.source,
    translateMatrix2dRe = new RegExp("matrix\\((?:".concat(numberReSrc, "),\\s?(?:").concat(numberReSrc, "),\\s?(?:").concat(numberReSrc, "),\\s?(?:").concat(numberReSrc, "),\\s?(").concat(numberReSrc, "),\\s?(").concat(numberReSrc, ")")),
    translateMatrix3dRe = new RegExp("matrix3d\\((?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(-?\\d*),\\s?(-?\\d*)"),
    translateMatrixRe = new RegExp("(?:".concat(translateMatrix2dRe.source, ")|(?:").concat(translateMatrix3dRe.source, ")")),
    pxTtranslateXRe = new RegExp("translate(3d|X)?\\((".concat(numberReSrc, ")px(?:,\\s?(").concat(numberReSrc, ")px)?")),
    pxTtranslateYRe = new RegExp("translate(3d|Y)?\\((".concat(numberReSrc, ")px(?:,\\s?(").concat(numberReSrc, ")px)?")),
    domIdRe = /^[^a-z]+|[^\w:.-]+/gi,
    whiteSpaceRe = /\s+/,
    semicolonRe = /\s*;\s*/,
    colonRe = /\s*:\s*/,
    elementPropKey = '$bryntum',
    // DomHelper#createElement properties which require special processing.
// All other configs such as id and type are applied directly to the element.
elementCreateProperties = {
  tag: 1,
  html: 1,
  for: 1,
  children: 1,
  tooltip: 1,
  style: 1,
  dataset: 1,
  parent: 1,
  nextSibling: 1,
  ns: 1,
  reference: 1,
  className: 1,
  unmatched: 1,
  // Used by syncId approach
  _element: 1,
  // Used by sync to assign used element back to the config, for usage by the caller
  onlyChildren: 1,
  // Used by sync to not touch the target element itself,
  elementData: 1,
  listeners: 1,
  compareHtml: 1,
  // Sync,
  syncOptions: 1 // Sync

},
    styleIgnoreProperties = {
  length: 1,
  parentRule: 1,
  style: 1
},
    styleDimensionProperties = {
  width: 1,
  height: 1,
  top: 1,
  left: 1,
  minWidth: 1,
  minHeight: 1,
  maxWidth: 1,
  maxHeight: 1,
  fontSize: 1
},
    nativeFocusableTags = {
  BUTTON: 1,
  IFRAME: 1,
  EMBED: 1,
  INPUT: 1,
  OBJECT: 1,
  SELECT: 1,
  TEXTAREA: 1,
  HTML: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11 ? 1 : 0,
  BODY: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11 ? 0 : 1
},
    win = window,
    doc = document,
    emptyObject = {},
    emptyArray = [],
    arraySlice = Array.prototype.slice,
    immediatePromise = Promise.resolve(),
    fontProps = ['font-size', 'font-size-adjust', 'font-style', 'font-weight', 'font-family', 'font-kerning', 'font-stretch', 'line-height', 'text-transform', 'text-decoration', 'letter-spacing', 'word-break'],
    isHiddenWidget = function isHiddenWidget(e) {
  return e._hidden;
},
    parentNode = function parentNode(el) {
  return el.parentNode || el.host;
},
    _isVisible = function isVisible(e) {
  var style = e.ownerDocument.defaultView.getComputedStyle(e);
  return style.getPropertyValue('display') !== 'none' && style.getPropertyValue('visibility') !== 'hidden';
},
    getRootNode = document.documentElement.getRootNode ? function (el) {
  return el.getRootNode();
} : function (el) {
  while (el.parentNode) {
    el = el.parentNode;
  }

  return el;
},
    // Both Shadow Root Element and Anchor <a> Element have `host` property.
// https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/host
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/host
// Need make sure `host` is an Element.
isShadowRoot = function isShadowRoot(el) {
  return el.host && el.host instanceof Element;
},
    // Check whether the element has an offsetParent.
// Nodes such as SVG which do not expose such a property must have an ancestor which has an offsetParent.
hasLayout = function hasLayout(el) {
  return el && (el === document.body || ('offsetParent' in el ? el.offsetParent : hasLayout(el.parentNode)));
},
    // Check for node being in document.
// If part of shadow DOM, see if the root's host is in the DOM
isInDocument = function isInDocument(el) {
  return el && (document.body.contains(el) || (root = getRootNode(el)) && isShadowRoot(root) && isInDocument(root.host));
},
    elementOrConfigToElement = function elementOrConfigToElement(elementOrConfig) {
  if (elementOrConfig instanceof Node) {
    return elementOrConfig;
  }

  if (typeof elementOrConfig === 'string') {
    return DH.createElementFromTemplate(elementOrConfig);
  }

  return DH.createElement(elementOrConfig);
};


var templateElement, htmlParser;
/**
 * @module Core/helper/DomHelper
 */

/**
 * Helps with dom querying and manipulation.
 * ```
 * DomHelper.createElement({
 *   tag: 'div',
 *   className: 'parent',
 *   style: 'background: red',
 *   children: [
 *      { tag: 'div', className: 'child' },
 *      { tag: 'div', className: 'child' }
 *   ]
 * });
 * ```
 */

var DomHelper = /*#__PURE__*/function () {
  function DomHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34___default()(this, DomHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35___default()(DomHelper, null, [{
    key: "isFocusable",

    /**
     * Returns `true` if the passed element is focusable either programatically or through pointer gestures.
     * @param {HTMLElement} element The element to test.
     */
    value: function isFocusable(element) {
      var skipAccessibilityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!skipAccessibilityCheck) {
        // If element is hidden or in a hidden Widget, it's not focusable.
        if (!DH.isVisible(element) || DH.Widget.fromElement(element, isHiddenWidget)) {
          return false;
        }
      }

      var nodeName = element.nodeName;
      /*
       * An element is focusable if:
       *   - It is natively focusable, or
       *   - It is an anchor or link with href attribute, or
       *   - It has a tabIndex, or
       *   - It is an editing host (contenteditable="true")
       */

      return nativeFocusableTags[nodeName] || (nodeName === 'A' || nodeName === 'LINK') && !!element.href || element.getAttribute('tabIndex') != null || element.contentEditable === 'true';
    }
    /**
     * Returns `true` if the passed element is currently visible in the browser viewport, i.e. user can find it on screen
     * @param {HTMLElement} element The element to test.
     * @param {Boolean} whole Whether to check that whole element is visible, not just part of it.
     */

  }, {
    key: "isInView",
    value: function isInView(el) {
      var whole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var elRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_38__["default"].from(el),
          inView = true;
      var fullHeight = elRect.height,
          fullWidth = elRect.width;

      while (inView && el.parentElement) {
        el = el.parentElement;
        elRect = elRect.intersect(_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_38__["default"].from(el));
        inView = elRect && (!whole || elRect.height >= fullHeight && elRect.width >= fullWidth);
      }

      return inView;
    }
    /**
     * Returns `true` if the passed element is deeply visible. Meaning it is not hidden using `display`
     * or `visibility` and no ancestor node is hidden.
     * @param {HTMLElement} element The element to test.
     * @returns {Boolean} `true` if deeply visible.
     */

  }, {
    key: "isVisible",
    value: function isVisible(element) {
      var document = element.ownerDocument; // Use the parentNode function so that we can traverse upwards through shadow DOM
      // to correctly ascertain visibility of nodes in web components.

      for (; element; element = parentNode(element)) {
        // Visible if we've reached top of the owning document without finding a hidden Element.
        if (element === document) {
          return true;
        } // Must not evaluate a shadow DOM's root fragment.


        if (element.nodeType === 1 && !_isVisible(element)) {
          return false;
        }
      } // We get here if the node is detached.


      return false;
    }
  }, {
    key: "roundPx",
    value: function roundPx(px) {
      var devicePixelRatio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.devicePixelRatio || 1;
      var multiplier = 1 / devicePixelRatio;
      return Math.round(px / multiplier) * multiplier;
    }
    /**
     * Returns true if element has opened shadow root
     * @param {HTMLElement} element Element to check
     * @returns {Boolean}
     */

  }, {
    key: "isCustomElement",
    value: function isCustomElement(element) {
      return element && element.shadowRoot;
    }
    /**
     * Resolves element from point, checking shadow DOM if requried
     * @param {Number} x
     * @param {Number} y
     * @returns {HTMLElement}
     */

  }, {
    key: "elementFromPoint",
    value: function elementFromPoint(x, y) {
      var el = document.elementFromPoint(x, y); // Try to check shadow dom if it exists

      if (DH.isCustomElement(el)) {
        el = el.shadowRoot.elementFromPoint(x, y) || el;
      }

      return el;
    }
    /**
     * Returns active element checking shadow dom too
     * @returns {HTMLElement}
     */

  }, {
    key: "getId",

    /**
     * Returns the `id` of the passed element. Generates a unique `id` if the element does not have one.
     * @param {HTMLElement} element The element to return the `id` of.
     */
    value: function getId(element) {
      return element.id || (element.id = 'b-element-' + ++idCounter);
    }
    /**
     * Returns common widget/node ancestor for from/to arguments
     * @param {Widget/HTMLElement} from
     * @param {Widget/HTMLElement} to
     * @returns {Widget/HTMLElement}
     * @internal
     */

  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(from, to) {
      if (from === to) {
        return from;
      }

      while (from && !(((_from = (_from2 = from)[from.isWidget ? 'owns' : 'contains']) === null || _from === void 0 ? void 0 : _from.call(_from2, to)) || from === to)) {
        var _from, _from2;

        from = from.owner || from.parentNode;
      }

      return from;
    } //region Internal

    /**
     * Internal convenience fn to allow specifying either an element or a CSS selector to retrieve one
     * @private
     * @param {String|HTMLElement} elementOrSelector element or selector to lookup in DOM
     * @returns {HTMLElement}
     */

  }, {
    key: "getElement",
    value: function getElement(elementOrSelector) {
      // also used for SVG elements, so need to use more basic class, that is also returned by querySelector
      if (elementOrSelector instanceof Element) {
        return elementOrSelector;
      }

      return doc.querySelector(elementOrSelector);
    }
    /**
     * Sets attributes passed as object to given element
     * @private
     * @param {String|Element} elementOrSelector
     * @param {Object} attributes
     */

  }, {
    key: "setAttributes",
    value: function setAttributes(elementOrSelector, attributes) {
      var element = DH.getElement(elementOrSelector);
      Object.entries(attributes).forEach(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_33___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return element.setAttribute(key, value);
      });
    }
    /**
     * Sets a CSS [length](https://developer.mozilla.org/en-US/docs/Web/CSS/length) style value.
     * @param {String|HTMLElement} element The element to set the style in, or, if just the result is required,
     * the style magnitude to return with units added.
     * @param {String} [style] The name of a style property which specifies a [length](https://developer.mozilla.org/en-US/docs/Web/CSS/length)
     * @param {Number|String} [value] The magnitude. If a number is used, the value will be set in `px` units.
     * @returns {String} The style value string.
     */

  }, {
    key: "setLength",
    value: function setLength(element, style, value) {
      if (arguments.length === 1) {
        return typeof element === 'number' ? "".concat(element, "px") : element;
      } else {
        element = DH.getElement(element);
        return element.style[style] = typeof value === 'number' ? "".concat(value, "px") : value;
      }
    } //endregion
    //region Children, going down...

    /**
     * Gets the first direct child of `element` that matches `selector.
     * @param {HTMLElement} element Parent element
     * @param {String} selector CSS selector
     * @returns {HTMLElement}
     * @category Query children
     */

  }, {
    key: "getChild",
    value: function getChild(element, selector) {
      // TODO: Only IE11 doesn't support :scope
      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].supportsQueryScope) {
        selector = ':scope>' + selector;
      } else {
        var elId = element.id || (element.id = 'b-element-' + ++idCounter);
        selector = "#".concat(elId, " > ").concat(selector);
      }

      return element.querySelector(selector);
    }
    /**
     * Checks if `element` has any child that matches `selector`.
     * @param {HTMLElement} element Parent element
     * @param {String} selector CSS selector
     * @returns {Boolean} true if any child matches selector
     * @category Query children
     */

  }, {
    key: "hasChild",
    value: function hasChild(element, selector) {
      return DH.getChild(element, selector) != null;
    }
    /**
     * Returns all child elements (not necessarily direct children) that matches `selector`.
     *
     * If `selector` starts with `'>'` or `'# '`, then all components of the `selector` must match inside of `element`.
     * Where supported, `:scope` is prepended to the selector (and if `#` was used, it is removed). In other cases,
     * the `id` of the `element` is used to restrict the `selector`. If necessary, the `element` may be assigned a
     * generated `id` to enable this.
     *
     * These are equivalent:
     *
     *      DomHelper.children(el, '# .foo .bar');
     *
     *      el.querySelectorAll(':scope .foo .bar');
     *
     * These are also equivalent:
     *
     *      DomHelper.children(el, '> .foo .bar');
     *
     *      el.querySelectorAll(':scope > .foo .bar');
     *
     * @param {HTMLElement} element The parent element
     * @param {String} selector The CSS selector
     * @returns {HTMLElement[]} Matched elements, somewhere below `element`
     * @category Query children
     */

  }, {
    key: "children",
    value: function children(element, selector) {
      // a '#' could be '#id' but '# ' (hash and space) is not a valid selector...
      if (selector[0] === '>' || selector.startsWith('# ')) {
        if (selector[0] === '#') {
          selector = selector.substr(2);
        }

        if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].supportsQueryScope) {
          selector = ':scope ' + selector;
        } else {
          var elId = element.id || (element.id = 'b-element-' + ++idCounter);
          selector = "#".concat(elId, " ").concat(selector);
        }
      }

      return Array.from(element.querySelectorAll(selector));
    }
    /**
     * Looks at the specified `element` and all of its children for the one that first matches `selector.
     * @param {HTMLElement} element Parent element
     * @param {String} selector CSS selector
     * @returns {HTMLElement} Matched element, either element or an element below it
     * @category Query children
     */

  }, {
    key: "down",
    value: function down(element, selector) {
      if (!element) {
        return null;
      }

      if (element.matches && element.matches(selector)) {
        return element;
      }

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].supportsQueryScope) {
        selector = ':scope ' + selector;
      } else {
        var elId = element.id || (element.id = 'b-element-' + ++idCounter);
        selector = "#".concat(elId, " ").concat(selector);
      }

      return element.querySelector(selector);
    }
    /**
     * Checks if childElement is a descendant of parentElement (contained in it or a sub element)
     * @param {HTMLElement} parentElement Parent element
     * @param {HTMLElement} childElement Child element, at any level below parent
     * @returns {Boolean}
     * @category Query children
     */

  }, {
    key: "isDescendant",
    value: function isDescendant(parentElement, childElement) {
      // In case of IE11 and parentElement is <html>, HTMLDocument#contains is not supported - fallback to body
      if (!parentElement.contains) {
        parentElement = parentElement.body;
      }

      return parentElement.contains(childElement);
    }
    /**
     * Returns the specified element of the given `event`. If the `event` is an `Element`, it is returned. Otherwise,
     * the `eventName` argument is used to retrieve the desired element property from `event` (this defaults to the
     * `'target'` property).
     * @param {Event|Element} event
     * @param {String} [elementName]
     * @returns {Element}
     */

  }, {
    key: "getEventElement",
    value: function getEventElement(event) {
      var elementName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'target';
      return DH.isElement(event) ? event : event[elementName];
    }
    /**
     * Returns `true` if the provided value is _likely_ a DOM element. If the element can be assured to be from the
     * same document, `instanceof Element` is more reliable.
     * @param {*} value
     * @returns {Boolean}
     */

  }, {
    key: "isElement",
    value: function isElement(value) {
      return (value === null || value === void 0 ? void 0 : value.nodeType) === 1 && DH.isNode(value);
    }
    /**
     * Returns `true` if the provided value is _likely_ a DOM node. If the node can be assured to be from the same
     * document, `instanceof Node` is more reliable.
     * @param {*} value
     * @returns {Boolean}
     */

  }, {
    key: "isNode",
    value: function isNode(value) {
      // cannot use instanceof across frames. Using it here won't help since we'd need the same logic if it were
      // false... meaning we'd have the same chances of a false-positive.
      return Boolean(value) && typeof value.nodeType === 'number' && !_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].isObject(value);
    }
    /**
     * Iterates over each result returned from `element.querySelectorAll(selector)`. First turns it into an array to
     * work in IE. Can also be called with only two arguments, in which case the first argument is used as selector and
     * document is used as the element.
     * @param {HTMLElement} element Parent element
     * @param {String} selector CSS selector
     * @param {Function} fn Function called for each found element
     * @category Query children
     */

  }, {
    key: "forEachSelector",
    value: function forEachSelector(element, selector, fn) {
      if (typeof element === 'string') {
        fn = selector;
        selector = element;
        element = doc;
      }

      DH.children(element, selector).forEach(fn);
    }
    /**
     * Iterates over the direct child elements of the specified element. First turns it into an array to
     * work in IE.
     * @param {HTMLElement} element Parent element
     * @param {Function} fn Function called for each child element
     * @category Query children
     */

  }, {
    key: "forEachChild",
    value: function forEachChild(element, fn) {
      Array.from(element.children).forEach(fn);
    }
    /**
     * Removes each element returned from `element.querySelectorAll(selector)`.
     * @param {HTMLElement} element
     * @param {String} selector
     * @category Query children
     */

  }, {
    key: "removeEachSelector",
    value: function removeEachSelector(element, selector) {
      DH.forEachSelector(element, selector, function (child) {
        return child.remove();
      });
    }
  }, {
    key: "removeClsGlobally",
    value: function removeClsGlobally(element) {
      for (var _len = arguments.length, classes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        classes[_key - 1] = arguments[_key];
      }

      classes.forEach(function (cls) {
        return DH.forEachSelector(element, '.' + cls, function (child) {
          return child.classList.remove(cls);
        });
      });
    } //endregion
    //region Parents, going up...

    /**
     * Looks at the specified element and all of its parents for the one that first matches selector.
     * @param {HTMLElement} element Element
     * @param {String} selector CSS selector
     * @returns {HTMLElement} Matched element, either the passed in element or an element above it
     * @category Query parents
     */

  }, {
    key: "up",
    value: function up(element, selector) {
      return element && element.closest(selector);
    }
  }, {
    key: "getAncestor",
    value: function getAncestor(element, possibleAncestorParents) {
      var outerElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var found = false,
          ancestor,
          parent = element;
      if (!Array.isArray(possibleAncestorParents)) possibleAncestorParents = [possibleAncestorParents];

      while (parent = parent.parentElement) {
        if (possibleAncestorParents.includes(parent)) {
          found = true;
          break;
        }

        if (outerElement && parent === outerElement) break;
        ancestor = parent;
      }

      if (!found) return null;
      return ancestor || element;
    }
    /**
     * Retrieves all parents to the specified element.
     * @param {HTMLElement} element Element
     * @returns {HTMLElement[]} All parent elements, bottom up
     * @category Query parents
     */

  }, {
    key: "getParents",
    value: function getParents(element) {
      var parents = [];

      while (element.parentElement) {
        parents.push(element.parentElement);
        element = element.parentElement;
      }

      return parents;
    } //endregion
    //region Creation

    /**
     * Converts the passed id to an id valid for usage as id on a DOM element.
     * @param {String} id
     * @returns {String}
     */

  }, {
    key: "makeValidId",
    value: function makeValidId(id) {
      if (id == null) return null;
      return String(id).replace(domIdRe, '');
    }
    /**
     * Creates an Element. Example usage:
     * @example
     * DomHelper.createElement({
     *   tag         : 'table', // defaults to 'div'
     *   cellSpacing : 0,
     *   className   : 'nacho',
     *   html        : 'I am a nacho',
     *   children    : [ { tag: 'tr', ... }, myDomElement ],
     *   parent      : myExistingElement // Or its id
     *   style       : 'font-weight: bold;color: red',
     *   dataset     : { index: 0, size: 10 },
     *   tooltip     : 'Yay!',
     *   ns          : 'http://www.w3.org/1999/xhtml'
     * });
     * @param {Object} config Element config, as in example
     * @param {Boolean|Object} options An object specifying creation options. If this is a boolean value, it is
     * understood to be the `returnAll` option. Passing a boolean is deprecated in favor of the `options` object.
     * @param {Boolean} options.returnAll Specify true to return all elements & child elements
     * created as an array.
     * @returns {HTMLElement|HTMLElement[]|Object} Single element or array of elements `returnAll` was set to true.
     * If any elements had a `reference` property, this will be an object containing a reference to
     * all those elements, keyed by the reference name.
     * @category Creation
     */

  }, {
    key: "createElement",
    value: function createElement() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 ? arguments[1] : undefined;
      var returnAll = options,
          refOwner,
          refs,
          syncIdField;

      if (typeof returnAll === 'boolean') {
        refs = arguments.length <= 2 ? undefined : arguments[2];
        syncIdField = arguments.length <= 3 ? undefined : arguments[3]; // TODO There are many internal calls that will need refactoring to the object form before we can do this:
        // VersionHelper.deprecate('Core', '4.0.0',
        //     'DomHelper.createElement should be given an options object not the returnAll boolean');

        options = {
          returnAll: returnAll,
          refs: refs,
          syncIdField: syncIdField
        };
      } else if (options) {
        refOwner = options.refOwner;
        refs = options.refs;
        returnAll = options.returnAll;
        syncIdField = options.syncIdField;
      }

      if (typeof config.parent === 'string') {
        config.parent = document.getElementById(config.parent);
      }

      if (config.syncOptions) {
        syncIdField = config.syncOptions.syncIdField || syncIdField;
      } // nextSibling implies a parent


      var parent = config.parent || config.nextSibling && config.nextSibling.parentNode,
          reference = config.reference;
      var element;

      if (config.ns) {
        element = doc.createElementNS(config.ns, config.tag || 'svg');
      } else {
        element = doc.createElement(config.tag || 'div');
      }

      if (config.html != null) {
        if (config.html instanceof DocumentFragment) {
          element.appendChild(config.html);
        } else {
          element.innerHTML = config.html;
        }
      }

      if (config.tooltip) {
        DH.Widget.attachTooltip(element, config.tooltip);
      }

      if (config.style) {
        DH.applyStyle(element, config.style);
      }

      if (config.dataset) {
        Object.assign(element.dataset, config.dataset);
      }

      if (config.for) {
        element.htmlFor = config.for;
      }

      if (parent) {
        parent.insertBefore(element, config.nextSibling);
      }

      if (refOwner) {
        // Tag each element created by the refOwner's id to enable DomSync
        element.$refOwnerId = refOwner.id;
      }

      if (reference) {
        // SalesForce platform does not allow custom attributes, but existing code
        // uses querySelector('[reference]'), so bypass it when we can:
        if (refOwner) {
          refOwner.byRef[element.$reference = reference] = element;
          refOwner.attachRef(reference, element, config);
        } else {
          // TODO fixup callers to do the above
          if (!refs) {
            options = Object.assign({}, options);
            options.refs = refs = {};
          }

          refs[reference] = element;
          element.setAttribute('data-reference', reference);
        }
      } // Attach custom data to the element, not visible


      if (config.elementData) {
        element.elementData = config.elementData;
      }

      var className = config.className || config.class; // matches DomSync

      if (className) {
        element.setAttribute('class', _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_40__["default"].normalize(className));
      } // Handle things like id, className, type, rel, cellSpacing, href etc which just get assigned.


      for (var _i = 0, _Object$keys = Object.keys(config); _i < _Object$keys.length; _i++) {
        var prop = _Object$keys[_i];

        if (!elementCreateProperties[prop]) {
          if (config.ns) {
            element.setAttribute(prop, config[prop]); //element.setAttributeNS(config.ns, prop, config[prop]);
          } else {
            element[prop] = config[prop];
          }
        }
      } // if returnAll is true, use array


      if (returnAll === true) {
        options.returnAll = returnAll = [element];
      } // if it already is an array, add to it (we are probably a child)
      else if (Array.isArray(returnAll)) {
          returnAll.push(element);
        }

      if (config.children) {
        if (syncIdField) {
          // Map syncId -> child element to avoid querying dom later on
          element.syncIdMap = {};
        }

        config.children.forEach(function (child) {
          // Skip null children, convenient to allow those for usage with Array.map()
          if (child) {
            // Append string children as text nodes
            if (typeof child === 'string') {
              var textNode = document.createTextNode(child);

              if (refOwner) {
                textNode.$refOwnerId = refOwner.id;
              }

              element.appendChild(textNode);
            } // Just append Elements directly.
            else if (isNaN(child.nodeType)) {
                child.parent = element;

                if (!child.ns && config.ns) {
                  child.ns = config.ns;
                }

                var childElement = DH.createElement(child, options),
                    syncId = child.dataset && child.dataset[syncIdField]; // syncId is used with DomHelper.sync to match elements. Populate a map here to make finding them faster

                if (syncId != null) {
                  element.syncIdMap[syncId] = childElement;
                } // Do not want to alter the initial config


                delete child.parent;
              } else {
                element.appendChild(child);
              }
          }
        });
      } // Store used config, to be able to compare on sync to determine if changed without hitting dom


      element.lastDomConfig = config; // Link element to config for easy retrieval

      config._element = element; // If references were used, return them in an object
      // If returnAll was specified, return the array
      // By default, return the root element

      return refs || returnAll || element;
    }
    /**
     * Create element(s) from a template (html string). Note that
     * `textNode`s are discarded unless the `raw` option is passed
     * as `true`.
     *
     * If the template has a single root element, then the single element will be returned
     * unless the `array` option is passed as `true`.
     *
     * If there are multiple elements, then an Array will be returned.
     *
     * @param {String} template The HTML string from which to create DOM content
     * @param {Object} [options] An object containing properties to modify how the DOM is created and returned.
     * @param {Boolean} [options.array] `true` to return an array even if there's only one resulting element.
     * @param {Boolean} [options.raw] Return all child nodes, including text nodes.
     * @param {Boolean} [options.fragment] Return a DocumentFragment.
     * @private
     */

  }, {
    key: "createElementFromTemplate",
    value: function createElementFromTemplate(template) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject;
      var array = options.array,
          raw = options.raw,
          fragment = options.fragment;
      var result; // Use template by preference if it exists. It's faster on most supported platforms
      // https://jsperf.com/domparser-vs-template/

      if (DH.supportsTemplate) {
        (templateElement || (templateElement = doc.createElement('template'))).innerHTML = template;
        result = templateElement.content;

        if (fragment) {
          // The template is reused, so therefore is its fragment.
          // If we release the fragment to a caller, it must be a clone.
          return result.cloneNode(true);
        }
      } else {
        (htmlParser || (htmlParser = new DOMParser())).parseFromString(template, 'text/html');
        result = htmlParser.parseFromString(template, 'text/html').body; // We must return a DocumentFragment.
        // myElement.append(fragment) inserts the contents of the fragment, not the fragment itself.

        if (fragment) {
          // Empty string results in *no document.body* on IE!
          var nodes = result ? result.childNodes : emptyArray;
          result = document.createDocumentFragment();

          while (nodes.length) {
            result.appendChild(nodes[0]);
          }

          return result;
        } // Happens with empty template in IE11
        else if (!result) {
            result = {
              children: [],
              childNodes: []
            };
          }
      } // Raw means all child nodes are returned


      if (raw) {
        result = result.childNodes;
      } // Otherwise, only element nodes
      else {
          result = result.children;
        }

      return result.length === 1 && !array ? result[0] : arraySlice.call(result);
    }
    /**
     * Inserts an `element` at first position in `into`.
     * @param {HTMLElement} into Parent element
     * @param {HTMLElement} element Element to insert, or an element config passed on to createElement()
     * @returns {HTMLElement}
     * @category Creation
     */

  }, {
    key: "insertFirst",
    value: function insertFirst(into, element) {
      if (element && element.nodeType !== ELEMENT_NODE && element.tag) {
        element = DH.createElement(element);
      }

      return into.insertBefore(element, into.firstElementChild);
    }
    /**
     * Inserts a `element` before `beforeElement` in `into`.
     * @param {HTMLElement} into Parent element
     * @param {HTMLElement} element Element to insert, or an element config passed on to createElement()
     * @param {HTMLElement} beforeElement Element before which passed element should be inserted
     * @returns {HTMLElement}
     * @category Creation
     */

  }, {
    key: "insertBefore",
    value: function insertBefore(into, element, beforeElement) {
      if (element && element.nodeType !== ELEMENT_NODE && element.tag) {
        element = DH.createElement(element);
      }

      return beforeElement ? into.insertBefore(element, beforeElement) : DH.insertFirst(into, element);
    }
  }, {
    key: "insertAt",
    value: function insertAt(parentElement, newElement, index) {
      var siblings = Array.from(parentElement.children);

      if (index >= siblings.length) {
        return DH.append(parentElement, newElement);
      }

      var beforeElement = siblings[index];
      return DH.insertBefore(parentElement, newElement, beforeElement);
    }
    /**
     * Appends element to parentElement.
     * @param {HTMLElement} parentElement Parent element
     * @param {HTMLElement|Object|String} elementOrConfig Element to insert, or an element config passed on to createElement(), or an html string passed to createElementFromTemplate
     * @returns {HTMLElement}
     * @category Creation
     */

  }, {
    key: "append",
    value: function append(parentElement, elementOrConfig) {
      if (elementOrConfig.forEach) {
        // Ensure all elements of an Array are HTMLElements.
        // The other implementor of forEach is a NodeList which needs no conversion.
        if (Array.isArray(elementOrConfig)) {
          elementOrConfig = elementOrConfig.map(function (elementOrConfig) {
            return elementOrConfigToElement(elementOrConfig);
          });
        }

        if (parentElement.append) {
          parentElement.append.apply(parentElement, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_32___default()(elementOrConfig));
        } else {
          var docFrag = document.createDocumentFragment();
          elementOrConfig.forEach(function (child) {
            docFrag.appendChild(child);
          });
          parentElement.appendChild(docFrag);
        }

        return elementOrConfig;
      } else {
        return parentElement.appendChild(elementOrConfigToElement(elementOrConfig));
      }
    } //endregion
    //region Get position

    /**
     * Returns the element's `transform translateX` value in pixels.
     * @param {HTMLElement} element
     * @returns {Number} X transform
     * @category Position, get
     */

  }, {
    key: "getTranslateX",
    value: function getTranslateX(element) {
      var transformStyle = element.style.transform;
      var matches = pxTtranslateXRe.exec(transformStyle); // Use inline transform style if it contains "translate(npx, npx" or "translate3d(npx, npx" or "translateX(npx"

      if (matches) {
        return parseInt(matches[2]);
      } else {
        // If the inline style is the matrix() form, then use that, otherwise, use computedStyle
        matches = translateMatrixRe.exec(transformStyle) || translateMatrixRe.exec(DH.getStyleValue(DH.getElement(element), 'transform'));
        return matches ? parseInt(matches[1] || matches[3]) : 0;
      }
    }
    /**
     * Returns the element's `transform translateY` value in pixels.
     * @param {HTMLElement} element
     * @returns {Number} Y coordinate
     * @category Position, get
     */

  }, {
    key: "getTranslateY",
    value: function getTranslateY(element) {
      var transformStyle = element.style.transform;
      var matches = pxTtranslateYRe.exec(transformStyle); // Use inline transform style if it contains "translate(npx, npx" or "translate3d(npx, npx" or "translateY(npx"

      if (matches) {
        // If it was translateY(npx), use first item in the parens.
        var y = parseInt(matches[matches[1] === 'Y' ? 2 : 3]); // FF will strip `translate(x, 0)` -> `translate(x)`, so need to check for isNaN also

        return isNaN(y) ? 0 : y;
      } else {
        // If the inline style is the matrix() form, then use that, otherwise, use computedStyle
        matches = translateMatrixRe.exec(transformStyle) || translateMatrixRe.exec(DH.getStyleValue(DH.getElement(element), 'transform'));
        return matches ? parseInt(matches[2] || matches[4]) : 0;
      }
    }
    /**
     * Gets both X and Y coordinates as an array [x, y]
     * @param {HTMLElement} element
     * @returns {Number[]} [x, y]
     * @category Position, get
     */

  }, {
    key: "getTranslateXY",
    value: function getTranslateXY(element) {
      return [DH.getTranslateX(element), DH.getTranslateY(element)];
    }
    /**
     * Get elements X offset within a containing element
     * @param {HTMLElement} element
     * @param {HTMLElement} container
     * @returns {Number} X offset
     * @category Position, get
     */

  }, {
    key: "getOffsetX",
    value: function getOffsetX(element) {
      var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return container ? element.getBoundingClientRect().left - container.getBoundingClientRect().left : element.offsetLeft;
    }
    /**
     * Get elements Y offset within a containing element
     * @param {HTMLElement} element
     * @param {HTMLElement} container
     * @returns {Number} Y offset
     * @category Position, get
     */

  }, {
    key: "getOffsetY",
    value: function getOffsetY(element) {
      var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return container ? element.getBoundingClientRect().top - container.getBoundingClientRect().top : element.offsetTop;
    }
    /**
     * Gets elemnts X and Y offset within containing element as an array [x, y]
     * @param {HTMLElement} element
     * @param {HTMLElement} container
     * @returns {Number[]} [x, y]
     * @category Position, get
     */

  }, {
    key: "getOffsetXY",
    value: function getOffsetXY(element) {
      var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return [DH.getOffsetX(element, container), DH.getOffsetY(element, container)];
    }
    /**
     * Focus element without scrolling the element into view.
     * @param {HTMLElement} element
     */

  }, {
    key: "focusWithoutScrolling",
    value: function focusWithoutScrolling(element) {
      function resetScroll(scrollHierarchy) {
        scrollHierarchy.forEach(function (_ref3) {
          var element = _ref3.element,
              scrollLeft = _ref3.scrollLeft,
              scrollTop = _ref3.scrollTop;

          // Check first to avoid triggering unnecessary `scroll` events
          if (element.scrollLeft !== scrollLeft) {
            element.scrollLeft = scrollLeft;
          }

          if (element.scrollTop !== scrollTop) {
            element.scrollTop = scrollTop;
          }
        });
      } // Check browsers which do support focusOptions
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus


      var preventScrollSupported = _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].chromeVersion >= 64 || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].firefoxVersion >= 68;

      if (preventScrollSupported) {
        element.focus({
          preventScroll: true
        });
      } else {
        // Examine every parentNode of the target and cache the scrollLeft and scrollTop,
        // and restore all values after the focus has taken place
        var parents = DH.getParents(element),
            scrollHierarchy = parents.map(function (parent) {
          return {
            element: parent,
            scrollLeft: parent.scrollLeft,
            scrollTop: parent.scrollTop
          };
        });
        element.focus(); // Reset in sync on IE, async in others

        if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11) {
          resetScroll(scrollHierarchy);
        } else {
          setTimeout(function () {
            return resetScroll(scrollHierarchy);
          }, 0);
        }
      }
    }
    /**
     * Get elements X position on page
     * @param {HTMLElement} element
     * @returns {Number}
     * @category Position, get
     */

  }, {
    key: "getPageX",
    value: function getPageX(element) {
      return element.getBoundingClientRect().left + win.pageXOffset; // no window.scrollX in IE11
    }
    /**
     * Get elements Y position on page
     * @param {HTMLElement} element
     * @returns {Number}
     * @category Position, get
     */

  }, {
    key: "getPageY",
    value: function getPageY(element) {
      return element.getBoundingClientRect().top + win.pageYOffset; // no window.scrollY in IE11
    }
    /**
     * Returns extremal (min/max) size (height/width) of the element in pixels
     * @param {HTMLElement} element
     * @param {String} style minWidth/minHeight/maxWidth/maxHeight
     * @returns {number}
     * @internal
     */

  }, {
    key: "getExtremalSizePX",
    value: function getExtremalSizePX(element, style) {
      var prop = _StringHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].hyphenate(style),
          measure = prop.split('-')[1];
      var value = DH.getStyleValue(element, prop);

      if (/%/.test(value)) {
        // Element might be detached from DOM
        if (element.parentElement) {
          value = parseInt(DH.getStyleValue(element.parentElement, measure), 10);
        } else {
          value = NaN;
        }
      } else {
        value = parseInt(value, 10);
      }

      return value;
    } //endregion
    //region Set position

    /**
     * Set element's `X` translation in pixels.
     * @param {HTMLElement} element
     * @param {Number} x The value by which the element should be translated from its default position.
     * @category Position, set
     */

  }, {
    key: "setTranslateX",
    value: function setTranslateX(element, x) {
      var t = DH.getStyleValue(element, 'transform').split(/,\s*/); // Avoid blurry text on non-retina displays

      x = DomHelper.roundPx(x);

      if (t.length > 1) {
        t[t[0].startsWith('matrix3d') ? 12 : 4] = x;
        element.style.transform = t.join(',');
      } else {
        element.style.transform = "translateX(".concat(x, "px)");
      }
    }
    /**
     * Set element's `Y` translation in pixels.
     * @param {HTMLElement} element
     * @param {Number} y  The value by which the element should be translated from its default position.
     * @category Position, set
     */

  }, {
    key: "setTranslateY",
    value: function setTranslateY(element, y) {
      var t = DH.getStyleValue(element, 'transform').split(/,\s*/); // Avoid blurry text on non-retina displays

      y = DomHelper.roundPx(y);

      if (t.length > 1) {
        t[t[0].startsWith('matrix3d') ? 13 : 5] = y;
        element.style.transform = t.join(',') + ')';
      } else {
        element.style.transform = "translateY(".concat(y, "px)");
      }
    }
    /**
     * Set element's style `top`.
     * @param {HTMLElement} element
     * @param {Number|String} y The top position. If numeric, `'px'` is used as the unit.
     * @category Position, set
     */

  }, {
    key: "setTop",
    value: function setTop(element, y) {
      DH.setLength(element, 'top', y);
    }
    /**
     * Set element's style `left`.
     * @param {HTMLElement} element
     * @param {Number|String} x The top position. If numeric, `'px'` is used as the unit.
     * @category Position, set
     */

  }, {
    key: "setLeft",
    value: function setLeft(element, x) {
      DH.setLength(element, 'left', x);
    }
    /**
     * Set elements `X` and `Y` translation in pixels.
     * @param {HTMLElement} element
     * @param {Number} [x] The `X translation.
     * @param {Number} [y] The `Y translation.
     * @category Position, set
     */

  }, {
    key: "setTranslateXY",
    value: function setTranslateXY(element, x, y) {
      if (x == null) {
        return DH.setTranslateY(element, y);
      }

      if (y == null) {
        return DH.setTranslateX(element, x);
      } // Avoid blurry text on non-retina displays


      x = DomHelper.roundPx(x);
      y = DomHelper.roundPx(y);
      var t = DH.getStyleValue(element, 'transform').split(/,\s*/),
          is3d = t[0].startsWith('matrix3d');

      if (t.length > 1) {
        t[is3d ? 12 : 4] = x;
        t[is3d ? 13 : 5] = y;
        element.style.transform = t.join(',') + ')';
      } else {
        element.style.transform = "translate(".concat(x, "px, ").concat(y, "px)");
      }
    }
    /**
     * Increase `X` translation
     * @param {HTMLElement} element
     * @param {Number} x The number of pixels by which to increase the element's `X` translation.
     * @category Position, set
     */

  }, {
    key: "addTranslateX",
    value: function addTranslateX(element, x) {
      DH.setTranslateX(element, DH.getTranslateX(element) + x);
    }
    /**
     * Increase `Y` position
     * @param {HTMLElement} element
     * @param {Number} y The number of pixels by which to increase the element's `Y` translation.
     * @category Position, set
     */

  }, {
    key: "addTranslateY",
    value: function addTranslateY(element, y) {
      DH.setTranslateY(element, DH.getTranslateY(element) + y);
    }
    /**
     * Increase X position
     * @param {HTMLElement} element
     * @param x
     * @category Position, set
     */

  }, {
    key: "addLeft",
    value: function addLeft(element, x) {
      DH.setLeft(element, DH.getOffsetX(element) + x);
    }
    /**
     * Increase Y position
     * @param {HTMLElement} element
     * @param y
     * @category Position, set
     */

  }, {
    key: "addTop",
    value: function addTop(element, y) {
      DH.setTop(element, DH.getOffsetY(element) + y);
    }
    /**
     * Align the passed element with the passed target according to the align spec.
     * @param {HTMLElement} element The element to align.
     * @param {HTMLElement|Core.helper.util.Rectangle} target The target element or rectangle to align to
     * @param {Object} alignSpec See {@link Core.helper.util.Rectangle#function-alignTo} Defaults to `{ align : 't0-t0' }`
     * @param {Boolean} [round] Round the calculated Rectangles (for example if dealing with scrolling which
     * is integer based).
     */

  }, {
    key: "alignTo",
    value: function alignTo(element, target) {
      var alignSpec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t0t0;
      var round = arguments.length > 3 ? arguments[3] : undefined;
      target = target instanceof _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_38__["default"] ? target : _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_38__["default"].from(target, true);
      var elXY = DH.getTranslateXY(element),
          elRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_38__["default"].from(element, true);

      if (round) {
        elRect.round();
        target.round();
      }

      var targetRect = elRect.alignTo(Object.assign(alignSpec, {
        target: target
      }));
      DH.setTranslateXY(element, elXY[0] + targetRect.x - elRect.x, elXY[1] + targetRect.y - elRect.y);
    } //endregion
    //region Styles & CSS

    /**
     * Returns a style value or values for the passed element.
     * @param {HTMLElement} element The element to read styles from
     * @param {String|String[]} propName The property or properties to read
     * @param {Boolean} [inline=false] Pass as `true` to read the element's inline style.
     * Note that this could return inaccurate results if CSS rules apply to this element.
     * @return {String|Object} The value or an object containing the values keyed by the requested property name.
     * @category CSS
     */

  }, {
    key: "getStyleValue",
    value: function getStyleValue(element, propName, inline, pseudo) {
      var styles = inline ? element.style : element.ownerDocument.defaultView.getComputedStyle(element, pseudo);

      if (Array.isArray(propName)) {
        var result = {};

        var _iterator = _createForOfIteratorHelper(propName),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var prop = _step.value;
            result[prop] = styles.getPropertyValue(_StringHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].hyphenate(prop));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return result;
      } // Use the elements owning view to get the computed style.
      // Ensure the property name asked for is hyphenated.
      // getPropertyValue doesn't work with camelCase


      return styles.getPropertyValue(_StringHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].hyphenate(propName));
    }
    /**
     * Returns an object with the parse style values for the top, right, bottom, and left
     * components of the given edge style.
     *
     * The return value is an object with `top`, `right`, `bottom`, and `left` properties
     * for the respective components of the edge style, as well as `width` (the sum of
     * `left` and `right`) and `height` (the sum of `top` and `bottom`).
     *
     * @param {HTMLElement} element
     * @param {String} edgeStyle The element's desired edge style such as 'padding', 'margin',
     * or 'border'.
     * @param {String} [edges='trbl'] A string with one character codes for each edge. Only
     * those edges will be populated in the returned object. By default, all edges will be
     * populated.
     * @returns {Object}
     */

  }, {
    key: "getEdgeSize",
    value: function getEdgeSize(element, edgeStyle, edges) {
      var suffix = edgeStyle === 'border' ? '-width' : '',
          ret = {
        raw: {}
      };

      for (var _i2 = 0, _arr = ['top', 'right', 'bottom', 'left']; _i2 < _arr.length; _i2++) {
        var edge = _arr[_i2];

        if (!edges || edges.includes(edge[0])) {
          // This produces px units even if the provided style is em or other (i.e.,
          // getComputedStyle normalizes this):
          ret[edge] = parseFloat(ret.raw[edge] = DomHelper.getStyleValue(element, "".concat(edgeStyle, "-").concat(edge).concat(suffix)));
        }
      } // These may not even be requested (based on "edges") but conditional code here
      // would be wasted since the caller would still need to know not to use them...


      ret.width = ret.left + ret.right;
      ret.height = ret.top + ret.bottom;
      return ret;
    }
    /**
     * Splits a style string up into object form. For example `'font-weight:bold;font-size:150%'`
     * would convert to
     *
     * ```javascript
     * {
     *     font-weight : 'bold',
     *     font-size : '150%'
     * }
     * ```
     * @param {String} style A DOM style string
     * @returns {Object} the style declaration in object form.
     */

  }, {
    key: "parseStyle",
    value: function parseStyle(style) {
      if (typeof style === 'string') {
        var styles = style.split(semicolonRe);
        style = {};

        for (var i = 0, length = styles.length; i < length; i++) {
          var propVal = styles[i].split(colonRe);
          style[propVal[0]] = propVal[1];
        }
      }

      return style || {};
    }
    /**
     * Applies specified style to the passed element. Style can be an object or a string.
     * @param {HTMLElement} element Target element
     * @param {String|Object} style Style to apply, 'border: 1px solid black' or { border: '1px solid black' }
     * @param {Boolean} [overwrite] Specify `true` to replace style instead of applying changes
     * @category CSS
     */

  }, {
    key: "applyStyle",
    value: function applyStyle(element, style) {
      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof style === 'string') {
        if (overwrite) {
          // Only assign if either end has any styles, do not want to add empty `style` tag on element
          if (style.length || element.style.cssText.length) {
            element.style.cssText = style;
          }
        } else {
          // Add style so as not to delete configs in style such as width, height, flex etc.
          // If a style is already there, the newest, appended one will take precedence.
          element.style.cssText += style;
        }
      } else {
        if (overwrite) {
          element.style.cssText = ''; //element.removeAttribute('style');
        } // Has a sub-style block?


        if (style.style) {
          if (typeof style.style === 'string') {
            element.style.cssText = style.style;
          } else {
            style = Object.assign({}, style.style, style);
          }
        } // Prototype chained objects may be passed, so use direct loop.


        for (var key in style) {
          // Ignore readonly properties of the CSSStyleDeclaration object:
          // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
          // Also ignores sub-style blocks, which are applied above
          if (!styleIgnoreProperties[key]) {
            // Append 'px' for numeric dimensions
            if (styleDimensionProperties[key] && typeof style[key] == 'number') {
              element.style[_StringHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].hyphenate(key)] = style[key] + 'px';
            } else {
              element.style[_StringHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].hyphenate(key)] = style[key];
            }
          }
        }
      }
    }
  }, {
    key: "getCSSText",
    value: function getCSSText(style) {
      if (typeof style === 'string') {
        return style;
      }

      var cssText = '';

      for (var key in style) {
        // Ignore readonly properties of the CSSStyleDeclaration object:
        // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
        if (!styleIgnoreProperties[key]) {
          cssText += "".concat(_StringHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].hyphenate(key), ":").concat(style[key], ";");
        }
      }

      return cssText;
    } // For IE11, it doesn't support adding/removing multiple classes at once

    /**
     * Add multiple classes to elements classList. Helper for IE11 which does not support it directly
     * @param {HTMLElement} element
     * @param {String[]} classes
     * @category CSS
     */

  }, {
    key: "addClasses",
    value: function addClasses(element, classes) {
      for (var i = 0; i < classes.length; i++) {
        element.classList.add(classes[i]);
      }
    }
    /**
     * Remove multiple classes from elements classList. Helper for IE11 which does not support it directly
     * @param {HTMLElement} element
     * @param {String[]} classes
     * @category CSS
     */

  }, {
    key: "removeClasses",
    value: function removeClasses(element, classes) {
      for (var i = 0; i < classes.length; i++) {
        element.classList.remove(classes[i]);
      }
    }
    /**
     * Toggle multiple classes in elements classList. Helper for IE11 which does not support toggling with force or for
     * multiple classes at once.
     * @param {HTMLElement} element
     * @param {String[]} classes
     * @param {Boolean} [force] Specify true to add classes, false to remove. Leave blank to toggle
     * @category CSS
     */

  }, {
    key: "toggleClasses",
    value: function toggleClasses(element, classes) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!Array.isArray(classes)) {
        classes = [classes];
      }

      if (force === true) {
        DH.addClasses(element, classes);
      } else if (force === false) {
        DH.removeClasses(element, classes);
      } else {
        classes.forEach(function (cls) {
          return element.classList.toggle(cls);
        });
      }
    }
    /**
     * Adds a CSS class to an element during the specified duration
     * @param {HTMLElement} element Target element
     * @param {String} cls CSS class to add temporarily
     * @param {Number} duration Duration in ms, 0 means cls will not be applied
     * @param {Core.mixin.Delayable} delayable The delayable to tie the setTimeout call to
     * @category CSS
     */

  }, {
    key: "addTemporaryClass",
    value: function addTemporaryClass(element, cls, duration) {
      var delayable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;

      if (duration > 0) {
        element.classList.add(cls);
        delayable.setTimeout(function () {
          return element.classList.remove(cls);
        }, duration);
      }
    }
    /**
     * Reads computed style from the element and returns transition duration for a given property in milliseconds
     * @param {HTMLElement} element Target DOM element
     * @param {String} property Animatied property name
     * @returns {number/undefined} Duration in ms
     * @private
     */

  }, {
    key: "getPropertyTransitionDuration",
    value: function getPropertyTransitionDuration(element, property) {
      var style = window.getComputedStyle(element),
          properties = style.transitionProperty.split(', '),
          durations = style.transitionDuration.split(', '),
          index = properties.indexOf(property);
      var result;

      if (index !== -1) {
        // get floating value of transition duration in seconds and convert into milliseconds
        result = parseFloat(durations[index]) * 1000;
      }

      return result;
    } //endregion
    //region Effects

    /**
     * Highlights the passed element or Rectangle according to the theme's highlighting rules.
     * Usually an animated framing effect.
     * @param {HTMLElement|Core.helper.util.Rectangle} element The element or Rectangle to highlight.
     */

  }, {
    key: "highlight",
    value: function highlight(element) {
      var delayable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

      if (element instanceof _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_38__["default"]) {
        return element.highlight();
      }

      return new Promise(function (resolve) {
        delayable.setTimeout(function () {
          element.classList.add('b-fx-highlight');
          delayable.setTimeout(function () {
            element.classList.remove('b-fx-highlight');
            resolve();
          }, 1000);
        }, 0);
      });
    } //endregion
    //region Measuring / Scrollbar

    /**
     * Measures the scrollbar width using a hidden div. Caches result
     * @returns {Number}
     * @readonly
     */

  }, {
    key: "resetScrollBarWidth",

    /**
     * Resets DomHelper.scrollBarWidth cache, triggering a new measurement next time it is read
     */
    value: function resetScrollBarWidth() {
      scrollBarWidth = null;
    }
    /**
     * Measures the text width using a hidden div
     * @param {String} text
     * @param {HTMLElement} sourceElement
     * @returns {Number} width
     * @category Measure
     */

  }, {
    key: "measureText",
    value: function measureText(text, sourceElement) {
      var useHTML = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var parentElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var offScreenDiv = DH.getMeasureElement(sourceElement, parentElement);
      offScreenDiv[useHTML ? 'innerHTML' : 'innerText'] = text;
      var result = offScreenDiv.clientWidth;
      offScreenDiv.className = '';
      return result;
    }
    /**
     * Measures a relative size, such as a size specified in `em` units for the passed element.
     * @param {String} size The CSS size value to measure.
     * @param {HTMLElement} sourceElement
     * @returns {Number} size The size in pixels of the passed relative measurement.
     * @category Measure
     */

  }, {
    key: "measureSize",
    value: function measureSize(size, sourceElement) {
      if (!size) {
        return 0;
      }

      if (typeof size === 'number') {
        return size;
      }

      if (!size.length) {
        return 0;
      }

      if (/^\d+(px)?$/.test(size)) {
        return parseInt(size);
      }

      if (sourceElement) {
        var offScreenDiv = DH.getMeasureElement(sourceElement);
        offScreenDiv.innerHTML = '';
        offScreenDiv.style.width = DH.setLength(size); //const result = BrowserHelper.isIE11 ?  offScreenDiv.offsetWidth : offScreenDiv.clientWidth;

        var result = offScreenDiv.offsetWidth;
        offScreenDiv.style.width = offScreenDiv.className = '';
        return result;
      }

      if (/^\d+em$/.test(size)) {
        return parseInt(size) * DEFAULT_FONT_SIZE;
      }

      return isNaN(size) ? 0 : parseInt(size);
    } // parentElement allows measurement to happen inside a specific element, allowing scoped css rules to match

  }, {
    key: "getMeasureElement",
    value: function getMeasureElement(sourceElement) {
      var parentElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : doc.body;
      var sourceElementStyle = win.getComputedStyle(sourceElement),
          offScreenDiv = parentElement.offScreenDiv = parentElement.offScreenDiv || DH.createElement({
        parent: parentElement,
        style: 'position:fixed;top:-10000px;left:-10000px;visibility:hidden;contain:strict',
        className: 'b-measure-element',
        children: [{
          style: 'white-space:nowrap;display:inline-block;will-change:contents;width:auto;contain:none'
        }]
      }, true)[1];
      fontProps.forEach(function (prop) {
        if (offScreenDiv.style[prop] !== sourceElementStyle[prop]) {
          offScreenDiv.style[prop] = sourceElementStyle[prop];
        }
      });
      offScreenDiv.className = sourceElement.className; // In case the measure element was moved/removed, re-add it

      if (offScreenDiv.parentElement.parentElement !== parentElement) {
        parentElement.appendChild(offScreenDiv.parentElement);
      }

      return offScreenDiv;
    } //endregion
    //region Sync

    /**
     * Sync one source element attributes, children etc. to a target element. Source element can be specified as a html
     * string or an actual HTMLElement.
     *
     * NOTE: This function is superseded by {@link Core/helper/DomSync#function-sync-static DomSync.sync()}, which works
     * with DOM configs. For most usecases, use it instead.
     *
     * @param {String|HTMLElement} sourceElement Source "element" to copy from
     * @param {HTMLElement} targetElement Target element to apply to, can also be specified as part of the config object
     * @returns {HTMLElement} Returns the updated targetElement (which is also updated in place)
     */

  }, {
    key: "sync",
    value: function sync(sourceElement, targetElement) {
      if (typeof sourceElement === 'string') {
        if (sourceElement === '') {
          targetElement.innerHTML = '';
          return;
        } else {
          sourceElement = DH.createElementFromTemplate(sourceElement);
        }
      }

      DH.performSync(sourceElement, targetElement);
      return targetElement;
    } // Internal helper used for recursive syncing

  }, {
    key: "performSync",
    value: function performSync(sourceElement, targetElement) {
      // Syncing identical elements is a no-op
      if (sourceElement.outerHTML !== targetElement.outerHTML) {
        DH.syncAttributes(sourceElement, targetElement);
        DH.syncContent(sourceElement, targetElement);
        DH.syncChildren(sourceElement, targetElement);
        return true;
      }

      return false;
    } // Attributes as map { attr : value, ... }, either from an html element or from a config

  }, {
    key: "getSyncAttributes",
    value: function getSyncAttributes(element) {
      var attributes = {},
          // Attribute names, simplifies comparisons and calls to set/removeAttribute
      names = []; // Extract from element

      for (var i = 0; i < element.attributes.length; i++) {
        var attr = element.attributes[i];

        if (attr.specified) {
          var name = attr.name.toLowerCase();
          attributes[name] = attr.value;
          names.push(name);
        }
      }

      return {
        attributes: attributes,
        names: names
      };
    }
    /**
     * Syncs attributes from sourceElement to targetElement.
     * @private
     * @param {HTMLElement} sourceElement
     * @param {HTMLElement} targetElement
     */

  }, {
    key: "syncAttributes",
    value: function syncAttributes(sourceElement, targetElement) {
      var _DH$getSyncAttributes = DH.getSyncAttributes(sourceElement),
          sourceAttributes = _DH$getSyncAttributes.attributes,
          sourceNames = _DH$getSyncAttributes.names,
          _DH$getSyncAttributes2 = DH.getSyncAttributes(targetElement),
          targetAttributes = _DH$getSyncAttributes2.attributes,
          targetNames = _DH$getSyncAttributes2.names,
          hasDataset = sourceNames.includes('dataset'),
          toAdd = sourceNames.filter(function (attr) {
        return !targetNames.includes(attr);
      }),
          toRemove = targetNames.filter(function (attr) {
        return !sourceNames.includes(attr) && (!hasDataset || !attr.startsWith('data-'));
      }),
          toSync = sourceNames.filter(function (attr) {
        return targetNames.includes(attr);
      });

      if (toAdd.length > 0) {
        for (var i = 0; i < toAdd.length; i++) {
          var attr = toAdd[i]; // Style requires special handling

          if (attr === 'style') {
            DH.applyStyle(targetElement, sourceAttributes.style, true);
          } // So does dataset
          else if (attr === 'dataset') {
              Object.assign(targetElement.dataset, sourceAttributes.dataset);
            } // Other attributes are set using setAttribute (since it calls toString() DomClassList works fine)
            else {
                targetElement.setAttribute(attr, sourceAttributes[attr]);
              }
        }
      }

      if (toRemove.length > 0) {
        for (var _i3 = 0; _i3 < toRemove.length; _i3++) {
          targetElement.removeAttribute(toRemove[_i3]);
        }
      }

      if (toSync.length > 0) {
        for (var _i4 = 0; _i4 < toSync.length; _i4++) {
          var _attr = toSync[_i4]; // Set all attributes that has changed, with special handling for style

          if (_attr === 'style') {
            // TODO: Check for changes?
            DH.applyStyle(targetElement, sourceAttributes.style, true);
          } // And dataset
          else if (_attr === 'dataset') {
              // TODO: Any cost to assigning same values?
              Object.assign(targetElement.dataset, sourceAttributes.dataset);
            } // And class, which might be a DomClassList or an config for a DomClassList
            else if (_attr === 'class' && (sourceAttributes.class.isDomClassList || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_31___default()(sourceAttributes.class) === 'object')) {
                var classList = void 0;

                if (sourceAttributes.class.isDomClassList) {
                  classList = sourceAttributes.class;
                } else {
                  // TODO : Reuse a single DomClassList?
                  classList = new _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_40__["default"](sourceAttributes.class);
                }

                if (!classList.isEqual(targetAttributes.class)) {
                  targetElement.setAttribute('class', classList);
                }
              } else if (targetAttributes[_attr] !== sourceAttributes[_attr]) {
                targetElement.setAttribute(_attr, sourceAttributes[_attr]);
              }
        }
      }
    }
    /**
     * Sync content (innerText) from sourceElement to targetElement
     * @private
     * @param {HTMLElement} sourceElement
     * @param {HTMLElement} targetElement
     */

  }, {
    key: "syncContent",
    value: function syncContent(sourceElement, targetElement) {
      if (sourceElement.childElementCount === 0) {
        targetElement.innerText = sourceElement.innerText;
      }
    }
  }, {
    key: "setInnerText",
    value: function setInnerText(targetElement, text) {
      // setting firstChild.data is faster than innerText (and innerHTML),
      // but in some cases the inner node is lost and needs to be recreated
      var firstChild = targetElement.firstChild;

      if (firstChild) {
        firstChild.data = text;
      } else {
        // textContent is supposed to be faster than innerText, since it does not trigger layout
        targetElement.textContent = text;
      }
    }
    /**
     * Sync traversing children
     * @private
     * @param {HTMLElement} sourceElement Source element
     * @param {HTMLElement} targetElement Target element
     * @param {String} syncIdField Field in dataset to use for element re-usage
     */

  }, {
    key: "syncChildren",
    value: function syncChildren(sourceElement, targetElement) {
      var me = this,
          sourceNodes = arraySlice.call(sourceElement.childNodes),
          targetNodes = arraySlice.call(targetElement.childNodes);

      while (sourceNodes.length) {
        var sourceNode = sourceNodes.shift(),
            targetNode = targetNodes.shift(); // only textNodes and elements allowed (no comments)

        if (sourceNode && sourceNode.nodeType !== TEXT_NODE && sourceNode.nodeType !== ELEMENT_NODE) {
          throw new Error("Source node type ".concat(sourceNode.nodeType, " not supported by DomHelper.sync()"));
        }

        if (targetNode && targetNode.nodeType !== TEXT_NODE && targetNode.nodeType !== ELEMENT_NODE) {
          throw new Error("Target node type ".concat(targetNode.nodeType, " not supported by DomHelper.sync()"));
        }

        if (!targetNode) {
          // out of target nodes, add to target
          targetElement.appendChild(sourceNode);
        } else {
          // match node
          if (sourceNode.nodeType === targetNode.nodeType) {
            // same type of node, take action depending on which type
            if (sourceNode.nodeType === TEXT_NODE) {
              // text
              targetNode.data = sourceNode.data;
            } else {
              if (sourceNode.tagName === targetNode.tagName) {
                me.performSync(sourceNode, targetNode);
              } else {
                // new tag, remove targetNode and insert new element
                targetElement.insertBefore(sourceNode, targetNode);
                targetNode.remove();
              }
            }
          } // Trying to set text node as element, use it as innerText
          // (we get this in FF with store mutations and List)
          else if (sourceNode.nodeType === TEXT_NODE && targetNode.nodeType === ELEMENT_NODE) {
              targetElement.innerText = sourceNode.data.trim();
            } else {
              throw new Error('Currently no support for transforming nodeType');
            }
        }
      } // Out of source nodes, remove remaining target nodes


      targetNodes.forEach(function (targetNode) {
        targetNode.remove();
      });
    }
    /**
     * Synchronizes the passed element's `classList` with the class names
     * passed in either Array or String format or Object. Avoiding mutating an element's
     * `classList` or `className` can avoid browser style recalculations.
     * @param {HTMLElement} element The element whose class list to synchronize.
     * @param {String[]|String|Object} newClasses The incoming class names to set on the element.
     * @category CSS
     */

  }, {
    key: "syncClassList",
    value: function syncClassList(element, newClasses) {
      var classList = element.classList,
          isString = typeof newClasses === 'string',
          newClsArray = isString ? newClasses.trim().split(whiteSpaceRe) : Array.isArray(newClasses) ? newClasses : _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].getTruthyKeys(newClasses),
          classCount = newClsArray.length;
      var changed = classList.length !== classCount,
          i; // If the incoming and existing class lists are the same length
      // then check that each contains the same names. As soon as
      // we find a non-matching name, we know we have to update the
      // className.

      for (i = 0; !changed && i < classCount; i++) {
        changed = !classList.contains(newClsArray[i]);
      }

      if (changed) {
        element.className = isString ? newClasses : newClsArray.join(' ');
      }
    }
    /**
     * Changes the theme to the passed theme name if possible.
     *
     * Theme names are case insensitive. The `href` used is all lower case.
     *
     * To use this method, the `<link rel="stylesheet">` _must_ use the default,
     * Bryntum-supplied CSS files where the `href` end with `<themeName>.css`, so that
     * it can be found in the document, and switched out for a new link with
     * the a modified `href`. The new `href` will use the same path, just
     * with the `themeName` portion subsituted for the new name.
     *
     * If no `<link>` with that name pattern can be found, an error will be thrown.
     *
     * If you use this method, you  must ensure that the theme files are
     * all accessible on your server.
     *
     * Because this is an asynchronous operation, a `Promise` is returned.
     * The theme change event is passed to the success function. If the
     * theme was not changed, because the theme name passed is the current theme,
     * nothing is passed to the success function.
     *
     * The theme change event contains two properties:
     *
     *  - `prev` The previous Theme name.
     *  - `theme` The new Theme name.
     *
     * @param {String} newThemeName
     * @returns {Promise} A promise who's success callback receives the theme change
     * event if the theme in fact changed. If the theme `href` could not be loaded,
     * the failure callback is called, passing the error event caught.
     */

  }, {
    key: "setTheme",
    value: function setTheme(newThemeName) {
      newThemeName = newThemeName.toLowerCase();
      var oldThemeName = DH.themeInfo.name.toLowerCase(),
          oldThemeLink = document.head.querySelector('#bryntum-theme:not([data-loading])') || document.head.querySelector("[href$=\"".concat(oldThemeName, ".css\"]:not([data-loading])")); // Remove any links currently loading

      DomHelper.removeEachSelector(document.head, '#bryntum-theme[data-loading]'); // Theme link href ends with <themeName>.css also there could be a query - css?11111...

      if (!oldThemeLink || !oldThemeLink.href.includes("".concat(oldThemeName, ".css"))) {
        throw new Error("Theme link for ".concat(oldThemeName, " not found"));
      } // Do not reapply same theme


      if (oldThemeLink.href.includes("".concat(newThemeName, ".css"))) {
        return immediatePromise;
      }

      return new Promise(function (resolve, reject) {
        var newThemeLink = document.createElement('link'),
            nextSibling = oldThemeLink.nextSibling,
            oldThemeName = DH.themeInfo.name.toLowerCase(),
            themeEvent = {
          theme: newThemeName,
          prev: oldThemeName
        },
            onThemeLoad = function onThemeLoad() {
          delete newThemeLink.dataset.loading;
          themeInfo = null;
          oldThemeLink.remove();
          window.bryntum.GlobalEvents.trigger('theme', themeEvent);
          resolve(themeEvent);
        },
            onThemeLoadError = function onThemeLoadError(e) {
          delete newThemeLink.dataset.loading;
          reject(e);
        };

        newThemeLink.rel = 'stylesheet';
        newThemeLink.id = 'bryntum-theme';
        newThemeLink.addEventListener('load', onThemeLoad);
        newThemeLink.addEventListener('error', onThemeLoadError);
        newThemeLink.dataset.loading = 'true';
        newThemeLink.href = oldThemeLink.href.replace(oldThemeName, newThemeName);
        nextSibling.parentNode.insertBefore(newThemeLink, nextSibling);
      });
    }
    /**
     * A theme information object about the current theme.
     *
     * Currently this has only one property:
     *
     *   - `name` The current theme name.
     * @property {Object}
     * @readonly
     */

  }, {
    key: "isOrphaned",
    //endregion
    value: function isOrphaned(element) {
      return element !== document.body && element !== document.documentElement && element.nodeType === Node.ELEMENT_NODE && element.offsetParent === null;
    }
  }, {
    key: "activeElement",
    get: function get() {
      var el = document.activeElement;

      while (el.shadowRoot) {
        el = el.shadowRoot.activeElement;
      }

      return el;
    }
  }, {
    key: "scrollBarWidth",
    get: function get() {
      // Ensure the measurement is only done once, when the value is null and body is available
      if (scrollBarWidth === null && doc.body) {
        var element = DH.createElement({
          parent: doc.body,
          style: 'position:absolute;top:-999px;width:100px;height:100px;overflow:scroll'
        });
        scrollBarWidth = element.offsetWidth - element.clientWidth;
        element.remove();
      }

      return scrollBarWidth;
    }
  }, {
    key: "scrollBarPadElement",
    get: function get() {
      return {
        className: 'b-yscroll-pad',
        children: [{
          className: 'b-yscroll-pad-sizer'
        }]
      };
    }
  }, {
    key: "themeInfo",
    get: function get() {
      if (!themeInfo) {
        var // The content it creates for 'b-theme-info' is described in corresponding theme in Core/resources/sass/themes
        // for example in Core/resources/sass/themes/material.scss
        // ```
        // .b-theme-info:before {
        //     content : '{"name":"Material"}';
        // }
        // ```
        testDiv = DH.createElement({
          parent: document.body,
          className: 'b-theme-info'
        }),
            // Need to be a pseudo element for Edge to report content correctly
        themeData = DH.getStyleValue(testDiv, 'content', false, ':before');

        if (themeData) {
          // themeData could be invalid JSON string in case there is no content rule
          try {
            themeInfo = JSON.parse(themeData.replace(/^["']|["']$|\\/g, ''));
          } catch (e) {
            themeInfo = null;
          }
        }

        testDiv.remove();
      }

      return themeInfo;
    }
  }]);

  return DomHelper;
}();


var DH = DomHelper;
var clearTouchTimer;

var clearTouchEvent = function clearTouchEvent() {
  return DH.isTouchEvent = false;
},
    setTouchEvent = function setTouchEvent() {
  DH.isTouchEvent = true; // Jump round the click delay

  clearTimeout(clearTouchTimer);
  clearTouchTimer = setTimeout(clearTouchEvent, 400);
}; // Set event type flags so that mousedown and click handlers can know whether a touch gesture was used.
// This is used. This must stay until we have a unified DOM event system which handles both touch and mouse events.


doc.addEventListener('touchstart', setTouchEvent, true);
doc.addEventListener('touchend', setTouchEvent, true);
DH.supportsTemplate = 'content' in doc.createElement('template');
DH.elementPropKey = elementPropKey;
DH.numberRe = numberRe; //region Polyfills
// TODO: include babels polyfills instead of keeping own?

if (!('children' in Node.prototype)) {
  var elementFilter = function elementFilter(node) {
    return node.nodeType === 1;
  };

  Object.defineProperty(Node.prototype, 'children', {
    get: function get() {
      return Array.prototype.filter.call(this.childNodes, elementFilter);
    }
  });
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s);
    var i = matches.length;

    while (--i >= 0 && matches.item(i) !== this) {}

    return i > -1;
  };
}

if (win.Element && !Element.prototype.closest) {
  Node.prototype.closest = Element.prototype.closest = function (s) {
    var el = this;
    if (!doc.documentElement.contains(el)) return null;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  };
} else {
  // It's crazy that closest is not already on the Node interface!
  // Note that some Node types (eg DocumentFragment) do not have a parentNode.
  Node.prototype.closest = function (selector) {
    var _this$parentNode;

    return (_this$parentNode = this.parentNode) === null || _this$parentNode === void 0 ? void 0 : _this$parentNode.closest(selector);
  };
} // from MDN (public domain): https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove


(function (arr) {
  arr.forEach(function (item) {
    if (Object.prototype.hasOwnProperty.call(item, 'remove')) {
      return;
    }

    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode && this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]); // IE11 polyfill


if (!SVGElement.prototype.contains) {
  SVGElement.prototype.contains = function (node) {
    do {
      if (this === node) {
        return true;
      }

      node = node.parentNode;
    } while (node);

    return false;
  };
} // IE11 polyfill for Event constructors


if (typeof win.CustomEvent !== 'function') {
  var evt, _constructor;

  win.CustomEvent = _constructor = function _constructor(event) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    evt = doc.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  _constructor.prototype = win.Event.prototype;

  win.MouseEvent = _constructor = function _constructor(event) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    evt = doc.createEvent('MouseEvents');
    evt.initMouseEvent(event, params.bubbles, params.cancelable, doc.defaultView || win, params.detail, params.screenX, params.screenY, params.clientX, params.clientY, false, false, false, false, 0, document);
    return evt;
  };

  _constructor.prototype = win.Event.prototype;

  win.KeyboardEvent = _constructor = function _constructor(event) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var modifiers = "".concat(params.shiftKey ? 'Shift ' : '').concat(params.ctrlKey ? 'Control' : '');
    evt = doc.createEvent('KeyboardEvent');
    evt.initKeyboardEvent(event, params.bubbles, params.cancelable, doc.defaultView || win, params.key, params.location, modifiers, false, '');
    return evt;
  };

  _constructor.prototype = win.Event.prototype;
} //endregion
// https://gist.github.com/brettz9/4093766


if (!Object.getOwnPropertyDescriptor(SVGElement.prototype, 'dataset') || !Object.getOwnPropertyDescriptor(SVGElement.prototype, 'dataset').get) {
  var propDescriptor = {
    enumerable: true,
    get: function get() {
      'use strict';

      var i,
          that = this,
          map = {},
          attrVal,
          attrName,
          propName,
          attribute,
          attributes = this.attributes,
          attsLength = attributes.length,
          toUpperCase = function toUpperCase(n0) {
        return n0.charAt(1).toUpperCase();
      },
          getter = function getter() {
        return this;
      },
          setter = function setter(attrName, value) {
        return typeof value !== 'undefined' ? this.setAttribute(attrName, value) : this.removeAttribute(attrName);
      };

      for (i = 0; i < attsLength; i++) {
        attribute = attributes[i]; // Fix: This test really should allow any XML Name without
        //         colons (and non-uppercase for XHTML)

        if (attribute && attribute.name && /^data-\w[\w-]*$/.test(attribute.name)) {
          attrVal = attribute.value;
          attrName = attribute.name; // Change to CamelCase

          propName = attrName.substr(5).replace(/-./g, toUpperCase);
          Object.defineProperty(map, propName, {
            enumerable: this.enumerable,
            get: getter.bind(attrVal || ''),
            set: setter.bind(that, attrName)
          });
        }
      }

      return map;
    }
  }; // FF enumerates over element's dataset, but not
  // SVGElement.prototype.dataset; IE9 iterates over both

  Object.defineProperty(SVGElement.prototype, 'dataset', propDescriptor);
} // Polyfill to allow an array to be passed to classList.add/remove


var nativeAdd = DOMTokenList.prototype.add,
    nativeRemove = DOMTokenList.prototype.remove;

DOMTokenList.prototype.add = function (cls) {
  var _this = this;

  if (Array.isArray(cls)) {
    cls.forEach(function (c) {
      return nativeAdd.call(_this, c);
    });
  } else {
    nativeAdd.call.apply(nativeAdd, [this].concat(Array.prototype.slice.call(arguments)));
  }
};

DOMTokenList.prototype.remove = function (cls) {
  var _this2 = this;

  if (Array.isArray(cls)) {
    cls.forEach(function (c) {
      return nativeRemove.call(_this2, c);
    });
  } else {
    nativeRemove.call.apply(nativeRemove, [this].concat(Array.prototype.slice.call(arguments)));
  }
}; // CTRL/+ and  CTRL/- zoom gestures must invalidate the scrollbar width.
// Window resize is triggered by this operation on Blink (Chrome & Edge), Firefox and Safari.


window.addEventListener('resize', function () {
  return scrollBarWidth = null;
});
DomHelper._$name = 'DomHelper';

/***/ }),

/***/ "./lib/Core/helper/DomSync.js":
/*!************************************!*\
  !*** ./lib/Core/helper/DomSync.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomSync; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");



























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';





/**
 * @module Core/helper/DomSync
 */

var arraySlice = Array.prototype.slice,
    htmlRe = /[&<]/,
    // tests if setInnerText is equivalent to innerHTML
// Used in sync to give ObjectHelper.isDeeplyEqual() some domain knowledge
syncEqualityEvaluator = {
  // Attributes used during creation that should not be compared
  ignore: {
    _element: 1,
    parent: 1,
    elementData: 1,
    ns: 1
  },
  // Function to evaluate 'compareHtml' property instead of 'html' for DocumentFragments
  evaluate: function evaluate(property, a, b) {
    if (property === 'html' && typeof a.value !== 'string' && "compareHtml" in a.object) {
      // DocumentFragment, compare separately supplied html
      return a.object.compareHtml === b.object.compareHtml;
    }
  }
},
    // Attributes to ignore on sync
syncIgnoreAttributes = {
  tag: 1,
  html: 1,
  text: 1,
  children: 1,
  tooltip: 1,
  parent: 1,
  nextSibling: 1,
  ns: 1,
  reference: 1,
  _element: 1,
  elementData: 1,
  retainElement: 1,
  compareHtml: 1,
  syncOptions: 1,
  listeners: 1,
  isReleased: 1
},
    isClass = {
  class: 1,
  className: 1,
  classname: 1
},
    emptyArray = Object.freeze([]);
/**
 * A utility class for syncing DOM config objects to DOM elements. Syncing compares the new config with the previously
 * used for that element, only applying the difference. Very much like a virtual DOM approach on a per element basis
 * (element + its children).
 *
 * Usage example:
 *
 * ```javascript
 * DomSync.sync({
 *     domConfig: {
 *         className : 'b-outer',
 *         children : [
 *             {
 *                 className : 'b-child',
 *                 html      : 'Child 1',
 *                 dataset   : {
 *                     custom : true
 *                 }
 *             },
 *             {
 *                 className : 'b-child',
 *                 html      : 'Child 2',
 *                 style     : {
 *                     fontWeight : 'bold',
 *                     color      : 'blue'
 *                 }
 *             }
 *         ]
 *     },
 *     targetElement : target
 * });
 * ```
 */

var DomSync = /*#__PURE__*/function () {
  function DomSync() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default()(this, DomSync);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25___default()(DomSync, null, [{
    key: "sync",

    /**
     * Sync a DOM config to a target element
     * @param {Object} options Options object
     * @param {Object} options.domConfig A DOM config object
     * @param {HTMLElement} options.targetElement Target element to apply to
     * @param {Boolean} options.strict Specify `true` to limit synchronization to only the values set by previous calls.
     * Styles and classes placed directly on the DOM elements by other means will not be affected.
     * @param {String} [options.syncIdField] Field in dataset to use to match elements for re-usage
     * @param {String|String[]} [options.affected] The references affected by a partial sync.
     * @param {Function} [options.callback] A function that will be called on element re-usage, creation and similar
     * @param {Boolean} [options.configEquality] A function that will be called to compare an incoming config to
     * the last config applied to the `targetElement`. Defaults to {@link Core.helper.ObjectHelper#function-isDeeplyEqual-static isDeeplyEqual}.
     * @returns {HTMLElement} Returns the updated target element (which is also updated in place)
     */
    value: function sync(options) {
      var refOwner = options.refOwner,
          refsWas = refOwner && refOwner.byRef;
      var affected = options.affected,
          i,
          ref,
          targetNode,
          lastDomConfig;

      if (typeof affected === 'string') {
        affected = [affected];
      }

      if (refOwner) {
        // We always rebuild the byRef map on each call
        refOwner.byRef = {};

        if (affected) {
          // We need to preserve all previously rendered refs that are not going to be affected by this partial
          // update...
          for (ref in refsWas) {
            if (!affected.includes(ref)) {
              refOwner.byRef[ref] = refsWas[ref];
            }
          }
        }

        options = Object.assign({
          refsWas: refsWas
        }, options);
      } // performSync() returns false if nothing was done because the configs were equal...


      if (this.performSync(options, options.targetElement) && refOwner) {
        if (!affected) {
          affected = Object.keys(refsWas);
        }

        for (i = 0; i < affected.length; ++i) {
          ref = affected[i];

          if (!(ref in refOwner.byRef)) {
            targetNode = refsWas[ref]; // If we are doing a partial update, the list of affected refs may contain refs that were not
            // rendered last time...

            if (targetNode) {
              lastDomConfig = targetNode.lastDomConfig;
              targetNode.remove();
              refOwner.detachRef(ref, targetNode, lastDomConfig);
            }
          }
        }
      }

      return options.targetElement;
    }
  }, {
    key: "performSync",
    value: function performSync(options, targetElement) {
      var domConfig = options.domConfig,
          callback = options.callback,
          configIsEqual = options.configEquality ? options.configEquality(domConfig, targetElement.lastDomConfig, syncEqualityEvaluator) : _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].isDeeplyEqual(domConfig, targetElement.lastDomConfig, syncEqualityEvaluator);

      if (!configIsEqual) {
        if (domConfig) {
          // Sync without affecting the containing element?
          if (!domConfig.onlyChildren) {
            this.syncAttributes(domConfig, targetElement, options);
            this.syncContent(domConfig, targetElement);
          }

          this.syncChildren(options, targetElement); // Link the element for easy retrieval later

          domConfig._element = targetElement;
        } // Allow null to clear html
        else {
            targetElement.innerHTML = null;
            targetElement.syncIdMap = null;
          } // Cache the config on the target for future comparison


        targetElement.lastDomConfig = domConfig;
        return true;
      } else {
        // Maintain link to element (deep)
        this.relinkElements(domConfig, targetElement); // Sync took no action, notify the world

        callback && callback({
          action: 'none',
          domConfig: domConfig,
          targetElement: targetElement
        });
      }

      return false;
    } // Called from sync when there is no change to elements, to set up link between new config and existing element.
    // Plucks the element from the last applied config, no need to hit DOM so is cheap

  }, {
    key: "relinkElements",
    value: function relinkElements(domConfig, targetElement) {
      var _this = this;

      // Hands off when retaining element (it is for some reason taken out of the normal rendering flow, for example
      // by dragging it)
      if (!domConfig.retainElement) {
        domConfig._element = targetElement; // Since there was no change detected, there is a 1 to 1 ratio between new config and last config, should be
        // safe to do a straight mapping

        domConfig.children && domConfig.children.forEach(function (childDomConfig, i) {
          // Skip null entries, allowed for convenience, neat with map.
          // Also skip text nodes
          if (childDomConfig && typeof childDomConfig !== 'string') {
            _this.relinkElements(childDomConfig, targetElement.lastDomConfig.children[i]._element);
          }
        });
      }
    } //region Attributes

  }, {
    key: "syncDataset",
    value: function syncDataset(domConfig, targetElement) {
      var lastDomConfig = targetElement.lastDomConfig,
          sameConfig = domConfig === lastDomConfig,
          source = Object.keys(domConfig.dataset),
          target = lastDomConfig && lastDomConfig.dataset && Object.keys(lastDomConfig.dataset),
          delta = _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].delta(source, target); // New attributes in dataset

      for (var i = 0; i < delta.onlyInA.length; i++) {
        var attr = delta.onlyInA[i],
            value = domConfig.dataset[attr]; // Prevent `data-property="undefined"`

        if (value !== undefined) {
          targetElement.setAttribute("data-".concat(_StringHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].hyphenate(attr)), value);
        }
      } // Might have changed


      for (var _i = 0; _i < delta.inBoth.length; _i++) {
        var _attr = delta.inBoth[_i]; // Intentional != since dataset is always string but want numbers to match
        // noinspection EqualityComparisonWithCoercionJS

        if (sameConfig || domConfig.dataset[_attr] != lastDomConfig.dataset[_attr]) {
          targetElement.setAttribute("data-".concat(_StringHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].hyphenate(_attr)), domConfig.dataset[_attr]);
        }
      } // Removed


      for (var _i2 = 0; _i2 < delta.onlyInB.length; _i2++) {
        targetElement.removeAttribute("data-".concat(_StringHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].hyphenate(delta.onlyInB[_i2])));
      }
    }
  }, {
    key: "syncClassList",
    value: function syncClassList(domConfig, targetElement, lastDomConfig) {
      var cls = domConfig.className || domConfig.class,
          c,
          currentClasses,
          i,
          k,
          keep,
          last;

      if (lastDomConfig) {
        // NOTE: The following reads the DOM to determine classes that may have been added by other means. This
        //  diff is only enabled when "strict" is used (see our callers)
        currentClasses = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_28__["default"].normalize(targetElement, 'array');
        cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_28__["default"].normalize(cls, 'object');
        last = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_28__["default"].normalize(lastDomConfig.className || lastDomConfig.class, 'object');
        keep = [];

        for (i = 0, k = currentClasses.length; i < k; ++i) {
          c = currentClasses[i]; // We want to keep classes not in cls if we didn't add them last time

          if (cls[c] || !(c in last)) {
            last[c] = 1;
            keep.push(c);
          }
        }

        for (c in cls) {
          if (!last[c]) {
            keep.push(c);
          }
        }

        cls = keep.join(' ');
      } else {
        cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_28__["default"].normalize(cls); // to string
      }

      targetElement.setAttribute('class', cls);
    } // Attributes as map { attr : value, ... }

  }, {
    key: "getSyncAttributes",
    value: function getSyncAttributes(domConfig) {
      var attributes = {},
          // Attribute names, simplifies comparisons and calls to set/removeAttribute
      names = []; // On a first sync, there are no domConfig on the target element yet

      if (domConfig) {
        Object.keys(domConfig).forEach(function (attr) {
          if (!syncIgnoreAttributes[attr]) {
            var name = attr.toLowerCase();
            attributes[name] = domConfig[attr];
            names.push(name);
          }
        });
      }

      return {
        attributes: attributes,
        names: names
      };
    }
  }, {
    key: "syncAttributes",
    value: function syncAttributes(domConfig, targetElement, options) {
      var lastDomConfig = targetElement.lastDomConfig,
          sameConfig = domConfig === lastDomConfig,
          sourceSyncAttrs = this.getSyncAttributes(domConfig),
          sourceAttributes = sourceSyncAttrs.attributes,
          sourceNames = sourceSyncAttrs.names,
          _ref = sameConfig ? sourceSyncAttrs : this.getSyncAttributes(lastDomConfig),
          targetAttributes = _ref.attributes,
          targetNames = _ref.names,
          _ref2 = sameConfig ? {
        onlyInA: emptyArray,
        onlyInB: emptyArray,
        inBoth: sourceNames
      } : _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].delta(sourceNames, targetNames),
          toAdd = _ref2.onlyInA,
          toRemove = _ref2.onlyInB,
          toSync = _ref2.inBoth; // Add new attributes


      for (var i = 0; i < toAdd.length; i++) {
        var attr = toAdd[i],
            sourceAttr = sourceAttributes[attr]; // Style requires special handling

        if (attr === 'style') {
          // TODO: Do diff style apply also instead of this replace
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].applyStyle(targetElement, sourceAttr, true);
        } // So does dataset
        else if (attr === 'dataset') {
            this.syncDataset(domConfig, targetElement);
          } // And class, which might be an object
          else if (isClass[attr]) {
              this.syncClassList(domConfig, targetElement);
            } // Other attributes are set using setAttribute (since it calls toString() DomClassList works fine),
            // unless they are undefined in which case they are ignored to not get `href="undefined"` etc
            else if (sourceAttr !== undefined) {
                targetElement.setAttribute(attr, sourceAttr);
              }
      } // Removed no longer used attributes


      for (var _i3 = 0; _i3 < toRemove.length; _i3++) {
        targetElement.removeAttribute(toRemove[_i3]);
      } // TODO: toAdd and toSync are growing very alike, consider merging
      // Sync values for all other attributes


      for (var _i4 = 0; _i4 < toSync.length; _i4++) {
        var _attr2 = toSync[_i4],
            _sourceAttr = sourceAttributes[_attr2],
            targetAttr = targetAttributes[_attr2]; // Attribute value null means remove attribute

        if (_sourceAttr == null) {
          targetElement.removeAttribute(_attr2);
        } // Set all attributes that has changed, with special handling for style.
        else if (_attr2 === 'style') {
            if (options.strict) {
              if (sameConfig) {
                this.syncStyles(targetElement, _sourceAttr);
              } else if (!_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].isEqual(_sourceAttr, targetAttr, true)) {
                this.syncStyles(targetElement, _sourceAttr, targetAttr);
              }
            } else if (sameConfig || !_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].isEqual(_sourceAttr, targetAttr, true)) {
              _DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].applyStyle(targetElement, _sourceAttr, true);
            }
          } // And dataset
          else if (_attr2 === 'dataset') {
              this.syncDataset(domConfig, targetElement);
            } // And class, which might be an object
            else if (isClass[_attr2]) {
                this.syncClassList(domConfig, targetElement, options.strict && targetElement.lastDomConfig);
              } else if (sameConfig || _sourceAttr !== targetAttr) {
                targetElement.setAttribute(_attr2, _sourceAttr);
              }
      }
    }
  }, {
    key: "syncStyles",
    value: function syncStyles(targetElement, sourceAttr, targetAttr) {
      var styles, key, value;

      if (!targetAttr) {
        styles = sourceAttr;
      } else {
        styles = {};

        if (sourceAttr) {
          for (key in sourceAttr) {
            value = sourceAttr[key];

            if (targetAttr[key] !== value) {
              styles[key] = value;
            }
          }
        }

        for (key in targetAttr) {
          if (!(key in sourceAttr)) {
            styles[key] = '';
          }
        }
      }

      _DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].applyStyle(targetElement, styles);
    } //endregion
    //region Content

  }, {
    key: "syncContent",
    value: function syncContent(domConfig, targetElement) {
      var html = domConfig.html,
          text = domConfig.text,
          content = text !== null && text !== void 0 ? text : html; // elementData holds custom data that we want to attach to the element (not visible in dom)

      if (domConfig.elementData) {
        targetElement.elementData = domConfig.elementData;
      } // Apply html from config


      if (content instanceof DocumentFragment) {
        // If given a DocumentFragment, replace content with it
        if (targetElement.childNodes.length === 1 && targetElement.childElementCount === 0 && content.childNodes.length === 1 && content.childElementCount === 0) {
          // Syncing a textNode to a textNode? Use shortcut
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].setInnerText(targetElement, content.firstChild.data);
        } else {
          targetElement.innerHTML = '';
          targetElement.appendChild(content);
        }
      } else if (html != null && htmlRe.test(html)) {
        targetElement.innerHTML = String(html); // convert numbers to strings
      } else if (content != null) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].setInnerText(targetElement, String(content));
      }
    }
  }, {
    key: "insertTextNode",
    value: function insertTextNode(text, targetElement, callback, refOwner) {
      var beforeElement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var newNode = document.createTextNode(text);
      targetElement.insertBefore(newNode, beforeElement);

      if (refOwner) {
        newNode.$refOwnerId = refOwner.id;
      }

      callback && callback({
        action: 'newNode',
        domConfig: text,
        targetElement: newNode
      });
    }
  }, {
    key: "insertElement",
    value: function insertElement(domConfig, targetElement, targetNode, refOwner, syncIdMap, syncId, options) {
      // Create a new element
      var newElement = options.ns ? document.createElementNS(options.ns, domConfig.tag || 'svg') : document.createElement(domConfig.tag || 'div'); // Insert (or append if no targetNode)

      targetElement.insertBefore(newElement, targetNode); // Sync to it

      this.performSync(options, newElement);

      if (syncId != null) {
        syncIdMap[syncId] = newElement;
      }

      if (refOwner) {
        newElement.$refOwnerId = refOwner.id;

        if (syncId) {
          newElement.$reference = syncId;
          refOwner.attachRef(syncId, newElement, domConfig);
        }
      }

      options.callback && options.callback({
        action: 'newElement',
        domConfig: domConfig,
        targetElement: newElement,
        syncId: syncId
      });
    } //endregion
    //region Children

  }, {
    key: "syncChildren",
    value: function syncChildren(options, targetElement) {
      var _domConfig$html;

      var domConfig = options.domConfig,
          syncIdField = options.syncIdField,
          callback = options.callback,
          releaseThreshold = options.releaseThreshold,
          configEquality = options.configEquality,
          ns = options.ns,
          refOwner = options.refOwner,
          refsWas = options.refsWas,
          strict = options.strict; // Having specified html or text replaces all inner content, no point in syncing

      if ((_domConfig$html = domConfig.html) !== null && _domConfig$html !== void 0 ? _domConfig$html : domConfig.text) {
        return;
      }

      var me = this,
          // Always repopulate the map, since elements might get used by other syncId below
      newSyncIdMap = refOwner ? refOwner.byRef : {},
          sourceConfigs = arraySlice.call(domConfig.children || []),
          targetNodes = arraySlice.call(targetElement.childNodes),
          syncIdMap = refsWas || targetElement.syncIdMap || {},
          syncOptions = domConfig.syncOptions || {},
          releasedIdMap = targetElement.releasedIdMap || {}; // Each level can optionally specify its own syncIdField, strict and callback, if left out parent levels will be used

      syncIdField = syncOptions.syncIdField || syncIdField;
      strict = syncOptions.strict || strict;
      callback = syncOptions.callback || callback;
      configEquality = syncOptions.configEquality || configEquality; // Make sure releaseThreshold 0 is respected...

      releaseThreshold = 'releaseThreshold' in syncOptions ? syncOptions.releaseThreshold : releaseThreshold;
      var cleanupNodes = null,
          syncId;

      if (syncIdField) {
        targetElement.syncIdMap = newSyncIdMap;
      } // Settings to use in all syncs below


      var syncChildOptions = {
        refOwner: refOwner,
        refsWas: refsWas,
        strict: strict,
        syncIdField: syncIdField,
        releaseThreshold: releaseThreshold,
        callback: callback,
        configEquality: configEquality
      };

      while (sourceConfigs.length) {
        var sourceConfig = sourceConfigs.shift();
        syncId = null; // Allowing null, convenient when using Array.map() to generate children

        if (!sourceConfig) {
          continue;
        }

        var isTextNode = typeof sourceConfig === 'string'; // Used in all syncs

        syncChildOptions.domConfig = sourceConfig;
        syncChildOptions.ns = sourceConfig.ns || ns;

        if (!isTextNode) {
          // If syncIdField was supplied, we should first try to reuse element with
          // matching "id"
          if (refOwner) {
            syncId = sourceConfig.reference;
          } else if (syncIdField && sourceConfig.dataset) {
            syncId = sourceConfig.dataset[syncIdField];
          } // We have an id to look for


          if (syncId != null && !sourceConfig.unmatched) {
            // Find any matching element, either in use or previously released
            var syncTargetElement = syncIdMap[syncId] || releasedIdMap[syncId];

            if (syncTargetElement) {
              var lastDomConfig = syncTargetElement.lastDomConfig;

              if ( // Ignore if flagged with `retainElement` (for example during dragging)
              !syncTargetElement.retainElement && // Otherwise sync with the matched element
              me.performSync(syncChildOptions, syncTargetElement)) {
                // Sync took some action, notify the world
                callback && callback({
                  action: 'reuseOwnElement',
                  domConfig: sourceConfig,
                  lastDomConfig: lastDomConfig,
                  targetElement: syncTargetElement,
                  syncId: syncId
                });
              } // Since it wont sync above when flagged to be retained, we need to apply the flag here


              if (sourceConfig.retainElement) {
                syncTargetElement.retainElement = true; // Normally linked in performSync(), but for retained elements that fn is not called

                sourceConfig._element = syncTargetElement;
              } // Cache the element on the syncIdMap for faster retrieval later


              newSyncIdMap[syncId] = syncTargetElement; // Remove target from targetElements & release tracking, no-one else is allowed to sync with it

              _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].remove(targetNodes, syncTargetElement);
              delete releasedIdMap[syncId];
              syncTargetElement.isReleased = false;

              if (strict || syncTargetElement.parentNode !== targetElement) {
                targetElement.insertBefore(syncTargetElement, targetNodes[0] || null);
              }
            } else if (strict) {
              this.insertElement(sourceConfig, targetElement, targetNodes[0] || null, refOwner, newSyncIdMap, syncId, syncChildOptions);
            } else {
              // No match, move to end of queue to not steal some one else's element
              sourceConfigs.push(sourceConfig); // Also flag as unmatched to know that when we reach this element again

              sourceConfig.unmatched = true;
            } // Node handled, carry on with next one


            continue;
          } // Avoid polluting the config object when done


          if (sourceConfig.unmatched) {
            delete sourceConfig.unmatched;
          }
        } // Skip over any retained elements


        var beforeNode = null,
            targetNode = null,
            cleanupNode = void 0;

        while (targetNodes.length && !targetNode) {
          cleanupNode = targetNodes.shift();

          if (refOwner) {
            // When syncing for a refOwner, foreign elements are skipped.
            if (cleanupNode.$refOwnerId !== refOwner.id) {
              continue;
            }

            if (cleanupNode.$reference) {
              // In refOwner mode we always pass strict:true, so this won't happen... but if it did, the
              // idea is that ref els do not get cleaned up until the end of the sync process.
              if (!strict) {
                continue;
              } // Since we want to maintain DOM order, this ref el marks the spot where to insert. We also
              // don't want to put it into cleanupNodes (see above). We cannot reuse ref els.


              beforeNode = cleanupNode;
              break;
            } // The element is owned by this refOwner and not assigned a reference...
            // We can reuse it


            targetNode = cleanupNode;
          } else if (!cleanupNode.retainElement) {
            targetNode = cleanupNode;
          }

          if (!targetNode) {
            (cleanupNodes || (cleanupNodes = [])).push(cleanupNode);
          }
        }

        if (beforeNode || !targetNode) {
          if (isTextNode) {
            this.insertTextNode(sourceConfig, targetElement, callback, refOwner, beforeNode);
          } else {
            // Will append if beforeNode === null
            this.insertElement(sourceConfig, targetElement, beforeNode, refOwner, newSyncIdMap, syncId, syncChildOptions);
          }
        } // We have targets left
        else {
            // Matching element tag, sync it
            if (!isTextNode && targetNode.nodeType === Node.ELEMENT_NODE && (sourceConfig.tag || 'div').toLowerCase() === targetNode.tagName.toLowerCase()) {
              var _lastDomConfig$datase;

              var _targetNode = targetNode,
                  _lastDomConfig = _targetNode.lastDomConfig,
                  result = me.performSync(syncChildOptions, targetNode); // Remove reused element from release tracking

              if (syncIdField && (_lastDomConfig === null || _lastDomConfig === void 0 ? void 0 : (_lastDomConfig$datase = _lastDomConfig.dataset) === null || _lastDomConfig$datase === void 0 ? void 0 : _lastDomConfig$datase[syncIdField])) {
                delete releasedIdMap[_lastDomConfig.dataset[syncIdField]];
              }

              if (syncId != null) {
                newSyncIdMap[syncId] = targetNode;
              }

              targetNode.isReleased = false; // Only use callback if sync succeeded (anything changed)

              result && callback && callback({
                action: 'reuseElement',
                domConfig: sourceConfig,
                lastDomConfig: _lastDomConfig,
                targetElement: targetNode,
                syncId: syncId
              });
            } // Text node to text node, change text :)
            else if (isTextNode && targetNode.nodeType === Node.TEXT_NODE) {
                targetNode.data = sourceConfig; // Not using callback for updating text of node, have no usecase for it currently
              } // Not matching, replace it
              else {
                  if (isTextNode) {
                    this.insertTextNode(sourceConfig, targetElement, callback, refOwner, targetNode);
                  } else {
                    // Will insert
                    this.insertElement(sourceConfig, targetElement, targetNode, refOwner, newSyncIdMap, syncId, syncChildOptions);
                  }

                  targetNode.remove();
                }
          }
      } // while (sourceConfigs.length)
      // Out of source nodes, remove remaining target nodes


      var numTargets = targetNodes.length;

      if (numTargets) {
        if (refOwner) {
          // Any remaining nodes that belong to this refOwner need to be cleaned up. If
          // they have an assigned reference, however, they will be handled at the very
          // end of the sync process since those elements can move in the node hierarchy.
          for (var i = 0; i < numTargets; ++i) {
            var _targetNode2 = targetNodes[i];

            if (_targetNode2.$refOwnerId === refOwner.id && !_targetNode2.$reference) {
              (cleanupNodes || (cleanupNodes = [])).push(_targetNode2);
            }
          }
        } else if (cleanupNodes) {
          var _cleanupNodes;

          (_cleanupNodes = cleanupNodes).push.apply(_cleanupNodes, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_23___default()(targetNodes));
        } else {
          cleanupNodes = targetNodes;
        }
      }

      if (cleanupNodes) {
        this.syncChildrenCleanup(targetElement, cleanupNodes, newSyncIdMap, callback, refOwner, releaseThreshold, syncIdField);
      }
    }
  }, {
    key: "syncChildrenCleanup",
    value: function syncChildrenCleanup(targetElement, cleanupNodes, newSyncIdMap, callback, refOwner, releaseThreshold, syncIdField) {
      var releaseCount = 0,
          ref;

      var _iterator = _createForOfIteratorHelper(cleanupNodes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var targetNode = _step.value;
          var lastDomConfig = targetNode.lastDomConfig; // Element might be retained, hands off (for example while dragging)

          if (!targetNode.retainElement) {
            // When using syncId to reuse elements, "release" left over elements instead of removing them, up to a
            // limit specified as releaseThreshold, above which elements are removed instead
            if (!refOwner && syncIdField && (releaseThreshold == null || releaseCount < releaseThreshold)) {
              // Prevent releasing already released element
              if (!targetNode.isReleased) {
                targetNode.className = 'b-released';
                targetNode.isReleased = true; // Store released element in syncIdMap, to facilitate reusing it for self later

                if (lastDomConfig === null || lastDomConfig === void 0 ? void 0 : lastDomConfig.dataset) {
                  if (!targetElement.releasedIdMap) {
                    targetElement.releasedIdMap = {};
                  }

                  targetElement.releasedIdMap[lastDomConfig.dataset[syncIdField]] = targetNode;
                }

                callback && callback({
                  action: 'releaseElement',
                  domConfig: lastDomConfig,
                  lastDomConfig: lastDomConfig,
                  targetElement: targetNode
                }); // Done after callback on purpose, to allow checking old className

                if (lastDomConfig) {
                  // Make sure lastDomConfig differs even from the same domConfig applied again
                  // Do not want to discard it completely since it is needed for diff when reused later
                  lastDomConfig.isReleased = true; // To force reapply of classes on reuse

                  if (lastDomConfig.className) {
                    lastDomConfig.className = 'b-released';
                  } // Same for style
                  // (for elements positioned using style, when moved in a non DomSync way, aka EventDrag)


                  if (lastDomConfig.style) {
                    lastDomConfig.style = null;
                  }
                }
              }

              releaseCount++;
            } // In normal sync mode, remove left overs
            else {
                targetNode.remove();

                if (refOwner) {
                  ref = targetNode.$reference;

                  if (ref) {
                    refOwner.detachRef(ref, targetNode, lastDomConfig);
                  }
                } // Remove from "release tracking"


                if (targetElement.releasedIdMap && syncIdField && (lastDomConfig === null || lastDomConfig === void 0 ? void 0 : lastDomConfig.dataset)) {
                  delete targetElement.releasedIdMap[lastDomConfig.dataset[syncIdField]];
                }

                callback && callback({
                  action: 'removeElement',
                  domConfig: targetNode.lastDomConfig,
                  lastDomConfig: targetNode.lastDomConfig,
                  targetElement: targetNode
                });
              }
          } else if (syncIdField) {
            // Keep retained element in map
            if (lastDomConfig) {
              newSyncIdMap[targetNode.dataset[syncIdField]] = targetNode;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Remove a child element without syncing, for example when dragging an element to some other parent.
     * Removes it both from DOM and the parent elements syncMap
     * @param {HTMLElement} parentElement
     * @param {HTMLElement} childElement
     */

  }, {
    key: "removeChild",
    value: function removeChild(parentElement, childElement) {
      if (parentElement.contains(childElement)) {
        var syncIdMap = parentElement.syncIdMap;

        if (syncIdMap) {
          var index = Object.values(syncIdMap).indexOf(childElement);

          if (index > -1) {
            delete syncIdMap[Object.keys(syncIdMap)[index]];
          }
        }

        parentElement.removeChild(childElement);
      }
    }
    /**
     * Adds a child element without syncing, making it properly available for later syncs. Useful for example
     * when dragging and dropping an element from some other parent.
     * @param {HTMLElement} parentElement
     * @param {HTMLElement} childElement
     * @param {String|Number} syncId
     */

  }, {
    key: "addChild",
    value: function addChild(parentElement, childElement, syncId) {
      parentElement.appendChild(childElement);
      parentElement.syncIdMap[syncId] = childElement;
    }
    /**
     * Get a child element using a dot separated syncIdMap path.
     *
     * ```javascript
     * DomSync.getChild(eventWrap, 'event.percentBar');
     * ```
     *
     * @param {HTMLElement} element "root" element, under which the path starts
     * @param {String} path Dot '.' separated path of syncIdMap entries
     */

  }, {
    key: "getChild",
    value: function getChild(element, path) {
      var syncIds = path.split('.');

      var _iterator2 = _createForOfIteratorHelper(syncIds),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var id = _step2.value;
          element = element.syncIdMap[id];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return element;
    } //endregion

  }]);

  return DomSync;
}();


DomSync._$name = 'DomSync';

/***/ }),

/***/ "./lib/Core/helper/DragHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/DragHelper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragHelper; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_DragHelperContainer_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./mixin/DragHelperContainer.js */ "./lib/Core/helper/mixin/DragHelperContainer.js");
/* harmony import */ var _mixin_DragHelperTranslate_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./mixin/DragHelperTranslate.js */ "./lib/Core/helper/mixin/DragHelperTranslate.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






 //TODO: add touch support
//TODO: add pointer events support

/**
 * @module Core/helper/DragHelper
 */

var documentListeners = {
  down: 'onMouseDown',
  move: 'onMouseMove',
  up: 'onMouseUp',
  docclick: 'onDocumentClick',
  touchstart: 'onTouchStart',
  touchmove: 'onTouchMove',
  touchend: 'onTouchEnd',
  keydown: 'onKeyDown'
};
/**
 * Helps with drag and drop. Supports two modes of dragging:
 * * `container` - moving/rearranging elements within and between specified containers
 * * `translateXY` - repositioning an element withing its container
 *
 * Usage examples:
 * ```
 * // dragging element between containers
 * let dragHelper = new DragHelper({
 *   mode       : 'container',
 *   containers : [ container1, container2 ]
 * });
 *
 * // dragging element within container
 * let dragHelper = new DragHelper({
 *   mode    : 'translateXY',
 *   targetSelector: 'div.moveable'
 * });
 * ```
 * In the various Drag event handlers, you will have access to the raw DOM event and some useful `context` of the drag operation:
 *
 * ```
 *  myDrag.on({
 *      drag : ({event , context}) {
 *            // The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
 *           const element = context.element;
 *
 *           // The original mousedown element upon which triggered the drag operation
 *           const grabbed = context.grabbed;
 *
 *           // The target under the current mouse / pointer / touch position
 *           const target = context.target;
 *       }
 *  });
 * ```
 *
 * Simple drag drop with a drop target specified:
 * ```javascript
 * export default class MyDrag extends DragHelper {
 *      static get defaultConfig() {
 *          return {
 *              // Don't drag the actual cell element, clone it
 *              cloneTarget        : true,
 *              mode               : 'translateXY',
 *              // Only allow drops on DOM elements with 'yourDropTarget' CSS class specified
 *              dropTargetSelector : '.yourDropTarget',
 *
 *              // Only allow dragging elements with the 'draggable' CSS class
 *              targetSelector : '.draggable'
 *          };
 *      }
 *
 *      construct(config) {
 *          const me = this;
 *
 *          super.construct(config);
 *
 *          me.on({
 *              dragstart : me.onDragStart
 *          });
 *      }
 *
 *      onDragStart({ event, context }) {
 *          const target = context.target;
 *
 *          // Here you identify what you are dragging (an image of a user, grid row in an order table etc) and map it to something in your
 *          // data model. You can store your data on the context object which is available to you in all drag-related events
 *          context.userId = target.dataset.userId;
 *      }
 *
 *      onEquipmentDrop({ context, event }) {
 *          const me = this;
 *
 *          if (context.valid) {
 *              const userId   = context.userId,
 *                    droppedOnTarget = context.target;
 *
 *              console.log(`You dropped user ${userStore.getById(userId).name} on ${droppedOnTarget}`, droppedOnTarget);
 *
 *              // Dropped on a scheduled event, display toast
 *              WidgetHelper.toast(`You dropped user ${userStore.getById(userId).name} on ${droppedOnTarget}`);
 *
 *              // tell the drag helper the operation is finished
 *              me.context.finalize();
 *          }
 *      }
 *  };
 * ```
 *
 * @mixes Core/mixin/Events
 * @extends Core/Base
 */

var DragHelper = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(DragHelper, _Base$mixin);

  var _super = _createSuper(DragHelper);

  function DragHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, DragHelper);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(DragHelper, [{
    key: "construct",
    //endregion
    //region Events

    /**
     * Fired before dragging starts, return false to prevent the drag operation.
     * @preventable
     * @event beforeDragStart
     * @param {DragHelper} source
     * @param {Object} context
     * @param {MouseEvent|TouchEvent} event
     */

    /**
     * Fired when dragging starts.
     * @event dragStart
     * @param {DragHelper} source
     * @param {Object} context
     * @param {MouseEvent|TouchEvent} event
     */

    /**
     * Fired while dragging, you can signal that the drop is valid or invalid by setting `context.valid = false;`
     * @event drag
     * @param {DragHelper} source
     * @param {Object} context
     * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid.
     * @param {MouseEvent} event
     */
    //endregion
    //region Init

    /**
     * Initializes a new DragHelper.
     * @param {Object} config Configuration object, accepts options specified under Configs above
     * @example
     * new DragHelper({
     *   containers: [div1, div2],
     *   isElementDraggable: element => element.className.contains('handle'),
     *   outerElement: topParent,
     *   listeners: {
     *     drop: onDrop,
     *     thisObj: this
     *   }
     * });
     * @function constructor
     */
    value: function construct(config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DragHelper.prototype), "construct", this).call(this, config);

      me.initListeners();

      if (me.mode === 'container') {
        me.initContainerDrag();
      } else if (me.mode.startsWith('translate')) {
        me.initTranslateDrag();
      }

      me.initialMode = me.mode;
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      // Abort dragging
      this.abort(true);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DragHelper.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "initListeners",

    /**
     * Initialize listener
     * @private
     */
    value: function initListeners() {
      var dragStartListeners = {
        element: this.outerElement,
        mousedown: documentListeners.down,
        thisObj: this
      };

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isTouchDevice) {
        dragStartListeners.touchstart = documentListeners.touchstart;
      } // These will be autoDetached upon destroy


      _EventHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].on(dragStartListeners);
    } //endregion
    //region Events

    /**
     * Fires after drop. For valid drops, it exposes `context.async` which you can set to true to signal that additional
     * processing is needed before finalizing the drop (such as showing some dialog). When that operation is done, call
     * `context.finalize(true/false)` with a boolean that determines the outcome of the drop.
     * @event drop
     * @param {DragHelper} dragHelper
     * @param {Object} context
     */

  }, {
    key: "onPointerDown",
    value: function onPointerDown(event) {
      var me = this,
          handled = false,
          isTouch = ('touches' in event); // If a drag is ongoing already, finalize it and don't proceed with new drag (happens if user does mouseup
      // outside browser window). Also handles the edge case of trying to start a new drag while previous is awaiting
      // finalization, in which case it just bails out.

      if (me.context) {
        if (!me.context.awaitingFinalization) {
          me.onMouseUp(event);
          me.reset();
        }

        return;
      }

      me.startEvent = event;
      if (me.isElementDraggable && !me.isElementDraggable(event.target, event)) return;

      if (me.mode) {
        if (!handled && me.mode === 'container') handled = me.grabContainerDrag(event);
        if (!handled && me.mode.startsWith('translate')) handled = me.grabTranslateDrag(event);
      }

      if (handled) {
        var dragListeners = {
          element: me.listenersTarget,
          thisObj: me,
          keydown: documentListeners.keydown
        };

        if (isTouch) {
          dragListeners.touchmove = {
            handler: documentListeners.touchmove,
            passive: false // We need to be able to preventDefault on the touchmove

          }; // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired
          // iOS do fire touchend

          dragListeners.touchend = dragListeners.pointerup = documentListeners.touchend;
        } else {
          dragListeners.mousemove = documentListeners.move;
          dragListeners.mouseup = documentListeners.up;
        } // A listener detacher is returned;


        me.removeListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].on(dragListeners);

        if (me.dragWithin && me.dragWithin !== me.outerElement) {
          var box = me.dragWithin.getBoundingClientRect();
          me.minY = box.top;
          me.maxY = box.bottom;
          me.minX = box.left;
          me.maxX = box.right;
        }
      }
    }
    /**
     * @param event
     * @private
     */

  }, {
    key: "onTouchStart",
    value: function onTouchStart(event) {
      var me = this; // only allowing one finger for now...

      if (event.touches.length === 1) {
        me.touchStartTimer = me.setTimeout(function () {
          me.touchStartTimer = null;
        }, me.touchStartDelay, 'touchStartDelay');
        me.onPointerDown(event);
      }
    }
    /**
     * Grab draggable element on mouse down.
     * @private
     * @param event
     */

  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      // only dragging with left mouse button
      if (event.button === 0) {
        this.onPointerDown(event);
      }
    }
  }, {
    key: "internalMove",
    value: function internalMove(event) {
      var me = this,
          context = me.context,
          distance = _EventHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].getDistanceBetween(me.startEvent, event),
          abortTouchDrag = me.touchStartTimer && distance > me.dragThreshold;

      if (abortTouchDrag) {
        me.abort(true);
        return;
      }

      if (!me.touchStartTimer && context && context.element && // Only target Elements, not text nodes
      event.target && event.target.nodeType === Node.ELEMENT_NODE && (context.started || distance >= me.dragThreshold)) {
        if (!context.started) {
          // triggers beforeDragStart, dragStart. returning false from beforeDragStart aborts drag
          if (me.callPreventable('dragStart', {
            context: context,
            event: event
          }, function () {
            if (me.mode !== 'container') {
              if (me.lockY) {
                me.mode = 'translateX';
              } else if (me.lockX) {
                me.mode = 'translateY';
              } else {
                me.mode = me.initialMode;
              }
            }

            var direction = me.lockX ? 'vertical' : me.lockY ? 'horizontal' : 'both';

            if (context.action.startsWith('translate')) {
              me.startTranslateDrag(event);
            } else if (context.action === 'container') {
              me.startContainerDrag(event);
            }

            context.started = true; // Now that the drag drop is confirmed to be starting, activate the configured scrollManager if present

            if (me.scrollManager) {
              me.scrollManager.startMonitoring({
                direction: direction,
                element: me.dragWithin || me.outerElement,
                callback: function callback(config) {
                  if (me.context.element && me.lastMouseMoveEvent) {
                    // Indicate that this is a 'fake' mousemove event as a result of the scrolling
                    me.lastMouseMoveEvent.isScroll = true;
                    me.update(me.lastMouseMoveEvent, config);
                  }
                },
                thisObj: me
              });
            } // Global informational class for when DragHelper is dragging


            document.body.classList.add('b-draghelper-active');
          }) === false) {
            return me.abort();
          }
        } // to prevent view drag (scroll) on ipad


        if (event.type === 'touchmove') {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        me.update(event);
      }
    }
  }, {
    key: "onTouchMove",
    value: function onTouchMove(event) {
      this.internalMove(event);
    }
    /**
     * Move drag element with mouse.
     * @param event
     * @fires beforeDragStart
     * @fires dragStart
     * @private
     */

  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      this.internalMove(event);
    }
    /**
     * Updates drag, called when an element is grabbed and mouse moves
     * @private
     * @fires drag
     */

  }, {
    key: "update",
    value: function update(event, scrollManagerConfig) {
      var me = this,
          context = me.context,
          draggingElement = context.dragProxy || context.element; // two different modes used

      var target = event.target,
          scrollingPageElement = document.scrollingElement || document.body; // "pointer-events:none" touchmove has no effect for the touchmove event target, meaning we cannot know
      // what's under the cursor as easily in touch devices

      if (event.type === 'touchmove') {
        var touch = event.changedTouches[0];
        target = _DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].elementFromPoint(touch.clientX + scrollingPageElement.scrollLeft, touch.clientY + scrollingPageElement.scrollTop);
      }

      context.target = target;

      if (me.dropTargetSelector) {
        context.valid = Boolean(target.closest(me.dropTargetSelector));
      } else {
        // assume valid drop location
        context.valid = true;
      } // Move the drag proxy or dragged element before triggering the drag event


      if (context.action) {
        if (context.action === 'container') {
          me.updateContainerProxy(event, scrollManagerConfig);
        }

        if (context.action.startsWith('translate')) {
          me.updateTranslateProxy(event, scrollManagerConfig);
        }
      } // Allow external code to validate the context before updating a container drag


      me.trigger('drag', {
        context: context,
        event: event
      }); // Move the placeholder element into its new place.
      // This will see the new state of context if mutated by a drag listener.

      if (context.action === 'container') {
        me.updateContainerDrag(event, scrollManagerConfig);
      } // change to toggle with force when not supporting IE11 any longer


      draggingElement.classList[context.valid ? 'remove' : 'add'](me.invalidCls);
      if (event) me.lastMouseMoveEvent = event;
    }
    /**
     * Abort dragging
     * @fires abort
     */

  }, {
    key: "abort",
    value: function abort() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          context = me.context;
      me.scrollManager && me.scrollManager.stopMonitoring(me.dragWithin || me.outerElement);

      if (context) {
        // Force a synchronous layout so that transitions from this point will work.
        context.element.getBoundingClientRect(); // Aborted drag not considered valid

        context.valid = false;

        if (context.action === 'container') {
          me.abortContainerDrag(undefined, undefined, silent);
        } else {
          me.abortTranslateDrag(undefined, undefined, silent);
        }
      }

      me.reset();
    } // Empty class implementation. If listeners *are* added, the detacher is added
    // as an instance property. So this is always callable.

  }, {
    key: "removeListeners",
    value: function removeListeners() {} // Called when a drag operation is completed, or aborted
    // Removes DOM listeners and resets context

  }, {
    key: "reset",
    value: function reset(silent) {
      document.body.classList.remove('b-draghelper-active');
      this.removeListeners();
      /**
       * Fired when a drag operation is completed or aborted
       * @event reset
       * @private
       * @param {DragHelper} dragHelper
       */

      if (!silent) {
        this.trigger('reset');
      }

      this.context = this.lastMouseMoveEvent = null;
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(event) {
      this.onMouseUp(event);
    }
    /**
     * This is a capture listener, only added during drag, which prevents a click gesture
     * propagating from the terminating mouseup gesture
     * @param {MouseEvent} event
     * @private
     */

  }, {
    key: "onDocumentClick",
    value: function onDocumentClick(event) {
      event.stopPropagation();
    }
    /**
     * Drop on mouse up (if dropped on valid target).
     * @param event
     * @private
     */

  }, {
    key: "onMouseUp",
    value: function onMouseUp(event) {
      var me = this,
          context = me.context;
      me.removeListeners();

      if (context) {
        me.scrollManager && me.scrollManager.stopMonitoring(me.dragWithin || me.outerElement);

        if (context.action === 'container') {
          me.finishContainerDrag(event);
        } else if (context.started && context.action.startsWith('translate')) {
          me.finishTranslateDrag(event);
        }

        if (context.started) {
          // Prevent the impending document click from the mouseup event from propagating
          // into a click on our element.
          _EventHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
            element: document,
            thisObj: me,
            click: documentListeners.docclick,
            capture: true,
            expires: me.clickSwallowDuration,
            // In case a click did not ensue, remove the listener
            once: true
          });
        } else {
          me.reset(true);
        }
      }
    }
    /**
     * Cancel on ESC key
     * @param event
     * @private
     */

  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      if (event.key === 'Escape') this.abort();
    }
    /**
     * Creates the proxy element to be dragged, when using {@link #config-cloneTarget}. Clones the original element by default
     */

  }, {
    key: "createProxy",
    value: function createProxy(element) {
      var clone = element.cloneNode(true);
      clone.removeAttribute('id');
      return clone;
    } //endregion

  }, {
    key: "listenersTarget",
    get: function get() {
      return document;
    }
  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        /**
         * Drag proxy CSS class
         * @config {String}
         * @default
         * @private
         */
        dragProxyCls: 'b-drag-proxy',

        /**
         * CSS class added when drag is invalid
         * @config {String}
         * @default
         */
        invalidCls: 'b-drag-invalid',

        /**
         * CSS class added to the source element in Container drag
         * @config {String}
         * @default
         * @private
         */
        draggingCls: 'b-dragging',

        /**
         * CSS class added to the source element in Container drag
         * @config {String}
         * @default
         * @private
         */
        dropPlaceholderCls: 'b-drop-placeholder',

        /**
         * The amount of pixels to move mouse before it counts as a drag operation
         * @config {Number}
         * @default
         */
        dragThreshold: 5,

        /**
         * The outer element where the drag helper will operate (attach events to it and use as outer limit when looking for ancestors)
         * @config {HTMLElement}
         * @default
         */
        outerElement: document.body,

        /**
         * Outer element that limits where element can be dragged
         * @config {HTMLElement}
         * @default
         */
        dragWithin: null,

        /**
         * Constrain translate drag to dragWithin elements bounds (set to false to allow it to "overlap" edges)
         * @config {Boolean}
         * @default
         */
        constrain: true,

        /**
         * Smallest allowed x when dragging horizontally.
         * @config {Number}
         * @default
         */
        minX: null,

        /**
         * Largest allowed x when dragging horizontally.
         * @config {Number}
         * @default
         */
        maxX: null,

        /**
         * Smallest allowed y when dragging horizontally.
         * @config {Number}
         * @default
         */
        minY: null,

        /**
         * Largest allowed y when dragging horizontally.
         * @config {Number}
         * @default
         */
        maxY: null,

        /**
         * Enabled dragging, specify mode:
         * <table>
         * <tr><td>container<td>Allows reordering elements within one and/or between multiple containers
         * <tr><td>translateXY<td>Allows dragging within a parent container
         * </table>
         * @config {String}
         * @default
         */
        mode: null,

        /**
         * A function that determines if dragging an element is allowed. Gets called with the element as argument,
         * return true to allow dragging or false to prevent.
         * @config {Function}
         * @default
         */
        isElementDraggable: null,

        /**
         * A CSS selector used to determine if dragging an element is allowed.
         * @config {String}
         * @default
         */
        targetSelector: null,

        /**
         * A CSS selector used to determine if a drop is allowed at the current position.
         * @config {String}
         * @default
         */
        dropTargetSelector: null,

        /**
         * Set to true to clone the dragged target, and not move the actual target DOM node.
         * @config {Boolean}
         * @default
         */
        cloneTarget: false,

        /**
         * Set to true to hide the original element while dragging (applicable when `cloneTarget` is true).
         * @config {Boolean}
         * @default
         */
        hideOriginalElement: false,

        /**
         * Containers whose elements can be rearranged (and moved between the containers). Used when
         * mode is set to "container".
         * @config {HTMLElement[]}
         * @default
         */
        containers: null,

        /**
         * A CSS selector used to exclude elements when using container mode
         * @config {String}
         * @default
         */
        ignoreSelector: null,
        startEvent: null,

        /**
         * Configure as `true` to disallow dragging in the `X` axis. The dragged element will only move vertically.
         * @config {Boolean}
         * @default
         */
        lockX: false,

        /**
         * Configure as `true` to disallow dragging in the `Y` axis. The dragged element will only move horizontally.
         * @config {Boolean}
         * @default
         */
        lockY: false,

        /**
         * The amount of milliseconds to wait after a touchstart, before a drag gesture will be allowed to start.
         * @config {Number}
         * @default
         */
        touchStartDelay: 300,
        // For the abort animation
        transitionDuration: 300,
        clickSwallowDuration: 50,
        ignoreSamePositionDrop: true,
        testConfig: {
          transitionDuration: 10,
          // In Edge synthetic click events are fired asynchronously and can take considerable
          // amount of time. Setting larger click swallow timeout to make sure Edge has time to fire click event.
          // Caught by test EventDrag4.t in Edge
          clickSwallowDuration: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isEdge ? 300 : 50
        }
      };
    }
  }]);

  return DragHelper;
}(_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_11__["default"], _mixin_DragHelperContainer_js__WEBPACK_IMPORTED_MODULE_12__["default"], _mixin_DragHelperTranslate_js__WEBPACK_IMPORTED_MODULE_13__["default"]));


DragHelper._$name = 'DragHelper';

/***/ }),

/***/ "./lib/Core/helper/EventHelper.js":
/*!****************************************!*\
  !*** ./lib/Core/helper/EventHelper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventHelper; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _util_Point_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");









var productName = 'scheduler';







/**
 * @module Core/helper/EventHelper
 */

var touchProperties = ['clientX', 'clientY', 'pageX', 'pageY', 'screenX', 'screenY'],
    isOption = {
  element: 1,
  thisObj: 1,
  once: 1,
  delegate: 1,
  delay: 1,
  capture: 1,
  passive: 1,
  throttled: 1,
  autoDetach: 1,
  expires: 1
},
    ctrlKeyProp = {
  get: function get() {
    return true;
  }
},
    normalizedKeyNames = {
  Spacebar: 'Space',
  Del: 'Delete',
  Esc: 'Escape',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown'
};

function getAccessorFromPrototype(target, property) {
  var descriptor, accessor;

  while ((target = Object.getPrototypeOf(target)) && !accessor) {
    descriptor = Object.getOwnPropertyDescriptor(target, property);
    accessor = descriptor && descriptor.get;
  }

  return accessor;
}
/**
 * Utility methods for dealing with Events, normalizing Touch/Pointer/Mouse events.
 */


var EventHelper = /*#__PURE__*/function () {
  function EventHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, EventHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(EventHelper, null, [{
    key: "normalizeEvent",
    value: function normalizeEvent(event) {
      return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].copyPropertiesIf(event, event.changedTouches[0] || event.touches[0], touchProperties);
    }
    /**
     * Returns the `[x, y]` coordinates of the event in the viewport coordinate system.
     * @param {Event} event The event
     * @return {Number[]} The coordinate.
     */

  }, {
    key: "getXY",
    value: function getXY(event) {
      if (event.touches) {
        event = event.touches[0];
      }

      return [event.clientX, event.clientY];
    }
    /**
     * Returns the pixel distance between two mouse/touch/pointer events.
     * @param {Event} event1 The first event.
     * @param {Event} event2 The second event.
     * @return {Number} The distance in pixels between the two events.
     */

  }, {
    key: "getDistanceBetween",
    value: function getDistanceBetween(event1, event2) {
      var xy1 = EH.getXY(event1),
          xy2 = EH.getXY(event2); // No point in moving this to Point. We are dealing only with number values here.

      return Math.sqrt(Math.pow(xy1[0] - xy2[0], 2) + Math.pow(xy1[1] - xy2[1], 2));
    }
    /**
     * Returns a {@link Core.helper.util.Point} which encapsulates the `pageX/Y` position of the event.
     * May be used in {@link Core.helper.util.Rectangle} events.
     * @param {Event} event A browser mouse/touch/pointer event.
     * @return {Core.helper.util.Point} The page point.
     */

  }, {
    key: "getPagePoint",
    value: function getPagePoint(event) {
      return new _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].Point(event.pageX, event.pageY);
    }
    /**
     * Returns a {@link Core.helper.util.Point} which encapsulates the `clientX/Y` position of the event.
     * May be used in {@link Core.helper.util.Rectangle} events.
     * @param {Event} event A browser mouse/touch/pointer event.
     * @return {Core.helper.util.Point} The page point.
     */

  }, {
    key: "getClientPoint",
    value: function getClientPoint(event) {
      return new _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].Point(event.clientX, event.clientY);
    }
    /**
     * Add a listener or listeners to an element
     * @param {HTMLElement} element The element to add a listener/listeners to.
     * @param {String|Object} eventName Either a string, being the name of the event to listen for,
     * or an options object containing event names and options as keys. See the options parameter
     * for details, or the {@link #function-on-static} method for details.
     * @param {Function} [handler] If the second parameter is a string event name, this is the handler function.
     * @param {Object} [options] If the second parameter is a string event name, this is the options.
     * @param {HTMLElement} options.element The element to add the listener to.
     * @param {Object} options.thisObj The default `this` reference for all handlers added in this call.
     * @param {Boolean} [options.autoDetach=true] The listeners are automatically removed when the `thisObj` is destroyed.
     * @param {String} [options.delegate] A CSS selector string which only fires the handler when the event takes place in a matching element.
     * @param {Boolean} [options.once] Specify as `true` to have the listener(s) removed upon first invocation.
     * @param {Number} [options.delay] The number of milliseconds to delay the handler call after the event fires:
     * @param {Number|Object} [options.expires] The listener only waits for a specified time before
     * being removed. The value may be a number or an object containing an expiry handler.
     * @param {Number} [options.expires.delay] How long to wait for the event for.
     * @param {String|Function} [options.expires.alt] The function to call when the listener expires
     * **without having been triggered**.
     * @returns {Function} A detacher function which removes all the listeners when called.
     */

  }, {
    key: "addListener",
    value: function addListener(element, eventName, handler, options) {
      if (element.nodeType) {
        // All separate params, element, eventname and handler
        if (typeof eventName === 'string') {
          options = Object.assign(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()({
            element: element
          }, eventName, handler), options);
        } // element, options
        else {
            options = Object.assign({
              element: element
            }, eventName);
          }
      } // Just an options object passed
      else {
          options = element;
        }

      return EH.on(options);
    }
    /**
     * Adds a listener or listeners to an element.
     * all property names other than the options listed below are taken to be event names,
     * and the values as handler specs.
     *
     * A handler spec is usually a function reference or the name of a function in the `thisObj`
     * option.
     *
     * But a handler spec may also be an options object containing a `handler` property which is
     * the function or function name, and local options, including `element` and `thisObj`
     * which override the top level options.
     *
     *  Usage example
     *
     * ```javascript
     * construct(config) {
     *     super.construct(config);
     *
     *     // Add auto detaching event handlers to this Widget's reference elements
     *     EventHelper.on({
     *         element : this.iconElement,
     *         click   : '_handleIconClick',
     *         thisObj : this,
     *         contextmenu : {
     *             element : document,
     *             handler : '_handleDocumentContextMenu'
     *         }
     *     });
     * }
     *```
     *
     * The `click` handler on the `iconElement` calls `this._handleIconClick`.
     *
     * The `contextmenu` handler is added to the `document` element, but the `thisObj`
     * is defaulted in from the top `options` and calls `this._handleDocumentContextMenu`.
     *
     * Note that on touch devices, `dblclick` and `contextmenu` events are synthesized.
     * Synthesized events contain a `browserEvent` property containing the final triggering
     * event of the gesture. For example a synthesized `dblclick` event would contain a
     * `browserEvent` property which is the last `touchend` event. A synthetic `contextmenu`
     * event will contain a `browserEvent` property which the longstanding `touchstart` event.
     *
     * @param {Object} options The full listener specification.
     * @param {HTMLElement} options.element The element to add the listener to.
     * @param {Object} options.thisObj The default `this` reference for all handlers added in this call.
     * @param {Boolean} [options.autoDetach=true] The listeners are automatically removed when the `thisObj` is destroyed.
     * @param {String} [options.delegate] A CSS selector string which only fires the handler when the event takes place in a matching element.
     * @param {Boolean} [options.once] Specify as `true` to have the listener(s) removed upon first invocation.
     * @param {Number} [options.delay] The number of milliseconds to delay the handler call after the event fires.
     * @param {Number} [options.throttled] For rapidly repeating events (Such as `wheel` or `scroll` or `mousemove`)
     * this is the number of milliseconds to delay subsequent handler calls after first invocation which happens immediately.
     * @param {Number|Object} [options.expires] The listener only waits for a specified time before
     * being removed. The value may be a number or an object containing an expiry handler.
     * @param {Number} [options.expires.delay] How long to wait for the event for.
     * @param {String|Function} [options.expires.alt] The function to call when the listener expires
     * **without having been triggered**.
     * @returns {Function} A detacher function which removes all the listeners when called.
     */

  }, {
    key: "on",
    value: function on(options) {
      var element = options.element,
          thisObj = options.thisObj,
          handlerDetails = [];

      for (var eventName in options) {
        // Only treat it as an event name if it's not a supported option
        if (!isOption[eventName]) {
          var handlerSpec = options[eventName];

          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default()(handlerSpec) !== 'object') {
            handlerSpec = {
              handler: handlerSpec
            };
          }

          var targetElement = handlerSpec.element || element; // If we need to convert taphold to an emulated contextmenu, add a wrapping function
          // in addition to the contextmenu listener. Platforms may support mouse *and* touch.

          if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isTouchDevice && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isAndroid) {
            if (eventName === 'contextmenu') {
              handlerDetails.push(EH.addElementListener(targetElement, 'touchstart', {
                handler: EH.createContextMenuWrapper(handlerSpec.handler, handlerSpec.thisObj || thisObj)
              }, options));
            }
          } // Keep track of the real handlers added.
          // addElementLister returns [ element, eventName, addedfunction, capture ]


          handlerDetails.push(EH.addElementListener(targetElement, eventName, handlerSpec, options));
        }
      }

      var detacher = function detacher() {
        for (var _handlerSpec, i = 0; i < handlerDetails.length; i++) {
          _handlerSpec = handlerDetails[i];
          EH.removeEventListener(_handlerSpec[0], _handlerSpec[1], _handlerSpec[2]);
        }

        handlerDetails.length = 0;
      }; // { autoDetach : true, thisObj : scheduler } means remove all listeners when the scheduler dies.


      if (thisObj && options.autoDetach !== false) {
        thisObj.doDestroy = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].createInterceptor(thisObj.doDestroy, detacher, thisObj);
      }

      return detacher;
    }
    /**
     * Used internally to add a single event handler to an element.
     * @param {HTMLElement} element The element to add the handler to.
     * @param {String} eventName The name of the event to add a handler for.
     * @param {Function|String|Object} handlerSpec Either a function to call, or
     * the name of a function to call in the `thisObj`, or an object containing
     * the handler local options.
     * @param {Function|String} [handlerSpec.handler] Either a function to call, or
     * the name of a function to call in the `thisObj`.
     * @param {HTMLElement} [handlerSpec.element] Optionally a local element for the listener.
     * @param {Object} [handlerSpec.thisObj] A local `this` specification for the handler.
     * @param {Object} defaults The `options` parameter from the {@link #function-addListener-static} call.
     * @private
     */

  }, {
    key: "addElementListener",
    value: function addElementListener(element, eventName, handlerSpec, defaults) {
      var handler = EH.createHandler(element, eventName, handlerSpec, defaults),
          handlerHasPassive = ('passive' in handlerSpec),
          expires = handlerSpec.expires || defaults.expires;
      var options = handlerSpec.capture || defaults.capture; // If we are passed the passive option and the browser supports it, then convert
      // The capture option into the object options form.

      if ((handlerHasPassive || 'passive' in defaults) && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].supportsPassive) {
        options = {
          capture: !!options,
          passive: handlerHasPassive ? handlerSpec.passive : defaults.passive
        };
      }

      element.addEventListener(eventName, handler, options);

      if (expires) {
        // Extract expires : { delay : 100, alt : 'onExpireFn' }
        var thisObj = handlerSpec.thisObj || defaults.thisObj,
            delayable = (thisObj === null || thisObj === void 0 ? void 0 : thisObj.isDelayable) ? thisObj : window,
            alt = expires.alt,
            delay = alt ? expires.delay : expires,
            spec = handler.spec; // expires is not applied with other options in createHandler(), store it here

        spec.expires = expires;
        spec.timerId = delayable[typeof delay === 'number' ? 'setTimeout' : 'requestAnimationFrame'](function () {
          spec.timerId = null;
          EH.removeEventListener(element, eventName, handler); // If we make it here and the handler has not been called, invoke the alt handler

          if (alt && !handler.called) {
            (typeof alt === 'string' ? thisObj[alt] : alt).call(thisObj);
          }
        }, delay, "listener-timer-".concat(performance.now()));
      }

      return [element, eventName, handler, options];
    }
  }, {
    key: "fixEvent",
    value: function fixEvent(event) {
      var _event$target, _event$target2, _event$target3, _event$relatedTarget;

      var type = event.type; // Normalize key names

      if (type.startsWith('key')) {
        var normalizedKeyName = normalizedKeyNames[event.key];

        if (normalizedKeyName) {
          Object.defineProperty(event, 'key', {
            get: function get() {
              return normalizedKeyName;
            }
          });
        } // Polyfill the code property for SPACE because it is not set for synthetic events.


        if (event.key === ' ' && !event.code) {
          Object.defineProperty(event, 'code', {
            get: function get() {
              return 'Space';
            }
          });
        }
      } // Sync OSX's meta key with the ctrl key. This will only happen on Mac platform.
      // It's read-only, so define a local property to return true for ctrlKey.


      if (event.metaKey && !event.ctrlKey) {
        Object.defineProperty(event, 'ctrlKey', ctrlKeyProp);
      } // When we listen to event on document and get event which bubbled from shadow dom, reading its target would
      // return shadow root element. We need actual element which started the event


      if (((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.shadowRoot) && event.composedPath && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isIE11 && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isEdge) {
        var targetElement = event.composedPath()[0],
            originalTarget = event.target; // Can there be an event which actually originated from custom element, not its shadow dom?

        if (event.target !== targetElement) {
          Object.defineProperty(event, 'target', {
            get: function get() {
              return targetElement;
            },
            configurable: true
          }); // Save original target just in case

          Object.defineProperty(event, 'originalTarget', {
            get: function get() {
              return originalTarget;
            },
            configurable: true
          });
        }
      } // Chrome 78 has a bug where moving out of the left edge of an element can report a mousemove
      // with that element as the target, but offsetX as -1 and moving out the right edge can report
      // that the element is the target but an offset of the offsetWidth. Patch the event until they fix it.
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1010528
      // Tested in EventHelper.js


      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isChrome && event.target && 'offsetX' in event) {
        // Wrap reading `offsetX/Y` until this property is actually accessed in the code to avoid forced reflow.
        // To avoid getting infinite loop, property descriptor is looked up in the prototype chain. Should be
        // better than forcing DOM reflow on every single event.
        if (!Object.getOwnPropertyDescriptor(event, 'offsetX')) {
          Object.defineProperty(event, 'offsetX', {
            get: function get() {
              var accessor = getAccessorFromPrototype(event, 'offsetX'),
                  offsetX = accessor.call(event),
                  target = event.target,
                  offsetWidth = target.offsetWidth,
                  x = Math.min(Math.max(offsetX, 0), offsetWidth - 1);

              if (offsetX < 0 || offsetX >= offsetWidth) {
                return x;
              }

              return offsetX;
            }
          });
        }

        if (!Object.getOwnPropertyDescriptor(event, 'offsetY')) {
          Object.defineProperty(event, 'offsetY', {
            get: function get() {
              var accessor = getAccessorFromPrototype(event, 'offsetY'),
                  offsetY = accessor.call(event),
                  target = event.target,
                  offsetHeight = target.offsetHeight,
                  y = Math.min(Math.max(offsetY, 0), offsetHeight - 1);

              if (offsetY < 0 || offsetY >= offsetHeight) {
                return y;
              }

              return offsetY;
            }
          });
        }
      } // Firefox has a bug where it can report that the target is the #document when mouse is over a pseudo element


      if (((_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.nodeType) === 9 && 'clientX' in event) {
        var _targetElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].elementFromPoint(event.clientX, event.clientY);

        Object.defineProperty(event, 'target', {
          get: function get() {
            return _targetElement;
          }
        });
      } // Firefox has a bug where it can report a textNode as an event target/relatedTarget.
      // We standardize this to report the parentElement.


      if (((_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.nodeType) === 3) {
        var _targetElement2 = event.target.parentElement;
        Object.defineProperty(event, 'target', {
          get: function get() {
            return _targetElement2;
          }
        });
      }

      if (((_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.nodeType) === 3) {
        var relatedTargetElement = event.target.parentElement;
        Object.defineProperty(event, 'relatedTarget', {
          get: function get() {
            return relatedTargetElement;
          }
        });
      } // If it's a touch event, move the positional details
      // of touches[0] up to the event.


      if (type.startsWith('touch') && event.touches.length) {
        this.normalizeEvent(event);
      }

      return event;
    }
  }, {
    key: "createHandler",
    value: function createHandler(element, eventName, handlerSpec, defaults) {
      var delay = handlerSpec.delay || defaults.delay,
          throttled = handlerSpec.throttled || defaults.throttled,
          block = handlerSpec.block || defaults.block,
          once = handlerSpec.once || defaults.once,
          thisObj = handlerSpec.thisObj || defaults.thisObj,
          capture = handlerSpec.capture || defaults.capture,
          delegate = handlerSpec.delegate || defaults.delegate,
          wrappedFn = handlerSpec.handler; //Capture initial conditions in case of destruction of thisObj.
      // Destruction completely wipes the object.
      // Innermost level of wrapping which calls the user's handler.
      // Normalize the event cross-browser, and attempt to normalize touch events.

      var _handler2 = function handler(event) {
        var _ref;

        // Flag for the expiry timer
        _handler2.called = true; // When playing a demo using DemoBot, only handle synthetic events

        if (EH.playingDemo && event.isTrusted) {
          return;
        } // If the thisObj is already destroyed, we cannot call the function.
        // If in dev mode, warn the developer with a JS error.


        if (thisObj && thisObj.isDestroyed) {
          // eslint-disable-next-line
          return;
        } // Fix up events to handle various browser inconsistencies


        event = EH.fixEvent(event); // delegate: '.b-field-trigger' only fires when click is in a matching el.
        // currentTarget becomes the delegate.

        if (delegate) {
          // Maintainer: In Edge event.target can be an empty object for transitionend events
          var delegatedTarget = event.target instanceof HTMLElement && event.target.closest(delegate);

          if (!delegatedTarget) {
            return;
          } // Allow this to be redefined as it bubbles through listeners up the parentNode axis
          // which might have their own delegate settings.


          Object.defineProperty(event, 'currentTarget', {
            get: function get() {
              return delegatedTarget;
            },
            configurable: true
          });
        }

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        (_ref = typeof wrappedFn === 'string' ? thisObj[wrappedFn] : wrappedFn).call.apply(_ref, [thisObj, event].concat(args));
      }; // Allow events to be blocked for a certain time


      if (block) {
        var _wrappedFn = _handler2;
        var lastCallTime, lastTarget;

        _handler2 = function _handler(e) {
          var now = performance.now();

          if (!lastCallTime || e.target !== lastTarget || now - lastCallTime > block) {
            lastTarget = e.target;
            lastCallTime = now;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            _wrappedFn.apply(void 0, [e].concat(args));
          }
        };
      } // Go through options, each creates a new handler by wrapping the previous handler to implement the options.
      // Right now, we have delay. Note that it may be zero, so test != null


      if (delay != null) {
        var _wrappedFn2 = _handler2,
            delayable = thisObj && thisObj.setTimeout ? thisObj : window;

        _handler2 = function _handler() {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          delayable.setTimeout(function () {
            _wrappedFn2.apply(void 0, args);
          }, delay);
        };
      } // If they specified the throttled option, wrap the handler in a createdThrottled
      // version. Allow the called to specify an alt function to call when the event
      // fires before the buffer time has expired.


      if (throttled != null) {
        var alt,
            buffer = throttled;

        if (throttled.buffer) {
          alt = function alt(e) {
            return throttled.alt.call(EH, EH.fixEvent(e));
          };

          buffer = throttled.buffer;
        }

        if (thisObj && thisObj.isDelayable) {
          _handler2 = thisObj.throttle(_handler2, {
            delay: buffer,
            throttled: alt
          });
        } else {
          _handler2 = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].createThrottled(_handler2, buffer, thisObj, null, alt);
        }
      } // This must always be the last option processed so that it is the outermost handler
      // which is the one added to the element and is called immediately so that the
      // handler is removed immediately.
      // TODO: Use the native once option when all browsers support it. Only IE11 doesn't.


      if (once) {
        var _wrappedFn3 = _handler2;

        _handler2 = function _handler() {
          //element.removeEventListener(eventName, handler, capture);
          EH.removeEventListener(element, eventName, _handler2);

          _wrappedFn3.apply(void 0, arguments);
        };
      } // Only autoDetach here if there's a local thisObj is in the handlerSpec for this one listener.
      // If it's in the defaults, then the "on" method will handle it.


      if (handlerSpec.thisObj && handlerSpec.autoDetach !== false) {
        thisObj.doDestroy = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].createInterceptor(thisObj.doDestroy, function () {
          return EH.removeEventListener(element, eventName, _handler2);
        }, thisObj);
      }

      _handler2.spec = {
        delay: delay,
        throttled: throttled,
        block: block,
        once: once,
        thisObj: thisObj,
        capture: capture,
        delegate: delegate
      };
      return _handler2;
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(element, eventName, handler) {
      var _handler$spec = handler.spec,
          expires = _handler$spec.expires,
          timerId = _handler$spec.timerId,
          thisObj = _handler$spec.thisObj,
          capture = _handler$spec.capture; // Cancel outstanding expires.alt() call when removing the listener

      if ((expires === null || expires === void 0 ? void 0 : expires.alt) && timerId) {
        var delayable = (thisObj === null || thisObj === void 0 ? void 0 : thisObj.isDelayable) ? thisObj : window;
        delayable[typeof expires.delay === 'number' ? 'clearTimeout' : 'cancelAnimationFrame'](timerId);
      }

      element.removeEventListener(eventName, handler, capture);
    }
  }, {
    key: "onTransitionEnd",
    value: function onTransitionEnd(_ref2) {
      var element = _ref2.element,
          property = _ref2.property,
          handler = _ref2.handler,
          _ref2$duration = _ref2.duration,
          duration = _ref2$duration === void 0 ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getPropertyTransitionDuration(element, property) : _ref2$duration,
          _ref2$thisObj = _ref2.thisObj,
          thisObj = _ref2$thisObj === void 0 ? window : _ref2$thisObj;
      var timerId;

      var timerSource = thisObj.isDelayable ? thisObj : window,
          doCallback = function doCallback() {
        detacher();

        if (!thisObj.isDestroyed) {
          if (thisObj.callback) {
            thisObj.callback(handler, thisObj);
          } else {
            handler.call(thisObj);
          }
        }
      },
          detacher = EH.on({
        element: element,
        transitionend: function transitionend(_ref3) {
          var propertyName = _ref3.propertyName,
              target = _ref3.target;

          if (propertyName === property && target === element) {
            if (timerId) {
              timerSource.clearTimeout(timerId);
              timerId = null;
            }

            doCallback();
          }
        }
      }); // If the transition has not signalled its end within duration + 20 milliseconds
      // then give up on it. Remove the listener and call the handler.


      if (duration != null) {
        timerId = timerSource.setTimeout(doCallback, duration + 20);
      }

      return detacher;
    }
    /**
     * Private function to wrap the passed function. The returned wrapper function to be used as
     * a `touchstart` handler which will call the passed function passing a fabricated `contextmenu`
     * event if there's no `touchend` or `touchmove` after a default of 400ms.
     * @param {String|Function} handler The handler to call.
     * @param {Object} thisObj The owner of the function.
     * @private
     */

  }, {
    key: "createContextMenuWrapper",
    value: function createContextMenuWrapper(handler, me) {
      return function (event) {
        // Only attempt conversion to contextmenu if it's a single touch start.
        if (event.touches.length === 1) {
          var tapholdStartTouch = event.touches[0],
              // Dispatch a synthetic "contextmenu" event from the touchpoint in <longPressTime> milliseconds.
          tapholdTimer = setTimeout(function () {
            // Remove the gesture cancelling listeners
            touchMoveRemover();
            var contextmenuEvent = new MouseEvent('contextmenu', tapholdStartTouch);
            Object.defineProperty(contextmenuEvent, 'target', {
              get: function get() {
                return tapholdStartTouch.target;
              }
            });

            if (typeof handler === 'string') {
              handler = me[handler];
            }

            contextmenuEvent.browserEvent = event; // Call the wrapped handler passing the fabricated contextmenu event

            handler.call(me, contextmenuEvent);
            EH.contextMenuTouchId = tapholdStartTouch.identifier;
          }, EH.longPressTime),
              // This is what gets called if the user moves their touchpoint,
          // or releases the touch before <longPressTime>ms is up
          cancelTapholdTimer = function cancelTapholdTimer() {
            EH.contextMenuTouchId = null;
            touchMoveRemover();
            clearTimeout(tapholdTimer);
          },
              // Touchmove or touchend before that timer fires cancels the timer and removes these listeners.
          touchMoveRemover = EH.on({
            element: document,
            touchmove: cancelTapholdTimer,
            touchend: cancelTapholdTimer,
            pointermove: cancelTapholdTimer,
            pointerup: cancelTapholdTimer,
            capture: true
          });
        }
      };
    }
    /**
     * Private function to wrap the passed function. The returned wrapper function to be used as
     * a `touchend` handler which will call the passed function passing a fabricated `dblclick`
     * event if there is a `click` within 300ms.
     * @param {String|Function} handler The handler to call.
     * @param {Object} thisObj The owner of the function.
     * @private
     */

  }, {
    key: "createDblClickWrapper",
    value: function createDblClickWrapper(element, handler, me) {
      var startId, secondListenerDetacher, tapholdTimer;
      return function () {
        if (!secondListenerDetacher) {
          secondListenerDetacher = EH.on({
            element: element,
            // We only get here if a touchstart arrives within 300ms of a click
            touchstart: function touchstart(secondStart) {
              startId = secondStart.changedTouches[0].identifier; // Prevent zoom

              secondStart.preventDefault();
            },
            touchend: function touchend(secondClick) {
              if (secondClick.changedTouches[0].identifier === startId) {
                secondClick.preventDefault();
                clearTimeout(tapholdTimer);
                startId = secondListenerDetacher = null;
                var targetRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].from(secondClick.changedTouches[0].target, null, true),
                    offsetX = secondClick.changedTouches[0].pageX - targetRect.x,
                    offsetY = secondClick.changedTouches[0].pageY - targetRect.y,
                    dblclickEventConfig = Object.assign({
                  browserEvent: secondClick
                }, secondClick),
                    dblclickEvent = new MouseEvent('dblclick', dblclickEventConfig);
                Object.defineProperty(dblclickEvent, 'target', {
                  get: function get() {
                    return secondClick.target;
                  }
                });
                Object.defineProperty(dblclickEvent, 'offsetX', {
                  get: function get() {
                    return offsetX;
                  }
                });
                Object.defineProperty(dblclickEvent, 'offsetY', {
                  get: function get() {
                    return offsetY;
                  }
                });

                if (typeof handler === 'string') {
                  handler = me[handler];
                } // Call the wrapped handler passing the fabricated dblclick event


                handler.call(me, dblclickEvent);
              }
            },
            once: true
          }); // Cancel the second listener is there's no second click within <dblClickTime> milliseconds.

          tapholdTimer = setTimeout(function () {
            secondListenerDetacher();
            startId = secondListenerDetacher = null;
          }, EH.dblClickTime);
        }
      };
    }
  }, {
    key: "lockComposedPath",
    value: function lockComposedPath(event) {
      if (event.composedPath) {
        event.composedPath = function (path) {
          return function () {
            return path;
          };
        }(event.composedPath());
      }
    }
  }]);

  return EventHelper;
}();


var EH = EventHelper;
/**
 * The time in milliseconds for a `taphold` gesture to trigger a `contextmenu` event.
 * @member {Number} [longPressTime=500]
 * @readonly
 * @static
 */

EH.longPressTime = 500;
/**
 * The time in milliseconds within which a second touch tap event triggers a `dblclick` event.
 * @member {Number} [dblClickTime=300]
 * @readonly
 * @static
 */

EH.dblClickTime = 300; // Flag body if last user action used keyboard, used for focus styling etc.

EH.on({
  element: document,
  mousedown: function mousedown() {
    if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].isTouchEvent) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].usingKeyboard = false;
      document.body.classList.remove('b-using-keyboard');
    }
  },
  touchmove: function touchmove() {
    _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].usingKeyboard = false;
    document.body.classList.remove('b-using-keyboard');
  },
  keydown: function keydown() {
    _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].usingKeyboard = true;
    document.body.classList.add('b-using-keyboard');
  }
}); // When dragging on a touch device, we need to prevent scrolling from happening.
// Dragging only starts on a touchmove event, by which time it's too late to preventDefault
// on the touchstart event which started it.
// To do this we need a capturing, non-passive touchmove listener at the document level so we can preventDefault.
// This is in lieu of a functioning touch-action style on iOS Safari. When that's fixed, this will not be needed.

if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isTouchDevice) {
  EH.on({
    element: document,
    touchmove: function touchmove(event) {
      // If we're touching a b-dragging event, then stop any panning by preventing default.
      if (event.target.closest('.b-dragging')) {
        event.preventDefault();
      }
    },
    passive: false,
    capture: true
  });
} // Set up the GlobalEvents listeners for global focus events


Object(_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_15__["setupFocusListeners"])(document, EventHelper);
EventHelper._$name = 'EventHelper';

/***/ }),

/***/ "./lib/Core/helper/FunctionHelper.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/FunctionHelper.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FunctionHelper; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");






var productName = 'scheduler';

/**
 * @module Core/helper/FunctionHelper
 */

var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Provides functionality for working with functions
 * @internal
 */

var FunctionHelper = /*#__PURE__*/function () {
  function FunctionHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, FunctionHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(FunctionHelper, null, [{
    key: "after",

    /**
     * Inserts a function after the specified `method` is called on an `object`. To remove this hook, invoke the
     * function returned by this method.
     * ```
     *  class A {
     *      method() {
     *          console.log('method');
     *      }
     *  }
     *
     *  let instance = new A();
     *
     *  let detach = FunctionHelper.after(instance, 'method', () => { console.log('after') });
     *
     *  instance.method();
     *  > method
     *  > after
     *
     *  detach();
     *  instance.method();
     *  > method
     * ```
     * The value returned by the original method is passed as the first argument to `fn` followed by all the arguments
     * passed by the caller.
     *
     * If `fn` returns a value (not `undefined`), that value is returned from the method call instead of the value
     * returned by the original method.
     * ```
     *  class A {
     *      method(x) {
     *          console.log('method', x);
     *          return x * 2
     *      }
     *  }
     *
     *  let instance = new A();
     *
     *  let detach = FunctionHelper.after(instance, 'method', (ret, x) => {
     *      console.log('after', ret, x);
     *      return x / 2;
     *  });
     *
     *  console.log(instance.method(50));
     *  > method 50
     *  > after 100 50
     *  > 25
     *
     *  detach();
     *  console.log(instance.method(50));
     *  > method 50
     *  > 100
     * ```
     *
     * @param {Object} object The object to hook.
     * @param {String} method The name of the method on `object` to hook.
     * @param {Function|String} fn The function or method name (on `thisObj`) to call after `method`.
     * @param {Object} [thisObj] The `this` pointer value for calling `fn`.
     * @param {Object} [options] Additional options
     * @param {Boolean} [options.return=true] Specify `false` to not include the return value of the hooked method as
     * the first argument to `fn`.
     * @returns {Function} The function to call to remove the hook.
     */
    value: function after(object, method, fn, thisObj, options) {
      var named = typeof fn === 'string',
          withReturn = (options === null || options === void 0 ? void 0 : options.return) !== false,
          hook = function hook() {
        var _hook$$nextHook;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var // if object.destroy() occurs, our hook will be removed, so this fn won't be called in that case
        origResult = (_hook$$nextHook = hook.$nextHook).call.apply(_hook$$nextHook, [object].concat(args)),
            hookResult = (thisObj === null || thisObj === void 0 ? void 0 : thisObj.isDestroyed) ? undefined : withReturn ? named ? thisObj[fn].apply(thisObj, [origResult].concat(args)) : fn.call.apply(fn, [thisObj, origResult].concat(args)) : named ? thisObj[fn].apply(thisObj, args) : fn.call.apply(fn, [thisObj].concat(args));

        return hookResult === undefined ? origResult : hookResult;
      };

      return FunctionHelper.hookMethod(object, method, hook);
    }
    /**
     * Inserts a function before the specified `method` is called on an `object`. To remove this hook, invoke the
     * function returned by this method.
     * ```
     *  class A {
     *      method() {
     *          console.log('method');
     *      }
     *  }
     *
     *  let instance = new A();
     *
     *  let detach = FunctionHelper.before(instance, 'method', () => { console.log('before') });
     *
     *  instance.method();
     *  > before
     *  > method
     *
     *  detach();
     *  instance.method();
     *  > method
     * ```
     * If `fn` returns `false`, the original method is not invoked and `false` is returned to the caller.
     * ```
     *  class A {
     *      method(x) {
     *          console.log('method', x);
     *          return x * 2;
     *      }
     *  }
     *
     *  let instance = new A();
     *
     *  let detach = FunctionHelper.before(instance, 'method', x => {
     *      console.log('before', x);
     *      return false;
     *  });
     *
     *  console.log(instance.method(50));
     *  > before 50
     *  > false
     *
     *  detach();
     *  console.log(instance.method(50));
     *  > method 50
     *  > 100
     * ```
     *
     * @param {Object} object The object to hook.
     * @param {String} method The name of the method on `object` to hook.
     * @param {Function|String} fn The function or method name (on `thisObj`) to call before `method`.
     * @param {Object} [thisObj] The `this` pointer value for calling `fn`.
     * @returns {Function} The function to call to remove the hook.
     */

  }, {
    key: "before",
    value: function before(object, method, fn, thisObj) {
      var named = typeof fn === 'string',
          hook = function hook() {
        var _hook$$nextHook2;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var ret = (thisObj === null || thisObj === void 0 ? void 0 : thisObj.isDestroyed) ? 0 : named ? thisObj[fn].apply(thisObj, args) : fn.call.apply(fn, [thisObj].concat(args));
        return ret === false ? ret : (_hook$$nextHook2 = hook.$nextHook).call.apply(_hook$$nextHook2, [object].concat(args));
      };

      return FunctionHelper.hookMethod(object, method, hook);
    }
  }, {
    key: "curry",
    value: function curry(func) {
      return function curried() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        if (args.length >= func.length) {
          return func.apply(this, args);
        } else {
          return function () {
            for (var _len4 = arguments.length, args2 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              args2[_key4] = arguments[_key4];
            }

            return curried.apply(this, args.concat(args2));
          };
        }
      };
    }
  }, {
    key: "bindAll",
    value: function bindAll(obj) {
      for (var key in obj) {
        if (typeof obj[key] === 'function') {
          obj[key] = obj[key].bind(obj);
        }
      }
    }
    /**
     * Returns a function which calls the passed `interceptor` function first, and the passed `original` after
     * as long as the `interceptor` does not return `false`.
     * @param {Function} original The function to call second.
     * @param {Function} interceptor The function to call first.
     * @param {Object} [thisObj] The `this` reference when the functions are called.
     * @returns The return value from the `original` function **if it was called**, else `false`.
     */

  }, {
    key: "createInterceptor",
    value: function createInterceptor(original, interceptor, thisObj) {
      return function () {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }

        if (interceptor.call.apply(interceptor, [thisObj].concat(args)) !== false) {
          return original.call.apply(original, [thisObj].concat(args));
        }

        return false;
      };
    }
    /**
     * Returns a function which calls the passed `sequence` function after calling
     * the passed `original`.
     * @param {Function} original The function to call first.
     * @param {Function} sequence The function to call second.
     * @param {Object} [thisObj] The `this` reference when the functions are called.
     * @returns The value returned from the sequence if it returned a value, else the return
     * value from the original function.
     */

  }, {
    key: "createSequence",
    value: function createSequence(original, sequence, thisObj) {
      return function () {
        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }

        var origResult = original.call.apply(original, [thisObj].concat(args)),
            sequenceResult = sequence.call.apply(sequence, [thisObj].concat(args));
        return sequenceResult === undefined ? origResult : sequenceResult;
      };
    }
    /**
     * Create a "debounced" function which will call on the "leading edge" of a timer period.
     * When first invoked will call immediately, but invocations after that inside its buffer
     * period will be rejected, and *one* invocation will be made after the buffer period has expired.
     *
     * This is useful for responding immediately to a first mousemove, but from then on, only
     * calling the action function on a regular timer while the mouse continues to move.
     *
     * @param {Function} fn The function to call.
     * @param {Number} buffer The milliseconds to wait after each execution before another execution takes place.
     * @param {Object} [thisObj] `this` reference for the function.
     * @param {Array} [extraArgs] The argument list to append to those passed to the function.
     * @param {Function} [alt] A function to call when the invocation is rejected due to buffer time not having expired.
     */

  }, {
    key: "createThrottled",
    value: function createThrottled(fn, buffer, thisObj, extraArgs, alt) {
      var lastCallTime = 0,
          callArgs,
          timerId,
          result;

      var invoke = function invoke() {
        timerId = 0;
        lastCallTime = performance.now();
        callArgs.push.apply(callArgs, extraArgs);
        fn.apply(thisObj, callArgs);
      };

      result = function result() {
        var elapsed = performance.now() - lastCallTime;

        for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }

        callArgs = args; // If it's been more then the buffer period since we invoked, we can call it now

        if (elapsed >= buffer) {
          clearTimeout(timerId);
          invoke();
        } // Otherwise, kick off a timer for the requested period.
        else {
            if (!timerId) {
              timerId = setTimeout(invoke, buffer - elapsed);
            }

            if (alt) {
              callArgs.push.apply(callArgs, extraArgs);
              alt.apply(thisObj, callArgs);
            }
          }
      };

      result.cancel = function () {
        return clearTimeout(timerId);
      };

      return result;
    }
    /**
     * Create a "debounced" function which will call on the "trailing edge" of a timer period.
     * When first invoked will wait until the buffer period has expired to call the function, and
     * more calls within that time will restart the timer.
     *
     * This is useful for responding to keystrokes, but deferring action until the user pauses typing.
     *
     * @param {Function} fn The function to call.
     * @param {Number} buffer The milliseconds to wait after each execution before another execution takes place.
     * @param {Object} [thisObj] `this` reference for the function.
     * @param {Array} [args] The argument list to append to those passed to the function.
     */

  }, {
    key: "createBuffered",
    value: function createBuffered(fn, buffer, thisObj, args) {
      var callArgs, timerId, _result;

      var invoke = function invoke() {
        timerId = 0;
        _result.isPending = false;
        callArgs.push.apply(callArgs, args);
        fn.apply(thisObj, callArgs);
      };

      _result = function result() {
        for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          args[_key8] = arguments[_key8];
        }

        callArgs = args; // Cancel any impending invocation. It's pushed out for <buffer> ms from each call

        if (timerId) {
          clearTimeout(timerId);
        }

        _result.isPending = true;
        timerId = setTimeout(invoke, buffer);
      };

      _result.cancel = function () {
        _result.isPending = false;
        clearTimeout(timerId);
      };

      return _result;
    }
  }, {
    key: "hookMethod",
    value: function hookMethod(object, method, hook) {
      hook.$nextHook = object[method];
      object[method] = hook;
      return function () {
        // Object will have no hooks on the instance if it is destroyed (perhaps other reasons too)
        if (hasOwnProperty.call(object, method)) {
          var f = object[method],
              next;

          if (f === hook) {
            var _Object$getPrototypeO;

            // When this is the outermost hook, we may be the last hook. If $nextHook is found on the object's
            // prototype, simply delete the slot to expose it. Otherwise, there's another hook, so make it the
            // outermost.
            if (((_Object$getPrototypeO = Object.getPrototypeOf(object)) === null || _Object$getPrototypeO === void 0 ? void 0 : _Object$getPrototypeO[method]) === hook.$nextHook) {
              delete object[method];
            } else {
              object[method] = hook.$nextHook;
            }
          } else {
            // Not being the outermost hook means we have outer hooks that should chain to the one we want to
            // remove. Be cautious because the object could be destroyed.
            for (; next = (_f = f) === null || _f === void 0 ? void 0 : _f.$nextHook; f = next) {
              var _f;

              if (next === hook) {
                f.$nextHook = hook.$nextHook;
                break;
              }
            }
          }
        }
      };
    }
  }, {
    key: "returnTrue",
    value: function returnTrue() {
      return true;
    }
  }, {
    key: "animate",
    value: function animate(duration, fn, thisObj) {
      var _this = this;

      var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'linear';
      var cancel = false;
      var result = new Promise(function (resolve) {
        var start = performance.now(),
            iterate = function iterate() {
          var progress = Math.min((performance.now() - start) / duration, 1),
              delayable = thisObj && thisObj.setTimeout ? thisObj : window;

          if (!cancel) {
            if (fn.call(thisObj, _this.easingFunctions[easing](progress)) === false) {
              resolve();
            }
          }

          if (cancel || progress === 1) {
            // Push resolution into the next animation frame so that
            // this frame completes before the resolution handler runs.
            delayable.requestAnimationFrame(function () {
              return resolve();
            });
          } else {
            delayable.requestAnimationFrame(iterate);
          }
        };

        iterate();
      });

      result.cancel = function () {
        cancel = true;
        return false;
      };

      return result;
    }
  }]);

  return FunctionHelper;
}();
/* eslint-disable */



var half = 0.5,
    e1 = 1.70158,
    e2 = 7.5625,
    e3 = 1.525,
    e4 = 2 / 2.75,
    e5 = 2.25 / 2.75,
    e6 = 1 / 2.75,
    e7 = 1.5 / 2.75,
    e8 = 2.5 / 2.75,
    e9 = 2.625 / 2.75,
    e10 = 0.75,
    e11 = 0.9375,
    e12 = 0.984375;
FunctionHelper.easingFunctions = {
  linear: function linear(t) {
    return t;
  },
  easeInQuad: function easeInQuad(t) {
    return Math.pow(t, 2);
  },
  easeOutQuad: function easeOutQuad(t) {
    return -(Math.pow(t - 1, 2) - 1);
  },
  easeInOutQuad: function easeInOutQuad(t) {
    return (t /= half) < 1 ? half * Math.pow(t, 2) : -half * ((t -= 2) * t - 2);
  },
  easeInCubic: function easeInCubic(t) {
    return Math.pow(t, 3);
  },
  easeOutCubic: function easeOutCubic(t) {
    return Math.pow(t - 1, 3) + 1;
  },
  easeInOutCubic: function easeInOutCubic(t) {
    return (t /= half) < 1 ? half * Math.pow(t, 3) : half * (Math.pow(t - 2, 3) + 2);
  },
  easeInQuart: function easeInQuart(t) {
    return Math.pow(t, 4);
  },
  easeOutQuart: function easeOutQuart(t) {
    return -(Math.pow(t - 1, 4) - 1);
  },
  easeInOutQuart: function easeInOutQuart(t) {
    return (t /= half) < 1 ? half * Math.pow(t, 4) : -half * ((t -= 2) * Math.pow(t, 3) - 2);
  },
  easeInQuint: function easeInQuint(t) {
    return Math.pow(t, 5);
  },
  easeOutQuint: function easeOutQuint(t) {
    return Math.pow(t - 1, 5) + 1;
  },
  easeInOutQuint: function easeInOutQuint(t) {
    return (t /= half) < 1 ? half * Math.pow(t, 5) : half * (Math.pow(t - 2, 5) + 2);
  },
  easeInSine: function easeInSine(t) {
    return -Math.cos(t * (Math.PI / 2)) + 1;
  },
  easeOutSine: function easeOutSine(t) {
    return Math.sin(t * (Math.PI / 2));
  },
  easeInOutSine: function easeInOutSine(t) {
    return -half * (Math.cos(Math.PI * t) - 1);
  },
  easeInExpo: function easeInExpo(t) {
    return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
  },
  easeOutExpo: function easeOutExpo(t) {
    return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
  },
  easeInOutExpo: function easeInOutExpo(t) {
    return t === 0 ? 0 : t === 1 ? 1 : (t /= half) < 1 ? half * Math.pow(2, 10 * (t - 1)) : half * (-Math.pow(2, -10 * --t) + 2);
  },
  easeInCirc: function easeInCirc(t) {
    return -(Math.sqrt(1 - t * t) - 1);
  },
  easeOutCirc: function easeOutCirc(t) {
    return Math.sqrt(1 - Math.pow(t - 1, 2));
  },
  easeInOutCirc: function easeInOutCirc(t) {
    return (t /= half) < 1 ? -half * (Math.sqrt(1 - t * t) - 1) : half * (Math.sqrt(1 - (t -= 2) * t) + 1);
  },
  easeOutBounce: function easeOutBounce(t) {
    return t < e6 ? e2 * t * t : t < e4 ? e2 * (t -= e7) * t + e10 : t < e8 ? e2 * (t -= e5) * t + e11 : e2 * (t -= e9) * t + e12;
  },
  easeInBack: function easeInBack(t) {
    return t * t * ((e1 + 1) * t - e1);
  },
  easeOutBack: function easeOutBack(t) {
    return (t = t - 1) * t * ((e1 + 1) * t + e1) + 1;
  },
  easeInOutBack: function easeInOutBack(t) {
    var s = 1.70158;
    return (t /= half) < 1 ? half * (t * t * (((s *= e3) + 1) * t - s)) : half * ((t -= 2) * t * (((s *= e3) + 1) * t + s) + 2);
  },
  elastic: function elastic(t) {
    return -1 * Math.pow(4, -8 * t) * Math.sin((t * 6 - 1) * (2 * Math.PI) / 2) + 1;
  },
  swingFromTo: function swingFromTo(t) {
    var s = 1.70158;
    return (t /= half) < 1 ? half * (t * t * (((s *= e3) + 1) * t - s)) : half * ((t -= 2) * t * (((s *= e3) + 1) * t + s) + 2);
  },
  swingFrom: function swingFrom(t) {
    return t * t * ((e1 + 1) * t - e1);
  },
  swingTo: function swingTo(t) {
    return (t -= 1) * t * ((e1 + 1) * t + e1) + 1;
  },
  bounce: function bounce(t) {
    return t < e6 ? e2 * t * t : t < e4 ? e2 * (t -= e7) * t + e10 : t < e8 ? e2 * (t -= e5) * t + e11 : e2 * (t -= e9) * t + e12;
  },
  bouncePast: function bouncePast(t) {
    return t < e6 ? e2 * t * t : t < e4 ? 2 - (e2 * (t -= e7) * t + e10) : t < e8 ? 2 - (e2 * (t -= e5) * t + e11) : 2 - (e2 * (t -= e9) * t + e12);
  },
  easeFromTo: function easeFromTo(t) {
    return (t /= half) < 1 ? half * Math.pow(t, 4) : -half * ((t -= 2) * Math.pow(t, 3) - 2);
  },
  easeFrom: function easeFrom(t) {
    return Math.pow(t, 4);
  },
  easeTo: function easeTo(t) {
    return Math.pow(t, 0.25);
  }
};
FunctionHelper._$name = 'FunctionHelper';

/***/ }),

/***/ "./lib/Core/helper/IdHelper.js":
/*!*************************************!*\
  !*** ./lib/Core/helper/IdHelper.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return IdHelper; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);


var productName = 'scheduler';
/**
* @module Core/helper/IdHelper
*/

/**
 * IdHelper provides unique ID generation.
 *
 * This class is not intended for application use, it is used internally by the Bryntum infrastructure.
 * @internal
 */

var IdHelper = /*#__PURE__*/function () {
  function IdHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, IdHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(IdHelper, null, [{
    key: "generateId",

    /**
     * Generate a new id, using IdHelpers internal counter and a prefix
     * @param {String} prefix Id prefix
     * @returns {String} Generated id
     */
    value: function generateId() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'generatedId';
      // This produces "b-foo-1, b-foo-2, ..." for each prefix independently of the others. In other words, it makes
      // id's more stable since the counter is on a per-class basis.
      return prefix + (IdHelper.idCounts[prefix] = (IdHelper.idCounts[prefix] || 0) + 1);
    }
  }]);

  return IdHelper;
}();


IdHelper.idCounts = {};
IdHelper._$name = 'IdHelper';

/***/ }),

/***/ "./lib/Core/helper/ObjectHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/ObjectHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ObjectHelper; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_number_to_fixed__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.number.to-fixed */ "./node_modules/core-js/modules/es.number.to-fixed.js");
/* harmony import */ var core_js_modules_es_number_to_fixed__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_to_fixed__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _util_Objects_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _DateHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./DateHelper.js */ "./lib/Core/helper/DateHelper.js");





































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
 // NOTE: This import prevents this module from being imported by Base (or anything Base imports):


var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * @module Core/helper/ObjectHelper
 */

var typeOf = function typeOf(value) {
  var baseType = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_35___default()(value); // If not atomic type, we handle date or null


  if (baseType === 'object') {
    if (value === null) {
      return 'null';
    }

    if (Object.prototype.toString.call(value) === '[object Date]') {
      return 'date';
    }
  }

  return baseType;
}; // Detect if browser has bad implementation of toFixed()


var toFixedFix = 1.005.toFixed(2) === '1.01' ? null : function (number, fractionDigits) {
  var split = number.toString().split('.'),
      newNumber = +(!split[1] ? split[0] : split.join('.') + '1');
  return number.toFixed.call(newNumber, fractionDigits);
};
/**
 * Helper for Object manipulation.
 */

var ObjectHelper = /*#__PURE__*/function (_Objects) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default()(ObjectHelper, _Objects);

  var _super = _createSuper(ObjectHelper);

  function ObjectHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default()(this, ObjectHelper);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default()(ObjectHelper, null, [{
    key: "transformArrayToNamedObject",
    // These methods are inherited from Objects (an internal class) but need to be documented here for public use.
    // This is primarily because static methods, while inherited by JavaScript classes, are not displayed in derived
    // classes in the docs.

    /**
     * Copies all enumerable properties from the supplied source objects to `dest`. Unlike `Object.assign`, this copy
     * also includes inherited properties.
     * @param {Object} dest The destination object.
     * @param {...Object} sources The source objects.
     * @returns {Object} The `dest` object.
     * @method assign
     * @static
     */

    /**
     * Copies all enumerable properties from the supplied source objects to `dest`, only including properties that does
     * not already exist on `dest`. Unlike `Object.assign`, this copy also includes inherited properties.
     * @param {Object} dest The destination object.
     * @param {...Object} sources The source objects.
     * @returns {Object} The `dest` object.
     * @method assignIf
     * @static
     */

    /**
     * Creates a deep copy of the `value`. Simple objects ({@link #function-isObject-static}, arrays and `Date` objects
     * are cloned. The enumerable properties of simple objects and the elements of arrays are cloned recursively.
     * @param {*} value The value to clone.
     * @param {Function} [handler] An optional function to call for values of types other than simple object, array or
     * `Date`. This function should return the clone of the `value` passed to it. It is only called for truthy values
     * whose `typeof` equals `'object'`.
     * @param {*} handler.value The value to clone.
     * @returns {*} The cloned value.
     * @method clone
     * @static
     */

    /**
     * Converts a list of names (either a space separated string or an array), into an object with those properties
     * assigned truthy values. The converse of {@link #function-getTruthyKeys-static}.
     * @param {String|String[]} source The list of names to convert to object form.
     * @method createTruthyKeys
     * @static
     */

    /**
     * Gathers the names of properties which have truthy values into an array.
     *
     * This is useful when gathering CSS class names for complex element production.
     * Instead of appending to an array or string which may already contain the
     * name, and instead of contending with space separation and concatenation
     * and conditional execution, just set the properties of an object:
     *
     *     cls = {
     *         [this.selectedCls] : this.isSelected(thing),
     *         [this.dirtyCls] : this.isDirty(thing)
     *     };
     *
     * @param {Object} source Source of keys to gather into an array.
     * @returns {String[]} The keys which had a truthy value.
     * @method getTruthyKeys
     * @static
     */

    /**
     * Gathers the values of properties which are truthy into an array.
     * @param {Object} source Source of values to gather into an array.
     * @returns {String[]} The truthy values from the passed object.
     * @method getTruthyValues
     * @static
     */

    /**
     * Tests whether a passed object has any enumerable properties.
     * @param {Object} object
     * @returns {Boolean} `true` if the passed object has no enumerable properties.
     * @method isEmpty
     * @static
     */

    /**
     * Returns `true` if the `value` is a simple `Object`.
     * @param {Object} value
     * @returns {Boolean} `true` if the `value` is a simple `Object`.
     * @method isObject
     * @static
     */

    /**
     * Copies all enumerable properties from the supplied source objects to `dest`, recursing when the properties of
     * both the source and `dest` are objects.
     * ```
     *  const o = {
     *      a : 1,
     *      b : {
     *          c : 2
     *      }
     *  };
     *  const o2 = {
     *      b : {
     *          d : 3
     *      }
     *  }
     *
     *  console.log(merge(o, o2));
     *
     *  > { a : 1, b : { c : 2, d : 3 } }
     * ```
     * @param {Object} dest The destination object.
     * @param {...Object} sources The source objects.
     * @returns {Object} The `dest` object.
     * @method merge
     * @static
     */

    /**
     * Returns the specific type of the given `value`. Unlike the `typeof` operator, this function returns the text
     * from the `Object.prototype.toString` result allowing `Date`, `Array`, `RegExp`, and others to be differentiated.
     * ```
     *  console.log(typeOf(null));
     *  > null
     *
     *  console.log(typeOf({}));
     *  > object
     *
     *  console.log(typeOf([]));
     *  > array
     *
     *  console.log(typeOf(new Date()));
     *  > date
     *
     *  console.log(typeOf(NaN));
     *  > nan
     *
     *  console.log(typeOf(/a/));
     *  > regexp
     * ```
     * @param {*} value
     * @returns {String}
     * @method typeOf
     * @static
     */

    /**
     * Returns value for a given path in the object
     * @param {Object} object Object to check path on
     * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
     * @returns {*} Value associated with passed key
     * @method getPath
     * @static
     */

    /**
     * Sets value for a given path in the object
     * @param {Object} object Target object
     * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
     * @param {*} value Value for a given path
     * @returns {Object} Returns passed object
     * @method setPath
     * @static
     */

    /**
     * Creates a new object where key is a property in array item (`ref` by default) or index in the array and value is array item.
     *
     * From:
     * ```
     * [
     *     {
     *          text : 'foo',
     *          ref : 'fooItem'
     *     },
     *     {
     *          text : 'bar'
     *     }
     * ]
     * ```
     *
     * To:
     * ```
     * {
     *     fooItem : {
     *         text : 'foo',
     *         ref  : 'fooItem'
     *     },
     *     1 : {
     *         text : 'bar'
     *     }
     * }
     * ```
     *
     * @param {Object[]} arrayOfItems Array to transform.
     * @param {String} [prop] Property to read the key from. `ref` by default.
     * @returns {Object} namedItems
     */
    value: function transformArrayToNamedObject(arrayOfItems) {
      var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ref';
      var namedItems = {};
      arrayOfItems.forEach(function (item, index) {
        var // 0 is valid value, but empty string in not valid
        key = item[prop] != null && item[prop].toString().length ? item[prop] : index;
        namedItems[key] = item;
      });
      return namedItems;
    }
    /**
     * Creates a new array from object values and saves key in a property (`ref` by default) of each item.
     *
     * From:
     * ```
     * {
     *     fooItem : {
     *         text : 'foo'
     *     },
     *     1 : {
     *         text : 'bar'
     *     },
     *     barItem : false // will be ignored
     * }
     * ```
     *
     * To:
     * ```
     * [
     *     {
     *          text : 'foo',
     *          ref : 'fooItem'
     *     },
     *     {
     *          text : 'bar',
     *          ref : 1
     *     }
     * ]
     * ```
     *
     * @param {Object} namedItems Object to transform.
     * @param {String} [prop] Property to save the key to. `ref` by default.
     * @returns {Object[]} arrayOfItems
     */

  }, {
    key: "transformNamedObjectToArray",
    value: function transformNamedObjectToArray(namedItems) {
      var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ref';
      return Object.keys(namedItems).filter(function (key) {
        return namedItems[key];
      }).map(function (key) {
        var item = namedItems[key];
        item[prop] = key;
        return item;
      });
    }
    /**
     * Checks if two values are equal. Basically === but special handling of dates.
     * @param a First value
     * @param b Second value
     * @returns {*} true if values are equal, otherwise false
     */

  }, {
    key: "isEqual",
    value: function isEqual(a, b) {
      var useIsDeeply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // Eliminate null vs undefined mismatch
      if (a === null && b !== null || a === undefined && b !== undefined || b === null && a !== null || b === undefined && a !== undefined) {
        return false;
      } // Covers undefined === undefined and null === null, since mismatches are elminated above


      if (a == null && b == null) {
        return true;
      } // The same instance should equal itself.


      if (a === b) {
        return true;
      }

      var typeA = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_35___default()(a),
          typeB = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_35___default()(b);

      if (typeA === typeB) {
        switch (typeA) {
          case 'number':
          case 'string':
          case 'boolean':
            return a === b;
        }

        switch (true) {
          case a instanceof Date && b instanceof Date:
            // faster than calling DateHelper.isEqual
            // https://jsbench.me/3jk2bom2r3/1
            return a.getTime() === b.getTime();

          case Array.isArray(a) && Array.isArray(b):
            return a.length === b.length ? a.every(function (v, idx) {
              return OH.isEqual(v, b[idx], useIsDeeply);
            }) : false;

          case typeA === 'object' && a.constructor.prototype === b.constructor.prototype:
            return useIsDeeply ? OH.isDeeplyEqual(a, b, useIsDeeply) : JSON.stringify(a) === JSON.stringify(b);
        }
      }

      return String(a) === String(b);
    }
    /**
     * Checks if two objects are deeply equal
     * @param {Object} a
     * @param {Object} b
     * @param {Object} [options] Additional comparison options
     * @param {Object} [options.ignore] Map of property names to ignore when comparing
     * @param {Function} [options.shouldEvaluate] Function used to evaluate if a property should be compared or not.
     * Return false to prevent comparision
     * @param {Function} [options.evaluate] Function used to evaluate equality. Return `true`/`false` as evaluation
     * result or anything else to let `isEqual` handle the comparision
     * @returns {Boolean}
     */

  }, {
    key: "isDeeplyEqual",
    value: function isDeeplyEqual(a, b) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // TODO : When syncing to DOM, it first checks the outermost config for equality with the previously used one
      //  and then drills downs for each task. If lets say the third task was changed, the two prior have already been
      //  determined to be equal before drilling down. That check could be persisted on the incoming object (a) to
      //  skip comparing it again on the more detailed level. Since (a) in this case is regenerated on ech draw there
      //  is no risk of polluting the next render
      // Same object, equal :)
      if (a === b) {
        return true;
      } // Nothing to compare, not equal


      if (!a || !b) {
        return false;
      } // Property names excluding ignored


      var aKeys = OH.keys(a, options.ignore),
          bKeys = OH.keys(b, options.ignore); // Property count differs, not equal

      if (aKeys.length !== bKeys.length) {
        return false;
      }

      for (var i = 0; i < aKeys.length; i++) {
        var aKey = aKeys[i],
            bKey = bKeys[i]; // Property name differs, not equal

        if (aKey !== bKey) {
          return false;
        }

        var aVal = a[aKey],
            bVal = b[bKey]; // Allow caller to determine if property values should be evaluated or not
        // TODO: Not currently used

        if (options.shouldEvaluate) {
          if (options.shouldEvaluate(aKey, {
            value: aVal,
            object: a
          }, {
            value: bVal,
            object: b
          }) === false) {
            continue;
          }
        } // Allow caller to determine equality of properties


        if (options.evaluate) {
          var result = options.evaluate(aKey, {
            value: aVal,
            object: a
          }, {
            value: bVal,
            object: b
          }); // Not equal

          if (result === false) {
            return false;
          } // Equal, skip isEqual call below


          if (result === true) {
            continue;
          }
        } // Values differ, not equal (also digs deeper)


        if (!OH.isEqual(aVal, bVal, options)) {
          return false;
        }
      } // Found to be equal


      return true;
    }
    /**
     * Checks if value B is partially equal to value A.
     * @param a First value
     * @param b Second value
     * @returns {Boolean} true if values are partially equal, false otherwise
     */

  }, {
    key: "isPartial",
    value: function isPartial(a, b) {
      a = String(a).toLowerCase();
      b = String(b).toLowerCase();
      return a.indexOf(b) != -1;
    }
    /**
     * Checks if value a is smaller than value b.
     * @param a First value
     * @param b Second value
     * @returns {Boolean} true if a < b
     */

  }, {
    key: "isLessThan",
    value: function isLessThan(a, b) {
      if (a instanceof Date && b instanceof Date) {
        return _DateHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].isBefore(a, b);
      }

      return a < b;
    }
    /**
     * Checks if value a is bigger than value b.
     * @param a First value
     * @param b Second value
     * @returns {Boolean} true if a > b
     */

  }, {
    key: "isMoreThan",
    value: function isMoreThan(a, b) {
      if (a instanceof Date && b instanceof Date) {
        return _DateHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].isAfter(a, b);
      }

      return a > b;
    }
    /**
     * Used by the Base class to make deep copies of defaultConfig blocks
     * @private
     */

  }, {
    key: "fork",
    value: function fork(obj) {
      var ret, key, value;

      if (obj && obj.constructor === Object) {
        ret = Object.setPrototypeOf({}, obj);

        for (key in obj) {
          value = obj[key];

          if (value) {
            if (value.constructor === Object) {
              ret[key] = OH.fork(value);
            } else if (value instanceof Array) {
              ret[key] = value.slice();
            }
          }
        }
      } else {
        ret = obj;
      }

      return ret;
    }
    /**
     * Copies the named properties from the `source` parameter into the `dest` parameter.
     * @param {Object} dest The destination into which properties are copied.
     * @param {Object} source The source from which properties are copied.
     * @param {String[]} props The list of property names.
     * @returns The `dest` object.
     */

  }, {
    key: "copyProperties",
    value: function copyProperties(dest, source, props) {
      var prop, i;

      for (i = 0; i < props.length; i++) {
        prop = props[i];

        if (prop in source) {
          dest[prop] = source[prop];
        }
      }

      return dest;
    }
    /**
     * Copies the named properties from the `source` parameter into the `dest` parameter
     * unless the property already exists in the `dest`.
     * @param {Object} dest The destination into which properties are copied.
     * @param {Object} source The source from which properties are copied.
     * @param {String[]} props The list of property names.
     * @returns The `dest` object.
     */

  }, {
    key: "copyPropertiesIf",
    value: function copyPropertiesIf(dest, source, props) {
      if (source) {
        var _iterator = _createForOfIteratorHelper(props),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var prop = _step.value;

            if (!(prop in dest)) {
              dest[prop] = source[prop];
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return dest;
    }
    /**
     * Returns an array containing all enumerable property names from every prototype level for the object.
     * @param {Object} object Object to retrieve property names from
     * @param {Object} [ignore] Optional map of names to ignore
     * @returns {String[]} All keys from every prototype level.
     */

  }, {
    key: "keys",
    value: function keys(object) {
      var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var result = [];

      for (var p in object) {
        if (!ignore || !ignore[p]) {
          result.push(p);
        }
      }

      return result;
    }
    /**
     * Returns an array of a given object's properties names including properties in
     * all superclasses, in the same order as we get with a normal loop.
     * @param {Object} object An object which may have properties in a prototype
     * chain, such as a configuration (These are chained because of inheritance).
     * @returns {String[]} The property names.
     */

  }, {
    key: "allKeys",
    value: function allKeys(object) {
      var result = [];

      for (var k in object) {
        result.push(k);
      }

      return result;
    }
    /**
     * Checks if a given path exists in an object
     * @param {Object} object Object to check path on
     * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
     * @returns {Boolean} Returns `true` if path exists or `false` if it does not
     */

  }, {
    key: "pathExists",
    value: function pathExists(object, path) {
      var properties = path.split('.');
      return properties.every(function (property) {
        if (!(property in object)) {
          return false;
        }

        object = object[property];
        return true;
      });
    }
    /**
     * Creates a simple single level key-value object from complex deep object.
     * @param {Object} object Object to extract path and values from
     * @returns {Object} Key-value object where key is a path to the corresponding value
     * @internal
     *
     * ```javascript
     * // converts deep object
     * {
     *     foo : {
     *         bar : {
     *             test : 1
     *         }
     *     }
     * }
     * // into a single level object
     * {
     *     'foo.bar.test' : 1
     * }
     * ```
     */

  }, {
    key: "pathifyKeys",
    value: function pathifyKeys(object) {
      var result = {};

      for (var key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          if (object[key] instanceof Object) {
            var paths = this.pathifyKeys(object[key]);

            for (var path in paths) {
              result["".concat(key, ".").concat(path)] = paths[path];
            }
          } else {
            result[key] = object[key];
          }
        }
      }

      return result;
    }
    /**
     * Removes value for a given path in the object. Doesn't cleanup empty objects.
     * @param {Object} object
     * @param {String} path Dot-separated path, e.g. `obj.child.someKey`
     * @internal
     */

  }, {
    key: "deletePath",
    value: function deletePath(object, path) {
      path.split('.').reduce(function (result, key, index, array) {
        if (result == null) {
          return null;
        } else if (Object.hasOwnProperty.call(result, key)) {
          if (index === array.length - 1) {
            delete result[key];
          } else {
            return result[key];
          }
        }
      }, object);
    }
  }, {
    key: "coerce",
    value: function coerce(from, to) {
      var fromType = typeOf(from),
          toType = typeOf(to),
          isString = typeof from === 'string';

      if (fromType !== toType) {
        switch (toType) {
          case 'string':
            return String(from);

          case 'number':
            return Number(from);

          case 'boolean':
            // See http://ecma262-5.com/ELS5_HTML.htm#Section_11.9.3 as to why '0'.
            // TL;DR => ('0' == 0), so if given string '0', we must return boolean false.
            return isString && (!from || from === 'false' || from === '0') ? false : Boolean(from);

          case 'null':
            return isString && (!from || from === 'null') ? null : false;

          case 'undefined':
            return isString && (!from || from === 'undefined') ? undefined : false;

          case 'date':
            return isString && isNaN(from) ? _DateHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].parse(from) : Date(Number(from));
        }
      }

      return from;
    }
  }, {
    key: "wrapProperty",
    value: function wrapProperty(object, propertyName, newGetter, newSetter) {
      var deep = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var newProperty = {};
      var proto = Object.getPrototypeOf(object),
          existingProperty = Object.getOwnPropertyDescriptor(proto, propertyName);

      while (!existingProperty && proto && deep) {
        proto = Object.getPrototypeOf(proto);

        if (proto) {
          existingProperty = Object.getOwnPropertyDescriptor(proto, propertyName);
        }
      }

      if (existingProperty) {
        if (existingProperty.set) {
          newProperty.set = function (v) {
            existingProperty.set.call(object, v); // Must invoke the getter in case "v" has been transformed.

            newSetter && newSetter.call(object, existingProperty.get.call(object));
          };
        } else {
          newProperty.set = newSetter;
        }

        if (existingProperty.get) {
          newProperty.get = function () {
            var result = existingProperty.get.call(object);

            if (newGetter) {
              result = newGetter.call(object, result);
            }

            return result;
          };
        } else {
          newProperty.get = newGetter;
        }
      } else {
        newProperty.set = function (v) {
          object["_".concat(propertyName)] = v;
          newSetter && newSetter.call(object, v);
        };

        newProperty.get = function () {
          var result = object["_".concat(propertyName)];

          if (newGetter) {
            result = newGetter.call(object, result);
          }

          return result;
        };
      }

      Object.defineProperty(object, propertyName, newProperty);
    }
    /**
     * Finds a property descriptor for the passed object from all inheritance levels.
     * @param {Object} object The Object whose property to find.
     * @param {String} propertyName The name of the property to find.
     * @returns {Object} An ECMA property descriptor is the property was found, otherwise `null`
     */

  }, {
    key: "getPropertyDescriptor",
    value: function getPropertyDescriptor(object, propertyName) {
      var result = null;

      for (var o = object; o && !result && !hasOwnProperty.call(o, 'isBase'); o = Object.getPrototypeOf(o)) {
        result = Object.getOwnPropertyDescriptor(o, propertyName);
      }

      return result;
    }
    /**
     * Changes the passed object and removes all null and undefined properties from it
     * @param {Object} object Target object
     * @param {Boolean} [keepNull] Pass true to only remove undefined properties
     * @returns {Object} Passed object
     */

  }, {
    key: "cleanupProperties",
    value: function cleanupProperties(object) {
      var keepNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      Object.entries(object).forEach(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_29___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (keepNull) {
          value === undefined && delete object[key];
        } else {
          value == null && delete object[key];
        }
      });
      return object;
    }
    /**
     * Changes the passed object and removes all properties from it.
     * Used while mutating when need to keep reference to the object but replace its properties.
     * @param {Object} object Target object
     * @returns {Object} Passed object
     */

  }, {
    key: "removeAllProperties",
    value: function removeAllProperties(obj) {
      Object.keys(obj).forEach(function (key) {
        return delete obj[key];
      });
      return obj;
    }
    /**
     * Checks that the supplied value is of the specified type. Throws if it is not
     * @param {Object} value Value to check type of
     * @param {String} type Expected type
     * @param {String} name Name of the value, used in error message
     */

  }, {
    key: "assertType",
    value: function assertType(value, type, name) {
      // eslint-disable-next-line valid-typeof
      if (value != null && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_35___default()(value) !== type) {
        throw new Error("Incorrect type \"".concat(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_35___default()(value), "\" for ").concat(name, ", expected \"").concat(type, "\""));
      }
    }
    /**
     * Checks that the supplied value is a number.  Throws if it is not
     * @param {Object} value Value to check type of
     * @param {String} name Name of the value, used in error message
     */

  }, {
    key: "assertNumber",
    value: function assertNumber(value, name) {
      var asNumber = Number(value);

      if (typeof value !== 'number' || isNaN(asNumber)) {
        throw new Error("Incorrect type for ".concat(name, ", got \"").concat(value, "\" (expected a Number)"));
      }
    }
    /**
     * Checks that the supplied value is a boolean.  Throws if it is not
     * @param {Object} value Value to check type of
     * @param {String} name Name of the value, used in error message
     */

  }, {
    key: "assertBoolean",
    value: function assertBoolean(value, name) {
      OH.assertType(value, 'boolean', name);
    }
    /**
     * Number.toFixed(), with polyfill for browsers that needs it
     * @param {Number} number
     * @param {Number} digits
     * @returns {String} A fixed point string representation of the passed number.
     */

  }, {
    key: "toFixed",
    value: function toFixed(number, digits) {
      if (toFixedFix) {
        return toFixedFix(number, digits);
      }

      return number.toFixed(digits);
    }
    /**
     * Round the passed number to closest passed step value.
     * @param {Number} number The number to round.
     * @param {Number} [step] The step value to round to.
     * @returns {Number} The number rounded to the closest step.
     */

  }, {
    key: "roundTo",
    value: function roundTo(number) {
      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return Math.round(number / step) * step;
    }
    /**
     * Round the passed number to the passed number of decimals.
     * @param {Number} number The number to round.
     * @param {Number} digits The number of decimal places to round to.
     * @returns {Number} The number rounded to the passed number of decimal places.
     */

  }, {
    key: "round",
    value: function round(number, digits) {
      // Undefined or null means do not round. NOT round to no decimals.
      if (digits == null) {
        return number;
      }

      var factor = Math.pow(10, digits);
      return Math.round(number * factor) / factor;
    }
    /**
     * Check if passed object is a Promise which contains `then` method.
     * Used to fix problems with detecting promises with `obj instanceof Promise` in code when Promise class is replaced with any other implementation.
     * Related to this issue https://github.com/bryntum/support/issues/791
     * @param obj Promise object to check
     * @returns {Boolean} truthy value if object is Promise
     * @internal
     */

  }, {
    key: "isPromise",
    value: function isPromise(obj) {
      return typeof (obj === null || obj === void 0 ? void 0 : obj.then) === 'function';
    }
  }]);

  return ObjectHelper;
}(_util_Objects_js__WEBPACK_IMPORTED_MODULE_36__["default"]);


var OH = ObjectHelper;
ObjectHelper._$name = 'ObjectHelper';

/***/ }),

/***/ "./lib/Core/helper/ResizeHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/ResizeHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResizeHelper; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





 //TODO: add pointer events support

var documentListeners = {
  down: 'onMouseDown',
  move: 'onMouseMove',
  up: 'onMouseUp',
  docclick: 'onDocumentClick',
  touchstart: 'onTouchStart',
  touchmove: 'onTouchMove',
  touchend: 'onTouchEnd',
  keydown: 'onKeyDown'
};
/**
 * @module Core/helper/ResizeHelper
 */

/**
 * Handles resizing of elements using handles. Handles can be actual elements or virtual handles specified as a border
 * area on elements left and right edges.
 *
 * ```
 * // enable resizing all elements with class 'resizable'
 * let resizer = new ResizeHelper({
 *   targetSelector: '.resizable'
 * });
 * ```
 *
 * @mixes Core/mixin/Events
 * @internal
 */

var ResizeHelper = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ResizeHelper, _Events);

  var _super = _createSuper(ResizeHelper);

  function ResizeHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ResizeHelper);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ResizeHelper, [{
    key: "construct",
    //endregion
    //region Events

    /**
     * Fired while dragging
     * @event resizing
     * @param {Core.helper.ResizeHelper} source
     * @param {Object} context Resize context
     * @param {MouseEvent} event Browser event
     */

    /**
     * Fired when dragging starts.
     * @event resizeStart
     * @param {Core.helper.ResizeHelper} source
     * @param {Object} context Resize context
     * @param {MouseEvent|TouchEvent} event Browser event
     */

    /**
     * Fires after resize, and allows for asynchronous finalization by setting 'async' to `true` on the context object.
     * @event resize
     * @param {Core.helper.ResizeHelper} source
     * @param {Object} context Context about the resize operation. Set 'async' to `true` to indicate asynchronous validation of the resize flow (for showing a confirmation dialog etc)
     */

    /**
     * Fires when a resize is canceled (width is unchanged)
     * @event cancel
     * @param {Core.helper.ResizeHelper} source
     * @param {Object} context Resize context
     * @param {MouseEvent|TouchEvent} event Browser event
     */
    //endregion
    //region Init
    value: function construct(config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ResizeHelper.prototype), "construct", this).call(this, config); // Larger grabbable zones on touch devices


      if (!me.handleSelector && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isTouchDevice) {
        me.handleSize = me.touchHandleSize;
      }

      me.handleVisibilityThreshold = me.handleVisibilityThreshold || 2 * me.handleSize;
      me.initListeners();
      me.initResize();
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.abort(true);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ResizeHelper.prototype), "doDestroy", this).call(this);
    }
    /**
     * Initializes resizing
     * @private
     */

  }, {
    key: "initResize",
    value: function initResize() {
      var me = this;

      if (!me.isElementResizable && me.targetSelector) {
        me.isElementResizable = function (element) {
          return _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(element, me.targetSelector);
        };
      }

      if (me.grab) {
        var _me$grab = me.grab,
            edge = _me$grab.edge,
            element = _me$grab.element,
            event = _me$grab.event;
        me.startEvent = event;
        var cursorOffset = me.getCursorOffsetToElementEdge(event, element, edge); // emulates mousedown & grabResize

        me.context = {
          element: element,
          edge: edge,
          valid: true,
          async: false,
          elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateX(element) || element.offsetLeft,
          // extract x from translate
          elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateY(element) || element.offsetTop,
          // extract x from translate
          newX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateX(element) || element.offsetLeft,
          // No change yet on start, but info must be present
          newY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateY(element) || element.offsetTop,
          // No change yet on start, but info must be present
          elementWidth: element.offsetWidth,
          elementHeight: element.offsetHeight,
          cursorOffset: cursorOffset,
          startX: event.clientX + cursorOffset.x + me.scrollLeft,
          startY: event.clientY + cursorOffset.y + me.scrollTop,
          finalize: function finalize() {
            var _me$reset;

            return (_me$reset = me.reset) === null || _me$reset === void 0 ? void 0 : _me$reset.call(me);
          }
        };
        element.classList.add(me.resizingCls);
        me.internalStartResize(me.isTouch);
      }
    }
    /**
     * Initialize listeners
     * @private
     */

  }, {
    key: "initListeners",
    value: function initListeners() {
      var me = this,
          dragStartListeners = {
        element: me.outerElement,
        mousedown: documentListeners.down,
        thisObj: me
      };

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isTouchDevice) {
        dragStartListeners.touchstart = documentListeners.touchstart;
      } else if (!me.handleSelector) {
        dragStartListeners.mousemove = {
          handler: documentListeners.move,
          // Filter events for checkResizeHandles so we only get called if the mouse
          // is over one of our targets.
          delegate: me.targetSelector
        }; // We need to clean up when we exit one of our targets

        dragStartListeners.mouseleave = {
          handler: 'onMouseLeaveTarget',
          delegate: me.targetSelector,
          capture: true
        };
      } // These will be autoDetached upon destroy


      me.removeListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on(dragStartListeners);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {} //endregion
    //region Scroll helpers

  }, {
    key: "internalStartResize",
    //endregion
    //region Events
    value: function internalStartResize(isTouch) {
      var me = this,
          dragListeners = {
        element: document,
        keydown: documentListeners.keydown,
        thisObj: me
      };

      if (isTouch) {
        dragListeners.touchmove = documentListeners.touchmove; // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired
        // iOS do fire touchend

        dragListeners.touchend = dragListeners.pointerup = documentListeners.touchend;
      } else {
        dragListeners.mousemove = documentListeners.move;
        dragListeners.mouseup = documentListeners.up;
      } // A listener detacher is returned;


      me.removeDragListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on(dragListeners);
    } // Empty class implementation. If listeners *are* added, the detacher is added
    // as an instance property. So this is always callable.

  }, {
    key: "removeDragListeners",
    value: function removeDragListeners() {}
  }, {
    key: "reset",
    value: function reset() {
      var _this$removeDragListe;

      (_this$removeDragListe = this.removeDragListeners) === null || _this$removeDragListe === void 0 ? void 0 : _this$removeDragListe.call(this);
      this.context = null;
    }
  }, {
    key: "onPointerDown",
    value: function onPointerDown(isTouch, event) {
      var me = this;
      me.startEvent = event;

      if (!me.isElementResizable || me.isElementResizable(event.target, event)) {
        if (me.grabResizeHandle(isTouch, event)) {
          // Stop event if resize handle was grabbed (resize started)
          event.stopImmediatePropagation();
          me.internalStartResize(isTouch);
        }
      }
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(event) {
      // only allowing one finger for now...
      if (event.touches.length > 1) {
        return;
      }

      this.onPointerDown(true, event);
    }
    /**
     * Grab draggable element on mouse down.
     * @private
     * @param event
     */

  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      // only dragging with left mouse button
      if (event.button !== 0) {
        return;
      }

      this.onPointerDown(false, event);
    }
  }, {
    key: "internalMove",
    value: function internalMove(isTouch, event) {
      var me = this,
          context = me.context;

      if (context && context.element && (context.started || _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getDistanceBetween(me.startEvent, event) >= me.dragThreshold)) {
        if (!context.started) {
          me.scrollManager && me.scrollManager.startMonitoring({
            direction: me.direction,
            // TODO Update this then when we add support for vertical resizing too
            element: me.dragWithin || me.outerElement,
            callback: function callback(config) {
              return me.context && me.context.element && me.lastMouseMoveEvent && me.update(me.lastMouseMoveEvent, config);
            },
            thisObj: me
          });
          me.trigger('resizeStart', {
            context: context,
            event: event
          });
          context.started = true;
        }

        me.update(event);
      } // If a mousemove, and we are using zones, and not handles, we have to
      // programatically check whether we are over a handle, and add/remove
      // classes to change the mouse cursor to resize.
      // If we are using handles, their CSS will set the mouse cursor.
      else if (!isTouch && !me.handleSelector) {
          me.checkResizeHandles(event);
        }
    }
  }, {
    key: "onTouchMove",
    value: function onTouchMove(event) {
      this.internalMove(true, event);
    }
    /**
     * Move grabbed element with mouse.
     * @param event
     * @fires resizestart
     * @private
     */

  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      this.internalMove(false, event);
    }
  }, {
    key: "onPointerUp",
    value: function onPointerUp(isTouch, event) {
      var _me$removeDragListene;

      var me = this,
          context = me.context;
      (_me$removeDragListene = me.removeDragListeners) === null || _me$removeDragListene === void 0 ? void 0 : _me$removeDragListene.call(me);

      if (context) {
        me.scrollManager && me.scrollManager.stopMonitoring(me.dragWithin || me.outerElement);

        if (context.started) {
          // Prevent the impending document click from the mouseup event from propagating
          // into a click on our element.
          _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
            element: document,
            thisObj: me,
            click: documentListeners.docclick,
            expires: me.clickSwallowDuration,
            // In case a click did not ensue, remove the listener
            capture: true,
            once: true
          });
        }

        me.finishResize(event);
      } else if (!context.async) {
        var _me$reset2;

        (_me$reset2 = me.reset) === null || _me$reset2 === void 0 ? void 0 : _me$reset2.call(me);
      }
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(event) {
      this.onPointerUp(true, event);
    }
    /**
     * Drop on mouse up (if dropped on valid target).
     * @param event
     * @private
     */

  }, {
    key: "onMouseUp",
    value: function onMouseUp(event) {
      this.onPointerUp(false, event);
    }
    /**
     * This is a capture listener, only added during drag, which prevents a click gesture
     * propagating from the terminating mouseup geature
     * @param {MouseEvent} event
     * @private
     */

  }, {
    key: "onDocumentClick",
    value: function onDocumentClick(event) {
      event.stopPropagation();
    }
    /**
     * Cancel on ESC key
     * @param event
     * @private
     */

  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      if (event.key === 'Escape') {
        this.abort();
      }
    } //endregion
    //region Grab, update, finish

    /**
     * Updates resize, called when an element is grabbed and mouse moves
     * @private
     * @fires resizing
     */

  }, {
    key: "update",
    value: function update(event) {
      var me = this,
          context = me.context,
          parentRectangle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(me.outerElement); // Calculate the current pointer X. Do not allow overflowing either edge

      context.currentX = Math.max(Math.min(event.clientX + context.cursorOffset.x, parentRectangle.right), parentRectangle.x) + me.scrollLeft;
      context.currentY = Math.max(Math.min(event.clientY + context.cursorOffset.y, parentRectangle.bottom), parentRectangle.y) + me.scrollTop;
      me.updateResize(event);
      me.trigger('resizing', {
        context: context,
        event: event
      });
      context.element.classList[context.valid === false ? 'add' : 'remove'](me.invalidCls); // When IE11 support is dropped
      // context.grabbed.classList.toggle(me.invalidCls, context.valid === false);

      if (event) {
        me.lastMouseMoveEvent = event;
      }
    }
    /**
     * Abort dragging
     */

  }, {
    key: "abort",
    value: function abort() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this;
      me.scrollManager && me.scrollManager.stopMonitoring(me.dragWithin || me.outerElement);

      if (me.context) {
        me.abortResize(null, silent);
      } else if (!me.isDestroyed) {
        me.reset();
      }
    }
    /**
     * Starts resizing, updates ResizeHelper#context with relevant info.
     * @private
     * @param {Boolean} isTouch
     * @param {MouseEvent} event
     * @returns {Boolean} True if handled, false if not
     */

  }, {
    key: "grabResizeHandle",
    value: function grabResizeHandle(isTouch, event) {
      var me = this;

      if (me.allowResize && !me.allowResize(event.target, event)) {
        return false;
      }

      var handleSelector = me.handleSelector,
          coordsFrom = event.type === 'touchstart' ? event.changedTouches[0] : event,
          clientX = coordsFrom.clientX,
          clientY = coordsFrom.clientY,
          // go up from "handle" to resizable element
      element = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(event.target, me.targetSelector) : event.target;

      if (element) {
        var edge; // Calculate which edge to resize
        // If there's a handle selector, see if it's anchored on the left or the right

        if (handleSelector) {
          if (event.target.matches(handleSelector)) {
            if (me.direction === 'horizontal') {
              if (event.pageX < _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getPageX(element) + element.offsetWidth / 2) {
                edge = 'left';
              } else {
                edge = 'right';
              }
            } else {
              if (event.pageY < _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getPageY(element) + element.offsetHeight / 2) {
                edge = 'top';
              } else {
                edge = 'bottom';
              }
            }
          } else {
            return false;
          }
        } // If we're not using handles, but just active zones
        // then test whether the event position is in an active resize zone.
        else {
            if (me.direction === 'horizontal') {
              if (me.overLeftHandle(event, element)) {
                edge = 'left';
              } else if (me.overRightHandle(event, element)) {
                edge = 'right';
              }
            } else {
              if (me.overTopHandle(event, element)) {
                edge = 'top';
              } else if (me.overBottomHandle(event, element)) {
                edge = 'bottom';
              }
            }

            if (!edge) {
              me.context = null; // not over an edge, abort

              return false;
            }
          } // If resizing is initiated by a touch, we must preventDefault on the touchstart
        // so that scrolling is not invoked when dragging. This is in lieu of a functioning
        // touch-action style on iOS Safari. When that's fixed, this will not be needed.


        if (event.type === 'touchstart') {
          event.preventDefault();
        }

        var cursorOffset = me.getCursorOffsetToElementEdge(coordsFrom, element, edge);

        if (me.trigger('beforeResizeStart', {
          element: element,
          event: event
        }) !== false) {
          // store initial size
          me.context = {
            element: element,
            edge: edge,
            valid: true,
            async: false,
            direction: me.direction,
            isTouch: isTouch,
            elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateX(element) || element.offsetLeft,
            // extract x from translate
            elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateY(element) || element.offsetTop,
            // extract y from translate
            newX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateX(element) || element.offsetLeft,
            // No change yet on start, but info must be present
            newY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateY(element) || element.offsetTop,
            // No change yet on start, but info must be present
            elementWidth: element.offsetWidth,
            elementHeight: element.offsetHeight,
            cursorOffset: cursorOffset,
            startX: clientX + cursorOffset.x + me.scrollLeft,
            startY: clientY + cursorOffset.y + me.scrollTop,
            finalize: function finalize() {
              var _me$reset3;

              return (_me$reset3 = me.reset) === null || _me$reset3 === void 0 ? void 0 : _me$reset3.call(me);
            }
          };
          element.classList.add(me.resizingCls);
          return true;
        }
      }

      return false;
    }
  }, {
    key: "getCursorOffsetToElementEdge",
    value: function getCursorOffsetToElementEdge(event, element, edge) {
      var rectEl = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(element);
      var x = 0,
          y = 0;

      switch (edge) {
        case 'left':
          x = rectEl.x - event.clientX; // negative

          break;

        case 'right':
          x = rectEl.x + rectEl.width - event.clientX; // positive

          break;

        case 'top':
          y = rectEl.y - event.clientY; // negative

          break;

        case 'bottom':
          y = rectEl.y + rectEl.height - event.clientY; // positive

          break;
      }

      return {
        x: x,
        y: y
      };
    }
    /**
     * Check if mouse is over a resize handle (virtual). If so, highlight.
     * @private
     * @param event
     */

  }, {
    key: "checkResizeHandles",
    value: function checkResizeHandles(event) {
      var me = this,
          target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(event.target, me.targetSelector) : event.target; // mouse over a target element and allowed to resize?

      if (target && (!me.allowResize || me.allowResize(event.target, event))) {
        me.currentElement = me.handleContainerSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(event.target, me.handleContainerSelector) : event.target;

        if (me.currentElement) {
          var over = false;

          if (me.direction === 'horizontal') {
            over = me.overLeftHandle(event, target) || me.overRightHandle(event, target);
          } else {
            over = me.overTopHandle(event, target) || me.overBottomHandle(event, target);
          }

          if (over) {
            me.highlightHandle(); // over handle
          } else {
            me.unHighlightHandle(); // not over handle
          }
        }
      } else if (me.currentElement) {
        me.unHighlightHandle(); // outside element
      }
    }
  }, {
    key: "onMouseLeaveTarget",
    value: function onMouseLeaveTarget(event) {
      var me = this;
      me.currentElement = me.handleContainerSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(event.target, me.handleContainerSelector) : event.target;

      if (me.currentElement) {
        me.unHighlightHandle();
      }
    }
    /**
     * Updates size of target (on mouse move).
     * @private
     * @param event
     */

  }, {
    key: "updateResize",
    value: function updateResize(event) {
      var me = this,
          context = me.context; // flip which edge is being dragged depending on whether we're to the right or left of the mousedown

      if (me.allowEdgeSwitch) {
        if (me.direction === 'horizontal') {
          context.edge = context.currentX > context.startX ? 'right' : 'left';
        } else {
          context.edge = context.currentY > context.startY ? 'bottom' : 'top';
        }
      }

      var // limit to outerElement if set
      deltaX = context.currentX - context.startX,
          deltaY = context.currentY - context.startY,
          minWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getExtremalSizePX(context.element, 'minWidth') || me.minWidth,
          maxWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getExtremalSizePX(context.element, 'maxWidth') || me.maxWidth,
          minHeight = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getExtremalSizePX(context.element, 'minHeight') || me.minHeight,
          maxHeight = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getExtremalSizePX(context.element, 'maxHeight') || me.maxHeight,
          // dragging right edge right increases width, dragging left edge right decreases width
      sign = context.edge === 'right' || context.edge === 'bottom' ? 1 : -1,
          // new width, not allowed to go below minWidth
      newWidth = context.elementWidth + deltaX * sign,
          newHeight = context.elementHeight + deltaY * sign;
      var width = Math.max(minWidth, newWidth),
          height = Math.max(minHeight, newHeight);

      if (maxWidth > 0) {
        width = Math.min(width, maxWidth);
      }

      if (maxHeight > 0) {
        height = Math.min(height, maxHeight);
      } // remove flex when resizing


      if (context.element.style.flex) {
        context.element.style.flex = '';
      }

      if (me.direction === 'horizontal') {
        context.element.style.width = Math.abs(width) + 'px';
        context.newWidth = width; // when dragging left edge, also update position (so that right edge remains in place)

        if (context.edge === 'left' || width < 0) {
          context.newX = Math.max(Math.min(context.elementStartX + context.elementWidth - me.minWidth, context.elementStartX + deltaX), 0);

          if (!me.skipTranslate) {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateX(context.element, context.newX);
          }
        } // When dragging the right edge and we're allowed to flip the drag from left to right
        // through the start point (eg drag event creation) the element must be at its initial X position
        else if (context.edge === 'right' && me.allowEdgeSwitch && !me.skipTranslate) {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateX(context.element, context.elementStartX);
          }
      } else {
        context.element.style.height = Math.abs(height) + 'px';
        context.newHeight = height; // when dragging top edge, also update position (so that bottom edge remains in place)

        if (context.edge === 'top' || height < 0) {
          context.newY = Math.max(Math.min(context.elementStartY + context.elementHeight - me.minHeight, context.elementStartY + deltaY), 0);

          if (!me.skipTranslate) {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateY(context.element, context.newY);
          }
        } // When dragging the bottom edge and we're allowed to flip the drag from top to bottom
        // through the start point (eg drag event creation) the element must be at its initial Y position
        else if (context.edge === 'bottom' && me.allowEdgeSwitch && !me.skipTranslate) {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateY(context.element, context.elementStartY);
          }
      }
    }
    /**
     * Finalizes resize, fires drop.
     * @private
     * @param event
     * @fires resize
     * @fires cancel
     */

  }, {
    key: "finishResize",
    value: function finishResize(event) {
      var me = this,
          context = me.context,
          eventObject = {
        context: context,
        event: event
      };
      context.element.classList.remove(me.resizingCls);

      if (context.started) {
        var changed = false;

        if (me.direction === 'horizontal') {
          changed = context.newWidth && context.newWidth !== context.elementWidth;
        } else {
          changed = context.newHeight && context.newHeight !== context.elementHeight;
        }

        me.trigger(changed ? 'resize' : 'cancel', eventObject);

        if (!context.async) {
          context.finalize();
        }
      } else {
        var _me$reset4;

        (_me$reset4 = me.reset) === null || _me$reset4 === void 0 ? void 0 : _me$reset4.call(me);
      }
    }
    /**
     * Abort resizing
     * @private
     * @fires cancel
     */

  }, {
    key: "abortResize",
    value: function abortResize() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          context = me.context;
      context.element.classList.remove(me.resizingCls);

      if (me.direction === 'horizontal') {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateX(context.element, context.elementStartX);
        context.element.style.width = context.elementWidth + 'px';
      } else {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateY(context.element, context.elementStartY);
        context.element.style.height = context.elementHeight + 'px';
      }

      !silent && me.trigger('cancel', {
        context: context,
        event: event
      });

      if (!me.isDestroyed) {
        me.reset();
      }
    } //endregion
    //region Handles
    // /**
    //  * Constrain resize to outerElements bounds
    //  * @private
    //  * @param x
    //  * @returns {*}
    //  */
    // constrainResize(x) {
    //     const me = this;
    //
    //     if (me.outerElement) {
    //         const box = me.outerElement.getBoundingClientRect();
    //         if (x < box.left) x = box.left;
    //         if (x > box.right) x = box.right;
    //     }
    //
    //     return x;
    // }

    /**
     * Highlights handles (applies css that changes cursor).
     * @private
     */

  }, {
    key: "highlightHandle",
    value: function highlightHandle() {
      var me = this,
          target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(me.currentElement, me.targetSelector) : me.currentElement; // over a handle, add cls to change cursor

      me.currentElement.classList.add('b-resize-handle');
      target.classList.add('b-over-resize-handle');
    }
    /**
     * Unhighlight handles (removes css).
     * @private
     */

  }, {
    key: "unHighlightHandle",
    value: function unHighlightHandle() {
      var me = this,
          target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(me.currentElement, me.targetSelector) : me.currentElement;
      target && target.classList.remove('b-over-resize-handle');
      me.currentElement.classList.remove('b-resize-handle');
      me.currentElement = null;
    }
  }, {
    key: "overAnyHandle",
    value: function overAnyHandle(event, target) {
      return this.overStartHandle(event, target) || this.overEndHandle(event, target);
    }
  }, {
    key: "overStartHandle",
    value: function overStartHandle(event, target) {
      return this.direction === 'horizontal' ? this.overLeftHandle(event, target) : this.overTopHandle(event, target);
    }
  }, {
    key: "overEndHandle",
    value: function overEndHandle(event, target) {
      return this.direction === 'horizontal' ? this.overRightHandle(event, target) : this.overBottomHandle(event, target);
    }
  }, {
    key: "getDynamicHandleSize",
    value: function getDynamicHandleSize(opposite, offsetWidth) {
      var handleCount = opposite ? 2 : 1,
          handleSize = this.handleSize; // Shrink handle size when configured to do so, preserving reserved space between handles

      if (this.dynamicHandleSize && handleSize * handleCount > offsetWidth - this.reservedSpace) {
        return Math.max(Math.floor((offsetWidth - this.reservedSpace) / handleCount), 0);
      }

      return handleSize;
    }
    /**
     * Check if over left handle (virtual).
     * @private
     * @param {MouseEvent} event MouseEvent
     * @param {HTMLElement} target The current target element
     * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
     */

  }, {
    key: "overLeftHandle",
    value: function overLeftHandle(event, target) {
      var me = this,
          offsetWidth = target.offsetWidth;

      if (me.leftHandle && (offsetWidth >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
        var leftHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(target);
        leftHandle.width = me.getDynamicHandleSize(me.rightHandle, offsetWidth);
        return leftHandle.width > 0 && leftHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getPagePoint(event));
      }

      return false;
    }
    /**
     * Check if over right handle (virtual).
     * @private
     * @param {MouseEvent} event MouseEvent
     * @param {HTMLElement} target The current target element
     * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
     */

  }, {
    key: "overRightHandle",
    value: function overRightHandle(event, target) {
      var me = this,
          offsetWidth = target.offsetWidth;

      if (me.rightHandle && (offsetWidth >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
        var rightHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(target);
        rightHandle.x = rightHandle.right - me.getDynamicHandleSize(me.leftHandle, offsetWidth);
        return rightHandle.width > 0 && rightHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getPagePoint(event));
      }

      return false;
    }
    /**
     * Check if over top handle (virtual).
     * @private
     * @param {MouseEvent} event MouseEvent
     * @param {HTMLElement} target The current target element
     * @returns {Boolean} Returns true if mouse is over top handle, otherwise false
     */

  }, {
    key: "overTopHandle",
    value: function overTopHandle(event, target) {
      var me = this,
          offsetHeight = target.offsetHeight;

      if (me.topHandle && (offsetHeight >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
        var topHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(target);
        topHandle.height = me.getDynamicHandleSize(me.bottomHandle, offsetHeight);
        return topHandle.height > 0 && topHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getPagePoint(event));
      }

      return false;
    }
    /**
     * Check if over bottom handle (virtual).
     * @private
     * @param {MouseEvent} event MouseEvent
     * @param {HTMLElement} target The current target element
     * @returns {Boolean} Returns true if mouse is over bottom handle, otherwise false
     */

  }, {
    key: "overBottomHandle",
    value: function overBottomHandle(event, target) {
      var me = this,
          offsetHeight = target.offsetHeight;

      if (me.bottomHandle && (offsetHeight >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
        var bottomHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(target);
        bottomHandle.y = bottomHandle.bottom - me.getDynamicHandleSize(me.bottomHandle, offsetHeight);
        return bottomHandle.height > 0 && bottomHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getPagePoint(event));
      }

      return false;
    } //endregion

  }, {
    key: "scrollLeft",
    get: function get() {
      if (this.scroller) {
        return this.scroller.x;
      }

      return this.outerElement.scrollLeft;
    }
  }, {
    key: "scrollTop",
    get: function get() {
      if (this.scroller) {
        return this.scroller.y;
      }

      return this.outerElement.scrollTop;
    }
  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        /**
         * CSS class added when resizing
         * @config {String}
         * @default
         */
        resizingCls: 'b-resizing',

        /**
         * The amount of pixels to move mouse before it counts as a drag operation
         * @config {Number}
         * @default
         */
        dragThreshold: 5,

        /**
         * Resizing handle size
         * @config {Number}
         * @default
         */
        handleSize: 10,

        /**
         * Automatically shrink virtual handles when available space < handleSize. The virtual handles will
         * decrease towards width/height 1, reserving space between opposite handles to for example leave room for
         * dragging. To configure reserved space, see {@link #config-reservedSpace}.
         * @config {Boolean}
         * @default false
         */
        dynamicHandleSize: null,
        //

        /**
         * Room in px to leave unoccupied by handles when shrinking them dynamically (see
         * {@link #config-dynamicHandleSize}).
         * @config {Number}
         * @default
         */
        reservedSpace: 10,

        /**
         * Resizing handle size on touch devices
         * @config {Number}
         * @default
         */
        touchHandleSize: 30,

        /**
         * Minimum width when resizing
         * @config {Number}
         * @default
         */
        minWidth: 1,

        /**
         * Max width when resizing.
         * @config {Number}
         * @default
         */
        maxWidth: 0,

        /**
         * Minimum height when resizing
         * @config {Number}
         * @default
         */
        minHeight: 1,

        /**
         * Max height when resizing
         * @config {Number}
         * @default
         */
        maxHeight: 0,
        // outerElement, attach events to it and use as outer limit when looking for ancestors
        outerElement: document.body,

        /**
         * Optional scroller used to read scroll position. If unspecified, the outer element will be used.
         * @config {Core.helper.util.Scroller}
         */
        scroller: null,

        /**
         * Assign a function to determine if a hovered element can be resized or not
         * @config {Function}
         * @default
         */
        allowResize: null,

        /**
         * Outer element that limits where element can be dragged
         * @config {HTMLElement}
         * @default
         */
        dragWithin: null,

        /**
         * A function that determines if dragging an element is allowed. Gets called with the element as argument,
         * return true to allow dragging or false to prevent.
         * @config {Function}
         * @default
         */
        isElementResizable: null,

        /**
         * A CSS selector used to determine if resizing an element is allowed.
         * @config {String}
         * @default
         */
        targetSelector: null,

        /**
         * Use left handle when resizing. Only applies when `direction` is 'horizontal'
         * @config {Boolean}
         * @default
         */
        leftHandle: true,

        /**
         * Use right handle when resizing. Only applies when `direction` is 'horizontal'
         * @config {Boolean}
         * @default
         */
        rightHandle: true,

        /**
         * Use top handle when resizing. Only applies when `direction` is 'vertical'
         * @config {Boolean}
         * @default
         */
        topHandle: true,

        /**
         * Use bottom handle when resizing. Only applies when `direction` is 'vertical'
         * @config {Boolean}
         * @default
         */
        bottomHandle: true,

        /**
         * A CSS selector used to determine where handles should be "displayed" when resizing. Defaults to
         * targetSelector if unspecified
         * @config {String}
         * @default
         */
        handleSelector: null,

        /**
         * A CSS selector used to determine which inner element contains handles.
         * @config {String}
         * @default
         */
        handleContainerSelector: null,
        startEvent: null,

        /*
         * Optional config object, used by EventResize feature: it appends proxy and has to start resizing immediately
         * @config {Object}
         * @private
         */
        grab: null,

        /**
         * CSS class added when the resize state is invalid
         * @config {String}
         * @default
         */
        invalidCls: 'b-resize-invalid',
        // A number that controls whether or not the element is wide enough for it to make sense to show resize handles
        // e.g. handle width is 10px, so doesn't make sense to show them unless handles on both sides fit
        handleVisibilityThreshold: null,
        // Private config that disables translation when resizing left edge. Useful for example in cases when element
        // being resized is part of a flex layout
        skipTranslate: false,

        /**
         * Direction to resize in, either 'horizontal' or 'vertical'
         * @config {String}
         * @default
         */
        direction: 'horizontal',
        clickSwallowDuration: 50
      };
    }
  }]);

  return ResizeHelper;
}(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_10__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]));


ResizeHelper._$name = 'ResizeHelper';

/***/ }),

/***/ "./lib/Core/helper/ResizeMonitor.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/ResizeMonitor.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResizeMonitor; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
















function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';
/* globals ResizeObserver: true */




var resizeFireTimer = null;

var resizedQueue = [],
    isAbsolutelyPositioned = function isAbsolutelyPositioned(n) {
  var _n$ownerDocument$defa;

  return n.nodeType === 1 && ((_n$ownerDocument$defa = n.ownerDocument.defaultView) === null || _n$ownerDocument$defa === void 0 ? void 0 : _n$ownerDocument$defa.getComputedStyle(n).getPropertyValue('position')) === 'absolute';
};
/**
 * @module Core/helper/ResizeMonitor
 */

/**
 * Allows size monitoring of elements (or optionally a Window instance).
 *
 * ```
 * ResizeMonitor.addResizeListener(
 *   myElement,
 *   element => {
 *      console.log(element, ' changed size');
 *   }
 * );
 * ```
 *
 * @internal
 */


var ResizeMonitor = /*#__PURE__*/function () {
  function ResizeMonitor() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, ResizeMonitor);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(ResizeMonitor, null, [{
    key: "addResizeListener",

    /**
     * Adds a resize listener to the passed element which is called when the element
     * is resized by layout.
     * @param {HTMLElement} element The element to listen for resizing.
     * @param {Function} handler The handling function. Will be passed the element.
     */
    value: function addResizeListener(element, handler) {
      var me = this;

      if (element === document || element === window) {
        element = document.body;
      }

      if (!element.classList.contains('b-resize-monitored')) {
        element.classList.add('b-resize-monitored');
        element._bResizemonitor = {
          handlers: []
        };
      } // If we're looking at the document, or body, use a window resize listener.


      if (element === document.body) {
        if (!me.hasWindowResizeListener) {
          // Throttle the reaction to window resize to only fire once every 100ms
          window.addEventListener('resize', me.onWindowResize);
          me.hasWindowResizeListener = true;
        }
      } // Regular element - use ResizeObserver by preference
      else if (window.ResizeObserver) {
          if (!me.resizeObserver) {
            me.resizeObserver = new ResizeObserver(me.onElementResize);
          }

          me.resizeObserver.observe(element);
        } // Polyfill ResizeObesrver
        else {
            element.classList.add('b-no-resizeobserver');

            var _DomHelper$createElem = _DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createElement({
              parent: element,
              className: 'b-resize-monitors',
              children: [{
                className: 'b-resize-monitor-expand'
              }, {
                className: 'b-resize-monitor-shrink'
              }]
            }, true),
                _DomHelper$createElem2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_12___default()(_DomHelper$createElem, 3),
                monitors = _DomHelper$createElem2[0],
                expand = _DomHelper$createElem2[1],
                shrink = _DomHelper$createElem2[2];

            expand.scrollLeft = expand.scrollTop = shrink.scrollLeft = shrink.scrollTop = 1000000;
            expand.addEventListener('scroll', me.onSizeMonitorScroll, true);
            shrink.addEventListener('scroll', me.onSizeMonitorScroll, true); // Also need to fake a resize-scroll on DOM mutation

            (handler.targetMutationMonitor = new MutationObserver(function (m) {
              var changedNodes = [];

              var _iterator = _createForOfIteratorHelper(m),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var mr = _step.value;

                  if (mr.type === 'childList') {
                    changedNodes.push.apply(changedNodes, mr.removedNodes);
                    changedNodes.push.apply(changedNodes, mr.addedNodes);
                  }
                } // If the changed nodes were absolutely positioned, then they won't
                // cause a resize, so return

              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              if (changedNodes.length > 0 && changedNodes.every(isAbsolutelyPositioned)) {
                return;
              } // HACK!
              // Although expand should be `b-resize-monitor-expand` element, id Edge 18 it might not be the case.
              // SimpleEventEditor.t.js in Scheduler shows this when you dragcreate event. At some point real expand element
              // get removed from DOM and we get smth like `b-sch-event-content` here, which is totally different element.
              // Reference is the same, it passes === check! So this is a sanity check to not trigger resizes when element
              // is incorrect.


              if ((_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].isIE11) && !expand.classList.contains('b-resize-monitor-expand')) {
                return;
              } // We only want the size monitor listener to trigger, so this event must NOT bubble
              // to any application or other framework listeners.


              expand.dispatchEvent(new CustomEvent('scroll', {
                bubbles: false
              }));
            })).observe(element, {
              childList: true,
              subtree: true
            }); // store reference for easier cleanup later

            handler.monitorElement = monitors;
          }

      element._bResizemonitor.handlers.push(handler);
    }
    /**
     * Removes a resize listener from the passed element.
     * @param {HTMLElement} element The element to listen for resizing.
     * @param {Function} handler The handling function to remove.
     */

  }, {
    key: "removeResizeListener",
    value: function removeResizeListener(element, handler) {
      if (element) {
        if (element === document || element === window) {
          element = document.body;
        }

        var resizeMonitor = element._bResizemonitor;
        var listenerCount = 0;

        if (resizeMonitor && resizeMonitor.handlers) {
          _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].remove(resizeMonitor.handlers, handler); // See if we should unobserve the element

          listenerCount = resizeMonitor.handlers.length;
        } // Down to no listeners.


        if (!listenerCount) {
          element.classList.remove('b-resize-monitored');

          if (this.resizeObserver) {
            this.resizeObserver.unobserve(element);
          } // Remove the polyfill resize listeners
          else {
              // remove any added elements
              if (handler.monitorElement) {
                handler.monitorElement.remove();
                handler.monitorElement = null;
              } // remove the DOM mutation observer


              if (handler.targetMutationMonitor) {
                handler.targetMutationMonitor.disconnect();
              }
            }
        }
      }
    }
  }, {
    key: "onElementResize",
    value: function onElementResize(entries) {
      var _iterator2 = _createForOfIteratorHelper(entries),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var resizeObserverEntry = _step2.value;
          var resizedElement = resizeObserverEntry.target,
              resizeMonitor = resizedElement._bResizemonitor,
              newRect = resizeObserverEntry.contentRect || resizedElement.getBoundingClientRect();

          if (resizedElement.offsetParent) {
            if (!resizeMonitor.rectangle || newRect.width !== resizeMonitor.rectangle.width || newRect.height !== resizeMonitor.rectangle.height) {
              var oldRect = resizeMonitor.rectangle;
              resizeMonitor.rectangle = newRect;

              var _iterator3 = _createForOfIteratorHelper(resizeMonitor.handlers),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var resizeHandler = _step3.value;
                  resizeHandler(resizedElement, oldRect, newRect);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "onSizeMonitorScroll",
    value: function onSizeMonitorScroll(e) {
      var _document$body;

      // If no body exists or the element has gone, ignore the event; the listener will be removed automatically.
      if ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.contains(e.target)) {
        e.stopImmediatePropagation();
        var monitorNode = e.target.parentNode,
            resizedElement = monitorNode.parentNode,
            resizeMonitor = resizedElement._bResizemonitor,
            newRect = resizedElement.getBoundingClientRect();

        if (!resizeMonitor.rectangle || newRect.width !== resizeMonitor.rectangle.width || newRect.height !== resizeMonitor.rectangle.height) {
          resizedQueue.push([resizedElement, resizeMonitor.rectangle, newRect]);
          resizeMonitor.rectangle = newRect;

          if (!resizeFireTimer) {
            resizeFireTimer = requestAnimationFrame(ResizeMonitor.fireResizeEvents);
          }
        }

        monitorNode.firstChild.scrollLeft = monitorNode.firstChild.scrollTop = monitorNode.childNodes[1].scrollTop = monitorNode.childNodes[1].scrollLeft = 1000000;
      }
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize(e) {
      var resizedElement = document.body,
          resizeMonitor = resizedElement._bResizemonitor,
          oldRect = resizeMonitor.rectangle;
      resizeMonitor.rectangle = document.documentElement.getBoundingClientRect();

      var _iterator4 = _createForOfIteratorHelper(resizeMonitor.handlers),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var resizeHandler = _step4.value;
          resizeHandler(resizedElement, oldRect, resizeMonitor.rectangle);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "fireResizeEvents",
    value: function fireResizeEvents() {
      var _iterator5 = _createForOfIteratorHelper(resizedQueue),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var resizedEntry = _step5.value;

          var _iterator6 = _createForOfIteratorHelper(resizedEntry[0]._bResizemonitor.handlers),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var resizeHandler = _step6.value;

              // Checking offsetParent to avoid resizing of elements which are not visible or exist in DOM
              if (resizedEntry[0].offsetParent) {
                resizeHandler.apply(this, resizedEntry);
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      resizeFireTimer = null;
      resizedQueue.length = 0;
    }
  }]);

  return ResizeMonitor;
}();


ResizeMonitor._$name = 'ResizeMonitor';

/***/ }),

/***/ "./lib/Core/helper/StringHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/StringHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StringHelper; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _VersionHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");















var productName = 'scheduler'; // IMPORTANT - adding imports here can create problems for Base class


/**
 * @module Core/helper/StringHelper
 */

var charsToEncode, entitiesToDecode, htmlEncodeRe, htmlDecodeRe;

var camelLettersRe = /([a-z])([A-Z])/g,
    escapeRegExpRe = /[.*+?^${}()|[\]\\]/g,
    // same as NPM escape-string-regexp
idRe = /(^[^a-z]+|[^\w]+)/gi,
    whiteSpaceRe = /\s+/,
    htmlDecoder = function htmlDecoder(m, captured) {
  return entitiesToDecode[captured.toLowerCase()] || String.fromCharCode(parseInt(captured.substr(2), 10));
},
    htmlEncoder = function htmlEncoder(m, captured) {
  return charsToEncode[captured];
},
    replaceCamelLetters = function replaceCamelLetters(all, g1, g2) {
  return g1 + '-' + g2.toLowerCase();
},
    replaceNonIdChar = function replaceNonIdChar(c) {
  if (c) {
    return "_x".concat(c.charCodeAt(0).toString(16));
  }

  return '__blank__';
},
    hyphenateCache = {};
/**
 * Helper for string manipulation.
 */


var StringHelper = /*#__PURE__*/function () {
  function StringHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, StringHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(StringHelper, null, [{
    key: "capitalize",

    /**
     * Capitalizes the first letter of a string, "myString" -> "MyString".
     * @param {String} string The string to capitalize
     * @returns {String} The capitalized string or the value of `string` if falsy.
     * @category String formatting
     */
    value: function capitalize(string) {
      return string && string[0].toUpperCase() + string.substr(1);
    }
    /**
     * Capitalizes the first letter of a string, "myString" -> "MyString".
     * If the parameter is falsy, `null` is returned.
     * @param {String} string The string to capitalize
     * @returns {String} The capitalized string or `null` if `string` is falsy.
     * @deprecated 4.0 Use {@link #function-capitalize} instead.
     * @category String formatting
     */

  }, {
    key: "capitalizeFirstLetter",
    value: function capitalizeFirstLetter(string) {
      _VersionHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `capitalize()`, will be removed in 5.0');

      if (!string) {
        return null;
      }

      return string[0].toUpperCase() + string.substr(1);
    }
    /**
     * This method decodes HTML entities and returns the original HTML.
     *
     * See also {@link #function-encodeHtml-static}.
     * @param {String} text
     * @returns {String}
     * @category HTML
     */

  }, {
    key: "decodeHtml",
    value: function decodeHtml(text) {
      return text ? String(text).replace(htmlDecodeRe, htmlDecoder) : text;
    }
    /**
     * This method encodes HTML entities and returns a string that can be placed in the document and produce the
     * original text rather than be interpreted as HTML. Using this method with user-entered values prevents those
     * values from executing as HTML (i.e., a cross-site scripting or "XSS" security issue).
     *
     * See also {@link #function-decodeHtml-static}.
     * @param {String} html
     * @returns {String}
     * @category HTML
     */

  }, {
    key: "encodeHtml",
    value: function encodeHtml(html) {
      return html ? String(html).replace(htmlEncodeRe, htmlEncoder) : html;
    }
    /**
     * Makes the first letter of a string lowercase, "MyString" -> "myString".
     * If the parameter is falsy, `null` is returned.
     * @param {String} string The string to lowercase.
     * @returns {String} The lowercased string or `null` if `string` is falsy.
     * @deprecated 4.0 Use {@link #function-uncapitalize} instead.
     * @category String formatting
     */

  }, {
    key: "lowercaseFirstLetter",
    value: function lowercaseFirstLetter(string) {
      _VersionHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `uncapitalize()`, will be removed in 5.0');

      if (!string) {
        return null;
      }

      return string[0].toLowerCase() + string.substr(1);
    }
    /**
     * Makes the first letter of a string lowercase, "MyString" -> "myString".
     * @param {String} string The string to un-capitalize.
     * @returns {String} The un-capitalized string or the value of `string` if falsy.
     * @category String formatting
     */

  }, {
    key: "uncapitalize",
    value: function uncapitalize(string) {
      return string && string[0].toLowerCase() + string.substr(1);
    }
    /**
     * Converts the passed camelCased string to a hyphen-separated string. eg "minWidth" -> "min-width"
     * @param string The string to convert.
     * @return {String} The string with adjoining lower and upper case letters
     * separated by hyphens and converted to lower case.
     * @category String formatting
     */

  }, {
    key: "hyphenate",
    value: function hyphenate(string) {
      // Cached since it is used heavily with DomHelper.sync()
      var cached = hyphenateCache[string];

      if (cached) {
        return cached;
      }

      return hyphenateCache[string] = string.replace(camelLettersRe, replaceCamelLetters);
    }
    /**
     * Initializes HTML entities used by {@link #function-encodeHtml-static} and {@link #function-decodeHtml-static}.
     * @param {Object} [mappings] An object whose keys are characters that should be encoded and values are the HTML
     * entity for the character.
     * @private
     */

  }, {
    key: "initHtmlEntities",
    value: function initHtmlEntities(mappings) {
      mappings = mappings || {
        '&': '&amp;',
        '>': '&gt;',
        '<': '&lt;',
        '"': '&quot;',
        "'": '&#39;'
      };
      var chars = Object.keys(mappings); // Maps '<' to '&lt;'

      charsToEncode = mappings; // Inverts the mapping so we can convert '&lt;' to '<'

      entitiesToDecode = chars.reduce(function (prev, val) {
        prev[mappings[val]] = val;
        return prev;
      }, {}); // Creates a regex char set like /([<&>])/g to match the characters that need to be encoded (escaping any of
      // the regex charset special chars '[', ']' and '-'):

      htmlEncodeRe = new RegExp("([".concat(chars.map(function (c) {
        return '[-]'.includes(c) ? '\\' + c : c;
      }).join(''), "])"), 'g'); // Creates a regex like /(&lt;|&amp;|&gt;)/ig to match encoded entities... good news is that (valid) HTML
      // entities do not contain any regex special characters:

      htmlDecodeRe = new RegExp("(".concat(Object.values(mappings).join('|'), "|&#[0-9]+;)"), 'ig');
    }
    /**
     * Parses JSON inside a try-catch block. Returns null if the string could not be parsed.
     *
     * @param {String} string String to parse
     * @returns {Object} Resulting object or null if parse failed
     * @category JSON
     */

  }, {
    key: "safeJsonParse",
    value: function safeJsonParse(string) {
      var parsed = null;

      try {
        parsed = JSON.parse(string);
      } catch (e) {}

      return parsed;
    }
    /**
     * Stringifies an object inside a try-catch block. Returns null if an exception is encountered.
     *
     * See [JSON.stringify on MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify)
     * for more information on the arguments.
     *
     * @param {Object} object The object to stringify
     * @param {Function|String[]|Number[]} [replacer] A function or array of string/number used to determine properties
     * to include in the JSON string
     * @param {String|Number} [space] Number of spaces to indent or string used as whitespace
     * @returns {Object} Resulting object or null if stringify failed
     * @category JSON
     */

  }, {
    key: "safeJsonStringify",
    value: function safeJsonStringify(object) {
      var replacer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var space = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var result = null;

      try {
        result = JSON.stringify(object, replacer, space);
      } catch (e) {}

      return result;
    }
    /**
     * Creates an alphanumeric identifier from any passed string. Encodes spaces and non-alpha characters.
     * @param inString The string from which to strip non-identifier characters.
     * @return {String}
     * @category Misc
     */

  }, {
    key: "createId",
    value: function createId(inString) {
      return String(inString).replace(idRe, replaceNonIdChar);
    }
  }, {
    key: "escapeRegExp",
    value: function escapeRegExp(string, flags) {
      // $& means the whole matched string
      var ret = string.replace(escapeRegExpRe, '\\$&');

      if (flags !== undefined) {
        ret = new RegExp(ret, flags);
      }

      return ret;
    }
    /**
     * Joins all given paths together using the separator as a delimiter and normalizes the resulting path.
     * @param paths {Array} array of paths to join
     * @param pathSeparator [{String}] path separator. Default value is '/'
     * @return {String}
     * @category Misc
     */

  }, {
    key: "joinPaths",
    value: function joinPaths(paths) {
      var pathSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
      return paths.join(pathSeparator).replace(new RegExp('\\' + pathSeparator + '+', 'g'), pathSeparator);
    }
    /**
     * Returns the provided string split on whitespace. If the string is empty or consists of only whitespace, the
     * returned array will be empty. If `str` is not a string, it is simply returned. This allows `null` or already
     * split strings (arrays) to be passed through.
     *
     * For example:
     * ```
     *  console.log(StringHelper.split(' abc def xyz   '));
     *  > ['abc', 'def', 'xyz']
     *  console.log(StringHelper.split(''));
     *  > []
     * ```
     * Compare to the standard `split()` method:
     * ```
     *  console.log(' abc def xyz   '.split(/\s+/));
     *  > ['', 'abc', 'def', 'xyz', '']
     *  console.log(''.split(/\s+/));
     *  > ['']
     * ```
     * @param {String} str
     * @param {String|RegExp} delimiter
     * @returns {String[]}
     * @category Misc
     */

  }, {
    key: "split",
    value: function split(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : whiteSpaceRe;
      var ret = str;

      if (typeof ret === 'string') {
        ret = str.trim(); // w/o trim() whitespace on the ends will give us '' in the array

        ret = ret ? ret.split(delimiter) : []; // also ''.split() = ['']
      }

      return ret;
    }
    /**
     * This is a tagged template function that performs HTML encoding on replacement values to avoid XSS (Cross-Site
     * Scripting) attacks.
     *
     * For example:
     *
     * ```javascript
     *  eventRenderer(eventRecord) {
     *      return StringHelper.xss`<span class="${eventRecord.attrib}">${eventRecord.name}</span>`;
     *  }
     * ```
     */

  }, {
    key: "xss",
    value: function xss(strings) {
      var buf = [];

      for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        values[_key - 1] = arguments[_key];
      }

      var i = values.length;
      buf[i] = strings[i];

      while (i-- > 0) {
        buf[i] = strings[i] + StringHelper.encodeHtml(values[i]);
      }

      return buf.join('');
    }
  }]);

  return StringHelper;
}();


StringHelper.initHtmlEntities();
StringHelper._$name = 'StringHelper';

/***/ }),

/***/ "./lib/Core/helper/TemplateHelper.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/TemplateHelper.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TemplateHelper; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.repeat */ "./node_modules/core-js/modules/es.string.repeat.js");
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);









var productName = 'scheduler';
/**
* @module Core/helper/TemplateHelper
*/

var tagSpaceRe = />[ \t\r\n]+</g,
    multiSpaceRe = /\s\s+/g;
/**
 * Helper for template strings, use as tag function
 * @example
 * TemplateHelper.tpl`...`
 * @internal
 */

var TemplateHelper = /*#__PURE__*/function () {
  function TemplateHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, TemplateHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(TemplateHelper, null, [{
    key: "tpl",

    /**
     * Tag function for template literals that does some basic cleanup
     * @private
     */
    value: function tpl(strings) {
      for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        values[_key - 1] = arguments[_key];
      }

      var count = 0,
          output = values.map(function (val, i) {
        // TODO: pad output nicely instead of just trimming away
        var ret = strings[i];

        if (Array.isArray(val)) {
          ret += val.reduce(function (ack, item) {
            return ack += (typeof item === 'string' ? item.trim() : item) + '\n';
          }, '');
        } else {
          if (val === undefined) {
            val = '';
          }

          ret += typeof val === 'string' ? val.trim() : val;
        }

        count++;
        return ret;
      }).join('');

      if (count <= strings.length) {
        output += strings[strings.length - 1];
      } // Excise unnecessary *soft* whitespace textNodes. We cannot use \s because that
      // matches non-breaking spaces which need to be preserved.
      // Also reduce any usage of multiple spaces to single, since they have no value in html


      return output.replace(tagSpaceRe, '><').replace(multiSpaceRe, ' ').trim();
    }
    /**
     * Tag function for template literals that does some basic cleanup. Version for docs that do not remove blank space,
     * to keep code snippets formatting intact.
     * @private
     */

  }, {
    key: "docsTpl",
    value: function docsTpl(strings) {
      for (var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        values[_key2 - 1] = arguments[_key2];
      }

      var count = 0,
          output = values.map(function (val, i) {
        // TODO: pad output nicely instead of just trimming away
        var str = strings[i],
            ret = str;

        if (Array.isArray(val)) {
          ret += val.reduce(function (ack, item) {
            return ack += (typeof item === 'string' ? item.trim() : item) + '\n';
          }, '');
        } else {
          if (val === undefined) {
            val = '';
          }

          ret += typeof val === 'string' ? val.trim() : val;
        }

        count++;
        return ret;
      }).join('');

      if (count <= strings.length) {
        output += strings[strings.length - 1];
      } // Excise unnecessary *soft* whitespace textNodes. We cannot use \s because that
      // matches non-breaking spaces which need to be preserved.


      return output.replace(tagSpaceRe, '><').trim();
    }
  }, {
    key: "repeat",
    value: function repeat(times) {
      return function () {
        return TemplateHelper.tpl.apply(TemplateHelper, arguments).repeat(times);
      };
    }
  }, {
    key: "loop",
    value: function loop(times) {}
  }]);

  return TemplateHelper;
}();


TemplateHelper._$name = 'TemplateHelper';

/***/ }),

/***/ "./lib/Core/helper/VersionHelper.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/VersionHelper.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VersionHelper; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");





var productName = 'scheduler';

/**
 * @module Core/helper/VersionHelper
 */

var isSiesta = false;

try {
  isSiesta = Boolean(_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].global.parent && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].global.parent.Siesta || typeof process !== 'undefined' && (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].global.StartTest || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].global.Siesta));
} catch (e) {}
/**
 * Helper for version handling
 * @private
 * @example
 *
 * VersionHelper.setVersion('grid', '1.5');
 *
 * if (VersionHelper.getVersion('grid').isNewerThan('1.0')) {
 *   ...
 * }
 */


var VersionHelper = /*#__PURE__*/function () {
  function VersionHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, VersionHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(VersionHelper, null, [{
    key: "setVersion",

    /**
     * Set version for specified product
     * @private
     * @param {String} product
     * @param {String} version
     */
    value: function setVersion(product, version) {
      product = product.toLowerCase();
      VH[product] = {
        version: version,
        isNewerThan: function isNewerThan(otherVersion) {
          return otherVersion < version;
        },
        isOlderThan: function isOlderThan(otherVersion) {
          return otherVersion > version;
        }
      };
      var bundleFor = ''; // Var productName is only defined in bundles, it is internal to bundle so not available on window. Used to
      // tell importing combinations of grid/scheduler/gantt bundles apart from loading same bundle twice
      // eslint-disable-next-line no-undef

      if (typeof productName !== 'undefined') {
        // eslint-disable-next-line no-undef
        bundleFor = productName;
      } // Set "global" flag to detect bundle being loaded twice


      var globalKey = "".concat(bundleFor, ".").concat(product).concat(version.replace(/\./g, '-'));

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isBrowserEnv) {
        if (window.bryntum[globalKey] === true) {
          if (isSiesta) {
            window.BUNDLE_EXCEPTION = true;
          } else {
            throw new Error('Bundle included twice, check cache-busters and file types (.js)');
          }
        } else {
          window.bryntum[globalKey] = true;
        }
      }
    }
    /**
     * Get (previously set) version for specified product
     * @private
     * @param {String} product
     */

  }, {
    key: "getVersion",
    value: function getVersion(product) {
      product = product.toLowerCase();

      if (!VH[product]) {
        throw new Error('No version specified! Please check that you import VersionHelper right into the class from where you call `deprecate` function.');
      }

      return VH[product].version;
    }
    /**
     * Checks the passed product against the passed version using the passed test.
     * @param {String} product The name of the product to test the version of
     * @param {String} version The version to test against
     * @param {String} test The test operator, `<=`, `<`, `=`, `>` or `>=`.
     * @returns {Boolean} `true` if the test passes.
     * @internal
     */

  }, {
    key: "checkVersion",
    value: function checkVersion(product, version, test) {
      var productVersion = VH.getVersion(product);
      var result;

      switch (test) {
        case '<':
          result = productVersion < version;
          break;

        case '<=':
          result = productVersion <= version;
          break;

        case '=':
          result = productVersion === version;
          break;

        case '>=':
          result = productVersion >= version;
          break;

        case '>':
          result = productVersion > version;
          break;
      }

      return result;
    }
    /**
     * Based on a comparison of current product version and the passed version this method either outputs a console.warn
     * or throws an error.
     * @param {String} product The name of the product
     * @param {String} invalidAsOfVersion The version where the offending code is invalid (when any compatibility layer
     * is actually removed).
     * @param {String} message Required! A helpful warning message to show to the developer using a deprecated API.
     * @internal
     */

  }, {
    key: "deprecate",
    value: function deprecate(product, invalidAsOfVersion, message) {
      var justWarn = VH.checkVersion(product, invalidAsOfVersion, '<');

      if (justWarn) {
        // During the grace period (until the next major release following the deprecated code), just show a console warning
        console.warn("Deprecation warning: You are using a deprecated API which will change in v".concat(invalidAsOfVersion, ". ").concat(message));
      } else {
        throw new Error("Deprecated API use. ".concat(message));
      }
    }
  }, {
    key: "isTestEnv",
    get: function get() {
      return isSiesta;
    }
  }]);

  return VersionHelper;
}();


var VH = VersionHelper;

if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isBrowserEnv) {
  (window.bryntum || (window.bryntum = {})).getVersion = VH.getVersion.bind(VH);
  window.bryntum.checkVersion = VH.checkVersion.bind(VH);
  window.bryntum.deprecate = VH.deprecate.bind(VH);
}

VersionHelper._$name = 'VersionHelper';
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../node_modules/process/browser.js */ "../node_modules/process/browser.js")))

/***/ }),

/***/ "./lib/Core/helper/WalkHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/WalkHelper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WalkHelper; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24__);

























var productName = 'scheduler';
/**
* @module Core/helper/WalkHelper
*/

/**
 * Tree walking helper
 * @internal
 */

var WalkHelper = /*#__PURE__*/function () {
  function WalkHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23___default()(this, WalkHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24___default()(WalkHelper, null, [{
    key: "preWalk",

    /**
     * Pre-walks any hierarchical data structure
     *
     * @param data Walking starting point
     * @param {Function} childrenFn Function to return `data` children entries in an array
     *                   or null if no children exists for the entry
     * @param {Function} fn Function to call on each entry
     */
    value: function preWalk(data, childrenFn, fn) {
      var walkStack = [data];
      var node, children;

      while (walkStack.length) {
        node = walkStack.pop();
        fn(node);
        children = childrenFn(node);

        if (children) {
          walkStack.push.apply(walkStack, children.slice().reverse());
        }
      }
    }
    /**
     * Pre-walks any hierarchical data structure, passing along a link to the parent node
     *
     * @param data Walking starting point
     * @param {Function} childrenFn Function to return `data` children entries in an array
     *                   or null if no children exists for the entry
     * @param {Function} fn Function to call on each entry, called with `parent` and `node`
     */

  }, {
    key: "preWalkWithParent",
    value: function preWalkWithParent(data, childrenFn, fn) {
      var walkStack = [{
        node: data,
        parent: null
      }];

      var _loop = function _loop() {
        var _walkStack$pop = walkStack.pop(),
            parent = _walkStack$pop.parent,
            node = _walkStack$pop.node;

        fn(parent, node);
        var children = childrenFn(node);

        if (children) {
          walkStack.push.apply(walkStack, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_22___default()(children.slice().reverse().map(function (child) {
            return {
              node: child,
              parent: node
            };
          })));
        }
      };

      while (walkStack.length) {
        _loop();
      }
    }
    /**
     * Pre-walk unordered.
     *
     * Like {@link #function-preWalk-static preWalk} but doesn't reverses children before walk,
     * thus children will be walked last child first - first child last
     *
     * @param data Walking starting point
     * @param {Function} childrenFn Function to return `data` children entries in an array
     *                   or null if no children exists for the entry
     * @param {Function} fn Function to call on each entry
     */

  }, {
    key: "preWalkUnordered",
    value: function preWalkUnordered(data, childrenFn, fn) {
      var walkStack = [data],
          node,
          children;

      while (walkStack.length) {
        node = walkStack[walkStack.length - 1];
        fn(node);
        children = childrenFn(node);

        if (children) {
          walkStack.splice.apply(walkStack, [walkStack.length - 1, 1].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_22___default()(children)));
        } else {
          walkStack.length = walkStack.length - 1;
        }
      }
    }
    /**
     * Post-walks any hierarchical data structure
     *
     * @param data Walking starting point
     * @param {Function} childrenFn Function to return `data` children entries in an array
     *                   or null if no children exists for the entry
     * @param {Function} fn Function to call on each entry
     */

  }, {
    key: "postWalk",
    value: function postWalk(data, childrenFn, fn) {
      var visited = new Map(),
          walkStack = [data],
          node,
          children;

      while (walkStack.length) {
        node = walkStack[walkStack.length - 1];

        if (visited.has(node)) {
          fn(node);
          walkStack.pop();
        } else {
          children = childrenFn(node);

          if (children) {
            walkStack = walkStack.concat(children.slice().reverse());
          }

          visited.set(node, node);
        }
      }
    }
    /**
     * Pre/Post-walks any hierarchical data structure calling inFn each node when it walks in,
     * and outFn when it walks out.
     *
     * @param data Walking starting point
     * @param {Function} childrenFn Function to return `data` children entries in an array
     *                   or null if no children exists for the entry
     * @param {Function} inFn  Function to call on each entry upon enter
     * @param {Function} outFn Function to call on each entry upon exit
     */

  }, {
    key: "prePostWalk",
    value: function prePostWalk(data, childrenFn, inFn, outFn) {
      var visited = new Map(),
          walkStack = [data],
          node,
          children;

      while (walkStack.length) {
        node = walkStack[walkStack.length - 1];

        if (visited.has(node)) {
          outFn(node);
          walkStack.pop();
        } else {
          inFn(node);
          children = childrenFn(node);

          if (children) {
            walkStack = walkStack.concat(children.slice().reverse());
          }

          visited.set(node, node);
        }
      }
    }
  }]);

  return WalkHelper;
}();


WalkHelper._$name = 'WalkHelper';

/***/ }),

/***/ "./lib/Core/helper/WidgetHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/WidgetHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetHelper; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/construct */ "./node_modules/@babel/runtime/helpers/construct.js");
/* harmony import */ var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _widget_Toast_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../widget/Toast.js */ "./lib/Core/widget/Toast.js");
/* harmony import */ var _widget_Mask_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony import */ var _util_Point_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./util/Point.js */ "./lib/Core/helper/util/Point.js");





var productName = 'scheduler';





/**
 * @module Core/helper/WidgetHelper
 */

/**
 * Helper for creating widgets.
 */

var WidgetHelper = /*#__PURE__*/function () {
  function WidgetHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, WidgetHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(WidgetHelper, null, [{
    key: "getById",
    //region Querying

    /**
     * Returns the widget with the specified id.
     * @param id Id of widget to find
     * @returns {Core.widget.Widget} The widget if any
     * @category Querying
     */
    value: function getById(id) {
      return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].getById(id);
    }
    /**
     * Returns the Widget which owns the passed element (or event).
     * @param {HTMLElement|Event} element The element or event to start from
     * @param {String|Function} [type] The type of Widget to scan upwards for. The lowercase
     * class name. Or a filter function which returns `true` for the required Widget.
     * @param {HTMLElement|Number} [limit] The number of components to traverse upwards to find a
     * match of the type parameter, or the element to stop at.
     * @returns {Core.widget.Widget} The found Widget or null.
     * @category Querying
     * @typings any
     */

  }, {
    key: "fromElement",
    value: function fromElement(element, type, limit) {
      return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].fromElement(element, type, limit);
    } //endregion
    //region Widgets

    /**
     * Create a widget.
     * @example
     * WidgetHelper.createWidget({
     *   type: 'button',
     *   icon: 'user',
     *   text: 'Edit user'
     * });
     * @param config Widget config
     * @returns {Object} The widget
     * @category Widgets
     */

  }, {
    key: "createWidget",
    value: function createWidget() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return config.isWidget ? config : _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].create(config);
    }
    /**
     * Appends a widget (array of widgets) to the DOM tree. If config is empty, widgets are appended to the DOM. To
     * append widget to certain position you can pass HTMLElement or its id as config, or as a config, that will be
     * applied to all passed widgets.
     *
     * Usage:
     *
     * ```javascript
     * // Will append button as last item to element with id 'container'
     * let [button] = WidgetHelper.append({ type : 'button' }, 'container');
     *
     * // Same as above, but will add two buttons
     * let [button1, button2] = WidgetHelper.append([
     *     { type : 'button' },
     *     { type : 'button' }
     *     ], { appendTo : 'container' });
     *
     * // Will append two buttons before element with id 'someElement'. Order will be preserved and all widgets will have
     * // additional class 'my-cls'
     * let [button1, button2] = WidgetHelper.append([
     *     { type : 'button' },
     *     { type : 'button' }
     *     ], {
     *         insertBefore : 'someElement',
     *         cls          : 'my-cls'
     *     });
     * ```
     *
     * @param {Object|Object[]} widget Widget config or array of such configs
     * @param {HTMLElement|String|Object} [config] Element (or element id) to which to append the widget or config to apply to all passed widgets
     * @returns {Core.widget.Widget[]} Array or widgets
     * @category Widgets
     */

  }, {
    key: "append",
    value: function append(widget, config) {
      widget = Array.isArray(widget) && widget || [widget];

      if (config instanceof HTMLElement || typeof config === 'string') {
        config = {
          appendTo: config
        };
      } // We want to fix position to insert into to keep order of passed widgets


      if (config.insertFirst) {
        var target = typeof config.insertFirst === 'string' ? document.getElementById(config.insertFirst) : config.insertFirst;

        if (target.firstChild) {
          config.insertBefore = target.firstChild;
        } else {
          config.appendTo = target;
        }
      }

      return widget.map(function (item) {
        return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].create(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({}, config || {}, item));
      });
    } //endregion
    //region Popups

    /**
     * Shows a popup (~tooltip) containing widgets connected to specified element.
     * @example
     * WidgetHelper.openPopup(element, {
     *   position: 'bottom center',
     *   items: [
     *      { widgetConfig }
     *   ]
     * });
     * @param element Element to connect popup to
     * @param config Config object, or string to use as html in popup
     * @returns {*|{close, widgets}}
     * @category Popups
     */

  }, {
    key: "openPopup",
    value: function openPopup(element, config) {
      return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].create(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
        forElement: element
      }, typeof config === 'string' ? {
        html: config
      } : config), 'popup');
    }
    /**
     * Shows a context menu connected to the specified element.
     * @example
     * WidgetHelper.showContextMenu(element, {
     *   items: [
     *      { id: 'addItem', icon: 'add', text: 'Add' },
     *      ...
     *   ],
     *   onItem: item => alert('Clicked ' + item.text)
     * });
     * @param {HTMLElement|Number[]} element Element (or a coordinate) to show the context menu for
     * @param {Object} config Context menu config, see example
     * @returns {*|{close}}
     * @category Popups
     */

  }, {
    key: "showContextMenu",
    value: function showContextMenu(element, config) {
      var me = this;

      if (me.currentContextMenu) {
        me.currentContextMenu.destroy();
      }

      if (element instanceof HTMLElement) {
        config.forElement = element;
      } else if (Array.isArray(element)) {
        config.forElement = {
          target: _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_1___default()(_util_Point_js__WEBPACK_IMPORTED_MODULE_9__["default"], _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default()(element))
        };
      } else if (element instanceof _util_Point_js__WEBPACK_IMPORTED_MODULE_9__["default"]) {
        config.forElement = {
          target: element
        };
      }

      me.currentContextMenu = _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].create(config, 'menu');
      me.currentContextMenu.on('destroy', function () {
        me.currentContextMenu = null;
      });
      return me.currentContextMenu;
    }
    /**
     * Attached a tooltip to the specified element.
     * @example
     * WidgetHelper.attachTooltip(element, {
     *   text: 'Useful information goes here'
     * });
     * @param element Element to attach tooltip for
     * @param configOrText Tooltip config or tooltip string, see example and source
     * @returns {Object}
     * @category Popups
     */

  }, {
    key: "attachTooltip",
    value: function attachTooltip(element, configOrText) {
      return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].attachTooltip(element, configOrText);
    }
    /**
     * Checks if element has tooltip attached
     *
     * @param element Element to check
     * @return {Boolean}
     * @category Popups
     */

  }, {
    key: "hasTooltipAttached",
    value: function hasTooltipAttached(element) {
      return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].resolveType('tooltip').hasTooltipAttached(element);
    }
    /**
     * Destroys any tooltip attached to an element, removes it from the DOM and unregisters any tip related listeners
     * on the element.
     *
     * @param element Element to remove tooltip from
     * @category Popups
     */

  }, {
    key: "destroyTooltipAttached",
    value: function destroyTooltipAttached(element) {
      return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].resolveType('tooltip').destroyTooltipAttached(element);
    } //endregion
    //region Mask

    /**
     * Masks the specified element, showing a message in the mask.
     * @param {HTMLElement} element Element to mask
     * @param {String} msg Message to show in the mask
     * @category Mask
     */

  }, {
    key: "mask",
    value: function mask(element) {
      var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Loading';

      if (element) {
        // Config object normalization
        if (element instanceof HTMLElement) {
          element = {
            target: element,
            text: msg
          };
        }

        return _widget_Mask_js__WEBPACK_IMPORTED_MODULE_8__["default"].mask(element, element.target);
      }
    }
    /**
     * Unmask the specified element.
     * @param {HTMLElement} element
     * @category Mask
     */

  }, {
    key: "unmask",
    value: function unmask(element) {
      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (element.mask) {
        if (close) {
          element.mask.close();
        } else {
          element.mask.hide();
        }
      }
    } //endregion
    //region Toast

    /**
     * Show a toast
     * @param {String} msg message to show in the toast
     * @category Mask
     */

  }, {
    key: "toast",
    value: function toast(msg) {
      return _widget_Toast_js__WEBPACK_IMPORTED_MODULE_7__["default"].show(msg);
    } //endregion

  }]);

  return WidgetHelper;
}();


WidgetHelper._$name = 'WidgetHelper';

/***/ }),

/***/ "./lib/Core/helper/mixin/DragHelperContainer.js":
/*!******************************************************!*\
  !*** ./lib/Core/helper/mixin/DragHelperContainer.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


 // TODO: Use mousedown pos and not center too reposition

/**
 * @module Core/helper/mixin/DragHelperContainer
 */

/**
 * Mixin for DragHelper that handles dragging elements between containers (or rearranging within)
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DragHelperContainer, _ref);

    var _super = _createSuper(DragHelperContainer);

    function DragHelperContainer() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DragHelperContainer);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DragHelperContainer, [{
      key: "initContainerDrag",
      //region Init

      /**
       * Initialize container drag mode.
       * @private
       */
      value: function initContainerDrag() {
        var me = this; //use container drag as default mode

        if (!me.mode) me.mode = 'container';
        if (me.mode === 'container' && !me.containers) throw new Error('Container drag mode must specify containers');
      } //endregion
      //region Grab, update, finish

      /**
       * Grab an element which can be dragged between containers.
       * @private
       * @param event
       * @returns {Boolean}
       */

    }, {
      key: "grabContainerDrag",
      value: function grabContainerDrag(event) {
        var me = this; // allow specified selectors to prevent drag

        if (!me.ignoreSelector || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(event.target, me.ignoreSelector)) {
          // go up from "handle" to draggable element
          var element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getAncestor(event.target, me.containers, me.outerElement);

          if (element) {
            var box = element.getBoundingClientRect();
            me.context = {
              element: element,
              valid: true,
              action: 'container',
              offsetX: event.pageX - box.left,
              offsetY: event.pageY - box.top,
              originalPosition: {
                parent: element.parentElement,
                prev: element.previousElementSibling,
                next: element.nextElementSibling
              }
            };
          }

          return true;
        }

        return false;
      }
      /**
       * Starts dragging, called when mouse moves first time after grabbing
       * @private
       * @param event
       */

    }, {
      key: "startContainerDrag",
      value: function startContainerDrag(event) {
        var context = this.context,
            dragElement = context.element,
            div = dragElement.cloneNode(true),
            box = dragElement.getBoundingClientRect(); // init drag proxy

        div.classList.add(this.dragProxyCls);
        div.classList.add(this.draggingCls);
        document.body.appendChild(div);
        context.dragProxy = div; // Always set the proxy element width manually, drag target could be sized with flex or % width

        div.style.width = box.width + 'px';
        div.style.height = box.height + 'px';
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateXY(context.dragProxy, box.left, box.top); // style dragged element

        context.dragging = dragElement;
        dragElement.classList.add(this.dropPlaceholderCls);
      }
      /**
       * Move the placeholder element into its new position on valid drag.
       * @private
       * @param event
       */

    }, {
      key: "updateContainerDrag",
      value: function updateContainerDrag(event) {
        var me = this,
            context = me.context;
        if (!context.started || !context.targetElement) return;
        var containerElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getAncestor(context.targetElement, me.containers, 'b-grid'),
            willLoseFocus = context.dragging && context.dragging.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].activeElement);

        if (containerElement && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isDescendant(context.element, containerElement)) {
          // dragging over part of self, do nothing
          return;
        } // The dragging element contains focus, and moving it within the DOM
        // will cause focus loss which might affect an encapsulating autoClose Popup.
        // Prevent focus loss handling during the DOM move.


        if (willLoseFocus) {
          _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_9__["default"].suspendFocusEvents();
        }

        if (containerElement && context.valid) {
          me.moveNextTo(containerElement, event);
        } else {
          // dragged outside of containers, revert position
          me.revertPosition();
        }

        if (willLoseFocus) {
          _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_9__["default"].resumeFocusEvents();
        }

        event.preventDefault();
      }
      /**
       * Finalize drag, fire drop.
       * @private
       * @param event
       * @fires drop
       */

    }, {
      key: "finishContainerDrag",
      value: function finishContainerDrag(event) {
        var _this = this;

        var me = this,
            context = me.context,
            dragging = context.dragging,
            dragProxy = context.dragProxy,
            valid = context.valid,
            draggedTo = context.draggedTo,
            insertBefore = context.insertBefore,
            originalPosition = context.originalPosition;

        if (dragging) {
          // needs to have a valid target
          context.valid = valid && draggedTo && ( // no drop on self or parent
          dragging !== insertBefore || originalPosition.parent !== draggedTo);

          context.finalize = function () {
            var valid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : context.valid;

            // revert if invalid (and context still exists, might have been aborted from outside)
            if (!valid && _this.context) {
              me.revertPosition();
            }

            dragging.classList.remove(me.dropPlaceholderCls);
            dragProxy.remove();
            me.reset();
          }; // allow async finalization by setting async to true on context in drop handler,
          // requires implementer to call context.finalize later to finish the drop


          context.async = false;
          me.trigger('drop', {
            context: context,
            event: event
          });

          if (!context.async) {
            // finalize immediately
            context.finalize();
          } else {
            context.awaitingFinalization = true;
          }
        }
      }
      /**
       * Aborts a drag operation.
       * @private
       * @param {Boolean} [invalid]
       * @param {Object} [event]
       * @param {Boolean} [silent]
       */

    }, {
      key: "abortContainerDrag",
      value: function abortContainerDrag() {
        var invalid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var me = this,
            context = me.context;

        if (context.dragging) {
          context.dragging.classList.remove(me.dropPlaceholderCls);
          context.dragProxy.remove();
          me.context = {};
        }

        if (!silent) {
          me.trigger(invalid ? 'drop' : 'abort', {
            context: context,
            event: event
          });
        }
      } //endregion
      //region Helpers

      /**
       * Starts a drag operation by creating a proxy and storing which element is being dragged.
       * @private
       */
      // startDrag() {
      //     const context = this.context,
      //           div      = context.element.cloneNode(true);
      //
      //     // init drag proxy
      //     div.classList.add('b-drag-proxy');
      //     document.body.appendChild(div);
      //     context.dragProxy = div;
      //
      //     // style dragged element
      //     context.dragging = context.element;
      //     context.dragging.classList.add('myClass');
      // }

      /**
       * Updates the drag proxy position.
       * @private
       * @param event
       */

    }, {
      key: "updateContainerProxy",
      value: function updateContainerProxy(event) {
        var me = this,
            context = me.context,
            proxy = context.dragProxy;
        var newX = event.pageX - context.offsetX,
            newY = event.pageY - context.offsetY;

        if (typeof me.minX === 'number') {
          newX = Math.max(me.minX, newX);
        }

        if (typeof me.maxX === 'number') {
          newX = Math.min(me.maxX - proxy.offsetWidth, newX);
        }

        if (typeof me.minY === 'number') {
          newY = Math.max(me.minY, newY);
        }

        if (typeof me.maxY === 'number') {
          newY = Math.min(me.maxY - proxy.offsetHeight, newY);
        }

        if (me.lockX) {
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateY(proxy, newY);
        } else if (me.lockY) {
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateX(proxy, newX);
        } else {
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateXY(proxy, newX, newY);
        }

        var targetElement;

        if (event.type === 'touchmove') {
          var touch = event.changedTouches[0];
          targetElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].elementFromPoint(touch.clientX, touch.clientY);
        } else {
          targetElement = event.target;
        }

        context.targetElement = targetElement;
      }
      /**
       * Positions element being dragged in relation to targetElement.
       * @private
       * @param targetElement
       * @param event
       */

    }, {
      key: "moveNextTo",
      value: function moveNextTo(targetElement, event) {
        var context = this.context,
            dragElement = context.dragging,
            parent = targetElement.parentElement;

        if (targetElement !== dragElement) {
          // dragged over a container and not over self, calculate where to insert
          var centerX = targetElement.getBoundingClientRect().left + targetElement.offsetWidth / 2;

          if (event.pageX < centerX) {
            // dragged left of target center, insert before
            parent.insertBefore(dragElement, targetElement);
            context.insertBefore = targetElement;
          } else {
            // dragged right of target center, insert after
            if (targetElement.nextElementSibling) {
              // check that not dragged to the immediate left of self. in such case, position should not change
              if (targetElement.nextElementSibling !== dragElement) {
                context.insertBefore = targetElement.nextElementSibling;
                parent.insertBefore(dragElement, targetElement.nextElementSibling);
              } else if (!context.insertBefore && dragElement.parentElement.lastElementChild !== dragElement) {
                // dragged left initially, should stay in place (checked in finishContainerDrag)
                // TODO: or flag as invalid drag? since no change...
                context.insertBefore = targetElement.nextElementSibling;
              }
            } else {
              parent.appendChild(dragElement);
              context.insertBefore = null;
            }
          }

          context.draggedTo = parent;
        }
      }
      /**
       * Moves element being dragged back to its original position.
       * @private
       */

    }, {
      key: "revertPosition",
      value: function revertPosition() {
        var context = this.context,
            original = context.originalPosition; // revert to correct location

        if (original.next) {
          var isNoop = original.next && original.next.previousSibling === context.dragging || !original.next && context.dragging === original.parent.lastChild;

          if (!isNoop) {
            original.parent.insertBefore(context.dragging, original.next);
          }
        } else {
          original.parent.appendChild(context.dragging);
        } // no target container


        context.draggedTo = null;
      } //endregion

    }], [{
      key: "$name",
      get: function get() {
        return 'DragHelperContainer';
      }
    }]);

    return DragHelperContainer;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);
});

/***/ }),

/***/ "./lib/Core/helper/mixin/DragHelperTranslate.js":
/*!******************************************************!*\
  !*** ./lib/Core/helper/mixin/DragHelperTranslate.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/helper/mixin/DragHelperTranslate
 */

var noScroll = {
  pageXOffset: 0,
  pageYOffset: 0
};
/**
 * Mixin for DragHelper that handles repositioning (translating) an element within its container
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Delayable) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(DragHelperTranslate, _Delayable);

    var _super = _createSuper(DragHelperTranslate);

    function DragHelperTranslate() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, DragHelperTranslate);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(DragHelperTranslate, [{
      key: "initTranslateDrag",
      //region Init

      /**
       * Initialize translation drag mode.
       * @private
       */
      value: function initTranslateDrag() {
        var me = this;
        me.mode = me.mode || 'translateXY';

        if (!me.isElementDraggable && me.targetSelector) {
          me.isElementDraggable = function (element) {
            return _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(element, me.targetSelector);
          };
        }
      } //endregion
      //region Grab, update, finish

      /**
       * Grab an element which can be moved using translation.
       * @private
       * @param event
       * @returns {Boolean}
       */

    }, {
      key: "grabTranslateDrag",
      value: function grabTranslateDrag(event) {
        var me = this,
            element = me.getTarget(event);

        if (element) {
          me.context = {
            valid: true,
            action: me.mode,
            // translateX or translateXY...
            element: element,
            startPageX: event.pageX,
            startPageY: event.pageY,
            startClientX: event.clientX,
            startClientY: event.clientY
          };
          return true;
        }

        return false;
      }
    }, {
      key: "getTarget",
      value: function getTarget(event) {
        return _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(event.target, this.targetSelector);
      }
      /**
       * Start translating, called on first mouse move after dragging
       * @private
       * @param event
       */

    }, {
      key: "startTranslateDrag",
      value: function startTranslateDrag(event) {
        var me = this,
            context = me.context,
            relatedElements = context.relatedElements;
        var element = context.dragProxy || context.element;

        if (element && !context.started) {
          var grabbed = element,
              grabbedParent = element.parentElement,
              // When cloning an element to be dragged, we place it in BODY by default
          dragWithin = me.dragWithin = me.dragWithin || me.cloneTarget && document.body,
              outerElement = me.outerElement;

          if (me.cloneTarget) {
            var offsetX = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getOffsetX(element, dragWithin),
                offsetY = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getOffsetY(element, dragWithin),
                offsetWidth = element.offsetWidth,
                offsetheight = element.offsetHeight;
            element = me.createProxy(element); // Match the grabbed element's size and position.

            _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateXY(element, offsetX, offsetY);
            element.style.width = "".concat(offsetWidth, "px");
            element.style.height = "".concat(offsetheight, "px");
            element.classList.add(me.dragProxyCls);
            dragWithin.appendChild(element);
            grabbed.classList.add('b-drag-original');

            if (me.hideOriginalElement) {
              grabbed.classList.add('b-hidden');
            }
          }

          Object.assign(me.context, {
            // The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
            element: element,
            // The original element upon which the mousedown event triggered a drag operation
            grabbed: grabbed,
            // The parent of the original element where the pointerdown was detected - to be able to restore after an invalid drop
            grabbedParent: grabbedParent,
            // The next sibling of the original element where the pointerdown was detected - to be able to restore after an invalid drop
            grabbedNextSibling: element.nextElementSibling,
            // elements position within parent element
            elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateX(element),
            elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateY(element),
            elementX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getOffsetX(element, dragWithin || outerElement),
            elementY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getOffsetY(element, dragWithin || outerElement),
            scrollX: 0,
            scrollY: 0,
            scrollManagerElementContainsDragProxy: !me.cloneTarget || dragWithin === outerElement
          });
          element.classList.add(me.draggingCls);

          if (dragWithin) {
            context.parentElement = element.parentElement;

            if (dragWithin !== element.parentElement) {
              dragWithin.appendChild(element);
            }

            me.updateTranslateProxy(event);
          }

          if (relatedElements) {
            relatedElements.forEach(function (r) {
              r.classList.add(me.draggingCls);
            });
          }
        }
      }
      /**
       * Limit translation to outer bounds and specified constraints
       * @private
       * @param element
       * @param x
       * @param y
       * @returns {{constrainedX: *, constrainedY: *}}
       */

    }, {
      key: "applyConstraints",
      value: function applyConstraints(element, x, y) {
        var me = this,
            dragWithin = me.dragWithin,
            _ref = dragWithin === document.body ? window : noScroll,
            pageXOffset = _ref.pageXOffset,
            pageYOffset = _ref.pageYOffset; // limit to outer elements edges


        if (dragWithin && me.constrain) {
          if (x < 0) x = 0;
          if (x + element.offsetWidth > dragWithin.scrollWidth) x = dragWithin.scrollWidth - element.offsetWidth;
          if (y < 0) y = 0;
          if (y + element.offsetHeight > dragWithin.scrollHeight) y = dragWithin.scrollHeight - element.offsetHeight;
        } // limit horizontally


        if (typeof me.minX === 'number') {
          x = Math.max(me.minX + pageXOffset, x);
        }

        if (typeof me.maxX === 'number') {
          x = Math.min(me.maxX + pageXOffset, x);
        } // limit vertically


        if (typeof me.minY === 'number') {
          y = Math.max(me.minY + pageYOffset, y);
        }

        if (typeof me.maxY === 'number') {
          y = Math.min(me.maxY + pageYOffset, y);
        }

        return {
          constrainedX: x,
          constrainedY: y
        };
      }
      /**
       * Update elements translation on mouse move.
       * @private
       * @param event
       */

    }, {
      key: "updateTranslateProxy",
      value: function updateTranslateProxy(event, scrollManagerConfig) {
        var me = this,
            mode = me.mode,
            lockX = me.lockX,
            lockY = me.lockY,
            context = me.context,
            element = context.dragProxy || context.element,
            relatedElements = context.relatedElements,
            relatedElDragFromPos = context.relatedElDragFromPos; // If we are cloning the dragged element outside of the element(s) monitored by the ScrollManager, then no need to take the scrollManager scroll values into account
        // since it is only relevant when dragProxy is inside the Grid (where scroll manager operates).

        if (context.scrollManagerElementContainsDragProxy && scrollManagerConfig) {
          context.scrollX = scrollManagerConfig.scrollRelativeLeft;
          context.scrollY = scrollManagerConfig.scrollRelativeTop;
        }

        context.pageX = event.pageX;
        context.pageY = event.pageY;
        context.clientX = event.clientX;
        context.clientY = event.clientY;

        var newX = context.elementStartX + event.pageX - context.startPageX + context.scrollX,
            newY = context.elementStartY + event.pageY - context.startPageY + context.scrollY,
            _me$applyConstraints = me.applyConstraints(element, newX, newY),
            constrainedX = _me$applyConstraints.constrainedX,
            constrainedY = _me$applyConstraints.constrainedY;

        if (mode === 'translateXY' && !(lockX || lockY)) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateXY(element, constrainedX, constrainedY);
        } else if (mode === 'translateX' || lockY) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateX(element, constrainedX);
        } else if (mode === 'translateY' || lockX) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateY(element, constrainedY);
        }

        if (relatedElements) {
          var deltaX = !lockX && mode !== 'translateY' ? constrainedX - context.elementStartX : 0,
              deltaY = !lockY && mode !== 'translateX' ? constrainedY - context.elementStartY : 0;
          relatedElements.forEach(function (r, i) {
            var _relatedElDragFromPos = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default()(relatedElDragFromPos[i], 2),
                x = _relatedElDragFromPos[0],
                y = _relatedElDragFromPos[1];

            _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateXY(r, x + deltaX, y + deltaY);
          });
        }

        context.newX = constrainedX;
        context.newY = constrainedY;
      }
      /**
       * Finalize drag, fire drop.
       * @private
       * @param event
       * @fires drop
       */

    }, {
      key: "finishTranslateDrag",
      value: function finishTranslateDrag(event) {
        var me = this,
            context = me.context,
            xChanged = context.newX !== context.elementStartX,
            yChanged = context.newY !== context.elementStartY,
            element = context.dragProxy || context.element,
            relatedElements = context.relatedElements;

        function cleanUp() {
          element.classList.remove(me.invalidCls);
          element.classList.remove(me.draggingCls);

          if (relatedElements) {
            relatedElements.forEach(function (r) {
              r.classList.remove(me.invalidCls);
              r.classList.remove(me.draggingCls);
            });
          } // If we're currently aborting, the b-hidden CSS class will be removed after animation is complete


          if (!element.classList.contains('b-aborting')) {
            if (me.hideOriginalElement) {
              context.grabbed.classList.remove('b-hidden');
            }

            context.grabbed.classList.remove('b-drag-original');
          }
        }

        if (!me.ignoreSamePositionDrop || me.mode !== 'translateY' && xChanged || me.mode !== 'translateX' && yChanged) {
          if (context.valid === false) {
            me.abortTranslateDrag(true, event);
          } else {
            var targetRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_15__["default"].from(me.dragWithin || me.outerElement);

            if (!me.minX && event.pageX < targetRect.left || !me.maxX && event.pageX > targetRect.right || !me.minY && event.pageY < targetRect.top || !me.maxY && event.pageY > targetRect.bottom) {
              // revert location when dropped outside allowed element
              context.valid = false;
              me.abortTranslateDrag(true, event);
            } else {
              context.finalize = function () {
                var valid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : context.valid;

                if (context.asyncCleanup) {
                  cleanUp();
                } // abort if invalid (and context still exists, might have been aborted from outside)


                if (!valid && me.context) {
                  // abort if flagged as invalid, without triggering abort or drop again
                  me.abortTranslateDrag(true, null, true);
                } else if (me.cloneTarget || context.dragProxy) {
                  element.remove();
                }

                me.reset();
              }; // allow async finalization by setting async to true on context in drop handler,
              // requires implementer to call context.finalize later to finish the drop


              context.async = false;
              me.trigger('drop', {
                context: context,
                event: event
              });

              if (!context.async) {
                // finalize immediately
                context.finalize();
              } else {
                context.awaitingFinalization = true;
              }
            }
          }

          if (!context.asyncCleanup) {
            cleanUp();
          }
        } else {
          // no change, abort but not as invalid
          me.abortTranslateDrag(false, event);
        }
      }
      /**
       * Abort translation
       * @private
       * @param invalid
       * @fires abort
       */

    }, {
      key: "abortTranslateDrag",
      value: function abortTranslateDrag() {
        var invalid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var me = this,
            context = me.context,
            relatedElements = context.relatedElements,
            relatedElStartPos = context.relatedElStartPos,
            grabbed = context.grabbed,
            element = context.dragProxy || context.element,
            resetEl = me.cloneTarget && me.hideOriginalElement ? grabbed : element;
        var elementStartX = context.elementStartX,
            elementStartY = context.elementStartY;

        if (element && context.started) {
          // Put the dragged element back where it was
          if (!me.cloneTarget && me.dragWithin && me.dragWithin !== context.grabbedParent) {
            context.grabbedParent.insertBefore(element, context.grabbedNextSibling);
          }

          grabbed.classList.remove('b-hidden'); // Align the now visible grabbed element with the clone, so that it looks like it's
          // sliding back into place when the clone is removed

          if (me.cloneTarget) {
            if (me.hideOriginalElement) {
              var _DomHelper$getTransla = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getTranslateXY(grabbed);

              var _DomHelper$getTransla2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default()(_DomHelper$getTransla, 2);

              elementStartX = _DomHelper$getTransla2[0];
              elementStartY = _DomHelper$getTransla2[1];
              _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].alignTo(grabbed, element); // The getBoundingClientRect is important. The aligning above must be processed
              // by a forced synchronous layout *before* the b-aborting class is added below.

              resetEl.getBoundingClientRect();
            }

            element.remove();
          } // animated restore of position.


          resetEl.classList.add('b-aborting'); // Move the elements back to their original positions.

          if (me.mode === 'translateXY' && !(me.lockX || me.lockY)) {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateXY(resetEl, elementStartX, elementStartY);
            relatedElements && relatedElements.forEach(function (element, i) {
              element.classList.add('b-aborting');
              _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateXY(element, relatedElStartPos[i][0], relatedElStartPos[i][1]);
            });
          }

          if (me.mode === 'translateX' || me.lockY) {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateX(resetEl, elementStartX);
            relatedElements && relatedElements.forEach(function (element, i) {
              element.classList.add('b-aborting');
              _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateX(element, relatedElStartPos[i][0]);
            });
          }

          if (me.mode === 'translateY' || me.lockX) {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateY(resetEl, elementStartY);
            relatedElements && relatedElements.forEach(function (element, i) {
              element.classList.add('b-aborting');
              _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].setTranslateY(element, relatedElStartPos[i][1]);
            });
          }

          me.setTimeout(function () {
            resetEl.classList.remove('b-aborting');
            grabbed.classList.remove('b-dragging');
            grabbed.classList.remove('b-drag-original');

            if (!me.cloneTarget) {
              relatedElements && relatedElements.forEach(function (element, i) {
                element.classList.remove('b-aborting');
              });
              element.classList.remove('b-aborting');
              element.classList.remove(me.draggingCls);
              element.classList.remove(me.invalidCls);
            }
          }, me.transitionDuration, undefined, true);

          if (!silent) {
            me.trigger(invalid ? 'drop' : 'abort', {
              context: context,
              event: event
            });
          }
        }

        me.reset();
      } //endregion

    }], [{
      key: "$name",
      get: function get() {
        return 'DragHelperTranslate';
      }
    }]);

    return DragHelperTranslate;
  }(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_14__["default"])(Target || _Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]));
});

/***/ }),

/***/ "./lib/Core/helper/util/DataGenerator.js":
/*!***********************************************!*\
  !*** ./lib/Core/helper/util/DataGenerator.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DataGenerator; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./RandomGenerator.js */ "./lib/Core/helper/util/RandomGenerator.js");
/* harmony import */ var _DateHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../DateHelper.js */ "./lib/Core/helper/DateHelper.js");






var productName = 'scheduler';



var DataGenerator = /*#__PURE__*/function () {
  function DataGenerator() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, DataGenerator);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(DataGenerator, null, [{
    key: "reset",
    //region Random
    value: function reset() {
      this.rnd.reset();
      this.rndTime.reset();
      this.rndRating.reset();
    } //endregion
    //region Generate data

  }, {
    key: "generate",
    value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function generate(count) {
      var randomHeight,
          initialId,
          me,
          rnd,
          rndTime,
          rndRating,
          firstNames,
          surNames,
          teams,
          foods,
          colors,
          cities,
          i,
          firstName,
          surName,
          name,
          startDay,
          start,
          finish,
          row,
          _args = arguments;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function generate$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              randomHeight = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              initialId = _args.length > 2 && _args[2] !== undefined ? _args[2] : 1;
              me = this, rnd = me.rnd, rndTime = me.rndTime, rndRating = me.rndRating, firstNames = me.firstNames, surNames = me.surNames, teams = me.teams, foods = me.foods, colors = me.colors, cities = me.cities;
              i = 0;

            case 4:
              if (!(i < count)) {
                _context.next = 12;
                break;
              }

              firstName = rnd.fromArray(firstNames), surName = rnd.fromArray(surNames), name = "".concat(firstName, " ").concat(String.fromCharCode(65 + i % 25), " ").concat(surName), startDay = rnd.nextRandom(60) + 1, start = new Date(2019, 0, startDay), finish = new Date(2019, 0, startDay + rnd.nextRandom(30) + 2), row = {
                id: i + initialId,
                title: 'Row ' + i,
                name: name,
                firstName: firstName,
                surName: surName,
                city: rnd.fromArray(cities),
                team: rnd.fromArray(cities) + ' ' + rnd.fromArray(teams),
                age: 10 + rnd.nextRandom(80),
                food: rnd.fromArray(foods),
                color: rnd.fromArray(colors),
                score: rnd.nextRandom(100) * 10,
                rank: rnd.nextRandom(100) + 1,
                start: start,
                finish: finish,
                time: _DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getTime(rndTime.nextRandom(24), rndTime.nextRandom(12) * 5),
                percent: rnd.nextRandom(100),
                done: rnd.nextRandom(100) < 50,
                rating: rndRating.nextRandom(5),
                relatedTo: Math.min(count - 1, i + initialId + rnd.nextRandom(10))
              };

              if (randomHeight) {
                row.rowHeight = rnd.nextRandom(randomHeight === true ? 20 : randomHeight) * 5 + 20;
              }

              _context.next = 9;
              return row;

            case 9:
              i++;
              _context.next = 4;
              break;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, generate, this);
    }) // Param reset defaults to true to ensure we get the same dataset on consecutive calls. Without it, code editor
    // reloading modules yields different data each time

  }, {
    key: "generateData",
    value: function generateData(count) {
      var randomHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var initialId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      if (reset) this.reset();
      var rows = [],
          number = DataGenerator.overrideRowCount ? DataGenerator.overrideRowCount : count,
          generator = this.generate(number, randomHeight, initialId);

      for (var i = 0; i < number; i++) {
        rows.push(generator.next().value);
      }

      return rows;
    } //endregion

  }]);

  return DataGenerator;
}();


Object.assign(DataGenerator, {
  rnd: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_6__["default"](),
  rndTime: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_6__["default"](),
  rndRating: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_6__["default"](),
  cities: ['Stockholm', 'Barcelona', 'Paris', 'Dubai', 'New York', 'San Francisco', 'Washington', 'Moscow'],
  firstNames: ['Mike', 'Linda', 'Don', 'Karen', 'Doug', 'Jenny', 'Daniel', 'Melissa', 'John', 'Jane', 'Theo', 'Lisa', 'Adam', 'Mary', 'Barbara', 'James', 'David'],
  surNames: ['McGregor', 'Ewans', 'Scott', 'Smith', 'Johnson', 'Adams', 'Williams', 'Brown', 'Jones', 'Miller', 'Davis', 'More', 'Wilson', 'Taylor', 'Anderson', 'Thomas', 'Jackson'],
  teams: ['Lions', 'Eagles', 'Tigers', 'Horses', 'Dogs', 'Cats', 'Panthers', 'Rats', 'Ducks', 'Cougars', 'Hens', 'Roosters'],
  foods: ['Pancake', 'Burger', 'Fish n chips', 'Carbonara', 'Taco', 'Salad', 'Bolognese', 'Mac n cheese', 'Waffles'],
  colors: ['Blue', 'Green', 'Red', 'Yellow', 'Pink', 'Purple', 'Orange', 'Teal', 'Black']
});
DataGenerator._$name = 'DataGenerator';

/***/ }),

/***/ "./lib/Core/helper/util/DemoBot.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/util/DemoBot.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DemoBot; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.repeat */ "./node_modules/core-js/modules/es.string.repeat.js");
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






var knownProps = ['action', 'target', 'to', 'deltaX', 'deltaY', 'x', 'y', 'text'];

var DemoBot = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(DemoBot, _Events);

  var _super = _createSuper(DemoBot);

  function DemoBot() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, DemoBot);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(DemoBot, [{
    key: "construct",
    // expects an outer element (grid.element/scheduler.element) and an array of steps similar to chain steps in siesta
    value: function construct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(DemoBot.prototype), "construct", this).call(this, config);

      var me = this;

      if (me.widget) {
        me.outerElement = me.widget.element;
        me.widget.playingDemo = true;
      }

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].playingDemo = true;
      Object.assign(me, {
        prevTarget: null,
        currentStep: 0,
        mouse: _DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].createElement({
          parent: me.outerElement,
          tag: 'div',
          className: 'simulated-mouse'
        }),
        timeoutId: null,
        innerIntervalId: null,
        mouseOutElements: []
      });
      me.intervalId = me.setInterval(me.nextStep.bind(me), 1000);
      me.outerElement.classList.add('b-playing-demo');
      me.outerElement.addEventListener('click', function (event) {
        if (event.isTrusted) {
          me.abort();
        }
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.abort();
    } // stops the bot

  }, {
    key: "abort",
    value: function abort() {
      var atEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this;
      me.mouse.style.top = '-100px';
      me.clearInterval(me.intervalId);
      me.timeoutId && me.clearTimeout(me.timeoutId);
      me.innerIntervalId && me.clearInterval(me.innerIntervalId);
      me.outerElement.classList.remove('b-playing-demo');

      if (me.widget) {
        me.widget.playingDemo = false;
      }

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].playingDemo = false;
      me.trigger(atEnd ? 'done' : 'abort');
    } // triggers a synthetic event

  }, {
    key: "triggerEvent",
    value: function triggerEvent(element, type, data) {
      if (!element) return null;
      var event;

      if (type.startsWith('mouse')) {
        var box = this.mouse.getBoundingClientRect();
        event = new MouseEvent(type, Object.assign({
          view: window,
          bubbles: true,
          cancelable: true,
          clientX: box.left,
          clientY: box.top
        }, data || {}));
      } else {
        event = document.createEvent('Event');
        event.initEvent(type, true, false);
      }

      element.dispatchEvent(event);
      return event;
    } // moves mouse to target in 10 steps, with animated transition between steps

  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(step, target) {
      var me = this,
          mouse = me.mouse;
      mouse.classList.add('quick');
      if (me.mouseDown) mouse.classList.add('drag');
      var mouseBox = _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__["default"].from(mouse, me.outerElement),
          x = mouseBox.x,
          y = mouseBox.y;
      var deltaX = 0,
          deltaY = 0;

      if (step.to) {
        if (typeof step.to === 'string') {
          var toElement = me.outerElement.querySelector(step.to);

          if (toElement) {
            var rect = _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__["default"].from(toElement, me.outerElement),
                toX = rect.x + rect.width / 2,
                toY = rect.y + rect.height / 2;
            deltaX = (toX - x) / 10;
            deltaY = (toY - y) / 10;
          }
        } else if (step.to.x) {
          deltaX = (step.to.x - x) / 10;
        } else {
          deltaX = step.to[0] / 10;
          deltaY = step.to[1] / 10;
        }
      } else if (step.deltaX) {
        deltaX = step.deltaX / 10;
      } else if (step.x) {
        deltaX = (step.x - x) / 10;
      }

      if (step.deltaY) {
        deltaY = step.deltaY / 10;
      }

      var i = 0;
      me.innerIntervalId = me.setInterval(function () {
        // Only move mouse if in view and not scrolling
        if (me.shouldPause) {
          return;
        }

        if (i++ === 9) {
          clearInterval(me.innerIntervalId);

          if (step.then) {
            step.then();
          }
        }

        var mouseX = x + deltaX * i,
            mouseY = y + deltaY * i; // Move mouse there also

        mouse.style.left = mouseX + 'px';
        mouse.style.top = mouseY + 'px';
        var mouseBounds = mouse.getBoundingClientRect(),
            clientX = mouseBounds.left,
            clientY = mouseBounds.top,
            eventTarget = _DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].elementFromPoint(clientX, clientY);

        if (eventTarget !== me.prevTarget) {
          if (me.prevTarget) {
            me.mouseOutElements.push(me.prevTarget);

            if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].isDescendant(me.mouseOutElements[0], eventTarget)) {
              me.mouseOutElements.forEach(function (element) {
                return me.triggerEvent(element, 'mouseout');
              });
              me.mouseOutElements.length = 0;
            }
          }

          me.prevTarget = eventTarget;
          me.triggerEvent(eventTarget, 'mouseover');
        }

        me.triggerEvent(eventTarget, step.action, {
          clientX: clientX,
          clientY: clientY
        });
      }, 50);
    } // target can be a string selector, a function or blank to use last target or outerElement if first time

  }, {
    key: "getTarget",
    value: function getTarget(step) {
      var me = this,
          target = step.target;

      if (!target) {
        return me.prevTarget || me.outerElement;
      }

      if (typeof target === 'function') {
        return target(step);
      }

      return document.querySelector(target);
    } // action can be a function, a string or extracted from a property by scanning for unknown names

  }, {
    key: "normalizeStep",
    value: function normalizeStep(step) {
      if (step.action) {
        if (typeof step.action === 'function') {
          return step.action(step);
        }

        return step;
      }

      if (typeof step === 'function') {
        step();
        return step;
      } // try to find action among properties


      for (var prop in step) {
        if (Object.hasOwnProperty.call(step, prop) && !knownProps.includes(prop)) {
          step.action = prop.toLowerCase();
          step.to = step[prop];
        }
      }

      if (!step.target && (typeof step.to === 'string' || typeof step.to === 'function')) step.target = step.to;
      return step;
    }
  }, {
    key: "nextStep",
    // process the next step
    value: function nextStep() {
      var me = this; // Only perform step if in view and not scrolling

      if (me.shouldPause) {
        return;
      }

      if (me.currentStep === me.steps.length) {
        if (me.repeat) {
          me.currentStep = 0;
        } else {
          return me.abort(true);
        }
      } // First step, signal to let demo initialize stuff


      if (me.currentStep === 0) {
        me.trigger('initialize');
      }

      var mouse = me.mouse,
          step = me.normalizeStep(me.steps[me.currentStep++]),
          target = me.getTarget(step),
          action = step.action;

      if (target && action) {
        mouse.className = 'simulated-mouse';

        if (action === 'mousemove') {
          me.handleMouseMove(step, target);
        } else {
          // First move mouse into position
          if (target !== me.prevTarget) {
            var rect = _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__["default"].from(target, me.outerElement);
            mouse.style.left = rect.x + rect.width / 2 + 'px';
            mouse.style.top = rect.y + rect.height / 2 + 'px';
          }

          if (action === 'mousedown') {
            me.mouseDown = true;
          }

          if (action === 'mouseup') {
            me.mouseDown = false;
          } // Then trigger action


          me.timeoutId = me.setTimeout(function () {
            me.prevTarget = target; // Animate click etc.

            mouse.classList.add(action);

            if (action === 'type') {
              var field = _widget_Widget_js__WEBPACK_IMPORTED_MODULE_19__["default"].fromElement(target),
                  parts = step.text.split('|');
              field.value = parts[parts.length === 1 || field.value != parts[0] ? 0 : 1];
            } else {
              me.triggerEvent(target, action);
            }
          }, action === 'type' ? 100 : 550);
        }
      }
    }
  }, {
    key: "isScrolling",
    get: function get() {
      var me = this,
          box = me.outerElement.getBoundingClientRect(),
          scrolled = me.lastTop && box.top !== me.lastTop;
      me.lastTop = box.top;
      return scrolled;
    }
  }, {
    key: "isInView",
    get: function get() {
      var box = this.outerElement.getBoundingClientRect();
      return box.top < window.innerHeight && box.bottom > 0;
    }
  }, {
    key: "shouldPause",
    get: function get() {
      return !this.isInView || this.isScrolling || document.hidden || !document.hasFocus();
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        repeat: true,
        outerElement: document.body,
        callOnFunctions: true
      };
    }
  }]);

  return DemoBot;
}(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_20__["default"])(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_22__["default"])()));


DemoBot._$name = 'DemoBot';

/***/ }),

/***/ "./lib/Core/helper/util/DomClassList.js":
/*!**********************************************!*\
  !*** ./lib/Core/helper/util/DomClassList.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomClassList; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");

























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';

/**
 * @module Core/helper/util/DomClassList
 */

/**
 * This class encapsulates a list of CSS classes which can be set as the `className`
 * on an `HTMLElement`.
 *
 * Properties names set on this class equate to *adding* a class if the property's value
 * is _truthy_, or removing a class if the value is _falsy_.
 *
 * ```javascript
 * const myClassList = new DomClassList('b-test-button');
 *
 * myClassList.add('test-class');
 * myClassList.important = 1;
 *
 * myHtmlElement.className = myClassList; // Sets it to "b-test-button test-class important"
 * ```
 */

var DomClassList = /*#__PURE__*/function () {
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(DomClassList, null, [{
    key: "change",
    value: function change(cls, add, remove) {
      var as = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'string';
      remove = DomClassList.normalize(remove, 'object');
      var after = DomClassList.normalize(cls, 'array').filter(function (c) {
        return !remove[c];
      });

      if (add) {
        add = DomClassList.normalize(add, 'array');

        for (var i = 0; i < add.length; ++i) {
          if (!after.includes(add[i])) {
            after.push(add[i]);
          }
        }
      }

      return DomClassList.normalize(after, as);
    }
    /**
     *
     * @param {String|String[]|Object|HTMLElement} cls
     * @param {String} as Pass `'object'` to return an object with the class names as its
     * keys (all keys will have a value of `true`), or pass `'array'` to return an array
     * of class names, or pass `'string'` (the default) to return a space-separated string
     * of class names,
     * @returns {String|String[]|Object}
     * @private
     */

  }, {
    key: "normalize",
    value: function normalize(cls) {
      var as = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
      cls = cls || ''; // promote null to '' to avoid typeof snag

      var type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_21___default()(cls),
          asArray = as === 'array',
          asObject = as === 'object',
          asString = !asArray && !asObject;

      var isString = type === 'string',
          c,
          ret;

      if (type === 'object') {
        if (cls.nodeType === 1 && typeof cls.getAttribute === 'function') {
          cls = cls.getAttribute('class'); // cannot use className for SVG el's

          isString = true;
        } else if (!Array.isArray(cls)) {
          cls = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getTruthyKeys(cls);
        }
      }

      if (isString) {
        if (asString) {
          return cls;
        }

        cls = cls.split(' ');
      } // ret is now an array


      if (asArray) {
        ret = cls;
      } else if (asString) {
        ret = cls.join(' ');
      } else {
        ret = Object.create(null);

        var _iterator = _createForOfIteratorHelper(cls),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            c = _step.value;
            ret[c] = true;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return ret;
    }
    /**
     * Initializes a new DomClassList.
     * @param {String} classes CSS classes to create with
     * @function constructor
     */

  }]);

  function DomClassList() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default()(this, DomClassList);

    for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
      classes[_key] = arguments[_key];
    }

    if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_21___default()(classes[0]) === 'object') {
      Object.assign(this, classes[0]);
    } else {
      this.process(1, classes);
    } // String value needs recalculating


    this[dirtySymbol] = true;
  }
  /**
   * Returns a clone of this DomClassList with all the same keys set.
   * @returns {Core.helper.util.DomClassList} A clone of this DomClassList.
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(DomClassList, [{
    key: "clone",
    value: function clone() {
      return new DomClassList(this);
    }
    /**
     * Returns a Boolean value, indicating whether this ClassList has the specified CSS class name.
     * @param {String} className CSS class name to check
     * @return {Boolean} true if this ClassList contains the passed CSS class name, false otherwise
     */

  }, {
    key: "contains",
    value: function contains(className) {
      if (typeof className === 'string' && className) {
        return Boolean(this[className]);
      }

      return false;
    } // An instance of this class may be assigned directly to an element's className
    // it will be coerced to a string value using this method.

  }, {
    key: "toString",
    value: function toString() {
      // Adding space at the end if there is content to make concatenation code simpler in renderers.
      return this.length ? "".concat(this.value, " ") : '';
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toString();
    }
    /**
     * Analogous to string.trim, returns the string value of this `DomClassList` with no trailing space.
     * @returns {String} A concatenated string value of all the class names in this `DomClassList`
     * separated by spaces.
     */

  }, {
    key: "trim",
    value: function trim() {
      return this.value;
    }
    /**
     * Compares this ClassList to another ClassList (or class name string of space separated classes).
     * If the *same class names, regardless of order* are present, the two are considered equal.
     *
     * So `new DomClassList('foo bar bletch').isEqual('bletch bar foo')` would return `true`
     * @param {Core.helper.util.DomClassList|String} other The `DomClassList` or string of classes to compare to.
     * @returns {Boolean} `true` if the two contain the same class names.
     */

  }, {
    key: "isEqual",
    value: function isEqual(other) {
      if (typeof other === 'string') {
        testClassList.value = other;
        other = testClassList;
      }

      if (this.length === other.length) {
        var otherClasses = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getTruthyKeys(other);

        for (var i = 0, len = otherClasses.length; i < len; i++) {
          if (!this[otherClasses[i]]) {
            return false;
          }
        }

        return true;
      }

      return false;
    }
    /**
     * Get/set string value.
     * Class names separated with space.
     * @property {String}
     */

  }, {
    key: "process",
    value: function process(value, classes) {
      var len = classes.length;

      for (var i = 0; i < len; i++) {
        if (classes[i]) {
          var cls = classes[i],
              splitClasses = cls.values ? Array.from(cls.values()) : cls.item ? Array.from(cls) : cls.split(whiteSpaceRe),
              _len2 = splitClasses.length;

          for (var _i = 0; _i < _len2; _i++) {
            if (splitClasses[_i]) {
              this[splitClasses[_i]] = value;
            }
          }
        }
      } // String value needs recalculating


      this[dirtySymbol] = true;
      return this;
    }
    /**
     * Add CSS class(es)
     * ```
     * myClassList.add('bold', 'small');
     * ```
     * @param {String} classes CSS classes to add
     */

  }, {
    key: "add",
    value: function add() {
      for (var _len3 = arguments.length, classes = new Array(_len3), _key2 = 0; _key2 < _len3; _key2++) {
        classes[_key2] = arguments[_key2];
      }

      return this.process(1, classes);
    }
    /**
     * Remove CSS class(es)
     * ```
     * myClassList.remove('bold', 'small');
     * ```
     * @param {String} classes CSS classes to remove
     */

  }, {
    key: "remove",
    value: function remove() {
      for (var _len4 = arguments.length, classes = new Array(_len4), _key3 = 0; _key3 < _len4; _key3++) {
        classes[_key3] = arguments[_key3];
      }

      return this.process(0, classes);
    }
    /**
     * Analogous to the `String#split` method, but with no delimiter
     * parameter. This method returns an array containing the individual
     * CSS class names set.
     * @returns {String[]} The individual class names in this `DomClassList`
     */

  }, {
    key: "split",
    value: function split() {
      return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getTruthyKeys(this);
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getTruthyKeys(this).forEach(fn);
    } // To gain some speed in DomHelper.sync(), faster than instanceof etc

  }, {
    key: "value",
    get: function get() {
      var me = this;

      if (me[dirtySymbol]) {
        var keys = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getTruthyKeys(me);
        me[lengthSymbol] = keys.length;
        me[valueSymbol] = keys.join(' ');
        me[dirtySymbol] = false;
      }

      return me[valueSymbol];
    },
    set: function set(value) {
      var me = this,
          keys = Object.keys(me),
          len = keys.length;

      for (var i = 0; i < len; i++) {
        delete me[keys[i]];
      }

      if (value) {
        me.process(1, [value]);
      } else {
        // String value needs recalculating
        me[dirtySymbol] = true;
      }
    }
    /**
     * Returns string values as an array.
     * @readonly
     * @property {String[]}
     */

  }, {
    key: "values",
    get: function get() {
      return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getTruthyKeys(this);
    }
  }, {
    key: "length",
    get: function get() {
      // Maintainer: We MUST access the value getter to force
      // the value to be calculated if it's currently dirty.
      return this.value ? this[lengthSymbol] : 0;
    }
  }, {
    key: "isDomClassList",
    get: function get() {
      return true;
    }
  }]);

  return DomClassList;
}();


;
var whiteSpaceRe = /\s+/,
    valueSymbol = Symbol('value'),
    lengthSymbol = Symbol('length'),
    dirtySymbol = Symbol('dirty'),
    testClassList = new DomClassList();
DomClassList._$name = 'DomClassList';

/***/ }),

/***/ "./lib/Core/helper/util/Formatter.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/util/Formatter.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Formatter; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__);






















var productName = 'scheduler';
var hasOwnProperty = Object.prototype.hasOwnProperty;
var cacheKey = null;

function setParser(me, parser) {
  Object.defineProperty(me, 'parser', {
    value: parser
  });
  return parser;
}

var Default = /*#__PURE__*/function () {
  function Default(formatter) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default()(this, Default);

    this.formatter = formatter;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(Default, [{
    key: "format",
    value: function format(value) {
      return this.formatter.defaultFormat(value);
    }
  }, {
    key: "parse",
    value: function parse(value, strict) {
      return this.formatter.defaultParse(value, strict);
    }
  }, {
    key: "resolvedOptions",
    value: function resolvedOptions() {
      return null;
    }
  }]);

  return Default;
}(); // This class does not extend Core.Base because instances are not reconfigurable (making
// setConfig harmful) nor destroyable. Instead, they get frozen and cached according to
// their "config" definition.

/**
 * Abstract base class for formatters.
 * @private
 */


var Formatter = /*#__PURE__*/function () {
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(Formatter, null, [{
    key: "get",
    value: function get(format) {
      if (format == null) {
        return this.NULL;
      }

      var key = typeof format === 'string' ? format : JSON.stringify(format),
          cache = this.cache;
      var fmt = cache.get(key);

      if (!fmt) {
        cacheKey = key; // this is grabbed by our constructor below...

        fmt = new this(format);
        cache.set(key, fmt);
      }

      return fmt;
    }
  }, {
    key: "cache",
    get: function get() {
      return hasOwnProperty.call(this, '_cache') && this._cache || (this._cache = new Map());
    }
  }, {
    key: "NULL",
    get: function get() {
      return hasOwnProperty.call(this, '_null') ? this._null : this._null = new this(null);
    }
  }]);

  function Formatter(config) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default()(this, Formatter);

    var me = this; // This is done in a funny way so as not to complicate the derived constructor's
    // desire to maintain a single argument signature, as well as it's calling of
    // Object.freeze() to ensure immutability in dev mode.

    me.cacheKey = cacheKey;
    cacheKey = null;
    me.initialize();

    if (config === null) {
      setParser(me, me.formatter = new Default(me));
    } else {
      me.configure(config); // Bring locale and other defaulted options back onto this object:

      for (var _i = 0, _Object$entries = Object.entries(me.resolvedOptions()); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19___default()(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        // For some reason (locale-specific perhaps), resolvedOptions returns
        // with 'undefined' in some keys (e.g., min/maximumFractionDigits) when
        // we specified 0.
        //
        // The second check is to only bring back values that we understand.
        if (value != null && key in me.defaults) {
          me[key] = value;
        }
      }
    }
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(Formatter, [{
    key: "defaultFormat",
    value: function defaultFormat(value) {
      return value == null ? value : String(value);
    }
  }, {
    key: "defaultParse",
    value: function defaultParse(value) {
      return value;
    }
  }, {
    key: "format",
    value: function format(value) {
      return value == null ? value : this.formatter.format(value);
    }
  }, {
    key: "parse",
    value: function parse(value, strict) {
      return value == null ? value : this.parser.parse(value, strict);
    }
  }, {
    key: "parseStrict",
    value: function parseStrict(value) {
      return this.parse(value, true);
    }
  }, {
    key: "resolvedOptions",
    value: function resolvedOptions() {
      return this.formatter.resolvedOptions();
    }
  }, {
    key: "parser",
    get: function get() {
      // Replace this property w/the actual instance:
      return setParser(this, new this.constructor.Parser(this));
    }
  }]);

  return Formatter;
}();


Formatter._$name = 'Formatter';

/***/ }),

/***/ "./lib/Core/helper/util/Fullscreen.js":
/*!********************************************!*\
  !*** ./lib/Core/helper/util/Fullscreen.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Fullscreen; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");





var productName = 'scheduler';

/**
 * @module Core/helper/util/Fullscreen
 */

/**
 * Encapsulates the functionality related to switching cross-browser to full screen view and back.
 */

var Fullscreen = /*#__PURE__*/function () {
  function Fullscreen() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Fullscreen);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Fullscreen, null, [{
    key: "init",
    value: function init() {
      var fnNames = ['fullscreenEnabled', 'requestFullscreen', 'exitFullscreen', 'fullscreenElement'],
          // turns fnNames into function calls to prefixed functions, fullscreenEnabled -> document.mozFullscreenEnabled
      prefixFn = function prefixFn(prefix) {
        return fnNames.map(function (fn) {
          var result = prefix + _StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].capitalize(fn); // fullscreenEnabled in Firefox is called fullScreenEnabled

          if (prefix === 'moz') {
            result = result.replace('screen', 'Screen'); // #6555 - Crash when clicking full screen button twice
            // firefox doesn't support exitFullScreen method

            if ('mozCancelFullScreen' in document && fn === 'exitFullscreen') {
              result = 'mozCancelFullScreen';
            }
          }

          return result;
        });
      };

      this.functions = 'fullscreenEnabled' in document && fnNames || 'webkitFullscreenEnabled' in document && prefixFn('webkit') || 'mozFullScreenEnabled' in document && prefixFn('moz') || 'msFullscreenEnabled' in document && prefixFn('ms') || [];

      var eventNames = ['fullscreenchange', 'fullscreenerror'],
          msEventNames = ['MSFullscreenChange', 'MSFullscreenError'],
          prefixEvt = function prefixEvt(prefix) {
        return eventNames.map(function (eventName) {
          return prefix + _StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].capitalize(eventName);
        });
      };

      this.events = 'fullscreenEnabled' in document && eventNames || 'webkitFullscreenEnabled' in document && prefixEvt('webkit') || 'mozFullscreenEnabled' in document && prefixEvt('moz') || 'msFullscreenEnabled' in document && msEventNames || [];
    }
    /**
     * True if the fullscreen mode is supported and enabled, false otherwise
     * @property {Boolean}
     */

  }, {
    key: "request",

    /**
     * Request entering the fullscreen mode.
     * @param {HTMLElement} element Element to be displayed fullscreen
     */
    value: function request(element) {
      return element[this.functions[1]]();
    }
    /**
     * Exit the previously entered fullscreen mode.
     */

  }, {
    key: "exit",
    value: function exit() {
      return document[this.functions[2]]();
    }
    /**
     * True if fullscreen mode is currently active, false otherwise
     * @return {Boolean}
     */

  }, {
    key: "onFullscreenChange",

    /**
     * Installs the passed listener to fullscreenchange event
     * @param {Function} fn The listener to install
     */
    value: function onFullscreenChange(fn) {
      document.addEventListener(this.events[0], fn);
    }
    /**
     * Uninstalls the passed listener from fullscreenchange event
     * @param {Function} fn
     */

  }, {
    key: "unFullscreenChange",
    value: function unFullscreenChange(fn) {
      document.removeEventListener(this.events[0], fn);
    }
  }, {
    key: "enabled",
    get: function get() {
      return document[this.functions[0]];
    }
  }, {
    key: "isFullscreen",
    get: function get() {
      return !!document[this.functions[3]];
    }
  }]);

  return Fullscreen;
}();


Fullscreen.init();
Fullscreen._$name = 'Fullscreen';

/***/ }),

/***/ "./lib/Core/helper/util/Navigator.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/util/Navigator.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Navigator; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/helper/util/Navigator
 */

/**
 * A helper class which allows keyboard navigation within the {@link #config-target} element.
 * @private
 */

var Navigator = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Navigator, _Events);

  var _super = _createSuper(Navigator);

  function Navigator() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Navigator);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Navigator, [{
    key: "updateOwnerCmp",
    value: function updateOwnerCmp(ownerCmp) {
      if (!this.itemSelector) {
        this.itemSelector = ".".concat(this.ownerCmp.itemCls);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(keyEvent) {
      var me = this,
          ownerCmp = me.ownerCmp,
          itemSelector = me.itemSelector,
          activeItem = me.activeItem,
          itemsTabbable = me.itemsTabbable,
          _keyEvent = keyEvent,
          target = _keyEvent.target,
          firstItem = me.target.querySelector(itemSelector),
          keyName = (keyEvent.key || '').trim() || keyEvent.code,
          composedKeyName = "".concat(keyEvent.ctrlKey ? 'CTRL+' : '').concat(keyEvent.shiftKey ? 'SHIFT+' : '').concat(keyEvent.altKey ? 'ALT+' : '').concat(keyName),
          validTarget = target.matches(itemSelector) || target === me.keyEventTarget; // Process the key gesture if there are items and we are visible.
      // Also, if key emanated from a valid target element (Not an owned positioned Widget).

      if (!me.disabled && firstItem && me.target.offsetParent && validTarget) {
        // Only set navigation key names if we are *not* using tabbing.
        if (!itemsTabbable) {
          // Detect whether the navigable items flow inline or downwards.
          if (me.inlineFlow == null) {
            var itemContainer = firstItem.parentNode,
                itemPositionStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStyleValue(firstItem, 'position'),
                itemDisplayStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStyleValue(firstItem, 'display'),
                itemFloatStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStyleValue(firstItem, 'float'); // This is how we know that RIGHT and LEFT arrow should be used for next and previous.
            // If inlineFlow is false, we use UP and DOWN. Consider tabs in a tab bar.

            me.inlineFlow = itemPositionStyle === 'absolute' || itemDisplayStyle === 'inline' || itemDisplayStyle === 'inline-block' || itemFloatStyle === 'left' || itemFloatStyle === 'right' || _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStyleValue(itemContainer, 'display') === 'flex' && _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStyleValue(itemContainer, 'flex-direction') === 'row';
          }

          if (!me.prevKey) {
            if (me.inlineFlow) {
              me.prevKey = 'ArrowLeft';
              me.nextKey = 'ArrowRight';
            } else {
              me.prevKey = 'ArrowUp';
              me.nextKey = 'ArrowDown';
            }
          }
        } // Feed the key event through our configured processor, process the event that returns if any.


        if (me.processEvent) {
          keyEvent = me.processEvent.call(ownerCmp, keyEvent);

          if (!keyEvent) {
            return;
          }
        }

        if (activeItem) {
          switch (keyName) {
            case me.prevKey:
              if (me.disabled || keyEvent.ctrlKey && !me.allowCtrlKey) {
                return;
              }

              if (keyEvent.shiftKey && !me.allowShiftKey) {
                return;
              }

              keyEvent.preventDefault();
              me.navigatePrevious(keyEvent);
              break;

            case me.nextKey:
              if (me.disabled || keyEvent.ctrlKey && !me.allowCtrlKey) {
                return;
              }

              if (keyEvent.shiftKey && !me.allowShiftKey) {
                return;
              }

              keyEvent.preventDefault();
              me.navigateNext(keyEvent);
              break;

            default:
              {
                var keyHandler = me.keys && me.keys[composedKeyName];

                if (keyHandler && !me.disabled) {
                  me.callback(keyHandler, me.thisObj || ownerCmp, [keyEvent]);
                } // Note that even if this.disabled, the ownerCmp will expect
                // to have its key down hander invoked.
                else if (ownerCmp.onInternalKeyDown) {
                    ownerCmp.onInternalKeyDown(keyEvent);
                  } // One of the handlers moved focus.
                // This KeyDown should not act upon the new target.
                // For example popped up a Popup and focused its "close" Tool.


                if (_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].activeElement !== target) {
                  keyEvent.preventDefault();
                } // No navigation must take place when items are tabbable.


                if (itemsTabbable) {
                  return;
                }
              }
          }
        } else {
          if (itemsTabbable) {
            return;
          }

          me.activeItem = me.previousActiveItem || me.getDefaultNavigationItem(keyEvent);
        }

        if (me.activeItem !== activeItem) {
          /**
           * Fired when a user gesture causes the active item to change _or become `null`_.
           * @event navigate
           * @param {Event} event The browser event which instigated navigation. May be a click or key or focus move event.
           * @param {HTMLElement} item The newly active item, or `null` if focus moved out.
           * @param {HTMLElement} oldItem The previously active item, or `null` if focus is moving in.
           */
          me.triggerNavigate(keyEvent);
        }
      }
    }
  }, {
    key: "getDefaultNavigationItem",
    value: function getDefaultNavigationItem(keyEvent) {
      var target = this.target,
          itemSelector = this.itemSelector,
          prevKey = this.prevKey,
          nextKey = this.nextKey; // Navigating backwards from after the component, we default to last item

      if (target.compareDocumentPosition(keyEvent.target) & 4 && keyEvent.key === prevKey) {
        return target.querySelector("".concat(itemSelector, ":last-of-type"));
      } // Navigating forwards from before the component we default to the first item


      if (target.compareDocumentPosition(keyEvent.target) & 2 && keyEvent.key === nextKey) {
        return target.querySelector("".concat(itemSelector));
      }
    }
  }, {
    key: "navigatePrevious",
    value: function navigatePrevious(keyEvent) {
      var me = this,
          previous = me.previous;
      keyEvent.preventDefault();

      if (previous) {
        me.ownerCmp.scrollable.scrollIntoView(previous, {
          animate: me.scrollDuration
        }).then(function () {
          me.activeItem = previous;
          me.triggerNavigate(keyEvent);
        });
      }
    }
  }, {
    key: "navigateNext",
    value: function navigateNext(keyEvent) {
      var me = this,
          next = me.next;
      keyEvent.preventDefault();

      if (next) {
        me.ownerCmp.scrollable.scrollIntoView(next, {
          animate: me.scrollDuration
        }).then(function () {
          me.activeItem = next;
          me.triggerNavigate(keyEvent);
        });
      }
    }
  }, {
    key: "getAdjacent",

    /**
     * Returns the next or previous navigable element starting from the passed `from` element,
     * navigating in the passed direction.
     * @param {HTMLElement} [from] The start point. Defaults to the current {@link #config-activeItem}
     * @param {Number} [direction=1] The direction. -1 for backwards, else forwards.
     */
    value: function getAdjacent() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.activeItem;
      var treeWalker = this.treeWalker;
      treeWalker.currentNode = from;
      treeWalker[direction < 0 ? 'previousNode' : 'nextNode']();

      if (treeWalker.currentNode !== this.activeItem) {
        return treeWalker.currentNode;
      }
    }
  }, {
    key: "onTargetFocusIn",
    value: function onTargetFocusIn(focusInEvent) {
      var me = this,
          target = focusInEvent.target,
          itemsTabbable = me.itemsTabbable,
          skipScrollIntoView = me.skipScrollIntoView; // Ignore navigating to a focus trap. It will bounce back in

      if (!target.matches('.b-focus-trap')) {
        var _focusInEvent$related, _focusInEvent$related2;

        if (target.matches(me.itemSelector)) {
          // We may need to know this in downstream code.
          // for example set activeItem must not scrollintoView on click
          me.skipScrollIntoView = true;
          me.activeItem = target;
          me.skipScrollIntoView = skipScrollIntoView; // If we are using natural, TAB based navigation, trigger the navigate event after it really happens.

          if (me.activeItem && itemsTabbable) {
            me.triggerNavigate(focusInEvent);
          }
        } // Upward focusing from within means a SHIFT+TAB, so go to previous sibling
        // PATCH: IE11 may receive event which related target is not an instance of HTMLElement
        else if (!itemsTabbable && ((_focusInEvent$related = focusInEvent.relatedTarget) === null || _focusInEvent$related === void 0 ? void 0 : (_focusInEvent$related2 = _focusInEvent$related.matches) === null || _focusInEvent$related2 === void 0 ? void 0 : _focusInEvent$related2.call(_focusInEvent$related, me.itemSelector))) {
            var _me$owner$previousSib;

            (_me$owner$previousSib = me.owner.previousSibling) === null || _me$owner$previousSib === void 0 ? void 0 : _me$owner$previousSib.focus();
          }
      }
    }
  }, {
    key: "onTargetFocusOut",
    value: function onTargetFocusOut(focusOutEvent) {
      var me = this,
          relatedTarget = focusOutEvent.relatedTarget; // Ignore navigating to a focus trap. It will bounce back in

      if (!(relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.matches('.b-focus-trap'))) {
        if (!relatedTarget || !me.target.contains(relatedTarget) || !relatedTarget.matches(me.itemSelector)) {
          if (me.activeItem) {
            me.activeItem = null; // If we are using natural, TAB based navigation, trigger the navigate event after it really happens.

            if (me.itemsTabbable) {
              me.triggerNavigate(focusOutEvent);
            }
          }
        }
      }
    }
  }, {
    key: "onTargetMouseDown",
    value: function onTargetMouseDown(mousedownEvent) {
      // Mousedown is the focus gesture.
      // This holds true even on touch platforms
      // where the mousedown event is synthesized -
      // preventing default prevents focus on the upcoming touchend.
      if (this.ownerCmp.itemsFocusable === false) {
        this.onFocusGesture(mousedownEvent);
      } else {
        var target = mousedownEvent.target.closest(this.itemSelector);

        if (target) {
          mousedownEvent.preventDefault();
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].focusWithoutScrolling(target);
        }
      }
    }
  }, {
    key: "onTargetClick",
    value: function onTargetClick(clickEvent) {
      var me = this,
          skipScrollIntoView = me.skipScrollIntoView;

      if (me.disabled) {
        return;
      } // We may need to know this in downstream code.
      // for example set activeItem must not scrollintoView on click


      me.skipScrollIntoView = true; // ownerCmp's preprocessing of any navigate event.

      if (me.processEvent) {
        clickEvent = me.processEvent.call(me.ownerCmp, clickEvent);
      }

      if (clickEvent) {
        me.activeItem = clickEvent.target.closest(me.itemSelector);
        me.triggerNavigate(clickEvent);
      }

      me.skipScrollIntoView = skipScrollIntoView;
    } // We have to prevent focus moving from eg, an input field when we mousedown
    // or touchtap a non focusable item when ownerCmp has itemsFocusable: false.
    // If the event was not on an item, we must allow it through to allow Lists
    // to contain other widgets.

  }, {
    key: "onFocusGesture",
    value: function onFocusGesture(event) {
      if (event.target === this.ownerCmp.contentElement || event.target.closest(this.itemSelector) && this.ownerCmp.itemsFocusable === false) {
        event.preventDefault();
      }
    }
  }, {
    key: "acceptNode",
    value: function acceptNode(node) {
      return node.offsetParent && node.matches && node.matches(this.itemSelector) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  }, {
    key: "changeActiveItem",
    value: function changeActiveItem(activeItem) {
      if (activeItem != null) {
        // List and Menu's getItem API allows number, or node or record or record id to be passed
        if (this.ownerCmp.getItem) {
          activeItem = this.ownerCmp.getItem(activeItem);
        }
      }

      return activeItem;
    }
  }, {
    key: "updateActiveItem",
    value: function updateActiveItem(activeItem, oldActiveItem) {
      var me = this,
          ownerCmp = me.ownerCmp,
          isActive = oldActiveItem && me.target.contains(oldActiveItem);

      if (isActive) {
        me.previousActiveItem = oldActiveItem;
      } // This may be set to null on focusout of the target element.
      // Cannot use truthiness test because index zero may be passed.


      if (activeItem != null) {
        // If the user was able to click the event, they will not expect it to attempt to scroll.
        if (!me.skipScrollIntoView) {
          ownerCmp.scrollable.scrollIntoView(activeItem, {
            block: 'nearest',
            // If we are being called in response to focus movement, it will already be the document.activeElement
            // so in that case, behave is if we were in non-focusing mode, and just add the focused class.
            focus: _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isFocusable(activeItem) && activeItem !== _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].activeElement,
            silent: me.scrollSilently
          });
        } // No change in active item, do nothing after we've ensured it's fully in view.


        if (activeItem === oldActiveItem && isActive) {
          return;
        }

        if (oldActiveItem) {
          oldActiveItem.classList.remove(me.focusCls);
        }

        activeItem.classList.add(me.focusCls);
        me._activeItem = activeItem;
      } else {
        if (oldActiveItem) {
          oldActiveItem.classList.remove(me.focusCls); // If we are clearing the activeItem, and it's focused, keep focus
          // close by actively reverting it.

          if (oldActiveItem === _DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].activeElement) {
            ownerCmp.revertFocus();
          }
        }

        me._activeItem = null;
      }
    }
  }, {
    key: "updateTarget",
    value: function updateTarget(target, oldTarget) {
      var me = this,
          listeners = {
        element: target,
        thisObj: me,
        focusin: 'onTargetFocusIn',
        focusout: 'onTargetFocusOut'
      };

      if (!me.itemsTabbable) {
        // We don't need pointer events if items are tabbable
        listeners.mousedown = 'onTargetMouseDown';
        listeners.click = 'onTargetClick';
      }

      if (!Object.prototype.hasOwnProperty.call(me, 'acceptNode')) {
        me.acceptNode = me.acceptNode.bind(me); // https://github.com/webcomponents/webcomponentsjs/issues/556
        // Work around Internet Explorer wanting a function instead of an object.
        // IE also *requires* this argument where other browsers don't.

        me.acceptNode.acceptNode = me.acceptNode;
      }

      _EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on(listeners); // This Navigator object acts as the filter for the TreeWalker. We must implement acceptNode(node)

      me.treeWalker = me.setupTreeWalker(target, NodeFilter.SHOW_ELEMENT, me.acceptNode, false); // If we were not configured with an outside key event provider (think the input field providing UP/DOWN keys for the dropdown)
      // then use the target element as the source.

      if (!me.keyEventTarget) {
        me.keyEventTarget = target;
      } // If the activeItem gets removed, we must know, and deactivate.


      (me.targetMutationMonitor = new MutationObserver(me.onTargetChildListChange.bind(me))).observe(target, {
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "setupTreeWalker",
    value: function setupTreeWalker(root, whatToShow, filter, entityReferenceExpansion) {
      // This Navigator object acts as the filter for the TreeWalker. We must implement acceptNode(node)
      return document.createTreeWalker(root, whatToShow, filter, entityReferenceExpansion);
    }
  }, {
    key: "onTargetChildListChange",
    value: function onTargetChildListChange() {
      var activeItem = this.activeItem; // On DOM mutation, if the activeItem got changed, pull the one with the same ID out again.

      if (activeItem) {
        if (this.target.contains(activeItem)) {
          activeItem.classList.add(this.focusCls);
        } else {
          // Passing undefined results in the config setter assuming no-change
          // So we must use null to clear.
          this.activeItem = this.target.querySelector("".concat(this.itemSelector, "[data-id=\"").concat(activeItem.dataset.id, "\"]")) || null;
        }
      }
    }
  }, {
    key: "changeKeyEventTarget",
    value: function changeKeyEventTarget(keyEventTarget) {
      this._keyEventTarget = keyEventTarget;
      _EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
        element: keyEventTarget,
        keydown: 'onKeyDown',
        thisObj: this
      });
    }
  }, {
    key: "triggerNavigate",
    value: function triggerNavigate(event) {
      var _this$ownerCmp;

      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.activeItem;
      var navEvent = {
        event: event,
        item: item,
        oldItem: this.previousActiveItem
      };
      this.trigger('navigate', navEvent);
      (_this$ownerCmp = this.ownerCmp) === null || _this$ownerCmp === void 0 ? void 0 : _this$ownerCmp.trigger('navigate', navEvent);
    }
  }, {
    key: "owner",
    get: function get() {
      return this.ownerCmp;
    }
  }, {
    key: "previous",
    get: function get() {
      return this.getAdjacent(-1);
    }
  }, {
    key: "next",
    get: function get() {
      return this.getAdjacent(1);
    }
  }], [{
    key: "configurable",
    get: function get() {
      return {
        /**
         * The owning Widget which is using this Navigator.
         * @config {Core.widget.Widget}
         */
        ownerCmp: null,

        /**
         * The encapsulating element in which navigation takes place.
         * @config {HTMLElement}
         */
        target: null,

        /**
         * The element which provides key events for navigation. Optional. Defaults to the {@link #config-target} element.
         * @config {HTMLElement}
         */
        keyEventTarget: null,

        /**
         * An optional key event processor which may preprocess the key event. Returning `null` prevents processing of the event.
         * @config {Function}
         */
        processEvent: null,

        /**
         * A query selector which identifies descendant elements within the {@link #config-target} which are navigable.
         * @config {String}
         */
        itemSelector: null,

        /**
         * The currently focused element within the {@link #config-target}.
         * @config {HTMLElement}
         */
        activeItem: null,

        /**
         * A CSS class name to add to focused elements.
         * @config {String}
         * @default
         */
        focusCls: 'b-active',

        /**
         * An object containing key definitions keys by the key name eg:
         *
         * ```javascript
         *  keys : {
         *      "CTRL+SPACE" : 'onCtrlSpace',
         *      ENTER        : 'onEnterKey'
         *  }```
         *
         * The {@link #config-ownerCmp} is used as the `this` reference and to resolve string method names.
         *
         * Modified key names must be created prepending one or more `'CTRL+'`, `'SHIFT+'`, `'ALT+'`
         * in that order, for example `"CTRL+SHIFT+ENTER" : 'showMenu'`
         * @config {Object}
         * @default
         */
        keys: null,

        /**
         * Configure as `true` to also navigate when the `CTRL` modifier key is used along with
         * navigation keys.
         * @config {Boolean}
         * @default false
         */
        allowCtrlKey: null,

        /**
         * Configure as `true` to also navigate when the `SHIFT` modifier key is used along with
         * navigation keys.
         * @config {Boolean}
         * @default false
         */
        allowShiftKey: null,
        scrollDuration: 50,

        /**
         * Configure as, or set to `true` to disable the processing of keys.
         * @config {Boolean}
         */
        disabled: null,
        testConfig: {
          scrollDuration: 1
        }
      };
    }
  }]);

  return Navigator;
}(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_15__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]));


Navigator._$name = 'Navigator';

/***/ }),

/***/ "./lib/Core/helper/util/NumberFormat.js":
/*!**********************************************!*\
  !*** ./lib/Core/helper/util/NumberFormat.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberFormat; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _Formatter_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Formatter.js */ "./lib/Core/helper/util/Formatter.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../localization/En.js */ "./lib/Core/localization/En.js");


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/helper/util/NumberFormat
 */

var escapeRegExp = _StringHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].escapeRegExp,
    digitsRe = /[\d+-]/g,
    // We cannot pass locale=null:
newFormatter = function newFormatter(locale, config) {
  return new Intl.NumberFormat(locale || undefined, config);
},
    numFormatRe = /^(?:([$])\s*)?(?:(\d+)>)?\d+(,\d+)?(?:\.((\d*)(?:#*)|[*]))?(?:\s*([%])?)?$/;

var NumberParser = /*#__PURE__*/function () {
  function NumberParser(formatter) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default()(this, NumberParser);

    var me = this,
        locale = formatter.locale,
        // We need a formatter for this locale that has decimals and grouping:
    numFmt = newFormatter(locale, {
      maximumFractionDigits: 3
    }),
        currency = formatter.is.currency ? me._decodeStyle(locale, {
      style: 'currency',
      currency: formatter.currency,
      currencyDisplay: formatter.currencyDisplay
    }) : null,
        percent = formatter.is.percent ? me._decodeStyle(locale, {
      style: 'percent'
    }) : null,
        decimal = numFmt.format(1.2).replace(digitsRe, '')[0],
        grouper = numFmt.format(1e9).replace(digitsRe, '')[0];
    Object.assign(me, {
      currency: currency,
      decimal: decimal,
      formatter: formatter,
      grouper: grouper,
      percent: percent
    });
    me.decimal = decimal;
    me.decimalRe = escapeRegExp(decimal, 'g');
    me.grouper = grouper; // The stripRe removes whitespace, currency text, percent text and grouping chars:

    me.stripRe = new RegExp("(?:\\s+|".concat(escapeRegExp(grouper), ")") + (currency ? "|(?:".concat(escapeRegExp(currency.text), ")") : '') + (percent ? "|(?:".concat(escapeRegExp(percent.text), ")") : ''), 'g');
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default()(NumberParser, [{
    key: "parse",
    value: function parse(value, strict) {
      if (typeof value === 'string') {
        value = value.replace(this.stripRe, '').replace(this.decimalRe, '.');
        value = strict ? Number(value) : parseFloat(value);

        if (this.formatter.is.percent) {
          value /= 100;
        }
      } // else, a number is already parsed but could be null...


      return value;
    }
  }, {
    key: "_decodeStyle",
    value: function _decodeStyle(locale, fmtDef) {
      var fmt = newFormatter(locale, fmtDef),
          decFmt = newFormatter(locale, Object.assign(fmt.resolvedOptions(), {
        style: 'decimal'
      })),
          zero = fmt.format(0),
          // = '0%' or '$0.00' in en-US
      zeroDec = decFmt.format(0); // = '0' or '0.00' in en-US

      return {
        suffix: zero.startsWith(zeroDec),
        text: zero.replace(zeroDec, '').trim()
      };
    }
  }]);

  return NumberParser;
}();
/**
 * This class is an enhancement to `Intl.NumberFormat` that has a more flexible
 * constructor as well as other features such as `parse()`.
 *
 * All constructor forms take a single argument. The most common is to pass a format
 * {@link #config-template} string:
 *```
 *  const formatter = new NumberFormat('9,999.99##');
 *```
 * The above is equivalent to:
 *```
 *  const formatter = new Intl.NumberFormat({
 *      useGrouping           : true,
 *      minimumFractionDigits : 2,
 *      maximumFractionDigits : 4
 *  });
 *```
 * The `formatter` created above is used as follows (in the `en-US` locale):
 *```
 *  console.log(formatter.format(12345.54321));
 *  console.log(formatter.format(42));
 *
 *  > 12,345.5432
 *  > 42.00
 *```
 * When a format template is insufficient, a config object can be provided, similar to
 * `Intl.NumberFormat`'s `options` parameter. While all options from `Intl.NumberFormat`
 * are valid properties for this class's config object, additional properties are
 * supported.
 *
 * For example:
 *```
 *  new NumberFormat({
 *      locale      : 'en-US',
 *      template    : '$9,999',
 *      significant : 5
 *  });
 *```
 * The `locale` option takes the place of the first positional parameter to the
 * `Intl.NumberFormat` constructor. The `template` config is the same string that can be
 * passed by itself.
 *
 * The shorthand properties `fraction`, `integer`, and `significant` set the standard
 * options `minimumFractionDigits`, `maximumFractionDigits`, `minimumIntegerDigits`,
 * `minimumSignificantDigits`, and `maximumSignificantDigits`.
 *
 * NOTE: Instances of `NumberFormat` are immutable after construction.
 *
 * For details about `Intl.NumberFormat` see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat).
 */


var NumberFormat = /*#__PURE__*/function (_Formatter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(NumberFormat, _Formatter);

  var _super = _createSuper(NumberFormat);

  function NumberFormat() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default()(this, NumberFormat);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default()(NumberFormat, [{
    key: "initialize",
    value: function initialize() {
      this._as = {// cacheKey : cachedInstance
      };
      this.is = {
        decimal: false,
        currency: false,
        percent: false,
        null: true,
        from: null
      };
    }
  }, {
    key: "configure",
    value: function configure(options) {
      var me = this;

      if (typeof options !== 'string') {
        Object.assign(me, options);
      } else {
        me.template = options;
      } // Do not remove. Assertion strings for Localization sanity check.
      // 'L{locale}'
      // 'L{currency}'


      var config = {},
          loc = me.locale ? _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_19__["default"].locales[me.locale] : _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_19__["default"].locale,
          defaults = loc && loc.NumberFormat,
          template = me.template;

      if (defaults) {
        for (var key in defaults) {
          if (me[key] == null && typeof defaults[key] !== 'function') {
            me[key] = defaults[key];
          }
        }
      }

      if (template) {
        var match = numFormatRe.exec(template),
            m2 = match[2],
            m4 = match[4];
        me.useGrouping = !!match[3];
        me.style = match[1] ? 'currency' : match[6] ? 'percent' : 'decimal';

        if (m2) {
          me.integer = +m2;
        }

        if (m4 === '*') {
          me.fraction = [0, 20];
        } else if (m4 != null) {
          me.fraction = [match[5].length, m4.length];
        }
      }

      me._minMax('fraction', true, true);

      me._minMax('integer', true, false);

      me._minMax('significant', false, true);

      for (var _key in me.defaults) {
        if (me[_key] != null) {
          config[_key] = me[_key];
        }
      }

      me.is.from = me.from && me.from.is;
      me.is[me.style] = !(me.is.null = false);
      me.formatter = newFormatter(me.locale, config);
    }
    /**
     * Creates a derived `NumberFormat` from this instance, with a different `style`. This is useful for processing
     * currency and percentage styles without the symbols being injected in the formatting.
     *
     * @param {String|Object} change The new style (if a string) or a set of properties to update.
     * @param {String} [cacheAs] A key by which to cache this derived formatter.
     * @returns {Core.helper.util.NumberFormat}
     */

  }, {
    key: "as",
    value: function as(change) {
      var cacheAs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var config = this.resolvedOptions() || {
        template: '9.*'
      },
          cache = this._as;
      var ret = cacheAs && cache[cacheAs];

      if (!ret) {
        if (typeof change === 'string') {
          config.style = change;
        } else {
          Object.assign(config, change);
        }

        config.from = this;
        ret = new NumberFormat(config);
      }

      if (cacheAs) {
        cache[cacheAs] = ret;
      }

      return ret;
    }
  }, {
    key: "defaultParse",
    value: function defaultParse(value, strict) {
      return value == null ? value : strict ? Number(value) : parseFloat(value);
    }
    /**
     * Returns the given `value` formatted in accordance with the specified locale and
     * formatting options.
     *
     * @param {Number} value
     * @returns {String}
     */

  }, {
    key: "format",
    value: function format(value) {
      if (typeof value === 'string') {
        var v = Number(value);
        value = isNaN(v) ? this.parse(value) : v;
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(NumberFormat.prototype), "format", this).call(this, value);
    } // The parse() method is inherited but the base class implementation
    // cannot properly document the parameter and return types:

    /**
     * Returns a `Number` parsed from the given, formatted `value`, in accordance with the
     * specified locale and formatting options.
     *
     * If the `value` cannot be parsed, `NaN` is returned.
     *
     * Pass `strict` as `true` to require all text to convert. In essence, the default is
     * in line with JavaScript's `parseFloat` while `strict=true` behaves like the `Number`
     * constructor:
     *```
     *  parseFloat('1.2xx');  // = 1.2
     *  Number('1.2xx')       // = NaN
     *```
     * @method parse
     * @param {String} value
     * @param {Boolean} [strict=false]
     * @returns {Number}
     */

    /**
     * Returns a `Number` parsed from the given, formatted `value`, in accordance with the
     * specified locale and formatting options.
     *
     * If the `value` cannot be parsed, `NaN` is returned.
     *
     * This method simply passes the `value` to `parse()` and passes `true` for the second
     * argument.
     *
     * @method parseStrict
     * @param {String} value
     * @returns {Number}
     */

    /**
     * Returns the given `Number` rounded in accordance with the specified locale and
     * formatting options.
     *
     * @param {Number|String} value
     * @returns {Number}
     */

  }, {
    key: "round",
    value: function round(value) {
      return this.parse(this.format(value));
    }
    /**
     * Returns the given `Number` truncated to the `maximumFractionDigits` in accordance
     * with the specified locale and formatting options.
     *
     * @param {Number|String} value
     * @returns {Number}
     */

  }, {
    key: "truncate",
    value: function truncate(value) {
      var scale = this.maximumFractionDigits;
      var v = this.parse(value),
          dot,
          truncator;

      if (scale != null) {
        truncator = this.as({
          style: 'decimal',
          maximumFractionDigits: Math.min(20, scale + 1)
        }, 'truncator');
        v = truncator.format(v);
        dot = v.indexOf(truncator.parser.decimal);

        if (dot > -1 && v.length - dot - 1 > scale) {
          v = v.substr(0, dot + scale + 1);
        }

        v = truncator.parse(v);
      }

      return v;
    }
  }, {
    key: "resolvedOptions",
    value: function resolvedOptions() {
      var options = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(NumberFormat.prototype), "resolvedOptions", this).call(this);

      for (var key in options) {
        // For some reason, on TeamCity, tests get undefined for some properties...
        // maybe a locale issue?
        if (options[key] === undefined) {
          options[key] = this[key];
        }
      }

      return options;
    }
    /**
     * Expands the provided shorthand into the "minimum*Digits" and "maximum*Digits".
     * @param {String} name
     * @param {Boolean} setMin
     * @param {Boolean} setMax
     * @private
     */

  }, {
    key: "_minMax",
    value: function _minMax(name, setMin, setMax) {
      var me = this,
          value = me[name];

      if (value != null) {
        var capName = _StringHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].capitalize(name),
            max = "maximum".concat(capName, "Digits"),
            min = "minimum".concat(capName, "Digits");

        if (typeof value === 'number') {
          if (setMin) {
            me[min] = value;
          }

          if (setMax) {
            me[max] = value;
          }
        } else {
          me[min] = value[0];
          me[max] = value[1];
        }
      }
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'NumberFormat';
    }
  }]);

  return NumberFormat;
}(_Formatter_js__WEBPACK_IMPORTED_MODULE_17__["default"]);


NumberFormat.Parser = NumberParser;
Object.assign(NumberFormat.prototype, {
  // This object holds only those properties that Intl.NumberFormat accepts in its
  // "options" parameter. Only these options will be copied from the NumberFormat
  // and passed to the Intl.NumberFormat constructor and only these will be copied
  // back from its resolvedOptions:
  defaults: {
    /**
     * The formatting style.
     *
     * Valid values are: `'decimal'` (the default), `'currency'`, and `'percent'`.
     * @config {String}
     * @default
     */
    style: 'decimal',

    /**
     * The currency to use when using `style: 'currency'`. For example, `'USD'` (US dollar)
     * or `'EUR'` for the euro.
     *
     * If not provided, the {@link Core.localization.LocaleManager} default will be used.
     * @config {Boolean}
     */
    currency: null,

    /**
     * The format in which to display the currency value when using `style: 'currency'`.
     *
     * Valid values are: `'symbol'` (the default), `'code'`, and `'name'`.
     * @config {String}
     * @default
     */
    currencyDisplay: 'symbol',

    /**
     * The name of the locale. For example, `'en-US'`. This config is the same as the
     * first argument to the `Intl.NumberFormat` constructor.
     *
     * Defaults to the browser's default locale.
     * @config {String}
     */
    locale: null,

    /**
     * The maximum number of digits following the decimal.
     *
     * This is more convenient to specify using the {@link #config-fraction} config.
     * @config {Number}
     */
    maximumFractionDigits: null,

    /**
     * The minimum number of digits following the decimal.
     *
     * This is more convenient to specify using the {@link #config-fraction} config.
     * @config {Number}
     */
    minimumFractionDigits: null,

    /**
     * The minimum number of digits preceding the decimal.
     *
     * This is more convenient to specify using the {@link #config-integer} config.
     * @config {Number}
     */
    minimumIntegerDigits: null,

    /**
     * The maximum number of significant digits.
     *
     * This is more convenient to specify using the {@link #config-significant} config.
     * @config {Number}
     */
    maximumSignificantDigits: null,

    /**
     * The minimum number of significant digits.
     *
     * This is more convenient to specify using the {@link #config-significant} config.
     * @config {Number}
     */
    minimumSignificantDigits: null,

    /**
     * Specify `false` to disable thousands separators.
     * @config {Boolean}
     * @default
     */
    useGrouping: true
  },

  /**
   * Specifies the `minimumFractionDigits` and `minimumFractionDigits` in a compact
   * way. If this value is a `Number`, it sets both the minimum and maximum to that
   * value. If this value is an array, `[0]` sets the minimum and `[1]` sets the
   * maximum.
   * @config {Number|Number[]}
   */
  fraction: null,
  from: null,

  /**
   * An alias for `minimumIntegerDigits`.
   * @config {Number}
   */
  integer: null,

  /**
   * Specifies the `minimumSignificantDigits` and `minimumSignificantDigits` in a compact
   * format. If this value is a `Number`, it sets only the maximum to that value. If this
   * value is an array, `[0]` sets the minimum and `[1]` sets the maximum.
   *
   * If this value (or `minimumSignificantDigits` or `minimumSignificantDigits`) is set,
   * `integer` (and `minimumIntegerDigits`) and `fraction` (and `minimumFractionDigits`
   * and `minimumFractionDigits`) are ignored.
   *
   * @config {Number|Number[]}
   */
  significant: null,

  /**
   * A format template consisting of the following parts:
   *```
   *  [$] [\d+:] \d+ [,\d+] [.\d* [#*] | *] [%]
   *```
   * If the template begins with a `'$'`, the formatter's `style` option is set to
   * `'currency'`. If the template ends with `'%'`, `style` is set to `'percent'`.
   * It is invalid to include both characters. When using `'$'`, the `currency` symbol
   * defaults to what is provided by the {@link Core.localization.LocaleManager}.
   *
   * To set the `minimumIntegerDigits`, the desired minimum comes before the first
   * digits in the template and is followed by a `'>'` (greater-than). For example:
   *```
   *  5>9,999.00
   *```
   * The above sets `minimumIntegerDigits` to 5.
   *
   * The `useGrouping` option is enabled if there is a `','` (comma) present and is
   * disabled otherwise.
   *
   * If there is a `'.'` (decimal) present, it may be followed by either of:
   *
   *  - Zero or more digits which may then be followed by zero or more `'#'` characters.
   *    The number of digits determines the `minimumFractionDigits`, while the total
   *    number of digits and `'#'`s determines the `maximumFractionDigits`.
   *  - A single `'*'` (asterisk) indicating any number of fractional digits (no minimum
   *    or maximum).
   *
   * @config {String}
   */
  template: null
});
Object.assign(NumberFormat.prototype, NumberFormat.prototype.defaults); // TODO is this the "right" way to do this?

_Formatter_js__WEBPACK_IMPORTED_MODULE_17__["default"].number = function (format, value) {
  return NumberFormat.format(format, value);
};

NumberFormat._$name = 'NumberFormat';

/***/ }),

/***/ "./lib/Core/helper/util/Objects.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/util/Objects.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Objects; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_is_frozen__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.is-frozen */ "./node_modules/core-js/modules/es.object.is-frozen.js");
/* harmony import */ var core_js_modules_es_object_is_frozen__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_is_frozen__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler'; // IMPORTANT - adding imports here can create problems for Base class
//  That is why this file was split from ObjectHelper


var toString = Object.prototype.toString,
    isFrozen = Object.isFrozen,
    typeNameRe = /\[object ([^\]]+)]/,
    typeCache = {};
/**
 * @module Core/helper/util/Objects
 */
// Static methods are not displayed in derived class documentation. Therefore, since this is an internal class, the
// work around is to copy method documentation to ObjectHelper (the public interface). Also tried making ObjectHelper
// a singleton.

/**
 * Helper for low-level Object manipulation.
 *
 * While documented on {@link Core.helper.ObjectHelper}, the following static methods are implemented by this class:
 *
 * - `{@link Core.helper.ObjectHelper#function-assign-static}`
 * - `{@link Core.helper.ObjectHelper#function-assignIf-static}`
 * - `{@link Core.helper.ObjectHelper#function-clone-static}`
 * - `{@link Core.helper.ObjectHelper#function-createTruthyKeys-static}`
 * - `{@link Core.helper.ObjectHelper#function-getPath-static}`
 * - `{@link Core.helper.ObjectHelper#function-getTruthyKeys-static}`
 * - `{@link Core.helper.ObjectHelper#function-getTruthyValues-static}`
 * - `{@link Core.helper.ObjectHelper#function-isEmpty-static}`
 * - `{@link Core.helper.ObjectHelper#function-isObject-static}`
 * - `{@link Core.helper.ObjectHelper#function-merge-static}`
 * - `{@link Core.helper.ObjectHelper#function-setPath-static}`
 * - `{@link Core.helper.ObjectHelper#function-typeOf-static}`
 * @internal
 */

var Objects = /*#__PURE__*/function () {
  function Objects() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_21___default()(this, Objects);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_22___default()(Objects, null, [{
    key: "assign",
    value: function assign(dest) {
      for (var source, key, i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
        source = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

        if (source) {
          for (key in source) {
            dest[key] = source[key];
          }
        }
      }

      return dest;
    }
  }, {
    key: "assignIf",
    value: function assignIf(dest) {
      for (var source, key, i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
        source = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

        if (source) {
          for (key in source) {
            if (!(key in dest) || dest[key] === undefined) {
              dest[key] = source[key];
            }
          }
        }
      }

      return dest;
    }
  }, {
    key: "clone",
    value: function clone(value, handler) {
      var cloned = value,
          key;

      if (value && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20___default()(value) === 'object') {
        if (O.isObject(value)) {
          cloned = {};

          for (key in value) {
            cloned[key] = O.clone(value[key]);
          }
        } else if (Array.isArray(value)) {
          cloned = []; // Loop backwards to:
          //  1. read source.length once
          //  2. get result array sized on first pass (avoid growing)

          for (key = value.length; key-- > 0;)
          /* empty */
          {
            cloned[key] = O.clone(value[key]);
          }
        } else if (O.isDate(value)) {
          cloned = new Date(value.getTime());
        } else if (handler) {
          // Allow other types to be handled (e.g., DOM nodes)
          cloned = handler(value);
        }
      }

      return cloned;
    }
  }, {
    key: "createTruthyKeys",
    value: function createTruthyKeys(source) {
      var keys = _StringHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].split(source),
          result = keys && {};

      if (keys) {
        var _iterator = _createForOfIteratorHelper(keys),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;

            // StringHelper.split won't return empty keys if passed a string, but we
            // could have been passed a String[]
            if (key) {
              result[key] = true;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return result;
    }
    /**
     * Returns value for a given path in the object
     * @param {Object} object Object to check path on
     * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
     * @returns {*} Value associated with passed key
     */

  }, {
    key: "getPath",
    value: function getPath(object, path) {
      return path.split('.').reduce(function (result, key) {
        return (result || {})[key];
      }, object);
    }
    /**
     * Determines if the specified path exists
     * @param {Object} object Object to check path on
     * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
     * @returns {Boolean}
     */

  }, {
    key: "hasPath",
    value: function hasPath(object, path) {
      return path.split('.').every(function (key) {
        if (key in object) {
          object = object[key];
          return true;
        }

        return false;
      });
    }
  }, {
    key: "getTruthyKeys",
    value: function getTruthyKeys(source) {
      var keys = Object.keys(source);

      for (var i = keys.length; i-- > 0;)
      /* empty */
      {
        if (!source[keys[i]]) {
          keys.splice(i, 1);
        }
      }

      return keys;
    }
  }, {
    key: "getTruthyValues",
    value: function getTruthyValues(source) {
      var keys = Object.keys(source);

      for (var i = keys.length; i-- > 0;)
      /* empty */
      {
        if (source[keys[i]]) {
          keys[i] = source[keys[i]];
        } else {
          keys.splice(i, 1);
        }
      }

      return keys;
    }
  }, {
    key: "isClass",
    value: function isClass(object) {
      var _object$prototype;

      if (typeof object === 'function' && ((_object$prototype = object.prototype) === null || _object$prototype === void 0 ? void 0 : _object$prototype.constructor) === object) {
        // TODO find a way to differentiate function(){} from class{}
        return true;
      }

      return false;
    }
  }, {
    key: "isDate",
    value: function isDate(object) {
      // A couple quick rejections but only sure way is typeOf:
      return Boolean(object && object.getUTCDate) && O.typeOf(object) === 'date';
    }
  }, {
    key: "isPromise",
    value: function isPromise(object) {
      if (Promise && Promise.resolve) {
        return Promise.resolve(object) === object;
      } else {
        throw new Error('Promise not supported in your environment');
      }
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(object) {
      if (object && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20___default()(object) === 'object') {
        // noinspection LoopStatementThatDoesntLoopJS
        for (var p in object) {
          // eslint-disable-line no-unused-vars
          return false;
        }
      }

      return true;
    }
  }, {
    key: "isObject",
    value: function isObject(value) {
      var C = value && value.constructor;
      return Boolean(C // Most things have a .constructor property
      ? // An in-frame instance of Object
      C === Object || // Detect cross-frame objects, but exclude instance of custom classes named Object. typeOf(value) is
      // "object" even for instances of a class and typeOf(C) is "function" for all constructors. We'll have
      // to settle for relying on the fact that getPrototypeOf(Object.prototype) === null.
      // NOTE: this issue does come up in Scheduler unit tests at least.
      // NOTE: IE11 does not have C.name === 'Object' for cross-frame objects! So instead of that check we
      //  do a presence check for a method unlikely to be found elsewhere.
      C.getPrototypeOf && C.prototype && !Object.getPrototypeOf(C.prototype) : // Since all classes have a constructor property, an object w/o one is likely from Object.create(null). Of
      // course, primitive types do not have ".constructor"
      value && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20___default()(value) === 'object');
    }
  }, {
    key: "merge",
    value: function merge(dest) {
      for (var destValue, source, key, value, i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
        source = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

        if (source) {
          for (key in source) {
            value = source[key];

            if (value && O.isObject(value)) {
              destValue = dest[key];

              if (destValue && O.isObject(destValue)) {
                if (isFrozen(destValue)) {
                  dest[key] = destValue = O.clone(destValue);
                }

                O.merge(destValue, value);
              } else {
                dest[key] = isFrozen(value) ? value : O.clone(value);
              }
            } else {
              dest[key] = value;
            }
          }
        }
      }

      return dest;
    }
    /**
     * Sets value for a given path in the object
     * @param {Object} object Target object
     * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
     * @param {*} value Value for a given path
     * @returns {Object} Returns passed object
     */

  }, {
    key: "setPath",
    value: function setPath(object, path, value) {
      path.split('.').reduce(function (result, key, index, array) {
        var isLast = index === array.length - 1;

        if (isLast) {
          return result[key] = value;
        } else if (!(result[key] instanceof Object)) {
          result[key] = {};
        }

        return result[key];
      }, object);
      return object;
    }
  }, {
    key: "typeOf",
    value: function typeOf(value) {
      var type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_20___default()(value),
          match,
          trueType; // If not atomic type, we handle date or null


      if (type === 'object') {
        if (value === null) {
          type = 'null';
        } else {
          trueType = toString.call(value);

          if (!(type = typeCache[trueType])) {
            match = typeNameRe.exec(trueType);
            typeCache[trueType] = type = match ? match[1].toLowerCase() : trueType;
          }
        }
      } // NaN is the only value that is !== to itself
      else if (value !== value) {
          // eslint-disable-line no-self-compare
          type = 'nan';
        }

      return type;
    }
  }]);

  return Objects;
}();


var O = Objects;
Objects._$name = 'Objects';

/***/ }),

/***/ "./lib/Core/helper/util/Point.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/util/Point.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Point; });
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Rectangle_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/helper/util/Point
 */

/**
 * Encapsulates an X,Y coordinate point.
 * @extends Core/helper/util/Rectangle
 */

var Point = /*#__PURE__*/function (_Rectangle) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Point, _Rectangle);

  var _super = _createSuper(Point);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(Point, null, [{
    key: "from",

    /**
     * Creates a new Point encapsulating the event's page position.
     * @param {Event} event
     * @return {Core.helper.util.Point}
     * @typings ignore
     */
    value: function from(event) {
      var touchPoints = event.changedTouches;
      return new Point(touchPoints ? touchPoints[0].screenX : event.screenX, touchPoints ? touchPoints[0].screenY : event.pageY);
    }
    /**
     * Constructs a Point
     * @param x The X coordinate
     * @param y The Y coordinate
     */

  }]);

  function Point(x, y) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, Point);

    return _super.call(this, x, y, 0, 0);
  }
  /**
   * Coerces this Point to be within the passed Rectangle. Translates it into the bounds.
   * @param {Core.helper.util.Rectangle} into The Rectangle into which to coerce this Point.
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(Point, [{
    key: "constrain",
    value: function constrain(into) {
      this.x = Math.min(Math.max(this.x, into.x), into.right - 1);
      this.y = Math.min(Math.max(this.y, into.y), into.bottom - 1);
      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return [this.x, this.y];
    }
  }]);

  return Point;
}(_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"]); // The Rectangle class uses the Point class, but cannot import it.
// TODO: find a better way of getting a reference to the Point class in Rectangle.
// #8224 - Gantt angular demo doesn't work in production



Object.getPrototypeOf(Point).Point = Point;
Point._$name = 'Point';

/***/ }),

/***/ "./lib/Core/helper/util/Promissory.js":
/*!********************************************!*\
  !*** ./lib/Core/helper/util/Promissory.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Promissory; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);



var productName = 'scheduler';
/**
* @module Core/helper/util/Promissory
*/

/**
 * Encapsulates a Promise and provides `resolve()` and `reject()` methods.
 *
 * For example:
 * ```
 *  load() {
 *      this.loading = new Promissory();
 *      this.store.load();
 *
 *      return this.loading.promise;
 *  }
 *
 *  onStoreLoad(store, err) {
 *      if (err) {
 *          this.loading.resolve(this);
 *      }
 *      else {
 *          this.loading.reject(err);
 *      }
 *  }
 *
 * ```
 * @private
 */

var Promissory = function Promissory(fn) {
  var _this = this;

  _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Promissory);

  this.promise = new Promise(function (resolve, reject) {
    _this.resolve = resolve;
    _this.reject = reject;
  });

  if (fn) {
    fn(this);
  }
};


Promissory._$name = 'Promissory';

/***/ }),

/***/ "./lib/Core/helper/util/RandomGenerator.js":
/*!*************************************************!*\
  !*** ./lib/Core/helper/util/RandomGenerator.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RandomGenerator; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);



var productName = 'scheduler';
/**
* @module Core/helper/util/RandomGenerator
*/

/**
 * Generates pseudo random numbers from predefined sequence of 100 numbers
 */

var RandomGenerator = /*#__PURE__*/function () {
  function RandomGenerator() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, RandomGenerator);

    this.random100 = [46, 2, 36, 46, 54, 59, 18, 20, 71, 55, 88, 98, 13, 61, 61, 40, 2, 15, 3, 32, 51, 45, 64, 25, 81, 85, 54, 13, 57, 49, 64, 22, 81, 94, 0, 62, 17, 7, 11, 2, 33, 99, 85, 26, 83, 83, 96, 26, 20, 89, 91, 38, 26, 13, 11, 79, 32, 30, 5, 51, 70, 7, 5, 56, 58, 77, 37, 89, 40, 80, 78, 59, 26, 36, 8, 51, 60, 23, 86, 5, 11, 96, 64, 94, 87, 64, 4, 78, 17, 85, 35, 0, 90, 86, 23, 55, 53, 9, 35, 59, 29, 2, 64, 42, 8, 49, 43, 73, 6, 53, 38, 9, 39, 31, 32, 40, 49, 13, 78, 68, 20, 99, 24, 78, 35, 91, 73, 46, 67, 76, 89, 69, 30, 69, 25, 3, 4, 55, 1, 65, 66, 76, 83, 19, 67, 1, 95, 24, 54, 45, 56, 40, 67, 92, 72, 4, 69, 8, 47, 50, 27, 2, 38, 9, 14, 83, 12, 14, 62, 95, 22, 47, 35, 18, 38, 14, 86, 64, 68, 61, 52, 69, 39, 93, 20, 73, 32, 52, 74, 6, 56, 68, 99, 29, 24, 92, 40, 67, 6, 72, 31, 41, 91, 53, 80, 55, 33, 97, 97, 99, 18, 20, 5, 27, 82, 84, 61, 78, 27, 67, 7, 42, 75, 95, 91, 25, 63, 21, 70, 36, 46, 0, 1, 45, 84, 6, 86, 15, 10, 62, 96, 94, 10, 23, 93, 83, 94, 47, 5, 29, 29, 52, 51, 37, 77, 96, 43, 72, 43, 14, 54, 14, 72, 52, 4, 39, 15, 26, 68, 28, 25, 76, 60, 50, 22, 40, 72, 74, 68, 58, 8, 48, 40, 62, 52, 24, 9, 26, 47, 44, 49, 96, 7, 77, 90, 45, 76, 47, 5, 86, 1, 36, 18, 42, 19, 90, 34, 23, 70, 32, 69, 79, 0, 99, 57, 80, 72, 21, 19, 72, 85, 68, 4, 40, 86, 62, 0, 63, 4, 11, 69, 31, 78, 31, 21, 78, 29, 84, 13, 53, 57, 10, 26, 50, 24, 30, 90, 42, 51, 96, 93, 21, 99, 23, 81, 0, 89, 43, 86, 63, 93, 19, 54, 71, 92, 36, 4, 95, 37, 99, 60, 29, 23, 50, 68, 95, 57, 95, 77, 53, 99, 78, 75, 12, 92, 47, 23, 14, 0, 41, 98, 11, 34, 64, 26, 90, 50, 23, 38, 31, 74, 76, 16, 76, 66, 23, 22, 72, 48, 50, 20, 36, 37, 58, 5, 43, 49, 64, 81, 30, 8, 21, 98, 75, 60, 17, 50, 42, 27, 38, 90, 74, 45, 68, 67, 27, 31, 15, 58, 76, 41, 99, 23, 98, 53, 98, 56, 19, 79, 2, 4, 38, 96, 24, 65, 51, 43, 42, 41, 60, 46, 7, 90, 65, 3, 27, 63, 99, 51, 44, 86, 1, 54, 40, 15, 74, 3, 81, 51, 63, 87, 79, 84, 72, 22, 38, 96, 95, 33, 41, 21, 99, 21, 69, 7, 49, 40, 52, 41, 6, 91, 19, 76, 40, 54, 17, 33, 11, 11, 0, 1, 32, 94, 33, 13, 18, 45, 7, 85, 61, 42, 54, 45, 72, 78, 96, 17, 9, 80, 87, 41, 96, 66, 0, 8, 59, 18, 21, 2, 28, 64, 75, 97, 32, 80, 86, 97, 97, 55, 2, 73, 75, 11, 89, 67, 58, 70, 76, 12, 46, 64, 17, 22, 97, 25, 35, 93, 57, 82, 46, 57, 61, 31, 74, 27, 4, 32, 85, 53, 86, 53, 53, 42, 5, 28, 50, 65, 63, 70, 61, 73, 37, 13, 80, 7, 34, 22, 3, 26, 6, 62, 78, 12, 56, 87, 41, 58, 64, 31, 27, 45, 35, 18, 66, 62, 43, 89, 69, 94, 93, 33, 74, 2, 43, 85, 37, 82, 41, 74, 9, 15, 44, 33, 42, 65, 19, 1, 49, 78, 12, 29, 9, 78, 7, 55, 12, 45, 40, 33, 16, 86, 14, 52, 16, 73, 76, 0, 98, 75, 91, 78, 46, 99, 95, 90, 69, 78, 45, 62, 55, 37, 88, 49, 77, 27, 83, 38, 73, 39, 1, 75, 40, 65, 83, 54, 95, 7, 73, 4, 30, 26, 36, 89, 21, 5, 95, 11, 14, 87, 45, 36, 21, 77, 55, 5, 66, 51, 98, 48, 62, 74, 58, 23, 82, 30, 28, 19, 53, 89, 76, 98, 8, 34, 70, 28, 54, 16, 52, 35, 93, 54, 54, 72, 49, 18, 93, 72, 90, 71, 73, 15, 60, 38, 80, 76, 53, 70, 39, 69, 25, 5, 31, 61, 46, 6, 54, 34, 31, 52, 33, 36, 79, 76, 44, 29, 28, 38, 1, 66, 2, 90, 91, 1, 76, 78, 31, 55, 37, 71, 2, 3, 38, 85, 0, 95, 42, 2, 39, 57, 87, 61, 77, 98, 2, 24, 80, 48, 27, 47, 71, 15, 7, 49, 60, 86, 3, 2, 29, 38, 54, 36, 59, 83, 27, 47, 9, 36, 42, 8, 73, 85, 9, 16, 73, 60, 39, 12, 43, 25, 23, 29, 28, 47, 40, 77, 20, 89, 22, 30, 41, 59, 96, 19, 56, 20, 76, 73, 39, 46, 72, 40, 47, 37, 52, 29, 79, 37, 39, 50, 41, 87, 66, 17, 75, 31, 45, 26, 88, 70, 11, 90, 40, 74, 9, 32, 65, 72, 61, 6, 93, 54, 15, 84, 22, 99, 47, 10, 96, 4, 84, 19, 85, 73, 45, 25, 16, 8, 94, 99, 39, 28, 26, 68, 87, 48, 1, 65, 86, 46, 86, 7, 60, 82, 45, 75, 38, 56, 41, 35, 30, 86, 91, 97, 85, 45, 5, 14, 69, 85, 96, 37, 18, 26, 16, 38, 16, 1, 44, 94, 85, 58, 60, 20, 5, 47, 52, 41, 50, 71, 43, 42, 67, 64, 38, 65, 83, 99, 78, 96, 33, 20, 98, 24, 6, 2, 25, 16, 16, 44, 63, 24, 68, 56, 49, 91, 15, 59, 99, 27, 43, 34, 28, 36, 45, 1, 10, 19, 54, 26, 75, 17, 88, 96, 63, 24, 71, 93, 72, 97, 66, 87, 18, 86];
    this.randomCache = {};
    this.rndIndex = 0;
  }
  /**
   * Returns next pseudo random integer number from sequence between 0 and max parameter value (99 is maximum value)
   * @param max max value
   * @returns {number}
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(RandomGenerator, [{
    key: "nextRandom",
    value: function nextRandom(max) {
      var randomCache = this.randomCache,
          randomNumbers;

      if (randomCache[max]) {
        randomNumbers = randomCache[max];
      } else {
        randomNumbers = this.random100.filter(function (num) {
          return num < max;
        });
        randomCache[max] = randomNumbers;
      }

      return randomNumbers[this.rndIndex++ % randomNumbers.length];
    }
    /**
     * Resets sequence to initial number
     */

  }, {
    key: "reset",
    value: function reset() {
      this.rndIndex = 0;
    }
    /**
     * Returns pseudo random array element
     * @param array input array
     * @returns {*}
     */

  }, {
    key: "fromArray",
    value: function fromArray(array) {
      return array[this.nextRandom(array.length)];
    }
  }]);

  return RandomGenerator;
}();


RandomGenerator._$name = 'RandomGenerator';

/***/ }),

/***/ "./lib/Core/helper/util/Rectangle.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/util/Rectangle.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Rectangle; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.anchor */ "./node_modules/core-js/modules/es.string.anchor.js");
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");











var productName = 'scheduler';
/**
* @module Core/helper/util/Rectangle
*/




var allBorders = ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width'],
    allPaddings = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left'],
    borderNames = {
  t: 'border-top-width',
  r: 'border-right-width',
  b: 'border-bottom-width',
  l: 'border-left-width'
},
    paddingNames = {
  t: 'padding-top',
  r: 'padding-right',
  b: 'padding-bottom',
  l: 'padding-left'
},
    zeroBased = Object.freeze({
  x: 0,
  y: 0
}),
    alignSpecRe = /^([trblc])(\d*)-([trblc])(\d*)$/i,
    alignPointRe = /^([trblc])(\d*)$/i,
    edgeNames = ['top', 'right', 'bottom', 'left'],
    edgeIndices = {
  t: 0,
  r: 1,
  b: 2,
  l: 3
},
    defaultAlignments = ['b-t', 'l-r', 't-b', 'r-l'],
    zeroOffsets = Object.freeze([0, 0]),
    matchDimensions = ['width', 'height']; // Parse a l0-r0 (That's how Menus align to their owning MenuItem) slign spec.

function parseAlign(alignSpec) {
  var parts = alignSpecRe.exec(alignSpec),
      myOffset = parseInt(parts[2] || 50),
      targetOffset = parseInt(parts[4] || 50); // Comments assume the Menu's alignSpec of l0-r0 is used.

  return {
    myAlignmentPoint: parts[1] + myOffset,
    // l0
    myEdge: parts[1],
    // l
    myOffset: myOffset,
    // 0
    targetAlignmentPoint: parts[3] + targetOffset,
    // r0
    targetEdge: parts[3],
    // r
    targetOffset: targetOffset,
    // 0
    startZone: edgeIndices[parts[3]] // 1 - start trying zone 1 in TRBL order

  };
} // Takes a result from the above function and flips edges for the axisLock config


function flipAlign(align) {
  return "".concat(edgeNames[(edgeIndices[align.myEdge] + 2) % 4][0]).concat(align.myOffset, "-").concat(edgeNames[(edgeIndices[align.targetEdge] + 2) % 4][0]).concat(align.targetOffset);
}

function createOffsets(offset) {
  if (offset == null) {
    return zeroOffsets;
  } else if (typeof offset === 'number') {
    return [offset, offset];
  }

  return offset;
}
/**
 * Encapsulates rectangular areas for comparison, intersection etc.
 *
 * Note that the `right` and `bottom` properties are *exclusive*.
 *
 */


var Rectangle = /*#__PURE__*/function () {
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(Rectangle, [{
    key: "roundPx",

    /**
     * Rounds this Rectangle to the pixel resolution of the current display or to the nearest
     * passed unit which defaults to the current display's [`devicePixelRatio`](https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio).
     * @param [devicePixelRatio] device pixel ratio which defaults to `window.devicePixelRatio`
     */
    value: function roundPx() {
      var devicePixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.devicePixelRatio || 1;
      var me = this;
      me._x = _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].roundPx(me._x, devicePixelRatio);
      me._y = _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].roundPx(me._y, devicePixelRatio);
      me._width = _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].roundPx(me._width, devicePixelRatio);
      me._height = _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].roundPx(me._height, devicePixelRatio);
      return me;
    } // This class doesn't extend Base and extending doesn't seem to be
    // the way to go. Instead we duplicate smallest piece of logic here

  }, {
    key: "$$name",
    get: function get() {
      return this.constructor.$$name;
    }
    /**
     * Constructs a Rectangle
     * @param {Number} x The X coordinate
     * @param {Number} y The Y coordinate
     * @param {Number} width The width
     * @param {Number} height The height
     */

  }], [{
    key: "from",

    /**
     * Returns the Rectangle in document based coordinates of the passed element.
     *
     * *Note:* If the element passed is the `document` or `window` the `window`'s
     * rectangle is returned which is always at `[0, 0]` and encompasses the
     * browser's entire document viewport.
     * @param {HTMLElement} element The element to calculate the Rectangle for.
     * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
     * @param {Boolean} [ignorePageScroll=false] Use browser viewport based coordinates.
     * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
     */
    value: function from(element, relativeTo, ignorePageScroll) {
      var _element$namespaceURI;

      if (element instanceof Rectangle) {
        return element;
      }

      if (ignorePageScroll === undefined && typeof relativeTo === 'boolean') {
        ignorePageScroll = relativeTo;
        relativeTo = null;
      }

      if (relativeTo) {
        // TODO: nige should figure out if there is a better solution
        var _relativeTo = relativeTo,
            scrollLeft = _relativeTo.scrollLeft,
            scrollTop = _relativeTo.scrollTop;

        if ((_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isSafari) && relativeTo === document.body) {
          scrollLeft = scrollTop = 0;
        }

        relativeTo = Rectangle.from(relativeTo).translate(-scrollLeft, -scrollTop);
      } else {
        relativeTo = zeroBased;
      } // Viewport is denoted by requesting window or document.
      // document.body may overflow the viewport, so this must not be evaluated as the viewport.


      var isViewport = element === document || element === window,
          viewRect = isViewport ? new Rectangle(0, 0, window.innerWidth, window.innerHeight) : element.getBoundingClientRect(),
          scrollOffset = ignorePageScroll || isViewport ? [0, 0] : [window.pageXOffset, window.pageYOffset];
      var scaleX = 0,
          scaleY = 0; // scaleX/Y is required to adjust scaled SVG element bounding rect

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isIE11 || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isEdge && ((_element$namespaceURI = element.namespaceURI) === null || _element$namespaceURI === void 0 ? void 0 : _element$namespaceURI.match(/svg/))) {
        var _element$dataset, _element$dataset2;

        scaleX = ((_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset.scaleX) || 0;
        scaleY = ((_element$dataset2 = element.dataset) === null || _element$dataset2 === void 0 ? void 0 : _element$dataset2.scaleY) || 0;
      }

      return new Rectangle(viewRect.left + scrollOffset[0] - relativeTo.x + scaleX / 2, viewRect.top + scrollOffset[1] - relativeTo.y + scaleY / 2, viewRect.width - scaleX, viewRect.height - scaleY);
    }
    /**
     * Returns the Rectangle in viewport coordinates of the passed element.
     *
     * *Note:* If the element passed is the `document` or `window` the `window`'s rectangle is returned which is always
     * at `[0, 0]` and encompasses the browser's entire document viewport.
     * @param {HTMLElement} element The element to calculate the Rectangle for.
     * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
     * @return {Core.helper.util.Rectangle} The Rectangle in viewport based coordinates. Relative to the _relativeTo_
     * parameter if provided.
     */

  }, {
    key: "fromScreen",
    value: function fromScreen(element, relativeTo) {
      return Rectangle.from(element, relativeTo,
      /* ignorePageScroll = */
      true);
    }
    /**
     * Returns the inner Rectangle (within border) in document based coordinates
     * of the passed element.
     * @param element The element to calculate the Rectangle for.
     * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
     * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
     * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
     */

  }, {
    key: "inner",
    value: function inner(element, relativeTo) {
      var ignorePageScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

      if (document.body.contains(element)) {
        var borders = _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getStyleValue(element, allBorders);
        result.x += parseFloat(borders[borderNames.l]);
        result.y += parseFloat(borders[borderNames.t]);
        result.right -= parseFloat(borders[borderNames.r]);
        result.bottom -= parseFloat(borders[borderNames.b]);
      }

      return result;
    }
    /**
     * Returns the content Rectangle (within border and padding) in document based coordinates
     * of the passed element.
     * @param element The element to calculate the Rectangle for.
     * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
     * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
     * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
     */

  }, {
    key: "content",
    value: function content(element, relativeTo) {
      var ignorePageScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

      if (document.body.contains(element)) {
        var borders = _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getStyleValue(element, allBorders),
            padding = _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getStyleValue(element, allPaddings);
        result.x += parseFloat(borders[borderNames.l]) + parseFloat(padding[paddingNames.l]);
        result.y += parseFloat(borders[borderNames.t]) + parseFloat(padding[paddingNames.t]);
        result.right -= parseFloat(borders[borderNames.r]) + parseFloat(padding[paddingNames.r]);
        result.bottom -= parseFloat(borders[borderNames.b]) + parseFloat(padding[paddingNames.b]);
      }

      return result;
    }
    /**
     * Returns the client Rectangle (within border and padding and scrollbars) in document based coordinates
     * of the passed element.
     * @param element The element to calculate the Rectangle for.
     * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
     * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
     * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
     */

  }, {
    key: "client",
    value: function client(element, relativeTo) {
      var ignorePageScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var result = this.content(element, relativeTo, ignorePageScroll),
          scrollbarWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].scrollBarWidth;
      var padding;

      if (scrollbarWidth) {
        // Capture width taken by any vertical scrollbar.
        // If there is a vertical scrollbar, shrink the box.
        // TODO: We may have to shrink from the left in RTL mode.
        if (element.scrollHeight > element.clientHeight && _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getStyleValue(element, 'overflow-y') !== 'hidden') {
          padding = parseFloat(_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getStyleValue(element, 'padding-right'));
          result.right += padding - Math.max(padding, scrollbarWidth);
        } // Capture height taken by any horizontal scrollbar.
        // If there is a horizontal scrollbar, shrink the box.


        if (element.scrollWidth > element.clientWidth && _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getStyleValue(element, 'overflow-x') !== 'hidden') {
          padding = parseFloat(_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getStyleValue(element, 'padding-bottom'));
          result.bottom += padding - Math.max(padding, scrollbarWidth);
        }
      } // The client region excluding any scrollbars.


      return result;
    }
    /**
     * Returns a new rectangle created as the union of all supplied rectangles.
     * @param {Core.helper.util.Rectangle[]} rectangles
     * @return {Core.helper.util.Rectangle}
     */

  }, {
    key: "union",
    value: function union() {
      var _ref = arguments.length <= 0 ? undefined : arguments[0],
          x = _ref.x,
          y = _ref.y,
          right = _ref.right,
          bottom = _ref.bottom,
          current;

      if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
          current = i < 0 || arguments.length <= i ? undefined : arguments[i];

          if (current.x < x) {
            x = current.x;
          }

          if (current.y < y) {
            y = current.y;
          }

          if (current.right > right) {
            right = current.right;
          }

          if (current.bottom > bottom) {
            bottom = current.bottom;
          }
        }
      }

      return new Rectangle(x, y, right - x, bottom - y);
    }
  }, {
    key: "$$name",
    get: function get() {
      return hasOwnProperty.call(this, '$name') && this.$name || // _$name is filled by webpack for every class (cls._$name = '...')
      hasOwnProperty.call(this, '_$name') && this._$name || this.name;
    }
  }]);

  function Rectangle(x, y, width, height) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, Rectangle);

    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].assertNumber(x, 'Rectangle.x');
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].assertNumber(y, 'Rectangle.y');
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].assertNumber(width, 'Rectangle.width');
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].assertNumber(height, 'Rectangle.height');
    var me = this;
    me._x = x;
    me._y = y;
    me._width = width;
    me._height = height;
  }
  /**
   * Creates a copy of this Rectangle.
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(Rectangle, [{
    key: "clone",
    value: function clone() {
      var me = this,
          result = new Rectangle(me.x, me.y, me.width, me.height);
      result.isAlignRectangle = me.isAlignRectangle;
      result.minHeight = me.minHeight;
      result.minWidth = me.minWidth;
      return result;
    }
    /**
     * Returns `true` if this Rectangle wholly contains the passed rectangle.
     *
     * Note that a {@link Core.helper.util.Point} may be passed.
     * @param other The Rectangle to test for containment within this Rectangle
     * @return {Boolean} `true` if the other Rectangle is wholly contained within this Rectangle
     */

  }, {
    key: "contains",
    value: function contains(other) {
      var me = this;

      if (other instanceof Rectangle) {
        return other._x >= me._x && other._y >= me._y && other.right <= me.right && other.bottom <= me.bottom;
      } else {
        return false;
      }
    }
    /**
     * Checks if this Rectangle intersects the passed Rectangle
     * @param {Core.helper.util.Rectangle} other The Rectangle to intersect with this.
     * @param {Boolean} useBoolean Specify `true` to return a boolean value instead of constructing a new Rectangle
     * @param {Boolean} allowZeroDimensions `true` to consider zero-width or zero-hight rectangles as intersecting if coordinates indicate the intersection
     * @return {Core.helper.util.Rectangle|Boolean} Returns the intersection Rectangle or `false` if there is no intersection.
     */

  }, {
    key: "intersect",
    value: function intersect(other) {
      var useBoolean = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var allowZeroDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          y = Math.max(me.y, other.y),
          r = Math.min(me.right, other.right),
          b = Math.min(me.bottom, other.bottom),
          x = Math.max(me.x, other.x),
          intersect = allowZeroDimensions ? b >= y && r >= x : b > y && r > x;

      if (intersect) {
        return useBoolean ? true : new Rectangle(x, y, r - x, b - y);
      } else {
        return false;
      }
    }
  }, {
    key: "equals",
    value: function equals(other) {
      var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var processor = round ? function (x) {
        return Math.round(x);
      } : function (x) {
        return x;
      };
      return other instanceof Rectangle && processor(other.x) === processor(this.x) && processor(other.y) === processor(this.y) && processor(other.width) === processor(this.width) && processor(other.height) === processor(this.height);
    }
    /**
     * Translates this Rectangle by the passed vector. Size is maintained.
     * @param {Number} x The X translation vector.
     * @param {Number} y The Y translation vector.
     * @returns This Rectangle;
     */

  }, {
    key: "translate",
    value: function translate(x, y) {
      this._x += x || 0;
      this._y += y || 0;
      return this;
    }
    /**
     * Moves this Rectangle to the passed `x`, `y` position. Size is maintained.
     * @param {Number} x The new X position.
     * @param {Number} y The new Y position.
     * @returns This Rectangle;
     */

  }, {
    key: "moveTo",
    value: function moveTo(x, y) {
      if (x != null) {
        this._x = x;
      }

      if (y != null) {
        this._y = y;
      }

      return this;
    }
    /**
     * Returns the vector which would translate this Rectangle (or Point) to the same position as the other Rectangle (or point)
     * @param {Core.helper.util.Rectangle|Core.helper.util.Point} other The Rectangle or Point to calculate the delta to.
     */

  }, {
    key: "getDelta",
    value: function getDelta(other) {
      return [other.x - this.x, other.y - this.y];
    }
    /**
     * The center point of this rectangle.
     * @property {Core.helper.util.Point}
     */

  }, {
    key: "adjust",

    /**
     * Modifies the bounds of this Rectangle by the specified deltas.
     * @param {Number} x How much to *add* to the x position.
     * @param {Number} y  How much to *add* to the y position.
     * @param {Number} width  How much to add to the width.
     * @param {Number} height  How much to add to the height.
     * @returns This Rectangle
     */
    value: function adjust(x, y, width, height) {
      var me = this;
      me.x += x;
      me.y += y;
      me.width += width;
      me.height += height;
      return me;
    }
    /**
     * Modifies the bounds of this rectangle by moving them by the specified amount in all directions.
     * @param {Number} amount How much to inflate
     * @returns {Core.helper.util.Rectangle} This Rectangle
     */

  }, {
    key: "inflate",
    value: function inflate(amount) {
      return this.adjust(-amount, -amount, amount, amount);
    }
    /**
     * Attempts constrain this Rectangle into the passed Rectangle. If the `strict` parameter is `true`
     * then this method will return `false` if constraint could not be acheived.
     *
     * If this Rectangle has a `minHeight` or `minWidth` property, size will be adjusted while attempting to constrain.
     *
     * Right and bottom are adjusted first leaving the top and bottom sides to "win" in the case that this Rectangle overflows
     * the constrainTo Rectangle.
     * @param {Core.helper.util.Rectangle} constrainTo The Rectangle to constrain this Rectangle into if possible.
     * @param {Boolean} strict Pass `true` to return false, and leave this Rectangle unchanged if constraint
     * could not be achieved.
     * @returns This Rectangle. If `strict` is true, and constraining was not successful, `false`.
     */

  }, {
    key: "constrainTo",
    value: function constrainTo(_constrainTo, strict) {
      var me = this,
          originalHeight = me.height,
          originalY = me.y,
          minWidth = me.minWidth || me.width,
          minHeight = me.minHeight || me.height;

      if (me.height >= _constrainTo.height) {
        // If we're strict, fail if we could *never* fit into available height.
        if (strict && minHeight > _constrainTo.height) {
          return false;
        } // If we are >= constrain height, we will have to be at top edge of constrainTo


        me._y = _constrainTo.y;
        me.height = _constrainTo.height;
      }

      if (me.width >= _constrainTo.width) {
        // If we're strict, fail if we could *never* fit into available width.
        if (strict && minWidth > _constrainTo.width) {
          // Could not be constrained; undo any previous attempt with height
          me.y = originalY;
          me.height = originalHeight;
          return false;
        } // If we are >= constrain width, we will have to be at left edge of constrainTo


        me._x = _constrainTo.x;
        me.width = _constrainTo.width;
      }

      var overflow = me.bottom - _constrainTo.bottom; // Overflowing the bottom side, translate upwards.

      if (overflow > 0) {
        me.translate(0, -overflow);
      }

      overflow = me.right - _constrainTo.right; // Overflowing the right side, translate leftwards.

      if (overflow > 0) {
        me.translate(-overflow);
      }

      overflow = _constrainTo.y - me.y; // Now, after possible translation upwards, we overflow the top, translate downwards.

      if (overflow > 0) {
        me.translate(0, overflow);
      }

      overflow = _constrainTo.x - me.x; // Now, after possible translation leftwards, we overflow the left, translate rightwards.

      if (overflow > 0) {
        me.translate(overflow);
      }

      return me;
    }
    /**
     * Returns a cloned version of this Rectangle aligned to a target Rectangle, or element or {@link Core.widget.Widget}.
     * @param {Object} spec Alignment specification.
     * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} spec.target The Widget or element or Rectangle to align to.
     * @param {Number[]} [spec.anchorSize] The `[width, height]` of the anchor pointer when in `top` position. The
     * width is the baseline length, and the height is the height of the arrow. If passed, the anchor position
     * will be calculated to be at the centre of the overlap of the two aligned edges and returned in the `anchor`
     * property of the resulting Rectangle:
     *
     *     {
     *         edge: 'top',         // or 'right' or 'bottom' or 'left'
     *         x/y: offset          // dimension to translate and value to translate by.
     *     }
     *
     * @param {Object} [spec.anchorPosition] an `{ x: n, y: n }` anchor translation to be used *if the requested alignment
     * succeeds without violating constraints*. If a fallback alignment is used, the anchor will be centered in the
     * overlap of the aligned edges as usual.
     * @param {Boolean} [spec.overlap] True to allow this to overlap the target.
     * @param {String} spec.align The edge alignment specification string, specifying two points to bring together.
     * The form is `[trblc][n]-[trblc][n]. The `n` is a percentage offset
     * along that edge which defines the alignment point. This is not valid for alignment point `c`.
     * For example `t0-b0' would align this Rectangle's top left corner with the bottom left corner of the `target`.
     * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} [spec.constrainTo] The Widget or Element or Rectangle to constrain to.
     * If the requested alignment cannot be constrained (it will first shrink the resulting Rectangle according
     * to the `minWidth` and `minHeight` properties of this rectangle), then it will try aligning at other edges
     * (honouring the `axisLock` option), and pick the fallback alignment which results in the shortest translation.
     * @param {Boolean} [spec.axisLock] Specify as a truthy value to fall back to aligning against the opposite
     * edge first if the requested alignment cannot be constrained into the `constrainTo` option. If specified
     * as `'flexible'`, then fallback will continue searching for solutions on the remaining two sides.
     * @param {Number|Number[]} [spec.offset] The 'x' and 'y' offset values to create an extra margin round the target
     * to offset the aligned widget further from the target. May be configured as -ve to move the aligned widget
     * towards the target - for example producing the effect of the anchor pointer piercing the target.
     * @param {Number} [spec.constrainPadding] The amount of pixels to pad from the constraining element
     * @returns {Core.helper.util.Rectangle} A new Rectangle aligned as requested if possible, but if the requested position violates
     * the `constrainTo` Rectangle, the shortest translation from the requested position which obeys constraints will be used.
     */

  }, {
    key: "alignTo",
    value: function alignTo(spec) {
      // The target and constrainTo may be passed as HtmlElements or Widgets.
      // If so, extract the Rectangles without mutating the incoming spec.
      var result = this.clone(),
          target = spec.target,
          constrainTo = spec.constrainTo,
          calculatedAnchorPosition,
          zone,
          resultZone,
          constrainingToViewport;

      if (target && !(target instanceof Rectangle)) {
        target = Rectangle.from(target.element ? target.element : target);
      }

      if (constrainTo && !(constrainTo instanceof Rectangle)) {
        // Viewport is denoted by requesting window or document.
        // document.body may overflow the viewport, so this must not be evaluated as the viewport.
        constrainingToViewport = constrainTo === window || constrainTo === document; // When rectangle is constrained to some element on the page other than window/document, page scroll
        // should not be taken into account

        var ignorePageScroll = 'ignorePageScroll' in spec ? spec.ignorePageScroll : !constrainingToViewport;
        constrainTo = Rectangle.from(constrainTo.element ? constrainTo.element : constrainTo, null, ignorePageScroll);

        if (spec.constrainPadding) {
          constrainTo.inflate(-spec.constrainPadding);
        }
      }

      var me = this,
          targetOffsets = createOffsets(spec.offset),
          align = spec.align,
          axisLock = spec.axisLock,
          anchorSize = spec.anchorSize,
          anchorPosition = spec.anchorPosition,
          alignSpec = parseAlign(align),
          position = spec.position || (target && target.$$name === 'Point' ? target : null),
          targetConstrainRect = constrainTo && constrainTo.clone(),
          constraintZones = [],
          zoneOrder = [{
        zone: zone = alignSpec.startZone,
        align: align
      }],
          matchDimension = spec.matchSize && matchDimensions[alignSpec.startZone & 1],
          originalSize = me[matchDimension]; // Match the size of the edge we are aligning against

      if (matchDimension && axisLock) {
        result[matchDimension] = target[matchDimension];
      } // Ensure we will fit before trying


      if (constrainTo) {
        result.constrainTo(constrainTo);
      } // If we are aligning edge-to-edge, then plan our fallback strategy when we are constrained.


      if (constrainTo && alignSpec.startZone != null) {
        // Create the list of zone numbers and alignments to try in the preferred order.
        //
        // In the case of axisLock, go through the zones by each axis.
        // So if they asked for t-b, which is zone 2,
        // the array will be [2, 0, 3, 1] (t-b, b-t, r-l, l-r)
        if (axisLock) {
          // First axis flip has to maintain the offset along that axis.
          // so align: l0-r0 has to flip to align: r0-l0. See submenu flipping when
          // constrained to the edge. It flips sides but maintains vertical position.
          zoneOrder.push({
            zone: zone = (zone + 2) % 4,
            align: flipAlign(alignSpec)
          }); // Only try the other axis is axisLock is 'flexible'

          if (axisLock === 'flexible') {
            zoneOrder.push({
              zone: zone = (alignSpec.startZone + 1) % 4,
              align: defaultAlignments[zone]
            });
            zoneOrder.push({
              zone: zone = (zone + 2) % 4,
              align: defaultAlignments[zone]
            });
          }
        } // Go through the zones in order from the requested start.
        // So if they asked for t-b, which is zone 2,
        // the array will be [2, 3, 0, 1] (t-b, r-l, b-t, l-r)
        else {
            for (var i = 1; i < 4; i++) {
              zoneOrder.push({
                zone: zone = (zone + 1) % 4,
                align: defaultAlignments[zone]
              });
            }
          }
      } // Allow them to pass anchorPosition: {x: 10} to indicate that after a fully successful,
      // unconstrained align, the anchor should be 10px from the start.


      if (anchorPosition) {
        var _calculatedAnchorPosi;

        var pos = alignSpec.startZone & 1 ? 'y' : 'x';
        calculatedAnchorPosition = (_calculatedAnchorPosi = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_calculatedAnchorPosi, pos, anchorPosition[pos]), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_calculatedAnchorPosi, "edge", edgeNames[(alignSpec.startZone + 2) % 4]), _calculatedAnchorPosi);
      } // Keep the target within reach. If it's way outside, pull it back so that it's only just outside);


      if (targetConstrainRect && target) {
        targetConstrainRect.adjust(-target.width, -target.height, target.width, target.height);
        target.constrainTo(targetConstrainRect);
      } // As part of fallback process when fitting within constraints, result may shrink to our minima


      result.minWidth = me.minWidth;
      result.minHeight = me.minHeight; // We're being commanded to try to align at a position

      if (position) {
        result.moveTo(position.x, position.y);

        if (constrainTo) {
          result.constrainTo(constrainTo);
        }
      } // We're aligning to a Target Rectangle within a ConstrainTo Rectangle, taking into account
      // a possible anchor pointer, or x/y offsets. Here's the situation:
      //
      //                             <-- ConstrainTo Rectangle -->
      //  +-----------------------------------+--------------------+-------------------------+
      //  |                                   |                    |                         |
      //  |                                   |                    |                         |
      //  |                                   |                    |                         |
      //  |-----------------------------------+--------------------+-------------------------+
      //  |                                   |          ▼         |                         |
      //  |                                   | +----------------+ |                         |
      //  |                                   | |                | |                         |
      //  |                                   | |                | |                         |
      //  |                                   |▶|     Target     |◀|                         |
      //  |                                   | |                | |                         |
      //  |                                   | |                | |                         |
      //  |                                   | +----------------+ |                         |
      //  |                                   |          ▲         |                         |
      //  +-----------------------------------+--------------------+-------------------------|
      //  |                                   |                    |                         |
      //  |                                   |                    |                         |
      //  |                                   |                    |                         |
      //  +-----------------------------------+--------------------+-------------------------+
      //
      // Which results in the four possible constraint zones above, which we index in standard CSS order.
      //
      // Top    = 0
      // Right  = 1
      // Bottom = 2
      // Left   = 3
      //
      // If the initially requested alignment is not within the constrainTo rectangle
      // then, calculate these four, and then loop through them, beginning at the requested one,
      // quitting when we find a position which does not violate constraints. This includes
      // shrinking the aligning Rectangle towards its minima to attempt a fit.
      //
      // The final fallback, if there is no position which does not violate constraints
      // is to position in whichever of the four rectangles has the largest area shrinking overflowing
      // dimensions down to minima if specified.
      //
      else {
          // Offsets: If we are using an anchor to move away from the target, use anchor height in both dimensions.
          // It's rotated so that "height" always has the same meaning. It's the height of the arrow.
          var offsets = anchorSize ? [anchorSize[1] + targetOffsets[0], anchorSize[1] + targetOffsets[1]] : targetOffsets,
              targetPoint = target.getAlignmentPoint(alignSpec.targetAlignmentPoint, offsets),
              myPoint = result.getAlignmentPoint(alignSpec.myAlignmentPoint);
          result.translate(targetPoint[0] - myPoint[0], targetPoint[1] - myPoint[1]); // If an overlapping position was requested, then we are *not* trying out those four zones.
          // We just respect constraint, and that's it.

          var overlap = result.intersect(target, true); // If we are aligned over our target, we just obey that within any constraint.
          // No complex edge alignment attempts to fall back to.

          if (overlap) {
            var _result;

            if (constrainTo) {
              result.constrainTo(constrainTo);
            }

            resultZone = alignSpec.startZone;

            (_result = result).translate.apply(_result, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default()(offsets));
          } // Aligned to outside of our target, and we need to be constrained
          else if (constrainTo && !constrainTo.contains(result)) {
              var requestedResult = result.clone(),
                  solutions = [],
                  _zone,
                  largestZone; // Any configured anchorPosition becomes invalid now that we're having to move the resulting zone
              // to some unpredictable new place where it fits. It will have to be calculated based upon where
              // we end up aligning.


              calculatedAnchorPosition = null; // Calculate the four constraint zones illustrated above.
              // Top

              constraintZones[0] = _zone = constrainTo.clone();
              _zone.bottom = target.y - offsets[1]; // Right

              constraintZones[1] = _zone = constrainTo.clone();
              _zone.x = target.right + offsets[0]; // Bottom

              constraintZones[2] = _zone = constrainTo.clone();
              _zone.y = target.bottom + offsets[1]; // Left

              constraintZones[3] = _zone = constrainTo.clone();
              _zone.right = target.x - offsets[0]; // Start from the preferred edge and see if we are able to constrain to within each rectangle

              for (var _i = 0; _i < zoneOrder.length; _i++) {
                // Revert to incoming dimension for fallback out of axisLock
                if (matchDimension && _i == 2) {
                  result[matchDimension] = originalSize;
                }

                _zone = constraintZones[resultZone = zoneOrder[_i].zone]; // Perform unconstrained alignment at the calculated alignment for the zone

                result = result.alignTo({
                  target: target,
                  offsets: offsets,
                  align: zoneOrder[_i].align
                }); // If we are able to strictly constrain into this area, then it's one of the possible solutions.
                // We choose the solution which result in the shortest translation from the initial position.

                if (result.constrainTo(_zone, true)) {
                  solutions.push({
                    result: result,
                    zone: resultZone
                  }); // If this successful constraint is at the requested alignment, or at a fallback
                  // alignment which has used min size constraints, then that's the correct solution.
                  // If there's no size compromising, we have to pick the shortest translation.

                  if (!largestZone || result.width < me.width || result.height < me.height) {
                    result.align = zoneOrder[_i].align;
                    break;
                  }
                } // Cache the largest zone we find in case we need the final fallback.


                if (!largestZone || _zone.area > largestZone.area) {
                  var r = result.clone(); // And just move the result clone into the edge zone

                  switch (resultZone) {
                    // Top
                    case 0:
                      r.moveTo(null, _zone.bottom - r.height);
                      break;
                    // Right

                    case 1:
                      r.moveTo(_zone.left);
                      break;
                    // Bottom

                    case 2:
                      r.moveTo(null, _zone.top);
                      break;
                    // Left

                    case 3:
                      r.moveTo(_zone.right - r.width);
                      break;
                  }

                  largestZone = {
                    area: _zone.area,
                    result: r,
                    zone: resultZone
                  };
                }
              } // The loop found at least one solution


              if (solutions.length) {
                // Multiple fallbacks with no axisLock.
                // Use the solution which resulted in the shortest translation distance from the requested alignment.
                if (solutions.length > 1 && !axisLock) {
                  solutions.sort(function (s1, s2) {
                    var s1TranslationDistance = Math.sqrt(Math.pow(requestedResult.x - s1.result.x, 2) + Math.pow(requestedResult.y - s1.result.y, 2)),
                        s2TranslationDistance = Math.sqrt(Math.pow(requestedResult.x - s2.result.x, 2) + Math.pow(requestedResult.y - s2.result.y, 2));
                    return s1TranslationDistance - s2TranslationDistance;
                  });
                } // Initial success, or axisLock. Use first successful solution.


                result = solutions[0].result;
                resultZone = solutions[0].zone;
              } // No solutions found - use the largest rectangle.
              else {
                  result = largestZone.result;
                  resultZone = largestZone.zone; // When we are constraining to the viewport, we must still must be constrained,
                  // even after we've given up making it align *and* constrain.

                  if (constrainingToViewport) {
                    result.constrainTo(constrainTo);
                  }
                }
            } else {
              resultZone = alignSpec.startZone;
            }

          result.zone = resultZone; // If they included an anchor, calculate its position along its edge.
          // TODO: Handle the edge overlap being less than anchor width.

          if (anchorSize) {
            // If we were passed an anchorPosition, and it has remnained valid (meaning the requested
            // alignment succeeded with no constraint), then anchorPosition will be set. If not,
            // we have to calculate it based upon the aligned edge.
            if (!calculatedAnchorPosition) {
              var _calculatedAnchorPosi2;

              var isLeftOrRight = resultZone & 1,
                  start = isLeftOrRight ? 'y' : 'x',
                  end = isLeftOrRight ? 'bottom' : 'right',
                  startValue = Math.max(target[start], result[start]),
                  endValue = Math.min(target[end], result[end]),
                  anchorStart = startValue + (endValue - startValue) / 2 - anchorSize[0] / 2,
                  anchorEnd = anchorStart + anchorSize[0];

              if (anchorEnd > result[end]) {
                anchorStart -= anchorEnd - result[end];
              }

              if (anchorStart < result[start]) {
                anchorStart += result[start] - anchorStart;
              } // Return an anchor property which will have an x or y property and an edge name onto which the
              // arrow should be aligned.


              calculatedAnchorPosition = (_calculatedAnchorPosi2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_calculatedAnchorPosi2, start, anchorStart - result[start]), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_calculatedAnchorPosi2, "edge", edgeNames[(resultZone + 2) % 4]), _calculatedAnchorPosi2);
            }

            result.anchor = calculatedAnchorPosition;
          }
        }

      return result;
    }
    /**
     * Returns the `[x, y]` position of the specified anchor point of this Rectangle in <edge><offset> format.
     * for example passing "t50" will return the centre point of the top edge, passing "r0" will return the start
     * position of the right edge (the top right corner).
     *
     * Note that the offset defaults to 50, so "t" means the centre of the top edge.
     * @param {String} alignmentPoint The alignment point to calculate. Must match the RegExp `[trbl]\d*`
     * @param {Number[]} margins The `[x, y]` margins to add from the left/right, top/bottom edge.
     */

  }, {
    key: "getAlignmentPoint",
    value: function getAlignmentPoint(alignmentPoint) {
      var margins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : zeroOffsets;
      var me = this,
          parts = alignPointRe.exec(alignmentPoint),
          edge = parts[1].toLowerCase(),
          edgeOffset = Math.min(Math.max(parseInt(parts[2] || 50), 0), 100) / 100;

      switch (edge) {
        case 't':
          return [me.x + me.width * edgeOffset, me.y - margins[1]];

        case 'r':
          return [me.right + margins[0], me.y + me.height * edgeOffset];

        case 'b':
          return [me.x + me.width * edgeOffset, me.bottom + margins[1]];

        case 'l':
          return [me.x - margins[0], me.y + me.height * edgeOffset];

        case 'c':
          {
            var center = me.center;
            return [center.x + margins[0], center.y + margins[1]];
          }
      }
    }
    /**
     * Highlights this Rectangle using the highlighting effect of {@link Core.helper.DomHelper}
     * on a transient element which encapsulates the region's area.
     */

  }, {
    key: "highlight",
    value: function highlight() {
      var me = this,
          highlightElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].createElement({
        parent: document.body,
        style: "position:absolute;z-index:9999999;pointer-events:none;\n                            left:".concat(me.x, "px;top:").concat(me.y, "px;width:").concat(me.width, "px;height:").concat(me.height, "px")
      });
      return _DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].highlight(highlightElement).then(function () {
        return highlightElement.remove();
      });
    }
  }, {
    key: "center",
    get: function get() {
      return new Rectangle.Point(this.x + this.width / 2, this.y + this.height / 2);
    }
    /**
     * Get/sets the X coordinate of the Rectangle. Note that this does *not* translate the
     * Rectangle. The requested {@link #property-width} will change.
     * @property {Number}
     */

  }, {
    key: "x",
    set: function set(x) {
      var xDelta = x - this._x;
      this._x = x;
      this._width -= xDelta;
    },
    get: function get() {
      return this._x;
    }
    /**
     * Alias for x. To match DOMRect.
     * @property {Number}
     */

  }, {
    key: "left",
    set: function set(x) {
      this.x = x;
    },
    get: function get() {
      return this.x;
    }
    /**
     * Alias for y. To match DOMRect.
     * @property {Number}
     */

  }, {
    key: "top",
    set: function set(y) {
      this.y = y;
    },
    get: function get() {
      return this.y;
    }
    /**
     * Get/sets the Y coordinate of the Rectangle. Note that this does *not* translate the
     * Rectangle. The requested {@link #property-height} will change.
     * @property {Number}
     */

  }, {
    key: "y",
    set: function set(y) {
      var yDelta = y - this._y;
      this._y = y;
      this._height -= yDelta;
    },
    get: function get() {
      return this._y;
    }
    /**
     * Get/sets the width of the Rectangle. Note that the requested {@link #property-right} will change.
     * @property {Number}
     */

  }, {
    key: "width",
    set: function set(width) {
      this._width = width;
    },
    get: function get() {
      return this._width;
    }
    /**
     * Get/sets the height of the Rectangle. Note that the requested {@link #property-bottom} will change.
     * @property {Number}
     */

  }, {
    key: "height",
    set: function set(height) {
      this._height = height;
    },
    get: function get() {
      return this._height;
    }
    /**
     * Get/sets the right edge of the Rectangle. Note that the requested {@link #property-width} will change.
     *
     * The right edge value is exclusive of the calculated rectangle width. So x=0 and right=10
     * means a width of 10.
     * @property {Number}
     */

  }, {
    key: "right",
    set: function set(right) {
      this._width = right - this._x;
    },
    get: function get() {
      return this._x + this._width;
    }
    /**
     * Get/sets the bottom edge of the Rectangle. Note that the requested {@link #property-height} will change.
     *
     * The bottom edge value is exclusive of the calculated rectangle height. So y=0 and bottom=10
     * means a height of 10.
     * @property {Number}
     */

  }, {
    key: "bottom",
    set: function set(bottom) {
      this._height = bottom - this._y;
    },
    get: function get() {
      return this._y + this._height;
    }
  }, {
    key: "area",
    get: function get() {
      return this.width * this.height;
    }
  }, {
    key: "minWidth",
    set: function set(minWidth) {
      var me = this;

      if (isNaN(minWidth)) {
        me._minWidth = null;
      } else {
        me._minWidth = Number(minWidth); // If this is being used as an alignment calculation rectangle, minWidth has a different meaning.
        // It does not mean that the width has to be at least this value. It means that under constraint,
        // it is willing to shrink down to that value before falling back to another align position.

        if (!me.isAlignRectangle) {
          me.width = Math.max(me.width, me._minWidth);
        }
      }
    },
    get: function get() {
      return this._minWidth;
    }
  }, {
    key: "minHeight",
    set: function set(minHeight) {
      var me = this;

      if (isNaN(minHeight)) {
        me._minHeight = null;
      } else {
        me._minHeight = Number(minHeight); // If this is being used as an alignment calculation rectangle, minHeight has a different meaning.
        // It does not mean that the height has to be at least this value. It means that under constraint,
        // it is willing to shrink down to that value before falling back to another align position.

        if (!me.isAlignRectangle) {
          me.height = Math.max(me.height, me._minHeight);
        }
      }
    },
    get: function get() {
      return this._minHeight;
    }
  }]);

  return Rectangle;
}();


Rectangle._$name = 'Rectangle';

/***/ }),

/***/ "./lib/Core/helper/util/Scroller.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/util/Scroller.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Scroller; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _IdHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Point_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./Point.js */ "./lib/Core/helper/util/Point.js");


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';











/**
 * @module Core/helper/util/Scroller
 */

var scrollLiterals = {
  true: 'auto',
  false: 'hidden',
  'hidden-scroll': 'auto'
},
    scrollerCls = 'b-widget-scroller',
    defaultScrollOptions = {
  block: 'nearest'
},
    immediatePromise = Promise.resolve(),
    scrollPromise = function scrollPromise(element) {
  return new Promise(function (resolve) {
    return _EventHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].on({
      element: element,
      scroll: resolve,
      once: true
    });
  });
},
    xAxis = {
  x: 1
};
/**
 * Encapsulates scroll functionality for a Widget. All requests for scrolling and scrolling information
 * must go through a Widget's {@link Core.widget.Widget#config-scrollable} property.
 * @mixes Core/mixin/Events
 * @mixes Core/mixin/Delayable
 * @extends Core/Base
 */


var Scroller = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(Scroller, _Delayable);

  var _super = _createSuper(Scroller);

  function Scroller() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, Scroller);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(Scroller, [{
    key: "syncOverflowState",

    /**
     * Fired when scrolling happens on this Scroller's element. The event object is a native `scroll` event
     * with the described extra properties injected.
     * @event scroll
     * @param {Core.widget.Widget} widget The owning Widget which has been scrolled.
     * @param {Core.helper.util.Scroller} source This Scroller
     */

    /**
     * Fired when scrolling finished on this Scroller's element. The event object is the last native `scroll` event
     * fires by the element with the described extra properties injected.
     * @event scrollend
     * @param {Core.widget.Widget} widget The owning Widget which has been scrolled.
     * @param {Core.helper.util.Scroller} source This Scroller
     */

    /**
     * The `overflow-x` setting for the widget. `true` means `'auto'`.
     * @member {Boolean|String} overflowX
     */

    /**
     * The `overflow-y` setting for the widget. `true` means `'auto'`.
     * @member {Boolean|String} overflowY
     */
    value: function syncOverflowState() {
      var element = this.element,
          classList = element.classList; // We use classes to indicate presence of overflow. This carries no rules by default.
      // Widget SASS may or may not attach rules or use these to select elements.

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isEdge) {
        // Edge rounds widths and may falsely report a horizontal overflow
        classList[element.scrollWidth - element.clientWidth > 1 ? 'add' : 'remove']('b-horizontal-overflow');
      } else {
        classList[element.scrollWidth > element.clientWidth ? 'add' : 'remove']('b-horizontal-overflow');
      }

      classList[element.scrollHeight > element.clientHeight ? 'add' : 'remove']('b-vertical-overflow');
    }
    /**
     * Returns `true` if there is a *space-consuming* scrollbar controlling scroll in the specified axis.
     * @param {*} axis The axis to check scrollbar for. Note that this is subtly different to asking
     * whether an axis *has any* overflow.
     */

  }, {
    key: "hasScrollbar",
    value: function hasScrollbar() {
      var axis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'y';
      var element = this.element;

      if (element && _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].scrollBarWidth) {
        var vertical = axis === 'y',
            dimension = vertical ? 'Width' : 'Height',
            clientSize = element["client".concat(dimension)],
            borderSize = parseInt(_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].getStyleValue(element, "border".concat(vertical ? 'Left' : 'Top', "Width"))) + parseInt(_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].getStyleValue(element, "border".concat(vertical ? 'Right' : 'Bottom', "Width"))),
            difference = element["offset".concat(dimension)] - borderSize - clientSize; // If the difference between the content width and the client width is
        // scrollBarWidth, then we have a scrollbar

        return Math.abs(difference - _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].scrollBarWidth) < 2;
      }
    }
    /**
     * Partners this Scroller with the passed scroller in order to sync the scrolling position in the passed axes
     * @param {Core.helper.util.Scroller} otherScroller
     * @param {String|Object} [axes='x'] `'x'` or `'y'` or `{x: true/false, y: true/false}` axes to sync
     */

  }, {
    key: "addPartner",
    value: function addPartner(otherScroller) {
      var axes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : xAxis;

      if (typeof axes === 'string') {
        axes = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()({}, axes, 1);
      }

      (this.partners || (this.partners = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_23__["default"]())).add({
        id: otherScroller.id,
        scroller: otherScroller,
        axes: axes
      }); // It's a mutual relationship - the other scroller partners with us.

      if (!otherScroller.partners || !otherScroller.partners.includes(this.id)) {
        otherScroller.addPartner(this, axes);
      }
    }
    /**
     * Breaks the link between this Scroller and the passed Scroller set up by the
     * {@link #function-addPartner} method.
     * @param {Core.helper.util.Scroller} otherScroller The Scroller to unlink from.
     */

  }, {
    key: "removePartner",
    value: function removePartner(otherScroller) {
      if (this.partners && this.partners.includes(otherScroller)) {
        this.partners.remove(otherScroller);
        otherScroller.removePartner(this);
      }
    }
    /**
     * Scrolls the passed element or {@link Core.helper.util.Rectangle} into view according to the passed options.
     * @param {HTMLElement|Core.helper.util.Rectangle} element The element or a Rectangle in document space to scroll into view.
     * @param {Object} [options] How to scroll.
     * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
     * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
     * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
     * or the number of milliseconds to animate over, or an animation config object.
     * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
     * @param {String} [options.animate.easing] The name of an easing function.
     * @param {Boolean|Function} [options.highlight] Set to `true` to highlight the element when it is in view.
     * May be a function which is called passing the element, to provide customized highlighting.
     * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
     * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
     * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
     * @returns {Promise} A promise which is resolved when the element has been scrolled into view.
     */

  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;

      var me = this,
          isRectangle = element instanceof _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__["default"],
          originalRect = isRectangle ? element : _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__["default"].from(element),
          _me$getDeltaTo = me.getDeltaTo(element, options),
          xDelta = _me$getDeltaTo.xDelta,
          yDelta = _me$getDeltaTo.yDelta,
          result = me.scrollBy(xDelta, yDelta, options);

      if (options.highlight || options.focus) {
        result.then(function () {
          if (isRectangle) {
            element = originalRect.translate(-xDelta, -yDelta);
          }

          if (options.highlight) {
            // Not coercible to a number means its a function or name of a function
            if (isNaN(options.highlight)) {
              (me.widget || me).callback(options.highlight, null, [element]);
            } // Otherwise, it's truthy or falsy
            else {
                _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].highlight(element, me);
              }
          }

          if (options.focus) {
            element.focus();
          }
        });
      }

      return result;
    }
    /**
     * Scrolls by the passed deltas according to the passed options.
     * @param {Number} [xDelta=0] How far to scroll in the X axis.
     * @param {Number} [yDelta=0] How far to scroll in the Y axis.
     * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
     * @param {Boolean} [options.silent] Set to `true` to suspend `scroll` events during scrolling.
     * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
     * or the number of milliseconds to animate over, or an animation config object.
     * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
     * @param {String} [options.animate.easing] The name of an easing function.
     * @returns {Promise} A promise which is resolved when the scrolling has finished.
     */

  }, {
    key: "scrollBy",
    value: function scrollBy() {
      var xDelta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var yDelta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultScrollOptions;
      var me = this,
          animate = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9___default()(options) === 'object' ? options.animate : options,
          absX = Math.abs(xDelta),
          absY = Math.abs(yDelta);

      if (me.scrollAnimation) {
        me.scrollAnimation.cancel();
        me.scrollAnimation = null;
      } // Only set the flag if there is going to be scrolling done.
      // It is cleared by the scrollEnd handler, so there must be scrolling.


      if (xDelta || yDelta) {
        me.silent = options.silent;
      }

      var duration = animate && (typeof animate === 'number' ? animate : typeof animate.duration === 'number' ? animate.duration : 300); // Only go through animation if there is significant scrolling to do.

      if (duration && (absX > 10 || absY > 10)) {
        var x = me.x,
            y = me.y;
        var lastX = x,
            lastY = y; // For small distances, constrain duration

        if (Math.max(absX, absY) < 50) {
          duration = Math.min(duration, 500);
        }

        me.scrollAnimation = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].animate(duration, function (progress) {
          var isEnd = progress === 1;

          if (xDelta) {
            // If the user, or another process has changed the position since last time, abort.
            // Unless called with the force option to proceed regardless.
            if (me.x !== lastX && !options.force) {
              return me.scrollAnimation && me.scrollAnimation.cancel();
            }

            me.x = Math.max(x + (isEnd ? xDelta : Math.round(xDelta * progress)), 0);
          }

          if (yDelta) {
            // If the user, or another process has changed the position since last time, abort.
            // Unless called with the force option to proceed regardless.
            if (me.y !== lastY && !options.force) {
              return me.scrollAnimation && me.scrollAnimation.cancel();
            }

            me.y = Math.max(y + (isEnd ? yDelta : Math.round(yDelta * progress)), 0);
          } // Store actual position from DOM


          lastX = me.x;
          lastY = me.y;
        }, me, animate.easing);
        me.element.classList.add('b-scrolling');
        me.scrollAnimation.then(function () {
          if (!me.isDestroyed) {
            me.element.classList.remove('b-scrolling');
            me.scrollAnimation = null;
          }
        });
        return me.scrollAnimation;
      } else {
        if (xDelta | yDelta) {
          me.x += xDelta;
          me.y += yDelta;
          return scrollPromise(me.element);
        } else {
          return immediatePromise;
        }
      }
    }
    /**
     * Scrolls to the passed position according to the passed options.
     * @param {Number} [toX=0] Where to scroll to in the X axis.
     * @param {Number} [toY=0] Where to scroll to in the Y axis.
     * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
     * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
     * or the number of milliseconds to animate over, or an animation config object.
     * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
     * @param {String} [options.animate.easing] The name of an easing function.
     * @returns {Promise} A promise which is resolved when the scrolling has finished.
     */

  }, {
    key: "scrollTo",
    value: function scrollTo(toX, toY, options) {
      var x = this.x,
          y = this.y,
          xDelta = toX == null ? 0 : toX - x,
          yDelta = toY == null ? 0 : toY - y;
      return this.scrollBy(xDelta, yDelta, options);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this;

      if (me._element) {
        me._element.removeEventListener('scroll', me.scrollHandler);

        me.wheelListenerRemover && me.wheelListenerRemover();
      }

      if (me.scrollAnimation) {
        me.scrollAnimation.cancel();
      }

      me.partners && me.partners.forEach(function (partner) {
        return partner.scroller.removePartner(me);
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Scroller.prototype), "doDestroy", this).call(this);
    }
    /**
     * Respond to style changes to monitor scroll *when this Scroller is in `translate: true` mode.*
     * @param {Object[]} mutations The ElementMutation records.
     * @private
     */

  }, {
    key: "onElMutation",
    value: function onElMutation(mutations) {
      var me = this,
          _DomHelper$getTransla = _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].getTranslateXY(me.element),
          _DomHelper$getTransla2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8___default()(_DomHelper$getTransla, 2),
          x = _DomHelper$getTransla2[0],
          y = _DomHelper$getTransla2[1]; // If the mutation was due to a change in the translateX/Y styles, this is
      // a scroll event, so inform observers and partners


      if (me._x !== -x || me.y !== -y) {
        var scrollEvent = new CustomEvent('scroll', {
          bubbles: true
        });
        Object.defineProperty(scrollEvent, 'target', {
          get: function get() {
            return me.element;
          }
        });
        me.onScroll(scrollEvent);
      }
    }
  }, {
    key: "onScroll",
    value: function onScroll(e) {
      var me = this;

      if (!me.widget || !me.widget.isDestroyed) {
        // Don't read the value until we have to. The x & y getters will check this flag
        me.positionDirty = true;

        if (!me.element.classList.contains('b-scrolling')) {
          me.element.classList.add('b-scrolling');
        }

        e.widget = me.widget; // If we have the scroll silent flag, do not fire the event.

        if (!me.silent) {
          me.trigger('scroll', e);
        } // Keep partners in sync


        me.syncPartners(); // If this scroll impulse was from a controlling partner, clear that now

        me.controllingPartner = null; // Will fire in 100ms, unless another scroll event comes round.
        // In which case execution will be pushed out by another 100ms.

        me.scrollEndHandler(e);
      }
    }
  }, {
    key: "syncPartners",
    value: function syncPartners() {
      var me = this; // Keep partners in sync

      if (me.partners) {
        me.partners.forEach(function (_ref) {
          var axes = _ref.axes,
              scroller = _ref.scroller;

          // Don't feed back to the one who's just told us to scroll here.
          if (scroller !== me.controllingPartner) {
            scroller.sync(me, axes);
          }
        });
      }
    }
  }, {
    key: "onScrollEnd",
    value: function onScrollEnd(e) {
      if (this.silent) {
        this.silent = false;
      }

      this.trigger('scrollEnd', e); // Controlling partner is required for scrollable not to change its partners on scroll. This method is buffered
      // and landing here essentially means that no scrolling has occurred during the `scrollEndBuffer` time. We can
      // safely cleanup controlling partner here.
      // https://github.com/bryntum/support/issues/1095

      this.controllingPartner = null;
      this.element.classList.remove('b-scrolling');
    }
    /**
     * Returns the xDelta and yDelta values in an object from the current scroll position to the
     * passed element or Rectangle.
     * @param {HTMLElement|Core.helper.util.Rectangle} element The element or a Rectangle to calculate deltas for.
     * @param {Object} [options] How to scroll.
     * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
     * @param {Number} [options.edgeOffset] A margin around the element or rectangle to bring into view.
     * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
     * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
     * @returns {Object} `{ xDelta, yDelta }`
     * @internal
     */

  }, {
    key: "getDeltaTo",
    value: function getDeltaTo(element, options) {
      var me = this; // scroller may belong to a collapsed subgrid widget

      if (!me.viewport) {
        return {
          xDelta: 0,
          yDelta: 0
        };
      }

      var elementRect = element instanceof _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__["default"] ? element : _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__["default"].from(element),
          block = options.block || 'nearest',
          scrollerRect = me.viewport,
          edgeOffset = options.edgeOffset || 0,
          // Only include the offset round the target is the viewport is big enough to accommodate it.
      xOffset = scrollerRect.width >= elementRect.width + edgeOffset * 2 ? edgeOffset : 0,
          yOffset = scrollerRect.height >= elementRect.height + edgeOffset * 2 ? edgeOffset : 0,
          elRect = elementRect.clone().adjust(-xOffset, -yOffset, xOffset, yOffset).constrainTo(new _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__["default"](scrollerRect.x - me.x, scrollerRect.y - me.y, me.scrollWidth, me.scrollHeight)),
          targetRect = elRect.clone();
      var xDelta = 0,
          yDelta = 0;

      if (block === 'start') {
        targetRect.moveTo(scrollerRect.x, scrollerRect.y);
        xDelta = elRect.x - targetRect.x;
        yDelta = elRect.y - targetRect.y;
      } else if (block === 'end') {
        targetRect.translate(scrollerRect.right - targetRect.right, scrollerRect.bottom - targetRect.bottom);
        xDelta = elRect.x - targetRect.x;
        yDelta = elRect.y - targetRect.y;
      } else {
        // Calculate deltas unless the above has done that for non-fitting target
        if (block === 'center') {
          var center = scrollerRect.center;
          targetRect.moveTo(center.x - targetRect.width / 2, center.y - targetRect.height / 2);
          xDelta = xDelta || elRect.x - targetRect.x;
          yDelta = yDelta || elRect.y - targetRect.y;
        } // Use "nearest"
        else {
            // Can't fit width in, scroll what is possible into view so that start is visible.
            if (targetRect.width > scrollerRect.width) {
              xDelta = targetRect.x - scrollerRect.x;
            } // If it's *possible* to scroll to nearest x, calculate the delta
            else {
                if (targetRect.right > scrollerRect.right) {
                  xDelta = targetRect.right - scrollerRect.right;
                } else if (targetRect.x < scrollerRect.x) {
                  xDelta = targetRect.x - scrollerRect.x;
                }
              } // Can't fit height in, scroll what is possible into view so that start is visible.


            if (targetRect.height > scrollerRect.height) {
              yDelta = targetRect.y - scrollerRect.y;
            } // If it's *possible* to scroll to nearest y, calculate the delta
            else {
                if (targetRect.bottom > scrollerRect.bottom) {
                  yDelta = targetRect.bottom - scrollerRect.bottom;
                } else if (targetRect.y < scrollerRect.y) {
                  yDelta = targetRect.y - scrollerRect.y;
                }
              }
          }
      } // Do not allow deltas which would produce -ve scrolling or scrolling past the maxX/Y


      return {
        // When calculating how much delta is necessary to scroll the targetRect to the center
        // constrain that to what is *possible*. If what you are trying to scroll into the
        // center is hard against the right edge of the scroll range, then it cannot scroll
        // to the center, and the result must reflect that even though scroll is self limiting.
        // This is because highlighting the requested "element", if that element is in fact
        // a Rectangle, uses a temporary element placed at the requested region which
        // MUST match where the actual scroll has moved the requested region.
        xDelta: options.x === false ? 0 : Math.round(Math.max(Math.min(xDelta, me.maxX - me.x), -me.x)),
        yDelta: options.y === false ? 0 : Math.round(Math.max(Math.min(yDelta, me.maxY - me.y), -me.y))
      };
    }
    /**
     * A {@link Core.helper.util.Rectangle Rectangle} describing the bounds of the scrolling viewport.
     * @property {Core.helper.util.Rectangle}
     */

  }, {
    key: "updateElement",
    value: function updateElement(element, oldElement) {
      var me = this,
          scrollHandler = me.scrollHandler || (me.scrollHandler = me.onScroll.bind(me));

      if (!me.scrollEndHandler) {
        me.scrollEndHandler = me.buffer(me.onScrollEnd, me.scrollEndBuffer);
      }

      if (oldElement) {
        if (me.translate) {
          me.mutationObserver && me.mutationObserver.disconnect(oldElement);
        } else {
          oldElement.removeEventListener('scroll', scrollHandler);
          oldElement.classList.remove(scrollerCls);
        }
      }

      if (me.translate) {
        if (!me.mutationObserver) {
          me.mutationObserver = new MutationObserver(function (mutations) {
            return me.onElMutation(mutations);
          });
        }

        me.mutationObserver.observe(element, {
          attributes: true
        });
        me._x = me._y = 0;

        if (document.contains(element)) {
          var _DomHelper$getTransla3 = _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].getTranslateXY(element),
              _DomHelper$getTransla4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8___default()(_DomHelper$getTransla3, 2),
              x = _DomHelper$getTransla4[0],
              y = _DomHelper$getTransla4[1];

          me._x = -x;
          me._y = -y;
        }
      } else {
        element.addEventListener('scroll', scrollHandler);
        element.classList.add(scrollerCls);
      } // Ensure the overflow configs, which are unable to process themselves
      // in the absence of the element get applied to the newly arrived element.


      if (me.positionDirty) {
        me.updateOverflowX(me.overflowX);
        me.updateOverflowY(me.overflowY);
      } // Apply initially configured scroll position if we have non-zero positions


      if (me.isConfiguring) {
        me._x && me.updateX(me._x);
        me._y && me.updateY(me._y);
      }

      me.positionDirty = true;
    }
    /**
     * The horizontal scroll position of the widget.
     * @property {Number}
     */

  }, {
    key: "changeX",
    value: function changeX(x) {
      // Only process initial X if we were configured to start at non-zero
      if (!this.isConfiguring || x) {
        return x;
      }

      this._x = x;
    }
  }, {
    key: "updateX",
    value: function updateX(x) {
      var element = this.element,
          widget = this.widget; // When element is outside of DOM, this can have no effect

      if (element && !(widget === null || widget === void 0 ? void 0 : widget.isConfiguring)) {
        this.trigger('scrollStart', {
          x: x
        });

        if (this.translate) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].setTranslateX(element, -x);
        } else {
          element.scrollLeft = x;
        }
      } // The scroll position will need to be read before we can return it.
      // Do not read it back now, we may not have our element, or if we do,
      // that would cause a forced synchronous layout.


      this.positionDirty = true;
    }
  }, {
    key: "sync",
    value: function sync(controllingPartner, axes) {
      var x = axes.x,
          y = axes.y;

      if (x != null) {
        if (this.x !== controllingPartner.x) {
          // Only set controlling partner when scroll will actually change. This helps to increase stability of
          // state restoring API.
          this.controllingPartner = controllingPartner;
          this.x = controllingPartner.x;
        }
      }

      if (y != null) {
        if (this.y !== controllingPartner.y) {
          this.controllingPartner = controllingPartner;
          this.y = controllingPartner.y;
        }
      }
    }
    /**
     * The vertical scroll position of the widget.
     * @property {Number}
     */

  }, {
    key: "changeY",
    value: function changeY(y) {
      // Only process initial Y if we were configured to start at non-zero
      if (!this.isConfiguring || y) {
        return y;
      }

      this._y = y;
    }
  }, {
    key: "updateY",
    value: function updateY(y) {
      var element = this.element,
          widget = this.widget; // When element is outside of DOM, this can have no effect

      if (element && !(widget === null || widget === void 0 ? void 0 : widget.isConfiguring)) {
        this.trigger('scrollStart', {
          y: y
        });

        if (this.translate) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].setTranslateY(element, -y);
        } else {
          element.scrollTop = y;
        }
      } // The scroll position will need to be read before we can return it.
      // Do not read it back now, we may not have our element, or if we do,
      // that would cause a forced synchronous layout.


      this.positionDirty = true;
    }
    /**
     * The maximum `X` scrollable position of the widget.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "updateOverflowX",
    value: function updateOverflowX(overflowX) {
      var element = this.element,
          translate = this.translate;

      if (element) {
        // Scroll, but without showing scrollbars.
        // For example a grid header. Only works on platforms which
        // support suppression of scrollbars through CSS.
        if (overflowX === 'hidden-scroll' && !translate) {
          element.classList.add('b-hide-scroll'); // Adds a wheel listener if needed - there is scrollbar width
          // and we don't already have one.

          this.enableWheel();
        }

        if (!translate) {
          element.style.overflowX = scrollLiterals[overflowX] || overflowX;
        }
      }

      this.positionDirty = !this.isConfiguring;
    }
  }, {
    key: "updateOverflowY",
    value: function updateOverflowY(overflowY) {
      var element = this.element,
          translate = this.translate;

      if (element) {
        // Scroll, but without showing scrollbars.
        // For example a grid header. Only works on platforms which
        // support suppression of scrollbars through CSS.
        if (overflowY === 'hidden-scroll' && !translate) {
          element.classList.add('b-hide-scroll'); // Adds a wheel listener if needed - there is scrollbar width
          // and we don't already have one.

          this.enableWheel();
        }

        if (!translate) {
          element.style.overflowY = scrollLiterals[overflowY] || overflowY;
        }
      }

      this.positionDirty = !this.isConfiguring;
    }
  }, {
    key: "enableWheel",
    value: function enableWheel() {
      if (!_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isChrome && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isSafari && !this.wheelListenerRemover) {
        this.wheelListenerRemover = _EventHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].on({
          element: this.element,
          wheel: 'onWheel',
          thisObj: this
        });
      }
    }
  }, {
    key: "onWheel",
    value: function onWheel(e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && this.overflowX !== false) {
        this.x += e.deltaX; // The gesture must not also scroll any scrollable ancestor

        e.stopPropagation();
      } else if (this.overflowY !== false) {
        this.y += e.deltaY; // The gesture must not also scroll any scrollable ancestor

        e.stopPropagation();
      }
    }
    /**
     * The horizontal scroll range of the widget.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "viewport",
    get: function get() {
      return _Rectangle_js__WEBPACK_IMPORTED_MODULE_18__["default"].client(this.element);
    }
  }, {
    key: "x",
    get: function get() {
      var me = this,
          element = me.element;

      if (element && me.positionDirty) {
        if (me.translate) {
          var _DomHelper$getTransla5 = _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].getTranslateXY(element),
              _DomHelper$getTransla6 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8___default()(_DomHelper$getTransla5, 2),
              x = _DomHelper$getTransla6[0],
              y = _DomHelper$getTransla6[1];

          me._x = -x;
          me._y = -y;
        } else {
          me._x = element.scrollLeft;
          me._y = element.scrollTop;
        }

        me.positionDirty = false;
      }

      return me._x;
    }
  }, {
    key: "y",
    get: function get() {
      var me = this,
          element = me.element;

      if (element && me.positionDirty) {
        if (me.translate) {
          var _DomHelper$getTransla7 = _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].getTranslateXY(element),
              _DomHelper$getTransla8 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8___default()(_DomHelper$getTransla7, 2),
              x = _DomHelper$getTransla8[0],
              y = _DomHelper$getTransla8[1];

          me._x = -x;
          me._y = -y;
        } else {
          me._x = element.scrollLeft;
          me._y = element.scrollTop;
        }

        me.positionDirty = false;
      }

      return me._y;
    }
  }, {
    key: "maxX",
    get: function get() {
      return this.scrollWidth - this.clientWidth;
    }
    /**
     * The maximum `Y` scrollable position of the widget.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "maxY",
    get: function get() {
      return this.scrollHeight - this.clientHeight;
    }
  }, {
    key: "scrollWidth",
    get: function get() {
      return this.element ? this.element.scrollWidth : 0;
    },
    set: function set(scrollWidth) {
      var me = this;
      var stretcher = me.widthStretcher; // "Unsetting" scrollWidth removes the stretcher

      if (stretcher && scrollWidth == null) {
        stretcher.remove();
        me.widthStretcher = null;
      } else if (scrollWidth) {
        if (!stretcher) {
          stretcher = me.widthStretcher = _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].createElement({
            className: 'b-scroller-stretcher'
          });
        }

        stretcher.style.transform = "translateX(".concat(scrollWidth - 1, "px)");

        if (me.element && me.element.lastChild !== stretcher) {
          me.element.appendChild(stretcher);
        }
      }

      me.syncOverflowState();
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      return this.element ? this.element.scrollHeight : 0;
    }
    /**
     * The vertical scroll range of the widget. May be set to larger than the actual data
     * height to enable virtual scrolling. This is how the grid extends its scroll range
     * while only rendering a small subset of the dataset.
     * @property {Number}
     */
    ,
    set: function set(scrollHeight) {
      var me = this,
          stretcher = me.stretcher || (me.stretcher = _DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].createElement({
        className: 'b-scroller-stretcher'
      }));
      stretcher.style.transform = "translateY(".concat(scrollHeight - 1, "px)");

      if (me.element && me.element.lastChild !== stretcher) {
        me.element.appendChild(stretcher);
      }
    }
    /**
     * The client width of the widget.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "clientWidth",
    get: function get() {
      return this.element ? this.element.clientWidth : 0;
    }
    /**
     * The client height of the widget.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "clientHeight",
    get: function get() {
      return this.element ? this.element.clientHeight : 0;
    }
    /**
     * The unique ID of this Scroller
     * @property {String}
     * @readonly
     */

  }, {
    key: "id",
    get: function get() {
      if (!this._id) {
        if (this.widget) {
          this._id = "".concat(this.widget.id, "-scroller");
        } else {
          this._id = _IdHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].generateId('scroller-');
        }
      }

      return this._id;
    }
  }], [{
    key: "configurable",
    get: function get() {
      return {
        /**
         * The widget which is to scroll.
         * @config {HTMLElement}
         */
        widget: null,

        /**
         * The element which is to scroll. Defaults to the
         * {@link Core.widget.Widget#property-overflowElement} of the configured
         * {@link #config-widget}
         * @config {HTMLElement}
         */
        element: null,

        /**
         * How to handle overflowing in the `X` axis.
         * May be:
         * * `'auto'`
         * * `'visible'`
         * * `'hidden'`
         * * `'scroll'`
         * * `'hidden-scroll'` Meaning scrollable from the UI but with no scrollbar,
         * for example a grid header. Only on platforms which support this feature.
         * * `true` - meaning `'auto'`
         * * `false` - meaning `'hidden'`
         * @config {String|Boolean}
         */
        overflowX: null,

        /**
         * How to handle overflowing in the `Y` axis.
         * May be:
         * * `'auto'`
         * * `'visible'`
         * * `'hidden'`
         * * `'scroll'`
         * * `'hidden-scroll'` Meaning scrollable from the UI but with no scrollbar.
         * Only on platforms which support this feature.
         * * `true` - meaning `'auto'`
         * * `false` - meaning `'hidden'`
         * @config {String|Boolean}
         */
        overflowY: null,

        /**
         * If configured as `true`, the {@link #config-element} is not scrolled
         * but is translated using CSS transform when controlled by this class's API.
         * Scroll events are fired when the element is translated.
         * @default
         * @config {Boolean}
         */
        translate: null,
        x: 0,
        y: 0,
        scrollEndBuffer: 100
      };
    }
  }]);

  return Scroller;
}(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_19__["default"])(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_20__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_17__["default"])));


Scroller._$name = 'Scroller';

/***/ }),

/***/ "./lib/Core/localization/En.js":
/*!*************************************!*\
  !*** ./lib/Core/localization/En.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");

var productName = 'scheduler';
 //<umd>

var localeName = 'En',
    localeDesc = 'English',
    locale = {
  localeName: localeName,
  localeDesc: localeDesc,
  // Translations for common words and phrases which are used by all classes.
  Object: {
    Yes: 'Yes',
    No: 'No',
    Cancel: 'Cancel'
  },
  //region Widgets
  Combo: {
    noResults: 'No results'
  },
  FilePicker: {
    file: 'File'
  },
  Field: {
    // native input ValidityState statuses
    badInput: 'Invalid field value',
    patternMismatch: 'Value should match a specific pattern',
    rangeOverflow: function rangeOverflow(value) {
      return "Value must be less than or equal to ".concat(value.max);
    },
    rangeUnderflow: function rangeUnderflow(value) {
      return "Value must be greater than or equal to ".concat(value.min);
    },
    stepMismatch: 'Value should fit the step',
    tooLong: 'Value should be shorter',
    tooShort: 'Value should be longer',
    typeMismatch: 'Value is required to be in a special format',
    valueMissing: 'This field is required',
    invalidValue: 'Invalid field value',
    minimumValueViolation: 'Minimum value violation',
    maximumValueViolation: 'Maximum value violation',
    fieldRequired: 'This field is required',
    validateFilter: 'Value must be selected from the list'
  },
  DateField: {
    invalidDate: 'Invalid date input'
  },
  NumberFormat: {
    locale: 'en-US',
    currency: 'USD'
  },
  TimeField: {
    invalidTime: 'Invalid time input'
  },
  List: {
    loading: 'Loading...'
  },
  PagingToolbar: {
    firstPage: 'Go to first page',
    prevPage: 'Go to previous page',
    page: 'Page',
    nextPage: 'Go to next page',
    lastPage: 'Go to last page',
    reload: 'Reload current page',
    noRecords: 'No records to display',
    pageCountTemplate: function pageCountTemplate(data) {
      return "of ".concat(data.lastPage);
    },
    summaryTemplate: function summaryTemplate(data) {
      return "Displaying records ".concat(data.start, " - ").concat(data.end, " of ").concat(data.allCount);
    }
  },
  //endregion
  //region Others
  DateHelper: {
    locale: 'en-US',
    weekStartDay: 0,
    unitNames: [{
      single: 'millisecond',
      plural: 'ms',
      abbrev: 'ms'
    }, {
      single: 'second',
      plural: 'seconds',
      abbrev: 's'
    }, {
      single: 'minute',
      plural: 'minutes',
      abbrev: 'min'
    }, {
      single: 'hour',
      plural: 'hours',
      abbrev: 'h'
    }, {
      single: 'day',
      plural: 'days',
      abbrev: 'd'
    }, {
      single: 'week',
      plural: 'weeks',
      abbrev: 'w'
    }, {
      single: 'month',
      plural: 'months',
      abbrev: 'mon'
    }, {
      single: 'quarter',
      plural: 'quarters',
      abbrev: 'q'
    }, {
      single: 'year',
      plural: 'years',
      abbrev: 'yr'
    }],
    // Used to build a RegExp for parsing time units.
    // The full names from above are added into the generated Regexp.
    // So you may type "2 w" or "2 wk" or "2 week" or "2 weeks" into a DurationField.
    // When generating its display value though, it uses the full localized names above.
    unitAbbreviations: [['mil'], ['s', 'sec'], ['m', 'min'], ['h', 'hr'], ['d'], ['w', 'wk'], ['mo', 'mon', 'mnt'], ['q', 'quar', 'qrt'], ['y', 'yr']],
    parsers: {
      L: 'MM/DD/YYYY',
      LT: 'HH:mm A'
    },
    ordinalSuffix: function ordinalSuffix(number) {
      return number + ({
        1: 'st',
        2: 'nd',
        3: 'rd'
      }[number[number.length - 1]] || 'th');
    }
  } //endregion

};
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerLocale(localeName, {
  desc: localeDesc,
  locale: locale
});

/***/ }),

/***/ "./lib/Core/localization/LocaleHelper.js":
/*!***********************************************!*\
  !*** ./lib/Core/localization/LocaleHelper.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LocaleHelper; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);













function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var productName = 'scheduler';
/**
* @module Core/localization/LocaleHelper
*/

/**
 * Provides locale management methods.
 */

var LocaleHelper = /*#__PURE__*/function () {
  function LocaleHelper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, LocaleHelper);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(LocaleHelper, null, [{
    key: "mergeLocales",

    /**
     * Merges all properties of provided locales into new locale.
     * Locales are merged in order they provided and locales wich go later replace same properties of previous locales.
     * @param {...Object} locales Locales to merge
     * @return {Object} Merged locale
     */
    value: function mergeLocales() {
      var result = {};

      for (var _len = arguments.length, locales = new Array(_len), _key = 0; _key < _len; _key++) {
        locales[_key] = arguments[_key];
      }

      locales.forEach(function (locale) {
        Object.keys(locale).forEach(function (key) {
          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9___default()(locale[key]) === 'object') {
            result[key] = _objectSpread(_objectSpread({}, result[key]), locale[key]);
          } else {
            result[key] = locale[key];
          }
        });
      });
      return result;
    }
    /**
     * Removes all properties from `locale` that are present in the provided `trimLocale`.
     * @param {Object} locale locales to merge
     * @param {Object} trimLocale locales to merge
     */

  }, {
    key: "trimLocale",
    value: function trimLocale(locale, _trimLocale) {
      var remove = function remove(key, subKey) {
        if (!locale[key]) {
          throw new Error("Key \"".concat(key, "\" doesn't exist in locale"));
        }

        if (subKey) {
          if (!locale[key][subKey]) {
            throw new Error("SubKey \"".concat(key, ".").concat(subKey, "\" doesn't exist in locale"));
          }

          delete locale[key][subKey];
        } else {
          delete locale[key];
        }
      };

      Object.keys(_trimLocale).forEach(function (key) {
        if (Array.isArray(_trimLocale[key])) {
          _trimLocale[key].forEach(function (subKey) {
            return remove(key, subKey);
          });
        } else {
          remove(key);
        }
      });
    }
    /**
     * Put the locale under `window.bryntum.locales` to make sure it can be discovered automatically
     * @param {String} localeName Locale name
     * @param {Object} config Locale config
     */

  }, {
    key: "publishLocale",
    value: function publishLocale(localeName, config) {
      var bryntum = window.bryntum = window.bryntum || {},
          locales = bryntum.locales = bryntum.locales || {}; // Avoid registering locales twice

      locales[localeName] = !locales[localeName] ? config : this.mergeLocales(locales[localeName], config);
    }
  }]);

  return LocaleHelper;
}();


LocaleHelper._$name = 'LocaleHelper';

/***/ }),

/***/ "./lib/Core/localization/LocaleManager.js":
/*!************************************************!*\
  !*** ./lib/Core/localization/LocaleManager.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





 // No module tag here. That stops the singleton from being included by the docs.

/**
 * Singleton that handles switching locale. Locales can be included on page with `<script type="module">` tags or
 * loaded using ajax. When using script tags the first locale loaded is used per default, if another should be used as
 * default specify it on the script tag for the grid (see example below).
 *
 * ```
 * // Using Ecma 6 modules
 * &lt;script type="module" src="./Core/localization/SvSE.js"&gt;
 *
 * // Specify default when using scripts
 * &lt;script src="build/locales/grid.locale.SvSE.js"&gt;
 * &lt;script data-default-locale="En" src="build/grid-all.js"&gt;
 *
 * import LocaleManager from 'Core/localization/LocaleManager.js';
 * // Set locale using method
 * LocaleManager.applyLocale('SvSE');
 * // Or set locale using property
 * LocaleManager.locale = LocaleManager.locales.SvSE;
 * ```
 *
 * @demo Grid/localization
 * @singleton
 */

var LocaleManager = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(LocaleManager, _Events);

  var _super = _createSuper(LocaleManager);

  function LocaleManager() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, LocaleManager);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(LocaleManager, [{
    key: "construct",
    value: function construct() {
      var _get2;

      var me = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(LocaleManager.prototype), "construct", this)).call.apply(_get2, [this].concat(args));

      var scriptTag = document.querySelector('script[data-default-locale]');

      if (scriptTag) {
        me.defaultLocaleName = scriptTag.dataset.defaultLocale;
      }

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].isBrowserEnv && window.bryntum && window.bryntum.locales) {
        Object.keys(window.bryntum.locales).forEach(function (localeName) {
          // keeping this check in case some client tries to use an old locale
          if (!localeName.startsWith('moment')) {
            var locale = window.bryntum.locales[localeName];

            if (locale.extends) {
              me.extendLocale(locale.extends, locale);
            } else if (locale.localeName) {
              me.registerLocale(locale.localeName, {
                desc: locale.localeDesc,
                locale: locale
              });
            }
          }
        });

        if (!me.locale) {
          // English locale is built in, no need to apply it here since it will be applied anyway
          if (me.defaultLocaleName !== 'En') {
            // No locale applied, use default or first found
            me.applyLocale(me.defaultLocaleName || Object.keys(me.locales)[0]);
          }
        }
      }
    }
  }, {
    key: "registerLocale",

    /**
     * Register a locale to make it available for applying.
     * Registered locales are available in {@link Core.localization.LocaleManager#property-locales-static}.
     * @param {String} name Name of locale (for example `En` or `SvSE`)
     * @param {Object} config Object with localized properties
     */
    value: function registerLocale(name, config) {
      var me = this,
          isDefault = me.defaultLocaleName === name,
          isCurrent = me.locale && me.locale.localeName === name,
          isFirst = Object.keys(me.locales).length === 0; // Avoid registering the same locale twice and merge configs

      if (!me.locales[name]) {
        me.locales[name] = config;
      } else {
        me.locales[name].locale = _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].mergeLocales(me.locales[name].locale, config.locale);
      } // if no default locale specified, use the first one. otherwise apply the default when it is registered
      // also reapply if current locale is registered again (first grid, then scheduler etc).


      if (isDefault || !me.defaultLocaleName && (isFirst || isCurrent)) {
        me.internalApplyLocale(me.locales[name]);
      }
    }
    /**
     * Extend an already loaded locale to add additional translations.
     * @param {String} name Name of locale (for example `En` or `SvSE`)
     * @param {Object} config Object with localized properties
     */

  }, {
    key: "extendLocale",
    value: function extendLocale(name, config) {
      var _this$locale;

      var locale = this.locales[name];

      if (!locale) {
        return false;
      }

      locale.locale = _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].mergeLocales(locale.locale, config);
      delete locale.locale.extends; // If current loaded locale is the same then apply to reflect changes

      if (((_this$locale = this.locale) === null || _this$locale === void 0 ? void 0 : _this$locale.localeName) === name) {
        this.applyLocale(name);
      }

      return true;
    }
  }, {
    key: "internalApplyLocale",
    value: function internalApplyLocale(localeConfig) {
      this._locale = localeConfig.locale;
      this.trigger('locale', localeConfig);
    }
    /**
     * Apply a locale. Locale must be defined in {@link Core.localization.LocaleManager#property-locales-static}.
     * If it is not loaded it will be loaded using AjaxHelper {@link Core.helper.AjaxHelper#function-get-static} request and then applied.
     * @param {String} name Name of locale to apply (for example `En` or `SvSE`)
     * @returns {boolean|Promise}
     */

  }, {
    key: "applyLocale",
    value: function applyLocale(name) {
      var forceApply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var ignoreError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          localeConfig = me.locales[name];

      if (localeConfig && localeConfig.locale && me._locale === localeConfig.locale && !forceApply) {
        // no need to apply same locale again
        return true;
      } // ignoreError is used in examples where one example might have defined a locale not available in another


      if (!localeConfig) {
        if (ignoreError) return true;
        throw new Error("Locale ".concat(name, " not registered"));
      }

      function internalApply() {
        me.internalApplyLocale(localeConfig);
      }

      if (!localeConfig.locale) {
        return new Promise(function (resolve, reject) {
          me.loadLocale(localeConfig.path).then(function (response) {
            response.text().then(function (text) {
              var // eslint-disable-next-line no-new-func
              parseLocale = new Function(text);
              parseLocale();

              if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].isBrowserEnv) {
                localeConfig.locale = window.bryntum.locales[name];
              }

              internalApply();
              resolve(localeConfig);
            });
          }).catch(function (response) {
            return reject(response);
          });
        });
      }

      internalApply();
      return true;
    }
    /**
     * Loads a locale using AjaxHelper {@link Core.helper.AjaxHelper#function-get-static} request.
     * @private
     * @param {String} path Path to locale file
     * @returns {Promise}
     */

  }, {
    key: "loadLocale",
    value: function loadLocale(path) {
      return _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].get(path);
    }
    /**
     * Specifies if {@link Core.localization.Localizable#function-L-static Localizable.L()} function would throw error if no localization found in runtime
     * @property {Boolean}
     * @default false
     */

  }, {
    key: "locales",
    set: function set(localeConfigs) {
      this._locales = localeConfigs;
    }
    /**
     * Get currently registered locales.
     * Returns an object with locale names (`localeName`) as properties.
     *
     * Example:
     * ```
     * const englishLocale = LocaleManager.locales.En;
     * ```
     *
     * this returns registered English locale object.
     * ```
     * {
     *   "desc": "English",
     *   "locale": {
     *     "localeName": "En",
     *     "localeDesc": "English",
     *
     *     ... (localization goes here)
     *
     *   }
     * }
     * ```
     * @readonly
     * @property {Object}
     */
    ,
    get: function get() {
      return this._locales;
    }
    /**
     * Get/set currently used locale. Set a name of a locale to have it applied, or give a locale configuration to
     * have it registered and then applied
     * @property {String|Object}
     */

  }, {
    key: "locale",
    set: function set(locale) {
      if (typeof locale === 'string') {
        this.applyLocale(locale);
      } else {
        if (!locale.locale) {
          locale = {
            locale: locale,
            localeName: locale.localeName || 'custom'
          };
        }

        this.registerLocale(locale.localeName, locale);
        this.applyLocale(locale.localeName);
      }
    },
    get: function get() {
      return this._locale;
    }
  }, {
    key: "throwOnMissingLocale",
    set: function set(value) {
      this._throwOnMissingLocale = value;
    },
    get: function get() {
      return this._throwOnMissingLocale;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        locales: {},
        // Enable strict locale checking by default for tests
        throwOnMissingLocale: _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].isTestEnv
      };
    }
  }]);

  return LocaleManager;
}(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_15__["default"]));

var LocaleManagerSingleton = new LocaleManager();
/* harmony default export */ __webpack_exports__["default"] = (LocaleManagerSingleton);

/***/ }),

/***/ "./lib/Core/localization/Localizable.js":
/*!**********************************************!*\
  !*** ./lib/Core/localization/Localizable.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");

































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/localization/Localizable
 */

var ObjectProto = Object.getPrototypeOf(Object),
    localeRe = /L{.*?}/g,
    escape = function escape(txt) {
  return txt.replace(/{(\d+)}/gm, '[[$1]]');
},
    unescape = function unescape(txt) {
  return txt.replace(/\[\[(\d+)]]/gm, '{$1}');
};
/**
 * Mixin that provides localization functionality to a class.
 *
 * ```
 * // Get localized string
 * grid.L('foo');
 * grid.L('L{foo});
 * ```
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29___default()(Localizable, _ref);

    var _super = _createSuper(Localizable);

    function Localizable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, Localizable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27___default()(Localizable, [{
      key: "construct",
      value: function construct() {
        var _get2;

        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // Base class applies configs.
        (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default()(Localizable.prototype), "construct", this)).call.apply(_get2, [this, config].concat(args));

        _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].on('locale', this.updateLocalization, this);
        this.updateLocalization();
      }
    }, {
      key: "localizeProperty",
      value: function localizeProperty(property) {
        var _me$$meta$configs$pro;

        var me = this,
            currentValue = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_34__["default"].getPath(me, property),
            localeKey = (_me$$meta$configs$pro = me.$meta.configs[property]) === null || _me$$meta$configs$pro === void 0 ? void 0 : _me$$meta$configs$pro.localeKey; // check if localeKey is defined and try to translate it

        if (localeKey) {
          var localizedValue = Localizable.localize(localeKey, null, me.localeClass || me); // if a user set value directly in class definition, his value has a prio

          if (localizedValue && !(property in me.initialConfig)) {
            _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_34__["default"].setPath(me, property, localizedValue);
          }
        } else if (typeof currentValue === 'string') {
          me.originalLocales = me.originalLocales || {};
          var propertyValue = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_34__["default"].getPath(me.originalLocales, property); // If we haven't saved original values yet let's do that

          if (propertyValue === undefined) {
            _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_34__["default"].setPath(me.originalLocales, property, currentValue);
            propertyValue = currentValue;
          } // Doing localization from the original values


          if (propertyValue) {
            _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_34__["default"].setPath(me, property, me.optionalL(propertyValue));
          }
        }
      }
      /**
       * Method that is triggered when applying a locale to the instance
       * (happens on the instance construction steps and when switching to another locale).
       *
       * The method can be overridden to dynamically translate the instance when locale is switched.
       * When overriding the method please make sure you call `super.updateLocalization()`.
       */

    }, {
      key: "updateLocalization",
      value: function updateLocalization() {
        var _this$localizableProp;

        (_this$localizableProp = this.localizableProperties) === null || _this$localizableProp === void 0 ? void 0 : _this$localizableProp.forEach(this.localizeProperty, this);
      }
    }, {
      key: "L",

      /**
       * Convenience function that can be called directly on the class that mixes Localizable in
       *
       * ```javascript
       * button.text = grid.L('L{group}');
       * ```
       *
       * @param {String} text String key
       * @param {Object} [templateData] Data to supply to template if localized string is a function
       * @returns {String}
       * @category Misc
       */
      value: function L(text, templateData) {
        var localeClass = this.localeClass,
            constructor = this.constructor; // If we have a different class set as translations provider
        // pass it first and use the class being translated as a fallback provider

        if (localeClass && Localizable.clsName(localeClass) !== Localizable.clsName(constructor)) {
          return Localizable.L(text, templateData, localeClass, constructor);
        } else {
          return Localizable.L(text, templateData, constructor);
        }
      }
      /**
       * Convenience function to get an optional translation. The difference compared to `L()` is that it wont throw
       * an error when the translation is missing even if configured with `throwOnMissingLocale`
       *
       * ```javascript
       * button.text = grid.optionalL('L{group}');
       * ```
       *
       * @param {String} text String key
       * @param {Object} [templateData] Data to supply to template if localized string is a function
       * @returns {String}
       * @static
       * @category Misc
       */

    }, {
      key: "optionalL",

      /**
       * Convenience function to get an optional translation. The difference compared to `L()` is that it wont throw
       * an error when the translation is missing even if configured with `throwOnMissingLocale`
       *
       * ```javascript
       * button.text = grid.optionalL('L{group}');
       * ```
       *
       * @param {String} text String key
       * @param {Object} [templateData] Data to supply to template if localized string is a function
       * @returns {String}
       * @category Misc
       * @internal
       */
      value: function optionalL(text, templateData) {
        var shouldThrow = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].throwOnMissingLocale;
        _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].throwOnMissingLocale = shouldThrow && localeRe.test(text);
        var result = this.L(text, templateData);
        _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].throwOnMissingLocale = shouldThrow;
        return result;
      }
      /**
       * Get the global LocaleManager
       * @returns {Core.localization.LocaleManager}
       * @category Misc
       */

    }, {
      key: "localeClass",
      get: function get() {
        return this._localeClass || null;
      }
    }, {
      key: "localeManager",
      get: function get() {
        return _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"];
      }
    }], [{
      key: "clsName",
      value: function clsName(cls) {
        var _cls$prototype, _cls$prototype2;

        return typeof cls === 'string' ? cls : cls === ObjectProto ? 'Object' : cls.$$name || cls.name || ((_cls$prototype = cls.prototype) === null || _cls$prototype === void 0 ? void 0 : _cls$prototype.$$name) || ((_cls$prototype2 = cls.prototype) === null || _cls$prototype2 === void 0 ? void 0 : _cls$prototype2.name);
      }
    }, {
      key: "parseLocaleString",
      value: function parseLocaleString(text) {
        var _text;

        var matches = [];
        var m; // Parse locale text in case it's wrapped with L{foo}

        if ((_text = text) === null || _text === void 0 ? void 0 : _text.includes('L{')) {
          var re = /L{(.*?)}/g; // Escape fix for {1}, {2} etc. in locale str

          text = escape(text);

          while ((m = re.exec(text)) != null) {
            // Support for parsing class namespace L{Class.foo}
            var classMatch = /((.*?)\.)?(.+)/g.exec(m[1]);
            matches.push({
              match: unescape(m[0]),
              localeKey: unescape(classMatch[3]),
              localeClass: classMatch[2]
            });
          }
        }

        return matches.length > 0 ? matches : [{
          match: text,
          localeKey: text,
          localeClass: undefined
        }];
      }
    }, {
      key: "getTranslation",
      value: function getTranslation(text, templateData, localeCls) {
        var locale = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].locale;
        var result = null,
            clsName,
            cls;

        if (locale) {
          // Iterate over all found localization entries
          var _iterator = _createForOfIteratorHelper(this.parseLocaleString(text)),
              _step;

          try {
            var _loop = function _loop() {
              var _step$value = _step.value,
                  match = _step$value.match,
                  localeKey = _step$value.localeKey,
                  localeClass = _step$value.localeClass;

              var translate = function translate(clsName) {
                var _locale$clsName;

                var translation = (_locale$clsName = locale[clsName]) === null || _locale$clsName === void 0 ? void 0 : _locale$clsName[localeKey];

                if (translation) {
                  if (typeof translation === 'function') {
                    result = templateData != null ? translation(templateData) : translation;
                  } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_25___default()(translation) === 'object' || text === match) {
                    result = translation;
                  } else {
                    result = (result || text).replace(match, translation);
                  }
                }

                return translation;
              }; // Translate order
              // 1. Try to translate for current class
              // 2. Try to translate by Class hierarchy traversing prototypes
              // 3. Try to translate if Class is in {Class.foo} format


              var success = false;

              for (cls = localeCls; cls && (clsName = Localizable.clsName(cls)); cls = Object.getPrototypeOf(cls)) {
                if (success = translate(clsName)) {
                  break;
                } else if (typeof cls === 'string') {
                  break;
                }
              }

              if (!success && localeClass) {
                translate(localeClass);
              }
            };

            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        return result;
      }
      /**
       * Get localized string, returns `null` if no localized string found.
       * @param {String} text String key
       * @param {Object} [templateData] Data to supply to template if localized string is a function
       * @returns {String}
       * @internal
       */

    }, {
      key: "localize",
      value: function localize(text) {
        var _localeClasses;

        var templateData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

        for (var _len2 = arguments.length, localeClasses = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          localeClasses[_key2 - 2] = arguments[_key2];
        }

        // In case this static method is called directly third argument is not provided
        // just fallback to searching locales for the class itself
        if (((_localeClasses = localeClasses) === null || _localeClasses === void 0 ? void 0 : _localeClasses.length) === 0) {
          localeClasses = [this];
        }

        var translation = null;
        localeClasses.some(function (cls) {
          translation = Localizable.getTranslation(text, templateData, cls);
          return translation != null;
        });
        return translation;
      }
      /**
       * Get localized string, returns value of `text` if no localized string found.
       *
       * If {@link Core.localization.LocaleManager#property-throwOnMissingLocale-static LocaleManager.throwOnMissingLocale}
       * is `true` then calls to `L()` will throw `Localization is not found for 'text' in 'ClassName'` exception when no
       * localization is found.
       *
       * @param {String} text String key
       * @param {Object} [templateData] Data to supply to template if localized string is a function
       * @static
       * @returns {String}
       */

    }, {
      key: "L",
      value: function L(text) {
        var _localeClasses2;

        var templateData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

        for (var _len3 = arguments.length, localeClasses = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          localeClasses[_key3 - 2] = arguments[_key3];
        }

        // In case this static method is called directly third argument is not provided
        // just fallback to searching locales for the class itself
        if (((_localeClasses2 = localeClasses) === null || _localeClasses2 === void 0 ? void 0 : _localeClasses2.length) === 0) {
          localeClasses = [this];
        }

        var translation = this.localize.apply(this, [text, templateData].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24___default()(localeClasses))); // Throw error if not localized anв text matches `L{foo}`

        if (_LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].throwOnMissingLocale && _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].locale && translation == null) {
          throw new Error("Localization is not found for '".concat(text, "' in '").concat(localeClasses.map(function (cls) {
            return Localizable.clsName(cls);
          }).join(', '), "'. ").concat(_LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].locale.localeName ? "Locale : ".concat(_LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].locale.localeName) : ''));
        }

        return translation !== null && translation !== void 0 ? translation : text;
      }
    }, {
      key: "optionalL",
      value: function optionalL(text) {
        var _localeClasses3;

        var templateData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

        for (var _len4 = arguments.length, localeClasses = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
          localeClasses[_key4 - 2] = arguments[_key4];
        }

        var shouldThrow = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].throwOnMissingLocale;
        _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].throwOnMissingLocale = shouldThrow && localeRe.test(text); // In case this static method is called directly third argument is not provided
        // just fallback to searching locales for the class itself

        if (((_localeClasses3 = localeClasses) === null || _localeClasses3 === void 0 ? void 0 : _localeClasses3.length) === 0) {
          localeClasses = [this];
        }

        var result = Localizable.L.apply(Localizable, [text, templateData].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24___default()(localeClasses)));
        _LocaleManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].throwOnMissingLocale = shouldThrow;
        return result;
      }
    }, {
      key: "$name",
      get: function get() {
        return 'Localizable';
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * A class translations of which are used for translating this entity.
           * This is often used when translations of an item are defined on its container class.
           * For example:
           *
           * ```js
           * // Toolbar class that has some predefined items
           * class MyToolbar extends Toolbar {
           *
           *     static get $name() {
           *         return 'MyToolbar';
           *     }
           *
           *     static get defaultConfig() {
           *         return {
           *             // this specifies default configs for the items
           *             defaults : {
           *                 // will tell items to use the toolbar locale
           *                 localeClass : this
           *             },
           *
           *             items : [
           *                 // The toolbar has 2 buttons and translation for their texts will be searched in
           *                 // the toolbar locales
           *                 { text : 'Agree' },
           *                 { text : 'Disagree' }
           *             ]
           *         };
           *     }
           *
           *    ...
           * }
           * ```
           * So if one makes a locale for the `MyToolbar` class that will include `Agree` and `Disagree` string translations:
           * ```js
           *     ...
           *     MyToolbar : {
           *         Agree    : 'Yes, I agree',
           *         Disagree : 'No, I do not agree'
           *     }
           * ```
           * They will be used for the toolbar buttons and the button captions will say `Yes, I agree` and `No, I do not agree`.
           *
           * @config {Class}
           */
          localeClass: null,

          /**
           * List of properties which values should be translated automatically upon a locale applying.
           * In case there is a need to localize not typical value (not a String value or a field with re-defined setter/getter),
           * you could use 'localeKey' meta configuration.
           * Example:
           * ```js
           *  static get configurable() {
           *     return {
           *          localizableProperties : ['width'],
           *
           *          width : {
           *              value   : '54em', // default value here
           *              $config : {
           *                  localeKey : 'L{editorWidth}' // name of the property that will be used in localization file
           *              }
           *          }
           *      };
           *  }
           * ```
           * @config {String[]}
           */
          localizableProperties: {
            value: [],
            $config: {
              merge: 'distinct'
            }
          }
        };
      }
    }]);

    return Localizable;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_32__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/Delayable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Delayable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
























































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_53___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_53___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_52___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var defineProperty = Reflect.defineProperty;
/**
 * @module Core/mixin/Delayable
 */
// Global timeout collections for tests

var globalDelays = null;

if (_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_56__["default"].isTestEnv) {
  var bryntum = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].global.bryntum || (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].global.bryntum = {});
  globalDelays = bryntum.globalDelays = {
    timeouts: new Map(),
    intervals: new Map(),
    animationFrames: new Map(),
    isEmpty: function isEmpty() {
      var includeIntervals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return globalDelays.timeouts.size + globalDelays.animationFrames.size + (includeIntervals ? globalDelays.intervals.size : 0) === 0;
    }
  };
}

var
/**
 * Creates and returns a function that will call the user-supplied `fn`.
 *
 * @param {Core.mixin.Delayable} me
 * @param {Function} fn The user function to call when the timer fires.
 * @param {Function} wrapFn The function the user will call to start the timer.
 * @param {Object} options The invoke options.
 * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
 * @param {Object} [options.thisObj] The `this` reference for `fn`.
 * @returns {Function}
 * @private
 */
makeInvoker = function makeInvoker(me, fn, wrapFn, options) {
  var named = typeof fn === 'string',
      appendArgs = options && options.appendArgs || [],
      // The invoker fn is intended to be wired directly to native setTimeout/requestAnimationFrame/etc and so
  // it does not receive any arguments worth passing on to the user's fn. Those come from the original call
  // to the wrapFn.
  invoker = function invoker() {
    wrapFn.timerId = null;
    wrapFn.lastCallTime = performance.now(); // Grab args now and null the stored args out (to avoid leaks):

    var args = wrapFn.args;
    wrapFn.args = null;

    if (named) {
      var _me;

      (_me = me)[fn].apply(_me, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_54___default()(args).concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_54___default()(appendArgs)));
    } else {
      fn.call.apply(fn, [me].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_54___default()(args), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_54___default()(appendArgs)));
    }

    wrapFn.called = true;
    ++wrapFn.calls;
  };

  if (options) {
    me = options.thisObj || me;
  } // We put most everything as properties on the wrapFn so that it can all be inspected in the debugger (unlike
  // closure variables) and expected in tests.


  wrapFn.lastCallTime = -9e9; // performance.now() = 0 at start...

  wrapFn.calls = 0;
  wrapFn.invoker = invoker;
  invoker.wrapFn = wrapFn;
  return invoker;
},

/**
 * Decorates the supported `wrapFn` with additional methods and an `isPending` readonly
 * property. These decorations are available to user code to help manage the scheduling
 * behavior of the buffered function.
 *
 * @param {Core.mixin.Delayable} me
 * @param {Function} wrapFn The function the user will call to start the timer.
 * @param {String} cancelFn The name of the function that will cancel a timer.
 * @returns {Function} The `wrapFn` is returned.
 * @private
 */
decorateWrapFn = function decorateWrapFn(me, wrapFn) {
  var cancelFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'clearTimeout';

  wrapFn.cancel = function () {
    if (wrapFn.isPending) {
      me[cancelFn](wrapFn.timerId); // avoid leaks and cleanup:

      wrapFn.args = wrapFn.timerId = null;
    }
  };

  wrapFn.flush = function () {
    if (wrapFn.isPending) {
      me[cancelFn](wrapFn.timerId);
      wrapFn.timerId = null; // we don't call cancel() since it also sets args=null

      wrapFn.invoker();
    }
  };

  wrapFn.now = function () {
    wrapFn.cancel();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    wrapFn.args = args;
    wrapFn.invoker();
  };

  wrapFn.immediate = false;
  wrapFn.timerId = null;
  defineProperty(wrapFn, 'isPending', {
    get: function get() {
      return wrapFn.timerId !== null;
    }
  });
  return wrapFn;
};
/**
 * Tracks setTimeout, setInterval and requestAnimationFrame calls and clears them on destroy.
 *
 * @example
 * someClass.setTimeout(() => console.log('hi'), 200);
 * someClass.setInterval(() => console.log('annoy'), 100);
 * // can also use named timeouts for easier tracking
 * someClass.setTimeout(() => console.log('named'), 300, 'named');
 * someClass.clearTimeout('named');
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_51___default()(Delayable, _ref);

    var _super = _createSuper(Delayable);

    function Delayable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_48___default()(this, Delayable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_49___default()(Delayable, [{
      key: "doDestroy",
      value: function doDestroy() {
        var me = this;

        if (me.timeoutIds) {
          me.timeoutIds.forEach(function (fn, id) {
            if (typeof fn === 'function') {
              fn();
            }

            clearTimeout(id);

            if (globalDelays) {
              globalDelays.timeouts.delete(id);
            }
          });
          me.timeoutIds = null;
        }

        if (me.timeoutMap) {
          me.timeoutMap.forEach(function (name, id) {
            return clearTimeout(id);
          });
          me.timeoutMap = null;
        }

        if (me.intervalIds) {
          me.intervalIds.forEach(function (id) {
            clearInterval(id);

            if (globalDelays) {
              globalDelays.intervals.delete(id);
            }
          });
          me.intervalIds = null;
        }

        if (me.animationFrameIds) {
          me.animationFrameIds.forEach(function (id) {
            cancelAnimationFrame(id);

            if (globalDelays) {
              globalDelays.animationFrames.delete(id);
            }
          });
          me.animationFrameIds = null;
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_50___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_53___default()(Delayable.prototype), "doDestroy", this).call(this);
      }
      /**
       * Check if a named timeout is active
       * @param name
       * @internal
       */

    }, {
      key: "hasTimeout",
      value: function hasTimeout(name) {
        return !!(this.timeoutMap && this.timeoutMap.has(name));
      }
      /**
       * Same as native setTimeout, but will be cleared automatically on destroy. If a propertyName is supplied it will
       * be used to store the timeout id.
       * @param {Object} timeoutSpec An object containing the details about that function, and the time delay.
       * @param {Function|String} timeoutSpec.fn The function to call, or name of function in this object to call. Used as the `name` parameter if a string.
       * @param {Number} timeoutSpec.delay The milliseconds to delay the call by.
       * @param {Object[]} timeoutSpec.args The arguments to pass.
       * @param {String} [timeoutSpec.name] The name under which to register the timer. Defaults to `fn.name`.
       * @param {Boolean} [timeoutSpec.runOnDestroy] Pass `true` if this function should be executed if the Delayable instance is destroyed while function is scheduled.
       * @param {Boolean} [timeoutSpec.cancelOutstanding] Pass `true` to cancel any outstanding invocation of the passed function.
       * @returns {Number}
       * @internal
       */

    }, {
      key: "setTimeout",
      value: function (_setTimeout) {
        function setTimeout(_x) {
          return _setTimeout.apply(this, arguments);
        }

        setTimeout.toString = function () {
          return _setTimeout.toString();
        };

        return setTimeout;
      }(function (_ref2) {
        var fn = _ref2.fn,
            delay = _ref2.delay,
            name = _ref2.name,
            runOnDestroy = _ref2.runOnDestroy,
            cancelOutstanding = _ref2.cancelOutstanding,
            args = _ref2.args;

        if (arguments.length > 1 || typeof arguments[0] === 'function') {
          var _arguments = Array.prototype.slice.call(arguments);

          fn = _arguments[0];
          delay = _arguments[1];
          name = _arguments[2];
          runOnDestroy = _arguments[3];
        }

        if (typeof fn === 'string') {
          name = fn;
        } else if (!name) {
          name = fn.name;
        }

        if (cancelOutstanding) {
          this.clearTimeout(name);
        }

        var me = this,
            timeoutIds = me.timeoutIds || (me.timeoutIds = new Map()),
            timeoutMap = me.timeoutMap || (me.timeoutMap = new Map()),
            timeoutId = setTimeout(function () {
          if (typeof fn === 'string') {
            fn = me[name];
          } // Cleanup before invocation in case fn throws


          timeoutIds && timeoutIds.delete(timeoutId);
          timeoutMap && timeoutMap.delete(name);
          globalDelays && globalDelays.timeouts.delete(timeoutId);
          fn.apply(me, args);
        }, delay);
        timeoutIds.set(timeoutId, runOnDestroy ? fn : true);

        if (globalDelays) {
          globalDelays.timeouts.set(timeoutId, {
            fn: fn,
            delay: delay,
            name: name
          });
        }

        if (name) {
          timeoutMap.set(name, timeoutId);
        }

        return timeoutId;
      })
      /**
       * clearTimeout wrapper, either call with timeout id as normal clearTimeout or with timeout name (if you specified
       * a name to setTimeout())
       * property to null.
       * @param {Number|String} idOrName timeout id or name
       * @internal
       */

    }, {
      key: "clearTimeout",
      value: function (_clearTimeout) {
        function clearTimeout(_x2) {
          return _clearTimeout.apply(this, arguments);
        }

        clearTimeout.toString = function () {
          return _clearTimeout.toString();
        };

        return clearTimeout;
      }(function (idOrName) {
        var id = idOrName;

        if (typeof id === 'string') {
          if (this.timeoutMap) {
            id = this.timeoutMap.get(idOrName);
            this.timeoutMap.delete(idOrName);
          } else {
            return;
          }
        }

        clearTimeout(id);
        this.timeoutIds && this.timeoutIds.delete(id);
        globalDelays && globalDelays.timeouts.delete(id);
      })
      /**
       * clearInterval wrapper
       * @param {Number} id
       * @internal
       */

    }, {
      key: "clearInterval",
      value: function (_clearInterval) {
        function clearInterval(_x3) {
          return _clearInterval.apply(this, arguments);
        }

        clearInterval.toString = function () {
          return _clearInterval.toString();
        };

        return clearInterval;
      }(function (id) {
        clearInterval(id);
        this.intervalIds && this.intervalIds.delete(id);
        globalDelays && globalDelays.intervals.delete(id);
      })
      /**
       * Same as native setInterval, but will be cleared automatically on destroy
       * @param fn
       * @param delay
       * @returns {Number}
       * @internal
       */

    }, {
      key: "setInterval",
      value: function (_setInterval) {
        function setInterval(_x4, _x5) {
          return _setInterval.apply(this, arguments);
        }

        setInterval.toString = function () {
          return _setInterval.toString();
        };

        return setInterval;
      }(function (fn, delay) {
        var intervalId = setInterval(fn, delay);
        (this.intervalIds || (this.intervalIds = new Set())).add(intervalId);
        globalDelays && globalDelays.intervals.set(intervalId, {
          fn: fn,
          delay: delay
        });
        return intervalId;
      })
      /**
       * Relays to native requestAnimationFrame and adds to tracking to have call automatically canceled on destroy.
       * @param {Function} fn
       * @param {Object[]} [extraArgs] The argument list to append to those passed to the function.
       * @param {Object} [thisObj] `this` reference for the function.
       * @returns {Number}
       * @internal
       */

    }, {
      key: "requestAnimationFrame",
      value: function (_requestAnimationFrame) {
        function requestAnimationFrame(_x6) {
          return _requestAnimationFrame.apply(this, arguments);
        }

        requestAnimationFrame.toString = function () {
          return _requestAnimationFrame.toString();
        };

        return requestAnimationFrame;
      }(function (fn) {
        var extraArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
        var animationFrameIds = this.animationFrameIds || (this.animationFrameIds = new Set()),
            frameId = requestAnimationFrame(function () {
          globalDelays && globalDelays.animationFrames.delete(frameId);
          animationFrameIds.delete(frameId);
          return fn.apply(thisObj, extraArgs);
        });
        animationFrameIds.add(frameId);
        globalDelays && globalDelays.animationFrames.set(frameId, {
          fn: fn,
          extraArgs: extraArgs,
          thisObj: thisObj
        });
        return frameId;
      })
      /**
       * Creates a function which will execute once, on the next animation frame. However many time it is
       * called in one event run, it will only be scheduled to run once.
       * @param {Function|String} fn The function to call, or name of function in this object to call.
       * @param {Object[]} [args] The argument list to append to those passed to the function.
       * @param {Object} [thisObj] `this` reference for the function.
       * @param {Boolean} [cancelOutstanding] Cancel any outstanding queued invocation upon call.
       * @internal
       */

    }, {
      key: "createOnFrame",
      value: function createOnFrame(fn) {
        var _this = this;

        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
        var cancelOutstanding = arguments.length > 3 ? arguments[3] : undefined;
        var rafId;

        var result = function result() {
          for (var _len2 = arguments.length, callArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            callArgs[_key2] = arguments[_key2];
          }

          // Cancel if outstanding if requested
          if (rafId && cancelOutstanding) {
            _this.cancelAnimationFrame(rafId);

            rafId = null;
          }

          if (!rafId) {
            rafId = _this.requestAnimationFrame(function () {
              if (typeof fn === 'string') {
                fn = thisObj[fn];
              }

              rafId = null;
              callArgs.push.apply(callArgs, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_54___default()(args));
              fn.apply(thisObj, callArgs);
            });
          }
        };

        result.cancel = function () {
          return _this.cancelAnimationFrame(rafId);
        };

        return result;
      }
      /**
       * Relays to native cancelAnimationFrame and removes from tracking.
       * @param {Number} handle
       * @internal
       */

    }, {
      key: "cancelAnimationFrame",
      value: function (_cancelAnimationFrame) {
        function cancelAnimationFrame(_x7) {
          return _cancelAnimationFrame.apply(this, arguments);
        }

        cancelAnimationFrame.toString = function () {
          return _cancelAnimationFrame.toString();
        };

        return cancelAnimationFrame;
      }(function (handle) {
        cancelAnimationFrame(handle);
        this.animationFrameIds && this.animationFrameIds.delete(handle);
        globalDelays && globalDelays.animationFrames.delete(handle);
      })
    }, {
      key: "nextAnimationFrame",
      value: function () {
        var _nextAnimationFrame = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_47___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_45___default.a.mark(function _callee() {
          var _this2 = this;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_45___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", new Promise(function (resolve) {
                    return _this2.requestAnimationFrame(resolve);
                  }));

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function nextAnimationFrame() {
          return _nextAnimationFrame.apply(this, arguments);
        }

        return nextAnimationFrame;
      }()
      /**
       * Wraps a function with another function that delays it specified amount of time, repeated calls to the wrapper
       * resets delay.
       * @param {Function|String} fn The function to call. If this is a string, it is looked up as a method on `this`
       * instance (or `options.thisObj` instead, if provided).
       * @param {Object|Number} options The delay in milliseconds or an options object.
       * @param {Number} options.delay The delay in milliseconds.
       * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
       * @param {Object} [options.thisObj] The `this` reference for the function.
       * @returns {Function} Wrapped function to call.
       * @internal
       */

    }, {
      key: "buffer",
      value: function buffer(fn, options) {
        var _this3 = this;

        var delay = options;

        if (options && typeof options !== 'number') {
          // if (config object)
          delay = options.delay;
        } else {
          options = null;
        }

        var bufferWrapFn = function bufferWrapFn() {
          var delay = bufferWrapFn.delay;
          bufferWrapFn.cancel();
          bufferWrapFn.called = false;

          for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            params[_key3] = arguments[_key3];
          }

          bufferWrapFn.args = params; // If delay=0, the buffer has been disabled so always call immediately.

          if (bufferWrapFn.immediate || !delay) {
            invoker();
          } else {
            bufferWrapFn.timerId = _this3.setTimeout(invoker, delay);
          }
        },
            invoker = makeInvoker(this, fn, bufferWrapFn, options);

        bufferWrapFn.delay = delay;
        return decorateWrapFn(this, bufferWrapFn);
      }
      /**
       * Returns a function that when called will schedule a call to `fn` on the next animation frame.
       *
       * @param {Function|String} fn The function to call. If this is a string, it is looked up as a method on `this`
       * instance (or `options.thisObj` instead, if provided).
       * @param {Boolean|Object} [options] An options object or the `cancelOutstanding` boolean property of it.
       * @param {Boolean} [options.cancelOutstanding] Pass `true` to cancel any pending animation frame requests and
       * schedule a new one on each call to the returned function.
       * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
       * @param {Object} [options.thisObj] The `this` reference for the function.
       * @returns {Function}
       * @internal
       */

    }, {
      key: "raf",
      value: function raf(fn, options) {
        var _this4 = this;

        // NOTE: This method is only intended for use with `delayable`. It has a signature that is compatible
        // with `buffer()` and `throttle()`. The name is 'raf' to make the following aesthetically pleasing:
        //
        //  class Foo extends Delayable() {
        //      static get delayable() {
        //          return {
        //              bar : 'raf'
        //          };
        //      }
        //  }
        var cancelOutstanding = options;

        if (options && typeof options !== 'boolean') {
          // if (config object)
          cancelOutstanding = options.cancelOutstanding;
        } else {
          options = null;
        }

        var rafWrapFn = function rafWrapFn() {
          // Reschedule the frame on each call if requested
          if (rafWrapFn.cancelOutstanding) {
            rafWrapFn.cancel();
          }

          rafWrapFn.called = false;

          for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            params[_key4] = arguments[_key4];
          }

          rafWrapFn.args = params;

          if (rafWrapFn.immediate) {
            invoker();
          } else if (!rafWrapFn.isPending) {
            rafWrapFn.timerId = _this4.requestAnimationFrame(invoker);
          }
        },
            invoker = makeInvoker(this, fn, rafWrapFn, options);

        rafWrapFn.cancelOutstanding = cancelOutstanding;
        return decorateWrapFn(this, rafWrapFn, 'cancelAnimationFrame');
      }
      /**
       * Create a "debounced" function which will call on the "leading edge" of a timer period.
       * When first invoked will call immediately, but invocations after that inside its buffer
       * period will be rejected, and *one* invocation will be made after the buffer period has expired.
       *
       * This is useful for responding immediately to a first mousemove, but from then on, only
       * calling the action function on a regular timer while the mouse continues to move.
       *
       * @param {Function|String} fn The function to call. If this is a string, it is looked up as a method on `this`
       * instance (or `options.thisObj` instead, if provided).
       * @param {Number|Object} options The milliseconds to wait after each execution before another execution takes place
       * or a object containing options.
       * @param {Object} [options.thisObj] `this` reference for the function.
       * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
       * @param {Function|String} [options.throttled] A function to call when the invocation is delayed due to buffer
       * time not having expired. If this is a string, it is looked up as a method on `this` instance (or `options.thisObj`
       * instead, if provided). When called, the same arguments are passed as would have been passed to `fn`, including
       * any `options.appendArgs`.
       * @internal
       */

    }, {
      key: "throttle",
      value: function throttle(fn, options) {
        var delay = options,
            throttled;

        if (options && typeof options !== 'number') {
          // if (config object)
          delay = options.delay;
          throttled = options.throttled;
        } else {
          options = null;
        }

        var me = this,
            throttleWrapFn = function throttleWrapFn() {
          var delay = throttleWrapFn.delay,
              elapsed = performance.now() - throttleWrapFn.lastCallTime;

          for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
          }

          throttleWrapFn.args = args; // If it's been more then the delay period since we invoked, we can call it now.
          // Setting delay=0 effectively disables the throttle (which is the goal)

          if (throttleWrapFn.immediate || elapsed >= delay) {
            me.clearTimeout(throttleWrapFn.timerId);
            invoker();
          } else {
            // Kick off a timer for the requested period.
            if (!throttleWrapFn.isPending) {
              throttleWrapFn.timerId = me.setTimeout(invoker, delay - elapsed);
              throttleWrapFn.called = false;
            }

            if (throttled) {
              // Args have to be stored on the wrapFn for the invoker to pick them up:
              throttled.wrapFn.args = args;
              throttled();
            }
          }
        },
            invoker = makeInvoker(me, fn, throttleWrapFn, options);

        throttleWrapFn.delay = delay;

        if (throttled) {
          // Make an invoker for this callback to handle thisObj and typeof=string etc (pass a dud wrapFn):
          throttled = makeInvoker(me, throttled, function () {}, options);
        }

        return decorateWrapFn(me, throttleWrapFn);
      }
    }, {
      key: "widgetClass",
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.
      get: function get() {}
    }], [{
      key: "setupDelayable",
      value: function setupDelayable(cls) {
        cls.setupDelayableMethods(cls.delayable);
      }
      /**
       * This method initializes the `delayable` methods on this class.
       * @param {Object} delayable The `delayable` property.
       * @param {Function} [cls] This parameter will be used internally to process static methods.
       * @private
       */

    }, {
      key: "setupDelayableMethods",
      value: function setupDelayableMethods(delayable) {
        var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var me = this,
            statics = delayable.static,
            target = cls || me.prototype;

        if (statics) {
          // TODO me.setupDelayableMethods(statics, me);
          delete delayable.static;
        }

        var _loop = function _loop(name) {
          var options = delayable[name];

          var implName = name + 'Now',
              type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_44___default()(options);

          target[implName] = target[name];

          if (type === 'number') {
            options = {
              type: 'buffer',
              delay: options
            };
          } else if (type === 'string') {
            options = {
              type: options
            };
          } // For instance methods, we place a getter on the prototype. When the method is first accessed from the
          // prototype, we create an instance-specific version by calling this.buffer()/throttle() (based on the type
          // desired) and set that as the instance-level property.


          defineProperty(target, name, {
            get: function get() {
              var _this5 = this;

              var value = this[options.type](function () {
                _this5[implName].apply(_this5, arguments);
              }, options);
              defineProperty(this, name, {
                value: value
              });
              return value;
            }
          });
        };

        for (var name in delayable) {
          _loop(name);
        }
      }
    }, {
      key: "$name",
      get: function get() {
        return 'Delayable';
      }
    }, {
      key: "declarable",
      get: function get() {
        return [
        /**
         * This class property returns an object that specifies methods to wrap with configurable timer behaviors.
         *
         * It is used like so:
         * ```
         *  class Foo extends Delayable() {
         *      static get delayable() {
         *          return {
         *              expensiveMethod : 500
         *          };
         *      }
         *
         *      expensiveMethod() {
         *          this.things();
         *          this.moreThings();
         *          this.evenMoreThings();
         *      }
         *  }
         * ```
         * With the above in place, consider:
         * ```
         *  let instance = new Foo();
         *
         *  instance.expensiveMethod();
         * ```
         * Instead of the above code immediately calling the `expensiveMethod()`, it will start a timer that will
         * invoke the method 500ms later. Because `expensiveMethod()` is an instance method, each instance of `Foo`
         * will have its own timer.
         *
         * NOTE: Only instance methods are currently supported (i.e., only non-`static` methods).
         *
         * #### Options
         * The value of each key configures how the method will be scheduled. If the value is a number, it is
         * promoted to a config object of `type='buffer'` as in the following:
         * ```
         *  class Foo extends Delayable() {
         *      static get delayable() {
         *          return {
         *              expensiveMethod : {
         *                  type  : 'buffer',
         *                  delay : 500
         *              }
         *          };
         *      }
         *  });
         * ```
         * The `type` property of the config object must be one of three values. Other options can be provided
         * depending on the `type`:
         *
         *  - `buffer`<br>
         *    Other options:
         *     - `delay` (Number) : The number of milliseconds to wait before calling the underlying method. A
         *       value of 0 is equivalent to setting `immediate: true`.
         *     - `immediate` (Boolean) : Set to `true` to call immediately (effectively disabling the buffer).
         *  - `raf` (short for "request animation frame")<br>
         *    Other options:
         *     - `cancelOutstanding` (Boolean) : Set to `true` to cancel any pending animation frame requests and
         *       schedule a new one on each call.
         *     - `immediate` (Boolean) : Set to `true` to call immediately.
         *  - `throttle`<br>
         *    Other options:
         *     - `delay` (Number) : The number of milliseconds to wait after each execution before another
         *       execution takes place. A value of 0 is equivalent to setting `immediate: true`.
         *     - `immediate` (Boolean) : Set to `true` to call immediately (effectively disabling the throttle).
         *
         * While `immediate: true` can be specified at the class level, it is more typical to set it on the
         * instance's method as described below.
         *
         * #### Delayable Method API
         * Delayable methods have a consistent API to manage their scheduling. This API is added to the methods
         * themselves.
         *
         * For example:
         * ```
         *  let instance = new Foo();
         *
         *  instance.expensiveMethod();         // schedule a call in 500ms
         *  instance.expensiveMethod.isPending; // true
         *  instance.expensiveMethod.cancel();
         *  instance.expensiveMethod.flush();
         *  instance.expensiveMethod.now();
         *
         *  instance.expensiveMethod.delay = 10;
         *  instance.expensiveMethod();         // schedule a call in 10ms
         * ```
         *
         * ##### `isPending` (Boolean, readonly)
         * This boolean property will be `true` if a call has been scheduled, and false otherwise.
         *
         * ##### `cancel()`
         * Cancels a pending call if one has been scheduled. Otherwise this method does nothing.
         *
         * ##### `flush()`
         * Cancels the timer and causes the pending call to execute immediately. If there is no pending call, this
         * method does nothing.
         *
         * ##### `now()`
         * Cancels the timer (if one is pending) and executes the method immediately. If there is no pending call,
         * this method will still call the underlying method.
         *
         * @static
         * @member {Object} delayable
         * @internal
         */
        'delayable'];
      }
    }]);

    return Delayable;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_55__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/Draggable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Draggable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../util/drag/DragContext.js */ "./lib/Core/util/drag/DragContext.js");
/* harmony import */ var _util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../util/drag/DragProxy.js */ "./lib/Core/util/drag/DragProxy.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Core/mixin/Draggable
 */

/**
 * Mix this into another class to enable drag/drop support.
 *
 * To use a draggable, it must be associated with an element that contains draggable content:
 *
 * ```javascript
 *  let draggable = new MyDraggable({
 *      dragRootElement : someElement
 *  });
 * ```
 *
 * Once the `dragRootElement` is assigned, any element inside that root is a candidate for dragging. To limit the
 * allowed element, set the {@link #config-dragSelector} config.
 *
 * ```javascript
 *  let draggable = new MyDraggable({
 *      dragRootElement : someElement,
 *      dragSelector    : '.drag-this'
 *  });
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Draggable, _ref);

    var _super = _createSuper(Draggable);

    function Draggable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Draggable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Draggable, [{
      key: "dragStart",
      //endregion
      //region Drag Processing
      // These template methods are implemented by derived classes as desired. There is only one overlap with Droppable's
      // template methods (dragDrop) so that a class can easily mixin both Draggable and Droppable and always distinguish
      // whether it is acting as the source, the target, or both.

      /**
       * This template method is called when the drag operation starts. This occurs when the {@link #config-dragThreshold}
       * has been reached.
       * @param {Core.util.drag.DragContext} drag
       */
      value: function dragStart(drag) {// template
      }
      /**
       * This template method is called as the drag moves. This occurs on each mouse/pointer/touchmove event.
       * @param {Core.util.drag.DragContext} drag
       */

    }, {
      key: "dragOver",
      value: function dragOver(drag) {// template
      }
      /**
       * This template method is called when the drag enters a {@link Core.mixin.Droppable target}.
       * @param {Core.util.drag.DragContext} drag
       */

    }, {
      key: "dragEnterTarget",
      value: function dragEnterTarget(drag) {// template
      }
      /**
       * This template method is called when the drag leaves a {@link Core.mixin.Droppable target}.
       * @param {Core.util.drag.DragContext} drag
       * @param {Core.mixin.Droppable} oldTarget The previous value of `drag.target`.
       */

    }, {
      key: "dragLeaveTarget",
      value: function dragLeaveTarget(drag, oldTarget) {// template
      }
      /**
       * This template method is called when the drag operation completes. This occurs on the pointerup event.
       *
       * This method is not called if the drag is {@link Core.util.drag.DragContext#property-aborted aborted}.
       * @param {Core.util.drag.DragContext} drag
       */

    }, {
      key: "dragDrop",
      value: function dragDrop(drag) {// template
      }
      /**
       * This template method is called when the drag operation completes. This occurs on the pointerup event or perhaps
       * a keypress event.
       *
       * This method is always called, even if the drag is {@link Core.util.drag.DragContext#property-aborted aborted}.
       * @param {Core.util.drag.DragContext} drag
       */

    }, {
      key: "dragEnd",
      value: function dragEnd(drag) {// template
      } //endregion
      //region Drag Management
      // These methods are called by the DragContext and generally manage element updates (adding/removing classes) or
      // event firing. In most cases these methods then call a corresponding Drag Processing template method intended
      // for derived classes to implement.

    }, {
      key: "beforeDrag",
      value: function beforeDrag(drag) {
        var dragSelector = this.dragSelector;
        return !dragSelector || drag.element.matches(dragSelector);
      }
    }, {
      key: "beginDrag",
      value: function beginDrag(drag) {
        var draggingCls = this.draggingCls,
            draggingClassElement = this.draggingClassElement;

        if (draggingCls && draggingClassElement) {
          draggingClassElement.classList.add(draggingCls);
          drag.cleaners.push(function () {
            return draggingClassElement.classList.remove(draggingCls);
          });
        }
      }
    }, {
      key: "endDrag",
      value: function () {
        var _endDrag = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee(drag) {
          var me, dragEventer, dragProxy;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  me = this, dragEventer = me.dragEventer, dragProxy = me.dragProxy;
                  me.dragEnd(drag);

                  if (!drag.valid) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 5;
                  return me.dragDrop(drag);

                case 5:
                  dragProxy === null || dragProxy === void 0 ? void 0 : dragProxy.dragEnd(drag);
                  /**
                   * This event is fired when a drag gesture is completed. This event is fired if the drag was
                   * {@link Core.util.drag.DragContext#property-aborted}.
                   * @event dragCancel
                   * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
                   * @param {Core.util.drag.DragContext} drag The drag context.
                   * @param {Event} event The browser event.
                   */

                  /**
                   * This event is fired when a drag gesture is completed. This event is not fired if the drag was
                   * {@link Core.util.drag.DragContext#property-aborted}.
                   * @event drop
                   * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
                   * @param {Core.util.drag.DragContext} drag The drag context.
                   * @param {Event} event The browser event.
                   */

                  dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger(drag.valid ? 'drop' : 'dragCancel', {
                    drag: drag,
                    event: drag.event
                  }); // The drag context could have registered finalizers added by the above methods or event. If so, we need to
                  // wait for finalization of the drag before we clear our "dragging" config.

                  me.finalizeDrag(drag);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function endDrag(_x) {
          return _endDrag.apply(this, arguments);
        }

        return endDrag;
      }()
    }, {
      key: "finalizeDrag",
      value: function () {
        var _finalizeDrag = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee2(drag) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return drag.finalize();

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function finalizeDrag(_x2) {
          return _finalizeDrag.apply(this, arguments);
        }

        return finalizeDrag;
      }()
    }, {
      key: "moveDrag",
      value: function moveDrag(drag) {
        if (this.dragOver(drag) !== false) {
          var dragEventer = this.dragEventer,
              dragProxy = this.dragProxy;
          dragProxy === null || dragProxy === void 0 ? void 0 : dragProxy.dragMove(drag);
          /**
           * This event is fired as a drag gesture progresses due to cursor movement.
           * @event drag
           * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
           * @param {Core.util.drag.DragContext} drag The drag context.
           * @param {Event} event The browser event.
           */

          dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger('drag', {
            drag: drag,
            event: drag.event
          });
        }
      }
    }, {
      key: "setupDragContext",
      value: function setupDragContext(event) {
        var me = this,
            dragItemSelector = me.dragItemSelector,
            target = event.target;
        return {
          event: event,
          itemElement: dragItemSelector ? target.closest(dragItemSelector) : target,
          touchStartDelay: me.dragTouchStartDelay,
          source: me,
          threshold: me.dragThreshold
        };
      }
    }, {
      key: "startDrag",
      value: function startDrag(drag) {
        var draggingStartedCls = this.draggingStartedCls,
            draggingClassElement = this.draggingClassElement,
            draggingItemCls = this.draggingItemCls,
            dragEventer = this.dragEventer,
            dragProxy = this.dragProxy,
            itemElement = drag.itemElement;
        /**
         * This event is fired prior to starting a drag gesture. This does not occur immediately after the user
         * performs the pointer/mousedown/touchstart but only after the {@link #config-dragThreshold} amount of
         * movement has taken place.
         *
         * The drag is canceled if a listener returns `false`.
         * @event beforeDragStart
         * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
         * @param {Core.util.drag.DragContext} drag The drag context.
         * @param {Event} event The browser event.
         * @preventable
         */

        if ((dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger('beforeDragStart', {
          drag: drag,
          event: drag.event
        })) === false) {
          return false;
        }

        if (draggingStartedCls && draggingClassElement) {
          draggingClassElement.classList.add(draggingStartedCls);
          drag.cleaners.push(function () {
            return draggingClassElement.classList.remove(draggingStartedCls);
          });
        }

        if (draggingItemCls && itemElement) {
          itemElement.classList.add(draggingItemCls);
          drag.cleaners.push(function () {
            return itemElement.classList.remove(draggingItemCls);
          });
        }

        dragProxy === null || dragProxy === void 0 ? void 0 : dragProxy.dragStart(drag);
        this.dragStart(drag);
        /**
         * This event is fired when a drag gesture has started. This does not occur immediately after the user
         * performs the pointer/mousedown/touchstart but only after the {@link #config-dragThreshold} amount of
         * movement has taken place.
         * @event dragStart
         * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
         * @param {Core.util.drag.DragContext} drag The drag context.
         * @param {Event} event The browser event.
         */

        dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger('dragStart', {
          drag: drag,
          event: drag.event
        });
      }
    }, {
      key: "trackDrag",
      value: function trackDrag(drag) {
        var _drag$targetElement;

        var dropTargetSelector = this.dropTargetSelector;
        drag.valid = !(dropTargetSelector && !((_drag$targetElement = drag.targetElement) === null || _drag$targetElement === void 0 ? void 0 : _drag$targetElement.closest(dropTargetSelector)));
        this.moveDrag(drag);
      } //endregion
      //region Configs

    }, {
      key: "updateDragging",
      value: function updateDragging(drag) {
        var me = this;

        if (drag) {
          var listeners = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].assign({
            thisObj: me
          }, me.dragDocumentListeners); // Only listen for the events related to how the drag was initiated:

          if ('touches' in drag.startEvent) {
            delete listeners.mousemove;
            delete listeners.mouseup;
          } else {
            delete listeners.contextmenu;
            delete listeners.touchmove;
            delete listeners.touchend;
            delete listeners.pointerup;
          }

          drag.cleaners.push(_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on(listeners));
          me.beginDrag(drag);
        }
      }
    }, {
      key: "changeDragProxy",
      value: function changeDragProxy(config, existing) {
        return _util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_16__["default"].reconfigure(existing, config, {
          owner: this,
          defaults: {
            owner: this
          }
        });
      }
    }, {
      key: "updateDragRootElement",
      value: function updateDragRootElement(rootEl) {
        var _me$_dragRootDetacher;

        var me = this;
        (_me$_dragRootDetacher = me._dragRootDetacher) === null || _me$_dragRootDetacher === void 0 ? void 0 : _me$_dragRootDetacher.call(me);
        me._dragRootDetacher = rootEl && _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
          thisObj: me,
          element: rootEl,
          mousedown: 'onDragMouseDown',
          // We have touchstart listener in place since Siesta/Chrome can send these events even on non-touch
          // devices:
          touchstart: 'onDragTouchStart'
        });
      } //endregion
      //region Events

    }, {
      key: "onDragContextMenu",
      value: function onDragContextMenu(event) {
        event.preventDefault();
      }
    }, {
      key: "onDragKeyDown",
      value: function onDragKeyDown(event) {
        this.dragging.keyDown(event);
      }
    }, {
      key: "onDragKeyUp",
      value: function onDragKeyUp(event) {
        this.dragging.keyUp(event);
      }
      /**
       * Grab draggable element on mouse down.
       * @param {Event} event
       * @private
       */

    }, {
      key: "onDragMouseDown",
      value: function onDragMouseDown(event) {
        // only dragging with left mouse button
        if (event.button === 0) {
          this.onDragPointerDown(event);
        }
      }
      /**
       * Grab draggable element on pointerdown.
       * @param {Event} event
       * @private
       */

    }, {
      key: "onDragPointerDown",
      value: function onDragPointerDown(event) {
        var drag = this.dragging; // If a drag is ongoing already, finalize it and don't proceed with new drag (happens if user does pointerup
        // outside browser window). Also handles the edge case of trying to start a new drag while previous is awaiting
        // finalization, in which case it just bails out.

        if (!drag) {
          drag = new _util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_15__["default"](this.setupDragContext(event));
          drag.begin();
        } else if (!drag.isFinalizing) {
          drag.abort();
        }
      }
    }, {
      key: "onDragPointerMove",
      value: function onDragPointerMove(event) {
        var drag = this.dragging;

        if (drag && !drag.completed) {
          drag === null || drag === void 0 ? void 0 : drag.move(event);
        }
      }
    }, {
      key: "onDragPointerUp",
      value: function onDragPointerUp(event) {
        var drag = this.dragging;

        if (drag && !drag.completed) {
          drag.end(event);
          this.endDrag(drag);
        }
      }
      /**
       * @param {Event} event
       * @private
       */

    }, {
      key: "onDragTouchStart",
      value: function onDragTouchStart(event) {
        // only allowing one finger for now...
        if (event.touches.length === 1) {
          this.onDragPointerDown(event);
        }
      } //endregion

    }, {
      key: "activeDrag",
      get: function get() {
        var drag = this.dragging;
        return (drag === null || drag === void 0 ? void 0 : drag.started) && !drag.completed ? drag : null;
      }
      /**
       * Return the `Events` instance from which drag events are fired.
       * @returns {Core.mixin.Events}
       */

    }, {
      key: "dragEventer",
      get: function get() {
        return this.callPreventable ? this : null; // simple Events feature detector
      }
    }, {
      key: "draggingClassElement",
      get: function get() {
        var draggingClsSelector = this.draggingClsSelector,
            dragRootElement = this.dragRootElement;
        return draggingClsSelector ? dragRootElement === null || dragRootElement === void 0 ? void 0 : dragRootElement.closest(draggingClsSelector) : dragRootElement;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'Draggable';
      } //region Configs

    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * The current `DragContext`. This is created immediately on pointerdown but does not become active until
           * some movement occurs. This {@link #config-dragThreshold threshold} is configurable.
           * @member {Core.util.drag.DragContext}
           * @readonly
           */
          dragging: null,

          /**
           * A CSS selector to use to ascend from the {@link #config-dragRootElement} to find the element that will
           * gain the {@link #property-draggingCls} and {@link #property-draggingStartedCls} CSS classes.
           * @config {String}
           */
          draggingClsSelector: null,

          /**
           * The listeners to add to the `document` during a drag.
           * @config {Object}
           * @private
           */
          dragDocumentListeners: {
            element: document,
            keydown: 'onDragKeyDown',
            keyup: 'onDragKeyUp',
            // On mobile, a long-press will (sometimes) trigger a context menu, so we suppress it:
            contextmenu: 'onDragContextMenu',
            // We don't use pointermove/up because they get snared in the "touch-action" vs "pan-x/y" trap and we
            // cannot prevent panning (aka scrolling) in response to move events if we go that way:
            mousemove: 'onDragPointerMove',
            mouseup: 'onDragPointerUp',
            // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired. iOS does
            // fire touchend:
            pointerup: 'onDragPointerUp',
            touchend: 'onDragPointerUp',
            touchmove: {
              handler: 'onDragPointerMove',
              passive: false // We need to be able to preventDefault on the touchmove

            }
          },

          /**
           * A CSS selector to use to ascend from the drag element to find the element that will gain the
           * {@link #property-draggingItemCls} CSS class. If not supplied, the drag element will gain this CSS
           * class.
           * @config {String}
           */
          dragItemSelector: null,

          /**
           * Configure as `'x'` to lock dragging to the `X` axis (the drag will only move horizontally) or `'y'`
           * to lock dragging to the `Y` axis (the drag will only move vertically).
           * @config {String}
           */
          dragLock: null,

          /**
           * The minimum distance a drag must move to be considered a drop and not
           * {@link Core.util.drag.DragContext#property-aborted aborted}.
           * @config {Number}
           * @default
           */
          dragMinDistance: 1,

          /**
           * The {@link Core.util.drag.DragProxy drag proxy} is a helper object that can be used to display feedback
           * during a drag.
           * @config {Object|Core.util.drag.DragProxy}
           */
          dragProxy: {
            $config: ['lazy', 'nullify'],
            value: null
          },

          /**
           * The outer element where dragging will operate (attach events to it and use as root limit when looking
           * for ancestors).
           * @config {HTMLElement}
           */
          dragRootElement: {
            $config: 'nullify',
            value: null
          },

          /**
           * Set to `true` to allow a drag to drop on to the same element from which the drag started.
           * @config {Boolean}
           * @default
           */
          dragSameTargetDrop: false,

          /**
           * A CSS selector used to determine which element(s) can be dragged.
           * @config {String}
           * @default
           */
          dragSelector: null,

          /**
           * The number of milliseconds after a pointerup to ignore click events on the document. This
           * is used to avoid the "up" event itself generating a `click` on the target.
           * @config {Number}
           * @default
           */
          dragSwallowClickTime: 50,

          /**
           * The amount of pixels to move pointer/mouse before it counts as a drag operation.
           * @config {Number}
           * @default
           */
          dragThreshold: 5,

          /**
           * The number of milliseconds that must elapse after a `touchstart` event before it is considered a drag. If
           * movement occurs before this time, the drag is aborted. This is to allow touch swipes and scroll gestures.
           * @config {Number}
           * @default
           */
          dragTouchStartDelay: 300,

          /**
           * The CSS selector to use to identify the closest valid target from the event target.
           * @config {String}
           */
          dropTargetSelector: null,
          testConfig: {
            // In Edge synthetic click events are fired asynchronously and can take considerable
            // amount of time. Setting larger click swallow timeout to make sure Edge has time to fire click event.
            // Caught by test EventDrag4.t in Edge
            dragSwallowClickTime: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isEdge ? 300 : 50
          }
        };
      }
    }, {
      key: "properties",
      get: function get() {
        return {
          /**
           * The CSS class to add to the {@link #config-dragRootElement} (or {@link #config-draggingClsSelector} from
           * there) as soon as the pointerdown event occurs.
           * @member {String}
           * @readonly
           */
          draggingCls: 'b-draggable-active',

          /**
           * The CSS class to add to the `body` element as soon as the {@config #link-dragThreshold} is reached and
           * an actual drag is in progress.
           * @member {String}
           * @readonly
           */
          draggingBodyCls: 'b-draghelper-active',
          // match DragHelper since we need the same treatment

          /**
           * The CSS class to add to the element being dragged as soon as the pointerdown event occurs.
           * @member {String}
           * @readonly
           */
          draggingItemCls: 'b-dragging-item',

          /**
           * The CSS class to add to the {@link #config-dragRootElement} (or {@link #config-draggingClsSelector} from
           * there) as soon as the {@config #link-dragThreshold} is reached and an actual drag is in progress.
           * @member {String}
           * @readonly
           */
          draggingStartedCls: 'b-draggable-started'
        };
      }
    }]);

    return Draggable;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_11__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/Droppable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Droppable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/mixin/Droppable
 */

/**
 * Mix this into another class to enable drop support and receive drops from {@link Core.mixin.Draggable draggables}.
 *
 * There are 4 basic methods that a droppable implements. These methods are called as drag operations occur:
 *
 * ```javascript
 *  class MyDroppable extends Base.mixin(Droppable) {
 *      dragEnter(drag) {
 *          // a drag has entered the drop zone... create some type of drop indicator perhaps
 *      }
 *
 *      dragMove(drag) {
 *          // a drag has changed position... update drop indicators
 *      }
 *
 *      dragDrop(drag) {
 *          // drop has occurred... process data from the drag context
 *      }
 *
 *      dragLeave(drag) {
 *          // the drag has left the drop zone... cleanup indicators
 *      }
 *  }
 * ```
 *
 * Instances of `Droppable` are associated with an element to receive drag operations:
 *
 * ```javascript
 *  let target = new MyDroppable({
 *      dropRootElement : someElement
 *  });
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Droppable, _ref);

    var _super = _createSuper(Droppable);

    function Droppable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Droppable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Droppable, [{
      key: "dragEnter",
      //endregion
      //region Drop Management

      /**
       * This method is called when a drag enters this droppable's `dropRootElement`. In many cases, this method is used
       * to create some sort of drop indicator to provide user feedback.
       *
       * If this method does not return `false`, the {@link #property-dropping} config will retain the given `drag` context
       * which was set prior to this method being called.
       *
       * If this method returns `false`, the drop will not be accepted. Neither {@link #function-dragDrop} nor
       * {@link #function-dragLeave} will be called for this drop. If the drag leaves this target and re-enters, this
       * method will be called again. While `dropping` will already be updated before this method is called, it will be
       * reset to `null` in this case.
       *
       * @param {Core.util.drag.DragContext} drag
       * @returns {Boolean}
       */
      value: function dragEnter(drag) {// template
      }
      /**
       * This method is called when the drag that was previously announced via {@link #function-dragEnter} moves to a new
       * position. This is typically where drop indicators are updated to reflect the new position.
       * @param {Core.util.drag.DragContext} drag
       */

    }, {
      key: "dragMove",
      value: function dragMove(drag) {// template
      }
      /**
       * This method is called when the drag that was previously announced via {@link #function-dragEnter} has ended with
       * a drop. In addition to any cleanup (since {@link #function-dragLeave} will not be called), this method handles
       * any updates associated with the data from the drag context and the position of the drop.
       * @param {Core.util.drag.DragContext} drag
       */

    }, {
      key: "dragDrop",
      value: function dragDrop(drag) {// template
      }
      /**
       * This method is called when the drag that was previously announced via {@link #function-dragEnter} leaves this
       * droppable's `dropRootElement`. This is the time to cleanup anything created by `dragEnter`.
       * @param {Core.util.drag.DragContext} drag
       */

    }, {
      key: "dragLeave",
      value: function dragLeave(drag) {// template
      } //endregion
      //region Configs

    }, {
      key: "changeDropping",
      value: function changeDropping(dropping, was) {
        if (dropping !== was) {
          var me = this;

          if (was) {
            if (was.aborted || !was.completed) {
              me.dragLeave(was);
            }
          }

          if (dropping) {
            me._dropping = dropping; // update config value early in case dragEnter et al refer to it

            if (me.dragEnter(dropping) === false) {
              dropping = null;
            }

            me._dropping = was; // restore the value so that updateDropping is called as it should be
          }
        }

        return dropping;
      }
    }, {
      key: "updateDropRootElement",
      value: function updateDropRootElement(rootEl, was) {
        var droppableCls = this.droppableCls;

        if (was) {
          was.classList.remove(droppableCls);

          if (_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_9__["default"].get(was, 'droppable') === this) {
            _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_9__["default"].remove(was, 'droppable');
          }
        }

        if (rootEl) {
          rootEl.classList.add(droppableCls);
          _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_9__["default"].set(rootEl, 'droppable', this);
        }
      } //endregion

    }, {
      key: "droppableCls",

      /**
       * Returns the CSS class that is added to the {@link #config-dropRootElement}, i.e., `'b-droppable'`.
       * @property {String}
       * @readonly
       */
      get: function get() {
        return 'b-droppable';
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'Droppable';
      } //region Configs

    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * The current `DragContext`. This is set when a drag enters this target. Changing this config causes the
           * {@link #function-dragEnter} and {@link #function-dragLeave} methods to be called. If `dragEnter` returns
           * `false` for a drag, this value will be set to `null`.
           * @member {Core.util.drag.DragContext}
           * @readonly
           */
          dropping: null,

          /**
           * Set this config to the element where drops should be received. When set, the `b-droppable` CSS class is
           * added to the element and the `Droppable` instance is associated with that element so that it can be
           * found by {@link Core.mixin.Draggable draggables}.
           * @config {HTMLElement}
           */
          dropRootElement: {
            $config: 'nullify',
            value: null
          }
        };
      }
    }]);

    return Droppable;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/Events.js":
/*!**********************************!*\
  !*** ./lib/Core/mixin/Events.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_is_extensible__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.is-extensible */ "./node_modules/core-js/modules/es.object.is-extensible.js");
/* harmony import */ var core_js_modules_es_object_is_extensible__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_is_extensible__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");





































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Core/mixin/Events
 */

// Used by the config system to flatten configs from the class hierrchy.
// In this case, a pure merge is not wanted. Listener definitions from
// every class level are collected up into an array.
// addListener iterates any passed array, adding each element.
var isArray = Array.isArray,
    specialProperties = {
  thisObj: 1,
  detachable: 1,
  once: 1,
  detacher: 1,
  prio: 1,
  args: 1,
  expires: 1,
  name: 1,
  _oldDestructor: 1
},
    priorityComparator = function priorityComparator(a, b) {
  return b.prio - a.prio;
};
/**
 * Mix this into another class to enable event handling.
 *
 * ## Basic usage
 * Listeners can be added either through config:
 *
 * ```javascript
 * let button = new Button({
 *   listeners: {
 *     click: () => {},
 *     press: () => {},
 *     ...
 *   }
 * });
 * ```
 *
 * *NOTE*: Do not reuse listeners config object, use new every time:
 * ```javascript
 * // wrong
 * let config = { click : () => {} }
 * new Button({
 *     listeners : config
 * })
 * new Button({
 *     listeners : config
 * })
 * // right
 * new Button({
 *     listeners : { click : () => {} }
 * })
 * new Button({
 *     listeners : { click : () => {} }
 * })
 * ```
 *
 * Or by calling on()/addListener():
 *
 * ```javascript
 * let button = new Button();
 *
 * button.addListener('press', () => {});
 * // on is an alias for addListener
 * button.on('click', () => {});
 * ```
 *
 * This style also accepts multiple listeners in same way as when using config:
 *
 * ```javascript
 * button.on({
 *   click: () => {},
 *   press: () => {},
 *   ...
 * });
 * ```
 *
 * ## Options
 * ### Once
 * Listeners can be configured to automatically deregister after first trigger by specifing config option `once`:
 *
 * ```javascript
 * button.on({
 *   click: () => {},
 *   once: true
 * });
 * ```
 *
 * ### Priority
 * Specifying priority affects the order in which listeners are called when triggering an event. Higher prios will be
 * called before lower. Default value is 0.
 *
 * ```javascript
 * button.on({
 *   click: this.onClick,
 *   prio: 1
 * });
 * ```
 *
 * ### This reference
 * If desired, you can specify thisObj when configuring listeners. There is no need if you are using arrow functions as
 * listeners, but might be handy in other cases. Of course, you can also use bind to set `this` reference.
 *
 * ```javascript
 * button.on({
 *   click: this.onClick,
 *   thisObj: this
 * });
 *
 * // or
 *
 * button.on({
 *   click: this.onClick.bind(this)
 * });
 * ```
 *
 * ### Detacher
 * A convenient way of unregistering events is to use a detacher, a function returned when adding listeners that you
 * call later to deregister them. As of version 1.0, detachable defaults to true.
 *
 * ```javascript
 * let detacher = button.on({
 *   click: () => {},
 *   press: () => {},
 *   detachable: true
 * });
 *
 * // when you want to detach, for example in destroy()
 * detacher();
 * ```
 *
 * ### Auto detaching
 * When listeners are bound to a class instance using `thisObj`, the `thisObj`'s `doDestroy` method
 * is overridden to remove the listeners before calling the overridden doDestroy.
 *
 * ```javascript
 * class MyClass extends Base {
 *   construct() {
 *     let button = new Button({
 *       listeners: {
 *         click: () => {},
 *         thisObj: this
 *       }
 *     });
 *   }
 *
 *   doDestroy() {
 *     // clean up stuff
 *   }
 * }
 *
 * let myObj = new MyClass();
 * // clean up, also removes listeners
 * myObj.destroy();
 * ```
 *
 * ### On-functions
 * When mixing Events into another class it can be configured to call on-functions when events are triggered.
 * On-functions are functions named 'onEventname', for example 'onClick', 'onPress' declared on the class triggering
 * the event.
 *
 * ```javascript
 * // mix Events in with on-functions activated
 * let button = new Button({
 *   callOnFunctions: true,
 *
 *   onClick: () => {}
 * });
 *
 * // or add a getter in class declaration
 * ```
 *
 * ### Catching all events
 * By specifying a listener for `catchAll` a function can be notified when any event is triggered:
 *
 * ```javascript
 * const button = new Button({
 *    listeners : {
 *        catchAll(event) {
 *            // All events on the button will pass through here
 *        }
 *    }
 * });
 * ```
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default()(Events, _ref);

    var _super = _createSuper(Events);

    function Events() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default()(this, Events);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default()(Events, [{
      key: "destroy",
      value: function destroy() {
        this.trigger('beforeDestroy');

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Events.prototype), "destroy", this).call(this);
      } //endregion
      //region Init

    }, {
      key: "construct",
      value: function construct(config) {
        var _config, _get2;

        // Configured listeners use this as the thisObj
        if (this.configuredListeners
        /* assignment */
        = (_config = config) === null || _config === void 0 ? void 0 : _config.listeners) {
          config = _objectSpread({}, config);
          delete config.listeners;
        }

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Events.prototype), "construct", this)).call.apply(_get2, [this, config].concat(args)); // Apply configured listeners after construction.
        // Note that some classes invoke this during parts of their construction.
        // Store invokes this prior to setting data so that observers are notified of data load.


        this.processConfiguredListeners();
      }
    }, {
      key: "processConfiguredListeners",
      value: function processConfiguredListeners() {
        // This can only happen once
        if (this.configuredListeners) {
          var me = this,
              isConfiguring = me.isConfiguring; // If called from config ingestion during configuration, listeners must be added
          // so temporarily clear the isConfiguring flag.

          me.isConfiguring = false;
          me.listeners = me.configuredListeners;
          me.configuredListeners = null;
          me.isConfiguring = isConfiguring;
        }
      }
      /**
       * Auto detaches listeners registered from start, if set as detachable
       * @internal
       */

    }, {
      key: "doDestroy",
      value: function doDestroy() {
        this.trigger('destroy');
        this.removeAllListeners();

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Events.prototype), "doDestroy", this).call(this);
      }
    }, {
      key: "addListener",
      //endregion
      //region Listeners

      /**
       * Adds an event listener. This method accepts parameters in the following format:
       *
       * ```javascript
       *  {
       *      thisObj    : this,          // The this reference for the handlers
       *      eventname2 : 'functionName' // Resolved at invocation time using the thisObj,
       *      otherevent : {
       *          fn      : 'handlerFnName',
       *          once    : true          // Just this handler is auto-removed on fire
       *      },
       *      yetanother  : {
       *          fn      : 'yetAnotherHandler',
       *          args    : [ currentState1, currentState2 ] // Capture info to be passed to handler
       *      },
       *      prio        : 100           // Higher prio listeners are called before lower
       *  }
       * ```
       *
       * When listeners have a `thisObj` option, they are linked to the lifecycle of that object.
       * When it is destroyed, those listeners are removed.
       *
       * @param {Object} config An object containing listener definitions.
       * @param {Object} [config.thisObj] The `this` reference for all listeners.
       * (May be overridden if a handler is specified in object form)
       * @param {Boolean} [config.once] Specify as `true` to remove the listener as soon as it is invoked.
       * @param {Number|Object} [config.expires] The listener only waits for a specified time before
       * being removed. The value may be a number or an object containing an expiry handler.
       * @param {Number} [config.expires.delay] How long to wait for the event for.
       * @param {String|Function} [config.expires.alt] The function to call when the listener expires
       * **without having been triggered**.
       * @param {Object[]} [config.args] An array of arguments to be passed to the handler before the event object.
       * @param {Object} [thisObj] `this` reference for all listeners.
       * @param {Number} [prio] The priority for all listeners; higher priority listeners are caled before lower.
       * @returns {Function} Returns a detacher function unless configured with `detachable: false`. Call detacher to remove listeners
       */
      value: function addListener(config, thisObj, arg2) {
        if (isArray(config)) {
          for (var i = 0, length = config.length; i < length; i++) {
            this.addListener(config[i], thisObj);
          }

          return;
        }

        var me = this,
            deprecatedEvents = me.$meta.getInherited('deprecatedEvents');

        if (typeof config === 'string') {
          var _me$addListener;

          // arguments[2] is thisObj if (eventname, handler, thisObj) form called.
          // Note that the other side of the if compares to undefined, so this will work.
          return me.addListener((_me$addListener = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_me$addListener, config, thisObj), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_me$addListener, "detachable", thisObj.detachable !== false), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_me$addListener, "thisObj", arg2), _me$addListener));
        } else {
          // Capture the default thisObj.
          thisObj = config.thisObj !== undefined ? config.thisObj : thisObj;

          for (var key in config) {
            if (!specialProperties[key]) {
              (function () {
                // comparing should be case insensitive
                var // comparing should be case insensitive
                eventName = key.toLowerCase(),
                    deprecatedEvent = deprecatedEvents === null || deprecatedEvents === void 0 ? void 0 : deprecatedEvents[eventName],
                    events = me.eventListeners || (me.eventListeners = {}),
                    listenerSpec = config[key],
                    expires = listenerSpec.expires || config.expires,
                    listener = {
                  fn: _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_28___default()(listenerSpec) === 'object' ? listenerSpec.fn : listenerSpec,
                  thisObj: listenerSpec.thisObj !== undefined ? listenerSpec.thisObj : thisObj,
                  args: listenerSpec.args || config.args,
                  prio: listenerSpec.prio !== undefined ? listenerSpec.prio : config.prio !== undefined ? config.prio : 0,
                  once: listenerSpec.once !== undefined ? listenerSpec.once : config.once !== undefined ? config.once : false,
                  catchAll: key === 'catchAll'
                };

                if (deprecatedEvent) {
                  var product = deprecatedEvent.product,
                      invalidAsOfVersion = deprecatedEvent.invalidAsOfVersion,
                      message = deprecatedEvent.message;
                  _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_40__["default"].deprecate(product, invalidAsOfVersion, message);
                }

                if (expires) {
                  // Extract expires : { delay : 100, alt : 'onExpireFn' }
                  var delayable = me.isDelayable ? me : window,
                      alt = expires.alt,
                      delay = alt ? expires.delay : expires;
                  delayable[typeof delay === 'number' ? 'setTimeout' : 'requestAnimationFrame'](function () {
                    me.un(eventName, listener); // If we make it here and the handler has not been called, invoke the alt handler

                    if (alt && !listener.called) {
                      me.callback(alt, thisObj);
                    }
                  }, delay);
                }

                var listeners = events[eventName] || (events[eventName] = []);

                if (listeners.$firing) {
                  events[eventName] = listeners = listeners.slice();
                } // Insert listener directly in prio order


                listeners.splice(_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].findInsertionIndex(listener, listeners, priorityComparator, listeners.length), 0, listener);

                if (!me.onListen.$nullFn && listeners.length < 2) {
                  me.onListen(eventName);
                }
              })();
            }
          }

          if (config.relayAll) {
            me.relayAll(config.relayAll);
          } // Hook into the thisObj's destruction sequence to remove these listeners.
          // Pass the default thisObj in for use when it comes to destruction time.


          if (thisObj) {
            me.attachAutoDetacher(config, thisObj);
          }

          var detachable = config.detachable !== false,
              name = config.name,
              destroy = config.expires || detachable || name ? function () {
            // drop listeners if not destroyed yet
            if (!me.isDestroyed) {
              me.removeListener(config, thisObj);
            }
          } : null;

          if (destroy) {
            var _thisObj;

            destroy.eventer = me;
            destroy.listenerName = name;

            if (name && ((_thisObj = thisObj) === null || _thisObj === void 0 ? void 0 : _thisObj.trackDetacher)) {
              thisObj.trackDetacher(name, destroy);
            }

            if (config.expires) {
              me.delay(destroy, config.expires);
            }

            if (detachable) {
              return destroy;
            }
          }
        }
      }
      /**
       * Shorthand for addListener
       * @param config
       * @param [thisObj]
       */

    }, {
      key: "on",
      value: function on() {
        return this.addListener.apply(this, arguments);
      }
      /**
       * Shorthand for removeListener
       * @param config
       * @param thisObj
       */

    }, {
      key: "un",
      value: function un() {
        this.removeListener.apply(this, arguments);
      }
    }, {
      key: "changeListeners",
      value: function changeListeners(listeners) {
        // If we are receiving class listeners, add them early, and they do not become
        // the configured listeners, and are not removed by setting listeners during the lifecycle.
        if (this.isConfiguring) {
          if (listeners) {
            this.on(listeners, this);
          }
        } // Setting listeners after config time clears the old set and adds the new.
        // This will initially happen at the tail end of the constructor when config
        // listeners are set.
        else {
            // Configured listeners use this as the thisObj by default.
            // Flatten using Objects.assign because it may have been part of
            // a prototype chained default configuration of another object.
            // eg: the tooltip config of a Widget.
            if (listeners && !('thisObj' in listeners)) {
              listeners = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_42__["default"].assign({
                thisObj: this
              }, listeners);
            }

            return listeners;
          }
      }
    }, {
      key: "updateListeners",
      value: function updateListeners(listeners, oldListeners) {
        // Only configured listeners get here. Class listeners are added by changeListeners.
        oldListeners && this.un(oldListeners);
        listeners && this.on(listeners);
      }
      /**
       * Removes an event listener. Same API signature as {@link #function-addListener}
       * @param {Object} config Listeners
       * @param {Object} thisObj `this` reference for all listeners
       */

    }, {
      key: "removeListener",
      value: function removeListener(config) {
        var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config.thisObj;
        var arg2 = arguments.length > 2 ? arguments[2] : undefined;
        var me = this;

        if (typeof config === 'string') {
          return me.removeListener(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()({}, config, thisObj), arg2);
        }

        Object.entries(config).forEach(function (_ref2) {
          var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27___default()(_ref2, 2),
              eventName = _ref3[0],
              listenerToRemove = _ref3[1];

          if (!specialProperties[eventName]) {
            eventName = eventName.toLowerCase();
            var eventListeners = me.eventListeners,
                index = me.findListener(eventName, listenerToRemove, thisObj);

            if (index >= 0) {
              var listeners = eventListeners[eventName];

              if (listeners.length > 1) {
                if (listeners.$firing) {
                  eventListeners[eventName] = listeners = listeners.slice();
                } // NOTE: we cannot untrack any detachers here because we may only be
                // removing some of its listeners


                listeners.splice(index, 1);
              } else {
                delete eventListeners[eventName];

                if (!me.onUnlisten.$nullFn) {
                  me.onUnlisten(eventName);
                }
              }
            }
          }
        });

        if (config.thisObj && !config.thisObj.isDestroyed) {
          me.detachAutoDetacher(config);
        }
      }
    }, {
      key: "findListener",
      value: function findListener(eventName, listenerToRemove, defaultThisObj) {
        var _this$eventListeners;

        var eventListeners = (_this$eventListeners = this.eventListeners) === null || _this$eventListeners === void 0 ? void 0 : _this$eventListeners[eventName],
            fn = listenerToRemove.fn || listenerToRemove,
            thisObj = listenerToRemove.thisObj || defaultThisObj;

        if (eventListeners) {
          for (var listenerEntry, i = 0, length = eventListeners.length; i < length; i++) {
            listenerEntry = eventListeners[i];

            if (listenerEntry.fn === fn && listenerEntry.thisObj === thisObj) {
              return i;
            }
          }
        }

        return -1;
      }
      /**
       * Check if any listener is registered for the specified eventName
       * @param {String} eventName
       * @returns {Boolean} `true` if listener is registered, otherwise `false`
       */

    }, {
      key: "hasListener",
      value: function hasListener(eventName) {
        var _this$eventListeners2;

        return Boolean((_this$eventListeners2 = this.eventListeners) === null || _this$eventListeners2 === void 0 ? void 0 : _this$eventListeners2[eventName === null || eventName === void 0 ? void 0 : eventName.toLowerCase()]);
      }
      /**
       * Relays all events through another object that also implements Events mixin. Adds a prefix to the event name
       * before relaying, for example add -> storeAdd
       * ```
       * // Relay all events from store through grid, will make it possible to listen for store events prefixed on grid:
       * 'storeLoad', 'storeChange', 'storeRemoveAll' etc.
       * store.relayAll(grid, 'store');
       *
       * grid.on('storeLoad', () => console.log('Store loaded');
       * ```
       * @param {Core.mixin.Events} through Object to relay the events through, needs to mix Events mixin in
       * @param {String} prefix Prefix to add to event name
       * @param {Boolean} [transformCase] Specify false to prevent making first letter of event name uppercase
       */

    }, {
      key: "relayAll",
      value: function relayAll(through, prefix) {
        var transformCase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        (this.relayAllTargets || (this.relayAllTargets = [])).push({
          through: through,
          prefix: prefix,
          transformCase: transformCase
        });
      }
      /**
       * Removes all listeners registered to this object
       */

    }, {
      key: "removeAllListeners",
      value: function removeAllListeners() {
        var listeners = this.eventListeners;
        var i, thisObj;

        for (var event in listeners) {
          var bucket = listeners[event]; // We iterate backwards since we call removeListener which will splice out of
          // this array as we go...

          for (i = bucket.length; i-- > 0;)
          /* empty */
          {
            var _thisObj2;

            var cfg = bucket[i];
            this.removeListener(event, cfg);
            thisObj = cfg.thisObj;

            if ((_thisObj2 = thisObj) === null || _thisObj2 === void 0 ? void 0 : _thisObj2.untrackDetachers) {
              thisObj.untrackDetachers(this);
            }
          }
        }
      }
    }, {
      key: "relayEvents",
      value: function relayEvents(source, eventNames) {
        var _this = this;

        var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var listenerConfig = {
          detachable: true
        };
        eventNames.forEach(function (eventName) {
          listenerConfig[eventName] = function (event) {
            for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              params[_key2 - 1] = arguments[_key2];
            }

            return _this.trigger.apply(_this, [prefix + event.type, event].concat(params));
          };
        });
        return source.on(listenerConfig);
      }
      /**
       * This method is called when the first listener for an event is added.
       * @param {String} eventName
       * @internal
       */

    }, {
      key: "onListen",
      value: function onListen() {}
      /**
       * This method is called when the last listener for an event is removed.
       * @param {String} eventName
       * @internal
       */

    }, {
      key: "onUnlisten",
      value: function onUnlisten() {}
      /**
       * Internal function used to hook destroy() calls when using thisObj
       * @private
       */

    }, {
      key: "attachAutoDetacher",
      value: function attachAutoDetacher(config, thisObj) {
        var _this2 = this;

        var target = config.thisObj || thisObj,
            // If it's a Bryntum Base subclass, hook doDestroy, otherwise, destroy
        destructorName = 'doDestroy' in target ? 'doDestroy' : 'destroy';

        if (destructorName in target) {
          var $autoDetachers = target.$autoDetachers;

          if (!$autoDetachers) {
            target[destructorName] = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].createInterceptor(target[destructorName], function () {
              // Remove listeners first, so that they do not fire during destruction.
              // The observable being listened to by the thisObj may already have
              // been destroyed in a clean up sequence
              for (var i = 0; i < $autoDetachers.length; i++) {
                var _$autoDetachers$i = $autoDetachers[i],
                    dispatcher = _$autoDetachers$i.dispatcher,
                    _config2 = _$autoDetachers$i.config;

                if (!dispatcher.isDestroyed) {
                  dispatcher.removeListener(_config2, target);
                }
              }
            }, target);
            target.$autoDetachers = $autoDetachers = [];
          }

          $autoDetachers.push({
            config: config,
            dispatcher: this
          });
        } else {
          target[destructorName] = function () {
            _this2.removeListener(config);
          };
        }
      }
      /**
       * Internal function used restore hooked destroy() calls when using thisObj
       * @private
       */

    }, {
      key: "detachAutoDetacher",
      value: function detachAutoDetacher(config) {
        var target = config.thisObj,
            destructorName = 'doDestroy' in target ? 'doDestroy' : 'destroy';

        if (config._oldDestructor) {
          target[destructorName] = config._oldDestructor;
        }
      } //endregion
      //region Promise based workflow
      // experimental, used in tests to support async/await workflow

    }, {
      key: "await",
      value: function _await(eventName) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          checkLog: true,
          resetLog: true,
          args: null
        };
        var me = this;

        if (options === false) {
          options = {
            checkLog: false
          };
        }

        var _options = options,
            args = _options.args;
        return new Promise(function (resolve) {
          var _me$_triggered;

          // check if previously triggered?
          if (options.checkLog && ((_me$_triggered = me._triggered) === null || _me$_triggered === void 0 ? void 0 : _me$_triggered[eventName])) {
            // resolve immediately, no params though...
            resolve(); // reset log to be able to await again

            if (options.resetLog) {
              me.clearLog(eventName);
            }
          } // This branch will listen for events until catches one with specific arguments


          if (args) {
            var _me$on;

            var detacher = me.on((_me$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_me$on, eventName, function () {
              for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                params[_key3] = arguments[_key3];
              }

              var argsOk = Object.keys(args).every(function (key) {
                return key in params[0] && params[0][key] === args[key];
              });

              if (argsOk) {
                // resolve when event is fired with required arguments
                resolve.apply(void 0, params); // reset log to be able to await again

                if (options.resetLog) {
                  me.clearLog(eventName);
                }

                detacher();
              }
            }), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_me$on, "prio", -10000), _me$on));
          } else {
            var _me$on2;

            me.on((_me$on2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_me$on2, eventName, function () {
              // resolve when event is caught
              resolve.apply(void 0, arguments); // reset log to be able to await again

              if (options.resetLog) {
                me.clearLog(eventName);
              }
            }), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_me$on2, "prio", -10000), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_29___default()(_me$on2, "once", true), _me$on2));
          }
        });
      }
    }, {
      key: "clearLog",
      value: function clearLog(eventName) {
        if (this._triggered) {
          if (eventName) {
            delete this._triggered[eventName];
          } else {
            this._triggered = {};
          }
        }
      } //endregion
      //region Trigger

      /**
       * Wraps a function with event triggering. First triggers before[eventName] with the supplied eventObject. If it is
       * not prevented (by returning false) the supplied fn is called with the eventObject as first argument and any
       * optional arguments after that. It then triggers [eventName] with the eventObject (that might have been altered in
       * fn). Finally it returns the return value from the fn.
       * @param {String} eventName Event name, used to trigger 'beforeEventName' and 'eventName'
       * @param {Object} eventObject Passed when triggering events
       * @param {Function} fn Function to call if before is not prevented
       * @param {Array} args Arguments to pass to fn
       * @param {Boolean} quiet Specify true to not trigger events
       * @returns {*} Result returned from calling fn, or false if prevented
       * @internal
       */

    }, {
      key: "callPreventable",
      value: function callPreventable(eventName, eventObject, fn) {
        var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        var quiet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var me = this;

        if (!quiet && me.trigger('before' + _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].capitalize(eventName), eventObject) === false) {
          return false;
        }

        var result = fn.apply(void 0, [eventObject].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26___default()(args)));

        if (!quiet) {
          me.trigger(eventName, eventObject);
        }

        return result;
      }
      /**
       * Triggers an event, calling all registered listeners with the supplied arguments. Returning false from any listener
       * makes function return false.
       * @param {String} eventName Event name for which to trigger listeners
       * @param {Object} [param] Single parameter passed on to listeners, source property will be added to it (this)
       * @param {Boolean} [param.bubbles] Pass as `true` to indicate that the event will bubble up the widget
       * ownership hierarchy. For example up a Menu->parent Menu tree, or a Field->Container tree.
       * @returns {Boolean} Returns false if any listener returned false, otherwise true
       */

    }, {
      key: "trigger",
      value: function trigger(eventName, param) {
        var _me$eventListeners, _me$eventListeners2;

        // TODO: should returning false from a listener really prevent other listeners from executing?
        var me = this,
            name = eventName.toLowerCase(),
            eventsSuspended = me.eventsSuspended,
            relayAllTargets = me.relayAllTargets,
            callOnFunctions = me.callOnFunctions,
            owner = me.owner;
        var listeners = (_me$eventListeners = me.eventListeners) === null || _me$eventListeners === void 0 ? void 0 : _me$eventListeners[name]; // log trigger, used by experimental promise support to resolve immediately when needed

        if (!me._triggered) {
          me._triggered = {};
        }

        me._triggered[eventName] = true;

        if (eventsSuspended) {
          if (eventsSuspended.shouldQueue) {
            eventsSuspended.queue.push(arguments);
          }

          return true;
        } // Include catchall listener for all events.
        // Do not push the catchAll listeners onto the events own listener array.


        if ((_me$eventListeners2 = me.eventListeners) === null || _me$eventListeners2 === void 0 ? void 0 : _me$eventListeners2.catchall) {
          var _listeners;

          (_listeners = listeners = listeners ? listeners.slice() : []).push.apply(_listeners, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26___default()(me.eventListeners.catchall)); // The catchAll listeners must honour their prio settings.


          listeners.sort(priorityComparator);
        }

        if (!listeners && !relayAllTargets && !callOnFunctions) {
          return true;
        } // default to include source : this in param


        if (param) {
          if (!('source' in param)) {
            if (Object.isExtensible(param)) {
              param.source = me;
            } else {
              param = Object.setPrototypeOf({
                source: me
              }, param);
            }
          }
        } else {
          param = {
            source: me
          };
        } // Lowercased event name should be the "type" property in keeping with DOM events.


        if (param.type !== name) {
          // Create instance property because "type" is read only
          if (param.constructor !== Object) {
            Reflect.defineProperty(param, 'type', {
              get: function get() {
                return name;
              }
            });
          } else {
            param.type = name;
          }
        }

        if (callOnFunctions) {
          var fnName = 'on' + _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].capitalize(eventName);

          if (fnName in me) {
            me.callback(me[fnName], me, [param]); // See if the called function was injected into the instance
            // masking an implementation in the prototype.
            // we must call the class's implementation after the injected one.
            // unless it's an injected chained function, in which case it will have been called above.
            // Note: The handler may have resulted in destruction.

            if (!me.isDestroyed && Object.prototype.hasOwnProperty.call(me, fnName) && (!me.pluginFunctionChain || !me.pluginFunctionChain[fnName])) {
              var myProto = Object.getPrototypeOf(me);

              if (fnName in myProto) {
                myProto[fnName].call(me, param); // A handler may have resulted in destruction.

                if (me.isDestroyed) {
                  return;
                }
              }
            }
          }
        }

        if (listeners) {
          var i = 0,
              listener,
              handler,
              ret; // Let add/removeListener know that we're using the array to protect against a situation where an event
          // listener changes the listeners when triggering the event.

          listeners.$firing = true; // If any listener resulted in our destruction, abort.

          for (i; i < listeners.length && !me.isDestroyed && ret !== false; i++) {
            listener = listeners[i];
            var thisObj = listener.thisObj; // Listeners that have thisObj are auto removed when thisObj is destroyed. If thisObj is destroyed from
            // a listener we might still end up here, since listeners are sliced and not affected by the removal

            if (!thisObj || !thisObj.isDestroyed) {
              // Flag for the expiry timer
              listener.called = true;

              if (listener.once) {
                me.removeListener(name, listener);
              }

              if (typeof listener.fn === 'string') {
                if (thisObj) {
                  handler = thisObj[listener.fn];
                } // keep looking for the callback in the hierarchy


                if (!handler) {
                  var result = me.resolveCallback(listener.fn);
                  handler = result.handler;
                  thisObj = result.thisObj;
                }
              } else {
                handler = listener.fn;
              } // If listener was declared with args, send our param after them


              if (listener.args) {
                var _handler;

                ret = (_handler = handler).call.apply(_handler, [thisObj || me].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26___default()(listener.args), [param]));
              } else {
                ret = handler.call(thisObj || me, param);
              }
            }
          }

          listeners.$firing = false;

          if (ret === false) {
            return ret;
          }
        } // relay all?


        if (relayAllTargets) {
          relayAllTargets.forEach(function (config) {
            var name = eventName;
            if (config.transformCase) name = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].capitalize(name);
            if (config.prefix) name = config.prefix + name;
            if (config.through.trigger(name, param) === false) return false;
          });
        } // Use DOM standard event property name to indicate that the event
        // bubbles up the owner axis.
        // False from any handler cancels the bubble.
        // The owner prop was cached above in case any handlers destroyed this object.
        // Must also avoid owner if any handlers destroyed the owner.


        if (param.bubbles && owner && !owner.isDestroyed) {
          return owner.trigger(eventName, param);
        }

        return true;
      }
      /**
       * Prevents events from being triggered until {@link #function-resumeEvents()} is called. Optionally queues events that are triggered while
       * suspended. Multiple calls stack to require matching calls to `resumeEvents()` before actually resuming.
       * @param {Boolean} queue Specify true to queue events triggered while suspended
       */

    }, {
      key: "suspendEvents",
      value: function suspendEvents() {
        var queue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var eventsSuspended = this.eventsSuspended || (this.eventsSuspended = {
          shouldQueue: queue,
          queue: [],
          count: 0
        });
        eventsSuspended.count++;
      }
      /**
       * Resume event triggering after a call to {@link #function-suspendEvents()}. If any triggered events were queued they will be triggered.
       * @returns `true` if events have been resumed (multiple calls to suspend require an equal number of resume calls to resume).
       */

    }, {
      key: "resumeEvents",
      value: function resumeEvents() {
        var suspended = this.eventsSuspended;

        if (suspended) {
          if (--suspended.count === 0) {
            this.eventsSuspended = null;

            if (suspended.shouldQueue) {
              var _iterator = _createForOfIteratorHelper(suspended.queue),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var queued = _step.value;
                  this.trigger.apply(this, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26___default()(queued));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
          }
        }

        return !Boolean(this.eventsSuspended);
      } //endregion

    }, {
      key: "listeners",
      get: function get() {
        return this.eventListeners;
      }
    }], [{
      key: "setupDeprecatedEvents",
      value: function setupDeprecatedEvents(cls, meta) {
        var all = meta.getInherited('deprecatedEvents'),
            add = cls.deprecatedEvents;

        for (var eventName in add) {
          // Event names are case-insensitive so build our map using toLowerCase'd names (but keep true case too):
          all[eventName.toLowerCase()] = all[eventName] = add[eventName];
        }
      } //region Config

    }, {
      key: "setupClass",
      value: function setupClass(meta) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Events), "setupClass", this).call(this, meta);

        ['onListen', 'onUnlisten'].forEach(function (fn) {
          return Events.prototype[fn].$nullFn = true;
        });
      }
    }, {
      key: "$name",
      get: function get() {
        return 'Events';
      } //region Events

      /**
       * Fires before an object is destroyed.
       * @event beforeDestroy
       * @param {Object} source The Object that is being destroyed.
       */

      /**
       * Fires when an object is destroyed.
       * @event destroy
       * @param {Object} source The Object that is being destroyed.
       */
      //endregion

    }, {
      key: "declarable",
      get: function get() {
        return [
        /**
         * The list of deprecated events as an object, where `key` is an event name which is deprecated and
         * `value` is an object which contains values for
         * {@link Core.helper.VersionHelper#function-deprecate-static VersionHelper}:
         * - product {String} The name of the product;
         * - invalidAsOfVersion {String} The version where the offending code is invalid (when any compatibility
         *   layer is actually removed);
         * - message {String} Warning message to show to the developer using a deprecated API;
         *
         * For example:
         *
         * ```javascript
         * return {
         *     click : {
         *         product            : 'Grid',
         *         invalidAsOfVersion : '1.0.0',
         *         message            : 'click is deprecated!'
         *     }
         * }
         * ```
         *
         * @name deprecatedEvents
         * @returns {Object}
         * @static
         * @internal
         */
        'deprecatedEvents'];
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * The listener set for this object.
           *
           * Listeners can be specified in target class config and they will be merged with any
           * listeners specified in the instantiation config. Class listeners will be fired first:
           * ```
           * class MyStore extends Store({
           *     static get configurable() {
           *         listeners : {
           *             myCustomEvent() {
           *             },
           *             load : {
           *                 prio : 10000,
           *                 fn() { // this load listener handles things first }
           *             }
           *         }
           *     }
           * });
           *
           * let store = new MyStore({
           *   listeners: {
           *     load: () => { // This load listener runs after the class's },
           *     ...
           *   }
           * });
           * ```
           * @config {Object}
           * @category Common
           */
          listeners: {
            value: null,
            $config: {
              merge: function merge(newValue, currentValue) {
                if (newValue !== null) {
                  if (!newValue) {
                    return currentValue;
                  }

                  if (currentValue) {
                    newValue = newValue ? [newValue] : [];
                    newValue.push[isArray(currentValue) ? 'apply' : 'call'](newValue, currentValue);
                  }
                }

                return newValue;
              }
            }
          }
        };
      }
    }]);

    return Events;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_36__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/Factoryable.js":
/*!***************************************!*\
  !*** ./lib/Core/mixin/Factoryable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
























function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/mixin/Factoryable
 */

var defineProperty = Reflect.defineProperty,
    ownerSymbol = Symbol('owner'),
    typeSplitRe = /[\s,]+/;
/**
 * This mixin is applied to base classes of a type that will be dynamically created by type name aliases.
 * ```
 *  class Layout extends Base.mixin(Factoryable) {
 *      static get factoryable() {
 *          return {
 *              defaultType : 'default'
 *          };
 *      }
 *
 *      static get type() {
 *          return 'default';
 *      }
 *  }
 *
 *  class Fit extends Layout {
 *      static get type() {
 *          return 'fit';
 *      }
 *  }
 * ```
 *
 * Once a family of classes has been defined, instances are created using the `create()` method:
 * ```
 *  const layout = Layout.create(config);
 * ```
 *
 * In the above example, `config` can be a type name (such as "fit") or a config object with a `type` property that
 * holds the type name.
 *
 * Factories can also extend other factories. For example, one factory creates objects that are useful across a wide
 * range of consumers, and a second factory creates objects for a more specialized consumer. If that specialized
 * consumer can also consume objects from the first factory, then the second factory can specify this relationship:
 * ```
 *  class General extends Base.mixin(Factoryable) {
 *      ...
 *  }
 *
 *  class Specialized extends Base.mixin(Factoryable) {
 *      static get factoryable() {
 *          return {
 *              extends : General,
 *              ...
 *          };
 *      }
 *  }
 * ```
 * The `extends` factoryable option can be either a class that mixes in `Factoryable` or an array of such classes.
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(Factoryable, _ref);

    var _super = _createSuper(Factoryable);

    function Factoryable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, Factoryable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(Factoryable, null, [{
      key: "register",

      /**
       * Registers a class (`cls`) associated with the given `type`.
       * @param {String|String[]} type A string, array of strings or a comma-separated string containing the type names
       * for the specified `cls` class.
       * @param {Function} cls The class (constructor function)
       * @param {Boolean} [replace] Pass `true` to overwrite existing registered types. Otherwise, this method will throw
       * an exception if the `type` is already registered with this factory.
       * @internal
       */
      value: function register(type, cls) {
        var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var _this$initClass = this.initClass(),
            factoryable = _this$initClass.factoryable,
            caseless = factoryable.caseless,
            registry = factoryable.registry,
            types = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].split(type, typeSplitRe); // if type is a string[] it will just be returned


        for (var lower, name, i = 0; i < types.length; ++i) {
          name = types[i];
          lower = caseless ? name.toLowerCase() : name;

          if (!replace && lower in registry) {
            throw new Error("Type \"".concat(name, "\" already registered with ").concat(factoryable.class.name, " factory"));
          } // Ensure class being registered is initialized. (initClass returns the class)


          registry[name] = registry[lower] = cls.initClass();
        }
      }
      /**
       * Returns 'true` if the passed instance is of the passed type or of a derived class.
       * @param {Object} instance The object to test.
       * @param {String} type The type to test against
       */

    }, {
      key: "isA",
      value: function isA(instance, type) {
        return this.isType(instance, type, true);
      }
      /**
       * Returns 'true` if the passed instance is of the passed type.
       * @param {Object} instance The object to test.
       * @param {String} type The type to test against
       * @param {Boolean} [deep] Pass `true` to return `true` if the class is a subclass of the passed type.
       */

    }, {
      key: "isType",
      value: function isType(instance, type, deep) {
        var factoryable = this.factoryable,
            caseless = factoryable.caseless,
            registry = factoryable.registry,
            typeCls = registry[caseless ? type.toLowerCase() : type]; // If the type to be tested against maps to a class, see if the instance is an instanceof that

        if (typeCls) {
          if (deep) {
            return instance instanceof typeCls;
          }

          return instance.constructor === typeCls;
        }

        return false;
      }
    }, {
      key: "setupAlias",
      value: function setupAlias(cls) {
        cls.register(cls.alias, cls);
      }
    }, {
      key: "setupFactoryable",
      value: function setupFactoryable(cls, meta) {
        var superClass = meta.super.class;
        var factoryable = cls.factoryable;
        factoryable = _objectSpread({
          caseless: true,
          defaultType: null,
          extends: superClass.factoryable ? [superClass] : null,
          typeKey: 'type'
        }, factoryable);
        factoryable.class = cls;
        factoryable.registry = Object.create(null);

        if (factoryable.extends && !Array.isArray(factoryable.extends)) {
          factoryable.extends = [factoryable.extends];
        } // Replace the class/static getter with a new one that returns the complete factoryable object:


        defineProperty(cls, 'factoryable', {
          get: function get() {
            return factoryable;
          }
        });
      }
    }, {
      key: "setupType",
      value: function setupType(cls) {
        var type = cls.type;
        cls.register(type, cls); // Copy the static type property onto the prototype as a readonly property:

        defineProperty(cls.prototype, 'type', {
          value: type
        });
      }
      /**
       * Creates an instance from this factory, given the type name or a config object.
       * @param {String|Object} config The type name string or config object.
       * @param {String|Function|Object} [options] Creation options (for details see {@link #function-reconfigure-static}).
       * @returns {Object}
       */

    }, {
      key: "create",
      value: function create(config, options) {
        return this.reconfigure(null, config, options);
      }
      /**
       * Reconfigures an optional existing instance based on the provided config and returns the correctly configured
       * instance. This will be the `existingInstance` if the `config` does not specify a different type.
       *
       * If `config` is `null` (or simply falsy), this method will destroy the `existingInstance` (if any) and return
       * `null`.
       *
       * If there is no `existingInstance`, the config must specify a type. That is, it must be a string (the type name)
       * or an object containing a `type` property, the `defaultType` must be provided or the factory itself must have
       * a `defaultType` specified (see {@link #property-factoryable-static}).
       *
       * When an `existingInstance` is provided and a type is specified, the instance will be reconfigured via `setConfig`
       * if it is of that type. Otherwise, the `existingInstance` is destroyed (if it is owned by the `options.owner`)
       * and a new instance of the correct type is created.
       *
       * @param {Object} existingInstance The instance to reconfigure. This can be `null`.
       *
       * @param {String|Object} config The type name string or config object.
       *
       * @param {String|Function|Object} [options] Additional options to control the reconfiguration process. If this
       * value is a string or a class constructor, it treated as `options.type`. If this value is an class instance, it
       * is used as the `options.owner`. If this is a function, it is treated as `options.setup`. NOTE: functions declared
       * using the `function` keyword are equivalent to class constructors. Use an arrow function or a class method to
       * avoid this when a `setup` function is intended.
       *
       * @param {String|Function} [options.type] The default type to use if the `config` object does not specify a type.
       *
       * @param {Object} [options.owner] The owner of any created instances. If the `existingInstance` is being replaced,
       * this value determines if the instance will be destroyed.
       *
       * @param {Object} [options.defaults] A config object of default values to use when creating a new instance.
       *
       * @param {Function|String} [options.setup] A function or the name of a method (on the `options.owner`) to call
       * prior to creating a new instance. It is passed the config object that will be used to create the instance. If a
       * truthy value is returned, that value is passed to the constructor instead of the provided config object.
       *
       * @param {Function|String} [options.cleanup] A function or the name of a method (on the `options.owner`) to call
       * prior to destroying the `existingInstance`. The `existingInstance` is passed as the sole argument.
       *
       * @returns {Object} The reconfigured instance (either `existingInstance` or a new instance of the desired type)
       */

    }, {
      key: "reconfigure",
      value: function reconfigure(existingInstance, config, options) {
        var me = this,
            factoryable = me.factoryable,
            typeKey = factoryable.typeKey;
        var type = config,
            defaultType = options,
            cleanup,
            defaults,
            mergeType,
            owner,
            prepared,
            setup,
            t; // Pick apart the options and set the vars accordingly

        if (options && !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isClass(options)) {
          // if (options is not the defaultType)
          defaultType = null;
          t = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16___default()(options);

          if (t === 'function') {
            setup = options;
          } else if (t === 'string') {
            defaultType = options;
          } else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isObject(options)) {
            // TODO revert to
            //  ({ cleanup, defaults, owner, setup, type : defaultType } = options);
            //  after this issue is fixed https://github.com/bryntum/bryntum-suite/issues/1457
            cleanup = options.cleanup;
            defaults = options.defaults;
            owner = options.owner;
            setup = options.setup;
            defaultType = options.type;
          } else {
            owner = options;
          }
        } // Figure out config... it's either a type (string), a config object or the actual instance.


        if (typeof type === 'string') {
          config = {};
        } else if (config) {
          if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isObject(config)) {
            // If we are being given an instance (not a config object), discard or destroy the existingInstance
            if (owner && config !== existingInstance && (existingInstance === null || existingInstance === void 0 ? void 0 : existingInstance[ownerSymbol]) === owner) {
              var _cleanup;

              typeof cleanup === 'string' ? owner[cleanup](existingInstance) : (_cleanup = cleanup) === null || _cleanup === void 0 ? void 0 : _cleanup(existingInstance);
              existingInstance.destroy();
            }

            return config;
          }

          type = config[typeKey];
        }

        type = type && me.resolveType(type); // We've got our orders... make it so...

        if (existingInstance) {
          // We can have a type-less config object when reconfiguring an existing instance, but if we have a type,
          // the existingInstance must be of that type. If !config that means we are nulling out.
          if (config && (!type || existingInstance.constructor === type)) {
            if (typeKey in config) {
              config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({}, config);
              delete config[typeKey]; // so "type" won't be processed as a config property
            }

            existingInstance.setConfig(config);
            return existingInstance;
          }

          if (owner && existingInstance[ownerSymbol] === owner) {
            var _cleanup2;

            typeof cleanup === 'string' ? owner[cleanup](existingInstance) : (_cleanup2 = cleanup) === null || _cleanup2 === void 0 ? void 0 : _cleanup2(existingInstance);
            existingInstance.destroy();
          }
        }

        if (config) {
          if (defaults) {
            if (!(mergeType = type)) {
              if (!(mergeType = defaults[typeKey] || defaultType || factoryable.defaultType)) {
                throw new Error("No default mergeType defined for ".concat(factoryable.class.name, " factory"));
              }

              mergeType = me.resolveType(mergeType);
            }

            if (mergeType) {
              // Allow the merge fn of each config to perform the task:
              config = mergeType.mergeConfigs(defaults, config);
            }
          }

          if (setup) {
            prepared = typeof setup === 'string' ? owner[setup](config, type, defaults) : setup(config, type, defaults);

            if (prepared === null) {
              return prepared;
            }

            config = prepared || config;
          }

          if (!type) {
            // One more check on config[typeKey] since the setup() function may have added it...
            if (!(type = config[typeKey] || defaultType || factoryable.defaultType)) {
              throw new Error("No default type defined for ".concat(factoryable.class.name, " factory"));
            }

            type = me.resolveType(type);
          }

          if (defaults && !mergeType) {
            config = type.mergeConfigs(defaults, config);
          }

          if (typeKey in config) {
            config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({}, config);
            delete config[typeKey]; // so "type" won't be processed as a config property
          }

          config = new type(config);

          if (owner) {
            config[ownerSymbol] = owner;
          }
        }

        return config || null;
      }
      /**
       * This method returns the constructor of the class registered for the given type name.
       * @param {String} type The type name to look up.
       * @param {Boolean} [optional] Pass `true` to return `null` if `type` is not found instead of throwing an exception.
       * @returns {Function}
       * @private
       */

    }, {
      key: "resolveType",
      value: function resolveType(type, optional) {
        if (typeof type !== 'string') {
          return type;
        }

        var factoryable = this.factoryable,
            bases = factoryable.extends;
        var result = factoryable.registry[factoryable.caseless ? type.toLowerCase() : type],
            i;

        for (i = 0; !result && bases && i < bases.length; ++i) {
          // Pass optional=true to base factory so the error is our own should the lookup fail:
          result = bases[i].resolveType(type,
          /* optional = */
          true);
        }

        if (!result && !optional) {
          throw new Error("Invalid type name \"".concat(type, "\" passed to ").concat(factoryable.class.name, " factory"));
        }

        return result;
      }
    }, {
      key: "$name",
      get: function get() {
        return 'Factoryable';
      }
    }, {
      key: "declarable",
      get: function get() {
        return [
        /**
         * This property getter returns options that control the factory process. This property getter must be
         * defined by the class that mixes in `Factoryable` in order to initialize the factory properly.
         * ```
         *  static get factoryable() {
         *      return {
         *          defaultType : 'default'
         *      };
         *  }
         * ```
         * If there are no special options to provide, this method can return nothing (`undefined`):
         * ```
         *  static get factoryable() {
         *      // initialize the factory with all default options
         *  }
         * ```
         * @static
         * @member {Object} factoryable
         * @property {Boolean} [factoryable.caseless=true] Specify `false` to use case-sensitive type names. The
         * default is to ignore case.
         * @property {String} [factoryable.defaultType=null] The default type to create when a config object has
         * no `typeKey` property.
         * @property {Function|Function[]} [factoryable.extends] One or more classes that mix in `Factoryable` to
         * use for resolving type names when a type name is not found in this factory.
         * @property {String} [factoryable.typeKey='type'] The name of the proprerty in a config object that holds
         * the type name.
         * @internal
         */
        'factoryable',
        /**
         * One or more additional type name aliases for this class. This can be useful for renaming and maintaining
         * a previous type name.
         * ```
         *  class Fit extends Layout {
         *      static get type() {
         *          return 'fit';
         *      }
         *
         *      static get alias() {
         *          return 'fill';  // deprecated type name (now known as 'fit')
         *      }
         *  }
         * ```
         * @static
         * @member {String|String[]} alias
         * @internal
         */
        'alias',
        /**
         * The (canonical) type name for this class by which instances can be created using the static
         * {@link #function-create-static create()} method.
         * @static
         * @member {String} type
         */
        'type'];
      }
    }]);

    return Factoryable;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_23__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/Featureable.js":
/*!***************************************!*\
  !*** ./lib/Core/mixin/Featureable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");



















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/mixin/Featureable
 */

/**
 * This mixin provides management of a set of features that can be manipulated via the `features` config.
 *
 * The first step in using `Featureable` is to define the family of features using `Factoryable` to declare a base
 * class for features to extend:
 * ```
 *  class SuperWidgetFeature extends InstancePlugin.mixin(Factoryable) {
 *      static get factoryable() {
 *          //
 *      }
 *  }
 * ```
 *
 * The various feature classes extend the `SuperWidgetFeature` base class and call `initClass()` to register themselves:
 * ```
 *  export default class AmazingSuperWidgetFeature extends SuperWidgetFeature {
 *      static get type() {
 *          return 'amazing';
 *      }
 *  }
 *
 *  AmazingSuperWidgetFeature.initClass();
 * ```
 *
 * A class that supports these features via `Featureable` is declared like so:
 * ```
 *  class SuperWidget extends Widget.mixin(Featureable) {
 *      static get featureable() {
 *          return {
 *              factory : SuperWidgetFeature
 *          };
 *      }
 *
 *      static get configurable() {
 *          return {
 *              // Declare the default features. These can be disabled by setting them to a falsy value. Using
 *              // configurable(), the value defined by this class is merged with values defined by derived classes
 *              // and ultimately the instance.
 *              features : {
 *                  amazing : {
 *                      ...
 *                  }
 *              }
 *          };
 *      }
 *  }
 *```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(Featureable, _ref);

    var _super = _createSuper(Featureable);

    function Featureable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default()(this, Featureable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default()(Featureable, [{
      key: "afterConfigure",
      value: function afterConfigure() {
        var _this$$features;

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Featureable.prototype), "afterConfigure", this).call(this);

        (_this$$features = this.$features) === null || _this$$features === void 0 ? void 0 : _this$$features.flush();
      }
    }, {
      key: "doDestroy",
      value: function doDestroy() {
        this.features = null;

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Featureable.prototype), "doDestroy", this).call(this);
      }
      /**
       * Returns `true` if the specified feature is active for this instance and `false` otherwise.
       * @param {String} name The feature name
       * @returns {Boolean}
       */

    }, {
      key: "hasFeature",
      value: function hasFeature(name) {
        var _this$features;

        return Boolean((_this$features = this.features) === null || _this$features === void 0 ? void 0 : _this$features[name]);
      }
    }, {
      key: "changeFeatures",
      value: function changeFeatures(features) {
        var me = this,
            featureable = me.constructor.featureable,
            manager = me.$features || (me.$features = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_19__["default"]({
          factory: featureable.factory,
          owner: me,
          ownerName: featureable.ownerName
        }));
        manager.update(features); // Normally we wait for afterConfigure to create all the features, but if we are being called after that
        // point in the life cycle, we need to flush them out now. We still use the same delay technique in case the
        // user adds multiple features dynamically.

        if (!me.isConfiguring) {
          manager.flush();
        }

        return manager.target;
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "setupFeatureable",
      value: function setupFeatureable(cls) {
        var featureable = _objectSpread({
          ownerName: 'client'
        }, cls.featureable);

        featureable.factory.initClass(); // Replace the class/static getter with a new one that returns the complete featureable object:

        Reflect.defineProperty(cls, 'featureable', {
          get: function get() {
            return featureable;
          }
        });
      }
    }, {
      key: "$name",
      get: function get() {
        return 'Featureable';
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * Specifies the features to create and associated with the instance. The keys of this object are the names
           * of features. The values are config objects for those feature instances.
           *
           * After construction, this property can be used to access the feature instances and even reconfigure them.
           *
           * For example:
           * ```
           *  instance.features.amazing = {
           *      // reconfigure this feature
           *  }
           * ```
           * This can also be done in bulk:
           * ```
           *  instance.features = {
           *      amazing : {
           *          // reconfigure this feature
           *      },
           *      // reconfigure other features
           *  }
           * ```
           * @config {Object}
           */
          features: null
        };
      }
    }, {
      key: "declarable",
      get: function get() {
        return [
        /**
         * This property getter returns options that control feature management for the derived class. This
         * property getter must be defined by the class that mixes in `Featureable` in order to initialize the
         * class properly.
         * ```
         *  class SuperWidget extends Widget.mixin(Featureable) {
         *      static get featureable() {
         *          return {
         *              factory : SuperWidgetFeature
         *          };
         *      }
         *      ...
         *  }
         * ```
         * @static
         * @member {Object} featureable
         * @property {Core.mixin.Factoryable} featureable.factory The factoryable class (not one of its instances)
         * that will be used to create feature instances.
         * @property {String} [featureable.ownerName='client'] The config or property to assign on each feature as
         * a reference to its creator, the `Featureable` instance.
         * @internal
         */
        'featureable'];
      }
    }]);

    return Featureable;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_18__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/Finalizable.js":
/*!***************************************!*\
  !*** ./lib/Core/mixin/Finalizable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/mixin/Finalizable
 */

/**
 * This mixin provides an asynchronous completion mechanism. This allows a process to coordinate its async actions
 * (such as Ajax requests or user interaction) with cleanup.
 *
 * Consider a context tracking helper class, for example:
 * ```
 *  class Context extends Base.mixin(Finalizable) {
 *      // ...
 *
 *      async finish() {
 *          this.owner.trigger('finish', {
 *              context : this
 *          });
 *
 *          // Wait for any scheduled finalizer to run...
 *          await this.finalize();
 *      }
 *
 *      doFinalize() {
 *          this.destroy();
 *      }
 *  }
 * ```
 *
 * When the `finish` event is processed, the receiver can register a promise for whatever processing it would like to
 * perform:
 * ```
 *  class Foo {
 *      onFinish({ context }) {
 *          context.finalizer = this.askUser(context);
 *      }
 *
 *      async askUser(context) {
 *          //
 *      }
 *  }
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(Finalizable, _ref);

    var _super = _createSuper(Finalizable);

    function Finalizable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Finalizable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Finalizable, [{
      key: "construct",
      value: function construct() {
        var _get2;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Finalizable.prototype), "construct", this)).call.apply(_get2, [this].concat(args));
        /**
         * This property can be set any time prior to calling {@link #function-finalize} (i.e., when the
         * {@link #property-isFinalizing} property goes to `true`). When set, this instance will `await` this
         * promise before completing the finalization process by calling {@link #function-doFinalize}.
         * @member {Promise} finalizer
         */


        this.finalizer = null;
        /**
         * This property holds the `Promise` that will resolve when {@link #function-finalize} has completed. It is
         * set when {@link #function-finalize} is called and cleared on return.
         * @member {Boolean} finalizing
         * @readonly
         * @private
         */

        this.finalizing = null;
        /**
         * This property is `true` once the instance completes the {@link #function-finalize} method.
         * @member {Boolean} isFinalized
         * @readonly
         */

        this.isFinalized = false;
        /**
         * This property is set to `true` when {@link #function-finalize} is called.
         * @member {Boolean} isFinalizing
         * @readonly
         */

        this.isFinalizing = false;
      }
      /**
       * This template method is called at the end of {@link #function-finalize}. By default it calls `destroy()`, but
       * can be replaced by the derived class. This can be useful if it is not the `Finalizable` instance that awaits
       * the {@link #function-finalize} method.
       */

    }, {
      key: "doFinalize",
      value: function doFinalize() {
        this.destroy();
      }
      /**
       * This method is called (typically by this instance or its owner) to cleanup this instance while possibly first
       * waiting for the {@link #property-finalizer} promise to settle. Once settled, the {@link #function-doFinalize}
       * method is called.
       * @async
       */

    }, {
      key: "finalize",
      value: function finalize() {
        var me = this;
        var ret = me.finalizing;

        if (!ret && !me.isFinalized) {
          me.isFinalizing = true; // note: we never clear this flag (use isFinalized to know if we're done)
          // If we are called during finalization, we want to return the same promise, so we cache it away.

          me.finalizing = ret = me._awaitFinalizer();
        }

        return ret;
      }
    }, {
      key: "_awaitFinalizer",
      value: function () {
        var _awaitFinalizer2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee() {
          var me;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  me = this;
                  _context.prev = 1;
                  _context.next = 4;
                  return me.finalizer;

                case 4:
                  _context.prev = 4;
                  // be sure we clean up even if an exception is thrown by the finalizer...
                  me.finalizing = null;
                  me.isFinalized = true;
                  me.doFinalize();
                  return _context.finish(4);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[1,, 4, 9]]);
        }));

        function _awaitFinalizer() {
          return _awaitFinalizer2.apply(this, arguments);
        }

        return _awaitFinalizer;
      }()
    }], [{
      key: "$name",
      get: function get() {
        return 'Finalizable';
      }
    }]);

    return Finalizable;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_13__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/Hoverable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Hoverable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Delayable_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");














var _EDGE_CLASSES;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


 // Remove this once https://github.com/eslint/eslint/issues/12822 is address (allowing "foo?.bar()" to be accepted):

/* eslint-disable no-unused-expressions */

/**
 * @module Core/mixin/Hoverable
 */

var EDGES = {
  e: 'b-hover-edge',
  t: 'b-hover-top',
  r: 'b-hover-right',
  b: 'b-hover-bottom',
  l: 'b-hover-left'
},
    EDGE_CLASSES = (_EDGE_CLASSES = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_EDGE_CLASSES, EDGES.e, 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_EDGE_CLASSES, EDGES.t, 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_EDGE_CLASSES, EDGES.r, 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_EDGE_CLASSES, EDGES.b, 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_EDGE_CLASSES, EDGES.l, 1), _EDGE_CLASSES),
    ZONES = {
  t: [EDGES.e, EDGES.t],
  r: [EDGES.e, EDGES.r],
  b: [EDGES.e, EDGES.b],
  l: [EDGES.e, EDGES.l],
  tr: [EDGES.e, EDGES.t, EDGES.r],
  bl: [EDGES.e, EDGES.b, EDGES.l],
  tl: [EDGES.e, EDGES.t, EDGES.l],
  br: [EDGES.e, EDGES.b, EDGES.r]
};
/**
 * This mixin provides mouse hover tracking.
 * ```
 *  class Tracker extends Base.mixin(Hoverable) {
 *      hoverEnter(leaving) {
 *          // this.hoverTarget has been entered from "leaving"
 *          // this.hoverTarget will never be null, but leaving may be null
 *      }
 *
 *      hoverLeave(leaving) {
 *          // this.hoverTarget has been entered from "leaving"
 *          // this.hoverTarget may be null, but leaving will never be null
 *      }
 *
 *      hoverMove(event) {
 *          // called when a mousemove is made within a hover target
 *          // this.hoverTarget will never be null
 *      }
 *  }
 *
 *  let tracker = new Tracker({
 *      hoverRootElement : document.body,
 *      hoverSelector    : '.hoverable'
 *  });
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target$mixin) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Hoverable, _Target$mixin);

    var _super = _createSuper(Hoverable);

    function Hoverable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Hoverable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Hoverable, [{
      key: "hoverEnter",
      //endregion
      //region State Handling

      /**
       * This method is called when the cursor enters the {@link #config-hoverTarget}. The `hoverTarget` will not be
       * `null`.
       * @param {HTMLElement} leaving The element that was previously the `hoverTarget`. This value may be null.
       */
      value: function hoverEnter(leaving) {// template
      }
      /**
       * This method should return true if the given `element` should be ignored. By default, this is `true` if the
       * `element` is contained inside the {@link #config-hoverIgnoreElement}.
       * @param {HTMLElement} element
       * @returns {Boolean}
       * @protected
       */

    }, {
      key: "hoverIgnore",
      value: function hoverIgnore(element) {
        var _this$hoverIgnoreElem;

        return (_this$hoverIgnoreElem = this.hoverIgnoreElement) === null || _this$hoverIgnoreElem === void 0 ? void 0 : _this$hoverIgnoreElem.contains(element);
      }
      /**
       * This method is called when the cursor leaves the {@link #config-hoverTarget}. The `hoverTarget` may be `null`
       * or refer to the new `hoverTarget`
       * @param {HTMLElement} leaving The element that was previously the `hoverTarget`. This value will not be null.
       */

    }, {
      key: "hoverLeave",
      value: function hoverLeave(leaving) {// template
      }
      /**
       * This method is called when the mouse moves within a {@link #config-hoverTarget}, but only if enabled by the
       * {@link #config-hoverTrack} config.
       * @param {Event} event
       */

    }, {
      key: "hoverMove",
      value: function hoverMove(event) {// template
      } //endregion
      //region Events

    }, {
      key: "onHoverMouseMove",
      value: function onHoverMouseMove(event) {
        var me = this,
            hoverEdges = me.hoverEdges,
            hoverEdgeSize = me.hoverEdgeSize,
            hoverTarget = me.hoverTarget;

        if (hoverTarget) {
          if (hoverEdges) {
            var _hoverTarget$getBound = hoverTarget.getBoundingClientRect(),
                top = _hoverTarget$getBound.top,
                left = _hoverTarget$getBound.left,
                width = _hoverTarget$getBound.width,
                height = _hoverTarget$getBound.height,
                right = _hoverTarget$getBound.right,
                bottom = _hoverTarget$getBound.bottom,
                clientX = event.clientX,
                clientY = event.clientY,
                centerX = left + width / 2,
                centerY = top + height / 2,
                t = clientY < (hoverEdgeSize ? top + hoverEdgeSize : centerY),
                r = clientX >= (hoverEdgeSize ? right - hoverEdgeSize : centerX),
                b = clientY >= (hoverEdgeSize ? bottom - hoverEdgeSize : centerY),
                l = clientX < (hoverEdgeSize ? left + hoverEdgeSize : centerX),
                tb = t || b ? t ? 't' : 'b' : '',
                rl = r || l ? r ? 'r' : 'l' : '';

            me.hoverZone = (hoverEdges.includes(tb) ? tb : '') + (hoverEdges.includes(rl) ? rl : '');
          }

          me.hoverEvent = event;
          me.hoverTrack && me.hoverMove(event);
        }
      }
    }, {
      key: "onHoverMouseOver",
      value: function onHoverMouseOver(event) {
        this.hoverEvent = event;
        this.hoverElement = event.target;
      }
    }, {
      key: "onHoverMouseOut",
      value: function onHoverMouseOut(event) {
        this.hoverEvent = event;
        this.hoverElement = event.relatedTarget;
      } //endregion
      //region Configs
      // hoverDelay

    }, {
      key: "updateHoverDelay",
      value: function updateHoverDelay(delay) {
        this.setHoverTarget.delay = delay;
      } // hoverEdges

    }, {
      key: "changeHoverEdges",
      value: function changeHoverEdges(edges) {
        return edges === true ? 'trbl' : (edges || '').replace('v', 'tb').replace('h', 'lr');
      }
    }, {
      key: "updateHoverEdges",
      value: function updateHoverEdges() {
        this.syncHoverListeners();
      } // hoverElement

    }, {
      key: "changeHoverElement",
      value: function changeHoverElement(element) {
        if (!this.hoverIgnore(element)) {
          return element;
        }
      }
    }, {
      key: "updateHoverElement",
      value: function updateHoverElement(hoverEl) {
        var hoverSelector = this.hoverSelector;

        if (hoverSelector) {
          var _hoverEl;

          hoverEl = (_hoverEl = hoverEl) === null || _hoverEl === void 0 ? void 0 : _hoverEl.closest(hoverSelector);
        }

        this.setHoverTarget(hoverEl); // this may be delayed
      } // hoverRootElement

    }, {
      key: "updateHoverRootElement",
      value: function updateHoverRootElement(rootEl, was) {
        var hoverRootCls = this.hoverRootCls;

        if (hoverRootCls) {
          was === null || was === void 0 ? void 0 : was.classList.remove(hoverRootCls);
          rootEl === null || rootEl === void 0 ? void 0 : rootEl.classList.add(hoverRootCls);
        }

        this.syncHoverListeners();
      } // hoverTarget

    }, {
      key: "changeHoverTarget",
      value: function changeHoverTarget(hoverEl, was) {
        if (was) {
          this.hoverZone = null;
        }

        return hoverEl;
      }
    }, {
      key: "updateHoverTarget",
      value: function updateHoverTarget(hoverEl, was) {
        var me = this,
            hoverCls = me.hoverCls,
            hoverAnimationCls = me.hoverAnimationCls,
            hoverRootActiveCls = me.hoverRootActiveCls,
            hoverRootElement = me.hoverRootElement;

        if (hoverRootActiveCls) {
          hoverRootElement === null || hoverRootElement === void 0 ? void 0 : hoverRootElement.classList[hoverEl ? 'add' : 'remove'](hoverRootActiveCls);
        }

        if (was) {
          hoverCls && was.classList.remove(hoverCls);
          hoverAnimationCls && was.classList.remove(hoverAnimationCls);
          me.hoverLeave(was);
        }

        if (hoverEl) {
          hoverCls && hoverEl.classList.add(hoverCls);
          me.hoverEnter(was);

          if (me.hoverTrack) {
            me.hoverMove(me.hoverEvent);
          }

          if (hoverAnimationCls) {
            hoverEl.getBoundingClientRect(); // force layout so next change starts animation

            hoverEl.classList.add(hoverAnimationCls);
          }
        }
      } // hoverTrack

    }, {
      key: "updateHoverTrack",
      value: function updateHoverTrack() {
        this.syncHoverListeners();
      } // hoverZone

    }, {
      key: "updateHoverZone",
      value: function updateHoverZone(zone) {
        var hoverAnimationCls = this.hoverAnimationCls,
            hoverTarget = this.hoverTarget;

        if (hoverTarget) {
          var className = hoverTarget.className,
              cls = _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_14__["default"].change(className,
          /* add= */
          zone ? ZONES[zone] : null,
          /* remove= */
          EDGE_CLASSES);

          if (className !== cls) {
            hoverTarget.className = cls;

            if (zone && hoverAnimationCls) {
              hoverTarget.classList.remove(hoverAnimationCls);
              hoverTarget.getBoundingClientRect(); // force layout so next change starts animation

              hoverTarget.classList.add(hoverAnimationCls);
            }
          }
        }
      } //endregion
      //region Misc

    }, {
      key: "setHoverTarget",
      value: function setHoverTarget(target) {
        // this method runs later based on the hoverDelay
        this.hoverTarget = target;
      }
    }, {
      key: "syncHoverListeners",
      value: function syncHoverListeners() {
        var _me$_hoverRootDetache;

        var me = this,
            element = me.hoverRootElement,
            listeners = {
          element: element,
          thisObj: me,
          mouseover: 'onHoverMouseOver',
          mouseout: 'onHoverMouseOut'
        };

        if (me.hoverTrack || me.hoverEdges) {
          listeners.mousemove = 'onHoverMouseMove';
        }

        (_me$_hoverRootDetache = me._hoverRootDetacher) === null || _me$_hoverRootDetache === void 0 ? void 0 : _me$_hoverRootDetache.call(me);
        me._hoverRootDetacher = element && _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].on(listeners);
      } //endregion

    }], [{
      key: "$name",
      get: function get() {
        return 'Hoverable';
      } //region Configs

    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * A CSS class to add to the {@link #config-hoverTarget target} element.
           * @config {String}
           */
          hoverCls: null,

          /**
           * A CSS class to add to the {@link #config-hoverTarget target} element to enable CSS animations. This class
           * is added after calling {@link #function-hoverEnter}.
           * @config {String}
           */
          hoverAnimationCls: null,

          /**
           * A CSS class to add to the {@link #config-hoverRootElement root} element.
           * @config {String}
           */
          hoverRootCls: null,

          /**
           * A CSS class to add to the {@link #config-hoverRootElement root} element when there is an active
           * {@link #config-hoverTarget target}.
           * @config {String}
           */
          hoverRootActiveCls: null,

          /**
           * The number of milliseconds to delay notification of changes in the {@link #config-hoverTarget}.
           * @config {Number}
           */
          hoverDelay: null,

          /**
           * The current element that the cursor is inside as determined by `mouseover` and `mouseout`. Changes in
           * this config trigger re-evaluation of the {@link #config-hoverSelector} to determine if there is a
           * {@link #config-hoverTarget}.
           * @config {HTMLElement}
           * @private
           */
          hoverElement: null,

          /**
           * An element to ignore. Mouse entry into this element will not trigger a change in either of the
           * {@link #config-hoverElement} or {@link #config-hoverTarget} values.
           * @config {HTMLElement}
           */
          hoverIgnoreElement: null,

          /**
           * This property is a string containing one character for each edge that is hoverable. For example, a
           * value of "tb" indicates that the top and bottom edges are hoverable.
           * @config {String}
           */
          hoverEdges: null,

          /**
           * When {@link #config-hoverEdges} is used, this value determines the size (in pixels) of the edge. When
           * the cursor is within this number of pixels of an edge listed in `hoverEdges`, the appropriate CSS class
           * is added to the {@link #config-hoverTarget}:
           *
           *  - `b-hover-top`
           *  - `b-hover-right`
           *  - `b-hover-bottom`
           *  - `b-hover-left`
           *
           * Depending on the values of `hoverEdges`, it is possible to have at most two of these classes present at
           * any one time (when the cursor is in a corner).
           * @config {Number}
           * @default
           */
          hoverEdgeSize: 10,

          /**
           * The outer element where hover tracking will operate (attach events to it and use as root limit when
           * looking for ancestors).
           *
           * A common choice for this will be `document.body`.
           * @config {HTMLElement}
           */
          hoverRootElement: {
            $config: 'nullify',
            value: null
          },

          /**
           * A selector for the [closest](https://developer.mozilla.org/en-US/docs/Web/API/Element/closest) API to
           * determine the actual element of interest. This selector is used to process changes to the
           * {@link #config-hoverElement} to determine the {@link #config-hoverTarget}.
           * @config {String}
           */
          hoverSelector: null,

          /**
           * The currently active hover target. This will be the same as {@link #config-hoverElement} unless there is
           * a {@link #config-hoverSelector}.
           * @config {HTMLElement}
           */
          hoverTarget: {
            $config: 'nullify',
            value: null
          },

          /**
           * Set to `true` to include tracking of `mousemove` events for the active {@link #config-hoverTarget}. This
           * is required for the {@link #function-hoverMove} method to be called.
           * @config {Boolean}
           * @default false
           */
          hoverTrack: null,

          /**
           * A string value containing one character per active edge (e.g., "tr").
           * @config {String}
           * @private
           */
          hoverZone: null
        };
      }
    }, {
      key: "delayable",
      get: function get() {
        return {
          setHoverTarget: 0
        };
      }
    }]);

    return Hoverable;
  }(Target.mixin(_Delayable_js__WEBPACK_IMPORTED_MODULE_13__["default"]));
});

/***/ }),

/***/ "./lib/Core/mixin/Identifiable.js":
/*!****************************************!*\
  !*** ./lib/Core/mixin/Identifiable.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/mixin/Identifiable
 */

var idCounts = Object.create(null),
    idTypes = {
  string: 1,
  number: 1
};
/**
 * A mixin which provides identifier services such as auto-creation of `id`s and registration and
 * lookup of instances by `id`.
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Identifiable, _ref);

    var _super = _createSuper(Identifiable);

    function Identifiable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Identifiable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Identifiable, [{
      key: "doDestroy",
      value: function doDestroy() {
        this.constructor.unregisterInstance(this);

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Identifiable.prototype), "doDestroy", this).call(this);
      }
      /**
       * This is called when the `id` config is assigned (via the setter).
       * @param {String} id The new id being assigned.
       * @param {String} oldId The old id (previously assigned) or `null`.
       * @private
       */

    }, {
      key: "changeId",
      value: function changeId(id, oldId) {
        var me = this;

        if (oldId) {
          me.hasGeneratedId = false;
          me.constructor.unregisterInstance(me); // uses me.id
        }

        id = id || me.generateAutoId();
        me.constructor.registerInstance(me, id);
        return id;
      }
      /**
       * This method generates an id for this instance.
       * @returns {String}
       * @private
       */

    }, {
      key: "generateAutoId",
      value: function generateAutoId() {
        this.hasGeneratedId = true;
        return this.constructor.generateId("b-".concat(this.$$name.toLowerCase(), "-"));
      }
      /**
       * Generate a new id, using an internal counter and a prefix.
       * @param {String} prefix Id prefix
       * @returns {String} Generated id
       */

    }], [{
      key: "setupIdentifiable",
      value: function setupIdentifiable(cls, meta) {
        var identifiable = cls.identifiable;
        identifiable.idMap = Object.create(null);
        Reflect.defineProperty(cls, 'identifiable', {
          get: function get() {
            return identifiable;
          }
        });
      }
    }, {
      key: "generateId",
      value: function generateId() {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'generatedId';
        // This produces "b-foo-1, b-foo-2, ..." for each prefix independently of the others. In other words, it makes
        // id's more stable since the counter is on a per-class basis.
        return prefix + (idCounts[prefix] = (idCounts[prefix] || 0) + 1);
      }
    }, {
      key: "registerInstance",
      value: function registerInstance(instance) {
        var instanceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : instance.id;
        var me = this,
            idMap = me.identifiable.idMap; // Code editor sets `disableThrow` to not get conflicts when loading the same module again

        if (instanceId in idMap && !me.disableThrow) {
          throw new Error('Id ' + instanceId + ' already in use');
        }

        idMap[instanceId] = instance;
      }
      /**
       * Unregister Identifiable instance, normally done on destruction
       * @param {Object} instance Object to unregister
       */

    }, {
      key: "unregisterInstance",
      value: function unregisterInstance(instance) {
        var idMap = this.identifiable.idMap; // ID may be passed, for example if the instance is destroyed and can no longer yield an id.

        if (idTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default()(instance)]) {
          delete idMap[instance];
        } else {
          // Have to check for identity in case another instance by the same id has been created.
          // Allow that to be overridden. Stores have always just evicted the previous owner of their IDs
          if (idMap[instance.id] === instance) {
            delete idMap[instance.id];
          }
        }
      }
    }, {
      key: "getById",
      value: function getById(id) {
        var idMap = this.identifiable.idMap;

        if (idMap) {
          return idMap[id];
        }
      }
    }, {
      key: "$name",
      get: function get() {
        return 'Identifiable';
      }
    }, {
      key: "declarable",
      get: function get() {
        return ['identifiable'];
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * The id of this object.  If not specified one will be generated. Also used for lookups through the
           * static `getById` of the class which mixes this in. An example being {@link Core.widget.Widget}.
           *
           * For a {@link Core.widget.Widget Widget}, this is assigned as the `id` of the DOM
           * {@link Core.widget.Widget#config-element element} and must be unique across all elements
           * in the page's `document`.
           * @config {String}
           * @category DOM
           */
          id: ''
        };
      }
    }, {
      key: "registeredInstances",
      get: function get() {
        var idMap = this.identifiable.idMap;
        return idMap ? Object.values(idMap) : [];
      }
    }]);

    return Identifiable;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/InstancePlugin.js":
/*!******************************************!*\
  !*** ./lib/Core/mixin/InstancePlugin.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InstancePlugin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");

























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/mixin/InstancePlugin
 */

function getDescriptor(me, fnName) {
  var property = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(me), fnName);
  return property && (property.get || property.set) ? property : null;
}
/**
 * Base class for plugins. Published functions will be available from the other class. `this` in published functions is
 * referenced to the plugin, access the other class using `this.client`.
 *
 * Observe that plugin doesn't apply itself on class level but instead on instance level. Plugin is its own instance
 * that can have own functions and data that is not exposed to target class.
 *
 * Functions can be published in four ways:
 *
 * * `assign` (when function is not already available on target)
 * * `before` (when function is already available on target, will be called before original function)
 * * `after` (when function is already available on target, will be called after original function)
 * * `override` (replaces function on target, but old function can be reached)
 *
 * To configure which functions get published and in what way, specify `pluginConfig` getter on plugin:
 *
 * ```
 * class Sort extends InstancePlugin {
 *   static get pluginConfig {
 *      return {
 *          before   : ['init'],
 *          after    : ['destroy', 'onElementClick'],
 *          override : ['render']
 *      };
 *   }
 * }
 * ```
 * @extends Core/Base
 * @mixes Core/localization/Localizable
 * @mixes Core/mixin/Events
 */


var InstancePlugin = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default()(InstancePlugin, _Base$mixin);

  var _super = _createSuper(InstancePlugin);

  function InstancePlugin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, InstancePlugin);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(InstancePlugin, [{
    key: "getFocusRevertTarget",
    // We can act as an owner of a widget, so must be able to participate in focus reversion
    value: function getFocusRevertTarget() {
      var _this$client;

      return (_this$client = this.client) === null || _this$client === void 0 ? void 0 : _this$client.getFocusRevertTarget();
    }
  }, {
    key: "construct",
    value: function construct() {
      var me = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var plugInto = args[0],
          config = args[1],
          listeners; // When called with one argument (a config object), grab the "client" from the config object.

      if (args.length === 1) {
        if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isObject(plugInto)) {
          config = plugInto;
          plugInto = config.client;
        }
      } // Two args, so client is the first. Ensure the config doesn't contain a client property.
      else {
          config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].assign({}, config);
          delete config.client;
        }

      me.client = plugInto;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(InstancePlugin.prototype), "construct", this).call(this, config);

      me.applyPluginConfig(plugInto);
      listeners = me.clientListeners;

      if (listeners) {
        listeners = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].assign({}, listeners);
        listeners.thisObj = me;
        plugInto.on(listeners);
      }
    }
    /**
     * Applies config as found in plugInto.pluginConfig, or published all if no config found.
     * @private
     * @param plugInto Target instance to plug into
     */

  }, {
    key: "applyPluginConfig",
    value: function applyPluginConfig(plugInto) {
      var me = this,
          config = me.pluginConfig || me.constructor.pluginConfig;

      if (config) {
        var assign = config.assign,
            chain = config.chain,
            after = config.after,
            before = config.before,
            override = config.override;
        assign && me.applyAssign(plugInto, assign);
        (chain || after) && me.applyChain(plugInto, chain || after);
        before && me.applyChain(plugInto, before, false);
        override && me.applyOverride(plugInto, override);
      }
    }
    /**
     * Applies assigning for specified functions.
     * @private
     * @param plugInto
     * @param fnNames
     */

  }, {
    key: "applyAssign",
    value: function applyAssign(plugInto, fnNames) {
      var _this = this;

      fnNames.forEach(function (fnName) {
        return _this.assign(plugInto, fnName);
      });
    }
    /**
     * Applies chaining for specified functions.
     * @private
     * @param plugInto
     * @param functions
     * @param after
     */

  }, {
    key: "applyChain",
    value: function applyChain(plugInto, functions) {
      var after = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (Array.isArray(functions)) {
        var _iterator = _createForOfIteratorHelper(functions),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var fnName = _step.value;
            this.chain(plugInto, fnName, fnName, after);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        for (var intoName in functions) {
          this.chain(plugInto, intoName, functions[intoName], after);
        }
      }
    }
    /**
     * Applies override for specified functions.
     * @private
     * @param plugInto
     * @param fnNames
     */

  }, {
    key: "applyOverride",
    value: function applyOverride(plugInto, fnNames) {
      var me = this;

      if (!me.overridden) {
        me.overridden = {};
      }

      fnNames.forEach(function (fnName) {
        if (!me[fnName]) {
          throw new Error("Trying to chain fn ".concat(plugInto.$$name, "#").concat(fnName, ", but plugin fn ").concat(me.$$name, "#").concat(fnName, " does not exist"));
        } // override


        if (typeof plugInto[fnName] === 'function') {
          me.overridden[fnName] = plugInto[fnName].bind(plugInto);
        }

        plugInto[fnName] = me[fnName].bind(me);
      });
    }
    /**
     * Assigns specified functions.
     * @private
     * @param plugInto
     * @param fnName
     */

  }, {
    key: "assign",
    value: function assign(plugInto, fnName) {
      var me = this,
          property = getDescriptor(me, fnName);

      if (property) {
        // getter/setter, define corresponding property on target
        Object.defineProperty(plugInto, fnName, {
          configurable: true,
          enumerable: true,
          get: property.get && property.get.bind(me),
          set: property.set && property.set.bind(me)
        });
      } else {
        plugInto[fnName] = me[fnName].bind(me);
      }
    } //endregion
    //region Chaining

    /**
     * Chains functions. When the function is called on the target class all functions in the chain will be called in
     * the order they where added.
     * @private
     * @param plugInto
     * @param intoName
     * @param hookName
     * @param after
     */

  }, {
    key: "chain",
    value: function chain(plugInto, intoName, hookName) {
      var after = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var me = this,
          chains = plugInto.pluginFunctionChain || (plugInto.pluginFunctionChain = {}),
          hookFn = me[hookName] && me[hookName].bind(me),
          // Grab the fn so that we won't need our this pointer to call it. This is due
      // to this instance possibly being destroyed by the time a chain call is made.
      functionChainRunner = me.functionChainRunner;

      if (!hookFn) {
        throw new Error("Trying to chain fn ".concat(plugInto.$$name, "#").concat(hookName, ", but plugin fn ").concat(me.$$name, "#").concat(hookName, " does not exist"));
      }

      if (!chains[intoName]) {
        var intoFn = plugInto[intoName];

        if (intoFn) {
          intoFn = intoFn.bind(plugInto);
          intoFn.$this = plugInto;
        }

        chains[intoName] = intoFn ? [intoFn] : [];

        plugInto[intoName] = function () {
          for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            params[_key2] = arguments[_key2];
          }

          return functionChainRunner(chains[intoName], params);
        };
      }

      hookFn.$this = me;
      chains[intoName][after ? 'push' : 'unshift'](hookFn);
    }
    /**
     * Used to run multiple plugged in functions with the same name, see chain above. Returning false from a
     * function will abort chain.
     * @private
     * @param {Array} chain
     * @param {Array} params
     * @returns value returned from last function in chain (or false if any returns false)
     */

  }, {
    key: "functionChainRunner",
    value: function functionChainRunner(chain, params) {
      // NOTE: even though we are an instance method, we must not use our "this" pointer
      // since our instance may be destroyed. We cope with that by receiving parameters
      // for everything we need (so we're just a pure function).
      var fn, i, returnValue; // changed from for..of to try and fix Edge problems

      for (i = 0; i < chain.length; i++) {
        fn = chain[i]; // Feature hooks remain in place even after GridBase loops and destroys its
        // features, so skip over any destroyed features on the chain. In particular,
        // bindStore hooks will be called when GridBase sets store to null.

        if (!fn.$this.isDestroyed) {
          returnValue = fn.apply(void 0, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default()(params));

          if (returnValue === false) {
            break;
          }
        }
      }

      return returnValue;
    } //endregion

    /**
     * Called when disabling/enabling the plugin. By default removes the cls of the plugin from its client.
     * Override in subclasses to take any other actions necessary.
     */

  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      var me = this,
          constructor = me.constructor,
          cls = 'featureClass' in constructor ? constructor.featureClass : "b-".concat(constructor.$$name.toLowerCase()); // Some features do not use a cls

      if (cls) {
        var _me$client, _me$client$element;

        (_me$client = me.client) === null || _me$client === void 0 ? void 0 : (_me$client$element = _me$client.element) === null || _me$client$element === void 0 ? void 0 : _me$client$element.classList[disable ? 'remove' : 'add'](cls);
      }

      if (!me.isConfiguring) {
        if (disable) {
          /**
           * Fired when the plugin/feature is disabled.
           * @event disable
           * @param {Core.mixin.InstancePlugin} source
           */
          me.trigger('disable');
        } else {
          /**
           * Fired when the plugin/feature is enabled.
           * @event enable
           * @param {Core.mixin.InstancePlugin} source
           */
          me.trigger('enable');
        }
      }
    }
  }, {
    key: "updateDisabled",
    value: function updateDisabled(disabled) {
      this.doDisable(disabled);
    }
  }, {
    key: "throwOverrideIsMissing",
    value: function throwOverrideIsMissing(data) {
      throw new Error("Trying to override fn ".concat(data.plugIntoName, "#").concat(data.fnName, ", but plugin fn ").concat(data.pluginName, "#").concat(data.fnName, " does not exist"));
    }
  }, {
    key: "client",

    /**
     * The Widget which was passed into the constructor,
     * which is the Widget we are providing extra services for.
     * @property {Core.widget.Widget}
     * @readonly
     * @category Misc
     */
    get: function get() {
      return this._client;
    },
    set: function set(client) {
      this._client = client;
    }
  }], [{
    key: "initPlugins",
    //endregion
    //region Init

    /**
     * Call from another instance to add plugins to it.
     * @example
     * InstancePlugin.initPlugins(this, Search, Stripe);
     * @param plugInto Instance to mix into (usually this)
     * @param plugins Classes to plug in
     * @internal
     */
    value: function initPlugins(plugInto) {
      var property = plugInto.plugins || (plugInto.plugins = {});

      for (var _len3 = arguments.length, plugins = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        plugins[_key3 - 1] = arguments[_key3];
      }

      for (var _i = 0, _plugins = plugins; _i < _plugins.length; _i++) {
        var PluginClass = _plugins[_i];
        property[PluginClass.$$name] = new PluginClass(plugInto);
      }
    }
  }, {
    key: "configurable",
    //region Config
    get: function get() {
      return {
        clientListeners: null,

        /**
         * Get/set the plugin disabled state
         * @property {Boolean}
         * @name disabled
         * @category Common
         */

        /**
         * The plugin disabled state
         * @config {Boolean}
         * @default
         * @category Common
         */
        disabled: false
      };
    }
  }]);

  return InstancePlugin;
}(_Base_js__WEBPACK_IMPORTED_MODULE_24__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_25__["default"], _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_27__["default"]));


InstancePlugin._$name = 'InstancePlugin';

/***/ }),

/***/ "./lib/Core/mixin/Override.js":
/*!************************************!*\
  !*** ./lib/Core/mixin/Override.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Override; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-names */ "./node_modules/core-js/modules/es.object.get-own-property-names.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_names__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_names__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_own_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.own-keys */ "./node_modules/core-js/modules/es.reflect.own-keys.js");
/* harmony import */ var core_js_modules_es_reflect_own_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_own_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");












var productName = 'scheduler';

/**
 * @module Core/mixin/Override
 */

var excludedPropNames = {
  constructor: 1,
  prototype: 1,
  name: 1,
  length: 1,
  arguments: 1,
  caller: 1,
  callee: 1,
  __proto__: 1
};
/**
 * Simplifies overriding class methods by allowing methods from another class to be used as overrides.
 * Overrides are defined as own classes. They must at a minimum contain a static getter named targetClass, which
 * should return the class to override. Apply the override by calling {@link #function-apply-static apply()}.
 *
 * @example
 * class TemplateColumnOverride {
 *   static get target() {
 *     return {
 *             class: TemplateColumn,
 *             product: 'grid',
 *             minVersion: '1.0',
 *             maxVersion: '1.5'
 *     }
 *   }
 *
 *   renderer(renderData) {
 *       // call overridden function (optional)
 *       const value = this._overridden.renderer.call(this, renderData);
 *
 *       return 'HELLO' + value;
 *   }
 * }
 * Override.apply(TemplateColumnOverride);
 */

var Override = /*#__PURE__*/function () {
  function Override() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, Override);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(Override, null, [{
    key: "apply",

    /**
     * Apply override. We strongly suggest that you at least specify a maxVersion for your overrides.
     * ```
     * class OriginalOverride {
     *     static get target() {
     *         return {
     *             class: Original,
     *             product: 'grid',
     *             minVersion: '1.0',
     *             maxVersion: '1.5'
     *         }
     *     }
     * }
     * ```
     * @param override An override class definition
     */
    value: function apply(override) {
      if (!override.target) throw new Error('Override must specify what it overrides, using static getter target');
      if (!override.target.class) throw new Error('Override must specify which class it overrides, using target.class');
      if (!this.shouldApplyOverride(override)) return false;
      var staticKeys = Object.getOwnPropertyNames(override),
          instanceKeys = Object.getOwnPropertyNames(override.prototype);
      staticKeys.splice(staticKeys.indexOf('target'), 1);
      this.internalOverrideAll(override.target.class, staticKeys, override);
      this.internalOverrideAll(override.target.class.prototype, instanceKeys, override.prototype);
      return true;
    }
  }, {
    key: "internalOverrideAll",
    value: function internalOverrideAll(targetClass, properties, overrideDefinition) {
      var _this = this;

      Reflect.ownKeys(overrideDefinition).forEach(function (key) {
        if (properties.includes(key) && !excludedPropNames[key]) {
          var desc = Object.getOwnPropertyDescriptor(overrideDefinition, key);
          var currentTargetClass = targetClass;
          var targetProperty = null; // Walk up the prototype chain to find fn, needed for mixin overrides applied to class that has them
          // mixed in

          while (!targetProperty && currentTargetClass) {
            targetProperty = Object.getOwnPropertyDescriptor(currentTargetClass, key);

            if (!targetProperty) {
              currentTargetClass = Object.getPrototypeOf(currentTargetClass);
            }
          }

          if (targetProperty) {
            _this.internalOverride(currentTargetClass, key, desc, targetProperty);
          }
        }
      });
    }
  }, {
    key: "internalOverride",
    value: function internalOverride(target, key, desc, targetDesc) {
      var overrides = target._overridden = target._overridden || {};
      overrides[key] = target[key];

      if (targetDesc.get) {
        Object.defineProperty(target, key, {
          enumerable: false,
          configurable: true,
          get: desc.get
        });
      } else {
        target[key] = desc.value;
      }
    }
    /**
     * Checks versions if an override should be applied. Specify version in your overrides target config
     * @param override
     * @returns {Boolean}
     * @example
     * class OriginalOverride {
     *     static get target() {
     *         return {
     *             class: Original,
     *             product: 'grid',
     *             minVersion: '1.0',
     *             maxVersion: '1.5'
     *         }
     *     }
     * }
     * @private
     */

  }, {
    key: "shouldApplyOverride",
    value: function shouldApplyOverride(override) {
      var config = override.target; // not using versioning, allow override

      if (!config.maxVersion && !config.minVersion) return true; // must specify product to be able to lookup versions

      if (!config.product) throw new Error('Override must specify product when using versioning'); // override is for older version, disallow

      if (config.maxVersion && _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"][config.product].isNewerThan(config.maxVersion)) {
        return false;
      } // override is for newer version, disallow


      if (config.minVersion && _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"][config.product].isOlderThan(config.minVersion)) {
        return false;
      } // override is for current version, allow


      return true;
    }
  }]);

  return Override;
}();


Override._$name = 'Override';

/***/ }),

/***/ "./lib/Core/mixin/Pluggable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Pluggable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/mixin/Pluggable
 */

/**
 * Enables using plugins for a class by specifying property plugins as an array of plugin classes. If only a single plugin
 * is used, just give the plugin class instead of an array. This class isn't required for using plugins, just makes it
 * easier. Without mixin you can otherwise use `InstancePlugin.initPlugins(this, PluginClass)`.
 *
 * @example
 * new Store({
 *   plugins: [PluginClass, ...]
 * });
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Pluggable, _ref);

    var _super = _createSuper(Pluggable);

    function Pluggable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Pluggable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Pluggable, [{
      key: "initPlugins",

      /**
       * Template method which may be implemented in subclasses to initialize any plugins.
       * This method is empty in the `Pluggable` base class.
       * @internal
       */
      value: function initPlugins() {}
      /**
       * Adds plugins to an instance.
       * @param plugins Plugins to add
       */

    }, {
      key: "addPlugins",
      value: function addPlugins() {
        for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
          plugins[_key] = arguments[_key];
        }

        _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"].initPlugins.apply(_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"], [this].concat(plugins));
      }
      /**
       * Checks if instance has plugin.
       * @param pluginClassOrName Plugin or name to check for
       * @returns {Boolean}
       */

    }, {
      key: "hasPlugin",
      value: function hasPlugin(pluginClassOrName) {
        return this.getPlugin(pluginClassOrName) != null;
      }
      /**
       * Get a plugin instance.
       * @param pluginClassOrName
       * @returns {Object}
       */

    }, {
      key: "getPlugin",
      value: function getPlugin(pluginClassOrName) {
        if (typeof pluginClassOrName === 'function') pluginClassOrName = pluginClassOrName.$$name;
        return this.plugins && this.plugins[pluginClassOrName];
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "plugins",

      /**
       * Specify plugins (an array of classes) in config
       * @config {Function[]} plugins
       * @category Misc
       */

      /**
       * Map of applied plugins
       * @property {Object}
       * @readonly
       * @category Misc
       */
      get: function get() {
        if (!this._plugins) {
          this._plugins = {};
        }

        return this._plugins;
      },
      set: function set(plugins) {
        if (plugins) {
          if (!Array.isArray(plugins)) plugins = [plugins];
          _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"].initPlugins.apply(_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"], [this].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(plugins)));
        }

        this.initPlugins();
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'Pluggable';
      }
    }]);

    return Pluggable;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_10__["default"]);
});

/***/ }),

/***/ "./lib/Core/mixin/State.js":
/*!*********************************!*\
  !*** ./lib/Core/mixin/State.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/mixin/State
 */

/**
 * Mixin that simplifies handling state for an ui component. Classes that uses this mixin must implement `getState()` and
 * `applyState(state)`.
 *
 * ```
 * class MyUIComponent extends State() {
 *   getState() {
 *     return {
 *       this.text,
 *       this.size
 *     }
 *   }
 *
 *   applyState(state) {
 *      this.text = state.text;
 *      this.size = state.size;
 *   }
 * }
 * ```
 *
 * @demo Grid/state
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(State, _ref);

    var _super = _createSuper(State);

    function State() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, State);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(State, [{
      key: "state",
      //getState() {}
      //applyState(State) {}

      /**
       * Gets or sets a component's state
       * @property {Object}
       */
      get: function get() {
        this._state = this.getState();
        return this._state;
      },
      set: function set(state) {
        this._state = state;
        this.applyState(state);
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'State';
      }
    }]);

    return State;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);
});

/***/ }),

/***/ "./lib/Core/util/Bag.js":
/*!******************************!*\
  !*** ./lib/Core/util/Bag.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Bag; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.weak-map */ "./node_modules/core-js/modules/es.weak-map.js");
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_weak_map_delete_all__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.weak-map.delete-all */ "./node_modules/core-js/modules/esnext.weak-map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_weak_map_delete_all__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_weak_map_delete_all__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./Collection.js */ "./lib/Core/util/Collection.js");








































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';


var nonPrimitives = new WeakMap(),
    safeIndexKey = function safeIndexKey(value) {
  if (value && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_38___default()(value) === 'object') {
    var substitute = nonPrimitives.get(value);

    if (substitute === undefined) {
      substitute = Symbol('bscik'); // Bryntum safe collection index key

      nonPrimitives.set(value, substitute);
    }

    value = substitute;
  }

  return value;
};
/**
 * @module Core/util/Bag
 */

/**
 * A simple collection class to contain unique, keyed items.
 */


var Bag = /*#__PURE__*/function () {
  function Bag(config) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_36___default()(this, Bag);

    var me = this;
    me.generation = 0;
    me.items = new Set();
    me.idMap = {};
    me.idProperty = 'id';

    if (config) {
      if (config.idProperty) {
        me.idProperty = config.idProperty;
      }

      if (config.values) {
        me.values = config.values;
      }
    }
  }
  /**
   * Returns the item with the passed `id`.
   *
   * @param {*} id The `id` to find.
   * @returns {Object} The found item, or `undefined`.
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_37___default()(Bag, [{
    key: "get",
    value: function get(key) {
      return this.idMap[safeIndexKey(key)];
    }
    /**
     * The number of items in this Bag.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "add",

    /**
     * Adds the passed item(s) to this Bag. Existing items with the same ID
     * will be replaced.
     * @param {Object|Object[]} toAdd Item(s) to add.
     */
    value: function add() {
      for (var _len = arguments.length, toAdd = new Array(_len), _key = 0; _key < _len; _key++) {
        toAdd[_key] = arguments[_key];
      }

      if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
        toAdd = toAdd[0];
      }

      var me = this,
          items = me.items,
          idMap = me.idMap,
          idProperty = me.idProperty,
          len = toAdd.length;

      for (var i = 0; i < len; i++) {
        var item = toAdd[i],
            key = _Collection_js__WEBPACK_IMPORTED_MODULE_39__["keyTypes"][_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_38___default()(item)] ? item : safeIndexKey(item[idProperty]),
            existingItem = idMap[key]; // Not already present

        if (existingItem == null) {
          idMap[key] = item;
          items.add(item);
          me.generation++;
        } // Already present, replace it if different. No generational change.
        // IDs rule.
        else if (existingItem !== item) {
            idMap[key] = item;
            items.delete(existingItem);
            items.add(item);
          }
      }
    }
    /**
     * Removes the passed item(s) from this Bag.
     * @param {Object|Object[]} toRemove Item(s) to remove.
     */

  }, {
    key: "remove",
    value: function remove(toRemove) {
      if (!Array.isArray(toRemove)) {
        toRemove = [toRemove];
      }

      var items = this.items,
          idMap = this.idMap,
          idProperty = this.idProperty,
          len = toRemove.length;

      for (var i = 0; i < len; i++) {
        var item = toRemove[i],
            key = _Collection_js__WEBPACK_IMPORTED_MODULE_39__["keyTypes"][_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_38___default()(item)] ? item : safeIndexKey(item[idProperty]),
            existingItem = idMap[key]; // Found natch, so delete it

        if (existingItem != null) {
          items.delete(existingItem);
          delete idMap[key];
          this.generation++;
        }
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items.clear();
      this.idMap = {};
      this.generation++;
    }
    /**
     * Change the id of an existing member by mutating its idProperty.
     * @param {String|Number|Object} item The item or id of the item to change.
     * @param {String|Number} newId The id to set in the existing member.
     */

  }, {
    key: "changeId",
    value: function changeId(item, newId) {
      var me = this,
          idMap = me.idMap,
          idProperty = me.idProperty,
          oldId = _Collection_js__WEBPACK_IMPORTED_MODULE_39__["keyTypes"][_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_38___default()(item)] ? item : safeIndexKey(item[idProperty]),
          member = me.get(oldId);

      if (member) {
        var existingMember = me.get(newId);

        if (existingMember && member !== existingMember) {
          throw new Error("Attempt to set item ".concat(oldId, " to already existing member's id ").concat(newId));
        }

        member[idProperty] = newId;
        delete idMap[oldId];
        idMap[newId] = member;
      }
    }
    /**
     * Returns `true` if this Collection includes an item with the same `id` as the passed item.
     *
     * @param {Object|String|Number} item The item to find, or an `id` to find.
     * @returns {Boolean} True if the passed item is found.
     */

  }, {
    key: "includes",
    value: function includes(item) {
      var key = _Collection_js__WEBPACK_IMPORTED_MODULE_39__["keyTypes"][_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_38___default()(item)] ? item : safeIndexKey(item[this.idProperty]);
      return Boolean(this.idMap[key]);
    }
    /**
     * Extracts the content of this Bag into an array based upon the passed
     * value extraction function.
     * @param {Function} fn A function, which, when passed an item, returns a value to place into the resulting array.
     * @param {Object} [thisObj] The `this` reference when the function is called.
     * @returns {Object[]} An array of values extracted from this Bag.
     */

  }, {
    key: "map",
    value: function map(fn, thisObj) {
      var items = this.items,
          result = new Array(items.size); // Set has no map

      var i = 0;
      items.forEach(function (item) {
        result[i] = fn.call(thisObj, item, i++, items);
      });
      return result;
    }
    /**
     * Executes the passed function for each item in this Bag, passing in the item.
     * @param {Function} fn The function to execute.
     * @param {Object} [thisObj] The `this` reference when the function is called.
     */

  }, {
    key: "forEach",
    value: function forEach(fn, thisObj) {
      return this.items.forEach(fn, thisObj);
    }
    /**
     * Returns the first item in this Bag which elicits a *truthy* return value from the passed funtion.
     * @param {Function} fn A function, which, when passed an item, returns `true` to select it as the item to return.
     * @returns {Object} The matched item, or `undefined`.
     */

  }, {
    key: "find",
    value: function find(fn) {
      var _iterator = _createForOfIteratorHelper(this.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var div = _step.value;

          if (fn(div)) {
            return div;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return undefined;
    }
    /**
     * Iterator that allows you to do for (let item of bag)
     */

  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.items[Symbol.iterator]();
    }
  }, {
    key: "indexOf",
    value: function indexOf(item) {
      return this.values.indexOf(item);
    }
    /**
     * The set of values of this Bag.
     *
     * Setting this property replaces the data set.
     * @property {Object[]}
     */

  }, {
    key: "sort",

    /**
     * Sort the values of this Bag using the passed comparison function.
     *
     * Setting this property replaces the data set.
     * @param {Function} fn Comparison function which returns -ve, 0, or +ve
     */
    value: function sort(fn) {
      this.values = this.values.sort(fn);
    }
  }, {
    key: "some",
    value: function some(fn, thisObj) {
      return this.values.some(fn, thisObj);
    }
  }, {
    key: "count",
    get: function get() {
      return this.items.size;
    }
  }, {
    key: "values",
    get: function get() {
      return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_35___default()(this.items);
    },
    set: function set(values) {
      if (!Array.isArray(values)) {
        values = [values];
      }

      this.clear();
      this.add.apply(this, values);
      this.generation++;
    }
  }]);

  return Bag;
}();


Bag._$name = 'Bag';

/***/ }),

/***/ "./lib/Core/util/ClickRepeater.js":
/*!****************************************!*\
  !*** ./lib/Core/util/ClickRepeater.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ClickRepeater; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/util/ClickRepeater
 */

/**
 * A helper class, which, when applied to an {@link #config-element} means that a mousedown
 * and hold on that element will, after a configured {@link #config-delay}, begin
 * autorepeating `click` events on that element, starting at a rate of
 * {@link #config-startRate} clicks per second, and over {@link #config-accelerateDuration}
 * milliseconds, accelerate to firing clicks at {@link #config-endRate} times per second.
 *
 * An example of this is used by the {@link Core.widget.NumberField NumberField}'s
 * spinner triggers.
 */

var ClickRepeater = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ClickRepeater, _Delayable);

  var _super = _createSuper(ClickRepeater);

  function ClickRepeater() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ClickRepeater);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ClickRepeater, [{
    key: "doDestroy",
    value: function doDestroy() {
      this.mousedownRemover && this.mousedownRemover();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ClickRepeater.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      var me = this,
          target = me.delegate ? e.target.closest(me.delegate) : me.element;

      if (target) {
        me.triggerEvent = e;
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].lockComposedPath(me.triggerEvent);
        me.activeListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
          mouseup: {
            element: document,
            handler: 'onMouseUp'
          },
          mousemove: {
            element: target,
            handler: 'onTargetMouseMove'
          },
          mouseleave: {
            element: target,
            handler: 'onTargetMouseLeave'
          },
          mouseenter: {
            element: target,
            handler: 'onTargetMouseEnter'
          },
          thisObj: me
        });
        me.setTimeout('startAutoRepeat', me.delay);
      }
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(e) {
      var me = this;
      me.acceleration && me.acceleration.cancel();
      me.activeListenerRemover && me.activeListenerRemover();
      me.clearTimeout('startAutoRepeat');
      me.clearTimeout(me.repeatTimer);
    }
  }, {
    key: "onTargetMouseLeave",
    value: function onTargetMouseLeave() {
      this.clearInterval(this.repeatTimer);
    }
  }, {
    key: "onTargetMouseEnter",
    value: function onTargetMouseEnter(e) {
      this.triggerEvent = e;
      this.fireClick();
    }
  }, {
    key: "onTargetMouseMove",
    value: function onTargetMouseMove(e) {
      this.triggerEvent = e;
    }
  }, {
    key: "startAutoRepeat",
    value: function startAutoRepeat() {
      var me = this;
      me.interval = me.startInterval = 1000 / me.startRate;
      me.accelerationDelta = me.startInterval - 1000 / me.endRate; // Begin animating the interval from 1000/me.startRate to 1000/me.endRate

      me.fireClick();
      me.acceleration = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].animate(me.accelerateDuration, me.nextTick, me, 'easeOutQuad');
    }
  }, {
    key: "nextTick",
    value: function nextTick(progress) {
      this.interval = this.startInterval - this.accelerationDelta * progress;
    }
  }, {
    key: "fireClick",
    value: function fireClick() {
      var me = this,
          clickEvent = new MouseEvent('click', me.triggerEvent);
      me.triggerEvent.target.dispatchEvent(clickEvent);
      me.repeatTimer = me.setTimeout(me.fireClick, me.interval);
    }
  }, {
    key: "element",
    set: function set(element) {
      this._element = element;
      this.mousedownRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
        element: element,
        mousedown: 'onMouseDown',
        thisObj: this
      });
    },
    get: function get() {
      return this._element;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The element on which to fire autorepeating `click` events when the mouse is held down.
         * @config {HTMLElement}
         */
        element: null,

        /**
         * A query selector which specifies subtargets of this ClickRepeater's {@link #config-element}
         * which act as the click auto repeat event targets.
         * @config {String}
         * @default
         */
        delegate: null,

        /**
         * How long in milliSeconds to pause before starting the click repeats.
         * @config {Number}
         * @default
         */
        delay: 500,

        /**
         * Clicks per second to start firing after the initial {@link #config-delay}
         * @config {Number}
         * @default
         */
        startRate: 2,

        /**
         * Clicks per second to fire at top speed, after accelerating over the {@link #config-accelerateDuration}
         * @config {Number}
         * @default
         */
        endRate: 20,

        /**
         * How long in milliseconds to accelerate from the
         * {@link #config-startRate} to the {@link #config-startRate}.
         * @config {Number}
         * @default
         */
        accelerateDuration: 4000
      };
    }
  }]);

  return ClickRepeater;
}(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_10__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]));


ClickRepeater._$name = 'ClickRepeater';

/***/ }),

/***/ "./lib/Core/util/Collection.js":
/*!*************************************!*\
  !*** ./lib/Core/util/Collection.js ***!
  \*************************************/
/*! exports provided: default, keyTypes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Collection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyTypes", function() { return keyTypes; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_59___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_59__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_60___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_60__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_61___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_61__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_62___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_62__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./CollectionSorter.js */ "./lib/Core/util/CollectionSorter.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
































































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_62___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_62___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_61___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Core/util/Collection
 */

var return0 = function return0() {
  return 0;
},
    reverseNumericSortFn = function reverseNumericSortFn(a, b) {
  return b - a;
},
    filteredIndicesProperty = Symbol('filteredIndicesProperty'),
    emptyArray = Object.freeze([]),
    sortEvent = Object.freeze({
  action: 'sort',
  added: emptyArray,
  removed: emptyArray,
  replaced: emptyArray
}),
    filterEvent = Object.freeze({
  action: 'filter',
  added: emptyArray,
  removed: emptyArray,
  replaced: emptyArray
}),
    keyTypes = {
  string: 1,
  number: 1
}; // Adds a single item to a single index using the specified key


function addItemToIndex(item, index, key) {
  // Unique holds a single entry
  if (index.unique !== false) {
    index.set(key, item);
  } // Non-unique index holds a Set
  else {
      var set = index.get(key); // Add a set if this is the first entry

      if (!set) {
        set = new Set();
        index.set(key, set);
      } // Add entry to the set


      set.add(item);
    }
} // Removes a single item from a single index using the specified key


function removeItemFromIndex(item, index, key) {
  // Unique holds single entry, remove it
  if (index.unique !== false) {
    index.delete(key);
  } else if (index.has(key)) {
    // Remove from set
    index.get(key).delete(item); // Remove turned empty set

    if (!index.get(key).size) {
      index.delete(key);
    }
  }
} // Used to fully build the indices, normal and filtered (if used). Better to do full builds for performance reasons
// when assigning new datasets. For other CRUD operations, indices are kept up to date elsewhere


function doRebuildIndices(values, indices, keyProps, indexCount) {
  for (var i = 0; i < values.length; i++) {
    var item = values[i];

    for (var j = 0; j < indexCount; j++) {
      var keyProp = keyProps[j],
          key = item[keyProp],
          index = indices[keyProp];
      addItemToIndex(item, index, key);
    }
  }
}
/**
 * A class which encapsulates a {@link #function-get keyed},
 * {@link #function-addFilter filterable}, {@link #function-addSorter sortable}
 * collection of objects. Entries may not be atomic data types such as `string` or `number`.
 *
 * The entries are keyed by their `id` which is determined by interrogating the {@link #config-idProperty}.
 *
 * To filter a Collection, add a {@link Core.util.CollectionFilter CollectionFilter}
 * using the {@link #function-addFilter} method. A Filter config object may be specified here
 * which will be promoted to a CollectionFilter instance.
 *
 * To sort a Collection, add a {@link Core.util.CollectionSorter CollectionSorter}
 * using the {@link #function-addSorter} method. A Sorter config object may be specified here
 * which will be promoted to a CollectionSorter instance.
 */


var Collection = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_60___default()(Collection, _Base$mixin);

  var _super = _createSuper(Collection);

  function Collection() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_57___default()(this, Collection);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_58___default()(Collection, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(config) {
      /**
       * A counter which is incremented whenever the Collection is mutated in a meaningful way.
       *
       * If a {@link #function-splice} call results in no net replacement, removal or addition,
       * then the `generation` will not be incremented.
       * @property {Number}
       * @readonly
       */
      this.generation = 0;
      this._values = [];

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_59___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_62___default()(Collection.prototype), "construct", this).call(this, config);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _me$_sorters;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_59___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_62___default()(Collection.prototype), "doDestroy", this).call(this);

      var me = this;
      me._values.length = 0;

      if (me.isFiltered) {
        me._filteredValues.length = 0;
        me.filters.destroy();
      } // eslint-disable-next-line no-unused-expressions


      (_me$_sorters = me._sorters) === null || _me$_sorters === void 0 ? void 0 : _me$_sorters.destroy();
    } //endregion
    //region "CRUD"

    /**
     * Clears this collection.
     */

  }, {
    key: "clear",
    value: function clear() {
      var me = this,
          removed = me._values.slice();

      if (me.totalCount) {
        me._values.length = 0;

        if (me._filteredValues) {
          me._filteredValues.length = 0;
        }

        me._indicesInvalid = true; // Indicate to observers that data has changed.

        me.generation++;
        me.trigger('change', {
          action: 'clear',
          removed: removed
        });
      }
    }
    /**
     * Replaces the internal `values` array with the passed `values`, or `filteredValues` array with the passed `filteredValues`.
     * If `filteredValues` are not passed explicitly, but storage is filtered, decides internally `values` or `filteredValues` should
     * be replaced by passed `values`.
     *
     * Note that this takes ownership of the array, and the array must not be mutated by outside code.
     *
     * This is an internal utility method, not designed for use by application code.
     *
     * @param {Object} params Values and parameters to replace
     * @param {Object[]} params.values The new `values` array
     * @param {Object[]} [params.filteredValues] The new `filteredValues` array. Applicable only when storage is filtered.
     * @param {Boolean} [params.silent=false] If true, `change` event will not be fired
     * @param {Boolean} [params.isNewDataset=false] If true, `values` is a new dataset
     * @fires change
     * @internal
     */

  }, {
    key: "replaceValues",
    value: function replaceValues(_ref) {
      var values = _ref.values,
          filteredValues = _ref.filteredValues,
          _ref$silent = _ref.silent,
          silent = _ref$silent === void 0 ? false : _ref$silent,
          _ref$isNewDataset = _ref.isNewDataset,
          isNewDataset = _ref$isNewDataset === void 0 ? false : _ref$isNewDataset;
      var me = this;
      var replacedValues, replacedFilteredValues; // The isNewDataset flag is passed by store#loadData to indicate that it's
      // a new data load, and that local filters can be applied.
      // Other use cases are for purely local updates of an existing dataset such as
      // refreshing the visible data with a values array containing group headers.

      if (me.isFiltered && !isNewDataset) {
        var filteredPassed = Boolean(filteredValues); // If `filteredValues` are missing, take `values` as a source of filtered values

        if (!filteredPassed) {
          filteredValues = values.slice();
          values = null;
        } // otherwise check if non-filtered values are passed together with filtered, and replace them too
        else if (values) {
            replacedValues = me._values;
            me._values = values.slice();
          }

        replacedFilteredValues = me._filteredValues;
        me._filteredValues = filteredValues.slice();
      } else {
        replacedValues = me._values;
        me._values = values.slice();
        filteredValues = null;

        if (me.isFiltered && isNewDataset && me.autoFilter) {
          me._filterFunction = null;
          me._filteredValues = me._values.filter(me.filterFunction);
        } else if (me._filteredValues) {
          me._filteredValues.length = 0;
        }
      }

      me._indicesInvalid = true; // Indicate to observers that data has changed.

      me.generation++;

      if (!silent) {
        me.trigger('change', {
          action: 'replaceValues',
          replacedValues: replacedValues,
          replacedFilteredValues: replacedFilteredValues,
          values: values,
          filteredValues: filteredValues
        });
      }
    }
  }, {
    key: Symbol.iterator,

    /**
     * Iterator that allows you to do `for (const item of collection)`
     */
    value: function value() {
      return this.values[Symbol.iterator]();
    }
    /**
     * Executes the passed function for each item in this Collection, passing in the item,
     * ths index, and the full item array.
     * @param {Function} fn The function to execute.
     * @param {Boolean} [ignoreFilters=false] Pass `true` to include all items, bypassing filters.
     */

  }, {
    key: "forEach",
    value: function forEach(fn) {
      var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).forEach(fn);
    }
    /**
     * Extracts ths content of this Collection into an array based upon the passed
     * value extraction function.
     * @param {Function} fn A function, which, when passed an item, returns a value to place into the resulting array.
     * @param {Boolean} [ignoreFilters=false] Pass `true` to process an item even if it is filtered out.
     * @returns {Object[]} An array of values extracted from this Collection.
     */

  }, {
    key: "map",
    value: function map(fn) {
      var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).map(fn);
    }
    /**
     * Returns the first item in this Collection which elicits a *truthy* return value from the passed function.
     * @param {Function} fn A function, which, when passed an item, returns `true` to select it as the item to return.
     * @param {Boolean} [ignoreFilters=false] Pass `true` to include filtered out items.
     * @returns {Object} The matched item, or `undefined`.
     */

  }, {
    key: "find",
    value: function find(fn) {
      var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).find(fn);
    }
  }, {
    key: "add",

    /**
     * Adds items to this Collection. Multiple new items may be passed.
     *
     * By default, new items are appended to the existing values.
     *
     * Any {@link #property-sorters} {@link #property-sorters} present are re-run.
     *
     * Any {@link #property-filters} {@link #property-filters} present are re-run.
     *
     * *Note that if application functionality requires add and remove, the
     * {@link #function-splice} operation is preferred as it performs both
     * operations in an atomic manner*
     * @param  {...Object} items The item(s) to add.
     */
    value: function add() {
      for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
        items[_key] = arguments[_key];
      }

      if (items.length === 1) {
        this.splice.apply(this, [this._values.length, null].concat(items));
      } else {
        this.splice(this._values.length, null, items);
      }
    }
    /**
     * Removes items from this Collection. Multiple items may be passed.
     *
     * Any {@link #property-sorters} {@link #property-sorters} present are re-run.
     *
     * Any {@link #property-filters} {@link #property-filters} present are re-run.
     *
     * *Note that if application functionality requires add and remove, the
     * {@link #function-splice} operation is preferred as it performs both
     * operations in an atomic manner*
     * @param  {...Object} items The item(s) to remove.
     */

  }, {
    key: "remove",
    value: function remove() {
      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      if (items.length === 1) {
        this.splice.apply(this, [0].concat(items));
      } else {
        this.splice(0, items);
      }
    }
    /**
     * Moves an individual item to another location.
     * @param {Object} item The item to move.
     * @param {Object} [beforeItem] the item to insert the first item before. If omitted, the `item`
     * is moved to the end of the Collection.
     * @returns {Number} The new index of the `item`.
     */

  }, {
    key: "move",
    value: function move(item, beforeItem) {
      var me = this,
          _values = me._values,
          itemIndex = me.indexOf(item, true);
      var beforeIndex = beforeItem ? me.indexOf(beforeItem, true) : _values.length;

      if (itemIndex === -1 || beforeIndex === -1) {
        throw new Error('Collection move parameters must be present in Collection');
      }

      if (itemIndex !== beforeIndex && itemIndex !== beforeIndex - 1) {
        if (itemIndex < beforeIndex) {
          beforeIndex--;
        }

        _values.splice(itemIndex, 1);

        _values.splice(beforeIndex, 0, item);

        me.trigger('change', {
          action: 'move',
          item: item,
          from: itemIndex,
          to: beforeIndex
        });
      }

      return beforeIndex;
    }
    /**
     * The core data set mutation method. Removes and adds at the same time. Analogous
     * to the `Array` `splice` method.
     *
     * Note that if items that are specified for removal are also in the `toAdd` array,
     * then those items are *not* removed then appended. They remain in the same position
     * relative to all remaning items.
     *
     * @param {Number} index Index at which to remove a block of items. Only valid if the
     * second, `toRemove` argument is a number.
     * @param {Object[]|Number} [toRemove] Either the number of items to remove starting
     * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
     * @param  {Object[]|Object} [toAdd] An item, or an array of items to add.
     */

  }, {
    key: "splice",
    value: function splice() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toRemove = arguments.length > 1 ? arguments[1] : undefined;

      for (var _len3 = arguments.length, toAdd = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        toAdd[_key3 - 2] = arguments[_key3];
      }

      var me = this,
          idProperty = me.idProperty,
          values = me._values,
          newIds = {},
          removed = [],
          replaced = [],
          oldCount = me.totalCount;
      var added, mutated; // Create an "newIds" map of the new items so remove ops know if it's really a replace
      // {
      //     1234 : true
      // }
      // And an "added" array of the items that need adding (there was not already an entry for the id)
      //

      if (toAdd) {
        if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
          toAdd = toAdd[0];
        } // Check for replacements if we contain any data


        if (oldCount && toAdd.length) {
          // Only risk rebuilding the indices if we are adding
          var idIndex = me.indices[idProperty];
          added = [];

          for (var i = 0; i < toAdd.length; i++) {
            var newItem = toAdd[i],
                id = newItem[idProperty],
                existingItem = idIndex.get(id),
                existingIndex = existingItem ? values.indexOf(existingItem) : -1; // Register incoming id so that removal leaves it be

            newIds[id] = true; // Incoming id is already present.
            // Replace it in place.

            if (existingIndex !== -1) {
              // If incoming is the same object, it's a no-op
              if (values[existingIndex] !== newItem) {
                replaced.push([values[existingIndex], newItem]);
                values[existingIndex] = newItem;
              }
            } else {
              added.push(newItem);
            }
          }
        } // Empty Collection, we simply add what we're passed
        else {
            added = toAdd;
          }
      }

      if (toRemove) {
        // We're removing a chunk starting at index
        if (typeof toRemove === 'number') {
          for (var removeIndex = index; toRemove; --toRemove) {
            var _id = values[removeIndex][idProperty]; // If the entry here is being replaced, skip the insertion index past it

            if (newIds[_id]) {
              index++;
              removeIndex++;
            } // If the id is not among incoming items, remove it
            else {
                removed.push(values[removeIndex]);
                values.splice(removeIndex, 1);
                mutated = true;
              }
          }
        } // We are removing an item/items
        else {
            var contiguous = added.length === 0,
                lastIdx;

            if (!Array.isArray(toRemove)) {
              toRemove = [toRemove];
            } // Create array of index points to remove.
            // They must be in reverse order so that removal leaves following remove indices stable


            var removeIndices = toRemove.reduce(function (result, item) {
              var isNumeric = typeof item === 'number',
                  idx = isNumeric ? item : me.indexOf(item, true); // Drop out of contiguous mode if we find a non-contiguous record, or a remove *index*

              if (contiguous && (lastIdx != null && idx !== lastIdx + 1 || isNumeric)) {
                contiguous = false;
              } // Do not include indices out of range in our removeIndices


              if (idx >= 0 && idx < oldCount) {
                result.push(idx);
              }

              lastIdx = idx;
              return result;
            }, []).sort(reverseNumericSortFn); // If it's a pure remove of contiguous items with no adds, fast track it.

            if (contiguous) {
              // If reduced to zero by being asked to remove items we do not contain
              // then this is a no-op
              if (removeIndices.length) {
                removed.push.apply(removed, toRemove);
                values.splice(removeIndices[removeIndices.length - 1], removeIndices.length);
                mutated = true;
              }
            } else {
              // Loop through removeIndices splicing each index out of the values
              // unless there's an incoming identical id.
              for (var _i = 0; _i < removeIndices.length; _i++) {
                var _removeIndex = removeIndices[_i];

                if (_removeIndex !== -1) {
                  var _id2 = values[_removeIndex][idProperty]; // If the id is not among incoming items, remove it

                  if (!newIds[_id2]) {
                    removed.unshift(values[_removeIndex]);
                    values.splice(_removeIndex, 1);
                    mutated = true;
                  }
                }
              }
            }
          } // Update indices only if they have been used


        if (removed.length && !me._indicesInvalid) {
          removed.forEach(me.removeFromIndices, me);
        }
      } // If we collected genuinely new entries, insert them at the splice index


      if (added.length) {
        values.splice.apply(values, [Math.min(index, values.length), 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_56___default()(added)));
        mutated = true; // Update indices only if they have been used

        if (!me._indicesInvalid) {
          added.forEach(me.addToIndices, me);
        }
      } // Update indices only if they have been used


      if (replaced.length && !me._indicesInvalid) {
        replaced.forEach(function (rep) {
          me.removeFromIndices(rep[0]);
          me.addToIndices(rep[1]);
        });
      } // If we either added or removed items, or we did an in-place replace operation
      // then inform all interested parties.


      if (mutated || replaced.length) {
        // Ensure order of values matches the sorters
        if (me.isSorted) {
          me.onSortersChanged();
        } // The sort will also recreate the filteredValues so that it can be in correct sort order
        else if (me.isFiltered) {
            if (me.autoFilter) {
              me.onFiltersChanged();
            } else {
              var _me$_filteredValues;

              (_me$_filteredValues = me._filteredValues).push.apply(_me$_filteredValues, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_56___default()(added));
            }
          } // Indicate to observers that data has changed.


        me.generation++;
        /**
         * Fired when items are added, replace or removed
         * @event change
         * @param {String} action The underlying operation which caused data change.
         * May be `'splice'` (meaning an atomic add/remove operation, `'sort'` or `'filter'`)
         * @param {Core.util.Collection} source This Collection.
         * @param {Object[]} removed An array of removed items.
         * @param {Object[]} added An array of added items.
         * @param {Object[]} replaced An array of replacements, each entry of which contains `[oldValue, newValue]`.
         * @param {Number} oldCount The number of items in the full, untiltered collection prior to the splice operation.
         */

        me.trigger('change', {
          action: 'splice',
          removed: removed,
          added: added,
          replaced: replaced,
          oldCount: oldCount
        });
      } else {
        /**
         * Fired when a {@link #function-splice} operation is requested but the operation
         * is a no-op and has caused no change to this Collection's dataset. The splice
         * method's parameters are passed for reference.
         * @event noChange
         * @param {Number} index Index at which to remove a block of items.
         * @param {Object[]|Number} [toRemove] Either the number of items to remove starting
         * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
         * @param  {Object[]|Object} [toAdd] An item, or an array of items to add.
         */
        me.trigger('noChange', {
          index: index,
          toRemove: toRemove,
          toAdd: toAdd
        });
      }
    }
    /**
     * Change the id of an existing member by mutating its {@link #config-idProperty}.
     * @param {String|Number|Object} item The item or id of the item to change.
     * @param {String|Number} newId The id to set in the existing member.
     */

  }, {
    key: "changeId",
    value: function changeId(item, newId) {
      var me = this,
          idProperty = me.idProperty,
          oldId = keyTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_55___default()(item)] ? item : item[idProperty],
          member = me.get(oldId);

      if (member) {
        var existingMember = me.get(newId);

        if (existingMember && member !== existingMember) {
          throw new Error("Attempt to set item ".concat(oldId, " to already existing member's id ").concat(newId));
        }

        me.removeIndexEntry(item, idProperty, oldId);
        me.addIndexEntry(item, idProperty, newId); // Last on purpose, onItemMutation would fail to find the item if its id was changed prior to the call

        member[idProperty] = newId;
      }
    }
    /**
     * Returns the item with the passed `id`. By default, filtered are honoured, and
     * if the item with the requested `id` is filtered out, nothing will be returned.
     *
     * To return the item even if it has been filtered out, pass the second parameter as `true`.
     * @param {*} id The `id` to find.
     * @param {Boolean} [ignoreFilters=false] Pass `true` to return an item even if it is filtered out.
     * @returns {Object} The found item, or `undefined`.
     */

  }, {
    key: "get",
    value: function get(id) {
      var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.getBy(this.idProperty, id, ignoreFilters);
    }
  }, {
    key: "getAt",
    value: function getAt(index) {
      var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.isFiltered && !ignoreFilters) {
        return this._filteredValues[index];
      } else {
        return this._values[index];
      }
    }
    /**
     * Returns the item with passed property name equal to the passed value. By default,
     * filtered are honoured, and if the item with the requested `id` is filtered out,
     * nothing will be returned.
     *
     * To return the item even if it has been filtered out, pass the third parameter as `true`.
     * @param {String} propertyName The property to test.
     * @param {*} value The value to find.
     * @param {Boolean} [ignoreFilters=false] Pass `true` to return an item even if it is filtered out.
     * @returns {Object} The found item, or `undefined`.
     */

  }, {
    key: "getBy",
    value: function getBy(propertyName, value) {
      var ignoreFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.findItem(propertyName, value, this.isFiltered && ignoreFilters);
    }
    /**
     * The number of items in this collection. Note that this honours filtering.
     * See {@link #property-totalCount};
     * @property {Number}
     * @readonly
     */

  }, {
    key: "updateIdProperty",

    /**
     * The property name used to extract item `id`s from added objects.
     * @member {String} idProperty
     */
    value: function updateIdProperty(idProperty) {
      this.addIndex({
        property: idProperty,
        unique: true
      });
    } //endregion
    //region Sorting

    /**
     * The Collection of {@link Core.util.CollectionSorter Sorters} for this Collection.
     * @member {Core.util.Collection} sorters
     */

  }, {
    key: "changeSorters",
    value: function changeSorters(sorters) {
      return new Collection({
        values: Array.isArray(sorters) ? sorters : [sorters],
        listeners: {
          change: 'onSortersChanged',
          thisObj: this
        }
      });
    }
    /**
     * Adds a Sorter to the Collection of Sorters which are operating on this Collection.
     *
     * A Sorter may be an specified as an instantiated {@link Core.util.CollectionSorter
     * CollectionSorter}, or a config object for a CollectionSorter of the form
     *
     *     {
     *         property  : 'age',
     *         direction : 'desc'
     *     }
     *
     * Note that by default, a Sorter *replaces* a Sorter with the same `property` to make
     * it easy to change existing Sorters. A Sorter's `id` is its `property` by default. You
     * can avoid this and add multiple Sorters for one property by configuring Sorters with `id`s.
     *
     * A Sorter may also be specified as a function which compares two objects eg:
     *
     *     (lhs, rhs) => lhs.customerDetails.age - rhs.customerDetails.age
     *
     * @param {Object} sorter A Sorter of Sorter configuration object to add to the Collection
     * of Sorters operating on this Collection.
     * @returns {Core.util.CollectionSorter} The resulting Sorter to make it easy to remove Sorters.
     */

  }, {
    key: "addSorter",
    value: function addSorter(sorter) {
      var result = sorter instanceof _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_66__["default"] ? sorter : new _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_66__["default"](sorter);
      this.sorters.add(result);
      return result;
    }
    /**
     * A flag which is `true` if this Collection has active {@link #property-sorters}.
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "onSortersChanged",
    value: function onSortersChanged() {
      var me = this;
      delete me._sortFunction;

      me._values.sort(me.sortFunction);

      me.trigger('change', sortEvent);
    }
    /**
     * A sorter function which encapsulates the {@link Core.util.CollectionSorter Sorters}
     * for this Collection.
     * @property {Function}
     * @readonly
     */

  }, {
    key: "addFilter",

    /**
     * Adds a Filter to the Collection of Filters which are operating on this Collection.
     *
     * A Filter may be an specified as an instantiated {@link Core.util.CollectionFilter
     * CollectionFilter}, or a config object for a CollectionFilter of the form
     *
     *     {
     *         property : 'age',
     *         operator : '>=',
     *         value    : 21
     *     }
     *
     * Note that by default, a Filter *replaces* a Filter with the same `property` to make
     * it easy to change existing Filters. A Filter's `id` is its `property` by default. You
     * can avoid this and add multiple Filters for one property by configuring Filters with `id`s.
     *
     * A Filter may also be specified as a function which filters candidate objects eg:
     *
     *     candidate => candidate.customerDetails.age >= 21
     *
     * @param {Object} filter A Filter or Filter configuration object to add to the Collection
     * of Filters operating on this Collection.
     * @returns {Core.util.CollectionFilter} The resulting Filter to make it easy to remove Filters.
     */
    value: function addFilter(filter) {
      var result = filter instanceof _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_65__["default"] ? filter : new _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_65__["default"](filter);
      this.filters.add(result);
      return result;
    }
    /**
     * A flag which is `true` if this Collection has active {@link #property-filters}.
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "onFiltersChanged",
    value: function onFiltersChanged() {
      var me = this;
      me._filterFunction = null;
      me._filteredValues = me._values.filter(me.filterFunction);
      me._indicesInvalid = true;
      me.trigger('change', filterEvent);
    }
    /**
     * A filter function which encapsulates the {@link Core.util.CollectionFilter Filters}
     * for this Collection.
     * @property {Function}
     * @readonly
     */

  }, {
    key: "changeExtraKeys",
    //endregion
    //region Indexing
    value: function changeExtraKeys(extraKeys) {
      var keys = !Array.isArray(extraKeys) ? [extraKeys] : extraKeys; // Normalize to always be an array of index configs

      return keys.map(function (config) {
        if (typeof config === 'string') {
          return {
            property: config,
            unique: true
          };
        }

        return config;
      });
    }
  }, {
    key: "updateExtraKeys",
    value: function updateExtraKeys(extraKeys) {
      for (var i = 0; i < extraKeys.length; i++) {
        this.addIndex(extraKeys[i]);
      }
    }
    /**
     * Adds a lookup index for the passed property name or index config. The index is built lazily when an index is
     * searched
     * @internal
     * @param {Object} indexConfig An index config
     * @param {String} indexConfig.property The property name to add an index for
     * @param {Boolean} [indexConfig.unique] Specify `false` to allow multiple entries of the same index, turning
     *   entries into sets
     */

  }, {
    key: "addIndex",
    value: function addIndex(indexConfig) {
      // Combo without valueField used in some tests -> addIndex(undefined). Safeguarding here
      if (indexConfig) {
        (this._indices || (this._indices = {}))[indexConfig.property] = new Map(); // Piggyback the index config

        Object.assign(this._indices[indexConfig.property], indexConfig); // Indices need a rebuild now.

        this._indicesInvalid = true;
        /**
         * this.indices is keyed by the property name, and contains the keys linked to an item in the _values array.
         * So collection.add({id : foo, name : 'Nige'}, {id : 'bar', name : 'Faye'}) where collection has had an index
         * added for the "name" property would result in:
         *
         * {
         *     id : Map({
         *         foo : nige,
         *         bar : faye
         *     }),
         *     name : Map({
         *         Nige : nige,
         *         Faye : faye
         *     })
         * }
         */
      }
    }
    /**
     * Return the index of the item with the specified key having the specified value.
     *
     * By default, filtering is taken into account and this returns the index in the filtered dataset if present. To
     * bypass this, pass the third parameter as `true`.
     *
     * Only useful for indices configured with `unique: true`.
     *
     * @param {String} propertyName The name of the property to test.
     * @param {*} value The value to test for.
     * @param {Boolean} [ignoreFilters=false] Pass `true` to return the index in
     * the original data set if the item is filtered out.
     * @returns {Number} The index of the item or `-1` if not found for unique indices
     */

  }, {
    key: "findIndex",
    value: function findIndex(propertyName, value) {
      var ignoreFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var item = this.findItem(propertyName, value, ignoreFilters);

      if (!item) {
        return -1;
      }

      var values = this.isFiltered && !ignoreFilters ? this._filteredValues : this._values;
      return values.indexOf(item);
    }
    /**
     * Return the item with the specified key having the specified value.
     *
     * By default, filtering is taken into account. To bypass this, pass the third parameter as `true`.
     *
     * For indices configured with `unique: false`, a Set of items will be returned.
     *
     * @param {String} propertyName The name of the property to test.
     * @param {*} value The value to test for.
     * @param {Boolean} [ignoreFilters=false] Pass `true` to return the index in
     * the original data set if the item is filtered out.
     * @returns {Object|Set} The found item or Set of items or null
     */

  }, {
    key: "findItem",
    value: function findItem(propertyName, value) {
      var ignoreFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          isFiltered = me.isFiltered,
          index = isFiltered && !ignoreFilters ? me.indices[filteredIndicesProperty][propertyName] : me.indices[propertyName];

      if (index) {
        var _index$get;

        // If the key is numeric, cast it to a number and find.
        // Store's idRegister is an object which treats numeric keys as strings
        // but Maps are more picky, so we have to work round that.
        var itemIndex = (_index$get = index.get(value)) !== null && _index$get !== void 0 ? _index$get : typeof value === 'string' && !isNaN(value) && index.get(Number(value)) || null;

        if (itemIndex != null) {
          return itemIndex;
        }
      } else {
        // Search the filtered values if we are filtered and not ignoring filters
        var values = isFiltered && !ignoreFilters ? me._filteredValues : me._values,
            count = values.length;

        for (var i = 0; i < count; i++) {
          var item = values[i];

          if (item[propertyName] == value) {
            return item;
          }
        }
      }

      return null;
    }
    /**
     * Returns the index of the item with the same `id` as the passed item.
     *
     * By default, filtering is honoured, so if the item in question has been added, but is currently filtered out of
     * visibility, `-1` will be returned.
     *
     * To find the index in the master, unfiltered dataset, pass the second parameter as `true`;
     * @param {Object|String|Number} item The item to find, or an `id` to find.
     * @param {Boolean} [ignoreFilters=false] Pass `true` to find the index in the master, unfiltered data set.
     * @returns {Number} The index of the item, or `-1` if not found.
     */

  }, {
    key: "indexOf",
    value: function indexOf(item) {
      var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.findIndex(this.idProperty, keyTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_55___default()(item)] ? item : item[this.idProperty], ignoreFilters);
    }
    /**
     * Returns `true` if this Collection includes an item with the same `id` as the passed item.
     *
     * By default, filtering is honoured, so if the item in question has been added,
     * but is currently filtered out of visibility, `false` will be returned.
     *
     * To query inclusion in the master, unfiltered dataset, pass the second parameter as `true`;
     * @param {Object|String|Number} item The item to find, or an `id` to find.
     * @param {Boolean} [ignoreFilters=false] Pass `true` to find the index in the master, unfiltered data set.
     * @returns {Boolean} True if the passed item is found.
     */

  }, {
    key: "includes",
    value: function includes(item) {
      var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return Boolean(this.findItem(this.idProperty, keyTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_55___default()(item)] ? item : item[this.idProperty], ignoreFilters));
    }
  }, {
    key: "rebuildIndices",

    /**
     * Called when the Collection is mutated and the indices have been flagged as invalid.
     *
     * Rebuilds the indices object to allow lookup by keys.
     * @internal
     */
    value: function rebuildIndices() {
      var me = this,
          isFiltered = me.isFiltered,
          indices = me._indices || (me._indices = {}),
          keyProps = Object.keys(indices),
          indexCount = keyProps.length,
          values = me._values;
      var filteredIndices;

      if (isFiltered) {
        filteredIndices = indices[filteredIndicesProperty] = {};
      } // First, clear indices.


      for (var i = 0; i < indexCount; i++) {
        var index = indices[keyProps[i]];
        index.clear();

        if (isFiltered) {
          var filteredIndex = filteredIndices[keyProps[i]];

          if (filteredIndex) {
            filteredIndex.clear();
          } else {
            filteredIndex = filteredIndices[keyProps[i]] = new Map(); // Piggyback config

            filteredIndex.unique = index.unique;
          }
        }
      }

      doRebuildIndices(values, indices, keyProps, indexCount); // Create a parallel lookup structure into the _filteredValues

      if (isFiltered) {
        doRebuildIndices(me._filteredValues, filteredIndices, keyProps, indexCount);
      }

      me._indicesInvalid = false;
    } // Returns an array with [indices] or [indices, filteredIndices] if filtering is used

  }, {
    key: "getIndices",
    value: function getIndices(propertyName) {
      var indices = [this.indices[propertyName]];

      if (this.isFiltered) {
        indices.push(this.indices[filteredIndicesProperty][propertyName]);
      }

      return indices;
    }
    /**
     * Add an item to all indices
     * @param {*} item Item already available in the Collection
     * @private
     */

  }, {
    key: "addToIndices",
    value: function addToIndices(item) {
      var _this = this;

      Object.keys(this.indices).forEach(function (propertyName) {
        _this.addIndexEntry(item, propertyName, item[propertyName]);
      });
    }
    /**
     * Remove an item from all indices
     * @param {*} item Item already available in the Collection
     * @private
     */

  }, {
    key: "removeFromIndices",
    value: function removeFromIndices(item) {
      var _this2 = this;

      Object.keys(this.indices).forEach(function (propertyName) {
        _this2.removeIndexEntry(item, propertyName, item[propertyName]);
      });
    }
    /**
     * Remove an entry from an index, and if filtering is used also from the filtered index.
     * @param {*} item Item already available in the Collection
     * @param {String} propertyName Property of the item, will be matched with configured indices
     * @param {*} oldValue Value to remove
     * @private
     */

  }, {
    key: "removeIndexEntry",
    value: function removeIndexEntry(item, propertyName, oldValue) {
      this.getIndices(propertyName).forEach(function (index) {
        return removeItemFromIndex(item, index, oldValue);
      });
    }
    /**
     * Add a new entry to an index, and if filtering is used also to the filtered index.
     * @param {*} item Item already available in the Collection
     * @param {String} propertyName Property of the item, will be matched with configured indices
     * @param {*} value Value to store
     * @private
     */

  }, {
    key: "addIndexEntry",
    value: function addIndexEntry(item, propertyName, value) {
      this.getIndices(propertyName).forEach(function (index) {
        return addItemToIndex(item, index, value);
      });
    }
    /**
     * Call externally to update indices on item mutation (from Store)
     * @param {*} item Item already available in the Collection
     * @param {Object} wasSet Uses the `wasSet` format from Store, `{ field : { oldValue, newValue } }`
     * @internal
     */

  }, {
    key: "onItemMutation",
    value: function onItemMutation(item, wasSet) {
      var _this3 = this;

      // Iterate over changes if we have extra indices defined, keeping those indices up to date
      if (this.extraKeys && !this._indicesInvalid) {
        Object.keys(wasSet).forEach(function (propertyName) {
          if (_this3.indices[propertyName]) {
            var _wasSet$propertyName = wasSet[propertyName],
                value = _wasSet$propertyName.value,
                oldValue = _wasSet$propertyName.oldValue;

            _this3.removeIndexEntry(item, propertyName, oldValue);

            _this3.addIndexEntry(item, propertyName, value);
          }
        });
      }
    } //endregion

  }, {
    key: "isCollection",
    get: function get() {
      return true;
    }
  }, {
    key: "values",
    set: function set(values) {
      // Want a full rebuild for new dataset, less costly than doing it per item
      this._indicesInvalid = true;
      this.splice(0, this._values.length, values);
    }
    /**
     * The set of values of this Collection. If this Collection {@link #property-isFiltered},
     * this yields the filtered data set.
     *
     * Setting this property replaces the data set.
     * @property {Object[]}
     */
    ,
    get: function get() {
      return this.isFiltered ? this._filteredValues : this._values;
    }
  }, {
    key: "first",
    get: function get() {
      return this.values[0];
    }
  }, {
    key: "last",
    get: function get() {
      return this.values[this.count - 1];
    }
    /**
     * The set of all values of this Collection regardless of filters applied.
     * @readonly
     * @property {Object[]}
     */

  }, {
    key: "allValues",
    get: function get() {
      return this._values;
    }
  }, {
    key: "count",
    get: function get() {
      return this.values.length;
    }
    /**
     * The number of items in this collection regardless of filtering.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "totalCount",
    get: function get() {
      return this._values.length;
    }
  }, {
    key: "isSorted",
    get: function get() {
      var _this$_sorters;

      return Boolean((_this$_sorters = this._sorters) === null || _this$_sorters === void 0 ? void 0 : _this$_sorters.count);
    }
  }, {
    key: "sortFunction",
    get: function get() {
      if (!this._sortFunction) {
        if (this.isSorted) {
          this._sortFunction = _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_66__["default"].generateSortFunction(this.sorters.values);
        } else {
          this._sortFunction = return0;
        }
      }

      return this._sortFunction;
    } //endregion
    //region Filtering

    /**
     * The Collection of {@link Core.util.CollectionFilter Filters} for this Collection.
     * @property {Core.util.Collection}
     * @readonly
     */

  }, {
    key: "filters",
    get: function get() {
      if (!this._filters) {
        this._filters = new Collection({
          listeners: {
            change: 'onFiltersChanged',
            thisObj: this
          }
        });
      }

      return this._filters;
    }
  }, {
    key: "isFiltered",
    get: function get() {
      return Boolean(this._filters && this._filters.count);
    }
  }, {
    key: "filterFunction",
    get: function get() {
      if (!this._filterFunction) {
        if (this.isFiltered) {
          this._filterFunction = _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_65__["default"].generateFiltersFunction(this.filters.values);
        } else {
          this._filterFunction = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_67__["default"].returnTrue;
        }
      }

      return this._filterFunction;
    }
  }, {
    key: "indices",
    get: function get() {
      if (this._indicesInvalid) {
        this.rebuildIndices();
      }

      return this._indices;
    }
  }], [{
    key: "configurable",
    //region Config
    get: function get() {
      return {
        /**
         * Specify the name of the property of added objects which provides the lookup key
         * @config {String}
         * @default
         */
        idProperty: 'id',

        /**
         * Specify the names or index configs of properties which are to be indexed for fast lookup.
         *
         * Index configs use the format `{ property : string, unique : boolean }`. Unique indices stores one index
         * per entry, non-unique stores a `Set`. If left out, `unique` defaults to `true`
         *
         * @config {String[]|Object[]}
         */
        extraKeys: null,

        /**
         * Automatically apply filters on item add.
         * @config {String[]}
         * @default
         */
        autoFilter: true,

        /**
         * A {@link Core.util.CollectionSorter Sorter}, or Sorter config object, or
         * an array of these, to use to sort this Collection.
         * @config {Object[]}
         * @default
         */
        sorters: {
          $config: ['lazy'],
          value: []
        }
      };
    }
  }]);

  return Collection;
}(_Base_js__WEBPACK_IMPORTED_MODULE_63__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_64__["default"])); // These are used by Bag for the same purpose




Collection._$name = 'Collection';

/***/ }),

/***/ "./lib/Core/util/CollectionFilter.js":
/*!*******************************************!*\
  !*** ./lib/Core/util/CollectionFilter.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CollectionFilter; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");






















function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/util/CollectionFilter
 */

/**
 * A class which encapsulates a single filter operation which may be applied to any object to decide whether to
 * include or exclude it from a set.
 *
 * A CollectionFilter generally has at least three main properties:
 *
 * * `property` - The name of a property in candidate objects from which to extract the value to test
 * * `value` - The value which  this filter uses to test against.
 * * `operator` - The comparison operator, eg: `'='` or `'>'` etc.
 *
 * Given these three essential values, further configurations may affect how the filter is applied:
 *
 * * `caseSensitive` - If configured as `false`, string comparisons are case insensitive.
 * * `convert` - A function which, when passed the extracted value from the candidate object, returns the value to test.
 *
 * A filter may also be configured with a single `filterBy` property. This function is just passed the raw
 * candidate object and must return `true` or `false`.
 *
 * A CollectionFilter may be configured to encapsulate a single filtering function by passing that function as the sole
 * parameter to the constructor:
 *
 *     new CollectionFilter(candidate => candidate.title.contains('search string'));
 *
 */

var CollectionFilter = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(CollectionFilter, _Base$mixin);

  var _super = _createSuper(CollectionFilter);

  function CollectionFilter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default()(this, CollectionFilter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default()(CollectionFilter, [{
    key: "construct",
    value: function construct(config) {
      if (typeof config === 'function') {
        config = {
          filterBy: config
        };
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(CollectionFilter.prototype), "construct", this).call(this, config);
    }
    /**
     * When in a Collection (A Collection holds its Filters in a Collection), we need an id.
     * @property {String}
     * @private
     */

  }, {
    key: "onChange",
    value: function onChange(propertyChanged) {
      var me = this; // Inform any owner (eg a Store), that it has to reassess its CollectionFilters

      if (!me.isConfiguring && me.owner && !me.owner.isConfiguring && me.owner.onFilterChanged) {
        me.owner.onFilterChanged(me, propertyChanged);
      }
    }
  }, {
    key: "defaultFilterBy",
    value: function defaultFilterBy(candidate) {
      return this[this.operator](this.convert(candidate[this.property]));
    }
    /**
     * The name of a property of candidate objects which yields the value to compare against this CollectionFilter's {@link #config-value}.
     * @type {String}
     */

  }, {
    key: "convert",
    value: function convert(value) {
      // This is a workaround for filterbar feature: it always converts input value to string. When date is typed,
      // it is converted into string, and Date.valueOf() would return number. So if we are matching date against string
      // type, we should not convert it.
      if (!(typeof this.filterValue === 'string' && value instanceof Date)) {
        var _value$valueOf, _value;

        // if value is a complex type, try to access `value` property to get primitive value
        value = (_value$valueOf = (_value = value) === null || _value === void 0 ? void 0 : _value.valueOf()) !== null && _value$valueOf !== void 0 ? _value$valueOf : value;
      }

      value = !this.caseSensitive && typeof value === 'string' ? value.toLowerCase() : value;
      return value;
    }
  }, {
    key: "filter",
    value: function filter(candidate) {
      return this.filterBy(candidate);
    }
  }, {
    key: "startsWith",
    value: function startsWith(v) {
      return String(v).startsWith(this.filterValue);
    }
  }, {
    key: "endsWith",
    value: function endsWith(v) {
      return String(v).endsWith(this.filterValue);
    }
  }, {
    key: '=',
    value: function _(v) {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isEqual(v, this.filterValue);
    }
  }, {
    key: '!=',
    value: function _(v) {
      return !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isEqual(v, this.filterValue);
    }
  }, {
    key: '>',
    value: function _(v) {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isMoreThan(v, this.filterValue);
    }
  }, {
    key: '>=',
    value: function _(v) {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isMoreThan(v, this.filterValue) || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isEqual(v, this.filterValue);
    }
  }, {
    key: '<',
    value: function _(v) {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isLessThan(v, this.filterValue);
    }
  }, {
    key: '<=',
    value: function _(v) {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isLessThan(v, this.filterValue) || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isEqual(v, this.filterValue);
    }
  }, {
    key: '*',
    value: function _(v) {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isPartial(v, this.filterValue);
    } // Accepts an array or a Collection

  }, {
    key: "id",
    get: function get() {
      return this._id || (this._id = this.property || CollectionFilter.generateId('b-filter'));
    },
    set: function set(id) {
      this._id = id;
    }
  }, {
    key: "filterBy",
    get: function get() {
      return this._filterBy || this.defaultFilterBy;
    }
    /**
     * May be used in place of the {@link #config-property}, {@link #config-value} and {@link #config-property} configs. A function which
     * accepts a candidate object and returns `true` or `false`
     * @type {Function}
     */
    ,
    set: function set(filterBy) {
      this._filterBy = filterBy;
    }
  }, {
    key: "property",
    set: function set(property) {
      this._property = property; // Signal to owner about filter change

      this.onChange('property');
    },
    get: function get() {
      return this._property;
    }
    /**
     * The value against which to compare the {@link #config-property} of candidate objects.
     * @type {*}
     */

  }, {
    key: "value",
    set: function set(value) {
      var _value$valueOf2, _value2;

      this._value = value;
      value = (_value$valueOf2 = (_value2 = value) === null || _value2 === void 0 ? void 0 : _value2.valueOf()) !== null && _value$valueOf2 !== void 0 ? _value$valueOf2 : value; // Filter value is a processed value to be used by the comparators. Useful when value is object, like Duration field

      this._filterValue = !this.caseSensitive && typeof value === 'string' ? value.toLowerCase() : value; // Signal to owner about filter change

      this.onChange('value');
    },
    get: function get() {
      return this._value;
    }
  }, {
    key: "filterValue",
    get: function get() {
      return this._filterValue;
    }
    /**
     * The operator to use when comparing a candidate object's {@link #config-property} with this CollectionFilter's {@link #config-value}.
     * May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`
     * @type {String}
     */

  }, {
    key: "operator",
    set: function set(operator) {
      this._operator = operator; // Signal to owner about filter change

      this.onChange('operator');
    },
    get: function get() {
      return this._operator || (typeof this.filterValue === 'string' ? '*' : '=');
    }
  }], [{
    key: "generateFiltersFunction",
    value: function generateFiltersFunction(filters) {
      if (!filters || !filters.length && !filters.count) {
        return _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].returnTrue;
      }

      return function (candidate) {
        var match = true;

        var _iterator = _createForOfIteratorHelper(filters),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var filter = _step.value;

            // Skip disabled filters
            if (!filter.disabled) {
              match = filter.filter(candidate);
            }

            if (!match) {
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return match;
      };
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The name of a property of candidate objects which yields the value to compare against this CollectionFilter's {@link #config-value}.
         * @config {String}
         */
        property: null,

        /**
         * The value against which to compare the {@link #config-property} of candidate objects.
         * @config {*}
         */
        value: null,

        /**
         * The operator to use when comparing a candidate object's {@link #config-property} with this CollectionFilter's {@link #config-value}.
         * May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`
         * @config {String}
         */
        operator: null,

        /**
         * May be used in place of the {@link #config-property}, {@link #config-value} and {@link #config-property} configs. A function which
         * accepts a candidate object and returns `true` or `false`
         * @config {Function}
         */
        filterBy: null,

        /**
         * A function which accepts a value extracted from a candidate object using the {@link #config-property} name, and
         * returns the value which the filter should use to compare against its {@link #config-value}.
         * @config {Function}
         */
        convert: null,

        /**
         * Configure as `false` to have string comparisons case insensitive.
         * @config {Boolean}
         */
        caseSensitive: true,

        /**
         * The `id` of this Filter for when used by a {@link Core.util.Collection} Collection.
         * By default the `id` is the {@link #config-property} value.
         * @config {String}
         */
        id: null
      };
    }
  }]);

  return CollectionFilter;
}(_Base_js__WEBPACK_IMPORTED_MODULE_21__["default"].mixin(_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_24__["default"]));


CollectionFilter._$name = 'CollectionFilter';

/***/ }),

/***/ "./lib/Core/util/CollectionSorter.js":
/*!*******************************************!*\
  !*** ./lib/Core/util/CollectionSorter.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CollectionSorter; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/util/CollectionSorter
 */

/**
 * A class which encapsulates a single sorter operation which may be applied to any object to decide whether to
 * include or exclude it from a set.
 *
 * A CollectionSorter generally has two properties:
 *
 * * `property` - The name of a property in collection objects by which to sort
 * * `direction` - The sort direction, `'ASC'` or `'DESC'`.
 *
 * It may also be configured with just a {@link #config-sortFn} function which returns the desired comparison
 * result when passed two objects to compare. Note that this does *not* require or use the
 * {@link #config-property} config. Two collection items are passed for comparison.
 *
 * Further configurations may affect how the sorter is applied:
 *
 * * `convert` - A function which, when passed the {@link #config-property} value from
 * a collection object, returns the value to sort by.
 *
 * A CollectionSorter may be configured to encapsulate a {@link #config-sortFn} by passing that function as the sole
 * parameter to the constructor:
 *
 *     new CollectionSorter((lhs, rhs) => {
 *         lhs = lhs.customerDetails.companyName.toLowerCase();
 *         rhs = rhs.customerDetails.companyName.toLowerCase();
 *
 *         if (lhs < rhs) {
 *             return -1;
 *         }
 *         else if (lhs > rhs) {
 *             return 1;
 *         }
 *         else {
 *             return 0;
 *         }
 *     });
 *
 */

var CollectionSorter = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(CollectionSorter, _Base);

  var _super = _createSuper(CollectionSorter);

  function CollectionSorter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, CollectionSorter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(CollectionSorter, [{
    key: "construct",
    value: function construct(config) {
      if (typeof config === 'function') {
        config = {
          sortFn: config
        };
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(CollectionSorter.prototype), "construct", this).call(this, config);
    }
    /**
     * When in a Collection (A Collection holds its Sorters in a Collection), we need an id.
     * @property {String}
     * @private
     */

  }, {
    key: "defaultSortFn",

    /**
     * Default sortFn used when no sortFn specified. Uses the {@link #config-property},
     * {@link #config-direction}, and {@link #config-convert}.
     * @private
    */
    value: function defaultSortFn(lhs, rhs) {
      var me = this,
          convert = me.convert,
          property = me.property,
          useLocaleSort = me.useLocaleSort,
          multiplier = me.direction.toLowerCase() === 'desc' ? -1 : 1;
      lhs = lhs[property];
      rhs = rhs[property];

      if (convert) {
        lhs = convert(lhs);
        rhs = convert(rhs);
      }

      if (useLocaleSort && lhs != null && rhs != null) {
        // Use systems locale
        if (useLocaleSort === true) {
          return String(lhs).localeCompare(rhs);
        } // Use specified locale


        if (typeof useLocaleSort === 'string') {
          return String(lhs).localeCompare(rhs, useLocaleSort);
        } // Use locale config


        if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default()(useLocaleSort) === 'object') {
          return String(lhs).localeCompare(rhs, useLocaleSort.locale, useLocaleSort);
        }
      }

      return (lhs > rhs ? 1 : lhs < rhs ? -1 : 0) * multiplier;
    }
  }, {
    key: "id",
    get: function get() {
      return this._id || (this._id = this.property || _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].generateId('b-sorter'));
    },
    set: function set(id) {
      this._id = id;
    }
  }, {
    key: "sortFn",
    set: function set(sortFn) {
      this._sortFn = sortFn;
    },
    get: function get() {
      if (this._sortFn) {
        return this._sortFn;
      }

      return this.defaultSortFn;
    }
  }], [{
    key: "generateSortFunction",
    value: function generateSortFunction(sorters, tieBreaker) {
      var items = sorters.isCollection ? sorters.values : sorters,
          n = items.length;
      return function (lhs, rhs) {
        var comp, i;

        for (i = 0; i < n; ++i) {
          comp = items[i].sortFn(lhs, rhs);

          if (comp) {
            return comp;
          }
        }

        return tieBreaker ? tieBreaker(lhs, rhs) : 0;
      };
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The name of a property of collection objects which yields the value to sort by.
         * @config {String}
         */
        property: null,

        /**
         * The direction to sort in, `'ASC'` or `'DESC'`
         * @config {String}
         * @default
         */
        direction: 'ASC',

        /**
         * A function which takes the place of using {@link #config-property} and {@link #config-direction}.
         * The function is passed two objects from the collection to compare and must return the comparison result.
         * @config {Function}
         */
        sortFn: null,

        /**
         * When using {@link #config-property}, this may be specified as a function which takes the raw
         * property value and returns the value to actually sort by.
         * @config {Function}
         */
        convert: null,

        /**
         * The `id` of this Sorter for when used by a {@link Core.util.Collection} Collection.
         * By default the `id` is the {@link #config-property} value.
         * @config {String}
         */
        id: null,

        /**
         * Use `localeCompare()` when sorting, which lets the browser sort in a locale specific order. Set to `true`,
         * a locale string or a locale config to enable.
         *
         * Enabling this has big negative impact on sorting
         * performance. For more info on `localeCompare()`, see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare).
         *
         * ```javascript
         * collection.addSorter({ field: 'name', useLocaleSort : 'sv-SE' });
         * ```
         *
         * @config {Boolean|String|Object}
         * @default false
         */
        useLocaleSort: null
      };
    }
  }]);

  return CollectionSorter;
}(_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]);


CollectionSorter._$name = 'CollectionSorter';

/***/ }),

/***/ "./lib/Core/util/DynamicObject.js":
/*!****************************************!*\
  !*** ./lib/Core/util/DynamicObject.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicObject; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/util/DynamicObject
 */

var PENDING = Symbol('pendingCreate');
/**
 * This class is used to manage dynamic creation and configuration of individual properties of an object. This pattern
 * is used to allow the names of an object to each represent a dynamically instantiated object. For example, the
 * `features` config of Calendar is defined like so:
 *
 * ```javascript
 *  class Calendar extends ... {
 *      static get configurable() {
 *          return {
 *              features : {
 *                  drag : {
 *                      // configs for Drag feature
 *                  }
 *              }
 *          }
 *      }
 *  }
 * ```
 * This class is used to manage the `features` objects in the above case. The `drag` property value is promoted from
 * the config object defined by the class and user instance on first request. Like config properties themselves, these
 * features may access other features during their initialization. These accesses are trapped by this class to ensure
 * the config object is promoted to an instantiated instance.
 *
 * A {@link #config-factory} is provided to this object to allow it to create instances from names like `'drag'`.
 * @internal
 */

var DynamicObject = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(DynamicObject, _Base);

  var _super = _createSuper(DynamicObject);

  function DynamicObject() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, DynamicObject);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(DynamicObject, [{
    key: "define",

    /**
     * This method establishes the initial definition of a dynamic property. When using a `Proxy`, this method simply
     * needs to cache away the initial config for use by the getter. When `Proxy` is unavailable, this method will
     * also defined a getter/setter to intercept access to the dynamic property.
     * @param {String} name The name of the dynamic property.
     * @param {Object} config The initial config object for the dynamic property.
     * @private
     */
    value: function define(name, config) {
      this.instances[name] = PENDING;
      this.setDefaults(name, config); // We provide get/set accessors on our `object` so that we can create the instance on first use and provide
      // the correct defaults. The setter also handles reassignment and reconfiguration. These accessors are
      // placed on the prototype of `object` so that we can add/remove the same accessors from `object` itself.
      // This allows users of the object to see the correct number of "own" keys for enumeration.

      this.defineProp(name, true);
    }
    /**
     * Define the get/set accessors for `name` on our `object` or its prototype.
     * @param {String} name
     * @param {Boolean} [base] Pass `true` to indicate the property should be defined on the prototype.
     * @private
     */

  }, {
    key: "defineProp",
    value: function defineProp(name, base) {
      var me = this,
          object = me.object;

      if (!me.proxy) {
        Reflect.defineProperty(base ? Object.getPrototypeOf(object) : object, name, {
          configurable: !base,
          enumerable: !base,
          get: function get() {
            return me.get(name);
          },
          set: function set(value) {
            return me.set(name, value);
          }
        });
      }
    }
    /**
     * Ensures that all defined members are touched to trigger their creation.
     * @internal
     */

  }, {
    key: "flush",
    value: function flush() {
      // Iterate the defaults object to loop over all the defined items:
      for (var name in this.defaults) {
        this.get(name);
      }
    }
    /**
     * Returns (lazily creating as necessary) the value of a dynamic property given its name.
     * @param {String} name
     * @returns {Object}
     * @private
     */

  }, {
    key: "get",
    value: function get(name) {
      var defaults = this.defaults,
          instances = this.instances;

      if (instances[name] === PENDING) {
        this.set(name, PENDING);
      } // Return null for defined instances that have been nulled out and undefined otherwise:


      return instances[name] || defaults[name] && null;
    }
    /**
     * Sets the value of a dynamic property given its name and value.
     * @param {String} name
     * @param {Object} value
     * @private
     */

  }, {
    key: "set",
    value: function set(name, value) {
      var me = this,
          defaults = me.defaults,
          factory = me.factory,
          instances = me.instances,
          setup = me.setup,
          was = instances[name] === PENDING ? null : instances[name],
          instance = factory.reconfigure(was, value === PENDING ? {} : value || null, {
        defaults: defaults[name] || me.setDefaults(name, {}),
        owner: me.owner,
        setup: setup && function (config, type, defaults) {
          return setup(config, name, type, defaults);
        }
      });

      if (instance !== was) {
        instances[name] = instance;

        if (instance) {
          var _me$created;

          me.defineProp(name);
          (_me$created = me.created) === null || _me$created === void 0 ? void 0 : _me$created.call(me, instance, name);
        } else {
          delete me.object[name];
          delete instances[name];
        }
      }
    }
    /**
     * Stores the default config values for use in the factory reconfiguration process.
     * @param {String} name The name and default type of the dynamic property. Depending on {@link #config-inferType},
     * this may not be overridden by a type property in the config object.
     * @param {Object} config The config object.
     * @returns {Object}
     * @private
     */

  }, {
    key: "setDefaults",
    value: function setDefaults(name, config) {
      var defaults = this.defaults,
          factory = this.factory,
          inferType = this.inferType,
          instances = this.instances,
          owner = this.owner,
          ownerName = this.ownerName,
          typeKey = factory.factoryable.typeKey;
      config = config === true ? {} : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].assign({}, config); // copy props even from prototype

      if (inferType === 'name' || inferType === true && !config[typeKey]) {
        config[typeKey] = name;
      } // Store this object as the "owner" on the config object so instances can access their creating object:


      if (ownerName) {
        config[ownerName] = owner;
      }

      config.beforeConfigure = function (instance) {
        // Ensure the feature is injected into the features object before initialization so that it is
        // available to call chains from its initialization.
        instances[name] = instance;
      };

      return defaults[name] = config;
    }
    /**
     * Updates the members of `object` based on the provided configuration.
     * @param {Object} members The configuration for the instances of `object`.
     * @internal
     */

  }, {
    key: "update",
    value: function update(members) {
      var me = this;
      var name, config;

      if (members) {
        // We prime the features so that if any configuration code accesses a feature, it will self initialize,
        // but if not, they will remain in a primed state until afterConfigure.
        for (name in members) {
          config = members[name];

          if (me.defaults[name]) {
            // if (already defined)
            me.set(name, config);
          } else if (config) {
            me.define(name, config);
          }
        } // NOTE: we leave alone any existing features that were not present in the given object. To remove a
        // feature, you must set it to null or set all features to null.

      } else {
        for (name in me.instances) {
          me.set(name, null);
        }
      }
    }
  }, {
    key: "proxy",

    /**
     * Returns the `Proxy` instance used to manage dynamic assignments. If the JavaScript platform does not support the
     * `Proxy` class, this will be `null`.
     * @property {Proxy}
     * @private
     */
    get: function get() {
      var me = this;
      var proxy = null;

      if (me.proxyable) {
        proxy = new Proxy(me.instances, {
          get: function get(o, name) {
            return me.get(name);
          },
          set: function set(o, name, value) {
            me.set(name, value);
            return true;
          },
          deleteProperty: function deleteProperty(o, name) {
            me.set(name, null);
            return true;
          }
        });
      } // Replace our getter with the result for quicker future use.


      Reflect.defineProperty(me, 'proxy', {
        configurable: true,
        // allow destroy() to delete it
        value: proxy
      });
      return proxy;
    }
    /**
     * Returns the object that contains the dynamic properties. This may be a `Proxy` instance or an object with getter
     * and setter accessors.
     * @property {Object}
     * @internal
     */

  }, {
    key: "target",
    get: function get() {
      return this.proxy || this.object;
    }
  }], [{
    key: "prototypeProperties",
    get: function get() {
      return {
        /**
         * Optional function to call as instances are created. Each new instance is passed to this function.
         * @param {Object} instance The newly created instance.
         * @param {String} key The property name in the dynamic object by which the new instance may be referenced.
         * @config {Function}
         */
        created: null,

        /**
         * The {@link Core.mixin.Factoryable factory} to use to create instances.
         * @config {Object}
         */
        factory: null,

        /**
         * By default, the name of the member is used for the type. Set this config to `true` to also allow the
         * config object for a property to contain a `type` property. Set this to `false` to ignore the name of the
         * member and rely on the {@link #config-factory} to process the config object.
         * @config {Boolean|String}
         * @default
         */
        inferType: 'name',

        /**
         * The owning object to pass along to the instances as the `ownerName` property.
         * @config {Object}
         */
        owner: null,

        /**
         * The property name by which to store the `owner` on each instance.
         * @config {String}
         */
        ownerName: null,

        /**
         * Set to `false` to prevent using a `Proxy` even if that JavaScript platform feature is available. Using
         * a `Proxy` is ideal because it allows for all forms of access to the dynamic properties to be handled
         * instead of only those that have predefined configuration values.
         * @config {Boolean}
         * @private
         */
        proxyable: typeof Proxy !== 'undefined',

        /**
         * Optional function that will be passed a config object prior to instantiating an object. This function
         * can either modify the passed object or return a new object.
         * @param {Object} config The config object used to create the object
         * @param {String} name The property name in the Dynamic object by which the new instance may be referenced.
         * @config {Function}
         */
        setup: null
      };
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        /**
         * Holds config objects for each defined object. These are used to hold class and instance config values
         * and use them to create instances on first request, or when `flush()` is called. Further, if the instance
         * is initially assigned instead of retrieved, these values act as the defaults for the instance and are
         * combined with those provided in the assignment.
         * @member {Object} defaults
         * @private
         */
        defaults: {},

        /**
         * This object holds the actual instances that are retrieved by the dynamic accessor or `Proxy`.
         * @member {Object} instances
         * @private
         */
        instances: {},

        /**
         * The object that contains the dynamic accessors for each instance. This object is not used when using a
         * `Proxy`.
         * @member {Object} object
         * @private
         */
        object: Object.create({})
      };
    }
  }]);

  return DynamicObject;
}(_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]);


DynamicObject.initClass();
DynamicObject._$name = 'DynamicObject';

/***/ }),

/***/ "./lib/Core/util/Month.js":
/*!********************************!*\
  !*** ./lib/Core/util/Month.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Month; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_math_sign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.math.sign */ "./node_modules/core-js/modules/es.math.sign.js");
/* harmony import */ var core_js_modules_es_math_sign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_math_sign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/util/Month
 */

var sundayAndSaturday = {
  0: true,
  6: true
};
/**
 * A class which encapsulates a calendar view of a month, and offers information about
 * the weeks and days within that calendar view.
 * ```
 *   // December 2018 using Monday as week start
 *   const m = new Month({
 *       date         : '2018-12-01',
 *       weekStartDay : 1
 *   });
 *
 *   m.eachWeek((week, dates) => console.log(dates.map(d => d.getDate())))
 * ```
 */

var Month = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(Month, _Events);

  var _super = _createSuper(Month);

  function Month() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Month);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Month, [{
    key: "configure",
    //region events

    /**
     * Fired when setting the {@link #config-date} property causes the encapsulated date to change
     * in **any** way, date, week, month or year.
     * @event dateChange
     * @param {Core.util.Month} source The Month which triggered the event.
     * @param {Date} newDate The new encapsulated date value.
     * @param {Date} oldDate The previous encapsulated date value.
     * @param {Number} changes An object which contains properties which indicate what part of the date changed.
     * @param {Boolean} changes.d True if the date changed in any way.
     * @param {Boolean} changes.w True if the week changed (including same week in a different year).
     * @param {Boolean} changes.m True if the month changed (including same month in a different year).
     * @param {Boolean} changes.y True if the year changed.
     */

    /**
     * Fired when setting the {@link #config-date} property causes a change of week. Note that
     * weeks are calculated in the ISO standard form such that if there are fewer than four
     * days in the first week of a year, then that week is owned by the previous year.
     *
     * The {@link #config-weekStartDay} is honoured when making this calculation and this is a
     * locale-specific value which defaults to the ISO standard of 1 (Monday) in provided European
     * locales and 0 (Sunday) in the provided US English locale.
     * @event weekChange
     * @param {Core.util.Month} source The Month which triggered the event.
     * @param {Date} newDate The new encapsulated date value.
     * @param {Date} oldDate The previous encapsulated date value.
     * @param {Number} changes An object which contains properties which indicate what part of the date changed.
     * @param {Boolean} changes.d True if the date changed in any way.
     * @param {Boolean} changes.w True if the week changed (including same week in a different year).
     * @param {Boolean} changes.m True if the month changed (including same month in a different year).
     * @param {Boolean} changes.y True if the year changed.
     */

    /**
     * Fired when setting the {@link #config-date} property causes a change of month. This
     * will fire when changing to the same month in a different year.
     * @event monthChange
     * @param {Core.util.Month} source The Month which triggered the event.
     * @param {Date} newDate The new encapsulated date value.
     * @param {Date} oldDate The previous encapsulated date value.
     * @param {Number} changes An object which contains properties which indicate what part of the date changed.
     * @param {Boolean} changes.d True if the date changed in any way.
     * @param {Boolean} changes.w True if the week changed (including same week in a different year).
     * @param {Boolean} changes.m True if the month changed (including same month in a different year).
     * @param {Boolean} changes.y True if the year changed.
    */

    /**
     * Fired when setting the {@link #config-date} property causes a change of year.
     * @event yearChange
     * @param {Core.util.Month} source The Month which triggered the event.
     * @param {Date} newDate The new encapsulated date value.
     * @param {Date} oldDate The previous encapsulated date value.
     * @param {Number} changes An object which contains properties which indicate what part of the date changed.
     * @param {Boolean} changes.d True if the date changed in any way.
     * @param {Boolean} changes.w True if the week changed (including same week in a different year).
     * @param {Boolean} changes.m True if the month changed (including same month in a different year).
     * @param {Boolean} changes.y True if the year changed.
     */
    //endRegion

    /**
     * For use when this Month's `weekStartDay` is non-zero.
     *
     * An array to map the days of the week 0-6 of this Calendar to the canonical day numbers
     * used by the Javascript [Date](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) object.
     * @member {Number[]} canonicalDayNumbers
     * @readonly
     */

    /**
     * An array to map a canonical day number to a *visible* column index.
     * For example, if we have `weekStartDay` as Monday which is 1, and non working days as
     * Wednesday, and `hideNonWorkingDays : true`, then the calendar would look like
     *
     *```
     * ┌────┬────┬────┬────┬────┬────┐
     * | Mo | Tu | Th | Fr | Sa | Su |
     * └────┴────┴────┴────┴────┴────┘
     *```
     *
     * So we'd need this array: `[ 5, 0, 1, undefined, 2, 3, 4]`
     * @member {Number[]} visibleDayColumnIndex
     * @readonly
     */

    /**
     * An array to map a canonical day number to a 0-6 column index.
     * For example, if we have `weekStartDay` as Monday which is 1, then the calendar would look like
     *
     *```
     * ┌────┬────┬────┬────┬────┬────┬────┐
     * | Mo | Tu | We | Th | Fr | Sa | Su |
     * └────┴────┴────┴────┴────┴────┴────┘
     *```
     *
     * So we'd need this array: `[ 6, 0, 1, 2, 3, 4, 5]`
     * @member {Number[]} dayColumnIndex
     * @readonly
     */

    /**
     * The number of visible days in the week as defined by the `nonWorkingDays` and
     * `hideNonWorkingDays` options.
     * @member {Number} weekLength
     * @readonly
     */
    value: function configure(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Month.prototype), "configure", this).call(this, config); // The set is rejected during configuration because everything else has to be set up.


      if (config.date) {
        this.date = config.date;
      }
    }
  }, {
    key: "changeDate",
    value: function changeDate(date) {
      // Date has to be set after we know everything else
      if (this.isConfiguring) {
        return;
      }

      date = typeof date === 'string' ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].parse(date, 'YYYY-MM-DD') : new Date(date);

      if (isNaN(date)) {
        throw new Error('Month date ingestion must be passed a Date, or a valid YYYY-MM-DD date string');
      }

      return date;
    }
  }, {
    key: "updateDate",
    value: function updateDate(newDate, oldDate) {
      var me = this,
          dayColumnIndex = me.dayColumnIndex,
          monthStart = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].getFirstDateOfMonth(newDate),
          monthEnd = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].getLastDateOfMonth(monthStart),
          startWeekDay = dayColumnIndex[monthStart.getDay()],
          endWeekDay = dayColumnIndex[monthEnd.getDay()],
          yearChanged = !oldDate || newDate.getFullYear() !== oldDate.getFullYear(),
          changes = me.eventListeners && (oldDate ? newDate.getDate() !== oldDate.getDate() | (me.getWeekId(newDate) !== me.getWeekId(oldDate)) << 1 | (newDate.getMonth() !== oldDate.getMonth()) << 2 | yearChanged << 3 : 15); // Keep our properties in sync with reality.
      // Access the private properties directly to avoid recursion.

      me._year = newDate.getFullYear();
      me._month = newDate.getMonth(); // These comments assume ISO standard of Monday as week start day.
      //
      // This is the date of month that is the beginning of the first week row.
      // So this may be -ve. Eg: for Dec 2018, Monday 26th Nov is the first
      // cell on the calendar which is the -4th of December. Note that the 0th
      // of December was 31st of November, so needs -4 to get back to the 26th.

      me.startDayOfMonth = 1 - startWeekDay; // This is the date of month that is the end of the last week row.
      // So this may be > month end. Eg: for Dec 2018, Sunday 6th Jan is the last
      // cell on the calendar which is the 37th of December.

      me.endDayOfMonth = monthEnd.getDate() + (6 - endWeekDay);

      if (me.sixWeeks) {
        me.endDayOfMonth += (6 - me.weekCount) * 7;
      } // Calculate the start point of where we calculate weeks from if we need to.
      // It's either the first "weekStartDay" in this year if this year's
      // first week is last year's, and so should work out as zero,
      // or the "weekStartDay" of the week before, so that dates in the first week
      // the Math.floor(DH.diff(weekBase, date, 'day') / 7) calculates as 1.


      if (!me.weekBase || yearChanged) {
        me.calculateWeekBase();
      }

      if (changes) {
        var event = {
          newDate: newDate,
          oldDate: oldDate,
          changes: {
            d: true,
            w: Boolean(changes & 2),
            m: Boolean(changes & 12),
            y: Boolean(changes & 8)
          }
        }; // If either date, month or year changes, we fire a dateChange

        me.trigger('dateChange', event); // If the week has changed, fire a weekChange

        if (changes & 2) {
          me.trigger('weekChange', event);
        } // If month or year changed, we fire a monthChange


        if (changes & 12) {
          me.trigger('monthChange', event);
        } // If the year has changed, fire a yearChange


        if (changes & 8) {
          me.trigger('yearChange', event);
        }
      }
    }
  }, {
    key: "calculateWeekBase",
    value: function calculateWeekBase() {
      var me = this,
          dayColumnIndex = me.dayColumnIndex,
          jan1 = new Date(me.year, 0, 1),
          dec31 = new Date(me.year, 11, 31),
          january = me.month ? me.getOtherMonth(jan1) : me; // First 7 days are in last week of previous year if the year
      // starts after our 4th day of week.

      if (me.dayColumnIndex[jan1.getDay()] > 3) {
        // Week base is calculated from the year start
        me.weekBase = january.startDate;
      } // First 7 days are in week 1 of this year
      else {
          // Week base is the start of week before
          me.weekBase = new Date(me.year, 0, january.startDayOfMonth - 7);
        }

      var dec31Week = Math.floor(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].diff(me.weekBase, dec31, 'day') / 7); // Our year only has a 53rd week if 53rd week ends after our week's 3rd day

      me.has53weeks = dec31Week === 53 && dayColumnIndex[dec31.getDay()] > 2;
    }
    /**
     * Returns the week start date, based on the configured {@link #config-weekStartDay} of the
     * passed week.
     * @param {Number| Number[]} week The week number in the current year, or an array containing
     * `[year, weekOfYear]` for any year.
     *
     * Week numbers greater than the number of weeks in the year just wrap into the following year.
     */

  }, {
    key: "getWeekStart",
    value: function getWeekStart(week) {
      // Week number n of current year
      if (typeof week === 'number') {
        return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(this.weekBase, Math.max(week, 1) * 7, 'day');
      } // Week n of year nnnn


      var me = this,
          _week = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default()(week, 2),
          year = _week[0],
          weekOfYear = _week[1]; // nnnn is our year, so we know it


      if (year === me.year) {
        return me.getWeekStart(weekOfYear);
      }

      return me.getOtherMonth(new Date(year, 0, 1)).getWeekStart(weekOfYear);
    }
  }, {
    key: "getOtherMonth",
    value: function getOtherMonth(date) {
      var me = this,
          result = me === otherMonth ? new Month(null) : otherMonth;
      result.configure({
        weekBase: null,
        weekStartDay: me.weekStartDay,
        nonWorkingDays: me.nonWorkingDays,
        hideNonWorkingDays: me.hideNonWorkingDays,
        sixWeeks: me.sixWeeks
      });
      result.date = date;

      if (result.date !== date) {
        // in this case, the date config ignores changes w/=== getTime so we have to force the update because we
        // also cleared weekBase above
        result.updateDate(result.date, result.date);
      }

      return result;
    }
  }, {
    key: "changeYear",
    value: function changeYear(year) {
      var newDate = new Date(this.date);
      newDate.setFullYear(year); // changeDate rejects non-changes, otherwise a change event will be emitted

      this.date = newDate;
    }
  }, {
    key: "changeMonth",
    value: function changeMonth(month) {
      var newDate = new Date(this.date);
      newDate.setMonth(month); // changeDate rejects non-changes, otherwise a change event will be emitted

      this.date = newDate;
    }
  }, {
    key: "changeWeekStartDay",
    value: function changeWeekStartDay(weekStartDay) {
      return weekStartDay == null ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].weekStartDay : weekStartDay;
    }
  }, {
    key: "updateWeekStartDay",
    value: function updateWeekStartDay() {
      var me = this;
      me.updateDayNumbers();
      me.calculateWeekBase();

      if (!me.isConfiguring) {
        me.updateDate(me.date, me.date);
      }
    }
  }, {
    key: "updateNonWorkingDays",
    value: function updateNonWorkingDays() {
      this.updateDayNumbers();
    }
  }, {
    key: "updateHideNonWorkingDays",
    value: function updateHideNonWorkingDays() {
      this.updateDayNumbers();
    }
  }, {
    key: "updateSixWeeks",
    value: function updateSixWeeks() {
      if (!this.isConfiguring) {
        this.updateDate(this.date);
      }
    }
    /**
     * The number of days in the calendar for this month. This will always be
     * a multiple of 7, because this represents the number of calendar cells
     * occupied by this month.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "eachDay",

    /**
     * Iterates through all calendar cells in this month, calling the passed function for each date.
     * @param {Function} fn The function to call.
     * @param {Date} fn.date The date for the cell.
     */
    value: function eachDay(fn) {
      for (var dayOfMonth = this.startDayOfMonth; dayOfMonth <= this.endDayOfMonth; dayOfMonth++) {
        fn(new Date(this.year, this.month, dayOfMonth));
      }
    }
    /**
     * Iterates through all weeks in this month, calling the passed function
     * for each week.
     * @param {Function} fn The function to call.
     * @param {Number[]} fn.week An array containing `[year, weekNumber]`
     * @param {Date[]} fn.dates The dates for the week.
     */

  }, {
    key: "eachWeek",
    value: function eachWeek(fn) {
      var me = this,
          weekCount = me.weekCount;

      for (var dayOfMonth = me.startDayOfMonth, week = 0; week < weekCount; week++) {
        var weekDates = [],
            weekOfYear = me.getWeekNumber(new Date(me.year, me.month, dayOfMonth));

        for (var day = 0; day < 7; day++, dayOfMonth++) {
          weekDates.push(new Date(me.year, me.month, dayOfMonth));
        }

        fn(weekOfYear, weekDates);
      }
    }
    /**
     * Returns the week of the year for the passed date. This returns an array containing *two* values,
     * the year **and** the week number are returned.
     *
     * The week number is calculated according to ISO rules, meaning that if the first week of the year
     * contains less than four days, it is considered to be the last week of the preceding year.
     *
     * The configured {@link #config-weekStartDay} is honoured in this calculation. So if the weekStartday
     * is **NOT** the ISO standard of `1`, (Monday), then the weeks do not coincide with ISO weeks.
     * @param {Date} date The date to calculate the week for.
     * @returns {Number[]} A numeric array: `[year, week]`
     */

  }, {
    key: "getWeekNumber",
    value: function getWeekNumber(date) {
      var me = this;
      date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].clearTime(date); // If it's a date in another year, use our otherMonth to find the answer.

      if (date.getFullYear() !== me.year) {
        return me.getOtherMonth(new Date(date.getFullYear(), 0, 1)).getWeekNumber(date);
      }

      var weekNo = Math.floor(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].diff(me.weekBase, date, 'day') / 7),
          year = date.getFullYear(); // No week 0. It's the last week of last year

      if (!weekNo) {
        // Week is the week of last year's 31st Dec
        return me.getOtherMonth(new Date(me.year - 1, 0, 1)).getWeekNumber(new Date(me.year, 0, 0));
      } // Only week 53 if year ends before our week's 5th day
      else if (weekNo === 53 && !me.has53weeks) {
          weekNo = 1;
          year++;
        } // 54 wraps round to 2 of next year
        else if (weekNo > 53) {
            weekNo = weekNo % 52;
          } // Return array of year and week number


      return [year, weekNo];
    }
  }, {
    key: "getWeekId",
    value: function getWeekId(date) {
      var week = this.getWeekNumber(date);
      return week[0] * 100 + week[1];
    }
  }, {
    key: "getCellData",
    value: function getCellData(date) {
      var me = this,
          day = date.getDay(),
          visibleColumnIndex = me.visibleDayColumnIndex[day],
          isNonWorking = me.nonWorkingDays[day],
          isHiddenDay = me.hideNonWorkingDays && isNonWorking; // Automatically move to required month

      if (date < me.startDate || date > me.endDate) {
        me.month = date.getMonth();
      }

      return {
        day: day,
        visibleColumnIndex: visibleColumnIndex,
        isNonWorking: isNonWorking,
        week: me.getWeekNumber(date),
        key: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].format(date, 'YYYY-MM-DD'),
        columnIndex: me.dayColumnIndex[day],
        date: new Date(date),
        isOtherMonth: Math.sign(date.getMonth() + date.getFullYear() * 12 - (me.month + me.year * 12)),
        visible: !isHiddenDay && date >= me.startDate && date < _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(me.endDate, 1, 'day'),
        tomorrow: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(date, 1, 'day'),
        isRowStart: visibleColumnIndex === 0,
        isRowEnd: visibleColumnIndex === me.visibleColumnCount - 1
      };
    }
  }, {
    key: "updateDayNumbers",
    value: function updateDayNumbers() {
      var me = this,
          weekStartDay = me.weekStartDay,
          nonWorkingDays = me.nonWorkingDays,
          hideNonWorkingDays = me.hideNonWorkingDays,
          dayColumnIndex = me.dayColumnIndex = [],
          canonicalDayNumbers = me.canonicalDayNumbers = [],
          visibleDayColumnIndex = me.visibleDayColumnIndex = []; // So, if they set weekStartDay to 1 meaning Monday which is ISO standard, we will
      // have mapping of internal day number to canonical day number (as used by Date class)
      // and to abbreviated day name like this:
      // canonicalDayNumbers = [1, 2, 3, 4, 5, 6, 0] // Use for translation from our day number to Date class's day number
      //
      // Also, we need a map from canonical day number to *visible* cell index.
      // for example, if we have weekStartDay as Monday which is 1, and non working days as
      // Wednesday, and hideNonWorkingDays:true, then the calendar would look like
      // +----+----+----+----+----+----+
      // | Mo | Tu | Th | Fr | Sa | Su |
      // +----+----+----+----+----+----+
      //
      // So we'd need this array
      // [ 5, 0, 1, undefined, 2, 3, 4]
      // Or think of it as this map:
      // {
      //      1 : 0,
      //      2 : 1,
      //      4 : 2,
      //      5 : 3,
      //      6 : 4,
      //      0 : 5
      // }
      // To be able to ascertain the cell index directly from the canonical day number.
      //
      // We also need a logical column map which would be
      // +----+----+----+----+----+----+----+
      // | Mo | Tu | We | Th | Fr | Sa | Su |
      // +----+----+----+----+----+----+----+
      //
      // So we'd need this array
      // [ 6, 0, 1, 2, 3, 4, 5]
      // Or think of it as this map:
      // {
      //      1 : 0,
      //      2 : 1,
      //      3 : 2
      //      4 : 3,
      //      5 : 4,
      //      6 : 5,
      //      0 : 6
      // }
      // We use this to cache the number of visible columns so that cell renderers can tell whether
      // they are on the last visible column.

      var visibleColumnIndex = 0;

      for (var columnIndex = 0; columnIndex < 7; columnIndex++) {
        var canonicalDay = (weekStartDay + columnIndex) % 7;
        canonicalDayNumbers[columnIndex] = canonicalDay;
        dayColumnIndex[canonicalDay] = columnIndex; // If this day is going to have visible representation, we need to
        // map it to a columnIndex;

        if (!hideNonWorkingDays || !nonWorkingDays[canonicalDay]) {
          visibleDayColumnIndex[canonicalDay] = visibleColumnIndex++;
        }
      }

      me.visibleColumnCount = visibleColumnIndex;
      me.weekLength = hideNonWorkingDays ? 7 - _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].keys(nonWorkingDays).length : 7;
    }
  }, {
    key: "dayCount",
    get: function get() {
      // So for the example month, Dec 2018 has 42 days, from Mon 26th Nov (-4th Dec) 2018
      // to Sun 6th Jan (37th Dec) 2019
      return this.endDayOfMonth + 1 - this.startDayOfMonth;
    }
    /**
     * The number of weeks in the calendar for this month.
     * @property {Number}
     * @readonly
     */

  }, {
    key: "weekCount",
    get: function get() {
      return this.dayCount / 7;
    }
    /**
     * The date of the first cell in the calendar view of this month.
     * @property {Date}
     * @readonly
     */

  }, {
    key: "startDate",
    get: function get() {
      var me = this;

      if (me.year != null && me.month != null && me.startDayOfMonth != null) {
        return new Date(me.year, me.month, me.startDayOfMonth);
      }
    }
    /**
     * The date of the last cell in the calendar view of this month.
     * @property {Date}
     * @readonly
     */

  }, {
    key: "endDate",
    get: function get() {
      var me = this;

      if (me.year != null && me.month != null && me.startDayOfMonth != null) {
        return new Date(me.year, me.month, me.endDayOfMonth);
      }
    }
  }], [{
    key: "configurable",
    get: function get() {
      return {
        /**
         * The date which the month should encapsulate. May be a `Date` object, or a
         * `YYYY-MM-DD` format string.
         *
         * Mutating a passed `Date` after initializing a `Month` object has no effect on
         * the `Month` object.
         * @config {Date|String}
         */
        date: {
          $config: {
            equal: 'date'
          },
          value: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].clearTime(new Date())
        },
        month: null,
        year: null,

        /**
         * Week start day override. Defaults to the locale's {@link Core.helper.DateHelper#property-weekStartDay-static}.
         * @config {Number}
         */
        weekStartDay: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].weekStartDay,

        /**
         * Configure as `true` to have the visibleDayColumnIndex and visibleColumnCount properties
         * respect the configured {@link #config-nonWorkingDays}.
         * @config {Boolean}
         */
        hideNonWorkingDays: null,

        /**
         * defaults to `{0 : true, 6 : true}`. Specifies which *canonical* day numbers are non working days.
         * @config {Object}
         */
        nonWorkingDays: sundayAndSaturday,

        /**
         * Configure as `true` to always have the month encapsulate six weeks.
         * This is useful for UIs which must be a fixed height.
         * @config {Boolean}
         */
        sixWeeks: null
      };
    }
  }]);

  return Month;
}(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_14__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_13__["default"])); // Instance needed for internal tasks



var otherMonth = new Month(null);
Month._$name = 'Month';

/***/ }),

/***/ "./lib/Core/util/Parser.js":
/*!*********************************!*\
  !*** ./lib/Core/util/Parser.js ***!
  \*********************************/
/*! exports provided: memo, memoCps, success, failure, isSuccess, resolveParser, succeed, string, bind, seq, alt, regexp, red, runParser, defineParser, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "memo", function() { return memo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "memoCps", function() { return memoCps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "success", function() { return success; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "failure", function() { return failure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSuccess", function() { return isSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveParser", function() { return resolveParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "succeed", function() { return succeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "string", function() { return string; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return bind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "seq", function() { return seq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alt", function() { return alt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "regexp", function() { return regexp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runParser", function() { return runParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineParser", function() { return defineParser; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.weak-map */ "./node_modules/core-js/modules/es.weak-map.js");
/* harmony import */ var core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_map__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_weak_map_delete_all__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.weak-map.delete-all */ "./node_modules/core-js/modules/esnext.weak-map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_weak_map_delete_all__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_weak_map_delete_all__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");



































var productName = 'scheduler';
 // The code is based on https://epsil.github.io/gll/ article.

/**
 * @module Core/util/Parser
 */
// Tools. Maybe move it to memoization module.

var nextObjectIdentity = 0;
var objectIdentityMap = new WeakMap();

var argsToCacheKey = function argsToCacheKey() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.map(function (arg) {
    var result;

    if (arg && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_34___default()(arg) == 'object' || typeof arg == 'function') {
      result = objectIdentityMap.get(arg);

      if (result === undefined) {
        result = ++nextObjectIdentity;
        objectIdentityMap.set(arg, result);
      }
    } else {
      result = String(arg);
    }

    return result;
  }).join('-');
};
/**
 * Generic memoization function. Wraps `fn` into higher order function which caches `fn` result
 * using stringified arguments as the cache key.
 *
 * @param {Function} fn function to memoize
 */


var memo = function memo(fn) {
  var mlist = new Map();
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var mkey = argsToCacheKey(args);
    var result = mlist.get(mkey);

    if (result === undefined) {
      result = fn.apply(void 0, args);
      mlist.set(mkey, result);
    }

    return result;
  };
};
/**
 * Specific memoization function caches `fn` calls. `fn` should recieve 2 arguments, the first one
 * is a string, and the second one is a callback which should be called by `fn` with some result.
 * The function returned wraps `fn` and it's callback such that `fn` would be called only once
 * with a particular first argument, other time callback will be called instantly with the result cached.
 *
 * @param {Function} fn function to memoize
 */

var memoCps = function memoCps(fn) {
  var table = new Map(),
      entryContinuations = function entryContinuations(entry) {
    return entry[0];
  },
      entryResults = function entryResults(entry) {
    return entry[1];
  },
      pushContinuation = function pushContinuation(entry, cont) {
    return entryContinuations(entry).push(cont);
  },
      pushResult = function pushResult(entry, result) {
    return entryResults(entry).push(result);
  },
      isResultSubsumed = function isResultSubsumed(entry, result) {
    return entryResults(entry).some(function (r) {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].isEqual(r, result);
    });
  },
      makeEntry = function makeEntry() {
    return [[], []];
  },
      isEmptyEntry = function isEmptyEntry(entry) {
    return !entryResults(entry).length && !entryContinuations(entry).length;
  },
      tableRef = function tableRef(str) {
    var entry = table.get(str);

    if (entry === undefined) {
      entry = makeEntry();
      table.set(str, entry);
    }

    return entry;
  };

  return function (str, cont) {
    var entry = tableRef(str);

    if (isEmptyEntry(entry)) {
      pushContinuation(entry, cont);
      fn(str, function (result) {
        if (!isResultSubsumed(entry, result)) {
          pushResult(entry, result);
          entryContinuations(entry).forEach(function (cont) {
            return cont(result);
          });
        }
      });
    } else {
      pushContinuation(entry, cont);
      entryResults(entry).forEach(function (result) {
        return cont(result);
      });
    }
  };
}; // End of tools

var SUCCESS = Symbol('success');
var FAILURE = Symbol('failure');
/**
 * Successfull parsing result. Represented as array with 3 items:
 * - SUCCESS symbol which can be checked with {@link #function-isSuccess} function.
 * - Parsed payload
 * - Rest string left to parse
 *
 * @typedef {Array} SuccessResult
 */

/**
 * Creates successull parsing result with parsed `val` and unparsed `rest`
 *
 * @param {String} val Parsed value
 * @param {String} rest Unparsed rest
 * @return {SuccessResult}
 */

var success = function success(val, rest) {
  return [SUCCESS, val, rest];
};
/**
 * Failure parsing result. Represented as array with 2 items:
 * - FAILURE symbol which can be checked with {@link #function-isSuccess} function
 * - Rest string left to parse
 *
 * @typedef {Array} FailureResult
 */

/**
 * Creates failed parsing result with unparsed `rest`
 *
 * @param {String} rest Unparsed rest
 * @return {FailureResult}
 */

var failure = function failure(rest) {
  return [FAILURE, rest];
};
/**
 * Checks if the given parsing `result` is successfull
 *
 * @param {SuccessfullResult|FailureResult} result
 */

var isSuccess = function isSuccess(result) {
  return result.length && result[0] === SUCCESS;
};
/**
 * Resolves parser when needed. Parser should be resolved if it's defined as a function
 * with no arguments which returns the actual parser function with more then one argument.
 *
 * @param {Function} p Parser factory
 * @return {Function} Combinable parser function
 */

var resolveParser = function resolveParser(p) {
  return typeof p === 'function' && !p.length ? p() : p;
};
/**
 * Returns combinable parser which always return successfull parsing result with `val`
 * as parsed result and string parsed as `rest`.
 *
 * @param {*} val Succefull parsing result parsed payload
 * @return {Function} Combinable parser function
 *
 * @example
 * const sp = succeed('Ok');
 * sp('My string', (r) => console.dir(r)) // Will output successfull parsing result with `Ok` payload and `My string` rest.
 */

var succeed = memo(function (val) {
  return memoCps(function (str, cont) {
    return cont(success(val, str));
  });
});
/**
 * Returns combinable parser which succeeds if string parsed starts with `match`. The parsing
 * result will contain `match` as parsed result and rest of the string characters,
 * the ones after `match` as the unparsed rest.
 *
 * @param {String} match String to match
 * @return {Function} Combinable parser function
 *
 * @example
 * const mp = string('My');
 * mp('My string', (r) => console.dir(r)); // Will output successfull parsing result with `My` payload and `string` rest.
 */

var string = memo(function (match) {
  return memoCps(function (str, cont) {
    var len = Math.min(match.length, str.length),
        head = str.substr(0, len),
        tail = str.substr(len);
    cont(head === match ? success(head, tail) : failure(tail));
  });
});
/**
 * Binds parser or parser factory with a `fn` function which should recieve one string argument
 * and return a combinable parser function.
 *
 * @param {Function} p Combinable parser function or combinable parser factory which can be
 *                     resolved using with {@link #function-resolveParser}.
 * @param {Function} fn A function recieving one string argument and returning combinable parser function.
 *
 * @internal
 */

var bind = function bind(p, fn) {
  return function (str, cont) {
    return resolveParser(p)(str, function (result) {
      if (isSuccess(result)) {
        var _result = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_33___default()(result, 3),
            val = _result[1],
            rest = _result[2];

        fn(val)(rest, cont);
      } else {
        cont(result);
      }
    });
  };
};
/**
 * Combines several combined parser functions or combinable parser factories in sequence such that second starts after first succeeds
 * third after second etc, if first fails then second will not be called and so on.
 *
 * @param {...Function} parsers Combinable parser function or combinable parser factory which can be
 *                      resolved using with {@link #function-resolveParser}.
 * @returns {Function} Combinable parser function
 *
 * @example
 * const ab = seq(string('a'), string('b'));
 * ab('abc', (r) => console.dir(r)); // Will output successfull parsing result with `ab` as parsed payload and `c` as the rest.
 */

var seq = memo(function () {
  var seq2 = memo(function (a, b) {
    return memoCps(bind(a, function (x) {
      return bind(b, function (y) {
        return succeed([].concat(x, y));
      });
    }));
  });

  for (var _len3 = arguments.length, parsers = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    parsers[_key3] = arguments[_key3];
  }

  return parsers.reduce(seq2, succeed([]));
});
/**
 * Combines several combined parser functions or combinable parser factories in alteration such that successfull parsing result will be passed into
 * a callback if one of those parsers succeeds.
 *
 * @param {...Function} parsers Combinable parser function or combinable parser factory which can be
 *                      resolved using with {@link #function-resolveParser}.
 * @returns {Function} Combinable parser function
 *
 * @example
 * const aorb = alt(string('a'), string('b'));
 * aorb('abc', (r) => console.dir(r)); // Will output successfull parsing result with `a` as parsed payload and `bc` as the rest.
 * aorb('bbc', (r) => console.dir(r)); // Will output successfull parsing result with `b` as parsed payload and `bc` as the rest.
 */

var alt = memo(function () {
  for (var _len4 = arguments.length, parsers = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    parsers[_key4] = arguments[_key4];
  }

  return memoCps(function (str, cont) {
    return parsers.forEach(function (p) {
      return resolveParser(p)(str, cont);
    });
  });
});
/**
 * Creates combinable parser which succeeds if string to parse starts from a substring which succeeds for the regular expression
 * `pattern` the parser is created with.
 *
 * @param {String} pattern Regular expression pattern
 * @return {Function} Combinable parser function
 *
 * @example
 * const rp = regexp('a+');
 * rp('aaabb', (r) => console.dir(r)); // Will output successfull parsing result with `aaa` as parsed payload and `bb` as the rest.
 */

var regexp = memo(function (pattern) {
  return function (str, cont) {
    var rexp = new RegExp("^".concat(pattern)),
        match = rexp.exec(str);

    if (match) {
      var head = match[0],
          tail = str.substr(head.length);
      cont(success(head, tail));
    } else {
      cont(failure(str));
    }
  };
});
/**
 * Creates reducing combinable parser function which should be used to create semantic actions
 * on parsed results.
 *
 * @param {Function} p Combinable parser function or combinable parser factory which can be
 *                     resolved using with {@link #function-resolveParser}.
 * @param {Function} fn Semantic action function should be the same arity as the successfull result arity
 *                      of `p` parser.
 * @return {Function} Combinable parser function
 *
 * @example
 * const nump = red(
 *     regexp('\d'),
 *     Number
 * );
 *
 * const plusp = string('+');
 *
 * const sump = red(
 *     seq(nump, plusp, nump),
 *     (a, _, b) => a + b
 * );
 *
 * sump('7+8', (r) => console.dir(r)); // Will return successfull parsing result with `15` as parsing payload and `` as rest.
 */

var red = memo(function (p, fn) {
  return bind(p, function () {
    for (var _len5 = arguments.length, val = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      val[_key5] = arguments[_key5];
    }

    return succeed(fn.apply(void 0, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_32___default()([].concat.apply([], val))));
  });
});
/**
 * Runs combinable parsing function returning totaly parsed results only, i.e. such results which have
 * parsed the `str` string completely.
 *
 * @param {Function} body Combinable parser function
 * @param {String} str String to parse
 * @return {SuccessfullResult[]} All totaly parsed results possible for the given parsing function.
 */

var runParser = function runParser(body, str) {
  var results = [];
  body(str, function (result) {
    if (isSuccess(result)) {
      var _result2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_33___default()(result, 3),
          left = _result2[2];

      if (left === '') {
        results.push(result);
      }
    }
  });
  return results;
};
/**
 * Helper function for combinable parser definition supplements combinable parser function
 * returning a higher order function which when called with 2 arguments (string to parse and
 * a callback function) behaves exactly like parser function, but when called with 1 argument
 * it wraps call to parser function with {@link function-runParser} thus returning array of
 * totaly parsed results.
 *
 * @param {Function} body Combinable parser function
 */

var defineParser = function defineParser(body) {
  return function (str, cont) {
    return cont ? resolveParser(body)(str, cont) : runParser(resolveParser(body), str);
  };
};
/**
 * Combines exports in an object such that it was possible to export parser utilities
 * in UMD/module bundles.
 *
 * @example
 * import Parser from 'Core/util/Parser.js';
 * const {string, alt, seq, success, red, defineParser} = Parser;
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  memo: memo,
  memoCps: memoCps,
  success: success,
  failure: failure,
  isSuccess: isSuccess,
  resolveParser: resolveParser,
  succeed: succeed,
  string: string,
  bind: bind,
  seq: seq,
  alt: alt,
  regexp: regexp,
  red: red,
  runParser: runParser,
  defineParser: defineParser
});

/***/ }),

/***/ "./lib/Core/util/drag/DragContext.js":
/*!*******************************************!*\
  !*** ./lib/Core/util/drag/DragContext.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragContext; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../mixin/Finalizable.js */ "./lib/Core/mixin/Finalizable.js");
/* harmony import */ var _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");





































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Core/util/drag/DragContext
 */

var ABORTED = Symbol('dragAbort'),
    // Drag has been aborted
INIT = Symbol('dragInit'),
    // Button is down but insufficient movement to start the drag
DRAGGING = Symbol('dragDrag'),
    // Button is down and movement has started a drag
DROPPED = Symbol('dragDrop'),
    // Button has been released and drop has occurred
lockDirections = {
  x: 'horizontal',
  y: 'vertical'
};
/**
 * This class is created during drag operations of {@link Core/mixin/Draggable}. It holds the state of an ongoing drag
 * operation.
 * @extends Core/Base
 * @internal
 */

var DragContext = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default()(DragContext, _Base$mixin);

  var _super = _createSuper(DragContext);

  function DragContext() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default()(this, DragContext);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default()(DragContext, [{
    key: "construct",

    /**
     * The current DOM event being processed.
     * @member {Event} event
     * @readonly
     */
    value: function construct() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(DragContext.prototype), "construct", this)).call.apply(_get2, [this].concat(args));

      var me = this,
          event = me.event;
      Object.assign(me, {
        /**
         * This property holds the `altKey` state of the most recent event.
         * @member {Boolean}
         */
        altKey: null,

        /**
         * An array of functions to call when cleaning up the context instance.
         * @member {Function[]}
         * @private
         */
        cleaners: [],

        /**
         * This property holds the `ctrlKey` state of the most recent event.
         * @member {Boolean}
         */
        ctrlKey: null,

        /**
         * Container for data associated with the drag. Data items are added by the {@link Core.mixin.Draggable}
         * when the drag starts.
         * @member {Map}
         * @private
         */
        data: new Map(),

        /**
         * The element from which the drag operation started.
         * @member {HTMLElement}
         * @readonly
         */
        element: event.target,

        /**
         * The event that completed the drag (a `mouseup`, `pointerup` or `touchend`).
         * @member {Event}
         * @readonly
         */
        endEvent: null,

        /**
         * The most recent `mousemove`, `pointermove` or `touchmove` event.
         * @member {Event}
         * @private
         */
        lastMoveEvent: null,

        /**
         * This property holds the `metaKey` state of the most recent event.
         * @member {Boolean}
         */
        metaKey: null,

        /**
         * The scroll actions reported by the {@link #config-scrollManager}.
         * @member {Object}
         * @private
         */
        scrollerAction: null,

        /**
         * This property holds the `shiftKey` state of the most recent event.
         * @member {Boolean}
         */
        shiftKey: null,

        /**
         * This property holds the current state of the drag process.
         *
         * This will be one of the following values:
         *
         *  - `DragContext.STATE.ABORTED` - The drag has been aborted.
         *  - `DragContext.STATE.INIT` - The button is down but there is insufficient movement to start the drag.
         *  - `DragContext.STATE.DRAGGING` - The button is down and movement has started the drag.
         *  - `DragContext.STATE.DROPPED` - The button has been released and drop has occurred.
         *
         * @member {Symbol}
         * @readonly
         * @internal
         */
        state: INIT,

        /**
         * The event that started the drag operation.
         * @member {Event}
         * @readonly
         */
        startEvent: event,

        /**
         * The timer that fires when a touch pointermove is allowed to start the drag. A touch pointermove event
         * prior to this will `abort()` the drag to allow touch scrolling.
         * @member {Number}
         * @private
         */
        touchStartTimer: null,

        /**
         * Stores the value from writes to the {@link #property-valid} property.
         * @member {Boolean}
         * @private
         */
        _valid: true
      });

      if ('touches' in event) {
        me.touchStartTimer = me.setTimeout(function () {
          return me.touchStartTimer = null;
        }, me.touchStartDelay, 'touchStartDelay');
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this,
          source = me.source,
          target = me.target;
      me.cleanup();

      if ((target === null || target === void 0 ? void 0 : target.dropping) === me) {
        target.dropping = null;
      }

      if ((source === null || source === void 0 ? void 0 : source.dragging) === me) {
        source.dragging = null;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(DragContext.prototype), "doDestroy", this).call(this);
    }
    /**
     * This property is `true` if the {@link #function-abort} method was called and `false` otherwise. This
     * is typically because the user pressed the ESC key, however, a drag can be aborted for other reasons.
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "get",
    //region Data Access

    /**
     * Retrieves a data item from the drag source. This method can only be called after the drag has completed.
     * @param {String|String[]} name The name of the data item.
     * @returns {*}
     * @async
     */
    value: function () {
      var _get3 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_29___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_27___default.a.mark(function _callee(name) {
        var _this = this;

        var value;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_27___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.aborted) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Data is not available on aborted drag');

              case 2:
                if (this.completed) {
                  _context.next = 4;
                  break;
                }

                throw new Error('Data is not available until drag completion');

              case 4:
                if (!Array.isArray(name)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", Promise.all(name.map(function (s) {
                  return _this.get(s);
                })));

              case 6:
                value = this.data.get(name);

                if (!(typeof value === 'function')) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return value();

              case 10:
                value = _context.sent;
                this.data.set(name, value);

              case 12:
                return _context.abrupt("return", value);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x) {
        return _get3.apply(this, arguments);
      }

      return get;
    }()
    /**
     * Returns `true` if the named data item is present.
     * @param {String} name The name of the data item.
     * @returns {Boolean}
     */

  }, {
    key: "has",
    value: function has(name) {
      return this.data.has(name);
    }
    /**
     * Retrieves a data item from the drag source if it is available. This will return `true` for an item that was
     * {@link #function-set} using a renderer function.
     * @param {String|String[]} name The name of the data item.
     * @returns {*}
     */

  }, {
    key: "peek",
    value: function peek(name) {
      var _this2 = this;

      if (this.aborted) {
        throw new Error('Data is not available on aborted drag');
      }

      if (Array.isArray(name)) {
        return name.map(function (s) {
          return _this2.peek(s);
        });
      }

      var value = this.data.get(name);

      if (typeof value === 'function') {
        value = true;
      }

      return value;
    }
    /**
     * Sets a data item for the drag. If a function is passed, it is called to render the data only if that data is
     * actually requested via the {@link #function-get} method. A data renderer function can be `async`.
     * @param {String} name The name of the data item.
     * @param {*} value The value of the data item.
     */

  }, {
    key: "set",
    value: function set(name, value) {
      this.data.set(name, value);
    } //endregion
    //region Configs

  }, {
    key: "changeTarget",
    value: function changeTarget(target, was) {
      if (target !== was) {
        var me = this;
        me._target = target;

        if (was) {
          was.dropping = null;
        }

        if (target) {
          target.dropping = me; // calls dragEnter/Leave on the target

          if (target.dropping !== me) {
            // if (target did not accept us)
            target = null;
            me.valid = false;
          }
        }

        me._target = was;
      }

      return target;
    }
  }, {
    key: "updateTarget",
    value: function updateTarget(target, was) {
      var me = this;
      was && me.source.dragLeaveTarget(me, was);

      if (target) {
        me.valid = true; // Always give the target an initial dragMove since feedback/indicators will need to update on move and
        // the lack of a move on entry will just make that a special case.

        target.dragMove(me);
        me.source.dragEnterTarget(me);
      }
    }
  }, {
    key: "updateTargetElement",
    value: function updateTargetElement(targetElement) {
      var target = targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest('.b-droppable'); // The selected drop target must *contain* the event target element.
      // Otherwise we can get a hit on borders,

      if (target && target.compareDocumentPosition(targetElement) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        // The following runs updateTarget and informs the target:
        this.target = _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_41__["default"].get(target, 'droppable') || null;
      }
    } //endregion
    //region Operations

    /**
     * Aborts the drag. After calling this method, {@link #property-aborted} will be `true`, {@link #property-valid}
     * will be `false` and {@link #property-completed} will be `true`.
     */

  }, {
    key: "abort",
    value: function abort() {
      var me = this,
          element = me.element,
          source = me.source; // Force a synchronous layout so that transitions from this point will work.

      element === null || element === void 0 ? void 0 : element.getBoundingClientRect();

      if (me.state !== DROPPED) {
        me.state = ABORTED;
        me.cleanup();
      }

      source === null || source === void 0 ? void 0 : source.endDrag(me);
    }
  }, {
    key: "begin",
    value: function begin() {
      var me = this,
          source = me.source;

      if (source.beforeDrag(me) !== false) {
        source.dragging = me;
      }
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var cleaner;

      while (cleaner = this.cleaners.pop()) {
        cleaner();
      }
    }
  }, {
    key: "end",
    value: function end(event) {
      var me = this,
          lastEvent = me.lastMoveEvent,
          target = me.target,
          dragSwallowClickTime = me.source.dragSwallowClickTime;
      me.event = me.endEvent = event;
      me.syncFlags();

      if (me.started) {
        if ((lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.clientX) !== event.clientX || (lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.clientY) !== event.clientY || (lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.target) !== event.target) {
          // Make sure the drop event is preceded by a move to the final position...
          me.track();
        }

        if (dragSwallowClickTime) {
          // Prevent the impending document click from the mouseup event from propagating
          // into a click on our element.
          _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].on({
            element: document,
            capture: true,
            expires: dragSwallowClickTime,
            // In case a click did not ensue, remove the listener
            once: true,
            click: function click(event) {
              event.stopPropagation();
            }
          });
        }

        me.state = DROPPED;

        if (target !== me.source) {
          // If we are the target and not also the source, we need to call dropDrop() now. If we are
          // the source, dragDrop() will be called by Draggable.
          target === null || target === void 0 ? void 0 : target.dragDrop(me);
        }
      }
    }
  }, {
    key: "fakeKey",
    value: function fakeKey(event, down) {
      var me = this,
          lastMoveEvent = me.lastMoveEvent;

      if (lastMoveEvent && me.element) {
        var changed; // Indicate that this is a 'fake' mousemove event as a result of the keydown

        lastMoveEvent.isKey = true;

        if (event.key === 'Alt') {
          if (me.altKey !== down) {
            me.altKey = down;
            changed = true;
          }
        } else if (event.key === 'Control') {
          if (me.ctrlKey !== down) {
            me.ctrlKey = down;
            changed = true;
          }
        }

        if (changed) {
          me.event = lastMoveEvent;
          me.track();
        }
      }
    }
  }, {
    key: "keyDown",
    value: function keyDown(event) {
      if (!this.completed) {
        if (event.key === 'Escape') {
          this.abort();
        } else if (this.isDragToggleKey(event.key)) {
          this.fakeKey(event, true);
        }
      }
    }
  }, {
    key: "keyUp",
    value: function keyUp(event) {
      if (!this.completed && this.isDragToggleKey(event.key)) {
        this.fakeKey(event, false);
      }
    }
  }, {
    key: "getDistance",
    value: function getDistance(event) {
      return _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getDistanceBetween(this.startEvent, event);
    }
  }, {
    key: "isDragToggleKey",
    value: function isDragToggleKey(key) {
      return key === 'Control' || key === 'Alt';
    }
  }, {
    key: "move",
    value: function move(event) {
      var me = this,
          target = event.target,
          distance = me.getDistance(event),
          significant = distance >= me.threshold;
      me.syncFlags();

      if (me.touchStartTimer) {
        if (significant) {
          me.abort();
        }

        return;
      }

      if (target && target.nodeType === Node.ELEMENT_NODE) {
        if (significant && !me.started) {
          me.event = event; // triggers beforeDragStart, dragStart. returning false from beforeDragStart aborts drag

          if (me.start() === false) {
            me.abort();
            return;
          }
        }

        if (me.started) {
          me.lastMoveEvent = me.event = event; // to prevent view drag (scroll) on ipad

          if (event.type === 'touchmove') {
            event.preventDefault();
            event.stopImmediatePropagation();
          }

          me.track();
        }
      }
    }
  }, {
    key: "start",
    value: function start() {
      var me = this,
          scrollManager = me.scrollManager,
          source = me.source,
          activeCls = source.draggingBodyCls,
          dragLock = source.dragLock,
          element =
      /* source.dragWithin || */
      source.dragRootElement;
      me.state = DRAGGING; // Now that the drag drop is confirmed to be starting, activate the configured scrollManager if present

      if (scrollManager) {
        scrollManager.startMonitoring({
          thisObj: source,
          direction: lockDirections[dragLock] || dragLock || 'both',
          element: element,
          callback: function callback(scrollerAction) {
            var lastMoveEvent = me.lastMoveEvent;

            if (lastMoveEvent && me.element) {
              // Indicate that this is a 'fake' mousemove event as a result of the scrolling
              lastMoveEvent.isScroll = true;
              me.event = lastMoveEvent;
              me.scrollerAction = scrollerAction;
              me.track();
              me.scrollerAction = null;
            }
          }
        });
        me.cleaners.push(function () {
          return scrollManager.stopMonitoring(element);
        });
      } // Global informational class for when DragHelper is dragging


      document.body.classList.add(activeCls);
      me.cleaners.push(function () {
        return document.body.classList.remove(activeCls);
      });

      if (source.startDrag(me) === false) {
        me.cleanup();
        return false;
      }
    }
  }, {
    key: "syncFlags",
    value: function syncFlags() {
      var me = this,
          event = me.event;
      me.altKey = event.altKey;
      me.ctrlKey = event.ctrlKey;
      me.metaKey = event.metaKey;
      me.shiftKey = event.shiftKey;
    }
  }, {
    key: "track",
    value: function track() {
      var me = this,
          event = me.event,
          source = me.source,
          target = me.target;
      var targetElement = event.target,
          touch; // NOTE: we cannot syncFlags here since we are called to pass along keydown events as movement updates
      // "pointer-events:none" touchmove has no effect for the touchmove event target, meaning we cannot know
      // what's under the cursor as easily in touch devices

      if (event.type === 'touchmove') {
        touch = event.changedTouches[0]; // From MDN:
        //  * clientX/Y - the coordinates of the touch point relative to the left/top edge of the browser viewport,
        //    not including any scroll offset.
        //  * The elementFromPoint() method returns the topmost Element at the specified coordinates (relative to
        //    the viewport).

        targetElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].elementFromPoint(touch.clientX, touch.clientY);
      }

      me.targetElement = targetElement; // when we change elements, update me.target

      if (target === me.target) {
        // if we have a target and that did not change due to setting targetElement, we need to inform the target
        // of the drag move
        target === null || target === void 0 ? void 0 : target.dragMove(me);
      }

      source.trackDrag(me);
    } //endregion

  }, {
    key: "aborted",
    get: function get() {
      return this.state === ABORTED;
    }
    /**
     * Returns `true` if the drag has completed either by mouse/pointerup or the {@link #function-abort} method.
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "completed",
    get: function get() {
      return this.aborted || this.endEvent !== null;
    }
    /**
     * This property is set to `true` if the drag {@link #config-threshold} is reached and the drag operation
     * becomes active.
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "started",
    get: function get() {
      return this.state !== INIT && !this.aborted;
    }
    /**
     * This property is `true` when the drag is in a valid drop state. This can be set to `false` to indicate the drop
     * is invalid. Setting to `true` does not ensure that the property will be `true` when next read due to other factors
     * that are required to make the drop valid. For example, setting `valid = true` will still return `false` if called
     * before the drag {@link #config-threshold} has not been reached or if the {@link #function-abort} method has been
     * called.
     * @property {Boolean}
     */

  }, {
    key: "valid",
    get: function get() {
      return this.started && this.targetElement != null && this._valid;
    },
    set: function set(v) {
      this._valid = v;
    }
  }], [{
    key: "configurable",
    get: function get() {
      return {
        /**
         * The element that will have the {@link Core.mixin.Draggable#property-draggingItemCls}. This element is
         * determined by the {@link Core.mixin.Draggable#config-dragItemSelector}.
         * @config {HTMLElement}
         */
        itemElement: null,

        /**
         * The `ScrollManager` instance to use for scrolling while dragging.
         * @config {Grid.util.ScrollManager}
         * @private
         */
        scrollManager: null,

        /**
         * The source of the drag operation.
         * @config {Core.mixin.Draggable}
         * @default
         * @readonly
         */
        source: null,

        /**
         * The current target element of the drag.
         * @member {Core.mixin.Droppable}
         * @readonly
         */
        target: null,

        /**
         * The current target element of the drag.
         * @member {HTMLElement}
         * @private
         */
        targetElement: null,

        /**
         * The minimum distance from the touchstart/mousedown/pointerdown that must be moved to actually start a
         * drag operation.
         * @config {Number}
         * @default
         * @readonly
         */
        threshold: 5,

        /**
         * The minimum amount of time a touch must be maintained before it will initiate a drag. Movement prior to
         * this time will cancel the drag in order to allow touch scrolling.
         * @config {Number}
         * @default
         */
        touchStartDelay: 300
      };
    }
  }]);

  return DragContext;
}(_Base_js__WEBPACK_IMPORTED_MODULE_36__["default"].mixin(_mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_40__["default"], _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_39__["default"]));


DragContext.prototype.STATE = DragContext.STATE = Object.freeze({
  ABORTED: ABORTED,
  INIT: INIT,
  DRAGGING: DRAGGING,
  DROPPED: DROPPED
});
DragContext._$name = 'DragContext';

/***/ }),

/***/ "./lib/Core/util/drag/DragProxy.js":
/*!*****************************************!*\
  !*** ./lib/Core/util/drag/DragProxy.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragProxy; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/util/drag/DragProxy
 */

/**
 * Drag proxies are helper classes that represent the object being dragged in some visual way. This is an abstract
 * base with which particular drag proxy classes (such as, {@link Core.util.drag.DragTipProxy} are registered.
 *
 * Derived classes the various template methods of this class to manage their particular form of visual feedback.
 * @extends Core/Base
 * @internal
 */

var DragProxy = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DragProxy, _Base$mixin);

  var _super = _createSuper(DragProxy);

  function DragProxy() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DragProxy);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DragProxy, [{
    key: "updateDragging",

    /**
     * The `Draggable` instance that owns this drag proxy.
     * @member {Core.mixin.Draggable} owner
     * @readonly
     */
    //region Configs
    value: function updateDragging(drag, was) {
      if (was) {
        this.close(was);
      }

      if (drag) {
        this.open(drag);
      }
    } //endregion
    //region Operations

    /**
     * This template method is called when {@link #config-dragging} is reset to `null`.
     * @param {Core.util.drag.DragContext} drag The drag instance.
     */

  }, {
    key: "close",
    value: function close(drag) {// template
    }
    /**
     * This template method is called when {@link #config-dragging} is set to a non-`null` value.
     * @param {Core.util.drag.DragContext} drag The drag instance.
     */

  }, {
    key: "open",
    value: function open(drag) {// template
    } //endregion
    //region Drag Processing

    /**
     * This template method is called by the `Draggable` instance when the drag officially starts.
      * This sets the {@link #config-dragging} config to `drag`, which triggers the call to {@link #function-open}.
     * @param {Core.util.drag.DragContext} drag The drag instance.
     */

  }, {
    key: "dragStart",
    value: function dragStart(drag) {
      this.dragging = drag;
    }
    /**
     * This template method is called by the `Draggable` instance as drag movement occurs.
     * @param {Core.util.drag.DragContext} drag The drag instance.
     */

  }, {
    key: "dragMove",
    value: function dragMove(drag) {// template
    }
    /**
     * This template method is called by the `Draggable` instance when the drag completes.
     *
     * This sets the {@link #config-dragging} config to `null`, which triggers the call to {@link #function-close}.
     * @param {Core.util.drag.DragContext} drag The drag instance.
     */

  }, {
    key: "dragEnd",
    value: function dragEnd(drag) {
      this.dragging = null;
    } //endregion

  }], [{
    key: "type",
    get: function get() {
      return 'default';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * The currently active `DragContext`. This context will be active prior to be passed to the proxy. This
         * config is set by {@link #function-dragStart} and cleared by {@link #function-dragEnd}.
         * @config {Core.util.drag.DragContext}
         */
        dragging: null
      };
    }
  }, {
    key: "factoryable",
    get: function get() {
      return {
        defaultType: DragProxy
      };
    }
  }]);

  return DragProxy;
}(_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"].mixin(_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_9__["default"]));


DragProxy.initClass();
DragProxy._$name = 'DragProxy';

/***/ }),

/***/ "./lib/Core/util/drag/DragTipProxy.js":
/*!********************************************!*\
  !*** ./lib/Core/util/drag/DragTipProxy.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragTipProxy; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _DragProxy_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./DragProxy.js */ "./lib/Core/util/drag/DragProxy.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



 // Remove this once https://github.com/eslint/eslint/issues/12822 is address (allowing "foo?.bar()" to be accepted):

/* eslint-disable no-unused-expressions */

/**
 * @module Core/util/drag/DragTipProxy
 */

/**
 * This drag proxy manages a {@link #config-tooltip} (or derived class) and aligns the tooltip to the current drag
 * position adjusted by the {@link #config-align} config.
 * @extends Core/util/drag/DragProxy
 * @classtype tip
 * @internal
 */

var DragTipProxy = /*#__PURE__*/function (_DragProxy) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DragTipProxy, _DragProxy);

  var _super = _createSuper(DragTipProxy);

  function DragTipProxy() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DragTipProxy);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DragTipProxy, [{
    key: "open",
    value: function open() {
      this.getConfig('tooltip'); // trigger creation
    }
  }, {
    key: "close",
    value: function close() {
      var _this$tooltip;

      (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.hide();
    }
  }, {
    key: "dragMove",
    value: function dragMove(drag) {
      var offset = this.offset,
          tooltip = this.tooltip,
          event = drag.event;

      if (tooltip) {
        if (!tooltip.isVisible) {
          tooltip.show();
        }

        tooltip.alignTo({
          align: this.align,
          target: new _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_10__["default"](event.clientX - offset, event.clientY - offset, offset * 2, offset * 2)
        });
      }
    }
  }, {
    key: "changeTooltip",
    value: function changeTooltip(config, existing) {
      return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"].reconfigure(existing, config,
      /* owner = */
      this);
    }
  }], [{
    key: "type",
    get: function get() {
      return 'tip';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Controls how the tooltip will be aligned to the current drag position.
         *
         * See {@link Core.helper.util.Rectangle#function-alignTo} for details.
         * @config {String}
         * @default
         */
        align: 't10-b50',

        /**
         * The number of pixels to offset from the drag position.
         * @config {Number}
         * @default
         */
        offset: 20,

        /**
         * The tooltip to be shown, hidden and repositioned to track the drag position.
         * @config {Core.widget.Tooltip}
         */
        tooltip: {
          $config: ['lazy', 'nullify'],
          value: {
            type: 'tooltip'
          }
        }
      };
    }
  }]);

  return DragTipProxy;
}(_DragProxy_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


DragTipProxy.initClass();
DragTipProxy._$name = 'DragTipProxy';

/***/ }),

/***/ "./lib/Core/widget/BooleanCombo.js":
/*!*****************************************!*\
  !*** ./lib/Core/widget/BooleanCombo.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BooleanCombo; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _data_Store_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * Boolean combo, a combo box with two options corresponding to true or false.
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 *
 * @classType booleancombo
 * @extends Core/widget/Combo
 */

var BooleanCombo = /*#__PURE__*/function (_Localizable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(BooleanCombo, _Localizable);

  var _super = _createSuper(BooleanCombo);

  function BooleanCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, BooleanCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(BooleanCombo, [{
    key: "changeStore",
    //endregion
    value: function changeStore(store, oldStore) {
      var me = this; // We must call super.changeStore() in order to deduce valueField. We also cannot just pass an array since it
      // will convert to a store and call back here (infinite recursion).

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(BooleanCombo.prototype), "changeStore", this).call(this, new _data_Store_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
        data: [{
          id: me.positiveValue,
          text: me.positiveText || me.L('L{Object.Yes}')
        }, {
          id: me.negativeValue,
          text: me.negativeText || me.L('L{Object.No}')
        }]
      }), oldStore);
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'BooleanCombo';
    }
  }, {
    key: "type",
    get: function get() {
      return 'booleancombo';
    } //region Config

  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Positive option value
         *
         * @config {*}
         */
        positiveValue: true,

        /**
         * Positive option display value
         *
         * @config {String}
         */
        positiveText: null,

        /**
         * Negative option value
         *
         * @config {*}
         */
        negativeValue: false,

        /**
         * False option display value
         *
         * @config {String}
         */
        negativeText: null,
        store: {
          value: [],
          $config: 'lazy'
        },

        /**
         * Default value
         *
         * @config {*}
         */
        value: false
      };
    }
  }]);

  return BooleanCombo;
}(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_11__["default"])(_Combo_js__WEBPACK_IMPORTED_MODULE_9__["default"])); // Register this widget type with its Factory



BooleanCombo.initClass();
BooleanCombo._$name = 'BooleanCombo';

/***/ }),

/***/ "./lib/Core/widget/Button.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Button.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Button; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _mixin_Badge_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./mixin/Badge.js */ "./lib/Core/widget/mixin/Badge.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");













function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5___default()(["\n            <", " ", " ", " class=\"", " ", "\" ", ">\n                <label data-reference=\"label\">\xA0</label>\n            </", ">\n        "], ["\n            <", " ", " ", " class=\"", " ", "\" ", ">\n                <label data-reference=\"label\">\\xa0</label>\n            </", ">\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





 //TODO: should togglebutton be own class implemented as input type=checkbox?
//TODO: A toggling widget's focusElement should be an opacity:0 input type=checkbox which covers the clickable area.

/**
 * @module Core/widget/Button
 */

var bIcon = /^b-icon-/,
    bFa = /^b-fa-/;
/**
 * Button widget, wraps and styles a regular <code>&lt;button&gt;</code> element. Can display text and icon and allows specifying button color.
 *
 * @extends Core/widget/Widget
 * @mixes Core/widget/mixin/Badge
 *
 * @example
 * // button with text and icon
 * let button = new Button({
 *   icon: 'b-fa-plus-circle',
 *   text: 'Add',
 *   color: 'green',
 *   onClick: () => {}
 * });
 *
 * @classType button
 * @externalexample widget/Button.js
 */

var Button = /*#__PURE__*/function (_Badge) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Button, _Badge);

  var _super = _createSuper(Button);

  function Button() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Button);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Button, [{
    key: "template",
    value: function template() {
      var me = this,
          tag = me.href ? 'a' : 'button';
      return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].tpl(_templateObject(), tag, tag === 'a' ? "href=\"".concat(me.href, "\"") : '', tag === 'a' && me.target ? "target=\"".concat(me.target, "\"") : '', me.color || '', me.toggleable && me.pressed ? 'b-pressed' : '', me.toggleGroup ? "data-group=\"".concat(me.toggleGroup, "\"") : '', tag);
    } //endregion
    //region Construct/Destroy

  }, {
    key: "construct",
    value: function construct() {
      var _get2;

      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (config.toggleGroup || config.menu) {
        config.toggleable = true;
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Button.prototype), "construct", this)).call.apply(_get2, [this, config].concat(args));

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].on({
        element: this.element,
        click: 'onInternalClick',
        thisObj: this
      });
    } //endregion

    /**
     * Iterate over all widgets owned by this widget and any descendants.
     *
     * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
     * functions. If the expression executed evaluates to `false`, iteration will terminate.
     *
     * _Due to the {@link #config-menu} config being a lazy config and only being converted to be a
     * `Menu` instance just before it's shown, the menu will not be part of the iteration before
     * it has been shown once_.
     * @function eachWidget
     * @param {Function} fn A function to execute upon all descendant widgets.
     * Iteration terminates if this function returns `false`.
     * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
     * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
     */

  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Button.prototype), "onFocusOut", this).call(this, e);

      if (this.menu) {
        this.menu.hide();
      }
    } //region Getters/Setters

  }, {
    key: "changeText",
    value: function changeText(text) {
      return text == null ? '' : text;
    }
  }, {
    key: "updateText",
    value: function updateText(text) {
      var element = this.element,
          label = this.label;
      label.innerText = text;
      element.classList[String(text).length ? 'add' : 'remove']('b-text');
    }
  }, {
    key: "changeMenu",
    value: function changeMenu(menu, oldMenu) {
      var me = this;

      if (menu) {
        // In case the reason for the hide is a mousedown
        // on this button, and it's not hiding because we are being destroyed,
        // wait until after any impending click handler to sync our state with the visibility.
        var onHide = function onHide() {
          return !me.isDestroying && me.setTimeout(function () {
            return me.toggle(false);
          }, me.onMenuHideTimeout);
        };

        if (menu.isWidget) {
          menu.forElement = me.element;
          menu.on('hide', onHide);
        } else {
          // This covers both Array and Object which are valid items config formats.
          // menu could be { itemRef : { text : 'sub item 1 } }. But if it has
          // child items or html property in it, it's the main config
          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default()(menu) === 'object' && !('type' in menu || 'items' in menu || 'widgets' in menu || 'html' in menu)) {
            menu = {
              lazyItems: menu
            };
          }

          menu = _Widget_js__WEBPACK_IMPORTED_MODULE_12__["default"].reconfigure(oldMenu, menu ? _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_17__["default"].merge({
            constrainTo: me.menuContainerElement,
            forElement: me.element,
            owner: me,
            onHide: onHide
          }, me.menuDefaults, menu) : null, me);
        }
      } else {
        if (oldMenu) {
          oldMenu.destroy();
        }
      }

      return menu;
    }
  }, {
    key: "updateMenu",
    value: function updateMenu(menu) {
      // We are toggleable if there's a menu.
      // Pressed means menu visible, not pressed means menu hidden.
      this.toggleable = Boolean(menu);
    }
  }, {
    key: "updatePressed",
    value: function updatePressed(pressed) {
      var me = this;

      if (pressed && me.toggleGroup) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].forEachSelector("button[data-group=".concat(me.toggleGroup, "]"), function (btnEl) {
          if (btnEl !== me.element) {
            _Widget_js__WEBPACK_IMPORTED_MODULE_12__["default"].getById(btnEl.id).toggle(false);
          }
        });
      }

      if (me.element) {
        me.element.classList[pressed ? 'add' : 'remove']('b-pressed');
      }
    }
  }, {
    key: "updateIcon",
    value: function updateIcon() {
      this.syncIconCls();
    }
  }, {
    key: "updatePressedIcon",
    value: function updatePressedIcon() {
      this.syncIconCls();
    }
  }, {
    key: "updateIconAlign",
    value: function updateIconAlign(iconAlign, oldAlign) {
      var classList = this.element.classList;

      if (oldAlign) {
        classList.remove("b-icon-align-".concat(oldAlign));
      }

      if (this.icon) {
        classList.add("b-icon-align-".concat(iconAlign));
      }
    } //endregion
    //region Events

    /**
     * Triggers events when user clicks button
     * @fires click
     * @fires action
     * @private
     */

  }, {
    key: "onInternalClick",
    value: function onInternalClick(event) {
      var me = this,
          bryntumEvent = {
        event: event
      };

      if (me.toggleable) {
        // Clicking the pressed button in a toggle group should do nothing
        if (me.toggleGroup && me.pressed) {
          return;
        }

        me.toggle(!me.pressed); // Edge case in dragfromgrid demo, where toggling mode destroys the Scheduler and thus destroys the toolbar
        // and the button in it

        if (me.isDestroyed) {
          return;
        }
      }
      /**
       * User clicked button
       * @event click
       * @property {Core.widget.Button} button - Clicked button
       * @property {Event} event - DOM event
       */


      me.trigger('click', bryntumEvent);
      /**
       * User performed the default action (clicked the button)
       * @event action
       * @property {Core.widget.Button} button - Clicked button
       * @property {Event} event - DOM event
       */
      // A handler may have resulted in destruction.

      if (!me.isDestroyed) {
        me.trigger('action', bryntumEvent);
      } // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onClick and onAction


      if (!this.href) {
        // stop the event since it has been handled
        event.preventDefault();
        event.stopPropagation();
      }
    } //endregion
    //region Toggle

    /**
     * Toggle button state (only use with toggleable = true)
     * @param {Boolean} pressed Specify to force a certain toggle state
     * @fires toggle
     */

  }, {
    key: "toggle",
    value: function toggle() {
      var pressed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var me = this,
          menu = me.menu;

      if (!me.toggleable) {
        return;
      }

      if (pressed === null) {
        pressed = !me.pressed;
      }

      me.pressed = pressed; // For handlers from the code below to detect and avoid recursion

      me.toggling = true;

      if (menu) {
        menu.minWidth = me.width;
        menu[pressed ? 'show' : 'hide']();
      }

      me.syncIconCls();
      /**
       * Button state was toggled
       * @event toggle
       * @property {Core.widget.Button} button - Button
       * @property {Boolean} pressed - New pressed state
       */

      me.trigger('toggle', {
        pressed: pressed
      });
      me.toggling = false;
    } //endregion
    //region Other

  }, {
    key: "syncIconCls",
    value: function syncIconCls() {
      var me = this;
      var iconEl = me._iconEl;

      if (me.icon) {
        if (!iconEl) {
          iconEl = me._iconEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createElement({
            tag: 'i',
            nextSibling: me.element.firstChild
          });
        }

        var iconCls = me.pressed && me.pressedIcon ? me.pressedIcon : me.icon;
        me._iconEl.className = iconCls; // if it's a supplied icon class b-fa-xxx or b-icon-xxx, add extra class
        // so user doesn't have to; they can just specify the icon

        if (bIcon.test(iconCls)) {
          iconEl.classList.add('b-icon');
        } else if (bFa.test(iconCls)) {
          iconEl.classList.add('b-fa');
        }
      } else {
        iconEl && iconEl.remove();
      }
    } //endregion

  }, {
    key: "childItems",
    get: function get() {
      if (this._menu) {
        return [this.menu];
      }
    }
  }, {
    key: "focusElement",
    get: function get() {
      return this.element;
    }
  }, {
    key: "menuContainerElement",
    get: function get() {
      return document.body;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Button';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'button';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Get/set the Button icon
         * @property {String}
         * @name icon
         */

        /**
         * Button icon class.
         *
         * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
         *
         * Otherwise this is a developer-defined CSS class string which results in the desired icon.
         * @config {String}
         */
        icon: null,

        /**
         * Get/set the Button pressed icon
         * @property {String}
         * @name pressedIcon
         */

        /**
         * Icon class for the buttons pressed state. Only applies to toggle buttons
         *
         * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
         *
         * Otherwise this is a developer-defined CSS class string which results in the desired icon.
         *
         * ```
         * new Button({
         *    // Icon for unpressed button
         *    icon        : 'b-fa-wine-glass',
         *
         *    // Icon for pressed button
         *    pressedIcon : 'b-fa-wine-glass-alt',
         *
         *    // Only applies to toggle buttons
         *    toggleable  : true
         * });
         * ```
         *
         * @config {String}
         */
        pressedIcon: null,

        /**
         * Get/Set the Button icon alignment.
         * May be `'start'` or `'end'`. Defaults to `'start'`
         * @property {String}
         * @name iconAlign
         */

        /**
         * Button icon alignment. May be `'start'` or `'end'`. Defaults to `'start'`
         * @config {String}
         */
        iconAlign: 'start',

        /**
         * Get/set text displayed on the button.
         * @property {String}
         * @name text
         */

        /**
         * The button's text.
         * @config {String}
         */
        text: '',

        /**
         * Button color (should have match in button.scss or your custom styling). Valid values in Bryntum themes
         * are:
         * * b-amber
         * * b-blue
         * * b-dark-gray
         * * b-deep-orange
         * * b-gray
         * * b-green
         * * b-indigo
         * * b-lime
         * * b-light-gray
         * * b-light-green
         * * b-orange
         * * b-purple
         * * b-red
         * * b-teal
         * * b-white
         * * b-yellow
         * Combine with specifying `b-raised` for raised/filled style (theme dependent).
         *
         * ```
         * new Button({
         *    color : 'b-teal b-raised'
         * });
         * ```
         *
         * @config {String}
         */
        color: null,

        /**
         * Enabled toggling of the button (stays pressed when pressed).
         * @config {Boolean}
         * @default
         */
        toggleable: false,

        /**
         * Get/set button pressed state
         * @property {Boolean}
         * @name pressed
         */

        /**
         * Initially pressed or not. Only applies with `toggleable = true`.
         * ```
         * const toggleButton = new Button({
         *    toggleable : true,
         *    text : 'Enable cool action'
         * });
         * ```
         * @config {Boolean}
         * @default
         */
        pressed: false,

        /**
         * Indicate that this button is part of a group where only one button can be pressed. Assigning a value
         * also sets `toggleable` to `true`.
         * ```
         * const yesButton = new Button({
         *    toggleGroup : 'yesno',
         *    text        : 'Yes'
         * });
         *
         * const noButton = new Button({
         *    toggleGroup : 'yesno',
         *    text        : 'No'
         * });
         * ```
         * @config {String}
         */
        toggleGroup: null,
        ripple: {
          radius: 75
        },
        defaultBindProperty: 'text',
        localizableProperties: ['text'],

        /**
         * Returns the instantiated menu widget as configured by {@link #config-menu}.
         * @property {Core.widget.Widget}
         * @name menu
         */

        /**
         * A submenu configuration object, or an array of MenuItem configuration
         * objects from which to create a submenu which is shown when this button is pressed.
         *
         * Note that this does not have to be a Menu. The `type` config can be used
         * to specify any widget as the submenu.
         *
         * May also be specified as a fully instantiated {@link Core.widget.Widget#config-floating floating Widget}
         * such as a {@link Core.widget.Popup Popup}.
         * @config {Object|Object[]|Core.widget.Widget}
         */
        menu: {
          $config: ['lazy', 'nullify'],
          value: null
        },
        menuDefaults: {
          type: 'menu',
          autoShow: false,
          autoClose: true,
          floating: true,
          scrollAction: 'realign',
          align: 't0-b0'
        },

        /**
         * If provided, turns the button into a link
         * @config {String}
         */
        href: null,

        /**
         * The `target` attribute for the {@link #config-href} config
         * @config {String}
         */
        target: null,
        onMenuHideTimeout: 300,
        testConfig: {
          onMenuHideTimeout: 0
        }
      };
    }
  }]);

  return Button;
}(Object(_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_14__["default"])(_Widget_js__WEBPACK_IMPORTED_MODULE_12__["default"])); // Register this widget type with its Factory



Button.initClass();
Button._$name = 'Button';

/***/ }),

/***/ "./lib/Core/widget/ButtonGroup.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/ButtonGroup.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ButtonGroup; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");

















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/widget/ButtonGroup
 */

/**
 * A specialized container that holds buttons, displaying them in a horizontal group with borders adjusted to make them
 * stick together.
 *
 * Trying to add other widgets than buttons will throw an exception.
 *
 * ```javascript
 * new ButtonGroup({
 *   items : [
 *       { icon : 'b-fa b-fa-kiwi-bird' },
 *       { icon : 'b-fa b-fa-kiwi-otter' },
 *       { icon : 'b-fa b-fa-kiwi-rabbit' },
 *       ...
 *   ]
 * });
 * ```
 *
 * @externalexample widget/ButtonGroup.js
 * @classType buttonGroup
 * @extends Core/widget/Container
 */

var ButtonGroup = /*#__PURE__*/function (_Container) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ButtonGroup, _Container);

  var _super = _createSuper(ButtonGroup);

  function ButtonGroup() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, ButtonGroup);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(ButtonGroup, [{
    key: "updateReadOnly",
    value: function updateReadOnly(readOnly) {
      this.element.style.pointerEvents = readOnly ? 'none' : '';
    }
  }, {
    key: "onChildAdd",
    value: function onChildAdd(item) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ButtonGroup.prototype), "onChildAdd", this).call(this, item);

      item.on({
        click: 'onItemClick',
        thisObj: this
      });
    }
  }, {
    key: "onChildRemove",
    value: function onChildRemove(item) {
      item.un({
        click: 'onItemClick',
        thisObj: this
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ButtonGroup.prototype), "onChildAdd", this).call(this, item);
    }
  }, {
    key: "onItemClick",
    value: function onItemClick() {
      // reset cached value to revalidate next time it's requested
      this._value = null;
    }
  }, {
    key: "createWidget",
    value: function createWidget(widget) {
      var me = this,
          type = me.constructor.resolveType(widget.type || 'button');

      if (type.isButton) {
        if (me.color && !widget.color) {
          widget.color = me.color;
        }

        if (me.toggleGroup && !widget.toggleGroup) {
          if (typeof me.toggleGroup === 'boolean') {
            me.toggleGroup = ButtonGroup.generateId('toggleGroup');
          }

          widget.toggleGroup = me.toggleGroup;
        }
      }

      if (me.columns) {
        widget.width = "".concat(100 / me.columns, "%");
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ButtonGroup.prototype), "createWidget", this).call(this, widget);
    }
  }, {
    key: "value",
    get: function get() {
      // if we don't have cached value
      // let's calculate it based on item values
      if (!this._value) {
        var values = []; // collect pressed item values

        this.items.forEach(function (w) {
          if (w.pressed && w.value !== undefined) values.push(w.value);
        }); // build a string

        this._value = values.join(this.valueSeparator);
      }

      return this._value;
    },
    set: function set(value) {
      if (!Array.isArray(value)) {
        if (value === undefined || value === null) {
          value = [];
        } else if (typeof value == 'string') {
          value = value.split(this.valueSeparator);
        } else {
          value = [value];
        }
      }

      this._value = value; // reflect value on items

      this.items.forEach(function (w) {
        if (w.value !== undefined) {
          w.pressed = value.indexOf(w.value) > -1;
        }
      });
    }
  }, {
    key: "disabled",
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ButtonGroup.prototype), "disabled", this);
    },
    set: function set(state) {
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ButtonGroup.prototype), "disabled", state, this, true);

      this.items.forEach(function (w) {
        return w.disabled = state;
      });
    }
  }, {
    key: "widgetClassList",
    get: function get() {
      var classList = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ButtonGroup.prototype), "widgetClassList", this); // if the buttons should be shown in rows


      if (this.columns) classList.push('b-columned');
      return classList;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ButtonGroup';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'buttongroup';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        defaultType: 'button',

        /**
         * Custom CSS class to add to element. When using raised buttons (cls 'b-raised' on the buttons), the group
         * will look nicer if you also set that cls on the group.
         *
         * ```
         * new ButtonGroup({
         *   cls : 'b-raised,
         *   items : [
         *       { icon : 'b-fa b-fa-unicorn', cls : 'b-raised' },
         *       ...
         *   ]
         * });
         * ```
         *
         * @config {String}
         * @category CSS
         */
        cls: null,

        /**
         * An array of Buttons or typed Button config objects.
         * @config {Object[]|Core.widget.Button[]}
         */
        items: null,

        /**
         * Default color to apply to all contained buttons, see {@link Core.widget.Button#config-color Button#color}.
         * Individual buttons can override the default.
         * @config {String}
         */
        color: null,

        /**
         * Set to `true` to turn the ButtonGroup into a toggle group, assigning a generated value to each contained
         * buttons {@link Core.widget.Button#config-toggleGroup toggleGroup config}. Individual buttons can
         * override the default.
         */
        toggleGroup: null,
        valueSeparator: ',',
        columns: null
      };
    }
  }]);

  return ButtonGroup;
}(_Container_js__WEBPACK_IMPORTED_MODULE_16__["default"]); // Register this widget type with its Factory



ButtonGroup.initClass();
ButtonGroup._$name = 'ButtonGroup';

/***/ }),

/***/ "./lib/Core/widget/CalendarPanel.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/CalendarPanel.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarPanel; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _Panel_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _util_Month_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../util/Month.js */ "./lib/Core/util/Month.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Core/widget/CalendarPanel
 */

/**
 * A Panel which can display a month of date cells.
 *
 * This is a base class for UI widgets which need to make use of a calendar layout
 * and should not be used directly.
 * @extends Core/widget/Panel
 */

var CalendarPanel = /*#__PURE__*/function (_Panel) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(CalendarPanel, _Panel);

  var _super = _createSuper(CalendarPanel);

  function CalendarPanel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, CalendarPanel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(CalendarPanel, [{
    key: "construct",
    value: function construct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(CalendarPanel.prototype), "construct", this).call(this, config);

      if (!this.refreshCount) {
        this.refresh();
      }
    }
  }, {
    key: "onPaint",
    value: function onPaint(_ref) {
      var firstPaint = _ref.firstPaint;

      // Invoke the lazy configs when we first hit the visible DOM
      if (firstPaint) {
        // The cell structure must exist for the configs to apply to.
        if (!this.refreshCount) {
          this.refresh();
        }

        this.getConfig('minColumnWidth');
        this.getConfig('minRowHeight');
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.tip && this.tip.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(CalendarPanel.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "changeMinRowHeight",
    value: function changeMinRowHeight(minRowHeight) {
      // Fall back to 75 on platforms that do not support CSS vars
      var minValue = parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].getStyleValue(this.element, '--min-row-height'), 10) || 75;
      return minRowHeight == null ? minRowHeight : Math.max(parseInt(minRowHeight) || 0, minValue);
    }
  }, {
    key: "updateMinRowHeight",
    value: function updateMinRowHeight(minRowHeight) {
      this.weekElements.forEach(function (w) {
        return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].setLength(w, 'flexBasis', minRowHeight);
      });
      this.scrollable = {
        overflowY: minRowHeight ? 'auto' : false
      };
    }
  }, {
    key: "changeMinColumnWidth",
    value: function changeMinColumnWidth(minColumnWidth) {
      // Fall back to 75 on platforms that do not support CSS vars
      var minValue = parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].getStyleValue(this.element, '--min-column-width'), 10) || 75;
      return minColumnWidth == null ? minColumnWidth : Math.max(parseInt(minColumnWidth) || 0, minValue);
    }
  }, {
    key: "updateMinColumnWidth",
    value: function updateMinColumnWidth(minColumnWidth) {
      var me = this;
      me.weekdayCells.forEach(function (c) {
        return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].setLength(c, 'minWidth', minColumnWidth);
      });
      me.cellElements.forEach(function (c) {
        return c.matches(".".concat(me.dayCellCls)) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].setLength(c, 'minWidth', minColumnWidth);
      });
      me.scrollable = {
        overflowX: minColumnWidth ? 'auto' : false
      };
      me.overflowElement.classList[minColumnWidth ? 'add' : 'remove']('b-min-columnwidth');
    }
  }, {
    key: "getDateFromEvent",
    value: function getDateFromEvent(domEvent) {
      var element = (domEvent.nodeType === 1 ? domEvent : domEvent.target).closest("#".concat(this.id, " [data-date]"));

      if (element) {
        return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].parseKey(element.dataset.date);
      }
    }
  }, {
    key: "changeTip",
    value: function changeTip(tip, oldTip) {
      var listeners = {
        pointerOver: 'onTipOverCell',
        thisObj: this
      };

      if (oldTip) {
        oldTip.un(listeners);
      }

      if (tip) {
        if (!(tip instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_18__["default"])) {
          tip = _Widget_js__WEBPACK_IMPORTED_MODULE_18__["default"].create(Object.assign({
            owner: this,
            type: 'tooltip',
            id: "".concat(this.id, "-cell-tip"),
            forElement: this.bodyElement,
            forSelector: ".".concat(this.dayCellCls)
          }, tip));
        }

        tip.on(listeners);
      }

      return tip;
    }
  }, {
    key: "changeElement",
    value: function changeElement(element) {
      var me = this;
      element = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(CalendarPanel.prototype), "changeElement", this).apply(this, arguments);
      me.updateHideNonWorkingDays(me.hideNonWorkingDays);
      me.weekElements = Array.from(element.querySelectorAll('.b-calendar-week'));
      me.weekDayElements = Array.from(element.querySelectorAll('.b-calendar-days'));
      me.cellElements = [];

      for (var i = 0, length = me.weekDayElements.length; i < length; i++) {
        var _me$cellElements;

        (_me$cellElements = me.cellElements).push.apply(_me$cellElements, [me.weekDayElements[i].previousSibling].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_10___default()(me.weekDayElements[i].children)));
      }

      return element;
    }
  }, {
    key: "changeDate",
    value: function changeDate(date) {
      date = typeof date === 'string' ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].parse(date) : new Date(date);

      if (isNaN(date)) {
        throw new Error('CalendarPanel date ingestion must be passed a Date, or a YYYY-MM-DD date string');
      }

      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clearTime(date);
    }
    /**
     * The date which this CalendarPanel encapsulates. Setting this causes the
     * content to be refreshed.
     * @property {Date}
     */

  }, {
    key: "updateDate",
    value: function updateDate(value) {
      // We respond to Month change events to update the UI
      this.month.date = value;
    }
  }, {
    key: "updateDayNameFormat",
    value: function updateDayNameFormat() {
      // 4th June 2000 was a Sunday
      var d = new Date('2000-06-04T12:00:00');
      this.shortDayNames = []; // Collect local shortDayNames in default order.

      for (var date = 4; date < 11; date++) {
        d.setDate(date);
        this.shortDayNames.push(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].format(d, this.dayNameFormat));
      }
    }
  }, {
    key: "updateWeekStartDay",

    /**
     * Set to 0 for Sunday (the default), 1 for Monday etc.
     *
     * Set to `null` to use the default value from {@link Core.helper.DateHelper DateHelper}.
     */
    value: function updateWeekStartDay(weekStartDay) {
      var me = this;

      if (me._month) {
        me.month.weekStartDay = weekStartDay;
        me.dayNames = []; // So, if they set weekStartDay to 1 meaning Monday which is ISO standard, we will
        // dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

        for (var i = 0; i < 7; i++) {
          me.dayNames[i] = me.shortDayNames[me.canonicalDayNumbers[i]];
        }

        me.refresh();
      }
    }
  }, {
    key: "updateHideNonWorkingDays",
    value: function updateHideNonWorkingDays(hideNonWorkingDays) {
      var _this$scrollable;

      this.contentElement.classList[hideNonWorkingDays ? 'add' : 'remove'](this.hideNonWorkingDaysCls);
      (_this$scrollable = this.scrollable) === null || _this$scrollable === void 0 ? void 0 : _this$scrollable.syncOverflowState();

      if (this._month) {
        this.month.hideNonWorkingDays = hideNonWorkingDays;
      }
    }
  }, {
    key: "changeNonWorkingDays",
    value: function changeNonWorkingDays(nonWorkingDays) {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].assign({}, nonWorkingDays);
    }
  }, {
    key: "updateNonWorkingDays",
    value: function updateNonWorkingDays(nonWorkingDays) {
      if (this._month) {
        var _this$scrollable2;

        this.month.nonWorkingDays = nonWorkingDays;
        this.refresh();
        (_this$scrollable2 = this.scrollable) === null || _this$scrollable2 === void 0 ? void 0 : _this$scrollable2.syncOverflowState();
      }
    }
  }, {
    key: "changeMonth",
    value: function changeMonth(month, currentMonth) {
      var me = this;

      if (!(month instanceof _util_Month_js__WEBPACK_IMPORTED_MODULE_20__["default"])) {
        // Setting month to a number when we already have a Month means
        // just updating the month number of our Month
        if (typeof month === 'number') {
          if (currentMonth) {
            currentMonth.month = month;
            return;
          }

          var date = me.date || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clearTime(new Date());
          date.setMonth(month);
          month = {
            date: date
          };
        }

        month = new _util_Month_js__WEBPACK_IMPORTED_MODULE_20__["default"](_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].assign({
          weekStartDay: me.weekStartDay,
          nonWorkingDays: me.nonWorkingDays,
          hideNonWorkingDays: me.hideNonWorkingDays,
          sixWeeks: me.sixWeeks
        }, month));
      }

      month.on({
        dateChange: 'onMonthDateChange',
        thisObj: me
      });
      return month;
    }
  }, {
    key: "onMonthDateChange",
    value: function onMonthDateChange(_ref2) {
      var month = _ref2.source,
          newDate = _ref2.newDate,
          oldDate = _ref2.oldDate;
      var me = this; // Ensure we're always in sync with the data our Month holds

      me.year = month.year;

      if (!me.isConfiguring) {
        me.refresh();

        if (oldDate - newDate) {
          /**
           * Fires when the date of this CalendarPanel is set.
           * @event dateChange
           * @param {Date[]} value The new date.
           * @param {Date[]} oldValue The old date.
           */
          me.trigger('dateChange', {
            value: newDate,
            oldValue: oldDate
          });
        }
      }
    }
  }, {
    key: "updateYear",
    value: function updateYear(year) {
      this.month.year = year;
    }
  }, {
    key: "updateShowWeekNumber",
    value: function updateShowWeekNumber(showWeekNumber) {
      this.updateShowWeekColumn(showWeekNumber);
    }
  }, {
    key: "updateShowWeekColumn",
    value: function updateShowWeekColumn(showWeekColumn) {
      var me = this;
      me.element.classList[showWeekColumn ? 'add' : 'remove']('b-show-week-column');

      if (me.floating) {
        // Must realign because content change might change dimensions
        if (!me.isAligning) {
          me.realign();
        }
      }
    }
    /**
     * Refreshes the UI after changing a config that would affect the UI.
     */

  }, {
    key: "refresh",
    value: function refresh() {
      // This method may be overridden by subclasses to add things like refresh scheduling.
      this.doRefresh();
    }
    /**
     * Implementation of the UI refresh.
     * @private
     */

  }, {
    key: "doRefresh",
    value: function doRefresh() {
      // Ensure sub elements are all present
      this.getConfig('element');
      var me = this,
          today = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clearTime(new Date()),
          cellElements = me.cellElements,
          weekElements = me.weekElements,
          weekDayElements = me.weekDayElements,
          date = me.date,
          month = me.month,
          dayCellCls = me.dayCellCls,
          disabledCls = me.disabledCls,
          otherMonthCls = me.otherMonthCls,
          weekendCls = me.weekendCls,
          todayCls = me.todayCls,
          nonWorkingDayCls = me.nonWorkingDayCls,
          canonicalDayNumbers = me.canonicalDayNumbers; // If we have not been initialized with a current date, use today

      if (!date) {
        me.date = today;
      } // Make sure we've calculated our shortDayNames


      me.getConfig('dayNameFormat'); // Reset all cell classNames.
      // The lastDomConfig property must not be preserved if we are directly manipulating the DOM
      // and other code paths in the app use DomSync.

      for (var i = 0, len = cellElements.length; i < len; i++) {
        cellElements[i].lastDomConfig = null;
        cellElements[i].className = dayCellCls;
      }

      for (var columnIndex = 0; columnIndex < 7; columnIndex++) {
        var cell = me.weekdayCells[columnIndex],
            cellDay = me.canonicalDayNumbers[columnIndex],
            cellClassList = cell.classList;
        cell.className = cell.innerHTML = '';

        if (me.headerRenderer) {
          me.headerRenderer(cell, columnIndex, cellDay);
        } else {
          cell.innerHTML = me.shortDayNames[cellDay];
        }

        cellClassList.add('b-calendar-day-header');

        if (cellDay === 0 || cellDay === 6) {
          cellClassList.add(weekendCls);
        }

        if (me.nonWorkingDays[cellDay]) {
          cellClassList.add(nonWorkingDayCls);
        }

        cell.dataset.columnIndex = columnIndex;
        cell.dataset.cellDay = cellDay;
      } // Create cell content


      var weekIndex = 0,
          cellIndex = 0,
          lastWorkingColumn = 6; // Which column is the last working day so it can be tagged with an identifying class

      for (var _columnIndex = 6; _columnIndex >= 0; _columnIndex--) {
        if (!me.nonWorkingDays[canonicalDayNumbers[_columnIndex]]) {
          lastWorkingColumn = _columnIndex;
          break;
        }
      }

      month.eachWeek(function (week, dates) {
        var weekDayElement = weekDayElements[weekIndex],
            weekCells = [weekDayElement.previousSibling].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_10___default()(weekDayElement.children)); // Stamp week into week row's dataset

        weekElements[weekIndex].dataset.week = "".concat(week[0], ",").concat(week[1]);
        weekCells[0].className = 'b-week-number-cell';

        if (me.weekRenderer) {
          me.weekRenderer(weekCells[0], week);
        } else {
          weekCells[0].innerHTML = week[1];
        }

        for (var _columnIndex2 = 0; _columnIndex2 < 7; _columnIndex2++) {
          var _date = dates[_columnIndex2],
              day = _date.getDay(),
              _cell = weekCells[_columnIndex2 + 1],
              _cellClassList = _cell.classList;

          if (me.isDisabledDate(_date)) {
            _cellClassList.add(disabledCls);
          }

          if (_date.getMonth() !== month.month) {
            _cellClassList.add(otherMonthCls);
          }

          if (day === 0 || day === 6) {
            _cellClassList.add(weekendCls);
          }

          if (_date.getTime() === today.getTime()) {
            _cellClassList.add(todayCls);
          }

          if (me.nonWorkingDays[day]) {
            _cellClassList.add(nonWorkingDayCls);
          } // Tag the last working day in a week with a class


          _cellClassList[_columnIndex2 === lastWorkingColumn ? 'add' : 'remove']('b-last-working-day');

          _cell.dataset.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].makeKey(_date);
          _cell.dataset.cellIndex = cellIndex;
          _cell.dataset.columnIndex = _columnIndex2;

          if (me.cellRenderer) {
            me.cellRenderer({
              cell: _cell,
              date: _date,
              day: day,
              cellIndex: cellIndex,
              columnIndex: _columnIndex2,
              visibleColumnIndex: me.visibleDayColumnIndex[day],
              week: week
            });
          } else {
            _cell.innerHTML = _date.getDate();
          }

          cellIndex++;
        }

        weekIndex++;
      });

      if (me.floating) {
        // Must realign because content change might change dimensions
        if (!me.isAligning) {
          me.realign();
        }
      }

      me.refreshCount = (me.refreshCount || 0) + 1;
      /**
       * Fires when this CalendarPanel refreshes.
       * @event refresh
       */

      me.trigger('refresh');
    }
  }, {
    key: "isDisabledDate",
    value: function isDisabledDate(date) {
      var day = date.getDay(),
          disabledDates = this.disabledDates;

      if (this.disableWeekends && (day === 0 || day === 6)) {
        return true;
      }

      if (disabledDates) {
        if (typeof disabledDates === 'function') {
          return disabledDates(date);
        }

        if (Array.isArray(disabledDates)) {
          date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clearTime(date, true);
          return disabledDates.some(function (d) {
            return !(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clearTime(d, true) - date);
          });
        }
      }
    }
  }, {
    key: "getCell",
    value: function getCell(date) {
      if (!(typeof date === 'string')) {
        date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].makeKey(date);
      }

      return this.weeksElement.querySelector("[data-date=\"".concat(date, "\"]"));
    }
  }, {
    key: "onTipOverCell",
    value: function onTipOverCell(_ref3) {
      var tip = _ref3.source,
          target = _ref3.target;
      tip.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].parseKey(target.dataset.date);
    }
  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      this.updateDayNameFormat();
      this.updateWeekStartDay(this.weekStartDay);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(CalendarPanel.prototype), "updateLocalization", this).call(this);
    }
  }, {
    key: "overflowElement",
    get: function get() {
      return this.weeksElement;
    }
  }, {
    key: "weekStartDay",
    get: function get() {
      // This trick allows our weekStartDay to float w/the locale even if the locale changes
      return typeof this._weekStartDay === 'number' ? this._weekStartDay : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].weekStartDay;
    }
  }, {
    key: "visibleDayColumnIndex",
    get: function get() {
      return this.month.visibleDayColumnIndex;
    }
  }, {
    key: "dayColumnIndex",
    get: function get() {
      return this.month.dayColumnIndex;
    }
  }, {
    key: "canonicalDayNumbers",
    get: function get() {
      return this.month.canonicalDayNumbers;
    }
  }, {
    key: "visibleColumnCount",
    get: function get() {
      return this.month.visibleColumnCount;
    }
  }, {
    key: "weekLength",
    get: function get() {
      return this.month.weekLength;
    }
    /**
     * The date of the first day cell in this panel.
     * Note that this may *not* be the first of this panel's current month.
     * @property {Date}
     * @readonly
     */

  }, {
    key: "startDate",
    get: function get() {
      return this.month.startDate;
    }
  }, {
    key: "duration",
    get: function get() {
      // The endDate is "exclusive" because it means 00:00:00 of that day.
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].diff(this.month.startDate, this.month.endDate, 'day') + 1;
    }
    /**
     * The end date of this view. Note that in terms of full days, this is exclusive,
     * ie: 2020-01-012 to 2020-01-08 is *seven* days. The end is 00:00:00 on the 8th.
     *
     * Note that this may *not* be the last date of this panel's current month.
     * @property {Date}
     * @readonly
     */

  }, {
    key: "endDate",
    get: function get() {
      var endDate = this.month.endDate;

      if (endDate) {
        return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(endDate, 1, 'day');
      }
    }
  }, {
    key: "bodyConfig",
    get: function get() {
      var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(CalendarPanel.prototype), "bodyConfig", this),
          weeksContainerChildren = [];

      result.children = [{
        tag: 'div',
        className: 'b-calendar-row b-calendar-weekdays',
        reference: 'weekdaysHeader',
        children: this.dayNameCells
      }, {
        // `notranslate` prevents google translate messing up the DOM, https://github.com/facebook/react/issues/11538
        className: 'b-weeks-container notranslate',
        reference: 'weeksElement',
        children: weeksContainerChildren
      }];

      for (var i = 0; i < 6; i++) {
        var weekRow = {
          className: 'b-calendar-row b-calendar-week',
          children: [{// the week number cell
          }, {
            className: 'b-calendar-days',
            children: []
          }]
        }; // Generate cells seven dys

        for (var j = 0; j < 7; j++) {
          weekRow.children[1].children.push({});
        }

        weeksContainerChildren.push(weekRow);
      }

      return result;
    }
  }, {
    key: "dayNameCells",
    get: function get() {
      var me = this,
          weekNumberHeader = document.createElement('div'),
          result = [weekNumberHeader];
      me.weekdayCells = [];
      weekNumberHeader.className = 'b-week-number-cell';

      for (var i = 0; i < 7; i++) {
        var cell = document.createElement('div');
        result.push(cell);
        me.weekdayCells.push(cell);
      }

      return result;
    }
  }, {
    key: "firstVisibleDate",
    get: function get() {
      for (var date = this.month.startDate;; date.setDate(date.getDate() + 1)) {
        if (!this.hideNonWorkingDays || !this.nonWorkingDays[date.getDay()]) {
          return date;
        }
      }
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'CalendarPanel';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'calendarpanel';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        textContent: false,

        /**
         * Gets or sets the date that orientates the panel to display a particular month.
         * Changing this causes the content to be refreshed.
         * @property {Date}
         * @name date
         */

        /**
         * The date which this CalendarPanel encapsulates.
         * @config {Date|String}
         */
        date: {
          $config: {
            equal: 'date'
          },
          value: null
        },

        /**
         * A {@link Core.util.Month} Month utility object which encapsulates this Panel's month
         * and provides contextual information and navigation services.
         */
        month: {},
        year: null,

        /**
         * The week start day, 0 meaning Sunday, 6 meaning Saturday.
         * Defaults to the locale's week start day.
         * @config {Number}
         */
        weekStartDay: false,

        /**
         * Configure as `true` to always show a six week calendar.
         * @config {Boolean}
         * @default
         */
        sixWeeks: true,

        /**
         * Configure as `true` to show a week number column at the start of the calendar block.
         * @deprecated 4.0.0 Use {@link #config-showWeekColumn} instead.
         * @config {Boolean}
         */
        showWeekNumber: null,

        /**
         * Configure as `true` to show a week number column at the start of the calendar block.
         * @config {Boolean}
         */
        showWeekColumn: null,

        /**
         * Either an array of `Date` objects which are to be disabled, or
         * a function, which, when passed a `Date` returns `true` if the
         * date is disabled.
         * @config {Function|Date[]}
         */
        disabledDates: null,

        /**
         * A function which creates content in, and may mutate a day header element.
         * The following parameters are passed:
         *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
         *  - day [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The day number conforming to the specified {@link #config-weekStartDay}. Will be in the range 0 to 6.
         *  - weekDay [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The canonial day number where Monday is 0 and Sunday is.
         * @config {Function}
         */
        headerRenderer: null,

        /**
         * A function which creates content in, and may mutate the week cell element at the start of a week row.
         * The following parameters are passed:
         *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
         *  - week [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) An array containing `[year, weekNumber]`.
         * @config {Function}
         */
        weekRenderer: null,

        /**
         * A function which creates content in, and may mutate a day cell element.
         * The following parameters are passed:
         *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
         *  - date [Date](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) The date for the cell.
         *  - cellIndex [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The cell index, 0 to 6.
         * @config {Function}
         */
        cellRenderer: null,

        /**
         * Configure as `true` to render weekends as {@link #config-disabledDates}.
         * @config {Boolean}
         */
        disableWeekends: null,
        hideNonWorkingDays: null,
        hideNonWorkingDaysCls: 'b-hide-nonworking-days',

        /**
         * An object with number properties (0-6) whose values define the non-working days.
         * @config {Object}
         * @default
         */
        nonWorkingDays: {
          0: true,
          6: true
        },

        /**
         * A config object to create a tooltip which will show on hover of a date cell
         * including disabled, weekend, and "other month" cells.
         *
         * It is the developer's responsibility to hook the `beforeshow` event
         * to either veto the show by returning `false` or provide contextual
         * content for the date.
         *
         * The tip instance will be primed with a `currentDate` property.
         * @config {Object}
         */
        tip: null,
        dayCellCls: 'b-calendar-cell',

        /**
         * The class name to add to disabled calendar cells.
         * @config {String}
         * @private
         */
        disabledCls: 'b-disabled-date',

        /**
         * The class name to add to calendar cells which are in the previous or next month.
         * @config {String}
         * @private
         */
        otherMonthCls: 'b-other-month',

        /**
         * The class name to add to calendar cells which are weekend dates.
         * @config {String}
         * @private
         */
        weekendCls: 'b-weekend',

        /**
         * The class name to add to the calendar cell which contains today's date.
         * @config {String}
         * @private
         */
        todayCls: 'b-today',

        /**
         * The class name to add to calendar cells which are {@link #config-nonWorkingDays}.
         * @config {String}
         * @private
         */
        nonWorkingDayCls: 'b-nonworking-day',

        /**
         * The {@link Core.helper.DateHelper DateHelper} format string to format the day names.
         * @config {String}
         * @default
         */
        dayNameFormat: 'ddd',

        /**
         * By default, week rows flex to share available Panel height equally.
         *
         * Set this config if the available height is too small, and the cell height needs
         * to be larger to show events.
         *
         * Setting this config causes the month grid to become scrollable in the `Y` axis.
         */
        minRowHeight: {
          $config: ['lazy'],
          value: null
        },

        /**
         * By default, day cells flex to share available Panel width equally.
         *
         * Set this config if the available width is too small, and the cell width needs
         * to be larger to show events.
         *
         * Setting this config causes the month grid to become scrollable in the `X` axis.
         */
        minColumnWidth: {
          $config: ['lazy'],
          value: null
        }
      };
    }
  }]);

  return CalendarPanel;
}(_Panel_js__WEBPACK_IMPORTED_MODULE_17__["default"]); // Register this widget type with its Factory



CalendarPanel.initClass();
CalendarPanel._$name = 'CalendarPanel';

/***/ }),

/***/ "./lib/Core/widget/Checkbox.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/Checkbox.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Checkbox; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/widget/Checkbox
 */

/**
 * Checkbox field, wraps <code>&lt;input type="checkbox"&gt;</code>.
 * Color can be specified and you can optionally configure {@link #config-text}
 * to display in a label to the right of the checkbox in addition to a standard
 * field {@link #config-label}.
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 *
 * @extends Core/widget/Field
 *
 * @example
 * // checkbox with a label and a handler
 * let checkbox = new Checkbox({
 *   text: 'Check me, please',
 *   onAction: () => {}
 * });
 *
 * @classType checkbox
 * @externalexample widget/Checkbox.js
 */

var Checkbox = /*#__PURE__*/function (_Field) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Checkbox, _Field);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Checkbox);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Checkbox, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(config) {
      // Convert checked to value so that initializing getter can read it if requested prior to trying to set it.
      if ('checked' in config) {
        config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].assign({}, config); // copy inherited properties unlike Object.assign()

        config.value = config.checked;
        delete config.checked;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Checkbox.prototype), "construct", this).call(this, config);

      this.syncHasText();
    } // Implementation needed at this level because it has two inner elements in its inputWrap

  }, {
    key: "syncHasText",
    value: function syncHasText() {
      this.element.classList[this.text ? 'add' : 'remove']('b-text');
    }
  }, {
    key: "updateText",
    value: function updateText(value) {
      if (this.textLabel) {
        this.syncHasText();
        this.textLabel.innerHTML = value;
      }
    }
  }, {
    key: "changeValue",
    value: function changeValue(value) {
      return value === 'false' ? false : Boolean(value);
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      var me = this; // Only do action if change needed.

      if (!me.inputting) {
        me.inputting = true;
        me.input.checked = value;
        me.inputting = false;
        me.uncheckToggleGroupMembers(); // The change event does not fire on programmatic change of input.

        if (!me.isConfiguring) {
          me.triggerChange(false);
        }
      }
    }
  }, {
    key: "updateColor",
    value: function updateColor(value, was) {
      var classes = this.element.classList;

      if (was) {
        classes.remove(was);
      }

      if (value) {
        classes.add(value);
      }
    }
  }, {
    key: "getToggleGroupMembers",
    value: function getToggleGroupMembers() {
      var me = this,
          checked = me.checked,
          toggleGroup = me.toggleGroup,
          checkedElement = me.input,
          result = [];

      if (checked && toggleGroup) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].forEachSelector("input[type=checkbox][data-group=".concat(toggleGroup, "]"), function (inputEl) {
          if (inputEl !== checkedElement) {
            var partnerCheckbox = _Widget_js__WEBPACK_IMPORTED_MODULE_13__["default"].fromElement(inputEl);
            partnerCheckbox && result.push(partnerCheckbox);
          }
        });
      }

      return result;
    }
  }, {
    key: "uncheckToggleGroupMembers",
    value: function uncheckToggleGroupMembers() {
      if (this.checked && this.toggleGroup) {
        this.getToggleGroupMembers().forEach(function (widget) {
          return widget.checked = false;
        });
      }
    }
  }, {
    key: "updateReadOnly",
    value: function updateReadOnly(readOnly) {
      this.input.disabled = readOnly; // Field and Widget have a say too. Widget adds the class and fires the event

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Checkbox.prototype), "updateReadOnly", this).call(this, readOnly);
    }
    /**
     * Check the box
     */

  }, {
    key: "check",
    value: function check() {
      this.checked = true;
    }
    /**
     * Uncheck the box
     */

  }, {
    key: "uncheck",
    value: function uncheck() {
      this.checked = false;
    }
    /**
     * Toggle checked state. If you want to force a certain state, assign to {@link #property-checked} instead.
     */

  }, {
    key: "toggle",
    value: function toggle() {
      this.checked = !this.checked;
    } //endregion
    //region Events

    /**
     * Triggers events when user toggles the checkbox
     * @fires beforeChange
     * @fires change
     * @fires action
     * @private
     */

  }, {
    key: "internalOnChange",
    value: function internalOnChange(event) {
      var me = this;

      if (!me.inputting) {
        me.inputting = true;
        me.value = me.input.checked;
        me.triggerChange(true);
        me.inputting = false;
      }
    }
    /**
     * Triggers events when checked state is changed
     * @fires beforeChange
     * @fires change
     * @fires action
     * @private
     */

  }, {
    key: "triggerChange",
    value: function triggerChange(userAction) {
      var me = this,
          checked = me.input.checked;
      /**
       * Fired before checkbox is toggled. Returning false from a listener prevents the checkbox from being toggled.
       * @event beforeChange
       * @preventable
       * @param {Core.widget.Checkbox} source Checkbox
       * @param {Boolean} checked Checked or not
       */

      /**
       * Fired when checkbox is toggled
       * @event change
       * @param {Core.widget.Checkbox} source Checkbox
       * @param {Boolean} checked Checked or not
       */
      // Prevent uncheck if this checkbox is part of a toggleGroup (radio-button mode) ..also ensure the group has
      // visible active members

      var prevented = !checked && userAction && me.toggleGroup && me.getToggleGroupMembers().filter(function (widget) {
        return widget.isVisible && !widget.disabled;
      }).length || // Since Widget has Events mixed in configured with 'callOnFunctions' this will also call onBeforeChange,
      // onChange and onAction
      !me.callPreventable('change', {
        checked: checked,
        value: checked,
        userAction: userAction,
        valid: true
      }, function (eventObject) {
        me.triggerFieldChange(eventObject, false);

        if (userAction) {
          me.uncheckToggleGroupMembers();
        }
        /**
        * User performed the default action (toggled the checkbox)
        * @event action
        * @param {Core.widget.Checkbox} source Checkbox
        * @param {Boolean} checked Checked or not
        */


        me.trigger('action', eventObject);
        return true;
      }); // If prevented need to rollback the checkbox input

      if (prevented) {
        // Input change is not preventable, so need to revert the changes
        // The change event does not fire on programmatic change of input, so no need to suspend
        me.input.checked = me._value = !checked;
      }
    } //endregion

  }, {
    key: "innerElements",
    get: function get() {
      return [this.inputElement, {
        tag: 'label',
        class: 'b-checkbox-label',
        for: "".concat(this.id, "-input"),
        reference: 'textLabel',
        html: this.text || ''
      }];
    }
  }, {
    key: "inputElement",
    get: function get() {
      var me = this,
          config = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Checkbox.prototype), "inputElement", this);

      if (me.toggleGroup) {
        config.dataset = {
          group: me.toggleGroup
        };
      }

      return config;
    } //endregion
    //region Toggle

    /**
     * Get/set checked state. Equivalent to `value` config.
     * @property {Boolean}
     */

  }, {
    key: "checked",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.value = value;
    }
  }, {
    key: "inputValueAttr",
    get: function get() {
      return 'checked';
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Checkbox';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'checkbox';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'check';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        inputType: 'checkbox',

        /**
         * Get/set label
         * @member {String} name
         */

        /**
         * Text to display on checkbox label
         * @config {String}
         */
        text: '',

        /**
         * The checked state. The same as `value`.
         * @config {Boolean} checked
         */

        /**
         * Checkbox color, must have match in css
         * @config {String}
         */
        color: null,

        /**
         * Get/set value
         * @member {String} value
         */

        /**
         * Sets input fields value attribute
         * @config {String}
         */
        value: '',
        toggleGroup: null,
        defaultBindProperty: 'value',
        localizableProperties: ['label', 'text']
      };
    }
  }]);

  return Checkbox;
}(_Field_js__WEBPACK_IMPORTED_MODULE_12__["default"]); // Register this widget type with its Factory



Checkbox.initClass();
Checkbox._$name = 'Checkbox';

/***/ }),

/***/ "./lib/Core/widget/ChipView.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/ChipView.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ChipView; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _List_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./List.js */ "./lib/Core/widget/List.js");
/* harmony import */ var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");













function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5___default()(["", "\n            ", "\n            ", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/widget/ChipView
 */

/**
 * Displays an inline series of Chips which may be navigated to, selected and deleted.
 * @extends Core/widget/List
 *
 * @classType chipview
 */

var ChipView = /*#__PURE__*/function (_List) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(ChipView, _List);

  var _super = _createSuper(ChipView);

  function ChipView() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, ChipView);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(ChipView, [{
    key: "itemContentTpl",
    value: function itemContentTpl(record, i) {
      var me = this;
      return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].tpl(_templateObject(), me.iconTpl ? this.iconTpl(record) : '', me.itemTpl(record, i), me.closable ? '<div class="b-icon b-close-icon b-icon-clear" data-noselect></div>' : '');
    }
  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(event) {
      if (this.closable && this.selected.count && (event.key === 'Delete' || event.key === 'Backspace')) {
        this.callback(this.closeHandler, this.owner, [this.selected.values, {
          isKeyEvent: true
        }]);
      } else {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ChipView.prototype), "onInternalKeyDown", this).call(this, event);
      }
    }
  }, {
    key: "updateClosable",
    value: function updateClosable(closable) {
      this.element.classList[closable ? 'add' : 'remove']('b-chips-closable');
      this.navigator.disabled = !closable;

      if (!this.isConfiguring) {
        this.refresh();
      }
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      var me = this,
          item = event.target.closest(".".concat(me.itemCls));

      if (me.closable && event.target.classList.contains('b-close-icon')) {
        var record = me.store.getAt(parseInt(item.dataset.index));
        me.callback(me.closeHandler, me.owner, [[record]]);
      } else {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ChipView.prototype), "onClick", this).call(this, event);
      }
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ChipView';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'chipview';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        itemCls: 'b-chip',

        /**
         * Configure as `true` to display a clickable close icon after the {@link Core.widget.List#config-itemTpl}.
         * When tapped, the configured {@link #config-closeHandler} is called passing the
         * associated record.
         *
         * Chips may also be selected using the `LEFT` and `RIGHT` arrows (And the `Shift` key to
         * do multiple, contiguous election). Pressing the `DELETE` or `BACKSPACE` key passes the
         * selected records to the {@link #config-closeHandler}
         * @config {Boolean}
         * @default
         */
        closable: true,

        /**
         * A template function, which, when passed a record, returns the markup which
         * encapsulates a chip's icon to be placed before the {@link Core.widget.List#config-itemTpl}.
         * @config {Function}
         */
        iconTpl: null,

        /**
         * If {@link #config-closable} is `true`, this is the name of a callback function
         * to handle what the "close" action means.
         * @config {String|Function}
         */
        closeHandler: null
      };
    }
  }]);

  return ChipView;
}(_List_js__WEBPACK_IMPORTED_MODULE_12__["default"]); // Register this widget type with its Factory



ChipView.initClass();
ChipView._$name = 'ChipView';

/***/ }),

/***/ "./lib/Core/widget/Combo.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Combo.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Combo; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _data_Store_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _data_Model_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _ChipView_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./ChipView.js */ "./lib/Core/widget/ChipView.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../helper/util/Navigator.js */ "./lib/Core/helper/util/Navigator.js");
/* harmony import */ var _List_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./List.js */ "./lib/Core/widget/List.js");






























function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';












var errorFieldRequired = 'L{Field.fieldRequired}',
    errorValidateFilter = 'L{Field.validateFilter}';
/**
 * @module Core/widget/Combo
 */

/**
 * Combo (dropdown) widget. Consists of a text field with a trigger icon, which displays a List. Can be
 * populated from a Store.
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 *
 * @extends Core/widget/PickerField
 *
 * @example
 * // items as strings
 * let combo = new Combo({
 *   items: ['Small', 'Smaller', 'Really small', 'Tiny', 'Super tiny', '?'],
 *   placeholder: 'Pick size of diamond for ring'
 * });
 *
 * @example
 * // items as configs
 * let combo = new Combo({
 *   items: [{ value: 'a', text: 'First' }, { value: 'z', text: 'Last' }]
 * });
 *
 * @example
 * // items from store
 * let combo = new Combo({
 *   store: memberStore,
 *   valueField: 'id',
 *   displayField: 'name'
 * });
 *
 * @classType combo
 * @externalexample widget/Combo.js
 */

var Combo = /*#__PURE__*/function (_PickerField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default()(Combo, _PickerField);

  var _super = _createSuper(Combo);

  function Combo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default()(this, Combo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(Combo, [{
    key: "construct",
    //endregion
    value: function construct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "construct", this).apply(this, arguments); // Ensure there will always be a store created if Combo is created without items/store


      if (!this.store) {
        this.items = [];
      }

      if (this.filterOnEnter) {
        this.hideTrigger = true;
      }
    }
  }, {
    key: "startConfigure",
    value: function startConfigure(config) {
      this.usingRecordAsValue = config.valueField === null;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "startConfigure", this).apply(this, arguments);
    }
  }, {
    key: "afterConfigure",
    value: function afterConfigure() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "afterConfigure", this).call(this);

      if (!('_value' in this)) {
        this._value = this.valueField === this.displayField ? '' : null;
      }
    }
  }, {
    key: "changeChipStore",
    value: function changeChipStore(chipStore) {
      if (chipStore && !(chipStore instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_29__["default"])) {
        chipStore = new _data_Store_js__WEBPACK_IMPORTED_MODULE_29__["default"](_data_Store_js__WEBPACK_IMPORTED_MODULE_29__["default"].mergeConfigs({
          storage: this.valueCollection
        }, chipStore));
      }

      return chipStore;
    }
  }, {
    key: "updateChipStore",
    value: function updateChipStore(store, was) {
      was === null || was === void 0 ? void 0 : was.destroy();
    }
  }, {
    key: "changeChipView",
    value: function changeChipView(chipView, was) {
      var me = this,
          input = me.input;
      var chipStore; // Avoid triggering lazy config create by using "me.chipStore" if we won't need it

      if (chipView && !(chipStore = me.chipStore)) {
        me.chipStore = {};
        chipStore = me.chipStore; // the {} above was transformed by changeChipStore, so read back the Store
      }

      if (!chipView && me.multiSelect && !me.isDestroying) {
        chipView = {};
      }

      return ComboChipView.reconfigure(was, chipView, {
        defaults: {
          parent: me,
          insertBefore: input,
          store: chipStore,
          closable: !me.readOnly,
          navigator: {
            class: ComboChipNavigator,
            keyEventTarget: input
          }
        }
      });
    }
  }, {
    key: "updateChipView",
    value: function updateChipView(chipView) {
      var _me$_chipViewEventDet;

      var me = this;
      me._chipViewEventDetacher = (_me$_chipViewEventDet = me._chipViewEventDetacher) === null || _me$_chipViewEventDet === void 0 ? void 0 : _me$_chipViewEventDet.call(me);
      me.chipStore = chipView === null || chipView === void 0 ? void 0 : chipView.store;

      if (chipView) {
        // Insert the input field
        chipView.element.appendChild(me.input); // Focus must flow into our field from the ChipView

        me._chipViewEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].on({
          element: chipView.element,
          mousedown: 'onChipViewMousedown',
          thisObj: me
        });
      }
    }
  }, {
    key: "updateMultiSelect",
    value: function updateMultiSelect(multiSelect) {
      var me = this,
          chipView = multiSelect ? me.chipView : me._chipView,
          input = me.input,
          parentNode = input.parentNode,
          fixValue = !me.isConfiguring;
      var value = me.value,
          chipViewEl;
      me.element.classList[multiSelect ? 'add' : 'remove']('b-multiselect');

      if (multiSelect) {
        if (!chipView) {
          // When multiSelect we read "me.chipView" which will trigger the lazy config... so if we don't have a
          // chipView that means the config has been nulled out somehow, so we need to recreate it as best we
          // can.
          me.chipView = {
            type: 'combochipview'
          };
        }

        chipViewEl = me.chipView.element; // read from config in case we assigned it above
        // If the input's parentNode is not the chipView's element, we need to restore that DOM arrangement

        if (chipViewEl !== parentNode) {
          // This is where the chipView is created in the DOM but it may have been removed.
          parentNode.insertBefore(chipViewEl, input);
          chipViewEl.appendChild(input);
          me.chipView.refresh();
        }

        input.value = '';

        if (fixValue && !Array.isArray(value)) {
          value = value ? [value] : null;
        }
      } // else when !multiSelect, if the input's parentNode is the chipView's element, we need to put things back the
      // other way
      else {
          if ((chipViewEl = chipView === null || chipView === void 0 ? void 0 : chipView.element) === parentNode) {
            // Put the input back in its proper place
            chipViewEl.parentNode.insertBefore(input, chipViewEl); // When no longer multiSelect, remove the chipView from the DOM. We do not destroy it because derived
            // classes or the instance config may have specified chipView config options. If we destroyed it, we could
            // not then properly recreate it.

            chipViewEl.remove();
          }

          if (fixValue && typeof value !== 'string') {
            value = value && value.length ? value[0] : null;
          }
        }

      if (fixValue) {
        me.value = value;
      }
    }
  }, {
    key: "onChipViewMousedown",
    value: function onChipViewMousedown(mousedownEvent) {
      mousedownEvent.preventDefault();

      if (!this.containsFocus) {
        this.focus();
      }
    }
  }, {
    key: "onChipClose",
    value: function onChipClose(records) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Do not clean value collection if input field is not empty - probably text is selected
      // and user just wants to remove it, not the picked values
      if (options.isKeyEvent && this.input.value === '' || !options.isKeyEvent) {
        this._isUserAction = true;
        this.valueCollection.remove(records);
        this._isUserAction = false;
      }
    }
  }, {
    key: "updateFilterParamName",
    value: function updateFilterParamName(filterParamName) {
      if (this.hideTrigger !== false) {
        this.hideTrigger = Boolean(filterParamName);
      }
    }
  }, {
    key: "updateHideTrigger",
    value: function updateHideTrigger(hideTrigger) {
      this.element.classList[hideTrigger ? 'add' : 'remove']('b-hide-trigger');
    } //region Getters/setters

  }, {
    key: "updateKeyStrokeFilterDelay",
    value: function updateKeyStrokeFilterDelay(delay) {
      var me = this;

      if (delay) {
        me.filterList = me.buffer(me.doFilter, delay);
      }
    }
  }, {
    key: "updateReadOnly",
    value: function updateReadOnly(readOnly) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "updateReadOnly", this).apply(this, arguments); // Disable closing (removing) chips when we are read-only.


      this._chipView && (this._chipView.closable = !readOnly);
    }
  }, {
    key: "changeItems",

    /**
     * Prepares items to work in attached menu (converts strings to items)
     * @private
     */
    value: function changeItems(items) {
      var me = this;

      if (items == null) {
        if (me.store && !me.store.isItemStore) {
          return;
        }

        items = [];
      }

      if (items instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_29__["default"]) {
        me.store = items;
        return;
      }

      var displayField = me.displayField;
      var itemModel,
          valueField = me.valueField,
          storeData;

      if (Array.isArray(items)) {
        storeData = items.map(function (item) {
          var result = item;

          if (item instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_31__["default"]) {
            itemModel = item.constructor;

            if (!valueField) {
              me.valueField = valueField = itemModel.idField;
            }
          } else {
            if (typeof item === 'string' || typeof item === 'number') {
              var _result;

              if (!valueField) {
                me.valueField = valueField = me.displayField;
              }

              result = (_result = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21___default()(_result, valueField, item), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21___default()(_result, displayField, item), _result);
            } else {
              if (!valueField) {
                me.valueField = valueField = 'value';
              }

              if (Array.isArray(item)) {
                var _result2;

                result = (_result2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21___default()(_result2, valueField, item[0]), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21___default()(_result2, displayField, item[1]), _result2);
              }
            }
          }

          if (result.selected) {
            me.value = result;
          }

          return result;
        });
      } // Must be a value -> text map
      else {
          if (!valueField) {
            me.valueField = valueField = 'value';
          }

          storeData = [];
          Object.entries(items).forEach(function (_ref) {
            var _storeData$push;

            var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_20___default()(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            storeData.push((_storeData$push = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21___default()(_storeData$push, valueField, key), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_21___default()(_storeData$push, displayField, value), _storeData$push));
          });
        } // Allow reconfiguring with a new set of items


      if (me.store) {
        me.store.data = storeData;
      } else {
        var valueFieldDefinition = valueField === displayField ? {
          name: 'value',
          dataSource: displayField
        } : valueField;
        me.store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_29__["default"]({
          isItemStore: true,
          data: storeData,
          idField: valueField,
          modelClass: itemModel || /*#__PURE__*/function (_Model) {
            _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default()(_class, _Model);

            var _super2 = _createSuper(_class);

            function _class() {
              _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default()(this, _class);

              return _super2.apply(this, arguments);
            }

            _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(_class, null, [{
              key: "idField",
              get: function get() {
                // Need to use instance var and not rely on closure for cases where valueField changes
                // (like first assigning [] and then ['a'] without configured valueField
                return me.valueField;
              },
              set: function set(idField) {
                _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(_class), "idField", idField, this, true);
              }
            }, {
              key: "fields",
              get: function get() {
                return [valueFieldDefinition, displayField];
              }
            }]);

            return _class;
          }(_data_Model_js__WEBPACK_IMPORTED_MODULE_31__["default"])
        });
      }
    }
  }, {
    key: "changeValue",
    value: function changeValue(value, oldValue) {
      var me = this;

      if (value === oldValue) {
        // Sync without highlight
        me.syncInputFieldValue(true);
        return;
      }

      if (!me.multiSelect && Array.isArray(value) && value.length > 1) {
        throw new Error('Multiple values cannot be set to a non-multiSelect Combo');
      } // This forces promotion of the items config into a Store if it has not already been injected


      me.triggerConfig('items');
      var valueField = me.valueField,
          displayField = me.displayField,
          store = me.store,
          valueCollection = me.valueCollection; // It's a remote filter store, so we have to do a filter down to just match(es)
      // and add the result to the valueCollection

      if (me.remoteFilter) {
        // The null case will drop through and be processed as for local just by clearing the valueCollection
        if (value != null) {
          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_19___default()(value) === 'object') {
            this.store.data = [value];
            this.valueCollection.splice(0, this.valueCollection.count, this.store.first);
          } else {
            var wasConfiguring = me.isConfiguring;
            me.primaryFilter.setConfig({
              value: value,
              disabled: false
            });
            store.performFilter(true).then(function () {
              var isConfiguring = me.isConfiguring; // Carry the wasConfiguring flag from the set value call frame so that
              // if it's the configuring set value, we do not now fire the change event.

              me.isConfiguring = wasConfiguring;
              valueCollection.splice(0, valueCollection.count, store.allRecords);
              me.isConfiguring = isConfiguring;
            });
            return;
          }
        }
      } // Else, if it's a *locally* filtered store, then
      // unfilter it so we can do the value lookup.
      else if (store.filtered) {
          me.primaryFilter.disabled = true;
          store.filter();
        }

      var record;

      if (value != null) {
        // If value is set as an array, make sure to slice it to not mutate original array below
        var arrayPassed = Array.isArray(value),
            values = arrayPassed ? value.slice() : [value];

        for (var i = 0, len = values.length; i < len; i++) {
          var currentValue = values[i];

          if (currentValue instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_31__["default"]) {
            // The required record value may not yet be in the store. Add it if not.
            if (!store.storage.includes(currentValue)) {
              store.add(currentValue);
            }
          } else {
            var isObject = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].isObject(currentValue); // If they passed a data object, match the valueField

            if (isObject) {
              currentValue = currentValue[valueField];
            } // Use the Store Collection's extra indices to quickly find a match


            record = store.storage.getBy(displayField, currentValue) || store.storage.getBy(valueField, currentValue);

            if (record) {
              // If the incoming value was a matched object, use it to update the record
              if (isObject) {
                record.set(values[i]);
              }

              values[i] = record;
            } else {
              values.splice(i, 1);
              len--;
              i--;
            }
          }
        } // Remove all old values, add new values in one shot.


        var vcGen = valueCollection.generation;
        valueCollection.splice(0, valueCollection.count, values); // If no change has fed through to onValueCollectionChange, just ensure the input matches

        if (valueCollection.generation === vcGen) {
          me.syncInputFieldValue();
        } // If we got no matches, onValueCollectionChange will set the _value to null.
        // Tests specify that the _value should be set to the incoming unmatched value.
        // Handle the case that an array was passed.


        if (!values.length) {
          me._value = arrayPassed ? values[0] || null : value;
        }
      } else {
        if (valueCollection.count) {
          valueCollection.clear();
        } else {
          var _oldValue = me._value; // Cache the value for use by our change handler next time, and also so that
          // when get value yields null, the fallback to ._value will be correct

          me._value = null;
          me.syncInputFieldValue();
          me.syncEmpty();

          if (!me.isConfiguring) {
            me.triggerFieldChange({
              value: value,
              oldValue: _oldValue,
              userAction: me._isUserAction,
              valid: me.isValid
            });
          }
        }
      }

      me._lastValue = me.value; // TODO ???
    }
  }, {
    key: "onComboStoreChange",
    value: function onComboStoreChange(_ref3) {
      var action = _ref3.action;

      // Local filter-on-type is happening, do not sync the input value.
      if (action !== 'filter') {
        this.syncInputFieldValue(true);
      }
    }
  }, {
    key: "syncInputFieldValue",
    value: function syncInputFieldValue(skipHighlight) {
      // We only sync the input's value if we are not multiselecting.
      // If we are multiselecting, our value is represented by a ChipView.
      // The ChipView automatically syncs itself with our valueCollection.
      if (!this.multiSelect) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "syncInputFieldValue", this).call(this, skipHighlight);
      }
    }
    /**
     * Returns `true` if this field has no selected records.
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "changePrimaryFilter",
    value: function changePrimaryFilter(primaryFilter) {
      if (!(primaryFilter instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_32__["default"])) {
        if (typeof primaryFilter === 'function') {
          primaryFilter = {
            filterBy: primaryFilter
          };
        } // This is the filter that performs filtering on typing.


        primaryFilter = new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_32__["default"](_objectSpread({
          // Need an id to replace any existing combo filter on the store.
          // Dodge pre-commit hook by quoting property:
          'id': 'primary',
          // eslint-disable-line quote-props
          disabled: true,
          property: this.displayField,
          operator: this.filterOperator,
          caseSensitive: this.caseSensitive
        }, primaryFilter));
      }

      return primaryFilter;
    }
  }, {
    key: "changeStore",
    value: function changeStore(store) {
      if (Array.isArray(store)) {
        this.items = store;
        return;
      }

      if (store) {
        if (typeof store === 'string') {
          store = _data_Store_js__WEBPACK_IMPORTED_MODULE_29__["default"].getStore(store);
        } else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].isObject(store)) {
          store = new (store.readUrl ? _data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_30__["default"] : _data_Store_js__WEBPACK_IMPORTED_MODULE_29__["default"])(store);
        }

        var me = this,
            remoteFilter = me.remoteFilter || store.restfulFilter,
            filterParamName = me.filterParamName,
            storeFilters = [];

        if (remoteFilter && filterParamName) {
          store.filterParamName = filterParamName;

          if (me.encodeFilterParams) {
            store.encodeFilterParams = me.encodeFilterParams;
          }
        } // If no value field provided, read it off of the Store's modelClass
        // Unless we want to use full record as the value


        if (!me.valueField && !me.usingRecordAsValue) {
          me.valueField = store.modelClass.idField;
        }

        storeFilters.push(me.primaryFilter);

        if (remoteFilter) {
          if (me.filterSelected) {
            store.storage.autoFilter = true;
            store.storage.addFilter({
              id: "".concat(me.id, "-selected-filter"),
              filterBy: function filterBy(r) {
                return !me.valueCollection.includes(r);
              }
            });
          }
        } else if (me.filterSelected) {
          me.selectedItemsFilter = function (r) {
            return !me.valueCollection.includes(r);
          };

          storeFilters.push(me.selectedItemsFilter);
          store.reapplyFilterOnAdd = true;
        }

        store.filter(storeFilters);
      }

      return store;
    }
  }, {
    key: "updateStore",
    value: function updateStore(store) {
      var me = this,
          _picker = me._picker;
      var storeListeners;

      if (_picker) {
        _picker.store = store;
      } // Allow fast lookup by value or displayed value


      store.storage.addIndex(me.displayField);
      store.storage.addIndex(me.valueField);

      if (me.remoteFilter) {
        storeListeners = {
          filter: 'onRemoteFilter'
        };
      }

      if (me.displayValueRenderer) {
        (storeListeners || (storeListeners = {})).change = 'onComboStoreChange';
        me.syncInputFieldValue();
      }

      me.detachListeners('store');

      if (storeListeners) {
        storeListeners.name = 'store';
        storeListeners.thisObj = me;
        store.on(storeListeners);
      }
    }
  }, {
    key: "onEditComplete",
    //endregion
    //region Value handling

    /**
     * Check if field value is valid
     * @internal
     */
    value: function onEditComplete() {
      var me = this,
          selectionCount = me.valueCollection.count;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "onEditComplete", this).call(this); // Ensure the input area matches the selected value


      if (selectionCount) {
        me.clearError(errorValidateFilter);
        me.syncInputFieldValue();
      }

      if (me.required && !selectionCount) {
        me.setError(errorFieldRequired);
      }
    } //endregion
    //region Events

    /**
     * User clicked trigger icon, toggle list.
     * @private
     */

  }, {
    key: "onTriggerClick",
    value: function onTriggerClick() {
      var _me$triggerAction;

      var me = this; // Bail out if enter key is required to trigger a filter

      if (me.remoteFilter && me.filterOnEnter) {
        return;
      }

      if (me.pickerVisible) {
        me.hidePicker();
      } else {
        if (!me.readOnly && !me.disabled) {
          switch ((_me$triggerAction = me.triggerAction) === null || _me$triggerAction === void 0 ? void 0 : _me$triggerAction.toLowerCase()) {
            case 'all':
              me.doFilter(null);
              break;

            case 'last':
              me.doFilter(me.lastQuery);
              break;

            default:
              me.doFilter(me.input.value);
          }
        }
      }
    }
    /**
     * User types into input field in editable combo, show list and filter it.
     * @private
     */

  }, {
    key: "internalOnInput",
    value: function internalOnInput(event) {
      var me = this,
          value = me.input.value,
          inputLen = value.length; // IE11 triggers input event on focus for some reason, ignoring it if not editable

      if (!me.editable) {
        return;
      }

      me.syncEmpty();
      me.syncInputWidth();
      me.inputting = true;

      if (inputLen >= me.minChars && !me.filterOnEnter) {
        me.filterList(value);
      } else {
        // During typing, the field is invalid
        if (me.validateFilter && !me.remoteFilter) {
          me[inputLen ? 'setError' : 'clearError'](errorValidateFilter);
        }

        me.hidePicker();
      }

      me.inputting = false;
      /**
       * User typed into the field. Please note that the value attached to this event is the raw input field value and
       * not the combos value
       * @event input
       * @param {Core.widget.Combo} source - The combo
       * @param {String} value - Raw input value
       */

      me.trigger('input', {
        value: value,
        event: event
      });
    }
  }, {
    key: "syncInputWidth",
    value: function syncInputWidth() {
      var me = this;

      if (me.multiSelect) {
        var input = me.input,
            // padding on the input el won't change, so cache the measurement:
        inputPadding = me._inputPadding || (me._inputPadding = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getEdgeSize(input, 'padding', 'lr')),
            value = input.value || '',
            width = // +'W' to avoid text getting clipped or horizontal scrolling
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].measureText(value + 'W', input, false, me.element) + inputPadding.width; // Normally the input is given "flex: 1 1 0px" so it will fill the space
        // so we just need to adjust the flex-basis to ensure the input is at least
        // as long as the text. Since it is also flex-shrink, it will not become
        // any larger than one "row".

        input.style.flex = "1 1 ".concat(Math.ceil(width), "px");
      }
    } // This is potentially a buffered function to respond to keystrokes in a buffered manner.
    // This only becomes useful as a saving when using remote querying where each filter is an Ajax request.

  }, {
    key: "filterList",
    value: function filterList(queryString) {
      this.doFilter(queryString);
    }
  }, {
    key: "doFilter",
    value: function doFilter(queryString) {
      var me = this,
          store = me.store,
          picker = me._picker,
          disableFilter = queryString == null || queryString === '';
      me.lastQuery = queryString;
      me.primaryFilter.setConfig({
        value: queryString,
        disabled: disableFilter
      });

      if (me.remoteFilter) {
        store.clear(true);
      } // Force the lazy config to create picker since the List needs to add its beforeLoad listener
      // showing a mask in case of remote filtering


      me.getConfig('picker');
      store.filter();

      if (picker === null || picker === void 0 ? void 0 : picker.isVisible) {
        // If aligned above, filtering will change its height so will need realigning
        if (picker.lastAlignSpec.zone === 0) {
          picker.realign();
        }
      } else {
        me.showPicker();
      }

      if (store.count) {
        // If we are filtering, activate the first match
        if (!disableFilter) {
          me.picker.navigator.activeItem = 0;
        }
      } // If we were actively *locally* filtering on a string but there were no matches
      // and we are validateFilter: true, then mark as invalid even though we
      // may have an underlying valid selected value.
      else if (!me.remoteFilter && !disableFilter && me.validateFilter) {
          me.setError(errorValidateFilter);
        }
    }
  }, {
    key: "onRemoteFilter",
    value: function onRemoteFilter() {
      var me = this,
          picker = me._picker; // If we are filtering, activate the first match

      if (me.store.count) {
        if (picker) {
          picker.navigator.activeItem = 0;
        }
      } // Invalid if no matches after filtering
      else {
          if (me.validateFilter) {
            me.setError(errorValidateFilter);
          }
        } // If we have selection, evict selected items from the newly remote-filtered list


      if (me.filterSelected && me.valueCollection.count) {
        me.store.storage.onFiltersChanged(); // Store does not react to Collection filtering yet because it does its own filtering and
        // then fires its own event. So we have to refresh the picker to hide the selected items.

        if (picker) {
          picker.refresh();
        }
      }
    }
    /**
     * This reacts to our {@link #property-valueCollection} being mutated in any way.
     * The `change`, `select` and `action` events are fired here.
     *
     * This could happen in four ways:
     *
     *  - User selected or deselected an item in the dropdown list.
     *  - `set value` changes the content.
     *  - The {@link #config-multiSelect} Chip view (which uses this in its store) deletes a record.
     *  - The application programmatically mutates the {@link #property-valueCollection}.
     *
     * @private
     */

  }, {
    key: "onValueCollectionChange",
    value: function onValueCollectionChange(_ref4) {
      var _me$hidePickerOnSelec;

      var valueCollection = _ref4.source;
      var me = this,
          multiSelect = me.multiSelect,
          _picker = me._picker,
          hidePicker = (_me$hidePickerOnSelec = me.hidePickerOnSelect) !== null && _me$hidePickerOnSelec !== void 0 ? _me$hidePickerOnSelec : !multiSelect,
          record = multiSelect ? valueCollection.values.slice() : valueCollection.first,
          records = valueCollection.values.slice(),
          isUserAction = me._isUserAction || (_picker === null || _picker === void 0 ? void 0 : _picker._isUserAction) || hidePicker && me.pickerVisible || false,
          oldValue = me._value;

      if (hidePicker) {
        me.hidePicker();
      }

      if (!valueCollection.count && me.required) {
        me.setError(errorFieldRequired);
      } else {
        me.clearError(errorFieldRequired);
        me.clearError(errorValidateFilter);
      }

      if (me.validateFilter && record) {
        me.clearError(errorValidateFilter);
      } // Re-evaluate *local* filtering so that selected items are filtered out of the dropdown.
      // For remote filtering, we programatically add a filter to the store's storage


      if (me.filterSelected) {
        if (me.remoteFilter) {
          me.store.storage.onFiltersChanged(); // Store does not react to Collection filtering yet because it does its own filtering and
          // then fires its own event. So we have to refresh the picker to hide the selected items.

          if (me._picker) {
            me._picker.refresh();
          }
        } else {
          me.store.filter();
        }
      } // Clear the cached value so that there's no fallback when we read back the value below


      me._value = null; // Cache the value for use by our change handler next time, and also so that
      // if we just cleared the valueCollection, the fallback to ._value will be correct

      var value = me._value = me.value;
      me.syncInputFieldValue();
      me.syncEmpty();

      if (!me.isConfiguring) {
        me.triggerFieldChange({
          value: value,
          oldValue: oldValue,
          userAction: isUserAction,
          valid: me.isValid
        });
        /**
         * An item in the list was selected
         * @event select
         * @property {Combo} combo - Combo
         * @property {Core.data.Model} record - Selected record
         * @property {Core.data.Model} records - Selected records as an array if {@link #config-multiSelect} is `true`
         * @property {Boolean} userAction - `true` if the value change is due to user interaction.
         */

        me.trigger('select', {
          record: record,
          records: records,
          userAction: isUserAction
        });
        /**
         * Th default action was performed (an item in the list was selected)
         * @event action
         * @property {Combo} combo - Combo
         * @property {*} value - The {@link #valueField} of the selected record
         * @property {Core.data.Model} record - Selected record
         * @property {Core.data.Model} records - Selected records as an array if {@link #config-multiSelect} is `true`
         * @property {Boolean} userAction - `true` if the value change is due to user interaction.
         */

        if (me.defaultAction === 'select') {
          me.trigger('action', {
            value: value,
            record: record,
            records: records,
            userAction: isUserAction
          });
        }
      }
    }
    /**
     * This listens for when a record from the list is selected, but is already part of
     * the selection and so the {@link #property-valueCollection} rejects that as a no-op.
     * At this point, the user will still expect the picker to hide.
     * @param {Object} event The noChange event containing the splice parameters
     * @private
     */

  }, {
    key: "onValueCollectionNoChange",
    value: function onValueCollectionNoChange(_ref5) {
      var toAdd = _ref5.toAdd;

      if (!this.multiSelect && toAdd.length && this.pickerVisible) {
        this.picker.hide();
      }
    } //endregion
    //region Picker

  }, {
    key: "showPicker",
    value: function showPicker() {
      var me = this,
          picker = me.picker;

      if (me.readOnly) {
        return;
      }

      picker.multiSelect = me.multiSelect;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "showPicker", this).call(this); // Once we have access to the anchor size, overlay the anchor pointer over the target if configured to do so.


      if (me.overlayAnchor && !picker.align.offset) {
        picker.align.offset = -picker.anchorSize[1];
        picker.realign();
      } // Activate and make visible the *single* selected item.
      // Not valid if multiselect because the user's interest will not be focused on any one item.


      if (!me.multiSelect && me.selected) {
        picker.restoreActiveItem(me.selected, true);
      }

      me.input.focus();
    }
    /**
     * Creates default picker widget
     *
     * @internal
     */

  }, {
    key: "changePicker",
    value: function changePicker(picker, oldPicker) {
      var _picker2;

      var me = this,
          pickerWidth = me.pickerWidth || ((_picker2 = picker) === null || _picker2 === void 0 ? void 0 : _picker2.width);
      picker = _List_js__WEBPACK_IMPORTED_MODULE_40__["default"].reconfigure(oldPicker, picker ? _List_js__WEBPACK_IMPORTED_MODULE_40__["default"].mergeConfigs({
        owner: me,
        store: me.store,
        selected: me.valueCollection,
        multiSelect: me.multiSelect,
        cls: me.listCls,
        itemTpl: me.listItemTpl || function (item) {
          return item[me.displayField];
        },
        forElement: me[me.pickerAlignElement],
        align: {
          matchSize: pickerWidth == null,
          anchor: me.overlayAnchor,
          target: me[me.pickerAlignElement],
          // Reasonable minimal height to fit few combo items below the combo.
          // When height is not enough, list will appear on top. That works for windows higher than 280px,
          // worrying about shorter windows sounds overkill.
          // We cannot use relative measures here, each combo list item is ~40px high
          minHeight: Math.min(3, me.store.count) * 40
        },
        width: pickerWidth,
        navigator: {
          keyEventTarget: me.input
        }
      }, picker) : null, me);
      picker && (picker.element.dataset.emptyText = me.emptyText || me.L('L{noResults}'));
      return picker;
    }
  }, {
    key: "onPickerHide",
    value: function onPickerHide() {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "onPickerHide", this).call(this); // https://app.assembla.com/spaces/bryntum/tickets/7736


      if (me.multiSelect && me.clearTextOnPickerHide) {
        me.input.value = '';
      }
    } //endregion

  }, {
    key: "internalOnKeyEvent",
    value: function internalOnKeyEvent(keyEvent) {
      var me = this,
          value = me.input.value,
          inputLen = value.length;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "internalOnKeyEvent", this).apply(this, arguments);

      if (keyEvent.type === 'keydown' && keyEvent.key === 'Enter' && me.filterOnEnter && inputLen >= me.minChars) {
        keyEvent.stopPropagation();
        me.filterList(value);
      }
    }
  }, {
    key: "childItems",
    get: function get() {
      var _chipView = this._chipView,
          _picker = this._picker,
          result = [];

      if (_chipView) {
        result.push(_chipView);
      }

      if (_picker) {
        result.push(_picker);
      }

      return result;
    }
  }, {
    key: "minChars",
    get: function get() {
      var minChars = this._minChars;

      if (minChars != null) {
        return minChars;
      } // If it's not actually set, default differently for remote filtering.


      return this.remoteFilter ? 4 : 1;
    }
  }, {
    key: "items",
    get: function get() {
      return this.store.allRecords;
    }
  }, {
    key: "value",
    get: function get() {
      var valueCollection = this.valueCollection,
          valueField = this.valueField;

      if (valueField == null) {
        return this.multiSelect ? valueCollection.values.slice() : valueCollection.first;
      }

      return this.multiSelect ? valueCollection.map(function (r) {
        return r[valueField];
      }) : valueCollection.count ? valueCollection.first[valueField] : this._value;
    },
    set: function set(value) {
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Combo.prototype), "value", value, this, true);
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.valueCollection.count === 0;
    }
  }, {
    key: "inputValue",
    get: function get() {
      // This must be evaluated first, and NOT moved to be directly used as the
      // second expression in the ternary. If called during configuration, this
      // will import the configured value from the config object and ensure the
      // value is matched against the store, and that the "selected" property is set.
      var me = this;
      var result = me.value;
      result = me.selected ? me.selected[me.displayField] : result;

      if (me.displayValueRenderer) {
        result = me.callback(me.displayValueRenderer, me, [me.selected, me]);
      }

      return result == null ? '' : result;
    }
    /**
     * A {@link Core.util.Collection Collection} which holds the currently seleted records
     * from the store which dictates this field's value.
     *
     * Usually, this will contain one record, the record selected.
     *
     * When {@link #config-multiSelect} is `true`, there may be several records selected.
     */

  }, {
    key: "valueCollection",
    get: function get() {
      var valueCollection = this._valueCollection;

      if (!valueCollection) {
        this._valueCollection = valueCollection = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_36__["default"]({
          listeners: {
            noChange: 'onValueCollectionNoChange',
            change: 'onValueCollectionChange',
            prio: -1000,
            // The ChipView must react to changes first.
            thisObj: this
          }
        });
      }

      return valueCollection;
    }
  }, {
    key: "remoteFilter",
    get: function get() {
      var _this$_store;

      // Don't use "this.store" since we need to run during changeStore()
      return Boolean(this.filterParamName || ((_this$_store = this._store) === null || _this$_store === void 0 ? void 0 : _this$_store.restfulFilter));
    }
    /**
     * Get selected record.
     * @property {Core.data.Model[]}
     * @readonly
     */

  }, {
    key: "record",
    get: function get() {
      return this.selected;
    }
    /**
     * Get the selected record(s).
     * @property {Core.data.Model[]}
     * @readonly
     */

  }, {
    key: "records",
    get: function get() {
      return this.valueCollection.values.slice();
    }
  }, {
    key: "selected",
    get: function get() {
      return this.valueCollection.first;
    }
  }], [{
    key: "$name",
    // Do not remove. Assertion strings for Localization sanity check.
    // 'L{Field.fieldRequired}'
    // 'L{Field.validateFilter}'
    //region Config
    get: function get() {
      return 'Combo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'combo';
    } // Factoryable type aliases

  }, {
    key: "alias",
    get: function get() {
      return 'combobox,dropdown';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Optionally a {@link Core.util.CollectionFilter Filter} config object which
         * the combo should use for filtering using the typed value.
         * This may use a `filterBy` property to test its `value` against any field
         * in the passed record.
         * ```javascript
         * {
         *     type          : 'combo',
         *     store         : myStore,
         *     primaryFilter : {
         *         filterBy(record) {
         *             if (this.value == null) {
         *                 return true;
         *             }
         *             const value = this.value.toLowerCase();
         *
         *             // Match typed value with forename or surname
         *             return record.forename.toLowerCase().startsWith(value) || record.surname.toLowerCase().startsWith(value);
         *         }
         *     }
         * }
         * ```
         * @config {Object}
         */
        primaryFilter: {},
        picker: {
          type: 'list',
          floating: true,
          scrollAction: 'realign',
          itemsFocusable: false,
          activateOnMouseover: true,
          align: {
            align: 't0-b0',
            axisLock: true
          },
          maxHeight: 324,
          scrollable: {
            overflowY: true
          },
          autoShow: false,
          focusOnHover: false
        },

        /**
         * Configure as `true` to allow selection of multiple values from the dropdown list.
         *
         * Each value is displayed as a "Chip" to the left of the input area. Chips may be
         * selected using the `LEFT` and `RIGHT` arrow keys and deleted using the `DELETE` key
         * to remove values from the field. There is also a clickable close icon in each chip.
         *
         * @config {Boolean}
         * @default false
         */
        multiSelect: null,

        /**
         * Rows to display in the dropdown (list items).
         *
         * If an object, the property names provide the {@link #config-value} for the Combo, and
         * the property values provide the displayed test in the list and input area eg:
         *
         *     items : {
         *         small  : 'Small',
         *         medium : 'Medium',
         *         large  : 'Large'
         *     }
         *
         * If an array, each entry may be
         *  - an object containing properties which must include
         * the {@link #config-valueField} and {@link #config-displayField} which populates the dropdown
         * with text and provides the corresponding field value.
         *  - An array whos first value provides the {@link #config-value} for the Combo and whos
         * second value provides the displayed test in the list and input area.
         *  - An array of values where the {@link #config-valueField} and {@link #config-displayField} are the same.
         *
         * eg:
         *
         *     items : [
         *         {value : 'small',  text : 'Small'},
         *         {value : 'medium', text : 'Medium'},
         *         {value : 'large',  text : 'Large'},
         *     ]
         *
         * or
         *
         *     items : [
         *         ['small',  'Small'],
         *         ['medium', 'Medium'],
         *         ['large',  'Large'],
         *     ]
         *
         * or
         *
         *     items : [ 'Small', 'Medium', 'Large' ]
         *
         * @config {Object[]|String[]|Object}
         */
        items: null,

        /**
         * Get/set store to display items from. Also accepts a Store config object.
         * @property {Core.data.Store|Object}
         * @name store
         */

        /**
         * A store used to populate items.
         * @config {Core.data.Store}
         */
        store: null,

        /**
         * Field used for item value when populating from store. Setting this to `null` will
         * yield the selected record as the Combo's {@link #property-value}.
         * @config {String}
         */
        valueField: undefined,

        /**
         * Field used for item text when populating from store
         * @config {String}
         */
        displayField: 'text',

        /**
         * Width of picker, defaults to this combo's {@link #config-pickerAlignElement} width
         * @config {Number}
         */
        pickerWidth: null,

        /**
         * The minimum string length to trigger the filtering, only relevant when {@link #config-editable} is `true`.
         *
         * This defaults to `1` in the case of local filtering, but `4` if the
         * {@link #config-filterParamName} is set to cause remote dropdown loading.
         *
         * @config {Number}
         * @default
         */
        minChars: null,
        selected: null,

        /**
         * Template for rendering list items contents
         * @config {Function}
         */
        listItemTpl: null,

        /**
         * Template function that can be used to customize the displayed value
         * @param {Core.data.Model} record The record to provide a textual value for.
         * @param {Core.widget.Combo} combo A reference to this Combo.
         * @config {Function}
         */
        displayValueRenderer: null,

        /**
         * CSS class to add to picker
         * @config {String}
         */
        listCls: null,
        triggers: {
          expand: {
            cls: 'b-icon-picker',
            handler: 'onTriggerClick'
          }
        },

        /**
         * If the dropdown is to be populated with a filtered query to a remote server, specify the
         * name of the parameter to pass the typed string here. By default, the string is simply sent
         * as the value of the parameter. For special encoding, configure the combo with {@link #config-encodeFilterParams}
         * @config {String}
         */
        filterParamName: null,

        /**
         * A function which creates an array of values for the {#config-filterParamName} to pass
         * any filters to the server upon load.
         *
         * The default behaviour is just to set the parameter value to the filter's `value`,
         * but the filter can be fully encoded for example:
         *
         * ```javascript
         *    {
         *        encodeFilterParams(filters) {
         *            const result = [];
         *
         *            for (const { property, operator, value, caseSensitive } of filters) {
         *                result.push(JSON.stringify({
         *                    field : property,
         *                    operator,
         *                    value,
         *                    caseSensitive
         *                }));
         *           }
         *        return result;
         *    }
         * ```
         * @config {Function}
         */
        encodeFilterParams: function encodeFilterParams(filters) {
          return filters.map(function (f) {
            return f.value;
          });
        },

        /**
         * If `false`, filtering will be triggered once you exceed {@link #config-minChars}. To filter only when
         * hitting Enter key, set this to `true`;
         * @config {Boolean}
         */
        filterOnEnter: false,

        /**
         * Configure as `true` to hide the expand trigger. This is automatically set to `true` if
         * remote filtering is enabled by setting the {@link #config-filterParamName} config.
         * @config {Boolean}
         * @default false
         */
        hideTrigger: null,

        /**
         * This implies that the picker will display an anchor pointer, but also means that the picker will align closer
         * to the input field so that the pointer pierces the {@link #config-pickerAlignElement}
         * @config {Boolean}
         * @default false
         */
        overlayAnchor: null,

        /**
         * The delay in milliseconds to wait after the last keystroke before filtering the list.
         * @config {Number}
         * @default
         */
        keyStrokeFilterDelay: null,
        defaultAction: 'select',

        /**
         * How to query the store upon click of the expand trigger. Specify one of these values:
         *
         *  - `'all'` - Clear the filter and display the whole dataset in the dropdown.
         *  - `'last'` - Filter the dataset using the last filter value.
         *  - `null`/any other - Use the value in the input field to filter the dataset.
         *
         * @config {String}
         * @default
         */
        triggerAction: 'all',

        /**
         * The name of an operator type as implemented in {@link Core.util.CollectionFilter#config-operator}
         * to use when filtering the dropdown list based upon the typed value.
         *
         * This defaults to `'startsWith'`, but the `'*'` operator may be used to match all
         * values which _contain_ the typed value.
         *
         * Not used when {@link #config-filterParamName} is set to cause remote dropdown loading.
         * The exact filtering operation is up to the server.
         *
         * @config {String}
         */
        filterOperator: 'startsWith',

        /**
         * Configure as `true` to force case matching when filtering the dropdown list based upon the typed value.
         *
         * @config {Boolean}
         * @default false
         */
        caseSensitive: false,

        /**
         * By default, the picker is hidden on selection in single select mode, and
         * remains to allow more selections when {@link #config-multiSelect} is `true`.
         * Setting this to a `Boolean` value can override that default.
         */
        hidePickerOnSelect: null,

        /**
         * A config object to configure the {@link Core.widget.ChipView} to display the
         * selected value set when {@link #config-multiSelect} is `true.
         *
         * For example the {@link Core.widget.List#config-itemTpl} or
         * {@link Core.widget.ChipView#config-iconTpl} might be configured to display
         * richer chips for selected items.
         * @config {Object}
         */
        chipView: {
          $config: ['lazy', 'nullify'],
          value: {
            type: 'combochipview'
          }
        },
        chipStore: {
          $config: ['lazy', 'nullify'],
          value: {}
        },

        /**
         * When {@link #config-multiSelect} is `true`, you may configure `filterSelected` as
         * `true` to hide items in the dropdown when they are added to the selection.
         * It will appear as if the requested item has "moved" into the field's
         * {@link #config-chipView ChipView}.
         *
         * @config {Boolean}
         * @default false
         */
        filterSelected: null,

        /**
         * Text to display in the drop down when there are no items in the underlying store
         * @config {String}
         * @default
         */
        emptyText: null,

        /**
         * Get/sets combo value, selects corresponding item in the list
         * Setting null clears the field.
         *
         * If {@link #config-multiSelect} is `true`, then multiple values may be passed as an array.
         * If the values are records, these become the selected record set held by {@link #property-valueCollection},
         * and the `value` yielded by this field is an array of all the {@link #config-valueField}s from the records.
         * @fires select
         * @fires action
         * @property {Object}
         * @name value
         */

        /**
         * The initial value of this Combo box. In single select mode (default) it's a simple string value, for
         * {@link #config-multiSelect} mode, it should be an array of record ids.
         * @config {String|Number[]|String[]}
         * @default
         */
        value: null,

        /**
         * `true` to cause the field to be in an invalid state while the typed filter string does not match a record in the store.
         * @config {Boolean}
         * @default
         */
        validateFilter: true,

        /**
         * `true` to clear value typed to a multiselect combo when picker is collapsed
         * @config {Boolean}
         * @default
         */
        clearTextOnPickerHide: true
      };
    }
    /**
     * A constant value for the {@link #config-triggerAction} config to indicate that clicking the trigger should
     * filter the dataset using the last filter query string, *not* the input field value.
     * @member {String} queryLast
     * @readonly
     * @static
     */

  }, {
    key: "queryLast",
    get: function get() {
      return 'last';
    }
  }]);

  return Combo;
}(_PickerField_js__WEBPACK_IMPORTED_MODULE_33__["default"]);



var ComboChipView = /*#__PURE__*/function (_ChipView) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default()(ComboChipView, _ChipView);

  var _super3 = _createSuper(ComboChipView);

  function ComboChipView() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default()(this, ComboChipView);

    return _super3.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(ComboChipView, null, [{
    key: "$name",
    get: function get() {
      return 'ComboChipView';
    }
  }, {
    key: "type",
    get: function get() {
      return 'combochipview';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        closeHandler: 'up.onChipClose',
        itemsFocusable: false,
        multiSelect: true,
        itemTpl: function itemTpl(record) {
          return record[this.owner.displayField];
        },
        scrollable: {
          overflowY: 'auto'
        }
      };
    }
  }]);

  return ComboChipView;
}(_ChipView_js__WEBPACK_IMPORTED_MODULE_34__["default"]);

var ComboChipNavigator = /*#__PURE__*/function (_Navigator) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default()(ComboChipNavigator, _Navigator);

  var _super4 = _createSuper(ComboChipNavigator);

  function ComboChipNavigator() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default()(this, ComboChipNavigator);

    return _super4.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(ComboChipNavigator, [{
    key: "onTargetClick",
    value: function onTargetClick(clickEvent) {
      var item = clickEvent.target.closest(this.itemSelector);

      if (item && !clickEvent.shiftKey && !item.contains(clickEvent.target.closest('[data-noselect]'))) {
        this.ownerCmp.selected.clear();
      } // Our own updateActiveItem also selects because on superclass *key* navigation
      // (which is async on scroll end), it sets activeItem, and we select at that time.
      // So set a flag which disables this.


      this.inClickHandler = true;
      this.activeItem = item;
      this.inClickHandler = false;
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(keyEvent) {
      // ENTER does not toggle selectedness in a ChipView.
      // ChipView's selection is bound to navigation.
      if (keyEvent.key !== 'Enter') {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(ComboChipNavigator.prototype), "onKeyDown", this).call(this, keyEvent);
      }
    }
  }, {
    key: "updateActiveItem",
    value: function updateActiveItem(activeItem, oldActiveItem) {
      var chipView = this.ownerCmp;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(ComboChipNavigator.prototype), "updateActiveItem", this).call(this, activeItem, oldActiveItem); // Selection simply follows navigation in a ChipView


      if (activeItem && !this.inClickHandler) {
        chipView.selected.add(chipView.getRecord(activeItem));
      }
    }
  }, {
    key: "navigatePrevious",
    value: function navigatePrevious(keyEvent) {
      var chipView = this.ownerCmp;

      if (chipView.navigator.activeItem && !keyEvent.shiftKey) {
        chipView.selected.clear();
      }

      if (this.previous) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(ComboChipNavigator.prototype), "navigatePrevious", this).call(this, keyEvent);
      } else {
        this.activeItem = null;
      }
    }
  }, {
    key: "navigateNext",
    value: function navigateNext(keyEvent) {
      var chipView = this.ownerCmp; // SHIFT+navigate preserves selection

      if (chipView.navigator.activeItem && !keyEvent.shiftKey) {
        chipView.selected.clear();
      }

      if (this.next) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(ComboChipNavigator.prototype), "navigateNext", this).call(this, keyEvent);
      } else {
        this.activeItem = null;
      }
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        allowShiftKey: true
      };
    }
  }]);

  return ComboChipNavigator;
}(_helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_39__["default"]); // Register this widget type with its Factory


Combo.initClass();
ComboChipView.initClass();
Combo._$name = 'Combo';

/***/ }),

/***/ "./lib/Core/widget/Container.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/Container.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Container; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_number_max_safe_integer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.number.max-safe-integer */ "./node_modules/core-js/modules/es.number.max-safe-integer.js");
/* harmony import */ var core_js_modules_es_number_max_safe_integer__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_max_safe_integer__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _layout_Layout_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./layout/Layout.js */ "./lib/Core/widget/layout/Layout.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Ripple_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./Ripple.js */ "./lib/Core/widget/Ripple.js");
/* harmony import */ var _util_Bag_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../util/Bag.js */ "./lib/Core/util/Bag.js");





























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Core/widget/Container
 */

var emptyObject = Object.freeze({}),
    emptyArray = Object.freeze([]),
    returnWeight = function returnWeight(i) {
  return i.weight;
},
    // Allowing string weights (used by subgrids for backwards compatibility)
sortByWeight = function sortByWeight(_ref, _ref2) {
  var a = _ref.weight;
  var b = _ref2.weight;

  if (typeof a === 'string' || typeof b === 'string') {
    return String(a).localeCompare(String(b));
  } // Items without weight sort last


  return (a !== null && a !== void 0 ? a : Number.MAX_SAFE_INTEGER) - (b !== null && b !== void 0 ? b : Number.MAX_SAFE_INTEGER);
},
    isNotHidden = function isNotHidden(w) {
  return !w.hidden;
};
/**
 * Widget that can contain other widgets. Layout is flexbox by default, see the {@link #config-layout} config.
 *
 * ```javascript
 * // create a container with two widgets
 * let container = new Container({
 *     items : [
 *         { type : 'text', label : 'Name' },
 *         { type : 'number', label : 'Score' }
 *     ]
 * });
 * ```
 *
 * Containers can have child widgets added, or removed during their lifecycle to accommodate business needs.
 *
 * For example:
 *
 *  ```javascript
 *  myTaskPopup.on({
 *      beforeShow() {
 *          if (task.type === task.MASTER) {
 *              // Insert the childTask multiselect before the masterTask field
 *              myPopyup.insert(childTaskMultiselect, masterTaskField)
 *
 *              // We don't need this for master tasks
 *              myPopup.remove(masterTaskField);
 *          }
 *          else {
 *              // Insert the masterTask combo before the childTask multiselect
 *              myPopyup.insert(masterTaskField, childTaskMultiselect)
 *
 *              // We don't need this for child tasks
 *              myPopup.remove(childTaskMultiselect);
 *          }
 *      }
 *  });
 * ```
 *
 * @extends Core/widget/Widget
 * @classType container
 * @externalexample widget/Container.js
 */


var Container = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default()(Container, _Widget);

  var _super = _createSuper(Container);

  function Container() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default()(this, Container);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(Container, [{
    key: "startConfigure",

    /**
     * An Array of this Container's children. This is read-only and immutable.
     *
     * Use the {@link #function-add} and {@link #function-remove} methods to change content.
     * @member {Core.widget.Widget[]} items
     * @readonly
     */

    /**
     * Sets multiple flexbox settings which affect how child widgets are arranged.
     *
     * By default, Containers use flexbox layout, so this property may contain the following properties:
     *
     * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction">flexDirection</a> default '`row`'
     * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap">flexWrap</a>
     * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-flow">flexFlow</a>
     * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content">justifyContent</a>
     * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-items">alignItems</a>
     * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-content">alignContent</a>
     * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/place-content">placeContent</a>
     * @member {Object} layoutStyle
     * @category Layout
     */

    /**
     * The {@link Core.data.Model record} to be applied to the fields contained in this Container. Any descendant
     * widgets of this Container with a `name` property will have its value set to the value of that named property of
     * the record. If no record is passed, the widget has its value set to `null`.
     * @member {Core.data.Model} record
     */
    value: function startConfigure(config) {
      // Set a flag so that code can test for presence of items.
      // Widgets which render child widgets outside of the Container scheme
      // can set this flag (eg Panels with tools and tbar).
      var items = config.items || config.lazyItems;
      this.hasItems = Boolean(items && (Array.isArray(items) ? items : Object.keys(items)).length);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(Container.prototype), "startConfigure", this).call(this, config);
    }
    /**
     * Removes the passed child/children from this Container.
     * @param  {...Core.widget.Widget} toRemove The child or children to remove.
     * @returns {Core.widget.Widget|Core.widget.Widget[]} All the removed items. An array if multiple items
     * were removed, otherwise, just the item removed.
     */

  }, {
    key: "remove",
    value: function remove() {
      for (var _len = arguments.length, toRemove = new Array(_len), _key = 0; _key < _len; _key++) {
        toRemove[_key] = arguments[_key];
      }

      var returnArray = true;

      if (toRemove.length === 1) {
        if (Array.isArray(toRemove[0])) {
          toRemove = toRemove[0];
        } else {
          returnArray = false;
        }
      }

      var me = this,
          _items = me._items,
          result = [];

      for (var i = 0; i < toRemove.length; i++) {
        var childToRemove = toRemove[i];

        if (_items.includes(childToRemove)) {
          _items.remove(childToRemove);

          me.layout.removeChild(childToRemove);
          result.push(childToRemove);
          me.onChildRemove(childToRemove);
        }
      }

      return returnArray ? result : result[0];
    }
    /**
     * Removes all children from this Container.
     * @returns {Core.widget.Widget[]} All the removed items.
     */

  }, {
    key: "removeAll",
    value: function removeAll() {
      return this.remove(this.items);
    }
    /**
     * Appends the passed widget/widgets to this Container.
     *
     * If the widgets specify a `weight`, they are inserted at the correct index compared to the existing items weights.
     *
     * @param  {...Core.widget.Widget} toAdd The child or children to add.
     * @returns {Core.widget.Widget|Core.widget.Widget[]} All the added widgets. An array if multiple items
     * were added, otherwise, just the item added.
     */

  }, {
    key: "add",
    value: function add() {
      for (var _len2 = arguments.length, toAdd = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        toAdd[_key2] = arguments[_key2];
      }

      var returnArray = true;

      if (toAdd.length === 1) {
        if (Array.isArray(toAdd[0])) {
          toAdd = toAdd[0];
        } else {
          returnArray = false;
        }
      } // Force creation of our items Bag


      if (!this.items) {
        this.items = [];
      }

      var me = this,
          _items = me._items,
          result = [];

      for (var i = 0; i < toAdd.length; i++) {
        var childToAdd = toAdd[i]; // Items with weight are inserted at correct index

        if (childToAdd.weight != null) {
          // Cannot use cached _items, weights might be unordered in set being added
          var index = _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].findInsertionIndex(childToAdd, me._items.values, sortByWeight);
          result.push(me.insert(childToAdd, index));
        } // Those without are appended
        else {
            if (!(childToAdd instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_28__["default"])) {
              childToAdd = me.createWidget(childToAdd);
            } else {
              childToAdd.parent = me;
            }

            if (!_items.includes(childToAdd)) {
              _items.add(childToAdd);

              me.onChildAdd(childToAdd);
              me.layout.appendChild(childToAdd);
              result.push(childToAdd);
            }
          }
      }

      return returnArray ? result : result[0];
    }
    /**
     * Inserts the passed widget into this Container at the specified position.
     * @param  {Core.widget.Widget} toAdd The child to insert.
     * @param {Number|Core.widget.Widget} The index to insert at or the existing child to insert before.
     * @returns {Core.widget.Widget} The added widget.
     */

  }, {
    key: "insert",
    value: function insert(toAdd, index) {
      // Force creation of our items Bag
      if (!this.items) {
        this.items = [];
      }

      var me = this,
          _items = me._items;

      if (toAdd instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_28__["default"]) {
        toAdd.parent = me;
      } else {
        toAdd = me.createWidget(toAdd);
      }

      if (_items.includes(index)) {
        index = me.indexOfChild(index);
      }

      index = Math.min(index, _items.count);
      var newValues = _items.values;
      newValues.splice(index, 0, toAdd);
      _items.values = newValues; // Register inserted item

      me.onChildAdd(toAdd);
      me.layout.insertChild(toAdd, index);
      return toAdd;
    }
  }, {
    key: "indexOfChild",
    value: function indexOfChild(child) {
      return this.items.indexOf(child);
    }
  }, {
    key: "changeLazyItems",
    value: function changeLazyItems(lazyItems) {
      this.items = lazyItems;
      this.layout.renderChildren();
    }
  }, {
    key: "changeItems",
    value: function changeItems(items) {
      var me = this,
          newItems = [],
          result = new _util_Bag_js__WEBPACK_IMPORTED_MODULE_34__["default"]();

      if (Array.isArray(items)) {
        me.processItemsArray(items, newItems);
      } else if (items) {
        me.processItemsObject(items, me.namedItems, newItems);
      } // Allow child items to have a weight to establish their order


      if (newItems.some(returnWeight)) {
        newItems.sort(sortByWeight);
      }

      result.add(newItems);
      return result;
    }
  }, {
    key: "updateItems",
    value: function updateItems(items) {
      items.forEach(this.onChildAdd, this);
    }
  }, {
    key: "updateHideWhenEmpty",
    value: function updateHideWhenEmpty() {
      this.syncChildCount();
    }
  }, {
    key: "processItemsArray",
    value: function processItemsArray(items, result) {
      var len = items.length;
      var i, item;

      for (i = 0; i < len; i++) {
        item = items[i];

        if (item instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_28__["default"]) {
          item.parent = this;
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].removeClasses(item.element, _Widget_js__WEBPACK_IMPORTED_MODULE_28__["default"].outerCls);
        } else {
          item = this.createWidget(item);
        } // If the widget creation function returns null, nothing to add


        if (item) {
          result.push(item);
        }
      }
    }
  }, {
    key: "processItemsObject",
    value: function processItemsObject(items) {
      var namedItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject;
      var result = arguments.length > 2 ? arguments[2] : undefined;
      var item, ref;

      for (ref in items) {
        item = items[ref]; // It might come in as itemRef : false

        if (item) {
          // If this class or instance has a "namedItems" object
          // named by this ref, then use it as the basis for the item
          if (ref in namedItems) {
            item = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_21___default()(item) === 'object' ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].merge(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].clone(namedItems[ref]), item) : namedItems[ref];
          } // Allow namedItems to be overridden with itemKey : false to indicate unavailability of an item


          if (item) {
            if (item instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_28__["default"]) {
              item.parent = this;
            } else {
              if (item instanceof Object) {
                item.ref = ref;
              }

              item = this.createWidget(item);
            } // If the widget creation function returns null, nothing to add


            if (item) {
              item.ref = ref;
              result.push(item);
            }
          }
        }
      }
    }
  }, {
    key: "onChildAdd",
    value: function onChildAdd(item) {
      var ref = item.ref || item.id; // Don't just assign the property across since the default value is undefined
      // which means false. Only set to true if we are readOnly

      if (this.readOnly) {
        item.readOnly = true;
      } // Keep layout informed of child item state


      this.layout.onChildAdd(item);

      if (ref) {
        for (var current = this; current; current = current.parent) {
          // Silently add the descendant to the ancestor's widgetMap without kicking off
          // the ancestor's items processing by directly accessing the widgetMap property.
          current.addDescendant(item, ref);
        }
      }

      this.syncChildCount();
    }
  }, {
    key: "onChildHide",
    value: function onChildHide() {
      this.syncChildCount();
    }
  }, {
    key: "onChildShow",
    value: function onChildShow() {
      this.syncChildCount();
    }
  }, {
    key: "syncChildCount",
    value: function syncChildCount() {
      // If called during configuration, the element may not be available because
      // some non-item widgets (eg, Tools) instantiate and declare themselves through
      // onChildAdd before the element is set.
      // But also there may be no items because of     lazyItems.
      // So do the initial sync at render time.
      if (!this.isConfiguring) {
        var me = this,
            childItems = me.childItems,
            length = childItems.length,
            _childItems$filter = childItems.filter(isNotHidden),
            visibleLength = _childItems$filter.length;

        if (me.hideWhenEmpty) {
          var shouldHide = Boolean(!visibleLength);

          if (Boolean(me._hidden) !== shouldHide) {
            me.hidden = shouldHide;
          }
        } // Keep hasItems property up to date. It's used by the isFocusable getter.


        me.hasItems = Boolean(length);
        me.contentElement.classList[visibleLength ? 'remove' : 'add']('b-no-visible-children'); // Reevaluate whether we should have the b-text-content class

        me.updateTextContent(me._textContent);
      }
    }
  }, {
    key: "addDescendant",
    value: function addDescendant(item, ref) {
      var widgetMap = this._widgetMap || (this._widgetMap = {});

      if (!widgetMap[ref]) {
        widgetMap[ref] = item;
      }
    }
  }, {
    key: "onChildRemove",
    value: function onChildRemove(item) {
      var ref = item.ref || item.id;

      if (ref) {
        for (var current = this; current; current = current.parent) {
          if (current.widgetMap[ref] === item) {
            delete current.widgetMap[ref];
          }
        }
      } // Keep layout informed of child item state


      this.layout.onChildRemove(item);
      this.syncChildCount();
    }
    /**
     * An object which contains a map of descendant widgets keyed by their {@link Core.widget.Widget#config-ref ref}.
     * All descendant widgets will be available in the `widgetMap`.
     * @property {Object}
     * @readonly
     * @typings any
     */

  }, {
    key: "changeRecord",
    value: function changeRecord(record) {
      // The config system's non-change vetoing must be bypassed.
      // The record might have changed, or the destination fields may be out of sync.
      this._record = record == null ? emptyObject : null;
      return record;
    }
  }, {
    key: "updateRecord",
    value: function updateRecord(record) {
      /**
       * Fired before this container will load record values into its child fields. This is useful if you
       * want to modify the UI before data is loaded (e.g. set some input field to be readonly)
       * @event beforeSetRecord
       * @param {Core.widget.Container} source The container
       * @param {Core.data.Model} record The record
       */
      this.trigger('beforeSetRecord', {
        record: record
      });
      this.setValues(record, true, !this.$highlight);
    }
  }, {
    key: "setRecord",
    value: function setRecord(record, highlightChanges) {
      this.$highlight = highlightChanges;
      this.record = record;
      this.$highlight = false;
    }
    /**
     * A function called by descendant widgets after they trigger their 'change' event, in reaction to field changes.
     * By default implements the functionality for the `autoUpdateRecord` config.
     *
     * @param {Object} params Normally the event params used when triggering the 'change' event
     * @internal
     */

  }, {
    key: "onFieldChange",
    value: function onFieldChange(_ref3) {
      var source = _ref3.source,
          userAction = _ref3.userAction;

      // When configured with `autoUpdateRecord`, changes from descendant fields/widgets are applied to the loaded
      // record using the fields `name`. Only changes from valid fields will be applied
      if (this.autoUpdateRecord) {
        var record = this.record,
            name = source.name,
            isValid = source.isValid,
            value = source.value;

        if (record && userAction && name && isValid) {
          record[name] = value;
        }
      }
    }
  }, {
    key: "getValues",
    value: function getValues(filterFn) {
      var me = this,
          widgets = me.queryAll(function (w) {
        return w.name;
      }),
          len = widgets.length,
          result = {};

      for (var i = 0; i < len; i++) {
        var widget = widgets[i],
            name = widget.name;

        if (!filterFn || filterFn(widget)) {
          result[name] = widget.value;
        }
      }

      return result;
    }
  }, {
    key: "updateTextContent",
    value: function updateTextContent(textContent) {
      // Add the text content class if we have no visible immediate item children.
      this.contentElement.classList[textContent && this.hasNoChildren ? 'add' : 'remove']('b-text-content'); // Depending on CSS settings around how this widget handles text content and widthing
      // we *may* have to realign. Realign only goes ahead if we're visible and floating.

      if (this.rendered) {
        this.realign();
      }
    }
  }, {
    key: "updateLayoutStyle",
    value: function updateLayoutStyle(layoutStyle) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].applyStyle(this.contentElement, layoutStyle);
    }
  }, {
    key: "changeLayout",
    value: function changeLayout(layout) {
      // TODO: Layouts to be Factoryable
      return _layout_Layout_js__WEBPACK_IMPORTED_MODULE_31__["default"].getLayout(layout, this);
    } // Items to iterate over

  }, {
    key: "getWidgetById",

    /**
     * Returns a directly contained widget by id
     * @param {String} id The widget id
     * @returns {Core.widget.Widget}
     */
    value: function getWidgetById(id) {
      return this.widgetMap[id];
    }
    /**
     * This function is called prior to creating widgets, override it in subclasses to allow containers to modify the
     * configuration of each widget. When adding a widget to a container hierarchy each parent containers
     * `processWidgetConfig` will be called. Returning false from the function prevents the widget from being added at
     * all.
     */

  }, {
    key: "processWidgetConfig",
    value: function processWidgetConfig(widget) {}
    /**
     * This method combines container {@link #config-defaults}
     * @param {Object} widgetConfig
     * @param {String|Function} [type] The type of widget described by `widgetConfig`.
     * @returns {Object}
     * @internal
     */

  }, {
    key: "setupWidgetConfig",
    value: function setupWidgetConfig(widgetConfig, type) {
      var me = this; // A string becomes the defaultType (see below) with the html set to the string.

      if (typeof widgetConfig === 'string') {
        widgetConfig = {
          html: widgetConfig
        };
      } // An element is encapsulated by a Widget
      else if (widgetConfig.nodeType === 1) {
          widgetConfig = {
            element: widgetConfig,
            id: widgetConfig.id
          };
        }

      if (typeof type === 'string' || !type && (type
      /* assignment */
      = widgetConfig.type)) {
        type = _Widget_js__WEBPACK_IMPORTED_MODULE_28__["default"].resolveType(type, true);
      } // widgetConfig = ObjectHelper.assign({}, me.defaults, widgetConfig, { parent : me });


      widgetConfig = (type || _Widget_js__WEBPACK_IMPORTED_MODULE_28__["default"]).mergeConfigs(me.defaults, widgetConfig, {
        parent: me
      });

      for (var ancestor = widgetConfig.parent; ancestor; ancestor = ancestor.parent) {
        if (ancestor.processWidgetConfig(widgetConfig) === false) {
          return null;
        }
      }

      if (me.trigger('beforeWidgetCreate', {
        widgetConfig: widgetConfig
      }) === false) {
        return null;
      }

      return widgetConfig;
    }
    /**
     * This function converts a Widget config object into a Widget.
     * @param {Object} widget A Widget config object.
     * @internal
     */

  }, {
    key: "createWidget",
    value: function createWidget(widget) {
      return _Widget_js__WEBPACK_IMPORTED_MODULE_28__["default"].create(this.setupWidgetConfig(widget), this.defaultType);
    } // Reapply defaults, not used during config

  }, {
    key: "updateDefaults",
    value: function updateDefaults(defaults, oldDefaults) {
      if (!this.isConfiguring) {
        var entries = Object.entries(defaults);
        this.eachWidget(function (widget) {
          entries.forEach(function (_ref4) {
            var _ref5 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_20___default()(_ref4, 2),
                prop = _ref5[0],
                value = _ref5[1];

            // Apply defaults only if current value matches the old default
            if (widget[prop] === oldDefaults[prop]) {
              widget[prop] = value;
            }
          });
        }, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // Pull in lazyItems at last second
      this.getConfig('lazyItems');
      this.layout.renderChildren(); // If called during configuration, the element may not have been available because
      // some non-item widgets (eg, Tools) instantiate and declare themselves through
      // onChildAdd before the element is set.
      // But also there may have been no items because of lazyItems.
      // So do the initial sync at render time.

      this.syncChildCount();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(Container.prototype), "render", this).apply(this, arguments);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _items = this._items;
      _items && _items.forEach(function (widget) {
        return widget.destroy && widget.destroy();
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(Container.prototype), "doDestroy", this).call(this);
    }
    /**
     * Checks that all descendant fields are valid.
     * @returns {Boolean} Returns `true` if all contained fields are valid, otherwise `false`
     */

  }, {
    key: "setValues",
    value: function setValues(values) {
      var onlyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var preventHighlight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      // Flag checked by Field to determine if it should highlight change or not
      this._isSettingValues = {
        preventHighlight: preventHighlight
      };
      this.eachWidget(function (widget) {
        var hec = widget.highlightExternalChange,
            key = onlyName ? widget.name : widget.name || widget.ref || widget.id;

        if ('value' in widget && key) {
          if (preventHighlight) {
            // Don't want a field highlight on mass change
            widget.highlightExternalChange = false;
          } // Setting to null when value not matched clears field


          widget.value = values && key in values ? values[key] : null;
          widget.highlightExternalChange = hec;
        }
      }, true);
      this._isSettingValues = false;
    }
  }, {
    key: "items",
    get: function get() {
      // If we are being asked for items, ingest lazyItems.
      this.getConfig('lazyItems'); // The documented API for items is an Array.
      // Internal code should access _items

      if (!this._items) {
        if (this.initializingItems) {
          // This is a created array. User may mutate it.
          return [];
        }

        this.items = emptyArray;
      } // This is the Collection's array. User may not mutate it.


      return this._items.values;
    }
  }, {
    key: "widgetMap",
    get: function get() {
      if (!this._widgetMap) {
        this._widgetMap = {};
      } // Force evaluation of the configured items by the getter
      // so that configs are promoted to widgets and the widgetMap
      // is created, and if there are widgets, populated.


      if (!this.initializingItems) {
        this.getConfig('items');
      }

      return this._widgetMap;
    }
  }, {
    key: "hasNoChildren",
    get: function get() {
      // If we have *uningested* lazyItems, use them to find our items length.
      // In that case we must not cause ingestion of the lazyItems by referencing this.items.
      // If we have items, then only those that are visible have any bearing.
      // Popup also has to consult this property to decide on its CSS classes.
      var lazyItems = this.initialConfig.lazyItems,
          lazyItemsArray = lazyItems && (Array.isArray(lazyItems) ? lazyItems : Object.values(lazyItems)),
          _filter = (lazyItemsArray && !this._items ? lazyItemsArray : this.items).filter(isNotHidden),
          length = _filter.length;

      return !length;
    }
  }, {
    key: "childItems",
    get: function get() {
      return this.items;
    }
  }, {
    key: "focusElement",
    get: function get() {
      // Find first focusable descendant widget that is not our close tool.
      var firstFocusable = this.query(this.defaultFocus || function (w) {
        return w.isFocusable && w.ref !== 'close';
      });

      if (firstFocusable) {
        return firstFocusable.focusElement;
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(Container.prototype), "focusElement", this);
    }
  }, {
    key: "isValid",
    get: function get() {
      var valid = true;
      this.eachWidget(function (widget) {
        // Touch each widget so that they all update their invalid state. This is important for required fields
        // since they don't initially complain if they start as empty.
        if ('isValid' in widget && !widget.isValid) {
          valid = false;
        }
      }, true);
      return valid;
    }
    /**
     * Retrieves or sets all values from/to contained fields.
     * Accepts and returns a map, using {@link Core.widget.Field#config-name name},
     * {@link Core.widget.Widget#config-ref ref} or {@link Core.widget.Widget#config-id id} (in that order) as keys.
     *
     * ```javascript
     * container.values = {
     *     firstName : 'Clark',
     *     surname : 'Kent'
     * };
     * ```
     *
     * @property {Object}
     */

  }, {
    key: "values",
    get: function get() {
      var values = {};
      this.eachWidget(function (widget) {
        if ('value' in widget) {
          values[widget.name || widget.ref || widget.id] = widget.value;
        }
      }, true);
      return values;
    },
    set: function set(values) {
      this.setValues(values);
    }
    /**
     * Returns `true` if currently setting values. Allows fields change highlighting to distinguishing between initially
     * setting values and later on changing values.
     * @property {Boolean}
     */

  }, {
    key: "isSettingValues",
    get: function get() {
      var _this$parent;

      // Fields query their parent, pass the question up in case containers are nested
      return Boolean(this._isSettingValues || ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.isSettingValues));
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'Container';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'container';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * An object containing typed child widget config objects or Widgets. May also be specified
         * as an array.
         *
         * If configured as an Object, the property names are used as the child component's
         * {@link Core.widget.Widget#config-ref ref} name, and the value is the child component's config object.
         *
         * ```javascript
         *  new Panel({
         *      title    : 'Test Panel',
         *      floating : true,
         *      centered : true,
         *      width    : 600,
         *      height   : 400,
         *      layout   : 'fit',
         *      items    : {
         *          tabs : {
         *              type : 'tabpanel',
         *              items : {
         *                  general : {
         *                      title : 'General',
         *                      html  : 'General content'
         *                  },
         *                  details : {
         *                      title : 'Details',
         *                      html  : 'Details content'
         *                  }
         *              }
         *          }
         *      }
         *  }).show();
         * ```
         *
         * The order of the child widgets is determined by the order they are defined in `items`, but can also be
         * affected by configuring a {@see Core.widget.Widget#config-weight weight} on one or more widgets.
         *
         * @config {Object|Object[]|Core.widget.Widget[]}
         */
        items: null,

        /**
         * An array of {@link #config-items child item} _config objects_ which is to be converted into
         * instances only when this Container is rendered, rather than eagerly at construct time.
         *
         * _This is mutually exclusive with the {@link #config-items} config._
         *
         * @config {Object|Object[]|Core.widget.Widget[]}
         */
        lazyItems: {
          $config: ['lazy'],
          value: null
        },

        /**
         * A config object containing default settings to apply to all child widgets.
         * @config {Object}
         */
        defaults: null,
        defaultType: 'widget',

        /**
         * The CSS style properties to apply to the {@link Core.widget.Widget#property-contentElement}.
         *
         * By default, a Container's {@link Core.widget.Widget#property-contentElement} uses flexbox layout, so this
         * config may contain the following properties:
         *
         * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction">flexDirection</a> default '`row`'
         * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap">flexWrap</a>
         * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-flow">flexFlow</a>
         * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content">justifyContent</a>
         * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-items">alignItems</a>
         * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-content">alignContent</a>
         * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/place-content">placeContent</a>
         * @config {Object}
         */
        layoutStyle: null,

        /**
         * An optional CSS class to add to child items of this container.
         * @config {String}
         */
        itemCls: null,

        /**
         * The short name of a helper class which manages rendering and styling of child items.
         *
         * By default, the only special processing that is applied is that the Container class's
         * {@link #config-itemCls} is added to child items.
         *
         * Containers use CSS flexbox in its default configuration to arrange child items. You may either use the
         * {@link #config-layoutStyle} configuration to tune how child items are layed out, or use one of the built
         * in helper classes which include:
         *
         *  - `card` Child items are displayed one at a time, size to fit the
         *  {@link Core.widget.Widget#property-contentElement} and are slid in from the side when activated.
         * @config {String}
         */
        layout: 'default',
        // TODO: deprecate namedItems, use items instead

        /**
         * An object containing named config objects which may be referenced by name in any {@link #config-items}
         * object. For example, a specialized {@link Core.widget.Menu Menu} subclass may have a `namedItems` default
         * value defined like this:
         *
         * ```javascript
         *  namedItems : {
         *      removeRow : {
         *          text : 'Remove row',
         *          onItem() {
         *              this.ownerGrid.remove(this.ownerGrid.selectedRecord);
         *          }
         *      }
         *  }
         * ```
         *
         * Then whenever that subclass is instantiated and configured with an {@link #config-items} object, the
         * items may be configured like this:
         *
         * ```javascript
         *  items : {
         *      removeRow : true,   // The referenced namedItem will be applied to this
         *      otherItemRef : {
         *          text : 'Option 2',
         *          onItem() {
         *          }
         *      }
         * }
         * ```
         * @config {Object}
         */
        namedItems: null,

        /**
         * Specify `true` for a container used to show text markup. It will apply the CSS class `b-text-content`
         * which specifies a default max-width that makes long text more readable.
         * 
         * This CSS class is automatically removed if the container adds/defines child Widgets.
         * @config {Boolean}
         * @default
         */
        textContent: true,

        /**
         * Record whose values will be used to populate fields in the container.
         * @config {Object}
         * @internal
         */
        record: null,
        // NOTE: internal since record is not documented

        /**
         * Update assigned {@link #config-record} automatically on field changes
         * @config {Boolean}
         * @internal
         */
        autoUpdateRecord: null,

        /**
         * Specify `true` to make this container hide when it has no visible children (Either empty
         * or all children hidden).
         *
         * Container will show itself when there are visible children, ie: hidden children are
         * shown, or new visible childre are added.
         * @config {Boolean}
         * @default
         */
        hideWhenEmpty: null
      };
    }
  }]);

  return Container;
}(_Widget_js__WEBPACK_IMPORTED_MODULE_28__["default"]); // Register this widget type with its Factory



Container.initClass();
Container._$name = 'Container';

/***/ }),

/***/ "./lib/Core/widget/DateField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/DateField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _DatePicker_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./DatePicker.js */ "./lib/Core/widget/DatePicker.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: picker icon (calendar) should show day number




/**
 * @module Core/widget/DateField
 */

/**
 * Date field widget (text field + date picker).
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.DateColumn DateColumn}.
 *
 * @extends Core/widget/PickerField
 *
 * @example
 * // minimal DateField config with date format specified
 * let dateField = new DateField({
 *   format: 'YYMMDD'
 * });
 *
 * @classType datefield
 * @externalexample widget/DateField.js
 */

var DateField = /*#__PURE__*/function (_PickerField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(DateField, _PickerField);

  var _super = _createSuper(DateField);

  function DateField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, DateField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(DateField, [{
    key: "changePicker",
    //endregion
    //region Init & destroy

    /**
     * Creates default picker widget
     *
     * @internal
     */
    value: function changePicker(picker, oldPicker) {
      var me = this,
          defaults = {
        owner: me,
        forElement: me[me.pickerAlignElement],
        minDate: me.min,
        maxDate: me.max,
        weekStartDay: me._weekStartDay,
        // need to pass the raw value to let the component to use its default value
        align: {
          anchor: me.overlayAnchor,
          target: me[me.pickerAlignElement]
        },
        onSelectionChange: function onSelectionChange(_ref) {
          var selection = _ref.selection,
              picker = _ref.source;

          // We only care about what DatePicker does if it has been opened
          if (picker.isVisible) {
            me._isUserAction = true;
            me.value = selection[0];
            me._isUserAction = false;
            picker.hide();
          }
        }
      };

      if (me.value) {
        defaults.value = me.value;
      } else {
        defaults.date = new Date();
      }

      picker = _DatePicker_js__WEBPACK_IMPORTED_MODULE_11__["default"].reconfigure(oldPicker, picker, {
        owner: me,
        defaults: defaults
      }); // May have been set to null (destroyed)

      if (picker && me.calendarContainerCls) {
        picker.element.classList.add(me.calendarContainerCls);
      }

      return picker;
    } //endregion
    //region Click listeners

  }, {
    key: "onBackClick",
    value: function onBackClick() {
      var me = this,
          min = me.min;

      if (!me.readOnly && me.value) {
        var newValue = me.backShiftDate;

        if (!min || min.getTime() <= newValue) {
          me._isUserAction = true;
          me.value = newValue;
          me._isUserAction = false;
        }
      }
    }
  }, {
    key: "onForwardClick",
    value: function onForwardClick() {
      var me = this,
          max = me.max;

      if (!me.readOnly && me.value) {
        var newValue = me.forwardShiftDate;

        if (!max || max.getTime() >= newValue) {
          me._isUserAction = true;
          me.value = newValue;
          me._isUserAction = false;
        }
      }
    } //endregion
    //region Toggle picker

  }, {
    key: "showPicker",
    value: function showPicker(focusPicker) {
      if (this.readOnly) {
        return;
      }

      var _picker = this._picker; // If it's already instanced, move it.
      // It will be initialized correctly if not.

      _picker && (_picker.value = this.value);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DateField.prototype), "showPicker", this).call(this, focusPicker);
    }
  }, {
    key: "focusPicker",
    value: function focusPicker() {
      this.picker.focus();
    } //endregion
    // region Validation

  }, {
    key: "transformDateValue",
    //endregion
    //region Getters/setters
    value: function transformDateValue(value) {
      if (value != null) {
        if (!_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isDate(value)) {
          if (typeof value === 'string') {
            // If date cannot be parsed with set format, try fallback - the more general one
            value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].parse(value, this.format) || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].parse(value, this.fallbackFormat);
          } else {
            value = new Date(value);
          }
        } // We insist on a *valid* Date as the value


        if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isValidDate(value)) {
          return this.transformTimeValue(value);
        }
      }

      return null;
    }
  }, {
    key: "transformTimeValue",
    value: function transformTimeValue(value) {
      var keep = this.keepTime;
      value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clone(value);

      if (!keep) {
        _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(value, false);
      } else {
        var timeValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].parse(keep, this.timeFormat); // if this.keepTime is a valid date or a string describing valid time copy from it

        if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isValidDate(timeValue)) {
          _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].copyTimeValues(value, timeValue);
        } // otherwise try to copy from the current value
        else if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isValidDate(this.value)) {
            _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].copyTimeValues(value, this.value);
          } // else don't change time

      }

      return value;
    }
  }, {
    key: "changeMin",
    value: function changeMin(value) {
      return this.transformDateValue(value);
    }
  }, {
    key: "updateMin",
    value: function updateMin(min) {
      var input = this.input,
          _picker = this._picker;

      if (input) {
        input.min = min;
      } // See if our lazy config has been realized...


      if (_picker) {
        _picker.minDate = min;
      }

      this.syncInvalid();
    }
  }, {
    key: "changeMax",
    value: function changeMax(value) {
      return this.transformDateValue(value);
    }
  }, {
    key: "updateMax",
    value: function updateMax(max) {
      var input = this.input,
          _picker = this._picker;

      if (input) {
        input.max = max;
      }

      if (_picker) {
        _picker.maxDate = max;
      }

      this.syncInvalid();
    }
  }, {
    key: "updateWeekStartDay",
    value: function updateWeekStartDay(weekStartDay) {
      if (this._picker) {
        this._picker.weekStartDay = weekStartDay;
      }
    }
  }, {
    key: "changeValue",
    value: function changeValue(value, oldValue) {
      var me = this,
          newValue = me.transformDateValue(value); // A value we could not parse

      if (value && !newValue) {
        // setError uses localization
        me.setError('L{invalidDate}');
        return;
      }

      me.clearError('L{invalidDate}'); // Reject non-change

      if (me.hasChanged(oldValue, newValue)) {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DateField.prototype), "changeValue", this).call(this, newValue, oldValue);
      } // But we must fix up the display in case it was an unparseable string
      // and the value therefore did not change.


      if (!me.inputting) {
        me.syncInputFieldValue();
      }
    }
  }, {
    key: "updateValue",
    value: function updateValue(value, oldValue) {
      var picker = this._picker;

      if (picker && !this.inputting) {
        picker.value = value;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DateField.prototype), "updateValue", this).call(this, value, oldValue);
    }
  }, {
    key: "changeStep",
    value: function changeStep(value, was) {
      var type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default()(value);

      if (!value) {
        return null;
      }

      if (type === 'number') {
        value = {
          magnitude: Math.abs(value),
          unit: was ? was.unit : 'day'
        };
      } else if (type === 'string') {
        value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].parseDuration(value);
      }

      if (value && value.unit && value.magnitude) {
        if (value.magnitude < 0) {
          value = {
            magnitude: -value.magnitude,
            // Math.abs
            unit: value.unit
          };
        }

        return value;
      }
    }
  }, {
    key: "updateStep",
    value: function updateStep(value) {
      // If a step is configured, show the steppers
      this.element.classList[value ? 'remove' : 'add']('b-no-steppers');
      this.syncInvalid();
    }
  }, {
    key: "hasChanged",
    value: function hasChanged(oldValue, newValue) {
      if (oldValue && oldValue.getTime && newValue && newValue.getTime) {
        // Only compare date part
        return !_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isEqual(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(oldValue), _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(newValue));
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DateField.prototype), "hasChanged", this).call(this, oldValue, newValue);
    }
  }, {
    key: "updateFormat",
    value: function updateFormat() {
      this.syncInputFieldValue(true);
    } //endregion
    //region Localization

  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DateField.prototype), "updateLocalization", this).call(this);

      this.syncInputFieldValue(true);
    } //endregion
    //region Other

  }, {
    key: "internalOnKeyEvent",
    value: function internalOnKeyEvent(event) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DateField.prototype), "internalOnKeyEvent", this).call(this, event);

      if (event.key === 'Enter' && this.isValid) {
        this.picker.hide();
      }
    } //endregion

  }, {
    key: "backShiftDate",
    get: function get() {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(this.value, -1 * this._step.magnitude, this._step.unit);
    }
  }, {
    key: "forwardShiftDate",
    get: function get() {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(this.value, this._step.magnitude, this._step.unit);
    }
  }, {
    key: "isValid",
    get: function get() {
      var me = this,
          min = me.min,
          max = me.max;
      me.clearError('L{Field.minimumValueViolation}', true);
      me.clearError('L{Field.maximumValueViolation}', true);
      var value = me.value;

      if (value) {
        value = value.getTime();

        if (min && min.getTime() > value) {
          me.setError('L{Field.minimumValueViolation}', true);
          return false;
        }

        if (max && max.getTime() < value) {
          me.setError('L{Field.maximumValueViolation}', true);
          return false;
        }
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DateField.prototype), "isValid", this);
    }
  }, {
    key: "weekStartDay",
    get: function get() {
      // This trick allows our weekStartDay to float w/the locale even if the locale changes
      return typeof this._weekStartDay === 'number' ? this._weekStartDay : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].weekStartDay;
    }
  }, {
    key: "inputValue",
    get: function get() {
      // Do not use the _value property. If called during configuration, this
      // will import the configured value from the config object.
      var date = this.value;
      return date ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].format(date, this.format) : '';
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'DateField';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'datefield';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'date';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Get/Set format for date displayed in field (see {@link Core.helper.DateHelper#function-format-static}
         * for formatting options).
         * @property {String}
         * @name format
         */

        /**
         * Format for date displayed in field. Defaults to using long date format, as defined by current locale (`L`)
         * @config {String}
         * @default
         */
        format: 'L',
        // same for all languages
        fallbackFormat: 'YYYY-MM-DD',
        timeFormat: 'HH:mm:ss:SSS',

        /**
         * A flag which indicates what time should be used for selected date.
         * `false` by default which means time is reset to midnight.
         *
         * Possible options are:
         * - `false` to reset time to midnight
         * - `true` to keep original time value
         * - `17:00` a string which is parsed automatically
         * - `new Date(2020, 0, 1, 17)` a date object to copy time from
         *
         * @config {Boolean|Date|String}
         * @default
         */
        keepTime: false,

        /**
         * Format for date in the {@link #config-picker}. Uses localized format per default
         * @config {String}
         */
        pickerFormat: null,
        triggers: {
          expand: {
            cls: 'b-icon-calendar',
            handler: 'onTriggerClick',
            weight: 200
          },
          back: {
            cls: 'b-icon b-icon-angle-left b-step-trigger',
            handler: 'onBackClick',
            align: 'start',
            weight: 100
          },
          forward: {
            cls: 'b-icon b-icon-angle-right b-step-trigger',
            handler: 'onForwardClick',
            align: 'end',
            weight: 100
          }
        },
        // An optional extra CSS class to add to the picker container element
        calendarContainerCls: '',

        /**
         * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using
         * the specified {@link #config-format}.
         * @property {String|Date}
         * @name min
         */

        /**
         * Min value
         * @config {String|Date}
         */
        min: null,

        /**
         * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using
         * the specified {@link #config-format}.
         * @property {String|Date}
         * @name max
         */

        /**
         * Max value
         * @config {String|Date}
         */
        max: null,

        /**
         * The `step` property may be set in object form specifying two properties, `magnitude`, a Number, and
         * `unit`, a String.
         *
         * If a Number is passed, the steps's current unit is used (or `day` if no current step set) and just the
         * magnitude is changed.
         *
         * If a String is passed, it is parsed by {@link Core.helper.DateHelper#function-parseDuration-static}, for
         * example `'1d'`, `'1 d'`, `'1 day'`, or `'1 day'`.
         *
         * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
         * @property {String|Number|Object}
         * @name step
         */

        /**
         * Time increment duration value. If specified, `forward` and `back` triggers are displayed.
         * The value is taken to be a string consisting of the numeric magnitude and the units.
         * The units may be a recognised unit abbreviation of this locale or the full local unit name.
         * For example `'1d'` or `'1w'` or `'1 week'`. This may be specified as an object containing
         * two properties: `magnitude`, a Number, and `unit`, a String
         * @config {String|Number|Object}
         */
        step: false,
        stepTriggers: null,

        /**
         * The week start day in the {@link #config-picker}, 0 meaning Sunday, 6 meaning Saturday.
         * Uses localized value per default.
         * @config {Number}
         */
        weekStartDay: null,

        /**
         * A config object used to configure the {@link Core.widget.DatePicker datePicker}.
         * ```javascript
         * dateField = new DateField({
         *      picker    : {
         *          multiSelect : true
         *      }
         *  });
         * ```
         * @config {Object}
         */
        picker: {
          type: 'datepicker',
          floating: true,
          scrollAction: 'realign',
          align: {
            align: 't0-b0',
            axisLock: true
          }
        },

        /**
         * Get/set value, which can be a Date or a string. If a string is specified, it will be converted using the
         * specified {@link #config-format}
         * @property {String|Date}
         * @name value
         */

        /**
         * Value, which can be a Date or a string. If a string is specified, it will be converted using the
         * specified {@link #config-format}
         * @config {String|Date}
         */
        value: null
      };
    }
  }]);

  return DateField;
}(_PickerField_js__WEBPACK_IMPORTED_MODULE_10__["default"]); // Register this widget type with its Factory



DateField.initClass();
DateField._$name = 'DateField';

/***/ }),

/***/ "./lib/Core/widget/DatePicker.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/DatePicker.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DatePicker; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _CalendarPanel_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./CalendarPanel.js */ "./lib/Core/widget/CalendarPanel.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Editor_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Combo.js */ "./lib/Core/widget/Combo.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Core/widget/DatePicker
 */

/**
 * A Panel which can display a month of date cells, which navigates between the cells,
 * fires events upon user selection actions, optionally navigates to other months
 * in response to UI gestures, and optionally displays information about each date cell.
 *
 * This class is used by the {@link Core.widget.DateField} class.
 *
 * @externalexample widget/DatePicker.js
 * @classtype datepicker
 * @extends Core/widget/CalendarPanel
 */

var DatePicker = /*#__PURE__*/function (_CalendarPanel) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(DatePicker, _CalendarPanel);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, DatePicker);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(DatePicker, [{
    key: "construct",

    /**
     * Fires when a date is selected. If {@link #config-multiSelect} is specified, this
     * will fire upon deselection and selection of dates.
     * @event selectionChange
     * @param {Date[]} selection The selected date. If {@link #config-multiSelect} is specified
     * this may be a two element array specifying start and end dates.
     * @param {Boolean} userAction This will be `true` if the change was caused by user interaction
     * as opposed to programmatic setting.
     */
    value: function construct(config) {
      var me = this;
      me.selection = [];

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DatePicker.prototype), "construct", this).call(this, config);

      me.element.setAttribute('aria-activedescendant', "".concat(me.id, "-active-day"));
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
        element: me.element,
        mouseover: 'onPickerMouseover',
        click: 'onPickerClick',
        thisObj: me
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      if (this._yearEditor) {
        this._yearEditor.destroy();
      }

      if (this._monthEditor) {
        this._monthEditor.destroy();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DatePicker.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var me = this,
          sbw = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].scrollBarWidth;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DatePicker.prototype), "refresh", this).call(this);

      me.monthElement.innerHTML = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].format(me.month.date, 'MMMM');
      me.yearElement.innerHTML = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].format(me.month.date, 'YYYY');

      if (me.editMonth) {
        me.monthElement.style.minWidth = "calc(".concat(me.maxMonthLength + 1, "ch + ").concat(sbw, "px)");
        me.yearElement.style.minWidth = sbw ? "calc(3ch + ".concat(sbw, "px") : '7ch';
      }
    }
  }, {
    key: "cellRenderer",
    value: function cellRenderer(_ref) {
      var cell = _ref.cell,
          date = _ref.date;
      var me = this,
          activeCls = me.activeCls,
          selectedCls = me.selectedCls,
          cellClassList = cell.classList;
      cell.innerHTML = date.getDate();
      cell.setAttribute('aria-label', _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].format(date, 'MMMM D, YYYY'));

      if (me.isActiveDate(date)) {
        cellClassList.add(activeCls);
        cell.id = "".concat(me.id, "-active-day");
      } else {
        cell.removeAttribute('id');
      }

      if (me.isSelectedDate(date)) {
        cellClassList.add(selectedCls);
      }

      if (me.minDate && date < me.minDate) {
        cellClassList.add(me.outOfRangeCls);
      } else if (me.maxDate && date > me.maxDate) {
        cellClassList.add(me.outOfRangeCls);
      }
    }
  }, {
    key: "onPickerMouseover",
    value: function onPickerMouseover(event) {
      if (this.editOnHover) {
        var editable = this.editMonth && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].up(event.target, '.b-editable');

        if (editable) {
          return this.onEditGesture(event);
        }
      }
    }
  }, {
    key: "onPickerClick",
    value: function onPickerClick(event) {
      var me = this,
          target = event.target,
          cell = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].up(target, ".".concat(me.dayCellCls, ":not(.").concat(me.disabledCls, "):not(.").concat(me.outOfRangeCls, ")")),
          editable = me.editMonth && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].up(target, '.b-editable');

      if (cell) {
        return me.onCellClick(event);
      }

      if ((!me.editOnHover || _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isTouchEvent) && editable) {
        return me.onEditGesture(event);
      }

      if (me._monthEditor && !me._monthEditor.owns(event)) {
        me._monthEditor.cancelEdit();
      }

      if (me._yearEditor && !me._yearEditor.owns(event)) {
        me._yearEditor.cancelEdit();
      }
    }
  }, {
    key: "onCellClick",
    value: function onCellClick(event) {
      this.onUIDateSelect(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].parseKey(event.target.dataset.date), event);
    }
  }, {
    key: "onEditGesture",
    value: function onEditGesture(event) {
      var me = this,
          month = me.month,
          target = event.target;

      if (target === me.monthElement) {
        me.monthEditor.startEdit({
          target: target,
          value: month.month,
          fitTargetContent: false,
          hideTarget: true
        });
      } else if (target === me.yearElement) {
        me.yearEditor.minWidth = "".concat(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].scrollBarWidth + 50, "px)");
        me.yearEditor.startEdit({
          target: target,
          value: month.year,
          fitTargetContent: true,
          hideTarget: true
        });
      }
    }
    /**
     * Called when the user uses the UI to select the current activeDate. So ENTER when focused
     * or clicking a date cell.
     * @param {Date} date The active date to select
     * @param {Event} event the intigating event, either a `click` event or a `keydown` event.
     * @internal
     */

  }, {
    key: "onUIDateSelect",
    value: function onUIDateSelect(date, event) {
      var me = this,
          lastClickedDate = me.lastClickedDate,
          selection = me.selection;
      me.activeDate = date;
      me.lastClickedDate = date;

      if (!me.isDisabledDate(date)) {
        me.activatingEvent = event; // Handle multi selecting.
        // * single contiguous date range, eg: an event start and end
        // * multiple discontiguous ranges

        if (me.multiSelect) {
          if (me.multiRange) {// TODO: multiple date ranges
          } else if (!lastClickedDate || date.getTime() !== lastClickedDate.getTime()) {
            if (lastClickedDate && event.shiftKey) {
              selection[1] = date;
              selection.sort();
            } else {
              selection.length = 0;
              selection[0] = date;
            }

            me.trigger('selectionChange', {
              selection: selection,
              userAction: Boolean(event)
            });
          }
        } else {
          if (!me.value || me.value.getTime() !== date.getTime()) {
            me.value = date;
          } else if (me.floating) {
            me.hide();
          }
        }

        me.activatingEvent = null;
      } // Ensure the b-selected-date class is on the correct cell(s).


      me.refresh();
    }
  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(keyEvent) {
      var me = this,
          keyName = keyEvent.key.trim() || keyEvent.code,
          activeDate = me.activeDate,
          newDate = new Date(activeDate);

      if (keyName === 'Escape' && me.floating) {
        return me.hide();
      } // Only navigate if not focused on one of our child widgets.
      // We have a prevMonth and nextMonth tool and possibly month and year pickers.


      if (activeDate && keyEvent.target === me.focusElement) {
        do {
          switch (keyName) {
            case 'ArrowLeft':
              // Disable browser use of this key.
              // Ctrl+ArrowLeft navigates back.
              // ArrowLeft scrolls if there is horizontal scroll.
              keyEvent.preventDefault();

              if (keyEvent.ctrlKey) {
                newDate.setMonth(newDate.getMonth() - 1);
              } else {
                newDate.setDate(newDate.getDate() - 1);
              }

              break;

            case 'ArrowUp':
              // Disable browser use of this key.
              // ArrowUp scrolls if there is vertical scroll.
              keyEvent.preventDefault();
              newDate.setDate(newDate.getDate() - 7);
              break;

            case 'ArrowRight':
              // Disable browser use of this key.
              // Ctrl+ArrowRight navigates forwards.
              // ArrowRight scrolls if there is horizontal scroll.
              keyEvent.preventDefault();

              if (keyEvent.ctrlKey) {
                newDate.setMonth(newDate.getMonth() + 1);
              } else {
                newDate.setDate(newDate.getDate() + 1);
              }

              break;

            case 'ArrowDown':
              // Disable browser use of this key.
              // ArrowDown scrolls if there is vertical scroll.
              keyEvent.preventDefault();
              newDate.setDate(newDate.getDate() + 7);
              break;

            case 'Enter':
              return me.onUIDateSelect(activeDate, keyEvent);
          }
        } while (me.isDisabledDate(newDate) && !me.focusDisabledDates); // Don't allow navigation to outside of date bounds.


        if (me.minDate && newDate < me.minDate) {
          return;
        }

        if (me.maxDate && newDate > me.maxDate) {
          return;
        }

        me.activeDate = newDate;
      }
    }
  }, {
    key: "updateDate",
    value: function updateDate(date) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DatePicker.prototype), "updateDate", this).call(this, date);

      this.activeDate = date;
    }
  }, {
    key: "changeActiveDate",
    value: function changeActiveDate(activeDate) {
      activeDate = activeDate ? this.changeDate(activeDate) : this.date || (this.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].clearTime(new Date()));

      if (isNaN(activeDate)) {
        throw new Error('DatePicker date ingestion must be passed a Date, or a YYYY-MM-DD date string');
      }

      return activeDate;
    }
  }, {
    key: "updateActiveDate",
    value: function updateActiveDate(activeDate) {
      // Month's date setter protects it from non-changes.
      this.month.date = activeDate; // Must refresh so that the active cell gets a refresh.

      this.refresh();
    }
  }, {
    key: "gotoPrevMonth",
    value: function gotoPrevMonth() {
      var activeDate = this.activeDate,
          baseDate = activeDate && this.getCell(activeDate) ? activeDate : this.date,
          newDate = new Date(baseDate);
      newDate.setMonth(newDate.getMonth() - 1);
      this.date = newDate;
    }
  }, {
    key: "gotoNextMonth",
    value: function gotoNextMonth() {
      var activeDate = this.activeDate,
          baseDate = activeDate && this.getCell(activeDate) ? activeDate : this.date,
          newDate = new Date(baseDate);
      newDate.setMonth(newDate.getMonth() + 1);
      this.date = newDate;
    }
  }, {
    key: "isActiveDate",
    value: function isActiveDate(date) {
      return this.activeDate && this.changeDate(date).getTime() === this.activeDate.getTime();
    }
  }, {
    key: "isSelectedDate",
    value: function isSelectedDate(date) {
      return this.selection.some(function (d) {
        return d.getTime() === date.getTime();
      });
    }
  }, {
    key: "onMonthPicked",
    value: function onMonthPicked(_ref2) {
      var value = _ref2.value,
          oldValue = _ref2.oldValue;
      this.activeDate = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].add(this.activeDate, value - oldValue, 'month');
    }
  }, {
    key: "onYearPicked",
    value: function onYearPicked(_ref3) {
      var value = _ref3.value;
      var newDate = new Date(this.activeDate);
      newDate.setFullYear(value);
      this.activeDate = newDate;
    }
  }, {
    key: "onBeforeEditorCancel",
    value: function onBeforeEditorCancel(_ref4) {
      var source = _ref4.source;

      // Always move focus to this to cancel the edit so that it doesn't try to find a revert target.
      if (source.containsFocus) {
        this.element.focus();
        return false;
      }
    }
  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      if (this._monthEditor) {
        this._monthEditor.doDestroy();

        this._monthEditor = null;
      }

      if (this._yearEditor) {
        this._yearEditor.doDestroy();

        this._yearEditor = null;
      }

      this._maxMonthLength = 0;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DatePicker.prototype), "updateLocalization", this).call(this);
    }
  }, {
    key: "focusElement",
    get: function get() {
      return this.element;
    }
  }, {
    key: "childItems",
    get: function get() {
      var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DatePicker.prototype), "childItems", this);

      if (this._yearEditor) {
        result.unshift(this._yearEditor);
      }

      if (this._monthEditor) {
        result.unshift(this._monthEditor);
      }

      return result;
    }
  }, {
    key: "minDate",
    set: function set(minDate) {
      this._minDate = minDate ? this.changeDate(minDate) : null;
      this.refresh();
    },
    get: function get() {
      return this._minDate;
    }
  }, {
    key: "maxDate",
    set: function set(maxDate) {
      this._maxDate = maxDate ? this.changeDate(maxDate) : null;
      this.refresh();
    },
    get: function get() {
      return this._maxDate;
    }
  }, {
    key: "value",
    set: function set(value) {
      var me = this,
          selection = me.selection;
      var changed;

      if (value) {
        value = me.changeDate(value, me.value); // Undefined return value means no change

        if (value === undefined) {
          return;
        }

        if (!me.value || value.getTime() !== me.value.getTime()) {
          selection.length = 0;
          selection[0] = value;
          changed = true;
        }

        me.date = value;
      } else {
        changed = selection.length;
        selection.length = 0; // Clearing the value - go to today's calendar

        me.date = new Date();
      }

      if (changed) {
        me.trigger('selectionChange', {
          selection: selection,
          userAction: Boolean(me.activatingEvent)
        });
      }
    },
    get: function get() {
      return this.selection[this.selection.length - 1];
    }
  }, {
    key: "monthEditor",
    get: function get() {
      var me = this;

      if (!me._monthEditor) {
        me._monthEditor = new _Editor_js__WEBPACK_IMPORTED_MODULE_17__["default"]({
          owner: me,
          appendTo: me.element,
          inputField: me.monthInput = new _Combo_js__WEBPACK_IMPORTED_MODULE_18__["default"]({
            editable: false,
            autoExpand: !me.editOnHover,
            items: me.monthItems,
            highlightExternalChange: false,
            picker: {
              align: {
                align: 't0-b0'
              },
              cls: 'b-month-picker-list',
              scrollable: {
                overflowX: false
              }
            }
          }),
          completeOnChange: true,
          listeners: {
            complete: 'onMonthPicked',
            beforeCancel: 'onBeforeEditorCancel',
            thisObj: me
          }
        });
      }

      return me._monthEditor;
    }
  }, {
    key: "yearEditor",
    get: function get() {
      var me = this;

      if (!me._yearEditor) {
        me._yearEditor = new _Editor_js__WEBPACK_IMPORTED_MODULE_17__["default"]({
          owner: me,
          appendTo: me.element,
          inputField: me.yearInput = new _Combo_js__WEBPACK_IMPORTED_MODULE_18__["default"]({
            editable: false,
            autoExpand: !me.editOnHover,
            items: me.yearItems,
            highlightExternalChange: false,
            picker: {
              cls: 'b-year-picker-list',
              scrollable: {
                overflowX: false
              }
            }
          }),
          completeOnChange: true,
          listeners: {
            complete: 'onYearPicked',
            beforeCancel: 'onBeforeEditorCancel',
            thisObj: me
          }
        });
      }

      return me._yearEditor;
    }
  }, {
    key: "monthItems",
    get: function get() {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getMonthNames().map(function (m, i) {
        return [i, m];
      });
    }
  }, {
    key: "yearItems",
    get: function get() {
      var result = [],
          middle = new Date().getFullYear();

      for (var y = middle - 20; y < middle + 21; y++) {
        result.push(y);
      }

      return result;
    }
  }, {
    key: "maxMonthLength",
    get: function get() {
      if (!this._maxMonthLength) {
        this._maxMonthLength = 0;

        for (var i = 0, months = this.monthItems; i < 12; i++) {
          this._maxMonthLength = Math.max(this._maxMonthLength, months[i][1].length);
        }
      }

      return this._maxMonthLength;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'DatePicker';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'datepicker';
    }
  }, {
    key: "delayable",
    get: function get() {
      return {
        refresh: 'raf'
      };
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * The date that the user has navigated to using the UI *prior* to setting the widget's
         * value by selecting.
         *
         * This may be changed using keyboard navigation. The {@link Core.widget.CalendarPanel#property-date} is set
         * by pressing `ENTER` when the desired date is reached.
         *
         * Programatically setting the {@link Core.widget.CalendarPanel#config-date}, or using the UI to select the date
         * by clicking it also sets the `activeDate`
         * @config {Date}
         */
        activeDate: {
          $config: {
            equal: 'date'
          },
          value: null
        }
      };
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        focusable: true,
        textContent: false,
        tools: {
          prevMonth: {
            align: 'start',
            cls: 'b-icon b-icon-angle-left',
            handler: 'gotoPrevMonth'
          },
          nextMonth: {
            align: 'end',
            cls: 'b-icon b-icon-angle-right',
            handler: 'gotoNextMonth'
          }
        },
        header: {
          title: '<div class="b-editable b-datepicker-month" data-reference="monthElement"></div> <div class="b-editable b-datepicker-year" data-reference="yearElement"></div>',
          titleAlign: 'center'
        },

        /**
         * The minimum selectable date. Selection of and navigtion to dates prior
         * to this date will not be possible.
         * @config {Date}
         */
        minDate: null,

        /**
         * The maximum selectable date. Selection of and navigtion to dates after
         * this date will not be possible.
         * @config {Date}
         */
        maxDate: null,

        /**
         * The class name to add to the calendar cell whose date which is outside of the
         * {@link #config-minDate}/{@link #config-maxDate} range.
         * @config {String}
         * @private
         */
        outOfRangeCls: 'b-out-of-range',

        /**
         * The class name to add to the currently focused calendar cell.
         * @config {String}
         * @private
         */
        activeCls: 'b-active-date',

        /**
         * The class name to add to selected calendar cells.
         * @config {String}
         * @private
         */
        selectedCls: 'b-selected-date',

        /**
         * By default, disabled dates cannot be navigated to, and they are skipped over
         * during keyboard navigation. Configure this as `true` to enable navigation to
         * disabled dates.
         * @config {Boolean}
         * @default
         */
        focusDisabledDates: null,

        /**
         * Configure as `true` to enable selecting a single date range by selecting a
         * start and end date.
         * @config {Boolean}
         * @default
         */
        multiSelect: false,

        /**
         * By default, the month and year show their editor on hover instead of click.
         * On a touch platform, they both show the editor on tap.
         * @config {Boolean}
         * @default
         */
        editOnHover: true,

        /**
         * By default, the month and year are editable. Configure this as `false` to prevent that.
         * @config {Boolean}
         * @default
         */
        editMonth: true
      };
    }
  }]);

  return DatePicker;
}(_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_13__["default"]); // Register this widget type with its Factory



DatePicker.initClass();
DatePicker._$name = 'DatePicker';

/***/ }),

/***/ "./lib/Core/widget/DateTimeField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/DateTimeField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateTimeField; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _TimeField_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony import */ var _DateField_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Core/widget/DateTimeField
 */

/**
 * A field combining a {@link Core.widget.DateField} and a {@link Core.widget.TimeField}.
 *
 * @extends Core/widget/Field
 * @classtype datetimefield
 * @externalexample widget/DateTimeField.js
 */

var DateTimeField = /*#__PURE__*/function (_Field) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(DateTimeField, _Field);

  var _super = _createSuper(DateTimeField);

  function DateTimeField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, DateTimeField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(DateTimeField, [{
    key: "changeTimeField",
    // Converts the timeField config into a TimeField
    value: function changeTimeField(config) {
      var me = this,
          result = new _TimeField_js__WEBPACK_IMPORTED_MODULE_14__["default"](_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].assign({
        syncInvalid: function syncInvalid() {
          var updatingInvalid = me.updatingInvalid;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _TimeField_js__WEBPACK_IMPORTED_MODULE_14__["default"].prototype.syncInvalid.apply(this, args);
          me.timeField && !updatingInvalid && me.syncInvalid();
        }
      }, config)); // Must set *after* construction, otherwise it becomes the default state
      // to reset readOnly back to

      if (me.readOnly) {
        result.readOnly = true;
      }

      return result;
    } // Set up change listener when TimeField is available. Not in timeField config to enable users to supply their own
    // listeners block there

  }, {
    key: "updateTimeField",
    value: function updateTimeField(timeField) {
      var me = this;
      timeField.on({
        change: function change(_ref) {
          var userAction = _ref.userAction,
              value = _ref.value;

          if (userAction && !me.$settingValue) {
            var dateAndTime = me.dateField.value;
            me._isUserAction = true;
            me.value = dateAndTime ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].copyTimeValues(dateAndTime, value) : null;
            me._isUserAction = false;
          }
        },
        thisObj: me
      });
    } // Converts the dateField config into a class based on { type : "..." } provided (DateField by default)

  }, {
    key: "changeDateField",
    value: function changeDateField(config) {
      var me = this,
          type = (config === null || config === void 0 ? void 0 : config.type) || 'datefield',
          cls = _Widget_js__WEBPACK_IMPORTED_MODULE_18__["default"].resolveType(config.type || 'datefield'),
          result = _Widget_js__WEBPACK_IMPORTED_MODULE_18__["default"].create(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].assign({
        type: type,
        syncInvalid: function syncInvalid() {
          var updatingInvalid = me.updatingInvalid;

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          cls.prototype.syncInvalid.apply(this, args);
          me.dateField && !updatingInvalid && me.syncInvalid();
        }
      }, config)); // Must set *after* construction, otherwise it becomes the default state
      // to reset readOnly back to

      if (me.readOnly) {
        result.readOnly = true;
      }

      return result;
    }
  }, {
    key: "updateDateField",
    // Set up change listener when DateField is available. Not in dateField config to enable users to supply their own
    // listeners block there
    value: function updateDateField(dateField) {
      var me = this;
      dateField.on({
        change: function change(_ref2) {
          var userAction = _ref2.userAction,
              value = _ref2.value;

          if (userAction && !me.$isInternalChange) {
            me._isUserAction = true;
            me.value = value;
            me._isUserAction = false;
          }
        },
        thisObj: me
      });
    }
  }, {
    key: "updateWeekStartDay",
    value: function updateWeekStartDay(weekStartDay) {
      if (this.dateField) {
        this.dateField.weekStartDay = weekStartDay;
      }
    }
  }, {
    key: "changeWeekStartDay",
    value: function changeWeekStartDay(value) {
      var _this$dateField$weekS, _this$dateField;

      return typeof value === 'number' ? value : (_this$dateField$weekS = (_this$dateField = this.dateField) === null || _this$dateField === void 0 ? void 0 : _this$dateField.weekStartDay) !== null && _this$dateField$weekS !== void 0 ? _this$dateField$weekS : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].weekStartDay;
    } // Apply our value to our underlying fields

  }, {
    key: "syncInputFieldValue",
    value: function syncInputFieldValue() {
      var skipHighlight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.isConfiguring;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DateTimeField.prototype), "syncInputFieldValue", this).call(this, true);

      if (!skipHighlight && !this.highlightExternalChange) {
        skipHighlight = true;
      }

      var me = this,
          highlightDate = me.dateField.highlightExternalChange,
          highlightTime = me.timeField.highlightExternalChange;
      me.$isInternalChange = true;
      me.dateField.highlightExternalChange = false; // Prevent dateField from keeping its time value
      // TODO: Should be doable without this hack

      me.dateField.value = null;
      me.dateField.highlightExternalChange = highlightDate;

      if (skipHighlight) {
        me.timeField.highlightExternalChange = me.dateField.highlightExternalChange = false;
      }

      me.timeField.value = me.dateField.value = me.inputValue;
      me.dateField.highlightExternalChange = highlightDate;
      me.timeField.highlightExternalChange = highlightTime;
      me.$isInternalChange = false; // Must evaluate after child fields have been updated since our validity state depends on theirs.

      me.syncInvalid();
    } // Make us and our underlying fields required

  }, {
    key: "updateRequired",
    value: function updateRequired(required, was) {
      this.timeField.required = this.dateField.required = required;
    }
  }, {
    key: "updateReadOnly",
    value: function updateReadOnly(readOnly, was) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DateTimeField.prototype), "updateReadOnly", this).call(this, readOnly, was);

      if (!this.isConfiguring) {
        this.timeField.readOnly = this.dateField.readOnly = readOnly;
      }
    } // Make us and our underlying fields disabled

  }, {
    key: "onDisabled",
    value: function onDisabled(value) {
      this.timeField.disabled = this.dateField.disabled = value;
    }
  }, {
    key: "hasChanged",
    value: function hasChanged(oldValue, newValue) {
      return !_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isEqual(oldValue, newValue);
    }
  }, {
    key: "setError",
    value: function setError(error, silent) {
      [this.dateField, this.timeField].forEach(function (f) {
        return f.setError(error, silent);
      });
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      var errors = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(this.dateField.getErrors() || []), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(this.timeField.getErrors() || []));
      return errors.length ? errors : null;
    }
  }, {
    key: "clearError",
    value: function clearError(error, silent) {
      [this.dateField, this.timeField].forEach(function (f) {
        return f.clearError(error, silent);
      });
    }
  }, {
    key: "updateInvalid",
    value: function updateInvalid() {
      // use this flag in this level to avoid looping
      this.updatingInvalid = true;
      [this.dateField, this.timeField].forEach(function (f) {
        return f.updateInvalid();
      });
      this.updatingInvalid = false;
    }
  }, {
    key: "innerElements",
    // Implementation needed at this level because it has two inner elements in its inputWrap
    get: function get() {
      return [this.dateField.element, this.timeField.element];
    }
  }, {
    key: "childItems",
    get: function get() {
      return [this.dateField, this.timeField];
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.timeField.isValid && this.dateField.isValid;
    }
  }], [{
    key: "configurable",
    get: function get() {
      return {
        /**
         * Configuration for {@link Core.widget.TimeField}
         *
         * @config {Object}
         */
        timeField: {
          flex: '0 0 45%'
        },

        /**
         * Configuration for {@link Core.widget.DateField}
         *
         * @config {Object}
         */
        dateField: {
          // To be able to use transformDateValue for parsing without loosing time, a bit of a hack
          keepTime: true,
          flex: 1,
          step: '1 d'
        },

        /**
         * The week start day in the {@link Core.widget.DateField#config-picker}, 0 meaning Sunday, 6 meaning Saturday.
         * Uses localized value per default.
         *
         * @config {Number}
         */
        weekStartDay: null,
        inputTemplate: function inputTemplate() {
          return '';
        }
      };
    }
  }, {
    key: "$name",
    get: function get() {
      return 'DateTimeField';
    }
  }, {
    key: "type",
    get: function get() {
      return 'datetimefield';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'datetime';
    }
  }]);

  return DateTimeField;
}(_Field_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


DateTimeField.initClass();
DateTimeField._$name = 'DateTimeField';

/***/ }),

/***/ "./lib/Core/widget/DisplayField.js":
/*!*****************************************!*\
  !*** ./lib/Core/widget/DisplayField.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DisplayField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/widget/DisplayField
 */

/**
 * DisplayField widget used to show a read only value
 *
 * @extends Core/widget/Field
 *
 * @example
 * let displayField = new DisplayField({
 *   label: 'name',
 *   value : 'John Doe'
 * });
 *
 * @classType DisplayField
 * @externalexample widget/DisplayField.js
 */

var DisplayField = /*#__PURE__*/function (_TextField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DisplayField, _TextField);

  var _super = _createSuper(DisplayField);

  function DisplayField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DisplayField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DisplayField, [{
    key: "changeReadOnly",
    value: function changeReadOnly() {
      return true;
    }
  }, {
    key: "changeEditable",
    value: function changeEditable() {
      return false;
    }
  }, {
    key: "focusElement",
    get: function get() {// we're not focusable.
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'DisplayField';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'displayfield';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'display';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        readOnly: true,
        editable: false,
        cls: 'b-display-field'
      };
    }
  }]);

  return DisplayField;
}(_TextField_js__WEBPACK_IMPORTED_MODULE_8__["default"]); // Register this widget type with its Factory



DisplayField.initClass();
DisplayField._$name = 'DisplayField';

/***/ }),

/***/ "./lib/Core/widget/DurationField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/DurationField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DurationField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _data_Duration_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../data/Duration.js */ "./lib/Core/data/Duration.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/widget/DurationField
 */

/**
 * A specialized field allowing a user to also specify duration unit when editing the duration value.
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the `DurationColumn`.
 *
 * @extends Core/widget/TextField
 * @classType durationfield
 * @externalexample widget/DurationField.js
 */

var DurationField = /*#__PURE__*/function (_TextField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(DurationField, _TextField);

  var _super = _createSuper(DurationField);

  function DurationField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DurationField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DurationField, [{
    key: "roundMagnitude",
    value: function roundMagnitude(value) {
      return value && this.decimalPrecision != null ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].round(value, this.decimalPrecision) : value;
    }
  }, {
    key: "internalOnChange",
    value: function internalOnChange(event) {
      var me = this,
          value = me.value,
          oldVal = me._lastValue;

      if (me.hasChanged(oldVal, value)) {
        me._lastValue = value;
        me.triggerFieldChange({
          value: value,
          event: event,
          userAction: true,
          valid: me.isValid
        });
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      this.syncInputFieldValue(true);
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DurationField.prototype), "onFocusOut", this).call(this, e);
    }
    /**
     * The `value` property may be set in Object form specifying two properties, `magnitude`, a Number, and `unit`, a
     * String.
     *
     * If a Number is passed, the field's current unit is used and just the magnitude is changed.
     *
     * If a String is passed, it is parsed in accordance with current locale rules. The string is taken to be the
     * numeric magnitude, followed by whitespace, then an abbreviation, or name of the unit.
     *
     * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
     * @property {String|Number|Object|Duration}
     */

  }, {
    key: "calcValue",
    value: function calcValue() {
      var me = this;

      if ((!me._unit || me._magnitude == null) && me.clearable) {
        return null;
      } else {
        return new _data_Duration_js__WEBPACK_IMPORTED_MODULE_13__["default"](me._magnitude, me._unit || DurationField.defaultConfig.defaultUnit);
      }
    }
  }, {
    key: "hasChanged",
    value: function hasChanged(oldValue, newValue) {
      return newValue && !oldValue || !newValue && oldValue || newValue && oldValue && !oldValue.isEqual(newValue);
    }
    /**
     * The `milliseconds` property is a read only property which returns the number of milliseconds in this field's
     * value
     * @property {Number}
     */

  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(keyEvent) {
      if (keyEvent.key === 'ArrowUp') {
        this.doSpinUp();
      } else if (keyEvent.key === 'ArrowDown') {
        this.doSpinDown();
      }
    }
  }, {
    key: "doSpinUp",
    value: function doSpinUp() {
      var me = this;
      me._isUserAction = true;
      me.magnitude = (me.magnitude || 0) + me.step;
      me._isUserAction = false;
    }
  }, {
    key: "doSpinDown",
    value: function doSpinDown() {
      var me = this;

      if (me.allowNegative || (me.magnitude || 0) > 0) {
        me._isUserAction = true;
        me.magnitude = (me.magnitude || 0) - me.step;
        me._isUserAction = false;
      }
    }
  }, {
    key: "inputValue",
    get: function get() {
      // Do not use the _value property. If called during configuration, this
      // will import the configured value from the config object.
      return this.value == null ? '' : this.value.toString(this.useAbbreviation);
    }
    /**
     * Get/Set duration unit to use with the current magnitude value.
     * Valid values are:
     * - "millisecond" - Milliseconds
     * - "second" - Seconds
     * - "minute" - Minutes
     * - "hour" - Hours
     * - "day" - Days
     * - "week" - Weeks
     * - "month" - Months
     * - "quarter" - Quarters
     * - "year"- Years
     *
     * @property {String}
     */

  }, {
    key: "unit",
    set: function set(unit) {
      this._unit = unit;

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DurationField.prototype), "value", this.calcValue(), this, true);
    },
    get: function get() {
      return this._unit;
    }
    /**
     * Get/Set numeric magnitude `value` to use with the current unit value.
     * @property {Number}
     */

  }, {
    key: "magnitude",
    set: function set(magnitude) {
      this._magnitude = this.roundMagnitude(magnitude);

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DurationField.prototype), "value", this.calcValue(), this, true);
    },
    get: function get() {
      return this._magnitude;
    }
  }, {
    key: "allowDecimals",
    get: function get() {
      return this.decimalPrecision !== 0;
    }
  }, {
    key: "isValid",
    get: function get() {
      var me = this,
          isEmpty = me.value == null || me.value && me.value.magnitude == null;
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DurationField.prototype), "isValid", this) && (isEmpty && !me.required || !isEmpty && (me.allowNegative || me.value.magnitude >= 0));
    }
  }, {
    key: "value",
    set: function set(value) {
      var me = this;
      var newMagnitude, newUnit;

      if (typeof value === 'number') {
        // A number means preserving existing unit value
        newMagnitude = me.roundMagnitude(value);
        newUnit = me._unit;
      } else if (typeof value === 'string') {
        // Parse as a string
        var parsedDuration = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].parseDuration(value, me.allowDecimals, me._unit || DurationField.defaultConfig.defaultUnit);

        if (parsedDuration) {
          newUnit = parsedDuration.unit;
          newMagnitude = me.roundMagnitude(parsedDuration.magnitude);
        }
      } else {
        // Using value object with unit and magnitude
        if (value && 'unit' in value && 'magnitude' in value) {
          newUnit = value.unit;
          newMagnitude = me.roundMagnitude(value.magnitude);
        } else {
          newUnit = null;
          newMagnitude = null;
        }
      }

      if (me._magnitude !== newMagnitude || me._unit !== newUnit) {
        me._magnitude = newMagnitude;
        me._unit = newUnit;

        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DurationField.prototype), "value", me.calcValue(), this, true);
      }
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DurationField.prototype), "value", this);
    }
  }, {
    key: "milliseconds",
    get: function get() {
      return this.value ? this.value.milliseconds : 0;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'DurationField';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'durationfield';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'duration';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The `value` config may be set in Object form specifying two properties,
         * `magnitude`, a Number, and `unit`, a String.
         *
         * If a String is passed, it is parsed in accordance with current locale rules.
         * The string is taken to be the numeric magnitude, followed by whitespace, then an abbreviation, or name of
         * the unit.
         * @config {Object|String}
         */
        value: null,

        /**
         * Step size for spin button clicks.
         * @config {Number}
         * @default
         */
        step: 1,

        /**
         * The duration unit to use with the current magnitude value.
         * @config {String}
         */
        unit: null,
        defaultUnit: 'day',

        /**
         * The duration magnitude to use with the current unit value.
         * @config {Number}
         */
        magnitude: null,

        /**
         * When set to `true` the field will use short names of unit durations
         * (as returned by {@link Core.helper.DateHelper#function-getShortNameOfUnit-static}) when creating the
         * input field's display value.
         * @config {Boolean}
         */
        useAbbreviation: false,

        /**
         * Set to `true` to allow negative duration
         * @config {Boolean}
         */
        allowNegative: false,

        /**
         * The number of decimal places to allow. Defaults to no constraint.
         * @config {Number}
         * @default
         */
        decimalPrecision: null,
        triggers: {
          spin: {
            type: 'spintrigger'
          }
        },
        nullValue: null
      };
    }
  }]);

  return DurationField;
}(_TextField_js__WEBPACK_IMPORTED_MODULE_10__["default"]); // Register this widget type with its Factory



DurationField.initClass();
DurationField._$name = 'DurationField';

/***/ }),

/***/ "./lib/Core/widget/Editor.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Editor.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Editor; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/widget/Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _layout_Fit_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./layout/Fit.js */ "./lib/Core/widget/layout/Fit.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");























function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';










/**
 * @module Core/widget/Editor
 */

/**
 * Displays an input field, optionally editing a field of a record at a particular position.
 *
 * Offers events to signal edit completion upon `ENTER` or focus loss (if configured to do so),
 * or edit cancellation on `ESC`, or focus loss if configured that way.
 * @extends Core/widget/Container
 *
 * @classType Editor
 */

var Editor = /*#__PURE__*/function (_Container) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default()(Editor, _Container);

  var _super = _createSuper(Editor);

  function Editor() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, Editor);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default()(Editor, [{
    key: "afterConfigure",
    //endregion
    //region Events

    /**
     * Fired before the editor is shown to start an edit operation. Returning `false` from a handler vetoes the edit operation.
     * @event beforestart
     * @param {Object} value - The value to be edited.
     * @preventable
     */

    /**
     * Fired when an edit operation has begun.
     * @event start
     * @param {Object} value - The starting value of the field.
     * @param {Core.widget.Editor} source - The Editor that triggered the event.
     */

    /**
     * Fired when an edit completion has been requested, either by `ENTER`, or focus loss (if configured to complete on blur).
     * The completion may be vetoed, in which case, focus is moved back into the editor.
     * @event beforeComplete
     * @param {Object} oldValue - The original value.
     * @param {Object} value - The new value.
     * @param {Core.widget.Editor} source - The Editor that triggered the event.
     * @param {Function} [finalize] An async function may be injected into this property
     * which performs asynchronous finalization tasks such as complex validation of confirmation. The
     * value `true` or `false` must be returned.
     * @param {Object} [finalize.context] An object describing the editing context upon requested completion of the edit.
     * @preventable
     */

    /**
     * Edit has been completed, and any associated record or element has been updated.
     * @event complete
     * @param {Object} oldValue - The original value.
     * @param {Object} value - The new value.
     * @param {Core.widget.Editor} source - The Editor that triggered the event.
     */

    /**
     * Fired when cancellation has been requested, either by `ESC`, or focus loss (if configured to cancel on blur).
     * The cancellation may be vetoed, in which case, focus is moved back into the editor.
     * @event beforeCancel
     * @param {Object} oldValue - The original value.
     * @param {Object} value - The new value.
     * @param {Core.widget.Editor} source - The Editor that triggered the event.
     * @preventable
     */

    /**
     * Edit has been canceled without updating the associated record or element.
     * @event cancel
     * @param {Object} oldValue - The original value.
     * @param {Object} value - The value of the field.
     * @param {Core.widget.Editor} source - The Editor that triggered the event.
     */

    /**
     * Fire to relay a `keypress` event from the field.
     * @event keypress
     * @param {Event} event - The key event.
     */
    //endregion
    value: function afterConfigure() {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(Editor.prototype), "afterConfigure", this).call(this);

      me.onTargetSizeChange = me.onTargetSizeChange.bind(me);

      if (me.completeKey || me.cancelKey) {
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].on({
          element: me.element,
          keydown: 'onKeyDown',
          thisObj: me
        });
      }

      me.on({
        hide: 'afterEditorHide',
        thisObj: me
      });
      _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_26__["default"].on({
        locale: 'onLocaleChange',
        thisObj: me
      });
    }
  }, {
    key: "onLocaleChange",
    value: function onLocaleChange() {
      var inputField = this.inputField;

      if (inputField && !inputField.isDestroyed) {
        // All Field subclasses have this method, but if `inputField` is a custom widget,
        // `syncInputFieldValue` has to be implemented
        if (inputField.syncInputFieldValue) {
          inputField.syncInputFieldValue(true);
        } else if (!(inputField instanceof _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_27__["default"])) {}
      }
    }
    /**
     * Start editing
     * @param {Object} editObject An object containing details about what to edit.
     * @param {HTMLElement|Core.helper.util.Rectangle} editObject.target the element or Rectangle to align to.
     * @param {String} [editObject.align=t0-t0] How to align to the target.
     * @param {Boolean} [editObject.matchSize=true] Match editor size to target size.
     * @param {Boolean} [editObject.matchFont=true] Match editor's font-size size to target's font-size.
     * @param {Core.data.Model} [editObject.record] The record to edit.
     * @param {String} [editObject.field] The field name in the record to edit. This defaults to the `name` of the {@link #config-inputField}.
     * Also if record has method set + capitalized field, method will be called, e.g. if record has method named
     * `setFoobar` and this config is `foobar`, then instead of `record.foobar = value`, `record.setFoobar(value)` will be called.
     * @param {Object} [editObject.value] The value to edit.
     * @param {Boolean} [editObject.focus=true] Focus the field.
     * @param {Boolean} [editObject.fitTargetContent] Pass `true` to allow the Editor to expand beyond the
     * width of its target element if its content overflows horizontally. This is useful if the editor has
     * triggers to display, such as a combo.
     */

  }, {
    key: "startEdit",
    value: function startEdit(_ref) {
      var target = _ref.target,
          _ref$align = _ref.align,
          align = _ref$align === void 0 ? this.align : _ref$align,
          _ref$hideTarget = _ref.hideTarget,
          hideTarget = _ref$hideTarget === void 0 ? false : _ref$hideTarget,
          _ref$matchSize = _ref.matchSize,
          matchSize = _ref$matchSize === void 0 ? true : _ref$matchSize,
          _ref$matchFont = _ref.matchFont,
          matchFont = _ref$matchFont === void 0 ? true : _ref$matchFont,
          _ref$fitTargetContent = _ref.fitTargetContent,
          fitTargetContent = _ref$fitTargetContent === void 0 ? false : _ref$fitTargetContent,
          value = _ref.value,
          record = _ref.record,
          _ref$field = _ref.field,
          field = _ref$field === void 0 ? this.inputField.name : _ref$field,
          _ref$focus = _ref.focus,
          focus = _ref$focus === void 0 ? true : _ref$focus;
      var me = this,
          inputField = me.inputField,
          targetFontSize = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].getStyleValue(target, 'font-size'),
          targetFontFamily = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].getStyleValue(target, 'font-family');

      if (me.trigger('beforestart', {
        value: value
      }) !== false) {
        if (record && field && value === undefined) {
          me.record = record;
          me.dataField = field;
          value = record[field];
        }

        if (matchSize) {
          if (target instanceof HTMLElement) {
            me.updateSize(target);
          } // If we are editing and sizing based on an element,
          // we need to update editor size if grid cell size changes
          // Removed in 'hide' listener


          if (target instanceof HTMLElement) {
            _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_31__["default"].addResizeListener(target, me.onTargetSizeChange);
          }
        }

        if (inputField.input) {
          if (matchFont) {
            inputField.input.style.fontSize = targetFontSize;
            inputField.input.style.fontFamily = targetFontFamily;
          } else {
            inputField.input.style.fontSize = inputField.input.style.fontFamily = '';
          }
        } // In case our finalize code set it to invalid, start it clear of errors.


        if (inputField.clearError) {
          inputField.clearError();
        }

        inputField.value = value; // The initialValue is what the revertOnEscape uses by preference before it uses its valueOnFocus.
        // In an Editor, it can focus in and out but still need that correct initial value.

        inputField.initialValue = inputField.value;
        me.showBy(_objectSpread({
          target: target
        }, align));

        if (fitTargetContent) {
          // Input doesn't fit, so widen it
          var overflow = inputField.input.scrollWidth - inputField.input.clientWidth;

          if (overflow > 0) {
            me.width += overflow + _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].scrollBarWidth;
          }
        }

        if (focus && me.inputField.focus) {
          me.inputField.focus();
        }

        if (target.nodeType === 1) {
          target.classList.add('b-editing');

          if (hideTarget) {
            target.classList.add('b-hide-visibility');
          }
        }

        me.editing = true; // Passed value may have been '10/06/2019', send the live field value to startedit

        me.trigger('start', {
          value: inputField.value
        });
        me.oldValue = inputField.value; // If the value from th value getter is an array, we must clone it because
        // if it's the same *instance*, the ObjectHelper.isEqual test in completeEdit
        // will find that there are no changes.

        if (Array.isArray(me.oldValue)) {
          me.oldValue = me.oldValue.slice();
        }

        return true;
      }

      return false;
    }
  }, {
    key: "refreshEdit",
    value: function refreshEdit() {
      if (this.isVisible) {
        var record = this.record,
            dataField = this.dataField,
            inputField = this.inputField;

        if (record && dataField) {
          var value = record[dataField]; // Only update the field if the value has changed

          if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isEqual(inputField.value, value)) {
            inputField.value = value;
          }
        }
      }
    }
  }, {
    key: "finishEdit",
    value: function finishEdit() {
      var target = this.lastAlignSpec.target;

      if (target.nodeType === 1) {
        target.classList.remove('b-editing');
        target.classList.remove('b-hide-visibility');
      }

      this.editing = false;
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var me = this;

      switch (event.key) {
        case me.completeKey:
          me.completeEdit();
          event.stopImmediatePropagation();
          break;

        case me.cancelKey:
          me.cancelEdit();
          event.stopImmediatePropagation();
          break;
      }

      me.trigger('keydown', {
        event: event
      });
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(event) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(Editor.prototype), "onFocusOut", this).call(this, event);

      if (!this.isFinishing && this.editing) {
        var method = this["".concat(this.blurAction, "Edit")];

        if (method) {
          method.call(this);
        }
      }
    }
    /**
     * Complete the edit, and, if associated with a record, update the record if possible.
     * If editing is completed, the editor is hidden.
     *
     * If the field is invalid, the `{@link #config-invalidAction}` config is used to decide
     * upon the course of action.
     *
     * If a {@link #event-beforeComplete} handler returns `false` then editing is not completed.
     *
     * If the field's valus has not been changed, then editing is terminated through {@link #function-cancelEdit}.
     *
     * @returns `true` if editing ceased, `false` if the editor is still active.
     * @async
     */

  }, {
    key: "completeEdit",
    value: function () {
      var _completeEdit = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee(finalize) {
        var me, inputField, oldValue, record, invalidAction, value, context, result, error, clearError, listeners;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this, inputField = me.inputField, oldValue = me.oldValue, record = me.record, invalidAction = inputField.invalidAction || (inputField.allowInvalid === false ? 'block' : me.invalidAction), value = inputField.value; // If we are not editing, we should manipulated the field or not fire any events

                if (me.isVisible) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                if (inputField.isValid) {
                  _context.next = 14;
                  break;
                }

                if (!(invalidAction === 'block')) {
                  _context.next = 9;
                  break;
                }

                inputField.focus && inputField.focus();
                return _context.abrupt("return", false);

              case 9:
                if (!(invalidAction === 'revert')) {
                  _context.next = 12;
                  break;
                }

                me.cancelEdit();
                return _context.abrupt("return", true);

              case 12:
                _context.next = 35;
                break;

              case 14:
                if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isEqual(value, oldValue)) {
                  _context.next = 19;
                  break;
                }

                me.cancelEdit();
                return _context.abrupt("return", true);

              case 19:
                context = {
                  inputField: inputField,
                  record: record,
                  value: value,
                  oldValue: oldValue
                };

                if (!(me.trigger('beforeComplete', context) === false)) {
                  _context.next = 24;
                  break;
                }

                inputField.focus && inputField.focus();
                _context.next = 35;
                break;

              case 24:
                // CellEdit#onEditorBeforeComplete injects editorContext into the basic context
                if (!finalize) {
                  finalize = context.finalize || context.editorContext && context.editorContext.finalize;
                } // Allow async finalization of the editing, implementer may want to show a confirmation popup etc


                if (!finalize) {
                  _context.next = 33;
                  break;
                }

                _context.next = 28;
                return finalize(context);

              case 28:
                result = _context.sent;

                if (result === true) {
                  me.onEditComplete();
                } else {
                  if (inputField.setError) {
                    error = result || inputField.invalidValueError, clearError = function clearError() {
                      listeners();
                      inputField.clearError(error);
                    }, listeners = inputField.on({
                      change: clearError,
                      input: clearError
                    }); // Mark as invalid. Because this is decided upon without the knowledge
                    // of the field, this state will be rescinded upon the next change of
                    // input field.

                    inputField.setError(error);
                  }

                  if (invalidAction === 'block') {
                    inputField.focus && inputField.focus();
                  } else if (invalidAction === 'revert') {
                    inputField.value = oldValue;
                    result = true;
                  }

                  result = false;
                }

                return _context.abrupt("return", result);

              case 33:
                me.onEditComplete();
                return _context.abrupt("return", true);

              case 35:
                return _context.abrupt("return", false);

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function completeEdit(_x) {
        return _completeEdit.apply(this, arguments);
      }

      return completeEdit;
    }()
    /**
     * Cancel the edit and hide the editor.
     */

  }, {
    key: "cancelEdit",
    value: function cancelEdit() {
      var me = this,
          inputField = me.inputField,
          oldValue = me.oldValue,
          value = inputField.value;

      if (me.isVisible && !me.isFinishing && me.trigger('beforeCancel', {
        value: value,
        oldValue: oldValue
      }) !== false) {
        // Hiding must not trigger our blurAction
        me.isFinishing = true;
        me.hide();
        me.trigger('cancel', {
          value: value,
          oldValue: oldValue
        });
        me.finishEdit();
        me.isFinishing = false;
      }
    } // Handle updating what needs to be updated.

  }, {
    key: "onEditComplete",
    value: function onEditComplete() {
      var me = this,
          record = me.record,
          dataField = me.dataField,
          inputField = me.inputField,
          oldValue = me.oldValue,
          value = inputField.value;

      if (!me.isFinishing) {
        // Hiding must not trigger our blurAction
        me.isFinishing = true;
        me.hide();

        if (record) {
          var setterName = "set".concat(_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].capitalize(dataField));

          if (record[setterName]) {
            record[setterName](value);
          } else {
            record[dataField] = value;
          }
        }

        me.trigger('complete', {
          value: value,
          oldValue: oldValue
        });
        me.finishEdit();
        me.isFinishing = false;
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      if (this.createdInputField) {
        this.inputField.destroy();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(Editor.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "changeInputField",
    value: function changeInputField(inputField, oldInputField) {
      var me = this;

      if (oldInputField) {
        oldInputField.destroy();
      }

      if (typeof inputField === 'string') {
        inputField = {
          type: inputField
        };
      }

      if (!(inputField instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_22__["default"])) {
        inputField = _Widget_js__WEBPACK_IMPORTED_MODULE_22__["default"].create(inputField);
        me.createdInputField = true; // So we know we can destroy it
      }

      if (me.completeOnChange) {
        inputField.on({
          change: 'onInputFieldChange',
          thisObj: me
        });
      }

      inputField.parent = me;
      return inputField;
    }
  }, {
    key: "updateInputField",
    value: function updateInputField(inputField) {
      this.removeAll();
      this.add(inputField);
    }
  }, {
    key: "onInputFieldChange",
    value: function onInputFieldChange() {
      if (this.containsFocus) {
        this.completeEdit();
      }
    }
  }, {
    key: "onTargetSizeChange",
    value: function onTargetSizeChange(resizedElement, oldRect, newRect) {
      if (oldRect && newRect) {
        this.updateSize(resizedElement);
      }
    }
  }, {
    key: "updateSize",
    value: function updateSize(targetEl) {
      var rect = targetEl.getBoundingClientRect();
      this.width = rect.width - this.align.offset[0];
      this.height = rect.height;
    }
  }, {
    key: "afterEditorHide",
    value: function afterEditorHide() {
      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_31__["default"].removeResizeListener(this.lastAlignSpec.target, this.onTargetSizeChange);
    }
  }, {
    key: "owner",
    set: function set(owner) {
      this._owner = owner;
    } // This is a positioned widget appended to a Widget's contentElement. It may have no owner link.
    // Grab the owner by finding what widget it is inside.
    ,
    get: function get() {
      return this._owner || _Widget_js__WEBPACK_IMPORTED_MODULE_22__["default"].fromElement(this.element.parentNode);
    }
  }, {
    key: "inputField",
    get: function get() {
      return this.items[0];
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Editor';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'editor';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        positioned: true,
        hidden: true,
        layout: 'fit',
        align: {
          align: 't0-t0',
          offset: [0, 0]
        },

        /**
         * A config object, or the `type` string of the widget (usually a {@link Core.widget.Field Field} subclass,
         * i.e. {@link Core.widget.TextField TextField}) which this editor will encapsulate.
         * @config {Object|String}
         * @default
         */
        inputField: 'textfield',

        /**
         * What action should be taken when focus moves out of the editor, either by `TAB` or clicking outside.
         * May be `'complete'` or `'cancel`'. Any other value results in no action being taken upon focus leaving the editor
         * leaving the application to listen for the {@link Core.widget.Widget#event-focusout focusout} event.
         * @config {String}
         * @default
         */
        blurAction: 'complete',

        /**
         * The name of the `key` which completes the edit.
         *
         * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values for key names.
         * @config {String}
         * @default
         */
        completeKey: 'Enter',

        /**
         * The name of the `key` which cancels the edit.
         *
         * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values for key names.
         * @config {String}
         * @default
         */
        cancelKey: 'Escape',

        /**
         * How to handle a request to complete the edit if the field is invalid. There are three choices:
         *  - `block` The default. The edit is not exited, the field remains focused.
         *  - `allow` Allow the edit to be completed.
         *  - `revert` The field value is reverted and the edit is completed.
         * @config {String}
         * @default
         */
        invalidAction: 'block',

        /**
         * Configure as `true` to have editing complete as soon as the field fires its `change` event.
         * @config {Boolean}
         * @default false
         */
        completeOnChange: null
      };
    }
  }]);

  return Editor;
}(_Container_js__WEBPACK_IMPORTED_MODULE_23__["default"]); // Register this widget type with its Factory



Editor.initClass();
Editor._$name = 'Editor';

/***/ }),

/***/ "./lib/Core/widget/Field.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Field.js ***!
  \**********************************/
/*! exports provided: createTooltip, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTooltip", function() { return createTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Field; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _mixin_Badge_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./mixin/Badge.js */ "./lib/Core/widget/mixin/Badge.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../util/ClickRepeater.js */ "./lib/Core/util/ClickRepeater.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';










var timeoutId;
function createTooltip(delay) {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  if (delay === undefined) {
    delay = _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].isTestEnv ? 0 : 1000;
  }

  if (delay === 0) {
    // eslint-disable-next-line
    Field.errorTip;
  } else {
    // eslint-disable-next-line
    timeoutId = setTimeout(function () {
      return Field.errorTip;
    }, delay);
  }
}
/**
 * @module Core/widget/Field
 */

var byWeight = function byWeight(l, r) {
  return (l.weight || 0) - (r.weight || 0);
},
    byWeightReverse = function byWeightReverse(l, r) {
  return (r.weight || 0) - (l.weight || 0);
};
/**
 * Base class for {@link Core.widget.TextField TextField} and {@link Core.widget.NumberField NumberField}. Not to be used directly.
 * All subclasses can be used as editors for the {@link Grid.column.Column Column}. The most popular are:
 * - {@link Core.widget.TextField TextField}
 * - {@link Core.widget.NumberField NumberField}
 * - {@link Core.widget.DateField DateField}
 * - {@link Core.widget.TimeField TimeField}
 * - {@link Core.widget.Combo Combo}
 *
 * @extends Core/widget/Widget
 * @mixes Core/widget/mixin/Badge
 * @abstract
 */


var Field = /*#__PURE__*/function (_Badge) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(Field, _Badge);

  var _super = _createSuper(Field);

  function Field() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, Field);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default()(Field, [{
    key: "doDestroy",
    value: function doDestroy() {
      var _me$inputListenerRemo, _me$keyListenerRemove;

      var me = this,
          triggers = me.triggers,
          errorTip = Field._errorTip;
      (_me$inputListenerRemo = me.inputListenerRemover) === null || _me$inputListenerRemo === void 0 ? void 0 : _me$inputListenerRemo.call(me);
      (_me$keyListenerRemove = me.keyListenerRemover) === null || _me$keyListenerRemove === void 0 ? void 0 : _me$keyListenerRemove.call(me);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Field.prototype), "doDestroy", this).call(this);

      if (triggers) {
        for (var _i = 0, _Object$values = Object.values(triggers); _i < _Object$values.length; _i++) {
          var t = _Object$values[_i];
          t.destroy();
        }
      } // The errorTip references this field, hide it when we die.


      if ((errorTip === null || errorTip === void 0 ? void 0 : errorTip.field) === me) {
        errorTip.hide();
      }
    }
  }, {
    key: "construct",
    //endregion
    //region Event

    /**
     * User typed into the field
     * @event input
     * @param {Core.widget.Field} source - The field
     * @param {String} value - Value
     */

    /**
     * Fired when the field value changes
     * @event change
     * @param {String} value - Value
     * @param {String} oldValue - Previous value
     * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
     * @param {Core.widget.Field} source - Field
     */

    /**
     * User performed default action (typed into the field)
     * @event click
     * @param {Core.widget.Field} field - Field
     * @param {String} value - Value
     */

    /**
     * User clicked fields clear icon
     * @event clear
     * @param {Core.widget.Field} field - Field
     */

    /*
     * User clicked on one of the field's {@link #property-triggers}
     * @event trigger
     * @param {Core.widget.Field.Trigger} trigger The trigger activated by click or touch tap.
     * @param {Core.widget.Field} trigger.field The trigger's owning Field.
     */
    //endregion
    //region Init
    value: function construct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Field.prototype), "construct", this).call(this, config);

      var me = this; // Instantiate error tip
      // In some demos this code may execute when body does not yet exist (happens in UMD bundles)
      // Create the singleton if DOM is ready

      if (_Tooltip_js__WEBPACK_IMPORTED_MODULE_24__["default"].listenersTarget) {
        createTooltip();
      } // wait till DOM is ready and then initialize Field.errorTip
      else {
          document.addEventListener('DOMContentLoaded', createTooltip);
        }

      if (me.keyStrokeChangeDelay) {
        me.changeOnKeyStroke = me.buffer(me.internalOnChange, me.keyStrokeChangeDelay);
      }
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      this.valueOnFocus = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].clone(this.value);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Field.prototype), "onFocusIn", this).call(this, e);
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Field.prototype), "onFocusOut", this).call(this, e); // Required field not flagged with error initially, flag on blur instead for better appearance


      this.syncRequired(); // Check field consistency on blur

      this.onEditComplete();
    }
    /**
     * Template function which may be implemented by subclasses to synchronize
     * input state and validity state upon completion of the edit.
     * @internal
     */

  }, {
    key: "onEditComplete",
    value: function onEditComplete() {}
  }, {
    key: "setInputAttributes",

    /**
     * Sets the inputAttributes and the attributes on the passed input field (or config for an input field
     * which it promoted to be an element).
     * For use by subclass implementations of `get innerElements` which return an array of child
     * configs or elements which should be children of the `inputWrap` element.
     * @param {HTMLElement|Object} inputField The element or DomHelper config to have attributes set.
     * @returns {HTMLElement} The element with the attributes set
     * @private
     */
    value: function setInputAttributes(inputField) {
      var me = this;

      if (!(inputField instanceof HTMLElement)) {
        var _inputField = inputField,
            reference = _inputField.reference;
        inputField = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].createElement(inputField);

        if (reference) {
          inputField = inputField[reference];
        }
      } // Propagate config values listed in the attributes property from this into the input element.


      me.attributes.forEach(function (attr) {
        var value = me[attr];

        if (value != null) {
          inputField.setAttribute(attr, value);
        }
      }); // Add custom inputAttributes provided

      me.inputAttributes && Object.entries(me.inputAttributes).forEach(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default()(_ref, 2),
            attr = _ref2[0],
            value = _ref2[1];

        if (value != null) {
          inputField.setAttribute(attr, value);
        }
      });
      return inputField;
    } //endregion
    //region Focus & select

  }, {
    key: "getAfterValue",

    /**
     * Returns the input value for this field's input element that will be present if
     * the event carrying the given text is allowed to proceed.
     * @param {String} text
     * @returns {String}
     * @private
     */
    value: function getAfterValue(text) {
      var _this$textSelection = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default()(this.textSelection, 2),
          begin = _this$textSelection[0],
          end = _this$textSelection[1],
          value = this.input.value;

      return "".concat(value.substr(0, begin)).concat(text).concat(value.substr(end || begin));
    }
    /**
     * Selects the field contents. Optionally may be passed a start and end.
     * NOTE: This method is async for IE11
     * @param {Number} [start] The start index from which to select the input.
     * @param {Number} [end] The index at which to end the selection of the input.
     */

  }, {
    key: "select",
    value: function select(start, end) {
      // Use focusElement which is the input field in this class
      // but allows subclasses to use other elements.
      // See, for example, TextAreaField
      var input = this.focusElement;

      if (input.value.length) {
        if (arguments.length === 0) {
          this.selectAll();
          return;
        } // Only allowed to select range in certain element / input types


        if (!this.supportsTextSelection) {
          return; // throw new Error('Trying to select text on an invalid element type');
        }

        if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isIE11) {
          // this.clearTimeout(this.selectTimeout);
          // HACK: IE focus processing is async and we can't select text until field is focused
          // Getting flaky exception in IE, something timing related. Found no way to detect it so using this
          // workaround for now
          input.focus();
          input.setSelectionRange(start, end); //
          // this.selectTimeout = this.setTimeout(() => {
          //     input && input.setSelectionRange(start, end);
          // }, 10);
        } else {
          input.setSelectionRange(start, end);
        }
      }
    }
  }, {
    key: "moveCaretToEnd",
    value: function moveCaretToEnd() {
      var input = this.input;

      if (input.createTextRange) {
        var range = input.createTextRange();
        range.collapse(false);
        range.select();
      } else if (this.supportsTextSelection) {
        // Move caret to the end if possible
        this.select(input.value.length, input.value.length);
      }
    }
  }, {
    key: "selectAll",
    value: function selectAll() {
      this.focusElement.select();
    } // called on value changes to update styling of empty vs non-empty field

  }, {
    key: "syncEmpty",
    value: function syncEmpty() {
      var isEmptyInput = this.isEmptyInput,
          isEmpty = this.isEmpty,
          element = this.element,
          clearIcon = this.clearIcon,
          empty = isEmptyInput && isEmpty;

      if (element) {
        if (clearIcon) {
          // IE11...
          clearIcon.classList[empty ? 'add' : 'remove']('b-icon-hidden');
        } // IE11...


        element.classList[empty ? 'add' : 'remove']('b-empty');
      }
    }
  }, {
    key: "updateHint",
    value: function updateHint() {
      this.syncHint();
    }
  }, {
    key: "updateHintHtml",
    value: function updateHintHtml() {
      this.syncHint();
    }
  }, {
    key: "syncHint",
    value: function syncHint() {
      var me = this,
          input = me.input,
          hint = me.hint,
          hintHtml = me.hintHtml,
          parent = input === null || input === void 0 ? void 0 : input.parentElement;

      if (input) {
        var hintValue = hintHtml || hint;
        var hintElement = me.hintElement || hintValue && (me.hintElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].createElement({
          parent: parent,
          className: 'b-field-hint',
          nextSibling: input.nextSibling,
          children: [{
            className: 'b-field-hint-content'
          }]
        }));

        if (hintElement) {
          if (typeof hintValue === 'function') {
            hintValue = hintValue({
              source: me,
              value: me.value
            });
          }

          hintElement.firstChild[hintHtml ? 'innerHTML' : 'textContent'] = hintValue || '';
        }

        me.element.classList[hintValue ? 'remove' : 'add']('b-field-no-hint');
      }
    }
  }, {
    key: "syncInvalid",
    value: function syncInvalid() {
      this.updatingInvalid = true;
      var isValid = this.isValid,
          element = this.element,
          inputWrap = this.inputWrap; // errorTip needs Tooltip.listenersTarget to be there
      // otherwise it doesn't setup listeners and cannot notice we mouseove an invalid field

      var errorTip = _Tooltip_js__WEBPACK_IMPORTED_MODULE_24__["default"].listenersTarget && this.errorTip;

      if (element) {
        element.classList[isValid ? 'remove' : 'add']('b-invalid'); // We achieved validity, so ensure the error tip is hidden

        if (isValid) {
          if ((errorTip === null || errorTip === void 0 ? void 0 : errorTip.isVisible) && errorTip.field === this) {
            errorTip.hide();
          }
        } // If the mouse is over, the tip should spring into view
        else if (errorTip && inputWrap.contains(_Tooltip_js__WEBPACK_IMPORTED_MODULE_24__["default"].currentOverElement)) {
            // Already shown by this field's inputWrap, just update content.
            if (errorTip.activeTarget === inputWrap && errorTip.isVisible) {
              errorTip.onBeforeShow();
            } else {
              errorTip.activeTarget = inputWrap;
              errorTip.showBy(inputWrap);
            }
          }
      }

      this.updatingInvalid = false;
    } //endregion
    //region Getters/setters

  }, {
    key: "updateEditable",
    value: function updateEditable() {
      this.syncInputReadOnly();
    }
  }, {
    key: "syncInputReadOnly",
    value: function syncInputReadOnly() {
      this.getConfig('readOnly'); // make sure our config is initialized...
      // but since the readOnly getter conflates disabled into it, we ultimately have to look at _readOnly:

      this.inputReadOnly = this._readOnly || this.editable === false;
    }
  }, {
    key: "updateInputReadOnly",
    value: function updateInputReadOnly(readOnly) {
      var me = this,
          input = me.input,
          inputListenerRemover = me.inputListenerRemover; // Editable refers *ONLY* to the readOnly state of the <input> field within the field.
      // It does *NOT* imply that the field is not modifiable by user interaction.
      // For example, a Combo or DateField may be not editable, but may still be set through the UI.
      // It is the readOnly config which disables user interaction from modifying the field.

      if (input) {
        input.readOnly = readOnly ? 'readOnly' : null;

        if (readOnly) {
          me.inputListenerRemover = inputListenerRemover === null || inputListenerRemover === void 0 ? void 0 : inputListenerRemover();
        } else if (!inputListenerRemover) {
          me.inputListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].on({
            element: input,
            thisObj: me,
            focus: 'internalOnInputFocus',
            change: 'internalOnChange',
            input: 'internalOnInput'
          });
        }
      }
    }
  }, {
    key: "changeReadOnly",
    value: function changeReadOnly(value) {
      return Boolean(value);
    }
  }, {
    key: "updateReadOnly",
    value: function updateReadOnly(readOnly) {
      var _this$element;

      // We can be called during element creation, so "this.element" may not yet be available
      (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.classList[readOnly ? 'add' : 'remove']('b-readonly');
      this.syncInputReadOnly();
    }
  }, {
    key: "updateClearable",
    value: function updateClearable(clearable) {
      var me = this;
      me.getConfig('triggers');
      me.triggers = {
        clear: clearable && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].assign({
          cls: 'b-icon-remove',
          weight: 1000,
          handler: function handler() {
            me._isUserAction = true;
            me.clear();
            me._isUserAction = false;
          }
        }, clearable) || null
      };
    }
  }, {
    key: "changeTriggers",
    value: function changeTriggers(triggers) {
      var me = this,
          manager = me.$triggers || (me.$triggers = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_31__["default"]({
        factory: Field.Trigger,
        inferType: false,
        // the name of a trigger in the triggers object is not its type
        owner: me,
        setup: function setup(config, name) {
          config.reference = name;
          config.parent = me;
        }
      }));

      if (me.stepTriggers === false && (triggers.back || triggers.forward)) {
        triggers = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].assign({}, triggers);
        delete triggers.back;
        delete triggers.forward;
      }

      manager.update(triggers);
      manager.flush();
      return manager.target;
    }
  }, {
    key: "updateLabelWidth",
    value: function updateLabelWidth(newValue) {
      if (this.labelElement) {
        this.labelElement.style.flex = "0 0 ".concat(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].setLength(newValue)); // If there's a label width, the input must conform with it, and not try to expand to 100%

        this.inputWrap.style.flexBasis = newValue == null ? '' : 0;
      }
    }
  }, {
    key: "updateInputWidth",
    value: function updateInputWidth(newValue) {
      this.input.style.width = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].setLength(newValue); // requires to make "Should support inputWidth with label" test green

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isIE11) {
        this.input.parentElement.style.flexBasis = this.input.style.width;
      }

      this.element.classList.add('b-has-width');
    }
  }, {
    key: "updateInputAlign",
    value: function updateInputAlign(newValue) {
      this.input.style.textAlign = newValue;
    }
  }, {
    key: "changeLabel",
    value: function changeLabel(label) {
      return label == null ? '' : label;
    }
  }, {
    key: "updateLabel",
    value: function updateLabel(label) {
      // since value is used in template it is not certain that element is available
      // TODO: move the code from template here instead
      if (this.labelElement) {
        // using innerHTML since we sometimes use icons as label
        this.labelElement.innerHTML = label;
      }
    }
    /**
     * Returns true if the field value is valid
     * @type {Boolean}
     * @readonly
     */

  }, {
    key: "changeValue",
    value: function changeValue(value, was) {
      if (value == null) {
        value = this.nullValue;
      } // In cases of arrays, for example, we need to return "was" to pass the === check in the setter to convince
      // the config that, in fact, no change has occurred.


      if (this.hasChanged(was, value)) {
        return value;
      } // When loading a record into a form, an empty value might be loaded into a field, which is not detected as a
      // change. In this scenario it should still be flagged as invalid


      if (value === '') {
        this.syncRequired();
      }

      return was;
    }
  }, {
    key: "updateValue",
    value: function updateValue(value, oldValue) {
      var me = this; // Do not flag with error if configured empty, looks ugly to have fields start red

      if (!me.isConfiguring) {
        me.syncRequired(); // Do not trigger change event during configuration phase
        // or during keyboard input

        if (!me.inputting) {
          // trigger change event, signaling that origin is from set operation,
          // makes it easier to ignore such events in applications that set value on load etc
          me.triggerChange();
        }
      } // lastValue is used for IE to check if a change event should be triggered when pressing ENTER


      if (!me.inputting) {
        me._lastValue = value;
      }

      me.syncInputFieldValue();
    }
    /**
     * Compare's this field's value with its previous value. May be overridden in subclasses
     * which have more complex value types. See, for example, {@link Core.widget.DurationField}.
     * @param {*} oldValue
     * @param {*} newValue
     * @private
     */

  }, {
    key: "hasChanged",
    value: function hasChanged(oldValue, newValue) {
      return newValue !== oldValue;
    }
    /**
     * Called by the base Field class's `set value` to sync the state of the UI with the field's value.
     *
     * Relies upon the class implementation of `get inputValue` to return a string representation of
     * the value for user consumption and editing.
     * @private
     */

  }, {
    key: "syncInputFieldValue",
    value: function syncInputFieldValue() {
      var skipHighlight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          input = me.input,
          parent = me.parent; // If we are updating from internalOnInput, we must not update the input field

      if (input && !me.inputting) {
        // Subclasses may implement their own read only inputValue property.
        me.input[me.inputValueAttr] = me.inputValue; // TODO : This highlighting logic needs extracting/clarifying
        // If it's being manipulated from the outside, highlight it

        if (!me.isConfiguring && !me.containsFocus && me.highlightExternalChange) {
          input.classList.remove('b-field-updated');
          me.clearTimeout('removeUpdatedCls');

          if (!skipHighlight && (!parent || !parent.isSettingValues || !parent._isSettingValues.preventHighlight)) {
            me.highlightChanged();
          }
        }
      }

      me.syncEmpty();
      me.syncInvalid();
    }
  }, {
    key: "highlightChanged",
    value: function highlightChanged() {
      this.input.classList.add('b-field-updated');
      this.setTimeout('removeUpdatedCls', this.updatedClsDuration);
    }
  }, {
    key: "removeUpdatedCls",
    value: function removeUpdatedCls() {
      this.input.classList.remove('b-field-updated');
    }
    /**
     * A String representation of the value of this field for {@link #function-syncInputFieldValue} to use
     * as the input element's value.
     *
     * Subclasses may override this to create string representations.
     *
     * For example, {@link Core.widget.DateField}'s implementation will format the field date
     * value according to its configured {@link Core.widget.DateField#config-format}. And {@link Core.widget.Combo}'s
     * implementation will return the {@link Core.widget.Combo#config-displayField} of the selected record.
     * @internal
     * @readOnly
     */

  }, {
    key: "internalOnInputFocus",
    //endregion
    //region Events
    value: function internalOnInputFocus() {
      var length = this.input.value.length; // Help IE to set caret at the end like the other browsers

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isIE11 && length && !this.autoSelect) {
        this.select(length, length);
      }
    }
    /**
     * Trigger event when fields input changes
     * @fires change
     * @private
     */

  }, {
    key: "internalOnChange",
    value: function internalOnChange(event) {
      var me = this; // Don't trigger change if we enter invalid value or if value has not changed (for IE when pressing ENTER)

      if (me.isValid && me.hasChanged(me._lastValue, me.value)) {
        me.triggerChange(event, true);
        me._lastValue = me.value;
      }
    }
  }, {
    key: "triggerChange",
    value: function triggerChange(event) {
      var userAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Boolean(this._isUserAction);
      var me = this,
          value = me.value,
          oldValue = me._lastValue,
          valid = me.isValid;
      me.syncHint(); // trigger change event, signaling that origin is from user

      me.triggerFieldChange({
        value: value,
        oldValue: oldValue,
        event: event,
        userAction: userAction,
        valid: valid
      }); // per default Field triggers action event on change, but might be reconfigured in subclasses (such as Combo)

      if (me.defaultAction === 'change') {
        me.trigger('action', {
          value: value,
          oldValue: oldValue,
          event: event,
          userAction: userAction,
          valid: valid
        });
      } // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onClick and onAction

    }
    /**
     * Trigger event when user inputs into field
     * @fires input
     * @param event
     * @private
     */

  }, {
    key: "internalOnInput",
    value: function internalOnInput(event) {
      var me = this; // Keep the value synced with the inputValue at all times.

      me.inputting = true;
      me.value = me.input.value;
      me.inputting = false;
      me.trigger('input', {
        value: me.value,
        event: event
      });
      me.changeOnKeyStroke && me.changeOnKeyStroke(event); // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onInput
    }
  }, {
    key: "internalOnKeyEvent",
    value: function internalOnKeyEvent(event) {
      var me = this,
          value = me.value;
      var stopEvent = false;

      if (event.type === 'keydown') {
        if (event.key === 'Escape' && !(me.readOnly || me.disabled)) {
          // We can be started with an initialValue which takes precedence over the valueOnFocus.
          // Because in some situations focus can move out and back in after a change which needs
          // to be revertable. For example in cell editing.
          var initialValue = 'initialValue' in me ? me.initialValue : me.valueOnFocus,
              valueChanged = me.hasChanged(initialValue, value),
              needsInputSync = me.input.value !== String(me.inputValue); // We revert on escape if we are configured to do so AND:
          // We are in an invalid state, or the value has changed, or the displayed value doesn't match the field value.

          if (me.revertOnEscape && (!me.isValid || valueChanged || needsInputSync)) {
            if (valueChanged) {
              me.value = initialValue;
            }

            if (needsInputSync) {
              me.syncInputFieldValue(true);
            }

            me.clearError();
            stopEvent = valueChanged && me.isValid;
          } else if (me.clearable && (value || me.input.value)) {
            me.clear();
          }
        } // #5730 - IE11 doesn't trigger "change" event by Enter click
        else if (event.key === 'Enter' && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isIE11) {
            me.internalOnChange(event);
          }
      } // The above processing might have destructive consequences.


      if (!me.isDestroyed) {
        // If the keystroke had the effect of changing the field, prevent other handlers
        // which may mask that effect. Such as ESC exiting some UI context. Keep it contained.
        if (stopEvent) {
          event.stopImmediatePropagation();
        }

        me.trigger(event.type, {
          event: event
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.value = this.nullValue;
      this.trigger('clear');
    }
    /**
     * Called when disabled state is changed.
     * Used to add or remove 'b-invalid' class for the invalid field based on current disabled state.
     * @private
     */

  }, {
    key: "onDisabled",
    value: function onDisabled() {
      this.syncInvalid();
    } //endregion
    //region Error

  }, {
    key: "syncRequired",
    value: function syncRequired() {
      var _me$parent;

      var me = this; // Empty valid if any ancestor Container is setting values

      if (!me.isConfiguring && me.required && me.isEmpty && !((_me$parent = me.parent) === null || _me$parent === void 0 ? void 0 : _me$parent.isSettingValues)) {
        me.setError('L{fieldRequired}', me.updatingInvalid);
      } else {
        me.clearError('L{fieldRequired}', me.updatingInvalid);
      }
    }
    /**
     * Adds an error message to the list of errors on this field.
     * By default the field's valid/invalid state is updated; pass
     * `false` as the second parameter to disable that if multiple
     * changes are being made to the error state.
     * @param {String} error A locale string, or message to use as an error message.
     * @param {Boolean} [silent=false] Pass as `true` to skip updating the field's valid/invalid state.
     */

  }, {
    key: "setError",
    value: function setError(error, silent) {
      // Error messages are deduped by using them as the property names in an object.
      (this.errors || (this.errors = {}))[this.L(error)] = 1;

      if (!silent) {
        this.syncInvalid();
      }
    }
    /**
     * Removes an error message from the list of errors on this field.
     * By default the field's valid/invalid state is updated; pass
     * `false` as the second parameter to disable that if multiple
     * changes are being made to the error state.
     * @param {String} [error] A locale string, or message to remove. If not passed, all errors are cleared.
     * @param {Boolean} [silent=false] Pass as `true` to skip updating the field's valid/invalid state.
     */

  }, {
    key: "clearError",
    value: function clearError(error, silent) {
      if (this.errors) {
        if (error) {
          delete this.errors[this.L(error)];
        } else {
          this.errors = {};
        }
      }

      if (!silent) {
        this.syncInvalid();
      }
    }
    /**
     * Returns an array of error messages as set by {@link #function-setError}, or
     * `undefined` if there are currently no errors.
     * @return {String[]} The errors for this field, or `undefined` if there are no errors.
     */

  }, {
    key: "getErrors",
    value: function getErrors() {
      var me = this;

      if (!me.isValid) {
        var validity = me.input.validity,
            // See possible state names: https://developer.mozilla.org/en-US/docs/Web/API/ValidityState
        stateName = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].allKeys(validity).find(function (key) {
          return key !== 'valid' && key !== 'customError' && validity[key];
        });
        var errors;

        if (me.errors) {
          errors = Object.keys(me.errors);
        } // If custom error message was set using https://developer.mozilla.org/en-US/docs/Web/API/HTMLObjectElement/setCustomValidity
        else if (validity.customError) {
            errors = [me.input.validationMessage];
          } // If invalid state found, translate it
          else if (stateName) {
              // Do not remove. Assertion strings for Localization sanity check.
              // 'L{foo}'
              // 'L{badInput}'
              // 'L{patternMismatch}'
              // 'L{rangeOverflow}'
              // 'L{rangeUnderflow}'
              // 'L{stepMismatch}'
              // 'L{tooLong}'
              // 'L{tooShort}'
              // 'L{typeMismatch}'
              // 'L{valueMissing}'
              errors = [me.L(stateName, {
                // In case min/max limits are present they will be used in the translation
                min: me.min,
                max: me.max
              })];
            } // If built-in state is 'valid' but me.isValid is false, show our invalid message
            else {
                errors = [me.L(me.invalidValueError)];
              }

        if (errors && errors.length > 0) {
          return errors;
        }
      }
    } //endregion

  }, {
    key: "invalidValueError",
    get: function get() {
      return 'L{invalidValue}';
    }
    /**
     * A singleton error tooltip which activates on hover of invalid fields.
     * before show, it gets a reference to the field and interrogates its
     * active error list to display as the tip content.
     * @member {Core.widget.Tooltip}
     * @readonly
     */

  }, {
    key: "errorTip",
    get: function get() {
      return this.constructor.errorTip;
    }
    /**
     * A singleton error tooltip which activates on hover of invalid fields.
     * before show, it gets a reference to the field and interrogates its
     * active error list to display as the tip content.
     * @member {Core.widget.Tooltip}
     * @readonly
     * @static
     */

  }, {
    key: "element",
    set: function set(element) {
      var me = this,
          value = me.initialConfig.value,
          innerElements = me.innerElements,
          children = [{
        className: 'b-field-inner',
        reference: 'inputWrap',
        children: innerElements
      }],
          startTriggers = [],
          endTriggers = [];
      var hasStartTrigger;
      var labels = me.labels || [];

      if (me.label) {
        labels.push({
          reference: 'labelElement',
          className: me.labelCls,
          html: me.label
        });
      }

      if (labels) {
        labels.forEach(function (label) {
          var entry = Object.assign({
            tag: 'label',
            htmlFor: "".concat(me.id, "-input"),
            className: "b-align-".concat(label.align || 'start')
          }, label);

          if (!label.align || label.align === 'start') {
            children.unshift(entry);
          } else {
            children.push(entry);
          }
        });
      } // Force evaluation of clearable so triggers include the clearable trigger.


      me.getConfig('clearable');

      for (var triggerRef in me.triggers) {
        var trigger = me.triggers[triggerRef];

        if (trigger.align === 'start') {
          startTriggers.unshift(trigger);
          hasStartTrigger = true;
        } else {
          endTriggers.push(trigger);
        }
      } // The triggers at each end are sorted "gavitationally".
      // Higher weight sorts towards the center which is the input element.


      startTriggers.sort(byWeight);
      endTriggers.sort(byWeightReverse);
      innerElements.unshift.apply(innerElements, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14___default()(startTriggers.map(function (t) {
        return t.element;
      })));
      innerElements.push.apply(innerElements, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14___default()(endTriggers.map(function (t) {
        return t.element;
      })));

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Field.prototype), "element", {
        children: children,
        className: {
          'b-has-label': labels.length,
          'b-has-start-trigger': hasStartTrigger,
          'b-readonly': me.readOnly
        }
      }, this, true); // Value must be injected into the input element after it has been constructed, not in the
      // initial template, otherwise the caret position will not be as expected.


      if (value != null) {
        me.value = value;
      }

      me.syncEmpty();
      me.updateInputReadOnly(me.inputReadOnly);
      me.syncInvalid();
      var keyEventElement = me.input || me.focusElement;

      if (keyEventElement) {
        me.keyListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].on({
          element: keyEventElement,
          thisObj: me,
          keydown: 'internalOnKeyEvent',
          keypress: 'internalOnKeyEvent',
          keyup: 'internalOnKeyEvent'
        });
      }
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Field.prototype), "element", this);
    } // Subclasses may implement this.
    // Needed because Checkbox produces an array of two elements as its innerElements

  }, {
    key: "innerElements",
    get: function get() {
      return [this.setInputAttributes(this.inputElement)];
    }
  }, {
    key: "inputElement",
    get: function get() {
      var me = this,
          config = {
        tag: 'input',
        reference: 'input',
        class: me.inputCls || '',
        value: me._value || '',
        name: me.name || me.id,
        id: "".concat(me.id, "-input")
      };

      if (me.inputType) {
        config.type = me.inputType;
      }

      return config;
    }
  }, {
    key: "caretPos",
    get: function get() {
      return this.textSelection[0];
    },
    set: function set(value) {
      this.textSelection = value;
    }
  }, {
    key: "focusElement",
    get: function get() {
      return this.input;
    }
  }, {
    key: "textSelection",
    get: function get() {
      var input = this.input;
      var ret;

      try {
        ret = [input.selectionStart, input.selectionEnd, input.selectionDirection];
      } catch (e) {
        // ignore (some input types cannot do this)
        ret = input.value;
        ret = ret ? ret.length : 0;
        ret = [ret, ret];
      }

      return ret;
    },
    set: function set(value) {
      if (typeof value === 'number') {
        this.select(value, value);
      } else {
        this.select.apply(this, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14___default()(value));
      }
    }
  }, {
    key: "hasTextSelection",
    get: function get() {
      var _this$textSelection2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default()(this.textSelection, 2),
          selectionStart = _this$textSelection2[0],
          selectionEnd = _this$textSelection2[1];

      return selectionStart && selectionEnd - selectionStart > 0;
    }
  }, {
    key: "isValid",
    get: function get() {
      var me = this; // Disabled fields are considered valid

      if (!me.disabled) {
        me.syncRequired();

        if (me.errors && Object.keys(me.errors).length) {
          return false;
        }

        var validity = me.validity;

        if (validity) {
          return validity.valid;
        }
      }

      return true;
    }
    /**
     * Returns `true` if this field is empty. That is, if it would violate the {@link #config-required}
     * setting.
     *
     * This may have different definitions in subclasses from simple text fields.
     * @type {boolean}
     * @readonly
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this.value == null || this.value === '';
    }
    /**
     * Returns true if the field's input is empty
     * @type {boolean}
     * @readonly
     */

  }, {
    key: "isEmptyInput",
    get: function get() {
      return !this.input || this.input.value == null || this.input.value === '';
    }
    /**
     * Returns the DOM `ValidityState` for this widget's input element, or `null` if there
     * isn't one.
     * @returns {ValidityState}
     * @private
     */

  }, {
    key: "validity",
    get: function get() {
      var input = this.input;
      return input && input.validity;
    }
  }, {
    key: "inputValue",
    get: function get() {
      // Do not use the _value property. If called during configuration, this
      // will import the configured value from the config object.
      return this.value == null ? '' : this.value;
    }
  }, {
    key: "inputValueAttr",
    get: function get() {
      return 'value';
    }
  }, {
    key: "supportsTextSelection",
    get: function get() {
      var input = this.focusElement; // Text selection using setSelectionRange is allowed in Chrome for certain elements. Edge supports it even for input[type=number]

      return input && (input.tagName.toLowerCase() === 'textarea' || input.type && (/text|search|password|tel|url/.test(input.type) || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isEdge));
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Field';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'field';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Text to display in empty field.
         * @config {String} placeholder
         */
        placeholder: null,

        /**
         * Gets or sets the value. The returned type will depend upon the Field subclass.
         *
         * `TextField` returns a `String`.
         *
         * `NumberField` returns a `Number`.
         *
         * `DateField` and `TimeField` return a `Date` object, and `null` if the field is empty.
         *
         * `Combo` will return a `String` if configured with `items` as a simple string array.
         * Otherwise it will return the {@link Core.widget.Combo#config-valueField} value from the
         * selected record, or `null` if no selection has been made.
         * @property {*}
         * @name value
         */

        /**
         * Default value
         * @config {String}
         */
        value: '',

        /**
         * Name of the field which is used as a key to get/set values from/to the field.
         * Used prior to {@link Core.widget.Widget#config-ref ref} and {@link Core.widget.Widget#config-id id} in
         * {@link Core.widget.Container#property-values Container.values}.
         *
         * The config is useful when the field is used in EventEditor or TaskEditor to load/save values automatically.
         * @config {String}
         */
        name: null,

        /**
         * Get/set fields label. Please note that the Field needs to have a label specified from start for this to
         * work, otherwise no element is created.
         * @property {String}
         * @name label
         */

        /**
         * Label, prepended to field
         * @config {String}
         * @category Label
         */
        label: null,

        /**
         * CSS class name or class names to add to any configured {@Link #config-label}
         * @config {String|Object}
         * @category Label
         */
        labelCls: null,

        /**
         * The labels to add either before or after the input field.
         * Each label may have the following properties:
         * * `html` The label text.
         * * `align` `'start'` or `'end'` which end of the field the label should go.
         * @config {Object}
         * @category Label
         */
        labels: null,

        /**
         * The width to apply to the `<label>` element. If a number is specified, `px` will be used.
         * @config {String|Number}
         * @localizable
         * @category Label
         */
        labelWidth: {
          value: null,
          $config: {
            localeKey: 'L{labelWidth}'
          }
        },

        /**
         * Configure as `true` to indicate that a `null` field value is to be marked as invalid.
         * @config {Boolean}
         * @default false
         */
        required: null,

        /**
         * Show a trigger to clear field, and allow `ESC` key to clear field if this field is
         * not {@link #config-readOnly}. The trigger is available in the {@link #property-triggers} object
         * under the name `clear`. May also be an object which configures the `clear` {@link #property-triggers trigger}.
         * @config {Boolean|Object}
         * @default false
         */
        clearable: null,

        /**
         * If this field is not {@link #config-readOnly}, then setting this option means that pressing
         * the `ESCAPE` key after editing the field will revert the field to the value it had when
         * the user focused the field. If the field is _not_ changed from when focused, the {@link #config-clearable}
         * behaviour will be activated.
         * @config {Boolean}
         * @default false
         */
        revertOnEscape: null,

        /**
         * An optional string to display inside the input field as an overlay. This can be useful for displaying
         * a field's units.
         *
         * This config is ignored if {@link #config-hintHtml} is set.
         *
         * For example:
         * ```javascript
         *  {
         *      type  : 'numberfield',
         *      label : 'Temperature',
         *      hint  : '°C'
         *  }
         * ```
         *
         * This config can be set to a function to dynamically generate the `hint` text:
         * ```javascript
         *  {
         *      type  : 'numberfield',
         *      label : 'Duration',
         *      hint  : ({ value }) => (value === 1) ? 'Day' : 'Days'
         *  }
         * ```
         *
         * The function is passed an object with the following properties:
         *
         *  - `source` A reference to the field instance.
         *  - `value` The current value of the field.
         *
         * A `hint` function will be called when the field changes value.
         *
         * @config {String|Function}
         * @category Label
         */
        hint: null,

        /**
         * This config is similar to {@link #config-hint} except that this config is used to display HTML content.
         * Since this can allow malicious content to be executed, be sure not to include user-entered data or to
         * encode such data (see {@link Core.helper.StringHelper#function-encodeHtml-static}).
         *
         * If this config is set, {@link #config-hint} is ignored.
         *
         * For example:
         * ```javascript
         *  {
         *      type     : 'numberfield',
         *      label    : 'Temperature',
         *      hintHtml : '<i>°C</i>'
         *  }
         * ```
         *
         * This config can be set to a function to dynamically generate the `hintHtml` text:
         * ```javascript
         *  {
         *      type     : 'numberfield',
         *      label    : 'Duration',
         *      hintHtml : ({ value }) => (value === 1) ? '<i>Day</i>' : '<i>Days</i>'
         *  }
         * ```
         *
         * The function is passed an object with the following properties:
         *
         *  - `source` A reference to the field instance.
         *  - `value` The current value of the field.
         *
         * A `hintHtml` function will be called when the field changes value.
         *
         * @config {String|Function}
         * @category Label
         */
        hintHtml: null,

        /**
         * The width to apply to the `<input>` element. If a number is specified, `px` will be used.
         * @config {String|Number}
         * @category Input element
         */
        inputWidth: null,

        /**
         * The delay in milliseconds to wait after the last keystroke before triggering a change event.
         * Set to 0 to not trigger change events from keystrokes (listen for input event instead to have
         * immediate feedback, change will still be triggered on blur)
         * @config {Number}
         * @default
         */
        keyStrokeChangeDelay: 0,

        /**
         * Makes the field unmodifiable by user action. The input area is not editable, and triggers
         * are unresponsive.
         *
         * This is a wider-acting setting than {@link #config-editable} which *only* sets the
         * `readOnly` attribute of the `<input>` field.
         *
         * PickerFields such as `Combo` and `DateField` can be `editable : false`, but still
         * modifiable through the UI.
         * @config {Boolean}
         */
        readOnly: null,

        /**
         * Set to false to prevent user from editing the field. For TextFields it is basically the same as setting
         * {@link #config-readOnly}, but for PickerFields there is a distinction where it allows you to pick a value
         * but not to type one in the field.
         *
         * PickerFields such as `Combo` and `DateField` can be `editable : false`, but still
         * modifiable through the UI.
         * @config {Boolean}
         * @default true
         */
        editable: true,
        defaultAction: 'change',

        /**
         * The trigger Widgets as specified by the {@link #config-triggers} configuration and the
         * {@link #config-clearable} configuration. Each is a {@link Core.widget.Widget Widget} instance which may
         * be hidden, shown and observed and styled just like any other widget.
         * @property {Object}
         * @name triggers
         */

        /**
         * The triggers to add either before or after the input field. Each property name is the reference by which
         * an instantiated Trigger Widget may be retrieved from the live `{@link #property-triggers}` property.
         *
         * Each trigger may have the following properties:
         * * `cls` The CSS class to apply.
         * * `handler` A method in the field to call upon click
         * * `align` `'start'` or `'end'` which end of the field the trigger should go.
         * * `weight` (Optional) Higher weighted triggers gravitate towards the input field.
         *
         * ```javascript
         * const textField = new TextField({
         *   triggers : {
         *       check : {
         *           cls : 'b-fa b-fa-check',
         *           handler() {
         *               ...
         *           }
         *       },
         *       ...
         *   }
         * })
         * ```
         *
         * @config {Object}
         */
        triggers: null,

        /**
         * Specify `false` to prevent field from being highlighted when on external value changes
         * @config {Boolean}
         */
        highlightExternalChange: true,
        localizableProperties: ['label', 'title', 'placeholder', 'labelWidth'],
        autoSelect: false,

        /**
         * Sets the native `autocomplete` property of the underlying input element. For more information, please refer to
         * [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)
         * @config {String}
         * @default
         * @category Input element
         */
        autoComplete: 'off',

        /**
         * Sets custom attributes of the underlying input element. For more information, please refer to
         * [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes)
         * @config {Object}
         * @default
         * @category Input element
         */
        inputAttributes: null,

        /**
         * Sets the `type` attribute of the underlying input element.
         * @config {String}
         * @private
         * @category Input element
         */
        inputType: null,

        /**
         * Text alignment for the input field.
         * @config {String}
         * @category Input element
         */
        inputAlign: null,

        /**
         * A list of property names to be set in the underlying input element from properties
         * by the same name in this Field object if the value is not `== null`.
         * @private
         * @category Input element
         */
        attributes: {
          value: ['placeholder', 'autoComplete', 'minLength', 'maxLength', 'pattern', 'tabIndex', 'min', 'max'],
          $config: {
            merge: 'distinct'
          }
        },
        nullValue: {
          $config: null,
          value: null,
          default: null // store _value=null on prototype

        },
        updatedClsDuration: 500,
        inputReadOnly: false,
        testConfig: {
          updatedClsDuration: 10
        }
      };
    }
  }, {
    key: "delayable",
    get: function get() {
      return {
        highlightChanged: 'raf'
      };
    }
  }, {
    key: "errorTip",
    get: function get() {
      return Field._errorTip || (Field._errorTip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_24__["default"]({
        id: 'bryntum-field-errortip',
        cls: 'b-field-error-tip',
        forSelector: '.b-field.b-invalid .b-field-inner',
        align: 'l-r',
        scrollAction: 'realign',
        onBeforeShow: function onBeforeShow() {
          var tip = this,
              field = _Widget_js__WEBPACK_IMPORTED_MODULE_23__["default"].fromElement(tip.activeTarget);

          if (field) {
            var errors = field.getErrors();

            if (errors) {
              tip.html = errors.join('<br>');
              tip.field = field;
              return true;
            }
          } // Veto show


          return false;
        }
      }));
    }
  }]);

  return Field;
}(Object(_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_25__["default"])(_Widget_js__WEBPACK_IMPORTED_MODULE_23__["default"]));
/**
 * Base class for field triggers May be configured with a `cls` and a `handler` which is a function (or name of a function)
 * in the owning Field.
 * @extends Core/widget/Widget
 */




Field.Trigger = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(FieldTrigger, _Widget);

  var _super2 = _createSuper(FieldTrigger);

  function FieldTrigger() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, FieldTrigger);

    return _super2.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default()(FieldTrigger, [{
    key: "template",
    value: function template() {
      return "<div class=\"b-icon b-align-".concat(this.align || 'end', "\"></div>");
    }
  }, {
    key: "construct",
    value: function construct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(FieldTrigger.prototype), "construct", this).call(this, config);

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].on({
        element: this.element,
        click: {
          handler: 'onClick',
          thisObj: this
        },
        mousedown: {
          handler: 'onMousedown',
          thisObj: this
        }
      });
    }
  }, {
    key: "changeAlign",
    value: function changeAlign(align) {
      return align; // Widget base class converts to an object
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      var me = this,
          field = me.field,
          handler = typeof me.handler === 'function' ? me.handler : field[me.handler];

      if (field.disabled || field.readOnly) {
        return;
      }

      if (handler && field.trigger('trigger', {
        trigger: me
      }) !== false) {
        handler.call(field, e);
      }
    }
  }, {
    key: "onMousedown",
    value: function onMousedown(e) {
      var field = this.field,
          isKeyEvent = ('key' in e); // If it's a touch tap on the trigger of an editable, then
      // avoid the keyboard by setting the field to not be editable
      // before focusing the field. Reset to be editable after focusing
      // has happened. Keyboard will not appear.

      if (!isKeyEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].isTouchEvent) {
        if (field.editable) {
          field.editable = false;
          field.setTimeout(function () {
            return field.editable = true;
          }, 500);
        }
      }

      e.preventDefault();

      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].activeElement !== field.input) {
        field.focus();
      }
    }
  }, {
    key: "field",
    get: function get() {
      return this.parent;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'FieldTrigger';
    }
  }, {
    key: "factoryable",
    get: function get() {
      return {
        defaultType: Field.Trigger,
        extends: null
      };
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'trigger';
    } // Align is a simple string at this level

  }, {
    key: "configurable",
    get: function get() {
      return {
        align: null
      };
    }
  }]);

  return FieldTrigger;
}(_Widget_js__WEBPACK_IMPORTED_MODULE_23__["default"]);

Field.SpinTrigger = /*#__PURE__*/function (_Field$Trigger) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(SpinTrigger, _Field$Trigger);

  var _super3 = _createSuper(SpinTrigger);

  function SpinTrigger() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, SpinTrigger);

    return _super3.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default()(SpinTrigger, [{
    key: "doDestroy",
    value: function doDestroy() {
      this.clickRepeater && this.clickRepeater.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(SpinTrigger.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "template",
    value: function template() {
      return "<div class=\"b-icon b-align-".concat(this.align || 'end', "\">\n                    <div data-reference=\"upButton\" class=\"b-icon b-spin-up\"></div>\n                    <div data-reference=\"downButton\" class=\"b-icon b-spin-down\"></div>\n                </div>");
    }
  }, {
    key: "updateRepeat",
    value: function updateRepeat(repeat) {
      var me = this;

      if (repeat) {
        me.clickRepeater = new _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_30__["default"](Object.assign({
          element: me.element
        }, repeat));
      } else if (me.clickrepeater) {
        me.clickRepeater.destroy();
        me.clickrepeater = null;
      }
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      var me = this,
          field = me.field;

      if (field.disabled || field.readOnly) {
        return;
      }

      if (e.target === me.upButton) {
        field.doSpinUp(e.shiftKey);
      } else if (e.target === me.downButton) {
        field.doSpinDown(e.shiftKey);
      }
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'SpinTrigger';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'spintrigger';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        repeat: true
      };
    }
  }]);

  return SpinTrigger;
}(Field.Trigger); // Register trigger widgets type with their Factory


Field.Trigger.initClass();
Field.SpinTrigger.initClass();
_Widget_js__WEBPACK_IMPORTED_MODULE_23__["default"].register(Field.Trigger, 'trigger');
_Widget_js__WEBPACK_IMPORTED_MODULE_23__["default"].register(Field.SpinTrigger, 'spintrigger');
Field._$name = 'Field';

/***/ }),

/***/ "./lib/Core/widget/FileField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/FileField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FileField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/widget/FileField
 */

/**
 * Filefield widget. Wraps native &lt;input type="file"&gt;.
 *
 * There is a nicer styled wrapper for this field, see {@link Core/widget/FilePicker}
 *
 * @extends Core/widget/Field
 * @example
 *
 * let fileField = new FileField({
 *   multiple : true,
 *   accept   : "image/*"
 * });
 *
 * @classType filefield
 * @externalexample widget/FileField.js
 */

var FileField = /*#__PURE__*/function (_Field) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(FileField, _Field);

  var _super = _createSuper(FileField);

  function FileField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, FileField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(FileField, [{
    key: "internalOnChange",
    value: function internalOnChange(event) {
      // Event order is not consistent across browsers:
      //
      //  Chrome/Firefox:             IE11:                       Edge:
      //      internalOnInput             internalOnChange            internalOnChange
      //      internalOnChange            internalOnInput
      //
      // The problem this creates is that the onChange logic expects value != lastValue which is ensured by the
      // onInput handler. In the IE11/Edge sequence, the first change event is ignored, but with a file input that
      // is the only one you get and so the component's change event does not fire. The user has to make a second
      // file selection to get the event to fire.
      //
      // Fortunately, the event sequence for a file input is simple, so we can just force that order here:
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(FileField.prototype), "internalOnInput", this).call(this, event);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(FileField.prototype), "internalOnChange", this).call(this, event);
    }
  }, {
    key: "internalOnInput",
    value: function internalOnInput() {// ignore -- see internalOnChange above
    }
  }, {
    key: "pickFile",

    /**
     * Opens browser file picker
     * @internal
     */
    value: function pickFile() {
      this.input.click();
    }
  }, {
    key: "clear",

    /**
     * Clears field value
     */
    value: function clear() {
      this.input.value = null;
    }
  }, {
    key: "triggerChange",
    value: function triggerChange(event) {
      this.triggerFieldChange({
        event: event,
        value: this.input.value,
        oldValue: this._lastValue,
        userAction: true,
        valid: true
      });
    }
  }, {
    key: "files",

    /**
     * Returns list of selected files
     * @returns {FileList}
     * @readonly
     */
    get: function get() {
      return this.input.files;
    }
  }, {
    key: "multiple",
    get: function get() {
      return this._multiple ? '' : null;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'FileField';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'filefield';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Set to true to allow picking multiple files. Note that when set to a truthy value,
         * the field is set to accept multiple files, but the value returned will be
         * an empty string since this is what is rendered into the HTML.
         * @config {Boolean}
         * @default
         */
        multiple: null,

        /**
         * Comma-separated list of file extensions or MIME type to to accept. E.g.
         * ".jpg,.png,.doc" or "image/*". Null by default, allowing all files.
         * @config {String}
         */
        accept: null,
        inputType: 'file',
        attributes: ['multiple', 'accept']
      };
    }
  }]);

  return FileField;
}(_Field_js__WEBPACK_IMPORTED_MODULE_9__["default"]); // Register this widget type with its Factory



FileField.initClass();
FileField._$name = 'FileField';

/***/ }),

/***/ "./lib/Core/widget/FilePicker.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/FilePicker.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FilePicker; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _FileField_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./FileField.js */ "./lib/Core/widget/FileField.js");

















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/widget/FilePicker
 */

/**
 * File input field wrapped into {@link Core/widget/Button button}. Clicking button opens browser file picker window.
 * When files are chosen, badge appears showing amount of files. Hovering the button shows tip with file names.
 *
 * By default only single file allowed.
 *
 * @extends Core/widget/Container
 * @example
 *
 * let fileField = new FilePicker({
 *   fileFieldConfig : {
 *      multiple : true,
 *      accept   : "image/*"
 *   },
 *   buttonConfig : {
 *       text : 'Pick file...'
 *   }
 * });
 *
 * @classType filepicker
 * @externalexample widget/FilePicker.js
 */

var FilePicker = /*#__PURE__*/function (_Container) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(FilePicker, _Container);

  var _super = _createSuper(FilePicker);

  function FilePicker() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, FilePicker);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(FilePicker, [{
    key: "construct",
    value: function construct() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this;
      config.items = [Object.assign({
        type: 'button',
        ref: 'fileButton',
        text: 'L{FilePicker.file}',
        localeClass: this
      }, config.buttonConfig), Object.assign({
        type: 'filefield',
        ref: 'fileField',
        style: 'display: none'
      }, config.fileFieldConfig)].concat(config.items || []);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(FilePicker.prototype), "construct", this).call(this, config);

      me.button.on({
        click: me.onButtonClick,
        thisObj: me
      });
      me.fileField.on({
        change: me.onFileFieldChange,
        thisObj: me
      });

      me._thisIsAUsedExpression(me.fileTip);
    }
  }, {
    key: "clear",

    /**
     * Clears field
     */
    value: function clear() {
      var me = this;
      me.fileField.clear();
      me.button.badge = '';
      me.trigger('clear');
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(_ref) {
      var event = _ref.event;
      var me = this; // forward click to the file input to open browser file picker
      // me.fileField.input.click();

      me.fileField.pickFile();
      event.preventDefault();
    }
  }, {
    key: "onFileFieldChange",
    value: function onFileFieldChange(_ref2) {
      var valid = _ref2.valid;
      var me = this;
      me.button.badge = me.files.length || '';
      me.triggerFieldChange({
        files: me.files,
        valid: valid
      });
    }
  }, {
    key: "button",
    get: function get() {
      return this.widgetMap.fileButton;
    }
  }, {
    key: "fileField",
    get: function get() {
      return this.widgetMap.fileField;
    }
    /**
     * List of selected files
     * @returns {FileList}
     * @readonly
     */

  }, {
    key: "files",
    get: function get() {
      return this.fileField.files;
    }
  }, {
    key: "fileTip",
    get: function get() {
      var me = this;
      return me._fileTip || (me._fileTip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_17__["default"]({
        cls: 'b-file-tip',
        forElement: me.button.element,
        showOnHover: true,
        align: 'b-t',
        scrollAction: 'realign',
        listeners: {
          beforeshow: function beforeshow() {
            var tip = this,
                files = me.files;

            if (files && files.length) {
              tip.html = "".concat(Array.from(files).map(function (file) {
                return file.name;
              }).join('<br>'));
              return true;
            } // Veto show


            return false;
          }
        }
      }));
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'FilePicker';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'filepicker';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The name of the property to set when a single value is to be applied to this FilePicker. Such as when used
         * in a grid WidgetColumn, this is the property to which the column's `field` is applied.
         * @config {String}
         * @default
         * @category Misc
         */
        defaultBindProperty: 'value',

        /**
         * Fires after user closes file picker dialog.
         * @event change
         * @param {FileList} files List of picked files
         */

        /**
         * Fires when field is cleared with {@link #function-clear} method
         * @event clear
         */

        /**
         * Wrapper button config object. See {@link Core/widget/Button} for list of available configs.
         * @config {Object}
         */
        buttonConfig: null,

        /**
         * Underlying field config object. See {@link Core/widget/FileField} for list of available configs.
         * @config {Object}
         */
        fileFieldConfig: null
      };
    }
  }]);

  return FilePicker;
}(_Container_js__WEBPACK_IMPORTED_MODULE_16__["default"]); // Register this widget type with its Factory



FilePicker.initClass();
FilePicker._$name = 'FilePicker';

/***/ }),

/***/ "./lib/Core/widget/FilterField.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/FilterField.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FilterField; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/widget/FilterField
 */

/**
 * A simple text field for filtering a store.
 *
 * Allows filtering by {@link #config-field field}:
 *
 * ```javascript
 * const filterField = new FilterField({
 *    store : eventStore,
 *    field : 'name'
 * });
 * ```
 *
 * Or by using a {@link #config-filterFunction filter function} for greater control/custom logic:
 *
 * ```javascript
 * const filterField = new FilterField({
 *    store          : eventStore,
 *    filterFunction : (record, value) => record.name.includes(value)
 * });
 * ```
 *
 * @extends Core/widget/TextField
 * @classType filterfield
 */

var FilterField = /*#__PURE__*/function (_TextField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(FilterField, _TextField);

  var _super = _createSuper(FilterField);

  function FilterField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, FilterField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(FilterField, null, [{
    key: "$name",
    get: function get() {
      return 'FilterField';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'filterfield';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * The model field name to filter by. Can optionally be replaced by {@link #config-filterFunction}
         * @config {String}
         * @category Filtering
         */
        field: null,

        /**
         * The store to filter.
         * @config {Core.data.Store}
         * @category Filtering
         */
        store: null,

        /**
         * Optional filter function to be called with record and value as parameters for store filtering.
         * ```javascript
         * {
         *     type           : 'filterfield',
         *     store          : myStore,
         *     filterFunction : (record, value)  => {
         *        return record.text.includes(value);
         *     }
         * }
         * ```
         * @param {Core.data.Model} record Record for comparison
         * @param {String} value Value to compare with
         * @return {Boolean} Return true if record matches comparison requirements
         * @config {Function}
         * @category Filtering
         */
        filterFunction: null,
        clearable: true,
        keyStrokeChangeDelay: 100,
        onChange: function onChange(_ref) {
          var value = _ref.value;
          var store = this.store,
              field = this.field,
              filterFunction = this.filterFunction;

          if (store) {
            var filterId = "".concat(field || this.id, "-Filter");

            if (value.length === 0) {
              store.removeFilter(filterId);
            } else {
              var filterBy;

              if (filterFunction) {
                filterBy = function filterBy(record) {
                  return filterFunction(record, value);
                };
              } else {
                // We filter using a RegExp, so quote significant characters
                value = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

                filterBy = function filterBy(record) {
                  return record.get(field).match(new RegExp(value, 'i'));
                };
              } // A filter with an id replaces any previous filter with that id.
              // Leave any other filters which may be in use in place.


              store.filter({
                id: filterId,
                filterBy: filterBy
              });
            }
          }
        }
      };
    }
  }]);

  return FilterField;
}(_Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


;
FilterField.initClass();
FilterField._$name = 'FilterField';

/***/ }),

/***/ "./lib/Core/widget/List.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/List.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return List; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _data_Store_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../helper/util/Navigator.js */ "./lib/Core/helper/util/Navigator.js");




























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _templateObject2() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_19___default()(["<div class=\"", "\" data-index=\"", "\" data-id=\"", "\" ", ">\n            ", "\n            </div>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_19___default()(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_25___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Core/widget/List
 */

var itemRange = document.createRange();
/**
 * Displays a list of items which the user can navigate using the keyboard and select using either pointer gestures or the keyboard.
 * @extends Core/widget/Widget
 *
 * @classType list
 * @externalexample widget/List.js
 */

var List = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_24___default()(List, _Widget);

  var _super = _createSuper(List);

  function List() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default()(this, List);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(List, [{
    key: "construct",
    //endregion
    //region Events

    /**
     * User activated an item in the list either by pointer or keyboard.
     * The active record, list item index, and the triggering event are passed.
     * @event item
     * @property {Object} record - Activated record
     * @property {Number} index - List item index
     * @property {Event} event - Triggering event
     */
    //endregion
    value: function construct(config) {
      var _get2;

      var me = this; // We can be created from a raw array. It becomes our items which we translate to a Store.

      if (Array.isArray(config)) {
        config = {
          items: config
        };
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_23___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(List.prototype), "construct", this)).call.apply(_get2, [this, config].concat(args));

      var element = me.element,
          classList = element.classList;

      if (me.multiSelect) {
        classList.add('b-multiselect');
      }

      if (me.store && me.store.count) {
        me.refresh();
      } else {
        classList.add('b-empty');
      }

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].on({
        element: element,
        delegate: me.itemSelector,
        mouseover: 'onMouseOver',
        click: 'onClick',
        thisObj: me
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$navigator;

      this.detachListeners('store');
      (_this$navigator = this.navigator) === null || _this$navigator === void 0 ? void 0 : _this$navigator.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_23___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(List.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      var listItem = e._target.classList.contains(this.itemCls) ? e._target.dataset.id : 0;
      this.restoreActiveItem(this.navigator.previousActiveItem || this.getItem(listItem));

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_23___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(List.prototype), "onFocusIn", this).call(this, e);
    }
  }, {
    key: "contentTpl",
    value: function contentTpl() {
      var _this = this;

      return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].tpl(_templateObject(), this.store.records.map(function (record, i) {
        return _this.itemWrapperTpl(record, i);
      }));
    }
  }, {
    key: "itemWrapperTpl",
    value: function itemWrapperTpl(record, i) {
      return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].tpl(_templateObject2(), this.getItemClasses(record, i), i, record.id, this.itemsFocusable ? 'tabindex="-1"' : '', this.itemContentTpl(record, i));
    }
  }, {
    key: "itemContentTpl",
    value: function itemContentTpl(record, i) {
      return "".concat(this.itemIconTpl(record, i)).concat(this.itemTpl(record, i));
    }
  }, {
    key: "itemIconTpl",
    value: function itemIconTpl(record, i) {
      return this.multiSelect ? "<div class=\"b-selected-icon b-icon ".concat(this.selectIconCls, "\"></div>") : '';
    }
  }, {
    key: "getItemClasses",
    value: function getItemClasses(record) {
      var _me$_navigator;

      var me = this,
          activeItem = (_me$_navigator = me._navigator) === null || _me$_navigator === void 0 ? void 0 : _me$_navigator.activeItem,
          isActive = (activeItem === null || activeItem === void 0 ? void 0 : activeItem.dataset.id) == record.id,
          isSelected = me.selected.includes(record);
      return "".concat(me.itemCls, " ").concat(record.cls || '', " ").concat(isSelected ? me.selectedCls : '', " ").concat(isActive ? me.navigator.focusCls : '');
    }
  }, {
    key: "onBeforeStoreLoad",
    value: function onBeforeStoreLoad() {
      this.mask(this.L('L{loading}'));
    }
  }, {
    key: "onAfterStoreRequest",
    value: function onAfterStoreRequest() {
      this.unmask();
    }
  }, {
    key: "onStoreChange",
    value: function onStoreChange(_ref) {
      var store = _ref.source,
          action = _ref.action,
          records = _ref.records,
          record = _ref.record;

      switch (action) {
        case 'remove':
          this.selected.remove(records);
          break;

        case 'clear':
          this.selected.clear();
          break;

        case 'update':
          this.refreshItem(record);
          return;
      }

      this.refresh();
    }
  }, {
    key: "onStoreRefresh",
    value: function onStoreRefresh() {
      this.refresh();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var me = this;

      if (me.isVisible) {
        var activeItem = me.navigator.activeItem; // Ensure that the next call to refresh when not visible queues a refresh

        me.paintListener = null;
        me.clearItems().insertNode(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].createElementFromTemplate(me.contentTpl(), {
          fragment: true
        })); // The item elements will be all new, so restore the active item.
        // Navigator will reacquire it by its id.

        if (activeItem) {
          me.restoreActiveItem(activeItem);
        }

        me.refreshCount = (me.refreshCount || 0) + 1;
        me.element.classList[me.store.count > 0 ? 'remove' : 'add']('b-empty');
      } // Only queue a refresh if not already queued
      else if (!me.paintListener) {
          me.paintListener = me.on({
            paint: 'refresh',
            thisObj: me,
            once: true
          });
        }
    }
  }, {
    key: "clearItems",
    value: function clearItems() {
      var me = this,
          firstItem = me.contentElement.querySelector(me.itemSelector),
          lastChild = me.contentElement.lastChild;

      if (firstItem) {
        // Can't use :last-of-type when other elements of same type may be present.
        // Have to pluck the last element of the NodeList.
        var items = me.contentElement.querySelectorAll("".concat(me.itemSelector, ":not(.b-mask)"));
        itemRange.setStartBefore(firstItem);
        itemRange.setEndAfter(items[items.length - 1]);
        itemRange.deleteContents();
      } else {
        // Allow a static set of elements to be at the top of the list
        if (lastChild) {
          itemRange.setStartAfter(lastChild);
          itemRange.setEndAfter(lastChild);
        } else {
          itemRange.setStart(me.contentElement, 0);
          itemRange.setEnd(me.contentElement, 0);
        }
      }

      return itemRange;
    }
  }, {
    key: "refreshItem",
    value: function refreshItem() {
      for (var _len2 = arguments.length, records = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        records[_key2] = arguments[_key2];
      }

      for (var _i = 0, _records = records; _i < _records.length; _i++) {
        var record = _records[_i];
        var item = this.getItem(record); // Maybe a record which is filtered out announces a change.
        // There will be no item.

        if (item) {
          var index = this.store.indexOf(record),
              newItem = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].createElementFromTemplate(this.itemWrapperTpl(record, index));
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].sync(newItem, item);
        }
      }
    }
  }, {
    key: "getItem",
    value: function getItem(recordOrId) {
      // Cannot use truthiness test because index zero may be passed.
      if (recordOrId != null) {
        if (typeof recordOrId === 'number') {
          return this.contentElement.querySelector("[data-index=\"".concat(recordOrId, "\"]"));
        } else if (recordOrId.nodeType === 1) {
          recordOrId = recordOrId.dataset.id;
        }

        if (recordOrId.id != null) {
          recordOrId = recordOrId.id;
        }

        return this.contentElement.querySelector("[data-id=\"".concat(recordOrId, "\"]"));
      }
    }
  }, {
    key: "getRecord",
    value: function getRecord(dom) {
      if (dom.target) {
        dom = dom.target;
      }

      dom = dom.closest(this.itemSelector);
      return this.store.getAt(parseInt(dom.dataset.index));
    } //region getters/setters

    /**
     * May be *set* as an array of Objects which are converted into records and used to create this
     * List's {@link #config-store}
     * @property {Object[]}
     */

  }, {
    key: "updateItems",
    value: function updateItems(items) {
      var me = this;

      if (me.store && me.store.autoCreated) {
        me.store.destroy();
      }

      me.store = _data_Store_js__WEBPACK_IMPORTED_MODULE_28__["default"].getStore(items);
    }
  }, {
    key: "updateSelected",
    value: function updateSelected(selected) {
      if (!(selected && selected instanceof _util_Collection_js__WEBPACK_IMPORTED_MODULE_32__["default"])) {
        selected = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_32__["default"](selected);
      }

      this._selected = selected;
      selected.on({
        change: 'onSelectionChange',
        thisObj: this
      });
    }
  }, {
    key: "changeStore",
    value: function changeStore(store) {
      var me = this;

      if (!(store instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_28__["default"])) {
        store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_28__["default"](store);
      }

      me.detachListeners('store');

      if (store) {
        var storeListeners = {
          name: 'store',
          change: 'onStoreChange',
          refresh: 'onStoreRefresh',
          thisObj: me
        };

        if (store.readUrl) {
          storeListeners.beforeLoad = 'onBeforeStoreLoad';
          storeListeners.afterRequest = 'onAfterStoreRequest';
        }

        store.on(storeListeners);
      }

      return store;
    }
  }, {
    key: "updateStore",
    value: function updateStore() {
      this.refresh();
    }
  }, {
    key: "changeNavigator",
    value: function changeNavigator(navigator) {
      var me = this,
          element = me.element;

      if (element) {
        navigator = new (navigator.class || _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_33__["default"])(Object.assign({
          ownerCmp: me,
          target: element,
          keyEventTarget: element
        }, navigator)); // This widget is responsible for relaying keyboard events into the navigator
        // So it must be able to receive focus.

        if (navigator.keyEventTarget === element) {
          element.tabIndex = 0;
        }
      }

      return navigator;
    }
  }, {
    key: "alignTo",
    //endregion
    //region Hide/Show
    value: function alignTo() {
      var _get3;

      // When aligning, if the items total height is less than minHeight, use that.
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(List.prototype), "minHeight", this.minAlignHeight, this, true);

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (_get3 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_23___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(List.prototype), "alignTo", this)).call.apply(_get3, [this].concat(args));
    }
  }, {
    key: "hide",
    value: function hide() {
      var _get4;

      this.navigator.activeItem = null;

      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      (_get4 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_23___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(List.prototype), "hide", this)).call.apply(_get4, [this].concat(args));
    }
  }, {
    key: "show",
    value: function show() {
      var refreshCount = this.refreshCount,
          previousActiveItem = this.navigator.previousActiveItem; // Restore the configured minHeight

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(List.prototype), "minHeight", this._minHeight, this, true);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_23___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_26___default()(List.prototype), "show", this).call(this); // If no refresh on paint took place, we need to restore the activeItem.
      // Refresh does that itself.


      if (this.refreshCount === refreshCount) {
        this.restoreActiveItem(previousActiveItem, true);
      }
    }
    /**
     * Sets the passed record as the current focused record for keyboard navigation and selection purposes.
     * @param {Core.data.Model} activeItem The item to highlight as the active ("focused") item.
     * @param {String|boolean} [block='nearest'] The block scroll specification to scroll
     * the item into view. Defaults to `'nearest'` which means a minimal scroll, only if
     * the item is actually out of view. Passing `true` is for when the List is aligned
     * to a picker and the selected item should be scrolled to be close to the picker,
     * however that is aligned. See `Combo.showPicker` for usage.
     * @internal
     */

  }, {
    key: "restoreActiveItem",
    value: function restoreActiveItem() {
      var activeItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.navigator.previousActiveItem;
      var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'nearest';
      var me = this,
          navigator = me.navigator,
          lastAlignSpec = me.lastAlignSpec; // Zero may be passed to select first item, so cannot use thruthiness.
      // This won't mean *clear* the active item if any. Falsy means
      // nothing to restore so leave it as is.

      if (activeItem != null) {
        if (typeof block !== 'string') {
          var alignZone = lastAlignSpec ? lastAlignSpec.zone : 1; // Scroll item into view appropriately, meaning closest to any align target.
          // Align zones are T,R,B,L => 0,1,2,3
          // If 1 or 3 (right or left), align nearest.
          // if 0 (above) align end.
          // else, we're below so align start.

          block = alignZone & 1 ? 'nearest' : alignZone ? 'start' : 'end';
        }

        activeItem = me.getItem(activeItem);

        if (activeItem) {
          // If we are aligned to a target, first, scroll the required item to the optimal
          // position to avoid Navigator's default minimal scroll to block: 'nearest'.
          // If we are aligned below a combo, move the point of interest to the top.
          // If we are aligned above a combo, move the point of interest to the bottom.
          me.scrollable.scrollIntoView(activeItem, {
            block: block
          });
          navigator.activeItem = activeItem;
        }
      }
    } //endregion
    //region Events

    /**
     * Focuses list items on hover.
     * @private
     */

  }, {
    key: "onMouseOver",
    value: function onMouseOver(event) {
      var me = this,
          itemElement = event.currentTarget; // Activate soon in case they're moving fast over items.

      if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].isTouchEvent && itemElement && me.navigator && me.activateOnMouseover) {
        me.setTimeout({
          fn: 'handleMouseOver',
          delay: 30,
          args: [itemElement],
          cancelOutstanding: true
        });
      }
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(itemElement) {
      this.navigator.activeItem = itemElement;
    }
    /**
     * Selects list items on click.
     * @private
     */

  }, {
    key: "onClick",
    value: function onClick(event) {
      var itemElement = event.target.closest(this.itemSelector);

      if (itemElement) {
        this.onItemClick(itemElement, event);
      }
    }
    /**
     * Key events which are not navigation are delegated up to here by the Navigator
     * @private
     */

  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(event) {
      var me = this,
          active = me.navigator.activeItem;

      switch (event.key) {
        case ' ':
          // If it's an input field that's providing events, allow it to process space.
          // Otherwise, it falls through and is processed the same as ENTER to make a click.
          if (event.target.nodeName.toUpperCase() === 'INPUT' && !event.target.readOnly) {
            break; // eslint-disable-line
          }

        case 'Enter':
          // eslint-disable-line
          if (active) {
            this.onItemClick(active, event); // Stop the keydown from bubbling.
            // And stop it from creating a keypress event.
            // No further action should be taken after item selection.

            event.stopImmediatePropagation();
            event.preventDefault();
          }

      }
    } //endregion

  }, {
    key: "onItemClick",
    value: function onItemClick(item, event) {
      var me = this,
          index = parseInt(item.dataset.index);
      var record = me.store.getAt(index);
      me._isUserAction = true;
      me.trigger('item', {
        item: item,
        record: record,
        index: index,
        event: event,
        userAction: true
      }); // Clicking on any element with the data-noselect attribute means no selection

      if (!item.contains(event.target.closest('[data-noselect]'))) {
        var selected = me.selected,
            isSelected = selected.includes(record);

        if (me.multiSelect) {
          if (me.toggleAllIfCtrlPressed && event.ctrlKey) {
            record = me.store.getRange();
          }

          selected[isSelected ? 'remove' : 'add'](record);
        } else {
          selected.splice(0, selected.count, record);
        }
      }

      me.lastClicked = record;
      me._isUserAction = false;
    }
    /**
     * Handles items being added or removed from the selected Collection
     * @param {Object} changeEvent
     * @private
     */

  }, {
    key: "onSelectionChange",
    value: function onSelectionChange(_ref2) {
      var action = _ref2.action,
          removed = _ref2.removed,
          added = _ref2.added,
          replaced = _ref2.replaced;
      var me = this,
          selectedCls = me.selectedCls,
          unselectedCls = me.unselectedCls;
      var record, item;

      if (action === 'clear') {
        var _iterator = _createForOfIteratorHelper(me.element.querySelectorAll(".".concat(selectedCls))),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            item = _step.value;
            item.classList.remove(selectedCls);
            unselectedCls && item.classList.remove(unselectedCls);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _iterator2 = _createForOfIteratorHelper(removed),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            record = _step2.value;
            item = me.getItem(record);
            item && item.classList.remove(selectedCls);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var _iterator3 = _createForOfIteratorHelper(added),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            record = _step3.value;
            item = me.getItem(record);
            item && item.classList.add(selectedCls);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  }, {
    key: "itemSelector",
    get: function get() {
      return ".".concat(this.itemCls);
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selected;
    }
    /**
     * Get the backing store, a {@link Core.data.Store} holding the records used to generate list items
     * @property {Core.data.Store}
     * @readonly
     */

  }, {
    key: "store",
    get: function get() {
      // Ensure any configured items is processed into a store before we try to return it.
      this._thisIsAUsedExpression(this.items);

      return this._store;
    }
  }, {
    key: "minAlignHeight",
    get: function get() {
      var lastItem = this.element.lastElementChild,
          minHeight = this.minHeight; // No minHeight specified, always defer to the items height

      if (minHeight != null) {
        return this.store.count ? Math.min(lastItem.offsetTop + lastItem.offsetHeight, minHeight) : 0;
      }
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'List';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'list';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        itemCls: 'b-list-item',
        selectedCls: 'b-selected',
        selectIconCls: 'b-icon-check',

        /**
         * An array of Objects which are converted into records and used to create this
         * List's {@link #config-store}
         * @config {Object[]}
         */
        items: null,

        /**
         * A {@link Core.data.Store} which provides the records which map to List items. Each record is passed through the
         * {@link #config-itemTpl} to produce the DOM structure of the List. May be generated from an array of {@link #config-items}.
         * @config {Object|Core.data.Store}
         */
        store: null,
        navigator: true,
        scrollable: {
          x: false,
          y: true
        },
        itemsFocusable: true,
        multiSelect: false,
        // If Cmd/Ctrl is pressed when clicking, toggle selected state for all items
        toggleAllIfCtrlPressed: false,

        /**
         * Template function which, when passed a record, returns the textual HTML for that item. Defaults to a
         * function returning the value of records `text` field
         * @config {Function} itemTpl
         */
        itemTpl: function itemTpl(record) {
          return record.text;
        },

        /**
         * A {@link Core.util.Collection Collection}, or Collection config object
         * to use to contain this List's selected records.
         * @config {Core.util.Collection|Object}
         */
        selected: {},

        /**
         * Configure as `true` to activate items on mouseover. This is used by the Combo
         * field when using a List as its dropdown.
         * @config {Boolean}
         */
        activateOnMouseover: null
      };
    }
  }]);

  return List;
}(_Widget_js__WEBPACK_IMPORTED_MODULE_27__["default"]); // Register this widget type with its Factory



List.initClass();
List.prototype.navigatorClass = _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_33__["default"];
List._$name = 'List';

/***/ }),

/***/ "./lib/Core/widget/Mask.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/Mask.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Mask; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../helper/util/Promissory.js */ "./lib/Core/helper/util/Promissory.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Renderable_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Renderable.js */ "./lib/Core/widget/Renderable.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




 //TODO: add loader

/**
 * @module Core/widget/Mask
 */

/**
 * Masks a target element (document.body if none is specified). Call static methods for ease of use or make instance
 * for reusability.
 *
 * @example
 * Mask.mask('hello');
 * Mask.unmask();
 *
 * @externalexample widget/Mask.js
 *
  * @example
 * // Using progress by calling static method
 * let mask = Mask.mask({
 *   text:'The task is in progress',
 *   progress: 0,
 *   maxProgress: 100
 * }, document.body);
 * let timer = setInterval(()=>{
 *   mask.progress += 5;
 *   if(mask.progress >= mask.maxProgress) {
 *     Mask.unmask();
 *     clearInterval(timer)
 *   }
 * },100)
 *
 * @example
 * // Using progress to mask a Bryntum component
 * scheduler.mask({
 *  text:'Loading in progress',
 *   progress: 0,
 *   maxProgress: 100
 * })
 * let timer = setInterval(()=>{
 *   scheduler.masked.progress += 5;
 *   if(scheduler.masked.progress >= scheduler.masked.maxProgress) {
 *     scheduler.unmask();
 *     clearInterval(timer)
 *   }
 * },100)
 *
 */

var Mask = /*#__PURE__*/function (_Renderable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(Mask, _Renderable);

  var _super = _createSuper(Mask);

  function Mask() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, Mask);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(Mask, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(config) {
      if (config) {
        var el = config.element,
            cfg; // Upgrade config -> cfg
        // Treat config as readonly, cfg is lazily copied and writable

        if (el) {
          _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].deprecate('Core', '4.0.0', 'Mask "element" config has been renamed to "target"');
          config = cfg = Object.assign({}, config);
          delete cfg.element;
          cfg.target = el;
        }

        el = config.target;

        if (typeof el === 'string') {
          config = cfg = cfg || Object.assign({}, config);
          cfg.target = config.owner[el]; // must supply "owner" in this case
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Mask.prototype), "construct", this).call(this, config);

      if (!this.target) {
        this.target = document.body;
      }

      this.show();
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this,
          element = me.element;

      if (element) {
        me.element = null;

        if (me.mode.endsWith('blur')) {
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].forEachChild(element, function (child) {
            child.classList.remove("b-masked-".concat(me.mode));
          });
        }

        me.target.classList.remove('b-masked');
        me.target[me.maskName] = null;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Mask.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "renderDom",
    value: function renderDom() {
      var _class;

      var me = this,
          maxProgress = me.maxProgress;
      return {
        class: (_class = {
          'b-mask': 1,
          'b-delayed-show': me.showDelay,
          'b-widget': 1
        }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_class, "b-mask-".concat(me.mode), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_class, 'b-progress', maxProgress), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_class, 'b-prevent-transitions', !me.useTransition), _class),
        children: [{
          reference: 'maskContent',
          class: 'b-mask-content b-drawable',
          children: [maxProgress ? {
            reference: 'progressElement',
            class: 'b-mask-progress-bar',
            style: {
              width: "".concat(Math.max(0, Math.min(100, Math.round(me.progress / maxProgress * 100))), "%")
            }
          } : null, {
            reference: 'maskText',
            class: 'b-mask-text',
            html: (me.icon ? "<i class=\"b-mask-icon ".concat(me.icon, "\"></i>") : '') + me.text
          }]
        }]
      };
    } //endregion
    //region Static

  }, {
    key: "updateAutoClose",
    //endregion
    //region Config
    value: function updateAutoClose(delay) {
      var me = this;
      me.deferredClose.cancel();

      if (delay) {
        me.deferredClose.delay = delay;
        me.deferredClose();
      }
    }
  }, {
    key: "updateCover",
    value: function updateCover() {
      var owner = this.owner;

      if (owner && owner.syncMaskCover) {
        owner.syncMaskCover(this);
      }
    }
  }, {
    key: "updateShowDelay",
    value: function updateShowDelay(delay) {
      var delayedShow = this.delayedShow;
      delayedShow.delay = delay;

      if (!delay) {
        delayedShow.flush();
      }
    } //endregion
    //region Show & hide

  }, {
    key: "deferredClose",
    value: function deferredClose() {
      var _this = this;

      var owner = this.owner;
      this.close().then(function () {
        if (owner && owner.onMaskAutoClose) {
          owner.onMaskAutoClose(_this);
        }
      });

      if (owner && owner.onMaskAutoClosing) {
        owner.onMaskAutoClosing(this);
      }
    }
  }, {
    key: "delayedShow",
    value: function delayedShow() {
      this.classes.remove('b-delayed-show');
    }
    /**
     * Show mask
     */

  }, {
    key: "show",
    value: function show() {
      var me = this,
          element = me.element,
          target = me.target,
          hiding = me.hiding,
          maskName = me.maskName; // We don't do this because we may want to show but automatically close after a
      // brief delay. The order of applying those configs should not be an issue. In
      // other words, to stop the deferredClose, you must set autoClose to falsy.
      // me.deferredClose.cancel();

      if (hiding) {
        // Resolving seems much better than the only other options:
        //  1. Never settling
        //  2. Rejecting
        hiding.resolve(); // This will be nulled out as the promise resolves but that is a race condition
        // compared to the next hide() call.

        me.hiding = null;
        me.clearTimeout('hide');
      }

      if (me.showDelay) {
        element.classList.add('b-delayed-show');
        me.delayedShow();
      }

      element.classList.add('b-visible');
      element.classList.remove('b-hidden');
      target.classList.add('b-masked');

      if (!target[maskName]) {
        target[maskName] = me;
        target.appendChild(element);
      }

      me.shown = true; // blur has to blur child elements

      if (me.mode.endsWith('blur')) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].forEachChild(target, function (child) {
          if (child !== element) {
            child.classList.add("b-masked-".concat(me.mode));
          }
        });
      }
    }
    /**
     * Hide mask
     * @returns {Promise} A promise which is resolved when the mask is hidden, or immediately if already hidden
     */

  }, {
    key: "hide",
    value: function hide() {
      var me = this,
          target = me.target,
          element = me.element;
      var hiding = me.hiding;

      if (!hiding) {
        if (!me.shown) {
          return Promise.resolve();
        }

        me.hiding = hiding = new _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_15__["default"]();
        me.shown = false;
        element.classList.remove('b-visible');
        element.classList.add('b-hidden');
        target.classList.remove('b-masked');

        if (me.mode.endsWith('blur')) {
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].forEachChild(target, function (child) {
            if (child !== element) {
              child.classList.remove("b-masked-".concat(me.mode));
            }
          });
        }

        hiding.promise = hiding.promise.then(function () {
          if (me.hiding === hiding) {
            me.hiding = null;
          }
        }); // TODO: use AnimationHelper when available

        me.setTimeout(function () {
          return hiding.resolve();
        }, 500, 'hide');
      }

      return hiding.promise;
    }
    /**
     * Close mask (removes it)
     * @returns {Promise} A promise which is resolved when the mask is closed
     */

  }, {
    key: "close",
    value: function close() {
      var _this2 = this;

      return this.hide().then(function () {
        _this2.destroy();
      });
    } //endregion

  }, {
    key: "maskElement",
    get: function get() {
      // TODO log on use of deprecated property?
      return this.element;
    }
  }, {
    key: "maskName",
    get: function get() {
      var type = this.type;
      return "mask".concat(typeof type === 'string' ? type.trim() : '');
    }
  }, {
    key: "error",
    set: function set(value) {
      this.setConfig(this.errorDefaults);
      this.text = value;
    }
  }], [{
    key: "mergeConfigs",
    value: function mergeConfigs() {
      var ret = {};

      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
        var src = _sources[_i];

        if (typeof src === 'string') {
          ret.text = src;
        } else {
          _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].assign(ret, src); // not Object.assign!
        }
      }

      return ret;
    }
    /**
     * Shows a mask with the specified message
     * @param {String|Object} text Message
     * @param {HTMLElement} target The element to mask
     * @returns {Core.widget.Mask}
     */

  }, {
    key: "mask",
    value: function mask(text) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
      return new Mask(typeof text !== 'string' ? Object.assign({
        target: target
      }, text) : {
        target: target,
        text: text
      });
    }
    /**
     * Unmask
     * @param {HTMLElement} element Element to unmask
     * @returns {Promise} A promise which is resolved when the mask is gone
     */

  }, {
    key: "unmask",
    value: function unmask() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
      return element.mask && element.mask.close();
    }
  }, {
    key: "$name",
    //region Config
    get: function get() {
      return 'Mask';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'mask';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Set this config to trigger an automatic close after the desired delay:
         * ```
         *  mask.autoClose = 2000;
         * ```
         * If the mask has an `owner`, its `onMaskAutoClosing` method is called when the close starts and its
         * `onMaskAutoClose` method is called when the close finishes.
         * @config {Number}
         * @private
         */
        autoClose: null,

        /**
         * The portion of the {@link #config-target} element to be covered by this mask. By default, the mask fully
         * covers the `target`. In some cases, however, it may be desired to only cover the `'body'` (for example,
         * in a grid).
         *
         * This config is set in conjunction with `owner` which implements the method `syncMaskCover`.
         *
         * @config {String}
         * @private
         */
        cover: null,

        /**
         * The icon to show next to the text. Defaults to showing a spinner
         * @config {String}
         * @default
         */
        icon: 'b-icon b-icon-spinner',
        errorDefaults: {
          icon: 'b-icon b-icon-warning',
          autoClose: 3000,
          showDelay: 0
        },

        /**
         * The maximum value of the progress indicator
         * @property {Number}
         */
        maxProgress: null,

        /**
         * Mode: bright, bright-blur, dark or dark-blur
         * @config {String}
         * @default
         */
        mode: 'dark',

        /**
         * Number expressing the progress
         * @property {Number}
         */
        progress: null,
        // The owner is involved in the following features:
        //
        // - The `autoClose` timer calls `onMaskAutoClose`.
        // - The `cover` config calls `syncMaskCover`.
        // - If the `target` is a string, that string names the property of the `owner` that holds the
        //   `HTMLElement` reference.

        /**
         * The owning widget of this mask. This is required if `target` is a string.
         *
         * @config {Object|Core.widget.Widget}
         */
        owner: null,

        /**
         * The element to be masked. If this config is a string, that string is the name of the property of the
         * `owner` that holds the `HTMLElement` that is the actual target of the mask.
         *
         * NOTE: In prior releases, this used to be specified as the `element` config, but that is now, as with
         * `Widget`, the primary element of the mask.
         *
         * @config {String|HTMLElement}
         */
        target: null,

        /**
         * The text (or HTML) to show in mask
         * @config {String}
         */
        text: null,
        // TODO - perhaps a better way to deal w/multiple reasons to mask something would be a mask FIFO behind
        //  the scenes so that only one mask is visible at a time. That would take a bit of tinkering in the
        //  hide/show mechanism but feels like a more natural way to go. In which case, this config would go away
        //  and multiple masks would simply cooperate. https://github.com/bryntum/support/issues/190
        type: null,

        /**
         * The number of milliseconds to delay before making the mask visible. If set, the mask will have an
         * initial `opacity` of 0 but will function in all other ways as a normal mask. Setting this delay can
         * reduce flicker in cases where load operations are typically short (for example, a second or less).
         *
         * @config {Number}
         */
        showDelay: null,
        useTransition: false
      };
    }
  }, {
    key: "delayable",
    get: function get() {
      return {
        deferredClose: 0,
        delayedShow: 0
      };
    }
  }]);

  return Mask;
}(_Renderable_js__WEBPACK_IMPORTED_MODULE_18__["default"]);


Mask._$name = 'Mask';

/***/ }),

/***/ "./lib/Core/widget/Menu.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/Menu.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Menu; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _MenuItem_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./MenuItem.js */ "./lib/Core/widget/MenuItem.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





var validKeys = {
  ArrowUp: 1,
  ArrowDown: 1,
  ArrowRight: 1,
  ArrowLeft: 1,
  Enter: 1,
  Escape: 1
};
/**
 * @module Core/widget/Menu
 */

/**
 * Menu widget, displays a list of items which the user can select from using mouse or keyboard. Can have submenus.
 *
 * @example
 * let menu = new Menu({
 *     forElement : btn.element,
 *     items      : [
 *         {
 *             icon : 'b-icon b-icon-add',
 *             text : 'Add'
 *         },
 *         {
 *             icon : 'b-icon b-icon-trash',
 *             text : 'Remove'
 *         },
 *         {
 *             icon     : 'b-icon b-icon-lock',
 *             disabled : true,
 *             text     : 'I am disabled'
 *         },
 *         {
 *             text : 'Sub menu',
 *             menu : [{
 *                 icon : 'b-icon b-fa-play',
 *                 text : 'Play'
 *             }]
 *         }
 *     ],
 *     // Method is called for all ancestor levels
 *     onItem({ item }) {
 *         Toast.show('You clicked ' + item.text);
 *     }
 * });
 *
 * @classType menu
 * @externalexample widget/Menu.js
 *
 * @extends Core/widget/Popup
 */

var Menu = /*#__PURE__*/function (_Popup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Menu, _Popup);

  var _super = _createSuper(Menu);

  function Menu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Menu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Menu, [{
    key: "construct",
    //endregion

    /**
     * A descendant menu item has been activated.
     *
     * Note that this event bubbles up through parents and can be
     * listened for on a top level {@link Core.widget.Menu Menu} for convenience.
     * @event item
     * @param {Core.widget.MenuItem} item - The menu item which is being actioned.
     * @param {Core.widget.Menu} menu - Menu containing the menu item
     */

    /**
     * The checked state of a descendant menu item has changed.
     *
     * Note that this event bubbles up through parents and can be
     * listened for on a top level {@link Core.widget.Menu Menu} for convenience.
     * @event toggle
     * @param {Core.widget.MenuItem} item - The menu item whose checked state changed.
     * @param {Core.widget.Menu} menu - Menu containing the menu item
     * @param {Boolean} checked - The _new_ checked state.
     */
    //region Init
    value: function construct(config) {
      if (Array.isArray(config)) {
        config = {
          lazyItems: config
        };
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Menu.prototype), "construct", this).call(this, config);

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on({
        element: this.element,
        click: 'onMouseClick',
        mouseover: 'onMouseOver',
        mouseleave: 'onMouseLeave',
        thisObj: this
      });
    }
  }, {
    key: "afterShow",
    value: function afterShow(resolveFn) {
      // Don't instantiate all our items' subMenus right now.
      // Use our private _menu property which will still be a config item.
      var hasSubmenu = this.items.some(function (item) {
        return Boolean(item._menu);
      }); // afterShow is called before alignment, so this is the correct time
      // to mutate things which will change this Widget's size.

      if (hasSubmenu) {
        this.element.classList.add('b-menu-with-submenu');
      } // Add CSS class to menu if any item has an icon, to allow aligning icon-less items


      var hasIcon = this.items.some(function (item) {
        return item.icon;
      });

      if (hasIcon) {
        this.element.classList.add('b-menu-with-icon');
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Menu.prototype), "afterShow", this).call(this, resolveFn);
    }
  }, {
    key: "createWidget",
    value: function createWidget(item) {
      if (typeof item === 'string') {
        item = {
          text: item
        };
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Menu.prototype), "createWidget", this).call(this, item);
    }
  }, {
    key: "onDocumentMouseDown",
    //endregion
    value: function onDocumentMouseDown(event) {
      // It's not a click outside if its a click on our owner Menu
      if (!this.parentMenu || !this.parentMenu.owns(event.event.target)) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Menu.prototype), "onDocumentMouseDown", this).call(this, event);
      }
    } //region Show

  }, {
    key: "hide",
    value: function hide(animate) {
      // We need to be _hidden when any focused descendants try to revertFocus
      // so that they continue to fall back through the getFocusRevertTarget upward chain.
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Menu.prototype), "hide", this).call(this, animate);

      if (this.currentSubMenu && !this.currentSubMenu.isDestroyed) {
        this.currentSubMenu.hide(animate);
      }

      if (this.parentMenu) {
        this.parentMenu.currentSubMenu = null;
      }
    } //endregion
    //region Events

    /**
     * Activates a menu item if user clicks on it
     * @private
     */

  }, {
    key: "onMouseClick",
    value: function onMouseClick(event) {
      var me = this,
          menuItem = event.target.closest('.b-menuitem');

      if (menuItem) {
        me.triggerElement(menuItem, event); // IE / Edge still triggers event listeners that were removed in a listener - prevent this

        event.stopImmediatePropagation();
      }
    }
    /**
     * Activates menu items on hover. On real mouse hover, not on a touchstart.
     * @private
     */

  }, {
    key: "onMouseOver",
    value: function onMouseOver(event) {
      var me = this;

      if (this.focusOnHover !== false) {
        var fromItemElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(event.relatedTarget, '.b-widget'),
            toItemElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(event.target, '.b-widget'),
            overItem = _Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"].fromElement(toItemElement); // Activate soon in case they're moving fast over items.

        if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isTouchEvent && toItemElement && toItemElement !== fromItemElement && overItem.parent === this) {
          me.setTimeout({
            fn: 'handleMouseOver',
            delay: 30,
            args: [overItem],
            cancelOutstanding: true
          });
        }
      }
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(overItem) {
      overItem.focus();
    } // unselect any menu item if mouse leaves the menu element (unless it enters a child menu)

  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(event) {
      var me = this,
          relatedTarget = event.relatedTarget,
          leavingToChild = relatedTarget && me.owns(relatedTarget);
      var targetCmp = relatedTarget && relatedTarget instanceof HTMLElement && _Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"].fromElement(relatedTarget),
          shouldHideMenu = !leavingToChild;

      if (targetCmp) {
        while (targetCmp.ownerCmp) {
          targetCmp = targetCmp.ownerCmp;
        } // Or was found and does not belong to current menu DOM tree
        // This condition will not allow possibly existing picker to hide
        // Covered by Menu.t.js


        shouldHideMenu &= !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getAncestor(targetCmp.element, [event.target]);
      }

      if (!leavingToChild && shouldHideMenu) {
        me.currentSubMenu && me.currentSubMenu.hide();
        me.currentSubMenu = me.selectedElement = null; // Deactivate currently active *menu items* on mouseleave

        if (me.element.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].activeElement) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].activeElement.matches('.b-menuitem')) {
          me.focusElement.focus();
        }
      }
    }
    /**
     * Keyboard navigation. Up/down, close with esc, activate with enter
     * @private
     */

  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(event) {
      var sourceWidget = _Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"].fromElement(event),
          isFromWidget = sourceWidget && sourceWidget !== this && !(sourceWidget instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_14__["default"]);

      if (event.key === 'Escape') {
        // Only close this menu if the ESC was in a child input Widget
        (isFromWidget ? this : this.rootMenu).close();
        return;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Menu.prototype), "onInternalKeyDown", this).call(this, event); // Do not process keys from certain elemens


      if (isFromWidget) {
        return;
      }

      if (validKeys[event.key]) {
        event.preventDefault();
      }

      var active = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].activeElement,
          el = this.element;
      this.navigateFrom(active !== el && el.contains(active) ? active : null, event.key, event);
    }
  }, {
    key: "navigateFrom",
    value: function navigateFrom(active, key, event) {
      var me = this,
          treeWalker = me.treeWalker,
          item = active && me.getItem(active);
      var toActivate;

      switch (key) {
        case 'ArrowUp':
          treeWalker.currentNode = active || (active = me.bottomFocusTrap);
          treeWalker.previousNode();
          toActivate = treeWalker.currentNode;
          break;

        case 'ArrowDown':
          treeWalker.currentNode = active || (active = me.topFocusTrap);
          treeWalker.nextNode();
          toActivate = treeWalker.currentNode;
          break;

        case ' ':
          if (active && !active.classList.contains('b-disabled')) {
            if (item && item.menu) {
              me.openSubMenu(active, item);
            } else {
              me.triggerElement(active, event);
            }
          }

          break;

        case 'ArrowRight':
          if (active && item && item.menu && !active.classList.contains('b-disabled')) {
            // opening with arrow keys highlights first item (as in menus on mac)
            var openedMenu = me.openSubMenu(active, item); // If show hs not been vetoed, ask it to focus.
            // Container will delegate focus inward if possible.

            if (openedMenu) {
              openedMenu.focus();
            }
          } else {
            treeWalker.currentNode = active || (active = me.topFocusTrap);
            treeWalker.nextNode();
            toActivate = treeWalker.currentNode;
          }

          break;

        case 'ArrowLeft':
          if (me.isSubMenu) {
            me.hide();
          } else if (!active) {
            treeWalker.currentNode = active || (active = me.topFocusTrap);
            treeWalker.nextNode();
            toActivate = treeWalker.currentNode;
          }

          break;

        case 'Enter':
          if (active && !active.classList.contains('b-disabled')) {
            me.triggerElement(active, event);
          }

          break;
      } // Move focus to wherever we have calculated


      if (toActivate) {
        // Previous moved to encapsulating element; wrap from end
        if (toActivate === me.element) {
          me.navigateFrom(me.bottomFocusTrap, 'ArrowUp', event);
        } // Next could not move because we're at the end; wrap from top
        else if (toActivate === active) {
            me.navigateFrom(me.topFocusTrap, 'ArrowDown', event);
          } else {
            toActivate.focus();
          }
      }
    } //endregion
    //region Activate menu item

  }, {
    key: "getItem",
    value: function getItem(item) {
      // Cannot use truthiness test because index zero may be passed.
      if (item != null) {
        // Access by index
        if (typeof item === 'number') {
          return this.items[item];
        } // Access by element


        if (item.nodeType === 1) {
          return _Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"].fromElement(item, 'menuitem', this.contentElement);
        } // Access by id
        else {
            return this.items.find(function (c) {
              return c.id == item;
            });
          }
      }
    }
    /**
     * Activate a menu item (from its element)
     * @private
     * @fires item
     * @param menuItemElement
     */

  }, {
    key: "triggerElement",
    value: function triggerElement(menuItemElement, event) {
      var menu = this,
          item = menu.getItem(menuItemElement); // If the trigger gesture happened on a non-MenuItem
      // item will be undefined. Do not action on a non-MenuItem
      // or a disabled MenuItem

      if (item && !item.disabled) {
        item.doAction(event);
      }
    }
    /**
     * Returns true if this menu is a sub menu.
     * To find out which menu is the parent, check {@link #property-parentMenu}.
     * @type {boolean}
     * @readonly
     */

  }, {
    key: "openSubMenu",

    /**
     * Opens a submenu anchored to a menu item
     * @private
     * @param element
     * @param item
     */
    value: function openSubMenu(element, item) {
      var me = this,
          subMenu = item.menu;

      if (subMenu) {
        if (!subMenu.isVisible) {
          var event = {
            item: item,
            element: element
          };

          if (me.trigger('beforeSubMenu', event) === false) {
            return;
          }

          if (item.onBeforeSubMenu && item.onBeforeSubMenu(event) === false) {
            return;
          }

          subMenu.show();
        }
        /**
         * Currently open sub menu, if any
         * @member {Core.widget.Menu} currentSubMenu
         * @readonly
         */


        return me.currentSubMenu = subMenu;
      }
    }
    /**
     * Get/set focused menu item.
     * Shows submenu if newly focused item has a menu and is not disabled.
     * @property {HTMLElement}
     */

  }, {
    key: "selectFirst",
    value: function selectFirst() {
      var treeWalker = this.treeWalker;
      treeWalker.currentNode = this.topFocusTrap;
      treeWalker.nextNode(); // If we are under keyboard control, this must happen in the next
      // animation frame so that the keydown event doesn't fire on the
      // newly focused node.

      this.requestAnimationFrame(function () {
        return treeWalker.currentNode.focus();
      });
    } //endregion
    //region Close

    /**
     * Gets the parent Menu if this Menu is a submenu.
     * @returns {Core.widget.Menu} The parent menu if this is a submenu, otherwise, `undefined`.
     */

  }, {
    key: "focusElement",
    get: function get() {
      var _this$parentMenu;

      var fromParentMenu = (_this$parentMenu = this.parentMenu) === null || _this$parentMenu === void 0 ? void 0 : _this$parentMenu.element.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].activeElement),
          firstWidget = this.items[0];

      if (fromParentMenu || !(firstWidget instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_14__["default"])) {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Menu.prototype), "focusElement", this);
      }

      return this.element;
    }
  }, {
    key: "isSubMenu",
    get: function get() {
      return this.owner && this === this.owner.menu;
    }
  }, {
    key: "selectedElement",
    set: function set(element) {
      var me = this,
          lastSelected = me._selectedElement;

      if (lastSelected) {
        var lastItem = me.getItem(lastSelected),
            lastItemMenu = lastItem && lastItem.menu;

        if (lastItemMenu) {
          lastItemMenu.hide();
        }

        lastSelected.classList.remove('b-active');
      }

      me._selectedElement = element; // might set to null to deselect

      if (element) {
        var doFocus = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isFocusable(element);
        element.classList.add('b-active');
        me.scrollable.scrollIntoView(element, {
          animate: !doFocus,
          focus: doFocus
        });
      }
    },
    get: function get() {
      return this._selectedElement;
    }
  }, {
    key: "parentMenu",
    get: function get() {
      var result = this.owner;

      if (result instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_14__["default"]) {
        result = result.owner;
      }

      if (result instanceof Menu) {
        return result;
      }
    }
    /**
     * Gets this menus root menu, the very first menu shown in a sub menu hierarchy
     * @property {Core.widget.Menu}
     * @private
     */

  }, {
    key: "rootMenu",
    get: function get() {
      var menu = this;

      while (menu.parentMenu && menu.parentMenu instanceof this.constructor) {
        menu = menu.parentMenu;
      }

      return menu;
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Menu';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'menu';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        align: 't-b',
        scrollAction: 'hide',

        /**
         * Specify false to prevent the menu from getting focus when hovering items
         * @default
         * @config {Boolean}
         */
        focusOnHover: null,
        // We do need a Scroller so that we can use its API to scroll around.
        // But the overflow flags default to false.
        scrollable: false,
        defaultType: 'menuitem',
        tools: {
          // To get rid of the close tool from Popup
          close: false
        }
      };
    }
  }]);

  return Menu;
}(_Popup_js__WEBPACK_IMPORTED_MODULE_11__["default"]); // Register this widget type with its Factory



Menu.initClass();
Menu._$name = 'Menu';

/***/ }),

/***/ "./lib/Core/widget/MenuItem.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/MenuItem.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MenuItem; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");















function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7___default()(["\n            <", " ", " ", " class=\"", "\" ", " tabIndex=\"-1\">\n                ", "\n                <span class=\"b-menu-text\" data-reference=\"textElement\">", "</span>\n                ", "\n            </", ">"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/widget/MenuItem
 */

var bIcon = /^b-icon-/,
    bFa = /^b-fa-/;
/**
 * A widget representing a single menu item in a {@link Core.widget.Menu}. May be configured with a
 * {@link #config-checked} state which creates a checkbox which may be toggled. Can also be
 * {@link Core.widget.Widget#config-disabled}, which affects item appearance and blocks interactions.
 *
 * Fires events when activated which bubble up through the parent hierarchy
 * and may be listened for on an ancestor. See {@link Core.widget.Menu Menu}
 * for more details on usage.
 *
 * @extends Core/widget/Widget
 * @classType menuitem
 */

var MenuItem = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(MenuItem, _Widget);

  var _super = _createSuper(MenuItem);

  function MenuItem() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, MenuItem);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(MenuItem, [{
    key: "doAction",

    /**
     * Actions this item. Fires the {@link #event-item} event, and if this
     * if a {@link #config-checked} item, toggles the checked state, firing
     * the {@link #event-toggle} event.
     */
    value: function doAction(event) {
      var item = this,
          menu = this.parent,
          itemEvent = {
        menu: menu,
        item: item,
        element: item.element,
        bubbles: true
      };

      if (typeof item.checked === 'boolean') {
        item.checked = !item.checked;
      } // Give internal handlers a chance to inject extra information before
      // user-supplied "item" handlers see the event.
      // Grid's CellMenu feature, HeaderMenu feature and other context menu features do this.


      item.trigger('beforeItem', itemEvent);
      /**
       * This menu item has been activated.
       *
       * Note that this event bubbles up through parents and can be
       * listened for on a top level {@link Core.widget.Menu Menu} for convenience.
       * @event item
       * @param {Core.widget.MenuItem} item - The menu item which is being actioned.
       * @param {Core.widget.Menu} menu - Menu containing the menu item
       */

      item.trigger('item', itemEvent); // Collapse the owning menu hierarchy if configured to do so

      if (item.closeParent && menu) {
        menu.rootMenu.close(); // Don't prevent links doing their thing

        if (event && !item.href) {
          event.preventDefault();
        }
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var menu = this._menu;

      if (menu instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"]) {
        menu.destroy();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(MenuItem.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "template",
    value: function template(me) {
      var icon = me.icon || (typeof me.checked === 'boolean' ? "b-fw-icon b-icon-".concat(me.checked ? '' : 'un', "checked") : ''),
          iconExtraCls = bIcon.test(icon) ? ' b-icon' : bFa.test(icon) ? ' b-fa' : '',
          tag = me.href ? 'a' : 'div';
      return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].tpl(_templateObject(), tag, tag === 'a' ? "href=\"".concat(me.href, "\"") : '', tag === 'a' && me.target ? "target=\"".concat(me.target, "\"") : '', me.hasMenu ? 'b-has-submenu' : '', me.name ? "data-name=\"".concat(me.name, "\"") : '', icon ? "<i class=\"b-menuitem-icon ".concat(icon).concat(iconExtraCls, "\" data-reference=\"iconElement\"></i>") : '', me.text, me.hasMenu ? '<i class="b-fw-icon b-icon-sub-menu" data-reference="subMenuIcon"></i>' : '', tag);
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(MenuItem.prototype), "onFocusIn", this).call(this, e);

      if (!this.disabled && this.menu) {
        this.openMenu();
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(MenuItem.prototype), "onFocusOut", this).call(this, e);

      this.closeMenu();
    }
  }, {
    key: "openMenu",
    value: function openMenu(andFocus) {
      var menu = this.menu;

      if (!this.disabled && menu) {
        menu.focusOnToFront = andFocus;
        menu.show();
        this.owner.currentSubMenu = menu;
      }
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      if (this._menu instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"]) {
        this.menu.close();
      }
    }
    /**
     * Get/sets the checked state of this `MenuItem` and fires the {@link #event-toggle}
     * event upon change.
     *
     * Note that this must be configured as a `Boolean` to enable the checkbox UI.
     * @member {Boolean} checked
     */

  }, {
    key: "changeChecked",
    value: function changeChecked(checked, old) {
      if (!this.isConfiguring && !(typeof old === 'boolean')) {
        return;
      }

      return Boolean(checked);
    }
  }, {
    key: "updateChecked",
    value: function updateChecked(checked) {
      var me = this;

      if (!me.isConfiguring) {
        me.iconElement.classList[checked ? 'add' : 'remove']('b-icon-checked');
        me.iconElement.classList[checked ? 'remove' : 'add']('b-icon-unchecked');
        /**
         * The checked state of this menu item has changed.
         *
         * Note that this event bubbles up through parents and can be listened for on a top level
         * {@link Core.widget.Menu Menu} for convenience.
         * @event toggle
         * @param {Core.widget.MenuItem} item - The menu item whose checked state changed.
         * @param {Core.widget.Menu} menu - Menu containing the menu item
         * @param {Boolean} checked - The _new_ checked state.
         */

        me.trigger('toggle', {
          menu: me.owner,
          item: me,
          checked: checked,
          element: me.element,
          bubbles: true
        });
      }
    }
  }, {
    key: "focusElement",
    get: function get() {
      return this.element;
    }
  }, {
    key: "contentElement",
    get: function get() {
      return this.textElement;
    }
  }, {
    key: "isFocusable",
    get: function get() {
      var focusElement = this.focusElement; // We are only focusable if the focusEl is deeply visible, that means
      // it must have layout - an offsetParent. Body does not have offsetParent.
      // Disabled menu items are focusable but cannot be activated.
      // https://www.w3.org/TR/wai-aria-practices/#h-note-17

      return focusElement && this.isVisible && (focusElement === document.body || focusElement.offsetParent);
    }
  }, {
    key: "menu",
    set: function set(menu) {
      this._menu = menu;
    },

    /**
     * Returns the instantiated menu widget as configured by {@link #config-menu}.
     * @property {Core.widget.Widget}
     * @readonly
     */
    get: function get() {
      var me = this;
      var result = me._menu; // Asking for the menu after it's been destroyed means we no longer have a menu

      if (result && result.isDestroyed) {
        result = me._menu = null;
      }

      if (result && !(result instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"])) {
        // This covers both Array and Object which are valid items config formats.
        // menu could be { itemRef : { text : 'sub item 1 } }. But if it has
        // child items or html property in it, it's the main config
        if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default()(result) === 'object' && !('items' in result || 'widgets' in result || 'html' in result)) {
          result = {
            lazyItems: result
          };
        }

        result = me.menu = _Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"].create(Object.assign({
          type: 'menu',
          autoShow: false,
          autoClose: true,
          scrollAction: me.owner.scrollAction,
          constrainTo: me.owner.constrainTo,
          forElement: me.element,
          align: 'l0-r0',
          anchor: true,
          owner: me,
          cls: 'b-sub-menu' // Makes the anchor hoverable to avoid mouseleave

        }, result));
      }

      return result;
    }
  }, {
    key: "text",
    get: function get() {
      return this.html;
    },
    set: function set(text) {
      this.html = text;
    }
  }, {
    key: "closeParent",
    set: function set(closeParent) {
      this._closeParent = closeParent;
    },
    get: function get() {
      var result = typeof this.checked === 'boolean' ? this._closeParent : this._closeParent !== false;
      return result && !this.hasMenu;
    }
  }, {
    key: "hasMenu",
    get: function get() {
      var menu = this.isConfiguring ? this.initialConfig.menu : this._menu;
      return menu && (menu instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"] || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default()(menu) === 'object' || menu.length > 0);
    }
  }, {
    key: "childItems",
    get: function get() {
      var menu = this.menu;
      return menu ? [menu] : [];
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'MenuItem';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'menuitem';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * If configured with a `Boolean` value, a checkbox is displayed
         * as the start icon, and the {@link #event-toggle} event is fired
         * when the checked state changes.
         * @config {Boolean}
         */
        checked: null
      };
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * A submenu configuration object, or an array of MenuItem configuration
         * objects from which to create a submenu.
         *
         * Note that this does not have to be a Menu. The `type` config can be used
         * to specify any widget as the submenu.
         * @config {Object|Object[]}
         */
        menu: null,

        /**
         * Item icon class.
         *
         * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
         *
         * Otherwise this is a developer-defined CSS class string which results in the desired icon.
         * @config {String}
         */
        icon: null,

        /**
         * The text to be displayed in the item
         * @config {String}
         */
        text: null,

        /**
         * By default, upon activate, non-checkbox menu items will collapse
         * the owning menu hierarchy.
         *
         * Configure this as `false` to cause the menu to persist after
         * activating an item
         * @config {Boolean}
         */
        closeParent: null,

        /**
         * If provided, turns the menu item into a link
         * @config {String}
         */
        href: null,

        /**
         * The `target` attribute for the {@link #config-href} config
         * @config {String}
         */
        target: null,
        localizableProperties: ['text']
      };
    }
  }]);

  return MenuItem;
}(_Widget_js__WEBPACK_IMPORTED_MODULE_15__["default"]); // Register this widget type with its Factory



MenuItem.initClass();
MenuItem._$name = 'MenuItem';

/***/ }),

/***/ "./lib/Core/widget/MessageDialog.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/MessageDialog.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


 // No module tag here. That stops the singleton from being included by the docs.

/**
 * A singleton modal dialog box which can be used to ask the user to confirm or reject actions.
 *
 * @extends Core/widget/Popup
 * @externalexample widget/MessageDialog.js
 * @singleton
 */

var MessageDialog = /*#__PURE__*/function (_Popup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(MessageDialog, _Popup);

  var _super = _createSuper(MessageDialog);

  function MessageDialog() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, MessageDialog);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(MessageDialog, [{
    key: "construct",
    value: function construct() {
      /**
       * The enum value for the no button
       * @property {Number} noButton
       * @readOnly
       */
      this.noButton = 0;
      /**
       * The enum value for the yes button
       * @property {Number} yesButton
       * @readOnly
       */

      this.yesButton = 1;
      /**
       * The enum value for the cancel button
       * @property {Number} cancelButton
       * @readOnly
       */

      this.cancelButton = 3;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(MessageDialog.prototype), "construct", this).apply(this, arguments);
    }
    /**
     * Shows a confirm dialog with "Yes" and "No" buttons. The returned promise resolves passing `true`
     * if the "yes" button is pressed, and `false` if the "No" button is pressed. Typing `ESC` rejects.
     * @async
     * @param {Object} options An options object for what to show.
     * @param {String} [options.title] The title to show in the dialog header.
     * @param {String} [options.message] The message to show in the dialog body.
     * @returns {Promise} A promise which is resolved when the dialog is shown
     */

  }, {
    key: "confirm",
    value: function () {
      var _confirm = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee(_ref) {
        var message, _ref$title, title, me;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                message = _ref.message, _ref$title = _ref.title, title = _ref$title === void 0 ? '\xa0' : _ref$title;
                me = this; // Ensure our child items are instanced

                me.getConfig('lazyItems');
                me.title = me.optionalL(title);
                me.element.classList.remove(me.showClass);

                if (message) {
                  me.showClass = 'b-show-message-yes-no';
                  me.widgetMap.message.html = me.optionalL(message);
                } else {
                  me.showClass = 'b-show-yes-no';
                }

                me.element.classList.add(me.showClass);
                me.show();
                return _context.abrupt("return", me.promise = new Promise(function (resolve) {
                  me.resolve = resolve;
                }));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }

      return confirm;
    }()
  }, {
    key: "doResolve",
    value: function doResolve(value) {
      var me = this,
          resolve = me.resolve;

      if (resolve) {
        me.resolve = me.reject = me.promise = null;
        resolve(value);
        me.hide();
      }
    }
  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(event) {
      // Cancel on escape key
      if (event.key === 'Escape') {
        event.stopImmediatePropagation();

        if (this.widgetMap.cancelButton.isVisible) {
          this.onCancelClick();
        } else {
          this.onNoClick();
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(MessageDialog.prototype), "onInternalKeyDown", this).call(this, event);
    }
  }, {
    key: "onYesClick",
    value: function onYesClick() {
      this.doResolve(MessageDialogSingleton.yesButton);
    }
  }, {
    key: "onNoClick",
    value: function onNoClick() {
      this.doResolve(MessageDialogSingleton.noButton);
    }
  }, {
    key: "onCancelClick",
    value: function onCancelClick() {
      this.doResolve(MessageDialogSingleton.cancelButton);
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'MessageDialog';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'messagedialog';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        id: 'bryntum-msgdialog',
        centered: true,
        modal: true,
        hidden: true,
        autoShow: false,
        closeAction: 'hide',
        title: '\xa0',
        lazyItems: {
          $config: ['lazy'],
          value: [{
            type: 'widget',
            id: 'bryntum-msgdialog-message',
            cls: 'b-msgdialog-message',
            ref: 'message'
          }, {
            type: 'textfield',
            id: 'bryntum-msgdialog-input',
            cls: 'b-msgdialog-input',
            ref: 'input'
          }]
        },
        bbar: {
          id: 'bryntum-msgdialog-bbar',
          items: [{
            ref: 'yesButton',
            id: 'bryntum-msgdialog-yesbutton',
            cls: 'b-msgdialog-yesbutton b-green',
            text: 'L{Object.Yes}',
            onClick: 'up.onYesClick'
          }, {
            ref: 'noButton',
            id: 'bryntum-msgdialog-nobutton',
            cls: 'b-msgdialog-nobutton b-gray',
            text: 'L{Object.No}',
            onClick: 'up.onNoClick'
          }, {
            ref: 'cancelButton',
            id: 'bryntum-msgdialog-cancelbutton',
            cls: 'b-msgdialog-cancelbutton b-gray',
            text: 'L{Object.Cancel}',
            onClick: 'up.onCancelClick'
          }]
        }
      };
    }
  }]);

  return MessageDialog;
}(_Popup_js__WEBPACK_IMPORTED_MODULE_13__["default"]); // Register this widget type with its Factory


MessageDialog.initClass();
var MessageDialogSingleton = new MessageDialog();
/* harmony default export */ __webpack_exports__["default"] = (MessageDialogSingleton);

/***/ }),

/***/ "./lib/Core/widget/NumberField.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/NumberField.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberField; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.repeat */ "./node_modules/core-js/modules/es.string.repeat.js");
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/util/NumberFormat.js */ "./lib/Core/helper/util/NumberFormat.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/widget/NumberField
 */

var digitRe = /\d/;
/**
 * Number field widget. Similar to native `<input type="number">`, but implemented as `<input type="text">` to support
 * formatting.
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.NumberColumn NumberColumn},
 * {@link Grid.column.PercentColumn PercentColumn}, {@link Grid.column.AggregateColumn AggregateColumn}.
 *
 * ```
 * const number = new NumberField({
 *   min   : 1,
 *   max   : 5,
 *   value : 3
 * });
 * ```
 *
 * @extends Core/widget/Field
 * @classType numberfield
 * @externalexample widget/NumberField.js
 */

var NumberField = /*#__PURE__*/function (_Field) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(NumberField, _Field);

  var _super = _createSuper(NumberField);

  function NumberField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, NumberField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(NumberField, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(NumberField.prototype), "construct", this).call(this, config);

      var me = this; // Support for selecting all by double click in empty input area
      // Browsers work differently at this case

      me.input.addEventListener('dblclick', function () {
        me.select();
      });

      if (typeof me.changeOnSpin === 'number') {
        me.bufferedSpinChange = me.buffer(me.triggerChange, me.changeOnSpin);
      }
    } //endregion
    //region Internal functions

  }, {
    key: "acceptValue",
    value: function acceptValue(value) {
      var accept = !isNaN(value); // https://github.com/bryntum/support/issues/1349
      // Pass through if there is a text selection in the field. This fixes the case when
      // valid value is typed already and we are replacing it by selecting complete string and typing over it.
      // Cannot be tested in siesta, see ticket for more info.

      if (accept && !this.hasTextSelection) {
        accept = false;
        var current = this.input.value; // current is a string, so compare to int or string... hence == here not ===
        // noinspection EqualityComparisonWithCoercionJS

        if (current != value) {
          // The new value is out of range, but we accept it if the current value
          // is also problematic. Consider the case where the input is empty and the
          // minimum value is 100. The user must first type "1" and we must accept it
          // if they are to get the opportunity to type the "0"s.
          accept = !this.acceptValue(current); // Also, if we are checking the current value, be sure not to infinitely
          // recurse here.
        }
      }

      return accept;
    }
  }, {
    key: "okMax",
    value: function okMax(value) {
      return isNaN(this.max) || value <= this.max;
    }
  }, {
    key: "okMin",
    value: function okMin(value) {
      return isNaN(this.min) || value >= this.min;
    }
  }, {
    key: "internalOnKeyEvent",
    value: function internalOnKeyEvent(e) {
      if (e.type === 'keydown') {
        var me = this,
            key = e.key;
        var block; // Native arrow key spin behaviour differs between browsers, so we replace
        // the native spinners w/our own triggers and handle arrows keys as well.

        if (key === 'ArrowUp') {
          me.doSpinUp(e.shiftKey);
          block = true;
        } else if (key === 'ArrowDown') {
          me.doSpinDown(e.shiftKey);
          block = true;
        } else if (!e.altKey && !e.ctrlKey && key && key.length === 1) {
          // The key property contains the character or key name... so ignore
          // keys that aren't a single character.
          var after = me.getAfterValue(key),
              afterValue = me.formatter.parseStrict(after);
          block = !me.acceptValue(afterValue);
        }

        if (key === 'Enter' && me._changedBySilentSpin) {
          me.triggerChange(e, true); // reset the flag

          me._changedBySilentSpin = false;
        }

        if (block) {
          e.preventDefault();
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(NumberField.prototype), "internalOnKeyEvent", this).call(this, e);
    }
  }, {
    key: "doSpinUp",
    value: function doSpinUp() {
      var largeStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this;
      var newValue = (me.value || 0) + (largeStep ? me.largeStep : me.step);

      if (!me.okMin(newValue)) {
        newValue = me.min;
      }

      if (me.okMax(newValue)) {
        me.applySpinChange(newValue);
      }
    }
  }, {
    key: "doSpinDown",
    value: function doSpinDown() {
      var largeStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this;
      var newValue = (me.value || 0) - (largeStep ? me.largeStep : me.step);

      if (!me.okMax(newValue)) {
        newValue = me.max;
      }

      if (me.okMin(newValue)) {
        me.applySpinChange(newValue);
      }
    }
  }, {
    key: "applySpinChange",
    value: function applySpinChange(newValue) {
      var me = this;
      me._isUserAction = true; // Should not trigger change immediately?

      if (me.changeOnSpin !== true) {
        me._changedBySilentSpin = true; // Silence the change

        me.silenceChange = true; // Optionally buffer the change

        me.bufferedSpinChange && me.bufferedSpinChange(null, true);
      }

      me.value = newValue;
      me._isUserAction = false;
      me.silenceChange = false;
    }
  }, {
    key: "triggerChange",
    value: function triggerChange() {
      if (!this.silenceChange) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(NumberField.prototype), "triggerChange", this).apply(this, arguments);
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(NumberField.prototype), "onFocusOut", this).apply(this, arguments);

      if (this._changedBySilentSpin) {
        this.triggerChange(e, true); // reset the flag

        this._changedBySilentSpin = false;
      }
    }
  }, {
    key: "internalOnInput",
    value: function internalOnInput(event) {
      var me = this,
          input = me.input,
          raw = input.value,
          trunc = me.formatter.truncate(raw),
          value = isNaN(trunc) ? '' : me.formatValue(trunc);

      if (raw !== value && digitRe.test(raw[raw.length - 1])) {
        // If typing has caused truncation or rounding, reset. To best preserve
        // the caret pos (which is reset by assigning input.value), we grab and
        // restore the distance from the end. This allows special things to format
        // into the string (such as thousands separators) since they always go to
        // the front of the input.
        var pos = raw.length - me.caretPos;
        input.value = value;
        me.caretPos = value.length - pos;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(NumberField.prototype), "internalOnInput", this).call(this, event);
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      return this.formatter.format(value);
    }
  }, {
    key: "changeFormat",
    value: function changeFormat(format) {
      var me = this;

      if (format === '') {
        var leadingZeroes = me.leadingZeroes,
            decimalPrecision = me.decimalPrecision;
        format = leadingZeroes ? "".concat(leadingZeroes, ">9") : null;

        if (decimalPrecision != null) {
          format = "".concat(format || '', "9.").concat('#'.repeat(decimalPrecision));
        } else if (format) {
          // When we only have leadingZeroes, we'll have a format like "4>9", but
          // that will default to 3 decimal digits. Prior behavior implied no limit
          // on decimal digits unless decimalPrecision was specified.
          format += '.*';
        }
      }

      return format;
    }
  }, {
    key: "updateStep",
    //endregion
    //region Getters/Setters
    value: function updateStep(step) {
      this.element.classList[step ? 'remove' : 'add']('b-hide-spinner');
      this._step = step;
    }
  }, {
    key: "changeLargeStep",
    value: function changeLargeStep(largeStep) {
      return largeStep || this.step * 10;
    }
  }, {
    key: "changeValue",

    /**
     * Get/set the NumberField's value, or `undefined` if the input field is empty
     * @property {Number}
     */
    value: function changeValue(value, was) {
      var me = this;

      if (value || value === 0) {
        var valueIsNaN; // We insist on a number as the value

        if (typeof value !== 'number') {
          value = typeof value === 'string' ? me.formatter.parse(value) : Number(value);
          valueIsNaN = isNaN(value);

          if (valueIsNaN) {
            value = '';
          }
        }

        if (!valueIsNaN && me.format) {
          value = me.formatter.round(value);
        }
      } else {
        value = undefined;
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(NumberField.prototype), "changeValue", this).call(this, value, was);
    }
  }, {
    key: "formatter",
    get: function get() {
      var me = this,
          format = me.format;
      var formatter = me._formatter;

      if (!formatter || me._lastFormat !== format) {
        formatter = _helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_13__["default"].get(me._lastFormat = format); // TODO use this.formatter.is.from.currency/percent visually...
        // if (!formatter.is.decimal) {
        //     formatter = formatter.as('decimal');
        // }

        me._formatter = formatter;
      }

      return formatter;
    }
  }, {
    key: "validity",
    get: function get() {
      var value = this.value,
          validity = {}; // Assert range for non-empty fields, empty fields will turn invalid if `required: true`

      if (value != null) {
        validity.rangeUnderflow = !this.okMin(value);
        validity.rangeOverflow = !this.okMax(value);
      }

      validity.valid = !validity.rangeUnderflow && !validity.rangeOverflow;
      return validity;
    }
  }, {
    key: "inputValue",
    get: function get() {
      var value = this.value;

      if (value != null && this.format) {
        value = this.formatValue(value);
      }

      return value;
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'NumberField';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'numberfield';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'number';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Min value
         * @config {Number}
         */
        min: null,

        /**
         * Max value
         * @config {Number}
         */
        max: null,

        /**
          * Step size for spin button clicks.
         * @property {Number}
         * @name step
         */

        /**
         * Step size for spin button clicks. Also used when pressing up/down keys in the field.
         * @config {Number}
         * @default
         */
        step: 1,

        /**
         * Large step size, defaults to 10 * `step`. Applied when pressing SHIFT and stepping either by click or
         * using keyboard.
         * @config {Number}
         * @default 10
         */
        largeStep: 0,

        /**
         * Initial value
         * @config {Number}
         */
        value: 0,

        /**
         * The format to use for rendering numbers.
         *
         * For example:
         * ```
         *  format: '9,999.00##'
         * ```
         * The above enables digit grouping and will display at least 2 (but no more than 4) fractional digits.
         * @config {String|Object|Core.helper.util.NumberFormat}
         * @default
         */
        format: '',

        /**
         * The number of decimal places to allow. Defaults to no constraint.
         *
         * This config has been replaced by {@link #config-format}. Instead of this:
         *```
         *  decimalPrecision : 3
         *```
         * Use `format`:
         *```
         *  format : '9.###'
         *```
         * To set both `decimalPrecision` and `leadingZeroes` (say to `3`), do this:
         *```
         *  format : '3>9.###'
         *```
         * @config {Number}
         * @default
         * @deprecated 3.1 Use {@link #config-format} instead.
         */
        decimalPrecision: null,

        /**
         * The maximum number of leading zeroes to show. Defaults to no constraint.
         *
         * This config has been replaced by {@link #config-format}. Instead of this:
         *```
         *  leadingZeros : 3
         *```
         * Use `format`:
         *```
         *  format : '3>9'
         *```
         * To set both `leadingZeroes` and `decimalPrecision` (say to `2`), do this:
         *```
         *  format : '3>9.##'
         *```
         * @config {Number}
         * @default
         * @deprecated 3.1 Use {@link #config-format} instead.
         */
        leadingZeroes: null,
        triggers: {
          spin: {
            type: 'spintrigger'
          }
        },

        /**
         * Controls how change events are triggered when stepping the value up or down using either spinners or
         * arrow keys.
         *
         * Configure with:
         * * `true` to trigger a change event per step
         * * `false` to not trigger change while stepping. Will trigger on blur/Enter
         * * A number of milliseconds to buffer the change event, triggering when no steps are performed during that
         *   period of time.
         *
         * @config {Boolean|Number}
         * @default
         */
        changeOnSpin: true,
        // NOTE: using type="number" has several trade-offs:
        //
        // Negatives:
        //   - No access to caretPos/textSelection. This causes anomalies when replacing
        //     the input value with a formatted version of that value (the caret moves to
        //     the end of the input el on each character typed).
        //   - The above also prevents Siesta/synthetic events from mimicking typing.
        //   - Thousand separators cannot be displayed (input.value = '1,000' throws an
        //     exception).
        // Positives:
        //   - On mobile, the virtual keyboard only shows digits et al.
        //   - validity property on DOM node that handles min/max checks.
        //
        // The above may not be exhaustive, but there is not a compelling reason to
        // use type="number" except on mobile.

        /**
         * This can be set to `'number'` to enable the numeric virtual keyboard on
         * mobile devices. Doing so limits this component's ability to handle keystrokes
         * and format properly as the user types, so this is not recommended for
         * desktop applications. This will also limit similar features of automated
         * testing tools that mimic user input.
         * @config {String}
         * @default text
         */
        inputType: null
      };
    }
  }]);

  return NumberField;
}(_Field_js__WEBPACK_IMPORTED_MODULE_12__["default"]); // Register this widget type with its Factory



NumberField.initClass();
NumberField._$name = 'NumberField';

/***/ }),

/***/ "./lib/Core/widget/PagingToolbar.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/PagingToolbar.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PagingToolbar; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Toolbar_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Toolbar.js */ "./lib/Core/widget/Toolbar.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/widget/PagingToolbar
 */

/**
 * A special Toolbar class, which, when attached to an {@link Core.data.AjaxStore AjaxStore}, which has been configured
 * to be {@link Core.data.AjaxStore#property-isPaged paged}, controls the loading of that store to page through the data
 * set.
 *
 * ```javascript
 * new Grid({
 *      bbar : {
 *          type  : 'pagingtoolbar'
 *      }
 * });
 * ```
 *
 * @extends Core/widget/Toolbar
 * @classType toolbar
 */

var PagingToolbar = /*#__PURE__*/function (_Toolbar) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(PagingToolbar, _Toolbar);

  var _super = _createSuper(PagingToolbar);

  function PagingToolbar() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, PagingToolbar);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(PagingToolbar, [{
    key: "onStoreBeforeRequest",
    value: function onStoreBeforeRequest() {
      this.eachWidget(function (w) {
        return w.disable();
      });
    }
  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      var me = this,
          _me$widgetMap = me.widgetMap,
          reloadButton = _me$widgetMap.reloadButton,
          firstPageButton = _me$widgetMap.firstPageButton,
          previousPageButton = _me$widgetMap.previousPageButton,
          nextPageButton = _me$widgetMap.nextPageButton,
          lastPageButton = _me$widgetMap.lastPageButton;
      firstPageButton.tooltip = me.L('L{firstPage}');
      previousPageButton.tooltip = me.L('L{prevPage}');
      nextPageButton.tooltip = me.L('L{nextPage}');
      lastPageButton.tooltip = me.L('L{lastPage}');
      reloadButton.tooltip = me.L('L{reload}');
      me.updateSummary();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(PagingToolbar.prototype), "updateLocalization", this).call(this);
    }
  }, {
    key: "updateSummary",
    value: function updateSummary() {
      var me = this,
          _me$widgetMap2 = me.widgetMap,
          pageCount = _me$widgetMap2.pageCount,
          dataSummary = _me$widgetMap2.dataSummary;
      var count, lastPage, start, end, allCount;
      count = lastPage = start = end = allCount = 0;

      if (me.store) {
        var store = me.store,
            pageSize = store.pageSize,
            currentPage = store.currentPage;
        count = store.count;
        lastPage = store.lastPage;
        allCount = store.allCount;
        start = Math.max(0, (currentPage - 1) * pageSize + 1);
        end = Math.min(allCount, start + pageSize - 1);
      }

      pageCount.html = me.L('L{pageCountTemplate}')({
        lastPage: lastPage
      });
      dataSummary.html = count ? me.L('L{summaryTemplate}')({
        start: start,
        end: end,
        allCount: allCount
      }) : me.L('L{noRecords}');
    }
  }, {
    key: "onStoreChange",
    value: function onStoreChange() {
      var me = this,
          widgetMap = me.widgetMap,
          store = me.store,
          count = store.count,
          lastPage = store.lastPage,
          currentPage = store.currentPage,
          pageNumber = widgetMap.pageNumber,
          pageCount = widgetMap.pageCount,
          firstPageButton = widgetMap.firstPageButton,
          previousPageButton = widgetMap.previousPageButton,
          nextPageButton = widgetMap.nextPageButton,
          lastPageButton = widgetMap.lastPageButton,
          dataSummary = widgetMap.dataSummary;
      me.eachWidget(function (w) {
        return w.enable();
      });
      pageNumber.value = currentPage;
      pageNumber.max = lastPage;
      dataSummary.disabled = pageNumber.disabled = pageCount.disabled = !count;
      firstPageButton.disabled = previousPageButton.disabled = currentPage <= 1 || !count;
      nextPageButton.disabled = lastPageButton.disabled = currentPage >= lastPage || !count;
      me.updateSummary();
    }
  }, {
    key: "onPageNumberChange",
    value: function onPageNumberChange(_ref) {
      var value = _ref.value;

      if (this.store.currentPage !== value) {
        this.store.loadPage(value);
      }
    }
  }, {
    key: "onFirstPageClick",
    value: function onFirstPageClick() {
      this.store.loadPage(1);
    }
  }, {
    key: "onPreviousPageClick",
    value: function onPreviousPageClick() {
      this.store.previousPage();
    }
  }, {
    key: "onNextPageClick",
    value: function onNextPageClick() {
      this.store.nextPage();
    }
  }, {
    key: "onLastPageClick",
    value: function onLastPageClick() {
      this.store.loadPage(this.store.lastPage);
    }
  }, {
    key: "onReloadClick",
    value: function onReloadClick() {
      this.store.loadPage(this.store.currentPage);
    }
  }, {
    key: "parent",
    // Retrieve store from grid when "assigned" to it
    set: function set(parent) {
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(PagingToolbar.prototype), "parent", parent, this, true);

      if (!this.store) {
        this.store = parent.store;
      }
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(PagingToolbar.prototype), "parent", this);
    }
  }, {
    key: "store",
    set: function set(store) {
      var me = this,
          listener = {
        beforerequest: 'onStoreBeforeRequest',
        afterrequest: 'onStoreChange',
        change: 'onStoreChange',
        thisObj: me
      };

      if (me.store) {
        me.store.un(listener);
      }

      me._store = store;

      if (store) {
        store.on(listener);

        if (store.isLoading) {
          me.onStoreBeforeRequest();
        }
      }
    },
    get: function get() {
      return this._store;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'PagingToolbar';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'pagingtoolbar';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The {@link Core.data.AjaxStore AjaxStore} that this PagingToolbar is to control.
         * @config {Core.data.AjaxStore}
         */
        store: null,
        defaults: {
          localeClass: this
        },
        items: {
          firstPageButton: {
            onClick: 'up.onFirstPageClick',
            icon: 'b-fa-angle-double-left'
          },
          previousPageButton: {
            onClick: 'up.onPreviousPageClick',
            icon: 'b-fa-angle-left'
          },
          pageNumber: {
            type: 'numberfield',
            label: 'L{page}',
            min: 1,
            max: 1,
            triggers: null,
            onChange: 'up.onPageNumberChange',
            highlightExternalChange: false
          },
          pageCount: {
            type: 'widget',
            cls: 'b-pagecount b-toolbar-text'
          },
          nextPageButton: {
            onClick: 'up.onNextPageClick',
            icon: 'b-fa-angle-right'
          },
          lastPageButton: {
            onClick: 'up.onLastPageClick',
            icon: 'b-fa-angle-double-right'
          },
          separator: {
            type: 'widget',
            cls: 'b-toolbar-separator'
          },
          reloadButton: {
            onClick: 'up.onReloadClick',
            icon: 'b-fa-redo'
          },
          spacer: {
            type: 'widget',
            cls: 'b-toolbar-fill'
          },
          dataSummary: {
            type: 'widget',
            cls: 'b-toolbar-text'
          }
        }
      };
    }
  }]);

  return PagingToolbar;
}(_Toolbar_js__WEBPACK_IMPORTED_MODULE_10__["default"]); // Register this widget type with its Factory



PagingToolbar.initClass();
PagingToolbar._$name = 'PagingToolbar';

/***/ }),

/***/ "./lib/Core/widget/Panel.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Panel.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Panel; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Tool_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Tool.js */ "./lib/Core/widget/Tool.js");
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Toolbar_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Toolbar.js */ "./lib/Core/widget/Toolbar.js");



















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Core/widget/Panel
 */

var acceptNode = function acceptNode(e) {
  return !e.classList.contains('b-focus-trap') && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isFocusable(e) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
},
    byWeight = function byWeight(l, r) {
  return (l.weight || 0) - (r.weight || 0);
},
    byWeightReverse = function byWeightReverse(l, r) {
  return (r.weight || 0) - (l.weight || 0);
}; // https://github.com/webcomponents/webcomponentsjs/issues/556
// Work around Internet Explorer wanting a function instead of an object.
// IE also *requires* this argument where other browsers don't.


acceptNode.acceptNode = acceptNode;
/**
 * Panel widget. A general pupose container which may be used to contain child {@link Core.widget.Container#config-items}
 * or {@link Core.widget.Widget#config-html}.
 *
 * Also may dock a {@link #config-header} and {@link #config-footer} either at top/bottom or left/right
 *
 *
 * @example
 * let panel = new Panel({
 *   title   : 'A Test Panel',
 *   items : [
 *     { type : 'text', placeholder: 'Text' },
 *   ],
 *   bbar : [{
 *     text : 'Proceed',
 *     onClick : () => {
 *       alert('Proceeding!');
 *     }
 *   }]
 * });
 *
 * @classType panel
 *
 * @extends Core/widget/Container
 * @externalexample widget/Panel.js
 */

var Panel = /*#__PURE__*/function (_Container) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(Panel, _Container);

  var _super = _createSuper(Panel);

  function Panel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, Panel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(Panel, [{
    key: "changeTbar",
    value: function changeTbar(tbar, oldTbar) {
      if (tbar) {
        if (Array.isArray(tbar)) {
          tbar = {
            items: tbar
          };
        }

        if (tbar.isWidget) {
          tbar.parent = this;
        } else {
          tbar = _Toolbar_js__WEBPACK_IMPORTED_MODULE_23__["default"].reconfigure(oldTbar, _Toolbar_js__WEBPACK_IMPORTED_MODULE_23__["default"].mergeConfigs({
            type: 'toolbar',
            parent: this
          }, tbar));
        } // Allow Panel subclasses with tbar configured into them to have tbar configured away


        if (tbar) {
          this.hasItems = this.hasItems || tbar.hasItems;
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].addClasses(tbar.element, ['b-top-toolbar', "b-dock-".concat(tbar.dock || 'top')]);
        }
      } else if (oldTbar) {
        oldTbar.destroy();
      }

      return tbar;
    }
  }, {
    key: "changeBbar",
    value: function changeBbar(bbar, oldTbar) {
      if (bbar) {
        if (Array.isArray(bbar)) {
          bbar = {
            items: bbar
          };
        }

        if (bbar.isWidget) {
          bbar.parent = this;
        } else {
          bbar = _Toolbar_js__WEBPACK_IMPORTED_MODULE_23__["default"].reconfigure(oldTbar, _Toolbar_js__WEBPACK_IMPORTED_MODULE_23__["default"].mergeConfigs({
            type: 'toolbar',
            parent: this
          }, bbar));
        } // Allow Panel subclasses with bbar configured into them to have bbar configured away


        if (bbar) {
          this.hasItems = this.hasItems || bbar.hasItems;
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].addClasses(bbar.element, ['b-bottom-toolbar', "b-dock-".concat(bbar.dock || 'bottom')]);
        }
      } else if (oldTbar) {
        oldTbar.destroy();
      }

      return bbar;
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(title) {
      var tools = this.tools;

      if (this.headerElement) {
        this.titleElement.innerHTML = title;
        this.headerElement.classList[!title && (!tools || !Object.values(tools).some(function (t) {
          return !t.hidden;
        })) ? 'add' : 'remove']('b-hide-display');
      }
    } // Override to iterate docked Toolbars in the correct order around contained widgets.

  }, {
    key: "changeTools",
    value: function changeTools(tools, oldTools) {
      var me = this,
          myTools = {};

      if (tools) {
        for (var toolRef in tools) {
          // Allow excluding tools by configuring them as `false`
          if (tools[toolRef]) {
            var tool = myTools[toolRef] = Panel.create(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].assign({
              type: 'tool',
              ref: toolRef,
              parent: me
            }, tools[toolRef]), me.defaultToolType || 'tool');
            me.onChildAdd(tool);
          }
        }
      } else if (oldTools) {
        for (var _i = 0, _Object$values = Object.values(oldTools); _i < _Object$values.length; _i++) {
          var t = _Object$values[_i];
          t.destroy();
        }
      }

      return myTools;
    }
  }, {
    key: "updateTrapFocus",
    value: function updateTrapFocus(trapFocus) {
      var me = this;
      me.element.classList[trapFocus ? 'add' : 'remove']('b-focus-trapped');

      if (trapFocus) {
        me.focusTrapListener = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].on({
          element: me.element,
          focusin: 'onFocusTrapped',
          delegate: '.b-focus-trap',
          thisObj: me
        }); // Create a TreeWalker which visits focusable elements.

        if (!me.treeWalker) {
          me.treeWalker = this.setupTreeWalker(me.element, NodeFilter.SHOW_ELEMENT, acceptNode, false);
        }
      } else {
        if (me.focusTrapListener) {
          me.focusTrapListener();
          me.focusTrapListener = null;
        }
      }
    }
  }, {
    key: "setupTreeWalker",
    value: function setupTreeWalker(root, whatToShow, filter, entityReferenceExpansion) {
      return document.createTreeWalker(root, whatToShow, filter, entityReferenceExpansion);
    }
  }, {
    key: "onFocusTrapped",
    value: function onFocusTrapped(e) {
      var me = this,
          treeWalker = me.treeWalker; // The only way of focusing these invisible elements is by TABbing to them.
      // If we hit the bottom one, wrap to the top.

      if (e.target === me.bottomFocusTrap) {
        treeWalker.currentNode = me.topFocusTrap;
        treeWalker.nextNode();
      } // If we hit the top one, wrap to the bottom.
      else {
          treeWalker.currentNode = me.bottomFocusTrap;
          treeWalker.previousNode();
        }

      me.requestAnimationFrame(function () {
        return treeWalker.currentNode.focus();
      });
    }
  }, {
    key: "element",
    //endregion

    /**
     * The tool Widgets as specified by the {@link #config-tools} configuration
     * (and the {@link Core.widget.Popup#config-closable} configuration in the Popup subclass).
     * Each is a {@link Core.widget.Widget Widget} instance which may be hidden, shown and observed and styled just like any other widget.
     * @member {Object} tools
     */

    /**
     * Get toolbar {@link Core.widget.Toolbar} docked to the top of the panel,
     * @member {Core.widget.Toolbar} tbar
     * @readonly
     * @typings Toolbar
     */

    /**
     * Get toolbar {@link Core.widget.Toolbar} docked to the bottom of the panel,
     * @member {Core.widget.Toolbar} bbar
     * @readonly
     * @typings Toolbar
     */

    /**
     * A header {@link #config-tools tool} has been clicked.
     * @event toolclick
     * @param {Core.widget.Tool} source - This Panel.
     * @param {Core.widget.Tool} tool - The tool which is being clicked.
     */
    //region Init & destroy
    set: function set(element) {
      var me = this,
          headerFromTitle = me.title && (!me.parent || !me.parent.suppressChildHeaders),
          tools = me.tools,
          footer = me.footer,
          tbar = me.tbar,
          header = me.header || (tools || headerFromTitle ? {} : null),
          bbar = me.bbar || me.buttons,
          children = [{
        reference: 'topFocusTrap',
        className: 'b-focus-trap',
        tabIndex: 0
      }],
          startTools = [],
          endTools = [],
          result = {
        children: children
      };

      if (me.hasItems && me.focusable !== false || me.focusable) {
        result.tabIndex = 0;
      }

      if (header) {
        var title = typeof header === 'string' ? header : me.title || header.title,
            titleAlign = header.titleAlign || 'start',
            headerClass = me.classHierarchy(Panel).reduce(function (prev, cls) {
          prev["b-".concat(cls.$$name.toLowerCase(), "-header")] = 1;
          return prev;
        }, typeof header.cls === 'string' ? _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()({}, header.cls, 1) : header.cls || {}),
            headerChildren = [{
          reference: 'titleElement',
          className: "b-header-title b-align-".concat(titleAlign),
          html: title
        }];

        for (var toolRef in tools) {
          var tool = tools[toolRef];

          if (tool.align === 'start') {
            startTools.unshift(tool);
          } else {
            endTools.push(tool);
          }
        } // The tools at each end are sorted "gravitationally".
        // Higher weight sorts towards the center which is the title element.


        startTools.sort(byWeight);
        endTools.sort(byWeightReverse);
        headerChildren.unshift.apply(headerChildren, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9___default()(startTools.map(function (t) {
          return t.element;
        })));
        headerChildren.push.apply(headerChildren, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9___default()(endTools.map(function (t) {
          return t.element;
        }))); // Hide the header if no title and all tools are hidden

        headerClass['b-hide-display'] = !title && (!tools || !Object.values(tools).some(function (t) {
          return !t.hidden;
        }));
        headerClass["b-dock-".concat(header.dock || 'top')] = 1;
        children.push({
          tag: 'header',
          reference: 'headerElement',
          className: headerClass,
          children: headerChildren
        });
      }

      if (tbar) {
        tbar.layout.renderChildren();
        children.push(tbar.element);
      }

      children.push(me.bodyConfig);

      if (bbar) {
        bbar.layout.renderChildren();
        children.push(bbar.element);
      }

      if (footer) {
        children.push({
          tag: 'footer',
          reference: 'footerElement',
          className: "b-dock-".concat(footer.dock || 'bottom', " ").concat(footer.cls || '')
        });
      }

      children.push({
        reference: 'bottomFocusTrap',
        className: 'b-focus-trap',
        tabIndex: 0
      });

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Panel.prototype), "element", result, this, true);
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Panel.prototype), "element", this);
    }
  }, {
    key: "bodyConfig",
    set: function set(bodyConfig) {
      this._bodyConfig = bodyConfig;
    },
    get: function get() {
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].merge({}, this._bodyConfig, {
        reference: 'bodyElement',
        className: this.classHierarchy(Panel).reduce(function (prev, cls) {
          prev["b-".concat(cls.$$name.toLowerCase(), "-content")] = 1;
          return prev;
        }, {}),
        html: this.html
      });
    }
  }, {
    key: "childItems",
    get: function get() {
      var me = this,
          items = me.items ? me.items.slice() : [];

      if (me.tools) {
        items.unshift.apply(items, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9___default()(Object.values(me.tools)));
      }

      if (me.tbar) {
        items.unshift(me.tbar);
      }

      if (me.bbar) {
        items.push(me.bbar);
      }

      return items;
    }
  }, {
    key: "focusElement",
    get: function get() {
      // Either use our Containerness to yield the focus element of
      // a descendant or fall back to the encapsulating element.
      return this.hasItems && (_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Panel.prototype), "focusElement", this) || this.element);
    }
  }, {
    key: "contentElement",
    get: function get() {
      return this.element && this.bodyElement;
    }
  }, {
    key: "widgetClassList",
    get: function get() {
      var me = this,
          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Panel.prototype), "widgetClassList", this),
          header = me.header;

      if (header || me.title || me.tools) {
        result.push("b-panel-has-header b-header-dock-".concat(header && header.dock || 'top'));
      }

      if (me.tbar) {
        result.push("b-panel-has-top-toolbar");
      }

      if (me.bbar) {
        result.push("b-panel-has-bottom-toolbar");
      }

      return result;
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Panel';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'panel';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        localizableProperties: ['title'],

        /**
         * By default, tabbing within a Panel is not contained, ie you can TAB out of the Panel
         * forwards or backwards.
         * Configure this as `true` to disallow tabbing out of the Panel, and make tabbing circular within this Panel.
         * @config {Boolean}
         * @default false
         */
        trapFocus: null,

        /**
         * A title to display in the header. Causes creation and docking of a header
         * to the top if no header is configured.
         *
         * If specified, overrides any title configured within the {@link #config-header} configuration.
         * @default
         * @config {String}
         */
        title: null,

        /**
         * Config object of a header. May contain a `title`, `titleAlign`, `dock`
         * and a `cls` property. If passed as a string, the value is used
         * as the title, dock is defaulted to `'top', and titleAlign` is defaulted to `start`.
         *
         * The `dock` property may be `top`, `right`, `bottom` or `left`.
         * The `titleAlign` property may be `start`, `center` or `end`.
         * @default
         * @config {Object|String}
         */
        header: null,

        /**
         * Config object of a footer. May contain a `dock`
         * and a `cls` property.
         *
         * The `dock` property may be `top`, `right`, `bottom` or `left`.
         * @default
         * @config {Object|String}
         */
        footer: null,

        /**
         * The tools to add either before or after the title in the Panel header.
         * Each property name is the reference by which an instantiated Tool Widget
         * may be retrieved from the live `{@link #property-tools}` property.
         * Each tool may have the following properties:
         * * `cls` The CSS class to apply.
         * * `handler` A method in the field to call upon click
         * * `align` `'start'` or `'end'` which end of the header the tool should go.
         * * `weight` (Optional) Heigher weighted tools gravitate towards the centre.
         * @config {Object}
         */
        tools: {
          $config: {
            nullify: true
          },
          value: null
        },

        /**
         * A Config object representing the configuration of a {@link Core.widget.Toolbar},
         * or array of config objects representing the child items of a Toolbar.
         *
         * This creates a toolbar docked to the top of the panel immediately below the header.
         * @config {Object[]|Object}
         */
        tbar: {
          $config: {
            nullify: true,
            merge: 'objects'
          },
          value: null
        },

        /**
         * A Config object representing the configuration of a {@link Core.widget.Toolbar},
         * or array of config objects representing the child items of a Toolbar.
         *
         * This creates a toolbar docked to the bottom of the panel immediately above the footer.
         * @config {Object[]|Object}
         */
        bbar: {
          $config: {
            nullify: true,
            merge: 'objects'
          },
          value: null
        }
      };
    }
  }]);

  return Panel;
}(_Container_js__WEBPACK_IMPORTED_MODULE_19__["default"]); // Register this widget type with its Factory



Panel.initClass();
Panel._$name = 'Panel';

/***/ }),

/***/ "./lib/Core/widget/PickerField.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/PickerField.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PickerField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/widget/PickerField
 */

/**
 * Base class used for {@link Core.widget.Combo Combo}, {@link Core.widget.DateField DateField}, and {@link Core.widget.TimeField TimeField}.
 * Displays a picker ({@link Core.widget.List List}, {@link Core.widget.DatePicker DatePicker}) anchored to the field.
 * Not intended to be used directly.
 *
 * This field's subclasses can be used as editors for the {@link Grid.column.Column Column}.
 *
 * When focused by means of *touch* tapping on the trigger element (eg, the down arrow on a Combo)
 * on a tablet, the keyboard will not be shown by default to allow for interaction with the dropdown.
 *
 * A second tap on the input area will then show the keyboard if required.
 *
 * @extends Core/widget/TextField
 * @abstract
 */

var PickerField = /*#__PURE__*/function (_TextField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(PickerField, _TextField);

  var _super = _createSuper(PickerField);

  function PickerField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, PickerField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(PickerField, [{
    key: "doDestroy",
    //endregion
    //region Init & destroy
    value: function doDestroy() {
      // Remove touch keyboard showing listener if we added it
      this.globalTapListener && this.globalTapListener(); // Destroys the picker

      this.picker = null;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(PickerField.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "finalizeInit",
    value: function finalizeInit() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(PickerField.prototype), "finalizeInit", this).call(this);

      var me = this,
          element = me.element;

      if (me.editable === false) {
        element.classList.add('b-not-editable');
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].on({
          element: me.input,
          click: 'onTriggerClick',
          thisObj: me
        });
      } else {
        // In case the field was temporarily set to readOnly="true" to prevent
        // the intrusive keyboard (This happens when tapping the trigger
        // and when focused by the container in response to a touch tap),
        // allow a subsequent touch tap to show the keyboard.
        me.globalTapListener = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
          globaltap: 'showKeyboard',
          thisObj: me
        });
      }
    } //endregion
    //region Picker

    /* TODO
    changePicker(picker, was) {
        if (was) {
            was.hide();
            was.destroy();
        }
         if (picker && !(picker instanceof Widget)) {
            picker = this.createPicker(picker);
        }
         return picker;
    }
     createPicker() {
        throw new Error('createPicker must be implemented in PickerField subclass implementations');
    }
    */

  }, {
    key: "changePicker",
    value: function changePicker(picker, oldPicker) {
      throw new Error('changePicker(oldPicker, newPicker) must be implemented in PickerField subclass implementations');
    }
    /**
     * Iterate over all widgets owned by this widget and any descendants.
     *
     * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
     * functions. If the expression executed evaluates to `false`, iteration will terminate.
     *
     * _Due to the {@link #config-picker} config being a lazy config and only being converted to be a
     * `List` instance just before it's shown, the picker will not be part of the iteration before
     * it has been shown once_.
     * @function eachWidget
     * @param {Function} fn A function to execute upon all descendant widgets.
     * Iteration terminates if this function returns `false`.
     * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
     * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
     */

  }, {
    key: "onEditComplete",
    //endregion
    //region Events

    /**
     * Check if field value is valid
     * @internal
     */
    value: function onEditComplete() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(PickerField.prototype), "onEditComplete", this).call(this);

      this.autoClosePicker();
    }
  }, {
    key: "onElementResize",
    value: function onElementResize(resizedElement) {
      var me = this; // If the field changes size while the picker is visible, the picker
      // must be kept in alignment. For example a multiSelect: true
      // ComboBox with a wrapped ChipView.

      if (me.pickerVisible) {
        // Push realignment out to the next AF, because this picker itself may move in
        // response to the element resize, and the picker must realign *after* that happens.
        // For example a multiSelect: true ComboBox with a wrapped ChipView inside
        // a Popup that is aligned *above* an element. When the ChipView gains or
        // loses height, the Popup must realign first, and then the List must align to the
        // new position of the ComboBox.
        me.picker.requestAnimationFrame(me.picker.realign, null, me.picker);
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(PickerField.prototype), "onElementResize", this).call(this, resizedElement);
    }
    /**
     * Allows using arrow keys to open/close list. Relays other keypresses to list if open.
     * @private
     */

  }, {
    key: "internalOnKeyEvent",
    value: function internalOnKeyEvent(event) {
      var me = this;
      var callSuper = true;

      if (event.type === 'keydown' && !me.disabled) {
        if (me.pickerVisible) {
          var picker = me.picker;

          if (event.key === 'Escape') {
            event.stopImmediatePropagation();
            me.hidePicker(); // EC has multiple effects. First stage is hide the picker.
            // If we do this, then the superclass's ESC handling must
            // not be called.

            callSuper = false;
          } else if (picker.onInternalKeyDown) {
            // if picker is visible, give it a shot at the event
            picker.onInternalKeyDown(event);
          } else if (event.key === 'ArrowDown') {
            if (picker.focusable) {
              picker.focus();
            }
          }
        } else if (event.key === 'ArrowDown') {
          // navigator should not react to initial DOWN keypress that triggers the List to show
          event.stopImmediatePropagation(); // If we not prevent default handler page might scroll. Siesta cannot reproduce this behavior, have to
          // leave it untested.
          // https://github.com/bryntum/support/issues/885

          event.preventDefault();
          me.onTriggerClick(event);
        }
      }

      if (callSuper) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(PickerField.prototype), "internalOnKeyEvent", this).call(this, event);
      }
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(PickerField.prototype), "onFocusIn", this).call(this, e);

      if (this.autoExpand) {
        // IE triggers an input event on focus.
        // If expand is configured for focus, minChars should be zero.
        this.minChars = 0;
        this.onTriggerClick(e);
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      this.autoClosePicker();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(PickerField.prototype), "onFocusOut", this).call(this, e);
    }
    /**
     * User clicked trigger icon, toggle list.
     * @private
     */

  }, {
    key: "onTriggerClick",
    value: function onTriggerClick(event) {
      if (!this.disabled) {
        // Pass focus flag as true if invoked by a key event
        this.togglePicker('key' in event);
      }
    }
    /**
     * User clicked on an editable input field. If it's a touch event
     * ensure that the keyboard is shown.
     * @private
     */

  }, {
    key: "showKeyboard",
    value: function showKeyboard(_ref) {
      var event = _ref.event;
      var input = this.input;

      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isTouchEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].activeElement === input && event.target === input) {
        _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_10__["default"].suspendFocusEvents();
        input.blur();
        input.focus();
        _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_10__["default"].resumeFocusEvents();
      }
    } //endregion
    //region Toggle picker

    /**
     * Toggle picker display
     */

  }, {
    key: "togglePicker",
    value: function togglePicker(focusPicker) {
      if (this.pickerVisible) {
        this.hidePicker();
      } else {
        this.showPicker(focusPicker);
      }
    }
    /**
     * Show picker
     */

  }, {
    key: "showPicker",
    value: function showPicker(focusPicker) {
      var me = this,
          picker = me.picker;

      if (!me.pickerHideShowListenersAdded) {
        picker.on({
          show: 'onPickerShow',
          hide: 'onPickerHide',
          thisObj: me
        });
        me.pickerHideShowListenersAdded = true;
      }

      picker.autoClose = me.autoClose;
      picker.show(); // Not been vetoed

      if (picker.isVisible) {
        if (focusPicker) {
          me.focusPicker();
        }
      }
    }
  }, {
    key: "onPickerShow",
    value: function onPickerShow() {
      var me = this;
      me.pickerVisible = true;
      me.element.classList.add('b-open');
      me.trigger('togglePicker', {
        show: true
      });
      me.pickerTapOutRemover = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
        globaltap: 'onPickerTapOut',
        thisObj: me
      });
      me.pickerKeyDownRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].on({
        element: me.picker.element,
        keydown: 'onPickerKeyDown',
        thisObj: me
      });
    }
  }, {
    key: "onPickerHide",
    value: function onPickerHide() {
      var me = this;
      me.pickerVisible = false;
      me.element.classList.remove('b-open');
      me.trigger('togglePicker', {
        show: false
      });
      me.pickerTapOutRemover && me.pickerTapOutRemover();
      me.pickerKeyDownRemover && me.pickerKeyDownRemover();
    }
  }, {
    key: "onPickerTapOut",
    value: function onPickerTapOut(_ref2) {
      var event = _ref2.event;

      if (!this.owns(event.target)) {
        this.autoClosePicker();
      }
    }
  }, {
    key: "onPickerKeyDown",
    value: function onPickerKeyDown(event) {
      if (event.key === 'Tab') {
        var activeEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].activeElement,
            forwardedEvent = new KeyboardEvent('keydown', event); // Offer our own element a shot at the TAB event.
        // Some widgets or plugins may actively navigate.

        this.input.dispatchEvent(forwardedEvent); // Somebody might preventDefault on the synthesized event. We must honour that.
        // For example if we are the field for a cell Editor, and it started an edit on the adjacent cell.

        if (forwardedEvent.defaultPrevented) {
          event.preventDefault();
        } // No listener intervened, point the TAB event at the input,
        // and user agent default navigation will proceed.


        if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].activeElement === activeEl) {
          this.input.focus();
        } // Some listener *did* navigate, prevent user agent default.
        else {
            event.preventDefault();
          } // If listeners have not destroyed us, close our picker.


        if (!this.isDestroyed) {
          this.hidePicker();
        }
      }
    } //endregion
    //region Visibility

  }, {
    key: "autoClosePicker",
    value: function autoClosePicker() {
      if (this.autoClose) {
        this.hidePicker();
      }
    }
    /**
     * Hide picker
     */

  }, {
    key: "hidePicker",
    value: function hidePicker() {
      if (this.pickerVisible) {
        this.picker.hide();
      }
    }
  }, {
    key: "focusPicker",
    value: function focusPicker() {}
  }, {
    key: "focus",
    value: function focus() {
      var input = this.input; // If we are focusing an editable PickerField from a touch event, temporarily
      // set it to readOnly to prevent the showing of the intrusive keyboard.
      // It's more likely that a user on a touch device will interact with the picker
      // rather than the input field.
      // A second touch tap on an already focused input will show the keyboard;
      // see the showKeyboard method.

      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isTouchEvent && this.editable) {
        input.readOnly = true;
        this.setTimeout(function () {
          return input.readOnly = false;
        }, 500);
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(PickerField.prototype), "focus", this).call(this);
    } //endregion

  }, {
    key: "childItems",
    get: function get() {
      if (this._picker) {
        return [this.picker];
      }
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'PickerField';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'pickerfield';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * User can edit text in text field (otherwise only pick from attached picker)
         * @config {Boolean}
         * @default
         */
        editable: true,

        /**
         * The name of the element property to which the picker should size and align itself.
         * @config {String}
         * @default element
         */
        pickerAlignElement: 'inputWrap',
        // Does not get set, but prevents PickerFields inheriting value:'' from Field.
        value: null,
        triggers: {
          expand: {
            cls: 'bars'
          }
        },

        /**
         * By default PickerFiled's picker is transient, and will {@link #function-hidePicker} when the user clicks or
         * taps outside or when focus moves outside picker.
         *
         * Configure as `false` to make picker non-transient.
         * @config {Boolean}
         * @default
         */
        autoClose: true,

        /**
         * Configure as `true` to have the picker expand upon focus enter.
         * @config {Boolean}
         */
        autoExpand: null,

        /**
         * Returns the instantiated picker widget as configured by {@link #config-picker}.
         * @property {Core.widget.Widget}
         * @name picker
         */

        /**
         * A config object which is merged into the generated picker configuration to allow specific use cases
         * to override behaviour. For example:
         *
         *     picker: {
         *         align: {
         *             anchor: true
         *         }
         *     }
         *
         * @config {Object}
         */
        picker: {
          value: {
            floating: true
          },
          $config: 'lazy'
        },
        inputType: 'text',
        // We need to realign the picker if we resize (eg a multiSelect Combo's ChipView wrapping)
        monitorResize: true,
        nullValue: null
      };
    }
  }]);

  return PickerField;
}(_TextField_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


PickerField._$name = 'PickerField';

/***/ }),

/***/ "./lib/Core/widget/Popup.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Popup.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Popup; });
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.anchor */ "./node_modules/core-js/modules/es.string.anchor.js");
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Panel_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Core/widget/Popup
 */

/**
 * Popup widget, used as base class for Menu but can also be used as is to contain widgets or html
 *
 * @example
 * let popup = new Popup({
 *   forElement : document.querySelector('button'),
 *   items      : [
 *     { type : 'text', placeholder: 'Text' },
 *     { type: 'button', text: 'Okey', style: 'width: 100%', color: 'b-orange'}
 *   ]
 * });
 *
 * @classType popup
 * @externalexample widget/Popup.js
 *
 * @extends Core/widget/Panel
 */

var Popup = /*#__PURE__*/function (_Panel) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Popup, _Panel);

  var _super = _createSuper(Popup);

  function Popup() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Popup);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Popup, [{
    key: "finalizeInit",
    //endregion
    //region Init & destroy
    value: function finalizeInit() {
      var me = this;
      me.anchoredTo = me.forElement;
      me.initialAnchor = me.anchor;

      if (me.forElement && me.showOnClick) {
        // disable autoShow if not enabled by config
        if (!me.initialConfig.autoShow) {
          me.autoShow = false;
        }

        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
          element: me.forElement,
          click: 'onElementUserAction',
          thisObj: me
        });
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Popup.prototype), "finalizeInit", this).call(this);

      if (me.autoShow) {
        if (me.autoShow === true) {
          me.show();
        } else {
          me.setTimeout(function () {
            return me.show();
          }, me.autoShow);
        }
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.syncModalMask();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Popup.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Show/hide

    /**
     * Performs the configured {@link #config-closeAction} upon this popup.
     * By default, the popup hides. The {@link #config-closeAction} may be
     * configured as `'destroy'`.
     * @fires beforeclose If popup is not hidden
     */

  }, {
    key: "close",
    value: function close() {
      var me = this;
      /**
       * Fired when the {@link #function-close} method is called and the popup is not hidden.
       * May be vetoed by returning `false` from a handler.
       * @event beforeClose
       * @param {Core.widget.Popup} source - This Popup
       */

      if (!me._hidden && me.trigger('beforeClose') !== false || // we should destroy it even if it's hidden just omit beforeclose event
      me._hidden && me.closeAction === 'destroy') {
        // Focus moves unrelated to where the user's attention is upon this gesture.
        // Go into the keyboard mode where the focused widget gets a rendition so that
        // it is obvious where focus now is.
        // Must jump over EventHelper's global mousedown listener which will remove this class.
        if (me.containsFocus && me.highlightReturnedFocus) {
          me.setTimeout(function () {
            return document.body.classList.add('b-using-keyboard');
          }, 0);
        }

        return me[me.closeAction]();
      }
    } //endregion
    //region Events

  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(event) {
      // close on escape key
      if (event.key === 'Escape') {
        event.stopImmediatePropagation();
        this.close(true);
      }
    }
  }, {
    key: "onDocumentMouseDown",
    value: function onDocumentMouseDown(_ref) {
      var event = _ref.event;
      var me = this;

      if (me.modal && event.target === Popup.modalMask) {
        event.preventDefault();

        if (me.modal.closeOnMaskTap) {
          me.close();
        } else if (!me.containsFocus) {
          me.focus();
        }
      } // in case of outside click and if popup is focused, focusout will trigger closing
      else if (!me.owns(event.target) && me.autoClose && !me.containsFocus) {
          me.close();
        }
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      var activeEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].activeElement;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Popup.prototype), "onFocusIn", this).call(this, e); // No event handler has moved focus, and target is outermost el
      // then delegate to the focusElement which for a Container
      // is found by finding the first visible, focusable descendant widget.


      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].activeElement === activeEl && e.target === this.element) {
        this.focus();
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      if (!this.modal && this.autoClose) {
        this.close();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Popup.prototype), "onFocusOut", this).call(this, e);
    }
  }, {
    key: "onShow",
    value: function onShow() {
      var me = this;

      if (me.autoClose) {
        me.addDocumentMouseDownListener();
      } // TODO: It's the floating "toFront" operation that should handle
      // focusing based on config focusOnToFront.


      if (me.focusOnToFront) {
        me.focus();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Popup.prototype), "onShow", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Popup.prototype), "onShow", this).call(this); // Insert the modal mask below this Popup if needed

      me.syncModalMask();
    }
  }, {
    key: "addDocumentMouseDownListener",
    value: function addDocumentMouseDownListener() {
      if (!this.mouseDownRemover) {
        this.mouseDownRemover = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
          globaltap: 'onDocumentMouseDown',
          thisObj: this
        });
      }
    }
  }, {
    key: "syncModalMask",
    value: function syncModalMask() {
      var me = this,
          modal = me.modal; // Note the difference between Popup.modalMask and this.modalMask.
      // this.modalMask syncs the position of the element in the DOM
      // to be below this element. Popup.modalMask just returns the element.

      if (modal && me.isVisible) {
        // If we have not been explicitly positioned, a modal is centered.
        if (!me._x && !me._y) {
          me.centered = true;
        }

        me.modalMask.classList.remove('b-hide-display');
        me.element.classList.add('b-modal');
      } else {
        me.element.classList.remove('b-modal');
        var remainingModals = me.constructor.floatRoot.querySelectorAll('.b-modal'),
            topModal = remainingModals.length ? Popup.fromElement(remainingModals[remainingModals.length - 1], 'popup') : null; // If there are any other visible modals, drop the mask to just below the new topmost

        if (topModal) {
          topModal.syncModalMask();
        } else {
          Popup.modalMask.classList.add('b-hide-display');
        }
      }
    }
  }, {
    key: "onHide",
    value: function onHide() {
      var me = this;

      if (me.mouseDownRemover) {
        me.mouseDownRemover();
        me.mouseDownRemover = null;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Popup.prototype), "onHide", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Popup.prototype), "onHide", this).call(this); // Insert the modal mask below the topmost Popup if needed, else hide it

      me.syncModalMask();
    }
  }, {
    key: "onElementUserAction",
    value: function onElementUserAction() {
      this.show();
    } //endregion

  }, {
    key: "updateClosable",
    value: function updateClosable(closable) {
      this.tools.close[closable ? 'show' : 'hide'](); // Ensure headerElement is shown if needed and hidden if not

      if (!this.title) {
        this.headerElement.classList[Object.values(this.tools).some(function (t) {
          return !t.hidden;
        }) ? 'remove' : 'add']('b-hide-display');
      }
    }
  }, {
    key: "updateTextContent",
    value: function updateTextContent(textContent) {
      // Popup has extra CSS responsibilities at the top level.
      // The CSS needs to know whether it should impose a max-width.
      this.element.classList[textContent && this.hasNoChildren ? 'add' : 'remove']('b-text-popup');

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Popup.prototype), "updateTextContent", this).call(this, textContent);
    }
    /**
     * Returns the modal mask element for this Popup correctly positioned just below this Popup.
     * @internal
     */

  }, {
    key: "isTopModal",
    get: function get() {
      return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isVisible(Popup.modalMask) && this.element.previousElementSibling === Popup.modalMask;
    }
  }, {
    key: "modalMask",
    get: function get() {
      var modalMask = Popup.modalMask;

      if (modalMask.nextElementSibling !== this.element) {
        Popup.floatRoot.insertBefore(modalMask, this.element);
      }

      return modalMask;
    }
    /**
     * Returns the modal mask element. It does NOT guarantee its placement in the DOM relative
     * to any Popup. To get the modal mask for a particular Popup, use the instance property.
     * @internal
     */

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Popup';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'popup';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Auto show flag for Popup.
         * If truthy then Popup is shown automatically upon hover.
         * @config {Boolean}
         * @default
         */
        autoShow: true,

        /**
         * By default a Popup is transient, and will {@link #function-close} when the user clicks or
         * taps outside its owned widgets and when focus moves outside its owned widgets.
         *
         * **Note**: {@link #config-modal Modal} popups won't {@link #function-close} when focus moves outside even if autoClose is `true`.
         *
         * Configure as `false` to make a Popup non-transient.
         * @config {Boolean}
         * @default
         */
        autoClose: true,

        /**
         * Show popup when user clicks the element that it is anchored to. Cannot be combined with showOnHover
         * @config {Boolean}
         * @default
         */
        showOnClick: false,

        /**
         * DOM element to attach popup.
         * @config {HTMLElement}
         */
        forElement: null,
        monitorResize: true,
        floating: true,
        hidden: true,
        axisLock: true,
        // Flip edges if align violates constrainTo
        hideAnimation: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isIE11 ? null : {
          opacity: {
            from: 1,
            to: 0,
            duration: '.3s',
            delay: '0s'
          }
        },
        showAnimation: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isIE11 ? null : {
          opacity: {
            from: 0,
            to: 1,
            duration: '.4s',
            delay: '0s'
          }
        },
        testConfig: {
          hideAnimation: null,
          showAnimation: null
        },

        /**
         * The action to take when calling the {@link #function-close} method.
         * By default, the popup is hidden.
         *
         * This may be set to `'destroy'` to destroy the popup upon close.
         * @config {String}
         * @default
         */
        closeAction: 'hide',

        /**
         * By default, tabbing within a Popup is circular - that is it does not exit.
         * Configure this as `false` to allow tabbing out of the Popup.
         * @config {Boolean}
         * @default
         */
        trapFocus: true,

        /**
         * By default a Popup is focused when it is shown.
         * Configure this as `false` to prevent automatic focus on show.
         * @config {Boolean}
         * @default
         */
        focusOnToFront: true,

        /**
         * Show a tool in the header to close this Popup, and allow `ESC` close it.
         * The tool is available in the {@link #property-tools} object
         * under the name `close`. It uses the CSS class `b-popup-close` to apply a
         * default close icon. This may be customized with your own CSS rules.
         * @config {Boolean}
         * @default
         */
        closable: null,

        /**
         * Optionally show an opaque mask below this Popup when shown.
         * Configure this as `true` to show the mask.
         *
         * When a Popup is modal, it defaults to being {@link Core.widget.Widget#config-centered centered}.
         * Also it won't {@link #function-close} when focus moves outside even if {@link #config-autoClose} is `true`.
         *
         * May also be an object containing the following properties:
         * * `closeOnMaskTap` Specify as `true` to {@link #function-close} when mask is tapped.
         * The default action is to focus the popup.
         *
         * Usage:
         * ```javascript
         * new Popup({
         *     title  : 'I am modal',
         *     modal  : {
         *         closeOnMaskTap : true
         *     },
         *     height : 100,
         *     width  : 200
         * });
         * ```
         *
         * @config {Boolean}
         * @default
         */
        modal: null,
        tools: {
          close: {
            cls: 'b-popup-close',
            handler: 'close',
            weight: -1000,
            hidden: true // shown when closable set to true

          }
        },
        highlightReturnedFocus: true
      };
    }
  }, {
    key: "modalMask",
    get: function get() {
      return this._modalMask || (this._modalMask = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].createElement({
        className: 'b-modal-mask b-hide-display'
      }));
    }
  }]);

  return Popup;
}(_Panel_js__WEBPACK_IMPORTED_MODULE_12__["default"]); // Register this widget type with its Factory



Popup.initClass();
Popup._$name = 'Popup';

/***/ }),

/***/ "./lib/Core/widget/Renderable.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/Renderable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Renderable; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");









































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_38___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';








var defineProperty = Reflect.defineProperty;
/**
 * @module Core/widget/Renderable
 */

/**
 * This class provides element rendering and automatic synchronization based on config property changes.
 *```
 *  class Label extends Renderable {
 *      static get configurable() {
 *          return {
 *              text : {
 *                  value: null,
 *
 *                  $config : 'render'
 *              }
 *          };
 *      }
 *
 *      renderDom() {
 *          return {
 *              tag: 'label',
 *              children: [
 *                  this.text
 *              ]
 *          };
 *      }
 *  }
 *```
 * A class can opt to not specify its render configs. In this case, these will be determined automatically, but with
 * some additional cost. This may not be worth considering if only a few instances are ever likely.
 *
 * @private
 */

var Renderable = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_37___default()(Renderable, _Base$mixin);

  var _super = _createSuper(Renderable);

  function Renderable() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_34___default()(this, Renderable);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_35___default()(Renderable, [{
    key: "construct",
    //region Init
    value: function construct() {
      var _get2;

      this.$iid = ++Renderable.$idSeed;
      this.byRef = {};

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_36___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39___default()(Renderable.prototype), "construct", this)).call.apply(_get2, [this].concat(args));

      if (this.onDraw !== Renderable.prototype.onDraw) {
        this.initDrawable();
      }
    }
  }, {
    key: "startConfigure",
    value: function startConfigure(config) {
      this.element = this.renderContext.renderDom(); // calls changeElement()

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_36___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_39___default()(Renderable.prototype), "startConfigure", this).call(this, config);
    } //endregion
    //region Configs

  }, {
    key: "changeElement",

    /**
     * This is called when the `element` config is assigned (via the setter).
     * @param {HTMLElement} element The new element being assigned.
     * @param {HTMLElement} oldElement The old element (previously assigned) or `null`.
     * @returns {HTMLElement}
     * @private
     */
    value: function changeElement(element, oldElement) {
      var me = this;

      if (oldElement) {
        oldElement.remove();
      }

      if (element) {
        element.id = me.id;
        element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_41__["default"].createElement(element, {
          refOwner: me
        });
      }

      return element;
    }
  }, {
    key: "updateId",
    value: function updateId(id, oldId) {
      var me = this;

      if (oldId) {
        var element = me.element;
        element.id = id;
        me.fixRefOwnerId(element, id, oldId);
      }
    } //endregion
    //region Misc

    /**
     * Returns the `classList` of this instance's `element`.
     * @returns {DOMTokenList}
     */

  }, {
    key: "fixRefOwnerId",

    /**
     * This method fixes the element's `$refOwnerId` when this instance's `id` is changing.
     * @param {HTMLElement} el The element to fix.
     * @param {String} id The new id being assigned.
     * @param {String} oldId The old id (previously assigned).
     * @private
     */
    value: function fixRefOwnerId(el, id, oldId) {
      if (el.$refOwnerId === oldId) {
        el.$refOwnerId = id;
        var ref = el.$reference;

        if (ref) {
          el.id = "".concat(id, "-").concat(ref);
        }

        var _iterator = _createForOfIteratorHelper(el.childNodes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var c = _step.value;
            this.fixRefOwnerId(c, id, oldId);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "onConfigChange",
    value: function onConfigChange(_ref) {
      var name = _ref.name;

      // The $renderConfigs Set is either on our prototype (due to renderConfigs getter) or on our instance (due to
      // renderContext getter):
      if (!this.isConfiguring && this.$renderConfigs.has(name)) {
        this.refreshDom();
      }
    } //endregion
    //region Rendering

    /**
     * This method is called by `DomHelper.createElement` and `DomSync.sync` as new reference elements are created.
     * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
     * @param {HTMLElement} el The element instance
     * @param {Object} domConfig The DOM config object.
     * @private
     */

  }, {
    key: "attachRef",
    value: function attachRef(name, el, domConfig) {
      var me = this,
          key = '_' + name,
          listeners = domConfig.listeners;

      if (!(key in me)) {
        defineProperty(me, name, {
          get: function get() {
            // Asking for a ref el is a good sign that we need to sync the DOM:
            me.refreshDom.flush();
            return me[key];
          },
          set: function set(el) {
            me[key] = el; // Key elements contain owner pointer (Not supported on IE SVG).
            // if (el && el.dataset) {
            //     el.dataset.ownerCmp = me.id;
            // }
          }
        });
      }

      el.id = "".concat(me.id, "-").concat(name);
      me[name] = el;

      if (listeners) {
        domConfig.listeners = {
          on: listeners,
          un: _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].on(Object.assign({
            element: el,
            thisObj: me
          }, listeners))
        };
      }
    }
    /**
     * This method is called by `DomSync.sync` as reference elements are removed from the DOM.
     * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
     * @param {HTMLElement} el The element instance
     * @param {Object} domConfig The DOM config object.
     * @private
     */

  }, {
    key: "detachRef",
    value: function detachRef(name, el, domConfig) {
      if (domConfig.listeners) {
        domConfig.listeners.un();
        domConfig.listeners = null;
      }

      this[name] = null;
    }
    /**
     * This method returns a {@link Core.helper.DomHelper#function-createElement-static} config object that describes
     * the desired elements for this instance.
     *
     * This method is called to produce the initial DOM structure and again as necessary to generate the DOM for the
     * current state. The DOM produced by these subsequent calls is then passed through
     * {@link Core.helper.DomSync#function-sync-static DomSync.sync()} to update the DOM.
     * @returns {Object}
     */

  }, {
    key: "renderDom",
    value: function renderDom() {
      // abstract method provided by derived class
      return {};
    }
    /**
     * This property is the object to use when calling the `renderDom` method. It may evaluate to this instance (if
     * the class declares its render configs) or a helper object to track config usage during the `renderDom` call.
     * @property {Object}
     * @private
     */

  }, {
    key: "refreshDom",

    /**
     * This method synchronized the DOM produced by {@link #function-renderDom} with what was previously produced and
     * updates the elements accordingly.
     *
     * This method is buffered such that calls to it do not immediately execute. To perform the refresh immediately,
     * do this:
     *```
     *  instance.refreshDom.now();
     *```
     * To flush any potential updates to the DOM (and do nothing if there are none), do this:
     *```
     *  instance.refreshDom.flush();
     *```
     * To determine if there are updates to the DOM pending, do this:
     *```
     *  if (instance.refreshDom.isPending) {
     *      ...
     *  }
     *```
     */
    value: function refreshDom() {
      _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_42__["default"].sync({
        targetElement: this.element,
        domConfig: this.renderContext.renderDom(),
        refOwner: this,
        // This limits the sync() to only removing the classes and styles added by previous renderings. This
        // allows dynamically added styles and classes to be preserved:
        strict: true
      });
    } //endregion

  }, {
    key: "onListen",
    value: function onListen(eventName) {
      // Only add the b-drawable-el when someone first listens for the draw event since it may never happen...
      if (eventName === 'draw') {
        this.initDrawable();
      }
    }
  }, {
    key: "initDrawable",
    value: function initDrawable() {
      var me = this;

      if (!me.intersector) {
        var el = Object.values(me.byRef).find(function (el) {
          return el.classList.contains('b-drawable');
        });

        if (!el) {
          el = me.element;
          el.classList.add('b-drawable');
        } // TODO Not supported in IE11 even w/polyfills at the moment


        me.intersector = true; // me.intersector = new IntersectionObserver(entries => {
        //     if (!me.isDestroyed) {
        //         entries.forEach(ent => {
        //             if (ent.isIntersecting) {
        //                 me.onDraw({
        //                     count : ++me.drawCounter
        //                 });
        //             }
        //         });
        //     }
        // });
        //
        // me.intersector.observe(el);

        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].on({
          element: _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_41__["default"].createElement({
            parent: el,
            class: 'b-drawable-el'
          }),
          animationend: function animationend(_ref2) {
            var animationName = _ref2.animationName;

            if (animationName === 'b-drawable-anim') {
              me.onDraw({
                count: ++me.drawCounter
              });
            }
          }
        });
      }
    }
  }, {
    key: "onDraw",
    value: function onDraw(ev) {
      this.trigger('draw', ev);
    }
  }, {
    key: "element",
    get: function get() {
      // NOTE: We can replace the getter of a config using defineConfig()...
      // Asking for the primary el is a good sign that we need to sync the DOM:
      this.refreshDom.flush();
      return this._element;
    }
  }, {
    key: "classes",
    get: function get() {
      return this.element.classList;
    }
  }, {
    key: "renderContext",
    get: function get() {
      var me = this,
          meta = me.$meta,
          C = me.constructor;
      var renderConfigs = meta.renderConfigs || C.renderConfigs,
          context = me; // If the class author did not declare any configs as render:true, then we make a proxy-like object that can
      // detect getter calls to build that Set. Since the getters may not all trigger on any given rendering, we
      // cannot share this work across instances since they may take different control paths.

      if (!renderConfigs) {
        context = Object.create(me);
        renderConfigs = new Set();

        var _loop = function _loop(name) {
          defineProperty(context, name, {
            get: function get() {
              renderConfigs.add(name);
              return me[name];
            }
          });
        };

        for (var name in meta.configs) {
          _loop(name);
        } // In order to be substitutable for the Renderable, we need the same method name... we just need to run
        // renderDom w/ our context as "this":


        context.renderDom = function () {
          return me.renderDom.call(context);
        };

        me.$renderConfigs = renderConfigs;
      } // Replace this getter with the actual context so we don't get called again:


      defineProperty(me, 'renderContext', {
        value: context
      });
      return context;
    }
  }], [{
    key: "configurable",
    get: function get() {
      return {
        /**
         * The top-level DOM element for this object. This element is produced from the {@link #function-renderDom}
         * method of the derived class. As configs used by `renderDom` change, a synchronization of the DOM is
         * scheduled by calling {@link #function-refreshDom}. This call is made automatically by this class, making
         * it rarely necessary to call `refreshDom` directly.
         * @config {HTMLElement}
         * @category DOM
         */
        element: null
      };
    }
  }, {
    key: "delayable",
    get: function get() {
      return {
        refreshDom: 'raf'
      };
    }
  }, {
    key: "identifiable",
    get: function get() {
      return {};
    }
    /**
     * Returns the Set of configs defined as `render: true`, that is, the configs that determine the rendering (via
     * `renderDom`). If no such configs are defined, this method returns `null`.
     *
     * @returns {Set}
     * @private
     */

  }, {
    key: "renderConfigs",
    get: function get() {
      var me = this,
          meta = me.$meta;
      var renderConfigs = meta.renderConfigs,
          configs,
          name;

      if (renderConfigs === undefined) {
        // if (first time for this class)
        renderConfigs = null;
        configs = meta.configs;

        for (name in configs) {
          if (configs[name].render) {
            (renderConfigs || (renderConfigs = new Set())).add(name);
          }
        } // Put $renderConfigs on the prototype so that onConfigChange is as simple as possible:


        meta.renderConfigs = me.prototype.$renderConfigs = renderConfigs;
      }

      return renderConfigs;
    }
  }]);

  return Renderable;
}(_Base_js__WEBPACK_IMPORTED_MODULE_47__["default"].mixin(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_45__["default"], _mixin_Events_js__WEBPACK_IMPORTED_MODULE_44__["default"], _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_40__["default"], _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_46__["default"]));


Renderable.$idSeed = 0;
Object.assign(Renderable.prototype, {
  drawCounter: 0,
  hasGeneratedId: false,
  intersector: null
});
Renderable._$name = 'Renderable';

/***/ }),

/***/ "./lib/Core/widget/Ripple.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Ripple.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Ripple; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






var lastTouchTime = 0;

var hasRipple = function hasRipple(w) {
  return w.ripple;
},
    Ripple = window.Ripple = new ( /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Ripple, _Widget);

  var _super = _createSuper(Ripple);

  function Ripple() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, Ripple);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(Ripple, [{
    key: "afterConstruct",
    value: function afterConstruct() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Ripple.prototype), "afterConstruct", this).call(this);

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
        element: document,
        mousedown: 'onRippleControllingEvent',
        thisObj: this,
        capture: true,
        once: true
      });
    }
  }, {
    key: "onRippleControllingEvent",
    value: function onRippleControllingEvent(event) {
      var me = this;
      me.show();
      var rippleAnimation = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStyleValue(me.circleElement, 'animationName');
      me.hide();
      me.listenerDetacher && me.listenerDetacher(); // If our theme supports ripples, add our listeners

      if (rippleAnimation && rippleAnimation !== 'none') {
        me.listenerDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
          // Trap all mousedowns and see if the encapsulating Component is configured to ripple
          mousedown: {
            element: document,
            capture: true,
            handler: 'onDocumentMousedown'
          },
          touchstart: {
            element: document,
            capture: true,
            handler: 'onDocumentTouchStart'
          },
          // Hide at the end of the ripple
          animationend: {
            element: me.circleElement,
            handler: 'onAnimationEnd'
          },
          thisObj: me
        }); // If this is the first mousedown, start listening to theme changes and trigger ripple manually

        if (event.type === 'mousedown') {
          me.onDocumentMousedown(event);
          _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
            theme: 'onRippleControllingEvent',
            thisObj: this
          });
        }
      }
    }
  }, {
    key: "onDocumentTouchStart",
    value: function onDocumentTouchStart(event) {
      lastTouchTime = performance.now();
      this.handleTriggerEvent(event);
    }
  }, {
    key: "onDocumentMousedown",
    value: function onDocumentMousedown(event) {
      // We need to prevent a touchend->mousedown simulated mousedown from triggering a ripple.
      // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent
      if (performance.now() - lastTouchTime > 200) {
        this.handleTriggerEvent(event);
      }
    }
  }, {
    key: "handleTriggerEvent",
    value: function handleTriggerEvent(event) {
      var targetWidget = _Widget_js__WEBPACK_IMPORTED_MODULE_10__["default"].fromElement(event.target, hasRipple);

      if (targetWidget) {
        var rippleCfg = targetWidget.ripple,
            _target = rippleCfg.delegate ? event.target.closest(rippleCfg.delegate) : targetWidget.focusElement || targetWidget.element;

        if (_target) {
          var ripple = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].assign({
            event: event,
            target: _target,
            radius: this.radius
          }, rippleCfg); // The clip option is specified as a string property name or delegate

          if (typeof ripple.clip === 'string') {
            ripple.clip = targetWidget[ripple.clip] || event.target.closest(ripple.clip); // Not inside an instance of the clip delegate, then no ripple

            if (!ripple.clip) {
              return;
            }
          }

          this.ripple(ripple);
        }
      }
    }
  }, {
    key: "ripple",
    value: function ripple(_ref) {
      var event = _ref.event,
          _ref$point = _ref.point,
          point = _ref$point === void 0 ? _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getClientPoint(event) : _ref$point,
          _ref$target = _ref.target,
          target = _ref$target === void 0 ? event.target : _ref$target,
          _ref$clip = _ref.clip,
          clip = _ref$clip === void 0 ? target : _ref$clip,
          _ref$radius = _ref.radius,
          radius = _ref$radius === void 0 ? this.radius : _ref$radius,
          _ref$color = _ref.color,
          color = _ref$color === void 0 ? this.color : _ref$color;
      this.clip = clip;
      clip = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(clip, null, true);
      var me = this,
          centreDelta = clip.getDelta(point),
          rippleStyle = me.rippleElement.style,
          circleElement = me.circleElement;
      me.hide();
      me.alignTo(clip);
      rippleStyle.transform = "translateX(".concat(centreDelta[0], "px) translateY(").concat(centreDelta[1], "px)");
      rippleStyle.height = rippleStyle.width = "".concat(radius, "px");
      circleElement.setAttribute('r', radius);
      circleElement.setAttribute('fill', color);
      me.show(); // Push binding to the scroll position out until the next animation frame.
      // This is in case the calling code is going to cause a scroll.
      // Mousedown is a focusing gesture which may cause a scroll
      // to fire as the target element moves into view.

      me.requestAnimationFrame(function () {
        document.addEventListener('scroll', me.callRealign, true);
        me.documentScrollListener = true;
      });
    }
  }, {
    key: "alignTo",
    value: function alignTo(clip) {
      if (clip.nodeType === 1) {
        clip = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(clip, null, true);
      }

      var me = this,
          _clip = clip,
          x = _clip.x,
          y = _clip.y,
          width = _clip.width,
          height = _clip.height;
      me.x = x;
      me.y = y;
      me.height = height;
      me.width = width;
    } // When fully expanded, it's all over.

  }, {
    key: "onAnimationEnd",
    value: function onAnimationEnd(event) {
      if (event.animationName === 'b-ripple-expand') {
        this.hide();
      }
    }
  }, {
    key: "realign",
    value: function realign() {
      if (this.isVisible) {
        this.alignTo(this.clip);
      }
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        id: 'bryntum-ripple',
        old_element: {
          children: [{
            className: 'b-ripple-inner',
            reference: 'rippleElement'
          }]
        },
        element: {
          children: [{
            tag: 'svg',
            class: 'b-ripple-inner',
            reference: 'rippleElement',
            ns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 100 100',
            children: [{
              reference: 'circleElement',
              tag: 'circle',
              cx: '0',
              cy: '0',
              r: 10
            }]
          }]
        },
        floating: true,
        hideAnimation: false,
        showAnimation: false,
        scrollAction: 'realign',
        color: 'rgba(0,0,0,.3)',
        startRadius: 10,
        radius: 100
      };
    }
  }, {
    key: "$name",
    get: function get() {
      return 'Ripple';
    }
  }]);

  return Ripple;
}(_Widget_js__WEBPACK_IMPORTED_MODULE_10__["default"]))();



/***/ }),

/***/ "./lib/Core/widget/Slider.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Slider.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Slider; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");












function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_4___default()(["\n            <div class=\"", "\">\n                <input type=\"range\"\n                   data-reference=\"input\"\n                   id=\"", "-input\"\n                   min=\"", "\"\n                   max=\"", "\"\n                   step=\"", "\"\n                   value=\"", "\">\n                <label data-reference=\"label\" for=\"", "-input\">", "</label>\n            </div>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/widget/Slider
 */

/**
 * Wraps native &lt;input type="range"&gt;
 *
 * @extends Core/widget/Widget
 *
 * @example
 * let slider = new Slider({
 *   text: 'Choose value'
 * });
 *
 * @classType slider
 * @externalexample widget/Slider.js
 */

var Slider = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Slider, _Widget);

  var _super = _createSuper(Slider);

  function Slider() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Slider);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Slider, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Slider.prototype), "construct", this).call(this, config);

      me.updateLabel();

      if (me.showTooltip) {
        me.tip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_13__["default"]({
          forElement: me.input,
          anchor: false,
          // No anchor displayed since thumbSize is different for different themes
          align: 'b-t',
          axisLock: true
        });
      }

      me.input.addEventListener('input', me.onInternalInput.bind(me));
      me.input.addEventListener('change', me.onInternalChange.bind(me));
      me.input.addEventListener('mouseover', me.onInternalMouseOver.bind(me));
      me.input.addEventListener('mouseout', me.onInternalMouseOut.bind(me));
    }
  }, {
    key: "template",
    value: function template(widget) {
      return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].tpl(_templateObject(), widget.text ? 'b-text b-has-label' : '', widget.id, widget.min, widget.max, widget.step, widget.value, widget.id, widget.text);
    }
  }, {
    key: "onInternalInput",
    //endregion
    //region Events

    /**
     * Fired while slider thumb is being dragged
     * @event input
     * @param {Core.widget.Slider} source - The slider
     * @param {String} value - The value
     */

    /**
     * Fired after the slider value changes (on mouse up following slider interaction)
     * @event change
     * @param {String} value - Value
     * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
     * @param {Core.widget.Slider} source - The slider
     */
    value: function onInternalInput(event) {
      var me = this;
      me._value = parseInt(me.input.value);
      me.updateUI();
      me.trigger('input', {
        value: me.value
      });
    }
  }, {
    key: "onInternalChange",
    value: function onInternalChange(event) {
      var me = this;
      me.updateUI();
      me.triggerChange(true);
      me.trigger('action', {
        value: me.value
      });
    }
  }, {
    key: "onInternalMouseOver",
    value: function onInternalMouseOver(event) {
      var me = this;
      me.updateLabel();

      if (me.tip) {
        me.tip.showBy({
          target: me.calcThumbPosition(),
          offset: 5
        });
      }
    }
  }, {
    key: "onInternalMouseOut",
    value: function onInternalMouseOut(event) {
      if (this.tip) {
        this.tip.hide();
      }
    }
  }, {
    key: "triggerChange",
    value: function triggerChange(userAction) {
      this.triggerFieldChange({
        value: this.value,
        valid: true,
        userAction: userAction
      });
    } //endregion
    //region Getters/setters

    /**
     * Get/Set text. Appends value if Slider.showValue is true
     * @property {String}
     */

  }, {
    key: "updateLabel",
    //endregion
    //region Util

    /**
     * Refresh label text
     * @private
     */
    value: function updateLabel() {
      this.text = this._text;
    }
    /**
     * Refresh tooltip position
     * @private
     */

  }, {
    key: "updateTooltipPosition",
    value: function updateTooltipPosition() {
      if (this.tip) {
        this.tip.alignTo({
          target: this.calcThumbPosition(),
          offset: 5
        });
      }
    }
    /**
     * Refresh slider UI
     * @private
     */

  }, {
    key: "updateUI",
    value: function updateUI() {
      this.updateLabel();
      this.updateTooltipPosition();
    }
  }, {
    key: "calcThumbPosition",
    value: function calcThumbPosition() {
      var me = this,
          inputRect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(me.input),
          offset = (inputRect.width - me.thumbSize) * me.calcPercentProgress() / 100;
      return new _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"](inputRect.x + offset, inputRect.y + inputRect.height / 2 - me.thumbSize / 2, me.thumbSize, me.thumbSize);
    }
  }, {
    key: "calcPercentProgress",
    value: function calcPercentProgress() {
      return (this.value - this.min) / (this.max - this.min) * 100;
    } //endregion

  }, {
    key: "focusElement",
    get: function get() {
      return this.input;
    }
  }, {
    key: "text",
    get: function get() {
      return this._text;
    },
    set: function set(text) {
      var me = this;
      me._text = text;

      if (me.label) {
        if (me.showValue) {
          text = text ? "".concat(text, " (").concat(me.value, ")") : me.value;
        }

        me.label.innerHTML = text;
      }

      if (me.tip) {
        me.tip.html = me.value;
      }
    }
    /**
     * Get/set value
     * @property {Number}
     */

  }, {
    key: "value",
    get: function get() {
      return this.input ? parseInt(this.input.value) : this._value;
    },
    set: function set(value) {
      var me = this;

      if (me._value !== value) {
        if (me.input) {
          me.input.value = value;
          me.updateUI();
          me.triggerChange(false);
        }

        me._value = value;
      }
    }
    /**
     * Get/set min value
     * @property {Number}
     */

  }, {
    key: "min",
    get: function get() {
      return this.input ? this.input.min : this._min;
    },
    set: function set(min) {
      var me = this;

      if (me.input) {
        me.input.min = min;

        if (me._value < min) {
          me.value = min;
          me.trigger('input', {
            value: me.value
          });
        }
      }

      me._min = min;
    }
    /**
     * Get/set max value
     * @property {Number}
     */

  }, {
    key: "max",
    get: function get() {
      return this.input ? this.input.max : this._max;
    },
    set: function set(max) {
      var me = this;

      if (me.input) {
        me.input.max = max;

        if (me._value > max) {
          me.value = max;
          me.trigger('input', {
            value: me.value
          });
        }
      }

      me._max = max;
    }
    /**
     * Get/set step size
     * @property {Number}
     */

  }, {
    key: "step",
    get: function get() {
      return this.input ? this.input.step : this._step;
    },
    set: function set(step) {
      if (this.input) this.input.step = step;
      this._step = step;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Slider';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'slider';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Slider label text
         * @config {String}
         */
        text: '',

        /**
         * Show value in label (appends in () if text is set)
         * @config {Boolean}
         * @default
         */
        showValue: true,

        /**
         * Show value in tooltip
         * @config {Boolean}
         * @default
         */
        showTooltip: false,

        /**
         * Minimum value
         * @config {Number}
         * @default
         */
        min: 0,

        /**
         * Maximum value
         * @config {Number}
         * @default
         */
        max: 100,

        /**
         * Step size
         * @config {Number}
         * @default
         */
        step: 1,

        /**
         * Initial value
         * @config {Number}
         */
        value: null,
        // The value is set in the Light theme. The Material theme will have different value.
        thumbSize: 20,
        localizableProperties: ['text']
      };
    }
  }]);

  return Slider;
}(_Widget_js__WEBPACK_IMPORTED_MODULE_11__["default"]); // Register this widget type with its Factory



Slider.initClass();
Slider._$name = 'Slider';

/***/ }),

/***/ "./lib/Core/widget/Splitter.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/Splitter.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Splitter; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/widget/Splitter
 */

var hasFlex = function hasFlex(el) {
  return parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStyleValue(el, 'flex-basis'), 10) || parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStyleValue(el, 'flex-grow'), 10);
};
/**
 * A simple splitter widget that resizes the elements next to it or above/below it depending on orientation.
 *
 * @extends Core/widget/Widget
 * @classType splitter
 * @externalexample widget/Splitter.js
 */


var Splitter = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(Splitter, _Widget);

  var _super = _createSuper(Splitter);

  function Splitter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, Splitter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default()(Splitter, [{
    key: "doDestroy",
    //endregion
    //region Init & destroy
    value: function doDestroy() {
      this.mouseDetacher && this.mouseDetacher();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Splitter.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Template & element

  }, {
    key: "template",
    value: function template() {
      return '<div class="b-splitter"></div>';
    }
  }, {
    key: "updateOrientation",
    // Determines current orientation if configured with 'auto'. Adds orientation cls
    value: function updateOrientation() {
      var me = this,
          element = this.element;

      if (me._prevOrientation) {
        element.classList.remove(me._prevOrientation);
      } // Orientation auto and already rendered, determine orientation to use


      if (!me._currentOrientation && me.rendered && element.offsetParent) {
        var flexDirection = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStyleValue(element.parentElement, 'flex-direction'); // If used in a flex layout, determine orientation from flex-direction

        if (flexDirection) {
          me._currentOrientation = flexDirection.startsWith('column') ? 'horizontal' : 'vertical';
        } // If used in some other layout, try to determine form sibling elements position
        else {
            var previous = element.previousElementSibling,
                next = element.nextElementSibling;

            if (!previous || !next) {
              // To early in rendering, next sibling not rendered yet
              return;
            }

            var prevRect = previous.getBoundingClientRect(),
                nextRect = next.getBoundingClientRect(),
                topMost = prevRect.top < nextRect.top ? prevRect : nextRect,
                bottomMost = topMost === nextRect ? prevRect : nextRect;
            me._currentOrientation = topMost.top !== bottomMost.top ? 'horizontal' : 'vertical';
          }
      }

      if (me._currentOrientation) {
        element.classList.add("b-".concat(me._currentOrientation));
      }

      me._prevOrientation = me._currentOrientation;
    } //endregion
    //region Events

  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      event.preventDefault();

      if (event.touches) {
        event = event.touches[0];
      }

      var me = this,
          element = me.element,
          prev = element.previousElementSibling,
          next = element.nextElementSibling,
          prevHasFlex = hasFlex(prev),
          nextHasFlex = hasFlex(next),
          flexed = []; // First stop any ongoing drag operation, since we cannot trust that we always get the mouseup event

      me.mouseDetacher && me.mouseDetacher(); // Remember flexed children, to enable maintaining their proportions on resize

      var _iterator = _createForOfIteratorHelper(element.parentElement.children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;

          if (hasFlex(child) && child !== element) {
            flexed.push({
              element: child,
              width: child.offsetWidth,
              height: child.offsetHeight
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      me.context = {
        startX: event.pageX,
        startY: event.pageY,
        prevWidth: prev.offsetWidth,
        prevHeight: prev.offsetHeight,
        nextWidth: next.offsetWidth,
        nextHeight: next.offsetHeight,
        prevHasFlex: prevHasFlex,
        nextHasFlex: nextHasFlex,
        flexed: flexed,
        prev: prev,
        next: next
      };
      var events = {
        element: document,
        pointermove: 'onMouseMove',
        pointerup: 'onMouseUp',
        thisObj: me
      };

      if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].supportsPointerEvents) {
        events.mousemove = 'onMouseMove';
        events.touchmove = 'onMouseMove';
        events.mouseup = events.touchend = 'onMouseUp';
      }

      me.mouseDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].on(events);
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      var me = this,
          context = me.context,
          deltaX = event.pageX - context.startX,
          deltaY = event.pageY - context.startY;
      event.preventDefault();
      Object.assign(context, {
        deltaX: deltaX,
        deltaY: deltaY
      });

      if (!context.started) {
        context.started = true;
        me.trigger('start', {
          context: context,
          event: event
        }); // Convert heights/widths to flex for flexed elements to maintain proportions
        // 100px high -> flex-grow 100

        context.flexed.forEach(function (flexed) {
          if (me.currentOrientation === 'vertical') {
            flexed.element.style.flexGrow = flexed.width;
          } else {
            flexed.element.style.flexGrow = flexed.height;
          } //Remove flex-basis, since it interferes with resizing


          flexed.element.style.flexBasis = '0';
        });
      } // Adjust flex-grow or width/height for splitters closest siblings


      if (me.currentOrientation === 'vertical') {
        var newPrevWidth = context.prevWidth + deltaX,
            newNextWidth = context.nextWidth - deltaX;

        if (context.prevHasFlex) {
          context.prev.style.flexGrow = newPrevWidth;
        } else {
          context.prev.style.width = "".concat(newPrevWidth, "px");
        }

        if (context.nextHasFlex) {
          context.next.style.flexGrow = newNextWidth;
        } else {
          context.next.style.width = "".concat(newNextWidth, "px");
        }
      } else {
        var newPrevHeight = context.prevHeight + deltaY,
            newNextHeight = context.nextHeight - deltaY;

        if (context.prevHasFlex) {
          context.prev.style.flexGrow = newPrevHeight;
        } else {
          context.prev.style.height = "".concat(newPrevHeight, "px");
        }

        if (context.nextHasFlex) {
          context.next.style.flexGrow = newNextHeight;
        } else {
          context.next.style.height = "".concat(newNextHeight, "px");
        }
      }

      me.trigger('move', {
        context: context,
        event: event
      });
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(event) {
      var me = this;
      me.mouseDetacher && me.mouseDetacher();
      me.mouseDetacher = null;

      if (me.context.started) {
        me.trigger('end', {
          context: me.context,
          event: event
        });
      }

      me.context = null;
    } //endregion

  }, {
    key: "render",
    value: function render() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Splitter.prototype), "render", this).apply(this, arguments);

      var me = this;

      if (!me._currentOrientation) {
        // Determine current orientation
        me.updateOrientation();

        if (!me._currentOrientation) {
          // Determine current orientation from closest siblings, needs to happen on new frame since the splitter
          // is rendered before its next sibling
          me.requestAnimationFrame(function () {
            return me.updateOrientation();
          });
        }
      }
    }
  }, {
    key: "element",
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Splitter.prototype), "element", this);
    },
    set: function set(element) {
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Splitter.prototype), "element", element, this, true);

      var events = {
        element: this.element,
        pointerdown: 'onMouseDown',
        thisObj: this
      };

      if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].supportsPointerEvents) {
        events.mousedown = 'onMouseDown';
        events.touchstart = 'onMouseDown';
      }

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].on(events);
    } //endregion
    //region Orientation

    /**
     * Get actually used orientation, which is either the configured value for `orientation` or if configured with
     * 'auto' the currently used orientation.
     * @property {String}
     * @readonly
     */

  }, {
    key: "currentOrientation",
    get: function get() {
      return this._currentOrientation;
    }
    /**
     * Splitter orientation, see {@link #config-orientation}. When set to 'auto' then actually used orientation can be
     * retrieved using {@link #property-currentOrientation}.
     * @property {String}
     * @readonly
     */

  }, {
    key: "orientation",
    get: function get() {
      return this._orientation;
    },
    set: function set(orientation) {
      this._orientation = orientation;

      if (orientation === 'auto') {
        this._currentOrientation = null;
      } else {
        this._currentOrientation = orientation;
      }

      this.updateOrientation();
    }
  }], [{
    key: "type",
    //region Config
    // Factoryable type name
    get: function get() {
      return 'splitter';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The splitters orientation, configurable with 'auto', 'horizontal' or 'vertical'.
         *
         * 'auto' tries to determine the orientation by either checking the `flex-direction` of the parent element
         * or by comparing the positions of the closest sibling elements to the splitter. If they are above and
         * below 'horizontal' is used, if not it uses 'vertical'.
         *
         * ```
         * new Splitter({
         *    orientation : 'horizontal'
         * });
         * ```
         *
         * To receive the actully used orienatation when configured with 'auto', see
         * {@link #property-currentOrientation}.
         *
         * @config {String}
         * @default
         */
        orientation: 'auto'
      };
    }
  }]);

  return Splitter;
}(_Widget_js__WEBPACK_IMPORTED_MODULE_23__["default"]); // Register this widget type with its Factory



Splitter.initClass();
Splitter._$name = 'Splitter';

/***/ }),

/***/ "./lib/Core/widget/TabPanel.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/TabPanel.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabPanel; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _layout_Card_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./layout/Card.js */ "./lib/Core/widget/layout/Card.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Core/widget/TabPanel
 */

/**
 * Tab panel widget, displays a collection of tabs which each can contain other widgets. Layout is handled using css
 *
 * @extends Core/widget/Container
 * @example
 * let tabPanel = new TabPanel({
 *  items: [
 *      {
 *          title: 'First',
 *          items: [
 *              { type: 'textfield', label: 'Name' },
 *              ...
 *          ]
 *      }, {
 *          title: 'Last',
 *          items: [
 *              ...
 *          ]
 *      }
 *  ]
 * });
 *
 * @classType tabpanel
 * @externalexample widget/TabPanel.js
 */

var TabPanel = /*#__PURE__*/function (_Container) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(TabPanel, _Container);

  var _super = _createSuper(TabPanel);

  function TabPanel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, TabPanel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(TabPanel, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(TabPanel.prototype), "construct", this).call(this, config); // assign elements to titleElement, so they can get updated automatically when title is changed


      me.items.forEach(function (tab, i) {
        tab.titleElement = me.element.querySelector("div.b-tabpanel-tab[data-index=\"".concat(i, "\"] span"));
      });
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
        element: me.tabStrip,
        delegate: '.b-tabpanel-tab',
        click: 'onTabElementClick',
        thisObj: this
      });
    }
  }, {
    key: "changeElement",
    value: function changeElement() {
      var me = this;
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(TabPanel.prototype), "changeElement", this).call(this, {
        children: [{
          className: 'b-tabpanel-tabs',
          reference: 'tabStrip',
          children: me.items.map(function (childItem, i) {
            var _className;

            return {
              className: (_className = {
                'b-tabpanel-tab': 1,
                'b-active': i === me.activeTab
              }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_className, childItem.cls, childItem.cls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_className, 'b-hidden', childItem.$hideTab), _className),
              style: {
                minWidth: _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].setLength(me.tabMinWidth),
                maxWidth: _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].setLength(me.tabMaxWidth)
              },
              tabindex: -1,
              dataset: {
                index: i
              },
              children: [{
                tag: 'span',
                className: 'b-tabpanel-tab-title',
                html: childItem.title
              }]
            };
          })
        }, {
          className: {
            'b-tabpanel-body': 1
          },
          reference: 'tabPanelBody'
        }]
      });
    }
  }, {
    key: "onChildAdd",
    value: function onChildAdd(child) {
      // If the items come in as hidden, assume they are to be not available.
      // This flag causes the tab selectors to be rendered hidden.
      if (child.hidden) {
        child.$hideTab = true;
      } // The layout will hide inactive new items.
      // The $hideTab flag is for items which were preconfigured as hidden.
      // And we must add our beforeHide listener *after* call super.


      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(TabPanel.prototype), "onChildAdd", this).call(this, child);

      child.on({
        beforeHide: 'onBeforeChildHide',
        thisObj: this,
        prio: 1000 // We must know before the layout intercepts and activates a sibling

      });
    }
  }, {
    key: "onChildRemove",
    value: function onChildRemove(child) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(TabPanel.prototype), "onChildRemove", this).call(this, child);

      child.un({
        beforeHide: 'onBeforeChildHide',
        thisObj: this
      });
    } //endregion

  }, {
    key: "updateTabMinWidth",
    value: function updateTabMinWidth(tabMinWidth) {
      this.element && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].forEachSelector(this.element, '.b-tabpanel-tab', function (tab) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].setLength(tab, 'minWidth', tabMinWidth || null);
      });
    }
  }, {
    key: "updateTabMaxWidth",
    value: function updateTabMaxWidth(tabMaxWidth) {
      this.element && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].forEachSelector(this.element, '.b-tabpanel-tab', function (tab) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].setLength(tab, 'maxWidth', tabMaxWidth || null);
      });
    }
  }, {
    key: "changeLayout",
    value: function changeLayout(layout) {
      layout = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(TabPanel.prototype), "changeLayout", this).call(this, layout);
      layout.activeIndex = this.activeTab;
      layout.animateCardChange = this.animateTabChange;
      return layout;
    } //region Tabs

  }, {
    key: "changeActiveTab",
    value: function changeActiveTab(activeTab) {
      return parseInt(activeTab, 10);
    }
  }, {
    key: "updateActiveTab",
    value: function updateActiveTab(activeTab) {
      var me = this;

      if (typeof activeTab === 'number') {
        if (activeTab < 0 || activeTab >= me.items.length) {
          throw new Error('Invalid tab index: ' + activeTab);
        }
      } // Must be a child widget, so add if it's not already in our items.
      else if (this.items.indexOf(activeTab) === -1) {
          activeTab = me.add(activeTab);
        }

      if (!me.isConfiguring) {
        me.layout.activeItem = activeTab;
      }
    } // Auto called because Card layout triggers the activeItemChange on its owner

  }, {
    key: "onActiveItemChange",
    value: function onActiveItemChange(activeItemChangeEvent) {
      var me = this,
          tabStrip = me.tabStrip,
          prevActiveIndex = activeItemChangeEvent.prevActiveIndex,
          activeIndex = activeItemChangeEvent.activeIndex,
          prevTabElement = tabStrip.children[prevActiveIndex]; // Our UI changes immediately, our state must be accurate

      me.activeTab = activeIndex; // Deactivate previous active tab

      if (prevTabElement) {
        prevTabElement.classList.remove('b-active');
      } // Activate the new tab


      tabStrip.children[activeIndex].classList.add('b-active');
      tabStrip.children[activeIndex].classList.remove('b-hidden');
      /**
       * The active tab has changed.
       * @event tabChange
       * @param {Core.widget.Widget} prevActiveItem - The previous active child widget.
       * @param {Number} prevActiveIndex - The previous active index.
       * @param {Core.widget.Widget} activeItem - The new active child widget.
       * @param {Number} activeIndex - The new active index.
       */

      me.trigger('tabChange', activeItemChangeEvent);
    }
    /**
     * The active tab index. Setting must be done through {@link #property-activeTab}
     * @property {Number}
     * @readonly
     */

  }, {
    key: "onTabElementClick",
    //endregion
    //region Events
    value: function onTabElementClick(event) {
      this.activeTab = event.currentTarget.dataset.index;
    }
  }, {
    key: "onBeforeChildHide",
    value: function onBeforeChildHide(_ref) {
      var hidingChild = _ref.source;

      // If it's a hide that is not part of the layout's deactivating, we must hide the tab selector :(
      if (!hidingChild.$isDeactivating) {
        var tabBarEl = this.element.querySelector("div.b-tabpanel-tab[data-index=\"".concat(this.items.indexOf(hidingChild), "\"]"));
        tabBarEl.classList.add('b-hidden');
      }
    } //endregion

  }, {
    key: "contentElement",
    get: function get() {
      return this.tabPanelBody;
    }
  }, {
    key: "focusElement",
    get: function get() {
      var me = this,
          activeTab = me.items[me.activeTab || 0],
          tabFocusElement = activeTab && activeTab.focusElement;
      return tabFocusElement || me.tabStrip.children[me.activeTab];
    }
  }, {
    key: "activeIndex",
    get: function get() {
      return this.layout.activeIndex;
    }
    /**
     * The active child widget. Setting must be done through {@link #property-activeTab}
     * @property {Core.widget.Widget}
     * @readonly
     */

  }, {
    key: "activeItem",
    get: function get() {
      return this.layout.activeItem;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'TabPanel';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'tabpanel';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'tabs';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        // Prevent child panels from displaying a header unless explicitly configured with one
        suppressChildHeaders: true,

        /**
         * The index of the initially active tab.
         * @config {Number}
         * @default
         */
        activeTab: 0,

        /**
         * Min width of a tab title. 0 means no minimum width. This is default.
         * @config {Number}
         * @default
         */
        tabMinWidth: null,

        /**
         * Max width of a tab title. 0 means no maximum width. This is default.
         * @config {Number}
         * @default
         */
        tabMaxWidth: null,

        /**
         * Specifies whether to slide tabs in and out of visibility.
         * @config {Boolean}
         * @default
         */
        animateTabChange: true
      };
    }
    /**
     * The index of the initially active tab.
     * @property {Number}
     * @name activeTab
     * @member
     */

  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        itemCls: 'b-tabpanel-item',
        defaultType: 'container',
        layout: 'card'
      };
    }
  }]);

  return TabPanel;
}(_Container_js__WEBPACK_IMPORTED_MODULE_14__["default"]); // Register this widget type with its Factory



TabPanel.initClass();
TabPanel._$name = 'TabPanel';

/***/ }),

/***/ "./lib/Core/widget/TextAreaField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/TextAreaField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextAreaField; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/widget/TextAreaField
 */

/**
 * TextAreaField widget for multiline text input. Wraps a native &lt;textarea&gt;
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 *
 * @extends Core/widget/Field
 *
 * @example
 * let textAreaField = new TextAreaField({
 *   placeholder: 'Enter some text'
 * });
 *
 * @classType textareafield
 * @externalexample widget/TextAreaField.js
 */

var TextAreaField = /*#__PURE__*/function (_PickerField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(TextAreaField, _PickerField);

  var _super = _createSuper(TextAreaField);

  function TextAreaField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, TextAreaField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField, [{
    key: "startConfigure",
    value: function startConfigure(config) {
      // Read the inline config which will force evaluation of triggers.
      this.getConfig('inline');

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(TextAreaField.prototype), "startConfigure", this).call(this, config);
    }
  }, {
    key: "showPicker",
    value: function showPicker() {
      // Block picker if inline
      if (this.inline) {
        return;
      }

      var picker = this.picker;
      picker.width = this.pickerWidth || this[this.pickerAlignElement].offsetWidth; // Always focus the picker.

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(TextAreaField.prototype), "showPicker", this).call(this, true);
    }
  }, {
    key: "focusPicker",
    value: function focusPicker() {
      this.input.focus();
    }
  }, {
    key: "onPickerKeyDown",
    value: function onPickerKeyDown(keyEvent) {
      var me = this,
          realInput = me.input;

      switch (keyEvent.key.trim() || keyEvent.code) {
        case 'Escape':
          // TODO: revert value?
          me.picker.hide();
          return;

        case 'Enter':
          if (keyEvent.ctrlKey) {
            me.syncInputFieldValue();
            me.picker.hide();
          }

          break;
      } // Super's onPickerKeyDown fires through this.input, so avoid infinite recursion
      // by redirecting it through the displayElement.


      me.input = me.displayElement;

      var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(TextAreaField.prototype), "onPickerKeyDown", this).call(this, keyEvent);

      me.input = realInput;
      return result;
    }
  }, {
    key: "syncInputFieldValue",
    value: function syncInputFieldValue(skipHighlight) {
      if (this.displayElement) {
        this.displayElement.value = this.inputValue;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(TextAreaField.prototype), "syncInputFieldValue", this).call(this, skipHighlight);
    }
  }, {
    key: "changeValue",
    value: function changeValue(value) {
      return value == null ? '' : value;
    }
  }, {
    key: "updateInline",
    value: function updateInline(inline) {
      if (!inline && !this.triggers) {
        this.triggers = {};
      }
    }
  }, {
    key: "changeTriggers",
    value: function changeTriggers(triggers, was) {
      if (!this.inline) {
        (triggers || (triggers = {})).expand = {
          cls: 'b-icon-picker',
          handler: 'onTriggerClick'
        };
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(TextAreaField.prototype), "changeTriggers", this).call(this, triggers, was);
    }
  }, {
    key: "changePicker",
    value: function changePicker(picker, oldPicker) {
      var _picker;

      var me = this,
          pickerWidth = me.pickerWidth || ((_picker = picker) === null || _picker === void 0 ? void 0 : _picker.width);
      picker = TextAreaField.reconfigure(oldPicker, picker ? _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_12__["default"].merge({
        owner: me,
        forElement: me[me.pickerAlignElement],
        align: {
          matchSize: pickerWidth == null,
          anchor: me.overlayAnchor,
          target: me[me.pickerAlignElement]
        },
        html: "<textarea id=\"".concat(me.id + '-input', "\" style=\"resize:").concat(me.resize, "\">").concat(me.value, "</textarea>")
      }, picker) : null, me); // May have been set to null (destroyed)

      if (picker) {
        var input = me.input = picker.element.querySelector("#".concat(me.id, "-input"));
        me.inputListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on({
          element: input,
          thisObj: me,
          focus: 'internalOnInputFocus',
          change: 'internalOnChange',
          input: 'internalOnInput',
          keydown: 'internalOnKeyEvent',
          keypress: 'internalOnKeyEvent',
          keyup: 'internalOnKeyEvent'
        });
      }

      return picker;
    }
  }, {
    key: "inputElement",
    get: function get() {
      var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(TextAreaField.prototype), "inputElement", this);

      if (this.inline) {
        result.tag = 'textarea';
        result.style = (result.style || '') + ";resize:".concat(this.resize);
      } else {
        result.readOnly = 'readonly';
        result.reference = 'displayElement';
      }

      return result;
    }
  }, {
    key: "focusElement",
    get: function get() {
      return this.inline || this._picker && this._picker.isVisible ? this.input : this.displayElement;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'TextAreaField';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'textareafield';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'textarea';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        picker: {
          type: 'widget',
          cls: 'b-textareafield-picker',
          floating: true,
          scrollAction: 'realign',
          align: {
            align: 't-b',
            axisLock: true
          },
          autoShow: false
        },
        triggers: null,
        // Override PickerField. We don't have a trigger by default

        /**
         * Configure as `false` to have the field render as a non-editable picker field which
         * shows a `<textarea>` input when expanded.
         * @config {Boolean}
         * @default
         */
        inline: true,

        /**
         * The resize style to apply to the `<textarea>` element.
         * @config {String}
         * @default
         */
        resize: 'none',
        inputType: null
      };
    }
  }]);

  return TextAreaField;
}(_PickerField_js__WEBPACK_IMPORTED_MODULE_11__["default"]); // Register this widget type with its Factory



TextAreaField.initClass();
TextAreaField._$name = 'TextAreaField';

/***/ }),

/***/ "./lib/Core/widget/TextField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/TextField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
 //TODO: label should be own element

/**
 * @module Core/widget/TextField
 */

/**
 * Textfield widget. Wraps native &lt;input type="text"&gt;
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.Column Column}, {@link Grid.column.TemplateColumn TemplateColumn},
 * {@link Grid.column.TreeColumn TreeColumn}, and for other columns if another editor is not specified explicitly,
 * or disabled by setting `false` value.
 *
 * @extends Core/widget/Field
 *
 * @example
 * let textField = new TextField({
 *   placeholder: 'Enter some text'
 * });
 *
 * @classType textfield
 * @externalexample widget/TextField.js
 */

var TextField = /*#__PURE__*/function (_Field) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(TextField, _Field);

  var _super = _createSuper(TextField);

  function TextField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TextField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TextField, [{
    key: "construct",
    value: function construct(config) {
      if (config.inputType === 'hidden') {
        config.hidden = true;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(TextField.prototype), "construct", this).apply(this, arguments);
    }
  }, {
    key: "updatePlaceholder",
    value: function updatePlaceholder(value) {
      if (this.input) {
        this.input.placeholder = value !== null && value !== void 0 ? value : '';
      }
    }
  }], [{
    key: "type",
    // Factoryable type name
    get: function get() {
      return 'textfield';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'text';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * The tab index of the input field
         * @config {Number} tabIndex
         * @category Input element
         */

        /**
         * The min number of characters for the input field
         * @config {Number} minLength
         * @category Field
         */

        /**
         * The max number of characters for the input field
         * @config {Number} maxLength
         * @category Field
         */
        nullValue: ''
      };
    }
  }, {
    key: "$name",
    get: function get() {
      return 'TextField';
    }
  }]);

  return TextField;
}(_Field_js__WEBPACK_IMPORTED_MODULE_9__["default"]); // Register this widget type with its Factory



TextField.initClass();
TextField._$name = 'TextField';

/***/ }),

/***/ "./lib/Core/widget/TimeField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/TimeField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeField; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _TimePicker_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./TimePicker.js */ "./lib/Core/widget/TimePicker.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: picker icon (clock) should be clock that shows actual time




/**
 * @module Core/widget/TimeField
 */

/**
 * Time field widget (text field + time picker).
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.TimeColumn TimeColumn}.
 *
 * @extends Core/widget/PickerField
 *
 * @example
 * let field = new TimeField({
 *   format: 'HH'
 * });
 *
 * @classType timefield
 * @externalexample widget/TimeField.js
 */

var TimeField = /*#__PURE__*/function (_PickerField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TimeField, _PickerField);

  var _super = _createSuper(TimeField);

  function TimeField() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, TimeField);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(TimeField, [{
    key: "changePicker",
    //endregion
    //region Init & destroy
    value: function changePicker(picker, oldPicker) {
      var me = this;
      return _TimePicker_js__WEBPACK_IMPORTED_MODULE_12__["default"].reconfigure(oldPicker, picker, {
        owner: me,
        defaults: {
          forElement: me[me.pickerAlignElement],
          owner: me,
          align: {
            anchor: me.overlayAnchor,
            target: me[me.pickerAlignElement]
          },
          onTimeChange: function onTimeChange(_ref) {
            var time = _ref.time;
            me._isUserAction = true;
            me.value = time;
            me._isUserAction = false;
          }
        }
      });
    } //endregion
    //region Click listeners

  }, {
    key: "onBackClick",
    value: function onBackClick() {
      var me = this,
          min = me.min;

      if (!me.readOnly && me.value) {
        var newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(me.value, -1 * me.step.magnitude, me.step.unit);

        if (!min || min.getTime() <= newValue) {
          me._isUserAction = true;
          me.value = newValue;
          me._isUserAction = false;
        }
      }
    }
  }, {
    key: "onForwardClick",
    value: function onForwardClick() {
      var me = this,
          max = me.max;

      if (!me.readOnly && me.value) {
        var newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(me.value, me.step.magnitude, me.step.unit);

        if (!max || max.getTime() >= newValue) {
          me._isUserAction = true;
          me.value = newValue;
          me._isUserAction = false;
        }
      }
    } //endregion
    // region Validation

  }, {
    key: "hasChanged",
    value: function hasChanged(oldValue, newValue) {
      if (oldValue && oldValue.getTime && newValue && newValue.getTime) {
        // Only care about the time part
        return oldValue.getHours() !== newValue.getHours() || oldValue.getMinutes() !== newValue.getMinutes() || oldValue.getSeconds() !== newValue.getSeconds() || oldValue.getMilliseconds() !== newValue.getMilliseconds();
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimeField.prototype), "hasChanged", this).call(this, oldValue, newValue);
    } //endregion
    //region Toggle picker

    /**
     * Show picker
     */

  }, {
    key: "showPicker",
    value: function showPicker(focusPicker) {
      var me = this,
          picker = me.picker;

      if (me.readOnly) {
        return;
      }

      picker.initialValue = me.value;
      picker.format = me.format;
      picker.maxTime = me.max;
      picker.minTime = me.min; // Show valid time from picker while editor has undefined value

      me.value = picker.value;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimeField.prototype), "showPicker", this).call(this, focusPicker);
    }
  }, {
    key: "onPickerShow",
    value: function onPickerShow() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimeField.prototype), "onPickerShow", this).call(this); // Remove PickerField key listener


      this.pickerKeyDownRemover && this.pickerKeyDownRemover();
    }
    /**
     * Focus time picker
     */

  }, {
    key: "focusPicker",
    value: function focusPicker() {
      this.picker.focus();
    } //endregion
    //region Getters/setters

  }, {
    key: "transformTimeValue",
    value: function transformTimeValue(value) {
      if (value != null) {
        if (!_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isDate(value)) {
          if (typeof value === 'string') {
            value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].parse(value, this.format);
          } else {
            value = new Date(value);
          }
        } // We insist on a *valid* Time as the value


        if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isValidDate(value)) {
          // Clear date part back to zero so that all we have is the time part of the epoch.
          return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getTime(value);
        }
      }

      return null;
    }
  }, {
    key: "changeMin",
    value: function changeMin(value) {
      return this.transformTimeValue(value);
    }
  }, {
    key: "updateMin",
    value: function updateMin(value) {
      var input = this.input;

      if (input) {
        input.min = value;
      }

      this.syncInvalid();
    }
  }, {
    key: "changeMax",
    value: function changeMax(value) {
      return this.transformTimeValue(value);
    }
  }, {
    key: "updateMax",
    value: function updateMax(value) {
      var input = this.input;

      if (input) {
        input.max = value;
      }

      this.syncInvalid();
    }
  }, {
    key: "changeValue",
    value: function changeValue(value, was) {
      var me = this,
          newValue = me.transformTimeValue(value); // A value we could not parse

      if (value && !newValue || me.isRequired && value === '') {
        // setError uses localization
        me.setError('L{invalidTime}');
        return;
      }

      me.clearError('L{invalidTime}'); // Reject non-change

      if (me.hasChanged(was, newValue)) {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimeField.prototype), "changeValue", this).call(this, newValue, was);
      } // But we must fix up the display in case it was an unparseable string
      // and the value therefore did not change.


      if (!me.inputting) {
        me.syncInputFieldValue(true);
      }
    }
  }, {
    key: "updateValue",
    value: function updateValue(value, was) {
      var expand = this.triggers.expand; // This makes to clock icon show correct time

      if (expand && value) {
        expand.element.firstElementChild.style.animationDelay = -((value.getHours() * 60 + value.getMinutes()) / 10) + 's';
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimeField.prototype), "updateValue", this).call(this, value, was);
    }
  }, {
    key: "changeStep",
    value: function changeStep(value, was) {
      var type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default()(value);

      if (!value) {
        return null;
      }

      if (type === 'number') {
        value = {
          magnitude: Math.abs(value),
          unit: was ? was.unit : 'day'
        };
      } else if (type === 'string') {
        value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].parseDuration(value);
      }

      if (value && value.unit && value.magnitude) {
        if (value.magnitude < 0) {
          value = {
            magnitude: -value.magnitude,
            // Math.abs
            unit: value.unit
          };
        }

        return value;
      }
    }
  }, {
    key: "updateStep",
    value: function updateStep(value) {
      // If a step is configured, show the steppers
      this.element.classList[value ? 'remove' : 'add']('b-no-steppers');
      this.syncInvalid();
    }
  }, {
    key: "updateFormat",
    value: function updateFormat() {
      this.syncInputFieldValue(true);
    }
  }, {
    key: "updateLocalization",
    //endregion
    //region Localization
    value: function updateLocalization() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimeField.prototype), "updateLocalization", this).call(this);

      this.syncInputFieldValue(true);
    } //endregion

  }, {
    key: "isValid",
    get: function get() {
      var me = this;
      me.clearError('L{Field.minimumValueViolation}', true);
      me.clearError('L{Field.maximumValueViolation}', true);
      var value = me.value;

      if (value) {
        value = value.getTime();

        if (me._min && me._min.getTime() > value) {
          me.setError('L{Field.minimumValueViolation}', true);
          return false;
        }

        if (me._max && me._max.getTime() < value) {
          me.setError('L{Field.maximumValueViolation}', true);
          return false;
        }
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimeField.prototype), "isValid", this);
    }
  }, {
    key: "inputValue",
    get: function get() {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(this.value, this.format);
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'TimeField';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'timefield';
    } // Factoryable type alias

  }, {
    key: "alias",
    get: function get() {
      return 'time';
    }
  }, {
    key: "configurable",
    get: function get() {
      var _this = this;

      return {
        picker: {
          type: 'timepicker',
          floating: true,
          align: {
            align: 't0-b0',
            axisLock: true
          }
        },

        /**
         * Get/Set format for time displayed in field (see {@link Core.helper.DateHelper#function-format-static}
         * for formatting options).
         * @property {String}
         * @name format
         */

        /**
         * Format for date displayed in field (see Core.helper.DateHelper#function-format-static for formatting
         * options).
         * @config {String}
         * @default
         */
        format: 'LT',
        triggers: {
          expand: {
            template: function template() {
              return "<div class=\"b-align-".concat(_this.align || 'end', "\"><div class=\"b-icon-clock-live\"></div></div>");
            },
            handler: 'onTriggerClick',
            align: 'end'
          },
          back: {
            cls: 'b-icon b-icon-angle-left b-step-trigger',
            handler: 'onBackClick',
            align: 'start'
          },
          forward: {
            cls: 'b-icon b-icon-angle-right b-step-trigger',
            handler: 'onForwardClick',
            align: 'end'
          }
        },

        /**
         * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using
         * the specified {@link #config-format}.
         * @property {String|Date}
         * @name min
         */

        /**
         * Min time value
         * @config {String|Date}
         */
        min: null,

        /**
         * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using
         * the specified {@link #config-format}.
         * @property {String|Date}
         * @name max
         */

        /**
         * Max time value
         * @config {String|Date}
         */
        max: null,

        /**
         * The `step` property may be set in Object form specifying two properties, `magnitude`, a Number, and
         * `unit`, a String.
         *
         * If a Number is passed, the steps's current unit is used and just the magnitude is changed.
         *
         * If a String is passed, it is parsed by {@link Core.helper.DateHelper#function-parseDuration-static}, for
         * example `'5m'`, `'5 m'`, `'5 min'`, `'5 minutes'`.
         *
         * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
         * @property {String|Number|Object}
         * @name step
         */

        /**
         * Time increment duration value. Defaults to 5 minutes.
         * The value is taken to be a string consisting of the numeric magnitude and the units.
         * The units may be a recognised unit abbreviation of this locale or the full local unit name.
         * For example `"10m"` or `"5min"` or `"2 hours"`
          * @config {String}
         */
        step: '5m',
        stepTriggers: null,

        /**
         * Get/set value, which can be a Date or a string. If a string is specified, it will be converted using the
         * specified {@link #config-format}.
         * @property {String|Date}
         */

        /**
         * Value, which can be a Date or a string. If a string is specified, it will be converted using the
         * specified {@link #config-format}
         * @config {String|Date}
         */
        value: null
      };
    }
  }]);

  return TimeField;
}(_PickerField_js__WEBPACK_IMPORTED_MODULE_11__["default"]); // Register this widget type with its Factory



TimeField.initClass();
TimeField._$name = 'TimeField';

/***/ }),

/***/ "./lib/Core/widget/TimePicker.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/TimePicker.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimePicker; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/widget/TimePicker
 */

/**
 * A Popup which displays hour and minute number fields and AM/PM switcher buttons for 12 hour time format.
 * Fires timeChange event upon user changes time.
 *
 * This class is not intended for use in applications. It is used internally by the
 * {@link Core.widget.TimeField} class.
 *
 * @classType timepicker
 * @private
 */

var TimePicker = /*#__PURE__*/function (_Popup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TimePicker, _Popup);

  var _super = _createSuper(TimePicker);

  function TimePicker() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, TimePicker);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(TimePicker, [{
    key: "construct",
    //endregion
    //region Init

    /**
     * Fires when a time is changed.
     * @event timeChange
     * @param {Date} time The selected time.
     */
    value: function construct(config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimePicker.prototype), "construct", this).call(this, config);

      me._pm = false;
      me.fieldHours.on('change', me.onFieldChange, me);
      me.fieldMinutes.on('change', me.onFieldChange, me);
      me.buttonAM.on('click', me.onButtonAMClick, me);
      me.buttonPM.on('click', me.onButtonPMClick, me);
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
        element: me.element,
        keydown: 'onPickerKeyDown',
        thisObj: me
      });
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
        element: me.fieldHours.element,
        keydown: 'onPickerKeyDown',
        thisObj: me
      });
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
        element: me.fieldMinutes.element,
        keydown: 'onPickerKeyDown',
        thisObj: me
      });
      me.refresh();
    } //endregion
    //region Event listeners

  }, {
    key: "onFieldChange",
    value: function onFieldChange() {
      var me = this;

      if (me._time) {
        me.value = me.pickerToTime();
      }
    }
  }, {
    key: "onButtonAMClick",
    value: function onButtonAMClick() {
      var me = this;
      me._pm = false;

      if (me._time) {
        me.value = me.pickerToTime();
      }
    }
  }, {
    key: "onButtonPMClick",
    value: function onButtonPMClick() {
      var me = this;
      me._pm = true;

      if (me._time) {
        me.value = me.pickerToTime();
      }
    }
  }, {
    key: "onPickerKeyDown",
    value: function onPickerKeyDown(keyEvent) {
      var me = this,
          keyName = keyEvent.key && keyEvent.key.trim() || keyEvent.code;

      switch (keyName) {
        case 'Escape':
          // Support for undefined initial time
          me.triggerTimeChange(me._initialValue);
          me.hide();
          keyEvent.preventDefault();
          break;

        case 'Enter':
          me.value = me.pickerToTime();
          me.hide();
          keyEvent.preventDefault();
          break;
      }
    } //endregion
    //region Internal functions

  }, {
    key: "pickerToTime",
    value: function pickerToTime() {
      var me = this,
          pm = me._pm;
      me.fieldHours.format = me._is24Hour ? '2>9' : null;
      var hours = me.fieldHours.value,
          newValue = new Date(me._time);

      if (!me._is24Hour) {
        if (pm && hours < 12) hours = hours + 12;
        if (!pm && hours === 12) hours = 0;
      }

      newValue.setHours(hours);
      newValue.setMinutes(me.fieldMinutes.value);

      if (me._min) {
        newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].max(me._min, newValue);
      }

      if (me._max) {
        newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].min(me._max, newValue);
      }

      return newValue;
    }
  }, {
    key: "triggerTimeChange",
    value: function triggerTimeChange(time) {
      this.trigger('timeChange', {
        time: time
      });
    } //endregion
    //region Getters / Setters

    /**
     * Get/set value, which can be a Date or a string. If a string is specified, it will be converted using the
     * specified {@link #config-format}
     * @property {Date|String}
     */

  }, {
    key: "refresh",
    //endregion
    //region Display
    value: function refresh() {
      var me = this;

      if (!me.isConfiguring) {
        var time = me._time,
            is24 = me._is24Hour,
            hours = time.getHours(),
            pm = me._pm = hours >= 12,
            fieldHours = me.fieldHours;
        me.element.classList[is24 ? 'add' : 'remove']('b-24h');
        fieldHours.min = is24 ? 0 : 1;
        fieldHours.max = is24 ? 23 : 12;
        fieldHours.value = is24 ? hours : hours % 12 || 12;
        me.fieldMinutes.value = time.getMinutes();
        me.buttonAM.pressed = !pm;
        me.buttonPM.pressed = pm;
        me.buttonAM.hidden = me.buttonPM.hidden = is24;
      }
    } //endregion

  }, {
    key: "value",
    set: function set(newTime) {
      var me = this;
      var changed = false;

      if (!newTime || !me._time) {
        me._time = TimePicker.defaultConfig.value;
        changed = true;
      } else if (newTime.getTime() !== me._time.getTime()) {
        me._time = newTime;
        changed = true;
      }

      if (changed) {
        if (me.isVisible) {
          me.triggerTimeChange(me.value);
        }

        me.refresh();
      }
    },
    get: function get() {
      return this._time;
    }
    /**
     * Get/Set format for time displayed in field (see Core.helper.DateHelper#format for formatting options)
     * @property {String}
     */

  }, {
    key: "format",
    set: function set(value) {
      var me = this;
      me._format = value;
      me._is24Hour = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].is24HourFormat(me._format);
      me.refresh();
    },
    get: function get() {
      return this._format;
    }
    /**
     * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using the
     * specified {@link #config-format}
     * @property {Date|String}
     */

  }, {
    key: "min",
    set: function set(value) {
      this._min = value;
    },
    get: function get() {
      return this._min;
    }
    /**
     * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using the
     * specified {@link #config-format}
     * @property {Date|String}
     */

  }, {
    key: "max",
    set: function set(value) {
      this._max = value;
    },
    get: function get() {
      return this._max;
    }
    /**
     * Get/set initial value and value, which can be a Date or a string. If a string is specified,
     * it will be converted using the specified {@link #config-format}. Initial value is restored on Escape click
     * @property {Date|String}
     */

  }, {
    key: "initialValue",
    set: function set(value) {
      this.value = value;
      this._initialValue = value;
    },
    get: function get() {
      return this._initialValue;
    } //endregion
    //region Internal widgets getters

  }, {
    key: "buttonAM",
    get: function get() {
      return this.widgetMap.buttonAM;
    }
  }, {
    key: "buttonPM",
    get: function get() {
      return this.widgetMap.buttonPM;
    }
  }, {
    key: "fieldHours",
    get: function get() {
      return this.widgetMap.fieldHours;
    }
  }, {
    key: "fieldMinutes",
    get: function get() {
      return this.widgetMap.fieldMinutes;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'TimePicker';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'timepicker';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        items: [{
          type: 'number',
          ref: 'fieldHours',
          min: 0,
          max: 23,
          highlightExternalChange: false,
          format: '2>9'
        }, {
          html: '<label>:</label>'
        }, {
          type: 'number',
          ref: 'fieldMinutes',
          min: 0,
          max: 59,
          highlightExternalChange: false,
          format: '2>9'
        }, {
          type: 'button',
          text: 'AM',
          toggleGroup: 'am-pm',
          ref: 'buttonAM',
          cls: 'b-blue'
        }, {
          type: 'button',
          text: 'PM',
          toggleGroup: 'am-pm',
          ref: 'buttonPM',
          cls: 'b-blue'
        }],
        float: '1',
        autoShow: false,
        trapFocus: true,

        /**
         * Default time value
         * @config {Date}
         */
        value: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getTime(0),

        /**
         * Time format. Used to set appropriate 12/24 hour format to display.
         * See Core.helper.DateHelper#format for formatting options.
         * @config {String}
         */
        format: null
      };
    }
  }]);

  return TimePicker;
}(_Popup_js__WEBPACK_IMPORTED_MODULE_10__["default"]); // Register this widget type with its Factory



TimePicker.initClass();
TimePicker._$name = 'TimePicker';

/***/ }),

/***/ "./lib/Core/widget/Toast.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Toast.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Toast; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Core/widget/Toast
*/




/**
 * Basic toast. Toasts are stacked on top of each other
 * @example
 * // simplest possible
 * Toast.show('Just toasting');
 *
 * // with config
 * Toast.show({
 *   html: 'Well toasted',
 *   showProgress: false
 * });
 *
 * // as instance (instance is also returned from Toast.show()
 * let toast = new Toast({
 *   html: 'Not going away',
 *   timeout: 0
 * });
 *
 * toast.show();
 *
 * @classType toast
 * @externalexample widget/Toast.js
 */

var Toast = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(Toast, _Widget);

  var _super = _createSuper(Toast);

  function Toast() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Toast);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Toast, [{
    key: "doDestroy",
    value: function doDestroy() {
      var index = Toast.toasts.indexOf(this);

      if (index > -1) {
        Toast.toasts.splice(index, 1);
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Toast.prototype), "doDestroy", this).call(this);
    } // Toasts must not create their element until show.

  }, {
    key: "show",

    /**
     * Show the toast
     */
    value: function show() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Toast.prototype), "show", this).call(this);

      if (this.timeout > 0) {
        this.hideTimeout = this.setTimeout('hide', this.timeout);
      }
    }
    /**
     * Hide the toast
     */

  }, {
    key: "hide",
    value: function hide() {
      var me = this;

      if (!me.destroyTimer) {
        me.element.classList.add('b-toast-hide');
        me.element.style.bottom = '';
        me.destroyTimer = me.setTimeout('destroy', me.destroyTimeout);
      }
    }
    /**
     * Hide all visible toasts
     */

  }, {
    key: "element",
    set: function set(element) {},
    get: function get() {
      // Toasts must not create their element until show.
      if (!this._element && !this.isConfiguring) {
        var me = this,
            topToast = Toast.toasts.length && Toast.toasts[0].element,
            bottom = topToast ? topToast._nextBottom : me.bottomMargin,
            element = _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Toast.prototype), "element", _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createElement({
          parent: me.appendTo || _Widget_js__WEBPACK_IMPORTED_MODULE_14__["default"].floatRoot,
          children: me.showProgress ? [{
            className: 'b-toast-progress',
            style: "animation-duration:".concat(me.timeout / 1000, "s;")
          }] : null,
          html: me._html,
          className: me.color || '',
          style: me._style || ''
        }), this, true);

        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].on({
          element: element,
          click: 'hide',
          thisObj: me
        });
        Toast.toasts.unshift(me);
        element._nextBottom = bottom + element.offsetHeight + me.bottomMargin; // Transitioned style props must be set dynamically

        element.style.cssText += ";bottom:".concat(bottom, "px;transform:translateY(0)");
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Toast.prototype), "element", this);
    }
  }], [{
    key: "hideAll",
    value: function hideAll() {
      Toast.toasts.reverse().forEach(function (toast) {
        return toast.hide();
      });
    }
    /**
     * Easiest way to show a toast
     * @param {String|Object} msgOrConfig Message or toast config object
     * @returns {Core.widget.Toast}
     * @example
     * Toast.show('Hi');
     * @example
     * Toast.show({
     *   html   : 'Read quickly, please',
     *   timeout: 1000
     * });
     */

  }, {
    key: "show",
    value: function show(msgOrConfig) {
      var toast = new Toast(typeof msgOrConfig === 'string' ? {
        html: msgOrConfig
      } : msgOrConfig);
      toast.show();
      return toast;
    }
  }, {
    key: "$name",
    get: function get() {
      return 'Toast';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'toast';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        testConfig: {
          timeout: 100,
          destroyTimeout: 1
        },
        floating: true,

        /**
         * Timeout (in ms) until the toast is automatically dismissed. Set to 0 to never hide.
         * @config {Number}
         * @default
         */
        timeout: 2500,
        // How long to wait after hide before destruction
        destroyTimeout: 200,

        /**
         * Show a progress bar indicating the time remaining until the toast is dismissed.
         * @config {Boolean}
         * @default
         */
        showProgress: true,

        /**
         * Toast color (should have match in toast.scss or your custom styling).
         * Valid values in Bryntum themes are:
         * * b-amber
         * * b-blue
         * * b-dark-gray
         * * b-deep-orange
         * * b-gray
         * * b-green
         * * b-indigo
         * * b-lime
         * * b-light-gray
         * * b-light-green
         * * b-orange
         * * b-purple
         * * b-red
         * * b-teal
         * * b-white
         * * b-yellow
         *
         * ```
         * new Toast({
         *    color : 'b-blue'
         * });
         * ```
         *
         * @config {String}
         */
        color: null,
        bottomMargin: 20
      };
    }
  }]);

  return Toast;
}(_Widget_js__WEBPACK_IMPORTED_MODULE_14__["default"]);


Toast.toasts = []; // Register this widget type with its Factory

Toast.initClass();
Toast._$name = 'Toast';

/***/ }),

/***/ "./lib/Core/widget/Tool.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/Tool.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tool; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/widget/Tool
 */

/**
 * Base class for tools.
 *
 * May be configured with a `cls` and a `handler` which is a function (or name of a function)
 * in the owning Panel.
 * @extends Core/widget/Widget
 *
 * @classType tool
 */

var Tool = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Tool, _Widget);

  var _super = _createSuper(Tool);

  function Tool() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, Tool);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(Tool, [{
    key: "changeAlign",
    value: function changeAlign(align) {
      return align;
    }
  }, {
    key: "template",
    value: function template() {
      return "<button class=\"b-icon b-align-".concat(this.align || 'end', "\"></button>");
    }
  }, {
    key: "construct",
    value: function construct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Tool.prototype), "construct", this).call(this, config);

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].on({
        element: this.element,
        click: 'onClick',
        thisObj: this
      });
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      var handler = this.handler,
          panel = this.panel;

      if (panel.trigger('toolclick', {
        domEvent: e,
        tool: this
      }) !== false) {
        handler && this.callback(handler, panel, [e]);
      }
    }
  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(keyEvent) {
      var keyName = keyEvent.key.trim() || keyEvent.code; // Don't allow key invocations to bubble and trigger owning
      // widget's key handlers.

      if (keyName === 'Enter') {
        keyEvent.cancelBubble = true;
        keyEvent.stopPropagation();
      }
    }
  }, {
    key: "focusElement",
    get: function get() {
      return this.element;
    }
  }, {
    key: "panel",
    get: function get() {
      return this.parent;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'Tool';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'tool';
    } // Align is a simple string at this level

  }, {
    key: "configurable",
    get: function get() {
      return {
        align: {
          value: null,
          $config: {
            merge: 'replace'
          }
        }
      };
    }
  }]);

  return Tool;
}(_Widget_js__WEBPACK_IMPORTED_MODULE_10__["default"]); // Register this widget type with its Factory



Tool.initClass();
Tool._$name = 'Tool';

/***/ }),

/***/ "./lib/Core/widget/Toolbar.js":
/*!************************************!*\
  !*** ./lib/Core/widget/Toolbar.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Toolbar; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Core/widget/Toolbar
 */

/**
 * A container widget that can contain Buttons or other widgets, and is docked to the bottom or top of
 * a {@link Core.widget.Panel Panel}.
 *
 * @extends Core/widget/Container
 * @classType toolbar
 * @externalexample widget/Toolbar.js
 */

var Toolbar = /*#__PURE__*/function (_Container) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Toolbar, _Container);

  var _super = _createSuper(Toolbar);

  function Toolbar() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Toolbar);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Toolbar, [{
    key: "createWidget",
    value: function createWidget(widget) {
      if (widget === '->') {
        widget = {
          type: 'widget',
          cls: 'b-toolbar-fill'
        };
      } else if (widget === '|') {
        widget = {
          type: 'widget',
          cls: 'b-toolbar-separator'
        };
      } else if (typeof widget === 'string') {
        widget = {
          type: 'widget',
          cls: 'b-toolbar-text',
          html: widget
        };
      }

      var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Toolbar.prototype), "createWidget", this).call(this, widget);

      if (this.widgetCls) {
        result.element.classList.add(this.widgetCls);
      }

      return result;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'Toolbar';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'toolbar';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        defaultType: 'button',

        /**
         * Custom CSS class to add to toolbar widgets
         * @config {String}
         * @category CSS
         */
        widgetCls: null,
        layout: 'default'
      };
    }
  }]);

  return Toolbar;
}(_Container_js__WEBPACK_IMPORTED_MODULE_9__["default"]); // Register this widget type with its Factory



Toolbar.initClass();
Toolbar._$name = 'Toolbar';

/***/ }),

/***/ "./lib/Core/widget/Tooltip.js":
/*!************************************!*\
  !*** ./lib/Core/widget/Tooltip.js ***!
  \************************************/
/*! exports provided: default, createTooltip */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTooltip", function() { return createTooltip; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.anchor */ "./node_modules/core-js/modules/es.string.anchor.js");
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../helper/util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");



















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';










var realignTransitions = {
  left: true,
  right: true,
  top: true,
  bottom: true,
  transform: true
},
    isBoolean = {
  true: 1,
  false: 1
};
/**
 * @module Core/widget/Tooltip
 */

/**
 * Tooltip. Easiest way of assigning a tooltip to a widget is by setting {@link Core.widget.Widget#config-tooltip}, see example below.
 *
 * ```javascript
 * new Button {
 *     text    : 'Hover me',
 *     tooltip : 'Click me and you wont believe what happens next'
 * });
 * ```
 *
 * By default, tooltips of widgets use a singleton Tooltip instance which may be accessed from the
 * `{@link Core.widget.Widget Widget}` class under the name `Widget.tooltip`.
 * This is configured according to the config object on pointer over.
 *
 * To request a separate instance be created just for this widget, add `newInstance : true`
 * to the configuration:
 *
 * ```javascript
 * new Button {
 *     text    : 'Hover me',
 *     tooltip : {
 *         html        : 'Click me and you wont believe what happens next',
 *         newInstance : true
 *     }
 * });
 * ```
 *
 * You can ask for the singleton instance to display configured tips for your own DOM structure using
 * `data-btip` element attributes:
 *
 * ```html
 * <button class="my-button" data-btip="Contextual help for my button" data-btip-scroll-action="realign">Hover me</button>
 * ```
 *
 * ## Showing async content
 * To load remote content into a simple tooltip, just load your data in the `beforeShow` listener (but ensure that the {@link #property-activeTarget} is the same when the data arrives)
 *
 * ```javascript
 * new Tooltip({
 *     listeners : {
 *         beforeShow : ({ source : tip }) => tip.html = AjaxHelper.get('someurl').then(response => response.text());
 *     }
 * });
 * ```
 *
 * If you have multiple targets that should show a tooltip when hovered over, look at {@link #config-forSelector} and {@link #config-getHtml}.
 *
 * ```javascript
 * new Tooltip({
 *     forSelector : '.myCssClass',
 *     getHtml     : ({ source : tip }) => AjaxHelper.fetch('data').then(response => response.text())
 * });
 * ```
 *
 * @extends Core/widget/Popup
 * @classType tooltip
 * @externalexample widget/Tooltip.js
 */

var Tooltip = /*#__PURE__*/function (_Popup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(Tooltip, _Popup);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, Tooltip);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(Tooltip, [{
    key: "afterConstruct",
    //endregion
    //region Events

    /**
     * Triggered when a mouseover event is detected on a potential target element.
     * Return false to prevent the action
     * @event pointerOver
     * @param {Core.widget.Tooltip} sourceThe tooltip instance.
     * @param {Event} event The mouseover event.
     */
    //endregion
    //region Properties

    /**
     * The HTML element that triggered this Tooltip to show
     * @member {HTMLElement} activeTarget
     */
    //endregion
    //region Init & destroy
    value: function afterConstruct() {
      var me = this,
          forSelector = me.forSelector;

      if (forSelector) {
        me.showOnHover = true;

        if (!me.forElement) {
          me.trackMouse = true;
          me.forElement = Tooltip.listenersTarget;
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "afterConstruct", this).call(this); // There's a triggering element, and we're showing on hover, add the mouse listeners


      if (me.forElement && me.showOnHover) {
        me.pointerOverOutDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].on({
          element: me.forElement,
          mouseover: 'internalOnPointerOver',
          mouseout: 'internalOnPointerOut',
          thisObj: me
        });
      }

      if (me.autoShow) {
        me.show();
      }

      if (me.allowOver) {
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].on({
          element: me.element,
          mouseenter: 'onOwnElementMouseEnter',
          mouseleave: 'internalOnPointerOut',
          thisObj: me
        });
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.pointerOverOutDetacher && this.pointerOverOutDetacher();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "updateAnchorToTarget",
    value: function updateAnchorToTarget(anchorToTarget) {
      if (!anchorToTarget) {
        this.anchor = false;
      }
    } //endregion
    //region Hovering, show and hide

  }, {
    key: "onDocumentMouseDown",
    value: function onDocumentMouseDown(_ref) {
      var event = _ref.event;
      var me = this,
          triggeredByEvent = me.triggeredByEvent; // If it's a tap that is caused by the touch that was converted into a mousover we should not hide.
      // That is if it's a touch and at the same place and within 500ms

      if (triggeredByEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isTouchEvent) {
        if (event.pageX === triggeredByEvent.pageX && event.pageY === triggeredByEvent.pageY && me.activeTarget.contains(event.target) && performance.now() - triggeredByEvent.timeStamp < 500) {
          return;
        }
      }

      me.abortDelayedShow();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "onDocumentMouseDown", this).call(this, {
        event: event
      });
    }
  }, {
    key: "internalOnPointerOver",
    value: function internalOnPointerOver(event) {
      var me = this,
          forElement = me.forElement,
          forSelector = me.forSelector,
          activeTarget = me.activeTarget;
      var newTarget;

      if (me.disabled) {
        return;
      } // If the mouse moves over this tooltip, it is theoretically a mouseout of its
      // forElement, but allowOver lets us tolerate this ane remain visible.


      if (me.allowOver && me.element.contains(event.target)) {
        return;
      } // There's been a mouseover. If we have a forSelector, we have to check
      // if it's an enter of a matching child


      if (forSelector) {
        // Moving inside a forSelector matching element
        if (activeTarget && activeTarget.contains(event.target) && activeTarget.contains(event.relatedTarget)) {
          return;
        }

        newTarget = event.target.closest(forSelector); // Mouseovers while within a target do nothing

        if (newTarget && event.relatedTarget && event.relatedTarget.closest(forSelector) === newTarget) {
          return;
        }
      } // There's no forSelector, so check if we moved from outside the target
      else if (!forElement.contains(event.relatedTarget)) {
          newTarget = forElement;
        } // Mouseover caused by moving from child to child inside the target
        else {
            return;
          } // If pointer entered the target or a forSelector child, then show.


      if (newTarget) {
        me.handleForElementOver(event, newTarget);
      } // If over a non-forSelector child, behave as in forElement out
      else if (activeTarget) {
          me.handleForElementOut();
        }
    } // Handle a transitioned reposition when the activeTarget moved beneath the pointer.
    // When it comes to an end, if the mouseout has not hidden, then realign at the new position
    // if the activeTarget is still beneath the pointer.

  }, {
    key: "onTransitionEnd",
    value: function onTransitionEnd(event) {
      var me = this,
          currOver = Tooltip.currentOverElement;

      if (realignTransitions[event.propertyName]) {
        // Don't realign if the mouse is over this, and is allowed to be over this
        // If user is interacting with this Toolltip, they won't expect it to move.
        if (me.allowOver && me.element.contains(currOver)) {
          return;
        } // If we are still visible, and mouse is still over the activeTarget, realign


        if (me.activeTarget && me.activeTarget.contains(currOver) && !me.trackMouse) {
          me.realign();
        }
      }
    }
  }, {
    key: "handleForElementOver",
    value: function () {
      var _handleForElementOver = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee(event, newTarget) {
        var me, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this; // Vetoed, then behave as is a targetout

                if (!(me.trigger('pointerOver', {
                  event: event,
                  target: newTarget
                }) === false)) {
                  _context.next = 5;
                  break;
                }

                me.internalOnPointerOut(event);
                _context.next = 24;
                break;

              case 5:
                me.triggeredByEvent = event;
                me.abortDelayedHide(); // Abort any in-flight animated hide, and show immediately.
                // This is needed when allowOver is false (which is the default), and mouseovering
                // hides, but that immediately causes the mouse to be over another delegate
                // which jumps right in here.

                if (!me.hideOnDelegateChange && me.element.classList.contains('b-hiding')) {
                  me.element.classList.remove('b-hiding');
                  me.show(false);
                } // We are over a new target. If we are still visible, we
                // do not want to hide to avoid flickering. But if there is a
                // beforeshow listener which may mutate us, we still have to
                // consult it. If it returns a veto, then we do in fact hide.
                // Under normal circumstances we just alignTo the new target.
                // We must handle the post show tasks like starting the dismiss timer etc.


                if (!(me.isVisible && !me.hideOnDelegateChange)) {
                  _context.next = 21;
                  break;
                }

                me.updateActiveTarget(newTarget);

                if (!(me.trigger('beforeShow') === false)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", me.hide());

              case 12:
                result = me.updateContent(); // Edge case, we have no loadingMsg meaning we're not visible until content has arrived

                if (!(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isPromise(result) && !me.loadingMsg)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 16;
                return result;

              case 16:
                me.alignTo({
                  target: me.anchorToTarget ? newTarget : new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_21__["default"](me.triggeredByEvent.pageX - window.pageXOffset + me.mouseOffsetX, me.triggeredByEvent.pageY - window.pageYOffset + me.mouseOffsetY),
                  overlap: !(me.anchorToTarget && me.anchor)
                });
                me.trigger('show');
                me.afterShowByTarget();
                _context.next = 24;
                break;

              case 21:
                if (me.hideOnDelegateChange) {
                  me.hide();
                }

                me.updateActiveTarget(newTarget);
                me.delayShow(newTarget);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleForElementOver(_x, _x2) {
        return _handleForElementOver.apply(this, arguments);
      }

      return handleForElementOver;
    }()
  }, {
    key: "delayShow",
    value: function () {
      var _delayShow = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee3(target) {
        var me, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                me = this; // Caught in an animation - cancel it

                if (me.currentAnimation) {
                  me.cancelHideShowAnimation();
                  me._hidden = true;
                }

                if (!(!me.isVisible && !me.hasTimeout('show'))) {
                  _context3.next = 16;
                  break;
                }

                if (!(!me.hoverDelay || me.forSelector && Date.now() - me.lastHidden < me.quickShowInterval)) {
                  _context3.next = 11;
                  break;
                }

                result = me.updateContent(); // Edge case, we have no loadingMsg meaning we're not visible until content has arrived

                if (!(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isPromise(result) && !me.loadingMsg)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 8;
                return result;

              case 8:
                me.showByTarget(target);
                _context3.next = 14;
                break;

              case 11:
                // If a mouse down happens during the delay period, we cancel the show
                me.addDocumentMouseDownListener(); // If we're not going to anchor to the hovered element, then we need to keep track
                // of mousemoves until the show happens so we can show where the mouse currently is.

                if (!me.listeningForMouseMove && !me.anchorToTarget) {
                  me.mouseMoveRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].on({
                    element: Tooltip.listenersTarget,
                    mousemove: 'onMouseMove',
                    thisObj: me
                  });
                } // If a tap event triggered, do not wait. Show immediately.


                me.setTimeout( /*#__PURE__*/_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee2() {
                  var _result;

                  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isOrphaned(target)) {
                            _context2.next = 6;
                            break;
                          }

                          _result = me.updateContent(); // Edge case, we have no loadingMsg meaning we're not visible until content has arrived

                          if (!(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isPromise(_result) && !me.loadingMsg)) {
                            _context2.next = 5;
                            break;
                          }

                          _context2.next = 5;
                          return _result;

                        case 5:
                          me.showByTarget(target);

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })), !me.triggeredByEvent || me.triggeredByEvent.type === 'mouseover' ? me.hoverDelay : 0, 'show');

              case 14:
                _context3.next = 17;
                break;

              case 16:
                if (me.isVisible) {
                  me.showByTarget(target);
                }

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function delayShow(_x3) {
        return _delayShow.apply(this, arguments);
      }

      return delayShow;
    }()
  }, {
    key: "updateContent",
    value: function () {
      var _updateContent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee4() {
        var me, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                me = this;

                if (!me.getHtml) {
                  _context4.next = 5;
                  break;
                }

                result = me.getHtml({
                  tip: me,
                  element: me.element,
                  activeTarget: me.activeTarget,
                  event: me.triggeredByEvent
                });
                me.html = result;
                return _context4.abrupt("return", result);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateContent() {
        return _updateContent.apply(this, arguments);
      }

      return updateContent;
    }() // There are 3 possible scenarios:
    // - Static content
    // - Remote content being loaded (meaning we (possibly) set a loading message as the `html`
    // - Tooltip acts as a Container

  }, {
    key: "internalBeforeShow",
    value: function internalBeforeShow() {
      // In case we update content on mouse move, need to show empty tooltip first
      return this.updateContentOnMouseMove || this.hasContent;
    }
    /**
     * Shows a spinner and a message to indicate an async flow is ongoing
     * @param {String} message The message, defaults to {@link #config-loadingMsg}
     */

  }, {
    key: "showAsyncMessage",
    value: function showAsyncMessage() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.optionalL(this.loadingMsg);

      // TODO: Load masking should ideally use a general Widget ability.
      if (message) {
        this.html = "\n                <div class=\"b-tooltip-loading\">\n                    <i class=\"b-icon b-icon-spinner\"></i>\n                    ".concat(message, "\n                </div>\n            ");
      }
    }
  }, {
    key: "showByTarget",
    value: function showByTarget(target) {
      var me = this;

      if (me.mouseMoveRemover) {
        me.mouseMoveRemover();
        me.mouseMoveRemover = null;
      } // Show by the correct thing.
      // If we are not anchored to the target, then it's the current pointer event.
      // Otherwise it's the activeTarget.


      me.showBy({
        target: me.anchorToTarget ? target : new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_21__["default"](me.triggeredByEvent.pageX - window.pageXOffset + me.mouseOffsetX, me.triggeredByEvent.pageY - window.pageYOffset + me.mouseOffsetY),
        overlap: !(me.anchorToTarget && me.anchor)
      });
    }
  }, {
    key: "afterShowByTarget",
    value: function afterShowByTarget() {
      var me = this,
          dismissDelay = me.dismissDelay;
      me.abortDelayedShow();

      if (dismissDelay) {
        me.setTimeout('hide', dismissDelay);
      }

      me.toFront();
    }
  }, {
    key: "updateActiveTarget",
    value: function updateActiveTarget(newTarget) {
      var me = this,
          lastTarget = me.activeTarget;
      me.activeTarget = newTarget;

      if (!me.isConfiguring) {
        me.trigger('overtarget', {
          newTarget: newTarget,
          lastTarget: lastTarget
        });
      }
    }
  }, {
    key: "internalOnPointerOut",
    value: function internalOnPointerOut(event) {
      var me = this,
          toElement = event.relatedTarget; // Edge case: If there is no space to fit the tooltip, and as a result of showing the tooltip - the mouse is over the tooltip
      // Make sure we don't end up in an infinite hide/show loop

      if (me.allowOver && me.element.contains(toElement)) {
        return;
      } // If we were in an allowOver situation and exited
      // into the activeTarget, do nothing; in this situation
      // the tip is treated as if it were part of the target.


      if (me.element.contains(event.target) && me.activeTarget && me.activeTarget.contains(toElement)) {
        return;
      } // We have exited the active target


      if (me.activeTarget && !me.activeTarget.contains(event.relatedTarget)) {
        me.handleForElementOut();
      }
    }
  }, {
    key: "handleForElementOut",
    value: function handleForElementOut() {
      // Separated from onTargetOut so that subclasses can handle target out in any way.
      var me = this,
          hideDelay = me.hideDelay; // Allow outside world to veto the hide

      if (me.trigger('pointerOut') === false) {
        me.activeTarget = null;
        return;
      }

      me.abortDelayedShow(); // Even if there is a hide timer, it's a *dismiss* timer which hides the tip
      // after a hover time. We begin a new delay on target out.

      if (me.isVisible && hideDelay !== false) {
        me.abortDelayedHide();

        if (hideDelay > 0) {
          me.setTimeout('hide', hideDelay);
        } else {
          // Hide immediately when configured with `hideDelay: 0`. Used by async cell tooltips that always should
          // retrigger `hoverDelay`, to not spam the backend
          me.hide();
        }
      }
    }
  }, {
    key: "show",
    value: function show() {
      var me = this; // If we know what element to show it by, and we are anchoring to it
      // and there's no ambiguity with a selector for sub elements,
      // then show it by our forElement (Unless we're being called from showBy)

      if (me.forElement && me.anchorToTarget && !me.forSelector && !me.inShowBy) {
        me.showByTarget(me.forElement);
      } // All we can do is the basic Widget show.
      else {
          if (me.inShowBy) {
            me.y = -10000;
          }

          _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "show", this).call(this);
        }

      me.afterShowByTarget(); // If we've shown, and are tracking the mouse and not anchored to (aligned to) the target, track the mouse

      if (!me.mouseMoveRemover && !me._hidden && (me.trackMouse || me.updateContentOnMouseMove)) {
        var _EventHelper$on;

        me.mouseMoveRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].on((_EventHelper$on = {
          element: Tooltip.listenersTarget
        }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_EventHelper$on, _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].supportsPointerEvents ? 'pointermove' : 'touchmove', 'onMouseMove'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_EventHelper$on, "thisObj", me), _EventHelper$on));
      }

      if (me.forElement && !me.transitionEndDetacher && !me._hidden) {
        me.transitionEndDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].on({
          element: me.forElement,
          transitionend: 'onTransitionEnd',
          thisObj: me
        });
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var me = this; // If we are asked to hide, we must always abort any impending show.

      me.abortDelayedShow(); // But if we are in fact visible, go ahead and hide

      if (me.isVisible) {
        var _get2;

        me.abortDelayedHide();

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "hide", this)).call.apply(_get2, [this].concat(args));

        me.lastHidden = Date.now();
        me.activeTarget = null;

        if (me.mouseMoveRemover) {
          me.mouseMoveRemover();
          me.mouseMoveRemover = null;
        }

        if (me.transitionEndDetacher) {
          me.transitionEndDetacher();
          me.transitionEndDetacher = null;
        }

        me.listeningForMouseMove = false;
      }
    }
  }, {
    key: "abortDelayedShow",
    value: function abortDelayedShow() {
      var me = this;

      if (me.hasTimeout('show')) {
        // This listener is addded in delayShow to make a mousedown abort,
        // So we must remove it here because it's only removed in onHide.
        if (me.mouseDownRemover) {
          me.mouseDownRemover();
          me.mouseDownRemover = null;
        }

        me.clearTimeout('show');

        if (me.mouseMoveRemover) {
          me.mouseMoveRemover();
          me.mouseMoveRemover = null;
        }

        if (me.transitionEndDetacher) {
          me.transitionEndDetacher();
          me.transitionEndDetacher = null;
        }
      }
    }
    /**
     * Stops both timers which may hide this tooltip, the one which counts down from mouseout
     * and the one which counts down from mouseover show for dismissDelay ms
     * @private
     */

  }, {
    key: "abortDelayedHide",
    value: function abortDelayedHide() {
      this.clearTimeout('hide');
    }
  }, {
    key: "realign",
    value: function realign(el) {
      var me = this,
          spec = me.lastAlignSpec,
          clippedBy = me.clippedBy; // If we are hidden because our align target scrolled, or otherwise
      // moved out of its clipping boundaries, then check if it's moved back in.
      // For example EventDrag might move the element outside of the scheduler
      // SubGrid, which will cause the tip to hide, but then moving it back in
      // must reshow it.

      if (!me.isConfiguring && clippedBy && !me.isVisible && spec && spec.targetHidden) {
        var target = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_20__["default"].from(spec.target, me.positioned ? me.element.offsetParent : null, !me.positioned),
            clippedTarget = target.intersect(clippedBy); // If there is an intersecting Rectangle with the forElement, align

        if (clippedTarget) {
          me.show();
          spec.targetHidden = false;
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "realign", this).call(this, el);
    }
  }, {
    key: "alignTo",
    value: function alignTo(spec) {
      var me = this;
      if (!me.isVisible) return; // If mouse pointer is over this, do not attempt
      // to call the getHtml method.

      if (!(me.triggeredByEvent && me.element.contains(me.triggeredByEvent.target))) {
        if (spec.nodeType === 1) {
          spec = {
            target: spec
          };
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "alignTo", this).call(this, spec);
    } //endregion
    //region Tooltip contents

    /**
     * Get/set the HTML to display. When specifying HTML, this widget's element will also have `b-html` added to its
     * classList, to allow targeted styling. To create async tooltip and show the {@link #config-loadingMsg}, see code below:
     * For example:
     *
     * ```javascript
     * new Tooltip({
     *     listeners : {
     *         beforeShow : ({ source : tip }) => {
     *             tip.showAsyncMessage();
     *             AjaxHelper.get('someurl').then(response => tip.html = 'Done!');
     *         }
     *     }
     * });
     * ```
     *
     * @property {String}
     * @name html
     * @category DOM
     */

  }, {
    key: "changeHtml",
    value: function changeHtml(htmlOrPromise) {
      var me = this;

      if (htmlOrPromise === false) {
        _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].deprecate('Grid', '5.0.0', 'Setting false to indicate loading is deprecated, in favor of `showAsyncMessage`. Please see https://bryntum.com/docs/grid/#guides/upgrades/3.0.1.md for more information');
        this.showAsyncMessage();
        return;
      }

      if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isPromise(htmlOrPromise)) {
        me.showAsyncMessage();
        htmlOrPromise.target = me.activeTarget;
        htmlOrPromise.then(function (html) {
          // Cursor might have exited the element while loading
          if (htmlOrPromise.target === me.activeTarget) {
            me.html = html;
          }
        });
        return;
      } // Allow objects to pass through, to be used with DomSync


      if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default()(htmlOrPromise) !== 'object') {
        // Stringify in case a number was passed in
        htmlOrPromise = htmlOrPromise != null ? me.optionalL(String(htmlOrPromise)) : '';
      }

      return htmlOrPromise;
    }
  }, {
    key: "updateHtml",
    value: function updateHtml(value, was) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "updateHtml", this).call(this, value, was);

      if (me.hasContent) {
        if (me.isVisible) {
          me.realign();
        }

        if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isPromise(value)) {
          me.trigger('innerHtmlUpdate');
        }
      } else {
        // Hide empty tooltips
        me.hide();
      }
    } //endregion
    //region Events

    /**
     * Mouse move event listener which updates tooltip
     * @private
     */

  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      var me = this,
          forElement = me.forElement,
          x = event.pageX - window.pageXOffset + me.mouseOffsetX,
          y = event.pageY - window.pageYOffset + me.mouseOffsetY,
          isHiding = me.hasTimeout('hide'),
          target = event.target; // MouseMove is listened for during the hover show timer wait phase if anchorToTarget is false
      // so that when the timer fires, it can show near the most recent pointer position.
      // It's also listened for after show when we are not anchored to the target and so tracking the mouse.

      /**
       * The DOM event that triggered this tooltip to show
       * @member {Event} triggeredByEvent
       * @readonly
       */

      me.triggeredByEvent = event; // Check that we are still valid to be visible, and if so, track the mouse.

      if (!me._hidden) {
        var hideVetoed;
        var isElementOut = me.forSelector && me.activeTarget && !isHiding && target.nodeType === 1 && !target.matches(me.forSelector) && !(me.allowOver && me.element.contains(target)),
            // We need an element we can ask the "contains" question about our target.
        // If we are using window, we need to step down to the documentElement.
        containingElement = (forElement === null || forElement === void 0 ? void 0 : forElement.document) ? forElement.document.documentElement : forElement,
            // If the forElement is a ShadowRoot, it won't implement contains
        // but it does implement compareDocumentPosition.
        forElementContainsTarget = containingElement && (containingElement.contains ? containingElement.contains(target) : containingElement.compareDocumentPosition(target) & 16); // Check whether the element we are over is still a valid delegate matching the forSelector,
        // or it's the tip element, and we're allowOver. If not, we have to hide.
        // nodeType check is for FF on Linux, event.target is sometimes a text node

        if (isElementOut) {
          hideVetoed = me.handleForElementOut();
        } // If we are not hiding due to moving mouse outside our forElement (or hide being vetoed), tooltip stays visible and optionally realigns based on trackMouse setting.


        if (hideVetoed || !isHiding || forElementContainsTarget) {
          // Mousemoves restart the dismiss timer.
          if (me.dismissDelay && !isHiding) {
            me.setTimeout('hide', me.dismissDelay);
          }

          if (me.updateContentOnMouseMove && me.getHtml) {
            me.html = me.getHtml({
              tip: me,
              element: me.element,
              forElement: me.activeTarget,
              event: event
            });
          } // If we're not anchoring to the target, track the mouse


          if (me.trackMouse) {
            me.alignTo({
              position: new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_21__["default"](x, y),
              ignorePageScroll: true
            });
          }
        }
      }
    }
  }, {
    key: "onOwnElementMouseEnter",
    value: function onOwnElementMouseEnter(event) {
      this.abortDelayedHide();
    } //endregion

  }, {
    key: "focusOnToFront",
    set: function set(focusOnToFront) {
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "focusOnToFront", focusOnToFront, this, true);
    },
    get: function get() {
      // Transient things like tooltips should not focus when invoked by pointer events
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "focusOnToFront", this) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].usingKeyboard;
    }
  }, {
    key: "focusElement",
    get: function get() {
      var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Tooltip.prototype), "focusElement", this);

      if (result !== this.element) {
        return result;
      }
    }
  }, {
    key: "trackMouse",
    get: function get() {
      // We do not track the mouse if we are anchored to (aligned to) the target
      return this._trackMouse && !this.anchorToTarget;
    }
  }, {
    key: "hasContent",
    get: function get() {
      return Boolean(typeof this.html === 'string' && this.html.length || this.items.length);
    }
  }], [{
    key: "$name",
    //region Default config
    get: function get() {
      return 'Tooltip';
    }
  }, {
    key: "listenersTarget",
    get: function get() {
      return document.body;
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'tooltip';
    }
    /**
     * Triggered before tooltip widget is shown. Return `false` to prevent the action.
     * @preventable
     * @event beforeShow
     * @param {Core.widget.Tooltip} source The Tooltip
     * @param {Event} source.triggeredByEvent The event that triggered this Tooltip to show.
     */

  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Horizontal offset from mouse when {@link #config-anchorToTarget} is `false`
         * @config {Number}
         * @default
         */
        mouseOffsetX: 15,

        /**
         * Vertical offset from mouse when {@link #config-anchorToTarget} is `false`
         * @config {Number}
         * @default
         */
        mouseOffsetY: 15,
        floating: true,

        /**
         * A method called to update the tooltip's content when the cursor is moved over a target. It receives one argument containing context about the tooltip and show operation.
         * The function should return a string, or a Promise yielding a string.
         * @param {Object} context
         * @param {Core.widget.Tooltip} context.tip The tooltip instance
         * @param {HTMLElement} context.element The Element for which the Tooltip is monitoring mouse movement
         * @param {HTMLElement} context.activeTarget The target element that triggered the show
         * @param {Event} context.event The raw DOM event
         * @return {String|Promise}
         * @config {Function}
         */
        getHtml: null,

        /**
         * DOM element to attach tooltip to. By default, the mouse entering this element will kick off a timer
         * (see {@link #config-hoverDelay}) to show itself.
         *
         * If the {@link #config-forSelector} is specified, then mouse entering matching elements within the `forElement`
         * will trigger the show timer to start.
         *
         * Note that when moving from matching element to matching element within the `forElement`, the tooltip
         * will remain visible for {@link #config-hideDelay} milliseconds after exiting one element, so that rapidly
         * entering another matching element will not cause hide+show flicker. To prevent this behaviour configure
         * with `hideDelay: 0`.
         * @config {HTMLElement}
         */
        forElement: null,
        trackMouse: null,

        /**
         * By default, a tooltip displays static content. In the Scheduler however, there are
         * plenty of uses cases when the tip content is based on the current mouse position (dragging events, resizing events, schedule hover tip, drag creation of events etc). Set
         * to `true` to update contents on mouse movement.
         * @config {Boolean}
         * @private
         */
        updateContentOnMouseMove: false,

        /**
         * A CSS selector which targets child elements of the {@link #config-forElement} that should produce a tooltip when hovered over.
         * @config {String}
         */
        forSelector: null,

        /**
         * By default, when moving rapidly from target to target, if, when mouseing over
         * a new target, the tip is still visible, the tooltip does not hide, it remains
         * visible, but updates its content however it is configured to do so.
         *
         * Configure `hideOnDelegateChange : true` to have the tip hide, and then trigger
         * a new show delay upon entry of a new target while still visible.
         * @config {Boolean}
         * @default false
         */
        hideOnDelegateChange: null,

        /**
         * Set to true to anchor tooltip to the triggering target. If set to `false`, the tooltip
         * will align to the mouse position. When set to `false`, it will also set `anchor: false`
         * to hide anchor arrow.
         * @config {Boolean}
         * @default true
         */
        anchorToTarget: true,

        /**
         * Show on hover
         * @config {Boolean}
         * @default
         */
        showOnHover: false,

        /**
         * The amount of time to hover before showing
         * @config {Number}
         * @default
         */
        hoverDelay: 500,

        /**
         * Show immediately when created
         * @config {Boolean}
         * @default
         */
        autoShow: false,

        /**
         * The time (in milliseconds) that the Tooltip should stay visible for when it shows over its
         * target. If the tooltip is anchored to its target, then moving the mouse during this time
         * resets the timer so that the tooltip will remain visible.
         *
         * Defaults to `0` which means the Tooltip will persist until the mouse leaves the target.
         * @config {Number}
         * @default
         */
        dismissDelay: 0,

        /**
         * The time (in milliseconds) for which the Tooltip remains visible when the mouse leaves the target.
         *
         * May be configured as `false` to persist visible after the mouse exits the target element. Configure it
         * as 0 to always retrigger `hoverDelay` even when moving mouse inside `fromElement`
         * @config {Number}
         * @default
         */
        hideDelay: 500,

        /**
         * The message to show while an async tooltip is fetching its content.
         * @config {String}
         * @default
         */
        loadingMsg: 'Loading...',

        /**
         * Keep the tooltip open if user hovers it
         * @config {Boolean}
         * @default
         */
        allowOver: false,
        anchor: true,
        align: 'b-t',
        axisLock: true,
        testConfig: {
          hideDelay: 100,
          hoverDelay: 100,
          showAnimation: null,
          hideAnimation: null
        }
      };
    }
  }]);

  return Tooltip;
}(_Popup_js__WEBPACK_IMPORTED_MODULE_19__["default"]); // In some demos this code may execute when body does not yet exist (scripttag)




if (!Tooltip.listenersTarget) {
  document.addEventListener('DOMContentLoaded', setupMouseEnterListener);
} else {
  setupMouseEnterListener();
}

function setupMouseEnterListener() {
  _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].on({
    element: Tooltip.listenersTarget,
    mouseenter: function mouseenter(event) {
      return Tooltip.currentOverElement = event.target;
    },
    capture: true
  });
}
/**
 * Updated dynamically with the current element that the mouse is over. For use when showing a Tooltip
 * from code which is not triggered by a pointer event so that a tooltip can be positioned.
 * @member {HTMLElement} currentOverElement
 * @readonly
 * @static
 */
// Register this widget type with its Factory


Tooltip.initClass();
var globalInstance;

function createGlobalTooltipInstance() {
  globalInstance = new Tooltip({
    id: 'bryntum-tooltip',
    forElement: Tooltip.listenersTarget,
    forSelector: '[data-btip]',
    header: true,
    // So that we can set a title
    resetCfg: {},
    listeners: {
      // Reconfigure on pointerOver
      pointerOver: function pointerOver(_ref3) {
        var me = _ref3.source,
            target = _ref3.target;

        // Revert last pointerOver config set to initial setting.
        for (var key in me.resetCfg) {
          if (key === 'listeners') {
            me.un(me.resetCfg[key].set);
          } // Do not reset HTML to "". It causes an unwanted inter-delegate hide.
          // hideOnDelegateChange defaults to false.
          else if (key !== 'html') {
              me[key] = me.resetCfg[key].was;
            }
        }

        me.resetCfg = {};
        var forComponent = _Widget_js__WEBPACK_IMPORTED_MODULE_18__["default"].getById(target.id); // If it's a component's tooltip, configure from the component,
        // Otherwise gather from the dataset

        var config = (forComponent === null || forComponent === void 0 ? void 0 : forComponent.tipConfig) || me.gatherDataConfigs(target.dataset);

        for (var _key2 in config) {
          me.resetCfg[_key2] = {
            set: config[_key2],
            was: me[_key2]
          };

          if (_key2 === 'listeners') {
            me.on(config[_key2]);
          } else {
            me[_key2] = config[_key2];
          }
        }

        me.headerElement.style.display = me.title ? '' : 'none';
      }
    },
    gatherDataConfigs: function gatherDataConfigs(dataset) {
      var me = this,
          config = {};

      for (var key in dataset) {
        if (key.startsWith('btip')) {
          if (key.length > 4) {
            var configProp = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].uncapitalize(key.substr(4)); // Snip off "btip" prefix to convert to property name
            // If we have a config by the name, set it

            if (configProp in me.getDefaultConfiguration()) {
              var value = dataset[key]; // gather the found config value

              config[configProp] = isBoolean[value] ? value === 'true' : isNaN(value) ? value : parseInt(value, 10);
            }
          } else {
            config.html = dataset[key];
          }
        }
      }

      return config;
    }
  });
}

Object.defineProperty(_Widget_js__WEBPACK_IMPORTED_MODULE_18__["default"], 'tooltip', {
  get: function get() {
    if (!globalInstance) {
      clearTimeout(timeoutId);
      createGlobalTooltipInstance();
    }

    return globalInstance;
  }
});
var timeoutId;
function createTooltip() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  if (delay === 0) {
    createGlobalTooltipInstance();
  } else {
    timeoutId = setTimeout(createGlobalTooltipInstance, delay);
  }
} // In some demos this code may execute when body does not yet exist (UMD)

if (!Tooltip.listenersTarget) {
  document.addEventListener('DOMContentLoaded', function () {
    return createTooltip(_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].isTestEnv ? 0 : 1000);
  });
} else {
  // Create the singleton after app startup (Unless in test mode when mouse will be grabbed immediately)
  createTooltip(_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].isTestEnv ? 0 : 1000);
}

Tooltip._$name = 'Tooltip';

/***/ }),

/***/ "./lib/Core/widget/Widget.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Widget.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Widget; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.reflect.get-own-property-descriptor */ "./node_modules/core-js/modules/es.reflect.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.string.anchor */ "./node_modules/core-js/modules/es.string.anchor.js");
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Config_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../Config.js */ "./lib/Core/Config.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../helper/util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Core/localization/En.js");
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Mask_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./Mask.js */ "./lib/Core/widget/Mask.js");



































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_32___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



















 // TODO: Needs more docs

/**
 * @module Core/widget/Widget
 */

var isTransparent = /transparent|rgba\(0,\s*0,\s*0,\s*0\)/,
    textInputTypes = {
  INPUT: 1,
  TEXTAREA: 1
},
    mergeAnim = function mergeAnim(value, was) {
  // The show/hideAnimation objects can only have one animation property, but it is fine to merge if they have
  // the same property.
  return value && was && was[_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_40__["default"].keys(value)[0]] ? _Config_js__WEBPACK_IMPORTED_MODULE_35__["default"].merge(value, was) : value;
},
    widgetTriggerPaint = function widgetTriggerPaint(w) {
  w.isVisible && w.triggerPaint();
},
    negationPseudo = /^:not\((.+)\)$/,
    isScaled = function isScaled(w) {
  return w.scale != null;
},
    hasOwnProperty = Object.prototype.hasOwnProperty,
    parseDuration = function parseDuration(d) {
  return parseFloat(d) * (d.endsWith('ms') ? 1 : 1000);
};
/**
 * Base class for other widgets. The Widget base class simply encapsulates an element, and may optionally contain some
 * specified {@link #config-html}.
 *
 * Subclasses should at override the {@link #function-template} member function to return an HTML string to create their
 * own encapsulating element and internal structure.
 *
 * ## Resolving properties
 *
 * Values for a Widgets properties can be resolved from the ownership hierarchy. For example a text field in a toolbar
 * can get its initial value from a property on the container owning the toolbar. This is achieved by prefixing the
 * desired property name with 'up.':
 *
 * ```javascript
 * const grid = new Grid((
 *   tbar : [
 *     {
 *         type  : 'numberfield',
 *         // Fields value will be retrieved from the grids rowHeight property
 *         value : 'up.rowHeight'
 *     }
 *   ]
 * });
 * ```
 *
 * Please note that this is for now a one way one time binding, the value will only be read initially and not kept up to
 * date on later changes.
 *
 * @mixes Core/mixin/Events
 * @mixes Core/localization/Localizable
 * @extends Core/Base
 * @classType widget
 */


var Widget = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_31___default()(Widget, _Base$mixin);

  var _super = _createSuper(Widget);

  function Widget() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default()(this, Widget);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default()(Widget, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this; // Flag so we know when our dimensions have been constrained during alignment

      me.alignConstrained = 0;
      me.byRef = Object.create(null);
      me.callRealign = me.realign.bind(me);
      me.doHideOrRealign = me.doHideOrRealign.bind(me);
      me.initialRender = true;
      me._isUserAction = false; // Base class applies configs.

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default()(Widget.prototype), "construct", this).call(this, config, args);

      me.finalizeInit();
    }
  }, {
    key: "isType",
    value: function isType(type, deep) {
      return Widget.isType(this, type, deep);
    }
  }, {
    key: "startConfigure",
    value: function startConfigure(config) {
      var me = this,
          adopt = me.adopt,
          element = me.element; // Adopt the preexisting element as our element before configuration proceeds.

      if (adopt) {
        var adoptElement = typeof adopt === 'string' ? document.getElementById(adopt) : adopt,
            previousHolder = Widget.fromElement(adoptElement); // If we are taking it over from a previous iteration, destroy the previous holder. This is not officially
        // supported, but CodeEditor relies on it working

        if (previousHolder && previousHolder.adopt && previousHolder !== me) {
          var previousHolderAdopt = typeof previousHolder.adopt === 'string' ? document.getElementById(previousHolder.adopt) : previousHolder.adopt;

          if (previousHolderAdopt === adoptElement) {
            previousHolder.destroy();
          }
        } // On destroy, leave these


        me.preExistingElements = Array.from(adoptElement.childNodes);
        me.adoptedElementClassName = adoptElement.className;
        me.adoptedElementCssText = adoptElement.style.cssText; // Adopt the host element's id if we don't have one so that we do not override
        // it and invalidate any ad-based CSS rules.

        if (adoptElement.id && !config.id) {
          me.id = element.id = adoptElement.id;
        }

        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].syncAttributes(element, adoptElement);

        for (var i = 0, length = element.childNodes.length; i < length; i++) {
          adoptElement.appendChild(element.childNodes[0]);
        }

        me._element = adoptElement;
        delete me._contentRange;
      } // Mutually exclusive with scaleToFitWidth.
      // Observe container element before the cascade down to descendants.
      // Outer elements are expected to fire resize first.
      // It's a lazy config, so this is the time to flush it through to begin monitoring.


      if (!me.scaleToFitWidth) {
        me.getConfig('monitorResize');
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default()(Widget.prototype), "startConfigure", this).call(this, config);
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(title) {
      if (this.titleElement) {
        this.titleElement.innerHTML = title;
      }
    }
    /**
     * This method is called by `DomHelper.createElement` and `DomSync.sync` as new reference elements are created.
     * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
     * @param {HTMLElement} el The element instance
     * @param {Object} [domConfig] The DOM config object.
     * @private
     */

  }, {
    key: "attachRef",
    value: function attachRef(name, el, domConfig) {
      var me = this,
          listeners = domConfig && domConfig.listeners;
      me[name] = me.byRef[name] = el; // Key elements contain owner pointer if data is supported (Not on IE SVG).

      el.dataset && (el.dataset.ownerCmp = me.id);

      if (listeners) {
        domConfig.listeners = {
          on: listeners,
          un: _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].on(Object.assign({
            element: el,
            thisObj: me
          }, listeners))
        };
      }
    }
    /**
     * This method is called by `DomSync.sync` as reference elements are removed from the DOM.
     * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
     * @param {HTMLElement} el The element instance
     * @param {Object} domConfig The DOM config object.
     * @private
     */

  }, {
    key: "detachRef",
    value: function detachRef(name, el, domConfig) {
      if (domConfig.listeners) {
        domConfig.listeners.un();
        domConfig.listeners = null;
      }

      this[name] = null;
      delete this.byRef[name];
    }
  }, {
    key: "changeElement",
    value: function changeElement(element) {
      var me = this;
      var el, i;

      if (typeof element === 'string') {
        element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].createElementFromTemplate(element);
      } else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_40__["default"].isObject(element)) {
        element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].createElement(element, {
          refOwner: me
        });
      } else if (element.nodeType !== 1) {
        element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].createElementFromTemplate(me.template(me));
      }

      me._element = element;
      var classList = element.classList;
      element.id = me.id; // Add the hierarchy, eg ['b-combo b-pickerfield b-textfield b-widget']
      // TODO: apply not needed when IE11 not supported, classList.add takes multiple classes
      //classList.add(...me.widgetClassList);

      element.className += ' ' + me.widgetClassList.join(' ');

      if (me.contentElementCls) {
        me.contentElement.className += ' ' + me.contentElementCls;
      }

      if (me._hidden) {
        classList.add('b-hidden');
      }

      if (me._readOnly) {
        classList.add('b-readonly');
      } // The environmental classes only need to be added to a naked Widget.
      // If we have a parent container, that will have them.


      if (!me.parent) {
        classList.add('b-outer');
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].addClasses(element, Widget.outerCls);
      }

      var namedElements = element.querySelectorAll('[data-reference]');

      for (i = 0; i < namedElements.length; ++i) {
        el = namedElements[i];
        me.attachRef(el.getAttribute('data-reference'), el);
        el.removeAttribute('data-reference');
      }

      return element;
    }
  }, {
    key: "updateCentered",
    value: function updateCentered(value) {
      var element = this.element;

      if (value && !this.floating && !this.positioned) {
        throw new Error('`centered` is only relevant when a Widget is `floating` or `positioned`');
      }

      if (value) {
        element.classList.add('b-centered');
        element.style.transform = element.style.left = element.style.top = '';
      } else {
        element.classList.remove('b-centered');
      }
    }
    /**
     * The child element into which content should be placed. This means where {@link #config-html} should be put,
     * or, for {@link Core.widget.Container Container}s, where child items should be rendered.
     * @property {HTMLElement}
     * @readonly
     * @category DOM
     */

  }, {
    key: "updateId",
    value: function updateId(id, oldId) {
      if (oldId) {
        var element = this.element,
            refEls = element.querySelectorAll("[data-owner-cmp=\"".concat(oldId, "\"]"));

        for (var i = 0, length = refEls.length; i < length; i++) {
          refEls[i].dataset.ownerCmp = id;
        }

        element.id = id;
      }
    }
    /**
     * Get/set widgets elements style. The setter accepts a cssText string or a style config object, the getter always
     * returns a CSSStyleDeclaration
     * @property {String|Object|CSSStyleDeclaration}
     * @category DOM
     */

  }, {
    key: "updateStyle",
    value: function updateStyle(style) {
      this.element && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].applyStyle(this.element, style);
    }
    /**
     * Get widgets elements dataset or assign to it
     * @property {Object}
     * @category DOM
     */

  }, {
    key: "changeDataset",
    value: function changeDataset(dataset) {
      Object.assign(this.dataset, dataset);
    }
    /**
     * Called by the Base constructor after all configs have been applied.
     * @internal
     * @category Lifecycle
     */

  }, {
    key: "finalizeInit",
    value: function finalizeInit() {
      if (this.insertBefore || this.appendTo || this.insertFirst || this.adopt) {
        this.render();
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this,
          tooltip = me.tooltip,
          preExistingElements = me.preExistingElements,
          element = me.element;
      me.scrollable && me.scrollable.destroy();

      if (tooltip) {
        // If it's our own "newInstance", then destroy it.
        if (me._tooltip) {
          tooltip.destroy();
        } // The singleton is active for this element and visible, so hide it
        else {
            tooltip.hide();
          }
      }

      me.unmask();

      if (element) {
        var _me$dragEventDetacher, _me$dragOverEventDeta;

        // If we get destroyed very quickly after a call to show,
        // we must kill the timers which add the realign listeners.
        me.clearTimeout(me.scrollListenerTimeout);
        me.clearTimeout(me.resizeListenerTimeout); // Remove listeners which are only added during the visible phase.
        // In its own method because it's called on hide and destroy.

        me.removeTransientListeners();

        if (me.floating || me.positioned) {
          me.hide();
        } else {
          me.revertFocus();
        }

        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].removeResizeListener(element.parentElement, me.onParentElementResize);
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].removeResizeListener(element, me.onElementResize); // Remove elements *which we own* on destroy,

        if (me.adopt) {
          for (var nodes = Array.from(element.childNodes), i = 0, length = nodes.length; i < length; i++) {
            var el = nodes[i]; // If it's not preexisting, and not the floatRoot, remove it

            if (!preExistingElements.includes(el) && el !== Widget.floatRoot) {
              el.remove();
            }
          }

          element.className = me.adoptedElementClassName;
          element.style.cssText = me.adoptedElementCssText;
        } else {
          element.remove();
        }

        (_me$dragEventDetacher = me.dragEventDetacher) === null || _me$dragEventDetacher === void 0 ? void 0 : _me$dragEventDetacher.call(me);
        (_me$dragOverEventDeta = me.dragOverEventDetacher) === null || _me$dragOverEventDeta === void 0 ? void 0 : _me$dragOverEventDeta.call(me);
        me.dragGhost.remove();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default()(Widget.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Render

  }, {
    key: "render",
    value: function render(appendToElement) {
      var triggerPaint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var me = this,
          element = me.element;
      me.emptyCache();

      if (me.syncElement && me.currentElement) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].sync(element, me.currentElement);
      } else {
        // Use passed element to insert this widget directly
        if (appendToElement) {
          me.appendTo = typeof appendToElement === 'string' ? document.getElementById(appendToElement) : appendToElement;
          me.appendTo.appendChild(element);
        } // If nothing was passed directly, try to use configs preferring `insertBefore` first
        else if (me.insertBefore) {
            me.insertBefore = typeof me.insertBefore === 'string' ? document.getElementById(me.insertBefore) : me.insertBefore;
            me.insertBefore.parentElement.insertBefore(element, me.insertBefore);
          } else if (me.insertFirst) {
            me.insertFirst = typeof me.insertFirst === 'string' ? document.getElementById(me.insertFirst) : me.insertFirst; // Try to insert as a first child

            if (me.insertFirst.firstChild) {
              me.insertFirst.insertBefore(element, me.insertFirst.firstChild);
            } // insertBefore will throw exceptions if firstChild element not exists. Add as only child then.
            else {
                me.insertFirst.appendChild(element);
              }
          } else if (me.appendTo) {
            me.appendTo = typeof me.appendTo === 'string' ? document.getElementById(me.appendTo) : me.appendTo;
            me.appendTo.appendChild(element);
          }

        me.currentElement = element;
      }

      me.rendered = true;

      if (triggerPaint) {
        me.getConfig('contentRange');
        me.triggerPaint();
      }
    }
    /**
     * A function which, when passed an instance of this Widget, produces a valid HTML string which is compiled
     * to create the encapsulating element for this Widget, and its own internal DOM structure.
     *
     * Note that this just creates the DOM structure that *this* Widget owns. If it contains child widgets
     * (Such as for example a grid), this is not included. The template creates own structure.
     *
     * Certain elements within the generated element can be identified as special elements with a `reference="name"`
     * property. These will be extracted from the element upon creation and injected as the named property into
     * the Widget. For example, a {@link Core.widget.TextField} will have an `input` property which is its
     * `<input>` element.
     * @param {Core.widget.Widget} me The widget for which to produce the initial HTML structure.
     * @internal
     */

  }, {
    key: "template",
    value: function template(me) {
      return "<".concat(me.tag, " class=\"").concat(me.html ? me.htmlCls : '', "\" ").concat(me.name ? "data-name=\"".concat(me.name, "\"") : '', ">").concat(me.html || '', "</").concat(me.tag, ">");
    } //endregion
    //region floating

    /**
     * If this Widget is {@link #config-floating} or {@link #config-positioned}, and visible,
     * aligns the widget according to the passed specification.
     * For details, see the {@link #function-showBy} method.
     * @param {Object} spec Alignment options. May be an object as processed by the {@link #function-showBy} method,
     * or an `HTMLElement` to align to using this Widget's {@link #config-align} configuration.
     * @category Float & align
     */

  }, {
    key: "alignTo",
    value: function alignTo(spec) {
      // You can "alignTo" an element or a Widget or a Point, and allow our align config.
      // property to specify how.
      if (spec.nodeType === 1 || spec instanceof Widget || spec.$$name === 'Point') {
        spec = {
          target: spec
        };
      } // Release size constraints so we can align from scratch each time.


      this.releaseSizeConstraints();
      var me = this,
          scrollable = me.scrollable,
          element = me.element,
          constrainTo = me.constrainTo,
          scale = me.scale || 1,
          passedTarget = spec.target,
          target = passedTarget && (passedTarget instanceof _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"] ? passedTarget : passedTarget.element || passedTarget),
          myPosition = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(element, me.positioned ? element.offsetParent : null, true),
          aligningToElement = target && target.nodeType === 1;
      spec = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_40__["default"].assign({
        constrainTo: constrainTo,
        align: 'b-t',
        // we can end up w/o a value for this if an object replaces a string
        axisLock: me.axisLock,
        anchor: me.anchor
      }, me.align, spec); // As part of fallback process when fitting within constraints, this may shrink to minima specified
      // either on the align spec or the widget itself.

      var minWidth = spec.minWidth || me.minWidth,
          minHeight = spec.minHeight || me.minHeight; // Minima have a different meaning in an alignRectangle.
      // It means that the rectangle is willing to shrink down
      // to that size during constraint, *not* that it can never
      // be smaller than that size.

      myPosition.isAlignRectangle = true;
      minWidth && (myPosition.minWidth = minWidth * scale);
      minHeight && (myPosition.minHeight = minHeight * scale); // This is used by the realign call which may be called either when a global scroll is detected
      // or the constraining element is resized.

      me.lastAlignSpec = spec;

      if (aligningToElement && target.offsetParent) {
        // Translate the element into a browser viewport based Rectangle. Rectangle
        // Doesn't have the knowledge that we do to make this decision. Floating
        // alignment all takes place within browser viewport space, not document space.
        // Don't destroy the spec which was cached above with the element in it.
        spec = Object.setPrototypeOf({}, spec);
        spec.target = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(target, me.positioned ? element.offsetParent : null, !me.positioned); // Force the target to have an area so that intersect works.

        spec.target.height = Math.max(spec.target.height, 1);
        spec.target.width = Math.max(spec.target.width, 1); // Handle the target being clipped by the bounds of various elements.
        // For example in a grid, the SubGrid element will clip the left and right
        // but the main grid bodyContainer will clip the top and bottom.

        var clippedBy = me.clippedBy;

        if (clippedBy) {
          var clippedTarget = spec.target.intersect(clippedBy); // If there is an intersecting Rectangle with the forElement, align

          if (clippedTarget) {
            spec.target = clippedTarget;
          } // This is the case where the target is scrolled or positioned out of view.
          else {
              var _result = me.hide(); // The hide method clears this flag.
              // Only this hide invocation must complete with the
              // targetHidden flag as true


              me.lastAlignSpec.targetHidden = true;
              return _result;
            }
        } // This is the element which determines our position.
        // This is used in doHideOrRealign to see if a scroll event
        // will have affected our position.


        me.anchoredTo = target;
      } else {
        me.anchoredTo = null;
      }

      if (spec.anchor) {
        spec.anchorSize = me.anchorSize;
        element.appendChild(me.anchorElement);
      } // If we're positioned, the constrainTo must be a Rectangle in our offsetParent's coordinate space


      if (constrainTo && !constrainTo.isRectangle && me.positioned) {
        var isViewport = constrainTo === document || constrainTo === window;
        spec.constrainTo = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(isViewport ? document.body : spec.constrainTo, element.offsetParent);
      } // Flag to prevent infinite loop when setting html from a beforeAlign listener


      me.isAligning = true; // Allow outside world to modify the suggested position

      me.trigger('beforeAlign', spec);
      me.isAligning = false; // Calculate the best position WRT target rectangle, our rectangle, a constrainTo rectangle
      // and the rectangle of an anchor pointer.

      var result = myPosition.alignTo(spec); // May change if constraint changes our shape, and we have to go round again

      var align = result.align,
          anchor = result.anchor,
          x = result.x,
          y = result.y,
          width = result.width,
          height = result.height,
          bottom = result.bottom,
          right = result.right; // Which zone, T=0, R=1, B=2, L=3 the result is in

      me.lastAlignSpec.zone = result.zone; // If the alignment specified that we must constrain a dimension in order to
      // fit within our constrainTo, then obey that. If we own a Scroller, then
      // inform it that we do now need to scroll that dimension.
      // These conditions are released upon each alignment call because conditions may change.

      if (height !== myPosition.height) {
        if (!('configuredHeight' in me)) {
          me.configuredHeight = element.style.height;
        }

        me.height = height / scale;
        me.alignConstrained = me.alignConstrained | 1;

        if (scrollable) {
          scrollable.overflowY = true;
        }
      }

      if (width !== myPosition.width) {
        if (!('configuredWidth' in me)) {
          me.configuredWidth = element.style.width;
        }

        me.width = width / scale;
        me.alignConstrained = me.alignConstrained | 2;

        if (scrollable) {
          scrollable.overflowX = scrollable.clientWidth > scrollable.scrollWidth;
        }
      } // If either dimension has been constrained, we may have changed shape
      // due to text wrapping/overflowing, so we have to realign at the
      // successful align setting.


      if (align && me.alignConstrained) {
        spec.align = align;
        var newResult = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(element, me.positioned ? element.offsetParent : null, true).alignTo(spec);
        anchor = newResult.anchor;
        x = newResult.x;
        y = newResult.y;
        width = newResult.width;
        height = newResult.height;
        bottom = newResult.bottom;
        right = newResult.right;
      }

      me.setXY(x, y); // If we asked it to also calculate our anchor position, position our anchor

      if (anchor) {
        var _anchor = anchor,
            edge = _anchor.edge,
            anchorElement = me.anchorElement,
            elRect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(element, null, true),
            colorMatchPoint = [],
            stylePointerEvents = element.style.pointerEvents; // Enable pointerEvents to make discoverable by elementFromPoint()

        element.style.pointerEvents = 'all'; // Make the anchor color match the color of the closest adjacent element

        if (edge === 'top' || edge === 'bottom') {
          colorMatchPoint[0] = elRect.x + anchor.x;
          colorMatchPoint[1] = edge === 'top' ? elRect.y + 1 : bottom - 1;
        } else {
          colorMatchPoint[0] = edge === 'left' ? elRect.x + 1 : right - 1;
          colorMatchPoint[1] = elRect.y + anchor.y;
        }

        var colourSource = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].elementFromPoint.apply(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"], colorMatchPoint);
        element.style.pointerEvents = stylePointerEvents || null; // If  it's off the edge of the screen, we won't be able to read it.
        // But that's fine, the anchor will be off the edge in that case.

        if (colourSource) {
          var fillColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getStyleValue(colourSource, 'background-color');

          if (fillColour.match(isTransparent)) {
            me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
          } else {
            me.anchorPathElement.setAttribute('fill', fillColour);
          }
        }

        anchorElement.classList.remove('b-hide-display');
        anchorElement.style.transform = '';
        anchorElement.className = "b-anchor b-anchor-".concat(edge); // Anchor's position needs boosting if we are scaled down

        anchor.x && (anchor.x /= scale);
        anchor.y && (anchor.y /= scale);
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].setTranslateXY(anchorElement, anchor.x, anchor.y);
        element.classList.add('b-anchored');
      } else if (me._anchorElement) {
        me.anchorElement.classList.add('b-hide-display');
        element.classList.remove('b-anchored');
      } // If we are to hide on scroll, we still need to know if the element we are
      // aligned to moves. If we have not been *explicitly* aligned to an element,
      // Use the element at our display position. For example, when a context menu
      // is shown on a grid header, then is the grid header is moved by a scroll
      // event, then we must hide.


      if (me.scrollAction === 'hide' && !aligningToElement) {
        // Our element is over the X, Y point now,
        // elementFromPoint must "see through" it.
        element.style.pointerEvents = 'none';
        me.anchoredTo = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].elementFromPoint(x, y);
        element.style.pointerEvents = '';
      } // If we're aligning to an element, then listen for scrolls so that we can remain aligned.
      // Scrolls can be instigated with no mousedown, so transient floating Widgets can be put
      // out of alignment by scrolls.


      if ((me.scrollAction === 'realign' && aligningToElement || me.scrollAction === 'hide') && !me.documentScrollListener) {
        // Firefox requires a longer timeout to not autohide as the result of a scroll event firing during Menu show
        me.clearTimeout(me.scrollListenerTimeout);
        me.scrollListenerTimeout = me.setTimeout(function () {
          me.documentScrollListener = true;
          document.addEventListener('scroll', me.doHideOrRealign, true);
        }, me.scrollAction === 'hide' ? me.ignoreScrollDuration : 0);
      } // If alignment specified monitorResize add a resize listener to the target so we can stay aligned.


      if (aligningToElement && spec.monitorResize && !me.targetResizeListener) {
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].addResizeListener(target, me.callRealign);
        me.targetResizeListener = true;
      } // Don't try to listen for window resizes to try realigning on Android.
      // That just means the keyboard has been shown.


      if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isAndroid) {
        if (!me.constrainListeners && !(constrainTo instanceof _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          // Always observe for changes to window size since aligned things
          // will possibly be out of place after a window resize
          me.clearTimeout(me.resizeListenerTimeout);
          me.resizeListenerTimeout = me.setTimeout(function () {
            me.constrainListeners = true;
            _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].addResizeListener(constrainTo || window, me.callRealign);
          }, me.ignoreScrollDuration);
        }
      }
    }
  }, {
    key: "realign",
    value: function realign(el) {
      var me = this;

      if (me.isVisible && (me.floating || me.positioned) && me.lastAlignSpec) {
        var target = me.lastAlignSpec.target; // If there was a DOM mutation which caused our target to become not layed out, or the target
        // is outside of the passed element's rectangle (passed from scroll handler), we must hide

        if (target && target.nodeType === 1) {
          // It might occur that target gets detached from DOM in IE11
          if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11 && !Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["isInDocument"])(target)) {
            return me.hide();
          }

          var targetWidget = Widget.fromElement(target),
              targetRect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(target),
              targetIsVisible = (!targetWidget || targetWidget.isVisible) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].isVisible(target); // We can align to an element which has a zero dimension, but the
          // intersection check requires that both dimensions are non-zero.

          targetRect.minHeight = targetRect.minWidth = 1;

          if (target !== document.body && !targetIsVisible || el && el.nodeType === 1 && el.contains(target) && !_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(el).intersect(targetRect)) {
            return me.hide();
          }
        }

        me.alignTo(me.lastAlignSpec);
      }
    }
  }, {
    key: "releaseSizeConstraints",
    value: function releaseSizeConstraints() {
      var me = this,
          scroller = me.scrollable; // Release constraints so we can align from scratch each time.

      if (me.alignConstrained & 1) {
        me.height = me.configuredHeight;

        if (scroller) {
          scroller.overflowY = scroller.config.overflowY;
        }
      }

      if (me.alignConstrained & 2) {
        me.width = me.configuredWidth;

        if (scroller) {
          scroller.overflowX = scroller.config.overflowX;
        }
      }

      me.alignConstrained = 0;
    }
    /**
     * Only valid for {@link #config-floating} Widgets. Moves to the front of the visual stacking order.
     * @category Float & align
     */

  }, {
    key: "toFront",
    value: function toFront() {
      var element = this.element,
          parent = this.floating ? Widget.floatRoot : this.positioned ? element === null || element === void 0 ? void 0 : element.parentNode : null;

      if (element && element.nextSibling) {
        var r = this._toFrontRange || (this._toFrontRange = document.createRange()); // Instead of moving this element (which may contain focus and therefore should not be moved),
        // Lasso all following nodes using a range and insert them before this.
        // If it contained focus, appending it triggers a focusOut event which will not be expected.

        r.setStartBefore(element.nextSibling);
        r.setEndAfter(parent.lastElementChild);
        parent.insertBefore(r.extractContents(), element);
      }
    } //endregion
    //region Getters/setters

  }, {
    key: "updateRef",
    value: function updateRef(ref) {
      this.element.dataset.ref = ref;
    }
  }, {
    key: "changeAlign",
    value: function changeAlign(align) {
      return typeof align === 'string' ? {
        align: align
      } : align;
    }
  }, {
    key: "changeScrollable",
    value: function changeScrollable(scrollable, oldScrollable) {
      var _scrollable;

      if (typeof scrollable === 'boolean') {
        scrollable = {
          overflowX: scrollable,
          overflowY: scrollable
        };
      }

      scrollable.element = this.overflowElement;
      scrollable.widget = this; // If we already had a scroller, reconfigure it if possible

      if (oldScrollable) {
        // Destroy the oldScrollable if we are not reconfiguring it
        if (!scrollable || scrollable.isScroller) {
          oldScrollable.destroy();
        } else {
          oldScrollable.setConfig(scrollable);
          scrollable = oldScrollable;
        }
      } else {
        scrollable = new this.scrollerClass(scrollable);
      } // Keep overflow indicator classes in sync


      (_scrollable = scrollable) === null || _scrollable === void 0 ? void 0 : _scrollable.syncOverflowState();
      return scrollable;
    }
    /**
     * Get/set HTML to display. When specifying HTML, this widget's element will also have the
     * {@link #config-htmlCls} added to its classList, to allow targeted styling.
     * @property {String}
     * @category DOM
     */

  }, {
    key: "updateHtml",
    value: function updateHtml(html) {
      var me = this,
          isClearing = html == null,
          element = me.element,
          contentElement = me.contentElement,
          htmlCls = me.htmlCls;

      if (element) {
        var anchorEl = contentElement === element && me._anchorElement; // Flag class that we are an HTML carrying element

        if (htmlCls) {
          element.classList[isClearing ? 'remove' : 'add'](htmlCls);
        } // Setting innerHTML destroys the anchorElement in some browsers
        // so we must temporarily remove it to preserve it.
        // Only if the contentElement is the main element.


        if (anchorEl) {
          me.element.removeChild(anchorEl);
        }

        if (html && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27___default()(html) === 'object') {
          _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_39__["default"].sync({
            domConfig: html,
            targetElement: me.contentElement,
            onlyChildren: true
          });
        } else {
          me.contentElement.innerHTML = isClearing ? '' : html;
        }

        if (anchorEl) {
          element.appendChild(anchorEl);
        }

        if (me.floating || me.positioned) {
          // Must realign because content change might change dimensions
          if (!me.isAligning) {
            me.realign();
          }
        }
      }
    }
  }, {
    key: "updateContent",
    value: function updateContent(html) {
      var me = this,
          isClearing = html == null,
          element = me.element,
          htmlCls = me.htmlCls;

      if (element) {
        var contentRange = me.contentRange; // Flag class that we are an HTML carrying element

        if (htmlCls) {
          element.classList[isClearing ? 'remove' : 'add'](htmlCls);
        } // Only works if we are in the DOM


        if (Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["isInDocument"])(element)) {
          // Replace the contents of our content range with the new content
          contentRange.deleteContents();

          if (!isClearing) {
            contentRange.insertNode(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].createElementFromTemplate(html, {
              fragment: true
            }));
          }
        } else {
          me.contentElement.innerHTML = html;
        } // Cache in case it gets collapsed


        me.contentRangeStartOffset = contentRange.startOffset;
        me.contentRangeEndOffset = contentRange.endOffset; // Must realign because content change might change dimensions

        if ((me.floating || me.positioned) && !me.isAligning) {
          me.realign();
        }
      }
    }
  }, {
    key: "onThemeChange",
    value: function onThemeChange() {
      var _this$anchorElement;

      // If we have a *visible* anchor element, then a theme change may
      // invalidate it's size or this.defaultAnchorBackgroundColor, so a
      // run through realign (and get anchorSize) will fix that.
      if ((_this$anchorElement = this.anchorElement) === null || _this$anchorElement === void 0 ? void 0 : _this$anchorElement.offsetParent) {
        this._anchorSize = null;
        this.realign();
      }
    }
    /**
     * Returns an `[x, y]` array containing the width and height of the anchor arrow used when
     * aligning this Widget to another Widget or element.
     *
     * The height is the height of the arrow when pointing upwards, the width is the width
     * of the baseline.
     * @property {Number[]}
     * @category Float & align
     */

  }, {
    key: "updateAnchor",
    value: function updateAnchor(anchor) {
      if (this._anchorElement) {
        this._anchorElement.classList[anchor ? 'remove' : 'add']('b-hide-display');
      }
    }
  }, {
    key: "updateDraggable",
    value: function updateDraggable(draggable) {
      var me = this,
          element = me.element;

      if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isFirefox) {
        element.setAttribute('draggable', Boolean(draggable));
      }

      if (draggable) {
        me.dragEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].addListener({
          element: element,
          dragstart: 'onWidgetDragStart',
          dragend: 'onWidgetDragEnd',
          thisObj: me
        }); // Fix for FF draggable bug https://bugzilla.mozilla.org/show_bug.cgi?id=1189486

        if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isFirefox) {
          me.ffDragDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].on({
            element: element,
            mousedown: function mousedown(e) {
              if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].up(e.target, '.b-field-inner')) {
                element.setAttribute('draggable', 'true');
              }
            },
            thisObj: me
          });
        }
      } else {
        var _me$dragEventDetacher2, _me$dragOverEventDeta2, _me$ffDragDetacher;

        (_me$dragEventDetacher2 = me.dragEventDetacher) === null || _me$dragEventDetacher2 === void 0 ? void 0 : _me$dragEventDetacher2.call(me);
        (_me$dragOverEventDeta2 = me.dragOverEventDetacher) === null || _me$dragOverEventDeta2 === void 0 ? void 0 : _me$dragOverEventDeta2.call(me);
        (_me$ffDragDetacher = me.ffDragDetacher) === null || _me$ffDragDetacher === void 0 ? void 0 : _me$ffDragDetacher.call(me);
      }
    }
  }, {
    key: "onWidgetDragStart",
    value: function onWidgetDragStart(e) {
      var me = this,
          element = me.element,
          actualTarget = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].elementFromPoint(e.clientX, e.clientY),
          handleSelector = me.draggable.handleSelector;

      if (handleSelector) {
        var blacklist = negationPseudo.exec(handleSelector)[1]; // Extract the content of :not()
        // If the selector was :not(), then if we are a descendant of a matching element, it's a no-drag

        if (blacklist) {
          if (actualTarget.closest("#".concat(element.id, " ").concat(blacklist))) {
            e.preventDefault();
            return;
          }
        } // If we are not the descendant of a matching element, it's a no-drag
        else if (!actualTarget.closest("#".concat(element.id, " ").concat(handleSelector))) {
            e.preventDefault();
            return;
          }
      } // Opt out of auto-alignment on scroll or DOM mutation.


      me.removeTransientListeners();
      var dragStartX = e.clientX,
          dragStartY = e.clientY,
          scrollingPageElement = document.scrollingElement || document.body,
          widgetX = me.getXY()[0],
          widgetY = me.getXY()[1];
      document.body.appendChild(me.dragGhost);
      me.setDragImage(e); // Prevent special cursor from being shown

      e.dataTransfer.effectAllowed = 'none';
      me.dragOverEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].addListener({
        element: document.body,
        // Position using direct DOM access, do not go though the setXY method which clears
        // any centered config. User dragging only moves this show of the widget. Upon next
        // neutral show (with no extra positioning info), a centered widget will show centered again.
        dragover: function dragover(event) {
          // Centered adds positioning rules, it can't be centered during drag.
          element.classList.remove('b-centered');
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].setTranslateXY(element, widgetX + event.clientX - dragStartX - scrollingPageElement.scrollLeft, widgetY + event.clientY - dragStartY - scrollingPageElement.scrollTop);
        }
      }); // Opt out of anchoring

      me.anchor = null;
    }
  }, {
    key: "setDragImage",
    value: function setDragImage(e) {
      if (e.dataTransfer.setDragImage) {
        // Firefox requires this to be called before setDragImage
        e.dataTransfer.setData('application/node type', ''); // Override the default HTML5 drag ghost and just drag an empty node

        e.dataTransfer.setDragImage(this.dragGhost, 0, 0);
      }
    }
  }, {
    key: "onWidgetDragEnd",
    value: function onWidgetDragEnd() {
      this.dragGhost.remove();
      this.dragOverEventDetacher();

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isFirefox) {
        this.element.removeAttribute('draggable');
      }
    }
  }, {
    key: "changeFloating",
    value: function changeFloating(value) {
      // Coerce all to boolean so that we have a true/false value
      return Boolean(value);
    }
  }, {
    key: "changePositioned",
    value: function changePositioned(value) {
      // Coerce all to boolean so that we have a true/false value
      return Boolean(value);
    }
  }, {
    key: "updatePositioned",
    value: function updatePositioned(positioned) {
      this.element.classList[positioned ? 'add' : 'remove']('b-positioned');
    }
  }, {
    key: "getXY",
    value: function getXY() {
      return [_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getPageX(this.element), _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getPageY(this.element)];
    }
    /**
     * Moves this Widget to the x,y position. Both arguments can be omitted to just set one value.
     *
     * *For {@link #config-floating} Widgets, this is a position in the browser viewport.*
     * *For {@link #config-positioned} Widgets, this is a position in the element it was rendered into.*
     *
     * @param {Number} [x]
     * @param {Number} [y]
     * @category Float & align
     */

  }, {
    key: "setXY",
    value: function setXY(x, y) {
      var me = this;

      if (me.floating || me.positioned) {
        if (x != null) {
          me._x = x;
          me.centered = false;
        }

        if (y != null) {
          me._y = y;
          me.centered = false;
        }

        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].setTranslateXY(me.element, me._x || 0, me._y || 0);
      }
    }
    /**
     * Moves this Widget to the desired x position. *Only valid for {@link #config-floating} Widgets.
     * @property {Number} x
     * @category Float & align
     */

  }, {
    key: "changeX",
    value: function changeX(x) {
      this.setXY(x);
    }
    /**
     * Moves this Widget to the desired y position. *Only valid for {@link #config-floating} Widgets.
     * @property {Number} y
     * @category Float & align
     */

  }, {
    key: "changeY",
    value: function changeY(y) {
      this.setXY(null, y);
    }
    /**
     * Get elements offsetWidth or sets its style.width, or specified width if element not created yet.
     * @property {Number|String}
     * @category Layout
     */

  }, {
    key: "changeWidth",
    value: function changeWidth(width) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].setLength(this.element, 'width', width); // Invalidate the width, so it will be read from the DOM if a read is requested before the resize event

      this._width = null; // Setting width explicitly should reset flex, since it's not flexed anymore

      this._flex = null;
      this.element.style.flex = '';
    }
    /**
     * Get/set elements maxWidth. Getter returns max-width from elements style, which is always a string. Setter accepts
     * either a String or a Number (which will have 'px' appended). Note that like {@link #config-width},
     * _reading_ the value will return the numeric value in pixels.
     * @property {String|Number}
     * @category Layout
     */

  }, {
    key: "updateMaxWidth",
    value: function updateMaxWidth(maxWidth) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].setLength(this.element, 'maxWidth', maxWidth);
    }
    /**
     * Get/set elements minWidth. Getter returns min-width from elements style, which is always a string. Setter accepts
     * either a String or a Number (which will have 'px' appended). Note that like {@link #config-width},
     * _reading_ the value will return the numeric value in pixels.
     * @property {String|Number}
     * @category Layout
     */

  }, {
    key: "updateMinWidth",
    value: function updateMinWidth(minWidth) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].setLength(this.element, 'minWidth', minWidth);
    }
  }, {
    key: "updateFlex",
    value: function updateFlex(flex) {
      // Default grow to the same as flex and basis to 0.
      if (typeof flex === 'number' || !isNaN(flex)) {
        flex = "".concat(flex, " ").concat(flex);
      }

      this.element.style.flex = flex;
      this.element.style.width = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11 ? '' : null;
    }
  }, {
    key: "updateAlignSelf",
    value: function updateAlignSelf(alignSelf) {
      this.element.style.alignSelf = alignSelf;
    }
  }, {
    key: "updateMargin",
    value: function updateMargin(margin) {
      // Convert eg 1 to "1px 1px 1px 1px" or "0 8px" to "0px 8px 0px 8px"
      this.element.style.margin = this.parseTRBL(margin).join(' ');
    }
  }, {
    key: "updateTextAlign",
    value: function updateTextAlign(align, oldAlign) {
      oldAlign && this.element.classList.remove("b-text-align-".concat(oldAlign));
      this.element.classList.add("b-text-align-".concat(align));
    }
    /**
     * Get element's offsetHeight or sets its style.height, or specified height if element no created yet.
     * @property {Number|String}
     * @category Layout
     */

  }, {
    key: "changeHeight",
    value: function changeHeight(height) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].setLength(this.element, 'height', height); // Invalidate the height, so it will be read from the DOM if a read is requested before the resize event

      this._height = null;
    }
    /**
     * Get/set element's maxHeight. Getter returns max-height from elements style, which is always a string. Setter
     * accepts either a String or a Number (which will have 'px' appended). Note that like {@link #config-height},
     * _reading_ the value will return the numeric value in pixels.
     * @property {String|Number}
     * @category Layout
     */

  }, {
    key: "updateMaxHeight",
    value: function updateMaxHeight(maxHeight) {
      var me = this,
          element = me.element;
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].setLength(me.maxHeightElement, 'maxHeight', maxHeight); // Flexbox does not handle overflow correctly when a vertically
      // flexed item is constrained by the maxHeight of its containing el.
      // So we have to propagate the maxHeight from the encapsulating element
      // onto the contentElement.

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11 && me.contentElement !== element) {
        if (maxHeight == null) {
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].removeResizeListener(element, me.boundMaxHeightBugHandler);
        } else {
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].addResizeListener(element, me.boundMaxHeightBugHandler || (me.boundMaxHeightBugHandler = me.fixIEMaxHeightBug.bind(me)));

          if (document.body.contains(element)) {
            me.fixIEMaxHeightBug();
          }
        }
      }
    }
  }, {
    key: "fixIEMaxHeightBug",
    value: function fixIEMaxHeightBug() {
      var element = this.element,
          contentElement = this.contentElement; // If this widget is flexed vertically, the maxHeight of the encapsulating element must be
      // propapagated onto the contentElement.

      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getStyleValue(element, 'flex-direction') === 'column') {
        // Release previous height constraint
        contentElement.style.maxHeight = '';
        var availableHeight = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].client(element).height;
        var siblings = element.childNodes,
            len = siblings.length; // In case there are height-consuming siblings of the contentElement.
        // For example a header/footer. The heights of these must be subtracted.

        for (var i = 0; i < len; i++) {
          var sibling = siblings[i];

          if (sibling !== contentElement && !sibling.classList.contains('b-resize-monitors')) {
            availableHeight -= sibling.offsetHeight;
          }
        } // Apply the adjusted height constraint to the contentElement


        this.contentElement.style.maxHeight = "".concat(availableHeight, "px");
      }
    }
    /**
     * Get/set element's minHeight. Getter returns min-height from elements style, which is always a string. Setter
     * accepts either a String or a Number (which will have 'px' appended). Note that like {@link #config-height},
     * _reading_ the value will return the numeric value in pixels.
     * @property {String|Number}
     * @category Layout
     */

  }, {
    key: "updateMinHeight",
    value: function updateMinHeight(minHeight) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].setLength(this.element, 'minHeight', minHeight);
    }
  }, {
    key: "updateDisabled",
    value: function updateDisabled(disabled) {
      var el = this.element,
          focusEl = this.focusElement;
      disabled && this.revertFocus();

      if (el) {
        el.classList[disabled ? 'add' : 'remove']('b-disabled');

        if (focusEl) {
          focusEl.disabled = disabled;
        }
      }

      this.onDisabled(disabled);
    }
    /**
     * Called when disabled state is changed.
     * Override in subclass that needs special handling when being disabled.
     * @param {Boolean} disabled current state
     * @private
     */

  }, {
    key: "onDisabled",
    value: function onDisabled(disabled) {}
    /**
     * Disable the widget
     */

  }, {
    key: "disable",
    value: function disable() {
      this.disabled = true;
    }
    /**
     * Enable the widget
     */

  }, {
    key: "enable",
    value: function enable() {
      this.disabled = false;
    }
    /**
     * Get/set a tooltip on the widget. Accepts a string or tooltip config (specify true (or 'true') to use placeholder
     * as tooltip). When using a string it will configure the tooltip with `textContent: true` which enforces a default
     * max width.
     *
     * By default, this uses a singleton Tooltip instance which may be accessed from the
     * `{@link Core.widget.Widget Widget}` class under the name `Widget.tooltip`.
     * This is configured according to the config object on pointer over.
     *
     * To request a separate instance be created just for this widget, add `newInstance : true`
     * to the configuration.
     *
     * @property {String|Object}
     * @category Misc
     */

  }, {
    key: "changeTooltip",
    //noinspection JSAnnotator
    value: function changeTooltip(config, oldTooltip) {
      var me = this;
      var ret = null;

      if (oldTooltip) {
        oldTooltip.destroy();
      }

      delete me.element.dataset.btip;

      if (config) {
        if (!(me.preventTooltipOnTouch && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isTouchDevice)) {
          if (config.constructor.name !== 'Object') {
            config = {
              html: typeof config === 'string' ? config : me.placeholder,
              textContent: true
            };
          } // We have to explicitly request a new instance to avoid spam Tooltip instances


          if (config.newInstance) {
            config.type = 'tooltip';
            if (!config.forElement) config.forElement = me.element;
            if (!('showOnHover' in config) && !config.forSelector) config.showOnHover = true;
            if (!('autoClose' in config)) config.autoClose = true;
            ret = Widget.create(config);
          } // The default is that tooltip content and configs from tipConfig
          else {
              me.element.dataset.btip = true;
              me.tipConfig = config;
            }
        }
      }

      return ret;
    }
    /**
     * Determines visibility by checking if the Widget is hidden, or any ancestor is hidden and that it has an
     * element which is visible in the DOM
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "focus",

    /**
     * Focuses this widget if it has a focusable element.
     */
    value: function focus() {
      if (this.isFocusable) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].focusWithoutScrolling(this.focusElement);
      }
    }
    /**
     * Get this widget's primary focus holding element if this widget is itself focusable, or contains focusable widgets.
     * @property {HTMLElement}
     * @readonly
     * @category DOM
     */

  }, {
    key: "show",

    /**
     * Shows this widget
     * @category Visibility
     * @async
     * @returns {Promise} A promise which is resolved when the widget is shown
     */
    value: function show() {
      var _this = this;

      return new Promise(function (resolve) {
        var me = _this,
            showAnimation = me.showAnimation,
            element = me.element,
            floatRoot = Widget.floatRoot,
            style = element.style;
        var styleProp, animProps;
        /**
         * Triggered before a widget is shown. Return `false` to prevent the action.
         * @preventable
         * @event beforeShow
         * @param {Core.widget.Widget} source The widget being shown.
         */

        if (!me.isVisible && me.trigger('beforeShow') !== false && (!me.internalBeforeShow || me.internalBeforeShow() !== false)) {
          // Cancel any current hide/show animation
          me.cancelHideShowAnimation(); // Centered config value takes precedence over x and y configs.
          // This also ensures that widgets configured with centered: true
          // and draggable : true will show in the center on next show after
          // being dragged by the user which is the intuitive UX.

          me.updateCentered(me._centered);

          if (me.floating) {
            if (!floatRoot.contains(element)) {
              // Replace this Widget's DOM into the container if it's already rendered
              if (me.rendered) {
                floatRoot.appendChild(me.element);
              } else {
                // Pass triggerPaint as false. The calls will not propagate
                // anyway since we are still hidden.
                me.render(floatRoot, false);
              }
            } // Because we are outside of any owner's element, we need to see if they're scaled so
            // that we match. See scaled examples with tooltips in API docs guides section.


            if (style.transform.includes('scale')) {
              me.scale = null;
              style.transform = style.transformOrigin = '';
            }

            var scaledAncestor = me.closest(isScaled);

            if (scaledAncestor) {
              var scale = scaledAncestor.scale; // Our scale is the same while we are visible and owned by that scaled ancestor.
              // Now floating descendants will follow suit.

              me.scale = scale;
              style.transform = "scale(".concat(scale, ")");
              style.transformOrigin = "0 0";
            }
          }

          me._hidden = false;
          element.classList.remove('b-hidden');

          if (showAnimation) {
            styleProp = Object.keys(showAnimation)[0];
            animProps = showAnimation[styleProp];
            me.currentAnimation = {
              styleProp: styleProp,
              resolve: resolve
            };
            me.isAnimating = true; // afterHideShowAnimate will always be called even if the transition aborts

            me.currentAnimation.detacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].onTransitionEnd({
              element: element,
              property: styleProp,
              duration: parseDuration(animProps.duration) + 20,
              handler: 'afterHideShowAnimate',
              thisObj: me
            }); // Setting transition style initial value before showing,
            // then reading the style to ensure transition will animate

            style[styleProp] = animProps.from;
            _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getStyleValue(element, styleProp);
            style.transition = "".concat(styleProp, " ").concat(animProps.duration, " ease ").concat(animProps.delay);
            style[styleProp] = animProps.to;
          }

          me.afterShow(!showAnimation && resolve); // Note: popups can be dismissed in the process of focusin/out if an editor has invalidAction='block',
          // so we may be hidden at this point...
          // If we're not being called from showBy, do default aligning unless its centered

          if (!me.inShowBy && me.floating && me.forElement && !me.centered && !me.hidden) {
            me.alignTo(me.forElement);
          }
        } else {
          resolve();
        }
      });
    }
    /**
     * Show aligned to another target element or {@link Core.widget.Widget} or {@link Core.helper.util.Rectangle}
     * @param {Object|HTMLElement} spec Alignment specification, or the element to align to using the configured
     * {@link #config-align}.
     * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} spec.target The Widget or Element or Rectangle to align to.
     * @param {Boolean} [spec.anchor] True to show a pointer arrow connecting to the target. Defaults to false.
     * @param {Boolean} [spec.overlap] True to allow this to overlap the target.
     * @param {String} spec.align The alignment specification string, `[trbl]n-[trbl]n`. Defaults to this instance's
     * {@link #config-align} setting.
     * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} [spec.constrainTo] The Widget or Element or Rectangle to constrain to.
     * If the requested alignment cannot be constrained (it will first shrink the resulting Rectangle according
     * to the `minWidth` and `minHeight` properties of this spec, or the Widget), then it will try aligning at other edges
     * (honouring the `axisLock` option), and pick the fallback alignment which results in the shortest translation.
     * @param {Number} [spec.minHeight] The minimum height this widget may be compressed to when constraining within the `constrainTo` option.
     * @param {Number} [spec.minWidth] The minimum width this widget may be compressed to when constraining within the `constrainTo` option.
     * @param {Boolean} [spec.axisLock] Specify as `true` to fall back to aligning against the opposite
     * edge if the requested alignment cannot be constrained into the `constrainTo` option. Specify as
     * `'flexible'` to allow continuation to try the other edges if a solution cannot be found on the originally requested axis.
     * @param {Boolean} [spec.matchSize] *Only honored when `axisLock` is enabled and alignment succeeds on the requested axis.
     * Specify as `true` to have this widget's size along the aligned edge match the size of the target's edge.
     * For example, a combobox's dropdown should match the width of the combobox.
     * @param {Number|Number[]} [spec.offset] The offset to create an extra margin round the target
     * to offset the aligned widget further from the target. May be configured as -ve to move the aligned widget
     * towards the target - for example producing the effect of the anchor pointer piercing the target.
     * @param {Boolean} [spec.monitorResize] Configure as `true` to monitor the element being aligned to for
     * resizing while visible to correct alignment.
     * @category Float & align
     * @async
     * @returns {Promise} A promise which is resolved when the widget is shown
     */

  }, {
    key: "showBy",
    value: function showBy(spec) {
      var me = this; // Prevent show from rerouting here.

      me.inShowBy = true;
      var result = me.show();
      me.inShowBy = false;

      if (me.isVisible) {
        me.alignTo(spec);
      }

      return result;
    }
    /**
     * Show this widget anchored to a coordinate
     * @param {Number|Number[]} x The x position (or an array with [x,y] values) to show by
     * @param {Number} [y] The y position to show by
     * @param {Object} [options] See {@link #function-showBy} for reference
     * @category Float & align
     * @async
     * @returns {Promise} A promise which is resolved when the widget is shown
     */

  }, {
    key: "showByPoint",
    value: function showByPoint(x, y, options) {
      var xy = arguments.length === 1 ? x : [x, y];
      return this.showBy(Object.assign({
        target: new _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"](xy[0], xy[1], 1, 1),
        // Override any matchSize that we might have in our align config.
        // Otherwise we are going to be 1px wide/high
        matchSize: false,
        align: 't-b'
      }, options));
    }
  }, {
    key: "afterShow",
    value: function afterShow(resolveFn) {
      var _this$parent;

      // This method is injected when maxHeight is set on IE11.
      // Flexbox does not handle overflow correctly when a vertically
      // flexed item is constrained by the maxHeight of its containing el.
      // So we have to propagate the maxHeight from the encapsulating element
      // onto the contentElement.
      if (this.boundMaxHeightBugHandler) {
        this.boundMaxHeightBugHandler();
      }

      this.trigger('show'); // Keep any owning container informed about visibility state

      (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.onChildShow();
      this.triggerPaint();
      resolveFn && resolveFn();
    }
  }, {
    key: "triggerPaint",
    value: function triggerPaint() {
      var me = this,
          element = me.element,
          firstPaint = !me.isPainted;

      if (me.isVisible) {
        if (firstPaint) {
          // Not for public use, only used in docs
          if (me.scaleToFitWidth && !me.monitorResize) {
            me.onParentElementResize = me.onParentElementResize.bind(me);
            _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].addResizeListener(element.parentElement, me.onParentElementResize);
            me.updateScale();
          }
        } // Trigger paint only on immediate children.
        // Each one will call this recursively.
        // paint is triggered in a bottom up manner.


        me.eachWidget(widgetTriggerPaint, false);
        /**
         * Triggered when a widget which had been in a non-visible state for any reason
         * achieves visibility.
         *
         * A non-visible state *might* mean the widget is hidden and has just been shown.
         *
         * But this event will also fire on widgets when a non-visible (unrendered, or hidden)
         * ancestor achieves visibility, for example a {@link Core.widget.Popup Popup} being shown.
         * @event paint
         * @param {Core.widget.Widget} source The widget being painted.
         * @param {Boolean} firstPaint `true` if this is the first paint.
         */

        me.trigger('paint', {
          firstPaint: firstPaint
        });

        if (firstPaint) {
          // On first paint, we should announce our size immediately.
          // When the real event comes along, onElementResize will reject it because the size will be the same.
          if (me.monitorResize && !me.scaleToFitWidth) {
            _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].onElementResize([{
              target: element
            }]);
          }
        }

        me.isPainted = true;
      }
    }
  }, {
    key: "cancelHideShowAnimation",
    value: function cancelHideShowAnimation() {
      var currentAnimation = this.currentAnimation,
          element = this.element,
          style = element.style;

      if (currentAnimation) {
        this.isAnimating = false;
        element.classList.remove('b-hiding');
        currentAnimation.detacher();
        style.transition = style[currentAnimation.styleProp] = '';
        this.currentAnimation = null;
      }
    }
  }, {
    key: "afterHideShowAnimate",
    value: function afterHideShowAnimate() {
      // If menu is destroyed too soon in Edge, this method will be invoked for destroyed element
      if (this.isDestroyed || !this.currentAnimation) {
        return;
      }

      var me = this,
          element = me.element,
          style = element.style,
          _me$currentAnimation = me.currentAnimation,
          styleProp = _me$currentAnimation.styleProp,
          resolve = _me$currentAnimation.resolve;
      element.classList.remove('b-hiding');
      me.isAnimating = false;
      me.currentAnimation = null;
      style.transition = style[styleProp] = ''; // Element must be fully hidden after the animation effect finishes

      if (me._hidden) {
        me.afterHideAnimation();
      }

      resolve();
    }
    /**
     * Hide widget
     * @param {Boolean} animate Pass `true` (default) to animate the hide action
     * @category Visibility
     * @returns {Promise} A promise which is resolved when the widget has been hidden
     */

  }, {
    key: "hide",
    value: function hide() {
      var _this2 = this;

      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return new Promise(function (resolve) {
        var me = _this2,
            element = me.element,
            style = element.style,
            hideAnimation = animate && me.hideAnimation; // If we get hidden very quickly after a call to show,
        // we must kill the timers which add the realign listeners.

        me.clearTimeout(me.scrollListenerTimeout);
        me.clearTimeout(me.resizeListenerTimeout); // replaced check for isVisible with _hidden, need to hide a component not yet in view in EventEditor

        if (!me._hidden && me.trigger('beforeHide') !== false) {
          me._hidden = true;

          if (!element) {
            resolve();
            return;
          }

          me.revertFocus(); // Safari and FireFox do not fire focusOut when an element hides, so in case the focus
          // reversion did not find a target, we will not get the call to onFocusOut
          // below to perform the forced focus reversion, so we must do it before hide.

          if ((_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isSafari || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isFirefox) && element.contains(document.activeElement)) {
            me.revertFocus(true);
          } // Focus exit causes close if autoClose: true, and if closeAction: 'hide'
          // that might destroy us, so exit now if that happens.


          if (me.isDestroyed) {
            resolve();
            return;
          } // Cancel any current hide/show animation


          me.cancelHideShowAnimation();

          if (hideAnimation) {
            var styleProp = Object.keys(hideAnimation)[0],
                animProps = hideAnimation[styleProp]; // Make sure we are not already at the final value of the hide animation (i.e. calling hide() directly after show())

            if (Number(getComputedStyle(me.element)[styleProp]) !== animProps.to) {
              me.currentAnimation = {
                styleProp: styleProp,
                resolve: resolve
              }; // Element must behave as though it were not there during
              // the animated hide. This means pointer-events:none

              element.classList.add('b-hiding');
              me.isAnimating = true; // afterHideShowAnimate will always be called even if the transition aborts

              me.currentAnimation.detacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].onTransitionEnd({
                element: element,
                property: styleProp,
                duration: parseDuration(animProps.duration) + 20,
                handler: 'afterHideShowAnimate',
                thisObj: me
              }); // Setting transition style initial value before showing,
              // then reading the style to ensure transition will animate

              style[styleProp] = animProps.from;
              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getStyleValue(element, styleProp);
              style.transition = "".concat(styleProp, " ").concat(animProps.duration, " ease ").concat(animProps.delay);
              style[styleProp] = animProps.to;
            } else {
              element.classList.add('b-hidden');
            }
          } else {
            element.classList.add('b-hidden');
          } // only supply resolve function if not using animation


          me.afterHide(!hideAnimation && resolve, hideAnimation);
        }
      });
    }
  }, {
    key: "doHideOrRealign",
    value: function doHideOrRealign(event) {
      var _event$target;

      var me = this,
          anchoredTo = me.anchoredTo,
          lastAlignSpec = me.lastAlignSpec,
          target = lastAlignSpec && lastAlignSpec.target,
          activeEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].activeElement,
          _me$getXY = me.getXY(),
          _me$getXY2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_26___default()(_me$getXY, 2),
          x = _me$getXY2[0],
          y = _me$getXY2[1]; // Scroll is inside this widget, no action


      if (me.element.contains(event.target)) {
        return;
      } // If it's a synthesized scroll event (such as from our ResizeMonitor polyfill), ignore it
      // If we're scrolling because a focused textual input field which we contain is being shifted into view,
      // we must not reposition - we'll just move with the document content.
      // event.target might be missing with LockerService enabled


      if (!event.isTrusted || ((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.nodeType) === 9 && me.element.contains(activeEl) && textInputTypes[activeEl] && window.innerHeight < document.body.offsetHeight) {
        return;
      } // Perform the realignment. If the scroll did not in fact cause us to become unaligned, then we don't have to hide.


      me.realign(event.target); // Might destroy on hide in realign, so check for isDestroyed.

      if (!me.isDestroyed && me.scrollAction === 'hide') {
        var _me$getXY3 = me.getXY(),
            _me$getXY4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_26___default()(_me$getXY3, 2),
            newX = _me$getXY4[0],
            newY = _me$getXY4[1],
            moved = newX !== x || newY !== y; // If the scroll caused our position to become invalid, and we either don't know what element
        // we're anchored to (or not anchored to one at all), or the element we're anchored to has been
        // affected by the scroll, we must hide.
        // target might be missing with LockerService enabled


        if ((moved || (target === null || target === void 0 ? void 0 : target.$$name) === 'Point') && (!anchoredTo || event.target && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].isDescendant(event.target, anchoredTo))) {
          me.hide();
        }
      }
    }
  }, {
    key: "afterHide",
    value: function afterHide() {
      var _me$parent;

      var resolveFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var hideAnimation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.hideAnimation;
      var me = this,
          lastAlignSpec = me.lastAlignSpec; // The flag must be cleared on a normal hide.
      // It's set after the hide() call in alignTo
      // if the target is outside our clippedTo region.

      if (lastAlignSpec) {
        lastAlignSpec.targetHidden = null;
      } // Remove listeners which are only added during the visible phase.
      // In its own method because it's called on hide and destroy.


      me.removeTransientListeners(); // Postprocessing to be done after the hideAnimation finishes.
      // If there's no animation, we call it immediately.
      // We set the element to be hidden here, after any animation completes.
      // We also remove floating Widgets from the DOM when they are hidden.

      if (!hideAnimation) {
        me.afterHideAnimation();
      }

      me.trigger('hide'); // Keep any owning container informed about visibility state

      (_me$parent = me.parent) === null || _me$parent === void 0 ? void 0 : _me$parent.onChildHide();
      resolveFn && resolveFn();
    }
  }, {
    key: "removeTransientListeners",
    value: function removeTransientListeners() {
      var me = this;

      if (me.documentScrollListener) {
        document.removeEventListener('scroll', me.doHideOrRealign, true);
        me.documentScrollListener = false;
      }

      if (me.targetResizeListener) {
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].removeResizeListener(me.lastAlignSpec.target, me.callRealign);
        me.targetResizeListener = false;
      }

      if (me.constrainListeners) {
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"].removeResizeListener(me.lastAlignSpec.constrainTo || window, me.callRealign);
        me.constrainMutationMonitor && me.constrainMutationMonitor.disconnect();
        me.constrainListeners = false;
      }
    }
  }, {
    key: "afterHideAnimation",
    value: function afterHideAnimation() {
      var me = this,
          element = me.element;

      if (me.floating && Widget.floatRoot.contains(element)) {
        element.remove();
      } else {
        element.classList.add('b-hidden');
      } // Reset anchor to its default colour after hide


      if (me.defaultAnchorBackgroundColor) {
        // Reset to default in case it has been positioned by a coloured header
        me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
      }
    }
  }, {
    key: "changeHidden",
    value: function changeHidden(value) {
      var ret;

      if (this.isConfiguring) {
        ret = Boolean(value);
        this.element.classList[value ? 'add' : 'remove']('b-hidden');
      } else {
        // These methods are async but set _hidden when they get past the before event, so don't set ret and
        // the setter won't set _hidden automatically.
        if (value) {
          this.hide();
        } else {
          this.show();
        }
      }

      return ret;
    }
    /**
     * Get id assigned by user (not generated id)
     * @returns {String}
     * @readonly
     * @private
     * @category Misc
     */

  }, {
    key: "getSibling",
    value: function getSibling(increment) {
      var me = this,
          parent = me.parent,
          siblings = parent ? parent.childItems : Array.from(me.element.parentElement.querySelectorAll('.b-widget'));
      return parent ? siblings[siblings.indexOf(me) + increment] : Widget.fromElement(siblings[siblings.indexOf(me.element) + increment]);
    }
    /**
     * Looks up the {@link #property-owner} axis to find an ancestor which matches the passed selector.
     * The selector may be a widget type identifier, such as `'grid'`, or a function which will return
     * `true` when passed the desired ancestore.
     * @param {String|Function} selector A Type identifier or selection function.
     * @param {Boolean} [deep] When using a string identifier, pass `true` if all superclasses should be included, ie if a `Grid` should match `'widget'`.
     * @param {Number|String|Core.widget.Widget} [limit] how many steps to step up before aborting the search, or a selector to stop at or the topmost ancestor to consider.
     */

  }, {
    key: "up",
    value: function up() {
      var owner = this.owner;

      if (owner) {
        return owner.closest.apply(owner, arguments);
      }
    }
    /**
     * Starts with this Widget, then Looks up the {@link #property-owner} axis to find an ancestor which matches the passed selector.
     * The selector may be a widget type identifier, such as `'grid'`, or a function which will return
     * `true` when passed the desired ancestore.
     * @param {String|Function} selector A Type identifier or selection function.
     * @param {Boolean} [deep] When using a string identifier, pass `true` if all superclasses should be included, ie if a `Grid` should match `'widget'`.
     * @param {Number|String|Core.widget.Widget} [limit] how many steps to step up before aborting the search, or a selector to stop at or the topmost ancestor to consider.
     */

  }, {
    key: "closest",
    value: function closest(selector, deep, limit) {
      var limitType = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27___default()(limit),
          numericLimit = limitType === 'number',
          selectorLimit = limitType === 'string';

      for (var result = this, steps = 1; result; result = result.owner, steps++) {
        if (Widget.widgetMatches(result, selector, deep)) {
          return result;
        }

        if (numericLimit && steps >= limit) {
          return;
        } else if (selectorLimit && Widget.widgetMatches(result, limit, deep)) {
          return;
        } else if (result === limit) {
          return;
        }
      }
    }
    /**
     * Returns `true` if this Widget owns the passed Element, Event or Widget. This is based on the widget hierarchy,
     * not DOM containment. So an element in a `Combo`'s dropdown list will be owned by the `Combo`.
     * @param {HTMLElement|Event|Core.widget.Widget} target The element event or Widget to test for being
     * within the ownership tree of this Widget.
     */

  }, {
    key: "owns",
    value: function owns(target) {
      if (target) {
        // Passed an event, grab its target
        if (target.eventPhase) {
          target = target.target;
        } // We were passed an HTMLElement


        if (target.nodeType === 1) {
          if (this.element.contains(target)) {
            return true;
          }

          target = Widget.fromElement(target);
        }

        while (target) {
          if (target === this) {
            return true;
          }

          target = target.owner;
        }
      }

      return false;
    }
    /**
     * Iterate over all ancestors of this widget.
     *
     * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
     * functions. If the expression executed evaluates to `false`, iteration will terminate.
     * @param {Function} fn Function to execute for all ancestors. Terminate iteration by returning `false`.
     * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
     */

  }, {
    key: "eachAncestor",
    value: function eachAncestor(fn) {
      var ancestor = this.owner;

      while (ancestor) {
        if (fn(ancestor) === false) {
          return false;
        }

        ancestor = ancestor.owner;
      }

      return true;
    }
  }, {
    key: "changeMonitorResize",
    value: function changeMonitorResize(monitorResize) {
      // They are mutually exclusive. scaleToFitWidth disables monitorResize
      return this.scaleToFitWidth ? false : monitorResize;
    }
  }, {
    key: "updateMonitorResize",
    value: function updateMonitorResize(monitorResize) {
      var me = this;

      if (!hasOwnProperty.call(me, 'onElementResize')) {
        me.onElementResize = me.onElementResize.bind(me);
      }

      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_41__["default"][monitorResize ? 'addResizeListener' : 'removeResizeListener'](me.element, me.onElementResize);
    }
  }, {
    key: "changeReadOnly",
    value: function changeReadOnly(readOnly) {
      readOnly = Boolean(readOnly); // It starts as undefined, so if false is passed, that's a no-change.

      if (Boolean(this._readOnly) !== readOnly) {
        return readOnly;
      }
    }
  }, {
    key: "updateReadOnly",
    value: function updateReadOnly(readOnly) {
      var _this$element;

      // Can be called from the element initialization because of the way Panel is set up.
      // tbar and bbar are instantiated, and their elements added to the gathered element
      // config object, but that can have consequences which can lead here.
      // eslint-disable-next-line no-unused-expressions
      (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.classList[readOnly ? 'add' : 'remove']('b-readonly'); // Do not update  children at configure time.
      // Container will sync its items.

      if (!this.isConfiguring) {
        // Implemented at this level because Widgets can own a descendant tree without being
        // a Container. For example Combos own a ChipView and a List. Buttons own a Menu etc.
        this.eachWidget(function (widget) {
          if (!('_originalReadOnly' in widget)) {
            // Store initial readOnly/disabled value.
            // the config getter copies the properties in a loop
            // so execute once and cache the value.
            widget._originalReadOnly = widget.config.readOnly || false;
          } // Set if truthy, otherwise reset to initial value


          widget.readOnly = readOnly || widget._originalReadOnly;
        }, false);
        /**
         * Fired when a Widget's read only state is toggled
         * @event readOnly
         * @param {Boolean} readOnly Read only or not
         */

        this.trigger('readOnly', {
          readOnly: readOnly
        });
      }
    }
    /**
     * Iterate over all widgets owned by this widget and any descendants.
     *
     * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
     * functions. If the expression executed evaluates to `false`, iteration will terminate.
     * @param {Function} fn A function to execute upon all descendant widgets.
     * Iteration terminates if this function returns `false`.
     * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
     * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
     */

  }, {
    key: "eachWidget",
    value: function eachWidget(fn) {
      var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var widgets = this.childItems,
          length = widgets ? widgets.length : 0;

      for (var i = 0; i < length; i++) {
        var widget = widgets[i]; // Abort if a call returns false

        if (fn(widget) === false) {
          return false;
        }

        if (deep && widget.eachWidget) {
          // Abort if a deep call returns false
          if (widget.eachWidget(fn, deep) === false) {
            return false;
          }
        }
      }

      return true;
    }
    /**
     * Returns an array of all descendant widgets which the passed
     * filter function returns `true` for.
     * @param {Function} filter A function which, when passed a widget,
     * returns `true` to include the widget in the results.
     * @returns {Core.widget.Widget[]} All matching descendant widgets.
     */

  }, {
    key: "queryAll",
    value: function queryAll(filter) {
      var result = [];
      this.eachWidget(function (w) {
        if (filter(w)) {
          result.push(w);
        }
      });
      return result;
    }
    /**
     * Returns the first descendant widgets which the passed
     * filter function returns `true` for.
     * @param {Function} filter A function which, when passed a widget,
     * returns `true` to return the widget as the sole result.
     * @returns {Core.widget.Widget} The first matching descendant widget.
     */

  }, {
    key: "query",
    value: function query(filter) {
      var result = null;
      this.eachWidget(function (w) {
        if (filter(w)) {
          result = w;
          return false;
        }
      });
      return result;
    }
    /**
     * Get a widget by ref, starts on self and traverses up the owner hierarchy checking `widgetMap` at each level.
     * Not checking the top level widgetMap right away to have some acceptance for duplicate refs.
     * @param {String} ref ref to find
     * @returns {Core.widget.Widget}
     * @internal
     */

  }, {
    key: "getWidgetByRef",
    value: function getWidgetByRef(ref) {
      var _this$widgetMap, _this$owner;

      if (ref instanceof Widget) {
        return ref;
      }

      return (this === null || this === void 0 ? void 0 : (_this$widgetMap = this.widgetMap) === null || _this$widgetMap === void 0 ? void 0 : _this$widgetMap[ref]) || (this === null || this === void 0 ? void 0 : (_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.getWidgetByRef(ref));
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      var me = this,
          element = me.element;
      me.containsFocus = true;
      me.focusInEvent = e;
      element.classList.add('b-contains-focus');

      if (element.contains(e._target) && me.onInternalKeyDown && !me.keyDownListenerRemover) {
        me.keyDownListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].on({
          element: element,
          keydown: 'onInternalKeyDown',
          thisObj: me
        });
      }
      /**
       * Fired when focus enters this Widget.
       * @event focusin
       * @param {Core.widget.Widget} source - This Widget
       * @param {HTMLElement} fromElement The element which lost focus.
       * @param {HTMLElement} toElement The element which gained focus.
       * @param {Core.widget.Widget} fromWidget The widget which lost focus.
       * @param {Core.widget.Widget} toWidget The widget which gained focus.
       * @param {Boolean} backwards `true` if the `toElement` is before the `fromElement` in document order.
       */


      me.trigger('focusin', e);
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      var me = this;

      if (me.keyDownListenerRemover) {
        me.keyDownListenerRemover();
        me.keyDownListenerRemover = null;
      }

      if (!me.isDestroyed) {
        // Focus to nowhere, focus a close relation
        if (!e.relatedTarget) {
          me.revertFocus(!me.isVisible);
        }

        me.containsFocus = false;
        me.element.classList.remove('b-contains-focus');
        /**
         * Fired when focus exits this Widget's ownership tree. This is different from a `blur` event.
         * focus moving from within this Widget's ownership tree, even if there are floating widgets
         * will not trigger this event. This is when focus exits this widget completely.
         * @event focusout
         * @param {Core.widget.Widget} source - This Widget
         * @param {HTMLElement} fromElement The element which lost focus.
         * @param {HTMLElement} toElement The element which gained focus.
         * @param {Core.widget.Widget} fromWidget The widget which lost focus.
         * @param {Core.widget.Widget} toWidget The widget which gained focus.
         * @param {Boolean} backwards `true` if the `toElement` is before the `fromElement` in document order.
         */

        me.trigger('focusout', e);
      }
    }
    /**
     * If this Widget contains focus, focus is reverted to the source from which it entered if possible,
     * or to a close relative if not.
     * @param {Boolean} force Pass as `true` to move focus to the previously focused item, or the
     * closest possible relatve even if this widget does not contain focus.
     */

  }, {
    key: "revertFocus",
    value: function revertFocus(force) {
      var target = this.focusInEvent && this.focusInEvent.relatedTarget;

      if (force || this.containsFocus && target && target.nodeType === 1 && this.element.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].activeElement)) {
        if (!target || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].isFocusable(target)) {
          target = this.getFocusRevertTarget();
        }

        if (target && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].isFocusable(target)) {
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].focusWithoutScrolling(target);
        }
      }
    }
    /**
     * This method finds a close sibling (or parent, or parent's sibling etc recursively) to which focus
     * can be directed in the case of revertFocus not having a focusable element from our focusInEvent.
     *
     * This can hapen when the "from" component is destroyed or hidden. We should endeavour to prevent
     * focus escaping to `document.body` for accessibility and ease of use, and keep focus close.
     * @internal
     */

  }, {
    key: "getFocusRevertTarget",
    value: function getFocusRevertTarget() {
      var me = this,
          owner = me.owner,
          focusInEvent = me.focusInEvent,
          searchDirection = focusInEvent ? focusInEvent.backwards ? 1 : -1 : -1;
      var target = focusInEvent && focusInEvent.relatedTarget;
      var toComponent = target && Widget.fromElement(target); // If the from element is now not focusable, for example an Editor which hid
      // itself on focus leave, then we have to find a sibling/parent/parent's sibling
      // to take focus. Anything is better than flipping to document.body.

      if (owner && !owner.isDestroyed && (!target || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].isFocusable(target) || toComponent && !toComponent.isFocusable)) {
        target = null; // If this widget can have siblings, then find the closest
        // (in the direction focus arrived from) focusable sibling.

        if (owner.eachWidget) {
          var siblings = []; // Collect focusable siblings.
          // With this included so we can find ourselves.

          owner.eachWidget(function (w) {
            if (w === me || w.isFocusable) {
              siblings.push(w);
            }
          }, false);

          if (siblings.length > 1) {
            var myIndex = siblings.indexOf(me);
            target = siblings[myIndex + searchDirection] || siblings[myIndex - searchDirection];
          }
        } // No focusable siblings found to take focus, try the owner


        if (!target && owner.isFocusable) {
          target = owner;
        } // If non of the above found any related focusable widget,
        // Go through these steps for the owner.


        target = target ? target.focusElement : owner.getFocusRevertTarget();
      }

      return target;
    }
    /**
     * Used by the Widget class internally to create CSS classes based on this Widget's
     * inheritance chain to allow styling from each level to apply.
     *
     * For example Combo would yield `"["b-widget", "b-field", "b-textfield", "b-pickerfield", "b-combo"]"`
     *
     * May be implemented in subclasses to add or remove classes from the super.widgetClassList
     * @returns {String[]} The css class list named using the class name.
     * @internal
     * @category DOM
     */

  }, {
    key: "changeCls",
    value: function changeCls(cls) {
      return new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_37__["default"](cls);
    }
  }, {
    key: "changeContentCls",
    value: function changeContentCls(cls) {
      return new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_37__["default"](cls);
    } //endregion
    //region Cache

    /**
     * Gets dom elements in the view. Caches the results for faster future calls.
     * @param {String} query CSS selector
     * @param {Boolean} children true to fetch multiple elements
     * @param {HTMLElement} element Element to use as root for the query, defaults to the views outermost element
     * @returns {HTMLElement|HTMLElement[]|null} A single element or an array of elements (if parameter children is set to true)
     * @internal
     * @category DOM
     */

  }, {
    key: "fromCache",
    value: function fromCache(query) {
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.element;
      if (!element) return null;
      var me = this;

      if (!me.cache[query]) {
        me.cache[query] = children ? _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].children(element, query) : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].down(element, query);
      }

      return me.cache[query];
    }
    /**
     * Clear caches, forces all calls to fromCache to requery dom. Called on render/rerender.
     * @internal
     * @category DOM
     */

  }, {
    key: "emptyCache",
    value: function emptyCache() {
      this.cache = {};
    } //endregion
    //region Mask

  }, {
    key: "changeMasked",
    value: function changeMasked(mask, maskInstance) {
      if (mask === true || mask === '') {
        // empty string don't render well, so promote it to an &nbsp; as well
        mask = '\xA0'; // nbsp
      }

      if (maskInstance) {
        if (typeof mask === 'string') {
          maskInstance.text = mask;
          mask = maskInstance;
        } else if (mask) {
          maskInstance.setConfig(mask);
          mask = maskInstance;
        } else {
          maskInstance.destroy();
        }
      } else if (mask) {
        var _Mask = Widget.resolveType('mask');

        mask = _Mask.mergeConfigs(this.maskDefaults, mask);
        mask.owner = this;
        mask = _Mask.mask(mask);
      }

      return mask || null;
    }
  }, {
    key: "onMaskAutoClose",
    value: function onMaskAutoClose(mask) {
      if (mask.isDestroyed && mask === this.masked) {
        this.masked = null;
      }
    }
    /**
     * Mask the widget, showing the specified message
     * @param {String|Object} msg Mask message (or a {@link Core.widget.Mask} config object
     * @returns {Core.widget.Mask}
     */

  }, {
    key: "mask",
    value: function mask(msg) {
      this.masked = msg;
      return this.masked;
    }
    /**
     * Unmask the widget
     */

  }, {
    key: "unmask",
    value: function unmask() {
      this.masked = null;
    } //endregion
    //region Monitor resize

  }, {
    key: "onInternalResize",
    value: function onInternalResize(element, width, height, oldWidth, oldHeight) {
      this._width = element.offsetWidth;
      this._height = element.offsetHeight;
    }
  }, {
    key: "onElementResize",
    value: function onElementResize(resizedElement) {
      var me = this,
          element = me.element,
          scrollable = me.scrollable,
          oldWidth = me._width,
          oldHeight = me._height,
          newWidth = element.offsetWidth,
          newHeight = element.offsetHeight;

      if (me.floating) {
        me.onFloatingWidgetResize.apply(me, arguments);
      }

      if (scrollable) {
        var _scrollable$syncOverf;

        (_scrollable$syncOverf = scrollable.syncOverflowState) === null || _scrollable$syncOverf === void 0 ? void 0 : _scrollable$syncOverf.call(scrollable);
      }

      if (!me.suspendResizeMonitor && (oldWidth !== newWidth || oldHeight !== newHeight)) {
        me.onInternalResize(element, newWidth, newHeight, oldWidth, oldHeight);
        /**
         * Fired when the encapsulating element of a Widget resizes *only when {@link #config-monitorResize} is `true`*.
         * @event resize
         * @param {Core.widget.Widget} source - This Widget
         * @param {Number} width The new width
         * @param {Number} height The new height
         * @param {Number} oldWidth The old width
         * @param {Number} oldHeight The old height
         */

        me.trigger('resize', {
          width: newWidth,
          height: newHeight,
          oldWidth: oldWidth,
          oldHeight: oldHeight
        });
      }
    }
  }, {
    key: "onFloatingWidgetResize",
    value: function onFloatingWidgetResize(resizedElement, lastRect, myRect) {
      var me = this,
          lastAlignSpec = me.lastAlignSpec,
          constrainTo = me.constrainTo; // If this Popup changes size while we are aligned and we are aligned to
      // a target (not a position), then we might need to realign.

      if (me.isVisible && lastAlignSpec && lastAlignSpec.target) {
        var heightChange = !lastRect || myRect.height !== lastRect.height,
            widthChange = !lastRect || myRect.width !== lastRect.width,
            failsConstraint = constrainTo && !_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(constrainTo).contains(_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(me.element, null, true)); // Only realign if:
        // the height has changed and we are not aligned below, or
        // the width has changed and we are not aligned to the right.

        if (heightChange && lastAlignSpec.zone !== 2 || widthChange && lastAlignSpec.zone !== 1 || failsConstraint) {
          // Must move to next AF because in Chrome, the resize monitor might fire
          // before the element is painted and the anchor color matching
          // scheme cannot work in that case.
          me.requestAnimationFrame(function () {
            return me.realign();
          });
        }
      }
    }
  }, {
    key: "updateScale",
    value: function updateScale() {
      var me = this,
          element = me.element,
          parentElement = element.parentElement; // this could be placed elsewhere but want to keep it contained to not spam other code,
      // since this is a very specific use case in our docs

      if (!me.configuredWidth) {
        me.configuredWidth = me.width;
      } // TODO: handle autoHeight, but seems it assigns height to late with current setup
      // We are scaling to fit inside the width, so ensure that we are not the cause of a scrollbar
      // in our current, unscaled state by hiding while we measure the parent's offsetWidth which
      // we are going to scale to.


      element.style.display = 'none';
      var rect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].client(parentElement),
          scale = rect.width / me.configuredWidth,
          adjustedScale = me.scale = me.allowGrowWidth ? Math.min(scale, 1) : scale;
      element.style.transform = "scale(".concat(adjustedScale, ")");
      element.style.transformOrigin = 'top left';
      element.style.display = '';

      if (me.allowGrowWidth && scale > 1) {
        // increase width
        me.width = me.configuredWidth * scale;
      }
    }
  }, {
    key: "onParentElementResize",
    value: function onParentElementResize(event) {
      this.updateScale();
    } //endregion

    /**
     * Returns a `TRBL` array of values parse from the passed specification. This can be used to parse`
     * a value list for `margin` or `padding` or `border-width` etc - any CSS value which takes a `TRBL` value.
     * @param {Number|String|String[]} values The `TRBL` value
     * @param {String} [units=px] The units to add to values which are specified as numeric.
     * @internal
     */

  }, {
    key: "parseTRBL",
    value: function parseTRBL(values) {
      var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
      values = values || 0;

      if (typeof values === 'number') {
        return ["".concat(values).concat(units), "".concat(values).concat(units), "".concat(values).concat(units), "".concat(values).concat(units)];
      }

      var parts = values.split(' '),
          len = parts.length;

      if (len === 1) {
        parts[1] = parts[2] = parts[3] = parts[0];
      } else if (len === 2) {
        parts[2] = parts[0];
        parts[3] = parts[1];
      } else if (len === 3) {
        parts[3] = parts[1];
      }

      return [isFinite(parts[0]) ? "".concat(parts[0]).concat(units) : parts[0], isFinite(parts[1]) ? "".concat(parts[1]).concat(units) : parts[2], isFinite(parts[2]) ? "".concat(parts[2]).concat(units) : parts[3], isFinite(parts[3]) ? "".concat(parts[3]).concat(units) : parts[4]];
    }
  }, {
    key: "triggerFieldChange",
    // NOTE: Not named `triggerChange` to not conflict with existing fn on Field

    /**
     * Triggers a 'change' event with the supplied params. After triggering it also calls `onFieldChange()` on each
     * ancestor the implements that function, supplying the same set of params.
     * @param {Object} params Event params, used both for triggering and notifying ancestors
     * @param {Boolean} [trigger] `false` to not trigger, only notifying ancestors
     * @internal
     */
    value: function triggerFieldChange(params) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (trigger) {
        this.trigger('change', params);
      }

      this.eachAncestor(function (ancestor) {
        if (ancestor.onFieldChange) {
          ancestor.onFieldChange(params);
        }
      });
    }
  }, {
    key: "parent",
    set: function set(parent) {
      this._parent = parent;
      this._element && this._element.classList[parent ? 'remove' : 'add']('b-outer');
    },
    get: function get() {
      return this._parent;
    }
  }, {
    key: "constrainTo",
    get: function get() {
      var ret = this._constrainTo;
      return ret === undefined ? window : ret;
    }
  }, {
    key: "contentElement",
    get: function get() {
      return this.element;
    }
  }, {
    key: "contentRange",
    get: function get() {
      var me = this,
          contentElement = me.contentElement,
          contentRange = me._contentRange || (me._contentRange = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11 ? document.createRange() : new Range()); // Initialize the contentRange if it's collapsed.
      // It gets collapsed if the widget's element is removed from the DOM.

      if (contentRange.collapsed) {
        contentRange.setStart(contentElement, me.contentRangeStartOffset || 0);
        contentRange.setEnd(contentElement, me.contentRangeEndOffset || contentElement.childNodes.length);
      }

      return contentRange;
    }
  }, {
    key: "style",
    get: function get() {
      return this.element ? this.element.ownerDocument.defaultView.getComputedStyle(this.element) : this._style;
    }
  }, {
    key: "dataset",
    get: function get() {
      return this.element.dataset;
    }
  }, {
    key: "dragGhost",
    get: function get() {
      return this.constructor._dragGhost || (this.constructor._dragGhost = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].createElement({
        // Safari won't allow dragging an empty node
        html: '\xa0',
        style: 'position:absolute;top:-10000em;left:-10000em'
      }));
    }
  }, {
    key: "clippedBy",
    set: function set(clippedBy) {
      this._clippedBy = Array.isArray(clippedBy) ? clippedBy : clippedBy ? [clippedBy] : null;
    },
    get: function get() {
      var clippedBy = this._clippedBy;

      if ((clippedBy === null || clippedBy === void 0 ? void 0 : clippedBy.length) > 0) {
        var result = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(clippedBy === null || clippedBy === void 0 ? void 0 : clippedBy[0], null, true),
            i;

        for (i = 1; i < clippedBy.length; i++) {
          result = result.intersect(_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(clippedBy === null || clippedBy === void 0 ? void 0 : clippedBy[i], null, true));
        }

        return result;
      }
    }
    /**
     * The child element which scrolls if any. This means the element used by the {@link #config-scrollable}.
     * @property {HTMLElement}
     * @readonly
     * @category DOM
     */

  }, {
    key: "overflowElement",
    get: function get() {
      return this.contentElement;
    }
  }, {
    key: "maxHeightElement",
    get: function get() {
      return this.element;
    }
  }, {
    key: "html",
    get: function get() {
      // Maintainer, we cannot use a ternary here, we need the this.initializingElement test to shortcut
      // to the true case to return the _html property to avoid infinite loops.
      if (this.initializingElement || !this.element) {
        return this.content || this._html;
      }

      return this.contentElement.innerHTML;
    }
  }, {
    key: "anchorSize",
    get: function get() {
      var me = this;
      var result = this._anchorSize;

      if (!result) {
        // TODO: Move the anchoring scheme to the Panel class when we have it.
        // These values will be in the SASS and styled into the SVG through the Panel's theme.
        var borderWidth = parseFloat(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getStyleValue(me.element, 'border-top-width')),
            borderColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getStyleValue(me.element, 'border-top-color'),
            anchorElement = me.anchorElement,
            svgEl = anchorElement.firstElementChild,
            pathElement = me.anchorPathElement = svgEl.lastElementChild,
            hidden = me._hidden;
        var backgroundColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getStyleValue(me.contentElement, 'background-color'); // If the background colour comes through from the outer element, use that.

        if (backgroundColour.match(isTransparent)) {
          backgroundColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].getStyleValue(me.element, 'background-color');
        }

        me.defaultAnchorBackgroundColor = backgroundColour;
        result = anchorElement.getBoundingClientRect();

        var _result2 = result = me._anchorSize = [result.width, result.height],
            _result3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_26___default()(_result2, 2),
            width = _result3[0],
            height = _result3[1];

        svgEl.setAttribute('height', height + borderWidth);
        svgEl.setAttribute('width', width);
        pathElement.setAttribute('d', "M0,".concat(height, "L").concat(width / 2, ",0.5L").concat(width, ",").concat(height));

        if (borderWidth) {
          pathElement.setAttribute('stroke-width', borderWidth);
          pathElement.setAttribute('stroke', borderColour);
        }

        result[1] -= borderWidth;

        if (hidden) {
          me.element.classList.add('b-hidden');
        }

        if (!me.themeChangeListener) {
          me.themeChangeListener = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_52__["default"].on({
            theme: 'onThemeChange',
            thisObj: me
          });
        } // Reset to default in case it has been positioned by a coloured header


        me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
      }

      return result;
    }
  }, {
    key: "anchorElement",
    get: function get() {
      var result = this._anchorElement;

      if (!result) {
        // Using the filter hides the SVG element when positioned inside a Widget.
        var useFilter = this.floating && !(_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11 || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isEdge);
        result = this._anchorElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].createElement({
          parent: this.element,
          className: 'b-anchor b-anchor-top',
          children: [{
            tag: 'svg',
            ns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            class: 'b-pointer-el',
            children: [useFilter ? {
              tag: 'defs',
              children: [{
                tag: 'filter',
                id: 'shadow-filter',
                children: [{
                  tag: 'feDropShadow',
                  dx: 0,
                  dy: -1,
                  stdDeviation: 2,
                  'flood-opacity': 0.05
                }]
              }]
            } : null, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default()({
              tag: 'path'
            }, useFilter !== null && useFilter !== void 0 ? useFilter : 'filter', 'url(#shadow-filter)')]
          }]
        });
      }

      return result;
    }
  }, {
    key: "x",
    get: function get() {
      return this.getXY()[0];
    }
  }, {
    key: "y",
    get: function get() {
      return this.getXY()[1];
    }
  }, {
    key: "width",
    get: function get() {
      var me = this,
          element = me.element;

      if (me.monitorResize) {
        // If the width is invalid, read it now.
        if (me._width == null) {
          me._width = element.offsetWidth;
        } // Usually this will be set in onInternalResize


        return me._width;
      } // No monitoring, we have to measure;


      return element.offsetWidth;
    }
  }, {
    key: "maxWidth",
    get: function get() {
      return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].measureSize(this.element.style.maxWidth, this.element);
    }
  }, {
    key: "minWidth",
    get: function get() {
      return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].measureSize(this.element.style.minWidth, this.element);
    }
  }, {
    key: "height",
    get: function get() {
      var me = this,
          element = me.element;

      if (me.monitorResize) {
        // If the height is invalid, read it now.
        if (me._height == null) {
          me._height = element.offsetHeight;
        } // Usually this will be set in onInternalResize


        return me._height;
      } // No monitoring, we have to measure;


      return element.offsetHeight;
    }
  }, {
    key: "maxHeight",
    get: function get() {
      return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].measureSize(this.maxHeightElement.style.maxHeight, this.element);
    }
  }, {
    key: "minHeight",
    get: function get() {
      return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].measureSize(this.element.style.minHeight, this.element);
    }
  }, {
    key: "tooltip",
    get: function get() {
      if (this._tooltip) {
        return this._tooltip;
      } else {
        var tooltip = Widget.tooltip; // If the shared tooltip is currently in use by us, return it.
        // If it's not in use by us, we don't have a tooltip.

        if (tooltip && tooltip.activeTarget === this._element && tooltip.isVisible) {
          return tooltip;
        }
      }
    }
  }, {
    key: "isVisible",
    get: function get() {
      var me = this,
          element = me.element; // If we are hidden, or destroying, or any ancestors are hidden, we're not visible

      return Boolean(element && !me._hidden && !me.isDestroying && Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["isInDocument"])(element) && (!me.requireSize || Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["hasLayout"])(element)) && (!me.owner || me.owner.isVisible));
    }
  }, {
    key: "focusElement",
    get: function get() {// Override in widgets which are focusable.
    }
  }, {
    key: "isFocusable",
    get: function get() {
      var focusElement = this.focusElement; // We are only focusable if the focusEl is deeply visible, that means
      // it must have layout - an offsetParent. Body does not have offsetParent.

      return focusElement && this.isVisible && !this.disabled && (focusElement === document.body || focusElement.offsetParent);
    }
  }, {
    key: "assignedId",
    get: function get() {
      return this.hasGeneratedId ? null : this.id;
    }
    /**
     * Get the owning Widget of this Widget. If this Widget is directly contained, then the containing
     * Widget is returned. If this Widget is floating, the configured `owner` property is returned.
     * If there is a `forElement`, that element's encapsulating Widget is returned.
     * @property {Core.widget.Widget}
     * @category Misc
     */

  }, {
    key: "owner",
    get: function get() {
      var _this$forElement, _this$element2;

      var owningEl = ((_this$forElement = this.forElement) === null || _this$forElement === void 0 ? void 0 : _this$forElement.nodeType) === 1 ? this.forElement : (_this$element2 = this.element) === null || _this$element2 === void 0 ? void 0 : _this$element2.parentNode;
      return this.parent || this._owner || (owningEl === null || owningEl === void 0 ? void 0 : owningEl.closest('.b-widget')) && Widget.fromElement(owningEl);
    }
    /**
     * Get this Widget's previous sibling in the parent {@link Core.widget.Container Container}, or, if not
     * in a Container, the previous sibling widget in the same _parentElement_.
     * @property {Core.widget.Widget}
     * @readonly
     * @category Misc
     */

  }, {
    key: "previousSibling",
    get: function get() {
      return this.getSibling(-1);
    }
    /**
     * Get this Widget's next sibling in the parent {@link Core.widget.Container Container}, or, if not
     * in a Container, the next sibling widget in the same _parentElement_.
     * @property {Core.widget.Widget}
     * @readonly
     * @category Misc
     */

  }, {
    key: "nextSibling",
    get: function get() {
      return this.getSibling(1);
    }
  }, {
    key: "readOnly",
    get: function get() {
      return this._readOnly || false;
    }
  }, {
    key: "widgetClassList",
    get: function get() {
      var me = this;
      var myCls = me.cls,
          result = me.classHierarchy(Widget).reduce(function (target, cls) {
        var widgetClassProperty = Reflect.getOwnPropertyDescriptor(cls.prototype, 'widgetClass');
        var widgetClass; // If the Class has its own get widgetClass, call it upon this instance.

        if (widgetClassProperty && widgetClassProperty.get) {
          widgetClass = widgetClassProperty.get.call(me);
        } else {
          // All built in widgets should define $name to be safer from minification/obfuscation, but user
          // created might not so fall back to actual name. UMD files use a _$name property
          // which the Base $$name getter uses as a fallback.
          var name = hasOwnProperty.call(cls, '$$name') || hasOwnProperty.call(cls, '$name') || hasOwnProperty.call(cls, '_$name') ? cls.$$name : cls.name; // Throw error in case of an obfuscated name or an autogenerated name.
          // These should never be released without a meaningful $name getter.

          if (name.length < 3 || name.includes('$')) {
            // class.$name comes from parent API class which has it
            console.warn("Class \"".concat(name, "\" which extends \"").concat(cls.$name, "\" should have \"$name\" static getter with no less than 3 chars."));
          }

          widgetClass = "b-".concat(name.toLowerCase());
        }

        if (widgetClass) {
          // The result is used as a DOM classList. Must not contain spaces.
          target.push.apply(target, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_24___default()(widgetClass.split(' ')));
        }

        return target;
      }, (myCls === null || myCls === void 0 ? void 0 : myCls.values) || []);

      if (me.floating) {
        result.push('b-floating');
      }

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isTouchDevice) {
        result.push('b-touch');
      }

      return result;
    }
  }, {
    key: "isAnimating",
    get: function get() {
      return this._animating;
    },
    set: function set(value) {
      var me = this;

      if (value !== me.isAnimating) {
        me.element.classList[value ? 'add' : 'remove']('b-animating');
        me._animating = value;
      }
    }
    /**
     * Analogous to document.querySelector, finds the first Bryntum widget matching the passed
     * selector. Right now, only class name (lowercased) selector strings, or
     * a filter function which returns `true` for required object are allowed:
     * ```
     * bryntum.query('grid').destroy();
     * ```
     * @param {String|Function} selector A lowercased class name, or a filter function.
     * @param {Boolean} [deep] Specify `true` to search the prototype chain (requires supplying a string `selector`). For
     *   example 'widget' would then find a Grid
     * @return {Core.widget.Widget} The first matched widget if any.
     */

  }], [{
    key: "query",
    value: function query(selector) {
      var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var idMap = Widget.identifiable.idMap;

      for (var id in idMap) {
        if (Widget.widgetMatches(idMap[id], selector, deep)) {
          return idMap[id];
        }
      }

      return null;
    }
    /**
     * Analogous to document.querySelectorAll, finds all Bryntum widgets matching the passed
     * selector. Right now, only registered widget `type` strings, or a filter function which
     * returns `true` for required object are allowed:
     * ```
     * let allFields = bryntum.queryAll('field', true);
     * ```
     * @param {String|Function} selector A lowercased class name, or a filter function.
     * @param {Boolean} [deep] Specify `true` to search the prototype chain (requires supplying a string `selector`). For
     *   example 'widget' would then find a Grid
     * @return {Core.widget.Widget[]} The first matched widgets if any - an empty array will be returned
     * if no matches are found.
     */

  }, {
    key: "queryAll",
    value: function queryAll(selector) {
      var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var idMap = Widget.identifiable.idMap,
          result = [];

      for (var id in idMap) {
        if (Widget.widgetMatches(idMap[id], selector, deep)) {
          result.push(idMap[id]);
        }
      }

      return result;
    }
    /**
     * Returns the Widget which owns the passed element (or event).
     * @param {HTMLElement|Event} element The element or event to start from
     * @param {String|Function} [type] The type of Widget to scan upwards for. The lowercase
     * class name. Or a filter function which returns `true` for the required Widget.
     * @param {HTMLElement|Number} [limit] The number of components to traverse upwards to find a
     * match of the type parameter, or the element to stop at.
     * @return {Widget} The found Widget or null.
     */

  }, {
    key: "fromElement",
    value: function fromElement(element, type, limit) {
      var typeOfType = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27___default()(type); // Event passed


      if (element && element instanceof Event) {
        element = element.target;
      }

      if (typeOfType === 'number' || type && type.nodeType === 1) {
        limit = type;
        type = null;
      }

      var target = element,
          depth = 0,
          topmost,
          cmpId,
          cmp;

      if (typeof limit !== 'number') {
        topmost = limit;
        limit = Number.MAX_VALUE;
      }

      if (typeOfType === 'string') {
        type = type.toLowerCase();
      }

      while (target && target.nodeType === 1 && depth < limit && target !== topmost) {
        cmpId = target.dataset && target.dataset.ownerCmp || target.id;

        if (cmpId) {
          cmp = Widget.getById(cmpId);

          if (cmp) {
            if (type) {
              if (typeOfType === 'function') {
                if (type(cmp)) {
                  return cmp;
                }
              } else if (Widget.widgetMatches(cmp, type, true)) {
                return cmp;
              }
            } else {
              return cmp;
            }
          } // Increment depth on every *Widget* found


          depth++;
        }

        target = target.parentNode;
      }

      return null;
    }
  }, {
    key: "widgetMatches",
    value: function widgetMatches(candidate, selector, deep) {
      if (selector === '*') {
        return true;
      }

      if (typeof selector === 'function') {
        return selector(candidate);
      }

      return Widget.isType(candidate, selector, deep);
    }
    /**
     * Attached a tooltip to the specified element.
     * @example
     * Widget.attachTooltip(element, {
     *   text: 'Useful information goes here'
     * });
     * @param element Element to attach tooltip for
     * @param configOrText Tooltip config or tooltip string, see example and source
     * @returns {Object}
     * @category Popups
     */

  }, {
    key: "attachTooltip",
    value: function attachTooltip(element, configOrText) {
      if (typeof configOrText === 'string') configOrText = {
        html: configOrText
      }; // TODO: refactor this
      // eslint-disable-next-line no-new

      Widget.create(Object.assign({
        forElement: element
      }, configOrText), 'tooltip');
      return element;
    }
  }, {
    key: "$name",
    //region Config

    /**
     * Class name getter.
     * Used when original ES6 class name is minified or mangled during production build.
     * Should be overriden in each class which extends Widget or it descendants.
     *
     * ```javascript
     * class MyNewClass extends Widget {
     *     static get $name() {
     *        return 'MyNewClass';
     *     }
     * }
     * ```
     *
     * @static
     * @member {String} $name
     */
    get: function get() {
      return 'Widget';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'widget';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Get this widget's encapsulating HTMLElement, which is created along with the widget but added to DOM at
         * render time.
         * @member {HTMLElement} element
         * @readonly
         * @category DOM
         */

        /**
         * A {@link Core.helper.DomHelper#function-createElement-static} config object or HTML string from which to
         * create the Widget's element.
         * @private
         * @config {Object|String}
         * @category DOM
         */
        element: true,
        callOnFunctions: true,

        /**
         * Get/set widgets id
         * @member {String} id
         * @category DOM
         */

        /**
         * Widget id, if not specified one will be generated. Also used for lookups through Widget.getById
         * @config {String}
         * @category DOM
         */
        id: '',

        /**
         * Html to display initially
         * @config {String}
         * @category DOM
         */
        html: null,

        /**
         * Set HTML content safely, without disturbing sibling elements which may have been
         * added to the {@link #property-contentElement} by plugins and features.
         * When specifying html, this widget's element will also have the {@link #config-htmlCls}
         * added to its classList, to allow targeted styling.
         * @member {String} content
         * @category DOM
         */

        /**
         * The HTML content that coexists with sibling elements which may have been added to the
         * {@link #property-contentElement} by plugins and features.
         * When specifying html, this widget's element will also have the {@link #config-htmlCls}
         * class added to its classList, to allow targeted styling.
         * @config {String} content
         * @category DOM
         */
        content: null,

        /**
         * true if no id was set, will use generated id instead (widget1, ...). Toggle automatically on creation
         * @default false
         * @type {Boolean}
         * @private
         * @category Misc
         */
        hasGeneratedId: null,

        /**
         * Custom CSS classes to add to element.
         * May be specified as a space separated string, or as an object in which property names
         * with truthy values are used as the class names:
         * ```javascript
         *  cls : {
         *      'b-my-class'     : 1,
         *      [this.extraCls]  : 1,
         *      [this.activeCls] : this.isActive
         *  }
         *  ```
         *
         * @config {String|Object}
         * @category CSS
         */
        cls: null,

        /**
         * Custom CSS classes to add to the {@link #property-contentElement}.
         * May be specified as a space separated string, or as an object in which property names
         * with truthy values are used as the class names:
         * ```javascript
         *  cls : {
         *      'b-my-class'     : 1,
         *      [this.extraCls]  : 1,
         *      [this.activeCls] : this.isActive
         *  }
         *  ```
         *
         * @config {String|Object}
         * @category CSS
         */
        contentElementCls: null,

        /**
         * The CSS class to add when HTML content is being applied to this widget.
         * @config {String}
         * @category CSS
         */
        htmlCls: 'b-html',

        /**
         * Custom style spec to add to element
         * @config {String}
         * @category CSS
         */
        style: null,

        /**
         * Get/set element's disabled state
         * @member {Boolean} disabled
         * @category Misc
         */

        /**
         * Disabled or enabled
         * @default false
         * @config {Boolean}
         * @category Misc
         */
        disabled: null,

        /**
         * Get/set element's readOnly state. This is only valid if the widget is an input
         * field, __or contains input fields at any depth__.
         *
         * All descendant input fields follow the widget's setting. If a descendant
         * widget has a readOnly config, that is set.
         * @member {Boolean} readOnly
         * @category Misc
         */

        /**
         * Whether this widget is read-only.  This is only valid if the widget is an input
         * field, __or contains input fields at any depth__.
         *
         * All descendant input fields follow the widget's setting. If a descendant
         * widget has a readOnly config, that is set.
         * @default false
         * @config {Boolean}
         * @category Misc
         */
        readOnly: null,

        /**
         * Element (or element id) to adopt as this Widget's encapsulating element. The widget's
         * content will be placed inside this element.
         *
         * If this widget has not been configured with an id, it will adopt the id of the element
         * in order to preserve CSS rules which may apply to the id.
         * @config {HTMLElement|String}
         * @default
         * @category DOM
         */
        adopt: null,

        /**
         * Element (or element id) to append this widgets element to
         * @config {HTMLElement|String}
         * @default
         * @category DOM
         */
        appendTo: null,

        /**
         * Element (or element id) to insert this widget before. If provided, {@link #config-appendTo} config is ignored.
         * @config {HTMLElement|String}
         * @category DOM
         */
        insertBefore: null,

        /**
         * Element (or element id) to append this widget element to, as a first child. If provided, {@link #config-appendTo} config is ignored.
         * @config {HTMLElement|String}
         * @category DOM
         */
        insertFirst: null,

        /**
         * Object to apply to elements dataset (each key will be used as a data-attribute on the element)
         * @config {Object}
         * @category DOM
         */
        dataset: null,

        /**
         * Tooltip for the widget, either as a string or as a Tooltip config object
         * @config {String|Object}
         * @category Misc
         */
        tooltip: null,

        /**
         * Prevent tooltip from being displayed on touch devices. Useful for example for buttons that display a
         * menu on click etc, since the tooltip would be displayed at the same time.
         * @config {Boolean}
         * @default false
         * @category Misc
         */
        preventTooltipOnTouch: null,

        /**
         * Specify true to have widget monitoring its own resize.
         * @config {Boolean}
         * @default false
         * @category Misc
         */
        monitorResize: {
          $config: ['lazy'],
          value: null
        },

        /**
         * Set to `true` to apply the default mask to the widget. Alternatively, this can be the mask message or a
         * {@link Core.widget.Mask} config object.
         * @config {Boolean|String|Object|Core.widget.Mask}
         * @category Misc
         */
        masked: null,

        /**
         * This config object contains the defaults for the {@link Core.widget.Mask} created for the
         * {@link #config-masked} config. Any properties specified in the `masked` config will override these
         * values.
         * @config {Object|Core.widget.Mask}
         * @default
         * @category Misc
         */
        maskDefaults: {
          target: 'element'
        },
        cache: {},

        /**
         * Set to `true` to move the widget out of the document flow and position it
         * absolutely in browser viewport space.
         * @config {Boolean}
         * @default
         * @category Float & align
         */
        floating: null,

        /**
         * Set to `true` when a widget is rendered into another widget's  {@link #property-contentElement}, but must not
         * participate in the standard layout of that widget, and must be positioned relatively to that
         * widget's {@link #property-contentElement}.
         *
         * {@link Core.widget.Editor Editor}s are positioned widgets.
         * @config {Boolean}
         * @default
         * @category Float & align
         */
        positioned: null,

        /**
         * Only valid if this Widget is {@link #config-floating}
         * Set to `true` to be able to drag a widget freely on the page. Or set to an object with a ´handleSelector´ property which controls when a drag
         * should start.
         *
         * ```javascript
         *
         * draggable : {
         *     handleSelector : ':not(button)'
         * }
         *
         * ```
         *
         * @config {Boolean|Object}
         * @default false
         * @category Float & align
         */
        draggable: null,

        /**
         * _Only valid if this Widget is {@link #config-floating}._
         *
         * How to align this element with its target when {@link #function-showBy} is called
         * passing a simple element as an align target.
         *
         * Either a full alignment config object as passed to {@link #function-showBy}, or for simple
         * cases, the edge alignment string to use.
         *
         * When using a simple string, the format is `'[trbl]n-[trbl]n'` and it specifies our edge and
         * the target edge plus optional offsets from 0 to 100 along the edges to align to.
         *
         * See the {@link #function-showBy} function for more details about using the object form.
         *
         * Once set, this is stored internally in object form.
         * @config {Object|String}
         * @category Float & align
         */
        align: 't-b',
        // NOTE: this config changes meaning in tools and grid columns, so we don't get too clever here (such as
        //  config merge fn that promotes strings to objects)

        /**
         * Only valid if this Widget is {@link #config-floating}
         * Set to `true` to centre the Widget in browser viewport space.
         * @config {Boolean}
         * @default
         * @category Float & align
         */
        centered: null,

        /**
         * Only valid if this Widget is {@link #config-floating} and being shown through {@link #function-showBy}.
         * Element, Widget or Rectangle to which this Widget is constrained.
         * @config {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle}
         * @default document.body
         * @category Float & align
         */
        constrainTo: undefined,

        /**
         * Only valid if this Widget is {@link #config-floating} and being shown through {@link #function-showBy}.
         * `true` to show a connector arrow pointing to the align target.
         * @config {Boolean}
         * @default false
         * @category Float & align
         */
        anchor: null,

        /**
         * The owning Widget of this Widget. If this Widget is directly contained, this will be the containing Widget.
         * If there is a `forElement`, this config will be that element's encapsulating Widget.
         *
         * If this Widget is floating, this config must be specified by the developer.
         * @config {Core.widget.Widget}
         * @category Float & align
         */
        owner: null,

        /**
         * Defines what to do if document is scrolled while Widget is visible (only relevant when floating is set to true).
         * Valid values: ´null´: do nothing, ´hide´: hide the widget or ´realign´: realign to the target if possible.
         * @config {String}
         * @default
         * @category Float & align
         */
        scrollAction: null,

        /**
         * Only valid if this Widget is {@link #config-floating}. An object which defined which CSS style
         * property should be animated upon hide, and how it should be animated eg:
         *
         * ```javascript
         * {
         *    opacity: {
         *        to : 0,
         *        duration: '10s',
         *        delay: '0s'
         *    }
         * }
         * ```
         *
         * Set to `'false'` to disable animation.
         *
         * @config {Boolean|Object}
         * @default null
         * @category Float & align
         */
        hideAnimation: {
          $config: {
            merge: mergeAnim
          },
          value: null
        },

        /**
         * Only valid if this Widget is {@link #config-floating}. An object which defined which CSS style
         * property should be animated upon show, and how it should be animated eg:
         *
         * ```javascript
         * {
         *    opacity: {
         *        to : 1,
         *        duration: '10s',
         *        delay: '0s'
         *    }
         * }
         * ```
         *
         * Set to `'false'` to disable animation.
         *
         * @config {Boolean|Object}
         * @default null
         * @category Float & align
         */
        showAnimation: {
          $config: {
            merge: mergeAnim
          },
          value: null
        },

        /**
         * Only valid if this Widget is {@link #config-floating}. The x position for the widget.
         *
         * @config {Number}
         * @default
         * @category Float & align
         */
        x: null,

        /**
         * Only valid if this Widget is {@link #config-floating}. The y position for the widget.
         *
         * @config {Number}
         * @default
         * @category Float & align
         */
        y: null,

        /**
         * Accessor to the {@link Core.helper.util.Scroller} which can be used
         * to both set and read scroll information.
         * @member {Core.helper.util.Scroller} scrollable
         * @category Scrolling
         */

        /**
         * Specifies whether (and optionally in which axes) a Widget may scroll. `true` means this widget
         * may scroll in both axes. May be an object containing boolean `overflowX` and `overflowY` properties which are applied
         * to CSS style properties `overflowX` and `overflowY`. If they are boolean, they are translated
         * to CSS overflow properties thus:
         *
         * *`true` -> `'auto'`
         * *`false` -> `'hidden'`
         *
         * After initialization, this property yields a {@link Core.helper.util.Scroller} which may be used
         * to both set and read scroll information.
         *
         * A Widget uses its `get overflowElement` property to select which element is to be scrollable.
         * By default, in the base `Widget` class, this is the Widget's encapsulating element. Subclasses
         * may implement `get overflowElement` to scroll inner elements.
         * @config {Boolean|Object|Core.helper.util.Scroller}
         * @default false
         * @category Scrolling
         */
        scrollable: null,

        /**
         * The class to instantiate to use as the {@link #config-scrollable}. Defaults to {@link Core.helper.util.Scroller}.
         * @internal
         * @config {Core.helper.util.Scroller}
         * @category Scrolling
         */
        scrollerClass: _helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_45__["default"],

        /**
         * The name of the property to set when a single value is to be applied to this Widget. Such as when used
         * in a grid WidgetColumn, this is the property to which the column's `field` is applied.
         * @config {String}
         * @default 'html'
         * @category Misc
         */
        defaultBindProperty: 'html',

        /**
         * Event that should be considered the default action of the widget. When that event is triggered the
         * widget is also expected to trigger an `action` event. Purpose is to allow reacting to most widgets in
         * a coherent way.
         * @private
         * @config {String}
         * @category Misc
         */
        defaultAction: null,

        /**
         * Widget's width, used to set element style.width. Either specify a valid width string or a number, which
         * will get 'px' appended. We recommend using CSS as the primary way to control width, but in some cases
         * this config is convenient.
         * @config {String|Number}
         * @category Layout
         */
        width: null,

        /**
         * Widget's height, used to set element style.height. Either specify a valid height string or a number, which
         * will get 'px' appended. We recommend using CSS as the primary way to control height, but in some cases
         * this config is convenient.
         * @config {String|Number}
         * @category Layout
         */
        height: null,

        /**
         * The element's maxHeight. Can be either a String or a Number (which will have 'px' appended). Note that
         * like {@link #config-height}, _reading_ the value will return the numeric value in pixels.
         * @config {String|Number}
         * @category Layout
         */
        maxHeight: null,

        /**
         * The elements maxWidth. Can be either a String or a Number (which will have 'px' appended). Note that
         * like {@link #config-width}, _reading_ the value will return the numeric value in pixels.
         * @config {String|Number}
         * @category Layout
         */
        maxWidth: null,

        /**
         * The elements minWidth. Can be either a String or a Number (which will have 'px' appended). Note that
         * like {@link #config-width}, _reading_ the value will return the numeric value in pixels.
         * @config {String|Number}
         * @category Layout
         */
        minWidth: null,

        /**
         * The element's minHeight. Can be either a String or a Number (which will have 'px' appended). Note that
         * like {@link #config-height}, _reading_ the value will return the numeric value in pixels.
         * @config {String|Number}
         * @category Layout
         */
        minHeight: null,
        // not public, only used by us in docs
        scaleToFitWidth: null,
        allowGrowWidth: true,
        // only used if scaleToFitWidth is true

        /**
         * Get element's margin property. This may be configured as a single number or a `TRBL` format string.
         * numeric-only values are interpreted as pixels.
         * @member {Number|String} margin
         * @category Layout
         */

        /**
         * Widget's margin. This may be configured as a single number or a `TRBL` format string.
         * numeric-only values are interpreted as pixels.
         * @config {Number|String}
         * @category Layout
         */
        margin: null,

        /**
         * Get element's flex property. This may be configured as a single number or a format string:
         *
         *      <flex-grow> <flex-shrink> <flex-basis>
         *
         * Numeric-only values are interpreted as the `flex-grow` value.
         * @member {Number|String} flex
         * @category Layout
         */

        /**
         * When this widget is a child of a {@link Core.widget.Container}, it will by default be participating in a
         * flexbox layout. This config allows you to set this widget's
         * <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex">flex</a> style.
         * This may be configured as a single number or a `<flex-grow> <flex-shrink> <flex-basis>` format string.
         * numeric-only values are interpreted as the `flex-grow` value.
         * @config {Number|String}
         * @category Layout
         */
        flex: null,

        /**
         * A widgets weight determines its position among siblings when added to a {@link Core.widget.Container}.
         * Higher weights go further down.
         * @config {Number}
         * @category Layout
         */
        weight: null,

        /**
         * Get/set this widget's `align-self` flexbox setting. This may be set to modify how this widget is aligned
         * within the cross axis of a flexbox layout container.
         * @member {String} alignSelf
         * @category Layout
         */

        /**
         * When this widget is a child of a {@link Core.widget.Container}, it will by default be participating in a
         * flexbox layout. This config allows you to set this widget's
         * <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-self">align-self</a> style.
         * @config {String}
         * @category Layout
         */
        alignSelf: null,

        /**
         * Configure as `true` to have the component display a translucent ripple when its
         * {@link #property-focusElement}, or {@link #property-element} is tapped *if the
         * current theme supports ripples*. Out of the box, only the Material theme supports ripples.
         *
         * This may also be a config object containing the following properties:
         *
         *  - `delegate  ` Optional. A CSS selector to filter which child elements trigger ripples. By default
         * the ripple is clipped to the triggering element.
         *  - `color     ` Optional, default = `#000`. A CSS color name or specification.
         *  - `radius    ` Optional, default is 100. The ending radius of the ripple.
         * Note that it will be clipped by the target element by default.
         *  - `clip      ` A string which describes how to clip the ripple if it is not to be clipped to the default
         * element. Either the property of the widget to use as the clipping element, or a selector to
         * allow clipping to the closest matching ancestor to the target element.
         *
         * eg:
         *```
         *    columns  : [{}...],
         *    ripple   : {
         *        color : 'red',
         *        clip  : '.b-grid-row'
         *    },
         *    ...
         *```
         * @config {Boolean|Object}
         * @category Misc
         */
        ripple: null,

        /**
         * A title to display for the widget. Only in effect when inside a container that uses it (such as TabPanel)
         * @default
         * @config {String}
         * @category DOM
         */
        title: null,
        localizableProperties: ['title'],
        // Set this flag to require element to have a size to be considered visible
        requireSize: false,

        /**
         * An identifier by which this widget will be registered in the {@link Core.widget.Container#property-widgetMap}
         * of all ancestor containers.
         *
         * If omitted, this widget will be registered using its {@link #config-id}. In most cases `ref` is
         * preferable over `id` since `id` is required to be globally unique while `ref` is not.
         *
         * The `ref` value is also added to the elements dataset, to allow targeting it using CSS etc.
         * @default
         * @config {String}
         * @category Misc
         */
        ref: null,

        /**
         * Get/set the widget hidden state.
         * @member {Boolean} hidden
         * @category Visibility
         */

        /**
         * Configure with true to make widget initially hidden.
         * @default false
         * @config {Boolean}
         * @category Visibility
         */
        hidden: null,

        /**
         * Text alignment: 'left', 'center' or 'right'. Applied by adding a `b-text-align-xx` class to the widgets
         * element. Blank by default, which does not add any alignment class.
         * @config {String}
         */
        textAlign: null,
        // When adding our scroll listeners to hide/realign, we ignore events
        // happening too quickly as a result of the show/align action
        ignoreScrollDuration: 500,

        /**
         * The tag name of this Widget's root element
         * @config {String}
         * @default
         */
        tag: 'div'
      };
    }
    /**
     * Call once per class for custom widgets to have them register with the `Widget` class, allowing them to be created
     * by type.
     *
     * For example:
     * ```javascript
     * class MyWidget extends Widget {
     *   static get type() {
     *     return 'mywidget';
     *   }
     * }
     * MyWidget.initClass();
     * ```
     * @method initClass
     * @static
     */

  }, {
    key: "factoryable",
    get: function get() {
      return {
        defaultType: 'widget'
      };
    }
  }, {
    key: "identifiable",
    get: function get() {
      return {};
    }
  }, {
    key: "floatRoot",
    get: function get() {
      var me = this;

      if (!me._floatRoot) {
        // Reuse any existing floatRoot. There might be one if using multiple product bundles
        me._floatRoot = document.querySelector('.b-float-root');
      }

      if (!me._floatRoot) {
        var _DomHelper$themeInfo;

        var outerCls = me.outerCls,
            themeName = (_DomHelper$themeInfo = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].themeInfo) === null || _DomHelper$themeInfo === void 0 ? void 0 : _DomHelper$themeInfo.name; // When outside of our examples, the body element doesn't get the theme class.
        // The floatRoot must carry it for floating items to be themed.

        if (themeName) {
          outerCls.push("b-theme-".concat(themeName.toLowerCase()));
        }

        me._floatRoot = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].createElement({
          className: "b-float-root ".concat(outerCls.join(' ')),
          parent: document.body
        }); // Make float root immune to keyboard-caused size changes

        if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isAndroid) {
          me._floatRoot.style.height = "".concat(screen.height, "px");
          _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].on({
            element: window,
            orientationchange: function orientationchange() {
              return me._floatRoot.style.height = "".concat(screen.height, "px");
            }
          });
        } // Keep floatRoot up to date with the theme


        _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_52__["default"].on({
          theme: function theme(_ref2) {
            var _theme = _ref2.theme,
                prev = _ref2.prev;
            me.floatRoot.classList.add("b-theme-".concat(_theme.toLowerCase()));
            me.floatRoot.classList.remove("b-theme-".concat(prev.toLowerCase()));
          }
        });
      } else if (!document.body.contains(me._floatRoot)) {
        // Reattach floatRoot if it was detached
        document.body.appendChild(me._floatRoot);
      }

      return me._floatRoot;
    }
  }, {
    key: "outerCls",
    get: function get() {
      var result = [];

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isTouchDevice) {
        result.push('b-touch-events');
      }

      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].scrollBarWidth) {
        result.push('b-visible-scrollbar');
      } else {
        result.push('b-overlay-scrollbar');
      }

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isChrome) {
        result.push('b-chrome');
      } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isSafari) {
        result.push('b-safari');
      } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isFirefox) {
        result.push('b-firefox');
      } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11) {
        result.push('b-ie');
      } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isEdge) {
        result.push('b-edge');
      } // So that we don't get the polyfill styles applied if we have ResizeMonitor available.
      // The polyfill styles can break certain elements styling.


      if (!window.ResizeObserver) {
        result.push('b-no-resizeobserver');
      }

      return result;
    }
  }]);

  return Widget;
}(_Base_js__WEBPACK_IMPORTED_MODULE_34__["default"].mixin(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_47__["default"], _mixin_Events_js__WEBPACK_IMPORTED_MODULE_48__["default"], _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_49__["default"], _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_51__["default"], _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_50__["default"])); // Register this widget type with its Factory



Widget.initClass();
Widget.register('mask', _Mask_js__WEBPACK_IMPORTED_MODULE_53__["default"]); // These low level classes must not import Widget because that would cause circularity.
// Instead Widget injects a reference to itself into them.

_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].Widget = Widget;
_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_52__["default"].Widget = Widget; // We use the same map to track instances by ID

_Mask_js__WEBPACK_IMPORTED_MODULE_53__["default"].identifiable.idMap = Widget.identifiable.idMap; // Simplify querying widgets by exposing fns in bryntum ns

(window.bryntum || (window.bryntum = {})).get = Widget.getById.bind(Widget);
window.bryntum.Widget = Widget;
window.bryntum.query = Widget.query;
window.bryntum.queryAll = Widget.queryAll;
window.bryntum.fromElement = Widget.fromElement;
Widget._$name = 'Widget';

/***/ }),

/***/ "./lib/Core/widget/layout/Card.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/layout/Card.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Card; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Layout_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Layout.js */ "./lib/Core/widget/layout/Layout.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Core/widget/layout/Card
 */

var animationClasses = ['b-slide-out-left', 'b-slide-out-right', 'b-slide-in-left', 'b-slide-in-right'];
/**
 * A helper class for containers which must manage multiple child widgets, of which only one may be visible at once such
 * as a {@link Core.widget.TabPanel}. This class offers an active widget switching API, and optional slide-in,
 * slide-out animations from child to child.
 */

var Card = /*#__PURE__*/function (_Layout) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(Card, _Layout);

  var _super = _createSuper(Card);

  function Card() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Card);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Card, [{
    key: "onChildAdd",
    value: function onChildAdd(item) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Card.prototype), "onChildAdd", this).call(this, item);

      item.on({
        beforeHide: 'onBeforeChildHide',
        beforeShow: 'onBeforeChildShow',
        thisObj: this
      });
      var activeItem = this.activeItem,
          owner = this.owner,
          activeIndex = owner.activeIndex != null ? owner.activeIndex : this.activeIndex || 0,
          itemIndex = owner.items.indexOf(item),
          isActive = activeItem != null ? item === activeItem : itemIndex === activeIndex; // Ensure inactive child items start hidden, and the active one starts shown.
      // Sync our active indicators with reality ready for render.

      if (isActive) {
        item.show();
        this._activeIndex = itemIndex;
        this._activeItem = item;
      } else {
        item.hide();
      }
    }
  }, {
    key: "onChildRemove",
    value: function onChildRemove(item) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Card.prototype), "onChildRemove", this).call(this, item); // Active child has been removed without setting another child to be active.
      // Choose an immediate sibling to be the new active item


      if (this._activeItem === item) {
        this.activateSiblingOf(item);
      }

      item.un({
        beforeHide: 'onBeforeChildHide',
        beforeShow: 'onBeforeChildShow',
        thisObj: this
      });
    }
    /**
     * Detect external code showing a child. We veto that show and activate it through the API.
     * @internal
     */

  }, {
    key: "onBeforeChildShow",
    value: function onBeforeChildShow(_ref) {
      var showingChild = _ref.source;

      // Some outside code is showing a child.
      // We must control this, so veto it and activate it in the standard way.
      if (!this.owner.isConfiguring && !showingChild.$isActivating) {
        this.activeItem = showingChild;
        return false;
      }
    }
    /**
     * Detect external code hiding a child. We veto that show and activate an immediate sibling through the API.
     * @internal
     */

  }, {
    key: "onBeforeChildHide",
    value: function onBeforeChildHide(_ref2) {
      var hidingChild = _ref2.source;

      // Some outside code is hiding a child.
      // We must control this, so veto it and activate a sibling in the standard way.
      if (!this.owner.isConfiguring && !hidingChild.$isDeactivating) {
        this.activateSiblingOf(hidingChild);
        return false;
      }
    }
  }, {
    key: "activateSiblingOf",
    value: function activateSiblingOf(item) {
      var owner = this.owner,
          items = owner.items.slice(),
          removeAt = items.indexOf(item);
      items.splice(removeAt, 1);
      this.activeIndex = Math.min(removeAt, items.length - 1);
    }
    /**
     * Get/set active item, using index or the Widget to activate
     * @param {Core.widget.Widget|Number} activeItem
     * @returns {Object} An object describing the card change containing the following properties:
     *
     *  - `prevActiveIndex` The previously active index.
     *  - `prevActiveItem ` The previously active child item.
     *  - `activeIndex    ` The newly active index.
     *  - `activeItem     ` The newly active child item.
     *  - `promise        ` A promise which completes when the slide-in animation finishes and the child item contains
     * focus if it is focusable.
     * @internal
     */

  }, {
    key: "setActiveItem",
    value: function setActiveItem(activeIndex) {
      var prevActiveIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.activeIndex;
      var me = this,
          owner = me.owner,
          items = owner.items,
          widgetPassed = activeIndex instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_14__["default"],
          prevActiveItem = items[prevActiveIndex],
          newActiveItem = owner.items[activeIndex = widgetPassed ? activeIndex = items.indexOf(activeIndex) : parseInt(activeIndex)],
          event = {
        prevActiveIndex: prevActiveIndex,
        prevActiveItem: prevActiveItem
      }; // There's a child widget at that index to activate and we're not already activating it.

      if (newActiveItem && !newActiveItem.$isActivating && newActiveItem !== prevActiveItem) {
        var prevItemElement = prevActiveItem && prevActiveItem.element,
            newActiveElement = newActiveItem && newActiveItem.element;
        event.activeIndex = activeIndex;
        event.activeItem = newActiveItem;

        if (owner.trigger('beforeActiveItemChange', event) === false) {
          return null;
        } // A previous card change is in progress, abort it and clean the items it was operating upon


        if (me.animateDetacher) {
          var abortedEvent = me.animateDetacher.event;
          me.animateDetacher();
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].removeClasses(abortedEvent.prevActiveItem.element, animationClasses);
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].removeClasses(abortedEvent.activeItem.element, animationClasses);
          me.animateDetacher = null;
        }

        event.promise = new Promise(function (resolve, reject) {
          // If there's something to slide out, slide it out, and slide the new item in
          if (prevItemElement && owner.isVisible && me.animateCardChange) {
            // During the card sliding trick, we don't want resize notifications.
            // The outgoing card should be as inert as if it were hidden.
            var wasMonitoringSize = prevActiveItem.monitorResize;
            prevActiveItem.monitorResize = false; // The outgoing card must report its isVisible property as false from now on
            // even before we officially hide it.

            prevActiveItem._hidden = true; // Show the item so that it can be slid in.
            // Events will ensue, UIs can react to the show event.
            // The flag is so that our onBeforeChildShow listener can
            // tell if it's part of our orderly activate operation.

            newActiveItem.$isActivating = true;
            newActiveItem.show();
            newActiveItem.$isActivating = false;
            prevItemElement.classList.add(activeIndex > prevActiveIndex ? 'b-slide-out-left' : 'b-slide-out-right');
            newActiveElement.classList.add(activeIndex < prevActiveIndex ? 'b-slide-in-left' : 'b-slide-in-right');
            owner.isAnimating = true; // When the new widget is in place, clean up

            me.animateDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
              element: newActiveElement,
              animationend: function animationend() {
                me.animateDetacher = null;
                owner.isAnimating = false; // Clean incoming widget's animation classes

                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].removeClasses(newActiveElement, animationClasses); // If there's an outgoing item, clean its animation classes and hide it

                if (prevItemElement) {
                  _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].removeClasses(prevItemElement, animationClasses); // The flag is so that our onBeforeChildHide listener can
                  // tell if it's part of our orderly activate operation.

                  prevActiveItem.$isDeactivating = true;
                  prevActiveItem._hidden = false;
                  prevActiveItem.hide();
                  prevActiveItem.monitorResize = wasMonitoringSize;
                  prevActiveItem.$isDeactivating = false;
                }

                me.onActiveItemChange(event, resolve);
              },
              once: true
            });
            me.animateDetacher.reject = reject;
            me.animateDetacher.event = event;
          } // Nothing to slide out or we are not animating.
          else {
              // Show the new active items first, so that the hide listener doesn't
              // automatically set a new active item based on active item being hidden.
              // The flag is so that our onBeforeChildShow listener can
              // tell if it's part of our orderly activate operation.
              newActiveItem.$isActivating = true;
              newActiveItem.show();
              newActiveItem.$isActivating = false;

              if (prevActiveItem) {
                // The flag is so that our onBeforeChildHide listener can
                // tell if it's part of our orderly activate operation.
                prevActiveItem.$isDeactivating = true;
                prevActiveItem.hide();
                prevActiveItem.$isDeactivating = false;
              }

              me.onActiveItemChange(event, resolve);
            }
        });
      }

      return event;
    }
  }, {
    key: "onActiveItemChange",
    value: function onActiveItemChange(event, resolve) {
      this._activeItem = event.activeItem;
      this._activeIndex = event.activeIndex;
      this.owner.trigger('activeItemChange', event); // Note that we have to call focus *after* the element is in its new position
      // because focus({preventScroll:true}) is not supported everywhere
      // and crazy browser scrolling behaviour on focus breaks the animation.

      event.activeItem.focus();
      resolve(event);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var owner = this.owner; // The usual; not working on IE11

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isIE11) {
        this.animateCardChange = false;
      }

      owner.contentElement.classList[owner.suppressChildHeaders ? 'add' : 'remove'](this.hideChildHeaderCls);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Card.prototype), "renderChildren", this).call(this);
    }
  }, {
    key: "changeActiveIndex",
    value: function changeActiveIndex(activeIndex) {
      var owner = this.owner; // Sanitize it if possible

      return owner.isConfiguring && !owner._items ? activeIndex : Math.min(activeIndex, owner.items.length - 1);
    }
  }, {
    key: "updateActiveIndex",
    value: function updateActiveIndex(activeIndex, oldActiveIndex) {
      if (!this.owner.isConfiguring) {
        this.setActiveItem(activeIndex, oldActiveIndex);
      }
    }
  }, {
    key: "updateActiveItem",
    value: function updateActiveItem(activeItem) {
      if (!this.owner.isConfiguring) {
        this.setActiveItem(activeItem, this.activeIndex);
      }
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'Card';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        containerCls: 'b-card-container',
        itemCls: 'b-card-item',
        hideChildHeaderCls: 'b-hide-child-headers',

        /**
         * Specifies whether to slide tabs in and out of visibility.
         * @config {Boolean}
         * @default
         */
        animateCardChange: true,

        /**
         * The active child item.
         * @config {Core.widget.Widget}
         */
        activeItem: null,

        /**
         * The active child index.
         * @config {Number}
         */
        activeIndex: null
      };
    }
  }]);

  return Card;
}(_Layout_js__WEBPACK_IMPORTED_MODULE_13__["default"]); // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names



Card._$name = 'Card';
_Layout_js__WEBPACK_IMPORTED_MODULE_13__["default"].registerLayout(Card);

/***/ }),

/***/ "./lib/Core/widget/layout/Fit.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/layout/Fit.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Fit; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Layout_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Layout.js */ "./lib/Core/widget/layout/Layout.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/widget/layout/Fit
 */

/**
 * A helper class for containers which must manage a single child widget which must fit the container's
 * {@link Core.widget.Widget#property-contentElement contentElement}.
 */

var Fit = /*#__PURE__*/function (_Layout) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Fit, _Layout);

  var _super = _createSuper(Fit);

  function Fit() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Fit);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Fit, null, [{
    key: "$name",
    get: function get() {
      return 'Fit';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        containerCls: 'b-fit-container',
        itemCls: 'b-fit-item'
      };
    }
  }]);

  return Fit;
}(_Layout_js__WEBPACK_IMPORTED_MODULE_8__["default"]); // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names



Fit._$name = 'Fit';
_Layout_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerLayout(Fit);

/***/ }),

/***/ "./lib/Core/widget/layout/Layout.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/layout/Layout.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Layout; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Core/widget/layout/Layout
 */

/**
  * A helper class used by {@link Core.widget.Container Container}s which renders child widgets to their
  * {@link Core.widget.Widget#property-contentElement}. It also adds the Container's
  * {@link Core.widget.Container#config-itemCls} class to child items.
  *
  * Subclasses may modify the way child widgets are rendered, or may offer APIs for manipulating the child widgets.
  *
  * The {@link Core.widget.layout.Card Card} layout class offers slide-in, slide-out animation of multiple
  * child widgets. {@link Core.widget.TabPanel} uses Card layout.
  */

var Layout = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Layout, _Events);

  var _super = _createSuper(Layout);

  function Layout() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Layout);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Layout, [{
    key: "onChildAdd",
    value: function onChildAdd(item) {}
  }, {
    key: "onChildRemove",
    value: function onChildRemove(item) {}
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var owner = this.owner,
          containerCls = this.containerCls,
          itemCls = this.itemCls,
          contentElement = owner.contentElement,
          items = owner.items,
          ownerItemCls = owner.itemCls,
          itemCount = items && items.length;
      contentElement.classList.add('b-content-element');

      if (containerCls) {
        contentElement.classList.add(containerCls);
      } // Need to check that container has widgets, for example TabPanel can have no tabs


      if (itemCount) {
        owner.textContent = false;

        for (var i = 0; i < itemCount; i++) {
          var item = items[i],
              element = item.element;
          element.dataset.itemIndex = i;

          if (itemCls) {
            element.classList.add(itemCls);
          }

          if (ownerItemCls) {
            element.classList.add(ownerItemCls);
          } // If instantiated by the app developer, external to Container#createWidget
          // a widget will have the b-outer class. Remove that if it' contained.


          element.classList.remove('b-outer'); // Only trigger paint if the owner is itself painted, otherwise
          // the outermost Container will cascade the paint signal down.

          item.render(contentElement, Boolean(owner.isPainted));
        }
      }

      this.syncChildCount();
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      var element = child.element,
          owner = this.owner,
          itemCls = this.itemCls,
          contentElement = owner.contentElement,
          ownerItemCls = owner.itemCls;
      contentElement.removeChild(element);
      delete element.dataset.itemIndex;

      if (itemCls) {
        element.classList.remove(itemCls);
      }

      if (ownerItemCls) {
        element.classList.remove(ownerItemCls);
      }

      this.fixChildIndices();
      this.syncChildCount();
    }
  }, {
    key: "appendChild",
    value: function appendChild(child) {
      var element = child.element,
          childIndex = this.owner.indexOfChild(child),
          owner = this.owner,
          itemCls = this.itemCls,
          contentElement = owner.contentElement,
          ownerItemCls = owner.itemCls;
      element.dataset.itemIndex = childIndex;
      owner.textContent = false;

      if (itemCls) {
        element.classList.add(itemCls);
      }

      if (ownerItemCls) {
        element.classList.add(ownerItemCls);
      }

      child.render(contentElement, Boolean(owner.isPainted));
      this.syncChildCount();
    }
  }, {
    key: "insertChild",
    value: function insertChild(toAdd, childIndex) {
      var element = toAdd.element,
          owner = this.owner,
          itemCls = this.itemCls,
          contentElement = owner.contentElement,
          nextSibling = contentElement.querySelector("[data-item-index=\"".concat(childIndex, "\"]")),
          ownerItemCls = owner.itemCls;
      owner.textContent = false;

      if (itemCls) {
        element.classList.add(itemCls);
      }

      if (ownerItemCls) {
        element.classList.add(ownerItemCls);
      }

      contentElement.insertBefore(element, nextSibling);
      toAdd.render(null, Boolean(owner.isPainted));
      this.fixChildIndices();
      this.syncChildCount();
    }
  }, {
    key: "fixChildIndices",
    value: function fixChildIndices() {
      this.owner.items.forEach(function (child, index) {
        child.element.dataset.itemIndex = index;
      });
    }
  }, {
    key: "syncChildCount",
    value: function syncChildCount() {
      var owner = this.owner,
          length = owner.items.length; // Special CSS conditions may apply if there's only a single child.

      owner.contentElement.classList[length === 1 ? 'add' : 'remove']('b-single-child');
    }
    /**
     * The owning Widget
     * @property {String} owner
     * @readonly
     */

  }], [{
    key: "getLayout",
    value: function getLayout(layout, owner) {
      if (layout instanceof Layout) {
        layout.owner = this;
        return layout;
      }

      var config = {
        owner: owner
      };

      if (typeof layout === 'string') {
        config.type = layout;
      } else {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].assign(config, layout);
      }

      return new layoutClasses[config.type || 'default'](config);
    }
  }, {
    key: "registerLayout",
    value: function registerLayout(cls) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cls.$$name.toLowerCase();
      layoutClasses[name] = cls;
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * The CSS class which should be added to the owning {@link Core.widget.Container Container}'s
         * {@link Core.widget.Widget#property-contentElement}.
         */
        containerCls: 'b-auto-container',

        /**
         * The CSS class which should be added to the encapsulating element of child items.
         */
        itemCls: null
      };
    }
  }]);

  return Layout;
}(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_11__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"]));


var layoutClasses = {
  default: Layout
};
Layout._$name = 'Layout';

/***/ }),

/***/ "./lib/Core/widget/mixin/Badge.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/mixin/Badge.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/widget/mixin/Badge
 */

/**
 * Mixin that allows a widget to display a badge (mostly done as css)
 *
 * @example
 * // show badge
 * button.badge = 5;
 *
 * // hide badge
 * button.badge = null;
 *
 * @externalexample widget/Badge.js
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Badge, _ref);

    var _super = _createSuper(Badge);

    function Badge() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Badge);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Badge, [{
      key: "updateBadge",
      value: function updateBadge(badge) {
        var element = this.element;

        if (element) {
          if (badge != null && badge !== '') {
            element.dataset.badge = badge;
            element.classList.add('b-badge');
          } else {
            if (element.dataset.badge) {
              delete element.dataset.badge;
            }

            element.classList.remove('b-badge');
          }
        }
      } // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {
        // If we don't have a badge, our classList doesn't include "b-badge"
        if (this.badge) {
          return 'b-badge';
        }
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'Badge';
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * Get/sets and display badge, set to null or empty string to hide.
           * @property {String}
           * @name badge
           */

          /**
           * Initial text to show in badge.
           * @config {String} badge
           */
          badge: null
        };
      }
    }]);

    return Badge;
  }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);
});

/***/ }),

/***/ "./lib/Core/widget/mixin/LocalizableComboItems.js":
/*!********************************************************!*\
  !*** ./lib/Core/widget/mixin/LocalizableComboItems.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Combo.js */ "./lib/Core/widget/Combo.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Core/widget/mixin/LocalizableComboItems
 */

/**
 * A mixin that regenerates a combobox items on locale change.
 * @private
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(LocalizableComboItems, _ref);

    var _super = _createSuper(LocalizableComboItems);

    function LocalizableComboItems() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, LocalizableComboItems);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(LocalizableComboItems, [{
      key: "construct",
      value: function construct() {
        var _get2;

        // set a special flag to skip unneeded store translation on construction step
        this.inConstruct = true;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(LocalizableComboItems.prototype), "construct", this)).call.apply(_get2, [this].concat(args));

        this.inConstruct = false;
      }
    }, {
      key: "buildLocalizedItems",
      value: function buildLocalizedItems() {
        return [];
      }
    }, {
      key: "updateLocalizedItems",
      value: function updateLocalizedItems() {
        var me = this;

        if (me.store && !me.inConstruct) {
          var value = me.value; // TODO: just updating new data is not enough ..selected value text is shown wrong :(
          // it seems caused by selected record cache
          // review this code after #9387 is fixed

          me.store.data = me.buildLocalizedItems();
          me.value = null;
          me.value = value;
          me.syncInputFieldValue(true);
        }
      }
    }, {
      key: "updateLocalization",
      value: function updateLocalization() {
        this.updateLocalizedItems();

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(LocalizableComboItems.prototype), "updateLocalization", this).call(this);
      }
    }, {
      key: "items",
      set: function set(items) {
        if (items === true) {
          items = this.buildLocalizedItems();
        }

        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(LocalizableComboItems.prototype), "items", items, this, true);
      },
      get: function get() {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(LocalizableComboItems.prototype), "items", this);
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'LocalizableComboItems';
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          items: true
        };
      }
    }]);

    return LocalizableComboItems;
  }(Target || _Combo_js__WEBPACK_IMPORTED_MODULE_11__["default"]);
});

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCache.js":
/*!**********************************************!*\
  !*** ./lib/Engine/calendar/CalendarCache.js ***!
  \**********************************************/
/*! exports provided: CalendarIteratorResult, CalendarCache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarIteratorResult", function() { return CalendarIteratorResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCache", function() { return CalendarCache; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _util_Types_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/Types.js */ "./lib/Engine/util/Types.js");



var productName = 'scheduler';




var CalendarIteratorResult;

(function (CalendarIteratorResult) {
  CalendarIteratorResult[CalendarIteratorResult["FullRangeIterated"] = 0] = "FullRangeIterated";
  CalendarIteratorResult[CalendarIteratorResult["StoppedByIterator"] = 1] = "StoppedByIterator";
  CalendarIteratorResult[CalendarIteratorResult["MaxCacheExtendCyclesReached"] = 2] = "MaxCacheExtendCyclesReached";
  CalendarIteratorResult[CalendarIteratorResult["MaxRangeReached"] = 3] = "MaxRangeReached";
})(CalendarIteratorResult || (CalendarIteratorResult = {}));

var CalendarCache = /*#__PURE__*/function () {
  function CalendarCache(config) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, CalendarCache);

    this.cacheFilledStartDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MAX_DATE"];
    this.cacheFilledEndDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MIN_DATE"];
    this.intervalsCachingChunkDuration = 30;
    this.intervalsCachingChunkUnit = _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_4__["TimeUnit"].Day;
    this.maxCacheExtendCycles = 100;
    this.maxRange = 5 * 12 * 30 * 24 * 60 * 60 * 1000;
    config && Object.assign(this, config);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(CalendarCache, [{
    key: "includeWrappingRangeFrom",
    value: function includeWrappingRangeFrom(cache, startDate, endDate) {
      cache.ensureCacheFilledForInterval(startDate, endDate);
      this.intervalCache.includeWrappingRange(cache.intervalCache, startDate, endDate);
    }
  }, {
    key: "ensureCacheFilledForInterval",
    value: function ensureCacheFilledForInterval(startDate, endDate) {
      var cacheFilledStartDateN = this.cacheFilledStartDate.getTime();
      var cacheFilledEndDateN = this.cacheFilledEndDate.getTime();

      if (cacheFilledStartDateN !== _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MAX_DATE"].getTime()) {
        var startDateN = startDate.getTime();
        var endDateN = endDate.getTime();
        if (cacheFilledStartDateN <= startDateN && endDateN <= cacheFilledEndDateN) return;

        if (endDateN <= cacheFilledStartDateN) {
          endDate = new Date(cacheFilledStartDateN - 1);
        } else if (startDateN >= cacheFilledEndDateN) {
          startDate = new Date(cacheFilledEndDateN + 1);
        } else if (cacheFilledStartDateN <= startDateN && startDateN <= cacheFilledEndDateN) {
          startDate = new Date(cacheFilledEndDateN + 1);
        } else if (cacheFilledStartDateN <= endDateN && endDateN <= cacheFilledEndDateN) {
          endDate = new Date(cacheFilledStartDateN - 1);
        } else {
          this.ensureCacheFilledForInterval(startDate, new Date(cacheFilledStartDateN - 1));
          this.ensureCacheFilledForInterval(new Date(cacheFilledEndDateN + 1), endDate);
          return;
        }
      }

      if (cacheFilledStartDateN === _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MAX_DATE"].getTime() || startDate.getTime() < cacheFilledEndDateN) {
        this.cacheFilledStartDate = startDate;
      }

      if (cacheFilledEndDateN === _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MIN_DATE"].getTime() || cacheFilledEndDateN < endDate.getTime()) {
        this.cacheFilledEndDate = endDate;
      }

      this.fillCache(startDate, endDate);
    }
  }, {
    key: "fillCache",
    value: function fillCache(_1, _2) {
      throw new Error("Abstract method");
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cacheFilledStartDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MAX_DATE"];
      this.cacheFilledEndDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MIN_DATE"];
      this.intervalCache.clear();
    }
  }, {
    key: "forEachAvailabilityInterval",
    value: function forEachAvailabilityInterval(options, func, scope) {
      var _a;

      scope = scope || this;
      var startDate = options.startDate;
      var endDate = options.endDate;
      var startDateN = startDate && startDate.getTime();
      var endDateN = endDate && endDate.getTime();
      var maxRange = (_a = options.maxRange) !== null && _a !== void 0 ? _a : this.maxRange;
      var isForward = options.isForward !== false;

      if (isForward ? !startDate : !endDate) {
        throw new Error("At least `startDate` or `endDate` is required, depending from the `isForward` option");
      }

      var intervalCache = this.intervalCache;
      var cacheCursorDate = isForward ? startDate : endDate;
      var cursorDate = isForward ? startDate : endDate;
      var rangeStart = cursorDate.getTime();

      for (var cycle = 1; cycle < this.maxCacheExtendCycles; cycle++) {
        if (isForward) {
          this.ensureCacheFilledForInterval(cacheCursorDate, endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(cacheCursorDate, this.intervalsCachingChunkDuration, this.intervalsCachingChunkUnit));
        } else {
          this.ensureCacheFilledForInterval(startDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(cacheCursorDate, -this.intervalsCachingChunkDuration, this.intervalsCachingChunkUnit), cacheCursorDate);
        }

        var interval = intervalCache.getIntervalOf(cursorDate, isForward ? _util_Types_js__WEBPACK_IMPORTED_MODULE_6__["EdgeInclusion"].Left : _util_Types_js__WEBPACK_IMPORTED_MODULE_6__["EdgeInclusion"].Right);

        while (interval) {
          var intervalStartDate = interval.startDate;
          var intervalEndDate = interval.endDate;

          if (isForward && endDateN && intervalStartDate.getTime() >= endDateN || !isForward && startDateN && intervalEndDate.getTime() <= startDateN) {
            return CalendarIteratorResult.FullRangeIterated;
          }

          if (isForward && intervalStartDate.getTime() - rangeStart >= maxRange || !isForward && rangeStart - intervalEndDate.getTime() >= maxRange) {
            return CalendarIteratorResult.MaxRangeReached;
          }

          if (isForward && intervalStartDate.getTime() > this.cacheFilledEndDate.getTime() || !isForward && intervalEndDate.getTime() < this.cacheFilledStartDate.getTime()) {
            break;
          }

          cursorDate = isForward ? intervalEndDate : intervalStartDate;
          var countFrom = startDateN && intervalStartDate.getTime() < startDateN ? startDate : intervalStartDate;
          var countTill = endDateN && intervalEndDate.getTime() > endDateN ? endDate : intervalEndDate;

          if (func.call(scope, countFrom, countTill, interval.cacheInterval) === false) {
            return CalendarIteratorResult.StoppedByIterator;
          }

          interval = isForward ? intervalCache.getNextInterval(interval) : intervalCache.getPrevInterval(interval);
        }

        if (isForward && cursorDate.getTime() === _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MAX_DATE"].getTime() || !isForward && cursorDate.getTime() === _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MIN_DATE"].getTime()) {
          return CalendarIteratorResult.FullRangeIterated;
        }

        cacheCursorDate = isForward ? this.cacheFilledEndDate : this.cacheFilledStartDate;
      }

      return CalendarIteratorResult.MaxCacheExtendCyclesReached;
    }
  }]);

  return CalendarCache;
}();

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheInterval.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheInterval.js ***!
  \******************************************************/
/*! exports provided: CalendarCacheInterval */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheInterval", function() { return CalendarCacheInterval; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");






var productName = 'scheduler';

var CalendarCacheInterval = /*#__PURE__*/function () {
  function CalendarCacheInterval(config) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CalendarCacheInterval);

    this.intervals = [];
    config && Object.assign(this, config);
    if (!this.calendar) throw new Error("Required attribute `calendar` is missing");
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(CalendarCacheInterval, [{
    key: "includeInterval",
    value: function includeInterval(interval) {
      if (this.intervals.indexOf(interval) == -1) {
        var copy = this.intervals.slice();
        copy.push(interval);
        return new CalendarCacheInterval({
          intervals: copy,
          calendar: this.calendar
        });
      } else return this;
    }
  }, {
    key: "combineWith",
    value: function combineWith(interval) {
      return new CalendarCacheInterval({
        intervals: this.intervals.concat(interval.intervals),
        calendar: this.calendar
      });
    }
  }, {
    key: "getIsWorking",
    value: function getIsWorking() {
      if (this.isWorking != null) return this.isWorking;
      var intervals = this.intervals = this.normalizeIntervals(this.intervals);
      return this.isWorking = intervals[0].isWorking;
    }
  }, {
    key: "normalizeIntervals",
    value: function normalizeIntervals(intervals) {
      var filtered = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_6__["stripDuplicates"])(intervals);
      filtered.sort(function (interval1, interval2) {
        return interval2.getPriorityField() - interval1.getPriorityField();
      });
      return filtered;
    }
  }]);

  return CalendarCacheInterval;
}();

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheIntervalMultiple.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheIntervalMultiple.js ***!
  \**************************************************************/
/*! exports provided: CalendarCacheIntervalMultiple */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheIntervalMultiple", function() { return CalendarCacheIntervalMultiple; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");
































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var productName = 'scheduler';

var CalendarCacheIntervalMultiple = /*#__PURE__*/function () {
  function CalendarCacheIntervalMultiple(config) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_29___default()(this, CalendarCacheIntervalMultiple);

    this.intervalGroups = [];
    config && Object.assign(this, config);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_30___default()(CalendarCacheIntervalMultiple, [{
    key: "combineWith",
    value: function combineWith(interval) {
      var copy = this.intervalGroups.slice();
      copy.push([interval.calendar, interval]);
      return new CalendarCacheIntervalMultiple({
        intervalGroups: copy
      });
    }
  }, {
    key: "getIsWorkingForEvery",
    value: function getIsWorkingForEvery() {
      if (this.isWorkingForEvery != null) return this.isWorkingForEvery;

      var _iterator = _createForOfIteratorHelper(this.getGroups()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default()(_step.value, 2),
              _calendar = _step$value[0],
              intervals = _step$value[1];

          if (!intervals[0].isWorking) return this.isWorkingForEvery = false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.isWorkingForEvery = true;
    }
  }, {
    key: "getIsWorkingForSome",
    value: function getIsWorkingForSome() {
      if (this.isWorkingForSome != null) return this.isWorkingForSome;

      var _iterator2 = _createForOfIteratorHelper(this.getGroups()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default()(_step2.value, 2),
              _calendar = _step2$value[0],
              intervals = _step2$value[1];

          if (intervals[0].isWorking) return this.isWorkingForSome = true;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return this.isWorkingForSome = false;
    }
  }, {
    key: "getCalendars",
    value: function getCalendars() {
      this.getGroups();
      return this.calendars;
    }
  }, {
    key: "isCalendarWorking",
    value: function isCalendarWorking(calendar) {
      return this.getCalendarsWorkStatus().get(calendar);
    }
  }, {
    key: "getCalendarsWorkStatus",
    value: function getCalendarsWorkStatus() {
      if (this.calendarsWorkStatus) return this.calendarsWorkStatus;
      var res = new Map();

      var _iterator3 = _createForOfIteratorHelper(this.getGroups()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default()(_step3.value, 2),
              calendar = _step3$value[0],
              intervals = _step3$value[1];

          res.set(calendar, intervals[0].isWorking);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return this.calendarsWorkStatus = res;
    }
  }, {
    key: "getCalendarsWorking",
    value: function getCalendarsWorking() {
      if (this.calendarsWorking) return this.calendarsWorking;
      var calendars = [];

      var _iterator4 = _createForOfIteratorHelper(this.getGroups()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default()(_step4.value, 2),
              calendar = _step4$value[0],
              intervals = _step4$value[1];

          if (intervals[0].isWorking) calendars.push(calendar);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return this.calendarsWorking = calendars;
    }
  }, {
    key: "getCalendarsNonWorking",
    value: function getCalendarsNonWorking() {
      if (this.calendarsNonWorking) return this.calendarsNonWorking;
      var calendars = [];

      var _iterator5 = _createForOfIteratorHelper(this.getGroups()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default()(_step5.value, 2),
              calendar = _step5$value[0],
              intervals = _step5$value[1];

          if (!intervals[0].isWorking) calendars.push(calendar);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return this.calendarsNonWorking = calendars;
    }
  }, {
    key: "getGroups",
    value: function getGroups() {
      if (this.intervalsByCalendar) return this.intervalsByCalendar;
      var calendars = this.calendars = [];
      var intervalsByCalendar = new Map();
      this.intervalGroups.forEach(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default()(_ref, 2),
            calendar = _ref2[0],
            interval = _ref2[1];

        var data = intervalsByCalendar.get(calendar);

        if (!data) {
          calendars.push(calendar);
          data = [];
          intervalsByCalendar.set(calendar, data);
        }

        data.push.apply(data, interval.intervals);
      });
      intervalsByCalendar.forEach(function (intervals, calendar) {
        var unique = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_31__["stripDuplicates"])(intervals);
        unique.sort(function (interval1, interval2) {
          return interval2.getPriorityField() - interval1.getPriorityField();
        });
        intervalsByCalendar.set(calendar, unique);
      });
      return this.intervalsByCalendar = intervalsByCalendar;
    }
  }]);

  return CalendarCacheIntervalMultiple;
}();

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheMultiple.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheMultiple.js ***!
  \******************************************************/
/*! exports provided: CalendarCacheMultiple, combineCalendars */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheMultiple", function() { return CalendarCacheMultiple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineCalendars", function() { return combineCalendars; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");
/* harmony import */ var _CalendarCache_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony import */ var _CalendarCacheIntervalMultiple_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./CalendarCacheIntervalMultiple.js */ "./lib/Engine/calendar/CalendarCacheIntervalMultiple.js");
/* harmony import */ var _IntervalCache_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./IntervalCache.js */ "./lib/Engine/calendar/IntervalCache.js");






























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CalendarCacheMultiple = /*#__PURE__*/function (_CalendarCache) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default()(CalendarCacheMultiple, _CalendarCache);

  var _super = _createSuper(CalendarCacheMultiple);

  function CalendarCacheMultiple(config) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default()(this, CalendarCacheMultiple);

    _this = _super.call(this, config);
    _this.calendarCaches = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_29__["stripDuplicates"])(_this.calendarCaches);
    _this.intervalCache = new _IntervalCache_js__WEBPACK_IMPORTED_MODULE_32__["IntervalCache"]({
      emptyInterval: new _CalendarCacheIntervalMultiple_js__WEBPACK_IMPORTED_MODULE_31__["CalendarCacheIntervalMultiple"](),
      combineIntervalsFn: function combineIntervalsFn(interval1, interval2) {
        return interval1.combineWith(interval2);
      }
    });
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25___default()(CalendarCacheMultiple, [{
    key: "fillCache",
    value: function fillCache(startDate, endDate) {
      var _this2 = this;

      this.calendarCaches.forEach(function (calendarCache) {
        calendarCache.fillCache(startDate, endDate);

        _this2.includeWrappingRangeFrom(calendarCache, startDate, endDate);
      });
    }
  }]);

  return CalendarCacheMultiple;
}(_CalendarCache_js__WEBPACK_IMPORTED_MODULE_30__["CalendarCache"]);
var COMBINED_CALENDARS_CACHE = new Map();
var combineCalendars = function combineCalendars(calendars) {
  var uniqueOnly = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_29__["stripDuplicates"])(calendars);
  if (uniqueOnly.length === 0) throw new Error("No calendars to combine");
  uniqueOnly.sort(function (calendar1, calendar2) {
    if (calendar1.internalId < calendar2.internalId) return -1;else return 1;
  });
  var hash = uniqueOnly.map(function (calendar) {
    return calendar.internalId + '/';
  }).join('');
  var versionsHash = uniqueOnly.map(function (calendar) {
    return calendar.version + '/';
  }).join('');
  var cached = COMBINED_CALENDARS_CACHE.get(hash);
  var res;
  if (cached && cached.versionsHash === versionsHash) res = cached.cache;else {
    res = new CalendarCacheMultiple({
      calendarCaches: uniqueOnly.map(function (calendar) {
        return calendar.calendarCache;
      })
    });
  }
  return res;
};

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheSingle.js":
/*!****************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheSingle.js ***!
  \****************************************************/
/*! exports provided: CalendarCacheSingle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheSingle", function() { return CalendarCacheSingle; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../vendor/later/later.js */ "./lib/Engine/vendor/later/later.js");
/* harmony import */ var _CalendarCache_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony import */ var _CalendarCacheInterval_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./CalendarCacheInterval.js */ "./lib/Engine/calendar/CalendarCacheInterval.js");
/* harmony import */ var _IntervalCache_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./IntervalCache.js */ "./lib/Engine/calendar/IntervalCache.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CalendarCacheSingle = /*#__PURE__*/function (_CalendarCache) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(CalendarCacheSingle, _CalendarCache);

  var _super = _createSuper(CalendarCacheSingle);

  function CalendarCacheSingle(config) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, CalendarCacheSingle);

    _this = _super.call(this, config);
    _this.staticIntervalsCached = false;
    if (!_this.unspecifiedTimeInterval) throw new Error("Required attribute `unspecifiedTimeInterval` is missing");
    _this.intervalCache = new _IntervalCache_js__WEBPACK_IMPORTED_MODULE_14__["IntervalCache"]({
      emptyInterval: new _CalendarCacheInterval_js__WEBPACK_IMPORTED_MODULE_13__["CalendarCacheInterval"]({
        intervals: [_this.unspecifiedTimeInterval],
        calendar: _this.calendar
      }),
      combineIntervalsFn: function combineIntervalsFn(interval1, interval2) {
        return interval1.combineWith(interval2);
      }
    });
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(CalendarCacheSingle, [{
    key: "fillCache",
    value: function fillCache(startDate, endDate) {
      var _this2 = this;

      if (!this.staticIntervalsCached) {
        this.cacheStaticIntervals();
        this.staticIntervalsCached = true;
      }

      if (this.parentCache) this.includeWrappingRangeFrom(this.parentCache, startDate, endDate);
      var startDateN = startDate.getTime();
      var endDateN = endDate.getTime();
      if (startDateN > endDateN) throw new Error("Invalid cache fill interval");
      this.forEachRecurrentInterval(function (interval) {
        var startSchedule = interval.getStartDateSchedule();
        var endSchedule = interval.getEndDateSchedule();
        var wrappingStartDate = startSchedule.prev(1, startDate);
        var wrappingEndDate = endSchedule.next(1, endDate);

        if (wrappingStartDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_11__["default"].NEVER && wrappingStartDate.getTime() === startDateN) {
          var wrappingStartDates = startSchedule.prev(2, startDate);
          if (wrappingStartDates !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_11__["default"].NEVER && wrappingStartDates.length === 2) wrappingStartDate = wrappingStartDates[1];
        }

        if (wrappingEndDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_11__["default"].NEVER && wrappingEndDate.getTime() === endDateN) {
          var wrappingEndDates = endSchedule.next(2, endDate);
          if (wrappingEndDates !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_11__["default"].NEVER && wrappingEndDates.length === 2) wrappingEndDate = wrappingEndDates[1];
        }

        var startDates = startSchedule.next(Infinity, wrappingStartDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_11__["default"].NEVER ? wrappingStartDate : startDate, wrappingEndDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_11__["default"].NEVER ? new Date(wrappingEndDate.getTime() - 1) : endDate);
        if (startDates === _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_11__["default"].NEVER) return;
        var endDates = endSchedule.next(Infinity, new Date(startDates[0].getTime() + 1), wrappingEndDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_11__["default"].NEVER ? wrappingEndDate : endDate);

        if (endDates.length > startDates.length) {
          endDates.length = startDates.length;
        } else if (endDates.length < startDates.length) {
          startDates.length = endDates.length;
        }

        startDates.forEach(function (startDate, index) {
          var recStartDate = startDate;
          var recEndDate = endDates[index];

          _this2.intervalCache.addInterval(recStartDate, recEndDate, function (existingCacheInterval) {
            return existingCacheInterval.includeInterval(interval);
          });
        });
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.staticIntervalsCached = false;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(CalendarCacheSingle.prototype), "clear", this).call(this);
    }
  }, {
    key: "cacheStaticIntervals",
    value: function cacheStaticIntervals() {
      var _this3 = this;

      this.forEachStaticInterval(function (interval) {
        _this3.intervalCache.addInterval(interval.startDate, interval.endDate, function (existingCacheInterval) {
          return existingCacheInterval.includeInterval(interval);
        });
      });
    }
  }, {
    key: "forEachStaticInterval",
    value: function forEachStaticInterval(func) {
      this.intervalStore.forEach(function (interval) {
        if (interval.isStatic()) func(interval);
      });
    }
  }, {
    key: "forEachRecurrentInterval",
    value: function forEachRecurrentInterval(func) {
      this.intervalStore.forEach(function (interval) {
        if (interval.isRecurrent()) func(interval);
      });
    }
  }]);

  return CalendarCacheSingle;
}(_CalendarCache_js__WEBPACK_IMPORTED_MODULE_12__["CalendarCache"]);

/***/ }),

/***/ "./lib/Engine/calendar/CalendarIntervalMixin.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarIntervalMixin.js ***!
  \******************************************************/
/*! exports provided: CalendarIntervalMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarIntervalMixin", function() { return CalendarIntervalMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../vendor/later/later.js */ "./lib/Engine/vendor/later/later.js");
/* harmony import */ var _quark_model_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../quark/model/mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var CalendarIntervalMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CalendarIntervalMixin, _Mixin);

  var _super = _createSuper(CalendarIntervalMixin);

  function CalendarIntervalMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CalendarIntervalMixin);

    return _super.apply(this, arguments);
  }

  return CalendarIntervalMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_quark_model_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_10__["AbstractPartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var CalendarIntervalMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CalendarIntervalMixin, _base);

    var _super2 = _createSuper(CalendarIntervalMixin);

    function CalendarIntervalMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CalendarIntervalMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CalendarIntervalMixin, [{
      key: "getCalendar",
      value: function getCalendar() {
        return this.stores[0].calendar;
      }
    }, {
      key: "resetPriority",
      value: function resetPriority() {
        this.priorityField = null;
        this.getCalendar().getDepth();
      }
    }, {
      key: "getPriorityField",
      value: function getPriorityField() {
        if (this.priorityField != null) return this.priorityField;
        var base = 10000 + this.getCalendar().getDepth() * 100;
        var priority = this.priority;

        if (priority == null) {
          priority = this.isRecurrent() ? 20 : 30;
        }

        return this.priorityField = base + priority;
      }
    }, {
      key: "isRecurrent",
      value: function isRecurrent() {
        return Boolean(this.recurrentStartDate && this.recurrentEndDate && this.getStartDateSchedule() && this.getEndDateSchedule());
      }
    }, {
      key: "isStatic",
      value: function isStatic() {
        return Boolean(this.startDate && this.endDate);
      }
    }, {
      key: "parseDateSchedule",
      value: function parseDateSchedule(schedule) {
        if (schedule && schedule !== Object(schedule)) {
          schedule = _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_9__["default"].parse.text(schedule);

          if (schedule !== Object(schedule) || schedule.error > 0) {
            try {
              schedule = JSON.parse(schedule);
            } catch (e) {
              return null;
            }
          }
        }

        return schedule;
      }
    }, {
      key: "getStartDateSchedule",
      value: function getStartDateSchedule() {
        if (this.startDateSchedule) return this.startDateSchedule;
        var schedule = this.parseDateSchedule(this.recurrentStartDate);
        return this.startDateSchedule = _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_9__["default"].schedule(schedule);
      }
    }, {
      key: "getEndDateSchedule",
      value: function getEndDateSchedule() {
        if (this.endDateSchedule) return this.endDateSchedule;
        var schedule = this.parseDateSchedule(this.recurrentEndDate);
        return this.endDateSchedule = _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_9__["default"].schedule(schedule);
      }
    }], [{
      key: "fields",
      get: function get() {
        return ['name', {
          name: 'startDate',
          type: 'date',
          format: 'YYYY-MM-DDTHH:mm:ssZ'
        }, {
          name: 'endDate',
          type: 'date',
          format: 'YYYY-MM-DDTHH:mm:ssZ'
        }, 'recurrentStartDate', 'recurrentEndDate', {
          name: 'isWorking',
          type: 'boolean',
          defaultValue: false
        }, {
          name: 'priority',
          type: 'number'
        }];
      }
    }]);

    return CalendarIntervalMixin;
  }(base);

  return CalendarIntervalMixin;
}));

/***/ }),

/***/ "./lib/Engine/calendar/CalendarIntervalStore.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarIntervalStore.js ***!
  \******************************************************/
/*! exports provided: CalendarIntervalStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarIntervalStore", function() { return CalendarIntervalStore; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./CalendarIntervalMixin.js */ "./lib/Engine/calendar/CalendarIntervalMixin.js");
/* harmony import */ var _quark_store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../quark/store/mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var CalendarIntervalStore = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CalendarIntervalStore, _Mixin);

  var _super = _createSuper(CalendarIntervalStore);

  function CalendarIntervalStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CalendarIntervalStore);

    return _super.apply(this, arguments);
  }

  return CalendarIntervalStore;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_quark_store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["AbstractPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var CalendarIntervalStore = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CalendarIntervalStore, _base);

    var _super2 = _createSuper(CalendarIntervalStore);

    function CalendarIntervalStore() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CalendarIntervalStore);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CalendarIntervalStore, null, [{
      key: "defaultConfig",
      get: function get() {
        return {
          modelClass: _CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_9__["CalendarIntervalMixin"]
        };
      }
    }]);

    return CalendarIntervalStore;
  }(base);

  return CalendarIntervalStore;
}));

/***/ }),

/***/ "./lib/Engine/calendar/IntervalCache.js":
/*!**********************************************!*\
  !*** ./lib/Engine/calendar/IntervalCache.js ***!
  \**********************************************/
/*! exports provided: IntervalCache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalCache", function() { return IntervalCache; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _util_Types_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/Types.js */ "./lib/Engine/util/Types.js");
/* harmony import */ var _SortedMap_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./SortedMap.js */ "./lib/Engine/calendar/SortedMap.js");





var productName = 'scheduler';



var IntervalCache = /*#__PURE__*/function () {
  function IntervalCache(config) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, IntervalCache);

    this.points = new _SortedMap_js__WEBPACK_IMPORTED_MODULE_7__["SortedMap"](function (a, b) {
      return a.getTime() - b.getTime();
    });
    this.leftInfinityKey = _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MIN_DATE"];
    this.rightInfinityKey = _util_Constants_js__WEBPACK_IMPORTED_MODULE_5__["MAX_DATE"];
    Object.assign(this, config);
    if (this.emptyInterval === undefined || !this.combineIntervalsFn) throw new Error("All of `emptyPoint`, `combineIntervalsFn` are required");
    this.points.set(this.leftInfinityKey, this.emptyInterval);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(IntervalCache, [{
    key: "size",
    value: function size() {
      return this.points.size();
    }
  }, {
    key: "indexOf",
    value: function indexOf(date) {
      return this.points.indexOfKey(date);
    }
  }, {
    key: "getDateAt",
    value: function getDateAt(index) {
      return this.points.getKeyAt(index);
    }
  }, {
    key: "getPointAt",
    value: function getPointAt(index) {
      return this.points.getValueAt(index);
    }
  }, {
    key: "getIntervalOf",
    value: function getIntervalOf(date) {
      var edgeInclusion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _util_Types_js__WEBPACK_IMPORTED_MODULE_6__["EdgeInclusion"].Left;

      var _this$indexOf = this.indexOf(date),
          found = _this$indexOf.found,
          index = _this$indexOf.index;

      var startDateIndex;

      if (edgeInclusion === _util_Types_js__WEBPACK_IMPORTED_MODULE_6__["EdgeInclusion"].Left) {
        startDateIndex = found === _SortedMap_js__WEBPACK_IMPORTED_MODULE_7__["IndexPosition"].Exact ? index : index - 1;
      } else {
        startDateIndex = index - 1;
      }

      return this.getIntervalWithStartDateIndex(startDateIndex);
    }
  }, {
    key: "getPrevInterval",
    value: function getPrevInterval(interval) {
      if (interval.startDateIndex === 0) return null;
      return this.getIntervalWithStartDateIndex(interval.startDateIndex - 1);
    }
  }, {
    key: "getNextInterval",
    value: function getNextInterval(interval) {
      if (interval.startDateIndex >= this.size() - 1) return null;
      return this.getIntervalWithStartDateIndex(interval.startDateIndex + 1);
    }
  }, {
    key: "getIntervalWithStartDateIndex",
    value: function getIntervalWithStartDateIndex(startDateIndex) {
      return {
        startDateIndex: startDateIndex,
        startDate: this.getDateAt(startDateIndex),
        endDate: startDateIndex + 1 < this.size() ? this.getDateAt(startDateIndex + 1) : this.rightInfinityKey,
        cacheInterval: this.getPointAt(startDateIndex)
      };
    }
  }, {
    key: "addInterval",
    value: function addInterval(startDate, endDate, extendInterval) {
      var points = this.points;

      var _points$indexOfKey = points.indexOfKey(startDate),
          found = _points$indexOfKey.found,
          index = _points$indexOfKey.index;

      var curIndex;
      var lastUpdatedPoint;

      if (found == _SortedMap_js__WEBPACK_IMPORTED_MODULE_7__["IndexPosition"].Exact) {
        var inclusion = extendInterval(lastUpdatedPoint = points.getValueAt(index));
        points.setValueAt(index, inclusion);
        curIndex = index + 1;
      } else {
        var _inclusion = extendInterval(lastUpdatedPoint = points.getValueAt(index - 1));

        points.insertAt(index, startDate, _inclusion);
        curIndex = index + 1;
      }

      while (curIndex < points.size()) {
        var curDate = points.getKeyAt(curIndex);
        if (curDate.getTime() >= endDate.getTime()) break;

        var _inclusion2 = extendInterval(lastUpdatedPoint = points.getValueAt(curIndex));

        points.setValueAt(curIndex, _inclusion2);
        curIndex++;
      }

      if (curIndex === points.size()) {
        points.insertAt(points.size(), endDate, this.emptyInterval);
      } else {
        var _curDate = points.getKeyAt(curIndex);

        if (_curDate.getTime() === endDate.getTime()) {} else {
          points.insertAt(curIndex, endDate, lastUpdatedPoint);
        }
      }
    }
  }, {
    key: "includeWrappingRange",
    value: function includeWrappingRange(intervalCache, startDate, endDate) {
      var _this = this;

      var interval = intervalCache.getIntervalOf(startDate);

      while (interval) {
        this.addInterval(interval.startDate, interval.endDate, function (existingInterval) {
          return _this.combineIntervalsFn(existingInterval, interval.cacheInterval);
        });
        if (interval.endDate.getTime() > endDate.getTime()) break;
        interval = intervalCache.getNextInterval(interval);
      }
    }
  }, {
    key: "getSummary",
    value: function getSummary() {
      return this.points.map(function (label, date) {
        return {
          label: label,
          date: date
        };
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.points.clear();
      this.points.set(this.leftInfinityKey, this.emptyInterval);
    }
  }]);

  return IntervalCache;
}();

/***/ }),

/***/ "./lib/Engine/calendar/SortedMap.js":
/*!******************************************!*\
  !*** ./lib/Engine/calendar/SortedMap.js ***!
  \******************************************/
/*! exports provided: IndexPosition, SortedMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndexPosition", function() { return IndexPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortedMap", function() { return SortedMap; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/BinarySearch.js */ "./lib/Engine/util/BinarySearch.js");







var productName = 'scheduler';

var IndexPosition;

(function (IndexPosition) {
  IndexPosition[IndexPosition["Exact"] = 0] = "Exact";
  IndexPosition[IndexPosition["Next"] = 1] = "Next";
})(IndexPosition || (IndexPosition = {}));

var SortedMap = /*#__PURE__*/function () {
  function SortedMap(comparator) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, SortedMap);

    this.keys = [];
    this.values = [];

    this.comparator = comparator || function (a, b) {
      return a - b;
    };
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(SortedMap, [{
    key: "set",
    value: function set(key, value) {
      var search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_7__["binarySearch"])(key, this.keys, this.comparator);

      if (search.found) {
        this.values[search.index] = value;
      } else {
        this.keys.splice(search.index, 0, key);
        this.values.splice(search.index, 0, value);
      }

      return search.index;
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, key, value) {
      this.keys.splice(index, 0, key);
      this.values.splice(index, 0, value);
    }
  }, {
    key: "setValueAt",
    value: function setValueAt(index, value) {
      this.values[index] = value;
    }
  }, {
    key: "get",
    value: function get(key) {
      var search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_7__["binarySearch"])(key, this.keys, this.comparator);
      return search.found ? this.values[search.index] : undefined;
    }
  }, {
    key: "getEntryAt",
    value: function getEntryAt(index) {
      return index < this.keys.length ? {
        key: this.keys[index],
        value: this.values[index]
      } : undefined;
    }
  }, {
    key: "getKeyAt",
    value: function getKeyAt(index) {
      return this.keys[index];
    }
  }, {
    key: "getValueAt",
    value: function getValueAt(index) {
      return this.values[index];
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_7__["binarySearch"])(key, this.keys, this.comparator);
      if (search.found) this.deleteAt(search.index);
    }
  }, {
    key: "size",
    value: function size() {
      return this.keys.length;
    }
  }, {
    key: "deleteAt",
    value: function deleteAt(index) {
      this.keys.splice(index, 1);
      this.values.splice(index, 1);
    }
  }, {
    key: "indexOfKey",
    value: function indexOfKey(key) {
      var search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_7__["binarySearch"])(key, this.keys, this.comparator);
      return {
        found: search.found ? IndexPosition.Exact : IndexPosition.Next,
        index: search.index
      };
    }
  }, {
    key: "map",
    value: function map(func) {
      var keys = this.keys;
      var values = this.values;
      var result = [];

      for (var i = 0; i < keys.length; i++) {
        result.push(func(values[i], keys[i], i));
      }

      return result;
    }
  }, {
    key: "getAllEntries",
    value: function getAllEntries() {
      return this.map(function (value, key) {
        return {
          value: value,
          key: key
        };
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.keys.length = 0;
      this.values.length = 0;
    }
  }]);

  return SortedMap;
}();

/***/ }),

/***/ "./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js":
/*!*************************************************************!*\
  !*** ./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js ***!
  \*************************************************************/
/*! exports provided: UnspecifiedTimeIntervalModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnspecifiedTimeIntervalModel", function() { return UnspecifiedTimeIntervalModel; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./CalendarIntervalMixin.js */ "./lib/Engine/calendar/CalendarIntervalMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var UnspecifiedTimeIntervalModel = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(UnspecifiedTimeIntervalModel, _Mixin);

  var _super = _createSuper(UnspecifiedTimeIntervalModel);

  function UnspecifiedTimeIntervalModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, UnspecifiedTimeIntervalModel);

    return _super.apply(this, arguments);
  }

  return UnspecifiedTimeIntervalModel;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_9__["CalendarIntervalMixin"]], function (base) {
  var superProto = base.prototype;

  var UnspecifiedTimeIntervalModel = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(UnspecifiedTimeIntervalModel, _base);

    var _super2 = _createSuper(UnspecifiedTimeIntervalModel);

    function UnspecifiedTimeIntervalModel() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, UnspecifiedTimeIntervalModel);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(UnspecifiedTimeIntervalModel, [{
      key: "getCalendar",
      value: function getCalendar() {
        return this.calendar;
      }
    }, {
      key: "getPriorityField",
      value: function getPriorityField() {
        if (this.priorityField != null) return this.priorityField;
        return this.priorityField = this.getCalendar().getDepth();
      }
    }]);

    return UnspecifiedTimeIntervalModel;
  }(base);

  return UnspecifiedTimeIntervalModel;
}));

/***/ }),

/***/ "./lib/Engine/chrono/ChronoModelMixin.js":
/*!***********************************************!*\
  !*** ./lib/Engine/chrono/ChronoModelMixin.js ***!
  \***********************************************/
/*! exports provided: ChronoModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelMixin", function() { return ChronoModelMixin; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var ChronoModelMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(ChronoModelMixin, _Mixin);

  var _super = _createSuper(ChronoModelMixin);

  function ChronoModelMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ChronoModelMixin);

    return _super.apply(this, arguments);
  }

  return ChronoModelMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__["Entity"], _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"]], function (base) {
  var superProto = base.prototype;

  var ChronoModelMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(ChronoModelMixin, _base);

    var _super2 = _createSuper(ChronoModelMixin);

    function ChronoModelMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ChronoModelMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(ChronoModelMixin, [{
      key: "construct",
      value: function construct(config) {
        var _superProto$construct;

        this.constructor.exposeProperties();
        this.originalData = config = config || {};

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        (_superProto$construct = superProto.construct).call.apply(_superProto$construct, [this, config].concat(args));
      }
    }, {
      key: "copy",
      value: function copy() {
        var _this = this;

        var newId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var copy = superProto.copy.call(this, newId, deep);

        if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].isObject(deep) && !deep.skipFieldIdentifiers || !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].isObject(deep)) {
          this.forEachFieldIdentifier(function (identifier, fieldName) {
            copy[fieldName] = _this[fieldName];
          });
        }

        return copy;
      }
    }, {
      key: "applyValue",
      value: function applyValue(useProp, key, value, skipAccessors, field) {
        var chronoField = this.$entity.getField(key);
        if (chronoField) useProp = true;

        if (skipAccessors) {
          useProp = false;
        }

        superProto.applyValue.call(this, useProp, key, value, skipAccessors, field);
      }
    }, {
      key: "afterChange",
      value: function afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors) {
        var _this2 = this;

        if (!skipAccessors && Object.keys(wasSet).some(function (key) {
          return _this2.$entity.getField(key);
        })) {
          superProto.afterChange.call(this, toSet, wasSet, true, fromRelationUpdate, skipAccessors);
        } else {
          superProto.afterChange.apply(this, arguments);
        }
      }
    }, {
      key: "data",
      get: function get() {
        return this._data;
      },
      set: function set(data) {
        this._data = data;
        var fields = this.fields;

        for (var i = 0; i < fields.length; i++) {
          var field = fields[i];
          var chronoField = this.$entity.getField(field.name);

          if (chronoField) {
            var value = field.complexMapping ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].getPath(data, field.dataSource) : data[field.dataSource];
            this[field.name] = value;
          }
        }
      }
    }, {
      key: "$entityName",
      get: function get() {
        var className = this.constructor.name || this.$entity.name;
        var id = this.id;
        return "".concat(className).concat(id != null ? '-' + String(id) : '');
      }
    }]);

    return ChronoModelMixin;
  }(base);

  return ChronoModelMixin;
}));

/***/ }),

/***/ "./lib/Engine/chrono/Conflict.js":
/*!***************************************!*\
  !*** ./lib/Engine/chrono/Conflict.js ***!
  \***************************************/
/*! exports provided: ConflictSymbol, ConflictResolutionResult, ConflictEffect, ConflictResolution */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConflictSymbol", function() { return ConflictSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConflictResolutionResult", function() { return ConflictResolutionResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConflictEffect", function() { return ConflictEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConflictResolution", function() { return ConflictResolution; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../ChronoGraph/util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var ConflictSymbol = Symbol('ConflictSymbol');
var ConflictResolutionResult;

(function (ConflictResolutionResult) {
  ConflictResolutionResult["Cancel"] = "Cancel";
  ConflictResolutionResult["Resume"] = "Resume";
})(ConflictResolutionResult || (ConflictResolutionResult = {}));

var ConflictEffect = /*#__PURE__*/function (_Effect) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ConflictEffect, _Effect);

  var _super = _createSuper(ConflictEffect);

  function ConflictEffect() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ConflictEffect);

    _this = _super.apply(this, arguments);
    _this.handler = ConflictSymbol;
    return _this;
  }

  return ConflictEffect;
}(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_12__["Effect"]);

__decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_14__["prototypeValue"])(false)], ConflictEffect.prototype, "sync", void 0);

var ConflictResolution = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ConflictResolution, _Base);

  var _super2 = _createSuper(ConflictResolution);

  function ConflictResolution() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ConflictResolution);

    return _super2.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(ConflictResolution, [{
    key: "getDescription",
    value: function getDescription() {
      throw new Error('Abstract method');
    }
  }, {
    key: "resolve",
    value: function resolve() {
      throw new Error('Abstract method');
    }
  }]);

  return ConflictResolution;
}(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_13__["Base"]);

/***/ }),

/***/ "./lib/Engine/chrono/ModelFieldAtom.js":
/*!*********************************************!*\
  !*** ./lib/Engine/chrono/ModelFieldAtom.js ***!
  \*********************************************/
/*! exports provided: KEEP_TRYING_TO_RESOLVE, isSerializableEqual, ModelField, ModelReferenceField, ModelBucketField, IsChronoModelSymbol, ChronoModelFieldIdentifier, ChronoModelReferenceFieldQuark, MinimalChronoModelReferenceFieldQuark, ChronoModelReferenceFieldIdentifier, ChronoModelReferenceBucketFieldIdentifier, MinimalChronoModelFieldIdentifierSync, MinimalChronoModelFieldIdentifierGen, MinimalChronoModelFieldVariable, model_field, injectStaticFieldsProperty, getDecoratedModelFields, dateConverter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEEP_TRYING_TO_RESOLVE", function() { return KEEP_TRYING_TO_RESOLVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSerializableEqual", function() { return isSerializableEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelField", function() { return ModelField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelReferenceField", function() { return ModelReferenceField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelBucketField", function() { return ModelBucketField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsChronoModelSymbol", function() { return IsChronoModelSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelFieldIdentifier", function() { return ChronoModelFieldIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelReferenceFieldQuark", function() { return ChronoModelReferenceFieldQuark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelReferenceFieldQuark", function() { return MinimalChronoModelReferenceFieldQuark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelReferenceFieldIdentifier", function() { return ChronoModelReferenceFieldIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoModelReferenceBucketFieldIdentifier", function() { return ChronoModelReferenceBucketFieldIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelFieldIdentifierSync", function() { return MinimalChronoModelFieldIdentifierSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelFieldIdentifierGen", function() { return MinimalChronoModelFieldIdentifierGen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimalChronoModelFieldVariable", function() { return MinimalChronoModelFieldVariable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "model_field", function() { return model_field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectStaticFieldsProperty", function() { return injectStaticFieldsProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDecoratedModelFields", function() { return getDecoratedModelFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateConverter", function() { return dateConverter; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../ChronoGraph/replica/Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");
/* harmony import */ var _ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../ChronoGraph/replica/Reference.js */ "./lib/ChronoGraph/replica/Reference.js");
/* harmony import */ var _ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../ChronoGraph/replica/ReferenceBucket.js */ "./lib/ChronoGraph/replica/ReferenceBucket.js");
/* harmony import */ var _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../ChronoGraph/replica/Replica.js */ "./lib/ChronoGraph/replica/Replica.js");
/* harmony import */ var _ChronoGraph_schema_Field_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../ChronoGraph/schema/Field.js */ "./lib/ChronoGraph/schema/Field.js");
/* harmony import */ var _ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../ChronoGraph/util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var KEEP_TRYING_TO_RESOLVE = Symbol('KEEP_TRYING_TO_RESOLVE');
var isSerializableEqual = function isSerializableEqual(oldValue, newValue) {
  return oldValue === newValue || ((newValue === null || newValue === void 0 ? void 0 : newValue.isBase) ? this.serialize(newValue) : newValue) == ((oldValue === null || oldValue === void 0 ? void 0 : oldValue.isBase) ? this.serialize(oldValue) : oldValue);
};
var ModelField = /*#__PURE__*/function (_Field) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ModelField, _Field);

  var _super = _createSuper(ModelField);

  function ModelField() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, ModelField);

    _this = _super.apply(this, arguments);
    _this.modelFieldConfig = {};
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(ModelField, [{
    key: "getIdentifierClass",
    value: function getIdentifierClass(calculationFunction) {
      if (this.identifierCls) return this.identifierCls;
      if (!calculationFunction) return MinimalChronoModelFieldVariable;
      return Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["isGeneratorFunction"])(calculationFunction) ? MinimalChronoModelFieldIdentifierGen : MinimalChronoModelFieldIdentifierSync;
    }
  }]);

  return ModelField;
}(_ChronoGraph_schema_Field_js__WEBPACK_IMPORTED_MODULE_24__["Field"]);
var ModelReferenceField = /*#__PURE__*/function (_ReferenceField$mix) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ModelReferenceField, _ReferenceField$mix);

  var _super2 = _createSuper(ModelReferenceField);

  function ModelReferenceField() {
    var _this2;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, ModelReferenceField);

    _this2 = _super2.apply(this, arguments);
    _this2.identifierCls = ChronoModelReferenceFieldIdentifier;
    return _this2;
  }

  return ModelReferenceField;
}(_ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_21__["ReferenceField"].mix(ModelField));
var ModelBucketField = /*#__PURE__*/function (_ReferenceBucketField) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ModelBucketField, _ReferenceBucketField);

  var _super3 = _createSuper(ModelBucketField);

  function ModelBucketField() {
    var _this3;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, ModelBucketField);

    _this3 = _super3.apply(this, arguments);
    _this3.identifierCls = ChronoModelReferenceBucketFieldIdentifier;
    return _this3;
  }

  return ModelBucketField;
}(_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_22__["ReferenceBucketField"].mix(_ChronoGraph_schema_Field_js__WEBPACK_IMPORTED_MODULE_24__["Field"]));
var IsChronoModelSymbol = Symbol('IsChronoModelSymbol');
var ChronoModelFieldIdentifier = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ChronoModelFieldIdentifier, _Mixin);

  var _super4 = _createSuper(ChronoModelFieldIdentifier);

  function ChronoModelFieldIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, ChronoModelFieldIdentifier);

    return _super4.apply(this, arguments);
  }

  return ChronoModelFieldIdentifier;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_18__["Mixin"])([_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_20__["FieldIdentifier"]], function (base) {
  var superProto = base.prototype;

  var ChronoModelFieldIdentifier = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ChronoModelFieldIdentifier, _base);

    var _super5 = _createSuper(ChronoModelFieldIdentifier);

    function ChronoModelFieldIdentifier() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, ChronoModelFieldIdentifier);

      return _super5.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(ChronoModelFieldIdentifier, [{
      key: IsChronoModelSymbol,
      value: function value() {}
    }, {
      key: "getFromGraph",
      value: function getFromGraph(graph) {
        if (graph) {
          if (graph.readMode === _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_23__["ReadMode"].CurrentOrProposedOrPrevious) {
            if (this.sync) return graph.get(this);else return graph.activeTransaction.readCurrentOrProposedOrPrevious(this);
          }

          return superProto.getFromGraph.call(this, graph);
        } else return this.DATA;
      }
    }, {
      key: "write",
      value: function write(me, transaction, quark, proposedValue) {
        var _superProto$write;

        proposedValue = me.convert(proposedValue);

        for (var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
          args[_key - 4] = arguments[_key];
        }

        (_superProto$write = superProto.write).call.apply(_superProto$write, [this, me, transaction, quark, proposedValue].concat(args));
      }
    }, {
      key: "convert",
      value: function convert(value) {
        var field = this.field;
        var fieldDefinition = this.self.getFieldDefinition(field.name);

        if (fieldDefinition === null || fieldDefinition === void 0 ? void 0 : fieldDefinition.convert) {
          value = fieldDefinition.convert(value);
        } else if (field.converter) {
          value = field.converter(value, field);
        }

        return value;
      }
    }, {
      key: "equality",
      value: function equality(v1, v2) {
        if (v1 instanceof Date && v2 instanceof Date) return v1.getTime() === v2.getTime();
        return v1 === v2;
      }
    }]);

    return ChronoModelFieldIdentifier;
  }(base);

  __decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["prototypeValue"])(false)], ChronoModelFieldIdentifier.prototype, "sync", void 0);

  return ChronoModelFieldIdentifier;
}));
var ChronoModelReferenceFieldQuark = /*#__PURE__*/function (_Mixin2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ChronoModelReferenceFieldQuark, _Mixin2);

  var _super6 = _createSuper(ChronoModelReferenceFieldQuark);

  function ChronoModelReferenceFieldQuark() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, ChronoModelReferenceFieldQuark);

    return _super6.apply(this, arguments);
  }

  return ChronoModelReferenceFieldQuark;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_18__["Mixin"])([_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_22__["ReferenceBucketQuark"]], function (base) {
  var superProto = base.prototype;

  var ChronoModelReferenceFieldQuark = /*#__PURE__*/function (_base2) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ChronoModelReferenceFieldQuark, _base2);

    var _super7 = _createSuper(ChronoModelReferenceFieldQuark);

    function ChronoModelReferenceFieldQuark() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, ChronoModelReferenceFieldQuark);

      return _super7.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(ChronoModelReferenceFieldQuark, [{
      key: "setValue",
      value: function setValue(value) {
        superProto.setValue.call(this, value);
        if (value !== _ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_17__["TombStone"]) this.identifier.DATA = value;
      }
    }]);

    return ChronoModelReferenceFieldQuark;
  }(base);

  return ChronoModelReferenceFieldQuark;
}));
var MinimalChronoModelReferenceFieldQuark = ChronoModelReferenceFieldQuark.mix(_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_22__["MinimalReferenceBucketQuark"]);
var ChronoModelReferenceFieldIdentifier = /*#__PURE__*/function (_ReferenceIdentifier$) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ChronoModelReferenceFieldIdentifier, _ReferenceIdentifier$);

  var _super8 = _createSuper(ChronoModelReferenceFieldIdentifier);

  function ChronoModelReferenceFieldIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, ChronoModelReferenceFieldIdentifier);

    return _super8.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(ChronoModelReferenceFieldIdentifier, [{
    key: "buildProposedValue",
    value: function buildProposedValue(me, q, transaction) {
      var quark = q;
      var proposedValue = quark.proposedValue;

      if (proposedValue === null) {
        transaction.candidate.failedResolutionReferences.delete(quark.identifier);
        return null;
      }

      if (Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_18__["isInstanceOf"])(proposedValue, _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_19__["Entity"])) {
        if (me.hasBucket()) me.getBucket(proposedValue).addToBucket(transaction, me.self);
        transaction.candidate.failedResolutionReferences.delete(quark.identifier);
        return proposedValue;
      }

      var resolved = me.resolve(proposedValue);

      if (Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_18__["isInstanceOf"])(resolved, _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_19__["Entity"])) {
        if (me.hasBucket()) me.getBucket(resolved).addToBucket(transaction, me.self);
        transaction.candidate.failedResolutionReferences.delete(quark.identifier);
        return resolved;
      } else {
        transaction.candidate.failedResolutionReferences.set(quark.identifier, proposedValue);
        return null;
      }
    }
  }]);

  return ChronoModelReferenceFieldIdentifier;
}(_ChronoGraph_replica_Reference_js__WEBPACK_IMPORTED_MODULE_21__["ReferenceIdentifier"].mix(ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_20__["MinimalFieldIdentifierSync"])));

__decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["prototypeValue"])(true)], ChronoModelReferenceFieldIdentifier.prototype, "sync", void 0);

__decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["prototypeValue"])(MinimalChronoModelReferenceFieldQuark)], ChronoModelReferenceFieldIdentifier.prototype, "quarkClass", void 0);

var ChronoModelReferenceBucketFieldIdentifier = /*#__PURE__*/function (_ReferenceBucketIdent) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ChronoModelReferenceBucketFieldIdentifier, _ReferenceBucketIdent);

  var _super9 = _createSuper(ChronoModelReferenceBucketFieldIdentifier);

  function ChronoModelReferenceBucketFieldIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, ChronoModelReferenceBucketFieldIdentifier);

    return _super9.apply(this, arguments);
  }

  return ChronoModelReferenceBucketFieldIdentifier;
}(_ChronoGraph_replica_ReferenceBucket_js__WEBPACK_IMPORTED_MODULE_22__["ReferenceBucketIdentifier"].mix(ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_20__["MinimalFieldIdentifierSync"])));

__decorate([Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_25__["prototypeValue"])(true)], ChronoModelReferenceBucketFieldIdentifier.prototype, "sync", void 0);

var MinimalChronoModelFieldIdentifierSync = /*#__PURE__*/function (_ChronoModelFieldIden) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(MinimalChronoModelFieldIdentifierSync, _ChronoModelFieldIden);

  var _super10 = _createSuper(MinimalChronoModelFieldIdentifierSync);

  function MinimalChronoModelFieldIdentifierSync() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, MinimalChronoModelFieldIdentifierSync);

    return _super10.apply(this, arguments);
  }

  return MinimalChronoModelFieldIdentifierSync;
}(ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_20__["MinimalFieldIdentifierSync"]));
var MinimalChronoModelFieldIdentifierGen = /*#__PURE__*/function (_ChronoModelFieldIden2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(MinimalChronoModelFieldIdentifierGen, _ChronoModelFieldIden2);

  var _super11 = _createSuper(MinimalChronoModelFieldIdentifierGen);

  function MinimalChronoModelFieldIdentifierGen() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, MinimalChronoModelFieldIdentifierGen);

    return _super11.apply(this, arguments);
  }

  return MinimalChronoModelFieldIdentifierGen;
}(ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_20__["MinimalFieldIdentifierGen"]));
var MinimalChronoModelFieldVariable = /*#__PURE__*/function (_ChronoModelFieldIden3) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(MinimalChronoModelFieldVariable, _ChronoModelFieldIden3);

  var _super12 = _createSuper(MinimalChronoModelFieldVariable);

  function MinimalChronoModelFieldVariable() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, MinimalChronoModelFieldVariable);

    return _super12.apply(this, arguments);
  }

  return MinimalChronoModelFieldVariable;
}(ChronoModelFieldIdentifier.mix(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_20__["MinimalFieldVariable"]));
var model_field = function model_field() {
  var modelFieldConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var chronoFieldConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var chronoFieldClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ModelField;
  return function (target, propertyKey) {
    var decoratorFn = Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_19__["generic_field"])(Object.assign({
      modelFieldConfig: modelFieldConfig
    }, chronoFieldConfig), chronoFieldClass);
    decoratorFn(target, propertyKey);
    injectStaticFieldsProperty(target.constructor);
  };
};
var injectStaticFieldsProperty = function injectStaticFieldsProperty(prototype) {
  if (!prototype.hasOwnProperty('fields')) {
    Object.defineProperty(prototype, 'fields', {
      get: function get() {
        return getDecoratedModelFields(this);
      }
    });
  }
};
var getDecoratedModelFields = function getDecoratedModelFields(constr) {
  var proto = constr.prototype;
  var result = [];

  if (proto.hasOwnProperty('$entity')) {
    proto.$entity.ownFields.forEach(function (field) {
      if (field instanceof ModelField) {
        var config = field.modelFieldConfig || {};

        if (!config.convert && field.converter && field.converter !== dateConverter) {
          config.convert = field.converter;
        }

        result.push(Object.assign(config, {
          $chrono: field,
          name: field.name
        }));
      }
    });
  }

  return result;
};
var dateConverter = function dateConverter(date, field) {
  var _a, _b;

  if (date === null) {
    return null;
  }

  if (!(date instanceof Date)) {
    date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].parse(date, ((_a = field.modelFieldConfig) === null || _a === void 0 ? void 0 : _a.format) || ((_b = field.modelFieldConfig) === null || _b === void 0 ? void 0 : _b.dateFormat) || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].defaultParseFormat);
  }

  return date || undefined;
};

/***/ }),

/***/ "./lib/Engine/chrono/Replica.js":
/*!**************************************!*\
  !*** ./lib/Engine/chrono/Replica.js ***!
  \**************************************/
/*! exports provided: EngineRevision, EngineTransaction, EngineReplica */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EngineRevision", function() { return EngineRevision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EngineTransaction", function() { return EngineTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EngineReplica", function() { return EngineReplica; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Quark.js */ "./lib/ChronoGraph/chrono/Quark.js");
/* harmony import */ var _ChronoGraph_chrono_Revision_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Revision.js */ "./lib/ChronoGraph/chrono/Revision.js");
/* harmony import */ var _ChronoGraph_chrono_Transaction_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../../ChronoGraph/chrono/Transaction.js */ "./lib/ChronoGraph/chrono/Transaction.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../../ChronoGraph/replica/Replica.js */ "./lib/ChronoGraph/replica/Replica.js");
/* harmony import */ var _Conflict_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./Conflict.js */ "./lib/Engine/chrono/Conflict.js");
/* harmony import */ var _ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");


























































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_55___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';









var EngineRevision = /*#__PURE__*/function (_Revision) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_54___default()(EngineRevision, _Revision);

  var _super = _createSuper(EngineRevision);

  function EngineRevision() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53___default()(this, EngineRevision);

    _this = _super.apply(this, arguments);
    _this.failedResolutionReferences = new Map();
    return _this;
  }

  return EngineRevision;
}(_ChronoGraph_chrono_Revision_js__WEBPACK_IMPORTED_MODULE_59__["Revision"]);
var EngineTransaction = /*#__PURE__*/function (_Transaction) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_54___default()(EngineTransaction, _Transaction);

  var _super2 = _createSuper(EngineTransaction);

  function EngineTransaction() {
    var _this2;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53___default()(this, EngineTransaction);

    _this2 = _super2.apply(this, arguments);
    _this2.candidateClass = EngineRevision;
    return _this2;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_51___default()(EngineTransaction, [{
    key: "initialize",
    value: function initialize() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_52___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56___default()(EngineTransaction.prototype), "initialize", this)).call.apply(_get2, [this].concat(args));

      this.candidate.failedResolutionReferences = new Map(this.baseRevision.failedResolutionReferences);
    }
  }, {
    key: "addIdentifier",
    value: function addIdentifier(identifier, proposedValue) {
      var _get3;

      this.markFailedResolutionReferences();

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return (_get3 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_52___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56___default()(EngineTransaction.prototype), "addIdentifier", this)).call.apply(_get3, [this, identifier, proposedValue].concat(args));
    }
  }, {
    key: "markFailedResolutionReferences",
    value: function markFailedResolutionReferences() {
      var _this3 = this;

      this.candidate.failedResolutionReferences.forEach(function (failedResolutionValue, identifier) {
        _this3.write(identifier, failedResolutionValue);
      });
      this.candidate.failedResolutionReferences.clear();
    }
  }]);

  return EngineTransaction;
}(_ChronoGraph_chrono_Transaction_js__WEBPACK_IMPORTED_MODULE_60__["Transaction"]);
var EngineReplica = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_54___default()(EngineReplica, _Mixin);

  var _super3 = _createSuper(EngineReplica);

  function EngineReplica() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53___default()(this, EngineReplica);

    return _super3.apply(this, arguments);
  }

  return EngineReplica;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_61__["Mixin"])([_ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_62__["Replica"]], function (base) {
  var superProto = base.prototype;

  var EngineReplica = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_54___default()(EngineReplica, _base);

    var _super4 = _createSuper(EngineReplica);

    function EngineReplica() {
      var _this4;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53___default()(this, EngineReplica);

      _this4 = _super4.apply(this, arguments);
      _this4.baseRevision = EngineRevision.new();
      _this4.transactionClass = EngineTransaction;
      _this4.autoCommitMode = 'async';
      _this4.onComputationCycle = 'reject';
      _this4.silenceInitialCommit = true;
      _this4.ignoreInitialCommitComputationCycles = true;
      return _this4;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_51___default()(EngineReplica, [{
      key: "onPropagationProgressNotification",
      value: function onPropagationProgressNotification(notification) {
        if (this.enableProgressNotifications && this.project) this.project.trigger('progress', notification);
      }
    }, {
      key: "propagate",
      value: function propagate(args) {
        return this.commitAsync(args);
      }
    }, {
      key: "commitAsync",
      value: function () {
        var _commitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_49___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_47___default.a.mark(function _callee(args) {
          var replacedReplicaResult;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_47___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.project.trigger('beforeCommit');

                  if (this.isInitialCommit && this.ignoreInitialCommitComputationCycles) {
                    this._onComputationCycle = this._onComputationCycle || this.onComputationCycle;
                    this.onComputationCycle = 'ignore';
                  }

                  replacedReplicaResult = this.project.beforeCommitAsync();

                  if (!replacedReplicaResult) {
                    _context.next = 5;
                    break;
                  }

                  return _context.abrupt("return", replacedReplicaResult);

                case 5:
                  return _context.abrupt("return", superProto.commitAsync.call(this, args));

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function commitAsync(_x) {
          return _commitAsync.apply(this, arguments);
        }

        return commitAsync;
      }()
    }, {
      key: "finalizeCommitAsync",
      value: function () {
        var _finalizeCommitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_49___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_47___default.a.mark(function _callee2(transactionResult) {
          var project, entries, autoCommitStores, isInitialCommit, silenceInitialCommit, silenceCommit;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_47___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  project = this.project;

                  if (!(!project || project.isDestroyed)) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt("return");

                case 3:
                  entries = transactionResult.entries;
                  autoCommitStores = new Set();
                  if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_65__["default"].global.DEBUG) console.timeEnd('Time to visible');
                  isInitialCommit = this.isInitialCommit, silenceInitialCommit = this.silenceInitialCommit;
                  silenceCommit = isInitialCommit && silenceInitialCommit;

                  if (isInitialCommit) {
                    project.isInitialCommitPerformed = true;
                    if (this.ignoreInitialCommitComputationCycles) this.onComputationCycle = this._onComputationCycle;
                  }

                  project.isWritingData = true;
                  project.hasLoadedDataToCommit = false;
                  project.trigger('refresh', {
                    isInitialCommit: isInitialCommit
                  });
                  _context2.next = 14;
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      var _a, _b;

                      if (!project.isDestroyed && !transactionResult.transaction.rejectedWith) {
                        (_a = project.suspendChangesTracking) === null || _a === void 0 ? void 0 : _a.call(project);
                        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_65__["default"].global.DEBUG) console.time('Finalize propagation');
                        var records = new Set();

                        var _iterator = _createForOfIteratorHelper(entries.values()),
                            _step;

                        try {
                          for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            var quark = _step.value;
                            var identifier = quark.identifier;
                            var quarkValue = quark.getValue();
                            var field = identifier.field;
                            if (quark.isShadow() || !identifier[_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_64__["IsChronoModelSymbol"]] || quarkValue === _ChronoGraph_chrono_Quark_js__WEBPACK_IMPORTED_MODULE_58__["TombStone"] || field instanceof _ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_64__["ModelBucketField"]) continue;
                            var record = identifier.self;
                            var store = record.firstStore;

                            if (!records.has(record)) {
                              record.beginBatch();
                              records.add(record);
                            }

                            if ((store === null || store === void 0 ? void 0 : store.autoCommit) && !autoCommitStores.has(store)) {
                              store.suspendAutoCommit();
                              autoCommitStores.add(store);
                            }

                            record.set(field.name, quarkValue);
                          }
                        } catch (err) {
                          _iterator.e(err);
                        } finally {
                          _iterator.f();
                        }

                        var _iterator2 = _createForOfIteratorHelper(records),
                            _step2;

                        try {
                          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                            var _record = _step2.value;
                            _record.ignoreBag = silenceCommit;

                            _record.endBatch(silenceCommit, true);

                            _record.ignoreBag = false;
                          }
                        } catch (err) {
                          _iterator2.e(err);
                        } finally {
                          _iterator2.f();
                        }

                        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_65__["default"].global.DEBUG) console.timeEnd('Finalize propagation');
                        project.trigger('dataReady', {
                          records: records,
                          isInitialCommit: isInitialCommit
                        });
                        (_b = project.resumeChangesTracking) === null || _b === void 0 ? void 0 : _b.call(project, silenceCommit);
                        autoCommitStores.forEach(function (store) {
                          return store.resumeAutoCommit();
                        });

                        if (silenceCommit) {
                          [project.eventStore, project.dependencyStore, project.resourceStore, project.assignmentStore, project.calendarManagerStore].forEach(function (store) {
                            return store.acceptChanges();
                          });
                        }
                      }

                      project.isWritingData = false;
                      resolve();
                    }, 0);
                  });

                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function finalizeCommitAsync(_x2) {
          return _finalizeCommitAsync.apply(this, arguments);
        }

        return finalizeCommitAsync;
      }()
    }, {
      key: _Conflict_js__WEBPACK_IMPORTED_MODULE_63__["ConflictSymbol"],
      value: function () {
        var _value = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_49___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_47___default.a.mark(function _callee3(effect, transaction) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_47___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", this.project.onSchedulingConflict(effect, transaction));

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function value(_x3, _x4) {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_57__["RejectSymbol"],
      value: function value(effect, transaction) {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_52___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56___default()(EngineReplica.prototype), _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_57__["RejectSymbol"], this).call(this, effect, transaction);
      }
    }, {
      key: "isInitialCommit",
      get: function get() {
        return this.project.isInitialCommit || _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_52___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56___default()(EngineReplica.prototype), "isInitialCommit", this);
      },
      set: function set(value) {
        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_50___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_56___default()(EngineReplica.prototype), "isInitialCommit", value, this, true);
      }
    }]);

    return EngineReplica;
  }(base);

  return EngineReplica;
}));

/***/ }),

/***/ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js":
/*!***************************************************************!*\
  !*** ./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js ***!
  \***************************************************************/
/*! exports provided: AbstractPartOfProjectGenericMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectGenericMixin", function() { return AbstractPartOfProjectGenericMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var AbstractPartOfProjectGenericMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AbstractPartOfProjectGenericMixin, _Mixin);

  var _super = _createSuper(AbstractPartOfProjectGenericMixin);

  function AbstractPartOfProjectGenericMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, AbstractPartOfProjectGenericMixin);

    return _super.apply(this, arguments);
  }

  return AbstractPartOfProjectGenericMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__["Mixin"])([], function (base) {
  var superProto = base.prototype;

  var AbstractPartOfProjectGenericMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AbstractPartOfProjectGenericMixin, _base);

    var _super2 = _createSuper(AbstractPartOfProjectGenericMixin);

    function AbstractPartOfProjectGenericMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, AbstractPartOfProjectGenericMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(AbstractPartOfProjectGenericMixin, [{
      key: "commitAsync",
      value: function () {
        var _commitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", this.project.commitAsync());

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function commitAsync() {
          return _commitAsync.apply(this, arguments);
        }

        return commitAsync;
      }()
    }, {
      key: "calculateProject",
      value: function calculateProject() {
        throw new Error("Implement me");
      }
    }, {
      key: "setProject",
      value: function setProject(project) {
        return this.project = project;
      }
    }, {
      key: "getProject",
      value: function getProject() {
        if (this.project) return this.project;
        return this.setProject(this.calculateProject());
      }
    }, {
      key: "getAssignmentStore",
      value: function getAssignmentStore() {
        var project = this.getProject();
        return project === null || project === void 0 ? void 0 : project.assignmentStore;
      }
    }, {
      key: "getDependencyStore",
      value: function getDependencyStore() {
        var project = this.getProject();
        return project === null || project === void 0 ? void 0 : project.dependencyStore;
      }
    }, {
      key: "getEventStore",
      value: function getEventStore() {
        var project = this.getProject();
        return project === null || project === void 0 ? void 0 : project.eventStore;
      }
    }, {
      key: "getResourceStore",
      value: function getResourceStore() {
        var project = this.getProject();
        return project === null || project === void 0 ? void 0 : project.resourceStore;
      }
    }, {
      key: "getCalendarManagerStore",
      value: function getCalendarManagerStore() {
        var project = this.getProject();
        return project === null || project === void 0 ? void 0 : project.calendarManagerStore;
      }
    }, {
      key: "project",
      set: function set(project) {
        this.$project = project;
      },
      get: function get() {
        return this.$project;
      }
    }]);

    return AbstractPartOfProjectGenericMixin;
  }(base);

  return AbstractPartOfProjectGenericMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/ChronoPartOfProjectGenericMixin.js":
/*!*************************************************************!*\
  !*** ./lib/Engine/quark/ChronoPartOfProjectGenericMixin.js ***!
  \*************************************************************/
/*! exports provided: ChronoPartOfProjectGenericMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoPartOfProjectGenericMixin", function() { return ChronoPartOfProjectGenericMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var ChronoPartOfProjectGenericMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ChronoPartOfProjectGenericMixin, _Mixin);

  var _super = _createSuper(ChronoPartOfProjectGenericMixin);

  function ChronoPartOfProjectGenericMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ChronoPartOfProjectGenericMixin);

    return _super.apply(this, arguments);
  }

  return ChronoPartOfProjectGenericMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_9__["AbstractPartOfProjectGenericMixin"]], function (base) {
  var superProto = base.prototype;

  var ChronoPartOfProjectGenericMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ChronoPartOfProjectGenericMixin, _base);

    var _super2 = _createSuper(ChronoPartOfProjectGenericMixin);

    function ChronoPartOfProjectGenericMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ChronoPartOfProjectGenericMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ChronoPartOfProjectGenericMixin, [{
      key: "getGraph",
      value: function getGraph() {
        var project = this.getProject();
        return project === null || project === void 0 ? void 0 : project.getGraph();
      }
    }, {
      key: "getEventById",
      value: function getEventById(id) {
        var _a;

        return (_a = this.getEventStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }, {
      key: "getDependencyById",
      value: function getDependencyById(id) {
        var _a;

        return (_a = this.getDependencyStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }, {
      key: "getResourceById",
      value: function getResourceById(id) {
        var _a;

        return (_a = this.getResourceStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }, {
      key: "getAssignmentById",
      value: function getAssignmentById(id) {
        var _a;

        return (_a = this.getAssignmentStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }, {
      key: "getCalendarById",
      value: function getCalendarById(id) {
        var _a;

        return (_a = this.getCalendarManagerStore()) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }]);

    return ChronoPartOfProjectGenericMixin;
  }(base);

  return ChronoPartOfProjectGenericMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Engine/quark/CorePartOfProjectGenericMixin.js ***!
  \***********************************************************/
/*! exports provided: CorePartOfProjectGenericMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectGenericMixin", function() { return CorePartOfProjectGenericMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var CorePartOfProjectGenericMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CorePartOfProjectGenericMixin, _Mixin);

  var _super = _createSuper(CorePartOfProjectGenericMixin);

  function CorePartOfProjectGenericMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CorePartOfProjectGenericMixin);

    return _super.apply(this, arguments);
  }

  return CorePartOfProjectGenericMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_9__["AbstractPartOfProjectGenericMixin"]], function (base) {
  var superProto = base.prototype;

  var CorePartOfProjectGenericMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CorePartOfProjectGenericMixin, _base);

    var _super2 = _createSuper(CorePartOfProjectGenericMixin);

    function CorePartOfProjectGenericMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CorePartOfProjectGenericMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CorePartOfProjectGenericMixin, [{
      key: "getEventById",
      value: function getEventById(id) {
        var _a;

        return (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }, {
      key: "getDependencyById",
      value: function getDependencyById(id) {
        var _a;

        return (_a = this.dependencyStore) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }, {
      key: "getResourceById",
      value: function getResourceById(id) {
        var _a;

        return (_a = this.resourceStore) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }, {
      key: "getAssignmentById",
      value: function getAssignmentById(id) {
        var _a;

        return (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }, {
      key: "getCalendarById",
      value: function getCalendarById(id) {
        var _a;

        return (_a = this.calendarManagerStore) === null || _a === void 0 ? void 0 : _a.getById(id);
      }
    }, {
      key: "eventStore",
      get: function get() {
        var _a;

        return (_a = this.project) === null || _a === void 0 ? void 0 : _a.eventStore;
      }
    }, {
      key: "resourceStore",
      get: function get() {
        var _a;

        return (_a = this.project) === null || _a === void 0 ? void 0 : _a.resourceStore;
      }
    }, {
      key: "assignmentStore",
      get: function get() {
        var _a;

        return (_a = this.project) === null || _a === void 0 ? void 0 : _a.assignmentStore;
      }
    }, {
      key: "dependencyStore",
      get: function get() {
        var _a;

        return (_a = this.project) === null || _a === void 0 ? void 0 : _a.dependencyStore;
      }
    }, {
      key: "calendarManagerStore",
      get: function get() {
        var _a;

        return (_a = this.project) === null || _a === void 0 ? void 0 : _a.calendarManagerStore;
      }
    }]);

    return CorePartOfProjectGenericMixin;
  }(base);

  return CorePartOfProjectGenericMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/AbstractCalendarMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Engine/quark/model/AbstractCalendarMixin.js ***!
  \*********************************************************/
/*! exports provided: AbstractCalendarMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractCalendarMixin", function() { return AbstractCalendarMixin; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../calendar/CalendarIntervalStore.js */ "./lib/Engine/calendar/CalendarIntervalStore.js");
/* harmony import */ var _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../calendar/CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _calendar_CalendarCacheSingle_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../calendar/CalendarCacheSingle.js */ "./lib/Engine/calendar/CalendarCacheSingle.js");
/* harmony import */ var _calendar_UnspecifiedTimeIntervalModel_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../calendar/UnspecifiedTimeIntervalModel.js */ "./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';








var AbstractCalendarMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AbstractCalendarMixin, _Mixin);

  var _super = _createSuper(AbstractCalendarMixin);

  function AbstractCalendarMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, AbstractCalendarMixin);

    return _super.apply(this, arguments);
  }

  return AbstractCalendarMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__["Mixin"])([_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_18__["AbstractPartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var CalendarMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(CalendarMixin, _base);

    var _super2 = _createSuper(CalendarMixin);

    function CalendarMixin() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, CalendarMixin);

      _this = _super2.apply(this, arguments);
      _this.version = 1;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(CalendarMixin, [{
      key: "afterConstruct",
      value: function afterConstruct() {
        superProto.afterConstruct.call(this);
        var modelClass = this.getDefaultConfiguration().calendarIntervalModelClass || this.intervalStoreClass.defaultConfig.modelClass;
        this.intervalStore = new this.intervalStoreClass({
          calendar: this,
          modelClass: modelClass
        });

        if (this.intervals && this.intervals.length) {
          this.addIntervals(this.intervals);
        }
      }
    }, {
      key: "isDefault",
      value: function isDefault() {
        var project = this.getProject();

        if (project) {
          return this === project.defaultCalendar;
        }

        return false;
      }
    }, {
      key: "getDepth",
      value: function getDepth() {
        return this.childLevel + 1;
      }
    }, {
      key: "forEachAvailabilityInterval",
      value: function forEachAvailabilityInterval(options, func, scope) {
        return this.calendarCache.forEachAvailabilityInterval(options, func, scope);
      }
    }, {
      key: "accumulateWorkingTime",
      value: function accumulateWorkingTime(date, durationMs, isForward) {
        if (durationMs === 0) return {
          finalDate: new Date(date),
          remainingDurationInMs: 0
        };
        if (isNaN(durationMs)) throw new Error("Invalid duration");
        var finalDate = date;
        this.forEachAvailabilityInterval(isForward ? {
          startDate: date,
          isForward: true
        } : {
          endDate: date,
          isForward: false
        }, function (intervalStartDate, intervalEndDate, calendarCacheInterval) {
          var result = true;

          if (calendarCacheInterval.getIsWorking()) {
            var dstDiff = intervalStartDate.getTimezoneOffset() - intervalEndDate.getTimezoneOffset();
            var diff = intervalEndDate.getTime() - intervalStartDate.getTime() + dstDiff * 60 * 1000;

            if (durationMs <= diff) {
              finalDate = isForward ? new Date(intervalStartDate.getTime() + durationMs) : new Date(intervalEndDate.getTime() - durationMs);
              durationMs = 0;
              result = false;
            } else {
              finalDate = isForward ? intervalEndDate : intervalStartDate;
              durationMs -= diff;
            }
          }

          return result;
        });
        return {
          finalDate: new Date(finalDate),
          remainingDurationInMs: durationMs
        };
      }
    }, {
      key: "calculateDurationMs",
      value: function calculateDurationMs(startDate, endDate) {
        var duration = 0;
        this.forEachAvailabilityInterval({
          startDate: startDate,
          endDate: endDate
        }, function (intervalStartDate, intervalEndDate, calendarCacheInterval) {
          if (calendarCacheInterval.getIsWorking()) {
            var dstDiff = intervalStartDate.getTimezoneOffset() - intervalEndDate.getTimezoneOffset();
            duration += intervalEndDate.getTime() - intervalStartDate.getTime() + dstDiff * 60 * 1000;
          }
        });
        return duration;
      }
    }, {
      key: "calculateEndDate",
      value: function calculateEndDate(startDate, durationMs) {
        var isForward = durationMs >= 0;
        var res = this.accumulateWorkingTime(startDate, Math.abs(durationMs), isForward);
        return res.remainingDurationInMs === 0 ? res.finalDate : null;
      }
    }, {
      key: "calculateStartDate",
      value: function calculateStartDate(endDate, durationMs) {
        var isForward = durationMs <= 0;
        var res = this.accumulateWorkingTime(endDate, Math.abs(durationMs), isForward);
        return res.remainingDurationInMs === 0 ? res.finalDate : null;
      }
    }, {
      key: "skipNonWorkingTime",
      value: function skipNonWorkingTime(date) {
        var isForward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var workingDate;
        var res = this.forEachAvailabilityInterval(isForward ? {
          startDate: date,
          isForward: true
        } : {
          endDate: date,
          isForward: false
        }, function (intervalStartDate, intervalEndDate, calendarCacheInterval) {
          if (calendarCacheInterval.getIsWorking()) {
            workingDate = isForward ? intervalStartDate : intervalEndDate;
            return false;
          }
        });
        if (res === _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_13__["CalendarIteratorResult"].MaxRangeReached || res === _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_13__["CalendarIteratorResult"].FullRangeIterated) return 'empty_calendar';
        return workingDate ? new Date(workingDate) : new Date(date);
      }
    }, {
      key: "addInterval",
      value: function addInterval(interval) {
        return this.addIntervals([interval]);
      }
    }, {
      key: "addIntervals",
      value: function addIntervals(intervals) {
        this.bumpVersion();
        return this.intervalStore.add(intervals);
      }
    }, {
      key: "bumpVersion",
      value: function bumpVersion() {
        this.clearCache();
        this.version++;
      }
    }, {
      key: "clearCache",
      value: function clearCache() {
        this.$calendarCache && this.$calendarCache.clear();
        this.$calendarCache = undefined;
      }
    }, {
      key: "resetPriorityOfAllIntervals",
      value: function resetPriorityOfAllIntervals() {
        this.traverse(function (calendar) {
          calendar.intervalStore.forEach(function (interval) {
            return interval.resetPriority();
          });
        });
      }
    }, {
      key: "insertChild",
      value: function insertChild(child, before) {
        var res = superProto.insertChild.call(this, child, before);

        if (!Array.isArray(res)) {
          res = [res];
        }

        res.forEach(function (r) {
          r.bumpVersion();
          r.resetPriorityOfAllIntervals();
        });
        return res;
      }
    }, {
      key: "joinProject",
      value: function joinProject() {
        superProto.joinProject.call(this);
        this.intervalStore.setProject(this.getProject());
      }
    }, {
      key: "leaveProject",
      value: function leaveProject() {
        superProto.leaveProject.call(this);
        this.intervalStore.setProject(null);
        this.intervalStore.destroy();
        this.clearCache();
      }
    }, {
      key: "isDayHoliday",
      value: function isDayHoliday(day) {
        var startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].clearTime(day),
            endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getNext(day, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_14__["TimeUnit"].Day);
        var hasWorkingTime = false;
        this.forEachAvailabilityInterval({
          startDate: startDate,
          endDate: endDate,
          isForward: true
        }, function (_intervalStartDate, _intervalEndDate, calendarCacheInterval) {
          hasWorkingTime = calendarCacheInterval.getIsWorking();
          return !hasWorkingTime;
        });
        return !hasWorkingTime;
      }
    }, {
      key: "getDailyHolidaysRanges",
      value: function getDailyHolidaysRanges(startDate, endDate) {
        var result = [];
        startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].clearTime(startDate);

        while (startDate < endDate) {
          if (this.isDayHoliday(startDate)) {
            result.push({
              startDate: startDate,
              endDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getStartOfNextDay(startDate, true, true)
            });
          }

          startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getNext(startDate, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_14__["TimeUnit"].Day);
        }

        return result;
      }
    }, {
      key: "getNonWorkingTimeRanges",
      value: function getNonWorkingTimeRanges(startDate, endDate) {
        var result = [];
        this.forEachAvailabilityInterval({
          startDate: startDate,
          endDate: endDate,
          isForward: true
        }, function (intervalStartDate, intervalEndDate, calendarCacheInterval) {
          if (!calendarCacheInterval.getIsWorking()) {
            var entry = calendarCacheInterval.intervals[0];
            result.push({
              name: entry.name,
              startDate: intervalStartDate,
              endDate: intervalEndDate
            });
          }
        });
        return result;
      }
    }, {
      key: "isWorkingTime",
      value: function isWorkingTime(startDate, endDate) {
        var workingTimeStart = this.skipNonWorkingTime(startDate);
        return workingTimeStart && workingTimeStart !== 'empty_calendar' ? workingTimeStart < endDate : false;
      }
    }, {
      key: "intervalStoreClass",
      get: function get() {
        return _calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_12__["CalendarIntervalStore"];
      }
    }, {
      key: "calendarCache",
      get: function get() {
        if (this.$calendarCache !== undefined) return this.$calendarCache;
        var unspecifiedTimeInterval = new _calendar_UnspecifiedTimeIntervalModel_js__WEBPACK_IMPORTED_MODULE_16__["UnspecifiedTimeIntervalModel"]({
          isWorking: this.unspecifiedTimeIsWorking
        });
        unspecifiedTimeInterval.calendar = this;
        return this.$calendarCache = new _calendar_CalendarCacheSingle_js__WEBPACK_IMPORTED_MODULE_15__["CalendarCacheSingle"]({
          calendar: this,
          unspecifiedTimeInterval: unspecifiedTimeInterval,
          intervalStore: this.intervalStore,
          parentCache: this.parent && !this.parent.isRoot ? this.parent.calendarCache : null
        });
      }
    }], [{
      key: "fields",
      get: function get() {
        return [{
          name: 'version',
          type: 'number'
        }, 'name', {
          name: 'unspecifiedTimeIsWorking',
          type: 'boolean',
          defaultValue: true
        }, 'intervals'];
      }
    }]);

    return CalendarMixin;
  }(base);

  return CalendarMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js":
/*!***************************************************************!*\
  !*** ./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js ***!
  \***************************************************************/
/*! exports provided: AbstractHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractHasAssignmentsMixin", function() { return AbstractHasAssignmentsMixin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var AbstractHasAssignmentsMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(AbstractHasAssignmentsMixin, _Mixin);

  var _super = _createSuper(AbstractHasAssignmentsMixin);

  function AbstractHasAssignmentsMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default()(this, AbstractHasAssignmentsMixin);

    return _super.apply(this, arguments);
  }

  return AbstractHasAssignmentsMixin;
}(Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_23__["Mixin"])([_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_24__["AbstractPartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var HasAssignmentsMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(HasAssignmentsMixin, _base);

    var _super2 = _createSuper(HasAssignmentsMixin);

    function HasAssignmentsMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default()(this, HasAssignmentsMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default()(HasAssignmentsMixin, [{
      key: "getAssignmentFor",
      value: function getAssignmentFor(resource) {
        var _iterator = _createForOfIteratorHelper(this.assigned),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var assignment = _step.value;
            if (assignment.resource === resource) return assignment;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return null;
      }
    }, {
      key: "isAssignedTo",
      value: function isAssignedTo(resource) {
        return Boolean(this.getAssignmentFor(resource));
      }
    }, {
      key: "assign",
      value: function () {
        var _assign = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee(resource) {
          var assignmentCls;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this.getAssignmentFor(resource)) {
                    _context.next = 2;
                    break;
                  }

                  throw new Error('Resource can\'t be assigned twice to the same task');

                case 2:
                  assignmentCls = this.project.assignmentStore.modelClass;
                  this.addAssignment(new assignmentCls({
                    event: this,
                    resource: resource
                  }));
                  return _context.abrupt("return", this.commitAsync());

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function assign(_x) {
          return _assign.apply(this, arguments);
        }

        return assign;
      }()
    }, {
      key: "unassign",
      value: function () {
        var _unassign = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee2(resource) {
          var assignment;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  assignment = this.getAssignmentFor(resource);

                  if (assignment) {
                    _context2.next = 3;
                    break;
                  }

                  throw new Error("Can't unassign resource `".concat(resource, "` from task `").concat(this, "` - resource is not assigned to the task!"));

                case 3:
                  this.removeAssignment(assignment);
                  return _context2.abrupt("return", this.commitAsync());

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function unassign(_x2) {
          return _unassign.apply(this, arguments);
        }

        return unassign;
      }()
    }, {
      key: "leaveProject",
      value: function leaveProject() {
        var _superProto$leaveProj;

        if (this.assigned) {
          var eventStore = this.getEventStore();
          this.assigned.forEach(function (assignment) {
            return eventStore.assignmentsForRemoval.add(assignment);
          });
        }

        (_superProto$leaveProj = superProto.leaveProject).call.apply(_superProto$leaveProj, [this].concat(Array.prototype.slice.call(arguments)));
      }
    }, {
      key: "remove",
      value: function remove() {
        if (this.parent) {
          var eventStore = this.getEventStore();
          superProto.remove.call(this);
          eventStore && eventStore.afterEventRemoval();
        } else {
          return superProto.remove.call(this);
        }
      }
    }, {
      key: "addAssignment",
      value: function addAssignment(assignment) {
        this.getProject().assignmentStore.add(assignment);
        return assignment;
      }
    }, {
      key: "removeAssignment",
      value: function removeAssignment(assignment) {
        this.getProject().assignmentStore.remove(assignment);
        return assignment;
      }
    }]);

    return HasAssignmentsMixin;
  }(base);

  return HasAssignmentsMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/AbstractProjectMixin.js":
/*!********************************************************!*\
  !*** ./lib/Engine/quark/model/AbstractProjectMixin.js ***!
  \********************************************************/
/*! exports provided: EventsWrapper, DelayableWrapper, AbstractProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventsWrapper", function() { return EventsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DelayableWrapper", function() { return DelayableWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractProjectMixin", function() { return AbstractProjectMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var EventsWrapper = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(EventsWrapper, _Mixin);

  var _super = _createSuper(EventsWrapper);

  function EventsWrapper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, EventsWrapper);

    return _super.apply(this, arguments);
  }

  return EventsWrapper;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__["Mixin"])([], _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_13__["default"]));
var DelayableWrapper = /*#__PURE__*/function (_Mixin2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(DelayableWrapper, _Mixin2);

  var _super2 = _createSuper(DelayableWrapper);

  function DelayableWrapper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, DelayableWrapper);

    return _super2.apply(this, arguments);
  }

  return DelayableWrapper;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__["Mixin"])([], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_12__["default"]));
var AbstractProjectMixin = /*#__PURE__*/function (_Mixin3) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AbstractProjectMixin, _Mixin3);

  var _super3 = _createSuper(AbstractProjectMixin);

  function AbstractProjectMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, AbstractProjectMixin);

    return _super3.apply(this, arguments);
  }

  return AbstractProjectMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__["Mixin"])([EventsWrapper, DelayableWrapper, _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"]], function (base) {
  var superProto = base.prototype;

  var AbstractProjectMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AbstractProjectMixin, _base);

    var _super4 = _createSuper(AbstractProjectMixin);

    function AbstractProjectMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, AbstractProjectMixin);

      return _super4.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(AbstractProjectMixin, [{
      key: "construct",
      value: function construct() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.isInitialCommitPerformed = false;
        this.isLoadingInlineData = false;
        this.isWritingData = false;
        this.hasLoadedDataToCommit = false;
        superProto.construct.call(this, config);
        this.silenceInitialCommit = 'silenceInitialCommit' in config ? config.silenceInitialCommit : true;
      }
    }, {
      key: "repopulateStore",
      value: function repopulateStore(store) {}
    }, {
      key: "repopulateReplica",
      value: function repopulateReplica() {}
    }, {
      key: "commitAsync",
      value: function () {
        var _commitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  throw new Error("Abstract method called");

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function commitAsync() {
          return _commitAsync.apply(this, arguments);
        }

        return commitAsync;
      }()
    }, {
      key: "isEngineReady",
      value: function isEngineReady() {
        throw new Error("Abstract method called");
      }
    }, {
      key: "isRepopulatingStores",
      get: function get() {
        return false;
      }
    }, {
      key: "isInitialCommit",
      get: function get() {
        return !this.isInitialCommitPerformed || this.hasLoadedDataToCommit;
      }
    }]);

    return AbstractProjectMixin;
  }(base);

  return AbstractProjectMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js":
/*!*************************************************************************!*\
  !*** ./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js ***!
  \*************************************************************************/
/*! exports provided: AbstractPartOfProjectModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectModelMixin", function() { return AbstractPartOfProjectModelMixin; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../store/mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../../Core/data/Model.js */ "./lib/Core/data/Model.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





var AbstractPartOfProjectModelMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(AbstractPartOfProjectModelMixin, _Mixin);

  var _super = _createSuper(AbstractPartOfProjectModelMixin);

  function AbstractPartOfProjectModelMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, AbstractPartOfProjectModelMixin);

    return _super.apply(this, arguments);
  }

  return AbstractPartOfProjectModelMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_14__["AbstractPartOfProjectGenericMixin"], _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_15__["default"]], function (base) {
  var superProto = base.prototype;

  var AbstractPartOfProjectModelMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(AbstractPartOfProjectModelMixin, _base);

    var _super2 = _createSuper(AbstractPartOfProjectModelMixin);

    function AbstractPartOfProjectModelMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, AbstractPartOfProjectModelMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(AbstractPartOfProjectModelMixin, [{
      key: "joinStore",
      value: function joinStore(store) {
        var joinedProject = false;

        if (Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["isInstanceOf"])(store, _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__["AbstractPartOfProjectStoreMixin"])) {
          var project = store.getProject();

          if (project && !project.isRepopulatingStores && !this.getProject()) {
            this.setProject(project);
            joinedProject = true;
          }
        }

        superProto.joinStore.call(this, store);
        if (joinedProject) this.joinProject();
      }
    }, {
      key: "unJoinStore",
      value: function unJoinStore(store) {
        var isReplacing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        superProto.unJoinStore.call(this, store, isReplacing);
        var project = this.getProject();

        if (project && !project.isDestroying && !project.isRepopulatingStores && Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["isInstanceOf"])(store, _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__["AbstractPartOfProjectStoreMixin"]) && project === store.getProject()) {
          this.leaveProject(isReplacing);
          this.setProject(null);
        }
      }
    }, {
      key: "joinProject",
      value: function joinProject() {}
    }, {
      key: "leaveProject",
      value: function leaveProject() {
        var isReplacing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      }
    }, {
      key: "calculateProject",
      value: function calculateProject() {
        var store = this.stores.find(function (s) {
          return Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["isInstanceOf"])(s, _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__["AbstractPartOfProjectStoreMixin"]) && !!s.getProject();
        });
        return store === null || store === void 0 ? void 0 : store.getProject();
      }
    }, {
      key: "setAsync",
      value: function () {
        var _setAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee(fieldName, value, silent) {
          var _a, result;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  result = this.set(fieldName, value, silent);
                  _context.next = 3;
                  return (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync();

                case 3:
                  return _context.abrupt("return", result);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function setAsync(_x, _x2, _x3) {
          return _setAsync.apply(this, arguments);
        }

        return setAsync;
      }()
    }, {
      key: "getAsync",
      value: function () {
        var _getAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee2(fieldName) {
          var _a;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync();

                case 2:
                  return _context2.abrupt("return", this.get(fieldName));

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function getAsync(_x4) {
          return _getAsync.apply(this, arguments);
        }

        return getAsync;
      }()
    }]);

    return AbstractPartOfProjectModelMixin;
  }(base);

  return AbstractPartOfProjectModelMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js ***!
  \***********************************************************************/
/*! exports provided: ChronoPartOfProjectModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoPartOfProjectModelMixin", function() { return ChronoPartOfProjectModelMixin; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../chrono/ChronoModelMixin.js */ "./lib/Engine/chrono/ChronoModelMixin.js");
/* harmony import */ var _ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../ChronoPartOfProjectGenericMixin.js */ "./lib/Engine/quark/ChronoPartOfProjectGenericMixin.js");
/* harmony import */ var _store_mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../store/mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






var ChronoPartOfProjectModelMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoPartOfProjectModelMixin, _Mixin);

  var _super = _createSuper(ChronoPartOfProjectModelMixin);

  function ChronoPartOfProjectModelMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoPartOfProjectModelMixin);

    return _super.apply(this, arguments);
  }

  return ChronoPartOfProjectModelMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__["Mixin"])([_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_13__["AbstractPartOfProjectModelMixin"], _ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_11__["ChronoPartOfProjectGenericMixin"], _chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_10__["ChronoModelMixin"]], function (base) {
  var superProto = base.prototype;

  var ChronoPartOfProjectModelMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoPartOfProjectModelMixin, _base);

    var _super2 = _createSuper(ChronoPartOfProjectModelMixin);

    function ChronoPartOfProjectModelMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoPartOfProjectModelMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ChronoPartOfProjectModelMixin, [{
      key: "joinProject",
      value: function joinProject() {
        this.getGraph().addEntity(this);
      }
    }, {
      key: "leaveProject",
      value: function leaveProject() {
        var isReplacing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        superProto.leaveProject.call(this, isReplacing);
        var replica = this.getGraph();
        replica.removeEntity(this);
      }
    }, {
      key: "getProject",
      value: function getProject() {
        return superProto.getProject.call(this);
      }
    }, {
      key: "calculateProject",
      value: function calculateProject() {
        var store = this.stores.find(function (s) {
          return Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_14__["isInstanceOf"])(s, _store_mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__["ChronoPartOfProjectStoreMixin"]) && !!s.getProject();
        });
        return store === null || store === void 0 ? void 0 : store.getProject();
      }
    }]);

    return ChronoPartOfProjectModelMixin;
  }(base);

  return ChronoPartOfProjectModelMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js ***!
  \*********************************************************************/
/*! exports provided: CorePartOfProjectModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectModelMixin", function() { return CorePartOfProjectModelMixin; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CorePartOfProjectModelMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(CorePartOfProjectModelMixin, _Mixin);

  var _super = _createSuper(CorePartOfProjectModelMixin);

  function CorePartOfProjectModelMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, CorePartOfProjectModelMixin);

    return _super.apply(this, arguments);
  }

  return CorePartOfProjectModelMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_15__["AbstractPartOfProjectModelMixin"], _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_13__["CorePartOfProjectGenericMixin"], _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"]], function (base) {
  var superProto = base.prototype;

  var CorePartOfProjectModelMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(CorePartOfProjectModelMixin, _base);

    var _super2 = _createSuper(CorePartOfProjectModelMixin);

    function CorePartOfProjectModelMixin() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, CorePartOfProjectModelMixin);

      _this = _super2.apply(this, arguments);
      _this.$isCalculating = false;
      _this.$changed = {};
      _this.$beforeChange = {};
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(CorePartOfProjectModelMixin, [{
      key: "joinProject",
      value: function joinProject() {
        this.invalidate();
      }
    }, {
      key: "leaveProject",
      value: function leaveProject() {
        var isReplacing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _a;

        superProto.leaveProject.call(this, isReplacing);
        (_a = this.project) === null || _a === void 0 ? void 0 : _a.bufferedCommitAsync();
      }
    }, {
      key: "invalidate",
      value: function invalidate() {
        var _a;

        (_a = this.project) === null || _a === void 0 ? void 0 : _a.invalidate(this);
      }
    }, {
      key: "getCurrentOrProposed",
      value: function getCurrentOrProposed(fieldName) {
        var _a;

        if (fieldName in this.$changed) {
          return this.$changed[fieldName];
        }

        return (_a = this.get(fieldName)) !== null && _a !== void 0 ? _a : null;
      }
    }, {
      key: "hasCurrentOrProposed",
      value: function hasCurrentOrProposed(fieldName) {
        return this.$changed[fieldName] != null || this.get(fieldName) != null;
      }
    }, {
      key: "propose",
      value: function propose(changes) {
        var _this2 = this;

        Object.keys(changes).forEach(function (field) {
          _this2.$changed[field] = changes[field];
        });
        this.invalidate();
      }
    }, {
      key: "setChanged",
      value: function setChanged(field, value) {
        var invalidate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var setData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var me = this;
        me.$changed[field] = value;

        if (setData) {
          if (!(field in me.$beforeChange)) {
            me.$beforeChange[field] = me.get(field);
          }

          me.setData(field, value);
        }

        invalidate && me.invalidate();
      }
    }, {
      key: "calculateInvalidated",
      value: function calculateInvalidated() {}
    }, {
      key: "finalizeInvalidated",
      value: function finalizeInvalidated() {
        var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var me = this;
        me.$isCalculating = true;

        if (me.$changed.__REFADR__) {
          me.$changed = Object.assign({}, me.$changed);
        }

        Object.keys(me.$beforeChange).forEach(function (fieldName) {
          me.setData(fieldName, me.$beforeChange[fieldName]);
        });
        me.set(me.$changed, null, silent);
        me.$changed = {};
        me.$beforeChange = {};
        me.$isCalculating = false;
      }
    }]);

    return CorePartOfProjectModelMixin;
  }(base);

  return CorePartOfProjectModelMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js ***!
  \***********************************************************************/
/*! exports provided: BaseAssignmentMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseAssignmentMixin", function() { return BaseAssignmentMixin; });
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var BaseAssignmentMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(BaseAssignmentMixin, _Mixin);

  var _super = _createSuper(BaseAssignmentMixin);

  function BaseAssignmentMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, BaseAssignmentMixin);

    return _super.apply(this, arguments);
  }

  return BaseAssignmentMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__["Mixin"])([_mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_12__["ChronoPartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var BaseAssignmentMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(BaseAssignmentMixin, _base);

    var _super2 = _createSuper(BaseAssignmentMixin);

    function BaseAssignmentMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, BaseAssignmentMixin);

      return _super2.apply(this, arguments);
    }

    return BaseAssignmentMixin;
  }(base);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_10__["generic_field"])({
    bucket: 'assigned',
    resolver: function resolver(id) {
      return this.getEventById(id);
    },
    modelFieldConfig: {
      serialize: function serialize(event) {
        return event === null || event === void 0 ? void 0 : event.id;
      },
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["isSerializableEqual"],
      persist: false
    }
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["ModelReferenceField"])], BaseAssignmentMixin.prototype, "event", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_10__["generic_field"])({
    bucket: 'assigned',
    resolver: function resolver(id) {
      return this.getResourceById(id);
    },
    modelFieldConfig: {
      serialize: function serialize(resource) {
        return resource === null || resource === void 0 ? void 0 : resource.id;
      },
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["isSerializableEqual"],
      persist: false
    }
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["ModelReferenceField"])], BaseAssignmentMixin.prototype, "resource", void 0);

  Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["injectStaticFieldsProperty"])(BaseAssignmentMixin);
  return BaseAssignmentMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js ***!
  \*********************************************************************/
/*! exports provided: BaseCalendarMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseCalendarMixin", function() { return BaseCalendarMixin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");
/* harmony import */ var _AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../AbstractCalendarMixin.js */ "./lib/Engine/quark/model/AbstractCalendarMixin.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var hasMixin = Symbol('CalendarMixin');
var BaseCalendarMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(BaseCalendarMixin, _Mixin);

  var _super = _createSuper(BaseCalendarMixin);

  function BaseCalendarMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, BaseCalendarMixin);

    return _super.apply(this, arguments);
  }

  return BaseCalendarMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_16__["AbstractCalendarMixin"], _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_15__["ChronoPartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var BaseCalendarMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(BaseCalendarMixin, _base);

    var _super2 = _createSuper(BaseCalendarMixin);

    function BaseCalendarMixin() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, BaseCalendarMixin);

      _this = _super2.apply(this, arguments);
      _this.version = 1;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(BaseCalendarMixin, [{
      key: hasMixin,
      value: function value() {}
    }]);

    return BaseCalendarMixin;
  }(base);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__["field"])({
    persistent: false
  })], BaseCalendarMixin.prototype, "version", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_14__["model_field"])({
    type: 'string'
  })], BaseCalendarMixin.prototype, "name", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_14__["model_field"])({
    type: 'boolean',
    defaultValue: true
  })], BaseCalendarMixin.prototype, "unspecifiedTimeIsWorking", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_14__["model_field"])()], BaseCalendarMixin.prototype, "intervals", void 0);

  return BaseCalendarMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseDependencyMixin.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseDependencyMixin.js ***!
  \***********************************************************************/
/*! exports provided: BaseDependencyMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseDependencyMixin", function() { return BaseDependencyMixin; });
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var BaseDependencyMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(BaseDependencyMixin, _Mixin);

  var _super = _createSuper(BaseDependencyMixin);

  function BaseDependencyMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, BaseDependencyMixin);

    return _super.apply(this, arguments);
  }

  return BaseDependencyMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__["Mixin"])([_mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_13__["ChronoPartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var BaseDependencyMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(BaseDependencyMixin, _base);

    var _super2 = _createSuper(BaseDependencyMixin);

    function BaseDependencyMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, BaseDependencyMixin);

      return _super2.apply(this, arguments);
    }

    return BaseDependencyMixin;
  }(base);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_10__["generic_field"])({
    bucket: 'outgoingDeps',
    resolver: function resolver(id) {
      return this.getEventById(id);
    },
    modelFieldConfig: {
      persist: true,
      serialize: function serialize(event) {
        return event === null || event === void 0 ? void 0 : event.id;
      },
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["isSerializableEqual"]
    }
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["ModelReferenceField"])], BaseDependencyMixin.prototype, "fromEvent", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_10__["generic_field"])({
    bucket: 'incomingDeps',
    resolver: function resolver(id) {
      return this.getEventById(id);
    },
    modelFieldConfig: {
      persist: true,
      serialize: function serialize(event) {
        return event === null || event === void 0 ? void 0 : event.id;
      },
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["isSerializableEqual"]
    }
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["ModelReferenceField"])], BaseDependencyMixin.prototype, "toEvent", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_11__["model_field"])({
    type: 'int',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_12__["DependencyType"].EndToStart
  })], BaseDependencyMixin.prototype, "type", void 0);

  return BaseDependencyMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js ***!
  \***********************************************************************/
/*! exports provided: Instruction, StartDateVar, EndDateVar, DurationVar, startDateFormula, endDateFormula, durationFormula, SEDGraphDescription, SEDForwardCycleResolutionContext, SEDBackwardCycleResolutionContext, SEDDispatcher, SEDDispatcherIdentifier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Instruction", function() { return Instruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StartDateVar", function() { return StartDateVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EndDateVar", function() { return EndDateVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DurationVar", function() { return DurationVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startDateFormula", function() { return startDateFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "endDateFormula", function() { return endDateFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "durationFormula", function() { return durationFormula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDGraphDescription", function() { return SEDGraphDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDForwardCycleResolutionContext", function() { return SEDForwardCycleResolutionContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDBackwardCycleResolutionContext", function() { return SEDBackwardCycleResolutionContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDDispatcher", function() { return SEDDispatcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEDDispatcherIdentifier", function() { return SEDDispatcherIdentifier; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _ChronoGraph_chrono_CycleResolver_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/CycleResolver.js */ "./lib/ChronoGraph/chrono/CycleResolver.js");
/* harmony import */ var _ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Identifier.js */ "./lib/ChronoGraph/chrono/Identifier.js");
/* harmony import */ var _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../../../ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Identifier.js */ "./lib/ChronoGraph/replica/Identifier.js");































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var Instruction;

(function (Instruction) {
  Instruction["KeepDuration"] = "KeepDuration";
  Instruction["KeepStartDate"] = "KeepStartDate";
  Instruction["KeepEndDate"] = "KeepEndDate";
})(Instruction || (Instruction = {}));

var StartDateVar = Symbol('StartDate');
var EndDateVar = Symbol('EndDate');
var DurationVar = Symbol('Duration');
var startDateFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_32__["Formula"].new({
  output: StartDateVar,
  inputs: new Set([DurationVar, EndDateVar])
});
var endDateFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_32__["Formula"].new({
  output: EndDateVar,
  inputs: new Set([DurationVar, StartDateVar])
});
var durationFormula = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_32__["Formula"].new({
  output: DurationVar,
  inputs: new Set([StartDateVar, EndDateVar])
});
var SEDGraphDescription = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_32__["CycleDescription"].new({
  variables: new Set([StartDateVar, EndDateVar, DurationVar]),
  formulas: new Set([startDateFormula, endDateFormula, durationFormula])
});
var SEDForwardCycleResolutionContext = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_32__["CycleResolution"].new({
  description: SEDGraphDescription,
  defaultResolutionFormulas: new Set([endDateFormula])
});
var SEDBackwardCycleResolutionContext = _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_32__["CycleResolution"].new({
  description: SEDGraphDescription,
  defaultResolutionFormulas: new Set([startDateFormula])
});
var SEDDispatcher = /*#__PURE__*/function (_CycleResolutionInput) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(SEDDispatcher, _CycleResolutionInput);

  var _super = _createSuper(SEDDispatcher);

  function SEDDispatcher() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, SEDDispatcher);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(SEDDispatcher, [{
    key: "addInstruction",
    value: function addInstruction(instruction) {
      if (instruction === Instruction.KeepStartDate) this.addKeepIfPossibleFlag(StartDateVar);
      if (instruction === Instruction.KeepEndDate) this.addKeepIfPossibleFlag(EndDateVar);
      if (instruction === Instruction.KeepDuration) this.addKeepIfPossibleFlag(DurationVar);
    }
  }]);

  return SEDDispatcher;
}(_ChronoGraph_chrono_CycleResolver_js__WEBPACK_IMPORTED_MODULE_30__["CycleResolutionInputChrono"]);
var SEDDispatcherIdentifier = /*#__PURE__*/function (_FieldIdentifier$mix) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_27___default()(SEDDispatcherIdentifier, _FieldIdentifier$mix);

  var _super2 = _createSuper(SEDDispatcherIdentifier);

  function SEDDispatcherIdentifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, SEDDispatcherIdentifier);

    return _super2.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(SEDDispatcherIdentifier, [{
    key: "equality",
    value: function equality(v1, v2) {
      var resolution1 = v1.resolution;
      var resolution2 = v2.resolution;
      return resolution1.get(StartDateVar) === resolution2.get(StartDateVar) && resolution1.get(EndDateVar) === resolution2.get(EndDateVar) && resolution1.get(DurationVar) === resolution2.get(DurationVar);
    }
  }]);

  return SEDDispatcherIdentifier;
}(_ChronoGraph_replica_Identifier_js__WEBPACK_IMPORTED_MODULE_33__["FieldIdentifier"].mix(_ChronoGraph_chrono_Identifier_js__WEBPACK_IMPORTED_MODULE_31__["CalculatedValueGen"]));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js":
/*!******************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js ***!
  \******************************************************************/
/*! exports provided: BaseEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseEventMixin", function() { return BaseEventMixin; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../../ChronoGraph/chrono/Effect.js */ "./lib/ChronoGraph/chrono/Effect.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../../ChronoGraph/cycle_resolver/CycleResolver.js */ "./lib/ChronoGraph/cycle_resolver/CycleResolver.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../../util/Functions.js */ "./lib/Engine/util/Functions.js");
/* harmony import */ var _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./BaseEventDispatcher.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventDispatcher.js");
/* harmony import */ var _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./HasCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js");
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var BaseEventMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(BaseEventMixin, _Mixin);

  var _super = _createSuper(BaseEventMixin);

  function BaseEventMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, BaseEventMixin);

    return _super.apply(this, arguments);
  }

  return BaseEventMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_16__["Mixin"])([_HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_24__["HasCalendarMixin"]], function (base) {
  var superProto = base.prototype;

  var BaseEventMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(BaseEventMixin, _base);

    var _super2 = _createSuper(BaseEventMixin);

    function BaseEventMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, BaseEventMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(BaseEventMixin, [{
      key: "calculateDispatcher",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateDispatcher(YIELD) {
        var proposed, cycleDispatcher, startDateProposedArgs, startInstruction, endDateProposedArgs, endInstruction, directionValue, durationProposedArgs, durationInstruction;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateDispatcher$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["ProposedOrPrevious"];

              case 2:
                proposed = _context.sent;
                return _context.delegateYield(this.prepareDispatcher(YIELD), "t0", 4);

              case 4:
                cycleDispatcher = _context.t0;
                _context.next = 7;
                return Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["ProposedArgumentsOf"])(this.$.startDate);

              case 7:
                startDateProposedArgs = _context.sent;
                startInstruction = startDateProposedArgs ? startDateProposedArgs[0] ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepDuration : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepEndDate : undefined;
                if (startInstruction) cycleDispatcher.addInstruction(startInstruction);
                _context.next = 12;
                return Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["ProposedArgumentsOf"])(this.$.endDate);

              case 12:
                endDateProposedArgs = _context.sent;
                endInstruction = endDateProposedArgs ? endDateProposedArgs[0] ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepDuration : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepStartDate : undefined;
                if (endInstruction) cycleDispatcher.addInstruction(endInstruction);
                _context.next = 17;
                return this.$.direction;

              case 17:
                directionValue = _context.sent;
                _context.next = 20;
                return Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["ProposedArgumentsOf"])(this.$.duration);

              case 20:
                durationProposedArgs = _context.sent;

                if (!durationProposedArgs) {
                  _context.next = 29;
                  break;
                }

                _context.t1 = durationProposedArgs[0];
                _context.next = _context.t1 === true ? 25 : _context.t1 === false ? 27 : 29;
                break;

              case 25:
                durationInstruction = _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepStartDate;
                return _context.abrupt("break", 29);

              case 27:
                durationInstruction = _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepEndDate;
                return _context.abrupt("break", 29);

              case 29:
                if (!durationInstruction && cycleDispatcher.hasProposedValue(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["DurationVar"])) {
                  durationInstruction = directionValue === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__["Direction"].Forward || directionValue === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__["Direction"].None ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepStartDate : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepEndDate;
                }

                if (durationInstruction) cycleDispatcher.addInstruction(durationInstruction);
                return _context.abrupt("return", cycleDispatcher);

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, calculateDispatcher, this);
      })
    }, {
      key: "prepareDispatcher",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function prepareDispatcher(Y) {
        var dispatcherClass, cycleDispatcher;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function prepareDispatcher$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatcherClass = this.dispatcherClass(Y);
                cycleDispatcher = dispatcherClass.new({
                  context: this.cycleResolutionContext(Y)
                });
                cycleDispatcher.collectInfo(Y, this.$.startDate, _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["StartDateVar"]);
                cycleDispatcher.collectInfo(Y, this.$.endDate, _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["EndDateVar"]);
                cycleDispatcher.collectInfo(Y, this.$.duration, _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["DurationVar"]);
                return _context2.abrupt("return", cycleDispatcher);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, prepareDispatcher, this);
      })
    }, {
      key: "cycleResolutionContext",
      value: function cycleResolutionContext(Y) {
        var direction = Y(this.$.direction);
        return direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__["Direction"].Forward || direction === _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__["Direction"].None ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["SEDForwardCycleResolutionContext"] : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["SEDBackwardCycleResolutionContext"];
      }
    }, {
      key: "dispatcherClass",
      value: function dispatcherClass(Y) {
        return _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["SEDDispatcher"];
      }
    }, {
      key: "buildProposedDispatcher",
      value: function buildProposedDispatcher(me, quark, transaction) {
        var dispatcher = this.dispatcherClass(transaction.onEffectSync).new({
          context: this.cycleResolutionContext(transaction.onEffectSync)
        });
        dispatcher.addPreviousValueFlag(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["StartDateVar"]);
        dispatcher.addPreviousValueFlag(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["EndDateVar"]);
        dispatcher.addPreviousValueFlag(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["DurationVar"]);
        return dispatcher;
      }
    }, {
      key: "skipNonWorkingTime",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function skipNonWorkingTime(date, isForward) {
        var calendar, skippingRes;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function skipNonWorkingTime$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$.effectiveCalendar;

              case 2:
                calendar = _context3.sent;

                if (date) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", null);

              case 5:
                skippingRes = calendar.skipNonWorkingTime(date, isForward);

                if (!(skippingRes instanceof Date)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", skippingRes);

              case 10:
                _context3.next = 12;
                return Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["Reject"])("Empty calendar");

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, skipNonWorkingTime, this);
      })
    }, {
      key: "skipWorkingTime",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function skipWorkingTime(date, isForward, duration, unit) {
        var durationUnit;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function skipWorkingTime$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$.durationUnit;

              case 2:
                durationUnit = _context4.sent;

                if (!(unit && unit !== durationUnit)) {
                  _context4.next = 6;
                  break;
                }

                return _context4.delegateYield(this.getProject().$convertDuration(duration, unit, durationUnit), "t0", 5);

              case 5:
                duration = _context4.t0;

              case 6:
                return _context4.delegateYield(this.calculateProjectedXDateWithDuration(date, isForward, duration), "t1", 7);

              case 7:
                return _context4.abrupt("return", _context4.t1);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, skipWorkingTime, this);
      })
    }, {
      key: "setStartDate",
      value: function setStartDate(date) {
        var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (this.graph) {
          this.graph.write(this.$.startDate, date, keepDuration);
          return this.graph.commitAsync();
        } else {
          this.$.startDate.DATA = date;
        }
      }
    }, {
      key: "writeStartDate",
      value: function writeStartDate(me, transaction, quark, date) {
        var keepDuration = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        if (!transaction.baseRevision.hasIdentifier(me) && date == null) return;
        var instruction = keepDuration ? _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepDuration : _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["Instruction"].KeepEndDate;
        me.constructor.prototype.write.call(this, me, transaction, quark, date, keepDuration);
      }
    }, {
      key: "calculateStartDate",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateStartDate() {
        var dispatch, formulaId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateStartDate$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$.dispatcher;

              case 2:
                dispatch = _context5.sent;
                formulaId = dispatch.resolution.get(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["StartDateVar"]);

                if (!(formulaId === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_17__["CalculateProposed"])) {
                  _context5.next = 9;
                  break;
                }

                return _context5.delegateYield(this.calculateStartDateProposed(), "t0", 6);

              case 6:
                return _context5.abrupt("return", _context5.t0);

              case 9:
                if (!(formulaId === _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["startDateFormula"].formulaId)) {
                  _context5.next = 14;
                  break;
                }

                return _context5.delegateYield(this.calculateStartDatePure(), "t1", 11);

              case 11:
                return _context5.abrupt("return", _context5.t1);

              case 14:
                throw new Error("Unknown formula for `startDate`");

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, calculateStartDate, this);
      })
    }, {
      key: "calculateStartDatePure",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateStartDatePure() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateStartDatePure$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.t0 = this;
                _context6.next = 3;
                return this.$.endDate;

              case 3:
                _context6.t1 = _context6.sent;
                _context6.next = 6;
                return this.$.duration;

              case 6:
                _context6.t2 = _context6.sent;
                return _context6.delegateYield(_context6.t0.calculateProjectedXDateWithDuration.call(_context6.t0, _context6.t1, false, _context6.t2), "t3", 8);

              case 8:
                return _context6.abrupt("return", _context6.t3);

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, calculateStartDatePure, this);
      })
    }, {
      key: "calculateStartDateProposed",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateStartDateProposed() {
        var startDate;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateStartDateProposed$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["ProposedOrPrevious"];

              case 2:
                startDate = _context7.sent;
                return _context7.delegateYield(this.skipNonWorkingTime(startDate, true), "t0", 4);

              case 4:
                return _context7.abrupt("return", _context7.t0);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, calculateStartDateProposed, this);
      })
    }, {
      key: "calculateProjectedXDateWithDuration",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateProjectedXDateWithDuration(baseDate, isForward, duration) {
        var durationUnit, calendar, project;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateProjectedXDateWithDuration$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.$.durationUnit;

              case 2:
                durationUnit = _context8.sent;
                _context8.next = 5;
                return this.$.effectiveCalendar;

              case 5:
                calendar = _context8.sent;
                project = this.getProject();

                if (!(!baseDate || Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_22__["isNotNumber"])(duration))) {
                  _context8.next = 9;
                  break;
                }

                return _context8.abrupt("return", null);

              case 9:
                isForward = isForward === undefined ? true : isForward;

                if (!isForward) {
                  _context8.next = 18;
                  break;
                }

                _context8.t0 = calendar;
                _context8.t1 = baseDate;
                return _context8.delegateYield(project.$convertDuration(duration, durationUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__["TimeUnit"].Millisecond), "t2", 14);

              case 14:
                _context8.t3 = _context8.t2;
                return _context8.abrupt("return", _context8.t0.calculateEndDate.call(_context8.t0, _context8.t1, _context8.t3));

              case 18:
                _context8.t4 = calendar;
                _context8.t5 = baseDate;
                return _context8.delegateYield(project.$convertDuration(duration, durationUnit, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__["TimeUnit"].Millisecond), "t6", 21);

              case 21:
                _context8.t7 = _context8.t6;
                return _context8.abrupt("return", _context8.t4.calculateStartDate.call(_context8.t4, _context8.t5, _context8.t7));

              case 23:
              case "end":
                return _context8.stop();
            }
          }
        }, calculateProjectedXDateWithDuration, this);
      })
    }, {
      key: "setEndDate",
      value: function setEndDate(date) {
        var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (this.graph) {
          this.graph.write(this.$.endDate, date, keepDuration);
          return this.graph.commitAsync();
        } else {
          this.$.endDate.DATA = date;
        }
      }
    }, {
      key: "writeEndDate",
      value: function writeEndDate(me, transaction, quark, date) {
        var keepDuration = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        if (!transaction.baseRevision.hasIdentifier(me) && date == null) return;
        me.constructor.prototype.write.call(this, me, transaction, quark, date, keepDuration);
      }
    }, {
      key: "calculateEndDate",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateEndDate() {
        var dispatch, formulaId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateEndDate$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.$.dispatcher;

              case 2:
                dispatch = _context9.sent;
                formulaId = dispatch.resolution.get(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["EndDateVar"]);

                if (!(formulaId === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_17__["CalculateProposed"])) {
                  _context9.next = 9;
                  break;
                }

                return _context9.delegateYield(this.calculateEndDateProposed(), "t0", 6);

              case 6:
                return _context9.abrupt("return", _context9.t0);

              case 9:
                if (!(formulaId === _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["endDateFormula"].formulaId)) {
                  _context9.next = 14;
                  break;
                }

                return _context9.delegateYield(this.calculateEndDatePure(), "t1", 11);

              case 11:
                return _context9.abrupt("return", _context9.t1);

              case 14:
                throw new Error("Unknown formula for `endDate`");

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, calculateEndDate, this);
      })
    }, {
      key: "calculateEndDatePure",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateEndDatePure() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateEndDatePure$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.t0 = this;
                _context10.next = 3;
                return this.$.startDate;

              case 3:
                _context10.t1 = _context10.sent;
                _context10.next = 6;
                return this.$.duration;

              case 6:
                _context10.t2 = _context10.sent;
                return _context10.delegateYield(_context10.t0.calculateProjectedXDateWithDuration.call(_context10.t0, _context10.t1, true, _context10.t2), "t3", 8);

              case 8:
                return _context10.abrupt("return", _context10.t3);

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, calculateEndDatePure, this);
      })
    }, {
      key: "calculateEndDateProposed",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateEndDateProposed() {
        var endDate;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateEndDateProposed$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["ProposedOrPrevious"];

              case 2:
                endDate = _context11.sent;
                return _context11.delegateYield(this.skipNonWorkingTime(endDate, false), "t0", 4);

              case 4:
                return _context11.abrupt("return", _context11.t0);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, calculateEndDateProposed, this);
      })
    }, {
      key: "getDuration",
      value: function getDuration(unit) {
        var duration = this.duration;
        return unit !== undefined ? this.getProject().convertDuration(duration, this.durationUnit, unit) : duration;
      }
    }, {
      key: "setDuration",
      value: function setDuration(duration, unit, keepStart) {
        if (this.graph) {
          if (duration !== undefined) {
            this.graph.write(this.$.duration, duration, unit, keepStart);
            return this.graph.commitAsync();
          }
        } else {
          this.$.duration.DATA = duration;
          if (unit != null) this.$.durationUnit.DATA = unit;
        }
      }
    }, {
      key: "setDurationUnit",
      value: function setDurationUnit(_value) {
        throw new Error("Use `setDuration` instead");
      }
    }, {
      key: "writeDuration",
      value: function writeDuration(me, transaction, quark, duration, unit) {
        var keepStart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
        if (duration < 0) duration = 0;
        if (!transaction.baseRevision.hasIdentifier(me) && duration == null) return;
        me.constructor.prototype.write.call(this, me, transaction, quark, duration, keepStart);
        if (unit != null) transaction.write(this.$.durationUnit, unit);
      }
    }, {
      key: "calculateDuration",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateDuration() {
        var dispatch, formulaId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateDuration$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.$.dispatcher;

              case 2:
                dispatch = _context12.sent;
                formulaId = dispatch.resolution.get(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["DurationVar"]);

                if (!(formulaId === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_17__["CalculateProposed"])) {
                  _context12.next = 9;
                  break;
                }

                return _context12.delegateYield(this.calculateDurationProposed(), "t0", 6);

              case 6:
                return _context12.abrupt("return", _context12.t0);

              case 9:
                if (!(formulaId === _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["durationFormula"].formulaId)) {
                  _context12.next = 14;
                  break;
                }

                return _context12.delegateYield(this.calculateDurationPure(), "t1", 11);

              case 11:
                return _context12.abrupt("return", _context12.t1);

              case 14:
                throw new Error("Unknown formula for `duration`");

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, calculateDuration, this);
      })
    }, {
      key: "calculateDurationPure",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateDurationPure() {
        var startDate, endDate;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateDurationPure$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.$.startDate;

              case 2:
                startDate = _context13.sent;
                _context13.next = 5;
                return this.$.endDate;

              case 5:
                endDate = _context13.sent;

                if (!(!startDate || !endDate)) {
                  _context13.next = 8;
                  break;
                }

                return _context13.abrupt("return", null);

              case 8:
                if (!(startDate > endDate)) {
                  _context13.next = 13;
                  break;
                }

                _context13.next = 11;
                return Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["Write"])(this.$.duration, 0, null);

              case 11:
                _context13.next = 15;
                break;

              case 13:
                return _context13.delegateYield(this.calculateProjectedDuration(startDate, endDate), "t0", 14);

              case 14:
                return _context13.abrupt("return", _context13.t0);

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, calculateDurationPure, this);
      })
    }, {
      key: "calculateDurationProposed",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateDurationProposed() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateDurationProposed$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return _ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["ProposedOrPrevious"];

              case 2:
                return _context14.abrupt("return", _context14.sent);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, calculateDurationProposed);
      })
    }, {
      key: "calculateProjectedDuration",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateProjectedDuration(startDate, endDate, durationUnit) {
        var calendar, project;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateProjectedDuration$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(!startDate || !endDate)) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return", null);

              case 2:
                if (durationUnit) {
                  _context15.next = 6;
                  break;
                }

                _context15.next = 5;
                return this.$.durationUnit;

              case 5:
                durationUnit = _context15.sent;

              case 6:
                _context15.next = 8;
                return this.$.effectiveCalendar;

              case 8:
                calendar = _context15.sent;
                project = this.getProject();
                return _context15.delegateYield(project.$convertDuration(calendar.calculateDurationMs(startDate, endDate), _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__["TimeUnit"].Millisecond, durationUnit), "t0", 11);

              case 11:
                return _context15.abrupt("return", _context15.t0);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, calculateProjectedDuration, this);
      })
    }, {
      key: "calculateEffectiveDuration",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function calculateEffectiveDuration() {
        var dispatch, effectiveDurationToUse, durationResolution;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function calculateEffectiveDuration$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.$.dispatcher;

              case 2:
                dispatch = _context16.sent;
                durationResolution = dispatch.resolution.get(_BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["DurationVar"]);

                if (!(durationResolution === _ChronoGraph_cycle_resolver_CycleResolver_js__WEBPACK_IMPORTED_MODULE_17__["CalculateProposed"])) {
                  _context16.next = 10;
                  break;
                }

                _context16.next = 7;
                return this.$.duration;

              case 7:
                effectiveDurationToUse = _context16.sent;
                _context16.next = 20;
                break;

              case 10:
                if (!(durationResolution === _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["durationFormula"].formulaId)) {
                  _context16.next = 20;
                  break;
                }

                _context16.t0 = this;
                _context16.next = 14;
                return Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["ProposedOrPreviousValueOf"])(this.$.startDate);

              case 14:
                _context16.t1 = _context16.sent;
                _context16.next = 17;
                return Object(_ChronoGraph_chrono_Effect_js__WEBPACK_IMPORTED_MODULE_15__["ProposedOrPreviousValueOf"])(this.$.endDate);

              case 17:
                _context16.t2 = _context16.sent;
                return _context16.delegateYield(_context16.t0.calculateProjectedDuration.call(_context16.t0, _context16.t1, _context16.t2), "t3", 19);

              case 19:
                effectiveDurationToUse = _context16.t3;

              case 20:
                return _context16.abrupt("return", effectiveDurationToUse);

              case 21:
              case "end":
                return _context16.stop();
            }
          }
        }, calculateEffectiveDuration, this);
      })
    }]);

    return BaseEventMixin;
  }(base);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_20__["model_field"])({
    type: 'date'
  }, {
    converter: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_20__["dateConverter"]
  })], BaseEventMixin.prototype, "startDate", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_20__["model_field"])({
    type: 'date'
  }, {
    converter: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_20__["dateConverter"]
  })], BaseEventMixin.prototype, "endDate", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_20__["model_field"])({
    type: 'number',
    allowNull: true
  })], BaseEventMixin.prototype, "duration", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_20__["model_field"])({
    type: 'string',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__["TimeUnit"].Day
  }, {
    converter: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].normalizeUnit
  })], BaseEventMixin.prototype, "durationUnit", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_20__["model_field"])({
    type: 'string',
    defaultValue: _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_21__["Direction"].Forward
  }, {
    sync: true
  })], BaseEventMixin.prototype, "direction", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__["field"])({
    identifierCls: _BaseEventDispatcher_js__WEBPACK_IMPORTED_MODULE_23__["SEDDispatcherIdentifier"]
  })], BaseEventMixin.prototype, "dispatcher", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_20__["model_field"])({
    type: 'boolean',
    defaultValue: false
  })], BaseEventMixin.prototype, "manuallyScheduled", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__["calculate"])('dispatcher')], BaseEventMixin.prototype, "calculateDispatcher", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__["build_proposed"])('dispatcher')], BaseEventMixin.prototype, "buildProposedDispatcher", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__["write"])('startDate')], BaseEventMixin.prototype, "writeStartDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__["calculate"])('startDate')], BaseEventMixin.prototype, "calculateStartDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__["write"])('endDate')], BaseEventMixin.prototype, "writeEndDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__["calculate"])('endDate')], BaseEventMixin.prototype, "calculateEndDate", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__["write"])('duration')], BaseEventMixin.prototype, "writeDuration", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_18__["calculate"])('duration')], BaseEventMixin.prototype, "calculateDuration", null);

  return BaseEventMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseHasAssignmentsMixin.js":
/*!***************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseHasAssignmentsMixin.js ***!
  \***************************************************************************/
/*! exports provided: BaseHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseHasAssignmentsMixin", function() { return BaseHasAssignmentsMixin; });
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");
/* harmony import */ var _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../AbstractHasAssignmentsMixin.js */ "./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var BaseHasAssignmentsMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(BaseHasAssignmentsMixin, _Mixin);

  var _super = _createSuper(BaseHasAssignmentsMixin);

  function BaseHasAssignmentsMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, BaseHasAssignmentsMixin);

    return _super.apply(this, arguments);
  }

  return BaseHasAssignmentsMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__["Mixin"])([_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_14__["BaseEventMixin"], _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_15__["AbstractHasAssignmentsMixin"]], function (base) {
  var superProto = base.prototype;

  var BaseHasAssignmentsMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(BaseHasAssignmentsMixin, _base);

    var _super2 = _createSuper(BaseHasAssignmentsMixin);

    function BaseHasAssignmentsMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, BaseHasAssignmentsMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(BaseHasAssignmentsMixin, [{
      key: "assignments",
      get: function get() {
        return this.assigned ? _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(this.assigned) : [];
      }
    }]);

    return BaseHasAssignmentsMixin;
  }(base);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_12__["generic_field"])({}, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_13__["ModelBucketField"])], BaseHasAssignmentsMixin.prototype, "assigned", void 0);

  return BaseHasAssignmentsMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js ***!
  \*********************************************************************/
/*! exports provided: BaseResourceMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseResourceMixin", function() { return BaseResourceMixin; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");
/* harmony import */ var _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./HasCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var BaseResourceMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(BaseResourceMixin, _Mixin);

  var _super = _createSuper(BaseResourceMixin);

  function BaseResourceMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, BaseResourceMixin);

    return _super.apply(this, arguments);
  }

  return BaseResourceMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_13__["Mixin"])([_HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_17__["HasCalendarMixin"], _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_16__["ChronoPartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var BaseResourceMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(BaseResourceMixin, _base);

    var _super2 = _createSuper(BaseResourceMixin);

    function BaseResourceMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, BaseResourceMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(BaseResourceMixin, [{
      key: "leaveProject",
      value: function leaveProject() {
        var isReplacing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (this.assigned && !isReplacing) {
          var resourceStore = this.getResourceStore();
          this.assigned.forEach(function (assignment) {
            return resourceStore.assignmentsForRemoval.add(assignment);
          });
        }

        superProto.leaveProject.call(this);
      }
    }, {
      key: "assignments",
      get: function get() {
        return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(this.assigned);
      }
    }]);

    return BaseResourceMixin;
  }(base);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_14__["generic_field"])({}, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_15__["ModelBucketField"])], BaseResourceMixin.prototype, "assigned", void 0);

  return BaseResourceMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/ChronoAbstractProjectMixin.js":
/*!******************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/ChronoAbstractProjectMixin.js ***!
  \******************************************************************************/
/*! exports provided: ChronoAbstractProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoAbstractProjectMixin", function() { return ChronoAbstractProjectMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../chrono/ChronoModelMixin.js */ "./lib/Engine/chrono/ChronoModelMixin.js");
/* harmony import */ var _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../chrono/Conflict.js */ "./lib/Engine/chrono/Conflict.js");
/* harmony import */ var _AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../AbstractProjectMixin.js */ "./lib/Engine/quark/model/AbstractProjectMixin.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var ChronoAbstractProjectMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(ChronoAbstractProjectMixin, _Mixin);

  var _super = _createSuper(ChronoAbstractProjectMixin);

  function ChronoAbstractProjectMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ChronoAbstractProjectMixin);

    return _super.apply(this, arguments);
  }

  return ChronoAbstractProjectMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_13__["ChronoModelMixin"], _AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_15__["AbstractProjectMixin"]], function (base) {
  var superProto = base.prototype;

  var ChronoAbstractProjectMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(ChronoAbstractProjectMixin, _base);

    var _super2 = _createSuper(ChronoAbstractProjectMixin);

    function ChronoAbstractProjectMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ChronoAbstractProjectMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(ChronoAbstractProjectMixin, [{
      key: "getGraph",
      value: function getGraph() {
        return this.replica;
      }
    }, {
      key: "beforeCommitAsync",
      value: function beforeCommitAsync() {
        return null;
      }
    }, {
      key: "commitAsync",
      value: function () {
        var _commitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", this.replica.commitAsync());

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function commitAsync() {
          return _commitAsync.apply(this, arguments);
        }

        return commitAsync;
      }()
    }, {
      key: "onSchedulingConflict",
      value: function () {
        var _onSchedulingConflict = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee2(conflict, transaction) {
          var _this = this;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!this.hasListener('schedulingConflict')) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return", new Promise(function (resolve, reject) {
                    _this.trigger('schedulingConflict', {
                      continueWithResolutionResult: resolve,
                      conflict: conflict
                    });
                  }));

                case 2:
                  return _context2.abrupt("return", _chrono_Conflict_js__WEBPACK_IMPORTED_MODULE_14__["ConflictResolutionResult"].Cancel);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function onSchedulingConflict(_x, _x2) {
          return _onSchedulingConflict.apply(this, arguments);
        }

        return onSchedulingConflict;
      }()
    }]);

    return ChronoAbstractProjectMixin;
  }(base);

  return ChronoAbstractProjectMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js":
/*!********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js ***!
  \********************************************************************/
/*! exports provided: HasCalendarMixin, CanCombineCalendarsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasCalendarMixin", function() { return HasCalendarMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CanCombineCalendarsMixin", function() { return CanCombineCalendarsMixin; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _calendar_CalendarCacheMultiple_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../../calendar/CalendarCacheMultiple.js */ "./lib/Engine/calendar/CalendarCacheMultiple.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../../util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");
/* harmony import */ var _mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../mixin/ChronoPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/ChronoPartOfProjectModelMixin.js");
/* harmony import */ var _BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./BaseCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js");


































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_32___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var HasCalendarMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29___default()(HasCalendarMixin, _Mixin);

  var _super = _createSuper(HasCalendarMixin);

  function HasCalendarMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default()(this, HasCalendarMixin);

    return _super.apply(this, arguments);
  }

  return HasCalendarMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_33__["Mixin"])([_mixin_ChronoPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_38__["ChronoPartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var HasCalendarMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29___default()(HasCalendarMixin, _base);

    var _super2 = _createSuper(HasCalendarMixin);

    function HasCalendarMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default()(this, HasCalendarMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27___default()(HasCalendarMixin, [{
      key: "writeCalendar",
      value: function writeCalendar(me, transaction, quark, calendar) {
        var calendarManagerStore = this.getCalendarManagerStore();
        var cal = calendar;

        if (calendar && calendarManagerStore && calendar instanceof _BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_39__["BaseCalendarMixin"] && !calendarManagerStore.includes(cal)) {
          calendarManagerStore.add(calendar);
        }

        me.constructor.prototype.write.call(this, me, transaction, quark, calendar);
      }
    }, {
      key: "resolveCalendar",
      value: function resolveCalendar(locator) {
        var _a;

        return (_a = this.getCalendarManagerStore()) === null || _a === void 0 ? void 0 : _a.getById(locator);
      }
    }, {
      key: "calculateEffectiveCalendar",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_25___default.a.mark(function calculateEffectiveCalendar() {
        var calendar, project;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_25___default.a.wrap(function calculateEffectiveCalendar$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$.calendar;

              case 2:
                calendar = _context.sent;

                if (calendar) {
                  _context.next = 8;
                  break;
                }

                project = this.getProject();
                _context.next = 7;
                return project.$.effectiveCalendar;

              case 7:
                calendar = _context.sent;

              case 8:
                _context.next = 10;
                return calendar.$.version;

              case 10:
                return _context.abrupt("return", calendar);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, calculateEffectiveCalendar, this);
      })
    }]);

    return HasCalendarMixin;
  }(base);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_34__["field"])()], HasCalendarMixin.prototype, "effectiveCalendar", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_34__["generic_field"])({
    modelFieldConfig: {
      persist: true,
      serialize: function serialize(calendar) {
        return calendar === null || calendar === void 0 ? void 0 : calendar.id;
      },
      isEqual: _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["isSerializableEqual"]
    },
    resolver: function resolver(locator) {
      return this.resolveCalendar(locator);
    },
    sync: true
  }, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["ModelReferenceField"])], HasCalendarMixin.prototype, "calendar", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_34__["write"])('calendar')], HasCalendarMixin.prototype, "writeCalendar", null);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_34__["calculate"])('effectiveCalendar')], HasCalendarMixin.prototype, "calculateEffectiveCalendar", null);

  Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_36__["injectStaticFieldsProperty"])(HasCalendarMixin);
  return HasCalendarMixin;
}));
var CanCombineCalendarsMixin = /*#__PURE__*/function (_Mixin2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29___default()(CanCombineCalendarsMixin, _Mixin2);

  var _super3 = _createSuper(CanCombineCalendarsMixin);

  function CanCombineCalendarsMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default()(this, CanCombineCalendarsMixin);

    return _super3.apply(this, arguments);
  }

  return CanCombineCalendarsMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_33__["Mixin"])([], function (base) {
  var superProto = base.prototype;

  var CanCombineCalendars = /*#__PURE__*/function (_base2) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29___default()(CanCombineCalendars, _base2);

    var _super4 = _createSuper(CanCombineCalendars);

    function CanCombineCalendars() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default()(this, CanCombineCalendars);

      _this = _super4.apply(this, arguments);
      _this.combinedcalendarscache = new Map();
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27___default()(CanCombineCalendars, [{
      key: "combineCalendars",
      value: function combineCalendars(calendars) {
        var uniqueOnly = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_37__["stripDuplicates"])(calendars);
        if (uniqueOnly.length === 0) throw new Error("No calendars to combine");
        uniqueOnly.sort(function (calendar1, calendar2) {
          if (calendar1.internalId < calendar2.internalId) return -1;else return 1;
        });
        var hash = uniqueOnly.map(function (calendar) {
          return calendar.internalId + '/';
        }).join('');
        var versionsHash = uniqueOnly.map(function (calendar) {
          return calendar.version + '/';
        }).join('');
        var cached = this.combinedcalendarscache.get(hash);
        var res;
        if (cached && cached.versionsHash === versionsHash) res = cached.cache;else {
          res = new _calendar_CalendarCacheMultiple_js__WEBPACK_IMPORTED_MODULE_35__["CalendarCacheMultiple"]({
            calendarCaches: uniqueOnly.map(function (calendar) {
              return calendar.calendarCache;
            })
          });
          this.combinedcalendarscache.set(hash, {
            versionsHash: versionsHash,
            cache: res
          });
        }
        return res;
      }
    }]);

    return CanCombineCalendars;
  }(base);

  return CanCombineCalendars;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/HasDependenciesMixin.js":
/*!************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/HasDependenciesMixin.js ***!
  \************************************************************************/
/*! exports provided: HasDependenciesMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasDependenciesMixin", function() { return HasDependenciesMixin; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var HasDependenciesMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(HasDependenciesMixin, _Mixin);

  var _super = _createSuper(HasDependenciesMixin);

  function HasDependenciesMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, HasDependenciesMixin);

    return _super.apply(this, arguments);
  }

  return HasDependenciesMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_15__["BaseEventMixin"]], function (base) {
  var superProto = base.prototype;

  var HasDependenciesMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(HasDependenciesMixin, _base);

    var _super2 = _createSuper(HasDependenciesMixin);

    function HasDependenciesMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, HasDependenciesMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(HasDependenciesMixin, [{
      key: "leaveProject",
      value: function leaveProject() {
        var eventStore = this.getEventStore();

        if (this.outgoingDeps) {
          this.outgoingDeps.forEach(function (dependency) {
            return eventStore.dependenciesForRemoval.add(dependency);
          });
        }

        if (this.incomingDeps) {
          this.incomingDeps.forEach(function (dependency) {
            return eventStore.dependenciesForRemoval.add(dependency);
          });
        }

        superProto.leaveProject.call(this);
      }
    }]);

    return HasDependenciesMixin;
  }(base);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__["generic_field"])({}, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_14__["ModelBucketField"])], HasDependenciesMixin.prototype, "outgoingDeps", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__["generic_field"])({}, _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_14__["ModelBucketField"])], HasDependenciesMixin.prototype, "incomingDeps", void 0);

  return HasDependenciesMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/HasSubEventsMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/HasSubEventsMixin.js ***!
  \*********************************************************************/
/*! exports provided: HasSubEventsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HasSubEventsMixin", function() { return HasSubEventsMixin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");





















function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var HasSubEventsMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default()(HasSubEventsMixin, _Mixin);

  var _super = _createSuper(HasSubEventsMixin);

  function HasSubEventsMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, HasSubEventsMixin);

    return _super.apply(this, arguments);
  }

  return HasSubEventsMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_20__["Mixin"])([_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_22__["BaseEventMixin"]], function (base) {
  var superProto = base.prototype;

  var HasSubEventsMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default()(HasSubEventsMixin, _base);

    var _super2 = _createSuper(HasSubEventsMixin);

    function HasSubEventsMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, HasSubEventsMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(HasSubEventsMixin, [{
      key: "hasSubEvents",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function hasSubEvents() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function hasSubEvents$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error("Abstract method `hasSubEvents` has been called");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, hasSubEvents);
      })
    }, {
      key: "subEventsIterable",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function subEventsIterable() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function subEventsIterable$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throw new Error("Abstract method `subEventsIterable` has been called");

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, subEventsIterable);
      })
    }, {
      key: "calculateStartDatePure",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function calculateStartDatePure() {
        var manuallyScheduled, hasSubEvents;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function calculateStartDatePure$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$.manuallyScheduled;

              case 2:
                manuallyScheduled = _context3.sent;
                return _context3.delegateYield(this.hasSubEvents(), "t0", 4);

              case 4:
                hasSubEvents = _context3.t0;

                if (!(!manuallyScheduled && hasSubEvents)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.delegateYield(this.calculateMinChildrenStartDate(), "t1", 7);

              case 7:
                return _context3.abrupt("return", _context3.t1);

              case 10:
                return _context3.delegateYield(superProto.calculateStartDatePure.call(this), "t2", 11);

              case 11:
                return _context3.abrupt("return", _context3.t2);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, calculateStartDatePure, this);
      })
    }, {
      key: "calculateEndDatePure",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function calculateEndDatePure() {
        var manuallyScheduled, hasSubEvents;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function calculateEndDatePure$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$.manuallyScheduled;

              case 2:
                manuallyScheduled = _context4.sent;
                return _context4.delegateYield(this.hasSubEvents(), "t0", 4);

              case 4:
                hasSubEvents = _context4.t0;

                if (!(!manuallyScheduled && hasSubEvents)) {
                  _context4.next = 10;
                  break;
                }

                return _context4.delegateYield(this.calculateMaxChildrenEndDate(), "t1", 7);

              case 7:
                return _context4.abrupt("return", _context4.t1);

              case 10:
                return _context4.delegateYield(superProto.calculateEndDatePure.call(this), "t2", 11);

              case 11:
                return _context4.abrupt("return", _context4.t2);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, calculateEndDatePure, this);
      })
    }, {
      key: "calculateStartDateProposed",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function calculateStartDateProposed() {
        var manuallyScheduled, hasSubEvents;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function calculateStartDateProposed$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$.manuallyScheduled;

              case 2:
                manuallyScheduled = _context5.sent;
                return _context5.delegateYield(this.hasSubEvents(), "t0", 4);

              case 4:
                hasSubEvents = _context5.t0;

                if (!(!manuallyScheduled && hasSubEvents)) {
                  _context5.next = 10;
                  break;
                }

                return _context5.delegateYield(this.calculateStartDatePure(), "t1", 7);

              case 7:
                return _context5.abrupt("return", _context5.t1);

              case 10:
                return _context5.delegateYield(superProto.calculateStartDateProposed.call(this), "t2", 11);

              case 11:
                return _context5.abrupt("return", _context5.t2);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, calculateStartDateProposed, this);
      })
    }, {
      key: "calculateEndDateProposed",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function calculateEndDateProposed() {
        var manuallyScheduled, hasSubEvents;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function calculateEndDateProposed$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.$.manuallyScheduled;

              case 2:
                manuallyScheduled = _context6.sent;
                return _context6.delegateYield(this.hasSubEvents(), "t0", 4);

              case 4:
                hasSubEvents = _context6.t0;

                if (!(!manuallyScheduled && hasSubEvents)) {
                  _context6.next = 10;
                  break;
                }

                return _context6.delegateYield(this.calculateEndDatePure(), "t1", 7);

              case 7:
                return _context6.abrupt("return", _context6.t1);

              case 10:
                return _context6.delegateYield(superProto.calculateEndDateProposed.call(this), "t2", 11);

              case 11:
                return _context6.abrupt("return", _context6.t2);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, calculateEndDateProposed, this);
      })
    }, {
      key: "calculateDurationProposed",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function calculateDurationProposed() {
        var manuallyScheduled, hasSubEvents;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function calculateDurationProposed$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.$.manuallyScheduled;

              case 2:
                manuallyScheduled = _context7.sent;
                return _context7.delegateYield(this.hasSubEvents(), "t0", 4);

              case 4:
                hasSubEvents = _context7.t0;

                if (!(!manuallyScheduled && hasSubEvents)) {
                  _context7.next = 10;
                  break;
                }

                return _context7.delegateYield(this.calculateDurationPure(), "t1", 7);

              case 7:
                return _context7.abrupt("return", _context7.t1);

              case 10:
                return _context7.delegateYield(superProto.calculateDurationProposed.call(this), "t2", 11);

              case 11:
                return _context7.abrupt("return", _context7.t2);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, calculateDurationProposed, this);
      })
    }, {
      key: "calculateMinChildrenStartDate",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function calculateMinChildrenStartDate() {
        var subEvents, subStartDates, _iterator, _step, subEvent, timestamp;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function calculateMinChildrenStartDate$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.delegateYield(this.subEventsIterable(), "t0", 1);

              case 1:
                subEvents = _context8.t0;
                subStartDates = [];
                _iterator = _createForOfIteratorHelper(subEvents);
                _context8.prev = 4;

                _iterator.s();

              case 6:
                if ((_step = _iterator.n()).done) {
                  _context8.next = 15;
                  break;
                }

                subEvent = _step.value;
                _context8.t1 = subStartDates;
                _context8.next = 11;
                return subEvent.$.startDate;

              case 11:
                _context8.t2 = _context8.sent;

                _context8.t1.push.call(_context8.t1, _context8.t2);

              case 13:
                _context8.next = 6;
                break;

              case 15:
                _context8.next = 20;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t3 = _context8["catch"](4);

                _iterator.e(_context8.t3);

              case 20:
                _context8.prev = 20;

                _iterator.f();

                return _context8.finish(20);

              case 23:
                timestamp = subStartDates.reduce(function (acc, subStartDate) {
                  return subStartDate ? Math.min(acc, subStartDate.getTime()) : acc;
                }, _util_Constants_js__WEBPACK_IMPORTED_MODULE_21__["MAX_DATE"].getTime());

                if (!(timestamp === _util_Constants_js__WEBPACK_IMPORTED_MODULE_21__["MIN_DATE"].getTime() || timestamp === _util_Constants_js__WEBPACK_IMPORTED_MODULE_21__["MAX_DATE"].getTime())) {
                  _context8.next = 26;
                  break;
                }

                return _context8.abrupt("return", null);

              case 26:
                return _context8.abrupt("return", new Date(timestamp));

              case 27:
              case "end":
                return _context8.stop();
            }
          }
        }, calculateMinChildrenStartDate, this, [[4, 17, 20, 23]]);
      })
    }, {
      key: "calculateMaxChildrenEndDate",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function calculateMaxChildrenEndDate() {
        var subEvents, subEndDates, _iterator2, _step2, subEvent, timestamp;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function calculateMaxChildrenEndDate$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.delegateYield(this.subEventsIterable(), "t0", 1);

              case 1:
                subEvents = _context9.t0;
                subEndDates = [];
                _iterator2 = _createForOfIteratorHelper(subEvents);
                _context9.prev = 4;

                _iterator2.s();

              case 6:
                if ((_step2 = _iterator2.n()).done) {
                  _context9.next = 15;
                  break;
                }

                subEvent = _step2.value;
                _context9.t1 = subEndDates;
                _context9.next = 11;
                return subEvent.$.endDate;

              case 11:
                _context9.t2 = _context9.sent;

                _context9.t1.push.call(_context9.t1, _context9.t2);

              case 13:
                _context9.next = 6;
                break;

              case 15:
                _context9.next = 20;
                break;

              case 17:
                _context9.prev = 17;
                _context9.t3 = _context9["catch"](4);

                _iterator2.e(_context9.t3);

              case 20:
                _context9.prev = 20;

                _iterator2.f();

                return _context9.finish(20);

              case 23:
                timestamp = subEndDates.reduce(function (acc, subEndDate) {
                  return subEndDate ? Math.max(acc, subEndDate.getTime()) : acc;
                }, _util_Constants_js__WEBPACK_IMPORTED_MODULE_21__["MIN_DATE"].getTime());

                if (!(timestamp === _util_Constants_js__WEBPACK_IMPORTED_MODULE_21__["MIN_DATE"].getTime() || timestamp === _util_Constants_js__WEBPACK_IMPORTED_MODULE_21__["MAX_DATE"].getTime())) {
                  _context9.next = 26;
                  break;
                }

                return _context9.abrupt("return", null);

              case 26:
                return _context9.abrupt("return", new Date(timestamp));

              case 27:
              case "end":
                return _context9.stop();
            }
          }
        }, calculateMaxChildrenEndDate, this, [[4, 17, 20, 23]]);
      })
    }]);

    return HasSubEventsMixin;
  }(base);

  return HasSubEventsMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js ***!
  \***********************************************************************/
/*! exports provided: SchedulerBasicEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerBasicEvent", function() { return SchedulerBasicEvent; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");
/* harmony import */ var _BaseHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./BaseHasAssignmentsMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseHasAssignmentsMixin.js");
/* harmony import */ var _HasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./HasDependenciesMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasDependenciesMixin.js");








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var SchedulerBasicEvent = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerBasicEvent, _Mixin);

  var _super = _createSuper(SchedulerBasicEvent);

  function SchedulerBasicEvent() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SchedulerBasicEvent);

    return _super.apply(this, arguments);
  }

  return SchedulerBasicEvent;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_7__["Mixin"])([_BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_8__["BaseEventMixin"], _BaseHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_9__["BaseHasAssignmentsMixin"], _HasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_10__["HasDependenciesMixin"]], function (base) {
  var superProto = base.prototype;

  var SchedulerBasicEvent = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerBasicEvent, _base);

    var _super2 = _createSuper(SchedulerBasicEvent);

    function SchedulerBasicEvent() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SchedulerBasicEvent);

      return _super2.apply(this, arguments);
    }

    return SchedulerBasicEvent;
  }(base);

  return SchedulerBasicEvent;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicProjectMixin.js":
/*!******************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_basic/SchedulerBasicProjectMixin.js ***!
  \******************************************************************************/
/*! exports provided: SchedulerBasicProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerBasicProjectMixin", function() { return SchedulerBasicProjectMixin; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../../../ChronoGraph/replica/Replica.js */ "./lib/ChronoGraph/replica/Replica.js");
/* harmony import */ var _ChronoGraph_schema_Schema_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../../../ChronoGraph/schema/Schema.js */ "./lib/ChronoGraph/schema/Schema.js");
/* harmony import */ var _ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../../../ChronoGraph/util/Helpers.js */ "./lib/ChronoGraph/util/Helpers.js");
/* harmony import */ var _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../../../Core/data/stm/StateTrackingManager.js */ "./lib/Core/data/stm/StateTrackingManager.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");
/* harmony import */ var _chrono_Replica_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../../../chrono/Replica.js */ "./lib/Engine/chrono/Replica.js");
/* harmony import */ var _scheduling_DurationConverterMixin_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../../../scheduling/DurationConverterMixin.js */ "./lib/Engine/scheduling/DurationConverterMixin.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _store_ChronoAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../../store/ChronoAssignmentStoreMixin.js */ "./lib/Engine/quark/store/ChronoAssignmentStoreMixin.js");
/* harmony import */ var _store_ChronoCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../../store/ChronoCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/ChronoCalendarManagerStoreMixin.js");
/* harmony import */ var _store_ChronoDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../../store/ChronoDependencyStoreMixin.js */ "./lib/Engine/quark/store/ChronoDependencyStoreMixin.js");
/* harmony import */ var _store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../../store/ChronoEventStoreMixin.js */ "./lib/Engine/quark/store/ChronoEventStoreMixin.js");
/* harmony import */ var _store_ChronoResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../../store/ChronoResourceStoreMixin.js */ "./lib/Engine/quark/store/ChronoResourceStoreMixin.js");
/* harmony import */ var _ChronoAbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./ChronoAbstractProjectMixin.js */ "./lib/Engine/quark/model/scheduler_basic/ChronoAbstractProjectMixin.js");
/* harmony import */ var _BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./BaseAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js");
/* harmony import */ var _BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./BaseCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js");
/* harmony import */ var _BaseDependencyMixin_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./BaseDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseDependencyMixin.js");
/* harmony import */ var _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./BaseEventMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseEventMixin.js");
/* harmony import */ var _BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./BaseResourceMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js");
/* harmony import */ var _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./HasCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasCalendarMixin.js");
/* harmony import */ var _HasSubEventsMixin_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./HasSubEventsMixin.js */ "./lib/Engine/quark/model/scheduler_basic/HasSubEventsMixin.js");
/* harmony import */ var _SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./SchedulerBasicEvent.js */ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");







































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_37___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


























var SchedulerBasicProjectMixin = /*#__PURE__*/function (_MixinAny) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34___default()(SchedulerBasicProjectMixin, _MixinAny);

  var _super = _createSuper(SchedulerBasicProjectMixin);

  function SchedulerBasicProjectMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_33___default()(this, SchedulerBasicProjectMixin);

    return _super.apply(this, arguments);
  }

  return SchedulerBasicProjectMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_38__["MixinAny"])([_ChronoAbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_53__["ChronoAbstractProjectMixin"], _BaseEventMixin_js__WEBPACK_IMPORTED_MODULE_57__["BaseEventMixin"], _HasSubEventsMixin_js__WEBPACK_IMPORTED_MODULE_60__["HasSubEventsMixin"], _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_59__["HasCalendarMixin"], _scheduling_DurationConverterMixin_js__WEBPACK_IMPORTED_MODULE_46__["DurationConverterMixin"], _HasCalendarMixin_js__WEBPACK_IMPORTED_MODULE_59__["CanCombineCalendarsMixin"]], function (base) {
  var superProto = base.prototype;

  var SchedulerBasicProjectMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34___default()(SchedulerBasicProjectMixin, _base);

    var _super2 = _createSuper(SchedulerBasicProjectMixin);

    function SchedulerBasicProjectMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_33___default()(this, SchedulerBasicProjectMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default()(SchedulerBasicProjectMixin, [{
      key: "construct",
      value: function construct() {
        var _this = this;

        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.enableProgressNotifications = config.enableProgressNotifications;

        if (!('expanded' in config)) {
          config.expanded = true;
        }

        superProto.construct.call(this, config);
        this.ignoreInitialCommitComputationCycles = 'ignoreInitialCommitComputationCycles' in config ? config.ignoreInitialCommitComputationCycles : true;
        if (this.repopulateOnDataset !== false) this.repopulateOnDataset = true;
        if (!this.eventModelClass) this.eventModelClass = this.getDefaultEventModelClass();
        if (!this.eventStoreClass) this.eventStoreClass = this.getDefaultEventStoreClass();
        if (!this.dependencyModelClass) this.dependencyModelClass = this.getDefaultDependencyModelClass();
        if (!this.dependencyStoreClass) this.dependencyStoreClass = this.getDefaultDependencyStoreClass();
        if (!this.resourceModelClass) this.resourceModelClass = this.getDefaultResourceModelClass();
        if (!this.resourceStoreClass) this.resourceStoreClass = this.getDefaultResourceStoreClass();
        if (!this.assignmentModelClass) this.assignmentModelClass = this.getDefaultAssignmentModelClass();
        if (!this.assignmentStoreClass) this.assignmentStoreClass = this.getDefaultAssignmentStoreClass();
        if (!this.calendarModelClass) this.calendarModelClass = this.getDefaultCalendarModelClass();
        if (!this.calendarManagerStoreClass) this.calendarManagerStoreClass = this.getDefaultCalendarManagerStoreClass();
        this.replica = this.createReplica();
        this.replica.addEntity(this);
        this.defaultCalendar = new this.calendarModelClass({
          unspecifiedTimeIsWorking: this.unspecifiedTimeIsWorking
        });
        this.defaultCalendar.project = this;
        this.replica.addEntity(this.defaultCalendar);
        var stm = this.stm = new _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_42__["default"](Object.assign({
          disabled: true
        }, this.stm));
        this.stm.on({
          restoringStop: function () {
            var _restoringStop = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function _callee() {
              return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _this.stm.disable();

                      _context.next = 3;
                      return _this.commitAsync();

                    case 3:
                      if (!_this.isDestroyed) {
                        _this.stm.enable();

                        _this.trigger('stateRestoringDone');
                      }

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function restoringStop() {
              return _restoringStop.apply(this, arguments);
            }

            return restoringStop;
          }()
        });
        var reEnableAutoRecord;
        this.on({
          beforeCommit: function beforeCommit() {
            if (stm.isRecording && stm.autoRecord) {
              reEnableAutoRecord = true;
              stm.autoRecord = false;
            }
          },
          dataReady: function dataReady() {
            if (reEnableAutoRecord) {
              stm.autoRecord = true;
              reEnableAutoRecord = false;
            }
          }
        });
        this.setCalendarManagerStore(this.calendarManagerStore);
        this.setEventStore(this.eventStore);
        this.setDependencyStore(this.dependencyStore);
        this.setResourceStore(this.resourceStore);
        this.setAssignmentStore(this.assignmentStore);
        var hasInlineData = Boolean(this.calendarsData || this.eventsData || this.dependenciesData || this.resourcesData || this.assignmentsData);

        if (hasInlineData) {
          this.loadInlineData({
            calendarsData: this.calendarsData,
            eventsData: this.eventsData,
            dependenciesData: this.dependenciesData,
            resourcesData: this.resourcesData,
            assignmentsData: this.assignmentsData
          });
          delete this.calendarsData;
          delete this.eventsData;
          delete this.dependenciesData;
          delete this.resourcesData;
          delete this.assignmentsData;
        }
      }
    }, {
      key: "doDestroy",
      value: function doDestroy() {
        var _a, _b, _c, _d, _e, _f;

        var me = this;
        (_a = me.eventStore) === null || _a === void 0 ? void 0 : _a.destroy();
        (_b = me.dependencyStore) === null || _b === void 0 ? void 0 : _b.destroy();
        (_c = me.assignmentStore) === null || _c === void 0 ? void 0 : _c.destroy();
        (_d = me.resourceStore) === null || _d === void 0 ? void 0 : _d.destroy();
        (_e = me.calendarManagerStore) === null || _e === void 0 ? void 0 : _e.destroy();
        me.replica.clear();
        (_f = me.stm) === null || _f === void 0 ? void 0 : _f.destroy();
        superProto.doDestroy.call(this);
      }
    }, {
      key: "createReplica",
      value: function createReplica() {
        return _chrono_Replica_js__WEBPACK_IMPORTED_MODULE_45__["EngineReplica"].mix(_ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_39__["Replica"]).new({
          project: this,
          schema: _ChronoGraph_schema_Schema_js__WEBPACK_IMPORTED_MODULE_40__["Schema"].new(),
          enableProgressNotifications: this.enableProgressNotifications,
          silenceInitialCommit: this.silenceInitialCommit,
          ignoreInitialCommitComputationCycles: this.ignoreInitialCommitComputationCycles,
          onWriteDuringCommit: 'ignore',
          readMode: _ChronoGraph_replica_Replica_js__WEBPACK_IMPORTED_MODULE_39__["ReadMode"].CurrentOrProposedOrPrevious
        });
      }
    }, {
      key: "hasSubEvents",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function hasSubEvents() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function hasSubEvents$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.getEventStore().count > 0);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, hasSubEvents, this);
      })
    }, {
      key: "subEventsIterable",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function subEventsIterable() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function subEventsIterable$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.getEventStore().getRange());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, subEventsIterable, this);
      })
    }, {
      key: "getType",
      value: function getType() {
        return _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_47__["ProjectType"].SchedulerBasic;
      }
    }, {
      key: "getDefaultEventModelClass",
      value: function getDefaultEventModelClass() {
        return _SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_61__["SchedulerBasicEvent"];
      }
    }, {
      key: "getDefaultEventStoreClass",
      value: function getDefaultEventStoreClass() {
        return _store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_51__["ChronoEventStoreMixin"];
      }
    }, {
      key: "getDefaultDependencyModelClass",
      value: function getDefaultDependencyModelClass() {
        return _BaseDependencyMixin_js__WEBPACK_IMPORTED_MODULE_56__["BaseDependencyMixin"];
      }
    }, {
      key: "getDefaultDependencyStoreClass",
      value: function getDefaultDependencyStoreClass() {
        return _store_ChronoDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_50__["ChronoDependencyStoreMixin"];
      }
    }, {
      key: "getDefaultResourceModelClass",
      value: function getDefaultResourceModelClass() {
        return _BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_58__["BaseResourceMixin"];
      }
    }, {
      key: "getDefaultResourceStoreClass",
      value: function getDefaultResourceStoreClass() {
        return _store_ChronoResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_52__["ChronoResourceStoreMixin"];
      }
    }, {
      key: "getDefaultAssignmentModelClass",
      value: function getDefaultAssignmentModelClass() {
        return _BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_54__["BaseAssignmentMixin"];
      }
    }, {
      key: "getDefaultAssignmentStoreClass",
      value: function getDefaultAssignmentStoreClass() {
        return _store_ChronoAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_48__["ChronoAssignmentStoreMixin"];
      }
    }, {
      key: "getDefaultCalendarModelClass",
      value: function getDefaultCalendarModelClass() {
        return _BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_55__["BaseCalendarMixin"];
      }
    }, {
      key: "getDefaultCalendarManagerStoreClass",
      value: function getDefaultCalendarManagerStoreClass() {
        return _store_ChronoCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_49__["ChronoCalendarManagerStoreMixin"];
      }
    }, {
      key: "loadInlineData",
      value: function () {
        var _loadInlineData = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function _callee2(data) {
          var calendarManagerStore, eventStore, dependencyStore, assignmentStore, resourceStore;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function _callee2$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  calendarManagerStore = this.calendarManagerStore, eventStore = this.eventStore, dependencyStore = this.dependencyStore, assignmentStore = this.assignmentStore, resourceStore = this.resourceStore;
                  this.replica.unScheduleAutoCommit();

                  if (!this.replica.enableProgressNotifications) {
                    _context4.next = 8;
                    break;
                  }

                  _context4.next = 5;
                  return Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_41__["delay"])(0);

                case 5:
                  this.replica.onPropagationProgressNotification({
                    total: 0,
                    remaining: 0,
                    phase: 'storePopulation'
                  });
                  _context4.next = 8;
                  return Object(_ChronoGraph_util_Helpers_js__WEBPACK_IMPORTED_MODULE_41__["delay"])(50);

                case 8:
                  this.isLoadingInlineData = true;

                  if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_62__["default"].global.DEBUG) {
                    console.log("%cInitializing project", 'font-weight:bold;color:darkgreen;text-transform:uppercase;margin-top: 2em');
                    console.time('Time to visible');
                    console.time('Populating project');
                  }

                  if (data.calendarsData) {
                    this.repopulateStore(calendarManagerStore);
                    calendarManagerStore.data = data.calendarsData;
                  }

                  if (data.eventsData || data.tasksData) {
                    this.repopulateStore(eventStore);
                    eventStore.data = data.eventsData || data.tasksData;
                  }

                  if (data.dependenciesData) {
                    this.repopulateStore(dependencyStore);
                    dependencyStore.data = data.dependenciesData;
                  }

                  if (data.resourcesData) {
                    this.repopulateStore(resourceStore);
                    resourceStore.data = data.resourcesData;
                  }

                  if (data.assignmentsData) {
                    this.repopulateStore(assignmentStore);
                    assignmentStore.data = data.assignmentsData;
                  }

                  if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_62__["default"].global.DEBUG) console.timeEnd('Populating project');
                  _context4.next = 18;
                  return this.commitLoad();

                case 18:
                  this.isLoadingInlineData = false;
                  return _context4.abrupt("return");

                case 20:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee2, this);
        }));

        function loadInlineData(_x) {
          return _loadInlineData.apply(this, arguments);
        }

        return loadInlineData;
      }()
    }, {
      key: "commitLoad",
      value: function () {
        var _commitLoad = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function _callee3() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function _callee3$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return this.commitAsync();

                case 2:
                  if (!this.isDestroyed) this.trigger('load');

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee3, this);
        }));

        function commitLoad() {
          return _commitLoad.apply(this, arguments);
        }

        return commitLoad;
      }()
    }, {
      key: "repopulateStore",
      value: function repopulateStore(store) {
        if (this.repopulateOnDataset && store.count) {
          if (!this.repopulateStores) this.repopulateStores = new Set();
          this.repopulateStores.add(store);
          this.repopulateReplica();
        }
      }
    }, {
      key: "repopulateReplica",
      value: function repopulateReplica() {
        var calendarManagerStore = this.calendarManagerStore,
            eventStore = this.eventStore,
            dependencyStore = this.dependencyStore,
            assignmentStore = this.assignmentStore,
            resourceStore = this.resourceStore,
            oldReplica = this.replica;
        this.unlinkStoreRecords(calendarManagerStore, eventStore, dependencyStore, resourceStore, assignmentStore);
        this.unlinkRecord(this);
        this.unlinkRecord(this.defaultCalendar);
        oldReplica.clear();
        var replica = this.replica = this.createReplica();
        replica.addEntity(this);
        replica.addEntity(this.defaultCalendar);
        this.joinStoreRecords(calendarManagerStore, true);
        this.joinStoreRecords(eventStore, true);
        this.joinStoreRecords(dependencyStore, true);
        this.joinStoreRecords(resourceStore, true);
        this.joinStoreRecords(assignmentStore, true);
        this.repopulateStores.clear();
      }
    }, {
      key: "beforeCommitAsync",
      value: function beforeCommitAsync() {
        if (this.repopulateReplica.isPending) {
          this.repopulateReplica.now();
          return this.replica.commitAsync();
        }

        return null;
      }
    }, {
      key: "unlinkRecord",
      value: function unlinkRecord(record) {
        var _a;

        var activeTransaction = this.replica.activeTransaction;
        var $ = record.$;
        var keys = Object.keys($);

        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          var identifier = $[key];

          if (identifier.field instanceof _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_44__["ModelReferenceField"]) {
            var value = record[key];
            identifier.DATA = (_a = value === null || value === void 0 ? void 0 : value.id) !== null && _a !== void 0 ? _a : value;
          } else {
            var entry = activeTransaction.getLatestStableEntryFor(identifier);
            if (entry) identifier.DATA = entry.getValue();
          }
        }

        record.graph = null;
      }
    }, {
      key: "unlinkStoreRecords",
      value: function unlinkStoreRecords() {
        var _this2 = this;

        for (var _len = arguments.length, stores = new Array(_len), _key = 0; _key < _len; _key++) {
          stores[_key] = arguments[_key];
        }

        stores.forEach(function (store) {
          return store.traverse(function (record) {
            if (!_this2.repopulateStores.has(store)) {
              _this2.unlinkRecord(record);
            }
          }, false);
        });
      }
    }, {
      key: "getGraph",
      value: function getGraph() {
        return this.replica;
      }
    }, {
      key: "addEvents",
      value: function () {
        var _addEvents = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function _callee4(events) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function _callee4$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  this.eventStore.add(events);
                  return _context6.abrupt("return", this.graph.commitAsync());

                case 2:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee4, this);
        }));

        function addEvents(_x2) {
          return _addEvents.apply(this, arguments);
        }

        return addEvents;
      }()
    }, {
      key: "addEvent",
      value: function () {
        var _addEvent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function _callee5(event) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function _callee5$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  this.eventStore.add(event);
                  return _context7.abrupt("return", this.graph.commitAsync());

                case 2:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee5, this);
        }));

        function addEvent(_x3) {
          return _addEvent.apply(this, arguments);
        }

        return addEvent;
      }()
    }, {
      key: "includeEvent",
      value: function includeEvent(event) {
        this.eventStore.add(event);
      }
    }, {
      key: "removeEvents",
      value: function () {
        var _removeEvents = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function _callee6(events) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function _callee6$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  this.eventStore.remove(events);
                  return _context8.abrupt("return", this.graph.commitAsync());

                case 2:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee6, this);
        }));

        function removeEvents(_x4) {
          return _removeEvents.apply(this, arguments);
        }

        return removeEvents;
      }()
    }, {
      key: "excludeEvent",
      value: function excludeEvent(event) {
        this.eventStore.remove(event);
      }
    }, {
      key: "removeEvent",
      value: function () {
        var _removeEvent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function _callee7(event) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function _callee7$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  this.eventStore.remove(event);
                  return _context9.abrupt("return", this.graph.commitAsync());

                case 2:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee7, this);
        }));

        function removeEvent(_x5) {
          return _removeEvent.apply(this, arguments);
        }

        return removeEvent;
      }()
    }, {
      key: "getStm",
      value: function getStm() {
        return this.stm;
      }
    }, {
      key: "calculateProject",
      value: function calculateProject() {
        return this;
      }
    }, {
      key: "resolveCalendar",
      value: function resolveCalendar(locator) {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(SchedulerBasicProjectMixin.prototype), "resolveCalendar", this).call(this, locator) || this.defaultCalendar;
      }
    }, {
      key: "joinStoreRecords",
      value: function joinStoreRecords(store) {
        var _this3 = this;

        var skipRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var fn = function fn(record) {
          record.setProject(_this3);
          record.joinProject();
        };

        if (store.rootNode) {
          store.rootNode.traverse(fn, skipRoot);
        } else {
          store.forEach(fn);
        }
      }
    }, {
      key: "unJoinStoreRecords",
      value: function unJoinStoreRecords(store) {
        var _this4 = this;

        var fn = function fn(record) {
          record.leaveProject();
          record.setProject(_this4);
        };

        if (store.rootNode) {
          store.rootNode.traverse(function (node) {
            if (node !== store.rootNode) fn(node);
          });
        } else {
          store.forEach(fn);
        }
      }
    }, {
      key: "setEventStore",
      value: function setEventStore(store) {
        var oldEventStore = this.eventStore;

        if (oldEventStore && this.stm.hasStore(oldEventStore)) {
          this.stm.removeStore(oldEventStore);
          this.unJoinStoreRecords(oldEventStore);
          var assignmentsForRemoval = oldEventStore.assignmentsForRemoval;
          assignmentsForRemoval.forEach(function (assignment) {
            var oldEvent = assignment.event;

            if (oldEvent) {
              var newEvent = store.getById(oldEvent.id);

              if (newEvent) {
                assignment.event = newEvent;
                assignmentsForRemoval.delete(assignment);
              }
            }
          });
          oldEventStore.afterEventRemoval();
        }

        if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.eventStoreClass;
          this.eventStore = new storeClass(Object.assign({
            modelClass: this.eventModelClass,
            project: this,
            stm: this.stm
          }, store || {}));
        } else {
          this.eventStore = store;
          store.setProject(this);
          this.stm.addStore(store);

          if (store.tree && store.rootNode !== this) {
            this.appendChild(store.rootNode.children || []);
            store.rootNode = this;
          } else {
            this.joinStoreRecords(store);
          }
        }

        this.trigger('eventStoreChange', {
          store: this.eventStore
        });
      }
    }, {
      key: "setDependencyStore",
      value: function setDependencyStore(store) {
        var oldDependencyStore = this.dependencyStore;

        if (oldDependencyStore && this.stm.hasStore(oldDependencyStore)) {
          this.stm.removeStore(oldDependencyStore);
        }

        if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.dependencyStoreClass;
          this.dependencyStore = new storeClass(Object.assign({
            modelClass: this.dependencyModelClass,
            project: this,
            stm: this.stm
          }, store || {}));
        } else {
          this.dependencyStore = store;
          store.setProject(this);
          this.stm.addStore(store);
          this.joinStoreRecords(store);
        }

        this.trigger('dependencyStoreChange', {
          store: this.dependencyStore
        });
      }
    }, {
      key: "setResourceStore",
      value: function setResourceStore(store) {
        var oldResourceStore = this.resourceStore;

        if (oldResourceStore && this.stm.hasStore(oldResourceStore)) {
          this.stm.removeStore(oldResourceStore);
          this.unJoinStoreRecords(oldResourceStore);
          var assignmentsForRemoval = oldResourceStore.assignmentsForRemoval;
          assignmentsForRemoval.forEach(function (assignment) {
            var oldResource = assignment.resource;

            if (oldResource) {
              var newResource = store.getById(oldResource.id);

              if (newResource) {
                assignment.resource = newResource;
                assignmentsForRemoval.delete(assignment);
              }
            }
          });
          oldResourceStore.afterResourceRemoval();
        }

        if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.resourceStoreClass;
          this.resourceStore = new storeClass(Object.assign({
            modelClass: this.resourceModelClass,
            project: this,
            stm: this.stm
          }, store || {}));
        } else {
          this.resourceStore = store;
          store.setProject(this);
          this.stm.addStore(store);
          this.joinStoreRecords(store);
        }

        this.trigger('resourceStoreChange', {
          store: this.resourceStore
        });
      }
    }, {
      key: "setAssignmentStore",
      value: function setAssignmentStore(store) {
        var oldAssignmentStore = this.assignmentStore;

        if (oldAssignmentStore && this.stm.hasStore(oldAssignmentStore)) {
          this.stm.removeStore(oldAssignmentStore);
          this.unJoinStoreRecords(oldAssignmentStore);
        }

        if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.assignmentStoreClass;
          this.assignmentStore = new storeClass(Object.assign({
            modelClass: this.assignmentModelClass,
            project: this,
            stm: this.stm
          }, store || {}));
        } else {
          this.assignmentStore = store;
          store.setProject(this);
          this.stm.addStore(store);
          this.joinStoreRecords(store);
        }

        this.trigger('assignmentStoreChange', {
          store: this.assignmentStore
        });
      }
    }, {
      key: "setCalendarManagerStore",
      value: function setCalendarManagerStore(store) {
        var oldCalendarManagerStore = this.calendarManagerStore;

        if (oldCalendarManagerStore && this.stm.hasStore(oldCalendarManagerStore)) {
          this.stm.removeStore(oldCalendarManagerStore);
        }

        if (!store || !(store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var storeClass = (store === null || store === void 0 ? void 0 : store.storeClass) || this.calendarManagerStoreClass;
          this.calendarManagerStore = new storeClass(Object.assign({
            modelClass: this.calendarModelClass,
            project: this,
            stm: this.stm
          }, store || {}));
        } else {
          this.calendarManagerStore = store;

          if (store) {
            store.setProject(this);
            this.stm.addStore(store);
            this.joinStoreRecords(store);
          }
        }

        this.trigger('calendarManagerStoreChange', {
          store: this.calendarManagerStore
        });
      }
    }, {
      key: "isValidDependency",
      value: function () {
        var _isValidDependency = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function _callee8() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function _callee8$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  return _context10.abrupt("return", true);

                case 1:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee8);
        }));

        function isValidDependency() {
          return _isValidDependency.apply(this, arguments);
        }

        return isValidDependency;
      }()
    }, {
      key: "tryPropagateWithChanges",
      value: function () {
        var _tryPropagateWithChanges = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_30___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.mark(function _callee9(changerFn) {
          var stm, stmInitiallyDisabled, stmInitiallyAutoRecord, captureStm, commitStmTransaction, rejectStmTransaction, freeStm, result, commitResult;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_28___default.a.wrap(function _callee9$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  stm = this.stm;

                  captureStm = function captureStm() {
                    stmInitiallyDisabled = stm.disabled;
                    stmInitiallyAutoRecord = stm.autoRecord;

                    if (stmInitiallyDisabled) {
                      stm.enable();
                    } else {
                      if (stmInitiallyAutoRecord) {
                        stm.autoRecord = false;
                      }

                      if (stm.isRecording) {
                        stm.stopTransaction();
                      }
                    }
                  };

                  commitStmTransaction = function commitStmTransaction() {
                    stm.stopTransaction();

                    if (stmInitiallyDisabled) {
                      stm.resetQueue();
                    }
                  };

                  rejectStmTransaction = function rejectStmTransaction() {
                    if (stm.transaction.length) {
                      stm.forEachStore(function (s) {
                        return s.beginBatch();
                      });
                      stm.rejectTransaction();
                      stm.forEachStore(function (s) {
                        return s.endBatch();
                      });
                    } else {
                      stm.stopTransaction();
                    }
                  };

                  freeStm = function freeStm() {
                    stm.disabled = stmInitiallyDisabled;
                    stm.autoRecord = stmInitiallyAutoRecord;
                  };

                  captureStm();
                  stm.startTransaction();
                  changerFn();
                  result = true;
                  _context11.prev = 9;
                  _context11.next = 12;
                  return this.commitAsync();

                case 12:
                  commitResult = _context11.sent;
                  result = !commitResult.rejectedWith;
                  _context11.next = 21;
                  break;

                case 16:
                  _context11.prev = 16;
                  _context11.t0 = _context11["catch"](9);

                  if (/cycle/i.test(_context11.t0)) {
                    _context11.next = 20;
                    break;
                  }

                  throw _context11.t0;

                case 20:
                  result = false;

                case 21:
                  if (result) {
                    commitStmTransaction();
                  } else {
                    this.replica.reject();
                    rejectStmTransaction();
                  }

                  freeStm();
                  return _context11.abrupt("return", result);

                case 24:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee9, this, [[9, 16]]);
        }));

        function tryPropagateWithChanges(_x6) {
          return _tryPropagateWithChanges.apply(this, arguments);
        }

        return tryPropagateWithChanges;
      }()
    }, {
      key: "isEngineReady",
      value: function isEngineReady() {
        var replica = this.replica;
        return !(replica.dirty && (replica.hasPendingAutoCommit() || replica.isCommitting));
      }
    }, {
      key: "enableProgressNotifications",
      get: function get() {
        return this._enableProgressNotifications;
      },
      set: function set(value) {
        this._enableProgressNotifications = value;
        if (this.replica) this.replica.enableProgressNotifications = value;
      }
    }, {
      key: "isRepopulatingStores",
      get: function get() {
        var _a;

        return Boolean((_a = this.repopulateStores) === null || _a === void 0 ? void 0 : _a.size);
      }
    }], [{
      key: "defaultConfig",
      get: function get() {
        return {
          assignmentsData: null,
          calendarsData: null,
          dependenciesData: null,
          eventsData: null,
          resourcesData: null,
          eventStore: null,
          resourceStore: null,
          assignmentStore: null,
          dependencyStore: null,
          calendarManagerStore: null,
          eventModelClass: null,
          resourceModelClass: null,
          assignmentModelClass: null,
          dependencyModelClass: null,
          calendarModelClass: null,
          repopulateOnDataSet: true
        };
      }
    }, {
      key: "delayable",
      get: function get() {
        return {
          repopulateReplica: 10
        };
      }
    }]);

    return SchedulerBasicProjectMixin;
  }(base);

  SchedulerBasicProjectMixin.applyConfigs = true;

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_44__["model_field"])({
    type: 'boolean',
    defaultValue: true
  })], SchedulerBasicProjectMixin.prototype, "unspecifiedTimeIsWorking", void 0);

  return SchedulerBasicProjectMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js":
/*!**********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js ***!
  \**********************************************************************/
/*! exports provided: CoreAssignmentMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreAssignmentMixin", function() { return CoreAssignmentMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CoreAssignmentMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreAssignmentMixin, _Mixin);

  var _super = _createSuper(CoreAssignmentMixin);

  function CoreAssignmentMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreAssignmentMixin);

    return _super.apply(this, arguments);
  }

  return CoreAssignmentMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_9__["CorePartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreAssignmentMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreAssignmentMixin, _base);

    var _super2 = _createSuper(CoreAssignmentMixin);

    function CoreAssignmentMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreAssignmentMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CoreAssignmentMixin, [{
      key: "setChanged",
      value: function setChanged(field, value, invalidate) {
        var assignmentStore = this.assignmentStore,
            eventStore = this.eventStore,
            resourceStore = this.resourceStore,
            project = this.project;
        var update = false;

        if (field === 'event') {
          var event = Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["isInstanceOf"])(value, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreEventMixin"]) ? value : eventStore === null || eventStore === void 0 ? void 0 : eventStore.getById(value);
          if (event) update = true;
          value = event || value;
        }

        if (field === 'resource') {
          var resource = Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["isInstanceOf"])(value, _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_11__["CoreResourceMixin"]) ? value : resourceStore === null || resourceStore === void 0 ? void 0 : resourceStore.getById(value);
          if (resource) update = true;
          value = resource || value;
        }

        superProto.setChanged.call(this, field, value, invalidate, true);

        if (assignmentStore && update && !project.isPerformingCommit && !assignmentStore.isLoadingData && !assignmentStore.isBatchAssigning) {
          assignmentStore.updateIndices();
        }
      }
    }, {
      key: "joinProject",
      value: function joinProject() {
        superProto.joinProject.call(this);
        this.setChanged('event', this.get('event'));
        this.setChanged('resource', this.get('resource'));
      }
    }, {
      key: "calculateInvalidated",
      value: function calculateInvalidated() {
        var _a, _b;

        var _this$$changed = this.$changed,
            _this$$changed$event = _this$$changed.event,
            event = _this$$changed$event === void 0 ? this.event : _this$$changed$event,
            _this$$changed$resour = _this$$changed.resource,
            resource = _this$$changed$resour === void 0 ? this.resource : _this$$changed$resour;

        if (event !== null && !Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["isInstanceOf"])(event, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreEventMixin"])) {
          var resolved = (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(event);
          if (resolved) this.setChanged('event', resolved, false);
        }

        if (resource !== null && !Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["isInstanceOf"])(resource, _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_11__["CoreResourceMixin"])) {
          var _resolved = (_b = this.resourceStore) === null || _b === void 0 ? void 0 : _b.getById(resource);

          if (_resolved) this.setChanged('resource', _resolved, false);
        }
      }
    }, {
      key: "event",
      set: function set(event) {
        this.setChanged('event', event);
      },
      get: function get() {
        var event = this.get('event');
        return Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["isInstanceOf"])(event, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreEventMixin"]) ? event : null;
      }
    }, {
      key: "resource",
      set: function set(resource) {
        this.setChanged('resource', resource);
      },
      get: function get() {
        var resource = this.get('resource');
        return Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["isInstanceOf"])(resource, _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_11__["CoreResourceMixin"]) ? resource : null;
      }
    }], [{
      key: "fields",
      get: function get() {
        return [{
          name: 'resource',
          isEqual: function isEqual(a, b) {
            return a === b;
          },
          persist: false
        }, {
          name: 'event',
          isEqual: function isEqual(a, b) {
            return a === b;
          },
          persist: false
        }];
      }
    }]);

    return CoreAssignmentMixin;
  }(base);

  return CoreAssignmentMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js":
/*!********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js ***!
  \********************************************************************/
/*! exports provided: CoreCalendarMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreCalendarMixin", function() { return CoreCalendarMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../AbstractCalendarMixin.js */ "./lib/Engine/quark/model/AbstractCalendarMixin.js");








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var CoreCalendarMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(CoreCalendarMixin, _Mixin);

  var _super = _createSuper(CoreCalendarMixin);

  function CoreCalendarMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, CoreCalendarMixin);

    return _super.apply(this, arguments);
  }

  return CoreCalendarMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_9__["AbstractCalendarMixin"], _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_7__["CorePartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreCalendarMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(CoreCalendarMixin, _base);

    var _super2 = _createSuper(CoreCalendarMixin);

    function CoreCalendarMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, CoreCalendarMixin);

      return _super2.apply(this, arguments);
    }

    return CoreCalendarMixin;
  }(base);

  return CoreCalendarMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js":
/*!**********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js ***!
  \**********************************************************************/
/*! exports provided: CoreDependencyMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreDependencyMixin", function() { return CoreDependencyMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CoreDependencyMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreDependencyMixin, _Mixin);

  var _super = _createSuper(CoreDependencyMixin);

  function CoreDependencyMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreDependencyMixin);

    return _super.apply(this, arguments);
  }

  return CoreDependencyMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_8__["CorePartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreDependencyMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreDependencyMixin, _base);

    var _super2 = _createSuper(CoreDependencyMixin);

    function CoreDependencyMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreDependencyMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CoreDependencyMixin, [{
      key: "setChanged",
      value: function setChanged(field, value, invalidate) {
        var _a, _b, _c;

        var update = false;

        if (field === 'fromEvent' || field === 'toEvent') {
          var event = Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_11__["isInstanceOf"])(value, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreEventMixin"]) ? value : (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(value);
          if (event) update = true;
          value = event || value;
        }

        superProto.setChanged.call(this, field, value, invalidate, true);

        if (update && !this.project.isPerformingCommit && !((_b = this.dependencyStore) === null || _b === void 0 ? void 0 : _b.isLoadingData)) {
          (_c = this.dependencyStore) === null || _c === void 0 ? void 0 : _c.updateIndices();
        }
      }
    }, {
      key: "joinProject",
      value: function joinProject() {
        superProto.joinProject.call(this);
        this.setChanged('fromEvent', this.get('fromEvent'));
        this.setChanged('toEvent', this.get('toEvent'));
      }
    }, {
      key: "calculateInvalidated",
      value: function calculateInvalidated() {
        var _a, _b;

        var _this$$changed = this.$changed,
            fromEvent = _this$$changed.fromEvent,
            toEvent = _this$$changed.toEvent;

        if (fromEvent !== null && !Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_11__["isInstanceOf"])(fromEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreEventMixin"])) {
          var resolved = (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(fromEvent);
          if (resolved) this.$changed.fromEvent = resolved;
        }

        if (toEvent !== null && !Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_11__["isInstanceOf"])(toEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreEventMixin"])) {
          var _resolved = (_b = this.eventStore) === null || _b === void 0 ? void 0 : _b.getById(toEvent);

          if (_resolved) this.$changed.toEvent = _resolved;
        }
      }
    }, {
      key: "fromEvent",
      set: function set(fromEvent) {
        this.setChanged('fromEvent', fromEvent);
      },
      get: function get() {
        var fromEvent = this.get('fromEvent');
        return Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_11__["isInstanceOf"])(fromEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreEventMixin"]) ? fromEvent : null;
      }
    }, {
      key: "toEvent",
      set: function set(toEvent) {
        this.setChanged('toEvent', toEvent);
      },
      get: function get() {
        var toEvent = this.get('toEvent');
        return Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_11__["isInstanceOf"])(toEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreEventMixin"]) ? toEvent : null;
      }
    }], [{
      key: "fields",
      get: function get() {
        return [{
          name: 'fromEvent',
          isEqual: function isEqual(a, b) {
            return a === b;
          },
          persist: false
        }, {
          name: 'toEvent',
          isEqual: function isEqual(a, b) {
            return a === b;
          },
          persist: false
        }];
      }
    }]);

    return CoreDependencyMixin;
  }(base);

  return CoreDependencyMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js":
/*!*****************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js ***!
  \*****************************************************************/
/*! exports provided: CoreEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreEventMixin", function() { return CoreEventMixin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");





















function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var CoreEventMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default()(CoreEventMixin, _Mixin);

  var _super = _createSuper(CoreEventMixin);

  function CoreEventMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, CoreEventMixin);

    return _super.apply(this, arguments);
  }

  return CoreEventMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_20__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_21__["CorePartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreEventMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default()(CoreEventMixin, _base);

    var _super2 = _createSuper(CoreEventMixin);

    function CoreEventMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, CoreEventMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(CoreEventMixin, [{
      key: "getStartDate",
      value: function getStartDate() {
        return this.startDate;
      }
    }, {
      key: "proposeStartDate",
      value: function proposeStartDate(startDate) {
        var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        this.propose({
          startDate: startDate,
          keepDuration: keepDuration
        });
      }
    }, {
      key: "setStartDate",
      value: function () {
        var _setStartDate = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee(startDate) {
          var keepDuration,
              _a,
              _args = arguments;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  keepDuration = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
                  this.proposeStartDate(startDate, keepDuration);
                  return _context.abrupt("return", (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync());

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function setStartDate(_x) {
          return _setStartDate.apply(this, arguments);
        }

        return setStartDate;
      }()
    }, {
      key: "getEndDate",
      value: function getEndDate() {
        return this.endDate;
      }
    }, {
      key: "proposeEndDate",
      value: function proposeEndDate(endDate) {
        var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        this.propose({
          endDate: endDate,
          keepDuration: keepDuration
        });
      }
    }, {
      key: "setEndDate",
      value: function () {
        var _setEndDate = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee2(endDate) {
          var keepDuration,
              _a,
              _args2 = arguments;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  keepDuration = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
                  this.proposeEndDate(endDate, keepDuration);
                  return _context2.abrupt("return", (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync());

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function setEndDate(_x2) {
          return _setEndDate.apply(this, arguments);
        }

        return setEndDate;
      }()
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: "proposeDuration",
      value: function proposeDuration(duration, unit) {
        var keepStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        this.propose({
          duration: duration,
          keepStart: keepStart
        });
        if (unit) this.propose({
          durationUnit: unit
        });
      }
    }, {
      key: "setDuration",
      value: function () {
        var _setDuration = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee3(duration, unit) {
          var keepStart,
              _a,
              _args3 = arguments;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  keepStart = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;
                  this.proposeDuration(duration, unit, keepStart);
                  return _context3.abrupt("return", (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync());

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function setDuration(_x3, _x4) {
          return _setDuration.apply(this, arguments);
        }

        return setDuration;
      }()
    }, {
      key: "getDurationUnit",
      value: function getDurationUnit() {
        return this.durationUnit;
      }
    }, {
      key: "joinProject",
      value: function joinProject() {
        var _a;

        var changed = this.$changed;
        if (this.hasCurrentOrProposed('startDate')) changed.startDate = this.getCurrentOrProposed('startDate');
        if (this.hasCurrentOrProposed('endDate')) changed.endDate = this.getCurrentOrProposed('endDate');
        if (this.hasCurrentOrProposed('duration')) changed.duration = this.getCurrentOrProposed('duration');

        if (this.eventStore && !this.eventStore.isLoadingData) {
          var unresolved = (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.storage.findItem('event', null);

          if (unresolved) {
            var _iterator = _createForOfIteratorHelper(unresolved),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var assignment = _step.value;

                if (assignment.getCurrentOrProposed('event') === this.id) {
                  assignment.setChanged('event', this);
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }

        superProto.joinProject.call(this);
      }
    }, {
      key: "applyValue",
      value: function applyValue(useProp, key, value, skipAccessors, field) {
        if (key === 'startDate' || key == 'duration' || key === 'endDate') {
          useProp = true;
        }

        if (skipAccessors) {
          useProp = false;
        }

        superProto.applyValue.call(this, useProp, key, value, skipAccessors, field);
      }
    }, {
      key: "afterChange",
      value: function afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors) {
        if (!this.$isCalculating && !skipAccessors) {
          this.setData(this.$changed);
        }

        superProto.afterChange.call(this, toSet, wasSet, silent, fromRelationUpdate, skipAccessors);
      }
    }, {
      key: "calculateInvalidated",
      value: function calculateInvalidated() {
        var changed = this.$changed;
        var changedStart = ('startDate' in changed);
        var changedEnd = ('endDate' in changed);
        var changedDuration = ('duration' in changed);
        var startDate = changed.startDate,
            endDate = changed.endDate,
            duration = changed.duration,
            keepDuration = changed.keepDuration,
            keepStart = changed.keepStart;
        var calculate = null;

        if (changedStart && !changedEnd && !changedDuration) {
          if (startDate === null) {
            changed.endDate = null;
          } else if (this.hasCurrentOrProposed('endDate') && startDate > this.getCurrentOrProposed('endDate') && !keepDuration) {
            changed.endDate = startDate;
            changed.duration = 0;
          } else if (this.hasCurrentOrProposed('duration') && (keepDuration || !this.hasCurrentOrProposed('endDate'))) {
            calculate = 'endDate';
          } else if (this.hasCurrentOrProposed('endDate')) {
            calculate = 'duration';
          }
        } else if (!changedStart && changedEnd && !changedDuration) {
          if (endDate === null) {
            changed.startDate = null;
          } else if (this.hasCurrentOrProposed('startDate') && endDate < this.getCurrentOrProposed('startDate') && !keepDuration) {
            changed.startDate = endDate;
            changed.duration = 0;
          } else if (this.hasCurrentOrProposed('duration') && (keepDuration || !this.hasCurrentOrProposed('startDate'))) {
            calculate = 'startDate';
          } else if (this.hasCurrentOrProposed('startDate')) {
            calculate = 'duration';
          }
        } else if (!changedStart && !changedEnd && changedDuration) {
          if (duration === null) {
            changed.endDate = null;
          } else if (this.hasCurrentOrProposed('startDate') && (keepStart || !this.hasCurrentOrProposed('endDate'))) {
            if (keepStart && changed.duration < 0) {
              changed.duration = 0;
            }

            calculate = 'endDate';
          } else if (this.hasCurrentOrProposed('endDate')) {
            calculate = 'startDate';
          }
        } else if (changedStart && changedEnd && !changedDuration) {
          if (startDate === null && endDate === null) {
            changed.duration = null;
          } else {
            calculate = 'duration';
          }
        } else if (changedStart && !changedEnd && changedDuration) {
          calculate = 'endDate';
        } else if (!changedStart && changedEnd && changedDuration) {
          calculate = 'startDate';
        } else if (changedStart && changedEnd && changedDuration) {
          if (duration == null) {
            calculate = 'duration';
          } else if (startDate == null) {
            calculate = 'startDate';
          } else {
            calculate = 'endDate';
          }
        }

        switch (calculate) {
          case 'startDate':
            changed.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].add(this.getCurrentOrProposed('endDate'), -this.getCurrentOrProposed('duration'), this.getCurrentOrProposed('durationUnit'));
            break;

          case 'endDate':
            changed.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].add(this.getCurrentOrProposed('startDate'), this.getCurrentOrProposed('duration'), this.getCurrentOrProposed('durationUnit'));
            break;

          case 'duration':
            changed.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].diff(this.getCurrentOrProposed('startDate'), this.getCurrentOrProposed('endDate'), this.getCurrentOrProposed('durationUnit'));
            break;
        }

        delete changed.keepDuration;
        delete changed.keepStart;
      }
    }, {
      key: "startDate",
      get: function get() {
        return this.getCurrentOrProposed('startDate');
      },
      set: function set(value) {
        this.proposeStartDate(value);
      }
    }, {
      key: "endDate",
      get: function get() {
        return this.getCurrentOrProposed('endDate');
      },
      set: function set(value) {
        this.proposeEndDate(value);
      }
    }, {
      key: "duration",
      get: function get() {
        return this.getCurrentOrProposed('duration');
      },
      set: function set(value) {
        this.proposeDuration(value);
      }
    }], [{
      key: "fields",
      get: function get() {
        return [{
          name: 'startDate',
          type: 'date'
        }, {
          name: 'endDate',
          type: 'date'
        }, {
          name: 'duration',
          type: 'number'
        }, {
          name: 'durationUnit',
          type: 'string',
          defaultValue: 'day'
        }];
      }
    }]);

    return CoreEventMixin;
  }(base);

  return CoreEventMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreHasAssignmentsMixin.js":
/*!**************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreHasAssignmentsMixin.js ***!
  \**************************************************************************/
/*! exports provided: CoreHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreHasAssignmentsMixin", function() { return CoreHasAssignmentsMixin; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../AbstractHasAssignmentsMixin.js */ "./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CoreHasAssignmentsMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(CoreHasAssignmentsMixin, _Mixin);

  var _super = _createSuper(CoreHasAssignmentsMixin);

  function CoreHasAssignmentsMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, CoreHasAssignmentsMixin);

    return _super.apply(this, arguments);
  }

  return CoreHasAssignmentsMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_10__["Mixin"])([_CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_11__["CoreEventMixin"], _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_13__["AbstractHasAssignmentsMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreHasAssignmentsMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(CoreHasAssignmentsMixin, _base);

    var _super2 = _createSuper(CoreHasAssignmentsMixin);

    function CoreHasAssignmentsMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, CoreHasAssignmentsMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(CoreHasAssignmentsMixin, [{
      key: "applyValue",
      value: function applyValue(useProp, key, value, skipAccessor, field) {
        var _a;

        if (key === 'id') {
          (_a = this.assigned) === null || _a === void 0 ? void 0 : _a.forEach(function (assignment) {
            return assignment.set('eventId', value);
          });
        }

        superProto.applyValue.call(this, useProp, key, value, skipAccessor, field);
      }
    }, {
      key: "copy",
      value: function copy() {
        var newId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var copy = superProto.copy.call(this, newId, deep);

        if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isObject(deep) && !deep.skipFieldIdentifiers || !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isObject(deep)) {
          copy.$cachedAssignments = this.assigned;
        }

        return copy;
      }
    }, {
      key: "assigned",
      get: function get() {
        var _a;

        var assignments = (_a = this.project) === null || _a === void 0 ? void 0 : _a.assignmentStore.getEventsAssignments(this);

        if (!assignments) {
          return this.$cachedAssignments;
        }

        return this.$cachedAssignments = assignments;
      }
    }]);

    return CoreHasAssignmentsMixin;
  }(base);

  return CoreHasAssignmentsMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreHasDependenciesMixin.js":
/*!***************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreHasDependenciesMixin.js ***!
  \***************************************************************************/
/*! exports provided: CoreHasDependenciesMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreHasDependenciesMixin", function() { return CoreHasDependenciesMixin; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var CoreHasDependenciesMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(CoreHasDependenciesMixin, _Mixin);

  var _super = _createSuper(CoreHasDependenciesMixin);

  function CoreHasDependenciesMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, CoreHasDependenciesMixin);

    return _super.apply(this, arguments);
  }

  return CoreHasDependenciesMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_10__["Mixin"])([_CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_11__["CoreEventMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreHasDependenciesMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(CoreHasDependenciesMixin, _base);

    var _super2 = _createSuper(CoreHasDependenciesMixin);

    function CoreHasDependenciesMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, CoreHasDependenciesMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(CoreHasDependenciesMixin, [{
      key: "leaveProject",
      value: function leaveProject() {
        var eventStore = this.eventStore;

        if (this.outgoingDeps) {
          this.outgoingDeps.forEach(function (dependency) {
            return eventStore.dependenciesForRemoval.add(dependency);
          });
        }

        if (this.incomingDeps) {
          this.incomingDeps.forEach(function (dependency) {
            return eventStore.dependenciesForRemoval.add(dependency);
          });
        }

        superProto.leaveProject.call(this);
      }
    }, {
      key: "outgoingDeps",
      get: function get() {
        return this.project.dependencyStore.getOutgoingDepsForEvent(this);
      }
    }, {
      key: "incomingDeps",
      get: function get() {
        return this.project.dependencyStore.getIncomingDepsForEvent(this);
      }
    }]);

    return CoreHasDependenciesMixin;
  }(base);

  return CoreHasDependenciesMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js":
/*!********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js ***!
  \********************************************************************/
/*! exports provided: CoreResourceMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreResourceMixin", function() { return CoreResourceMixin; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var CoreResourceMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(CoreResourceMixin, _Mixin);

  var _super = _createSuper(CoreResourceMixin);

  function CoreResourceMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, CoreResourceMixin);

    return _super.apply(this, arguments);
  }

  return CoreResourceMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_11__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_12__["CorePartOfProjectModelMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreResourceMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(CoreResourceMixin, _base);

    var _super2 = _createSuper(CoreResourceMixin);

    function CoreResourceMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, CoreResourceMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(CoreResourceMixin, [{
      key: "joinProject",
      value: function joinProject() {
        var _this = this;

        var _a;

        if (this.resourceStore && !this.resourceStore.isLoadingData) {
          (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.query(function (a) {
            return a.get('resource') === _this.id;
          }).forEach(function (unresolved) {
            return unresolved.setChanged('resource', _this);
          });
        }

        superProto.joinProject.call(this);
      }
    }, {
      key: "leaveProject",
      value: function leaveProject() {
        var isReplacing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (this.assigned && !isReplacing) {
          var resourceStore = this.resourceStore;
          this.assigned.forEach(function (assignment) {
            return resourceStore.assignmentsForRemoval.add(assignment);
          });
        }

        superProto.leaveProject.call(this);
      }
    }, {
      key: "applyValue",
      value: function applyValue(useProp, key, value, skipAccessor, field) {
        if (field.name === 'id') {
          this.assigned.forEach(function (assignment) {
            assignment.set('resourceId', value);
          });
        }

        superProto.applyValue.call(this, useProp, key, value, skipAccessor, field);
      }
    }, {
      key: "assigned",
      get: function get() {
        var _a;

        return (_a = this.project) === null || _a === void 0 ? void 0 : _a.assignmentStore.getResourcesAssignments(this);
      }
    }]);

    return CoreResourceMixin;
  }(base);

  return CoreResourceMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js ***!
  \*********************************************************************/
/*! exports provided: SchedulerCoreEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerCoreEvent", function() { return SchedulerCoreEvent; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _CoreHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./CoreHasAssignmentsMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreHasAssignmentsMixin.js");
/* harmony import */ var _CoreHasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./CoreHasDependenciesMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreHasDependenciesMixin.js");








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var SchedulerCoreEvent = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerCoreEvent, _Mixin);

  var _super = _createSuper(SchedulerCoreEvent);

  function SchedulerCoreEvent() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SchedulerCoreEvent);

    return _super.apply(this, arguments);
  }

  return SchedulerCoreEvent;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_7__["Mixin"])([_CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_8__["CoreEventMixin"], _CoreHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_9__["CoreHasAssignmentsMixin"], _CoreHasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreHasDependenciesMixin"]], function (base) {
  var superProto = base.prototype;

  var SchedulerCoreEvent = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerCoreEvent, _base);

    var _super2 = _createSuper(SchedulerCoreEvent);

    function SchedulerCoreEvent() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SchedulerCoreEvent);

      return _super2.apply(this, arguments);
    }

    return SchedulerCoreEvent;
  }(base);

  return SchedulerCoreEvent;
}));

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js":
/*!****************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js ***!
  \****************************************************************************/
/*! exports provided: EventsWrapper, DelayableWrapper, SchedulerCoreProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventsWrapper", function() { return EventsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DelayableWrapper", function() { return DelayableWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerCoreProjectMixin", function() { return SchedulerCoreProjectMixin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./SchedulerCoreEvent.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../../store/CoreEventStoreMixin.js */ "./lib/Engine/quark/store/CoreEventStoreMixin.js");
/* harmony import */ var _CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./CoreAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js");
/* harmony import */ var _store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../../store/CoreAssignmentStoreMixin.js */ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js");
/* harmony import */ var _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
/* harmony import */ var _store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../../store/CoreResourceStoreMixin.js */ "./lib/Engine/quark/store/CoreResourceStoreMixin.js");
/* harmony import */ var _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../../CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony import */ var _store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../../store/CoreDependencyStoreMixin.js */ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js");
/* harmony import */ var _CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./CoreDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js");
/* harmony import */ var _CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./CoreCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js");
/* harmony import */ var _store_CoreCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../../store/CoreCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../../../util/Functions.js */ "./lib/Engine/util/Functions.js");
/* harmony import */ var _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../../../../Core/data/stm/StateTrackingManager.js */ "./lib/Core/data/stm/StateTrackingManager.js");
/* harmony import */ var _AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../AbstractProjectMixin.js */ "./lib/Engine/quark/model/AbstractProjectMixin.js");










































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



















var EventsWrapper = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default()(EventsWrapper, _Mixin);

  var _super = _createSuper(EventsWrapper);

  function EventsWrapper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37___default()(this, EventsWrapper);

    return _super.apply(this, arguments);
  }

  return EventsWrapper;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_41__["Mixin"])([], _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_45__["default"]));
var DelayableWrapper = /*#__PURE__*/function (_Mixin2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default()(DelayableWrapper, _Mixin2);

  var _super2 = _createSuper(DelayableWrapper);

  function DelayableWrapper() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37___default()(this, DelayableWrapper);

    return _super2.apply(this, arguments);
  }

  return DelayableWrapper;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_41__["Mixin"])([], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_46__["default"]));
var SchedulerCoreProjectMixin = /*#__PURE__*/function (_Mixin3) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default()(SchedulerCoreProjectMixin, _Mixin3);

  var _super3 = _createSuper(SchedulerCoreProjectMixin);

  function SchedulerCoreProjectMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37___default()(this, SchedulerCoreProjectMixin);

    return _super3.apply(this, arguments);
  }

  return SchedulerCoreProjectMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_41__["Mixin"])([_AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_59__["AbstractProjectMixin"], _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_52__["CorePartOfProjectGenericMixin"], EventsWrapper, DelayableWrapper, _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_44__["default"]], function (base) {
  var superProto = base.prototype;

  var SchedulerCoreProjectMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default()(SchedulerCoreProjectMixin, _base);

    var _super4 = _createSuper(SchedulerCoreProjectMixin);

    function SchedulerCoreProjectMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37___default()(this, SchedulerCoreProjectMixin);

      return _super4.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36___default()(SchedulerCoreProjectMixin, [{
      key: "construct",
      value: function construct() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.$invalidated = new Set();
        this.isPerformingCommit = false;
        this.silenceInitialCommit = true;
        this.ongoing = Promise.resolve();
        superProto.construct.call(this, config);
        this.defaultCalendar = new this.calendarManagerStore.modelClass({
          unspecifiedTimeIsWorking: this.unspecifiedTimeIsWorking
        });
        this.defaultCalendar.project = this;
        var calendarsData = this.calendarsData,
            eventsData = this.eventsData,
            dependenciesData = this.dependenciesData,
            resourcesData = this.resourcesData,
            assignmentsData = this.assignmentsData;
        var hasInlineData = Boolean(calendarsData || eventsData || dependenciesData || resourcesData || assignmentsData);

        if (hasInlineData) {
          this.loadInlineData({
            calendarsData: calendarsData,
            eventsData: eventsData,
            dependenciesData: dependenciesData,
            resourcesData: resourcesData,
            assignmentsData: assignmentsData
          });
          delete this.calendarsData;
          delete this.eventsData;
          delete this.dependenciesData;
          delete this.resourcesData;
          delete this.assignmentsData;
        } else {
          this.bufferedCommitAsync();
        }
      }
    }, {
      key: "doDestroy",
      value: function doDestroy() {
        var _a, _b, _c, _d, _e, _f;

        var me = this;
        (_a = me.eventStore) === null || _a === void 0 ? void 0 : _a.destroy();
        (_b = me.dependencyStore) === null || _b === void 0 ? void 0 : _b.destroy();
        (_c = me.assignmentStore) === null || _c === void 0 ? void 0 : _c.destroy();
        (_d = me.resourceStore) === null || _d === void 0 ? void 0 : _d.destroy();
        (_e = me.calendarManagerStore) === null || _e === void 0 ? void 0 : _e.destroy();
        (_f = me.stm) === null || _f === void 0 ? void 0 : _f.destroy();
        superProto.doDestroy.call(this);
      }
    }, {
      key: "loadInlineData",
      value: function () {
        var _loadInlineData = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee(data) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.isLoadingInlineData = true;

                  if (data.calendarsData) {
                    this.calendarManagerStore.data = data.calendarsData;
                  }

                  if (data.resourcesData) {
                    this.resourceStore.data = data.resourcesData;
                  }

                  if (data.assignmentsData) {
                    this.assignmentStore.data = data.assignmentsData;
                  }

                  if (data.eventsData) {
                    this.eventStore.data = data.eventsData;
                  }

                  if (data.dependenciesData) {
                    this.dependencyStore.data = data.dependenciesData;
                  }

                  _context.next = 8;
                  return this.commitLoad();

                case 8:
                  this.isLoadingInlineData = false;
                  return _context.abrupt("return");

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function loadInlineData(_x) {
          return _loadInlineData.apply(this, arguments);
        }

        return loadInlineData;
      }()
    }, {
      key: "commitLoad",
      value: function () {
        var _commitLoad = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee2() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.commitAsync();

                case 2:
                  if (!this.isDestroyed) this.trigger('load');

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function commitLoad() {
          return _commitLoad.apply(this, arguments);
        }

        return commitLoad;
      }()
    }, {
      key: "joinStoreRecords",
      value: function joinStoreRecords(store) {
        var _this = this;

        var fn = function fn(record) {
          record.setProject(_this);
          record.joinProject();
        };

        if (store.rootNode) {
          store.rootNode.traverse(fn);
        } else {
          store.forEach(fn);
        }
      }
    }, {
      key: "unJoinStoreRecords",
      value: function unJoinStoreRecords(store) {
        var _this2 = this;

        var fn = function fn(record) {
          record.leaveProject();
          record.setProject(_this2);
        };

        if (store.rootNode) {
          store.rootNode.traverse(function (node) {
            if (node !== store.rootNode) fn(node);
          });
        } else {
          store.forEach(fn);
        }
      }
    }, {
      key: "resolveStoreAndModelClass",
      value: function resolveStoreAndModelClass(name, config) {
        var storeClass = (config === null || config === void 0 ? void 0 : config.storeClass) || this["".concat(name, "StoreClass")];
        var modelClass = config === null || config === void 0 ? void 0 : config.modelClass;

        if (!modelClass) {
          if (this.getDefaultConfiguration()["".concat(name, "ModelClass")] !== storeClass.defaultConfig.modelClass) {
            modelClass = storeClass.defaultConfig.modelClass;
          } else {
            modelClass = this["".concat(name, "ModelClass")];
          }
        }

        return {
          storeClass: storeClass,
          modelClass: modelClass
        };
      }
    }, {
      key: "setEventStore",
      value: function setEventStore(eventStore) {
        this.eventStore = eventStore;
      }
    }, {
      key: "setAssignmentStore",
      value: function setAssignmentStore(assignmentStore) {
        this.assignmentStore = assignmentStore;
      }
    }, {
      key: "setResourceStore",
      value: function setResourceStore(resourceStore) {
        this.resourceStore = resourceStore;
      }
    }, {
      key: "setDependencyStore",
      value: function setDependencyStore(dependencyStore) {
        this.dependencyStore = dependencyStore;
      }
    }, {
      key: "setCalendarManagerStore",
      value: function setCalendarManagerStore(calendarManagerStore) {
        this.calendarManagerStore = calendarManagerStore;
      }
    }, {
      key: "addEvent",
      value: function () {
        var _addEvent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee3(event) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  this.eventStore.add(event);
                  return _context3.abrupt("return", this.commitAsync());

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function addEvent(_x2) {
          return _addEvent.apply(this, arguments);
        }

        return addEvent;
      }()
    }, {
      key: "addAssignment",
      value: function () {
        var _addAssignment = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee4(assignment) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  this.assignmentStore.add(assignment);
                  return _context4.abrupt("return", this.commitAsync());

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function addAssignment(_x3) {
          return _addAssignment.apply(this, arguments);
        }

        return addAssignment;
      }()
    }, {
      key: "addResource",
      value: function () {
        var _addResource = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee5(resource) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  this.resourceStore.add(resource);
                  return _context5.abrupt("return", this.commitAsync());

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function addResource(_x4) {
          return _addResource.apply(this, arguments);
        }

        return addResource;
      }()
    }, {
      key: "addDependency",
      value: function () {
        var _addDependency = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee6(dependency) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  this.dependencyStore.add(dependency);
                  return _context6.abrupt("return", this.commitAsync());

                case 2:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function addDependency(_x5) {
          return _addDependency.apply(this, arguments);
        }

        return addDependency;
      }()
    }, {
      key: "bufferedCommitAsync",
      value: function bufferedCommitAsync() {
        if (!this.hasPendingAutoCommit) {
          this.setTimeout({
            fn: 'commitAsync',
            delay: 10
          });
        }
      }
    }, {
      key: "unScheduleAutoCommit",
      value: function unScheduleAutoCommit() {
        this.clearTimeout('commitAsync');
      }
    }, {
      key: "commitAsync",
      value: function () {
        var _commitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee7() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!this.isPerformingCommit) {
                    _context7.next = 2;
                    break;
                  }

                  return _context7.abrupt("return", this.ongoing);

                case 2:
                  return _context7.abrupt("return", this.ongoing = this.doCommitAsync());

                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function commitAsync() {
          return _commitAsync.apply(this, arguments);
        }

        return commitAsync;
      }()
    }, {
      key: "doCommitAsync",
      value: function () {
        var _doCommitAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee8() {
          var _iterator, _step, record, isInitialCommit, silenceInitialCommit, silenceCommit, stores, _iterator2, _step2, _record, _iterator3, _step3, _record2;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  this.isPerformingCommit = true;
                  this.unScheduleAutoCommit();
                  _context8.next = 4;
                  return Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_57__["delay"])(0);

                case 4:
                  if (this.isDestroyed) {
                    _context8.next = 28;
                    break;
                  }

                  _iterator = _createForOfIteratorHelper(this.$invalidated);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      record = _step.value;
                      record.calculateInvalidated();
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  isInitialCommit = this.isInitialCommit, silenceInitialCommit = this.silenceInitialCommit;
                  silenceCommit = isInitialCommit && silenceInitialCommit;
                  this.assignmentStore.onCommitAsync();
                  this.dependencyStore.onCommitAsync();
                  this.isInitialCommitPerformed = true;
                  this.hasLoadedDataToCommit = false;
                  this.isPerformingCommit = false;
                  stores = [this.assignmentStore, this.dependencyStore, this.eventStore, this.resourceStore, this.calendarManagerStore];
                  stores.forEach(function (store) {
                    return store.suspendAutoCommit();
                  });
                  this.isWritingData = true;
                  this.trigger('refresh', {
                    isInitialCommit: isInitialCommit
                  });
                  _iterator2 = _createForOfIteratorHelper(this.$invalidated);

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      _record = _step2.value;

                      _record.beginBatch();

                      _record.finalizeInvalidated(isInitialCommit);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }

                  _iterator3 = _createForOfIteratorHelper(this.$invalidated);

                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      _record2 = _step3.value;
                      _record2.ignoreBag = silenceCommit;

                      _record2.endBatch(silenceCommit, true);

                      _record2.ignoreBag = false;
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }

                  this.isWritingData = false;
                  this.$invalidated.clear();
                  this.trigger('dataReady');
                  stores.forEach(function (store) {
                    return store.resumeAutoCommit();
                  });

                  if (silenceCommit) {
                    [this.eventStore, this.dependencyStore, this.resourceStore, this.assignmentStore, this.calendarManagerStore].forEach(function (store) {
                      return store.acceptChanges();
                    });
                  }

                  return _context8.abrupt("return", true);

                case 28:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function doCommitAsync() {
          return _doCommitAsync.apply(this, arguments);
        }

        return doCommitAsync;
      }()
    }, {
      key: "propagateAsync",
      value: function () {
        var _propagateAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee9() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  return _context9.abrupt("return", this.commitAsync());

                case 1:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));

        function propagateAsync() {
          return _propagateAsync.apply(this, arguments);
        }

        return propagateAsync;
      }()
    }, {
      key: "invalidate",
      value: function invalidate(record) {
        this.$invalidated.add(record);
        this.bufferedCommitAsync();
      }
    }, {
      key: "isValidDependency",
      value: function () {
        var _isValidDependency = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee10() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  return _context10.abrupt("return", true);

                case 1:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        function isValidDependency() {
          return _isValidDependency.apply(this, arguments);
        }

        return isValidDependency;
      }()
    }, {
      key: "getStm",
      value: function getStm() {
        return this.stm;
      }
    }, {
      key: "isEngineReady",
      value: function isEngineReady() {
        return !this.hasPendingAutoCommit && !this.isPerformingCommit && this.isInitialCommitPerformed;
      }
    }, {
      key: "eventStore",
      get: function get() {
        return this.$eventStore;
      },
      set: function set(eventStore) {
        var me = this;
        var stm = me.stm;
        var oldStore = me.$eventStore;

        if (!(eventStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var _me$resolveStoreAndMo = me.resolveStoreAndModelClass('event', eventStore),
              storeClass = _me$resolveStoreAndMo.storeClass,
              modelClass = _me$resolveStoreAndMo.modelClass;

          eventStore = new storeClass(Object.assign({
            modelClass: modelClass,
            project: me,
            stm: stm
          }, eventStore));
        } else {
          eventStore.project = me;
          stm.addStore(eventStore);
          me.joinStoreRecords(eventStore);
        }

        if (oldStore && stm.hasStore(oldStore)) {
          stm.removeStore(oldStore);
          me.unJoinStoreRecords(oldStore);
          var assignmentsForRemoval = oldStore.assignmentsForRemoval;
          assignmentsForRemoval.forEach(function (assignment) {
            var oldEvent = assignment.event;

            if (oldEvent) {
              var newEvent = eventStore.getById(oldEvent.id);

              if (newEvent) {
                assignment.event = newEvent;
                assignmentsForRemoval.delete(assignment);
              }
            }
          });
          oldStore.afterEventRemoval();
        }

        eventStore.setProject(me);
        me.$eventStore = eventStore;
        me.trigger('eventStoreChange', {
          store: eventStore
        });
      }
    }, {
      key: "assignmentStore",
      get: function get() {
        return this.$assignmentStore;
      },
      set: function set(assignmentStore) {
        var me = this;
        var stm = me.stm;
        var oldStore = me.$assignmentStore;

        if (oldStore && stm.hasStore(oldStore)) {
          stm.removeStore(oldStore);
          me.unJoinStoreRecords(oldStore);
        }

        if (!(assignmentStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var _me$resolveStoreAndMo2 = me.resolveStoreAndModelClass('assignment', assignmentStore),
              storeClass = _me$resolveStoreAndMo2.storeClass,
              modelClass = _me$resolveStoreAndMo2.modelClass;

          assignmentStore = new storeClass(Object.assign({
            modelClass: modelClass,
            project: me,
            stm: stm
          }, assignmentStore));
        } else {
          assignmentStore.project = me;
          stm.addStore(assignmentStore);
          me.joinStoreRecords(assignmentStore);
        }

        assignmentStore.setProject(me);
        me.$assignmentStore = assignmentStore;
        me.trigger('assignmentStoreChange', {
          store: assignmentStore
        });
      }
    }, {
      key: "resourceStore",
      get: function get() {
        return this.$resourceStore;
      },
      set: function set(resourceStore) {
        var me = this;
        var stm = me.stm;
        var oldStore = me.$resourceStore;

        if (!(resourceStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var _me$resolveStoreAndMo3 = me.resolveStoreAndModelClass('resource', resourceStore),
              storeClass = _me$resolveStoreAndMo3.storeClass,
              modelClass = _me$resolveStoreAndMo3.modelClass;

          resourceStore = new storeClass(Object.assign({
            modelClass: modelClass,
            project: me,
            stm: stm
          }, resourceStore));
        } else {
          resourceStore.project = me;
          stm.addStore(resourceStore);
          me.joinStoreRecords(resourceStore);
        }

        if (oldStore && stm.hasStore(oldStore)) {
          stm.removeStore(oldStore);
          me.unJoinStoreRecords(oldStore);
          var assignmentsForRemoval = oldStore.assignmentsForRemoval;
          assignmentsForRemoval.forEach(function (assignment) {
            var oldResource = assignment.resource;

            if (oldResource) {
              var newResource = resourceStore.getById(oldResource.id);

              if (newResource) {
                assignment.resource = newResource;
                assignmentsForRemoval.delete(assignment);
              }
            }
          });
          oldStore.afterResourceRemoval();
        }

        resourceStore.setProject(me);
        me.$resourceStore = resourceStore;
        me.trigger('resourceStoreChange', {
          store: resourceStore
        });
      }
    }, {
      key: "dependencyStore",
      get: function get() {
        return this.$dependencyStore;
      },
      set: function set(dependencyStore) {
        var me = this;

        if (!(dependencyStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var _me$resolveStoreAndMo4 = me.resolveStoreAndModelClass('dependency', dependencyStore),
              storeClass = _me$resolveStoreAndMo4.storeClass,
              modelClass = _me$resolveStoreAndMo4.modelClass;

          dependencyStore = new storeClass(Object.assign({
            modelClass: modelClass,
            project: me,
            stm: me.stm
          }, dependencyStore));
        } else {
          dependencyStore.project = me;
          me.stm.addStore(dependencyStore);
          me.joinStoreRecords(dependencyStore);
        }

        me.$dependencyStore = dependencyStore;
        me.trigger('dependencyStoreChange', {
          store: dependencyStore
        });
      }
    }, {
      key: "calendarManagerStore",
      get: function get() {
        return this.$calendarManagerStore;
      },
      set: function set(calendarManagerStore) {
        var me = this;

        if (!(calendarManagerStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_43__["default"])) {
          var storeClass = (calendarManagerStore === null || calendarManagerStore === void 0 ? void 0 : calendarManagerStore.storeClass) || me.calendarManagerStoreClass;
          var modelClass = (calendarManagerStore === null || calendarManagerStore === void 0 ? void 0 : calendarManagerStore.modelClass) || storeClass.defaultConfig.modelClass || me.calendarModelClass;
          calendarManagerStore = new storeClass(Object.assign({
            modelClass: modelClass,
            project: me,
            stm: me.stm
          }, calendarManagerStore));
        } else {
          me.stm.addStore(calendarManagerStore);
        }

        calendarManagerStore.setProject(me);
        me.$calendarManagerStore = calendarManagerStore;
        me.trigger('calendarManagerStoreChange', {
          store: calendarManagerStore
        });
      }
    }, {
      key: "calendar",
      get: function get() {
        return this.$calendar || this.defaultCalendar;
      },
      set: function set(calendar) {
        this.$calendar = calendar;
      }
    }, {
      key: "effectiveCalendar",
      get: function get() {
        return this.calendar;
      }
    }, {
      key: "hasPendingAutoCommit",
      get: function get() {
        return this.hasTimeout('commitAsync');
      }
    }, {
      key: "stm",
      set: function set(stm) {
        var _this3 = this;

        stm = this.$stm = new _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_58__["default"](Object.assign({
          disabled: true
        }, stm));
        stm.on({
          restoringStop: function () {
            var _restoringStop = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_35___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.mark(function _callee11() {
              return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_33___default.a.wrap(function _callee11$(_context11) {
                while (1) {
                  switch (_context11.prev = _context11.next) {
                    case 0:
                      stm.disable();
                      _context11.next = 3;
                      return _this3.commitAsync();

                    case 3:
                      if (!_this3.isDestroyed) {
                        stm.enable();

                        _this3.trigger('stateRestoringDone');
                      }

                    case 4:
                    case "end":
                      return _context11.stop();
                  }
                }
              }, _callee11);
            }));

            function restoringStop() {
              return _restoringStop.apply(this, arguments);
            }

            return restoringStop;
          }()
        });
      },
      get: function get() {
        return this.$stm;
      }
    }], [{
      key: "defaultConfig",
      get: function get() {
        return {
          stm: {},
          eventStore: {},
          assignmentStore: {},
          resourceStore: {},
          dependencyStore: {},
          calendarManagerStore: {},
          eventModelClass: _SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_42__["SchedulerCoreEvent"],
          assignmentModelClass: _CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_48__["CoreAssignmentMixin"],
          resourceModelClass: _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_50__["CoreResourceMixin"],
          dependencyModelClass: _CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_54__["CoreDependencyMixin"],
          calendarModelClass: _CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_55__["CoreCalendarMixin"],
          eventStoreClass: _store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_47__["CoreEventStoreMixin"],
          assignmentStoreClass: _store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_49__["CoreAssignmentStoreMixin"],
          resourceStoreClass: _store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_51__["CoreResourceStoreMixin"],
          dependencyStoreClass: _store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_53__["CoreDependencyStoreMixin"],
          calendarManagerStoreClass: _store_CoreCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_56__["CoreCalendarManagerStoreMixin"],
          assignmentsData: null,
          calendarsData: null,
          dependenciesData: null,
          eventsData: null,
          resourcesData: null
        };
      }
    }]);

    return SchedulerCoreProjectMixin;
  }(base);

  SchedulerCoreProjectMixin.applyConfigs = true;
  return SchedulerCoreProjectMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js":
/*!****************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js ***!
  \****************************************************************/
/*! exports provided: AbstractAssignmentStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractAssignmentStoreMixin", function() { return AbstractAssignmentStoreMixin; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../util/Functions.js */ "./lib/Engine/util/Functions.js");





























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var AbstractAssignmentStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default()(AbstractAssignmentStoreMixin, _Mixin);

  var _super = _createSuper(AbstractAssignmentStoreMixin);

  function AbstractAssignmentStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default()(this, AbstractAssignmentStoreMixin);

    return _super.apply(this, arguments);
  }

  return AbstractAssignmentStoreMixin;
}(Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_28__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_29__["AbstractPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var AbstractAssignmentStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default()(AbstractAssignmentStoreMixin, _base);

    var _super2 = _createSuper(AbstractAssignmentStoreMixin);

    function AbstractAssignmentStoreMixin() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default()(this, AbstractAssignmentStoreMixin);

      _this = _super2.apply(this, arguments);
      _this.assignmentsForRemoval = new Set();
      _this.allAssignmentsForRemoval = false;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(AbstractAssignmentStoreMixin, [{
      key: "remove",
      value: function remove(records, silent) {
        this.assignmentsForRemoval = Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_30__["CIFromSetOrArrayOrValue"])(records).toSet();
        var res = superProto.remove.call(this, records);
        this.assignmentsForRemoval.clear();
        return res;
      }
    }, {
      key: "removeAll",
      value: function removeAll(silent) {
        this.allAssignmentsForRemoval = true;
        var res = superProto.removeAll.call(this, silent);
        this.allAssignmentsForRemoval = false;
        return res;
      }
    }]);

    return AbstractAssignmentStoreMixin;
  }(base);

  return AbstractAssignmentStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js ***!
  \*********************************************************************/
/*! exports provided: AbstractCalendarManagerStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractCalendarManagerStoreMixin", function() { return AbstractCalendarManagerStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var AbstractCalendarManagerStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(AbstractCalendarManagerStoreMixin, _Mixin);

  var _super = _createSuper(AbstractCalendarManagerStoreMixin);

  function AbstractCalendarManagerStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, AbstractCalendarManagerStoreMixin);

    return _super.apply(this, arguments);
  }

  return AbstractCalendarManagerStoreMixin;
}(Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_7__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_8__["AbstractPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var AbstractCalendarManagerStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(AbstractCalendarManagerStoreMixin, _base);

    var _super2 = _createSuper(AbstractCalendarManagerStoreMixin);

    function AbstractCalendarManagerStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, AbstractCalendarManagerStoreMixin);

      return _super2.apply(this, arguments);
    }

    return AbstractCalendarManagerStoreMixin;
  }(base);

  return AbstractCalendarManagerStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractDependencyStoreMixin.js":
/*!****************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractDependencyStoreMixin.js ***!
  \****************************************************************/
/*! exports provided: AbstractDependencyStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractDependencyStoreMixin", function() { return AbstractDependencyStoreMixin; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../util/Functions.js */ "./lib/Engine/util/Functions.js");





























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var AbstractDependencyStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default()(AbstractDependencyStoreMixin, _Mixin);

  var _super = _createSuper(AbstractDependencyStoreMixin);

  function AbstractDependencyStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default()(this, AbstractDependencyStoreMixin);

    return _super.apply(this, arguments);
  }

  return AbstractDependencyStoreMixin;
}(Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_28__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_29__["AbstractPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var AbstractDependencyStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default()(AbstractDependencyStoreMixin, _base);

    var _super2 = _createSuper(AbstractDependencyStoreMixin);

    function AbstractDependencyStoreMixin() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default()(this, AbstractDependencyStoreMixin);

      _this = _super2.apply(this, arguments);
      _this.dependenciesForRemoval = new Set();
      _this.allDependenciesForRemoval = false;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(AbstractDependencyStoreMixin, [{
      key: "remove",
      value: function remove(records, silent) {
        this.dependenciesForRemoval = Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_30__["CIFromSetOrArrayOrValue"])(records).toSet();
        var res = superProto.remove.call(this, records);
        this.dependenciesForRemoval.clear();
        return res;
      }
    }, {
      key: "removeAll",
      value: function removeAll(silent) {
        this.allDependenciesForRemoval = true;
        var res = superProto.removeAll.call(this, silent);
        this.allDependenciesForRemoval = false;
        return res;
      }
    }]);

    return AbstractDependencyStoreMixin;
  }(base);

  return AbstractDependencyStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractEventStoreMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractEventStoreMixin.js ***!
  \***********************************************************/
/*! exports provided: AbstractEventStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractEventStoreMixin", function() { return AbstractEventStoreMixin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");





































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var AbstractEventStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default()(AbstractEventStoreMixin, _Mixin);

  var _super = _createSuper(AbstractEventStoreMixin);

  function AbstractEventStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32___default()(this, AbstractEventStoreMixin);

    return _super.apply(this, arguments);
  }

  return AbstractEventStoreMixin;
}(Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_36__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_37__["AbstractPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var AbstractEventStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default()(AbstractEventStoreMixin, _base);

    var _super2 = _createSuper(AbstractEventStoreMixin);

    function AbstractEventStoreMixin() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32___default()(this, AbstractEventStoreMixin);

      _this = _super2.apply(this, arguments);
      _this.assignmentsForRemoval = new Set();
      _this.dependenciesForRemoval = new Set();
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default()(AbstractEventStoreMixin, [{
      key: "remove",
      value: function remove(records, silent) {
        var res = superProto.remove.call(this, records);
        this.afterEventRemoval();
        return res;
      }
    }, {
      key: "afterEventRemoval",
      value: function afterEventRemoval() {
        var assignmentsForRemoval = this.assignmentsForRemoval,
            dependenciesForRemoval = this.dependenciesForRemoval;
        if (!assignmentsForRemoval) return;
        var assignmentStore = this.getAssignmentStore();

        if (assignmentStore && !assignmentStore.allAssignmentsForRemoval && assignmentsForRemoval.size) {
          var toRemove = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(assignmentsForRemoval).filter(function (assignment) {
            return !assignmentStore.assignmentsForRemoval.has(assignment);
          });

          toRemove.length > 0 && assignmentStore.remove(toRemove);
        }

        assignmentsForRemoval.clear();
        var dependencyStore = this.getDependencyStore();

        if (dependencyStore && !dependencyStore.allDependenciesForRemoval && dependenciesForRemoval.size) {
          var _toRemove = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(dependenciesForRemoval).filter(function (dependency) {
            return !dependencyStore.dependenciesForRemoval.has(dependency);
          });

          _toRemove.length > 0 && dependencyStore.remove(_toRemove);
        }

        dependenciesForRemoval.clear();
      }
    }, {
      key: "removeAll",
      value: function removeAll(silent) {
        var res = superProto.removeAll.call(this, silent);
        this.afterEventRemoval();
        return res;
      }
    }, {
      key: "processRecord",
      value: function processRecord(eventRecord) {
        var isDataset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _a;

        if (!((_a = this.project) === null || _a === void 0 ? void 0 : _a.isRepopulatingStores)) {
          var existingRecord = this.getById(eventRecord.id);
          var isReplacing = existingRecord && existingRecord !== eventRecord;

          if (isReplacing) {
            var _iterator = _createForOfIteratorHelper(existingRecord.assigned),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var assignment = _step.value;
                assignment.event = eventRecord;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }

        return eventRecord;
      }
    }]);

    return AbstractEventStoreMixin;
  }(base);

  return AbstractEventStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractResourceStoreMixin.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractResourceStoreMixin.js ***!
  \**************************************************************/
/*! exports provided: AbstractResourceStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractResourceStoreMixin", function() { return AbstractResourceStoreMixin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");





































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_35___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_34___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var AbstractResourceStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default()(AbstractResourceStoreMixin, _Mixin);

  var _super = _createSuper(AbstractResourceStoreMixin);

  function AbstractResourceStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32___default()(this, AbstractResourceStoreMixin);

    return _super.apply(this, arguments);
  }

  return AbstractResourceStoreMixin;
}(Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_36__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_37__["AbstractPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var AbstractResourceStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_33___default()(AbstractResourceStoreMixin, _base);

    var _super2 = _createSuper(AbstractResourceStoreMixin);

    function AbstractResourceStoreMixin() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_32___default()(this, AbstractResourceStoreMixin);

      _this = _super2.apply(this, arguments);
      _this.assignmentsForRemoval = new Set();
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default()(AbstractResourceStoreMixin, [{
      key: "remove",
      value: function remove(records, silent) {
        var res = superProto.remove.call(this, records);
        this.afterResourceRemoval();
        return res;
      }
    }, {
      key: "afterResourceRemoval",
      value: function afterResourceRemoval() {
        var assignmentStore = this.getAssignmentStore();

        if (assignmentStore && !assignmentStore.allAssignmentsForRemoval) {
          var assignmentsForRemoval = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(this.assignmentsForRemoval).filter(function (assignment) {
            return !assignmentStore.assignmentsForRemoval.has(assignment);
          });

          assignmentsForRemoval.length > 0 && assignmentStore.remove(assignmentsForRemoval);
        }

        this.assignmentsForRemoval.clear();
      }
    }, {
      key: "removeAll",
      value: function removeAll(silent) {
        var res = superProto.removeAll.call(this, silent);
        this.afterResourceRemoval();
        return res;
      }
    }, {
      key: "processRecord",
      value: function processRecord(resourceRecord) {
        var isDataset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var existingRecord = this.getById(resourceRecord.id);
        var isReplacing = existingRecord && existingRecord !== resourceRecord;

        if (isReplacing) {
          var _iterator = _createForOfIteratorHelper(existingRecord.assigned),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var assignment = _step.value;
              assignment.resource = resourceRecord;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        return resourceRecord;
      }
    }]);

    return AbstractResourceStoreMixin;
  }(base);

  return AbstractResourceStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoAssignmentStoreMixin.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoAssignmentStoreMixin.js ***!
  \**************************************************************/
/*! exports provided: ChronoAssignmentStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoAssignmentStoreMixin", function() { return ChronoAssignmentStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_basic_BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../model/scheduler_basic/BaseAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./AbstractAssignmentStoreMixin.js */ "./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var ChronoAssignmentStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoAssignmentStoreMixin, _Mixin);

  var _super = _createSuper(ChronoAssignmentStoreMixin);

  function ChronoAssignmentStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoAssignmentStoreMixin);

    return _super.apply(this, arguments);
  }

  return ChronoAssignmentStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__["Mixin"])([_AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__["AbstractAssignmentStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["ChronoPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var ChronoAssignmentStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoAssignmentStoreMixin, _base);

    var _super2 = _createSuper(ChronoAssignmentStoreMixin);

    function ChronoAssignmentStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoAssignmentStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ChronoAssignmentStoreMixin, [{
      key: "data",
      set: function set(value) {
        this.allAssignmentsForRemoval = true;

        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ChronoAssignmentStoreMixin.prototype), "data", value, this, true);

        this.allAssignmentsForRemoval = false;
      }
    }], [{
      key: "defaultConfig",
      get: function get() {
        return {
          modelClass: _model_scheduler_basic_BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_10__["BaseAssignmentMixin"]
        };
      }
    }]);

    return ChronoAssignmentStoreMixin;
  }(base);

  return ChronoAssignmentStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoCalendarManagerStoreMixin.js":
/*!*******************************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoCalendarManagerStoreMixin.js ***!
  \*******************************************************************/
/*! exports provided: ChronoCalendarManagerStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoCalendarManagerStoreMixin", function() { return ChronoCalendarManagerStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../model/scheduler_basic/BaseCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseCalendarMixin.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./AbstractCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var ChronoCalendarManagerStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ChronoCalendarManagerStoreMixin, _Mixin);

  var _super = _createSuper(ChronoCalendarManagerStoreMixin);

  function ChronoCalendarManagerStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ChronoCalendarManagerStoreMixin);

    return _super.apply(this, arguments);
  }

  return ChronoCalendarManagerStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["AbstractCalendarManagerStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["ChronoPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var ChronoCalendarManagerStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ChronoCalendarManagerStoreMixin, _base);

    var _super2 = _createSuper(ChronoCalendarManagerStoreMixin);

    function ChronoCalendarManagerStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ChronoCalendarManagerStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ChronoCalendarManagerStoreMixin, null, [{
      key: "defaultConfig",
      get: function get() {
        return {
          tree: true,
          modelClass: _model_scheduler_basic_BaseCalendarMixin_js__WEBPACK_IMPORTED_MODULE_9__["BaseCalendarMixin"]
        };
      }
    }]);

    return ChronoCalendarManagerStoreMixin;
  }(base);

  return ChronoCalendarManagerStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoDependencyStoreMixin.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoDependencyStoreMixin.js ***!
  \**************************************************************/
/*! exports provided: ChronoDependencyStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoDependencyStoreMixin", function() { return ChronoDependencyStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./AbstractDependencyStoreMixin.js */ "./lib/Engine/quark/store/AbstractDependencyStoreMixin.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var ChronoDependencyStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoDependencyStoreMixin, _Mixin);

  var _super = _createSuper(ChronoDependencyStoreMixin);

  function ChronoDependencyStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoDependencyStoreMixin);

    return _super.apply(this, arguments);
  }

  return ChronoDependencyStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__["Mixin"])([_AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["AbstractDependencyStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["ChronoPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var ChronoDependencyStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoDependencyStoreMixin, _base);

    var _super2 = _createSuper(ChronoDependencyStoreMixin);

    function ChronoDependencyStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoDependencyStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ChronoDependencyStoreMixin, [{
      key: "data",
      set: function set(value) {
        this.allDependenciesForRemoval = true;

        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ChronoDependencyStoreMixin.prototype), "data", value, this, true);

        this.allDependenciesForRemoval = false;
      }
    }]);

    return ChronoDependencyStoreMixin;
  }(base);

  return ChronoDependencyStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoEventStoreMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoEventStoreMixin.js ***!
  \*********************************************************/
/*! exports provided: ChronoEventStoreMixin, ChronoEventTreeStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoEventStoreMixin", function() { return ChronoEventStoreMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoEventTreeStoreMixin", function() { return ChronoEventTreeStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_basic_SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../model/scheduler_basic/SchedulerBasicEvent.js */ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./AbstractEventStoreMixin.js */ "./lib/Engine/quark/store/AbstractEventStoreMixin.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var ChronoEventStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoEventStoreMixin, _Mixin);

  var _super = _createSuper(ChronoEventStoreMixin);

  function ChronoEventStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoEventStoreMixin);

    return _super.apply(this, arguments);
  }

  return ChronoEventStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__["Mixin"])([_AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__["AbstractEventStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["ChronoPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var ChronoEventStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoEventStoreMixin, _base);

    var _super2 = _createSuper(ChronoEventStoreMixin);

    function ChronoEventStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoEventStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ChronoEventStoreMixin, [{
      key: "data",
      set: function set(value) {
        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ChronoEventStoreMixin.prototype), "data", value, this, true);

        this.afterEventRemoval();
      }
    }], [{
      key: "defaultConfig",
      get: function get() {
        return {
          modelClass: _model_scheduler_basic_SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_10__["SchedulerBasicEvent"]
        };
      }
    }]);

    return ChronoEventStoreMixin;
  }(base);

  return ChronoEventStoreMixin;
}));
var ChronoEventTreeStoreMixin = /*#__PURE__*/function (_Mixin2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoEventTreeStoreMixin, _Mixin2);

  var _super3 = _createSuper(ChronoEventTreeStoreMixin);

  function ChronoEventTreeStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoEventTreeStoreMixin);

    return _super3.apply(this, arguments);
  }

  return ChronoEventTreeStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_9__["Mixin"])([ChronoEventStoreMixin], function (base) {
  var superProto = base.prototype;

  var ChronoEventTreeStoreMixin = /*#__PURE__*/function (_base2) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ChronoEventTreeStoreMixin, _base2);

    var _super4 = _createSuper(ChronoEventTreeStoreMixin);

    function ChronoEventTreeStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ChronoEventTreeStoreMixin);

      return _super4.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ChronoEventTreeStoreMixin, [{
      key: "buildRootNode",
      value: function buildRootNode() {
        return this.getProject() || {};
      }
    }], [{
      key: "defaultConfig",
      get: function get() {
        return {
          tree: true
        };
      }
    }]);

    return ChronoEventTreeStoreMixin;
  }(base);

  return ChronoEventTreeStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/ChronoResourceStoreMixin.js":
/*!************************************************************!*\
  !*** ./lib/Engine/quark/store/ChronoResourceStoreMixin.js ***!
  \************************************************************/
/*! exports provided: ChronoResourceStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoResourceStoreMixin", function() { return ChronoResourceStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_basic_BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../model/scheduler_basic/BaseResourceMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js");
/* harmony import */ var _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixin/ChronoPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./AbstractResourceStoreMixin.js */ "./lib/Engine/quark/store/AbstractResourceStoreMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var ChronoResourceStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ChronoResourceStoreMixin, _Mixin);

  var _super = _createSuper(ChronoResourceStoreMixin);

  function ChronoResourceStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ChronoResourceStoreMixin);

    return _super.apply(this, arguments);
  }

  return ChronoResourceStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["AbstractResourceStoreMixin"], _mixin_ChronoPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["ChronoPartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var ChronoResourceStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ChronoResourceStoreMixin, _base);

    var _super2 = _createSuper(ChronoResourceStoreMixin);

    function ChronoResourceStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ChronoResourceStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ChronoResourceStoreMixin, null, [{
      key: "defaultConfig",
      get: function get() {
        return {
          modelClass: _model_scheduler_basic_BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_9__["BaseResourceMixin"]
        };
      }
    }]);

    return ChronoResourceStoreMixin;
  }(base);

  return ChronoResourceStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js":
/*!************************************************************!*\
  !*** ./lib/Engine/quark/store/CoreAssignmentStoreMixin.js ***!
  \************************************************************/
/*! exports provided: CoreAssignmentStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreAssignmentStoreMixin", function() { return CoreAssignmentStoreMixin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../model/scheduler_core/CoreAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./AbstractAssignmentStoreMixin.js */ "./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js");




































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var emptySet = new Set();
var CoreAssignmentStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default()(CoreAssignmentStoreMixin, _Mixin);

  var _super = _createSuper(CoreAssignmentStoreMixin);

  function CoreAssignmentStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31___default()(this, CoreAssignmentStoreMixin);

    return _super.apply(this, arguments);
  }

  return CoreAssignmentStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_36__["Mixin"])([_AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_38__["AbstractAssignmentStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_37__["CorePartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreAssignmentStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default()(CoreAssignmentStoreMixin, _base);

    var _super2 = _createSuper(CoreAssignmentStoreMixin);

    function CoreAssignmentStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31___default()(this, CoreAssignmentStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default()(CoreAssignmentStoreMixin, [{
      key: "getEventsAssignments",
      value: function getEventsAssignments(event) {
        return this.storage.findItem('event', event) || emptySet;
      }
    }, {
      key: "getResourcesAssignments",
      value: function getResourcesAssignments(resource) {
        return this.storage.findItem('resource', resource) || emptySet;
      }
    }, {
      key: "updateIndices",
      value: function updateIndices() {
        this.storage.rebuildIndices();
      }
    }, {
      key: "linkAssignments",
      value: function linkAssignments(store, modelName) {
        var unresolved = this.storage.findItem(modelName, null);

        if (unresolved) {
          this.isBatchAssigning = true;

          var _iterator = _createForOfIteratorHelper(unresolved),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var assignment = _step.value;
              var record = store.getById(assignment.getCurrentOrProposed(modelName));
              if (record) assignment.setChanged(modelName, record);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          this.isBatchAssigning = false;
          this.updateIndices();
        }
      }
    }, {
      key: "onCommitAsync",
      value: function onCommitAsync() {
        this.updateIndices();
      }
    }, {
      key: "data",
      set: function set(value) {
        this.allAssignmentsForRemoval = true;

        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_30___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(CoreAssignmentStoreMixin.prototype), "data", value, this, true);

        this.allAssignmentsForRemoval = false;
      }
    }], [{
      key: "defaultConfig",
      get: function get() {
        return {
          modelClass: _model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_35__["CoreAssignmentMixin"],
          storage: {
            extraKeys: [{
              property: 'event',
              unique: false
            }, {
              property: 'resource',
              unique: false
            }]
          }
        };
      }
    }]);

    return CoreAssignmentStoreMixin;
  }(base);

  return CoreAssignmentStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js":
/*!*****************************************************************!*\
  !*** ./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js ***!
  \*****************************************************************/
/*! exports provided: CoreCalendarManagerStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreCalendarManagerStoreMixin", function() { return CoreCalendarManagerStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _model_scheduler_core_CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../model/scheduler_core/CoreCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js");
/* harmony import */ var _AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./AbstractCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CoreCalendarManagerStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreCalendarManagerStoreMixin, _Mixin);

  var _super = _createSuper(CoreCalendarManagerStoreMixin);

  function CoreCalendarManagerStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreCalendarManagerStoreMixin);

    return _super.apply(this, arguments);
  }

  return CoreCalendarManagerStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["AbstractCalendarManagerStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_9__["CorePartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreCalendarManagerStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreCalendarManagerStoreMixin, _base);

    var _super2 = _createSuper(CoreCalendarManagerStoreMixin);

    function CoreCalendarManagerStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreCalendarManagerStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CoreCalendarManagerStoreMixin, null, [{
      key: "defaultConfig",
      get: function get() {
        return {
          tree: true,
          modelClass: _model_scheduler_core_CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreCalendarMixin"]
        };
      }
    }]);

    return CoreCalendarManagerStoreMixin;
  }(base);

  return CoreCalendarManagerStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js":
/*!************************************************************!*\
  !*** ./lib/Engine/quark/store/CoreDependencyStoreMixin.js ***!
  \************************************************************/
/*! exports provided: CoreDependencyStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreDependencyStoreMixin", function() { return CoreDependencyStoreMixin; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../model/scheduler_core/CoreDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js");
/* harmony import */ var _AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./AbstractDependencyStoreMixin.js */ "./lib/Engine/quark/store/AbstractDependencyStoreMixin.js");






























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var emptySet = new Set();
var CoreDependencyStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default()(CoreDependencyStoreMixin, _Mixin);

  var _super = _createSuper(CoreDependencyStoreMixin);

  function CoreDependencyStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, CoreDependencyStoreMixin);

    return _super.apply(this, arguments);
  }

  return CoreDependencyStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_29__["Mixin"])([_AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_32__["AbstractDependencyStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_30__["CorePartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreDependencyStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default()(CoreDependencyStoreMixin, _base);

    var _super2 = _createSuper(CoreDependencyStoreMixin);

    function CoreDependencyStoreMixin() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, CoreDependencyStoreMixin);

      _this = _super2.apply(this, arguments);
      _this.dependenciesForRemoval = new Set();
      _this.allDependenciesForRemoval = false;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(CoreDependencyStoreMixin, [{
      key: "getIncomingDepsForEvent",
      value: function getIncomingDepsForEvent(event) {
        return this.storage.findItem('toEvent', event) || emptySet;
      }
    }, {
      key: "getOutgoingDepsForEvent",
      value: function getOutgoingDepsForEvent(event) {
        return this.storage.findItem('fromEvent', event) || emptySet;
      }
    }, {
      key: "updateIndices",
      value: function updateIndices() {
        this.storage.rebuildIndices();
      }
    }, {
      key: "onCommitAsync",
      value: function onCommitAsync() {
        this.updateIndices();
      }
    }, {
      key: "data",
      set: function set(value) {
        this.allDependenciesForRemoval = true;

        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(CoreDependencyStoreMixin.prototype), "data", value, this, true);

        this.allDependenciesForRemoval = false;
      }
    }], [{
      key: "defaultConfig",
      get: function get() {
        return {
          modelClass: _model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_31__["CoreDependencyMixin"],
          storage: {
            extraKeys: [{
              property: 'fromEvent',
              unique: false
            }, {
              property: 'toEvent',
              unique: false
            }]
          }
        };
      }
    }]);

    return CoreDependencyStoreMixin;
  }(base);

  return CoreDependencyStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/CoreEventStoreMixin.js":
/*!*******************************************************!*\
  !*** ./lib/Engine/quark/store/CoreEventStoreMixin.js ***!
  \*******************************************************/
/*! exports provided: CoreEventStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreEventStoreMixin", function() { return CoreEventStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../model/scheduler_core/SchedulerCoreEvent.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./AbstractEventStoreMixin.js */ "./lib/Engine/quark/store/AbstractEventStoreMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CoreEventStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreEventStoreMixin, _Mixin);

  var _super = _createSuper(CoreEventStoreMixin);

  function CoreEventStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreEventStoreMixin);

    return _super.apply(this, arguments);
  }

  return CoreEventStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["AbstractEventStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["CorePartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreEventStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreEventStoreMixin, _base);

    var _super2 = _createSuper(CoreEventStoreMixin);

    function CoreEventStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreEventStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CoreEventStoreMixin, [{
      key: "joinProject",
      value: function joinProject() {
        var _a;

        (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'event');
      }
    }, {
      key: "afterLoadData",
      value: function afterLoadData() {
        var _a;

        this.afterEventRemoval();
        (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'event');
      }
    }], [{
      key: "defaultConfig",
      get: function get() {
        return {
          modelClass: _model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_9__["SchedulerCoreEvent"]
        };
      }
    }]);

    return CoreEventStoreMixin;
  }(base);

  return CoreEventStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/CoreResourceStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Engine/quark/store/CoreResourceStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: CoreResourceStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreResourceStoreMixin", function() { return CoreResourceStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../model/scheduler_core/CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
/* harmony import */ var _AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./AbstractResourceStoreMixin.js */ "./lib/Engine/quark/store/AbstractResourceStoreMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CoreResourceStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreResourceStoreMixin, _Mixin);

  var _super = _createSuper(CoreResourceStoreMixin);

  function CoreResourceStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreResourceStoreMixin);

    return _super.apply(this, arguments);
  }

  return CoreResourceStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["AbstractResourceStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_9__["CorePartOfProjectStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var CoreResourceStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CoreResourceStoreMixin, _base);

    var _super2 = _createSuper(CoreResourceStoreMixin);

    function CoreResourceStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CoreResourceStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CoreResourceStoreMixin, [{
      key: "joinProject",
      value: function joinProject() {
        var _a;

        (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'resource');
      }
    }, {
      key: "afterLoadData",
      value: function afterLoadData() {
        var _a;

        (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'resource');
      }
    }], [{
      key: "defaultConfig",
      get: function get() {
        return {
          modelClass: _model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreResourceMixin"]
        };
      }
    }]);

    return CoreResourceStoreMixin;
  }(base);

  return CoreResourceStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js":
/*!*************************************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js ***!
  \*************************************************************************/
/*! exports provided: AbstractPartOfProjectStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectStoreMixin", function() { return AbstractPartOfProjectStoreMixin; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var AbstractPartOfProjectStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(AbstractPartOfProjectStoreMixin, _Mixin);

  var _super = _createSuper(AbstractPartOfProjectStoreMixin);

  function AbstractPartOfProjectStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, AbstractPartOfProjectStoreMixin);

    return _super.apply(this, arguments);
  }

  return AbstractPartOfProjectStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_13__["AbstractPartOfProjectGenericMixin"], _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_14__["default"]], function (base) {
  var superProto = base.prototype;

  var AbstractPartOfProjectStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(AbstractPartOfProjectStoreMixin, _base);

    var _super2 = _createSuper(AbstractPartOfProjectStoreMixin);

    function AbstractPartOfProjectStoreMixin() {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, AbstractPartOfProjectStoreMixin);

      _this = _super2.apply(this, arguments);
      _this.isLoadingData = false;
      return _this;
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(AbstractPartOfProjectStoreMixin, [{
      key: "construct",
      value: function construct() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        config.asyncEvents = {
          add: true,
          remove: true,
          removeAll: true,
          change: true,
          refresh: true,
          replace: true,
          move: true,
          update: true
        };
        return superProto.construct.call(this, config);
      }
    }, {
      key: "trigger",
      value: function trigger(eventName, param) {
        var me = this,
            asyncEvents = me.asyncEvents,
            project = me.project,
            asyncEvent = asyncEvents === null || asyncEvents === void 0 ? void 0 : asyncEvents[eventName],
            asyncAction = asyncEvent && (asyncEvent === true || asyncEvent[param.action]);

        if (!asyncAction) {
          return superProto.trigger.call(me, eventName, param);
        }

        superProto.trigger.call(me, "".concat(eventName, "PreCommit"), Object.assign({}, param));

        if (!project || project.isEngineReady() && !project.isWritingData) {
          superProto.trigger.call(me, eventName, param);
        } else {
          project === null || project === void 0 ? void 0 : project.on({
            dataReady: function dataReady() {
              superProto.trigger.call(me, eventName, param);
            },
            once: true,
            thisObj: this
          });
        }

        return true;
      }
    }, {
      key: "calculateProject",
      value: function calculateProject() {
        return this.project;
      }
    }, {
      key: "setStoreData",
      value: function setStoreData(data) {
        var _a;

        if (this.project) {
          this.project.hasLoadedDataToCommit = true;
        }

        this.isLoadingData = true;
        superProto.setStoreData.call(this, data);
        this.isLoadingData = false;
        (_a = this.project) === null || _a === void 0 ? void 0 : _a.trigger('storeRefresh', {
          store: this
        });
      }
    }, {
      key: "doAutoCommit",
      value: function () {
        var _doAutoCommit = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(this.suspendCount <= 0 && !this.project.isEngineReady())) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return this.project.commitAsync();

                case 3:
                  superProto.doAutoCommit.call(this);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function doAutoCommit() {
          return _doAutoCommit.apply(this, arguments);
        }

        return doAutoCommit;
      }()
    }, {
      key: "addAsync",
      value: function () {
        var _addAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee2(records, silent) {
          var result;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  result = this.add(records, silent);
                  _context2.next = 3;
                  return this.project.commitAsync();

                case 3:
                  return _context2.abrupt("return", result);

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function addAsync(_x, _x2) {
          return _addAsync.apply(this, arguments);
        }

        return addAsync;
      }()
    }, {
      key: "insertAsync",
      value: function () {
        var _insertAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee3(index, records, silent) {
          var result;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  result = this.insert(index, records, silent);
                  _context3.next = 3;
                  return this.project.commitAsync();

                case 3:
                  return _context3.abrupt("return", result);

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function insertAsync(_x3, _x4, _x5) {
          return _insertAsync.apply(this, arguments);
        }

        return insertAsync;
      }()
    }, {
      key: "loadDataAsync",
      value: function () {
        var _loadDataAsync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee4(data) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  this.data = data;
                  _context4.next = 3;
                  return this.project.commitAsync();

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function loadDataAsync(_x6) {
          return _loadDataAsync.apply(this, arguments);
        }

        return loadDataAsync;
      }()
    }]);

    return AbstractPartOfProjectStoreMixin;
  }(base);

  return AbstractPartOfProjectStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js":
/*!***********************************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/ChronoPartOfProjectStoreMixin.js ***!
  \***********************************************************************/
/*! exports provided: ChronoPartOfProjectStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoPartOfProjectStoreMixin", function() { return ChronoPartOfProjectStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../ChronoPartOfProjectGenericMixin.js */ "./lib/Engine/quark/ChronoPartOfProjectGenericMixin.js");
/* harmony import */ var _ChronoStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./ChronoStoreMixin.js */ "./lib/Engine/quark/store/mixin/ChronoStoreMixin.js");
/* harmony import */ var _AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var ChronoPartOfProjectStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ChronoPartOfProjectStoreMixin, _Mixin);

  var _super = _createSuper(ChronoPartOfProjectStoreMixin);

  function ChronoPartOfProjectStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ChronoPartOfProjectStoreMixin);

    return _super.apply(this, arguments);
  }

  return ChronoPartOfProjectStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["AbstractPartOfProjectStoreMixin"], _ChronoPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_9__["ChronoPartOfProjectGenericMixin"], _ChronoStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["ChronoStoreMixin"]], function (base) {
  var superProto = base.prototype;

  var ChronoPartOfProjectStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ChronoPartOfProjectStoreMixin, _base);

    var _super2 = _createSuper(ChronoPartOfProjectStoreMixin);

    function ChronoPartOfProjectStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ChronoPartOfProjectStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ChronoPartOfProjectStoreMixin, [{
      key: "setStoreData",
      value: function setStoreData(data) {
        var _a;

        (_a = this.project) === null || _a === void 0 ? void 0 : _a.repopulateStore(this);
        superProto.setStoreData.call(this, data);
      }
    }]);

    return ChronoPartOfProjectStoreMixin;
  }(base);

  return ChronoPartOfProjectStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/ChronoStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/ChronoStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: ChronoStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChronoStoreMixin", function() { return ChronoStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


var ChronoStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ChronoStoreMixin, _Mixin);

  var _super = _createSuper(ChronoStoreMixin);

  function ChronoStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ChronoStoreMixin);

    return _super.apply(this, arguments);
  }

  return ChronoStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_7__["Mixin"])([_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_8__["default"]], function (base) {
  return /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ChronoStoreMixin, _base);

    var _super2 = _createSuper(ChronoStoreMixin);

    function ChronoStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ChronoStoreMixin);

      return _super2.apply(this, arguments);
    }

    return ChronoStoreMixin;
  }(base);
}));

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js ***!
  \*********************************************************************/
/*! exports provided: CorePartOfProjectStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectStoreMixin", function() { return CorePartOfProjectStoreMixin; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var CorePartOfProjectStoreMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CorePartOfProjectStoreMixin, _Mixin);

  var _super = _createSuper(CorePartOfProjectStoreMixin);

  function CorePartOfProjectStoreMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CorePartOfProjectStoreMixin);

    return _super.apply(this, arguments);
  }

  return CorePartOfProjectStoreMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_8__["Mixin"])([_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["AbstractPartOfProjectStoreMixin"], _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_9__["CorePartOfProjectGenericMixin"], _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_10__["default"]], function (base) {
  var superProto = base.prototype;

  var CorePartOfProjectStoreMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CorePartOfProjectStoreMixin, _base);

    var _super2 = _createSuper(CorePartOfProjectStoreMixin);

    function CorePartOfProjectStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CorePartOfProjectStoreMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CorePartOfProjectStoreMixin, [{
      key: "setProject",
      value: function setProject(project) {
        var result = superProto.setProject.call(this, project);
        if (project) this.joinProject(project);
        return result;
      }
    }, {
      key: "joinProject",
      value: function joinProject(project) {}
    }, {
      key: "onCommitAsync",
      value: function onCommitAsync() {}
    }]);

    return CorePartOfProjectStoreMixin;
  }(base);

  return CorePartOfProjectStoreMixin;
}));

/***/ }),

/***/ "./lib/Engine/scheduling/DurationConverterMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Engine/scheduling/DurationConverterMixin.js ***!
  \*********************************************************/
/*! exports provided: DurationConverterMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DurationConverterMixin", function() { return DurationConverterMixin; });
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../ChronoGraph/replica/Entity.js */ "./lib/ChronoGraph/replica/Entity.js");
/* harmony import */ var _chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../chrono/ChronoModelMixin.js */ "./lib/Engine/chrono/ChronoModelMixin.js");
/* harmony import */ var _chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../chrono/ModelFieldAtom.js */ "./lib/Engine/chrono/ModelFieldAtom.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var DurationConverterMixin = /*#__PURE__*/function (_Mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(DurationConverterMixin, _Mixin);

  var _super = _createSuper(DurationConverterMixin);

  function DurationConverterMixin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, DurationConverterMixin);

    return _super.apply(this, arguments);
  }

  return DurationConverterMixin;
}(Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_12__["Mixin"])([_chrono_ChronoModelMixin_js__WEBPACK_IMPORTED_MODULE_14__["ChronoModelMixin"]], function (base) {
  var superProto = base.prototype;

  var DurationConverterMixin = /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(DurationConverterMixin, _base);

    var _super2 = _createSuper(DurationConverterMixin);

    function DurationConverterMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, DurationConverterMixin);

      return _super2.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(DurationConverterMixin, [{
      key: "calculateUnitsInMs",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function calculateUnitsInMs() {
        var hoursPerDay, daysPerWeek, daysPerMonth;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function calculateUnitsInMs$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$.hoursPerDay;

              case 2:
                hoursPerDay = _context.sent;
                _context.next = 5;
                return this.$.daysPerWeek;

              case 5:
                daysPerWeek = _context.sent;
                _context.next = 8;
                return this.$.daysPerMonth;

              case 8:
                daysPerMonth = _context.sent;
                return _context.abrupt("return", {
                  millisecond: 1,
                  second: 1000,
                  minute: 60 * 1000,
                  hour: 60 * 60 * 1000,
                  day: hoursPerDay * 60 * 60 * 1000,
                  week: daysPerWeek * hoursPerDay * 60 * 60 * 1000,
                  month: daysPerMonth * hoursPerDay * 60 * 60 * 1000,
                  quarter: 3 * daysPerMonth * hoursPerDay * 60 * 60 * 1000,
                  year: 4 * 3 * daysPerMonth * hoursPerDay * 60 * 60 * 1000
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, calculateUnitsInMs, this);
      })
    }, {
      key: "convertDuration",
      value: function convertDuration(duration, fromUnit, toUnit) {
        var result = duration;

        if (fromUnit !== toUnit) {
          result = duration * this.unitsInMs[fromUnit] / this.unitsInMs[toUnit];
        }

        return result;
      }
    }, {
      key: "$convertDuration",
      value: /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function $convertDuration(duration, fromUnit, toUnit) {
        var unitsInMs, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function $convertDuration$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!fromUnit || !toUnit)) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Conversion unit not provided");

              case 2:
                _context2.next = 4;
                return this.$.unitsInMs;

              case 4:
                unitsInMs = _context2.sent;
                result = duration;

                if (fromUnit !== toUnit) {
                  result = duration * unitsInMs[fromUnit] / unitsInMs[toUnit];
                }

                return _context2.abrupt("return", result);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, $convertDuration, this);
      })
    }]);

    return DurationConverterMixin;
  }(base);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__["field"])()], DurationConverterMixin.prototype, "unitsInMs", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_15__["model_field"])({
    type: 'number',
    defaultValue: 24
  })], DurationConverterMixin.prototype, "hoursPerDay", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_15__["model_field"])({
    type: 'number',
    defaultValue: 7
  })], DurationConverterMixin.prototype, "daysPerWeek", void 0);

  __decorate([Object(_chrono_ModelFieldAtom_js__WEBPACK_IMPORTED_MODULE_15__["model_field"])({
    type: 'number',
    defaultValue: 30
  })], DurationConverterMixin.prototype, "daysPerMonth", void 0);

  __decorate([Object(_ChronoGraph_replica_Entity_js__WEBPACK_IMPORTED_MODULE_13__["calculate"])('unitsInMs')], DurationConverterMixin.prototype, "calculateUnitsInMs", null);

  return DurationConverterMixin;
}));

/***/ }),

/***/ "./lib/Engine/scheduling/Types.js":
/*!****************************************!*\
  !*** ./lib/Engine/scheduling/Types.js ***!
  \****************************************/
/*! exports provided: TimeUnit, ConstraintType, SchedulingMode, DependencyValidationResult, DependencyType, DependenciesCalendar, ProjectType, Direction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeUnit", function() { return TimeUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConstraintType", function() { return ConstraintType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulingMode", function() { return SchedulingMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DependencyValidationResult", function() { return DependencyValidationResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DependencyType", function() { return DependencyType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DependenciesCalendar", function() { return DependenciesCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProjectType", function() { return ProjectType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Direction", function() { return Direction; });
var productName = 'scheduler';
var TimeUnit;

(function (TimeUnit) {
  TimeUnit["Millisecond"] = "millisecond";
  TimeUnit["Second"] = "second";
  TimeUnit["Minute"] = "minute";
  TimeUnit["Hour"] = "hour";
  TimeUnit["Day"] = "day";
  TimeUnit["Week"] = "week";
  TimeUnit["Month"] = "month";
  TimeUnit["Quarter"] = "quarter";
  TimeUnit["Year"] = "year";
})(TimeUnit || (TimeUnit = {}));

var ConstraintType;

(function (ConstraintType) {
  ConstraintType["MustStartOn"] = "muststarton";
  ConstraintType["MustFinishOn"] = "mustfinishon";
  ConstraintType["StartNoEarlierThan"] = "startnoearlierthan";
  ConstraintType["StartNoLaterThan"] = "startnolaterthan";
  ConstraintType["FinishNoEarlierThan"] = "finishnoearlierthan";
  ConstraintType["FinishNoLaterThan"] = "finishnolaterthan";
})(ConstraintType || (ConstraintType = {}));

var SchedulingMode;

(function (SchedulingMode) {
  SchedulingMode["Normal"] = "Normal";
  SchedulingMode["FixedDuration"] = "FixedDuration";
  SchedulingMode["FixedEffort"] = "FixedEffort";
  SchedulingMode["FixedUnits"] = "FixedUnits";
})(SchedulingMode || (SchedulingMode = {}));

var DependencyValidationResult;

(function (DependencyValidationResult) {
  DependencyValidationResult[DependencyValidationResult["NoError"] = 0] = "NoError";
  DependencyValidationResult[DependencyValidationResult["CyclicDependency"] = 1] = "CyclicDependency";
  DependencyValidationResult[DependencyValidationResult["DuplicatingDependency"] = 2] = "DuplicatingDependency";
})(DependencyValidationResult || (DependencyValidationResult = {}));

var DependencyType;

(function (DependencyType) {
  DependencyType[DependencyType["StartToStart"] = 0] = "StartToStart";
  DependencyType[DependencyType["StartToEnd"] = 1] = "StartToEnd";
  DependencyType[DependencyType["EndToStart"] = 2] = "EndToStart";
  DependencyType[DependencyType["EndToEnd"] = 3] = "EndToEnd";
})(DependencyType || (DependencyType = {}));

var DependenciesCalendar;

(function (DependenciesCalendar) {
  DependenciesCalendar["Project"] = "Project";
  DependenciesCalendar["FromEvent"] = "FromEvent";
  DependenciesCalendar["ToEvent"] = "ToEvent";
})(DependenciesCalendar || (DependenciesCalendar = {}));

var ProjectType;

(function (ProjectType) {
  ProjectType[ProjectType["SchedulerBasic"] = 1] = "SchedulerBasic";
  ProjectType[ProjectType["SchedulerPro"] = 2] = "SchedulerPro";
  ProjectType[ProjectType["Gantt"] = 3] = "Gantt";
})(ProjectType || (ProjectType = {}));

var Direction;

(function (Direction) {
  Direction["Forward"] = "Forward";
  Direction["Backward"] = "Backward";
  Direction["None"] = "None";
})(Direction || (Direction = {}));

/***/ }),

/***/ "./lib/Engine/util/BinarySearch.js":
/*!*****************************************!*\
  !*** ./lib/Engine/util/BinarySearch.js ***!
  \*****************************************/
/*! exports provided: binarySearch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "binarySearch", function() { return binarySearch; });
var productName = 'scheduler';
var binarySearch = function binarySearch(value, array) {
  var comparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
    return a - b;
  };
  var left = 0;
  var right = array.length;

  while (left < right) {
    var mid = (left + right) / 2 | 0;
    var compare = comparator(value, array[mid]);
    if (compare === 0) return {
      found: true,
      index: mid
    };else if (compare < 0) right = mid;else left = mid + 1;
  }

  return {
    found: false,
    index: right
  };
};

/***/ }),

/***/ "./lib/Engine/util/Constants.js":
/*!**************************************!*\
  !*** ./lib/Engine/util/Constants.js ***!
  \**************************************/
/*! exports provided: MIN_DATE, MAX_DATE, isDateFinite */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIN_DATE", function() { return MIN_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_DATE", function() { return MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDateFinite", function() { return isDateFinite; });
var productName = 'scheduler';
var MIN_DATE = new Date(-8640000000000000);
var MAX_DATE = new Date(8640000000000000);
var isDateFinite = function isDateFinite(date) {
  if (!date) return false;
  var time = date.getTime();
  return time !== MIN_DATE.getTime() && time !== MAX_DATE.getTime();
};

/***/ }),

/***/ "./lib/Engine/util/Functions.js":
/*!**************************************!*\
  !*** ./lib/Engine/util/Functions.js ***!
  \**************************************/
/*! exports provided: isNotNumber, CIFromSetOrArrayOrValue, delay */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNotNumber", function() { return isNotNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIFromSetOrArrayOrValue", function() { return CIFromSetOrArrayOrValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return delay; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../ChronoGraph/collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");























var productName = 'scheduler';

var isNotNumber = function isNotNumber(value) {
  return Number(value) !== value;
};
var CIFromSetOrArrayOrValue = function CIFromSetOrArrayOrValue(value) {
  if (value instanceof Set || value instanceof Array) return Object(_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_23__["CI"])(value);
  return Object(_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_23__["CI"])([value]);
};
var delay = function delay(value) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, value);
  });
};

/***/ }),

/***/ "./lib/Engine/util/StripDuplicates.js":
/*!********************************************!*\
  !*** ./lib/Engine/util/StripDuplicates.js ***!
  \********************************************/
/*! exports provided: stripDuplicates */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stripDuplicates", function() { return stripDuplicates; });
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_21__);






















var productName = 'scheduler';
var stripDuplicates = function stripDuplicates(array) {
  return Array.from(new Set(array));
};

/***/ }),

/***/ "./lib/Engine/util/Types.js":
/*!**********************************!*\
  !*** ./lib/Engine/util/Types.js ***!
  \**********************************/
/*! exports provided: EdgeInclusion */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeInclusion", function() { return EdgeInclusion; });
var productName = 'scheduler';
var EdgeInclusion;

(function (EdgeInclusion) {
  EdgeInclusion[EdgeInclusion["Left"] = 0] = "Left";
  EdgeInclusion[EdgeInclusion["Right"] = 1] = "Right";
})(EdgeInclusion || (EdgeInclusion = {}));

/***/ }),

/***/ "./lib/Engine/vendor/later/later.js":
/*!******************************************!*\
  !*** ./lib/Engine/vendor/later/later.js ***!
  \******************************************/
/*! exports provided: later, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "later", function() { return later; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_string_at__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.string.at */ "./node_modules/core-js/modules/esnext.string.at.js");
/* harmony import */ var core_js_modules_esnext_string_at__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_string_at__WEBPACK_IMPORTED_MODULE_13__);














var productName = 'scheduler';
/**
* The code just copy/pasted from pre-built later.js file and made exported
*
* @private
*/
// @ts-ignore

var later = function () {
  // @ts-ignore
  "use strict"; // @ts-ignore

  var later = {
    // @ts-ignore
    version: "1.2.0" // @ts-ignore

  }; // @ts-ignore

  if (!Array.prototype.indexOf) {
    // @ts-ignore
    Array.prototype.indexOf = function (searchElement) {
      // @ts-ignore
      "use strict"; // @ts-ignore

      if (this == null) {
        // @ts-ignore
        throw new TypeError(); // @ts-ignore
      } // @ts-ignore


      var t = Object(this); // @ts-ignore

      var len = t.length >>> 0; // @ts-ignore

      if (len === 0) {
        // @ts-ignore
        return -1; // @ts-ignore
      } // @ts-ignore


      var n = 0; // @ts-ignore

      if (arguments.length > 1) {
        // @ts-ignore
        n = Number(arguments[1]); // @ts-ignore

        if (n != n) {
          // @ts-ignore
          n = 0; // @ts-ignore
        } else if (n != 0 && n != Infinity && n != -Infinity) {
          // @ts-ignore
          n = (n > 0 || -1) * Math.floor(Math.abs(n)); // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore


      if (n >= len) {
        // @ts-ignore
        return -1; // @ts-ignore
      } // @ts-ignore


      var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0); // @ts-ignore

      for (; k < len; k++) {
        // @ts-ignore
        if (k in t && t[k] === searchElement) {
          // @ts-ignore
          return k; // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore


      return -1; // @ts-ignore
    }; // @ts-ignore

  } // @ts-ignore


  if (!String.prototype.trim) {
    // @ts-ignore
    String.prototype.trim = function () {
      // @ts-ignore
      return this.replace(/^\s+|\s+$/g, ""); // @ts-ignore
    }; // @ts-ignore

  } // @ts-ignore


  later.array = {}; // @ts-ignore

  later.array.sort = function (arr, zeroIsLast) {
    // @ts-ignore
    arr.sort(function (a, b) {
      // @ts-ignore
      return +a - +b; // @ts-ignore
    }); // @ts-ignore

    if (zeroIsLast && arr[0] === 0) {
      // @ts-ignore
      arr.push(arr.shift()); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore


  later.array.next = function (val, values, extent) {
    // @ts-ignore
    var cur,
        zeroIsLargest = extent[0] !== 0,
        nextIdx = 0; // @ts-ignore

    for (var i = values.length - 1; i > -1; --i) {
      // @ts-ignore
      cur = values[i]; // @ts-ignore

      if (cur === val) {
        // @ts-ignore
        return cur; // @ts-ignore
      } // @ts-ignore


      if (cur > val || cur === 0 && zeroIsLargest && extent[1] > val) {
        // @ts-ignore
        nextIdx = i; // @ts-ignore

        continue; // @ts-ignore
      } // @ts-ignore


      break; // @ts-ignore
    } // @ts-ignore


    return values[nextIdx]; // @ts-ignore
  }; // @ts-ignore


  later.array.nextInvalid = function (val, values, extent) {
    // @ts-ignore
    var min = extent[0],
        max = extent[1],
        len = values.length,
        zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0,
        next = val,
        i = values.indexOf(val),
        start = next; // @ts-ignore

    while (next === (values[i] || zeroVal)) {
      // @ts-ignore
      next++; // @ts-ignore

      if (next > max) {
        // @ts-ignore
        next = min; // @ts-ignore
      } // @ts-ignore


      i++; // @ts-ignore

      if (i === len) {
        // @ts-ignore
        i = 0; // @ts-ignore
      } // @ts-ignore


      if (next === start) {
        // @ts-ignore
        return undefined; // @ts-ignore
      } // @ts-ignore

    } // @ts-ignore


    return next; // @ts-ignore
  }; // @ts-ignore


  later.array.prev = function (val, values, extent) {
    // @ts-ignore
    var cur,
        len = values.length,
        zeroIsLargest = extent[0] !== 0,
        prevIdx = len - 1; // @ts-ignore

    for (var i = 0; i < len; i++) {
      // @ts-ignore
      cur = values[i]; // @ts-ignore

      if (cur === val) {
        // @ts-ignore
        return cur; // @ts-ignore
      } // @ts-ignore


      if (cur < val || cur === 0 && zeroIsLargest && extent[1] < val) {
        // @ts-ignore
        prevIdx = i; // @ts-ignore

        continue; // @ts-ignore
      } // @ts-ignore


      break; // @ts-ignore
    } // @ts-ignore


    return values[prevIdx]; // @ts-ignore
  }; // @ts-ignore


  later.array.prevInvalid = function (val, values, extent) {
    // @ts-ignore
    var min = extent[0],
        max = extent[1],
        len = values.length,
        zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0,
        next = val,
        i = values.indexOf(val),
        start = next; // @ts-ignore

    while (next === (values[i] || zeroVal)) {
      // @ts-ignore
      next--; // @ts-ignore

      if (next < min) {
        // @ts-ignore
        next = max; // @ts-ignore
      } // @ts-ignore


      i--; // @ts-ignore

      if (i === -1) {
        // @ts-ignore
        i = len - 1; // @ts-ignore
      } // @ts-ignore


      if (next === start) {
        // @ts-ignore
        return undefined; // @ts-ignore
      } // @ts-ignore

    } // @ts-ignore


    return next; // @ts-ignore
  }; // @ts-ignore


  later.day = later.D = {
    // @ts-ignore
    name: "day",
    // @ts-ignore
    range: 86400,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.D || (d.D = later.date.getDate.call(d)); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.D.val(d) === (val || later.D.extent(d)[1]); // @ts-ignore
    },
    // @ts-ignore
    extent: function extent(d) {
      // @ts-ignore
      if (d.DExtent) return d.DExtent; // @ts-ignore

      var month = later.M.val(d),
          max = later.DAYS_IN_MONTH[month - 1]; // @ts-ignore

      if (month === 2 && later.dy.extent(d)[1] === 366) {
        // @ts-ignore
        max = max + 1; // @ts-ignore
      } // @ts-ignore


      return d.DExtent = [1, max]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d.DStart || (d.DStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d))); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d.DEnd || (d.DEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d))); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      val = val > later.D.extent(d)[1] ? 1 : val; // @ts-ignore

      var month = later.date.nextRollover(d, val, later.D, later.M),
          DMax = later.D.extent(month)[1]; // @ts-ignore

      val = val > DMax ? 1 : val || DMax; // @ts-ignore

      return later.date.next(later.Y.val(month), later.M.val(month), val); // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      var month = later.date.prevRollover(d, val, later.D, later.M),
          DMax = later.D.extent(month)[1]; // @ts-ignore

      return later.date.prev(later.Y.val(month), later.M.val(month), val > DMax ? DMax : val || DMax); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.dayOfWeekCount = later.dc = {
    // @ts-ignore
    name: "day of week count",
    // @ts-ignore
    range: 604800,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.dc || (d.dc = Math.floor((later.D.val(d) - 1) / 7) + 1); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.dc.val(d) === val || val === 0 && later.D.val(d) > later.D.extent(d)[1] - 7; // @ts-ignore
    },
    // @ts-ignore
    extent: function extent(d) {
      // @ts-ignore
      return d.dcExtent || (d.dcExtent = [1, Math.ceil(later.D.extent(d)[1] / 7)]); // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d.dcStart || (d.dcStart = later.date.next(later.Y.val(d), later.M.val(d), Math.max(1, (later.dc.val(d) - 1) * 7 + 1 || 1))); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d.dcEnd || (d.dcEnd = later.date.prev(later.Y.val(d), later.M.val(d), Math.min(later.dc.val(d) * 7, later.D.extent(d)[1]))); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      val = val > later.dc.extent(d)[1] ? 1 : val; // @ts-ignore

      var month = later.date.nextRollover(d, val, later.dc, later.M),
          dcMax = later.dc.extent(month)[1]; // @ts-ignore

      val = val > dcMax ? 1 : val; // @ts-ignore

      var next = later.date.next(later.Y.val(month), later.M.val(month), val === 0 ? later.D.extent(month)[1] - 6 : 1 + 7 * (val - 1)); // @ts-ignore

      if (next.getTime() <= d.getTime()) {
        // @ts-ignore
        month = later.M.next(d, later.M.val(d) + 1); // @ts-ignore

        return later.date.next(later.Y.val(month), later.M.val(month), val === 0 ? later.D.extent(month)[1] - 6 : 1 + 7 * (val - 1)); // @ts-ignore
      } // @ts-ignore


      return next; // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      var month = later.date.prevRollover(d, val, later.dc, later.M),
          dcMax = later.dc.extent(month)[1]; // @ts-ignore

      val = val > dcMax ? dcMax : val || dcMax; // @ts-ignore

      return later.dc.end(later.date.prev(later.Y.val(month), later.M.val(month), 1 + 7 * (val - 1))); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.dayOfWeek = later.dw = later.d = {
    // @ts-ignore
    name: "day of week",
    // @ts-ignore
    range: 86400,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.dw || (d.dw = later.date.getDay.call(d) + 1); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.dw.val(d) === (val || 7); // @ts-ignore
    },
    // @ts-ignore
    extent: function extent() {
      // @ts-ignore
      return [1, 7]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return later.D.start(d); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return later.D.end(d); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      val = val > 7 ? 1 : val || 7; // @ts-ignore

      return later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val - later.dw.val(d)) + (val <= later.dw.val(d) ? 7 : 0)); // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      val = val > 7 ? 7 : val || 7; // @ts-ignore

      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (val - later.dw.val(d)) + (val >= later.dw.val(d) ? -7 : 0)); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.dayOfYear = later.dy = {
    // @ts-ignore
    name: "day of year",
    // @ts-ignore
    range: 86400,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.dy || (d.dy = Math.ceil(1 + (later.D.start(d).getTime() - later.Y.start(d).getTime()) / later.DAY)); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.dy.val(d) === (val || later.dy.extent(d)[1]); // @ts-ignore
    },
    // @ts-ignore
    extent: function extent(d) {
      // @ts-ignore
      var year = later.Y.val(d); // @ts-ignore

      return d.dyExtent || (d.dyExtent = [1, year % 4 ? 365 : 366]); // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return later.D.start(d); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return later.D.end(d); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      val = val > later.dy.extent(d)[1] ? 1 : val; // @ts-ignore

      var year = later.date.nextRollover(d, val, later.dy, later.Y),
          dyMax = later.dy.extent(year)[1]; // @ts-ignore

      val = val > dyMax ? 1 : val || dyMax; // @ts-ignore

      return later.date.next(later.Y.val(year), later.M.val(year), val); // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      var year = later.date.prevRollover(d, val, later.dy, later.Y),
          dyMax = later.dy.extent(year)[1]; // @ts-ignore

      val = val > dyMax ? dyMax : val || dyMax; // @ts-ignore

      return later.date.prev(later.Y.val(year), later.M.val(year), val); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.hour = later.h = {
    // @ts-ignore
    name: "hour",
    // @ts-ignore
    range: 3600,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.h || (d.h = later.date.getHour.call(d)); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.h.val(d) === val; // @ts-ignore
    },
    // @ts-ignore
    extent: function extent() {
      // @ts-ignore
      return [0, 23]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d.hStart || (d.hStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d))); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d.hEnd || (d.hEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d))); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      val = val > 23 ? 0 : val; // @ts-ignore

      var next = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val <= later.h.val(d) ? 1 : 0), val); // @ts-ignore

      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
        // @ts-ignore
        next = later.date.next(later.Y.val(next), later.M.val(next), later.D.val(next), val + 1); // @ts-ignore
      } // @ts-ignore


      return next; // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      val = val > 23 ? 23 : val; // @ts-ignore

      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (val >= later.h.val(d) ? -1 : 0), val); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.minute = later.m = {
    // @ts-ignore
    name: "minute",
    // @ts-ignore
    range: 60,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.m || (d.m = later.date.getMin.call(d)); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.m.val(d) === val; // @ts-ignore
    },
    // @ts-ignore
    extent: function extent(d) {
      // @ts-ignore
      return [0, 59]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d.mStart || (d.mStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d))); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d.mEnd || (d.mEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d))); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      var m = later.m.val(d),
          s = later.s.val(d),
          inc = val > 59 ? 60 - m : val <= m ? 60 - m + val : val - m,
          next = new Date(d.getTime() + inc * later.MIN - s * later.SEC); // @ts-ignore

      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
        // @ts-ignore
        next = new Date(d.getTime() + (inc + 120) * later.MIN - s * later.SEC); // @ts-ignore
      } // @ts-ignore


      return next; // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      val = val > 59 ? 59 : val; // @ts-ignore

      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d) + (val >= later.m.val(d) ? -1 : 0), val); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.month = later.M = {
    // @ts-ignore
    name: "month",
    // @ts-ignore
    range: 2629740,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.M || (d.M = later.date.getMonth.call(d) + 1); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.M.val(d) === (val || 12); // @ts-ignore
    },
    // @ts-ignore
    extent: function extent() {
      // @ts-ignore
      return [1, 12]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d.MStart || (d.MStart = later.date.next(later.Y.val(d), later.M.val(d))); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d.MEnd || (d.MEnd = later.date.prev(later.Y.val(d), later.M.val(d))); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      val = val > 12 ? 1 : val || 12; // @ts-ignore

      return later.date.next(later.Y.val(d) + (val > later.M.val(d) ? 0 : 1), val); // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      val = val > 12 ? 12 : val || 12; // @ts-ignore

      return later.date.prev(later.Y.val(d) - (val >= later.M.val(d) ? 1 : 0), val); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.second = later.s = {
    // @ts-ignore
    name: "second",
    // @ts-ignore
    range: 1,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.s || (d.s = later.date.getSec.call(d)); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.s.val(d) === val; // @ts-ignore
    },
    // @ts-ignore
    extent: function extent() {
      // @ts-ignore
      return [0, 59]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d; // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d; // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      var s = later.s.val(d),
          inc = val > 59 ? 60 - s : val <= s ? 60 - s + val : val - s,
          next = new Date(d.getTime() + inc * later.SEC); // @ts-ignore

      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
        // @ts-ignore
        next = new Date(d.getTime() + (inc + 7200) * later.SEC); // @ts-ignore
      } // @ts-ignore


      return next; // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val, cache) {
      // @ts-ignore
      val = val > 59 ? 59 : val; // @ts-ignore

      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d) + (val >= later.s.val(d) ? -1 : 0), val); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.time = later.t = {
    // @ts-ignore
    name: "time",
    // @ts-ignore
    range: 1,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.t || (d.t = later.h.val(d) * 3600 + later.m.val(d) * 60 + later.s.val(d)); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.t.val(d) === val; // @ts-ignore
    },
    // @ts-ignore
    extent: function extent() {
      // @ts-ignore
      return [0, 86399]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d; // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d; // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      val = val > 86399 ? 0 : val; // @ts-ignore

      var next = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val <= later.t.val(d) ? 1 : 0), 0, 0, val); // @ts-ignore

      if (!later.date.isUTC && next.getTime() < d.getTime()) {
        // @ts-ignore
        next = later.date.next(later.Y.val(next), later.M.val(next), later.D.val(next), later.h.val(next), later.m.val(next), val + 7200); // @ts-ignore
      } // @ts-ignore


      return next; // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      val = val > 86399 ? 86399 : val; // @ts-ignore

      return later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val >= later.t.val(d) ? -1 : 0), 0, 0, val); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.weekOfMonth = later.wm = {
    // @ts-ignore
    name: "week of month",
    // @ts-ignore
    range: 604800,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.wm || (d.wm = (later.D.val(d) + (later.dw.val(later.M.start(d)) - 1) + (7 - later.dw.val(d))) / 7); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.wm.val(d) === (val || later.wm.extent(d)[1]); // @ts-ignore
    },
    // @ts-ignore
    extent: function extent(d) {
      // @ts-ignore
      return d.wmExtent || (d.wmExtent = [1, (later.D.extent(d)[1] + (later.dw.val(later.M.start(d)) - 1) + (7 - later.dw.val(later.M.end(d)))) / 7]); // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d.wmStart || (d.wmStart = later.date.next(later.Y.val(d), later.M.val(d), Math.max(later.D.val(d) - later.dw.val(d) + 1, 1))); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d.wmEnd || (d.wmEnd = later.date.prev(later.Y.val(d), later.M.val(d), Math.min(later.D.val(d) + (7 - later.dw.val(d)), later.D.extent(d)[1]))); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      val = val > later.wm.extent(d)[1] ? 1 : val; // @ts-ignore

      var month = later.date.nextRollover(d, val, later.wm, later.M),
          wmMax = later.wm.extent(month)[1]; // @ts-ignore

      val = val > wmMax ? 1 : val || wmMax; // @ts-ignore

      return later.date.next(later.Y.val(month), later.M.val(month), Math.max(1, (val - 1) * 7 - (later.dw.val(month) - 2))); // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      var month = later.date.prevRollover(d, val, later.wm, later.M),
          wmMax = later.wm.extent(month)[1]; // @ts-ignore

      val = val > wmMax ? wmMax : val || wmMax; // @ts-ignore

      return later.wm.end(later.date.next(later.Y.val(month), later.M.val(month), Math.max(1, (val - 1) * 7 - (later.dw.val(month) - 2)))); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.weekOfYear = later.wy = {
    // @ts-ignore
    name: "week of year (ISO)",
    // @ts-ignore
    range: 604800,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      if (d.wy) return d.wy; // @ts-ignore

      var wThur = later.dw.next(later.wy.start(d), 5),
          YThur = later.dw.next(later.Y.prev(wThur, later.Y.val(wThur) - 1), 5); // @ts-ignore

      return d.wy = 1 + Math.ceil((wThur.getTime() - YThur.getTime()) / later.WEEK); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.wy.val(d) === (val || later.wy.extent(d)[1]); // @ts-ignore
    },
    // @ts-ignore
    extent: function extent(d) {
      // @ts-ignore
      if (d.wyExtent) return d.wyExtent; // @ts-ignore

      var year = later.dw.next(later.wy.start(d), 5),
          dwFirst = later.dw.val(later.Y.start(year)),
          dwLast = later.dw.val(later.Y.end(year)); // @ts-ignore

      return d.wyExtent = [1, dwFirst === 5 || dwLast === 5 ? 53 : 52]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d.wyStart || (d.wyStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) - (later.dw.val(d) > 1 ? later.dw.val(d) - 2 : 6))); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d.wyEnd || (d.wyEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (later.dw.val(d) > 1 ? 8 - later.dw.val(d) : 0))); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      val = val > later.wy.extent(d)[1] ? 1 : val; // @ts-ignore

      var wyThur = later.dw.next(later.wy.start(d), 5),
          year = later.date.nextRollover(wyThur, val, later.wy, later.Y); // @ts-ignore

      if (later.wy.val(year) !== 1) {
        // @ts-ignore
        year = later.dw.next(year, 2); // @ts-ignore
      } // @ts-ignore


      var wyMax = later.wy.extent(year)[1],
          wyStart = later.wy.start(year); // @ts-ignore

      val = val > wyMax ? 1 : val || wyMax; // @ts-ignore

      return later.date.next(later.Y.val(wyStart), later.M.val(wyStart), later.D.val(wyStart) + 7 * (val - 1)); // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      var wyThur = later.dw.next(later.wy.start(d), 5),
          year = later.date.prevRollover(wyThur, val, later.wy, later.Y); // @ts-ignore

      if (later.wy.val(year) !== 1) {
        // @ts-ignore
        year = later.dw.next(year, 2); // @ts-ignore
      } // @ts-ignore


      var wyMax = later.wy.extent(year)[1],
          wyEnd = later.wy.end(year); // @ts-ignore

      val = val > wyMax ? wyMax : val || wyMax; // @ts-ignore

      return later.wy.end(later.date.next(later.Y.val(wyEnd), later.M.val(wyEnd), later.D.val(wyEnd) + 7 * (val - 1))); // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.year = later.Y = {
    // @ts-ignore
    name: "year",
    // @ts-ignore
    range: 31556900,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.Y || (d.Y = later.date.getYear.call(d)); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.Y.val(d) === val; // @ts-ignore
    },
    // @ts-ignore
    extent: function extent() {
      // @ts-ignore
      return [1970, 2099]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d.YStart || (d.YStart = later.date.next(later.Y.val(d))); // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d.YEnd || (d.YEnd = later.date.prev(later.Y.val(d))); // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      return val > later.Y.val(d) && val <= later.Y.extent()[1] ? later.date.next(val) : later.NEVER; // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      return val < later.Y.val(d) && val >= later.Y.extent()[0] ? later.date.prev(val) : later.NEVER; // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.fullDate = later.fd = {
    // @ts-ignore
    name: "full date",
    // @ts-ignore
    range: 1,
    // @ts-ignore
    val: function val(d) {
      // @ts-ignore
      return d.fd || (d.fd = d.getTime()); // @ts-ignore
    },
    // @ts-ignore
    isValid: function isValid(d, val) {
      // @ts-ignore
      return later.fd.val(d) === val; // @ts-ignore
    },
    // @ts-ignore
    extent: function extent() {
      // @ts-ignore
      return [0, 3250368e7]; // @ts-ignore
    },
    // @ts-ignore
    start: function start(d) {
      // @ts-ignore
      return d; // @ts-ignore
    },
    // @ts-ignore
    end: function end(d) {
      // @ts-ignore
      return d; // @ts-ignore
    },
    // @ts-ignore
    next: function next(d, val) {
      // @ts-ignore
      return later.fd.val(d) < val ? new Date(val) : later.NEVER; // @ts-ignore
    },
    // @ts-ignore
    prev: function prev(d, val) {
      // @ts-ignore
      return later.fd.val(d) > val ? new Date(val) : later.NEVER; // @ts-ignore
    } // @ts-ignore

  }; // @ts-ignore

  later.modifier = {}; // @ts-ignore

  later.modifier.after = later.modifier.a = function (constraint, values) {
    // @ts-ignore
    var value = values[0]; // @ts-ignore

    return {
      // @ts-ignore
      name: "after " + constraint.name,
      // @ts-ignore
      range: (constraint.extent(new Date())[1] - value) * constraint.range,
      // @ts-ignore
      val: constraint.val,
      // @ts-ignore
      isValid: function isValid(d, val) {
        // @ts-ignore
        return this.val(d) >= value; // @ts-ignore
      },
      // @ts-ignore
      extent: constraint.extent,
      // @ts-ignore
      start: constraint.start,
      // @ts-ignore
      end: constraint.end,
      // @ts-ignore
      next: function next(startDate, val) {
        // @ts-ignore
        if (val != value) val = constraint.extent(startDate)[0]; // @ts-ignore

        return constraint.next(startDate, val); // @ts-ignore
      },
      // @ts-ignore
      prev: function prev(startDate, val) {
        // @ts-ignore
        val = val === value ? constraint.extent(startDate)[1] : value - 1; // @ts-ignore

        return constraint.prev(startDate, val); // @ts-ignore
      } // @ts-ignore

    }; // @ts-ignore
  }; // @ts-ignore


  later.modifier.before = later.modifier.b = function (constraint, values) {
    // @ts-ignore
    var value = values[values.length - 1]; // @ts-ignore

    return {
      // @ts-ignore
      name: "before " + constraint.name,
      // @ts-ignore
      range: constraint.range * (value - 1),
      // @ts-ignore
      val: constraint.val,
      // @ts-ignore
      isValid: function isValid(d, val) {
        // @ts-ignore
        return this.val(d) < value; // @ts-ignore
      },
      // @ts-ignore
      extent: constraint.extent,
      // @ts-ignore
      start: constraint.start,
      // @ts-ignore
      end: constraint.end,
      // @ts-ignore
      next: function next(startDate, val) {
        // @ts-ignore
        val = val === value ? constraint.extent(startDate)[0] : value; // @ts-ignore

        return constraint.next(startDate, val); // @ts-ignore
      },
      // @ts-ignore
      prev: function prev(startDate, val) {
        // @ts-ignore
        val = val === value ? value - 1 : constraint.extent(startDate)[1]; // @ts-ignore

        return constraint.prev(startDate, val); // @ts-ignore
      } // @ts-ignore

    }; // @ts-ignore
  }; // @ts-ignore


  later.compile = function (schedDef) {
    // @ts-ignore
    var constraints = [],
        constraintsLen = 0,
        tickConstraint; // @ts-ignore

    for (var key in schedDef) {
      // @ts-ignore
      var nameParts = key.split("_"),
          name = nameParts[0],
          mod = nameParts[1],
          vals = schedDef[key],
          constraint = mod ? later.modifier[mod](later[name], vals) : later[name]; // @ts-ignore

      constraints.push({
        // @ts-ignore
        constraint: constraint,
        // @ts-ignore
        vals: vals // @ts-ignore

      }); // @ts-ignore

      constraintsLen++; // @ts-ignore
    } // @ts-ignore


    constraints.sort(function (a, b) {
      // @ts-ignore
      var ra = a.constraint.range,
          rb = b.constraint.range; // @ts-ignore

      return rb < ra ? -1 : rb > ra ? 1 : 0; // @ts-ignore
    }); // @ts-ignore

    tickConstraint = constraints[constraintsLen - 1].constraint; // @ts-ignore

    function compareFn(dir) {
      // @ts-ignore
      return dir === "next" ? function (a, b) {
        // @ts-ignore
        return a.getTime() > b.getTime(); // @ts-ignore
      } : function (a, b) {
        // @ts-ignore
        return b.getTime() > a.getTime(); // @ts-ignore
      }; // @ts-ignore
    } // @ts-ignore


    return {
      // @ts-ignore
      start: function start(dir, startDate) {
        // @ts-ignore
        var next = startDate,
            nextVal = later.array[dir],
            maxAttempts = 1e3,
            done; // @ts-ignore

        while (maxAttempts-- && !done && next) {
          // @ts-ignore
          done = true; // @ts-ignore

          for (var i = 0; i < constraintsLen; i++) {
            // @ts-ignore
            var constraint = constraints[i].constraint,
                curVal = constraint.val(next),
                extent = constraint.extent(next),
                newVal = nextVal(curVal, constraints[i].vals, extent); // @ts-ignore

            if (!constraint.isValid(next, newVal)) {
              // @ts-ignore
              next = constraint[dir](next, newVal); // @ts-ignore

              done = false; // @ts-ignore

              break; // @ts-ignore
            } // @ts-ignore

          } // @ts-ignore

        } // @ts-ignore


        if (next !== later.NEVER) {
          // @ts-ignore
          next = dir === "next" ? tickConstraint.start(next) : tickConstraint.end(next); // @ts-ignore
        } // @ts-ignore


        return next; // @ts-ignore
      },
      // @ts-ignore
      end: function end(dir, startDate) {
        // @ts-ignore
        var result,
            nextVal = later.array[dir + "Invalid"],
            compare = compareFn(dir); // @ts-ignore

        for (var i = constraintsLen - 1; i >= 0; i--) {
          // @ts-ignore
          var constraint = constraints[i].constraint,
              curVal = constraint.val(startDate),
              extent = constraint.extent(startDate),
              newVal = nextVal(curVal, constraints[i].vals, extent),
              next; // @ts-ignore

          if (newVal !== undefined) {
            // @ts-ignore
            next = constraint[dir](startDate, newVal); // @ts-ignore

            if (next && (!result || compare(result, next))) {
              // @ts-ignore
              result = next; // @ts-ignore
            } // @ts-ignore

          } // @ts-ignore

        } // @ts-ignore


        return result; // @ts-ignore
      },
      // @ts-ignore
      tick: function tick(dir, date) {
        // @ts-ignore
        return new Date(dir === "next" ? tickConstraint.end(date).getTime() + later.SEC : tickConstraint.start(date).getTime() - later.SEC); // @ts-ignore
      },
      // @ts-ignore
      tickStart: function tickStart(date) {
        // @ts-ignore
        return tickConstraint.start(date); // @ts-ignore
      } // @ts-ignore

    }; // @ts-ignore
  }; // @ts-ignore


  later.schedule = function (sched) {
    // @ts-ignore
    if (!sched) throw new Error("Missing schedule definition."); // @ts-ignore

    if (!sched.schedules) throw new Error("Definition must include at least one schedule."); // @ts-ignore

    var schedules = [],
        schedulesLen = sched.schedules.length,
        exceptions = [],
        exceptionsLen = sched.exceptions ? sched.exceptions.length : 0; // @ts-ignore

    for (var i = 0; i < schedulesLen; i++) {
      // @ts-ignore
      schedules.push(later.compile(sched.schedules[i])); // @ts-ignore
    } // @ts-ignore


    for (var j = 0; j < exceptionsLen; j++) {
      // @ts-ignore
      exceptions.push(later.compile(sched.exceptions[j])); // @ts-ignore
    } // @ts-ignore


    function getInstances(dir, count, startDate, endDate, isRange) {
      // @ts-ignore
      var compare = compareFn(dir),
          loopCount = count,
          maxAttempts = 1e3,
          schedStarts = [],
          exceptStarts = [],
          next,
          end,
          results = [],
          isForward = dir === "next",
          lastResult,
          rStart = isForward ? 0 : 1,
          rEnd = isForward ? 1 : 0; // @ts-ignore

      startDate = startDate ? new Date(startDate) : new Date(); // @ts-ignore

      if (!startDate || !startDate.getTime()) throw new Error("Invalid start date."); // @ts-ignore

      setNextStarts(dir, schedules, schedStarts, startDate); // @ts-ignore

      setRangeStarts(dir, exceptions, exceptStarts, startDate); // @ts-ignore

      while (maxAttempts-- && loopCount && (next = findNext(schedStarts, compare))) {
        // @ts-ignore
        if (endDate && compare(next, endDate)) {
          // @ts-ignore
          break; // @ts-ignore
        } // @ts-ignore


        if (exceptionsLen) {
          // @ts-ignore
          updateRangeStarts(dir, exceptions, exceptStarts, next); // @ts-ignore

          if (end = calcRangeOverlap(dir, exceptStarts, next)) {
            // @ts-ignore
            updateNextStarts(dir, schedules, schedStarts, end); // @ts-ignore

            continue; // @ts-ignore
          } // @ts-ignore

        } // @ts-ignore


        if (isRange) {
          // @ts-ignore
          var maxEndDate = calcMaxEndDate(exceptStarts, compare); // @ts-ignore

          end = calcEnd(dir, schedules, schedStarts, next, maxEndDate); // @ts-ignore

          var r = isForward ? [new Date(Math.max(startDate, next)), end ? new Date(endDate ? Math.min(end, endDate) : end) : undefined] : [end ? new Date(endDate ? Math.max(endDate, end.getTime() + later.SEC) : end.getTime() + later.SEC) : undefined, new Date(Math.min(startDate, next.getTime() + later.SEC))]; // @ts-ignore

          if (lastResult && r[rStart].getTime() === lastResult[rEnd].getTime()) {
            // @ts-ignore
            lastResult[rEnd] = r[rEnd]; // @ts-ignore

            loopCount++; // @ts-ignore
          } else {
            // @ts-ignore
            lastResult = r; // @ts-ignore

            results.push(lastResult); // @ts-ignore
          } // @ts-ignore


          if (!end) break; // @ts-ignore

          updateNextStarts(dir, schedules, schedStarts, end); // @ts-ignore
        } else {
          // @ts-ignore
          results.push(isForward ? new Date(Math.max(startDate, next)) : getStart(schedules, schedStarts, next, endDate)); // @ts-ignore

          tickStarts(dir, schedules, schedStarts, next); // @ts-ignore
        } // @ts-ignore


        loopCount--; // @ts-ignore
      } // @ts-ignore


      for (var i = 0, len = results.length; i < len; i++) {
        // @ts-ignore
        var result = results[i]; // @ts-ignore

        results[i] = Object.prototype.toString.call(result) === "[object Array]" ? [cleanDate(result[0]), cleanDate(result[1])] : cleanDate(result); // @ts-ignore
      } // @ts-ignore


      return results.length === 0 ? later.NEVER : count === 1 ? results[0] : results; // @ts-ignore
    } // @ts-ignore


    function cleanDate(d) {
      // @ts-ignore
      if (d instanceof Date && !isNaN(d.valueOf())) {
        // @ts-ignore
        return new Date(d); // @ts-ignore
      } // @ts-ignore


      return undefined; // @ts-ignore
    } // @ts-ignore


    function setNextStarts(dir, schedArr, startsArr, startDate) {
      // @ts-ignore
      for (var i = 0, len = schedArr.length; i < len; i++) {
        // @ts-ignore
        startsArr[i] = schedArr[i].start(dir, startDate); // @ts-ignore
      } // @ts-ignore

    } // @ts-ignore


    function updateNextStarts(dir, schedArr, startsArr, startDate) {
      // @ts-ignore
      var compare = compareFn(dir); // @ts-ignore

      for (var i = 0, len = schedArr.length; i < len; i++) {
        // @ts-ignore
        if (startsArr[i] && !compare(startsArr[i], startDate)) {
          // @ts-ignore
          startsArr[i] = schedArr[i].start(dir, startDate); // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore

    } // @ts-ignore


    function setRangeStarts(dir, schedArr, rangesArr, startDate) {
      // @ts-ignore
      var compare = compareFn(dir); // @ts-ignore

      for (var i = 0, len = schedArr.length; i < len; i++) {
        // @ts-ignore
        var nextStart = schedArr[i].start(dir, startDate); // @ts-ignore

        if (!nextStart) {
          // @ts-ignore
          rangesArr[i] = later.NEVER; // @ts-ignore
        } else {
          // @ts-ignore
          rangesArr[i] = [nextStart, schedArr[i].end(dir, nextStart)]; // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore

    } // @ts-ignore


    function updateRangeStarts(dir, schedArr, rangesArr, startDate) {
      // @ts-ignore
      var compare = compareFn(dir); // @ts-ignore

      for (var i = 0, len = schedArr.length; i < len; i++) {
        // @ts-ignore
        if (rangesArr[i] && !compare(rangesArr[i][0], startDate)) {
          // @ts-ignore
          var nextStart = schedArr[i].start(dir, startDate); // @ts-ignore

          if (!nextStart) {
            // @ts-ignore
            rangesArr[i] = later.NEVER; // @ts-ignore
          } else {
            // @ts-ignore
            rangesArr[i] = [nextStart, schedArr[i].end(dir, nextStart)]; // @ts-ignore
          } // @ts-ignore

        } // @ts-ignore

      } // @ts-ignore

    } // @ts-ignore


    function tickStarts(dir, schedArr, startsArr, startDate) {
      // @ts-ignore
      for (var i = 0, len = schedArr.length; i < len; i++) {
        // @ts-ignore
        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
          // @ts-ignore
          startsArr[i] = schedArr[i].start(dir, schedArr[i].tick(dir, startDate)); // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore

    } // @ts-ignore


    function getStart(schedArr, startsArr, startDate, minEndDate) {
      // @ts-ignore
      var result; // @ts-ignore

      for (var i = 0, len = startsArr.length; i < len; i++) {
        // @ts-ignore
        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
          // @ts-ignore
          var start = schedArr[i].tickStart(startDate); // @ts-ignore

          if (minEndDate && start < minEndDate) {
            // @ts-ignore
            return minEndDate; // @ts-ignore
          } // @ts-ignore


          if (!result || start > result) {
            // @ts-ignore
            result = start; // @ts-ignore
          } // @ts-ignore

        } // @ts-ignore

      } // @ts-ignore


      return result; // @ts-ignore
    } // @ts-ignore


    function calcRangeOverlap(dir, rangesArr, startDate) {
      // @ts-ignore
      var compare = compareFn(dir),
          result; // @ts-ignore

      for (var i = 0, len = rangesArr.length; i < len; i++) {
        // @ts-ignore
        var range = rangesArr[i]; // @ts-ignore

        if (range && !compare(range[0], startDate) && (!range[1] || compare(range[1], startDate))) {
          // @ts-ignore
          if (!result || compare(range[1], result)) {
            // @ts-ignore
            result = range[1]; // @ts-ignore
          } // @ts-ignore

        } // @ts-ignore

      } // @ts-ignore


      return result; // @ts-ignore
    } // @ts-ignore


    function calcMaxEndDate(exceptsArr, compare) {
      // @ts-ignore
      var result; // @ts-ignore

      for (var i = 0, len = exceptsArr.length; i < len; i++) {
        // @ts-ignore
        if (exceptsArr[i] && (!result || compare(result, exceptsArr[i][0]))) {
          // @ts-ignore
          result = exceptsArr[i][0]; // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore


      return result; // @ts-ignore
    } // @ts-ignore


    function calcEnd(dir, schedArr, startsArr, startDate, maxEndDate) {
      // @ts-ignore
      var compare = compareFn(dir),
          result; // @ts-ignore

      for (var i = 0, len = schedArr.length; i < len; i++) {
        // @ts-ignore
        var start = startsArr[i]; // @ts-ignore

        if (start && start.getTime() === startDate.getTime()) {
          // @ts-ignore
          var end = schedArr[i].end(dir, start); // @ts-ignore

          if (maxEndDate && (!end || compare(end, maxEndDate))) {
            // @ts-ignore
            return maxEndDate; // @ts-ignore
          } // @ts-ignore


          if (!result || compare(end, result)) {
            // @ts-ignore
            result = end; // @ts-ignore
          } // @ts-ignore

        } // @ts-ignore

      } // @ts-ignore


      return result; // @ts-ignore
    } // @ts-ignore


    function compareFn(dir) {
      // @ts-ignore
      return dir === "next" ? function (a, b) {
        // @ts-ignore
        return !b || a.getTime() > b.getTime(); // @ts-ignore
      } : function (a, b) {
        // @ts-ignore
        return !a || b.getTime() > a.getTime(); // @ts-ignore
      }; // @ts-ignore
    } // @ts-ignore


    function findNext(arr, compare) {
      // @ts-ignore
      var next = arr[0]; // @ts-ignore

      for (var i = 1, len = arr.length; i < len; i++) {
        // @ts-ignore
        if (arr[i] && compare(next, arr[i])) {
          // @ts-ignore
          next = arr[i]; // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore


      return next; // @ts-ignore
    } // @ts-ignore


    return {
      // @ts-ignore
      isValid: function isValid(d) {
        // @ts-ignore
        return getInstances("next", 1, d, d) !== later.NEVER; // @ts-ignore
      },
      // @ts-ignore
      next: function next(count, startDate, endDate) {
        // @ts-ignore
        return getInstances("next", count || 1, startDate, endDate); // @ts-ignore
      },
      // @ts-ignore
      prev: function prev(count, startDate, endDate) {
        // @ts-ignore
        return getInstances("prev", count || 1, startDate, endDate); // @ts-ignore
      },
      // @ts-ignore
      nextRange: function nextRange(count, startDate, endDate) {
        // @ts-ignore
        return getInstances("next", count || 1, startDate, endDate, true); // @ts-ignore
      },
      // @ts-ignore
      prevRange: function prevRange(count, startDate, endDate) {
        // @ts-ignore
        return getInstances("prev", count || 1, startDate, endDate, true); // @ts-ignore
      } // @ts-ignore

    }; // @ts-ignore
  }; // @ts-ignore


  later.setTimeout = function (fn, sched) {
    // @ts-ignore
    var s = later.schedule(sched),
        t; // @ts-ignore

    if (fn) {
      // @ts-ignore
      scheduleTimeout(); // @ts-ignore
    } // @ts-ignore


    function scheduleTimeout() {
      // @ts-ignore
      var now = Date.now(),
          next = s.next(2, now); // @ts-ignore

      if (!next[0]) {
        // @ts-ignore
        t = undefined; // @ts-ignore

        return; // @ts-ignore
      } // @ts-ignore


      var diff = next[0].getTime() - now; // @ts-ignore

      if (diff < 1e3) {
        // @ts-ignore
        diff = next[1] ? next[1].getTime() - now : 1e3; // @ts-ignore
      } // @ts-ignore


      if (diff < 2147483647) {
        // @ts-ignore
        t = setTimeout(fn, diff); // @ts-ignore
      } else {
        // @ts-ignore
        t = setTimeout(scheduleTimeout, 2147483647); // @ts-ignore
      } // @ts-ignore

    } // @ts-ignore


    return {
      // @ts-ignore
      isDone: function isDone() {
        // @ts-ignore
        return !t; // @ts-ignore
      },
      // @ts-ignore
      clear: function clear() {
        // @ts-ignore
        clearTimeout(t); // @ts-ignore
      } // @ts-ignore

    }; // @ts-ignore
  }; // @ts-ignore


  later.setInterval = function (fn, sched) {
    // @ts-ignore
    if (!fn) {
      // @ts-ignore
      return; // @ts-ignore
    } // @ts-ignore


    var t = later.setTimeout(scheduleTimeout, sched),
        done = t.isDone(); // @ts-ignore

    function scheduleTimeout() {
      // @ts-ignore
      if (!done) {
        // @ts-ignore
        fn(); // @ts-ignore

        t = later.setTimeout(scheduleTimeout, sched); // @ts-ignore
      } // @ts-ignore

    } // @ts-ignore


    return {
      // @ts-ignore
      isDone: function isDone() {
        // @ts-ignore
        return t.isDone(); // @ts-ignore
      },
      // @ts-ignore
      clear: function clear() {
        // @ts-ignore
        done = true; // @ts-ignore

        t.clear(); // @ts-ignore
      } // @ts-ignore

    }; // @ts-ignore
  }; // @ts-ignore


  later.date = {}; // @ts-ignore

  later.date.timezone = function (useLocalTime) {
    // @ts-ignore
    later.date.build = useLocalTime ? function (Y, M, D, h, m, s) {
      // @ts-ignore
      return new Date(Y, M, D, h, m, s); // @ts-ignore
    } : function (Y, M, D, h, m, s) {
      // @ts-ignore
      return new Date(Date.UTC(Y, M, D, h, m, s)); // @ts-ignore
    }; // @ts-ignore

    var get = useLocalTime ? "get" : "getUTC",
        d = Date.prototype; // @ts-ignore

    later.date.getYear = d[get + "FullYear"]; // @ts-ignore

    later.date.getMonth = d[get + "Month"]; // @ts-ignore

    later.date.getDate = d[get + "Date"]; // @ts-ignore

    later.date.getDay = d[get + "Day"]; // @ts-ignore

    later.date.getHour = d[get + "Hours"]; // @ts-ignore

    later.date.getMin = d[get + "Minutes"]; // @ts-ignore

    later.date.getSec = d[get + "Seconds"]; // @ts-ignore

    later.date.isUTC = !useLocalTime; // @ts-ignore
  }; // @ts-ignore


  later.date.UTC = function () {
    // @ts-ignore
    later.date.timezone(false); // @ts-ignore
  }; // @ts-ignore


  later.date.localTime = function () {
    // @ts-ignore
    later.date.timezone(true); // @ts-ignore
  }; // @ts-ignore


  later.date.UTC(); // @ts-ignore

  later.SEC = 1e3; // @ts-ignore

  later.MIN = later.SEC * 60; // @ts-ignore

  later.HOUR = later.MIN * 60; // @ts-ignore

  later.DAY = later.HOUR * 24; // @ts-ignore

  later.WEEK = later.DAY * 7; // @ts-ignore

  later.DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // @ts-ignore

  later.NEVER = 0; // @ts-ignore

  later.date.next = function (Y, M, D, h, m, s) {
    // @ts-ignore
    return later.date.build(Y, M !== undefined ? M - 1 : 0, D !== undefined ? D : 1, h || 0, m || 0, s || 0); // @ts-ignore
  }; // @ts-ignore


  later.date.nextRollover = function (d, val, constraint, period) {
    // @ts-ignore
    var cur = constraint.val(d),
        max = constraint.extent(d)[1]; // @ts-ignore

    return (val || max) <= cur || val > max ? new Date(period.end(d).getTime() + later.SEC) : period.start(d); // @ts-ignore
  }; // @ts-ignore


  later.date.prev = function (Y, M, D, h, m, s) {
    // @ts-ignore
    var len = arguments.length; // @ts-ignore

    M = len < 2 ? 11 : M - 1; // @ts-ignore

    D = len < 3 ? later.D.extent(later.date.next(Y, M + 1))[1] : D; // @ts-ignore

    h = len < 4 ? 23 : h; // @ts-ignore

    m = len < 5 ? 59 : m; // @ts-ignore

    s = len < 6 ? 59 : s; // @ts-ignore

    return later.date.build(Y, M, D, h, m, s); // @ts-ignore
  }; // @ts-ignore


  later.date.prevRollover = function (d, val, constraint, period) {
    // @ts-ignore
    var cur = constraint.val(d); // @ts-ignore

    return val >= cur || !val ? period.start(period.prev(d, period.val(d) - 1)) : period.start(d); // @ts-ignore
  }; // @ts-ignore


  later.parse = {}; // @ts-ignore

  later.parse.cron = function (expr, hasSeconds) {
    // @ts-ignore
    var NAMES = {
      // @ts-ignore
      JAN: 1,
      // @ts-ignore
      FEB: 2,
      // @ts-ignore
      MAR: 3,
      // @ts-ignore
      APR: 4,
      // @ts-ignore
      MAY: 5,
      // @ts-ignore
      JUN: 6,
      // @ts-ignore
      JUL: 7,
      // @ts-ignore
      AUG: 8,
      // @ts-ignore
      SEP: 9,
      // @ts-ignore
      OCT: 10,
      // @ts-ignore
      NOV: 11,
      // @ts-ignore
      DEC: 12,
      // @ts-ignore
      SUN: 1,
      // @ts-ignore
      MON: 2,
      // @ts-ignore
      TUE: 3,
      // @ts-ignore
      WED: 4,
      // @ts-ignore
      THU: 5,
      // @ts-ignore
      FRI: 6,
      // @ts-ignore
      SAT: 7 // @ts-ignore

    }; // @ts-ignore

    var REPLACEMENTS = {
      // @ts-ignore
      "* * * * * *": "0/1 * * * * *",
      // @ts-ignore
      "@YEARLY": "0 0 1 1 *",
      // @ts-ignore
      "@ANNUALLY": "0 0 1 1 *",
      // @ts-ignore
      "@MONTHLY": "0 0 1 * *",
      // @ts-ignore
      "@WEEKLY": "0 0 * * 0",
      // @ts-ignore
      "@DAILY": "0 0 * * *",
      // @ts-ignore
      "@HOURLY": "0 * * * *" // @ts-ignore

    }; // @ts-ignore

    var FIELDS = {
      // @ts-ignore
      s: [0, 0, 59],
      // @ts-ignore
      m: [1, 0, 59],
      // @ts-ignore
      h: [2, 0, 23],
      // @ts-ignore
      D: [3, 1, 31],
      // @ts-ignore
      M: [4, 1, 12],
      // @ts-ignore
      Y: [6, 1970, 2099],
      // @ts-ignore
      d: [5, 1, 7, 1] // @ts-ignore

    }; // @ts-ignore

    function getValue(value, offset, max) {
      // @ts-ignore
      return isNaN(value) ? NAMES[value] || null : Math.min(+value + (offset || 0), max || 9999); // @ts-ignore
    } // @ts-ignore


    function cloneSchedule(sched) {
      // @ts-ignore
      var clone = {},
          field; // @ts-ignore

      for (field in sched) {
        // @ts-ignore
        if (field !== "dc" && field !== "d") {
          // @ts-ignore
          clone[field] = sched[field].slice(0); // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore


      return clone; // @ts-ignore
    } // @ts-ignore


    function add(sched, name, min, max, inc) {
      // @ts-ignore
      var i = min; // @ts-ignore

      if (!sched[name]) {
        // @ts-ignore
        sched[name] = []; // @ts-ignore
      } // @ts-ignore


      while (i <= max) {
        // @ts-ignore
        if (sched[name].indexOf(i) < 0) {
          // @ts-ignore
          sched[name].push(i); // @ts-ignore
        } // @ts-ignore


        i += inc || 1; // @ts-ignore
      } // @ts-ignore


      sched[name].sort(function (a, b) {
        // @ts-ignore
        return a - b; // @ts-ignore
      }); // @ts-ignore
    } // @ts-ignore


    function addHash(schedules, curSched, value, hash) {
      // @ts-ignore
      if (curSched.d && !curSched.dc || curSched.dc && curSched.dc.indexOf(hash) < 0) {
        // @ts-ignore
        schedules.push(cloneSchedule(curSched)); // @ts-ignore

        curSched = schedules[schedules.length - 1]; // @ts-ignore
      } // @ts-ignore


      add(curSched, "d", value, value); // @ts-ignore

      add(curSched, "dc", hash, hash); // @ts-ignore
    } // @ts-ignore


    function addWeekday(s, curSched, value) {
      // @ts-ignore
      var except1 = {},
          except2 = {}; // @ts-ignore

      if (value === 1) {
        // @ts-ignore
        add(curSched, "D", 1, 3); // @ts-ignore

        add(curSched, "d", NAMES.MON, NAMES.FRI); // @ts-ignore

        add(except1, "D", 2, 2); // @ts-ignore

        add(except1, "d", NAMES.TUE, NAMES.FRI); // @ts-ignore

        add(except2, "D", 3, 3); // @ts-ignore

        add(except2, "d", NAMES.TUE, NAMES.FRI); // @ts-ignore
      } else {
        // @ts-ignore
        add(curSched, "D", value - 1, value + 1); // @ts-ignore

        add(curSched, "d", NAMES.MON, NAMES.FRI); // @ts-ignore

        add(except1, "D", value - 1, value - 1); // @ts-ignore

        add(except1, "d", NAMES.MON, NAMES.THU); // @ts-ignore

        add(except2, "D", value + 1, value + 1); // @ts-ignore

        add(except2, "d", NAMES.TUE, NAMES.FRI); // @ts-ignore
      } // @ts-ignore


      s.exceptions.push(except1); // @ts-ignore

      s.exceptions.push(except2); // @ts-ignore
    } // @ts-ignore


    function addRange(item, curSched, name, min, max, offset) {
      // @ts-ignore
      var incSplit = item.split("/"),
          inc = +incSplit[1],
          range = incSplit[0]; // @ts-ignore

      if (range !== "*" && range !== "0") {
        // @ts-ignore
        var rangeSplit = range.split("-"); // @ts-ignore

        min = getValue(rangeSplit[0], offset, max); // @ts-ignore

        max = getValue(rangeSplit[1], offset, max) || max; // @ts-ignore
      } // @ts-ignore


      add(curSched, name, min, max, inc); // @ts-ignore
    } // @ts-ignore


    function parse(item, s, name, min, max, offset) {
      // @ts-ignore
      var value,
          split,
          schedules = s.schedules,
          curSched = schedules[schedules.length - 1]; // @ts-ignore

      if (item === "L") {
        // @ts-ignore
        item = min - 1; // @ts-ignore
      } // @ts-ignore


      if ((value = getValue(item, offset, max)) !== null) {
        // @ts-ignore
        add(curSched, name, value, value); // @ts-ignore
      } else if ((value = getValue(item.replace("W", ""), offset, max)) !== null) {
        // @ts-ignore
        addWeekday(s, curSched, value); // @ts-ignore
      } else if ((value = getValue(item.replace("L", ""), offset, max)) !== null) {
        // @ts-ignore
        addHash(schedules, curSched, value, min - 1); // @ts-ignore
      } else if ((split = item.split("#")).length === 2) {
        // @ts-ignore
        value = getValue(split[0], offset, max); // @ts-ignore

        addHash(schedules, curSched, value, getValue(split[1])); // @ts-ignore
      } else {
        // @ts-ignore
        addRange(item, curSched, name, min, max, offset); // @ts-ignore
      } // @ts-ignore

    } // @ts-ignore


    function isHash(item) {
      // @ts-ignore
      return item.indexOf("#") > -1 || item.indexOf("L") > 0; // @ts-ignore
    } // @ts-ignore


    function itemSorter(a, b) {
      // @ts-ignore
      return isHash(a) && !isHash(b) ? 1 : a - b; // @ts-ignore
    } // @ts-ignore


    function parseExpr(expr) {
      // @ts-ignore
      var schedule = {
        // @ts-ignore
        schedules: [{}],
        // @ts-ignore
        exceptions: [] // @ts-ignore

      },
          components = expr.replace(/(\s)+/g, " ").split(" "),
          field,
          f,
          component,
          items; // @ts-ignore

      for (field in FIELDS) {
        // @ts-ignore
        f = FIELDS[field]; // @ts-ignore

        component = components[f[0]]; // @ts-ignore

        if (component && component !== "*" && component !== "?") {
          // @ts-ignore
          items = component.split(",").sort(itemSorter); // @ts-ignore

          var i,
              length = items.length; // @ts-ignore

          for (i = 0; i < length; i++) {
            // @ts-ignore
            parse(items[i], schedule, field, f[1], f[2], f[3]); // @ts-ignore
          } // @ts-ignore

        } // @ts-ignore

      } // @ts-ignore


      return schedule; // @ts-ignore
    } // @ts-ignore


    function prepareExpr(expr) {
      // @ts-ignore
      var prepared = expr.toUpperCase(); // @ts-ignore

      return REPLACEMENTS[prepared] || prepared; // @ts-ignore
    } // @ts-ignore


    var e = prepareExpr(expr); // @ts-ignore

    return parseExpr(hasSeconds ? e : "0 " + e); // @ts-ignore
  }; // @ts-ignore


  later.parse.recur = function () {
    // @ts-ignore
    var schedules = [],
        exceptions = [],
        cur,
        curArr = schedules,
        curName,
        values,
        _every,
        modifier,
        applyMin,
        applyMax,
        i,
        last; // @ts-ignore


    function add(name, min, max) {
      // @ts-ignore
      name = modifier ? name + "_" + modifier : name; // @ts-ignore

      if (!cur) {
        // @ts-ignore
        curArr.push({}); // @ts-ignore

        cur = curArr[0]; // @ts-ignore
      } // @ts-ignore


      if (!cur[name]) {
        // @ts-ignore
        cur[name] = []; // @ts-ignore
      } // @ts-ignore


      curName = cur[name]; // @ts-ignore

      if (_every) {
        // @ts-ignore
        values = []; // @ts-ignore

        for (i = min; i <= max; i += _every) {
          // @ts-ignore
          values.push(i); // @ts-ignore
        } // @ts-ignore


        last = {
          // @ts-ignore
          n: name,
          // @ts-ignore
          x: _every,
          // @ts-ignore
          c: curName.length,
          // @ts-ignore
          m: max // @ts-ignore

        }; // @ts-ignore
      } // @ts-ignore


      values = applyMin ? [min] : applyMax ? [max] : values; // @ts-ignore

      var length = values.length; // @ts-ignore

      for (i = 0; i < length; i += 1) {
        // @ts-ignore
        var val = values[i]; // @ts-ignore

        if (curName.indexOf(val) < 0) {
          // @ts-ignore
          curName.push(val); // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore


      values = _every = modifier = applyMin = applyMax = 0; // @ts-ignore
    } // @ts-ignore


    return {
      // @ts-ignore
      schedules: schedules,
      // @ts-ignore
      exceptions: exceptions,
      // @ts-ignore
      on: function on() {
        // @ts-ignore
        values = arguments[0] instanceof Array ? arguments[0] : arguments; // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      every: function every(x) {
        // @ts-ignore
        _every = x || 1; // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      after: function after(x) {
        // @ts-ignore
        modifier = "a"; // @ts-ignore

        values = [x]; // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      before: function before(x) {
        // @ts-ignore
        modifier = "b"; // @ts-ignore

        values = [x]; // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      first: function first() {
        // @ts-ignore
        applyMin = 1; // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      last: function last() {
        // @ts-ignore
        applyMax = 1; // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      time: function time() {
        // @ts-ignore
        for (var i = 0, len = values.length; i < len; i++) {
          // @ts-ignore
          var split = values[i].split(":"); // @ts-ignore

          if (split.length < 3) split.push(0); // @ts-ignore

          values[i] = +split[0] * 3600 + +split[1] * 60 + +split[2]; // @ts-ignore
        } // @ts-ignore


        add("t"); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      second: function second() {
        // @ts-ignore
        add("s", 0, 59); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      minute: function minute() {
        // @ts-ignore
        add("m", 0, 59); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      hour: function hour() {
        // @ts-ignore
        add("h", 0, 23); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      dayOfMonth: function dayOfMonth() {
        // @ts-ignore
        add("D", 1, applyMax ? 0 : 31); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      dayOfWeek: function dayOfWeek() {
        // @ts-ignore
        add("d", 1, 7); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      onWeekend: function onWeekend() {
        // @ts-ignore
        values = [1, 7]; // @ts-ignore

        return this.dayOfWeek(); // @ts-ignore
      },
      // @ts-ignore
      onWeekday: function onWeekday() {
        // @ts-ignore
        values = [2, 3, 4, 5, 6]; // @ts-ignore

        return this.dayOfWeek(); // @ts-ignore
      },
      // @ts-ignore
      dayOfWeekCount: function dayOfWeekCount() {
        // @ts-ignore
        add("dc", 1, applyMax ? 0 : 5); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      dayOfYear: function dayOfYear() {
        // @ts-ignore
        add("dy", 1, applyMax ? 0 : 366); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      weekOfMonth: function weekOfMonth() {
        // @ts-ignore
        add("wm", 1, applyMax ? 0 : 5); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      weekOfYear: function weekOfYear() {
        // @ts-ignore
        add("wy", 1, applyMax ? 0 : 53); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      month: function month() {
        // @ts-ignore
        add("M", 1, 12); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      year: function year() {
        // @ts-ignore
        add("Y", 1970, 2450); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      fullDate: function fullDate() {
        // @ts-ignore
        for (var i = 0, len = values.length; i < len; i++) {
          // @ts-ignore
          values[i] = values[i].getTime(); // @ts-ignore
        } // @ts-ignore


        add("fd"); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      customModifier: function customModifier(id, vals) {
        // @ts-ignore
        var custom = later.modifier[id]; // @ts-ignore

        if (!custom) throw new Error("Custom modifier " + id + " not recognized!"); // @ts-ignore

        modifier = id; // @ts-ignore

        values = arguments[1] instanceof Array ? arguments[1] : [arguments[1]]; // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      customPeriod: function customPeriod(id) {
        // @ts-ignore
        var custom = later[id]; // @ts-ignore

        if (!custom) throw new Error("Custom time period " + id + " not recognized!"); // @ts-ignore

        add(id, custom.extent(new Date())[0], custom.extent(new Date())[1]); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      startingOn: function startingOn(start) {
        // @ts-ignore
        return this.between(start, last.m); // @ts-ignore
      },
      // @ts-ignore
      between: function between(start, end) {
        // @ts-ignore
        cur[last.n] = cur[last.n].splice(0, last.c); // @ts-ignore

        _every = last.x; // @ts-ignore

        add(last.n, start, end); // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      and: function and() {
        // @ts-ignore
        cur = curArr[curArr.push({}) - 1]; // @ts-ignore

        return this; // @ts-ignore
      },
      // @ts-ignore
      except: function except() {
        // @ts-ignore
        curArr = exceptions; // @ts-ignore

        cur = null; // @ts-ignore

        return this; // @ts-ignore
      } // @ts-ignore

    }; // @ts-ignore
  }; // @ts-ignore


  later.parse.text = function (str) {
    // @ts-ignore
    var recur = later.parse.recur,
        pos = 0,
        input = "",
        error; // @ts-ignore

    var TOKENTYPES = {
      // @ts-ignore
      eof: /^$/,
      // @ts-ignore
      rank: /^((\d\d\d\d)|([2-5]?1(st)?|[2-5]?2(nd)?|[2-5]?3(rd)?|(0|[1-5]?[4-9]|[1-5]0|1[1-3])(th)?))\b/,
      // @ts-ignore
      time: /^((([0]?[1-9]|1[0-2]):[0-5]\d(\s)?(am|pm))|(([0]?\d|1\d|2[0-3]):[0-5]\d))\b/,
      // @ts-ignore
      dayName: /^((sun|mon|tue(s)?|wed(nes)?|thu(r(s)?)?|fri|sat(ur)?)(day)?)\b/,
      // @ts-ignore
      monthName: /^(jan(uary)?|feb(ruary)?|ma((r(ch)?)?|y)|apr(il)?|ju(ly|ne)|aug(ust)?|oct(ober)?|(sept|nov|dec)(ember)?)\b/,
      // @ts-ignore
      yearIndex: /^(\d\d\d\d)\b/,
      // @ts-ignore
      every: /^every\b/,
      // @ts-ignore
      after: /^after\b/,
      // @ts-ignore
      before: /^before\b/,
      // @ts-ignore
      second: /^(s|sec(ond)?(s)?)\b/,
      // @ts-ignore
      minute: /^(m|min(ute)?(s)?)\b/,
      // @ts-ignore
      hour: /^(h|hour(s)?)\b/,
      // @ts-ignore
      day: /^(day(s)?( of the month)?)\b/,
      // @ts-ignore
      dayInstance: /^day instance\b/,
      // @ts-ignore
      dayOfWeek: /^day(s)? of the week\b/,
      // @ts-ignore
      dayOfYear: /^day(s)? of the year\b/,
      // @ts-ignore
      weekOfYear: /^week(s)?( of the year)?\b/,
      // @ts-ignore
      weekOfMonth: /^week(s)? of the month\b/,
      // @ts-ignore
      weekday: /^weekday\b/,
      // @ts-ignore
      weekend: /^weekend\b/,
      // @ts-ignore
      month: /^month(s)?\b/,
      // @ts-ignore
      year: /^year(s)?\b/,
      // @ts-ignore
      between: /^between (the)?\b/,
      // @ts-ignore
      start: /^(start(ing)? (at|on( the)?)?)\b/,
      // @ts-ignore
      at: /^(at|@)\b/,
      // @ts-ignore
      and: /^(,|and\b)/,
      // @ts-ignore
      except: /^(except\b)/,
      // @ts-ignore
      also: /(also)\b/,
      // @ts-ignore
      first: /^(first)\b/,
      // @ts-ignore
      last: /^last\b/,
      // @ts-ignore
      "in": /^in\b/,
      // @ts-ignore
      of: /^of\b/,
      // @ts-ignore
      onthe: /^on the\b/,
      // @ts-ignore
      on: /^on\b/,
      // @ts-ignore
      through: /(-|^(to|through)\b)/ // @ts-ignore

    }; // @ts-ignore

    var NAMES = {
      // @ts-ignore
      jan: 1,
      // @ts-ignore
      feb: 2,
      // @ts-ignore
      mar: 3,
      // @ts-ignore
      apr: 4,
      // @ts-ignore
      may: 5,
      // @ts-ignore
      jun: 6,
      // @ts-ignore
      jul: 7,
      // @ts-ignore
      aug: 8,
      // @ts-ignore
      sep: 9,
      // @ts-ignore
      oct: 10,
      // @ts-ignore
      nov: 11,
      // @ts-ignore
      dec: 12,
      // @ts-ignore
      sun: 1,
      // @ts-ignore
      mon: 2,
      // @ts-ignore
      tue: 3,
      // @ts-ignore
      wed: 4,
      // @ts-ignore
      thu: 5,
      // @ts-ignore
      fri: 6,
      // @ts-ignore
      sat: 7,
      // @ts-ignore
      "1st": 1,
      // @ts-ignore
      fir: 1,
      // @ts-ignore
      "2nd": 2,
      // @ts-ignore
      sec: 2,
      // @ts-ignore
      "3rd": 3,
      // @ts-ignore
      thi: 3,
      // @ts-ignore
      "4th": 4,
      // @ts-ignore
      "for": 4 // @ts-ignore

    }; // @ts-ignore

    function t(start, end, text, type) {
      // @ts-ignore
      return {
        // @ts-ignore
        startPos: start,
        // @ts-ignore
        endPos: end,
        // @ts-ignore
        text: text,
        // @ts-ignore
        type: type // @ts-ignore

      }; // @ts-ignore
    } // @ts-ignore


    function peek(expected) {
      // @ts-ignore
      var scanTokens = expected instanceof Array ? expected : [expected],
          whiteSpace = /\s+/,
          token,
          curInput,
          m,
          scanToken,
          start,
          len; // @ts-ignore

      scanTokens.push(whiteSpace); // @ts-ignore

      start = pos; // @ts-ignore

      while (!token || token.type === whiteSpace) {
        // @ts-ignore
        len = -1; // @ts-ignore

        curInput = input.substring(start); // @ts-ignore

        token = t(start, start, input.split(whiteSpace)[0]); // @ts-ignore

        var i,
            length = scanTokens.length; // @ts-ignore

        for (i = 0; i < length; i++) {
          // @ts-ignore
          scanToken = scanTokens[i]; // @ts-ignore

          m = scanToken.exec(curInput); // @ts-ignore

          if (m && m.index === 0 && m[0].length > len) {
            // @ts-ignore
            len = m[0].length; // @ts-ignore

            token = t(start, start + len, curInput.substring(0, len), scanToken); // @ts-ignore
          } // @ts-ignore

        } // @ts-ignore


        if (token.type === whiteSpace) {
          // @ts-ignore
          start = token.endPos; // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore


      return token; // @ts-ignore
    } // @ts-ignore


    function scan(expectedToken) {
      // @ts-ignore
      var token = peek(expectedToken); // @ts-ignore

      pos = token.endPos; // @ts-ignore

      return token; // @ts-ignore
    } // @ts-ignore


    function parseThroughExpr(tokenType) {
      // @ts-ignore
      var start = +parseTokenValue(tokenType),
          end = checkAndParse(TOKENTYPES.through) ? +parseTokenValue(tokenType) : start,
          nums = []; // @ts-ignore

      for (var i = start; i <= end; i++) {
        // @ts-ignore
        nums.push(i); // @ts-ignore
      } // @ts-ignore


      return nums; // @ts-ignore
    } // @ts-ignore


    function parseRanges(tokenType) {
      // @ts-ignore
      var nums = parseThroughExpr(tokenType); // @ts-ignore

      while (checkAndParse(TOKENTYPES.and)) {
        // @ts-ignore
        nums = nums.concat(parseThroughExpr(tokenType)); // @ts-ignore
      } // @ts-ignore


      return nums; // @ts-ignore
    } // @ts-ignore


    function parseEvery(r) {
      // @ts-ignore
      var num, period, start, end; // @ts-ignore

      if (checkAndParse(TOKENTYPES.weekend)) {
        // @ts-ignore
        r.on(NAMES.sun, NAMES.sat).dayOfWeek(); // @ts-ignore
      } else if (checkAndParse(TOKENTYPES.weekday)) {
        // @ts-ignore
        r.on(NAMES.mon, NAMES.tue, NAMES.wed, NAMES.thu, NAMES.fri).dayOfWeek(); // @ts-ignore
      } else {
        // @ts-ignore
        num = parseTokenValue(TOKENTYPES.rank); // @ts-ignore

        r.every(num); // @ts-ignore

        period = parseTimePeriod(r); // @ts-ignore

        if (checkAndParse(TOKENTYPES.start)) {
          // @ts-ignore
          num = parseTokenValue(TOKENTYPES.rank); // @ts-ignore

          r.startingOn(num); // @ts-ignore

          parseToken(period.type); // @ts-ignore
        } else if (checkAndParse(TOKENTYPES.between)) {
          // @ts-ignore
          start = parseTokenValue(TOKENTYPES.rank); // @ts-ignore

          if (checkAndParse(TOKENTYPES.and)) {
            // @ts-ignore
            end = parseTokenValue(TOKENTYPES.rank); // @ts-ignore

            r.between(start, end); // @ts-ignore
          } // @ts-ignore

        } // @ts-ignore

      } // @ts-ignore

    } // @ts-ignore


    function parseOnThe(r) {
      // @ts-ignore
      if (checkAndParse(TOKENTYPES.first)) {
        // @ts-ignore
        r.first(); // @ts-ignore
      } else if (checkAndParse(TOKENTYPES.last)) {
        // @ts-ignore
        r.last(); // @ts-ignore
      } else {
        // @ts-ignore
        r.on(parseRanges(TOKENTYPES.rank)); // @ts-ignore
      } // @ts-ignore


      parseTimePeriod(r); // @ts-ignore
    } // @ts-ignore


    function parseScheduleExpr(str) {
      // @ts-ignore
      pos = 0; // @ts-ignore

      input = str; // @ts-ignore

      error = -1; // @ts-ignore

      var r = recur(); // @ts-ignore

      while (pos < input.length && error < 0) {
        // @ts-ignore
        var token = parseToken([TOKENTYPES.every, TOKENTYPES.after, TOKENTYPES.before, TOKENTYPES.onthe, TOKENTYPES.on, TOKENTYPES.of, TOKENTYPES["in"], TOKENTYPES.at, TOKENTYPES.and, TOKENTYPES.except, TOKENTYPES.also]); // @ts-ignore

        switch (token.type) {
          // @ts-ignore
          case TOKENTYPES.every:
            // @ts-ignore
            parseEvery(r); // @ts-ignore

            break;
          // @ts-ignore
          // @ts-ignore

          case TOKENTYPES.after:
            // @ts-ignore
            if (peek(TOKENTYPES.time).type !== undefined) {
              // @ts-ignore
              r.after(parseTokenValue(TOKENTYPES.time)); // @ts-ignore

              r.time(); // @ts-ignore
            } else {
              // @ts-ignore
              r.after(parseTokenValue(TOKENTYPES.rank)); // @ts-ignore

              parseTimePeriod(r); // @ts-ignore
            } // @ts-ignore


            break;
          // @ts-ignore
          // @ts-ignore

          case TOKENTYPES.before:
            // @ts-ignore
            if (peek(TOKENTYPES.time).type !== undefined) {
              // @ts-ignore
              r.before(parseTokenValue(TOKENTYPES.time)); // @ts-ignore

              r.time(); // @ts-ignore
            } else {
              // @ts-ignore
              r.before(parseTokenValue(TOKENTYPES.rank)); // @ts-ignore

              parseTimePeriod(r); // @ts-ignore
            } // @ts-ignore


            break;
          // @ts-ignore
          // @ts-ignore

          case TOKENTYPES.onthe:
            // @ts-ignore
            parseOnThe(r); // @ts-ignore

            break;
          // @ts-ignore
          // @ts-ignore

          case TOKENTYPES.on:
            // @ts-ignore
            r.on(parseRanges(TOKENTYPES.dayName)).dayOfWeek(); // @ts-ignore

            break;
          // @ts-ignore
          // @ts-ignore

          case TOKENTYPES.of:
            // @ts-ignore
            r.on(parseRanges(TOKENTYPES.monthName)).month(); // @ts-ignore

            break;
          // @ts-ignore
          // @ts-ignore

          case TOKENTYPES["in"]:
            // @ts-ignore
            r.on(parseRanges(TOKENTYPES.yearIndex)).year(); // @ts-ignore

            break;
          // @ts-ignore
          // @ts-ignore

          case TOKENTYPES.at:
            // @ts-ignore
            r.on(parseTokenValue(TOKENTYPES.time)).time(); // @ts-ignore

            while (checkAndParse(TOKENTYPES.and)) {
              // @ts-ignore
              r.on(parseTokenValue(TOKENTYPES.time)).time(); // @ts-ignore
            } // @ts-ignore


            break;
          // @ts-ignore

          case TOKENTYPES.and:
            // @ts-ignore
            break;
          // @ts-ignore

          case TOKENTYPES.also:
            // @ts-ignore
            r.and(); // @ts-ignore

            break;
          // @ts-ignore

          case TOKENTYPES.except:
            // @ts-ignore
            r.except(); // @ts-ignore

            break;
          // @ts-ignore

          default:
            // @ts-ignore
            error = pos;
          // @ts-ignore
        } // @ts-ignore

      } // @ts-ignore


      return {
        // @ts-ignore
        schedules: r.schedules,
        // @ts-ignore
        exceptions: r.exceptions,
        // @ts-ignore
        error: error // @ts-ignore

      }; // @ts-ignore
    } // @ts-ignore


    function parseTimePeriod(r) {
      // @ts-ignore
      var timePeriod = parseToken([TOKENTYPES.second, TOKENTYPES.minute, TOKENTYPES.hour, TOKENTYPES.dayOfYear, TOKENTYPES.dayOfWeek, TOKENTYPES.dayInstance, TOKENTYPES.day, TOKENTYPES.month, TOKENTYPES.year, TOKENTYPES.weekOfMonth, TOKENTYPES.weekOfYear]); // @ts-ignore

      switch (timePeriod.type) {
        // @ts-ignore
        case TOKENTYPES.second:
          // @ts-ignore
          r.second(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.minute:
          // @ts-ignore
          r.minute(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.hour:
          // @ts-ignore
          r.hour(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.dayOfYear:
          // @ts-ignore
          r.dayOfYear(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.dayOfWeek:
          // @ts-ignore
          r.dayOfWeek(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.dayInstance:
          // @ts-ignore
          r.dayOfWeekCount(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.day:
          // @ts-ignore
          r.dayOfMonth(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.weekOfMonth:
          // @ts-ignore
          r.weekOfMonth(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.weekOfYear:
          // @ts-ignore
          r.weekOfYear(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.month:
          // @ts-ignore
          r.month(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.year:
          // @ts-ignore
          r.year(); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        default:
          // @ts-ignore
          error = pos;
        // @ts-ignore
      } // @ts-ignore


      return timePeriod; // @ts-ignore
    } // @ts-ignore


    function checkAndParse(tokenType) {
      // @ts-ignore
      var found = peek(tokenType).type === tokenType; // @ts-ignore

      if (found) {
        // @ts-ignore
        scan(tokenType); // @ts-ignore
      } // @ts-ignore


      return found; // @ts-ignore
    } // @ts-ignore


    function parseToken(tokenType) {
      // @ts-ignore
      var t = scan(tokenType); // @ts-ignore

      if (t.type) {
        // @ts-ignore
        t.text = convertString(t.text, tokenType); // @ts-ignore
      } else {
        // @ts-ignore
        error = pos; // @ts-ignore
      } // @ts-ignore


      return t; // @ts-ignore
    } // @ts-ignore


    function parseTokenValue(tokenType) {
      // @ts-ignore
      return parseToken(tokenType).text; // @ts-ignore
    } // @ts-ignore


    function convertString(str, tokenType) {
      // @ts-ignore
      var output = str; // @ts-ignore

      switch (tokenType) {
        // @ts-ignore
        case TOKENTYPES.time:
          // @ts-ignore
          var parts = str.split(/(:|am|pm)/),
              hour = parts[3] === "pm" && parts[0] < 12 ? parseInt(parts[0], 10) + 12 : parts[0],
              min = parts[2].trim(); // @ts-ignore

          output = (hour.length === 1 ? "0" : "") + hour + ":" + min; // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.rank:
          // @ts-ignore
          output = parseInt(/^\d+/.exec(str)[0], 10); // @ts-ignore

          break;
        // @ts-ignore
        // @ts-ignore

        case TOKENTYPES.monthName: // @ts-ignore

        case TOKENTYPES.dayName:
          // @ts-ignore
          output = NAMES[str.substring(0, 3)]; // @ts-ignore

          break;
        // @ts-ignore
      } // @ts-ignore


      return output; // @ts-ignore
    } // @ts-ignore


    return parseScheduleExpr(str.toLowerCase()); // @ts-ignore
  }; // @ts-ignore


  return later; // @ts-ignore
}(); // Set the local time mode for "later" library
// @ts-ignore

later.date.localTime(); // @ts-ignore

/* harmony default export */ __webpack_exports__["default"] = (later);

/***/ }),

/***/ "./lib/Grid/column/ActionColumn.js":
/*!*****************************************!*\
  !*** ./lib/Grid/column/ActionColumn.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ActionColumn; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");



















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/column/ActionColumn
 */

/**
 * A column that displays actions (clickable icons) in the cell.
 *
 * ```javascript
 * new TreeGrid({
 *     appendTo : document.body,
 *     columns  : [{
 *         type    : 'action',
 *         text    : 'Increase amount',
 *         actions : [{
 *             cls      : 'b-fa b-fa-plus',
 *             renderer : ({ action, record }) => `<i class="b-action-item ${action.cls} b-${record.enabled ? "green" : "red"}-class"></i>`,
 *             visible  : ({ record }) => record.canAdd,
 *             tooltip  : ({ record }) => `<p class="b-nicer-than-default">Add to ${record.name}</p>`,
 *             onClick  : ({ record }) => console.log(`Adding ${record.name}`)
 *         }, {
 *             cls     : 'b-fa b-fa-pencil',
 *             tooltip : 'Edit note',
 *             onClick : ({ record }) => console.log(`Editing ${record.name}`)
 *         }]
 *     }]
 * });
 * ```
 *
 * Actions may be placed in {@link Grid/feature/Group} headers, by setting `actions.showForGroup` to `true`. Those actions will not be shown on normal rows.
 *
 * @extends Grid/column/Column
 *
 * @classType action
 * @externalexample column/ActionColumn.js
 */

var ActionColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(ActionColumn, _Column);

  var _super = _createSuper(ActionColumn);

  function ActionColumn() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default()(this, ActionColumn);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default()(ActionColumn, [{
    key: "construct",
    value: function construct(config, store) {
      this.internalCellCls = 'b-action-cell';

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(ActionColumn.prototype), "construct", this).apply(this, arguments); // use auto-size only as default behaviour


      if (!config.width && !config.flex) {
        this.grid.on('paint', this.updateAutoWidth, this);
      }
    }
    /**
     * Renderer that displays action icon(s) in the cell.
     * @private
     */

  }, {
    key: "renderer",
    value: function renderer(_ref) {
      var column = _ref.column,
          record = _ref.record;
      var inGroupTitle = record && 'groupRowFor' in record.meta;
      return {
        className: {
          'b-action-ct': 1
        },
        children: column.actions.map(function (actionConfig, index) {
          if ('visible' in actionConfig) {
            if (typeof actionConfig.visible === 'function' && actionConfig.visible({
              record: record
            }) === false) {
              return '';
            }

            if (actionConfig.visible === false) {
              return '';
            }
          } // check if an action allowed to be shown in case of using groupping


          if (inGroupTitle && !actionConfig.showForGroup || !inGroupTitle && actionConfig.showForGroup) {
            return '';
          }

          var btip;

          if (typeof actionConfig.tooltip === 'function') {
            btip = actionConfig.tooltip({
              record: record
            });
          } else {
            btip = actionConfig.tooltip || '';
          } // handle custom renderer if it is specified


          if (actionConfig.renderer && typeof actionConfig.renderer === 'function') {
            var customRendererData = actionConfig.renderer({
              index: index,
              record: record,
              column: column,
              tooltip: btip,
              action: actionConfig
            }); // take of set data-index to make onClick handler work stable

            if (typeof customRendererData === 'string') {
              return {
                tag: 'span',
                dataset: {
                  index: index
                },
                html: customRendererData
              };
            } else {
              customRendererData.dataset = customRendererData.dataset || {};
              customRendererData.dataset.index = index;
              return customRendererData;
            }
          } else {
            return {
              tag: 'i',
              dataset: {
                index: index,
                btip: btip
              },
              className: _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default()({
                'b-action-item': 1
              }, actionConfig.cls, 1)
            };
          }
        })
      };
    }
    /**
     * Handle icon click and call action handler.
     * @private
     */

  }, {
    key: "onCellClick",
    value: function onCellClick(_ref2) {
      var grid = _ref2.grid,
          column = _ref2.column,
          record = _ref2.record,
          target = _ref2.target;

      if (!target.classList.contains('b-action-item') || grid.readOnly) {
        return;
      }

      var actionIndex = target.dataset.index; // index may be set in a parent node if user used an html string in his custom renderer
      // and we take care to set this property to support onClick handler

      if (!actionIndex) {
        actionIndex = target.parentElement.dataset && target.parentElement.dataset.index;
      }

      var action = column.actions[actionIndex],
          actionHandler = action && action.onClick;

      if (actionHandler) {
        this.callback(actionHandler, column, [{
          record: record,
          action: action
        }]);
      }
    }
    /**
     * Update width for actions column to fit content.
     * @private
     */

  }, {
    key: "updateAutoWidth",
    value: function updateAutoWidth() {
      var me = this,
          groupActions = [];
      var actions = []; // collect group and non group actions to check length later

      me.actions.forEach(function (actionOriginal) {
        var action = _objectSpread({}, actionOriginal); // remove possible visibility condition to make sure an action will exists in test HTML


        delete action.visible; // group actions shows in different row and never together with non group

        if (action.showForGroup) {
          delete action.showForGroup;
          groupActions.push(action);
        } else {
          actions.push(action);
        }
      }); // use longest actions length to calculate column width

      if (groupActions.length > actions.length) {
        actions = groupActions;
      }

      var actionsHtml = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].createElement(me.renderer({
        column: {
          actions: actions
        }
      })).outerHTML;
      me.width = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].measureText(actionsHtml, me.element, true, me.element.parentElement);
    }
  }], [{
    key: "type",
    get: function get() {
      return 'action';
    }
  }, {
    key: "fields",
    get: function get() {
      return [
      /**
       * An array of action config objects
       * @config {Object[]} actions List of action configs
       * @config {String} actions.cls CSS Class for action icon
       * @config {Function|String} actions.tooltip Tooltip text
       * @config {Function|Boolean} actions.visible Callback function or Boolean to update action icon visiblity on data change
       * @config {Function} actions.onClick Callback to handle click action item event
       * @config {Model} actions.onClick.record Record model
       * @config {Boolean} actions.showForGroup Set to true to have action icon visible in group headers only when using the `group` feature
       * @config {Function} actions.renderer A render function used to define the action element. Expected to return a HTML string or a DOM config object
       * @category Common
       */
      'actions'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        /**
         * Filtering by action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
         * @config {Boolean} filterable
         * @default false
         * @category Interaction
         */
        filterable: false,

        /**
         * Grouping by action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
         * @config {Boolean} groupable
         * @default false
         * @category Interaction
         */
        groupable: false,

        /**
         * Sorting by action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
         * @config {Boolean} sortable
         * @default false
         * @category Interaction
         */
        sortable: false,

        /**
         * Editor for action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
         * @config {Boolean} editor
         * @default false
         * @category Interaction
         */
        editor: false,

        /**
         * Searching by action column is not supported by default, because it has a custom renderer and uses HTML with icons as content.
         * @config {Boolean} searchable
         * @default false
         * @category Interaction
         */
        searchable: false,

        /**
         * By default, for action column this flag is switched to `true`, because the content of this column is always HTML.
         * @config {Boolean} htmlEncode
         * @default false
         * @category Misc
         */
        htmlEncode: false,

        /**
         * Set to `true` to allow the column to being drag-resized when the ColumnResize plugin is enabled.
         * @config {Boolean} resizable
         * @default false
         * @category Interaction
         */
        resizable: false,

        /**
         * Column minimal width. If value is Number then minimal width is in pixels.
         * @config {Number|String} minWidth
         * @default 30
         * @category Layout
         */
        minWidth: 30
      };
    }
  }]);

  return ActionColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_18__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_19__["default"].registerColumnType(ActionColumn);
ActionColumn.exposeProperties();
ActionColumn._$name = 'ActionColumn';

/***/ }),

/***/ "./lib/Grid/column/AggregateColumn.js":
/*!********************************************!*\
  !*** ./lib/Grid/column/AggregateColumn.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AggregateColumn; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Grid/column/AggregateColumn
 */

/**
 * A column, which, when used as part of a Tree, aggregates the values of this column's descendants using
 * a configured function which defaults to `sum`.
 *
 * Default editor depends on the data field type. If it is a number, default editor is a {@link Core.widget.NumberField NumberField}.
 * Otherwise Default editor is a {@link Core.widget.TextField TextField}.
 *
 * ```
 * const grid = new TreeGrid({
 *   // Custom aggregation handler.
 *   // For test purposes, this just does "sum"
 *   myAggregator(...values) {
 *       let result = 0;
 *
 *       for (let i = 0, { length } = args; i < length; i++) {
 *           result += parseInt(args[i], 10);
 *       }
 *       return result;
 *   },
 *   columns : [
 *      { field : 'name', text : 'Name' },
 *
 *      // Will sum the ages of leaf nodes. This is the default.
 *      { type : 'aggregate', field : 'age', text : 'Age', renderer : ({ value }) => `<b>${value}<b>` },
 *
 *      // Will use AggregateColumn's built-in avg of scores of leaf nodes
 *      { type : 'aggregate', field : 'score', text : 'Score', function : 'avg' },
 *
 *      // Will use the grid's myAggregator function
 *      { type : 'aggregate', field : 'revenue', text : 'Revenue', function : 'up.myAggregator' },
 *   ]
 * });
 * ```
 *
 * @extends Grid/column/Column
 * @classType aggregate
 */

var AggregateColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(AggregateColumn, _Column);

  var _super = _createSuper(AggregateColumn);

  function AggregateColumn() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, AggregateColumn);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(AggregateColumn, [{
    key: "construct",
    value: function construct(data, columnStore) {
      this.configuredAlign = 'align' in data;
      this.configuredEditor = 'editor' in data;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(AggregateColumn.prototype), "construct", this).apply(this, arguments);

      var grid = columnStore.grid;

      if (grid) {
        this.owner = grid;
        grid.on({
          paint: 'onGridPaint',
          thisObj: this,
          prio: 1000
        });
      }
    }
  }, {
    key: "onGridPaint",
    value: function onGridPaint(_ref) {
      var grid = _ref.source;
      this.store = grid.store;
    }
  }, {
    key: "canEdit",
    value: function canEdit(record) {
      return record.isLeaf;
    }
  }, {
    key: "sum",
    value: function sum() {
      var result = 0;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      for (var i = 0, length = args.length; i < length; i++) {
        result += parseInt(args[i] || 0, 10);
      }

      return result;
    }
  }, {
    key: "avg",
    value: function avg() {
      var result = 0;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var length = args.length;

      for (var i = 0; i < length; i++) {
        result += parseInt(args[i] || 0, 10);
      }

      return result / length;
    }
  }, {
    key: "onRecordUpdate",
    value: function onRecordUpdate(_ref2) {
      var record = _ref2.record,
          changes = _ref2.changes;
      var me = this,
          rowManager = me.grid.rowManager;

      if (me.field in changes) {
        if (record.isLeaf) {
          record.bubble(function (rec) {
            var row = rowManager.getRowFor(rec);

            if (row) {
              var cell = row.getCell(me.field);

              if (cell) {
                row.renderCell(cell, rec);
              }
            }
          }, true);
        }
      }
    }
  }, {
    key: "getRawValue",
    value: function getRawValue(record) {
      var value = 0;

      if (record.children) {
        var me = this,
            fn = me.function,
            isMathFn = typeof fn === 'string' && typeof Math[fn] === 'function',
            _ref3 = isMathFn ? {
          handler: Math[fn],
          thisObj: Math
        } : me.resolveCallback(fn),
            handler = _ref3.handler,
            thisObj = _ref3.thisObj;

        for (var i = 0, length = record.children.length; i < length; i++) {
          value = handler.call(thisObj, value, me.getRawValue(record.children[i]));
        }

        record.setData(me.field, value);
      } else {
        value = record[this.field];
      }

      return value;
    }
  }, {
    key: "store",
    set: function set(store) {
      var me = this,
          storeListeners = {
        update: 'onRecordUpdate',
        thisObj: me,
        prio: 1000
      },
          oldStore = me._store;

      if (store !== oldStore) {
        if (oldStore) {
          oldStore.un(storeListeners);
        }

        me._store = store;
        var modelClass = store.modelClass,
            field = modelClass.fieldMap[me.field]; // It's *likely*, but not certain that this will be used for a numeric field.
        // Use numeric defaults unless configured otherwise if so.

        if (field && field.type === 'number') {
          if (!me.configuredAlign) {
            me.align = 'end';
          }

          if (!me.configuredEditor) {
            me.editor = 'number';
          }
        }

        store.on(storeListeners);
      }
    },
    get: function get() {
      return this._store;
    }
  }], [{
    key: "type",
    //region Config
    get: function get() {
      return 'aggregate';
    }
  }, {
    key: "fields",
    get: function get() {
      return ['function'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        /**
         * Math Function name, or function name prepended by `"up."` that is resolveable in an
         * ancestor component (such as the owning Grid, or a hight Container), or a function to
         * use to aggregate child record values for this column, or a function.
         *
         * This Column is provided with a `sum` and `avg` function. The default function is `sum`
         * which is used for the aggregation.
         * @config {Function|String}
         * @category Common
         */
        function: 'sum'
      };
    }
  }]);

  return AggregateColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerColumnType(AggregateColumn, true);
AggregateColumn.exposeProperties();
AggregateColumn._$name = 'AggregateColumn';

/***/ }),

/***/ "./lib/Grid/column/CheckColumn.js":
/*!****************************************!*\
  !*** ./lib/Grid/column/CheckColumn.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CheckColumn; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _WidgetColumn_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./WidgetColumn.js */ "./lib/Grid/column/WidgetColumn.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Reuse checkbox instead of creating a new one





/**
 * @module Grid/column/CheckColumn
 */

/**
 * A column that displays a checkbox in the cell. The value of the backing field is toggled by the checkbox.
 *
 * This column uses a {@link Core.widget.Checkbox checkbox} as its editor, and it is not intended to be changed.
 *
 * @extends Grid/column/WidgetColumn
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'check', field: 'allow' }
 *     ]
 * });
 *
 * @classType check
 * @externalexample column/CheckColumn.js
 */

var CheckColumn = /*#__PURE__*/function (_WidgetColumn) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(CheckColumn, _WidgetColumn);

  var _super = _createSuper(CheckColumn);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(CheckColumn, null, [{
    key: "type",
    //region Config
    get: function get() {
      return 'check';
    }
  }, {
    key: "fields",
    get: function get() {
      return ['checkCls', 'showCheckAll'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        align: 'center',

        /**
         * CSS class name to add to checkbox
         * @config {String}
         * @category Rendering
         */
        checkCls: null,

        /**
         * True to show a checkbox in the column header to be able to select/deselect all rows
         * @config {Boolean}
         */
        showCheckAll: false,
        widgets: [{
          type: 'checkbox',
          valueProperty: 'checked'
        }]
      };
    }
  }]);

  function CheckColumn(config, store) {
    var _me$grid;

    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, CheckColumn);

    _this = _super.apply(this, arguments);

    var me = _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this);

    me.internalCellCls = 'b-check-cell';
    (_me$grid = me.grid) === null || _me$grid === void 0 ? void 0 : _me$grid.on({
      destroy: function destroy() {
        var _me$headerCheckbox;

        return (_me$headerCheckbox = me.headerCheckbox) === null || _me$headerCheckbox === void 0 ? void 0 : _me$headerCheckbox.destroy();
      },
      thisObj: me
    });
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(CheckColumn, [{
    key: "headerRenderer",
    value: function headerRenderer(_ref) {
      var headerElement = _ref.headerElement,
          column = _ref.column;
      var me = this;
      headerElement.classList.add('b-check-header');

      if (column.showCheckAll) {
        headerElement.classList.add('b-check-header-with-checkbox');

        if (column.headerCheckbox) {
          column.headerCheckbox.destroy();
        }

        column.headerCheckbox = new _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_13__["default"]({
          appendTo: headerElement,
          owner: me.grid,
          listeners: {
            change: function change(_ref2) {
              var checked = _ref2.checked;

              /**
               * Fired when the header checkbox is clicked to toggle its checked status.
               * @event toggleAll
               * @param {Grid.column.Column} source This Column
               * @param {Boolean} checked The checked status of the header checkbox.
               */
              column.trigger('toggleAll', {
                checked: checked
              });
            }
          }
        });
      } else {
        return column.text;
      }
    } //endregion

  }, {
    key: "renderer",
    value: function renderer(_ref3) {
      var value = _ref3.value,
          isExport = _ref3.isExport;

      if (isExport) {
        return value == null ? '' : value;
      } else {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(CheckColumn.prototype), "renderer", this).apply(this, arguments);
      }
    } //region Widget rendering

  }, {
    key: "onBeforeWidgetCreate",
    value: function onBeforeWidgetCreate(widgetCfg, event) {
      widgetCfg.cls = this.checkCls;
    }
  }, {
    key: "onAfterWidgetCreate",
    value: function onAfterWidgetCreate(widget, event) {
      event.cellElement.widget = widget;
      widget.on({
        beforeChange: 'onBeforeCheckboxChange',
        change: 'onCheckboxChange',
        thisObj: this
      });
    }
  }, {
    key: "onBeforeWidgetSetValue",
    value: function onBeforeWidgetSetValue(widget) {
      widget.record = widget.cellInfo.record;
      this.isInitialSet = true;
    }
  }, {
    key: "onAfterWidgetSetValue",
    value: function onAfterWidgetSetValue(widget) {
      this.isInitialSet = false;
    } //endregion
    //region Events

  }, {
    key: "onBeforeCheckboxChange",
    value: function onBeforeCheckboxChange(_ref4) {
      var source = _ref4.source,
          checked = _ref4.checked;

      if (!this.isInitialSet) {
        /**
         * Fired when a cell is clicked to toggle its checked status. Returning `false` will prevent status change.
         * @event beforeToggle
         * @param {Grid.column.Column} source This Column
         * @param {Core.data.Model} record The record for the row containing the cell.
         * @param {Boolean} checked The new checked status of the cell.
         */
        return this.trigger('beforeToggle', {
          record: source.cellInfo.record,
          checked: checked
        });
      }
    }
  }, {
    key: "onCheckboxChange",
    value: function onCheckboxChange(_ref5) {
      var source = _ref5.source,
          checked = _ref5.checked;

      if (!this.isInitialSet) {
        var record = source.cellInfo.record,
            field = this.field;

        if (field) {
          var setterName = "set".concat(_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].capitalize(field));

          if (record[setterName]) {
            record[setterName](checked);
          } else {
            record.set(field, checked);
          }
        }
        /**
         * Fired when a cell is clicked to toggle its checked status.
         * @event toggle
         * @param {Grid.column.Column} source This Column
         * @param {Core.data.Model} record The record for the row containing the cell.
         * @param {Boolean} checked The new checked status of the cell.
         */


        this.trigger('toggle', {
          record: record,
          checked: checked
        });
      }
    } //endregion

  }, {
    key: "onCellKeyDown",
    value: function onCellKeyDown(_ref6) {
      var event = _ref6.event,
          cellElement = _ref6.cellElement;

      // SPACE key toggles the checkbox
      if (event.key === ' ') {
        var checkbox = cellElement.widget;
        checkbox === null || checkbox === void 0 ? void 0 : checkbox.toggle(); // Prevent native browser scrolling

        event.preventDefault();
      }
    }
  }]);

  return CheckColumn;
}(_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_12__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerColumnType(CheckColumn, true);
CheckColumn._$name = 'CheckColumn';

/***/ }),

/***/ "./lib/Grid/column/Column.js":
/*!***********************************!*\
  !*** ./lib/Grid/column/Column.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Column; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Grid/column/Column
 */

var validWidth = function validWidth(value) {
  return typeof value === 'number' || (value === null || value === void 0 ? void 0 : value.endsWith('px'));
};
/**
 * Base class for other column types, used if no type is specified on a column.
 *
 * Default editor is a {@link Core.widget.TextField TextField}.
 *
 * ```javascript
 * const grid = new Grid({
 *   columns : [{
 *     field : 'name',
 *     text  : 'Name'
 *   }, {
 *     text  : 'Hobby',
 *     field : 'others.hobby', // reading nested field data
 *   }, {
 *     type  : 'number', // Will use NumberColumn
 *     field : 'age',
 *     text  : 'Age'
 *   }]
 * });
 * ```
 *
 * ## Column types
 *
 * Grid ships with multiple different column types. Which type to use for a column is specified by the `type` config. The built in types are:
 *
 * * {@link Grid.column.ActionColumn action} - displays actions (clickable icons) in the cell.
 * * {@link Grid.column.AggregateColumn aggregate} - a column, which, when used as part of a Tree, aggregates the values of
 *   this column's descendants using a configured function which defaults to `sum`.
 * * {@link Grid.column.CheckColumn check} - displays a checkbox in the cell.
 * * {@link Grid.column.DateColumn date} - displays a date in the specified format.
 * * {@link Grid.column.NumberColumn number} - a column for showing/editing numbers.
 * * {@link Grid.column.PercentColumn percent} - displays a basic progress bar.
 * * {@link Grid.column.RatingColumn rating} - displays a star rating.
 * * {@link Grid.column.RowNumberColumn rownumber} - displays the row number in each cell.
 * * {@link Grid.column.TemplateColumn template} - uses a template for cell content.
 * * {@link Grid.column.TimeColumn time} - displays a time in the specified format.
 * * {@link Grid.column.TreeColumn tree} - displays a tree structure when using the {@link Grid.feature.Tree tree} feature.
 * * {@link Grid.column.WidgetColumn widget} - displays widgets in the cells.
 *
 * ## Cell renderers
 *
 * You can affect the contents and styling of cells in a column using a {@link Grid.column.Column#config-renderer renderer()} function.
 *
 * ```javascript
 * const grid = new Grid({
 *   columns : [
 *   ...
 *     {
 *       field      : 'approved',
 *       text       : 'Approved',
 *       htmlEncode : false, // allow to use HTML code
 *       renderer({ value }) {
 *         return value === true ? '<b>Yes</b>' : '<i>No</i>';
 *       }
 *     }
 *     ...
 *     ]
 * });
 * ```
 *
 * ## Menus
 *
 * You can add custom items to the context menu for a columns header and for its cells, using {@link Grid.column.Column#config-headerMenuItems headerMenuItems} and
 * {@link Grid.column.Column#config-cellMenuItems cellMenuItems}. Here is an example:
 *
 * ```javascript
 * const grid = new Grid({
 *   columns : [
 *     ...
 *     {
 *       type  : 'number',
 *       field : 'age',
 *       text  : 'Age',
 *       headerMenuItems: [{
 *           text : 'My unique header item',
 *           icon : 'b-fa b-fa-paw',
 *           onItem() { console.log('item clicked'); }
 *       }],
 *       cellMenuItems: [{
 *           text : 'My unique cell item',
 *           icon : 'b-fa b-fa-plus',
 *           onItem() { console.log('item clicked'); }
 *       }]
 *     }
 *   ...
 *   ]
 * });
 * ```
 *
 * @extends Core/data/Model
 * @classType column
 * @mixes Core/mixin/Events
 * @mixes Core/localization/Localizable
 */


var Column = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(Column, _Events);

  var _super = _createSuper(Column);

  function Column() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17___default()(this, Column);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default()(Column, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(data, store) {
      var me = this;
      me.masterStore = store; // Store might be an array

      if (store) {
        me._grid = Array.isArray(store) ? store[0].grid : store.grid;
      }

      me.localizableProperties = data.localizableProperties || ['text'];

      if (data.localeClass) {
        me.localeClass = data.localeClass;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Column.prototype), "construct", this).call(this, data, store, null, false); // Default value for region is assigned by the ColumnStore in createRecord(), same for `locked`
      // Allow field : null if the column does not rely on a record field.
      // For example the CheckColumn when used by GridSelection.


      if (!('field' in me.data)) {
        me.field = '_' + (me.type || '') + ++Column.emptyCount;
        me.noFieldSpecified = true;
      } // If our field is a dot separated path, we must use ObjectHelper.getPath to extract our value


      me.hasComplexMapping = me.field && me.field.includes('.');

      if (!me.width && !me.flex && !me.children) {
        // Set the width silently because we're in construction.
        me.set({
          width: Column.defaultWidth,
          flex: null
        }, null, true);
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      var subGrid = this.subGrid,
          grid = this.grid,
          focusedCell = subGrid && grid && grid.focusedCell; // Prevent errors when removing the column that the owning grid has registered as focused.

      if (focusedCell && focusedCell.columnId === this.id) {
        // Focus is in the grid, navigate before column is removed
        if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].activeElement === grid) {
          grid.navigateRight();
        } // Focus not in the grid, bump the focused cell pointer to the ext visible column.
        else {
            focusedCell.columnId = subGrid.columns.getAdjacentVisibleLeafColumn(this.id, true, true).id;
          }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Column.prototype), "remove", this).call(this);
    }
    /**
     * Extracts the value from the record specified by this Column's {@link #config-field} specification.
     *
     * This will work if the field is a dot-separated path to access fields in associated records, eg
     *
     * ```javascript
     *  field : 'resource.calendar.name'
     * ```
     *
     * **Note:** This is the raw field value, not the value returned by the {@link #config-renderer}.
     * @param {Core.data.Model} record The record from which to extract the field value.
     * @returns {*} The value of the referenced field if any.
     */

  }, {
    key: "getRawValue",
    value: function getRawValue(record) {
      var me = this;

      if (me.hasComplexMapping) {
        return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].getPath(record, me.field);
      } // Engine can change field value to null, in which case cell will render previous record value, before project commit


      return record[me.field];
    } // Create an ownership hierarchy which links columns up to their SubGrid if no owner injected.

  }, {
    key: "hide",
    //endregion
    //region Show/hide

    /**
     * Hides this column.
     */
    value: function hide() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          parent = me.parent; // Reject non-change

      if (!me.hidden) {
        me.hidden = true;

        if (parent && !parent.isRoot) {
          // check if all sub columns are hidden, if so hide parent
          var anyVisible = parent.children.some(function (child) {
            return child.hidden !== true;
          });

          if (!anyVisible && !parent.hidden) {
            silent = true; // hiding parent will trigger event

            parent.hide();
          }
        }

        if (me.children) {
          me.children.forEach(function (child) {
            return child.hide(true);
          });
        }

        if (!silent) {
          me.stores.forEach(function (store) {
            return store.trigger('columnHide', {
              column: me
            });
          });
        }
      }
    }
    /**
     * Shows this column.
     */

  }, {
    key: "show",
    value: function show() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          parent = me.parent; // Reject non-change

      if (me.hidden) {
        me.hidden = false;

        if (parent && parent.hidden) {
          parent.show();
        }

        if (me.children) {
          me.children.forEach(function (child) {
            return child.show(true);
          });
        } // event is triggered on chained stores


        if (!silent) {
          me.stores.forEach(function (store) {
            return store.trigger('columnShow', {
              column: me
            });
          });
        }
      }
    }
    /**
     * Toggles the column visibility.
     * @param {Boolean} force Set to true (visible) or false (hidden) to force a certain state
     */

  }, {
    key: "toggle",
    value: function toggle() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.hidden && force === undefined || force === true) return this.show();
      if (!this.hidden && force === undefined || force === false) return this.hide();
    } //endregion
    //region Index & id

    /**
     * Generates an id for the column when none is set. Generated ids are 'col1', 'col2' and so on. If a field is
     * specified (as it should be in most cases) the field name is used instead: 'name1', 'age2' ...
     * @private
     * @returns {String}
     */

  }, {
    key: "generateId",
    value: function generateId() {
      if (!Column.generatedIdIndex) Column.generatedIdIndex = 0;
      return (this.field ? this.field.replace(/\./g, '-') : 'col') + ++Column.generatedIdIndex;
    }
    /**
     * Index among all flattened columns
     * @property {Number}
     * @readOnly
     * @internal
     */

  }, {
    key: "measureSize",
    // Returns size in pixels for measured value
    value: function measureSize(value) {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].measureSize(value, this.subGrid ? this.subGrid.element : undefined);
    } // This method is used to calculate minimum row width for edge and safari
    // It calculates minimum width of the row taking column hierarchy into account

  }, {
    key: "calculateMinWidth",
    value: function calculateMinWidth() {
      var me = this,
          width = me.measureSize(me.width),
          minWidth = me.measureSize(me.minWidth);
      var minChildWidth = 0;

      if (me.children) {
        minChildWidth = me.children.reduce(function (result, column) {
          return result + column.calculateMinWidth();
        }, 0);
      }

      return Math.max(width, minWidth, minChildWidth);
    }
    /**
     * Resizes the column to match the widest string in it. By default it also measures the column header, this
     * behaviour can be configured by setting {@link Grid.view.Grid#config-resizeToFitIncludesHeader}.
     *
     * Called internally when you double click the edge between
     * column headers, but can also be called programmatically. For performance reasons it is limited to checking 1000
     * rows surrounding the current viewport.
     *
     * @param {Number|Number[]} widthMin The minimum allowed width. If the content width
     * is less than this number, this width is used instead. If this parameter is an array,
     * the first element is `widthMin` and the seconds is `widthMax`.
     * @param {Number} widthMax The maximum allowed width. If the content width is greater
     * than this number, this width is used instead.
     */

  }, {
    key: "resizeToFitContent",
    value: function resizeToFitContent(widthMin, widthMax) {
      var me = this,
          grid = me.grid,
          renderer = me.renderer,
          defaultRenderer = me.defaultRenderer,
          element = me.element,
          rowManager = grid.rowManager,
          store = grid.store,
          count = store.count,
          useRenderer = renderer || defaultRenderer;

      if (count <= 0) {
        return;
      }

      var cellElement = grid.element.querySelector(".b-grid-cell[data-column-id=\"".concat(me.id, "\"]")),
          originalStyle = cellElement.cssText,
          // Renderer might overwrite
      originalClassName = cellElement.className; // Renderer might overwrite

      var maxWidth = 0,
          start,
          end,
          i,
          record,
          value; // Measure header unless configured not to

      if (grid.resizeToFitIncludesHeader) {
        var style = window.getComputedStyle(element); // Header always in view, use its element

        maxWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].measureText(element.innerText, element, false, element.parentElement) + parseInt(style.paddingLeft); // Seems to miss the padding, have not found why
        // Remove measuring element, it messes some styling rules up if left in DOM

        element.parentElement.offScreenDiv.parentElement.remove();
      } // If it's a very large dataset, measure the maxWidth of the field in the 1000 rows
      // surrounding the rendered block.


      if (count > 1000) {
        start = Math.max(Math.min(rowManager.topIndex + rowManager.rowCount / 2 - 500, count - 1000), 0);
        end = start + 1000;
      } else {
        start = 0;
        end = count;
      }

      for (i = start; i < end; i++) {
        record = store.getAt(i);
        value = me.getRawValue(record);

        if (useRenderer) {
          value = useRenderer.call(me, {
            cellElement: cellElement,
            rowElement: cellElement.parentNode,
            value: value,
            record: record,
            column: me,
            size: {
              height: record.rowHeight || 0
            },
            grid: grid,
            row: {},
            updatingSingleRow: false
          }); // Cell renderer is allowed to direction manipulate the cell element, if so it wont return a value

          value = value == null ? cellElement.innerHTML : String(value);
        }

        if (value) {
          // Measure withing the SubGrid, allows more css rules to apply. Not measuring inside rows sine that might get to costly performance wise
          maxWidth = Math.max(maxWidth, _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].measureText(value, cellElement, !(me.htmlEncode && !me.disableHtmlEncode), me.subGrid.element));
        }
      }

      if (Array.isArray(widthMin)) {
        var _widthMin = widthMin;

        var _widthMin2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_16___default()(_widthMin, 2);

        widthMin = _widthMin2[0];
        widthMax = _widthMin2[1];
      }

      maxWidth = Math.max(maxWidth, widthMin || 0);
      maxWidth = Math.min(maxWidth, widthMax || 1e6); // 1 million px default max
      // Restore top cell which may be mutated by the repeated call of the renderer.

      cellElement.className = originalClassName;
      cellElement.cssText = originalStyle;
      return me.width = maxWidth;
    } //endregion
    //region State

    /**
     * Get column state, used by State mixin
     * @private
     */

  }, {
    key: "getState",
    value: function getState() {
      var _state;

      // TODO: exclude those with value = default?
      var me = this,
          state = (_state = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(_state, me.flex ? 'flex' : 'width', me.flex ? me.flex : me.width), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(_state, "id", me.id), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(_state, "hidden", me.hidden), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(_state, "index", me.allIndex), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(_state, "region", me.region), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(_state, "filterable", me.filterable), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(_state, "text", me.text), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(_state, "locked", me.locked), _state);
      if (me.children) state.children = me.children.map(function (child) {
        return child.getState();
      });
      return state;
    }
    /**
     * Apply state to column, used by State mixin
     * @private
     */

  }, {
    key: "applyState",
    value: function applyState(state) {
      var me = this;
      me.beginBatch();

      if ('locked' in state) {
        me.locked = state.locked;
      }

      if ('minWidth' in state) {
        me.minWidth = state.minWidth;
      }

      if ('width' in state) {
        me.width = state.width;
      }

      if ('flex' in state) {
        me.flex = state.flex;
      }

      if ('width' in state && me.flex) {
        me.flex = undefined;
      } else if ('flex' in state && me.width) {
        me.width = undefined;
      }

      if ('text' in state) {
        me.text = state.text;
      }

      if ('region' in state) {
        me.region = state.region;
      }

      if ('renderer' in state) {
        me.renderer = state.renderer;
      }

      if ('filterable' in state) {
        me.filterable = state.filterable;
      }

      me.endBatch();

      if ('hidden' in state) {
        me.toggle(state.hidden !== true);
      }
    } //endregion
    //region Other

    /**
     * Refresh the cell for supplied record in this column, if that cell is rendered.
     * @param {Core.data.Model} record Record used to get row to update the cell in
     */

  }, {
    key: "refreshCell",
    value: function refreshCell(record) {
      this.grid.rowManager.refreshCell(record, this.id);
    }
    /**
     * Clear cell contents. Base implementation which just sets innerHTML to blank string.
     * Should be overridden in subclasses to clean up for examples widgets.
     * @param {HTMLElement} cellElement
     * @internal
     */

  }, {
    key: "clearCell",
    value: function clearCell(cellElement) {
      cellElement.innerHTML = '';
    }
    /**
     * Override in subclasses to allow/prevent editing of certain rows.
     * @param {Core.data.Model} record
     * @internal
     */

  }, {
    key: "canEdit",
    value: function canEdit(record) {
      return true;
    } //endregion

  }, {
    key: "owner",
    get: function get() {
      return this._owner || this.subGrid;
    },
    set: function set(owner) {
      this._owner = owner;
    }
  }, {
    key: "nextVisibleSibling",
    get: function get() {
      // During move from one region to another, nextSibling might not be wired up to the new next sibling in region.
      // (Because the order in master store did not change)
      var region = this.region;
      var next = this.nextSibling;

      while (next && (next.hidden || next.region !== region)) {
        next = next.nextSibling;
      }

      return next;
    }
  }, {
    key: "isLastInSubGrid",
    get: function get() {
      return !this.nextVisibleSibling && (!this.parent || this.parent.isLastInSubGrid);
    }
    /**
     * The header element for this Column. *Only available after the grid has been rendered*.
     *
     * **Note that column headers are rerendered upon mutation of Column values, so this
     * value is volatile and should not be cached, but should be read whenever needed.**
     * @property {HTMLElement}
     * @readonly
     */

  }, {
    key: "element",
    get: function get() {
      return this.grid.getHeaderElement(this);
    }
    /**
     * The text wrapping element for this Column. *Only available after the grid has been rendered*.
     *
     * This is the full-width element which *contains* the text-bearing element and any icons.
     *
     * **Note that column headers are rerendered upon mutation of Column values, so this
     * value is volatile and should not be cached, but should be read whenever needed.**
     * @property {HTMLElement}
     * @readonly
     */

  }, {
    key: "textWrapper",
    get: function get() {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].getChild(this.element, '.b-grid-header-text');
    }
    /**
     * The text containing element for this Column. *Only available after the grid has been rendered*.
     *
     * **Note that column headers are rerendered upon mutation of Column values, so this
     * value is volatile and should not be cached, but should be read whenever needed.**
     * @property {HTMLElement}
     * @readonly
     */

  }, {
    key: "textElement",
    get: function get() {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].down(this.element, '.b-grid-header-text-content');
    }
    /**
     * The child element into which content should be placed. This means where any
     * contained widgets such as filter input fields should be rendered. *Only available after the grid has been rendered*.
     *
     * **Note that column headers are rerendered upon mutation of Column values, so this
     * value is volatile and should not be cached, but should be read whenever needed.**
     * @property {HTMLElement}
     * @readonly
     */

  }, {
    key: "contentElement",
    get: function get() {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].down(this.element, '.b-grid-header-children');
    }
    /**
     * The Field to use as editor for this column
     * @private
     * @readonly
     */

  }, {
    key: "editor",
    get: function get() {
      var editor = this.data.editor;

      if (editor && !(editor instanceof _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_27__["default"])) {
        // Give frameworks a shot at injecting their own editor, wrapped as a widget
        var result = this.grid.processCellEditor({
          editor: editor,
          field: this.field
        });

        if (result) {
          // Use framework editor
          editor = this.data.editor = result.editor;
        } else {
          if (typeof editor === 'string') {
            editor = {
              type: editor
            };
          }

          editor = this.data.editor = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_27__["default"].create(Object.assign(this.defaultEditor, editor, {
            owner: this.grid
          }));
        }
      }

      return editor;
    },
    set: function set(editor) {
      this.data.editor = editor;
    }
    /**
     * A config object specifying the editor to use to edit this column.
     * @private
     * @readonly
     */

  }, {
    key: "defaultEditor",
    get: function get() {
      return {
        type: 'textfield',
        name: this.field
      };
    }
    /**
     * Default settings for the column, applied in constructor. None by default, override in subclass.
     * @member {Object} defaults
     * @returns {Object}
     * @readonly
     */
    //get defaults() {
    //    return {};
    //}
    //endregion
    //region Properties

  }, {
    key: "isFocusable",
    get: function get() {
      return this.isLeaf;
    }
  }, {
    key: "grid",
    get: function get() {
      return this._grid || this.parent && this.parent.grid;
    }
  }, {
    key: "locked",
    get: function get() {
      return this.data.region === 'locked';
    },
    set: function set(locked) {
      this.region = locked ? 'locked' : 'normal';
    } // parent headers cannot be sorted by

  }, {
    key: "sortable",
    get: function get() {
      return this.isLeaf && this.data.sortable;
    },
    set: function set(sortable) {
      this.set('sortable', sortable);
    } // parent headers cannot be grouped by

  }, {
    key: "groupable",
    get: function get() {
      return this.isLeaf && this.data.groupable;
    },
    set: function set(groupable) {
      this.set('groupable', groupable);
    }
  }, {
    key: "allIndex",
    get: function get() {
      return this.masterStore.indexOf(this);
    } //endregion
    //region Width

    /**
     * Returns minimal width in pixels for applying to style according to the current `width` and `minWidth`. Used for IE11.
     * @internal
     */

  }, {
    key: "calcMinWidth",
    get: function get() {
      var _this$data = this.data,
          width = _this$data.width,
          minWidth = _this$data.minWidth;

      if (validWidth(width) && validWidth(minWidth)) {
        return Math.max(parseInt(width) || 0, parseInt(minWidth) || 0);
      } else {
        return width;
      }
    }
    /**
     * Get/set columns width in px. If column uses flex, width will be undefined.
     * Setting a width on a flex column cancels out flex.
     *
     * **NOTE:** Grid might be configured to always stretch the last column, in which case the columns actual width
     * might deviate from the configured width.
     *
     * ```javascript
     * let grid = new Grid({
     *     appendTo : 'container',
     *     height   : 200,
     *     width    : 400,
     *     columns  : [{
     *         text  : 'First column',
     *         width : 100
     *     }, {
     *         text  : 'Last column',
     *         width : 100 // last column in the grid is always stretched to fill the free space
     *     }]
     * });
     *
     * grid.columns.last.element.offsetWidth; // 300 -> this points to the real element width
     * ```
     * @property {Number|String}
     */

  }, {
    key: "width",
    get: function get() {
      return this.data.width;
    },
    set: function set(width) {
      var data = {
        width: width
      };

      if (width && 'flex' in this.data) {
        data.flex = null; // remove flex when setting width to enable resizing flex columns
      }

      this.set(data);
    }
  }, {
    key: "flex",
    set: function set(flex) {
      var data = {
        flex: flex
      };

      if (flex && 'width' in this.data) {
        data.width = null; // remove width when setting flex
      }

      this.set(data);
    },
    get: function get() {
      return this.data.flex;
    } // Private, only used in tests where standalone Headers are created with no grid
    // from which to lookup the associate SubGrid.

  }, {
    key: "subGrid",
    set: function set(subGrid) {
      this._subGrid = subGrid;
    }
    /**
     * Get the SubGrid to which this column belongs
     * @property {Grid.view.SubGrid}
     * @readonly
     */
    ,
    get: function get() {
      return this._subGrid || (this.grid ? this.grid.getSubGridFromColumn(this) : undefined);
    }
    /**
     * Get the element for the SubGrid to which this column belongs
     * @property {HTMLElement}
     * @readonly
     * @private
     */

  }, {
    key: "subGridElement",
    get: function get() {
      return this.subGrid.element;
    }
  }], [{
    key: "fields",
    //region Config
    get: function get() {
      return [//region Common

      /**
       * Get/set header text
       * @member {String} text
       */

      /**
       * Text to display in the header
       * @config {String} text
       * @category Common
       */
      'text',
      /**
       * The {@link Core.data.Model Model} field name to read data from
       * @config {String} field
       * @category Common
       */
      'field',
      /**
       * Renderer function, used to format and style the content displayed in the cell. Return the cell text you
       * want to display. Can also affect other aspects of the cell, such as styling.
       *
       * **NOTE:** If you mutate cellElement and you want to prevent cell content to be reset during the rendering,
       * please return `undefined` from the renderer or just omit the `return` statement. If you return a value and
       * the value can be undefined, please make sure you return an empty string to update the cell content. For example:
       *
       * ```javascript
       * new Grid({
       *     columns : [
       *         // Returns an empty string if status field value is undefined
       *         { text : 'Status', renderer : ({ record }) => record.status ?? '' },
       *     ]
       * });
       * ```
       *
       * @param {Object} renderData Object containing renderer parameters
       * @param {HTMLElement} [renderData.cellElement] Cell element, for adding CSS classes, styling etc.
       *        Can be `null` in case of export
       * @param {*} renderData.value Value to be displayed in the cell
       * @param {Core.data.Model} renderData.record Record for the row
       * @param {Grid.column.Column} renderData.column This column
       * @param {Grid.view.Grid} renderData.grid This grid
       * @param {Grid.row.Row} [renderData.row] Row object. Can be null in case of export
       * @param {Object} [renderData.size] Set `size.height` to specify the desired row height for the current row.
       *        Largest specified height is used, falling back to configured {@link Grid/view/Grid#config-rowHeight}
       *        in case none is specified. Can be null in case of export
       * @param {Number} [renderData.size.height] Set this to request a certain row height
       * @param {Number} [renderData.size.configuredHeight] Row height that will be used if none is requested
       * @param {Boolean} [renderData.isExport] True if record is being exported to allow special handling during export
       *
       * @config {Function} renderer
       * @category Common
       */
      'renderer', //'reactiveRenderer',

      /**
       * Column width. If value is Number then width is in pixels
       * @config {Number|String} width
       * @category Common
       */
      'width',
      /**
       * Gets or sets the column flex weight
       * @member {String} flex
       */

      /**
       * Column width as a flex weight. All columns with flex specified divide the available space (after
       * subtracting fixed widths) between them according to the flex value. Columns that have flex 2 will be
       * twice as wide as those with flex 1 (and so on)
       * @config {Number} flex
       * @category Common
       */
      'flex',
      /**
       * This config sizes a column to fits its content. It is used instead of `width` or `flex`.
       *
       * This config requires the {@link Grid.feature.ColumnAutoWidth} feature which responds to changes in the
       * grid's store and synchronizes the widths' of all `autoWidth` columns.
       *
       * If this config is not a Boolean value, it is passed as the only argument to the `resizeToFitContent`
       * method to constrain the column's width.
       *
       * @config {Boolean|Number|Number[]} autoWidth
       * @category Common
       */
      'autoWidth', //endregion
      //region Interaction

      /**
       * Specify if this column should be editable, and define which editor to use for editing cells in the
       * column (if {@link Grid/feature/CellEdit CellEdit} feature is enabled). Editor refers to {@link #config-field}
       * for a data source.
       *
       * All subclasses of {@link Core.widget.Field Field} can be used as editors. The most popular are:
       * - {@link Core.widget.TextField TextField};
       * - {@link Core.widget.NumberField NumberField};
       * - {@link Core.widget.DateField DateField};
       * - {@link Core.widget.TimeField TimeField};
       * - {@link Core.widget.Combo Combo};
       *
       * If record has method set + capitalized field, method will be called, e.g. if record has method named
       * `setFoobar` and this config is `foobar`, then instead of `record.foobar = value`,
       * `record.setFoobar(value)` will be called.
       *
       * @config {String|Object|Boolean} editor
       * @category Interaction
       */
      {
        name: 'editor',
        defaultValue: {}
      },
      /**
       * A function which is called when a cell edit is requested to finish.
       *
       * This may be an `async` function which performs complex validation. The edit will not
       * complete until it returns `false` to mean the edit cannot be finished, or `true` to go
       * ahead and complete.
       *
       * @param {Object} context An object describing the state of the edit at completion request time.
       * @param {Core.widget.Field} context.inputField The field configured as the column's `editor`.
       * @param {Core.data.Model} context.record The record being edited.
       * @param {*} context.oldValue The old value of the cell.
       * @param {*} context.value The new value of the cell.
       * @param {Grid.view.Grid} context.grid The host grid.
       * @param {Object} context.editorContext The {@link Grid.feature.CellEdit CellEdit} context object.
       * @param {Grid.column.Column} context.editorContext.column The column being edited.
       * @param {Core.data.Model} context.editorContext.record The record being edited.
       * @param {HTMLElement} context.editorContext.cell The cell element hosting the editor.
       * @param {Core.widget.Editor} context.editorContext.editor The floating Editor widget which is hosting the input field.
       * @config {Function} finalizeCellEdit
       * @category Interaction
       */
      'finalizeCellEdit',
      /**
       * Setting this option means that pressing the `ESCAPE` key after editing the field will
       * revert the field to the value it had when the edit began. If the value is _not_ changed
       * from when the edit started, the input field's {@link Core.widget.Field#config-clearable}
       * behaviour will be activated. Finally, the edit will be canceled.
       * @config {Boolean} revertOnEscape
       * @default true
       * @category Interaction
       */
      {
        name: 'revertOnEscape',
        defaultValue: true
      },
      /**
       * How to handle a request to complete a cell edit in this column if the field is invalid.
       * There are three choices:
       *  - `block` The default. The edit is not exited, the field remains focused.
       *  - `allow` Allow the edit to be completed.
       *  - `revert` The field value is reverted and the edit is completed.
       * @config {String} invalidAction
       * @default 'block'
       * @category Interaction
       */
      {
        name: 'invalidAction',
        defaultValue: 'block'
      },
      /**
       * Allow sorting of data in the column. You can pass true/false to enable/disable sorting, or provide a
       * custom sorting function, or a config object for a {@link Core.util.CollectionSorter}
       *
       * ```javascript
       * const grid = new Grid({
       *     columns : [
       *          {
       *              // Disable sorting for this column
       *              sortable : false
       *          },
       *          {
       *              // Custom sorting for this column
       *              sortable : function(user1, user2) {
       *                  return user1.name < user2.name ? -1 : 1;
       *              }
       *          },
       *          {
       *              // A config object for a Core.util.CollectionSorter
       *              sortable : {
       *                  property         : 'someField',
       *                  direction        : 'DESC',
       *                  useLocaleCompare : 'sv-SE'
       *              }
       *          }
       *     ]
       * });
       * ```
       *
       * @config {Boolean|Function|Object} sortable
       * @default true
       * @category Interaction
       */
      {
        name: 'sortable',
        defaultValue: true
      },
      /**
       * Allow searching in the column (respected by QuickFind and Search features)
       * @config {Boolean} searchable
       * @default true
       * @category Interaction
       */
      {
        name: 'searchable',
        defaultValue: true
      },
      /**
       * Allow filtering data in the column (if {@link Grid.feature.Filter} or {@link Grid.feature.FilterBar} feature is enabled).
       * Also allows passing a custom filtering function that will be called for each record with a single argument of format
       * { value, record, [operator] }. Returning `true` from the function includes the record in the filtered set.
       * Configuration object may be used for {@link Grid.feature.FilterBar} feature to specify `filterField`. See an example in the code
       * snippet below or check {@link Grid.feature.FilterBar} page for more details.
       *
       * ```
       * const grid = new Grid({
       *     columns : [
       *          {
       *              field : 'name',
       *              // Disable filtering for this column
       *              filterable : false
       *          },
       *          {
       *              field : 'age',
       *              // Custom filtering for this column
       *              filterable: ({ value, record }) => Math.abs(record.age - value) < 10
       *          },
       *          {
       *              field : 'city',
       *              // Filtering for a value out of a list of values
       *              filterable: {
       *                  filterField : {
       *                      type  : 'combo',
       *                      value : '',
       *                      items : [
       *                          'Paris',
       *                          'Dubai',
       *                          'Moscow',
       *                          'London',
       *                          'New York'
       *                      ]
       *                  }
       *              }
       *          }
       *     ]
       * });
       * ```
       *
       * @config {Boolean|Function|Object} filterable
       * @default true
       * @category Interaction
       */
      {
        name: 'filterable',
        defaultValue: true
      },
      /**
       * Allow column visibility to be toggled through UI
       * @config {Boolean} hideable
       * @default true
       * @category Interaction
       */
      {
        name: 'hideable',
        defaultValue: true
      },
      /**
       * Set to false to prevent this column header from being dragged
       * @config {Boolean} draggable
       * @category Interaction
       */
      {
        name: 'draggable',
        defaultValue: true
      },
      /**
       * Set to false to prevent grouping by this column
       * @config {Boolean} groupable
       * @category Interaction
       */
      {
        name: 'groupable',
        defaultValue: true
      },
      /**
       * Set to `false` to prevent the column from being drag-resized when the ColumnResize plugin is enabled.
       * @config {Boolean} resizable
       * @default true
       * @category Interaction
       */
      {
        name: 'resizable',
        defaultValue: true
      }, //endregion
      //region Rendering

      /**
       * Renderer function for group headers (when using Group feature).
       * @param {Object} renderData
       * @param {HTMLElement} renderData.cellElement Cell element, for adding CSS classes, styling etc.
       * @param {*} renderData.groupRowFor Current group value
       * @param {Core.data.Model} renderData.record Record for the row
       * @param {Core.data.Model[]} renderData.groupRecords Records in the group
       * @param {Grid.column.Column} renderData.column Current rendering column
       * @param {Grid.column.Column} renderData.groupColumn Column that the grid is grouped by
       * @param {Number} renderData.count Number of records in the group
       * @param {Grid.view.Grid} renderData.grid This grid
       * @config {Function} groupRenderer
       * @returns {String} The header grouping text
       * @category Rendering
       */
      'groupRenderer',
      /**
       * Renderer function for the column header.
       * @param {Object} renderData
       * @param {Grid.column.Column} renderData.column This column
       * @param {HTMLElement} renderData.headerElement The header element
       * @config {Function} headerRenderer
       * @category Rendering
       */
      'headerRenderer',
      /**
       * Renderer function for cell tooltips header (used with CellTooltip feature). Specify false to prevent
       * tooltip for that column.
       * @param {HTMLElement} cellElement Cell element
       * @param {Core.data.Model} record Record for cell row
       * @param {Grid.column.Column} column Cell column
       * @param {CellTooltip} cellTooltip Feature instance, used to set tooltip content async
       * @param {MouseEvent} event The event that triggered the tooltip
       * @config {Function} tooltipRenderer
       * @category Rendering
       */
      'tooltipRenderer',
      /**
       * CSS class added to each cell in this column
       * @config {String} cellCls
       * @category Rendering
       */
      'cellCls',
      /**
       * CSS class added to the header of this column
       * @config {String} cls
       * @category Rendering
       */
      'cls',
      /**
       * Get/set header icon class
       * @member {String} icon
       */

      /**
       * Icon to display in header. Specifying an icon will render a `<i>` element with the icon as value for the
       * class attribute
       * @config {String} icon
       * @category Rendering
       */
      'icon', //endregion
      //region Layout

      /**
       * Text align (left, center, right)
       * @config {String} align
       * @category Layout
       */
      'align',
      /**
       * Column minimal width. If value is Number then minimal width is in pixels
       * @config {Number|String} minWidth
       * @default 60
       * @category Layout
       */
      {
        name: 'minWidth',
        defaultValue: 60
      },
      /**
       * Get/set columns hidden state. Specify `true` to hide the column, `false` to show it.
       * @member {Boolean} hidden
       */

      /**
       * Hide the column from start
       * @config {Boolean} hidden
       * @category Layout
       */
      {
        name: 'hidden',
        defaultValue: false
      },
      /**
       * Convenient way of putting a column in the "locked" region. Same effect as specifying region: 'locked'.
       * If you have defined your own regions (using {@link Grid.view.Grid#config-subGridConfigs}) you should use
       * {@link #config-region} instead of this one.
       * @config {Boolean} locked
       * @default false
       * @category Layout
       */
      {
        name: 'locked'
      },
      /**
       * Region (part of the grid, it can be configured with multiple) where to display the column. Defaults to
       * {@link Grid.view.Grid#config-defaultRegion}.
       * @config {String} region
       * @category Layout
       */
      {
        name: 'region'
      }, //endregion
      // region Menu

      /**
       * Show column picker for the column
       * @config {Boolean} showColumnPicker
       * @default true
       * @category Menu
       */
      {
        name: 'showColumnPicker',
        defaultValue: true
      },
      /**
       * false to prevent showing a context menu on the column header element
       * @config {Boolean} enableHeaderContextMenu
       * @default true
       * @category Menu
       */
      {
        name: 'enableHeaderContextMenu',
        defaultValue: true
      },
      /**
       * Set to `false` to prevent showing a context menu on the cell elements in this column
       * @config {Boolean} enableCellContextMenu
       * @default true
       * @category Menu
       */
      {
        name: 'enableCellContextMenu',
        defaultValue: true
      },
      /**
       * Extra items to show in the header context menu for this column.
       *
       * **Deprecated** to be an array:
       *
       * ```javascript
       * headerMenuItems : [
       *     { text : 'Custom item' }
       * ]
       * ```
       *
       * Now it has to be a named object:
       *
       * ```javascript
       * headerMenuItems : {
       *     customItem : { text : 'Custom item' }
       * }
       * ```
       *
       * @config {Object} headerMenuItems
       * @category Menu
       */
      'headerMenuItems',
      /**
       * Extra items to show in the cell context menu for this column
       *
       * **Deprecated** to be an array:
       *
       * ```javascript
       * cellMenuItems : [
       *     { text : 'Custom item' }
       * ]
       * ```
       *
       * Now it has to be a named object:
       *
       * ```javascript
       * cellMenuItems : {
       *     customItem : { text : 'Custom item' }
       * }
       * ```
       *
       * @config {Object} cellMenuItems
       * @category Menu
       */
      'cellMenuItems', //endregion
      //region Summary

      /**
       * Summary type (when using Summary feature). Valid types are:
       * <dl class="wide">
       * <dt>sum <dd>Sum of all values in the column
       * <dt>add <dd>Alias for sum
       * <dt>count <dd>Number of rows
       * <dt>countNotEmpty <dd>Number of rows containing a value
       * <dt>average <dd>Average of all values in the column
       * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
       * </dl>
       * @config {String} sum
       * @category Summary
       */
      'sum',
      /**
       * Summary configs, use if you need multiple summaries per column. Replaces {@link #config-sum} and
       * {@link #config-summaryRenderer} configs. Accepts an array of objects with the following fields:
       * * sum - Matching {@link #config-sum}
       * * renderer - Matching {@link #config-summaryRenderer}
       * * seed - Initial value when using a function as `sum`
       * @config {Object[]} summaries
       * @category Summary
       */
      'summaries',
      /**
       * Renderer function for summary (when using Summary feature). The renderer is called with the calculated
       * summary as only argument.
       * @config {Function} summaryRenderer
       * @category Summary
       */
      'summaryRenderer', //endregion
      //region Misc

      /**
       * Column settings at different responsive levels, see responsive demo under examples/
       * @config {Object} responsiveLevels
       * @category Misc
       */
      'responsiveLevels',
      /**
       * Tags, may be used by ColumnPicker feature for grouping columns by tag in the menu
       * @config {String[]} tags
       * @category Misc
       */
      'tags',
      /**
       * Column config to apply to normal config if viewed on a touch device
       * @config {Object} touchConfig
       * @category Misc
       */
      'touchConfig',
      /**
       * When using the tree feature, exactly one column should specify { tree: true }
       * @config {Boolean} tree
       * @category Misc
       */
      'tree',
      /**
       * Determines which type of filtering to use for the column. Usually determined by the column type used,
       * but may be overridden by setting this field.
       * @config {String} filterType
       * @category Misc
       */
      'filterType',
      /**
       * By default, any rendered column text content is HTML-encoded. Set this flag to `false` disable this and allow rendering html elements
       * @config {Boolean} htmlEncode
       * @default true
       * @category Misc
       */
      {
        name: 'htmlEncode',
        defaultValue: true
      },
      /**
       * Set to `true`to automatically call DomHelper.sync for html returned from a renderer. Should in most cases
       * be more performant than replacing entire innerHTML of cell and also allows CSS transitions to work. Has
       * no effect unless {@link #config-htmlEncode} is disabled. Returned html must contain a single root element (that can have
       * multiple children). See PercentColumn for example usage.
       * @config {Boolean} autoSyncHtml
       * @default false
       * @category Misc
       */
      {
        name: 'autoSyncHtml',
        defaultValue: false
      }, 'type',
      /**
       * Set to `true` to have the {@link Grid.feature.CellEdit CellEdit} feature update the record being
       * edited live upon field edit instead of when editing is finished by using `TAB` or `ENTER`
       * @config {Boolean} instantUpdate
       * @category Misc
       */
      {
        name: 'instantUpdate',
        defaultValue: false
      }, {
        name: 'repaintOnResize',
        defaultValue: false
      },
      /**
       * An optional query selector to select a sub element within the cell being
       * edited to align a cell editor's `X` position and `width` to.
       * @config {String} editTargetSelector
       * @category Misc
       */
      'editTargetSelector', //endregion
      //region Export

      /**
       * Used by the Export feature. Set to `false` to omit a column from an exported dataset
       * @config {Boolean} exportable
       * @default true
       * @category Export
       */
      {
        name: 'exportable',
        defaultValue: true
      },
      /**
       * Column type which will be used by {@link Grid.util.TableExporter}. See list of available types in TableExporter
       * doc. Returns undefined by default, which means column type should be read from the record field.
       * @config {String} exportedType
       * @category Export
       */
      {
        name: 'exportedType'
      } //endregion
      ];
    } // prevent undefined fields from being exposed, to simplify spotting errors

  }, {
    key: "autoExposeFields",
    get: function get() {
      return false;
    }
  }, {
    key: "type",
    get: function get() {
      return 'column';
    }
  }, {
    key: "text",
    get: function get() {
      return this.$meta.fields.defaults.text;
    }
  }]);

  return Column;
}(Object(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_26__["default"])(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_24__["default"])(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_23__["default"]))); // Registered in ColumnStore as we can't have this in Column due to circular dependencies
// ColumnStore.registerColumnType(Column);



Column.emptyCount = 0;
Column.defaultWidth = 100;
Column.exposeProperties();
Column._$name = 'Column';

/***/ }),

/***/ "./lib/Grid/column/DateColumn.js":
/*!***************************************!*\
  !*** ./lib/Grid/column/DateColumn.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateColumn; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/column/DateColumn
 */

/**
 * A column that displays a date in the specified format (see {@link Core.helper.DateHelper#function-format-static} for
 * formatting options).
 *
 * Default editor is a {@link Core.widget.DateField DateField}.
 *
 * If no `format` is specified, {@link Core.helper.DateHelper#property-defaultFormat-static DateHelper.defaultFormat} is
 * used. Please note that by default the `L` format is used.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *          { type: 'date', text: 'Start date', format: 'YYYY-MM-DD', data: 'start' }
 *     ]
 * });
 *
 * @classType date
 * @externalexample column/DateColumn.js
 */

var DateColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DateColumn, _Column);

  var _super = _createSuper(DateColumn);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DateColumn, null, [{
    key: "$name",
    get: function get() {
      return 'DateColumn';
    } //region Config

  }, {
    key: "type",
    get: function get() {
      return 'date';
    } // Type to use when auto adding field

  }, {
    key: "fieldType",
    get: function get() {
      return 'date';
    }
  }, {
    key: "fields",
    get: function get() {
      return ['format', 'pickerFormat', 'step'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        /**
         * Date format
         * @config {String}
         * @category Common
         */
        format: 'L',

        /**
         * Time increment duration value to apply when clicking the left / right trigger icons. See {@link Core.widget.DateField#config-step} for more information
         * Set to `null` to hide the step triggers.
         * @config {String|Number|Object}
         * @category Common
         */
        step: 1,
        minWidth: 85,
        filterType: 'date'
      };
    } //endregion
    //region Init

  }]);

  function DateColumn(config, store) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DateColumn);

    _this = _super.apply(this, arguments);
    _this.internalCellCls = 'b-date-cell';
    return _this;
  } //endregion
  //region Display

  /**
   * Renderer that displays the date with the specified format. Also adds cls 'date-cell' to the cell.
   * @private
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DateColumn, [{
    key: "defaultRenderer",
    value: function defaultRenderer(_ref) {
      var value = _ref.value;
      return value ? this.formatValue(value) : '';
    }
    /**
     * Group renderer that displays the date with the specified format.
     * @private
     */

  }, {
    key: "groupRenderer",
    value: function groupRenderer(_ref2) {
      var cellElement = _ref2.cellElement,
          groupRowFor = _ref2.groupRowFor;
      cellElement.innerHTML = this.formatValue(groupRowFor);
    } //endregion
    //region Formatter

    /**
     * Used by both renderer and groupRenderer to do the actual formatting of the date
     * @private
     * @param value
     * @returns {String}
     */

  }, {
    key: "formatValue",
    value: function formatValue(value) {
      // Ideally we should be served a date, but if not make it easier for the user by parsing
      if (typeof value === 'string') {
        value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].parse(value, this.format || undefined); // null does not use default format
      }

      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(value, this.format || undefined);
    } //endregion
    //region Getters/setters

    /**
     * Get/Set format for date displayed in cell and editor (see {@link Core.helper.DateHelper#function-format-static} for formatting options)
     * @property {String}
     */

  }, {
    key: "format",
    set: function set(value) {
      var me = this,
          editor = me.editor;
      me.set('format', value);

      if (editor) {
        editor.format = me.format;
      }
    },
    get: function get() {
      return this.get('format');
    }
  }, {
    key: "defaultEditor",
    get: function get() {
      var me = this;
      return {
        name: me.field,
        type: 'date',
        calendarContainerCls: 'b-grid-cell-editor-related',
        weekStartDay: me.grid.weekStartDay,
        format: me.format,
        step: me.step
      };
    } //endregion

  }]);

  return DateColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerColumnType(DateColumn, true);
DateColumn.exposeProperties();
DateColumn._$name = 'DateColumn';

/***/ }),

/***/ "./lib/Grid/column/NumberColumn.js":
/*!*****************************************!*\
  !*** ./lib/Grid/column/NumberColumn.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberColumn; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/util/NumberFormat.js */ "./lib/Core/helper/util/NumberFormat.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Grid/column/NumberColumn
 */

/**
 * A column for showing/editing numbers.
 *
 * Default editor is a {@link Core.widget.NumberField NumberField}.
 *
 * @extends Grid/column/Column
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'number', min: 0, max : 100, field: 'score' }
 *     ]
 * });
 *
 * @classType number
 * @externalexample column/NumberColumn.js
 */

var NumberColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(NumberColumn, _Column);

  var _super = _createSuper(NumberColumn);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(NumberColumn, null, [{
    key: "type",
    //region Config
    get: function get() {
      return 'number';
    } // Type to use when auto adding field

  }, {
    key: "fieldType",
    get: function get() {
      return 'number';
    }
  }, {
    key: "fields",
    get: function get() {
      return ['format',
      /**
       * The minimum value for the field used during editing.
       * @config {Number} min
       * @category Common
       */
      'min',
      /**
       * The maximum value for the field used during editing.
       * @config {Number} max
       * @category Common
       */
      'max',
      /**
       * Step size for the field used during editing.
       * @config {Number} step
       * @category Common
       */
      'step',
      /**
       * Large step size for the field used during editing. In effect for `SHIFT + click/arrows`
       * @config {Number} largeStep
       * @category Common
       */
      'largeStep',
      /**
       * Unit to append to displayed value.
       * @config {String} unit
       * @category Common
       */
      'unit'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        filterType: 'number',

        /**
         * The format to use for rendering numbers.
         *
         * By default, the locale's default number formatter is used. For `en-US`, the
         * locale default is a maximum of 3 decimal digits, using thousands-based grouping.
         * This would render the number `1234567.98765` as `'1,234,567.988'`.
         *
         * @config {String|Object|Core.helper.util.NumberFormat}
         */
        format: ''
      };
    }
  }]);

  function NumberColumn(config, store) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, NumberColumn);

    _this = _super.apply(this, arguments);
    _this.internalCellCls = 'b-number-cell';
    return _this;
  } //endregion
  //region Init


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(NumberColumn, [{
    key: "defaultRenderer",

    /**
     * Renderer that displays value + optional unit in the cell
     * @private
     */
    value: function defaultRenderer(_ref) {
      var value = _ref.value;

      if (value != null) {
        value = this.formatter.format(value);

        if (this.unit) {
          value = "".concat(value).concat(this.unit);
        }
      }

      return value;
    }
  }, {
    key: "defaultEditor",
    get: function get() {
      var format = this.format,
          name = this.name,
          max = this.max,
          min = this.min,
          step = this.step,
          largeStep = this.largeStep,
          align = this.align; // Remove any undefined configs, to allow config system to use default values instead

      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].cleanupProperties({
        type: 'numberfield',
        format: format,
        name: name,
        max: max,
        min: min,
        step: step,
        largeStep: largeStep,
        textAlign: align
      });
    }
  }, {
    key: "formatter",
    get: function get() {
      var me = this,
          format = me.format;
      var formatter = me._formatter;

      if (!formatter || me._lastFormat !== format) {
        me._formatter = formatter = _Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_12__["default"].get(me._lastFormat = format);
      }

      return formatter;
    }
  }]);

  return NumberColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerColumnType(NumberColumn, true);
NumberColumn.exposeProperties();
NumberColumn._$name = 'NumberColumn';

/***/ }),

/***/ "./lib/Grid/column/PercentColumn.js":
/*!******************************************!*\
  !*** ./lib/Grid/column/PercentColumn.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PercentColumn; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Grid/column/PercentColumn
 */

/**
 * A column that display a basic progress bar.
 *
 * Default editor is a {@link Core.widget.NumberField NumberField}.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'percent', text: 'Progress', data: 'progress' }
 *     ]
 * });
 *
 * @classType percent
 * @externalexample column/PercentColumn.js
 */

var PercentColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(PercentColumn, _Column);

  var _super = _createSuper(PercentColumn);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(PercentColumn, null, [{
    key: "type",
    get: function get() {
      return 'percent';
    } // Type to use when auto adding field

  }, {
    key: "fieldType",
    get: function get() {
      return 'number';
    }
  }, {
    key: "fields",
    get: function get() {
      return ['lowThreshold'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        /**
         * PercentColumn uses a {@link Core.widget.NumberField} configured with an allowed interval 0 - 100 as
         * its default editor.
         * @config {Object|String}
         * @default Core.widget.NumberField
         * @category Misc
         */
        editor: {
          type: 'number',
          min: 0,
          max: 100
        },

        /**
         * Set to false to not render the number value
         * @config {Boolean}
         * @category Rendering
         */
        showValue: true,

        /**
         * When below this percentage the bar will have `b-low` CSS class added. By default it turns the bar red.
         * @config {Number}
         * @category Rendering
         */
        lowThreshold: 20,
        filterType: 'number',
        htmlEncode: false,
        searchable: false,
        summaryRenderer: function summaryRenderer(sum) {
          return "".concat(sum, "%");
        }
      };
    }
  }]);

  function PercentColumn(config, store) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, PercentColumn);

    _this = _super.apply(this, arguments);
    _this.internalCellCls = 'b-percent-bar-cell';
    return _this;
  }
  /**
   * Renderer that displays a progress bar in the cell.
   * @private
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(PercentColumn, [{
    key: "defaultRenderer",
    value: function defaultRenderer(_ref) {
      var value = _ref.value;
      value = value || 0;
      return {
        className: 'b-percent-bar-outer',
        children: [{
          tag: 'div',
          className: {
            'b-percent-bar': 1,
            'b-zero': value === 0,
            'b-low': value < this.lowThreshold
          },
          style: {
            width: value + '%'
          },
          text: this.showValue ? value + '%' : undefined
        }]
      };
    } // Null implementation because the column width drives the width of its content.
    // So the concept of sizing to content is invalid here.

  }, {
    key: "resizeToFitContent",
    value: function resizeToFitContent() {}
  }]);

  return PercentColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


PercentColumn.sum = 'average';
_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerColumnType(PercentColumn, true);
PercentColumn._$name = 'PercentColumn';

/***/ }),

/***/ "./lib/Grid/column/RatingColumn.js":
/*!*****************************************!*\
  !*** ./lib/Grid/column/RatingColumn.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RatingColumn; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _NumberColumn_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./NumberColumn.js */ "./lib/Grid/column/NumberColumn.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/column/RatingColumn
 */

/**
 * A column that displays a star rating. Click a start to set a value, shift+click to unset a single start from the end.
 * Clicking the first and only star toggles it.
 *
 * This column uses a custom widget as its editor, and it is not intended to be changed.
 *
 * @extends Grid/column/NumberColumn
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'rating', max : 10, field: 'rating' }
 *     ]
 * });
 *
 * @classType percent
 * @externalexample column/RatingColumn.js
 */

var RatingColumn = /*#__PURE__*/function (_NumberColumn) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(RatingColumn, _NumberColumn);

  var _super = _createSuper(RatingColumn);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(RatingColumn, null, [{
    key: "type",
    get: function get() {
      return 'rating';
    } // Type to use when auto adding field

  }, {
    key: "fieldType",
    get: function get() {
      return 'number';
    }
  }, {
    key: "fields",
    get: function get() {
      return ['emptyIcon', 'filledIcon', 'editable'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        min: 0,
        max: 5,

        /**
         * The empty rating icon to show
         * @config {String}
         * @category Rendering
         */
        emptyIcon: 'b-icon b-icon-star',

        /**
         * The filled rating icon to show
         * @config {String}
         * @category Rendering
         */
        filledIcon: 'b-icon b-icon-star',

        /**
         * Allow user to click an icon to change the value
         * @config {Boolean}
         * @category Interaction
         */
        editable: true,
        filterType: 'number',
        searchable: false,
        width: '11.2em',
        htmlEncode: false,
        minWidth: '11.2em',
        editor: false
      };
    }
  }]);

  function RatingColumn(config, store) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, RatingColumn);

    _this = _super.apply(this, arguments);
    _this.internalCellCls = 'b-rating-cell';
    return _this;
  }
  /**
   * Renderer that displays a number of stars in the cell. Also adds CSS class 'b-rating-cell' to the cell.
   * @private
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(RatingColumn, [{
    key: "renderer",
    value: function renderer(_ref) {
      var _this2 = this;

      var value = _ref.value;
      return {
        className: {
          'b-rating-cell-inner': 1,
          'b-not-editable': !this.editable
        },
        children: _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].populate(this.max, function (i) {
          var filled = i < value;
          return {
            tag: 'i',
            className: _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()({
              'b-rating-icon': true,
              'b-filled': filled,
              'b-empty': !filled
            }, filled ? _this2.filledIcon : _this2.emptyIcon, true)
          };
        })
      };
    }
  }, {
    key: "onCellClick",
    value: function onCellClick(_ref2) {
      var grid = _ref2.grid,
          column = _ref2.column,
          record = _ref2.record,
          target = _ref2.target,
          event = _ref2.event;

      if (target.classList.contains('b-rating-icon') && !grid.readOnly && column.editable) {
        var starIndex = [].indexOf.call(target.parentNode.childNodes, target);

        if (target.classList.contains('b-filled') && (event.metaKey || event.shiftKey)) {
          starIndex = starIndex - 1;
        } // Clicking first star when it is only one removes it


        if (record.get(column.field) === 1 && starIndex === 0) {
          starIndex = -1;
        }

        record.set(column.field, starIndex + 1);
      }
    }
  }]);

  return RatingColumn;
}(_NumberColumn_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerColumnType(RatingColumn, true);
RatingColumn.exposeProperties();
RatingColumn._$name = 'RatingColumn';

/***/ }),

/***/ "./lib/Grid/column/RowNumberColumn.js":
/*!********************************************!*\
  !*** ./lib/Grid/column/RowNumberColumn.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RowNumberColumn; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/column/RowNumberColumn
 */

/**
 * A column that displays the row number in each cell.
 *
 * There is no `editor`, since value is read-only.
 *
 * ```javascript
 * const grid = new Grid({
 *   appendTo : targetElement,
 *   width    : 300,
 *   columns  : [
 *     { type : 'rownumber' }
 *   ]
 * });
 *
 * @extends Grid/column/Column
 *
 * @classType rownumber
 * @externalexample column/RowNumberColumn.js
 */

var RowNumberColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(RowNumberColumn, _Column);

  var _super = _createSuper(RowNumberColumn);

  function RowNumberColumn() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, RowNumberColumn);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(RowNumberColumn, [{
    key: "construct",
    value: function construct(config, store) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(RowNumberColumn.prototype), "construct", this).apply(this, arguments);

      var grid = me.grid; // Update our width when the store mutates (tests test Columns in isolation with no grid, so we must handle that!)

      if (grid) {
        var _grid$store$on;

        grid.store.on((_grid$store$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_grid$store$on, "change".concat(grid.asyncEventSuffix), 'onStoreChange'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_grid$store$on, "thisObj", me), _grid$store$on));

        if (grid.store.count) {
          grid.on({
            render: 'resizeToFitContent',
            thisObj: me,
            once: true
          });
        }
      }

      me.internalCellCls = 'b-row-number-cell';
    }
  }, {
    key: "onStoreChange",
    value: function onStoreChange(_ref) {
      var action = _ref.action;

      if (action === 'dataset' || action === 'add' || action === 'remove' || action === 'removeall') {
        this.resizeToFitContent();
      }
    }
    /**
     * Renderer that displays the row number in the cell.
     * @private
     */

  }, {
    key: "renderer",
    value: function renderer(_ref2) {
      var record = _ref2.record,
          grid = _ref2.grid;
      return record.isSpecialRow ? '' : grid.store.indexOf(record, true) + 1;
    }
    /**
     * Resizes the column to match the widest string in it. Called when you double click the edge between column
     * headers
     */

  }, {
    key: "resizeToFitContent",
    value: function resizeToFitContent() {
      var grid = this.grid,
          store = grid.store,
          count = store.count;

      if (count && !this.hidden) {
        var cellElement = grid.element.querySelector(".b-grid-cell[data-column-id=\"".concat(this.id, "\"]")); // cellElement might not exist, e.g. when trial is expired

        if (cellElement) {
          var cellPadding = parseInt(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStyleValue(cellElement, 'padding-left')),
              maxWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].measureText(count, cellElement);
          this.width = maxWidth + 2 * cellPadding;
        }
      }
    }
  }, {
    key: "flex",
    set: function set(f) {}
  }], [{
    key: "defaults",
    get: function get() {
      return {
        /**
         * @config {Boolean} groupable
         * @hide
         */
        groupable: false,

        /**
         * @config {Boolean} sortable
         * @hide
         */
        sortable: false,

        /**
         * @config {Boolean} filterable
         * @hide
         */
        filterable: false,

        /**
         * @config {Boolean} searchable
         * @hide
         */
        searchable: false,

        /**
         * @config {Boolean} resizable
         * @hide
         */
        resizable: false,
        minWidth: 50,
        width: 50,
        align: 'right',
        text: '#',
        editor: false
      };
    }
  }, {
    key: "type",
    get: function get() {
      return 'rownumber';
    }
  }]);

  return RowNumberColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerColumnType(RowNumberColumn, true);
RowNumberColumn._$name = 'RowNumberColumn';

/***/ }),

/***/ "./lib/Grid/column/TemplateColumn.js":
/*!*******************************************!*\
  !*** ./lib/Grid/column/TemplateColumn.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TemplateColumn; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Grid/column/TemplateColumn
 */

/**
 * A column that uses a template for cell content. Any function can be used as template, and the function is passed { value, record, field } properties.
 * It should return a string which will be rendered in the cell.
 *
 * Default editor is a {@link Core.widget.TextField TextField}.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'template', field: 'age', template: value => `${value} years old` }
 *     ]
 * });
 *
 * @classType template
 * @externalexample column/TemplateColumn.js
 */

var TemplateColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(TemplateColumn, _Column);

  var _super = _createSuper(TemplateColumn);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(TemplateColumn, null, [{
    key: "fields",
    get: function get() {
      return [
      /**
       * Template function used to generate a value displayed in the cell. Called with arguments { value, record, field }
       * @config {Function} template
       * @category Common
       */
      'template'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        htmlEncode: false
      };
    }
  }]);

  function TemplateColumn(config, store) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TemplateColumn);

    _this = _super.apply(this, arguments);

    var me = _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this);

    if (!me.template) {
      throw new Error('TemplateColumn needs a template');
    }

    if (typeof me.template !== 'function') {
      throw new Error('TemplateColumn.template must be a function');
    }

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(TemplateColumn, [{
    key: "renderer",

    /**
     * Renderer that uses a template for cell content.
     * @private
     */
    value: function renderer(renderData) {
      // If it's a special row, such as a group row, we can't use the user's template
      if (!renderData.record.isSpecialRow) {
        return this.template({
          value: renderData.value,
          record: renderData.record,
          field: renderData.column.field
        });
      }
    }
  }], [{
    key: "type",
    get: function get() {
      return 'template';
    }
  }]);

  return TemplateColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerColumnType(TemplateColumn, true);
TemplateColumn.exposeProperties();
TemplateColumn._$name = 'TemplateColumn';

/***/ }),

/***/ "./lib/Grid/column/TimeColumn.js":
/*!***************************************!*\
  !*** ./lib/Grid/column/TimeColumn.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeColumn; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/column/TimeColumn
 */

/**
 * A column that displays a time in the specified format (see {@link Core.helper.DateHelper#function-format-static} for formatting options).
 *
 * Default editor is a {@link Core.widget.TimeField TimeField}.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *          { type: 'time', text: 'Start time', format: 'HH:mm:ss', data: 'start' }
 *     ]
 * });
 *
 * @classType time
 * @externalexample column/TimeColumn.js
 */

var TimeColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(TimeColumn, _Column);

  var _super = _createSuper(TimeColumn);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TimeColumn, null, [{
    key: "type",
    //region Config
    get: function get() {
      return 'time';
    } // Type to use when auto adding field

  }, {
    key: "fieldType",
    get: function get() {
      return 'date';
    }
  }, {
    key: "fields",
    get: function get() {
      return ['format'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        /**
         * Time format
         * @config {String}
         * @category Common
         */
        format: 'LT',
        minWidth: 140,
        filterType: 'time'
      };
    } //endregion
    //region Init

  }]);

  function TimeColumn(config, store) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TimeColumn);

    _this = _super.apply(this, arguments);
    _this.internalCellCls = 'b-time-cell';
    return _this;
  } //endregion
  //region Display

  /**
   * Renderer that displays the time with the specified format. Also adds cls 'b-time-cell' to the cell.
   * @private
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TimeColumn, [{
    key: "defaultRenderer",
    value: function defaultRenderer(_ref) {
      var value = _ref.value;
      return value ? this.formatValue(value) : '';
    }
    /**
     * Group renderer that displays the time with the specified format.
     * @private
     */

  }, {
    key: "groupRenderer",
    value: function groupRenderer(_ref2) {
      var cellElement = _ref2.cellElement,
          groupRowFor = _ref2.groupRowFor;
      cellElement.innerHTML = this.formatValue(groupRowFor);
    } //endregion
    //region Formatter

    /**
     * Used by both renderer and groupRenderer to do the actual formatting of the time
     * @private
     * @param value
     * @returns {String}
     */

  }, {
    key: "formatValue",
    value: function formatValue(value) {
      var me = this; // Ideally we should be served a time, but if not make it easier for the user by parsing

      if (typeof value === 'string') {
        value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].parse(value, me.format);
      }

      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(value, me.format);
    } //endregion
    //region Getters/Setters

    /**
     * Get/Set format for time displayed in cell and editor (see {@link Core.helper.DateHelper#function-format-static} for formatting options)
     * @property {String}
     */

  }, {
    key: "format",
    set: function set(value) {
      var me = this,
          editor = me.editor;
      me.set('format', value);

      if (editor) {
        editor.format = me.format;
      }
    },
    get: function get() {
      return this.get('format');
    }
  }, {
    key: "defaultEditor",
    get: function get() {
      return {
        name: this.field,
        type: 'time',
        format: this.format
      };
    } //endregion

  }]);

  return TimeColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerColumnType(TimeColumn, true);
TimeColumn.exposeProperties();
TimeColumn._$name = 'TimeColumn';

/***/ }),

/***/ "./lib/Grid/column/TreeColumn.js":
/*!***************************************!*\
  !*** ./lib/Grid/column/TreeColumn.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TreeColumn; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Grid/column/TreeColumn
 */

var currentParentHasIcon = false;
/**
 * A column that displays a tree structure when using the {@link Grid.feature.Tree tree} feature.
 *
 * Default editor is a {@link Core.widget.TextField TextField}.
 *
 * TreeColumn provides configs to define icons for {@link #config-expandIconCls expanded} / {@link #config-collapseIconCls collapsed} nodes,
 * {@link #config-expandedFolderIconCls expanded folder} / {@link #config-collapsedFolderIconCls collapsed folder} nodes and
 * {@link #config-leafIconCls leaf} nodes.
 *
 * When the TreeColumn renders its cells, it will look for two special fields {@link Grid.data.GridRowModel#field-href}
 * and {@link Grid.data.GridRowModel#field-target}. Specifying `href` will produce a link for the TreeNode,
 * and `target` will have the same meaning as in an A tag:
 *
 * ```javascript
 * {
 *    id        : 1,
 *    name      : 'Some external link'
 *    href      : '//www.website.com",
 *    target    : '_blank"
 * }
 * ```
 *
 * @example
 * new TreeGrid({
 *     appendTo : document.body,
 *
 *     columns : [
 *          { type: 'tree', field: 'name' }
 *     ]
 * });
 *
 * @classType tree
 * @extends Grid/column/Column
 * @externalexample column/TreeColumn.js
 */

var TreeColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TreeColumn, _Column);

  var _super = _createSuper(TreeColumn);

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(TreeColumn, null, [{
    key: "defaults",
    get: function get() {
      return {
        tree: true,
        hideable: false,
        minWidth: 150
      };
    }
  }, {
    key: "fields",
    get: function get() {
      return [
      /**
       * The icon to use for the collapse icon in collapsed state
       * @config {String} expandIconCls
       */
      {
        name: 'expandIconCls',
        defaultValue: 'b-icon b-icon-tree-expand'
      },
      /**
       * The icon to use for the collapse icon in expanded state
       * @config {String} collapseIconCls
       */
      {
        name: 'collapseIconCls',
        defaultValue: 'b-icon b-icon-tree-collapse'
      },
      /**
       * The icon to use for the collapse icon in expanded state
       * @config {String} collapsedFolderIconCls
       */
      {
        name: 'collapsedFolderIconCls'
      },
      /**
       * The icon to use for the collapse icon in expanded state
       * @config {String} expandedFolderIconCls
       */
      {
        name: 'expandedFolderIconCls'
      },
      /**
       * Size of the child indent in em. Resulting indent is indentSize multiplied by child level.
       * @config {Number} indentSize
       * @default 1.7
       */
      {
        name: 'indentSize',
        defaultValue: 1.7
      },
      /**
       * The icon to use for the leaf nodes in the tree
       * @config {String} leafIconCls
       */
      {
        name: 'leafIconCls',
        defaultValue: 'b-icon b-icon-tree-leaf'
      }, {
        name: 'editTargetSelector',
        defaultValue: '.b-tree-cell-value'
      }];
    }
  }, {
    key: "type",
    get: function get() {
      return 'tree';
    }
  }]);

  function TreeColumn(config, store) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, TreeColumn);

    _this = _super.apply(this, arguments);

    var me = _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this);

    me.internalCellCls = 'b-tree-cell'; // We handle htmlEncoding in this class rather than relying on the generic Row DOM manipulation
    // since this class requires quite a lot of DOM infrastructure around the actual rendered content

    me.shouldHtmlEncode = me.htmlEncode;
    me.tempDiv = document.createElement('div');
    me.setData('htmlEncode', false); // add tree renderer (which calls original renderer internally)

    if (me.renderer) {
      me.originalRenderer = me.renderer;
    }

    me.renderer = me.treeRenderer.bind(me);
    return _this;
  }
  /**
   * A column renderer that is automatically added to the column with { tree: true }. It adds padding and node icons
   * to the cell to make the grid appear to be a tree. The original renderer is called in the process.
   * @private
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(TreeColumn, [{
    key: "treeRenderer",
    value: function treeRenderer(renderData) {
      var me = this,
          cellElement = renderData.cellElement,
          row = renderData.row,
          record = renderData.record,
          isExport = renderData.isExport,
          gridMeta = record.instanceMeta(renderData.grid.store),
          tag = record.href ? 'a' : 'div';
      var value = renderData.value,
          result;

      if (me.originalRenderer) {
        var rendererHtml = me.originalRenderer(renderData);
        value = rendererHtml === false ? cellElement.innerHTML : rendererHtml;
      }

      if (!isExport) {
        var html = '',
            iconCls;

        if (!record.isLeaf) {
          var isCollapsed = gridMeta.collapsed,
              expanderIconCls = isCollapsed ? me.expandIconCls : me.collapseIconCls,
              folderIconCls = isCollapsed ? me.collapsedFolderIconCls : me.expandedFolderIconCls; // Row can be just a dummy object for example when the renderer is called from Column#resizeToFitContent

          if (row.$$name === 'Row') {
            var loadingCls = 'b-loading-children',
                collapsedCls = 'b-tree-collapsed',
                expandedCls = 'b-tree-expanded',
                rowClsToAdd = ['b-tree-parent-row'],
                rowClsToRemove = []; // Spinner while loading children, added to row in Tree#toggleCollapse but needs to be readded if row is rerendered during load

            if (gridMeta.isLoadingChildren) {
              rowClsToAdd.push(loadingCls);
            } else {
              rowClsToRemove.push(loadingCls);
            }

            if (isCollapsed) {
              rowClsToAdd.push(collapsedCls);
              rowClsToRemove.push(expandedCls);
            } else {
              rowClsToAdd.push(expandedCls);
              rowClsToRemove.push(collapsedCls);
            }

            row.removeCls.apply(row, rowClsToRemove);
            row.addCls.apply(row, rowClsToAdd);
          }

          cellElement.classList.add('b-tree-parent-cell');
          html += "<div class=\"b-tree-expander\">".concat(expanderIconCls ? "<i class=\"".concat(expanderIconCls, "\"></i>") : '', "</div>"); // Allow user to customize tree icon or opt out entirely

          currentParentHasIcon = iconCls = renderData.iconCls || record.iconCls || folderIconCls;
        } else {
          // TODO: Cleanup for reusing dom nodes should be done elsewhere, also cleanup selection
          cellElement.classList.add('b-tree-leaf-cell'); // Allow user to customize tree icon or opt out entirely

          iconCls = renderData.iconCls || record.iconCls || me.leafIconCls;
        }

        value = value != null ? value : '';

        if (me.shouldHtmlEncode) {
          me.tempDiv.innerText = value;
          value = me.tempDiv.innerHTML;
        }

        html += "<div class=\"b-tree-cell-value\">".concat(iconCls ? "<i class=\"b-tree-icon ".concat(iconCls, "\"></i>") : '').concat(value, "</div>");
        var padding = record.childLevel * me.indentSize + (record.isLeaf ? currentParentHasIcon ? 2.0 : iconCls ? 0.5 : 0.4 : 0); // requires to be a one-liner for SinglePage_features.t.js test

        result = "<".concat(tag, " ").concat(record.href ? "href=\"".concat(record.href, "\"") : '', " ").concat(tag === 'a' && record.target ? "target=\"".concat(record.target, "\"") : '', " class=\"b-tree-cell-inner\" style=\"padding-left:").concat(padding, "em;\">").concat(html, "</").concat(tag, ">");
      } else {
        result = value != null ? value : '';
      }

      return result;
    }
  }]);

  return TreeColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerColumnType(TreeColumn, true);
TreeColumn.exposeProperties();
TreeColumn._$name = 'TreeColumn';

/***/ }),

/***/ "./lib/Grid/column/WidgetColumn.js":
/*!*****************************************!*\
  !*** ./lib/Grid/column/WidgetColumn.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetColumn; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Column_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Currently widgets reuse elements already in cell, but performance would improve if entire widget was reused
//TODO: Leaking widget on rerender of row, since the old one is not destroyed




/**
 * @module Grid/column/WidgetColumn
 */

/**
 * A column that displays widgets in the cells.
 *
 * There is no `editor` provided. It is the configured widget's responsibility to provide editing if needed.
 *
 * @extends Grid/column/Column
 *
 * @example
 * new Grid({
 *     appendTo : document.body,
 *
 *     columns : [
 *         { type: 'widget', text: 'Increase age', widgets: [{ type: 'button', icon: 'add' }], data: 'age' }
 *     ]
 * });
 *
 * @classType widget
 * @externalexample column/WidgetColumn.js
 */

var WidgetColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(WidgetColumn, _Column);

  var _super = _createSuper(WidgetColumn);

  function WidgetColumn() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, WidgetColumn);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(WidgetColumn, [{
    key: "construct",
    //endregion
    //region Init / Destroy
    value: function construct(config, store) {
      this.widgetMap = {};
      this.internalCellCls = 'b-widget-cell';

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(WidgetColumn.prototype), "construct", this).apply(this, arguments);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      // Destroy all the widgets we created.
      for (var _i = 0, _Object$values = Object.values(this.widgetMap); _i < _Object$values.length; _i++) {
        var widget = _Object$values[_i];
        widget.destroy && widget.destroy();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(WidgetColumn.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Render

    /**
     * Renderer that displays a widget in the cell.
     * @param {Object} event Render event
     * @param {Grid.column.Column} event.column Rendered column
     * @param {Core.data.Model} event.record Rendered record
     * @private
     */

  }, {
    key: "renderer",
    value: function renderer(event) {
      var me = this,
          cellElement = event.cellElement,
          column = event.column,
          value = event.value,
          record = event.record,
          isExport = event.isExport,
          widgets = column.widgets; // This renderer might be called from subclasses by accident
      // This condition saves us from investigating bug reports

      if (!isExport && widgets) {
        // If there is no widgets yet and we're going to add them,
        // need to make sure there is no content left in the cell after its previous usage
        // by grid features such as grouping feature or so.
        if (!cellElement.widgets) {
          // Reset cell content
          me.clearCell(cellElement);
        }

        cellElement.widgets = widgets.map(function (widgetCfg, i) {
          var widget, widgetNextSibling; // If cell element already has widgets, check if we need to destroy/remove one

          if (cellElement.widgets) {
            // Current widget
            widget = cellElement.widgets[i]; // Store next element sibling to insert widget to correct position later

            widgetNextSibling = widget.element.nextElementSibling; // If we are not syncing content for present widget, remove it from cell and render again later

            if (widgetCfg.recreate && widget) {
              // destroy widget and remove reference to it
              delete me.widgetMap[widget.id];
              widget.destroy();
              cellElement.widgets[i] = null;
            }
          } // Ensure widget is created if first time through


          if (!widget) {
            me.onBeforeWidgetCreate(widgetCfg, event);
            widget = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].append(widgetCfg, widgetNextSibling ? {
              insertBefore: widgetNextSibling
            } : cellElement)[0];
            me.widgetMap[widget.id] = widget;
            me.onAfterWidgetCreate(widget, event);
          }

          widget.cellInfo = {
            cellElement: cellElement,
            value: value,
            record: record,
            column: column
          };

          if (me.grid) {
            widget.readOnly = me.grid.readOnly;
          }

          if (me.onBeforeWidgetSetValue(widget, event) !== false) {
            if (!widgetCfg.noValueOnRender) {
              if (widgetCfg.valueProperty) {
                widget[widgetCfg.valueProperty] = value;
              } else if (widget.defaultBindProperty) {
                widget[widget.defaultBindProperty] = value;
              } else {
                widget.text = widget.value = value;
              }
            }
          }

          me.onAfterWidgetSetValue(widget, event);
          return widget;
        });
      }

      if (isExport) {
        return null;
      }
    } //endregion
    //region Other

    /**
     * Called before widget is created on rendering
     * @param {Object} widgetCfg Widget config
     * @param {Object} event Render event
     * @private
     */

  }, {
    key: "onBeforeWidgetCreate",
    value: function onBeforeWidgetCreate(widgetCfg, event) {}
    /**
     * Called after widget is created on rendering
     * @param {Core.widget.Widget} widget Created widget
     * @param {Object} event Render event
     * @private
     */

  }, {
    key: "onAfterWidgetCreate",
    value: function onAfterWidgetCreate(widget, event) {}
    /**
     * Called before widget gets value on rendering. Pass `false` to skip value setting while rendering
     * @preventable
     * @param {Core.widget.Widget} widget Created widget
     * @param {Object} event Render event
     * @param {Grid.column.Column} event.column Rendered column
     * @param {Core.data.Model} event.record Rendered record
     */

  }, {
    key: "onBeforeWidgetSetValue",
    value: function onBeforeWidgetSetValue(widget, event) {}
    /**
     * Called after widget gets value on rendering.
     * @param {Core.widget.Widget} widget Created widget
     * @param {Object} event Render event
     * @param {Grid.column.Column} event.column Rendered column
     * @param {Core.data.Model} event.record Rendered record
     */

  }, {
    key: "onAfterWidgetSetValue",
    value: function onAfterWidgetSetValue(widget, event) {} // Overrides base implementation to cleanup widgets, for example when a cell is reused as part of group header

  }, {
    key: "clearCell",
    value: function clearCell(cellElement) {
      var _this = this;

      if (cellElement.widgets) {
        cellElement.widgets.forEach(function (widget) {
          // Destroy widget and remove reference to it
          delete _this.widgetMap[widget.id];
          widget.destroy();
        });
        cellElement.widgets = null;
      } // Even if there is no widgets need to make sure there is no content left, for example after a cell has been reused as part of group header


      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(WidgetColumn.prototype), "clearCell", this).call(this, cellElement);
    } // Null implementation because there is no way of ascertaining whether the widgets get their width from
    // the column, or the column shrinkwraps the Widget.
    // Remember that the widget could have a width from a CSS rule which we cannot read.
    // It might have width: 100%, or a flex which would mean it is sized by us, but we cannot read that -
    // getComputedStyle would return the numeric width.

  }, {
    key: "resizeToFitContent",
    value: function resizeToFitContent() {} //endregion

  }], [{
    key: "type",
    //region Config
    get: function get() {
      return 'widget';
    }
  }, {
    key: "fields",
    get: function get() {
      return [
      /**
       * An array of widget config objects
       * @config {Object[]} widgets
       * @category Common
       */
      'widgets'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        filterable: false,
        sortable: false,
        editor: false,
        searchable: false
      };
    }
  }]);

  return WidgetColumn;
}(_Column_js__WEBPACK_IMPORTED_MODULE_14__["default"]);


_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_15__["default"].registerColumnType(WidgetColumn);
WidgetColumn.exposeProperties();
WidgetColumn._$name = 'WidgetColumn';

/***/ }),

/***/ "./lib/Grid/data/ColumnStore.js":
/*!**************************************!*\
  !*** ./lib/Grid/data/ColumnStore.js ***!
  \**************************************/
/*! exports provided: default, columnResizeEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columnResizeEvent", function() { return columnResizeEvent; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _column_Column_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/data/ColumnStore
 */

/**
 * A store specialized in handling columns. Used by the Grid to hold its columns and used as a chained store by each SubGrid
 * to hold theirs. Should not be instanced directly, instead access it through `grid.columns` or `subGrid.columns`
 *
 * ```
 * // resize first column
 * grid.columns.first.width = 200;
 *
 * // remove city column
 * grid.columns.get('city').remove();
 *
 * // add new column
 * grid.columns.add({text : 'New column'});
 *
 * // add new column to specific region (SubGrid)
 * grid.columns.add({text : 'New column', region : 'locked'});
 *
 * // add new column to 'locked' region (SubGrid)
 * grid.columns.add({text : 'New column', locked : true});
 * ```
 *
 * @extends Core/data/Store
 */

var ColumnStore = /*#__PURE__*/function (_Localizable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(ColumnStore, _Localizable);

  var _super = _createSuper(ColumnStore);

  function ColumnStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17___default()(this, ColumnStore);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default()(ColumnStore, [{
    key: "construct",
    value: function construct(config) {
      var me = this; // Consequences of ColumnStore construction can cause reading of grid.columns
      // so set the property early.

      if (config.grid) {
        config.grid._columnStore = me;
        me.id = "".concat(config.grid.id, "-columns"); // Visible columns must be invalidated on expand/collapse

        config.grid.on({
          subGridCollapse: 'clearSubGridCaches',
          subGridExpand: 'clearSubGridCaches',
          thisObj: me
        });
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(ColumnStore.prototype), "construct", this).call(this, config); // So that we can invalidate cached collections which take computing so that we compute them
      // only when necessary. For example when asking for the visible leaf columns, we do not want
      // to compute that each time.


      me.on({
        change: me.clearCaches,
        thisObj: me,
        prio: 1
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var allColumns = [];
      this.traverse(function (column) {
        return allColumns.push(column);
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(ColumnStore.prototype), "doDestroy", this).call(this); // Store's destroy unjoins all records. Destroy all columns *after* that.


      allColumns.forEach(function (column) {
        return column.destroy();
      });
    } // Overridden because the flat collection only contains top level columns,
    // not leaves - group columns are *not* expanded.

  }, {
    key: "getById",
    value: function getById(id) {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(ColumnStore.prototype), "getById", this).call(this, id) || this.idRegister[id];
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      // Override to omit root
      this.traverseWhile(function (n, i) {
        return fn.call(thisObj, n, i);
      }, true);
    }
  }, {
    key: "calculateFixedWidth",
    value: function calculateFixedWidth(column) {
      if (column.flex) {
        return column.measureSize(_column_Column_js__WEBPACK_IMPORTED_MODULE_24__["default"].defaultWidth);
      } else {
        return Math.max(column.measureSize(column.width), column.measureSize(column.minWidth));
      }
    }
    /**
     * Returns the top level columns. If using grouped columns, this is the top level columns. If no grouped
     * columns are being used, this is the leaf columns.
     * @property {Grid.column.Column[]}
     * @readonly
     */

  }, {
    key: "clearSubGridCaches",
    value: function clearSubGridCaches(subGrid) {
      subGrid.columns.clearCaches();
      this.clearCaches();
    }
  }, {
    key: "clearCaches",
    value: function clearCaches() {
      this._visibleColumns = null;
    }
  }, {
    key: "onMasterDataChanged",
    value: function onMasterDataChanged(event) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(ColumnStore.prototype), "onMasterDataChanged", this).call(this, event); // If master store has changes we also need to clear cached columns, in case a column was hidden


      this.clearCaches();
    }
  }, {
    key: "getAdjacentVisibleLeafColumn",
    value: function getAdjacentVisibleLeafColumn(columnOrId) {
      var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var columns = this.visibleColumns,
          column = columnOrId instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_24__["default"] ? columnOrId : this.getById(columnOrId);
      var idx = columns.indexOf(column) + (next ? 1 : -1); // If we walked off either end, wrap if directed to do so,
      // otherwise, return null;

      if (!columns[idx]) {
        if (wrap) {
          idx = next ? 0 : columns.length - 1;
        } else {
          return null;
        }
      }

      return columns[idx];
    }
    /**
     * Bottom columns are the ones displayed in the bottom row of a grouped header, or all columns if not using a grouped
     * header. They are the columns that actually display any data.
     * @returns {Grid.column.Column[]}
     * @readonly
     */

  }, {
    key: "get",

    /**
     * Get column by field. To be sure that you are getting exactly the intended column, use {@link Core.data.Store#function-getById Store#getById()} with the
     * columns id instead.
     * @param {String} field Field name
     * @returns {Grid.column.Column}
     */
    value: function get(field) {
      return this.findRecord('field', field, true);
    }
    /**
     * Used internally to create a new record in the store. Creates a column of the correct type by looking up the
     * specified type among registered columns.
     * @private
     */

  }, {
    key: "createRecord",
    value: function createRecord(data) {
      var _this$grid = this.grid,
          grid = _this$grid === void 0 ? {} : _this$grid,
          store = grid.store;
      var columnClass = this.modelClass;

      if (data.type) {
        columnClass = ColumnStore.getColumnClass(data.type);

        if (!columnClass) {
          throw new Error("Column type '".concat(data.type, "' not registered"));
        }
      }

      if (data.locked) {
        data.region = 'locked';
        delete data.locked;
      }

      var column = new columnClass(data, this); // Doing this after construction, in case the columnClass has a default value for region (Schedulers
      // TimeAxisColumn has)

      if (!column.data.region) {
        column.data.region = grid.defaultRegion || 'normal';
      } // Add missing fields to Grids stores model


      if (this.autoAddField && !column.noFieldSpecified && store && !store.modelClass.getFieldDefinition(column.field)) {
        var fieldDefinition = column.field; // Some columns define the type to use for new fields (date, number etc)

        if (column.constructor.fieldType) {
          fieldDefinition = {
            name: column.field,
            type: column.constructor.fieldType
          };
        }

        store.modelClass.addField(fieldDefinition);
      }

      return column;
    }
    /**
     * indexOf extended to also accept a columns field, for backward compatibility.
     * ```
     * grid.columns.indexOf('name');
     * ```
     * @param recordOrId
     * @returns {Number}
     */

  }, {
    key: "indexOf",
    value: function indexOf(recordOrId) {
      // TODO: build the need for field away
      var index = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(ColumnStore.prototype), "indexOf", this).call(this, recordOrId);

      if (index > -1) return index; // no record found by id, find by field since old code relies on that instead of id
      // TODO: replace such cases with columns id

      return this.records.findIndex(function (r) {
        return r.field === recordOrId;
      });
    } //region Column types

    /**
     * Call from custom column to register it with ColumnStore. Required to be able to specify type in column config.
     * @param {Class} columnClass The {@link Grid.column.Column} subclass to register.
     * @param {Boolean} simpleRenderer Pass `true` if its default renderer does *not* use other fields from the passed
     * record than its configured {@link Grid.column.Column#config-field}. This enables more granular cell updating
     * upon record mutation.
     * @example
     * // create and register custom column
     * class CustomColumn {
     *  static get type() {
     *      return 'custom';
     *  }
     * }
     * ColumnStore.registerColumnType(CustomColumn, true);
     * // now possible to specify in column config
     * let grid = new Grid({
     *   columns: [
     *     { type: 'custom', field: 'id' }
     *   ]
     * });
     */

  }, {
    key: "modelClass",
    get: function get() {
      return this._modelClass;
    },
    set: function set(ClassDef) {
      this._modelClass = ClassDef;
    }
  }, {
    key: "totalFixedWidth",
    get: function get() {
      var _this = this;

      var result = 0;

      var _iterator = _createForOfIteratorHelper(this),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var col = _step.value;

          if (!col.hidden) {
            // if column has children (grouped header) use they to width increment
            if (col.children) {
              col.children.forEach(function (childCol) {
                return result += _this.calculateFixedWidth(childCol);
              });
            } else {
              result += this.calculateFixedWidth(col);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
  }, {
    key: "topColumns",
    get: function get() {
      return this.isChained ? this.masterStore.rootNode.children.filter(this.chainedFilterFn) : this.rootNode.children;
    }
    /**
     * Returns the visible leaf headers which drive the rows' cell content.
     * @property {Grid.column.Column[]}
     * @readonly
     */

  }, {
    key: "visibleColumns",
    get: function get() {
      var me = this;

      if (!me._visibleColumns) {
        me._visibleColumns = me.leaves.filter(function (column) {
          return !column.hidden && (!column.subGrid || !column.subGrid.collapsed);
        });
      }

      return me._visibleColumns;
    }
  }, {
    key: "bottomColumns",
    get: function get() {
      return this.leaves;
    }
  }], [{
    key: "registerColumnType",
    value: function registerColumnType(columnClass) {
      var simpleRenderer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!ColumnStore.columnTypes) ColumnStore.columnTypes = {};
      columnClass.simpleRenderer = simpleRenderer;
      ColumnStore.columnTypes[columnClass.type] = columnClass;
    }
    /**
     * Returns registered column class for specified type.
     * @param type Type name
     * @returns {Grid.column.Column}
     * @internal
     */

  }, {
    key: "getColumnClass",
    value: function getColumnClass(type) {
      return ColumnStore.columnTypes && ColumnStore.columnTypes[type];
    } //endregion

  }, {
    key: "defaultConfig",
    //region events

    /**
     * Fires when a column is shown.
     * @event columnShow
     * @param {Grid.data.ColumnStore} source The store which triggered the event.
     * @param {Grid.column.Column} column The column which status has been changed.
     */

    /**
    * Fires when a column has been hidden.
    * @event columnHide
    * @param {Grid.data.ColumnStore} source The store which triggered the event.
    * @param {Grid.column.Column} column The column which status has been changed.
    */
    //endregion
    get: function get() {
      return {
        modelClass: _column_Column_js__WEBPACK_IMPORTED_MODULE_24__["default"],
        tree: true,

        /**
         * Automatically adds a field definition to the store used by the Grid when adding a new Column displaying a
         * non-existing field.
         *
         * To enable this behaviour:
         *
         * ```javascript
         * const grid = new Grid({
         *     columns : {
         *         autoAddField : true,
         *         data         : [
         *             // Column definitions here
         *         ]
         *     }
         * }
         *
         * @config {Boolean}
         * @default
         */
        autoAddField: false
      };
    }
  }]);

  return ColumnStore;
}(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_25__["default"])(_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_23__["default"]));
/**
 * Custom {@link Grid.data.ColumnStore} event which triggers when a column is resized, i.e. its width has been changed
 *
 * @param {Function} handler
 * @param {Object} [thisObj]
 */



var columnResizeEvent = function columnResizeEvent(handler, thisObj) {
  return {
    update: function update(_ref) {
      var store = _ref.store,
          record = _ref.record,
          changes = _ref.changes;
      var result = true;

      if ('width' in changes || 'minWidth' in changes || 'flex' in changes) {
        result = handler.call(thisObj, {
          store: store,
          record: record,
          changes: changes
        });
      }

      return result;
    }
  };
}; // Can't have this in Column due to circular dependencies

ColumnStore.registerColumnType(_column_Column_js__WEBPACK_IMPORTED_MODULE_24__["default"], true);
ColumnStore._$name = 'ColumnStore';

/***/ }),

/***/ "./lib/Grid/data/GridRowModel.js":
/*!***************************************!*\
  !*** ./lib/Grid/data/GridRowModel.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GridRowModel; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Grid/data/GridRowModel
 */

/**
 * Model extended with some fields related to grid rendering. Used as default model type in the grids store if nothing
 * else is specified.
 *
 * Using this model is optional. If you use a custom model instead and need the functionality of any of the fields
 * below, you just have to remember to add fields with the same name to your model.
 *
 * @extends Core/data/Model
 */

var GridRowModel = /*#__PURE__*/function (_Model) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(GridRowModel, _Model);

  var _super = _createSuper(GridRowModel);

  function GridRowModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, GridRowModel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(GridRowModel, null, [{
    key: "fields",
    get: function get() {
      return [
      /**
       * Icon for row (used automatically in tree, feel free to use it in renderer in other cases)
       * @field {String} iconCls
       * @category Styling
       */
      'iconCls',
      /**
       * Start expanded or not (only valid for tree data)
       * @field {Boolean} expanded
       * @category Tree
       */
      'expanded',
      /**
       * CSS class (or several classes divided by space) to append to row elements
       * @field {String} cls
       * @category Styling
       */
      'cls',
      /**
       * Used by the default implementation of {@link Grid.view.GridBase#config-getRowHeight} to determine row
       * height. Set it to use another height than the default for a the records row.
       * @field {Number} rowHeight
       * @category Styling
       */
      'rowHeight',
      /**
       * A link to use for this record when rendered into a {@link Grid.column.TreeColumn}.
       * @field {String} href
       * @category Tree
       */
      'href',
      /**
       * The target to use if this tree node provides a value for the {@link #field-href} field.
       * @field {String} target
       * @category Tree
       */
      'target'];
    }
  }]);

  return GridRowModel;
}(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


GridRowModel.exposeProperties();
GridRowModel._$name = 'GridRowModel';

/***/ }),

/***/ "./lib/Grid/feature/CellEdit.js":
/*!**************************************!*\
  !*** ./lib/Grid/feature/CellEdit.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CellEdit; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony import */ var _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/widget/MessageDialog.js */ "./lib/Core/widget/MessageDialog.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");



















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Maybe some more way to stop editing in touch mode (in case grid fills entire page...)













var validNonEditingKeys = {
  Enter: 1,
  F2: 1
},
    validEditingKeys = {
  ArrowUp: 1,
  ArrowDown: 1,
  ArrowLeft: 1,
  ArrowRight: 1
};
/**
 * @module Grid/feature/CellEdit
 */

/**
 * Adding this feature to the grid and other Bryntum products which are based on the Grid (i.e. Scheduler, SchedulerPro, and Gantt)
 * enables cell editing. Any subclass of {@link Core.widget.Field Field} can be used
 * as editor for the {@link Grid.column.Column Column}. The most popular are:
 *
 * - {@link Core.widget.TextField TextField}
 * - {@link Core.widget.NumberField NumberField}
 * - {@link Core.widget.DateField DateField}
 * - {@link Core.widget.TimeField TimeField}
 * - {@link Core.widget.Combo Combo}
 *
 * Usage instructions:
 * ## Start editing
 * * Double click on a cell
 * * Press [ENTER] or [F2] with a cell selected
 * * It is also possible to change double click to single click to start editing, using the {@link #config-triggerEvent} config
 *
 * ```javascript
 * new Grid({
 *    features : {
 *        cellEdit : {
 *            triggerEvent : 'cellclick'
 *        }
 *    }
 * });
 * ```
 *
 * ## While editing
 * * [ENTER] Finish editing and start editing the same cell in next row
 * * [SHIFT] + [ENTER] Same as above put with previous row
 * * [F2] Finish editing
 * * [CMD/CTRL] + [ENTER] Finish editing
 * * [ESC] By default, first reverts the value back to its original value, next press cancels editing
 * * [TAB] Finish editing and start editing the next cell
 * * [SHIFT] + [TAB] Finish editing and start editing the previous cell
 *
 * Columns specify editor in their configuration. Editor can also by set by using a column type. Columns
 * may also contain these three configurations which affect how their cells are edited:
 * * {@link Grid.column.Column#config-invalidAction}
 * * {@link Grid.column.Column#config-revertOnEscape}
 * * {@link Grid.column.Column#config-finalizeCellEdit}
 *
 * ## Preventing editing of certain cells
 * You can prevent editing on a column by setting `editor` to false:
 *
 * ```javascript
 * new Grid({
 *    columns : [
 *       {
 *          type   : 'number',
 *          text   : 'Age',
 *          field  : 'age',
 *          editor : false
 *       }
 *    ]
 * });
 * ```
 * To prevent editing in a specific cell, listen to the {@link #event-beforeCellEditStart} and return false:
 *
 * ```javascript
 * grid.on('beforeCellEditStart', ({ editorContext }) => {
 *     return editorContext.column.field !== 'id';
 * });
 * ```
 *
 * To use an alternative input field to edit a cell, listen to the {@link #event-beforeCellEditStart} and
 * set the `editor` property of the context to the input field you want to use:
 *
 * ```javascript
 * grid.on('beforeCellEditStart', ({ editorContext }) => {
 *     return editorContext.editor = myDateField;
 * });
 * ```
 *
 * This feature is **enabled** by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/celledit
 * @classtype cellEdit
 * @externalexample feature/CellEdit.js
 */

var CellEdit = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(CellEdit, _Delayable);

  var _super = _createSuper(CellEdit);

  function CellEdit() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, CellEdit);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(CellEdit, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(grid, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(CellEdit.prototype), "construct", this).call(this, grid, config);

      var me = this,
          gridListeners = {
        beforeRenderRows: 'onGridBeforeRenderRows',
        cellClick: 'onCellClick',
        thisObj: me
      };
      me.grid = grid;

      if (me.triggerEvent !== 'cellclick') {
        gridListeners[me.triggerEvent] = 'onTriggerEditEvent';
      }

      grid.on(gridListeners);
      me.bindStore(grid.store);
    }
  }, {
    key: "bindStore",
    value: function bindStore(store) {
      this.detachListeners('store');
      store.on({
        name: 'store',
        update: 'onStoreUpdate',
        thisObj: this
      });
    }
    /**
     * Displays a YES/NO confirmation dialog box owned by the current Editor. This is intended to be
     * used by {@link Grid.column.Column#config-finalizeCellEdit} implementations. The returned promise resolves passing `true`
     * if the "yes" button is pressed, and `false` if the "No" button is pressed. Typing `ESC` rejects.
     * @param {Object} options An options object for what to show.
     * @param {String} [options.title] The title to show in the dialog header.
     * @param {String} [options.message] The message to show in the dialog body.
     * @async
     */

  }, {
    key: "confirm",
    value: function () {
      var _confirm = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee(options) {
        var result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = true;

                if (!this.editorContext) {
                  _context.next = 7;
                  break;
                }

                // The input field must not lose containment of focus during this confirmation
                // so temporarily make the MessageDialog a descendant widget.
                _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_25__["default"].owner = this.editorContext.editor.inputField;
                _context.next = 5;
                return _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_25__["default"].confirm(options);

              case 5:
                result = _context.sent;
                _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_25__["default"].owner = null;

              case 7:
                return _context.abrupt("return", result === _Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_25__["default"].yesButton);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }

      return confirm;
    }()
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.cancelEditing(true); // To kill timeouts

      this.grid.columns.allRecords.forEach(function (column) {
        if (column._cellEditor) {
          column._cellEditor.destroy();
        }
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(CellEdit.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      if (disable) {
        this.cancelEditing(true);
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(CellEdit.prototype), "doDisable", this).call(this, disable);
    }
  }, {
    key: "getEditorForCell",

    /**
     * Internal function to create or get existing editor for specified cell.
     * @private
     * @param cellContext Cell to get or create editor for
     * @returns {Core.widget.Editor} An Editor container which displays the input field.
     * @category Internal
     */
    value: function getEditorForCell(_ref) {
      var cell = _ref.cell,
          column = _ref.column,
          selector = _ref.selector,
          editor = _ref.editor;
      var me = this,
          grid = me.grid; // Reuse the Editor by caching it on the column.

      var cellEditor = column._cellEditor,
          leftOffset = 0; // Only applicable for tree cells to show editor right of the icons etc
      // Help Editor match size and position

      if (column.editTargetSelector) {
        var editorTarget = cell.querySelector(column.editTargetSelector);
        leftOffset = editorTarget.offsetLeft;
      }

      editor.autoSelect = me.autoSelect;

      if (cellEditor) {
        // Already got the positioned Editor container which carries the input field.
        // just check if the actual field has been changed in a beforeCellEditStart handler.
        // If so, switch it out.
        if (cellEditor.inputField !== editor) {
          cellEditor.remove(cellEditor.items[0]);
          cellEditor.add(editor);
        }

        cellEditor.align.offset[0] = leftOffset;
      } else {
        cellEditor = column._cellEditor = new me.editorClass({
          constrainTo: null,
          cls: 'b-cell-editor',
          inputField: editor,
          blurAction: 'none',
          invalidAction: column.invalidAction,
          completeKey: false,
          cancelKey: false,
          owner: grid,
          align: {
            align: 't0-t0',
            offset: [leftOffset, 0]
          },
          listeners: me.getEditorListeners()
        });
      } // Keep the record synced with the value


      if (column.instantUpdate && !editor.cellEditValueSetter) {
        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].wrapProperty(editor, 'value', null, function (value) {
          var editorContext = me.editorContext; // Only tickle the record if the value has changed.

          if ((editorContext === null || editorContext === void 0 ? void 0 : editorContext.editor.isValid) && !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isEqual(editorContext.record[editorContext.column.field], value)) {
            editorContext.record[editorContext.column.field] = value;
          }
        });
        editor.cellEditValueSetter = true;
      }

      Object.assign(cellEditor.element.dataset, {
        rowId: selector.id,
        columnId: selector.columnId,
        field: column.field
      }); // First ESC press reverts

      cellEditor.inputField.revertOnEscape = column.revertOnEscape;
      return me.editor = cellEditor;
    } // Turned into function to allow overriding in Gantt, and make more configurable in general

  }, {
    key: "getEditorListeners",
    value: function getEditorListeners() {
      return {
        focusout: 'onEditorFocusOut',
        focusin: 'onEditorFocusIn',
        start: 'onEditorStart',
        beforecomplete: 'onEditorBeforeComplete',
        complete: 'onEditorComplete',
        cancel: 'onEditorCancel',
        thisObj: this
      };
    }
  }, {
    key: "onEditorStart",
    value: function onEditorStart(_ref2) {
      var editor = _ref2.source;
      var me = this,
          editorContext = me.editorContext = editor.cellEditorContext;

      if (editorContext) {
        var grid = me.grid,
            cell = editorContext.cell;
        cell.classList.add('b-editing'); // Should move editing to new cell on click, unless click is configured to start editing - in which case it
        // will move anyway

        if (me.triggerEvent !== 'cellclick') {
          grid.on({
            cellclick: 'onCellClickWhileEditing'
          }, me);
        } // Handle tapping outside of the grid element. Use GlobalEvents
        // because it uses a capture:true listener before any other handlers
        // might stop propagation.
        // Cannot use delegate here. A tapped cell will match :not(#body-container)


        me.removeEditingListeners = _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_24__["default"].addListener({
          globaltap: 'onTapOut',
          thisObj: me
        });
        /**
         * Fires on the owning Grid when editing starts
         * @event startCellEdit
         * @param {Grid.view.Grid} source Owner grid
         * @param {Object} editorContext Editing context
         * @param {Core.widget.Editor} editorContext.editor The Editor being used.
         * Will contain an `inputField` property which is the field being used to perform the editing.
         * @param {Grid.column.Column} editorContext.column Target column
         * @param {Core.data.Model} editorContext.record Target record
         * @param {HTMLElement} editorContext.cell Target cell
         * @param {*} editorContext.value Cell value
         */

        grid.trigger('startCellEdit', {
          grid: grid,
          editorContext: editorContext
        });
      }
    }
  }, {
    key: "onEditorBeforeComplete",
    value: function onEditorBeforeComplete(context) {
      var grid = this.grid,
          editor = context.source,
          editorContext = editor.cellEditorContext;
      context.grid = grid;
      context.editorContext = editorContext;
      /**
       * Fires on the owning Grid before the cell editing is finished, return false to signal that the value is invalid and editing should not be finalized.
       * @event beforeFinishCellEdit
       * @param {Grid.view.Grid} grid Target grid
       * @param {Object} editorContext Editing context
       * @param {Core.widget.Editor} editorContext.editor The Editor being used.
       * Will contain an `inputField` property which is the field being used to perform the editing.
       * @param {Grid.column.Column} editorContext.column Target column
       * @param {Core.data.Model} editorContext.record Target record
       * @param {HTMLElement} editorContext.cell Target cell
       * @param {*} editorContext.value Cell value
       */

      return grid.trigger('beforeFinishCellEdit', context);
    }
  }, {
    key: "onEditorComplete",
    value: function onEditorComplete(_ref3) {
      var editor = _ref3.source;
      var grid = this.grid,
          editorContext = editor.cellEditorContext; // Ensure the docs below are accurate!

      editorContext.value = editor.inputField.value;
      /**
       * Fires on the owning Grid when cell editing is finished
       * @event finishCellEdit
       * @param {Grid.view.Grid} grid Target grid
       * @param {Object} editorContext Editing context
       * @param {Core.widget.Editor} editorContext.editor The Editor being used.
       * Will contain an `inputField` property which is the field being used to perform the editing.
       * @param {Grid.column.Column} editorContext.column Target column
       * @param {Core.data.Model} editorContext.record Target record
       * @param {HTMLElement} editorContext.cell Target cell
       * @param {*} editorContext.value Cell value
       */

      grid.trigger('finishCellEdit', {
        grid: grid,
        editorContext: editorContext
      });
      this.cleanupAfterEdit(editorContext);
    }
  }, {
    key: "onEditorCancel",
    value: function onEditorCancel() {
      var editorContext = this.editorContext,
          muteEvents = this.muteEvents,
          grid = this.grid;

      if (editorContext) {
        this.cleanupAfterEdit(editorContext);
      }

      if (!muteEvents) {
        /**
         * Fires on the owning Grid when editing is cancelled
         * @event cancelCellEdit
         * @param {Grid.view.Grid} source Owner grid
         */
        grid.trigger('cancelCellEdit', {
          grid: grid
        });
      }
    }
  }, {
    key: "cleanupAfterEdit",
    value: function cleanupAfterEdit(editorContext) {
      var me = this,
          editor = editorContext.editor;
      editorContext.cell.classList.remove('b-editing');
      editor.cellEditorContext = me.editorContext = null;
      me.grid.un({
        cellclick: 'onCellClickWhileEditing',
        viewportResize: 'onViewportResizeWhileEditing'
      }, me);
      me.removeEditingListeners(); // MS Edge workaround.
      // At this moment active element is grid.element, but removing editor element still triggers focusout event
      // which is processed by the GlobalEvents, which decides that focus goes to body element. That, in turn, triggers
      // clearFocus on grid navigation, removing focused cell from cache etc, eventually focus actually goes to body.
      // Suspending listener to seamlessly remove element keeping focus where it belongs.
      // NOTE: not reproducible in IFrame, so our tests cannot catch this

      _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_24__["default"].suspendFocusEvents();
      editor.element.remove();
      _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_24__["default"].resumeFocusEvents();
    }
    /**
     * Find the next succeeding or preceding cell which is editable (column.editor != false)
     * @param {Object} cellInfo
     * @param {Boolean} isForward
     * @returns {Object}
     * @private
     * @category Internal
     */

  }, {
    key: "getAdjacentEditableCell",
    value: function () {
      var _getAdjacentEditableCell = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee2(cellInfo, isForward) {
        var grid, store, columns, rowId, columnId, column, record, editRec;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                grid = this.grid, store = grid.store, columns = grid.columns;
                rowId = cellInfo.id, columnId = cellInfo.columnId, column = columns.getAdjacentLeaf(columnId, isForward);

              case 2:
                if (!rowId) {
                  _context2.next = 16;
                  break;
                }

                record = store.getById(rowId);

                if (!column) {
                  _context2.next = 11;
                  break;
                }

                columnId = column.id;

                if (!(!column.hidden && column.editor && column.canEdit(record))) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", {
                  id: rowId,
                  columnId: column.id
                });

              case 8:
                column = columns.getAdjacentLeaf(columnId, isForward);
                _context2.next = 14;
                break;

              case 11:
                editRec = store.getAdjacent(cellInfo.id, isForward, false, true);
                rowId = editRec === null || editRec === void 0 ? void 0 : editRec.id;

                if (editRec) {
                  column = isForward ? columns.first : columns.leaves[columns.leaves.length - 1];
                }

              case 14:
                _context2.next = 2;
                break;

              case 16:
                return _context2.abrupt("return", null);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAdjacentEditableCell(_x2, _x3) {
        return _getAdjacentEditableCell.apply(this, arguments);
      }

      return getAdjacentEditableCell;
    }()
    /**
     * Adds a new, empty record at the end of the TaskStore with the initial
     * data specified by the {@link Grid.feature.CellEdit#config-addNewAtEnd} setting.
     *
     * @returns {Promise} Newly added record wrapped in a promise.
     */

  }, {
    key: "doAddNewAtEnd",
    value: function () {
      var _doAddNewAtEnd = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee3(newRecordConfig) {
        var grid, record;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                grid = this.grid, record = grid.store.add(newRecordConfig)[0]; // If the new record was not added due to it being off the end of the rendered block
                // ensure we force it to be there before we attempt to edit it.

                if (!grid.rowManager.getRowFor(record)) {
                  grid.rowManager.displayRecordAtBottom();
                }

                return _context3.abrupt("return", record);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function doAddNewAtEnd(_x4) {
        return _doAddNewAtEnd.apply(this, arguments);
      }

      return doAddNewAtEnd;
    }()
    /**
     * Creates an editing context object for the passed cell context (target cell must be in the DOM).
     *
     * If the referenced cell is editable, an object returned will
     * be returned containing the following properties:
     *
     *     - column
     *     - record
     *     - cell
     *     - value
     *     - selector
     *
     * If the references cell is _not_ editable, `false` will be returned.
     * @param {Object} cellContext an object which encapsulates a cell.
     * @param {String} cellContext.id The record id of the row to edit
     * @param {String} cellContext.columnId The column id of the column to edit
     * @private
     */

  }, {
    key: "getEditingContext",
    value: function getEditingContext(cellContext) {
      cellContext = this.grid.normalizeCellContext(cellContext);
      var me = this,
          grid = me.grid,
          column = grid.columns.getById(cellContext.columnId),
          record = grid.store.getById(cellContext.id); // Cell must be in the DOM to edit.
      // Cannot edit hidden columns and columns without an editor.
      // Cannot edit special rows (groups etc).

      if (column && !column.hidden && column.editor && record && !record.isSpecialRow && column.canEdit(record)) {
        var value = record === null || record === void 0 ? void 0 : record[column.field];
        return {
          column: column,
          record: record,
          value: value === undefined ? null : value,
          selector: cellContext,
          editor: column.editor
        };
      } else {
        return false;
      }
    }
    /**
     * Start editing specified cell. If no cellContext is given it starts with the first cell in the first row.
     * This function is exposed on Grid and can thus be called as `grid.startEditing(...)`
     * @param {Object} cellContext Cell specified in format { id: 'x', columnId/column/field: 'xxx' }. See {@link Grid.view.Grid#function-getCell} for details.
     * @fires startCellEdit
     * @returns {Boolean} editingStarted
     * @category Editing
     */

  }, {
    key: "startEditing",
    value: function startEditing() {
      var cellContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this; // If already editing, or grid is readonly, no can do.

      if (!(me.editorContext || me.disabled)) {
        var grid = me.grid,
            normalizedContext = grid.normalizeCellContext(cellContext);
        var editorContext = me.getEditingContext(normalizedContext); // Cannot edit hidden columns and columns without an editor
        // Cannot edit special rows (groups etc).

        if (!editorContext) {
          return false;
        } // Now that we know we can edit this cell, scroll the record into view and register it as last focusedCell


        grid.focusCell(cellContext);
        editorContext.cell = grid.getCell(cellContext);
        /**
         * Fires on the owning Grid before editing starts, return `false` to prevent editing
         * @event beforeCellEditStart
         * @preventable
         * @param {Grid.view.Grid} source Owner grid
         * @param {Object} editorContext Editing context
         * @param {Grid.column.Column} editorContext.column Target column
         * @param {Core.data.Model} editorContext.record Target record
         * @param {HTMLElement} editorContext.cell Target cell
         * @param {Core.widget.Field} editorContext.editor The input field that the column is configured
         * with (see {@link Grid.column.Column#config-field}). This property mey be replaced
         * to be a different {@link Core.widget.Field field} in the handler, to take effect
         * just for the impending edit.
         * @param {Function} [editorContext.finalize] An async function may be injected into this property
         * which performs asynchronous finalization tasks such as complex validation of confirmation. The
         * value `true` or `false` must be returned.
         * @param {Object} [editorContext.finalize.context] An object describing the editing context upon requested completion of the edit.
         * @param {*} editorContext.value Cell value
         */

        if (grid.trigger('beforeCellEditStart', {
          grid: grid,
          editorContext: editorContext
        }) === false) {
          return false;
        } // Focus grid element to preserve focus inside once editing is started
        // https://app.assembla.com/spaces/bryntum/tickets/8155-grid-cell-not-properly-focused-in-advanced-demo


        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].focusWithoutScrolling(grid.focusElement);
        var editor = editorContext.editor = me.getEditorForCell(editorContext),
            cell = editorContext.cell,
            record = editorContext.record,
            column = editorContext.column; // Prevent highlight when setting the value in the editor

        editor.inputField.highlightExternalChange = false;
        editor.cellEditorContext = editorContext;
        editor.render(me.grid.getSubGridFromColumn(column).element); // Attempt to start edit.
        // We will set up our context in onEditorStart *if* the start was successful.

        editor.startEdit({
          target: cell,
          record: record,
          field: editor.inputField.name || editorContext.column.field
        });
        return true;
      }

      return false;
    }
    /**
     * Cancel editing, destroys the editor
     * @param {Boolean} silent Pass true to prevent method from firing event
     * @fires cancelCellEdit
     * @category Editing
     */

  }, {
    key: "cancelEditing",
    value: function cancelEditing() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          editorContext = me.editorContext,
          editor = me.editor,
          grid = me.grid;

      if (editorContext) {
        // If cancel was not called from onEditorFocusOut, then refocus the grid.
        if (editor.containsFocus) {
          // Kill editorContext before we destroy the editor so that we know we are not editing
          // in ensuing focusout event handling
          me.editorContext = null; // Control focus reversion if we own focus

          if (editor.inputField.owns(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].activeElement)) {
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].focusWithoutScrolling(grid.focusElement);
          }

          me.editorContext = editorContext;
        }

        me.muteEvents = silent;
        editor.cancelEdit();
        me.muteEvents = false;
      }
    }
    /**
     * Finish editing, update the underlying record and destroy the editor
     * @fires finishCellEdit
     * @category Editing
     * @returns `false` if the edit could not be finished due to the value being invalid or the
     * Editor's `complete` event was vetoed.
     * @async
     */

  }, {
    key: "finishEditing",
    value: function () {
      var _finishEditing = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee4() {
        var editorContext, result, column;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                editorContext = this.editorContext;
                result = false;

                if (!editorContext) {
                  _context4.next = 9;
                  break;
                }

                column = editorContext.column; // If completeEdit finds that the editor context has a finalize method in it,
                // it will *await* the completion of that method before completing the edit
                // so we must await completeEdit.
                // We can override that finalize method by passing the column's own finalizeCellEdit.
                // Set a flag (promise) indicating that we are in the middle of editing finalization

                this.finishEditingPromise = editorContext.editor.completeEdit(column.bindCallback(column.finalizeCellEdit));
                _context4.next = 7;
                return this.finishEditingPromise;

              case 7:
                result = _context4.sent;
                // reset the flag
                this.finishEditingPromise = null;

              case 9:
                return _context4.abrupt("return", result);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function finishEditing() {
        return _finishEditing.apply(this, arguments);
      }

      return finishEditing;
    }() //endregion
    //region Events

    /**
     * Event handler added when editing is active called when user clicks a cell in the grid during editing.
     * It finishes editing and moves editor to the selected cell instead.
     * @private
     * @category Internal event handling
     */

  }, {
    key: "onCellClickWhileEditing",
    value: function () {
      var _onCellClickWhileEditing = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee5(_ref4) {
        var event, cellSelector, me;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                event = _ref4.event, cellSelector = _ref4.cellSelector;
                me = this; // Ignore clicks if async finalization is running

                if (!me.finishEditingPromise) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                if (!(me.editorContext && !me.editorContext.editor.owns(event.target))) {
                  _context5.next = 17;
                  break;
                }

                if (!me.getEditingContext(cellSelector)) {
                  _context5.next = 16;
                  break;
                }

                _context5.next = 8;
                return me.finishEditing();

              case 8:
                if (!_context5.sent) {
                  _context5.next = 12;
                  break;
                }

                me.startEditing(cellSelector);
                _context5.next = 14;
                break;

              case 12:
                me.grid.focusCell(me.editorContext.selector);
                me.editor.inputField.focus();

              case 14:
                _context5.next = 17;
                break;

              case 16:
                me.finishEditing();

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onCellClickWhileEditing(_x5) {
        return _onCellClickWhileEditing.apply(this, arguments);
      }

      return onCellClickWhileEditing;
    }()
    /**
     * Starts editing if user taps selected cell again on touch device. Chained function called when user clicks a cell.
     * @private
     * @category Internal event handling
     */

  }, {
    key: "onCellClick",
    value: function onCellClick(_ref5) {
      var grid = _ref5.source,
          record = _ref5.record,
          cellSelector = _ref5.cellSelector,
          cellElement = _ref5.cellElement,
          target = _ref5.target,
          event = _ref5.event;
      var selected = grid.focusedCell || {},
          column = grid.columns.getById(cellSelector.columnId); // Columns may provide their own handling of cell editing

      if (column.onCellClick) {
        column.onCellClick({
          grid: grid,
          column: column,
          record: record,
          cellSelector: cellSelector,
          cellElement: cellElement,
          target: target,
          event: event
        });
      } else if (target.closest('.b-tree-expander')) {
        this.cancelEditing();
        return false;
      } else if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].isTouchEvent && cellSelector.id == selected.id && cellSelector.columnId == selected.columnId) {
        this.startEditing(cellSelector);
      } else if (this.triggerEvent === 'cellclick') {
        this.onTriggerEditEvent({
          cellSelector: cellSelector
        });
      }
    }
    /**
     * Called when the user triggers the edit action in {@link #config-triggerEvent} config. Starts editing.
     * @private
     * @category Internal event handling
     */

  }, {
    key: "onTriggerEditEvent",
    value: function onTriggerEditEvent(_ref6) {
      var cellSelector = _ref6.cellSelector;

      if (this.editorContext && !this.finishEditing()) {
        return;
      }

      this.startEditing(cellSelector);
    }
    /**
     * Update the input field if underlying data changes during edit.
     * @private
     * @category Internal event handling
     */

  }, {
    key: "onStoreUpdate",
    value: function onStoreUpdate(_ref7) {
      var changes = _ref7.changes,
          record = _ref7.record;
      var editorContext = this.editorContext;

      if (editorContext === null || editorContext === void 0 ? void 0 : editorContext.editor.isVisible) {
        if (record === editorContext.record && editorContext.editor.dataField in changes) {
          editorContext.editor.refreshEdit();
        }
      }
    }
    /**
     * Invalidate editor when grid renders rows.
     * @private
     * @category Internal event handling
     */

  }, {
    key: "onGridBeforeRenderRows",
    value: function onGridBeforeRenderRows() {
      var _this$editorContext;

      // grid rows are being rerendered, meaning the underlying data might be changed.
      // the editor probably won't be over the same record, so cancel
      if ((_this$editorContext = this.editorContext) === null || _this$editorContext === void 0 ? void 0 : _this$editorContext.editor.isVisible) {
        this.cancelEditing();
      }
    }
    /**
     * Chained function called on key down. [enter] or [f2] starts editing. [enter] also finishes editing and starts
     * editing next row, [f2] also finishes editing without moving to the next row. [esc] cancels editing. [tab]
     * edits next column, [shift] + [tab] edits previous.
     * @param event
     * @private
     * @category Internal event handling
     */

  }, {
    key: "onElementKeyDown",
    value: function () {
      var _onElementKeyDown = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee6(event) {
        var me, key, backspace, autoEdit, inputField, input;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                me = this; // flagging event with handled = true used to signal that other features should probably not care about it

                if (!(event.handled || !me.grid.focusElement.contains(event.target))) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                if (me.editorContext) {
                  _context6.next = 8;
                  break;
                }

                key = event.key, backspace = key === 'Backspace', autoEdit = me.autoEdit && (key.length === 1 || backspace); // enter or f2 to edit, or any character key if autoEdit is enabled

                if ((autoEdit || validNonEditingKeys[key]) && me.grid.focusedCell) {
                  if (me.startEditing(me.grid.focusedCell)) {
                    inputField = me.editor.inputField, input = inputField.input; // if editing started with a keypress and the editor has an input field, set its value

                    if (autoEdit && input) {
                      // Simulate a keydown in an input field by setting input value
                      // plus running our internal processing of that event
                      inputField.internalOnKeyEvent(event);

                      if (!event.defaultPrevented) {
                        input.value = backspace ? '' : key;
                        inputField.internalOnInput(event); // IE11 + Edge put caret at 0 when focusing

                        inputField.moveCaretToEnd();
                      }
                    }
                  }

                  event.preventDefault();
                }

                _context6.next = 23;
                break;

              case 8:
                _context6.t0 = event.key;
                _context6.next = _context6.t0 === 'Enter' ? 11 : _context6.t0 === 'F2' ? 13 : _context6.t0 === 'Escape' ? 16 : _context6.t0 === 'Tab' ? 20 : 22;
                break;

              case 11:
                me.onEnterKeyPress(event);
                return _context6.abrupt("break", 22);

              case 13:
                event.preventDefault();
                me.finishEditing();
                return _context6.abrupt("break", 22);

              case 16:
                event.stopPropagation();
                event.preventDefault();
                me.cancelEditing();
                return _context6.abrupt("break", 22);

              case 20:
                me.onTabKeyPress(event);
                return _context6.abrupt("break", 22);

              case 22:
                // prevent arrow keys from moving editor
                if (validEditingKeys[event.key]) {
                  event.handled = true;
                }

              case 23:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function onElementKeyDown(_x6) {
        return _onElementKeyDown.apply(this, arguments);
      }

      return onElementKeyDown;
    }()
  }, {
    key: "onEnterKeyPress",
    value: function () {
      var _onEnterKeyPress = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee7(event) {
        var me, grid;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                me = this, grid = me.grid;
                event.preventDefault();
                event.stopPropagation();
                _context7.next = 5;
                return me.finishEditing();

              case 5:
                if (!_context7.sent) {
                  _context7.next = 10;
                  break;
                }

                if (me.isEditing) {
                  _context7.next = 10;
                  break;
                }

                if (!(event.ctrlKey || event.metaKey || event.altKey || me.grid.touch)) {
                  _context7.next = 9;
                  break;
                }

                return _context7.abrupt("return");

              case 9:
                // Edit previous
                if (event.shiftKey) {
                  if (grid.navigateUp()) {
                    me.startEditing(grid.focusedCell);
                  }
                } // Edit next
                else if (grid.navigateDown()) {
                    me.startEditing(grid.focusedCell);
                  }

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onEnterKeyPress(_x7) {
        return _onEnterKeyPress.apply(this, arguments);
      }

      return onEnterKeyPress;
    }()
  }, {
    key: "onTabKeyPress",
    value: function () {
      var _onTabKeyPress = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee8(event) {
        var me, focusedCell, isForward, cellInfo, currentEditableFinalizationResult, finalizationResult;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                event.preventDefault();
                me = this, focusedCell = me.grid.focusedCell;

                if (!focusedCell) {
                  _context8.next = 24;
                  break;
                }

                isForward = !event.shiftKey;
                _context8.next = 6;
                return me.getAdjacentEditableCell(focusedCell, isForward);

              case 6:
                cellInfo = _context8.sent;

                if (!(!cellInfo && isForward && me.addNewAtEnd)) {
                  _context8.next = 17;
                  break;
                }

                _context8.next = 10;
                return me.finishEditing();

              case 10:
                currentEditableFinalizationResult = _context8.sent;

                if (!(currentEditableFinalizationResult === true)) {
                  _context8.next = 17;
                  break;
                }

                _context8.next = 14;
                return this.doAddNewAtEnd(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7___default()(me.addNewAtEnd) === 'object' ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].clone(me.addNewAtEnd) : {});

              case 14:
                _context8.next = 16;
                return me.getAdjacentEditableCell(focusedCell, isForward);

              case 16:
                cellInfo = _context8.sent;

              case 17:
                if (!cellInfo) {
                  _context8.next = 24;
                  break;
                }

                finalizationResult = true;

                if (!me.isEditing) {
                  _context8.next = 23;
                  break;
                }

                _context8.next = 22;
                return me.finishEditing();

              case 22:
                finalizationResult = _context8.sent;

              case 23:
                if (finalizationResult) {
                  me.grid.focusCell(cellInfo, {
                    animate: me.focusCellAnimationDuration
                  });
                  me.startEditing(cellInfo);
                } else {// finishing cell editing was not allowed, current editor value is invalid
                }

              case 24:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function onTabKeyPress(_x8) {
        return _onTabKeyPress.apply(this, arguments);
      }

      return onTabKeyPress;
    }()
  }, {
    key: "onElementMouseDown",
    value: function onElementMouseDown(event) {
      // If it's a contextmenu mousedown during cell edit, prevent default
      // because the contextmenu handler will move focus directly to the context menu.
      // If we allow it to go through the grid, the edit will not terminate because
      // that usually means begin editing somewhere else in the grid.
      // TODO: This won't be necessary when cells are the focusable DOM unit.
      if (event.button === 2 && this.editorContext) {
        event.preventDefault();
      }
    }
    /**
     * Cancel editing on widget focusout
     * @private
     */

  }, {
    key: "onEditorFocusOut",
    value: function onEditorFocusOut(event) {
      var me = this,
          grid = me.grid; // If the editor is not losing focus as a result of its tidying up process
      // And focus is moving to outside of the grid, or back to the initiating cell
      // (which indicates a click on empty space below rows), then explicitly terminate.

      if (me.editorContext && !me.editor.isFinishing && me.editor.inputField.owns(event._target) && (event.toWidget !== grid || grid.isLocationEqual(me.grid.focusedCell, me.editorContext.selector))) {
        if (me.blurAction === 'cancel') {
          me.cancelEditing();
        } // if not already in the middle of editing finalization (that could be async)
        else if (!me.finishEditingPromise) {
            me.finishEditing();
          }
      }
    }
  }, {
    key: "onEditorFocusIn",
    value: function onEditorFocusIn(event) {
      var widget = event.toWidget;

      if (widget === this.editor.inputField) {
        if (this.autoSelect && widget.selectAll && !widget.readOnly && !widget.disabled) {
          widget.selectAll();
        }
      }
    }
    /**
     * Cancel edit on touch outside of grid for mobile Safari (focusout not triggering unless you touch something focusable)
     * @private
     */

  }, {
    key: "onTapOut",
    value: function onTapOut(_ref8) {
      var event = _ref8.event;
      var me = this;

      if (!me.grid.bodyContainer.contains(event.target)) {
        if (!me.editor.owns(event.target)) {
          if (me.blurAction === 'cancel') {
            me.cancelEditing();
          } else {
            me.finishEditing();
          }
        }
      }
    }
    /**
     * Finish editing if clicking below rows (only applies when grid is higher than rows).
     * @private
     * @category Internal event handling
     */

  }, {
    key: "onElementClick",
    value: function onElementClick(event) {
      if (event.target.classList.contains('b-grid-body-container') && this.editorContext) {
        this.finishEditing();
      }
    } //endregion

  }, {
    key: "disabled",
    set: function set(disabled) {
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(CellEdit.prototype), "disabled", disabled, this, true);
    },
    get: function get() {
      var grid = this.grid;
      return Boolean(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(CellEdit.prototype), "disabled", this) || grid.disabled || grid.readOnly);
    } //endregion
    //region Editing

    /**
     * Is any cell currently being edited?
     * @returns {Boolean}
     */

  }, {
    key: "isEditing",
    get: function get() {
      return Boolean(this.editorContext);
    }
    /**
     * Returns the record currently being edited, or `null`
     * @returns {Core.data.Model}
     */

  }, {
    key: "activeRecord",
    get: function get() {
      var _this$editorContext2;

      return ((_this$editorContext2 = this.editorContext) === null || _this$editorContext2 === void 0 ? void 0 : _this$editorContext2.record) || null;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'CellEdit';
    } // Default configuration

  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Set to true to select the field text when editing starts
         * @config {Boolean}
         * @default
         */
        autoSelect: true,

        /**
         * What action should be taken when focus moves leaves the cell editor, for example when clicking outside.
         * May be `'complete'` or `'cancel`'.
         * @config {String}
         * @default
         */
        blurAction: 'complete',

        /**
         * Set to true to have TAB on the last cell in the data set create a new record
         * and begin editing it at its first editable cell.
         *
         * If this is configured as an object, it is used as the default data value set for each new record.
         * @config {Boolean|Object}
         * @default
         */
        addNewAtEnd: null,

        /**
         * Set to true to start editing when user starts typing text on a focused cell (as in Excel)
         * @config {Boolean}
         * @default
         */
        autoEdit: false,

        /**
         * Class to use as an editor. Default value: {@link Core.widget.Editor}
         * @config {Core.widget.Widget}
         * @internal
         */
        editorClass: _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_23__["default"],

        /**
         * The name of the grid event that will trigger cell editing. Defaults to
         * {@link Grid.view.mixin.GridElementEvents#event-cellDblClick celldblclick} but can be changed to any other event,
         * such as {@link Grid.view.mixin.GridElementEvents#event-cellClick cellclick}.
         *
         * ```javascript
         * features : {
         *     cellEdit : {
         *         triggerEvent : 'cellclick'
         *     }
         * }
         * ```
         *
         * @config {String}
         * @default
         */
        triggerEvent: 'celldblclick',
        focusCellAnimationDuration: 100
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        assign: ['startEditing'],
        before: ['onElementKeyDown', 'onElementMouseDown'],
        chain: ['onElementClick', 'bindStore']
      };
    }
  }]);

  return CellEdit;
}(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_21__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_19__["default"]));


CellEdit._$name = 'CellEdit';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_20__["default"].registerFeature(CellEdit, true);

/***/ }),

/***/ "./lib/Grid/feature/CellMenu.js":
/*!**************************************!*\
  !*** ./lib/Grid/feature/CellMenu.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CellMenu; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Grid_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Grid/feature/base/ContextMenuBase.js */ "./lib/Grid/feature/base/ContextMenuBase.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Grid/feature/CellMenu
 */

/**
 * Right click to display context menu for cells.
 *
 * ### Default cell menu items
 *
 * The Cell menu feature provides only one item by default and all the other items are populated by the other features:
 *
 * | Item reference         | Text             | Weight | Feature    | Enabled by default | Description                                                                    |
 * |------------------------|------------------|--------|------------|--------------------|--------------------------------------------------------------------------------|
 * | `removeRow`            | Delete record    | 100    | `CellMenu` | true               | Removes the selected record from the store                                     |
 * | `search`               | Search for value | 200    | `Search`   | false              | Searches the grid for the selected cell text                                   |
 * | `filterDateEquals`     | On               | 300    | `Filter`   | false              | Filters records in the store by the column field equal to selected cell value  |
 * | `filterDateBefore`     | Before           | 310    | `Filter`   | false              | Filters records in the store by the column field less than selected cell value |
 * | `filterDateAfter`      | After            | 320    | `Filter`   | false              | Filters records in the store by the column field more than selected cell value |
 * | `filterNumberEquals`   | Equals           | 300    | `Filter`   | false              | Filters records in the store by the column field equal to selected cell value  |
 * | `filterNumberLess`     | Less than        | 310    | `Filter`   | false              | Filters records in the store by the column field less than selected cell value |
 * | `filterNumberMore`     | More than        | 320    | `Filter`   | false              | Filters records in the store by the column field more than selected cell value |
 * | `filterDurationEquals` | Equals           | 300    | `Filter`   | false              | Filters records in the store by the column field equal to selected cell value  |
 * | `filterDurationLess`   | Less than        | 310    | `Filter`   | false              | Filters records in the store by the column field less than selected cell value |
 * | `filterDurationMore`   | More than        | 320    | `Filter`   | false              | Filters records in the store by the column field more than selected cell value |
 * | `filterStringEquals`   | Equals           | 300    | `Filter`   | false              | Filters records in the store by the column field equal to selected cell value  |
 * | `filterRemove`         | Remove filter    | 400    | `Filter`   | false              | Stops filtering by selected column field                                       |
 *
 * ### Customizing the menu items
 *
 * The menu items in the Cell menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * Add extra items for all columns:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     cellMenu : {
 *       items : {
 *          extraItem : { text: 'My cell item', icon: 'fa fa-bus', weight: 200, onItem : () => ... }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * It is also possible to add items using columns config. See examples below.
 *
 * Add extra items for a single column:
 *
 * ```javascript
 * const grid = new Grid({
 *   columns: [
 *     {
 *       field: 'city',
 *       text: 'City',
 *       cellMenuItems: {
 *         columnItem : { text: 'My unique cell item', icon: 'fa fa-beer', onItem : () => ... }
 *       }
 *     }
 *   ]
 * });
 * ```
 *
 * Remove existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         cellMenu : {
 *             items : {
 *                 removeRow : false
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Customize existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         cellMenu : {
 *             items : {
 *                 removeRow : {
 *                     text : 'Throw away',
 *                     icon : 'b-fa b-fa-dumpster'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * It is also possible to manipulate the default items and add new items in the processing function:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     cellMenu : {
 *       processItems({items, record}) {
 *           if (record.cost > 5000) {
 *              items.myItem = { text : 'Split cost' };
 *           }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the ["Customizing the Cell menu and the Header menu"](#guides/customization/contextmenu.md)
 * guide.
 *
 * This feature is **enabled** by default.
 *
 * @extends Grid/feature/base/ContextMenuBase
 * @demo Grid/filtering
 * @classtype cellMenu
 * @externalexample feature/CellMenu.js
 */

var CellMenu = /*#__PURE__*/function (_ContextMenuBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(CellMenu, _ContextMenuBase);

  var _super = _createSuper(CellMenu);

  function CellMenu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, CellMenu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(CellMenu, [{
    key: "showContextMenu",
    //endregion
    //region Events

    /**
     * Fired from grid before the context menu is shown for a cell.
     * Allows manipulation of the items to show in the same way as in the {@link Grid.feature.base.ContextMenuBase#config-processItems}.
     *
     * Returning `false` from a listener prevents the menu from being shown.
     *
     * @event cellMenuBeforeShow
     * @preventable
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} items Menu item configs
     * @param {Grid.column.Column} column Column
     * @param {Core.data.Model} record Record
     */

    /**
     * Fired from grid after the context menu is shown for a cell.
     * @event cellMenuShow
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} items Menu item configs
     * @param {Grid.column.Column} column Column
     * @param {Core.data.Model} record Record
     */

    /**
     * Fired from grid when an item is selected in the cell context menu.
     * @event cellMenuItem
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} item Selected menu item
     * @param {Grid.column.Column} column Column
     * @param {Core.data.Model} record Record
     */

    /**
     * Fired from grid when a check item is toggled in the cell context menu.
     * @event cellMenuToggleItem
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} item Selected menu item
     * @param {Grid.column.Column} column Column
     * @param {Core.data.Model} record Record
     * @param {Boolean} checked Checked or not
     */
    //endregion
    //region Menu handlers
    value: function showContextMenu(eventParams) {
      var me = this,
          cellSelector = eventParams.cellSelector,
          id = eventParams.id,
          event = eventParams.event; // Process the gesture as navigation so that the use may select/multiselect
      // the items to include in their context menu operation.
      // Also select if not already selected.

      me.client.focusCell(cellSelector, {
        doSelect: !me.client.isSelected(id),
        event: event
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(CellMenu.prototype), "showContextMenu", this).call(this, eventParams);
    }
  }, {
    key: "shouldShowMenu",
    value: function shouldShowMenu(_ref) {
      var column = _ref.column;
      return column && column.enableCellContextMenu !== false;
    }
  }, {
    key: "getDataFromEvent",
    value: function getDataFromEvent(event) {
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].assign(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(CellMenu.prototype), "getDataFromEvent", this).call(this, event), this.client.getCellDataFromEvent(event));
    }
  }, {
    key: "beforeContextMenuShow",
    value: function beforeContextMenuShow(eventParams) {
      if (!eventParams.record || eventParams.record.isSpecialRow) {
        eventParams.items.removeRow = false;
      }
    } //endregion
    //region Getters/Setters

  }, {
    key: "populateCellMenu",
    value: function populateCellMenu(_ref2) {
      var items = _ref2.items,
          column = _ref2.column;
      var client = this.client;

      if (column === null || column === void 0 ? void 0 : column.cellMenuItems) {
        if (Array.isArray(column.cellMenuItems)) {
          _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].deprecate('Grid', '5.0.0', '`cellMenuItems` column config specified as an array is deprecated, need to specify the config as a named object. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.');
        } // Array works smoothly since number index turns into a key for named object


        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].merge(items, column.cellMenuItems);
      }

      if (!client.readOnly) {
        items.removeRow = {
          text: client.selectedRecords.length > 1 ? 'L{removeRows}' : 'L{removeRow}',
          localeClass: this,
          icon: 'b-fw-icon b-icon-trash',
          name: 'removeRow',
          cls: 'b-separator',
          weight: 100,
          onItem: function onItem() {
            return client.store.remove(client.selectedRecords);
          }
        };

        if (!client.showRemoveRowInContextMenu) {
          _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].deprecate('Grid', '5.0.0', '`showRemoveRowInContextMenu` config is deprecated, in favor of `CellMenu` feature configuration. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.');
          items.removeRow = false;
        }
      }
    }
  }, {
    key: "showMenu",
    get: function get() {
      return true;
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'CellMenu';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        type: 'cell'
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      var config = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(CellMenu), "pluginConfig", this);

      config.chain.push('populateCellMenu');
      return config;
    }
  }]);

  return CellMenu;
}(_Grid_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


CellMenu.featureClass = '';
CellMenu._$name = 'CellMenu';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(CellMenu, true, ['Grid', 'Scheduler']);
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(CellMenu, false, ['Gantt']);

/***/ }),

/***/ "./lib/Grid/feature/CellTooltip.js":
/*!*****************************************!*\
  !*** ./lib/Grid/feature/CellTooltip.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CellTooltip; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Grid/feature/CellTooltip
 */

/**
 * Displays a tooltip when hovering cells. Contents can be customized by specifying a global `tooltipRenderer` function
 * for the feature and/or on a per column basis.
 *
 * Configuration properties passed into this feature are used to configure the {@link Core.widget.Tooltip} instance
 * used.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * ## Showing async content
 * Showing remotely loaded content is super easy using the {@link #config-tooltipRenderer}:
 *
 * ```javascript
 * // Async tooltip with some custom settings
 * let grid = new Grid({
 *   features: {
 *     cellTooltip: {
 *       // Time that mouse needs to be over cell before tooltip is shown
 *       hoverDelay : 4000,
 *       // Time after mouse out to hide the tooltip, 0 = instantly
 *       hideDelay  : 0,
 *       // Async tooltip renderer, return a Promise which yields the text content
 *       tooltipRenderer({ record, tip }) => AjaxHelper.get(`tooltip.php?id=${record.id}`).then(response => response.text())
 *     }
 *   }
 * });
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // Column with its own tooltip renderer
 * {
 *   text            : 'Name',
 *   field           : 'name',
 *   tooltipRenderer : ({ record }) => `My name is\xa0<b>${record.name}</b>`
 * }
 *
 * @demo Grid/celltooltip
 * @classtype cellTooltip
 * @externalexample feature/CellTooltip.js
 */

var CellTooltip = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(CellTooltip, _InstancePlugin);

  var _super = _createSuper(CellTooltip);

  function CellTooltip() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CellTooltip);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(CellTooltip, [{
    key: "construct",
    //endregion
    // region Init
    value: function construct(grid, config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(CellTooltip.prototype), "construct", this).call(this, grid, me.processConfig(config));
    }
  }, {
    key: "initTip",
    value: function initTip() {
      var me = this;
      me.tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_10__["default"](Object.assign({
        forElement: me.client.element,
        forSelector: '.b-grid-cell',
        hoverDelay: 1000,
        trackMouse: false,
        cls: 'b-celltooltip-tip',
        getHtml: me.getTooltipContent.bind(me),
        listeners: {
          pointerOver: 'onPointerOver',
          thisObj: me
        }
      }, me.initialConfig));
      me.relayEvents(me.tip, ['beforeshow', 'show']);
    }
  }, {
    key: "onPointerOver",
    value: function onPointerOver(_ref) {
      var target = _ref.target;
      var column = this.client.getColumnFromElement(target); // Veto onPointerOver if column's tooltipRenderer is false

      return column.tooltipRenderer !== false;
    } // CellTooltip feature handles special config cases, where user can supply a function to use as tooltipRenderer
    // instead of a normal config object

  }, {
    key: "processConfig",
    value: function processConfig(config) {
      if (typeof config === 'function') {
        return {
          tooltipRenderer: config
        };
      }

      return config;
    } // override setConfig to process config before applying it (used mainly from ReactGrid)

  }, {
    key: "setConfig",
    value: function setConfig(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(CellTooltip.prototype), "setConfig", this).call(this, this.processConfig(config));
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.tip && this.tip.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(CellTooltip.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      if (!disable) {
        this.initTip();
      } else if (this.tip) {
        this.tip.destroy();
        this.tip = null;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(CellTooltip.prototype), "doDisable", this).call(this, disable);
    } //endregion
    //region Content

    /**
     * Called from Tooltip to populate it with html.
     * @private
     */

  }, {
    key: "getTooltipContent",
    value: function getTooltipContent(_ref2) {
      var tip = _ref2.tip,
          cellElement = _ref2.activeTarget,
          event = _ref2.event;
      var me = this,
          record = me.client.getRecordFromElement(cellElement),
          column = me.client.getColumnFromElement(cellElement);
      var result; // If we have not changed context, we should not change content, unless we have a custom target selector (element within the cell)

      if (!me.forSelector && record === me.lastRecord && column === me.lastColumn) {
        return me.tip._html;
      }

      me.lastRecord = record;
      me.lastColumn = column; // first, use columns tooltipRenderer if any

      if (column.tooltipRenderer) {
        result = column.tooltipRenderer({
          cellElement: cellElement,
          record: record,
          column: column,
          event: event,
          tip: tip,
          cellTooltip: me
        });

        if (result === false) {
          _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].deprecate('Grid', '5.0.0', 'Returning false to indicate loading is deprecated. Please see https://bryntum.com/docs/grid/#guides/upgrades/3.0.1.md for more information');
        }
      } // secondly, try features renderer (but specifying column.tooltipRenderer as false prevents tooltip in that column)
      else if (me.tooltipRenderer && column.tooltipRenderer !== false) {
          result = me.tooltipRenderer({
            cellElement: cellElement,
            record: record,
            column: column,
            event: event,
            tip: tip,
            cellTooltip: me
          });

          if (result === false) {
            _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].deprecate('Grid', '5.0.0', 'Returning false to indicate loading is deprecated. Please see https://bryntum.com/docs/grid/#guides/upgrades/3.0.1.md for more information');
          }
        }

      return result;
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'CellTooltip';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Function called to generate the HTML content for the cell tooltip. The function should return a string (your HTML), or a Promise yielding a string (for remotely loaded content)
         * @config {Function}
         * @param {Object} context
         * @param {HTMLElement} context.cellElement The cell element
         * @param {Core.data.Model} context.record The row record
         * @param {Grid.column.Column} context.column The column
         * @param {Core.widget.Tooltip} context.tip The Tooltip instance
         * @param {Grid.feature.CellTooltip} context.cellTooltip The feature
         * @param {Event} context.event The raw DOM event
         * @return {String|Promise}
         */
        tooltipRenderer: null
      };
    }
  }]);

  return CellTooltip;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


CellTooltip._$name = 'CellTooltip';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(CellTooltip);

/***/ }),

/***/ "./lib/Grid/feature/ColumnAutoWidth.js":
/*!*********************************************!*\
  !*** ./lib/Grid/feature/ColumnAutoWidth.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnAutoWidth; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");




















function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var storeListenerName = 'store';
/**
 * @module Grid/feature/ColumnAutoWidth
 */

/**
 * Enables the {@link Grid.column.Column#config-autoWidth} config for a grid's columns.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 * @mixes Core/mixin/Delayable
 *
 * @classtype columnAutoWidth
 */

var ColumnAutoWidth = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(ColumnAutoWidth, _Delayable);

  var _super = _createSuper(ColumnAutoWidth);

  function ColumnAutoWidth() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, ColumnAutoWidth);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(ColumnAutoWidth, [{
    key: "construct",
    value: function construct(config) {
      var _this$client;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(ColumnAutoWidth.prototype), "construct", this).call(this, config);

      var store = (_this$client = this.client) === null || _this$client === void 0 ? void 0 : _this$client.store; // The initial bindStore can come super early such that our hooks won't catch it:

      if (store) {
        this.bindStore(store);
      }
    } //region Config

  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.unbindStore();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(ColumnAutoWidth.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "bindStore",
    value: function bindStore(store) {
      this.lastSync = null;
      store.on(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()({
        name: storeListenerName
      }, "change".concat(this.client.asyncEventSuffix), 'onStoreChange'), this);
    }
  }, {
    key: "unbindStore",
    value: function unbindStore() {
      this.detachListeners(storeListenerName);
    }
  }, {
    key: "onStoreChange",
    value: function onStoreChange(_ref) {
      var action = _ref.action;

      if (action !== 'move') {
        ++this.storeGeneration;

        if (!this.hasTimeout('syncAutoWidthColumns')) {
          this.setTimeout('syncAutoWidthColumns', this.delay);
        }
      }
    }
  }, {
    key: "syncAutoWidthColumns",
    value: function syncAutoWidthColumns() {
      var me = this,
          grid = me.client,
          storeGeneration = me.storeGeneration;

      if (me.lastSync !== storeGeneration) {
        me.lastSync = storeGeneration;
        var autoWidth, resizingColumns;

        var _iterator = _createForOfIteratorHelper(grid.columns.visibleColumns),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var column = _step.value;
            autoWidth = column.autoWidth;

            if (autoWidth) {
              if (autoWidth === true) {
                autoWidth = me.default;
              }

              grid.resizingColumns = resizingColumns = true;
              column.resizeToFitContent(autoWidth);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (resizingColumns) {
          grid.resizingColumns = false;
          grid.afterColumnsResized();
        }
      }

      if (me.hasTimeout('syncAutoWidthColumns')) {
        me.clearTimeout('syncAutoWidthColumns');
      }
    } //endregion

  }, {
    key: "columnAutoWidthPending",
    get: function get() {
      return this.lastSync === null || this.hasTimeout('syncAutoWidthColumns');
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ColumnAutoWidth';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The default `autoWidth` option for columns with `autoWidth: true`. This can
         * be a single number for the minimum column width, or an array of two numbers
         * for the `[minWidth, maxWidth]`.
         * @config {Number|Number[]}
         */
        default: null,

        /**
         * The amount of time (in milliseconds) to delay after a store modification
         * before synchronizing `autoWidth` columns.
         * @config {Number}
         * @default
         */
        delay: 0
      };
    } //endregion
    //region Internals

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        after: {
          bindStore: 'bindStore',
          unbindStore: 'unbindStore',
          renderRows: 'syncAutoWidthColumns'
        },
        assign: ['columnAutoWidthPending', 'syncAutoWidthColumns']
      };
    }
  }]);

  return ColumnAutoWidth;
}(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_21__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_19__["default"]));


ColumnAutoWidth.prototype.storeGeneration = 0;
ColumnAutoWidth._$name = 'ColumnAutoWidth';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_20__["default"].registerFeature(ColumnAutoWidth, true);

/***/ }),

/***/ "./lib/Grid/feature/ColumnDragToolbar.js":
/*!***********************************************!*\
  !*** ./lib/Grid/feature/ColumnDragToolbar.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnDragToolbar; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");

















function _templateObject3() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9___default()(["\n                        <div class=\"b-target-button\" data-name=\"", "\" data-disabled=\"", "\">\n                            <i class=\"", "\"></i>\n                            ", "\n                        </div>\n                    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9___default()(["\n                <div class=\"b-group\">\n                    <div class=\"b-buttons\">\n                    ", "\n                    </div>\n                    <div class=\"b-title\">", "</div>\n                </div>\n            "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9___default()(["\n            <div class=\"b-columndragtoolbar\">     \n            <div class=\"b-title\"></div>          \n            ", "\n            </div>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Grid/feature/ColumnDragToolbar
 */

/**
 * Displays a toolbar while dragging column headers. Drop on a button in the toolbar to activate a certain function,
 * for example to group by that column. This feature simplifies certain operations on touch devices.
 *
 * This feature is <strong>disabled</strong> by default, but turned on automatically on touch devices.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @classtype columnDragToolbar
 * @externalexample feature/ColumnDragToolbar.js
 * @demo Grid/columndragtoolbar
 */

var ColumnDragToolbar = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ColumnDragToolbar, _Delayable);

  var _super = _createSuper(ColumnDragToolbar);

  function ColumnDragToolbar() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, ColumnDragToolbar);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(ColumnDragToolbar, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(grid, config) {
      if (grid.features.columnReorder) {
        grid.features.columnReorder.on('beforedestroy', this.onColumnReorderBeforeDestroy, this);
      }

      this.grid = grid;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ColumnDragToolbar.prototype), "construct", this).call(this, grid, config);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this;

      if (me.grid.features.columnReorder && !me.grid.features.columnReorder.isDestroyed) {
        me.detachFromColumnReorder();
      }

      me.element && me.element.remove();
      me.element = null;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ColumnDragToolbar.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      if (this.initialized) {
        if (disable) {
          this.detachFromColumnReorder();
        } else {
          this.init();
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ColumnDragToolbar.prototype), "doDisable", this).call(this, disable);
    }
  }, {
    key: "init",
    value: function init() {
      var me = this,
          grid = me.grid;

      if (!grid.features.columnReorder) {
        return;
      }

      me.reorderDetacher = grid.features.columnReorder.on({
        gridheaderdragstart: function gridheaderdragstart(_ref) {
          var context = _ref.context;
          var column = grid.columns.getById(context.element.dataset.columnId);
          me.showToolbar(column);
        },
        gridheaderdrag: function gridheaderdrag(_ref2) {
          var context = _ref2.context;
          return me.onDrag(context);
        },
        gridheaderabort: function gridheaderabort() {
          me.hideToolbar();
        },
        gridheaderdrop: function gridheaderdrop(_ref3) {
          var context = _ref3.context;

          if (context.valid) {
            me.hideToolbar();
          } else {
            me.onDrop(context);
          }
        },
        thisObj: me
      });
      me.initialized = true;
    }
  }, {
    key: "onColumnReorderBeforeDestroy",
    value: function onColumnReorderBeforeDestroy() {
      this.detachFromColumnReorder();
    }
  }, {
    key: "detachFromColumnReorder",
    value: function detachFromColumnReorder() {
      var me = this;
      me.grid.features.columnReorder.un('beforedestroy', me.onColumnReorderBeforeDestroy, me);
      me.reorderDetacher && me.reorderDetacher();
      me.reorderDetacher = null;
    }
    /**
     * Initializes this feature on grid render.
     * @private
     */

  }, {
    key: "render",
    value: function render() {
      if (!this.initialized) {
        this.init();
      }
    } //endregion
    //region Toolbar

  }, {
    key: "showToolbar",
    value: function showToolbar(column) {
      var me = this,
          buttons = me.grid.getColumnDragToolbarItems(column, []),
          groups = [];
      me.clearTimeout(me.buttonHideTimer);
      me.clearTimeout(me.toolbarHideTimer);
      buttons.forEach(function (button) {
        button.text = button.localeClass.L(button.text);
        var group = groups.find(function (group) {
          return group.text === button.group;
        });

        if (!group) {
          group = {
            text: button.localeClass.L(button.group),
            buttons: []
          };
          groups.push(group);
        }

        group.buttons.push(button);
      });
      me.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].append(me.grid.element, me.template(groups));
      me.groups = groups;
      me.buttons = buttons;
      me.column = column;
    }
  }, {
    key: "hideToolbar",
    value: function hideToolbar() {
      var me = this;
      return new Promise(function (resolve) {
        if (me.element && !me.toolbarHideTimer) {
          me.element.classList.add('b-remove'); // TODO: use AnimationHelper when available

          me.toolbarHideTimer = me.setTimeout(function () {
            me.toolbarHideTimer = null;
            me.element && me.element.remove();
            me.element = null;
            resolve();
          }, 200);
        }
      });
    } //endregion
    //region Events

  }, {
    key: "onDrag",
    value: function onDrag(info) {
      var me = this;

      if (info.dragProxy.getBoundingClientRect().top - me.grid.element.getBoundingClientRect().top > 100) {
        me.element.classList.add('b-closer');
      } else {
        me.element.classList.remove('b-closer');
      }

      if (me.hoveringButton) {
        me.hoveringButton.classList.remove('b-hover');
        me.hoveringButton = null;
      }

      if (info.targetElement && info.targetElement.closest('.b-columndragtoolbar')) {
        me.element.classList.add('b-hover');
        var button = info.targetElement.closest('.b-columndragtoolbar  .b-target-button:not([data-disabled=true])');

        if (button) {
          button.classList.add('b-hover');
          me.hoveringButton = button;
        }
      } else {
        me.element.classList.remove('b-hover');
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(info) {
      var me = this;

      if (info.targetElement && info.targetElement.matches('.b-columndragtoolbar .b-target-button:not([data-disabled=true])')) {
        var buttonEl = info.targetElement,
            button = me.buttons.find(function (button) {
          return button.name === buttonEl.dataset.name;
        });

        if (button) {
          buttonEl.classList.add('b-activate');
          me.buttonHideTimer = me.setTimeout(function () {
            me.hideToolbar();
            button.onDrop({
              column: me.column
            });
          }, 100);
        }
      } else {
        me.hideToolbar();
      }
    } //endregion

  }, {
    key: "template",
    value: function template(groups) {
      return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].tpl(_templateObject(), groups.map(function (group) {
        return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].tpl(_templateObject2(), group.buttons.map(function (btn) {
          return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].tpl(_templateObject3(), btn.name, btn.disabled, btn.icon, btn.text);
        }), group.text);
      }));
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ColumnDragToolbar';
    } // Plugin configuration. This plugin chains some of the functions in Grid

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        after: ['render']
      };
    }
  }]);

  return ColumnDragToolbar;
}(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_20__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_16__["default"]));


ColumnDragToolbar.featureClass = 'b-hascolumndragtoolbar'; // used by default on touch devices, can be enabled otherwise

ColumnDragToolbar._$name = 'ColumnDragToolbar';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_17__["default"].registerFeature(ColumnDragToolbar, _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isTouchDevice);

/***/ }),

/***/ "./lib/Grid/feature/ColumnPicker.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/ColumnPicker.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnPicker; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");





















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/feature/ColumnPicker
 */

/**
 * Displays a column picker (to show/hide columns) in the header context menu. Columns can be displayed in sub menus
 * by region or tag. Grouped headers are displayed as menu hierarchies.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/columns
 * @classtype columnPicker
 * @externalexample feature/ColumnPicker.js
 */

var ColumnPicker = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default()(ColumnPicker, _InstancePlugin);

  var _super = _createSuper(ColumnPicker);

  function ColumnPicker() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, ColumnPicker);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(ColumnPicker, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(grid, config) {
      this.grid = grid;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(ColumnPicker.prototype), "construct", this).call(this, grid, config);
    } //endregion
    //region Context menu

    /**
     * Get menu items, either a straight list of columns or sub menus per subgrid
     * @private
     * @param columnStore Column store to traverse
     * @returns {Object[]} Menu item configs
     */

  }, {
    key: "getColumnPickerItems",
    value: function getColumnPickerItems(columnStore) {
      var me = this;

      if (me.groupByRegion) {
        // submenus for grids regions
        return me.grid.regions.map(function (region) {
          var columns = me.grid.getSubGrid(region).columns.topColumns;
          return {
            text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].capitalize(region),
            menu: me.buildColumnMenu(columns),
            disabled: columns.length === 0,
            region: region
          };
        });
      } else if (me.groupByTag) {
        // submenus for column tags
        var tags = {};
        columnStore.topColumns.forEach(function (column) {
          column.tags && column.hideable && column.tags.forEach(function (tag) {
            if (!tags[tag]) {
              tags[tag] = 1;
            }
          });
        }); // TODO: as checkitems, but how to handle toggling? hide a column only when all tags for it are unchecked?

        return Object.keys(tags).sort().map(function (tag) {
          return {
            text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].capitalize(tag),
            menu: me.buildColumnMenu(me.getColumnsForTag(tag)),
            tag: tag,
            onBeforeSubMenu: function onBeforeSubMenu(_ref) {
              var item = _ref.item,
                  itemEl = _ref.itemEl;
              me.refreshTagMenu(item, itemEl);
            }
          };
        });
      } else {
        // all columns in same menu
        return me.buildColumnMenu(columnStore.topColumns);
      }
    }
    /**
     * Get all columns that has the specified tag
     * TODO: if tags are useful from somewhere else, move to ColumnStore
     * @private
     * @param tag
     * @returns {Grid.column.Column[]}
     */

  }, {
    key: "getColumnsForTag",
    value: function getColumnsForTag(tag) {
      // TODO: if tags are usefull from somewhere else, move to ColumnStore
      return this.grid.columns.records.filter(function (column) {
        return column.tags && column.tags.includes(tag) && column.hideable !== false;
      });
    }
    /**
     * Refreshes checked status for a tag menu. Needed since columns can appear under multiple tags.
     * @private
     */

  }, {
    key: "refreshTagMenu",
    value: function refreshTagMenu(item, itemEl) {
      var columns = this.getColumnsForTag(item.tag);
      columns.forEach(function (column) {
        var subItem = item.items.find(function (subItem) {
          return subItem.column === column;
        });
        if (subItem) subItem.checked = column.hidden !== true;
      });
    }
    /**
     * Traverses columns to build menu items for the column picker.
     * @private
     */

  }, {
    key: "buildColumnMenu",
    value: function buildColumnMenu(columns) {
      var _this = this;

      var currentRegion = columns.length > 0 && columns[0].region;
      var grid = this.grid;
      return columns.reduce(function (items, column) {
        var visibleInRegion = _this.grid.columns.visibleColumns.filter(function (col) {
          return col.region === column.region;
        });

        if (column.hideable !== false) {
          var itemConfig = {
            grid: grid,
            text: column.text,
            column: column,
            name: column.id,
            checked: column.hidden !== true,
            disabled: column.hidden !== true && visibleInRegion.length === 1,
            cls: column.region !== currentRegion ? 'b-separator' : ''
          };
          currentRegion = column.region;

          if (column.children) {
            itemConfig.menu = _this.buildColumnMenu(column.children);
          }

          items.push(itemConfig);
        }

        return items;
      }, []);
    }
    /**
     * Populates the header context menu items.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateHeaderMenu",
    value: function populateHeaderMenu(_ref2) {
      var column = _ref2.column,
          items = _ref2.items;
      var me = this,
          columns = me.grid.columns;

      if (column.showColumnPicker !== false && columns.some(function (col) {
        return col.hideable;
      })) {
        // column picker
        items.columnPicker = {
          text: 'L{columnsMenu}',
          localeClass: me,
          name: 'columnPicker',
          icon: 'b-fw-icon b-icon-columns',
          cls: 'b-separator',
          weight: 200,
          menu: me.getColumnPickerItems(columns),
          onToggle: me.onColumnToggle,
          disabled: me.disabled
        };
      } // menu item for hiding this column


      if (column.hideable !== false) {
        var visibleInRegion = columns.visibleColumns.filter(function (col) {
          return col.region === column.region;
        });
        items.hideColumn = {
          text: 'L{hideColumn}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-hide-column',
          weight: 210,
          name: 'hideColumn',
          disabled: visibleInRegion.length === 1 || me.disabled,
          onItem: function onItem() {
            return column.hide();
          }
        };
      }
    }
    /**
     * Handler for column hide/show menu checkitems.
     * @private
     * @param {Object} event The {@link Core.widget.MenuItem#event-toggle} event.
     */

  }, {
    key: "onColumnToggle",
    value: function onColumnToggle(_ref3) {
      var menu = _ref3.menu,
          item = _ref3.item,
          checked = _ref3.checked;

      if (!!item.column.hidden !== !checked) {
        item.column[checked ? 'show' : 'hide']();
        var grid = item.grid,
            column = item.column,
            columns = grid.columns,
            features = grid.features,
            siblingItems = menu.items,
            visibleInRegion = columns.visibleColumns.filter(function (col) {
          return col.region === item.column.region;
        }),
            contextMenu = features.contextMenu,
            headerMenu = features.headerMenu,
            isOldFeatureUsed = contextMenu && !contextMenu.disabled,
            contextMenuFeature = isOldFeatureUsed ? contextMenu : headerMenu,
            mainMenu = contextMenuFeature && contextMenuFeature[isOldFeatureUsed ? 'currentMenu' : 'menu'],
            hideItem = isOldFeatureUsed ? mainMenu.items.find(function (item) {
          return item.name === 'hideColumn';
        }) : mainMenu.widgetMap.hideColumn; // Do not allow user to hide the last column in any region

        if (visibleInRegion.length === 1) {
          var lastVisibleItem = siblingItems.find(function (i) {
            return i.name === visibleInRegion[0].id;
          });

          if (lastVisibleItem) {
            lastVisibleItem.disabled = true;
          } // Also disable "Hide column" item if only one column left in this region


          if (hideItem && column.region === item.column.region) {
            hideItem.disabled = true;
          }
        } // Multiple columns visible, enable "hide-column" and all items for that region
        else {
            visibleInRegion.forEach(function (col) {
              var siblingItem = siblingItems.find(function (sibling) {
                return sibling.column === col;
              });

              if (siblingItem) {
                siblingItem.disabled = false;
              }
            });

            if (hideItem && column.region === item.column.region) {
              hideItem.disabled = false;
            }
          }

        if (item.menu) {
          // Reflect status in submenu.
          // Cannot use short form () => foo because eachWidget aborts on return of false
          item.menu.eachWidget(function (subItem) {
            subItem.checked = checked;
          });
        }

        var parentItem = menu.owner;

        if (parentItem && parentItem.column === column.parent) {
          parentItem.checked = siblingItems.some(function (subItem) {
            return subItem.checked === true;
          });
        }
      }
    }
    /**
     * Supply items to ColumnDragToolbar
     * @private
     */

  }, {
    key: "getColumnDragToolbarItems",
    value: function getColumnDragToolbarItems(column, items) {
      var visibleInRegion = this.grid.columns.visibleColumns.filter(function (col) {
        return col.region === column.region;
      });

      if (column.hideable !== false && visibleInRegion.length > 1) {
        items.push({
          text: 'L{hideColumnShort}',
          group: 'L{column}',
          localeClass: this,
          icon: 'b-fw-icon b-icon-hide-column',
          weight: 101,
          name: 'hideColumn',
          onDrop: function onDrop(_ref4) {
            var column = _ref4.column;
            return column.hide();
          }
        });
      }

      return items;
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ColumnPicker';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Groups columns in the picker by region (each region gets its own sub menu)
         * @config {Boolean}
         * @default
         */
        groupByRegion: false,

        /**
         * Groups columns in the picker by tag, each column may be shown under multiple tags. See
         * {@link Grid.column.Column#config-tags}
         * @config {Boolean}
         * @default
         */
        groupByTag: false
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['populateHeaderMenu', 'getColumnDragToolbarItems']
      };
    }
  }]);

  return ColumnPicker;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_20__["default"]);


ColumnPicker._$name = 'ColumnPicker';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_22__["default"].registerFeature(ColumnPicker, true);

/***/ }),

/***/ "./lib/Grid/feature/ColumnReorder.js":
/*!*******************************************!*\
  !*** ./lib/Grid/feature/ColumnReorder.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnReorder; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Grid/feature/ColumnReorder
 */

/**
 * Allows user to reorder columns by dragging headers. To get notified about column reorder listen to `change` event
 * on {@link Grid.data.ColumnStore columns} store.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/columns
 * @classtype columnReorder
 * @externalexample feature/ColumnReorder.js
 */

var ColumnReorder = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ColumnReorder, _Delayable);

  var _super = _createSuper(ColumnReorder);

  function ColumnReorder() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ColumnReorder);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(ColumnReorder, [{
    key: "construct",
    value: function construct(grid, config) {
      this.ignoreSelectors = ['.b-grid-header-resize-handle', '.b-field'];
      this.grid = grid;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(ColumnReorder.prototype), "construct", this).call(this, grid, config);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.dragHelper && this.dragHelper.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(ColumnReorder.prototype), "doDestroy", this).call(this);
    }
    /**
     * Initialize drag & drop (called from render)
     * @private
     */

  }, {
    key: "init",
    value: function init() {
      var me = this,
          grid = me.grid,
          gridEl = grid.element,
          containers = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].children(gridEl, '.b-grid-headers');
      containers.push.apply(containers, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].children(gridEl, '.b-grid-header-children')));

      if (me.dragHelper) {
        // update the dragHelper with the new set of containers it should operate upon
        me.dragHelper.containers = containers;
      } else {
        me.dragHelper = new _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"]({
          name: 'columnReorder',
          mode: 'container',
          dragThreshold: 10,
          targetSelector: '.b-grid-header',
          outerElement: gridEl.querySelector('header.b-grid-header-container'),
          containers: containers,
          isElementDraggable: function isElementDraggable(element) {
            var abort = Boolean(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(element, me.ignoreSelectors.join(',')));

            if (abort || me.disabled) {
              return false;
            }

            var columnEl = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(element, this.targetSelector),
                column = columnEl && grid.columns.getById(columnEl.dataset.columnId),
                isLast = column && column.childLevel === 0 && grid.subGrids[column.region].columns.count === 1; // TODO: If we want to prevent dragging last column out of group we can use the code below...

            /*isLast = column.level !== 0
                    // In grouped header, do not allow dragging last remaining child
                    ? column.parent.children.length === 1
                    // Not in a grouped header, do not allow dragging last remaining column
                    : grid.subGrids[column.region].columns.count === 1;*/

            return Boolean(column) && column.draggable !== false && !isLast;
          },
          ignoreSelector: '.b-filter-icon,.b-grid-header-resize-handle',
          listeners: {
            dragstart: me.onDragStart,
            drag: me.onDrag,
            drop: me.onDrop,
            thisObj: me
          }
        });
        me.relayEvents(me.dragHelper, ['dragStart', 'drag', 'drop', 'abort'], 'gridHeader');
      }
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Grid

  }, {
    key: "onDrag",
    //endregion
    //region Events (drop)
    value: function onDrag(_ref) {
      var context = _ref.context,
          event = _ref.event;
      var me = this,
          targetHeader = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_16__["default"].fromElement(event.target, 'gridheader'); // If SubGrid is configured with a sealed column set, do not allow moving into it

      if (targetHeader && targetHeader.subGrid.sealedColumns) {
        context.valid = false;
        return;
      } // Require that we drag inside grid header while dragging if we don't have a drag toolbar


      if (!me.grid.features.columnDragToolbar) {
        context.valid = Boolean(event.target.closest('.b-grid-headers'));
      }
    }
  }, {
    key: "onDragStart",
    value: function onDragStart() {
      var me = this;

      if (!me.grid.features.columnDragToolbar) {
        var headerContainerBox = me.grid.element.querySelector('.b-grid-header-container').getBoundingClientRect();
        me.dragHelper.minY = headerContainerBox.top;
        me.dragHelper.maxY = headerContainerBox.bottom;
      }

      this.grid.headerContainer.classList.add('b-dragging-header');
    }
    /**
     * Handle drop
     * @private
     */

  }, {
    key: "onDrop",
    value: function onDrop(_ref2) {
      var context = _ref2.context;

      if (!context.valid) {
        return this.onInvalidDrop({
          context: context
        });
      }

      var me = this,
          grid = me.grid,
          element = context.dragging,
          onHeader = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(context.target, '.b-grid-header'),
          onColumn = grid.columns.get(onHeader.dataset.column),
          toRegion = context.draggedTo.dataset.region || onColumn.region,
          sibling = context.insertBefore,
          column = grid.columns.getById(element.dataset.columnId),
          insertBefore = sibling ? grid.columns.getById(sibling.dataset.columnId) : grid.subGrids[toRegion].columns.last.nextSibling,
          newParent = insertBefore ? insertBefore.parent : grid.columns.rootNode;
      grid.headerContainer.classList.remove('b-dragging-header'); // Dropped into its current position in the same SubGrid - abort

      if (toRegion === column.region && (onColumn === column.previousSibling || insertBefore === column.nextSibling)) {
        me.dragHelper.abort();
        return;
      } // Check if we should remove last child


      var emptyParent = column.parent && column.parent.children.length === 1 && column.parent;

      if (emptyParent) {
        emptyParent.parent.removeChild(emptyParent);
      } // Clean up element used during drag drop as it will not be removed by Grid when it refreshes its header elements


      element.remove();
      column.region = toRegion; // Insert the column into its new place

      newParent.insertChild(column, insertBefore);
    }
    /**
     * Handle invalid drop
     * @private
     */

  }, {
    key: "onInvalidDrop",
    value: function onInvalidDrop() {
      this.grid.headerContainer.classList.remove('b-dragging-header');
    } //endregion
    //region Render

    /**
     * Updates DragHelper with updated headers when grid contents is rerendered
     * @private
     */

  }, {
    key: "renderContents",
    value: function renderContents() {
      // columns shown, hidden or reordered
      this.init();
    }
    /**
     * Initializes this feature on grid render.
     * @private
     */

  }, {
    key: "render",
    value: function render() {
      // always reinit on render
      this.init();
    } //endregion

  }], [{
    key: "$name",
    //region Init
    get: function get() {
      return 'ColumnReorder';
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        after: ['render', 'renderContents']
      };
    }
  }]);

  return ColumnReorder;
}(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]));


ColumnReorder.featureClass = 'b-column-reorder';
ColumnReorder._$name = 'ColumnReorder';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(ColumnReorder, true);

/***/ }),

/***/ "./lib/Grid/feature/ColumnResize.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/ColumnResize.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnResize; });
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/ResizeHelper.js */ "./lib/Core/helper/ResizeHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Grid/feature/ColumnResize
 */

/**
 * Enables user to resize columns by dragging a handle on the righthand side of the header. To get notified about column
 * resize listen to `change` event on {@link Grid.data.ColumnStore columns} store.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/columns
 * @classtype columnResize
 * @externalexample feature/ColumnResize.js
 */

var ColumnResize = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ColumnResize, _InstancePlugin);

  var _super = _createSuper(ColumnResize);

  function ColumnResize() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ColumnResize);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ColumnResize, [{
    key: "construct",
    //region Init
    value: function construct(grid, config) {
      var me = this;
      me.grid = grid;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ColumnResize.prototype), "construct", this).call(this, grid, config);

      me.resizer = new _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
        name: 'columnResize',
        targetSelector: '.b-grid-header',
        handleSelector: '.b-grid-header-resize-handle',
        outerElement: grid.element,
        listeners: {
          beforeresizestart: me.onBeforeResizeStart,
          resizestart: me.onResizeStart,
          resizing: me.onResizing,
          resize: me.onResize,
          thisObj: me
        }
      });
    } //endregion
    // This plugin needs no functions chaining into the client grid

  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.resizer && this.resizer.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ColumnResize.prototype), "doDestroy", this).call(this);
    } //region Events

  }, {
    key: "onBeforeResizeStart",
    value: function onBeforeResizeStart() {
      return !this.disabled;
    }
  }, {
    key: "onResizeStart",
    value: function onResizeStart(_ref) {
      var context = _ref.context;
      var grid = this.grid,
          resizer = this.resizer,
          column = context.column = grid.columns.getById(context.element.dataset.columnId);
      resizer.minWidth = column.minWidth; // remove minWidth value as it's used as a rendering workaround for IE flexbox bugs

      context.element.style.minWidth = '';
      grid.element.classList.add('b-column-resizing');
    }
    /**
     * Handle drag event - resize the column live unless it's a touch gesture
     * @private
     */

  }, {
    key: "onResizing",
    value: function onResizing(_ref2) {
      var context = _ref2.context;

      if (context.valid && this.liveResize) {
        this.grid.resizingColumns = true;
        context.column.width = context.newWidth;
      }
    }
    /**
     * Handle drop event (only used for touch)
     * @private
     */

  }, {
    key: "onResize",
    value: function onResize(_ref3) {
      var context = _ref3.context;
      var grid = this.grid,
          column = context.column;
      grid.element.classList.remove('b-column-resizing');

      if (context.valid) {
        if (this.liveResize) {
          grid.resizingColumns = false;
          grid.afterColumnsResized();
        } else {
          column.width = context.newWidth;
        } // In case of IE 11 we should calculate flex basis to fix header width
        // covered by ColumnResize.t


        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isIE11 && column.parent && column.parent.flex) {
          var parent = column.parent,
              headerEl = grid.getHeaderElement(parent.id);
          headerEl.style.flexBasis = parent.children.reduce(function (result, column) {
            return result + grid.getHeaderElement(column.id).offsetWidth;
          }, 0) + 'px';
        }
      }
    } //endregion

  }, {
    key: "liveResize",
    set: function set(liveResize) {
      if (liveResize === 'auto') {
        liveResize = !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isMobileSafari;
      }

      this._liveResize = liveResize;
    },
    get: function get() {
      return this._liveResize;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ColumnResize';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Resize all cells below a resizing header during dragging.
         * `'auto'` means `true` on non-mobile platforms.
         * @config {String|Boolean}
         * @default
         */
        liveResize: 'auto'
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return [];
    }
  }]);

  return ColumnResize;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


ColumnResize._$name = 'ColumnResize';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(ColumnResize, true);

/***/ }),

/***/ "./lib/Grid/feature/ContextMenu.js":
/*!*****************************************!*\
  !*** ./lib/Grid/feature/ContextMenu.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ContextMenu; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/widget/MenuItem.js */ "./lib/Core/widget/MenuItem.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Grid/feature/ContextMenu
 */

/**
 * **DEPRECATED: This class is deprecated since v4.0.0,
 * use {@link Grid.feature.CellMenu CellMenu} feature for cell context menu and
 * {@link Grid.feature.HeaderMenu HeaderMenu} feature for header context menu instead.**
 *
 * Right click to display context menu for headers and cells.
 *
 * This feature is **disabled** by default in favor of `CellMenu` and `HeaderMenu`.
 *
 * @extends Core/mixin/InstancePlugin
 * @classtype contextMenu
 * @deprecated 4.0.0
 */

var ContextMenu = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(ContextMenu, _InstancePlugin);

  var _super = _createSuper(ContextMenu);

  function ContextMenu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ContextMenu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(ContextMenu, [{
    key: "construct",
    //endregion
    //region Events

    /**
     * Fired from grid before the context menu is shown for a header. Allows manipulation of the items
     * to show in the same way as in `processHeaderItems`. Returning false from a listener prevents the
     * menu from being shown.
     * @event headerContextMenuBeforeShow
     * @deprecated 4.0.0 Renamed to headerMenuBeforeShow
     * @preventable
     * @param {Grid.view.Grid} source
     * @param {Object} items Menu item configs
     * @param {Grid.column.Column} column Column
     */

    /**
     * Fired from grid after showing the context menu for a header
     * @event headerContextMenuShow
     * @deprecated 4.0.0 Renamed to headerMenuShow
     * @preventable
     * @param {Grid.view.Grid} source
     * @param {Core.widget.Menu} menu The menu
     * @param {Grid.column.Column} column Column
     */

    /**
     * Fired from grid before the context menu is shown for a cell. Allows manipulation of the items
     * to show in the same way as in `processCellItems`. Returning false from a listener prevents the
     * menu from being shown.
     * @event cellContextMenuBeforeShow
     * @deprecated 4.0.0 Renamed to cellMenuBeforeShow
     * @preventable
     * @param {Grid.view.Grid} source
     * @param {Object} items Menu item configs
     * @param {Grid.column.Column} column Column
     * @param {Core.data.Model} record Record
     */

    /**
     * Fired from grid after showing the context menu for a cell
     * @event cellContextMenuShow
     * @deprecated 4.0.0 Renamed to cellMenuShow
     * @preventable
     * @param {Grid.view.Grid} source
     * @param {Core.widget.Menu} menu The menu
     * @param {Grid.column.Column} column Column
     * @param {Core.data.Model} record Record
     */

    /**
     * Fired when an item is selected in the context menu.
     * @event contextMenuItem
     * @deprecated 4.0.0 Renamed to cellMenuItem and headerMenuItem
     * @param {Grid.view.Grid} grid The grid
     * @param {Object} item Selected menu item
     * @param {Grid.column.Column} column Column
     * @param {HTMLElement} itemEl Menu item element
     */

    /**
     * Fired when a check item is toggled in the context menu.
     * @event contextMenuToggleItem
     * @deprecated 4.0.0 Renamed to cellMenuToggleItem and headerMenuToggleItem
     * @param {Grid.view.Grid} grid The grid
     * @param {Object} item Selected menu item
     * @param {Grid.column.Column} column Column
     * @param {Boolean} checked Checked or not
     * @param {HTMLElement} itemEl Menu item element
     */
    //endregion
    //region Init
    value: function construct(grid, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(ContextMenu.prototype), "construct", this).call(this, grid, config);

      this.grid = grid;
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].deprecate('Grid', '5.0.0', '`ContextMenu` feature is deprecated, in favor of `CellMenu` and `HeaderMenu` features. Please see https://bryntum.com/docs/grid/#guides/upgrades/3.1.0.md for more information.'); // If this feature is enabled, need to disable CellMenu and HeaderMenu. They are mutually exclusive.

      if (grid.features.cellMenu) {
        grid.features.cellMenu.disabled = true;
      }

      if (grid.features.headerMenu) {
        grid.features.headerMenu.disabled = true;
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      if (this.currentMenu) {
        this.currentMenu.destroy();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(ContextMenu.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Grid.
    // The contextmenu event is emulated from a taphold gesture on touch platforms.

  }, {
    key: "onElementContextMenu",
    //endregion
    //region Events
    value: function onElementContextMenu(event) {
      this.triggerEvent === 'contextmenu' && this.showContextMenu(event);
    }
  }, {
    key: "onElementClick",
    value: function onElementClick(event) {
      this.triggerEvent === 'click' && this.showContextMenu(event);
    }
  }, {
    key: "onElementDblClick",
    value: function onElementDblClick(event) {
      this.triggerEvent === 'dblclick' && this.showContextMenu(event);
    }
  }, {
    key: "onElementKeyDown",
    value: function onElementKeyDown(event) {
      if (!event.handled && event.target.matches('.b-grid-header.b-depth-0')) {
        switch (event.key) {
          case ' ':
          case 'ArrowDown':
            this.showContextMenu(event);
            break;
        }
      }
    }
    /**
     * Show context menu.
     * @param event
     * @private
     */

  }, {
    key: "showContextMenu",
    value: function showContextMenu(event) {
      if (!this.disabled) {
        var header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].up(event.target, '.b-grid-header'),
            cellData = this.grid.getCellDataFromEvent(event);

        if (header) {
          this.handleHeaderContextMenu(header, event);
        } else if (cellData && !this.disableCellContextMenu) {
          this.handleCellContextMenu(cellData, event);
        }
      }
    }
  }, {
    key: "handleHeaderContextMenu",
    value: function handleHeaderContextMenu(header, event) {
      if (header.dataset.column) {
        var me = this,
            grid = me.grid,
            column = grid.columns.getById(header.dataset.columnId);

        if (column.enableHeaderContextMenu !== false) {
          var arrayOfItems = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default()(me.headerItems), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default()(column.headerMenuItems || [])),
              namedItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].transformArrayToNamedObject(arrayOfItems),
              menu = {
            owner: me.client,
            constrainTo: document,
            cls: 'b-context-menu',
            scrollAction: 'hide',
            onItem: function onItem(_ref) {
              var item = _ref.item,
                  element = _ref.element;
              grid.trigger('contextMenuItem', {
                source: grid,
                item: item,
                column: column,
                element: element
              });
            },
            onToggle: function onToggle(_ref2) {
              var item = _ref2.item,
                  checked = _ref2.checked,
                  element = _ref2.element;
              grid.trigger('contextMenuToggleItem', {
                source: grid,
                item: item,
                column: column,
                checked: checked,
                element: element
              });
            },
            onDestroy: function onDestroy() {
              // If menu is destroyed by WidgetHelper, make sure we don't keep a reference to it anymore
              me.currentMenu = null;
            },
            listeners: {
              show: function show(_ref3) {
                var menu = _ref3.source;
                eventParams.menu = menu;
                grid.trigger('headerContextMenuShow', eventParams);
              }
            }
          }; // `populateHeaderMenu` is chained by mixins, thus each feature can supply items

          grid.populateHeaderMenu({
            column: column,
            items: namedItems,
            menu: menu
          });
          var items = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].transformNamedObjectToArray(namedItems),
              processHeaderItems = me.processHeaderItems,
              eventParams = {
            items: items,
            column: column,
            event: event,
            element: header
          };
          _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].merge(menu, {
            items: items
          });

          if ((!processHeaderItems || processHeaderItems(eventParams) !== false) && items.length > 0) {
            event.preventDefault();
            items.sort(function (a, b) {
              return (a.weight || 150) - (b.weight || 150);
            }); // Trigger event that allows preventing menu or manipulating its items

            if (grid.trigger('headerContextMenuBeforeShow', eventParams) !== false) {
              // Align to header element when using arrow down key
              me.currentMenu = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].showContextMenu(event.type === 'keydown' ? header : [event.clientX + 1, event.clientY + 1], menu); // Propagate the operating column down to all MenuItem levels
              // Will not override if they are preconfigured with a column.

              me.currentMenu.eachWidget(function (item) {
                if (!item.column && item instanceof _Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_20__["default"]) {
                  item.column = column;
                }
              }, true);
            }
          }
        }
      }
    }
  }, {
    key: "handleCellContextMenu",
    value: function handleCellContextMenu(cellData, event) {
      var me = this,
          grid = me.grid,
          column = grid.columns.getById(cellData.columnId);

      if (column.enableCellContextMenu !== false) {
        // Process the gesture as navigation so that the use may select/multiselect
        // the items to include in their context menu operation.
        // Also select if not already selected.
        grid.focusCell(cellData.cellSelector, {
          doSelect: !grid.isSelected(cellData.id),
          event: event
        });
        var record = cellData.record,
            arrayOfItems = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default()(me.cellItems || []), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default()(column.cellMenuItems || [])),
            namedItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].transformArrayToNamedObject(arrayOfItems); // `populateCellMenu` is chained by mixins, thus each feature can supply items

        grid.populateCellMenu({
          column: column,
          record: record,
          items: namedItems
        });
        var items = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].transformNamedObjectToArray(namedItems),
            processCellItems = me.processCellItems,
            cell = cellData.cellElement,
            eventParams = {
          items: items,
          column: column,
          event: event,
          record: record,
          element: cell
        },
            menu = {
          owner: me.client,
          items: items,
          // Load up the item event with the contextual info
          onBeforeItem: function onBeforeItem(itemEvent) {
            Object.assign(itemEvent, eventParams);
          },
          onItem: function onItem(_ref4) {
            var item = _ref4.item;
            grid.trigger('contextMenuItem', {
              source: grid,
              item: item,
              column: column,
              record: record,
              cell: cell
            });
          },
          onClose: function onClose(_ref5) {
            var reason = _ref5.reason;

            // return focus to grid when context menu is closed, if not cause by clicking outside of grid
            if (reason !== 'outside') {
              grid.focus();
            }
          },
          onDestroy: function onDestroy() {
            // If menu is destroyed by WidgetHelper, make sure we don't keep a reference to it anymore
            me.currentMenu = null;
          },
          listeners: {
            show: function show(_ref6) {
              var menu = _ref6.source;
              eventParams.menu = menu;
              grid.trigger('cellContextMenuShow', eventParams);
            }
          }
        };

        if ((!processCellItems || processCellItems(eventParams) !== false) && items.length > 0) {
          items.forEach(function (item) {
            item.column = column;
            item.record = record;
          });
          event.preventDefault();
          items.sort(function (a, b) {
            return (a.weight || 150) - (b.weight || 150);
          }); // Trigger event that allows preventing menu or manipulating its items

          if (grid.trigger('cellContextMenuBeforeShow', eventParams) !== false) {
            me.currentMenu = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].showContextMenu([event.clientX + 1, event.clientY + 1], menu);
          }
        }
      }
    }
    /**
     * Hides the context menu
     * @internal
     */

  }, {
    key: "hideContextMenu",
    value: function hideContextMenu(animate) {
      this.currentMenu && this.currentMenu.hide(animate);
    } //endregion
    //region Getters/Setters

  }, {
    key: "triggerEvent",
    get: function get() {
      return this._triggerEvent || this.client.contextMenuTriggerEvent;
    },
    set: function set(value) {
      this._triggerEvent = value;
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ContextMenu';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Extra items to add to the header context menu. See {@link Core.widget.MenuItem} for more info.
         *
         * ```javascript
         * features : {
         *     contextMenu : {
         *         headerItems : [
         *             { text : 'Header item', onItem : () => ... }
         *         ]
         *     }
         * }
         * ```
         *
         * @config {Object[]}
         */
        headerItems: [],

        /**
         * A function called before displaying the header menu that allows manipulations of its items. Called with a
         * single parameter with format { column, items }. Returning `false` from this function prevents
         * the menu from being shown.
         *
         * ```javascript
         * features : {
         *     contextMenu : {
         *         processHeaderItems({record, items}) {
         *             // Add or remove items here as needed
         *             if (column.field === 'age') {
         *                 items.push({ text: 'Hide youngsters', icon : 'b-fa b-fa-fw b-fa-baby' })
         *             }
         *         }
         *     }
         * }
         * ```
         *
         * @config {Function}
         */
        processHeaderItems: null,

        /**
         * Extra items to add to the cell context menu. See {@link Core.widget.MenuItem} for more info.
         *
         * ```javascript
         * features : {
         *     contextMenu : {
         *         cellItems : [
         *             { text : 'Cell item', onItem : () => ... }
         *         ]
         *     }
         * }
         * ```
         *
         * @config {Object[]}
         */
        cellItems: [],

        /**
         * A function called before displaying the cell menu that allows manipulations of its items. Called with a
         * single parameter with format { record, items }. Returning `false` from this function prevents
         * the menu from being shown.
         *
         * ```javascript
         * features : {
         *     contextMenu : {
         *         processCellItems({record, items}) {
         *             // Add or remove items here as needed
         *             if (record.age > 50) {
         *                 items.push({ text: 'Add extra vacation', icon : 'b-fa b-fa-fw b-fa-umbrella-beach' })
         *             }
         *         }
         *     }
         * }
         * ```
         *
         * @config {Function}
         */
        processCellItems: null,

        /**
         * Event which is used to show context menu.
         * Available options are: 'contextmenu', 'click', 'dblclick'.
         * Default value is used from {@link Grid/view/Grid#config-contextMenuTriggerEvent}
         * @config {String}
         */
        triggerEvent: null,
        // Private config to disable context menu for cells, raised when
        // taskContextMenu is enabled
        disableCellContextMenu: null
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        assign: ['showContextMenu'],
        chain: ['onElementContextMenu', 'onElementClick', 'onElementDblClick', 'onElementKeyDown']
      };
    }
  }]);

  return ContextMenu;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_18__["default"]);


ContextMenu.featureClass = '';
ContextMenu._$name = 'ContextMenu';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_19__["default"].registerFeature(ContextMenu);

/***/ }),

/***/ "./lib/Grid/feature/Filter.js":
/*!************************************!*\
  !*** ./lib/Grid/feature/Filter.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Filter; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");

























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Format value in header filter tooltip (see date)











/**
 * @module Grid/feature/Filter
 */

var fieldTypeMap = {
  date: 'date',
  integer: 'number',
  number: 'number',
  string: 'text',
  duration: 'duration'
};
/**
 * Feature that allows filtering of the grid by settings filters on columns. The actual filtering is done by the store.
 * For info on programmatically handling filters, see {@link Core.data.mixin.StoreFilter StoreFilter}.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * **Note:** This feature cannot be used together with {@link Grid.feature.FilterBar filterBar} feature, they are mutually exclusive.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // Filtering turned on but no default filter
 * let grid = new Grid({
 *   features : {
 *     filter : true
 *   }
 * });
 *
 * // Using default filter
 * let grid = new Grid({
 *   features : {
 *     filter : { property : 'city', value : 'Gavle' }
 *   }
 * });
 *
 * // Custom filtering function for a column
 * let grid = new Grid({
 *    features : {
 *        filter : true
 *    },
 *
 *    columns: [
 *        {
 *          field      : 'age',
 *          text       : 'Age',
 *          type       : 'number',
 *          // Custom filtering function that checks "greater than" no matter which field user filled in :)
 *          filterable : ({ record, value, operator }) => record.age > value
 *        }
 *    ]
 * });
 *
 * // For string-type columns you can also replace the filter UI with a custom field:
 * columns: [
 *     {
 *         field : 'city',
 *         // Filtering for a value out of a list of values
 *         filterable: {
 *             filterField : {
 *                 type  : 'combo',
 *                 items : [
 *                     'Paris',
 *                     'Dubai',
 *                     'Moscow',
 *                     'London',
 *                     'New York'
 *                 ]
 *             }
 *         }
 *     }
 * ]
 * @demo Grid/filtering
 * @classtype filter
 * @externalexample feature/Filter.js
 */

var Filter = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default()(Filter, _InstancePlugin);

  var _super = _createSuper(Filter);

  function Filter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, Filter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(Filter, [{
    key: "construct",
    value: function construct(grid, config) {
      if (grid.features.filterBar) {
        throw new Error('Grid.feature.Filter feature may not be used together with Grid.feature.FilterBar. These features are mutually exclusive.');
      }

      var me = this;
      me.grid = grid;
      me.closeFilterEditor = me.closeFilterEditor.bind(me);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Filter.prototype), "construct", this).call(this, grid, config);

      me.bindStore(grid.store);

      if (config && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17___default()(config) === 'object') {
        grid.store.filter(config, null, grid.isConfiguring);
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$filterTip, _this$filterEditorPop;

      (_this$filterTip = this.filterTip) === null || _this$filterTip === void 0 ? void 0 : _this$filterTip.destroy();
      (_this$filterEditorPop = this.filterEditorPopup) === null || _this$filterEditorPop === void 0 ? void 0 : _this$filterEditorPop.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Filter.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "bindStore",
    value: function bindStore(store) {
      this.detachListeners('name');
      store.on({
        name: 'store',
        filter: 'onStoreFilter',
        thisObj: this
      });
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "refreshHeaders",
    //endregion
    //region Refresh headers

    /**
     * Update headers to match stores filters. Called on store load and grid header render.
     * @param reRenderRows Also refresh rows?
     * @private
     */
    value: function refreshHeaders(reRenderRows) {
      var me = this,
          grid = me.grid,
          element = grid.headerContainer;

      if (element) {
        // remove .latest from all filters, will be applied to actual latest
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].children(element, '.b-filter-icon.b-latest').forEach(function (iconElement) {
          return iconElement.classList.remove('b-latest');
        });

        if (!me.filterTip) {
          me.filterTip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_27__["default"]({
            forElement: element,
            forSelector: '.b-filter-icon',
            getHtml: function getHtml(_ref) {
              var activeTarget = _ref.activeTarget;
              return activeTarget.dataset.filterText;
            }
          });
        }

        var _iterator = _createForOfIteratorHelper(grid.columns),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var column = _step.value;

            if (column.filterable !== false) {
              var filter = me.store.filters.getBy('property', column.field),
                  headerEl = column.element;

              if (headerEl) {
                var textEl = column.textWrapper;
                var filterIconEl = textEl === null || textEl === void 0 ? void 0 : textEl.querySelector('.b-filter-icon'),
                    filterText = void 0;

                if (filter) {
                  filterText = me.L('L{filter}') + ': ' + (typeof filter === 'string' ? filter : "".concat(filter.operator, " ").concat(filter.displayValue || filter.value || '')); //TODO: filter.value needs to be formatted using column format or something
                } else {
                  filterText = me.L('L{applyFilter}');
                }

                if (!filterIconEl) {
                  // putting icon in header text to have more options for positioning it
                  filterIconEl = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].createElement({
                    parent: textEl,
                    tag: 'div',
                    className: 'b-filter-icon',
                    dataset: {
                      filterText: filterText
                    }
                  });
                  headerEl.classList.add('b-filterable');
                } else {
                  filterIconEl.dataset.filterText = filterText;
                } // latest applied filter distinguished with class to enable highlighting etc.


                if (column.field === me.store.latestFilterField) filterIconEl.classList.add('b-latest');
                headerEl.classList[filter ? 'add' : 'remove']('b-filter'); // When IE11 support is dropped
                // headerEl.classList.toggle('b-filter', !!filter);
              }

              column.meta.isFiltered = !!filter;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (reRenderRows) {
          grid.refreshRows();
        }
      }
    } //endregion
    //region Filter

  }, {
    key: "applyFilter",
    value: function applyFilter(config) {
      var store = this.store,
          column = this.grid.columns.get(config.property);

      if (typeof column.filterable === 'function') {
        store.filter({
          filterBy: function filterBy(record) {
            return column.filterable(Object.assign({}, config, {
              record: record
            }));
          },
          // To be able to retrieve the value next time filtering popup is shown, not actually used by the filter
          value: config.value,
          property: config.property,
          operator: config.operator,
          displayValue: config.displayValue
        });
      } else {
        store.filter(config);
      }
    } // TODO: break out as own views, registering with Filter the same way columns register with ColumnManager

  }, {
    key: "getPopupDateItems",
    value: function getPopupDateItems(fieldType, filter, initialValue, field, store, changeCallback, closeCallback) {
      var me = this,
          onClose = changeCallback;

      function onClear() {
        me.store.removeFilter(field);
      }

      function onKeyDown(_ref2) {
        var event = _ref2.event;

        if (event.key === 'Enter') {
          changeCallback();
        }
      }

      function onChange(_ref3) {
        var source = _ref3.source,
            value = _ref3.value;

        if (value == null) {
          onClear();
        } else {
          me.clearSiblingsFields(source);
          me.applyFilter({
            property: field,
            operator: source.operator,
            value: value,
            displayValue: source._value
          });
        }
      }

      return [{
        type: 'date',
        ref: 'on',
        placeholder: 'L{on}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
        value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '=' ? filter.value : initialValue,
        operator: '=',
        onKeydown: onKeyDown,
        onChange: onChange,
        onClose: onClose,
        onClear: onClear
      }, {
        type: 'date',
        ref: 'before',
        placeholder: 'L{before}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-before"></i>',
        value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '<' ? filter.value : null,
        operator: '<',
        onKeydown: onKeyDown,
        onChange: onChange,
        onClose: onClose,
        onClear: onClear
      }, {
        type: 'date',
        ref: 'after',
        cls: 'b-last-row',
        placeholder: 'L{after}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-after"></i>',
        value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '>' ? filter.value : null,
        operator: '>',
        onKeydown: onKeyDown,
        onChange: onChange,
        onClose: onClose,
        onClear: onClear
      }];
    }
  }, {
    key: "getPopupNumberItems",
    value: function getPopupNumberItems(fieldType, filter, initialValue, field, store, changeCallback, closeCallback) {
      var me = this,
          onEsc = changeCallback;

      function onClear() {
        me.store.removeFilter(field);
      }

      function onKeyDown(_ref4) {
        var event = _ref4.event;

        if (event.key === 'Enter') {
          changeCallback();
        }
      }

      function onChange(_ref5) {
        var source = _ref5.source,
            value = _ref5.value;

        if (value == null) {
          onClear();
        } else {
          me.clearSiblingsFields(source);
          me.applyFilter({
            property: field,
            operator: source.operator,
            value: value
          });
        }
      }

      return [{
        type: 'number',
        placeholder: 'L{Filter.equals}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
        value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '=' ? filter.value : initialValue,
        onKeydown: onKeyDown,
        operator: '=',
        onChange: onChange,
        onEsc: onEsc,
        onClear: onClear
      }, {
        type: 'number',
        placeholder: 'L{lessThan}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-less"></i>',
        value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '<' ? filter.value : null,
        onKeydown: onKeyDown,
        operator: '<',
        onChange: onChange,
        onEsc: onEsc,
        onClear: onClear
      }, {
        type: 'number',
        cls: 'b-last-row',
        placeholder: 'L{moreThan}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-more"></i>',
        value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '>' ? filter.value : null,
        onKeydown: onKeyDown,
        operator: '>',
        onChange: onChange,
        onEsc: onEsc,
        onClear: onClear
      }];
    }
  }, {
    key: "clearSiblingsFields",
    value: function clearSiblingsFields(sourceField) {
      var _this$filterEditorPop2;

      // TODO: Store filtering allows multiple filters per field (for example age > 50 and age < 80),
      // but the Filter feature only handles a single filter per field.
      // For now, trying to add filter by age > and then for age <,
      // it should clear the previous field since that filter is replaced
      (_this$filterEditorPop2 = this.filterEditorPopup) === null || _this$filterEditorPop2 === void 0 ? void 0 : _this$filterEditorPop2.items.forEach(function (field) {
        field !== sourceField && (field === null || field === void 0 ? void 0 : field.clear());
      });
    }
  }, {
    key: "getPopupDurationItems",
    value: function getPopupDurationItems(fieldType, filter, initialValue, field, store, changeCallback, closeCallback) {
      var me = this,
          onEsc = changeCallback,
          onClear = closeCallback;

      function onChange(_ref6) {
        var source = _ref6.source,
            value = _ref6.value;

        if (value == null) {
          closeCallback();
        } else {
          me.applyFilter({
            property: field,
            operator: source.operator,
            value: value
          });
          changeCallback();
        }
      }

      return [{
        type: 'duration',
        placeholder: 'L{Filter.equals}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
        value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '=' ? filter.value : initialValue,
        operator: '=',
        onChange: onChange,
        onEsc: onEsc,
        onClear: onClear
      }, {
        type: 'duration',
        placeholder: 'L{lessThan}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-less"></i>',
        value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '<' ? filter.value : null,
        operator: '<',
        onChange: onChange,
        onEsc: onEsc,
        onClear: onClear
      }, {
        type: 'duration',
        cls: 'b-last-row',
        placeholder: 'L{moreThan}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-more"></i>',
        value: (filter === null || filter === void 0 ? void 0 : filter.operator) === '>' ? filter.value : null,
        operator: '>',
        onChange: onChange,
        onEsc: onEsc,
        onClear: onClear
      }];
    }
  }, {
    key: "getPopupStringItems",
    value: function getPopupStringItems(fieldType, filter, initialValue, field, store, changeCallback, closeCallback, filterField) {
      var me = this;
      return [_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].assign({
        type: fieldType,
        cls: 'b-last-row',
        placeholder: 'L{filter}',
        localeClass: me,
        clearable: true,
        label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
        value: filter ? filter.value || filter : initialValue,
        onChange: function onChange(_ref7) {
          var value = _ref7.value;

          if (value === '') {
            closeCallback();
          } else {
            me.applyFilter({
              property: field,
              value: value
            });
            changeCallback();
          }
        },
        onClose: changeCallback,
        onClear: closeCallback
      }, filterField)];
    }
    /**
     * Get fields to display in filter popup.
     * @param fieldType Type of field, number, date etc.
     * @param filter Current filter filter
     * @param initialValue
     * @param field Column
     * @param store Grid store
     * @param changeCallback Callback for when filter has changed
     * @param closeCallback Callback for when editor should be closed
     * @param filterField filter field
     * @returns {*}
     * @private
     */

  }, {
    key: "getPopupItems",
    value: function getPopupItems(fieldType, filter, initialValue, field, store, changeCallback, closeCallback, filterField) {
      switch (fieldType) {
        case 'date':
          return this.getPopupDateItems.apply(this, arguments);

        case 'number':
          return this.getPopupNumberItems.apply(this, arguments);

        case 'duration':
          return this.getPopupDurationItems.apply(this, arguments);

        default:
          return this.getPopupStringItems.apply(this, arguments);
      }
    }
    /**
     * Shows a popup where a filter can be edited.
     * @param {Grid.column.Column|String} column Column to show filter editor for
     * @param {*} [value] The initial value of the filter field
     */

  }, {
    key: "showFilterEditor",
    value: function showFilterEditor(column, value) {
      var _this = this;

      var me = this,
          store = me.store,
          col = typeof column === 'string' ? me.grid.columns.getById(column) : column,
          headerEl = col.element,
          field = store.modelClass.fieldMap[col.field],
          filter = store.filters.getBy('property', col.field),
          type = col.filterType,
          fieldType = type ? fieldTypeMap[type] : fieldTypeMap[col.type] || field && fieldTypeMap[field.type] || 'text';

      if (col.filterable === false) {
        return;
      } // Destroy previous filter popup


      me.closeFilterEditor();
      var items = me.getPopupItems(fieldType, filter, value, col.field, me.store, me.closeFilterEditor, function () {
        me.store.removeFilter(col.field);
        me.closeFilterEditor();
      }, col.filterable.filterField); // Localize placeholders

      items.forEach(function (item) {
        return item.placeholder = _this.L(item.placeholder);
      });
      me.filterEditorPopup = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].openPopup(headerEl, {
        owner: this.grid,
        width: '16em',
        cls: 'b-filter-popup',
        scrollAction: 'realign',
        items: items
      });
    }
    /**
     * Close the filter editor.
     */

  }, {
    key: "closeFilterEditor",
    value: function closeFilterEditor() {
      var _this$filterEditorPop3;

      // Must defer the destroy because it may be closed by an event like a "change" event where
      // there may be plenty of code left to execute which must not execute on destroyed objects.
      (_this$filterEditorPop3 = this.filterEditorPopup) === null || _this$filterEditorPop3 === void 0 ? void 0 : _this$filterEditorPop3.setTimeout(this.filterEditorPopup.destroy);
      this.filterEditorPopup = null;
    } //endregion
    //region Context menu
    //TODO: break out together with getPopupXXItems() (see comment above)

  }, {
    key: "populateCellMenuWithDateItems",
    value: function populateCellMenuWithDateItems(_ref8) {
      var column = _ref8.column,
          record = _ref8.record,
          items = _ref8.items;
      var property = column.field,
          field = record.getFieldDefinition(property),
          type = column.filterType || (field === null || field === void 0 ? void 0 : field.type) || column.type;

      if (type === 'date') {
        var me = this,
            value = record[property],
            filter = function filter(operator) {
          me.applyFilter({
            property: property,
            operator: operator,
            value: value,
            displayValue: column.formatValue ? column.formatValue(value) : value
          });
        };

        items.filterDateEquals = {
          text: 'L{on}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-equal',
          cls: 'b-separator',
          name: 'filterDateEquals',
          weight: 300,
          disabled: me.disabled,
          onItem: function onItem() {
            return filter('=');
          }
        };
        items.filterDateBefore = {
          text: 'L{before}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-before',
          name: 'filterDateBefore',
          weight: 310,
          disabled: me.disabled,
          onItem: function onItem() {
            return filter('<');
          }
        };
        items.filterDateAfter = {
          text: 'L{after}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-after',
          name: 'filterDateAfter',
          weight: 320,
          disabled: me.disabled,
          onItem: function onItem() {
            return filter('>');
          }
        };
      }
    }
  }, {
    key: "populateCellMenuWithNumberItems",
    value: function populateCellMenuWithNumberItems(_ref9) {
      var column = _ref9.column,
          record = _ref9.record,
          items = _ref9.items;
      var property = column.field,
          field = record.getFieldDefinition(property),
          type = column.filterType || column.type || (field === null || field === void 0 ? void 0 : field.type);

      if (type === 'number') {
        var me = this,
            value = record[property],
            filter = function filter(operator) {
          me.applyFilter({
            property: property,
            operator: operator,
            value: value
          });
        };

        items.filterNumberEquals = {
          text: 'L{equals}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-equal',
          cls: 'b-separator',
          name: 'filterNumberEquals',
          weight: 300,
          disabled: me.disabled,
          onItem: function onItem() {
            return filter('=');
          }
        };
        items.filterNumberLess = {
          text: 'L{lessThan}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-less',
          name: 'filterNumberLess',
          weight: 310,
          disabled: me.disabled,
          onItem: function onItem() {
            return filter('<');
          }
        };
        items.filterNumberMore = {
          text: 'L{moreThan}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-more',
          name: 'filterNumberMore',
          weight: 320,
          disabled: me.disabled,
          onItem: function onItem() {
            return filter('>');
          }
        };
      }
    }
  }, {
    key: "populateCellMenuWithDurationItems",
    value: function populateCellMenuWithDurationItems(_ref10) {
      var column = _ref10.column,
          record = _ref10.record,
          items = _ref10.items;
      var property = column.field,
          field = record.getFieldDefinition(property),
          type = column.filterType || (field === null || field === void 0 ? void 0 : field.type) || column.type;

      if (type === 'duration') {
        var me = this,
            value = record[property],
            filter = function filter(operator) {
          me.applyFilter({
            property: property,
            operator: operator,
            value: value
          });
        };

        items.filterDurationEquals = {
          text: 'L{equals}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-equal',
          cls: 'b-separator',
          name: 'filterDurationEquals',
          weight: 300,
          disabled: me.disabled,
          onItem: function onItem() {
            return filter('=');
          }
        };
        items.filterDurationLess = {
          text: 'L{lessThan}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-less',
          name: 'filterDurationLess',
          weight: 310,
          disabled: me.disabled,
          onItem: function onItem() {
            return filter('<');
          }
        };
        items.filterDurationMore = {
          text: 'L{moreThan}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-more',
          name: 'filterDurationMore',
          weight: 320,
          disabled: me.disabled,
          onItem: function onItem() {
            return filter('>');
          }
        };
      }
    }
  }, {
    key: "populateCellMenuWithStringItems",
    value: function populateCellMenuWithStringItems(_ref11) {
      var column = _ref11.column,
          record = _ref11.record,
          items = _ref11.items;
      var property = column.field,
          field = record.getFieldDefinition(property),
          type = column.filterType || (field === null || field === void 0 ? void 0 : field.type) || column.type;

      if (!/(date|number|duration)/.test(type)) {
        var me = this,
            value = record[property];
        items.filterStringEquals = {
          text: 'L{equals}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-filter-equal',
          cls: 'b-separator',
          name: 'filterStringEquals',
          weight: 300,
          disabled: me.disabled,
          onItem: function onItem() {
            return me.applyFilter({
              property: property,
              value: value
            });
          }
        };
      }
    }
    /**
     * Add menu items for filtering.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Core.data.Model} options.record Record for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateCellMenu",
    value: function populateCellMenu(_ref12) {
      var column = _ref12.column,
          record = _ref12.record,
          items = _ref12.items;
      var me = this;

      if (column.filterable !== false) {
        me.populateCellMenuWithDateItems.apply(me, arguments);
        me.populateCellMenuWithNumberItems.apply(me, arguments);
        me.populateCellMenuWithDurationItems.apply(me, arguments);
        me.populateCellMenuWithStringItems.apply(me, arguments);

        if (column.meta.isFiltered) {
          items.filterRemove = {
            text: 'L{removeFilter}',
            localeClass: me,
            icon: 'b-fw-icon b-icon-clear',
            cls: 'b-separator',
            weight: 400,
            name: 'filterRemove',
            disabled: me.disabled,
            onItem: function onItem() {
              return me.store.removeFilter(column.field);
            }
          };
        }
      }
    }
    /**
     * Add menu item for removing filter if column is filtered.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @returns {Object} items Menu items config
     * @internal
     */

  }, {
    key: "populateHeaderMenu",
    value: function populateHeaderMenu(_ref13) {
      var column = _ref13.column,
          items = _ref13.items;
      var me = this;

      if (column.meta.isFiltered) {
        items.editFilter = {
          text: 'L{editFilter}',
          localeClass: me,
          name: 'editFilter',
          weight: 100,
          icon: 'b-fw-icon b-icon-filter',
          cls: 'b-separator',
          disabled: me.disabled,
          onItem: function onItem() {
            return me.showFilterEditor(column);
          }
        };
        items.removeFilter = {
          text: 'L{removeFilter}',
          localeClass: me,
          name: 'removeFilter',
          weight: 110,
          icon: 'b-fw-icon b-icon-remove',
          disabled: me.disabled,
          onItem: function onItem() {
            return me.store.removeFilter(column.field);
          }
        };
      } else if (column.filterable !== false) {
        items.filter = {
          text: 'L{filter}',
          localeClass: me,
          name: 'filter',
          weight: 100,
          icon: 'b-fw-icon b-icon-filter',
          cls: 'b-separator',
          disabled: me.disabled,
          onItem: function onItem() {
            return me.showFilterEditor(column);
          }
        };
      }
    } //endregion
    //region Events

    /**
     * Store filtered; refresh headers.
     * @private
     */

  }, {
    key: "onStoreFilter",
    value: function onStoreFilter() {
      // Pass false to not refresh rows.
      // Store's refresh event will refresh the rows.
      this.refreshHeaders(false);
    }
    /**
     * Called after headers are rendered, make headers match stores initial sorters
     * @private
     */

  }, {
    key: "renderHeader",
    value: function renderHeader() {
      this.refreshHeaders(false);
    }
    /**
     * Called when user clicks on the grid. Only care about clicks on the filter icon.
     * @param {MouseEvent} event
     * @private
     */

  }, {
    key: "onElementClick",
    value: function onElementClick(event) {
      var target = event.target;
      if (this.filterEditorPopup) this.closeFilterEditor(); // Checks if click is on node expander icon, then toggles expand/collapse

      if (target.classList.contains('b-filter-icon')) {
        var headerEl = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].up(target, '.b-grid-header');
        this.showFilterEditor(headerEl.dataset.columnId);
        return false;
      }
    } //endregion

  }, {
    key: "store",
    get: function get() {
      return this.grid.store;
    }
  }], [{
    key: "$name",
    //region Init
    get: function get() {
      return 'Filter';
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['renderHeader', 'populateCellMenu', 'populateHeaderMenu', 'onElementClick', 'bindStore']
      };
    }
  }]);

  return Filter;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_28__["default"]);


Filter._$name = 'Filter';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_33__["default"].registerFeature(Filter);

/***/ }),

/***/ "./lib/Grid/feature/FilterBar.js":
/*!***************************************!*\
  !*** ./lib/Grid/feature/FilterBar.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FilterBar; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.match */ "./node_modules/core-js/modules/es.string.match.js");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");

























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/* eslint-disable no-unused-expressions */








/**
 * @module Grid/feature/FilterBar
 */

/**
 * Feature that allows filtering of the grid by entering filters on column headers.
 * The actual filtering is done by the store.
 * For info on programmatically handling filters, see {@link Core.data.mixin.StoreFilter StoreFilter}.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * The individual filterability of columns is defined by a `filterable`
 * property on the column which defaults to `true`. If `false`, that column
 * is not filterable.
 *
 * The property value may also be a custom filter function.
 *
 * The property value may also be an object which may contain the following two properties:
 *  - **filterFn** : `Function` A custom filtering function
 *  - **filterField** : `Object` A config object for the filter value input field.
 *
 * **Note:** This feature cannot be used together with {@link Grid.feature.Filter filter} feature, they are mutually exclusive.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // filtering turned on but no default filter
 * let grid = new Grid({
 *   features: {
 *     filterBar : true
 *   }
 * });
 *
 * @example
 * // using default filter
 * let grid = new Grid({
 *   features : {
 *     filterBar : { filter: { property : 'city', value : 'Gavle' } }
 *   }
 * });
 *
 * @example
 * // Custom filtering function for a column
 * let grid = new Grid({
 *   features : {
 *     filter : true
 *   },
 *
 *   columns: [
 *      {
 *        field      : 'age',
 *        text       : 'Age',
 *        type       : 'number',
 *        // Custom filtering function that checks "greater than"
 *        filterable : ({ record, value }) => record.age > value
 *      },
 *      {
 *        field : 'name',
 *        // Filterable may specify a filterFn and a config for the filtering input field
 *        filterable : {
 *          filterFn : ({ record, value }) => record.name.toLowerCase().indexof(value.toLowerCase()) !== -1,
 *          filterField : {
 *            emptyText : 'Filter name'
 *          }
 *        }
 *      },
 *      {
 *        field : 'city',
 *        text : 'Visited',
 *        flex : 1,
 *        // Filterable with multiselect combo to pick several items to filter
 *        filterable : {
 *          filterField : {
 *            type        : 'combo',
 *            multiSelect : true,
 *            items       : ['Barcelona', 'Moscow', 'Stockholm']
 *          },
 *          filterFn    : ({ record, value }) => !value.length || value.includes(record.city)
 *        }
 *      }
 *   ]
 * });
 *
 * @demo Grid/filterbar
 * @classtype filterBar
 * @externalexample feature/FilterBar.js
 */

var FilterBar = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default()(FilterBar, _InstancePlugin);

  var _super = _createSuper(FilterBar);

  function FilterBar() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, FilterBar);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(FilterBar, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(grid, config) {
      if (grid.features.filter) {
        throw new Error('Grid.feature.FilterBar feature may not be used together with Grid.feature.Filter, These features are mutually exclusive.');
      }

      var me = this;
      Object.assign(me, {
        filterFieldCls: 'b-filter-bar-field',
        filterFieldInputCls: 'b-filter-bar-field-input',
        filterableColumnCls: 'b-filter-bar-enabled',
        filterFieldInputSelector: '.b-filter-bar-field-input',
        filterableColumnSelector: '.b-filter-bar-enabled',
        filterParseRegExp: /^\s*([<>=*])?(.*)$/,
        storeTrackingSupended: 0,
        grid: grid
      });
      me.onColumnFilterFieldChange = me.onColumnFilterFieldChange.bind(me);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(FilterBar.prototype), "construct", this).call(this, grid, Array.isArray(config) ? {
        filter: config
      } : config);

      me.bindStore(grid.store);

      if (me.filter) {
        grid.store.filter(me.filter);
      }

      me.gridDetacher = grid.on('beforeelementclick', me.onBeforeElementClick, me);
    }
  }, {
    key: "bindStore",
    value: function bindStore(store) {
      this.detachListeners('store');
      store.on({
        name: 'store',
        filter: 'onStoreFilter',
        thisObj: this
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$gridDetacher;

      this.destroyFilterBar();
      (_this$gridDetacher = this.gridDetacher) === null || _this$gridDetacher === void 0 ? void 0 : _this$gridDetacher.call(this);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(FilterBar.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      var _this = this;

      var columns = this.grid.columns; // hide the fields, each silently - no updating of the store's filtered state until the end

      columns === null || columns === void 0 ? void 0 : columns.forEach(function (column) {
        var widget = _this.getColumnFilterField(column);

        if (widget) {
          widget.disabled = disable;
        }
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(FilterBar.prototype), "doDisable", this).call(this, disable);
    }
  }, {
    key: "destroyFilterBar",
    //endregion
    //region FilterBar
    value: function destroyFilterBar() {
      var _this$grid$columns;

      (_this$grid$columns = this.grid.columns) === null || _this$grid$columns === void 0 ? void 0 : _this$grid$columns.forEach(this.destroyColumnFilterField, this);
    }
    /**
     * Hides the filtering fields.
     */

  }, {
    key: "hideFilterBar",
    value: function hideFilterBar() {
      var _me$grid$columns;

      var me = this; // we don't want to hear back store "filter" event while we're resetting store filters

      me.clearStoreFiltersOnHide && me.suspendStoreTracking(); // hide the fields, each silently - no updating of the store's filtered state until the end

      (_me$grid$columns = me.grid.columns) === null || _me$grid$columns === void 0 ? void 0 : _me$grid$columns.forEach(function (col) {
        return me.hideColumnFilterField(col, true);
      }); // Now update the filtered state

      me.grid.store.filter();
      me.clearStoreFiltersOnHide && me.resumeStoreTracking();
      me.hidden = true;
    }
    /**
     * Shows the filtering fields.
     */

  }, {
    key: "showFilterBar",
    value: function showFilterBar() {
      this.renderFilterBar();
      this.hidden = false;
    }
    /**
     * Toggles the filtering fields visibility.
     */

  }, {
    key: "toggleFilterBar",
    value: function toggleFilterBar() {
      if (this.hidden) {
        this.showFilterBar();
      } else {
        this.hideFilterBar();
      }
    }
    /**
     * Renders the filtering fields for filterable columns.
     * @private
     */

  }, {
    key: "renderFilterBar",
    value: function renderFilterBar() {
      var _this2 = this;

      this.grid.columns.visibleColumns.forEach(function (column) {
        return _this2.renderColumnFilterField(column);
      });
      this.rendered = true;
    } //endregion
    //region FilterBar fields

    /**
     * Renders text field filter in the provided column header.
     * @param {Grid.column.Column} column Column to render text field filter for.
     * @private
     */

  }, {
    key: "renderColumnFilterField",
    value: function renderColumnFilterField(column) {
      var me = this,
          grid = me.grid,
          filterable = me.getColumnFilterable(column); // we render fields for filterable columns only

      if (filterable && !column.hidden) {
        var headerEl = column.element;
        var widget = me.getColumnFilterField(column); // if we don't haven't created a field yet
        // we build it from scratch

        if (!widget) {
          var filter = grid.store.filters.getBy('property', column.field),
              type = "".concat(column.filterType || 'text', "field");
          widget = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].append(Object.assign({
            type: type,
            owner: me.grid,
            clearable: true,
            column: column,
            name: column.field,
            value: filter && !filter._filterBy && me.buildFilterString(filter),
            cls: me.filterFieldCls,
            inputCls: me.filterFieldInputCls,
            keyStrokeChangeDelay: me.keyStrokeFilterDelay,
            onChange: me.onColumnFilterFieldChange,
            onClear: me.onColumnFilterFieldChange,
            disabled: me.disabled
          }, filterable.filterField), headerEl)[0];
          me.setColumnFilterField(column, widget);
        } // if we have one..
        else {
            // re-apply widget filter
            me.onColumnFilterFieldChange({
              source: widget,
              value: widget.value
            }); // re-append the widget to its parent node (in case the column header was redrawn (happens when resizing columns))

            widget.render(headerEl); // show widget in case it was hidden

            widget.show();
          }

        headerEl.classList.add(me.filterableColumnCls);
      }
    }
    /**
     * Fills in column filter fields with values from the grid store filters.
     * @private
     */

  }, {
    key: "updateColumnFilterFields",
    value: function updateColumnFilterFields() {
      var _this$grid = this.grid,
          columns = _this$grid.columns,
          store = _this$grid.store;
      var field, filter;

      var _iterator = _createForOfIteratorHelper(columns),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var column = _step.value;
          field = this.getColumnFilterField(column);

          if (field) {
            filter = store.filters.getBy('property', column.field);

            if (filter) {
              // For filtering functions we keep what user typed into the field, we cannot construct a filter
              // string from them
              if (!filter._filterBy) {
                field.value = this.buildFilterString(filter);
              }
            } // No filter, clear field
            else {
                field.value = '';
              }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "getColumnFilterable",
    value: function getColumnFilterable(column) {
      if (!column.isRoot && column.filterable !== false && column.field) {
        if (typeof column.filterable === 'function') {
          column.filterable = {
            filterFn: column.filterable
          };
        }

        return column.filterable;
      }
    }
  }, {
    key: "destroyColumnFilterField",
    value: function destroyColumnFilterField(column) {
      var widget = this.getColumnFilterField(column);

      if (widget) {
        this.hideColumnFilterField(column); // destroy filter UI field

        widget.destroy(); // remember there is no field bound anymore

        this.setColumnFilterField(column, undefined);
      }
    }
  }, {
    key: "hideColumnFilterField",
    value: function hideColumnFilterField(column, silent) {
      var me = this,
          store = me.grid.store,
          columnEl = column.element,
          widget = me.getColumnFilterField(column);

      if (widget) {
        // hide field
        widget.hide();

        if (me.clearStoreFiltersOnHide && column.field) {
          store.removeFilter(column.field, silent);
        }

        columnEl === null || columnEl === void 0 ? void 0 : columnEl.classList.remove(me.filterableColumnCls);
      }
    }
  }, {
    key: "getColumnFilterField",
    value: function getColumnFilterField(column) {
      var _this$_columnFilters;

      return (_this$_columnFilters = this._columnFilters) === null || _this$_columnFilters === void 0 ? void 0 : _this$_columnFilters[column.data.id];
    }
  }, {
    key: "setColumnFilterField",
    value: function setColumnFilterField(column, widget) {
      this._columnFilters = this._columnFilters || {};
      this._columnFilters[column.data.id] = widget;
    } //endregion
    //region Filters

  }, {
    key: "parseFilterValue",
    value: function parseFilterValue(value) {
      var match = String(value).match(this.filterParseRegExp);
      return {
        operator: match[1] || '*',
        value: match[2]
      };
    }
  }, {
    key: "buildFilterString",
    value: function buildFilterString(filter) {
      return (filter.operator === '*' ? '' : filter.operator) + filter.value;
    } //endregion
    // region Events

    /**
     * Fires when store gets filtered. Refreshes field values in column headers.
     * @private
     */

  }, {
    key: "onStoreFilter",
    value: function onStoreFilter() {
      if (!this.storeTrackingSupended && this.rendered) {
        this.updateColumnFilterFields();
      }
    }
  }, {
    key: "suspendStoreTracking",
    value: function suspendStoreTracking() {
      this.storeTrackingSupended++;
    }
  }, {
    key: "resumeStoreTracking",
    value: function resumeStoreTracking() {
      this.storeTrackingSupended--;
    }
    /**
     * Called after headers are rendered, make headers match stores initial sorters
     * @private
     */

  }, {
    key: "renderHeader",
    value: function renderHeader() {
      if (!this.hidden) {
        this.renderFilterBar();
      }
    }
  }, {
    key: "onElementKeyDown",
    value: function onElementKeyDown(event) {
      // flagging event with handled = true used to signal that other features should probably not care about it
      if (event.handled) {
        return;
      } // if we are pressing left/right arrow keys while being in a filter editor
      // we set event.handled flag (otherwise other features prevent the event)


      if (event.target.matches(this.filterFieldInputSelector)) {
        switch (event.key) {
          case 'ArrowLeft':
          case 'ArrowRight':
            event.handled = true;
        }
      }
    }
  }, {
    key: "onBeforeElementClick",
    value: function onBeforeElementClick(_ref) {
      var event = _ref.event;

      // prevent other features reacting when clicking a filter field (or any element inside it)
      if (event.target.closest(".".concat(this.filterFieldCls))) {
        return false;
      }
    }
    /**
     * Called when a column text filter field value is changed by user.
     * @param  {TextField} field Filter text field.
     * @param  {String} value New filtering value.
     * @private
     */

  }, {
    key: "onColumnFilterFieldChange",
    value: function onColumnFilterFieldChange(_ref2) {
      var field = _ref2.source,
          value = _ref2.value;
      var me = this,
          store = me.grid.store,
          filterable = me.getColumnFilterable(field.column); // we don't want to hear back store "filter" event
      // so we suspend store tracking

      me.suspendStoreTracking();

      if (value == null || value === '' || Array.isArray(value) && value.length === 0) {
        // remove filter if setting to empty
        store.removeFilter(field.name);
      } else if (filterable.filterFn) {
        store.filter({
          filterBy: function filterBy(record) {
            return filterable.filterFn({
              property: field.name,
              value: value,
              record: record
            });
          },
          // To be able to clear the filter
          property: field.name
        });
      } else {
        store.filter(Object.assign({
          property: field.name
        }, me.parseFilterValue(value)));
      }

      me.resumeStoreTracking();
    } //endregion
    //region Menu items

    /**
     * Adds a menu item to toggle filter bar visibility.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateHeaderMenu",
    value: function populateHeaderMenu(_ref3) {
      var _this3 = this;

      var items = _ref3.items;
      items.toggleFilterBar = {
        text: this.hidden ? 'L{enableFilterBar}' : 'L{disableFilterBar}',
        localeClass: this,
        name: 'toggleFilterBar',
        weight: 120,
        icon: 'b-fw-icon b-icon-filter',
        cls: 'b-separator',
        onItem: function onItem() {
          return _this3.toggleFilterBar();
        }
      };
    } //endregion

  }], [{
    key: "$name",
    //region Default config
    get: function get() {
      return 'FilterBar';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The delay in milliseconds to wait after the last keystroke before applying filters.
         * Set to 0 to not trigger filtering from keystrokes, requires pressing ENTER instead
         * @config {Number}
         * @default
         */
        keyStrokeFilterDelay: 300,
        // Destroying data level filters when we hiding UI is supposed to be optional someday. So far this flag is private
        clearStoreFiltersOnHide: true
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        before: ['onElementKeyDown'],
        chain: ['renderHeader', 'populateHeaderMenu', 'bindStore']
      };
    }
  }]);

  return FilterBar;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_25__["default"]);


FilterBar.featureClass = 'b-filter-bar';
FilterBar._$name = 'FilterBar';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_30__["default"].registerFeature(FilterBar);

/***/ }),

/***/ "./lib/Grid/feature/GridFeatureManager.js":
/*!************************************************!*\
  !*** ./lib/Grid/feature/GridFeatureManager.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GridFeatureManager; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");






























var productName = 'scheduler';

/**
 * @module Grid/feature/GridFeatureManager
 */

var consumerToFeatureMap = new Map(),
    consumerToDefaultFeatureMap = new Map(),
    DEFAULT_FOR_TYPE = 'Grid',
    remapToBase = {
  Grid: 'GridBase',
  Scheduler: 'SchedulerBase',
  Gantt: 'GanttBase'
},
    classNameFix = /\$\d+$/;
/**
 * Static class intended to register and query grid features
 *
 * @class
 */

var GridFeatureManager = /*#__PURE__*/function () {
  function GridFeatureManager() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default()(this, GridFeatureManager);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default()(GridFeatureManager, null, [{
    key: "registerFeature",

    /**
     * Register a feature class with the Grid. Enables it to be created and configured using config Grid#features.
     * @param {Core.mixin.InstancePlugin} featureClass Feature to register
     * @param {Boolean} [onByDefault] Specify true to have the feature enabled per default
     * @param {String|String[]} [forType] Specify a type to let the class applying the feature to determine if it should use it
     */
    value: function registerFeature(featureClass) {
      var onByDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var forType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var as = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      // Our built in features should all define $name to survive minification/obfuscation, but user defined features might not
      as = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].uncapitalize(as || Object.prototype.hasOwnProperty.call(featureClass, '$name') && featureClass.$$name || featureClass.name); // Remove webpack's disambiguation suffix.
      // For example ExcelExporter in Scheduler will be called ExcelExporter$1
      // It must be found as ExcelExporter in the Scheduler's feature Map, so correct the name.

      as = as.replace(classNameFix, '');

      if (!Array.isArray(forType)) {
        forType = [forType || DEFAULT_FOR_TYPE];
      }

      forType.forEach(function (forType) {
        var type = remapToBase[forType] || forType,
            consumerFeaturesMap = consumerToFeatureMap.get(type) || new Map(),
            consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(type) || new Map();
        consumerFeaturesMap.set(as, featureClass);
        consumerDefaultFeaturesMap.set(featureClass, onByDefault);
        consumerToFeatureMap.set(type, consumerFeaturesMap);
        consumerToDefaultFeatureMap.set(type, consumerDefaultFeaturesMap);
      });
    }
    /**
     * Get all the features registered for the given type name in an object where keys are feature names and values are feature constructors.
     *
     * @param {String} [forType]
     * @return {Object}
     */

  }, {
    key: "getTypeNameFeatures",
    value: function getTypeNameFeatures() {
      var forType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FOR_TYPE;
      var type = remapToBase[forType] || forType,
          consumerFeaturesMap = consumerToFeatureMap.get(type),
          features = {};

      if (consumerFeaturesMap) {
        consumerFeaturesMap.forEach(function (featureClass, as) {
          return features[as] = featureClass;
        });
      }

      return features;
    }
    /**
     * Get all the default features registered for the given type name in an object where keys are feature names and values are feature constructors.
     *
     * @param {String} [forType]
     * @return {Object}
     */

  }, {
    key: "getTypeNameDefaultFeatures",
    value: function getTypeNameDefaultFeatures() {
      var forType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FOR_TYPE;
      var type = remapToBase[forType] || forType,
          consumerFeaturesMap = consumerToFeatureMap.get(type),
          consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(type);
      var features = {};

      if (consumerFeaturesMap && consumerDefaultFeaturesMap) {
        consumerFeaturesMap.forEach(function (featureClass, as) {
          if (consumerDefaultFeaturesMap.get(featureClass)) {
            features[as] = featureClass;
          }
        });
      }

      return features;
    }
    /**
     * Gets all the features registered for the given instance type name chain. First builds the type name chain then quaries for features
     * for each type name and combines them into one object, see {@link #function-getTypeNameFeatures-static}() for returned object description.
     * If feature is registered for both parent and child type name then feature for child overrides feature for parent.
     *
     * @param {Object} instance
     * @return {Object}
     */

  }, {
    key: "getInstanceFeatures",
    value: function getInstanceFeatures(instance) {
      var _this = this;

      return instance.$meta.names.reduce(function (features, typeName) {
        return Object.assign(features, _this.getTypeNameFeatures(typeName));
      }, {});
    }
    /**
     * Gets all the *defualt* features registered for the given instance type name chain. First builds the type name chain then quaries for features
     * for each type name and combines them into one object, see {@link #function-getTypeNameFeatures-static}() for returned object description.
     * If feature is registered for both parent and child type name then feature for child overrides feature for parent.
     *
     * @param {Object} instance
     * @return {Object}
     */

  }, {
    key: "getInstanceDefaultFeatures",
    value: function getInstanceDefaultFeatures(instance) {
      var _this2 = this;

      return instance.$meta.names.reduce(function (features, typeName) {
        return Object.entries(_this2.getTypeNameFeatures(typeName)).reduce(function (features, _ref) {
          var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_27___default()(_ref, 2),
              as = _ref2[0],
              featureClass = _ref2[1];

          if (_this2.isDefaultFeatureForTypeName(featureClass, typeName)) {
            features[as] = featureClass;
          } else {
            delete features[as];
          }

          return features;
        }, features);
      }, {});
    }
    /**
     * Checks if the given feature class is default for the type name
     *
     * @param {Core.mixin.InstancePlugin} featureClass Feature to check
     * @param {String} [forType]
     * @return {Boolean}
     */

  }, {
    key: "isDefaultFeatureForTypeName",
    value: function isDefaultFeatureForTypeName(featureClass) {
      var forType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FOR_TYPE;
      var type = remapToBase[forType] || forType,
          consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(type);
      return consumerDefaultFeaturesMap && consumerDefaultFeaturesMap.get(featureClass) || false;
    }
    /**
     * Checks if the given feature class is default for the given instance type name chain. If the feature is not default for the
     * parent type name but it is for the child type name, then the child setting overrides the parent one.
     *
     * @param {Core.mixin.InstancePlugin} featureClass Feature to check
     * @param {String} [forType]
     * @return {Boolean}
     */

  }, {
    key: "isDefaultFeatureForInstance",
    value: function isDefaultFeatureForInstance(featureClass, instance) {
      //const typeChain = ObjectHelper.getTypeNameChain(instance);
      var typeChain = instance.$meta.names.slice().reverse();
      var result = null;

      for (var i = 0, len = typeChain.length; i < len && result === null; ++i) {
        var consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(typeChain[i]);

        if (consumerDefaultFeaturesMap && consumerDefaultFeaturesMap.has(featureClass)) {
          result = consumerDefaultFeaturesMap.get(featureClass);
        }
      }

      return result || false;
    }
    /**
     * Resets feature registration date, used in tests to reset state after test
     *
     * @internal
     */

  }, {
    key: "reset",
    value: function reset() {
      consumerToFeatureMap.clear();
      consumerToDefaultFeatureMap.clear();
    }
  }]);

  return GridFeatureManager;
}();


GridFeatureManager._$name = 'GridFeatureManager';

/***/ }),

/***/ "./lib/Grid/feature/Group.js":
/*!***********************************!*\
  !*** ./lib/Grid/feature/Group.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Group; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");



























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Expand function?
//TODO: Collapse function?
//TODO: Sorting breaks grouping if some groups are collapsed
//TODO: Grouping via context menu doesn't work






/**
 * @module Grid/feature/Group
 */

/**
 * Enables rendering and handling of row groups. The actual grouping is done in the store, but triggered by [shift] +
 * clicking headers or by using two finger tap (one on header, one anywhere on grid). Groups can be expanded/collapsed
 * by clicking on the group row or pressing [space] when group row is selected.
 * The actual grouping is done by the store, see {@link Core.data.mixin.StoreGroup#function-group}.
 *
 * Grouping by a field performs sorting by the field automatically. It's not possible to prevent sorting.
 * If you group, the records have to be sorted so that records in a group stick together. You can either control sorting
 * direction, or provide a custom sorting function called `fn` to your grouper.
 *
 * For info on programmatically handling grouping, see {@link Core.data.mixin.StoreGroup StoreGroup}.
 *
 * This feature is **enabled** by default.
 *
 * @example
 * // grouping feature is enabled, no default value though
 * let grid = new Grid({
 *     features : {
 *         group : true
 *     }
 * });
 *
 * // use initial grouping
 * let grid = new Grid({
 *     features : {
 *         group : 'city'
 *     }
 * });
 *
 * // default grouper and custom renderer, which will be applied to each cell except the "group" cell
 * let grid = new Grid({
 *   features : {
 *     group : {
 *       field : 'city',
 *       ascending : false,
 *       renderer : ({ isFirstColumn, count, groupRowFor, record }) => isFirstColumn ? `${groupRowFor} (${count})` : ''
 *     }
 *   }
 * });
 *
 * // can also be specified on the store
 * let grid = new Grid({
 *     store : {
 *         groupers : [
 *             { field : 'city', ascending : false }
 *         ]
 *     }
 * });
 *
 * // custom sorting function can also be specified on the store
 * let grid = new Grid({
 *     store : {
 *         groupers : [{
 *             field : 'city',
 *             fn : (recordA, recordB) => {
 *                 // apply custom logic, for example:
 *                 return recordA.city.length < recordB.city.length ? -1 : 1;
 *             }
 *         }]
 *     }
 * });
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/grouping
 * @classtype group
 * @externalexample feature/Group.js
 */

var Group = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default()(Group, _InstancePlugin);

  var _super = _createSuper(Group);

  function Group() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default()(this, Group);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(Group, [{
    key: "construct",
    //region Init
    value: function construct(grid, config) {
      var me = this;

      if (grid.features.tree) {
        return;
      } // groupSummary feature needs to be initialized first, if it is used


      me._thisIsAUsedExpression(grid.features.groupSummary); // process initial config into an actual config object


      config = me.processConfig(config);
      me.grid = grid;
      me.rowManager = grid.rowManager;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Group.prototype), "construct", this).call(this, grid, config);

      me.bindStore(grid.store);
      me.rowManager.on({
        beforeRenderRow: 'onBeforeRenderRow',
        renderCell: 'renderCell',
        // The feature gets to see cells being rendered before the GroupSummary feature
        // because this injects header content into group header rows and adds rendering
        // info to the cells renderData which GroupSummary must comply with.
        prio: 1100,
        thisObj: me
      });
    } // Group feature handles special config cases, where user can supply a string or a group config object
    // instead of a normal config object

  }, {
    key: "processConfig",
    value: function processConfig(config) {
      if (typeof config === 'string') {
        return {
          field: config,
          ascending: null
        };
      }

      return config;
    } // override setConfig to process config before applying it (used mainly from ReactGrid)

  }, {
    key: "setConfig",
    value: function setConfig(config) {
      if (config === null) {
        this.store.clearGroupers();
      } else {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Group.prototype), "setConfig", this).call(this, this.processConfig(config));
      }
    }
  }, {
    key: "bindStore",
    value: function bindStore(store) {
      this.detachListeners('store');
      store.on({
        name: 'store',
        group: 'onStoreGroup',
        thisObj: this
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Group.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      var store = this.store; // Grouping mostly happens in store, need to clear groupers there to remove headers.
      // Use configured groupers as first sorters to somewhat maintain the order

      if (disable && store.isGrouped) {
        var sorters = store.sorters;
        sorters.unshift.apply(sorters, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_19___default()(store.groupers));
        store.clearGroupers();
        store.sort(sorters);
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Group.prototype), "doDisable", this).call(this, disable);
    }
  }, {
    key: "toggleCollapse",
    //endregion
    //region Expand/collapse

    /**
     * Collapses or expands a group depending on its current state
     * @param recordOrId Record or records id for a group row to collapse or expand
     * @param collapse Force collapse (true) or expand (true)
     * @fires togglegroup
     */
    value: function toggleCollapse(recordOrId, collapse) {
      this.internalToggleCollapse(recordOrId, collapse);
    }
    /**
     * Collapses or expands a group depending on its current state
     * @param recordOrId Record or records id for a group row to collapse or expand
     * @param collapse Force collapse (true) or expand (true)
     * @param skipRender True to not render rows
     * @internal
     * @fires togglegroup
     */

  }, {
    key: "internalToggleCollapse",
    value: function internalToggleCollapse(recordOrId, collapse) {
      var skipRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          store = me.store,
          groupRecord = store.getById(recordOrId),
          meta = groupRecord.meta;
      if (meta.groupRowFor === undefined) return;
      collapse = collapse === undefined ? !meta.collapsed : collapse;

      if (collapse) {
        store.excludeGroupRecords(groupRecord);
      } else {
        store.includeGroupRecords(groupRecord);
      } // note to self, all this could be done in collapsed setter on GroupModel if desired...


      meta.collapsed = collapse;
      /**
       * Group expanded or collapsed
       * @event toggleGroup
       * @param groupRecord Group record
       * @param {Boolean} collapse Collapsed (true) or expanded (false)
       */

      me.grid.trigger('toggleGroup', {
        groupRecord: groupRecord,
        collapse: collapse
      });

      if (!skipRender) {
        // render from grouprecord and down, no need to touch those above
        me.rowManager.renderFromRecord(groupRecord);
      }
    }
    /**
     * Collapse all groups. This function is exposed on Grid and can thus be called as `grid.collapseAll()`
     */

  }, {
    key: "collapseAll",
    value: function collapseAll() {
      var me = this;

      if (me.store.isGrouped && !me.disabled) {
        me.store.groupRecords.forEach(function (r) {
          return me.internalToggleCollapse(r, true, true);
        });
        me.grid.refreshRows(true);
      }
    }
    /**
     * Expand all groups. This function is exposed on Grid and can thus be called as `grid.expandAll()`
     */

  }, {
    key: "expandAll",
    value: function expandAll() {
      var me = this;

      if (me.store.isGrouped && !me.disabled) {
        me.store.groupRecords.forEach(function (r) {
          return me.internalToggleCollapse(r, false, true);
        });
        me.grid.refreshRows();
      }
    } //endregion
    //region Rendering

    /**
     * Called before rendering row contents, used to reset rows no longer used as group rows
     * @private
     */

  }, {
    key: "onBeforeRenderRow",
    value: function onBeforeRenderRow(_ref) {
      var row = _ref.row,
          record = _ref.record;
      // row.id contains previous record id on before render
      var oldRecord = row.grid.store.getById(row.id); // force update of inner html if this row used for group data

      row.forceInnerHTML = row.forceInnerHTML || oldRecord && 'groupRowFor' in oldRecord.meta;
    }
    /**
     * Called when a cell is rendered, styles the group rows first cell.
     * @private
     */

  }, {
    key: "renderCell",
    value: function renderCell(renderData) {
      var me = this; // no need to run the code below if not grouping or of feature is disabled

      if (!me.store.isGrouped || me.disabled) {
        return;
      }

      var cellElement = renderData.cellElement,
          rowElement = renderData.rowElement,
          column = renderData.column,
          grid = me.grid,
          meta = renderData.record.meta,
          firstColumn = grid.columns.visibleColumns[0],
          firstSubGridColumns = grid.subGrids[grid.regions[0]].columns.visibleColumns;

      if ('groupRowFor' in meta) {
        // do nothing with action column to make possible using actions for groups
        if (column.type === 'action') {
          return;
        } // let column clear the cell, in case it needs to do some cleanup


        column.clearCell(cellElement); // this is a group row, add css classes
        // IE11 doesnt support this
        //rowElement.classList.toggle('b-grid-group-collapsed', meta.collapsed === undefined ? false : meta.collapsed);

        rowElement.classList[meta.collapsed ? 'add' : 'remove']('b-grid-group-collapsed');
        rowElement.classList.add('b-group-row');

        if (firstColumn.type === 'rownumber' && column === firstSubGridColumns[1] || firstColumn.type !== 'rownumber' && column === firstSubGridColumns[0]) {
          cellElement.classList.add('b-group-title');
        }

        me.buildGroupHeader(renderData);
      } else {
        // not a group row, remove css classes
        // TODO: use dom query to remove before render instead?
        if (cellElement === rowElement.firstElementChild) {
          // IE11 doesnt support this
          //rowElement.classList.remove('b-group-row', 'b-grid-group-collapsed');
          rowElement.classList.remove('b-group-row');
          rowElement.classList.remove('b-grid-group-collapsed');
          cellElement.classList.remove('b-group-title');
        }
      }
    } // renderData.cellElement is required

  }, {
    key: "buildGroupHeader",
    value: function buildGroupHeader(renderData) {
      var me = this,
          record = renderData.record,
          cellElement = renderData.cellElement,
          column = renderData.column,
          persist = renderData.persist,
          grid = me.grid,
          meta = record.meta,
          count = meta.childCount - (grid.features.groupSummary ? 1 : 0),
          firstVisibleColumn = grid.columns.visibleColumns[0],
          firstSubGridColumns = column && grid.subGrids[grid.regions[0]].columns.visibleColumns,
          isFirstColumn = renderData.isFirstColumn = firstVisibleColumn.type === 'rownumber' && column === firstSubGridColumns[1] || firstVisibleColumn.type !== 'rownumber' && column === firstSubGridColumns[0];
      var html = null,
          applyDefault = true;

      if (persist || column) {
        var groupColumn = grid.columns.get(meta.groupField); // First try using columns groupRenderer (might not even have a column if grouping programmatically)

        if (groupColumn === null || groupColumn === void 0 ? void 0 : groupColumn.groupRenderer) {
          if (isFirstColumn) {
            // groupRenderer could return nothing and just apply changes directly to DOM element
            html = groupColumn.groupRenderer(Object.assign({}, renderData, {
              groupRowFor: meta.groupRowFor,
              groupRecords: record.groupChildren,
              groupColumn: groupColumn,
              count: count
            }));
            applyDefault = false;
          }
        } // Secondly use features groupRenderer, if configured with one
        else if (me.groupRenderer) {
            // groupRenderer could return nothing and just apply changes directly to DOM element
            html = me.groupRenderer(Object.assign({}, renderData, {
              groupRowFor: meta.groupRowFor,
              groupRecords: record.groupChildren,
              groupColumn: groupColumn,
              count: count,
              isFirstColumn: isFirstColumn
            }));
          } // Third, just display unformatted value and child count (also applied for features groupRenderer that do
        // not output any html of their own)


        if (isFirstColumn && html == null && applyDefault) {
          html = "".concat(meta.groupRowFor === '__novalue__' ? '' : meta.groupRowFor, " (").concat(count, ")");
        }
      } else if (me.groupRenderer) {
        // groupRenderer could return nothing and just apply changes directly to DOM element
        html = me.groupRenderer(renderData);
      } // Renderers could return nothing and just apply changes directly to DOM element


      if (typeof html === 'string') {
        cellElement.innerHTML = html;
      } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_18___default()(html) === 'object') {
        _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_30__["default"].sync({
          targetElement: cellElement,
          domConfig: {
            onlyChildren: true,
            children: Array.isArray(html) ? html : [html]
          }
        });
      } // If groupRenderer added elements to the cell, we need to remember that to clear it on re-usage as a normal cell


      if (cellElement.childElementCount > 0) {
        cellElement._hasHtml = true;
      }

      return cellElement.innerHTML;
    }
    /**
     * Called when an header is rendered, adds grouping icon if grouped by that column.
     * @private
     * @param headerContainerElement
     */

  }, {
    key: "renderHeader",
    value: function renderHeader(headerContainerElement) {
      var store = this.store,
          grid = this.grid;

      if (store.isGrouped) {
        // Sorted from start, reflect in rendering
        var _iterator = _createForOfIteratorHelper(store.groupers),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var groupInfo = _step.value;
            // Might be grouping by field without column, which is valid
            var column = grid.columns.get(groupInfo.field),
                header = column && grid.getHeaderElement(column.id); // IE11 doesnt support this
            //header && header.classList.add('b-group', groupInfo.ascending ? 'b-asc' : 'b-desc');

            if (header) {
              header.classList.add('b-group');
              header.classList.add(groupInfo.ascending ? 'b-asc' : 'b-desc');
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    } //endregion
    //region Context menu

    /**
     * Supply items for headers context menu.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateHeaderMenu",
    value: function populateHeaderMenu(_ref2) {
      var column = _ref2.column,
          items = _ref2.items;
      var me = this;

      if (column.groupable !== false) {
        items.groupAsc = {
          text: 'L{groupAscending}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-group-asc',
          name: 'groupAsc',
          cls: 'b-separator',
          weight: 400,
          disabled: me.disabled,
          onItem: function onItem() {
            return me.store.group(column.field, true);
          }
        };
        items.groupDesc = {
          text: 'L{groupDescending}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-group-desc',
          name: 'groupDesc',
          weight: 410,
          disabled: me.disabled,
          onItem: function onItem() {
            return me.store.group(column.field, false);
          }
        };
      }

      if (me.store.isGrouped) {
        items.groupRemove = {
          text: 'L{stopGrouping}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-clear',
          name: 'groupRemove',
          cls: column.groupable ? '' : 'b-separator',
          weight: 420,
          disabled: me.disabled,
          onItem: function onItem() {
            return me.store.clearGroupers();
          }
        };
      }
    }
    /**
     * Supply items to ColumnDragToolbar
     * @private
     */

  }, {
    key: "getColumnDragToolbarItems",
    value: function getColumnDragToolbarItems(column, items) {
      var _store$groupers;

      var me = this,
          store = me.store;
      items.push({
        text: 'L{groupAscendingShort}',
        group: 'L{group}',
        localeClass: me,
        icon: 'b-icon b-icon-group-asc',
        name: 'groupAsc',
        cls: 'b-separator',
        weight: 110,
        disabled: me.disabled,
        onDrop: function onDrop(_ref3) {
          var column = _ref3.column;
          return store.group(column.field, true);
        }
      });
      items.push({
        text: 'L{groupDescendingShort}',
        group: 'L{group}',
        localeClass: me,
        icon: 'b-icon b-icon-group-desc',
        name: 'groupDesc',
        weight: 110,
        disabled: me.disabled,
        onDrop: function onDrop(_ref4) {
          var column = _ref4.column;
          return store.group(column.field, false);
        }
      });
      var grouped = ((_store$groupers = store.groupers) === null || _store$groupers === void 0 ? void 0 : _store$groupers.some(function (col) {
        return col.field === column.field;
      })) && !me.disabled;
      items.push({
        text: 'L{stopGroupingShort}',
        group: 'L{group}',
        localeClass: me,
        icon: 'b-icon b-icon-clear',
        name: 'groupRemove',
        disabled: !grouped,
        weight: 110,
        onDrop: function onDrop(_ref5) {
          var column = _ref5.column;
          return store.removeGrouper(column.field);
        }
      });
      return items;
    } //endregion
    //region Events - Store

    /**
     * Called when store grouping changes. Reflects on header and rerenders rows.
     * @private
     */

  }, {
    key: "onStoreGroup",
    value: function onStoreGroup(_ref6) {
      var groupers = _ref6.groupers;
      var grid = this.grid,
          element = grid.element,
          curGroupHeaders = element && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].children(element, '.b-grid-header.b-group');

      if (element) {
        var _iterator2 = _createForOfIteratorHelper(curGroupHeaders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _header = _step2.value;
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].removeClasses(_header, ['b-group', 'b-asc', 'b-desc']);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (groupers) {
          var _iterator3 = _createForOfIteratorHelper(groupers),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var groupInfo = _step3.value;
              var header = grid.getHeaderElementByField(groupInfo.field);

              if (header) {
                _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].addClasses(header, ['b-group', groupInfo.ascending ? 'b-asc' : 'b-desc']);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }
    } //endregion
    //region Events - Grid

    /**
     * Store touches when user touches header, used in onElementTouchEnd.
     * @private
     */

  }, {
    key: "onElementTouchStart",
    value: function onElementTouchStart(event) {
      var me = this,
          target = event.target,
          header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].up(target, '.b-grid-header'),
          column = header && me.grid.getColumnFromElement(header); // If it's a multi touch, group.

      if (event.touches.length > 1 && column && column.groupable !== false && !me.disabled) {
        me.store.group(column.field);
      }
    }
    /**
     * React to click on headers (to group by that column if [alt] is pressed) and on group rows (expand/collapse).
     * @private
     * @param event
     * @returns {Boolean}
     */

  }, {
    key: "onElementClick",
    value: function onElementClick(event) {
      var me = this,
          store = me.store,
          target = event.target,
          row = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].up(target, '.b-group-row'),
          header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].up(target, '.b-grid-header'),
          field = header === null || header === void 0 ? void 0 : header.dataset.column; // prevent expand/collapse if disabled or clicked on item with own handler

      if (target.classList.contains('b-resizer') || me.disabled || target.classList.contains('b-action-item')) {
        return;
      } // Header


      if (header && field) {
        var _store$groupers2;

        var columnGrouper = (_store$groupers2 = store.groupers) === null || _store$groupers2 === void 0 ? void 0 : _store$groupers2.find(function (g) {
          return g.field === field;
        }); // Store has a grouper for this column's field; flip grouper order

        if (columnGrouper && !event.shiftKey) {
          store.group(field, !columnGrouper.ascending);
          return false;
        } // Group or ungroup
        else if (event.shiftKey) {
            var column = me.grid.columns.get(field);

            if (column.groupable !== false) {
              if (event.altKey) {
                store.removeGrouper(field);
              } else {
                store.group(field);
              }
            }
          }

        event.preventDefault();
      } // Anywhere on group-row


      if (row) {
        me.internalToggleCollapse(_Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_26__["default"].get(row).id);
        return false;
      }
    }
    /**
     * Toggle groups with [space].
     * @private
     * @param event
     * @returns {*}
     */

  }, {
    key: "onElementKeyDown",
    value: function onElementKeyDown(event) {
      var me = this; // only catch space on grid element, not in editors etc...

      if (!me.disabled && me.store.isGrouped && event.target === me.grid.focusElement && event.key === ' ' && me.grid.focusedCell) {
        event.preventDefault();
        me.internalToggleCollapse(me.grid.focusedCell.id);
      }
    } //endregion

  }, {
    key: "renderer",
    set: function set(renderer) {
      this.groupRenderer = renderer;
    }
  }, {
    key: "field",
    set: function set(field) {
      this._field = field;
      this.store.group(field, this.ascending);
    },
    get: function get() {
      return this._field;
    }
  }, {
    key: "store",
    get: function get() {
      return this.grid.store;
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Grid.

  }], [{
    key: "$name",
    get: function get() {
      return 'Group';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The name of the record field to group by.
         * @config {String}
         * @default
         */
        field: null,

        /**
         * A function which produces the HTML for a group header.
         * The function is called in the context of this Group feature object.
         * Default group renderer displays the `groupRowFor` and `count`.
         *
         * @config {Function}
         * @property {String} groupRowFor The value of the `field` for the group.
         * @property {Core.data.Model} record The group record representing the group.
         * @property {Object} record.meta Meta data with additional info about the grouping.
         * @property {Array} record.groupChildren The group child records.
         * @property {Number} count Number of records in the group.
         * @property {Grid.column.Column} column The column the renderer runs for.
         * @property {Boolean} isFirstColumn True, if `column` is the first column.
         * If `RowNumberColumn` is the real first column, it's not taken into account.
         * @property {Grid.column.Column} [groupColumn] The column under which the `field` is shown.
         * @property {Object} size Sizing information for the group header row, only `height` is relevant.
         * @property {Number} size.height The height of the row, set this if you want a custom height for the group header row
         * That is UI part, so do not rely on its existence.
         * @default
         */
        renderer: null
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        assign: ['collapseAll', 'expandAll'],
        chain: ['renderHeader', 'populateHeaderMenu', 'getColumnDragToolbarItems', 'onElementTouchStart', 'onElementClick', 'onElementKeyDown', 'bindStore']
      };
    }
  }]);

  return Group;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_28__["default"]);


Group._$name = 'Group';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_29__["default"].registerFeature(Group, true, ['Grid', 'Scheduler']);

/***/ }),

/***/ "./lib/Grid/feature/GroupSummary.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/GroupSummary.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GroupSummary; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./mixin/SummaryFormatter.js */ "./lib/Grid/feature/mixin/SummaryFormatter.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Grid/feature/GroupSummary
 */

/**
 * Displays a summary row as a group footer in a grouped grid. Uses same configuration options on columns as
 * {@link Grid.feature.Summary}.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * ```
 * features : {
 *     group        : 'city',
 *     groupSummary : true
 * }
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/groupsummary
 * @classtype groupSummary
 * @externalexample feature/GroupSummary.js
 */

var GroupSummary = /*#__PURE__*/function (_SummaryFormatter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(GroupSummary, _SummaryFormatter);

  var _super = _createSuper(GroupSummary);

  function GroupSummary() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, GroupSummary);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(GroupSummary, [{
    key: "construct",
    value: function construct(grid, config) {
      this.grid = grid;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(GroupSummary.prototype), "construct", this).call(this, grid, config);

      if (!grid.features.group) {
        throw new Error('Requires Group feature to work, please enable');
      }

      this.bindStore(grid.store);
      grid.rowManager.on({
        beforeRenderRow: 'onBeforeRenderRow',
        renderCell: 'renderCell',
        // The feature gets to see cells being rendered after the Group feature
        // because the Group feature injects header content into group header rows
        // and adds rendering info to the cells renderData which we must comply with.
        // In particular, it calculates the isFirstColumn flag which it adds to
        // the cell renderData which we interrogate.
        prio: 1000,
        thisObj: this
      });
    }
  }, {
    key: "bindStore",
    value: function bindStore(store) {
      this.detachListeners('store');
      store.on({
        name: 'store',
        update: 'onStoreUpdate',
        // need to run before grids listener, to flag for full refresh
        prio: 1,
        thisObj: this
      });
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      // Flag that will make the Store insert rows for group footers
      this.store.useGroupFooters = !disable; // Refresh groups to show/hide footers

      if (!this.isConfiguring) {
        this.store.group();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(GroupSummary.prototype), "doDisable", this).call(this, disable);
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "onBeforeRenderRow",
    //endregion
    //region Render

    /**
     * Called before rendering row contents, used to reset rows no longer used as group summary rows
     * @private
     */
    value: function onBeforeRenderRow(_ref) {
      var row = _ref.row,
          record = _ref.record;

      if (row.isGroupFooter && !('groupFooterFor' in record.meta)) {
        // not a group row, remove css
        row.isGroupFooter = false;
        row.removeCls('b-group-footer'); // force full "redraw" when rendering cells

        row.forceInnerHTML = true;
      } else if (row.isGroupHeader && !record.meta.collapsed) {
        row.removeCls('b-header-summary'); // remove any summary elements

        row.eachElement(this.removeSummaryElements);
      }
    }
  }, {
    key: "removeSummaryElements",
    value: function removeSummaryElements(rowEl) {
      var summaryElement = rowEl.querySelector('.b-timeaxis-group-summary');
      summaryElement === null || summaryElement === void 0 ? void 0 : summaryElement.remove();
    }
    /**
     * Called when a cell is rendered, styles the group rows first cell.
     * @private
     */

  }, {
    key: "renderCell",
    value: function renderCell(_ref2) {
      var column = _ref2.column,
          cellElement = _ref2.cellElement,
          rowElement = _ref2.rowElement,
          row = _ref2.row,
          record = _ref2.record,
          size = _ref2.size,
          isFirstColumn = _ref2.isFirstColumn;
      var me = this,
          meta = record.meta,
          isGroupHeader = ('groupRowFor' in meta),
          isGroupFooter = ('groupFooterFor' in meta); // no need to do the code below if not grouping

      if (!me.store.isGrouped) return; // Should we generate summary content in this cell?
      // We should if this is a group footer row.
      // We also should if it's a collapsed group header and we are configured to put
      // the summary in the header on collapse, *and* if it's not the first column
      // as defined by the Group feature.

      if (isGroupFooter || me.collapseToHeader && isGroupHeader && meta.collapsed && !isFirstColumn) {
        var groupRecord = isGroupHeader ? record : meta.groupRecord;
        row.isGroupFooter = isGroupFooter;
        row.isGroupHeader = isGroupHeader; // This is a group footer row, add css

        if (isGroupFooter) {
          rowElement.classList.add('b-group-footer');
        } // This is a header row which is being used during collapsed state
        // to contain summary data because of the collapseToHeader config.
        else {
            rowElement.classList.add('b-header-summary');
          } // returns height config or count. config format is { height, count }. where `height is in px and should be
        // added to value calculated from `count


        var heightSetting = me.updateSummaryHtml(cellElement, column, groupRecord);
        var count = typeof heightSetting === 'number' ? heightSetting : heightSetting.count; // number of summaries returned, use to calculate cell height

        if (count > 1) {
          size.height = me.grid.rowHeight + count * me.grid.rowHeight * 0.1;
        } // height config with height specified, added to cell height


        if (heightSetting.height) {
          size.height += heightSetting.height;
        }
      }
    }
  }, {
    key: "updateSummaryHtml",
    value: function updateSummaryHtml(cellElement, column, groupRecord) {
      var records = groupRecord.groupChildren.slice();
      records.pop(); // last record is group footer, remove

      var html = this.generateHtml(column, records, 'b-grid-group-summary'); // First time, set table

      if (!cellElement.children.length) {
        cellElement.innerHTML = html;
      } // Following times, sync changes
      else {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].sync(html, cellElement.firstElementChild);
        } // return summary "count", used to set row height


      return column.summaries ? column.summaries.length : column.sum ? 1 : 0;
    } //endregion
    //region Events

    /**
     * Updates summaries on store changes (except record update, handled below)
     * @private
     */

  }, {
    key: "onStoreUpdate",
    value: function onStoreUpdate(_ref3) {
      var _this = this;

      var store = _ref3.source,
          changes = _ref3.changes;

      if (!this.disabled && store.isGrouped) {
        // If a grouping field is among the changes, StoreGroup#onDataChanged will
        // take care of the update by re-sorting.
        if (changes && store.groupers.find(function (grouper) {
          return grouper.field in changes;
        })) {
          return;
        } // only update summary when a field that affects summary is changed
        // TODO: this should maybe be removed, another column might depend on the value for its summary?


        var shouldUpdate = Object.keys(changes).some(function (field) {
          var colField = _this.grid.columns.get(field); // check existence, since a field not used in a column might have changed


          return Boolean(colField) && (Boolean(colField.sum) || Boolean(colField.summaries));
        });

        if (shouldUpdate) {
          this.grid.forceFullRefresh = true;
        }
      }
    } //endregion

  }, {
    key: "store",
    get: function get() {
      return this.grid.store;
    }
  }], [{
    key: "$name",
    //region Init
    get: function get() {
      return 'GroupSummary';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * Configure as true to have group summaries rendered in the group header when a group is collapsed.
         * @config {Boolean}
         */
        collapseToHeader: null
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['bindStore']
      };
    }
  }]);

  return GroupSummary;
}(Object(_mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_15__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]));


GroupSummary.featureClass = 'b-group-summary';
GroupSummary._$name = 'GroupSummary';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(GroupSummary);

/***/ }),

/***/ "./lib/Grid/feature/HeaderMenu.js":
/*!****************************************!*\
  !*** ./lib/Grid/feature/HeaderMenu.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HeaderMenu; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Grid_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Grid/feature/base/ContextMenuBase.js */ "./lib/Grid/feature/base/ContextMenuBase.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Grid/feature/HeaderMenu
 */

/**
 * Right click column header or focus it and press SPACE key to show the context menu for headers.
 *
 * ### Default header menu items
 *
 * The Header menu has no default items provided by the `HeaderMenu` feature, but there are other features
 * that populate the header menu with the following items:
 *
 * | Item reference    | Text                              | Weight | Feature        | Enabled by default | Description                                                                   |
 * |-------------------|-----------------------------------|--------|----------------|--------------------|-------------------------------------------------------------------------------|
 * | `filter`          | Filter                            | 100    | `Filter`       | false              | Shows filter field below the column header to enter a new value               |
 * | `editFilter`      | Edit filter                       | 100    | `Filter`       | false              | Shows filter field below the column header to change/remove the filter value  |
 * | `removeFilter`    | Remove filter                     | 110    | `Filter`       | false              | Stops filtering by selected column field                                      |
 * | `toggleFilterBar` | Hide filter bar / Show filter bar | 120    | `FilterBar`    | false              | Toggles filter bar visibility                                                 |
 * | `columnPicker`    | Columns                           | 200    | `ColumnPicker` | true               | Shows a submenu to control columns visibility                                 |
 * | \>column.id*      | column.text*                      |        | `ColumnPicker` | true               | Check item to hide/show corresponding column                                  |
 * | `hideColumn`      | Hide column                       | 210    | `ColumnPicker` | true               | Hides selected column                                                         |
 * | `sortAsc`         | Sort ascending                    | 300    | `Sort`         | true               | Sorts records in the store by the column field in ascending order             |
 * | `sortDesc`        | Sort descending                   | 310    | `Sort`         | true               | Sorts records in the store by the column field in descending order            |
 * | `multiSort`       | Multi sort                        | 320    | `Sort`         | true               | Shows a submenu to control multi-sorting                                      |
 * | \>`addSortAsc`    | Add ascending sorting             | 330    | `Sort`         | true               | Adds additional ascending sorting by the column field                         |
 * | \>`addSortDesc`   | Add descending sorting            | 340    | `Sort`         | true               | Adds additional ascending sorting by the column field                         |
 * | \>`removeSorter`  | Remove sorter                     | 350    | `Sort`         | true               | Stops sorting by selected column field                                        |
 * | `groupAsc`        | Group ascending                   | 400    | `Group`        | true               | Groups and sorts records in the store by the column field in ascending order  |
 * | `groupDesc`       | Group descending                  | 410    | `Group`        | true               | Groups and sorts records in the store by the column field in descending order |
 * | `groupRemove`     | Stop grouping                     | 420    | `Group`        | true               | Stops grouping                                                                |
 *
 * \* - items that are generated dynamically
 *
 * \> - first level of submenu
 *
 * ### Customizing the menu items
 *
 * The menu items in the Header menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * Add extra items for all columns:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     headerMenu : {
 *       items : {
 *         extraItem : { text: 'My header item', icon: 'fa fa-car', weight: 200, onItem : () => ... }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * It is also possible to add items using columns config. See examples below.
 *
 * Add extra items for a single column:
 *
 * ```javascript
 * const grid = new Grid({
 *   columns: [
 *     {
 *       field: 'name',
 *       text: 'Name',
 *       headerMenuItems: {
 *         columnItem : { text: 'My unique header item', icon: 'fa fa-flask', onItem : () => ... }
 *       }
 *     }
 *   ]
 * });
 * ```
 *
 * Remove built in item:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     headerMenu : {
 *       items : {
 *          // Hide 'Stop grouping'
 *          groupRemove : false
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * Customize built in item:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     headerMenu : {
 *       items : {
 *          hideColumn : {
 *              text : 'Bye bye column'
 *          }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * It is also possible to manipulate the default items and add new items in the processing function:
 *
 * ```javascript
 * const grid = new Grid({
 *   features : {
 *     headerMenu : {
 *       processItems({items, record}) {
 *           if (record.cost > 5000) {
 *              items.myItem = { text : 'Split cost' };
 *           }
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the "Customizing the Cell menu and the Header menu" guide.
 *
 * This feature is <strong>enabled</strong> by default.
 *
 * @extends Grid/feature/base/ContextMenuBase
 * @demo Grid/filtering
 * @classtype headerMenu
 * @externalexample feature/HeaderMenu.js
 */

var HeaderMenu = /*#__PURE__*/function (_ContextMenuBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(HeaderMenu, _ContextMenuBase);

  var _super = _createSuper(HeaderMenu);

  function HeaderMenu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, HeaderMenu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(HeaderMenu, [{
    key: "onElementKeyDown",
    //endregion
    //region Events

    /**
     * Fired from grid before the context menu is shown for a header.
     * Allows manipulation of the items to show in the same way as in the {@link Grid.feature.base.ContextMenuBase#config-processItems}.
     *
     * Returning `false` from a listener prevents the menu from being shown.
     *
     * @event headerMenuBeforeShow
     * @preventable
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} items Menu item configs
     * @param {Grid.column.Column} column Column
     */

    /**
     * Fired from grid after the context menu is shown for a header
     * @event headerMenuShow
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} items Menu item configs
     * @param {Grid.column.Column} column Column
     */

    /**
     * Fired from grid when an item is selected in the header context menu.
     * @event headerMenuItem
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} item Selected menu item
     * @param {Grid.column.Column} column Column
     */

    /**
     * Fired from grid when a check item is toggled in the header context menu.
     * @event headerMenuToggleItem
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} item Selected menu item
     * @param {Grid.column.Column} column Column
     * @param {Boolean} checked Checked or not
     */
    //endregion
    value: function onElementKeyDown(event) {
      if (!event.handled && event.target.matches('.b-grid-header.b-depth-0')) {
        switch (event.key) {
          case ' ':
            this.internalShowContextMenu(this.createContextMenuEventForElement(event.target));
            break;
        }
      }
    } //region Menu handlers

  }, {
    key: "shouldShowMenu",
    value: function shouldShowMenu(eventParams) {
      var column = eventParams.column; // TODO: remove "this._showForTimeAxis || " when support for HeaderContextMenu feature in Scheduler is dropped.

      return column && column.enableHeaderContextMenu !== false && (this._showForTimeAxis || column !== this.client.timeAxisColumn);
    } // TODO: remove "showContextMenu" override completely when support for HeaderContextMenu feature in Scheduler is dropped.

  }, {
    key: "showContextMenu",
    value: function showContextMenu(_ref) {
      var column = _ref.column;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(HeaderMenu.prototype), "showContextMenu", this).apply(this, arguments);

      if (column === this.client.timeAxisColumn && this.menu) {
        // the TimeAxis's context menu probably will cause scrolls because it manipulates the dates.
        // The menu should not hide on scroll when for a TimeAxisColumn
        this.menu.scrollAction = 'realign';
      }
    }
  }, {
    key: "getDataFromEvent",
    value: function getDataFromEvent(event) {
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].assign(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(HeaderMenu.prototype), "getDataFromEvent", this).call(this, event), this.client.getHeaderDataFromEvent(event));
    }
  }, {
    key: "populateHeaderMenu",
    value: function populateHeaderMenu(_ref2) {
      var items = _ref2.items,
          column = _ref2.column;

      if (column === null || column === void 0 ? void 0 : column.headerMenuItems) {
        if (Array.isArray(column.headerMenuItems)) {
          _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].deprecate('Grid', '5.0.0', '`headerMenuItems` column config specified as an array is deprecated, need to specify the config as a named object. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.');
        } // Array works smoothly since number index turns into a key for named object


        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].merge(items, column.headerMenuItems);
      }

      return items;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'HeaderMenu';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        type: 'header',
        // private "hack" to provide backward compatibility for deprecated HeaderContextMenu feature in Scheduler
        _showForTimeAxis: false
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      var config = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(HeaderMenu), "pluginConfig", this);

      config.chain.push('populateHeaderMenu');
      return config;
    }
  }]);

  return HeaderMenu;
}(_Grid_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


HeaderMenu.featureClass = '';
HeaderMenu._$name = 'HeaderMenu';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(HeaderMenu, true);

/***/ }),

/***/ "./lib/Grid/feature/QuickFind.js":
/*!***************************************!*\
  !*** ./lib/Grid/feature/QuickFind.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return QuickFind; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.search */ "./node_modules/core-js/modules/es.string.search.js");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");



























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Handle date columns
//TODO: Icons to navigate between hits in the header? or in each cell?
//TODO: Icon to clear quickfind in header
//TODO: regex for valid key pressed?






/**
 * @module Grid/feature/QuickFind
 */

/**
 * Feature that allows the user to search in a column by focusing a cell and typing. Navigate between hits using the
 * keyboard, [f3] or [ctrl]/[cmd] + [g] moves to next, also pressing [shift] moves to previous.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // enable QuickFind
 * let grid = new Grid({
 *   features: {
 *     quickFind: true
 *   }
 * });
 *
 * // navigate to next hit programmatically
 * grid.features.quickFind.gotoNextHit();
 *
 * @demo Grid/quickfind
 * @classtype quickFind
 * @externalexample feature/QuickFind.js
 */

var QuickFind = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default()(QuickFind, _InstancePlugin);

  var _super = _createSuper(QuickFind);

  function QuickFind() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default()(this, QuickFind);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(QuickFind, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(grid, config) {
      this.grid = grid;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(QuickFind.prototype), "construct", this).call(this, grid, config);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      if (disable) {
        this.clear();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(QuickFind.prototype), "doDisable", this).call(this, disable);
    }
  }, {
    key: "showQuickFind",
    //endregion
    //region Show/hide QuickFind

    /**
     * Shows a "searchfield" in the header. Triggered automatically when you have a cell focused and start typing.
     * @private
     */
    value: function showQuickFind() {
      var me = this,
          header = me.grid.getHeaderElement(me.columnId);

      if (header) {
        if (!me.headerField) {
          var _DomHelper$createElem = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].createElement({
            tag: 'div',
            className: 'b-quick-hit-header',
            children: [{
              tag: 'div',
              className: 'b-quick-hit-field'
            }, {
              tag: 'div',
              className: 'b-quick-hit-badge'
            }]
          }, true),
              _DomHelper$createElem2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19___default()(_DomHelper$createElem, 3),
              element = _DomHelper$createElem2[0],
              field = _DomHelper$createElem2[1],
              badge = _DomHelper$createElem2[2];

          if (me.mode === 'header') {
            header.appendChild(element);
          } else {
            element.className += ' b-quick-hit-mode-grid';
            me.grid.element.appendChild(element);
          }

          me.headerField = {
            header: element,
            field: field,
            badge: badge,
            colHeader: header
          };
        }

        me.headerField.field.innerHTML = me.find;
        me.headerField.badge.innerHTML = me.found.length;
        header.classList.add('b-quick-find-header');

        if (!me.renderListenerInitialized) {
          me.grid.rowManager.on({
            rendercell: me.renderCell,
            thisObj: me
          });
          me.renderListenerInitialized = true;
        }
      }
    }
    /**
     * Hide the "searchfield" and remove highlighted hits. Called automatically when pressing [esc] or backspacing away
     * the keywords.
     * @private
     */

  }, {
    key: "hideQuickFind",
    value: function hideQuickFind() {
      var me = this,
          grid = me.grid,
          headerField = me.headerField; // rerender cells to remove quick-find markup

      var _iterator = _createForOfIteratorHelper(me.prevFound || me.found),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var hit = _step.value;
          var row = grid.getRowById(hit.id);

          if (row) {
            var cell = row.getCell(me.columnId);
            cell._content = null;
            row.renderCell(cell, hit.data);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (headerField) {
        headerField.header.parentNode.removeChild(headerField.header);
        headerField.colHeader.classList.remove('b-quick-find-header');
        me.headerField = null;
      }

      if (me.renderListenerInitialized) {
        grid.rowManager.un({
          rendercell: me.renderCell
        }, me);
        me.renderListenerInitialized = false;
      }

      grid.trigger('hideQuickFind');
    } //endregion
    //region Search

    /**
     * Performs a search and highlights hits. If find is empty, QuickFind is closed.
     * @param find Text to search for
     * @param columnFieldOrId Column to search
     */

  }, {
    key: "search",
    value: function search(find) {
      var columnFieldOrId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.columnId;
      var me = this,
          grid = me.grid,
          currentColumn = me.currentColumn,
          column = grid.columns.getById(columnFieldOrId) || grid.columns.get(columnFieldOrId),
          found = me.store.findByField(column.field, find);
      var i = 1;
      Object.assign(me, {
        foundMap: {},
        prevFound: me.found,
        found: found,
        find: find,
        columnId: column.id
      });

      if (find) {
        me.showQuickFind();
      } else {
        me.hideQuickFind();
      } // reset column to use its normal settings for htmlEncoding


      if (currentColumn && currentColumn !== column) currentColumn.disableHtmlEncode = false; // clear old hits

      var _iterator2 = _createForOfIteratorHelper(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].children(grid.element, '.b-quick-hit')),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var cell = _step2.value;
          //IE11 doesnt support this
          //cell.classList.remove('b-quick-hit', 'b-quick-hit-cell');
          cell.classList.remove('b-quick-hit');
          cell.classList.remove('b-quick-hit-cell'); // rerender cell to remove quick-hit-text

          var row = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_26__["default"].get(cell).row; // Cell caches its content for faster comparison, need to clear cache to have it rerendered

          cell._content = null;
          row.renderCell(cell);
        } // want to set innerHTML each time for cell decoration to work

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      column.disableHtmlEncode = true;
      me.currentColumn = column;
      if (!found) return;

      if (found.length > 0) {
        me.gotoClosestHit(grid.focusedCell, found);
      } // highlight hits for visible cells


      var _iterator3 = _createForOfIteratorHelper(found),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var hit = _step3.value;
          me.foundMap[hit.id] = i++;

          var _row = grid.getRowById(hit.data.id);

          if (_row) {
            _row.renderCell(_row.getCell(column.id));
          } // limit highlighted hits


          if (i > 1000) break;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      grid.trigger('quickFind', {
        find: find,
        found: found
      });
    }
    /**
     * Clears and closes QuickFind.
     */

  }, {
    key: "clear",
    value: function clear() {
      var _this$found;

      if ((_this$found = this.found) === null || _this$found === void 0 ? void 0 : _this$found.length) {
        this.search('');
      }
    }
    /**
     * Number of results found
     * @type {Number}
     * @readonly
     */

  }, {
    key: "gotoHit",

    /**
     * Found results (as returned by Store#findByField), an array in format { index: x, data: record }
     * @member {Object[]} found
     * @readonly
     */
    //endregion
    //region Navigation

    /**
     * Go to specified hit.
     * @param index
     */
    value: function gotoHit(index) {
      var nextHit = this.found[index];

      if (nextHit) {
        this.grid.focusCell({
          columnId: this.columnId,
          id: nextHit.id
        });
      }

      return !!nextHit;
    }
  }, {
    key: "gotoClosestHit",
    value: function gotoClosestHit(focusedCell, found) {
      var focusedIndex = focusedCell ? this.grid.store.indexOf(focusedCell.id) : 0,
          foundSorted = found.slice().sort(function (a, b) {
        return Math.abs(a.index - focusedIndex) - Math.abs(b.index - focusedIndex);
      });
      this.gotoHit(found.indexOf(foundSorted[0]));
    }
    /**
     * Go to the first hit.
     */

  }, {
    key: "gotoFirstHit",
    value: function gotoFirstHit() {
      this.gotoHit(0);
    }
    /**
     * Go to the last hit.
     */

  }, {
    key: "gotoLastHit",
    value: function gotoLastHit() {
      this.gotoHit(this.found.length - 1);
    }
    /**
     * Select the next hit, scrolling it into view. Triggered with [f3] or [ctrl]/[cmd] + [g].
     */

  }, {
    key: "gotoNextHit",
    value: function gotoNextHit() {
      var _grid$lastFocusedCell;

      var me = this,
          grid = me.grid,
          currentId = grid._focusedCell ? grid._focusedCell.id : (_grid$lastFocusedCell = grid.lastFocusedCell) === null || _grid$lastFocusedCell === void 0 ? void 0 : _grid$lastFocusedCell.id,
          currentIndex = grid.store.indexOf(currentId) || 0,
          nextHit = me.found.find(function (hit) {
        return hit.index > currentIndex;
      });

      if (nextHit) {
        grid.focusCell({
          columnId: me.columnId,
          id: nextHit.id
        });
      } else {
        me.gotoFirstHit();
      }
    }
    /**
     * Select the previous hit, scrolling it into view. Triggered with [shift] + [f3] or [shift] + [ctrl]/[cmd] + [g].
     */

  }, {
    key: "gotoPrevHit",
    value: function gotoPrevHit() {
      var _grid$lastFocusedCell2;

      var me = this,
          grid = me.grid,
          found = me.found,
          currentId = grid._focusedCell ? grid._focusedCell.id : (_grid$lastFocusedCell2 = grid.lastFocusedCell) === null || _grid$lastFocusedCell2 === void 0 ? void 0 : _grid$lastFocusedCell2.id,
          currentIndex = grid.store.indexOf(currentId) || 0;
      var prevHit;

      if (!found.length) {
        return;
      }

      for (var i = found.length - 1; i--; i >= 0) {
        if (found[i].index < currentIndex) {
          prevHit = found[i];
          break;
        }
      }

      if (prevHit) {
        grid.focusCell({
          columnId: me.columnId,
          id: prevHit.id
        });
      } else {
        me.gotoLastHit();
      }
    } //endregion
    //region Render

    /**
     * Called from SubGrid when a cell is rendered.
     * @private
     */

  }, {
    key: "renderCell",
    value: function renderCell(renderData) {
      var _me$foundMap;

      var me = this,
          cellElement = renderData.cellElement,
          foundMap = me.columnId === renderData.column.id && ((_me$foundMap = me.foundMap) === null || _me$foundMap === void 0 ? void 0 : _me$foundMap[renderData.record.id]);

      if (foundMap) {
        // Check also TreeColumn's special internal `shouldHtmlEncode` flag
        var htmlEncoded = renderData.column.htmlEncode || renderData.column.shouldHtmlEncode; // highlight cell

        cellElement.classList.add('b-quick-hit'); // Special treatment of columns outputting HTML, just highlight whole cell

        if (!htmlEncoded) {
          cellElement.classList.add('b-quick-hit-cell');
        } else {
          var _html;

          // if features have added other stuff to the cell, value is in div.b-grid-cell-value
          // highlight in cell if found in innerHTML
          var inner = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].down(cellElement, '.b-grid-cell-value,.b-tree-cell-value') || cellElement,
              html = inner.innerText,
              where = (_html = html) === null || _html === void 0 ? void 0 : _html.toLowerCase().indexOf(me.find.toLowerCase());

          if (where > -1) {
            var end = where + me.find.length,
                casedFind = html.slice(where, end);
            var spaceChar = ''; // Insert a space if matching char preceded by whitespace

            if (html[where - 1] === ' ') {
              spaceChar = '&nbsp;';
            }

            html = html.slice(0, where) + "<span class=\"b-quick-hit-text\">".concat(spaceChar).concat(casedFind, "</span>") + html.slice(end);
            inner.innerHTML = html + "<div class=\"b-quick-hit-cell-badge\">".concat(foundMap, "</div>");
          } else {
            cellElement.classList.add('b-quick-hit-cell');
          }
        }
      }
    } //endregion
    //region Events

    /**
     * Chained function called on grids keydown event. Handles backspace, escape, f3 and ctrl/cmd + g keys.
     * @private
     * @param event KeyboardEvent
     */

  }, {
    key: "onElementKeyDown",
    value: function onElementKeyDown(event) {
      var me = this,
          filterFeature = me.grid.features.filter; // Only react to keystrokes on grid cell elements. IE11 gets event.target wrong compared to other browsers...

      if (me.disabled || _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].up(event.target, _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].isIE11 ? '.b-widget:not(.b-grid-subgrid):not(.b-grid)' : '.b-widget:not(.b-grid)')) {
        return;
      }

      if (me.find.length > 0) {
        // backspace
        if (event.key === 'Backspace') {
          event.preventDefault();
          me.find = me.find.substr(0, me.find.length - 1);
          me.search(me.find);
        } // escape
        else if (event.key === 'Escape') {
            event.preventDefault();
            me.find = '';
            me.search(me.find);
          } // F3 or CTRL+g
          else if (event.key === 'F3' || event.key.toLowerCase() === 'g' && (event.ctrlKey || event.metaKey)) {
              event.preventDefault();

              if (event.shiftKey) {
                me.gotoPrevHit();
              } else {
                me.gotoNextHit();
              }
            } // Ctrl+Shift+F
            else if (filterFeature && me.columnId && me.foundCount && event.ctrlKey && event.shiftKey && event.key === 'F') {
                me.clear();
                filterFeature.showFilterEditor(me.grid.columns.getById(me.columnId), me.find);
              }
      }
    }
    /**
     * Chained function called on grids keypress event. Handles input for "searchfield".
     * @private
     * @param event
     */

  }, {
    key: "onElementKeyPress",
    value: function onElementKeyPress(event) {
      var me = this,
          grid = me.grid; // Only react to keystrokes on grid cell elements

      if (me.disabled || _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].up(event.target, _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].isIE11 ? '.b-widget:not(.b-grid-subgrid):not(.b-grid)' : '.b-widget:not(.b-grid)') || event.key === 'Enter') {
        return;
      }

      if (grid._focusedCell) {
        var column = grid.columns.getById(grid._focusedCell.columnId); // if trying to search in invalid column, it's a hard failure

        if (column && column.searchable !== false) {
          var _event$key;

          me.columnId = grid._focusedCell.columnId;

          if (((_event$key = event.key) === null || _event$key === void 0 ? void 0 : _event$key.length) === 1) {
            me.find += event.key;
            me.search(me.find);
          }
        }
      }
    }
  }, {
    key: "onCellNavigate",
    value: function onCellNavigate(grid, fromCellSelector, toCellSelector) {
      var me = this,
          found = me.prevFound || me.found;

      if (found && (!toCellSelector || toCellSelector.columnId !== me.columnId)) {
        me.clear();
      }
    } //endregion

  }, {
    key: "store",
    get: function get() {
      return this.grid.store;
    }
  }, {
    key: "foundCount",
    get: function get() {
      var _this$found$length, _this$found2;

      return (_this$found$length = (_this$found2 = this.found) === null || _this$found2 === void 0 ? void 0 : _this$found2.length) !== null && _this$found$length !== void 0 ? _this$found$length : 0;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'QuickFind';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        mode: 'header',
        find: ''
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onElementKeyDown', 'onElementKeyPress', 'onCellNavigate']
      };
    }
  }]);

  return QuickFind;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_28__["default"]);


QuickFind._$name = 'QuickFind';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_29__["default"].registerFeature(QuickFind);

/***/ }),

/***/ "./lib/Grid/feature/RegionResize.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/RegionResize.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RegionResize; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/feature/RegionResize
 */

/**
 * Makes the splitter between grid section draggable so you can resize grid sections.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // enable RegionResize
 * let grid = new Grid({
 *   features: {
 *     regionResize: true
 *   }
 * });
 *
 * @demo Grid/features
 * @classtype regionResize
 * @externalexample feature/RegionResize.js
 */

var RegionResize = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(RegionResize, _InstancePlugin);

  var _super = _createSuper(RegionResize);

  function RegionResize() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, RegionResize);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(RegionResize, [{
    key: "construct",
    value: function construct(grid, config) {
      this.grid = grid;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(RegionResize.prototype), "construct", this).call(this, grid, config);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      // TODO: Cleanup
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(RegionResize.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "onElementDblClick",
    //endregion
    value: function onElementDblClick(event) {
      var me = this,
          grid = me.grid,
          splitterEl = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(event.target, '.b-grid-splitter-collapsed'); // If collapsed splitter is dblclicked and region is not expanding
      // It is unlikely that user might dblclick splitter twice and even if he does, nothing should happen.
      // But just in case lets not expand twice.

      if (splitterEl && !me.expanding) {
        me.expanding = true;
        var region = splitterEl.dataset.region,
            subGrid = grid.getSubGrid(region); // Usually collapsed splitter means corresponding region is collapsed. But in case of last two regions one
        // splitter can be collapsed in two directions. So, if corresponding region is expanded then last one is collapsed

        if (!subGrid.collapsed) {
          region = grid.getLastRegions()[1];
          subGrid = grid.getSubGrid(region);
        }

        subGrid.expand().then(function () {
          return me.expanding = false;
        });
      }
    } //region Move splitter

    /**
     * Begin moving splitter.
     * @private
     * @param splitterElement Splitter element
     * @param clientX Initial x position from which new width will be calculated on move
     */

  }, {
    key: "startMove",
    value: function startMove(splitterElement, clientX) {
      var me = this,
          grid = me.grid,
          region = splitterElement.dataset.region,
          gridEl = grid.element,
          nextRegion = grid.regions[grid.regions.indexOf(region) + 1],
          nextSubGrid = grid.getSubGrid(nextRegion),
          splitterSubGrid = grid.getSubGrid(region);
      var subGrid = splitterSubGrid,
          flip = 1;

      if (subGrid.flex != null) {
        // If subgrid has flex, check if next one does not
        if (nextSubGrid.flex == null) {
          subGrid = nextSubGrid;
          flip = -1;
        }
      }

      if (splitterElement.classList.contains('b-grid-splitter-collapsed')) {
        return;
      }

      var availableWidth = subGrid.element.offsetWidth + nextSubGrid.element.offsetWidth;
      me.dragContext = {
        element: splitterElement,
        headerEl: subGrid.header.element,
        subGridEl: subGrid.element,
        subGrid: subGrid,
        splitterSubGrid: splitterSubGrid,
        originalWidth: subGrid.element.offsetWidth,
        originalX: clientX,
        minWidth: subGrid.minWidth || 0,
        maxWidth: Math.min(availableWidth, subGrid.maxWidth || availableWidth),
        flip: flip
      };
      gridEl.classList.add('b-moving-splitter');
      splitterSubGrid.toggleSplitterCls('b-moving');
    }
    /**
     * Stop moving splitter.
     * @private
     */

  }, {
    key: "endMove",
    value: function endMove() {
      var dragContext = this.dragContext;

      if (dragContext) {
        this.grid.element.classList.remove('b-moving-splitter');
        dragContext.splitterSubGrid.toggleSplitterCls('b-moving', false);
        this.dragContext = null;
      }
    }
  }, {
    key: "onCollapseClick",
    value: function onCollapseClick(subGrid, splitterEl) {
      var me = this,
          grid = me.grid,
          region = splitterEl.dataset.region,
          regions = grid.getLastRegions(); // Last splitter in the grid is responsible for collapsing/expanding last 2 regions and is always related to the
      // left one. Check if we are working with last splitter

      if (regions[0] === region) {
        var lastSubGrid = grid.getSubGrid(regions[1]);

        if (lastSubGrid.collapsed) {
          lastSubGrid.expand();
          return;
        }
      }

      subGrid.collapse();
    }
  }, {
    key: "onExpandClick",
    value: function onExpandClick(subGrid, splitterEl) {
      var me = this,
          grid = me.grid,
          region = splitterEl.dataset.region,
          regions = grid.getLastRegions(); // Last splitter in the grid is responsible for collapsing/expanding last 2 regions and is always related to the
      // left one. Check if we are working with last splitter

      if (regions[0] === region) {
        if (!subGrid.collapsed) {
          var lastSubGrid = grid.getSubGrid(regions[1]);
          lastSubGrid.collapse();
          return;
        }
      }

      subGrid.expand();
    }
    /**
     * Update splitter position.
     * @private
     * @param newClientX
     */

  }, {
    key: "updateMove",
    value: function updateMove(newClientX) {
      var dragContext = this.dragContext;

      if (dragContext) {
        var difX = newClientX - dragContext.originalX,
            newWidth = Math.min(dragContext.maxWidth, dragContext.originalWidth + difX * dragContext.flip); // SubGrids monitor their own size and keep any splitters synced

        dragContext.subGrid.width = Math.max(newWidth, dragContext.minWidth);
      }
    } //endregion
    //region Events

    /**
     * Start moving splitter on touch start.
     * @private
     * @param event
     */

  }, {
    key: "onElementTouchStart",
    value: function onElementTouchStart(event) {
      var target = event.target.closest('.b-grid-splitter');

      if (target) {
        this.startMove(target, event.touches[0].clientX);
      }
    }
    /**
     * Move splitter on touch move.
     * @private
     * @param event
     */

  }, {
    key: "onElementTouchMove",
    value: function onElementTouchMove(event) {
      if (this.dragContext) {
        this.updateMove(event.touches[0].clientX);
        event.preventDefault();
      }
    }
    /**
     * Stop moving splitter on touch end.
     * @private
     * @param event
     */

  }, {
    key: "onElementTouchEnd",
    value: function onElementTouchEnd(event) {
      if (this.dragContext) {
        this.endMove();
        event.preventDefault();
      }
    }
    /**
     * Start moving splitter on mouse down (on splitter).
     * @private
     * @param event
     */

  }, {
    key: "onElementMouseDown",
    value: function onElementMouseDown(event) {
      var me = this,
          target = event.target,
          splitter = target.closest(':not(.b-row-reordering):not(.b-dragging-event):not(.b-dragging-task):not(.b-dragging-header):not(.b-dragselecting) .b-grid-splitter'),
          subGrid = splitter && me.grid.getSubGrid(splitter.dataset.region); // Only care about left clicks, avoids a bug found by monkeys

      if (event.button === 0) {
        // In case of touch screen inner splitter has 100% height and we should handle
        // it as target too
        if (target.classList.contains('b-grid-splitter') || target.classList.contains('b-grid-splitter-inner')) {
          me.startMove(splitter, event.clientX);
        } else if (target.classList.contains('b-icon-collapse-gridregion')) {
          me.onCollapseClick(subGrid, splitter);
        } else if (target.classList.contains('b-icon-expand-gridregion')) {
          me.onExpandClick(subGrid, splitter);
        }
      }
    }
    /**
     * Move splitter on mouse move.
     * @private
     * @param event
     */

  }, {
    key: "onElementMouseMove",
    value: function onElementMouseMove(event) {
      if (this.dragContext) {
        this.updateMove(event.clientX);
        event.preventDefault();
      }
    }
    /**
     * Stop moving splitter on mouse up.
     * @private
     * @param event
     */

  }, {
    key: "onElementMouseUp",
    value: function onElementMouseUp(event) {
      if (this.dragContext) {
        this.endMove();
        event.preventDefault();
      }
    }
  }, {
    key: "onSubGridCollapse",
    value: function onSubGridCollapse(subGrid) {
      var splitterEl = this.grid.resolveSplitter(subGrid),
          regions = this.grid.getLastRegions(); // if last region was collapsed

      if (regions[1] === subGrid.region) {
        splitterEl.classList.add('b-grid-splitter-allow-collapse');
      }
    }
  }, {
    key: "onSubGridExpand",
    value: function onSubGridExpand(subGrid) {
      var splitterEl = this.grid.resolveSplitter(subGrid);
      splitterEl.classList.remove('b-grid-splitter-allow-collapse');
    } //endregion

  }, {
    key: "render",
    value: function render() {
      var _this$grid = this.grid,
          regions = _this$grid.regions,
          subGrids = _this$grid.subGrids; // Multiple regions, only allow collapsing to the edges by hiding buttons

      if (regions.length > 2) {
        // Only works in a 3 subgrid scenario. To support more subgrids we have to merge splitters or something
        // on collapse. Not going down that path currently...
        subGrids[regions[0]].splitterElement.classList.add('b-left-only');
        subGrids[regions[1]].splitterElement.classList.add('b-right-only');
      }
    }
  }], [{
    key: "$name",
    // region Init
    get: function get() {
      return 'RegionResize';
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onElementTouchStart', 'onElementTouchMove', 'onElementTouchEnd', 'onElementMouseDown', 'onElementMouseMove', 'onElementDblClick', 'onElementMouseUp', 'onSubGridCollapse', 'onSubGridExpand', 'render']
      };
    }
  }]);

  return RegionResize;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


RegionResize.featureClass = 'b-split';
RegionResize._$name = 'RegionResize';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(RegionResize);

/***/ }),

/***/ "./lib/Grid/feature/RowReorder.js":
/*!****************************************!*\
  !*** ./lib/Grid/feature/RowReorder.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RowReorder; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");



















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Grid/feature/RowReorder
*/









/**
 * Allows user to reorder rows by dragging them. To get notified about row reorder listen to `change` event
 * on the grid {@link Core.data.Store store}.
 *
 * This feature is **disabled** by default.
 * This feature is **enabled** by default for Gantt.
 *
 * If the grid is set to {@link Grid.view.Grid#config-readOnly}, reordering is disabled. Inside all event listeners you have access a `context` object which has a `record` property (the dragged record).
 *
 * You can validate the drag drop flow by listening to the `gridrowdrag` event. Inside this listener you have access the `index` property which is the target drop position.
 * For trees you get access to the `parent` record and `index`, where index means the child index inside the parent.
 *
 * ```
 * features : {
 *     rowReorder : {
 *         listeners : {
 *             gridRowDrag : ({ context }) => {
 *                // Here you have access to context.insertBefore, and additionally context.parent for trees
 *
 *                context.valid = false;
 *             }
 *         }
 *     }
 * }
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Grid/rowreorder
 * @classtype rowReorder
 */

var RowReorder = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(RowReorder, _Delayable);

  var _super = _createSuper(RowReorder);

  function RowReorder() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default()(this, RowReorder);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default()(RowReorder, [{
    key: "construct",
    value: function construct(grid, config) {
      this.grid = grid;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(RowReorder.prototype), "construct", this).apply(this, arguments);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$dragHelper;

      (_this$dragHelper = this.dragHelper) === null || _this$dragHelper === void 0 ? void 0 : _this$dragHelper.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(RowReorder.prototype), "doDestroy", this).call(this);
    }
    /**
     * Initialize drag & drop (called from render)
     * @private
     */

  }, {
    key: "init",
    value: function init() {
      var me = this,
          grid = me.grid;
      me.dragHelper = new _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"]({
        name: 'rowReorder',
        mode: 'translateXY',
        cloneTarget: true,
        dragThreshold: 10,
        targetSelector: '.b-grid-row',
        lockX: true,
        transitionDuration: grid.transitionDuration,
        scrollManager: grid.scrollManager,
        dragWithin: grid.verticalScroller,
        outerElement: grid.verticalScroller,
        // Since parent nodes can expand after hovering, meaning original drag start position now refers to a different point in the tree
        ignoreSamePositionDrop: false,
        createProxy: function createProxy(element) {
          var clone = element.cloneNode(true),
              container = document.createElement('div');
          clone.removeAttribute('id'); // The containing element will be positioned instead

          clone.style.transform = '';
          container.appendChild(clone);

          if (grid.selectedRecords.length > 1) {
            var clone2 = clone.cloneNode(true);
            clone2.classList.add('b-row-dragging-multiple');
            container.appendChild(clone2);
          }

          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].removeClsGlobally(container, 'b-selected', 'b-hover', 'b-focused');
          return container;
        },
        listeners: {
          beforedragstart: me.onBeforeDragStart,
          dragstart: me.onDragStart,
          drag: me.onDrag,
          drop: me.onDrop,
          reset: me.onReset,
          prio: 10000,
          // To ensure our listener is run before the relayed listeners (for the outside world)
          thisObj: me
        }
      });
      me.dropIndicator = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].createElement({
        parent: grid.bodyContainer,
        className: 'b-row-drop-indicator'
      });
      me.relayEvents(me.dragHelper, ['beforeDragStart', 'dragStart', 'drag', 'abort'], 'gridRow');
    } //endregion
    //region Plugin config

  }, {
    key: "onBeforeDragStart",
    //endregion
    //region Events (drop)
    value: function onBeforeDragStart(_ref) {
      var context = _ref.context;
      var me = this,
          grid = me.grid,
          targetSubGrid = grid.regions[0],
          subGridEl = grid.subGrids[targetSubGrid].element; // Only dragging enabled in the leftmost grid section

      if (me.disabled || grid.readOnly || !subGridEl.contains(context.element)) {
        return false;
      }

      var records = context.records = grid.selectedRecords.slice().sort(function (r1, r2) {
        return grid.store.indexOf(r1) - grid.store.indexOf(r2);
      });
      context.startRecord = grid.getRecordFromElement(context.element); // Backwards compat, @deprecated - remove in 5.0

      context.record = context.startRecord;
      return records.length > 0 && !records.some(function (rec) {
        return rec.isSpecialRow;
      });
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(_ref2) {
      var context = _ref2.context;
      var me = this,
          _me$grid$features = me.grid.features,
          cellEdit = _me$grid$features.cellEdit,
          contextMenu = _me$grid$features.contextMenu,
          cellMenu = _me$grid$features.cellMenu,
          headerMenu = _me$grid$features.headerMenu;

      if (cellEdit) {
        me.cellEditDisabledState = cellEdit.disabled;
        cellEdit.disabled = true; // prevent editing from being started through keystroke during row reordering
      } // TODO: 'contextMenu' is deprecated. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.


      contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.hideContextMenu(false);
      cellMenu === null || cellMenu === void 0 ? void 0 : cellMenu.hideContextMenu(false);
      headerMenu === null || headerMenu === void 0 ? void 0 : headerMenu.hideContextMenu(false);
      me.grid.element.classList.add('b-row-reordering');
      var focusedCell = context.element.querySelector('.b-focused');
      focusedCell === null || focusedCell === void 0 ? void 0 : focusedCell.classList.remove('b-focused');
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].removeClasses(context.element.firstElementChild, ['b-selected', 'b-hover']);
    }
  }, {
    key: "onDrag",
    value: function onDrag(_ref3) {
      var context = _ref3.context,
          event = _ref3.event;
      var me = this,
          grid = me.grid,
          store = grid.store,
          rowManager = grid.rowManager,
          outerElement = me.dragHelper.outerElement; // Ignore if user drags outside grid area

      if (!outerElement.contains(event.target) || !event.target.closest('.b-grid-subgrid')) {
        context.valid = false;
        return;
      } // Chrome 85 has a bug, event.targets top is sometimes below event.pageX
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1121915


      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isChrome && !_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_25__["default"].from(outerElement).contains(_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getPagePoint(event))) {
        return;
      }

      var valid = context.valid,
          row = grid.rowManager.getRowAt(event.clientY),
          overRecord,
          dataIndex,
          after,
          insertBefore;

      if (row) {
        var rowTop = row.top + grid._bodyRectangle.y - grid.scrollable.y,
            middleY = rowTop + row.height / 2;
        dataIndex = row.dataIndex;
        overRecord = row && store.getAt(dataIndex); // Drop after row below if mouse is in bottom half of hovered row

        after = event.clientY > middleY;
      } // Below the rows. Drop after last row
      else {
          dataIndex = store.count - 1;
          overRecord = store.last;
          row = grid.rowManager.getRow(dataIndex);
          after = true;
        } // Hovering the dragged record. This is a no-op.
      // But still gather the contextual data.


      if (overRecord === context.startRecord) {
        valid = false;
      }

      if (store.tree) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].removeClsGlobally(grid.element, 'b-row-reordering-target-parent');
        insertBefore = after ? overRecord.nextSibling : overRecord; // For trees, prevent moving a parent into its own hierarchy

        if (context.records.some(function (rec) {
          return rec.contains(overRecord);
        })) {
          valid = false;
        }

        context.parent = overRecord.parent;

        if (!context.parent.isRoot) {
          var parentRow = rowManager.getRowById(context.parent);

          if (parentRow) {
            parentRow.addCls('b-row-reordering-target-parent');
          }
        }

        me.clearTimeout(me.hoverTimer);

        if (overRecord && overRecord.isParent && !overRecord.isExpanded(store)) {
          me.hoverTimer = me.setTimeout(function () {
            return grid.expand(overRecord);
          }, me.hoverExpandTimeout);
        }
      } else {
        // Public property used for validation
        insertBefore = after ? store.getAt(dataIndex + 1) : overRecord;
      } // Provide visual clue to user of the drop position


      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].setTranslateY(me.dropIndicator, row.top + (after ? row.height : 0));
      context.insertBefore = insertBefore;
      context.valid = valid;
    }
    /**
     * Handle drop
     * @private
     */

  }, {
    key: "onDrop",
    value: function () {
      var _onDrop = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee(event) {
        var me, context;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this, context = event.context;
                me.trigger('gridRowBeforeDropFinalize', event);

                if (context.valid) {
                  context.asyncCleanup = context.async = true;
                  context.element.classList.add('b-dropping');
                  me.setTimeout(function () {
                    return me.finalizeReorder(context).then(function () {
                      return me.trigger('gridRowDrop', event);
                    });
                  }, me.finalizeDelay);
                } else {
                  me.trigger('gridRowDrop', event);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDrop(_x) {
        return _onDrop.apply(this, arguments);
      }

      return onDrop;
    }()
  }, {
    key: "finalizeReorder",
    value: function () {
      var _finalizeReorder = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee2(context) {
        var me, grid, store, records, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                me = this, grid = me.grid, store = grid.store;
                records = context.records;
                context.valid = context.valid && !records.some(function (rec) {
                  return !store.includes(rec);
                });

                if (!context.valid) {
                  _context2.next = 14;
                  break;
                }

                if (!store.tree) {
                  _context2.next = 12;
                  break;
                }

                // Remove any selected child records of parent nodes
                records = records.filter(function (record) {
                  return !record.parent || !records.includes(record.parent);
                });
                _context2.next = 8;
                return context.parent.tryInsertChild(records, context.insertBefore);

              case 8:
                result = _context2.sent;
                context.valid = result !== false;
                _context2.next = 13;
                break;

              case 12:
                store.insert(context.insertBefore ? store.indexOf(context.insertBefore) : store.count, records);

              case 13:
                store.clearSorters();

              case 14:
                context.finalize(context.valid);
                grid.element.classList.remove('b-row-reordering');

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function finalizeReorder(_x2) {
        return _finalizeReorder.apply(this, arguments);
      }

      return finalizeReorder;
    }()
    /**
     * Clean up on reset
     * @private
     */

  }, {
    key: "onReset",
    value: function onReset() {
      var me = this,
          cellEdit = me.grid.features.cellEdit;
      me.grid.element.classList.remove('b-row-reordering');

      if (cellEdit) {
        cellEdit.disabled = me.cellEditDisabledState;
      }

      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].removeClsGlobally(me.grid.element, 'b-row-reordering-target-parent');
    } //endregion
    //region Render

    /**
     * Updates DragHelper with updated headers when grid contents is rerendered
     * @private
     */

  }, {
    key: "render",
    value: function render() {
      // columns shown, hidden or reordered
      this.init();
    } //endregion

  }], [{
    key: "$name",
    //region Events

    /**
     * Fired before dragging starts, return false to prevent the drag operation.
     * @preventable
     * @event gridRowBeforeDragStart
     * @param {DragHelper} source
     * @param {Object} context
     * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
     * @param {Core.data.Model[]} context.records The dragged row records
     * @param {MouseEvent|TouchEvent} event
     */

    /**
     * Fired when dragging starts.
     * @event gridRowDragStart
     * @param {DragHelper} source
     * @param {Object} context
     * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
     * @param {Core.data.Model[]} context.records The dragged row records
     * @param {MouseEvent|TouchEvent} event
     */

    /**
     * Fired while the row is being dragged, in the listener function you have access to `context.insertBefore` a grid / tree record, and additionally `context.parent` (a TreeNode) for trees. You can
     * signal that the drop position is valid or invalid by setting `context.valid = false;`
     * @event gridRowDrag
     * @param {DragHelper} source
     * @param {Object} context
     * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid.
     * @param {Core.data.Model} context.insertBefore The record to insert before (`null` if inserting at last position of a parent node)
     * @param {Core.data.Model} context.parent The parent record of the current drop position (only applicable for trees)
     * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
     * @param {Core.data.Model[]} context.records The dragged row records
     * @param {MouseEvent} event
     */

    /**
     * Fired before the row drop operation is finalized.
     * @event gridRowBeforeDropFinalize
     * @param {DragHelper} source
     * @param {Object} context
     * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid
     * @param {Core.data.Model} context.insertBefore The record to insert before (`null` if inserting at last position of a parent node)
     * @param {Core.data.Model} context.parent The parent record of the current drop position (only applicable for trees)
     * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
     * @param {Core.data.Model[]} context.records The dragged row records
     * @param {MouseEvent} event
     */

    /**
     * Fired after the row drop operation has completed, regardless of validity
     * @event gridRowDrop
     * @param {DragHelper} source
     * @param {Object} context
     * @param {Boolean} context.valid true or false depending on whether the drop position was valid
     * @param {Core.data.Model} context.insertBefore The record to insert before (`null` if inserting at last position of a parent node)
     * @param {Core.data.Model} context.parent The parent record of the current drop position (only applicable for trees)
     * @param {Core.data.Model} context.record [DEPRECATED] The dragged row record
     * @param {Core.data.Model[]} context.records The dragged row records
     * @param {MouseEvent} event
     */

    /**
     * Fired when a row drag operation is aborted
     * @event gridRowAbort
     * @param {DragHelper} source
     * @param {Object} context
     * @param {MouseEvent} event
     */
    //endregion
    //region Init
    get: function get() {
      return 'RowReorder';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * If hovering over a parent node for this period of a time in a tree, the node will expand
         * @config {Number}
         */
        hoverExpandTimeout: 1000,
        finalizeDelay: 300
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        after: ['render']
      };
    }
  }]);

  return RowReorder;
}(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_22__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_20__["default"]));


RowReorder.featureClass = '';
RowReorder._$name = 'RowReorder';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_18__["default"].registerFeature(RowReorder, false);
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_18__["default"].registerFeature(RowReorder, true, 'Gantt');

/***/ }),

/***/ "./lib/Grid/feature/Search.js":
/*!************************************!*\
  !*** ./lib/Grid/feature/Search.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Search; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.string.search */ "./node_modules/core-js/modules/es.string.search.js");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Should listen for store search also, to work the other way around
//TODO: Buggy sometimes, try searching for Barcelona tigers, navigate using buttons
//TODO: Allow regex
//TODO: Optional case sensitive
//TODO: build in UI, popup with keyboard shortcut?





/**
 * @module Grid/feature/Search
 */

/**
 * Feature that allows the user to search the entire grid. Navigate between hits using the
 * keyboard, [f3] or [ctrl]/[cmd] + [g] moves to next, also pressing [shift] moves to previous.
 *
 * Note that this feature does not include a UI, please build your own and call appropriate methods in the feature. For
 * a demo implementation, see
 * <a href="../examples/search" target="_blank">Search example</a>.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // enable Search
 * let grid = new Grid({
 *   features: {
 *     search: true
 *   }
 * });
 *
 * // perform search
 * grid.features.search.search('steve');
 *
 * @demo Grid/search
 * @classtype search
 * @externalexample feature/Search.js
 */

var Search = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28___default()(Search, _InstancePlugin);

  var _super = _createSuper(Search);

  function Search() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, Search);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(Search, [{
    key: "construct",
    value: function construct(grid, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(Search.prototype), "construct", this).call(this, grid, config);

      Object.assign(this, {
        grid: grid,
        find: '',
        hitEls: []
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.clear(true);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(Search.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      if (disable) {
        this.clear();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(Search.prototype), "doDisable", this).call(this, disable);
    }
  }, {
    key: "search",
    //endregion
    //region Search

    /**
     * Performs a search and highlights hits.
     * @param {String} find Text to search for
     * @param {Boolean} gotoHit Go to first hit after search
     * @param {Boolean} reapply Pass true to force search
     */
    value: function search(find) {
      var _me$hitColumns;

      var gotoHit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var reapply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this; // empty search considered a clear

      if (!find) {
        return me.clear();
      } // searching for same thing again, do nothing


      if (!reapply && find === me.find || me.disabled) {
        return;
      }

      var grid = me.grid,
          store = me.store,
          columns = grid.columns.visibleColumns.filter(function (col) {
        return col.searchable !== false;
      }),
          fields = columns.map(function (col) {
        return col.field;
      }),
          found = store.search(find, fields);
      var i = 1;
      Object.assign(me, {
        foundMap: {},
        prevFound: me.found,
        found: found,
        find: find
      });
      me.clearHits();

      if (!found) {
        return;
      } // columns from previous search, reset htmlEncode


      (_me$hitColumns = me.hitColumns) === null || _me$hitColumns === void 0 ? void 0 : _me$hitColumns.forEach(function (col) {
        return col.disableHtmlEncode = false;
      });
      me.hitColumns = []; // highlight hits for visible cells

      var _iterator = _createForOfIteratorHelper(found),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var hit = _step.value;
          me.foundMap[hit.field + '-' + hit.id] = i++; // disable htmlEncode for columns with hits

          var column = grid.columns.get(hit.field);

          if (column) {
            column.disableHtmlEncode = true;
            me.hitColumns.push(column);
          } // limit hits


          if (i > 1000) break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!me.listenersInitialized) {
        grid.rowManager.on({
          rendercell: me.renderCell
        }, me);
        store.on(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()({}, "refresh".concat(grid.asyncEventSuffix), me.onStoreRefresh), me);
        me.listenersInitialized = true;
      }

      grid.refreshRows();
      grid.trigger('search', {
        grid: grid,
        find: find,
        found: found
      });

      if (gotoHit && !me.isHitFocused) {
        me.gotoNextHit(true);
      }

      return found;
    }
  }, {
    key: "clearHits",
    value: function clearHits() {
      // clear old hits
      var _iterator2 = _createForOfIteratorHelper(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].children(this.grid.element, '.b-search-hit')),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var cell = _step2.value;
          // IE11 doesnt support this
          //cell.classList.remove('b-search-hit', 'b-search-hit-cell');
          cell.classList.remove('b-search-hit');
          cell.classList.remove('b-search-hit-cell'); // rerender cell to remove search-hit-text

          var row = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_33__["default"].get(cell).row;
          cell._content = null;
          row.renderCell(cell);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * Clears search results.
     */

  }, {
    key: "clear",
    value: function clear() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          grid = me.grid;

      if (me.foundMap) {
        delete me.foundMap;
      }

      delete me.find;
      me.clearHits();

      if (me.listenersInitialized) {
        grid.rowManager.un({
          rendercell: me.renderCell
        }, me);
        me.store.un({
          refresh: me.onStoreRefresh
        }, me);
        me.listenersInitialized = false;
      }

      if (!silent) {
        grid.trigger('clearSearch', {
          grid: grid
        });
      }
    }
    /**
     * Number of results found
     * @readonly
     * @returns {Number}
     */

  }, {
    key: "gotoNextHit",

    /**
     * Select the next hit, scrolling it into view. Triggered with [f3] or [ctrl]/[cmd] + [g].
     */
    value: function gotoNextHit() {
      var _me$found;

      var fromStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this;
      if (!((_me$found = me.found) === null || _me$found === void 0 ? void 0 : _me$found.length)) return;
      var grid = me.grid,
          fromCell = grid.focusedCell || grid.lastFocusedCell,
          currentIndex = fromCell && !fromStart ? grid.store.indexOf(fromCell.id) : -1,
          nextHit = me.found.findIndex(function (hit) {
        return hit.index > currentIndex;
      });

      if (nextHit !== -1) {
        me.gotoHit(nextHit);
      }
    }
    /**
     * Select the previous hit, scrolling it into view. Triggered with [shift] + [f3] or [shift] + [ctrl]/[cmd] + [g].
     */

  }, {
    key: "gotoPrevHit",
    value: function gotoPrevHit() {
      var _me$found2;

      var me = this;
      if (!((_me$found2 = me.found) === null || _me$found2 === void 0 ? void 0 : _me$found2.length)) return;
      var grid = me.grid,
          found = me.found,
          fromCell = grid.focusedCell || grid.lastFocusedCell,
          currentIndex = fromCell ? grid.store.indexOf(fromCell.id) : 0;

      for (var i = found.length - 1; i--; i >= 0) {
        var hit = found[i];

        if (hit.index < currentIndex) {
          me.gotoHit(i);
          break;
        }
      }
    }
    /**
     * Go to specified hit.
     * @param index
     */

  }, {
    key: "gotoHit",
    value: function gotoHit(index) {
      var grid = this.grid,
          nextHit = this.found[index];

      if (nextHit) {
        grid.focusCell({
          field: nextHit.field,
          id: nextHit.id
        });
      }

      return Boolean(nextHit);
    }
    /**
     * Go to the first hit.
     */

  }, {
    key: "gotoFirstHit",
    value: function gotoFirstHit() {
      this.gotoHit(0);
    }
    /**
     * Go to the last hit.
     */

  }, {
    key: "gotoLastHit",
    value: function gotoLastHit() {
      this.gotoHit(this.found.length - 1);
    } //endregion
    //region Render

    /**
     * Called from SubGrid when a cell is rendered. Highlights search hits.
     * @private
     */

  }, {
    key: "renderCell",
    value: function renderCell(_ref) {
      var _me$foundMap;

      var cellElement = _ref.cellElement,
          column = _ref.column,
          record = _ref.record,
          value = _ref.value,
          cellContent = _ref.cellContent;
      var me = this,
          hitIndex = (_me$foundMap = me.foundMap) === null || _me$foundMap === void 0 ? void 0 : _me$foundMap[column.field + '-' + record.id];

      if (hitIndex) {
        // highlight cell
        cellElement.classList.add('b-search-hit'); // highlight in cell if found in innerHTML

        var inner = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].down(cellElement, '.b-grid-cell-value') || cellElement,
            find = String(me.find).toLowerCase();

        if (String(value).toLowerCase() === find) {
          inner.innerHTML = "<span class=\"b-search-hit-text\">".concat(cellContent, "</span><div class=\"b-search-hit-cell-badge\">").concat(hitIndex, "</div>");
        } else {
          var _find = String(me.find).toLowerCase(),
              where = cellContent && cellContent.toLowerCase().indexOf(_find);

          if (where > -1) {
            var end = where + _find.length,
                casedFind = cellContent.slice(where, end);
            inner.innerHTML = "".concat(cellContent.slice(0, where), "<span class=\"b-search-hit-text\">").concat(casedFind, "</span>").concat(cellContent.slice(end), "<div class=\"b-search-hit-cell-badge\">").concat(hitIndex, "</div>");
          } else {
            cellElement.classList.add('b-search-hit-cell');
          }
        }

        me.hitEls.push(cellElement);
      }
    } //endregion
    //region Context menu

    /**
     * Add search menu item to cell context menu.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Core.data.Model} options.record Record for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateCellMenu",
    value: function populateCellMenu(_ref2) {
      var column = _ref2.column,
          record = _ref2.record,
          items = _ref2.items;
      var me = this;

      if (column.searchable) {
        items.search = {
          text: 'L{searchForValue}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-search',
          cls: 'b-separator',
          name: 'search',
          weight: 200,
          disabled: me.disabled,
          onItem: function onItem() {
            // TODO: Only extract selection from current cell instead? Lazy way for now
            var sel = window.getSelection().toString();

            if (!sel) {
              sel = record[column.field];
            }

            me.search(sel);
          }
        };
      }
    } //endregion
    //region Events

    /**
     * Chained function called on grids keydown event. Handles backspace, escape, f3 and ctrl/cmd + g keys.
     * @private
     * @param event KeyboardEvent
     */

  }, {
    key: "onElementKeyDown",
    value: function onElementKeyDown(event) {
      var me = this;

      if (me.find && me.find !== '') {
        if (event.key === 'F3' || event.key.toLowerCase() === 'g' && (event.ctrlKey || event.metaKey)) {
          event.preventDefault();

          if (event.shiftKey) {
            me.gotoPrevHit();
          } else {
            me.gotoNextHit();
          }
        }
      }
    }
  }, {
    key: "onStoreRefresh",
    value: function onStoreRefresh() {
      this.search(this.find, false, true);
    } //endregion

  }, {
    key: "store",
    get: function get() {
      return this.grid.store;
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "foundCount",
    get: function get() {
      var _this$found$length, _this$found;

      return (_this$found$length = (_this$found = this.found) === null || _this$found === void 0 ? void 0 : _this$found.length) !== null && _this$found$length !== void 0 ? _this$found$length : 0;
    } //endregion
    //region Navigation

    /**
     * Checks if focused row is a search hit.
     * @returns {Boolean} Returns true if focused row is a hit
     * @readonly
     */

  }, {
    key: "isHitFocused",
    get: function get() {
      var me = this,
          grid = me.grid,
          currentIndex = grid.focusedCell ? grid.store.indexOf(grid.focusedCell.id) : -1,
          currentColumn = grid.focusedCell ? grid.columns.getById(grid.focusedCell.columnId) : null;
      return currentIndex !== -1 && me.found.some(function (hit) {
        return hit.index === currentIndex && currentColumn && hit.field === currentColumn.field;
      });
    }
  }], [{
    key: "$name",
    //region Init
    get: function get() {
      return 'Search';
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['populateCellMenu', 'onElementKeyDown']
      };
    }
  }]);

  return Search;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_32__["default"]);


Search.featureClass = 'b-search';
Search._$name = 'Search';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_34__["default"].registerFeature(Search);

/***/ }),

/***/ "./lib/Grid/feature/Sort.js":
/*!**********************************!*\
  !*** ./lib/Grid/feature/Sort.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Sort; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.constructor */ "./node_modules/core-js/modules/es.regexp.constructor.js");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");

























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Allow multisort using multitouch?
//TODO: UI sort of broken with grouped headers, take a look at groupedheaders demo





/**
 * @module Grid/feature/Sort
 */

/**
 * Allows sorting of grid by clicking (or tapping) headers, also displays which columns grid is sorted by (numbered if
 * using multisort). Use modifier keys for multisorting: ctrl + click to add sorter, ctrl + alt + click to remove sorter.
 * The actual sorting is done by the store, see {@link Core.data.mixin.StoreSort#function-sort}.
 *
 * For info on programmatically handling sorting, see {@link Core.data.mixin.StoreSort StoreSort}.
 *
 * This feature is **enabled** by default.
 *
 * @example
 * // sorting feature is enabled, no default value though
 * let grid = new Grid({
 *     features : {
 *         sort : true
 *     }
 * });
 *
 * // use initial sorting
 * let grid = new Grid({
 *     features : {
 *         sort : 'name'
 *     }
 * });
 *
 * // can also be specified on the store
 * let grid = new Grid({
 *     store : {
 *         sorters : [
 *             { field : 'name', ascending : false }
 *         ]
 *     }
 * });
 *
 * // custom sorting function can also be specified on the store
 * let grid = new Grid({
 *     store : {
 *         sorters : [{
 *             fn : (recordA, recordB) => {
 *                 // apply custom logic, for example:
 *                 return recordA.name.length < recordB.name.length ? -1 : 1;
 *             }
 *         }]
 *     }
 * });
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Grid/sorting
 * @classtype sort
 * @externalexample feature/Sort.js
 */

var Sort = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default()(Sort, _InstancePlugin);

  var _super = _createSuper(Sort);

  function Sort() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, Sort);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(Sort, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(grid, config) {
      // process initial config into an actual config object
      config = this.processConfig(config);
      this.grid = grid;
      this.bindStore(grid.store);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Sort.prototype), "construct", this).call(this, grid, config);
    } // Sort feature handles special config cases, where user can supply a string or an array of sorters
    // instead of a normal config object

  }, {
    key: "processConfig",
    value: function processConfig(config) {
      if (typeof config === 'string' || Array.isArray(config)) {
        return {
          field: config,
          ascending: null
        };
      }

      return config;
    } // override setConfig to process config before applying it

  }, {
    key: "setConfig",
    value: function setConfig(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Sort.prototype), "setConfig", this).call(this, this.processConfig(config));
    }
  }, {
    key: "bindStore",
    value: function bindStore(store) {
      this.detachListeners('store');
      store.on({
        name: 'store',
        sort: 'syncHeaderSortState',
        thisObj: this
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Sort.prototype), "doDestroy", this).call(this);
    } // Avoid caching store, it might change

  }, {
    key: "syncHeaderSortState",
    //endregion
    //region Headers

    /**
     * Update headers to match stores sorters (displays sort icon in correct direction on them)
     * @private
     */
    value: function syncHeaderSortState() {
      var me = this,
          sorterMap = {};

      if (!me.grid.isConfiguring) {
        var storeSorters = me.store.sorters,
            sorterCount = storeSorters.length,
            classList = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_25__["default"]();
        var sorter; // Key sorters object by field name so we can find them.

        for (var sortIndex = 0; sortIndex < sorterCount; sortIndex++) {
          var _sorter = storeSorters[sortIndex];

          if (_sorter.field) {
            sorterMap[_sorter.field] = {
              ascending: _sorter.ascending,
              sortIndex: sortIndex + 1
            };
          }
        } // Sync the sortable, sorted, and sortIndex state of each leaf header element


        var _iterator = _createForOfIteratorHelper(me.grid.columns.bottomColumns),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var leafColumn = _step.value;
            var leafHeader = leafColumn.element;

            if (leafHeader) {
              var _leafColumn$textWrapp;

              // TimeAxisColumn in Scheduler has no textWrapper, since it has custom rendering,
              // but since it cannot be sorted by anyway lets just ignore it
              var dataset = (_leafColumn$textWrapp = leafColumn.textWrapper) === null || _leafColumn$textWrapp === void 0 ? void 0 : _leafColumn$textWrapp.dataset; // data-sortIndex is 1-based, and only set if there is > 1 sorter.
              // iOS Safari throws a JS error if the requested delete property is not present.

              (dataset === null || dataset === void 0 ? void 0 : dataset.sortIndex) && delete dataset.sortIndex;
              classList.value = leafHeader.classList;

              if (leafColumn.sortable !== false) {
                classList.add(me.sortableCls);
                sorter = sorterMap[leafColumn.field];

                if (sorter) {
                  if (sorterCount > 1 && dataset) {
                    dataset.sortIndex = sorter.sortIndex;
                  }

                  classList.add(me.sortedCls);

                  if (sorter.ascending) {
                    classList.add(me.sortedAscCls);
                    classList.remove(me.sortedDescCls);
                  } else {
                    classList.add(me.sortedDescCls);
                    classList.remove(me.sortedAscCls);
                  }
                } else {
                  classList.remove(me.sortedCls); // Not optimal, but easiest way to make sure sort feature does not remove needed classes.
                  // Better solution would be to use different names for sorting and grouping

                  if (!classList['b-group']) {
                    classList.remove(me.sortedAscCls);
                    classList.remove(me.sortedDescCls);
                  }
                }
              } else {
                classList.remove(me.sortableCls);
              } // Update the element's classList


              _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].syncClassList(leafHeader, classList);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    } //endregion
    //region Context menu

    /**
     * Adds sort menu items to header context menu.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateHeaderMenu",
    value: function populateHeaderMenu(_ref) {
      var column = _ref.column,
          items = _ref.items;
      var me = this,
          store = me.store,
          sortBy = typeof column.sortable === 'function' ? column.sortable : column.field;

      if (column.sortable !== false) {
        items.sortAsc = {
          text: 'L{sortAscending}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-sort-asc',
          name: 'sortAsc',
          cls: 'b-separator',
          weight: 300,
          disabled: me.disabled,
          onItem: function onItem() {
            return store.sort(sortBy, true);
          }
        };
        items.sortDesc = {
          text: 'L{sortDescending}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-sort-desc',
          name: 'sortDesc',
          weight: 310,
          disabled: me.disabled,
          onItem: function onItem() {
            return store.sort(sortBy, false);
          }
        };

        if (me.multiSort && me.grid.columns.records.some(function (col) {
          return col.sortable;
        })) {
          var sorter = store.sorters.find(function (s) {
            return s.field === column.field;
          });
          items.multiSort = {
            text: 'L{multiSort}',
            localeClass: me,
            icon: 'b-fw-icon b-icon-sort',
            name: 'multiSort',
            weight: 320,
            disabled: me.disabled,
            menu: {
              addSortAsc: {
                text: sorter ? 'L{toggleSortAscending}' : 'L{addSortAscending}',
                localeClass: me,
                icon: 'b-fw-icon b-icon-sort-asc',
                name: 'addSortAsc',
                disabled: sorter && (sorter === null || sorter === void 0 ? void 0 : sorter.ascending),
                weight: 330,
                onItem: function onItem() {
                  return store.addSorter(sortBy, true);
                }
              },
              addSortDesc: {
                text: sorter ? 'L{toggleSortDescending}' : 'L{addSortDescending}',
                localeClass: me,
                icon: 'b-fw-icon b-icon-sort-desc',
                name: 'addSortDesc',
                disabled: sorter && !sorter.ascending,
                weight: 340,
                onItem: function onItem() {
                  return store.addSorter(sortBy, false);
                }
              },
              removeSorter: {
                text: 'L{removeSorter}',
                localeClass: me,
                icon: 'b-fw-icon b-icon-remove',
                name: 'removeSorter',
                weight: 350,
                disabled: !sorter,
                onItem: function onItem() {
                  return store.removeSorter(sortBy);
                }
              }
            }
          };
        }
      }
    }
    /**
     * Supply items to ColumnDragToolbar
     * @private
     */

  }, {
    key: "getColumnDragToolbarItems",
    value: function getColumnDragToolbarItems(column, items) {
      var me = this,
          store = me.store,
          disabled = me.disabled;

      if (column.sortable !== false) {
        items.push({
          text: 'L{sortAscendingShort}',
          group: 'L{sort}',
          localeClass: me,
          icon: 'b-icon b-icon-sort-asc',
          name: 'sortAsc',
          cls: 'b-separator',
          weight: 105,
          disabled: disabled,
          onDrop: function onDrop(_ref2) {
            var column = _ref2.column;
            return store.sort(column.field, true);
          }
        });
        items.push({
          text: 'L{sortDescendingShort}',
          group: 'L{sort}',
          localeClass: me,
          icon: 'b-icon b-icon-sort-desc',
          name: 'sortDesc',
          weight: 105,
          disabled: disabled,
          onDrop: function onDrop(_ref3) {
            var column = _ref3.column;
            return store.sort(column.field, false);
          }
        });
        var sorter = store.sorters.find(function (s) {
          return s.field === column.field;
        });
        Array.prototype.push.apply(items, [{
          text: 'L{addSortAscendingShort}',
          group: 'L{multiSort}',
          localeClass: me,
          icon: 'b-icon b-icon-sort-asc',
          name: 'multisortAddAsc',
          disabled: disabled || sorter && sorter.ascending,
          weight: 105,
          onDrop: function onDrop(_ref4) {
            var column = _ref4.column;
            return store.addSorter(column.field, true);
          }
        }, {
          text: 'L{addSortDescendingShort}',
          group: 'L{multiSort}',
          localeClass: me,
          icon: 'b-icon b-icon-sort-desc',
          name: 'multisortAddDesc',
          disabled: disabled || sorter && !sorter.ascending,
          weight: 105,
          onDrop: function onDrop(_ref5) {
            var column = _ref5.column;
            return store.addSorter(column.field, false);
          }
        }, {
          text: 'L{removeSorterShort}',
          group: 'L{multiSort}',
          localeClass: me,
          icon: 'b-icon b-icon-remove',
          name: 'multisortRemove',
          weight: 105,
          disabled: disabled || !sorter,
          onDrop: function onDrop(_ref6) {
            var column = _ref6.column;
            return store.removeSorter(column.field);
          }
        }]);
      }

      return items;
    } //endregion
    //region Events

    /**
     * Clicked on header, sort Store.
     * @private
     */

  }, {
    key: "onElementClick",
    value: function onElementClick(event) {
      var me = this,
          store = me.store,
          target = event.target,
          header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].up(target, '.b-grid-header.b-sortable'),
          field = header === null || header === void 0 ? void 0 : header.dataset.column;
      if (me.ignoreRe.test(target.className) || me.disabled) return; //Header

      if (header && field) {
        var column = me.grid.columns.getById(header.dataset.columnId),
            columnGrouper = store.isGrouped && store.groupers.find(function (g) {
          return g.field === field;
        }); // The Group feature will handle the change of the grouper's direction

        if (columnGrouper && !event.shiftKey) {
          return;
        }

        if (column.sortable && !event.shiftKey) {
          if (event.ctrlKey && event.altKey) {
            store.removeSorter(column.field);
          } else {
            var sortBy = column.field;

            if (typeof column.sortable === 'function') {
              sortBy = {
                field: column.field,
                fn: column.sortable
              };
            } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17___default()(column.sortable) === 'object') {
              sortBy = column.sortable; // Handle mismatch between Store#sort and CollectionSorter (field/property)

              if (!sortBy.field) {
                sortBy.field = sortBy.property || column.field;
              }
            }

            store.sort(sortBy, null, event.ctrlKey);
          }
        }
      }
    }
    /**
     * Called when grid headers are rendered, make headers match current sorters.
     * @private
     */

  }, {
    key: "renderHeader",
    value: function renderHeader() {
      this.syncHeaderSortState();
    } //endregion

  }, {
    key: "field",
    set: function set(field) {
      // Use columns sortable config for initial sorting if it is specified
      var column = this.grid.columns.get(field);

      if (column && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_17___default()(column.sortable) === 'object') {
        // Normalization of Store & CollectionSorter differences
        column.sortable.field = column.sortable.property || field;
        field = column.sortable;
      }

      this.store.sort(field, this.ascending);
    }
  }, {
    key: "store",
    get: function get() {
      return this.grid.store;
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Grid.

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Sort';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Enable multi sort
         * @config {Boolean}
         * @default
         */
        multiSort: true,
        ignoreRe: new RegExp([// Stop this feature from having to know the internals of two other optional features.
        'b-grid-header-resize-handle', 'b-filter-icon'].join('|')),
        sortableCls: 'b-sortable',
        sortedCls: 'b-sort',
        sortedAscCls: 'b-asc',
        sortedDescCls: 'b-desc'
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onElementClick', 'populateHeaderMenu', 'getColumnDragToolbarItems', 'renderHeader']
      };
    }
  }]);

  return Sort;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_26__["default"]);


Sort.featureClass = 'b-sort';
Sort._$name = 'Sort';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_27__["default"].registerFeature(Sort, true);

/***/ }),

/***/ "./lib/Grid/feature/Stripe.js":
/*!************************************!*\
  !*** ./lib/Grid/feature/Stripe.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Stripe; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Grid/feature/Stripe
 */

/**
 * Stripes rows, by adding even (b-even) or odd (b-odd) css classes to row elements.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * let grid = new Grid({
 *   features: {
 *     stripe: true
 *   }
 * });
 *
 * @demo Grid/columns
 * @classtype stripe
 * @externalexample feature/Stripe.js
 */

var Stripe = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Stripe, _InstancePlugin);

  var _super = _createSuper(Stripe);

  function Stripe() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Stripe);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Stripe, [{
    key: "construct",
    value: function construct(grid, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Stripe.prototype), "construct", this).call(this, grid, config);

      grid.rowManager.on({
        renderrow: 'onRenderRow',
        thisObj: this
      });
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      if (!this.isConfiguring) {
        // Refresh rows to add/remove even/odd classes
        this.client.refreshRows();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Stripe.prototype), "doDisable", this).call(this, disable);
    }
    /**
     * Applies even/odd CSS when row is rendered
     * @param {Grid.row.Row} rowModel
     * @private
     */

  }, {
    key: "onRenderRow",
    value: function onRenderRow(_ref) {
      var row = _ref.row;

      if (!this.disabled) {
        row.addCls(row.dataIndex % 2 === 0 ? 'b-even' : 'b-odd');
      }
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'Stripe';
    }
  }]);

  return Stripe;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


Stripe._$name = 'Stripe';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(Stripe);

/***/ }),

/***/ "./lib/Grid/feature/Summary.js":
/*!*************************************!*\
  !*** ./lib/Grid/feature/Summary.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Summary; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./mixin/SummaryFormatter.js */ "./lib/Grid/feature/mixin/SummaryFormatter.js");




















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Grid/feature/Summary
 */

/**
 * Displays a summary row in the grid footer. Specify type of summary on columns, available types are:
 * <dl class="wide">
 * <dt>sum <dd>Sum of all values in the column
 * <dt>add <dd>Alias for sum
 * <dt>count <dd>Number of rows
 * <dt>countNotEmpty <dd>Number of rows containing a value
 * <dt>average <dd>Average of all values in the column
 * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
 * </dl>
 * Columns can also specify a summaryRenderer to format the calculated sum.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * ```
 * { text : 'Score', data : 'score', width : 80, sum : true }
 * { text : 'Rank', data : 'rank', width : 80, sum : 'average', summaryRenderer: sum => return 'Average rank ' + sum }
 * ```
 *
 * Also it is possible to set up multiple summaries as array of summary configs:
 * ```
 * { text : 'Rank', data : 'rank', summaries : [{ sum : 'average', label : 'Average' }, { sum : 'count', label : 'Count' }] }
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/features
 * @classtype summary
 * @externalexample feature/Summary.js
 */

var Summary = /*#__PURE__*/function (_SummaryFormatter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(Summary, _SummaryFormatter);

  var _super = _createSuper(Summary);

  function Summary() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, Summary);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(Summary, [{
    key: "construct",
    value: function construct(grid, config) {
      this.grid = grid;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Summary.prototype), "construct", this).call(this, grid, config);

      this.bindStore(grid.store);
      grid.hideFooters = false;
    }
  }, {
    key: "bindStore",
    value: function bindStore(store) {
      this.detachListeners('store');
      store.on({
        name: 'store',
        change: 'onStoreChange',
        thisObj: this
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Summary.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Summary.prototype), "doDisable", this).call(this, disable);

      if (disable) {
        this.grid.element.classList.add('b-summary-disabled');
      } else {
        this.updateSummaries();
        this.grid.element.classList.remove('b-summary-disabled');
      }
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "renderRows",
    //endregion
    //region Render
    value: function renderRows() {
      this.updateSummaries();
    }
    /**
     * Updates summaries. Summaries are displayed as tables in footer (styling left out to keep brief):
     * ```
     * <table>
     *     <tr><td colspan="2">0</td></tr> // { sum : 'min' } Only a calculation, span entire table
     *     <tr><td>Max</td><td>10</td></tr> // { sum : 'max', label: 'Max' } Label + calculation
     *     <tr><td>Max</td><td>10</td></tr> // { sum : 'sum', label: 'Max' } Label + calculation
     * </table>
     * ```
     * @private
     */

  }, {
    key: "updateSummaries",
    value: function updateSummaries() {
      var me = this,
          grid = me.grid,
          store = me.store,
          cells = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].children(grid.element, '.b-grid-footer'),
          records = store.storage.values.filter(function (r) {
        return !r.isSpecialRow;
      }); // reset seeds, to not have ever increasing sums :)

      grid.columns.forEach(function (column) {
        column.summaries && column.summaries.forEach(function (config) {
          if ('seed' in config) {
            if (!('initialSeed' in config)) {
              config.initialSeed = config.seed;
            }

            if (['number', 'string', 'date'].includes(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12___default()(config.initialSeed))) {
              config.seed = config.initialSeed;
            } else {
              // create shallow copy
              config.seed = Object.assign({}, config.initialSeed);
            }
          }
        });
      });
      cells.forEach(function (cellElement) {
        // Skip for special columns like checkbox selection
        if (!cellElement.dataset.column) {
          return;
        }

        var column = grid.columns.get(cellElement.dataset.column),
            html = me.generateHtml(column, records, 'b-grid-footer-summary');

        if (column.summaries ? column.summaries.length : column.sum ? 1 : 0) {
          // First time, set table
          if (!cellElement.children.length) {
            cellElement.innerHTML = html;
          } // Following times, sync changes
          else {
              _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].sync(html, cellElement.firstElementChild);
            }
        }
      });
    } //endregion
    //region Events

    /**
     * Updates summaries on store changes (except record update, handled below)
     * @private
     */

  }, {
    key: "onStoreChange",
    value: function onStoreChange(_ref) {
      var _this = this;

      var action = _ref.action,
          changes = _ref.changes;
      var shouldUpdate = true;

      if (this.disabled) {
        return;
      }

      if (action === 'update') {
        // only update summary when a field that affects summary is changed
        // TODO: this should maybe be removed, another column might depend on the value for its summary?
        shouldUpdate = Object.keys(changes).some(function (field) {
          var colField = _this.grid.columns.get(field); // check existence, since a field not used in a column might have changed


          return Boolean(colField) && (Boolean(colField.sum) || Boolean(colField.summaries));
        });
      }

      if (shouldUpdate) {
        this.updateSummaries();
      }
    } //endregion

  }, {
    key: "store",
    get: function get() {
      return this.grid.store;
    }
  }], [{
    key: "$name",
    //region Init
    get: function get() {
      return 'Summary';
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['renderRows']
      };
    }
  }]);

  return Summary;
}(Object(_mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_22__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_20__["default"]));


Summary.featureClass = 'b-summary';
Summary._$name = 'Summary';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_21__["default"].registerFeature(Summary);

/***/ }),

/***/ "./lib/Grid/feature/Tree.js":
/*!**********************************!*\
  !*** ./lib/Grid/feature/Tree.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tree; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../column/TreeColumn.js */ "./lib/Grid/column/TreeColumn.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");






















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Handle paths? Like expandPath('Parent A/Sub B/Leaf')
//TODO: Dblclick on row (or at least tree cell) should expand/collapse (if not using celleditor)
//TODO: Arrows





/**
 * @module Grid/feature/Tree
 */

var immediatePromise = Promise.resolve();
/**
 * Feature that makes the grid work more like a tree. Included by default in {@link Grid.view.TreeGrid}. Requires
 * exactly one {@link Grid.column.TreeColumn} among grids columns. That column will have its renderer replaced with a
 * tree renderer that adds padding and icon to give the appearance of a tree. The original renderer is preserved and
 * also called.
 *
 * This feature is <strong>disabled</strong> by default. When enabled, the feature cannot be disabled during runtime.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/tree
 * @classtype tree
 * @externalexample feature/Tree.js
 */

var Tree = /*#__PURE__*/function (_InstancePlugin$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(Tree, _InstancePlugin$mixin);

  var _super = _createSuper(Tree);

  function Tree() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default()(this, Tree);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default()(Tree, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(grid, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Tree.prototype), "construct", this).call(this, grid, config); // find column


      var me = this,
          treeColumn = grid.columns.find(function (col) {
        return col instanceof _column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_21__["default"];
      });
      Object.assign(me, {
        grid: grid,
        rowManager: grid.rowManager,
        treeColumn: treeColumn
      });
      this.bindStore(grid.store);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {}
  }, {
    key: "bindStore",
    value: function bindStore(store) {
      this.detachListeners('store');
      store.on({
        name: 'store',
        beforeLoadChildren: 'onBeforeLoadChildren',
        loadChildren: 'onLoadChildren',
        loadChildrenException: 'onLoadChildrenException',
        beforeToggleNode: 'onBeforeToggleNode',
        thisObj: this
      });
    } //endregion
    //region Expand & collapse

    /**
     * Collapse an expanded node or expand a collapsed. Optionally forcing a certain state.
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to toggle
     * @param {Boolean} [collapse] Force collapse (true) or expand (false)
     * @param {Boolean} [skipRefresh] Set to true to not refresh rows (if calling in batch)
     * @returns {Promise}
     * @async
     */

  }, {
    key: "toggleCollapse",
    value: function () {
      var _toggleCollapse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee(idOrRecord, collapse) {
        var skipRefresh,
            me,
            store,
            grid,
            rowManager,
            record,
            meta,
            row,
            cell,
            _args = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                skipRefresh = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                me = this, store = me.store, grid = me.grid, rowManager = grid.rowManager, record = store.getById(idOrRecord), meta = record.instanceMeta(store);
                _context.next = 4;
                return store.toggleCollapse(record, collapse);

              case 4:
                if (!_context.sent) {
                  _context.next = 10;
                  break;
                }

                row = rowManager.getRowFor(record);

                if (row) {
                  cell = row.getCell(me.treeColumn.id); // Toggle cell's expanded/collapsed state

                  cell && row.renderCell(cell, record);
                } // Add a temporary cls, used by Scheduler & Gantt to prevent transitions on events/tasks
                // Block multiple applications in the case of a recursive collapseAll operation


                if (!me.isTogglingNode) {
                  grid.element.classList.add('b-toggling-node');
                  me.isTogglingNode = true;
                  me.requestAnimationFrame(function () {
                    grid.element.classList.remove('b-toggling-node');
                    me.isTogglingNode = false;
                  });
                }

                grid.trigger(meta.collapsed ? 'collapseNode' : 'expandNode', {
                  source: grid,
                  record: record
                });
                grid.trigger('toggleNode', {
                  source: grid,
                  record: record,
                  collapse: collapse
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toggleCollapse(_x, _x2) {
        return _toggleCollapse.apply(this, arguments);
      }

      return toggleCollapse;
    }()
    /**
     * Collapse a single node. This function is exposed on Grid and can thus be called as `grid.collapse()`
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to collapse
     * @returns {Promise}
     */

  }, {
    key: "collapse",
    value: function () {
      var _collapse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee2(idOrRecord) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.toggleCollapse(idOrRecord, true));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function collapse(_x3) {
        return _collapse.apply(this, arguments);
      }

      return collapse;
    }()
    /**
     * Expand a single node. This function is exposed on Grid and can thus be called as `grid.expand()`
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to expand
     * @returns {Promise}
     */

  }, {
    key: "expand",
    value: function () {
      var _expand = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee3(idOrRecord) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.toggleCollapse(idOrRecord, false));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function expand(_x4) {
        return _expand.apply(this, arguments);
      }

      return expand;
    }()
  }, {
    key: "onBeforeToggleNode",
    value: function onBeforeToggleNode(_ref) {
      var record = _ref.record,
          collapse = _ref.collapse;
      this.grid.trigger('beforeToggleNode', {
        record: record,
        collapse: collapse
      });
    }
  }, {
    key: "onBeforeLoadChildren",
    value: function onBeforeLoadChildren(_ref2) {
      var store = _ref2.source,
          params = _ref2.params;
      var parent = store.getById(params[store.modelClass.idField]),
          row = this.grid.rowManager.getRowFor(parent);

      if (row) {
        row.addCls('b-loading-children');
      }
    }
  }, {
    key: "onLoadChildren",
    value: function onLoadChildren(_ref3) {
      var store = _ref3.source,
          params = _ref3.params;
      var parent = store.getById(params[store.modelClass.idField]),
          row = this.grid.rowManager.getRowFor(parent);

      if (row) {
        row.removeCls('b-loading-children');
      }
    }
  }, {
    key: "onLoadChildrenException",
    value: function onLoadChildrenException(_ref4) {
      var record = _ref4.record;
      var row = this.grid.rowManager.getRowFor(record);

      if (row) {
        row.removeCls('b-loading-children');
      }
    }
    /**
     * Expand or collapse all nodes, as specified by param, starting at the passed node (which defaults to the root node)
     * @param {Boolean} [collapse] Set to true to collapse, false to expand (defaults to true)
     * @param {Core.data.Model} [topNode] The topmost node from which to cascade a collapse.
     * Defaults to the {@link Core.data.Store#property-rootNode}. Not included in the cascade if
     * the root node is being used.
     * @returns {Promise}
     */

  }, {
    key: "expandOrCollapseAll",
    value: function expandOrCollapseAll() {
      var _this = this;

      var collapse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var topNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.store.rootNode;
      // TODO: Some logic here and some in the store, keep in same place maybe
      var grid = this.grid,
          store = this.store,
          promises = [],
          childRecords = [];
      grid.trigger('beforeToggleAllNodes', {
        source: grid,
        collapse: collapse
      }); // Each collapse/expand will trigger events on store, avoid that by suspending

      store.suspendEvents();
      store.traverse(function (record) {
        var gridMeta = record.instanceMeta(store);

        if (!record.isLeaf) {
          if (collapse && !gridMeta.collapsed) {
            _this.toggleCollapse(record, true, true);

            childRecords.push.apply(childRecords, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_11___default()(record.children));
          } else if (!collapse && gridMeta.collapsed) {
            if (Array.isArray(record.children)) {
              childRecords.push.apply(childRecords, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_11___default()(record.children));
            }

            promises.push(_this.toggleCollapse(record, false, true));
          }
        }
      }, topNode, topNode === store.rootNode);
      store.resumeEvents();
      return (collapse ? immediatePromise : Promise.all(promises)).then(function () {
        // Return to top when collapsing all
        grid.refreshRows(collapse);

        if (childRecords.length) {
          if (collapse) {
            store.trigger('remove', {
              records: childRecords,
              isCollapse: true,
              isCollapseAll: true
            });
          } else {
            store.trigger('add', {
              records: childRecords,
              isExpand: true,
              isExpandAll: true
            });
          }
        }

        grid.trigger('toggleAllNodes', {
          source: grid,
          collapse: collapse
        });
      });
    }
    /**
     * Collapse all nodes. This function is exposed on Grid and can thus be called as `grid.collapseAll()`
     * @returns {Promise}
     */

  }, {
    key: "collapseAll",
    value: function () {
      var _collapseAll = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee4() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.expandOrCollapseAll(true));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function collapseAll() {
        return _collapseAll.apply(this, arguments);
      }

      return collapseAll;
    }()
    /**
     * Expand all nodes. This function is exposed on Grid and can thus be called as `grid.expandAll()`
     * @returns {Promise}
     */

  }, {
    key: "expandAll",
    value: function () {
      var _expandAll = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee5() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.expandOrCollapseAll(false));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function expandAll() {
        return _expandAll.apply(this, arguments);
      }

      return expandAll;
    }()
    /**
     * Expands parent nodes to make this node "visible". This function is exposed on Grid and can thus be called as
     * `grid.expandTo()`
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node
     * @returns {Promise}
     */

  }, {
    key: "expandTo",
    value: function () {
      var _expandTo = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee7(idOrRecord) {
        var me, record, recordMeta, refreshNeeded, parent, parents;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                me = this, record = me.store.getById(idOrRecord), recordMeta = record.instanceMeta(me.store); // Already visible? abort

                if (!(recordMeta.hiddenByCollapse === false)) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return");

              case 3:
                // Expand each parent
                refreshNeeded = false, parent = record.parent;
                parents = []; // To expand path correctly we need to do it from top
                // so parent record for each record will be in the store already

                while (parent && !parent.isRoot) {
                  parents.push(parent);
                  parent = parent.parent;
                }

                _context7.next = 8;
                return parents.reverse().forEach( /*#__PURE__*/function () {
                  var _ref5 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee6(parent) {
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (parent.instanceMeta(me.store).collapsed) {
                              refreshNeeded = true;
                            }

                            _context6.next = 3;
                            return me.toggleCollapse(parent, false, true);

                          case 3:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x6) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 8:
                if (refreshNeeded) {
                  me.grid.refreshRows();
                }

                _context7.next = 11;
                return me.grid.scrollRowIntoView(record);

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function expandTo(_x5) {
        return _expandTo.apply(this, arguments);
      }

      return expandTo;
    }() //endregion
    //region Renderer
    //endregion
    //region Events

    /**
     * Called when user clicks somewhere in the grid. Expand/collapse node on icon click.
     * @private
     */

  }, {
    key: "onElementClick",
    value: function onElementClick(event) {
      var me = this,
          target = event.target,
          cellData = me.grid.getCellDataFromEvent(event),
          clickedExpander = target.closest('.b-tree-expander'); // Checks if click is on node expander icon, then toggles expand/collapse. Also toggles on entire cell if expandOnCellClick is true

      if (clickedExpander || me.expandOnCellClick && cellData && cellData.record.isParent) {
        clickedExpander && event.preventDefault();
        me.toggleCollapse(cellData.record);
      }
    }
    /**
     * Called on key down in grid. Expand/collapse node on [space]
     * @private
     */

  }, {
    key: "onElementKeyDown",
    value: function onElementKeyDown(event) {
      // only catch space on grid element, not in editors etc...
      if (event.target === this.client.focusElement && event.key === ' ') {
        event.preventDefault();
        this.toggleCollapse(this.grid.focusedCell.id);
      }
    } //endregion

  }, {
    key: "navigateRight",
    value: function navigateRight(event) {
      var me = this,
          grid = me.grid,
          cellSelector = grid.focusedCell;

      if (cellSelector) {
        var record = grid.store.getById(cellSelector.id); // shift triggers tree navigation behaviour, also used by default for single column which is tree

        if (grid.columns.getById(cellSelector.columnId).tree && (event.shiftKey || grid.columns.count === 1)) {
          // on collapsed parent, expand
          if (record.isParent && record.instanceMeta(grid.store).collapsed) {
            me.expand(record);
          } // otherwise go down
          else {
              grid.navigateDown(event);
            }

          return false;
        }
      }
    }
  }, {
    key: "navigateLeft",
    value: function navigateLeft(event) {
      var me = this,
          grid = me.grid,
          cellSelector = grid.focusedCell;

      if (cellSelector) {
        var record = grid.store.getById(cellSelector.id);

        if (grid.columns.getById(cellSelector.columnId).tree && (event.shiftKey || grid.columns.count === 1)) {
          // on expanded parent, collapse
          if (record.isParent && !record.instanceMeta(grid.store).collapsed) {
            me.collapse(record);
          } // otherwise go to parent
          else if (record.parent) {
              grid.focusCell({
                id: record.parent.id,
                columnId: cellSelector.columnId
              });
            }

          return false;
        }
      }
    }
  }, {
    key: "store",
    get: function get() {
      return this.grid.store;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Tree';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Expand parent nodes when clicking on their cell
         * @config {Boolean}
         * @default
         */
        expandOnCellClick: false
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        assign: ['collapseAll', 'expandAll', 'collapse', 'expand', 'expandTo', 'toggleCollapse'],
        before: ['navigateRight', 'navigateLeft'],
        chain: ['onElementClick', 'onElementKeyDown', 'bindStore']
      };
    }
  }]);

  return Tree;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_22__["default"].mixin(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_24__["default"]));


Tree.featureClass = 'b-tree';
Tree._$name = 'Tree';
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_23__["default"].registerFeature(Tree, false, 'Grid');
_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_23__["default"].registerFeature(Tree, true, 'TreeGrid');

/***/ }),

/***/ "./lib/Grid/feature/base/ContextMenuBase.js":
/*!**************************************************!*\
  !*** ./lib/Grid/feature/base/ContextMenuBase.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ContextMenuBase; });
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_delete_property__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.delete-property */ "./node_modules/core-js/modules/es.reflect.delete-property.js");
/* harmony import */ var core_js_modules_es_reflect_delete_property__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_delete_property__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../Core/widget/Menu.js */ "./lib/Core/widget/Menu.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Grid/feature/base/ContextMenuBase
 */

/**
 * Abstract base class used by other context menu features.
 * @extends Core/mixin/InstancePlugin
 * @abstract
 */

var ContextMenuBase = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(ContextMenuBase, _InstancePlugin);

  var _super = _createSuper(ContextMenuBase);

  function ContextMenuBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ContextMenuBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(ContextMenuBase, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(ContextMenuBase.prototype), "construct", this).apply(this, arguments);

      if (!this.type || !this.type.length) {
        throw new Error("Config 'type' is required to be specified for context menu");
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$menu;

      (_this$menu = this.menu) === null || _this$menu === void 0 ? void 0 : _this$menu.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(ContextMenuBase.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Events

    /**
     * Fired from grid when an item is selected in the context menu.
     * @event contextMenuItem
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} item Selected menu item
     */

    /**
     * Fired from grid when a check item is toggled in the context menu.
     * @event contextMenuToggleItem
     * @param {Grid.view.Grid} source The grid
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} item Selected menu item
     * @param {Boolean} checked Checked or not
     */

  }, {
    key: "onElementContextMenu",
    value: function onElementContextMenu(event) {
      this.triggerEvent === 'contextmenu' && this.internalShowContextMenu(event);
    }
  }, {
    key: "onElementClick",
    value: function onElementClick(event) {
      this.triggerEvent === 'click' && this.internalShowContextMenu(event);
    }
  }, {
    key: "onElementDblClick",
    value: function onElementDblClick(event) {
      this.triggerEvent === 'dblclick' && this.internalShowContextMenu(event);
    }
  }, {
    key: "onElementKeyDown",
    value: function onElementKeyDown(event) {} //endregion
    //region Menu handlers

  }, {
    key: "internalShowContextMenu",
    value: function internalShowContextMenu(event) {
      var me = this;

      if (me.disabled) {
        return;
      }

      var data = me.getDataFromEvent(event);

      if (me.shouldShowMenu(data)) {
        me.showContextMenu(data);
      }
    }
  }, {
    key: "getDataFromEvent",
    value: function getDataFromEvent(event) {
      return {
        event: event,
        targetElement: this.getTargetElementFromEvent(event)
      };
    }
  }, {
    key: "getTargetElementFromEvent",
    value: function getTargetElementFromEvent(event) {
      return event.target;
    }
    /**
     * Shows the context menu
     * @param {Object} eventParams
     * @param {MouseEvent} eventParams.event
     * @param {HTMLElement} eventParams.targetElement
     * @internal
     */

  }, {
    key: "showContextMenu",
    value: function showContextMenu(eventParams) {
      var me = this;

      if (me.disabled) {
        return;
      }

      var type = me.type,
          client = me.client,
          processItems = me.processItems,
          items = me.items,
          event = eventParams.event,
          targetElement = eventParams.targetElement,
          point = event ? [event.clientX + 1, event.clientY + 1] : _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__["default"].from(targetElement).center;
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].assign(eventParams, {
        items: {},
        selection: client.selectedRecords
      }); // Call the chainable method which other features use to add their own menu items.

      me.callChainablePopulateMenuMethod(eventParams); // Filter out `true` values

      for (var key in items) {
        if (items[key] === true) {
          Reflect.deleteProperty(items, key);
        }
      } // Merge with user defined items


      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].merge(eventParams.items, items); // Allow user a chance at processing the items and preventing the menu from showing

      if ((!processItems || processItems(eventParams) !== false) && me.hasActiveMenuItems(eventParams)) {
        me.populateItemsWithData(eventParams);
        me.preventDefaultEvent(eventParams); // beforeContextMenuShow is a lifecycle method which may be implemented in subclasses to preprocess the event.

        if (me.beforeContextMenuShow(eventParams) !== false) {
          // Trigger event that allows preventing menu or manipulating its items
          if (client.trigger("".concat(type, "MenuBeforeShow"), eventParams) !== false && // TODO: cellContextMenuBeforeShow and headerContextMenuBeforeShow events are deprecated in ContextMenu feature
          client.trigger("".concat(type, "ContextMenuBeforeShow"), eventParams) !== false) {
            me.menu = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].showContextMenu(point, _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].merge({
              items: eventParams.items,
              owner: client,
              scrollAction: 'hide',
              constrainTo: window,
              // Load up the item event with the contextual info
              onBeforeItem: function onBeforeItem(itemEvent) {
                Object.assign(itemEvent, eventParams);
              },
              onItem: function onItem(itemEvent) {
                client.trigger("".concat(type, "MenuItem"), itemEvent); // TODO: contextMenuItem event is deprecated in ContextMenu feature

                client.trigger('contextMenuItem', itemEvent); // TODO: eventContextMenuItem event and schedulerContextMenuItem event are deprecated

                client.trigger("".concat(type, "ContextMenuItem"), itemEvent);
              },
              onToggle: function onToggle(itemEvent) {
                client.trigger("".concat(type, "MenuToggleItem"), itemEvent); // TODO: contextMenuToggleItem event is deprecated in ContextMenu feature

                client.trigger('contextMenuToggleItem', itemEvent);
              },
              onDestroy: function onDestroy() {
                me.menu = null;
              },
              onShow: function onShow(_ref) {
                var menu = _ref.source;
                eventParams.menu = menu;
                client.trigger("".concat(type, "MenuShow"), eventParams); // TODO: cellContextMenuShow and headerContextMenuShow events are deprecated in ContextMenu feature

                client.trigger("".concat(type, "ContextMenuShow"), eventParams);
              }
            }, me.menuConfig));
          }
        }
      }
    }
    /**
     * Hides the context menu
     * @internal
     */

  }, {
    key: "hideContextMenu",
    value: function hideContextMenu(animate) {
      var _this$menu2;

      (_this$menu2 = this.menu) === null || _this$menu2 === void 0 ? void 0 : _this$menu2.hide(animate);
    }
  }, {
    key: "callChainablePopulateMenuMethod",
    value: function callChainablePopulateMenuMethod(eventParams) {
      // For example `populateCellMenu`
      var getItemsMethod = "populate".concat(_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].capitalize(this.type), "Menu");

      if (this.client[getItemsMethod]) {
        this.client[getItemsMethod](eventParams);
      }
    }
  }, {
    key: "createContextMenuEventForElement",
    value: function createContextMenuEventForElement(targetElement) {
      var targetPoint = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__["default"].from(targetElement).center,
          contextmenuEvent = new MouseEvent(this.triggerEvent, {
        clientX: targetPoint.x,
        clientY: targetPoint.y
      });
      Object.defineProperty(contextmenuEvent, 'target', {
        get: function get() {
          return targetElement;
        }
      });
      return contextmenuEvent;
    }
  }, {
    key: "hasActiveMenuItems",
    value: function hasActiveMenuItems(eventParams) {
      return Object.values(eventParams.items).some(function (item) {
        return item;
      });
    }
    /**
     * Override this function and return `false` to prevent the context menu from being shown. Returns `true` by default.
     * @return {Boolean}
     * @internal
     */

  }, {
    key: "shouldShowMenu",
    value: function shouldShowMenu() {
      return true;
    }
  }, {
    key: "beforeContextMenuShow",
    value: function beforeContextMenuShow(eventParams) {}
  }, {
    key: "populateItemsWithData",
    value: function populateItemsWithData(eventParams) {}
  }, {
    key: "preventDefaultEvent",
    value: function preventDefaultEvent(eventParams) {
      var _eventParams$event;

      (_eventParams$event = eventParams.event) === null || _eventParams$event === void 0 ? void 0 : _eventParams$event.preventDefault();
    } //endregion
    //region Getters/Setters

  }, {
    key: "triggerEvent",
    set: function set(value) {
      this._triggerEvent = value;
    },
    get: function get() {
      return this._triggerEvent || this.client.contextMenuTriggerEvent;
    }
  }, {
    key: "type",
    set: function set(value) {
      this._type = value;
    },
    get: function get() {
      return this._type;
    }
  }, {
    key: "menuConfig",
    set: function set(value) {
      this._menuConfig = value;
    },
    get: function get() {
      return this._menuConfig;
    } //endregion

  }], [{
    key: "$name",
    get: function get() {
      return 'ContextMenuBase';
    } //region Config

  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * This is a type of the context menu used to generate correct names for methods and events.
         * Should be in camel case. Required to be set in subclass.
         * @config {String}
         * @readonly
         */
        type: null,

        /**
         * A config which will be applied for Menu component
         * @config {Object}
         */
        menuConfig: null,

        /**
         * {@link Core.widget.Menu Menu} items object containing named child menu items to apply to the feature's
         * provided context menu.
         *
         * This may add extra items as below, but may also remove any of the default items by configuring the name
         * of the item as `false`
         *
         * ```javascript
         * features : {
         *     cellMenu : {
         *         // This object is applied to the Feature's predefined default items
         *         items : {
         *             switchToDog : {
         *                 text : 'Dog',
         *                 icon : 'b-fa b-fa-fw b-fa-dog',
         *                 onItem({contextRecord}) {
         *                     contextRecord.dog = true;
         *                     contextRecord.cat = false;
         *                 },
         *                 weight : 500     // Make this second from end
         *             },
         *             switchToCat : {
         *                 text : 'Cat',
         *                 icon : 'b-fa b-fa-fw b-fa-cat',
         *                 onItem({contextRecord}) {
         *                     contextRecord.dog = false;
         *                     contextRecord.cat = true;
         *                 },
         *                 weight : 510     // Make this sink to end
         *             },
         *             add : false // We do not want the "Add" submenu to be available
         *         }
         *     }
         * }
         * ```
         *
         * @config {Object|Object[]}
         */
        items: null,

        /**
         * A function called before displaying the menu that allows manipulations of its items.
         * Called with a single parameter with format { contextRecord, eventElement, items }.
         * Returning `false` from this function prevents the menu from being shown.
         *
         * ```javascript
         * features : {
         *     cellMenu : {
         *         processItems({contextRecord, items}) {
         *             // Add or remove items here as needed
         *             if (contextRecord.type === 'Meeting') {
         *                 items.cancel = {
         *                     text   : 'Cancel',
         *                     icon   : 'b-fa b-fa-fw b-fa-ban',
         *                     weight : 200 // Move to end
         *                 };
         *             }
         *
         *             // Hide delete for parents
         *             items.deleteTask.hidden = contextRecord.isParent;
         *         }
         *     }
         * }
         * ```
         *
         * @config {Function}
         * @preventable
         */
        processItems: null,

        /**
         * Event which is used to show context menu.
         * Available options are: 'contextmenu', 'click', 'dblclick'.
         * Default value is used from {@link Grid/view/GridBase#config-contextMenuTriggerEvent}
         * @config {String}
         */
        triggerEvent: null
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.
    // The contextmenu event is emulated from a taphold gesture on touch platforms.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        assign: ['showContextMenu'],
        chain: ['onElementContextMenu', 'onElementClick', 'onElementDblClick', 'onElementKeyDown']
      };
    }
  }]);

  return ContextMenuBase;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


ContextMenuBase._$name = 'ContextMenuBase';

/***/ }),

/***/ "./lib/Grid/feature/experimental/ExcelExporter.js":
/*!********************************************************!*\
  !*** ./lib/Grid/feature/experimental/ExcelExporter.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExcelExporter; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_number_is_nan__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.number.is-nan */ "./node_modules/core-js/modules/es.number.is-nan.js");
/* harmony import */ var core_js_modules_es_number_is_nan__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_is_nan__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _util_TableExporter_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../util/TableExporter.js */ "./lib/Grid/util/TableExporter.js");
/* harmony import */ var _util_BooleanUnicodeSymbol_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../util/BooleanUnicodeSymbol.js */ "./lib/Grid/util/BooleanUnicodeSymbol.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/*global zipcelx*/







/**
 * @module Grid/feature/experimental/ExcelExporter
 */

/**
 * **NOTE**: This class requires a 3rd party library to operate.
 *
 * A feature that allows exporting Grid data to Excel without involving the server. It uses {@link Grid.util.TableExporter}
 * class as data provider, [zipcelx library](https://www.npmjs.com/package/zipcelx)
 * forked and adjusted to support [column width config](https://github.com/bryntum/zipcelx/tree/column-width-build)
 * and [Microsoft XML specification](https://msdn.microsoft.com/en-us/library/office/documentformat.openxml.spreadsheet.aspx).
 * Zipcelx should be either in global scope (window) or can be provided with {@link #config-zipcelx} config.
 *
 * ```
 * // Global scope
 * <script src="zipcelx.js"></script>
 *
 * // importing from package
 * import zipcelx from 'zipcelx';
 *
 * const grid = new Grid({
 *     features : {
 *         excelExporter : {
 *             zipcelx
 *         }
 *     }
 * })
 * ```
 *
 * Here is an example of how to add the feature:
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         excelExporter : {
 *             // Choose the date format for date fields
 *             dateFormat : 'YYYY-MM-DD HH:mm',
 *
 *             exporterConfig : {
 *                 // Choose the columns to include in the exported file
 *                 columns : ['name', 'role']
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * And how to call it:
 *
 * ```javascript
 * grid.features.excelExporter.export({
 *     filename : 'Export',
 *     exporterConfig : {
 *         columns : [
 *             { text : 'First Name', field : 'firstName', width : 90 },
 *             { text : 'Age', field : 'age', width : 40 },
 *             { text : 'Starts', field : 'start', width : 140 },
 *             { text : 'Ends', field : 'finish', width : 140 }
 *         ]
 *     }
 * })
 * ```
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Grid/exporttoexcel
 */

var ExcelExporter = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(ExcelExporter, _InstancePlugin);

  var _super = _createSuper(ExcelExporter);

  function ExcelExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, ExcelExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(ExcelExporter, [{
    key: "processValue",
    value: function processValue(value) {
      if (value === undefined || value === null || Number.isNaN(value) || typeof value === 'function' || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default()(value) === 'object' && String(value) === '[object Object]') {
        return '';
      } else {
        return value;
      }
    }
  }, {
    key: "generateExportData",
    value: function generateExportData(config) {
      var me = this,
          _me$exporter$export = me.exporter.export(config.exporterConfig),
          rows = _me$exporter$export.rows,
          columns = _me$exporter$export.columns;

      return {
        rows: rows.map(function (row) {
          return row.map(function (value, index) {
            var _columns$index;

            if (value instanceof Date) {
              value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].format(value, config.dateFormat);
            } else if (typeof value === 'boolean') {
              value = new _util_BooleanUnicodeSymbol_js__WEBPACK_IMPORTED_MODULE_18__["default"](value);
            }

            if (me.convertEmptyValueToEmptyString) {
              value = me.processValue(value);
            }

            var type = ((_columns$index = columns[index]) === null || _columns$index === void 0 ? void 0 : _columns$index.type) === 'number' ? 'number' : 'string';
            return {
              value: value,
              type: type
            };
          });
        }),
        columns: columns.map(function (col) {
          var field = col.field,
              value = col.value,
              width = col.width,
              type = col.type; // when number column is exported with zipcelx, excel warns that sheet is broken and asks for repair
          // repair works, but having error on open doesn't look acceptable
          // type = type === 'number' ? 'number' : 'string';

          type = 'string';
          return {
            field: field,
            value: value,
            width: width,
            type: type
          };
        })
      };
    }
    /**
     * Generate and download a .xslx file.
     * @param {Object} config Optional configuration object, which overrides initial settings of the feature/exporter.
     */

  }, {
    key: "export",
    value: function _export() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this;

      if (!me.zipcelx) {
        throw new Error('ExcelExporter: "zipcelx" library is required');
      }

      if (me.disabled) {
        return;
      }

      config = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].assign({}, me.config, config);

      if (!config.filename) {
        config.filename = me.client.$$name;
      }

      var _config = config,
          filename = _config.filename,
          _me$generateExportDat = me.generateExportData(config),
          rows = _me$generateExportDat.rows,
          columns = _me$generateExportDat.columns;

      me.zipcelx({
        filename: filename,
        sheet: {
          data: [columns].concat(rows),
          cols: columns
        }
      });
    }
  }, {
    key: "construct",
    value: function construct(grid, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(ExcelExporter.prototype), "construct", this).call(this, grid, config);

      if (!this.zipcelx) {
        if (typeof zipcelx !== 'undefined') {
          this.zipcelx = zipcelx;
        }
      }
    }
  }, {
    key: "exporter",
    get: function get() {
      return this._exporter || (this._exporter = new this.exporterClass(Object.assign({
        target: this.client
      }, this.exporterConfig)));
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ExcelExporter';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Name of the exported file
         * @config {String} filename
         * @default
         */
        filename: null,

        /**
         * Defines how date in a cell will be formatted
         * @config {String} dateFormat
         * @default
         */
        dateFormat: 'YYYY-MM-DD',

        /**
         * Exporter class to use as a data provider. {@link Grid.util.TableExporter} by default.
         * @config {Grid.util.TableExporter}
         * @default
         */
        exporterClass: _util_TableExporter_js__WEBPACK_IMPORTED_MODULE_17__["default"],

        /**
         * Configuration object for {@link #config-exporterClass exporter class}.
         * @config {Object}
         */
        exporterConfig: null,

        /**
         * Reference to zipcelx library. If not provided, exporter will look in the global scope.
         * @config
         */
        zipcelx: null,

        /**
         * If this config is true, exporter will convert all empty values to ''. Empty values are:
         * * undefined, null, NaN
         * * Objects/class instances that do not have toString method defined and are stringified to [object Object]
         * * functions
         * @config {Boolean}
         */
        convertEmptyValueToEmptyString: true
      };
    }
  }]);

  return ExcelExporter;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_16__["default"]);


ExcelExporter._$name = 'ExcelExporter';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_15__["default"].registerFeature(ExcelExporter, false, 'Grid');

/***/ }),

/***/ "./lib/Grid/feature/export/PdfExport.js":
/*!**********************************************!*\
  !*** ./lib/Grid/feature/export/PdfExport.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PdfExport; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../../Core/helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./exporter/MultiPageExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageExporter.js");
/* harmony import */ var _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./exporter/MultiPageVerticalExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony import */ var _exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./exporter/SinglePageExporter.js */ "./lib/Grid/feature/export/exporter/SinglePageExporter.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../view/export/ExportDialog.js */ "./lib/Grid/view/export/ExportDialog.js");
/* harmony import */ var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../../../Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");


































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';












/**
 * @module Grid/feature/export/PdfExport
 */

/**
 * Generates PDF/PNG files from the Grid component.
 *
 *
 * **NOTE:** This feature will make a fetch request to the server, posting
 * the HTML fragments to be exported. The {@link #config-exportServer} URL must be configured.
 *
 * ## Usage
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080' // Required
 *         }
 *     }
 * })
 *
 * // Opens popup allowing to customize export settings
 * grid.features.pdfExport.showExportDialog();
 *
 * // Simple export
 * grid.features.pdfExport.export({
 *     columns : grid.columns.map(c => c.id) // Required, set list of column ids to export
 * }).then(result => {
 *     // Response instance and response content in JSON
 *     let { response } = result;
 * });
 * ```
 *
 * ## Exporters
 *
 * There are three exporters available by default: `singlepage`, `multipage` and `multipagevertical`:
 *  * `singlepage` -  generates single page with content scaled to fit the provided {@link #config-paperFormat}
 *  * `multipage` - generates as many pages as required to fit all requested content, unscaled
 *  * `multipagevertical` - a combination of two above: it scales content horizontally to fit into page width and then
 *  puts overflowing content on vertical pages. Like a scroll.
 *
 * ## Loading resources
 *
 * If you face a problem with loading resources when exporting, the cause might be that the application and the export server are hosted on different servers.
 * This is due to [Cross-Origin Resource Sharing](https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS) (CORS). There are 2 options how to handle this:
 * - Allow cross origin requests from the server where your export is hosted to the server where your application is hosted;
 * - Copy all resources keeping the folder hierarchy from the server where your application is hosted to the server where your export is hosted
 * and setup paths using {@link #config-translateURLsToAbsolute} config and configure the export server to give access to the path:
 *
 * ```javascript
 * const grid = new Grid({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080',
 *             translateURLsToAbsolute : 'http://localhost:8080/resources' // '/resources' is hardcoded in WebServer implementation
 *         }
 *     }
 * })
 * ```
 *
 * ```javascript
 * // Following path would be served by this address: http://localhost:8080/resources/
 * node ./src/server.js -h 8080 -r web/application/styles
 * ```
 *
 * where `web/application/styles` is a physical root location of the copied resources, for example:
 *
 * <img src="resources/images/export-server-resources.png" style="max-width : 500px" alt="Export server structure with copied resources" />
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @demo Grid/export
 * @classtype pdfExport
 */

var PdfExport = /*#__PURE__*/function (_Localizable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default()(PdfExport, _Localizable);

  var _super = _createSuper(PdfExport);

  function PdfExport() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27___default()(this, PdfExport);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default()(PdfExport, [{
    key: "doDestroy",
    value: function doDestroy() {
      if (this.exportDialog) {
        this.exportDialog.destroy();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(PdfExport.prototype), "doDestroy", this).call(this);
    }
    /**
     * When export is started from GUI ({@link Grid.view.export.ExportDialog}), export promise can be accessed via
     * this property.
     * @property {Promise}
     */

  }, {
    key: "getExporter",
    value: function getExporter() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this,
          exportersMap = me.exportersMap,
          _config = config,
          type = _config.type;
      var exporter;

      if (exportersMap.has(type)) {
        exporter = exportersMap.get(type);
      } else {
        var exporterClass = this.exporters.find(function (cls) {
          return cls.type === type;
        });

        if (!exporterClass) {
          throw new Error("Exporter type ".concat(type, " is not found. Make sure you've configured it"));
        }

        config = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].clone(config);
        delete config.type;
        exporter = new exporterClass(config);
        exporter.relayAll(me);
        exportersMap.set(type, exporter);
      }

      return exporter;
    }
  }, {
    key: "buildRequest",
    value: function buildRequest(pages, config) {
      return {
        html: JSON.stringify(pages),
        fileFormat: config.fileFormat,
        format: config.paperFormat,
        orientation: config.orientation
      };
    }
  }, {
    key: "buildExportConfig",
    value: function buildExportConfig() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this,
          client = me.client,
          exportServer = me.exportServer,
          clientURL = me.clientURL,
          fileFormat = me.fileFormat,
          fileName = me.fileName,
          paperFormat = me.paperFormat,
          rowsRange = me.rowsRange,
          alignRows = me.alignRows,
          repeatHeader = me.repeatHeader,
          keepRegionSizes = me.keepRegionSizes,
          orientation = me.orientation,
          exporters = me.exporters,
          translateURLsToAbsolute = me.translateURLsToAbsolute,
          keepPathName = me.keepPathName,
          headerTpl = me.headerTpl,
          footerTpl = me.footerTpl;

      if (!config.columns) {
        config.columns = client.columns.visibleColumns.map(function (c) {
          return c.id;
        });
      }

      var result = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].assign({
        client: client,
        exportServer: exportServer,
        clientURL: clientURL,
        fileFormat: fileFormat,
        paperFormat: paperFormat,
        rowsRange: rowsRange,
        alignRows: alignRows,
        repeatHeader: repeatHeader,
        keepRegionSizes: keepRegionSizes,
        orientation: orientation,
        translateURLsToAbsolute: translateURLsToAbsolute,
        keepPathName: keepPathName,
        headerTpl: headerTpl,
        footerTpl: footerTpl,
        exporterType: exporters[0].type,
        fileName: fileName || client.$$name
      }, config); // Only vertical exporter is supported

      if (result.exporterType !== 'multipagevertical') {
        result.repeatHeader = false;
      } // Align rows by default


      if (!('alignRows' in config) && config.repeatHeader) {
        result.alignRows = true;
      } // Only change this setting if it is default (false) and not provided directly in config


      if (!('keepRegionSizes' in config) && !result.keepRegionSizes) {
        var collapsed = [],
            _keepRegionSizes = {}; // If there's at least one collapsed region - lock other region sizes

        client.eachSubGrid(function (s) {
          return s.collapsed && collapsed.push(s.region);
        });

        if (collapsed.length) {
          client.eachSubGrid(function (s) {
            if (!collapsed.includes(s.region)) {
              _keepRegionSizes[s.region] = true;
            }
          });
          result.keepRegionSizes = _keepRegionSizes;
        }
      }

      return result;
    }
    /**
     * Starts the export process. Accepts a config object which overrides any default configs.
     * **NOTE**. Component should not be interacted with when export is in progress
     *
     * @param {Object} config
     * @param {String[]} config.columns (requried) List of column ids to export. E.g.
     * ```grid.features.pdfExport.export({ columns : grid.columns.map(c => c.id) })```
     * @returns {Promise} Object of the following structure
     * ```
     * {
     *     response // Response instance
     * }
     * ```
     * @async
     */

  }, {
    key: "export",
    value: function () {
      var _export2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default.a.mark(function _callee() {
        var config,
            me,
            client,
            pagesPerRequest,
            result,
            exporter,
            pages,
            response,
            responseJSON,
            link,
            _args = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                me = this, client = me.client, pagesPerRequest = me.pagesPerRequest;
                config = me.buildExportConfig(config);
                config.exporterConfig = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].assign({
                  type: config.exporterType,
                  translateURLsToAbsolute: config.translateURLsToAbsolute,
                  keepPathName: config.keepPathName
                }, config.exporterConfig || {});
                /**
                 * Fires before export started. Return `false` to cancel the export.
                 * @event beforeExport
                 * @preventable
                 * @param {Object} config Export config
                 */

                if (!(client.trigger('beforeExport', config) !== false)) {
                  _context.next = 33;
                  break;
                }

                // Raise flag on the client to render all suggested dependencies
                client.ignoreViewBox = true; // This mask should be always visible to protect grid from changes even if the mask message is not visible
                // due to the export dialog which is rendered above the grid's mask. The dialog has its own mask which shares the export message.

                client.mask(me.exportMask);
                _context.prev = 7;
                exporter = me.getExporter(config.exporterConfig);

                if (!(pagesPerRequest === 0)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 12;
                return exporter.export(config);

              case 12:
                pages = _context.sent;

                /**
                 * Fires when export progress changes
                 * @event exportStep
                 * @param {Number} progress Current progress, 0-100
                 * @param {String} text Optional text to show
                 */
                me.trigger('exportStep', {
                  progress: 90,
                  text: me.exportProgressMask
                });
                _context.next = 16;
                return _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_33__["default"].post(config.exportServer, {
                  html: pages,
                  orientation: config.orientation,
                  format: config.paperFormat,
                  fileFormat: config.fileFormat,
                  fileName: config.fileName,
                  clientURL: config.clientURL
                }, Object.assign({
                  credentials: 'omit',
                  parseJson: true
                }, me.fetchOptions));

              case 16:
                response = _context.sent;
                result = {
                  response: response
                };

                if (response.ok) {
                  responseJSON = response.parsedJson;

                  if (me.openAfterExport) {
                    if (responseJSON.success) {
                      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].isIE11) {
                        window.open(responseJSON.url, 'ExportedPanel');
                      } else {
                        link = document.createElement('a');
                        link.download = config.fileName;
                        link.href = responseJSON.url;

                        if (me.openInNewTab) {
                          link.target = '_blank';
                        }

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }
                    } else {
                      _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].toast(responseJSON.msg);
                    }
                  }
                }

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](7);

                if (_context.t0 instanceof Response) {
                  result = {
                    response: _context.t0
                  };
                } else {
                  result = {
                    error: _context.t0
                  };
                }

                throw _context.t0;

              case 25:
                _context.prev = 25;

                if (me.exportDialog) {
                  me.exportDialog.close();
                }

                client.unmask();
                client.ignoreViewBox = false;
                /**
                 * Fires when export has finished
                 * @event export
                 * @param {Response} [response] Optional response, if received
                 * @param {Error} [error] Optional error, if exception occurred
                 */

                me.trigger('export', result);

                if (result.error) {
                  _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].toast(me.L('L{Export failed}'));
                } else if (!result.response.ok) {
                  _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].toast(me.L('L{Server error}'));
                }

                client.trigger('export', result);
                return _context.finish(25);

              case 33:
                return _context.abrupt("return", result);

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 21, 25, 33]]);
      }));

      function _export() {
        return _export2.apply(this, arguments);
      }

      return _export;
    }()
  }, {
    key: "showExportDialog",

    /**
     * Shows {@link Grid.view.export.ExportDialog export dialog}
     * @returns {Promise}
     */
    value: function showExportDialog() {
      var me = this;

      if (!me.exportDialog) {
        me.exportDialog = new _view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_40__["default"](Object.assign({}, me.defaultExportDialogConfig, {
          listeners: {
            export: me.onExportDialogExport,
            thisObj: me
          }
        }));
      }

      return me.exportDialog.show();
    }
  }, {
    key: "onExportDialogExport",
    value: function onExportDialogExport(_ref) {
      var values = _ref.values;
      var me = this;
      me.mask = new _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_43__["default"]({
        progress: 0,
        maxProgress: 100,
        text: me.exportMask,
        target: me.exportDialog.element
      });
      var detacher = me.on({
        export: function _export() {
          me.mask.close();
          detacher();
        },
        exportstep: function exportstep(_ref2) {
          var progress = _ref2.progress,
              text = _ref2.text;
          me.mask.progress = progress;

          if (text != null) {
            me.mask.text = text;
          }
        }
      });
      me.currentExportPromise = me.export(values); // Clear current export promise

      me.currentExportPromise.then(function () {
        return me.currentExportPromise = null;
      });
    }
  }, {
    key: "currentExportPromise",
    get: function get() {
      return this._currentExportPromise;
    },
    set: function set(value) {
      this._currentExportPromise = value;
    }
  }, {
    key: "exportersMap",
    get: function get() {
      return this._exportersMap || (this._exportersMap = new Map());
    }
  }, {
    key: "defaultExportDialogConfig",
    get: function get() {
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].copyProperties({}, this, ['client', 'exporters', 'exporterType', 'orientation', 'fileFormat', 'paperFormat', 'alignRows', 'rowsRange', 'repeatHeader']);
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'PdfExport';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * URL of the print server.
         * @config {String}
         */
        exportServer: undefined,

        /**
         * Name of the exported file.
         * @config {String}
         */
        fileName: null,

        /**
         * Format of the exported file, selectable from `pdf` or `png`. By default plugin exports panel contents to PDF
         * but PNG file format is also available.
         * @config {String}
         * @default
         * @group Export file config
         */
        fileFormat: 'pdf',

        /**
         * Export server will navigate to this url first and then will change page content to whatever client sent.
         * This option is useful with react dev server, which has pretty strict CORS policy.
         * @config {String}
         */
        clientURL: null,

        /**
         * Export paper format. Available options are A1...A5, Legal, Letter.
         * @config {String}
         * @default
         * @group Export file config
         */
        paperFormat: 'A4',

        /**
         * Orientation. Options are `portrait` and `landscape`.
         * @config {String}
         * @default
         * @group Export file config
         */
        orientation: 'portrait',

        /**
         * Specifies which rows to export. `all` for complete set of rows, `visible` for only rows currently visible.
         * @config {String}
         * @group Export file config
         */
        rowsRange: 'all',

        /**
         * Set to true to align row top to the page top on every exported page. Only applied to multipage export.
         * @config {Boolean}
         * @default
         */
        alignRows: false,

        /**
         * Set to true to show column headers on every page. This will also set {@link #config-alignRows} to true.
         * Only applies to MultiPageVertical exporter.
         * @config {Boolean}
         * @default
         */
        repeatHeader: false,

        /**
         * By default subGrid width is changed to fit all exported columns. To keep certain subGrid size specify it
         * in the following form:
         * ```
         * keepRegionSizes : {
         *     locked : true
         * }
         * ```
         * @config {Object}
         * @default
         */
        keepRegionSizes: null,

        /**
         * When exporting large views (hundreds of pages) stringified HTML may exceed browser or server request
         * length limit. This config allows to specify how many pages to send to server in one request.
         * @config {Number}
         * @default
         * @private
         */
        pagesPerRequest: 0,

        /**
         * Config for exporter.
         * @config {Object}
         * @private
         */
        exporterConfig: null,

        /**
         * Type of the exporter to use. Should be one of the configured {@link #config-exporters}
         * @config {String}
         * @default
         */
        exporterType: 'singlepage',

        /**
         * List of exporter classes to use in export feature
         * @config {Grid.feature.export.exporter.Exporter[]}
         * @default
         */
        exporters: [_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_37__["default"], _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_35__["default"], _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_36__["default"]],

        /**
         * `True` to replace all linked CSS files URLs to absolute before passing HTML to the server.
         * When passing a string the current origin of the CSS files URLS will be replaced by the passed origin.
         *
         * For example: css files pointing to /app.css will be translated from current origin to {translateURLsToAbsolute}/app.css
         * @config {Boolean|String}
         * @default
         */
        translateURLsToAbsolute: true,

        /**
         * When true links are converted to absolute by combining current window location (with replaced origin) with
         * resource link.
         * When false links are converted by combining new origin with resource link (for angular)
         * @config {Boolean}
         * @default
         */
        keepPathName: true,

        /**
         * When true, page will attempt to download generated file.
         * @config {Boolean}
         * @default
         */
        openAfterExport: true,

        /**
         * False to open in the current tab, true - in a new tab
         * @config {Boolean}
         * @default
         */
        openInNewTab: false,

        /**
         * A template function used to generate a page header. It is passed an object with ´currentPage´ and `totalPages´ properties.
         *
         * ```javascript
         * let grid = new Grid({
         *     appendTo   : 'container',
         *     features : {
         *         pdfExport : {
         *             exportServer : 'http://localhost:8080/',
         *             headerTpl : ({ currentPage, totalPages }) => `
         *                 <div class="demo-export-header">
         *                     <img src="coolcorp-logo.png"/>
         *                     <dl>
         *                         <dt>Date: ${DateHelper.format(new Date(), 'll LT')}</dt>
         *                         <dd>${totalPages ? `Page: ${currentPage + 1}/${totalPages}` : ''}</dd>
         *                     </dl>
         *                 </div>`
         *          }
         *     }
         * });
         * ```
         * @config {Function}
         */
        headerTpl: null,

        /**
         * A template function used to generate a page footer. It is passed an object with ´currentPage´ and `totalPages´ properties.
         *
         * ```javascript
         * let grid = new Grid({
         *      appendTo   : 'container',
         *      features : {
         *          pdfExport : {
         *              exportServer : 'http://localhost:8080/',
         *              footerTpl    : () => '<div class="demo-export-footer"><h3>© 2020 CoolCorp Inc</h3></div>'
         *          }
         *      }
         * });
         * ```
         * @config {Function}
         */
        footerTpl: null,

        /**
         * An object containing the Fetch options to pass to the export server request. Use this to control if credentials are sent
         * and other options, read more at [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch).
         * @config {Object}
         */
        fetchOptions: null,

        /**
         * A message to be shown when Export feature is performing export.
         * @config {String}
         * @default "Generating pages..."
         */
        exportMask: 'L{Generating pages}',

        /**
         * A message to be shown when export is almost done.
         * @config {String}
         * @default "Waiting for response from server..."
         */
        exportProgressMask: 'L{Waiting for response from server}',
        localizableProperties: ['exportMask', 'exportProgressMask']
      };
    }
  }]);

  return PdfExport;
}(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_44__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_34__["default"]));


PdfExport._$name = 'PdfExport';
_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_41__["default"].registerFeature(PdfExport, false, 'Grid'); // Format expected by export server
// const pageFormat = {
//     html       : '',
//     column     : 1,
//     number     : 1,
//     row        : 1,
//     rowsHeight : 1
// };
//
// const format = {
//     fileFormat  : 'pdf',
//     format      : 'A4',
//     orientation : 'portrait',
//     range       : 'complete',
//     html        : { array : JSON.stringify(pageFormat) }
// };

/***/ }),

/***/ "./lib/Grid/feature/export/Utils.js":
/*!******************************************!*\
  !*** ./lib/Grid/feature/export/Utils.js ***!
  \******************************************/
/*! exports provided: RowsRange, PaperFormat, Orientation, FileFormat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RowsRange", function() { return RowsRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaperFormat", function() { return PaperFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Orientation", function() { return Orientation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileFormat", function() { return FileFormat; });
var productName = 'scheduler';
var RowsRange = {
  all: 'all',
  visible: 'visible'
};
var PaperFormat = {
  A6: {
    width: 4.13,
    height: 5.81
  },
  A5: {
    width: 5.81,
    height: 8.25
  },
  A4: {
    width: 8.25,
    height: 11.69
  },
  A3: {
    width: 11.69,
    height: 16.49
  },
  Legal: {
    width: 8.5,
    height: 14
  },
  Letter: {
    width: 8.5,
    height: 11
  }
};
var Orientation = {
  portrait: 'portrait',
  landscape: 'landscape'
};
var FileFormat = {
  pdf: 'pdf',
  png: 'png'
};

/***/ }),

/***/ "./lib/Grid/feature/export/exporter/Exporter.js":
/*!******************************************************!*\
  !*** ./lib/Grid/feature/export/exporter/Exporter.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Exporter; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/web.url */ "./node_modules/core-js/modules/web.url.js");
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! @babel/runtime/helpers/awaitAsyncGenerator */ "./node_modules/@babel/runtime/helpers/awaitAsyncGenerator.js");
/* harmony import */ var _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! @babel/runtime/helpers/wrapAsyncGenerator */ "./node_modules/@babel/runtime/helpers/wrapAsyncGenerator.js");
/* harmony import */ var _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../../../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../../../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../../../../Core/helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");

















































function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_40___default()(["\n            <!DOCTYPE html>\n            <html class=\"", "\" style=\"width: ", "in; height: ", "in;\">\n                <head>\n                    <meta content=\"text/html; charset=UTF-8\" http-equiv=\"Content-Type\" />\n                    <title>", "</title>\n                    ", "\n                </head>\n                <body class=\"b-export ", "\" style=\"width: ", "in; height: ", "in; ", "\">\n                    <div class=\"b-export-content\">\n                        ", "\n                        <div class=\"b-export-body\"><div class=\"b-export-viewport\">", "</div></div>\n                        ", "\n                    </div>\n                </body>\n            </html>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';









/**
 * @module Grid/feature/export/exporter/Exporter
 */

/**
 * Base class for all exporters
 * @mixes Core/localization/Localizable
 * @mixes Core/mixin/Events
 */

var Exporter = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43___default()(Exporter, _Delayable);

  var _super = _createSuper(Exporter);

  function Exporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_41___default()(this, Exporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_42___default()(Exporter, [{
    key: "pageTpl",

    /**
     * Template of an extracted page.
     * @param {Object} data Data for the page template
     * @returns {String}
     */
    value: function pageTpl(data) {
      var title = data.title,
          header = data.header,
          footer = data.footer,
          styles = data.styles,
          htmlClasses = data.htmlClasses,
          bodyStyle = data.bodyStyle,
          _data$bodyClasses = data.bodyClasses,
          bodyClasses = _data$bodyClasses === void 0 ? [] : _data$bodyClasses,
          paperHeight = data.paperHeight,
          paperWidth = data.paperWidth,
          html = data.html;
      bodyClasses.push("b-".concat(this.constructor.type)); // Other classes needed on outer element.
      // TODO: use the new static Widget.outerCls property when merged with master

      if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_53__["default"].scrollBarWidth) {
        bodyClasses.push('b-visible-scrollbar');
      } else {
        bodyClasses.push('b-overlay-scrollbar');
      }

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"].isChrome) {
        bodyClasses.push('b-chrome');
      } else if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"].isSafari) {
        bodyClasses.push('b-safari');
      } else if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"].isFirefox) {
        bodyClasses.push('b-firefox');
      } else if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"].isIE11) {
        bodyClasses.push('b-ie');
      } else if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"].isEdge) {
        bodyClasses.push('b-edge');
      }

      return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].tpl(_templateObject(), htmlClasses, paperWidth, paperHeight, title, styles.join(''), bodyClasses.join(' '), paperWidth, paperHeight, bodyStyle, header && "<div class=\"b-export-header\" style=\"width: 100%\">".concat(header, "</div>"), html, footer && "<div class=\"b-export-footer\" style=\"width: 100%\">".concat(footer, "</div>"));
    }
    /**
     * Returns all style-related tags: `<style>` and `<link rel="stylesheet">`
     * @property {String[]}
     * @readonly
     */

  }, {
    key: "getStyleTagURLConverter",
    value: function getStyleTagURLConverter(translate) {
      return function (match, url) {
        var result;

        try {
          var base; // Filter out local references, e.g. to svg marker

          if (/^#/.test(url)) {
            result = match;
          } else {
            if (translate === true) {
              base = window.location.href;
            } // translate is truthy if we are here, which means it is string now
            else {
                if (this.keepPathName) {
                  base = window.location.href.replace(window.location.origin, translate);
                } else {
                  base = translate;
                }
              }

            result = "url('".concat(new URL(url, base).href, "')");
          }
        } catch (e) {
          result = match;
        }

        return result;
      }.bind(this);
    }
  }, {
    key: "saveState",
    value: function saveState(_ref) {
      var client = _ref.client;
      this.state = client.state;
      var tbar = client.tbar,
          bbar = client.bbar;

      if (tbar) {
        this.state.tbar_hidden = tbar.hidden;
        tbar.hide(false);
      }

      if (bbar) {
        this.state.bbar_hidden = bbar.hidden;
        bbar.hide(false);
      }
    }
  }, {
    key: "restoreState",
    value: function () {
      var _restoreState = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_39___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.mark(function _callee(_ref2) {
        var client, promises, detachers, tbar, bbar;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client = _ref2.client;
                promises = [], detachers = new Set(), tbar = client.tbar, bbar = client.bbar;
                detachers.add(client.scrollable.on({
                  scrollStart: function scrollStart() {
                    promises.push(client.scrollable.await('scrollEnd'));
                  }
                }));
                client.eachSubGrid(function (_ref3) {
                  var header = _ref3.header,
                      scrollable = _ref3.scrollable;
                  detachers.add(scrollable.on({
                    scrollStart: function scrollStart() {
                      promises.push(scrollable.await('scrollEnd'));
                    }
                  }));
                  detachers.add(header.scrollable.on({
                    scrollStart: function scrollStart() {
                      promises.push(header.scrollable.await('scrollEnd'));
                    }
                  }));
                });

                if (tbar) {
                  tbar.hidden = this.state.tbar_hidden;
                  delete this.state.tbar_hidden;
                }

                if (bbar) {
                  bbar.hidden = this.state.bbar_hidden;
                  delete this.state.bbar_hidden;
                }

                client.state = this.state;
                _context.next = 9;
                return Promise.all(promises);

              case 9:
                detachers.forEach(function (fn) {
                  return fn();
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function restoreState(_x) {
        return _restoreState.apply(this, arguments);
      }

      return restoreState;
    }()
  }, {
    key: "beforeExport",
    value: function beforeExport() {
      // Into this element we will put HTML for export
      this.element = document.createElement('div');
    } //region DOM helpers

  }, {
    key: "cloneElement",
    value: function cloneElement(element) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.element;
      var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (clear) {
        target.innerHTML = '';
      }

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"].isChrome) {
        target.appendChild(element.cloneNode(true));
      } else {
        target.innerHTML = element.outerHTML;
      }

      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_53__["default"].removeEachSelector(target, '.b-grid-row');
      var maskEl = target.querySelector('.b-gridbase > .b-mask');

      if (maskEl) {
        maskEl.remove();
      }
    }
    /**
     * Appends generated header/footer element to the document body to measure their height
     * @param html
     * @returns {number}
     * @private
     */

  }, {
    key: "measureElement",
    value: function measureElement() {
      var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (html instanceof HTMLElement) {
        html = html.outerHTML;
      }

      var target = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_53__["default"].createElement({
        parent: document.body,
        style: {
          visibility: 'hidden',
          position: 'absolute'
        },
        // Add html to measure to a div between two other divs to take margin into account
        html: "<div style=\"height: 1px\"></div>".concat(html, "<div style=\"height: 1px\"></div>")
      });
      var result = target.offsetHeight - 2;
      target.remove();
      return result;
    } // Converts local urls to absolute

  }, {
    key: "prepareHTML",
    value: function prepareHTML(html) {
      if (html instanceof HTMLElement) {
        html = html.outerHTML;
      }

      var target = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_53__["default"].createElement({
        parent: document.body,
        style: {
          visibility: 'hidden',
          position: 'absolute'
        },
        html: html
      });
      var elements = target.querySelectorAll('img');

      for (var i = 0, l = elements.length; i < l; i++) {
        elements[i].setAttribute('src', elements[i].src);
      }

      var result = target.innerHTML;
      target.remove();
      return result;
    }
  }, {
    key: "createPlaceholder",
    value: function createPlaceholder(el) {
      var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (clear) {
        el.innerHTML = '';
      }

      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_53__["default"].createElement({
        parent: el,
        id: _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_52__["default"].generateId('export')
      });
    }
  }, {
    key: "getVirtualScrollerHeight",
    value: function getVirtualScrollerHeight(client) {
      var result = 0; // If overlay scroll is enabled, this will return 0
      // when disabled, it will report proper virutalScrollers element height

      client.eachSubGrid(function (subGrid) {
        if (subGrid.overflowingHorizontally) {
          result = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_53__["default"].scrollBarWidth;
        }
      }); // If there's a visible scrollbar, need to also take border height into account

      return result === 0 ? result : result + 1;
    } //endregion

  }, {
    key: "inchToPx",
    value: function inchToPx(value) {
      // 1in = 96px for screens
      // https://developer.mozilla.org/en-US/docs/Web/CSS/length#Absolute_length_units
      return value * 96;
    }
  }, {
    key: "getScaleValue",
    value: function getScaleValue(base, value) {
      return Math.floor(base * 10000 / value) / 10000;
    }
  }, {
    key: "getVisibleRowsCount",
    value: function getVisibleRowsCount(client) {
      var rowManager = client.rowManager,
          // We cannot rely on `visibleRowCount` property, it is a mere estimate
      firstVisibleIndex = rowManager.rows.indexOf(rowManager.firstVisibleRow),
          lastVisibleIndex = rowManager.rows.indexOf(rowManager.lastVisibleRow);
      var result; // first index could be negative only if there are no rendered rows, in which case we return store count

      if (firstVisibleIndex !== -1) {
        // last visible index could be negative if last actually visible row doesn't reach view bottom, i.e.
        // view is not completely filled with rows
        if (lastVisibleIndex === -1) {
          result = client.store.count - firstVisibleIndex;
        } else {
          // for a zero-based index we need to add 1 to the result
          result = lastVisibleIndex - firstVisibleIndex + 1;
        }
      } else {
        result = client.store.count;
      }

      return result;
    }
  }, {
    key: "export",
    value: function () {
      var _export2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_39___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.mark(function _callee2(config) {
        var me, pages;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                me = this;
                me.beforeExport();
                me.saveState(config);
                _context2.next = 5;
                return me.prepareComponent(config);

              case 5:
                _context2.prev = 5;
                _context2.next = 8;
                return me.getPages(config);

              case 8:
                pages = _context2.sent;

              case 9:
                _context2.prev = 9;
                _context2.next = 12;
                return me.restoreComponent(config);

              case 12:
                me.stylesheets = null; // https://app.assembla.com/spaces/bryntum/tickets/9400-scrollrowintoview-promise-is-not-reliable/details
                // Restoring scroll might trigger rows repaint on next animation frame. We are
                // waiting for next animation frame in such case. Covered in SinglePage.t.js

                _context2.next = 15;
                return new Promise(function (resolve) {
                  return me.requestAnimationFrame(resolve);
                });

              case 15:
                _context2.next = 17;
                return me.restoreState(config);

              case 17:
                return _context2.finish(9);

              case 18:
                return _context2.abrupt("return", pages);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5,, 9, 18]]);
      }));

      function _export(_x2) {
        return _export2.apply(this, arguments);
      }

      return _export;
    }()
  }, {
    key: "getPages",
    value: function () {
      var _getPages = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_39___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.mark(function _callee3(config) {
        var generator, pages, step;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                generator = this.pagesExtractor(config), pages = [];

              case 1:
                _context3.next = 3;
                return generator.next();

              case 3:
                _context3.t0 = step = _context3.sent;

                if (!_context3.t0) {
                  _context3.next = 6;
                  break;
                }

                _context3.t0 = !step.done;

              case 6:
                if (!_context3.t0) {
                  _context3.next = 10;
                  break;
                }

                pages.push(step.value);
                _context3.next = 1;
                break;

              case 10:
                return _context3.abrupt("return", pages);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPages(_x3) {
        return _getPages.apply(this, arguments);
      }

      return getPages;
    }() // Row buffer has to be adjusted to render complete row set per exported page. See virtual scrolling section in README
    // for more details

  }, {
    key: "adjustRowBuffer",
    value: function adjustRowBuffer(client) {
      var contentHeight = this.exportMeta.contentHeight,
          rowManager = client.rowManager;
      this.oldRowManagerConfig = {
        prependRowBuffer: rowManager.prependRowBuffer,
        appendRowBuffer: rowManager.appendRowBuffer
      }; // render 3 times more rows to get enough to fill exported page

      var adjustedRowBuffer = Math.ceil(contentHeight / rowManager.rowOffsetHeight);
      rowManager.prependRowBuffer = adjustedRowBuffer;
      rowManager.appendRowBuffer = adjustedRowBuffer; // Pass false to skip scrolling

      client.renderRows(false); // In case we are at the bottom of the view and we are increasing buffer, rowmanager might return to the top row
      // In this case we need to force it to render rows at the current scroll position

      client.rowManager.jumpToPosition(client.scrollable.y);
    }
  }, {
    key: "restoreRowBuffer",
    value: function restoreRowBuffer(client) {
      client.rowManager.prependRowBuffer = this.oldRowManagerConfig.prependRowBuffer;
      client.rowManager.appendRowBuffer = this.oldRowManagerConfig.appendRowBuffer; // There is no need to force rendering rows here, those would be updated during applyState call on a grid.
      // More precisely - during setRowHeight method.
    }
  }, {
    key: "prepareComponent",
    value: function () {
      var _prepareComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_39___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.mark(function _callee4(config) {
        var me, client, columns, rowsRange, keepRegionSizes, exportMeta, firstVisibleDataIndex, element;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                me = this, client = config.client, columns = config.columns, rowsRange = config.rowsRange, keepRegionSizes = config.keepRegionSizes, exportMeta = me.exportMeta = {
                  totalWidth: 0,
                  totalHeight: 0 - me.getVirtualScrollerHeight(client),
                  subGrids: {}
                };
                client.columns.forEach(function (column) {
                  if (columns.includes(column.id)) {
                    column.show();
                  } else {
                    column.hide();
                  }
                });

                if (!(client.rowManager.rowCount > 0)) {
                  _context4.next = 13;
                  break;
                }

                if (!(rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_54__["RowsRange"].all)) {
                  _context4.next = 9;
                  break;
                }

                exportMeta.firstVisibleDataIndex = client.rowManager.rows[0].dataIndex;
                _context4.next = 7;
                return client.scrollRowIntoView(client.store.first, {
                  block: 'start'
                });

              case 7:
                _context4.next = 13;
                break;

              case 9:
                firstVisibleDataIndex = exportMeta.firstVisibleDataIndex = client.rowManager.rows.find(function (row) {
                  return row.bottom > client.scrollable.y;
                }).dataIndex;
                _context4.next = 12;
                return client.scrollRowIntoView(client.store.getAt(firstVisibleDataIndex), {
                  block: 'start'
                });

              case 12:
                config.alignRows = true;

              case 13:
                // clone whole grid element to the detached container
                this.cloneElement(client.element);
                element = me.element;
                client.eachSubGrid(function (subGrid) {
                  var _subGrid$splitterElem;

                  var placeHolder = me.createPlaceholder(element.querySelector("[id=\"".concat(subGrid.id, "\"]")), false);
                  var width;

                  if (keepRegionSizes === null || keepRegionSizes === void 0 ? void 0 : keepRegionSizes[subGrid.region]) {
                    width = subGrid.element.offsetWidth;
                  } else {
                    width = subGrid.columns.visibleColumns.reduce(function (result, column) {
                      if (typeof column.width === 'number') {
                        result += column.width;
                      } else {
                        result += client.getHeaderElement(column.id).offsetWidth;
                      }

                      return result;
                    }, 0);
                  }

                  exportMeta.totalWidth += width;
                  var splitterWidth = ((_subGrid$splitterElem = subGrid.splitterElement) === null || _subGrid$splitterElem === void 0 ? void 0 : _subGrid$splitterElem.offsetWidth) || 0;
                  exportMeta.totalWidth += splitterWidth;
                  exportMeta.subGrids[subGrid.region] = {
                    id: subGrid.id,
                    headerId: subGrid.header && subGrid.header.id || null,
                    footerId: subGrid.footer && subGrid.footer.id || null,
                    rows: [],
                    splitterWidth: splitterWidth,
                    placeHolder: placeHolder,
                    width: width
                  };
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function prepareComponent(_x4) {
        return _prepareComponent.apply(this, arguments);
      }

      return prepareComponent;
    }()
  }, {
    key: "prepareExportElement",
    value: function prepareExportElement() {
      var me = this,
          element = me.element,
          exportMeta = me.exportMeta; // Exporters may change subGrid width, e.g. when specific date range is exported

      Object.values(exportMeta.subGrids).forEach(function (_ref4) {
        var width = _ref4.width,
            id = _ref4.id,
            headerId = _ref4.headerId,
            footerId = _ref4.footerId;
        [id, headerId, footerId].forEach(function (id) {
          if (id) {
            var childElement = element.querySelector("[id=\"".concat(id, "\"]")); // SubGrid now always have header & footer, but not always in DOM

            if (childElement) {
              childElement.style.width = "".concat(width, "px");
              childElement.style.flex = '';
            }
          }
        });
      });
      return element.innerHTML;
    }
  }, {
    key: "restoreComponent",
    value: function () {
      var _restoreComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_39___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.mark(function _callee5(config) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function restoreComponent(_x5) {
        return _restoreComponent.apply(this, arguments);
      }

      return restoreComponent;
    }()
  }, {
    key: "scrollRowIntoView",
    value: function () {
      var _scrollRowIntoView = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_39___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.mark(function _callee6(client, index) {
        var _this = this;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return client.scrollRowIntoView(client.store.getAt(index), {
                  block: 'start'
                });

              case 2:
                _context6.next = 4;
                return new Promise(function (resolve) {
                  return _this.requestAnimationFrame(resolve);
                });

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function scrollRowIntoView(_x6, _x7) {
        return _scrollRowIntoView.apply(this, arguments);
      }

      return scrollRowIntoView;
    }()
  }, {
    key: "stylesheets",
    get: function get() {
      var _this2 = this;

      var me = this;

      if (me._stylesheets) {
        return me._stylesheets;
      }

      var translate = me.translateURLsToAbsolute,
          origin = window.origin,
          styleSheetNodes = Array.from(document.querySelectorAll('link[rel="stylesheet"], style')),
          styles = [];
      styleSheetNodes.forEach(function (node) {
        node = node.cloneNode(true); // put absolute URL to node `href` attribute

        if (translate && node.href) {
          var result;

          if (translate === true) {
            result = node.href;
          } // translate is truthy if we are here, which means it is string now
          else {
              if (_this2.keepPathName) {
                result = node.href.replace(origin, translate);
              } else {
                result = new URL(node.getAttribute('href'), translate);
              }
            }

          node.setAttribute('href', result);
        }

        var styleText; // Empty style tag will be copied in IE, so we need to use cssText

        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"].isIE11 && node.styleSheet && /style/i.test(node.tagName)) {
          styleText = "<style type=\"text/css\">".concat(node.styleSheet.cssText, "</style>");
        } else {
          styleText = node.outerHTML;
        }

        if (translate && /style/i.test(node.tagName)) {
          var converter = me.getStyleTagURLConverter(translate);
          styleText = styleText.replace(/url\(['"]?(.+?)['"]?\)/g, converter);
        }

        styles.push(styleText);
      });
      styles.push("<style>\n                body, html {\n                    overflow: auto;\n                }\n\n                body {\n                    position: relative;\n                    margin: 0;\n                }\n            </style>");
      return me._stylesheets = styles;
    },
    set: function set(value) {
      this._stylesheets = value;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * `True` to replace all linked CSS files URLs to absolute before passing HTML to the server.
         * When passing a string the current origin of the CSS files URLS will be replaced by the passed origin.
         *
         * For example: css files pointing to /app.css will be translated from current origin to {translateURLsToAbsolute}/app.css
         * @config {Boolean|String}
         * @default
         */
        translateURLsToAbsolute: true,

        /**
         * When true links are converted to absolute by combining current window location (with replaced origin) with
         * resource link.
         * When false links are converted by combining new origin with resource link (for angular)
         * @config {Boolean}
         * @default
         */
        keepPathName: true
      };
    }
  }]);

  return Exporter;
}(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_56__["default"])(Object(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_55__["default"])(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_51__["default"])(_Core_Base_js__WEBPACK_IMPORTED_MODULE_50__["default"])))); // HACK: terser/obfuscator doesn't yet support async generators, when processing code it converts async generator to regular async
// function.

/**
 * Pages generator. Value should be string with exported HTML
 * @param {Object} config
 * @returns {AsyncIterableIterator<{value: String, done: Boolean}>}
 * @private
 */




Exporter.prototype.pagesExtractor = /*#__PURE__*/function () {
  var _pagesExtractor = _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_47___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.mark(function _callee7() {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_37___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return '';

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  function pagesExtractor() {
    return _pagesExtractor.apply(this, arguments);
  }

  return pagesExtractor;
}();

Exporter._$name = 'Exporter';

/***/ }),

/***/ "./lib/Grid/feature/export/exporter/MultiPageExporter.js":
/*!***************************************************************!*\
  !*** ./lib/Grid/feature/export/exporter/MultiPageExporter.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageExporter; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/awaitAsyncGenerator */ "./node_modules/@babel/runtime/helpers/awaitAsyncGenerator.js");
/* harmony import */ var _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/wrapAsyncGenerator */ "./node_modules/@babel/runtime/helpers/wrapAsyncGenerator.js");
/* harmony import */ var _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _Exporter_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./Exporter.js */ "./lib/Grid/feature/export/exporter/Exporter.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../Utils.js */ "./lib/Grid/feature/export/Utils.js");




























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var MultiPageExporter = /*#__PURE__*/function (_Exporter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22___default()(MultiPageExporter, _Exporter);

  var _super = _createSuper(MultiPageExporter);

  function MultiPageExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default()(this, MultiPageExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20___default()(MultiPageExporter, [{
    key: "stateNextPage",
    //region State management
    value: function () {
      var _stateNextPage = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee(_ref) {
        var client, exportMeta;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client = _ref.client;
                exportMeta = this.exportMeta;
                ++exportMeta.currentPage;
                ++exportMeta.verticalPosition;
                delete exportMeta.lastExportedRowBottom; // If current vertical position is greater than max vertical pages, switch to next column

                if (!(exportMeta.verticalPosition >= exportMeta.verticalPages)) {
                  _context.next = 10;
                  break;
                }

                exportMeta.verticalPosition = exportMeta.currentPageTopMargin = 0;
                ++exportMeta.horizontalPosition;
                _context.next = 10;
                return this.scrollRowIntoView(client, exportMeta.firstVisibleDataIndex, {
                  block: 'start'
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function stateNextPage(_x2) {
        return _stateNextPage.apply(this, arguments);
      }

      return stateNextPage;
    }() //endregion
    //region Preparation

  }, {
    key: "prepareComponent",
    value: function () {
      var _prepareComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee2(config) {
        var me, exportMeta, client, headerTpl, footerTpl, alignRows, rowsRange, paperFormat, isPortrait, paperWidth, paperHeight, pageWidth, pageHeight, horizontalPages, totalHeight, contentHeight, verticalPages, totalRows, lastRowBottom, rowHeight, rowsOnFirstPage, rowsPerPage, remainingRows;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(MultiPageExporter.prototype), "prepareComponent", this).call(this, config);

              case 2:
                me = this, exportMeta = me.exportMeta, client = config.client, headerTpl = config.headerTpl, footerTpl = config.footerTpl, alignRows = config.alignRows, rowsRange = config.rowsRange, paperFormat = _Utils_js__WEBPACK_IMPORTED_MODULE_28__["PaperFormat"][config.paperFormat], isPortrait = config.orientation === _Utils_js__WEBPACK_IMPORTED_MODULE_28__["Orientation"].portrait, paperWidth = isPortrait ? paperFormat.width : paperFormat.height, paperHeight = isPortrait ? paperFormat.height : paperFormat.width, pageWidth = me.inchToPx(paperWidth), pageHeight = me.inchToPx(paperHeight), horizontalPages = Math.ceil(exportMeta.totalWidth / pageWidth); // To estimate amount of pages correctly we need to know height of the header/footer on every page

                totalHeight = exportMeta.totalHeight + client.height - client.bodyHeight + client.scrollable.scrollHeight, contentHeight = pageHeight;

                if (headerTpl) {
                  contentHeight -= me.measureElement(headerTpl({
                    totalWidth: exportMeta.totalWidth,
                    totalPages: -1,
                    currentPage: -1
                  }));
                }

                if (footerTpl) {
                  contentHeight -= me.measureElement(footerTpl({
                    totalWidth: exportMeta.totalWidth,
                    totalPages: -1,
                    currentPage: -1
                  }));
                }

                totalRows = client.store.count;

                if (rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_28__["RowsRange"].visible) {
                  totalRows = me.getVisibleRowsCount(client);
                  lastRowBottom = client.rowManager.rows[totalRows - 1].bottom;
                  totalHeight = totalHeight - client.scrollable.scrollHeight + lastRowBottom;
                } // alignRows config specifies if rows should be always fully visible. E.g. if row doesn't fit on the page, it goes
                // to the top of the next page


                if (alignRows && rowsRange !== _Utils_js__WEBPACK_IMPORTED_MODULE_28__["RowsRange"].visible) {
                  // we need to estimate amount of vertical pages for case when we only put row on the page if it fits
                  // first we need to know how much rows would fit one page, keeping in mind first page also contains header
                  // This estimation is loose, because row height might differ much between pages
                  rowHeight = client.rowManager.rowOffsetHeight, rowsOnFirstPage = Math.floor((contentHeight - client.headerHeight) / rowHeight), rowsPerPage = Math.floor(contentHeight / rowHeight), remainingRows = totalRows - rowsOnFirstPage;
                  verticalPages = 1 + Math.ceil(remainingRows / rowsPerPage);
                } else {
                  verticalPages = Math.ceil(totalHeight / contentHeight);
                }

                Object.assign(exportMeta, {
                  paperWidth: paperWidth,
                  paperHeight: paperHeight,
                  pageWidth: pageWidth,
                  pageHeight: pageHeight,
                  horizontalPages: horizontalPages,
                  verticalPages: verticalPages,
                  totalHeight: totalHeight,
                  contentHeight: contentHeight,
                  totalRows: totalRows,
                  totalPages: horizontalPages * verticalPages,
                  currentPage: 0,
                  verticalPosition: 0,
                  horizontalPosition: 0,
                  currentPageTopMargin: 0
                });
                this.adjustRowBuffer(client);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function prepareComponent(_x3) {
        return _prepareComponent.apply(this, arguments);
      }

      return prepareComponent;
    }()
  }, {
    key: "restoreComponent",
    value: function () {
      var _restoreComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee3(config) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(MultiPageExporter.prototype), "restoreComponent", this).call(this, config);

              case 2:
                this.restoreRowBuffer(config.client);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function restoreComponent(_x4) {
        return _restoreComponent.apply(this, arguments);
      }

      return restoreComponent;
    }() //endregion

  }, {
    key: "buildPage",
    value: function () {
      var _buildPage = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee4(config) {
        var me, exportMeta, client, headerTpl, footerTpl, alignRows, totalWidth, totalPages, currentPage, subGrids, currentPageTopMargin, verticalPosition, totalRows, rowManager, rows, headerHeight, footerHeight, index, remainingHeight, header, footer, firstRowIndex, overflowingHeight, lastDataIndex, offset, row, lastRow, detacher, html;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                me = this, exportMeta = me.exportMeta, client = config.client, headerTpl = config.headerTpl, footerTpl = config.footerTpl, alignRows = config.alignRows, totalWidth = exportMeta.totalWidth, totalPages = exportMeta.totalPages, currentPage = exportMeta.currentPage, subGrids = exportMeta.subGrids, currentPageTopMargin = exportMeta.currentPageTopMargin, verticalPosition = exportMeta.verticalPosition, totalRows = exportMeta.totalRows, rowManager = client.rowManager, rows = rowManager.rows; // Rows are stored in shared state object, need to clean it before exporting next page

                Object.values(subGrids).forEach(function (subGrid) {
                  return subGrid.rows = [];
                }); // With variable row height total height might change after scroll, update it
                // to show content completely on the last page

                if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_28__["RowsRange"].all) {
                  exportMeta.totalHeight = client.height - client.bodyHeight + client.scrollable.scrollHeight - me.getVirtualScrollerHeight(client);
                }

                headerHeight = 0, footerHeight = 0, index = config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_28__["RowsRange"].visible ? rows.findIndex(function (r) {
                  return r.bottom > client.scrollable.y;
                }) : rows.findIndex(function (r) {
                  return r.bottom + currentPageTopMargin + client.headerHeight > 0;
                });
                firstRowIndex = index, overflowingHeight = verticalPosition === 0 ? 0 : rows[index].top + currentPageTopMargin + client.headerHeight; // Measure header and footer height

                if (headerTpl) {
                  header = me.prepareHTML(headerTpl({
                    totalWidth: totalWidth,
                    totalPages: totalPages,
                    currentPage: currentPage
                  }));
                  headerHeight = me.measureElement(header);
                }

                if (footerTpl) {
                  footer = me.prepareHTML(footerTpl({
                    totalWidth: totalWidth,
                    totalPages: totalPages,
                    currentPage: currentPage
                  }));
                  footerHeight = me.measureElement(footer);
                } // Calculate remaining height to fill with rows
                // remainingHeight is height of the page content region to fill. When next row is exported, this heights gets
                // reduced. Since top rows may be partially visible, it would lead to increasing error and eventually to incorrect
                // exported rows for the page


                remainingHeight = exportMeta.pageHeight - headerHeight - footerHeight - overflowingHeight; // first exported page container header

                if (verticalPosition === 0) {
                  remainingHeight -= client.headerHeight;
                } // data index of the last collected row


                offset = 0;

                while (remainingHeight > 0) {
                  row = rows[index];

                  if (alignRows && remainingHeight < row.offsetHeight) {
                    offset = -remainingHeight;
                    remainingHeight = 0; // If we skip a row save its bottom to meta data in order to align canvases height
                    // properly

                    me.exportMeta.lastExportedRowBottom = rows[index - 1].bottom;
                  } else {
                    me.collectRow(row);
                    remainingHeight -= row.offsetHeight;
                    lastDataIndex = row.dataIndex; // Last row is processed, still need to fill the view

                    if (++index === rows.length && remainingHeight > 0) {
                      remainingHeight = 0;
                    } else if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_28__["RowsRange"].visible && index - firstRowIndex === totalRows) {
                      remainingHeight = 0;
                    }
                  }
                }

                lastRow = rows[index - 1];

                if (lastRow) {
                  // Calculate exact grid height according to the the last exported row
                  exportMeta.exactGridHeight = lastRow.bottom + client.footerContainer.offsetHeight + client.headerContainer.offsetHeight;
                }

                _context4.next = 15;
                return me.onRowsCollected(rows.slice(firstRowIndex, index), config);

              case 15:
                if (!(config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_28__["RowsRange"].visible)) {
                  _context4.next = 19;
                  break;
                }

                exportMeta.exactGridHeight -= exportMeta.scrollableTopMargin = client.scrollable.y;
                _context4.next = 23;
                break;

              case 19:
                // With variable row height row manager might relayout rows to fix position, moving them up or down.
                detacher = rowManager.on('offsetrows', function (_ref2) {
                  var value = _ref2.offset;
                  return offset += value;
                });
                _context4.next = 22;
                return me.scrollRowIntoView(client, lastDataIndex + 1);

              case 22:
                detacher();

              case 23:
                html = me.buildPageHtml();
                return _context4.abrupt("return", {
                  html: html,
                  header: header,
                  footer: footer,
                  offset: offset
                });

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function buildPage(_x5) {
        return _buildPage.apply(this, arguments);
      }

      return buildPage;
    }()
  }, {
    key: "onRowsCollected",
    value: function () {
      var _onRowsCollected = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee5() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function onRowsCollected() {
        return _onRowsCollected.apply(this, arguments);
      }

      return onRowsCollected;
    }()
  }, {
    key: "collectRow",
    value: function collectRow(row) {
      var subGrids = this.exportMeta.subGrids;
      Object.entries(row.elements).forEach(function (_ref3) {
        var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        subGrids[key].rows.push(value.outerHTML);
      });
    }
  }, {
    key: "buildPageHtml",
    value: function buildPageHtml() {
      var me = this,
          subGrids = me.exportMeta.subGrids; // Now when rows are collected, we need to add them to exported grid

      var html = me.prepareExportElement();
      Object.values(subGrids).forEach(function (_ref5) {
        var placeHolder = _ref5.placeHolder,
            rows = _ref5.rows;
        var placeHolderText = placeHolder.outerHTML;
        html = html.replace(placeHolderText, rows.join(''));
      });
      return html;
    }
  }, {
    key: "prepareExportElement",
    value: function prepareExportElement() {
      var me = this,
          element = me.element,
          exportMeta = me.exportMeta;

      if (exportMeta.scrollableTopMargin) {
        element.querySelector('.b-grid-vertical-scroller').style.marginTop = "-".concat(exportMeta.scrollableTopMargin, "px");
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(MultiPageExporter.prototype), "prepareExportElement", this).call(this);
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'MultiPageExporter';
    }
  }, {
    key: "type",
    get: function get() {
      return 'multipage';
    }
  }, {
    key: "title",
    get: function get() {
      // In case locale is missing exporter is still distinguishable
      return this.L('L{multipage}');
    }
  }, {
    key: "exportingPageText",
    get: function get() {
      return 'L{exportingPage}';
    }
  }]);

  return MultiPageExporter;
}(_Exporter_js__WEBPACK_IMPORTED_MODULE_27__["default"]); // HACK: terser/obfuscator doesn't yet support async generators, when processing code it converts async generator to regular async
// function.




MultiPageExporter.prototype.pagesExtractor = /*#__PURE__*/function () {
  var _pagesExtractor = _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_26___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee6(config) {
    var me, exportMeta, stylesheets, totalWidth, totalPages, paperWidth, paperHeight, contentHeight, currentPage, _yield$_awaitAsyncGen, html, header, footer, offset, styles;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            me = this, exportMeta = me.exportMeta, stylesheets = me.stylesheets, totalWidth = exportMeta.totalWidth, totalPages = exportMeta.totalPages, paperWidth = exportMeta.paperWidth, paperHeight = exportMeta.paperHeight, contentHeight = exportMeta.contentHeight;

          case 1:
            if (!((currentPage = exportMeta.currentPage) < totalPages)) {
              _context6.next = 18;
              break;
            }

            me.trigger('exportStep', {
              text: me.L(MultiPageExporter.exportingPageText, {
                currentPage: currentPage,
                totalPages: totalPages
              }),
              progress: Math.round((currentPage + 1) / totalPages * 90)
            });
            _context6.next = 5;
            return _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_25___default()(me.buildPage(config));

          case 5:
            _yield$_awaitAsyncGen = _context6.sent;
            html = _yield$_awaitAsyncGen.html;
            header = _yield$_awaitAsyncGen.header;
            footer = _yield$_awaitAsyncGen.footer;
            offset = _yield$_awaitAsyncGen.offset;
            // TotalHeight might change in case of variable row heights
            // Move exported content in the visible frame
            styles = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_14___default()(stylesheets), ["\n                <style>\n                    #".concat(config.client.id, " {\n                        height: ").concat(exportMeta.exactGridHeight, "px !important;\n                        width: ").concat(totalWidth, "px !important;\n                    }\n                    \n                    .b-export-body .b-export-viewport {\n                        margin-left : ").concat(-paperWidth * exportMeta.horizontalPosition, "in;\n                        margin-top  : ").concat(exportMeta.currentPageTopMargin, "px;\n                    }\n                </style>\n            ")]); // when aligning rows, offset gets accumulated, so we need to take it into account

            exportMeta.currentPageTopMargin -= contentHeight + offset;
            _context6.next = 14;
            return _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_25___default()(me.stateNextPage(config));

          case 14:
            _context6.next = 16;
            return {
              html: me.pageTpl({
                html: html,
                header: header,
                footer: footer,
                styles: styles,
                paperWidth: paperWidth,
                paperHeight: paperHeight
              })
            };

          case 16:
            _context6.next = 1;
            break;

          case 18:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  function pagesExtractor(_x) {
    return _pagesExtractor.apply(this, arguments);
  }

  return pagesExtractor;
}();

MultiPageExporter._$name = 'MultiPageExporter';

/***/ }),

/***/ "./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js":
/*!***********************************************************************!*\
  !*** ./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageVerticalExporter; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! @babel/runtime/helpers/awaitAsyncGenerator */ "./node_modules/@babel/runtime/helpers/awaitAsyncGenerator.js");
/* harmony import */ var _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! @babel/runtime/helpers/wrapAsyncGenerator */ "./node_modules/@babel/runtime/helpers/wrapAsyncGenerator.js");
/* harmony import */ var _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _Exporter_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./Exporter.js */ "./lib/Grid/feature/export/exporter/Exporter.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../Utils.js */ "./lib/Grid/feature/export/Utils.js");
















































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_43___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var MultiPageVerticalExporter = /*#__PURE__*/function (_Exporter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_42___default()(MultiPageVerticalExporter, _Exporter);

  var _super = _createSuper(MultiPageVerticalExporter);

  function MultiPageVerticalExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_39___default()(this, MultiPageVerticalExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_40___default()(MultiPageVerticalExporter, [{
    key: "stateNextPage",
    //region State management
    value: function () {
      var _stateNextPage = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_38___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.mark(function _callee(_ref) {
        var client, exportMeta, totalRows, processedRows, totalPages;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client = _ref.client;
                exportMeta = this.exportMeta, totalRows = exportMeta.totalRows, processedRows = exportMeta.processedRows, totalPages = exportMeta.totalPages;
                ++exportMeta.currentPage;
                ++exportMeta.verticalPosition; // With variable row heights it is possible that initial pages estimation is wrong. If we're out but there are
                // more rows to process - continue exporting

                if (exportMeta.currentPage === totalPages && processedRows.size !== totalRows) {
                  ++exportMeta.totalPages;
                  ++exportMeta.verticalPages;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function stateNextPage(_x2) {
        return _stateNextPage.apply(this, arguments);
      }

      return stateNextPage;
    }() //endregion

  }, {
    key: "estimateTotalPages",
    value: function estimateTotalPages(config) {
      var me = this,
          exportMeta = me.exportMeta,
          client = config.client,
          headerTpl = config.headerTpl,
          footerTpl = config.footerTpl,
          alignRows = config.alignRows,
          rowsRange = config.rowsRange,
          repeatHeader = config.repeatHeader,
          pageWidth = exportMeta.pageWidth,
          pageHeight = exportMeta.pageHeight,
          totalWidth = exportMeta.totalWidth,
          scale = me.getScaleValue(pageWidth, totalWidth); // To estimate amount of pages correctly we need to know height of the header/footer on every page

      var totalHeight = 0 - me.getVirtualScrollerHeight(client) + client.height - client.bodyHeight + client.scrollable.scrollHeight,
          // We will be scaling content horizontally, need to adjust content height accordingly
      contentHeight = pageHeight / scale,
          totalRows = client.store.count,
          initialScroll = 0,
          verticalPages;

      if (headerTpl) {
        contentHeight -= me.measureElement(headerTpl({
          totalWidth: totalWidth,
          totalPages: -1,
          currentPage: -1
        }));
      }

      if (footerTpl) {
        contentHeight -= me.measureElement(footerTpl({
          totalWidth: totalWidth,
          totalPages: -1,
          currentPage: -1
        }));
      } // If we are repeating header on every page we have smaller contentHeight


      if (repeatHeader) {
        contentHeight -= client.headerHeight;
        totalHeight -= client.headerHeight;
      }

      if (rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_48__["RowsRange"].visible) {
        var rowManager = client.rowManager,
            firstRow = rowManager.firstVisibleRow,
            lastRow = rowManager.lastVisibleRow;
        initialScroll = firstRow.top;
        totalRows = me.getVisibleRowsCount(client);
        totalHeight = totalHeight - client.scrollable.scrollHeight + lastRow.bottom - firstRow.top;
      } // alignRows config specifies if rows should be always fully visible. E.g. if row doesn't fit on the page, it goes
      // to the top of the next page


      if (alignRows && !repeatHeader && rowsRange !== _Utils_js__WEBPACK_IMPORTED_MODULE_48__["RowsRange"].visible) {
        // we need to estimate amount of vertical pages for case when we only put row on the page if it fits
        // first we need to know how much rows would fit one page, keeping in mind first page also contains header
        // This estimation is loose, because row height might differ much between pages
        var rowHeight = client.rowManager.rowOffsetHeight,
            rowsOnFirstPage = Math.floor((contentHeight - client.headerHeight) / rowHeight),
            rowsPerPage = Math.floor(contentHeight / rowHeight),
            remainingRows = totalRows - rowsOnFirstPage;
        verticalPages = 1 + Math.ceil(remainingRows / rowsPerPage);
      } else {
        verticalPages = Math.ceil(totalHeight / contentHeight);
      }

      Object.assign(exportMeta, {
        scale: scale,
        contentHeight: contentHeight,
        totalRows: totalRows,
        totalHeight: totalHeight,
        verticalPages: verticalPages,
        initialScroll: initialScroll,
        horizontalPages: 1,
        totalPages: verticalPages
      });
    }
  }, {
    key: "prepareComponent",
    value: function () {
      var _prepareComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_38___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.mark(function _callee2(config) {
        var me, exportMeta, client, paperFormat, isPortrait, paperWidth, paperHeight, pageWidth, pageHeight, horizontalPages;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_41___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default()(MultiPageVerticalExporter.prototype), "prepareComponent", this).call(this, config);

              case 2:
                me = this, exportMeta = me.exportMeta, client = config.client, paperFormat = _Utils_js__WEBPACK_IMPORTED_MODULE_48__["PaperFormat"][config.paperFormat], isPortrait = config.orientation === _Utils_js__WEBPACK_IMPORTED_MODULE_48__["Orientation"].portrait, paperWidth = isPortrait ? paperFormat.width : paperFormat.height, paperHeight = isPortrait ? paperFormat.height : paperFormat.width, pageWidth = me.inchToPx(paperWidth), pageHeight = me.inchToPx(paperHeight), horizontalPages = 1;
                Object.assign(exportMeta, {
                  paperWidth: paperWidth,
                  paperHeight: paperHeight,
                  pageWidth: pageWidth,
                  pageHeight: pageHeight,
                  horizontalPages: horizontalPages,
                  currentPage: 0,
                  verticalPosition: 0,
                  horizontalPosition: 0,
                  currentPageTopMargin: 0,
                  processedRows: new Set()
                });
                me.estimateTotalPages(config);
                me.adjustRowBuffer(client);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function prepareComponent(_x3) {
        return _prepareComponent.apply(this, arguments);
      }

      return prepareComponent;
    }()
  }, {
    key: "restoreComponent",
    value: function () {
      var _restoreComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_38___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.mark(function _callee3(config) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_41___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_44___default()(MultiPageVerticalExporter.prototype), "restoreComponent", this).call(this, config);

              case 2:
                this.restoreRowBuffer(config.client);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function restoreComponent(_x4) {
        return _restoreComponent.apply(this, arguments);
      }

      return restoreComponent;
    }()
  }, {
    key: "buildPage",
    value: function () {
      var _buildPage = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_38___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.mark(function _callee4(config) {
        var me, exportMeta, client, headerTpl, footerTpl, alignRows, repeatHeader, totalWidth, totalPages, currentPage, subGrids, currentPageTopMargin, verticalPosition, totalRows, contentHeight, clientHeaderHeight, rowManager, rows, index, remainingHeight, header, footer, firstRowIndex, overflowingHeight, lastDataIndex, offset, row, lastRow, detacher, html;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                me = this, exportMeta = me.exportMeta, client = config.client, headerTpl = config.headerTpl, footerTpl = config.footerTpl, alignRows = config.alignRows, repeatHeader = config.repeatHeader, totalWidth = exportMeta.totalWidth, totalPages = exportMeta.totalPages, currentPage = exportMeta.currentPage, subGrids = exportMeta.subGrids, currentPageTopMargin = exportMeta.currentPageTopMargin, verticalPosition = exportMeta.verticalPosition, totalRows = exportMeta.totalRows, contentHeight = exportMeta.contentHeight, clientHeaderHeight = repeatHeader ? 0 : client.headerHeight, rowManager = client.rowManager, rows = rowManager.rows; // Rows are stored in shared state object, need to clean it before exporting next page

                Object.values(subGrids).forEach(function (subGrid) {
                  return subGrid.rows = [];
                }); // With variable row height total height might change after scroll, update it
                // to show content completely on the last page

                if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_48__["RowsRange"].all) {
                  exportMeta.totalHeight = client.height - client.bodyHeight + client.scrollable.scrollHeight - me.getVirtualScrollerHeight(client);
                }

                index = config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_48__["RowsRange"].visible ? rows.findIndex(function (r) {
                  return r.bottom > client.scrollable.y;
                }) : rows.findIndex(function (r) {
                  return r.bottom + currentPageTopMargin + clientHeaderHeight > 0;
                });
                firstRowIndex = index, overflowingHeight = verticalPosition === 0 ? 0 : rows[index].top + currentPageTopMargin + clientHeaderHeight; // Measure header and footer height

                if (headerTpl) {
                  header = me.prepareHTML(headerTpl({
                    totalWidth: totalWidth,
                    totalPages: totalPages,
                    currentPage: currentPage
                  }));
                }

                if (footerTpl) {
                  footer = me.prepareHTML(footerTpl({
                    totalWidth: totalWidth,
                    totalPages: totalPages,
                    currentPage: currentPage
                  }));
                } // Calculate remaining height to fill with rows
                // remainingHeight is height of the page content region to fill. When next row is exported, this heights gets
                // reduced. Since top rows may be partially visible, it would lead to increasing error and eventually to incorrect
                // exported rows for the page


                remainingHeight = contentHeight - overflowingHeight; // first exported page container header

                if (verticalPosition === 0) {
                  remainingHeight -= clientHeaderHeight;
                } // data index of the last collected row


                offset = 0;

                while (remainingHeight > 0) {
                  row = rows[index];

                  if (alignRows && remainingHeight < row.offsetHeight) {
                    offset = -remainingHeight;
                    remainingHeight = 0;
                  } else {
                    me.collectRow(row);
                    remainingHeight -= row.offsetHeight; // only mark row as processed if it fitted without overflow

                    if (remainingHeight > 0) {
                      // We cannot use simple counter here because some rows appear on 2 pages. Need to track unique identifier
                      exportMeta.processedRows.add(row.dataIndex);
                    }

                    lastDataIndex = row.dataIndex; // Last row is processed, still need to fill the view

                    if (++index === rows.length && remainingHeight > 0) {
                      remainingHeight = 0;
                    } else if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_48__["RowsRange"].visible && index - firstRowIndex === totalRows) {
                      remainingHeight = 0;
                    }
                  }
                }

                lastRow = rows[index - 1];

                if (lastRow) {
                  // Calculate exact grid height according to the the last exported row
                  exportMeta.exactGridHeight = lastRow.bottom + client.footerContainer.offsetHeight + client.headerContainer.offsetHeight;
                }

                _context4.next = 15;
                return me.onRowsCollected(rows.slice(firstRowIndex, index), config);

              case 15:
                if (!(config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_48__["RowsRange"].visible)) {
                  _context4.next = 19;
                  break;
                }

                exportMeta.scrollableTopMargin = client.scrollable.y;
                _context4.next = 23;
                break;

              case 19:
                // With variable row height row manager migh relayout rows to fix position, moving them up or down.
                detacher = rowManager.on('offsetrows', function (_ref2) {
                  var value = _ref2.offset;
                  return offset += value;
                });
                _context4.next = 22;
                return me.scrollRowIntoView(client, lastDataIndex + 1);

              case 22:
                detacher();

              case 23:
                html = me.buildPageHtml();
                return _context4.abrupt("return", {
                  html: html,
                  header: header,
                  footer: footer,
                  offset: offset
                });

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function buildPage(_x5) {
        return _buildPage.apply(this, arguments);
      }

      return buildPage;
    }()
  }, {
    key: "onRowsCollected",
    value: function () {
      var _onRowsCollected = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_38___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.mark(function _callee5() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function onRowsCollected() {
        return _onRowsCollected.apply(this, arguments);
      }

      return onRowsCollected;
    }()
  }, {
    key: "collectRow",
    value: function collectRow(row) {
      var subGrids = this.exportMeta.subGrids;
      Object.entries(row.elements).forEach(function (_ref3) {
        var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_35___default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        subGrids[key].rows.push(value.outerHTML);
      });
    }
  }, {
    key: "buildPageHtml",
    value: function buildPageHtml() {
      var me = this,
          subGrids = me.exportMeta.subGrids; // Now when rows are collected, we need to add them to exported grid

      var html = me.prepareExportElement();
      Object.values(subGrids).forEach(function (_ref5) {
        var placeHolder = _ref5.placeHolder,
            rows = _ref5.rows;
        var placeHolderText = placeHolder.outerHTML;
        html = html.replace(placeHolderText, rows.join(''));
      });
      return html;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'MultiPageVerticalExporter';
    }
  }, {
    key: "type",
    get: function get() {
      return 'multipagevertical';
    }
  }, {
    key: "title",
    get: function get() {
      // In case locale is missing exporter is still distinguishable
      return this.L('L{multipagevertical}');
    }
  }, {
    key: "exportingPageText",
    get: function get() {
      return 'L{exportingPage}';
    }
  }]);

  return MultiPageVerticalExporter;
}(_Exporter_js__WEBPACK_IMPORTED_MODULE_47__["default"]); // HACK: terser/obfuscator doesn't yet support async generators, when processing code it converts async generator to regular async
// function.




MultiPageVerticalExporter.prototype.pagesExtractor = /*#__PURE__*/function () {
  var _pagesExtractor = _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_46___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.mark(function _callee6(config) {
    var me, exportMeta, stylesheets, totalWidth, paperWidth, paperHeight, contentHeight, scale, initialScroll, totalPages, currentPage, _yield$_awaitAsyncGen, html, header, footer, offset, styles, gridHeight, _gridHeight;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_36___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            me = this, exportMeta = me.exportMeta, stylesheets = me.stylesheets, totalWidth = exportMeta.totalWidth, paperWidth = exportMeta.paperWidth, paperHeight = exportMeta.paperHeight, contentHeight = exportMeta.contentHeight, scale = exportMeta.scale, initialScroll = exportMeta.initialScroll;
            totalPages = exportMeta.totalPages;

          case 2:
            if (!((currentPage = exportMeta.currentPage) < totalPages)) {
              _context6.next = 21;
              break;
            }

            me.trigger('exportStep', {
              text: me.L(MultiPageVerticalExporter.exportingPageText, {
                currentPage: currentPage,
                totalPages: totalPages
              }),
              progress: Math.round((currentPage + 1) / totalPages * 90)
            });
            _context6.next = 6;
            return _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_45___default()(me.buildPage(config));

          case 6:
            _yield$_awaitAsyncGen = _context6.sent;
            html = _yield$_awaitAsyncGen.html;
            header = _yield$_awaitAsyncGen.header;
            footer = _yield$_awaitAsyncGen.footer;
            offset = _yield$_awaitAsyncGen.offset;
            // TotalHeight might change in case of variable row heights
            // Move exported content in the visible frame
            styles = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_34___default()(stylesheets), ["\n                <style>\n                    #".concat(config.client.id, " {\n                        width: ").concat(totalWidth, "px !important;\n                    }\n                    \n                    .b-export .b-export-content {\n                        transform: scale(").concat(scale, ");\n                        transform-origin: top left;\n                        height: auto;\n                    }\n                </style>\n            ")]);

            if (config.repeatHeader) {
              gridHeight = exportMeta.exactGridHeight ? "".concat(exportMeta.exactGridHeight + exportMeta.currentPageTopMargin, "px") : '100%';
              styles.push("\n                <style>\n                    #".concat(config.client.id, " {\n                        height: ").concat(gridHeight, " !important;\n                    }\n                    \n                    .b-export .b-export-content {\n                        height: ").concat(100 / scale, "%;\n                    }\n                    \n                    .b-export-body {\n                        height: 100%;\n                        display: flex;\n                    }\n                \n                    .b-export-viewport {\n                        height: 100%;\n                    }\n                    \n                    .b-grid-vertical-scroller {\n                        margin-top: ").concat(exportMeta.currentPageTopMargin - initialScroll, "px;\n                    }\n                </style>\n                "));
            } else {
              _gridHeight = exportMeta.exactGridHeight || contentHeight - exportMeta.currentPageTopMargin;
              styles.push("\n                <style>\n                    #".concat(config.client.id, " {\n                        height: ").concat(_gridHeight, "px !important;\n                    }\n                    \n                    .b-export-body {\n                        overflow: hidden;\n                    }\n                    \n                    .b-export .b-export-content {\n                        height: ").concat(100 / scale, "%;\n                    }\n                    \n                    .b-export-body .b-export-viewport {\n                        margin-top: ").concat(exportMeta.currentPageTopMargin, "px;\n                    }\n                    \n                    .b-grid-vertical-scroller {\n                        margin-top: -").concat(initialScroll, "px;\n                    }\n                </style>\n                "));
            } // when aligning rows, offset gets accumulated, so we need to take it into account


            exportMeta.currentPageTopMargin -= contentHeight + offset;
            _context6.next = 16;
            return _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_45___default()(me.stateNextPage(config));

          case 16:
            totalPages = exportMeta.totalPages;
            _context6.next = 19;
            return {
              html: me.pageTpl({
                html: html,
                header: header,
                footer: footer,
                styles: styles,
                paperWidth: paperWidth,
                paperHeight: paperHeight
              })
            };

          case 19:
            _context6.next = 2;
            break;

          case 21:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  function pagesExtractor(_x) {
    return _pagesExtractor.apply(this, arguments);
  }

  return pagesExtractor;
}();

MultiPageVerticalExporter._$name = 'MultiPageVerticalExporter';

/***/ }),

/***/ "./lib/Grid/feature/export/exporter/SinglePageExporter.js":
/*!****************************************************************!*\
  !*** ./lib/Grid/feature/export/exporter/SinglePageExporter.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SinglePageExporter; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/awaitAsyncGenerator */ "./node_modules/@babel/runtime/helpers/awaitAsyncGenerator.js");
/* harmony import */ var _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/wrapAsyncGenerator */ "./node_modules/@babel/runtime/helpers/wrapAsyncGenerator.js");
/* harmony import */ var _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Exporter_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./Exporter.js */ "./lib/Grid/feature/export/exporter/Exporter.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../Utils.js */ "./lib/Grid/feature/export/Utils.js");





























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var SinglePageExporter = /*#__PURE__*/function (_Exporter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default()(SinglePageExporter, _Exporter);

  var _super = _createSuper(SinglePageExporter);

  function SinglePageExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_20___default()(this, SinglePageExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_21___default()(SinglePageExporter, [{
    key: "prepareComponent",
    value: function () {
      var _prepareComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_19___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_17___default.a.mark(function _callee(config) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_17___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(SinglePageExporter.prototype), "prepareComponent", this).call(this, config);

              case 2:
                Object.assign(this.exportMeta, {
                  verticalPages: 1,
                  horizontalPages: 1,
                  totalPages: 1,
                  currentPage: 0,
                  verticalPosition: 0,
                  horizontalPosition: 0
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepareComponent(_x2) {
        return _prepareComponent.apply(this, arguments);
      }

      return prepareComponent;
    }()
  }, {
    key: "onRowsCollected",
    value: function () {
      var _onRowsCollected = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_19___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_17___default.a.mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_17___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onRowsCollected() {
        return _onRowsCollected.apply(this, arguments);
      }

      return onRowsCollected;
    }()
  }, {
    key: "positionRows",
    value: function positionRows(rows) {
      var currentTop = 0; // In case of variable row height row vertical position is not guaranteed to increase
      // monotonously. Position row manually instead

      return rows.map(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_16___default()(_ref, 2),
            html = _ref2[0],
            height = _ref2[1];

        var result = html.replace(/translate\(\d+px, \d+px\)/, "translate(0px, ".concat(currentTop, "px)"));
        currentTop += height;
        return result;
      });
    }
  }, {
    key: "collectRow",
    value: function collectRow(row) {
      var subGrids = this.exportMeta.subGrids;
      Object.entries(row.elements).forEach(function (_ref3) {
        var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_16___default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        subGrids[key].rows.push([value.outerHTML, row.offsetHeight]);
      });
    }
  }, {
    key: "buildPageHtml",
    value: function buildPageHtml() {
      var me = this,
          subGrids = me.exportMeta.subGrids; // Now when rows are collected, we need to add them to exported grid

      var html = me.prepareExportElement();
      Object.values(subGrids).forEach(function (_ref5) {
        var placeHolder = _ref5.placeHolder,
            rows = _ref5.rows;
        var placeHolderText = placeHolder.outerHTML;
        html = html.replace(placeHolderText, me.positionRows(rows).join(''));
      });
      return html;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'SinglePageExporter';
    }
  }, {
    key: "type",
    get: function get() {
      return 'singlepage';
    }
  }, {
    key: "title",
    get: function get() {
      // In case locale is missing exporter is still distinguishable
      return this.localize('L{singlepage}');
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Set to true to center content horizontally on the page
         * @config {Boolean}
         */
        centerContentHorizontally: false
      };
    }
  }]);

  return SinglePageExporter;
}(_Exporter_js__WEBPACK_IMPORTED_MODULE_29__["default"]); // HACK: terser/obfuscator doesn't yet support async generators, when processing code it converts async generator to regular async
// function.




SinglePageExporter.prototype.pagesExtractor = /*#__PURE__*/function () {
  var _pagesExtractor = _babel_runtime_helpers_wrapAsyncGenerator__WEBPACK_IMPORTED_MODULE_27___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_17___default.a.mark(function _callee3(config) {
    var me, client, rowManager, store, styles, portrait, paperFormat, paperWidth, paperHeight, totalRows, _me$exportMeta, totalHeight, totalWidth, processedRows, lastDataIndex, header, footer, rows, lastRow, lastProcessedRowIndex, firstNewRowIndex, lastNewRowIndex, html, totalClientHeight, height, _height, widthScale, heightScale, scale;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_17___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // When we prepared grid we stretched it horizontally, now we need to gather all rows
            // There are two ways:
            // 1. set component height to scrollable.scrollHeight value to render all rows at once (maybe a bit more complex
            // if rows have variable height)
            // 2. iterate over rows, scrolling new portion into view once in a while
            // #1 sounds simpler, but that might require too much rendering, let's scroll rows instead
            me = this, client = config.client, rowManager = client.rowManager, store = client.store, styles = me.stylesheets, portrait = config.orientation === _Utils_js__WEBPACK_IMPORTED_MODULE_30__["Orientation"].portrait, paperFormat = _Utils_js__WEBPACK_IMPORTED_MODULE_30__["PaperFormat"][config.paperFormat], paperWidth = portrait ? paperFormat.width : paperFormat.height, paperHeight = portrait ? paperFormat.height : paperFormat.width, totalRows = config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_30__["RowsRange"].visible && store.count // visibleRowCount is a projection of how much rows will fit the view, which should be
            // maximum amount of exported rows. and there can be less
            ? Math.min(store.count, rowManager.visibleRowCount) : store.count;
            _me$exportMeta = me.exportMeta, totalHeight = _me$exportMeta.totalHeight, totalWidth = _me$exportMeta.totalWidth, processedRows = 0, lastDataIndex = -1;

            if (!(rowManager.rows.length > 0)) {
              _context3.next = 16;
              break;
            }

            if (config.rowsRange === _Utils_js__WEBPACK_IMPORTED_MODULE_30__["RowsRange"].visible) {
              lastDataIndex = rowManager.rows.find(function (row) {
                return row.bottom > client.scrollable.y;
              }).dataIndex - 1;
            } // Collecting rows


          case 4:
            if (!(processedRows < totalRows)) {
              _context3.next = 16;
              break;
            }

            rows = rowManager.rows, lastRow = rows[rows.length - 1], lastProcessedRowIndex = processedRows;
            rows.forEach(function (row) {
              // When we are scrolling rows will be duplicated even with disabled buffers (e.g. when we are trying to
              // scroll last record into view). So we store last processed row dataIndex (which is always growing
              // sequence) and filter all rows with lower/same dataIndex
              if (row.dataIndex > lastDataIndex && processedRows < totalRows) {
                ++processedRows;
                totalHeight += row.offsetHeight;
                me.collectRow(row);
              }
            }); // Calculate new rows processed in this iteration e.g. to collect events

            firstNewRowIndex = rows.findIndex(function (r) {
              return r.dataIndex === lastDataIndex + 1;
            }), lastNewRowIndex = firstNewRowIndex + (processedRows - lastProcessedRowIndex);
            _context3.next = 10;
            return _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_26___default()(me.onRowsCollected(rows.slice(firstNewRowIndex, lastNewRowIndex), config));

          case 10:
            if (!(processedRows < totalRows)) {
              _context3.next = 14;
              break;
            }

            lastDataIndex = lastRow.dataIndex;
            _context3.next = 14;
            return _babel_runtime_helpers_awaitAsyncGenerator__WEBPACK_IMPORTED_MODULE_26___default()(me.scrollRowIntoView(client, lastDataIndex + 1));

          case 14:
            _context3.next = 4;
            break;

          case 16:
            html = me.buildPageHtml(); // Calculate header height

            totalHeight += client.height - client.bodyHeight;
            totalClientHeight = totalHeight; // Measure header and footer height

            if (config.headerTpl) {
              header = me.prepareHTML(config.headerTpl({
                totalWidth: totalWidth
              }));
              height = me.measureElement(header);
              totalHeight += height;
            }

            if (config.footerTpl) {
              footer = me.prepareHTML(config.footerTpl({
                totalWidth: totalWidth
              }));
              _height = me.measureElement(footer);
              totalHeight += _height;
            }

            widthScale = Math.min(1, me.getScaleValue(me.inchToPx(paperWidth), totalWidth)), heightScale = Math.min(1, me.getScaleValue(me.inchToPx(paperHeight), totalHeight)), scale = Math.min(widthScale, heightScale); // Now add style to stretch grid vertically

            styles.push("<style>\n                #".concat(client.id, " {\n                    height: ").concat(totalClientHeight, "px !important;\n                    width: ").concat(totalWidth, "px !important;\n                }\n                \n                .b-export-content {\n                    ").concat(me.centerContentHorizontally ? 'left: 50%;' : '', "\n                    transform: scale(").concat(scale, ") ").concat(me.centerContentHorizontally ? 'translateX(-50%)' : '', ";\n                    transform-origin: top left;\n                    height: ").concat(scale === 1 ? 'inherit' : 'auto !important', ";\n                }\n            </style>"));

            if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].isIE11) {
              styles.push("<style>\n                .b-export-body {\n                   min-height: ".concat(totalClientHeight, "px !important;\n                }\n         </style>"));
            } // This is a single page exporter so we only yield one page


            _context3.next = 26;
            return {
              html: me.pageTpl({
                html: html,
                header: header,
                footer: footer,
                styles: styles,
                paperWidth: paperWidth,
                paperHeight: paperHeight
              })
            };

          case 26:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  function pagesExtractor(_x) {
    return _pagesExtractor.apply(this, arguments);
  }

  return pagesExtractor;
}();

SinglePageExporter._$name = 'SinglePageExporter';

/***/ }),

/***/ "./lib/Grid/feature/mixin/SummaryFormatter.js":
/*!****************************************************!*\
  !*** ./lib/Grid/feature/mixin/SummaryFormatter.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Grid/feature/mixin/SummaryFormatter
 */

/**
 * Mixin for Summary and GroupSummary that handles formatting sums.
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(SummaryFormatter, _ref);

    var _super = _createSuper(SummaryFormatter);

    function SummaryFormatter() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, SummaryFormatter);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(SummaryFormatter, [{
      key: "generateHtml",

      /**
       * Calculates sums and returns as a html table
       * @param {Grid.column.Column} column Column to calculate sum for
       * @param {Core.data.Model[]} records Records to include in calculation
       * @param {String} cls CSS class to apply to summary table
       * @returns {string}
       */
      value: function generateHtml(column, records, cls) {
        var store = this.store,
            summaries = column.summaries || (column.sum ? [{
          sum: column.sum,
          renderer: column.summaryRenderer
        }] : []);
        var html = "<table class=\"".concat(cls, "\">");
        summaries.forEach(function (config) {
          var type = config.sum,
              sum = null;
          if (type === true) type = 'sum';

          switch (type) {
            case 'sum':
            case 'add':
              sum = store.sum(column.field, records);
              break;

            case 'max':
              sum = store.max(column.field, records);
              break;

            case 'min':
              sum = store.min(column.field, records);
              break;

            case 'average':
            case 'avg':
              sum = store.average(column.field, records);
              break;

            case 'count':
              sum = records.length;
              break;

            case 'countNotEmpty':
              sum = records.reduce(function (sum, record) {
                var value = record[column.field];
                return sum + (value != null ? 1 : 0);
              }, 0);
              break;
          }

          if (typeof type === 'function') {
            sum = records.reduce(type, 'seed' in config ? config.seed : 0);
          }

          if (sum !== null) {
            var valueCls = 'b-grid-summary-value',
                // optional label
            labelHtml = config.label ? "<td class=\"b-grid-summary-label\">".concat(config.label, "</td>") : ''; // value to display, either using renderer or as is

            var valueHtml = config.renderer ? config.renderer({
              config: config,
              sum: sum
            }) : sum,
                summaryHtml;

            if (valueHtml == null) {
              valueHtml = '';
            } // no <td>s in html, wrap it (always the case when not using renderer)


            if (!String(valueHtml).includes('<td>')) {
              summaryHtml = labelHtml // has label, use returned html as value cell
              ? "".concat(labelHtml, "<td class=\"").concat(valueCls, "\">").concat(valueHtml, "</td>") // no label, span entire table
              : "<td colspan=\"2\" class=\"".concat(valueCls, "\">").concat(valueHtml, "</td>");
            } // user is in charge of giving correct formatting
            else {
                summaryHtml = valueHtml;
              }

            html += "<tr>".concat(summaryHtml, "</tr>");
          }
        });
        return html + '</table>';
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'SummaryFormatter';
      }
    }]);

    return SummaryFormatter;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_14__["default"]);
});

/***/ }),

/***/ "./lib/Grid/localization/En.js":
/*!*************************************!*\
  !*** ./lib/Grid/localization/En.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Core_localization_En_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/localization/En.js */ "./lib/Core/localization/En.js");
/* harmony import */ var _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");

var productName = 'scheduler';
 //<umd>



var locale = _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].mergeLocales(_Core_localization_En_js__WEBPACK_IMPORTED_MODULE_2__["default"], {
  //region Features
  ColumnPicker: {
    column: 'Column',
    columnsMenu: 'Columns',
    hideColumn: 'Hide column',
    hideColumnShort: 'Hide'
  },
  Filter: {
    applyFilter: 'Apply filter',
    filter: 'Filter',
    editFilter: 'Edit filter',
    on: 'On',
    before: 'Before',
    after: 'After',
    equals: 'Equals',
    lessThan: 'Less than',
    moreThan: 'More than',
    removeFilter: 'Remove filter'
  },
  FilterBar: {
    enableFilterBar: 'Show filter bar',
    disableFilterBar: 'Hide filter bar'
  },
  Group: {
    group: 'Group',
    groupAscending: 'Group ascending',
    groupDescending: 'Group descending',
    groupAscendingShort: 'Ascending',
    groupDescendingShort: 'Descending',
    stopGrouping: 'Stop grouping',
    stopGroupingShort: 'Stop'
  },
  Search: {
    searchForValue: 'Search for value'
  },
  Sort: {
    sort: 'Sort',
    sortAscending: 'Sort ascending',
    sortDescending: 'Sort descending',
    multiSort: 'Multi sort',
    removeSorter: 'Remove sorter',
    addSortAscending: 'Add ascending sorter',
    addSortDescending: 'Add descending sorter',
    toggleSortAscending: 'Change to ascending',
    toggleSortDescending: 'Change to descending',
    sortAscendingShort: 'Ascending',
    sortDescendingShort: 'Descending',
    removeSorterShort: 'Remove',
    addSortAscendingShort: '+ Ascending',
    addSortDescendingShort: '+ Descending'
  },
  //endregion
  //region Grid
  GridBase: {
    loadFailedMessage: 'Data loading failed!',
    syncFailedMessage: 'Data synchronization failed!',
    unspecifiedFailure: 'Unspecified failure',
    networkFailure: 'Network error',
    parseFailure: 'Failed to parse server response',
    loadMask: 'Loading...',
    syncMask: 'Saving changes, please wait...',
    noRows: 'No records to display',
    moveColumnLeft: 'Move to left section',
    moveColumnRight: 'Move to right section',
    removeRow: 'Delete record',
    removeRows: 'Delete records',
    moveColumnTo: function moveColumnTo(region) {
      return "Move column to ".concat(region);
    }
  },
  CellMenu: {
    removeRow: 'Delete record',
    removeRows: 'Delete records'
  },
  //endregion
  //region Export
  PdfExport: {
    'Waiting for response from server': 'Waiting for response from server...',
    'Export failed': 'Export failed',
    'Server error': 'Server error',
    'Generating pages': 'Generating pages...'
  },
  ExportDialog: {
    width: '40em',
    labelWidth: '12em',
    exportSettings: 'Export settings',
    export: 'Export',
    exporterType: 'Control pagination',
    cancel: 'Cancel',
    fileFormat: 'File format',
    rows: 'Rows',
    alignRows: 'Align rows',
    columns: 'Columns',
    paperFormat: 'Paper format',
    orientation: 'Orientation',
    repeatHeader: 'Repeat header'
  },
  ExportRowsCombo: {
    all: 'All rows',
    visible: 'Visible rows'
  },
  ExportOrientationCombo: {
    portrait: 'Portrait',
    landscape: 'Landscape'
  },
  SinglePageExporter: {
    singlepage: 'Single page'
  },
  MultiPageExporter: {
    multipage: 'Multiple pages',
    exportingPage: function exportingPage(_ref) {
      var currentPage = _ref.currentPage,
          totalPages = _ref.totalPages;
      return "Exporting page ".concat(currentPage, "/").concat(totalPages);
    }
  },
  MultiPageVerticalExporter: {
    multipagevertical: 'Multiple pages (vertical)',
    exportingPage: function exportingPage(_ref2) {
      var currentPage = _ref2.currentPage,
          totalPages = _ref2.totalPages;
      return "Exporting page ".concat(currentPage, "/").concat(totalPages);
    }
  } //endregion

});
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerLocale('En', {
  desc: 'English',
  locale: locale
});

/***/ }),

/***/ "./lib/Grid/row/Row.js":
/*!*****************************!*\
  !*** ./lib/Grid/row/Row.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Row; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");



















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Grid/row/Row
 */

/**
 * Represents a single rendered row in the grid. Consists of one row element for each SubGrid in use. The grid only
 * creates as many rows as needed to fill the current viewport (and a buffer). As the grid scrolls
 * the rows are repositioned and reused, there is not a one to one relation between rows and records.
 *
 * For normal use cases you should not have to use this class directly. Rely on using renderers instead.
 * @extends Core/Base
 */

var Row = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(Row, _Delayable);

  var _super = _createSuper(Row);

  function Row() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default()(this, Row);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default()(Row, [{
    key: "construct",
    //region Init

    /**
     * Constructs a Row setting its index.
     * @param {Object} config A configuration object which must contain the following two properties:
     * @param {Grid.view.Grid} config.grid The owning Grid.
     * @param {Grid.row.RowManager} config.rowManager The owning RowManager.
     * @param {Number} index The index of the row within the RowManager's cache.
     * @function constructor
     * @internal
     */
    value: function construct(config) {
      // Set up defaults and properties
      Object.assign(this, {
        _elements: {},
        _elementsArray: [],
        _cells: {},
        _allCells: [],
        _regions: [],
        lastHeight: 0,
        lastTop: -1,
        _dataIndex: 0,
        _top: 0,
        _height: 0,
        _id: null,
        forceInnerHTML: false,
        isGroupFooter: false
      }, config);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Row.prototype), "construct", this).call(this);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this; // No need to clean elements up if the entire thing is being destroyed

      if (!me.rowManager.isDestroying) {
        me.removeElements();

        if (me.rowManager.idMap[me.id] === me) {
          delete me.rowManager.idMap[me.id];
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Row.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Data getters/setters

    /**
     * Get index in RowManagers rows array
     * @property {Number}
     * @readonly
     */

  }, {
    key: "addElement",
    //endregion
    //region Row elements

    /**
     * Add a row element for specified region.
     * @param {String} region Region to add element for
     * @param {HTMLElement} element Element
     * @private
     */
    value: function addElement(region, element) {
      var me = this;
      var cellElement = element.firstElementChild;
      me._elements[region] = element;

      me._elementsArray.push(element);

      me._regions.push(region);

      _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign(element, {
        index: me.index
      });
      me._cells[region] = [];

      while (cellElement) {
        me._cells[region].push(cellElement);

        me._allCells.push(cellElement);

        _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_19__["default"].set(cellElement, {
          column: cellElement.dataset.column,
          // TODO: dataset is slow, read from columnstore using index instead
          columnId: cellElement.dataset.columnId,
          rowElement: cellElement.parentNode,
          row: me
        });
        cellElement = cellElement.nextElementSibling;
      } // making css selectors simpler, dataset has bad performance but it is only set once and never read


      element.dataset.index = me.index;
    }
    /**
     * Get the element for the specified region.
     * @param {String} region
     * @returns {HTMLElement}
     */

  }, {
    key: "getElement",
    value: function getElement(region) {
      return this._elements[region];
    }
    /**
     * Execute supplied function for each regions element.
     * @param {Function} fn
     */

  }, {
    key: "eachElement",
    value: function eachElement(fn) {
      for (var i = 0; i < this._elementsArray.length; i++) {
        fn(this._elementsArray[i], i);
      }
    }
    /**
     * Execute supplied function for each cell.
     * @param {Function} fn
     */

  }, {
    key: "eachCell",
    value: function eachCell(fn) {
      this._allCells.forEach(fn);
    }
    /**
     * Row elements (one for each region)
     * @type {HTMLElement[]}
     * @readonly
     */

  }, {
    key: "getCells",

    /**
     * Get cell elements for specified region.
     * @param {String} region Region to get elements for
     * @returns {HTMLElement[]} Array of cell elements
     */
    value: function getCells(region) {
      return this._cells[region];
    }
    /**
     * Get the cell element for the specified column.
     * @param {String|Number} columnId Column id
     * @returns {HTMLElement} Cell element
     */

  }, {
    key: "getCell",
    value: function getCell(columnId) {
      return this._allCells.find(function (cell) {
        var cellData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_19__["default"].get(cell);
        return cellData.columnId === columnId || cellData.column === columnId;
      });
    }
  }, {
    key: "removeElements",
    value: function removeElements() {
      var onlyRelease = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this; // Triggered before the actual remove to allow cleaning up elements etc.

      me.rowManager.trigger('removeRow', {
        row: me
      });

      if (!onlyRelease) {
        me._elementsArray.forEach(function (element) {
          return element.remove();
        });
      }

      me._elements = {};
      me._cells = {};
      me._elementsArray.length = me._regions.length = me._allCells.length = me.lastHeight = me.height = 0;
      me.lastTop = -1;
    } //endregion
    //region Height

    /**
     * Get/set row height
     * @property {Number}
     */

  }, {
    key: "updateElementsHeight",

    /**
     * Sync elements height to rows height
     * @private
     */
    value: function updateElementsHeight() {
      var me = this;
      me.rowManager.storeKnownHeight(me.id, me.height); // prevent unnecessary style updates

      if (me.lastHeight !== me.height) {
        var elements = me._elementsArray;

        for (var i = 0; i < elements.length; i++) {
          elements[i].style.height = "".concat(me.offsetHeight, "px");
        }

        me.lastHeight = me.height;
      }
    } //endregion
    //region CSS

    /**
     * Add css classes to each element.
     * @param {...String} classes
     */

  }, {
    key: "addCls",
    value: function addCls() {
      for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
        classes[_key] = arguments[_key];
      }

      this.eachElement(function (element) {
        return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].addClasses(element, classes);
      });
    }
    /**
     * Remove css classes from each element.
     * @param {...String} classes
     */

  }, {
    key: "removeCls",
    value: function removeCls() {
      for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        classes[_key2] = arguments[_key2];
      }

      this.eachElement(function (element) {
        return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].removeClasses(element, classes);
      });
    } //endregion
    //region Position

    /**
     * Is this the very first row?
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "setTop",

    /**
     * Sets top coordinate, translating elements position.
     * @param {Number} top Top coordinate
     * @param {Boolean} [silent] Specify `true` to not trigger translation event
     * @internal
     */
    value: function setTop(top, silent) {
      if (this._top !== top) {
        this._top = top;
        this.translateElements(silent);
      }
    }
    /**
     * Sets bottom coordinate, translating elements position.
     * @param {Number} bottom Bottom coordinate
     * @param {Boolean} [silent] Specify `true` to not trigger translation event
     * @private
     */

  }, {
    key: "setBottom",
    value: function setBottom(bottom, silent) {
      this.setTop(bottom - this.offsetHeight, silent);
    }
    /**
     * Sets css transform to position elements at correct top position (translateY)
     * @private
     */

  }, {
    key: "translateElements",
    value: function translateElements(silent) {
      var me = this,
          positionMode = me.grid.positionMode;

      if (me.lastTop !== me.top) {
        var elements = me._elementsArray;

        for (var i = 0; i < elements.length; i++) {
          var style = elements[i].style;

          if (positionMode === 'translate') {
            style.transform = "translate(0,".concat(me.top, "px)");
          } else if (positionMode === 'translate3d') {
            style.transform = "translate3d(0,".concat(me.top, "px,0)");
          } else if (positionMode === 'position') {
            style.top = "".concat(me.top, "px");
          }
        }

        if (!silent) {
          me.rowManager.trigger('translateRow', {
            row: me
          });
        }

        me.lastTop = me.top;
      }
    }
    /**
     * Moves all row elements up or down and updates model.
     * @param {Number} offsetTop Pixels to offset the elements
     * @private
     */

  }, {
    key: "offset",
    value: function offset(offsetTop) {
      var newTop = this._top + offsetTop; // Not allowed to go below zero (won't be reachable on scroll in that case)

      if (newTop < 0) {
        offsetTop -= newTop;
        newTop = 0;
      }

      this.setTop(newTop);
      return offsetTop;
    } //endregion
    //region Render

    /**
     * Renders a record into this rows elements (trigger event that subgrids catch to do the actual rendering).
     * @param {Number} recordIndex
     * @param {Core.data.Model} record
     * @param {Boolean} [updatingSingleRow]
     * @param {Boolean} [batch]
     * @private
     */

  }, {
    key: "render",
    value: function render(recordIndex, record) {
      var _maxRequestedHeight;

      var updatingSingleRow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var batch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var me = this,
          cells = me.cells,
          grid = me.grid,
          rowManager = me.rowManager,
          oldHeight = me.height,
          oldId = me._id,
          elements = me._elementsArray,
          rowElData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_19__["default"].get(elements[0]),
          rowHeight = rowManager._rowHeight,
          defaultRowCls = updatingSingleRow && grid.transitionDuration ? "".concat(me.cls, " b-grid-row-updating") : me.cls;
      var i = 0,
          rowElement,
          cell,
          size; // no record specified, try looking up in store (false indicates empty row, don't do lookup

      if (!record && record !== false) {
        record = grid.store.getById(rowElData.id);
        recordIndex = grid.store.indexOf(record);
      }

      var selected = record && grid.isSelected(record.id); // used by GroupSummary feature to clear row before

      rowManager.trigger('beforeRenderRow', {
        row: me,
        record: record,
        recordIndex: recordIndex,
        oldId: oldId
      });

      for (i; i < elements.length; i++) {
        rowElement = elements[i]; // Clean classList

        rowElement.className = defaultRowCls; // Apply cls from data directly to row
        // TODO: should be configurable on grid

        if (selected) {
          rowElement.classList.add('b-selected');
        }

        if (record.cls) {
          record.cls.split(' ').forEach(function (cls) {
            return rowElement.classList.add(cls);
          });
        }
      }

      if (updatingSingleRow && grid.transitionDuration) {
        me.setTimeout(function () {
          // We should iterate all elements, in case we have regions in the grid
          elements.forEach(function (element) {
            element.classList.remove('b-grid-row-updating');
          });
        }, grid.transitionDuration);
      }

      me.id = record.id;
      me.dataIndex = recordIndex; // Configured height, used as row height if renderers do not specify otherwise

      var height = !grid.fixedRowHeight && grid.getRowHeight(record) || rowHeight; // Max height returned by renderers

      var maxRequestedHeight = null;

      for (i = 0; i < cells.length; i++) {
        cell = cells[i];
        size = me.renderCell(cell, record, i, updatingSingleRow, height);

        if (!rowManager.fixedRowHeight) {
          // We want to make row in all regions as high as the highest cell
          if (size.height != null) {
            maxRequestedHeight = Math.max(maxRequestedHeight, size.height);
          }
        }
      }

      me.height = (_maxRequestedHeight = maxRequestedHeight) !== null && _maxRequestedHeight !== void 0 ? _maxRequestedHeight : height; // Height gets set during render, reflect on elements

      me.updateElementsHeight(); // Rerendering a row might change its height, which forces translation of all following rows

      if (updatingSingleRow) {
        if (oldHeight !== me.height) {
          rowManager.translateFromRow(me, batch);
        }

        rowManager.trigger('updateRow', {
          row: me,
          record: record,
          recordIndex: recordIndex,
          oldId: oldId
        });
        rowManager.trigger('renderDone');
      }

      rowManager.trigger('renderRow', {
        row: me,
        record: record,
        recordIndex: recordIndex,
        oldId: oldId
      });
      me.forceInnerHTML = false;
    }
    /**
     * Renders a single cell, calling features to allow them to hook.
     * @param cellElement Cell element to render
     * @param record Record, fetched from store if undefined
     * @param index
     * @param updatingSingleRow
     * @private
     */

  }, {
    key: "renderCell",
    value: function renderCell(cellElement, record, index) {
      var _newCellClass;

      var updatingSingleRow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var height = arguments.length > 4 ? arguments[4] : undefined;
      var me = this,
          grid = me.grid,
          cellElementData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_19__["default"].get(cellElement),
          column = grid.columns.getById(cellElementData.columnId),
          rowElement = cellElementData.rowElement,
          rowElementData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_19__["default"].get(rowElement),
          internalCellCls = column.internalCellCls,
          cellCls = column.cellCls,
          align = column.align,
          renderer = column.renderer,
          defaultRenderer = column.defaultRenderer,
          columnId = column.id,
          cellContext = {
        columnId: columnId,
        id: rowElementData.id
      },
          useRenderer = renderer || defaultRenderer;

      if (!record) {
        // Clear out row without record
        // Edge case, only happens if groups/tree is collapsed leading to fewer records than row elements
        if (rowElementData.id === null) {
          // setting to ' ' (space) makes it not remove firstChild, thus not breaking
          // when doing real render the next time
          // NOTE: have opted to not clear cell. might be confusing in DOM but simplifies for cells reusing
          // elements internally. Another option would be to have a derenderer per column which is called
          // cell.innerHTML = ' ';
          cellElement.className = 'b-grid-cell';
          return;
        }

        record = grid.store.getById(rowElementData.id);

        if (!record) {
          return;
        }
      } // Using new record for this row, consider it repurposed and inform Grid that cell is now visible
      // if (record.id !== oldId && col.reactiveRenderer) {
      //     const oldRecord = me.grid.store.getById(oldId);
      //     me.grid.cellBecameInvisible({ oldRecord : record, row : cellElementData.row, cell : cellElement });
      //     me.grid.cellBecameVisible({ record, row : cellElementData.row, cell : cellElement });
      // }
      // if (column.reactiveRenderer) {
      //     return null;
      // }


      var cellContent = column.getRawValue(record),
          shouldSetContent = true;
      var dataField = record.fieldMap[column.field],
          size = {
        configuredHeight: height,
        height: null
      },
          rendererData = {
        cellElement: cellElement,
        dataField: dataField,
        rowElement: rowElement,
        value: cellContent,
        record: record,
        column: column,
        size: size,
        grid: grid,
        row: cellElementData.row,
        updatingSingleRow: updatingSingleRow
      },
          newCellClass = (_newCellClass = {
        'b-grid-cell': 1
      }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default()(_newCellClass, internalCellCls, internalCellCls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default()(_newCellClass, cellCls, record.isSpecialRow && column.internalCellCls === 'b-check-cell' ? undefined : cellCls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default()(_newCellClass, 'b-cell-dirty', record.isFieldModified(column.field)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default()(_newCellClass, "b-grid-cell-align-".concat(align), align), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default()(_newCellClass, 'b-selected', grid.isSelected(cellContext)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_11___default()(_newCellClass, 'b-focused', grid.isFocused(cellContext)), _newCellClass);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].syncClassList(cellElement, newCellClass); // Call renderer or set innerHTML directly if none
      // if renderer returns a value, set it in innerHTML below. render is also free to do it itself

      if (useRenderer) {
        cellContent = useRenderer.call(column, rendererData);

        if (cellContent === undefined) {
          shouldSetContent = false;
        }
      } else if (dataField) {
        cellContent = dataField.print(cellContent);
      } // Allow wrappers to do their own processing of cell contents, for example react wrapper allows JSX


      if (grid.processCellContent) {
        shouldSetContent = grid.processCellContent({
          cellContent: cellContent,
          cellElement: cellElement,
          record: record,
          cellElementData: cellElementData,
          rendererData: rendererData
        });
      } // Listeners might need to know what string went into the DOM
      // Maintainer: the == null test below ensures that values of both null and undefined
      // result in an empty cell.


      var text = rendererData.cellContent = cellContent == null ? '' : String(cellContent);

      if (shouldSetContent) {
        // row might be flagged by GroupSummary to require full "redraw"
        if (me.forceInnerHTML) {
          // To allow minimal updates below, we must remove custom markup inserted by the GroupSummary feature
          cellElement.innerHTML = '';
          cellElement.lastDomConfig = null;
        } // display cell contents as text or use actual html?
        // (disableHtmlEncode set by features that decorate cell contents)


        if (column.htmlEncode && !column.disableHtmlEncode) {
          // Set innerText if cell currently has html content (from for example group renderer),
          // always do it on Linux, it does not have firstChild.data
          if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].isLinux || cellElement._hasHtml) {
            cellElement.innerText = text;
            cellElement._hasHtml = false;
          } else {
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].setInnerText(cellElement, text);
          }
        } else {
          var hasStringContent = typeof cellContent === 'string',
              hasObjectContent = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default()(cellContent) === 'object';

          if (column.autoSyncHtml && (!hasStringContent || cellElement.childElementCount)) {
            // String content in html column is handled as a html template string
            if (hasStringContent) {
              // update cell with only changed attributes etc.
              _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].sync(text, cellElement.firstElementChild);
            } // Other content is considered to be a DomHelper config object
            else {
                _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_22__["default"].sync({
                  domConfig: cellContent,
                  targetElement: cellElement
                });
              }
          } // Consider all returned plain objects to be DomHelper configs for cell content
          else if (hasObjectContent) {
              _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_22__["default"].sync({
                targetElement: cellElement,
                domConfig: {
                  onlyChildren: true,
                  children: Array.isArray(cellContent) ? cellContent : [cellContent]
                }
              });
            } // Apply text as innerHTML only if it has changed
            else if (cellElement._content !== text) {
                cellElement.innerHTML = cellElement._content = text;
              }
        }
      } // Allow others to affect rendering


      me.rowManager.trigger('renderCell', rendererData);
      return size;
    } //endregion

  }, {
    key: "index",
    get: function get() {
      return this._index;
    },
    set: function set(index) {
      this._index = index;
    }
    /**
     * Get/set this rows current index in grids store
     * @property {Number}
     */

  }, {
    key: "dataIndex",
    get: function get() {
      return this._dataIndex;
    },
    set: function set(dataIndex) {
      if (this._dataIndex !== dataIndex) {
        var elements = this._elementsArray;
        this._dataIndex = dataIndex;

        for (var i = 0; i < elements.length; i++) {
          elements[i].dataset.index = dataIndex;
        }
      }
    }
    /**
     * Get/set id for currently rendered record
     * @property {String|Number}
     */

  }, {
    key: "id",
    get: function get() {
      return this._id;
    },
    set: function set(id) {
      var me = this,
          idObj = {
        id: id
      },
          idMap = me.rowManager.idMap,
          elements = me._elementsArray,
          cells = me._allCells;

      if (me._id != id || idMap[id] !== me) {
        if (idMap[me._id] === me) delete idMap[me._id];
        idMap[id] = me;
        me._id = id;

        for (var i = 0; i < elements.length; i++) {
          _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign(elements[i], idObj);
        }

        for (var _i = 0; _i < cells.length; _i++) {
          _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign(cells[_i], idObj);
        }

        for (var _i2 = 0; _i2 < elements.length; _i2++) {
          elements[_i2].dataset.id = id;
        }
      }
    }
  }, {
    key: "elements",
    get: function get() {
      return this._elements;
    } //endregion
    //region Cell elements

    /**
     * Row cell elements
     * @returns {HTMLElement[]}
     * @readonly
     */

  }, {
    key: "cells",
    get: function get() {
      return this._allCells;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    },
    set: function set(height) {
      this._height = height;
    }
    /**
     * Get row height including border
     * @property {Number}
     */

  }, {
    key: "offsetHeight",
    get: function get() {
      // me.height is specified height, add border height to it to get cells height to match specified rowHeight
      // border height is measured in Grid#get rowManager
      return this.height + this.grid._rowBorderHeight;
    }
  }, {
    key: "isFirst",
    get: function get() {
      return this.dataIndex === 0;
    }
    /**
     * Row top coordinate
     * @property {Number}
     * @readonly
     */

  }, {
    key: "top",
    get: function get() {
      return this._top;
    }
    /**
     * Row bottom coordinate
     * @property {Number}
     * @readonly
     */

  }, {
    key: "bottom",
    get: function get() {
      return this._top + this._height + this.grid._rowBorderHeight;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        cls: 'b-grid-row'
      };
    }
  }]);

  return Row;
}(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_23__["default"])(_Core_Base_js__WEBPACK_IMPORTED_MODULE_18__["default"]));


Row._$name = 'Row';

/***/ }),

/***/ "./lib/Grid/row/RowManager.js":
/*!************************************!*\
  !*** ./lib/Grid/row/RowManager.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RowManager; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Row_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./Row.js */ "./lib/Grid/row/Row.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");






































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Handle vertical resize, add/remove row elements?







/**
 * @module Grid/row/RowManager
 * @private
 */

/**
 * Virtual representation of the grid, using {@link Grid.row.Row} to represent rows. Plugs into {@link Grid.view.Grid}
 * and exposes the following functions on grid itself:
 * * {@link #function-getRecordCoords()}
 * * {@link #function-getRowById()}
 * * {@link #function-getRow()}
 * * {@link #function-getRowFor()}
 * * {@link #function-getRowFromElement()}
 *
 * @example
 * let row = grid.getRowById(1);
 * @private
 */

var RowManager = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34___default()(RowManager, _InstancePlugin);

  var _super = _createSuper(RowManager);

  function RowManager() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31___default()(this, RowManager);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32___default()(RowManager, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(config) {
      config.grid._rowManager = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(RowManager.prototype), "construct", this).call(this, config.grid, config);
    } // Chained to grids doDestroy

  }, {
    key: "doDestroy",
    value: function doDestroy() {
      // To remove timeouts
      this._rows.forEach(function (row) {
        return row.destroy();
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(RowManager.prototype), "doDestroy", this).call(this);
    }
    /**
     * Initializes the RowManager with Rows to fit specified height.
     * @param {Number} height
     * @param {Boolean} [isRendering]
     * @private
     * @category Init
     */

  }, {
    key: "initWithHeight",
    value: function initWithHeight(height) {
      var isRendering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this; // no valid height, make room for all rows

      if (me.autoHeight) {
        height = me.store.allCount * me.preciseRowOffsetHeight;
      }

      me.viewHeight = height;
      me.calculateRowCount(isRendering);
      return height;
    }
    /**
     * Releases all elements (not from dom), calculates how many are needed, creates those and renders
     */

  }, {
    key: "reinitialize",
    value: function reinitialize() {
      var returnToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this; // Calculate and correct the amount of rows needed (without triggering render)
      // Rows which are found to be surplus are destroyed.

      me.calculateRowCount(false, true, true); // If our row range is outside of the store's range, force a return to top

      if (me.topIndex + me.rowCount - 1 > me.store.count) {
        returnToTop = true;
      }

      var top = me.topRow && !returnToTop ? me.topRow.top : 0;
      me.scrollTargetRecordId = null;

      if (returnToTop) {
        me.topIndex = me.lastScrollTop = 0;
      }

      var topRow = me.topRow;

      if (topRow) {
        // Ensure rendering from the topRow starts at the correct position
        topRow.dataIndex = me.topIndex;
        topRow.setTop(top, true);
      } // Need to estimate height in case we have Grid using autoHeight


      me.estimateTotalHeight();
      me.renderFromRow(topRow);
    } //endregion
    //region Rows

    /**
     * Add or remove rows to fit row count
     * @private
     * @category Rows
     */

  }, {
    key: "matchRowCount",
    value: function matchRowCount() {
      var skipRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          rows = me.rows,
          grid = me.grid,
          numRows = rows.length,
          delta = numRows - me.rowCount;

      if (delta) {
        if (delta < 0) {
          var newRows = []; // add rows

          for (var index = numRows, dataIndex = numRows ? rows[numRows - 1].dataIndex + 1 : 0; index < me.rowCount; index++, dataIndex++) {
            newRows.push(new _Row_js__WEBPACK_IMPORTED_MODULE_39__["default"]({
              rowManager: me,
              grid: grid,
              index: index,
              dataIndex: dataIndex
            }));
          }

          rows.push.apply(rows, newRows); // and elements (by triggering event used by SubGrid to add elements)

          me.trigger('addRows', {
            rows: newRows
          });

          if (!skipRender) {
            // render
            me.renderFromRow(rows[Math.max(0, numRows - 1)]);
          }
        } else {
          // remove rows from bottom
          var removedRows = rows.splice(numRows - delta, delta); // trigger event in case some feature needs to cleanup when removing (widget column might be interested)

          me.trigger('removeRows', {
            rows: removedRows
          });
          removedRows.forEach(function (row) {
            return row.destroy();
          }); // no need to rerender or such when removing from bottom. all is good :)
        }
      }
    }
    /**
     * Calculates how many rows fit in the available height (view height)
     * @private
     * @category Rows
     */

  }, {
    key: "calculateRowCount",
    value: function calculateRowCount() {
      var skipMatchRowCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var allowRowCountShrink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var skipRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // TODO: replace prependRowBuffer, appendXX with bufferSize
      var me = this,
          store = me.store,
          visibleRowCount = Math.ceil(me.viewHeight / me.minRowOffsetHeight),
          maxRenderRowCount = visibleRowCount + me.prependRowBuffer + me.appendRowBuffer; // If RowManager is reinitialized in a hidden state the view might not have a height

      if (!me.grid.columns.count || isNaN(visibleRowCount)) {
        me.rowCount = 0;
        return 0;
      } // when for example jumping we do not want to remove excess rows,
      // since we know they are needed at other scroll locations


      if (maxRenderRowCount < me.rowCount && !allowRowCountShrink) {
        return me.rowCount;
      }

      me.visibleRowCount = visibleRowCount;
      me.rowCount = Math.min(store.count, maxRenderRowCount); // No need for more rows than data
      // If the row count doesn't match the calculated, ensure it matches,

      if (!skipMatchRowCount) {
        if (me.rows && me.rowCount !== me.rows.length) {
          me.matchRowCount(skipRender);
        } else if (!me.rowCount) {
          me.trigger('changeTotalHeight', {
            totalHeight: me.totalHeight
          });
        }

        me.grid.toggleEmptyText();
      }

      return me.rowCount;
    }
  }, {
    key: "removeAllRows",
    value: function removeAllRows() {
      // remove rows from bottom
      var me = this,
          topRow = me.topRow,
          result = topRow ? me.refreshDetails = {
        topRowIndex: topRow.dataIndex,
        topRowTop: topRow.top
      } : me.refreshDetails,
          removedRows = me.rows.slice(); // trigger event in case some feature needs to cleanup when removing (widget column might be interested)

      me.trigger('removeRows', {
        rows: removedRows
      });
      me.rows.forEach(function (row) {
        return row.destroy();
      });
      me.rows.length = 0;
      me.idMap = {}; // We return a descriptor of the last rendered block before the remove.
      // This is primarily for a full GridBase#renderContents to be able to perform a correct refresh.

      return result;
    }
  }, {
    key: "setPosition",
    value: function setPosition(refreshDetails) {
      // Sets up the rendering position for the next call to reinitialize
      var topRow = this.topRow,
          topRowIndex = refreshDetails.topRowIndex,
          topRowTop = refreshDetails.topRowTop;
      topRow.setTop(topRowTop);
      topRow.dataIndex = topRowIndex;
    } //endregion
    //region Rows - Getters

  }, {
    key: "getRow",

    /**
     * Get the Row at specified index. Returns `undefined` if the row index is not rendered.
     * @param {Number} index
     * @returns {Grid.row.Row}
     * @category Rows
     */
    value: function getRow(index) {
      return this.rowCount && this.rows[index - this.topIndex];
    }
    /**
     * Get Row for specified record id
     * @param {Core.data.Model|String|Number} recordOrId Record id (or a record)
     * @returns {Grid.row.Row} Found Row or null if record not rendered
     * @category Rows
     */

  }, {
    key: "getRowById",
    value: function getRowById(recordOrId) {
      if (recordOrId && recordOrId.isModel) {
        recordOrId = recordOrId.id;
      }

      return this.idMap[recordOrId];
    }
    /**
     * Get a Row from an HTMLElement
     * @param {HTMLElement} element
     * @returns {Grid.row.Row} Found Row or null if record not rendered
     * @category Rows
     */

  }, {
    key: "getRowFromElement",
    value: function getRowFromElement(element) {
      element = element.closest('.b-grid-row');
      return element && this.getRow(element.dataset.index);
    }
    /**
     * Get the row at the specified Y coordinate, which is by default viewport-based.
     * @param {Number} y The `Y` coordinate to find the Row for.
     * @param {Boolean} [local=false] Pass `true` if the `Y` coordinate is local to the SubGrid's element.
     * @returns {Grid.row.Row} Found Row or null if no row is rendered at that point.
     */

  }, {
    key: "getRowAt",
    value: function getRowAt(y) {
      var local = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // Make it local.
      if (!local) {
        // Because this is used with event Y positions which are integers, we must
        // round the Rectangle to the closest integer.
        y -= _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_37__["default"].from(this.grid.bodyContainer, null, true).roundPx(1).top; // Adjust for scrolling

        y += this.grid.scrollable.y;
      }

      y = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_41__["default"].roundPx(y);
      return this.rows.find(function (r) {
        return y >= r.top && y < r.bottom;
      });
    }
    /**
     * Get a Row for either a record, a record id or an HTMLElement
     * @param {HTMLElement|Core.data.Model|String|Number} recordOrId Record or record id or HTMLElement
     * @returns {Grid.row.Row} Found Row or null if record not rendered
     * @category Rows
     */

  }, {
    key: "getRowFor",
    value: function getRowFor(recordOrId) {
      if (recordOrId instanceof HTMLElement) {
        return this.getRowFromElement(recordOrId);
      }

      return this.getRowById(recordOrId);
    }
    /**
     * Gets the Row following the specified Row (by index or object). Wraps around the end.
     * @param {Number|Grid.row.Row} indexOrRow index or Row
     * @returns {Grid.row.Row}
     * @category Rows
     */

  }, {
    key: "getNextRow",
    value: function getNextRow(indexOrRow) {
      var index = typeof indexOrRow === 'number' ? indexOrRow : indexOrRow.index;
      return this.getRow((index + 1) % this.rowCount);
    }
    /**
     * Get the Row that is currently displayed at top.
     * @property {Grid.row.Row}
     * @readonly
     * @category Rows
     */

  }, {
    key: "offsetRows",

    /**
     * Calls offset() for each Row passing along offset parameter
     * @param {Number} offset Pixels to translate Row elements.
     * @private
     * @category Rows
     */
    value: function offsetRows(offset) {
      if (offset !== 0) {
        var rows = this.rows,
            length = rows.length;

        for (var i = 0; i < length; i++) {
          rows[i].offset(offset);
        }
      }

      this.trigger('offsetRows', {
        offset: offset
      });
    } //endregion
    //region Row height
    // TODO: should support setting rowHeight in em and then convert internally to pixels. 1em = font-size. Not needed for 1.0

    /**
     * Set a fixed row height (can still be overridden by renderers) or get configured row height. Setting refreshes all rows
     * @category Rows
     */

  }, {
    key: "storeKnownHeight",

    /**
     * Store supplied `height` using `id` as key in the height map. Called by `Row` when it gets its height.
     * Keeps `avarageRowHeight` and `totalKnownHeight` up to date. Ignored when configured with `fixedRowHeight`
     * @param {String|Number} id
     * @param {Number} height
     * @internal
     */
    value: function storeKnownHeight(id, height) {
      var me = this,
          heightMap = me.heightMap;

      if (!me.fixedRowHeight) {
        // Decrease know height with old value
        if (heightMap.has(id)) {
          me.totalKnownHeight -= heightMap.get(id);
        } // Height here is "clientHeight"


        heightMap.set(id, height); // And increase with new

        me.totalKnownHeight += height;

        if (height < me.minRowHeight) {
          me.minRowHeight = height;
        }

        me.averageRowHeight = me.totalKnownHeight / heightMap.size;
      }
    }
    /**
     * Get the known or estimated offset height for the specified record id
     * @param {Core.data.Model} record
     * @returns {Number}
     * @private
     */

  }, {
    key: "getOffsetHeight",
    value: function getOffsetHeight(record) {
      var me = this;
      return (me.heightMap.get(record.id) || me.grid.getRowHeight(record) || me.averageRowHeight || me.rowHeight) + me.grid._rowBorderHeight;
    }
    /**
     * Invalidate cached height for a record. Removing it from `totalKnownHeight` and factoring it out of
     * `avarageRowHeight`.
     * @param {Core.data.Model|Core.data.Model[]} records
     */

  }, {
    key: "invalidateKnownHeight",
    value: function invalidateKnownHeight(records) {
      var me = this;

      if (!me.fixedRowHeight) {
        var heightMap = me.heightMap;

        if (!Array.isArray(records)) {
          records = [records];
        }

        records.forEach(function (record) {
          if (record) {
            if (heightMap.has(record.id)) {
              // Known height decreases when invalidating
              me.totalKnownHeight -= heightMap.get(record.id);
              heightMap.delete(record.id);
            }
          }
        });
        me.averageRowHeight = me.totalKnownHeight / heightMap.size;
      }
    }
    /**
     * Invalidates all cached height and resets `avarageRowHeight` and `totalKnownHeight`
     */

  }, {
    key: "clearKnownHeights",
    value: function clearKnownHeights() {
      this.heightMap.clear();
      this.averageRowHeight = this.totalKnownHeight = 0;
    }
    /**
     * Calculates a row top from its data index. Uses known values from the height map, unknown are substituted with
     * the average row height. When configured with `fixedRowHeight`, it will always calculate a correct value
     * @param {Number} index Index in store
     * @private
     */

  }, {
    key: "calculateTop",
    value: function calculateTop(index) {
      // When using fixed row height, life is easy
      if (this.fixedRowHeight) {
        return index * this.rowOffsetHeight;
      }

      var store = this.store;
      var top = 0; // When not using fixed row height, we make an educated guess at the top. The more rows have been visited, the
      // more correct the guess is (fully correct if all rows visited)

      for (var i = 0; i < index; i++) {
        var record = store.getAt(i);
        top += this.getOffsetHeight(record);
      }

      return Math.floor(top);
    } //endregion
    //region Calculations

    /**
     * Returns top and bottom for rendered row or estimated coordinates for unrendered.
     * @param {Core.data.Model|string|Number} recordOrId Record or record id
     * @param {Boolean} [local] Pass true to get relative record coordinates
     * @param {Boolean} [roughly] Pass true to allow a less exact but cheaper estimate
     * @returns {Core.helper.util.Rectangle} Record bounds with format { x, y, width, height, bottom, right }
     * @category Calculations
     */

  }, {
    key: "getRecordCoords",
    value: function getRecordCoords(recordOrId) {
      var local = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var roughly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          id = typeof recordOrId === 'string' || typeof recordOrId === 'number' ? recordOrId : recordOrId.id,
          row = me.getRowById(recordOrId);
      var scrollingViewport = me.client._bodyRectangle; // _bodyRectangle is not updated on page/containing element scroll etc. Need to make sure it is correct in case
      // that has happend. This if-statement should be removed when fixing
      // https://app.assembla.com/spaces/bryntum/tickets/6587-cached-_bodyrectangle-should-be-updated-on--quot-external-quot--scroll/details

      if (!local) {
        scrollingViewport = me.client._bodyRectangle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_37__["default"].client(me.client.bodyContainer);
      } // Rendered? Then we know position for certain


      if (row) {
        return new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_37__["default"](scrollingViewport.x, local ? Math.round(row.top) : Math.round(row.top + scrollingViewport.y - me.client.scrollable.y), scrollingViewport.width, row.offsetHeight);
      }

      return me.getRecordCoordsByIndex(me.store.indexOf(id), local, roughly);
    }
    /**
     * Returns estimated top and bottom coordinates for specified row.
     * @param {Number} recordIndex Record index
     * @param {Boolean} [local]
     * @returns {Core.helper.util.Rectangle} Estimated record bounds with format { x, y, width, height, bottom, right }
     * @category Calculations
     */

  }, {
    key: "getRecordCoordsByIndex",
    value: function getRecordCoordsByIndex(recordIndex) {
      var local = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var roughly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var me = this,
          topRow = me.topRow,
          bottomRow = me.bottomRow,
          scrollingViewport = me.client._bodyRectangle,
          _me$store$getAt = me.store.getAt(recordIndex),
          id = _me$store$getAt.id,
          height = me.preciseRowOffsetHeight,
          currentTopIndex = topRow.dataIndex,
          currentBottomIndex = bottomRow.dataIndex,
          calculateFrom = // bottomRow is closest, calculate from it
      recordIndex > currentBottomIndex ? {
        index: recordIndex - currentBottomIndex - 1,
        y: bottomRow.bottom,
        from: 'bottomRow'
      } //  closer to topRow than 0, use topRow
      : recordIndex > currentTopIndex / 2 ? {
        index: recordIndex - currentTopIndex,
        y: topRow.top,
        from: 'topRow'
      } // closer to the very top, use it
      : {
        index: recordIndex,
        y: 0,
        from: 'top'
      },
          top = me.allHeightsKnown && !roughly // All heights are known (all rows visited or fixed row height), get actual top coord
      ? me.calculateTop(recordIndex) // Otherwise estimate
      : Math.floor(calculateFrom.y + calculateFrom.index * height),
          result = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_37__["default"](scrollingViewport.x, local ? top : top + scrollingViewport.y - me.client.scrollable.y, scrollingViewport.width, // Either known height or average
      Math.floor(me.heightMap.get(id) || height)); // Signal that it's not based on an element, so is only approximate.
      // Grid.scrollRowIntoView will have to go round again using the block options below to ensure it's correct.


      result.virtual = true; // When the block becomes visible, scroll it to the logical position using the scrollIntoView's block
      // option. If it's above, use block: 'start', if below, use block: 'end'.

      result.block = result.bottom < scrollingViewport.y ? 'start' : result.y > scrollingViewport.bottom ? 'end' : 'nearest';
      return result;
    }
    /**
     * Total estimated grid height (used for scroller)
     * @property {Number}
     * @readonly
     * @category Calculations
     */

  }, {
    key: "forEach",
    //endregion
    //region Iteration etc.

    /**
     * Calls a function for each Row
     * @param {Function} fn Function that will be called with Row as first parameter
     * @category Iteration
     */
    value: function forEach(fn) {
      this.rows.forEach(fn);
    }
    /**
     * Iterator that allows you to do for (let row of rowManager)
     * @category Iteration
     */

  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.rows[Symbol.iterator]();
    } //endregion
    //region Scrolling & rendering

    /**
     * Refresh a single cell.
     * @param {Core.data.Model} record Record for row holding the cell that should be updated
     * @param {String|Number} columnId Column id to identify the cell within the row
     * @returns {Boolean} Returns `true` if cell was found and refreshed, `false` if not
     */

  }, {
    key: "refreshCell",
    value: function refreshCell(record, columnId) {
      var row = this.getRowFor(record);

      if (row) {
        var cell = row.getCell(columnId);

        if (cell) {
          row.renderCell(cell);
          return true;
        }
      }

      return false;
    }
    /**
     * Renders from the top of the grid, also resetting scroll to top. Used for example when collapsing all groups.
     * @category Scrolling & rendering
     */

  }, {
    key: "returnToTop",
    value: function returnToTop() {
      var me = this;
      me.topIndex = 0;
      me.lastScrollTop = 0;

      if (me.topRow) {
        me.topRow.dataIndex = 0; // Force the top row to the top of the scroll range

        me.topRow.setTop(0, true);
      }

      me.refresh(); // Rows rendered from top, make sure grid is scrolled to top also

      me.grid.scrollable.y = 0;
    }
    /**
     * Renders from specified records row and down (used for example when collapsing a group, does not affect rows above).
     * @param {Core.data.Model} record Record of first row to render
     * @category Scrolling & rendering
     */

  }, {
    key: "renderFromRecord",
    value: function renderFromRecord(record) {
      var row = this.getRowById(record.id);

      if (row) {
        this.renderFromRow(row);
      }
    }
    /**
     * Renders from specified row and down (used for example when collapsing a group, does not affect rows above).
     * @param {Grid.row.Row} fromRow First row to render
     * @category Scrolling & rendering
     */

  }, {
    key: "renderFromRow",
    value: function renderFromRow() {
      var fromRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var me = this,
          rows = me.rows,
          store = me.store,
          storeCount = store.count; // Calculate row count, adding rows if needed, but do not rerender - we are going to do that below.
      // Bail out if no rows. Allow removing rows if we have more than store have rows

      if (me.calculateRowCount(false, storeCount < rows.length, true) === 0) {
        return;
      }

      var // render from this row
      fromRowIndex = fromRow ? rows.indexOf(fromRow) : 0,
          // starting either from its specified dataIndex or from its index (happens on first render, no dataIndex yet)
      dataIndex = fromRow ? fromRow.dataIndex : rows[0].dataIndex,
          // amount of records after this one in store
      recordsAfter = storeCount - dataIndex - 1,
          // render to this row, either the last row or the row which will hold the last record available
      toRowIndex = Math.min(rows.length - 1, fromRowIndex + recordsAfter),
          // amount of rows which wont be rendered below last record (if we have fewer records than topRow + row count)
      leftOverCount = rows.length - toRowIndex - 1,
          // Start with top correctly just below the previous row's bottom
      top = fromRowIndex > 0 ? rows[fromRowIndex - 1].bottom : rows[fromRowIndex].top,
          row; // _rows array is ordered in display order, just iterate to the end

      for (var i = fromRowIndex; i <= toRowIndex; i++) {
        row = rows[i]; // Needed in scheduler when translating events, happens before render

        row.dataIndex = dataIndex; // Silent translation, render will update contents anyway

        row.setTop(top, true);
        row.render(dataIndex, store.getAt(dataIndex++), false);
        top += row.offsetHeight;
      } // if number for records to display has decreased, for example by collapsing a node, we might get unused rows
      // below bottom. move those to top to not have unused rows laying around


      while (leftOverCount-- > 0) {
        me.displayRecordAtTop();
      } // Reestimate total height


      me.estimateTotalHeight(true);
      me.trigger('renderDone');
    }
    /**
     * Renders the passed array (or [Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set)) of {@link Grid.row.Row rows}
     * @param {Grid.row.Row[]|Set} rows The rows to render
     * @category Scrolling & rendering
     */

  }, {
    key: "renderRows",
    value: function renderRows(rows) {
      var oldHeight,
          heightChanged = false;
      rows = Array.from(rows); // Sort topmost row first

      rows.sort(function (a, b) {
        return a.dataIndex - b.dataIndex;
      }); // Render the requested rows.

      var _iterator = _createForOfIteratorHelper(rows),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          oldHeight = row.height; // Pass updatingSingleRow as false, so that it does not shuffle following
          // rows downwards on each render. We do that once here after the rows are all refreshed.

          row.render(null, null, false);
          heightChanged |= row.height !== oldHeight;
        } // If this caused a height change, shuffle following rows.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (heightChanged) {
        this.translateFromRow(rows[0]);
      }

      this.trigger('renderDone');
    }
    /**
     * Translates all rows after the specified row. Used when a single rows height is changed and the others should
     * rearrange. (Called from Row#render)
     * @param {Grid.row.Row} fromRow
     * @private
     * @category Scrolling & rendering
     */

  }, {
    key: "translateFromRow",
    value: function translateFromRow(fromRow) {
      var batch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this;
      var top = fromRow.bottom,
          row,
          index;

      for (index = fromRow.dataIndex + 1, row = me.getRow(index); row; row = me.getRow(++index)) {
        row.setTop(top);
        top += row.offsetHeight;
      } // Reestimate total height


      if (!batch) {
        me.estimateTotalHeight(true);
      }
    }
    /**
     * Rerender all rows
     * @category Scrolling & rendering
     */

  }, {
    key: "refresh",
    value: function refresh() {
      var me = this,
          topRow = me.topRow; // too early

      if (!topRow) {
        return;
      }

      me.idMap = {};
      me.renderFromRow(topRow);
      me.trigger('refresh');
    }
    /**
     * Makes sure that specified record is displayed in view
     * @param newScrollTop Top of visible section
     * @param [forceRecordIndex] Index of record to display at center
     * @private
     * @category Scrolling & rendering
     */

  }, {
    key: "jumpToPosition",
    value: function jumpToPosition(newScrollTop, forceRecordIndex) {
      // There are two very different requirements here.
      // If there is a forceRecordIndex, that takes precedence to get it into the center of the
      // viewport, and wherever we render the calculated row block, we may then *adjust the scrollTop*
      // to get that row to the center.
      //
      // If there's no forceRecordIndex, then the scroll position is the primary objective and
      // we must render what we calculate to be correct at that viewport position.
      var me = this,
          store = me.store,
          heightMap = me.heightMap,
          storeCount = store.count;

      if (me.allHeightsKnown && !me.fixedRowHeight) {
        var top = newScrollTop - me.prependBufferHeight,
            border = me.grid._rowBorderHeight;
        var accumulated = 0,
            targetIndex = 0;

        while (accumulated < top) {
          var record = store.getAt(targetIndex);
          accumulated += heightMap.get(record.id) + border;
          targetIndex++;
        }

        var startIndex = Math.max(Math.min(targetIndex, storeCount - me.rowCount), 0);
        me.lastScrollTop = newScrollTop;
        me.topRow.dataIndex = me.topIndex = startIndex;
        me.topRow.setTop(me.calculateTop(startIndex), false); // render entire buffer

        me.refresh();
      } else {
        var rowHeight = me.preciseRowOffsetHeight,
            // Calculate index of the top of the rendered block.
        // If we are targeting the scrollTop, this will be the top index at the scrollTop minus prepend count.
        // If we are targeting a recordIndex, this will attempt to place that in the center of the rendered block.
        _targetIndex = forceRecordIndex == null ? Math.floor(newScrollTop / rowHeight) - me.prependRowBuffer : forceRecordIndex - Math.floor(me.rowCount / 2),
            _startIndex = Math.max(Math.min(_targetIndex, storeCount - me.rowCount), 0),
            viewportTop = me.client.scrollable.y,
            viewportBottom = Math.min(me.client._bodyRectangle.height + viewportTop + me.appendBufferHeight, me.totalHeight);

        me.lastScrollTop = newScrollTop;
        me.topRow.dataIndex = me.topIndex = _startIndex;
        me.topRow.setTop(Math.floor(_startIndex * rowHeight), false); // render entire buffer

        me.refresh(); // TODO: It is likely the approach below will be needed for scrolling in opposite direction also, although no
        //   problem encountered yet
        // Not filled all the way down?

        if (me.bottomRow.bottom < viewportBottom) {
          // Might have jumped into a section of low heights. Needs to be done after the refresh, since heights
          // are not known before it
          me.calculateRowCount(false, false, false); // Fill with available rows (might be available above buffer because of var row height), stop if we run out of records :)

          while (me.bottomRow.bottom < viewportBottom && me._rows[me.prependRowBuffer].top < viewportTop && me.bottomRow.dataIndex < storeCount - 1) {
            me.displayRecordAtBottom();
          } // TODO: Block below was not needed for current tests, but if row height in one block is enough smaller
          //  than average row height then we will need to add more rows
          // Still not filled all the way down? Need more rows
          // if (me.bottomRow.bottom < viewportBottom) {
          //     //const localAverage = blockHeight / me.rowCount;
          //     while (me.bottomRow.bottom < viewportBottom) {
          //        me.addRecordAtBottom();
          //     }
          // }

        }

        me.estimateTotalHeight();
      } // If the row index is our priority, then scroll it into the center


      if (forceRecordIndex != null) {
        var scrollable = me.grid.scrollable,
            targetRow = me.getRow(forceRecordIndex),
            rowCenter = targetRow && _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_37__["default"].from(targetRow._elementsArray[0]).center.y,
            viewportCenter = scrollable.viewport.center.y; // Scroll the targetRow into the center of the viewport

        if (targetRow) {
          scrollable.y = newScrollTop = Math.floor(scrollable.y + (rowCenter - viewportCenter));
        }
      }

      return newScrollTop;
    }
    /**
     * Jumps to a position if it is far enough from current position. Otherwise does nothing.
     * @private
     * @category Scrolling & rendering
     */

  }, {
    key: "warpIfNeeded",
    value: function warpIfNeeded(newScrollTop) {
      var me = this,
          result = {
        newScrollTop: newScrollTop,
        deltaTop: newScrollTop - me.lastScrollTop
      }; // if gap to fill is large enough, better to jump there than to fill row by row

      if (Math.abs(result.deltaTop) > me.rowCount * me.rowOffsetHeight * 3) {
        // no specific record targeted
        var index; // Specific record specified as target of scroll?

        if (me.scrollTargetRecordId) {
          index = me.store.indexOf(me.scrollTargetRecordId); // since scroll is happening async record might have been removed after requesting scroll,
          // in that case we rely on calculated index (as when scrolling without target)
        } // perform the jump and return results


        result.newScrollTop = me.jumpToPosition(newScrollTop, index);
        result.deltaTop = 0; // no extra filling needed
      }

      return result;
    }
    /**
     * Handles virtual rendering (only visible rows + buffer are in dom) for rows
     * @param {Number} newScrollTop The `Y` scroll position for which to render rows.
     * @param {Boolean} [force=false] Pass `true` to update the rendered row block even if the scroll position has not changed.
     * @return {Number} Adjusted height required to fit rows
     * @private
     * @category Scrolling & rendering
     */

  }, {
    key: "updateRenderedRows",
    value: function updateRenderedRows(newScrollTop, force) {
      var ignoreError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          clientRect = me.client._bodyRectangle; // Might be triggered after removing all records, should not crash

      if (me.rowCount === 0) {
        return 0;
      }

      var result = me.totalHeight;

      if (force || // Only react if we have scrolled by one row or more
      Math.abs(newScrollTop - me.lastScrollTop) >= me.rowOffsetHeight || // or if we have a gap at top/bottom (#9375)
      me.topRow.top > newScrollTop || me.bottomRow.bottom < newScrollTop + clientRect.height) {
        // If scrolled by a large amount, jump instead of rendering each row
        var posInfo = me.warpIfNeeded(newScrollTop);
        me.scrollTargetRecordId = null; // Cache the last correct render scrollTop before fill.
        // it can be adjusted to hide row position corrections.

        me.lastScrollTop = posInfo.newScrollTop;

        if (posInfo.deltaTop > 0) {
          // Scrolling down
          me.fillBelow(posInfo.newScrollTop);
        } else if (posInfo.deltaTop < 0) {
          // Scrolling up
          me.fillAbove(posInfo.newScrollTop);
        }

        if (!me.fixedRowHeight && !ignoreError) {
          me.correctError(posInfo, clientRect, newScrollTop);
        } // Calculate the new height based on new content


        result = me.estimateTotalHeight();
      }

      return result;
    }
  }, {
    key: "correctError",
    value: function correctError(posInfo, clientRect, newScrollTop) {
      var me = this;
      var error = 0; // TODO: Merge with else, does the same calculation
      // When we transition from not knowing all heights to doing so, the old estimate will likely have positioned
      // rows a bit off. Compensate for that here.

      if (me.allHeightsKnown) {
        error = me.topRow.top - me.calculateTop(me.topRow.dataIndex);
      } // If it's a temporary scroll, we can be told to ignore the drift.
      // Apart from that, we must correct keep the rendered block position correct.
      // Otherwise, when rolling upwards after a teleport, we may not be able to reach
      // the top. Some rows may end up at -ve positions.
      else {
          // Only correct the rendered block position if we are in danger of running out of scroll space.
          // That is if we are getting towards the top or bottom of the scroll range.
          if ( // Scrolling up within top zone
          posInfo.deltaTop < 0 && newScrollTop < clientRect.height * 2 || // Scrolling down within bottom zone
          posInfo.deltaTop > 0 && newScrollTop > me.totalHeight - clientRect.height * 2 - 3) {
            // TODO: Calc could be eased more, using distance left to have less effect the further away from top/bottom
            error = me.topRow.top - me.calculateTop(me.topRow.dataIndex); //me.topIndex * me.rowOffsetHeight;
          }
        }

      if (error) {
        // Correct the rendered block position if it's not at the calculated position.
        // Keep the visual position correct by adjusting the scrollTop by the same amount.
        // When variable row heights are used, this will keep the rendered block top correct.
        me.offsetRows(-error);
        me.grid.scrollable.y = me.lastScrollTop = me.grid.scrollable.y - error;
      }
    }
    /**
     * Moves as many rows from the bottom to the top that are needed to fill to current scroll pos.
     * @param newTop Scroll position
     * @private
     * @category Scrolling & rendering
     */

  }, {
    key: "fillAbove",
    value: function fillAbove(newTop) {
      var me = this,
          fillHeight = newTop - me.topRow.top - me.prependBufferHeight;
      var accumulatedHeight = 0;

      while (accumulatedHeight > fillHeight && me.topIndex > 0) {
        // We want to show prev record at top of rows
        accumulatedHeight -= me.displayRecordAtTop();
      }

      me.trigger('renderDone');
    }
    /**
     * Moves as many rows from the top to the bottom that are needed to fill to current scroll pos.
     * @param newTop Scroll position
     * @private
     * @category Scrolling & rendering
     */

  }, {
    key: "fillBelow",
    value: function fillBelow(newTop) {
      var me = this,
          fillHeight = newTop - me.topRow.top - me.prependBufferHeight,
          recordCount = me.store.count,
          rowCount = me.rowCount;
      var accumulatedHeight = 0; // Repeat until we have filled empty height

      while (accumulatedHeight < fillHeight && // fill empty height
      me.topIndex + rowCount < recordCount && // as long as we have records left
      me.topRow.top + me.topRow.offsetHeight < newTop // and do not move top row fully into view (can happen with var row height)
      ) {
        // We want to show next record at bottom of rows
        accumulatedHeight += me.displayRecordAtBottom();
      }

      me.trigger('renderDone');
    }
    /**
     * Estimates height needed to fit all rows, based on average row height. Also offsets rows if needed to not be above
     * the reachable area of the view.
     * @param {Boolean} [immediate] Specify true to pass the `immediate` flag on to any listeners (probably only Grid
     * cares. Used to bypass buffered element resize)
     * @returns {Number}
     * @private
     * @category Scrolling & rendering
     */

  }, {
    key: "estimateTotalHeight",
    value: function estimateTotalHeight() {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this;

      if (me.grid.renderingRows) {
        return;
      }

      var recordCount = me.store.count,
          unknownCount = recordCount - me.heightMap.size,
          bottomRow = me.bottomRow;
      var estimate; // No need to estimate when using fixed row height

      if (me.fixedRowHeight) {
        estimate = recordCount * me.rowOffsetHeight;
      } else {
        estimate = // Known height, from entries in heightMap
        me.totalKnownHeight + // Those heights are "clientHeights", estimate needs to include borders
        me.heightMap.size * me.grid._rowBorderHeight + // Add estimate for rows with unknown height
        unknownCount * me.preciseRowOffsetHeight; // No bottomRow yet if estimating initial height in autoHeight grid

        if (bottomRow && unknownCount) {
          var bottom = bottomRow.bottom; // To low estimate or reached the end with scroll left, adjust to fit current bottom

          if (bottom > estimate || me.topIndex + me.rowCount >= recordCount && estimate > bottom) {
            estimate = bottom; // estimate all the way down

            if (bottomRow.dataIndex < recordCount - 1) {
              estimate += (recordCount - 1 - bottomRow.dataIndex) * me.preciseRowOffsetHeight;
            }
          }
        }

        estimate = Math.floor(estimate);
      }

      if (estimate !== me.totalHeight) {
        if (me.trigger('changeTotalHeight', {
          totalHeight: estimate,
          immediate: immediate
        }) !== false) {
          me._totalHeight = estimate;
        }
      }

      return estimate;
    }
    /**
     * Moves a row from bottom to top and renders the corresponding record to it.
     * @returns {Number} New row height
     * @private
     * @category Scrolling & rendering
     */

  }, {
    key: "displayRecordAtTop",
    value: function displayRecordAtTop() {
      var me = this,
          recordIndex = me.topIndex - 1,
          record = me.store.getAt(recordIndex),
          // Row currently rendered at the bottom, the row we want to move
      bottomRow = me.bottomRow,
          bottomRowTop = bottomRow.top;
      me.trigger('beforeTranslateRow', {
        row: bottomRow,
        newRecord: record
      }); // estimated top, for rendering that depends on having top

      bottomRow._top = me.topRow.top - me.getOffsetHeight(record); // if configured with fixed row height, it will be the correct value

      bottomRow.estimatedTop = !me.fixedRowHeight; // Render row

      bottomRow.render(recordIndex, record, false); // Move it to top. Restore top so that the setter won't reject non-change
      // if the estimate happened to be correct.

      bottomRow._top = bottomRowTop;
      bottomRow.setBottom(me.topRow.top);
      bottomRow.estimatedTop = false; // Prev row is now at top

      me.topIndex--; // move to start of array (bottomRow becomes topRow)

      me._rows.unshift(me._rows.pop());

      return bottomRow.offsetHeight;
    }
    /**
     * Moves a row from top to bottom and renders the corresponding record to it.
     * @returns {Number} New row height
     * @private
     * @category Scrolling & rendering
     */

  }, {
    key: "displayRecordAtBottom",
    value: function displayRecordAtBottom() {
      var me = this,
          recordIndex = me.topIndex + me.rowCount,
          record = me.store.getAt(recordIndex),
          // Row currently rendered on the top, the row we want to move
      topRow = me.topRow;
      me.trigger('beforeTranslateRow', {
        row: topRow,
        newRecord: record
      });
      topRow.dataIndex = recordIndex; // Move it to bottom

      topRow.setTop(me.bottomRow.bottom); // Render row

      topRow.render(recordIndex, record, false); // Next row is now at top

      me.topIndex++; // move to end of array (topRow becomes bottomRow)

      me._rows.push(me._rows.shift());

      return topRow.offsetHeight;
    } //endregion

  }, {
    key: "store",
    get: function get() {
      return this.client.store;
    }
    /**
     * Get all Rows
     * @property {Grid.row.Row[]}
     * @readonly
     * @category Rows
     */

  }, {
    key: "rows",
    get: function get() {
      return this._rows;
    }
  }, {
    key: "topRow",
    get: function get() {
      return this.rows[0];
    }
    /**
     * Get the Row currently displayed furthest down.
     * @property {Grid.row.Row}
     * @readonly
     * @category Rows
     */

  }, {
    key: "bottomRow",
    get: function get() {
      // TODO: remove when ticket on making sure rowCount is always up to date is fixed
      var rowCount = Math.min(this.rowCount, this.store.count);
      return this.rows[rowCount - 1];
    }
  }, {
    key: "firstVisibleRow",
    get: function get() {
      var _this = this;

      return this.rows.find(function (r) {
        return r.bottom > _this.grid.scrollable.y;
      });
    }
  }, {
    key: "firstFullyVisibleRow",
    get: function get() {
      var _this2 = this;

      return this.rows.find(function (r) {
        return r.top >= _this2.grid.scrollable.y;
      });
    }
  }, {
    key: "lastVisibleRow",
    get: function get() {
      var grid = this.grid; // We need the last row who's top is inside the scrolling viewport

      return _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"].findLast(this.rows, function (r) {
        return r.top < grid.scrollable.y + grid.bodyHeight;
      });
    }
  }, {
    key: "rowHeight",
    get: function get() {
      return this._rowHeight;
    },
    set: function set(height) {
      var me = this,
          grid = me.grid,
          fixedRowHeight = me.fixedRowHeight,
          oldRowHeight = me.rowHeight;
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_40__["default"].assertNumber(height, 'rowHeight');

      if (height < 10) {
        height = 10;
      }

      me.trigger('beforeRowHeight', {
        height: height
      });
      me.minRowHeight = me._rowHeight = height;
      me.prependBufferHeight = me.prependRowBuffer * me.rowOffsetHeight;
      me.appendBufferHeight = me.appendRowBuffer * me.rowOffsetHeight;

      if (fixedRowHeight) {
        me.averageRowHeight = height;
      }

      if (me.rows.length) {
        var oldY = grid.scrollable.y,
            topRow = me.getRowAt(oldY, true),
            // When changing rowHeight in a scrolled grid, there might no longer be a row at oldY
        edgeOffset = topRow ? topRow.top - oldY : 0;
        var average, oldAverage; // When using fixedRowHeight there is no need to update an average

        if (fixedRowHeight) {
          average = height;
          oldAverage = oldRowHeight;
        } else {
          oldAverage = average = me.averageRowHeight;
          me.clearKnownHeights(); // Scale the average height in proportion to the row height change

          average *= height / oldRowHeight;
        } // Adjust number of rows, since it is only allowed to shrink in refresh()


        me.calculateRowCount(false, true, true); // Reposition the top row since it is used to position the rest

        me.topRow.setTop(me.topRow.dataIndex * (average + grid._rowBorderHeight), true);
        me.refresh();
        var newY = oldY * (average / oldAverage); // Scroll top row to the same position.

        if (newY !== oldY) {
          grid.scrollRowIntoView(topRow.id, {
            block: 'start',
            edgeOffset: edgeOffset
          });
        }
      }

      me.trigger('rowHeight', {
        height: height
      });
    }
    /**
     * Get actually used row height, which includes any border and might be an average if using variable row height.
     * @property {Number}
     */

  }, {
    key: "rowOffsetHeight",
    get: function get() {
      return Math.floor(this.preciseRowOffsetHeight);
    }
  }, {
    key: "preciseRowOffsetHeight",
    get: function get() {
      return (this.averageRowHeight || this._rowHeight) + this.grid._rowBorderHeight;
    }
  }, {
    key: "minRowOffsetHeight",
    get: function get() {
      return (this.minRowHeight || this._rowHeight) + this.grid._rowBorderHeight;
    }
    /*
    * How store CRUD affects the height map:
    *
    * | Operation | Result                            |
    * |-----------|-----------------------------------|
    * | add       | No. Appears on render             |
    * | insert    | No. Appears on render             |
    * | remove    | Remove entry                      |
    * | removeAll | Clear                             |
    * | update    | No                                |
    * | replace   | Height might differ, remove entry |
    * | move      | No                                |
    * | filter    | No                                |
    * | sort      | No                                |
    * | group     | No                                |
    * | dataset   | Clear                             |
    *
    * The above is handled in GridBase
    */

    /**
     * Returns `true` if all rows have a known height. They do if all rows are visitied, or if RowManager is configured
     * with `fixedRowHeight`. If so, all tops can be calculated exactly, no guessing needed
     * @property {Boolean}
     * @private
     */

  }, {
    key: "allHeightsKnown",
    get: function get() {
      return this.fixedRowHeight || this.heightMap.size >= this.store.count;
    }
  }, {
    key: "totalHeight",
    get: function get() {
      return this._totalHeight;
    }
  }, {
    key: "widgetClass",
    get: function get() {}
  }], [{
    key: "pluginConfig",
    //region Config
    // Plugin configuration.
    get: function get() {
      return {
        chain: ['getRowById', 'getRecordCoords', 'getRow', 'getRowFor', 'getRowFromElement', 'destroy'],
        assign: ['rowHeight', 'topRow', 'bottomRow']
      };
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Number of rows to render above current viewport
         * @config {Number}
         * @default
         */
        prependRowBuffer: 5,

        /**
         * Number of rows to render below current viewport
         * @config {Number}
         * @default
         */
        appendRowBuffer: 5,

        /**
         * Default row height, assigned from Grid at construction (either from config
         * {@link Grid.view.Grid#config-rowHeight} or CSS). Can be set from renderers
         * @config {Number}
         * @default
         */
        rowHeight: null,

        /**
         * Set to `true` to get a small performance boost in applications that uses fixed row height
         * @config {Boolean}
         */
        fixedRowHeight: null,
        autoHeight: false
      };
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        idMap: {},
        // TODO: investigate if topIndex can to built away, since topRow is always first in array and has dataIndex??
        topIndex: 0,
        lastScrollTop: 0,
        _rows: [],
        // Record id -> row height mapping
        heightMap: new Map(),
        // Sum of entries in heightMap
        totalKnownHeight: 0,
        // Will be calculated in `estimateTotalHeight()`, as totalKnownHeight + an estimate for unknown rows
        _totalHeight: 0,
        // Average of the known heights, kept up to date when entries in the heightMap are updated
        averageRowHeight: 0,
        scrollTargetRecordId: null,
        refreshDetails: {
          topRowIndex: 0,
          topRowTop: 0
        }
      };
    }
  }]);

  return RowManager;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_38__["default"]);


RowManager._$name = 'RowManager';

/***/ }),

/***/ "./lib/Grid/util/BooleanUnicodeSymbol.js":
/*!***********************************************!*\
  !*** ./lib/Grid/util/BooleanUnicodeSymbol.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BooleanUnicodeSymbol; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);


var productName = 'scheduler';

var BooleanUnicodeSymbol = /*#__PURE__*/function () {
  function BooleanUnicodeSymbol(value) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, BooleanUnicodeSymbol);

    this._value = value;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(BooleanUnicodeSymbol, [{
    key: "toString",
    value: function toString() {
      return Boolean(this.value) ? '✓' : '';
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    }
  }]);

  return BooleanUnicodeSymbol;
}();


BooleanUnicodeSymbol._$name = 'BooleanUnicodeSymbol';

/***/ }),

/***/ "./lib/Grid/util/GridScroller.js":
/*!***************************************!*\
  !*** ./lib/Grid/util/GridScroller.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GridScroller; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");






















function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Grid/util/GridScroller
 */

var xAxis = {
  x: 1
};
/**
 * A Scroller subclass which handles scrolling in a grid.
 *
 * If the grid has no parallel scrolling grids (No locked columns), then this functions
 * transparently as a Scroller.
 *
 * If there are locked columns, then scrolling to an _element_ will invoke the scroller
 * of the subgrid which contains that element.
 * @internal
 */

var GridScroller = /*#__PURE__*/function (_Scroller) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(GridScroller, _Scroller);

  var _super = _createSuper(GridScroller);

  function GridScroller() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default()(this, GridScroller);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default()(GridScroller, [{
    key: "addScroller",
    value: function addScroller(scroller) {
      (this.xScrollers || (this.xScrollers = [])).push(scroller);
    }
  }, {
    key: "addPartner",
    value: function addPartner(otherScroller) {
      var axes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : xAxis;

      if (typeof axes === 'string') {
        axes = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()({}, axes, 1);
      } // Link up all our X scrollers


      if (axes.x) {
        for (var i = 0; i < this.xScrollers.length; i++) {
          this.xScrollers[i].addPartner(otherScroller.xScrollers[i], 'x');
        }
      } // We are the only Y scroller


      if (axes.y) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(GridScroller.prototype), "addPartner", this).call(this, otherScroller, 'y');
      }
    }
  }, {
    key: "updateOverflowX",
    value: function updateOverflowX(overflowX) {
      this.xScrollers && this.xScrollers.forEach(function (s) {
        return s.overflowX = overflowX;
      });
      this.widget.virtualScrollers.classList[overflowX === false ? 'add' : 'remove']('b-hide-display');
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(element, options) {
      // If we are after an element, we have to ask the scroller of the SubGrid
      // that the element is in. It will do the X scrolling and delegate the Y
      // scrolling up to this GridScroller.
      if (element.nodeType === 1) {
        var _iterator = _createForOfIteratorHelper(this.xScrollers),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var subGridScroller = _step.value;

            if (subGridScroller.element.contains(element)) {
              return subGridScroller.scrollIntoView(element, options);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(GridScroller.prototype), "scrollIntoView", this).call(this, element, options);
      }
    }
  }, {
    key: "x",
    set: function set(x) {
      if (this.xScrollers) {
        this.xScrollers[0].x = x;
      }
    },
    get: function get() {
      // when trying to scroll grid with no columns xScrollers do not exist
      return this.xScrollers ? this.xScrollers[0].x : 0;
    }
  }]);

  return GridScroller;
}(_Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_21__["default"]);


GridScroller._$name = 'GridScroller';

/***/ }),

/***/ "./lib/Grid/util/ScrollManager.js":
/*!****************************************!*\
  !*** ./lib/Grid/util/ScrollManager.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScrollManager; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/util/ScrollManager
 */

/**
 * Monitors the mouse position over an element and scrolls the element if the cursor is close to edges. This is used by
 * various features to scroll the grid section element, for example dragging rows close to vertical edges.
 * Normally you should not need to interact with this class directly, but you can configure its
 * behavior using the {@link Grid.view.Grid#config-scrollManager} config.
 */

var ScrollManager = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(ScrollManager, _Delayable);

  var _super = _createSuper(ScrollManager);

  function ScrollManager() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ScrollManager);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(ScrollManager, [{
    key: "startMonitoring",
    //endregion
    //region Start/stop monitoring

    /**
     * Starts monitoring an element. It will be scrolled if mouse is pressed and within zoneWidth pixels from element edge.
     * @param {HTMLElement|Object} elementOrConfig Element which might be scrolled or config { element, callback, thisObj }
     * @internal
     */
    value: function startMonitoring(elementOrConfig) {
      var me = this,
          config = elementOrConfig instanceof HTMLElement ? {
        element: elementOrConfig
      } : elementOrConfig,
          element = config.element,
          verticalElement = config.verticalElement || me.verticalElement || element; // only interested in elements that exists and are scrollable

      if (element && (element.scrollWidth > element.offsetWidth || verticalElement.scrollHeight > verticalElement.offsetHeight)) {
        // already monitoring, bail out
        if (me.monitoring.find(function (m) {
          return m.element === element;
        })) return;
        config.direction = config.direction || me.direction; // store some stuff needed later

        Object.assign(config, {
          verticalElement: verticalElement,
          scrollManager: me,
          startScrollLeft: element.scrollLeft,
          startScrollTop: verticalElement.scrollTop,
          scrollLeft: element.scrollLeft,
          scrollTop: verticalElement.scrollTop,
          scrollRelativeLeft: 0,
          scrollRelativeTop: 0
        });
        var handler = me.onMouseMove.bind(config); // listen to mousemove to determine if scroll needed or not

        me.mouseMoveDetacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
          mousemove: handler,
          touchmove: handler,
          mouseleave: function mouseleave() {
            return me.clearTimeout(me.scrollTimeout);
          },
          element: element
        }); // Cache scrollWidth because it may actually change in Edge and allow scrolling to empty space when creating
        // dependency

        config.scrollWidth = element.scrollWidth;
        me.monitoring.push(config);
      }
    }
    /**
     * Stops monitoring an element.
     * @param {HTMLElement} element Element for which monitoring is not desired any more and should stop as soon as possible. Preferably right away, but no later than on next frame :)
     * @internal
     */

  }, {
    key: "stopMonitoring",
    value: function stopMonitoring(element) {
      var me = this,
          config = me.monitoring.find(function (m) {
        return m.element === element;
      }); // cant stop nothing...

      if (!config) return;
      me.stopScroll(config);
      me.mouseMoveDetacher && me.mouseMoveDetacher();
      me.monitoring.splice(me.monitoring.indexOf(config), 1);
    } //endregion
    //region Internals

    /**
     * Starts scrolling (see #performScroll). Called from onMouseMove.
     * @private
     * @param {Object} config Config object
     */

  }, {
    key: "startScroll",
    value: function startScroll(config) {
      config.scrolling = true;
      this.performScroll(config);
    }
    /**
     * Stops scrolling. Called from onMouseMove.
     * @private
     * @param {Object} config
     */

  }, {
    key: "stopScroll",
    value: function stopScroll(config) {
      var me = this;
      config.scrolling = false;

      if (config.scrollRequested) {
        me.cancelAnimationFrame(config.frameId);
        config.scrollRequested = false;
      }

      me.clearTimeout(me.scrollTimeout);
      me.scrollTimeout = null;
    }
    /**
     * Scrolls by an amount determined by config.scrollDeltaX/Y on each frame. Start/stop by calling #startScroll and
     * #stopScroll.
     * @private
     * @param {Object} config Config object
     */

  }, {
    key: "performScroll",
    value: function performScroll(config) {
      var _this = this;

      // this function is called repeatedly on each frame for as long as scrolling is needed
      // check that scrolling is needed
      if (config.scrolling && !config.scrollRequested) {
        var element = config.element,
            vertical = config.verticalElement; // scroll the determined amount of pixels

        if (config.scrollDeltaX !== 0) {
          config.scrollLeft += config.scrollDeltaX; // limit to element edges

          config.scrollLeft = Math.max(Math.min(config.scrollLeft, config.scrollWidth - element.clientWidth), 0);
          config.scrollRelativeLeft = config.scrollLeft - config.startScrollLeft;
          element.scrollLeft = config.scrollLeft;
        }

        if (config.scrollDeltaY !== 0) {
          config.scrollTop += config.scrollDeltaY; // limit to element edges

          config.scrollTop = Math.max(Math.min(config.scrollTop, vertical.scrollHeight - vertical.clientHeight), 0);
          config.scrollRelativeTop = config.scrollTop - config.startScrollTop;
          vertical.scrollTop = config.scrollTop;
        } // call callback if scrolled in any direction


        if ((config.scrollRelativeLeft !== 0 || config.scrollRelativeTop !== 0) && config.callback) {
          config.callback.call(config.thisObj || this, config);
        } // scroll some more on next frame


        config.scrollRequested = true;
        config.frameId = this.requestAnimationFrame(function () {
          config.scrollRequested = false;

          _this.performScroll(config);
        });
      }
    }
    /**
     * Listener for mouse move on monitored element. Determines if scrolling is needed, and if so how fast to scroll.
     * See #zoneWidth & #scrollSpeed configs.
     * @private
     * @param {MouseEvent} event
     */

  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      var config = this,
          me = config.scrollManager,
          element = config.element,
          vertical = config.verticalElement,
          box = element.getBoundingClientRect(),
          vbox = vertical.getBoundingClientRect(),
          width = me.zoneWidth,
          speed = me.scrollSpeed; // scroll left or right?

      config.scrollDeltaX = 0;

      if (config.direction !== 'vertical') {
        if (event.clientX > box.right - width) {
          config.scrollDeltaX = Math.round((width - (box.right - event.clientX)) / speed) + 1;
        } else if (event.clientX < box.left + width) {
          config.scrollDeltaX = -Math.round((width + (box.left - event.clientX)) / speed) - 1;
        }
      } // scroll up or down?


      config.scrollDeltaY = 0;

      if (config.direction !== 'horizontal') {
        if (event.clientY > vbox.bottom - width) {
          config.scrollDeltaY = Math.round((width - (vbox.bottom - event.clientY)) / speed) + 1;
        } else if (event.clientY < vbox.top + width) {
          config.scrollDeltaY = -Math.round((width + (vbox.top - event.clientY)) / speed) - 1;
        }
      }

      if (config.scrollDeltaX === 0 && config.scrollDeltaY === 0) {
        me.stopScroll(config);
      } else if (!me.scrollTimeout) {
        me.scrollTimeout = me.setTimeout(function () {
          return me.startScroll(config);
        }, me.startScrollDelay);
      }
    } //endregion

  }], [{
    key: "defaultConfig",
    //region Default config
    get: function get() {
      return {
        /**
         * Width in pixels of the area at the edges of an element where scrolling should be triggered
         * @config {Number}
         * @default
         */
        zoneWidth: 50,

        /**
         * Scroll speed, higher number is slower. Calculated as "distance from zone edge / scrollSpeed"
         * @config {Number}
         * @default
         */
        scrollSpeed: 5,

        /**
         * Default element to use for vertical scrolling. Can be overridden in calls to `startMonitoring()`.
         * @internal
         * @config {HTMLElement}
         */
        verticalElement: null,

        /**
         * The direction(s) to scroll ('horizontal', 'vertical' or 'both')
         * @config {String}
         */
        direction: 'both',
        monitoring: [],

        /**
         * Number of milliseconds to wait before scroll starts when the mouse is moved close to an edge monitored by this scroll manager
         * @config {Number}
         * @default
         */
        startScrollDelay: 500,
        testConfig: {
          scrollSpeed: 2,
          startScrollDelay: 0
        }
      };
    }
  }]);

  return ScrollManager;
}(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_13__["default"])(_Core_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]));


ScrollManager._$name = 'ScrollManager';

/***/ }),

/***/ "./lib/Grid/util/SubGridScroller.js":
/*!******************************************!*\
  !*** ./lib/Grid/util/SubGridScroller.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SubGridScroller; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Grid/util/SubGridScroller
*/




var immediatePromise = Promise.resolve(),
    defaultScrollOptions = {
  block: 'nearest'
};
/**
 * A Scroller subclass which handles scrolling in a SubGrid. Needs special treatment since the SubGrid itself only
 * allows horizontal scrolling, while the vertical scrolling is done by an outer element containing all subgrids.
 *
 * @internal
 */

var SubGridScroller = /*#__PURE__*/function (_Scroller) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(SubGridScroller, _Scroller);

  var _super = _createSuper(SubGridScroller);

  function SubGridScroller() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, SubGridScroller);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(SubGridScroller, [{
    key: "scrollIntoView",
    value: function scrollIntoView(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;

      var me = this,
          _me$getDeltaTo = me.getDeltaTo(element, options),
          xDelta = _me$getDeltaTo.xDelta,
          yDelta = _me$getDeltaTo.yDelta,
          result = xDelta || yDelta ? me.scrollBy(xDelta, yDelta, options) : immediatePromise;

      if (options.highlight || options.focus) {
        result.then(function () {
          if (options.highlight) {
            if (element instanceof _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"]) {
              element.translate(-xDelta, -yDelta).highlight();
            } else {
              _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].highlight(element);
            }
          }

          options.focus && element.focus && element.focus();
        });
      }

      return result;
    }
  }, {
    key: "scrollBy",
    value: function scrollBy(xDelta, yDelta, options) {
      var yPromise = yDelta && this.yScroller.scrollBy(0, yDelta, options),
          xPromise = xDelta && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(SubGridScroller.prototype), "scrollBy", this).call(this, xDelta, 0, options);

      if (xPromise && xPromise.cancel && yPromise && yPromise.cancel) {
        var cancelX = xPromise.cancel,
            cancelY = yPromise.cancel; // Set up cross canceling

        xPromise.cancel = yPromise.cancel = function () {
          cancelX();
          cancelY();
        };

        return Promise.all([xPromise, yPromise]);
      }

      return xPromise || yPromise || immediatePromise;
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(toX, toY, options) {
      var yPromise = toY != null && this.yScroller.scrollTo(null, toY, options),
          xPromise = toX != null && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(SubGridScroller.prototype), "scrollTo", this).call(this, toX, null, options); // Keep parters in sync immediately unless we are going to animate our position.
      // There are potentially three: The header, the footer and the docked fake horizontal scroller.
      // It will be more efficient and maintain correct state doing it now.


      if (!(options && options.animate)) {
        this.syncPartners();
      }

      if (xPromise && xPromise.cancel && yPromise && yPromise.cancel) {
        var cancelX = xPromise.cancel,
            cancelY = yPromise.cancel; // Set up cross canceling

        xPromise.cancel = yPromise.cancel = function () {
          cancelX();
          cancelY();
        };

        return Promise.all([xPromise, yPromise]);
      }

      return xPromise || yPromise || immediatePromise;
    }
  }, {
    key: "viewport",
    get: function get() {
      var elementBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(this.element),
          viewport = elementBounds.intersect(_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(this.yScroller.element)); // For 0 height subgrids, viewport will be `false` but we still expect a Rectangle to be returned

      return viewport || new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"](elementBounds.x, elementBounds.y, elementBounds.width, 0);
    }
  }, {
    key: "y",
    set: function set(y) {
      if (this.yScroller) {
        this.yScroller.y = y;
      }
    },
    get: function get() {
      return this.yScroller ? this.yScroller.y : 0;
    }
  }, {
    key: "maxY",
    get: function get() {
      return this.yScroller ? this.yScroller.maxY : 0;
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      return this.yScroller ? this.yScroller.scrollHeight : 0;
    }
  }, {
    key: "clientHeight",
    get: function get() {
      return this.yScroller ? this.yScroller.clientHeight : 0;
    }
  }]);

  return SubGridScroller;
}(_Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


SubGridScroller._$name = 'SubGridScroller';

/***/ }),

/***/ "./lib/Grid/util/TableExporter.js":
/*!****************************************!*\
  !*** ./lib/Grid/util/TableExporter.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TableExporter; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.repeat */ "./node_modules/core-js/modules/es.string.repeat.js");
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/util/TableExporter
 */

/**
 * This class transforms grid component into two arrays: rows and columns. Columns array contains objects with
 * meta information about column: field name, column name, width and type of the rendered value, rows array contains
 * arrays of cell values.
 *
 * ```javascript
 * const exporter = new TableExporter({ target : grid });
 * exporter.export()
 *
 * // Output
 * {
 *     columns : [
 *         { field : 'name',     value : 'First name', type : 'string',  width : 100 },
 *         { field : 'surname',  value : 'Last name',  type : 'string',  width : 100 },
 *         { field : 'age',      value : 'Age',        type : 'number',  width : 50  },
 *         { field : 'married',  value : 'Married',    type : 'boolean', width : 50  },
 *         { field : 'children', value : 'Children',   type : 'object',  width : 100 }
 *     ],
 *     rows : [
 *         ['Michael', 'Scott',   40, false, []],
 *         ['Jim',     'Halpert', 30, true,  [...]]
 *     ]
 * }
 * ```
 *
 * ## How data is exported
 *
 * Exporter iterates over store records and processes each record for each column being exported. Exporter uses same
 * approach to retrieve data as column: reading record field, configured on the column, or calling renderer function
 * if one is provided. This means data can be of any type: primitives or objects. So children array in the above code
 * snippet may contain instances of child record class.
 *
 * ## Column renderers
 *
 * Column renderers are commonly used to style the cell, or even render more HTML into it, like {@link Grid.column.WidgetColumn}
 * does. This is not applicable in case of export. Also, given grid uses virtual rendering (only renders visible rows) and
 * exporter iterates over all records, not just visible ones, we cannot provide all data necessary to the renderer. Some
 * arguments, like cellElement and row, wouldn't exist. Thus renderer is called with as much data we have: value,
 * record, column, grid, other {@link Grid.column.Column#config-renderer documented arguments} would be undefined.
 *
 * Exporter adds one more flag for renderer function: isExport. When renderer receives this flag it knows
 * data is being exported and can skip DOM work to return simpler value. Below snippet shows simplified code of the
 * widget column handling export:
 *
 * ```javascript
 * renderer({ isExport }) {
 *     if (isExport) {
 *         return null;
 *     }
 *     else {
 *         // widget rendering routine
 *         ...
 *     }
 * }
 * ```
 *
 * ## Column types
 *
 * Column types are not actually a complete list of JavaScript types (you can get actual type of the cell using typeof) it
 * is a simple and helpful meta information.
 *
 * Available column types are:
 *  * string
 *  * number
 *  * boolean
 *  * date
 *  * object
 *
 * Everything which is not primitive like string/number/bool (or a date) is considered an object. This includes null, undefined,
 * arrays, classes, functions etc.
 *
 * ## Getting column type
 *
 * If existing grid column is used, column type first would be checked with {@link Grid.column.Column#config-exportedType exportedType}
 * config. If exportedType is undefined or column does not exist in grid, type is read from a record field definition.
 * If the field is not defined, object type is used.
 *
 * Configuring exported type:
 *
 * ```javascript
 * new Grid({
 *     columns : [
 *         {
 *             name         : 'Name',
 *             field        : 'name',
 *             exportedType : 'object',
 *             renderer     : ({ value, isExport }) => {
 *                 if (isExport) {
 *                     return { value }; // return value wrapped into object
 *                 }
 *             }
 *     ]
 * })
 * ```
 *
 * @extends Core/Base
 */

var TableExporter = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(TableExporter, _Base);

  var _super = _createSuper(TableExporter);

  function TableExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, TableExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(TableExporter, [{
    key: "export",

    /**
     * Exports grid data according to provided config
     * @param {Object} config
     * @returns {{ rows : Object[][], columns : Object[] }}
     */
    value: function _export() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this;
      config = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].assign({}, me.config, config);
      me.normalizeColumns(config);
      return me.generateExportData(config);
    }
  }, {
    key: "generateExportData",
    value: function generateExportData(config) {
      var me = this,
          columns = me.generateColumns(config),
          rows = me.generateRows(config);
      return {
        rows: rows,
        columns: columns
      };
    }
  }, {
    key: "normalizeColumns",
    value: function normalizeColumns(config) {
      var _this = this;

      // In case columns are provided we need to use normalized config. If those are not provided, we are going
      // to use real columns, possible invoking renderers (we need to pass column instance to the renderer to
      // avoid breaking API too much)
      var columns = config.columns || this.target.columns.visibleColumns.filter(function (rec) {
        return rec.exportable !== false;
      });
      config.columns = columns.map(function (col) {
        if (typeof col === 'string') {
          return _this.target.columns.find(function (column) {
            return column.field === col;
          }) || {
            field: col
          };
        } else {
          return col;
        }
      });
    }
  }, {
    key: "generateColumns",
    value: function generateColumns(config) {
      var _this2 = this;

      return config.columns.map(function (col) {
        return _this2.processColumn(col, config);
      });
    }
  }, {
    key: "generateRows",
    value: function generateRows(config) {
      var columns = config.columns;

      if (!columns.length) {
        return [];
      }

      var me = this,
          target = me.target;
      return target.store // although columns are taken from config, it is convenient to provide them as a separate argument
      // becuase that allows to override set of columns to process
      .map(function (record) {
        return me.processRecord(record, columns, config);
      }) // filter out empty rows
      .filter(function (cells) {
        return cells.length;
      });
    }
  }, {
    key: "getColumnType",
    value: function getColumnType(column) {
      var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.target.store;
      var result = column.exportedType || 'object';

      if (column.exportedType === undefined) {
        if (column.field) {
          var fieldDefinition = store.modelClass.getFieldDefinition(column.field);

          if (fieldDefinition && fieldDefinition.type !== 'auto') {
            result = fieldDefinition.type;
          }
        }
      }

      return result;
    }
    /**
     * Extracts export data from the column instance
     * @param {Column} column
     * @param {Object} config
     * @private
     * @returns {Object}
     */

  }, {
    key: "processColumn",
    value: function processColumn(column, config) {
      var me = this,
          target = me.target,
          defaultColumnWidth = config.defaultColumnWidth;
      var field = column.field,
          value = column.text,
          width = column.width,
          minWidth = column.minWidth; // If column is not configured with field, field is generated (see Column.js around line 514).
      // In export we want empty string there

      if (!(field in target.store.modelClass.fieldMap)) {
        field = '';
      } // If name or width is missing try to retrieve them from the grid column and the field, or use default values.


      if (!value || !width) {
        var gridColumn = target.columns.find(function (col) {
          return col.field === field;
        });

        if (!value) {
          value = gridColumn && gridColumn.text || field;
        } // null or undefined


        if (width == null) {
          width = gridColumn && gridColumn.width || defaultColumnWidth;
        }
      }

      width = Math.max(width || defaultColumnWidth, minWidth || defaultColumnWidth);
      return {
        field: field,
        value: value,
        width: width,
        type: me.getColumnType(column)
      };
    }
    /**
     * Extracts export data from the record instance reading supplied column configs
     * @param {Model|null} record If null is passed, all columns will be filled with empty strings
     * @param {Column[]} columns
     * @param {Object} config
     * @private
     * @returns {Object[]}
     */

  }, {
    key: "processRecord",
    value: function processRecord(record, columns, config) {
      var target = this.target,
          showGroupHeader = config.showGroupHeader,
          indent = config.indent,
          indentationSymbol = config.indentationSymbol;
      var cells;

      if (!record) {
        cells = columns.map(function () {
          return '';
        });
      } else if (record.isSpecialRow) {
        if (showGroupHeader && record.meta.groupRowFor) {
          cells = columns.map(function (column) {
            return target.features.group.buildGroupHeader({
              // Create dummy element to get html from
              cellElement: _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].createElement(),
              grid: target,
              record: record,
              column: column
            });
          });
        }
      } else {
        cells = columns.map(function (column) {
          var value = record[column.field],
              useRenderer = column.renderer || column.defaultRenderer;

          if (useRenderer && !(value && column.isDateColumn && config.exportDateAsInstance)) {
            value = useRenderer.call(column, {
              value: value,
              record: record,
              column: column,
              grid: target,
              isExport: true
            });
          }

          if (indent && column.tree) {
            value = "".concat(indentationSymbol.repeat(record.childLevel)).concat(value);
          }

          return value;
        });
      }

      return cells;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Target grid instance to export data from
         * @config {Grid} target
         */
        target: null,

        /**
         * Specifies a default column width if no width specified
         * @config {Number} defaultColumnWidth
         * @default
         */
        defaultColumnWidth: 100,

        /**
         * Set to false to export date as it is displayed by Date column formatter
         * @config {Boolean}
         * @default
         */
        exportDateAsInstance: true,

        /**
         * If true and the grid is grouped, shows the grouped value in the first column. True by default.
         * @config {Boolean} showGroupHeader
         * @default
         */
        showGroupHeader: true,

        /**
         * An array of columns configuration used to specify columns width, headers name, and column fields to get the data from.
         * 'field' config is required. If 'text' is missing, it will try to get it retrieved from the grid column or the 'field' config.
         * If 'width' is missing, it will try to get it retrieved from the grid column or {@link #config-defaultColumnWidth} config.
         * If no columns provided the config will be generated from the grid columns.
         *
         * For example:
         * ```javascript
         * columns : [
         *     'firstName', // field
         *     'age', // field
         *     { text : 'Starts', field : 'start', width : 140 },
         *     { text : 'Ends', field : 'finish', width : 140 }
         * ]
         * ```
         *
         * @config {String[]|Object[]} columns
         * @default
         */
        columns: null,

        /**
         * When true and tree is being exported, node names are indented with {@link #config-indentationSymbol}
         * @config {Boolean}
         * @default
         */
        indent: true,

        /**
         * This symbol (four spaces by default) is used to indent node names when {@link #config-indent} is true
         * @config {String}
         * @default
         */
        indentationSymbol: "\xA0\xA0\xA0\xA0"
      };
    }
  }]);

  return TableExporter;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_14__["default"]);


TableExporter._$name = 'TableExporter';

/***/ }),

/***/ "./lib/Grid/view/Bar.js":
/*!******************************!*\
  !*** ./lib/Grid/view/Bar.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Bar; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/view/Bar
 */

/**
 * Base class used by Header and Footer. Holds an element for each column. Not intended to be used directly.
 *
 * @extends Core/widget/Widget
 * @internal
 * @abstract
 */

var Bar = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Bar, _Widget);

  var _super = _createSuper(Bar);

  function Bar() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Bar);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Bar, [{
    key: "fixCellWidths",
    //endregion

    /**
     * Fix cell widths (flex or fixed width) after rendering.
     * Not a part of template any longer because of CSP
     * @private
     */
    value: function fixCellWidths() {
      var me = this;
      var hasFlex = false,
          flexBasis; // single header "cell"

      me.columns.traverse(function (column) {
        var cellEl = me.getBarCellElement(column.id),
            domWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].setLength(column.width),
            domMinWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].setLength(column.minWidth);

        if (cellEl) {
          // We have to work round the IE11 bug that flex-basis affects the content-box
          // and any padding is added as extra.
          // TODO: Remove  this when IE11 retires.
          if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isIE11) {
            flexBasis = "calc(".concat(domWidth, " - ").concat(me.getLrPadding(cellEl), "px)");
          } else {
            flexBasis = domWidth;
          }

          hasFlex = hasFlex || Boolean(column.flex); // Parent column without any specified width and flex should have flex calculated if any child has flex

          if (column.isParent && column.width == null && column.flex == null) {
            var flex = column.children.reduce(function (result, child) {
              return result += !child.hidden && child.flex || 0;
            }, 0); // Do not want to store this flex value on the column since it is always calculated

            cellEl.style.flex = flex > 0 ? "".concat(flex, " 0 auto") : '';

            if (flex > 0) {
              // TODO: Figure out a better way of handling this, minWidth on the columns breaks the flexbox
              //  calculation compared to cells, making them misalign
              column.traverse(function (col) {
                return col.data.minWidth = null;
              });
            }
          } // Normal case, set flex, width etc.
          else {
              if (parseInt(column.minWidth) >= 0) {
                cellEl.style.minWidth = domMinWidth;
              } // Clear all the things we might have to set to correct cell widths


              cellEl.style.flex = cellEl.style.flexBasis = cellEl.style.width = '';

              if (column.flex) {
                // If column has children we need to give it
                // flex-shrink: 0, flex-basis: auto so that it always
                // shrinkwraps its children without shrinking
                if (!isNaN(parseInt(column.flex)) && column.children) {
                  cellEl.style.flex = "".concat(column.flex, " 0 auto");
                } else {
                  cellEl.style.flex = column.flex;
                }
              } else if (parseInt(column.width) >= 0) {
                var parent = column.parent; // Only grid header bar has a notion of group headers
                // Column is a child of an unwidthed group. We have to use width
                // to stretch it.

                if (me.isHeader && !parent.isRoot && !parent.width) {
                  cellEl.style.width = domWidth;
                } else {
                  // https://app.assembla.com/spaces/bryntum/tickets/8041
                  // Column header widths must be set using flex-basis.
                  // Using width means that wide widths cause a flexed SubGrid
                  // to bust the flex rules.
                  // TODO: When IE11 retires, remove calc() hacks to overcome its flexbox bugs.
                  // Note that grid in Grid#onColumnsResized and SubGrid#fixCellWidths,
                  // cells MUST still be sized using width since rows
                  // are absolutely positioned and will not cause the busting out
                  // problem, and rows will not stretch to shrinkwrap the cells
                  // unless they are widthed with width.
                  cellEl.style.flexBasis = flexBasis;
                }
              }
            }

          if (column.height >= 0) {
            cellEl.style.height = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].setLength(column.height);
          }
        }
      });
      me.element.classList[hasFlex ? 'add' : 'remove']('b-has-flex');
    }
  }, {
    key: "getLrPadding",
    value: function getLrPadding(cellEl) {
      if (!this.cellLrPadding) {
        var s = cellEl.ownerDocument.defaultView.getComputedStyle(cellEl);
        this.cellLrPadding = parseInt(s.getPropertyValue('padding-left')) + parseInt(s.getPropertyValue('padding-right')) + parseInt(s.getPropertyValue('border-left-width')) + parseInt(s.getPropertyValue('border-right-width'));
      }

      return this.cellLrPadding;
    }
    /**
     * Get the header or footer cell element for the specified column.
     * @param {String} columnId Column id
     * @returns {HTMLElement} Header or footer element, depending on which subclass is in use.
     * @private
     */

  }, {
    key: "getBarCellElement",
    value: function getBarCellElement(columnId) {
      return this.element.querySelector("[data-column-id=\"".concat(columnId, "\"]"));
    }
  }, {
    key: "columns",
    //region Init
    get: function get() {
      return this._columns || this.subGrid.columns;
    } // Only needed for tests which create standalone Headers with no owning SubGrid.
    ,
    set: function set(columns) {
      this._columns = columns;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'Bar';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'gridbar';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        htmlCls: '',
        scrollable: {} // We need a scroller, but no dimensions scroll by default

      };
    }
  }]);

  return Bar;
}(_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_10__["default"]); // Register this widget type with its Factory



Bar.initClass();
Bar._$name = 'Bar';

/***/ }),

/***/ "./lib/Grid/view/Footer.js":
/*!*********************************!*\
  !*** ./lib/Grid/view/Footer.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Footer; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Bar_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Bar.js */ "./lib/Grid/view/Bar.js");













function _templateObject2() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5___default()(["\n                <div\n                    class=\"b-grid-footer ", " ", "\"\n                    data-column=\"", "\" data-column-id=\"", "\" data-all-index=\"", "\"\n                    >\n                    ", "\n                </div>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5___default()(["\n            <div class=\"b-grid-footer-scroller b-grid-footer-scroller-", "\">\n                <div data-reference=\"footersElement\" class=\"b-grid-footers b-grid-footers-", "\" data-region=\"", "\"></div>\n            </div>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

 //import styles from '../../../resources/sass/grid/view/footer.scss';

/**
 * @module Grid/view/Footer
 */

/**
 * Grid footer, used by Summary feature. You should not need to create instances manually.
 *
 * @extends Grid/view/Bar
 * @internal
 */

var Footer = /*#__PURE__*/function (_Bar) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Footer, _Bar);

  var _super = _createSuper(Footer);

  function Footer() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Footer);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Footer, [{
    key: "startConfigure",
    value: function startConfigure(config) {
      config.scrollable.overflowX = 'hidden-scroll';

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Footer.prototype), "startConfigure", this).call(this, config);
    }
  }, {
    key: "refreshContent",
    value: function refreshContent() {
      this.element.firstElementChild.innerHTML = this.contentTemplate();
      this.fixFooterWidths();
    }
  }, {
    key: "onPaint",
    value: function onPaint(_ref) {
      var firstPaint = _ref.firstPaint;

      if (firstPaint) {
        this.refreshContent();
      }
    }
  }, {
    key: "template",
    value: function template() {
      var region = this.subGrid.region;
      return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].tpl(_templateObject(), region, region, region);
    }
  }, {
    key: "getFooter",
    //region Getters

    /**
     * Get the footer cell element for the specified column.
     * @param {String} columnId Column id
     * @returns {HTMLElement} Footer cell element
     */
    value: function getFooter(columnId) {
      return this.getBarCellElement(columnId);
    } //endregion

    /**
     * Footer template. Iterates leaf columns to create content.
     * Style not included because of CSP. Widths are fixed up in
     * {@link #function-fixFooterWidths}
     * @private
     */

  }, {
    key: "contentTemplate",
    value: function contentTemplate() {
      var me = this;
      return me.columns.visibleColumns.map(function (column) {
        return column.hidden ? '' : _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].tpl(_templateObject2(), column.align ? "b-grid-footer-align-".concat(column.align) : '', column.cls || '', column.field || '', column.id, column.allIndex, column.footerText || '');
      }).join('');
    }
    /**
     * Fix footer widths (flex or fixed width) after rendering. Not a part of template any longer because of CSP
     * @private
     */

  }, {
    key: "fixFooterWidths",
    value: function fixFooterWidths() {
      this.fixCellWidths();
    }
  }, {
    key: "subGrid",
    get: function get() {
      return this._subGrid;
    },
    set: function set(subGrid) {
      this._subGrid = this.owner = subGrid;
    }
  }, {
    key: "overflowElement",
    get: function get() {
      return this.footersElement;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'Footer';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'gridfooter';
    }
  }]);

  return Footer;
}(_Bar_js__WEBPACK_IMPORTED_MODULE_13__["default"]); // Register this widget type with its Factory



Footer.initClass();
Footer._$name = 'Footer';

/***/ }),

/***/ "./lib/Grid/view/Grid.js":
/*!*******************************!*\
  !*** ./lib/Grid/view/Grid.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Grid; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _GridBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./GridBase.js */ "./lib/Grid/view/GridBase.js");
/* harmony import */ var _feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../feature/CellEdit.js */ "./lib/Grid/feature/CellEdit.js");
/* harmony import */ var _feature_ColumnAutoWidth_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../feature/ColumnAutoWidth.js */ "./lib/Grid/feature/ColumnAutoWidth.js");
/* harmony import */ var _feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../feature/ColumnDragToolbar.js */ "./lib/Grid/feature/ColumnDragToolbar.js");
/* harmony import */ var _feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../feature/ColumnPicker.js */ "./lib/Grid/feature/ColumnPicker.js");
/* harmony import */ var _feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../feature/ColumnReorder.js */ "./lib/Grid/feature/ColumnReorder.js");
/* harmony import */ var _feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../feature/ColumnResize.js */ "./lib/Grid/feature/ColumnResize.js");
/* harmony import */ var _feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../feature/ContextMenu.js */ "./lib/Grid/feature/ContextMenu.js");
/* harmony import */ var _feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../feature/CellMenu.js */ "./lib/Grid/feature/CellMenu.js");
/* harmony import */ var _feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony import */ var _feature_Filter_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../feature/Filter.js */ "./lib/Grid/feature/Filter.js");
/* harmony import */ var _feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../feature/FilterBar.js */ "./lib/Grid/feature/FilterBar.js");
/* harmony import */ var _feature_Group_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../feature/Group.js */ "./lib/Grid/feature/Group.js");
/* harmony import */ var _feature_Sort_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../feature/Sort.js */ "./lib/Grid/feature/Sort.js");
/* harmony import */ var _feature_Stripe_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../feature/Stripe.js */ "./lib/Grid/feature/Stripe.js");
/* harmony import */ var _column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //region Import

 // import default features (might be able to skip this when draft on dynamic import is implemented)







 // TODO: 'contextMenu' is deprecated. Please see https://bryntum.com/docs/grid/#guides/upgrades/3.1.0.md for more information.







 // To enable using checkbox selection mode, moved here to not be dragged into GridBase automatically

 //endregion

/**
 * @module Grid/view/Grid
 */

/**
 * The Grid component is a very powerful and performant UI component that shows tabular data (or tree data using the {@link Grid.view.TreeGrid}).
 *
 * <h2>Intro</h2>
 * The Grid widget has a wide range of features and a large API to allow users to work with data efficiently in the browser. The two
 * most important configs are {@link #config-store} and {@link #config-columns}. With the store config, you decide which data to load into the grid.
 * You can work with both in-memory arrays or load data using ajax. See the {@link Core.data.Store} class to learn more about loading data into stores.
 *
 * The columns config accepts an array of {@link Grid.column.Column Column} descriptors defining which fields that will be displayed in the grid.
 * The {@link Grid.column.Column#config-field} property in the column descriptor maps to a field in your dataset. The simplest grid configured with inline data and two columns would
 * look like this:
 *
 *      let grid = new Grid({
 *          appendTo : document.body,
 *
 *          columns: [
 *              { field: 'name', text: 'Name' },
 *              { field: 'job', text: 'Job', renderer: ({value}) => value || 'Unemployed' }
 *          ],
 *
 *          data: [
 *              { name: 'Bill', job: 'Retired' },
 *              { name: 'Elon', job: 'Visionary' },
 *              { name: 'Me' }
 *          ]
 *      });
 *
 * {@inlineexample grid/Grid.js}
 * <h2>Features</h2>
 * To avoid the Grid core being bloated, its main features are implemented in separate ´feature´ classes. These can be turned on and off based
 * on your requirements. To configure (or disable) a feature, use the {@link #config-features} object to provide your desired configuration for the features
 * you want to use. Each feature has an ´id´ that you use as a key in the features object:
 *
 *      let grid = new Grid({
 *          appendTo : document.body,
 *
 *          features : {
 *              cellEdit     : false,
 *              regionResize : true,
 *              cellTooltip  : {
 *                  tooltipRenderer : (data) => {
 *                  }
 *              },
 *              ...
 *          }
 *      });
 *
 * {@region Column configuration options}
 * A grid contains a number of columns that control how your data is rendered. The simplest option is to simply point a Column to a field in your dataset, or define a custom {@link Grid.column.Column#config-renderer}.
 * The renderer function receives one object parameter containing rendering data for the current cell being rendered.
 *
 *      let grid = new Grid({
 *          appendTo : document.body,
 *
 *          columns: [
 *              {
 *                  field: 'task',
 *                  text: 'Task',
 *                  renderer: (renderData) => {
 *                      const record = renderData.record;
 *
 *                      if (record.percentDone === 100) {
 *                          renderData.cellElement.classList.add('taskDone');
 *                          renderData.cellElement.style.background = 'green';
 *                      }
 *
 *                      return renderData.value;
 *                  }
 *              }
 *          ]
 *      });
 *
 * {@endregion}
 * {@region Grid sections (aka "locked" or "frozen" columns)}
 * The grid can be divided horizontally into individually scrollable sections. This is great if you have lots of columns that
 * don't fit the available width of the screen. To enable this feature, simply mark the columns you want to `lock`.
 * Locked columns are then displayed in their own section to the left of the other columns:
 *
 *      let grid = new Grid({
 *          appendTo : document.body,
 *          width    : 500,
 *          subGridConfigs : {
 *              // set a fixed locked section width if desired
 *              locked : { width: 300 }
 *          },
 *          columns : [
 *              { field : 'name', text : 'Name', width : 200, locked : true },
 *              { field : 'firstName', text : 'First name', width : 100, locked : true },
 *              { field : 'surName', text : 'Last name', width : 100, locked : true },
 *              { field : 'city', text : 'City', width : 100 },
 *              { type : 'number', field : 'age', text : 'Age', width : 200 },
 *              { field : 'food', text : 'Food', width : 200 }
 *          ]
 *      });
 *
 * {@inlineexample grid/LockedGrid.js}
 * You can also move columns between sections by using drag and drop, or use the built-in header context menu. If you want to be able to resize the
 * locked grid section, enable the {@link Grid.feature.RegionResize regionResize} feature.
 * {@endregion}
 * {@region Filtering}
 * One important requirement of a good Grid component is the ability to filter large datasets to quickly find what you're looking for. To
 * enable filtering (through the context menu), add the {@link Grid.feature.Filter filter} feature:
 *
 *      let grid = new Grid({
 *          features: {
 *              filter: true
 *          }
 *      });
 *
 * Or activate a default filter at initial rendering:
 *
 *      let grid = new Grid({
 *          features: {
 *              filter: { property : 'city', value : 'New York' }
 *          }
 *      });
 *
 * {@inlineexample feature/Filter.js}
 * {@endregion}
 * {@region Tooltips}
 * If you have a data models with many fields, and you want to show
 * additional data when hovering over a cell, use the {@link Grid.feature.CellTooltip cellTooltip} feature. To show a tooltip for all cells:
 *
 *      let grid = new Grid({
 *          features: {
 *              cellTooltip: ({value}) => value
 *          }
 *      });
 *
 * {@inlineexample feature/CellTooltip.js}
 * {@endregion}
 * {@region Inline Editing (default <strong>on</strong>)}
 * To enable inline cell editing in the grid, simply add the {@link Grid.feature.CellEdit cellEdit} feature:
 *
 *      let grid = new Grid({
 *          appendTo : document.body,
 *
 *          features : {
 *              cellEdit : true
 *          },
 *          columns: [
 *              {
 *                  field: 'task',
 *                  text: 'Task'
 *              }
 *          ]
 *      });
 *
 * {@inlineexample feature/CellEdit.js}
 * {@endregion}
 * {@region Context Menu}
 * Use {@link Grid.feature.CellMenu CellMenu} and {@link Grid.feature.HeaderMenu HeaderMenu}
 * features if you want your users to be able to interact with the data through the context menu:
 *
 *      let grid = new Grid({
 *          features : {
 *              headerMenu : {
 *                  items : {
 *                      showInfo : {
 *                          text   : 'Show info',
 *                          icon   : 'fa fa-info-circle',
 *                          weight : 200,
 *                          onItem : ({ item }) => console.log(item.text)
 *                      }
 *                  }
 *              },
 *              cellMenu :  {
 *                  items : {
 *                      showOptions : {
 *                          text   : 'Show options',
 *                          icon   : 'fa fa-gear',
 *                          weight : 200
 *                      }
 *                  }
 *              }
 *          }
 *      });
 *
 * {@inlineexample feature/CellMenu.js}
 * {@endregion}
 * {@region Grouping}
 * To group rows by a field in your dataset, use the {@link Grid.feature.Group group} feature.
 * {@inlineexample feature/Group.js}
 * {@endregion}
 * {@region Searching}
 * When working with lots of data, a quick alternative to filtering is the {@link Grid.feature.Search search} feature. It highlights
 * matching values in the grid as you type.
 * {@inlineexample feature/Search.js}
 * {@endregion}
 * {@region Loading and saving data}
 * The grid keeps all its data in a {@link Core.data.Store}, which is essentially an Array of {@link Core.data.Model Model} items.
 * You define your own Model representing your data entities and use the Model API to get and set values.
 *
 *      class Person extends Model {}
 *
 *      let person = new Person({
 *          name: 'Steve',
 *          age: 38
 *      });
 *
 *      person.name = 'Linda'; // person object is now `dirty`
 *
 *      let store = new Store({
 *          data : [
 *              { name : 'Don', age : 40 }
 *          ]
 *      });
 *
 *      store.add(person);
 *
 *      console.log(store.count()); // === 2
 *
 *      store.remove(person); // Remove from store
 *
 * When you update a record in a store, it's considered dirty, until you call {@link Core.data.mixin.StoreCRUD#function-commit commit} on the containing Store. You can also configure your Store to commit automatically (like Google docs).
 * If you use an AjaxStore, it will send changes to your server when commit is called.
 * Any changes you make to the Store or its records are immediately reflected in the Grid, so there is no need to tell it to refresh manually.
 *
 * To learn more about loading and saving data, please refer to [this guide](#guides/data/displayingdata.md).
 * {@endregion}
 * {@region Default configs}
 * There is a myriad of configs and features available for Grid, some of them on by default and some of them requiring
 * extra configuration. The code below tries to illustrate the major things that are used by default:
 *
 * ```javascript
 * let grid = new Grid({
 *    // The following features are enabled by default:
 *    features : {
 *        cellEdit      : true,
 *        columnPicker  : true,
 *        columnReorder : true,
 *        columnResize  : true,
 *        cellMenu      : true,
 *        headerMenu    : true,
 *        group         : true,
 *        sort          : true
 *    },
 *
 *    animateRemovingRows       : true,  // Rows will slide out on removal
 *    autoHeight                : false, // Grid needs to have a height supplied through CSS (strongly recommended) or by specifying `height`
 *    columnLines               : true,  // Themes might override it to hide lines anyway
 *    emptyText                 : 'No rows to display',
 *    enableTextSelection       : false, // Not allowed to select text in cells by default,
 *    fillLastColumn            : true,  // By default the last column is stretched to fill the grid
 *    fullRowRefresh            : true,  // Refreshes entire row when a cell value changes
 *    loadMask                  : 'Loading...',
 *    resizeToFitIncludesHeader : true,  // Also measure header when auto resizing columns
 *    responsiveLevels : {
 *      small : 400,
 *      medium : 600,
 *      large : '*'
 *    },
 *    rowHeight                  : null,  // Determined using CSS, it will measure rowHeight
 *    showDirty                  : false, // No indicator for changed cells
 * });
 * ```
 * {@endregion}
 * {@region Performance}
 * In general the Grid widget has very good performance and you can try loading any amount of data in the <a target="_blank" href="../examples/bigdataset">bigdataset</a> demo.
 * The overall rendering performance is naturally affected by many other things than
 * the data volume. Other important factors that can impact performance: number of columns, complex cell renderers, locked columns, the number of features enabled
 * and of course the browser (Chrome fastest, IE slowest).
 * {@endregion}
 *
 * @extends Grid/view/GridBase
 * @classType grid
 */

var Grid = /*#__PURE__*/function (_GridBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Grid, _GridBase);

  var _super = _createSuper(Grid);

  function Grid() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Grid);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Grid, null, [{
    key: "$name",
    get: function get() {
      return 'Grid';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'grid';
    }
  }]);

  return Grid;
}(_GridBase_js__WEBPACK_IMPORTED_MODULE_8__["default"]); // Register this widget type with its Factory



Grid.initClass();
Grid._$name = 'Grid';

/***/ }),

/***/ "./lib/Grid/view/GridBase.js":
/*!***********************************!*\
  !*** ./lib/Grid/view/GridBase.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GridBase; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony import */ var _Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../../Core/widget/Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../../Core/mixin/Pluggable.js */ "./lib/Core/mixin/Pluggable.js");
/* harmony import */ var _Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../../Core/mixin/State.js */ "./lib/Core/mixin/State.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../data/GridRowModel.js */ "./lib/Grid/data/GridRowModel.js");
/* harmony import */ var _row_RowManager_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../row/RowManager.js */ "./lib/Grid/row/RowManager.js");
/* harmony import */ var _util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../util/ScrollManager.js */ "./lib/Grid/util/ScrollManager.js");
/* harmony import */ var _util_GridScroller_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../util/GridScroller.js */ "./lib/Grid/util/GridScroller.js");
/* harmony import */ var _Header_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./Header.js */ "./lib/Grid/view/Header.js");
/* harmony import */ var _Footer_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./Footer.js */ "./lib/Grid/view/Footer.js");
/* harmony import */ var _mixin_GridElementEvents_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./mixin/GridElementEvents.js */ "./lib/Grid/view/mixin/GridElementEvents.js");
/* harmony import */ var _mixin_GridFeatures_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./mixin/GridFeatures.js */ "./lib/Grid/view/mixin/GridFeatures.js");
/* harmony import */ var _mixin_GridNavigation_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./mixin/GridNavigation.js */ "./lib/Grid/view/mixin/GridNavigation.js");
/* harmony import */ var _mixin_GridResponsive_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./mixin/GridResponsive.js */ "./lib/Grid/view/mixin/GridResponsive.js");
/* harmony import */ var _mixin_GridSelection_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./mixin/GridSelection.js */ "./lib/Grid/view/mixin/GridSelection.js");
/* harmony import */ var _mixin_GridState_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./mixin/GridState.js */ "./lib/Grid/view/mixin/GridState.js");
/* harmony import */ var _mixin_GridSubGrids_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./mixin/GridSubGrids.js */ "./lib/Grid/view/mixin/GridSubGrids.js");
/* harmony import */ var _column_Column_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Grid/localization/En.js");
































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //region Import
































 // Needed since Grid now has its own localization

 //endregion

/**
 * @module Grid/view/GridBase
 */

var resolvedPromise = new Promise(function (resolve) {
  return resolve();
}),
    storeListenerName = 'GridBase:store',
    defaultScrollOptions = {
  block: 'nearest',
  inline: 'nearest'
},
    preserveScroll = {
  dataset: 1,
  filter: 1
};
/**
 * A thin base class for {@link Grid.view.Grid}. Does not include any features by default, allowing smaller custom built bundles if used
 * in place of {@link Grid.view.Grid}.
 *
 * **NOTE:** In most scenarios you probably want to use Grid instead of GridBase.

 * @extends Core/widget/Panel
 * @mixes Core/mixin/Events
 * @mixes Core/mixin/Pluggable
 * @mixes Core/mixin/State
 * @mixes Grid/view/mixin/GridElementEvents
 * @mixes Grid/view/mixin/GridFeatures
 * @mixes Grid/view/mixin/GridResponsive
 * @mixes Grid/view/mixin/GridSelection
 * @mixes Grid/view/mixin/GridState
 * @mixes Grid/view/mixin/GridSubGrids
 */

var GridBase = /*#__PURE__*/function (_Panel$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28___default()(GridBase, _Panel$mixin);

  var _super = _createSuper(GridBase);

  function GridBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, GridBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_26___default()(GridBase, [{
    key: "finishConfigure",
    //endregion
    //region Init-destroy
    value: function finishConfigure(config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "finishConfigure", this).call(this, config);

      me.scrollManager = new _util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_51__["default"](_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].assign({
        grid: me,
        // Horizontal scrolling might happen on different subgrids, but vertical is always on same element
        verticalElement: me.scrollable.element
      }, me.scrollManager)); // When locale is applied columns react and change, which triggers `change` event on columns store for each
      // changed column, and every change normally triggers rendering view. This overhead becomes noticeable with
      // larger amount of columns. So we set two listeners to locale events: prioritized listener to be executed first
      // and suspend renderContents method and unprioritized one to resume method and call it immediately.

      _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_45__["default"].on({
        locale: 'onBeforeLocaleChange',
        prio: 1,
        thisObj: me
      });
      _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_45__["default"].on({
        locale: 'onLocaleChange',
        prio: -1,
        thisObj: me
      });
      _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_44__["default"].on({
        theme: 'onThemeChange',
        thisObj: me
      });
      me.on({
        subGridExpand: 'onSubGridExpand',
        prio: -1,
        thisObj: me
      }); // Buffered for scrolling, to be called

      me.bufferedFixElementHeights = me.buffer('fixElementHeights', 350, me); // Add the extra grid classes to the element

      me.setGridClassList(me.element.classList);
    }
  }, {
    key: "updateEnableSticky",
    value: function updateEnableSticky(enableSticky) {
      this.positionMode = enableSticky ? 'position' : 'translate';
      this.element.classList[enableSticky ? 'add' : 'remove']('b-enable-sticky');
    }
  }, {
    key: "onSubGridExpand",
    value: function onSubGridExpand() {
      // Need to rerender all rows, because if the rows were rerendered (by adding a new column to another region for example)
      // while the region was collapsed, cells in the region will be empty.
      this.renderContents();
    }
  }, {
    key: "onBeforeLocaleChange",
    value: function onBeforeLocaleChange() {
      this._suspendRenderContentsOnColumnsChanged = true;
    }
  }, {
    key: "onLocaleChange",
    value: function onLocaleChange() {
      this._suspendRenderContentsOnColumnsChanged = false;

      if (this.isPainted) {
        this.renderContents();
      }
    }
  }, {
    key: "finalizeInit",
    value: function finalizeInit() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "finalizeInit", this).call(this);

      if (this.store.isLoading) {
        // Maybe show loadmask if store is already loading when grid is constructed
        this.onStoreBeforeRequest();
      }
    }
    /**
     * Cleanup
     * @private
     */

  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this;
      me.detachListeners(storeListenerName);

      for (var _i = 0, _Object$values = Object.values(me.features); _i < _Object$values.length; _i++) {
        var feature = _Object$values[_i];
        feature.destroy && feature.destroy();
      }

      if (me.columns) {
        me.columns = null;
      }

      if (me.store) {
        me.store = null;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "doDestroy", this).call(this);
    }
    /**
     * Adds extra classes to the Grid element after it's been configured.
     * Also iterates through features, thus ensuring they have been initialized.
     * @private
     */

  }, {
    key: "setGridClassList",
    value: function setGridClassList(classList) {
      var me = this;
      classList.add("b-grid-".concat(me.positionMode)); // TODO: enableTextSelection should be a setter, enabling toggling at any time

      if (!me.enableTextSelection) {
        classList.add('b-grid-notextselection');
      }

      if (me.autoHeight) {
        classList.add('b-autoheight');
      }

      if (me.fillLastColumn) {
        classList.add('b-fill-last-column');
      }

      if (me.showDirty) {
        classList.add('b-show-dirty');
      }

      for (var featureName in me.features) {
        var feature = me.features[featureName];
        var featureClass = void 0;

        if (Object.prototype.hasOwnProperty.call(feature.constructor, 'featureClass')) {
          featureClass = feature.constructor.featureClass;
        } else {
          featureClass = "b-".concat(feature instanceof _Core_Base_js__WEBPACK_IMPORTED_MODULE_31__["default"] ? feature.$$name : feature.constructor.name);
        }

        if (featureClass) {
          classList.add(featureClass.toLowerCase());
        }
      }
    } //endregion
    //region Functions & events injected by features
    // For documentation & typings purposes
    //region Feature events

    /**
     * *Only when the {@link Grid.feature.Tree} feature is enabled*.
     * <p>Fired before a record toggles its collapsed state.
     * @event beforeToggleNode
     * @param {Core.data.Model} record The record being toggled.
     * @param {Boolean} collapse `true` if the node is being collapsed.
     */

    /**
     * *Only when the {@link Grid.feature.Tree} feature is enabled*.
     * <p>Fired after a record has been collapsed.
     * @event collapseNode
     * @param {Core.data.Model} record The record which has been collapsed.
     */

    /**
     * *Only when the {@link Grid.feature.Tree} feature is enabled*.
     * <p>Fired after a record has been expanded.
     * @event expandNode
     * @param {Core.data.Model} record The record which has been expanded.
     */

    /**
     * *Only when the {@link Grid.feature.Tree} feature is enabled*.
     * <p>Fired after a record toggles its collapsed state.
     * @event toggleNode
     * @param {Core.data.Model} record The record being toggled.
     * @param {Boolean} collapse `true` if the node is being collapsed.
     */
    //endregion

    /**
     * Collapse all groups/parent nodes.
     *
     * *NOTE: Only available when the {@link Grid/feature/Group Group} or the {@link Grid/feature/Tree Tree} feature is enabled.*
     *
     * @function collapseAll
     * @category Feature shortcuts
     */

    /**
     * Expand all groups/parent nodes.
     *
     * *NOTE: Only available when the {@link Grid/feature/Group Group} or the {@link Grid/feature/Tree Tree} feature is enabled.*
     *
     * @function expandAll
     * @category Feature shortcuts
     */

    /**
     * Start editing specified cell. If no cellContext is given it starts with the first cell in the first row.
     *
     * *NOTE: Only available when the {@link Grid/feature/CellEdit CellEdit} feature is enabled.*
     *
     * @function startEditing
     * @param {Object} cellContext Cell specified in format { id: 'x', columnId/column/field: 'xxx' }. See {@link Grid.view.Grid#function-getCell} for details.
     * @returns {Boolean}
     * @category Feature shortcuts
     */

    /**
     * Collapse an expanded node or expand a collapsed. Optionally forcing a certain state.
     *
     * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
     *
     * @function toggleCollapse
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to toggle
     * @param {Boolean} [collapse] Force collapse (true) or expand (false)
     * @param {Boolean} [skipRefresh] Set to true to not refresh rows (if calling in batch)
     * @returns {Promise}
     * @category Feature shortcuts
     */

    /**
     * Collapse a single node.
     *
     * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
     *
     * @function collapse
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to collapse
     * @returns {Promise}
     * @category Feature shortcuts
     */

    /**
     * Expand a single node.
     *
     * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
     *
     * @function expand
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to expand
     * @returns {Promise}
     * @category Feature shortcuts
     */

    /**
     * Expands parent nodes to make this node "visible".
     *
     * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
     *
     * @function expandTo
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node
     * @returns {Promise}
     * @category Feature shortcuts
     */
    //endregion
    //region Grid template & elements

  }, {
    key: "updateHideFooters",
    value: function updateHideFooters(hide) {
      var _this$footerContainer;

      (_this$footerContainer = this.footerContainer) === null || _this$footerContainer === void 0 ? void 0 : _this$footerContainer.classList[hide ? 'add' : 'remove']('b-hidden');
    } //endregion
    //region Columns

  }, {
    key: "onColumnsChanged",
    value: function onColumnsChanged(_ref) {
      var action = _ref.action,
          changes = _ref.changes,
          column = _ref.record;
      var me = this; // this.onPaint will handle changes caused by updateResponsive

      if (!me.isPainted) {
        return;
      }

      if (action === 'update') {
        // Just updating width is already handled in a minimal way.
        if ('width' in changes || 'minWidth' in changes || 'flex' in changes) {
          // Update any leaf columns that want to be repainted on size change
          var region = column.region;
          me.columns.visibleColumns.forEach(function (col) {
            if (col.region === region && col.repaintOnResize) {
              me.refreshColumn(col);
            }
          });
          return;
        } // Column toggled, need to recheck if any visible column has flex


        if ('hidden' in changes) {
          var subGrid = me.getSubGridFromColumn(column.id);
          subGrid.header.fixHeaderWidths();
          subGrid.footer.fixFooterWidths();
          subGrid.updateHasFlex();
        }
      } // Might have to add or remove subgrids when assigning a new set of columns or when changing region


      if (action === 'dataset' || action === 'update' && 'region' in changes) {
        var regions = me.columns.getDistinctValues('region'),
            _ArrayHelper$delta = _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].delta(regions, me.regions, true),
            toRemove = _ArrayHelper$delta.toRemove,
            toAdd = _ArrayHelper$delta.toAdd;

        me.remove(toRemove.map(function (region) {
          return me.getSubGrid(region);
        }));
        me.add(toAdd.map(function (region) {
          return me.createSubGrid(region);
        }));
      }

      if (!me._suspendRenderContentsOnColumnsChanged) {
        me.renderContents();
      }
    }
  }, {
    key: "onColumnsResized",
    value: function onColumnsResized(_ref2) {
      var changes = _ref2.changes,
          column = _ref2.record;
      var me = this,
          domWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setLength(column.width),
          domMinWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setLength(column.minWidth),
          subGrid = me.getSubGridFromColumn(column.id); // Let header and footer fix their own widths

      subGrid.header.fixHeaderWidths();
      subGrid.footer.fixFooterWidths();
      subGrid.updateHasFlex();

      if (!me.cellEls || column !== me.lastColumnResized) {
        me.cellEls = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].children(me.element, ".b-grid-cell[data-column-id=\"".concat(column.id, "\"]"));
        me.lastColumnResized = column;
      }

      var _iterator = _createForOfIteratorHelper(me.cellEls),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cell = _step.value;

          if ('width' in changes) {
            // https://app.assembla.com/spaces/bryntum/tickets/8041
            // Although header and footer elements must be sized
            // using flex-basis to avoid the busting out problem,
            // grid cells MUST be sized using width since rows are absolutely
            // positioned and will not cause the busting out problem,
            // and rows will not stretch to shrinkwrap the cells
            // unless they are widthed with width.
            cell.style.width = domWidth; // IE11 calculates flexbox container width based on min-width rather than actual width. When column
            // has width defined greater than minWidth, row may have incorrect width

            if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11) {
              cell.style.flex = '';
              cell.style.minWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].setLength(column.calcMinWidth);
            }
          }

          if ('minWidth' in changes) {
            cell.style.minWidth = domMinWidth;
          }

          if ('flex' in changes) {
            var _column$flex;

            cell.style.flex = (_column$flex = column.flex) !== null && _column$flex !== void 0 ? _column$flex : null;
          }
        } // If we're being driven by the ColumnResizer or other bulk column resizer (like
        // ColumnAutoWidth), they will finish up with a call to afterColumnsResized.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!me.resizingColumns) {
        me.afterColumnsResized();
      }
    }
  }, {
    key: "afterColumnsResized",
    value: function afterColumnsResized() {
      var me = this;
      me.eachSubGrid(function (subGrid) {
        if (!subGrid.collapsed) {
          subGrid.fixWidths();
          subGrid.fixRowWidthsInSafariEdge();
        }
      });
      me.lastColumnResized = me.cellEls = null; // Buffer some expensive operations, like updating the fake scrollers

      me.bufferedAfterColumnsResized();
    }
  }, {
    key: "bufferedAfterColumnsResized",
    value: function bufferedAfterColumnsResized() {
      this.refreshVirtualScrollbars();
      this.eachSubGrid(function (subGrid) {
        if (!subGrid.collapsed) {
          subGrid.refreshFakeScroll();
        }
      });
      this.onHeightChange();
    } // Hook that can be overridden to prepare custom editors, can be used by framework wrappers

  }, {
    key: "processCellEditor",
    value: function processCellEditor(editorConfig) {} //endregion
    //region Rows

    /**
     * Get the Row that is currently displayed at top.
     * @member {Grid.row.Row} topRow
     * @readonly
     * @category Rows
     * @private
     */

    /**
     * Get the Row currently displayed furthest down.
     * @member {Grid.row.Row} bottomRow
     * @readonly
     * @category Rows
     * @private
     */

    /**
     * Get Row for specified record id.
     * @function getRowById
     * @param {Core.data.Model|String|Number} recordOrId Record id (or a record)
     * @returns {Grid.row.Row} Found Row or null if record not rendered
     * @category Rows
     * @private
     */

    /**
     * Returns top and bottom for rendered row or estimated coordinates for unrendered.
     * @function getRecordCoords
     * @param {Core.data.Model|string|Number} recordOrId Record or record id
     * @returns {Object} Record bounds with format { top, height, bottom }
     * @category Calculations
     * @private
     */

    /**
     * Get the Row at specified index. "Wraps" index if larger than available rows.
     * @function getRow
     * @param {Number} index
     * @returns {Grid.row.Row}
     * @category Rows
     * @private
     */

    /**
     * Get a Row for either a record, a record id or an HTMLElement
     * @function getRowFor
     * @param {HTMLElement|Core.data.Model|String|Number} recordOrId Record or record id or HTMLElement
     * @returns {Grid.row.Row} Found Row or null if record not rendered
     * @category Rows
     * @private
     */

    /**
     * Get a Row from an HTMLElement
     * @function getRowFromElement
     * @param {HTMLElement} element
     * @returns {Grid.row.Row} Found Row or null if record not rendered
     * @category Rows
     * @private
     */

  }, {
    key: "getRowHeight",
    // Default implementation, documented in `defaultConfig`
    value: function getRowHeight(record) {
      return record.rowHeight;
    } //endregion
    //region Store

    /**
     * Hooks up data store listeners
     * @private
     * @category Store
     */

  }, {
    key: "bindStore",
    value: function bindStore(store) {
      var _store$on;

      var suffix = this.asyncEventSuffix;
      store.on((_store$on = {
        name: storeListenerName
      }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "refresh".concat(suffix), 'onStoreDataChange'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "add".concat(suffix), 'onStoreAdd'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "remove".concat(suffix), 'onStoreRemove'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "move".concat(suffix), 'onStoreMove'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "replace".concat(suffix), 'onStoreReplace'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "removeAll".concat(suffix), 'onStoreRemoveAll'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "idChange", 'onStoreRecordIdChange'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "update", 'onStoreUpdateRecord'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "beforeRequest", 'onStoreBeforeRequest'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "afterRequest", 'onStoreAfterRequest'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "clearChanges", 'onStoreDataChange'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "exception", 'onStoreException'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_24___default()(_store$on, "commit", 'onStoreCommit'), _store$on), this);
    }
  }, {
    key: "unbindStore",
    value: function unbindStore(oldStore) {
      this.detachListeners(storeListenerName);

      if (this.destroyStore) {
        oldStore.destroy();
      }
    }
  }, {
    key: "onStoreUpdateRecord",

    /**
     * Rerenders a cell if a record is updated in the store
     * @private
     * @category Store
     */
    value: function onStoreUpdateRecord(_ref3) {
      var store = _ref3.source,
          record = _ref3.record,
          changes = _ref3.changes;
      var me = this;

      if (me.forceFullRefresh) {
        // flagged to need full refresh (probably from using GroupSummary)
        me.rowManager.refresh();
        me.forceFullRefresh = false;
      } else {
        var row; // Search for old row if id was changed

        if (record.isFieldModified('id')) {
          row = me.getRowFor(record.meta.modified.id);
        }

        row = row || me.getRowFor(record); // not rendered, bail out

        if (!row) return; // We must refresh the full row if it's a special row which has signalled
        // an update because it has no cells.

        if (me.fullRowRefresh || record.isSpecialRow) {
          var index = store.indexOf(record);

          if (index !== -1) {
            row.render(index, record);
          }
        } else {
          me.columns.visibleColumns.forEach(function (column) {
            var field = column.field,
                isSafe = column.constructor.simpleRenderer && !Object.prototype.hasOwnProperty.call(column.data, 'renderer'); // If there's a  non-safe renderer, that is a renderer which draws values from elsewhere
            // than just its configured field, that column must be refreshed on every record update.
            // Obviously, if the column's configured field is changed that also means it's refreshed.

            if (!isSafe || changes[field]) {
              var cell = row.getCell(field);

              if (cell) {
                row.renderCell(cell, record);
              }
            }
          });
        }
      }
    }
  }, {
    key: "refreshFromRowOnStoreAdd",
    value: function refreshFromRowOnStoreAdd(row, context) {
      var me = this,
          rowManager = me.rowManager;
      rowManager.renderFromRow(row);
      rowManager.trigger('changeTotalHeight', {
        totalHeight: rowManager.totalHeight
      }); // First record? Also update fake scrollers
      // TODO: Consider making empty grid scrollable to not have to do this

      if (me.store.count === 1) {
        me.callEachSubGrid('refreshFakeScroll');
      }
    }
  }, {
    key: "onMaskAutoClose",
    value: function onMaskAutoClose(mask) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "onMaskAutoClose", this).call(this, mask);

      this.toggleEmptyText();
    }
    /**
     * Refreshes rows when data is added to the store
     * @private
     * @category Store
     */

  }, {
    key: "onStoreAdd",
    value: function onStoreAdd(_ref4) {
      var store = _ref4.source,
          records = _ref4.records,
          index = _ref4.index,
          oldIndex = _ref4.oldIndex,
          isChild = _ref4.isChild,
          oldParent = _ref4.oldParent,
          isMove = _ref4.isMove,
          isExpandAll = _ref4.isExpandAll;

      // Do not react if the content has not been rendered
      if (!this.isPainted || isExpandAll) {
        return;
      } // If it's the addition of a child to a collapsed zone, the UI does not change.


      if (isChild && !records[0].ancestorsExpanded(store)) {
        return;
      }

      this.rowManager.calculateRowCount(false, true, true);
      var me = this,
          rowManager = me.rowManager,
          topIndex = rowManager.topIndex,
          rows = rowManager.rows,
          rowCount = rowManager.rowCount,
          bottomIndex = rowManager.topIndex + rowManager.rowCount - 1,
          dataStart = index,
          dataEnd = index + records.length - 1,
          atEnd = bottomIndex >= store.count - records.length - 1; // When moving a node within a tree we might need the redraw to include its old parent and its children. Not worth
      // the complexity of trying to do a partial render for this, rerender all rows to be safe.
      // Moving records within a flat store is handled elsewhere, in onStoreMove
      // TODO: Moving within a tree should also trigger 'move' (https://app.assembla.com/spaces/bryntum/tickets/7270)

      if (oldParent || oldIndex > -1 || isChild && isMove) {
        rowManager.refresh();
      } // Added block starts in our visible block. Render from there downwards.
      else if (dataStart >= topIndex && dataStart < topIndex + rowCount) {
          me.refreshFromRowOnStoreAdd.apply(me, [rows[dataStart - topIndex]].concat(Array.prototype.slice.call(arguments)));
        } // Added block ends in our visible block, render block
        else if (dataEnd >= topIndex && dataEnd < topIndex + rowCount) {
            rowManager.refresh();
          } // If added block is outside of the visible area, no visible change
          // but potentially a change in total dataset height.
          else {
              var totalHeight = rowManager.totalHeight.totalHeight; // If we are against the end of the dataset, and have appended records
              // ensure they are rendered below

              if (atEnd && index > bottomIndex) {
                rowManager.fillBelow(me._scrollTop || 0);
              }

              if (totalHeight !== rowManager.totalHeight) {
                rowManager.trigger('changeTotalHeight', {
                  totalHeight: rowManager.totalHeight
                });
              }
            }
    }
    /**
     * Responds to exceptions signalled by the store
     * @private
     * @category Store
     */

  }, {
    key: "onStoreException",
    value: function onStoreException(_ref5) {
      var action = _ref5.action,
          type = _ref5.type,
          response = _ref5.response,
          exceptionType = _ref5.exceptionType,
          error = _ref5.error;
      var me = this;
      var message;

      switch (type) {
        case 'server':
          message = response.message || me.L('L{unspecifiedFailure}');
          break;

        case 'exception':
          message = exceptionType === 'network' ? me.L('L{networkFailure}') : error && error.message || me.L('L{parseFailure}');
          break;
      }

      if (me.masked) {
        // eslint-disable-next-line
        var messageHTML = "<div class=\"b-grid-load-failure\">\n                    <div class=\"b-grid-load-fail\">".concat(me.L(action === 'read' ? 'L{loadFailedMessage}' : 'L{syncFailedMessage}'), "</div>\n                    <div class=\"b-grid-load-fail\">").concat(response && response.url ? response.url + ' responded with' : '', "</div>\n                    <div class=\"b-grid-load-fail\">").concat(message, "</div>\n                </div>");
        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].assign(me.masked.errorDefaults, me.loadMaskError);
        me.masked.error = messageHTML;
      }
    }
    /**
     * Refreshes rows when data is changed in the store
     * @private
     * @category Store
     */

  }, {
    key: "onStoreDataChange",
    value: function onStoreDataChange(_ref6) {
      var action = _ref6.action,
          changes = _ref6.changes,
          store = _ref6.source;

      if (this.suspendRendering) {
        return;
      } // If the next mixin up the inheritance chain has an implementation, call it


      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "onStoreDataChange", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "onStoreDataChange", this).apply(this, arguments);
      var me = this,
          isGroupFieldChange = store.isGrouped && changes && store.groupers.some(function (grouper) {
        return grouper.field in changes;
      }); // If it's new data, the old calculation is invalidated.

      if (action === 'dataset') {
        me.rowManager.clearKnownHeights();
      } // No need to rerender if it's a change of the value of the group field which
      // will be responded to by StoreGroup


      if (me.isPainted && !isGroupFieldChange) {
        // Return to top if setting new data or is filtering
        me.renderRows(null, action in preserveScroll);
      }

      me.toggleEmptyText();
    }
    /**
     * The hook is called when the id of a record has changed.
     * @private
     * @category Store
     */

  }, {
    key: "onStoreRecordIdChange",
    value: function onStoreRecordIdChange() {
      // If the next mixin up the inheritance chain has an implementation, call it
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "onStoreRecordIdChange", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "onStoreRecordIdChange", this).apply(this, arguments);
    }
    /**
     * Shows a load mask while the connected store is loading
     * @private
     * @category Store
     */

  }, {
    key: "onStoreBeforeRequest",
    value: function onStoreBeforeRequest() {
      var loadMask = this.loadMask;

      if (loadMask) {
        this.masked = _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_42__["default"].mergeConfigs(this.loadMaskDefaults, loadMask);
      }
    }
    /**
     * Hides load mask after a load request ends either in success or failure
     * @private
     * @category Store
     */

  }, {
    key: "onStoreAfterRequest",
    value: function onStoreAfterRequest(event) {
      if (this.loadMask && !event.exception) {
        this.masked = null;
        this.toggleEmptyText();
      }
    }
  }, {
    key: "needsFullRefreshOnStoreRemove",
    value: function needsFullRefreshOnStoreRemove() {
      var features = this._features;
      return (features === null || features === void 0 ? void 0 : features.group) && !features.group.disabled || (features === null || features === void 0 ? void 0 : features.groupSummary) && !features.groupSummary.disabled;
    }
    /**
     * Animates removal of record.
     * @private
     * @category Store
     */

  }, {
    key: "onStoreRemove",
    value: function onStoreRemove(_ref7) {
      var records = _ref7.records,
          isCollapse = _ref7.isCollapse,
          isChild = _ref7.isChild,
          isMove = _ref7.isMove,
          isCollapseAll = _ref7.isCollapseAll;

      // Do not react if the content has not been rendered,
      // or if it is a move, which will be handled by onStoreAdd
      if (!this.isPainted || isMove || isCollapseAll) {
        return;
      } // GridSelection mixin does its job on records removing


      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "onStoreRemove", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "onStoreRemove", this).apply(this, arguments);
      var topRowIndex = Math.pow(2, 53) - 1;
      var me = this,
          rowManager = me.rowManager,
          rowsToRemove = records.reduce(function (result, record) {
        var row = rowManager.getRowById(record.id);

        if (row) {
          result.push(row); // Rows are repositioned in the array, it matches visual order. Need to find actual index in it

          topRowIndex = Math.min(topRowIndex, rowManager.rows.indexOf(row));
        }

        return result;
      }, []); // Remove cached heights

      rowManager.invalidateKnownHeight(records);

      if (me.animateRemovingRows && rowsToRemove.length && !isCollapse && !isChild) {
        var topRow = rowsToRemove[0];
        me.isAnimating = true; // As soon as first row has disappeared, rerender the view

        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].onTransitionEnd({
          element: topRow._elementsArray[0],
          property: 'left',
          // Detach listener after timeout even if event wasn't fired
          duration: me.transitionDuration,
          thisObj: me,
          handler: function handler() {
            me.isAnimating = false;
            rowsToRemove.forEach(function (row) {
              return !row.isDestroyed && row.removeCls('b-removing');
            });
            rowManager.refresh(); // undocumented internal event for scheduler

            me.trigger('rowRemove');
          }
        });
        rowsToRemove.forEach(function (row) {
          return row.addCls('b-removing');
        });
      } // Cannot do an update from the affected row and down here. Since group headers might be affected by
      // removing rows we need a full refresh
      else if (me.needsFullRefreshOnStoreRemove.apply(me, arguments)) {
          rowManager.refresh();
        } else {
          // Potentially remove rows and change dataset height
          rowManager.calculateRowCount(false, true, true); // If there were rows below which have moved up into place
          // then repurpose them with their new records

          if (rowManager.rows[topRowIndex]) {
            rowManager.renderFromRow(rowManager.rows[topRowIndex]);
          } // If nothing to render below, just update dataset height
          else {
              rowManager.trigger('changeTotalHeight', {
                totalHeight: rowManager.totalHeight
              });
            }

          me.trigger('rowRemove', {
            isCollapse: isCollapse
          });
        }
    }
  }, {
    key: "onStoreMove",
    value: function onStoreMove(_ref8) {
      var from = _ref8.from,
          to = _ref8.to;

      var rowManager = this.rowManager,
          topIndex = rowManager.topIndex,
          rowCount = rowManager.rowCount,
          _sort = [from, to].sort(),
          _sort2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23___default()(_sort, 2),
          dataStart = _sort2[0],
          dataEnd = _sort2[1]; // Changed block starts in our visible block. Render from there downwards.


      if (dataStart >= topIndex && dataStart < topIndex + rowCount) {
        rowManager.renderFromRow(rowManager.rows[dataStart - topIndex]);
      } // Changed block ends in our visible block, render block
      else if (dataEnd >= topIndex && dataEnd < topIndex + rowCount) {
          rowManager.refresh();
        } // If changed block is outside of the visible area, this is a no-op

    }
  }, {
    key: "onStoreReplace",
    value: function onStoreReplace(_ref9) {
      var _this = this;

      var records = _ref9.records,
          all = _ref9.all;
      var rowManager = this.rowManager;

      if (all) {
        rowManager.clearKnownHeights();
        rowManager.refresh();
      } else {
        var rows = records.reduce(function (rows, _ref10) {
          var _ref11 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23___default()(_ref10, 2),
              record = _ref11[1];

          var row = _this.getRowFor(record);

          if (row) {
            rows.push(row);
          }

          return rows;
        }, []); // Heights will be stored on render, but some records might be out of view -> have to invalidate separately

        rowManager.invalidateKnownHeight(records);
        rowManager.renderRows(rows);
      }
    }
    /**
     * Rerenders grid when all records have been removed
     * @private
     * @category Store
     */

  }, {
    key: "onStoreRemoveAll",
    value: function onStoreRemoveAll() {
      // GridSelection mixin does its job on records removing
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "onStoreRemoveAll", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "onStoreRemoveAll", this).apply(this, arguments);

      if (this.isPainted) {
        this.rowManager.clearKnownHeights();
        this.renderRows();
        this.toggleEmptyText();
      }
    } // Refresh dirty cells on commit

  }, {
    key: "onStoreCommit",
    value: function onStoreCommit(_ref12) {
      var _this2 = this;

      var changes = _ref12.changes;

      if (this.showDirty && changes.modified.length) {
        var rows = [];
        changes.modified.forEach(function (record) {
          var row = _this2.rowManager.getRowFor(record);

          row && rows.push(row);
        });
        this.rowManager.renderRows(rows);
      }
    }
    /**
     * Convenience functions for getting/setting data in related store
     * @property {Object[]}
     * @category Common
     */

  }, {
    key: "populateHeaderMenu",
    //endregion
    //region Context menu items

    /**
     * Populates the header context menu. Chained in features to add menu items.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */
    value: function populateHeaderMenu(_ref13) {
      var column = _ref13.column,
          items = _ref13.items;
      var me = this,
          subGrids = me.subGrids,
          regions = me.regions;
      var first = true;
      Object.entries(subGrids).forEach(function (_ref14) {
        var _ref15 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_23___default()(_ref14, 2),
            region = _ref15[0],
            subGrid = _ref15[1];

        // If SubGrid is configured with a sealed column set, do not allow moving into it
        if (subGrid.sealedColumns) {
          return;
        }

        if (column.draggable && region !== column.region && (!column.parent && subGrids[column.region].columns.count > 1 || column.parent && column.parent.children.length > 1)) {
          var moveRight = subGrid.element.compareDocumentPosition(subGrids[column.region].element) === document.DOCUMENT_POSITION_PRECEDING,
              // With 2 regions, use Move left, Move right. With multiple, include region name
          text = regions.length > 2 ? me.L('L{moveColumnTo}', me.optionalL(region)) : me.L(moveRight ? 'L{moveColumnRight}' : 'L{moveColumnLeft}');
          items["".concat(region, "Region")] = {
            targetSubGrid: region,
            text: text,
            icon: 'b-fw-icon ' + (moveRight ? 'b-icon-column-move-right' : 'b-icon-column-move-left'),
            name: 'moveColumn',
            cls: first ? 'b-separator' : '',
            onItem: function onItem(_ref16) {
              var item = _ref16.item;
              column.traverse(function (col) {
                return col.region = region;
              }); // Changing region will move the column to the correct SubGrid, but we want it to go last

              me.columns.insert(me.columns.indexOf(subGrids[item.targetSubGrid].columns.last) + 1, column);
              me.scrollColumnIntoView(column);
            }
          };
          first = false;
        }
      });
    }
    /**
     * Populates the cell context menu. Chained in features to add menu items.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Core.data.Model} options.record Record for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateCellMenu",
    value: function populateCellMenu(_ref17) {
      var _me$features;

      var record = _ref17.record,
          items = _ref17.items;
      var me = this,
          // TODO: 'contextMenu' is deprecated. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.
      isDeprecatedFeatureUsed = ((_me$features = me.features) === null || _me$features === void 0 ? void 0 : _me$features.contextMenu) && !me.features.contextMenu.disabled;

      if (isDeprecatedFeatureUsed && me.showRemoveRowInContextMenu && !me.readOnly && record && !record.isSpecialRow) {
        var manyItems = me.selectedRecords.length > 1;
        items.removeRow = {
          text: manyItems ? 'L{removeRows}' : 'L{removeRow}',
          localeClass: this,
          icon: 'b-fw-icon b-icon-trash',
          name: manyItems ? 'removeRows' : 'removeRow',
          onItem: function onItem() {
            return me.store.remove(manyItems ? me.selectedRecords : record);
          }
        };
      }
    }
  }, {
    key: "getColumnDragToolbarItems",
    value: function getColumnDragToolbarItems(column, items) {
      return items;
    } //endregion
    //region Getters

  }, {
    key: "normalizeCellContext",
    value: function normalizeCellContext(cellContext) {
      var columns = this.columns,
          store = this.store; // TODO: should clone instead of modify?
      // TODO: The answer is to use the Grid/util/Location class to robustly encapsulate a record/column intersection
      // And have them immutable, so that to change is to clone, as explained by MaximGB,
      // we want to use columnId for precision, but allow user to specify column name for ease of use...
      // modify cellContext to include columnId in those cases

      if (cellContext instanceof store.modelClass) {
        return {
          record: cellContext,
          id: cellContext.id,
          columnId: columns.bottomColumns[0].id
        };
      }

      if (!('columnId' in cellContext)) {
        if ('field' in cellContext) {
          var column = columns.get(cellContext.field);
          cellContext.columnId = column && column.id;
        } else if ('column' in cellContext) {
          var _column = typeof cellContext.column === 'number' ? columns.bottomColumns[cellContext.column] : cellContext.column;

          cellContext.columnId = _column && _column.id;
        } // Fall back to first leaf column


        if (!('columnId' in cellContext)) {
          cellContext.columnId = columns.bottomColumns[0].id;
        }
      }

      if ('id' in cellContext) {
        // If the context is for an element, but it's stale (for a removed record)
        // then fix it up to refer to the record id at the same index.
        if (cellContext.element && !store.getById(cellContext.id)) {
          // This uses the data-index property to get the row at that index.
          var record = this.getRecordFromElement(cellContext.element); // We have a record at the same index.

          if (record) {
            cellContext.id = record.id;
          }
        }
      } else {
        var _record = 'row' in cellContext ? store.getAt(cellContext.row) : cellContext.record;

        if (_record) {
          cellContext.id = _record.id;
        }
      }

      return cellContext;
    } // TODO: move to RowManager? Or create a CellManager?

    /**
     * Returns a cell if rendered.
     * @param {Object} cellContext { id: rowId, columnId: columnId [,column: column number, field: column field] }
     * @param {Number} [cellContext.row] The row index of the row to access. Exclusive with `id` and 'record'.
     * @param {String|Number} [cellContext.id] The record id of the row to access. Exclusive with `row` and 'record'.
     * @param {Core.data.Model} [cellContext.record] The record of the row to access. Exclusive with `id` and 'row'.
     * @param {Number} [cellContext.column] The column instance or the index of the cell to access.  Exclusive with `columnId`.
     * @param {String|Number} [cellContext.columnId] The column id of the column to access. Exclusive with `column`.
     * @param {String} [cellContext.field] The field of the column to access. Exclusive with `column`.
     * @returns {HTMLElement}
     * @category Getters
     */

  }, {
    key: "getCell",
    value: function getCell(cellContext) {
      var row,
          result = null;
      cellContext = this.normalizeCellContext(cellContext);

      if ('id' in cellContext) {
        row = this.getRowById(cellContext.id);
      }

      if (row && 'columnId' in cellContext) {
        result = row.getCell(cellContext.columnId);
      }

      return result;
    } //TODO: Should move to ColumnManager? Or Header?

    /**
     * Returns the header element for the column
     * @param {String|Number|Grid.column.Column} columnId or Column instance
     * @returns {HTMLElement} Header element
     * @category Getters
     */

  }, {
    key: "getHeaderElement",
    value: function getHeaderElement(columnId) {
      if (typeof columnId !== 'string') {
        columnId = columnId.id;
      }

      return this.fromCache(".b-grid-header[data-column-id=\"".concat(columnId, "\"]"));
    }
  }, {
    key: "getHeaderElementByField",
    value: function getHeaderElementByField(field) {
      var column = this.columns.get(field);
      return column ? this.getHeaderElement(column) : null;
    }
    /**
     * Body height
     * @property {Number}
     * @readonly
     * @category Layout
     */

  }, {
    key: "getRecordFromElement",

    /**
     * Searches up from the specified element for a grid row and returns the record associated with that row.
     * @param {HTMLElement} element Element somewhere within a row or the row container element
     * @returns {Core.data.Model} Record for the row
     * @category Getters
     */
    value: function getRecordFromElement(element) {
      var el = element.closest('.b-grid-row');
      if (!el) return null;
      return this.store.getAt(el.dataset.index);
    }
    /**
     * Searches up from specified element for a grid cell or an header and returns the column which the cell belongs to
     * @param {HTMLElement} element Element somewhere in a cell
     * @returns {Grid.column.Column} Column to which the cell belongs
     * @category Getters
     */

  }, {
    key: "getColumnFromElement",
    value: function getColumnFromElement(element) {
      var cell = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].up(element, '.b-grid-cell, .b-grid-header');
      if (!cell) return null;

      if (cell.matches('.b-grid-header')) {
        return this.columns.getById(cell.dataset.columnId);
      }

      var cellData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_33__["default"].get(cell);
      return this.columns.getById(cellData.columnId);
    } // Getter and setter for autoHeight only added for type checking, since it seems common to get it wrong in react/angular

  }, {
    key: "fixSizes",
    //endregion
    //region Fix width & height

    /**
     * Sets widths and heights for headers, rows and other parts of the grid as needed
     * @private
     * @category Width & height
     */
    value: function fixSizes() {
      // subGrid width
      this.callEachSubGrid('fixWidths');
    }
  }, {
    key: "onRowManagerChangeTotalHeight",
    value: function onRowManagerChangeTotalHeight(_ref18) {
      var totalHeight = _ref18.totalHeight,
          immediate = _ref18.immediate;
      return this.refreshTotalHeight(totalHeight, immediate);
    }
    /**
     * Makes height of vertical scroller match estimated total height of grid. Called when scrolling vertically and
     * when showing/hiding rows.
     * @param {Number} [height] Total height supplied by RowManager
     * @param {Boolean} [immediate] Flag indicating if buffered element sizing should be bypassed
     * @private
     * @category Width & height
     */

  }, {
    key: "refreshTotalHeight",
    value: function refreshTotalHeight() {
      var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rowManager.totalHeight;
      var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this; // Veto change of estimated total height while rendering rows or if triggered while in a hidden state

      if (me.renderingRows || !me.isVisible) {
        return false;
      } // TODO: Needed??


      if (me.rowManager.bottomRow) {
        height = Math.max(height, me.rowManager.bottomRow.bottom);
      }

      var scroller = me.scrollable,
          delta = Math.abs(me.virtualScrollHeight - height),
          clientHeight = me._bodyRectangle.height,
          newMaxY = height - clientHeight;

      if (delta) {
        var // We must update immediately if we are nearing the end of the scroll range.
        isCritical = newMaxY - me._scrollTop < clientHeight * 2 || // Or if we have scrolled pass visual height
        me._verticalScrollHeight && me._verticalScrollHeight - clientHeight < me._scrollTop; // Update the true scroll range using the scroller. This will not cause a repaint.

        scroller.scrollHeight = me.virtualScrollHeight = height; // If we are scrolling, put this off because it causes
        // a full document layout and paint.
        // Do not buffer calls for not yet painted grid

        if (me.isPainted && (me.scrolling && !isCritical || delta < 100) && !immediate) {
          me.bufferedFixElementHeights();
        } else {
          me.virtualScrollHeightDirty && me.virtualScrollHeightDirty();
          me.bufferedFixElementHeights.cancel();
          me.fixElementHeights();
        }
      }
    }
  }, {
    key: "fixElementHeights",
    value: function fixElementHeights() {
      var me = this,
          height = me.virtualScrollHeight,
          heightInPx = "".concat(height, "px");
      me._verticalScrollHeight = height;
      me.verticalScroller.style.height = heightInPx;
      me.virtualScrollHeightDirty = false;

      if (me.autoHeight) {
        me.bodyContainer.style.height = heightInPx;
        me._bodyHeight = height;
        me._bodyRectangle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_40__["default"].client(me.bodyContainer);
      }

      me.refreshVirtualScrollbars();
    } //endregion
    //region Scroll & virtual rendering

  }, {
    key: "enableScrollingCloseToEdges",

    /**
     * Activates automatic scrolling of a subGrid when mouse is moved closed to the edges
     * @param {Grid.view.SubGrid|String} subGrid A subGrid instance or its region name
     */
    value: function enableScrollingCloseToEdges(subGrid) {
      if (typeof subGrid === 'string') {
        subGrid = this.subGrids[subGrid];
      }

      this.scrollManager.startMonitoring({
        element: subGrid.element
      });
    }
    /**
     * Deactivates automatic scrolling of a subGrid when mouse is moved closed to the edges
     * @param {Grid.view.SubGrid|String} subGrid A subGrid instance or its region name
     */

  }, {
    key: "disableScrollingCloseToEdges",
    value: function disableScrollingCloseToEdges(subGrid) {
      if (typeof subGrid === 'string') {
        subGrid = this.subGrids[subGrid];
      }

      this.scrollManager.stopMonitoring(subGrid.element);
    }
    /**
     * Responds to request from RowManager to adjust scroll position. Happens when jumping to a scroll position with
     * variable row height.
     * @param {Number} bottomMostRowY
     * @private
     * @category Scrolling
     */

  }, {
    key: "onRowManagerRequestScrollChange",
    value: function onRowManagerRequestScrollChange(_ref19) {
      var bottom = _ref19.bottom;
      this.scrollable.y = bottom - this.bodyHeight;
    }
    /**
     * Scroll syncing for normal headers & grid + triggers virtual rendering for vertical scroll
     * @private
     * @fires scroll
     * @category Scrolling
     */

  }, {
    key: "initScroll",
    value: function initScroll() {
      var me = this; // This method may be called early, before render calls it, so ensure that it's
      // only executed once.

      if (!me.scrollInitialized) {
        var scrollTop;
        var onScroll = me.createOnFrame(function () {
          scrollTop = me.scrollable.y; // Was getting scroll events in FF where scrollTop was unchanged, ignore those

          if (scrollTop !== me._scrollTop) {
            me._scrollTop = scrollTop;

            if (!me.scrolling) {
              me.scrolling = true;
              me.eachSubGrid(function (s) {
                return s.suspendResizeMonitor = true;
              });
            }

            me.rowManager.updateRenderedRows(scrollTop);
            /**
                * Grid has scrolled vertically
                * @event scroll
                * @param {Grid.view.Grid} grid
                * @param {Number} scrollTop
                */

            me.trigger('scroll', {
              scrollTop: scrollTop
            });
          }
        });
        me.scrollInitialized = true;
        me.scrollable.on({
          scroll: onScroll,
          scrollend: function scrollend() {
            me.scrolling = false;
            me.eachSubGrid(function (s) {
              return s.suspendResizeMonitor = false;
            });
          }
        });
        me.callEachSubGrid('initScroll');
      }
    } // TODO: rename to scrollRecordIntoView? Or have an alias?

    /**
     * Scrolls a row into view. If row isn't rendered it tries to calculate position
     * @param {Core.data.Model|String|Number} recordOrId Record or record id
     * @param {Object} [options] How to scroll.
     * @param {String} [options.column] Field name or ID of the column, or the Column instance to scroll to.
     * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
     * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
     * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
     * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
     * @category Scrolling
     * @returns {Promise} A promise which resolves when the specified row has been scrolled into view.
     */

  }, {
    key: "scrollRowIntoView",
    value: function scrollRowIntoView(recordOrId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;
      var me = this,
          blockPosition = options.block || 'nearest',
          rowManager = me.rowManager;
      recordOrId = me.store.getById(recordOrId);

      if (recordOrId) {
        // check that record is "displayable", not filtered out or hidden by collapse
        if (me.store.indexOf(recordOrId) === -1) {
          return resolvedPromise;
        }

        var scroller = me.scrollable,
            recordRect = me.getRecordCoords(recordOrId);
        var scrollerRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_40__["default"].from(scroller.element); // If it was calculated from the index, update the rendered rowScrollMode
        // and scroll to the actual element. Note that this should only be necessary
        // for variableRowHeight.
        // But to "make the tests green", this is a workaround for a buffered rendering
        // bug when teleporting scroll. It does not render the rows at their correct
        // positions. Please do not try to "fix" this. I will do it. NGW

        if (recordRect.virtual) {
          var virtualBlock = recordRect.block; // Scroll the calculated position to the center of the scrollingViewport
          // and then update the rendered block while asking the RowManager to
          // display the required recordOrId.

          scroller.scrollIntoView(recordRect, {
            block: 'center'
          });
          rowManager.scrollTargetRecordId = recordOrId;
          rowManager.updateRenderedRows(scroller.y, true);
          recordRect = me.getRecordCoords(recordOrId);
          rowManager.lastScrollTop = scroller.y;

          if (recordRect.virtual) {
            // bail out to not get caught in infinite loop, since code above is cut out of bundle
            // eslint-disable-next-line no-useless-return,no-unreachable
            return resolvedPromise;
          }

          var innerOptions = blockPosition !== 'nearest' ? options : {
            block: virtualBlock
          }; // Scroll the target just less than append/prepend buffer height out of view so that the animation looks good

          if (options.animate) {
            // Do not fire scroll events during this scroll sequence - it's a purely cosmetic operation.
            // We are scrolling the desired row out of view merely to *animate scroll* it to the requested position.
            scroller.suspendEvents(); // Scroll to its final position

            if (blockPosition === 'end' || blockPosition === 'nearest' && virtualBlock === 'end') {
              scroller.y -= scrollerRect.bottom - recordRect.bottom;
            } else if (blockPosition === 'start' || blockPosition === 'nearest' && virtualBlock === 'start') {
              scroller.y += recordRect.y - scrollerRect.y;
            } // Ensure rendered block is correct at that position


            rowManager.updateRenderedRows(scroller.y, false, true); // Scroll away from final position to enable a cosmetic scroll to final position

            if (virtualBlock === 'end') {
              scroller.y -= rowManager.appendRowBuffer * rowManager.rowHeight - 1;
            } else {
              scroller.y += rowManager.prependRowBuffer * rowManager.rowHeight - 1;
            } // The row will still be rendered, so scroll it using the scroller directly


            var result = scroller.scrollIntoView(me.getRecordCoords(recordOrId), Object.assign({}, options, innerOptions)); // Now we're at the required position, resume events

            return result.then(function () {
              return scroller.resumeEvents();
            });
          } else {
            return me.scrollRowIntoView(recordOrId, Object.assign({}, options, innerOptions));
          }
        } else {
          var column = options.column;

          if (column) {
            if (typeof column === 'string') {
              column = me.columns.getById(column) || me.columns.get(column);
            } // If we are targetting a column, we must use the scroller of that column's SubGrid


            if (column) {
              scroller = me.getSubGridFromColumn(column).scrollable;
              var cellRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_40__["default"].from(rowManager.getRowFor(recordOrId).getCell(column.id));
              recordRect.x = cellRect.x;
              recordRect.width = cellRect.width;
            }
          } // No column, then tell the scroller not to scroll in the X axis
          else {
              options.x = false;
            }

          return scroller.scrollIntoView(recordRect, options);
        }
      }
    }
    /**
     * Scrolls a column into view (if it is not already)
     * @param {Grid.column.Column|String|Number} column Column name (data) or column index or actual column object.
     * @param {Object} [options] How to scroll.
     * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
     * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
     * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
     * or the number of milliseconds to animate over, or an animation config object.
     * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
     * @param {String} [options.animate.easing] The name of an easing function.
     * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
     * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
     * @returns {Promise} If the column exists, a promise which is resolved when the column header element has been scrolled into view.
     * @category Scrolling
     */

  }, {
    key: "scrollColumnIntoView",
    value: function scrollColumnIntoView(column, options) {
      column = column instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_62__["default"] ? column : this.columns.get(column) || this.columns.getById(column) || this.columns.getAt(column);
      return this.getSubGridFromColumn(column).scrollColumnIntoView(column, options);
    } // TODO The API { id: recordId, column: 'columnName' } is not clear: id has to be renamed to `record` or `recordId` to be self-explanatory;

    /**
     * Scrolls a cell into view (if it is not already)
     * @param {Object} cellContext Cell selector { id: recordId, column: 'columnName' }
     * @category Scrolling
     */

  }, {
    key: "scrollCellIntoView",
    value: function scrollCellIntoView(cellContext, options) {
      return this.scrollRowIntoView(cellContext.id, Object.assign({
        column: cellContext.columnId
      }, typeof options === 'boolean' ? {
        animate: options
      } : options));
    }
    /**
     * Scroll all the way down
     * @returns {Promise} A promise which resolves when the bottom is reached.
     * @category Scrolling
     */

  }, {
    key: "scrollToBottom",
    value: function scrollToBottom(options) {
      // triggers scroll to last record. not using current scroller height because we do not know if it is correct
      return this.scrollRowIntoView(this.store.last, options);
    }
    /**
     * Scroll all the way up
     * @returns {Promise} A promise which resolves when the top is reached.
     * @category Scrolling
     */

  }, {
    key: "scrollToTop",
    value: function scrollToTop(options) {
      return this.scrollable.scrollBy(0, -this.scrollable.y, options);
    }
    /**
     * Store scroll state (scrollTop for entire grid and scrollLeft per sub grid)
     * @returns {{scrollTop: (*|string|number), scrollLeft: {}}}
     * @category Scrolling
     */

  }, {
    key: "storeScroll",
    value: function storeScroll() {
      var me = this,
          state = me.storedScrollState = {
        scrollTop: me.scrollable.y,
        scrollLeft: {}
      }; // TODO: Implement special multi-element Scroller subclass for Grids which
      // encapsulates the x axis only Scrollers of all its SubGrids.

      me.eachSubGrid(function (subGrid) {
        state.scrollLeft[subGrid.region] = subGrid.scrollable.x;
      });
      return state;
    }
    /**
     * Restore scroll state. If state is not specified, restores the last stored state.
     * @param state Scroll state, optional
     * @category Scrolling
     */

  }, {
    key: "restoreScroll",
    value: function restoreScroll() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.storedScrollState;
      var me = this; // TODO: Implement special multi-element Scroller subclass for Grids which
      // encapsulates the x axis only Scrollers of all its SubGrids.

      me.eachSubGrid(function (subGrid) {
        subGrid.scrollable.x = state.scrollLeft[subGrid.region];
      });
      me.scrollable.y = state.scrollTop;
    } //endregion
    //region Theme & measuring

    /**
     * Creates a fake subgrid with one row and mesaures its height. Result is used as rowHeight.
     * @private
     */

  }, {
    key: "measureRowHeight",
    value: function measureRowHeight() {
      var _me$features2;

      var me = this,
          // Create a fake subgrid with one row, since styling for row is specified on .b-grid-subgrid .b-grid-row
      rowMeasureElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].createElement({
        tag: 'div',
        // TODO: should either get correct widgetClassList or query features for measure classes
        className: 'b-grid ' + (((_me$features2 = me.features) === null || _me$features2 === void 0 ? void 0 : _me$features2.stripe) ? 'b-stripe' : ''),
        style: 'position: absolute; visibility: hidden',
        html: '<div class="b-grid-subgrid"><div class="b-grid-row"></div></div>',
        parent: document.getElementById(me.appendTo) || document.body
      }); // Use style height or default height from config.
      // Not using clientHeight since it will have some value even if no height specified in CSS

      var rowEl = rowMeasureElement.firstElementChild.firstElementChild,
          styleHeight = parseInt(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getStyleValue(rowEl, 'height')),
          borderTop = parseInt(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getStyleValue(rowEl, 'border-top-width')),
          borderBottom = parseInt(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].getStyleValue(rowEl, 'border-bottom-width')); // Change rowHeight if specified in styling, also remember that value to replace later if theme changes and
      // user has not explicitly set some other height

      if (me.rowHeight == null || me.rowHeight === me._rowHeightFromStyle) {
        me.rowHeight = !isNaN(styleHeight) && styleHeight ? styleHeight : me.defaultRowHeight;
        me._rowHeightFromStyle = me.rowHeight;
      } // this measurement will be added to rowHeight during rendering, to get correct cell height


      me._rowBorderHeight = borderTop + borderBottom;
      me._isRowMeasured = true;
      rowMeasureElement.remove(); // There is a ticket about measuring the actual first row instead:
      // https://app.assembla.com/spaces/bryntum/tickets/5735-measure-first-real-rendered-row-for-rowheight/details
    }
    /**
     * Handler for global theme change event (triggered by shared.js). Remeasures row height.
     * @private
     */

  }, {
    key: "onThemeChange",
    value: function onThemeChange(_ref20) {
      var theme = _ref20.theme;
      this.measureRowHeight();
      this.trigger('theme', {
        theme: theme
      });
    } //endregion
    //region Rendering of rows

    /**
     * Triggers a render of records to all row elements. Call after changing order, grouping etc to reflect changes
     * visually. Preserves scroll.
     * @category Rendering
     */

  }, {
    key: "refreshRows",
    value: function refreshRows() {
      var returnToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var element = this.element,
          rowManager = this.rowManager;
      element.classList.add('b-notransition');

      if (returnToTop) {
        rowManager.returnToTop();
      } else {
        rowManager.refresh();
      }

      element.classList.remove('b-notransition');
    }
    /**
     * Triggers a render of all the cells in a column.
     * @param {Grid.column.Column} column
     * @category Rendering
     */

  }, {
    key: "refreshColumn",
    value: function refreshColumn(column) {
      if (!column.hidden) {
        var field = column.field;
        this.rowManager.forEach(function (row) {
          var cell = row.getCell(field);
          row.renderCell(cell);
        });
      }
    } //endregion
    //region Render the grid

    /**
     * Recalculates virtual scrollbars widths and scrollWidth
     * @private
     */

  }, {
    key: "refreshVirtualScrollbars",
    value: function refreshVirtualScrollbars() {
      // NOTE: This was at some point changed to only run on platforms with width-occupying scrollbars, but it needs
      // to run with overlayed scrollbars also to make them show/hide as they should.
      var me = this,
          headerContainer = me.headerContainer,
          footerContainer = me.footerContainer,
          virtualScrollers = me.virtualScrollers,
          hasVerticalOverflow = me.hasVerticalOverflow,
          hasHorizontalOverflow = Object.values(me.subGrids).some(function (subGrid) {
        return subGrid.overflowingHorizontally;
      }),
          method = hasVerticalOverflow ? 'add' : 'remove';

      if (hasHorizontalOverflow) {
        virtualScrollers.classList.remove('b-hide-display');
      } else {
        virtualScrollers.classList.add('b-hide-display');
      } // Auto-widthed padding element at end hides or shows to create matching margin.


      if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].scrollBarWidth) {
        headerContainer.classList[method]('b-show-yscroll-padding');
        footerContainer.classList[method]('b-show-yscroll-padding');
        virtualScrollers.classList[method]('b-show-yscroll-padding');
      } // Change of scrollbar status means height change


      me.onHeightChange();
    }
  }, {
    key: "onContentChange",
    value: function onContentChange() {
      var me = this,
          rowManager = me.rowManager;

      if (me.isVisible) {
        rowManager.estimateTotalHeight();
        me.paintListener = null;
        me.refreshTotalHeight(me.contentHeight);
        me.callEachSubGrid('refreshFakeScroll');
        me.onHeightChange();
      } // If not visible, this operation MUST be done when we become visible.
      // This is announced by the paint event which is triggered when a Widget
      // really gains visibility, ie is shown or rendered, or it's not hidden,
      // and a hidden/non-rendered ancestor is shown or rendered.
      // See Widget#triggerPaint.
      else if (!me.paintListener) {
          me.paintListener = me.on({
            paint: 'onContentChange',
            once: true,
            thisObj: me
          });
        }
    }
  }, {
    key: "onHeightChange",
    value: function onHeightChange() {
      var me = this; // cache to avoid recalculations in the middle of rendering code (RowManger#getRecordCoords())

      me._bodyRectangle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_40__["default"].client(me.bodyContainer);
      me._bodyHeight = me.autoHeight ? me.contentHeight : me.bodyContainer.offsetHeight;
    }
    /**
     * Called after headers have been rendered to the headerContainer.
     * This does not do anything, it's just for Features to hook in to.
     * @param {HTMLElement} headerContainer DOM element which contains the headers.
     * @param {HTMLElement} element Grid element
     * @private
     * @category Rendering
     */

  }, {
    key: "renderHeader",
    value: function renderHeader(headerContainer, element) {}
    /**
     * Called after footers have been rendered to the footerContainer.
     * This does not do anything, it's just for Features to hook in to.
     * @param {HTMLElement} footerContainer DOM element which contains the footers.
     * @param {HTMLElement} element Grid element
     * @private
     * @category Rendering
     */

  }, {
    key: "renderFooter",
    value: function renderFooter(footerContainer, element) {}
  }, {
    key: "suspendRefresh",
    value: function suspendRefresh() {
      this.refreshSuspended++;
    }
  }, {
    key: "resumeRefresh",
    value: function resumeRefresh(trigger) {
      if (this.refreshSuspended && ! --this.refreshSuspended) {
        if (trigger) {
          this.refreshRows();
        }

        this.trigger('resumeRefresh');
      }
    }
    /**
     * Rerenders all grid rows, completely replacing all row elements with new ones
     * @category Rendering
     */

  }, {
    key: "renderRows",
    value: function renderRows() {
      var keepScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var returnToTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          scrollState = keepScroll && me.storeScroll();

      if (me.refreshSuspended) {
        return;
      }
      /**
       * Grid rows are about to be rendered
       * @event beforeRenderRows
       * @param {Grid.view.Grid} source This grid.
       */


      me.trigger('beforeRenderRows');
      me.renderingRows = true; // This allows us to do things like disable animations on a refresh

      me.element.classList.add('b-grid-refreshing');

      if (returnToTop) {
        me.scrollable.y = me._scrollTop = 0;
      }

      me.rowManager.reinitialize(returnToTop);
      /**
       * Grid rows have been rendered
       * @event renderRows
       * @param {Grid.view.Grid} source This grid.
       */

      me.trigger('renderRows');
      me.renderingRows = false;
      me.onContentChange();

      if (keepScroll) {
        me.restoreScroll(scrollState);
      }

      me.element.classList.remove('b-grid-refreshing');
    }
    /**
     * Rerenders the grids rows, headers and footers, completely replacing all row elements with new ones
     * @category Rendering
     */

  }, {
    key: "renderContents",
    value: function renderContents() {
      var me = this,
          element = me.element,
          headerContainer = me.headerContainer,
          footerContainer = me.footerContainer,
          rowManager = me.rowManager;
      me.emptyCache(); // columns will be "drawn" on render anyway, bail out

      if (me.isPainted) {
        // reset measured header height, to make next call to get headerHeight measure it
        me._headerHeight = null;
        me.callEachSubGrid('refreshHeader', headerContainer);
        me.callEachSubGrid('refreshFooter', footerContainer); // Note that these are hook methods for features to plug in to. They do not do anything.

        me.renderHeader(headerContainer, element);
        me.renderFooter(footerContainer, element);
        me.fixSizes(); // any elements currently used for rows should be released.
        // actual removal of elements is done in SubGrid#clearRows

        var refreshContext = rowManager.removeAllRows();
        rowManager.calculateRowCount(false, true, true);

        if (rowManager.rowCount) {
          // Sets up the RowManager's position for when renderRows calls RowManager#reinitialize
          // so that it renders the correct data block at the correct position.
          rowManager.setPosition(refreshContext);
          me.renderRows();
        }
      }
    } // Render rows etc. on first paint, to make sure Grids element has been laid out

  }, {
    key: "onPaint",
    value: function onPaint() {
      var me = this,
          rowManager = me.rowManager,
          store = me.store,
          element = me.element,
          headerContainer = me.headerContainer,
          bodyContainer = me.bodyContainer,
          footerContainer = me.footerContainer,
          scrollPad = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].scrollBarPadElement;

      if (me.isPainted) {
        return;
      }

      var columnsChanged,
          maxDepth = 0; // See if updateResponsive changed any columns.

      me.columns.on({
        change: function change() {
          return columnsChanged = true;
        },
        single: true
      }); // Cached, updated on resize. Used by RowManager and by the subgrids upon their render

      me._bodyRectangle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_40__["default"].client(me.bodyContainer);
      var bodyOffsetHeight = me.bodyContainer.offsetHeight; // Apply any responsive configs before rendering rows.

      me.updateResponsive(me.width, 0); // If there were any column changes, apply them

      if (columnsChanged) {
        me.callEachSubGrid('refreshHeader', headerContainer);
        me.callEachSubGrid('refreshFooter', footerContainer);
      } // Note that these are hook methods for features to plug in to. They do not do anything.
      // SubGrids take care of their own rendering.


      me.renderHeader(headerContainer, element);
      me.renderFooter(footerContainer, element); // These padding elements are only visible on scrollbar showing platforms.
      // And then, only when the owning element as the b-show-yscroll-padding class added.
      // See refreshVirtualScrollbars where this is synced on the header, footer and scroller elements.

      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].append(headerContainer, scrollPad);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].append(footerContainer, scrollPad);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].append(me.virtualScrollers, scrollPad);

      if (me.autoHeight) {
        me._bodyHeight = rowManager.initWithHeight(element.offsetHeight - headerContainer.offsetHeight - footerContainer.offsetHeight, true);
        bodyContainer.style.height = me.bodyHeight + 'px';
      } else {
        me._bodyHeight = bodyOffsetHeight;
        rowManager.initWithHeight(me._bodyHeight, true);
      }

      me.eachSubGrid(function (subGrid) {
        if (subGrid.header.maxDepth > maxDepth) {
          maxDepth = subGrid.header.maxDepth;
        }
      });
      headerContainer.dataset.maxDepth = maxDepth;
      me.fixSizes();

      if (store.count || !store.isLoading) {
        me.renderRows(false, false);
      }

      me.initScroll();
      me.initInternalEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var me = this; // When displayed inside one of our containers, require a size to be considered visible. Ensures it is painted
      // on display when for example in a tab

      me.requireSize = Boolean(me.owner); // Render as a container. This renders the child SubGrids

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(GridBase.prototype), "render", this).apply(this, arguments); // Sanity check that main element has been given some sizing styles, unless autoHeight is used in which case
      // it will be sized programmatically instead


      if (!me.autoHeight && me.headerContainer.offsetHeight && !me.bodyContainer.offsetHeight) {
        console.warn('Grid element not sized correctly, please check your CSS styles and review how you size the widget');
      }
    } //endregion
    //region Masking and Appearance

    /**
     * Show a load mask with a spinner and the specified message. When using an AjaxStore masking and unmasking is
     * handled automatically, but if you are loading data in other ways you can call this function manually when your
     * load starts.
     * ```
     * myLoadFunction() {
     *   // Show mask before initiating loading
     *   grid.maskBody('Loading data');
     *   // Your custom loading code
     *   load.then(() => {
     *      // Hide the mask when loading is finished
     *      grid.unmaskBody();
     *   });
     * }
     * ```
     * @param {String} loadMask Message to show next to the spinner
     * @returns {Core.widget.Mask}
     */

  }, {
    key: "maskBody",
    value: function maskBody(loadMask) {
      var me = this;

      if (!me.bodyContainer) {
        return;
      } // remove any existing mask


      me.unmaskBody();

      var _me$activeMask = me.activeMask = _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_42__["default"].mask(loadMask, me.element),
          maskElement = _me$activeMask.maskElement;

      maskElement.style.marginTop = "".concat(me.bodyContainer.offsetTop, "px");
      maskElement.style.height = "".concat(me.virtualScrollers.offsetTop + me.virtualScrollers.offsetHeight - me.bodyContainer.offsetTop, "px");
      return me.activeMask;
    }
    /**
     * Hide the load mask.
     */

  }, {
    key: "unmaskBody",
    value: function unmaskBody() {
      var me = this;
      me.loadmaskHideTimer && me.clearTimeout(me.loadmaskHideTimer);
      me.loadmaskHideTimer = null;
      me.activeMask && me.activeMask.destroy();
      me.activeMask = null;
    }
  }, {
    key: "toggleEmptyText",
    value: function toggleEmptyText() {
      if (this.bodyContainer) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].toggleClasses(this.bodyContainer, 'b-grid-empty', !(this.rowManager.rowCount > 0 || this.store.isLoading || this.store.isCommitting));
      }
    } //endregion

  }, {
    key: "bodyConfig",
    get: function get() {
      return {
        reference: 'bodyElement',
        className: 'b-grid-panel-body',
        children: [{
          tag: 'header',
          reference: 'headerContainer',
          className: {
            'b-grid-header-container': 1,
            'b-hidden': this.hideHeaders
          }
        }, {
          reference: 'bodyContainer',
          className: 'b-grid-body-container',
          tabIndex: -1,
          children: [{
            reference: 'verticalScroller',
            className: 'b-grid-vertical-scroller'
          }]
        }, {
          reference: 'virtualScrollers',
          className: 'b-virtual-scrollers',
          style: _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isFirefox ? {
            height: "".concat(_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].scrollBarWidth, "px")
          } : undefined
        }, {
          tag: 'footer',
          reference: 'footerContainer',
          className: {
            'b-grid-footer-container': 1,
            'b-hidden': this.hideFooters
          }
        }]
      };
    }
  }, {
    key: "contentElement",
    get: function get() {
      return this.verticalScroller;
    }
  }, {
    key: "overflowElement",
    get: function get() {
      return this.bodyContainer;
    }
  }, {
    key: "focusElement",
    get: function get() {
      return this.bodyContainer;
    }
  }, {
    key: "columns",
    set: function set(columns) {
      var me = this;

      if (me._columnStore) {
        if (columns) {
          // TODO: @johan: reconfiguring, ie changing whole column set should work.
          // That could mean a total recalculation of subGrids.
          // That's not possible right now, so
          //throw new Error('Cannot reconfigure column set');
          // me._columnStore.clear();
          me._columnStore.data = columns;
        } else {
          me._columnStore.destroy();
        }
      } else {
        // ColumnStore instance
        if (columns instanceof _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_48__["default"]) {
          if (!columns.grid) {
            columns.grid = me;
          }

          me._columnStore = columns;
        } // Array of columns
        else if (Array.isArray(columns)) {
            me._columnStore = new _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_48__["default"]({
              grid: me,
              data: columns
            });
          } // Store config object
          else if (columns) {
              me._columnStore = new _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_48__["default"](Object.assign({
                grid: me
              }, columns));
            } // changes might be triggered when applying state, before grid is rendered
        // TODO: have this run a lighter weight, non-destructive response.
        // onColumnsChanged is a start, but lots of machinery is hooked to render.


        me._columnStore.on('change', me.onColumnsChanged, me);

        me._columnStore.on(Object(_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_48__["columnResizeEvent"])(me.onColumnsResized, me)); // Add touch class for touch devices


        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isTouchDevice) {
          me.touch = true; // apply touchConfig for columns that defines it

          me._columnStore.forEach(function (column) {
            var touchConfig = column.touchConfig;

            if (touchConfig) {
              column.applyState(touchConfig);
            }
          });
        }
      }
    }
    /**
     * Get the {@link Grid.data.ColumnStore ColumnStore} used by this Grid.
     *
     * @property {Grid.data.ColumnStore}
     * @category Common
     * @readonly
     */
    ,
    get: function get() {
      return this._columnStore;
    }
  }, {
    key: "rowManager",
    get: function get() {
      var me = this; // Use row height from CSS if not specified in config. Did not want to turn this into a getter/setter for
      // rowHeight since RowManager will plug its implementation into Grid when created below, and after initial
      // configuration that is what should be used

      if (!me._isRowMeasured) {
        me.measureRowHeight();
      } // RowManager is a plugin, it is configured with its grid as its "client".
      // It uses client.store as its record source.


      return me._rowManager || (me._rowManager = new _row_RowManager_js__WEBPACK_IMPORTED_MODULE_50__["default"]({
        grid: me,
        rowHeight: me.rowHeight,
        rowScrollMode: me.rowScrollMode || 'move',
        autoHeight: me.autoHeight,
        fixedRowHeight: me.fixedRowHeight,
        listeners: {
          changeTotalHeight: me.onRowManagerChangeTotalHeight,
          requestScrollChange: me.onRowManagerRequestScrollChange,
          thisObj: me
        }
      }));
    }
  }, {
    key: "store",
    get: function get() {
      return this._store;
    }
    /**
     * Get/set the store used by this Grid. The setter accepts Store or a configuration object for a store.
     * If the configuration contains a `readUrl`, an AjaxStore will be created.
     * @property {Core.data.Store|Object}
     * @category Common
     */
    ,
    set: function set(store) {
      var me = this,
          rowManager = me.rowManager,
          features = me.initialConfig.features,
          oldStore = me._store;

      if (store !== oldStore) {
        if (oldStore) {
          me.unbindStore(oldStore);
        }

        if (store) {
          if (typeof store === 'string') {
            store = _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_34__["default"].getStore(store);
          }

          if (store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_34__["default"]) {} else {
            var storeCfg = {};

            if (me.data) {
              storeCfg.data = me.data;
            }

            if (features === null || features === void 0 ? void 0 : features.tree) {
              storeCfg.tree = true;
            } // extend GridRowModel to not pollute it with custom fields (if we have multiple grids on page)


            if (!store.modelClass) {
              storeCfg.modelClass = /*#__PURE__*/function (_GridRowModel) {
                _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28___default()(_class, _GridRowModel);

                var _super2 = _createSuper(_class);

                function _class() {
                  _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_25___default()(this, _class);

                  return _super2.apply(this, arguments);
                }

                return _class;
              }(_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_49__["default"]);
            }

            store = new (store.readUrl ? _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_32__["default"] : _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_34__["default"])(Object.assign(storeCfg, store));
          }

          me._store = store;
          me.bindStore(store); // Changing store when painted -> refresh rows to reflect new data

          if (me.isPainted && !me.refreshSuspended) {
            rowManager.reinitialize();
          }
        } else {
          me._store = null;
        }
      }
    }
  }, {
    key: "data",
    get: function get() {
      if (this._store) {
        return this._store.records;
      } else {
        return this._data;
      }
    },
    set: function set(data) {
      if (this._store) {
        this._store.data = data;
      } else {
        this._data = data;
      }
    }
  }, {
    key: "emptyText",
    get: function get() {
      return this._emptyText;
    },
    set: function set(text) {
      this._emptyText = text;
      this.eachSubGrid(function (subGrid) {
        return subGrid.emptyText = text;
      });
    }
  }, {
    key: "bodyHeight",
    get: function get() {
      return this._bodyHeight;
    }
    /**
     * Header height
     * @property {Number}
     * @readonly
     * @category Layout
     */

  }, {
    key: "headerHeight",
    get: function get() {
      var me = this; // measure header if rendered and not stored

      if (me.isPainted && !me._headerHeight) {
        me._headerHeight = me.headerContainer.offsetHeight;
      }

      return me._headerHeight;
    }
  }, {
    key: "autoHeight",
    get: function get() {
      return this._autoHeight;
    },
    set: function set(autoHeight) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].assertBoolean(autoHeight, 'autoHeight');
      this._autoHeight = autoHeight;
    }
    /**
     * Toggle column line visibility. End result might be overruled by/differ between themes.
     * @property {Boolean}
     * @category Misc
     */

  }, {
    key: "columnLines",
    get: function get() {
      return this._columnLines;
    },
    set: function set(columnLines) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].assertBoolean(columnLines, 'columnLines');
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].toggleClasses(this.element, 'b-no-column-lines', !columnLines);
      this._columnLines = columnLines;
    }
  }, {
    key: "scrolling",
    set: function set(scrolling) {
      this._scrolling = scrolling;
    },
    get: function get() {
      return this._scrolling;
    }
  }, {
    key: "hasVerticalOverflow",
    get: function get() {
      var scrollable = this.scrollable; // IE11 and Edge report 1px scroll when no scroll actually exist, which breaks header margin
      // caught by FilterBar test

      return _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isEdge || _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11 ? Math.abs(scrollable.scrollHeight - scrollable.clientHeight) > 1 : scrollable.scrollHeight > scrollable.clientHeight;
    }
    /**
     * Returns content height calculated from row manager
     * @private
     */

  }, {
    key: "contentHeight",
    get: function get() {
      var rowManager = this.rowManager;
      return Math.max(rowManager.totalHeight, rowManager.bottomRow ? rowManager.bottomRow.bottom : 0);
    } // Will return any row which has some part of it in the visible viewport

  }, {
    key: "firstVisibleRow",
    get: function get() {
      return this.rowManager.firstVisibleRow;
    } // Will return the first row which is fully inside visible viewport

  }, {
    key: "firstFullyVisibleRow",
    get: function get() {
      return this.rowManager.firstFullyVisibleRow;
    }
  }], [{
    key: "getLKey",

    /**
     * Animation transition duration in milliseconds.
     * @property {number}
     * @name transitionDuration
     * @category Misc
     */
    value: function getLKey() {
      return '0bfbc212-2a42-11eb-b269-d094663d5c88';
    }
  }, {
    key: "$name",
    //region Config
    get: function get() {
      return 'GridBase';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'gridbase';
    }
  }, {
    key: "delayable",
    get: function get() {
      return {
        onGridScroll: {
          type: 'raf'
        },
        bufferedAfterColumnsResized: 250
      };
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        //region Hidden configs

        /**
         * @hideconfigs autoUpdateRecord, defaults, hideWhenEmpty, itemCls, items, layout, layoutStyle, lazyItems, namedItems, record, textContent, defaultAction, html, htmlCls, tag, textAlign, trapFocus, content, defaultBindProperty, ripple
         */

        /**
         * @hideproperties html, isSettingValues, isValid, items, record, values, content, layoutStyle
         */

        /**
         * @hidefunctions attachTooltip, add, getWidgetById, insert, processWidgetConfig, remove, removeAll
         */
        //endregion

        /**
         * Configure this as `true` to allow elements within cells to be styled as `position: sticky`.
         *
         * Columns which contain sticky content will need to be configured with
         *
         * ```javascript
         *    cellCls : 'b-sticky-cell',
         * ```
         *
         * Or a custom renderer can add the class to the passed cell element.
         *
         * It is up to the application author how to style the cell content. It is recommended that
         * a custom renderer create content with CSS class names which the application author
         * will use to apply the `position`, and matching `margin-top` and `top` styles to keep the
         * content stuck at the grid's top.
         *
         * Note that not all browsers support this CSS feature. A cross browser alternative
         * is to use the {link Grid.feature.StickyCells StickyCells} Feature.
         * @config {Boolean}
         * @category Misc
         */
        enableSticky: null,

        /**
         * An object containing sub grid configuration objects keyed by a `region` property.
         * By default, grid has a 'locked' region (if configured with locked columns) and a 'normal' region.
         * The 'normal' region defaults to use `flex: 1`.
         *
         * This config can be used to reconfigure the "built in" sub grids or to define your own.
         * ```
         * // Redefining the "built in" regions
         * new Grid({
         *   subGridConfigs : {
         *     locked : { flex : 1 },
         *     normal : { width : 100 }
         *   }
         * });
         *
         * // Defining your own multi region sub grids
         * new Grid({
         *   subGridConfigs : {
         *     left   : { width : 100 },
         *     middle : { flex : 1 },
         *     right  : { width  : 100 }
         *   },
         *
         *   columns : {
         *     { field : 'manufacturer', text: 'Manufacturer', region : 'left' },
         *     { field : 'model', text: 'Model', region : 'middle' },
         *     { field : 'year', text: 'Year', region : 'middle' },
         *     { field : 'sales', text: 'Sales', region : 'right' }
         *   }
         * });
         * ```
         * @config {Object}
         * @category Misc
         */
        subGridConfigs: {
          normal: {
            flex: 1
          }
        },
        hideFooters: true
      };
    } // Default settings, applied in grids constructor.

  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Row height in pixels. When set to null, an empty row will be measured and its height will be used as
         * default row height, enabling it to be controlled using CSS
         * @config {Number}
         * @default null
         * @category Common
         */
        rowHeight: null,

        /**
         * Use fixed row height. Setting this to `true` will configure the underlying RowManager to use fixed row
         * height, which sacrifices the ability to use rows with variable height to gain a fraction better
         * performance.
         *
         * Using this setting also ignores the {@link Grid.view.GridBase#config-getRowHeight} function, and thus any
         * row height set in data. Only Grids configured {@link Grid.view.GridBase#config-rowHeight} is used.
         *
         * @config {Boolean}
         * @category Layout
         */
        fixedRowHeight: null,

        /**
         * A function called for each row to determine its height. It is passed a {@link Core.data.Model record} and
         * expected to return the desired height of that records row. If the function returns a falsy value, Grids
         * configured {@link Grid.view.GridBase#config-rowHeight} is used.
         *
         * The default implementation of this function returns the row height from the records
         * {@link Grid.data.GridRowModel#field-rowHeight rowHeight field}.
         *
         * Override this function to take control over how row heights are determined:
         *
         * ```javascript
         * new Grid({
         *    getRowHeight(record) {
         *        if (record.low) {
         *            return 20;
         *        }
         *        else if (record.high) {
         *            return 60;
         *        }
         *
         *        // Will use grids configured rowHeight
         *        return null;
         *    }
         * });
         * ```
         *
         * NOTE: Height set in a Column renderer takes precedence over the height returned by this function.
         *
         * @config {Function} getRowHeight
         * @param {Core.data.Model} getRowHeight.record Record to determine row height for
         * @returns {Number} Desired row height
         * @category Layout
         */
        // used if no rowHeight specified and none found in CSS. not public since our themes have row height
        // specified and this is more of an internal failsafe
        defaultRowHeight: 45,

        /**
         * Text to display when there is no data to display in the grid
         * @config {String}
         * @default
         * @category Common
         */
        emptyText: 'L{noRows}',

        /**
         * Refresh entire row when a record changes (`true`) or, if possible, only the cells affected (`false`).
         *
         * When this is set to `false`, then if a column uses a renderer, cells in that column will still
         * be updated because it is impossible to know whether the cells value will be affected.
         *
         * If a standard, provided Column class is used with no custom renderer, its cells will only be updated
         * if the column's {@link Grid.column.Column#config-field} is changed.
         * @config {Boolean}
         * @default
         * @category Misc
         */
        fullRowRefresh: true,

        /**
         * True to not create any grid column headers
         * @config {Boolean}
         * @default false
         * @category Misc
         */
        hideHeaders: null,

        /**
         * Show "Remove row" item in context menu (if enabled and grid not read only).
         *
         * **DEPRECATED:** Use cellMenu feature configuration instead:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         cellMenu : {
         *             items : {
         *                 removeRow : false
         *             }
         *         }
         *     }
         * });
         *
         * Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.
         *
         * @deprecated 4.0.0
         * @config {Boolean}
         * @default
         * @category Misc
         */
        showRemoveRowInContextMenu: true,

        /**
         * Automatically set grids height to fit all rows (no scrolling in the grid). In general you should avoid
         * using `autoHeight: true`, since it will bypass Grids virtual rendering and render all rows at once, which
         * in a larger grid is really bad for performance.
         * @config {Boolean}
         * @default false
         * @category Layout
         */
        autoHeight: null,

        /**
         * Store that holds records to display in the grid, or a store config object.
         * A store will be created if none is specified
         * @config {Core.data.Store|Object}
         * @category Common
         */
        store: {},

        /**
         * Data to set in grids store (a Store will be created if none is specified)
         * @config {Object[]}
         * @category Common
         */
        data: null,

        /**
         * Column definitions for the grid, will be used to create Column instances that are added to a ColumnStore:
         *
         * ```
         * new Grid({
         *   columns : [
         *     { text : 'Alias', field : 'alias' },
         *     { text : 'Superpower', field : 'power' }
         *   ]
         * });
         * ```
         *
         * Also accepts a store config object:
         *
         * ```
         * new Grid({
         *   columns : {
         *     data : [
         *       { text : 'Alias', field : 'alias' },
         *       { text : 'Superpower', field : 'power' }
         *     ],
         *     listeners : {
         *       update() {
         *         // Some update happened
         *       }
         *     }
         *   }
         * });
         * ```
         *
         * This store can be accessed using {@link #property-columns}:
         *
         * ```
         * grid.columns.add({ field : 'column', text : 'New column' });
         * ```
         * @config {Object[]|Object}
         * @category Common
         */
        columns: [],

        /**
         * Region to which columns are added when they have none specified
         * @config {String}
         * @default
         * @category Misc
         */
        defaultRegion: 'normal',

        /**
         * true to destroy the store when the grid is destroyed
         * @config {Boolean}
         * @default false
         * @category Misc
         */
        destroyStore: null,

        /**
         * Set to true to allow text selection in the grid cells
         * @config {Boolean}
         * @default false
         * @category Selection
         */
        enableTextSelection: null,

        /**
         * A message to be shown when a store or Crud Manager is performing a remote operation. Set to `null` to disable default load mask.
         *
         * To create a custom load mask need to subscribe to the grid's store events and show {@link Core.widget.Mask Mask}
         * on {@link Core.data.AjaxStore#event-beforeRequest beforeRequest} and hide it on {@link Core.data.AjaxStore#event-afterRequest afterRequest}.
         * Note, for Crud Manager events are different: show Mask on `beforeSend` and hide it on `requestDone` and `requestFail`.
         *
         * ```javascript
         * const grid = new Grid({
         *     loadMask : null,
         *     syncMask : null
         * });
         *
         * grid.store.on({
         *     beforeRequest : () => {
         *         Mask.mask({
         *             text : 'Data is loading...',
         *             mode : 'dark-blur'
         *         }, document.body);
         *     }
         *     afterRequest : () => {
         *         Mask.unmask(document.body);
         *     }
         * });
         *
         * store.load();
         * ```
         *
         * @config {String|null}
         * @default "Loading..."
         * @category Misc
         */
        loadMask: 'L{loadMask}',

        /**
         * A {@link Core.widget.Mask} config object to adjust the {@link Core.widget.Widget#config-maskDefaults}
         * when data is loading. The message and optional configuration from the {@link #config-loadMask} config
         * take priority over these options, just as they do for `maskDefaults`, respectively.
         *
         * The final mask configuration for a load mask is as if the following were applied:
         *
         * ```
         *  Object.assign({},
         *      grid.maskDefaults,
         *      grid.loadMaskDefaults,
         *      grid.loadMask);
         * ```
         * @config {Object|Core.widget.Mask}
         * @category Misc
         */
        loadMaskDefaults: {
          useTransition: true,
          showDelay: 1000
        },

        /**
         * A {@link Core.widget.Mask} config object to adjust the {@link Core.widget.Widget#config-maskDefaults}
         * when an error occurs loading data.
         *
         * The final mask configuration for an error mask is as if the following were applied:
         *
         * ```
         *  Object.assign({},
         *      grid.maskDefaults,
         *      grid.loadMaskDefaults,
         *      grid.loadMaskError,
         *      errorMessage);
         * ```
         * @config {Object|Core.widget.Mask}
         * @category Misc
         */
        loadMaskError: {
          icon: 'b-icon b-icon-warning',
          autoClose: 3000,
          showDelay: 0
        },

        /**
         * Grids change the `maskDefaults` to cover only their `body` element.
         * @config {Object|Core.widget.Mask}
         * @category Misc
         */
        maskDefaults: {
          cover: 'body',
          target: 'element'
        },

        /**
         * A message to be shown when Crud Manager is persisting changes on the server. Set to `null` to disable default sync mask.
         * This config is similar to {@link #config-loadMask} but designed for saving data.
         *
         * To create a custom sync mask need to subscribe to the Crud Manager events and show {@link Core.widget.Mask Mask}
         * on `beforeSend` and hide it on `requestDone` and `requestFail`.
         *
         * @config {String|null}
         * @default "Saving changes, please wait..."
         * @category Misc
         */
        syncMask: 'L{syncMask}',

        /**
         * Set to `false` to inhibit column lines
         * @config {Boolean}
         * @default
         * @category Misc
         */
        columnLines: true,

        /**
         * Set to `true` to stretch the last column in a grid with all fixed width columns
         * to fill extra available space if the grid's width is wider than the sum of all
         * configured column widths.
         * @config {Boolean}
         * @default
         * @category Layout
         */
        fillLastColumn: true,

        /**
         * Set to `false` to only measure cell contents when double clicking the edge between column headers.
         * @config {Boolean}
         * @default
         * @category Layout
         */
        resizeToFitIncludesHeader: true,

        /**
         * Set to `false` to prevent remove row animation and remove the delay related to that.
         * @config {Boolean}
         * @default
         * @category Misc
         */
        animateRemovingRows: !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].isIE11,
        // IE11 doesn't have reliable firing of transitionend

        /**
         * Set to `true` to not get a warning when using another base class than GridRowModel for your grid data. If
         * you do, and would like to use the full feature set of the grid then include the fields from GridRowModel
         * in your model definition.
         * @config {Boolean}
         * @default false
         * @category Misc
         */
        disableGridRowModelWarning: null,
        headerClass: _Header_js__WEBPACK_IMPORTED_MODULE_53__["default"],
        footerClass: _Footer_js__WEBPACK_IMPORTED_MODULE_54__["default"],
        testPerformance: false,
        // TODO: break out as strategies
        positionMode: 'translate',
        // translate, translate3d, position
        rowScrollMode: 'move',
        // move, dom, all

        /**
         * Grid monitors window resize by default.
         * @config {Boolean}
         * @default true
         * @category Misc
         */
        monitorResize: true,

        /**
         * An object containing Feature configuration objects (or `true` if no configuration is required)
         * keyed by the Feature class name in all lowercase.
         * @config {Object}
         * @category Common
         * @typings any
         */
        features: true,

        /**
         * Configures whether the grid is scrollable in the `Y` axis. This is used to configure a {@link Grid.util.GridScroller}.
         * See the {@link #config-scrollerClass} config option.
         * @config {Boolean|Object|Core.helper.util.Scroller}
         * @category Scrolling
         */
        scrollable: {
          // Just Y for now until we implement a special grid.view.Scroller subclass
          // Which handles the X scrolling of subgrids.
          overflowY: true
        },

        /**
         * The class to instantiate to use as the {@link #config-scrollable}. Defaults to {@link Grid.util.GridScroller}.
         * @config {Core.helper.util.Scroller}
         * @category Scrolling
         */
        scrollerClass: _util_GridScroller_js__WEBPACK_IMPORTED_MODULE_52__["default"],

        /**
         * Configuration values for the {@link Grid.util.ScrollManager} class.
         * @config {Object}
         * @category Scrolling
         */
        scrollManager: null,

        /**
         * Configure as `true` to have the grid show a red "changed" tag in cells who's
         * field value has changed and not yet been committed.
         * @config {Boolean}
         * @default false
         * @category Misc
         */
        showDirty: null,
        refreshSuspended: 0,

        /**
         * Animation transition duration in milliseconds.
         * @config {Number}
         * @default
         * @category Misc
         */
        transitionDuration: 500,

        /**
         * Event which is used to show context menus.
         * Available options are: 'contextmenu', 'click', 'dblclick'.
         * Default value is 'contextmenu'
         * @config {String}
         * @category Misc
         */
        contextMenuTriggerEvent: 'contextmenu',
        localizableProperties: ['emptyText', 'loadMask', 'syncMask'],
        asyncEventSuffix: ''
      };
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        _selectedRecords: [],
        _verticalScrollHeight: 0,
        virtualScrollHeight: 0,
        _scrollTop: null
      };
    }
  }, {
    key: "deprecatedEvents",
    get: function get() {
      return {
        cellContextMenuBeforeShow: {
          product: 'Grid',
          invalidAsOfVersion: '5.0.0',
          message: '`cellContextMenuBeforeShow` event is deprecated, in favor of `cellMenuBeforeShow` event. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.'
        },
        cellContextMenuShow: {
          product: 'Grid',
          invalidAsOfVersion: '5.0.0',
          message: '`cellContextMenuShow` event is deprecated, in favor of `cellMenuShow` event. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.'
        },
        headerContextMenuBeforeShow: {
          product: 'Grid',
          invalidAsOfVersion: '5.0.0',
          message: '`headerContextMenuBeforeShow` event is deprecated, in favor of `headerMenuBeforeShow` event. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.'
        },
        headerContextMenuShow: {
          product: 'Grid',
          invalidAsOfVersion: '5.0.0',
          message: '`headerContextMenuShow` event is deprecated, in favor of `headerMenuShow` event. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.'
        },
        contextMenuItem: {
          product: 'Grid',
          invalidAsOfVersion: '5.0.0',
          message: '`contextMenuItem` event is deprecated, in favor of `cellMenuItem` and `headerMenuItem` events. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.'
        },
        contextMenuToggleItem: {
          product: 'Grid',
          invalidAsOfVersion: '5.0.0',
          message: '`contextMenuToggleItem` event is deprecated, in favor of `cellMenuToggleItem` and `headerMenuToggleItem` events. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.'
        }
      };
    }
  }]);

  return GridBase;
}(_Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_43__["default"].mixin(_Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_46__["default"], _Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_47__["default"], _mixin_GridElementEvents_js__WEBPACK_IMPORTED_MODULE_55__["default"], _mixin_GridFeatures_js__WEBPACK_IMPORTED_MODULE_56__["default"], _mixin_GridNavigation_js__WEBPACK_IMPORTED_MODULE_57__["default"], _mixin_GridResponsive_js__WEBPACK_IMPORTED_MODULE_58__["default"], _mixin_GridSelection_js__WEBPACK_IMPORTED_MODULE_59__["default"], _mixin_GridState_js__WEBPACK_IMPORTED_MODULE_60__["default"], _mixin_GridSubGrids_js__WEBPACK_IMPORTED_MODULE_61__["default"])); // Register this widget type with its Factory



GridBase.initClass();
_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_41__["default"].setVersion('grid', '4.0.2');
GridBase._$name = 'GridBase';

/***/ }),

/***/ "./lib/Grid/view/Header.js":
/*!*********************************!*\
  !*** ./lib/Grid/view/Header.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Header; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _Bar_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./Bar.js */ "./lib/Grid/view/Bar.js");
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");



























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _templateObject2() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18___default()(["\n                <div class=\"b-grid-header\" data-column=\"", "\" data-column-id=\"", "\" ", ">\n                    <div class=\"b-grid-header-text\">\n                        <div class=\"b-grid-header-text-content\"></div>\n                    </div>\n                    ", "\n                    <div class=\"b-grid-header-resize-handle\"></div>\n                </div>\n            "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18___default()(["\n            <div class=\"b-grid-header-scroller b-grid-header-scroller-", "\">\n                <div data-reference=\"headersElement\" class=\"b-grid-headers b-grid-headers-", "\" data-region=\"", "\" data-max-depth=\"", "\" data-reference=\"headersElement\"></div>\n            </div>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_24___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Grid/view/Header
 */

/**
 * The Grid header, which contains simple columns but also allows grouped columns. One instance is created and used per SubGrid
 * automatically, you should not need to instantiate this class manually. See {@link Grid.column.Column} for information about
 * column configuration.
 *
 * @extends Grid/view/Bar
 * @internal
 *
 * @externalexample grid/Header.js
 */

var Header = /*#__PURE__*/function (_Bar) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default()(Header, _Bar);

  var _super = _createSuper(Header);

  function Header() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default()(this, Header);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20___default()(Header, [{
    key: "startConfigure",
    value: function startConfigure(config) {
      config.scrollable.overflowX = 'hidden-scroll';

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Header.prototype), "startConfigure", this).call(this, config);
    }
  }, {
    key: "template",
    value: function template() {
      var me = this,
          region = me.region;
      return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].tpl(_templateObject(), region, region, region, me.maxDepth);
    }
  }, {
    key: "contentTemplate",

    /**
     * Header template, recursive template for column headers.
     * Style not included because of CSP. Widths are fixed up in
     * {@link #function-fixHeaderWidths}
     * @private
     */
    value: function contentTemplate(column) {
      var me = this;

      if (column.hidden) {
        return '';
      } else {
        /* eslint-disable */
        return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].tpl(_templateObject2(), column.field || '', column.id, column.isFocusable ? 'tabindex="0"' : '', column.children ? "\n                    <div class=\"b-grid-header-children\">\n                            ".concat(column.children.map(function (child) {
          return me.contentTemplate(child);
        }).join(''), "\n                    </div>\n                    ") : '');
        /* eslint-enable */
      }
    } // used by safari to fix flex when rows width shrink below this value

  }, {
    key: "calculateMinWidthForSafari",
    value: function calculateMinWidthForSafari() {
      var minWidth = 0,
          columns = this.columns.visibleColumns;
      columns.forEach(function (column) {
        minWidth += column.calculateMinWidth();
      });
      return minWidth;
    }
    /**
     * Fix header widths (flex or fixed width) after rendering. Not a part of template any longer because of CSP
     * @private
     */

  }, {
    key: "fixHeaderWidths",
    value: function fixHeaderWidths() {
      this.fixCellWidths();
    }
  }, {
    key: "refreshHeaders",
    value: function refreshHeaders() {
      var me = this; // run renderers, not done from template to work more like cell rendering

      me.columns.traverse(function (column) {
        var headerElement = me.getBarCellElement(column.id);

        if (headerElement) {
          var _DomClassList;

          var classList = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_28__["default"]((_DomClassList = {
            'b-grid-header': 1,
            'b-grid-header-parent': column.isParent
          }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_DomClassList, "b-level-".concat(column.childLevel), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_DomClassList, "b-depth-".concat(column.meta.depth), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_DomClassList, "b-grid-header-align-".concat(column.align), column.align), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_DomClassList, 'b-grid-header-resizable', column.resizable && column.isLeaf), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_DomClassList, column.cls, column.cls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_DomClassList, 'b-last-parent', column.isParent && column.isLastInSubGrid), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_DomClassList, 'b-last-leaf', column.isLeaf && column.isLastInSubGrid), _DomClassList));
          var html = column.text;
          headerElement.className = classList;

          if (column.headerRenderer) {
            html = column.headerRenderer.call(column.thisObj || me, {
              column: column,
              headerElement: headerElement
            });
          }

          if (column.icon) {
            html = "<i class=\"".concat(column.icon, "\"></i>") + (html || '');
          }

          var innerEl = headerElement.querySelector('.b-grid-header-text-content');

          if (innerEl) {
            innerEl.innerHTML = html || '';
          }
        }
      });
      me.fixHeaderWidths();
    }
  }, {
    key: "initDepths",

    /**
     * Depths are used for styling of grouped headers. Sets them on meta.
     * @private
     */
    value: function initDepths() {
      var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.columns.topColumns;
      var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var me = this,
          maxDepth = 0;
      if (parent && parent.meta) parent.meta.depth++;

      var _iterator = _createForOfIteratorHelper(columns),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var column = _step.value;
          // TODO: this should maybe move
          column.meta.depth = 0;

          if (column.children) {
            me.initDepths(column.children.filter(me.columns.chainedFilterFn), column);
            if (column.meta.depth && parent) parent.meta.depth += column.meta.depth;
          }

          if (column.meta.depth > maxDepth) maxDepth = column.meta.depth;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!parent) {
        me.maxDepth = maxDepth;
      }

      return maxDepth;
    } //endregion
    //region Getters

    /**
     * Get the header cell element for the specified column.
     * @param {String} columnId Column id
     * @returns {HTMLElement} Header cell element
     */

  }, {
    key: "getHeader",
    value: function getHeader(columnId) {
      return this.getBarCellElement(columnId);
    } //endregion

  }, {
    key: "refreshContent",
    value: function refreshContent() {
      var me = this;
      me.content = me.columns.topColumns.map(function (col) {
        return me.contentTemplate(col);
      }).join('');
      me.refreshHeaders();
    }
  }, {
    key: "onPaint",
    value: function onPaint(_ref) {
      var firstPaint = _ref.firstPaint;

      if (firstPaint) {
        this.refreshContent();
      }
    }
  }, {
    key: "subGrid",
    get: function get() {
      return this._subGrid;
    },
    set: function set(subGrid) {
      this._subGrid = subGrid;
      this.id = subGrid.id + '-header';
    }
  }, {
    key: "region",
    get: function get() {
      return this.subGrid && this.subGrid.region;
    }
  }, {
    key: "overflowElement",
    get: function get() {
      return this.headersElement;
    }
  }, {
    key: "columns",
    get: function get() {
      var me = this,
          result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Header.prototype), "columns", this);

      if (!me.columnsDetacher) {
        // columns is a chained store, it will be repopulated from master when columns change.
        // That action always triggers change with action dataset.
        me.columnsDetacher = result.on({
          change: function change() {
            me.initDepths();
          },
          thisObj: me
        });
        me.initDepths();
      }

      return result;
    },
    set: function set(columns) {
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_25___default()(Header.prototype), "columns", columns, this, true);
    }
  }, {
    key: "contentElement",
    get: function get() {
      return this.element.firstElementChild;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'Header';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'gridheader';
    }
  }]);

  return Header;
}(_Bar_js__WEBPACK_IMPORTED_MODULE_26__["default"]); // Register this widget type with its Factory



Header.initClass();
Header._$name = 'Header';

/***/ }),

/***/ "./lib/Grid/view/SubGrid.js":
/*!**********************************!*\
  !*** ./lib/Grid/view/SubGrid.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SubGrid; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _column_Column_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _util_SubGridScroller_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../util/SubGridScroller.js */ "./lib/Grid/util/SubGridScroller.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_29___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';








/**
 * @module Grid/view/SubGrid
 */

/**
 * A SubGrid is a part of the grid (it has at least one and normally no more than two, called locked and normal). It
 * has its own header, which holds the columns to display rows for in the SubGrid. SubGrids are created by Grid, you
 * should not need to create instances directly.
 *
 * If not configured with a width or flex, the SubGrid will be sized to fit its columns. In this case, if all columns
 * have a fixed width (not using flex) then toggling columns will also affect the width of the SubGrid.
 *
 * @extends Core/widget/Widget
 */

var SubGrid = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_28___default()(SubGrid, _Widget);

  var _super = _createSuper(SubGrid);

  function SubGrid() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24___default()(this, SubGrid);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25___default()(SubGrid, [{
    key: "construct",
    //endregion
    //region Init

    /**
     * SubGrid constructor
     * @param config
     * @private
     */
    value: function construct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(SubGrid.prototype), "construct", this).call(this, config);

      this.rowManager.on('addrows', this.onAddRow, this);
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _me$fakeScroller;

      var me = this;
      me.header.destroy();
      me.footer.destroy();
      (_me$fakeScroller = me.fakeScroller) === null || _me$fakeScroller === void 0 ? void 0 : _me$fakeScroller.destroy();
      me.virtualScrollerElement.remove();
      me.splitterElement.remove();
      me.headerSplitter.remove();
      me.scrollerSplitter.remove();
      me.footerSplitter.remove();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(SubGrid.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "changeHeader",
    value: function changeHeader() {
      return new this.headerClass(this.barConfig);
    }
  }, {
    key: "changeFooter",
    value: function changeFooter() {
      return new this.footerClass(this.barConfig);
    } //endregion
    //region Splitters

    /**
     * Toggle (add/remove) class for splitters
     * @param {String} cls class name
     * @param {Boolean} [add] actions. Set to `true` to add class, `false` to remove
     * @private
     */

  }, {
    key: "toggleSplitterCls",
    value: function toggleSplitterCls(cls) {
      var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var me = this,
          splitters = [me.splitterElement, me.headerSplitter, me.footerSplitter, me.scrollerSplitter];
      splitters.forEach(function (el) {
        return el === null || el === void 0 ? void 0 : el.classList[add ? 'add' : 'remove'](cls);
      });
    } //endregion
    //region Template

  }, {
    key: "changeElement",
    value: function changeElement(element) {
      var _className;

      var region = this.region;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(SubGrid.prototype), "changeElement", this).call(this, {
        className: (_className = {
          'b-grid-subgrid': 1
        }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23___default()(_className, "b-grid-subgrid-".concat(region), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23___default()(_className, 'b-grid-horizontal-scroller', 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_23___default()(_className, 'b-grid-subgrid-collapsed', this.collapsed), _className),
        dataset: {
          region: region
        }
      });
    }
  }, {
    key: "changeVirtualScrollerElement",
    // Added to DOM in  Grid `get bodyConfig`
    value: function changeVirtualScrollerElement() {
      var references = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].createElement({
        reference: 'virtualScrollerElement',
        className: 'b-virtual-scroller',
        dataset: {
          region: this.region
        },
        children: [{
          reference: 'virtualScrollerWidth',
          className: 'b-virtual-width'
        }]
      });
      this.virtualScrollerWidth = references.virtualScrollerWidth;
      return references.virtualScrollerElement;
    }
  }, {
    key: "changeSplitterElement",
    value: function changeSplitterElement() {
      var references = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].createElement({
        reference: 'splitterElement',
        className: {
          'b-grid-splitter': 1,
          'b-grid-splitter-collapsed': this.collapsed,
          'b-hide-display': 1 // GridSubGrids determines visibility

        },
        dataset: {
          region: this.region
        },
        children: [{
          className: 'b-grid-splitter-inner b-grid-splitter-main',
          children: [{
            className: 'b-grid-splitter-buttons',
            reference: 'splitterButtons',
            children: [{
              tag: 'i',
              className: 'b-icon b-icon-collapse-gridregion'
            }, {
              tag: 'i',
              className: 'b-icon b-icon-expand-gridregion'
            }]
          }]
        }]
      });
      this.splitterButtons = references.splitterButtons;
      return references.splitterElement;
    }
  }, {
    key: "changeHeaderSplitter",
    value: function changeHeaderSplitter() {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].createElement(this.splitterConfig);
    }
  }, {
    key: "changeScrollerSplitter",
    value: function changeScrollerSplitter() {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].createElement(this.splitterConfig);
    }
  }, {
    key: "changeFooterSplitter",
    value: function changeFooterSplitter() {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].createElement(this.splitterConfig);
    }
  }, {
    key: "hideSplitter",
    value: function hideSplitter() {
      this.splitterElement.classList.add('b-hide-display');
      this.headerSplitter.classList.add('b-hide-display');
      this.scrollerSplitter.classList.add('b-hide-display');
      this.footerSplitter.classList.add('b-hide-display');
      this.$showingSplitter = false;
    }
  }, {
    key: "showSplitter",
    value: function showSplitter() {
      this.splitterElement.classList.remove('b-hide-display');
      this.headerSplitter.classList.remove('b-hide-display');
      this.scrollerSplitter.classList.remove('b-hide-display');
      this.footerSplitter.classList.remove('b-hide-display');
      this.$showingSplitter = true;
    } //endregion
    //region Render

  }, {
    key: "render",
    value: function render() {
      var _get2;

      var me = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(SubGrid.prototype), "render", this)).call.apply(_get2, [this].concat(args)); // Unit tests create naked SubGrids so we have to do this.


      if (me.grid) {
        me.updateHasFlex();
        me.element.parentNode.insertBefore(me.splitterElement, me.element.nextElementSibling);
        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].on({
          element: me.grid.element,
          delegate: ".b-grid-splitter[data-region=".concat(me.region, "]"),
          mouseover: 'onSplitterMouseOver',
          mouseout: 'onSplitterMouseOut',
          thisObj: me
        });
        me._collapsed && me.collapse();
      }
    }
  }, {
    key: "refreshHeader",
    value: function refreshHeader() {
      this.header.refreshContent();
    }
  }, {
    key: "refreshFooter",
    value: function refreshFooter() {
      var _this$footer;

      (_this$footer = this.footer) === null || _this$footer === void 0 ? void 0 : _this$footer.refreshContent();
    } // Override to iterate header and footer.

  }, {
    key: "eachWidget",
    value: function eachWidget(fn) {
      var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var me = this,
          widgets = [me.header, me.footer];

      for (var i = 0; i < widgets.length; i++) {
        var widget = widgets[i];

        if (fn(widget) === false) {
          return;
        }

        if (deep && widget.eachWidget) {
          widget.eachWidget(fn, deep);
        }
      }
    } //endregion
    //region Size & resize

    /**
     * Sets cell widths. Cannot be done in template because of CSP
     * @private
     */

  }, {
    key: "fixCellWidths",
    value: function fixCellWidths(rowElement) {
      var visibleColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!visibleColumns) visibleColumns = this.columns.bottomColumns.filter(function (col) {
        return !col.hidden;
      }); // fix cell widths, no longer allowed in template because of CSP

      var cell = rowElement.firstElementChild,
          i = 0;

      while (cell) {
        var column = visibleColumns[i];

        if (column.minWidth) {
          cell.style.minWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].setLength(column.minWidth);
        } // either flex or width, flex has precedence


        if (column.flex) {
          cell.style.flex = column.flex;
          cell.style.width = '';
        } else if (column.width) {
          // https://app.assembla.com/spaces/bryntum/tickets/8041
          // Although header and footer elements must be sized using flex-basis to avoid the busting out problem,
          // grid cells MUST be sized using width since rows are absolutely positioned and will not cause the
          // busting out problem, and rows will not stretch to shrinkwrap the cells unless they are widthed with
          // width.
          cell.style.width = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].setLength(column.width); // IE11 calculates flexbox container width based on min-width rather than actual width. When column
          // has width defined greater than minWidth, row may have incorrect width

          if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].isIE11) {
            cell.style.flex = '';
            cell.style.minWidth = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].setLength(column.calcMinWidth);
          }
        } else {
          cell.style.flex = cell.style.width = cell.style.minWidth = '';
        }

        cell = cell.nextElementSibling;
        i++;
      }
    }
  }, {
    key: "fixWidths",

    /**
     * Sets header width and scroller width (if needed, depending on if using flex). Might also change the subgrids
     * width, if it uses a width calculated from its columns.
     * @private
     */
    value: function fixWidths() {
      var me = this,
          element = me.element,
          header = me.header,
          footer = me.footer;

      if (!me.collapsed) {
        if (me.flex) {
          header.flex = me.flex;

          if (footer) {
            footer.flex = me.flex;
          }

          element.style.flex = me.flex;
        } else {
          // If width is calculated and no column is using flex, check if total width is less than width. If so,
          // recalculate width and bail out of further processing (since setting width will trigger again)
          if (me.hasCalculatedWidth && !me.columns.some(function (col) {
            return !col.hidden && col.flex;
          }) && me.totalFixedWidth !== me.width) {
            me.width = me.totalFixedWidth; // Setting width above clears the hasCalculatedWidth flag, but we want to keep it set to react
            // correctly next time

            me.hasCalculatedWidth = true;
            return;
          }

          var totalWidth = me.width;

          if (!totalWidth) {
            totalWidth = 0; // summarize column widths, needed as container width when not using flex widths and for correct
            // overflow check in Edge

            var _iterator = _createForOfIteratorHelper(me.columns),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var col = _step.value;
                if (!col.flex && !col.hidden) totalWidth += col.width;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } // rows are absolutely positioned, meaning that their width won't affect container width
          // hence we must set it, if not using flex


          element.style.width = "".concat(totalWidth, "px");
          header.width = totalWidth;

          if (footer) {
            footer.width = totalWidth;
          }
        }

        me.syncScrollingPartners(false);
      }
    } // Safari/Edge do not shrink cells the same way as chrome & ff does without having a width set on the row

  }, {
    key: "fixRowWidthsInSafariEdge",
    value: function fixRowWidthsInSafariEdge() {
      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].isSafari || _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].isEdge) {
        var me = this,
            region = me.region,
            header = me.header,
            minWidth = header.calculateMinWidthForSafari(); // fix row widths for safari, it does not size flex cells correctly at small widths otherwise.
        // there should be a css solution, but I have failed to find it

        me.rowManager.forEach(function (row) {
          // This function runs on resize and rendering a SubGrid triggers a resize. When adding a new SubGrid
          // on the fly elements wont exists for it yet, so ignore...
          var element = row.getElement(region); // it is worth noting that setting a width does not prevent the row from growing beyond that with
          // when making view wider, it is used in flex calculation more like a min-width

          if (element) {
            element.style.width = "".concat(minWidth, "px");
          }
        });
        header.headersElement.style.width = "".concat(minWidth, "px");
      }
    }
    /**
     * Get/set SubGrid width, which also sets header and footer width (if available).
     * @property {Number}
     */

  }, {
    key: "onInternalResize",

    /**
     * Called when grid changes size. SubGrid determines if it has changed size and triggers scroll (for virtual
     * rendering in cells to work when resizing etc.)
     * @private
     */
    value: function onInternalResize(element, newWidth, newHeight, oldWidth, oldHeight) {
      var me = this,
          grid = me.grid; // Widget caches dimensions

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(SubGrid.prototype), "onInternalResize", this).call(this, element, newWidth, newHeight, oldWidth, oldHeight); // Unit tests create naked SubGrids so we have to do this.


      if (grid) {
        me.syncSplitterButtonPosition();

        if (newWidth !== oldWidth) {
          // trigger scroll, in case anything is done on scroll it needs to be done now also
          grid.trigger('horizontalScroll', {
            subGrid: me,
            grid: grid,
            scrollLeft: me.scrollable.x
          });
          me.refreshFakeScroll();
          me.fixRowWidthsInSafariEdge();
        }

        me.trigger('afterInternalResize', me);
      }
    }
    /**
     * Keeps the parallel splitters in the header, footer and fake scroller synced in terms
     * of being collapsed or not.
     * @private
     */

  }, {
    key: "syncParallelSplitters",
    value: function syncParallelSplitters(collapsed) {
      var me = this,
          grid = me.grid;

      if (me.splitterElement && me.$showingSplitter) {
        me.toggleSplitterCls('b-grid-splitter-collapsed', collapsed);
      } else {
        // If we're the last, we don't own a splitter, we use the previous region's splitter
        var prevGrid = grid.getSubGrid(grid.getPreviousRegion(me.region)); // If there's a splitter before us, sync it with our state.

        if (prevGrid && prevGrid.splitterElement) {
          prevGrid.syncParallelSplitters(collapsed);
        }
      }
    }
  }, {
    key: "onSplitterMouseOver",
    value: function onSplitterMouseOver() {
      var me = this,
          nextSibling = me.nextSibling; // No hover effect when collapsed

      if (!me.collapsed && (!nextSibling || !nextSibling.collapsed)) {
        me.toggleSplitterCls('b-hover');
      }

      me.startSplitterButtonSyncing();
    }
  }, {
    key: "onSplitterMouseOut",
    value: function onSplitterMouseOut() {
      var me = this,
          nextSibling = me.nextSibling;
      me.toggleSplitterCls('b-hover', false);

      if (!me.collapsed && (!nextSibling || !nextSibling.collapsed)) {
        me.stopSplitterButtonSyncing();
      }
    }
  }, {
    key: "startSplitterButtonSyncing",
    value: function startSplitterButtonSyncing() {
      var me = this;

      if (me.splitterElement) {
        me.syncSplitterButtonPosition();

        if (!me.splitterSyncScrollListener) {
          me.splitterSyncScrollListener = me.grid.scrollable.on({
            scroll: 'syncSplitterButtonPosition',
            thisObj: me
          });
        }
      }
    }
  }, {
    key: "stopSplitterButtonSyncing",
    value: function stopSplitterButtonSyncing() {
      if (this.splitterSyncScrollListener) {
        this.splitterSyncScrollListener();
        this.splitterSyncScrollListener = null;
      }
    }
  }, {
    key: "syncSplitterButtonPosition",
    value: function syncSplitterButtonPosition() {
      var me = this;
      me.splitterButtons.style.transform = "translateY(".concat(me.grid.scrollable.y + me.grid.bodyHeight / 2 - (me.headerSplitter ? me.grid.headerHeight : 0), "px)");
    }
    /**
     * Get the "viewport" for the SubGrid as a Rectangle
     * @property {Core.helper.util.Rectangle}
     * @readonly
     */

  }, {
    key: "updateHasFlex",

    /**
     * Called when updating column widths to apply 'b-has-flex' which is used when fillLastColumn is configured.
     * @internal
     */
    value: function updateHasFlex() {
      var hasFlex = this.columns.visibleColumns.some(function (column) {
        return column.flex;
      });
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].toggleClasses(this.element, ['b-has-flex'], hasFlex);
    } //endregion
    //region Scroll

  }, {
    key: "refreshFakeScroll",

    /**
     * Fixes widths of fake scrollers
     * @private
     */
    value: function refreshFakeScroll() {
      var me = this,
          element = me.element,
          virtualScrollerElement = me.virtualScrollerElement,
          virtualScrollerWidth = me.virtualScrollerWidth,
          totalFixedWidth = me.totalFixedWidth,
          store = me.store,
          header = me.header,
          footer = me.footer,
          scroller = me.scrollable; // Use a fixed scroll width if grid is empty, to make it scrollable without rows
      // https://app.assembla.com/spaces/bryntum/tickets/7184

      scroller.scrollWidth = (store === null || store === void 0 ? void 0 : store.count) ? null : totalFixedWidth; // Scroller lays out in the same way as subgrid.
      // If we are flexed, the scroller is flexed etc.

      virtualScrollerElement.style.width = element.style.width;
      virtualScrollerElement.style.flex = element.style.flex;

      if (!me.collapsed) {
        if (me.overflowingHorizontally) {
          virtualScrollerWidth.style.width = "".concat(scroller.scrollWidth, "px");
          header.element.classList.add('b-overflowing');
          footer.element.classList.add('b-overflowing'); // If *any* SubGrids have horizontal overflow, the main grid
          // has to show its virtual horizontal scollbar.

          me.grid.virtualScrollers.classList.remove('b-hide-display');
        } else {
          virtualScrollerWidth.style.width = 0;
          header.element.classList.remove('b-overflowing');
          footer.element.classList.remove('b-overflowing');
        }
      }
    }
    /**
     * Init scroll syncing for header and footer (if available).
     * @private
     */

  }, {
    key: "initScroll",
    value: function initScroll() {
      var me = this,
          scroller = me.scrollable,
          virtualScrollerElement = me.virtualScrollerElement;
      me.syncPartnersOnFrame = me.createOnFrame(me.syncScrollingPartners);

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].isFirefox) {
        scroller.element.addEventListener('wheel', function (event) {
          if (event.deltaX) {
            scroller.x += event.deltaX;
            event.preventDefault();
          }
        });
      }

      scroller.yScroller = me.grid.scrollable; // Add our Scroller to the controlling GridScroller

      scroller.yScroller.addScroller(scroller); // Create a Scroller for the fake horizontal scrollbar so that it can partner

      me.fakeScroller = new _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_37__["default"]({
        element: virtualScrollerElement,
        overflowX: true
      }); // Sync scrolling partners (header, footer) when our xScroller reports a scroll.
      // Also fires horizontalscroll

      scroller.on({
        scroll: 'onSubGridScroll',
        scrollend: 'onSubGridScrollEnd',
        thisObj: me
      });
      scroller.addPartner(me.fakeScroller, 'x');
      scroller.addPartner(me.header.scrollable, 'x');
      scroller.addPartner(me.footer.scrollable, 'x');
    }
  }, {
    key: "onSubGridScrollEnd",
    value: function onSubGridScrollEnd() {
      // If we do not have the direct update flag set which would ensure a sync in each scroll event
      // then ensure syncing happens on scroll end. This is for animated scrolls where the scroll
      // impulses come through animation frames.
      if (!this.forceScrollUpdate) {
        this.syncScrollingPartners();
      }

      this.scrolling = false;
    }
  }, {
    key: "onSubGridScroll",
    value: function onSubGridScroll() {
      // Force direct update, without waiting for next animation frame
      // TODO: Only used in Scheduler, could perhaps live in Scheduler specific SubGrid in the future
      if (this.forceScrollUpdate) {
        this.syncScrollingPartners();
        this.forceScrollUpdate = false;
      } else {
        this.syncPartnersOnFrame();
      }
    }
  }, {
    key: "syncScrollingPartners",

    /**
     * This syncs the horizontal scroll position of the header and the footer with
     * the horizontal scroll position of the grid. Usually, this will be called automatically
     * when the grid scrolls. In some cases, such as a refresh caused by column changes
     * it will need to be called from elsewhere.
     * @internal
     */
    value: function syncScrollingPartners() {
      var addCls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var subGrid = this,
          grid = subGrid.grid;

      if (!subGrid.scrolling && addCls) {
        subGrid.scrolling = true;
      }

      grid.trigger('horizontalScroll', {
        subGrid: subGrid,
        grid: grid,
        scrollLeft: subGrid.scrollable.x
      });
    }
    /**
     * Scrolls a column into view (if it is not already). Called by Grid#scrollColumnIntoView, use it instead to not
     * have to care about which SubGrid contains a column.
     * @param {Grid.column.Column|String|Number} column Column name (data) or column index or actual column object.
     * @param {Object} [options] How to scroll.
     * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
     * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
     * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
     * or the number of milliseconds to animate over, or an animation config object.
     * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
     * @param {String} [options.animate.easing] The name of an easing function.
     * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
     * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
     * @returns {Promise} If the column exists, a promise which is resolved when the column header element has been scrolled into view.
     */

  }, {
    key: "scrollColumnIntoView",
    value: function scrollColumnIntoView(column, options) {
      var me = this,
          scroller = me.header.scrollable; // Allow column,column id,or column index to be passed

      column = column instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_34__["default"] ? column : me.columns.get(column) || me.columns.getById(column) || me.columns.getAt(column);

      if (column) {
        // Get the current column header element.
        var columnHeaderElement = me.header.getHeader(column.id);

        if (columnHeaderElement) {
          return scroller.scrollIntoView(_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_36__["default"].from(columnHeaderElement, null, true), options);
        }
      }
    } //endregion
    //region Rows

    /**
     * Creates elements for the new rows when RowManager has determined that more rows are needed
     * @private
     */

  }, {
    key: "onAddRow",
    value: function onAddRow(_ref) {
      var rows = _ref.rows;
      var me = this,
          config = me.rowElementConfig,
          visibleColumns = me.columns.bottomColumns.filter(function (col) {
        return !col.hidden;
      }),
          frag = document.createDocumentFragment();
      rows.forEach(function (row) {
        var rowElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].createElement(config);
        frag.appendChild(rowElement);
        row.addElement(me.region, rowElement); // TODO: Stamp the correct width into the cells on creation

        me.fixCellWidths(rowElement, visibleColumns);
      });
      me.fixRowWidthsInSafariEdge(); // Put the row elements into the SubGrid en masse.
      // If 2nd param is null, insertBefore appends.

      me.element.insertBefore(frag, me.insertRowsBefore);
    }
    /**
     * Get all row elements for this SubGrid.
     * @returns {HTMLElement[]} Row elements
     * @readonly
     */

  }, {
    key: "clearRows",

    /**
     * Removes all row elements from the subgrids body and empties cache
     * @private
     */
    value: function clearRows() {
      this.emptyCache();
      var all = this.element.querySelectorAll('.b-grid-row'),
          range = document.createRange();

      if (all.length) {
        range.setStartBefore(all[0]);
        range.setEndAfter(all[all.length - 1]);
        range.deleteContents();
      }
    } // only called when RowManager.rowScrollMode = 'dom', which is not intended to be used

  }, {
    key: "addNewRowElement",
    value: function addNewRowElement() {
      var rowElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].append(this.element, this.rowElementConfig);
      this.fixCellWidths(rowElement);
      return rowElement;
    }
  }, {
    key: "toggleTransitionClasses",
    //endregion
    // region Expand/collapse
    // All usages are commented, uncomment when this is resolved: https://app.assembla.com/spaces/bryntum/tickets/5472
    value: function toggleTransitionClasses() {
      var doRemove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          grid = me.grid,
          nextRegion = grid.getSubGrid(grid.getNextRegion(me.region)),
          splitter = grid.resolveSplitter(nextRegion);
      nextRegion.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
      nextRegion.header.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
      me.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
      me.header.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
      splitter.classList[doRemove ? 'remove' : 'add']('b-grid-splitter-animate');
    }
    /**
     * Get/set collapsed state
     * @property {Boolean}
     */

  }, {
    key: "collapse",

    /**
     * Collapses subgrid. If collapsing subgrid is the only one expanded, next subgrid to the right (or previous) will
     * be expanded.
     *
     * @example
     * let locked = grid.getSubGrid('locked');
     * locked.collapse().then(() => {
     *     console.log(locked.collapsed); // Logs 'True'
     * });
     *
     * let normal = grid.getSubGrid('normal');
     * normal.collapse().then(() => {
     *     console.log(locked.collapsed); // Logs 'False'
     *     console.log(normal.collapsed); // Logs 'True'
     * });
     *
     * @async
     * @returns {Promise} A Promise which resolves when this SubGrid is fully collapsed.
     */
    value: function () {
      var _collapse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_22___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_20___default.a.mark(function _callee() {
        var me, grid, nextRegion, splitterOwner, expandedRegions;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_20___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this, grid = me.grid, nextRegion = grid.getSubGrid(grid.getNextRegion(me.region)), splitterOwner = me.splitterElement ? me : me.previousSibling; // Count all expanded regions. Grid must have always have at least one expanded

                expandedRegions = 0;
                grid.eachSubGrid(function (subGrid) {
                  subGrid !== me && !subGrid._collapsed && ++expandedRegions;
                }); // Current region is the only one expanded, expand next region

                if (!(expandedRegions === 0)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return nextRegion.expand();

              case 6:
                return _context.abrupt("return", new Promise(function (resolve) {
                  if (!me._beforeCollapseState) {
                    me._beforeCollapseState = {};
                    var widthChanged = false; // If current width is zero, the resize event will not be fired. In such case we want to trigger callback immediately

                    if (me.width) {
                      widthChanged = true; // Toggle transition classes here, we will actually change width below
                      // me.toggleTransitionClasses();
                      // afterinternalresize event is buffered, it will be fired only once after animation is finished
                      // and element size is final

                      me.on({
                        afterinternalresize: function afterinternalresize() {
                          // me.toggleTransitionClasses(true);
                          resolve(me);
                        },
                        thisObj: me,
                        once: true
                      });
                    } // When trying to collapse region we need its partner to occupy free space. Considering multiple
                    // regions, several cases are possible:
                    // 1) Both left and right regions have fixed width
                    // 2) Left region has fixed width, right region is flexed
                    // 3) Left region is flexed, right region has fixed width
                    // 4) Both regions are flexed
                    //
                    // To collapse flexed region we need to remove flex style, remember it somehow and set fixed width.
                    // If another region is flexed, it will fill the space. If it has fixed width, we need to increase
                    // its width by collapsing region width. Same logic should be appliead to headers.
                    //
                    // Save region width first


                    me._beforeCollapseState.width = me.width;
                    me._beforeCollapseState.elementWidth = me.element.style.width; // Next region is not flexed, need to make it fill the space

                    if (nextRegion.element.style.flex === '') {
                      me._beforeCollapseState.nextRegionWidth = nextRegion.width;
                      nextRegion.width += me._beforeCollapseState.width;
                    } // Current region is flexed, store style to restore on expand


                    if (me.element.style.flex !== '') {
                      me._beforeCollapseState.flex = me.element.style.flex; // remove flex state to reduce width later

                      me.header.element.style.flex = me.element.style.flex = '';
                    } // Sets the grid to its collapsed width as defined in SASS: zero


                    me.element.classList.add('b-grid-subgrid-collapsed'); // The parallel elements which must be in sync width-wise must know about collapsing

                    me.virtualScrollerElement.classList.add('b-collapsed');
                    me.header.element.classList.add('b-collapsed');
                    me.footer.element.classList.add('b-collapsed');
                    me.width = '';
                    me._collapsed = true;

                    if (!widthChanged) {
                      resolve(false);
                    }
                  }
                }).then(function (value) {
                  if (!me.isDestroyed && value !== false) {
                    me.syncParallelSplitters(true);
                    me.grid.trigger('subGridCollapse', me); // Our splitter is permanently visible when collapsed, so keep splitter button set
                    // synced in the vertical centre of the view just in time for paint.
                    // Uses translateY so will not cause a further layout.

                    splitterOwner.startSplitterButtonSyncing && splitterOwner.startSplitterButtonSyncing();
                  }
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function collapse() {
        return _collapse.apply(this, arguments);
      }

      return collapse;
    }()
    /**
     * Expands subgrid.
     *
     * @example
     * grid.getSubGrid('locked').expand().then(() => console.log('locked grid expanded'));
     *
     * @async
     * @returns {Promise} A Promise which resolves when this SubGrid is fully expanded.
     */

  }, {
    key: "expand",
    value: function () {
      var _expand = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_22___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_20___default.a.mark(function _callee2() {
        var me, grid, nextRegion, splitterOwner;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_20___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                me = this, grid = me.grid, nextRegion = grid.getSubGrid(grid.getNextRegion(me.region)), splitterOwner = me.splitterElement ? me : me.previousSibling;
                return _context2.abrupt("return", new Promise(function (resolve) {
                  if (me._beforeCollapseState != null) {
                    // If current width matches width expected after expand resize event will not be fired. In such case
                    // we want to trigger callback immediately
                    var widthChanged = false; // See similar clause in collapse method above

                    if (me.width !== me._beforeCollapseState.elementWidth) {
                      widthChanged = true; // Toggle transition classes here, we will actually change width below
                      // me.toggleTransitionClasses();

                      me.on({
                        afterinternalresize: function afterinternalresize() {
                          // me.toggleTransitionClasses(true);
                          // Delay the resolve to avoid "ResizeObserver loop limit exceeded" errors
                          // collapsing the only expanded region and it has to expand its nextRegion
                          // before it can collapse.
                          me.setTimeout(function () {
                            return resolve(me);
                          }, 10);
                        },
                        thisObj: me,
                        once: true
                      });
                    } // previous region is not flexed, reduce its width as it was increased in collapse


                    if (nextRegion.element.style.flex === '') {
                      nextRegion.width = me._beforeCollapseState.nextRegionWidth;
                    }

                    me.element.classList.remove('b-grid-subgrid-collapsed');
                    me._collapsed = false; // The parallel elements which must be in sync width-wise must know about collapsing

                    me.virtualScrollerElement.classList.remove('b-collapsed');
                    me.header.element.classList.remove('b-collapsed');
                    me.footer.element.classList.remove('b-collapsed'); // This region used to be flex, let's restore it

                    if (me._beforeCollapseState.flex) {
                      // Always restore width, restoring flex wont trigger resize otherwise
                      me.width = me._beforeCollapseState.width; // Widget flex setting clears style width

                      me.header.flex = me.flex = me._beforeCollapseState.flex;
                      me.footer.flex = me._beforeCollapseState.flex;
                      me._width = null;
                    } else {
                      me.width = me._beforeCollapseState.elementWidth;
                    }

                    me.element.classList.remove('b-grid-subgrid-collapsed');
                    me._collapsed = false;

                    if (!widthChanged) {
                      resolve(false);
                    }

                    delete me._beforeCollapseState;
                  }
                }).then(function (value) {
                  if (value !== false) {
                    // Our splitter is hidden when expanded, so we no longer need to keep splitter button set
                    // synced in the vertical centre of the view.
                    splitterOwner.stopSplitterButtonSyncing();
                    me.syncParallelSplitters(false);
                    me.grid.trigger('subGridExpand', me);
                  }
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function expand() {
        return _expand.apply(this, arguments);
      }

      return expand;
    }() //endregion

  }, {
    key: "barConfig",
    get: function get() {
      var me = this,
          _me$element$style = me.element.style,
          width = _me$element$style.width,
          flex = _me$element$style.flex,
          config = {
        subGrid: me,
        parent: me // Contained widgets need to know their parents

      }; // If we have been configured with sizing, construct the Bar in sync.

      if (flex) {
        config.flex = flex;
      } else if (width) {
        config.width = width;
      }

      return config;
    }
  }, {
    key: "rowElementConfig",
    get: function get() {
      return {
        className: 'b-grid-row',
        children: this.columns.visibleColumns.map(function (column) {
          return {
            className: 'b-grid-cell',
            dataset: {
              column: column.field || '',
              columnId: column.id
            }
          };
        })
      };
    }
  }, {
    key: "splitterConfig",
    get: function get() {
      return {
        className: this.splitterElement.className.trim(),
        children: [{
          className: 'b-grid-splitter-inner'
        }],
        dataset: {
          region: this.region
        }
      };
    }
  }, {
    key: "totalFixedWidth",
    get: function get() {
      return this.columns.totalFixedWidth;
    }
  }, {
    key: "width",
    set: function set(width) {
      var me = this; // Width explicitly set, remember that

      me.hasCalculatedWidth = false;

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_26___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(SubGrid.prototype), "width", width, this, true);

      me.header.width = width;
      me.footer.width = width; // When we're live, we can't wait until the  throttled resize occurs - it looks bad.

      if (me.isPainted) {
        me.onElementResize();
      }
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(SubGrid.prototype), "width", this);
    }
    /**
     * Get/set SubGrid flex, which also sets header and footer flex (if available).
     * @property {Number|String}
     */

  }, {
    key: "flex",
    set: function set(flex) {
      var me = this; // Width explicitly set, remember that

      me.hasCalculatedWidth = false;
      me.header.flex = flex;
      me.footer.flex = flex;

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_26___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(SubGrid.prototype), "flex", flex, this, true); // When we're live, we can't wait until the  throttled resize occurs - it looks bad.


      if (me.isPainted) {
        me.onElementResize();
      }
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_27___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_30___default()(SubGrid.prototype), "flex", this);
    }
  }, {
    key: "viewRectangle",
    get: function get() {
      var me = this;
      return new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_36__["default"](me.scrollable.x, me.scrollable.y, me._width || 0, me.rowManager.viewHeight);
    }
  }, {
    key: "overflowingHorizontally",
    get: function get() {
      var scrollable = this.scrollable; // This is if *this* subGrid has horizontal overflow
      // +1 is for Edge, it messes up otherwise

      return scrollable.scrollWidth > scrollable.clientWidth + (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].isEdge ? 1 : 0);
    }
  }, {
    key: "scrolling",
    set: function set(scrolling) {
      this._scrolling = scrolling;
    },
    get: function get() {
      return this._scrolling;
    }
  }, {
    key: "rowElements",
    get: function get() {
      return this.fromCache('.b-grid-row', true);
    }
  }, {
    key: "emptyText",
    get: function get() {
      return this._emptyText;
    },
    set: function set(text) {
      this._emptyText = text;
      this.element.dataset.emptyText = text;
    }
  }, {
    key: "collapsed",
    get: function get() {
      return this._collapsed;
    },
    set: function set(collapsed) {
      if (this.isConfiguring) {
        this._collapsed = collapsed;
      } else {
        if (collapsed) {
          this.collapse();
        } else {
          this.expand();
        }
      }
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'SubGrid';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'subgrid';
    }
    /**
     * Region (name) for this SubGrid
     * @config {String} region
     */

    /**
     * Column store, a store containing the columns for this SubGrid
     * @config {Grid.data.ColumnStore} columns
     */

  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        localizableProperties: ['emptyText'],
        insertRowsBefore: null,
        appendTo: null,
        monitorResize: true,
        headerClass: null,
        footerClass: null,

        /**
         * Set `true` to start subgrid collapsed. To operate collapsed state on subgrid use
         * {@link #function-collapse}/{@link #function-expand} methods.
         * @config {Boolean}
         * @default false
         */
        collapsed: null,
        scrollable: {
          // Each SubGrid only handles scrolling in the X axis.
          // The owning Grid handles the Y axis.
          overflowX: true
        },
        scrollerClass: _util_SubGridScroller_js__WEBPACK_IMPORTED_MODULE_35__["default"],
        // Will be set to true by GridSubGrids if it calculates the subgrids width based on its columns.
        // Used to determine if hiding a column should affect subgrids width
        hasCalculatedWidth: null,

        /**
         * Set `true` to disable moving columns into or out of this SubGrid.
         * @config {Boolean}
         * @default false
         * @private
         */
        sealedColumns: null,
        emptyText: null
      };
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        element: true,
        header: true,
        footer: true,
        virtualScrollerElement: true,
        splitterElement: true,
        headerSplitter: true,
        scrollerSplitter: true,
        footerSplitter: true
      };
    }
  }]);

  return SubGrid;
}(_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_33__["default"]); // Register this widget type with its Factory



SubGrid.initClass();
SubGrid._$name = 'SubGrid';

/***/ }),

/***/ "./lib/Grid/view/TreeGrid.js":
/*!***********************************!*\
  !*** ./lib/Grid/view/TreeGrid.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TreeGrid; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Grid_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Grid.js */ "./lib/Grid/view/Grid.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _feature_Tree_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../feature/Tree.js */ "./lib/Grid/feature/Tree.js");
/* harmony import */ var _column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../column/TreeColumn.js */ "./lib/Grid/column/TreeColumn.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

 // tree feature will be added by default to TreeGrid, but needs to be imported

 // not used here but enables using `type : tree` in a column config (exactly one required)


/**
 * @module Grid/view/TreeGrid
 */

/**
 * A TreeGrid, a Tree combined with a Grid. Must be configured with exactly one {@link Grid.column.TreeColumn} (`type: tree`), but can also have an
 * arbitrary number of other columns. Most features that can be used with Grid also works with TreeGrid, with the
 * exception of the Group feature.
 * @extends Grid/view/Grid
 *
 * @classtype treegrid
 * @externalexample grid/TreeGrid.js
 */

var TreeGrid = /*#__PURE__*/function (_Grid) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TreeGrid, _Grid);

  var _super = _createSuper(TreeGrid);

  function TreeGrid() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TreeGrid);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TreeGrid, [{
    key: "store",
    //region Plugged in functions / inherited configs

    /**
     * Store that holds records to display in the TreeGrid, or a store config object.
     * If you supply a Store, make sure it is configured with `tree : true` to handle tree data.
     * A store will be created if none is specified
     * @config {Core.data.Store|Object} store
     * @default
     */

    /**
     * Collapse an expanded node or expand a collapsed. Optionally forcing a certain state.
     *
     * @function toggleCollapse
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to toggle
     * @param {Boolean} [collapse] Force collapse (true) or expand (false)
     * @param {Boolean} [skipRefresh] Set to true to not refresh rows (if calling in batch)
     * @returns {Promise}
     * @category Feature shortcuts
     */

    /**
     * Collapse a single node.
     *
     * @function collapse
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to collapse
     * @returns {Promise}
     * @category Feature shortcuts
     */

    /**
     * Expand a single node.
     *
     * @function expand
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node to expand
     * @returns {Promise}
     * @category Feature shortcuts
     */

    /**
     * Expands parent nodes to make this node "visible".
     *
     * @function expandTo
     * @param {String|Number|Core.data.Model} idOrRecord Record (the node itself) or id of a node
     * @returns {Promise}
     * @category Feature shortcuts
     */
    //endregion
    //region Store

    /**
     * Get/set the store used by this TreeGrid. Accepts a config or a Store. If assigning an already existing Store,
     * it must be configured with `tree: true`
     * @property {Core.data.Store|Object}
     */
    set: function set(store) {
      if (store && !store.tree) {
        // existing store instance, not much we can do about it
        if (store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_11__["default"]) {
          throw new Error('TreeGrid requires a Store configured with tree : true');
        } // store config, enable tree
        else {
            store.tree = true;
          }
      }

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TreeGrid.prototype), "store", store, this, true);
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TreeGrid.prototype), "store", this);
    } //endregion

  }], [{
    key: "$name",
    get: function get() {
      return 'TreeGrid';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'treegrid';
    }
  }]);

  return TreeGrid;
}(_Grid_js__WEBPACK_IMPORTED_MODULE_10__["default"]); // Register this widget type with its Factory



TreeGrid.initClass();
TreeGrid._$name = 'TreeGrid';

/***/ }),

/***/ "./lib/Grid/view/export/ExportDialog.js":
/*!**********************************************!*\
  !*** ./lib/Grid/view/export/ExportDialog.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExportDialog; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _field_ExportRowsCombo_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./field/ExportRowsCombo.js */ "./lib/Grid/view/export/field/ExportRowsCombo.js");
/* harmony import */ var _field_ExportOrientationCombo_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./field/ExportOrientationCombo.js */ "./lib/Grid/view/export/field/ExportOrientationCombo.js");
/* harmony import */ var _field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./field/LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../feature/export/Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony import */ var _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../../Core/widget/Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");




















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';









/**
 * @module Grid/view/export/ExportDialog
 */

/**
 * Dialog window which allows to pick export options.
 *
 * ```
 * grid = new Grid({
 *     features : {
 *         pdfExport : { exportServer : '...' }
 *     }
 * });
 *
 * grid.features.pdfExport.showExportDialog();
 * ```
 *
 * @extends Core/widget/Popup
 */

var ExportDialog = /*#__PURE__*/function (_Popup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(ExportDialog, _Popup);

  var _super = _createSuper(ExportDialog);

  function ExportDialog() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, ExportDialog);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(ExportDialog, [{
    key: "construct",
    value: function construct() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this,
          client = config.client;

      if (!client) {
        throw new Error('`client` config is required');
      }

      var items = me.buildDialogItems(config);

      if (config.items) {
        if (Array.isArray(config.items)) {
          var _config$items;

          (_config$items = config.items).push.apply(_config$items, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12___default()(items));
        } else {
          items.forEach(function (item) {
            config.items[item.ref] = item;
            delete item.ref;
          });
        }
      } else {
        config.items = items;
      }

      config.width = config.width || me.L('L{width}');

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(ExportDialog.prototype), "construct", this).call(this, config);

      me.widgetMap.exportButton.on('click', me.onExportClick, me);
      me.widgetMap.cancelButton.on('click', me.onCancelClick, me);
      _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_20__["default"].on({
        locale: 'onLocaleChange',
        prio: -1,
        thisObj: me
      });
    }
  }, {
    key: "getDefaultFieldValues",
    value: function getDefaultFieldValues(config) {
      var result = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].copyProperties({}, config, this.fieldProperties);
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].copyPropertiesIf(result, this.getDefaultConfiguration(), this.fieldProperties);
    }
  }, {
    key: "buildDialogItems",
    value: function buildDialogItems(config) {
      var _this = this;

      var me = this,
          exporters = config.exporters,
          client = config.client,
          _me$getDefaultFieldVa = me.getDefaultFieldValues(config),
          exporterType = _me$getDefaultFieldVa.exporterType,
          orientation = _me$getDefaultFieldVa.orientation,
          paperFormat = _me$getDefaultFieldVa.paperFormat,
          fileFormat = _me$getDefaultFieldVa.fileFormat,
          alignRows = _me$getDefaultFieldVa.alignRows,
          rowsRange = _me$getDefaultFieldVa.rowsRange,
          repeatHeader = _me$getDefaultFieldVa.repeatHeader,
          labelWidth = me.L('L{ExportDialog.labelWidth}');

      me.columnsStore = client.columns.chain(function (record) {
        return record.isLeaf && record.exportable;
      });

      function buildComboItems(obj) {
        var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
          return x;
        };
        return Object.keys(obj).map(function (key) {
          return {
            id: key,
            text: fn(key)
          };
        });
      }

      return [{
        labelWidth: labelWidth,
        type: 'combo',
        ref: 'columnsField',
        label: 'L{ExportDialog.columns}',
        store: me.columnsStore,
        value: me.columnsStore.allRecords,
        valueField: 'id',
        displayField: 'text',
        multiSelect: true
      }, {
        labelWidth: labelWidth,
        type: 'exportrowscombo',
        ref: 'rowsRangeField',
        label: 'L{ExportDialog.rows}',
        value: rowsRange
      }, {
        labelWidth: labelWidth,
        type: 'localizablecombo',
        ref: 'exporterTypeField',
        label: 'L{ExportDialog.exporterType}',
        editable: false,
        value: exporterType,
        buildLocalizedItems: function buildLocalizedItems() {
          return exporters.map(function (exporter) {
            return {
              id: exporter.type,
              text: me.optionalL(exporter.title, _this)
            };
          });
        },
        onChange: function onChange(_ref) {
          var value = _ref.value;
          this.owner.widgetMap.alignRowsField.hidden = value === 'singlepage';
          this.owner.widgetMap.repeatHeaderField.hidden = value !== 'multipagevertical';
        }
      }, {
        labelWidth: labelWidth,
        type: 'checkbox',
        ref: 'alignRowsField',
        label: 'L{ExportDialog.alignRows}',
        checked: alignRows,
        hidden: exporterType === 'singlepage'
      }, {
        labelWidth: labelWidth,
        type: 'checkbox',
        ref: 'repeatHeaderField',
        label: 'L{ExportDialog.repeatHeader}',
        localeClass: this,
        value: repeatHeader,
        hidden: exporterType !== 'multipagevertical'
      }, {
        labelWidth: labelWidth,
        type: 'combo',
        ref: 'fileFormatField',
        label: 'L{ExportDialog.fileFormat}',
        localeClass: this,
        editable: false,
        value: fileFormat,
        items: buildComboItems(_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_24__["FileFormat"], function (value) {
          return value.toUpperCase();
        }),
        onChange: function onChange(_ref2) {
          var value = _ref2.value,
              oldValue = _ref2.oldValue;

          if (me.hidePNGMultipageOption) {
            var exporterField = me.widgetMap.exporterTypeField,
                exporter = exporterField.store.find(function (r) {
              return r.id === 'singlepage';
            });

            if (value === _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_24__["FileFormat"].png && exporter) {
              this._previousDisabled = exporterField.disabled;
              exporterField.disabled = true;
              this._previousValue = exporterField.value;
              exporterField.value = 'singlepage';
            } else if (oldValue === _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_24__["FileFormat"].png && this._previousValue) {
              exporterField.disabled = this._previousDisabled;
              exporterField.value = this._previousValue;
            }
          }
        }
      }, {
        labelWidth: labelWidth,
        type: 'combo',
        ref: 'paperFormatField',
        label: 'L{ExportDialog.paperFormat}',
        editable: false,
        value: paperFormat,
        items: buildComboItems(_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_24__["PaperFormat"])
      }, {
        labelWidth: labelWidth,
        type: 'exportorientationcombo',
        ref: 'orientationField',
        label: 'L{ExportDialog.orientation}',
        value: orientation
      }];
    }
  }, {
    key: "onLocaleChange",
    value: function onLocaleChange() {
      var labelWidth = this.L('L{labelWidth}');
      this.width = this.L('L{width}');
      this.eachWidget(function (widget) {
        if (widget instanceof _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_26__["default"]) {
          widget.labelWidth = labelWidth;
        }
      });
    }
  }, {
    key: "onExportClick",
    value: function onExportClick() {
      var values = this.values;
      /**
       * Fires when export button is clicked
       * @event export
       * @param {Object} values Object containing config for {@link Grid.feature.export.PdfExport#function-export export()} method
       * @group Export
       */

      this.trigger('export', {
        values: values
      });
    }
  }, {
    key: "onCancelClick",
    value: function onCancelClick() {
      /**
       * Fires when cancel button is clicked. Popup will hide itself.
       * @event cancel
       * @group Export
       */
      this.trigger('cancel');
      this.hide();
    }
  }, {
    key: "fieldProperties",
    get: function get() {
      return ['exporterType', 'orientation', 'fileFormat', 'paperFormat', 'alignRows', 'rowsRange', 'repeatHeader'];
    }
  }, {
    key: "values",
    get: function get() {
      var fieldRe = /field/i,
          result = {};
      this.eachWidget(function (widget) {
        if (fieldRe.test(widget.ref)) {
          result[widget.ref.replace(fieldRe, '')] = widget instanceof _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_25__["default"] ? widget.checked : widget.value;
        }
      });
      return result;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ExportDialog';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        autoShow: false,
        autoClose: false,
        closable: true,
        centered: true,

        /**
         * Grid instance to build export dialog for
         */
        client: null,

        /**
         * Set to `false` to allow using PNG + Multipage config in export dialog
         */
        hidePNGMultipageOption: true,
        exporterType: 'singlepage',
        orientation: 'portrait',
        paperFormat: 'A4',
        fileFormat: 'pdf',
        alignRows: false,
        rowsRange: 'all',
        title: 'L{exportSettings}',
        defaults: {
          localeClass: this
        },
        bbar: {
          defaults: {
            type: 'button',
            localeClass: this
          },
          items: {
            exportButton: {
              color: 'b-green',
              text: 'L{ExportDialog.export}',
              weight: 100
            },
            cancelButton: {
              color: 'b-gray',
              text: 'L{ExportDialog.cancel}',
              weight: 200
            }
          }
        }
      };
    }
  }]);

  return ExportDialog;
}(_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_19__["default"]);


ExportDialog._$name = 'ExportDialog';

/***/ }),

/***/ "./lib/Grid/view/export/field/ExportOrientationCombo.js":
/*!**************************************************************!*\
  !*** ./lib/Grid/view/export/field/ExportOrientationCombo.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExportOrientationCombo; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../feature/export/Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony import */ var _LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var ExportOrientationCombo = /*#__PURE__*/function (_LocalizableCombo) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ExportOrientationCombo, _LocalizableCombo);

  var _super = _createSuper(ExportOrientationCombo);

  function ExportOrientationCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ExportOrientationCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ExportOrientationCombo, [{
    key: "buildLocalizedItems",
    value: function buildLocalizedItems() {
      var me = this;
      return [{
        id: _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_8__["Orientation"].portrait,
        text: me.L('L{portrait}')
      }, {
        id: _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_8__["Orientation"].landscape,
        text: me.L('L{landscape}')
      }];
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ExportOrientationCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'ExportOrientationCombo';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        editable: false
      };
    }
  }]);

  return ExportOrientationCombo;
}(_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_9__["default"]); // Register this widget type with its Factory



ExportOrientationCombo.initClass();
ExportOrientationCombo._$name = 'ExportOrientationCombo';

/***/ }),

/***/ "./lib/Grid/view/export/field/ExportRowsCombo.js":
/*!*******************************************************!*\
  !*** ./lib/Grid/view/export/field/ExportRowsCombo.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExportRowsCombo; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../feature/export/Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony import */ var _LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var ExportRowsCombo = /*#__PURE__*/function (_LocalizableCombo) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ExportRowsCombo, _LocalizableCombo);

  var _super = _createSuper(ExportRowsCombo);

  function ExportRowsCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ExportRowsCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ExportRowsCombo, [{
    key: "buildLocalizedItems",
    value: function buildLocalizedItems() {
      var me = this;
      return [{
        id: _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_8__["RowsRange"].all,
        text: me.L('L{all}')
      }, {
        id: _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_8__["RowsRange"].visible,
        text: me.L('L{visible}')
      }];
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ExportRowsCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'ExportRowsCombo';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        editable: false
      };
    }
  }]);

  return ExportRowsCombo;
}(_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_9__["default"]); // Register this widget type with its Factory



ExportRowsCombo.initClass();
ExportRowsCombo._$name = 'ExportRowsCombo';

/***/ }),

/***/ "./lib/Grid/view/export/field/LocalizableCombo.js":
/*!********************************************************!*\
  !*** ./lib/Grid/view/export/field/LocalizableCombo.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LocalizableCombo; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var LocalizableCombo = /*#__PURE__*/function (_LocalizableComboItem) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(LocalizableCombo, _LocalizableComboItem);

  var _super = _createSuper(LocalizableCombo);

  function LocalizableCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, LocalizableCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(LocalizableCombo, null, [{
    key: "$name",
    get: function get() {
      return 'LocalizableCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'localizablecombo';
    }
  }]);

  return LocalizableCombo;
}(Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_8__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_9__["default"])); // Register this widget type with its Factory



LocalizableCombo.initClass();
LocalizableCombo._$name = 'LocalizableCombo';

/***/ }),

/***/ "./lib/Grid/view/mixin/GridElementEvents.js":
/*!**************************************************!*\
  !*** ./lib/Grid/view/mixin/GridElementEvents.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; // We declare consts inside case blocks in this file.

/* eslint-disable no-case-declarations */
//TODO: Should it fire more own events instead and rely less on function chaining?









var gridElementEventHandlers = {
  touchstart: 'onElementTouchStart',
  touchmove: 'onElementTouchMove',
  touchend: 'onElementTouchEnd',
  mouseover: 'onElementMouseOver',
  mouseout: 'onElementMouseOut',
  mousedown: 'onElementMouseDown',
  mousemove: 'onElementMouseMove',
  mouseup: 'onElementMouseUp',
  click: 'onHandleElementClick',
  dblclick: 'onElementDblClick',
  keydown: 'onElementKeyDown',
  keyup: 'onElementKeyUp',
  keypress: 'onElementKeyPress',
  contextmenu: 'onElementContextMenu'
};
/**
 * @module Grid/view/mixin/GridElementEvents
 */

/**
 * Mixin for Grid that handles dom events. Some listeners fire own events but all can be chained by features. None of
 * the functions in this class are indented to be called directly.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(GridElementEvents, _ref);

    var _super = _createSuper(GridElementEvents);

    function GridElementEvents() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, GridElementEvents);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(GridElementEvents, [{
      key: "initInternalEvents",
      //endregion
      //region Events

      /**
       * User clicked in a grid cell
       * @event cellClick
       * @param {Grid.view.Grid} grid
       * @param {Core.data.Model} record
       * @param {Grid.column.Column} column
       * @param {Object} cellSelector
       * @param {HTMLElement} cellElement
       * @param {HTMLElement} target
       * @param {Event} event
       */

      /**
       * User double clicked in a grid cell
       * @event cellDblClick
       * @param {Grid.view.Grid} grid
       * @param {Core.data.Model} record
       * @param {Grid.column.Column} column
       * @param {Object} cellSelector
       * @param {HTMLElement} cellElement
       * @param {HTMLElement} target
       * @param {Event} event
       */

      /**
       * User activated contextmenu in a grid cell
       * @event cellContextMenu
       * @param {Grid.view.Grid} grid
       * @param {Core.data.Model} record
       * @param {Grid.column.Column} column
       * @param {Object} cellSelector
       * @param {HTMLElement} cellElement
       * @param {HTMLElement} target
       * @param {Event} event
       */

      /**
       * User moved moused to a grid cell
       * @event cellMouseOver
       * @param {Grid.view.Grid} grid
       * @param {Core.data.Model} record
       * @param {Grid.column.Column} column
       * @param {Object} cellSelector
       * @param {HTMLElement} cellElement
       * @param {HTMLElement} target
       * @param {Event} event
       */

      /**
       * User moved moused out of a grid cell
       * @event cellMouseOut
       * @param {Grid.view.Grid} grid
       * @param {Core.data.Model} record
       * @param {Grid.column.Column} column
       * @param {Object} cellSelector
       * @param {HTMLElement} cellElement
       * @param {HTMLElement} target
       * @param {Event} event
       */
      //endregion
      //region Event handling

      /**
       * Init listeners for a bunch of dom events. All events are handled by handleEvent().
       * @private
       * @category Events
       */
      value: function initInternalEvents() {
        var handledEvents = Object.keys(gridElementEventHandlers),
            len = handledEvents.length,
            listeners = {
          element: this.element,
          thisObj: this
        }; // Route all events through handleEvent, so that we can capture this.event
        // before we route to the handlers

        for (var i = 0; i < len; i++) {
          listeners[handledEvents[i]] = 'handleEvent';
        }

        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on(listeners);
        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
          focus: 'onGridElementFocus',
          element: this.focusElement,
          thisObj: this
        });
      }
      /**
       * This method finds the cell location of the passed event. It returns an object describing the cell.
       * @param {Event} event A Mouse, Pointer or Touch event targeted at part of the grid.
       * @returns {Object} An object containing the following properties:
       * - `cellElement` - The cell element clicked on.
       * - `column` - The {@link Grid.column.Column column} clicked under.
       * - `columnId` - The `id` of the {@link Grid.column.Column column} clicked under.
       * - `record` - The {@link Core.data.Model record} clicked on.
       * - `id` - The `id` of the {@link Core.data.Model record} clicked on.
       * @internal
       * @category Events
       */

    }, {
      key: "getCellDataFromEvent",
      value: function getCellDataFromEvent(event) {
        var me = this,
            cellElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(event.target, '.b-grid-cell'); // There is a cell

        if (cellElement) {
          var cellData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].get(cellElement),
              id = cellData.id,
              columnId = cellData.columnId,
              record = me.store.getById(id),
              column = me.columns.getById(columnId); // Row might not have a record, since we transition record removal
          // https://app.assembla.com/spaces/bryntum/tickets/6805

          return record ? {
            cellElement: cellElement,
            cellData: cellData,
            columnId: columnId,
            id: id,
            record: record,
            column: column,
            cellSelector: {
              id: id,
              columnId: columnId
            }
          } : null;
        }
      }
      /**
       * This method finds the header location of the passed event. It returns an object describing the header.
       * @param {Event} event A Mouse, Pointer or Touch event targeted at part of the grid.
       * @returns {Object} An object containing the following properties:
       * - `headerElement` - The header element clicked on.
       * - `column` - The {@link Grid.column.Column column} clicked under.
       * - `columnId` - The `id` of the {@link Grid.column.Column column} clicked under.
       * @internal
       * @category Events
       */

    }, {
      key: "getHeaderDataFromEvent",
      value: function getHeaderDataFromEvent(event) {
        var headerElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(event.target, '.b-grid-header'); // There is a header

        if (headerElement) {
          var headerData = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].assign({}, headerElement.dataset),
              columnId = headerData.columnId,
              column = this.columns.getById(columnId);
          return column ? {
            headerElement: headerElement,
            headerData: headerData,
            columnId: columnId,
            column: column
          } : null;
        }
      }
      /**
       * Handles all dom events, routing them to correct functions (touchstart -> onElementTouchStart)
       * @param event
       * @private
       * @category Events
       */

    }, {
      key: "handleEvent",
      value: function handleEvent(event) {
        if (!this.disabled) {
          this.event = event;

          if (gridElementEventHandlers[event.type]) {
            this[gridElementEventHandlers[event.type]](event);
          }
        }
      } //endregion
      //region Touch events

      /**
       * Touch start, chain this function in features to handle the event.
       * @param event
       * @category Touch events
       * @internal
       */

    }, {
      key: "onElementTouchStart",
      value: function onElementTouchStart(event) {
        var me = this,
            cellData = me.getCellDataFromEvent(event);
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isTouchEvent = true;

        if (event.touches.length === 1) {
          me.longPressTimeout = me.setTimeout(function () {
            me.onElementLongPress(event);
            event.preventDefault();
            me.longPressPerformed = true;
          }, me.longPressTime);
        }

        if (cellData && !event.defaultPrevented) {
          me.onFocusGesture(cellData, event);
        }
      }
      /**
       * Touch move, chain this function in features to handle the event.
       * @param event
       * @category Touch events
       * @internal
       */

    }, {
      key: "onElementTouchMove",
      value: function onElementTouchMove(event) {
        var me = this;

        if (me.longPressTimeout) {
          me.clearTimeout(me.longPressTimeout);
          me.longPressTimeout = null;
        }
      }
      /**
       * Touch end, chain this function in features to handle the event.
       * @param event
       * @category Touch events
       * @internal
       */

    }, {
      key: "onElementTouchEnd",
      value: function onElementTouchEnd(event) {
        var me = this;

        if (me.longPressPerformed) {
          if (event.cancelable) {
            event.preventDefault();
          }

          me.longPressPerformed = false;
        }

        if (me.longPressTimeout) {
          me.clearTimeout(me.longPressTimeout);
          me.longPressTimeout = null;
        }
      }
    }, {
      key: "onElementLongPress",
      value: function onElementLongPress(event) {} //endregion
      //region Mouse events
      // Trigger events in same style when clicking, dblclicking and for contextmenu

    }, {
      key: "triggerCellMouseEvent",
      value: function triggerCellMouseEvent(name, event) {
        var me = this,
            cellData = me.getCellDataFromEvent(event); // There is a cell

        if (cellData) {
          var column = me.columns.getById(cellData.columnId);
          me.trigger('cell' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].capitalize(name), {
            grid: this,
            record: cellData.record,
            column: column,
            cellSelector: cellData.cellSelector,
            cellElement: cellData.cellElement,
            target: event.target,
            event: event
          });
        }
      }
      /**
       * Mouse down, chain this function in features to handle the event.
       * @param event
       * @category Mouse events
       * @internal
       */

    }, {
      key: "onElementMouseDown",
      value: function onElementMouseDown(event) {
        var me = this,
            cellData = me.getCellDataFromEvent(event);
        me.skipFocusSelection = true;
        me.triggerCellMouseEvent('mousedown', event); // Browser event unification fires a mousedown on touch tap prior to focus.

        if (cellData && !event.defaultPrevented) {
          me.onFocusGesture(cellData, event);
        }
      }
      /**
       * Mouse move, chain this function in features to handle the event.
       * @param event
       * @category Mouse events
       * @internal
       */

    }, {
      key: "onElementMouseMove",
      value: function onElementMouseMove(event) {
        // Keep track of the last mouse position in case, due to OSX sloppy focusing,
        // focus is moved into the browser before a mousedown is delivered.
        // The cached mousemove event will provide the correct target in
        // GridNavigation#onGridElementFocus.
        this.mouseMoveEvent = event;
      }
      /**
       * Mouse up, chain this function in features to handle the event.
       * @param event
       * @category Mouse events
       * @internal
       */

    }, {
      key: "onElementMouseUp",
      value: function onElementMouseUp(event) {}
      /**
       * Called before {@link #function-onElementClick}.
       * Fires 'beforeElementClick' event which can return false to cancel further onElementClick actions.
       * @param event
       * @fires beforeElementClick
       * @category Mouse events
       * @internal
       */

    }, {
      key: "onHandleElementClick",
      value: function onHandleElementClick(event) {
        if (this.trigger('beforeElementClick', {
          event: event
        }) !== false) {
          this.onElementClick(event);
        }
      }
      /**
       * Click, select cell on click and also fire 'cellClick' event.
       * Chain this function in features to handle the dom event.
       * @param event
       * @fires cellClick
       * @category Mouse events
       * @internal
       */

    }, {
      key: "onElementClick",
      value: function onElementClick(event) {
        var me = this,
            cellData = me.getCellDataFromEvent(event); // There is a cell

        if (cellData) {
          me.triggerCellMouseEvent('click', event); // Clear hover styling when clicking in a row to avoid having it stick around if you keyboard navigate
          // away from it
          // https://app.assembla.com/spaces/bryntum/tickets/5848

          _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].get(cellData.cellElement).row.removeCls('b-hover');
        }
      }
    }, {
      key: "onFocusGesture",
      value: function onFocusGesture(cellData, event) {
        //TODO: should be able to cancel focusCell from listeners
        if (cellData) {
          this.focusCell(cellData.cellSelector, {
            scroll: false,
            doSelect: true,
            event: event
          });
        }
      }
      /**
       * Double click, fires 'cellDblClick' event.
       * Chain this function in features to handle the dom event.
       * @param {Event} event
       * @fires cellDblClick
       * @category Mouse events
       * @internal
       */

    }, {
      key: "onElementDblClick",
      value: function onElementDblClick(event) {
        var me = this,
            target = event.target;
        me.triggerCellMouseEvent('dblClick', event);

        if (target.classList.contains('b-grid-header-resize-handle')) {
          var header = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(target, '.b-grid-header'),
              column = me.columns.getById(header.dataset.columnId);
          column.resizeToFitContent();
        }
      }
      /**
       * Mouse over, adds 'hover' class to elements.
       * @param event
       * @fires mouseOver
       * @category Mouse events
       * @internal
       */

    }, {
      key: "onElementMouseOver",
      value: function onElementMouseOver(event) {
        // bail out early if scrolling
        if (!this.scrolling) {
          var cellElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(event.target, '.b-grid-cell');

          if (cellElement) {
            var row = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].get(cellElement).row; // No hover effect needed if a mouse button is pressed (like when resizing window, region, or resizing something etc).
            // NOTE: 'buttons' not supported in Safari

            if (row && (typeof event.buttons !== 'number' || event.buttons === 0)) {
              this.hoveredRow = row;
            }

            this.triggerCellMouseEvent('mouseOver', event);
          }
          /**
           * Mouse moved in over element in grid
           * @event mouseOver
           * @param {Event} event
           */


          this.trigger('mouseOver', {
            event: event
          });
        }
      }
      /**
       * Mouse out, removes 'hover' class from elements.
       * @param event
       * @fires mouseOut
       * @category Mouse events
       * @internal
       */

    }, {
      key: "onElementMouseOut",
      value: function onElementMouseOut(event) {
        this.hoveredRow = null; // bail out early if scrolling

        if (!this.scrolling) {
          var cellElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(event.target, '.b-grid-cell');

          if (cellElement) {
            this.triggerCellMouseEvent('mouseOut', event);
          }
          /**
           * Mouse moved out from element in grid
           * @event mouseOut
           * @param {Event} event
           */


          this.trigger('mouseOut', {
            event: event
          });
        }
      }
    }, {
      key: "onElementKeyDown",
      //endregion
      //region Keyboard events

      /**
       * Key down, handles arrow keys for selection.
       * Chain this function in features to handle the dom event.
       * @param event
       * @category Keyboard events
       * @internal
       */
      value: function onElementKeyDown(event) {
        var me = this; // flagging event with handled = true used to signal that other features should probably not care about it.
        // for this to work you should specify overrides for onElementKeyDown to be run before this function
        // (see for example CellEdit feature)

        if (event.handled) return; // Read this to refresh cached reference in case this keystroke lead to the removal of current row

        var focusedCell = me.focusedCell;

        if (event.target.matches('.b-grid-header.b-depth-0')) {
          me.handleHeaderKeyDown(event);
        } else if (event.target === me.focusElement || _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].isIE11 && event.currentTarget === me.focusElement) {
          // IE11 Browser check is not placed in EventHelper to maintain built-in delegated functionality
          me.handleViewKeyDown(event); // If a cell is focused and column is interested - call special callback

          if (focusedCell) {
            var _column$onCellKeyDown;

            var cellElement = focusedCell.element,
                column = me.columns.getById(cellElement.dataset.columnId);
            (_column$onCellKeyDown = column.onCellKeyDown) === null || _column$onCellKeyDown === void 0 ? void 0 : _column$onCellKeyDown.call(column, {
              event: event,
              cellElement: cellElement
            });
          }
        } // If focus is *within* a cell (eg WidgetColumn or CheckColumn), jump up to focus the cell.
        else if (event.key === 'Escape' && me.isActionableLocation) {
            var focusedCellClone = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].clone(focusedCell);
            focusedCellClone.element = null;
            me.focusCell(focusedCellClone);
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].focusWithoutScrolling(me.element);
          }
      }
    }, {
      key: "handleViewKeyDown",
      value: function handleViewKeyDown(event) {
        var me = this;

        switch (event.key) {
          case 'ArrowLeft':
            event.preventDefault();
            return me.navigateLeft(event);

          case 'ArrowRight':
            event.preventDefault();
            return me.navigateRight(event);

          case 'ArrowUp':
            event.preventDefault();
            return me.navigateUp(event);

          case 'ArrowDown':
            event.preventDefault();
            return me.navigateDown(event);
        }
      }
    }, {
      key: "handleHeaderKeyDown",
      value: function handleHeaderKeyDown(event) {
        var me = this,
            column = me.columns.getById(event.target.dataset.columnId);
        column.onKeyDown && column.onKeyDown(event);

        switch (event.key) {
          case 'ArrowLeft':
            me.onHeaderLeftKey(column);
            break;

          case 'ArrowRight':
            me.onHeaderRightKey(column);
            break;

          case 'ArrowDown':
            event.preventDefault();
            me.onHeaderDownKey(column);
            break;

          case 'Enter':
            me.onHeaderEnterKey(column);
            break;
        }
      }
    }, {
      key: "onHeaderLeftKey",
      value: function onHeaderLeftKey(column) {
        var prev = this.columns.getAdjacentVisibleLeafColumn(column, false);

        if (prev) {
          this.getHeaderElement(prev.id).focus();
        }
      }
    }, {
      key: "onHeaderRightKey",
      value: function onHeaderRightKey(column) {
        var next = this.columns.getAdjacentVisibleLeafColumn(column, true);

        if (next) {
          this.getHeaderElement(next.id).focus();
        }
      }
    }, {
      key: "onHeaderDownKey",
      value: function onHeaderDownKey(column) {
        var row = this.firstFullyVisibleRow;

        if (row) {
          this.focusCell({
            columnId: column.id,
            id: row.id
          });
        }
      }
    }, {
      key: "onHeaderEnterKey",
      value: function onHeaderEnterKey(column) {
        this.getHeaderElement(column.id).click();
      }
      /**
       * Key press, chain this function in features to handle the dom event.
       * @param event
       * @category Keyboard events
       * @internal
       */

    }, {
      key: "onElementKeyPress",
      value: function onElementKeyPress(event) {}
      /**
       * Key up, chain this function in features to handle the dom event.
       * @param event
       * @category Keyboard events
       * @internal
       */

    }, {
      key: "onElementKeyUp",
      value: function onElementKeyUp(event) {} //endregion
      //region Other events

      /**
       * Context menu, chain this function in features to handle the dom event.
       * In most cases, include ContextMenu feature instead.
       * @param event
       * @category Other events
       * @internal
       */

    }, {
      key: "onElementContextMenu",
      value: function onElementContextMenu(event) {
        var me = this,
            cellData = me.getCellDataFromEvent(event); // There is a cell

        if (cellData) {
          me.triggerCellMouseEvent('contextMenu', event); // Focus on tap for touch events.
          // Selection follows from focus.

          if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isTouchEvent) {
            me.onFocusGesture(cellData, event);
          }
        }
      }
      /**
       * Overrides empty base function in View, called when view is resized.
       * @fires resize
       * @param element
       * @param width
       * @param height
       * @param oldWidth
       * @param oldHeight
       * @category Other events
       * @internal
       */

    }, {
      key: "onInternalResize",
      value: function onInternalResize(element, width, height, oldWidth, oldHeight) {
        var me = this;

        if (me._devicePixelRatio && me._devicePixelRatio !== window.devicePixelRatio) {
          // Pixel ratio changed, likely because of browser zoom. This affects the relative scrollbar width also
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].resetScrollBarWidth();
        }

        me._devicePixelRatio = window.devicePixelRatio; // cache to avoid recalculations in the middle of rendering code (RowManger#getRecordCoords())

        me._bodyRectangle = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].client(me.bodyContainer);

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(GridElementEvents.prototype), "onInternalResize", this).apply(this, arguments);

        if (height !== oldHeight) {
          me._bodyHeight = me.bodyContainer.offsetHeight;

          if (me.isPainted) {
            // initial height will be set from render(),
            // it reaches onInternalResize too early when rendering, headers/footers are not sized yet
            me.rowManager.initWithHeight(me._bodyHeight);
          }
        }

        me.refreshVirtualScrollbars();

        if (width !== oldWidth) {
          // Slightly delay to avoid resize loops.
          me.setTimeout(function () {
            if (!me.isDestroyed) {
              me.updateResponsive(width, oldWidth);
            }
          }, 0);
        }
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "hoveredRow",
      set: function set(row) {
        var me = this; // Unhover

        if (me._hoveredRow && !me._hoveredRow.isDestroyed) {
          me._hoveredRow.removeCls('b-hover');

          me._hoveredRow = null;
        } // Hover


        if (row && !me.scrolling) {
          me._hoveredRow = row;
          row.addCls('b-hover');
        }
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'GridElementEvents';
      } //region Config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Time in ms until a longpress is triggered
           * @config {Number}
           * @default
           * @category Events
           */
          longPressTime: 400
        };
      }
    }]);

    return GridElementEvents;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"]);
});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridFeatures.js":
/*!*********************************************!*\
  !*** ./lib/Grid/view/mixin/GridFeatures.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.define-property */ "./node_modules/core-js/modules/es.reflect.define-property.js");
/* harmony import */ var core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_define_property__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/construct */ "./node_modules/@babel/runtime/helpers/construct.js");
/* harmony import */ var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Grid/view/mixin/GridFeatures
 */

var validConfigTypes = {
  string: 1,
  object: 1,
  function: 1 // used by CellTooltip

};
/**
 * Mixin for Grid that handles features. Features are plugins that add functionality to the grid. Feature classes should
 * register with Grid by calling {@link Grid.feature.GridFeatureManager#function-registerFeature-static registerFeature}. This
 * enables features to be specified and configured in grid
 * config.
 *
 * Define which features to use:
 *
 * ```javascript
 * // specify which features to use (note that some features are used by default)
 * const grid = new Grid({
 *   features: {
 *      sort: 'name',
 *      search: true
 *   }
 * });
 * ```
 *
 * Access a feature in use:
 *
 * ```javascript
 * grid.features.search.search('cat');
 * ```
 *
 * Basic example of implementing a feature:
 *
 * ```javascript
 * class MyFeature extends InstancePlugin {
 *
 * }
 *
 * GridFeatures.registerFeature(MyFeature);
 *
 * // using the feature
 * const grid = new Grid({
 *   features: {
 *     myFeature: true
 *   }
 * });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(GridFeatures, _ref);

    var _super = _createSuper(GridFeatures);

    function GridFeatures() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, GridFeatures);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(GridFeatures, [{
      key: "createFeatureInitializer",
      value: function createFeatureInitializer(features, featureName, featureClass, config) {
        var constructorArgs = [this],
            construct = featureClass.prototype.construct; // Only pass config if there is one.
        // The constructor(config = {}) only works for undefined config

        if (validConfigTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default()(config)]) {
          constructorArgs[1] = config;
        }

        return {
          configurable: true,
          get: function get() {
            // Delete this defined property and replace it with the Feature instance.
            delete features[featureName]; // Ensure the feature is injected into the features object before initialization
            // so that it is available from call chains from its initialization.

            featureClass.prototype.construct = function () {
              features[featureName] = this;

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              construct.apply(this, args);
              featureClass.prototype.construct = construct;
            }; // Return the Feature instance


            return _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_7___default()(featureClass, constructorArgs);
          }
        };
      } //endregion
      //region Other stuff

      /**
       * Check if a feature is included
       * @param {String} name Feature name, as registered with `GridFeatureManager.registerFeature()`
       * @returns {Boolean}
       * @category Misc
       */

    }, {
      key: "hasFeature",
      value: function hasFeature(name) {
        return !!(this.features && this.features[name]);
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "features",
      //region Init

      /**
       * Specify which features to use on the grid. Most features accepts a boolean, some also accepts a config object.
       * Please note that if you are not using the bundles you might need to import the features you want to use.
       *
       * ```javascript
       * const grid = new Grid({
       *     features : {
       *         stripe : true,   // Enable stripe feature
       *         sort   : 'name', // Configure sort feature
       *         group  : false   // Disable group feature
       *     }
       * }
       * ```
       *
       * @config {Object} features
       * @category Common
       */

      /**
       * Map of the features available on the grid. Use it to access them on your grid object
       *
       * ```javascript
       * grid.features.group.expandAll();
       * ```
       *
       * @readonly
       * @member {Object} features
       * @category Common
       * @typings any
       */
      set: function set(features) {
        var me = this,
            defaultFeatures = _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__["default"].getInstanceDefaultFeatures(this);
        features = me._features = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].assign({}, features); // default features, enabled unless otherwise specified

        if (defaultFeatures) {
          Object.keys(defaultFeatures).forEach(function (feature) {
            if (!(feature in features)) {
              features[feature] = true;
            }
          });
        } // We *prime* the features so that if any configuration code accesses a feature, it
        // will self initialize, but if not, they will remain in a primed state until afterConfigure.


        var registeredInstanceFeatures = _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__["default"].getInstanceFeatures(this);

        for (var _i = 0, _Object$keys = Object.keys(features); _i < _Object$keys.length; _i++) {
          var featureName = _Object$keys[_i];
          var config = features[featureName]; // Create feature initialization property if config is truthy.
          // Config must be a valid configuration value for the feature class.

          if (config) {
            // Feature configs name must start with lowercase letter to be valid
            if (_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].uncapitalize(featureName) !== featureName) {
              throw new Error("Invalid feature name '".concat(featureName, "', must start with a lowercase letter"));
            }

            var featureClass = registeredInstanceFeatures[featureName];

            if (!featureClass) {
              throw new Error("Feature '".concat(featureName, "' not available, make sure you have imported it"));
            } // Create a self initializing property on the features object named by the feature name.
            // when accessed, it will create and return the real feature.
            // Now, if some Feature initialization code attempt to access a feature which has not yet been initialized
            // it will be initialized just in time.


            Reflect.defineProperty(features, featureName, me.createFeatureInitializer(features, featureName, featureClass, config));
          }
        }
      },
      get: function get() {
        return this._features;
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'GridFeatures';
      }
    }]);

    return GridFeatures;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_14__["default"]);
});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridNavigation.js":
/*!***********************************************!*\
  !*** ./lib/Grid/view/mixin/GridNavigation.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Grid/view/mixin/GridNavigation
 */

var defaultFocusOptions = Object.freeze({
  doSelect: true
}),
    disableScrolling = Object.freeze({
  x: false,
  y: false
});
/**
 * Mixin for Grid that handles cell to cell navigation.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(GridNavigation, _ref);

    var _super = _createSuper(GridNavigation);

    function GridNavigation() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, GridNavigation);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(GridNavigation, [{
      key: "onGridElementFocus",

      /**
       * Grid element focus, selects first row and cell when grid is focused if none is selected (otherwise user cannot
       * see that grid is focused).
       * Chain this function it features to handle the dom event.
       * @param event
       * @category Other events
       * @internal
       */
      value: function onGridElementFocus(event) {
        // Select first row if none is selected when grid is focused (to show that it has focus)
        var me = this,
            focusOptions = {
          doSelect: false,
          event: event
        };

        if (me._initialFocusedCellContext) {
          var _me$_initialFocusedCe = me._initialFocusedCellContext,
              cellSelector = _me$_initialFocusedCe.cellSelector,
              options = _me$_initialFocusedCe.options;
          me._focusedCell = null;
          me.focusCell(cellSelector, options);
          me._initialFocusedCellContext = null;
        } else if (me._focusedCell) {
          me.focusCell(me._focusedCell, focusOptions);
        } else {
          // If they just clicked in blank space, do not refocus the last focused cell.
          // We focus cell 0, 0 on that gesture.
          var targetContext = me.element.contains(event.relatedTarget) ? null : me.lastFocusedCell;

          if (targetContext) {
            var cell = me.getCell(targetContext); // If we're using lastFocusedCell and the cell is no longer in existence, or not visible
            // or the previously focused record has since been removed.
            // Fallback to reverting to where focus entered the grid from.
            // TODO: CellContext should store the record index
            // to fall back to if the actual record is no longer present.

            if (!cell || !_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isVisible(cell) || !me.store.getById(targetContext.id)) {
              me.revertFocus();
              return;
            } // flag to not affect selection


            me.returningFocus = true;
            me.focusCell(targetContext, focusOptions);
            me.returningFocus = false;
          } else if (!me.scrolling && !me.skipFocusSelection && me.store.first) {
            var evt = me.mouseMoveEvent,
                rm = me.rowManager,
                r = me._bodyRectangle,
                defaultRow = evt && rm.getRowAt(Math.min(Math.max(evt.clientY, r.y), r.bottom)) || me.firstFullyVisibleRow,
                focusContext = evt && me.getCellDataFromEvent(evt) || {
              id: defaultRow.id,
              columnId: me.columns.visibleColumns[0].id
            };

            if (me.getCell(focusContext)) {
              me.focusCell(focusContext, focusOptions);
            }
          }
        }

        me.skipFocusSelection = false;
      }
    }, {
      key: "onFocusOut",
      value: function onFocusOut(event) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridNavigation.prototype), "onFocusOut", this).call(this, event);

        this.clearFocus();
      }
    }, {
      key: "afterHide",
      value: function afterHide() {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridNavigation.prototype), "afterHide", this).apply(this, arguments); // Do not scroll back to the last focused cell/last moused over cell upon reshow


        this.lastFocusedCell = this.mouseMoveEvent = null;
      }
      /**
       * Checks whether or not a cell is focused.
       * @param {Object|string|Number} cellSelector Cell selector { id: x, columnId: xx } or row id
       * @returns {Boolean} true if cell or row is focused, otherwise false
       */

    }, {
      key: "isFocused",
      value: function isFocused(cellSelector) {
        return Boolean(this._focusedCell) && this.isLocationEqual(cellSelector, this._focusedCell);
      }
      /**
       * Navigates to a cell and/or its row (depending on selectionMode)
       * @param {Object} cellSelector { id: rowId, columnId: 'columnId' }
       * @param {Object} options Modifier options for how to deal with focusing the cell. These
       * are used as the {@link Core.helper.util.Scroller#function-scrollTo} options.
       * @param {Boolean} [options.doSelect=true] Optionally pass `false` to not continue to selection.
       * @param {Event} [options.event] Optionally pass the UI event which instigated the focus request.
       * @param {Object|boolean} [options.scroll=true] Pass `false` to not scroll the cell into view, or a
       * scroll options object to affact the scroll.
       * @returns {Object} Cell selector
       * @fires navigate
       */

    }, {
      key: "focusCell",
      value: function focusCell(cellSelector) {
        var _options, _options$event, _Widget$fromElement;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFocusOptions;

        // Mac OS specific behaviour: when you right click a non-active window, the window does not receive focus, but the context menu is shown.
        // So for Mac OS we treat the right click as a non-focusable action, if window is not active
        if (!document.hasFocus() && _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isMac && ((_options = options) === null || _options === void 0 ? void 0 : (_options$event = _options.event) === null || _options$event === void 0 ? void 0 : _options$event.button) === 2) {
          return;
        }

        var me = this,
            activeElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].activeElement; // If we're being passed a context object (as opposed to a record), clone in case we were
        // passed the _focusedCell, and after refresh isLocationEqual needs to detect a difference.

        cellSelector = me.normalizeCellContext(cellSelector === Object ? Object.assign({}, cellSelector) : cellSelector);
        var doSelect = options.doSelect !== false,
            _options2 = options,
            event = _options2.event,
            scroll = _options2.scroll,
            lastFocusedCell = me.lastFocusedCell = me._focusedCell,
            isNotMove = me.isLocationEqual(cellSelector, lastFocusedCell),
            lastCell = lastFocusedCell && me.getCell(lastFocusedCell),
            subGrid = me.getSubGridFromColumn(cellSelector.columnId);
        var cell = me.getCell(cellSelector); // If we're focusing due to a mousedown on a focusable element *within* a cell
        // then we do not "navigate" to the cell - we allow the element to be focused.
        // For example a CheckColumn or WidgetColumn.

        if (event && event.type === 'mousedown') {
          for (var target = event.target; target !== cell; target = target.parentElement) {
            if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isFocusable(target)) {
              cellSelector.element = target;
              return;
            }
          }
        } // No navigation takes place, but the selection still needs to know if a UI event happened.


        if (isNotMove) {
          if (event) {
            me.onCellNavigate && me.onCellNavigate(me, null, me._focusedCell, event, doSelect);
          }

          return cellSelector;
        }

        if (lastCell) {
          lastCell.classList.remove('b-focused');
        } // DomHelper.focusWithoutScrolling means "Don't try to scroll this element into view"
        // because browsers try to move the element into view.
        // But the grid itself needs to scroll the cell into view.


        var testCell = cell || me.getCell({
          row: me.rowManager.topIndex,
          columnId: cellSelector.columnId
        }),
            subGridRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_15__["default"].from(subGrid.element),
            bodyRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_15__["default"].from(me.bodyContainer),
            cellRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_15__["default"].from(testCell).moveTo(null, subGridRect.y);

        if (scroll === false) {
          options = Object.assign({}, options, disableScrolling);
        } else {
          options = Object.assign({}, options, scroll); // If the test cell is larger than the subGrid, in any dumension, disable scrolling

          if (cellRect.width > subGridRect.width || cellRect.height > bodyRect.height) {
            options.x = options.y = false;
          } // Else ask for the column to be scrolled into view
          else {
              options.column = cellSelector.columnId;
            }

          me.scrollRowIntoView(cellSelector.id, options);
        } // If active element is not a part of the grid body,
        // and the grid does not own the widget which is represented by the active element
        // (for example header element), focus the cell without scrolling


        if (activeElement !== me.focusElement && !me.focusElement.contains(activeElement) && ((_Widget$fromElement = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_16__["default"].fromElement(activeElement)) === null || _Widget$fromElement === void 0 ? void 0 : _Widget$fromElement.owner) !== me) {
          me._initialFocusedCellContext = {
            cellSelector: cellSelector,
            options: options
          };
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].focusWithoutScrolling(me.focusElement); // If focusing didn't work right away, clear the cached value, so onGridElementFocus is not affected by the value.
          // Does not work in IE11 because focus in IE asynchronous. Just ignore it.

          if (!me.isLocationEqual(cellSelector, me._focusedCell) && !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isIE11) {
            me._initialFocusedCellContext = null;
          }

          return;
        } // Get the newly visible cell *after* it has been scrolled into view.
        // With buffered rendering, it may not have existed before the scroll.


        cell = me.getCell(cellSelector);

        if (cell) {
          cellSelector.element = cell;
          cell.classList.add('b-focused');
        } //Remember


        me._focusedCell = cellSelector;
        me.onCellNavigate && me.onCellNavigate(me, lastFocusedCell, me._focusedCell, event, doSelect);
        me.trigger('navigate', {
          lastFocusedCell: lastFocusedCell,
          focusedCell: me._focusedCell,
          event: event
        }); //TODO: should be able to cancel selectcell from listeners

        return cellSelector;
      }
    }, {
      key: "isLocationEqual",
      value: function isLocationEqual(cellSelector, otherCellSelector) {
        return cellSelector && otherCellSelector && cellSelector.id === otherCellSelector.id && cellSelector.columnId === otherCellSelector.columnId && ( // Normalized cellSelectors are not required to have an element, only compare elements if both selectors
        // have it specified
        !cellSelector.element || !otherCellSelector.element || cellSelector.element === otherCellSelector.element);
      }
    }, {
      key: "blurCell",
      value: function blurCell(cellSelector) {
        var me = this,
            cell = me.getCell(cellSelector);

        if (cell) {
          cell.classList.remove('b-focused');
        }
      }
    }, {
      key: "clearFocus",
      value: function clearFocus() {
        var me = this;

        if (me._focusedCell) {
          // set last to have focus return to previous cell when alt tabbing
          me.lastFocusedCell = me._focusedCell;
          me.blurCell(me._focusedCell);
          me._focusedCell = null;
        }
      }
      /**
       * Selects the cell before or after currently focused cell.
       * @private
       * @param next Specify true to select the next cell, false to select the previous
       * @param {Event} [event] Optionally, the UI event which caused navigation.
       * @returns {Object} Used cell selector
       */

    }, {
      key: "internalNextPrevCell",
      value: function internalNextPrevCell() {
        var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var event = arguments.length > 1 ? arguments[1] : undefined;
        var me = this,
            cellSelector = me._focusedCell;

        if (cellSelector) {
          return me.focusCell({
            id: cellSelector.id,
            columnId: me.columns.getAdjacentVisibleLeafColumn(cellSelector.columnId, next, true).id
          }, {
            doSelect: true,
            event: event
          });
        }

        return null;
      }
      /**
       * Select the cell after the currently focused one.
       * @param {Event} [event] Optionally, the UI event which caused navigation.
       * @returns {Object} Cell selector
       */

    }, {
      key: "navigateRight",
      value: function navigateRight(event) {
        return this.internalNextPrevCell(true, event);
      }
      /**
       * Select the cell before the currently focused one.
       * @param {Event} [event] Optionally, the UI event which caused navigation.
       * @returns {Object} Cell selector
       */

    }, {
      key: "navigateLeft",
      value: function navigateLeft(event) {
        return this.internalNextPrevCell(false, event);
      } //endregion
      //region Row

      /**
       * Selects the next or previous record in relation to the current selection. Scrolls into view if outside.
       * @private
       * @param next Next record (true) or previous (false)
       * @param {Boolean} skipSpecialRows True to not return specialRows like headers
       * @param {Event} [event] Optionally, the UI event which caused navigation.
       * @returns {Object|Boolean} Selection context for the focused row (& cell) or false if no selection was made
       */

    }, {
      key: "internalNextPrevRow",
      value: function internalNextPrevRow(next) {
        var skipSpecialRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var event = arguments.length > 2 ? arguments[2] : undefined;
        var me = this,
            cell = me._focusedCell;
        if (!cell) return false;
        var record = me.store["get".concat(next ? 'Next' : 'Prev')](cell.id, false, skipSpecialRows);

        if (record) {
          return me.focusCell({
            id: record.id,
            columnId: cell.columnId,
            scroll: {
              x: false
            }
          }, {
            doSelect: true,
            event: event
          });
        } else if (!next) {
          this.clearFocus();
          return this.getHeaderElement(cell.columnId).focus();
        }
      }
      /**
       * Navigates to the cell below the currently focused cell
       * @param {Event} [event] Optionally, the UI event which caused navigation.
       * @returns {Object} Selector for focused row (& cell)
       */

    }, {
      key: "navigateDown",
      value: function navigateDown(event) {
        return this.internalNextPrevRow(true, false, event);
      }
      /**
       * Navigates to the cell above the currently focused cell
       * @param {Event} [event] Optionally, the UI event which caused navigation.
       * @returns {Object} Selector for focused row (& cell)
       */

    }, {
      key: "navigateUp",
      value: function navigateUp(event) {
        return this.internalNextPrevRow(false, false, event);
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "focusedCell",
      //region Cell

      /**
       * User navigated to a grid cell
       * @event navigate
       * @param {Grid.view.Grid} grid
       * @param {Object} last focused location
       * @param {Object} location focus moved to
       * @param {Event} [event] The UI event which caused navigation.
       */

      /**
       * Cell selector for focused cell, set to focus a cell or use {@link #function-focusCell}.
       * @property {Object}
       */
      get: function get() {
        var result = this._focusedCell;

        if (result && this.getCell(result)) {
          return result;
        }

        this.clearFocus();
      }
      /**
       * This property is `true` if an element _within_ a cell is focused.
       * @property {Boolean}
       * @readonly
       */
      ,
      set: function set(cellSelector) {
        this.focusCell(cellSelector, {
          doSelect: false
        });
      }
    }, {
      key: "isActionableLocation",
      get: function get() {
        var focusedCell = this._focusedCell;
        return Boolean(focusedCell && focusedCell.element && this.getCell(focusedCell).contains(focusedCell.element));
      }
    }, {
      key: "focusedRecord",
      get: function get() {
        if (this._focusedCell) {
          return this.store.getById(this._focusedCell.id);
        }
      }
      /**
       * CSS selector for currently focused cell. Format is "[data-index=index] [data-column-id=columnId]".
       * @property {String}
       * @readonly
       */

    }, {
      key: "cellCSSSelector",
      get: function get() {
        var me = this,
            cell = me._focusedCell,
            row = cell && me.getRowById(cell.id);
        if (!cell || !row) return '';
        return "[data-index=".concat(row.index, "] [data-column-id=").concat(cell.columnId, "]");
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'GridNavigation';
      }
    }]);

    return GridNavigation;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]);
});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridResponsive.js":
/*!***********************************************!*\
  !*** ./lib/Grid/view/mixin/GridResponsive.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Grid/view/mixin/GridResponsive
 */

/**
 * Simplifies making grid responsive. Supply levels as {@link #config-responsiveLevels} config, default levels are:
 * <dl>
 * <dt>small <dd>< 400px,
 * <dt>medium <dd>< 600px
 * <dt>large <dd>> 600px
 * </dl>
 *
 * Columns can define configs per level to be resized etc:
 *
 * ```
 * let grid = new Grid({
 *   responsiveLevels: {
 *     small: 300,
 *     medium: 400,
 *     large: '*' // everything above 400
 *   },
 *
 *   columns: [
 *     {
 *       field: 'name',
 *       text: 'Name',
 *       responsiveLevels: {
 *         small: { hidden: true },
 *         '*': { hidden: false } // all other levels
 *       }
 *     },
 *     { field: 'xx', ... }
 *   ]
 * });
 * ```
 *
 * It is also possible to give a [Grid state](#Grid/view/mixin/GridState) object instead of a level width, but in that
 * case the object must contain a `levelWidth` property:
 *
 * ```
 * let grid = new Grid({
 *   responsiveLevels: {
 *     small: {
 *       // Width is required
 *       levelWidth : 400,
 *       // Other configs are optional, see GridState for available options
 *       rowHeight  : 30
 *     },
 *     medium : {
 *       levelWidth : 600,
 *       rowHeight  : 40
 *     },
 *     large: {
 *       levelWidth : '*', // everything above 300
 *       rowHeight  : 45
 *     }
 *   }
 * });
 * ```
 *
 * @demo Grid/responsive
 * @externalexample grid/Responsive.js
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(GridResponsive, _ref);

    var _super = _createSuper(GridResponsive);

    function GridResponsive() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, GridResponsive);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(GridResponsive, [{
      key: "getClosestBiggerLevel",

      /**
       * Find closes bigger level, aka level we want to use.
       * @private
       * @category Misc
       */
      value: function getClosestBiggerLevel(width) {
        var me = this,
            levels = Object.keys(me.responsiveLevels),
            useLevel = null,
            minDelta = 99995,
            biggestLevel = null;
        levels.forEach(function (level) {
          var levelSize = me.responsiveLevels[level]; // responsiveLevels can contains config objects, in which case we should use width from it

          if (!['number', 'string'].includes(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default()(levelSize))) {
            levelSize = levelSize.levelWidth;
          }

          if (levelSize === '*') {
            biggestLevel = level;
          } else if (width < levelSize) {
            var delta = levelSize - width;

            if (delta < minDelta) {
              minDelta = delta;
              useLevel = level;
            }
          }
        });
        return useLevel || biggestLevel;
      }
      /**
       * Get currently used responsive level (as string)
       * @returns {String}
       * @readonly
       * @category Misc
       */

    }, {
      key: "updateResponsive",

      /**
       * Check if resize lead to a new responsive level and take appropriate actions
       * @private
       * @fires responsive
       * @param width
       * @param oldWidth
       * @category Misc
       */
      value: function updateResponsive(width, oldWidth) {
        var me = this,
            oldLevel = me.getClosestBiggerLevel(oldWidth),
            level = me.getClosestBiggerLevel(width);

        if (oldLevel !== level) {
          // Level might be a state object
          var levelConfig = me.responsiveLevels[level];

          if (!['number', 'string'].includes(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8___default()(levelConfig))) {
            me.applyState(levelConfig);
          } // check columns for responsive config


          me.columns.forEach(function (column) {
            var levels = column.responsiveLevels;

            if (levels) {
              if (levels[level]) {
                // using state to apply responsive config, since it already does what we want...
                column.applyState(levels[level]);
              } else if (levels['*']) {
                column.applyState(levels['*']);
              }
            }
          });
          me.element.classList.remove('b-responsive-' + oldLevel);
          me.element.classList.add('b-responsive-' + level);
          /**
           * Grid resize lead to a new responsive level being applied
           * @event responsive
           * @param {Grid.view.Grid} grid Grid that was resized
           * @param {String} level New responsive level (small, large, etc)
           * @param {Number} width New width in px
           * @param {String} oldLevel Old responsive level
           * @param {Number} oldWidth Old width in px
           */

          me.trigger('responsive', {
            level: level,
            width: width,
            oldLevel: oldLevel,
            oldWidth: oldWidth
          });
        }
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "responsiveLevel",
      get: function get() {
        return this.getClosestBiggerLevel(this.width);
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'GridResponsive';
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * "Break points" for which responsive config to use for columns and css.
           * @config {Object}
           * @category Misc
           * @default <code>{ small : 400, medium : 600, large : '*' }</code>
           */
          responsiveLevels: Object.freeze({
            small: 400,
            medium: 600,
            large: '*'
          })
        };
      }
    }]);

    return GridResponsive;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_14__["default"]);
});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridSelection.js":
/*!**********************************************!*\
  !*** ./lib/Grid/view/mixin/GridSelection.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../../Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");






























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_27___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var validIdTypes = {
  string: 1,
  number: 1
},
    isSelectAction = {
  dataset: 1,
  batch: 1
};
/**
 * @module Grid/view/mixin/GridSelection
 */

/**
 * A mixin for Grid that handles row and cell selection. See {@link #config-selectionMode} for details on how to control what should be selected (rows or cells)
 *
 * @example
 * // select a row
 * grid.selectedRow = 7;
 *
 * // select a cell
 * grid.selectedCell = { id: 5, columnId: 'column1' }
 *
 * // select a record
 * grid.selectedRecord = grid.store.last;
 *
 * // select multiple records by ids
 * grid.selectedRecords = [1, 2, 4, 6]
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_26___default()(GridSelection, _ref);

    var _super = _createSuper(GridSelection);

    function GridSelection() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_23___default()(this, GridSelection);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_24___default()(GridSelection, [{
      key: "afterConfigure",
      //region Init
      value: function afterConfigure() {
        var me = this; // Inject our CheckColumn into the ColumnStore

        if (me.selectionMode.checkbox) {
          var checkColumnClass = _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_31__["default"].getColumnClass('check');

          if (!checkColumnClass) {
            throw new Error('CheckColumn must be imported for checkbox selection mode to work');
          }

          var col = me.checkboxColumn = new checkColumnClass({
            id: "".concat(me.id, "-selection-column"),
            width: '4em',
            minWidth: '4em',
            // Misaligned on IE11 without, since 4em is below columns default minWidth
            field: null,
            cellCls: 'b-checkbox-selection',
            // Always put the checkcolumn in the first region
            region: me.items[0].region,
            showCheckAll: me.selectionMode.showCheckAll
          }, me.columns);
          col.meta.depth = 0; // This is assigned in Column.js for normal columns

          col._grid = me; // Override renderer to inject the rendered record's selected status into the value

          var checkboxRenderer = col.renderer;

          col.renderer = function (renderData) {
            renderData.value = me.isSelected(renderData.record);
            checkboxRenderer.call(col, renderData);
          };

          col.on({
            toggle: 'onCheckChange',
            toggleAll: 'onCheckAllChange',
            thisObj: me
          }); // Insert the checkbox after any rownumber column. If not there, -1 means in at 0.

          var insertIndex = me.columns.indexOf(me.columns.findRecord('type', 'rownumber')) + 1;
          me.columns.insert(insertIndex, col);
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(GridSelection.prototype), "afterConfigure", this).call(this);
      } //endregion
      //region Events

      /**
       * Triggered from Grid view when the id of a record has changed.
       * Update the collection indices.
       * @private
       * @category Selection
       */

    }, {
      key: "onStoreRecordIdChange",
      value: function onStoreRecordIdChange(_ref2) {
        var record = _ref2.record,
            oldValue = _ref2.oldValue;
        // If the next mixin up the inheritance chain has an implementation, call it
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(GridSelection.prototype), "onStoreRecordIdChange", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(GridSelection.prototype), "onStoreRecordIdChange", this).apply(this, arguments);
        var item = this.selectedRecordCollection.get(oldValue); // having the record registered by the oldValue means we need to rebuild indices

        if (item === record) {
          this.selectedRecordCollection.rebuildIndices();
        }
      }
      /**
       * The selection has been changed.
       * @event selectionchange
       * @param {String} action `'select'`/`'deselect'`
       * @param {String} mode `'row'`/`'cell'`
       * @param {Grid.view.Grid} source
       * @param {Core.data.Model[]|Object} deselected The records or cells (depending on the `mode`) deselected in this operation.
       * @param {Core.data.Model[]|Object} selected The records or cells (depending on the `mode`) selected in this operation.
       * @param {Core.data.Model[]|Object} selection  The records or cells (depending on the `mode`) in the new selection.
       */

      /**
       * Responds to mutations of the underlying storage Collection
       * @param {Object} event
       * @private
       */

    }, {
      key: "onSelectedRecordCollectionChange",
      value: function onSelectedRecordCollectionChange(_ref3) {
        var selectedRecordCollection = _ref3.source,
            action = _ref3.action,
            _ref3$added = _ref3.added,
            added = _ref3$added === void 0 ? [] : _ref3$added,
            removed = _ref3.removed;
        var me = this;

        if (me._selectedCell && !me.isSelectable(me._selectedCell)) {
          me.deselectCell(me._selectedCell);
        } // Filter out unselectable rows


        added = added.filter(function (row) {
          return me.isSelectable(row);
        });
        me.triggerChangeEvent({
          mode: 'row',
          action: added.length ? 'select' : 'deselect',
          selection: me.selectedRecords,
          selected: added,
          deselected: removed
        }, me.silent);
      }
    }, {
      key: "onCheckChange",
      value: function onCheckChange(_ref4) {
        var column = _ref4.source,
            checked = _ref4.checked,
            record = _ref4.record;

        if (checked) {
          this.selectRow({
            record: record,
            column: column,
            addToSelection: this.selectionMode.multiSelect !== false,
            scrollIntoView: false
          });

          if (column.headerCheckbox && this.selectedRecords.length === this.store.count - (this.store.groupRecords ? this.store.groupRecords.length : 0)) {
            column.suspendEvents();
            column.headerCheckbox.checked = true;
            column.resumeEvents();
          }
        } else {
          this.deselectRow(record);

          if (column.headerCheckbox) {
            column.suspendEvents();
            column.headerCheckbox.checked = false;
            column.resumeEvents();
          }
        }
      }
    }, {
      key: "onCheckAllChange",
      value: function onCheckAllChange(_ref5) {
        var checked = _ref5.checked;
        this[checked ? 'selectAll' : 'deselectAll']();
      } //endregion
      //region Selection collection

    }, {
      key: "spliceSelectedRecords",

      /**
       * Removes and adds records to/from the selection at the same time. Analogous
       * to the `Array` `splice` method.
       *
       * Note that if items that are specified for removal are also in the `toAdd` array,
       * then those items are *not* removed then appended. They remain in the same position
       * relative to all remaining items.
       *
       * @param {Number} index Index at which to remove a block of items. Only valid if the
       * second, `toRemove` argument is a number.
       * @param {Object[]|Number} toRemove Either the number of items to remove starting
       * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
       * @param  {Object[]|Object} toAdd An item, or an array of items to add.
       */
      value: function spliceSelectedRecords(index, toRemove, toAdd) {
        this._selectedRecordCollection.splice(index, toRemove, toAdd);
      } //endregion
      //region Cell & row

      /**
       * Checks whether or not a cell or row is selected.
       * @param {Object|string|Number|Core.data.Model} cellSelectorOrId Cell selector { id: x, column: xx } or row id, or record
       * @returns {Boolean} true if cell or row is selected, otherwise false
       * @category Selection
       */

    }, {
      key: "isSelected",
      value: function isSelected(cellSelectorOrId) {
        var _cellSelectorOrId;

        var me = this; // A record passed
        // HACK: replaces instanceof check with this because it makes GridSelection test in Edge more stable

        if ((_cellSelectorOrId = cellSelectorOrId) === null || _cellSelectorOrId === void 0 ? void 0 : _cellSelectorOrId.isModel) {
          cellSelectorOrId = cellSelectorOrId.id;
        }

        if (validIdTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_22___default()(cellSelectorOrId)]) {
          return me.selectedRecordCollection.includes(cellSelectorOrId);
        } else {
          return me._selectedCell && me._selectedCell.id == cellSelectorOrId.id && me._selectedCell.columnId === cellSelectorOrId.columnId;
        }
      }
      /**
       * Checks whether or not a cell or row can be selected.
       * @param recordCellOrId Record or cell or record id
       * @returns {Boolean} true if cell or row cane be selected, otherwise false
       * @category Selection
       */

    }, {
      key: "isSelectable",
      value: function isSelectable(recordCellOrId) {
        // Selection disabled for undefined record, special row (group header / footer) and
        // record which was already removed from store
        if (!recordCellOrId) {
          return false;
        }

        var row = this.store.getById(recordCellOrId.id || recordCellOrId);
        return row && !(row.meta && row.isSpecialRow);
      }
      /**
       * Cell selector for selected cell, set to select a cell or use {@link #function-selectCell()}.
       * @property {Object}
       * @category Selection
       */

    }, {
      key: "selectRow",

      /**
       * Selects a row (without selecting a cell).
       * @param {Object} options
       * @param (Core.data.Model|String) options.record Record or record id, specifying null will deselect all
       * @param {Column} [Grid.column.Column|String] The column to scroll into view if `scrollIntoView` is not specified as `false`. Defaults to the grid's first column.
       * @param {Boolean} [options.scrollIntoView] Specify `false` to prevent row from being scrolled into view
       * @param {Boolean} [options.addToSelection] Specify `true` to add to selection, defaults to `false` which replaces
       * @fires selectionchange
       * @category Selection
       */
      value: function selectRow(_ref6) {
        var record = _ref6.record,
            _ref6$column = _ref6.column,
            column = _ref6$column === void 0 ? this.columns.bottomColumns[0] : _ref6$column,
            _ref6$scrollIntoView = _ref6.scrollIntoView,
            scrollIntoView = _ref6$scrollIntoView === void 0 ? true : _ref6$scrollIntoView,
            _ref6$addToSelection = _ref6.addToSelection,
            addToSelection = _ref6$addToSelection === void 0 ? false : _ref6$addToSelection;

        // TODO: Remove this backward compatibility code in 3.0
        if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_22___default()(arguments[0]) !== 'object') {
          var args = arguments;
          record = args[0];
          scrollIntoView = args.length > 1 ? args[1] : true;
          addToSelection = args[2] || false;
        }

        var me = this,
            targetRecord = me.store.getById(record);

        if (record) {
          me.selectCell({
            id: targetRecord.id,
            column: column
          }, scrollIntoView, addToSelection);
        } else {
          me.deselectAll();
        }
      }
      /**
       * Selects a cell and/or its row (depending on selectionMode)
       * @param {Object} cellSelector { id: rowId, columnId: 'columnId' }
       * @param {Boolean} scrollIntoView Specify false to prevent row from being scrolled into view
       * @param {Boolean} addToSelection Specify `true` to add to selection, defaults to `false` which replaces
       * @param {Boolean} silent Specify `true` to not trigger any events when selecting the cell
       * @returns {Object} Cell selector
       * @fires selectionchange
       * @category Selection
       */

    }, {
      key: "selectCell",
      value: function selectCell(cellSelector) {
        var scrollIntoView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var addToSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var silent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var me = this,
            selectedRecordCollection = me.selectedRecordCollection,
            selectionMode = me.selectionMode,
            selector = me.normalizeCellContext(cellSelector),
            record = selector.record || me.store.getById(selector.id); // Clear selection if row is not selectable

        if (!me.isSelectable(record)) {
          this.deselectAll();
          return;
        }

        if (scrollIntoView) {
          me.scrollRowIntoView(selector.id, {
            column: selector.columnId
          });
        } // Row selection (both sides if locked columns)


        if (selectionMode.row) {
          if (silent) {
            me.silent = (me.silent || 0) + 1;
          }

          if (addToSelection) {
            selectedRecordCollection.add(record);
          } // Clear all others
          else {
              selectedRecordCollection.splice(0, selectedRecordCollection.count, record);
            }

          if (silent) {
            me.silent--;
          } // When starting a selection, register the start cell


          if (me.selectedRecordCollection.count === 1) {
            me.startCell = selector;
            me.lastRange = null;
          }
        } // Cell selection


        if (selectionMode.cell && (selector.columnId || selector.column) && !me.isSelected(selector)) {
          var deselected = me._selectedCell ? [me._selectedCell] : []; //Remember

          me._selectedCell = selector;
          me.triggerChangeEvent({
            mode: 'cell',
            action: 'select',
            selected: [selector],
            deselected: deselected,
            selection: [selector]
          }, silent);
        }

        return selector;
      }
      /**
       * Selects all rows. If store is filterered, this will merge the selection of all visible rows with any selection made prior to filtering
       * @category Selection
       */

    }, {
      key: "selectAll",
      value: function selectAll() {
        var me = this;

        if (me.store.isFiltered) {
          var _me$selectedRecordCol;

          (_me$selectedRecordCol = me.selectedRecordCollection).add.apply(_me$selectedRecordCol, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_21___default()(me.store.records.filter(function (r) {
            return !r.isSpecialRow;
          })));
        } else {
          me.selectedRecords = me.store.records.filter(function (r) {
            return !r.isSpecialRow;
          });
        }
      }
      /**
       * Deselects all selected rows and cells. If store is filterered, this will unselect all visible rows only. Any selections made prior to filtering remains.
       * @category Selection
       */

    }, {
      key: "deselectAll",
      value: function deselectAll() {
        var me = this;

        if (me.store.isFiltered) {
          var _me$selectedRecordCol2;

          (_me$selectedRecordCol2 = me.selectedRecordCollection).remove.apply(_me$selectedRecordCol2, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_21___default()(me.store.records.filter(function (r) {
            return !r.isSpecialRow;
          })));
        } else {
          me.selectedRecordCollection.clear();
        }

        if (me._selectedCell) {
          me.deselectCell(me._selectedCell);
        }
      }
      /**
       * Deselect a row
       * @param {Core.data.Model|String|Number} recordOrId Record or an id for a record
       * @category Selection
       */

    }, {
      key: "deselectRow",
      value: function deselectRow(record) {
        this.deselectRows(record);
      }
      /**
       * Deselect one or more rows
       * @param {Core.data.Model|String|Number|Core.data.Model[]|String[]|Number[]} recordOrIds An array of records or ids for a record
       * @category Selection
       */

    }, {
      key: "deselectRows",
      value: function deselectRows(recordsOrIds) {
        var _this = this;

        recordsOrIds = Array.isArray(recordsOrIds) ? recordsOrIds : [recordsOrIds];
        var records = recordsOrIds.map(function (recordOrId) {
          return _this.store.getById(recordOrId);
        });
        this.selectedRecordCollection.remove(records);
      }
      /**
       * Deselect a cell/row, depending on settings in Grid#selectionMode
       * @param {Object} cellSelector
       * @returns {Object} Normalized cell selector
       * @category Selection
       */

    }, {
      key: "deselectCell",
      value: function deselectCell(cellSelector) {
        var me = this,
            selector = me.normalizeCellContext(cellSelector),
            selMode = me.selectionMode,
            record = selector.record || me.store.getById(selector.id),
            selectedCell = me._selectedCell; // Row selection (both sides if locked columns)

        if (selMode.row) {
          me.selectedRecordCollection.remove(record);
        } // Cell selection


        if (selMode.cell && selector.columnId && selectedCell) {
          if (selectedCell.id === selector.id && selectedCell.columnId === selector.columnId) {
            me._selectedCell = null;
            me.triggerChangeEvent({
              mode: 'cell',
              action: 'deselect',
              selected: [],
              deselected: [selector],
              selection: []
            });
          }
        }

        return selector;
      } //endregion
      //region Record

      /**
       * Selects rows corresponding to a range of records (from fromId to toId)
       * @param {String|Number} fromId
       * @param {String|Number} toId
       * @category Selection
       */

    }, {
      key: "selectRange",
      value: function selectRange(fromId, toId) {
        var store = this.store,
            selectedRecordCollection = this.selectedRecordCollection,
            fromIndex = store.indexOf(fromId),
            toIndex = store.indexOf(toId),
            startIndex = Math.min(fromIndex, toIndex),
            endIndex = Math.max(fromIndex, toIndex);

        if (startIndex === -1 || endIndex === -1) {
          throw new Error('Record not found in selectRange');
        }

        selectedRecordCollection.splice(0, selectedRecordCollection.count, store.getRange(startIndex, endIndex + 1, false));
      }
      /**
       * Triggered from Grid view when records get removed from the store.
       * Deselects all records which have been removed.
       * @private
       * @category Selection
       */

    }, {
      key: "onStoreRemove",
      value: function onStoreRemove(event) {
        // If the next mixin up the inheritance chain has an implementation, call it
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(GridSelection.prototype), "onStoreRemove", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(GridSelection.prototype), "onStoreRemove", this).call(this, event);
        this.selectedRecordCollection.remove(event.records);
      }
      /**
       * Triggered from Grid view when the store changes. This might happen
       * if store events are batched and then resumed.
       * Deselects all records which have been removed.
       * @private
       * @category Selection
       */

    }, {
      key: "onStoreDataChange",
      value: function onStoreDataChange(_ref7) {
        var action = _ref7.action,
            store = _ref7.source;
        // If the next mixin up the inheritance chain has an implementation, call it
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(GridSelection.prototype), "onStoreDataChange", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(GridSelection.prototype), "onStoreDataChange", this).apply(this, arguments);

        if (isSelectAction[action]) {
          var selectedRecords = this.selectedRecordCollection,
              toRemove = []; // Update selected records collection

          selectedRecords.forEach(function (record) {
            // If record still exists after reload, update selectedRecordCollection with a reference to the new task version
            if (store.includes(record)) {
              var index = selectedRecords.indexOf(record);
              selectedRecords.splice(index, 1, store.getById(record.id));
            } else {
              toRemove.push(record);
            }
          }); // Remove in one go to fire a single selectionChange event

          selectedRecords.remove(toRemove);
        }
      }
      /**
       * Triggered from Grid view when all records get removed from the store.
       * Deselects all records.
       * @private
       * @category Selection
       */

    }, {
      key: "onStoreRemoveAll",
      value: function onStoreRemoveAll() {
        // If the next mixin up the inheritance chain has an implementation, call it
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(GridSelection.prototype), "onStoreRemoveAll", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_25___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_28___default()(GridSelection.prototype), "onStoreRemoveAll", this).call(this);
        this.deselectAll();
      } //endregion
      //region Handle multiSelect

      /**
       * Handles multi selection using the mouse. Called from GridElementEvents on mousedown in a cell and
       * simultaneously pressing a modifier key.
       * @param cellData
       * @param event
       * @private
       * @category Selection
       */

    }, {
      key: "handleMouseMultiSelect",
      value: function handleMouseMultiSelect(cellData, event) {
        var me = this,
            id = cellData.id;

        function mergeRange(fromId, toId) {
          var store = me.store,
              selectedRecordCollection = me.selectedRecordCollection,
              fromIndex = store.indexOf(fromId),
              toIndex = store.indexOf(toId),
              startIndex = Math.min(fromIndex, toIndex),
              endIndex = Math.max(fromIndex, toIndex);

          if (startIndex === -1 || endIndex === -1) {
            throw new Error('Record not found in selectRange');
          }

          var newRange = store.getRange(startIndex, endIndex + 1, false).filter(function (row) {
            return me.isSelectable(row);
          });
          selectedRecordCollection.splice(0, me.lastRange || 0, newRange);
          me.lastRange = newRange;
        }

        if ((event.metaKey || event.ctrlKey) && me.isSelected(id)) {
          // ctrl/cmd deselects row if selected
          me.deselectRow(id);
        } else if (me.selectionMode.multiSelect) {
          if (event.shiftKey && me.startCell) {
            // shift appends selected range (if we have previously focused cell)
            mergeRange(me.startCell.id, id);
          } else if (event.ctrlKey || event.metaKey) {
            // ctrl/cmd adds to selection if using multiselect (and not selected)
            me.selectRow({
              record: id,
              scrollIntoView: false,
              addToSelection: true
            });
          }
        }
      } //endregion
      //region Navigation

      /**
       * Triggered from GridNavigation when focus is moved to another cell within the grid. Selects the cell unless
       * modifier keys are pressed, in which case it has already been handled
       * @private
       * @category Selection
       */

    }, {
      key: "onCellNavigate",
      value: function onCellNavigate(me, fromCellSelector, toCellSelector, event) {
        var doSelect = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

        // CheckColumn events are handled by the CheckColumn itself.
        if (me.columns.getById(toCellSelector.columnId) === me.checkboxColumn || me.selectionMode.rowCheckboxSelection) {
          return;
        } // 1.do not affect selection if focus is returning to the grid from some widget
        // 2. don't select when clicking expander icon in a tree


        if (!doSelect || me.returningFocus || event && event.target.closest('.b-tree-expander')) {
          return;
        }

        var isSameRecord = fromCellSelector && toCellSelector.id === fromCellSelector.id,
            isMouse = event && event.type === 'mousedown',
            isMouseCtrl = isMouse && event.ctrlKey; // SHIFT for keyboard / mouse and CTRL for mouse events indicate multiselect

        if (event && (!event.button || event.button === 2) && (event.shiftKey || isMouseCtrl)) {
          me.handleMouseMultiSelect(toCellSelector, event);
        } else {
          var clickedSameRecordWithModifierKey = isSameRecord && (!event || event.shiftKey || event.ctrlKey),
              clickedAlreadySelectedRecord = event && me.isSelected(toCellSelector.id),
              clickedWithModifierKey = isMouseCtrl; // We intentionally do not clear existing selection here if clicking a selected record,
          // it's done in onCellClick where we know current interaction is not a drag drop operation

          me.selectCell(toCellSelector, false, clickedSameRecordWithModifierKey || clickedWithModifierKey || clickedAlreadySelectedRecord);
        } // Remember last cell with ctrl pressed


        if (!me.startCell || isMouseCtrl) {
          me.startCell = toCellSelector;
          me.lastRange = null;
        }
      }
      /**
       * Keeps the UI synced with the selectionchange event before firing it out.
       * Event is not fired if the `silent` parameter is truthy.
       * @param {Object} selectionChangeEvent The change event to sync the UI to, and to possibly fire.
       * @param {Boolean} silent Specify `true` to not trigger any the passed.
       * @private
       * @category Selection
       */

    }, {
      key: "triggerChangeEvent",
      value: function triggerChangeEvent(selectionChangeEvent, silent) {
        var me = this,
            mode = selectionChangeEvent.mode,
            selected = selectionChangeEvent.selected,
            deselected = selectionChangeEvent.deselected;
        var i, len, row, cell; // Keep the UI up to date with the triggered changes.
        // A mode: 'row' change selects and/or deselects records.

        if (mode === 'row') {
          for (i = 0, len = selected.length; i < len; i++) {
            row = me.getRowFor(selected[i]);

            if (row) {
              row.addCls('b-selected');

              if (me.checkboxColumn && !me.checkboxColumn.hidden && !selected[i].isSpecialRow) {
                row.getCell(me.checkboxColumn.id).widget.checked = true;
              }
            }
          }

          for (i = 0, len = deselected.length; i < len; i++) {
            row = me.getRowFor(deselected[i]);

            if (row) {
              row.removeCls('b-selected');

              if (me.checkboxColumn && !me.checkboxColumn.hidden && !deselected[i].isSpecialRow) {
                row.getCell(me.checkboxColumn.id).widget.checked = false;
              }
            }
          }
        } // A mode: 'cell' change selects and/or deselects *one* cell right now.
        // But we always use an array for future-proofing.
        else if (mode === 'cell') {
            for (i = 0, len = selected.length; i < len; i++) {
              cell = me.getCell(selected[i]);

              if (cell) {
                cell.classList.add('b-selected');
              }
            }

            for (i = 0, len = deselected.length; i < len; i++) {
              cell = me.getCell(deselected[i]);

              if (cell) {
                cell.classList.remove('b-selected');
              }
            }
          }

        if (!silent) {
          me.trigger('selectionChange', selectionChangeEvent);
        }
      }
    }, {
      key: "onCellClick",
      value: function onCellClick(_ref8) {
        var event = _ref8.event,
            record = _ref8.record;
        var me = this;

        if (!me.selectionMode.checkbox && me.selectionMode.multiSelect && !event.shiftKey && !event.metaKey && !event.ctrlKey) {
          me.deselectRows(me.selectedRecords.filter(function (rec) {
            return rec !== record;
          }));
        }
      } //endregion
      //region Getters/setters
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "selectedRecordCollection",
      set: function set(selectedRecordCollection) {
        if (!(selectedRecordCollection instanceof _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_30__["default"])) {
          selectedRecordCollection = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_30__["default"](selectedRecordCollection);
        }

        this._selectedRecordCollection = selectedRecordCollection; // Fire row change events from onSelectedRecordCollectionChange

        selectedRecordCollection.on({
          change: 'onSelectedRecordCollectionChange',
          thisObj: this
        });
      },
      get: function get() {
        return this._selectedRecordCollection;
      }
    }, {
      key: "selectedCell",
      get: function get() {
        return this._selectedCell;
      },
      set: function set(cellSelector) {
        this.selectCell(cellSelector);
      }
    }, {
      key: "selectionMode",
      set: function set(mode) {
        if (mode && mode.rowCheckboxSelection) {
          mode.row = mode.checkbox = true;
          mode.cell = false;
        }

        this._selectionMode = mode;
      },
      get: function get() {
        return this._selectionMode;
      }
      /**
       * The last selected record. Set to select a row or use Grid#selectRow. Set to null to
       * deselect all
       * @property {Core.data.Model}
       * @category Selection
       */

    }, {
      key: "selectedRecord",
      get: function get() {
        return this.selectedRecordCollection.last || null;
      },
      set: function set(record) {
        this.selectRow({
          record: record
        });
      }
      /**
       * Selected records.
       * Can be set as array of ids.
       * ```
       * grid.selectedRecords = [1, 2, 4, 6]
       * ```
       *
       * @property {Core.data.Model[]|Number[]}
       * @category Selection
       */

    }, {
      key: "selectedRecords",
      get: function get() {
        return this.selectedRecordCollection.values;
      },
      set: function set(selectedRecords) {
        var selectedRecordCollection = this.selectedRecordCollection,
            store = this.store,
            toSelect = [];

        if (selectedRecords) {
          var _iterator = _createForOfIteratorHelper(selectedRecords),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var record = _step.value;
              record = store.getById(record);

              if (record) {
                toSelect.push(record);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } // Replace the entire selected collection with the new record set


        selectedRecordCollection.splice(0, selectedRecordCollection.count, toSelect);
      }
      /**
       * CSS selector for the currently selected cell. Format is "[data-index=index] [data-column-id=column]".
       * @type {String}
       * @category Selection
       * @readonly
       */

    }, {
      key: "selectedCellCSSSelector",
      get: function get() {
        var me = this,
            cell = me._selectedCell,
            row = cell && me.getRowById(cell.id);
        if (!cell || !row) return '';
        return "[data-index=".concat(row.dataIndex, "] [data-column-id=").concat(cell.columnId, "]");
      }
    }, {
      key: "widgetClass",
      get: function get() {} //endregion

    }], [{
      key: "$name",
      get: function get() {
        return 'GridSelection';
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * The selection settings, where you can set these boolean flags to control what is selected. Options below:
           * @config {Object} selectionMode
           * @param {Boolean} selectionMode.row select rows
           * @param {Boolean} selectionMode.cell select cells
           * @param {Boolean} selectionMode.rowCheckboxSelection select rows only when clicking in the checkbox column
           * @param {Boolean} selectionMode.multiSelect Allow multiple selection
           * @param {Boolean} selectionMode.checkbox true to add a checkbox selection column to the grid
           * @param {Boolean} selectionMode.showCheckAll  true to add a checkbox to the selection column header to select/delselect all rows
           * @default
           * @category Selection
           */
          selectionMode: {
            row: true,
            cell: true,
            rowCheckboxSelection: false,
            multiSelect: true,
            checkbox: false,
            showCheckAll: false
          },
          selectedRecordCollection: {}
        };
      }
    }]);

    return GridSelection;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_29__["default"]);
});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridState.js":
/*!******************************************!*\
  !*** ./lib/Grid/view/mixin/GridState.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
 // TODO: prevent multiple rerenders

/**
 * @module Grid/view/mixin/GridState
 */

var suspendStoreEvents = function suspendStoreEvents(subGrid) {
  return subGrid.columns.suspendEvents();
},
    resumeStoreEvents = function resumeStoreEvents(subGrid) {
  return subGrid.columns.resumeEvents();
},
    fillSubGridColumns = function fillSubGridColumns(subGrid) {
  subGrid.columns.clearCaches();
  subGrid.columns.fillFromMaster();
},
    compareStateSortIndex = function compareStateSortIndex(a, b) {
  return a.stateSortIndex - b.stateSortIndex;
};
/**
 * Mixin for Grid that handles state. It serializes the following grid properties:
 *
 * * rowHeight
 * * readOnly
 * * selectedCell
 * * selectedRecords
 * * columns (order, widths, visibility)
 * * store (sorters, groupers, filters)
 * * scroll position
 *
 * See {@link Core.mixin.State} for more information on state.
 *
 * @demo Grid/state
 * @externalexample grid/State.js
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(GridState, _ref);

    var _super = _createSuper(GridState);

    function GridState() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, GridState);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(GridState, [{
      key: "getState",

      /**
       * Get grids current state for serialization. State includes rowHeight, headerHeight, readOnly, selectedCell,
       * selectedRecordId, column states and store state.
       * @returns {Object} State object to be serialized
       * @private
       */
      value: function getState() {
        var me = this,
            style = me.element.style.cssText,
            state = {
          rowHeight: me.rowHeight,
          readOnly: me.readOnly
        };

        if (style) {
          state.style = style;
        }

        if (me.selectedCell) {
          // TODO: Create wrapper class to avoid JSON.stringify recursion in state.selectedCell.
          var _me$selectedCell = me.selectedCell,
              id = _me$selectedCell.id,
              columnId = _me$selectedCell.columnId;
          state.selectedCell = {
            id: id,
            columnId: columnId
          };
        }

        state.selectedRecords = me.selectedRecords.map(function (entry) {
          return entry.id;
        });
        state.columns = me.columns.map(function (column) {
          return column.getState();
        });
        state.store = me.store.state;
        state.scroll = me.storeScroll();
        state.subGrids = {};
        me.eachSubGrid(function (subGrid) {
          var config = state.subGrids[subGrid.region] = state.subGrids[subGrid.region] || {};

          if (subGrid.flex == null) {
            config.width = subGrid.width;
          }

          config.collapsed = subGrid.collapsed;
        });
        return state;
      }
      /**
       * Apply previously stored state.
       * @param {Object} state
       * @private
       */

    }, {
      key: "applyState",
      value: function applyState(state) {
        var me = this;

        if ('readOnly' in state) {
          me.readOnly = state.readOnly;
        }

        if ('rowHeight' in state) {
          me.rowHeight = state.rowHeight;
        }

        if ('style' in state) {
          me.style = state.style;
        }

        if ('selectedCell' in state) {
          me.selectedCell = state.selectedCell;
        }

        if ('store' in state) {
          me.store.state = state.store;
        }

        if ('selectedRecords' in state) {
          me.selectedRecords = state.selectedRecords;
        }

        if ('columns' in state) {
          var columnsChanged = false,
              needSort = false; // We're going to renderContents anyway, so stop the ColumnStores from updating the UI

          me.columns.suspendEvents();
          me.eachSubGrid(suspendStoreEvents); // each column triggers rerender at least once...

          state.columns.forEach(function (columnState, index) {
            var column = me.columns.getById(columnState.id);

            if (column) {
              var columnGeneration = column.generation;
              column.applyState(columnState);
              columnsChanged = columnsChanged || column.generation !== columnGeneration; // In case a sort is needed, stamp in the ordinal position.

              column.stateSortIndex = index; // If we find one out of order, only then do we need to sort

              if (column.allIndex !== index) {
                needSort = columnsChanged = true;
              }
            }
          });

          if (columnsChanged) {
            me.eachSubGrid(fillSubGridColumns);
          }

          if (needSort) {
            me.eachSubGrid(function (subGrid) {
              subGrid.columns.records.sort(compareStateSortIndex);
              subGrid.columns.allRecords.sort(compareStateSortIndex);
            });
            me.columns.sort({
              fn: compareStateSortIndex,
              // always sort ascending
              ascending: true
            });
          } // If we have been painted, and column restoration changed the column layout, refresh contents


          if (me.isPainted && columnsChanged) {
            me.renderContents();
          } // Allow ColumnStores to update the UI again


          me.columns.resumeEvents();
          me.eachSubGrid(resumeStoreEvents);
        }

        if ('subGrids' in state) {
          me.eachSubGrid(function (subGrid) {
            if (subGrid.region in state.subGrids) {
              var subGridState = state.subGrids[subGrid.region];

              if ('width' in subGridState) {
                subGrid.width = subGridState.width;
              }

              if ('collapsed' in subGridState) {
                subGrid.collapsed = subGridState.collapsed;
              }
            }
          });
        }

        if ('scroll' in state) {
          me.restoreScroll(state.scroll);
        }
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'GridState';
      }
    }]);

    return GridState;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_11__["default"]);
});

/***/ }),

/***/ "./lib/Grid/view/mixin/GridSubGrids.js":
/*!*********************************************!*\
  !*** ./lib/Grid/view/mixin/GridSubGrids.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _column_Column_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _GridBase_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../GridBase.js */ "./lib/Grid/view/GridBase.js");
/* harmony import */ var _SubGrid_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../SubGrid.js */ "./lib/Grid/view/SubGrid.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");








































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_38___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_38___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_37___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Grid/view/mixin/GridSubGrids
 */

/**
 * Mixin for grid that handles SubGrids. Each SubGrid is scrollable horizontally separately from the other SubGrids.
 * Having two SubGrids allows you to achieve what is usually called locked or frozen columns.
 *
 * By default a Grid has two SubGrids, one named 'locked' and one 'normal'. The `locked` region has fixed width, while
 * the `normal` region grows to fill all available width (flex).
 *
 * Which SubGrid a column belongs to is determined using its {@link Grid.column.Column#config-region} config. For
 * example to put a column into the locked region, specify `{ region: 'locked' }`. For convenience, a column can be put
 * in the locked region using `{ locked: true }`.
 *
 * ```javascript
 * new Grid({
 *   columns : [
 *     // These two columns both end up in the "locked" region
 *     { field: 'name', text: 'Name', locked: true }
 *     { field: 'age', text: 'Age', region: 'locked' }
 *   ]
 * });
 * ```
 *
 * To customize the SubGrids, use {@link Grid.view.Grid#config-subGridConfigs}:
 *
 * ```javascript
 * // change the predefined subgrids
 * new Grid({
 *   subGridConfigs : {
 *       locked : { flex : 1 } ,
 *       normal : { flex : 3 }
 *   }
 * })
 *
 * // or define your own entirely
 * new Grid({
 *   subGridConfigs : {
 *       a : { width : 150 } ,
 *       b : { flex  : 1 },
 *       c : { width : 150 }
 *   },
 *
 *   columns : [
 *       { field : 'name', text : 'Name', region : 'a' },
 *       ...
 *   ]
 * })
 * ```
 *
 * @demo Grid/lockedcolumns
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_36___default()(GridSubGrids, _ref);

    var _super = _createSuper(GridSubGrids);

    function GridSubGrids() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_33___default()(this, GridSubGrids);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_34___default()(GridSubGrids, [{
      key: "changeSubGridConfigs",
      //region Init
      value: function changeSubGridConfigs(configs) {
        var me = this,
            usedRegions = new Set();

        var _iterator = _createForOfIteratorHelper(me.columns),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var column = _step.value;

            // Allow specifying regions for undefined subgrids
            if (column.region && !configs[column.region]) {
              configs[column.region] = {};
            }

            usedRegions.add(column.region);
          } // Implementer has provided configs for other subGrids but not normal, put defaults in place

        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (configs.normal && _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"].isEmpty(configs.normal)) {
          configs.normal = _GridBase_js__WEBPACK_IMPORTED_MODULE_41__["default"].defaultConfig.subGridConfigs.normal;
        }

        var _iterator2 = _createForOfIteratorHelper(usedRegions),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var region = _step2.value;
            me.createSubGrid(region, configs[region]);
          } // Add them to Grid

        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        me.items = Object.values(me.subGrids);
        return configs;
      }
    }, {
      key: "createSubGrid",
      value: function createSubGrid(region) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var me = this,
            subGridColumns = me.columns.makeChained(function (column) {
          return column.region === region;
        }, ['region']),
            subGridConfig = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"].assign({
          grid: me,
          store: me.store,
          rowManager: me.rowManager,
          region: region,
          headerClass: me.headerClass,
          footerClass: me.footerClass,
          columns: subGridColumns,
          // Sort by region unless weight is explicitly defined
          weight: region
        }, config || me.subGridConfigs[region]);
        me.regions.push(region);
        var hasCalculatedWidth = false;

        if (!subGridConfig.flex && !subGridConfig.width) {
          subGridConfig.width = subGridColumns.totalFixedWidth;
          hasCalculatedWidth = true;
        }

        var subGrid = me.subGrids[region] = new _SubGrid_js__WEBPACK_IMPORTED_MODULE_42__["default"](subGridConfig); // Must be set after creation, otherwise reset in SubGrid#set width

        subGrid.hasCalculatedWidth = hasCalculatedWidth;

        if (region === me.regions[0]) {
          // Have already done lookups for this in a couple of places, might as well store it...
          subGrid.isFirstRegion = true;
        }

        return subGrid;
      } // A SubGrid is added to Grid, add its header etc too

    }, {
      key: "onChildAdd",
      value: function onChildAdd(subGrid) {
        if (subGrid.isSubGrid) {
          var me = this,
              items = me.items,
              headerContainer = me.headerContainer,
              virtualScrollers = me.virtualScrollers,
              footerContainer = me.footerContainer,
              index = items.indexOf(subGrid) * 2;

          if (!me.hideHeaders) {
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].insertAt(headerContainer, subGrid.headerSplitter, index);
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].insertAt(headerContainer, subGrid.header.element, index);
          }

          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].insertAt(virtualScrollers, subGrid.scrollerSplitter, index);
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].insertAt(virtualScrollers, subGrid.virtualScrollerElement, index);
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].insertAt(footerContainer, subGrid.footerSplitter, index);
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].insertAt(footerContainer, subGrid.footer.element, index); // Show splitter for all except last (new might not sort last, depending on weight)

          items.forEach(function (subGrid, i) {
            if (i < items.length - 1) {
              subGrid.showSplitter();
            }
          });
        }

        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_35___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_38___default()(GridSubGrids.prototype), "onChildAdd", this).call(this, subGrid);
      } // A SubGrid is remove from grid, remove its header etc too

    }, {
      key: "onChildRemove",
      value: function onChildRemove(subGrid) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_35___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_38___default()(GridSubGrids.prototype), "onChildRemove", this).call(this, subGrid);

        var items = this.items;
        delete this.subGrids[subGrid.region];
        _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].remove(this.regions, subGrid.region);
        subGrid.destroy(); // Make sure the new last splitter is hidden

        if (items.length) {
          items[items.length - 1].hideSplitter();
        }
      }
    }, {
      key: "doDestroy",
      value: function doDestroy() {
        this.eachSubGrid(function (subGrid) {
          return subGrid.destroy();
        });

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_35___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_38___default()(GridSubGrids.prototype), "doDestroy", this).call(this);
      } //endregion
      //region Iteration & calling

      /**
       * Iterate over all subGrids, calling the supplied function for each.
       * @param {Function} fn Function to call for each instance
       * @param {Object} thisObj `this` reference to call the function in, defaults to the subGrid itself
       * @category SubGrid
       * @internal
       */

    }, {
      key: "eachSubGrid",
      value: function eachSubGrid(fn) {
        var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.items.forEach(function (subGrid, i) {
          fn.call(thisObj || subGrid, subGrid, i++);
        });
      }
    }, {
      key: "eachWidget",
      value: function eachWidget(fn) {
        var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        this.items.forEach(function (widget) {
          if (fn(widget) === false) {
            return;
          }

          if (deep && widget.eachWidget) {
            widget.eachWidget(fn, deep);
          }
        });
      }
      /**
       * Call a function by name for all subGrids (that have the function).
       * @param {String} fnName Name of function to call, uses the subGrid itself as `this` reference
       * @param params Parameters to call the function with
       * @return {*} Return value from first SubGrid is returned
       * @category SubGrid
       * @internal
       */

    }, {
      key: "callEachSubGrid",
      value: function callEachSubGrid(fnName) {
        for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          params[_key - 1] = arguments[_key];
        }

        // TODO: make object { normal: retval, locked: retval } to return? or store. revisit when needed
        var returnValue = null;
        this.items.forEach(function (subGrid, i) {
          if (subGrid[fnName]) {
            var partialReturnValue = subGrid[fnName].apply(subGrid, params);
            if (i === 0) returnValue = partialReturnValue;
          }
        });
        return returnValue;
      } //endregion
      //region Getters

      /**
       * This method should return names of the two last regions in the grid as they are visible in the UI. In case
       * `regions` property cannot be trusted, use different approach. Used by SubGrid and RegionResize to figure out
       * which region should collapse or expand.
       * @returns {String[]}
       * @private
       * @category SubGrid
       */

    }, {
      key: "getLastRegions",
      value: function getLastRegions() {
        var result = this.regions.slice(-2); // ALWAYS return array of length 2 in order to avoid extra conditions. Normally should not be called with 1 region

        return result.length === 2 ? result : [result[0], result[0]];
      }
      /**
       * This method should return right neighbour for passed region, or left neighbour in case last visible region is passed.
       * This method is used to decide which subgrid should take space of the collapsed one.
       * @param {String} region
       * @returns {String}
       * @private
       * @category SubGrid
       */

    }, {
      key: "getNextRegion",
      value: function getNextRegion(region) {
        var regions = this.regions; // return next region or next to last

        return regions[regions.indexOf(region) + 1] || regions[regions.length - 2];
      }
    }, {
      key: "getPreviousRegion",
      value: function getPreviousRegion(region) {
        return this.regions[this.regions.indexOf(region) - 1];
      }
      /**
       * Returns the subGrid for the specified region.
       * @param {String} region Region, eg. locked or normal (per default)
       * @returns {Grid.view.SubGrid} A subGrid
       * @category SubGrid
       */

    }, {
      key: "getSubGrid",
      value: function getSubGrid(region) {
        return this.subGrids[region];
      }
      /**
       * Get the SubGrid that contains specified column
       * @param {String|Grid.column.Column} column Column "name" or column object
       * @returns {Grid.view.SubGrid}
       * @category SubGrid
       */

    }, {
      key: "getSubGridFromColumn",
      value: function getSubGridFromColumn(column) {
        column = column instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_40__["default"] ? column : this.columns.get(column) || this.columns.getById(column);
        return this.getSubGrid(column.region);
      } //endregion

      /**
       * Returns splitter element for subgrid
       * @param {Grid.view.SubGrid|String} subGrid
       * @returns {HTMLElement}
       * @private
       * @category SubGrid
       */

    }, {
      key: "resolveSplitter",
      value: function resolveSplitter(subGrid) {
        var regions = this.getLastRegions();
        var region = subGrid instanceof _SubGrid_js__WEBPACK_IMPORTED_MODULE_42__["default"] ? subGrid.region : subGrid;

        if (regions[1] === region) {
          region = regions[0];
        }

        return this.subGrids[region].splitterElement;
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'GridSubGrids';
      }
    }, {
      key: "properties",
      get: function get() {
        return {
          /**
           * An object containing the {@link Grid.view.SubGrid} region instances, indexed by subGrid id ('locked', normal'...)
           * @property {Object} subGrids
           * @readonly
           * @category Common
           */
          subGrids: {},
          regions: []
        };
      }
    }]);

    return GridSubGrids;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_39__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/column/ResourceInfoColumn.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/column/ResourceInfoColumn.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceInfoColumn; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/column/ResourceInfoColumn
 */

/**
 * Displays basic resource information. Defaults to showing image + name + event count, it is all configurable.
 * If a resource has no image, you can also provide an icon using `iconCls` in the data (you then need to specify
 * `image === false` in your data).
 * Be sure to specify {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImagePath} to instruct the
 * column where to look for the images.
 * @externalexample scheduler/ResourceInfoColumn.js
 * @classType resourceInfo
 * @extends Grid/column/Column
 */

var ResourceInfoColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(ResourceInfoColumn, _Column);

  var _super = _createSuper(ResourceInfoColumn);

  function ResourceInfoColumn() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ResourceInfoColumn);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(ResourceInfoColumn, [{
    key: "construct",
    value: function construct() {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(ResourceInfoColumn.prototype), "construct", this).apply(this, arguments);

      if (me.grid.isPainted) {
        me.addErrorListener();
      } else {
        me.grid.on({
          paint: me.addErrorListener,
          thisObj: me,
          once: true
        });
      }
    }
  }, {
    key: "getImageURL",
    value: function getImageURL(imageName) {
      return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].joinPaths([this.grid.resourceImagePath || '', imageName || '']);
    }
  }, {
    key: "addErrorListener",
    value: function addErrorListener() {
      var _this = this;

      _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].on({
        element: this.grid.element,
        delegate: '.b-resource-image',
        error: function error(event) {
          return _this.setDefaultResourceImage(event.target);
        },
        capture: true
      });
    }
  }, {
    key: "setDefaultResourceImage",
    value: function setDefaultResourceImage(target) {
      var defaultResourceImageName = this.grid.defaultResourceImageName;

      if (defaultResourceImageName) {
        var defaultURL = this.getImageURL(defaultResourceImageName); // Set image to defaultURL if it is not already set

        if (target.src && !target.src.endsWith(defaultURL.replace(/^[./]*/gm, ''))) {
          target.src = defaultURL;
        }
      }
    }
  }, {
    key: "template",
    value: function template(record) {
      var me = this,
          showImage = me.showImage,
          showRole = me.showRole,
          showEventCount = me.showEventCount,
          scheduler = me.grid,
          timeAxis = scheduler.timeAxis,
          resourceImageExtension = scheduler.resourceImageExtension,
          defaultResourceImageName = scheduler.defaultResourceImageName,
          roleField = typeof showRole === 'string' ? showRole : 'role',
          count = record.eventStore.getEvents({
        includeOccurrences: scheduler.enableRecurringEvents,
        resourceRecord: record,
        startDate: timeAxis.startDate,
        endDate: timeAxis.endDate
      }).length,
          value = record.get(me.field);
      var imageUrl;

      if (showImage && record.image !== false) {
        if (record.imageUrl) {
          imageUrl = record.imageUrl;
        } else {
          // record.image supposed to be a file name, located at resourceImagePath
          var imageName = typeof showImage === 'string' ? showImage : record.image || value && value.toLowerCase() + resourceImageExtension || defaultResourceImageName;
          imageUrl = me.getImageURL(imageName); // Image name should have an extension

          if (!imageName.includes('.')) {
            // If validNames is specified, check that imageName is valid
            if (!me.validNames || me.validNames.includes(imageName)) {
              imageUrl += resourceImageExtension;
            } // If name is not valid, use generic image
            else if (!record.iconCls) {
                imageUrl = me.getImageURL(defaultResourceImageName);
              }
          }
        }
      }

      return {
        class: 'b-resource-info',
        children: [imageUrl ? {
          tag: 'img',
          draggable: 'false',
          class: 'b-resource-image',
          src: imageUrl
        } : null, record.iconCls ? {
          tag: 'i',
          className: "b-resource-icon ".concat(record.iconCls)
        } : null, {
          tag: 'dl',
          children: [{
            tag: 'dt',
            html: value
          }, showRole ? {
            tag: 'dd',
            class: 'b-resource-role',
            html: record[roleField]
          } : null, showEventCount ? {
            tag: 'dd',
            class: 'b-resource-events',
            html: me.L('L{eventCountText}', count)
          } : null]
        }]
      };
    }
  }, {
    key: "defaultRenderer",
    value: function defaultRenderer(_ref) {
      var grid = _ref.grid,
          record = _ref.record,
          cellElement = _ref.cellElement,
          value = _ref.value,
          isExport = _ref.isExport;
      var result;

      if (record.isSpecialRow) {
        result = '';
      } else if (isExport) {
        result = value;
      } else {
        if (this.autoScaleThreshold && grid.rowHeight < this.autoScaleThreshold) {
          cellElement.style.fontSize = grid.rowHeight / 40 + 'em';
        } else {
          cellElement.style.fontSize = '';
        }

        result = this.template(record);
      }

      return result;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ResourceInfoColumn';
    }
  }, {
    key: "type",
    get: function get() {
      return 'resourceInfo';
    }
  }, {
    key: "fields",
    get: function get() {
      return ['showEventCount', 'showRole', 'showImage', 'validNames', 'autoScaleThreshold'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        /**
         * Show image. Looks for image name in fields on the resource in the following order: 'imageUrl', 'image',
         * 'name'. Set `showImage` to a field name to use a custom field. Set `Scheduler.resourceImagePath` to
         * specify where to load images from. If no extension found, defaults to
         * {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImageExtension}.
         * @config {Boolean}
         * @default
         */
        showImage: true,

        /**
         * Show number of events assigned to the resource below the name.
         * @config {Boolean}
         * @default
         */
        showEventCount: true,

        /**
         * Show resource role below the name. Specify `true` to display data from the `role` field, or specify a field
         * name to read this value from.
         * @config {Boolean|String}
         * @default
         */
        showRole: false,

        /**
         * Valid image names. Set to `null` to allow all names.
         * @config {String[]}
         * @default
         */
        validNames: ['amit', 'angelo', 'arcady', 'arnold', 'celia', 'chang', 'dan', 'dave', 'emilia', 'george', 'gloria', 'henrik', 'hitomi', 'jong', 'kate', 'lee', 'linda', 'lisa', 'lola', 'macy', 'madison', 'malik', 'mark', 'maxim', 'mike', 'rob', 'steve'],

        /**
         * Specify 0 to prevent the column from adapting its content according to the used row height, or specify a
         * a threshold (row height) at which scaling should start.
         * @config {Number}
         * @default
         */
        autoScaleThreshold: 40,
        field: 'name',
        htmlEncode: false,
        width: 140,
        cellCls: 'b-resourceinfo-cell',
        editor: _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].isTestEnv ? false : 'text'
      };
    }
  }]);

  return ResourceInfoColumn;
}(_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_14__["default"]);


_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_15__["default"].registerColumnType(ResourceInfoColumn);
ResourceInfoColumn._$name = 'ResourceInfoColumn';

/***/ }),

/***/ "./lib/Scheduler/column/TimeAxisColumn.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/column/TimeAxisColumn.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisColumn; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../view/HorizontalTimeAxis.js */ "./lib/Scheduler/view/HorizontalTimeAxis.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _view_ResourceHeader_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../view/ResourceHeader.js */ "./lib/Scheduler/view/ResourceHeader.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';









/**
 * @module Scheduler/column/TimeAxisColumn
 */

/**
 * A column containing the timeline "viewport", in which events, dependencies etc are drawn.
 * Normally you do not need to interact with or create this column, it is handled by Scheduler.
 *
 * @extends Grid/column/Column
 */

var TimeAxisColumn = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(TimeAxisColumn, _Events);

  var _super = _createSuper(TimeAxisColumn);

  function TimeAxisColumn() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TimeAxisColumn);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TimeAxisColumn, [{
    key: "construct",
    // region Events

    /**
     * Fires after a click on a time axis cell
     * @event timeAxisHeaderClick
     * @param {Scheduler.column.TimeAxisColumn} column The column object
     * @param {Date} startDate The start date of the header cell
     * @param {Date} endDate The start date of the header cell
     * @param {Event} event The event object
     */

    /**
     * Fires after a double click on a time axis cell
     * @event timeAxisHeaderDblClick
     * @param {Scheduler.column.TimeAxisColumn} column The column object
     * @param {Date} startDate The start date of the header cell
     * @param {Date} endDate The end date of the header cell
     * @param {Event} event The event object
     */

    /**
     * Fires after a right click on a time axis cell
     * @event timeAxisHeaderContextMenu
     * @param {Scheduler.column.TimeAxisColumn} column The column object
     * @param {Date} startDate The start date of the header cell
     * @param {Date} endDate The start date of the header cell
     * @param {Event} event The event object
     */
    //endregion
    //region Init
    value: function construct() {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(TimeAxisColumn.prototype), "construct", this).apply(this, arguments);

      me.initialRender = true;
      me.thisObj = me;
      me.timeAxisViewModel = me.timeline.timeAxisViewModel; // A bit hacky, because mode is a field and not a config
      // eslint-disable-next-line no-self-assign

      me.mode = me.mode;
      me.grid.on({
        paint: 'onTimelinePaint',
        thisObj: me,
        once: true
      });
      me.timeAxisViewModel.on({
        update: me.onViewModelUpdate,
        thisObj: me
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.resourceColumns && this.resourceColumns.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(TimeAxisColumn.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "onViewModelUpdate",
    // TODO: define all configs as fields and set below to false...
    //region Events
    value: function onViewModelUpdate(_ref) {
      var viewModel = _ref.source;
      var me = this;

      if (me.mode === 'horizontal') {
        // render the time axis view into the column header element
        me.refreshHeader(true);
        me.width = viewModel.totalSize;
        me.timeline.refresh();
      } else if (me.mode === 'vertical') {
        // Refresh to rerender cells, in the process updating the vertical timeaxis to reflect view model changes
        me.timeline.refreshRows();
      }
    } // Called on paint. SubGrid has its width so this is the earliest time to configure the TimeAxisViewModel with
    // correct width

  }, {
    key: "onTimelinePaint",
    value: function onTimelinePaint(_ref2) {
      var firstPaint = _ref2.firstPaint;
      var me = this;

      if (!me.subGrid.insertRowsBefore) {
        return;
      }

      if (firstPaint) {
        me.subGridElement.classList.add('b-timeline-subgrid'); // If the owning Scheduler has hideHeaders: true, element won't be available.

        if (me.element) {
          _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
            element: me.element,
            thisObj: me,
            click: 'onContainerElementClick',
            dblclick: 'onContainerElementClick',
            contextmenu: 'onContainerElementClick'
          });
        }

        if (me.mode === 'vertical') {
          me.refreshHeader();
        }
      }
    } //endregion
    //region Rendering

    /**
     * Refreshes the columns header contents (which is either a HorizontalTimeAxis or a ResourceHeader). Useful if you
     * have rendered some extra meta data that depends on external data such as the EventStore or ResourceStore.
     */

  }, {
    key: "refreshHeader",
    value: function refreshHeader(internal) {
      var me = this,
          element = me.element;

      if (element) {
        if (me.mode === 'horizontal') {
          // Force timeAxisViewModel to regenerate its column config, which calls header renderers etc.
          !internal && me.timeAxisViewModel.update(null, true);

          if (!me.timeAxisView.rendered) {
            // Do not need the normal header markup
            element.innerHTML = '';
            me.timeAxisView.render(element);
          } else {
            // Force rebuild of cells in case external data has changed (cheap since it still syncs to DOM)
            me.timeAxisView.refresh(true);
          }
        } else if (me.mode === 'vertical') {
          if (!me.resourceColumns.currentElement) {
            // Do not need the normal header markup
            element.innerHTML = '';
            me.resourceColumns.render(element);
          } // Vertical's resourceColumns is redrawn with the events, no need here

        }
      }
    }
  }, {
    key: "renderer",
    value: function renderer(renderData) {
      // No drawing of events before engines initial commit
      if (this.timeline.project.isInitialCommitPerformed) {
        return this.timeline.currentOrientation.renderer(renderData);
      }
    } //endregion
    // region DOM events

  }, {
    key: "onContainerElementClick",
    value: function onContainerElementClick(event) {
      var target = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].up(event.target, '.b-sch-header-timeaxis-cell');

      if (target) {
        var index = target.dataset.tickIndex,
            position = target.parentElement.dataset.headerPosition,
            columnConfig = this.timeAxisViewModel.columnConfig[position][index]; // Skip same events with Grid context menu triggerEvent

        var contextMenu = this.grid.features.contextMenu;

        if (!contextMenu || event.type !== contextMenu.triggerEvent) {
          this.trigger('timeAxisHeader' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].capitalize(event.type), {
            startDate: columnConfig.start,
            endDate: columnConfig.end,
            event: event
          });
        }
      }
    } // endregion

  }, {
    key: "mode",
    set: function set(mode) {
      var me = this,
          timeline = me.timeline;
      me.set('mode', mode); // In horizontal mode this column has a time axis header on top, with timeline ticks

      if (mode === 'horizontal') {
        me.timeAxisView = new _view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_13__["default"]({
          model: me.timeAxisViewModel,
          compactCellWidthThreshold: me.compactCellWidthThreshold,
          owner: me.grid,
          client: me.grid
        });
      } // In vertical mode, it instead displays resources at top
      else if (mode === 'vertical') {
          // TODO: Most other vertical stuff is handled in VerticalRendering, move there?
          me.resourceColumns = new _view_ResourceHeader_js__WEBPACK_IMPORTED_MODULE_15__["default"](_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].assign({
            column: me,
            resourceStore: timeline.resourceStore,
            imagePath: timeline.resourceImagePath,
            imageExtension: timeline.resourceImageExtension,
            defaultImageName: timeline.defaultResourceImageName
          }, timeline.resourceColumns || {}));
          me.relayEvents(me.resourceColumns, ['resourceheaderclick', 'resourceheaderdblclick', 'resourceheadercontextmenu']);
        }
    },
    get: function get() {
      return this.get('mode');
    }
  }], [{
    key: "autoExposeFields",
    get: function get() {
      return true;
    } // endregion
    //region Config

  }, {
    key: "fields",
    get: function get() {
      return ['mode'];
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        /**
         * Set to false to prevent this column header from being dragged.
         * @config {Boolean} draggable
         * @category Interaction
         * @default false
         */
        draggable: false,

        /**
         * Set to false to prevent grouping by this column.
         * @config {Boolean} groupable
         * @category Interaction
         * @default false
         */
        groupable: false,

        /**
         * Allow column visibility to be toggled through UI.
         * @config {Boolean} hideable
         * @default false
         * @category Interaction
         */
        hideable: false,

        /**
         * Show column picker for the column.
         * @config {Boolean} showColumnPicker
         * @default false
         * @category Menu
         */
        showColumnPicker: false,

        /**
         * Allow filtering data in the column (if Filter feature is enabled)
         * @config {Boolean} filterable
         * @default false
         * @category Interaction
         */
        filterable: false,

        /**
         * Allow sorting of data in the column
         * @config {Boolean} sortable
         * @category Interaction
         * @default false
         */
        sortable: false,

        /**
         * Set to `false` to prevent the column from being drag-resized when the ColumnResize plugin is enabled.
         * @config {Boolean} resizable
         * @default false
         * @category Interaction
         */
        resizable: false,

        /**
         * Allow searching in the column (respected by QuickFind and Search features)
         * @config {Boolean} searchable
         * @default false
         * @category Interaction
         */
        searchable: false,

        /**
         * Specifies if this column should be editable, and define which editor to use for editing cells in the column (if CellEdit feature is enabled)
         * @config {String} editor
         * @default false
         * @category Interaction
         */
        editor: false,

        /**
         * Set to `true` to show a context menu on the cell elements in this column
         * @config {Boolean} enableCellContextMenu
         * @default false
         * @category Menu
         */
        enableCellContextMenu: false,

        /**
         * Renderer function for cell tooltips header (used with CellTooltip feature). Specify false to prevent
         * tooltip for that column.
         * @param {HTMLElement} cellElement Cell element
         * @param {Core.data.Model} record Record for cell row
         * @param {Grid.column.Column} column Cell column
         * @param {CellTooltip} cellTooltip Feature instance, used to set tooltip content async
         * @param {MouseEvent} event The event that triggered the tooltip
         * @config {Function} tooltipRenderer
         * @category Rendering
         * @default false
         */
        tooltipRenderer: false,

        /**
         * CSS class added to the header of this column
         * @config {String} cls
         * @category Rendering
         * @default 'b-sch-timeaxiscolumn'
         */
        cls: 'b-sch-timeaxiscolumn',
        // needs to have width specified, flex-basis messes measurements up
        needWidth: true,
        mode: null,
        region: 'normal',
        exportable: false
      };
    }
  }, {
    key: "type",
    get: function get() {
      return 'timeAxis';
    }
  }]);

  return TimeAxisColumn;
}(Object(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_12__["default"])(_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_10__["default"]));


_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerColumnType(TimeAxisColumn);
TimeAxisColumn._$name = 'TimeAxisColumn';

/***/ }),

/***/ "./lib/Scheduler/column/VerticalTimeAxisColumn.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/column/VerticalTimeAxisColumn.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VerticalTimeAxisColumn; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony import */ var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony import */ var _view_VerticalTimeAxis_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../view/VerticalTimeAxis.js */ "./lib/Scheduler/view/VerticalTimeAxis.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/column/VerticalTimeAxisColumn
 */

/**
 * A column containing the time axis labels for vertical mode. Normally you do not need to interact with or 
 * create this column, it is handled by Scheduler/Gantt.
 * 
 * @extends Grid/column/Column
 */

var VerticalTimeAxisColumn = /*#__PURE__*/function (_Column) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(VerticalTimeAxisColumn, _Column);

  var _super = _createSuper(VerticalTimeAxisColumn);

  function VerticalTimeAxisColumn() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, VerticalTimeAxisColumn);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(VerticalTimeAxisColumn, [{
    key: "construct",
    value: function construct(data) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(VerticalTimeAxisColumn.prototype), "construct", this).apply(this, arguments);

      me.timeAxisViewModel = data.timeline.timeAxisViewModel;
      me.view = new _view_VerticalTimeAxis_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
        model: me.timeAxisViewModel,
        client: data.timeline
      });
    }
  }, {
    key: "renderer",
    value: function renderer(_ref) {
      var cellElement = _ref.cellElement,
          size = _ref.size;
      this.view.render(cellElement);
      size.height = this.view.height;
    }
  }, {
    key: "isFocusable",
    get: function get() {
      return false;
    }
  }], [{
    key: "type",
    get: function get() {
      return 'verticalTimeAxis';
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        /**
         * Set to false to prevent this column header from being dragged.
         * @config {Boolean} draggable
         * @category Interaction
         * @default false
         * @hide
         */
        draggable: false,

        /**
         * Set to false to prevent grouping by this column.
         * @config {Boolean} groupable
         * @category Interaction
         * @default false
         * @hide
         */
        groupable: false,

        /**
         * Allow column visibility to be toggled through UI.
         * @config {Boolean} hideable
         * @default false
         * @category Interaction
         * @hide
         */
        hideable: false,

        /**
         * Show column picker for the column.
         * @config {Boolean} showColumnPicker
         * @default false
         * @category Menu
         * @hide
         */
        showColumnPicker: false,

        /**
         * Allow filtering data in the column (if Filter feature is enabled)
         * @config {Boolean} filterable
         * @default false
         * @category Interaction
         * @hide
         */
        filterable: false,

        /**
         * Allow sorting of data in the column
         * @config {Boolean} sortable
         * @category Interaction
         * @default false
         * @hide
         */
        sortable: false,
        // /**
        //  * Set to `false` to prevent the column from being drag-resized when the ColumnResize plugin is enabled.
        //  * @config {Boolean} resizable
        //  * @default false
        //  * @category Interaction
        //  * @hide
        //  */
        // resizable : false,

        /**
         * Allow searching in the column (respected by QuickFind and Search features)
         * @config {Boolean} searchable
         * @default false
         * @category Interaction
         * @hide
         */
        searchable: false,

        /**
         * Specifies if this column should be editable, and define which editor to use for editing cells in the column (if CellEdit feature is enabled)
         * @config {String} editor
         * @default false
         * @category Interaction
         * @hide
         */
        editor: false,

        /**
         * Set to `true` to show a context menu on the cell elements in this column
         * @config {Boolean} enableCellContextMenu
         * @default false
         * @category Menu
         * @hide
         */
        enableCellContextMenu: false,

        /**
         * Renderer function for cell tooltips header (used with CellTooltip feature). Specify false to prevent
         * tooltip for that column.
         * @param {HTMLElement} cellElement Cell element
         * @param {Core.data.Model} record Record for cell row
         * @param {Grid.column.Column} column Cell column
         * @param {CellTooltip} cellTooltip Feature instance, used to set tooltip content async
         * @param {MouseEvent} event The event that triggered the tooltip
         * @config {Function} tooltipRenderer
         * @category Rendering
         * @default false
         * @hide
         */
        tooltipRenderer: false,
        cellCls: 'b-verticaltimeaxiscolumn'
      };
    }
  }]);

  return VerticalTimeAxisColumn;
}(_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerColumnType(VerticalTimeAxisColumn);
VerticalTimeAxisColumn._$name = 'VerticalTimeAxisColumn';

/***/ }),

/***/ "./lib/Scheduler/crud/AbstractCrudManager.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/crud/AbstractCrudManager.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AbstractCrudManager; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./AbstractCrudManagerMixin.js */ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/crud/AbstractCrudManager
 */

/**
 * This is an abstract class serving as the base for the {@link Scheduler.data.CrudManager} class.
 * It implements basic mechanisms to organize batch communication with a server.
 * Yet it does not contain methods related to _data transfer_ nor _encoding_.
 * These methods are to be provided in sub-classes by consuming the appropriate mixins.
 *
 * For example, this is how the class can be used to implement an JSON encoding system:
 *
 * ```javascript
 * // let's make new CrudManager using AJAX as a transport system and JSON for encoding
 * class MyCrudManager extends JsonEncode(AjaxTransport(AbstractCrudManager)) {
 *
 * }
 * ```
 *
 * ## Data transfer and encoding methods
 * These are methods that must be provided by subclasses of this class:
 *
 * - [#sendRequest](#Scheduler/crud/AbstractCrudManagerMixin#function-sendRequest)
 * - [#cancelRequest](#Scheduler/crud/AbstractCrudManagerMixin#function-cancelRequest)
 * - [#encode](#Scheduler/crud/AbstractCrudManagerMixin#function-encode)
 * - [#decode](#Scheduler/crud/AbstractCrudManagerMixin#function-decode)
 *
 * @extends Core/Base
 * @mixes Scheduler/crud/AbstractCrudManagerMixin
 * @abstract
 */

var AbstractCrudManager = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(AbstractCrudManager, _Base$mixin);

  var _super = _createSuper(AbstractCrudManager);

  function AbstractCrudManager() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, AbstractCrudManager);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(AbstractCrudManager, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (config.stores) {
        config.crudStores = config.stores;
        delete config.stores;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(AbstractCrudManager.prototype), "construct", this).call(this, config);
    } //endregion
    //region Store collection (add, remove, get & iterate)

  }, {
    key: "commit",

    /**
     * Commits all records changes of all the registered stores.
     */
    value: function commit() {
      this.commitCrudStores();
    }
    /**
     * Rejects all records changes on all stores and re-insert any records that were removed locally. Any phantom records will be removed.
     */

  }, {
    key: "reject",
    value: function reject() {
      this.rejectCrudStores();
    }
    /**
     * Adds a store to the collection.
     *
     *```javascript
     * // append stores to the end of collection
     * crudManager.addStore([
     *     store1,
     *     // storeId
     *     'bar',
     *     // store descriptor
     *     {
     *         storeId : 'foo',
     *         store   : store3
     *     },
     *     {
     *         storeId         : 'bar',
     *         store           : store4,
     *         // to write all fields of modified records
     *         writeAllFields  : true
     *     }
     * ]);
     *```
     *
     * **Note:** Order in which stores are kept in the collection is very essential sometimes.
     * Exactly in this order the loaded data will be put into each store.
     * @param {Core.data.Store|String|Object|Core.data.Store[]|String[]|Object[]} store
     * A store or list of stores. Each store might be specified by its instance, `storeId` or _descriptor_.
     * The _store descriptor_ is an object having following properties:
     * @param {String} store.storeId The store identifier that will be used as a key in requests.
     * @param {Core.data.Store} store.store The store itself.
     * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
     * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
     * @param {Boolean} [store.writeAllFields] Set to true to write all fields from modified records
     * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
     * If not specified then store(s) will be appended to the end of collection.
     * Otherwise it will be just a position in stores collection.
     *
     * ```javascript
     * // insert stores store4, store5 to the start of collection
     * crudManager.addStore([ store4, store5 ], 0);
     * ```
     *
     * @param {String|Core.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or descriptor (the result of {@link Scheduler/crud/AbstractCrudManagerMixin#function-getStoreDescriptor} call).
     *
     * ```javascript
     * // insert store6 just before a store having storeId equal to 'foo'
     * crudManager.addStore(store6, 0, 'foo');
     *
     * // insert store7 just after store3 store
     * crudManager.addStore(store7, 1, store3);
     * ```
     */

  }, {
    key: "addStore",
    value: function addStore() {
      return this.addCrudStore.apply(this, arguments);
    }
  }, {
    key: "removeStore",
    value: function removeStore() {
      return this.removeCrudStore.apply(this, arguments);
    }
  }, {
    key: "getStore",
    value: function getStore() {
      return this.getCrudStore.apply(this, arguments);
    }
  }, {
    key: "hasChanges",
    value: function hasChanges() {
      return this.crudStoreHasChanges.apply(this, arguments);
    }
  }, {
    key: "loadData",
    value: function loadData() {
      return this.loadCrudManagerData.apply(this, arguments);
    }
  }, {
    key: "revision",
    //region Default config

    /**
     * The server revision stamp.
     * The _revision stamp_ is a number which should be incremented after each server-side change.
     * This property reflects the current version of the data retrieved from the server and gets updated after each {@link Scheduler/crud/AbstractCrudManagerMixin#function-load} and {@link Scheduler/crud/AbstractCrudManagerMixin#function-sync} call.
     * @property {Number} revision
     * @readonly
     */
    get: function get() {
      return this.crudRevision;
    },
    set: function set(value) {
      this.crudRevision = value;
    }
  }, {
    key: "stores",
    set: function set(stores) {
      if (stores !== this.crudStores) {
        this.crudStores = stores;
      }
    }
    /**
     * A list of registered stores whose server communication will be collected into a single batch.
     * Each store is represented by a _store descriptor_, an object having following structure:
     * @member {Object[]} stores
     * @property {String} stores.storeId Unique store identifier.
     * @property {Core.data.Store} stores.store Store itself.
     * @property {String} [stores.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
     * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
     */
    ,
    get: function get() {
      return this.crudStores;
    } //endregion

    /**
     * Returns true if the crud manager is currently loading data
     * @property {Boolean}
     * @readonly
     * @category CRUD
     */

  }, {
    key: "isLoading",
    get: function get() {
      return this.isCrudManagerLoading;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        overrideCrudStoreLoad: true,

        /**
         * Sets the list of stores controlled by the CRUD manager.
         * Store can be provided by itself, its storeId or an object having the following structure:
         * @property {String} stores.storeId Unique store identifier. Under this name the store related requests/responses will be sent.
         * @property {Core.data.Store} stores.store The store itself.
         * @property {String} [stores.phantomIdField] Set this if the store model has a predefined field to keep phantom record identifier.
         * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
         * @config {Core.data.Store[]|String[]|Object[]}
         */
        stores: null
        /**
         * Encodes request to the server.
         * @function encode
         * @param {Object} request The request to encode.
         * @returns {String} The encoded request.
         * @abstract
         */

        /**
         * Decodes response from the server.
         * @function decode
         * @param {String} response The response to decode.
         * @returns {Object} The decoded response.
         * @abstract
         */

      };
    }
  }]);

  return AbstractCrudManager;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"].mixin(_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_10__["default"]));


AbstractCrudManager._$name = 'AbstractCrudManager';

/***/ }),

/***/ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/crud/AbstractCrudManagerMixin.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.number.parse-int */ "./node_modules/core-js/modules/es.number.parse-int.js");
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/es.promise.finally */ "./node_modules/core-js/modules/es.promise.finally.js");
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");















































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_34___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_44___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';








/**
 * @module Scheduler/crud/AbstractCrudManagerMixin
 */

var storeSortFn = function storeSortFn(lhs, rhs, sortProperty) {
  // TODO: get rid of these StoreDescriptors. Just use Stores.
  if (lhs.store) {
    lhs = lhs.store;
  }

  if (rhs.store) {
    rhs = rhs.store;
  }

  lhs = lhs[sortProperty] || 0;
  rhs = rhs[sortProperty] || 0;
  return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
},
    // Sorter function to keep stores in loadPriority order
storeLoadSortFn = function storeLoadSortFn(lhs, rhs) {
  return storeSortFn(lhs, rhs, 'loadPriority');
},
    // Sorter function to keep stores in syncPriority order
storeSyncSortFn = function storeSyncSortFn(lhs, rhs) {
  return storeSortFn(lhs, rhs, 'syncPriority');
},
    nullFn = function nullFn() {};
/**
 * An abstract mixin that supplies most of the CrudManager functionality.
 * It implements basic mechanisms of collecting stores to organize batch communication with a server.
 * Yet it does not contain methods related to _data transfer_ nor _encoding_.
 * These methods are to be provided in sub-classes.
 * Out of the box there are mixins implementing {@link Scheduler.crud.transport.AjaxTransport support of AJAX for data transferring}
 * and {@link Scheduler.crud.encoder.JsonEncoder JSON for data encoding system}.
 * For example this is how we make a model that will implement CrudManager protocol and use AJAX/JSON to pass the dada to the server:
 *
 * ```javascript
 * class SystemSettings extends JsonEncode(AjaxTransport(AbstractCrudManagerMixin(Model))) {
 *     ...
 * }
 * ```
 *
 * ## Data transfer and encoding methods
 *
 * These are methods that must be provided by subclasses of this class:
 *
 * - {@link #function-sendRequest sendRequest}
 * - {@link #function-cancelRequest cancelRequest}
 * - {@link #function-encode encode}
 * - {@link #function-decode decode}
 *
 * @mixin
 * @mixes Core/mixin/Delayable
 * @mixes Core/mixin/Events
 * @abstract
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  var _ref;

  // Trigger $meta calculation to get up-to-date is "isXXX" flags
  Target.$meta;
  var mixins = []; // These two mixins are mixed in the Scheduling Engine code ..but in its own way
  // so that Base.mixin() cannot understand that they are already there and applies them 2nd time

  if (!Target.isEvents) {
    mixins.push(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_53__["default"]);
  }

  if (!Target.isDelayable) {
    mixins.push(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_47__["default"]);
  }

  return /*#__PURE__*/function (_mixin) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_43___default()(AbstractCrudManagerMixin, _mixin);

    var _super = _createSuper(AbstractCrudManagerMixin);

    function AbstractCrudManagerMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_40___default()(this, AbstractCrudManagerMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_41___default()(AbstractCrudManagerMixin, [{
      key: "construct",
      //endregion
      //region Init
      value: function construct() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._requestId = 0;
        this.activeRequests = {};
        this.crudStoresIndex = {};

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_42___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(AbstractCrudManagerMixin.prototype), "construct", this).call(this, config);
      }
    }, {
      key: "afterConstruct",
      value: function afterConstruct() {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_42___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(AbstractCrudManagerMixin.prototype), "afterConstruct", this).call(this);

        if (this.autoLoad) {
          this.doAutoLoad();
        }
      } //endregion
      //region Load

    }, {
      key: "doAutoLoad",
      value: function doAutoLoad() {
        var _this = this;

        return this.load().catch(function (response) {
          if (!response || !_this.isValidResponse(response.rawResponse, response.response)) {
            throw response;
          }
        });
      } //endregion
      //region Store descriptors & index

      /**
       * Returns a registered store descriptor.
       * @param {String|Core.data.Store} storeId The store identifier or registered store instance.
       * @returns {Object} The descriptor of the store.
       */

    }, {
      key: "getStoreDescriptor",
      value: function getStoreDescriptor(storeId) {
        if (!storeId) return null;
        if (storeId instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_46__["default"]) return this.crudStores.find(function (storeDesc) {
          return storeDesc.store === storeId;
        });
        if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_39___default()(storeId) === 'object') return this.crudStoresIndex[storeId.storeId];
        return this.crudStoresIndex[storeId] || this.getStoreDescriptor(_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_46__["default"].getStore(storeId));
      }
    }, {
      key: "fillStoreDescriptor",
      value: function fillStoreDescriptor(descriptor) {
        var store = descriptor.store,
            _store$storeIdPropert = store.storeIdProperty,
            storeIdProperty = _store$storeIdPropert === void 0 ? this.storeIdProperty : _store$storeIdPropert,
            modelClass = store.modelClass;

        if (!descriptor.storeId) {
          descriptor.storeId = store[storeIdProperty];
        }

        if (!descriptor.idField) {
          descriptor.idField = modelClass.idField;
        }

        if (!descriptor.phantomIdField) {
          descriptor.phantomIdField = modelClass.phantomIdField;
        }

        if (!descriptor.phantomParentIdField) {
          descriptor.phantomParentIdField = modelClass.phantomParentIdField;
        }

        if (!('writeAllFields' in descriptor)) {
          descriptor.writeAllFields = store.writeAllFields;
        }

        return descriptor;
      }
    }, {
      key: "updateCrudStoreIndex",
      value: function updateCrudStoreIndex() {
        var crudStoresIndex = this.crudStoresIndex = {};
        this.crudStores.forEach(function (store) {
          return store.storeId && (crudStoresIndex[store.storeId] = store);
        });
      } //endregion
      //region Store collection (add, remove, get & iterate)

      /**
       * Returns a registered store.
       * @param {String} storeId Store identifier.
       * @returns {Core.data.Store} Found store instance.
       */

    }, {
      key: "getCrudStore",
      value: function getCrudStore(storeId) {
        var storeDescriptor = this.getStoreDescriptor(storeId);
        return storeDescriptor === null || storeDescriptor === void 0 ? void 0 : storeDescriptor.store;
      }
    }, {
      key: "forEachCrudStore",
      value: function forEachCrudStore(fn) {
        var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
        if (!fn) return;
        this.crudStores.every(function (store) {
          return fn.call(thisObj, store.store, store.storeId, store) !== false;
        });
      }
    }, {
      key: "internalAddCrudStore",
      value: function internalAddCrudStore(store) {
        var me = this;
        var storeInfo; // if store instance provided

        if (store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_46__["default"]) {
          storeInfo = {
            store: store
          };
        } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_39___default()(store) === 'object') {
          // normalize sub-stores (if any)
          if (store.stores) {
            if (!Array.isArray(store.stores)) {
              store.stores = [store.stores];
            }

            store.stores.forEach(function (subStore, j) {
              var subStoreInfo = subStore;

              if (typeof subStore === 'string') {
                subStoreInfo = {
                  storeId: subStore
                };
              } // keep reference to the "master" store descriptor


              subStoreInfo.masterStoreInfo = store;
              store.stores[j] = subStoreInfo;
            });
          } else if (!store.store) {
            // not a store descriptor, assume it is a store config
            store = {
              storeId: store.id,
              store: new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_46__["default"](store)
            };
          }

          storeInfo = store;
        } // if it's a store identifier
        else {
            storeInfo = {
              store: _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_46__["default"].getStore(store)
            };
          }

        me.fillStoreDescriptor(storeInfo); // store instance

        store = storeInfo.store; // if the store has "setCrudManager" hook - use it

        if (store.setCrudManager) {
          store.setCrudManager(me);
        } // otherwise decorate the store w/ "crudManager" property
        else {
            store.crudManager = me;
          } // Stores have a defaultConfig for pageSize. CrudManager does not support that.
        // TODO: PORT currently no support for paging.


        store.pageSize = null; // Prevent AjaxStores from performing their own CRUD operations

        if (me.overrideCrudStoreLoad && store.load) {
          store.load = store.commit = function () {};
        } // listen to store changes


        me.bindCrudStoreListeners(store);
        return storeInfo;
      }
      /**
       * Adds a store to the collection.
       *
       *```javascript
      * // append stores to the end of collection
      * crudManager.addCrudStore([
      *     store1,
      *     // storeId
      *     'bar',
      *     // store descriptor
      *     {
      *         storeId : 'foo',
      *         store   : store3
      *     },
      *     {
      *         storeId         : 'bar',
      *         store           : store4,
      *         // to write all fields of modified records
      *         writeAllFields  : true
      *     }
      * ]);
      *```
      *
      * **Note:** Order in which stores are kept in the collection is very essential sometimes.
      * Exactly in this order the loaded data will be put into each store.
      * @param {Core.data.Store|String|Object|Core.data.Store[]|String[]|Object[]} store
      * A store or list of stores. Each store might be specified by its instance, `storeId` or _descriptor_.
      * The _store descriptor_ is an object having following properties:
      * @param {String} store.storeId The store identifier that will be used as a key in requests.
      * @param {Core.data.Store} store.store The store itself.
      * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
      * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
      * @param {Boolean} [store.writeAllFields] Set to true to write all fields from modified records
      * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
      * If not specified then store(s) will be appended to the end of collection.
      * Otherwise it will be just a position in stores collection.
      *
      * ```javascript
      * // insert stores store4, store5 to the start of collection
      * crudManager.addCrudStore([ store4, store5 ], 0);
      * ```
      *
      * @param {String|Core.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or descriptor (the result of {@link #function-getStoreDescriptor} call).
      *
      * ```javascript
      * // insert store6 just before a store having storeId equal to 'foo'
      * crudManager.addCrudStore(store6, 0, 'foo');
      *
      * // insert store7 just after store3 store
      * crudManager.addCrudStore(store7, 1, store3);
      * ```
      */

    }, {
      key: "addCrudStore",
      value: function addCrudStore(store, position, fromStore) {
        var _me$orderedCrudStores;

        if (!store) return;
        if (!Array.isArray(store)) store = [store];
        if (!store.length) return;
        var me = this,
            stores = store.map(me.internalAddCrudStore, me); // if no position specified then append stores to the end

        if (typeof position === 'undefined') {
          var _me$crudStores;

          (_me$crudStores = me.crudStores).push.apply(_me$crudStores, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default()(stores));
        } // if position specified
        else {
            var _me$crudStores2;

            var pos = position; // if specified the store relative to which we should insert new one(-s)

            if (fromStore) {
              if (fromStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_46__["default"] || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_39___default()(fromStore) !== 'object') fromStore = me.getStoreDescriptor(fromStore); // get its position

              pos += me.crudStores.indexOf(fromStore);
            } // insert new store(-s)
            //me.crudStores.splice.apply(me.crudStores, [].concat([pos, 0], stores));


            (_me$crudStores2 = me.crudStores).splice.apply(_me$crudStores2, [pos, 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default()(stores)));
          }

        (_me$orderedCrudStores = me.orderedCrudStores).push.apply(_me$orderedCrudStores, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default()(stores));

        me.updateCrudStoreIndex();
      } // Adds configured scheduler stores to the store collection ensuring correct order
      // unless they're already registered.

    }, {
      key: "addPrioritizedStore",
      value: function addPrioritizedStore(store) {
        var me = this;

        if (!me.hasCrudStore(store)) {
          this.addCrudStore(store, _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_50__["default"].findInsertionIndex(store, me.crudStores, storeLoadSortFn));
        }

        if (!me.hasApplySequenceStore(store)) {
          this.addStoreToApplySequence(store, _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_50__["default"].findInsertionIndex(store, me.syncApplySequence, storeSyncSortFn));
        }
      }
    }, {
      key: "hasCrudStore",
      value: function hasCrudStore(store) {
        var _this$crudStores;

        return (_this$crudStores = this.crudStores) === null || _this$crudStores === void 0 ? void 0 : _this$crudStores.some(function (s) {
          return s === store || s.store === store || s.storeId === store;
        });
      }
      /**
       * Removes a store from collection. If the store was registered in alternative sync sequence list
       * it will be removed from there as well.
       *
       * ```javascript
       *    // remove store having storeId equal to "foo"
       *    crudManager.removeCrudStore("foo");
       *
       *    // remove store3
       *    crudManager.removeCrudStore(store3);
       * ```
       *
       * @param {Object|String|Core.data.Store} store The store to remove. Either the store descriptor, store identifier or store itself.
       */

    }, {
      key: "removeCrudStore",
      value: function removeCrudStore(store) {
        var me = this,
            stores = me.crudStores;

        for (var i = 0, l = stores.length; i < l; i++) {
          var s = stores[i];

          if (s === store || s.store === store || s.storeId === store) {
            // unbind store listeners
            me.unbindCrudStoreListeners(s.store);
            delete me.crudStoresIndex[s.storeId];
            stores.splice(i, 1);

            if (me.syncApplySequence) {
              me.removeStoreFromApplySequence(store);
            }

            break;
          }
        }
      } //endregion
      //region Store listeners

    }, {
      key: "bindCrudStoreListeners",
      value: function bindCrudStoreListeners(store) {
        store.on({
          name: store.id,
          change: 'onCrudStoreChange',
          thisObj: this
        });
      }
    }, {
      key: "unbindCrudStoreListeners",
      value: function unbindCrudStoreListeners(store) {
        this.detachListeners(store.id);
      } //endregion
      //region Apply sequence

      /**
       * Adds a store to the alternative sync responses apply sequence.
       * By default the order in which sync responses are applied to the stores is the same as they registered in.
       * But this order can be changes either on construction step using {@link #config-syncApplySequence} option
       * or but calling this method.
       *
       * **Please note**, that if the sequence was not initialized before this method call then
       * you will have to do it yourself like this for example:
       *
       *    ```javascript
       *    // alternative sequence was not set for this crud manager
       *    // so let's fill it with existing stores keeping the same order
       *    crudManager.addStoreToApplySequence(crudManager.crudStores);
       *
       *    // and now we can add our new store
       *
       *    // we will load its data last
       *    crudManager.addCrudStore(someNewStore);
       *    // but changes to it will be applied first
       *    crudManager.addStoreToApplySequence(someNewStore, 0);
       *    ```
       * add registered stores to the sequence along with the store(s) you want to add
       *
       * @param {Core.data.Store|Object|Core.data.Store[]|Object[]} store The store to add or its _descriptor_ (or array of stores or descriptors).
       * Where _store descriptor_ is an object having following properties:
       * @param {String} store.storeId The store identifier that will be used as a key in requests.
       * @param {Core.data.Store} store.store The store itself.
       * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
       * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
       * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
      * If not specified then store(s) will be appended to the end of collection.
      * Otherwise it will be just a position in stores collection.
      *
      *    ```javascript
      *    // insert stores store4, store5 to the start of sequence
      *    crudManager.addStoreToApplySequence([ store4, store5 ], 0);
      *    ```
      * @param {String|Core.data.Store|object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or its descriptor (the result of {@link #function-getStoreDescriptor} call).
      *
      *    ```javascript
      *    // insert store6 just before a store having storeId equal to 'foo'
      *    crudManager.addStoreToApplySequence(store6, 0, 'foo');
      *
      *    // insert store7 just after store3 store
      *    crudManager.addStoreToApplySequence(store7, 1, store3);
      *    ```
      */

    }, {
      key: "addStoreToApplySequence",
      value: function addStoreToApplySequence(store, position, fromStore) {
        if (!store) return;
        if (!Array.isArray(store)) store = [store];
        var me = this,
            // loop over list of stores to add
        data = store.reduce(function (collection, store) {
          var s = me.getStoreDescriptor(store);
          if (s) collection.push(s);
          return collection;
        }, []); // if no position specified then append stores to the end

        if (typeof position === 'undefined') {
          var _me$syncApplySequence;

          (_me$syncApplySequence = me.syncApplySequence).push.apply(_me$syncApplySequence, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default()(data)); // if position specified

        } else {
          var _me$syncApplySequence2;

          var pos = position; // if specified the store relative to which we should insert new one(-s)

          if (fromStore) {
            if (fromStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_46__["default"] || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_39___default()(fromStore) !== 'object') fromStore = me.getStoreDescriptor(fromStore); // get its position

            pos += me.syncApplySequence.indexOf(fromStore);
          } // insert new store(-s)
          //me.syncApplySequence.splice.apply(me.syncApplySequence, [].concat([pos, 0], data));


          (_me$syncApplySequence2 = me.syncApplySequence).splice.apply(_me$syncApplySequence2, [pos, 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default()(data)));
        }

        var sequenceKeys = me.syncApplySequence.map(function (desc) {
          return desc.storeId;
        });
        me.orderedCrudStores = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default()(me.syncApplySequence);
        me.crudStores.forEach(function (desc) {
          if (!sequenceKeys.includes(desc.storeId)) {
            me.orderedCrudStores.push(desc);
          }
        });
      }
      /**
       * Removes a store from the alternative sync sequence.
       *
       * ```javascript
       * // remove store having storeId equal to "foo"
       * crudManager.removeStoreFromApplySequence("foo");
       * ```
       *
       * @param {Object|String|Core.data.Store} store The store to remove. Either the store descriptor, store identifier or store itself.
       */

    }, {
      key: "removeStoreFromApplySequence",
      value: function removeStoreFromApplySequence(store) {
        var index = this.syncApplySequence.findIndex(function (s) {
          return s === store || s.store === store || s.storeId === store;
        });

        if (index > -1) {
          this.syncApplySequence.splice(index, 1); // ordered crud stores list starts with syncApplySequence, we can use same index

          this.orderedCrudStores.splice(index, 1);
        }
      }
    }, {
      key: "hasApplySequenceStore",
      value: function hasApplySequenceStore(store) {
        return this.syncApplySequence.some(function (s) {
          return s === store || s.store === store || s.storeId === store;
        });
      } //endregion
      //region Events
      // onNodeRemove(oldParent) {
      //     var treeStore = oldParent && oldParent.getTreeStore();
      //     // "noderemove" event is fired too early and getRemovedRecords() don't not have the removed node yet
      //     // so we wait till tree store "endupdate" event and only then invoke "onCrudStoreChange" method
      //     treeStore && treeStore.on('endupdate', this.onCrudStoreChange, this, { once : true });
      // }
      // onStoreUpdate(store, record, operation, fields) {
      //     if ((!store.isTreeStore || record !== store.getRoot())) {
      //         // If only a single field was changed, make sure it's a persistable field to avoid full scan of the store
      //         // Collapsing/expanding a tree node will trigger this behavior otherwise
      //         var isSingleNonPersistField = fields && fields.length === 1 && record.getField(fields[0]) && !record.getField(fields[0]).persist;
      //
      //         if (!isSingleNonPersistField) {
      //             this.onCrudStoreChange();
      //         }
      //     }
      // }
      // onTreeStoreInsertOrAppend(parent, child) {
      //     if (!child.isRoot()) {
      //         this.onCrudStoreChange();
      //     }
      // }

    }, {
      key: "onCrudStoreChange",
      value: function onCrudStoreChange() {
        var me = this;

        if (me.crudIgnoreUpdates) {
          return;
        }
        /**
         * Fires when any record in a registered stores is changed.
         * ```javascript
         *     crudManager.on('hasChanges', function (crud) {
         *         // enable persist changes button when some store gets changed
         *         saveButton.enable();
         *     });
         * ```
         * @event hasChanges
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         */


        if (me.crudStoreHasChanges()) {
          me.trigger('hasChanges');

          if (me.autoSync) {
            me.scheduleAutoSync();
          }
        } else {
          me.trigger('noChanges');
        }
      }
      /**
       * Suspends automatic sync upon store changes. Can be called multiple times (it uses an internal counter).
       */

    }, {
      key: "suspendAutoSync",
      value: function suspendAutoSync() {
        this.autoSyncSuspendCounter++;
        this.forEachCrudStore(function (store) {
          return store.suspendAutoCommit();
        });
      }
      /**
       * Resumes automatic sync upon store changes. Will trigger commit if the internal counter is 0.
       */

    }, {
      key: "resumeAutoSync",
      value: function resumeAutoSync() {
        var doSync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var me = this;
        me.autoSyncSuspendCounter--;

        if (me.autoSyncSuspendCounter <= 0) {
          me.autoSyncSuspendCounter = 0;

          if (me.autoSync && doSync) {
            me.forEachCrudStore(function (store) {
              return store.resumeAutoCommit(doSync);
            });
            me.sync();
          }
        }
      }
    }, {
      key: "scheduleAutoSync",
      value: function scheduleAutoSync() {
        var me = this; // add deferred call if it's not scheduled yet

        if (!me.autoSyncTimerId && !me.autoSyncSuspendCounter) {
          me.autoSyncTimerId = me.setTimeout(function () {
            me.autoSyncTimerId = null;
            me.sync().catch(function (error) {
              if (!error || !me.isValidResponse(error.rawResponse, error.response)) {
                throw error;
              }
            });
          }, me.autoSyncTimeout);
        }
      }
    }, {
      key: "internalOnResponse",
      value: function () {
        var _internalOnResponse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee(requestType, responseText, fetchOptions, options) {
          var me, response;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // reset last requested package ID
                  me = this;
                  me.activeRequests[requestType] = null;
                  response = responseText ? me.decode(responseText) : null;

                  if (!(!response || !response.success)) {
                    _context.next = 7;
                    break;
                  }

                  /**
                   * Fires when a request fails.
                   * @event requestFail
                   * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
                   * @param {String} requestType The request type (`sync` or `load`).
                   * @param {Object} response The decoded server response object.
                   * @param {String} responseText The raw server response text
                   * @param {Object} responseOptions The response options.
                   */
                  me.trigger('requestFail', {
                    requestType: requestType,
                    response: response,
                    responseText: responseText,
                    responseOptions: fetchOptions
                  });
                  /**
                   * Fires when a {@link #function-load load request} fails.
                   * @event loadFail
                   * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
                   * @param {Object} response The decoded server response object.
                   * @param {String} responseText The raw server response text
                   * @param {Object} responseOptions The response options.
                   * @params {Object} options Options provided to the {@link #function-load} method.
                   */

                  /**
                   * Fires when a {@link #function-sync sync request} fails.
                   * @event syncFail
                   * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
                   * @param {Object} response The decoded server response object.
                   * @param {String} responseText The raw server response text
                   * @param {Object} responseOptions The response options.
                   */

                  me.trigger(requestType + 'Fail', {
                    response: response,
                    responseOptions: fetchOptions,
                    responseText: responseText,
                    options: options
                  });
                  return _context.abrupt("return", response);

                case 7:
                  if (!(me.trigger('beforeResponseApply', {
                    requestType: requestType,
                    response: response
                  }) !== false && me.trigger('before' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"].capitalize(requestType) + 'Apply', {
                    response: response,
                    options: options
                  }) !== false)) {
                    _context.next = 14;
                    break;
                  }

                  me.crudRevision = response.revision;
                  _context.next = 11;
                  return me.applyResponse(requestType, response, options);

                case 11:
                  /**
                   * Fires on successful request completion after data gets applied to the stores.
                   * @event requestDone
                   * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
                   * @param {String} requestType The request type (`sync` or `load`).
                   * @param {Object} response The decoded server response object.
                   * @param {Object} responseOptions The server response options.
                   */
                  me.trigger('requestDone', {
                    requestType: requestType,
                    response: response,
                    responseOptions: fetchOptions
                  });
                  /**
                   * Fires on successful {@link #function-load load request} completion after data gets loaded to the stores.
                   * @event load
                   * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
                   * @param {Object} response The decoded server response object.
                   * @param {Object} responseOptions The server response options.
                   * @params {Object} options Options provided to the {@link #load} method.
                   */

                  /**
                   * Fires on successful {@link #function-sync sync request} completion.
                   * @event sync
                   * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
                   * @param {Object} response The decoded server response object.
                   * @param {Object} responseOptions The server response options.
                   */

                  me.trigger(requestType, {
                    response: response,
                    responseOptions: fetchOptions,
                    options: options
                  });

                  if (requestType === 'load' || !me.crudStoreHasChanges()) {
                    /**
                     * Fires when registered stores get into state when they don't have any
                     * not persisted change. This happens after {@link #function-load load} or {@link #function-sync sync} request
                     * completion. Or this may happen after a record update which turns its fields back to their original state.
                     *
                     * ```javascript
                     *     crudManager.on('nochanges', function (crud) {
                     *         // disable persist changes button when there is no changes
                     *         saveButton.disable();
                     *     });
                     * ```
                     *
                     * @event noChanges
                     * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
                     */
                    me.trigger('noChanges');
                  }

                case 14:
                  return _context.abrupt("return", response);

                case 15:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function internalOnResponse(_x, _x2, _x3, _x4) {
          return _internalOnResponse.apply(this, arguments);
        }

        return internalOnResponse;
      }()
    }, {
      key: "internalOnLoad",
      value: function () {
        var _internalOnLoad = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee2(responseText, fetchOptions, options) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // Successful load request, mark crud manager as loaded
                  this.crudLoaded = true;
                  return _context2.abrupt("return", this.internalOnResponse('load', responseText, fetchOptions, options));

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function internalOnLoad(_x5, _x6, _x7) {
          return _internalOnLoad.apply(this, arguments);
        }

        return internalOnLoad;
      }()
    }, {
      key: "internalOnSync",
      value: function () {
        var _internalOnSync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee3(responseText, fetchOptions, options) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", this.internalOnResponse('sync', responseText, fetchOptions, options));

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function internalOnSync(_x8, _x9, _x10) {
          return _internalOnSync.apply(this, arguments);
        }

        return internalOnSync;
      }() //endregion
      //region Changes tracking

    }, {
      key: "suspendChangesTracking",
      value: function suspendChangesTracking() {
        this.crudIgnoreUpdates++;
      }
    }, {
      key: "resumeChangesTracking",
      value: function resumeChangesTracking(skipChangeCheck) {
        if (this.crudIgnoreUpdates && ! --this.crudIgnoreUpdates && !skipChangeCheck) {
          this.onCrudStoreChange();
        }
      }
    }, {
      key: "crudStoreHasChanges",

      /**
       * Returns `true` if any of registered stores (or some particular store) has non persisted changes.
       *
       *    ```javascript
       *    // if we have any unsaved changes
       *    if (crudManager.crudStoreHasChanges()) {
       *        // persist them
       *        crudManager.sync();
       *    // otherwise
       *    } else {
       *        alert("There are no unsaved changes...");
       *    }
       *    ```
       *
       * @param {String|Core.data.Store} [storeId] The store identifier or store instance to check changes for.
       * If not specified then will check changes for all of the registered stores.
       * @returns {Boolean} `true` if there are not persisted changes.
       */
      value: function crudStoreHasChanges(storeId) {
        return storeId ? this.isCrudStoreDirty(this.getCrudStore(storeId)) : this.crudStores.some(this.isCrudStoreDirty);
      }
    }, {
      key: "isCrudStoreDirty",
      value: function isCrudStoreDirty(store) {
        return Boolean(store === null || store === void 0 ? void 0 : store.store.changes);
      } //endregion
      //region Load

    }, {
      key: "emitCrudStoreEvents",
      value: function emitCrudStoreEvents(stores, eventName, eventParams) {
        var event = _objectSpread({
          action: 'read' + eventName
        }, eventParams);

        var _iterator = _createForOfIteratorHelper(this.crudStores),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var store = _step.value;

            if (stores.includes(store.storeId)) {
              store.store.trigger(eventName, event);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "getLoadPackage",
      value: function getLoadPackage(options) {
        var pack = {
          type: 'load',
          requestId: this.requestId
        },
            stores = this.crudStores,
            optionsCopy = Object.assign({}, options); // This is a special option which does not apply to a store.
        // It's used as options to the AjaxTransport#sendRequest method

        delete optionsCopy.request;
        pack.stores = stores.map(function (store) {
          var _store$store;

          var opts = optionsCopy === null || optionsCopy === void 0 ? void 0 : optionsCopy[store.storeId],
              pageSize = store.pageSize || ((_store$store = store.store) === null || _store$store === void 0 ? void 0 : _store$store.pageSize); // TODO: PORT currently no support for remote filters
          // if the store uses remote filtering
          // if (store.store.remoteFilter && filterParam) {
          //
          //     opts = opts || {};
          //
          //     var filters = [];
          //
          //     store.store.getFilters().each(function(f) {
          //         filters.push(f.serialize());
          //     });
          //
          //     // put filters info into the package
          //     opts[filterParam] = filters;
          // }
          // TODO: PORT currently no support for paging

          if (opts || pageSize) {
            var params = Object.assign({
              storeId: store.storeId,
              page: 1
            }, opts);

            if (pageSize) {
              params.pageSize = pageSize;
            }

            store.currentPage = params.page; // Remove from common request options

            if (opts) {
              delete optionsCopy[store.storeId];
            }

            return params;
          }

          return store.storeId;
        }); // Apply common request options

        Object.assign(pack, optionsCopy);
        return pack;
      }
    }, {
      key: "loadCrudStore",
      value: function loadCrudStore(store, data, options) {
        var rows = data === null || data === void 0 ? void 0 : data.rows;

        if ((options === null || options === void 0 ? void 0 : options.append) || (data === null || data === void 0 ? void 0 : data.append)) {
          store.add(rows);
        } else {
          store.data = rows;
        }

        store.trigger('load', {
          data: rows
        });
      }
    }, {
      key: "loadDataToCrudStore",
      value: function loadDataToCrudStore(storeDesc, data, options) {
        var me = this,
            store = storeDesc.store,
            // nested stores list
        subStores = storeDesc.stores,
            idField = storeDesc.idField || 'id',
            //model && model.meta.idField || 'id',
        isTree = store.tree,
            rows = data === null || data === void 0 ? void 0 : data.rows;
        store.__loading = true; //TODO: PORT meta data on store?
        // apply server provided meta data to the store
        // const metaData = data?.metaData;
        // if (metaData) {
        //     if (store.applyMetaData) {
        //         store.applyMetaData(metaData);
        //     } else {
        //         store.metaData = metaData;
        //     }
        // }

        if (rows) {
          var subData;

          if (subStores) {
            subData = me.getSubStoresData(rows, subStores, idField, isTree);
          }

          me.loadCrudStore(store, data, options, storeDesc);

          if (subData) {
            // load sub-stores as well (if we have them)
            subData.forEach(function (sub) {
              me.loadDataToCrudStore(Object.assign({
                store: store.getById(sub.id).get(sub.storeDesc.storeId) // TODO: PORT have to check what this does

              }, sub.storeDesc), sub.data);
            });
          }
        }

        store.__loading = false;
      }
      /**
       * Loads data to the Crud Manager
       * @param {Object} response A simple object representing the data.
       * The object structure matches the decoded `load` response structure:
       *
       * // load static data into crudManager
       * crudManager.loadCrudManagerData({
       *     success   : true,
       *     resources : {
       *         rows : [
       *             { id : 1, name : 'John' },
       *             { id : 2, name : 'Abby' }
       *         ]
       *     }
       * });
       * @param {Object} [options] Extra data loading options.
       */

    }, {
      key: "loadCrudManagerData",
      value: function loadCrudManagerData(response) {
        var _this2 = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        // we don't want to react to store changes during loading of them
        this.suspendChangesTracking(); // we load data to the stores in the order they're kept in this.stores array

        this.crudStores.forEach(function (storeDesc) {
          var storeId = storeDesc.storeId,
              data = response[storeId];

          if (data) {
            _this2.loadDataToCrudStore(storeDesc, data, options[storeId]);
          }
        });
        this.resumeChangesTracking(true);
      }
      /**
       * Returns true if the crud manager is currently loading data
       * @property {Boolean}
       * @readonly
       * @category CRUD
       */

    }, {
      key: "load",

      /**
       * Loads data to the stores registered in the crud manager. For example:
       *
       * ```javascript
       * crudManager.load(
       *     // here are request parameters
       *     {
       *         store1 : { append : true, page : 3, smth : 'foo' },
       *         store2 : { page : 2, bar : '!!!' }
       *     }
       * ).then(
       *     () => alert('OMG! It works!'),
       *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
       * );
       * ```
       *
       * ** Note: ** If there is an incomplete load request in progress then system will try to cancel it by calling {@link #function-cancelRequest}.
       * @param {Object} [options] The request parameters. This argument can be omitted like this:
       *
       * ```javascript
       * crudManager.load().then(
       *     () => alert('OMG! It works!'),
       *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
       * );
       * ```
       *
       * When presented it should be an object where keys are store Ids and values are, in turn, objects
       * of parameters related to the corresponding store. These parameters will be transferred in each
       * store's entry in the `stores` property of the POST data.
       *
       * A special property, `request` may reference an object which contains options to merge
       * into the options which are passed to {@link Scheduler.crud.transport.AjaxTransport#function-sendRequest}.
       *
       * ```javascript
       * {
       *     store1 : { page : 3, append : true, smth : 'foo' },
       *     store2 : { page : 2, bar : '!!!' },
       *     request : {
       *         params : {
       *             startDate : '2021-01-01'
       *         }
       *     }
       * },
       * ```
       *
       * Additionally for flat stores `append: true` can be specified to add loaded records to the existing records, default is to remove corresponding store's existing records first.
       * **Please note** that for delta loading you can also use an {@link #config-trackResponseType alternative approach}.
       * @returns {Promise} Promise, which is resolved if request was successful.
       * Both the resolve and reject functions are passed a `state` object. State object has following structure:
       *
       *     {
       *         cancelled       : Boolean, // **optional** flag, which is present when promise was rejected
       *         rawResponse     : String,  // raw response from ajax request, either response xml or text
       *         rawResponseText : String,  // raw response text as String from ajax request
       *         response        : Object,  // processed response in form of object
       *         options         : Object   // options, passed to load request
       *     }
       *
       * If promise was rejected by {@link #event-beforeLoad} event, `state` object will have structure:
       *
       *     {
       *         cancelled : true
       *     }
       *
       */
      value: function load(options) {
        var me = this,
            pack = me.getLoadPackage(options);
        return new Promise(function (resolve, _reject) {
          /**
           * Fires before {@link #function-load load request} is sent. Return `false` to cancel load request.
           * @event beforeLoad
           * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
           * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
           */
          if (me.trigger('beforeLoad', {
            pack: pack
          }) !== false) {
            // if another load request is in progress let's cancel it
            var load = me.activeRequests.load;

            if (load) {
              me.cancelRequest(load.desc, load.reject);
              me.trigger('loadCanceled', {
                pack: pack
              });
            } // TODO: refactor this


            var request = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_51__["default"].assign({
              data: me.encode(pack),
              type: 'load',
              success: me.onLoadSuccess,
              failure: me.onLoadFailure,
              thisObj: me
            }, options === null || options === void 0 ? void 0 : options.request);
            me.activeRequests.load = {
              options: options,
              pack: pack,
              resolve: resolve,
              reject: function reject() {
                // sendRequest will start a fetch promise, which we cannot reject from here. In fact what we
                // need to do, is to make fetch.then() to not call any real handlers. Which is what we do here.
                request.success = request.failure = null;

                _reject.apply(void 0, arguments);
              },
              id: pack.requestId,
              desc: me.sendRequest(request)
            };
            me.emitCrudStoreEvents(pack.stores, 'loadStart');
            me.trigger('loadStart', {
              pack: pack
            });
          } else {
            /**
             * Fired after {@link #function-load load request} was canceled by some {@link #event-beforeLoad}
             * listener or due to incomplete prior load request.
             * @event loadCanceled
             * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
             * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
             */
            me.trigger('loadCanceled', {
              pack: pack
            });
            me.processPromise(_reject, null, {
              action: 'load',
              cancelled: true
            });
          }
        });
      }
    }, {
      key: "onLoadSuccess",
      value: function () {
        var _onLoadSuccess = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee4(rawResponse, fetchOptions) {
          var responseText, request, options, response;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!this.isDestroyed) {
                    _context4.next = 2;
                    break;
                  }

                  return _context4.abrupt("return");

                case 2:
                  responseText = '';
                  request = this.activeRequests.load, options = request.options;
                  _context4.next = 6;
                  return rawResponse.text().then(function (value) {
                    return responseText = value;
                  }).catch(nullFn);

                case 6:
                  if (!this.isDestroyed) {
                    _context4.next = 8;
                    break;
                  }

                  return _context4.abrupt("return");

                case 8:
                  _context4.next = 10;
                  return this.internalOnLoad(responseText, fetchOptions, options);

                case 10:
                  response = _context4.sent;

                  if (!this.isDestroyed) {
                    _context4.next = 13;
                    break;
                  }

                  return _context4.abrupt("return");

                case 13:
                  this.emitCrudStoreEvents(request.pack.stores, 'afterRequest');

                  if (response === null || response === void 0 ? void 0 : response.success) {
                    request.resolve({
                      response: response,
                      rawResponse: rawResponse,
                      responseText: responseText,
                      options: options
                    });
                  } else {
                    this.processPromise(request.reject, request.resolve, {
                      action: 'load',
                      cancelled: false,
                      response: response,
                      rawResponse: rawResponse,
                      responseText: responseText,
                      options: options
                    });
                  }

                case 15:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function onLoadSuccess(_x11, _x12) {
          return _onLoadSuccess.apply(this, arguments);
        }

        return onLoadSuccess;
      }()
    }, {
      key: "onLoadFailure",
      value: function () {
        var _onLoadFailure = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee5(rawResponse) {
          var _fetchOptions$abortCo;

          var fetchOptions,
              request,
              options,
              signal,
              wasAborted,
              responseText,
              response,
              _args5 = arguments;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  fetchOptions = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};

                  if (!this.isDestroyed) {
                    _context5.next = 3;
                    break;
                  }

                  return _context5.abrupt("return");

                case 3:
                  request = this.activeRequests.load, options = request.options, signal = (_fetchOptions$abortCo = fetchOptions.abortController) === null || _fetchOptions$abortCo === void 0 ? void 0 : _fetchOptions$abortCo.signal, wasAborted = Boolean(signal === null || signal === void 0 ? void 0 : signal.aborted);

                  if (wasAborted) {
                    _context5.next = 18;
                    break;
                  }

                  responseText = '';

                  if (!rawResponse) {
                    _context5.next = 9;
                    break;
                  }

                  _context5.next = 9;
                  return rawResponse.text().then(function (value) {
                    return responseText = value;
                  }).catch(nullFn);

                case 9:
                  if (!this.isDestroyed) {
                    _context5.next = 11;
                    break;
                  }

                  return _context5.abrupt("return");

                case 11:
                  _context5.next = 13;
                  return this.internalOnLoad(responseText, fetchOptions, options);

                case 13:
                  response = _context5.sent;

                  if (!this.isDestroyed) {
                    _context5.next = 16;
                    break;
                  }

                  return _context5.abrupt("return");

                case 16:
                  this.emitCrudStoreEvents(request.pack.stores, 'afterRequest', {
                    exception: true
                  });
                  this.processPromise(request.reject, null, {
                    action: 'load',
                    cancelled: wasAborted,
                    response: response,
                    rawResponse: rawResponse,
                    responseText: responseText,
                    options: options,
                    request: request
                  });

                case 18:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function onLoadFailure(_x13) {
          return _onLoadFailure.apply(this, arguments);
        }

        return onLoadFailure;
      }()
    }, {
      key: "getSubStoresData",
      value: function getSubStoresData(rows, subStores, idField, isTree) {
        var _this3 = this;

        if (!rows) return;
        var result = [];

        function processRow(row, subStores) {
          subStores.forEach(function (subStore) {
            var storeId = subStore.storeId; // if row contains data for this sub-store

            if (row[storeId]) {
              // keep them for the later loading
              result.push({
                id: row[idField],
                storeDesc: subStore,
                data: row[storeId]
              }); // and remove reference from the row

              delete row[storeId];
            }
          });
        } // if it's a TreeStore


        if (isTree) {
          // loop over nodes
          rows.forEach(function (row) {
            processRow(row, subStores); // also let's grab sub-stores from node children

            var childrenSubData = _this3.getSubStoresData(row.children, subStores, idField, true);

            if (childrenSubData) {
              result.push.apply(result, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_38___default()(childrenSubData));
            }
          }); // if it's a "flat" store
        } else {
          rows.forEach(function (row) {
            return processRow(row, subStores);
          });
        }

        return result;
      } //endregion
      //region Changes (prepare, process, get)

    }, {
      key: "prepareAdded",
      value: function prepareAdded(list, storeInfo) {
        var _this4 = this;

        var store = storeInfo.store,
            stores = storeInfo.stores,
            isTree = store.isTree,
            phantomIdField = storeInfo.phantomIdField || this.phantomIdField,
            phantomParentIdField = storeInfo.phantomParentIdField || this.phantomParentIdField;
        return list.filter(function (record) {
          return record.isValid;
        }).map(function (record) {
          var cls = record.constructor,
              data = Object.assign(record.persistableData, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_34___default()({}, phantomIdField, record.id));

          if (isTree) {
            var parent = record.parent;

            if (parent && !parent.isRoot && parent.isPhantom) {
              data[phantomParentIdField] = parent.id;
            }
          }

          if (_this4.resetIdsBeforeSync) delete _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].deletePath(data, cls.getFieldDataSource(cls.idField)); // if the store has embedded ones

          if (stores) {
            _this4.processSubStores(record, data, stores);
          }

          return data;
        });
      }
    }, {
      key: "prepareUpdated",
      value: function prepareUpdated(list, storeInfo) {
        var _this5 = this;

        var store = storeInfo.store,
            stores = storeInfo.stores,
            isTree = store.isTree,
            writeAllFields = storeInfo.writeAllFields || storeInfo.writeAllFields !== false && this.writeAllFields,
            phantomParentIdField = storeInfo.phantomParentIdField || this.phantomParentIdField; // TODO: root node included into store.modified
        // need to get rid of it since we don't persist it

        if (storeInfo.store.tree) {
          var rootNode = storeInfo.store.rootNode;
          list = list.filter(function (record) {
            return record !== rootNode;
          });
        }

        return list.filter(function (record) {
          return record.isValid;
        }).reduce(function (data, record) {
          var recordData; // write all fields

          if (writeAllFields) {
            recordData = record.persistableData;
          } else {
            recordData = record.modificationData; // TODO: PORT critical fields
            // critical fields should always be presented
            // const criticalFields = record.getCriticalFields();
            //
            // for (var j = 0; j < criticalFields.length; j++) {
            //     field = criticalFields[j];
            //
            //     if (field.serialize) {
            //         data[field.getName()] = field.serialize(record.get(field.getName()), record);
            //     } else {
            //         data[field.getName()] = record.get(field.getName());
            //     }
            // }
          }

          if (isTree) {
            var parent = record.parent;

            if (parent && !parent.isRoot && parent.isPhantom) {
              recordData[phantomParentIdField] = parent.id;
            }
          } // if the store has embedded ones


          if (stores) {
            _this5.processSubStores(record, recordData, stores);
          } // recordData can be null


          if (!_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].isEmpty(recordData)) {
            data.push(recordData);
          }

          return data;
        }, []);
      }
    }, {
      key: "prepareRemoved",
      value: function prepareRemoved(list) {
        return list.map(function (record) {
          var cls = record.constructor;
          return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].setPath({}, cls.getFieldDataSource(cls.idField), record.id);
        });
      }
    }, {
      key: "processSubStores",
      value: function processSubStores(record, data, stores) {
        var _this6 = this;

        stores.forEach(function (store) {
          var id = store.storeId,
              subStore = record.get(id); // if embedded store is assigned to the record

          if (subStore) {
            // let's collect its changes as well
            var changes = _this6.getCrudStoreChanges(Object.assign({
              store: subStore
            }, store));

            if (changes) {
              data[id] = Object.assign(changes, {
                $store: true
              });
            } else {
              delete data[id];
            }
          } else {
            delete data[id];
          }
        });
      }
    }, {
      key: "getCrudStoreChanges",
      value: function getCrudStoreChanges(storeDescriptor) {
        var store = storeDescriptor.store;
        var added = store.added.values,
            updated = store.modified.values,
            removed = store.removed.values,
            // sub-stores
        result;
        if (added.length) added = this.prepareAdded(added, storeDescriptor);
        if (updated.length) updated = this.prepareUpdated(updated, storeDescriptor);
        if (removed.length) removed = this.prepareRemoved(removed); // if this store has changes

        if (added.length || updated.length || removed.length) {
          result = {};
          if (added.length) result.added = added;
          if (updated.length) result.updated = updated;
          if (removed.length) result.removed = removed;
        }

        return result;
      }
    }, {
      key: "getChangeSetPackage",
      value: function getChangeSetPackage() {
        var _this7 = this;

        var pack = {
          type: 'sync',
          requestId: this.requestId,
          revision: this.crudRevision
        };
        var found = 0;
        this.crudStores.forEach(function (store) {
          var changes = _this7.getCrudStoreChanges(store);

          if (changes) {
            found++;
            pack[store.storeId] = changes;
          }
        });
        return found ? pack : null;
      } //endregion
      //region Apply

    }, {
      key: "applyChangesToRecord",
      value: function applyChangesToRecord(record, rawChanges, stores) {
        var me = this,
            modelClass = record.constructor,
            fieldDataSourceMap = modelClass.fieldDataSourceMap,
            recProto = modelClass.prototype,
            changes = {},
            data = record.data,
            done = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_34___default()({}, me.phantomIdField, true);

        var hasChanges; // if this store has sub-stores assigned to some fields

        if (stores) {
          // then first we apply changes to that stores
          stores.forEach(function (store) {
            var name = store.storeId;

            if (Object.prototype.hasOwnProperty.call(rawChanges, name)) {
              // remember that we processed this field
              done[name] = true;
              var subStore = record.get(name);

              if (subStore) {
                me.applyChangesToStore(Object.assign({
                  store: subStore
                }, store), rawChanges[name]);
              } else {
                console.log('Can\'t find store for the response sub-package');
              }
            }
          });
        }

        var rawChangesFiltered = {};

        for (var key in rawChanges) {
          if (Object.prototype.hasOwnProperty.call(rawChanges, key) && !done[key]) {
            rawChangesFiltered[key] = rawChanges[key];
          }
        }

        var rowChangesSimplePaths = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].pathifyKeys(rawChangesFiltered); // Collect the changes into a change set for field names.

        for (var dataSource in rowChangesSimplePaths) {
          var field = fieldDataSourceMap[dataSource],
              propName = field ? field.name : dataSource,
              value = modelClass.processField(propName, rowChangesSimplePaths[dataSource]),
              oldValue = dataSource in recProto ? record[propName] : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].getPath(data, dataSource);

          if (!((field === null || field === void 0 ? void 0 : field.isEqual) ? field.isEqual(oldValue, value) : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].isEqual(oldValue, value))) {
            hasChanges = true;
            changes[propName] = value;
          }
        }

        if (hasChanges) {
          me.suspendChangesTracking(); // Set each field separately until https://app.assembla.com/spaces/bryntum/tickets/9123 is fixed.

          for (var fieldName in changes) {
            record[fieldName] = changes[fieldName];
          } // TODO: Re-enable record.set when https://app.assembla.com/spaces/bryntum/tickets/9123 is fixed.
          // Set fields one go
          // record.set(changes);


          me.resumeChangesTracking(true);
        } // Clear changes only for the passed record,
        // not descendant nodes.
        // TODO: they *might* also be genuinely new
        // so might have to stay.


        record.clearChanges(true, false);
      }
    }, {
      key: "applyRemovals",
      value: function applyRemovals(store, removedEntries, context) {
        var _this8 = this;

        var removedStash = store.removed,
            modelClass = store.modelClass,
            findByIdFn = context.findByIdFn,
            removeRecordFn = context.removeRecordFn,
            dataSource = modelClass.getFieldDataSource(modelClass.idField);
        var applied = 0;
        removedEntries.forEach(function (removedEntry) {
          var id = removedEntry[dataSource];
          var done = false; // just remove the record from the removed stash

          if (removedStash.includes(id)) {
            removedStash.remove(id);
            done = true; // number of removals applied

            applied++;
          } // if responded removed record isn`t found in store.removed
          // probably don't removed on the client side yet (server driven removal)


          if (!done) {
            var record = findByIdFn(id);

            if (record) {
              _this8.suspendChangesTracking();

              removeRecordFn(record);
              removedStash.remove(record); // number of removals applied

              applied++;

              _this8.resumeChangesTracking(true);
            } else {
              console.log('Can\'t find record to remove from the response package');
            }
          }
        });
        return applied;
      }
    }, {
      key: "getApplyChangesToStoreHelpers",
      value: function getApplyChangesToStoreHelpers(store) {
        // if it's a tree store
        if (store.tree) {
          return {
            findByPhantomFn: function findByPhantomFn(id) {
              return store.getById(id);
            },
            findByIdFn: function findByIdFn(id) {
              return store.getById(id);
            },
            // TODO: need to support parentIdProperty
            addRecordFn: function addRecordFn(data) {
              var parent = data.parentId && store.getById(data.parentId) || store.rootNode;
              return parent.appendChild(data);
            },
            removeRecordFn: function removeRecordFn(record) {
              return record.remove();
            }
          }; // plain store
        } else {
          return {
            findByPhantomFn: function findByPhantomFn(id) {
              return store.getById(id);
            },
            findByIdFn: function findByIdFn(id) {
              return store.getById(id);
            },
            addRecordFn: function addRecordFn(data) {
              return store.add(data)[0];
            },
            removeRecordFn: function removeRecordFn(record) {
              return store.remove(record);
            }
          };
        }
      }
    }, {
      key: "applyChangesToStore",
      value: function applyChangesToStore(storeDesc, storeResponse) {
        var me = this,
            phantomIdField = storeDesc.phantomIdField || me.phantomIdField,
            store = storeDesc.store,
            modelClass = store.modelClass,
            idDataSource = modelClass.getFieldDataSource(modelClass.idField),
            _me$getApplyChangesTo = me.getApplyChangesToStoreHelpers(store),
            findByPhantomFn = _me$getApplyChangesTo.findByPhantomFn,
            findByIdFn = _me$getApplyChangesTo.findByIdFn,
            addRecordFn = _me$getApplyChangesTo.addRecordFn,
            removeRecordFn = _me$getApplyChangesTo.removeRecordFn,
            rows = storeResponse.rows,
            removed = storeResponse.removed; // process added/updated records


        if (rows) {
          // sub-stores
          var stores = storeDesc.stores;
          rows.forEach(function (data) {
            var phantomId = data[phantomIdField],
                id = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].getPath(data, idDataSource);
            var record = null; // if phantomId is provided then we will use it to find added record

            if (phantomId != null) {
              record = findByPhantomFn(phantomId);
            } // if id is provided then we will use it to find updated record
            else if (id != null) {
                record = findByIdFn(id);
              }

            if (record) {
              me.applyChangesToRecord(record, data, stores, store);
            } else {
              me.suspendChangesTracking(); // create new record in the store

              record = addRecordFn(data);
              me.resumeChangesTracking(true);
              record.clearChanges();
            }
          });
        } // process removed records


        if (removed && me.applyRemovals(store, removed, {
          findByIdFn: findByIdFn,
          removeRecordFn: removeRecordFn
        })) {
          store.trigger('dataChanged', {
            source: store
          });
        }
      }
    }, {
      key: "applySyncResponse",
      value: function applySyncResponse(response) {
        var me = this,
            stores = me.orderedCrudStores;
        me.applyingSyncResponse = true;

        var _iterator2 = _createForOfIteratorHelper(stores),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var store = _step2.value;
            var storeResponse = response[store.storeId];

            if (storeResponse) {
              me.applyChangesToStore(store, storeResponse);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        me.applyingSyncResponse = false;
      }
    }, {
      key: "applyLoadResponse",
      value: function applyLoadResponse(response, options) {
        this.applyingLoadResponse = true;
        this.loadCrudManagerData(response, options);
        this.applyingLoadResponse = false;
      }
    }, {
      key: "applyResponse",
      value: function () {
        var _applyResponse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee6(requestType, response, options) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  // in trackResponseType we check response type before deciding how to react on the response
                  if (this.trackResponseType) {
                    requestType = response.type || requestType;
                  }

                  _context6.t0 = requestType;
                  _context6.next = _context6.t0 === 'load' ? 4 : _context6.t0 === 'sync' ? 6 : 8;
                  break;

                case 4:
                  this.applyLoadResponse(response, options);
                  return _context6.abrupt("break", 8);

                case 6:
                  this.applySyncResponse(response);
                  return _context6.abrupt("break", 8);

                case 8:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function applyResponse(_x14, _x15, _x16) {
          return _applyResponse.apply(this, arguments);
        }

        return applyResponse;
      }() //endregion

      /**
       * Generates unique request identifier.
       * @internal
       * @template
       * @return {Number} The request identifier.
       */

    }, {
      key: "sync",

      /**
       * Persists changes made on the registered stores to the server. Usage:
       *
       * ```javascript
       * // persist and run a callback on request completion
       * crud.sync().then(
       *     () => console.log("Changes saved..."),
       *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
       * );
       * ```
       *
       * ** Note: ** If there is an incomplete sync request in progress then system will queue the call and delay it until previous request completion.
       * In this case {@link #event-syncDelayed} event will be fired.
       *
       * ** Note: ** Please take a look at {@link #config-autoSync} config. This option allows to persist changes automatically after any data modification.
       * @returns {Promise} Promise, which is resolved if request was successful.
       * Both the resolve and reject functions are passed a `state` object. State object has following structure:
       *
       *     {
       *         cancelled       : Boolean, // **optional** flag, which is present when promise was rejected
       *         rawResponse     : String,  // raw response from ajax request, either response xml or text
       *         rawResponseText : String,  // raw response text as String from ajax request
       *         response        : Object,  // processed response in form of object
       *     }
       *
       * If promise was rejected by {@link #event-beforeSync} event, `state` object will have structure:
       *
       *     {
       *         cancelled : true
       *     }
       *
       */
      value: function sync() {
        var _this9 = this;

        var me = this;

        if (me.activeRequests.sync) {
          // let's delay this call and start it only after server response

          /**
           * Fires after {@link #function-sync sync request} was delayed due to incomplete previous one.
           * @event syncDelayed
           * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
           * @param {Object} arguments The arguments of {@link #function-sync} call.
           */
          me.trigger('syncDelayed'); // Queue sync request after current one

          return me.activeSyncPromise = me.activeSyncPromise.finally(function () {
            return me.sync();
          });
        } // Store current request promise. While this one is pending, all following sync requests will create chain
        // of sequential promises


        return me.activeSyncPromise = new Promise(function (resolve, reject) {
          // get current changes set package
          var pack = me.getChangeSetPackage(); // if no data to persist we resolve immediately

          if (!pack) {
            resolve(null);
            return;
          }
          /**
           * Fires before {@link #function-sync sync request} is sent. Return `false` to cancel sync request.
           *
           * ```javascript
           *     crudManager.on('beforesync', function() {
           *        // cannot persist changes before at least one record is added
           *        // to the `someStore` store
           *        if (!someStore.getCount()) return false;
           *     });
           * ```
           * @event beforeSync
           * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
           * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
           */


          if (me.trigger('beforeSync', {
            pack: pack
          }) !== false) {
            me.trigger('syncStart', {
              pack: pack
            }); // keep active request details

            me.activeRequests.sync = {
              pack: pack,
              resolve: resolve,
              reject: reject,
              id: pack.requestId,
              desc: me.sendRequest({
                data: me.encode(pack),
                type: 'sync',
                success: me.onSyncSuccess,
                failure: me.onSyncFailure,
                thisObj: me
              })
            };
          } else {
            // if this sync was canceled let's fire event about it

            /**
             * Fires after {@link #function-sync sync request} was canceled by some {@link #event-beforeSync} listener.
             * @event syncCanceled
             * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
             * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
             */
            me.trigger('syncCanceled', {
              pack: pack
            });

            _this9.processPromise(reject, null, {
              action: 'sync',
              cancelled: true
            });
          }
        }).catch(function (error) {
          // If the request was not cancelled in beforeSync listener, forward the error so the user's `catch` handler can catch it
          if (error && !error.cancelled) {
            throw error;
          } // Pass the error object as a param to the next `then` chain


          return error;
        });
      }
    }, {
      key: "onSyncSuccess",
      value: function () {
        var _onSyncSuccess = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee7(rawResponse, fetchOptions) {
          var responseText, request, response;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!this.isDestroyed) {
                    _context7.next = 2;
                    break;
                  }

                  return _context7.abrupt("return");

                case 2:
                  responseText = '';
                  _context7.next = 5;
                  return rawResponse.text().then(function (value) {
                    return responseText = value;
                  }).catch(nullFn);

                case 5:
                  if (!this.isDestroyed) {
                    _context7.next = 7;
                    break;
                  }

                  return _context7.abrupt("return");

                case 7:
                  request = this.activeRequests.sync;
                  _context7.next = 10;
                  return this.internalOnSync(responseText, fetchOptions);

                case 10:
                  response = _context7.sent;

                  if (!this.isDestroyed) {
                    _context7.next = 13;
                    break;
                  }

                  return _context7.abrupt("return");

                case 13:
                  if (response === null || response === void 0 ? void 0 : response.success) {
                    request.resolve({
                      response: response,
                      rawResponse: rawResponse,
                      responseText: responseText,
                      request: request
                    });
                  } else {
                    this.processPromise(request.reject, request.resolve, {
                      action: 'sync',
                      cancelled: false,
                      response: response,
                      rawResponse: rawResponse,
                      responseText: responseText,
                      request: request
                    });
                  }

                case 14:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function onSyncSuccess(_x17, _x18) {
          return _onSyncSuccess.apply(this, arguments);
        }

        return onSyncSuccess;
      }()
    }, {
      key: "onSyncFailure",
      value: function () {
        var _onSyncFailure = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee8(rawResponse) {
          var _fetchOptions$abortCo2;

          var fetchOptions,
              request,
              options,
              signal,
              wasAborted,
              responseText,
              response,
              _args8 = arguments;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  fetchOptions = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};

                  if (!this.isDestroyed) {
                    _context8.next = 3;
                    break;
                  }

                  return _context8.abrupt("return");

                case 3:
                  request = this.activeRequests.sync, options = request.options, signal = (_fetchOptions$abortCo2 = fetchOptions.abortController) === null || _fetchOptions$abortCo2 === void 0 ? void 0 : _fetchOptions$abortCo2.signal, wasAborted = Boolean(signal === null || signal === void 0 ? void 0 : signal.aborted);

                  if (wasAborted) {
                    _context8.next = 17;
                    break;
                  }

                  responseText = '';

                  if (!rawResponse) {
                    _context8.next = 9;
                    break;
                  }

                  _context8.next = 9;
                  return rawResponse.text().then(function (value) {
                    return responseText = value;
                  }).catch(nullFn);

                case 9:
                  if (!this.isDestroyed) {
                    _context8.next = 11;
                    break;
                  }

                  return _context8.abrupt("return");

                case 11:
                  _context8.next = 13;
                  return this.internalOnSync(responseText, fetchOptions, options);

                case 13:
                  response = _context8.sent;

                  if (!this.isDestroyed) {
                    _context8.next = 16;
                    break;
                  }

                  return _context8.abrupt("return");

                case 16:
                  this.processPromise(request.reject, null, {
                    action: 'sync',
                    cancelled: wasAborted,
                    response: response,
                    rawResponse: rawResponse,
                    responseText: responseText,
                    options: options,
                    request: request
                  });

                case 17:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function onSyncFailure(_x19) {
          return _onSyncFailure.apply(this, arguments);
        }

        return onSyncFailure;
      }()
      /**
       * Commits all records changes of all the registered stores.
       */

    }, {
      key: "commitCrudStores",
      value: function commitCrudStores() {
        this.crudStores.forEach(function (store) {
          return store.store.commit();
        });
      }
      /**
       * Rejects all records changes on all stores and re-insert any records that were removed locally. Any phantom records will be removed.
       */

    }, {
      key: "rejectCrudStores",
      value: function rejectCrudStores() {
        this.orderedCrudStores.forEach(function (store) {
          return store.store.clearChanges();
        });
      }
      /**
       * Removes all stores and cancels active requests.
       */

    }, {
      key: "doDestroy",
      value: function doDestroy() {
        var me = this,
            _me$activeRequests = me.activeRequests,
            load = _me$activeRequests.load,
            sync = _me$activeRequests.sync;
        load && me.cancelRequest(load.desc, load.reject);
        sync && me.cancelRequest(sync.desc, sync.reject);

        while (me.crudStores.length > 0) {
          me.removeCrudStore(me.crudStores[0]);
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_42___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(AbstractCrudManagerMixin.prototype), "doDestroy", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_42___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_45___default()(AbstractCrudManagerMixin.prototype), "doDestroy", this).call(this);
      } // set crudRevision(value) {
      //     debugger
      //     this._crudRevision = value;
      // }
      // get crudRevision() {
      //     return this._crudRevision;
      // }

      /**
       * Check if response is valid
       * @param {Response} rawResponse raw
       * @param {Object} response parsed response
       * @return {Boolean} truthy when response is `ok` or `status` is 500 or 404 and it is successfully parsed
       * @private
       */

    }, {
      key: "isValidResponse",
      value: function isValidResponse(rawResponse, response) {
        return rawResponse && (rawResponse.ok && response || [500, 404].includes(rawResponse.status));
      }
    }, {
      key: "processPromise",
      value: function processPromise(reject, resolve, context) {
        var cancelled = context.cancelled,
            action = context.action,
            rawResponse = context.rawResponse,
            response = context.response; // Call `resolve()` instead of `reject()` for valid response. These errors are notified by API events

        if (resolve && this.isValidResponse(rawResponse, response)) {
          resolve(context);
        } else {
          var message = "".concat(_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"].capitalize(action), " ").concat(cancelled ? 'canceled' : 'failed'),
              error = new Error(message);
          Object.assign(error, context);
          reject(error);
        }
      }
    }, {
      key: "isCrudManager",
      get: function get() {
        return true;
      }
    }, {
      key: "crudStores",
      set: function set(stores) {
        this._crudStores = [];
        this.addCrudStore(stores); // Ensure preconfigured stores stay stable at the start of the array when
        // addPrioritizedStore attempts to insert in order. Only featured gantt/scheduler stores
        // must participate in the ordering. If they were configured in, they must not move.

        var _iterator3 = _createForOfIteratorHelper(this._crudStores),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var store = _step3.value;
            store.loadPriority = store.syncPriority = 0;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      },
      get: function get() {
        return this._crudStores;
      }
    }, {
      key: "orderedCrudStores",
      get: function get() {
        return this._orderedCrudStores;
      },
      set: function set(stores) {
        return this._orderedCrudStores = stores;
      }
    }, {
      key: "syncApplySequence",
      set: function set(stores) {
        this._syncApplySequence = [];
        this.addStoreToApplySequence(stores);
      },
      get: function get() {
        return this._syncApplySequence;
      }
    }, {
      key: "isBatchingChanges",
      get: function get() {
        return this.crudIgnoreUpdates > 0;
      }
    }, {
      key: "isCrudManagerLoading",
      get: function get() {
        return Boolean(this.activeRequests.load || this.applyingLoadResponse);
      }
    }, {
      key: "isCrudManagerSyncing",
      get: function get() {
        return Boolean(this.activeRequests.sync || this.applyingSyncResponse);
      }
    }, {
      key: "isLoadingOrSyncing",
      get: function get() {
        return Boolean(this.activeRequests.load || this.activeRequests.sync);
      }
    }, {
      key: "requestId",
      get: function get() {
        return Number.parseInt("".concat(Date.now()).concat(this._requestId++));
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'AbstractCrudManagerMixin';
      } //region Default config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          // overrideCrudStoreLoad : false,

          /**
           * The server revision stamp.
           * The _revision stamp_ is a number which should be incremented after each server-side change.
           * This property reflects the current version of the data retrieved from the server and gets updated after each {@link #function-load} and {@link #function-sync} call.
           * @property {Number}
           * @readonly
           */
          crudRevision: null,

          /**
           * A list of registered stores whose server communication will be collected into a single batch.
           * Each store is represented by a _store descriptor_, an object having following structure:
           * @member {Object[]} crudStores
           * @property {String} crudStores.storeId Unique store identifier.
           * @property {Core.data.Store} crudStores.store Store itself.
           * @property {String} [crudStores.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
           * @property {String} [crudStores.idField] id field name, if it's not specified then class will try to get it from a store model.
           */

          /**
           * Sets the list of stores controlled by the CRUD manager.
           * Store can be provided by itself, its storeId or an object having the following structure:
           * @property {String} stores.storeId Unique store identifier. Under this name the store related requests/responses will be sent.
           * @property {Core.data.Store} stores.store The store itself.
           * @property {String} [stores.phantomIdField] Set this if the store model has a predefined field to keep phantom record identifier.
           * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
           * @config {Core.data.Store[]|String[]|Object[]}
           */
          crudStores: [],

          /**
           * Name of a store property to retrieve store identifiers from.
           * Store identifier is used as a container name holding corresponding store data while transferring them to/from the server.
           * By default `storeId` property is used. And in case a container identifier has to differ this config can be used:
           *
           * ```javascript
           * class CatStore extends Store {
           *     // storeId is "meow" but for sending/receiving store data
           *     // we want have "cats" container in JSON, so we create a new property "storeIdForCrud"
           *     storeId          : 'meow',
           *     storeIdForCrud   : 'cats'
           * });
           *
           * class MyCrudManager extends CrudManager {
           *     ...
           *     crudStores           : ['meow'],
           *     // crud manager will get store identifier from "storeIdForCrud" property
           *     storeIdProperty  : 'storeIdForCrud'
           * });
           * ```
           * The `storeIdProperty` property can also be specified directly on a store:
           *
           * ```javascript
           * class CatStore extends Store {
           *     // storeId is "meow" but for sending/receiving store data
           *     // we want have "cats" container in JSON
           *     storeId          : 'meow',
           *     // so we create a new property "storeIdForCrud"..
           *     storeIdForCrud  : 'cats',
           *     // and point CrudManager to use it as the store identifier source
           *     storeIdProperty  : 'storeIdForCrud'
           * });
           *
           * class DogStore extends Store {
           *     // storeId is "dogs" and it will be used as a container name for the store data
           *     storeId          : 'dogs'
           * });
           *
           * class MyCrudManager extends CrudManager {
           *     ...
           *     crudStores           : ['meow', 'dogs']
           * });
           * ```
           * @config {String}
           */
          storeIdProperty: 'storeId',
          // TODO: no support for remote filtering yet
          // /**
          //  * The name of the 'filter' parameter to send in a load request.
          //  * @config {String}
          //  * @default
          //  */
          crudFilterParam: 'filter',

          /**
           * Sends request to the server.
           * @function sendRequest
           * @param {Object} request The request to send. An object having following properties:
           * @param {String} request.data {@link #function-encode Encoded} request.
           * @param {String} request.type Request type, can be either `load` or `sync`
           * @param {Function} request.success Callback to be started on successful request transferring
           * @param {Function} request.failure Callback to be started on request transfer failure
           * @param {Object} request.thisObj `this` reference for the above `success` and `failure` callbacks
           * @return {Promise} The request promise.
           * @abstract
           */

          /**
           * Cancels request to the server.
           * @function cancelRequest
           * @param {Promise} promise The request promise to cancel (a value returned by corresponding {@link #function-sendRequest} call).
           * @param {Function} reject Reject handle of the corresponding promise
           * @abstract
           */

          /**
           * Encodes request to the server.
           * @function encode
           * @param {Object} request The request to encode.
           * @returns {String} The encoded request.
           * @abstract
           */

          /**
           * Decodes response from the server.
           * @function decode
           * @param {String} response The response to decode.
           * @returns {Object} The decoded response.
           * @abstract
           */
          transport: {},

          /**
           * When `true` forces the CRUD manager to process responses depending on their `type` attribute.
           * So `load` request may be responded with `sync` response for example.
           * Can be used for smart server logic allowing the server to decide when it's better to respond with a complete data set (`load` response)
           * or it's enough to return just a delta (`sync` response).
           * @config {Boolean}
           * @default
           */
          trackResponseType: false,

          /**
           * Field name to be used to transfer a phantom record identifier.
           * @config {String}
           * @default
           */
          phantomIdField: '$PhantomId',

          /**
           * Field name to be used to transfer a phantom parent record identifier.
           * @config {String}
           * @default
           */
          phantomParentIdField: '$PhantomParentId',

          /**
           * `true` to automatically call {@link #function-load} method after creation.
           * @config {Boolean}
           * @default
           */
          autoLoad: false,

          /**
           * The timeout in milliseconds to wait before persisting changes to the server.
           * Used when {@link #config-autoSync} is set to `true`.
           * @config {Number}
           * @default
           */
          autoSyncTimeout: 100,

          /**
           * `true` to automatically persist store changes after edits are made in any of the stores monitored.
           * Please note that sync request will not be invoked immediately but only after {@link #config-autoSyncTimeout} interval.
           * @config {Boolean}
           * @default
           */
          autoSync: false,

          /**
           * `True` to reset identifiers (defined by `idField` config) of phantom records before submitting them to the server.
           * @config {Boolean}
           * @default
           */
          resetIdsBeforeSync: true,

          /**
           * @member {Object[]} syncApplySequence
           * An array of stores presenting an alternative sync responses apply order.
           * Each store is represented by a _store descriptor_, an object having following structure:
           * @property {String} syncApplySequence.storeId Unique store identifier.
           * @property {Core.data.Store} syncApplySequence.store Store itself.
           * @property {String} [syncApplySequence.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
           * @property {String} [syncApplySequence.idField] id field name, if it's not specified then class will try to get it from a store model.
           */

          /**
           * An array of store identifiers sets an alternative sync responses apply order.
           * By default the order in which sync responses are applied to the stores is the same as they registered in.
           * But in case of some tricky dependencies between stores this order can be changed:
           *
           *```javascript
          * class MyCrudManager extends CrudManager {
          *     // register stores (they will be loaded in the same order: 'store1' then 'store2' and finally 'store3')
          *     crudStores : ['store1', 'store2', 'store3'],
          *     // but we apply changes from server to them in an opposite order
          *     syncApplySequence : ['store3', 'store2', 'store1']
          * });
          *```
          * @config {String[]}
          */
          syncApplySequence: [],
          orderedCrudStores: [],

          /**
           * true to write all fields from the record to the server. If set to false it will only send the fields that
           * were modified. Note that any fields that have `persist` set to false will still be ignored while those
           * with `critical` set to true will be included.
           * @config {Boolean}
           * @default
           */
          writeAllFields: false,
          crudIgnoreUpdates: 0,
          autoSyncSuspendCounter: 0,
          // Flag that shows if crud manager performed successful load request
          crudLoaded: false,
          createMissingRecords: false,
          autoSyncTimerId: null,
          applyingLoadResponse: false,
          applyingSyncResponse: false,
          callOnFunctions: true
        };
      }
    }]);

    return AbstractCrudManagerMixin;
  }((_ref = Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_52__["default"]).mixin.apply(_ref, mixins));
});

/***/ }),

/***/ "./lib/Scheduler/crud/encoder/JsonEncoder.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/crud/encoder/JsonEncoder.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/crud/encoder/JsonEncoder
 */

/**
 * Implements data encoding functional that should be mixed to a {@link Scheduler.crud.AbstractCrudManager} sub-class.
 * Uses _JSON_ as an encoding system.
 *
 * @example
 * // create a new CrudManager using AJAX as a transport system and JSON for encoding
 * class MyCrudManager extends JsonEncode(AjaxTransport(AbstractCrudManager)) {}
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(JsonEncoder, _ref);

    var _super = _createSuper(JsonEncoder);

    function JsonEncoder() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, JsonEncoder);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(JsonEncoder, [{
      key: "encode",
      //format  : 'json',

      /**
       * Encodes a request object to _JSON_ encoded string. If encoding fails (due to circular structure), it returns null.
       * Supposed to be overridden in case data provided by the CRUD manager has to be transformed into format requested by server.
       * @param {Object} request The request to encode.
       * @returns {String} The encoded request.
       */
      value: function encode(requestConfig) {
        return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].safeJsonStringify(requestConfig);
      }
      /**
       * Decodes (parses) a _JSON_ response string to an object. If parsing fails, it returns null.
       * Supposed to be overridden in case data provided by server has to be transformed into format requested by the CRUD manager.
       * @param {String} responseText The response text to decode.
       * @returns {Object} The decoded response.
       */

    }, {
      key: "decode",
      value: function decode(responseText) {
        return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].safeJsonParse(responseText);
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'JsonEncoder';
      }
    }]);

    return JsonEncoder;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/crud/mixin/CrudManagerView.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/crud/mixin/CrudManagerView.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/* eslint-disable no-unused-expressions */

/**
 * @module Scheduler/crud/mixin/CrudManagerView
 */


/**
 * This mixin class adds Crud Manager functionality to the class it is mixed in to.
 *
 * The class mixing it in should draw its `eventStore` from the instantiated CrudManager's eventStore.
 *
 * It adds {@link #config-crudManager} config allowing to provide a Crud Manager either as a class instance or as a configuration object
 * (for later the mixin provides {@link #config-crudManagerClass} config defining which class should be instantiated).
 *
 * The mixin also tracks Crud Manager requests to the server and masks the view during them. For masking it
 * uses the grid {@link Grid.view.GridBase#config-loadMask} and {@link Grid.view.GridBase#config-syncMask} properties.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(CrudManagerView, _Target);

    var _super = _createSuper(CrudManagerView);

    function CrudManagerView() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, CrudManagerView);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(CrudManagerView, [{
      key: "afterConstruct",
      //endregion

      /**
       * Get/set the CrudManager instance
       * @member {Scheduler.data.CrudManager} crudManager
       * @category Data
       */
      //region Init
      value: function afterConstruct() {
        var me = this,
            crudManager = me.crudManager;

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(CrudManagerView.prototype), "afterConstruct", this).call(this);

        if (crudManager && me.loadMask && crudManager.isCrudManagerLoading) {
          // Show loadMask if crud manager is already loading
          me.onCrudManagerLoadStart();
        }
      } //endregion

      /**
       * Hooks up crud manager listeners
       * @private
       * @category Store
       */

    }, {
      key: "bindCrudManager",
      value: function bindCrudManager(crudManager) {
        this.detachListeners('crudManager');
        crudManager === null || crudManager === void 0 ? void 0 : crudManager.on({
          name: 'crudManager',
          loadStart: 'onCrudManagerLoadStart',
          load: 'onCrudManagerLoad',
          loadCanceled: 'onCrudManagerLoadCanceled',
          syncStart: 'onCrudManagerSyncStart',
          sync: 'onCrudManagerSync',
          syncCanceled: 'onCrudManagerSyncCanceled',
          requestFail: 'onCrudManagerRequestFail',
          thisObj: this
        });
      }
    }, {
      key: "onCrudManagerLoadStart",
      value: function onCrudManagerLoadStart() {
        // Show loadMask before crud manager starts loading
        var me = this,
            loadMask = me.loadMask;

        if (loadMask) {
          me.masked = _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_11__["default"].mergeConfigs(me.loadMaskDefaults, loadMask);
        }

        me.toggleEmptyText();
      }
    }, {
      key: "onCrudManagerSyncStart",
      value: function onCrudManagerSyncStart() {
        var me = this,
            syncMask = me.syncMask;

        if (syncMask) {
          me.masked = _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_11__["default"].mergeConfigs(me.loadMaskDefaults, syncMask);
        }
      }
    }, {
      key: "onCrudManagerRequestFinalize",
      value: function onCrudManagerRequestFinalize() {
        var successful = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var requestType = arguments.length > 1 ? arguments[1] : undefined;
        var response = arguments.length > 2 ? arguments[2] : undefined;
        var me = this;

        if (successful) {
          me.masked = null;
          me.toggleEmptyText();
        } else {
          // Do not remove. Assertion strings for Localization sanity check.
          // 'L{GridBase.loadFailedMessage}'
          // 'L{GridBase.syncFailedMessage}'
          var messageHTML = "<div class=\"b-grid-load-failure\">\n                <div class=\"b-grid-load-fail\">".concat(me.L("L{GridBase.".concat(requestType, "FailedMessage}")), "</div>\n                ").concat(response && response.message ? "<div class=\"b-grid-load-fail\">".concat(me.L('L{CrudManagerView.serverResponseLabel}'), " ").concat(response.message, "</div>") : '', "\n            </div>");
          me.masked = _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_11__["default"].mergeConfigs(me.loadMaskDefaults, me.loadMaskError, messageHTML);
        }
      }
    }, {
      key: "onCrudManagerLoadCanceled",
      value: function onCrudManagerLoadCanceled() {
        this.onCrudManagerRequestFinalize();
      }
    }, {
      key: "onCrudManagerSyncCanceled",
      value: function onCrudManagerSyncCanceled() {
        this.onCrudManagerRequestFinalize();
      }
    }, {
      key: "onCrudManagerLoad",
      value: function onCrudManagerLoad() {
        this.onCrudManagerRequestFinalize();
      }
    }, {
      key: "onCrudManagerSync",
      value: function onCrudManagerSync() {
        this.onCrudManagerRequestFinalize();
      }
    }, {
      key: "onCrudManagerRequestFail",
      value: function onCrudManagerRequestFail(_ref) {
        var requestType = _ref.requestType,
            response = _ref.response;
        this.onCrudManagerRequestFinalize(false, requestType, response);
      }
    }, {
      key: "changeCrudManager",
      value: function changeCrudManager(crudManager) {
        if (crudManager && !crudManager.isCrudManager) {
          // CrudManager injects itself into is Scheduler's _crudManager property
          // because code it triggers needs to access it through its getter.
          crudManager = new this.crudManagerClass(Object.assign({
            scheduler: this
          }, crudManager));
        } // config setter will veto because of above described behaviour
        // of setting the property early on creation


        this._crudManager = crudManager;
        this.bindCrudManager(crudManager);
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      //region Config
      get: function get() {
        return 'CrudManagerView';
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * Class that should be used to instantiate a CrudManager in case it's provided as a simple object to
           * {@link #config-crudManager} config.
           * @config {Scheduler.crud.AbstractCrudManagerMixin}
           * @category Data
           */
          crudManagerClass: null,

          /**
           * Supply a {@link Scheduler.data.CrudManager CrudManager} instance or a config object if you want to use
           * CrudManager for handling data.
           * @config {Object|Scheduler.crud.AbstractCrudManagerMixin}
           * @category Data
           */
          crudManager: null
        };
      }
    }]);

    return CrudManagerView;
  }(Target);
});

/***/ }),

/***/ "./lib/Scheduler/crud/transport/AjaxTransport.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/crud/transport/AjaxTransport.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/crud/transport/AjaxTransport
 */

/**
 * Implements data transferring functional that can be used for {@link Scheduler.crud.AbstractCrudManager} super classing.
 * Uses the fetch API for transport, https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 *
 * @example
 * // create a new CrudManager using AJAX as a transport system and JSON for encoding
 * class MyCrudManager extends AjaxTransport(JsonEncode(AbstractCrudManager)) {}
 *
 * @abstract
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(AjaxTransport, _ref);

    var _super = _createSuper(AjaxTransport);

    function AjaxTransport() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, AjaxTransport);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(AjaxTransport, [{
      key: "cancelRequest",

      /**
       * Cancels a sent request.
       * @param {Promise} requestPromise The Promise object wrapping the Request to be cancelled.
       * The _requestPromise_ is the value returned from the corresponding {@link #function-sendRequest} call.
       * @param {Function} reject The reject handle of the requestPromise
       */
      value: function cancelRequest(requestPromise, reject) {
        reject();
      }
    }, {
      key: "shouldUseBodyForRequestData",
      value: function shouldUseBodyForRequestData(packCfg, method, paramName) {
        return !(method === 'HEAD' || method === 'GET') && !paramName;
      }
      /**
       * Sends a __Crud Manager__ request to the server.
       * @param {Object}   request The request configuration object having following properties:
       * @param {String}   request.type The request type. Either `load` or `sync`.
       * @param {String}   request.data The encoded __Crud Manager__ request data.
       * @param {Object}   request.params An object specifying extra HTTP params to send with the request.
       * @param {Function} request.success A function to be started on successful request transferring.
       * @param {String}   request.success.rawResponse `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
       * @param {Function} request.failure A function to be started on request transfer failure.
       * @param {String}   request.failure.rawResponse `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
       * @param {Object}   request.thisObj `this` reference for the above `success` and `failure` functions.
       * @return {Promise} The fetch Promise object.
       * @fires beforesend
       */

    }, {
      key: "sendRequest",
      value: function sendRequest(request) {
        var me = this,
            data = request.data,
            transportConfig = me.transport[request.type] || {},
            requestConfig = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_14__["default"].assign({}, transportConfig, transportConfig.requestConfig);
        requestConfig.method = requestConfig.method || AjaxTransport.defaultMethod[request.type];
        requestConfig.params = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_14__["default"].assign(requestConfig.params || {}, request.params);
        var paramName = requestConfig.paramName; // transfer package in the request body for some types of HTTP requests

        if (me.shouldUseBodyForRequestData(transportConfig, requestConfig.method, paramName)) {
          requestConfig.body = data; // for requests having body we set Content-Type to 'application/json' by default

          requestConfig.headers = requestConfig.headers || {};
          requestConfig.headers['Content-Type'] = requestConfig.headers['Content-Type'] || 'application/json';
        } else {
          // when we don't use body paramName is mandatory so fallback to 'data' as name
          paramName = paramName || 'data';
          requestConfig.params[paramName] = data;
        }

        if (!requestConfig.url) {
          throw new Error('Trying to request without URL specified');
        } // sanitize request config


        delete requestConfig.requestConfig;
        delete requestConfig.paramName;
        /**
         * Fires before a request is sent to the server.
         *
         * ```javascript
         * crudManager.on('beforeSend', function ({ params, type }) {
         *     // let's set "sync" request parameters
         *     if (type == 'sync') {
         *         // dynamically depending on "flag" value
         *         if (flag) {
         *             params.foo = 'bar';
         *         }
         *         else {
         *             params.foo = 'smth';
         *         }
         *     }
         * });
         * ```
         * @event beforeSend
         * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
         * @param {Object} params HTTP request params to be passed in the request URL.
         * @param {String} type CrudManager request type (`load`/`sync`)
         * @param {Object} requestConfig Configuration object for Ajax request call
         */

        me.trigger('beforeSend', {
          params: requestConfig.params,
          type: request.type,
          requestConfig: requestConfig,
          config: request
        }); // AjaxHelper.fetch call it "queryParams"

        requestConfig.queryParams = requestConfig.params;
        delete requestConfig.params;
        var responsePromise;
        var fetchOptions = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_14__["default"].assign({}, requestConfig, requestConfig.fetchOptions),
            ajaxPromise = _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].fetch(requestConfig.url, fetchOptions);
        ajaxPromise.catch(function (error) {
          var signal = fetchOptions.abortController && fetchOptions.abortController.signal;

          if (signal && !signal.aborted) {
            console.warn(error);
          }
        }).then(function (response) {
          if (response && response.ok) {
            var _request$success;

            responsePromise = (_request$success = request.success) === null || _request$success === void 0 ? void 0 : _request$success.call(request.thisObj || me, response, fetchOptions);
          } else {
            var _request$failure;

            responsePromise = (_request$failure = request.failure) === null || _request$failure === void 0 ? void 0 : _request$failure.call(request.thisObj || me, response, fetchOptions);
          }
        });
        return Promise.all([ajaxPromise, responsePromise]);
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'AjaxTransport';
      }
      /**
       * Configuration of the AJAX requests used by __Crud Manager__ to communicate with a server-side.
       *
       * ```javascript
       * transport : {
       *     load : {
       *         url       : 'http://mycool-server.com/load.php',
       *         // HTTP request parameter used to pass serialized "load"-requests
       *         paramName : 'data',
       *         // pass extra HTTP request parameter
       *         params    : {
       *             foo : 'bar'
       *         }
       *     },
       *     sync : {
       *         url     : 'http://mycool-server.com/sync.php',
       *         // specify Content-Type for requests
       *         headers : {
       *             'Content-Type' : 'application/json'
       *         }
       *     }
       * }
       *```
       * Since the class uses Fetch API you can use
       * any its [Request interface](https://developer.mozilla.org/en-US/docs/Web/API/Request) options:
       *
       * ```javascript
       * transport : {
       *     load : {
       *         url         : 'http://mycool-server.com/load.php',
       *         // HTTP request parameter used to pass serialized "load"-requests
       *         paramName   : 'data',
       *         // pass few Fetch API options
       *         method      : 'GET',
       *         credentials : 'include',
       *         cache       : 'no-cache'
       *     },
       *     sync : {
       *         url         : 'http://mycool-server.com/sync.php',
       *         // specify Content-Type for requests
       *         headers     : {
       *             'Content-Type' : 'application/json'
       *         },
       *         credentials : 'include'
       *     }
       * }
       *```
       *
       * An object where you can set the following possible properties:
       * @config {Object} transport
       * @property {Object} transport.load Load requests configuration:
       * @property {String} transport.load.url URL to request for data loading.
       * @property {String} [transport.load.method='GET'] HTTP method to be used for load requests.
       * @property {String} [transport.load.paramName='data'] Name of the parameter that will contain a serialized `load` request.
       * The value is mandatory for requests using `GET` method (default for `load`) so if the value is not provided `data` string is used as default.
       * This value is optional for HTTP methods like `POST` and `PUT`, the request body will be used for data transferring in these cases.
       * @property {Object} [transport.load.params] An object containing extra HTTP parameters to pass to the server when sending a `load` request.
       *
       * ```javascript
       * transport : {
       *     load : {
       *         url       : 'http://mycool-server.com/load.php',
       *         // HTTP request parameter used to pass serialized "load"-requests
       *         paramName : 'data',
       *         // pass extra HTTP request parameter
       *         // so resulting URL will look like: http://mycool-server.com/load.php?userId=123456&data=...
       *         params    : {
       *             userId : '123456'
       *         }
       *     },
       *     ...
       * }
       * ```
       * @property {Object} [transport.load.headers] An object containing headers to pass to each server request.
       *
       * ```javascript
       * transport : {
       *     load : {
       *         url       : 'http://mycool-server.com/load.php',
       *         // HTTP request parameter used to pass serialized "load"-requests
       *         paramName : 'data',
       *         // specify Content-Type for "load" requests
       *         headers   : {
       *             'Content-Type' : 'application/json'
       *         }
       *     },
       *     ...
       * }
       * ```
       * @property {Object} [transport.load.fetchOptions] **DEPRECATED:** Any Fetch API options can be simply defined on the upper configuration level:
       * ```javascript
       * transport : {
       *     load : {
       *         url          : 'http://mycool-server.com/load.php',
       *         // HTTP request parameter used to pass serialized "load"-requests
       *         paramName    : 'data',
       *         // Fetch API options
       *         method       : 'GET',
       *         credentials  : 'include'
       *     },
       *     ...
       * }
       * ```
       * @property {Object} [transport.load.requestConfig] **DEPRECATED:** The config options can be defined on the upper configuration level.
       * @property {Object} transport.sync Sync requests (`sync` in further text) configuration:
       * @property {String} transport.sync.url URL to request for `sync`.
       * @property {String} [transport.sync.method='POST'] HTTP request method to be used for `sync`.
       * @property {String} [transport.sync.paramName=undefined] Name of the parameter in which `sync` data will be transferred.
       * This value is optional for requests using methods like `POST` and `PUT`, the request body will be used for data transferring in this case (default for `sync`).
       * And the value is mandatory for requests using `GET` method (if the value is not provided `data` string will be used as fallback).
       * @property {Object} [transport.sync.params] HTTP headers to pass with an HTTP request handling `sync`.
       *
       * ```javascript
       * transport : {
       *     sync : {
       *         url    : 'http://mycool-server.com/sync.php',
       *         // extra HTTP request parameter
       *         params : {
       *             userId : '123456'
       *         }
       *     },
       *     ...
       * }
       * ```
       * @property {Object} [transport.sync.headers] HTTP headers to pass with an HTTP request handling `sync`.
       *
       * ```javascript
       * transport : {
       *     sync : {
       *         url     : 'http://mycool-server.com/sync.php',
       *         // specify Content-Type for "sync" requests
       *         headers : {
       *             'Content-Type' : 'application/json'
       *         }
       *     },
       *     ...
       * }
       * ```
       * @property {Object} [transport.sync.fetchOptions] **DEPRECATED:** Any Fetch API options can be simply defined on the upper configuration level:
       * ```javascript
       * transport : {
       *     sync : {
       *         url         : 'http://mycool-server.com/sync.php',
       *         credentials : 'include'
       *     },
       *     ...
       * }
       * ```
       * @property {Object} [transport.sync.requestConfig] **DEPRECATED:** The config options can be defined on the upper configuration level.
       */

    }, {
      key: "defaultMethod",
      get: function get() {
        return {
          load: 'GET',
          sync: 'POST'
        };
      }
    }]);

    return AjaxTransport;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/customElements/SchedulerTag.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/customElements/SchedulerTag.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerTag; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _view_Scheduler_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../view/Scheduler.js */ "./lib/Scheduler/view/Scheduler.js");
/* harmony import */ var _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");



















function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


 //TODO: If we want to improve on this, add settings as attributes, replace data-field with field etc.

/**
 * @module Scheduler/customElements/SchedulerTag
 */

/**
 * Import this file to be able to use the tag **&lt;bryntum-scheduler&gt;** to create a scheduler. This is more of a
 * proof of concept than a ready to use class. Dataset from **&lt;data&gt;** and **&lt;bryntum-scheduler&gt;** tags is
 * applied to record and scheduler config, which means, that you can pass any documented config there, not only
 * demonstrated here. Dataset attributes are translated as follows:
 *
 *  * data-view-preset -> viewPreset
 *  * data-start-date -> startDate
 *
 *  etc.
 * ## Example
 * ```html
 * &lt;bryntum-scheduler data-view-preset="weekAndDay" data-start-date="2018-04-02" data-end-date="2018-04-09"&gt;
 *  &lt;column data-field="name"&gt;Name&lt;/column&gt;
 *      &lt;data&gt;
 *          &lt;events&gt;
 *              &lt;data data-id="1" data-resource-id="1" data-start-date="2018-04-03" data-end-date="2018-04-05"&gt;&lt;/data&gt;
 *              &lt;data data-id="2" data-resource-id="2" data-start-date="2018-04-04" data-end-date="2018-04-06"&gt;&lt;/data&gt;
 *              &lt;data data-id="3" data-resource-id="3" data-start-date="2018-04-05" data-end-date="2018-04-07"&gt;&lt;/data&gt;
 *          &lt;/events&gt;
 *          &lt;resources&gt;
 *              &lt;data data-id="1" data-name="Daniel"&gt;&lt;/data&gt;
 *              &lt;data data-id="2" data-name="Steven"&gt;&lt;/data&gt;
 *              &lt;data data-id="3" data-name="Sergei"&gt;&lt;/data&gt;
 *          &lt;/resources&gt;
 *      &lt;/data&gt;
 * &lt;/bryntum-scheduler&gt;
 * ```
 */
// This is required to make trial build function normally

var TagBase = window.customElements ? HTMLElement : Object;

var SchedulerTag = /*#__PURE__*/function (_TagBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerTag, _TagBase);

  var _super = _createSuper(SchedulerTag);

  function SchedulerTag() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, SchedulerTag);

    _this = _super.call(this);

    var me = _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_14___default()(_this),
        columns = [],
        resources = [],
        events = []; // create columns and data


    var _iterator = _createForOfIteratorHelper(me.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var tag = _step.value;

        if (tag.tagName === 'COLUMN') {
          var width = parseInt(tag.dataset.width),
              flex = parseInt(tag.dataset.flex),
              column = {
            field: tag.dataset.field,
            text: tag.innerHTML
          };
          if (width) column.width = width;else if (flex) column.flex = flex;else column.flex = 1;
          columns.push(column);
        } else if (tag.tagName === 'DATA') {
          var _iterator2 = _createForOfIteratorHelper(tag.children),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var storeType = _step2.value;

              var _iterator3 = _createForOfIteratorHelper(storeType.children),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var record = _step3.value;
                  var row = {};
                  Object.assign(row, record.dataset);

                  if (storeType.tagName === 'EVENTS') {
                    events.push(row);
                  } else if (storeType.tagName === 'RESOURCES') {
                    resources.push(row);
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var // go over to the dark side
    shadowRoot = _this.attachShadow({
      mode: 'open'
    }),
        // include css and target div in shadow dom
    link = document.createElement('link');

    link.rel = 'stylesheet';
    link.href = '../../build/scheduler.stockholm.css';

    link.onload = function () {
      var div = document.createElement('div');
      div.id = 'container';
      div.style.width = '100%';
      div.style.height = '100%';
      shadowRoot.appendChild(div); // Listen to focus events on shadow root to handle focus inside the shadow dom

      Object(_Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_19__["setupFocusListeners"])(shadowRoot, _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"]);
      var config = {
        appendTo: div,
        columns: columns,
        resources: resources,
        events: events
      };
      Object.assign(config, me.dataset); // render as usual

      var scheduler = new _view_Scheduler_js__WEBPACK_IMPORTED_MODULE_18__["default"](config); // for testing, set first scheduler as global variable

      if (!window.scheduler) window.scheduler = scheduler;
    };

    shadowRoot.appendChild(link);
    return _this;
  }

  return SchedulerTag;
}(TagBase); // Try-catch to make trial work




try {
  window.customElements && window.customElements.define('bryntum-scheduler', SchedulerTag);
} catch (error) {}

SchedulerTag._$name = 'SchedulerTag';

/***/ }),

/***/ "./lib/Scheduler/data/AssignmentStore.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/data/AssignmentStore.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentStore; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../model/AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
/* harmony import */ var _mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./mixin/AssignmentStoreMixin.js */ "./lib/Scheduler/data/mixin/AssignmentStoreMixin.js");
/* harmony import */ var _Engine_quark_store_ChronoAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoAssignmentStoreMixin.js */ "./lib/Engine/quark/store/ChronoAssignmentStoreMixin.js");
/* harmony import */ var _Engine_quark_store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Engine/quark/store/CoreAssignmentStoreMixin.js */ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js");









var _window$bryntum;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/*  */


var EngineMixin =
/*  */
Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_10__["default"])(_Engine_quark_store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_14__["CoreAssignmentStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_8__["default"]));
/**
 * @module Scheduler/data/AssignmentStore
 */

/**
 * A store representing a collection of assignments between events in the {@link Scheduler.data.EventStore} and resources
 * in the {@link Scheduler.data.ResourceStore}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.AssignmentModel}.
 *
 * An AssignmentStore is usually connected to a project, which binds it to other related stores (EventStore,
 * ResourceStore and DependencyStore). The project also handles references (event, resource) to related records for the
 * records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * assignmentStore.data = [{ eventId, resourceId }, ...];
 *
 * // references (event, resource) not resolved yet
 *
 * await assignmentStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await assignmentStore.loadDataAsync([{ eventId, resourceId }, ...]);
 *
 * // references (event, resource) are resolved
 * ```
 *
 * @mixes Scheduler/data/mixin/AssignmentStoreMixin
 * @mixes Scheduler/data/mixin/PartOfProject
 * @extends Core/data/AjaxStore
 */

var AssignmentStore = /*#__PURE__*/function (_AssignmentStoreMixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(AssignmentStore, _AssignmentStoreMixin);

  var _super = _createSuper(AssignmentStore);

  function AssignmentStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, AssignmentStore);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(AssignmentStore, null, [{
    key: "defaultConfig",
    get: function get() {
      return {
        modelClass: _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_9__["default"]
      };
    }
  }]);

  return AssignmentStore;
}(Object(_mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__["default"])(EngineMixin));


AssignmentStore._$name = 'AssignmentStore';

/***/ }),

/***/ "./lib/Scheduler/data/CrudManager.js":
/*!*******************************************!*\
  !*** ./lib/Scheduler/data/CrudManager.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CrudManager; });
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _ResourceStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./ResourceStore.js */ "./lib/Scheduler/data/ResourceStore.js");
/* harmony import */ var _EventStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony import */ var _AssignmentStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./AssignmentStore.js */ "./lib/Scheduler/data/AssignmentStore.js");
/* harmony import */ var _DependencyStore_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./DependencyStore.js */ "./lib/Scheduler/data/DependencyStore.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./mixin/ProjectCrudManager.js */ "./lib/Scheduler/data/mixin/ProjectCrudManager.js");
/* harmony import */ var _crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../crud/AbstractCrudManager.js */ "./lib/Scheduler/crud/AbstractCrudManager.js");
/* harmony import */ var _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../crud/transport/AjaxTransport.js */ "./lib/Scheduler/crud/transport/AjaxTransport.js");
/* harmony import */ var _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../crud/encoder/JsonEncoder.js */ "./lib/Scheduler/crud/encoder/JsonEncoder.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';









/**
 * @module Scheduler/data/CrudManager
 */

/**
 * The Crud Manager (or "CM") is a class implementing centralized loading and saving of data in multiple stores.
 * Loading the stores and saving all changes is done using a single AJAX request.
 * This class uses JSON as the data encoding format.
 *
 * ## Scheduler stores
 *
 * The class supports Scheduler specific stores (namely: resource, event, assignment and dependency stores).
 * For these stores, the CM has separate configs ({@link #config-resourceStore}, {@link #config-eventStore},
 * {@link #config-assignmentStore}) to register them.
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     autoLoad        : true,
 *     resourceStore   : resourceStore,
 *     eventStore      : eventStore,
 *     assignmentStore : assignmentStore,
 *     transport       : {
 *         load : {
 *             url : 'php/read.php'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 * ```
 *
 * ## AJAX request configuration
 *
 * To configure AJAX request parameters please take a look at the
 * {@link Scheduler.crud.transport.AjaxTransport AjaxTransport} docs.
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     autoLoad        : true,
 *     resourceStore,
 *     eventStore,
 *     assignmentStore,
 *     transport       : {
 *         load    : {
 *             url         : 'php/read.php',
 *             // use GET request
 *             method      : 'GET',
 *             // pass request JSON in "rq" parameter
 *             paramName   : 'rq',
 *             // extra HTTP request parameters
 *             params      : {
 *                 foo     : 'bar'
 *             },
 *             // pass some extra Fetch API option
 *             credentials : 'include'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 * ```
 *
 * ## Load order
 *
 * The CM is aware of the proper load order for Scheduler specific stores so you don't need to worry about it.
 * If you provide any extra stores (using {@link Scheduler.crud.AbstractCrudManager#config-stores} config) they will be
 * added to the start of collection before the Scheduler specific stores.
 * If you need a different loading order, you should use {@link Scheduler.crud.AbstractCrudManager#function-addStore} method to
 * register your store:
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     resourceStore   : resourceStore,
 *     eventStore      : eventStore,
 *     assignmentStore : assignmentStore,
 *     // extra user defined stores will get to the start of collection
 *     // so they will be loaded first
 *     stores          : [ store1, store2 ],
 *     transport       : {
 *         load : {
 *             url : 'php/read.php'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 *
 * // append store3 to the end so it will be loaded last
 * crudManager.addStore(store3);
 *
 * // now when we registered all the stores let's load them
 * crudManager.load();
 * ```
 *
 * ## Assignment store
 *
 * CrudManager is designed to use AssignmentStore for assigning events to one or multiple resources.
 * However if server provides `resourceId` for any of the `events` then CrudManager enables backward compatible mode when an event could have a single assignment only. This also disables multiple assignments in Scheduler UI.
 * In order to use multiple assignments server backend should be able to receive/send `assignments` for `load` and `sync` requests.
 *
 * ## Features
 *
 * The Crud Manager can automatically add Scheduler feature stores to the tracked collection.
 * For example, it tracks TimeRanges {@link Scheduler.feature.TimeRanges#config-store}.
 * You can receive a tracked store by its id:
 * ```javascript
 * const timeRangesStore = crudManager.getStore('timeRanges');
 * ```
 *
 * @mixes Scheduler/data/mixin/ProjectCrudManager
 * @mixes Scheduler/crud/encoder/JsonEncoder
 * @mixes Scheduler/crud/transport/AjaxTransport
 * @extends Scheduler/crud/AbstractCrudManager
 */

var CrudManager = /*#__PURE__*/function (_AbstractCrudManager$) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(CrudManager, _AbstractCrudManager$);

  var _super = _createSuper(CrudManager);

  function CrudManager() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, CrudManager);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(CrudManager, [{
    key: "startConfigure",
    //endregion
    value: function startConfigure(config) {
      if (config.scheduler) {
        // The effects of this class's initialization are so wide ranging that they may need to
        // access the Scheduler's CrudManager, so ensure it's available immediately.
        config.scheduler._crudManager = this;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(CrudManager.prototype), "startConfigure", this).call(this, config);
    }
  }, {
    key: "afterConstruct",
    value: function afterConstruct() {
      var me = this,
          scheduler = me.scheduler; // Created by being configured on a scheduler

      if (scheduler) {
        // Features self initialize if not already initialized.
        // This must be done after the _crudManager is assigned because it may access this.crudManager
        // to get its eventStore.
        var timeRanges = scheduler.features.timeRanges; // Must pull resourceTimeRanges in here. TODO: Refactor this flow, it is weird

        if (timeRanges) {
          me.addCrudStore(timeRanges.store);
          me._timeRangesStore = timeRanges.store;
        }
      } // Created as a standalone instance, create stores to load if none supplied (and plug them into scheduler later)
      // (Not using {} as default value on the configs to not create unneeded stores when running the code above)
      else if (!me.project) {
          me.project = null;
        }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(CrudManager.prototype), "afterConstruct", this).call(this);
    } //region Stores

  }, {
    key: "setFeaturedStore",
    value: function setFeaturedStore(property, store, storeClass) {
      var _me$property;

      var me = this,
          oldStore = (_me$property = me[property]) === null || _me$property === void 0 ? void 0 : _me$property.store; // if not the same store

      if (oldStore !== store) {
        var _store;

        // normalize store value (turn it into a storeClass instance if needed)
        store = _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_14__["default"].getStore(store, ((_store = store) === null || _store === void 0 ? void 0 : _store.storeClass) || storeClass);

        if (oldStore) {
          me.removeStore(oldStore);
        }

        me[property] = store && {
          store: store
        } || null; // Adds configured scheduler stores to the store collection ensuring correct order
        // unless they're already registered.

        me.addPrioritizedStore(me[property]);
      }

      return me[property];
    }
  }, {
    key: "getChangeSetPackage",
    value: function getChangeSetPackage() {
      var pack = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(CrudManager.prototype), "getChangeSetPackage", this).call(this); // Remove assignments from changes if using single assignment mode (resourceId)


      if (pack && this.eventStore.usesSingleAssignment) {
        delete pack[this.assignmentStore.storeId]; // No other changes?

        if (!this.crudStores.some(function (storeInfo) {
          return pack[storeInfo.storeId];
        })) {
          return null;
        }
      }

      return pack;
    } //endregion

  }, {
    key: "project",
    set: function set(project) {
      var me = this;
      me._project = project;

      if (project) {
        me.eventStore = project.eventStore;
        me.resourceStore = project.resourceStore;
        me.assignmentStore = project.assignmentStore;
        me.dependencyStore = project.dependencyStore;
        me.resourceTimeRangeStore = project.resourceTimeRangeStore;
      }

      if (!me.eventStore) {
        me.eventStore = {};
      }

      if (!me.resourceStore) {
        me.resourceStore = {};
      }

      if (!me.assignmentStore) {
        me.assignmentStore = {};
      }

      if (!me.dependencyStore) {
        me.dependencyStore = {};
      }
    },
    get: function get() {
      return this._project;
    }
    /**
     * Returns store associated with timeRanges feature, if feature is enabled.
     * @property {Core.data.Store}
     * @readonly
     */

  }, {
    key: "timeRangesStore",
    get: function get() {
      return this._timeRangesStore;
    }
    /**
     * Get/set the resource store bound to the CRUD manager.
     * @property {Scheduler.data.ResourceStore}
     */

  }, {
    key: "resourceStore",
    get: function get() {
      var _this$_resourceStore;

      return (_this$_resourceStore = this._resourceStore) === null || _this$_resourceStore === void 0 ? void 0 : _this$_resourceStore.store;
    },
    set: function set(store) {
      var me = this;
      me.setFeaturedStore('_resourceStore', store, me.resourceStoreClass);
    }
    /**
     * Get/set the event store bound to the CRUD manager.
     * @property {Scheduler.data.EventStore}
     */

  }, {
    key: "eventStore",
    get: function get() {
      var _this$_eventStore;

      return (_this$_eventStore = this._eventStore) === null || _this$_eventStore === void 0 ? void 0 : _this$_eventStore.store;
    },
    set: function set(store) {
      var me = this;
      me.setFeaturedStore('_eventStore', store, me.eventStoreClass);
    }
    /**
     * Get/set the assignment store bound to the CRUD manager.
     * @property {Scheduler.data.AssignmentStore}
     */

  }, {
    key: "assignmentStore",
    get: function get() {
      var _this$_assignmentStor;

      return (_this$_assignmentStor = this._assignmentStore) === null || _this$_assignmentStor === void 0 ? void 0 : _this$_assignmentStor.store;
    },
    set: function set(store) {
      this.setFeaturedStore('_assignmentStore', store, this.assignmentStoreClass);
    }
    /**
     * Get/set the dependency store bound to the CRUD manager.
     * @property {Scheduler.data.DependencyStore}
     */

  }, {
    key: "dependencyStore",
    get: function get() {
      var _this$_dependencyStor;

      return (_this$_dependencyStor = this._dependencyStore) === null || _this$_dependencyStor === void 0 ? void 0 : _this$_dependencyStor.store;
    },
    set: function set(store) {
      this.setFeaturedStore('_dependencyStore', store, this.dependencyStoreClass);
    }
  }, {
    key: "resourceTimeRangeStore",
    set: function set(store) {
      this._resourceTimeRangesStore = store;
      this.addCrudStore(store);
    },
    get: function get() {
      return this._resourceTimeRangesStore;
    }
  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        resourceStoreClass: _ResourceStore_js__WEBPACK_IMPORTED_MODULE_10__["default"],
        eventStoreClass: _EventStore_js__WEBPACK_IMPORTED_MODULE_11__["default"],
        assignmentStoreClass: _AssignmentStore_js__WEBPACK_IMPORTED_MODULE_12__["default"],
        dependencyStoreClass: _DependencyStore_js__WEBPACK_IMPORTED_MODULE_13__["default"],

        /**
         * A store with resources (or its descriptor).
         * @config {Scheduler.data.ResourceStore|Object}
         */
        resourceStore: {},

        /**
         * A store with events (or its descriptor).
         *
         * ```
         * crudManager : {
         *      eventStore {
         *          storeClass : MyEventStore
         *      }
         * }
         * ```
         * @config {Scheduler.data.EventStore|Object}
         */
        eventStore: {},

        /**
         * A store with assignments (or its descriptor).
         * @config {Scheduler.data.AssignmentStore|Object}
         */
        assignmentStore: {},

        /**
         * A store with dependencies (or its descriptor).
         * @config {Scheduler.data.DependencyStore|Object}
         */
        dependencyStore: {},

        /**
         * A project that holds and links stores
         * @config {Scheduler.model.ProjectModel}
         */
        project: null,
        scheduler: null
      };
    }
  }]);

  return CrudManager;
}(_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_16__["default"].mixin(_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_15__["default"], _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_17__["default"], _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_18__["default"]));


;
CrudManager._$name = 'CrudManager';

/***/ }),

/***/ "./lib/Scheduler/data/DependencyStore.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/data/DependencyStore.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyStore; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/DependencyStoreMixin.js */ "./lib/Scheduler/data/mixin/DependencyStoreMixin.js");
/* harmony import */ var _Engine_quark_store_ChronoDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoDependencyStoreMixin.js */ "./lib/Engine/quark/store/ChronoDependencyStoreMixin.js");
/* harmony import */ var _Engine_quark_store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Engine/quark/store/CoreDependencyStoreMixin.js */ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");









var _window$bryntum;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/*  */



var EngineMixin =
/*  */
Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_10__["default"])(_Engine_quark_store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__["CoreDependencyStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_8__["default"]));
/**
 * @module Scheduler/data/DependencyStore
 */

/**
 * A store representing a collection of dependencies between events in the {@link Scheduler.data.EventStore}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.DependencyModel}.
 *
 * A DependencyStore is usually connected to a project, which binds it to other related stores (EventStore,
 * AssignmentStore and ResourceStore). The project also handles references (fromEvent, toEvent) to related records
 * for the records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * dependencyStore.data = [{ from, to }, ...];
 *
 * // references (fromEvent, toEvent) not resolved yet
 *
 * await dependencyStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await dependencyStore.loadDataAsync([{ from, to }, ...]);
 *
 * // references (fromEvent, toEvent) are resolved
 * ```
 *
 * @mixes Scheduler/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/DependencyStoreMixin
 * @extends Core/data/AjaxStore
 */

var DependencyStore = /*#__PURE__*/function (_DependencyStoreMixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DependencyStore, _DependencyStoreMixin);

  var _super = _createSuper(DependencyStore);

  function DependencyStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DependencyStore);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DependencyStore, null, [{
    key: "defaultConfig",
    get: function get() {
      return {
        modelClass: _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_9__["default"]
      };
    }
  }]);

  return DependencyStore;
}(Object(_mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_11__["default"])(EngineMixin.derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_8__["default"])));


DependencyStore._$name = 'DependencyStore';

/***/ }),

/***/ "./lib/Scheduler/data/EventStore.js":
/*!******************************************!*\
  !*** ./lib/Scheduler/data/EventStore.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventStore; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/EventStoreMixin.js */ "./lib/Scheduler/data/mixin/EventStoreMixin.js");
/* harmony import */ var _mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixin/SharedEventStoreMixin.js */ "./lib/Scheduler/data/mixin/SharedEventStoreMixin.js");
/* harmony import */ var _mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/RecurringEventsMixin.js */ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js");
/* harmony import */ var _model_EventModel_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../model/EventModel.js */ "./lib/Scheduler/model/EventModel.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_store_ChronoEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoEventStoreMixin.js */ "./lib/Engine/quark/store/ChronoEventStoreMixin.js");
/* harmony import */ var _Engine_quark_store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Engine/quark/store/CoreEventStoreMixin.js */ "./lib/Engine/quark/store/CoreEventStoreMixin.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");









var _window$bryntum;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/*  */



var EngineMixin =
/*  */
Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_13__["default"])(_Engine_quark_store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_15__["CoreEventStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_8__["default"]));
/**
 * @module Scheduler/data/EventStore
 */

/**
 * A store holding all the {@link Scheduler.model.EventModel events} to be rendered into a {@link Scheduler.view.Scheduler Scheduler}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.EventModel}.
 *
 * An EventStore is usually connected to a project, which binds it to other related stores (AssignmentStore,
 * ResourceStore and DependencyStore). The project also handles normalization/calculation of the data on the records in
 * the store. For example if a record is added with a `startDate` and an `endDate`, it will calculate the `duration`.
 *
 * The calculations happens async, records are not guaranteed to have up to date data until they are finished. To be
 * certain that calculations have finished, call `await project.commitAsync()` after store actions. Or use one of the
 * `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * eventStore.data = [{ startDate, endDate }, ...];
 *
 * // duration of the record is not yet calculated
 *
 * await eventStore.project.commitAsync();
 *
 * // now it is
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await eventStore.loadDataAsync([{ startDate, endDate }, ...]);
 *
 * // duration is calculated
 * ```
 *
 * @mixes Scheduler/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/SharedEventStoreMixin
 * @mixes Scheduler/data/mixin/EventStoreMixin
 * @mixes Scheduler/data/mixin/RecurringEventsMixin
 * @extends Core/data/AjaxStore
 */

var EventStore = /*#__PURE__*/function (_EngineMixin$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(EventStore, _EngineMixin$mixin);

  var _super = _createSuper(EventStore);

  function EventStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, EventStore);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(EventStore, null, [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Class used to represent records
         * @config {Scheduler.model.EventModel}
         * @default
         * @category Common
         * @typings { new(data: object): Model }
         */
        modelClass: _model_EventModel_js__WEBPACK_IMPORTED_MODULE_12__["default"],

        /**
         * ***Only valid when this EventStore is being consumed by the Calendar product***
         *
         * This is the id of the default Calendar to assign to new events created using
         * dblclick or drag.
         *
         * @category Calendar
         * @config {String|Number}
         */
        defaultCalendar: null
      };
    }
  }]);

  return EventStore;
}(EngineMixin.mixin(_mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["default"], _mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_11__["default"], _mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_9__["default"]));


EventStore._$name = 'EventStore';

/***/ }),

/***/ "./lib/Scheduler/data/ResourceStore.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/data/ResourceStore.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceStore; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./mixin/ResourceStoreMixin.js */ "./lib/Scheduler/data/mixin/ResourceStoreMixin.js");
/* harmony import */ var _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../model/ResourceModel.js */ "./lib/Scheduler/model/ResourceModel.js");
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_store_ChronoResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Engine/quark/store/ChronoResourceStoreMixin.js */ "./lib/Engine/quark/store/ChronoResourceStoreMixin.js");
/* harmony import */ var _Engine_quark_store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Engine/quark/store/CoreResourceStoreMixin.js */ "./lib/Engine/quark/store/CoreResourceStoreMixin.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");









var _window$bryntum;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/*  */



var EngineMixin =
/*  */
Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_11__["default"])(_Engine_quark_store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_13__["CoreResourceStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_10__["default"]));
/**
 * @module Scheduler/data/ResourceStore
 */

/**
 * A store holding all the {@link Scheduler.model.ResourceModel resources} to be rendered into a
 * {@link Scheduler.view.Scheduler Scheduler}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.ResourceModel}.
 *
 * A ResourceStore is usually connected to a project, which binds it to other related stores (EventStore,
 * AssignmentStore and DependencyStore). The project also handles references (assignments, events) to related records
 * for the records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * resourceStore.data = [{ id }, ...];
 *
 * // references (assignments, events) not resolved yet
 *
 * await resourceStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await resourceStore.loadDataAsync([{ id }, ...]);
 *
 * // references (assignments, events) are resolved
 * ```
 *
 * @mixes Scheduler/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/ResourceStoreMixin
 * @extends Core/data/AjaxStore
 */

var ResourceStore = /*#__PURE__*/function (_ResourceStoreMixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ResourceStore, _ResourceStoreMixin);

  var _super = _createSuper(ResourceStore);

  function ResourceStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ResourceStore);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ResourceStore, null, [{
    key: "defaultConfig",
    get: function get() {
      return {
        modelClass: _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_9__["default"]
      };
    }
  }]);

  return ResourceStore;
}(Object(_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_8__["default"])(EngineMixin));


ResourceStore._$name = 'ResourceStore';

/***/ }),

/***/ "./lib/Scheduler/data/ResourceTimeRangeStore.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/data/ResourceTimeRangeStore.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRangeStore; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../model/ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/data/ResourceTimeRangeStore
 */

/**
 * A class representing a collection of resource time ranges.
 * Contains a collection of {@link Scheduler.model.ResourceTimeRangeModel} records.
 *
 * @extends Core/data/AjaxStore
 */

var ResourceTimeRangeStore = /*#__PURE__*/function (_AjaxStore) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ResourceTimeRangeStore, _AjaxStore);

  var _super = _createSuper(ResourceTimeRangeStore);

  function ResourceTimeRangeStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ResourceTimeRangeStore);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ResourceTimeRangeStore, [{
    key: "getResourcesForEvent",
    // Matching signature in EventStore to allow reusage of SchedulerStores#onInternalEventStoreChange()
    value: function getResourcesForEvent(resourceTimeRange) {
      return [resourceTimeRange.resource];
    }
  }, {
    key: "resourceStore",
    set: function set(store) {
      this._resourceStore = store; // If store is assigned after configuration we need to init relations

      if (!this.isConfiguring) {
        this.initRelations(true);
      }
    },
    get: function get() {
      return this._resourceStore;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * CrudManager must load stores in the correct order. Lowest first.
         * @private
         */
        loadPriority: 500,

        /**
         * CrudManager must sync stores in the correct order. Lowest first.
         * @private
         */
        syncPriority: 500,

        /**
         * This store should be linked to a ResourceStore to link the time ranges to resources
         * @config {Scheduler.data.ResourceStore}
         */
        resourceStore: null,
        modelClass: _model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_9__["default"],
        storeId: 'resourceTimeRanges'
      };
    }
  }]);

  return ResourceTimeRangeStore;
}(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


ResourceTimeRangeStore._$name = 'ResourceTimeRangeStore';

/***/ }),

/***/ "./lib/Scheduler/data/TimeAxis.js":
/*!****************************************!*\
  !*** ./lib/Scheduler/data/TimeAxis.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxis; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../preset/ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../preset/PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");



















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/data/TimeAxis
 */

/**
 * A class representing the time axis of the scheduler. The scheduler timescale is based on the ticks generated by this class.
 * This is a pure "data" (model) representation of the time axis and has no UI elements.
 *
 * The time axis can be {@link #config-continuous} or not. In continuous mode, each timespan starts where the previous ended, and in non-continuous mode
 * there can be gaps between the ticks.
 * A non-continuous time axis can be used when want to filter out certain periods of time (like weekends) from the time axis.
 *
 * To create a non-continuos time axis you have 2 options. First, you can create a time axis containing only the time spans of interest.
 * To do that, subclass this class and override the {@link #function-generateTicks} method.
 *
 * The other alternative is to call the {@link #function-filterBy} method, passing a function to it which should return `false` if the time tick should be filtered out.
 * Calling {@link Core.data.mixin.StoreFilter#function-clearFilters} will return you to a full time axis.
 *
 * @extends Core/data/Store
 */

var TimeAxis = /*#__PURE__*/function (_Store) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(TimeAxis, _Store);

  var _super = _createSuper(TimeAxis);

  function TimeAxis() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default()(this, TimeAxis);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default()(TimeAxis, [{
    key: "construct",
    //endregion
    //region Init
    // private
    value: function construct(config) {
      var me = this; // TODO: maybe not needed

      me.generateTicksValidatorFn = function () {
        return true;
      };

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(TimeAxis.prototype), "construct", this).call(this, config);

      me.originalContinuous = me.continuous;
      me.on({
        change: function change(_ref) {
          var action = _ref.action;

          // If the change was due to filtering, there will be a refresh event
          // arriving next, so do not reconfigure
          if (action !== 'filter') {
            me.trigger('reconfigure', {
              supressRefresh: false
            });
          }
        },
        refresh: function refresh() {
          return me.trigger('reconfigure', {
            supressRefresh: false
          });
        },
        endreconfigure: function endreconfigure(event) {
          return me.trigger('reconfigure', event);
        }
      });

      if (me.startDate) {
        me.internalOnReconfigure();
        me.trigger('reconfigure');
      } else if (me.viewPreset) {
        var range = me.getAdjustedDates(new Date());
        me.startDate = range.startDate;
        me.endDate = range.endDate;
      }
    }
  }, {
    key: "reconfigure",
    //endregion
    //region Configuration (reconfigure & consumePreset)

    /**
     * Reconfigures the time axis based on the config object supplied and generates the new 'ticks'.
     * @param {Object} config
     * @param {Boolean} [suppressRefresh]
     * @private
     */
    value: function reconfigure(config) {
      var suppressRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var preventThrow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          normalized = me.getAdjustedDates(config.startDate, config.endDate);

      if (me.trigger('beforeReconfigure', {
        startDate: normalized.startDate,
        endDate: normalized.endDate,
        config: config
      }) !== false) {
        me.trigger('beginReconfigure');
        me._configuredStartDate = config.startDate;
        me._configuredEndDate = config.endDate;
        Object.assign(me, config);

        if (me.internalOnReconfigure(preventThrow) === false) {
          return false;
        }

        me.trigger('endReconfigure', {
          suppressRefresh: suppressRefresh,
          config: config
        });
      }
    }
  }, {
    key: "internalOnReconfigure",
    value: function internalOnReconfigure() {
      var preventThrow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this;
      me.isConfigured = true;
      var adjusted = me.getAdjustedDates(me.startDate, me.endDate, true),
          normalized = me.getAdjustedDates(me.startDate, me.endDate),
          start = normalized.startDate,
          end = normalized.endDate;

      if (start >= end) {
        throw new Error("Invalid start/end dates. Start date must less than end date. Start date: ".concat(start, ". End date: ").concat(end, "."));
      }

      var unit = me.unit,
          increment = me.increment || 1,
          ticks = me.generateTicks(start, end, unit, increment); // Suspending to be able to detect an invalid filter

      me.suspendEvents();
      me.data = ticks;
      var count = me.count;

      if (count === 0) {
        if (preventThrow) {
          me.resumeEvents();
          return false;
        }

        throw new Error('Invalid time axis configuration or filter, please check your input data.');
      } // start date is cached, update it to fill after generated ticks


      me.startDate = me.first.startDate;
      me.resumeEvents();
      var checkEnd = me.last.endDate;

      if (me.isContinuous) {
        me.adjustedStart = adjusted.startDate;
        me.adjustedEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getNext(count > 1 ? ticks[count - 1].startDate : adjusted.startDate, unit, increment, me.weekStartDay);
      } else {
        me.adjustedStart = me.startDate;
        me.adjustedEnd = checkEnd;
      } // if visibleTickStart > 1 this means some tick is fully outside of the view - we are not interested in it and want to
      // drop it and adjust "adjustedStart" accordingly


      do {
        // TODO this has to use more sophisticated formula to take into account that months for example can be expressed in ms consistenly
        me.visibleTickStart = (me.startDate - me.adjustedStart) / (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].asMilliseconds(unit) * increment); // TODO: Changed from round to floor which seems to work, but this is not needed in ExtScheduler. Need to step and see what is different

        if (me.autoAdjust) me.visibleTickStart = Math.floor(me.visibleTickStart);
        if (me.visibleTickStart >= 1) me.adjustedStart = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getNext(me.adjustedStart, unit, increment, me.weekStartDay);
      } while (me.visibleTickStart >= 1);

      do {
        me.visibleTickEnd = count - (me.adjustedEnd - checkEnd) / (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].asMilliseconds(unit) * increment);
        if (count - me.visibleTickEnd >= 1) me.adjustedEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getNext(me.adjustedEnd, unit, -1, me.weekStartDay);
      } while (count - me.visibleTickEnd >= 1);

      me.updateTickCache(true);
    }
    /**
     * Get/set currently used preset
     * @property {Scheduler.preset.ViewPreset}
     */

  }, {
    key: "setTimeSpan",
    //endregion
    //region Timespan & resolution

    /**
     * Changes the time axis timespan to the supplied start and end dates.
     * @param {Date} newStartDate The new start date
     * @param {Date} newEndDate The new end date
     */
    value: function setTimeSpan(newStartDate, newEndDate) {
      var preventThrow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var me = this,
          _me$getAdjustedDates = me.getAdjustedDates(newStartDate, newEndDate),
          startDate = _me$getAdjustedDates.startDate,
          endDate = _me$getAdjustedDates.endDate;

      if (me.startDate - startDate !== 0 || me.endDate - endDate !== 0) {
        return me.reconfigure({
          startDate: startDate,
          endDate: endDate
        }, false, preventThrow);
      }
    }
    /**
     * Moves the time axis by the passed amount and unit.
     *
     * NOTE: When using a filtered TimeAxis the result of `shift()` cannot be guaranteed, it might shift into a
     * filtered out span. It tries to be smart about it by shifting from unfiltered start and end dates.
     * If that solution does not work for your filtering setup, please call {@link #function-setTimeSpan} directly
     * instead.
     *
     * @param {Number} amount The number of units to jump
     * @param {String} [unit] The unit (Day, Week etc)
     */

  }, {
    key: "shift",
    value: function shift(amount) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.shiftUnit;
      var me = this;
      var startDate = me.startDate,
          endDate = me.endDate; // Use unfiltered start and end dates when shifting a filtered time axis, to lessen risk of messing it up.
      // Still not guaranteed to work though

      if (me.isFiltered) {
        startDate = me.allRecords[0].startDate;
        endDate = me.allRecords[me.allCount - 1].endDate;
      } // Hack for filtered time axis, for example if weekend is filtered out and you shiftPrev() day from monday


      var tries = 0;

      do {
        startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(startDate, amount, unit);
        endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(endDate, amount, unit);
      } while (tries++ < 100 && me.setTimeSpan(startDate, endDate, true) === false);
    }
    /**
     * Moves the time axis forward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement`
     * config of the current view preset.
     *
     * NOTE: When using a filtered TimeAxis the result of `shiftNext()` cannot be guaranteed, it might shift into a
     * filtered out span. It tries to be smart about it by shifting from unfiltered start and end dates.
     * If that solution does not work for your filtering setup, please call {@link #function-setTimeSpan} directly
     * instead.
      *
     * @param {Number} [amount] The number of units to jump forward
     */

  }, {
    key: "shiftNext",
    value: function shiftNext() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.shiftIncrement;
      this.shift(amount);
    }
    /**
     * Moves the time axis backward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement` config of the current view preset.
     *
     * NOTE: When using a filtered TimeAxis the result of `shiftPrev()` cannot be guaranteed, it might shift into a
     * filtered out span. It tries to be smart about it by shifting from unfiltered start and end dates.
     * If that solution does not work for your filtering setup, please call {@link #function-setTimeSpan} directly
     * instead.
      *
     * @param {Number} [amount] The number of units to jump backward
     */

  }, {
    key: "shiftPrevious",
    value: function shiftPrevious() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.shiftIncrement;
      this.shift(-amount);
    } //endregion
    //region Filter & continous

    /**
     * Filter the time axis by a function. The passed function will be called with each tick in time axis.
     * If the function returns true, the 'tick' is included otherwise it is filtered. If all ticks are filtered out
     * the time axis is considered invalid, triggering `invalidFilter` and then removing the filter.
     * @param {Function} fn The function to be called, it will receive an object with startDate/endDate properties, and 'index' of the tick.
     * @param {Object} [thisObj] `this` reference for the function
     */

  }, {
    key: "filterBy",
    value: function filterBy(fn) {
      var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var me = this;
      me.filters.clear();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(TimeAxis.prototype), "filterBy", this).call(this, function (tick, index) {
        return fn.call(thisObj, tick.data, index);
      });

      if (me.count === 0) {
        me.trigger('invalidFilter');
        me.clearFilters();
      }
    }
  }, {
    key: "triggerFilterEvent",
    value: function triggerFilterEvent(event) {
      var me = this;

      if (!event.filters.count) {
        me.continuous = me.originalContinuous;
      } else {
        me.continuous = false;
      } // Filters has been applied (or cleared) but listeners are not informed yet, update tick cache to have start and
      // end dates correct when later redrawing events & header


      me.updateTickCache();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(TimeAxis.prototype), "triggerFilterEvent", this).call(this, event);
    }
    /**
     * Returns `true` if the time axis is continuous (will return `false` when filtered)
     * @return {Boolean}
     */

  }, {
    key: "getAdjustedDates",
    //endregion
    //region Dates
    value: function getAdjustedDates(startDate, endDate) {
      var forceAdjust = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this;
      startDate = startDate || me.startDate;
      endDate = endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(startDate, me.defaultSpan, me.mainUnit);
      return me.autoAdjust || forceAdjust ? {
        startDate: me.floorDate(startDate, false, me.autoAdjust ? me.mainUnit : me.unit, 1),
        endDate: me.ceilDate(endDate, false, me.autoAdjust ? me.mainUnit : me.unit, 1)
      } : {
        startDate: startDate,
        endDate: endDate
      };
    }
    /**
     * Method to get the current start date of the time axis.
     * @property {Date}
     */

  }, {
    key: "floorDate",
    // Floors a date and optionally snaps it to one of the following resolutions:
    // 1. 'resolutionUnit'. If param 'resolutionUnit' is passed, the date will simply be floored to this unit.
    // 2. If resolutionUnit is not passed: If date should be snapped relative to the timeaxis start date,
    // the resolutionUnit of the timeAxis will be used, or the timeAxis 'mainUnit' will be used to snap the date
    //
    // returns a copy of the original date
    // private
    value: function floorDate(date, relativeToStart, resolutionUnit, incr) {
      relativeToStart = relativeToStart !== false;

      var me = this,
          relativeTo = relativeToStart ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clone(me.startDate) : null,
          increment = incr || me.resolutionIncrement,
          unit = resolutionUnit || (relativeToStart ? me.resolutionUnit : me.mainUnit),
          snap = function snap(value, increment) {
        return Math.floor(value / increment) * increment;
      };

      if (relativeToStart) {
        var snappedDuration = snap(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].diff(relativeTo, date, unit), increment); // TODO: used to be small unit multipled with factor (minute = seconds, minutes * 60)

        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(relativeTo, snappedDuration, unit);
      }

      var dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clone(date);

      if (unit === 'week') {
        var day = dt.getDay() || 7,
            startDay = me.weekStartDay || 7;
        dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].startOf(dt, 'day'), day >= startDay ? startDay - day : -(7 - startDay + day), 'day'); // Watch out for Brazil DST craziness (see test 028_timeaxis_dst.t.js)

        if (dt.getDay() !== startDay && dt.getHours() === 23) {
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(dt, 1, 'hour');
        }
      } else {
        // removes "smaller" units from date (for example minutes; removes seconds and milliseconds)
        dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].startOf(dt, unit); // day and year are 1-based so need to make additional adjustments

        var modifier = ['day', 'year'].includes(unit) ? 1 : 0,
            useUnit = unit === 'day' ? 'date' : unit,
            snappedValue = snap(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].get(dt, useUnit) - modifier, increment) + modifier;
        dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].set(dt, useUnit, snappedValue);
      }

      return dt;
    }
    /**
     * Rounds the date to nearest unit increment
     * @private
     */

  }, {
    key: "roundDate",
    value: function roundDate(date, relativeTo) {
      var me = this,
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clone(date),
          increment = me.resolutionIncrement || 1;
      relativeTo = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clone(relativeTo || me.startDate);

      switch (me.resolutionUnit) {
        case 'week':
          _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].startOf(dt, 'day');
          var distanceToWeekStartDay = dt.getDay() - me.weekStartDay,
              toAdd;

          if (distanceToWeekStartDay < 0) {
            distanceToWeekStartDay = 7 + distanceToWeekStartDay;
          }

          if (Math.round(distanceToWeekStartDay / 7) === 1) {
            toAdd = 7 - distanceToWeekStartDay;
          } else {
            toAdd = -distanceToWeekStartDay;
          }

          return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(dt, toAdd, 'day');

        case 'month':
          var nbrMonths = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].diff(relativeTo, dt, 'month') + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].as('month', dt.getDay() / _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].daysInMonth(dt)),
              //*/DH.as('month', DH.diff(relativeTo, dt)) + (dt.getDay() / DH.daysInMonth(dt)),
          snappedMonths = Math.round(nbrMonths / increment) * increment;
          return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(relativeTo, snappedMonths, 'month');

        case 'quarter':
          _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].startOf(dt, 'month');
          return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(dt, 'month', 3 - dt.getMonth() % 3);

        default:
          var duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].as(me.resolutionUnit, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].diff(relativeTo, dt)),
              // Need to find the difference of timezone offsets between relativeTo and original dates. 0 if timezone offsets are the same.
          offset = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].as(me.resolutionUnit, relativeTo.getTimezoneOffset() - dt.getTimezoneOffset(), 'minute'),
              // Need to add the offset to the whole duration, so the divided value will take DST into account
          snappedDuration = Math.round((duration + offset) / increment) * increment; // TODO: used to add one res unit lower * factor, minutes = add seconds, minutes * 60
          // Now when the round is done, we need to subtract the offset, so the result also will take DST into account

          return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(relativeTo, snappedDuration - offset, me.resolutionUnit);
      }
    } // private

  }, {
    key: "ceilDate",
    value: function ceilDate(date, relativeToStart, resolutionUnit, increment) {
      var me = this;
      relativeToStart = relativeToStart !== false;
      increment = increment || (relativeToStart ? this.resolutionIncrement : 1);
      var dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].clone(date),
          doCall = false,
          unit = resolutionUnit || (relativeToStart ? me.resolutionUnit : me.mainUnit);

      switch (unit) {
        case 'minute':
          doCall = !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].isStartOf(dt, 'minute');
          break;

        case 'hour':
          doCall = !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].isStartOf(dt, 'hour');
          break;

        case 'day':
        case 'date':
          doCall = !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].isStartOf(dt, 'day');
          break;

        case 'week':
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].startOf(dt, 'day');
          doCall = dt.getDay() !== me.weekStartDay || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].isEqual(dt, date);
          break;

        case 'month':
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].startOf(dt, 'day');
          doCall = dt.getDate() !== 1 || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].isEqual(dt, date);
          break;

        case 'quarter':
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].startOf(dt, 'day');
          doCall = dt.getMonth() % 3 !== 0 || dt.getDate() !== 1 || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].isEqual(dt, date);
          break;

        case 'year':
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].startOf(dt, 'day');
          doCall = dt.getMonth() !== 0 || dt.getDate() !== 1 || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].isEqual(dt, date);
          break;
      }

      if (doCall) return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getNext(dt, unit, increment, me.weekStartDay);
      return dt;
    } //endregion
    //region Ticks

  }, {
    key: "processExclusion",
    // Check if a certain date is included based on timeAxis.include rules
    value: function processExclusion(startDate, endDate, unit) {
      var include = this.include;

      if (include) {
        return Object.entries(include).some(function (_ref2) {
          var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11___default()(_ref2, 2),
              includeUnit = _ref3[0],
              rule = _ref3[1];

          if (!rule) {
            return false;
          }

          var from = rule.from,
              to = rule.to; // Including the closest smaller unit with a { from, to} rule should affect start & end of the
          // generated tick. Currently only works for days or smaller.

          if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].compareUnits('day', unit) >= 0 && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getLargerUnit(includeUnit) === unit) {
            if (from) {
              _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].set(startDate, includeUnit, from);
            }

            if (to) {
              var _DH$set;

              var stepUnit = unit; // Stepping back base on date, not day

              if (unit === 'day') {
                stepUnit = 'date';
              } // Since endDate is not inclusive it points to the next day etc.
              // Turns for example 2019-01-10T00:00 -> 2019-01-09T18:00


              _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].set(endDate, (_DH$set = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_DH$set, stepUnit, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].get(endDate, stepUnit) - 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_DH$set, includeUnit, to), _DH$set));
            }
          } // "Greater" unit being included? Then we need to care about it
          // (for example excluding day will also affect hour, minute etc)


          if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].compareUnits(includeUnit, unit) >= 0) {
            var datePart = includeUnit === 'day' ? startDate.getDay() : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].get(startDate, includeUnit);

            if (from && datePart < from || to && datePart >= to) {
              return true;
            }
          }
        });
      }

      return false;
    } // Calculate constants used for exclusion when scaling within larger ticks

  }, {
    key: "initExclusion",
    value: function initExclusion() {
      Object.entries(this.include).forEach(function (_ref4) {
        var _ref5 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11___default()(_ref4, 2),
            unit = _ref5[0],
            rule = _ref5[1];

        if (rule) {
          var from = rule.from,
              to = rule.to; // For example for hour:
          // 1. Get the next bigger unit -> day, get ratio -> 24
          // 2. to 20 - from 8 = 12 hours visible each day. lengthFactor 24 / 12 = 2 means that each hour used
          // needs to represent 2 hours when drawn (to stretch)
          // |    ████    | -> |  ████████  |

          rule.lengthFactor = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getUnitToBaseUnitRatio(unit, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getLargerUnit(unit)) / (to - from); // TODO: Since `to` is exclusive this should be the correct one... but cannot get it to work throughout

          rule.lengthFactorExcl = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getUnitToBaseUnitRatio(unit, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getLargerUnit(unit)) / (to - from - 1); // Calculate weighted center to stretch around |   ██x█ |

          rule.center = from + from / (rule.lengthFactor - 1);
        }
      });
    }
    /**
     * Method generating the ticks for this time axis. Should return an array of ticks. Each tick is an object of the following structure:
     * ```
     * {
     *    startDate : ..., // start date
     *    endDate   : ...  // end date
     * }
     * ```
     * Take notice, that this function either has to be called with `start`/`end` parameters, or create those variables.
     *
     * To see it in action please check out our [TimeAxis](https://bryntum.com/examples/scheduler/timeaxis/) example and navigate to "Compressed non-working time" tab.
     *
     * @param {Date} axisStartDate The start date of the interval
     * @param {Date} axisEndDate The end date of the interval
     * @param {String} unit The unit of the time axis
     * @param {Number} increment The increment for the unit specified.
     * @return {Array} ticks The ticks representing the time axis
     */

  }, {
    key: "generateTicks",
    value: function generateTicks(axisStartDate, axisEndDate) {
      var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.unit;
      var increment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.increment;
      var me = this,
          ticks = [],
          usesExclusion = Boolean(me.include);

      var intervalEnd,
          tickEnd,
          isExcluded,
          dstDiff = 0,
          _me$getAdjustedDates2 = me.getAdjustedDates(axisStartDate, axisEndDate),
          startDate = _me$getAdjustedDates2.startDate,
          endDate = _me$getAdjustedDates2.endDate;

      me.tickCache = {};

      if (usesExclusion) {
        me.initExclusion();
      }

      while (startDate < endDate) {
        intervalEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getNext(startDate, unit, increment, me.weekStartDay);

        if (!me.autoAdjust && intervalEnd > endDate) {
          intervalEnd = endDate;
        } // Handle hourly increments crossing DST boundaries to keep the timescale looking correct
        // Only do this for HOUR resolution currently, and only handle it once per tick generation.


        if (unit === 'hour' && increment > 1 && ticks.length > 0 && dstDiff === 0) {
          var prev = ticks[ticks.length - 1];
          dstDiff = (prev.startDate.getHours() + increment) % 24 - prev.endDate.getHours();

          if (dstDiff !== 0) {
            // A DST boundary was crossed in previous tick, adjust this tick to keep timeaxis "symmetric".
            intervalEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(intervalEnd, dstDiff, 'hour');
          }
        }

        isExcluded = false;

        if (usesExclusion) {
          tickEnd = new Date(intervalEnd.getTime());
          isExcluded = me.processExclusion(startDate, intervalEnd, unit);
        } else {
          tickEnd = intervalEnd;
        }

        if (me.generateTicksValidatorFn(startDate) && !isExcluded) {
          ticks.push({
            id: ticks.length + 1,
            startDate: startDate,
            endDate: intervalEnd
          });
          me.tickCache[startDate.getTime()] = ticks.length - 1;
        }

        startDate = tickEnd;
      }

      return ticks;
    }
  }, {
    key: "getTickFromDate",

    /**
     * Gets a tick "coordinate" representing the date position on the time scale. Returns -1 if the date is not part of the time axis.
     * @param {Date} date the date
     * @return {Number} the tick position on the scale or -1 if the date is not part of the time axis
     */
    value: function getTickFromDate(date) {
      var me = this,
          ticks = me.records,
          dateMS = date.getTime();
      var begin = 0,
          end = ticks.length - 1,
          middle,
          tick,
          tickStart,
          tickEnd; // Quickly eliminate out of range dates or if we have not been set up with a time range yet

      if (!ticks.length || date < ticks[0].startDate || date > ticks[end].endDate) {
        return -1;
      }

      if (me.isContinuous) {
        // TODO: This is the code from ExtScheduler, it is a calculation without iteration so it should perform better,
        //  we should consider using it...
        // if (date - ticks[0].startDate === 0) return this.visibleTickStart;
        // if (date - ticks[end].endDate === 0) return this.visibleTickEnd;
        //
        // const { adjustedStart, adjustedEnd }     = this;
        //
        // let tickIndex       = Math.floor(ticks.length * (date - adjustedStart) / (adjustedEnd - adjustedStart));
        //
        // // for the date == adjustedEnd case
        // if (tickIndex > end) {
        //     tickIndex = end;
        // }
        //
        // const tickStart           = tickIndex === 0 ? adjustedStart : ticks[tickIndex].startDate;
        // const tickEnd             = tickIndex === end ? adjustedEnd : ticks[tickIndex].endDate;
        //
        // tick                = tickIndex + (date - tickStart) / (tickEnd - tickStart);
        //
        // // in case of `autoAdjust : false` the actual visible timespan starts not from 0 tick coordinate, but
        // // from `visibleTickStart` coordinate, this check generally repeats the "quick bailout" check in the begining of the method,
        // // but still
        // if (tick < this.visibleTickStart || tick > this.visibleTickEnd) {
        //     return -1;
        // }
        //
        // return tick;
        // Chop tick cache in half until we find a match
        while (begin < end) {
          middle = begin + end + 1 >> 1;

          if (dateMS > ticks[middle].endDate.getTime()) {
            begin = middle + 1;
          } else if (dateMS < ticks[middle].startDate.getTime()) {
            end = middle - 1;
          } else {
            begin = middle;
          }
        }

        tick = ticks[begin];
        tickStart = tick.startDate.getTime(); // Part way though, calculate the fraction

        if (dateMS > tickStart) {
          tickEnd = tick.endDate.getTime();
          begin += (dateMS - tickStart) / (tickEnd - tickStart);
        }

        return Math.min(Math.max(begin, me.visibleTickStart), me.visibleTickEnd);
      } else {
        for (var i = 0; i <= end; i++) {
          tickEnd = ticks[i].endDate;

          if (date <= tickEnd) {
            tickStart = ticks[i].startDate; // date < tickStart can occur in filtered case

            tick = i + (date > tickStart ? (date - tickStart) / (tickEnd - tickStart) : 0);
            return tick;
          }
        }
      }
    }
    /**
     * Gets the time represented by a tick "coordinate".
     * @param {Number} tick the tick "coordinate"
     * @param {String} [roundingMethod] The rounding method to use
     * @return {Date} The date to represented by the tick "coordinate", or null if invalid.
     */

  }, {
    key: "getDateFromTick",
    value: function getDateFromTick(tick, roundingMethod) {
      var me = this;

      if (tick === me.visibleTickEnd) {
        return me.endDate;
      }

      var wholeTick = Math.floor(tick),
          fraction = tick - wholeTick,
          t = me.getAt(wholeTick);

      if (!t) {
        return null;
      }

      var start = wholeTick === 0 ? me.adjustedStart : t.startDate,
          // if we've filtered timeaxis using filterBy, then we cannot trust to adjustedEnd property and should use tick end
      end = wholeTick === me.count - 1 && me.isContinuous ? me.adjustedEnd : t.endDate,
          date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].add(start, fraction * (end - start), 'millisecond');

      if (roundingMethod) {
        date = me[roundingMethod + 'Date'](date);
      }

      return date;
    }
    /**
     * Returns the ticks of the timeaxis in an array of objects with a "start" and "end" date.
     * @return {Object[]} the ticks on the scale
     */

  }, {
    key: "updateTickCache",

    /**
     * Caches ticks and start/end dates for faster processing during rendering of events.
     * @private
     */
    value: function updateTickCache() {
      var onlyStartEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this;

      if (me.count) {
        me._start = me.first.startDate;
        me._end = me.last.endDate;
        me._startMS = me.startDate.getTime();
        me._endMS = me.endDate.getTime();
      } else {
        me._start = me._end = me._startMs = me._endMS = null;
      } // onlyStartEnd is true prior to clearing filters, to get start and end dates correctly during that process.
      // No point in filling tickCache yet in that case, it will be done after the filters are cleared


      if (!onlyStartEnd) {
        me.tickCache = {};
        me.forEach(function (tick, i) {
          return me.tickCache[tick.startDate.getTime()] = i;
        });
      }
    } //endregion
    //region Axis

    /**
     * Returns true if the passed date is inside the span of the current time axis.
     * @param {Date} date The date to query for
     * @return {Boolean} true if the date is part of the timeaxis
     */

  }, {
    key: "dateInAxis",
    value: function dateInAxis(date) {
      var inclusiveEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          axisStart = me.startDate,
          axisEnd = me.endDate; // Date is between axis start/end and axis is not continuous - need to perform better lookup

      if (me.isContinuous) {
        return inclusiveEnd ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].betweenLesserEqual(date, axisStart, axisEnd) : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].betweenLesser(date, axisStart, axisEnd);
      } else {
        var length = me.getCount(),
            tickStart,
            tickEnd,
            tick;

        for (var i = 0; i < length; i++) {
          tick = me.getAt(i);
          tickStart = tick.startDate;
          tickEnd = tick.endDate;

          if (inclusiveEnd && date <= tickEnd || !inclusiveEnd && date < tickEnd) {
            return date >= tickStart;
          }
        }
      }

      return false;
    }
    /**
     * Returns true if the passed timespan is part of the current time axis (in whole or partially).
     * @param {Date} start The start date
     * @param {Date} end The end date
     * @return {Boolean} true if the timespan is part of the timeaxis
     */

  }, {
    key: "timeSpanInAxis",
    value: function timeSpanInAxis(start, end) {
      var me = this;

      if (!end || end.getTime() === start.getTime()) {
        return this.dateInAxis(start, true);
      }

      if (me.isContinuous) {
        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].intersectSpans(start, end, me.startDate, me.endDate);
      }

      return start < me.startDate && end > me.endDate || me.getTickFromDate(start) !== me.getTickFromDate(end);
    } // Accepts a TimeSpan model (uses its cached MS values to be a bit faster during rendering)

  }, {
    key: "isTimeSpanInAxis",
    value: function isTimeSpanInAxis(timeSpan) {
      var me = this,
          startMS = me.startMS,
          endMS = me.endMS,
          startDateMS = timeSpan.startDateMS,
          endDateMS = timeSpan.endDateMS; // only consider fully scheduled ranges

      if (!startDateMS || !endDateMS) return false;

      if (endDateMS === startDateMS) {
        return me.dateInAxis(timeSpan.startDate, true);
      }

      if (me.isContinuous) {
        return endDateMS > startMS && startDateMS < endMS;
      }

      var startTick = me.getTickFromDate(timeSpan.startDate),
          endTick = me.getTickFromDate(timeSpan.endDate); // endDate is not inclusive
      // TODO: Handle in getTickFromDate() somehow?

      if (startTick === me.count && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].isEqual(timeSpan.startDate, me.last.endDate) || endTick === 0 && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].isEqual(timeSpan.endDate, me.first.startDate)) {
        return false;
      }

      return (// Spanning entire axis
        startDateMS < startMS && endDateMS > endMS || // Unintentionally 0 wide (ticks excluded or outside)
        startTick !== endTick
      );
    } //endregion
    //region Iteration

    /**
     * Calls the supplied iterator function once per interval. The function will be called with three parameters, start date and end date and an index.
     * @internal
     * @param {String} unit The unit to use when iterating over the timespan
     * @param {Number} increment The increment to use when iterating over the timespan
     * @param {Function} iteratorFn The function to call
     * @param {Object} [thisObj] `this` reference for the function
     */

  }, {
    key: "forEachAuxInterval",
    value: function forEachAuxInterval(unit) {
      var increment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var iteratorFn = arguments.length > 2 ? arguments[2] : undefined;
      var thisObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this;
      var end = this.endDate,
          dt = this.startDate,
          i = 0,
          intervalEnd;
      if (dt > end) throw new Error('Invalid time axis configuration');

      while (dt < end) {
        intervalEnd = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].min(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].getNext(dt, unit, increment, this.weekStartDay), end);
        iteratorFn.call(thisObj, dt, intervalEnd, i);
        dt = intervalEnd;
        i++;
      }
    } //endregion

  }, {
    key: "isTimeAxis",
    get: function get() {
      return true;
    }
  }, {
    key: "viewPreset",
    get: function get() {
      return this._viewPreset;
    },
    set: function set(preset) {
      var me = this;
      preset = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_22__["default"].getPreset(preset);

      if (!(preset instanceof _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_21__["default"])) {
        throw new Error('TimeAxis must be configured with the ViewPreset instance that the Scheduler is using');
      }

      me._viewPreset = preset;
      Object.assign(me, {
        unit: preset.bottomHeader.unit,
        increment: preset.bottomHeader.increment || 1,
        resolutionUnit: preset.timeResolution.unit,
        resolutionIncrement: preset.timeResolution.increment,
        mainUnit: preset.mainHeader.unit,
        shiftUnit: preset.shiftUnit,
        shiftIncrement: preset.shiftIncrement || 1,
        defaultSpan: preset.defaultSpan || 1,
        presetName: preset.id,
        // Weekview columns are updated upon 'datachanged' event on this object.
        // We have to pass headers in order to render them correctly (timeAxisViewModel is incorrect in required time)
        headers: preset.headers
      });
    } //endregion
    //region Getters & setters

  }, {
    key: "weekStartDay",
    set: function set(day) {
      this._weekStartDay = day;
    },
    get: function get() {
      if (this._weekStartDay == null) {
        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].weekStartDay;
      }

      return this._weekStartDay;
    } // private

  }, {
    key: "resolution",
    get: function get() {
      return {
        unit: this.resolutionUnit,
        increment: this.resolutionIncrement
      };
    } // private
    ,
    set: function set(resolution) {
      this.resolutionUnit = resolution.unit;
      this.resolutionIncrement = resolution.increment;
    }
  }, {
    key: "resolutionUnit",
    get: function get() {
      return this._resolutionUnit;
    },
    set: function set(resolutionUnit) {
      this._resolutionUnit = resolutionUnit;
    }
  }, {
    key: "resolutionIncrement",
    get: function get() {
      return this._resolutionIncrement;
    },
    set: function set(resolutionIncrement) {
      this._resolutionIncrement = resolutionIncrement || 1;
    }
  }, {
    key: "mainUnit",
    set: function set(mainUnit) {
      this._mainUnit = mainUnit;
    },
    get: function get() {
      return this._mainUnit;
    }
  }, {
    key: "shiftUnit",
    set: function set(shiftUnit) {
      this._shiftUnit = shiftUnit;
    } // private
    ,
    get: function get() {
      return this._shiftUnit || this._mainUnit;
    }
  }, {
    key: "shiftIncrement",
    set: function set(shiftIncrement) {
      this._shiftIncrement = shiftIncrement;
    } // private
    ,
    get: function get() {
      return this._shiftIncrement || 1;
    }
  }, {
    key: "unit",
    set: function set(unit) {
      this._unit = unit;
    } // private
    ,
    get: function get() {
      return this._unit;
    }
  }, {
    key: "increment",
    set: function set(increment) {
      this._increment = increment;
    } // private
    ,
    get: function get() {
      return this._increment;
    }
  }, {
    key: "defaultSpan",
    get: function get() {
      return this._defaultSpan;
    },
    set: function set(defaultSpan) {
      this._defaultSpan = defaultSpan;
    }
  }, {
    key: "isContinuous",
    get: function get() {
      return this.continuous !== false && !this.filtered;
    }
  }, {
    key: "startDate",
    get: function get() {
      // TODO: added _start as caching, might mess something up when reconfiguring? change here if tests fail
      return this._start || (this.first ? new Date(this.first.startDate) : null);
    },
    set: function set(start) {
      this._start = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].parse(start);
    }
    /**
     * Method to get a the current end date of the time axis
     * @property {Date}
     */

  }, {
    key: "endDate",
    get: function get() {
      return this._end || (this.last ? new Date(this.last.endDate) : null);
    },
    set: function set(end) {
      if (end) this._end = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].parse(end);
    } // used in performance critical code for comparisons

  }, {
    key: "startMS",
    get: function get() {
      return this._startMS;
    } // used in performance critical code for comparisons

  }, {
    key: "endMS",
    get: function get() {
      return this._endMS;
    }
  }, {
    key: "include",
    get: function get() {
      return this._include;
    },
    set: function set(include) {
      var me = this;
      me._include = include;
      me.continuous = !include;

      if (!me.isConfiguring) {
        me.startDate = me._configuredStartDate;
        me.endDate = me._configuredEndDate;
        me.internalOnReconfigure();
        me.trigger('includeChange');
      }
    }
  }, {
    key: "visibleTickTimeSpan",
    get: function get() {
      var me = this;
      return me.isContinuous ? me.visibleTickEnd - me.visibleTickStart : me.count;
    }
  }, {
    key: "ticks",
    get: function get() {
      return this.records;
    }
  }], [{
    key: "defaultConfig",
    //region Events

    /**
     * Fires before the timeaxis is about to be reconfigured (e.g. new start/end date or unit/increment). Return false to abort the operation.
     * @event beforereconfigure
     * @param {Scheduler.data.TimeAxis} source The time axis instance
     * @param {Date} startDate The new time axis start date
     * @param {Date} endDate The new time axis end date
     */

    /**
     * Event that is triggered when we end reconfiguring and everything UI-related should be done
     * @event endreconfigure
     * @private
     */

    /**
     * Fires when the timeaxis has been reconfigured (e.g. new start/end date or unit/increment)
     * @event reconfigure
     * @param {Scheduler.data.TimeAxis} source The time axis instance
     */

    /**
     * Fires if all the ticks in the timeaxis are filtered out. After firing the filter is cleared to return the time
     * axis to a valid state.
     * @event invalidFilter
     * @param {Scheduler.data.TimeAxis} source The time axis instance
     */
    //endregion
    //region Default config
    get: function get() {
      return {
        modelClass: _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_20__["default"],

        /**
         * Set to false if the timeline is not continuous, e.g. the next timespan does not start where the previous ended (for example skipping weekends etc).
         * @config {Boolean}
         * @default
         */
        continuous: true,
        originalContinuous: null,

        /**
         * Include only certain hours or days in the time axis (makes it `continuous : false`). Accepts and object
         * with `day` and `hour` properties:
         * ```
         * const scheduler = new Scheduler({
         *     timeAxis : {
         *         include : {
         *              // Do not display hours after 17 or before 9 (only display 9 - 17). The `to´ value is not
         *              // included in the time axis
         *              hour : {
         *                  from : 9,
         *                  to   : 17
         *              },
         *              // Do not display sunday or saturday
         *              day : [0, 6]
         *         }
         *     }
         * }
         * ```
         * In most cases we recommend that you use Scheduler's workingTime config instead. It is easier to use and
         * makes sure all parts of the Scheduler gets updated.
         * @config {Object}
         */
        include: null,

        /**
         * Automatically adjust the timespan when generating ticks with {@link #function-generateTicks} according to
         * the `viewPreset` configuration. Setting this to false may lead to shifting time/date of ticks.
         * @config {Boolean}
         * @default
         */
        autoAdjust: true,
        unit: null,
        increment: null,
        resolutionUnit: null,
        resolutionIncrement: null,
        weekStartDay: null,
        mainUnit: null,
        shiftUnit: null,
        shiftIncrement: 1,
        //isConfigured : false,
        // in case of `autoAdjust : false`, the 1st and last ticks can be truncated, containing only part of the normal tick
        // these dates will contain adjusted start/end (like if the tick has not been truncated)
        adjustedStart: null,
        adjustedEnd: null,
        // the visible position in the first tick, can actually be > 1 because the adjustment is done by the `mainUnit`
        visibleTickStart: null,
        // the visible position in the first tick, is always ticks count - 1 < value <= ticks count, in case of autoAdjust, always = ticks count
        visibleTickEnd: null,
        defaultSpan: 1,
        tickCache: {},
        viewPreset: null
      };
    }
  }]);

  return TimeAxis;
}(_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_18__["default"]);


TimeAxis._$name = 'TimeAxis';

/***/ }),

/***/ "./lib/Scheduler/data/mixin/AssignmentStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/AssignmentStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");






































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_35___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/data/mixin/AssignmentStoreMixin
 */

/**
 * This is a mixin, containing functionality related to managing assignments.
 *
 * It is consumed by the regular {@link Scheduler.data.AssignmentStore} class and Scheduler Pros counterpart.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_34___default()(AssignmentStoreMixin, _Target);

    var _super = _createSuper(AssignmentStoreMixin);

    function AssignmentStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default()(this, AssignmentStoreMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default()(AssignmentStoreMixin, [{
      key: "add",
      value: function add(newAssignments) {
        if (!Array.isArray(newAssignments)) {
          newAssignments = [newAssignments];
        }

        for (var i = 0; i < newAssignments.length; i++) {
          var a = newAssignments[i];

          if (!(a instanceof _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_37__["default"])) {
            newAssignments[i] = a = this.createRecord(a);
          }

          if (this.storage.findIndex('eventResourceKey', a.eventResourceKey, true) !== -1) {
            throw new Error("Duplicate assignment Event: ".concat(a.eventId, " to resource: ").concat(a.resourceId));
          }
        }

        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(AssignmentStoreMixin.prototype), "add", this).call(this, newAssignments);
      }
    }, {
      key: "setStoreData",
      value: function setStoreData(data) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(AssignmentStoreMixin.prototype), "setStoreData", this).call(this, data);
      } //region Init & destroy

    }, {
      key: "getOccurrence",
      //endregion
      //region Recurrence

      /**
       * Returns a "fake" assignment used to identify a certain occurrence of a recurring event.
       * If passed the original event, it returns `originalAssignment`.
       * @param {Scheduler.model.AssignmentModel} originalAssignment
       * @param {Scheduler.model.EventModel} occurrence
       * @returns {Object} Temporary assignment
       * @internal
       */
      value: function getOccurrence(originalAssignment, occurrence) {
        // Pass along the original assignment for non occurrence related calls
        if (!originalAssignment || !(occurrence === null || occurrence === void 0 ? void 0 : occurrence.isOccurrence)) {
          return originalAssignment;
        } // Not for saving chars, needed in fn below


        var me = this;
        return {
          id: "".concat(occurrence.id, ":a").concat(originalAssignment.id),
          event: occurrence,
          resource: originalAssignment.resource,
          eventId: occurrence.id,
          resourceId: originalAssignment.resource.id,
          isAssignment: true,
          // This field is required to distinguish this fake assignment when event is being removed from UI
          isOccurrenceAssignment: true,
          // Not being an actual record, instanceMeta is stored on the store instead
          instanceMeta: function instanceMeta(instanceOrId) {
            return me.occurrenceInstanceMeta(this, instanceOrId);
          }
        };
      } // Per fake assignment instance meta, stored on store since fakes are always generated on demand

    }, {
      key: "occurrenceInstanceMeta",
      value: function occurrenceInstanceMeta(occurrenceAssignment, instanceOrId) {
        var me = this,
            instanceId = instanceOrId.id || instanceOrId,
            id = occurrenceAssignment.id;
        var occurrenceMeta = me.occurrenceMeta;

        if (!occurrenceMeta) {
          occurrenceMeta = me.occurrenceMeta = {};
        }

        if (!occurrenceMeta[id]) {
          occurrenceMeta[id] = {};
        }

        return occurrenceMeta[id][instanceId] || (occurrenceMeta[id][instanceId] = {});
      } //endregion
      //region Mapping

      /**
       * Maps over event assignments.
       *
       * @param {Scheduler.model.EventModel} event
       * @param {Function} [fn]
       * @param {Function} [filterFn]
       * @return {Scheduler.model.EventModel[]|Array}
       * @category Assignments
       */

    }, {
      key: "mapAssignmentsForEvent",
      value: function mapAssignmentsForEvent(event, fn, filterFn) {
        event = this.eventStore.getById(event);
        var fnSet = Boolean(fn),
            filterFnSet = Boolean(filterFn);

        if (fnSet || filterFnSet) {
          return event.assignments.reduce(function (result, assignment) {
            var mapResult = fnSet ? fn(assignment) : assignment;

            if (!filterFnSet || filterFn(mapResult)) {
              result.push(mapResult);
            }

            return result;
          }, []);
        }

        return event.assignments;
      }
      /**
       * Maps over resource assignments.
       *
       * @param {Scheduler.model.ResourceModel|Number|String} resource
       * @param {Function} [fn]
       * @param {Function} [filterFn]
       * @return {Scheduler.model.ResourceModel[]|Array}
       * @category Assignments
       */

    }, {
      key: "mapAssignmentsForResource",
      value: function mapAssignmentsForResource(resource, fn, filterFn) {
        resource = this.resourceStore.getById(resource);
        var fnSet = Boolean(fn),
            filterFnSet = Boolean(filterFn);

        if (fnSet || filterFnSet) {
          return resource.assignments.reduce(function (result, assignment) {
            var mapResult = fnSet ? fn(assignment) : assignment;

            if (!filterFnSet || filterFn(mapResult)) {
              result.push(mapResult);
            }

            return result;
          }, []);
        }

        return resource.assignments;
      }
      /**
       * Returns all assignments for a given event.
       *
       * @param {Scheduler.model.TimeSpan} event
       * @return {Scheduler.model.AssignmentModel[]}
       * @category Assignments
       */

    }, {
      key: "getAssignmentsForEvent",
      value: function getAssignmentsForEvent(event) {
        return event.assignments;
      }
      /**
       * Removes all assignments for given event
       *
       * @param {Scheduler.model.TimeSpan} event
       * @category Assignments
       */

    }, {
      key: "removeAssignmentsForEvent",
      value: function removeAssignmentsForEvent(event) {
        return this.remove(event.assignments);
      }
      /**
       * Returns all assignments for a given resource.
       *
       * @param {Scheduler.model.ResourceModel} resource
       * @return {Scheduler.model.AssignmentModel[]}
       * @category Assignments
       */

    }, {
      key: "getAssignmentsForResource",
      value: function getAssignmentsForResource(resource) {
        resource = this.resourceStore.getById(resource);
        return resource.assignments;
      }
      /**
       * Removes all assignments for given resource
       *
       * @param {Scheduler.model.ResourceModel|*} resource
       * @category Assignments
       */

    }, {
      key: "removeAssignmentsForResource",
      value: function removeAssignmentsForResource(resource) {
        this.remove(this.getAssignmentsForResource(resource));
      }
      /**
       * Returns all resources assigned to an event.
       *
       * @param {Scheduler.model.EventModel} event
       * @return {Scheduler.model.ResourceModel[]}
       * @category Assignments
       */

    }, {
      key: "getResourcesForEvent",
      value: function getResourcesForEvent(event) {
        return event.resources;
      }
      /**
       * Returns all events assigned to a resource
       *
       * @param {Scheduler.model.ResourceModel|String|Number} resource
       * @return {Scheduler.model.TimeSpan[]}
       * @category Assignments
       */

    }, {
      key: "getEventsForResource",
      value: function getEventsForResource(resource) {
        resource = this.resourceStore.getById(resource);
        return resource && resource.events;
      }
      /**
       * Creates and adds assignment record(s) for a given event and resource(s).
       *
       * @param {Scheduler.model.TimeSpan} event
       * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} resources The resource(s) to assign to the event
       * @param {Boolean} [removeExistingAssignments] `true` to remove assignments for other resources
       * @return {Scheduler.model.AssignmentModel[]} An array with the created assignment(s)
       * @category Assign
       */

    }, {
      key: "assignEventToResource",
      value: function assignEventToResource(event, resources) {
        var assignmentSetupFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (o) {
          return o;
        };
        var removeExistingAssignments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var me = this,
            toRemove = removeExistingAssignments ? new Set(event.assignments) : null;
        resources = Array.isArray(resources) ? resources : [resources]; // Use same code path as other single assignments if already assigned

        if (me.eventStore && me.eventStore.usesSingleAssignment && event.assignments.length) {
          if (!me.isEventAssignedToResource(event, resources[0])) {
            event.resource = resources[0];
          }

          return [];
        }

        var newAssignments = [];
        me.suspendAutoCommit(); // Assign

        resources.forEach(function (resource) {
          var assignment = me.getAssignmentForEventAndResource(event, resource);

          if (!assignment) {
            var _assignment = {
              eventId: _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_37__["default"].asId(event),
              resourceId: _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_37__["default"].asId(resource)
            };
            _assignment = assignmentSetupFn(_assignment);
            newAssignments.push(_assignment);
          } else if (removeExistingAssignments) {
            toRemove.delete(assignment);
          }
        });
        newAssignments = me.add(newAssignments);

        if (removeExistingAssignments) {
          me.remove(Array.from(toRemove));
        } // If true, will trigger a commit


        me.resumeAutoCommit();
        return newAssignments;
      }
      /**
       * Removes assignment record for a given event and resource.
       *
       * @param {Scheduler.model.TimeSpan|String|Number} event
       * @param {Scheduler.model.ResourceModel|String|Number} [resources] The resource to unassign the event from. If omitted, all resources of the events will be unassigned
       * @return {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]}
       * @category Assign
       */

    }, {
      key: "unassignEventFromResource",
      value: function unassignEventFromResource(event, resources) {
        var me = this,
            assignmentsToRemove = [];

        if (!resources) {
          return me.removeAssignmentsForEvent(event);
        }

        if (!Array.isArray(resources)) {
          resources = [resources];
        }

        for (var i = 0; i < resources.length; i++) {
          if (me.isEventAssignedToResource(event, resources[i])) {
            assignmentsToRemove.push(me.getAssignmentForEventAndResource(event, resources[i]));
          }
        }

        return me.remove(assignmentsToRemove);
      }
      /**
       * Checks whether an event is assigned to a resource.
       *
       * @param {Scheduler.model.EventModel|String|Number} event Event record or id
       * @param {Scheduler.model.ResourceModel|String|Number} resource Resource record or id
       * @return {Boolean}
       * @category Assignments
       */

    }, {
      key: "isEventAssignedToResource",
      value: function isEventAssignedToResource(event, resource) {
        return Boolean(this.getAssignmentForEventAndResource(event, resource));
      }
      /**
       * Returns an assignment record for a given event and resource
       *
       * @param {Scheduler.model.EventModel|String|Number} event The event or its id
       * @param {Scheduler.model.ResourceModel|String|Number} resource The resource or its id
       * @return {Scheduler.model.AssignmentModel}
       * @category Assignments
       */

    }, {
      key: "getAssignmentForEventAndResource",
      value: function getAssignmentForEventAndResource(event, resource) {
        event = this.eventStore.getById(event);
        resource = this.resourceStore.getById(resource);

        if (!event || !resource) {
          return null;
        }

        return this.getOccurrence(event.assignments.find(function (a) {
          return a.resource === resource;
        }), event);
      } //endregion

    }, {
      key: "storage",
      set: function set(storage) {
        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_32___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(AssignmentStoreMixin.prototype), "storage", storage, this, true); // This allows a map based, fast lookup of assignments by their eventResourceKey.
        // This is so that the test for duplicate assignment adding is fast.


        this.storage.addIndex('eventResourceKey');
      },
      get: function get() {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_33___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_36___default()(AssignmentStoreMixin.prototype), "storage", this);
      } //endregion
      //region Stores
      // To not have to do instanceof checks

    }, {
      key: "isAssignmentStore",
      get: function get() {
        return true;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'AssignmentStoreMixin';
      }
      /**
       * Add assignments to the store.
       *
       * NOTE: References (event, resource) on the assignments are determined async by a calculation engine. Thus they
       * cannot be directly accessed after using this function.
       *
       * For example:
       *
       * ```javascript
       * const [assignment] = assignmentStore.add({ eventId, resourceId });
       * // assignment.event is not yet available
       * ```
       *
       * To guarantee references are set up, wait for calculations for finish:
       *
       * ```javascript
       * const [assignment] = assignmentStore.add({ eventId, resourceId });
       * await assignmentStore.project.commitAsync();
       * // assignment.event is available (assuming EventStore is loaded and so on)
       * ```
       *
       * Alternatively use `addAsync()` instead:
       *
       * ```javascript
       * const [assignment] = await assignmentStore.addAsync({ eventId, resourceId });
       * // assignment.event is available (assuming EventStore is loaded and so on)
       * ```
       *
       * @param {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]|Object|Object[]} records
       * Array of records/data or a single record/data to add to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Scheduler.model.AssignmentModel[]} Added records
       * @function add
       * @category CRUD
       */

      /**
       * Add assignments to the store and triggers calculations directly after. Await this function to have up to date
       * references on the added assignments.
       *
       * ```javascript
       * const [assignment] = await assignmentStore.addAsync({ eventId, resourceId });
       * // assignment.event is available (assuming EventStore is loaded and so on)
       * ```
       *
       * @param {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]|Object|Object[]} records
       * Array of records/data or a single record/data to add to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Scheduler.model.AssignmentModel[]} Added records
       * @function addAsync
       * @category CRUD
       * @async
       */

      /**
       * Applies a new dataset to the AssignmentStore. Use it to plug externally fetched data into the store.
       *
       * NOTE: References (assignments, resources) on the assignments are determined async by a calculation engine. Thus
       * they cannot be directly accessed after assigning the new dataset.
       *
       * For example:
       *
       * ```javascript
       * assignmentStore.data = [{ eventId, resourceId }];
       * // assignmentStore.first.event is not yet available
       * ```
       *
       * To guarantee references are available, wait for calculations for finish:
       *
       * ```javascript
       * assignmentStore.data = [{ eventId, resourceId  }];
       * await assignmentStore.project.commitAsync();
       * // assignmentStore.first.event is available
       * ```
       *
       * Alternatively use `loadDataAsync()` instead:
       *
       * ```javascript
       * await assignmentStore.loadDataAsync([{ eventId, resourceId }]);
       * // assignmentStore.first.event is available
       * ```
       *
       * @member {Object[]} data
       * @category Records
       */

      /**
       * Applies a new dataset to the AssignmentStore and triggers calculations directly after. Use it to plug externally
       * fetched data into the store.
       *
       * ```javascript
       * await assignmentStore.loadDataAsync([{ eventId, resourceId }]);
       * // assignmentStore.first.event is available
       * ```
       *
       * @param {Object[]} data Array of AssignmentModel data objects
       * @function loadDataAsync
       * @category CRUD
       * @async
       */

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * CrudManager must load stores in the correct order. Lowest first.
           * @private
           */
          loadPriority: 300,

          /**
           * CrudManager must sync stores in the correct order. Lowest first.
           * @private
           */
          syncPriority: 300,
          storeId: 'assignments'
        };
      }
    }]);

    return AssignmentStoreMixin;
  }(Target);
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/AttachToProjectMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Scheduler/data/mixin/AttachToProjectMixin
*/

/**
 * Mixin that calls the target class `attachToProject()` function when a new project is assigned to Scheduler/Gantt.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(AttachToProjectMixin, _Target);

    var _super = _createSuper(AttachToProjectMixin);

    function AttachToProjectMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, AttachToProjectMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(AttachToProjectMixin, [{
      key: "afterConstruct",
      value: function () {
        var _afterConstruct = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee() {
          var me, projectHolder, project;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(AttachToProjectMixin.prototype), "afterConstruct", this).call(this);

                  me = this, projectHolder = me.client || me.grid, project = projectHolder.project;
                  projectHolder.projectSubscribers.push(me); // Attach to already existing stores

                  if (project) {
                    me.attachToProject(project);
                    me.attachToResourceStore(project.resourceStore);
                    me.attachToEventStore(project.eventStore);
                    me.attachToAssignmentStore(project.assignmentStore);
                    me.attachToDependencyStore(project.dependencyStore);
                    me.attachToCalendarManagerStore(project.calendarManagerStore);
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function afterConstruct() {
          return _afterConstruct.apply(this, arguments);
        }

        return afterConstruct;
      }()
      /**
       * Override to take action when the project instance is replaced.
       *
       * @param {Scheduler.model.ProjectModel} project
       */

    }, {
      key: "attachToProject",
      value: function attachToProject(project) {
        this.detachListeners('project');
        this._project = project;
      }
      /**
       * Override to take action when the EventStore instance is replaced, either from being replaced on the project or
       * from assigning a new project.
       *
       * @param {Scheduler.data.EventStore} store
       */

    }, {
      key: "attachToEventStore",
      value: function attachToEventStore(store) {
        this.detachListeners('eventStore');
        this.eventStore = store;
      }
      /**
       * Override to take action when the ResourceStore instance is replaced, either from being replaced on the project
       * or from assigning a new project.
       *
       * @param {Scheduler.data.ResourceStore} store
       */

    }, {
      key: "attachToResourceStore",
      value: function attachToResourceStore(store) {
        this.detachListeners('resourceStore');
        this.resourceStore = store;
      }
      /**
       * Override to take action when the AssignmentStore instance is replaced, either from being replaced on the project
       * or from assigning a new project.
       *
       * @param {Scheduler.data.AssignmentStore} store
       */

    }, {
      key: "attachToAssignmentStore",
      value: function attachToAssignmentStore(store) {
        this.detachListeners('assignmentStore');
        this.assignmentStore = store;
      }
      /**
       * Override to take action when the DependencyStore instance is replaced, either from being replaced on the project
       * or from assigning a new project.
       *
       * @param {Scheduler.data.DependencyStore} store
       */

    }, {
      key: "attachToDependencyStore",
      value: function attachToDependencyStore(store) {
        this.detachListeners('dependencyStore');
        this.dependencyStore = store;
      } // TODO: Move attachToCalendarMangerStore to Pro somehow

      /**
       * Override to take action when the CalendarManagerStore instance is replaced, either from being replaced on the
       * project or from assigning a new project.
       *
       * @param {Core.data.Store} store
       */

    }, {
      key: "attachToCalendarManagerStore",
      value: function attachToCalendarManagerStore(store) {
        this.detachListeners('calendarManagerStore');
        this.calendarManagerStore = store;
      }
    }, {
      key: "project",
      get: function get() {
        return this._project;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'AttachToProjectMixin';
      }
    }]);

    return AttachToProjectMixin;
  }(Target);
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/DependencyStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/DependencyStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/data/mixin/DependencyStoreMixin
 */

/**
 * This is a mixin, containing functionality related to managing dependencies.
 *
 * It is consumed by the regular {@link Scheduler.data.DependencyStore} class and Scheduler Pros counterpart.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(DependencyStoreMixin, _Target);

    var _super = _createSuper(DependencyStoreMixin);

    function DependencyStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, DependencyStoreMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(DependencyStoreMixin, [{
      key: "reduceEventDependencies",
      // TODO: document
      value: function reduceEventDependencies(event, reduceFn, result) {
        var _this = this;

        var flat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        var depsGetterFn = arguments.length > 4 ? arguments[4] : undefined;

        depsGetterFn = depsGetterFn || function (event) {
          return _this.getEventDependencies(event);
        };

        event = Array.isArray(event) ? event : [event];
        event.reduce(function (result, event) {
          if (event.children && !flat) {
            event.traverse(function (evt) {
              result = depsGetterFn(evt).reduce(reduceFn, result);
            });
          } else {
            result = depsGetterFn(event).reduce(reduceFn, result);
          }
        }, result);
        return result;
      } // TODO: document

    }, {
      key: "mapEventDependencies",
      value: function mapEventDependencies(event, fn, filterFn, flat, depsGetterFn) {
        return this.reduceEventDependencies(event, function (result, dependency) {
          filterFn(dependency) && result.push(dependency);
          return result;
        }, [], flat, depsGetterFn);
      } // TODO: document

    }, {
      key: "mapEventPredecessors",
      value: function mapEventPredecessors(event, fn, filterFn, flat) {
        return this.reduceEventPredecessors(event, function (result, dependency) {
          filterFn(dependency) && result.push(dependency);
          return result;
        }, [], flat);
      } // TODO: document

    }, {
      key: "mapEventSuccessors",
      value: function mapEventSuccessors(event, fn, filterFn, flat) {
        return this.reduceEventSuccessors(event, function (result, dependency) {
          filterFn(dependency) && result.push(dependency);
          return result;
        }, [], flat);
      }
      /**
       * Returns all dependencies for a certain event (both incoming and outgoing)
       *
       * @param {Scheduler.model.EventModel} event
       * @return {Scheduler.model.DependencyModel[]}
       */

    }, {
      key: "getEventDependencies",
      value: function getEventDependencies(event) {
        return [].concat(event.predecessors || [], event.successors || []);
      }
      /**
       * Returns all incoming dependencies of the given event
       *
       * @param {Scheduler.model.EventModel} event
       * @return {Scheduler.model.DependencyModel[]}
       * @deprecated 5.0.0
       */

    }, {
      key: "getEventPredecessors",
      value: function getEventPredecessors(event) {
        _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].deprecate('scheduler', '5.0.0', 'Superfluous, will be removed in favour of `event.predecessors`');
        return event.predecessors;
      }
      /**
       * Returns all outgoing dependencies of a event
       *
       * @param {Scheduler.model.EventModel} event
       * @return {Scheduler.model.DependencyModel[]}
       * @deprecated 5.0.0
       */

    }, {
      key: "getEventSuccessors",
      value: function getEventSuccessors(event) {
        _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].deprecate('scheduler', '5.0.0', 'Superfluous, will be removed in favour of `event.successors`');
        return event.successors;
      } // TODO: document

    }, {
      key: "removeEventDependencies",
      value: function removeEventDependencies(event) {
        this.remove(this.getEventDependencies(event));
      } // TODO: document

    }, {
      key: "removeEventPredecessors",
      value: function removeEventPredecessors(event) {
        this.remove(event.predecessors);
      } // TODO: document

    }, {
      key: "removeEventSuccessors",
      value: function removeEventSuccessors(event, flat) {
        this.remove(event.successors);
      }
    }, {
      key: "getBySourceTargetId",
      value: function getBySourceTargetId(key) {
        var _this2 = this;

        //TODO: in original code this uses a keymap
        return this.records.find(function (r) {
          return key == _this2.constructor.makeDependencySourceTargetCompositeKey(r.from, r.to);
        });
      }
      /**
       * Returns dependency model instance linking tasks with given ids. The dependency can be forward (from 1st
       * task to 2nd) or backward (from 2nd to 1st).
       *
       * @param {Scheduler.model.EventModel|String} sourceEvent 1st event
       * @param {Scheduler.model.EventModel|String} targetEvent 2nd event
       * @return {Scheduler.model.DependencyModel}
       */

    }, {
      key: "getDependencyForSourceAndTargetEvents",
      value: function getDependencyForSourceAndTargetEvents(sourceEvent, targetEvent) {
        sourceEvent = _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_12__["default"].asId(sourceEvent);
        targetEvent = _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_12__["default"].asId(targetEvent);
        return this.getBySourceTargetId(this.constructor.makeDependencySourceTargetCompositeKey(sourceEvent, targetEvent));
      }
      /**
       * Returns a dependency model instance linking given events if such dependency exists in the store.
       * The dependency can be forward (from 1st event to 2nd) or backward (from 2nd to 1st).
       *
       * @param {Scheduler.model.EventModel|String} sourceEvent
       * @param {Scheduler.model.EventModel|String} targetEvent
       * @return {Scheduler.model.DependencyModel}
       */

    }, {
      key: "getEventsLinkingDependency",
      value: function getEventsLinkingDependency(sourceEvent, targetEvent) {
        return this.getDependencyForSourceAndTargetEvents(sourceEvent, targetEvent) || this.getDependencyForSourceAndTargetEvents(targetEvent, sourceEvent);
      }
      /**
       * Validation method used to validate a dependency. Override and return `true` to indicate that an
       * existing dependency between two tasks is valid. For a new dependency being created please see
       * {@link #function-isValidDependencyToCreate}.
       *
       * @param {Scheduler.model.DependencyModel|Number|String} dependencyOrFromId The dependency model or from event id
       * @param {Number|String} [toId] To event id if the first parameter is not a dependency model instance
       * @param {Number} [type] Dependency {@link Scheduler.model.DependencyBaseModel#property-Type-static}  if the first parameter is not a dependency model instance.
       * @return {Boolean}
       */

    }, {
      key: "isValidDependency",
      value: function isValidDependency(dependencyOrFromId, toId, type) {
        if (arguments.length === 1) {
          toId = dependencyOrFromId.to || dependencyOrFromId.toEvent;
          dependencyOrFromId = dependencyOrFromId.from || dependencyOrFromId.fromEvent;
        } // This condition is supposed to map all model instances to be validated by project. Lowest common ancestor
        // for scheduler event, scheduler pro event and gantt task is TimeSpan


        if (dependencyOrFromId instanceof _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_13__["default"] && toId instanceof _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_13__["default"]) {
          // Not asserting dependency type here. Default value should normally suffice.
          return this.project.isValidDependency(dependencyOrFromId, toId, type);
        }

        return dependencyOrFromId != null && toId != null && dependencyOrFromId !== toId;
      }
      /**
       * Validation method used to validate a dependency while creating. Override and return `true` to indicate that
       * a new dependency is valid to be created.
       *
       * @param {Number|String} fromId `From` event id
       * @param {Number|String} toId `To` event id
       * @param {Number} type Dependency {@link Scheduler.model.DependencyBaseModel#property-Type-static}
       * @return {Boolean}
       */

    }, {
      key: "isValidDependencyToCreate",
      value: function isValidDependencyToCreate(fromId, toId, type) {
        return this.isValidDependency(fromId, toId, type);
      }
      /**
       * Returns all dependencies highlighted with the given CSS class
       *
       * @param {String} cls
       * @return {Scheduler.model.DependencyBaseModel[]}
       */

    }, {
      key: "getHighlightedDependencies",
      value: function getHighlightedDependencies(cls) {
        return this.records.reduce(function (result, dep) {
          if (dep.isHighlightedWith(cls)) result.push(dep);
          return result;
        }, []);
      }
    }, {
      key: "getTimeSpanDependencies",
      //region Product neutral
      value: function getTimeSpanDependencies(record) {
        return this.getEventDependencies(record);
      } //endregion

    }], [{
      key: "makeDependencySourceTargetCompositeKey",
      value: function makeDependencySourceTargetCompositeKey(from, to) {
        return "source(".concat(from, ")-target(").concat(to, ")");
      }
    }, {
      key: "$name",
      get: function get() {
        return 'DependencyStoreMixin';
      }
      /**
       * Add dependencies to the store.
       *
       * NOTE: References (fromEvent, toEvent) on the dependencies are determined async by a calculation engine. Thus they
       * cannot be directly accessed after using this function.
       *
       * For example:
       *
       * ```javascript
       * const [dependency] = dependencyStore.add({ from, to });
       * // dependency.fromEvent is not yet available
       * ```
       *
       * To guarantee references are set up, wait for calculations for finish:
       *
       * ```javascript
       * const [dependency] = dependencyStore.add({ from, to });
       * await dependencyStore.project.commitAsync();
       * // dependency.fromEvent is available (assuming EventStore is loaded and so on)
       * ```
       *
       * Alternatively use `addAsync()` instead:
       *
       * ```javascript
       * const [dependency] = await dependencyStore.addAsync({ from, to });
       * // dependency.fromEvent is available (assuming EventStore is loaded and so on)
       * ```
       *
       * @param {Scheduler.model.DependencyModel|Scheduler.model.DependencyModel[]|Object|Object[]} records
       * Array of records/data or a single record/data to add to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Scheduler.model.DependencyModel[]} Added records
       * @function add
       * @category CRUD
       */

      /**
       * Add dependencies to the store and triggers calculations directly after. Await this function to have up to date
       * references on the added dependencies.
       *
       * ```javascript
       * const [dependency] = await dependencyStore.addAsync({ from, to });
       * // dependency.fromEvent is available (assuming EventStore is loaded and so on)
       * ```
       *
       * @param {Scheduler.model.DependencyModel|Scheduler.model.DependencyModel[]|Object|Object[]} records
       * Array of records/data or a single record/data to add to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Scheduler.model.DependencyModel[]} Added records
       * @function addAsync
       * @category CRUD
       * @async
       */

      /**
       * Applies a new dataset to the DependencyStore. Use it to plug externally fetched data into the store.
       *
       * NOTE: References (fromEvent, toEvent) on the dependencies are determined async by a calculation engine. Thus
       * they cannot be directly accessed after assigning the new dataset.
       *
       * For example:
       *
       * ```javascript
       * dependencyStore.data = [{ from, to }];
       * // dependencyStore.first.fromEvent is not yet available
       * ```
       *
       * To guarantee references are available, wait for calculations for finish:
       *
       * ```javascript
       * dependencyStore.data = [{ from, to }];
       * await dependencyStore.project.commitAsync();
       * // dependencyStore.first.fromEvent is available
       * ```
       *
       * Alternatively use `loadDataAsync()` instead:
       *
       * ```javascript
       * await dependencyStore.loadDataAsync([{ from, to }]);
       * // dependencyStore.first.fromEvent is available
       * ```
       *
       * @member {Object[]} data
       * @category Records
       */

      /**
       * Applies a new dataset to the DependencyStore and triggers calculations directly after. Use it to plug externally
       * fetched data into the store.
       *
       * ```javascript
       * await dependencyStore.loadDataAsync([{ from, to }]);
       * // dependencyStore.first.fromEvent is available
       * ```
       *
       * @param {Object[]} data Array of DependencyModel data objects
       * @function loadDataAsync
       * @category CRUD
       * @async
       */

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * CrudManager must load stores in the correct order. Lowest first.
           * @private
           */
          loadPriority: 400,

          /**
           * CrudManager must sync stores in the correct order. Lowest first.
           * @private
           */
          syncPriority: 400,
          storeId: 'dependencies'
        };
      }
    }]);

    return DependencyStoreMixin;
  }(Target);
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/EventStoreMixin.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/data/mixin/EventStoreMixin.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../../model/AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
























































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_53___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/data/mixin/EventStoreMixin
 */

var returnTrue = function returnTrue() {
  return true;
},
    emptyArray = Object.freeze([]),
    emptyIndex = Object.freeze({}),
    MS_PER_DAY = 864e5,
    notRecurring = function notRecurring(event) {
  return !event.isRecurring;
};
/**
 * This is a mixin, containing functionality related to managing events.
 *
 * It is consumed by the regular {@link Scheduler.data.EventStore} class and the Gantt `TaskStore` classes
 * to allow data sharing between a Gantt chart and a Scheduler.
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_52___default()(EventStoreMixin, _ref);

    var _super = _createSuper(EventStoreMixin);

    function EventStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_49___default()(this, EventStoreMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_50___default()(EventStoreMixin, [{
      key: "construct",
      //region Init & destroy
      value: function construct(config) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_51___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(EventStoreMixin.prototype), "construct", this).call(this, config);

        Object.assign(this, {
          autoTree: true
        });
      } //endregion
      //region Indices
      // Override to syncIndices on initial load

    }, {
      key: "afterLoadData",
      value: function afterLoadData() {
        this.syncIndices('splice', this.storage.allValues); // Babel cannot transpile ?. version of this correctly for some reason

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_51___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(EventStoreMixin.prototype), "afterLoadData", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_51___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(EventStoreMixin.prototype), "afterLoadData", this).call(this);
      }
      /**
       * Responds to mutations of the underlying storage Collection.
       *
       * Maintain indices for fast finding of events by date.
       * @param {Object} event
       * @private
       */

    }, {
      key: "onDataChange",
      value: function onDataChange(_ref2) {
        var action = _ref2.action,
            added = _ref2.added,
            removed = _ref2.removed,
            replaced = _ref2.replaced;
        // Indices must be synced before responding to change
        this.syncIndices(action, added, removed, replaced);

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_51___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(EventStoreMixin.prototype), "onDataChange", this).apply(this, arguments);
      }
    }, {
      key: "onDataReplaced",
      value: function onDataReplaced(action, data) {
        // Indices must be synced before responding to change
        this.syncIndices('clear');
        this.syncIndices('splice', this.storage.values);

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_51___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(EventStoreMixin.prototype), "onDataReplaced", this).call(this, action, data);
      } // TODO: Improve Collection indices to handle this
      // Keeps date & startDate indices up to date, used by Calendar and recurrence
      // The indices are initialized lazily on first access, and then kept up to date on changes

    }, {
      key: "syncIndices",
      value: function syncIndices(action) {
        var _added, _removed, _DateHelper$clearTime3, _wasSet$startDate, _getTime, _ref3, _wasSet$endDate;

        var added = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray;
        var removed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : emptyArray;
        var replaced = arguments.length > 3 ? arguments[3] : undefined;
        var wasSet = arguments.length > 4 ? arguments[4] : undefined;
        var me = this,
            addedCount = (_added = added) === null || _added === void 0 ? void 0 : _added.length,
            removedCount = (_removed = removed) === null || _removed === void 0 ? void 0 : _removed.length,
            replacedCount = replaced === null || replaced === void 0 ? void 0 : replaced.length;
        var dateMS, endDateMS, i, newEvent, outgoingEvent; // Only create indices if they have been requested

        if (me.dateIndicesRequested) {
          switch (action) {
            case 'clear':
              me._startDateIndex = {};
              me._dateIndex = {};
              break;
            // Add and remove

            case 'splice':
              // Handle replacement of records by instances with same ID
              if (replacedCount) {
                added = added.slice();
                removed = removed.slice();

                for (i = 0; i < replacedCount; i++) {
                  removed.push(replaced[i][0]);
                  added.push(replaced[i][1]);
                }
              } // Remove entries from indices


              if (removedCount) {
                for (i = 0; i < removedCount; i++) {
                  var _DateHelper$clearTime, _outgoingEvent$endDat, _outgoingEvent$endDat2;

                  outgoingEvent = removed[i];
                  dateMS = (_DateHelper$clearTime = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].clearTime(outgoingEvent.startDate)) === null || _DateHelper$clearTime === void 0 ? void 0 : _DateHelper$clearTime.getTime();
                  endDateMS = (_outgoingEvent$endDat = (_outgoingEvent$endDat2 = outgoingEvent.endDate) === null || _outgoingEvent$endDat2 === void 0 ? void 0 : _outgoingEvent$endDat2.getTime()) !== null && _outgoingEvent$endDat !== void 0 ? _outgoingEvent$endDat : dateMS; // Must handle unscheduled events

                  if (dateMS) {
                    me.removeIndexEntry('startDate', outgoingEvent, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(dateMS));

                    do {
                      me.removeIndexEntry('date', outgoingEvent, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(dateMS));
                      dateMS += MS_PER_DAY;
                    } while (dateMS < endDateMS);
                  }
                }
              } // Add entries to indices


              if (addedCount) {
                for (i = 0; i < addedCount; i++) {
                  newEvent = added[i]; // Can only be date-indexed if it's scheduled

                  if (newEvent.isScheduled) {
                    var _DateHelper$clearTime2, _newEvent$endDate$get, _newEvent$endDate;

                    dateMS = (_DateHelper$clearTime2 = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].clearTime(newEvent.startDate)) === null || _DateHelper$clearTime2 === void 0 ? void 0 : _DateHelper$clearTime2.getTime();
                    endDateMS = (_newEvent$endDate$get = (_newEvent$endDate = newEvent.endDate) === null || _newEvent$endDate === void 0 ? void 0 : _newEvent$endDate.getTime()) !== null && _newEvent$endDate$get !== void 0 ? _newEvent$endDate$get : dateMS; // Must handle unscheduled events

                    if (dateMS) {
                      me.addIndexEntry('startDate', newEvent, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(dateMS));

                      do {
                        me.addIndexEntry('date', newEvent, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(dateMS));
                        dateMS += MS_PER_DAY;
                      } while (dateMS < endDateMS);
                    }
                  }
                }
              }

              break;
            // invoked when the start or end changes so that the event can be re-indexed.

            case 'reschedule':
              outgoingEvent = added[0];
              dateMS = (_DateHelper$clearTime3 = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].clearTime(((_wasSet$startDate = wasSet.startDate) === null || _wasSet$startDate === void 0 ? void 0 : _wasSet$startDate.oldValue) || outgoingEvent.startDate)) === null || _DateHelper$clearTime3 === void 0 ? void 0 : _DateHelper$clearTime3.getTime();
              endDateMS = (_getTime = (_ref3 = ((_wasSet$endDate = wasSet.endDate) === null || _wasSet$endDate === void 0 ? void 0 : _wasSet$endDate.oldValue) || outgoingEvent.endDate) === null || _ref3 === void 0 ? void 0 : _ref3.getTime()) !== null && _getTime !== void 0 ? _getTime : dateMS; // Must handle unscheduled events

              if (dateMS) {
                // Remove index entries for the outgoing date
                me.removeIndexEntry('startDate', outgoingEvent, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(dateMS));

                do {
                  me.removeIndexEntry('date', outgoingEvent, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(dateMS));
                  dateMS += MS_PER_DAY;
                } while (dateMS < endDateMS);
              } // Now process as as splice with an add and no removes.


              me.syncIndices('splice', added);
              break;
          }
        }
      }
    }, {
      key: "onModelChange",
      value: function onModelChange(record, toSet, wasSet, silent, fromRelationUpdate) {
        // Ensure by-date indices are up to date.
        if ('startDate' in wasSet || 'endDate' in wasSet) {
          this.syncIndices('reschedule', [record], null, null, wasSet);
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_51___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_54___default()(EventStoreMixin.prototype), "onModelChange", this).apply(this, arguments);
      }
    }, {
      key: "addIndexEntry",
      value: function addIndexEntry(indexName, value) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : value[indexName];
        var indexPropName = "_".concat(indexName, "Index"),
            index = this[indexPropName] || (this[indexPropName] = {}),
            entry = index[key] || (index[key] = new Set());
        entry.add(value);
      }
    }, {
      key: "removeIndexEntry",
      value: function removeIndexEntry(indexName, value) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : value[indexName];
        var indexPropName = "_".concat(indexName, "Index"),
            index = this[indexPropName] || (this[indexPropName] = {}),
            entry = index[key];

        if (entry) {
          entry.delete(value);
        }
      } // Retrieve the date or startDate index, building them on first request

    }, {
      key: "getDateIndex",
      value: function getDateIndex(indexName) {
        var me = this; // Date indices are created on first usage and after that kept up to date on changes

        if (!me.dateIndicesRequested) {
          me.dateIndicesRequested = true;
          me.syncIndices('splice', me.storage.allValues);
        }

        return me["_".concat(indexName, "Index")] || emptyIndex;
      } //endregion
      //region Events records, iteration etc.

      /**
       * Returns events between the supplied start and end date
       *
       * @param {Date} startDate The start date
       * @param {Date} endDate The end date
       * @param {Boolean} allowPartial false to only include events that start and end inside of the span
       * @param {Boolean} onlyAssigned true to only include events that are assigned to a resource
       * @return {Scheduler.model.EventModel[]} the events
       * @category Events
       * @deprecated 4.0.0 Use {@link #function-getEvents}
       */

    }, {
      key: "getEventsInTimeSpan",
      value: function getEventsInTimeSpan(startDate, endDate) {
        var allowPartial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var onlyAssigned = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_59__["default"].deprecate('Scheduler', '5.0.0', '`getEventsInTimeSpan` method deprecated, in favor of `getEvents`');
        return this.getEvents({
          startDate: startDate,
          endDate: endDate,
          allowPartial: allowPartial,
          onlyAssigned: onlyAssigned
        });
      }
      /**
       * Returns all events that starts on the specified day.
       *
       * @param {Date} startDate Start date
       * @returns {Scheduler.model.EventModel[]} Events starting on specified day
       * @category Events
       * @deprecated 4.0.0 Use {@link #function-getEvents}
       */

    }, {
      key: "getEventsByStartDate",
      value: function getEventsByStartDate(startDate) {
        _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_59__["default"].deprecate('Scheduler', '5.0.0', '`getEventsByStartDate` method deprecated, in favor of `getEvents`');
        return this.getEvents({
          startDate: startDate,
          startOnly: true
        });
      }
      /**
       * Returns an array of events for the date range specified by the `startDate` and `endDate` options.
       *
       * By default, for any date, this includes any event which *intersects* that date.
       *
       * To only include events that are fully contained *within* the date range, pass the `allowPartial`
       * option as `false`
       *
       * By default, any occurrences of recurring events are included in the resulting array. If that is not
       * required, pass the `includeOccurrences` option as `false`. **Note that if
       * `includeOccurrences` is `true`, the start date and end date options are mandatory. The method
       * must know what range of ocurrences needs to be generated and returned.**
       *
       * example:
       *
       * ```javascript
       *  visibleEvents = eventStore.getEvents({
       *      resourceRecord : myResource,
       *      startDate      : scheduler.timeAxis.startDate,
       *      endDate        : scheduler.timeAxis.endDate
       *  });
       * ```
       *
       * @param {Date} [options.date] If only one date is required, pass this option instead of the
       * `startDate` and `endDate` options.
       * @param {Date} options.startDate The start date for the range of events to include.
       * @param {Date} [options.endDate] The end date for the range of events to include.
       * @param {Scheduler.model.ResourceModel} options.resourceRecord Pass a resource to only return events assigned to
       *   this resource. Not supported when using the `dateMap` option (see below)
       * @param {Function} [options.filter] A function to filter out events which are not required.
       * @param {Boolean} [options.includeOccurrences=true] Occurrences of recurring events are included by default.
       * @param {Boolean} [options.allowPartial=true] Events which start before or after the range, but *intersect* the
       *   range are included by default.
       * @param {Boolean} [options.startOnly] Pass `true` to only include events which *start on* each date in the range.
       * @param {Boolean} [options.onlyAssigned] Pass `true` to only include events that are assigned to a resource
       * @param {Boolean|Map} [options.dateMap] Populates the passed `Map`, or if passed as `true`, creates and 
       * returns a new `Map`. The keys are `YYYY-MM-DD` date strings and the entries are arrays of {@link Scheduler.model.EventModel EventModel}s.
       * @returns {Scheduler.model.EventModel[]|Map} Events which match the passed configuration.
       * @category Events
       */

    }, {
      key: "getEvents",
      value: function getEvents(_ref4) {
        var filter = _ref4.filter,
            date = _ref4.date,
            startDate = _ref4.startDate,
            endDate = _ref4.endDate,
            startOnly = _ref4.startOnly,
            includeOccurrences = _ref4.includeOccurrences,
            allowPartial = _ref4.allowPartial,
            _ref4$onlyAssigned = _ref4.onlyAssigned,
            onlyAssigned = _ref4$onlyAssigned === void 0 ? false : _ref4$onlyAssigned,
            _ref4$dateMap = _ref4.dateMap,
            dateMap = _ref4$dateMap === void 0 ? false : _ref4$dateMap,
            getDateIndex = _ref4.getDateIndex;
        var me = this,
            options = arguments[0],
            lastDateRange = me.lastDateRange,
            added = me.added,
            filtersFunction = me.filtersFunction,
            passedFilter = filter; // Add filtering for only assigned events if requested.

        if (onlyAssigned) {
          options.filter = passedFilter ? function (e) {
            return passedFilter(e) && e.resources.length;
          } : function (e) {
            return e.resources.length;
          };
        } // Note that we cannot use defaulting in the argument block because we pass
        // the incoming options object down into implementations.


        if (!('startDate' in options)) {
          startDate = options.startDate = date;
        }

        if (!('includeOccurrences' in options)) {
          includeOccurrences = options.includeOccurrences = true;
        }

        if (!('allowPartial' in options)) {
          allowPartial = options.allowPartial = !startOnly;
        } // We can't use me.filtersFunction if reapplyFilterOnAdd is false because there may be newly
        // added events which may not be subject to the filter. Records which are still in 
        // the added bag must be tested for presence using indexOf so as to be always in sync
        // with the store being refiltered. Parens help readability.
        // eslint-disable-next-line no-extra-parens


        options.storeFilterFn = me.isFiltered ? me.reapplyFilterOnAdd ? filtersFunction : function (eventRecord) {
          return added.includes(eventRecord) ? me.indexOf(eventRecord) > -1 : filtersFunction(eventRecord);
        } : null; // Default to a one day range if only startDate passed

        if (!endDate) {
          if (startDate) {
            endDate = options.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].clearTime(startDate);
            endDate.setDate(endDate.getDate() + 1);
          } // If no dates passed, the dateFilter will include all.
          else {
              // We need to know what occurrences to generate.
              if (includeOccurrences) {
                throw new Error('getEvents MUST be passed startDate and endDate if recurring occurrences are requested');
              }

              options.dateFilter = returnTrue;
            }
        }

        if (!options.dateFilter) {
          // Must start in the date range
          if (startOnly) {
            options.dateFilter = function (e) {
              return e.startDate && !(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].clearTime(e.startDate) - startDate);
            };
          } // Any intersection with our date range
          else if (allowPartial) {
              options.dateFilter = function (e) {
                return e.startDate && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].intersectSpans(e.startDate, e.endDate || e.startDate, startDate, endDate);
              };
            } // Must be wholly contained with the our range
            else {
                options.dateFilter = function (e) {
                  return e.startDate && e.startDate >= startDate && (e.endDate || e.startDate) <= endDate;
                };
              }
        }

        var newDateRange = {
          startDate: startDate,
          endDate: endDate
        },
            dateRangeChange = !lastDateRange || lastDateRange.startDate - newDateRange.startDate || lastDateRange.endDate - newDateRange.endDate;

        if (dateRangeChange) {
          // Ensure the listeners are present
          me.processConfiguredListeners();
          /**
           * Fired when a range of events is requested from the {@link #function-getEvents} method.
           * @event loadDateRange
           * @param {Scheduler.data.EventStore} source This EventStore
           * @param {Object} old The old date range
           * @param {Date} old.startDate the old start date.
           * @param {Date} old.endDate the old end date.
           * @param {Object} new The new date range
           * @param {Date} new.startDate the new start date.
           * @param {Date} new.endDate the new end date.
           */

          me.trigger('loadDateRange', {
            old: lastDateRange || {},
            new: Object.assign({}, newDateRange)
          });
          me.lastDateRange = newDateRange;
        }

        return dateMap ? me.getEventsAsMap(options) : me.getEventsAsArray(options);
      }
      /**
       * Internal implementation for {@link #function-getEvents} to use when not using dateMap.
       * @private
       */

    }, {
      key: "getEventsAsArray",
      value: function getEventsAsArray(_ref5) {
        var filter = _ref5.filter,
            date = _ref5.date,
            resourceRecord = _ref5.resourceRecord,
            _ref5$startDate = _ref5.startDate,
            startDate = _ref5$startDate === void 0 ? date : _ref5$startDate,
            endDate = _ref5.endDate,
            startOnly = _ref5.startOnly,
            _ref5$includeOccurren = _ref5.includeOccurrences,
            includeOccurrences = _ref5$includeOccurren === void 0 ? true : _ref5$includeOccurren,
            dateFilter = _ref5.dateFilter,
            storeFilterFn = _ref5.storeFilterFn,
            getDateIndex = _ref5.getDateIndex;
        var me = this,
            events = [];

        if (me.count) {
          var candidateEvents = resourceRecord ? me.getEventsForResource(resourceRecord) : new Set(); // If there *was* a resourceRecord, candidateEvents will already be set up using me.getEventsForResource.
          // If no resourceRecord specified, we are gathering by date, so use the indices.

          if (!resourceRecord) {
            (function () {
              var eventSet = new Set(),
                  index = me.getDateIndex(startOnly ? 'startDate' : 'date'); // Add all recurring events which started on or before our date range.

              me.recurringEvents.forEach(function (e) {
                if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].clearTime(e.startDate) <= startDate) {
                  eventSet.add(e);
                }
              }); // Iterate the date range, using the indices to find qualifed events.

              for (var _date = new Date(startDate); _date < endDate; _date.setDate(_date.getDate() + 1)) {
                var coincidingEvents = (getDateIndex ? me.getDateIndex(getDateIndex(_date)) : index)[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(_date)];

                if (coincidingEvents) {
                  coincidingEvents.forEach(function (e) {
                    return eventSet.add(e);
                  });
                }
              } // We gathered all events which *coincide* with each date.
              // We also added in all recurring events which started on or before our date range.
              // All these were made unique by the Set.
              // Return it to array form.


              candidateEvents = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_48___default()(eventSet);
            })();
          } // Events found from the date indices won't be filtered.
          // On the other side, when using getEventForResource we will get all events for
          // the resource even if the EventStore is filtered, handle this by excluding "invisible" events here


          if (storeFilterFn) {
            candidateEvents = candidateEvents.filter(storeFilterFn);
          } // Go through candidates.
          // For a recurring event, and we are including recurrences, add date-qualifying occurrences.
          // For a non-recurring event, add it if it's date-qualified.


          for (var i = 0, _candidateEvents = candidateEvents, length = _candidateEvents.length; i < length; i++) {
            var e = candidateEvents[i]; // For recurring events, add date-qualifying occurrences, not the base

            if (e.isRecurring && includeOccurrences) {
              events.push.apply(events, e.getOccurrencesForDateRange(startDate, endDate).filter(dateFilter));
            } // For ordinary events, add if it's date-qualified
            else {
                if (dateFilter(e)) {
                  events.push(e);
                }
              }
          }
        }

        return filter ? events.filter(filter) : events;
      }
      /**
       * Internal implementation for {@link #function-getEvents} to use when using dateMap.
       * @private
       */

    }, {
      key: "getEventsAsMap",
      value: function getEventsAsMap(_ref6) {
        var passedFilter = _ref6.filter,
            date = _ref6.date,
            resourceRecord = _ref6.resourceRecord,
            _ref6$startDate = _ref6.startDate,
            startDate = _ref6$startDate === void 0 ? date : _ref6$startDate,
            endDate = _ref6.endDate,
            startOnly = _ref6.startOnly,
            _ref6$includeOccurren = _ref6.includeOccurrences,
            includeOccurrences = _ref6$includeOccurren === void 0 ? true : _ref6$includeOccurren,
            dateMap = _ref6.dateMap,
            storeFilterFn = _ref6.storeFilterFn,
            getDateIndex = _ref6.getDateIndex;
        var me = this; // Convert `true` to a Map.

        if (dateMap.clear) {
          dateMap.clear();
        } else {
          dateMap = new Map();
        }

        if (me.count) {
          var index = me.getDateIndex(startOnly ? 'startDate' : 'date'),
              recurringEvents = [],
              filter = function filter(e) {
            return (!passedFilter || passedFilter(e)) && (!storeFilterFn || storeFilterFn(e));
          }; // We can't yet do this for just a resource.


          if (resourceRecord) {
            throw new Error('Querying for events for a resource and returning a date-keyed Map is not supported');
          } else {
            // Add all recurring events which started before the end of our date range.
            me.recurringEvents.forEach(function (e) {
              if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].clearTime(e.startDate) < endDate) {
                recurringEvents.push(e);
              }
            }); // Iterate the date range, using the indices to find qualifed events.

            for (var _date2 = new Date(startDate); _date2 < endDate; _date2.setDate(_date2.getDate() + 1)) {
              var key = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(_date2);
              var coincidingEvents = (getDateIndex ? me.getDateIndex(getDateIndex(_date2)) : index)[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(_date2)];

              if (coincidingEvents) {
                var _ref7;

                // Convert Set which index holds into an Array.
                // A recurring event doesn't go into the Map, its occurrences do.
                // Then filter by the passed filter and this Store's filter function
                // because events found from the date indices won't be filtered.
                coincidingEvents = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_48___default()(coincidingEvents).filter(notRecurring).filter(filter);

                (_ref7 = dateMap.get(key) || dateMap.set(key, []).get(key)).push.apply(_ref7, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_48___default()(coincidingEvents));
              }
            }
          } // Go through matching recurring events.


          for (var i = 0, length = recurringEvents.length; i < length; i++) {
            var e = recurringEvents[i]; // For each recurring event, add occurrences if we are including occurrences else, add the base.
            // Then filter by the passed filter and this Store's filter function
            // because events found from the date indices won't be filtered.

            var occurrences = (includeOccurrences ? e.getOccurrencesForDateRange(startDate, endDate) : [e]).filter(filter); // Add occurrences to dateMap

            for (var _i = 0, _length = occurrences.length; _i < _length; _i++) {
              var occurrence = occurrences[_i],
                  _date3 = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].clearTime(occurrence.startDate),
                  _indexName = getDateIndex ? getDateIndex(_date3) : startOnly ? 'startDate' : 'date',
                  lastInteresctingDate = _indexName === 'startDate' ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].endOf(_date3) : occurrence.endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].add(occurrence.startDate, occurrence.duration, occurrence.durationUnit); // Loop through covered dates, adding to dateMap if required


              for (; _date3 < lastInteresctingDate; _date3.setDate(_date3.getDate() + 1)) {
                var _key = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].makeKey(_date3);

                (dateMap.get(_key) || dateMap.set(_key, []).get(_key)).push(occurrence);
              }
            }
          }
        }

        return dateMap;
      }
      /**
       * Calls the supplied iterator function once for every scheduled event, providing these arguments
       * - event : the event record
       * - startDate : the event start date
       * - endDate : the event end date
       *
       * Returning false cancels the iteration.
       *
       * @param {Function} fn iterator function
       * @param {Object} thisObj `this` reference for the function
       * @category Events
       */

    }, {
      key: "forEachScheduledEvent",
      value: function forEachScheduledEvent(fn) {
        var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
        this.forEach(function (event) {
          var startDate = event.startDate,
              endDate = event.endDate;

          if (startDate && endDate) {
            return fn.call(thisObj, event, startDate, endDate);
          }
        });
      }
      /**
       * Returns an object defining the earliest start date and the latest end date of all the events in the store.
       *
       * @return {Object} An object with 'start' and 'end' Date properties (or null values if data is missing).
       * @category Events
       */

    }, {
      key: "getTotalTimeSpan",
      value: function getTotalTimeSpan() {
        var earliest = new Date(9999, 0, 1),
            latest = new Date(0);
        this.forEach(function (event) {
          if (event.startDate) {
            earliest = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].min(event.startDate, earliest);
          }

          if (event.endDate) {
            latest = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].max(event.endDate, latest);
          }
        }); // TODO: this will fail in programs designed to work with events in the past (after Jan 1, 1970)

        earliest = earliest < new Date(9999, 0, 1) ? earliest : null;
        latest = latest > new Date(0) ? latest : null; // keep last calculated value to be able to track total timespan changes

        return this.lastTotalTimeSpan = {
          startDate: earliest || null,
          endDate: latest || earliest || null
        };
      }
      /**
       * Checks if given event record is persistable. By default it always is, override EventModels `isPersistable` if you
       * need custom logic.
       *
       * @param {Scheduler.model.EventModel} event
       * @return {Boolean}
       * @category Events
       */

    }, {
      key: "isEventPersistable",
      value: function isEventPersistable(event) {
        return event.isPersistable;
      } //endregion
      //region Resource

      /**
       * Checks if a date range is allocated or not for a given resource.
       * @param {Date} start The start date
       * @param {Date} end The end date
       * @param {Scheduler.model.EventModel|null} excludeEvent An event to exclude from the check (or null)
       * @param {Scheduler.model.ResourceModel} resource The resource
       * @return {Boolean} True if the timespan is available for the resource
       * @category Resource
       */

    }, {
      key: "isDateRangeAvailable",
      value: function isDateRangeAvailable(start, end, excludeEvent, resource) {
        var _this = this;

        // This should be a collection of unique event records
        var allEvents = new Set(this.getEventsForResource(resource)); // In private mode we can pass an AssignmentModel. In this case, we assume that multi-assignment is used.
        // So we need to make sure that other resources are available for this time too.
        // No matter if the event retrieved from the assignment belongs to the target resource or not.
        // We gather all events from from the resources the event is assigned to except of the one from the assignment record.
        // Note, events from the target resource are added above.

        if (excludeEvent instanceof _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_58__["default"]) {
          var currentEvent = excludeEvent.event,
              resources = currentEvent.resources;
          resources.forEach(function (resource) {
            // Ignore events for the resource which is passed as an AssignmentModel to excludeEvent
            if (resource.id !== excludeEvent.resourceId) {
              _this.getEventsForResource(resource).forEach(function (event) {
                return allEvents.add(event);
              });
            }
          });
        }

        if (excludeEvent) {
          var eventToRemove = excludeEvent instanceof _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_58__["default"] ? excludeEvent.event : excludeEvent;
          allEvents.delete(eventToRemove);
        }

        return !Array.from(allEvents).some(function (event) {
          return event.isScheduled && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_57__["default"].intersectSpans(start, end, event.startDate, event.endDate);
        });
      }
      /**
       * Filters the events associated with a resource, based on the function provided. An array will be returned for those
       * events where the passed function returns true.
       * @param {Scheduler.model.ResourceModel} resource
       * @param {Function} fn The function
       * @param {Object} [thisObj] `this` reference for the function
       * @return {Scheduler.model.EventModel[]} the events in the time span
       * @private
       * @category Resource
       */

    }, {
      key: "filterEventsForResource",
      value: function filterEventsForResource(resource, fn) {
        var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
        return resource.getEvents(this).filter(fn.bind(thisObj));
      }
      /**
       * Returns all resources assigned to an event.
       *
       * @param {Scheduler.model.EventModel|String|Number} event
       * @return {Scheduler.model.ResourceModel[]}
       * @category Resource
       */

    }, {
      key: "getResourcesForEvent",
      value: function getResourcesForEvent(event) {
        // If we are sent an occurrence, use its parent
        if (event.isOccurrence) {
          event = event.recurringTimeSpan;
        }

        return this.assignmentStore.getResourcesForEvent(event);
      }
      /**
       * Returns all events assigned to a resource.
       *
       * @param {Scheduler.model.ResourceModel|String|Number} resource Resource or resource id.
       *   *NOTE:* this does not include occurrences of recurring events. Use the {@link #function-getEvents} API
       *   to include occurrences of recurring events.
       * @return {Scheduler.model.EventModel[]}
       * @category Resource
       */

    }, {
      key: "getEventsForResource",
      value: function getEventsForResource(resource) {
        return this.assignmentStore.getEventsForResource(resource);
      } //endregion
      //region Assignment

      /**
       * Returns all assignments for a given event.
       *
       * @param {Scheduler.model.EventModel|String|Number} event
       * @return {Scheduler.model.AssignmentModel[]}
       * @category Assignment
       */

    }, {
      key: "getAssignmentsForEvent",
      value: function getAssignmentsForEvent(event) {
        return this.assignmentStore.getAssignmentsForEvent(event) || [];
      }
      /**
       * Returns all assignments for a given resource.
       *
       * @param {Scheduler.model.ResourceModel|String|Number} resource
       * @return {Scheduler.model.AssignmentModel[]}
       * @category Assignment
       */

    }, {
      key: "getAssignmentsForResource",
      value: function getAssignmentsForResource(resource) {
        return this.assignmentStore.getAssignmentsForResource(resource) || [];
      }
      /**
       * Creates and adds assignment record for a given event and a resource.
       *
       * @param {Scheduler.model.EventModel|String|Number} event
       * @param {Scheduler.model.ResourceModel|String|Number|Scheduler.model.ResourceModel[]|String[]|number[]} resource The resource(s) to assign to the event
       * @param {Boolean} [removeExistingAssignments] `true` to first remove existing assignments
       * @return {Scheduler.model.AssignmentModel[]} An array with the created assignment(s)
       * @category Assignment
       */

    }, {
      key: "assignEventToResource",
      value: function assignEventToResource(event, resource) {
        var removeExistingAssignments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return this.assignmentStore.assignEventToResource(event, resource, undefined, removeExistingAssignments);
      }
      /**
       * Removes assignment record for a given event and a resource.
       *
       * @param {Scheduler.model.EventModel|String|Number} event
       * @param {Scheduler.model.ResourceModel|String|Number} resource
       * @category Assignment
       */

    }, {
      key: "unassignEventFromResource",
      value: function unassignEventFromResource(event, resource) {
        this.assignmentStore.unassignEventFromResource(event, resource);
      }
      /**
       * Reassigns an event from an old resource to a new resource
       *
       * @param {Scheduler.model.EventModel}    event    An event or id of the event to reassign
       * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} oldResource A resource or id to unassign from
       * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} newResource A resource or id to assign to
       * @category Assignment
       */

    }, {
      key: "reassignEventFromResourceToResource",
      value: function reassignEventFromResourceToResource(event, oldResource, newResource) {
        var me = this,
            newResourceId = _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_56__["default"].asId(newResource),
            assignment = me.assignmentStore.getAssignmentForEventAndResource(event, oldResource);

        if (assignment) {
          assignment.resourceId = newResourceId;
        } else {
          me.assignmentStore.assignEventToResource(event, newResource);
        }
      }
      /**
       * Checks whether an event is assigned to a resource.
       *
       * @param {Scheduler.model.EventModel|String|Number} event
       * @param {Scheduler.model.ResourceModel|String|Number} resource
       * @return {Boolean}
       * @category Assignment
       */

    }, {
      key: "isEventAssignedToResource",
      value: function isEventAssignedToResource(event, resource) {
        return this.assignmentStore.isEventAssignedToResource(event, resource);
      }
      /**
       * Removes all assignments for given event
       *
       * @param {Scheduler.model.EventModel|String|Number} event
       * @category Assignment
       */

    }, {
      key: "removeAssignmentsForEvent",
      value: function removeAssignmentsForEvent(event) {
        this.assignmentStore.removeAssignmentsForEvent(event);
      }
      /**
       * Removes all assignments for given resource
       *
       * @param {Scheduler.model.ResourceModel|String|Number} resource
       * @category Assignment
       */

    }, {
      key: "removeAssignmentsForResource",
      value: function removeAssignmentsForResource(resource) {
        this.assignmentStore.removeAssignmentsForResource(resource);
      } //endregion

    }], [{
      key: "$name",
      get: function get() {
        return 'EventStoreMixin';
      }
    }]);

    return EventStoreMixin;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_55__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/PartOfBaseProject.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/data/mixin/PartOfBaseProject.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; // Private class that leverages the differences between a core and a basic project

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(PartOfBaseProject, _Target);

    var _super = _createSuper(PartOfBaseProject);

    function PartOfBaseProject() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, PartOfBaseProject);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(PartOfBaseProject, [{
      key: "assignmentStore",
      get: function get() {
        return this.project.assignmentStore;
      }
    }, {
      key: "calendarManagerStore",
      get: function get() {
        return this.project.calendarManagerStore;
      }
    }, {
      key: "dependencyStore",
      get: function get() {
        return this.project.dependencyStore;
      }
    }, {
      key: "eventStore",
      get: function get() {
        return this.project.eventStore;
      }
    }, {
      key: "resourceStore",
      get: function get() {
        return this.project.resourceStore;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'PartOfBaseProject';
      }
    }]);

    return PartOfBaseProject;
  }(Target);
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/PartOfProject.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/data/mixin/PartOfProject.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/data/mixin/PartOfProject
 */

/**
 * This is a mixin, included in all models and stores of the Scheduler project. It provides a common API for accessing
 * all stores of the project.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(PartOfProject, _ref);

    var _super = _createSuper(PartOfProject);

    function PartOfProject() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, PartOfProject);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(PartOfProject, null, [{
      key: "$name",

      /**
       * Returns the project this entity belongs to.
       *
       * @member {Scheduler.model.ProjectModel} project
       * @readonly
       * @category Project
       */

      /**
       * Returns the event store of the project this entity belongs to.
       *
       * @member {Scheduler.data.EventStore} eventStore
       * @readonly
       * @category Project
       */

      /**
       * Returns the dependency store of the project this entity belongs to.
       *
       * @member {Scheduler.data.DependencyStore} dependencyStore
       * @readonly
       * @category Project
       */

      /**
       * Returns the assignment store of the project this entity belongs to.
       *
       * @member {Scheduler.data.AssignmentStore} assignmentStore
       * @readonly
       * @category Project
       */

      /**
       * Returns the resource store of the project this entity belongs to.
       *
       * @member {Scheduler.data.ResourceStore} resourceStore
       * @readonly
       * @category Project
       */
      get: function get() {
        return 'PartOfProject';
      }
    }]);

    return PartOfProject;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/ProjectConsumer.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/data/mixin/ProjectConsumer.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../model/ProjectModel.js */ "./lib/Scheduler/model/ProjectModel.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");










































function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/data/mixin/ProjectConsumer
 */

/**
 * Creates a Project using any configured stores, and sets the stores configured into the project into
 * the host object.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default()(ProjectConsumer, _ref);

    var _super = _createSuper(ProjectConsumer);

    function ProjectConsumer() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_35___default()(this, ProjectConsumer);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36___default()(ProjectConsumer, [{
      key: "startConfigure",
      //endregion
      value: function startConfigure(config) {
        // process the project first which ingests any configured data sources,
        this.getConfig('project');

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(ProjectConsumer.prototype), "startConfigure", this).call(this, config);
      } //region Project
      // This is where all the ingestion hapens.
      // At config time, the changers inject incoming values into the project config object
      // that we are building. At the end we instantiate the project with all incoming
      // config values filled in.

    }, {
      key: "changeProject",
      value: function changeProject(project, oldProject) {
        var me = this,
            _me$constructor = me.constructor,
            projectStoreNames = _me$constructor.projectStoreNames,
            projectDataNames = _me$constructor.projectDataNames;
        me.projectCallbacks = new Set();

        if (project) {
          // Flag for changes to know what stage we are at
          me.buildingProjectConfig = true;

          if (!project.isModel) {
            // When configuring, prio order:
            // 1. If using an already existing CrudManager, it is assumed to already have the stores we should use,
            //    adopt them as ours.
            // 2. If a supplied store already has a project, it is assumed to be shared with another scheduler and
            //    that project is adopted as ours.
            // 3. Use stores from a supplied project config.
            // 4. Use stores configured on scheduler.
            // + Pass on inline data (events, resources, dependencies, assignments -> xxData on the project config)
            //
            // What happens during project initialization is this:
            // this._project is the project *config* object.
            // changeXxxx methods put incoming values directly into it through this.project
            // to be used as its configuration.
            // So when it is instantiated, it has had all configs injected.
            if (me.isConfiguring) {
              // Set property for changers to put incoming values into
              me._project = project; // crudManager will be a clone of the raw config if it is a raw config.

              var crudManager = me.crudManager; // Pull in stores from the crudManager config first

              if (crudManager) {
                var isCrudManager = crudManager.isCrudManager;

                var _iterator = _createForOfIteratorHelper(projectStoreNames),
                    _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var storeName = _step.value;

                    if (crudManager[storeName]) {
                      // We configure the project with the stores, and *not* the CrudManger.
                      // The CrudManager ends up having its project set and thereby adopting ours.
                      me[storeName] = crudManager[storeName]; // If it's just a config, take the stores out.
                      // We will *configure* it with this project and it will ingest
                      // its stores from there.

                      if (!isCrudManager) {
                        delete crudManager[storeName];
                      }
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              } // Pull in all our configured stores into the project config object.
              // That also extracts any project into this._sharedProject


              me.getConfig('projectStores'); // Referencing these data configs causes them to be pulled into
              // the _project.xxxData config property if they are present.

              var _iterator2 = _createForOfIteratorHelper(projectDataNames),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var dataName = _step2.value;
                  me.getConfig(dataName);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }

            var _project = project,
                eventStore = _project.eventStore; // Delay autoLoading until listeners are set up, to be able to inject params

            if (eventStore && !eventStore.isEventStoreMixin && eventStore.autoLoad && !eventStore.count) {
              eventStore.autoLoad = false;
              me.delayAutoLoad = true;
            } // Use sharedProject if found, else instantiate our config.


            project = me._sharedProject || new me.projectModelClass(project); // Clear the property so that the updater is called.

            delete me._project;
          } // In the updater, configs are live


          me.buildingProjectConfig = false;
        }

        return project;
      }
      /**
       * Implement in subclass to take action when project is replaced.
       *
       * __`super.updateProject(...arguments)` must be called first.__
       *
       * @param {Scheduler.model.ProjectModel} project
       */

    }, {
      key: "updateProject",
      value: function updateProject(project, oldProject) {
        var me = this,
            projectListeners = me.projectListeners,
            crudManager = me.crudManager;
        me.detachListeners('projectConsumer'); // When we set the crudManager now, it will go through to the CrudManagerVIew

        delete me._crudManager;

        if (project) {
          projectListeners.thisObj = me;
          project.on(projectListeners); // If the project is a CrudManager, use it as such.

          if (project.isCrudManager) {
            me.crudManager = project;
          } // Apply the project to CrudManager, making sure the same stores are used there and here
          else if (crudManager) {
              crudManager.project = project; // CrudManager goes through the changer as usual and is initialized
              // from the Project, not any stores it was originally configured with.

              me.crudManager = crudManager;
            } // Notifies classes that mix AttachToProjectMixin that we have a new project


          me.projectSubscribers.forEach(function (subscriber) {
            return subscriber.attachToProject(project);
          }); // Sets the project's stores into the host object

          var _iterator3 = _createForOfIteratorHelper(me.constructor.projectStoreNames),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var storeName = _step3.value;
              me[storeName] = project[storeName];
            } // Listeners are set up, if EventStore was configured with autoLoad now is the time to load

          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          if (me.delayAutoLoad) {
            // Restore the flag, not needed but to look good on inspection
            project.eventStore.autoLoad = true;
            project.eventStore.load();
          }
        }

        me.trigger('projectChange', {
          project: project
        });
      } // Implementation here because we need to get first look at it to adopt its stores

    }, {
      key: "changeCrudManager",
      value: function changeCrudManager(crudManager) {
        // Set the property to be scanned for incoming stores.
        // If it's a config, it will be stripped of those stores prior to construction.
        if (this.buildingProjectConfig) {
          this._crudManager = crudManager.isCrudManager ? crudManager : Object.assign({}, crudManager);
        } else {
          return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(ProjectConsumer.prototype), "changeCrudManager", this).call(this, crudManager);
        }
      } // Called when project changes are committed, after data is written back to records

    }, {
      key: "onProjectDataReady",
      value: function onProjectDataReady() {
        if (this.projectCallbacks.size) {
          this.projectCallbacks.forEach(function (callback) {
            return callback();
          });
          this.projectCallbacks.clear();
        }
      }
      /**
       * Accepts a callback that will be called when the underlying project is ready (no commit pending and current commit
       * finalized)
       * @param {Function} callback
       */

    }, {
      key: "whenProjectReady",
      value: function whenProjectReady(callback) {
        // Might already be ready, call directly
        if (this.isEngineReady) {
          callback();
        } else {
          this.projectCallbacks.add(callback);
        }
      }
      /**
       * Returns `true` if engine is in a stable calculated state, `false` otherwise.
       * @returns {Boolean}
       */

    }, {
      key: "doDestroy",
      //endregion
      //region Destroy
      // Cleanup, destroys stores if this.destroyStores is true.
      value: function doDestroy() {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(ProjectConsumer.prototype), "doDestroy", this).call(this);

        if (this.destroyStores) {
          // Shared project might already be destroyed
          !this.project.isDestroyed && this.project.destroy();
        }
      } //endregion

    }, {
      key: "isEngineReady",
      get: function get() {
        var _this$project$isEngin, _this$project;

        // NonWorkingTime calls this during destruction, hence the ?.
        return Boolean((_this$project$isEngin = (_this$project = this.project).isEngineReady) === null || _this$project$isEngin === void 0 ? void 0 : _this$project$isEngin.call(_this$project));
      }
    }, {
      key: "projectStores",
      get: function get() {
        var _this = this;

        var projectStoreNames = this.constructor.projectStoreNames;
        return projectStoreNames.map(function (storeName) {
          return _this[storeName];
        });
      }
    }, {
      key: "widgetClass",
      //region WidgetClass
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.
      get: function get() {} //endregion

    }], [{
      key: "setupProjectStores",
      value: function setupProjectStores(cls, meta) {
        var _this2 = this;

        var projectStores = cls.projectStores;

        if (projectStores) {
          var projectListeners = {
            name: 'projectConsumer',
            dataReady: 'onProjectDataReady'
          },
              storeConfigs = {
            projectListeners: projectListeners
          }; // Create property for dataName and change and updater for stores

          var _loop = function _loop(storeName) {
            var dataName = projectStores[storeName].dataName; // Define "eventStore" config

            storeConfigs[storeName] = null; // Define up the "events" property

            if (dataName) {
              // Getter to return store data
              // Setter to update project config or live project
              Object.defineProperty(meta.class.prototype, dataName, {
                get: function get() {
                  var _this$project$storeNa;

                  // get events() { return this.project.eventStore.records; }
                  return (_this$project$storeNa = this.project[storeName]) === null || _this$project$storeNa === void 0 ? void 0 : _this$project$storeNa.records;
                },
                set: function set(data) {
                  var project = this.project;

                  if (this.buildingProjectConfig) {
                    // Set the property in the project config object.
                    // eg project.eventsData = [...]
                    project["".concat(dataName, "Data")] = data;
                  } else {
                    // Live update the project when in use.
                    project[storeName].data = data;
                  }
                }
              });
            }

            _this2.createStoreDescriptor(meta, storeName, projectStores[storeName], projectListeners);
          };

          for (var storeName in projectStores) {
            _loop(storeName);
          } // Create the projectListeners config.


          this.setupConfigs(meta, storeConfigs);
        }
      }
    }, {
      key: "createStoreDescriptor",
      value: function createStoreDescriptor(meta, storeName, _ref2, projectListeners) {
        var listeners = _ref2.listeners;
        var clsProto = meta.class.prototype,
            storeNameCap = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].capitalize(storeName); // Set up onProjectEventStoreChange to set this.eventStore

        projectListeners["".concat(storeName, "Change")] = function (_ref3) {
          var store = _ref3.store;
          this[storeName] = store;
        }; // create changeEventStore


        clsProto["change".concat(storeNameCap)] = function (store, oldStore) {
          var me = this,
              project = me.project,
              storeProject = store.project;

          if (me.buildingProjectConfig) {
            // Capture any project found at project config time
            // to use as our shared project
            if (storeProject && storeProject.isProjectModel) {
              me._sharedProject = storeProject;
            } // Set the property in the project config object.
            // Must not go through the updater. It's too early to
            // inform host of store change.


            project[storeName] = store;
            return;
          } // Live update the project when in use.


          if (!me.initializingProject) {
            if (project[storeName] !== store) {
              project["set".concat(storeNameCap)](store);
              store = project[storeName];
            }
          } // Implement processing here instead of creating a separate updater.
          // Subclasses can implement updaters.


          if (store !== oldStore) {
            if (listeners) {
              listeners.thisObj = me;
              listeners.name = "".concat(storeName, "Listeners");
              me.detachListeners(listeners.name);
              store.on(listeners);
            } // Notifies classes that mix AttachToProjectMixin that we have a new XxxxxStore


            me.projectSubscribers.forEach(function (subscriber) {
              if (subscriber[storeName] !== store) {
                subscriber["attachTo".concat(storeNameCap)](store);
              }
            });
          }

          return store;
        };
      }
    }, {
      key: "$name",
      get: function get() {
        return 'ProjectConsumer';
      } //region Default config

    }, {
      key: "declarable",
      get: function get() {
        return ['projectStores'];
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          projectModelClass: _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_42__["default"],

          /**
           * The configuration of the {@link Scheduler.model.ProjectModel Project} this class is to use. Mandatory for **Scheduler Pro**.
           *
           * May contain the store configs for this class, eg:
           * ```javascript
           *     project : {
           *         eventStore {
           *             loadUrl : '/data/events.php'
           *         },
           *         resourceStore {
           *             loadUrl : '/data/resources.php'
           *         }
           *     }
           * ```
           *
           * If not supplied, or not configured with stores, the stores configured on this object, or
           * this object's {@link Scheduler.crud.mixin.CrudManagerView#config-crudManager crudManager}
           * will be used.
           *
           * @config {Scheduler.model.ProjectModel|Object} project
           */
          project: {},

          /**
           * Configure as `true` to destroy the Project and stores when `this` is destroyed.
           * @config {Boolean}
           * @default
           */
          destroyStores: null,
          // Will be populated by AttachToProjectMixin which features mix in
          projectSubscribers: []
        };
      }
    }, {
      key: "projectStoreNames",
      get: function get() {
        return Object.keys(this.projectStores);
      }
    }, {
      key: "projectDataNames",
      get: function get() {
        var _this3 = this;

        return this.projectStoreNames.reduce(function (result, storeName) {
          var dataName = _this3.projectStores[storeName].dataName;

          if (dataName) {
            result.push(dataName);
          }

          return result;
        }, []);
      }
    }]);

    return ProjectConsumer;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_41__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/ProjectCrudManager.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/ProjectCrudManager.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Scheduler/crud/AbstractCrudManagerMixin.js */ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../crud/transport/AjaxTransport.js */ "./lib/Scheduler/crud/transport/AjaxTransport.js");
/* harmony import */ var _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../crud/encoder/JsonEncoder.js */ "./lib/Scheduler/crud/encoder/JsonEncoder.js");
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/data/mixin/ProjectCrudManager
 */

/**
 * This mixin provides Crud Manager functionality supporting loading of scheduling engine projects.
 *
 * @mixin
 * @mixes Scheduler/crud/AbstractCrudManagerMixin
 * @mixes Scheduler/crud/transport/AjaxTransport
 * @mixes Scheduler/crud/encoder/JsonEncoder
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_mixin) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(ProjectCrudManager, _mixin);

    var _super = _createSuper(ProjectCrudManager);

    function ProjectCrudManager() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, ProjectCrudManager);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(ProjectCrudManager, [{
      key: "startConfigure",
      value: function startConfigure(config) {
        // process the project first which ingests any configured data sources,
        this.getConfig('project');

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(ProjectCrudManager.prototype), "startConfigure", this).call(this, config);
      }
    }, {
      key: "doAutoLoad",
      value: function () {
        var _doAutoLoad = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee() {
          var project;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  project = this.project; // Delay autoLoad to after projects initial commit if configured with a project

                  if (!project) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 4;
                  return project.commitAsync();

                case 4:
                  return _context.abrupt("return", _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(ProjectCrudManager.prototype), "doAutoLoad", this).call(this));

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function doAutoLoad() {
          return _doAutoLoad.apply(this, arguments);
        }

        return doAutoLoad;
      }()
    }, {
      key: "loadCrudManagerData",
      value: function loadCrudManagerData(response) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var me = this,
            project = me.project; // we don't want reacting on store changes during loading of them

        me.suspendChangesTracking();

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(ProjectCrudManager.prototype), "loadCrudManagerData", this).apply(this, arguments); // if there is the project data provided


        if (response === null || response === void 0 ? void 0 : response.project) {
          me.applyingProjectResponse = true;
          Object.assign(project, response.project);
          me.applyingProjectResponse = false;
        }

        me.resumeChangesTracking();
      }
    }, {
      key: "sync",
      value: function () {
        var _sync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee2() {
          var project;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  project = this.project; // Suspend Crud Manager autoSync to not react on changes during commitAsync() call

                  this.suspendAutoSync(); // Make sure data is in a calculated state before syncing

                  if (!project) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return project.commitAsync();

                case 5:
                  this.resumeAutoSync(false);
                  return _context2.abrupt("return", _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(ProjectCrudManager.prototype), "sync", this).call(this));

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function sync() {
          return _sync.apply(this, arguments);
        }

        return sync;
      }()
    }, {
      key: "applyResponse",
      value: function () {
        var _applyResponse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee3(requestType, response, options) {
          var me, propagationFlag;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  me = this;

                  if (!me.isDestroyed) {
                    _context3.next = 3;
                    break;
                  }

                  return _context3.abrupt("return");

                case 3:
                  me.trigger('startApplyResponse'); // clear "added"/"modified" collections on the stores
                  // TODO: need to snapshot their state to be able to revert in case of an exception

                  me.clearCrudStoresChanges({
                    clearRemovedCollection: false
                  });
                  _context3.next = 7;
                  return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(ProjectCrudManager.prototype), "applyResponse", this).call(this, requestType, response, options);

                case 7:
                  // clear "removed" collection on the stores
                  me.clearCrudStoresChanges({
                    removeAddedRecords: false,
                    clearAddedCollection: false,
                    clearModifiedCollection: false,
                    clearRemovedCollection: true
                  });
                  me.applyingProjectResponse = true; // if there is the project data provided

                  response && response.project && Object.assign(me, response.project);
                  me.applyingProjectResponse = false; // if we have a project

                  if (!me.project) {
                    _context3.next = 18;
                    break;
                  }

                  // response can force its type
                  if (me.trackResponseType) {
                    requestType = response.type || requestType;
                  } // Make a boolean flag indicating what has triggered the propagation ("propagatingLoadChanges" or  "propagatingSyncChanges")


                  propagationFlag = "propagating".concat(_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].capitalize(requestType), "Changes");
                  me[propagationFlag] = true; // Wait till calculation gets done

                  _context3.next = 17;
                  return me.project.commitAsync();

                case 17:
                  me[propagationFlag] = false;

                case 18:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function applyResponse(_x, _x2, _x3) {
          return _applyResponse.apply(this, arguments);
        }

        return applyResponse;
      }()
    }, {
      key: "clearCrudStoresChanges",
      value: function clearCrudStoresChanges() {
        var _this = this;

        var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          removeAddedRecords: true,
          clearAddedCollection: true,
          clearModifiedCollection: true,
          clearRemovedCollection: true
        };
        var removeAddedRecords = flags.removeAddedRecords,
            clearAddedCollection = flags.clearAddedCollection,
            clearModifiedCollection = flags.clearModifiedCollection,
            clearRemovedCollection = flags.clearRemovedCollection; // TODO: Change when https://app.assembla.com/spaces/bryntum/tickets/8975 is fixed
        // this.crudStores.forEach(store => store.store.clearChanges());

        this.forEachCrudStore(function (store) {
          if (removeAddedRecords) {
            // remove phantom records
            store.remove(_this.added, true);
          }

          if (clearModifiedCollection) {
            store.modified.forEach(function (r) {
              return r.clearChanges(false);
            });
            store.modified.clear();
          }

          if (clearAddedCollection) {
            store.added.clear();
          }

          if (clearRemovedCollection) {
            store.removed.clear();
          }
        });
      }
    }], [{
      key: "defaultConfig",
      //region Config
      get: function get() {
        return {
          /**
           * A project that holds and links stores
           * @config {Scheduler.model.ProjectModel}
           */
          project: null
        };
      }
    }]);

    return ProjectCrudManager;
  }((Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_17__["default"]).mixin(_Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_15__["default"], _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_18__["default"], _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_19__["default"]));
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/RecurringEventsMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./RecurringTimeSpansMixin.js */ "./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/data/mixin/RecurringEventsMixin
 */

/**
 * This mixin class provides recurring events functionality to the {@link Scheduler.data.EventStore event store}.
 * @extends Scheduler/data/mixin/RecurringTimeSpansMixin
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_RecurringTimeSpansMi) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(RecurringEventsMixin, _RecurringTimeSpansMi);

    var _super = _createSuper(RecurringEventsMixin);

    function RecurringEventsMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, RecurringEventsMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(RecurringEventsMixin, [{
      key: "getRecurringEvents",

      /**
       * Returns all the recurring events.
       *
       * **An alias for ** {@link Scheduler.data.mixin.RecurringTimeSpansMixin#function-getRecurringTimeSpans} method.
       *
       * @return {Scheduler.model.EventModel[]} Array of recurring events.
       */
      value: function getRecurringEvents() {
        return this.getRecurringTimeSpans();
      }
    }, {
      key: "isEventPersistable",
      value: function isEventPersistable(event) {
        // occurrences are not persistable
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(RecurringEventsMixin.prototype), "isEventPersistable", this).call(this, event) && (!event.supportsRecurring || !event.isOccurrence);
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'RecurringEventsMixin';
      }
    }]);

    return RecurringEventsMixin;
  }(Object(_RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_10__["default"])(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]));
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js":
/*!*************************************************************!*\
  !*** ./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.freeze */ "./node_modules/core-js/modules/es.object.freeze.js");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");


















































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_47___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/data/mixin/RecurringTimeSpansMixin
 */

var emptyArray = Object.freeze([]);
/**
 * This mixin class provides recurring timespans functionality to a store of {@link Scheduler.model.TimeSpan} models.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_46___default()(RecurringTimeSpansMixin, _ref);

    var _super = _createSuper(RecurringTimeSpansMixin);

    function RecurringTimeSpansMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_42___default()(this, RecurringTimeSpansMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_43___default()(RecurringTimeSpansMixin, [{
      key: "construct",
      value: function construct() {
        var _get2;

        var me = this; // We store all generated occurrences keyed by `_generated_${recurringTimeSpan.id}:${occurrenceStartDate}`
        // So that when asked to generate an occurrence for a date, an already generated one can be returned.

        me.globalOccurrences = new Map(); // All recurring events added to the store are accessible through this Set. It's used
        // to generate occurrences.

        me.recurringEvents = new Set();

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(RecurringTimeSpansMixin.prototype), "construct", this)).call.apply(_get2, [this].concat(args));
      } // Override to refreshRecurringEventsCache on initial load

    }, {
      key: "afterLoadData",
      value: function afterLoadData() {
        // All cached occurrences are now potentially invalid.
        // A store reload might imply any number of changes which invalidate any occurrence.
        this.globalOccurrences.clear(); // Clear and rebuild the recurring events cache

        this.refreshRecurringEventsCache('clear');
        this.refreshRecurringEventsCache('splice', this.storage.allValues);
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(RecurringTimeSpansMixin.prototype), "afterLoadData", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(RecurringTimeSpansMixin.prototype), "afterLoadData", this).call(this);
      }
      /**
       * Responds to mutations of the underlying storage Collection.
       *
       * Maintain indices for fast finding of events by date.
       * @param {Object} event
       * @private
       */

    }, {
      key: "onDataChange",
      value: function onDataChange(_ref2) {
        var action = _ref2.action,
            added = _ref2.added,
            removed = _ref2.removed,
            replaced = _ref2.replaced;
        // Recurring events cache must be refreshed before responding to change
        this.refreshRecurringEventsCache(action, added, removed, replaced);

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(RecurringTimeSpansMixin.prototype), "onDataChange", this).apply(this, arguments);
      }
    }, {
      key: "refreshRecurringEventsCache",
      value: function refreshRecurringEventsCache(action) {
        var added = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray;
        var removed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : emptyArray;
        var replaced = arguments.length > 3 ? arguments[3] : undefined;
        var me = this,
            recurringEvents = me.recurringEvents,
            replacedCount = replaced === null || replaced === void 0 ? void 0 : replaced.length;

        switch (action) {
          case 'clear':
            recurringEvents.clear();
            break;
          // Add and remove

          case 'splice':
            // Handle replacement of records by instances with same ID
            if (replacedCount) {
              added = added.slice();
              removed = removed.slice();

              for (var i = 0; i < replacedCount; i++) {
                removed.push(replaced[i][0]);
                added.push(replaced[i][1]);
              }
            }

            var addedCount = added.length,
                removedCount = removed.length; // Track the recurring events we contain

            if (removedCount) {
              for (var _i = 0; _i < removedCount; _i++) {
                var outgoingEvent = removed[_i];

                if (outgoingEvent.isRecurring) {
                  recurringEvents.delete(outgoingEvent);
                }
              }
            } // Track the recurring events we contain


            if (addedCount) {
              for (var _i2 = 0; _i2 < addedCount; _i2++) {
                var newEvent = added[_i2]; // Allow easy access to recurring events

                if (newEvent.isRecurring) {
                  recurringEvents.add(newEvent);
                }
              }
            }

            break;
        }
      }
    }, {
      key: "add",
      value: function add(record) {
        // StoreCRUD#add always converts to array anyway, so do it first here
        // so that the occurrence check can be reliable.
        var records = Array.isArray(record) ? record : [record]; // Occurrences can never be in the store.
        // When an occurrence is edited, it becomes an exception
        // and is promoted to be a full event and THEN added.

        if (records.some(function (r) {
          return r.isOccurrence;
        })) {
          throw new Error('Occurrences must not be added to the event store');
        } else {
          return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(RecurringTimeSpansMixin.prototype), "add", this).call(this, records);
        }
      }
    }, {
      key: "getById",
      value: function getById(id) {
        var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(RecurringTimeSpansMixin.prototype), "getById", this).call(this, id); // If the id is not found in the Store, then it could be one of our generated occurrences


        if (!result) {
          result = this.globalOccurrences.get(this.modelClass.asId(id));
        }

        return result;
      }
    }, {
      key: "onModelChange",
      value: function onModelChange(record, toSet, wasSet, silent, fromRelationUpdate) {
        var isRecurrenceRelatedFieldChange = this.isRecurrenceRelatedFieldChange(record, wasSet); // If this is the base of a recurring sequence, then any reactors to events from
        // the super call must regenerate occurrences, so must be done at top.
        // If silent is true, occurences won't be recalculated. Do not remove occurrences from cache in such case.

        if (isRecurrenceRelatedFieldChange && !silent) {
          record.removeOccurrences();
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_45___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(RecurringTimeSpansMixin.prototype), "onModelChange", this).apply(this, arguments); // If this is the base of a recurring sequence, then the EventStore must
        // trigger a refresh event so that UIs refresh themselves.
        // This could be at the tail end of the creation of an exception
        // or a new recurring base.


        if (isRecurrenceRelatedFieldChange && !silent) {
          var event = {
            action: 'batch',
            records: this.storage.values
          };
          this.trigger('refresh', event);
          this.trigger('change', event);
        }
      }
      /**
       * The method restricts which field modifications should trigger timespan occurrences building.
       * By default any field change of a recurring timespan causes the rebuilding.
       * @param  {Scheduler.model.TimeSpan} timeSpan The modified timespan.
       * @param  {Object} wasSet Object containing the change set.
       * @return {Boolean} `True` if the fields modification should trigger the timespan occurrences rebuilding.
       * @internal
       */

    }, {
      key: "isRecurrenceRelatedFieldChange",
      value: function isRecurrenceRelatedFieldChange(timeSpan, wasSet) {
        return timeSpan.isRecurring || 'recurrenceRule' in wasSet;
      }
      /**
       * Builds occurrences for the provided timespan across the provided date range.
       * @private
       */

    }, {
      key: "getOccurrencesForTimeSpan",
      value: function getOccurrencesForTimeSpan(timeSpan, startDate, endDate) {
        var result = [];

        if (timeSpan.isRecurring) {
          timeSpan.recurrence.forEachOccurrence(startDate, endDate, function (r) {
            return result.push(r);
          });
        }

        return result;
      }
    }, {
      key: "getRecurringTimeSpans",

      /**
       * Returns all the recurring timespans.
       * @return {Scheduler.model.TimeSpan[]} Array of recurring events.
       */
      value: function getRecurringTimeSpans() {
        return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_41___default()(this.recurringEvents);
      }
    }, {
      key: "data",
      set: function set(data) {
        // All cached occurrences are now invalid with a new dataset
        this.globalOccurrences.clear();

        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_44___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_48___default()(RecurringTimeSpansMixin.prototype), "data", data, this, true);
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'RecurringTimeSpansMixin';
      }
    }]);

    return RecurringTimeSpansMixin;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_49__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/ResourceStoreMixin.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/ResourceStoreMixin.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/data/mixin/ResourceStoreMixin
 */

/**
 * This is a mixin for the ResourceStore functionality. It is consumed by the {@link Scheduler.data.ResourceStore}.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ResourceStoreMixin, _ref);

    var _super = _createSuper(ResourceStoreMixin);

    function ResourceStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ResourceStoreMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ResourceStoreMixin, [{
      key: "construct",
      value: function construct(config) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ResourceStoreMixin.prototype), "construct", this).call(this, config);

        if (!this.modelClass.isResourceModel) {
          throw new Error('Model for ResourceStore must subclass ResourceModel');
        }
      }
    }, {
      key: "removeAll",
      value: function removeAll() {
        var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ResourceStoreMixin.prototype), "removeAll", this).apply(this, arguments); // Removing all resources removes all assignments


        result && this.assignmentStore.removeAll();
        return result;
      } // Apply id changes also to assignments (used to be handled automatically by relations earlier, but engine does not
      // care about ids so needed now)
      // problems:
      // 1. orientation/HorizontalRendering listens to assignment store changes and is trying to refresh view
      // When we update resource id on assignment, listener will be invoken and view will try to refresh. And it will
      // fail, because row is not updated yet. Flag is raised on resource store to make HorizontalRendering to skip
      // refreshing view in this particular case of resource id changing

    }, {
      key: "onRecordIdChange",
      value: function onRecordIdChange(_ref2) {
        var record = _ref2.record,
            oldValue = _ref2.oldValue,
            value = _ref2.value;

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ResourceStoreMixin.prototype), "onRecordIdChange", this).call(this, {
          record: record,
          oldValue: oldValue,
          value: value
        });

        if (record.isFieldModified('id')) {
          this.isChangingId = true;
          record.updateAssignmentResourceIds();
          this.isChangingId = false;
        }
      }
    }, {
      key: "isResourceStore",
      get: function get() {
        return true;
      }
      /**
       * Add resources to the store.
       *
       * NOTE: References (events, assignments) on the resources are determined async by a calculation engine. Thus they
       * cannot be directly accessed after using this function.
       *
       * For example:
       *
       * ```javascript
       * const [resource] = resourceStore.add({ id });
       * // resource.events is not yet available
       * ```
       *
       * To guarantee references are set up, wait for calculations for finish:
       *
       * ```javascript
       * const [resource] = resourceStore.add({ id });
       * await resourceStore.project.commitAsync();
       * // resource.events is available (assuming EventStore is loaded and so on)
       * ```
       *
       * Alternatively use `addAsync()` instead:
       *
       * ```javascript
       * const [resource] = await resourceStore.addAsync({ id });
       * // resource.events is available (assuming EventStore is loaded and so on)
       * ```
       *
       * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]|Object|Object[]} records
       * Array of records/data or a single record/data to add to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Scheduler.model.ResourceModel[]} Added records
       * @function add
       * @category CRUD
       */

      /**
       * Add resources to the store and triggers calculations directly after. Await this function to have up to date
       * references on the added resources.
       *
       * ```javascript
       * const [resource] = await resourceStore.addAsync({ id });
       * // resource.events is available (assuming EventStore is loaded and so on)
       * ```
       *
       * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]|Object|Object[]} records
       * Array of records/data or a single record/data to add to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Scheduler.model.ResourceModel[]} Added records
       * @function addAsync
       * @category CRUD
       * @async
       */

      /**
       * Applies a new dataset to the ResourceStore. Use it to plug externally fetched data into the store.
       *
       * NOTE: References (events, assignments) on the resources are determined async by a calculation engine. Thus
       * they cannot be directly accessed after assigning the new dataset.
       *
       * For example:
       *
       * ```javascript
       * resourceStore.data = [{ id }];
       * // resourceStore.first.events is not yet available
       * ```
       *
       * To guarantee references are available, wait for calculations for finish:
       *
       * ```javascript
       * resourceStore.data = [{ id }];
       * await resourceStore.project.commitAsync();
       * // resourceStore.first.events is available
       * ```
       *
       * Alternatively use `loadDataAsync()` instead:
       *
       * ```javascript
       * await resourceStore.loadDataAsync([{ id }]);
       * // resourceStore.first.events is available
       * ```
       *
       * @member {Object[]} data
       * @category Records
       */

      /**
       * Applies a new dataset to the ResourceStore and triggers calculations directly after. Use it to plug externally
       * fetched data into the store.
       *
       * ```javascript
       * await resourceStore.loadDataAsync([{ id }]);
       * // resourceStore.first.events is available
       * ```
       *
       * @param {Object[]} data Array of ResourceModel data objects
       * @function loadDataAsync
       * @category CRUD
       * @async
       */

    }], [{
      key: "$name",
      get: function get() {
        return 'ResourceStoreMixin';
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * CrudManager must load stores in the correct order. Lowest first.
           * @private
           */
          loadPriority: 200,

          /**
           * CrudManager must sync stores in the correct order. Lowest first.
           * @private
           */
          syncPriority: 100,
          storeId: 'resources',
          autoTree: true
        };
      }
    }]);

    return ResourceStoreMixin;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/SharedEventStoreMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/SharedEventStoreMixin.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37__);







































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_36___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/* eslint-disable no-unused-expressions */

/**
 * @module Scheduler/data/mixin/SharedEventStoreMixin
 */

/**
 * This is a mixin, containing functionality related to managing events.
 *
 * It is consumed by the regular {@link Scheduler.data.EventStore} class and Scheduler Pros counterpart.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_35___default()(SharedEventStoreMixin, _Target);

    var _super = _createSuper(SharedEventStoreMixin);

    function SharedEventStoreMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31___default()(this, SharedEventStoreMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32___default()(SharedEventStoreMixin, [{
      key: "construct",

      /**
       * Class used to represent records. Defaults to class EventModel.
       * @property {Scheduler.model.EventModel}
       * @category Records
       * @typings { new(data: object): Model }
       * @name modelClass
       */
      value: function construct(config) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SharedEventStoreMixin.prototype), "construct", this).call(this, config, true);

        if (!this.modelClass.isEventModel) {
          throw new Error('The model for the EventStore must subclass EventModel');
        }
      }
    }, {
      key: "suspendAssignmentsAutoAdd",
      value: function suspendAssignmentsAutoAdd() {
        this.assignmentsAutoAddSuspended++;
      }
    }, {
      key: "resumeAssignmentsAutoAdd",
      value: function resumeAssignmentsAutoAdd() {
        if (this.assignmentsAutoAddSuspended > 0) {
          this.assignmentsAutoAddSuspended--;
        }
      }
      /**
       * Appends a new record to the store
       * @param {Scheduler.model.EventModel} record The record to append to the store
       */

    }, {
      key: "append",
      value: function append(record) {
        return this.add(record);
      } //region Project

    }, {
      key: "processRecord",
      //endregion
      //region Single assignment
      value: function processRecord(eventRecord) {
        var isDataset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SharedEventStoreMixin.prototype), "processRecord", this).call(this, eventRecord, isDataset);

        var resourceId = eventRecord.get('resourceId');

        if (resourceId != null) {
          var me = this,
              assignmentStore = me.assignmentStore,
              existingRecord = me.getById(eventRecord.id),
              isReplacing = existingRecord && existingRecord !== eventRecord && !isDataset; // Replacing an existing event, repoint the resource of its assignment
          // (already repointed to the new event by engine in EventStoreMixin)

          if (isReplacing) {
            // Have to look assignment up on store, removed by engine in super call above
            var assignment = assignmentStore.find(function (e) {
              return e.eventId === eventRecord.id;
            });

            if (assignment) {
              assignment.resource = resourceId;
              me.reassignedFromReplace = true;
            }
          } // AssignmentStore found, add an assignment to it if this is no a dataset operation
          else if (assignmentStore && !isDataset && !me.assignmentsAutoAddSuspended) {
              // Check if the event is already assigned to the resource, though it's not in the event store.
              // It could happen when you remove an event, so both event and assignment records are removed,
              // then you "undo" the action and the assignment is restored before the event is restored.
              var _assignment = assignmentStore.find(function (r) {
                return r.resourceId === resourceId && r.eventId === eventRecord.id;
              }); // If the assignment is already exist, skip its adding


              if (!_assignment) {
                // Cannot use `event.assign(resourceId)` since event is not part of store yet
                // Using a bit shorter generated id to not look so ugly in DOM
                assignmentStore.add({
                  id: assignmentStore.modelClass.generateId(''),
                  resourceId: resourceId,
                  eventId: eventRecord.id
                });
              }
            } // No AssignmentStore assigned yet, need to process when that happens. Or if it is a dataset operation,
            // processing will happen at the end of it to not add individual assignment (bad for performance)
            else {
                me.$processResourceIds = true;
              } // Flag that we have been loaded using resourceId, checked by CrudManager to exclude the internal
          // AssignmentStore from sync


          me.usesSingleAssignment = true;
        }

        return eventRecord;
      }
    }, {
      key: "processResourceIds",
      value: function processResourceIds() {
        var assignmentStore = this.assignmentStore;

        if (this.$processResourceIds && (assignmentStore === null || assignmentStore === void 0 ? void 0 : assignmentStore.isAssignmentStore)) {
          var assignments = []; // resourceIds used during initialization, convert into assignments

          this.forEach(function (eventRecord) {
            var resourceId = eventRecord.resourceId,
                eventId = eventRecord.id;

            if (resourceId != null) {
              // Using a bit shorter generated id to not look so ugly in DOM
              assignments.push({
                id: assignmentStore.modelClass.generateId(''),
                resourceId: resourceId,
                eventId: eventId
              });
            }
          }); // Disable as much as possible, since we are in full control of this store when using single assignment mode

          assignmentStore.useRawData = {
            disableDefaultValue: true,
            disableDuplicateIdCheck: true,
            disableTypeConversion: true
          }; // Flag that throws in AssignmentStore if data is loaded some other way when using single assignment

          assignmentStore.usesSingleAssignment = false;
          assignmentStore.data = assignments;
          assignmentStore.usesSingleAssignment = true;
          this.$processResourceIds = false;
        }
      }
    }, {
      key: "loadData",
      value: function loadData() {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SharedEventStoreMixin.prototype), "loadData", this).apply(this, arguments);

        this.processResourceIds();
      } // Optionally remove unassigned events

    }, {
      key: "onBeforeRemoveAssignment",
      value: function onBeforeRemoveAssignment(_ref) {
        var _me$stm;

        var records = _ref.records;
        var me = this;

        if (me.removeUnassignedEvent && !me.isRemoving && !me.isSettingData && !((_me$stm = me.stm) === null || _me$stm === void 0 ? void 0 : _me$stm.isRestoring) && !me.usesSingleAssignment) {
          var toRemove = new Set(); // Collect all events that are unassigned after the remove

          records.forEach(function (assignmentRecord) {
            var event = assignmentRecord.event; // Assignment might not have an event or the event might already be removed

            if (event && !event.isRemoved && event.assignments.every(function (a) {
              return records.includes(a);
            })) {
              toRemove.add(event);
            }
          }); // And remove them

          if (toRemove.size) {
            me.remove(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(toRemove));
          }
        }
      }
    }, {
      key: "onProjectAssignmentStoreChange",
      value: function onProjectAssignmentStoreChange(_ref2) {
        var store = _ref2.store;
        this.attachToAssignmentStore(store);
      }
    }, {
      key: "attachToAssignmentStore",
      value: function attachToAssignmentStore(assignmentStore) {
        var me = this;
        me.detachListeners('assignmentStore');

        if (assignmentStore) {
          me.processResourceIds();
          assignmentStore.on({
            name: 'assignmentStore',
            // Adding an assignment in single assignment mode should set events resourceId if needed
            addPreCommit: function addPreCommit(_ref3) {
              var records = _ref3.records;

              if (me.usesSingleAssignment && !me.isSettingData && !me.isAssigning) {
                records.forEach(function (assignment) {
                  var event = assignment.event;

                  if ((event === null || event === void 0 ? void 0 : event.isEvent) && event.resourceId !== assignment.resourceId) {
                    event.meta.isAssigning = true;
                    event.set('resourceId', assignment.resourceId);
                    event.meta.isAssigning = false;
                  }
                });
              }
            },
            // Called both for remove and removeAll
            beforeRemove: 'onBeforeRemoveAssignment',
            // Removing an assignment in single assignment mode should set events resourceId to null
            removePreCommit: function removePreCommit(_ref4) {
              var records = _ref4.records;

              if (me.usesSingleAssignment) {
                records.forEach(function (assignment) {
                  var _me$getById;

                  // With engine link to event is already broken when we get here, hence the lookup
                  (_me$getById = me.getById(assignment.eventId)) === null || _me$getById === void 0 ? void 0 : _me$getById.set('resourceId', null);
                });
              }
            },
            removeAllPreCommit: function removeAllPreCommit() {
              if (me.usesSingleAssignment && !me.isSettingData) {
                me.allRecords.forEach(function (eventRecord) {
                  return eventRecord.set('resourceId', null);
                });
              }
            },
            // Keep events resourceId in sync with assignment on changes in single assignment mode
            update: function update(_ref5) {
              var record = _ref5.record,
                  changes = _ref5.changes;

              if (me.usesSingleAssignment && 'resourceId' in changes) {
                var event = record.event;
                event.meta.isAssigning = true;
                event.set('resourceId', changes.resourceId.value);
                event.meta.isAssigning = false;
              }
            },
            thisObj: me
          });
        }
      }
    }, {
      key: "trigger",
      // Override trigger to decorate update/change events with a flag if resourceId was the only thing changed, in which
      // case the change most likely can be ignored since the assignment will also change
      value: function trigger(eventName, params) {
        var _ref6 = params || {},
            changes = _ref6.changes;

        if (changes && 'resourceId' in changes && Object.keys(changes).length === 1) {
          params.isAssign = true;
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SharedEventStoreMixin.prototype), "trigger", this).apply(this, arguments);
      } //endregion

    }, {
      key: "project",
      get: function get() {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SharedEventStoreMixin.prototype), "project", this);
      },
      set: function set(project) {
        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_33___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SharedEventStoreMixin.prototype), "project", project, this, true);

        this.detachListeners('project');

        if (project) {
          project.on({
            name: 'project',
            assignmentStoreChange: 'onProjectAssignmentStoreChange',
            thisObj: this,
            prio: 200 // Before UI updates

          }); // Project already has AssignmentStore instance? Attach to it

          if (project.assignmentStore && project.assignmentStore.isAssignmentStore) {
            this.attachToAssignmentStore(project.assignmentStore);
          }
        }
      }
    }, {
      key: "data",
      set: function set(data) {
        this.isSettingData = true; // // When using single assignment, remove all assignments when loading a new set of events

        if (this.usesSingleAssignment) {
          this.assignmentStore.removeAll(true);
        }

        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_33___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SharedEventStoreMixin.prototype), "data", data, this, true);

        this.isSettingData = false;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'SharedEventStoreMixin';
      }
      /**
       * Add events to the store.
       *
       * NOTE: Dates, durations and references (assignments, resources) on the events are determined async by a calculation
       * engine. Thus they cannot be directly accessed after using this function.
       *
       * For example:
       *
       * ```javascript
       * eventStore.add({ startDate, duration });
       * // endDate is not yet calculated
       * ```
       *
       * To guarantee data is in a calculated state, wait for calculations for finish:
       *
       * ```javascript
       * eventStore.add({ startDate, duration });
       * await eventStore.project.commitAsync();
       * // endDate is calculated
       * ```
       *
       * Alternatively use `addAsync()` instead:
       *
       * ```javascript
       * await eventStore.addAsync({ startDate, duration });
       * // endDate is calculated
       * ```
       *
       * @param {Scheduler.model.EventModel|Scheduler.model.EventModel[]|Object|Object[]} records
       * Array of records/data or a single record/data to add to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Scheduler.model.EventModel[]} Added records
       * @function add
       * @category CRUD
       */

      /**
       * Add events to the store and triggers calculations directly after. Await this function to have up to date data on
       * the added events.
       *
       * ```javascript
       * await eventStore.addAsync({ startDate, duration });
       * // endDate is calculated
       * ```
       *
       * @param {Scheduler.model.EventModel|Scheduler.model.EventModel[]|Object|Object[]} records
       * Array of records/data or a single record/data to add to store
       * @param {Boolean} [silent] Specify `true` to suppress events
       * @returns {Scheduler.model.EventModel[]} Added records
       * @function addAsync
       * @category CRUD
       * @async
       */

      /**
       * Applies a new dataset to the EventStore. Use it to plug externally fetched data into the store.
       *
       * NOTE: Dates, durations and relations (assignments, resources) on the events are determined async by a calculation
       * engine. Thus they cannot be directly accessed after assigning the new dataset.
       *
       * For example:
       *
       * ```javascript
       * eventStore.data = [{ startDate, duration }];
       * // eventStore.first.endDate is not yet calculated
       * ```
       *
       * To guarantee data is in a calculated state, wait for calculations for finish:
       *
       * ```javascript
       * eventStore.data = [{ startDate, duration }];
       * await eventStore.project.commitAsync();
       * // eventStore.first.endDate is calculated
       * ```
       *
       * Alternatively use `loadDataAsync()` instead:
       *
       * ```javascript
       * await eventStore.loadDataAsync([{ startDate, duration }]);
       * // eventStore.first.endDate is calculated
       * ```
       *
       * @member {Object[]} data
       * @category Records
       */

      /**
       * Applies a new dataset to the EventStore and triggers calculations directly after. Use it to plug externally
       * fetched data into the store.
       *
       * ```javascript
       * await eventStore.loadDataAsync([{ startDate, duration }]);
       * // eventStore.first.endDate is calculated
       * ```
       *
       * @param {Object[]} data Array of EventModel data objects
       * @function loadDataAsync
       * @category CRUD
       * @async
       */

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * CrudManager must load stores in the correct order. Lowest first.
           * @private
           */
          loadPriority: 100,

          /**
           * CrudManager must sync stores in the correct order. Lowest first.
           * @private
           */
          syncPriority: 200,
          storeId: 'events',

          /**
           * Configure with `true` to also remove the event when removing the last assignment from the linked
           * AssignmentStore. This config has not effect when using EventStore in legacy `resourceId`-mode.
           * @config {Boolean}
           * @default
           * @category Common
           */
          removeUnassignedEvent: true
        };
      }
    }, {
      key: "properties",
      get: function get() {
        return {
          assignmentsAutoAddSuspended: 0
        };
      }
    }]);

    return SharedEventStoreMixin;
  }(Target);
});

/***/ }),

/***/ "./lib/Scheduler/data/util/ModelPersistencyManager.js":
/*!************************************************************!*\
  !*** ./lib/Scheduler/data/util/ModelPersistencyManager.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ModelPersistencyManager; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/data/util/ModelPersistencyManager
 */

/**
 * This class manages model persistency, it listens to model stores' beforesync event and removes all non persistable
 * records from sync operation. The logic has meaning only for CRUD-less sync operations.
 *
 * @private
 */

var ModelPersistencyManager = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ModelPersistencyManager, _Base);

  var _super = _createSuper(ModelPersistencyManager);

  function ModelPersistencyManager() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ModelPersistencyManager);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(ModelPersistencyManager, [{
    key: "onEventStoreBeforeSync",
    // endregion
    // region Event handlers
    value: function onEventStoreBeforeSync(_ref) {
      var changes = _ref.changes;
      var me = this;
      me.removeNonPersistableRecordsToCreate(changes);
      return me.shallContinueSync(changes);
    }
  }, {
    key: "onResourceStoreBeforeSync",
    value: function onResourceStoreBeforeSync(_ref2) {
      var changes = _ref2.changes;
      var me = this;
      me.removeNonPersistableRecordsToCreate(changes);
      return me.shallContinueSync(changes);
    }
  }, {
    key: "onAssignmentStoreBeforeSync",
    value: function onAssignmentStoreBeforeSync(_ref3) {
      var changes = _ref3.changes;
      var me = this;
      me.removeNonPersistableRecordsToCreate(changes);
      return me.shallContinueSync(changes);
    }
  }, {
    key: "onDependencyStoreBeforeSync",
    value: function onDependencyStoreBeforeSync(_ref4) {
      var changes = _ref4.changes;
      var me = this;
      me.removeNonPersistableRecordsToCreate(changes);
      return me.shallContinueSync(changes);
    } // endregion
    // region Management rules

  }, {
    key: "removeNonPersistableRecordsToCreate",
    value: function removeNonPersistableRecordsToCreate(changes) {
      var recordsToCreate = changes.added || [],
          r,
          i; // We remove from the array we iterate thus we iterate from end to start

      for (i = recordsToCreate.length - 1; i >= 0; --i) {
        r = recordsToCreate[i];

        if (!r.isPersistable) {
          recordsToCreate.splice(recordsToCreate.indexOf(r), 1);
        }
      } // Prevent empty create request


      if (recordsToCreate.length === 0) {
        changes.added.length = 0;
      }
    }
  }, {
    key: "shallContinueSync",
    value: function shallContinueSync(options) {
      return Boolean(options.added && options.added.length > 0 || options.modified && options.modified.length > 0 || options.removed && options.removed.length > 0);
    } // endregion

  }, {
    key: "eventStore",
    // region Event attachers
    set: function set(newEventStore) {
      var me = this;
      me.eventStoreDetacher && me.eventStoreDetacher();
      me._eventStore = newEventStore;

      if (newEventStore && newEventStore.autoCommit) {
        me.eventStoreDetacher = newEventStore.on({
          beforecommit: me.onEventStoreBeforeSync,
          thisObj: me,
          detachable: true,
          // Just in case
          prio: 100
        });
      }
    },
    get: function get() {
      return this._eventStore;
    }
  }, {
    key: "resourceStore",
    set: function set(newResourceStore) {
      var me = this;
      me.resourceStoreDetacher && me.resourceStoreDetacher();
      me._resourceStore = newResourceStore;

      if (newResourceStore && newResourceStore.autoCommit) {
        me.resourceStoreDetacher = newResourceStore.on({
          beforecommit: me.onResourceStoreBeforeSync,
          thisObj: me,
          detachable: true,
          // Just in case
          prio: 100
        });
      }
    },
    get: function get() {
      return this._resourceStore;
    }
  }, {
    key: "assignmentStore",
    set: function set(newAssignmentStore) {
      var me = this;
      me.assignmentStoreDetacher && me.assignmentStoreDetacher();
      me._assignmentStore = newAssignmentStore;

      if (newAssignmentStore && newAssignmentStore.autoSync) {
        me.assignmentStoreDetacher = newAssignmentStore.on({
          beforecommit: me.onAssignmentStoreBeforeSync,
          thisObj: me,
          detachable: true,
          // Just in case
          prio: 100
        });
      }
    },
    get: function get() {
      return this._assignmentStore;
    }
  }, {
    key: "dependencyStore",
    set: function set(newDependencyStore) {
      var me = this;
      me.dependencyStoreDetacher && me.dependencyStoreDetacher();
      me._dependencyStore = newDependencyStore;

      if (newDependencyStore && newDependencyStore.autoSync) {
        me.dependencyStoreDetacher = newDependencyStore.on({
          beforecommit: me.onDependencyStoreBeforeSync,
          thisObj: me,
          detachable: true,
          // Just in case
          prio: 100
        });
      }
    },
    get: function get() {
      return this._dependencyStore;
    }
  }]);

  return ModelPersistencyManager;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


ModelPersistencyManager._$name = 'ModelPersistencyManager';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js":
/*!**************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AbstractRecurrenceIterator; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var frequencyToUnitRe = /ly$/i,
    frequencyToUnit = function frequencyToUnit(frequency) {
  var result = frequency.replace(frequencyToUnitRe, '');
  return result === 'DAI' ? 'DAY' : result;
},
    fn = function fn(date, counter, isFirst, timeSpan) {
  return timeSpan.buildOccurrence(date, isFirst);
},
    captureLastOccurrence = function captureLastOccurrence(date) {
  return lastOccurrenceDate = date;
};

var lastOccurrenceDate;

var AbstractRecurrenceIterator = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AbstractRecurrenceIterator, _Base);

  var _super = _createSuper(AbstractRecurrenceIterator);

  function AbstractRecurrenceIterator() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, AbstractRecurrenceIterator);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(AbstractRecurrenceIterator, null, [{
    key: "processIterationConfig",
    value: function processIterationConfig(config) {
      var recurrence = config.recurrence,
          frequency = recurrence.frequency,
          interval = recurrence.interval,
          timeSpan = recurrence.timeSpan,
          until = recurrence.endDate,
          count = recurrence.count; // Force the correction of the event to be in sync with its recurrence rule
      // before performing iteration. For example, if the event's configured startDate
      // is 1st January 2020, and the rule dictates that the event will take place
      // monthly, every Monday, then the first event is not until Monday 6th January, 2020.

      if (!config.syncingStartDate && !timeSpan.meta.isSyncedWithRule) {
        // Do not generate occurrences outside of the specified range
        var intervalEndDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(timeSpan.startDate, interval, frequencyToUnit(frequency)),
            _endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].min(intervalEndDate, config.endDate || intervalEndDate);

        this.forEachDate({
          syncingStartDate: true,
          startDate: timeSpan.startDate,
          endDate: _endDate,
          recurrence: recurrence,
          fn: fn
        });
      } // Capture the start after its been synced with its recurrence rule


      var timeSpanStart = timeSpan.startDate; // Extract the endDate from the config, defaulting to the recurrence UNTIL date

      var _config$startDate = config.startDate,
          startDate = _config$startDate === void 0 ? timeSpanStart : _config$startDate,
          _config$endDate = config.endDate,
          endDate = _config$endDate === void 0 ? until : _config$endDate; // No point in starting the iteration before the event starts

      if (startDate < timeSpanStart) {
        startDate = timeSpanStart;
      } // The recurrence's stop date overrides the configured endDate.


      if (until) {
        if (!endDate || endDate > until) {
          endDate = until;
        }
      } // If we are limiting using count and we are not starting from the
      // first occurrence, then we have to calculate a stop date.
      // This is because for date ranges in the future we cannot calculate how many
      // preceding occurrences there may have been.
      else if (count && startDate > timeSpanStart) {
          // Iterate the occurrences from the start to capture the last one
          this.forEachDate({
            recurrence: recurrence,
            fn: captureLastOccurrence
          }); // The date of the last occurrence in the count sequence overrides the configured endDate.

          if (!endDate || endDate > lastOccurrenceDate) {
            endDate = lastOccurrenceDate;
          }
        } // Preserve the requested start of requested visits.


      var earliestVisibleDate = startDate; // Unless we are only asked for events which *start* within the time range. we must make
      // a best attempt to include any occurrences which span the start date.
      // So if we are asking for events from the 1st of the month, and there's an event
      // which runs every 2 months from the 15th to the 5th, we must include it. Start the
      // iteration <interval> full frequency quanta before the requested start.
      // This will only cause <interval> extra iterations.
      // We cannot step back to before the event's startihg date though.

      if (!config.startOnly) {
        startDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].max(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(startDate, -interval, frequencyToUnit(frequency)), timeSpanStart));
      }

      return Object.assign({
        extraArgs: [],
        // Only check start date for time spans with 0 duration
        startOnly: !Boolean(timeSpan.durationMS)
      }, config, {
        startDate: startDate,
        endDate: endDate,
        timeSpan: timeSpan,
        timeSpanStart: timeSpanStart,
        earliestVisibleDate: earliestVisibleDate,
        durationMS: timeSpan.durationMS,
        spansStart: startDate <= timeSpanStart && endDate > timeSpanStart
      });
    }
  }, {
    key: "getNthDayInPeriod",

    /**
     * Returns Nth occurrence of a week day in the provided period of time.
     * @param  {Date} startDate Period start date.
     * @param  {Date} endDate   Period end date.
     * @param  {Integer} day    Week day (0 - Sunday, 1 - Monday, 2 - Tuesday, etc.)
     * @param  {Integer} index  Index to find.
     * @return {Date}           Returns the found date or null if there is no `index`th entry.
     * @private
     */
    value: function getNthDayInPeriod(startDate, endDate, day, index) {
      var result, sign, borderDate;

      if (index) {
        var dayDurationInMs = 86400000,
            weekDurationInMs = 604800000;

        if (index > 0) {
          sign = 1;
          borderDate = startDate;
        } else {
          sign = -1;
          borderDate = endDate;
        } // delta between requested day and border day


        var delta = day - borderDate.getDay(); // if the requested day goes after (before, depending on borderDate used (start/end))
        // we adjust index +/-1

        if (sign * delta < 0) {
          index += sign;
        } // measure "index" weeks forward (or backward) ..take delta into account


        result = new Date(borderDate.getTime() + (index - sign) * weekDurationInMs + delta * dayDurationInMs); // if resulting date is outside of the provided range there is no "index"-th entry
        // of the day

        if (result < startDate || result > endDate) {
          result = null;
        }
      }

      return result;
    }
  }, {
    key: "buildDate",
    value: function buildDate(year, month, date) {
      var dt = new Date(year, month, date);

      if (dt.getFullYear() === year && dt.getMonth() === month && dt.getDate() === date) {
        return dt;
      }
    }
  }, {
    key: "isValidPosition",
    value: function isValidPosition(position) {
      return Boolean(position);
    }
  }, {
    key: "forEachDateAtPositions",
    value: function forEachDateAtPositions(dates, positions, fn, scope) {
      var datesLength = dates.length,
          processed = {};

      for (var i = 0; i < positions.length; i++) {
        var index = positions[i];

        if (this.isValidPosition(index)) {
          var date = index > 0 ? dates[index - 1] : dates[datesLength + index];

          if (date && !processed[date.getTime()]) {
            // remember that we've returned the date
            processed[date.getTime()] = true; // return false if it's time to stop recurring

            if (fn.call(scope, date) === false) {
              return false;
            }
          }
        }
      }
    }
  }, {
    key: "isInView",
    value: function isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan) {
      return (startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate) && !timeSpan.hasException(occurrenceDate);
    }
  }, {
    key: "frequency",
    get: function get() {
      return 'NONE';
    }
  }, {
    key: "MAX_OCCURRENCES_COUNT",
    get: function get() {
      return 1000000;
    }
  }]);

  return AbstractRecurrenceIterator;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


AbstractRecurrenceIterator._$name = 'AbstractRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js":
/*!***********************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DailyRecurrenceIterator; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Scheduler/data/util/recurrence/DailyRecurrenceIterator
*/



/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

var DailyRecurrenceIterator = /*#__PURE__*/function (_AbstractRecurrenceIt) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(DailyRecurrenceIterator, _AbstractRecurrenceIt);

  var _super = _createSuper(DailyRecurrenceIterator);

  function DailyRecurrenceIterator() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, DailyRecurrenceIterator);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(DailyRecurrenceIterator, null, [{
    key: "forEachDate",

    /**
     * Iterates over the passed date range, calling the passed callback on each date on which
     * starts a recurring event which matches the passed recurrence rule and overlaps the start and end dates
     * and is not an {@link Scheduler.model.mixin.RecurringTimeSpan#field-exceptionDates exceptionDate}
     * in the recurring event.
     * @param {Object} config An object which describes how to iterate.
     * @param {Date} config.startDate The point in time to begin iteration.
     * @param {Date} config.endDate The point in time to end iteration.
     * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
     * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
     * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
     * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
     * @param {Date} config.fn.date The occurrence date.
     * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
     * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
     * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
     */
    value: function forEachDate(config) {
      var _this$processIteratio = this.processIterationConfig(config),
          startOnly = _this$processIteratio.startOnly,
          startDate = _this$processIteratio.startDate,
          endDate = _this$processIteratio.endDate,
          timeSpan = _this$processIteratio.timeSpan,
          timeSpanStart = _this$processIteratio.timeSpanStart,
          earliestVisibleDate = _this$processIteratio.earliestVisibleDate,
          durationMS = _this$processIteratio.durationMS,
          spansStart = _this$processIteratio.spansStart,
          recurrence = _this$processIteratio.recurrence,
          fn = _this$processIteratio.fn,
          extraArgs = _this$processIteratio.extraArgs,
          _this$processIteratio2 = _this$processIteratio.scope,
          scope = _this$processIteratio2 === void 0 ? this : _this$processIteratio2,
          interval = recurrence.interval,
          delay = startDate - timeSpanStart,
          intervalDuration = interval * 86400000,
          delayInIntervals = Math.floor(delay / intervalDuration);

      var count = recurrence.count,
          counter = 0,
          occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].add(timeSpanStart, delayInIntervals * interval, 'day');

      if (!endDate && !count) {
        count = this.MAX_OCCURRENCES_COUNT;
      }

      while (!endDate || occurrenceDate <= endDate) {
        var inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
        counter++;

        if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(extraArgs))) === false || count && counter >= count)) {
          break;
        } // shift to the next day


        occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].add(occurrenceDate, interval, 'day');
      }
    }
  }, {
    key: "frequency",
    get: function get() {
      return 'DAILY';
    }
  }]);

  return DailyRecurrenceIterator;
}(_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


DailyRecurrenceIterator._$name = 'DailyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js":
/*!*************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MonthlyRecurrenceIterator; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Scheduler/data/util/recurrence/MonthlyRecurrenceIterator
*/




/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

var MonthlyRecurrenceIterator = /*#__PURE__*/function (_AbstractRecurrenceIt) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(MonthlyRecurrenceIterator, _AbstractRecurrenceIt);

  var _super = _createSuper(MonthlyRecurrenceIterator);

  function MonthlyRecurrenceIterator() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, MonthlyRecurrenceIterator);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(MonthlyRecurrenceIterator, null, [{
    key: "getNthDayOfMonth",
    value: function getNthDayOfMonth(date, dayNum) {
      var daysInMonth = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].daysInMonth(date);
      var result = null;

      if (dayNum && Math.abs(dayNum) <= daysInMonth) {
        result = new Date(date.getFullYear(), date.getMonth(), dayNum < 0 ? daysInMonth + dayNum + 1 : dayNum);
      }

      return result;
    }
  }, {
    key: "isValidPosition",
    value: function isValidPosition(position) {
      return position && Math.abs(position) > 0 && Math.abs(position) <= 31;
    }
    /**
     * Iterates over the passed date range, calling the passed callback on each date on which
     * starts an event which matches the passed recurrence rule and overlaps the start and end dates.
     * @param {Object} config An object which describes how to iterate.
     * @param {Date} config.startDate The point in time to begin iteration.
     * @param {Date} config.endDate The point in time to end iteration.
     * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
     * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
     * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
     * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
     * @param {Date} config.fn.date The occurrence date.
     * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
     * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
     * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
     */

  }, {
    key: "forEachDate",
    value: function forEachDate(config) {
      var _this = this;

      var _this$processIteratio = this.processIterationConfig(config),
          startOnly = _this$processIteratio.startOnly,
          startDate = _this$processIteratio.startDate,
          endDate = _this$processIteratio.endDate,
          timeSpan = _this$processIteratio.timeSpan,
          timeSpanStart = _this$processIteratio.timeSpanStart,
          earliestVisibleDate = _this$processIteratio.earliestVisibleDate,
          durationMS = _this$processIteratio.durationMS,
          spansStart = _this$processIteratio.spansStart,
          recurrence = _this$processIteratio.recurrence,
          fn = _this$processIteratio.fn,
          extraArgs = _this$processIteratio.extraArgs,
          _this$processIteratio2 = _this$processIteratio.scope,
          scope = _this$processIteratio2 === void 0 ? this : _this$processIteratio2,
          interval = recurrence.interval,
          days = recurrence.days,
          count = recurrence.count,
          positions = recurrence.positions,
          weekDays = _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_14__["default"].decode(days),
          hasPositions = positions && positions.length,
          processedDate = {};

      var monthDays = recurrence.monthDays,
          counter = 0,
          weekDayPosition,
          monthStartDate,
          monthEndDate,
          dates,
          occurrenceDate,
          i; // If the recurrence is limited w/ "Count", we need to 1st count passed
      // occurrences so we always start iteration from the event start date

      monthStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].startOf(count ? timeSpanStart : startDate, 'month');
      monthEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getNext(monthStartDate, 'month', 1) - 1); // If no month days nor week days are provided let's use event start date month day

      if (!(monthDays && monthDays.length) && !(weekDays && weekDays.length)) {
        monthDays = [timeSpanStart.getDate()];
      }

      if (weekDays && weekDays.length) {
        // Collect hash of positions indexed by week days
        weekDays.forEach(function (day) {
          if (day[1]) {
            weekDayPosition = weekDayPosition || {};
            weekDayPosition[day[0]] = day[1];
          }
        });
      }

      while ((!endDate || endDate >= monthStartDate) && (!count || counter < count)) {
        dates = [];

        if (weekDays && weekDays.length) {
          weekDays.forEach(function (day) {
            var weekDay = day[0];
            var from = 1,
                till = 53; // if position provided

            if (day[1]) {
              from = till = day[1];
            }

            for (i = from; i <= till; i++) {
              if (occurrenceDate = _this.getNthDayInPeriod(monthStartDate, monthEndDate, weekDay, i)) {
                occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].copyTimeValues(occurrenceDate, timeSpanStart);

                if (!processedDate[occurrenceDate.getTime()]) {
                  // remember we processed the date
                  processedDate[occurrenceDate.getTime()] = true;
                  dates.push(occurrenceDate);
                }
              }
            }
          });
          dates.sort(function (a, b) {
            return a - b;
          });

          if (!hasPositions) {
            for (i = 0; i < dates.length; i++) {
              occurrenceDate = dates[i];

              if (occurrenceDate >= timeSpanStart) {
                var inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
                counter++;

                if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(extraArgs))) === false || count && counter >= count)) {
                  return false;
                }
              }
            }
          }
        } else {
          var sortedMonthDates = [];

          for (i = 0; i < monthDays.length; i++) {
            // check if the date wasn't iterated over yet
            if ((occurrenceDate = this.getNthDayOfMonth(monthStartDate, monthDays[i])) && !processedDate[occurrenceDate.getTime()]) {
              processedDate[occurrenceDate.getTime()] = true;
              sortedMonthDates.push(occurrenceDate);
            }
          } // it's important to sort the dates to iterate over them in the proper order


          sortedMonthDates.sort(function (a, b) {
            return a - b;
          });

          for (i = 0; i < sortedMonthDates.length; i++) {
            occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].copyTimeValues(sortedMonthDates[i], timeSpanStart);

            if (hasPositions) {
              dates.push(occurrenceDate);
            } else if (occurrenceDate >= timeSpanStart) {
              var _inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);

              counter++;

              if (_inView && ( // eslint-disable-next-line no-labels
              endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(extraArgs))) === false || count && counter >= count)) {
                return;
              }
            }
          }
        }

        if (hasPositions && dates.length) {
          this.forEachDateAtPositions(dates, positions, function (occurrenceDate) {
            if (occurrenceDate >= timeSpanStart) {
              var _inView2 = startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate && !timeSpan.hasException(occurrenceDate);

              counter++; // Ignore dates outside of the [startDate, endDate] range

              if (_inView2 && (!endDate || occurrenceDate <= endDate) && ( // return false if it's time to stop recurring
              fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(extraArgs))) === false || count && counter >= count)) {
                return false;
              }
            }
          });
        } // get next month start


        monthStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getNext(monthStartDate, 'month', interval);
        monthEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getNext(monthStartDate, 'month', 1) - 1);
      }
    }
  }, {
    key: "frequency",
    get: function get() {
      return 'MONTHLY';
    }
  }]);

  return MonthlyRecurrenceIterator;
}(_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_12__["default"]);


MonthlyRecurrenceIterator._$name = 'MonthlyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js":
/*!************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceDayRuleEncoder; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../Core/Base.js */ "./lib/Core/Base.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

var dayParseRegExp = /^([+-]?[0-9])?(SU|MO|TU|WE|TH|FR|SA)$/;
var days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

var RecurrenceDayRuleEncoder = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(RecurrenceDayRuleEncoder, _Base);

  var _super = _createSuper(RecurrenceDayRuleEncoder);

  function RecurrenceDayRuleEncoder() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, RecurrenceDayRuleEncoder);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(RecurrenceDayRuleEncoder, null, [{
    key: "decodeDay",
    value: function decodeDay(rawDay) {
      var parsedDay, result;

      if (parsedDay = dayParseRegExp.exec(rawDay)) {
        result = [days.indexOf(parsedDay[2])]; // optional position number

        if (parsedDay[1]) {
          parsedDay[1] = parseInt(parsedDay[1], 10);
          result.push(parsedDay[1]);
        }
      }

      return result;
    }
  }, {
    key: "encodeDay",
    value: function encodeDay(day) {
      var position; // support decodeDay() result format

      if (Array.isArray(day)) {
        var _day = day;

        var _day2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5___default()(_day, 2);

        day = _day2[0];
        position = _day2[1];
      }

      return (position ? position.toString() : '') + days[day];
    } // Turns days values provided as an array of strings (like [`-1MO`, `SU`, `+3FR`])
    // into an array of [ dayIndex, position ] elements, where:
    //
    // - `dayIndex` - zero-based week day index value (0 - Sunday, 1 - Monday, 2 - Tuesday, etc.)
    // - `position` - (optional) 1-based position of the day (integer value (can be both positive and negative))

  }, {
    key: "decode",
    value: function decode(rawDays) {
      var result = [],
          parsedDay;

      if (rawDays) {
        for (var i = 0; i < rawDays.length; i++) {
          if (parsedDay = this.decodeDay(rawDays[i])) {
            result.push(parsedDay);
          }
        }
      }

      return result;
    }
  }, {
    key: "encode",
    value: function encode(days) {
      var result = [],
          day;

      if (days) {
        for (var i = 0; i < days.length; i++) {
          if (day = this.encodeDay(days[i])) {
            result.push(day);
          }
        }
      }

      return result;
    }
  }]);

  return RecurrenceDayRuleEncoder;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


;
RecurrenceDayRuleEncoder._$name = 'RecurrenceDayRuleEncoder';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/RecurrenceLegend.js":
/*!****************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/RecurrenceLegend.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceLegend; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/data/util/recurrence/RecurrenceLegend
 */

/**
 * A static class allowing to get a human readable description of the provided recurrence.
 *
 * ```javascript
 * const event = new EventModel({ startDate : new Date(2018, 6, 3), endDate : new Date(2018, 6, 4) });
 * const recurrence = new RecurrenceModel({ frequency : 'WEEKLY', days : ['MO', 'TU', 'WE'] });
 * event.recurrence = recurrence;
 * // "Weekly on  Mon, Tue and Wed"
 * RecurrenceLegend.getLegend(recurrence);
 * ```
 * @mixes Core/localization/Localizable
 */

var RecurrenceLegend = /*#__PURE__*/function (_Localizable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(RecurrenceLegend, _Localizable);

  var _super = _createSuper(RecurrenceLegend);

  function RecurrenceLegend() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, RecurrenceLegend);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(RecurrenceLegend, null, [{
    key: "getLegend",

    /**
     * Returns the provided recurrence description. The recurrence might be assigned to a timespan model,
     * in this case the timespan start date should be provided in the second argument.
     * @param  {Scheduler.model.RecurrenceModel} recurrence         Recurrence model.
     * @param  {Date}                           [timeSpanStartDate] The recurring timespan start date. Can be omitted if the recurrence is assigned to a timespan model
     *                                                              (and the timespan has {@link Scheduler.model.TimeSpan#field-startDate} filled).
     *                                                              Then start date will be retrieved from the model.
     * @return {String}                                             The recurrence description.
     */
    value: function getLegend(recurrence, timeSpanStartDate) {
      var me = this,
          timeSpan = recurrence.timeSpan,
          interval = recurrence.interval,
          days = recurrence.days,
          monthDays = recurrence.monthDays,
          months = recurrence.months,
          positions = recurrence.positions,
          startDate = timeSpanStartDate || timeSpan.startDate,
          tplData = {
        interval: interval
      };
      var fn;

      switch (recurrence.frequency) {
        case 'DAILY':
          return interval === 1 ? me.L('L{Daily}') : me.L('L{Every {0} days}', tplData);

        case 'WEEKLY':
          if (days && days.length) {
            tplData.days = me.getDaysLegend(days);
          } else if (startDate) {
            tplData.days = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getDayName(startDate.getDay());
          }

          return me.L(interval === 1 ? 'L{Weekly on {1}}' : 'L{Every {0} weeks on {1}}', tplData);

        case 'MONTHLY':
          if (days && days.length && positions && positions.length) {
            tplData.days = me.getDaysLegend(days, positions);
          } else if (monthDays && monthDays.length) {
            // sort dates to output in a proper order
            monthDays.sort(function (a, b) {
              return a - b;
            });
            tplData.days = me.arrayToText(monthDays);
          } else if (startDate) {
            tplData.days = startDate.getDate();
          }

          return me.L(interval === 1 ? 'L{Monthly on {1}}' : 'L{Every {0} months on {1}}', tplData);

        case 'YEARLY':
          if (days && days.length && positions && positions.length) {
            tplData.days = me.getDaysLegend(days, positions);
          } else {
            tplData.days = startDate.getDate();
          }

          if (months && months.length) {
            // sort months to output in a proper order
            months.sort(function (a, b) {
              return a - b;
            });

            if (months.length > 2) {
              fn = function fn(month) {
                return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getMonthShortName(month - 1);
              };
            } else {
              fn = function fn(month) {
                return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getMonthName(month - 1);
              };
            }

            tplData.months = me.arrayToText(months, fn);
          } else {
            tplData.months = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getMonthName(startDate.getMonth());
          }

          return me.L(interval === 1 ? 'L{Yearly on {1} of {2}}' : 'L{Every {0} years on {1} of {2}}', tplData);
      }
    }
  }, {
    key: "getDaysLegend",
    value: function getDaysLegend(days, positions) {
      var me = this,
          tplData = {
        position: ''
      };
      var fn;

      if (positions && positions.length) {
        // Do not remove. Assertion strings for Localization sanity check.
        // 'L{position1}'
        // 'L{position2}'
        // 'L{position3}'
        // 'L{position4}'
        // 'L{position5}'
        // 'L{position-1}'
        tplData.position = me.arrayToText(positions, function (position) {
          return me.L("L{position".concat(position, "}"));
        });
      }

      if (days.length) {
        days.sort(function (a, b) {
          return _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_13__["default"].decodeDay(a)[0] - _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_13__["default"].decodeDay(b)[0];
        });

        switch (days.join(',')) {
          case me.allDaysValue:
            tplData.days = me.L('L{day}');
            break;

          case me.workingDaysValue:
            tplData.days = me.L('L{weekday}');
            break;

          case me.nonWorkingDaysValue:
            tplData.days = me.L('L{weekend day}');
            break;

          default:
            if (days.length > 2) {
              fn = function fn(day) {
                return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getDayShortName(_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_13__["default"].decodeDay(day)[0]);
              };
            } else {
              fn = function fn(day) {
                return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getDayName(_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_13__["default"].decodeDay(day)[0]);
              };
            }

            tplData.days = me.arrayToText(days, fn);
        }
      }

      return me.L('L{daysFormat}', tplData);
    } // Converts array of items to a human readable list.
    // For example: [1,2,3,4]
    // to: "1, 2, 3 and 4"

  }, {
    key: "arrayToText",
    value: function arrayToText(array, fn) {
      if (fn) {
        array = array.map(fn);
      }

      return array.join(', ').replace(/,(?=[^,]*$)/, this.L('L{ and }'));
    }
  }, {
    key: "$name",
    get: function get() {
      return 'RecurrenceLegend';
    }
  }, {
    key: "allDaysValue",
    get: function get() {
      return 'SU,MO,TU,WE,TH,FR,SA';
    }
  }, {
    key: "workingDaysValue",
    get: function get() {
      return 'MO,TU,WE,TH,FR';
    }
  }, {
    key: "nonWorkingDaysValue",
    get: function get() {
      return 'SU,SA';
    }
  }]);

  return RecurrenceLegend;
}(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_12__["default"])());


RecurrenceLegend._$name = 'RecurrenceLegend';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js":
/*!************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WeeklyRecurrenceIterator; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Scheduler/data/util/recurrence/WeeklyRecurrenceIterator
*/




/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

var WeeklyRecurrenceIterator = /*#__PURE__*/function (_AbstractRecurrenceIt) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(WeeklyRecurrenceIterator, _AbstractRecurrenceIt);

  var _super = _createSuper(WeeklyRecurrenceIterator);

  function WeeklyRecurrenceIterator() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, WeeklyRecurrenceIterator);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(WeeklyRecurrenceIterator, null, [{
    key: "forEachDate",

    /**
     * Iterates over the passed date range, calling the passed callback on each date on which
     * starts an event which matches the passed recurrence rule and overlaps the start and end dates.
     * @param {Object} config An object which describes how to iterate.
     * @param {Date} config.startDate The point in time to begin iteration.
     * @param {Date} config.endDate The point in time to end iteration.
     * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
     * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
     * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
     * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
     * @param {Date} config.fn.date The occurrence date.
     * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
     * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
     * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
     */
    value: function forEachDate(config) {
      var _this$processIteratio = this.processIterationConfig(config),
          startOnly = _this$processIteratio.startOnly,
          startDate = _this$processIteratio.startDate,
          endDate = _this$processIteratio.endDate,
          timeSpan = _this$processIteratio.timeSpan,
          timeSpanStart = _this$processIteratio.timeSpanStart,
          earliestVisibleDate = _this$processIteratio.earliestVisibleDate,
          durationMS = _this$processIteratio.durationMS,
          spansStart = _this$processIteratio.spansStart,
          recurrence = _this$processIteratio.recurrence,
          fn = _this$processIteratio.fn,
          extraArgs = _this$processIteratio.extraArgs,
          _this$processIteratio2 = _this$processIteratio.scope,
          scope = _this$processIteratio2 === void 0 ? this : _this$processIteratio2,
          interval = recurrence.interval,
          days = recurrence.days;

      var counter = 0,
          count = recurrence.count,
          weekDays = _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_12__["default"].decode(days),
          weekStartDate,
          occurrenceDate; // days could be provided in any order so it's important to sort them

      if (weekDays && weekDays.length) {
        weekDays.sort(function (a, b) {
          return a[0] - b[0];
        });
      } // "Days" might be skipped then we use the event start day
      else {
          weekDays = [[timeSpanStart.getDay()]];
        } // if the recurrence is limited w/ "Count"
      // we need to 1st count passed occurrences so we always start iteration from the event start date


      weekStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getNext(count ? timeSpanStart : startDate, 'week', 0, 0);

      if (!endDate && !count) {
        count = this.MAX_OCCURRENCES_COUNT;
      }

      while (!endDate || weekStartDate <= endDate) {
        for (var i = 0; i < weekDays.length; i++) {
          occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].copyTimeValues(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].add(weekStartDate, weekDays[i][0], 'day'), timeSpanStart);

          if (occurrenceDate >= timeSpanStart) {
            var inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
            counter++;

            if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(extraArgs))) === false || count && counter >= count)) {
              return;
            }
          }
        } // get next week start


        weekStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getNext(weekStartDate, 'week', interval, 0);
      }
    }
  }, {
    key: "frequency",
    get: function get() {
      return 'WEEKLY';
    }
  }]);

  return WeeklyRecurrenceIterator;
}(_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


WeeklyRecurrenceIterator._$name = 'WeeklyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js":
/*!************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return YearlyRecurrenceIterator; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Scheduler/data/util/recurrence/YearlyRecurrenceIterator
*/




/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

var YearlyRecurrenceIterator = /*#__PURE__*/function (_AbstractRecurrenceIt) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(YearlyRecurrenceIterator, _AbstractRecurrenceIt);

  var _super = _createSuper(YearlyRecurrenceIterator);

  function YearlyRecurrenceIterator() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, YearlyRecurrenceIterator);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(YearlyRecurrenceIterator, null, [{
    key: "forEachDate",

    /**
     * Iterates over the passed date range, calling the passed callback on each date on which
     * starts an event which matches the passed recurrence rule and overlaps the start and end dates.
     * @param {Object} config An object which describes how to iterate.
     * @param {Date} config.startDate The point in time to begin iteration.
     * @param {Date} config.endDate The point in time to end iteration.
     * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
     * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
     * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
     * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
     * @param {Date} config.fn.date The occurrence date.
     * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
     * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
     * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
     */
    value: function forEachDate(config) {
      var _this = this;

      var _this$processIteratio = this.processIterationConfig(config),
          startOnly = _this$processIteratio.startOnly,
          startDate = _this$processIteratio.startDate,
          endDate = _this$processIteratio.endDate,
          timeSpan = _this$processIteratio.timeSpan,
          timeSpanStart = _this$processIteratio.timeSpanStart,
          earliestVisibleDate = _this$processIteratio.earliestVisibleDate,
          durationMS = _this$processIteratio.durationMS,
          spansStart = _this$processIteratio.spansStart,
          recurrence = _this$processIteratio.recurrence,
          fn = _this$processIteratio.fn,
          extraArgs = _this$processIteratio.extraArgs,
          _this$processIteratio2 = _this$processIteratio.scope,
          scope = _this$processIteratio2 === void 0 ? this : _this$processIteratio2,
          interval = recurrence.interval,
          days = recurrence.days,
          count = recurrence.count,
          positions = recurrence.positions,
          weekDays = _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_14__["default"].decode(days),
          hasPositions = positions && positions.length,
          processedDate = {};

      var months = recurrence.months,
          counter = 0,
          i,
          occurrenceDate,
          dates,
          yearStartDate,
          yearEndDate,
          weekDayPosition; // if the recurrence is limited w/ "Count"
      // we need to 1st count passed occurrences so we always start iteration from the event start date

      yearStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].startOf(count ? timeSpanStart : startDate, 'year');
      yearEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getNext(yearStartDate, 'year', 1) - 1);
      months && months.sort(function (a, b) {
        return a - b;
      }); // if no months provided let's use the event month

      if (!(months && months.length) && !(weekDays && weekDays.length)) {
        months = [timeSpanStart.getMonth() + 1];
      }

      if (weekDays && weekDays.length) {
        // Collect hash of positions indexed by week days
        weekDays.forEach(function (day) {
          if (day[1]) {
            weekDayPosition = weekDayPosition || {};
            weekDayPosition[day[0]] = day[1];
          }
        });
      }

      while ((!endDate || endDate >= yearStartDate) && (!count || counter < count)) {
        dates = [];

        if (weekDays && weekDays.length) {
          weekDays.forEach(function (day) {
            var weekDay = day[0],
                from = 1,
                till = 53; // if position provided

            if (day[1]) {
              from = till = day[1];
            }

            for (i = from; i <= till; i++) {
              if (occurrenceDate = _this.getNthDayInPeriod(yearStartDate, yearEndDate, weekDay, i)) {
                occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].copyTimeValues(occurrenceDate, timeSpanStart);

                if (!processedDate[occurrenceDate.getTime()]) {
                  // remember we processed the date
                  processedDate[occurrenceDate.getTime()] = true;
                  dates.push(occurrenceDate);
                }
              }
            }
          });
          dates.sort(function (a, b) {
            return a - b;
          });

          if (!hasPositions) {
            for (i = 0; i < dates.length; i++) {
              occurrenceDate = dates[i];

              if (occurrenceDate >= timeSpanStart) {
                var inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
                counter++;

                if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(extraArgs))) === false || count && counter >= count)) {
                  return;
                }
              }
            }
          }
        } else {
          for (i = 0; i < months.length; i++) {
            if (occurrenceDate = this.buildDate(yearStartDate.getFullYear(), months[i] - 1, timeSpanStart.getDate())) {
              occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].copyTimeValues(occurrenceDate, timeSpanStart); // check if the date wasn't iterated over yet

              if (!processedDate[occurrenceDate.getTime()]) {
                processedDate[occurrenceDate.getTime()] = true;

                if (hasPositions) {
                  dates.push(occurrenceDate);
                } else if (occurrenceDate >= timeSpanStart) {
                  var _inView = startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate && !timeSpan.hasException(occurrenceDate);

                  counter++;

                  if (_inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(extraArgs))) === false || count && counter >= count)) {
                    return;
                  }
                }
              }
            }
          }
        }

        if (hasPositions && dates.length) {
          this.forEachDateAtPositions(dates, positions, function (occurrenceDate) {
            if (occurrenceDate >= timeSpanStart) {
              var _inView2 = startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate && !timeSpan.hasException(occurrenceDate);

              counter++; // Ignore dates outside of the [startDate, endDate] range

              if (_inView2 && (!endDate || occurrenceDate <= endDate)) {
                // return false if it's time to stop recurring
                if (fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(extraArgs))) === false || count && counter >= count) {
                  return false;
                }
              }
            }
          });
        } // get next month start


        yearStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getNext(yearStartDate, 'year', interval);
        yearEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getNext(yearStartDate, 'year', 1) - 1);
      }
    }
  }, {
    key: "frequency",
    get: function get() {
      return 'YEARLY';
    }
  }]);

  return YearlyRecurrenceIterator;
}(_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_12__["default"]);


YearlyRecurrenceIterator._$name = 'YearlyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/eventlayout/HorizontalLayout.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/eventlayout/HorizontalLayout.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalLayout; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/eventlayout/HorizontalLayout
 */

/**
 * Base class for HorizontalLayoutPack & HorizontalLayoutStack. Should not be used directly, instead specify
 * {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventLayout} in Scheduler config (stack, pack or none):
 * @example
 * let scheduler = new Scheduler({
 *   eventLayout: 'stack'
 * });
 * @abstract
 * @private
 */

var HorizontalLayout = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(HorizontalLayout, _Base);

  var _super = _createSuper(HorizontalLayout);

  function HorizontalLayout() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, HorizontalLayout);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(HorizontalLayout, [{
    key: "clearCache",
    value: function clearCache(resource) {
      if (resource) {
        delete this.nbrOfBandsByResource[resource.id];
      } else {
        this.nbrOfBandsByResource = {};
      }
    } // Input:
    // 1. Resource record
    // 2. Array of Event models, or a function to call to receive such event records lazily

  }, {
    key: "getNumberOfBands",
    value: function getNumberOfBands(resource, resourceEventsOrFn) {
      var nbrOfBandsByResource = this.nbrOfBandsByResource;

      if (nbrOfBandsByResource.hasOwnProperty(resource.id)) {
        return nbrOfBandsByResource[resource.id];
      }

      var resourceEvents = typeof resourceEventsOrFn === 'function' ? resourceEventsOrFn() : resourceEventsOrFn,
          eventsData = resourceEvents.map(function (event) {
        return {
          start: event.startDate,
          end: event.endDate,
          event: event
        };
      });
      return this.applyLayout(eventsData, resource);
    } // TODO DOC

  }, {
    key: "applyLayout",
    value: function applyLayout(events, resource) {
      var rowEvents = events.slice(),
          // return a number of bands required
      newNbrBands = this.layoutEventsInBands(rowEvents);
      return this.nbrOfBandsByResource[resource.id] = newNbrBands;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        nbrOfBandsByResource: {},
        bandIndexToPxConvertFn: null,
        bandIndexToPxConvertThisObj: null
      };
    }
  }]);

  return HorizontalLayout;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


HorizontalLayout._$name = 'HorizontalLayout';

/***/ }),

/***/ "./lib/Scheduler/eventlayout/HorizontalLayoutPack.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/eventlayout/HorizontalLayoutPack.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalLayoutPack; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./HorizontalLayout.js */ "./lib/Scheduler/eventlayout/HorizontalLayout.js");
/* harmony import */ var _PackMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./PackMixin.js */ "./lib/Scheduler/eventlayout/PackMixin.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/eventlayout/HorizontalLayoutPack
 */

/**
 * Handles layout of events within a row (resource) in horizontal mode. Packs events (adjusts their height) to fit
 * available row height
 *
 * @extends Scheduler/eventlayout/HorizontalLayout
 * @mixes Scheduler/eventlayout/PackMixin
 * @private
 */

var HorizontalLayoutPack = /*#__PURE__*/function (_PackMixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(HorizontalLayoutPack, _PackMixin);

  var _super = _createSuper(HorizontalLayoutPack);

  function HorizontalLayoutPack() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, HorizontalLayoutPack);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(HorizontalLayoutPack, [{
    key: "applyLayout",
    // Packs the events to consume as little space as possible
    value: function applyLayout(events) {
      var _this = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(HorizontalLayoutPack.prototype), "applyLayout", this).call(this, events, function (event, j, slot, slotSize) {
        event.height = slotSize;
        event.top = slot.start + j * slotSize;
      });

      events.forEach(function (event) {
        Object.assign(event, _this.bandIndexToPxConvertFn.call(_this.bandIndexToPxConvertThisObj || _this, event.top, event.height, null, event.eventRecord));
      });
    }
  }]);

  return HorizontalLayoutPack;
}(Object(_PackMixin_js__WEBPACK_IMPORTED_MODULE_13__["default"])(_HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_12__["default"]));


HorizontalLayoutPack._$name = 'HorizontalLayoutPack';

/***/ }),

/***/ "./lib/Scheduler/eventlayout/HorizontalLayoutStack.js":
/*!************************************************************!*\
  !*** ./lib/Scheduler/eventlayout/HorizontalLayoutStack.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalLayoutStack; });
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./HorizontalLayout.js */ "./lib/Scheduler/eventlayout/HorizontalLayout.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/eventlayout/HorizontalLayoutStack
 */

/**
 * Handles layout of events within a row (resource) in horizontal mode. Stacks events, increasing row height when to fit
 * all overlapping events.
 *
 * This layout is used by default in horizontal mode.
 *
 * @extends Scheduler/eventlayout/HorizontalLayout
 * @private
 */

var HorizontalLayoutStack = /*#__PURE__*/function (_HorizontalLayout) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(HorizontalLayoutStack, _HorizontalLayout);

  var _super = _createSuper(HorizontalLayoutStack);

  function HorizontalLayoutStack() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, HorizontalLayoutStack);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(HorizontalLayoutStack, [{
    key: "layoutEventsInBands",
    // Input: Array of event layout data
    value: function layoutEventsInBands(events) {
      var verticalPosition = 0;

      do {
        var eventIndex = 0,
            event = events[0];

        while (event) {
          // Apply band height to the event cfg
          event.top = this.bandIndexToPxConvertFn.call(this.bandIndexToPxConvertThisObj || this, verticalPosition, event.eventRecord); // Remove it from the array and continue searching

          events.splice(eventIndex, 1);
          eventIndex = this.findClosestSuccessor(event, events);
          event = events[eventIndex];
        }

        verticalPosition++;
      } while (events.length > 0); // Done!


      return verticalPosition;
    } // TODO: optimize this for better performance with many events per resource

  }, {
    key: "findClosestSuccessor",
    value: function findClosestSuccessor(eventRenderData, events) {
      var eventEnd = eventRenderData.endMS,
          isMilestone = eventRenderData.eventRecord && eventRenderData.eventRecord.duration === 0;
      var minGap = Infinity,
          closest,
          gap,
          event;

      for (var i = 0, l = events.length; i < l; i++) {
        event = events[i];
        gap = event.startMS - eventEnd;

        if (gap >= 0 && gap < minGap && ( // Two milestones should not overlap
        gap > 0 || event.endMS - event.startMS > 0 || !isMilestone)) {
          closest = i;
          minGap = gap;
        }
      }

      return closest;
    }
  }]);

  return HorizontalLayoutStack;
}(_HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


HorizontalLayoutStack._$name = 'HorizontalLayoutStack';

/***/ }),

/***/ "./lib/Scheduler/eventlayout/PackMixin.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/eventlayout/PackMixin.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/eventlayout/PackMixin
 */

/**
 * Mixin holding functionality shared between HorizontalLayoutPack and VerticalLayout.
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(PackMixin, _ref);

    var _super = _createSuper(PackMixin);

    function PackMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, PackMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(PackMixin, [{
      key: "applyLayout",
      // Packs the events to consume as little space as possible
      value: function applyLayout(events, applyClusterFn) {
        var me = this,
            coordProp = me.coordProp,
            sizeProp = me.sizeProp;
        var slot, firstInCluster, cluster, j;

        for (var i = 0, l = events.length; i < l; i++) {
          firstInCluster = events[i];
          slot = me.findStartSlot(events, firstInCluster);
          cluster = me.getCluster(events, i);

          if (cluster.length > 1) {
            firstInCluster[coordProp] = slot.start;
            firstInCluster[sizeProp] = slot.end - slot.start; // If there are multiple slots and events in the cluster have multiple start dates, group all same-start events into first slot

            j = 1;

            while (j < cluster.length - 1 && cluster[j + 1].start - firstInCluster.start === 0) {
              j++;
            } // See if there's more than 1 slot available for this cluster, if so - first group in cluster consumes the entire first slot


            var nextSlot = me.findStartSlot(events, cluster[j]);

            if (nextSlot && nextSlot.start < 0.8) {
              cluster.length = j;
            }
          }

          var clusterSize = cluster.length,
              slotSize = (slot.end - slot.start) / clusterSize; // Apply fraction values

          for (j = 0; j < clusterSize; j++) {
            applyClusterFn(cluster[j], j, slot, slotSize);
          }

          i += clusterSize - 1;
        }
      }
    }, {
      key: "findStartSlot",
      value: function findStartSlot(events, event) {
        var sizeProp = this.sizeProp,
            coordProp = this.coordProp,
            priorOverlappers = this.getPriorOverlappingEvents(events, event);
        var i;

        if (priorOverlappers.length === 0) {
          return {
            start: 0,
            end: 1
          };
        }

        for (i = 0; i < priorOverlappers.length; i++) {
          if (i === 0 && priorOverlappers[0][coordProp] > 0) {
            return {
              start: 0,
              end: priorOverlappers[0][coordProp]
            };
          } else if (priorOverlappers[i][coordProp] + priorOverlappers[i][sizeProp] < (i < priorOverlappers.length - 1 ? priorOverlappers[i + 1][coordProp] : 1)) {
            return {
              start: priorOverlappers[i][coordProp] + priorOverlappers[i][sizeProp],
              end: i < priorOverlappers.length - 1 ? priorOverlappers[i + 1][coordProp] : 1
            };
          }
        }

        return false;
      }
    }, {
      key: "getPriorOverlappingEvents",
      value: function getPriorOverlappingEvents(events, event) {
        var start = event.start,
            end = event.end,
            overlappers = [];

        for (var i = 0, l = events.indexOf(event); i < l; i++) {
          if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].intersectSpans(start, end, events[i].start, events[i].end)) {
            overlappers.push(events[i]);
          }
        }

        overlappers.sort(this.sortOverlappers.bind(this));
        return overlappers;
      }
    }, {
      key: "sortOverlappers",
      value: function sortOverlappers(e1, e2) {
        return e1[this.coordProp] < e2[this.coordProp] ? -1 : 1;
      }
    }, {
      key: "getCluster",
      value: function getCluster(events, startIndex) {
        var startEvent = events[startIndex];

        if (startIndex >= events.length - 1) {
          return [startEvent];
        }

        var evts = [startEvent],
            l = events.length;
        var start = startEvent.start,
            end = startEvent.end,
            i = startIndex + 1;

        while (i < l && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].intersectSpans(start, end, events[i].start, events[i].end)) {
          evts.push(events[i]);
          start = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].max(start, events[i].start);
          end = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].min(events[i].end, end);
          i++;
        }

        return evts;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'PackMixin';
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          coordProp: 'top',
          sizeProp: 'height'
        };
      }
    }]);

    return PackMixin;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/eventlayout/VerticalLayout.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/eventlayout/VerticalLayout.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VerticalLayout; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _PackMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./PackMixin.js */ "./lib/Scheduler/eventlayout/PackMixin.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/eventlayout/VerticalLayout
 */

/**
 * Assists with event layout in vertical mode, handles `eventLayout: none|pack|mixed`
 * @private
 * @mixes Scheduler/eventlayout/PackMixin
 */

var VerticalLayout = /*#__PURE__*/function (_PackMixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(VerticalLayout, _PackMixin);

  var _super = _createSuper(VerticalLayout);

  function VerticalLayout() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, VerticalLayout);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(VerticalLayout, [{
    key: "applyLayout",
    // Try to pack the events to consume as little space as possible
    value: function applyLayout(events, columnWidth, resourceMargin, barMargin, columnIndex) {
      var _this = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(VerticalLayout.prototype), "applyLayout", this).call(this, events, function (tplData, clusterIndex, slot, slotSize) {
        // Stretch events to fill available width
        if (_this.scheduler.eventLayout === 'none') {
          tplData.width = columnWidth - resourceMargin * 2;
          tplData.left += resourceMargin;
        } else {
          // Fractions of resource column
          tplData.widthFactor = slotSize;
          var leftFactor = tplData.leftFactor = slot.start + clusterIndex * slotSize,
              // Number of "columns" in the current slot
          packColumnCount = Math.round(1 / slotSize),
              // Index among those columns for current event
          packColumnIndex = leftFactor / slotSize,
              // Width with all bar margins subtracted
          availableWidth = columnWidth - resourceMargin * 2 - barMargin * (packColumnCount - 1); // Allowing two events to overlap? Slightly offset the second

          if (_this.scheduler.eventLayout === 'mixed' && packColumnCount === 2) {
            tplData.left += leftFactor * columnWidth / 5 + barMargin;
            tplData.width = columnWidth - leftFactor * columnWidth / 5 - barMargin * 2;
            tplData.zIndex = 5 + packColumnIndex;
          } // Pack by default
          else {
              // Fractional width
              tplData.width = slotSize * availableWidth; // Translate to absolute position

              tplData.left += leftFactor * availableWidth + resourceMargin + barMargin * packColumnIndex;
            }
        }
      });
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        coordProp: 'leftFactor',
        sizeProp: 'widthFactor'
      };
    }
  }]);

  return VerticalLayout;
}(Object(_PackMixin_js__WEBPACK_IMPORTED_MODULE_9__["default"])());


VerticalLayout._$name = 'VerticalLayout';

/***/ }),

/***/ "./lib/Scheduler/feature/AbstractTimeRanges.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/feature/AbstractTimeRanges.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AbstractTimeRanges; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_number_max_safe_integer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.number.max-safe-integer */ "./node_modules/core-js/modules/es.number.max-safe-integer.js");
/* harmony import */ var core_js_modules_es_number_max_safe_integer__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_max_safe_integer__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Core/helper/ResizeHelper.js */ "./lib/Core/helper/ResizeHelper.js");
/* harmony import */ var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");

























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';










/**
 * @module Scheduler/feature/AbstractTimeRanges
 */

/**
 * Abstract base class, you should not use this class directly.
 * @abstract
 * @mixes Core/mixin/Delayable
 * @extends Core/mixin/InstancePlugin
 */

var AbstractTimeRanges = /*#__PURE__*/function (_InstancePlugin$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default()(AbstractTimeRanges, _InstancePlugin$mixin);

  var _super = _createSuper(AbstractTimeRanges);

  function AbstractTimeRanges() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, AbstractTimeRanges);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(AbstractTimeRanges, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(client, config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(AbstractTimeRanges.prototype), "construct", this).call(this, client, config); // Add a unique cls used by subclasses to get custom styling of the elements rendered
      // This makes sure that each class only removed its own elements from the DOM


      me.cls = me.cls || "b-timerange-".concat(me.constructor.$$name);
      me.baseSelector = ".".concat(me.baseCls, ".").concat(me.cls); // header elements are required for interaction

      if (me.enableResizing) {
        me.showHeaderElements = true;
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _me$storeDetacher, _me$clockTemplate, _me$tip, _me$drag, _me$resize;

      var me = this;
      (_me$storeDetacher = me.storeDetacher) === null || _me$storeDetacher === void 0 ? void 0 : _me$storeDetacher.call(me);
      me.detachListeners('timeAxisViewModel');
      me.detachListeners('timeAxis');
      (_me$clockTemplate = me.clockTemplate) === null || _me$clockTemplate === void 0 ? void 0 : _me$clockTemplate.destroy();
      (_me$tip = me.tip) === null || _me$tip === void 0 ? void 0 : _me$tip.destroy();
      (_me$drag = me.drag) === null || _me$drag === void 0 ? void 0 : _me$drag.destroy();
      (_me$resize = me.resize) === null || _me$resize === void 0 ? void 0 : _me$resize.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(AbstractTimeRanges.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      if (this.client.isPainted) {
        this.renderRanges();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(AbstractTimeRanges.prototype), "doDisable", this).call(this, disable);
    } //endregion
    //region Draw

  }, {
    key: "onPaint",
    value: function onPaint() {
      var me = this,
          client = me.client;

      if (!me.isPainted) {
        me.timeAxisViewModel = client.timeAxisViewModel;
        me.timeAxisViewModel.on({
          name: 'timeAxisViewModel',
          // TODO seems not needed to listen to both "reconfigure" & "update" ..causes double re-rendering
          // reconfigure : 'onTimeAxisViewModelUpdate',
          update: 'onTimeAxisViewModelUpdate',
          thisObj: me
        });
        client.timeAxis.on({
          name: 'timeAxis',
          includeChange: 'onTimeAxisViewModelUpdate',
          thisObj: me
        });

        if (me.enableResizing && !client.hideHeaders) {
          me.drag = new _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"]({
            name: 'rangeDrag',
            mode: client.isVertical ? 'translateY' : 'translateX',
            constrain: true,
            outerElement: me.headerContainerElement,
            targetSelector: "".concat(me.baseSelector),
            isElementDraggable: function isElementDraggable(el, event) {
              return !client.readOnly && me.isElementDraggable(el, event);
            },
            transitionDuration: client.transitionDuration,
            listeners: {
              dragstart: 'onDragStart',
              drag: 'onDrag',
              drop: 'onDrop',
              abort: 'onInvalidDrop',
              thisObj: me
            }
          });
          me.resize = new _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"]({
            direction: client.mode,
            targetSelector: "".concat(me.baseSelector, ".b-sch-range"),
            outerElement: me.headerContainerElement,
            isElementResizable: function isElementResizable(el) {
              return !el.closest('.b-dragging');
            },
            listeners: {
              resizestart: 'onResizeStart',
              resizing: 'onResizeDrag',
              resize: 'onResize',
              cancel: 'onInvalidResize',
              thisObj: me
            }
          });
        }

        me.renderRanges();
      }
    }
  }, {
    key: "renderRanges",
    value: function renderRanges() {
      var me = this,
          element = me.client.foregroundCanvas; // Scheduler/Gantt might not yet be rendered

      if (element) {
        var headerContainerElement = me.headerContainerElement; // remove existing timeRanges

        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].removeEachSelector(element, me.baseSelector); // Partnered Scheduler might not have header container element

        if (headerContainerElement) {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].removeEachSelector(headerContainerElement, me.baseSelector);
        }

        if (!me.disabled) {
          // add timeRanges
          var _iterator = _createForOfIteratorHelper(me.timeRanges),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var range = _step.value;
              me.renderRange(range, true);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
    }
    /**
     * Returns the TimeRanges in the store.
     * @returns {Scheduler.model.TimeSpan[]} the time ranges in the store.
     */

  }, {
    key: "shouldRenderRange",
    value: function shouldRenderRange(range) {
      var timeAxis = this.client.timeAxis;
      return range.duration && timeAxis.timeSpanInAxis(range.startDate, range.endDate) || range.startDate && timeAxis.dateInAxis(range.startDate);
    }
  }, {
    key: "renderRange",
    value: function renderRange(range, injectIntoDom) {
      var me = this,
          client = me.client;

      if (me.shouldRenderRange(range)) {
        var _className;

        var startPos = client.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].max(range.startDate, client.timeAxis.startDate), {
          respectExclusion: true
        }),
            endPos = range.duration && client.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].min(range.endDate, client.timeAxis.endDate), {
          respectExclusion: true,
          isEnd: true
        }),
            size = endPos - startPos,
            labelTpl = "<label>".concat(range.iconCls ? "<i class=\"".concat(range.iconCls, "\"></i>") : '', " ").concat(range.name || '&nbsp;', "</label>"),
            config = {
          className: (_className = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_className, me.baseCls, 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_className, me.cls, me.cls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_className, me.rangeCls, endPos), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_className, me.lineCls, !endPos), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_className, range.cls, range.cls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_17___default()(_className, 'b-narrow-range', endPos && size < me.narrowThreshold), _className),
          //`${me.baseCls} ${me.cls} ${endPos ? me.rangeCls : me.lineCls} ${range.cls || ''}`,
          dataset: {
            id: range.id
          },
          style: client.isVertical ? "transform: translateY(".concat(startPos, "px); ").concat(endPos ? "height:".concat(size, "px") : '', ";") : "transform: translateX(".concat(startPos, "px); ").concat(endPos ? "width:".concat(size, "px") : '', ";"),
          retainElement: true // To prevent DomHelper.sync from reusing the element

        },
            bodyElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].createElement(Object.assign({}, config, {
          parent: injectIntoDom && client.foregroundCanvas,
          style: config.style + (range.style || ''),
          html: me.showHeaderElements && !me.showLabelInBody ? '' : labelTpl
        }));
        var headerElement;

        if (me.showHeaderElements) {
          headerElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].createElement(Object.assign({
            parent: injectIntoDom && me.headerContainerElement,
            html: range.name && !me.showLabelInBody ? labelTpl : ''
          }, config));
        }

        var result = {
          bodyElement: bodyElement,
          headerElement: headerElement
        };

        if (injectIntoDom) {
          // Make the label run vertically if it overflows the width
          me.rotateLabel(range, result);
        }

        return result;
      }
    }
  }, {
    key: "rotateLabel",
    value: function rotateLabel(range, _ref) {
      var bodyElement = _ref.bodyElement;

      // Lines have no label. Do not check label content to do not force DOM layout!
      if (!range.iconCls && !range.name) {
        return;
      }

      var label = bodyElement.firstChild; // Check if label is rendered

      if (!label) {
        return;
      } // Remove any rotation so with can be measured.


      label.classList.remove('b-vertical');
      var rotate = this.client.isVertical ? label.offsetHeight < bodyElement.offsetHeight : label.offsetWidth > bodyElement.offsetWidth; // If it overflows, rotate it.

      label.classList[rotate ? 'add' : 'remove']('b-vertical');
    } // returns one body el (+ optionally one header el) that represents a time range, or null if timeRanges is not currently rendered

  }, {
    key: "getElementsByRecord",
    value: function getElementsByRecord(idOrRecord) {
      var id = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_16___default()(idOrRecord) !== 'object' ? idOrRecord : idOrRecord.id,
          bodyElement = this.client.foregroundCanvas.querySelector("".concat(this.baseSelector, "[data-id=\"").concat(id, "\"]")),
          headerElement = this.headerContainerElement.querySelector("".concat(this.baseSelector, "[data-id=\"").concat(id, "\"]"));
      return bodyElement ? {
        bodyElement: bodyElement,
        headerElement: headerElement
      } : null;
    }
  }, {
    key: "getBodyElementByRecord",
    value: function getBodyElementByRecord(idOrRecord) {
      var id = typeof idOrRecord === 'string' ? idOrRecord : idOrRecord.id;
      return this.client.foregroundCanvas.querySelector("".concat(this.baseSelector, "[data-id=\"").concat(id, "\"]"));
    }
  }, {
    key: "getRecordByElement",
    value: function getRecordByElement(el) {
      return this.store.getById(el.dataset.id);
    }
  }, {
    key: "populateHeaderMenu",
    //endregion
    //region Menu items
    // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/4.0.0.md for more information.

    /**
     * Adds menu items for the context menu.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     * @deprecated 4.0.0 Use `populateTimeAxisHeaderMenu` instead.
     */
    value: function populateHeaderMenu(_ref2) {
      var column = _ref2.column,
          items = _ref2.items;

      if (column.type !== 'timeAxis') {
        return;
      }

      this.populateTimeAxisHeaderMenu.apply(this, arguments);
    }
    /**
     * Adds menu items for the context menu, and may mutate the menu configuration.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateTimeAxisHeaderMenu",
    value: function populateTimeAxisHeaderMenu(_ref3) {
      var column = _ref3.column,
          items = _ref3.items;
    } //endregion
    //region Store

    /**
     * Returns the {@link Core.data.Store store} used by this feature
     * @property {Core.data.Store}
     */

  }, {
    key: "onTimeAxisViewModelUpdate",
    //endregion
    //region Events
    value: function onTimeAxisViewModelUpdate() {
      this.renderRanges();
    }
  }, {
    key: "onStoreChanged",
    value: function onStoreChanged(event) {
      var me = this;

      if (me.disabled || me.isConfiguring || event.type === 'refresh' && event.action !== 'batch') {
        return;
      } // Only animate changes that happen as a result of a pure data change, i.e. not after a drag drop


      if (event.action === 'update') {
        var range = event.record,
            id = event.changes.hasOwnProperty('id') ? event.changes.id.oldValue : range.id,
            existingElements = me.getElementsByRecord(id),
            redrawnElements = me.renderRange(range, !existingElements);

        if (existingElements && !redrawnElements) {
          existingElements.bodyElement.remove();
          existingElements.headerElement && existingElements.headerElement.remove();
        }

        if (!existingElements || !redrawnElements) return;
        me.client.runWithTransition(function () {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].sync(redrawnElements.bodyElement, existingElements.bodyElement);

          if (me.showHeaderElements) {
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].sync(redrawnElements.headerElement, existingElements.headerElement);
          } // Make the label run vertically if it overflows the width


          me.rotateLabel(range, existingElements);
        });
      } else {
        me.renderRanges();
      }
    } //endregion
    //region Drag drop

  }, {
    key: "showTip",
    value: function showTip(context) {
      var me = this;

      if (me.showTooltip) {
        me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_29__["default"]({
          scheduler: me.client
        });
        me.tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_28__["default"]({
          id: "".concat(me.client.id, "-time-range-tip"),
          cls: 'b-interaction-tooltip',
          align: 'b-t',
          autoShow: true,
          updateContentOnMouseMove: true,
          forElement: context.element,
          getHtml: function getHtml() {
            return me.getTipHtml(context.record, context.element);
          }
        });
      }
    }
  }, {
    key: "isElementDraggable",
    value: function isElementDraggable(el) {
      el = el.closest(this.baseSelector + ':not(.b-resizing)');
      return el && !el.classList.contains('b-over-resize-handle');
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(_ref4) {
      var context = _ref4.context;
      var me = this,
          record = me.getRecordByElement(context.element.closest(me.baseSelector)),
          rangeBodyEl = me.getBodyElementByRecord(record),
          drag = me.drag;
      Object.assign(context, {
        record: record,
        rangeBodyEl: rangeBodyEl,
        originRangeX: _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].getTranslateX(rangeBodyEl),
        originRangeY: _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].getTranslateY(rangeBodyEl)
      });

      if (me.client.isVertical) {
        drag.minY = 0; // Moving the range, you can drag the start marker down until the end of the range hits the time axis end

        drag.maxY = me.timeAxisViewModel.totalSize - context.rangeBodyEl.offsetHeight; // Setting min/max for X makes drag right of the header valid, but visually still constrained vertically

        drag.minX = 0;
        drag.maxX = Number.MAX_SAFE_INTEGER;
      } else {
        drag.minX = 0; // Moving the range, you can drag the start marker right until the end of the range hits the time axis end

        drag.maxX = me.timeAxisViewModel.totalSize - context.rangeBodyEl.offsetWidth; // Setting min/max for Y makes drag below header valid, but visually still constrained horizontally

        drag.minY = 0;
        drag.maxY = Number.MAX_SAFE_INTEGER;
      }

      me.client.element.classList.add('b-dragging-timerange');
      me.showTip(context);
    }
  }, {
    key: "onDrag",
    value: function onDrag(_ref5) {
      var context = _ref5.context;

      // sync body element with header element (x + width)
      if (this.client.isVertical) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].setTranslateY(context.rangeBodyEl, _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].getTranslateY(context.element));
      } else {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].setTranslateX(context.rangeBodyEl, _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].getTranslateX(context.element));
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(_ref6) {
      var context = _ref6.context;

      if (!context.valid) {
        return this.onInvalidDrop({
          context: context
        });
      }

      var me = this,
          record = context.record,
          box = context.rangeBodyEl.getBoundingClientRect(),
          newStart = me.client.getDateFromCoordinate(me.client.isVertical ? box.top : box.left, 'round', false),
          wasModified = record.startDate - newStart !== 0;

      if (wasModified) {
        record.setStartDate(newStart);
      } else {
        me.onInvalidDrop();
      }

      if (me.tip) {
        me.tip.destroy();
        me.tip = null;
      }

      me.client.element.classList.remove('b-dragging-timerange');
    }
  }, {
    key: "onInvalidDrop",
    value: function onInvalidDrop() {
      var me = this;
      me.drag.reset();
      me.renderRanges();
      me.client.element.classList.remove('b-dragging-timerange');

      if (me.tip) {
        me.tip.destroy();
        me.tip = null;
      }
    } // endregion
    // region Resize

  }, {
    key: "onResizeStart",
    value: function onResizeStart(_ref7) {
      var context = _ref7.context;
      var me = this,
          record = me.getRecordByElement(context.element.closest(me.baseSelector)),
          rangeBodyEl = me.getBodyElementByRecord(record);
      Object.assign(context, {
        record: record,
        rangeBodyEl: rangeBodyEl
      });
      me.showTip(context);
    }
  }, {
    key: "onResizeDrag",
    value: function onResizeDrag(_ref8) {
      var context = _ref8.context;
      var me = this;

      if (me.client.isVertical) {
        if (context.edge === 'top') {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].setTranslateY(context.rangeBodyEl, context.newY);
        }

        context.rangeBodyEl.style.height = context.newHeight + 'px';
      } else {
        if (context.edge === 'left') {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].setTranslateX(context.rangeBodyEl, context.newX);
        }

        context.rangeBodyEl.style.width = context.newWidth + 'px';
      }
    }
  }, {
    key: "onResize",
    value: function onResize(_ref9) {
      var context = _ref9.context;
      if (!context.valid) return this.onInvalidDrop({
        context: context
      });
      var me = this,
          client = me.client,
          record = context.record,
          box = context.element.getBoundingClientRect(),
          startPos = client.isVertical ? box.top : box.left,
          endPos = client.isVertical ? box.bottom : box.right,
          newStart = client.getDateFromCoordinate(startPos, 'round', false),
          isStart = context.edge === 'left' || context.edge === 'top',
          newEnd = client.getDateFromCoordinate(endPos, 'round', false),
          wasModified = isStart && record.startDate - newStart !== 0 || newEnd && record.endDate - newEnd !== 0;

      if (wasModified && newEnd > newStart) {
        if (isStart) {
          // could be that the drag operation placed the range with start/end outside the axis
          record.setStartDate(newStart, false);
        } else {
          record.setEndDate(newEnd, false);
        }
      } else {
        me.onInvalidResize();
      }

      if (me.tip) {
        me.tip.destroy();
        me.tip = null;
      }
    }
  }, {
    key: "onInvalidResize",
    value: function onInvalidResize() {
      var me = this;
      me.resize.reset();
      me.renderRanges();

      if (me.tip) {
        me.tip.destroy();
        me.tip = null;
      }
    } //endregion
    //region Tooltip

    /**
     * Generates the html to display in the tooltip during drag drop.
     */

  }, {
    key: "getTipHtml",
    value: function getTipHtml(record, element) {
      var me = this,
          client = me.client,
          box = element.getBoundingClientRect(),
          startPos = client.isVertical ? box.top : box.left,
          endPos = client.isVertical ? box.bottom : box.right,
          startDate = client.getDateFromCoordinate(startPos, 'round', false),
          endDate = record.endDate && client.getDateFromCoordinate(endPos, 'round', false),
          startText = client.getFormattedDate(startDate),
          endText = endDate && client.getFormattedEndDate(endDate, startDate);
      return me.dragTipTemplate({
        name: record.name || '',
        startDate: startDate,
        endDate: endDate,
        startText: startText,
        endText: endText,
        startClockHtml: me.clockTemplate.template({
          date: startDate,
          text: startText,
          cls: 'b-sch-tooltip-startdate'
        }),
        endClockHtml: endText && me.clockTemplate.template({
          date: endDate,
          text: endText,
          cls: 'b-sch-tooltip-enddate'
        })
      });
    } //endregion

  }, {
    key: "timeRanges",
    get: function get() {
      return this.store.records;
    }
  }, {
    key: "headerContainerElement",
    get: function get() {
      var _this$client = this.client,
          isVertical = _this$client.isVertical,
          timeView = _this$client.timeView,
          timeAxisColumn = _this$client.timeAxisColumn;
      var element = null; // Render into the subGrid´s header element or the vertical timeaxis depending on mode

      if (isVertical && timeView.element) {
        element = timeView.element.parentElement;
      } else if (!isVertical) {
        element = timeAxisColumn.element;
      }

      return element;
    } //endregion
    //region Settings

    /**
     * Get/set if header elements should be rendered
     * @property {boolean}
     */

  }, {
    key: "showHeaderElements",
    get: function get() {
      return this._showHeaderElements;
    },
    set: function set(show) {
      this._showHeaderElements = show;
      if (!this.client.isPainted) return;

      if (show) {
        this.client.element.classList.add('b-sch-timeranges-with-headerelements');
      } else {
        this.client.element.classList.remove('b-sch-timeranges-with-headerelements');
      }

      this.renderRanges();
    }
  }, {
    key: "store",
    get: function get() {
      return this._store;
    },
    set: function set(store) {
      var me = this;
      me._store = _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_25__["default"].getStore(store, _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_25__["default"]);
      var renderRanges = false; // if we had some store assigned before we need to detach it

      if (me.storeDetacher) {
        me.storeDetacher(); // then we'll need to render ranges provided by the new store

        renderRanges = true;
      }

      me.storeDetacher = me._store.on({
        change: me.onStoreChanged,
        refresh: me.onStoreChanged,
        thisObj: me
      }); // render ranges if needed

      renderRanges && this.renderRanges();
    }
  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        // CSS class to apply to range elements
        rangeCls: 'b-sch-range',
        // CSS class to apply to line elements (0-duration time range)
        lineCls: 'b-sch-line',

        /**
         * Store that holds timeRanges (using the {@link Scheduler.model.TimeSpan} model or subclass thereof).
         * A store will be automatically created if none is specified
         * @config {Object|Core.data.Store}
         */
        store: {
          modelClass: _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_33__["default"]
        },

        /**
         * Set to `true` to enable dragging and resizing of range elements in the header. Only relevant when {@link #config-showHeaderElements} is true.
         * @config {Boolean}
         * @defaultValue
         */
        enableResizing: false,

        /**
         * Specifies whether or not to show tooltip while resizing range elements
         * @config {Boolean}
         * @default
         */
        showTooltip: true,

        /**
         * `true` to render range elements into the time axis header
         * @config {Boolean}
         * @default
         */
        showHeaderElements: true,
        dragTipTemplate: function dragTipTemplate(data) {
          return "\n                <div class=\"b-sch-tip-".concat(data.valid ? 'valid' : 'invalid', "\">\n                    <div class=\"b-sch-tip-name\">").concat(data.name || '', "</div>\n                    ").concat(data.startClockHtml, "\n                    ").concat(data.endClockHtml || '', "\n                </div>\n            ");
        },
        baseCls: 'b-sch-timerange',
        // a unique cls used by subclasses to get custom styling of the elements rendered
        cls: '',
        narrowThreshold: 80
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onPaint', 'populateHeaderMenu', // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.
        'populateTimeAxisHeaderMenu']
      };
    }
  }]);

  return AbstractTimeRanges;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_24__["default"].mixin(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_31__["default"]));


AbstractTimeRanges._$name = 'AbstractTimeRanges';

/***/ }),

/***/ "./lib/Scheduler/feature/ColumnLines.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/feature/ColumnLines.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnLines; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");

































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_30___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Scheduler/feature/ColumnLines
 */

/**
 * Displays column lines for ticks, with a different styling for major ticks (by default they are darker). If this
 * feature is disabled, no lines are shown. If it's enabled, line are shown for the tick level which is set in current
 * ViewPreset. Please see {@link Scheduler.preset.ViewPreset#field-columnLinesFor} config for details.
 *
 * The lines are drawn as divs, with only visible lines available in DOM. The color and style of the lines are
 * determined the css rules for `.b-column-line` and `.b-column-line-major`.
 *
 * This feature is **enabled** by default
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/basic
 * @externalexample scheduler/ColumnLines.js
 * @classtype columnLines
 */

var ColumnLines = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_29___default()(ColumnLines, _InstancePlugin);

  var _super = _createSuper(ColumnLines);

  function ColumnLines() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_26___default()(this, ColumnLines);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_27___default()(ColumnLines, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(client, config) {
      client.useBackgroundCanvas = true;
      client.on({
        visibleRangeChange: 'onRangeChange',
        thisObj: this
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default()(ColumnLines.prototype), "construct", this).call(this, client, config);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_31___default()(ColumnLines.prototype), "doDisable", this).call(this, disable);

      if (!this.isConfiguring) {
        this.refresh();
      }
    } //endregion
    //region Draw

    /**
     * Draw lines when scheduler/gantt is rendered.
     * @private
     */

  }, {
    key: "render",
    value: function render() {
      this.refresh();
    }
    /**
     * Draw column lines that are in view
     * @private
     */

  }, {
    key: "refresh",
    value: function refresh() {
      var me = this,
          client = me.client,
          timeAxis = client.timeAxis,
          timeAxisViewModel = client.timeAxisViewModel,
          isHorizontal = client.isHorizontal,
          axisStart = timeAxis.startDate; // Early bailout for timeaxis without start date

      if (!axisStart || !me.startDate) {
        return;
      }

      var linesForLevel = timeAxisViewModel.columnLinesFor,
          majorLinesForLevel = Math.max(linesForLevel - 1, 0),
          start = me.startDate.getTime(),
          end = me.endDate.getTime(),
          domConfigs = [],
          dates = new Set();

      if (!me.element) {
        me.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].createElement({
          parent: client.backgroundCanvas,
          className: 'b-column-lines-canvas'
        });
      }

      if (!me.disabled) {
        var addLineConfig = function addLineConfig(tick, isMajor) {
          var tickEnd = tick.end.getTime(); // Only end of tick matters, not a typo :)

          if (tickEnd > start && tickEnd < end && !dates.has(tickEnd)) {
            dates.add(tickEnd);
            domConfigs.push({
              className: isMajor ? 'b-column-line-major' : 'b-column-line',
              style: _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default()({}, isHorizontal ? 'left' : 'top', tick.coord + tick.width - 1),
              dataset: {
                line: isMajor ? "major-".concat(tick.index) : "line-".concat(tick.index)
              }
            });
          }
        }; // Collect configs for major lines


        if (linesForLevel !== majorLinesForLevel) {
          timeAxisViewModel.columnConfig[majorLinesForLevel].forEach(function (tick) {
            return addLineConfig(tick, true);
          });
        } // And normal lines, skipping dates already occupied by major lines


        timeAxisViewModel.columnConfig[linesForLevel].forEach(function (tick) {
          return addLineConfig(tick, false);
        });
      }

      _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_33__["default"].sync({
        targetElement: me.element,
        onlyChildren: true,
        domConfig: {
          children: domConfigs,
          syncOptions: {
            // When zooming in and out we risk getting a lot of released lines if we do not limit it
            releaseThreshold: 4
          }
        },
        syncIdField: 'line'
      });
    } //endregion
    //region Events
    // Called when visible date range changes, for example from zooming, scrolling, resizing

  }, {
    key: "onRangeChange",
    value: function onRangeChange(_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      this.startDate = startDate;
      this.endDate = endDate;
      this.refresh();
    }
  }, {
    key: "updateCanvasSize",
    value: function updateCanvasSize() {
      this.refresh();
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ColumnLines';
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        after: ['render', 'updateCanvasSize']
      };
    }
  }]);

  return ColumnLines;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_34__["default"]);


ColumnLines._$name = 'ColumnLines';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_35__["default"].registerFeature(ColumnLines, true, ['Scheduler', 'Gantt']);

/***/ }),

/***/ "./lib/Scheduler/feature/Dependencies.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/Dependencies.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Dependencies; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_object_define_getter__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.object.define-getter */ "./node_modules/core-js/modules/es.object.define-getter.js");
/* harmony import */ var core_js_modules_es_object_define_getter__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_getter__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_59___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_59__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_60___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_60__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_61___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_61__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_62___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_62__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_63___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_63__);
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! @babel/runtime/helpers/taggedTemplateLiteral */ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
/* harmony import */ var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_64___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_64__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_65___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_65__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_66___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_66__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_67___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_67__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_68___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_68__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_69___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_69__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_70___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_70__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_71___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_71__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_73___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_73__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_74___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_74__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75__);
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../../Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ./mixin/DependencyCreation.js */ "./lib/Scheduler/feature/mixin/DependencyCreation.js");
/* harmony import */ var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony import */ var _util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../util/RectangularPathFinder.js */ "./lib/Scheduler/util/RectangularPathFinder.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");













































































function _templateObject() {
  var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_64___default()(["\n             <table class=\"b-sch-dependency-tooltip\">\n                <tr>\n                    <td>", ": </td>\n                    <td>", "</td>\n                    <td>\n                        <div class=\"b-sch-box b-", "\"></div>\n                    </td>\n                </tr>\n                <tr>\n                    <td>", ": </td>\n                    <td>", "</td>\n                    <td><div class=\"b-sch-box b-", "\"></div></td>\n                </tr>\n            </table>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_74___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';














/**
 * @module Scheduler/feature/Dependencies
 */

var fromBoxSide = ['left', 'left', 'right', 'right'],
    toBoxSide = ['left', 'right', 'left', 'right'];
/**
 * Feature that draws dependencies between events Uses a {@link Scheduler.data.DependencyStore DependencyStore} to
 * determine which dependencies to draw, if none is defined one will be created automatically. Dependencies can also be
 * specified as Scheduler#dependencies, see example below.
 *
 * To customize the dependency tooltip, you can provide the {@link #config-tooltip} config and specify a {@link Core.widget.Tooltip#config-getHtml} function.
 * For example:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         dependencies : {
 *             tooltip : {
 *                 getHtml({ activeTarget }) {
 *                     const dependencyModel = scheduler.resolveDependencyRecord(activeTarget);
 *
 *                     if (!dependencyModel) return null;
 *
 *                     const { fromEvent, toEvent } = dependencyModel;
 *
 *                     return `${fromEvent.name} (${fromEvent.id}) -> ${toEvent.name} (${toEvent.id})`;
 *                 }
 *             }
 *         }
 *     }
 * }
 * ```
 *
 * This feature is **disabled** by default. It is **not** supported in vertical mode.
 *
 * @mixes Core/mixin/Delayable
 * @mixes Scheduler/feature/mixin/DependencyCreation
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/dependencies
 * @externalexample scheduler/Dependencies.js
 * @classtype dependencies
 */

var Dependencies = /*#__PURE__*/function (_InstancePlugin$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_73___default()(Dependencies, _InstancePlugin$mixin);

  var _super = _createSuper(Dependencies);

  function Dependencies() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_70___default()(this, Dependencies);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_71___default()(Dependencies, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(scheduler) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var me = this;

      if (scheduler.isVertical) {
        throw new Error('Dependencies feature is not supported in vertical mode');
      } // Many things may schedule a draw. Ensure it only happens once, on the next frame.
      // And Ensure it really is on the *next* frame after invocation by passing
      // the cancelOutstanding flag.


      me.doScheduleDraw = me.createOnFrame('draw', [], me, true);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default()(Dependencies.prototype), "construct", this).call(this, scheduler, config);

      me.pathFinder = new _util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_87__["default"](me.pathFinderConfig);
      delete me.pathFinderConfig;
      me.lineDefAdjusters = me.createLineDefAdjusters();
      scheduler.rowManager.on({
        refresh: 'onRefresh',
        thisObj: me
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$tooltip;

      (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default()(Dependencies.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      var me = this,
          project = me.project;
      me.updateCreateListeners(); // detach/attach store listeners

      if (project || disable) {
        me.attachToResourceStore(disable ? null : project.resourceStore);
        me.attachToEventStore(disable ? null : project.eventStore);
        me.attachToAssignmentStore(disable ? null : project.assignmentStore);
        me.attachToDependencyStore(disable ? null : project.dependencyStore);
      }

      if (me.client.isPainted) {
        // draw() needs "me.dependencyStore" to be provided
        me.dependencyStore = me.dependencyStore || project.dependencyStore;
        me.draw();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default()(Dependencies.prototype), "doDisable", this).call(this, disable);
    } //endregion
    //region Dependency types

  }, {
    key: "findDependencyIndex",
    value: function findDependencyIndex() {
      var dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var dependency = arguments.length > 1 ? arguments[1] : undefined;
      var assignmentData = arguments.length > 2 ? arguments[2] : undefined;
      return dependencies.findIndex(function (item) {
        return item.dependency === dependency && (item.assignmentData === assignmentData || item.assignmentData && assignmentData && item.assignmentData.from === assignmentData.from && item.assignmentData.to === assignmentData.to);
      });
    }
  }, {
    key: "includesDependency",
    value: function includesDependency() {
      return this.findDependencyIndex.apply(this, arguments) >= 0;
    } //endregion
    //region Stores

  }, {
    key: "attachToResourceStore",
    value: function attachToResourceStore(store) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default()(Dependencies.prototype), "attachToResourceStore", this).call(this, store);

      if (store && !this.disabled) {
        store.on({
          name: 'resourceStore',
          changePreCommit: 'onResourceStoreChange',
          refreshPreCommit: 'onResourceStoreRefresh',
          thisObj: this
        });
      }
    }
  }, {
    key: "attachToDependencyStore",
    value: function attachToDependencyStore(store) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default()(Dependencies.prototype), "attachToDependencyStore", this).call(this, store); // When assigning a new store there is no point in keeping anything cached


      me.resetGridCache();
      me.resetBoundsCache();

      if (store && !me.disabled) {
        // TODO: This is rather doubtfull code, investigate it
        // used to store meta per scheduler on models, in case they are used in multiple schedulers
        store.metaMapId = me.client.id;
        store.on({
          name: 'dependencyStore',
          changePreCommit: 'onDependencyChange',
          thisObj: me
        });
      }
    }
  }, {
    key: "attachToAssignmentStore",
    value: function attachToAssignmentStore(store) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default()(Dependencies.prototype), "attachToAssignmentStore", this).call(this, store);

      if (store && !this.disabled) {
        store.on({
          name: 'assignmentStore',
          changePreCommit: 'onAssignmentChange',
          refreshPreCommit: 'onAssignmentRefresh',
          thisObj: this
        });
      }
    }
  }, {
    key: "attachToEventStore",
    value: function attachToEventStore(store) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_72___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_75___default()(Dependencies.prototype), "attachToEventStore", this).call(this, store);

      if (store && !this.disabled) {
        store.on({
          name: 'eventStore',
          changePreCommit: 'onEventChange',
          thisObj: this
        });
      }
    } //endregion
    //region Markers

  }, {
    key: "createMarkers",
    value: function createMarkers() {
      var me = this,
          svg = me.client.svgCanvas,
          endMarker = me.endMarker = me.initMarkerElement('arrowEnd', '8', 'M0,0 L0,6 L9,3 z'); // Edge and IE11 do not support required svg 2.0 orient value

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_76__["default"].isEdge || _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_76__["default"].isIE11) {
        var startMarker = me.startMarker = me.initMarkerElement('arrowStart', '1', 'M0,3 L9,6 L9,0 z');
        svg.appendChild(startMarker);
      } else {
        endMarker.setAttribute('orient', 'auto-start-reverse');
      }

      svg.appendChild(endMarker);
    }
    /**
     * Creates SVG marker element (arrow) which is used for all dependency lines
     * @private
     * @param {String} id Id of the marker element
     * @param {String} refX
     * @param {String} arrowPath Path defining arrow
     */

  }, {
    key: "initMarkerElement",
    value: function initMarkerElement(id, refX, arrowPath) {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_78__["default"].createElement({
        id: id,
        tag: 'marker',
        ns: 'http://www.w3.org/2000/svg',
        markerHeight: 9,
        markerWidth: 9,
        refX: refX,
        refY: 3,
        viewBox: '0 0 9 6',
        orient: 'auto',
        markerUnits: 'userSpaceOnUse',
        children: [{
          tag: 'path',
          ns: 'http://www.w3.org/2000/svg',
          d: arrowPath
        }]
      });
    }
    /**
     * Returns an array of functions used to alter path config when no path found.
     * It first tries to shrink arrow margins and secondly hides arrows entirely
     * @private
     * @returns {Function[]}
     */

  }, {
    key: "createLineDefAdjusters",
    value: function createLineDefAdjusters() {
      var scheduler = this.client;

      function shrinkArrowMargins(lineDef) {
        var adjusted = false;

        if (lineDef.startArrowMargin > scheduler.barMargin || lineDef.endArrowMargin > scheduler.barMargin) {
          lineDef.startArrowMargin = lineDef.endArrowMargin = scheduler.barMargin;
          adjusted = true;
        }

        return adjusted ? lineDef : adjusted;
      }

      function resetArrowMargins(lineDef) {
        var adjusted = false;

        if (lineDef.startArrowMargin > 0 || lineDef.endArrowMargin > 0) {
          lineDef.startArrowMargin = lineDef.endArrowMargin = 0;
          adjusted = true;
        }

        return adjusted ? lineDef : adjusted;
      }

      return [shrinkArrowMargins, resetArrowMargins];
    } //endregion
    //region Elements

  }, {
    key: "getElementForDependency",
    value: function getElementForDependency(dependency) {
      var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.getElementsForDependency(dependency, assignmentData)[0];
    }
  }, {
    key: "getElementsForDependency",
    value: function getElementsForDependency(dependency) {
      var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // Selector targeting all instances of a dependency
      var selector = "[depId=\"".concat(dependency.id, "\"]"); // Optionally narrow it down to a single instance (assignment)

      if (assignmentData) {
        selector += "[fromId=\"".concat(assignmentData.from.id, "\"][toId=\"").concat(assignmentData.to.id, "\"]");
      }

      return Array.from(this.client.svgCanvas.querySelectorAll(selector));
    }
    /**
     * Returns the dependency record for a DOM element
     * @param {HTMLElement} element The dependency line element
     * @return {Scheduler.model.DependencyModel} The dependency record
     */

  }, {
    key: "resolveDependencyRecord",
    value: function resolveDependencyRecord(element) {
      // getAttribute return a string or null
      var id = typeof element === 'string' ? element : element.getAttribute('depId');
      return id ? this.dependencyStore.getById(id) : null;
    } //endregion
    //region Events
    //region Events that triggers redraw
    // Refresh dependencies when grid is refreshed

  }, {
    key: "onRefresh",
    value: function onRefresh() {
      if (this.client.isEngineReady) {
        this.onProjectRefresh();
      }
    }
  }, {
    key: "onProjectRefresh",
    value: function onProjectRefresh() {
      var me = this;

      if (!me.client.refreshSuspended) {
        // Mainly for operations involving rows, adding or removing invalidates all resources
        if (me.refreshAllWhenReady) {
          me.resetGridCache();
          me.scheduleDraw(true);
          me.refreshAllWhenReady = false;
        } else if (me.toDrawOnProjectRefresh.size) {
          // Check if there is a cache exists. If it does - use it,
          // if not - create one after all records are drawn, this will cache all existing records
          var cache = me._dependencyGridCache;
          cache && me.toDrawOnProjectRefresh.forEach(function (dependency) {
            // Previously this code would draw added dependencies here, no matter if in view or not. To not have
            // to have the logic for determining whats in view or not here also, simply do a full draw below.
            // Old approach was especially costly when using CrudManager, which adds on load
            me.addToGridCache(dependency);
          });

          if (!cache) {
            me._thisIsAUsedExpression(me.dependencyGridCache);
          }

          me.toDrawOnProjectRefresh.clear();
          me.scheduleDraw();
        }
      }
    }
  }, {
    key: "onToggleNode",
    value: function onToggleNode() {
      // Need to repopulate grid cache
      this.resetGridCache(); // node toggled in tree, can affect resources both above and below, need to redraw all.

      this.scheduleDraw(true);
    }
  }, {
    key: "onViewportResize",
    value: function onViewportResize() {
      // More or fewer dependencies might be in view, but their locations has not changed so no need to invalidate
      // grid cache
      this.scheduleDraw(true);
    }
    /**
     * Flags for redrawing if a rows height has changed
     * @private
     */

  }, {
    key: "onTranslateRow",
    value: function onTranslateRow(_ref) {
      var row = _ref.row;

      // a changetotalheight event is fired after translations, if a rowHeight change is detected here it will redraw
      // all dependencies
      if (row.lastTop >= 0 && row.top !== row.lastTop) {
        this.scheduleDraw(true);
      }
    }
    /**
     * Redraws all dependencies if a rows height changed, as detected in onTranslateRow
     * @private
     */

  }, {
    key: "onChangeTotalHeight",
    value: function onChangeTotalHeight() {
      if (this.client.isEngineReady) {
        // redraw all dependencies if the height changes. Could be caused by resource add/remove.
        // in reality not all deps needs to be redrawn, those fully above the row which changed height could be left
        // as is, but determining that would likely require more processing than redrawing
        this.scheduleDraw(true);
      }
    }
    /**
     * Draws dependencies on horizontal scroll
     * @private
     */

  }, {
    key: "onHorizontalScroll",
    value: function onHorizontalScroll(_ref2) {
      var subGrid = _ref2.subGrid;

      // ResizeMonitor triggers scroll during render, make sure we have been drawn some other way before redrawing
      if (this.isDrawn && subGrid === this.client.timeAxisSubGrid) {
        this.scheduleDraw(false);
      }
    }
    /**
     * Draws dependencies on vertical scroll
     * @private
     */

  }, {
    key: "onVerticalScroll",
    value: function onVerticalScroll() {
      // ResizeMonitor triggers scroll during render, make sure render is done
      if (this.isDrawn) {
        // Do not invalidate on scroll, if height changes it will be invalidated anyway
        this.scheduleDraw(false);
      }
    }
  }, {
    key: "onRowsRefresh",
    value: function onRowsRefresh() {
      this.scheduleDraw(true);
    }
  }, {
    key: "onResourceStoreChange",
    value: function onResourceStoreChange(_ref3) {
      var action = _ref3.action;

      // bail out in case we are finalizing the propagation caused by project loading
      // we've already scheduled dependencies draw in the project "refresh" listener
      if (this.client.project.propagatingLoadChanges) {
        return;
      } // Adding/removing resources affects all dependencies that intersect or are fully below the resources.
      // Instead of determining which those are, do a full redraw when project have been recalculated


      if (action === 'add' || action === 'remove' || action === 'removeall') {
        this.refreshAllWhenReady = true;
      }
    }
    /**
     * Redraws dependencies when a row has changed
     * @private
     */

  }, {
    key: "onResourceStoreRefresh",
    value: function onResourceStoreRefresh(_ref4) {
      var action = _ref4.action;

      // bail out in case we are finalizing the propagation caused by project loading
      // we've already scheduled dependencies draw in the project "refresh" listener
      if (this.client.project.propagatingLoadChanges) {
        return;
      }

      switch (action) {
        case 'sort':
        case 'filter':
        case 'batch':
          // Will need to recreate grid cache after sort, filter, and any unspecified
          // set of operations encapsulated by a batch, and redraw everything
          this.resetGridCache();
          this.scheduleDraw(true);
      }
    }
    /**
     * Redraws dependencies when a dependency has changed
     * @private
     */

  }, {
    key: "onDependencyChange",
    value: function () {
      var _onDependencyChange = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_69___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_67___default.a.mark(function _callee(_ref5) {
        var action, record, records, me, client;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_67___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                action = _ref5.action, record = _ref5.record, records = _ref5.records;
                me = this, client = me.client; // bail out in case:
                // - client is not painted yet
                // - client has rendering suspended
                // - or we are finalizing the propagation caused by project loading
                // we've already scheduled dependencies draw in the project "refresh" listener

                if (!(!client.isPainted || client.suspendRendering || this.client.project.propagatingLoadChanges)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _context.t0 = action;
                _context.next = _context.t0 === 'dataset' ? 7 : _context.t0 === 'add' ? 10 : _context.t0 === 'update' ? 12 : _context.t0 === 'remove' ? 19 : _context.t0 === 'removeall' ? 22 : _context.t0 === 'filter' ? 22 : 24;
                break;

              case 7:
                me.dependencyGridCache = {};
                me.toDrawOnProjectRefresh = new Set(records);
                return _context.abrupt("return");

              case 10:
                // Dependency added, draw it on project refresh. Cannot draw it earlier since adding it will have
                // invalidated the graph, making it impossible to determine coords
                records.forEach(function (record) {
                  return me.toDrawOnProjectRefresh.add(record);
                });
                return _context.abrupt("return");

              case 12:
                if (me.drawnDependencies.some(function (d) {
                  return d.dependency === record;
                })) {
                  _context.next = 17;
                  break;
                }

                me.addToGridCache(record);
                me.scheduleDraw();
                _context.next = 18;
                break;

              case 17:
                return _context.abrupt("return", me.scheduleRefreshDependency(record));

              case 18:
                return _context.abrupt("break", 24);

              case 19:
                // dependencies removed, release elements and remove from cache
                records.forEach(function (dependency) {
                  me.releaseDependency(dependency, true);
                  me.removeFromCache(dependency); // Dependency might got scheduled to be refreshed before it is removed

                  me.dependenciesToRefresh.delete(dependency);
                });
                client.trigger('dependenciesDrawn');
                return _context.abrupt("return");

              case 22:
                me.resetGridCache(); // continue to schedule draw

                return _context.abrupt("break", 24);

              case 24:
                // other changes (removeall, filter) trigger full redraw
                me.scheduleDraw(true);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDependencyChange(_x) {
        return _onDependencyChange.apply(this, arguments);
      }

      return onDependencyChange;
    }()
    /**
     * Redraws dependencies when an event has changed
     * @private
     */

  }, {
    key: "onEventChange",
    value: function onEventChange(_ref6) {
      var action = _ref6.action,
          record = _ref6.record,
          changes = _ref6.changes;
      // TODO : In Gantt this will be the same as the row store, only need one
      var me = this; // bail out in case we are finalizing the propagation caused by project loading
      // we've already scheduled dependencies draw in the project "refresh" listener

      if (me.client.project.propagatingLoadChanges) {
        return;
      }

      switch (action) {
        case 'filter':
          // filtering events, need to redraw all dependencies
          me.scheduleDraw(true);
          break;

        case 'update':
          // Ignore normalization of single field
          if (Object.keys(changes).length === 1 && (changes.startDate || changes.endDate || changes.duration)) {
            return;
          }

          if (!record.isEvent) {
            me.drawForTimeSpan(record, true);
          } else {
            // event updated, need to redraw dependencies for all events in its row since it might have changed
            // vertical position (from changing startDate, duration, name or anything if using custom sorter)
            var eventRecords = [record]; // Collect all events for all resources which have this event assigned... they might all be affected

            record.resources.forEach(function (resourceRecord) {
              return eventRecords.push.apply(eventRecords, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_66___default()(resourceRecord.events));
            });
            new Set(eventRecords).forEach(function (eventRecord) {
              return me.drawForTimeSpan(eventRecord, true);
            });
          }

          break;

        case 'removeall':
          me.resetGridCache();
          me.scheduleDraw(true);
          break;
      } // adding event has no effect on dependencies, unless it changes row height. in which case it will be handled
      // by onTranslateRow().
      // updating an event might also change row height, handled the same way.
      // removing events will also remove dependencies, thus handled in onDependencyChange

    }
  }, {
    key: "onAssignmentRefresh",
    value: function onAssignmentRefresh(_ref7) {
      var action = _ref7.action;

      // bail out in case we are finalizing the propagation caused by project loading
      // we've already scheduled dependencies draw in the project "refresh" listener
      if (this.client.project.propagatingLoadChanges) {
        return;
      }

      if (action === 'dataset') {
        // Assigning using EventEdit replaces all assignments. Taking the easy way out, throwing cache away
        this.resetGridCache();
        this.scheduleDraw(true);
      }
    }
  }, {
    key: "onAssignmentChange",
    value: function onAssignmentChange(_ref8) {
      var action = _ref8.action,
          record = _ref8.record,
          records = _ref8.records,
          changes = _ref8.changes;
      var me = this; // bail out in case we are finalizing the propagation caused by project loading
      // we've already scheduled dependencies draw in the project "refresh" listener

      if (me.client.project.propagatingLoadChanges) {
        return;
      }

      if (record) {
        records = [record];
      } // Unusual case probably, not worth figuring out which was filtered out


      if (action === 'filter') {
        me.resetGridCache();
        me.scheduleDraw(true);
      }

      if (action === 'add' || action === 'remove' || action === 'update') {
        // Ignore normalization of event & resource
        if (action === 'update' && // Only care about the normalization case, where changes are exactly 2 = event + resource
        Object.keys(changes).length === 2 && // And those changed from not being models
        changes.event && changes.resource && !changes.event.isModel && !changes.resource.isModel) {
          return;
        }

        records.forEach(function (assignment) {
          var _me$client = me.client,
              assignmentStore = _me$client.assignmentStore,
              eventStore = _me$client.eventStore,
              event = eventStore.getById(assignment.eventId); // Event might have been removed with the assignment, if not all its deps might need refreshing

          event && event.dependencies.forEach(function (dependency) {
            // New assignment added by other means than EventEdit
            if (action === 'add') {
              me.toDrawOnProjectRefresh.add(dependency); //me.scheduleRefreshDependency(dependency);
            } // Event unassigned, remove dep line (directly, nothing is redrawn so engine state can be ignored)
            else if (action === 'remove') {
                var assignments; // Removed source?

                if (dependency.fromEvent === event) {
                  // Might point to a multi assigned event, need to remove all lines
                  assignments = dependency.toEvent.assignments.map(function (to) {
                    return {
                      from: assignment,
                      to: to
                    };
                  });
                } // Nope, target
                else {
                    // Might point to a multi assigned event, need to remove all lines
                    assignments = dependency.fromEvent.assignments.map(function (from) {
                      return {
                        from: from,
                        to: assignment
                      };
                    });
                  }

                assignments.forEach(function (assignmentData) {
                  me.releaseDependency(dependency, assignmentData);
                  me.removeFromCache(dependency, assignmentData);
                });
              } // Single assignment updated, redraw lines for it
              else if (action === 'update') {
                  me.getDependencyAssignmentsAsFromToArray({
                    dependency: dependency,
                    assignmentStore: assignmentStore
                  }).filter(function (a) {
                    return a.from === record || a.to === record;
                  }).forEach(function (assignmentData) {
                    me.scheduleRefreshDependency(dependency, assignmentData);
                  });
                }
          });
        });
      }
    } // TODO: this function is called often, use cache to avoid searching in store

  }, {
    key: "getDependencyAssignmentsAsFromToArray",
    value: function getDependencyAssignmentsAsFromToArray(_ref9) {
      var dependency = _ref9.dependency,
          assignmentStore = _ref9.assignmentStore;
      var fromEvent = dependency.fromEvent,
          toEvent = dependency.toEvent,
          assignments = [];

      if (fromEvent && toEvent) {
        var fromAssignments = this.getEventAssignments(fromEvent, assignmentStore),
            toAssignments = this.getEventAssignments(toEvent, assignmentStore);
        fromAssignments.forEach(function (from) {
          toAssignments.forEach(function (to) {
            assignments.push({
              from: from,
              to: to
            });
          });
        });
      }

      return assignments;
    }
  }, {
    key: "getEventAssignments",
    value: function getEventAssignments(event, assignmentStore) {
      if (!event.isRemoved) {
        return event.assignments;
      } // If event is removed assignments might be either removed or planned to be removed
      else {
          var assignments = assignmentStore.removed.values.filter(function (assignment) {
            return assignment.event === event;
          });

          var _iterator = _createForOfIteratorHelper(assignmentStore.assignmentsForRemoval),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var assignment = _step.value;

              if (assignment.event === event) {
                assignments.push(assignment);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return assignments;
        }
    } //endregion

  }, {
    key: "onElementClick",
    value: function onElementClick(event) {
      var me = this;

      if (event.target.matches('.' + me.baseCls)) {
        var dependency = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_82__["default"].get(event.target).dependency,
            eventName = event.type === 'click' ? 'Click' : 'DblClick';
        /**
         * Fires on the owning Scheduler/Gantt when a click is registered on a dependency line.
         * @event dependencyClick
         * @param {Scheduler.view.Scheduler} source The scheduler
         * @param {Scheduler.model.DependencyModel} dependency
         * @param {MouseEvent} event
         */

        /**
         * Fires on the owning Scheduler/Gantt when a click is registered on a dependency line.
         * @event dependencyDblClick
         * @param {Scheduler.view.Scheduler} source The scheduler
         * @param {Scheduler.model.DependencyModel} dependency
         * @param {MouseEvent} event
         */

        me.client.trigger("dependency".concat(eventName), {
          dependency: dependency,
          event: event
        });
      }
    }
  }, {
    key: "onElementDblClick",
    value: function onElementDblClick(event) {
      return this.onElementClick(event);
    }
  }, {
    key: "onElementMouseOver",
    value: function onElementMouseOver(event) {
      var me = this;

      if (event.target.matches('.' + me.baseCls)) {
        var dependency = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_82__["default"].get(event.target).dependency;
        /**
         * Fires on the owning Scheduler/Gantt when the mouse moves over a dependency line.
         * @event dependencyMouseOver
         * @param {Scheduler.view.Scheduler} source The scheduler
         * @param {Scheduler.model.DependencyModel} dependency
         * @param {MouseEvent} event
         */

        me.client.trigger('dependencyMouseOver', {
          dependency: dependency,
          event: event
        });

        if (me.overCls) {
          me.highlight(dependency, me.overCls);
        }
      }
    }
  }, {
    key: "onElementMouseOut",
    value: function onElementMouseOut(event) {
      var me = this;

      if (event.target.matches('.' + me.baseCls)) {
        var dependency = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_82__["default"].get(event.target).dependency;
        /**
         * Fires on the owning Scheduler/Gantt when the mouse moves out of a dependency line.
         * @event dependencyMouseOut
         * @param {Scheduler.view.Scheduler} source The scheduler
         * @param {Scheduler.model.DependencyModel} dependency
         * @param {MouseEvent} event
         */

        me.client.trigger('dependencyMouseOut', {
          dependency: dependency,
          event: event
        });
        if (me.overCls && !dependency.isRemoved) me.unhighlight(dependency);
      }
    } //endregion
    //region Highlight

  }, {
    key: "highlight",
    value: function highlight(dependency) {
      var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.overCls;
      var elements = this.getElementsForDependency(dependency);
      elements.forEach(function (element) {
        element.classList.add(cls);
      });
      dependency.highlight(cls);
    }
  }, {
    key: "unhighlight",
    value: function unhighlight(dependency) {
      var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.overCls;
      var elements = this.getElementsForDependency(dependency);
      elements.forEach(function (element) {
        element.classList.remove(cls);
      });
      dependency.unhighlight(cls);
    }
  }, {
    key: "highlightEventDependencies",
    value: function highlightEventDependencies(timespan) {
      var _this = this;

      timespan.dependencies.forEach(function (dep) {
        return _this.highlight(dep);
      });
    }
  }, {
    key: "unhighlightEventDependencies",
    value: function unhighlightEventDependencies(timespan) {
      var _this2 = this;

      timespan.dependencies.forEach(function (dep) {
        return _this2.unhighlight(dep);
      });
    } //endregion
    //region Determining dependencies to draw
    // Neither resource can be hidden for a dependency to be considered visible

  }, {
    key: "isDependencyVisible",
    value: function isDependencyVisible(dependency) {
      var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var me = this,
          _me$client2 = me.client,
          assignmentStore = _me$client2.assignmentStore,
          resourceStore = _me$client2.resourceStore,
          eventStore = _me$client2.eventStore,
          fromEvent = dependency.fromEvent,
          toEvent = dependency.toEvent; // Bail out early in case source or target doesn't exist

      if (!(fromEvent && toEvent)) {
        return false;
      }

      var fromResource, toResource; // Using multi-assignment, resource obtained from assignment

      if (assignmentData) {
        var from = assignmentData.from,
            to = assignmentData.to;
        fromResource = from.resource;
        toResource = to.resource; // EventStore or AssignmentStore might be filtered, or assignment might opt out of dependency drawing

        if (from.drawDependencies === false || to.drawDependencies === false || eventStore.isFiltered && (!eventStore.includes(fromEvent) || !eventStore.includes(toEvent)) || assignmentStore.isFiltered && (!assignmentStore.includes(from) || !assignmentStore.includes(to))) {
          return false;
        }
      } // Not using assignments, resource obtained from event
      else {
          fromResource = fromEvent.resource;
          toResource = toEvent.resource;
        } // Verify these are real existing Resources and collapsed away (resource not existing in resource store)


      if (!resourceStore.isAvailable(fromResource) || !resourceStore.isAvailable(toResource)) {
        return false;
      }

      return fromEvent.isModel && !fromResource.instanceMeta(resourceStore).hidden && !toResource.instanceMeta(resourceStore).hidden;
    } // Get the bounding box for either the source or the target event

  }, {
    key: "getBox",
    value: function getBox(dependency, source) {
      var assignmentData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var roughly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var eventRecord = this.getTimeSpanRecordFromDependency(dependency, source);
      var resourceRecord; // Multi-assignment, get resource from assignment

      if (assignmentData) {
        resourceRecord = assignmentData[source ? 'from' : 'to'].resource;
      } // Single, get resource from event
      else {
          // resourceRecord = this.dataApi.getEventResource({ event : eventRecord, resourceStore : this.resourceStore });
          resourceRecord = eventRecord.resource;
        }

      return this.client.getResourceEventBox(eventRecord, resourceRecord, true, roughly);
    } // Get source or target events resource

  }, {
    key: "getRowRecordFromDependency",
    value: function getRowRecordFromDependency(dependency, source, assignmentData) {
      var rowRecord; // Multi-assigned, use assignments resource

      if (assignmentData) {
        rowRecord = assignmentData[source ? 'from' : 'to'].resource;
      } // Not multi-assigned, get events resource
      else {
          rowRecord = this.getTimeSpanRecordFromDependency(dependency, source).resource;
        }

      return rowRecord;
    } // Get from or to event

  }, {
    key: "getTimeSpanRecordFromDependency",
    value: function getTimeSpanRecordFromDependency(dependency) {
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return dependency["".concat(from ? 'from' : 'to', "Event")];
    }
  }, {
    key: "getMetaId",
    value: function getMetaId() {
      var assignmentData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return assignmentData ? "".concat(this.client.id, "-ass").concat(assignmentData.from.id, "-ass").concat(assignmentData.to.id) : this.client.id;
    } // Gets the source and target events bounds and unions them to determine the dependency bounds

  }, {
    key: "getDependencyBounds",
    value: function getDependencyBounds(dependency, assignmentData) {
      var roughly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          scheduler = me.client,
          ddr = dependency.getDateRange(); // quick bailout for hidden rows

      if (!scheduler.rowManager.rowCount || !me.isDependencyVisible(dependency, assignmentData)) {
        return null;
      } // quick bailout in case dependency dates and view dates do not intersect


      if (!(ddr && scheduler.timeAxis.count && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_77__["default"].intersectSpans(ddr.start, ddr.end, scheduler.startDate, scheduler.endDate))) {
        return null;
      }

      var metaId = me.getMetaId(assignmentData),
          instanceMeta = dependency.instanceMeta(metaId),
          startRectangle = me.getBox(dependency, true, assignmentData, roughly),
          endRectangle = me.getBox(dependency, false, assignmentData, roughly); // Can't draw dependency if either start or end is in collapsed row

      if (!startRectangle || !endRectangle) {
        return null;
      } // If we are forcing recalculation of dep bounds, or there are no calculated bounds for this dependency
      // or the calculated bounds were based on a "best guess", then recalculate the bounds.


      if (me._resetBoundsCache || !instanceMeta.bounds || !instanceMeta.bounds.layout) {
        var from = me.getTimeSpanRecordFromDependency(dependency, true),
            to = me.getTimeSpanRecordFromDependency(dependency, false),
            bounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_79__["default"].union(startRectangle, endRectangle);

        if (!scheduler.isGantt) {
          [[from, startRectangle, assignmentData.from], [to, endRectangle, assignmentData.to]].map(function (_ref10) {
            var _ref11 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_65___default()(_ref10, 3),
                record = _ref11[0],
                rectangle = _ref11[1],
                assignment = _ref11[2];

            // When using other milestoneLayoutMode than default milestones should be treated as normal events.
            // Milestones are zero width by default, so we must measure the milestone el's height
            // (or icon el width) and use that as the width. We cannot use the event's calculated height because
            // if there are labels, the milestone diamond will be smaller.
            // If the event doesn't have an element, then it's outside of the rendered block and the exact
            // width doesn't matter.
            if (scheduler.milestoneLayoutMode === 'default' && record.isMilestone) {
              if (!scheduler.milestoneWidth) {
                var milestoneElement = scheduler.getElementFromAssignmentRecord(assignment);

                if (milestoneElement) {
                  scheduler.milestoneWidth = milestoneElement.offsetWidth; // The line above used to have this, but that does not allow mixin icons with non-icons.
                  // With the new milestone styling, we seem fine without it anyway
                  //record.iconCls ? milestoneElement.offsetWidth : parseInt(window.getComputedStyle(milestoneElement, ':before').fontSize);
                }
              } // If it could not be measured due to the event being outside of the rendered block
              // we have to use the calculated height.


              var milestoneWidth = scheduler.milestoneWidth || rectangle.height;
              rectangle.left -= milestoneWidth / 2;
              rectangle.right += milestoneWidth / 2;
            }
          });
        }

        instanceMeta.bounds = {
          bounds: bounds,
          startRectangle: startRectangle,
          endRectangle: endRectangle,
          // Cache whether both rectangles are based on the true layout
          // or a best guess approximation to be recalculated
          // next time through.
          layout: startRectangle.layout || endRectangle.layout
        };
      }

      return dependency.instanceMeta(metaId).bounds;
    } // Grid cache is a virtual grid holding info on which dependencies intersects its virtual cells.
    // Used to determine which dependencies should be considered for drawing, iterating over all dependencies each update
    // gets too costly when count increases (>10000).
    //
    // Illustration shows entire schedule area, dddd is a dependency line, vvv is viewport, xxx virtual cell border:
    //
    // ----------------------------------
    // |     vvvvvxvvvvv                |
    // |     v    x    v                |
    // |     v d  x    v                |
    // |     v d  x    v                |
    // |xxxxxvxdxxx    v                |
    // |     vvdvvxvvvvv                |
    // |       d  x                     |
    // |       d  x                     |
    // |       d  x                     |
    // |xxxxxxxdxxxxxxx                 |
    // |       d  x                     |
    // |       d  x                     |
    // |          x                     |
    // |          x                     |
    // |xxxxxxxxxxxxxxx                 |
    // ----------------------------------
    //
    // The dependency crosses three virtual grid cells [0,0], [0,1] and [0,2]. Stored in a map in cache:
    // {
    //    0 : {
    //      0 : [ d, ... ],
    //      1 : [ d, ... ],
    //      2 : [ d, ... ]
    //    }
    // }
    //
    // Viewport crosses four virtual grid cells [0,0], [1,0], [0,1], [1,1]. Those cells are checked in the cached map to
    // find out which rows should be considered for drawing.
    //
    // This approach minimizes the amount of iteration needed

  }, {
    key: "getIteratableDependencyAssignments",
    value: function getIteratableDependencyAssignments(dependency) {
      return this.assignmentStore ? this.getDependencyAssignmentsAsFromToArray({
        dependency: dependency,
        assignmentStore: this.assignmentStore
      }) : [null]; // On purpose, to be iterable
    }
  }, {
    key: "addToGridCache",
    value: function addToGridCache(dependency) {
      var me = this,
          client = me.client,
          store = client.store,
          dependencyGridCache = me.dependencyGridCache,
          cacheGridSize = me.cacheGridSize,
          assignmentDataArray = me.getIteratableDependencyAssignments(dependency),
          axisStartMS = client.startDate.getTime(),
          axisEndMS = client.endDate.getTime(),
          cacheGridSizeTicksMS = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_77__["default"].asMilliseconds(client.timeAxis.unit) * cacheGridSize.ticks;
      assignmentDataArray.forEach(function (assignmentData) {
        var metaId = me.getMetaId(assignmentData),
            meta = dependency.instanceMeta(metaId),
            metaGridCache = meta.gridCache = [],
            // Using index vertically rather than y for reliability with variable row height
        fromIndex = store.indexOf(me.getRowRecordFromDependency(dependency, true, assignmentData)),
            toIndex = store.indexOf(me.getRowRecordFromDependency(dependency, false, assignmentData)),
            // Using dates horizontally rather than x for performance reasons
        dates = dependency.getDateRange(),
            startDateMS = dates === null || dates === void 0 ? void 0 : dates.start.getTime(),
            endDateMS = dates === null || dates === void 0 ? void 0 : dates.end.getTime();

        if (fromIndex !== -1 && toIndex !== -1 && dates && endDateMS > axisStartMS && startDateMS < axisEndMS) {
          var topIndex = Math.min(fromIndex, toIndex),
              bottomIndex = Math.max(fromIndex, toIndex),
              boxTop = Math.floor(topIndex / cacheGridSize.index),
              boxBottom = Math.floor(bottomIndex / cacheGridSize.index),
              boxLeft = Math.floor(Math.max(startDateMS - axisStartMS, 0) / cacheGridSizeTicksMS),
              boxRight = Math.floor(Math.max(endDateMS - axisStartMS, 0) / cacheGridSizeTicksMS),
              key = "".concat(dependency.id, ".-.").concat(metaId);
          var cacheX, cacheY, cacheYMap, x, y; // Store the dependency in the virtual cells which it intersects

          for (x = boxLeft; x <= boxRight; x++) {
            cacheX = dependencyGridCache[x] || (dependencyGridCache[x] = {});

            for (y = boxTop; y <= boxBottom; y++) {
              cacheY = cacheX[y] || (cacheX[y] = []);
              cacheYMap = cacheY.cached || (cacheY.cached = {}); // Only push to the cache if it is not already there

              if (!cacheYMap[key]) {
                cacheYMap[key] = true;
                cacheY.push({
                  dependency: dependency,
                  assignmentData: assignmentData,
                  metaId: metaId
                });
              }

              metaGridCache.push([x, y]);
            }
          }
        }
      });
    }
  }, {
    key: "removeFromCache",
    value: function removeFromCache(dependency) {
      var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var me = this,
          _dependencyGridCache = me._dependencyGridCache;
      var assignments; // Some short-cut case

      if (assignmentData) {
        assignments = [assignmentData];
      } else {
        assignments = this.getIteratableDependencyAssignments(dependency);
      }

      assignments.forEach(function (assignmentData) {
        var _meta$gridCache;

        var metaId = me.getMetaId(assignmentData),
            meta = dependency.instanceMeta(metaId),
            key = "".concat(dependency.id, ".-.").concat(metaId);
        _dependencyGridCache && ((_meta$gridCache = meta.gridCache) === null || _meta$gridCache === void 0 ? void 0 : _meta$gridCache.forEach(function (_ref12) {
          var _dependencyGridCache$;

          var _ref13 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_65___default()(_ref12, 2),
              x = _ref13[0],
              y = _ref13[1];

          if ((_dependencyGridCache$ = _dependencyGridCache[x]) === null || _dependencyGridCache$ === void 0 ? void 0 : _dependencyGridCache$.hasOwnProperty(y)) {
            var entries = me._dependencyGridCache[x][y];

            if (entries === null || entries === void 0 ? void 0 : entries.cached[key]) {
              var index = me.findDependencyIndex(entries, dependency, assignmentData);
              delete entries.cached[key]; // Cannot use ArrayHelper#remove since it cannot compare deeply

              if (index > -1) {
                entries.splice(index, 1);
              }
            }
          }
        }));
        meta.bounds = null;
        meta.gridCache = null;
      });
    }
  }, {
    key: "resetBoundsCache",
    // Reset cached bounds, not grid cache since it is expensive to create. It is so coarse anyway so should be fine
    // with most changes, except for sorting and similar. Reset on demand instead
    value: function resetBoundsCache() {
      // Not actually resetting here, would just be costly to iterate and reset per dependency, instead flagging to
      // force cached value to be updated
      this._resetBoundsCache = true;
    } // In some cases we do need to reset cache, like when time axis is reconfigured

  }, {
    key: "resetGridCache",
    value: function resetGridCache() {
      this.dependencyGridCache = null;
    } //endregion
    //region Draw & render
    //region Lines

    /**
     * Generates `otherBoxes` config for rectangular path finder, which push dependency line to the row boundary.
     * It should be enough to return single box with top/bottom taken from row top/bottom and left/right taken from source
     * box, extended by start arrow margin to both sides.
     * @param {Rectangle} box Box for which other boxes are requried
     * @param {String} side Side of the box where line starts
     * @returns {Array}
     * @private
     */

  }, {
    key: "generateBoundaryBoxes",
    value: function generateBoundaryBoxes(box, side) {
      var boxes = []; // We need two boxes for the bottom edge, because otherwise path cannot be found. Ideally that shouldn't be
      // necessary. Other solution would be to adjust bottom by -1px, but that would make some dependency lines to take
      // 1px different path on a row boundary, which doesn't look nice (but slightly more performant)

      if (side === 'bottom') {
        boxes.push({
          start: box.left,
          end: box.left + box.width / 2,
          top: box.rowTop,
          bottom: box.rowBottom
        }, {
          start: box.left + box.width / 2,
          end: box.right,
          top: box.rowTop,
          bottom: box.rowBottom
        });
      } else {
        boxes.push({
          start: box.left - this.pathFinder.startArrowMargin,
          end: box.right + this.pathFinder.startArrowMargin,
          top: box.rowTop,
          bottom: box.rowBottom
        });
      }

      return boxes;
    }
  }, {
    key: "getDependencyStartSide",
    value: function getDependencyStartSide(dependency) {
      var me = this,
          source = me.getTimeSpanRecordFromDependency(dependency, true),
          type = dependency.type;
      var startSide = dependency.fromSide;

      if (!startSide) {
        switch (true) {
          case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_86__["default"].Type.StartToEnd:
            startSide = me.getConnectorStartSide(source);
            break;

          case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_86__["default"].Type.StartToStart:
            startSide = me.getConnectorStartSide(source);
            break;

          case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_86__["default"].Type.EndToStart:
            startSide = me.getConnectorEndSide(source);
            break;

          case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_86__["default"].Type.EndToEnd:
            startSide = me.getConnectorEndSide(source);
            break;

          default:
            throw new Error('Invalid dependency type: ' + type);
        }
      }

      return startSide;
    }
  }, {
    key: "getDependencyEndSide",
    value: function getDependencyEndSide(dependency) {
      var me = this,
          target = me.getTimeSpanRecordFromDependency(dependency, false),
          type = dependency.type;
      var endSide = dependency.toSide; // Fallback to view trait if dependency end side is not given /*or can be obtained from type*/

      if (!endSide) {
        switch (true) {
          case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_86__["default"].Type.StartToEnd:
            endSide = me.getConnectorEndSide(target);
            break;

          case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_86__["default"].Type.StartToStart:
            endSide = me.getConnectorStartSide(target);
            break;

          case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_86__["default"].Type.EndToStart:
            endSide = me.getConnectorStartSide(target);
            break;

          case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_86__["default"].Type.EndToEnd:
            endSide = me.getConnectorEndSide(target);
            break;

          default:
            throw new Error('Invalid dependency type: ' + type);
        }
      }

      return endSide;
    }
  }, {
    key: "prepareLineDef",
    value: function prepareLineDef(dependency, dependencyDrawData) {
      var assignmentData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var me = this,
          startSide = me.getDependencyStartSide(dependency),
          endSide = me.getDependencyEndSide(dependency),
          startRectangle = dependencyDrawData.startRectangle,
          endRectangle = dependencyDrawData.endRectangle,
          intraRowDependency = startRectangle.rowTop != null && startRectangle.rowTop !== endRectangle.rowTop,
          otherBoxes = []; // Only add otherBoxes if there is a rowTop and those are not equal - which means assignments are is different
      // resources

      if (intraRowDependency) {
        otherBoxes.push.apply(otherBoxes, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_66___default()(me.generateBoundaryBoxes(startRectangle, startSide)));
      }

      var _me$pathFinder = me.pathFinder,
          startArrowMargin = _me$pathFinder.startArrowMargin,
          verticalMargin = _me$pathFinder.verticalMargin; // Do not change start arrow margin in case dependency is bidirectional

      if (!dependency.bidirectional) {
        if (/(top|bottom)/.test(startSide)) {
          startArrowMargin = me.client.barMargin / 2;
        }

        verticalMargin = me.client.barMargin / 2;
      }

      return {
        startBox: {
          start: startRectangle.x,
          end: startRectangle.right,
          top: startRectangle.y,
          bottom: startRectangle.bottom
        },
        endBox: {
          start: endRectangle.x,
          end: endRectangle.right,
          top: endRectangle.y,
          bottom: endRectangle.bottom
        },
        otherBoxes: otherBoxes,
        startArrowMargin: startArrowMargin,
        verticalMargin: verticalMargin,
        otherVerticalMargin: 0,
        otherHorizontalMargin: 0,
        startSide: startSide,
        endSide: endSide
      };
    } // Draws a single SVG line that represents the dependency

  }, {
    key: "drawLine",
    value: function drawLine(canvas, dependency, points) {
      var assignmentData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var cache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var scheduler = this.client,
          metaId = this.getMetaId(assignmentData); // Reuse existing element if possible

      var line = dependency.instanceMeta(metaId).lineElement;

      if (!line || !cache) {
        line = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');

        if (cache) {
          dependency.instanceMeta(metaId).lineElement = line;
        }

        line.setAttribute('depId', dependency.id);

        if (assignmentData) {
          line.setAttribute('fromId', assignmentData.from.id);
          line.setAttribute('toId', assignmentData.to.id);
        }

        canvas.appendChild(line);
      } // TODO: Use DomHelper.syncClassList
      // className is SVGAnimatedString for svg elements, reading attribute instead


      line.classList.length && line.classList.remove.apply(line.classList, line.getAttribute('class').split(' '));
      line.classList.add(this.baseCls);

      if (dependency.cls) {
        line.classList.add(dependency.cls);
      }

      if (dependency.bidirectional) {
        line.classList.add('b-sch-bidirectional-line');
      }

      if (dependency.highlighted) {
        var _line$classList;

        (_line$classList = line.classList).add.apply(_line$classList, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_66___default()(dependency.highlighted.split(' ')));
      }

      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_76__["default"].isIE11) {
        var ddr = dependency.getDateRange(true),
            viewStart = scheduler.startDate;

        if (ddr.start < viewStart) {
          line.classList.add('b-no-start-marker');
        }

        if (ddr.end < viewStart) {
          line.classList.add('b-no-end-marker');
        }
      }

      line.setAttribute('points', !points ? '' : points.map(function (p, i) {
        return i !== points.length - 1 ? "".concat(p.x1, ",").concat(p.y1) : "".concat(p.x1, ",").concat(p.y1, " ").concat(p.x2, ",").concat(p.y2);
      }).join(' '));
      _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_82__["default"].set(line, {
        dependency: dependency
      });
      return line;
    } //endregion

    /**
     * Re-caches and redraws a dependency, for all assignments.
     * @param {Scheduler.model.DependencyModel} dependency Dependency to refresh
     */

  }, {
    key: "refreshDependency",
    value: function refreshDependency(dependency) {
      var me = this,
          assignments = me.getIteratableDependencyAssignments(dependency); // Release dependency element, for all assignments if using AssignmentStore

      me.releaseDependency(dependency, assignments[0] !== null); // Remove it from grid & bounds cache

      me.removeFromCache(dependency); // Re-add it to grid cache

      me.addToGridCache(dependency); // Draw all assignments

      assignments.forEach(function (assignmentData) {
        return me.drawDependency(dependency, null, assignmentData);
      });
    }
    /**
     * Re-caches and redraws a dependency for given assignment.
     * @param {Scheduler.model.DependencyModel} dependency Dependency to refresh
     * @param {Object} assignmentData
     * @param {Scheduler.model.AssignmentModel} assignmentData.from Source assignment
     * @param {Scheduler.model.AssignmentModel} assignmentData.to Target assignment
     * @private
     */

  }, {
    key: "refreshDependencyAssignment",
    value: function refreshDependencyAssignment(dependency, assignmentData) {
      var me = this; // In case it was assigned to something not in view/timeline, release the line

      me.releaseDependency(dependency, assignmentData); // Update cache to only contain whats left of it

      me.removeFromCache(dependency, assignmentData);
      me.addToGridCache(dependency); // Draw lines

      me.drawDependency(dependency, null, assignmentData);
    }
    /**
     * Stores all dependencies/assignments that were requested to refresh and schedules repaint on next animation frame
     * @param {Scheduler.model.DependencyModel} dependency Dependency model to refresh
     * @param {Object} [assignmentData] Assignment data
     * @param {Scheduler.model.AssignmentModel} [assignmentData.from] Source assignment
     * @param {Scheduler.model.AssignmentModel} [assignmentData.to] Target assignment
     * @private
     */

  }, {
    key: "scheduleRefreshDependency",
    value: function scheduleRefreshDependency(dependency) {
      var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var me = this,
          map = me.dependenciesToRefresh; // Ignore undrawn dependencies, they cannot be refreshed

      if (!me.drawnDependencies.find(function (d) {
        return d.dependency === dependency;
      })) {
        // Nevertheless update the cache, we might land here from method which updates dependency for modified event
        me.removeFromCache(dependency);
        me.addToGridCache(dependency);
        return;
      } // If this method was called once without assignment data - all lines related should be repainted


      if (!assignmentData) {
        map.set(dependency, true);
      } else if (map.has(dependency)) {
        if (map.get(dependency) !== true) {
          map.get(dependency).add(assignmentData);
        }
      } else {
        map.set(dependency, new Set([assignmentData]));
      }

      if (map.size === 1) {
        me.requestAnimationFrame(function () {
          return me.refreshDependencyOnFrame();
        });
      }
    }
    /**
     * Implement on subclass when a certain sort order is needed
     * @returns {Map} Dependencies
     * @private
     */

  }, {
    key: "getSortedDependenciesToRefresh",
    value: function getSortedDependenciesToRefresh() {
      return this.dependenciesToRefresh;
    }
    /**
     * Repaints scheduled dependencies/assignments
     * @private
     */

  }, {
    key: "refreshDependencyOnFrame",
    value: function refreshDependencyOnFrame() {
      var me = this,
          map = me.getSortedDependenciesToRefresh();

      if (me.client.isPainted) {
        // First clear cache and release dependencies. This will modify DOM
        map.forEach(function (assignments, dependency) {
          if (assignments === true) {
            var _assignments = me.getIteratableDependencyAssignments(dependency); // Release dependency element, for all assignments if using AssignmentStore


            me.releaseDependency(dependency, _assignments[0] !== null); // Remove it from grid & bounds cache

            me.removeFromCache(dependency);
          } else {
            assignments.forEach(function (assignment) {
              // In case it was assigned to something not in view/timeline, release the line
              me.releaseDependency(dependency, assignment); // Update cache to only contain whats left of it

              me.removeFromCache(dependency, assignment);
            });
          }
        }); // Then fill cache before drawing dependencies. This will read the DOM forcing reflow

        map.forEach(function (assignments, dependency) {
          // Re-add it to grid cache
          me.addToGridCache(dependency);
        }); // Finally append elements to the DOM

        map.forEach(function (assignments, dependency) {
          if (assignments === true) {
            assignments = me.getIteratableDependencyAssignments(dependency);
          }

          assignments.forEach(function (assignmentData) {
            me.drawDependency(dependency, null, assignmentData);
          });
        }); // Cannot clear `map`, since it is a sorted copy of the actual map.

        me.dependenciesToRefresh.clear();
        me.client.trigger('dependenciesDrawn', {
          partial: true
        });
      }
    }
    /**
     * Draws a single dependency (for a single assignment if using multiple), if in view.
     * @param {Scheduler.model.DependencyModel} dependency Dependency to draw
     */

  }, {
    key: "drawDependency",
    value: function drawDependency(dependency) {
      var drawData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var assignmentData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.client.svgCanvas;
      var cache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var me = this,
          drawnDependencies = me.drawnDependencies,
          oldDrawnDependencies = me.oldDrawnDependencies,
          dependencyDrawData = drawData || me.getDependencyBounds(dependency, assignmentData);

      if (!me.disabled && dependencyDrawData) {
        // Build line defs
        var lineDef = me.prepareLineDef(dependency, dependencyDrawData),
            lines = me.pathFinder.findPath(lineDef, me.lineDefAdjusters);
        me.drawLine(canvas, dependency, lines, assignmentData, cache); // Do not push dependency to drawn deps if this is a temporary render
        // Cannot use ArrayHelper#include since object wont be the same, only its contents

        if (cache && !this.includesDependency(drawnDependencies, dependency, assignmentData)) {
          drawnDependencies.push({
            dependency: dependency,
            assignmentData: assignmentData
          });
        }
      } // Remove from oldDrawnDeps, to not have element removed. Cannot use ArrayHelper#remove as stated above


      var oldIndex = this.findDependencyIndex(oldDrawnDependencies, dependency, assignmentData);

      if (oldIndex >= 0) {
        oldDrawnDependencies.splice(oldIndex, 1);
      }
    }
    /**
     * Draws multiple dependencies, called from drawForEvent() or drawFromTask().
     * @private
     */

  }, {
    key: "drawForTimeSpan",
    value: function drawForTimeSpan(timeSpanRecord) {
      var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this; // If the client is doing an animated update, we must update at end.
      // That will be asynchronous relative to now, so do not pass on the async flag.

      if (me.client.isAnimating) {
        me.client.on({
          transitionend: function transitionend() {
            // Because of asyncness record might be removed during the transition
            !timeSpanRecord.isRemoved && me.drawForTimeSpan(timeSpanRecord, true);
          },
          once: true
        });
      } // Otherwise, schedule the draw for the next frame.
      else {
          me.dependencyStore.getTimeSpanDependencies(timeSpanRecord).forEach(function (dependency) {
            if (async) {
              me.scheduleRefreshDependency(dependency);
            } else {
              me.refreshDependency(dependency);
            }
          });
        }
    }
    /**
     * Draws all dependencies for the specified event.
     */

  }, {
    key: "drawForEvent",
    value: function drawForEvent(eventRecord) {
      this.drawForTimeSpan(eventRecord);
    } // Redraw all dependencies for a particular eventRecord, using its current element instead of calculating a box
    // Used to do live redraw while resizing or dragging events

  }, {
    key: "updateDependenciesForTimeSpan",
    value: function updateDependenciesForTimeSpan(timeSpanRecord, element) {
      var _this3 = this;

      var newResource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var me = this,
          eventRecord = timeSpanRecord.isAssignment ? timeSpanRecord.event : timeSpanRecord,
          deps = me.dependencyStore.getTimeSpanDependencies(eventRecord),
          metaId = me.getMetaId(),
          scheduler = me.client,
          originalTaskRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_79__["default"].from(element, scheduler.timeAxisSubGridElement),
          row = newResource && scheduler.getRowFor(newResource);
      var bounds;
      deps.forEach(function (dep) {
        var assignments = _this3.getIteratableDependencyAssignments(dep);

        assignments.forEach(function (assignmentData) {
          var taskRect = originalTaskRect.clone();
          var startRectangle, endRectangle;

          if (row) {
            taskRect.rowTop = row.top;
            taskRect.rowBottom = row.bottom;
          } // If dragging one multi assigned event the others wont move until it is dropped. Prevent their dep
          // lines from updating by bailing out


          if (assignmentData && assignmentData.from !== timeSpanRecord && assignmentData.to !== timeSpanRecord) {
            return;
          } // Bail out if dependency is not visible (other end might be collapsed)


          if (!me.isDependencyVisible(dep, assignmentData)) {
            return;
          }

          if (me.getTimeSpanRecordFromDependency(dep, true) === eventRecord) {
            startRectangle = taskRect; // try to look into dependency cache first

            if (bounds = dep.instanceMeta(metaId).bounds) {
              endRectangle = bounds.endRectangle;
            } else {
              endRectangle = me.getBox(dep, false, assignmentData);
            }
          } else {
            // try to look into dependency cache first
            if (bounds = dep.instanceMeta(metaId).bounds) {
              startRectangle = bounds.startRectangle;
            } else {
              startRectangle = me.getBox(dep, true, assignmentData);
            }

            endRectangle = taskRect;
          }

          if (startRectangle && endRectangle) {
            me.drawDependency(dep, {
              startRectangle: startRectangle,
              endRectangle: endRectangle
            }, assignmentData);
          }
        });
      });
    }
  }, {
    key: "scheduleDraw",
    value: function scheduleDraw() {
      var relayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this;

      if (me.disabled) {
        return;
      } // There may be number of concurrent calls to this method, we need to reset cache if at least
      // once it was called with relayout = true


      if (relayout) {
        me.resetBoundsCache();
      } // If the scheduler/gantt is doing an animated update, schedule the draw
      // for when that's done so that we get correct element boxes.


      if (me.client.isAnimating) {
        if (!me.clientTransitionRemover) {
          me.clientTransitionRemover = me.client.on({
            transitionend: function transitionend() {
              me.clientTransitionRemover();
              me.clientTransitionRemover = null;
              me.draw();
            },
            once: true
          });
        }
      } // Otherwise, schedule the draw for the next frame.
      else {
          me.doScheduleDraw();
        }
    }
    /**
     * Draws all dependencies that overlap the current viewport
     */

  }, {
    key: "draw",
    value: function draw() {
      var reLayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var me = this,
          scheduler = me.client; // Early bailout if we get here before we have any deps or rows rendered

      if (!me.oldDrawnDependencies && !me.dependencyStore.count || !scheduler.isPainted) {
        return;
      } // if animation is in progress, schedule drawing and skip current one


      if (scheduler.isAnimating) {
        scheduler.on({
          transitionend: function transitionend() {
            me.scheduleDraw(true);
          },
          once: true
        });
        return;
      } // viewBox is the bounds of the current viewport, used to determine which dependencies to draw


      var viewBox = scheduler.timeAxisSubGrid.viewRectangle;

      if (reLayout) {
        me.resetBoundsCache();
      } // If there is no visible area for dependencies to display, we should stop redrawing and keep info about current dependencies.
      // Next time when visible area appears all dependencies will be redrawn.


      if (!viewBox.width || !viewBox.height) {
        return;
      }

      me.oldDrawnDependencies = me.drawnDependencies;
      me.drawnDependencies = []; // expand viewBox with buffer size

      viewBox.inflate(me.bufferSize); // Do not draw if no rows

      if (!me.disabled && !scheduler.suspendRendering && scheduler.store.count && scheduler.rowManager.rowCount) {
        // dependencies might start rendering before the 1st propagation which ends up having an empty dependencies cache
        // and thus never rendered dependencies
        if (!scheduler.project.isInitialCommitPerformed) {
          // Restore drawn dependencies, otherwise the unused ones will not be released next time we draw
          me.drawnDependencies = me.oldDrawnDependencies;
          me.refreshAllWhenReady = true;
          return;
        }

        var consideredDependencies = {},
            dependencyGridCache = me.dependencyGridCache,
            cacheGridSize = me.cacheGridSize,
            startDate = scheduler.startDate,
            visibleDateRange = scheduler.visibleDateRange,
            cacheGridSizeTicksMS = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_77__["default"].asMilliseconds(scheduler.timeAxis.unit) * cacheGridSize.ticks,
            visibleStartMS = visibleDateRange.startDate.getTime() - startDate.getTime(),
            visibleEndMS = visibleDateRange.endDate.getTime() - startDate.getTime(),
            viewLeft = Math.floor(visibleStartMS / cacheGridSizeTicksMS),
            viewRight = Math.floor(visibleEndMS / cacheGridSizeTicksMS),
            topIndex = Math.floor(scheduler.rowManager.topRow.dataIndex / cacheGridSize.index),
            bottomIndex = Math.floor(scheduler.rowManager.bottomRow.dataIndex / cacheGridSize.index),
            dependenciesToDraw = [];
        var x, rowIndex, i; // Iterate over virtual dependency grid cells, pushing each dependency that intersects that cell

        for (x = viewLeft; x <= viewRight; x++) {
          for (rowIndex = topIndex; rowIndex <= bottomIndex; rowIndex++) {
            var cacheX = dependencyGridCache[x],
                deps = cacheX === null || cacheX === void 0 ? void 0 : cacheX[rowIndex];

            for (i = 0; deps && i < deps.length; i++) {
              var _deps$i = deps[i],
                  dependency = _deps$i.dependency,
                  assignmentData = _deps$i.assignmentData,
                  metaId = _deps$i.metaId,
                  flagId = dependency.id + '-' + metaId;

              if (!consideredDependencies[flagId]) {
                // Only draw those actually in view
                var bounds = me.getDependencyBounds(dependency, assignmentData); // TODO: get rid of this export-specific flag

                if ((bounds === null || bounds === void 0 ? void 0 : bounds.bounds.intersect(viewBox, true, true)) || scheduler.ignoreViewBox) {
                  dependenciesToDraw.push([dependency, bounds, assignmentData]);
                }

                consideredDependencies[flagId] = true;
              }
            }
          }
        } // Append dependencies to the DOM only after all have been calculated


        dependenciesToDraw.forEach(function (_ref14) {
          var _ref15 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_65___default()(_ref14, 3),
              dependency = _ref15[0],
              bounds = _ref15[1],
              assignmentData = _ref15[2];

          me.drawDependency(dependency, bounds, assignmentData);
        });
      } // Stop forcing recalculation of bounds


      me._resetBoundsCache = false; // Release elements for any dependencies that wasn't drawn

      me.oldDrawnDependencies.forEach(function (data) {
        return me.releaseDependency(data.dependency, data.assignmentData);
      });
      scheduler.trigger('dependenciesDrawn');
      me.isDrawn = true;
    }
    /**
     * Release a dependency that is determined to be no longer visible
     * @param {Scheduler.model.DependencyModel} dependency
     */

  }, {
    key: "releaseDependency",
    value: function releaseDependency(dependency) {
      var _this4 = this;

      var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // Remove for all assignments (related to this client, store might be shared)
      if (assignmentData === true) {
        var clientDataKeys = Object.keys(dependency.meta.map || {}).filter(function (key) {
          return key.startsWith(_this4.client.id);
        });
        clientDataKeys.forEach(function (key) {
          var data = dependency.meta.map[key];

          if (data.lineElement) {
            data.lineElement.remove();
            data.lineElement = null;
          }
        });
      } // Remove specific
      else {
          var metaId = this.getMetaId(assignmentData),
              lineElement = dependency.instanceMeta(metaId).lineElement;

          if (lineElement) {
            dependency.instanceMeta(metaId).lineElement = null; // Not reusing elements for other lines currently

            lineElement.remove();
          }
        }
    }
  }, {
    key: "render",
    value: function render() {
      var me = this,
          scheduler = me.client;

      if (me.showTooltip) {
        me.tooltip = me.createTooltip();
      }

      scheduler.timeAxis.on({
        endreconfigure: 'resetGridCache',
        thisObj: me
      });
      scheduler.rowManager.on({
        refresh: 'onRowsRefresh',
        // redraws dependencies after zoom
        changetotalheight: 'onChangeTotalHeight',
        // redrawn dependencies after group collapse
        thisObj: me
      }); // dependencies are drawn on scroll, both horizontal and vertical

      scheduler.on({
        horizontalscroll: 'onHorizontalScroll',
        svgcanvascreated: 'createMarkers',
        togglenode: 'onToggleNode',
        scroll: 'onVerticalScroll',
        timelineviewportresize: 'onViewportResize',
        thisObj: me
      });

      if (me.highlightDependenciesOnEventHover) {
        scheduler.on(scheduler.scheduledEventName + 'MouseEnter', function (params) {
          return me.highlightEventDependencies(params.eventRecord || params.taskRecord);
        });
        scheduler.on(scheduler.scheduledEventName + 'MouseLeave', function (params) {
          return me.unhighlightEventDependencies(params.eventRecord || params.taskRecord);
        });
      }
    }
  }, {
    key: "renderContents",
    value: function renderContents() {
      this.draw();
    } //endregion
    //region Connector sides

    /**
     * Gets displaying item start side
     *
     * @param {Scheduler.model.TimeSpan} timeSpanRecord
     * @return {String} 'left' / 'right' / 'top' / 'bottom'
     */

  }, {
    key: "getConnectorStartSide",
    value: function getConnectorStartSide(timeSpanRecord) {
      return this.client.currentOrientation.getConnectorStartSide(timeSpanRecord);
    }
    /**
     * Gets displaying item end side
     *
     * @param {Scheduler.model.TimeSpan} timeSpanRecord
     * @return {String} 'left' / 'right' / 'top' / 'bottom'
     */

  }, {
    key: "getConnectorEndSide",
    value: function getConnectorEndSide(timeSpanRecord) {
      return this.client.currentOrientation.getConnectorEndSide(timeSpanRecord);
    } //endregion
    //region Tooltip

  }, {
    key: "createTooltip",
    value: function createTooltip() {
      var me = this,
          scheduler = me.client;
      return new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_83__["default"](Object.assign({
        align: 'b-t',
        id: "".concat(scheduler.id, "-dependency-tip"),
        //TODO: need some way better to specify this. maybe each feature should be queried?
        forSelector: ".b-timelinebase:not(.b-eventeditor-editing):not(.b-resizing-event):not(.b-dragcreating):not(.b-dragging-event):not(.b-creating-dependency) .".concat(me.baseCls),
        clippedBy: [scheduler.timeAxisSubGridElement, scheduler.bodyContainer],
        forElement: scheduler.timeAxisSubGridElement,
        showOnHover: true,
        hoverDelay: 0,
        hideDelay: 0,
        anchorToTarget: false,
        textContent: false,
        // Skip max-width setting
        trackMouse: false,
        getHtml: me.getHoverTipHtml.bind(me)
      }, me.tooltip || {}));
    }
    /**
     * Generates html for the tooltip shown when hovering a dependency
     * @param {Object} tooltipConfig
     * @returns {string} Html to display in the tooltip
     * @private
     */

  }, {
    key: "getHoverTipHtml",
    value: function getHoverTipHtml(_ref16) {
      var activeTarget = _ref16.activeTarget;
      var me = this,
          dependency = me.resolveDependencyRecord(activeTarget),
          fromEvent = dependency.fromEvent,
          toEvent = dependency.toEvent;
      return _Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_80__["default"].tpl(_templateObject(), me.L('L{from}'), fromEvent.name, fromBoxSide[dependency.type], me.L('L{to}'), toEvent.name, toBoxSide[dependency.type]);
    } //endregion

  }, {
    key: "dependencyGridCache",
    get: function get() {
      var me = this;

      if (!me._dependencyGridCache) {
        me._dependencyGridCache = {};
        me.dependencyStore.forEach(function (dependency) {
          return me.addToGridCache(dependency);
        });
      }

      return me._dependencyGridCache;
    },
    set: function set(cache) {
      this._dependencyGridCache = cache;
    }
  }], [{
    key: "getLocalizedDependencyType",
    value: function getLocalizedDependencyType(type) {
      // Do not remove. Assertion strings for Localization sanity check.
      // 'L{DependencyType.SS}'
      // 'L{DependencyType.SF}'
      // 'L{DependencyType.FS}'
      // 'L{DependencyType.FF}'
      // 'L{DependencyType.StartToStart}'
      // 'L{DependencyType.StartToEnd}'
      // 'L{DependencyType.EndToStart}'
      // 'L{DependencyType.EndToEnd}'
      // 'L{DependencyType.long}'
      // 'L{DependencyType.short}'
      return type ? this.L("L{DependencyType.".concat(type, "}")) : '';
    }
  }, {
    key: "$name",

    /**
     * Fired when dependencies are rendered
     * @event dependenciesDrawn
     * @param {Boolean} [partial] Optional event parameter. `true` when subset of dependencies is repainted, omitted
     * when all lines were repainted.
     */
    //region Config
    get: function get() {
      return 'Dependencies';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Path finder instance configuration
         * @config {Object}
         */
        pathFinderConfig: null,

        /**
         * The CSS class to add to a dependency line when hovering over it
         * @config {String}
         * @default
         * @private
         */
        overCls: 'b-sch-dependency-over',

        /**
         * The CSS class applied to dependency lines
         * @config {String}
         * @default
         * @private
         */
        baseCls: 'b-sch-dependency',
        highlightDependenciesOnEventHover: false,

        /**
         * Set to true to show a tooltip when hovering a dependency line
         * @config {Boolean}
         */
        showTooltip: true,

        /**
         * A tooltip config object that will be applied to the dependency hover tooltip. Can be used to for example
         * customize delay
         * @config {Object}
         */
        tooltip: null,
        bufferSize: 50,
        // Used to determine the size of the cells in the virtual grid used to cache intersecting dependencies
        cacheGridSize: {
          // the width of an intersection cell expressed in timeaxis ticks
          ticks: 25,
          // the height of an intersection cell express in amount of rows
          // (could be named rows, but that wont match if we add support for vertical mode)
          index: 25
        }
      };
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        toDrawOnProjectRefresh: new Set(),
        dependenciesToRefresh: new Map(),
        drawnDependencies: [],
        drawnLines: []
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['render', 'renderContents', 'onElementClick', 'onElementDblClick', 'onElementMouseOver', 'onElementMouseOut', 'onProjectRefresh'],
        assign: ['getElementForDependency', 'getElementsForDependency', 'resolveDependencyRecord']
      };
    }
  }]);

  return Dependencies;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_81__["default"].mixin(_mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_85__["default"], _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_89__["default"], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_88__["default"]));


Dependencies._$name = 'Dependencies';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_84__["default"].registerFeature(Dependencies, false, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_84__["default"].registerFeature(Dependencies, true, 'SchedulerPro'); // region polyfills
// from https://github.com/eligrey/classList.js

if (document.createElementNS && !('classList' in document.createElementNS('http://www.w3.org/2000/svg', 'g'))) {
  (function (view) {
    if (!('Element' in view)) return;

    var classListProp = 'classList',
        protoProp = 'prototype',
        elemCtrProto = view.Element[protoProp],
        objCtr = Object,
        strTrim = String[protoProp].trim || function () {
      return this.replace(/^\s+|\s+$/g, '');
    },
        arrIndexOf = Array[protoProp].indexOf || function (item) {
      for (var i = 0, len = this.length; i < len; i++) {
        if (i in this && this[i] === item) {
          return i;
        }
      }

      return -1;
    },
        // Vendors: please allow content code to instantiate DOMExceptions
    DOMEx = function DOMEx(type, message) {
      this.name = type;
      this.code = DOMException[type]; // eslint-disable-line no-undef

      this.message = message;
    },
        checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
      if (token === '') {
        throw new DOMEx('SYNTAX_ERR', 'The token must not be empty.');
      }

      if (/\s/.test(token)) {
        throw new DOMEx('INVALID_CHARACTER_ERR', 'The token must not contain space characters.');
      }

      return arrIndexOf.call(classList, token);
    },
        ClassList = function ClassList(elem) {
      var trimmedClasses = strTrim.call(elem.getAttribute('class') || ''),
          classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [];

      for (var i = 0, len = classes.length; i < len; i++) {
        this.push(classes[i]);
      }

      this._updateClassName = function () {
        elem.setAttribute('class', this.toString());
      };
    },
        classListProto = ClassList[protoProp] = [],
        classListGetter = function classListGetter() {
      return new ClassList(this);
    }; // Most DOMException implementations don't allow calling DOMException's toString()
    // on non-DOMExceptions. Error's toString() is sufficient here.


    DOMEx[protoProp] = Error[protoProp];

    classListProto.item = function (i) {
      return this[i] || null;
    };

    classListProto.contains = function (token) {
      return ~checkTokenAndGetIndex(this, token + '');
    };

    classListProto.add = function () {
      var tokens = arguments,
          i = 0,
          l = tokens.length,
          token,
          updated = false;

      do {
        token = tokens[i] + '';

        if (!~checkTokenAndGetIndex(this, token)) {
          this.push(token);
          updated = true;
        }
      } while (++i < l);

      if (updated) {
        this._updateClassName();
      }
    };

    classListProto.remove = function () {
      var tokens = arguments,
          i = 0,
          l = tokens.length,
          token,
          updated = false,
          index;

      do {
        token = tokens[i] + '';
        index = checkTokenAndGetIndex(this, token);

        while (~index) {
          this.splice(index, 1);
          updated = true;
          index = checkTokenAndGetIndex(this, token);
        }
      } while (++i < l);

      if (updated) {
        this._updateClassName();
      }
    };

    classListProto.toggle = function (token, force) {
      var result = this.contains(token),
          method = result ? force !== true && 'remove' : force !== false && 'add';

      if (method) {
        this[method](token);
      }

      if (force === true || force === false) {
        return force;
      } else {
        return !result;
      }
    };

    classListProto.replace = function (token, replacementToken) {
      var index = checkTokenAndGetIndex(token + '');

      if (~index) {
        this.splice(index, 1, replacementToken);

        this._updateClassName();
      }
    };

    classListProto.toString = function () {
      return this.join(' ');
    };

    if (objCtr.defineProperty) {
      var classListPropDesc = {
        get: classListGetter,
        enumerable: true,
        configurable: true
      };

      try {
        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
      } catch (ex) {
        // IE 8 doesn't support enumerable:true
        // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
        // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
        if (ex.number === undefined || ex.number === -0x7FF5EC54) {
          classListPropDesc.enumerable = false;
          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
        }
      }
    } else if (objCtr[protoProp].__defineGetter__) {
      elemCtrProto.__defineGetter__(classListProp, classListGetter);
    }
  })(window);
} // There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.


(function () {
  var testElement = document.createElement('_');
  testElement.classList.add('c1', 'c2'); // Polyfill for IE 10/11 and Firefox <26, where classList.add and
  // classList.remove exist but support only one argument at a time.

  if (!testElement.classList.contains('c2')) {
    var createMethod = function createMethod(method) {
      var original = DOMTokenList.prototype[method]; // eslint-disable-line no-undef

      DOMTokenList.prototype[method] = function (token) {
        // eslint-disable-line no-undef
        for (var i = 0, len = arguments.length; i < len; i++) {
          token = arguments[i];
          original.call(this, token);
        }
      };
    };

    createMethod('add');
    createMethod('remove');
  }

  testElement.classList.toggle('c3', false); // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
  // support the second argument.

  if (testElement.classList.contains('c3')) {
    var _toggle = DOMTokenList.prototype.toggle; // eslint-disable-line no-undef

    DOMTokenList.prototype.toggle = function (token, force) {
      // eslint-disable-line no-undef
      if (1 in arguments && !this.contains(token) === !force) {
        return force;
      } else {
        return _toggle.call(this, token);
      }
    };
  } // replace() polyfill


  if (!('replace' in document.createElement('_').classList)) {
    DOMTokenList.prototype.replace = function (token, replacementToken) {
      // eslint-disable-line no-undef
      var tokens = this.toString().split(' '),
          index = tokens.indexOf(token + '');

      if (~index) {
        tokens = tokens.slice(index);
        this.remove.apply(this, tokens);
        this.add(replacementToken);
        this.add.apply(this, tokens.slice(1));
      }
    };
  }

  testElement = null;
})(); // endregion

/***/ }),

/***/ "./lib/Scheduler/feature/DependencyEdit.js":
/*!*************************************************!*\
  !*** ./lib/Scheduler/feature/DependencyEdit.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyEdit; });
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Core/widget/DisplayField.js */ "./lib/Core/widget/DisplayField.js");
/* harmony import */ var _Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/widget/DurationField.js */ "./lib/Core/widget/DurationField.js");
/* harmony import */ var _view_DependencyEditor_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../view/DependencyEditor.js */ "./lib/Scheduler/view/DependencyEditor.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");





















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/* eslint-disable no-unused-expressions */









/**
 * @module Scheduler/feature/DependencyEdit
 */

/**
 * Feature that displays a popup containing fields for editing a dependency. Requires the {@link Scheduler.feature.Dependencies Dependencies} feature to be enabled.
 *
 * This feature is **disabled** by default. It does **not** support vertical mode.
 *
 * @extends Core/mixin/InstancePlugin
 * @externalexample scheduler/Dependencies.js
 * @demo Scheduler/dependencies
 * @classtype dependencyEdit
 */

var DependencyEdit = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default()(DependencyEdit, _InstancePlugin);

  var _super = _createSuper(DependencyEdit);

  function DependencyEdit() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, DependencyEdit);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(DependencyEdit, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(client, config) {
      var _client$on;

      var me = this;
      client.dependencyEdit = me;
      me.dependencyStore = client.dependencyStore;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(DependencyEdit.prototype), "construct", this).call(this, client, config);

      if (!client.features.dependencies) {
        throw new Error('Dependencies feature required when using DependencyEdit');
      }

      me.clientListenersDetacher = client.on((_client$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_client$on, me.triggerEvent, me.onActivateEditor), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_client$on, "thisObj", me), _client$on));
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$editor;

      this.clientListenersDetacher();
      (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(DependencyEdit.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Editing

  }, {
    key: "onBeforeSave",

    /**
         * Template method, intended to be overridden. Called before the dependency record has been updated.
         * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency record
         *
         **/
    value: function onBeforeSave(dependencyRecord) {}
    /**
         * Template method, intended to be overridden. Called after the dependency record has been updated.
         * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency record
         *
         **/

  }, {
    key: "onAfterSave",
    value: function onAfterSave(dependencyRecord) {}
    /**
         * Updates record being edited with values from the editor
         * @private
         */

  }, {
    key: "updateRecord",
    value: function updateRecord(dependencyRecord) {
      var values = this.values; // Engine does not understand { magnitude, unit } syntax

      if (values.lag) {
        values.lagUnit = values.lag.unit;
        values.lag = values.lag.magnitude;
      } // Type replaces fromSide/toSide, if they are used


      if ('type' in values) {
        dependencyRecord.fromSide != null && (values.fromSide = null);
        dependencyRecord.toSide != null && (values.toSide = null);
      } // Chronograph doesn't filter out undefined fields, it nullifies them instead
      // https://github.com/bryntum/chronograph/issues/11


      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].cleanupProperties(values, true);
      dependencyRecord.set(values);
    } //endregion
    //region Events

  }, {
    key: "onPopupKeyDown",
    value: function onPopupKeyDown(_ref) {
      var event = _ref.event;

      if (event.key === 'Enter' && this.saveAndCloseOnEnter && event.target.tagName.toLowerCase() === 'input') {
        // Need to prevent this key events from being fired on whatever receives focus after the editor is hidden
        event.preventDefault();
        this.onSaveClick();
      }
    }
  }, {
    key: "onSaveClick",
    value: function onSaveClick() {
      if (this.save()) {
        this.editor.hide();
      }
    }
  }, {
    key: "onDeleteClick",
    value: function onDeleteClick() {
      this.deleteDependency();
      this.editor.hide();
    }
  }, {
    key: "onCancelClick",
    value: function onCancelClick() {
      this.editor.hide();
    } //region Editing
    // Called from editDependency() to actually show the editor

  }, {
    key: "internalShowEditor",
    value: function internalShowEditor(dependencyRecord) {
      var me = this,
          scheduler = me.client;
      var showPoint = me.lastPointerDownCoordinate;
      /**
       * Fires on the owning Scheduler before an dependency is displayed in the editor.
       * This may be listened for to allow an application to take over dependency editing duties. Returning `false`
       * stops the default editing UI from being shown.
       * @event beforeDependencyEdit
       * @param {Scheduler.view.Scheduler} source The scheduler
       * @param {Scheduler.feature.DependencyEdit} dependencyEdit The dependencyEdit feature
       * @param {Scheduler.model.DependencyModel} dependencyRecord The record about to be shown in the editor.
       * @preventable
       */

      if (scheduler.trigger('beforeDependencyEdit', {
        dependencyEdit: me,
        dependencyRecord: dependencyRecord
      }) === false) {
        return;
      }

      var editor = me.getEditor(dependencyRecord);
      me.loadRecord(dependencyRecord);
      /**
       * Fires on the owning Scheduler when the editor for a dependency is available but before it is shown. Allows
       * manipulating fields before the widget is shown.
       * @event beforeDependencyEditShow
       * @param {Scheduler.view.Scheduler} source The scheduler
       * @param {Scheduler.feature.DependencyEdit} dependencyEdit The dependencyEdit feature
       * @param {Scheduler.model.DependencyModel} dependencyRecord The record about to be shown in the editor.
       * @param {Core.widget.Popup} editor The editor popup
       */

      scheduler.trigger('beforeDependencyEditShow', {
        dependencyEdit: me,
        dependencyRecord: dependencyRecord,
        editor: editor
      });

      if (!showPoint) {
        var center = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_22__["default"].from(me.client.element).center;
        showPoint = [center.x - editor.width / 2, center.y - editor.height / 2];
      }

      editor.showByPoint(showPoint);
    }
    /**
     * Opens a popup to edit the passed dependency.
     * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency to edit
     */

  }, {
    key: "editDependency",
    value: function editDependency(dependencyRecord) {
      if (this.client.readOnly) return;
      this.internalShowEditor(dependencyRecord);
    } //endregion
    //region Save

    /**
     * Gets an editor instance. Creates on first call, reuses on consecutive
     * @internal
     * @returns {Scheduler.view.DependencyEditor} Editor popup
     */

  }, {
    key: "getEditor",
    value: function getEditor() {
      var _me$saveButton, _me$deleteButton, _me$cancelButton;

      var me = this;
      var editor = me.editor;

      if (editor) {
        return editor;
      }

      editor = me.editor = new _view_DependencyEditor_js__WEBPACK_IMPORTED_MODULE_25__["default"](_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].assign({
        dependencyEditFeature: me,
        autoShow: false,
        anchor: true,
        scrollAction: 'realign',
        clippedBy: [me.client.timeAxisSubGridElement, me.client.bodyContainer],
        constrainTo: window,
        autoClose: me.autoClose,
        cls: me.cls,
        listeners: {
          keydown: me.onPopupKeyDown,
          thisObj: me
        }
      }, me.editorConfig));

      if (editor.items.length === 0) {
        console.warn('Editor configured without any `items`');
      } // assign widget refs


      editor.eachWidget(function (widget) {
        var ref = widget.ref || widget.id; // don't overwrite if already defined

        if (ref && !me[ref]) {
          me[ref] = widget;
        }
      });
      (_me$saveButton = me.saveButton) === null || _me$saveButton === void 0 ? void 0 : _me$saveButton.on('click', me.onSaveClick, me);
      (_me$deleteButton = me.deleteButton) === null || _me$deleteButton === void 0 ? void 0 : _me$deleteButton.on('click', me.onDeleteClick, me);
      (_me$cancelButton = me.cancelButton) === null || _me$cancelButton === void 0 ? void 0 : _me$cancelButton.on('click', me.onCancelClick, me);
      return me.editor;
    } //endregion
    //region Delete

    /**
     * Sets fields values from record being edited
     * @private
     */

  }, {
    key: "loadRecord",
    value: function loadRecord(dependency) {
      var me = this;
      me.fromNameField.value = dependency.fromEvent.name;
      me.toNameField.value = dependency.toEvent.name;

      if (me.lagField) {
        me.lagField.unit = dependency.lagUnit;
      }

      me.editor.record = me.dependencyRecord = dependency;
    } //endregion
    //region Stores

    /**
     * Saves the changes (applies them to record if valid, if invalid editor stays open)
     * @private
     * @fires beforeDependencySave
     * @fires beforeDependencyAdd
     * @fires afterDependencySave
     * @returns {*}
     */

  }, {
    key: "save",
    value: function () {
      var _save = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee() {
        var me, client, dependencyRecord, dependencyStore, values, _client$project;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this, client = me.client, dependencyRecord = me.dependencyRecord;

                if (!(!dependencyRecord || !me.isValid)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                dependencyStore = me.dependencyStore, values = me.values;
                /**
                 * Fires on the owning Scheduler before a dependency is saved
                 * @event beforeDependencySave
                 * @param {Scheduler.view.Scheduler} source The scheduler instance
                 * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency about to be saved
                 * @param {Object} values The new values
                 * @preventable
                 */

                if (!(client.trigger('beforeDependencySave', {
                  dependencyRecord: dependencyRecord,
                  values: values
                }) !== false)) {
                  _context.next = 15;
                  break;
                }

                me.onBeforeSave(dependencyRecord);
                me.updateRecord(dependencyRecord); // Check if this is a new record

                if (!(dependencyStore && !dependencyRecord.stores.length)) {
                  _context.next = 11;
                  break;
                }

                if (!(client.trigger('beforeDependencyAdd', {
                  dependencyRecord: dependencyRecord,
                  dependencyEdit: me
                }) === false)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                dependencyStore.add(dependencyRecord);

              case 11:
                _context.next = 13;
                return (_client$project = client.project) === null || _client$project === void 0 ? void 0 : _client$project.commitAsync();

              case 13:
                /**
                 * Fires on the owning Scheduler after a dependency is successfully saved
                 * @event afterDependencySave
                 * @param {Scheduler.view.Scheduler} source The scheduler instance
                 * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency about to be saved
                 */
                client.trigger('afterDependencySave', {
                  dependencyRecord: dependencyRecord
                });
                me.onAfterSave(dependencyRecord);

              case 15:
                return _context.abrupt("return", dependencyRecord);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
    /**
     * Delete dependency being edited
     * @private
     * @fires beforeDependencyDelete
     */

  }, {
    key: "deleteDependency",
    value: function () {
      var _deleteDependency = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee2() {
        var client, editor, dependencyRecord, _client$project2;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                client = this.client, editor = this.editor, dependencyRecord = this.dependencyRecord;
                /**
                 * Fires on the owning Scheduler before a dependency is deleted
                 * @event beforeDependencyDelete
                 * @param {Scheduler.view.Scheduler} source The scheduler instance
                 * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency record about to be deleted
                 * @preventable
                 */

                if (!(client.trigger('beforeDependencyDelete', {
                  dependencyRecord: dependencyRecord
                }) !== false)) {
                  _context2.next = 7;
                  break;
                }

                if (editor.containsFocus) {
                  editor.revertFocus();
                }

                client.dependencyStore.remove(dependencyRecord);
                _context2.next = 6;
                return (_client$project2 = client.project) === null || _client$project2 === void 0 ? void 0 : _client$project2.commitAsync();

              case 6:
                return _context2.abrupt("return", true);

              case 7:
                return _context2.abrupt("return", false);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteDependency() {
        return _deleteDependency.apply(this, arguments);
      }

      return deleteDependency;
    }() //endregion
    //region Events

  }, {
    key: "onActivateEditor",
    value: function onActivateEditor(_ref2) {
      var dependency = _ref2.dependency,
          event = _ref2.event;

      if (!this.disabled) {
        this.lastPointerDownCoordinate = [event.clientX, event.clientY];
        this.editDependency(dependency);
      }
    } //endregion

  }, {
    key: "editorConfig",
    get: function get() {
      return this._editorConfig;
    },
    set: function set(editorConfig) {
      var me = this,
          defaultEditorConfig = me.getDefaultConfiguration().editorConfig; // Apply editorConfig to the default editorConfig, allowing users to manipulate for example only bbar

      editorConfig = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].assign({}, defaultEditorConfig, editorConfig);
      editorConfig.items = editorConfig.items || [];
      me._editorConfig = editorConfig;
    } //endregion
    //region Save

  }, {
    key: "isValid",
    get: function get() {
      return Object.values(this.editor.widgetMap).every(function (field) {
        if (!field.name || field.hidden) {
          return true;
        }

        return field.isValid !== false;
      });
    }
  }, {
    key: "values",
    get: function get() {
      var values = {};
      this.editor.eachWidget(function (widget) {
        if (!widget.name || widget.hidden) return;
        values[widget.name] = widget.value;
      }, true);
      return values;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'DependencyEdit';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      var _this = this;

      return {
        /**
         * True to hide this editor if a click is detected outside it (defaults to true)
         * @config {Boolean}
         * @default
         * @category Editor
         */
        autoClose: true,

        /**
         * True to save and close this panel if ENTER is pressed in one of the input fields inside the panel.
         * @config {Boolean}
         * @default
         * @category Editor
         */
        saveAndCloseOnEnter: true,

        /**
         * True to show a delete button in the form.
         * @config {Boolean}
         * @default
         * @category Editor widgets
         */
        showDeleteButton: true,

        /**
         * The event that shall trigger showing the editor. Defaults to `dependencydblclick`, set to empty string or `null` to disable editing of dependencies.
         * @config {String}
         * @default
         * @category Editor
         */
        triggerEvent: 'dependencydblclick',

        /**
         * True to show the lag field for the dependency
         * @config {Boolean}
         * @default
         * @category Editor widgets
         */
        showLagField: false,
        dependencyRecord: null,

        /**
         * Default editor configuration, used to configure the Popup.
         * @config {Object}
         * @category Editor
         */
        editorConfig: {
          title: 'L{Edit dependency}',
          localeClass: this,
          closable: true,
          defaults: {
            localeClass: this
          },
          items: {
            /**
             * Reference to the from name
             * @member {Core.widget.DisplayField} fromNameField
             * @readonly
             */
            fromNameField: {
              type: 'display',
              label: 'L{From}',
              editable: false
            },

            /**
             * Reference to the to name field
             * @member {Core.widget.DisplayField} toNameField
             * @readonly
             */
            toNameField: {
              type: 'display',
              label: 'L{To}'
            },

            /**
             * Reference to the type field
             * @member {Core.widget.Combo} typeField
             * @readonly
             */
            typeField: {
              type: 'combo',
              label: 'L{Type}',
              name: 'type',
              editable: false,
              valueField: 'id',
              displayField: 'name',
              items: Object.keys(_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_27__["default"].Type).map(function (type) {
                // Do not remove. Assertion strings for Localization sanity check.
                // 'L{StartToStart}'
                // 'L{StartToEnd}'
                // 'L{EndToStart}'
                // 'L{EndToEnd}'
                return {
                  id: _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_27__["default"].Type[type],
                  name: _this.L(type)
                };
              })
            },

            /**
             * Reference to the lag field
             * @member {Core.widget.DurationField} lagField
             * @readonly
             */
            lagField: {
              type: 'duration',
              label: 'L{Lag}',
              name: 'lag',
              allowNegative: true
            }
          },
          bbar: {
            defaults: {
              localeClass: this
            },
            items: {
              foo: {
                type: 'widget',
                cls: 'b-label-filler'
              },

              /**
               * Reference to the save button, if used
               * @member {Core.widget.Button} saveButton
               * @readonly
               */
              saveButton: {
                color: 'b-green',
                text: 'L{Save}'
              },

              /**
               * Reference to the delete button, if used
               * @member {Core.widget.Button} deleteButton
               * @readonly
               */
              deleteButton: {
                color: 'b-gray',
                text: 'L{Delete}'
              },

              /**
               * Reference to the cancel button, if used
               * @member {Core.widget.Button} cancelButton
               * @readonly
               */
              cancelButton: {
                color: 'b-gray',
                text: 'L{Object.Cancel}'
              }
            }
          }
        }
      };
    }
  }]);

  return DependencyEdit;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_26__["default"]);


DependencyEdit._$name = 'DependencyEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_20__["default"].registerFeature(DependencyEdit, false);

/***/ }),

/***/ "./lib/Scheduler/feature/EventContextMenu.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/feature/EventContextMenu.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventContextMenu; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _EventMenu_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./EventMenu.js */ "./lib/Scheduler/feature/EventMenu.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/feature/EventContextMenu
 */

/**
 * **DEPRECATED: This class is deprecated since v4.0.0,
 * use {@link Scheduler.feature.EventMenu EventMenu} feature instead.**
 *
 * Displays a context menu for events. Items are populated by other features and/or application code.
 *
 * This feature is **disabled** by default in favor of `EventMenu`.
 *
 * @deprecated 4.0.0
 * @extends Scheduler/feature/EventMenu
 * @classtype eventContextMenu
 */

var EventContextMenu = /*#__PURE__*/function (_EventMenu) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(EventContextMenu, _EventMenu);

  var _super = _createSuper(EventContextMenu);

  function EventContextMenu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, EventContextMenu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(EventContextMenu, [{
    key: "construct",
    value: function construct(scheduler, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(EventContextMenu.prototype), "construct", this).apply(this, arguments);

      this.scheduler = scheduler;
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].deprecate('Scheduler', '5.0.0', '`EventContextMenu` feature is deprecated, in favor of `EventMenu` feature. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.'); // If this feature is enabled, need to disable EventMenu. They are mutually exclusive.

      if (scheduler.features.eventMenu) {
        scheduler.features.eventMenu.disabled = true;
      }
    } //endregion
    //region Events

    /**
     * Fired from scheduler before the context menu is shown for an event. Allows manipulation of the items
     * to show in the same way as in `processItems`. Returning `false` from a listener prevents the menu from
     * being shown.
     * @event eventContextMenuBeforeShow
     * @deprecated 4.0.0 Renamed to eventMenuBeforeShow
     * @preventable
     * @param {Scheduler.view.Scheduler} source
     * @param {Object} items Menu item configs
     * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
     * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */

    /**
     * Fired from scheduler when an item is selected in the context menu.
     * @event eventContextMenuItem
     * @deprecated 4.0.0 Renamed to eventMenuItem
     * @param {Scheduler.view.Scheduler} source
     * @param {Core.widget.MenuItem} item
     * @param {Scheduler.model.EventModel} eventRecord
     * @param {Scheduler.model.ResourceModel} resourceRecord
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */

    /**
     * Fired from scheduler after showing the context menu for an event
     * @event eventContextMenuShow
     * @deprecated 4.0.0 Renamed to eventMenuShow
     * @param {Scheduler.view.Scheduler} source
     * @param {Core.widget.Menu} menu The menu
     * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
     * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */
    //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'EventContextMenu';
    }
  }]);

  return EventContextMenu;
}(_EventMenu_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


EventContextMenu.featureClass = '';
EventContextMenu._$name = 'EventContextMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(EventContextMenu);

/***/ }),

/***/ "./lib/Scheduler/feature/EventDrag.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/feature/EventDrag.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventDrag; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _base_DragBase_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./base/DragBase.js */ "./lib/Scheduler/feature/base/DragBase.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");












































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_42___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_42___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_41___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/* eslint-disable no-unused-expressions */








/**
 * @module Scheduler/feature/EventDrag
 */
//TODO: relay events as in Dependencies. (drag -> eventdrag etc)
//TODO: shift to copy
//TODO: dragging of event that starts & ends outside of view

/**
 * Allows user to drag and drop events within the scheduler, to change startDate or resource assignment.
 *
 * This feature is **enabled** by default
 *
 * Note that changing record data during drag is not supported.
 *
 * @example
 * // constrain drag to current resource
 * let scheduler = new Scheduler({
 *   features: {
 *     eventDrag: {
 *       constrainDragToResource: true
 *     }
 *   }
 * });
 *
 * @extends Scheduler/feature/base/DragBase
 * @demo Scheduler/basic
 * @externalexample scheduler/EventDrag.js
 * @classtype eventDrag
 */

var EventDrag = /*#__PURE__*/function (_DragBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_40___default()(EventDrag, _DragBase);

  var _super = _createSuper(EventDrag);

  function EventDrag() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_37___default()(this, EventDrag);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_38___default()(EventDrag, [{
    key: "isElementDraggable",
    //endregion
    //region Drag events
    value: function isElementDraggable(el, event) {
      var scheduler = this.scheduler,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"].up(el, scheduler.eventSelector),
          eventResize = scheduler.features.eventResize;

      if (!eventElement || this.disabled) {
        return false;
      } // displaying something resizable within the event?


      if (el.matches('[class$="-handle"]')) {
        return false;
      }

      var eventRecord = scheduler.resolveEventRecord(eventElement); // using EventResize and over a virtual handle?
      // Milestones cannot be resized

      return !(eventResize && eventRecord.resizable && !eventRecord.isMilestone && eventResize.resize.overAnyHandle(event, eventElement));
    }
  }, {
    key: "getTriggerParams",
    value: function getTriggerParams(dragData) {
      var assignmentRecords = dragData.assignmentRecords,
          eventRecords = dragData.eventRecords;
      return {
        context: dragData,
        // `draggedRecords` is deprecated
        draggedRecords: eventRecords,
        eventRecords: eventRecords,
        assignmentRecords: assignmentRecords
      };
    }
  }, {
    key: "triggerEventDrag",
    value: function triggerEventDrag(dragData, start) {
      // If there has been a change...
      if (dragData.startDate - start !== 0 || dragData.newResource !== dragData.resourceRecord) {
        this.scheduler.trigger('eventDrag', Object.assign(this.getTriggerParams(dragData), {
          startDate: dragData.startDate,
          endDate: dragData.endDate,
          newResource: dragData.newResource
        }));
      }
    }
  }, {
    key: "triggerDragStart",
    value: function triggerDragStart(dragData) {
      this.scheduler.trigger('eventDragStart', this.getTriggerParams(dragData));
    }
  }, {
    key: "triggerDragAbort",
    value: function triggerDragAbort(dragData) {
      this.scheduler.trigger('eventDragAbort', this.getTriggerParams(dragData));
    }
  }, {
    key: "triggerAfterDrop",
    value: function triggerAfterDrop(dragData, valid) {
      this.currentOverClient.trigger('afterEventDrop', Object.assign(this.getTriggerParams(dragData), {
        valid: valid
      }));
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(_ref) {
      var context = _ref.context,
          event = _ref.event;
      var _this$client$features = this.client.features,
          eventMenu = _this$client$features.eventMenu,
          eventContextMenu = _this$client$features.eventContextMenu,
          eventContextMenuFeature = eventMenu && !eventMenu.disabled ? eventMenu : eventContextMenu;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_39___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_42___default()(EventDrag.prototype), "onDragStart", this).call(this, {
        context: context,
        event: event
      }); // If this is a touch action, hide the context menu which may have shown


      eventContextMenuFeature === null || eventContextMenuFeature === void 0 ? void 0 : eventContextMenuFeature.hideContextMenu(false);
    } //endregion
    //region Finalization & validation

    /**
     * Checks if an event can be dropped on the specified resource.
     * @private
     * @returns {Boolean} Valid (true) or invalid (false)
     */

  }, {
    key: "isValidDrop",
    value: function isValidDrop(dragData) {
      var newResource = dragData.newResource,
          resourceRecord = dragData.resourceRecord,
          sourceRecord = dragData.draggedEntities[0]; // Not allowed to drop an event to group header

      if (!newResource || newResource.isSpecialRow) {
        return false;
      } // Not allowed to assign an event twice to the same resource


      if (resourceRecord !== newResource) {
        return !sourceRecord.event.resources.includes(newResource);
      }

      return true;
    }
  }, {
    key: "checkDragValidity",
    value: function checkDragValidity(dragData, event) {
      var me = this,
          scheduler = me.currentOverClient;
      var result = me.dragData.context.valid;

      if (result) {
        // First make sure DragHelper thinks it's a valid drag, then scheduler domain checks
        if (!scheduler.allowOverlap && !scheduler.isDateRangeAvailable(dragData.startDate, dragData.endDate, dragData.draggedEntities[0], dragData.newResource)) {
          result = {
            valid: false,
            message: me.L('L{eventOverlapsExisting}')
          };
        } else {
          result = me.validatorFn.call(me.validatorFnThisObj || me, dragData, event);
        }
      }

      return result;
    } //endregion
    //region Update records

    /**
     * Update events being dragged.
     * @private
     * @param context Drag data.
     * @async
     */

  }, {
    key: "updateRecords",
    value: function () {
      var _updateRecords = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_36___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_34___default.a.mark(function _callee(context) {
        var me, fromScheduler, toScheduler, copyKeyPressed, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_34___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this, fromScheduler = me.scheduler, toScheduler = me.currentOverClient, copyKeyPressed = false;
                fromScheduler.eventStore.suspendAutoCommit();
                toScheduler.eventStore.suspendAutoCommit();
                _context.next = 5;
                return me.updateAssignments(fromScheduler, toScheduler, context, copyKeyPressed);

              case 5:
                result = _context.sent;
                fromScheduler.eventStore.resumeAutoCommit();
                toScheduler.eventStore.resumeAutoCommit(); // Tell the world there was a successful drop

                toScheduler.trigger('eventDrop', Object.assign(me.getTriggerParams(context), {
                  isCopy: copyKeyPressed,
                  event: context.browserEvent,
                  targetEventRecord: context.targetEventRecord,
                  targetResourceRecord: context.newResource
                }));
                return _context.abrupt("return", result);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateRecords(_x) {
        return _updateRecords.apply(this, arguments);
      }

      return updateRecords;
    }()
    /**
     * Update assignments being dragged
     * @private
     * @async
     */

  }, {
    key: "updateAssignments",
    value: function () {
      var _updateAssignments = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_36___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_34___default.a.mark(function _callee2(fromScheduler, toScheduler, context, copy) {
        var _toEventStore$add;

        var me, isCrossScheduler, isVertical, fromAssignmentStore, fromEventStore, resourceStore, toAssignmentStore, toEventStore, eventRecords, assignmentRecords, timeDiff, fromResource, toResource, unifiedDrag, indexDiff, event1Date, eventsToAdd, eventsToRemove, assignmentsToAdd, assignmentsToRemove, eventsToCheck, resourcesToRefresh, eventsToBatch, updated, updatedEvent, i, draggedAssignment, draggedEvent, eventBar, originalEventRecord, originalStartDate, originalResourceRecord, newStartDate, inTimeAxis, keepEvent, newAssignment, clonedData, newResource, newIndex, clone, elRect, _draggedEvent$resourc;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_34___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // The code is written to emit as few store events as possible
                me = this, isCrossScheduler = fromScheduler !== toScheduler, isVertical = toScheduler.mode === 'vertical', fromAssignmentStore = fromScheduler.assignmentStore, fromEventStore = fromScheduler.eventStore, resourceStore = fromScheduler.resourceStore, toAssignmentStore = toScheduler.assignmentStore, toEventStore = toScheduler.eventStore, eventRecords = context.eventRecords, assignmentRecords = context.assignmentRecords, timeDiff = context.timeDiff, fromResource = context.resourceRecord, toResource = context.newResource, unifiedDrag = me.unifiedDrag || isCrossScheduler && assignmentRecords.length > 1, indexDiff = me.constrainDragToResource ? 0 : resourceStore.indexOf(fromResource) - resourceStore.indexOf(toResource), event1Date = me.adjustStartDate(assignmentRecords[0].event.startDate, timeDiff), eventsToAdd = [], eventsToRemove = [], assignmentsToAdd = [], assignmentsToRemove = [], eventsToCheck = [], resourcesToRefresh = new Set(), eventsToBatch = new Set();
                fromScheduler.suspendRefresh();
                toScheduler.suspendRefresh();
                updated = false, updatedEvent = false;

                if (isVertical) {
                  // TODO : Broken after merge, figure it out
                  eventRecords.forEach(function (draggedEvent, i) {
                    var eventBar = context.eventBarEls[i];
                    delete draggedEvent.instanceMeta(fromScheduler).hasTemporaryDragElement; // If it was created by a call to scheduler.currentOrientation.addTemporaryDragElement
                    // then release it back to be available to DomSync next time the rendered event block
                    // is synced.

                    if (eventBar.dataset.transient) {
                      eventBar.remove();
                    }
                  });
                } // Using for to support await inside


                for (i = 0; i < assignmentRecords.length; i++) {
                  // Reassigned when dropped on other scheduler, thus not const
                  draggedAssignment = assignmentRecords[i], draggedEvent = draggedAssignment.event;
                  eventBar = context.eventBarEls[i], originalEventRecord = draggedEvent, originalStartDate = originalEventRecord.startDate, originalResourceRecord = draggedAssignment.resource, newStartDate = this.constrainDragToTimeSlot ? originalStartDate : unifiedDrag ? event1Date : me.adjustStartDate(originalStartDate, timeDiff), inTimeAxis = toScheduler.isInTimeAxis(originalEventRecord);
                  resourcesToRefresh.add(originalResourceRecord); // If changing resource, the element wont be found in SchedulerStores#onEventBeforeCommit and thus the
                  // committing cls wont be applied. Apply it here, in case we are using a backend. If we are not, it will be
                  // replaced anyway on the immediate redraw

                  eventBar.querySelector(fromScheduler.eventInnerSelector).classList.add(fromScheduler.committingCls);

                  if (copy) {
                    draggedAssignment = draggedAssignment.copy(null);
                    assignmentsToAdd.push(draggedAssignment);
                  } // Dropped on another scheduler, not sharing assignmentStore
                  else if (fromAssignmentStore !== toAssignmentStore) {
                      keepEvent = originalEventRecord.assignments.length > 1, newAssignment = draggedAssignment.copy(); // Remove assignment from source scheduler

                      assignmentsToRemove.push(draggedAssignment); // If it was the last assignment, the event should also be removed

                      if (!keepEvent) {
                        eventsToRemove.push(originalEventRecord);
                      } // If event does not already exist in target scheduler a copy is added


                      if (!toEventStore.getById(originalEventRecord.id)) {
                        // Clone keeping the same id
                        clonedData = Object.assign({}, originalEventRecord.data, {
                          id: originalEventRecord.id,
                          // Engine gets mad if not nulled
                          calendar: null
                        });
                        draggedEvent = clonedData;
                        eventsToAdd.push(clonedData);
                      } // And add it to the target scheduler
                      // TODO: Should be handled on the data layer ideally


                      if (!toEventStore.usesSingleAssignment) {
                        assignmentsToAdd.push(newAssignment);
                      }

                      draggedAssignment = newAssignment;
                    }

                  newResource = unifiedDrag || isCrossScheduler ? toResource : originalResourceRecord; // If not dragging events as a unified block, distribute each to a new resource
                  // using the same offset as the dragged event.

                  if (!unifiedDrag && !isCrossScheduler && indexDiff !== 0) {
                    newIndex = Math.max(Math.min(resourceStore.indexOf(originalResourceRecord) - indexDiff, resourceStore.count - 1), 0);
                    newResource = resourceStore.getAt(newIndex);
                  }

                  resourcesToRefresh.add(newResource); // When not constrained to timeline we are dragging a clone and need to manually do some cleanup if
                  // dropped in view

                  if (!me.constrainDragToTimeline) {
                    // Remove original element properly
                    _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_47__["default"].removeChild(fromScheduler.foregroundCanvas, eventBar);

                    if (toScheduler.rowManager.getRowFor(newResource) && inTimeAxis) {
                      clone = i === 0 ? context.context.element : context.context.relatedElements[i - 1], elRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_48__["default"].from(clone, toScheduler.foregroundCanvas, true); // Ensure that after inserting the dragged element clone into the toScheduler's foregroundCanvas
                      // it's at the same visual position that it was dragged to.

                      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"].setTranslateXY(clone, elRect.x, elRect.y);
                      clone.classList.remove('b-sch-event-hover');
                      clone.classList.remove('b-active');
                      clone.classList.remove('b-drag-proxy');
                      clone.classList.remove('b-dragging');
                      clone.retainElement = false; // TODO: Try if addChild is enough now
                      // Add element properly, so that DomSync will reuse it on next update

                      _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_47__["default"].addChild(toScheduler.foregroundCanvas, clone, draggedAssignment.id);
                    }
                  } // Cannot rely on assignment generation to detect update, since it might be a new assignment


                  if (draggedAssignment.resource !== newResource) {
                    draggedAssignment.resource = newResource; // Actual events should be batched, not data for new events when dragging between

                    draggedEvent.isEvent && eventsToBatch.add(draggedEvent);
                    updated = true; // When dragging an occurrence, the assignment is only temporary. We have to tag the newResource along
                    // to be picked up by the occurrence -> event conversion
                    // TODO: A hack, figure a better way out

                    if (draggedEvent.isOccurrence) {
                      draggedEvent.newResource = newResource;
                    } // // TODO: Should be handled on the datalayer somehow, but it is kind of edge casey


                    if (isCrossScheduler && toEventStore.usesSingleAssignment) {
                      // In single assignment mode, when dragged to another scheduler it will not copy the assignment
                      // over but instead set the resourceId of the event. To better match expected behaviour
                      draggedEvent.resourceId = newResource.id;
                    }
                  } // Same for event


                  if (!_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].isEqual(draggedEvent.startDate, newStartDate)) {
                    eventsToCheck.push({
                      draggedEvent: draggedEvent,
                      originalStartDate: originalStartDate
                    });
                    draggedEvent.startDate = newStartDate;
                    draggedEvent.isEvent && eventsToBatch.add(draggedEvent);
                    updatedEvent = true; // When changing date, all assignments are affected so might need to redraw more resources
                    // (might be a clone, no resources then)

                    (_draggedEvent$resourc = draggedEvent.resources) === null || _draggedEvent$resourc === void 0 ? void 0 : _draggedEvent$resourc.forEach(function (resource) {
                      return resourcesToRefresh.add(resource);
                    });
                  }
                }

                fromAssignmentStore.remove(assignmentsToRemove);
                fromEventStore.remove(eventsToRemove);
                toAssignmentStore.add(assignmentsToAdd);
                (_toEventStore$add = toEventStore.add(eventsToAdd)) === null || _toEventStore$add === void 0 ? void 0 : _toEventStore$add.forEach(function (added) {
                  return eventsToBatch.add(added);
                }); // Any added or removed events or assignments => something changed

                if (assignmentsToRemove.length || eventsToRemove.length || assignmentsToAdd.length || eventsToAdd.length) {
                  updated = true;
                } // Commit changes to affected projects


                if (!(updated || updatedEvent)) {
                  _context2.next = 16;
                  break;
                }

                // By batching event changes when using single assignment we avoid two updates, without it there will be one
                // for date change and one when changed assignment updates resourceId on the event
                toEventStore.usesSingleAssignment && eventsToBatch.forEach(function (eventRecord) {
                  return eventRecord.beginBatch();
                });
                _context2.next = 15;
                return Promise.all([toScheduler.project !== fromScheduler.project ? toScheduler.project.commitAsync() : null, fromScheduler.project.commitAsync()]);

              case 15:
                // End batch in engine friendly way, avoiding to have `set()` trigger another round of calculations
                toEventStore.usesSingleAssignment && eventsToBatch.forEach(function (eventRecord) {
                  return eventRecord.endBatch(false, true);
                });

              case 16:
                if (!updated) {
                  // Engine might have reverted the date change, in which case this should be considered an invalid op
                  updated = eventsToCheck.some(function (_ref2) {
                    var draggedEvent = _ref2.draggedEvent,
                        originalStartDate = _ref2.originalStartDate;
                    return !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].isEqual(draggedEvent.startDate, originalStartDate);
                  });
                } // Resumes self twice if not cross scheduler, but was suspended twice above also so all good


                toScheduler.resumeRefresh();
                fromScheduler.resumeRefresh();

                if (!updated) {
                  context.valid = false;
                } else {
                  // Not doing full refresh above, to allow for animations
                  toScheduler.refreshWithTransition();

                  if (isCrossScheduler) {
                    fromScheduler.refreshWithTransition();
                  }
                }

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateAssignments(_x2, _x3, _x4, _x5) {
        return _updateAssignments.apply(this, arguments);
      }

      return updateAssignments;
    }() //endregion
    //region Drag data

  }, {
    key: "getProductDragContext",
    value: function getProductDragContext(dragData) {
      var targetEventRecord = this.scheduler.resolveEventRecord(dragData.browserEvent.target);
      var newResource;

      if (this.constrainDragToResource) {
        newResource = dragData.resourceRecord;
      } else if (!this.constrainDragToTimeline) {
        // If we're dragging freely on the page, require to drag onto a resource row always
        newResource = this.resolveResource();
      } else {
        newResource = this.resolveResource() || dragData.newResource || dragData.resourceRecord;
      }

      var assignmentRecords = dragData.assignmentRecords,
          eventRecords = dragData.eventRecords;
      return {
        valid: Boolean(newResource),
        // `draggedRecords` is deprecated
        draggedRecords: eventRecords,
        eventRecords: eventRecords,
        assignmentRecords: assignmentRecords,
        newResource: newResource,
        targetEventRecord: targetEventRecord
      };
    }
  }, {
    key: "setupProductDragData",
    value: function setupProductDragData(info) {
      var me = this,
          scheduler = me.scheduler,
          element = info.grabbed,
          eventRecord = scheduler.resolveEventRecord(element),
          resourceRecord = scheduler.resolveResourceRecord(element),
          assignmentRecord = scheduler.resolveAssignmentRecord(element),
          eventRegion = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_48__["default"].from(element),
          draggedEntities = [assignmentRecord],
          eventBarEls = [];

      if (me.constrainDragToResource && !resourceRecord) {
        throw new Error('Resource could not be resolved for event: ' + eventRecord.id);
      }

      var dateConstraints = scheduler.getDateConstraints(me.constrainDragToResource ? resourceRecord : null, eventRecord);

      if (me.constrainDragToTimeline) {
        me.setupConstraints(scheduler.getScheduleRegion(me.constrainDragToResource ? resourceRecord : null, eventRecord), eventRegion, scheduler.timeAxisViewModel.snapPixelAmount, Boolean(dateConstraints));
      } // We multi drag other selected events if multiEventSelect is set and
      // (the dragged event is already selected, or the ctrl key is pressed)


      if (scheduler.multiEventSelect && (scheduler.isAssignmentSelected(draggedEntities[0]) || me.drag.startEvent.ctrlKey)) {
        draggedEntities.push.apply(draggedEntities, me.getRelatedRecords(assignmentRecord));
      } // Collecting all elements to drag


      draggedEntities.forEach(function (assignment) {
        var eventBarEl = scheduler.getElementFromAssignmentRecord(assignment);

        if (!eventBarEl) {
          eventBarEl = scheduler.currentOrientation.addTemporaryDragElement(assignment.event, assignment.resource);
          eventBarEl = eventBarEl.innerElement;
        }

        eventBarEls.push(eventBarEl);
      }); // What is dragged is the wrapper.

      eventBarEls.forEach(function (el, i) {
        return eventBarEls[i] = el.parentNode;
      });
      return {
        record: assignmentRecord,
        dateConstraints: dateConstraints,
        eventBarEls: eventBarEls,
        draggedEntities: draggedEntities
      };
    }
    /**
     * Initializes drag data (dates, constraints, dragged events etc). Called when drag starts.
     * @private
     * @param info
     * @param event
     * @returns {*}
     */

  }, {
    key: "getDragData",
    value: function getDragData(info, event) {
      var dragData = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_39___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_42___default()(EventDrag.prototype), "getDragData", this).call(this, info, event),
          assignmentRecords = dragData.draggedEntities,
          eventRecords = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_33___default()(new Set(assignmentRecords.map(function (assignment) {
        return assignment.event;
      })));

      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"].assign(dragData, {
        resourceRecord: this.scheduler.resolveResourceRecord(info.grabbed),
        eventRecords: eventRecords,
        assignmentRecords: assignmentRecords
      });
    }
    /**
     * Provide your custom implementation of this to allow additional selected records to be dragged together with the original one.
     * @param {Scheduler.model.AssignmentModel} assignmentRecord The assignment about to be dragged
     * @return {Scheduler.model.AssignmentModel[]} An array of assignment records to drag together with the original
     */

  }, {
    key: "getRelatedRecords",
    value: function getRelatedRecords(assignmentRecord) {
      return this.scheduler.selectedAssignments.filter(function (selectedRecord) {
        return selectedRecord !== assignmentRecord && selectedRecord.event.isDraggable;
      });
    }
    /**
     * Get correct axis coordinate depending on schedulers mode (horizontal -> x, vertical -> y). Also takes milestone
     * layout into account.
     * @private
     * @param {Scheduler.model.EventModel} eventRecord Record being dragged
     * @param {HTMLElement} element Element being dragged
     * @param {Number[]} coord XY coordinates
     * @returns {Number|Number[]} X,Y or XY
     */

  }, {
    key: "getCoordinate",
    value: function getCoordinate(eventRecord, element, coord) {
      var scheduler = this.currentOverClient;

      if (scheduler.isHorizontal) {
        var x = coord[0]; // Adjust coordinate for milestones if using a layout mode, since they are aligned differently than events

        if (scheduler.milestoneLayoutMode !== 'default' && eventRecord.isMilestone) {
          switch (scheduler.milestoneAlign) {
            case 'center':
              x += element.offsetWidth / 2;
              break;

            case 'end':
              x += element.offsetWidth;
              break;
          }
        }

        return x;
      } else {
        var y = coord[1]; // Adjust coordinate for milestones if using a layout mode, since they are aligned differently than events

        if (scheduler.milestoneLayoutMode !== 'default' && eventRecord.isMilestone) {
          switch (scheduler.milestoneAlign) {
            case 'center':
              y += element.offsetHeight / 2;
              break;

            case 'end':
              y += element.offsetHeight;
              break;
          }
        }

        return y;
      }
    }
    /**
     * Get resource record occluded by the drag proxy.
     * @private
     * @returns {Scheduler.model.ResourceModel}
     */

  }, {
    key: "resolveResource",
    value: function resolveResource() {
      var me = this,
          client = me.currentOverClient,
          isHorizontal = client.isHorizontal,
          context = me.dragData.context,
          element = context.dragProxy || context.element,
          pageRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_48__["default"].from(element, null, true),
          y = client.isVertical || me.unifiedDrag ? context.clientY : pageRect.center.y,
          localRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_48__["default"].from(element, me.currentOverClient.timeAxisSubGridElement, true),
          _localRect$center = localRect.center,
          lx = _localRect$center.x,
          ly = _localRect$center.y; // This is benchmarked as the fastest way to find a Grid Row from a viewport Y coordinate
      // so use it in preference to elementFromPoint (which causes a forced synchonous layout) in horiontal mode.

      if (isHorizontal) {
        var row = client.rowManager.getRowAt(y);
        return row && client.resourceStore.getAt(row.dataIndex);
      } // In vertical mode, just use the X coordinate to find out which resource we are under.
      // The method requires that a .b-sch-timeaxis-cell element be passed.
      // There is only one in vertical mode, so use that.


      return client.resolveResourceRecord(client.timeAxisSubGridElement.querySelector('.b-sch-timeaxis-cell'), [lx, ly]);
    } //endregion
    //region Other stuff

  }, {
    key: "adjustStartDate",
    value: function adjustStartDate(startDate, timeDiff) {
      var scheduler = this.currentOverClient;
      return scheduler.timeAxis.roundDate(new Date(startDate - 0 + timeDiff), scheduler.snapRelativeToEventStartDate ? startDate : false);
    }
  }, {
    key: "resolveStartEndDates",
    value: function resolveStartEndDates(proxyRect) {
      var scheduler = this.currentOverClient,
          timeAxis = scheduler.timeAxis,
          dd = this.dragData; // Non continuous time axis will return null instead of date for a rectangle outside of the view unless
      // told to estimate date

      var _scheduler$getStartEn = scheduler.getStartEndDatesFromRectangle(proxyRect, 'round', dd.duration, !timeAxis.isContinuous),
          startDate = _scheduler$getStartEn.start,
          endDate = _scheduler$getStartEn.end; // if dragging is out of timeAxis rect bounds, we will not be able to get dates


      if (startDate && endDate) {
        if (!dd.startsOutsideView) {
          // Make sure we didn't target a start date that is filtered out, if we target last hour cell (e.g. 21:00) of
          // the time axis, and the next tick is 08:00 following day. Trying to drop at end of 21:00 cell should target start of next cell
          if (startDate && !scheduler.timeAxis.dateInAxis(startDate, false)) {
            var tick = scheduler.timeAxis.getTickFromDate(startDate);

            if (tick >= 0) {
              startDate = scheduler.timeAxis.getDateFromTick(tick);
            }
          }

          endDate = startDate && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].add(startDate, dd.duration, 'ms');
        } else if (!dd.endsOutsideView) {
          startDate = endDate && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].add(endDate, -dd.duration, 'ms');
        }
      }

      return {
        startDate: startDate,
        endDate: endDate
      };
    }
  }, {
    key: "getRecordElement",
    value: function getRecordElement(assignmentRecord) {
      return this.scheduler.getElementFromAssignmentRecord(assignmentRecord, true);
    } //endregion

  }, {
    key: "scheduler",
    //endregion
    //region Events

    /**
     * Fired on the owning Scheduler to allow implementer to prevent immediate finalization by setting `data.context.async = true`
     * in the listener, to show a confirmation popup etc
     * ```
     *  scheduler.on('beforeeventdropfinalize', ({context}) => {
     *      context.async = true;
     *      setTimeout(() => {
     *          // async code don't forget to call finalize
     *          context.finalize();
     *      }, 1000);
     *  })
     * ```
     * Changing record data during drag is not supported.
     *
     * @event beforeEventDropFinalize
     * @param {Scheduler.view.Scheduler} source Scheduler instance
     * @param {Object} context
     * @param {Boolean} context.async Set true to handle dragdrop asynchronously (e.g. to wait for user
     * @param {Scheduler.model.EventModel} context.targetEventRecord Event record for drop target
     * @param {Scheduler.model.ResourceModel} context.newResource Resource record for drop target
     * confirmation)
     * @param {Function} context.finalize Call this method to finalize dragdrop. This method accepts one
     * argument: pass true to update records, or false, to ignore changes
     */

    /**
     * Fired on the owning Scheduler after event drop
     * @event afterEventDrop
     * @param {Scheduler.view.Scheduler} source
     * @param {Scheduler.model.AssignmentModel[]} assignmentRecords
     * @param {Scheduler.model.EventModel[]} eventRecords
     * @param {Boolean} valid
     * @param {Object} context
     */

    /**
     * Fired on the owning Scheduler when an event is dropped
     * @event eventDrop
     * @param {Scheduler.view.Scheduler} source
     * @param {Scheduler.model.EventModel[]} eventRecords
     * @param {Scheduler.model.AssignmentModel[]} assignmentRecords
     * @param {Boolean} isCopy
     * @param {Object} context
     * @param {Scheduler.model.EventModel} context.targetEventRecord Event record for drop target
     * @param {Scheduler.model.ResourceModel} context.newResource Resource record for drop target
     */

    /**
     * Fired on the owning Scheduler before event dragging starts. Return false to prevent the action
     * @event beforeEventDrag
     * @param {Scheduler.view.Scheduler} source
     * @param {Scheduler.model.EventModel} eventRecord
     * @param {Object} context
     */

    /**
     * Fired on the owning Scheduler when event dragging starts
     * @event eventDragStart
     * @param {Scheduler.view.Scheduler} source
     * @param {Scheduler.model.EventModel[]} eventRecords
     * @param {Scheduler.model.AssignmentModel[]} assignmentRecords
     * @param {Object} context
     */

    /**
     * Fired on the owning Scheduler when event is dragged
     * @event eventDrag
     * @param {Scheduler.view.Scheduler} source
     * @param {Scheduler.model.AssignmentModel[]} assignmentRecords
     * @param {Scheduler.model.EventModel[]} eventRecords
     * @param {Date} startDate
     * @param {Date} endDate
     * @param {Scheduler.model.ResourceModel} newResource
     * @param {Object} context
     */

    /**
     * Fired on the owning Scheduler after an event drag operation has been aborted
     * @event eventDragAbort
     * @param {Scheduler.view.Scheduler} source
     * @param {Scheduler.model.AssignmentModel[]} assignmentRecords
     * @param {Scheduler.model.EventModel[]} eventRecords
     * @param {Object} context
     */
    //endregion
    //region Data layer
    // Deprecated. Use this.client instead
    get: function get() {
      return this.client;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'EventDrag';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Template used to generate drag tooltip contents.
         * ```
         * const scheduler = new Scheduler({
         *   features : {
         *     eventDrag : {
         *       dragTipTemplate({eventRecord, startText}) {
         *         return `${eventRecord.name}: ${startText}`
         *       }
         *     }
         *   }
         * });
         * ```
         * @config {Function} dragTipTemplate
         * @param {Object} data Tooltip data
         * @param {Scheduler.model.EventModel} data.eventRecord
         * @param {Boolean} data.valid Currently over a valid drop target or not
         * @param {Date} data.startDate New start date
         * @param {Date} data.endDate New end date
         * @param {String} data.startText Formatted new start date
         * @param {String} data.endText Formatted new end date
         * @param {String} data.startClockHtml Pre-generated HTML to display startDate as clock/calendar
         * @param {String} data.endClockHtml Pre-generated HTML to display endDate as clock/calendar
         * @param {Object} data.dragData Detailed drag context
         * @returns {String}
         */

        /**
         * Set to true to only allow dragging events within the same resource.
         * @config {Boolean}
         * @default
         */
        constrainDragToResource: false,

        /**
         * Set to true to only allow dragging events to different resources, and disallow rescheduling by dragging.
         * @config {Boolean}
         * @default
         */
        constrainDragToTimeSlot: false,

        /**
         * An empty function by default, but provided so that you can perform custom validation on
         * the item being dragged. This function is called during the drag and drop process and also after the drop is made.
         * Return true if the new position is valid, false to prevent the drag.
         * @param {Object} context A drag drop context object
         * @param {Date} context.startDate New start date
         * @param {Date} context.endDate New end date
         * @param {Scheduler.model.AssignmentModel[]} context.assignmentRecords Assignment records which were dragged
         * @param {Scheduler.model.EventModel[]} context.draggedRecords  **Deprecated** in 4.0. Use `context.eventRecords` instead.
         * @param {Scheduler.model.EventModel[]} context.eventRecords Event records which were dragged
         * @param {Scheduler.model.ResourceModel} context.newResource New resource record
         * @param {Event} event The event object
         * @return {Boolean} `true` if this validation passes
         * @config {Function}
         */
        validatorFn: function validatorFn() {},

        /**
         * The `this` reference for the validatorFn
         * @config {Object}
         */
        validatorFnThisObj: null,

        /**
         * When the host Scheduler is `{@link Scheduler.view.mixin.EventSelection#config-multiEventSelect multiEventSelect}: true`
         * then, there are two modes of dragging *within the same Scheduler*.
         *
         * Non unified means that all selected events are dragged by the same number of resource rows.
         *
         * Unified means that all selected events are collected together and dragged as one, and are all dropped
         * on the same targeted resource row at the same targeted time.
         * @config {Boolean}
         * @default false
         */
        unifiedDrag: null
      };
    }
  }]);

  return EventDrag;
}(_base_DragBase_js__WEBPACK_IMPORTED_MODULE_43__["default"]);


EventDrag._$name = 'EventDrag';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_49__["default"].registerFeature(EventDrag, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/EventDragCreate.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/EventDragCreate.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventDragCreate; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./base/DragCreateBase.js */ "./lib/Scheduler/feature/base/DragCreateBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/feature/EventDragCreate
 */

/**
 * Feature that allows the user to create new events by dragging in empty parts of the scheduler rows.
 *
 * This feature is **enabled** by default
 *
 * **NOTE:** Incompatible with {@link Scheduler.feature.Pan Pan} feature.
 *
 * @extends Scheduler/feature/base/DragCreateBase
 * @demo Scheduler/basic
 * @externalexample scheduler/EventDragCreate.js
 * @classtype eventDragCreate
 */

var EventDragCreate = /*#__PURE__*/function (_DragCreateBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(EventDragCreate, _DragCreateBase);

  var _super = _createSuper(EventDragCreate);

  function EventDragCreate() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, EventDragCreate);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(EventDragCreate, [{
    key: "construct",
    //endregion
    //region Events

    /**
     * Fires on the owning Scheduler after the new event has been created.
     * @event dragCreateEnd
     * @param {Scheduler.view.Scheduler} source
     * @param {Scheduler.model.EventModel} newEventRecord
     * @param {Scheduler.model.ResourceModel} resourceRecord
     * @param {MouseEvent} event The ending mouseup event.
     * @param {HTMLElement} proxyElement The proxy element showing the drag creation zone.
     */

    /**
     * Fires on the owning Scheduler at the beginning of the drag gesture
     * @event beforeDragCreate
     * @param {Scheduler.view.Scheduler} source
     * @param {Scheduler.model.ResourceModel} resourceRecord
     * @param {Date} date The datetime associated with the drag start point.
     */

    /**
     * Fires on the owning Scheduler after the drag start has created a proxy element.
     * @event dragCreateStart
     * @param {Scheduler.view.Scheduler} source
     * @param {HTMLElement} proxyElement The proxy representing the new event.
     */

    /**
     * Fired on the owning Scheduler to allow implementer to prevent immediate finalization by setting `data.context.async = true`
     * in the listener, to show a confirmation popup etc
     * ```
     *  scheduler.on('beforedragcreatefinalize', ({context}) => {
     *      context.async = true;
     *      setTimeout(() => {
     *          // async code don't forget to call finalize
     *          context.finalize();
     *      }, 1000);
     *  })
     * ```
     * @event beforeDragCreateFinalize
     * @param {Scheduler.view.Scheduler} source Scheduler instance
     * @param {HTMLElement} proxyElement Proxy element, representing future event
     * @param {Object} context
     * @param {Boolean} context.async Set true to handle drag create asynchronously (e.g. to wait for user
     * confirmation)
     * @param {Function} context.finalize Call this method to finalize drag create. This method accepts one
     * argument: pass true to update records, or false, to ignore changes
     */

    /**
     * Fires on the owning Scheduler at the end of the drag create gesture whether or not
     * a new event was created by the gesture.
     * @event afterDragCreate
     * @param {Scheduler.view.Scheduler} source
     * @param {HTMLElement} proxyElement The proxy element showing the drag creation zone.
     */
    //endregion
    //region Init
    value: function construct(scheduler, config) {
      this.scheduler = scheduler;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(EventDragCreate.prototype), "construct", this).call(this, scheduler, config);
    }
  }, {
    key: "finalizeDragCreate",
    //endregion
    //region Scheduler specific implementation
    value: function finalizeDragCreate(context) {
      var newEventRecord = new this.store.modelClass({
        startDate: context.startDate,
        // Needed to force engine to calculate duration even if there is a defaultValue specified
        duration: null,
        endDate: context.endDate
      });
      this.proxy.dataset.eventId = newEventRecord.id;
      this.scheduler.trigger('dragCreateEnd', {
        newEventRecord: newEventRecord,
        resourceRecord: context.rowRecord,
        event: context.event,
        proxyElement: this.proxy
      });
    }
  }, {
    key: "handleBeforeDragCreate",
    value: function handleBeforeDragCreate(dateTime, event) {
      var me = this,
          result = me.scheduler.trigger('beforeDragCreate', {
        resourceRecord: me.createContext.rowRecord,
        date: dateTime,
        event: event
      });

      if (result) {
        var _tipFeature$hoverTip;

        // Tooltip will not be activated while drag is in progress,
        // but we need to hide it deliberately on drag start
        var tipFeature = me.scheduler.features.scheduleTooltip;
        tipFeature === null || tipFeature === void 0 ? void 0 : (_tipFeature$hoverTip = tipFeature.hoverTip) === null || _tipFeature$hoverTip === void 0 ? void 0 : _tipFeature$hoverTip.hide();
      } // Save date constraints


      me.dateConstraints = me.scheduler.getDateConstraints(me.createContext.rowRecord, dateTime);
      return result;
    }
  }, {
    key: "checkValidity",
    value: function checkValidity(context, event) {
      var me = this,
          client = me.client; // Nicer for users of validatorFn

      context.resourceRecord = context.rowRecord;
      return (client.allowOverlap || client.isDateRangeAvailable(context.startDate, context.endDate, null, context.resourceRecord)) && me.validatorFn.call(me.validatorFnThisObj || me, context, event);
    } // Determine if resource already has events or not

  }, {
    key: "isRowEmpty",
    value: function isRowEmpty(resourceRecord) {
      var events = this.store.getEventsForResource(resourceRecord);
      return !events || !events.length;
    } //endregion

  }, {
    key: "store",
    get: function get() {
      return this.scheduler.eventStore;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'EventDragCreate';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * An empty function by default, but provided so that you can perform custom validation on the event being created.
         * Return true if the new event is valid, false to prevent an event being created.
         * @param {Object} context A drag create context
         * @param {Date} context.startDate Event start date
         * @param {Date} context.endDate Event end date
         * @param {Scheduler.model.EventModel} context.record Event record
         * @param {Scheduler.model.ResourceModel} context.resourceRecord Resource record
         * @param {Event} event The event object
         * @return {Boolean} `true` if this validation passes
         * @config {function}
         */
        validatorFn: function validatorFn() {}
      };
    }
  }]);

  return EventDragCreate;
}(_base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


EventDragCreate._$name = 'EventDragCreate';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(EventDragCreate, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/EventDragSelect.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/EventDragSelect.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventDragSelect; });
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Scheduler/feature/EventDragSelect
 */

/**
 * Enables users to click and drag to select events inside the Scheduler's timeline.
 *
 * This feature is **disabled** by default.
 *
 * **NOTE:** Incompatible with {@link Scheduler.feature.EventDragCreate EventDragCreate} and the {@link Scheduler.feature.Pan Pan} features.
 *
 * @extends Core/mixin/InstancePlugin
 * @mixes Core/mixin/Delayable
 *
 * @example
 * let scheduler = new Scheduler({
 *   features : {
 *     eventDragSelect      : true,
 *     eventDragCreate      : false
 *   }
 * });
 *
 * @demo Scheduler/dragselection
 * @classtype eventDragSelect
 */

var EventDragSelect = /*#__PURE__*/function (_Delayable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(EventDragSelect, _Delayable);

  var _super = _createSuper(EventDragSelect);

  function EventDragSelect() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, EventDragSelect);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(EventDragSelect, [{
    key: "construct",
    value: function construct(timeline, config) {
      this.timeline = timeline;
      timeline.multiEventSelect = true;

      if (timeline.features.eventDragCreate || timeline.features.pan) {
        throw new Error('Cannot combine this feature with Pan or EventDragCreate features');
      }

      var targetSelectors = ['.b-timeline-subgrid .b-grid-cell', '.b-timeline-subgrid'];
      this.targetSelector = targetSelectors.join(',');

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(EventDragSelect.prototype), "construct", this).call(this, timeline, config);
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Scheduler.

  }, {
    key: "onElementMouseDown",
    //endregion
    value: function onElementMouseDown(event) {
      var me = this,
          scheduler = me.client; // only react to mouse input, and left button

      if (event.touches || event.button !== 0 || me.disabled) {
        return;
      } // only react to mousedown directly on grid cell or subgrid element


      if (event.target.matches(me.targetSelector)) {
        me.startX = event.clientX;
        me.startY = event.clientY;
        me.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].createElement({
          tag: 'div',
          className: 'b-dragselect-rect'
        }, true)[0];
        _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_19__["default"].floatRoot.appendChild(me.element);
        scheduler.element.classList.add('b-dragselecting'); // Since the dragselect element is in the floatRoot, we want to use viewport-based coordinates, so we pass
        // ignorePageScroll=true when calling Rectangle.from():

        me.eventRectangles = Array.from(scheduler.element.querySelectorAll(scheduler.eventSelector)).map(function (el) {
          return {
            rectangle: _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__["default"].from(el,
            /* ignorePageScroll = */
            true),
            record: scheduler.resolveEventRecord(el)
          };
        });
        scheduler.clearEventSelection();
        me.subGridElementRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__["default"].from(scheduler.timeAxisSubGrid.element,
        /* ignorePageScroll = */
        true); // No key processing during drag selection

        scheduler.navigator.disabled = true;
      }
    }
  }, {
    key: "onElementMouseMove",
    value: function onElementMouseMove(event) {
      var me = this; // Synthetic mousemove event has no button for IE11
      // Detect if a mouseup happened outside our element (or browser window for that matter). Note 'buttons' is not supported by Safari

      if (event.buttons === 0 && !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].isSafari && (!_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].isIE11 || event.isTrusted)) {
        me.onElementMouseUp(event);
        return;
      }

      if (typeof me.startX === 'number') {
        var x = Math.max(event.clientX, me.subGridElementRect.left),
            y = Math.max(event.clientY, me.subGridElementRect.top),
            left = Math.min(me.startX, x),
            top = Math.min(me.startY, y),
            width = Math.abs(me.startX - x),
            height = Math.abs(me.startY - y),
            rect = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__["default"](left, top, width, height).constrainTo(me.subGridElementRect);
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].setTranslateXY(me.element, rect.left, rect.top);
        me.element.style.width = rect.width + 'px';
        me.element.style.height = rect.height + 'px';
        me.rectangle = rect;
        me.updateSelection();
      }
    }
  }, {
    key: "onElementMouseUp",
    value: function onElementMouseUp() {
      var me = this;

      if (typeof me.startX === 'number') {
        me.element && me.element.remove();
        me.client.element.classList.remove('b-dragselecting');
        me.startX = me.startY = null; // Navigator will react to the 'click' event which clears selection, bypass this with a short timeout

        me.setTimeout(function () {
          return me.client.navigator.disabled = false;
        }, 100);
      }
    }
  }, {
    key: "updateSelection",
    value: function updateSelection() {
      var me = this,
          renderedEventRects = me.eventRectangles,
          rectangle = me.rectangle;

      for (var i = 0, len = renderedEventRects.length; i < len; i++) {
        var eventData = renderedEventRects[i],
            shouldSelect = rectangle.intersect(eventData.rectangle, true);

        if (shouldSelect && !eventData.selected) {
          eventData.selected = true;
          me.client.selectEvent(eventData.record, true);
        } else if (!shouldSelect && eventData.selected) {
          eventData.selected = false;
          me.client.deselectEvent(eventData.record);
        }
      }
    }
  }], [{
    key: "$name",
    // region Init
    get: function get() {
      return 'EventDragSelect';
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onElementMouseDown', 'onElementMouseMove', 'onElementMouseUp']
      };
    }
  }]);

  return EventDragSelect;
}(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__["default"])(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]));


EventDragSelect._$name = 'EventDragSelect';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(EventDragSelect, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/EventEdit.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/feature/EventEdit.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventEdit; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.anchor */ "./node_modules/core-js/modules/es.string.anchor.js");
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _base_EditBase_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./base/EditBase.js */ "./lib/Scheduler/feature/base/EditBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _view_EventEditor_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../view/EventEditor.js */ "./lib/Scheduler/view/EventEditor.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_RecurringEventEdit_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./mixin/RecurringEventEdit.js */ "./lib/Scheduler/feature/mixin/RecurringEventEdit.js");
/* harmony import */ var _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _Scheduler_widget_ResourceCombo_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../Scheduler/widget/ResourceCombo.js */ "./lib/Scheduler/widget/ResourceCombo.js");
/* harmony import */ var _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");





























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_26___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';















/**
 * @module Scheduler/feature/EventEdit
 */

/**
 * Feature that displays a popup containing fields for editing event data.
 *
 *  {@inlineexample scheduler/EventEdit.js}
 *
 * To customize its contents you can:
 *
 * * Reconfigure built in widgets by providing override configs in the {@link Scheduler.feature.base.EditBase#config-items items} config.
 * * Change the date format of the date & time fields: {@link Scheduler.feature.base.EditBase#config-dateFormat dateFormat} and {@link Scheduler.feature.base.EditBase#config-timeFormat timeFormat}
 * * Configure provided fields in the editor and add your own in the {@link Scheduler.feature.base.EditBase#config-items items} config.
 * * Advanced: Reconfigure the whole editor widget using {@link #config-editorConfig}
 *
 * ## Built in fields
 *
 * The built in fields are:
 *
 * | Field ref              | Type      | Weight | Description                                                    |
 * |------------------------|-----------|--------|----------------------------------------------------------------|
 * | `nameField`            | TextField | 100    | Edit name                                                      |
 * | `resourceField`        | Combo     | 200    | Pick resource(s)                                               |
 * | `startDateField`       | DateField | 300    | Edit startDate (date part)                                     |
 * | `startTimeField`       | TimeField | 400    | Edit startDate (time part)                                     |
 * | `endDateField`         | DateField | 500    | Edit endDate (date part)                                       |
 * | `endTimeField`         | TimeField | 600    | Edit endDate (time part)                                       |
 * | `recurrenceCombo`      | Combo     | 700    | Select recurrence rule (only visible if recurrence is used)    |
 * | `editRecurrenceButton` | Button    | 800    | Edit the recurrence rule  (only visible if recurrence is used) |
 *
 * ## Removing a built in field
 *
 * To remove a built in field, specify its `ref` as `false` in the `items` config:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventEdit : {
 *             items : {
 *                 // Remove the start time field
 *                 startTimeField : false
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * ## Customizing a built in field
 *
 * To customize a built in field, use its `ref` as the key in the `items` config and specify the configs you want
 * to change (they will merge with the fields default configs):
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventEdit : {
 *             items : {
 *                 // ref for an existing field
 *                 nameField : {
 *                     // Change its label
 *                     label : 'Description'
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * ## Adding custom fields
 *
 * To add a custom field, add an entry to the `items` config. The `name` property links the input field to a field in
 * the loaded event record:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventEdit : {
 *             items : {
 *                 // Key to use as fields ref (for easier retrieval later)
 *                 color : {
 *                     type  : 'combo',
 *                     label : 'Color',
 *                     items : ['red', 'green', 'blue'],
 *                     // name will be used to link to a field in the event record when loading and saving in the editor
 *                     name  : 'eventColor'
 *                 }
 *             }
 *         }
 *     }
 * })
 * ```
 *
 * For more info on customizing the event editor, please see Guides/Customization/Customize event editor
 *
 * This feature is **enabled** by default
 *
 * @mixes Scheduler/feature/mixin/RecurringEventEdit
 * @extends Scheduler/feature/base/EditBase
 * @demo Scheduler/eventeditor
 * @classtype eventEdit
 */

var EventEdit = /*#__PURE__*/function (_EditBase$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_25___default()(EventEdit, _EditBase$mixin);

  var _super = _createSuper(EventEdit);

  function EventEdit() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_22___default()(this, EventEdit);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_23___default()(EventEdit, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(scheduler, config) {
      this.scheduler = scheduler; // Default to the scheduler's state, but configs may override

      this.readOnly = scheduler.readOnly;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(EventEdit.prototype), "construct", this).call(this, scheduler, config);

      scheduler.on({
        projectChange: 'onChangeProject',
        readOnly: 'onClientReadOnlyToggle',
        thisObj: this
      });
    } //endregion
    //region Editing

    /**
     * Get/set readonly state
     * @property {Boolean}
     */

  }, {
    key: "updateReadOnly",
    value: function updateReadOnly(readOnly) {
      if (this.editor) {
        this.editor.readOnly = readOnly;
      }
    }
  }, {
    key: "onClientReadOnlyToggle",
    value: function onClientReadOnlyToggle(_ref) {
      var readOnly = _ref.readOnly;
      this.readOnly = readOnly;
    }
    /**
     * Gets an editor instance. Creates on first call, reuses on consecutive
     * @internal
     * @returns {Core.widget.Popup} Editor popup
     */

  }, {
    key: "getEditor",
    value: function getEditor() {
      var _me$onEditorConstruct, _me$eventTypeField, _me$saveButton, _me$deleteButton, _me$cancelButton;

      var me = this;
      var editor = me.editor;

      if (editor) {
        return editor;
      }

      editor = me.editor = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_42__["default"].create(me.getEditorConfig()); // Must set *after* construction, otherwise it becomes the default state
      // to reset readOnly back to. Must use direct property access because
      // getter consults state of editor.

      editor.readOnly = me._readOnly;

      if (editor.items.length === 0) {
        console.warn('Event Editor configured without any `items`');
      } // add listeners programmatically so users cannot override them accidentally


      editor.on({
        beforehide: 'resetEditingContext',
        beforeshow: 'onBeforeEditorShow',
        keydown: 'onPopupKeyDown',
        thisObj: me
      });
      /**
       * Fired before the editor will load the event record data into its input fields. This is useful if you
       * want to modify the fields before data is loaded (e.g. set some input field to be readonly)
       * @event eventEditBeforeSetRecord
       * @param {Core.widget.Container} source The editor widget
       * @param {Scheduler.model.EventModel} record The record
       */

      this.scheduler.relayEvents(editor, ['beforeSetRecord'], 'eventEdit'); // assign widget variables, using widget name: startDate -> me.startDateField
      // widgets with id set use that instead, id -> me.idField

      Object.values(editor.widgetMap).forEach(function (widget) {
        var ref = widget.ref || widget.id; // don't overwrite if already defined

        if (ref && !me[ref]) {
          me[ref] = widget;

          switch (widget.name) {
            case 'startDate':
            case 'endDate':
              widget.on('change', me.onDatesChange, me);
              break;
          }
        }
      }); // launch onEditorConstructed hook if provided

      (_me$onEditorConstruct = me.onEditorConstructed) === null || _me$onEditorConstruct === void 0 ? void 0 : _me$onEditorConstruct.call(me, editor);
      (_me$eventTypeField = me.eventTypeField) === null || _me$eventTypeField === void 0 ? void 0 : _me$eventTypeField.on('change', me.onEventTypeChange, me);
      (_me$saveButton = me.saveButton) === null || _me$saveButton === void 0 ? void 0 : _me$saveButton.on('click', me.onSaveClick, me);
      (_me$deleteButton = me.deleteButton) === null || _me$deleteButton === void 0 ? void 0 : _me$deleteButton.on('click', me.onDeleteClick, me);
      (_me$cancelButton = me.cancelButton) === null || _me$cancelButton === void 0 ? void 0 : _me$cancelButton.on('click', me.onCancelClick, me);
      return me.editor;
    }
  }, {
    key: "getEditorConfig",
    value: function getEditorConfig() {
      var me = this,
          autoClose = me.autoClose,
          cls = me.cls,
          scheduler = me.scheduler;
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].assign({
        owner: scheduler,
        eventEditFeature: me,
        weekStartDay: me.weekStartDay,
        align: 'b-t',
        id: "".concat(scheduler.id, "-event-editor"),
        autoShow: false,
        anchor: true,
        scrollAction: 'realign',
        clippedBy: [scheduler.timeAxisSubGridElement, scheduler.bodyContainer],
        constrainTo: window,
        autoClose: autoClose,
        cls: cls
      }, me.editorConfig);
    } // Called from editEvent() to actually show the editor

  }, {
    key: "internalShowEditor",
    value: function internalShowEditor(eventRecord, resourceRecord) {
      var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var me = this,
          scheduler = me.scheduler,
          // Align to the element (b-sch-event) and not the wrapper
      eventElement = element || _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].down(scheduler.getElementFromEventRecord(eventRecord, resourceRecord), scheduler.eventInnerSelector); // Event not in current TimeAxis - cannot be edited without extending the TimeAxis.
      // If there's no event element and the eventRecord is not in the store, we still
      // edit centered on the Scheduler - we're adding a new event

      if (eventElement || !eventRecord.isPartOfStore(scheduler.eventStore)) {
        /**
         * Fires on the owning Scheduler before an event is displayed in an editor.
         * This may be listened for to allow an application to take over event editing duties. Returning `false`
         * stops the default editing UI from being shown.
         * @event beforeEventEdit
         * @param {Scheduler.view.Scheduler} source The scheduler
         * @param {Scheduler.feature.EventEdit} eventEdit The eventEdit feature
         * @param {Scheduler.model.EventModel} eventRecord The record about to be shown in the event editor.
         * @param {Scheduler.model.ResourceModel} resourceRecord The Resource record for the event. If the event
         * is being created, it will not contain a resource, so this parameter specifies the resource the
         * event is being created for.
         * @param {HTMLElement} eventElement The element which represents the event in the scheduler display.
         * @preventable
         */
        if (scheduler.trigger('beforeEventEdit', {
          eventEdit: me,
          eventRecord: eventRecord,
          resourceRecord: resourceRecord,
          eventElement: eventElement
        }) === false) {
          var _me$phantomEventEleme;

          scheduler.element.classList.remove('b-eventeditor-editing');
          (_me$phantomEventEleme = me.phantomEventElement) === null || _me$phantomEventEleme === void 0 ? void 0 : _me$phantomEventEleme.remove();
          me.phantomEventElement = null;
          return;
        }

        me.resourceRecord = resourceRecord;
        var editor = me.getEditor(eventRecord);
        me.editingContext = {
          eventRecord: eventRecord,
          resourceRecord: resourceRecord,
          eventElement: eventElement,
          editor: editor
        };
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(EventEdit.prototype), "internalShowEditor", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(EventEdit.prototype), "internalShowEditor", this).call(this, eventRecord, resourceRecord, element);

        if (me.typeField) {
          me.toggleEventType(eventRecord.get(me.typeField));
        } // raise flag indicating that we are editing an event


        me.isEditing = true;
        me.loadRecord(eventRecord, resourceRecord); // Honour alignment settings "anchor" and "centered" which may be injected from editorConfig.

        if (editor.centered || !editor.anchor) {
          editor.show();
        } else if (eventElement) {
          me.targetEventElement = eventElement;
          editor.showBy({
            target: eventElement,
            anchor: true
          });
        } // We are adding a new event. Display the editor centered in the Scheduler
        else {
            editor.showBy({
              target: scheduler.element,
              anchor: false,
              align: 'c-c'
            });
          } // Adjust time field step increment based on timeAxis resolution


        var timeResolution = scheduler.timeAxisViewModel.timeResolution;

        if (timeResolution.unit === 'hour' || timeResolution.unit === 'minute') {
          me.startTimeField.step = me.endTimeField.step = "".concat(timeResolution.increment).concat(timeResolution.unit);
        }
      }
    } // Fired in a listener so that it's after the auto-called onBeforeShow listeners so that
    // subscribers to the beforeEventEditShow are called at exactly the correct lifecycle point.

  }, {
    key: "onBeforeEditorShow",
    value: function onBeforeEditorShow() {
      /**
       * Fires on the owning Scheduler when the editor for an event is available but before it is populated with
       * data and shown. Allows manipulating fields etc.
       * @event beforeEventEditShow
       * @param {Scheduler.view.Scheduler} source The scheduler
       * @param {Scheduler.feature.EventEdit} eventEdit The eventEdit feature
       * @param {Scheduler.model.EventModel} eventRecord The record about to be shown in the event editor.
       * @param {Scheduler.model.ResourceModel} resourceRecord The Resource record for the event. If the event
       * is being created, it will not contain a resource, so this parameter specifies the resource the
       * event is being created for.
       * @param {HTMLElement} eventElement The element which represents the event in the scheduler display.
       * @param {Core.widget.Popup} editor The editor
       */
      this.scheduler.trigger('beforeEventEditShow', Object.assign({
        eventEdit: this
      }, this.editingContext));
    }
  }, {
    key: "updateTargetEventElement",
    value: function updateTargetEventElement(targetEventElement, oldTargetEventElement) {
      if (targetEventElement) {
        targetEventElement.classList.add('b-editing');
      }

      if (oldTargetEventElement) {
        oldTargetEventElement.classList.remove('b-editing');
      }
    }
    /**
     * Opens an editor for the passed event. This function is exposed on Scheduler and can be called as
     * `scheduler.editEvent()`.
     * @param {Scheduler.model.EventModel} eventRecord Event to edit
     * @param {Scheduler.model.ResourceModel} [resourceRecord] The Resource record for the event.
     * This parameter is needed if the event is newly created for a resource and has not been assigned, or when using
     * multi assignment.
     * @param {HTMLElement} [element] Element to anchor editor to (defaults to events element)
     */

  }, {
    key: "editEvent",
    value: function editEvent(eventRecord, resourceRecord) {
      var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var me = this;

      if (me.isEditing) {
        // old editing flow already running, clean it up
        me.resetEditingContext();
      }

      if (me.disabled) {
        return;
      } // The Promise being async allows a mouseover to trigger the event tip
      // unless we add the editing class immediately.


      me.scheduler.element.classList.add('b-eventeditor-editing'); // Implementations may be async, so the return value must always be propagated.

      return me.doEditEvent.apply(me, arguments);
    } // editEvent is the single entry point in the base class.
    // Subclass implementations of the action may differ, so are implemented in doEditEvent

  }, {
    key: "doEditEvent",
    value: function doEditEvent(eventRecord, resourceRecord) {
      var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var me = this,
          scheduler = me.scheduler,
          isNewRecord = !eventRecord.isOccurrence && scheduler.eventStore.indexOf(eventRecord) < 0;

      if (!resourceRecord) {
        // Need to handle resourceId for edge case when creating an event with resourceId and editing it before
        // adding it to the EventStore
        resourceRecord = eventRecord.resource || me.resourceStore.getById(eventRecord.resourceId);
      }

      if (isNewRecord) {
        // Assume ownership of the phantom element
        this.phantomEventElement = element; // Ensure temporal data fields are ready when the editor is shown

        _Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_38__["default"].prototype.normalize.call(eventRecord);
      } // If element is specified (call triggered by EventDragCreate)
      // Then we can align to that, and no scrolling is necessary.
      // If we are simply being asked to edit a new event which is not
      // yet added, the editor is centered, and no scroll is necessary


      if (element || isNewRecord) {
        me.internalShowEditor(eventRecord, resourceRecord, element);
      } else {
        // Ensure event is in view before showing the editor.
        // Note that we first need to extend the time axis to include
        // currently out of range events.
        scheduler.scrollResourceEventIntoView(resourceRecord, eventRecord, null, {
          animate: true,
          edgeOffset: 0,
          extendTimeAxis: false
        }).then(function () {
          return me.internalShowEditor(eventRecord, resourceRecord);
        }, function () {
          return scheduler.element.classList.remove('b-eventeditor-editing');
        });
      }
    }
    /**
     * Sets fields values from record being edited
     * @private
     */

  }, {
    key: "loadRecord",
    value: function loadRecord(eventRecord, resourceRecord) {
      this.loadingRecord = true;
      this.internalLoadRecord(eventRecord, resourceRecord);
      this.loadingRecord = false;
    }
  }, {
    key: "internalLoadRecord",
    value: function internalLoadRecord(eventRecord, resourceRecord) {
      var me = this,
          eventStore = me.client.eventStore,
          editor = me.editor;
      me.eventRecord = eventRecord;
      me.resourceRecord = resourceRecord;
      editor.record = eventRecord;

      if (me.resourceField) {
        var resources = eventStore.getResourcesForEvent(eventRecord); // Flag on parent Container to indicate that initially blank fields are valid

        editor._isSettingValues = true; // If this is an unassigned event, select the resource we've been provided

        if (!eventStore.storage.includes(eventRecord, true) && me.resourceRecord) {
          me.resourceField.value = me.resourceRecord[me.resourceField.valueField];
        } else if (me.assignmentStore) {
          me.resourceField.value = resources.map(function (resource) {
            return resource[me.resourceField.valueField];
          });
        }

        editor._isSettingValues = false;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_24___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_27___default()(EventEdit.prototype), "internalLoadRecord", this).call(this, eventRecord, resourceRecord);
    }
  }, {
    key: "toggleEventType",
    value: function toggleEventType(eventType) {
      // expose eventType in dataset, for querying and styling
      this.editor.element.dataset.eventType = eventType || '';
      this.editor.eachWidget(function (widget) {
        var _widget$dataset;

        // need {}'s here so we don't return false and end iteration
        ((_widget$dataset = widget.dataset) === null || _widget$dataset === void 0 ? void 0 : _widget$dataset.eventType) && (widget.hidden = widget.dataset.eventType !== eventType);
      });
    } //endregion
    //region Save

  }, {
    key: "finalizeEventSave",
    value: function () {
      var _finalizeEventSave = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_21___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_18___default.a.mark(function _callee(eventRecord, resourceRecords, resolve, reject) {
        var me, scheduler, eventStore, assignmentStore, element, _eventStore$assignEve, _eventStore$assignEve2, assignmentRecord;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_18___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this, scheduler = me.scheduler, eventStore = me.eventStore, assignmentStore = me.assignmentStore, element = me.phantomEventElement; // Prevent multiple commits from this flow

                assignmentStore.suspendAutoCommit(); // Avoid multiple redraws, from event changes + assignment changes

                scheduler.suspendRefresh();
                me.onBeforeSave(eventRecord);
                eventRecord.beginBatch();
                me.updateRecord(eventRecord);
                eventRecord.endBatch(); // Occurrences are ephemeral and never added to stores.

                if (eventRecord.isOccurrence) {
                  _context.next = 20;
                  break;
                }

                if (!(eventStore && !eventRecord.stores.length)) {
                  _context.next = 19;
                  break;
                }

                if (!(scheduler.trigger('beforeEventAdd', {
                  eventRecord: eventRecord,
                  resourceRecords: resourceRecords,
                  resources: resourceRecords
                }) !== false)) {
                  _context.next = 15;
                  break;
                }

                //  Add to eventStore first, then assign the resource. Order is necessary since assigning might
                // involve an AssignmentStore
                eventStore.add(eventRecord);
                _eventStore$assignEve = eventStore.assignEventToResource(eventRecord, resourceRecords), _eventStore$assignEve2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_19___default()(_eventStore$assignEve, 1), assignmentRecord = _eventStore$assignEve2[0];

                if (element) {
                  // If a filter was reapplied and filtered out the newly added event we need to clean up the drag proxy...
                  if (!me.eventStore.includes(eventRecord)) {
                    // Feels a bit strange having that responsibility here, but since it is already handled
                    element.remove();
                  } else {
                    // Hand it over to DomSync (to make sure it does not use any other previously released element,
                    // which would break the animation when transitioning from dragproxy -> event element)
                    _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_31__["default"].addChild(scheduler.foregroundCanvas, element, assignmentRecord.id);
                  }

                  me.phantomEventElement = null;
                }

                _context.next = 17;
                break;

              case 15:
                resolve(false);
                return _context.abrupt("return");

              case 17:
                _context.next = 20;
                break;

              case 19:
                eventStore.assignEventToResource(eventRecord, resourceRecords, true);

              case 20:
                _context.next = 22;
                return scheduler.project.commitAsync();

              case 22:
                assignmentStore.resumeAutoCommit(); // Redraw once

                scheduler.resumeRefresh(true);
                /**
                 * Fires on the owning Scheduler after an event is successfully saved
                 * @event afterEventSave
                 * @param {Scheduler.view.Scheduler} source The scheduler instance
                 * @param {Scheduler.model.EventModel} eventRecord The record about to be saved
                 */

                scheduler.trigger('afterEventSave', {
                  eventRecord: eventRecord
                });
                me.onAfterSave(eventRecord);
                resolve(eventRecord);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function finalizeEventSave(_x, _x2, _x3, _x4) {
        return _finalizeEventSave.apply(this, arguments);
      }

      return finalizeEventSave;
    }()
    /**
     * Saves the changes (applies them to record if valid, if invalid editor stays open)
     * @private
     * @fires beforeEventSave
     * @fires beforeEventAdd
     * @fires afterEventSave
     * @returns {Promise}
     * @async
     */

  }, {
    key: "save",
    value: function save() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var _me$resourceField;

        var me = _this,
            scheduler = me.scheduler,
            eventRecord = me.eventRecord;

        if (!eventRecord || !me.isValid) {
          resolve(false);
          return;
        }

        var eventStore = me.eventStore,
            values = me.values,
            resourceRecords = ((_me$resourceField = me.resourceField) === null || _me$resourceField === void 0 ? void 0 : _me$resourceField.records) || (me.resourceRecord ? [me.resourceRecord] : []),
            resourceRecord = resourceRecords[0]; // Check for potential overlap scenarios before saving. TODO needs to be indicated in the UI

        if (!me.scheduler.allowOverlap && eventStore) {
          var abort = resourceRecords.some(function (resource) {
            return !eventStore.isDateRangeAvailable(values.startDate, values.endDate, eventRecord, resource);
          });

          if (abort) {
            resolve(false);
            return;
          }
        }

        var context = {
          finalize: function finalize(saveEvent) {
            try {
              if (saveEvent !== false) {
                me.finalizeEventSave(eventRecord, resourceRecords, resolve, reject);
              } else {
                resolve(false);
              }
            } catch (e) {
              reject(e);
            }
          }
        };
        /**
         * Fires on the owning Scheduler before an event is saved
         * @event beforeEventSave
         * @param {Scheduler.view.Scheduler} source The scheduler instance
         * @param {Scheduler.model.EventModel} eventRecord The record about to be saved
         * @param {Scheduler.model.ResourceModel} resourceRecord [DEPRECATED IN FAVOR OF `resourceRecords`] The resource to which the event is assigned
         * @param {Scheduler.model.ResourceModel[]} resourceRecords The resources to which the event is assigned
         * @param {Object} values The new values
         * @param {Object} context Extended save context:
         * @param {Boolean} [context.async] Set this to `true` in a listener to indicate that the listener will asynchronously decide to prevent or not the event save.
         * @param {Function} context.finalize Function to call to finalize the save. Used when `async` is `true`. Provide `false` to the function to prevent the save.
         * @preventable
         */

        if (scheduler.trigger('beforeEventSave', {
          eventRecord: eventRecord,
          resourceRecords: resourceRecords,
          resourceRecord: resourceRecord,
          values: values,
          context: context
        }) !== false) {
          context.finalize();
        } // truthy context.async means than a listener will decide to approve saving asynchronously
        else if (!context.async) {
            resolve();
          }
      });
    } //endregion
    //region Delete

    /**
     * Delete event being edited
     * @returns {Promise}
     * @fires beforeEventDelete
     * @private
     * @async
     */

  }, {
    key: "deleteEvent",
    value: function deleteEvent() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var me = _this2,
            eventRecord = me.eventRecord,
            editor = me.editor;
        me.scheduler.removeRecords([eventRecord], function (removeRecord) {
          // The reason it does it here is to move focus *before* it gets deleted,
          // and then there's code in the delete to see that it's deleting the focused one,
          // and jump forwards or backwards to move to the next or previous event
          // See 'Should allow key activation' test in tests/view/mixins/EventNavigation.t.js
          if (removeRecord && editor.containsFocus) {
            editor.revertFocus();
          }

          resolve(removeRecord);
        });
      });
    } //endregion
    //region Stores

  }, {
    key: "onChangeProject",
    value: function onChangeProject(_ref2) {
      var project = _ref2.project;

      if (this.resourceField) {
        this.resourceField.store = project.resourceStore;
      }
    }
  }, {
    key: "onActivateEditor",
    //endregion
    //endregion
    //region Events
    value: function onActivateEditor(_ref3) {
      var eventRecord = _ref3.eventRecord,
          resourceRecord = _ref3.resourceRecord,
          eventElement = _ref3.eventElement;
      this.editEvent(eventRecord, resourceRecord, eventElement);
    }
  }, {
    key: "onDragCreateEnd",
    value: function onDragCreateEnd(_ref4) {
      var newEventRecord = _ref4.newEventRecord,
          resourceRecord = _ref4.resourceRecord,
          proxyElement = _ref4.proxyElement;
      var me = this;

      if (!me.disabled) {
        // Call scheduler template method
        me.scheduler.onEventCreated(newEventRecord); // Clone proxy after showing editor so it's not deleted

        var phantomEventElement = proxyElement.cloneNode(true);
        phantomEventElement.removeAttribute('id');
        proxyElement.parentElement.appendChild(phantomEventElement);
        me.editEvent(newEventRecord, resourceRecord, phantomEventElement);
      }
    } // chained from EventNavigation

  }, {
    key: "onEventEnterKey",
    value: function onEventEnterKey(_ref5) {
      var assignmentRecord = _ref5.assignmentRecord,
          eventRecord = _ref5.eventRecord,
          target = _ref5.target;
      var element = target.closest(this.client.eventInnerSelector);

      if (assignmentRecord) {
        this.editEvent(eventRecord, assignmentRecord.resource, element);
      } else if (eventRecord) {
        this.editEvent(eventRecord, eventRecord.resource, element);
      }
    } // Toggle fields visibility when changing eventType

  }, {
    key: "onEventTypeChange",
    value: function onEventTypeChange(_ref6) {
      var value = _ref6.value;
      this.toggleEventType(value);
    } //endregion
    //region Context menu

  }, {
    key: "populateEventMenu",
    value: function populateEventMenu(_ref7) {
      var _this3 = this;

      var eventRecord = _ref7.eventRecord,
          resourceRecord = _ref7.resourceRecord,
          items = _ref7.items;

      if (!this.scheduler.readOnly) {
        items.editEvent = {
          text: 'L{EventEdit.Edit event}',
          localeClass: this,
          icon: 'b-icon b-icon-edit',
          weight: 100,
          onItem: function onItem() {
            _this3.editEvent(eventRecord, resourceRecord);
          }
        };
      }
    } //endregion

  }, {
    key: "readOnly",
    get: function get() {
      return this.editor ? this.editor.readOnly : this._readOnly;
    }
  }, {
    key: "resourceStore",
    set: function set(store) {
      this._resourceStore = store;
    },
    get: function get() {
      return this.scheduler.project.resourceStore;
    }
  }, {
    key: "eventStore",
    get: function get() {
      return this.scheduler.project.eventStore;
    }
  }, {
    key: "assignmentStore",
    get: function get() {
      return this.scheduler.project.assignmentStore;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'EventEdit';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * The event that shall trigger showing the editor. Defaults to `eventdblclick`, set to `` or null to disable editing of existing events.
         * @config {String}
         * @default
         * @category Editor
         */
        triggerEvent: 'eventdblclick',

        /**
         * True to show a combo for picking resource:
         * ```javascript
         * const scheduler = new Scheduler({
         *    features : {
         *       eventEdit : {
         *           // Merged with the provided items
         *           // So we can override any config of any provided field.
         *          items : {
         *              resourceField : {
         *                  hidden : true
         *              }
         *           }
         *        }
         *     }
         * });
         * ```
         * @config {Boolean}
         * @default
         * @category Editor widgets
         * @deprecated 4.0.0 Configure using the `resourceField` property in the `items`
         * of {@link #config-editorConfig}
         */
        showResourceField: true,

        /**
         * Config for the resourceField constructor:
         * ```javascript
         * const scheduler = new Scheduler({
         *    features : {
         *       eventEdit : {
         *           // Merged with the provided items
         *           // So we can override any config of any provided field.
         *          items : {
         *              resourceField : {
         *                  label : 'Calendar
         *              }
         *           }
         *        }
         *     }
         * });
         * ```
         * @config {Object}
         * @category Editor widgets
         * @deprecated 4.0.0 Configure using the `resourceField` property in the `items`
         * of {@link #config-editorConfig}
         */
        resourceFieldConfig: null,

        /**
         * The data field in the model that defines the eventType.
         * Applied as class (b-eventtype-xx) to the editors element, to allow showing/hiding fields depending on
         * eventType. Dynamic toggling of fields in the editor is activated by adding an `eventTypeField` field to
         * your widget:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *    features : {
         *       eventEdit : {
         *           items : {
         *               eventTypeField : {
         *                  type  : 'combo',
         *                  name  : 'eventType',
         *                  label : 'Type',
         *                  items : ['Appointment', 'Internal', 'Meeting']
         *               }
         *           }
         *        }
         *     }
         * });
         * ```
         * Note, your event model class also must declare this field:
         * ```javascript
         *  class MyEvent extends EventModel {
         *      static get fields() {
         *          return [
         *              { name : 'eventType' }
         *          ];
         *      }
         *  }
         * ```
         * @config {String}
         * @default
         * @category Editor
         */
        typeField: 'eventType',

        /**
         * The current {@link Scheduler.model.EventModel} record, which is being edited by the event editor.
         * @property {Scheduler.model.EventModel}
         * @readonly
         */
        eventRecord: null,

        /**
         * Specify `true` to put the editor in read only mode.
         * @config {Boolean}
         * @default false
         */
        readOnly: null,

        /**
         * The configuration for the internal editor widget. With this config you can control the *type*
         * of editor (defaults to `Popup`) and which widgets to show,
         * change the items in the `bbar`, or change whether the popup should be modal etc.
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit  : {
         *             editorConfig : {
         *                 modal  : true,
         *                 cls    : 'my-editor' // A CSS class,
         *                 items  : {
         *                     owner : {
         *                         weight : -100, // Will sort above system-supplied fields which are weight 100 to 800
         *                         type   : 'usercombo',
         *                         name   : 'owner',
         *                         label  : 'Owner'
         *                     },
         *                     agreement : {
         *                         weight : 1000, // Will sort below system-supplied fields which are weight 100 to 800
         *                         type   : 'checkbox',
         *                         name   : 'agreement',
         *                         label  : 'Agree to terms'
         *                     }
         *                 },
         *                 bbar : {
         *                     items : {
         *                         deleteButton : {
         *                             hidden : true
         *                         }
         *                     }
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * Or to use your own custom editor:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit  : {
         *             editorConfig : {
         *                 type : 'myCustomEditorType'
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {Object}
         * @category Editor
         */
        editorConfig: {
          type: 'eventeditor',
          title: 'L{EventEdit.Edit event}',
          closable: true,
          localeClass: this,
          defaults: {
            localeClass: this
          },
          items: {
            /**
             * Reference to the name field, if used
             * @member {Core.widget.TextField} nameField
             * @readonly
             */
            nameField: {
              type: 'text',
              label: 'L{Name}',
              clearable: true,
              name: 'name',
              weight: 100,
              required: true
            },

            /**
             * Reference to the resource field, if used
             * @member {Core.widget.Combo} resourceField
             * @readonly
             */
            resourceField: {
              type: 'resourcecombo',
              label: 'L{Resource}',
              name: 'resource',
              editable: true,
              valueField: 'id',
              displayField: 'name',
              highlightExternalChange: false,
              weight: 200
            },

            /**
             * Reference to the start date field, if used
             * @member {Core.widget.DateField} startDateField
             * @readonly
             */
            startDateField: {
              type: 'date',
              cls: 'b-inline',
              clearable: false,
              required: true,
              label: 'L{Start}',
              name: 'startDate',
              flex: '1 0 60%',
              weight: 300
            },

            /**
             * Reference to the start time field, if used
             * @member {Core.widget.TimeField} startTimeField
             * @readonly
             */
            startTimeField: {
              type: 'time',
              clearable: false,
              required: true,
              name: 'startDate',
              cls: 'b-match-label',
              flex: '1 0 40%',
              weight: 400
            },

            /**
             * Reference to the end date field, if used
             * @member {Core.widget.DateField} endDateField
             * @readonly
             */
            endDateField: {
              type: 'date',
              cls: 'b-inline',
              clearable: false,
              required: true,
              label: 'L{End}',
              name: 'endDate',
              flex: '1 0 60%',
              weight: 500
            },

            /**
             * Reference to the end time field, if used
             * @member {Core.widget.TimeField} endTimeField
             * @readonly
             */
            endTimeField: {
              type: 'time',
              clearable: false,
              required: true,
              name: 'endDate',
              cls: 'b-match-label',
              flex: '1 0 40%',
              weight: 600
            }
          },
          bbar: {
            // When readOnly, child buttons are hidden
            hideWhenEmpty: true,
            defaults: {
              localeClass: this
            },
            items: {
              /**
               * Reference to the save button, if used
               * @member {Core.widget.Button} saveButton
               * @readonly
               */
              saveButton: {
                color: 'b-green',
                text: 'L{Save}',
                weight: 100
              },

              /**
               * Reference to the delete button, if used
               * @member {Core.widget.Button} deleteButton
               * @readonly
               */
              deleteButton: {
                color: 'b-gray',
                text: 'L{Delete}',
                weight: 200
              },

              /**
               * Reference to the cancel button, if used
               * @member {Core.widget.Button} cancelButton
               * @readonly
               */
              cancelButton: {
                color: 'b-gray',
                text: 'L{Object.Cancel}',
                weight: 300
              }
            }
          }
        },
        targetEventElement: null
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['populateEventMenu', 'onEventEnterKey'],
        assign: ['editEvent']
      };
    }
  }]);

  return EventEdit;
}(_base_EditBase_js__WEBPACK_IMPORTED_MODULE_28__["default"].mixin(_mixin_RecurringEventEdit_js__WEBPACK_IMPORTED_MODULE_35__["default"], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_34__["default"]));


EventEdit._$name = 'EventEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_29__["default"].registerFeature(EventEdit, true, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_29__["default"].registerFeature(EventEdit, false, 'SchedulerPro');
EventEdit.initClass();

/***/ }),

/***/ "./lib/Scheduler/feature/EventFilter.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/feature/EventFilter.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventFilter; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/feature/EventFilter
 */

/**
 * Adds event filter menu items to the timeline header context menu.
 *
 * This feature is **enabled** by default
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * let scheduler = new Scheduler({
 *   features : {
 *     eventFilter : true // `true` by default, set to `false` to disable the feature and remove the menu item from the timeline header
 *   }
 * });
 *
 * @classtype eventFilter
 * @externalexample scheduler/EventFilter.js
 */

var EventFilter = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(EventFilter, _InstancePlugin);

  var _super = _createSuper(EventFilter);

  function EventFilter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, EventFilter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(EventFilter, [{
    key: "construct",
    value: function construct(scheduler, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(EventFilter.prototype), "construct", this).call(this, scheduler, config);

      this.scheduler = scheduler;
    } // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/4.0.0.md for more information.

    /**
     * Populates the header context menu items.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     * @deprecated 4.0.0 Use `populateTimeAxisHeaderMenu` instead
     */

  }, {
    key: "populateHeaderMenu",
    value: function populateHeaderMenu(_ref) {
      var column = _ref.column,
          items = _ref.items;

      if (column.type !== 'timeAxis') {
        return;
      }

      this.populateTimeAxisHeaderMenu.apply(this, arguments);
    }
    /**
     * Populates the header context menu items.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateTimeAxisHeaderMenu",
    value: function populateTimeAxisHeaderMenu(_ref2) {
      var column = _ref2.column,
          items = _ref2.items;
      var me = this;
      items.eventsFilter = {
        text: 'L{filterEvents}',
        icon: 'b-fw-icon b-icon-filter',
        disabled: me.disabled,
        localeClass: this,
        weight: 100,
        menu: {
          type: 'popup',
          localeClass: this,
          items: {
            nameFilter: {
              weight: 110,
              type: 'textfield',
              cls: 'b-eventfilter b-last-row',
              clearable: true,
              keyStrokeChangeDelay: 300,
              label: 'L{byName}',
              localeClass: this,
              width: 200,
              listeners: {
                change: me.onEventFilterChange,
                thisObj: me
              }
            }
          },
          onBeforeShow: function onBeforeShow(_ref3) {
            var menu = _ref3.source;

            var _menu$items = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4___default()(menu.items, 1),
                filterByName = _menu$items[0],
                filter = me.scheduler.eventStore.filters.getBy('property', 'name');

            filterByName.value = filter && filter.value || '';
          }
        }
      };
    }
  }, {
    key: "onEventFilterChange",
    value: function onEventFilterChange(_ref4) {
      var value = _ref4.value;
      var me = this;

      if (value !== '') {
        me.scheduler.eventStore.filter('name', value);
      } else {
        me.scheduler.eventStore.removeFilter('name');
      }
    }
  }], [{
    key: "$name",
    // Plugin configuration. This plugin chains some of the functions in Grid.
    get: function get() {
      return 'EventFilter';
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['populateHeaderMenu', // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/4.0.0.md for more information.
        'populateTimeAxisHeaderMenu']
      };
    }
  }]);

  return EventFilter;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


EventFilter.featureClass = 'b-event-filter';
EventFilter._$name = 'EventFilter';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(EventFilter, true, ['Scheduler', 'Gantt']);

/***/ }),

/***/ "./lib/Scheduler/feature/EventMenu.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/feature/EventMenu.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventMenu; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./base/TimeSpanMenuBase.js */ "./lib/Scheduler/feature/base/TimeSpanMenuBase.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Scheduler/feature/EventMenu
 */

/**
 * Displays a context menu for events. Items are populated by other features and/or application code.
 *
 * ### Default event menu items
 *
 * Here is the list of menu items provided by the feature and populated by the other features:
 *
 * | Item reference  | Text           | Weight | Feature     | Enabled by default | Description                                                                                                                                |
 * |-----------------|----------------|--------|-------------|--------------------|--------------------------------------------------------------------------------------------------------------------------------------------|
 * | `editEvent`     | Edit event     | 100    | `EventEdit` | true               | Opens event editor for the selected event. Shown if the Scheduler is not read-only.                                                        |
 * | `deleteEvent`   | Delete event   | 200    | `EventMenu` | true               | Removes the selected event from the store. Shown if the Scheduler is not read-only.                                                        |
 * | `unassignEvent` | Unassign event | 300    | `EventMenu` | true               | Removes the selected resource assignment from the selected event. Shown in case of multi-assignment and if the Scheduler is not read-only. |
 *
 * ### Customizing the menu items
 *
 * The menu items in the Event menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * Add extra items for all events:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventMenu : {
 *             items : {
 *                 extraItem : {
 *                     text : 'Extra',
 *                     icon : 'b-fa b-fa-fw b-fa-flag',
 *                     onItem({eventRecord}) {
 *                         eventRecord.flagged = true;
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Remove existing items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventMenu : {
 *             items : {
 *                 deleteEvent   : false,
 *                 unassignEvent : false
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Customize existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventMenu : {
 *             items : {
 *                 deleteEvent : {
 *                     text : 'Delete booking'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Manipulate existing items for all events or specific events:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventMenu : {
 *             // Process items before menu is shown
 *             processItems({eventRecord, items}) {
 *                  // Push an extra item for conferences
 *                  if (eventRecord.type === 'conference') {
 *                      items.showSessionItem = {
 *                          text : 'Show sessions',
 *                          onItem({eventRecord}) {
 *                              // ...
 *                          }
 *                      };
 *                  }
 *
 *                  // Do not show menu for secret events
 *                  if (eventRecord.type === 'secret') {
 *                      return false;
 *                  }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the "Customizing the Event menu, the Schedule menu, and the TimeAxisHeader menu" guide.
 *
 * This feature is **enabled** by default
 *
 * @extends Scheduler/feature/base/TimeSpanMenuBase
 * @demo Scheduler/eventmenu
 * @classtype eventMenu
 */

var EventMenu = /*#__PURE__*/function (_TimeSpanMenuBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(EventMenu, _TimeSpanMenuBase);

  var _super = _createSuper(EventMenu);

  function EventMenu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, EventMenu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(EventMenu, [{
    key: "onElementKeyDown",
    //endregion
    //region Events

    /**
     * Fired from scheduler before the context menu is shown for an event. Allows manipulation of the items
     * to show in the same way as in `processItems`. Returning `false` from a listener prevents the menu from
     * being shown.
     * @event eventMenuBeforeShow
     * @preventable
     * @param {Scheduler.view.Scheduler} source
     * @param {Object} items Menu item configs
     * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
     * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */

    /**
     * Fired from scheduler when an item is selected in the context menu.
     * @event eventMenuItem
     * @param {Scheduler.view.Scheduler} source
     * @param {Core.widget.MenuItem} item
     * @param {Scheduler.model.EventModel} eventRecord
     * @param {Scheduler.model.ResourceModel} resourceRecord
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */

    /**
     * Fired from scheduler after showing the context menu for an event
     * @event eventMenuShow
     * @param {Scheduler.view.Scheduler} source
     * @param {Core.widget.Menu} menu The menu
     * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
     * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */
    //endregion
    value: function onElementKeyDown(event) {
      if (!event.handled && event.target.matches(this.client.eventSelector)) {
        if (event.key === ' ') {
          this.internalShowContextMenu(this.createContextMenuEventForElement(event.target));
        }
      }
    }
  }, {
    key: "getDataFromEvent",
    value: function getDataFromEvent(event) {
      var data = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(EventMenu.prototype), "getDataFromEvent", this).call(this, event),
          eventElement = data.targetElement,
          client = this.client,
          eventRecord = client.resolveEventRecord(eventElement),
          resourceRecord = eventRecord && (client.resolveResourceRecord(eventElement) || client.resourceStore.last),
          assignmentRecord = eventRecord && client.resolveAssignmentRecord(eventElement);

      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].assign(data, {
        eventElement: eventElement,
        eventRecord: eventRecord,
        resourceRecord: resourceRecord,
        assignmentRecord: assignmentRecord
      });
    }
  }, {
    key: "getTargetElementFromEvent",
    value: function getTargetElementFromEvent(_ref) {
      var target = _ref.target;
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(target, this.client.eventSelector) || target;
    }
  }, {
    key: "shouldShowMenu",
    value: function shouldShowMenu(eventParams) {
      return eventParams.eventRecord;
    }
    /**
     * Shows context menu for the provided event. If record is not rendered (outside of time span/filtered)
     * menu won't appear.
     * @param {Scheduler.model.EventModel} eventRecord Event record to show menu for.
     * @param {Object} [options]
     * @param {HTMLElement} options.targetElement Element to align context menu to.
     * @param {MouseEvent} options.event Browser event.
     * If provided menu will be aligned according to clientX/clientY coordinates.
     * If omitted, context menu will be centered to event element.
     */

  }, {
    key: "showContextMenuFor",
    value: function showContextMenuFor(eventRecord) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          targetElement = _ref2.targetElement,
          event = _ref2.event;

      if (this.disabled) {
        return;
      }

      if (!targetElement) {
        targetElement = this.getElementFromRecord(eventRecord); // If record is not rendered, do nothing

        if (!targetElement) {
          return;
        }
      }

      event = event || this.createContextMenuEventForElement(targetElement);
      this.internalShowContextMenu(event);
    }
  }, {
    key: "getElementFromRecord",
    value: function getElementFromRecord(record) {
      return this.client.getElementsFromEventRecord(record)[0];
    }
  }, {
    key: "populateEventMenu",
    value: function populateEventMenu(_ref3) {
      var items = _ref3.items;
      var client = this.client;

      if (!client.readOnly) {
        items.deleteEvent = {
          text: 'L{SchedulerBase.Delete event}',
          icon: 'b-icon b-icon-trash',
          weight: 200,
          onItem: function onItem(_ref4) {
            var _menu$focusInEvent;

            var menu = _ref4.menu,
                eventRecord = _ref4.eventRecord;
            // We must synchronously push focus back into the menu's triggering
            // event so that the our beforeRemove handlers can move focus onwards
            // to the closest remaining event.
            // Otherwise, the menu's default hide processing on hide will attempt
            // to move focus back to the menu's triggering event which will
            // by then have been deleted.
            var revertTarget = (_menu$focusInEvent = menu.focusInEvent) === null || _menu$focusInEvent === void 0 ? void 0 : _menu$focusInEvent.relatedTarget;

            if (revertTarget) {
              revertTarget.focus();
              client.navigator.activeItem = revertTarget;
            }

            client.removeRecords([eventRecord]);
          }
        };

        if (!client.eventStore.usesSingleAssignment) {
          items.unassignEvent = {
            text: 'L{SchedulerBase.Unassign event}',
            icon: 'b-icon b-icon-unassign',
            weight: 300,
            name: 'unassignEvent',
            onItem: function onItem(_ref5) {
              var _menu$focusInEvent2;

              var menu = _ref5.menu,
                  eventRecord = _ref5.eventRecord,
                  resourceRecord = _ref5.resourceRecord;
              // We must synchronously push focus back into the menu's triggering
              // event so that the our beforeRemove handlers can move focus onwards
              // to the closest remaining event.
              // Otherwise, the menu's default hide processing on hide will attempt
              // to move focus back to the menu's triggering event which will
              // by then have been deleted.
              var revertTarget = (_menu$focusInEvent2 = menu.focusInEvent) === null || _menu$focusInEvent2 === void 0 ? void 0 : _menu$focusInEvent2.relatedTarget;

              if (revertTarget) {
                revertTarget.focus();
                client.navigator.activeItem = revertTarget;
              }

              eventRecord.unassign(resourceRecord);
            }
          };
        }
      }
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'EventMenu';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        type: 'event'
        /**
         * This is a preconfigured set of items used to create the default context menu.
         *
         * The `items` provided by this feature are listed below. These are the property names which you may
         * configure in the feature's {@link Grid.feature.base.ContextMenuBase#config-items} config:
         *
         * - `deleteEvent` Deletes the context event.
         * - `unassignEvent` Unassigns the context event from the context resource.
         *
         * To remove existing items, set corresponding keys to `false`
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventMenu : {
         *             items : {
         *                 deleteEvent   : false,
         *                 unassignEvent : false
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * See the feature config in the above example for details.
         *
         * @config {Object} items
         */

      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      var config = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(EventMenu), "pluginConfig", this);

      config.chain.push('populateEventMenu');
      return config;
    }
  }]);

  return EventMenu;
}(_base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


EventMenu.featureClass = '';
EventMenu._$name = 'EventMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(EventMenu, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/EventResize.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/feature/EventResize.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventResize; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _base_ResizeBase_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./base/ResizeBase.js */ "./lib/Scheduler/feature/base/ResizeBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/ResizeHelper.js */ "./lib/Core/helper/ResizeHelper.js");
/* harmony import */ var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Prevent right click while resizing (do it in ResizeHelper?)
//TODO: Scroll





/**
 * @module Scheduler/feature/EventResize
 */

/**
 * Feature that allows resizing an event by dragging its end.
 *
 * By default it displays a tooltip with the new start and end dates, formatted using
 * {@link Scheduler/view/mixin/TimelineViewPresets#config-displayDateFormat}.
 *
 * This feature is **enabled** by default
 *
 * @extends Scheduler/feature/base/ResizeBase
 * @demo Scheduler/basic
 * @externalexample scheduler/EventResize.js
 * @classtype eventResize
 */

var EventResize = /*#__PURE__*/function (_ResizeBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(EventResize, _ResizeBase);

  var _super = _createSuper(EventResize);

  function EventResize() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, EventResize);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(EventResize, [{
    key: "createResizeHelper",
    value: function createResizeHelper() {
      var me = this,
          client = me.client;
      return new _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
        direction: client.isVertical ? 'vertical' : 'horizontal',
        name: me.constructor.$$name,
        // for debugging
        isElementResizable: function isElementResizable(el, event) {
          return me.isElementResizable(el, event);
        },
        targetSelector: client.eventSelector,
        handleContainerSelector: client.eventInnerSelector,
        resizingCls: 'b-sch-event-wrap-resizing',
        allowResize: me.isElementResizable.bind(me),
        outerElement: client.timeAxisSubGridElement,
        // constrain resize to view
        scrollManager: client.scrollManager,
        dragThreshold: 0,
        dynamicHandleSize: true,
        reservedSpace: 5,
        scroller: client.timeAxisSubGrid.scrollable,
        // allow reading correct x & y scroll
        listeners: {
          beforeresizestart: me.onBeforeResizeStart,
          resizestart: me.onResizeStart,
          resizing: me.onResizing,
          resize: me.onFinishResize,
          cancel: me.onCancelResize,
          thisObj: me
        }
      });
    } // Store used by ResizeBase to detect updates on dropped record

  }, {
    key: "getTimespanRecord",
    // Used by ResizeBase to get an eventRecord from the drag context
    value: function getTimespanRecord(context) {
      return context.eventRecord;
    }
  }, {
    key: "getRowRecord",
    value: function getRowRecord(context) {
      return context.resourceRecord;
    } // Injects Scheduler specific data into the drag context

  }, {
    key: "setupProductResizeContext",
    value: function setupProductResizeContext(context, event) {
      var scheduler = this.client,
          eventRecord = scheduler.resolveEventRecord(context.element),
          resourceRecord = scheduler.resolveResourceRecord(context.element);
      Object.assign(context, {
        eventRecord: eventRecord,
        resourceRecord: resourceRecord,
        dateConstraints: scheduler.getDateConstraints(resourceRecord, eventRecord)
      });
    }
  }, {
    key: "onResizeStart",
    value: function onResizeStart(_ref) {
      var context = _ref.context,
          event = _ref.event;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(EventResize.prototype), "onResizeStart", this).call(this, {
        context: context,
        event: event
      }); // Hide terminals when resizing starts


      if (this.client.features.dependencies) {
        this.client.features.dependencies.hideTerminals(context.element);
      } // Add resizing cls to inner element, as expected by styling


      context.element.querySelector('.b-sch-event').classList.add('b-sch-event-resizing');
    }
  }, {
    key: "checkValidity",
    value: function checkValidity(context, event) {
      return (this.client.allowOverlap || this.client.isDateRangeAvailable(context.startDate, context.endDate, context.eventRecord, context.resourceRecord)) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(EventResize.prototype), "checkValidity", this).call(this, context, event);
    }
  }, {
    key: "onFinishResize",
    value: function onFinishResize(_ref2) {
      var source = _ref2.source,
          context = _ref2.context,
          event = _ref2.event;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(EventResize.prototype), "onFinishResize", this).call(this, {
        source: source,
        context: context,
        event: event
      }); // When resizing is done successfully, mouse should be over element, so we show terminals


      if (this.client.features.dependencies) {
        this.client.features.dependencies.showTerminals(context.eventRecord, context.element);
      }
    }
  }, {
    key: "internalUpdateRecord",
    value: function () {
      var _internalUpdateRecord = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee(context, timespanRecord) {
        var generation;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                generation = timespanRecord.generation; // Special handling of occurrences, they need normalization since that is not handled by engine at the moment

                if (!timespanRecord.isOccurrence) {
                  _context.next = 5;
                  break;
                }

                timespanRecord.set(_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_16__["default"].prototype.inSetNormalize.call(timespanRecord, {
                  startDate: context.startDate,
                  endDate: context.endDate
                }));
                _context.next = 12;
                break;

              case 5:
                if (!(context.edge === 'left' || context.edge === 'top')) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return timespanRecord.setStartDate(context.startDate, false);

              case 8:
                _context.next = 12;
                break;

              case 10:
                _context.next = 12;
                return timespanRecord.setEndDate(context.endDate, false);

              case 12:
                if (!(timespanRecord.generation !== generation)) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", true);

              case 14:
                return _context.abrupt("return", false);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function internalUpdateRecord(_x, _x2) {
        return _internalUpdateRecord.apply(this, arguments);
      }

      return internalUpdateRecord;
    }()
  }, {
    key: "finalize",
    value: function finalize(updateRecord) {
      this.resize.context.element.querySelector('.b-sch-event').classList.remove('b-sch-event-resizing');

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(EventResize.prototype), "finalize", this).call(this, updateRecord);
    } //endregion

  }, {
    key: "store",
    get: function get() {
      return this.client.eventStore;
    }
  }], [{
    key: "$name",
    //region Events

    /**
     * Fired on the owning Scheduler before resizing starts. Return false to prevent operation
     * @event beforeEventResize
     * @param {Scheduler.model.EventModel} eventRecord
     * @param {Event} event
     */

    /**
     * Fires on the owning Scheduler when event resizing starts
     * @event eventResizeStart
     * @param {Scheduler.model.EventModel} eventRecord
     * @param {Event} event
     */

    /**
     * Fires on the owning Scheduler on each resize move event
     * @event eventPartialResize
     * @param {Scheduler.model.EventModel} eventRecord
     * @param {Date} startDate
     * @param {Date} endDate
     * @param {HTMLElement} element
     */

    /**
     * Fired on the owning Scheduler to allow implementer to prevent immediate finalization by setting `data.context.async = true`
     * in the listener, to show a confirmation popup etc
     * ```
     *  scheduler.on('beforeeventresizefinalize', ({context}) => {
     *      context.async = true;
     *      setTimeout(() => {
     *          // async code don't forget to call finalize
     *          context.finalize();
     *      }, 1000);
     *  })
     * ```
     * @event beforeEventResizeFinalize
     * @param {Object} data
     * @param {Scheduler.view.Scheduler} data.source Scheduler instance
     * @param {Object} data.context
     * @param {Boolean} data.context.async Set true to handle resize asynchronously (e.g. to wait for user
     * confirmation)
     * @param {Function} data.context.finalize Call this method to finalize resize. This method accepts one
     * argument: pass true to update records, or false, to ignore changes
     */

    /**
     * Fires on the owning Scheduler after the resizing gesture has finished.
     * @event eventResizeEnd
     * @param {Boolean} wasChanged
     * @param {Scheduler.model.EventModel} eventRecord
     */
    //endregion
    //region Scheduler specifics
    get: function get() {
      return 'EventResize';
    }
  }]);

  return EventResize;
}(_base_ResizeBase_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


EventResize._$name = 'EventResize';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(EventResize, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/EventTooltip.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/EventTooltip.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventTooltip; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./base/TooltipBase.js */ "./lib/Scheduler/feature/base/TooltipBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/feature/EventTooltip
 */

/**
 * Displays a tooltip when hovering events. The template used to render the tooltip can be customized, see {@link #config-template}.
 * Config options are also applied to the tooltip shown, see {@link Core.widget.Tooltip} for available options.
 *
 * ## Showing local data
 * To show a basic "local" tooltip (with data available in the Event record) upon hover:
 * ```javascript
 * new Scheduler({
 *   features : {
 *     eventTooltip : {
 *         // Tooltip configs can be used here
 *         align : 'l-r' // Align left to right,
 *         // A custom HTML template
 *         template : data => `<dl>
 *           <dt>Assigned to:</dt>
 *              <dt>Time:</dt>
 *              <dd>
 *                  ${DateHelper.format(data.eventRecord.startDate, 'LT')} - ${DateHelper.format(data.eventRecord.endDate, 'LT')}
 *              </dd>
 *              ${data.eventRecord.get('note') ? `<dt>Note:</dt><dd>${data.eventRecord.note}</dd>` : ''}
 *
 *              ${data.eventRecord.get('image') ? `<dt>Image:</dt><dd><img class="image" src="${data.eventRecord.get('image')}"/></dd>` : ''}
 *          </dl>
 *     }
 *   }
 * });
 * ```
 *
 * ## Showing remotely loaded data
 * Loading remote data into the event tooltip is easy. Simply use the {@link #config-template} and return a Promise which yields the content to show.
 * ```javascript
 * new Scheduler({
 *   features : {
 *     eventTooltip : {
 *        template : ({ eventRecord }) => AjaxHelper.get(`./fakeServer?name=${eventRecord.name}`).then(response => response.text())
 *     }
 *   }
 * });
 * ```
 * This feature is **enabled** by default
 *
 * By default, the tooltip {@link Core.widget.Widget#config-scrollAction realigns on scroll}
 * meaning that it will stay aligned with its target should a scroll interaction make the target move.
 *
 * If this is causing performance issues in a Scheduler, such as if there are many dozens of events
 * visible, you can configure this feature with `scrollAction: 'hide'`. This feature's configuration is
 * applied to the tooltip, so that will mean that the tooltip will hide if its target is moved by a
 * scroll interaction.
 *
 * @extends Scheduler/feature/base/TooltipBase
 * @demo Scheduler/basic
 * @externalexample scheduler/EventTooltip.js
 * @classtype eventTooltip
 */

var EventTooltip = /*#__PURE__*/function (_TooltipBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(EventTooltip, _TooltipBase);

  var _super = _createSuper(EventTooltip);

  function EventTooltip() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, EventTooltip);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(EventTooltip, [{
    key: "construct",
    //endregion
    value: function construct(client, config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(EventTooltip.prototype), "construct", this).call(this, client, config);

      if (typeof me.align === 'string') {
        me.align = {
          align: me.align
        };
      }
    }
  }, {
    key: "render",
    value: function render() {
      var me = this,
          dependencies = me.client.features.dependencies;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(EventTooltip.prototype), "render", this).call(this);

      if (dependencies) {
        var configuredOffset = me.align.offset;
        me.tooltip.on('beforeshow', function (_ref) {
          var tooltip = _ref.source;

          // Don't let dependency terminal interfere with this tooltip
          if (!dependencies.disabled) {
            tooltip.align.offset = [0, 10];
          } else {
            tooltip.align.offset = configuredOffset;
          }
        });
      }
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'EventTooltip';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * A function which receives data about the event and returns a string,
         * or a Promise yielding a string (for async tooltips), to be displayed in the tooltip.
         * This method will be called with an object containing the fields below
         * @param {Object} data
         * @param {Scheduler.model.EventModel} data.eventRecord
         * @param {Date} data.startDate
         * @param {Date} data.endDate
         * @param {String} data.startText
         * @param {String} data.endText
         * @config {Function} template
         */
        template: function template(data) {
          return "\n                ".concat(data.eventRecord.name ? "<div class=\"b-sch-event-title\">".concat(data.eventRecord.name, "</div>") : '', "\n                ").concat(data.startClockHtml, "\n                ").concat(data.endClockHtml);
        },
        cls: 'b-sch-event-tooltip'
      };
    }
  }]);

  return EventTooltip;
}(_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


EventTooltip._$name = 'EventTooltip';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(EventTooltip, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/GroupSummary.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/GroupSummary.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GroupSummary; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.trim */ "./node_modules/core-js/modules/es.string.trim.js");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _Grid_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Grid/feature/GroupSummary.js */ "./lib/Grid/feature/GroupSummary.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Scheduler/view/SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




 // Actions that trigger rerendering of group summary rows

var refreshActions = {
  add: 1,
  remove: 1,
  update: 1,
  removeAll: 1,
  filter: 1
};
/**
 * @module Scheduler/feature/GroupSummary
 */
// noinspection JSClosureCompilerSyntax

/**
 * A special version of the Grid GroupSummary feature that enables summaries within scheduler. To use a single summary
 * it is easiest to configure {@link #config-renderer}, for multiple summaries see {@link #config-summaries}.
 *
 * This feature is <strong>disabled</strong> by default. It is **not** supported in vertical mode.
 *
 * @extends Grid/feature/GroupSummary test
 *
 * @classtype groupSummary
 * @externalexample scheduler/GroupSummary.js
 * @demo Scheduler/groupsummary
 * @typings Grid/feature/GroupSummary -> Grid/feature/GridGroupSummary
 */

var GroupSummary = /*#__PURE__*/function (_GridGroupSummary) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default()(GroupSummary, _GridGroupSummary);

  var _super = _createSuper(GroupSummary);

  function GroupSummary() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, GroupSummary);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default()(GroupSummary, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(scheduler, config) {
      var me = this;

      if (scheduler.isVertical) {
        throw new Error('GroupSummary feature is not supported in vertical mode');
      }

      me.scheduler = scheduler;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(GroupSummary.prototype), "construct", this).call(this, scheduler, config);

      if (!me.summaries && me.renderer) {
        me.summaries = [{
          renderer: me.renderer
        }];
      }

      me.isScheduler = scheduler instanceof _Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_26__["default"];

      if (me.isScheduler) {
        scheduler.eventStore.on({
          change: me.onEventStoreChange,
          thisObj: me
        });
        scheduler.timeAxis.on({
          reconfigure: me.onTimeAxisChange,
          thisObj: me
        });
        scheduler.timeAxisViewModel.on({
          update: me.onTimeAxisChange,
          thisObj: me
        });
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      if (this._tip) {
        this._tip.destroy();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(GroupSummary.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Events

  }, {
    key: "onTimeAxisChange",
    value: function onTimeAxisChange() {
      this.rerenderGroupSummaries();
    }
  }, {
    key: "onEventStoreChange",
    value: function onEventStoreChange(_ref) {
      var action = _ref.action;

      // Scheduler does minimal update on event changes, it will not rerender the summary rows.
      // Need to handle that here
      if (refreshActions[action]) {
        this.rerenderGroupSummaries();
      }
    }
  }, {
    key: "rerenderGroupSummaries",
    value: function rerenderGroupSummaries() {
      // TODO: Sort out the affected rows by checking events resources
      this.scheduler.rowManager.rows.forEach(function (row) {
        if (row.isGroupFooter) {
          row.render();
        }
      });
    } //endregion
    //region Render

    /**
     * Called before rendering row contents, used to reset rows no longer used as group summary rows
     * @private
     */

  }, {
    key: "onBeforeRenderRow",
    value: function onBeforeRenderRow(_ref2) {
      var row = _ref2.row,
          record = _ref2.record;

      if (row.isGroupFooter && !record.meta.hasOwnProperty('groupFooterFor')) {
        var timeaxisCell = row.elements.normal.querySelector('.b-sch-timeaxis-cell'); // remove summary cells if exist

        if (timeaxisCell) {
          timeaxisCell.innerHTML = '';
        }
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(GroupSummary.prototype), "onBeforeRenderRow", this).apply(this, arguments);
    }
    /**
     * Called by parent class to fill timeaxis with summary contents. Generates tick "cells" and populates them with
     * summaries.
     * ```
     * <div class="b-timeaxis-group-summary">
     *     <div class="b-timeaxis-tick">
     *         <div class="b-timeaxix-summary-value">x</div>
     *         ...
     *     </div>
     *     ...
     * </div>
     * ```
     * @private
     */

  }, {
    key: "generateHtml",
    value: function generateHtml(column, records, cls) {
      // TODO: Use DOM config object instead of strings
      if (column.type === 'timeAxis') {
        var me = this,
            scheduler = me.scheduler,
            tickSize = scheduler.tickSize;
        var html = '';

        if (scheduler.isEngineReady) {
          scheduler.timeAxis.forEach(function (tick) {
            var // events for current tick
            events = scheduler.eventStore.getEvents({
              startDate: tick.startDate,
              endDate: tick.endDate,
              allowPartial: true,
              onlyAssigned: true
            }),
                // filter those events to current groups
            groupEvents = events.filter(function (event) {
              return event.resources.some(function (resource) {
                return records.includes(resource);
              });
            }); // TODO: could turn this into a template

            var sumHtml = me.summaries.map(function (config) {
              // summary renderer used to calculate and format value
              var value = config.renderer({
                startDate: tick.startDate,
                endDate: tick.endDate,
                eventStore: scheduler.eventStore,
                resourceStore: scheduler.resourceStore,
                events: groupEvents
              });
              return "<div class=\"b-timeaxis-summary-value\">".concat(value, "</div>");
            }).join('');
            html += "<div class=\"b-timeaxis-tick\" style=\"width: ".concat(tickSize, "px\">").concat(sumHtml, "</div>");
          });
        }

        return "<div class=\"b-timeaxis-group-summary\">".concat(html, "</div>");
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(GroupSummary.prototype), "generateHtml", this).call(this, column, records, cls);
    }
    /**
     * Overrides parents function to return correct summary count, used when sizing row
     * @private
     */

  }, {
    key: "updateSummaryHtml",
    value: function updateSummaryHtml(cellElement, column, records) {
      var count = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(GroupSummary.prototype), "updateSummaryHtml", this).call(this, cellElement, column, records);

      if (column.type === 'timeAxis') {
        var result = {
          count: 0,
          height: 0
        };
        this.summaries.forEach(function (config) {
          if (config.height) {
            result.height += config.height;
          } else {
            result.count++;
          }
        });
        return result;
      }

      return count;
    }
    /**
     * Generates tooltip contents for hovered summary tick
     * @private
     */

  }, {
    key: "getTipHtml",
    value: function getTipHtml(_ref3) {
      var activeTarget = _ref3.activeTarget;
      var me = this,
          index = Array.from(activeTarget.parentElement.children).indexOf(activeTarget),
          tick = me.scheduler.timeAxis.getAt(index);
      var tipHtml = "<header>".concat(me.L('L{Summary.Summary for}', me.scheduler.getFormattedDate(tick.startDate)), "</header>"),
          showTip = false;
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].forEachSelector(activeTarget, '.b-timeaxis-summary-value', function (element, i) {
        var label = me._labels[i],
            text = element.innerText.trim();
        tipHtml += "<label>".concat(label || '', "</label><div class=\"b-timeaxis-summary-value\">").concat(text, "</div>");
        if (element.innerHTML) showTip = true;
      });
      return showTip ? tipHtml : null;
    }
    /**
     * Initialize tooltip on render
     * @private
     */

  }, {
    key: "render",
    value: function render() {
      var me = this,
          scheduler = me.scheduler;

      if (me.isScheduler) {
        // if any sum config has a label, init tooltip
        if (me.summaries && me.summaries.some(function (config) {
          return config.label;
        }) && me.showTooltip && !me._tip) {
          me._labels = me.summaries.map(function (config) {
            return config.label || '';
          });
          me._tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_25__["default"]({
            id: "".concat(scheduler.id, "-groupsummary-tip"),
            cls: 'b-timeaxis-summary-tip',
            hoverDelay: 0,
            hideDelay: 0,
            forElement: scheduler.timeAxisSubGridElement,
            anchorToTarget: true,
            forSelector: '.b-timeaxis-group-summary .b-timeaxis-tick',
            clippedBy: [scheduler.timeAxisSubGridElement, scheduler.bodyContainer],
            getHtml: me.getTipHtml.bind(me)
          });
        }
      }
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'GroupSummary';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Show tooltip containing summary values and labels
         * @config {Boolean}
         * @default
         */
        showTooltip: true,

        /**
         * Array of summary configs, with format
         * `[{ label: 'Label', renderer : ({startDate, endDate, eventStore, resourceStore, events, element}) }]`.
         * @config {Object[]}
         */
        summaries: null,

        /**
         * Easier way to configure when using a single summary. Accepts a renderer function with the format specified
         * in {@link #config-summaries}
         * @config {Function}
         */
        renderer: null
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['render']
      };
    }
  }]);

  return GroupSummary;
}(_Grid_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_22__["default"]); // Override Grids GroupSummary with this improved version



GroupSummary._$name = 'GroupSummary';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_24__["default"].registerFeature(GroupSummary, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/HeaderContextMenu.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/feature/HeaderContextMenu.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HeaderContextMenu; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/widget/Slider.js */ "./lib/Core/widget/Slider.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';









/**
 * @module Scheduler/feature/HeaderContextMenu
 */

/**
 * **DEPRECATED: This class is deprecated since v4.0.0,
 * use {@link Scheduler.feature.TimeAxisHeaderMenu TimeAxisHeaderMenu} feature instead.**
 *
 * Adds scheduler specific menu items to the timeline header context menu.
 *
 * This feature is **disabled** by default in favor of `TimeAxisHeaderMenu`.
 *
 * @extends Core/mixin/InstancePlugin
 * @classtype headerContextMenu
 * @deprecated 4.0.0
 * @classtype headerContextMenu
 */

var HeaderContextMenu = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(HeaderContextMenu, _InstancePlugin);

  var _super = _createSuper(HeaderContextMenu);

  function HeaderContextMenu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, HeaderContextMenu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(HeaderContextMenu, [{
    key: "construct",
    value: function construct(scheduler, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(HeaderContextMenu.prototype), "construct", this).call(this, scheduler, config);

      this.scheduler = scheduler;
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].deprecate('Scheduler', '5.0.0', '`HeaderContextMenu` feature is deprecated, in favor of `TimeAxisHeaderMenu` feature. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.'); // If this feature is enabled, need to disable TimeAxisHeaderMenu. They are mutually exclusive.

      if (scheduler.features.timeAxisHeaderMenu) {
        scheduler.features.timeAxisHeaderMenu.disabled = true;
      } // By default this feature works based on ContextMenu feature.
      // In case new HeaderMenu feature is used, need to make sure it shows menu for timeAxis too


      if (scheduler.features.headerMenu) {
        scheduler.features.headerMenu._showForTimeAxis = true;
      }
    }
    /**
     * Populates the TimeAxis header context menu items.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateHeaderMenu",
    value: function populateHeaderMenu(_ref) {
      var column = _ref.column,
          items = _ref.items,
          menu = _ref.menu;
      var me = this;

      if (column.type !== 'timeAxis') {
        return;
      }

      if (menu) {
        // the TimeAxis's context menu probably will cause scrolls because it manipulates the dates.
        // The menu should not hide on scroll when for a TimeAxisColumn
        menu.scrollAction = 'realign';
      }

      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].merge(items, me.defaultItems);
      var arrayOfItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].transformNamedObjectToArray(items);

      if (me.extraItems) {
        arrayOfItems.push.apply(arrayOfItems, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(me.extraItems));
      }

      if (me.processItems) {
        me.processItems({
          items: arrayOfItems
        });
      }

      var namedItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].transformArrayToNamedObject(arrayOfItems); // replace items in original object with the new items

      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].removeAllProperties(items);
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].merge(items, namedItems);
    }
  }, {
    key: "onZoomSliderChange",
    value: function onZoomSliderChange(_ref2) {
      var value = _ref2.value;
      this.scheduler.zoomLevel = value;
    }
  }, {
    key: "initDates",
    value: function initDates() {
      var me = this;
      me.startDateField.suspendEvents();
      me.endDateField.suspendEvents(); // The actual scheduler start dates may include time, but our Date field cannot currently handle
      // a time portion and throws it away, so when we need the value from an unchanged field, we need
      // to use the initialValue set from the timeAxis values.
      // Until our DateField can optionally include a time value, this is the solution.

      me.startDateField.value = me.startDateFieldInitialValue = me.scheduler.startDate;
      me.endDateField.value = me.endDateFieldInitialValue = me.scheduler.endDate;
      me.startDateField.resumeEvents();
      me.endDateField.resumeEvents();
    }
  }, {
    key: "onRangeDateFieldChange",
    value: function onRangeDateFieldChange(_ref3) {
      var source = _ref3.source;
      var me = this,
          startDateChanged = source === me.startDateField,
          client = me.client,
          timeAxis = client.timeAxis,
          startDate = me.startDateFieldInitialValue && !startDateChanged ? me.startDateFieldInitialValue : me.startDateField.value;
      var endDate = me.endDateFieldInitialValue && startDateChanged ? me.endDateFieldInitialValue : me.endDateField.value; // When either of the fields is changed, we no longer use its initialValue from the timeAxis start or end
      // so that gets nulled to indicate that it's unavailable and the real field value is to be used.

      if (startDateChanged) {
        me.startDateFieldInitialValue = null;
      } else {
        me.endDateFieldInitialValue = null;
      } // Because the start and end dates are exclusive, avoid a zero
      // length time axis by incrementing the end by one tick unit
      // if they are the same.


      if (!(endDate - startDate)) {
        endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].add(endDate, timeAxis.shiftIncrement, timeAxis.shiftUnit);
      } // if start date got bigger than end date set end date to start date plus one tick
      else if (endDate < startDate) {
          endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].add(startDate, timeAxis.shiftIncrement, timeAxis.shiftUnit);
        }

      client.preserveViewCenter(function () {
        return client.timeAxis.setTimeSpan(startDate, endDate);
      });
      me.initDates();
    }
  }, {
    key: "onLeftShiftBtnClick",
    value: function onLeftShiftBtnClick() {
      var me = this;
      me.scheduler.timeAxis.shiftPrevious();
      me.initDates();
    }
  }, {
    key: "onTodayBtnClick",
    value: function onTodayBtnClick() {
      var me = this,
          today = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].clearTime(new Date());
      me.scheduler.timeAxis.setTimeSpan(today, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].add(today, 1, 'day'));
      me.initDates();
    }
  }, {
    key: "onRightShiftBtnClick",
    value: function onRightShiftBtnClick() {
      var me = this;
      me.scheduler.timeAxis.shiftNext();
      me.initDates();
    }
  }, {
    key: "defaultItems",
    get: function get() {
      var me = this,
          scheduler = me.scheduler,
          timeAxis = scheduler.timeAxis,
          dateStep = {
        magnitude: timeAxis.shiftIncrement,
        unit: timeAxis.shiftUnit
      },
          items = {};
      items.pickZoomLevel = {
        text: 'L{pickZoomLevel}',
        localeClass: this,
        icon: 'b-fw-icon b-icon-search-plus',
        disabled: !scheduler.presets.count || me.disabled,
        menu: {
          type: 'popup',
          items: [{
            type: 'slider',
            showValue: false,
            listeners: {
              input: me.onZoomSliderChange,
              thisObj: me
            },
            // set width for IE11
            minWidth: 130
          }],
          onBeforeShow: function onBeforeShow(_ref4) {
            var menu = _ref4.source;

            var _menu$items = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default()(menu.items, 1),
                zoom = _menu$items[0];

            zoom.min = scheduler.minZoomLevel;
            zoom.max = scheduler.maxZoomLevel;
            zoom.value = scheduler.zoomLevel;
          }
        }
      };
      me.startDateField = new _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
        label: me.L('L{startText}'),
        labelWidth: '6em',
        required: true,
        step: dateStep,
        listeners: {
          change: me.onRangeDateFieldChange,
          thisObj: me
        }
      });
      me.endDateField = new _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
        label: me.L('L{endText}'),
        labelWidth: '6em',
        required: true,
        step: dateStep,
        listeners: {
          change: me.onRangeDateFieldChange,
          thisObj: me
        }
      });
      items.activeDateRange = {
        text: 'L{activeDateRange}',
        localeClass: this,
        icon: 'b-fw-icon b-icon-calendar',
        disabled: me.disabled,
        menu: {
          type: 'popup',
          width: '20em',
          items: [me.startDateField, me.endDateField, {
            type: 'button',
            cls: 'b-left-nav-btn',
            icon: 'b-icon b-icon-prev',
            color: 'b-blue b-raised',
            flex: 1,
            margin: 0,
            listeners: {
              click: me.onLeftShiftBtnClick,
              thisObj: me
            }
          }, {
            type: 'button',
            cls: 'b-today-nav-btn',
            color: 'b-blue b-raised',
            text: 'L{todayText}',
            localeClass: this,
            flex: 4,
            margin: '0 8',
            listeners: {
              click: me.onTodayBtnClick,
              thisObj: me
            }
          }, {
            type: 'button',
            cls: 'b-right-nav-btn',
            icon: 'b-icon b-icon-next',
            color: 'b-blue b-raised',
            flex: 1,
            listeners: {
              click: me.onRightShiftBtnClick,
              thisObj: me
            }
          }],
          onBeforeShow: function onBeforeShow() {
            return me.initDates();
          }
        }
      };
      return items;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'HeaderContextMenu';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * An array of additional items to add to the menu
         * @config {Object[]}
         * @default
         */
        extraItems: null,

        /**
         * A function called before displaying the menu that allows manipulations of its items. Called with a
         * single parameter with format { eventRecord, resourceRecord, eventElement, items }.
         *
         * ```javascript
         * features : {
         *     headerContextMenu : {
         *         processItems({ items }) {
         *             // Add or remove items here as needed
         *             items.push({ text: 'Some action', icon : 'b-fa b-fa-fw b-fa-ban' })
         *         }
         *     }
         * }
         * ```
         *
         * @config {Function}
         */
        processItems: null
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['populateHeaderMenu']
      };
    }
  }]);

  return HeaderContextMenu;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


HeaderContextMenu.featureClass = '';
HeaderContextMenu._$name = 'HeaderContextMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(HeaderContextMenu);

/***/ }),

/***/ "./lib/Scheduler/feature/HeaderZoom.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/feature/HeaderZoom.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HeaderZoom; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/feature/HeaderZoom
 */

/**
 * Enables users to click and drag to zoom to a date range in Scheduler's header time axis.
 *
 * This feature is **disabled** by default.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * let scheduler = new Scheduler({
 *   features : {
 *     headerZoom : true
 *   }
 * });
 *
 * @classtype headerZoom
 * @externalexample scheduler/HeaderZoom.js
 */

var HeaderZoom = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(HeaderZoom, _InstancePlugin);

  var _super = _createSuper(HeaderZoom);

  function HeaderZoom() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, HeaderZoom);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(HeaderZoom, [{
    key: "onElementMouseDown",
    value: function onElementMouseDown(event) {
      var me = this,
          scheduler = me.client; // only react to mouse input, and left button

      if (event.touches || event.button !== 0 || me.disabled) {
        return;
      } // only react to mousedown directly on timeaxis cell


      if (event.target.matches('.b-sch-header-timeaxis-cell')) {
        var headerEl = scheduler.subGrids.normal.header.headersElement;
        me.startX = event.clientX;
        me.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].createElement({
          parent: headerEl,
          tag: 'div',
          className: 'b-headerzoom-rect'
        });
        me.headerElementRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(headerEl);
      }
    }
  }, {
    key: "onElementMouseMove",
    value: function onElementMouseMove(event) {
      var me = this; // Synthetic mousemove event has no button for IE11
      // Detect if a mouseup happened outside our element (or browser window for that matter). Note 'buttons' is not supported by Safari

      if (event.buttons === 0 && !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isSafari && (!_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isIE11 || event.isTrusted)) {
        me.onElementMouseUp(event);
        return;
      }

      if (typeof me.startX === 'number') {
        var x = Math.max(event.clientX, me.headerElementRect.left),
            left = Math.min(me.startX, x),
            width = Math.abs(me.startX - x),
            rect = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"](left - me.headerElementRect.x + me.client.scrollLeft, 0, width, me.headerElementRect.height);
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].setTranslateX(me.element, rect.left);
        me.element.style.width = rect.width + 'px';
      }
    }
  }, {
    key: "onElementMouseUp",
    value: function onElementMouseUp(event) {
      var me = this;

      if (typeof me.startX === 'number') {
        var timeline = me.client,
            rect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(me.element),
            startDate = timeline.getDateFromCoordinate(rect.left, 'round', false),
            endDate = timeline.getDateFromCoordinate(rect.right, 'round', false);
        me.element && me.element.remove();
        me.startX = null;
        me.client.zoomToSpan({
          startDate: startDate,
          endDate: endDate
        });
      }
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'HeaderZoom';
    } // Plugin configuration. This plugin chains some of the functions in Scheduler.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onElementMouseDown', 'onElementMouseMove', 'onElementMouseUp']
      };
    }
  }]);

  return HeaderZoom;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


HeaderZoom._$name = 'HeaderZoom';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(HeaderZoom, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/Labels.js":
/*!*****************************************!*\
  !*** ./lib/Scheduler/feature/Labels.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Labels; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_has__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.has */ "./node_modules/core-js/modules/es.reflect.has.js");
/* harmony import */ var core_js_modules_es_reflect_has__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_has__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");






















function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/feature/Labels
 */

var sides = ['top', 'left', 'right', 'bottom'],
    editorAlign = {
  top: 'b-b',
  right: 'l-l',
  bottom: 't-t',
  left: 'r-r'
},
    topBottom = {
  top: 1,
  bottom: 1
};
/**
 * Displays labels at positions {@link #config-top}, {@link #config-right}, {@link #config-bottom} and {@link #config-left}.
 *
 * Text in labels can be set from a field on the {@link Scheduler.model.EventModel EventModel}
 * or the {@link Scheduler.model.ResourceModel ResourceModel} or using a custom renderer.
 *
 * Since `top` and `bottom` labels occupy space that would otherwise be used by the event we recommend using bigger rowHeights
 * (>55px for both labels with default styling) and zero barMargins because `top`/`bottom` labels give space around events anyway.
 *
 * This feature is **disabled** by default. It is **not** supported in vertical mode.
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/labels
 * @externalexample scheduler/Labels.js
 * @classtype labels
 */

var Labels = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(Labels, _InstancePlugin);

  var _super = _createSuper(Labels);

  function Labels() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default()(this, Labels);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default()(Labels, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(scheduler, config) {
      var me = this;

      if (scheduler.isVertical) {
        throw new Error('Labels feature is not supported in vertical mode');
      }

      me.scheduler = scheduler;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Labels.prototype), "construct", this).call(this, scheduler, config);

      if (me.top || me.bottom || me.left || me.right) {
        me.updateHostClasslist(); // rowHeight warning, not in use
        //const labelCount = !!me.topLabel + !!me.bottomLabel;
        //if (scheduler.rowHeight < 60 - labelCount * 12) console.log('')
      }
    }
  }, {
    key: "updateHostClasslist",
    value: function updateHostClasslist() {
      var top = this.top,
          bottom = this.bottom,
          classList = this.scheduler.element.classList;
      classList.remove('b-labels-topbottom');
      classList.remove('b-labels-top');
      classList.remove('b-labels-bottom'); // OR is correct. This means that there are labels above OR below.

      if (top || bottom) {
        classList.add('b-labels-topbottom');

        if (top) {
          classList.add('b-labels-top');
        }

        if (bottom) {
          classList.add('b-labels-bottom');
        }
      }
    }
  }, {
    key: "onLabelDblClick",
    value: function onLabelDblClick(event) {
      var me = this,
          target = event.target;

      if (target && !me.scheduler.readOnly) {
        var side = target.dataset.side,
            labelConfig = me[side],
            editor = labelConfig.editor,
            field = labelConfig.field;

        if (editor) {
          var eventRecord = this.scheduler.resolveEventRecord(event.target);

          if (!(editor instanceof _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_25__["default"])) {
            labelConfig.editor = new _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_25__["default"]({
              appendTo: me.scheduler.element,
              blurAction: me.blurAction,
              inputField: editor,
              scrollAction: 'realign'
            });
          }

          labelConfig.editor.startEdit({
            target: target,
            align: editorAlign[side],
            matchSize: false,
            record: eventRecord,
            field: field
          });
          event.stopImmediatePropagation();
          return false;
        }
      }
    }
  }, {
    key: "processLabelSpec",
    value: function processLabelSpec(labelSpec, side) {
      if (typeof labelSpec === 'function') {
        labelSpec = {
          renderer: labelSpec
        };
      } else if (typeof labelSpec === 'string') {
        labelSpec = {
          field: labelSpec
        };
      } // Allow us to mutate ownProperties in the labelSpec without mutating outside object
      else if (labelSpec) {
          labelSpec = Object.setPrototypeOf({}, labelSpec);
        } else {
          return;
        }

      var scheduler = this.scheduler,
          eventStore = scheduler.eventStore,
          resourceStore = scheduler.resourceStore,
          taskStore = scheduler.taskStore,
          id = scheduler.id,
          _labelSpec = labelSpec,
          field = _labelSpec.field,
          editor = _labelSpec.editor; // If there are milestones, and we are changing the available height
      // either by adding a top/bottom label, or adding a top/bottom label
      // then during the next dependency refresh, milestone width must be recalculated.

      if (topBottom[side]) {
        scheduler.milestoneWidth = null;
      }

      if (eventStore && !taskStore) {
        labelSpec.recordType = 'event';
      } else {
        labelSpec.recordType = 'task';
      } // Find the field definition or property from whichever store and cache the type.


      if (field) {
        var fieldDef,
            fieldFound = false;

        if (eventStore && !taskStore) {
          fieldDef = eventStore.modelClass.fieldMap[field];

          if (fieldDef) {
            labelSpec.fieldDef = fieldDef;
            labelSpec.recordType = 'event';
            fieldFound = true;
          } // Check if it references a property
          else if (Reflect.has(eventStore.modelClass.prototype, field)) {
              labelSpec.recordType = 'event';
              fieldFound = true;
            }
        }

        if (!fieldDef && taskStore) {
          fieldDef = taskStore.modelClass.fieldMap[field];

          if (fieldDef) {
            labelSpec.fieldDef = fieldDef;
            labelSpec.recordType = 'task';
            fieldFound = true;
          } // Check if it references a property
          else if (Reflect.has(resourceStore.modelClass.prototype, field)) {
              labelSpec.recordType = 'task';
              fieldFound = true;
            }
        }

        if (!fieldDef && resourceStore) {
          fieldDef = resourceStore.modelClass.fieldMap[field];

          if (fieldDef) {
            labelSpec.fieldDef = fieldDef;
            labelSpec.recordType = 'resource';
            fieldFound = true;
          } // Check if it references a property
          else if (Reflect.has(resourceStore.modelClass.prototype, field)) {
              labelSpec.recordType = 'resource';
              fieldFound = true;
            }
        }

        if (editor) {
          if (typeof editor === 'boolean') {
            scheduler.editor = {
              type: 'textfield'
            };
          } else if (typeof editor === 'string') {
            scheduler.editor = {
              type: editor
            };
          }

          _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].on({
            element: scheduler.timeAxisSubGrid.element,
            delegate: '.b-sch-label',
            dblclick: 'onLabelDblClick',
            thisObj: this
          });
        }
      }

      return labelSpec;
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Labels.prototype), "doDisable", this).call(this, disable);

      if (this.client.isPainted) {
        this.client.refresh();
      }
    } //endregion

  }, {
    key: "onEventDataGenerated",
    value: function onEventDataGenerated(data) {
      var me = this;

      if (!me.disabled) {
        // Insert all configured labels
        var _iterator = _createForOfIteratorHelper(sides),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var side = _step.value;

            if (me[side]) {
              var _className;

              var _me$side = me[side],
                  field = _me$side.field,
                  fieldDef = _me$side.fieldDef,
                  recordType = _me$side.recordType,
                  renderer = _me$side.renderer,
                  thisObj = _me$side.thisObj,
                  domConfig = {
                tag: 'label',
                className: (_className = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_className, me.labelCls, 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_className, "".concat(me.labelCls, "-").concat(side), 1), _className),
                dataset: {
                  side: side,
                  taskFeature: "label-".concat(side)
                }
              };
              var value = void 0;
              var eventRecordProperty = "".concat(recordType, "Record"),
                  eventRecord = data[eventRecordProperty]; // If there's a renderer, use that by preference

              if (renderer) {
                var _renderer$call;

                value = renderer.call(thisObj || me.thisObj || me, (_renderer$call = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_renderer$call, eventRecordProperty, eventRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_renderer$call, "resourceRecord", data.resourceRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_renderer$call, "assignmentRecord", data.assignmentRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_renderer$call, "domConfig", domConfig), _renderer$call));
              } else {
                value = eventRecord[field]; // If it's a date, format it according to the Scheduler's defaults

                if (fieldDef && fieldDef.type === 'date' && !renderer) {
                  value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].format(value, me.client.displayDateFormat);
                }
              }

              domConfig.html = value || '\xa0';
              data.wrapperChildren.push(domConfig);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "top",
    set: function set(top) {
      this._top = this.processLabelSpec(top, 'top');
      this.updateHostClasslist();
    },
    get: function get() {
      return this._top;
    }
  }, {
    key: "right",
    set: function set(right) {
      this._right = this.processLabelSpec(right, 'right');
      this.updateHostClasslist();
    },
    get: function get() {
      return this._right;
    }
  }, {
    key: "bottom",
    set: function set(bottom) {
      this._bottom = this.processLabelSpec(bottom, 'bottom');
      this.updateHostClasslist();
    },
    get: function get() {
      return this._bottom;
    }
  }, {
    key: "left",
    set: function set(left) {
      this._left = this.processLabelSpec(left, 'left');
      this.updateHostClasslist();
    },
    get: function get() {
      return this._left;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Labels';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * CSS class to apply to label elements
         * @config {String}
         * @default
         */
        labelCls: 'b-sch-label',

        /**
         * Top label configuration object. May contain the following properties:
         * @param {String} field The name of a field in one of the associated records,
         *   {@link Scheduler.model.EventModel EventModel} or {@link Scheduler.model.ResourceModel ResourceModel}.
         *   The record from which the field value is drawn will be ascertained by checking for field definitions by
         *   the specified name.
         * @param {Function} renderer A function, which when passed an object containing `eventRecord`,
         *   `resourceRecord`, `assignmentRecord` and `domConfig` properties, returns the HTML to display as the
         *   label
         * @param {Object} thisObj The `this` reference to use in the `renderer`.
         * @param {Object|Core.widget.Field} editor If the label is to be editable, a field configuration object
         *   with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to
         *   work**.
         * @config {Object}
         * @default
         */
        top: null,

        /**
         * Right label configuration object. May contain the following properties:
         * @param {String} field The name of a field in one of the associated records,
         *   {@link Scheduler.model.EventModel EventModel} or {@link Scheduler.model.ResourceModel ResourceModel}.
         *   The record from which the field value is drawn will be ascertained by checking for field definitions by
         *   the specified name.
         * @param {Function} renderer A function, which when passed an object containing `eventRecord`,
         *   `resourceRecord`, `assignmentRecord` and `domConfig` properties, returns the HTML to display as the
         *   label
         * @param {Object} thisObj The `this` reference to use in the `renderer`.
         * @param {Object|Core.widget.Field} editor If the label is to be editable, a field configuration object
         *   with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to
         *   work**.
         * @config {Object}
         * @default
         */
        right: null,

        /**
         * Bottom label configuration object. May contain the following properties:
         * @param {String} field The name of a field in one of the associated records,
         *   {@link Scheduler.model.EventModel EventModel} or {@link Scheduler.model.ResourceModel ResourceModel}.
         *   The record from which the field value is drawn will be ascertained by checking for field definitions by
         *   the specified name.
         * @param {Function} renderer A function, which when passed an object containing `eventRecord`,
         *   `resourceRecord`, `assignmentRecord` and `domConfig` properties, returns the HTML to display as the
         *   label
         * @param {Object} thisObj The `this` reference to use in the `renderer`.
         * @param {Object|Core.widget.Field} editor If the label is to be editable, a field configuration object
         *   with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to
         *   work**.
         * @config {Object}
         * @default
         */
        bottom: null,

        /**
         * Left label configuration object. May contain the following properties:
         * @param {String} field The name of a field in one of the associated records,
         *   {@link Scheduler.model.EventModel EventModel} or {@link Scheduler.model.ResourceModel ResourceModel}.
         *   The record from which the field value is drawn will be ascertained by checking for field definitions by
         *   the specified name.
         * @param {Function} renderer A function, which when passed an object containing `eventRecord`,
         *   `resourceRecord`, `assignmentRecord` and `domConfig` properties, returns the HTML to display as the
         *   label
         * @param {Object} thisObj The `this` reference to use in the `renderer`.
         * @param {Object|Core.widget.Field} editor If the label is to be editable, a field configuration object
         *   with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to
         *   work**.
         * @config {Object}
         * @default
         */
        left: null,
        thisObj: null,

        /**
         * What action should be taken when focus moves leaves the cell editor, for example when clicking outside.
         * May be `'complete'` or `'cancel`'.
         * @config {String}
         * @default
         */
        blurAction: 'cancel'
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onEventDataGenerated']
      };
    }
  }]);

  return Labels;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_21__["default"]); // TODO: Refactor the SASS, so that the auto-generated class name of ''b-' + cls.name.toLowerCase() can be used.



Labels.featureClass = 'b-sch-labels';
Labels._$name = 'Labels';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_22__["default"].registerFeature(Labels, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/NonWorkingTime.js":
/*!*************************************************!*\
  !*** ./lib/Scheduler/feature/NonWorkingTime.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NonWorkingTime; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./AbstractTimeRanges.js */ "./lib/Scheduler/feature/AbstractTimeRanges.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Scheduler/feature/NonWorkingTime
 */

/**
 * Feature that allows styling of weekends (and other non working time) by adding timeRanges for those days.
 *
 * By default, Schedulers calendar is empty. When enabling this feature for the basic Scheduler, it injects weekend
 * intervals if no intervals are encountered (saturday and sunday).
 *
 * Please note that the feature does not render ranges smaller than the base unit used by the time axis
 * and for some levels it bails out rendering ranges completely (see {@link #config-maxTimeAxisUnit} for details).
 *
 * This feature is **disabled** by default for Scheduler, but **enabled** by default for Scheduler Pro.
 *
 * @extends Scheduler/feature/AbstractTimeRanges
 * @demo Scheduler/configuration
 * @externalexample scheduler/NonWorkingTime.js
 * @classtype nonWorkingTime
 */

var NonWorkingTime = /*#__PURE__*/function (_AbstractTimeRanges$m) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(NonWorkingTime, _AbstractTimeRanges$m);

  var _super = _createSuper(NonWorkingTime);

  function NonWorkingTime() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, NonWorkingTime);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(NonWorkingTime, [{
    key: "doDestroy",
    //endregion
    //region Init & destroy
    value: function doDestroy() {
      this.attachToCalendar(null);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(NonWorkingTime.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Project

  }, {
    key: "attachToProject",
    value: function attachToProject(project) {
      var _this = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(NonWorkingTime.prototype), "attachToProject", this).call(this, project);

      this.attachToCalendar(project.effectiveCalendar);
      project.on({
        name: 'project',
        calendarChange: function calendarChange() {
          return _this.attachToCalendar(_this.project.effectiveCalendar);
        },
        thisObj: this
      });
    } //endregion
    //region TimeAxisViewModel

  }, {
    key: "onTimeAxisViewModelUpdate",
    value: function onTimeAxisViewModelUpdate() {
      this._timeAxisUnitDurationMs = null;
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(NonWorkingTime.prototype), "onTimeAxisViewModelUpdate", this).call(this);
    } //endregion
    //region Calendar

  }, {
    key: "attachToCalendar",
    value: function attachToCalendar(calendar) {
      var me = this,
          project = me.project,
          client = me.client;
      me.detachListeners('calendar');

      if (calendar) {
        if ( // For basic scheduler...
        !client.isSchedulerPro && !client.isGantt && // ...that uses the default calendar...
        calendar === project.defaultCalendar && // ...and has no defined intervals
        !project.defaultCalendar.intervalStore.count) {
          // Add weekends as non-working time
          calendar.addIntervals([{
            recurrentStartDate: 'on Sat at 0:00',
            recurrentEndDate: 'on Mon at 0:00',
            isWorking: false
          }]);
        }

        calendar.intervalStore.on({
          name: 'calendar',
          change: me.renderRanges,
          delay: 1,
          thisObj: me
        });
      } // On changing calendar we react to a data level event which is triggered after project refresh.
      // Redraw right away


      if (client.isEngineReady) {
        me.renderRanges();
      } // Initially there is no guarantee we are ready to draw, wait for refresh
      else if (!project.isDestroyed) {
          project.on({
            refresh: me.renderRanges,
            thisObj: me,
            once: true
          });
        }
    }
  }, {
    key: "shouldRenderRange",
    value: function shouldRenderRange(range) {
      // if the range is longer or equal than one timeAxis unit then render it
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(NonWorkingTime.prototype), "shouldRenderRange", this).call(this, range) && range.durationMS >= this.timeAxisUnitDurationMs;
    }
  }, {
    key: "renderRanges",
    value: function renderRanges() {
      var me = this,
          store = me.store,
          calendar = me.calendar,
          _me$client = me.client,
          timeAxis = _me$client.timeAxis,
          foregroundCanvas = _me$client.foregroundCanvas; // if not too early (project correctly set up yet etc)

      if (calendar && foregroundCanvas && store && !store.isDestroyed) {
        if (!me.disabled) {
          // checks if we should render ranges for the current zoom level
          var shouldPaint = !me.maxTimeAxisUnit || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].compareUnits(timeAxis.unit, me.maxTimeAxisUnit) <= 0;
          store.removeAll(true);

          if (calendar && me.highlightWeekends && shouldPaint && timeAxis.count) {
            var timeRanges = calendar.getNonWorkingTimeRanges(timeAxis.startDate, timeAxis.endDate).map(function (r, i) {
              return {
                name: r.name,
                cls: 'b-nonworkingtime',
                startDate: r.startDate,
                endDate: r.endDate
              };
            });
            var timeRangesMerged = [];
            var prevRange; // intervals returned by the calendar are not merged ..let's combine them

            timeRanges.forEach(function (range) {
              if (prevRange && range.startDate <= prevRange.endDate && range.name === prevRange.name) {
                prevRange.endDate = range.endDate;
              } else {
                timeRangesMerged.push(range);
                range.id = "nonworking-".concat(timeRangesMerged.length);
                prevRange = range;
              }
            });
            store.add(timeRangesMerged, true);
          }
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(NonWorkingTime.prototype), "renderRanges", this).call(this);
      }
    } //endregion

  }, {
    key: "calendar",
    get: function get() {
      var _this$project;

      return (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.effectiveCalendar;
    } //endregion
    //region Draw

  }, {
    key: "timeAxisUnitDurationMs",
    get: function get() {
      // calculate and cache duration of the timeAxis unit in milliseconds
      if (!this._timeAxisUnitDurationMs) {
        this._timeAxisUnitDurationMs = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].as('ms', 1, this.client.timeAxis.unit);
      }

      return this._timeAxisUnitDurationMs;
    }
  }], [{
    key: "$name",
    //region Default config
    get: function get() {
      return 'NonWorkingTime';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Set to `true` to highlight non working periods of time
         * @config {Boolean}
         * @default
         */
        highlightWeekends: true,
        showHeaderElements: true,
        showLabelInBody: true,
        cls: 'b-sch-nonworkingtime',

        /**
         * The maximum time axis unit to display non working ranges for.
         * Allows to filter out zoom levels on which the feature should not render.
         * @config {Boolean}
         * @default
         */
        maxTimeAxisUnit: 'week'
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onPaint', 'attachToProject']
      };
    }
  }]);

  return NonWorkingTime;
}(_AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_13__["default"].mixin(_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_16__["default"]));


NonWorkingTime._$name = 'NonWorkingTime';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(NonWorkingTime, false, 'Scheduler');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(NonWorkingTime, true, 'SchedulerPro');
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(NonWorkingTime, true, 'Gantt');

/***/ }),

/***/ "./lib/Scheduler/feature/Pan.js":
/*!**************************************!*\
  !*** ./lib/Scheduler/feature/Pan.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Pan; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _base_DragBase_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./base/DragBase.js */ "./lib/Scheduler/feature/base/DragBase.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Scheduler/feature/Pan
 */

/**
 * Makes the scheduler's timeline pannable by dragging with the mouses.
 *
 * This feature is **disabled** by default.
 *
 * **NOTE:** Incompatible with {@link Scheduler.feature.EventDragCreate EventDragCreate} feature.
 *
 * @extends Core/mixin/InstancePlugin
 *
 * @example
 * // enable Pan
 * let scheduler = new Scheduler({
 *   features : {
 *     pan : true,
 *     eventDragCreate : false
 *   }
 * });
 *
 * @classtype pan
 */

var Pan = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Pan, _InstancePlugin);

  var _super = _createSuper(Pan);

  function Pan() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Pan);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Pan, [{
    key: "construct",
    value: function construct(timeline, config) {
      this.timeline = timeline;

      if (timeline.features.eventDragCreate && !timeline.features.eventDragCreate.disabled) {
        throw new Error('Cannot combine Pan and eventDragCreate features');
      }

      var targetSelectors = ['.b-grid-cell', '.b-timeline-subgrid'];
      this.targetSelector = targetSelectors.join(',');

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Pan.prototype), "construct", this).call(this, timeline, config);
    } //endregion
    //region Plugin config
    // Plugin configuration. This plugin chains some of the functions in Scheduler.

  }, {
    key: "onElementMouseDown",
    //endregion
    value: function onElementMouseDown(event) {
      var me = this,
          timeline = me.timeline,
          dragFeature = Object.values(timeline.features).find(function (feature) {
        return feature instanceof _base_DragBase_js__WEBPACK_IMPORTED_MODULE_15__["default"];
      }),
          enablePanOnEvents = timeline.readOnly || !dragFeature || dragFeature.disabled; // only react to mouse input, and left button

      if (event.touches || event.button !== 0 || me.disabled) {
        return;
      } // only react to mousedown directly on grid cell, subgrid element or if drag is disabled - the events too


      if (event.target.matches(me.targetSelector) || enablePanOnEvents && event.target.closest(timeline.eventSelector)) {
        me.mouseX = event.clientX;
        me.mouseY = event.clientY;
      }
    }
  }, {
    key: "onElementMouseMove",
    value: function onElementMouseMove(event) {
      var me = this; // Synthetic mousemove event has no button for IE11
      // Detect if a mouseup happened outside our element (or browser window for that matter). Note 'buttons' is not supported by Safari

      if (event.buttons === 0 && !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isSafari && (!_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isIE11 || event.isTrusted)) {
        me.onElementMouseUp();
        return;
      }

      if (typeof me.mouseX === 'number') {
        var xScroller = me.timeline.subGrids.normal.scrollable,
            yScroller = me.timeline.scrollable,
            x = event.clientX,
            y = event.clientY;
        event.preventDefault();

        if (me.vertical) {
          yScroller.scrollBy(0, me.mouseY - y);
        }

        xScroller.scrollBy(me.mouseX - x);
        me.mouseX = x;
        me.mouseY = y;
      }
    }
  }, {
    key: "onElementMouseUp",
    value: function onElementMouseUp(event) {
      this.mouseX = this.mouseY = null;
    } //endregion

  }], [{
    key: "$name",
    // region Init
    get: function get() {
      return 'Pan';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Set to false to only pan horizontally
         * @config {Boolean}
         * @default
         */
        vertical: true
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onElementMouseDown', 'onElementMouseMove', 'onElementMouseUp']
      };
    }
  }]);

  return Pan;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_12__["default"]);


Pan._$name = 'Pan';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_13__["default"].registerFeature(Pan, false, ['Scheduler', 'Gantt']);

/***/ }),

/***/ "./lib/Scheduler/feature/ResourceTimeRanges.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/feature/ResourceTimeRanges.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRanges; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _base_ResourceTimeRangesBase_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./base/ResourceTimeRangesBase.js */ "./lib/Scheduler/feature/base/ResourceTimeRangesBase.js");
/* harmony import */ var _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../data/ResourceTimeRangeStore.js */ "./lib/Scheduler/data/ResourceTimeRangeStore.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/feature/ResourceTimeRanges
 */

/**
 * Feature that draws resource time ranges, shaded areas displayed behind events. These zones are similar to events in
 * that they have a start and end date but different in that they do not take part in the event layout and they always
 * occupy full row height.
 *
 * Each time range is represented by an instances of {@link Scheduler.model.ResourceTimeRangeModel}, held in a
 * {@link Scheduler.data.ResourceTimeRangeStore}. Currently the they are readonly UI-wise, but can be manipulated on
 * the data level. To style the rendered elements, use the {@link Scheduler.model.TimeSpan#field-cls cls} field or use the {@link Scheduler.model.ResourceTimeRangeModel#field-timeRangeColor} field.
 *
 * Data can be provided either using the {@link #config-store} config:
 *
 * ```javascript
 * new Scheduler({
 *   features :  {
 *       resourceTimeRanges : {
 *          store : new Scheduler.data.ResourceTimeRangeStore({
 *              readUrl : './resourceTimeRanges/'
 *          })
 *       }
 *   }
 * })
 * ```
 *
 * or the `resourceTimeRanges` config on the Scheduler config object:
 *
 * ```javascript
 * new Scheduler({
 *   features :  {
 *       resourceTimeRanges : true
 *   },
 *
 *   // Data specified directly on the Scheduler instance
 *   resourceTimeRanges : [
 *     // Either specify startDate & endDate or startDate & duration when defining a range
 *     { startDate : new Date(2019,0,1), endDate : new Date(2019,0,3), name : 'Occupied', timeRangeColor : 'red' },
 *     { startDate : new Date(2019,0,3), duration : 2, durationUnit : 'd', name : 'Available' },
 *   ]
 * })
 * ```
 *
 * This feature is **disabled** by default
 *
 * @extends Scheduler/feature/base/ResourceTimeRangesBase
 * @demo Scheduler/resourcetimeranges
 * @externalexample scheduler/ResourceTimeRanges.js
 * @classtype resourceTimeRanges
 */

var ResourceTimeRanges = /*#__PURE__*/function (_ResourceTimeRangesBa) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ResourceTimeRanges, _ResourceTimeRangesBa);

  var _super = _createSuper(ResourceTimeRanges);

  function ResourceTimeRanges() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ResourceTimeRanges);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ResourceTimeRanges, [{
    key: "attachToProject",
    //endregion
    //region Init
    value: function attachToProject(project) {
      var me = this,
          scheduler = me.scheduler;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ResourceTimeRanges.prototype), "attachToProject", this).call(this, project);

      if (!project.resourceTimeRangeStore) {
        project.resourceTimeRangeStore = me._store || scheduler.resourceTimeRangeStore || new _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_12__["default"]();
        var crudManager = scheduler.crudManager;

        if (crudManager && !crudManager.resourceTimeRangeStore) {
          crudManager.resourceTimeRangeStore = project.resourceTimeRangeStore;
        }
      }

      var store = project.resourceTimeRangeStore;

      if (!me.exposedOnScheduler) {
        // ResourceZones can be set on scheduler or feature, for convenience
        if (scheduler.resourceTimeRanges) {
          store.add(scheduler.resourceTimeRanges);
          delete scheduler.resourceTimeRanges;
        } // expose getter/setter for resourceTimeRanges on scheduler


        Object.defineProperty(scheduler, 'resourceTimeRanges', {
          get: function get() {
            return store.records;
          },
          set: function set(resourceTimeRanges) {
            return store.data = resourceTimeRanges;
          }
        });
        Object.defineProperty(scheduler, 'resourceTimeRangeStore', {
          get: function get() {
            return store;
          }
        });
        me.exposedOnScheduler = true;
      } // Link to projects resourceStore if not already linked to one


      if (!store.resourceStore) {
        store.resourceStore = project.resourceStore;
      }

      me.detachListeners('store');
      store.on({
        name: 'store',
        change: me.onStoreChange,
        thisObj: me
      });
    }
    /**
     * Called during construction to do product specific store setup
     * @private
     */

  }, {
    key: "getEventsToRender",
    //endregion
    // Called on render of resources events to get events to render. Add any ranges
    // (chained function from Scheduler)
    value: function getEventsToRender(resource, events) {
      if (resource.timeRanges && resource.timeRanges.length && !this.disabled) {
        events.push.apply(events, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default()(resource.timeRanges));
      }

      return events;
    }
  }, {
    key: "shouldInclude",
    value: function shouldInclude(eventRecord) {
      return eventRecord.isResourceTimeRange && !eventRecord.isNonWorking;
    }
  }, {
    key: "store",
    set: function set(store) {
      // For backwards compatibility, we now want the store on the project
      this._store = store;
    },
    get: function get() {
      return this.project.resourceTimeRangeStore;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ResourceTimeRanges';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        idPrefix: 'resourcetimerange',
        rangeCls: 'b-sch-resourcetimerange',

        /**
         * Store that holds resource time ranges (using ResourceTimeRangeModel or subclass thereof). A store will be
         * automatically created if none is specified
         * @config {Scheduler.data.ResourceTimeRangeStore}
         * @deprecated 4.0 Define `resourceTimeRangeStore` on Scheduler or its project
         */
        store: false,

        /**
         * Time range definitions (data to ResourceTimeRangeModels). Will be added to store. Can also be specified
         * on Scheduler for convenience
         * @config {Scheduler.model.ResourceTimeRangeModel[]|Object[]}
         * @deprecated 4.0 Define `resourceTimeRanges` on Scheduler or `resourceTimeRangesData` on its project
         */
        resourceTimeRanges: null
      };
    }
  }]);

  return ResourceTimeRanges;
}(_base_ResourceTimeRangesBase_js__WEBPACK_IMPORTED_MODULE_11__["default"]); // No feature based styling needed, do not add a cls to Scheduler



ResourceTimeRanges.featureClass = '';
ResourceTimeRanges._$name = 'ResourceTimeRanges';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(ResourceTimeRanges, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/ScheduleContextMenu.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/feature/ScheduleContextMenu.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleContextMenu; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Scheduler/feature/ScheduleMenu.js */ "./lib/Scheduler/feature/ScheduleMenu.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/feature/ScheduleContextMenu
 */

/**
 * **DEPRECATED: This class is deprecated since v4.0.0,
 * use {@link Scheduler.feature.ScheduleMenu ScheduleMenu} feature instead.**
 *
 * Displays a context menu for empty parts of the schedule. Items are populated by other features and/or application code.
 *
 * This feature is **disabled** by default in favor of `ScheduleMenu`.
 *
 * @deprecated 4.0.0
 * @extends Scheduler/feature/ScheduleMenu
 * @classtype scheduleContextMenu
 */

var ScheduleContextMenu = /*#__PURE__*/function (_ScheduleMenu) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ScheduleContextMenu, _ScheduleMenu);

  var _super = _createSuper(ScheduleContextMenu);

  function ScheduleContextMenu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ScheduleContextMenu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ScheduleContextMenu, [{
    key: "construct",
    value: function construct(scheduler, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ScheduleContextMenu.prototype), "construct", this).call(this, scheduler, config);

      this.scheduler = scheduler;
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].deprecate('Scheduler', '5.0.0', '`ScheduleContextMenu` feature is deprecated, in favor of `ScheduleMenu` feature. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.'); // If this feature is enabled, need to disable ScheduleMenu. They are mutually exclusive.

      if (scheduler.features.scheduleMenu) {
        scheduler.features.scheduleMenu.disabled = true;
      }
    } //endregion
    //region Events

    /**
     * Fired from scheduler before the context menu is shown for an event. Allows manipulation of the items
     * to show in the same way as in `processItems`. Returning `false` from a listener prevents the menu from
     * being shown.
     * @event scheduleContextMenuBeforeShow
     * @deprecated 4.0.0 Renamed to scheduleMenuBeforeShow
     * @preventable
     * @param {Scheduler.view.Scheduler} source
     * @param {Object} items Menu item configs
     * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
     * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */

    /**
     * Fired from scheduler when an item is selected in the context menu.
     * @event scheduleContextMenuItem
     * @deprecated 4.0.0 Renamed to scheduleMenuItem
     * @param {Scheduler.view.Scheduler} source
     * @param {Core.widget.MenuItem} item
     * @param {Scheduler.model.EventModel} eventRecord
     * @param {Scheduler.model.ResourceModel} resourceRecord
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */

    /**
     * Fired from scheduler after showing the context menu for an event
     * @event scheduleContextMenuShow
     * @deprecated 4.0.0 Renamed to eventMenuShow
     * @param {Scheduler.view.Scheduler} source
     * @param {Core.widget.Menu} menu The menu
     * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
     * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */
    //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ScheduleContextMenu';
    }
  }]);

  return ScheduleContextMenu;
}(_Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


ScheduleContextMenu.featureClass = '';
ScheduleContextMenu._$name = 'ScheduleContextMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(ScheduleContextMenu);

/***/ }),

/***/ "./lib/Scheduler/feature/ScheduleMenu.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/ScheduleMenu.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleMenu; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Scheduler_feature_base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Scheduler/feature/base/TimeSpanMenuBase.js */ "./lib/Scheduler/feature/base/TimeSpanMenuBase.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/feature/ScheduleMenu
 */

/**
 * Displays a context menu for empty parts of the schedule. Items are populated in the first place
 * by configurations of this Feature, then by other features and/or application code.
 *
 * ### Default scheduler zone menu items
 *
 * The Scheduler menu feature provides only one item:
 *
 * | Item reference | Text      | Weight | Feature        | Enabled by default | Description                                                                                                                                                                       |
 * |----------------|-----------|--------|----------------|--------------------|-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|
 * | `addEvent`     | Add event | 100    | `ScheduleMenu` | true               | Adds a new event to the store. The event starts at the selected point of time and lasts 1 hour. It is assigned to the selected resource. Shown if the Scheduler is not read-only. |
 *
 * ### Customizing the menu items
 *
 * The menu items in the Scheduler menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * Add extra item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleMenu : {
 *             items : {
 *                 extraItem : {
 *                     text : 'Extra',
 *                     icon : 'b-fa b-fa-fw b-fa-flag',
 *                     onItem({date, resourceRecord, items}) {
 *                         // Custom date based action
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Remove existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleMenu : {
 *             items : {
 *                 addEvent : false
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Customize existing item:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleMenu : {
 *             items : {
 *                 addEvent : {
 *                     text : 'Create new booking'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Manipulate existing items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleMenu : {
 *             // Process items before menu is shown
 *             processItems({date, resourceRecord, items}) {
 *                  // Add an extra item for ancient times
 *                  if (date < new Date(2018, 11, 17)) {
 *                      items.modernize = {
 *                          text : 'Modernize',
 *                          ontItem({date}) {
 *                              // Custom date based action
 *                          }
 *                      };
 *                  }
 *
 *                  // Do not show menu for Sundays
 *                  if (date.getDay() === 0) {
 *                      return false;
 *                  }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the "Customizing the Event menu, the Schedule menu, and the TimeAxisHeader menu" guide.
 *
 * This feature is **enabled** by default
 *
 * @demo Scheduler/basic
 * @extends Scheduler/feature/base/TimeSpanMenuBase
 * @classtype scheduleMenu
 */

var ScheduleMenu = /*#__PURE__*/function (_TimeSpanMenuBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ScheduleMenu, _TimeSpanMenuBase);

  var _super = _createSuper(ScheduleMenu);

  function ScheduleMenu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ScheduleMenu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ScheduleMenu, [{
    key: "shouldShowMenu",
    //endregion
    //region Events

    /**
     * Fired from scheduler before the context menu is shown for an event. Allows manipulation of the items
     * to show in the same way as in `processItems`. Returning `false` from a listener prevents the menu from
     * being shown.
     * @event scheduleMenuBeforeShow
     * @preventable
     * @param {Scheduler.view.Scheduler} source
     * @param {Object} items Menu item configs
     * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
     * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */

    /**
     * Fired from scheduler when an item is selected in the context menu.
     * @event scheduleMenuItem
     * @param {Scheduler.view.Scheduler} source
     * @param {Core.widget.MenuItem} item
     * @param {Scheduler.model.EventModel} eventRecord
     * @param {Scheduler.model.ResourceModel} resourceRecord
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */

    /**
     * Fired from scheduler after showing the context menu for an event
     * @event scheduleMenuShow
     * @param {Scheduler.view.Scheduler} source
     * @param {Core.widget.Menu} menu The menu
     * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
     * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
     * @param {HTMLElement} eventElement
     */
    //endregion
    value: function shouldShowMenu(eventParams) {
      var client = this.client,
          column = eventParams.column,
          targetElement = eventParams.targetElement,
          resourceRecord = eventParams.resourceRecord,
          isTimeAxisColumn = column ? column === client.timeAxisColumn : client.timeAxisSubGrid.element === targetElement;
      return isTimeAxisColumn && !(resourceRecord && resourceRecord.isSpecialRow);
    }
  }, {
    key: "getDataFromEvent",
    value: function getDataFromEvent(event) {
      var client = this.client,
          cellData = client.getCellDataFromEvent(event),
          date = client.getDateFromDomEvent(event, 'floor'),
          resourceRecord = client.resolveResourceRecord(event) || client.resourceStore.last;
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].assign(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ScheduleMenu.prototype), "getDataFromEvent", this).call(this, event), cellData, {
        date: date,
        resourceRecord: resourceRecord
      });
    }
  }, {
    key: "populateScheduleMenu",
    value: function populateScheduleMenu(_ref) {
      var items = _ref.items;
      var client = this.client;

      if (!client.readOnly) {
        items.addEvent = {
          text: 'L{SchedulerBase.Add event}',
          icon: 'b-icon b-icon-add',
          disabled: client.resourceStore.count === 0,
          weight: 100,
          onItem: function onItem(_ref2) {
            var date = _ref2.date,
                resourceRecord = _ref2.resourceRecord;
            client.internalAddEvent(date, resourceRecord, client.getRowFor(resourceRecord));
          }
        };
      }
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ScheduleMenu';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        type: 'schedule'
        /**
         * This is a preconfigured set of items used to create the default context menu.
         *
         * The `items` provided by this feature are listed below. These are the property names which you may
         * configure in the feature's {@link Grid.feature.base.ContextMenuBase#config-items} config:
         *
         * - `addEvent` Add an event for at the resource and time indicated by the `contextmenu` event.
         *
         * To remove existing items, set corresponding keys to `false`
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         scheduleMenu : {
         *             items : {
         *                 addEvent : false
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * @config {Object} items
         */

      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      var config = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ScheduleMenu), "pluginConfig", this);

      config.chain.push('populateScheduleMenu');
      return config;
    }
  }]);

  return ScheduleMenu;
}(_Scheduler_feature_base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


ScheduleMenu.featureClass = '';
ScheduleMenu._$name = 'ScheduleMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(ScheduleMenu, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/ScheduleTooltip.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/ScheduleTooltip.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleTooltip; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/feature/ScheduleTooltip
 */

/**
 * Feature that displays a tooltip containing the time at the mouse position when hovering empty parts of the schedule.
 * To hide the schedule tooltip, just disable this feature:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleTooltip : false
 *     }
 * });
 * ```
 *
 * You can also output a message along with the default time indicator (to indicate resource availability etc)
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *    features : {
 *       scheduleTooltip : {
 *           getText(date, event, resource) {
 *               return 'Hovering ' + resource.name;
 *           }
 *       }
 *   }
 * });
 * ```
 *
 * To take full control over the markup shown in the tooltip you can override the {@link #function-generateTipContent} method:
 * ```
 * const scheduler = new Scheduler({
 *     features : {
 *         scheduleTooltip : {
 *             generateTipContent({ date, event, resourceRecord }) {
 *                 return `
 *                     <dl>
 *                         <dt>Date</dt><dd>${date}</dd>
 *                         <dt>Resource</dt><dd>${resourceRecord.name}</dd>
 *                     </dl>
 *                 `;
 *             }
 *         }
 *     }
 * });
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/basic
 * @externalexample scheduler/ScheduleTooltip.js
 * @classtype scheduleTooltip
 */

var ScheduleTooltip = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ScheduleTooltip, _InstancePlugin);

  var _super = _createSuper(ScheduleTooltip);

  function ScheduleTooltip() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ScheduleTooltip);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ScheduleTooltip, [{
    key: "render",
    //endregion
    //region Init

    /**
     * Called when scheduler is rendered. Sets up drag and drop and hover tooltip.
     * @private
     */
    value: function render() {
      var me = this,
          scheduler = me.client; // TODO: render should not ever be called twice.

      if (me.hoverTip) {
        me.hoverTip.destroy();
      }

      var reshowListener;
      var tip = me.hoverTip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
        id: "".concat(scheduler.id, "-schedule-tip"),
        cls: 'b-sch-scheduletip',
        allowOver: true,
        hoverDelay: 0,
        hideDelay: 100,
        showOnHover: true,
        forElement: scheduler.timeAxisSubGridElement,
        anchorToTarget: false,
        trackMouse: true,
        updateContentOnMouseMove: true,
        // disable text content and monitor resize for tooltip, otherwise it doesn't
        // get sized properly on first appearance
        monitorResize: false,
        textContent: false,
        forSelector: '.b-schedulerbase:not(.b-animating):not(.b-dragging-event):not(.b-dragcreating) .b-grid-body-container:not(.b-scrolling) .b-timeline-subgrid:not(.b-scrolling) > :not(.b-sch-foreground-canvas):not(.b-group-footer):not(.b-group-row) *',
        // Do not constrain at all, want it to be able to go outside of the viewport to not get in the way
        constrainTo: null,
        getHtml: me.getHoverTipHtml.bind(me),
        onDocumentMouseDown: function onDocumentMouseDown(event) {
          // Click on the scheduler hides until the very next
          // non-button-pressed mouse move!
          if (tip.forElement.contains(event.event.target)) {
            reshowListener = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on({
              element: scheduler.timeAxisSubGridElement,
              mousemove: function mousemove(e) {
                return tip.internalOnPointerOver(e);
              },
              capture: true
            });
          }

          var hideAnimation = tip.hideAnimation;
          tip.hideAnimation = false;
          tip.constructor.prototype.onDocumentMouseDown.call(tip, event);
          tip.hideAnimation = hideAnimation;
        },
        listeners: {
          pointerover: function pointerover(_ref) {
            var event = _ref.event;
            var buttonsPressed = 'buttons' in event ? event.buttons > 0 : event.which > 0; // fallback for Safari which doesn't support 'buttons'
            // This is the non-button-pressed mousemove
            // after the document mousedown

            if (!buttonsPressed && reshowListener) {
              reshowListener();
            } // Never any tooltip while interaction is ongoing and a mouse button is pressed


            return !me.disabled && !buttonsPressed;
          }
        }
      });
      me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_12__["default"]({
        scheduler: scheduler
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.destroyProperties('clockTemplate', 'hoverTip');

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ScheduleTooltip.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Contents

    /**
     * @deprecated Use {@link #function-generateTipContent} instead.
     * @private
     * Gets html to display in hover tooltip (tooltip displayed on empty parts of scheduler)
     */

  }, {
    key: "getHoverTipHtml",
    value: function getHoverTipHtml(_ref2) {
      var tip = _ref2.tip,
          event = _ref2.event;
      var me = this,
          scheduler = me.client,
          date = event && scheduler.getDateFromDomEvent(event, 'floor', true);
      var html = me.lastHtml;

      if (date) {
        var resourceRecord = scheduler.resolveResourceRecord(event); // resourceRecord might be null if user hover over the tooltip, but we shouldn't hide the tooltip in this case

        if (resourceRecord && (date - me.lastTime !== 0 || resourceRecord !== me.lastResource)) {
          me.lastResource = resourceRecord;
          html = me.lastHtml = me.generateTipContent({
            date: date,
            event: event,
            resourceRecord: resourceRecord
          });
        }
      } else {
        tip.hide();
        me.lastTime = null;
        me.lastResource = null;
      }

      return html;
    }
    /**
     * Called as mouse pointer is moved over a new resource or time block. You can override this to show
     * custom HTML in the tooltip.
     * @param {Object} context
     * @param {Date} context.date The date of the hovered point
     * @param {Event} context.event The DOM event that triggered this tooltip to show
     * @param {Scheduler.model.ResourceModel} context.resourceRecord The resource record
     */

  }, {
    key: "generateTipContent",
    value: function generateTipContent(_ref3) {
      var date = _ref3.date,
          event = _ref3.event,
          resourceRecord = _ref3.resourceRecord;
      var me = this,
          clockHtml = me.clockTemplate.generateContent({
        date: date,
        text: me.client.getFormattedDate(date)
      }),
          messageHtml = me.messageTemplate({
        message: me.getText(date, event, resourceRecord) || ''
      });
      me.lastTime = date;
      return clockHtml + messageHtml;
    }
    /**
     * Override this to render custom text to default hover tip
     * @param {Date} date
     * @param {Event} event Browser event
     * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
     * @return {String}
     */

  }, {
    key: "getText",
    value: function getText(date, event, resourceRecord) {} //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ScheduleTooltip';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        messageTemplate: function messageTemplate(data) {
          return "<div class=\"b-sch-hovertip-msg\">".concat(data.message, "</div>");
        }
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['render']
      };
    }
  }]);

  return ScheduleTooltip;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__["default"]); // TODO: Refactor SASS so thet auto-generated class name of 'b-' + cls.name.toLowerCase() can be used.



ScheduleTooltip.featureClass = 'b-scheduletip';
ScheduleTooltip._$name = 'ScheduleTooltip';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(ScheduleTooltip, true, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/SimpleEventEdit.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/SimpleEventEdit.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SimpleEventEdit; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../model/AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony import */ var _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/feature/SimpleEventEdit
 */

/**
 * Feature that displays a text field to edit the event name. You can control the flow of this by listening to the events relayed by this class from the underlying {@link Core.widget.Editor}.
 * To use this feature, you also need to disable the built-in default editing feature:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         eventEdit       : false,
 *         simpleEventEdit : true
 *     }
 * });
 * ```
 *
 * This feature is **disabled** by default
 *
 * @extends Core/mixin/InstancePlugin
 * @demo Scheduler/simpleeditor
 * @externalexample scheduler/SimpleEventEdit.js
 * @classtype simpleEventEdit
 */

var SimpleEventEdit = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(SimpleEventEdit, _InstancePlugin);

  var _super = _createSuper(SimpleEventEdit);

  function SimpleEventEdit() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, SimpleEventEdit);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(SimpleEventEdit, [{
    key: "construct",
    //endregion
    //region Editing
    value: function construct(scheduler, config) {
      var _scheduler$on;

      var me = this;
      me.scheduler = scheduler;
      scheduler.eventEdit = me;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(SimpleEventEdit.prototype), "construct", this).call(this, scheduler, config);

      me.clientListenersDetacher = scheduler.on((_scheduler$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_scheduler$on, me.triggerEvent, function (_ref) {
        var eventRecord = _ref.eventRecord,
            eventElement = _ref.eventElement;
        return me.editEvent(eventRecord, eventRecord.resource, eventElement);
      }), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_scheduler$on, "dragcreateend", me.onDragCreateEnd), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_scheduler$on, "thisObj", me), _scheduler$on));
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$editor;

      this.clientListenersDetacher();
      (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(SimpleEventEdit.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "editEvent",
    // region Editor

    /**
     * Opens an Editor for the passed event. This function is exposed on Scheduler and can be called as
     * `scheduler.editEvent()`.
     * @param {Scheduler.model.EventModel} eventRecord The Event to edit
     * @param {Scheduler.model.ResourceModel} [resourceRecord] The Resource record for the event.
     */
    value: function editEvent(eventRecord, resourceRecord, element) {
      var me = this,
          scheduler = me.scheduler;

      if (scheduler.readOnly || me.disabled) {
        return;
      } // Want to put editor in inner element (b-sch-event) to get correct font size, but when drag creating the proxy
      // has no inner element


      element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].down(element, scheduler.eventInnerSelector) || element;
      eventRecord = eventRecord instanceof _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_13__["default"] ? eventRecord.event : eventRecord;
      me.resource = resourceRecord;
      me.event = eventRecord;
      me.element = element;
      scheduler.element.classList.add('b-eventeditor-editing');

      if (!me.editor) {
        // Editor is contained in, and owned by the TimeAxisSubGrid to avoid focus flipping out and in.
        // The editor is an owned descendant of the SubGrid.
        me.editor = new _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_14__["default"](Object.assign({
          owner: me.scheduler.timeAxisSubGrid,
          appendTo: me.scheduler.timeAxisSubGridElement,
          scrollAction: 'realign',
          cls: 'b-simpleeventeditor',
          listeners: {
            complete: me.onEditorComplete,
            cancel: me.onEditorCancel,
            thisObj: me
          }
        }, me.editorConfig));
        me.relayEvents(me.editor, ['beforestart', 'start', 'beforecomplete', 'complete', 'beforecancel', 'cancel']);
      }

      me.editor.startEdit({
        target: element,
        record: eventRecord,
        field: me.field
      }); // No key navigation during editing

      me.scheduler.navigator.disabled = true;
    }
  }, {
    key: "onEditorComplete",
    value: function onEditorComplete() {
      var _me$element;

      var me = this;

      if (me.event.stores.length === 0) {
        me.eventStore.add(me.editor.record);
        me.event.assign(me.resource);
      } // remove element if it's a drag create proxy


      if ((_me$element = me.element) === null || _me$element === void 0 ? void 0 : _me$element.classList.contains('b-sch-dragcreator-proxy')) {
        me.element.remove();
      }

      me.reset();
    }
  }, {
    key: "onEditorCancel",
    value: function onEditorCancel() {
      if (this.event.stores.length === 0) {
        this.element.remove();
      }

      this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.scheduler.element.classList.remove('b-eventeditor-editing'); // Restore key navigation after editing

      this.scheduler.navigator.disabled = false;
    } //endregion
    // chained from EventNavigation

  }, {
    key: "onEventEnterKey",
    value: function onEventEnterKey(_ref2) {
      var assignmentRecord = _ref2.assignmentRecord,
          eventRecord = _ref2.eventRecord;
      var element = assignmentRecord ? this.scheduler.getElementFromAssignmentRecord(assignmentRecord) : this.scheduler.getElementFromEventRecord(eventRecord),
          resourceRecord = (assignmentRecord || eventRecord).resource;
      this.editEvent(eventRecord, resourceRecord, element);
    } //endregion

  }, {
    key: "onDragCreateEnd",
    value: function onDragCreateEnd(_ref3) {
      var newEventRecord = _ref3.newEventRecord,
          resourceRecord = _ref3.resourceRecord,
          proxyElement = _ref3.proxyElement;
      var me = this; // Call scheduler template method

      me.scheduler.onEventCreated(newEventRecord); // Clone proxy after showing editor so it's not deleted

      var phantomEventElement = proxyElement.cloneNode(true);
      phantomEventElement.removeAttribute('id');
      proxyElement.parentElement.appendChild(phantomEventElement);
      me.element = phantomEventElement;
      me.editEvent(newEventRecord, resourceRecord, phantomEventElement);
    }
  }, {
    key: "eventStore",
    get: function get() {
      return this.scheduler.eventStore;
    }
  }], [{
    key: "$name",
    // region Events

    /**
     * Fired before the editor is shown to start an edit operation. Returning `false` from a handler vetoes the edit operation.
     * @event beforeStart
     * @preventable
     * @property {Object} value - The value to be edited.
     * @property {Core.widget.Editor} source - The Editor that triggered the event.
     */

    /**
     * Fired when an edit operation has begun.
     * @event start
     * @property {Object} value - The starting value of the field.
     * @property {Core.widget.Editor} source - The Editor that triggered the event.
     */

    /**
     * Fired when an edit completion has been requested, either by `ENTER`, or focus loss (if configured to complete on blur).
     * The completion may be vetoed, in which case, focus is moved back into the editor.
     * @event beforeComplete
     * @property {Object} oldValue - The original value.
     * @property {Object} value - The new value.
     * @property {Core.widget.Editor} source - The Editor that triggered the event.
     * @preventable
     */

    /**
     * Edit has been completed, and any associated record or element has been updated.
     * @event complete
     * @property {Object} oldValue - The original value.
     * @property {Object} value - The new value.
     * @property {Core.widget.Editor} source - The Editor that triggered the event.
     */

    /**
     * Fired when cancellation has been requested, either by `ESC`, or focus loss (if configured to cancel on blur).
     * The cancellation may be vetoed, in which case, focus is moved back into the editor.
     * @event beforeCancel
     * @property {Object} oldValue - The original value.
     * @property {Object} value - The new value.
     * @property {Core.widget.Editor} source - The Editor that triggered the event.
     * @preventable
     */

    /**
     * Edit has been canceled without updating the associated record or element.
     * @event cancel
     * @property {Object} oldValue - The original value.
     * @property {Object} value - The value of the field.
     * @property {Core.widget.Editor} source - The Editor that triggered the event.
     */
    // endregion
    //region Config
    get: function get() {
      return 'SimpleEventEdit';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * The event that shall trigger showing the editor. Defaults to `eventdblclick`, set to `` or null to disable editing of existing events.
         * @config {String}
         * @default
         * @category Editor
         */
        triggerEvent: 'eventdblclick',

        /**
         * The current {@link Scheduler.model.EventModel} record, which is being edited by the event editor.
         * @property {Scheduler.model.EventModel}
         * @readonly
         */
        eventRecord: null,

        /**
         * The {@link Scheduler.model.EventModel} field to edit
         * @config {String}
         * @category Editor
         */
        field: 'name',

        /**
         * The editor configuration, where you can control which widget to show
         * @config {Object}
         * @category Editor
         */
        editorConfig: null
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onEventEnterKey'],
        assign: ['editEvent']
      };
    }
  }]);

  return SimpleEventEdit;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_12__["default"]);


SimpleEventEdit._$name = 'SimpleEventEdit';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerFeature(SimpleEventEdit, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/Summary.js":
/*!******************************************!*\
  !*** ./lib/Scheduler/feature/Summary.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Summary; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.repeat */ "./node_modules/core-js/modules/es.string.repeat.js");
/* harmony import */ var core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_repeat__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Grid_feature_Summary_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Grid/feature/Summary.js */ "./lib/Grid/feature/Summary.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../view/SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Scheduler/feature/Summary
 */
// noinspection JSClosureCompilerSyntax

/**
 * A special version of the Grid Summary feature. This feature displays a summary row in the grid footer.
 * For regular columns in the locked section - specify type of summary on columns, available types are:
 * <dl class="wide">
 * <dt>sum <dd>Sum of all values in the column
 * <dt>add <dd>Alias for sum
 * <dt>count <dd>Number of rows
 * <dt>countNotEmpty <dd>Number of rows containing a value
 * <dt>average <dd>Average of all values in the column
 * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
 * </dl>
 * Columns can also specify a summaryRender to format the calculated sum.
 *
 * To summarize events, either provide a {@link #config-renderer} or use {@link #config-summaries}
 *
 * This feature is <strong>disabled</strong> by default. It is **not** supported in vertical mode.
 *
 * @extends Grid/feature/Summary
 * @classtype summary
 * @externalexample scheduler/Summary.js
 * @demo Scheduler/summary
 * @typings Grid/feature/Summary -> Grid/feature/GridSummary
 */

var Summary = /*#__PURE__*/function (_GridSummary) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(Summary, _GridSummary);

  var _super = _createSuper(Summary);

  function Summary() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, Summary);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(Summary, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(scheduler, config) {
      var me = this;

      if (scheduler.isVertical) {
        throw new Error('Summary feature is not supported in vertical mode');
      }

      me.scheduler = scheduler;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Summary.prototype), "construct", this).call(this, scheduler, config);

      if (!me.summaries) {
        me.summaries = [{
          renderer: me.renderer
        }];
      } // Feature might be run from Grid (in docs), should not crash
      // https://app.assembla.com/spaces/bryntum/tickets/6801/details


      if (scheduler instanceof _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_18__["default"]) {
        scheduler.eventStore.on({
          filter: 'updateScheduleSummaries',
          thisObj: me
        });
        scheduler.resourceStore.on({
          filter: 'updateScheduleSummaries',
          thisObj: me
        });
        scheduler.project.on({
          refresh: 'updateScheduleSummaries',
          thisObj: me
        });
        scheduler.timeAxisViewModel.on({
          update: me.renderRows,
          thisObj: me
        });
      }
    } //endregion
    //region Render

  }, {
    key: "renderRows",
    value: function renderRows() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Summary.prototype), "renderRows", this).call(this);

      this.render();
    }
    /**
     * Updates summaries.
     * @private
     */

  }, {
    key: "updateScheduleSummaries",
    value: function updateScheduleSummaries() {
      var me = this,
          scheduler = me.scheduler,
          summaryContainer = scheduler.bodyElement.querySelector('.b-grid-footer.b-sch-timeaxiscolumn');

      if (summaryContainer && scheduler.isEngineReady) {
        Array.from(summaryContainer.children).forEach(function (element, i) {
          var tick = scheduler.timeAxis.getAt(i),
              events = scheduler.eventStore.getEvents({
            startDate: tick.startDate,
            endDate: tick.endDate,
            allowPartial: true,
            onlyAssigned: true
          });
          var html = '',
              tipHtml = "<header>".concat(me.L('L{Summary for}', scheduler.getFormattedDate(tick.startDate)), "</header>");
          me.summaries.forEach(function (config) {
            var value = config.renderer({
              startDate: tick.startDate,
              endDate: tick.endDate,
              eventStore: scheduler.eventStore,
              resourceStore: scheduler.resourceStore,
              events: events,
              element: element
            }),
                valueHtml = "<div class=\"b-timeaxis-summary-value\">".concat(value, "</div>");
            if (me.summaries.length > 1 || value !== '') html += valueHtml;
            tipHtml += "<label>".concat(config.label || '', "</label>") + valueHtml;
          });
          element.innerHTML = html;
          element._tipHtml = tipHtml;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var me = this,
          scheduler = me.scheduler,
          summaryEl = scheduler.element.querySelector('.b-grid-footer.b-sch-timeaxiscolumn');

      if (summaryEl) {
        // if any sum config has a label, init tooltip
        if (me.summaries.some(function (config) {
          return config.label;
        }) && me.showTooltip && !me._tip) {
          me._tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_17__["default"]({
            id: "".concat(scheduler.id, "-summary-tip"),
            cls: 'b-timeaxis-summary-tip',
            hoverDelay: 0,
            hideDelay: 100,
            forElement: summaryEl,
            anchorToTarget: true,
            trackMouse: false,
            forSelector: '.b-timeaxis-tick',
            getHtml: function getHtml(_ref) {
              var activeTarget = _ref.activeTarget;
              return activeTarget._tipHtml;
            }
          });
        }

        summaryEl.innerHTML = "<div class=\"b-timeaxis-tick\" style=\"width: ".concat(scheduler.tickSize, "px\"></div>").repeat(scheduler.timeAxis.count);
        me.updateScheduleSummaries();
      }
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'Summary';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Show tooltip containing summary values and labels
         * @config {Boolean}
         * @default
         */
        showTooltip: true,

        /**
         * Array of summary configs which consists of a label and a {@link #config-renderer} function
         *
         * ```javascript
         * new Scheduler({
         *     features : {
         *         summary : {
         *             summaries : [
         *                 {
         *                     label : 'Label',
         *                     renderer : ({ startDate, endDate, eventStore, resourceStore, events, element }) => {
         *                         // return display value
         *                     }
         *                 }
         *             ]
         *         }
         *     }
         * });
         * ```
         *
         * @config {Object[]}
         */
        summaries: null,

        /**
         * A function to display summary value per tick. Applicable when single summary row is used.
         *
         * ```javascript
         * new Scheduler({
         *     features : {
         *         summary : {
         *             renderer : ({ startDate, endDate, eventStore, resourceStore, events, element }) => {
         *                 // return display value
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * @config {Function}
         */
        renderer: null
      };
    }
  }]);

  return Summary;
}(_Grid_feature_Summary_js__WEBPACK_IMPORTED_MODULE_15__["default"]); // Override Grids Summary with this improved version



Summary._$name = 'Summary';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__["default"].registerFeature(Summary, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/TimeAxisHeaderMenu.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/feature/TimeAxisHeaderMenu.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisHeaderMenu; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Grid/feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/feature/TimeAxisHeaderMenu
 */

/**
 * Adds scheduler specific menu items to the timeline header context menu.
 *
 * ### Default timeaxis header menu items
 *
 * Here is the list of menu items provided by the `TimeAxisHeaderMenu` feature and populated by the other features:
 *
 * | Item reference     | Text                  | Weight | Feature              | Enabled by default | Description                                                                                        |
 * |--------------------|-----------------------|--------|----------------------|--------------------|----------------------------------------------------------------------------------------------------|
 * | `eventsFilter`     | Filter tasks          | 100    | `EventFilter`        | true               | Shows a submenu to control events filtering                                                        |
 * | \>`nameFilter`     | By name               | 110    | `EventFilter`        | true               | Filters the event store records by `name` field using the input value                              |
 * | `zoomLevel`        | Zoom                  | 200    | `TimeAxisHeaderMenu` | true               | Shows a submenu to control the timeline zooming                                                    |
 * | \>`zoomSlider`     | -                     | 210    | `TimeAxisHeaderMenu` | true               | Changes current zoom level                                                                         |
 * | `dateRange`        | Date range            | 300    | `TimeAxisHeaderMenu` | true               | Shows a submenu to control the timeline range                                                      |
 * | \>`startDateField` | Start date            | 310    | `TimeAxisHeaderMenu` | true               | Sets start date fot the timeline                                                                   |
 * | \>`endDateField`   | End date              | 320    | `TimeAxisHeaderMenu` | true               | Sets end date fot the timeline                                                                     |
 * | \>`leftShiftBtn`   | <                     | 330    | `TimeAxisHeaderMenu` | true               | Shifts start and end dates backward                                                                |
 * | \>`todayBtn`       | Today                 | 340    | `TimeAxisHeaderMenu` | true               | Sets start date equal to the current day and end date equal to the next day after the current day. |
 * | \>`rightShiftBtn`  | \>                    | 350    | `TimeAxisHeaderMenu` | true               | Shifts start and end dates forward                                                                 |
 * | `currentTimeLine`  | Show current timeline | 400    | `TimeRanges`         | true               | When selected shows the current time line on the timeline                                          |
 *
 * \> - first level of submenu
 *
 * ### Customizing the menu items
 *
 * The menu items in the TimeAxis Header menu can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the `items` config of the feature.
 *
 * Add extra items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         timeAxisHeaderMenu : {
 *             items : {
 *                 extraItem : {
 *                     text : 'Extra',
 *                     icon : 'b-fa b-fa-fw b-fa-flag',
 *                     onItem() {
 *                         ...
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Remove existing items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         timeAxisHeaderMenu : {
 *             items : {
 *                 zoomLevel : false
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Customize existing item:
 *
 * * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         timeAxisHeaderMenu : {
 *             items : {
 *                 zoomLevel : {
 *                     text : 'Scale'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Manipulate existing items:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         timeAxisHeaderMenu : {
 *             // Process items before menu is shown
 *             processItems({ items }) {
 *                  // Add an extra item dynamically
 *                 items.coolItem = {
 *                     text : 'Cool action',
 *                     onItem() {
 *                           // ...
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * Full information of the menu customization can be found in the "Customizing the Event menu, the Schedule menu, and the TimeAxisHeader menu" guide.
 *
 * This feature is **enabled** by default
 *
 * @extends Grid/feature/HeaderMenu
 * @demo Scheduler/basic
 * @classtype timeAxisHeaderMenu
 * @externalexample scheduler/TimeAxisHeaderMenu.js
 */

var TimeAxisHeaderMenu = /*#__PURE__*/function (_HeaderMenu) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(TimeAxisHeaderMenu, _HeaderMenu);

  var _super = _createSuper(TimeAxisHeaderMenu);

  function TimeAxisHeaderMenu() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, TimeAxisHeaderMenu);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(TimeAxisHeaderMenu, [{
    key: "construct",
    //endregion
    //region Events

    /**
     * Fired from Scheduler before the context menu is shown for the time axis header.
     * Allows manipulation of the items to show in the same way as in the {@link Grid.feature.base.ContextMenuBase#config-processItems}.
     *
     * Returning `false` from a listener prevents the menu from being shown.
     *
     * @event timeAxisHeaderContextMenuBeforeShow
     * @preventable
     * @param {Scheduler.view.Scheduler} source The scheduler
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} items Menu item configs
     * @param {Grid.column.Column} column Time axis column
     */

    /**
     * Fired from grid after the context menu is shown for a header
     * @event timeAxisHeaderContextMenuShow
     * @param {Scheduler.view.Scheduler} source The scheduler
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} items Menu item configs
     * @param {Grid.column.Column} column Time axis column
     */

    /**
     * Fired from grid when an item is selected in the header context menu.
     * @event timeAxisHeaderContextMenuItem
     * @param {Scheduler.view.Scheduler} source The scheduler
     * @param {Core.widget.Menu} menu The menu
     * @param {Object} item Selected menu item
     * @param {Grid.column.Column} column Time axis column
     */
    //endregion
    value: function construct() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeAxisHeaderMenu.prototype), "construct", this).apply(this, arguments);

      if (this.triggerEvent.includes('click') && this.client.zoomOnTimeAxisDoubleClick) {
        this.client.zoomOnTimeAxisDoubleClick = false;
      }
    }
  }, {
    key: "shouldShowMenu",
    value: function shouldShowMenu(eventParams) {
      var column = eventParams.column;
      return column && column.enableHeaderContextMenu !== false && column === this.client.timeAxisColumn;
    }
  }, {
    key: "showContextMenu",
    value: function showContextMenu(eventParams) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeAxisHeaderMenu.prototype), "showContextMenu", this).apply(this, arguments);

      if (this.menu) {
        // the TimeAxis's context menu probably will cause scrolls because it manipulates the dates.
        // The menu should not hide on scroll when for a TimeAxisColumn
        this.menu.scrollAction = 'realign';
      }
    }
  }, {
    key: "populateTimeAxisHeaderMenu",
    value: function populateTimeAxisHeaderMenu(_ref) {
      var items = _ref.items;
      var me = this,
          client = me.client,
          dateStep = {
        magnitude: client.timeAxis.shiftIncrement,
        unit: client.timeAxis.shiftUnit
      };
      Object.assign(items, {
        zoomLevel: {
          text: 'L{pickZoomLevel}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-search-plus',
          disabled: !client.presets.count || me.disabled,
          weight: 200,
          menu: {
            type: 'popup',
            items: {
              zoomSlider: {
                weight: 210,
                type: 'slider',
                showValue: false,
                listeners: {
                  input: me.onZoomSliderChange,
                  thisObj: me
                },
                // set width for IE11
                minWidth: 130
              }
            },
            onBeforeShow: function onBeforeShow(_ref2) {
              var menu = _ref2.source;

              var _menu$items = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default()(menu.items, 1),
                  zoom = _menu$items[0];

              zoom.min = client.minZoomLevel;
              zoom.max = client.maxZoomLevel;
              zoom.value = client.zoomLevel;
            }
          }
        },
        dateRange: {
          text: 'L{activeDateRange}',
          localeClass: me,
          icon: 'b-fw-icon b-icon-calendar',
          weight: 300,
          menu: {
            type: 'popup',
            width: '20em',
            defaults: {
              localeClass: me
            },
            items: {
              startDateField: {
                type: 'datefield',
                label: 'L{startText}',
                weight: 310,
                labelWidth: '6em',
                required: true,
                step: dateStep,
                listeners: {
                  change: me.onRangeDateFieldChange,
                  thisObj: me
                }
              },
              endDateField: {
                type: 'datefield',
                label: 'L{endText}',
                weight: 320,
                labelWidth: '6em',
                required: true,
                step: dateStep,
                listeners: {
                  change: me.onRangeDateFieldChange,
                  thisObj: me
                }
              },
              leftShiftBtn: {
                type: 'button',
                weight: 330,
                cls: 'b-left-nav-btn',
                icon: 'b-icon b-icon-prev',
                color: 'b-blue b-raised',
                flex: 1,
                margin: 0,
                listeners: {
                  click: me.onLeftShiftBtnClick,
                  thisObj: me
                }
              },
              todayBtn: {
                type: 'button',
                weight: 340,
                cls: 'b-today-nav-btn',
                color: 'b-blue b-raised',
                text: 'L{todayText}',
                flex: 4,
                margin: '0 8',
                listeners: {
                  click: me.onTodayBtnClick,
                  thisObj: me
                }
              },
              rightShiftBtn: {
                type: 'button',
                weight: 350,
                cls: 'b-right-nav-btn',
                icon: 'b-icon b-icon-next',
                color: 'b-blue b-raised',
                flex: 1,
                listeners: {
                  click: me.onRightShiftBtnClick,
                  thisObj: me
                }
              }
            },
            listeners: {
              paint: me.initDateRangeFields,
              thisObj: me
            }
          }
        }
      });
    }
  }, {
    key: "onZoomSliderChange",
    value: function onZoomSliderChange(_ref3) {
      var value = _ref3.value;
      var me = this; // Zooming maintains timeline center point by scrolling the newly rerendered timeline to the
      // correct point to maintain the visual center. Temporarily inhibit context menu hide on scroll
      // of its context element.

      me.menu.scrollAction = 'realign';
      me.client.zoomLevel = value;
      me.menu.setTimeout({
        fn: function fn() {
          return me.menu.scrollAction = 'hide';
        },
        delay: 100,
        cancelOutstanding: true
      });
    }
  }, {
    key: "initDateRangeFields",
    value: function initDateRangeFields(_ref4) {
      var dateRange = _ref4.source,
          firstPaint = _ref4.firstPaint;

      if (firstPaint) {
        var widgetMap = dateRange.widgetMap;
        this.startDateField = widgetMap.startDateField;
        this.endDateField = widgetMap.endDateField;
      }

      this.initDates();
    }
  }, {
    key: "initDates",
    value: function initDates() {
      var me = this;
      me.startDateField.suspendEvents();
      me.endDateField.suspendEvents(); // The actual scheduler start dates may include time, but our Date field cannot currently handle
      // a time portion and throws it away, so when we need the value from an unchanged field, we need
      // to use the initialValue set from the timeAxis values.
      // Until our DateField can optionally include a time value, this is the solution.

      me.startDateField.value = me.startDateFieldInitialValue = me.client.startDate;
      me.endDateField.value = me.endDateFieldInitialValue = me.client.endDate;
      me.startDateField.resumeEvents();
      me.endDateField.resumeEvents();
    }
  }, {
    key: "onRangeDateFieldChange",
    value: function onRangeDateFieldChange(_ref5) {
      var source = _ref5.source;
      var me = this,
          startDateChanged = source === me.startDateField,
          client = me.client,
          timeAxis = client.timeAxis,
          startDate = me.startDateFieldInitialValue && !startDateChanged ? me.startDateFieldInitialValue : me.startDateField.value;
      var endDate = me.endDateFieldInitialValue && startDateChanged ? me.endDateFieldInitialValue : me.endDateField.value; // When either of the fields is changed, we no longer use its initialValue from the timeAxis start or end
      // so that gets nulled to indicate that it's unavailable and the real field value is to be used.

      if (startDateChanged) {
        me.startDateFieldInitialValue = null;
      } else {
        me.endDateFieldInitialValue = null;
      } // Because the start and end dates are exclusive, avoid a zero
      // length time axis by incrementing the end by one tick unit
      // if they are the same.


      if (!(endDate - startDate)) {
        endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(endDate, timeAxis.shiftIncrement, timeAxis.shiftUnit);
      } // if start date got bigger than end date set end date to start date plus one tick
      else if (endDate < startDate) {
          endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(startDate, timeAxis.shiftIncrement, timeAxis.shiftUnit);
        }

      client.preserveViewCenter(function () {
        return client.timeAxis.setTimeSpan(startDate, endDate);
      });
      me.initDates();
    }
  }, {
    key: "onLeftShiftBtnClick",
    value: function onLeftShiftBtnClick() {
      this.client.timeAxis.shiftPrevious();
      this.initDates();
    }
  }, {
    key: "onTodayBtnClick",
    value: function onTodayBtnClick() {
      var today = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].clearTime(new Date());
      this.client.timeAxis.setTimeSpan(today, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(today, 1, 'day'));
      this.initDates();
    }
  }, {
    key: "onRightShiftBtnClick",
    value: function onRightShiftBtnClick() {
      this.client.timeAxis.shiftNext();
      this.initDates();
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'TimeAxisHeaderMenu';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        type: 'timeAxisHeader'
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      var config = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeAxisHeaderMenu), "pluginConfig", this);

      config.chain.push('populateTimeAxisHeaderMenu');
      return config;
    }
  }]);

  return TimeAxisHeaderMenu;
}(_Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


TimeAxisHeaderMenu._$name = 'TimeAxisHeaderMenu';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(TimeAxisHeaderMenu, true, ['Scheduler', 'Gantt']);

/***/ }),

/***/ "./lib/Scheduler/feature/TimeRanges.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/feature/TimeRanges.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeRanges; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./AbstractTimeRanges.js */ "./lib/Scheduler/feature/AbstractTimeRanges.js");
/* harmony import */ var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/feature/TimeRanges
 */

/**
 * Feature that renders global ranges of time in the timeline. Use this feature to visualize a `range` like a 1 hr lunch or some important point in time
 * (a `line`, i.e. a range with 0 duration). This feature can also show a current time indicator if you set {@link #config-showCurrentTimeLine} to true. To style
 * the rendered elements, use the {@link Scheduler.model.TimeSpan#field-cls cls} field of the `TimeSpan` class.
 *
 * Each time range is represented by an instances of {@link Scheduler.model.TimeSpan}, held in a simple {@link Core.data.Store}.
 * If {@link Scheduler.data.CrudManager} is specified for the scheduler, the {@link #config-store} will be added at the end of the CrudManager
 * {@link Scheduler.crud.AbstractCrudManager#property-stores} collection.
 *
 * This feature is **disabled** by default
 *
 * @extends Scheduler/feature/AbstractTimeRanges
 * @classtype timeRanges
 * @demo Scheduler/timeranges
 * @externalexample scheduler/TimeRanges.js
 */

var TimeRanges = /*#__PURE__*/function (_AbstractTimeRanges) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(TimeRanges, _AbstractTimeRanges);

  var _super = _createSuper(TimeRanges);

  function TimeRanges() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, TimeRanges);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(TimeRanges, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(client, config) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeRanges.prototype), "construct", this).call(this, client, config);

      if (!client._timeRangesExposed) {
        // expose getter/setter for timeRanges on scheduler/gantt
        Object.defineProperty(client, 'timeRanges', {
          get: function get() {
            return me.timeRanges;
          },
          set: function set(timeRanges) {
            return me.store.data = timeRanges;
          }
        });
        client._timeRangesExposed = true;
      } // Pull in the timeRanges config before the store config if it exists.


      me.getConfig('timeRanges');
    }
  }, {
    key: "startConfigure",
    value: function startConfigure(config) {
      var client = this.client; // If the client's project has a timeRangeStore, we must use that
      // unless we've configured feature with a store (e.g. with recurrence mixin)

      if (client.project && !this.initialConfig.store) {
        var store = client.project.timeRangeStore;

        if (store) {
          var data = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getPath(config, 'store.data');

          if (data) {
            store.data = data;
          }

          config.store = store;
        }
      }
    }
  }, {
    key: "initCurrentTimeLine",
    //endregion
    //region Current time line
    value: function initCurrentTimeLine() {
      var me = this,
          now = new Date();

      if (me.currentTimeLine || !me.showCurrentTimeLine) {
        return;
      }

      me.currentTimeLine = new me.store.modelClass({
        // eslint-disable-next-line quote-props
        'id': 'currentTime',
        cls: 'b-sch-current-time',
        startDate: now,
        name: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].format(now, me.currentDateFormat)
      });
      me.updateCurrentTimeLine = me.updateCurrentTimeLine.bind(me);
      me.currentTimeInterval = me.setInterval(me.updateCurrentTimeLine, me.updateCurrentTimeLineInterval);

      if (me.client.isPainted) {
        me.renderRanges();
      }
    }
  }, {
    key: "updateCurrentTimeLine",
    value: function updateCurrentTimeLine() {
      var me = this;
      me.currentTimeLine.startDate = new Date();
      me.currentTimeLine.name = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].format(me.currentTimeLine.startDate, me.currentDateFormat);
      me.onStoreChanged({
        action: 'update',
        record: me.currentTimeLine,
        changes: {}
      });
    }
  }, {
    key: "hideCurrentTimeLine",
    value: function hideCurrentTimeLine() {
      var me = this;

      if (!me.currentTimeLine) {
        return;
      }

      me.clearInterval(me.currentTimeInterval);
      me.currentTimeLine = null;

      if (me.client.isPainted) {
        me.renderRanges();
      }
    }
  }, {
    key: "renderRanges",
    value: function renderRanges() {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeRanges.prototype), "renderRanges", this).call(this);

      if (me.showCurrentTimeLine && !me.disabled) {
        me.renderRange(me.currentTimeLine, true);
      }
    }
    /**
     * Get/set the current time line display state
     * @property {boolean}
     */

  }, {
    key: "populateHeaderMenu",
    //endregion
    //region Menu items
    // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/4.0.0.md for more information.

    /**
     * Adds a menu item to show/hide current time line.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @deprecated 4.0.0 Use `populateTimeAxisHeaderMenu` instead
     */
    value: function populateHeaderMenu(_ref) {
      var column = _ref.column,
          items = _ref.items;

      if (column.type !== 'timeAxis') {
        return;
      }

      this.populateTimeAxisHeaderMenu.apply(this, arguments);
    }
    /**
     * Adds a menu item to show/hide current time line.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown
     * @param {Object} options.items A named object to describe menu items
     * @internal
     */

  }, {
    key: "populateTimeAxisHeaderMenu",
    value: function populateTimeAxisHeaderMenu(_ref2) {
      var column = _ref2.column,
          items = _ref2.items;
      var me = this;
      items.currentTimeLine = {
        weight: 400,
        text: me.L('L{showCurrentTimeLine}'),
        checked: me.showCurrentTimeLine,
        onToggle: function onToggle(_ref3) {
          var checked = _ref3.checked;
          me.showCurrentTimeLine = checked;
        }
      };
    } //endregion
    //region Disable

    /**
     * Get/set the features disabled state
     * @property {Boolean}
     */

  }, {
    key: "timeRanges",
    set: function set(timeRanges) {
      var store = this.getConfig('store');

      if (store) {
        store.data = timeRanges;
      } else {
        this._timeRanges = timeRanges;
      }
    }
    /**
     * Returns the TimeRanges which occur within the client Scheduler's time axis.
     * @returns {Scheduler.model.TimeSpan[]} the time ranges for the time axis.
     */
    ,
    get: function get() {
      var store = this.store,
          records = store.records;

      if (store.recurringEvents) {
        var result = [],
            _this$client$timeAxis = this.client.timeAxis,
            startDate = _this$client$timeAxis.startDate,
            endDate = _this$client$timeAxis.endDate; // Collect occurrences for the recurring events in the record set

        records.forEach(function (timeSpan) {
          if (timeSpan.isRecurring) {
            result.push.apply(result, timeSpan.getOccurrencesForDateRange(startDate, endDate));
          } else {
            result.push(timeSpan);
          }
        });
        return result;
      } else {
        return records;
      }
    }
  }, {
    key: "showCurrentTimeLine",
    get: function get() {
      return this._showCurrentTimeLine;
    },
    set: function set(show) {
      this._showCurrentTimeLine = show;

      if (show) {
        this.initCurrentTimeLine();
      } else {
        this.hideCurrentTimeLine();
      }
    }
  }, {
    key: "disabled",
    get: function get() {
      return this._disabled;
    },
    set: function set(disabled) {
      this._disabled = disabled;

      if (this.client.isPainted) {
        this.renderRanges();
      }
    }
    /**
     * Returns the {@link Core.data.Store store} used by this feature
     * @property {Core.data.Store}
     */

  }, {
    key: "store",
    get: function get() {
      return this._store;
    },
    set: function set(store) {
      var me = this,
          client = me.client;

      if (!store.storeId) {
        store.storeId = 'timeRanges';
      }

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeRanges.prototype), "store", store, this, true); // timeRanges can be set on scheduler/gantt or feature, for convenience. Should only be processed by the TimeRanges
      // and not any subclasses


      if (client.timeRanges && !client._timeRangesExposed) {
        me._store.add(client.timeRanges);

        delete client.timeRanges;
      }

      if (me.timeRanges) {
        me._store.add(me.timeRanges);

        delete me.timeRanges;
      }
    } //endregion

  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'TimeRanges';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Store that holds timeRanges (using the {@link Scheduler.model.TimeSpan} model or subclass thereof).
         * A store will be automatically created if none is specified
         * @config {Object|Core.data.Store}
         */
        store: {
          modelClass: _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_14__["default"],
          storeId: 'timeRanges'
        },
        updateCurrentTimeLineInterval: 10000,

        /**
         * The date format to show in the header for the current time line, see {@link #config-showCurrentTimeLine}
         * @config {String}
         * @default
         */
        currentDateFormat: 'HH:mm',

        /**
         * Range definitions (data to {@link Scheduler.model.TimeSpan} models). Will be added to store.
         * @config {Scheduler.model.TimeSpan[]|Object[]}
         */
        timeRanges: null,

        /**
         * Show a line indicating current time
         * @config {Boolean}
         * @default
         */
        showCurrentTimeLine: false
      };
    }
  }]);

  return TimeRanges;
}(_AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


TimeRanges._$name = 'TimeRanges';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_15__["default"].registerFeature(TimeRanges, false, ['Scheduler', 'Gantt']);

/***/ }),

/***/ "./lib/Scheduler/feature/base/DragBase.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/feature/base/DragBase.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragBase; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../../Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");






















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/* eslint-disable no-unused-expressions */











/**
 * @module Scheduler/feature/base/DragBase
 */
//TODO: shift to copy
//TODO: dragging of event that starts & ends outside of view

/**
 * Base class for EventDrag (Scheduler) and TaskDrag (Gantt) features. Contains shared code. Not to be used directly.
 *
 * @extends Core/mixin/InstancePlugin
 * @abstract
 */

var DragBase = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(DragBase, _InstancePlugin);

  var _super = _createSuper(DragBase);

  function DragBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default()(this, DragBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default()(DragBase, [{
    key: "render",
    //endregion
    //region Init

    /**
     * Called when scheduler is rendered. Sets up drag and drop and hover tooltip.
     * @private
     */
    value: function render() {
      var _me$drag, _Object$assign;

      var me = this,
          client = me.client,
          constrainDragToTimeline = me.constrainDragToTimeline;
      (_me$drag = me.drag) === null || _me$drag === void 0 ? void 0 : _me$drag.destroy();
      me.drag = new _Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"](Object.assign((_Object$assign = {
        name: me.constructor.name,
        // useful when debugging with multiple draggers
        mode: 'translateXY'
      }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, client.isHorizontal ? 'lockY' : 'lockX', me.constrainDragToResource), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, client.isHorizontal ? 'lockX' : 'lockY', me.constrainDragToTimeSlot), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "minX", true), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "maxX", true), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "constrain", false), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "cloneTarget", !constrainDragToTimeline), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "dragWithin", constrainDragToTimeline ? null : document.body), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "hideOriginalElement", true), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "outerElement", client.timeAxisSubGridElement), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "targetSelector", client.eventSelector), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "isElementDraggable", function isElementDraggable(el, event) {
        return !client.readOnly && (!me.dragHelperConfig || !me.dragHelperConfig.isElementDraggable || me.dragHelperConfig.isElementDraggable(el, event)) && me.isElementDraggable(el, event);
      }), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "scrollManager", constrainDragToTimeline ? client.scrollManager : null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "transitionDuration", client.transitionDuration), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_Object$assign, "listeners", {
        beforedragstart: 'onBeforeDragStart',
        dragstart: 'onDragStart',
        drag: 'onDrag',
        drop: 'onDrop',
        abort: 'onDragAbort',
        reset: 'onDragReset',
        thisObj: me
      }), _Object$assign), me.dragHelperConfig));
      client.rowManager.on({
        changeTotalHeight: 'updateYConstraint',
        thisObj: me
      });

      if (me.showTooltip) {
        me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_26__["default"]({
          scheduler: client
        });
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$drag, _this$clockTemplate, _this$tip;

      (_this$drag = this.drag) === null || _this$drag === void 0 ? void 0 : _this$drag.destroy();
      (_this$clockTemplate = this.clockTemplate) === null || _this$clockTemplate === void 0 ? void 0 : _this$clockTemplate.destroy();
      (_this$tip = this.tip) === null || _this$tip === void 0 ? void 0 : _this$tip.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(DragBase.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Drag events

  }, {
    key: "onBeforeDragStart",
    value: function onBeforeDragStart(_ref) {
      var context = _ref.context;
      var me = this,
          client = me.client,
          name = client.scheduledEventName,
          eventRecord = client.resolveEventRecord(context.element);

      if (me.disabled || !eventRecord || eventRecord.isDraggable === false) {
        return false;
      } // Cache the date corresponding to the drag start point so that on drag, we can always
      // perform the same calculation to then find the time delta without having to calculate
      // the new start end end times from the position that the element is.


      context.pointerStartDate = client.getDateFromXY([context.startClientX, context.startPageY], null, false);
      var result = client.trigger("before".concat(name, "Drag"), {
        eventRecord: eventRecord,
        context: me.dragData
      }) !== false;

      if (result !== false) {
        me.updateYConstraint(eventRecord);
      }

      return result;
    } // Constrain to time slot means lockX if we're horizontal, otherwise lockY

  }, {
    key: "onDragStart",

    /**
     * Triggered when dragging of an event starts. Initializes drag data associated with the event being dragged.
     * @private
     */
    value: function onDragStart(_ref2) {
      var context = _ref2.context,
          event = _ref2.event;
      var me = this,
          client = me.client;
      me.currentOverClient = client;
      me.scrollClients = {};
      me.onMouseOverNewTimeline(client);
      var dragData = me.dragData = me.getDragData(context, event); // Do not let DomSync reuse the element

      context.element.retainElement = true;

      if (me.showTooltip) {
        var tipTarget = dragData.context.dragProxy ? dragData.context.dragProxy.firstChild : context.element;

        if (!me.tip) {
          me.tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_27__["default"]({
            id: "".concat(client.id, "-event-drag-tip"),
            align: 'b-t',
            autoShow: true,
            updateContentOnMouseMove: true,
            clippedBy: me.constrainDragToTimeline ? [client.timeAxisSubGridElement, client.bodyContainer] : null,
            forElement: tipTarget,
            getHtml: me.getTipHtml.bind(me),
            // During drag, it must be impossible for the mouse to be over the tip.
            style: 'pointer-events:none',
            cls: me.tooltipCls
          });
          me.tip.on('innerhtmlupdate', me.updateDateIndicator, me);
        } else {
          me.tip.showBy(tipTarget);
        }
      } // me.copyKeyPressed = me.isCopyKeyPressed();
      //
      // if (me.copyKeyPressed) {
      //     dragData.refElements.addCls('sch-event-copy');
      //     dragData.originalHidden = true;
      // }


      me.triggerDragStart(dragData);
    }
  }, {
    key: "updateDateIndicator",
    value: function updateDateIndicator() {
      var _this$dragData = this.dragData,
          startDate = _this$dragData.startDate,
          endDate = _this$dragData.endDate,
          tip = this.tip,
          endDateElement = tip.element.querySelector('.b-sch-tooltip-enddate');
      this.clockTemplate.updateDateIndicator(tip.element, startDate);
      endDateElement && this.clockTemplate.updateDateIndicator(endDateElement, endDate);
    }
    /**
     * Triggered while dragging an event. Updates drag data, validation etc.
     * @private
     */

  }, {
    key: "onDrag",
    value: function onDrag(_ref3) {
      var context = _ref3.context,
          event = _ref3.event;
      var me = this,
          dd = me.dragData,
          start = dd.startDate;
      var client;

      if (me.constrainDragToTimeline) {
        client = me.client;
      } else {
        var target = event.target; // Can't detect target under a touch event

        if (/^touch/.test(event.type)) {
          var center = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_25__["default"].from(dd.context.element, null, true).center;
          target = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].elementFromPoint(center.x, center.y);
        }

        client = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_30__["default"].fromElement(target, 'timelinebase');
      }

      var depFeature = me.client.features.dependencies,
          x = context.newX,
          y = context.newY;

      if (!client) {
        if (depFeature) {
          depFeature.updateDependenciesForTimeSpan(dd.draggedEntities[0], dd.context.element);
        }

        return;
      }

      if (client !== me.currentOverClient) {
        me.onMouseOverNewTimeline(client);
      } //this.checkShiftChange();


      me.updateDragContext(context, event); // Snapping not supported when dragging outside a scheduler

      if (me.constrainDragToTimeline && !me.constrainDragToTimeSlot && (me.showExactDropPosition || me.client.timeAxisViewModel.snap)) {
        var newDate = client.getDateFromCoordinate(me.getCoordinate(dd.draggedEntities[0], context.element, [x, y])),
            timeDiff = newDate - dd.sourceDate,
            realStart = new Date(dd.origStart - 0 + timeDiff),
            offset = client.timeAxisViewModel.getDistanceBetweenDates(realStart, dd.startDate);

        if (dd.startDate >= client.timeAxis.startDate && offset != null) {
          if (me.client.isVertical) {
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].addTranslateY(context.element, offset);
          } else {
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].addTranslateX(context.element, offset);
          }
        }
      } // Let product specific implementations trigger drag event (eventDrag, taskDrag)


      me.triggerEventDrag(dd, start);
      var valid = me.checkDragValidity(dd, event);

      if (valid && typeof valid !== 'boolean') {
        context.message = valid.message || '';
        valid = valid.valid;
      }

      context.valid = valid !== false;

      if (me.showTooltip) {
        me.tip.realign();
      }

      if (depFeature) {
        depFeature.updateDependenciesForTimeSpan(dd.draggedEntities[0], dd.context.element.querySelector(client.eventInnerSelector), dd.newResource);
      }
    }
  }, {
    key: "onMouseOverNewTimeline",
    value: function onMouseOverNewTimeline(newTimeline) {
      var me = this,
          scrollClients = me.scrollClients || {};
      me.currentOverClient.element.classList.remove('b-dragging-' + me.currentOverClient.scheduledEventName);
      newTimeline.element.classList.add('b-dragging-' + newTimeline.scheduledEventName);

      if (!(newTimeline.id in scrollClients)) {
        var scrollManager = newTimeline.scrollManager;
        scrollManager.startMonitoring({
          element: newTimeline.timeAxisSubGridElement
        });
        scrollClients[newTimeline.id] = newTimeline;
      }

      me.currentOverClient = newTimeline;
    }
    /**
     * Triggered when dropping an event. Finalizes the operation.
     * @private
     */

  }, {
    key: "onDrop",
    value: function onDrop(_ref4) {
      var _me$tip;

      var context = _ref4.context,
          event = _ref4.event;
      var me = this,
          currentOverClient = me.currentOverClient,
          dragData = me.dragData;
      var modified = false;
      me.updateDragContext(context, event);
      (_me$tip = me.tip) === null || _me$tip === void 0 ? void 0 : _me$tip.hide();

      if (context.valid && dragData.startDate && dragData.endDate) {
        dragData.finalize = function () {
          me.finalize.apply(me, arguments);
          context.finalize.apply(context, arguments);
        }; // Allow implementer to take control of the flow, by returning false from this listener,
        // to show a confirmation popup etc. This event is documented in EventDrag and TaskDrag


        currentOverClient.trigger("before".concat(currentOverClient.capitalizedEventName, "DropFinalize"), {
          context: dragData,
          event: event
        });
        context.async = dragData.async; // Internal validation, making sure all dragged records fit inside the view

        if (!context.async && me.isValidDrop(dragData)) {
          modified = dragData.startDate - dragData.origStart !== 0 || dragData.newResource !== dragData.resourceRecord;
        }
      }

      if (!context.async) {
        me.finalize(dragData.valid && context.valid && modified);
      }
    }
  }, {
    key: "onDragAbort",
    value: function onDragAbort(_ref5) {
      var _me$tip2;

      var context = _ref5.context;
      var me = this;
      me.client.currentOrientation.onDragAbort({
        context: context,
        dragData: me.dragData
      }); // otherwise the event disappears on next refresh (#62)

      me.resumeElementRedrawing(me.dragData.record);
      (_me$tip2 = me.tip) === null || _me$tip2 === void 0 ? void 0 : _me$tip2.hide(); // Trigger eventDragAbort / taskDragAbort depending on product

      me.triggerDragAbort(me.dragData);
    } // For the drag across multiple schedulers, tell all involved scroll managers to stop monitoring

  }, {
    key: "onDragReset",
    value: function onDragReset(_ref6) {
      var _me$currentOverClient, _me$dragData;

      var dragHelper = _ref6.source;
      var me = this,
          scrollClients = me.scrollClients || {};

      for (var managerId in scrollClients) {
        scrollClients[managerId].scrollManager.stopMonitoring(scrollClients[managerId].timeAxisSubGridElement);
      }

      if (dragHelper.context && dragHelper.context.started) {
        var eventBarEls = me.dragData.eventBarEls;
        eventBarEls[0].classList.remove('b-drag-main');
      }

      me.scrollClients = null;
      (_me$currentOverClient = me.currentOverClient) === null || _me$currentOverClient === void 0 ? void 0 : _me$currentOverClient.element.classList.remove('b-dragging-' + me.currentOverClient.scheduledEventName); // Dependencies are updated dynamically during drag, so ensure they are redrawn
      // if the event snaps back with no change after abort or an invalid drop.

      if (((_me$dragData = me.dragData) === null || _me$dragData === void 0 ? void 0 : _me$dragData.context.valid) === false && me.currentOverClient.features.dependencies) {
        me.currentOverClient.features.dependencies.scheduleDraw(true);
      } // TODO we should clean this up, requires review of the flow first
      // me.dragData = null;

    }
    /**
     * Triggered internally on invalid drop.
     * @private
     */

  }, {
    key: "onInternalInvalidDrop",
    value: function onInternalInvalidDrop() {
      var _this$tip2;

      (_this$tip2 = this.tip) === null || _this$tip2 === void 0 ? void 0 : _this$tip2.hide();
      this.drag.abort();
      this.triggerAfterDrop(this.dragData, false);
    } //endregion
    //region Finalization & validation

    /**
     * Called on drop to update the record of the event being dropped.
     * @private
     * @param {Boolean} updateRecords Specify true to update the record, false to treat as invalid
     */

  }, {
    key: "finalize",
    value: function () {
      var _finalize = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee(updateRecords) {
        var me, dragData, context, draggedEntities, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this, dragData = me.dragData, context = dragData.context, draggedEntities = dragData.draggedEntities;
                draggedEntities.forEach(function (record, i) {
                  me.resumeElementRedrawing(record);
                  dragData.eventBarEls[i].classList.remove(me.drag.draggingCls);
                  dragData.eventBarEls[i].retainElement = false;
                });

                if (!updateRecords) {
                  _context.next = 11;
                  break;
                }

                // updateRecords may or may not be async.
                // We see if it returns a Promise.
                result = me.updateRecords(dragData); // If updateRecords is async, the calling DragHelper must know this and
                // go into a awaitingFinalization state.

                if (!_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].isPromise(result)) {
                  _context.next = 8;
                  break;
                }

                context.async = true;
                _context.next = 8;
                return result;

              case 8:
                // If the finalize handler decided to change the dragData's validity...
                if (!dragData.valid) {
                  me.onInternalInvalidDrop();
                } else {
                  me.drag.reset();
                  me.triggerAfterDrop(dragData, true);
                }

                _context.next = 12;
                break;

              case 11:
                me.onInternalInvalidDrop();

              case 12:
                return _context.abrupt("return", result);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function finalize(_x) {
        return _finalize.apply(this, arguments);
      }

      return finalize;
    }() //endregion
    //region Drag data

    /**
     * Updates drag datas dates and validity (calls #validatorFn if specified)
     * @private
     */

  }, {
    key: "updateDragContext",
    value: function updateDragContext(info, event) {
      var me = this,
          drag = me.drag,
          dd = me.dragData,
          client = me.currentOverClient,
          isHorizontal = client.isHorizontal,
          element = info.element,
          proxyRegion = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_25__["default"].from(element, client.timeAxisSubGridElement),
          record = dd.draggedEntities[0],
          eventRecord = record.isAssignment ? record.event : record,
          constrainToTimeSlot = me.constrainDragToTimeSlot || (isHorizontal ? drag.lockX : drag.lockY);
      dd.browserEvent = event;

      if (constrainToTimeSlot) {
        dd.timeDiff = 0;
      } else {
        if (client.timeAxis.isContinuous) {
          var dateConstraints = dd.dateConstraints,
              timeAxisSubGrid = client.timeAxisSubGrid,
              scrollable = timeAxisSubGrid.scrollable,
              timeAxisRegion = scrollable.viewport,
              timeAxisPosition = client.isHorizontal ? info.pageX - timeAxisRegion.x + scrollable.x : info.pageY - timeAxisRegion.y + scrollable.y,
              pointerDate = client.timeAxisViewModel.getDateFromPosition(timeAxisPosition, null, true),
              timeDiff = dd.timeDiff = pointerDate - info.pointerStartDate; // calculate and round new startDate based on actual dd.timeDiff

          dd.startDate = me.adjustStartDate(dd.origStart, timeDiff);

          if (dateConstraints) {
            dd.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].constrain(dd.startDate, dateConstraints.start, new Date(dateConstraints.end - eventRecord.durationMS));
          }

          dd.endDate = new Date(dd.startDate - 0 + dd.duration);
        } else {
          var range = me.resolveStartEndDates(proxyRegion); // if dragging is out of timeAxis rect bounds, we will not be able to get dates

          dd.valid = Boolean(range.startDate && range.endDate);

          if (dd.valid) {
            dd.startDate = range.startDate;
            dd.endDate = range.endDate;
          }
        }

        if (dd.valid) {
          dd.timeDiff = dd.startDate - dd.origStart;
        }
      } // getProductDragContext may switch valid flag, need to keep it here


      Object.assign(dd, me.getProductDragContext(dd));

      if (dd.valid) {
        // If it's fully outside, we don't allow them to drop it - the event would disappear from their control.
        if (dd.endDate <= client.timeAxis.startDate || dd.startDate >= client.timeAxis.endDate) {
          dd.context.valid = false;
          dd.context.message = me.L('L{EventDrag.noDropOutsideTimeline}');
        } else {
          var result = !event || me.checkDragValidity(dd, event);

          if (!result || typeof result === 'boolean') {
            dd.context.valid = result !== false;
            dd.context.message = '';
          } else {
            dd.context.valid = result.valid !== false;
            dd.context.message = result.message;
          }
        }
      } else {
        dd.context.valid = false;
      }
    }
  }, {
    key: "suspendElementRedrawing",
    value: function suspendElementRedrawing(record) {
      var suspend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var element = this.getRecordElement(record);

      if (element) {
        element.retainElement = suspend;
      }

      record.instanceMeta(this.client).retainElement = suspend;
    }
  }, {
    key: "resumeElementRedrawing",
    value: function resumeElementRedrawing(record) {
      this.suspendElementRedrawing(record, false);
    }
    /**
     * Initializes drag data (dates, constraints, dragged events etc). Called when drag starts.
     * @private
     * @param info
     * @param event
     * @returns {*}
     */

  }, {
    key: "getDragData",
    value: function getDragData(info, event) {
      var me = this,
          client = me.client,
          drag = me.drag,
          _me$setupProductDragD = me.setupProductDragData(info),
          record = _me$setupProductDragD.record,
          dateConstraints = _me$setupProductDragD.dateConstraints,
          eventBarEls = _me$setupProductDragD.eventBarEls,
          draggedEntities = _me$setupProductDragD.draggedEntities,
          timespan = record.isAssignment ? record.event : record,
          origStart = timespan.startDate,
          origEnd = timespan.endDate,
          timeAxis = client.timeAxis,
          startsOutsideView = origStart < timeAxis.startDate,
          endsOutsideView = origEnd > timeAxis.endDate,
          coordinate = me.getCoordinate(timespan, info.element, [info.elementStartX, info.elementStartY]),
          clientCoordinate = me.getCoordinate(timespan, info.element, [info.startClientX, info.startClientY]); // prevent elements from being released when out of view


      draggedEntities.forEach(function (record) {
        return me.suspendElementRedrawing(record);
      }); // Select current without deselecting other events if Ctrl key is pressed

      if (drag.startEvent.ctrlKey) {
        if (record.isAssignment) {
          client.selectAssignment(record, true);
        } else {
          client.selectEvent(record, true);
        }
      }

      var dragData = {
        context: info,
        dateConstraints: dateConstraints,
        eventBarEls: eventBarEls,
        record: record,
        draggedEntities: draggedEntities,
        sourceDate: startsOutsideView ? origStart : client.getDateFromCoordinate(coordinate),
        screenSourceDate: client.getDateFromCoordinate(clientCoordinate, null, false),
        origStart: origStart,
        origEnd: origEnd,
        startDate: origStart,
        endDate: origEnd,
        timeDiff: 0,
        startsOutsideView: startsOutsideView,
        endsOutsideView: endsOutsideView,
        duration: origEnd - origStart,
        browserEvent: event // So we can know if SHIFT/CTRL was pressed

      };
      eventBarEls.forEach(function (el) {
        el.classList.add(drag.draggingCls);
        el.classList.remove('b-sch-event-hover');
        el.classList.remove('b-active');
      });

      if (eventBarEls.length > 1) {
        // RelatedElements are secondary elements moved by the same delta as the grabbed element
        if (!me.constrainDragToTimeline) {
          // Will be dragging a clone, need to do the same for all selected elements
          // TODO: This should be handled by DragHelper! It is basically a copy of code there for the main element
          info.relatedElements = eventBarEls.slice(1).map(function (eventBar) {
            // TODO: Should be able to simplify this to only use DomSync.addChild
            var offsetX = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].getOffsetX(eventBar, drag.dragWithin),
                offsetY = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].getOffsetY(eventBar, drag.dragWithin),
                offsetWidth = eventBar.offsetWidth,
                offsetHeight = eventBar.offsetHeight,
                element = drag.createProxy(eventBar); // Match the grabbed element's size and position.

            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].setTranslateXY(element, offsetX, offsetY);
            element.style.width = "".concat(offsetWidth, "px");
            element.style.height = "".concat(offsetHeight, "px"); //element.classList.add(drag.dragProxyCls);

            drag.dragWithin.appendChild(element);
            eventBar.classList.add('b-drag-original');

            if (drag.hideOriginalElement) {
              eventBar.classList.add('b-hidden');
            }

            return element;
          });
        } else {
          info.relatedElements = eventBarEls.slice(1);
        }

        info.relatedElStartPos = [];
        info.relatedElDragFromPos = []; // Move the selected events into a unified cascade.

        if (me.unifiedDrag) {
          // EventBarEls should animate into the cascade
          me.client.isAnimating = true;
          _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].on({
            element: eventBarEls[1],
            transitionend: function transitionend() {
              me.client.isAnimating = false;
            },
            once: true
          }); // Main dragged element should not look different. The relatedElements do.

          eventBarEls[0].classList.add('b-drag-main');

          var _DomHelper$getTransla = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].getTranslateXY(info.element),
              _DomHelper$getTransla2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_10___default()(_DomHelper$getTransla, 2),
              x = _DomHelper$getTransla2[0],
              y = _DomHelper$getTransla2[1];

          info.relatedElements.forEach(function (el, i) {
            // Cache the start pos for reversion in case of invalid drag
            info.relatedElStartPos[i] = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].getTranslateXY(el); // Move into cascade and cache the dragFrom pos

            x += 10;
            y += 10;
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].setTranslateXY(el, x, y);
            info.relatedElDragFromPos[i] = [x, y];
          });
        } else {
          // Start pos and dragFrom pos are the same for non-unified
          info.relatedElements.forEach(function (el, i) {
            info.relatedElStartPos[i] = info.relatedElDragFromPos[i] = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].getTranslateXY(el);
          });
        }
      }

      return dragData;
    } // Provide your custom implementation of this to allow additional selected records to be dragged together with the original one.

  }, {
    key: "getRelatedRecords",
    value: function getRelatedRecords(record) {
      return [];
    } //endregion
    //region Constraints
    // private

  }, {
    key: "setupConstraints",
    value: function setupConstraints(constrainRegion, elRegion, tickSize, constrained) {
      var me = this,
          xTickSize = !me.showExactDropPosition && tickSize > 1 ? tickSize : 0,
          yTickSize = 0; // If `constrained` is false then we haven't specified getDateConstraint method and should constrain mouse position to scheduling area
      // else we have specified date constraints and so we should limit mouse position to smaller region inside of constrained region using offsets and width.

      if (constrained) {
        me.setXConstraint(constrainRegion.left, constrainRegion.right - elRegion.width, xTickSize);
      } // And if not constrained, release any constraints from the previous drag.
      else {
          // minX being true means allow the start to be before the time axis.
          // maxX being true means allow the end to be after the time axis.
          me.setXConstraint(true, true, xTickSize);
        }

      me.setYConstraint(constrainRegion.top, constrainRegion.bottom - elRegion.height, yTickSize);
    }
  }, {
    key: "updateYConstraint",
    value: function updateYConstraint(eventRecord) {
      var me = this,
          client = me.client,
          context = me.drag.context,
          tickSize = client.timeAxisViewModel.snapPixelAmount; // If we're dragging when the vertical size is recalculated by the host grid,
      // we must update our Y constraint unless we are locked in the Y axis.

      if (context && !me.drag.lockY) {
        var constrainRegion; // This calculates a relative region which the DragHelper uses within its outerElement

        if (me.constrainDragToTimeline) {
          constrainRegion = client.getScheduleRegion(null, eventRecord);
        } // Not constraining to timeline.
        // Unusual configuration, but this must mean no Y constraining.
        else {
            me.setYConstraint(null, null, tickSize);
            return;
          }

        me.setYConstraint(constrainRegion.top, constrainRegion.bottom - context.element.offsetHeight, tickSize);
      } else {
        me.setYConstraint(null, null, tickSize);
      }
    }
  }, {
    key: "setXConstraint",
    value: function setXConstraint(iLeft, iRight, iTickSize) {
      var drag = this.drag;
      drag.leftConstraint = iLeft;
      drag.rightConstraint = iRight;
      drag.minX = iLeft;
      drag.maxX = iRight;
    }
  }, {
    key: "setYConstraint",
    value: function setYConstraint(iUp, iDown, iTickSize) {
      var drag = this.drag;
      drag.topConstraint = iUp;
      drag.bottomConstraint = iDown;
      drag.minY = iUp;
      drag.maxY = iDown;
    } //endregion
    //region Other stuff

  }, {
    key: "adjustStartDate",
    value: function adjustStartDate(startDate, timeDiff) {
      return this.client.timeAxis.roundDate(new Date(startDate - 0 + timeDiff), this.client.snapRelativeToEventStartDate ? startDate : false);
    }
  }, {
    key: "resolveStartEndDates",
    value: function resolveStartEndDates(proxyRect) {
      var _this$client$getStart = this.client.getStartEndDatesFromRectangle(proxyRect, 'round', this.dragData.duration),
          start = _this$client$getStart.start,
          end = _this$client$getStart.end;

      return {
        startDate: start,
        endDate: end
      };
    } //endregion
    //region Dragtip

    /**
     * Gets html to display in tooltip while dragging event. Uses clockTemplate to display start & end dates.
     */

  }, {
    key: "getTipHtml",
    value: function getTipHtml() {
      var _me$dragTipTemplate;

      var me = this,
          dragData = me.dragData,
          client = me.client,
          startDate = dragData.startDate,
          endDate = dragData.endDate,
          draggedEntities = dragData.draggedEntities,
          startText = client.getFormattedDate(startDate),
          endText = client.getFormattedEndDate(endDate, startDate),
          _dragData$context = dragData.context,
          valid = _dragData$context.valid,
          message = _dragData$context.message,
          dragged = draggedEntities[0],
          timeSpanRecord = dragged.isTask ? dragged : dragged.event;
      return me.dragTipTemplate((_me$dragTipTemplate = {
        valid: valid,
        startDate: startDate,
        endDate: endDate,
        startText: startText,
        endText: endText,
        dragData: dragData,
        message: message || ''
      }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_me$dragTipTemplate, client.scheduledEventName + 'Record', timeSpanRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_me$dragTipTemplate, "startClockHtml", me.clockTemplate.template({
        date: startDate,
        text: startText,
        cls: 'b-sch-tooltip-startdate'
      })), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_me$dragTipTemplate, "endClockHtml", timeSpanRecord.isMilestone ? '' : me.clockTemplate.template({
        date: endDate,
        text: endText,
        cls: 'b-sch-tooltip-enddate'
      })), _me$dragTipTemplate));
    } //endregion
    //region Product specific, implemented in subclasses
    // Check if element can be dropped at desired location

  }, {
    key: "isValidDrop",
    value: function isValidDrop(dragData) {
      throw new Error('Implement in subclass');
    } // Similar to the fn above but also calls validatorFn

  }, {
    key: "checkDragValidity",
    value: function checkDragValidity(dragData) {
      throw new Error('Implement in subclass');
    } // Update records being dragged

  }, {
    key: "updateRecords",
    value: function updateRecords(context) {
      throw new Error('Implement in subclass');
    } // Determine if an element can be dragged

  }, {
    key: "isElementDraggable",
    value: function isElementDraggable(el, event) {
      throw new Error('Implement in subclass');
    } // Get coordinate for correct axis

  }, {
    key: "getCoordinate",
    value: function getCoordinate(record, element, coord) {
      throw new Error('Implement in subclass');
    } // Product specific drag data

  }, {
    key: "setupProductDragData",
    value: function setupProductDragData(info) {
      throw new Error('Implement in subclass');
    } // Product specific data in drag context

  }, {
    key: "getProductDragContext",
    value: function getProductDragContext(dd) {
      throw new Error('Implement in subclass');
    }
  }, {
    key: "getRecordElement",
    value: function getRecordElement(record) {
      throw new Error('Implement in subclass');
    } //endregion

  }, {
    key: "constrainDragToTimeSlot",
    set: function set(value) {
      var axis = this.client.isHorizontal ? 'lockX' : 'lockY';
      this._constrainDragToTimeSlot = value;

      if (this.drag) {
        this.drag[axis] = value;
      }
    },
    get: function get() {
      return this._constrainDragToTimeSlot;
    } // Constrain to resource means lockY if we're horizontal, otherwise lockX

  }, {
    key: "constrainDragToResource",
    set: function set(value) {
      var axis = this.client.isHorizontal ? 'lockY' : 'lockX';
      this._constrainDragToResource = value;

      if (this.drag) {
        this.drag[axis] = value;
      }
    },
    get: function get() {
      return this._constrainDragToResource;
    }
  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        // documented on Schedulers EventDrag feature and Gantts TaskDrag
        dragTipTemplate: function dragTipTemplate(data) {
          return "\n                <div class=\"b-sch-tip-".concat(data.valid ? 'valid' : 'invalid', "\">\n                    ").concat(data.startClockHtml, "\n                    ").concat(data.endClockHtml, "\n                    <div class=\"b-sch-tip-message\">").concat(data.message, "</div>\n                </div>\n            ");
        },
        // documented on Schedulers EventDrag feature, not used for Gantt
        constrainDragToResource: true,

        /**
         * Specifies whether or not to show tooltip while dragging event
         * @config {Boolean}
         * @default
         */
        showTooltip: true,

        /**
         * When enabled, the event being dragged always "snaps" to the exact start date that it will have after drop.
         * @config {Boolean}
         * @default
         */
        showExactDropPosition: false,

        /**
         * Set to `false` to allow dragging tasks outside of the client Scheduler.
         * Useful when you want to drag tasks between multiple Scheduler instances
         * @config {Boolean}
         * @default
         */
        constrainDragToTimeline: true,

        /*
         * The store from which the dragged items are mapped to the UI.
         * In Scheduler's implementation of this base class, this will be
         * an EventStore, in Gantt's implementations, this will be a TaskStore.
         * Because both derive from this base, we must refer to it as this.store.
         * @private
         */
        store: null,

        /**
         * An object used to configure the internal {@link Core.helper.DragHelper} class
         * @config {Object}
         * @default
         */
        dragHelperConfig: null,
        tooltipCls: null
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['render']
      };
    }
  }]);

  return DragBase;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_21__["default"]);


DragBase._$name = 'DragBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/DragCreateBase.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/feature/base/DragCreateBase.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragCreateBase; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/helper/ResizeHelper.js */ "./lib/Core/helper/ResizeHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';









/**
 * @module Scheduler/feature/base/DragCreateBase
 */
// TODO: add hovertip if EvenDrag feature not used
// TODO: some of the code here could be shared with EventResize. make common base class?
// TODO: touch support
// TODO: mouse up outside not working as it should

/**
 * Base class for EventDragCreate (Scheduler) and TaskDragCreate (Gantt) features. Contains shared code. Not to be used directly.
 *
 * @extends Core/mixin/InstancePlugin
 */

var DragCreateBase = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(DragCreateBase, _InstancePlugin);

  var _super = _createSuper(DragCreateBase);

  function DragCreateBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, DragCreateBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(DragCreateBase, [{
    key: "doDestroy",
    value: function doDestroy() {
      var _this$tip, _this$resize;

      (_this$tip = this.tip) === null || _this$tip === void 0 ? void 0 : _this$tip.destroy();
      (_this$resize = this.resize) === null || _this$resize === void 0 ? void 0 : _this$resize.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DragCreateBase.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Proxy element & resizing

    /**
     * Adds a proxy element to illustrate the timespan that might be created
     * @param config
     * @param {Core.data.Model} config.rowRecord  The row for which an event proxy element is being created.
     * @param {Number} config.startX the position along the time axis at which to display the proxy element.
     * @param {Number} [config.width] the width of the proxy element.
     */

  }, {
    key: "addProxy",
    value: function addProxy(config) {
      var me = this,
          client = me.client,
          barMargin = client.barMargin,
          region = client.currentOrientation.getRowRegion(config.rowRecord);
      var width, height, proxyX, proxyY;

      if (client.isHorizontal) {
        proxyX = 'currentX' in config ? Math.min(config.startX, config.currentX + 1) : config.startX;
        proxyY = region.y + barMargin;
        width = config.width || me.dragTolerance;
        height = region.height - barMargin * 2;
      } else {
        proxyX = region.x + barMargin;
        proxyY = 'currentY' in config ? Math.min(config.startY, config.currentY + 1) : config.startY;
        width = region.width - barMargin * 2;
        height = config.height || me.dragTolerance;
      } // This CSS class is to block further drag creates when one is in progress (like awaiting async finalization)


      client.element.classList.add('b-dragcreating'); // This CSS class is to block hover for other events during actually dragging the proxy

      client.element.classList.add('b-dragcreating-proxy-sizing'); // We are dragging to size element from nothing. Its size on drag is calculated by its *initial size*, plus the
      // mouse movement delta, so it MUST start at zero for that to yield the correct result.

      return me.proxy = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].createElement({
        parent: client.foregroundCanvas,
        className: me.proxyCls,
        style: "transform:translate(".concat(proxyX, "px, ").concat(proxyY, "px);width:").concat(width, "px;height:").concat(height, "px"),
        // Prevent element from being recycled by DomHelper.sync()
        retainElement: true
      });
    }
    /**
     * Remove proxy element and clean up related stuff
     * @private
     */

  }, {
    key: "removeProxy",
    value: function removeProxy() {
      var me = this;

      if (me.proxy) {
        var _me$tip;

        me.proxy.remove();
        me.resize.destroy();
        me.proxy = me.resize = null; // This CSS class is to block further drag creates when one is in progress (like awaiting async finalization)

        me.client.element.classList.remove('b-dragcreating'); // This CSS class is to block hover for other events during actually dragging the proxy

        me.client.element.classList.remove('b-dragcreating-proxy-sizing');
        (_me$tip = me.tip) === null || _me$tip === void 0 ? void 0 : _me$tip.hide();
      }
    }
    /**
     * Creates an instance of ResizeHelper used to resize the proxy element
     * @param event
     * @param data
     */

  }, {
    key: "initResizer",
    value: function initResizer(event, data) {
      var _me$resize;

      var me = this,
          client = me.client;
      var edge;

      if (client.isHorizontal) {
        edge = data.currentX > data.startX ? 'right' : 'left';
      } else {
        edge = data.currentY > data.startY ? 'bottom' : 'top';
      }

      (_me$resize = me.resize) === null || _me$resize === void 0 ? void 0 : _me$resize.destroy();
      me.resize = new _Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
        name: me.constructor.name,
        // For debugging
        direction: client.isVertical ? 'vertical' : 'horizontal',
        isTouch: event.type.startsWith('touch'),
        dragThreshold: me.dragTolerance,
        grab: {
          element: me.proxy,
          edge: edge,
          event: data.startEvent
        },
        allowEdgeSwitch: true,
        // Means that they can switch edges; the mouse can cross the zero point and drag the other way
        outerElement: client.timeAxisSubGridElement,
        // Constrain resize to view
        scrollManager: client.scrollManager,
        scroller: client.timeAxisSubGrid.scrollable,
        // Scroll in both directions
        listeners: {
          resizing: 'onResizing',
          resize: 'onResize',
          cancel: 'onCancel',
          thisObj: me
        }
      });
      me.resize.context.resource = data.resource;
    } //endregion
    //region Tooltip

    /**
     * Creates a tooltip that displays start & end dates. Anchored to the proxy element
     */

  }, {
    key: "initTooltip",
    value: function initTooltip() {
      var me = this,
          client = me.client;

      if (me.showTooltip) {
        if (me.tip) {
          me.tip.showBy(me.getTooltipTarget());
        } else {
          me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_19__["default"]({
            scheduler: client
          });
          me.tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_18__["default"]({
            id: "".concat(client.id, "-drag-create-tip"),
            autoShow: true,
            trackMouse: false,
            updateContentOnMouseMove: true,
            getHtml: me.getTipHtml.bind(me),
            align: client.isVertical ? 't-b' : 'b100-t100',
            hideDelay: 0,
            axisLock: true // Don't want it flipping to the side where we are dragging

          });
          me.tip.on('innerhtmlupdate', me.updateDateIndicator, me);
        }
      }
    }
  }, {
    key: "updateDateIndicator",
    value: function updateDateIndicator() {
      var me = this,
          _me$createContext = me.createContext,
          startDate = _me$createContext.startDate,
          endDate = _me$createContext.endDate,
          tip = me.tip,
          endDateElement = tip.element.querySelector('.b-sch-tooltip-enddate');

      if (startDate && endDate) {
        me.clockTemplate.updateDateIndicator(tip.element, startDate);
        endDateElement && me.clockTemplate.updateDateIndicator(endDateElement, endDate);
      }
    }
    /**
     * Updates tooltips contents
     * @returns {*}
     */

  }, {
    key: "getTipHtml",
    value: function getTipHtml() {
      if (!this.resize.context) {
        return;
      } // keeping this on separate row to not mess up look of other declarations


      var me = this,
          client = me.client,
          _me$resize$context = me.resize.context,
          edge = _me$resize$context.edge,
          newX = _me$resize$context.newX,
          newY = _me$resize$context.newY,
          elementStartX = _me$resize$context.elementStartX,
          elementStartY = _me$resize$context.elementStartY,
          elementWidth = _me$resize$context.elementWidth,
          elementHeight = _me$resize$context.elementHeight,
          newWidth = _me$resize$context.newWidth,
          newHeight = _me$resize$context.newHeight,
          valid = _me$resize$context.valid,
          message = _me$resize$context.message;
      var start, end;

      if (client.isHorizontal) {
        var x = edge === 'left' ? newX : elementStartX,
            // Coordinates are 0 based, widths are not so subtracting 1 from the widths
        endX = Math.min(Math.max(x + (newWidth || elementWidth) - 1, 0), client.timeAxisViewModel.totalSize - 1);
        start = client.getDateFromCoordinate(x, 'round', true);
        end = client.getDateFromCoordinate(endX, 'round', true);
      } else {
        var y = edge === 'top' ? newY : elementStartY,
            // Coordinates are 0 based, widths are not so subtracting 1 from the widths
        endY = Math.min(Math.max(y + (newHeight || elementHeight) - 1, 0), client.timeAxisViewModel.totalSize - 1);
        start = client.getDateFromCoordinate(y, 'round', true);
        end = client.getDateFromCoordinate(endY, 'round', true);
      }

      var first = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].min(start, end),
          last = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].max(start, end),
          startText = first && client.getFormattedDate(first),
          endText = last && end && client.getFormattedEndDate(last, first);
      return me.tipTemplate({
        startDate: first,
        endDate: last,
        startClockHtml: me.clockTemplate.template({
          date: first,
          text: startText,
          cls: 'b-sch-tooltip-startdate'
        }),
        endClockHtml: me.clockTemplate.template({
          // actual end date and display date may differ
          date: client.getDisplayEndDate(last, first),
          text: endText,
          cls: 'b-sch-tooltip-enddate'
        }),
        valid: valid,
        startText: startText,
        endText: endText,
        message: message
      });
    } //endregion
    //region Finalize (create EventModel)

  }, {
    key: "finalize",
    value: function finalize(doCreate) {
      var me = this;

      var resetFinalization = function resetFinalization() {
        me.proxy.retainElement = false;
        me.reset();
      };

      var completeFinalization = function completeFinalization() {
        me.client.trigger('afterDragCreate', {
          proxyElement: me.proxy
        });
        resetFinalization();
      };

      if (doCreate) {
        // Call product specific implementation
        var result = me.finalizeDragCreate(me.createContext);

        if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isPromise(result)) {
          result.then(completeFinalization, resetFinalization);
        } else {
          completeFinalization();
        }
      } else {
        completeFinalization();
      }
    } //endregion
    //region Events

  }, {
    key: "onElementMouseDown",
    value: function onElementMouseDown(event) {
      var me = this,
          client = me.client; // detect mouse down directly in scheduler cell

      if (event.button === 0 && event.target.matches('.b-sch-timeaxis-cell') && !me.disabled && !client.readOnly) {
        var rowRecord = client.isVertical ? client.resolveResourceRecord(event) : client.getRecordFromElement(event.target); // no drag creation in group headers etc.

        if (rowRecord.isSpecialRow) {
          return;
        }

        if (me.preventMultiple && !me.isRowEmpty(rowRecord)) {
          return;
        }

        me.monitorMove = true;
        me.createContext = {
          startEvent: event,
          startScreenX: event.screenX,
          startScreenY: event.screenY,
          startX: event.offsetX,
          startY: event.offsetY,
          cellElement: event.target,
          rowRecord: rowRecord
        };
        me.mouseUpDetacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].on({
          element: document.body,
          mouseup: 'onMouseUp',
          once: true,
          thisObj: this
        });
      }
    }
  }, {
    key: "onElementMouseMove",
    value: function onElementMouseMove(event) {
      var me = this;

      if (me.monitorMove) {
        var createContext = me.createContext,
            client = me.client,
            delta = client.isVertical ? createContext.startScreenY - event.screenY : createContext.startScreenX - event.screenX;

        if (Math.abs(delta) > me.dragTolerance) {
          var dateTime = client.getDateFromDomEvent(event),
              region = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__["default"].from(client.timeAxisSubGridElement, null, true);

          if (me.handleBeforeDragCreate(dateTime, event) === false) {
            me.monitorMove = false;
            return;
          } // Math.max with 0 because if the mousedown is within dragTolerance of
          // the left edge and then drag goes left, dragging can begin with
          // the X in negative territory.


          createContext.currentX = Math.max(event.clientX - region.x + client.timeAxisSubGrid.scrollable.x, 0);
          createContext.currentY = Math.max(event.clientY - region.y + client.timeAxisSubGrid.scrollable.y, 0);
          me.addProxy(me.createContext);
          me.initResizer(event, me.createContext);
          me.initTooltip();
          me.monitorMove = false;
          client.trigger('dragCreateStart', {
            proxyElement: me.proxy
          });
        }
      } // If dragcreate is async, resizer was already reset and we should not
      // align tooltip anymore


      if (me.proxy && me.showTooltip && me.resize.context) {
        me.tip.alignTo(me.getTooltipTarget());
      }
    }
  }, {
    key: "getTooltipTarget",
    value: function getTooltipTarget() {
      var me = this,
          target = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__["default"].from(me.proxy, null, true);

      if (me.client.isVertical) {
        // Align to the dragged edge of the proxy, and then bump bottom so that the anchor aligns perfectly.
        if (me.resize.context.edge === 'bottom') {
          target.y = target.bottom - 1;
        }

        target.height = me.tip.anchorSize[1] / 2;
      } else {
        // Align to the dragged edge of the proxy, and then bump right so that the anchor aligns perfectly.
        if (me.resize.context.edge === 'right') {
          target.x = target.right - 1;
        }

        target.width = me.tip.anchorSize[0] / 2;
      }

      return {
        target: target
      };
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp() {
      var me = this;
      me.client.element.classList.remove('b-dragcreating-proxy-sizing');
      me.monitorMove = false;
    }
    /**
     * Prevent right click when drag creating
     * @returns {Boolean}
     * @internal
     */

  }, {
    key: "onElementContextMenu",
    value: function onElementContextMenu() {
      if (this.proxy) {
        return false;
      }
    }
  }, {
    key: "onResizing",
    value: function onResizing(_ref) {
      var context = _ref.context,
          event = _ref.event;
      var me = this,
          client = me.client,
          x = context.edge === 'left' ? context.newX : context.elementStartX,
          y = context.edge === 'top' ? context.newY : context.elementStartY,
          endX = Math.min(x + Math.max((context.newWidth || context.elementWidth) - 1, 0), client.timeAxisViewModel.totalSize - 1),
          endY = Math.min(y + Math.max((context.newHeight || context.elementHeight) - 1, 0), client.timeAxisViewModel.totalSize - 1),
          startCoord = client.isVertical ? y : x,
          endCoord = client.isVertical ? endY : endX,
          first = client.getDateFromCoordinate(startCoord, 'round', true),
          last = client.getDateFromCoordinate(endCoord, 'round', true),
          dc = me.dateConstraints;
      var start = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].min(first, last),
          end = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].max(first, last);

      if (dc) {
        end = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].constrain(end, dc.start, dc.end);
        start = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].constrain(start, dc.start, dc.end);
      }

      Object.assign(me.createContext, {
        startDate: start,
        endDate: end
      });
      context.valid = me.checkValidity(me.createContext, event);
      context.message = '';

      if (context.valid && typeof context.valid !== 'boolean') {
        context.message = context.valid.message;
        context.valid = context.valid.valid;
      } // If users returns nothing, that's interpreted as valid


      context.valid = context.valid !== false;
    }
  }, {
    key: "onResize",
    value: function onResize(_ref2) {
      var valid = _ref2.context.valid,
          event = _ref2.event;
      var me = this,
          _me$createContext2 = me.createContext,
          startDate = _me$createContext2.startDate,
          endDate = _me$createContext2.endDate;

      if (!startDate || !endDate || endDate - startDate <= 0) {
        valid = false;
      }

      me.createContext = me.prepareCreateContextForFinalization(me.createContext, event, me.finalize.bind(me));

      if (valid) {
        me.client.trigger('beforeDragCreateFinalize', {
          context: me.createContext,
          event: event,
          proxyElement: me.proxy
        });
      } // Drag create could be finalized immediately


      if (me.createContext) {
        // OMG, how not to confuse those contexts?
        me.resize.context.async = me.createContext.async;

        if (!me.createContext.async) {
          me.finalize(valid);
        } else {
          // We do not want to remove resizer yet, because it will also remove context and proxy element (or resize to 0 width)
          // Instead we blindfold resize helper to prevent event resize from starting parallel drag create
          me.resize.removeListeners();
        }
      }
    }
  }, {
    key: "prepareCreateContextForFinalization",
    value: function prepareCreateContextForFinalization(createContext, event, finalize) {
      var async = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return Object.assign({}, createContext, {
        async: async,
        event: event,
        finalize: finalize
      });
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.cancel();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.reset();
      this.mouseUpDetacher && this.mouseUpDetacher();
    }
  }, {
    key: "reset",
    value: function reset() {
      var me = this;
      me.removeProxy();
      me.createContext = null;
      me.monitorMove = false;
    } //endregion
    //region Product specific, implemented in subclasses

  }, {
    key: "checkValidity",
    value: function checkValidity(context, event) {
      throw new Error('Implement in subclass');
    }
  }, {
    key: "triggerDragCreateEnd",
    value: function triggerDragCreateEnd(newRecord, context) {
      throw new Error('Implement in subclass');
    }
  }, {
    key: "handleBeforeDragCreate",
    value: function handleBeforeDragCreate(dateTime, event) {
      throw new Error('Implement in subclass');
    }
  }, {
    key: "isRowEmpty",
    value: function isRowEmpty(rowRecord) {
      throw new Error('Implement in subclass');
    } //endregion

  }, {
    key: "dragging",
    get: function get() {
      return this.resize;
    }
  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        /**
         * true to show a time tooltip when dragging to create a new event
         * @config {Boolean}
         * @default
         */
        showTooltip: true,

        /**
         * Number of pixels the drag target must be moved before dragging is considered to have started. Defaults to 2.
         * @config {Number}
         * @default
         */
        dragTolerance: 2,
        // used by gantt to only allow one task per row
        preventMultiple: false,
        validatorFn: function validatorFn() {},

        /**
         * `this` reference for the validatorFn
         * @config {Object}
         */
        validatorFnThisObj: null,

        /**
         * CSS class to add to proxy used when creating a new event
         * @config {String}
         * @default
         * @private
         */
        proxyCls: 'b-sch-dragcreator-proxy',
        tipTemplate: function tipTemplate(data) {
          return "\n                <div class=\"b-sch-tip-".concat(data.valid ? 'valid' : 'invalid', "\">\n                    ").concat(data.startClockHtml, "\n                    ").concat(data.endClockHtml, "\n                    <div class=\"b-sch-tip-message\">").concat(data.message, "</div>\n                </div>\n            ");
        }
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['onElementMouseDown', 'onElementMouseMove'],
        before: ['onElementContextMenu']
      };
    }
  }]);

  return DragCreateBase;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


DragCreateBase._$name = 'DragCreateBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/EditBase.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/feature/base/EditBase.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EditBase; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.every */ "./node_modules/core-js/modules/es.array.every.js");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_Config_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../../Core/Config.js */ "./lib/Core/Config.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");




































function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_27___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_32___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Scheduler/feature/base/EditBase
 */

var DH = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"],
    makeDate = function makeDate(fields) {
  // single field, update record directly
  if (fields.length === 1) return fields[0].value; // two fields, date + time
  else if (fields.length === 2) {
      var _ref = fields[0] instanceof _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_36__["default"] ? fields : fields.reverse(),
          _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34___default()(_ref, 2),
          date = _ref2[0],
          time = _ref2[1],
          dateValue = DH.parse(date.value);

      if (dateValue) {
        dateValue.setHours(time.value.getHours(), time.value.getMinutes(), time.value.getSeconds(), time.value.getMilliseconds());
      } // Clone to not end up sharing dates


      return dateValue ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"].clone(dateValue) : null;
    } // shouldn't happen...

  return null;
},
    copyTime = function copyTime(dateTo, dateFrom) {
  var d = new Date(dateTo.getTime());
  d.setHours(dateFrom.getHours(), dateFrom.getMinutes());
  return d;
},
    adjustEndDate = function adjustEndDate(startDate, startTime, me) {
  // The end datetime just moves in response to the changed start datetime, keeping the same duration.
  if (startDate && startTime) {
    var newEndDate = DH.add(copyTime(me.startDateField.value, me.startTimeField.value), me.eventRecord.durationMS, 'milliseconds');
    me.endDateField.value = newEndDate;
    me.endTimeField.value = DH.clone(newEndDate);
  }
};
/**
 * Base class for EventEdit (Scheduler) and TaskEdit (Gantt) features. Contains shared code. Not to be used directly.
 *
 * @extends Core/mixin/InstancePlugin
 */


var EditBase = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_31___default()(EditBase, _InstancePlugin);

  var _super = _createSuper(EditBase);

  function EditBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default()(this, EditBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default()(EditBase, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(client, config) {
      var _client$on;

      var me = this;
      client.eventEdit = me;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default()(EditBase.prototype), "construct", this).call(this, client, _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].assign({
        weekStartDay: client.weekStartDay
      }, config));

      me.clientListenersDetacher = client.on((_client$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_27___default()(_client$on, me.triggerEvent, me.onActivateEditor), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_27___default()(_client$on, "dragcreateend", me.onDragCreateEnd), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_27___default()(_client$on, "thisObj", me), _client$on));
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$editor;

      this.clientListenersDetacher();
      (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_33___default()(EditBase.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Editing

  }, {
    key: "changeEditorConfig",
    value: function changeEditorConfig(editorConfig) {
      // extraItems is deprecated
      var items = this.items,
          extraItems = this.extraItems; // Merge extraItems in either format into a copy of the default editorConfig.

      if (extraItems) {
        editorConfig = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_41__["default"].clone(editorConfig);
        editorConfig = this.insertExtraWidgetsIntoDefaultWidgets(editorConfig);
      } // Merge items which is an Object with the default editorConfig's items
      else if (items) {
          editorConfig = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_41__["default"].clone(editorConfig);
          editorConfig.items = _Core_Config_js__WEBPACK_IMPORTED_MODULE_40__["default"].merge(items, editorConfig.items);
        }

      return editorConfig;
    }
    /**
     * Insert extra fields into default Editor fields according to specific rules:
     * - If no index provided insert them into `extraItems` placeholder (or at the end if not);
     * - If index provided sort ASC and insert one by one, but only after no-index fields are inserted;
     * - If `extraItems` placeholder exists, don't take widgets that go after it into account;
     * @private
     */

  }, {
    key: "insertExtraWidgetsIntoDefaultWidgets",
    value: function insertExtraWidgetsIntoDefaultWidgets(editorConfig) {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].deprecate('Scheduler', '5.0.0', 'extraItems replaced by items in EditFeature.');
      var me = this,
          extraItems = me.extraItems,
          items = editorConfig.items,
          extraItemsAsArray = Array.isArray(extraItems) ? extraItems : extraItems && Object.values(extraItems);

      if (!extraItems || !Object.keys(extraItemsAsArray).length) {
        return editorConfig;
      } // If they still use index instead of weight, we honour it for now.


      var hasIndex = Object.values(extraItemsAsArray).some(function (i) {
        return 'index' in i;
      });

      if (hasIndex) {
        var _extraItemsAsArray = Array.isArray(extraItems) ? extraItems : extraItems && _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].transformNamedObjectToArray(extraItems);

        _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].deprecate('Scheduler', '5.0.0', 'index in extraItems replaced by weight to sort editor items'); // items needs to be an array to have extra items inserted at an index.

        var itemsAsArray = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].transformNamedObjectToArray(items),
            lastItem = itemsAsArray[itemsAsArray.length - 1]; // Find default extra widgets position

        var index = itemsAsArray.findIndex(function (widget) {
          return widget.type === 'extraItems';
        }),
            tail; // If extra widgets placeholder exists

        if (index > -1) {
          // Remove extra widgets placeholder from its position
          itemsAsArray.splice(index, 1); // Backup everything that goes after extra widgets placeholder, like Save/Delete/Cancel buttons

          tail = itemsAsArray.splice(index);
        } // Split extra widgets on 2 parts: those which have index and those which haven't


        var withIndex = _extraItemsAsArray.filter(function (widget) {
          return widget.index >= 0;
        }),
            withoutIndex = _extraItemsAsArray.filter(function (widget) {
          return !(widget.index >= 0);
        }); // Add those without index to the end of the default widgets


        withoutIndex.forEach(function (item, index) {
          return item.weight = lastItem.weight + index * 100;
        });
        itemsAsArray = itemsAsArray.concat(withoutIndex); // Sort those which have index in ASC order, so we insert fields in series

        withIndex.sort(function (widgetA, widgetB) {
          return widgetA.index - widgetB.index;
        }); // And now insert extra widgets at their individually specified index

        withIndex.forEach(function (widget) {
          var previousWidget = itemsAsArray[Math.min(widget.index, itemsAsArray.length) - 1];
          widget.weight = previousWidget ? previousWidget.weight + 1 : -100;
          itemsAsArray.splice(widget.index, 0, widget);
        });

        if (tail && tail.length) {
          // Return backuped fields to the end of the widgets
          itemsAsArray = itemsAsArray.concat(tail);
        } // Convert it back to object form.


        editorConfig.items = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].transformArrayToNamedObject(itemsAsArray);
      } // Merge object form of extraItems into editorConfig's items
      else {
          // Default is to append so make high weight
          var weight = 900;

          var _iterator = _createForOfIteratorHelper(Array.isArray(extraItems) ? extraItems : Object.values(extraItems)),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;

              if (!item.ref) {
                item.ref = item.id;
              }

              item.weight = weight += 100;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          editorConfig.items = _objectSpread(_objectSpread({}, items), Array.isArray(extraItems) ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"].transformArrayToNamedObject(extraItems) : extraItems);
        }

      return editorConfig;
    }
  }, {
    key: "onDatesChange",
    value: function onDatesChange(params) {
      var me = this,
          field = params.source,
          value = params.value;

      switch (field.ref) {
        case 'startDateField':
          me.startTimeField && adjustEndDate(value, me.startTimeField.value, me);
          break;

        case 'startTimeField':
          me.startDateField && adjustEndDate(me.startDateField.value, value, me);
          break;
      }

      if (me.endTimeField) {
        // If the event starts and ends on the same day, the time fields need
        // to have their min and max set against each other.
        if (DH.isEqual(DH.clearTime(me.startDateField.value), DH.clearTime(me.endDateField.value))) {
          me.endTimeField.min = me.startTimeField.value;
        } else {
          me.endTimeField.min = null;
        }
      }
    } //endregion
    //region Save

  }, {
    key: "save",
    value: function () {
      var _save = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('Implement in subclass');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "onBeforeSave",

    /**
     * Template method, intended to be overridden. Called before the event record has been updated.
     * @param {Scheduler.model.EventModel} eventRecord The event record
     *
     **/
    value: function onBeforeSave(eventRecord) {}
    /**
     * Template method, intended to be overridden. Called after the event record has been updated.
     * @param {Scheduler.model.EventModel} eventRecord The event record
     *
     **/

  }, {
    key: "onAfterSave",
    value: function onAfterSave(eventRecord) {}
    /**
     * Updates record being edited with values from the editor
     * @private
     */

  }, {
    key: "updateRecord",
    value: function updateRecord(record) {
      var values = this.values; // Clean resourceId / resources out of values when using assignment store, it will handle the assignment

      if (this.scheduler.assignmentStore) {
        delete values.resource;
      }

      record.set(values);
    } //endregion
    //region Events

  }, {
    key: "resetEditingContext",
    value: function resetEditingContext() {
      var me = this; // reset flag indicating that we are editing

      me.isEditing = false;
      me.targetEventElement = null;
      me.client.element.classList.remove('b-eventeditor-editing');
      me.phantomEventElement && me.phantomEventElement.remove();
      me.phantomEventElement = null;
    }
  }, {
    key: "onPopupKeyDown",
    value: function onPopupKeyDown(_ref3) {
      var event = _ref3.event;

      if (!this.readOnly && event.key === 'Enter' && this.saveAndCloseOnEnter && event.target.tagName.toLowerCase() === 'input') {
        // Need to prevent this key events from being fired on whatever receives focus after the editor is hidden
        event.preventDefault(); // If enter key was hit in an input element of a start field, need to adjust end date fields (the same way as if #onDatesChange handler was called)

        if (event.target.name === 'startDate') {
          adjustEndDate(this.startDateField.value, this.startTimeField.value, this);
        }

        this.onSaveClick();
      }
    }
  }, {
    key: "onSaveClick",
    value: function () {
      var _onSaveClick = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default.a.mark(function _callee2() {
        var saved;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.save();

              case 2:
                saved = _context2.sent;

                if (saved) {
                  this.editor.close();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onSaveClick() {
        return _onSaveClick.apply(this, arguments);
      }

      return onSaveClick;
    }()
  }, {
    key: "onDeleteClick",
    value: function () {
      var _onDeleteClick = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_26___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default.a.mark(function _callee3() {
        var removed;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_24___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.deleteEvent();

              case 2:
                removed = _context3.sent;

                if (removed) {
                  // We expect deleteEvent will trigger close if autoClose is true and focus has moved out,
                  // otherwise need to call it manually
                  if (!this.editor.autoClose || this.editor.containsFocus) {
                    this.editor.close();
                  }
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onDeleteClick() {
        return _onDeleteClick.apply(this, arguments);
      }

      return onDeleteClick;
    }()
  }, {
    key: "onCancelClick",
    value: function onCancelClick() {
      this.editor.close();
    } //endregion

  }, {
    key: "isValid",
    get: function get() {
      var me = this;
      return Object.values(me.editor.widgetMap).every(function (field) {
        if (!field.name || field.hidden) {
          return true;
        }

        return field.isValid !== false;
      });
    }
  }, {
    key: "values",
    get: function get() {
      var me = this,
          editor = me.editor,
          startFields = [],
          endFields = [],
          values = {};
      editor.eachWidget(function (widget) {
        var _editor$widgetMap$rec;

        var name = widget.name; // If the widget is part of the recurrence editor, we don't gather it.

        if (!name || widget.hidden || widget.up(function (w) {
          return w === me.recurrenceEditor;
        })) {
          return;
        }

        switch (name) {
          case 'startDate':
            startFields.push(widget);
            break;

          case 'endDate':
            endFields.push(widget);
            break;

          case 'resource':
            values[name] = widget.record;
            break;

          case 'recurrenceRule':
            // If recurrence set to null, completely clear the recurrenceRule.
            // Otherwise it will still be perceived as recurring with the rule 'FREQ=none'
            values[name] = ((_editor$widgetMap$rec = editor.widgetMap.recurrenceCombo) === null || _editor$widgetMap$rec === void 0 ? void 0 : _editor$widgetMap$rec.value) === 'none' ? '' : widget.value;
            break;

          default:
            values[name] = widget.value;
        }
      }, true); // Handle fields being configured away

      if (startFields.length) {
        values.startDate = makeDate(startFields);
      }

      if (endFields.length) {
        values.endDate = makeDate(endFields);
      } // Since there is no duration field in the editor,
      // we don't need to recalc duration value on each date change.
      // It's enough to return correct duration value in `values`,
      // so the record will get updated with the correct data.


      if ('startDate' in values && 'endDate' in values) {
        values.duration = DH.diff(values.startDate, values.endDate, me.editor.record.durationUnit, true);
      }

      return values;
    }
  }], [{
    key: "configurable",
    //region Config
    get: function get() {
      return {
        /**
         * Deprecated. Use the `editorConfig` config:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit  : {
         *             editorConfig : {
         *                 autoClose : false,
         *                 modal     : true
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {Boolean}
         * @default
         * @category Editor
         * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
         */
        autoClose: true,

        /**
         * True to save and close this panel if ENTER is pressed in one of the input fields inside the panel.
         * @config {Boolean}
         * @default
         * @category Editor
         */
        saveAndCloseOnEnter: true,
        triggerEvent: null,

        /**
         * Deprecated. Use the `items` config:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit : {
         *             editorConfig : {
         *                 bbar : {
         *                     items : {
         *                         deleteButton : false
         *                     }
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {Boolean}
         * @default
         * @category Editor widgets
         * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
         */
        showDeleteButton: true,

        /**
         * Deprecated. Use the `items` config:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit : {
         *             items : {
         *                 nameField : {
         *                     hidden : true
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {Boolean}
         * @default
         * @category Editor widgets
         * @deprecated 4.0.0 Configure the {@link #config-items}:
         */
        showNameField: true,

        /**
         * Deprecated. Use the `items` config:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit : {
         *             timeFormat : 'HH:mm',
         *             items      : {
         *                 startTimeField : {
         *                     // We use 24 hour clock: use less space
         *                     flex   : '1 0 30%'
         *                 },
         *                 endTimeField : {
         *                     flex   : '1 0 30%'
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {Object}
         * @category Editor widgets
         * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
         */
        startTimeConfig: null,

        /**
         * Deprecated. Use the `items` config:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit : {
         *             items : {
         *                 startDateField : {
         *                     // Allow click back and forward by 1 day
         *                     step: '1d'
         *                 },
         *                 endDateField : {
         *                     step: '1d'
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {Object}
         * @category Editor widgets
         * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
         */
        startDateConfig: null,

        /**
         * Deprecated. Use the `items` config:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit  : {
         *             timeFormat : 'HH:mm',
         *             items : {
         *                 startTimeField : {
         *                     // We use 24 hour clock: use less space
         *                     flex   : '1 0 30%'
         *                 },
         *                 endTimeField : {
         *                     flex   : '1 0 30%'
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {Object}
         * @category Editor widgets
         * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
         */
        endTimeConfig: null,

        /**
         * Deprecated. Use the `items` config:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit  : {
         *             items : {
         *                 startDateField : {
         *                     // Allow click back and forward by 1 day
         *                     step: '1d'
         *                 },
         *                 endDateField : {
         *                     step: '1d'
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {Object}
         * @category Editor widgets
         * @deprecated 4.0.0 Configure the {@link #config-editorConfig}:
         */
        endDateConfig: null,

        /**
         * This config parameter is passed to the `startDateField` and `endDateField` constructor.
         * @config {String}
         * @default
         * @category Editor widgets
         */
        dateFormat: 'L',
        // date format that uses browser locale

        /**
         * This config parameter is passed to the `startTimeField` and `endTimeField` constructor.
         * @config {String}
         * @default
         * @category Editor widgets
         */
        timeFormat: 'LT',
        // date format that uses browser locale

        /**
         * Default editor configuration, which widgets it shows etc.
         *
         * This is the entry point into configuring any aspect of the editor.
         *
         * The {@link Core.widget.Container#config-items} configuration of a Container
         * is *deeply merged* with its default `items` value. This means that you can specify
         * an `editorConfig` object which configures the editor, or widgets inside the editor:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit  : {
         *             editorConfig : {
         *                 autoClose : false,
         *                 modal     : true,
         *                 cls       : 'editor-widget-cls',
         *                 items : {
         *                     resourceField : {
         *                         hidden : true
         *                     },
         *                     // Add our own event owner field at the top of the form.
         *                     // Weight -100 will make it sort top the top.
         *                     ownerField : {
         *                         weight : -100,
         *                         type   : 'usercombo',
         *                         name   : 'owner',
         *                         label  : 'Owner'
         *                     }
         *                 },
         *                 bbar : {
         *                     items : {
         *                         deleteButton : false
         *                     }
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {Object}
         * @category Editor
         */
        editorConfig: null,

        /**
         * Deprecated. Use the `items` config:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit  : {
         *             items : {
         *                 owner : {
         *                     weight : -100, // Will sort above system-supplied fields which are weight 0
         *                     type   : 'usercombo',
         *                     name   : 'owner',
         *                     label  : 'Owner'
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         * @config {String|Object[]}
         * @category Editor widgets
         * @deprecated 4.0.0 Use the {@link #config-items} config
         */
        extraItems: null,

        /**
         * An object to merge with the provided items config of the editor to override the
         * configuration of provided fields, or add new fields.
         *
         * Example:
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit  : {
         *             items : {
         *                 // Merged with provided config of the resource field
         *                 resourceField : {
         *                     label : 'Calendar'
         *                 },
         *                 owner : {
         *                     weight : -100, // Will sort above system-supplied fields which are weight 0
         *                     type   : 'usercombo',
         *                     name   : 'owner',
         *                     label  : 'Owner'
         *                 }
         *             }
         *         }
         *     }
         * });
         *```
         *
         * The provided fields are called
         *  - `nameField`
         *  - `resourceField`
         *  - `startDateField`
         *  - `startTimeField`
         *  - `endDateField`
         *  - `endTimeField`
         *  - `recurrenceCombo`
         *  - `editRecurrenceButton`
         * @config {Object}
         * @category Editor widgets
         */
        items: null,

        /**
         * The week start day used in all date fields of the feature editor form by default.
         * 0 means Sunday, 6 means Saturday.
         * Defaults to the locale's week start day.
         * @config {Number}
         */
        weekStartDay: null
      };
    }
  }]);

  return EditBase;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_35__["default"]);


EditBase._$name = 'EditBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/ResizeBase.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/feature/base/ResizeBase.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResizeBase; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler'; //TODO: Prevent right click while resizing (do it in ResizeHelper?)
//TODO: Scroll







/**
 * @module Scheduler/feature/base/ResizeBase
 */

var tipAlign = {
  top: 'b-t',
  right: 'b100-t100',
  bottom: 't-b',
  left: 'b0-t0'
};
/**
 * Base class for EventResize (Scheduler) and TaskResize (Gantt) features. Contains shared code. Not to be used directly.
 *
 * @extends Core/mixin/InstancePlugin
 * @abstract
 */

var ResizeBase = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(ResizeBase, _InstancePlugin);

  var _super = _createSuper(ResizeBase);

  function ResizeBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ResizeBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(ResizeBase, [{
    key: "render",
    //endregion
    //region Init & destroy
    value: function render() {
      var me = this;
      me.resize && me.resize.destroy();
      me.resize = me.createResizeHelper();

      if (me.showTooltip) {
        me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_19__["default"]({
          scheduler: me.client
        });
      }
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this;
      me.tip && me.tip.destroy();
      me.clockTemplate && me.clockTemplate.destroy();
      me.resize && me.resize.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(ResizeBase.prototype), "doDestroy", this).call(this);
    } //endregion
    //region Events

  }, {
    key: "isElementResizable",
    value: function isElementResizable(element, event) {
      var client = this.client,
          resize = this.resize,
          timespanRecord = client.resolveTimeSpanRecord(element);

      if (client.readOnly) {
        return false;
      }

      var resizable = timespanRecord && timespanRecord.isResizable; // go up from "handle" to resizable element

      element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].up(event.target, client.eventSelector); // Not resizable if the mousedown is on a resizing handle of
      // a percent bar.

      var handleHoldingElement = element ? element.firstElementChild : element,
          handleEl = event.target.closest('[class$="-handle"]');

      if (!resizable || handleEl && handleEl !== handleHoldingElement) {
        return false;
      }

      var startsOutside = element.classList.contains('b-sch-event-startsoutside'),
          endsOutside = element.classList.contains('b-sch-event-endsoutside');

      if (resizable === true) {
        if (startsOutside && endsOutside) {
          return false;
        } else if (startsOutside) {
          resizable = 'end';
        } else if (endsOutside) {
          resizable = 'start';
        } else {
          return resize.overStartHandle(event, element) || resize.overEndHandle(event, element);
        }
      }

      if (startsOutside && resizable === 'start' || endsOutside && resizable === 'end') {
        return false;
      }

      if (resize.overStartHandle(event, element) && resizable === 'start' || resize.overEndHandle(event, element) && resizable === 'end') {
        return true;
      }

      return false;
    }
  }, {
    key: "onBeforeResizeStart",
    value: function onBeforeResizeStart(_ref) {
      var _client$trigger;

      var element = _ref.element,
          event = _ref.event;
      var client = this.client,
          name = client.scheduledEventName,
          timespanRecord = client.resolveTimeSpanRecord(element);

      if (this.disabled) {
        return false;
      } // trigger beforeEventResize or beforeTaskResize depending on product


      return client.trigger("before".concat(client.capitalizedEventName, "Resize"), (_client$trigger = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger, name + 'Record', timespanRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger, "event", event), _client$trigger)) !== false;
    }
  }, {
    key: "onResizeStart",
    value: function onResizeStart(_ref2) {
      var _client$trigger2;

      var context = _ref2.context,
          event = _ref2.event;
      var me = this,
          client = me.client,
          timespanRecord = client.resolveTimeSpanRecord(context.element),
          name = client.scheduledEventName;
      client.element.classList.add('b-resizing-event'); // Let products to their specific stuff

      me.setupProductResizeContext(context, event);

      if (me.showTooltip) {
        if (me.tip) {
          me.tip.align = tipAlign[context.edge];
          me.tip.showBy(me.getTooltipTarget());
        } else {
          me.tip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_18__["default"]({
            id: "".concat(client.id, "-event-resize-tip"),
            autoShow: true,
            axisLock: true,
            trackMouse: false,
            updateContentOnMouseMove: true,
            getHtml: me.getTipHtml.bind(me),
            align: tipAlign[context.edge],
            hideDelay: 0
          });
          me.tip.on('innerhtmlupdate', me.updateDateIndicator, me);
        }
      } // flag to not allow release of element when scrolling


      timespanRecord.instanceMeta(client).retainElement = true; // Trigger eventResizeStart or taskResizeStart depending on product

      client.trigger("".concat(name, "ResizeStart"), (_client$trigger2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger2, "".concat(name, "Record"), timespanRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger2, "event", event), _client$trigger2));
    }
  }, {
    key: "updateDateIndicator",
    value: function updateDateIndicator() {
      var _this$resize$context = this.resize.context,
          edge = _this$resize$context.edge,
          startDate = _this$resize$context.startDate,
          endDate = _this$resize$context.endDate,
          element = this.tip.element;

      if (startDate || endDate) {
        if (edge === 'right' || edge === 'bottom') {
          this.clockTemplate.updateDateIndicator(element.querySelector('.b-sch-tooltip-enddate'), endDate);
        } else {
          this.clockTemplate.updateDateIndicator(element, startDate);
        }
      }
    }
  }, {
    key: "getTooltipTarget",
    value: function getTooltipTarget() {
      var me = this,
          target = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_17__["default"].from(me.resize.context.element, null, true);

      if (me.resize.direction === 'horizontal') {
        // Align to the dragged edge of the proxy, and then bump right so that the anchor aligns perfectly.
        if (me.resize.context.edge === 'right') {
          target.x = target.right - 1;
        }

        target.width = me.tip.anchorSize[0] / 2;
      } else {
        // Align to the dragged edge of the proxy, and then bump bottom so that the anchor aligns perfectly.
        if (me.resize.context.edge === 'bottom') {
          target.y = target.bottom - 1;
        }

        target.height = me.tip.anchorSize[1] / 2;
      }

      return {
        target: target
      };
    }
  }, {
    key: "onResizing",
    value: function onResizing(_ref3) {
      var _client$trigger3;

      var context = _ref3.context,
          event = _ref3.event;
      var me = this,
          client = me.client,
          depFeature = client.features.dependencies,
          timespanRecord = me.getTimespanRecord(context),
          name = client.scheduledEventName,
          element = context.element,
          edge = context.edge,
          xy = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getTranslateXY(element);
      var start, end;

      if (edge === 'top' || edge === 'left') {
        end = timespanRecord.endDate;

        if (client.snapRelativeToEventStartDate) {
          start = client.getDateFromXY(xy, null, true);
          start = client.timeAxis.roundDate(start, timespanRecord.startDate);
        } else {
          start = client.getDateFromXY(xy, 'round', true);
        }
      } // bottom || right
      else {
          xy[0] += element.offsetWidth;
          xy[1] += element.offsetHeight;
          start = timespanRecord && timespanRecord.startDate;

          if (client.snapRelativeToEventStartDate) {
            end = client.getDateFromXY(xy, null, true);
            end = client.timeAxis.roundDate(end, timespanRecord.endDate);
          } else {
            end = client.getDateFromXY(xy, 'round', true);
          }
        }

      start = start || context.startDate;
      end = end || context.endDate;

      if (context.dateConstraints) {
        start = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].constrain(start, context.dateConstraints.start, context.dateConstraints.end);
        end = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].constrain(end, context.dateConstraints.start, context.dateConstraints.end);
      }

      if (me.showExactResizePosition || client.timeAxisViewModel.snap) {
        var exactSize = edge === 'top' || edge === 'left' ? client.timeAxisViewModel.getDistanceBetweenDates(start, timespanRecord.endDate) : client.timeAxisViewModel.getDistanceBetweenDates(timespanRecord.startDate, end);

        switch (edge) {
          case 'top':
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].setTranslateY(element, context.elementStartY + context.elementWidth - exactSize);
            element.style.height = exactSize + 'px';
            break;

          case 'right':
            element.style.width = exactSize + 'px';
            break;

          case 'bottom':
            element.style.height = exactSize + 'px';
            break;

          case 'left':
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].setTranslateX(element, context.elementStartX + context.elementWidth - exactSize);
            element.style.width = exactSize + 'px';
            break;
        }
      }

      var dateChanged = context.endDate - end !== 0 || context.startDate - start !== 0;
      context.endDate = end;
      context.startDate = start; // No need to query on every pixel of mouse move

      if (dateChanged) {
        context.valid = me.checkValidity(context, event);
      } // Trigger eventPartialResize or taskPartialResize depending on product


      client.trigger("".concat(name, "PartialResize"), (_client$trigger3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger3, "".concat(name, "Record"), timespanRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger3, "startDate", start), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger3, "endDate", end), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger3, "element", element), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger3, "context", context), _client$trigger3));

      if (depFeature) {
        depFeature.updateDependenciesForTimeSpan(timespanRecord, element);
      }

      if (me.showTooltip) {
        me.tip.alignTo(me.getTooltipTarget());
      }
    }
  }, {
    key: "checkValidity",
    value: function checkValidity(context, event) {
      var valid = context.startDate && context.endDate > context.startDate && this.validatorFn.call(this.validatorFnThisObj || this, context, event);

      if (valid && typeof valid !== 'boolean') {
        context.message = valid.message || '';
        valid = valid.valid;
      }

      return valid !== false;
    }
  }, {
    key: "onFinishResize",
    value: function onFinishResize(_ref4) {
      var drag = _ref4.source,
          context = _ref4.context,
          event = _ref4.event;
      var me = this,
          timespanRecord = me.getTimespanRecord(context),
          oldStart = timespanRecord.startDate,
          oldEnd = timespanRecord.endDate,
          start = context.startDate || oldStart,
          end = context.endDate || oldEnd,
          client = me.client;
      var modified = false;

      if (me.tip) {
        me.tip.hide();
      } // allow release of element again


      timespanRecord.instanceMeta(client).retainElement = false;
      context.oldFinalize = context.finalize;

      context.finalize = function () {
        // We are overriding context of the resize helper. It is finalized automatically on sync resize. Which means,
        // we should only call finalize if context is async.
        context.async && me.finalize.apply(me, arguments);
      };

      context.valid = start && end && end - start > 0 && ( // Input sanity check
      start - oldStart !== 0 || end - oldEnd !== 0) && // Make sure start OR end changed
      context.valid !== false;

      if (context.valid) {
        // Seems to be a valid resize operation, ask outside world if anyone wants to take control over the finalizing,
        // to show a confirm dialog prior to applying the new values. Triggers beforeEventResizeFinalize or
        // beforeTaskResizeFinalize depending on product
        client.trigger("before".concat(client.scheduledEventName, "ResizeFinalize"), {
          context: context,
          event: event
        });
        modified = true;
      }

      if (!context.async) {
        me.finalize(modified);
      }
    }
  }, {
    key: "onCancelResize",
    value: function onCancelResize(_ref5) {
      var context = _ref5.context;
      var timespanRecord = this.getTimespanRecord(context); // resizing may not have started at all (just clicking a resize handle)

      if (timespanRecord) {
        timespanRecord.instanceMeta(this.client).retainElement = false;
      }

      this.finalize(false);
    }
  }, {
    key: "finalize",
    value: function () {
      var _finalize = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee(updateRecord) {
        var me, client, context, timespanRecord, name, wasChanged, dependencies;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this, client = me.client, context = me.resize.context, timespanRecord = me.getTimespanRecord(context), name = client.scheduledEventName;
                wasChanged = false;

                if (me.tip) {
                  me.tip.hide();
                }

                if (!context.started) {
                  _context.next = 9;
                  break;
                }

                if (!updateRecord) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return me.internalUpdateRecord(context, timespanRecord);

              case 7:
                wasChanged = _context.sent;

              case 8:
                if (!updateRecord || !wasChanged) {
                  dependencies = client.features.dependencies;
                  me.resize.abortResize(null, true); // Dependencies are updated dynamically during resize, so ensure they are redrawn
                  // if the event snaps back with no change.

                  if (dependencies) {
                    dependencies.scheduleDraw(true);
                  }
                } else {
                  context.oldFinalize();
                }

              case 9:
                client.element.classList.remove('b-resizing-event'); // Triggers eventResizeEnd or taskResizeEnd depending on product

                client.trigger("".concat(name, "ResizeEnd"), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()({
                  changed: wasChanged
                }, "".concat(name, "Record"), timespanRecord || client.resolveEventRecord(context.element)));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function finalize(_x) {
        return _finalize.apply(this, arguments);
      }

      return finalize;
    }() //endregion
    //region Tooltip

  }, {
    key: "getTipHtml",
    value: function getTipHtml(_ref6) {
      var tip = _ref6.tip;
      var me = this;
      var _me$resize$context = me.resize.context,
          startDate = _me$resize$context.startDate,
          endDate = _me$resize$context.endDate,
          valid = _me$resize$context.valid,
          message = _me$resize$context.message; // Empty string hides the tip - we get called before the Resizer, so first call will be empty

      if (!startDate || !endDate) {
        return tip.html;
      }

      if (message === undefined) message = '';
      endDate = me.client.getDisplayEndDate(endDate, startDate);
      var startText = me.client.getFormattedDate(startDate),
          endText = me.client.getFormattedDate(endDate);
      return me.tipTemplate({
        valid: valid,
        startDate: startDate,
        endDate: endDate,
        startText: startText,
        endText: endText,
        message: message,
        startClockHtml: me.clockTemplate.template({
          date: startDate,
          text: startText,
          cls: 'b-sch-tooltip-startdate'
        }),
        endClockHtml: me.clockTemplate.template({
          date: endDate,
          text: endText,
          cls: 'b-sch-tooltip-enddate'
        })
      });
    } //endregion
    //region Product specific, implemented in subclasses

  }, {
    key: "getRowRecord",
    value: function getRowRecord(context) {
      throw new Error('Implement in subclass');
    }
  }, {
    key: "getTimespanRecord",
    value: function getTimespanRecord(context) {
      throw new Error('Implement in subclass');
    }
  }, {
    key: "setupProductResizeContext",
    value: function setupProductResizeContext(context, event) {
      throw new Error('Implement in subclass');
    } // Store containing the timespan record being resized

  }, {
    key: "store",
    get: function get() {
      throw new Error('Implement in subclass');
    } //endregion

  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        /**
         * `false` to not show a tooltip while resizing
         * @config {Boolean}
         * @default
         */
        showTooltip: true,

        /**
         * true to see exact event length during resizing
         * @config {Boolean}
         * @default
         */
        showExactResizePosition: false,

        /**
         * An empty function by default, but provided so that you can perform custom validation on
         * the item being resized. Return true if the new duration is valid, false to signal that it is not.
         * @param {Object} context The resize context, contains the record & dates.
         * @param {Scheduler.model.TimeSpan} context.record The record being resized.
         * @param {Date} context.startDate The new start date.
         * @param {Date} context.endDate The new start date.
         * @param {Event} event The browser Event object
         * @return {Boolean}
         * @config {Function}
         */
        validatorFn: function validatorFn() {},

        /**
         * `this` reference for the validatorFn
         * @config {Object}
         */
        validatorFnThisObj: null,

        /**
         * The tooltip instance to show while resizing an event or a configuration object for the {@link Core.widget.Tooltip}.
         * @config {Core.widget.Tooltip}
         */
        tip: null,
        tipTemplate: function tipTemplate(data) {
          return "\n                <div class=\"b-sch-tip-".concat(data.valid ? 'valid' : 'invalid', "\">\n                    ").concat(data.startClockHtml, "\n                    ").concat(data.endClockHtml, "\n                    <div class=\"b-sch-tip-message\">").concat(data.message, "</div>\n                </div>\n            ");
        }
      };
    }
  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['render']
      };
    }
  }]);

  return ResizeBase;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__["default"]);


ResizeBase._$name = 'ResizeBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/ResourceTimeRangesBase.js":
/*!**************************************************************!*\
  !*** ./lib/Scheduler/feature/base/ResourceTimeRangesBase.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRangesBase; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/feature/base/ResourceTimeRangesBase
 */

/**
 * Abstract base class for ResourceTimeRanges and ResourceNonWorkingTime features.
 * You should not use this class directly.
 *
 * @extends Core/mixin/InstancePlugin
 * @abstract
 */

var ResourceTimeRangesBase = /*#__PURE__*/function (_InstancePlugin$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(ResourceTimeRangesBase, _InstancePlugin$mixin);

  var _super = _createSuper(ResourceTimeRangesBase);

  function ResourceTimeRangesBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ResourceTimeRangesBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(ResourceTimeRangesBase, [{
    key: "noFeatureElementsInAxis",
    // Let Scheduler know if we have ResourceTimeRanges in view or not
    value: function noFeatureElementsInAxis() {
      var timeAxis = this.scheduler.timeAxis;
      return this.store && !this.store.storage.values.some(function (t) {
        return timeAxis.isTimeSpanInAxis(t);
      });
    } //endregion
    //region Init

  }, {
    key: "construct",
    value: function construct(scheduler, config) {
      var me = this;
      me.scheduler = scheduler;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(ResourceTimeRangesBase.prototype), "construct", this).call(this, scheduler, config);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      if (this.client.isPainted) {
        this.client.refresh();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(ResourceTimeRangesBase.prototype), "doDisable", this).call(this, disable);
    } //endregion

  }, {
    key: "getEventsToRender",
    value: function getEventsToRender(resource, events) {
      throw new Error('Implement in subclass');
    } // Called for each event during render, allows manipulation of render data. Adjust any resource time ranges
    // (chained function from Scheduler)

  }, {
    key: "onEventDataGenerated",
    value: function onEventDataGenerated(renderData) {
      var me = this,
          eventRecord = renderData.eventRecord;

      if (me.shouldInclude(eventRecord)) {
        if (me.scheduler.isVertical) {
          renderData.width = me.scheduler.resourceColumnWidth;
        } else {
          renderData.top = 0;
        } // Flag that we should fill entire row/col


        renderData.fillSize = true; // Add our own cls

        renderData.wrapperCls[me.rangeCls] = 1;
        renderData.wrapperCls["b-sch-color-".concat(eventRecord.timeRangeColor)] = eventRecord.timeRangeColor; // Add label

        renderData.children.push(eventRecord.name); // Event data for DOMSync comparison

        renderData.eventId = "".concat(me.idPrefix, "-").concat(eventRecord.id);
      }
    }
  }, {
    key: "shouldInclude",
    value: function shouldInclude(eventRecord) {
      throw new Error('Implement in subclass');
    } // Called when a ResourceTimeRangeModel is manipulated, relays to Scheduler#onInternalEventStoreChange which updates to UI

  }, {
    key: "onStoreChange",
    value: function onStoreChange(event) {
      this.scheduler.onInternalEventStoreChange(event);
    }
  }], [{
    key: "pluginConfig",
    //region Config
    // Plugin configuration. This plugin chains some of the functions in Grid.
    get: function get() {
      return {
        chain: ['getEventsToRender', 'onEventDataGenerated', 'noFeatureElementsInAxis']
      };
    }
  }]);

  return ResourceTimeRangesBase;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__["default"].mixin(_data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_15__["default"])); // No feature based styling needed, do not add a cls to Scheduler



ResourceTimeRangesBase.featureClass = '';
ResourceTimeRangesBase._$name = 'ResourceTimeRangesBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/TimeSpanMenuBase.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/feature/base/TimeSpanMenuBase.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeSpanMenuBase; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Grid_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Grid/feature/base/ContextMenuBase.js */ "./lib/Grid/feature/base/ContextMenuBase.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/feature/base/TimeSpanMenuBase
 */

/**
 * Abstract base class used by other context menu features which show the context menu for TimeAxis.
 * Using this class you can make sure the menu expects the target to disappear,
 * since it can be scroll out of the scheduling zone.
 *
 * Features that extend this class are:
 *  * {@link Scheduler/feature/EventMenu EventMenu};
 *  * {@link Scheduler/feature/ScheduleMenu ScheduleMenu};
 *  * {@link Scheduler/feature/TimeAxisHeaderMenu TimeAxisHeaderMenu};
 *
 * @extends Grid/feature/base/ContextMenuBase
 * @abstract
 */

var TimeSpanMenuBase = /*#__PURE__*/function (_ContextMenuBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(TimeSpanMenuBase, _ContextMenuBase);

  var _super = _createSuper(TimeSpanMenuBase);

  function TimeSpanMenuBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TimeSpanMenuBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TimeSpanMenuBase, [{
    key: "menuConfig",
    get: function get() {
      var me = this;
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].assign({}, _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(TimeSpanMenuBase.prototype), "menuConfig", this), {
        // It's a rectangle outside which the target of alignment may disappear.
        // It has to be like that because when scrolling in a scheduler, there are two scrolling elements.
        // The main Scheduler body for up/down and the subgrid for left and right
        clippedBy: [me.client.timeAxisSubGridElement, me.client.bodyContainer]
      });
    }
  }]);

  return TimeSpanMenuBase;
}(_Grid_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


TimeSpanMenuBase._$name = 'TimeSpanMenuBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js":
/*!*********************************************************************!*\
  !*** ./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeSpanRecordContextMenuBase; });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Scheduler/feature/base/TimeSpanRecordContextMenuBase
 */
// This is a version of what Containers do, except that we have to apply our namedItems
// all the way down any configured menu hierarchy, and the resulting structure must
// be available *before* menu instantiation for the processItems method to interrogate.

function applyNamedItems(items, namedItems) {
  for (var ref in items) {
    var item = items[ref];

    if (item) {
      if (ref in namedItems) {
        item = items[ref] = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default()(item) === 'object' ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].merge(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].clone(namedItems[ref]), item) : namedItems[ref];
      } // Our namedItems must apply all the way down any descendant menus.
      // Extract menu here because it may have been applied by a namedItem.


      var menu = item.menu;

      if (menu) {
        applyNamedItems('items' in menu ? menu.items : menu, namedItems);
      }
    }
  }
}

;
/**
 * DEPRECATED: This class is deprecated since v4.0.0.
 * It is **not** used by our features anymore and remains here only for backward compatibility.
 * If you already extended this class please re-implement it utilizing our new
 * {@link Scheduler.feature.base.TimeSpanMenuBase } abstract base class.
 *
 * @extends Core/mixin/InstancePlugin
 * @abstract
 * @deprecated 4.0.0
 */

var TimeSpanRecordContextMenuBase = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TimeSpanRecordContextMenuBase, _InstancePlugin);

  var _super = _createSuper(TimeSpanRecordContextMenuBase);

  function TimeSpanRecordContextMenuBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, TimeSpanRecordContextMenuBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(TimeSpanRecordContextMenuBase, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(grid, config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimeSpanRecordContextMenuBase.prototype), "construct", this).call(this, grid, config);

      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].deprecate('Scheduler', '5.0.0', '`TimeSpanRecordContextMenuBase` feature is deprecated, in favor of `TimeSpanMenuBase` feature. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.');
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      if (this.menu) {
        this.menu.destroy();
      }
    } //endregion
    //region Events

  }, {
    key: "onElementContextMenu",
    value: function onElementContextMenu(event) {
      this.triggerEvent === 'contextmenu' && this.showEventContextMenu(event);
    }
  }, {
    key: "onElementClick",
    value: function onElementClick(event) {
      this.triggerEvent === 'click' && this.showEventContextMenu(event);
    }
  }, {
    key: "onElementDblClick",
    value: function onElementDblClick(event) {
      this.triggerEvent === 'dblclick' && this.showEventContextMenu(event);
    } // chained from EventNavigation

  }, {
    key: "onEventSpaceKey",
    value: function onEventSpaceKey(keyEvent) {
      var targetPoint = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_16__["default"].from(keyEvent.target).center,
          contextmenuEvent = new MouseEvent('contextmenu', Object.assign({
        clientX: targetPoint.x,
        clientY: targetPoint.y
      }, keyEvent));
      Object.defineProperty(contextmenuEvent, 'target', {
        get: function get() {
          return keyEvent.target;
        }
      });
      this.showEventContextMenu(contextmenuEvent);
    } //endregion
    //region Menu handlers

    /**
     * Show event context menu.
     * @param event
     * @internal
     */

  }, {
    key: "showEventContextMenu",
    value: function showEventContextMenu(event) {
      var me = this,
          client = me.client,
          target = event.target,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].up(target, client.eventSelector),
          targetElement = eventElement || target;

      if (targetElement) {
        var record = me.resolveRecord(targetElement);

        if (record) {
          event.preventDefault();
          me.showContextMenuFor(record, {
            targetElement: targetElement,
            eventElement: eventElement,
            event: event
          });
        }
      }
    }
    /**
     * A method to retrieve record from its DOM element. Must be implemented in subclasses.
     * @abstract
     */

  }, {
    key: "resolveRecord",
    value: function resolveRecord() {}
    /**
     * Shows context menu for the provided record. If record is not rendered (outside of time span, or collapsed)
     * menu won't appear.
     * @param {Scheduler.model.TimeSpan} record
     * @param {Object} [options]
     * @param {HTMLElement} options.targetElement Element to align context menu to
     * @param {HTMLElement} options.eventElement Event element if target is an event, otherwise `null`
     * @param {Event} options.event Browser event. If provided menu will be aligned according to clientX/clientY coordinates.
     * If omitted, context menu will be centered to targetElement
     */

  }, {
    key: "showContextMenuFor",
    value: function showContextMenuFor(record, options) {} // Implement in subclasses to massage options or veto show.

  }, {
    key: "beforeContextMenuShow",
    value: function beforeContextMenuShow() {} //endregion
    //region Show/Hide

    /**
     * @param {Object} eventParams
     * @param {Object[]} items
     * @internal
     */

  }, {
    key: "showContextMenu",
    value: function showContextMenu(eventParams) {
      if (this.disabled) {
        return;
      }

      var me = this,
          event = eventParams.event,
          menuType = eventParams.menuType.toLowerCase(),
          eventType = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].uncapitalize(menuType),
          clientGetItemsMethod = "get".concat(_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].capitalize(menuType), "MenuItems"),
          client = me.client,
          processItems = me.processItems,
          defaultItems = me.defaultItems,
          namedItems = me.namedItems,
          point = event ? [event.clientX + 1, event.clientY + 1] : _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_16__["default"].from(eventParams.targetElement).center,
          items = eventParams.items = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isEmpty(me.items) ? _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].clone(defaultItems) : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].merge(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].clone(defaultItems), me.items);
      eventParams.namedItems = namedItems;
      eventParams.selection = client.selectedRecords; // Apply the named items prior to Container's item processing.
      // Our namedItems must cascade to all descendant Menu levels.
      // And they MUST have all been converted prior to the processItems call.

      applyNamedItems(items, namedItems); // Call the chainable method which other features use to add their own menu items.
      // For example getEventMenuItems

      if (client[clientGetItemsMethod]) {
        client[clientGetItemsMethod](eventParams, items);
      } // Allow user a chance at processing the items and preventing the menu from showing


      if ((!processItems || processItems(eventParams) !== false) && !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isEmpty(eventParams.items)) {
        // beforeContextMenuShow is a lifecycle method which may be implemented in subclasses to
        // preprocess the event.
        if (me.beforeContextMenuShow(eventParams) !== false) {
          // Trigger event that allows preventing menu or manipulating its items
          if (client.trigger("".concat(eventType, "ContextMenuBeforeShow"), eventParams) !== false) {
            me.menu = _Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].showContextMenu(point, {
              owner: client,
              scrollAction: 'hide',
              clippedBy: [client.timeAxisSubGridElement, client.bodyContainer],
              constrainTo: window,
              items: items,
              onDestroy: function onDestroy() {
                me.menu = null;
              },
              // Load up the item event with the contextual info
              onBeforeItem: function onBeforeItem(itemEvent) {
                Object.assign(itemEvent, eventParams);
              },
              onItem: function onItem(itemEvent) {
                return client.trigger("".concat(eventType, "ContextMenuItem"), itemEvent);
              },
              listeners: {
                show: function show(_ref) {
                  var menu = _ref.source;
                  eventParams.menu = menu;
                  client.trigger("".concat(eventType, "ContextMenuShow"), eventParams);
                }
              }
            });
          }
        }
      }
    }
    /**
     * Hides the context menu
     * @internal
     */

  }, {
    key: "hideContextMenu",
    value: function hideContextMenu(animate) {
      this.menu && this.menu.hide(animate);
    } //endregion
    //region Getters/Setters

    /**
     * Provides the default configuration of the context menu.
     *
     * Concrete classes must all provide their own defaultItems value in their defaultConfig blocks
     * @private
     */

  }, {
    key: "defaultItems",
    set: function set(defaultItems) {
      this._defaultItems = defaultItems;
    },
    get: function get() {
      var result = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].clone(this._defaultItems); // Read-only client should have no default items enabled

      if (this.client.readOnly) {
        for (var item in result) {
          result[item] = false;
        }
      }

      return result;
    }
  }, {
    key: "triggerEvent",
    get: function get() {
      return this._triggerEvent || this.client.contextMenuTriggerEvent;
    },
    set: function set(value) {
      this._triggerEvent = value;
    } //endregion

  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        /**
         * This is a preconfigured set of {@link Core.widget.Container#config-namedItems} used to create the default
         * context menu.
         * @config {Object}
         */
        defaultItems: null,

        /**
         * An {@link Core.widget.Menu Menu} items object containing named child menu items
         * to apply to the feature's provided context menu, see {@link #config-defaultItems}.
         *
         * This may add extra items as below, but may also remove any of the {@link #config-defaultItems}
         * by configuring the name of the item as `false`
         *
         * ```javascript
         * features : {
         *     taskMenu : { // use eventMenu in the Scheduler product
         *         // This object is applied to the Feature's predefined defaultItems object
         *         items : {
         *             switchToDog : {
         *                 text : 'Dog',
         *                 icon : 'b-fa b-fa-fw b-fa-dog',
         *                 onItem({contextRecord}) {
         *                     contextRecord.dog = true;
         *                     contextRecord.cat = false;
         *                 },
         *                 weight : 500     // Make this second from end
         *             },
         *             switchToCat : {
         *                 text : 'Cat',
         *                 icon : 'b-fa b-fa-fw b-fa-cat',
         *                 onItem({contextRecord}) {
         *                     contextRecord.dog = false;
         *                     contextRecord.cat = true;
         *                 },
         *                 weight : 510     // Make this sink to end
         *             },
         *             add : false // We do not want the "Add" submenu to be available
         *         }
         *     }
         * }
         * ```
         *
         * @config {Object|Object[]}
         */
        items: null,

        /**
         * A function called before displaying the menu that allows manipulations of its items. Called with a
         * single parameter with format { contextRecord, eventElement, items }. Returning `false`
         * from this function prevents the menu from being shown.
         *
         * ```javascript
         * features : {
         *     taskContextMenu : {
         *         processItems({contextRecord, items}) {
         *             // Add or remove items here as needed
         *             if (contextRecord.type === 'Meeting') {
         *                 items.cancel = {
         *                     text   : 'Cancel',
         *                     icon   : 'b-fa b-fa-fw b-fa-ban',
         *                     weight : 200 // Move to end
         *                 };
         *             }
         *
         *             // Hide delete for parents
         *             items.deleteTask.hidden = contextRecord.isParent;
         *         }
         *     }
         * }
         * ```
         *
         * @config {Function}
         */
        processItems: null,

        /**
         * Event which is used to show context menu.
         * Available options are: 'contextmenu', 'click', 'dblclick'.
         * Default value is used from {@link Grid/view/GridBase#config-contextMenuTriggerEvent}
         * @config {String}
         */
        triggerEvent: null
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        assign: ['showEventContextMenu'],
        chain: ['onElementContextMenu', 'onElementClick', 'onElementDblClick', 'onEventSpaceKey']
      };
    }
  }]);

  return TimeSpanRecordContextMenuBase;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


TimeSpanRecordContextMenuBase._$name = 'TimeSpanRecordContextMenuBase';

/***/ }),

/***/ "./lib/Scheduler/feature/base/TooltipBase.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/feature/base/TooltipBase.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TooltipBase; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../tooltip/ClockTemplate.js */ "./lib/Scheduler/tooltip/ClockTemplate.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/feature/base/TooltipBase
 */

/**
 * Base class for EventTooltip (Scheduler) and TaskTooltip (Gantt) features. Contains shared code. Not to be used directly.
 *
 * @extends Core/mixin/InstancePlugin
 */

var TooltipBase = /*#__PURE__*/function (_InstancePlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(TooltipBase, _InstancePlugin);

  var _super = _createSuper(TooltipBase);

  function TooltipBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, TooltipBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(TooltipBase, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(client, config) {
      var me = this; // process initial config into an actual config object

      config = me.processConfig(config);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(TooltipBase.prototype), "construct", this).call(this, client, config); // Default triggering selector is the client's inner element selector


      if (!me.forSelector) {
        me.forSelector = "".concat(client.eventInnerSelector, ":not(.b-dragproxy)");
      }

      me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
        scheduler: client
      });
      client.on(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()({}, "before".concat(client.scheduledEventName, "drag"), function beforedrag() {
        var _me$tooltip;

        return (_me$tooltip = me.tooltip) === null || _me$tooltip === void 0 ? void 0 : _me$tooltip.hide();
      }));
    } // TooltipBase feature handles special config cases, where user can supply a function to use as template
    // instead of a normal config object

  }, {
    key: "processConfig",
    value: function processConfig(config) {
      if (typeof config === 'function') {
        return {
          template: config
        };
      }

      return config;
    } // override setConfig to process config before applying it (used mainly from ReactScheduler)

  }, {
    key: "setConfig",
    value: function setConfig(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(TooltipBase.prototype), "setConfig", this).call(this, this.processConfig(config));
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var _this$clockTemplate, _this$tooltip;

      (_this$clockTemplate = this.clockTemplate) === null || _this$clockTemplate === void 0 ? void 0 : _this$clockTemplate.destroy();
      (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.destroy();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(TooltipBase.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "doDisable",
    value: function doDisable(disable) {
      if (this.tooltip) {
        this.tooltip.disabled = disable;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(TooltipBase.prototype), "doDisable", this).call(this, disable);
    } //endregion

  }, {
    key: "render",
    value: function render() {
      var me = this,
          client = me.client,
          ignoreSelector = ['.b-dragselecting', '.b-eventeditor-editing', '.b-taskeditor-editing', '.b-resizing-event', '.b-dragcreating', ".b-dragging-".concat(client.scheduledEventName), '.b-creating-dependency', '.b-dragproxy'].map(function (cls) {
        return ":not(".concat(cls, ")");
      }).join('');

      if (me.tooltip) {
        me.tooltip.destroy();
      }
      /**
       * A reference to the tooltip instance, which will have a special `eventRecord` property that
       * you can use to get data from the contextual event record to which this tooltip is related.
       * @member {Core.widget.Tooltip} tooltip
       * @readonly
       * @category Misc
       */


      me.tooltip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_15__["default"](Object.assign({
        axisLock: 'flexible',
        id: me.tipId || "".concat(me.client.id, "-event-tip"),
        cls: me.tipCls,
        forSelector: ".b-timelinebase".concat(ignoreSelector, " .b-grid-body-container:not(.b-scrolling) ").concat(me.forSelector),
        scrollAction: 'realign',
        clippedBy: [client.timeAxisSubGridElement, client.bodyContainer],
        forElement: client.timeAxisSubGridElement,
        showOnHover: true,
        hoverDelay: 0,
        hideDelay: 100,
        anchorToTarget: true,
        allowOver: Boolean(me.config.items || me.config.tools),
        getHtml: me.getTipHtml.bind(me),
        disabled: me.disabled
      }, me.config));
      me.tooltip.on('innerhtmlupdate', me.updateDateIndicator, me);
    }
  }, {
    key: "updateDateIndicator",
    value: function updateDateIndicator() {
      var me = this,
          client = me.client,
          tip = me.tooltip,
          timeSpanRecord = tip.activeTarget && client.resolveTimeSpanRecord(tip.activeTarget),
          endDateElement = tip.element.querySelector('.b-sch-tooltip-enddate');

      if (!timeSpanRecord) {
        return;
      }

      me.clockTemplate.updateDateIndicator(tip.element, timeSpanRecord.startDate);
      endDateElement && me.clockTemplate.updateDateIndicator(endDateElement, timeSpanRecord.endDate);
    }
  }, {
    key: "resolveTimeSpanRecord",
    value: function resolveTimeSpanRecord(forElement) {
      return this.client.resolveTimeSpanRecord(forElement);
    }
  }, {
    key: "getTipHtml",
    value: function getTipHtml(_ref) {
      var tip = _ref.tip,
          activeTarget = _ref.activeTarget;
      var me = this,
          client = me.client,
          recordProp = me.recordType || "".concat(client.scheduledEventName, "Record"),
          timeSpanRecord = me.resolveTimeSpanRecord(activeTarget); // If user has mouseovered a fading away element of a deleted event,
      // an event record will not be found. In this case the tip must hide.
      // Instance of check is to not display while propagating

      if ((timeSpanRecord === null || timeSpanRecord === void 0 ? void 0 : timeSpanRecord.startDate) instanceof Date) {
        var _me$template;

        var startDate = timeSpanRecord.startDate,
            endDate = timeSpanRecord.endDate,
            startText = client.getFormattedDate(startDate),
            endDateValue = client.getDisplayEndDate(endDate, startDate),
            endText = client.getFormattedDate(endDateValue);
        tip.eventRecord = timeSpanRecord;
        return me.template((_me$template = {
          tip: tip
        }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$template, "".concat(recordProp), timeSpanRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$template, "startDate", startDate), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$template, "endDate", endDate), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$template, "startText", startText), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$template, "endText", endText), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$template, "startClockHtml", me.clockTemplate.template({
          date: startDate,
          text: startText,
          cls: 'b-sch-tooltip-startdate'
        })), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$template, "endClockHtml", timeSpanRecord.isMilestone ? '' : me.clockTemplate.template({
          date: endDateValue,
          text: endText,
          cls: 'b-sch-tooltip-enddate'
        })), _me$template));
      } else {
        tip.hide();
        return '';
      }
    }
  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        /**
         * Specify true to have tooltip updated when mouse moves, if you for example want to display date at mouse
         * position.
         * @config {Boolean}
         * @default
         * @category Misc
         */
        autoUpdate: false,
        template: null,
        cls: null,
        align: {
          align: 'b-t'
        },
        clockTemplate: null
      };
    } // Plugin configuration. This plugin chains some of the functions in Grid.

  }, {
    key: "pluginConfig",
    get: function get() {
      return {
        chain: ['render']
      };
    }
  }]);

  return TooltipBase;
}(_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__["default"]);


TooltipBase._$name = 'TooltipBase';

/***/ }),

/***/ "./lib/Scheduler/feature/experimental/ExcelExporter.js":
/*!*************************************************************!*\
  !*** ./lib/Scheduler/feature/experimental/ExcelExporter.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExcelExporter; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _Grid_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Grid/feature/experimental/ExcelExporter.js */ "./lib/Grid/feature/experimental/ExcelExporter.js");
/* harmony import */ var _util_ScheduleTableExporter_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../util/ScheduleTableExporter.js */ "./lib/Scheduler/util/ScheduleTableExporter.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/*eslint no-undef: "error"*/




/**
 * @module Scheduler/feature/experimental/ExcelExporter
 */

/**
 * **NOTE**: This class requires a 3rd party library to operate.
 *
 * A plugin that allows exporting Scheduler data to Excel without involving the server. It uses {@link Scheduler.util.ScheduleTableExporter}
 * class as data provider, [zipcelx library](https://www.npmjs.com/package/zipcelx)
 * forked and adjusted to support [column width config](https://github.com/bryntum/zipcelx/tree/column-width-build)
 * and [Microsoft XML specification](https://msdn.microsoft.com/en-us/library/office/documentformat.openxml.spreadsheet.aspx).
 * Zipcelx should be either in global scope (window) or can be provided with {@link #config-zipcelx} config.
 *
 * ```
 * // Global scope
 * <script src="zipcelx.js"></script>
 *
 * // importing from package
 * import zipcelx from 'zipcelx';
 *
 * const grid = new Grid({
 *     features : {
 *         excelExporter : {
 *             zipcelx
 *         }
 *     }
 * })
 * ```
 *
 * Here is an example of how to add the feature:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         excelExporter : {
 *             // Choose the date format for date fields
 *             dateFormat : 'YYYY-MM-DD HH:mm',
 *             exporterConfig : {
 *                 // Choose the Resource fields to include in the exported file
 *                 columns : [{ text : 'Staff', field : 'name' }],
 *
 *                 // Choose the Event fields to include in the exported file
 *                 eventColumns    : [
 *                     { text : 'Task', field : 'name' },
 *                     { text : 'Starts', field : 'startDate', width : 140 },
 *                     { text : 'Ends', field : 'endDate', width : 140 }
 *                 ]
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * And how to call it:
 *
 * ```javascript
 * scheduler.features.excelExporter.export({
 *     filename : 'Export',
 *     exporterConfig : {
 *         columns : [{ text : 'Staff', field : 'name' }]
 *     }
 * })
 * ```
 *
 * @extends Grid/feature/experimental/ExcelExporter
 * @demo Scheduler/exporttoexcel
 * @typings Grid/feature/experimental/ExcelExporter -> Grid/feature/experimental/GridExcelExporter
 */

var ExcelExporter = /*#__PURE__*/function (_GridExcelExporter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ExcelExporter, _GridExcelExporter);

  var _super = _createSuper(ExcelExporter);

  function ExcelExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ExcelExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ExcelExporter, null, [{
    key: "$name",
    get: function get() {
      return 'ExcelExporter';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Exporter class. Must subclass {@link Scheduler.util.ScheduleTableExporter}
         * @config {Scheduler.util.ScheduleTableExporter}
         * @default
         */
        exporterClass: _util_ScheduleTableExporter_js__WEBPACK_IMPORTED_MODULE_10__["default"],

        /**
         * Configuration object for {@link #config-exporterClass exporter class}.
         * @config {Object}
         */
        exporterConfig: null
      };
    }
  }]);

  return ExcelExporter;
}(_Grid_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


ExcelExporter._$name = 'ExcelExporter';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(ExcelExporter, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/export/PdfExport.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/feature/export/PdfExport.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PdfExport; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Grid_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Grid/feature/export/PdfExport.js */ "./lib/Grid/feature/export/PdfExport.js");
/* harmony import */ var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony import */ var _view_export_SchedulerExportDialog_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../view/export/SchedulerExportDialog.js */ "./lib/Scheduler/view/export/SchedulerExportDialog.js");
/* harmony import */ var _exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./exporter/SinglePageExporter.js */ "./lib/Scheduler/feature/export/exporter/SinglePageExporter.js");
/* harmony import */ var _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./exporter/MultiPageExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageExporter.js");
/* harmony import */ var _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./exporter/MultiPageVerticalExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Scheduler/feature/export/PdfExport
 */

/**
 * Generates PDF/PNG files from the Scheduler component.
 *
 * <img src="resources/images/export-dialog.png" style="max-width : 300px" alt="Scheduler Export dialog">
 *
 * **NOTE:** This feature makes a fetch request to the server, posting the HTML fragments to be exported.
 * The {@link Grid.feature.export.PdfExport#config-exportServer} URL must be configured.
 *
 * ## Usage
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080' // Required
 *         }
 *     }
 * })
 *
 * // Opens popup allowing to customize export settings
 * scheduler.features.pdfExport.showExportDialog();
 *
 * // Simple export
 * scheduler.features.pdfExport.export({
 *     columns : scheduler.columns.map(c => c.id) // Required, set list of column ids to export
 * }).then(result => {
 *     // Response instance and response content in JSON
 *     let { response, responseJSON } = result;
 * });
 * ```
 *
 * Appends configs related to exporting time axis: {@link #config-scheduleRange}, {@link #config-rangeStart},
 * {@link #config-rangeEnd}
 *
 * ## Loading resources
 *
 * If you face a problem with loading resources when exporting, the cause might be that the application and the export server are hosted on different servers.
 * This is due to [Cross-Origin Resource Sharing](https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS) (CORS). There are 2 options how to handle this:
 * - Allow cross origin requests from the server where your export is hosted to the server where your application is hosted;
 * - Copy all resources keeping the folder hierarchy from the server where your application is hosted to the server where your export is hosted
 * and setup paths using {@link Grid.feature.export.PdfExport#config-translateURLsToAbsolute} config and configure the export server to give access to the path:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     features : {
 *         pdfExport : {
 *             exportServer : 'http://localhost:8080',
 *             translateURLsToAbsolute : 'http://localhost:8080/resources' // '/resources' is hardcoded in WebServer implementation
 *         }
 *     }
 * })
 * ```
 *
 * ```javascript
 * // Following path would be served by this address: http://localhost:8080/resources/
 * node ./src/server.js -h 8080 -r web/application/styles
 * ```
 *
 * where `web/application/styles` is a physical root location of the copied resources, for example:
 *
 * <img src="resources/images/export-server-resources.png" style="max-width : 500px" alt="Export server structure with copied resources" />
 *
 * @extends Grid/feature/export/PdfExport
 * @typings Grid/feature/export/PdfExport -> Grid/feature/export/GridPdfExport
 */

var PdfExport = /*#__PURE__*/function (_GridPdfExport) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(PdfExport, _GridPdfExport);

  var _super = _createSuper(PdfExport);

  function PdfExport() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, PdfExport);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(PdfExport, [{
    key: "showExportDialog",
    value: function showExportDialog() {
      var me = this;

      if (!me.exportDialog) {
        me.exportDialog = new _view_export_SchedulerExportDialog_js__WEBPACK_IMPORTED_MODULE_13__["default"](Object.assign({}, me.defaultExportDialogConfig, {
          listeners: {
            export: me.onExportDialogExport,
            thisObj: me
          }
        }));
      }

      me.exportDialog.show();
    }
  }, {
    key: "buildExportConfig",
    value: function buildExportConfig(config) {
      config = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(PdfExport.prototype), "buildExportConfig", this).call(this, config);
      var scheduleRange = this.scheduleRange,
          rangeStart = this.rangeStart,
          rangeEnd = this.rangeEnd; // Time axis is filtered from UI, need to append it

      if (config.columns && !config.columns.find(function (col) {
        return col.type === 'timeAxis';
      })) {
        config.columns.push(config.client.timeAxisColumn.id);
      }

      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].assign({
        scheduleRange: scheduleRange,
        rangeStart: rangeStart,
        rangeEnd: rangeEnd
      }, config);
    }
  }, {
    key: "defaultExportDialogConfig",
    get: function get() {
      return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].copyProperties(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(PdfExport.prototype), "defaultExportDialogConfig", this), this, ['scheduleRange']);
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'PdfExport';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        exporters: [_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_14__["default"], _exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_15__["default"], _exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_16__["default"]],

        /**
         * Specifies how to export time span.
         *  * completeview - Complete configured time span, from scheduler start date to end date
         *  * currentview  - Currently visible time span
         *  * daterange    - Use specific date range, provided additionally in config. See {@link #config-rangeStart}/
         *  {@link #config-rangeEnd}
         * @config {String}
         * @default
         * @group Export file config
         */
        scheduleRange: 'completeview',

        /**
         * Exported time span range start. Used with `daterange` config of the {@link #config-scheduleRange}
         * @config {Date}
         * @group Export file config
         */
        rangeStart: null,

        /**
         * Exported time span range end. Used with `daterange` config of the {@link #config-scheduleRange}
         * @config {Date}
         * @group Export file config
         */
        rangeEnd: null
      };
    }
  }]);

  return PdfExport;
}(_Grid_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


PdfExport._$name = 'PdfExport';
_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(PdfExport, false, 'Scheduler');

/***/ }),

/***/ "./lib/Scheduler/feature/export/Utils.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/feature/export/Utils.js ***!
  \***********************************************/
/*! exports provided: ScheduleRange */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScheduleRange", function() { return ScheduleRange; });
var productName = 'scheduler';
var ScheduleRange = {
  completeview: 'completeview',
  // completedata : 'completedata',
  currentview: 'currentview',
  daterange: 'daterange'
};

/***/ }),

/***/ "./lib/Scheduler/feature/export/exporter/MultiPageExporter.js":
/*!********************************************************************!*\
  !*** ./lib/Scheduler/feature/export/exporter/MultiPageExporter.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageExporter; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Grid_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../../Grid/feature/export/exporter/MultiPageExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageExporter.js");
/* harmony import */ var _SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./SchedulerExporterMixin.js */ "./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js");




















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var MultiPageExporter = /*#__PURE__*/function (_SchedulerExporterMix) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(MultiPageExporter, _SchedulerExporterMix);

  var _super = _createSuper(MultiPageExporter);

  function MultiPageExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, MultiPageExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(MultiPageExporter, [{
    key: "stateNextPage",
    value: function () {
      var _stateNextPage = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee(config) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(MultiPageExporter.prototype), "stateNextPage", this).call(this, config);

              case 2:
                this.exportMeta.eventsBoxes.clear();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function stateNextPage(_x) {
        return _stateNextPage.apply(this, arguments);
      }

      return stateNextPage;
    }()
  }, {
    key: "positionRows",
    value: function positionRows(rows) {
      var _this = this;

      var resources = [],
          events = []; // In case of variable row height row vertical position is not guaranteed to increase
      // monotonously. Position row manually instead

      rows.forEach(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9___default()(_ref, 4),
            html = _ref2[0],
            top = _ref2[1],
            height = _ref2[2],
            eventsHtml = _ref2[3];

        resources.push(html);
        eventsHtml && Array.from(eventsHtml.entries()).forEach(function (_ref3) {
          var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9___default()(_ref3, 2),
              key = _ref4[0],
              _ref4$ = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9___default()(_ref4[1], 2),
              html = _ref4$[0],
              box = _ref4$[1];

          events.push(html); // Store event box to render dependencies later

          _this.exportMeta.eventsBoxes.set(String(key), box);
        });
      });
      return {
        resources: resources,
        events: events
      };
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'MultiPageExporter';
    }
  }]);

  return MultiPageExporter;
}(Object(_SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_20__["default"])(_Grid_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_19__["default"]));


MultiPageExporter._$name = 'MultiPageExporter';

/***/ }),

/***/ "./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js":
/*!****************************************************************************!*\
  !*** ./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPageVerticalExporter; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Grid_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../../Grid/feature/export/exporter/MultiPageVerticalExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony import */ var _SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./SchedulerExporterMixin.js */ "./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../Utils.js */ "./lib/Scheduler/feature/export/Utils.js");




















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




var MultiPageVerticalExporter = /*#__PURE__*/function (_SchedulerExporterMix) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(MultiPageVerticalExporter, _SchedulerExporterMix);

  var _super = _createSuper(MultiPageVerticalExporter);

  function MultiPageVerticalExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, MultiPageVerticalExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(MultiPageVerticalExporter, [{
    key: "stateNextPage",
    value: function () {
      var _stateNextPage = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee(config) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(MultiPageVerticalExporter.prototype), "stateNextPage", this).call(this, config);

              case 2:
                this.exportMeta.eventsBoxes.clear();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function stateNextPage(_x) {
        return _stateNextPage.apply(this, arguments);
      }

      return stateNextPage;
    }()
  }, {
    key: "prepareComponent",
    value: function () {
      var _prepareComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee2(config) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(MultiPageVerticalExporter.prototype), "prepareComponent", this).call(this, config);

              case 2:
                // Scheduler exporter mixin can update totalWidth, so we need to adjust pages and scale here again
                if (config.scheduleRange !== _Utils_js__WEBPACK_IMPORTED_MODULE_21__["ScheduleRange"].completeview) {
                  this.estimateTotalPages(config);
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function prepareComponent(_x2) {
        return _prepareComponent.apply(this, arguments);
      }

      return prepareComponent;
    }()
  }, {
    key: "positionRows",
    value: function positionRows(rows) {
      var _this = this;

      var resources = [],
          events = []; // In case of variable row height row vertical position is not guaranteed to increase
      // monotonously. Position row manually instead

      rows.forEach(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9___default()(_ref, 4),
            html = _ref2[0],
            top = _ref2[1],
            height = _ref2[2],
            eventsHtml = _ref2[3];

        resources.push(html);
        eventsHtml && Array.from(eventsHtml.entries()).forEach(function (_ref3) {
          var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9___default()(_ref3, 2),
              key = _ref4[0],
              _ref4$ = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_9___default()(_ref4[1], 2),
              html = _ref4$[0],
              box = _ref4$[1];

          events.push(html); // Store event box to render dependencies later

          _this.exportMeta.eventsBoxes.set(String(key), box);
        });
      });
      return {
        resources: resources,
        events: events
      };
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'MultiPageVerticalExporter';
    }
  }]);

  return MultiPageVerticalExporter;
}(Object(_SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_20__["default"])(_Grid_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_19__["default"]));


MultiPageVerticalExporter._$name = 'MultiPageVerticalExporter';

/***/ }),

/***/ "./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js":
/*!*************************************************************************!*\
  !*** ./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.number.constructor */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../Utils.js */ "./lib/Scheduler/feature/export/Utils.js");













































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_42___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





var immediatePromise = Promise.resolve();
/* harmony default export */ __webpack_exports__["default"] = (function (base) {
  return /*#__PURE__*/function (_base) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_41___default()(SchedulerExporterMixin, _base);

    var _super = _createSuper(SchedulerExporterMixin);

    function SchedulerExporterMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_38___default()(this, SchedulerExporterMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_39___default()(SchedulerExporterMixin, [{
      key: "scrollRowIntoView",
      value: function () {
        var _scrollRowIntoView = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee(client, index) {
          var rowManager, scrollable, oldY;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  rowManager = client.rowManager, scrollable = client.scrollable, oldY = scrollable.y; // If it's a valid index to scroll to, then try it.

                  if (!(index < client.store.count)) {
                    _context.next = 5;
                    break;
                  }

                  // Scroll the requested row to the viewport top
                  scrollable.scrollTo(null, rowManager.calculateTop(index)); // If that initiated a scroll, we need to wait for the row to be rendered, so return
                  // a Promise which resolves when that happens.

                  if (!(scrollable.y !== oldY)) {
                    _context.next = 5;
                    break;
                  }

                  return _context.abrupt("return", new Promise(function (resolve) {
                    var detacher = client.on({
                      scroll: function scroll(_ref) {
                        var scrollTop = _ref.scrollTop;

                        // future-proof: only react to scroll event with certain argument
                        if (scrollTop != null && rowManager.getRow(index)) {
                          detacher();
                          resolve();
                        }
                      }
                    });
                  }));

                case 5:
                  return _context.abrupt("return", immediatePromise);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function scrollRowIntoView(_x, _x2) {
          return _scrollRowIntoView.apply(this, arguments);
        }

        return scrollRowIntoView;
      }()
    }, {
      key: "scrollToDate",
      value: function () {
        var _scrollToDate = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee2(client, date) {
          var scrollFired, promises, detacher;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  scrollFired = false;
                  promises = []; // Time axis is updated on element scroll, which is async event. We need to synchronize this logic.
                  // If element horizontal scroll is changed then sync event is fired. We add listener to that one specific event
                  // and remove it right after scrollToDate sync code, keeping listeners clean. If scrolling occurred, we need
                  // to wait until time header is updated.

                  detacher = client.timeAxisSubGrid.scrollable.on({
                    scrollstart: function scrollstart(_ref2) {
                      var x = _ref2.x;

                      if (x != null) {
                        scrollFired = true;
                      }
                    }
                  }); // added `block: start` to do scrolling faster
                  // it moves data to begin of visible area that is longer section for re-render

                  promises.push(client.scrollToDate(date, {
                    block: 'start'
                  }));
                  detacher();

                  if (scrollFired) {
                    promises.push(client.timeView.await('refresh', {
                      checkLog: false
                    })); // We have to wait for scrollEnd event before moving forward. When exporting large view we might have to scroll
                    // extensively and it might occur that requested scroll position would not be reached because concurrent
                    // scrollEnd events would move scroll back.
                    // Covered by Gantt/tests/feature/export/MultiPageVertical.t.js

                    promises.push(client.timeAxisSubGrid.header.scrollable.await('scrollEnd', {
                      checkLog: false
                    }));
                  }

                  _context2.next = 8;
                  return Promise.all(promises);

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function scrollToDate(_x3, _x4) {
          return _scrollToDate.apply(this, arguments);
        }

        return scrollToDate;
      }()
    }, {
      key: "prepareComponent",
      value: function () {
        var _prepareComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee3(config) {
          var me, client, includeTimeline, _client$visibleDateRa, startDate, endDate, exportMeta, fgCanvasEl, timeAxisEl, horizontalPages, totalPages, columnLinesCanvas, svgCanvasEl;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  me = this, client = config.client, includeTimeline = client.timeAxisSubGrid.width > 0;
                  _context3.t0 = config.scheduleRange;
                  _context3.next = _context3.t0 === _Utils_js__WEBPACK_IMPORTED_MODULE_48__["ScheduleRange"].completeview ? 4 : _context3.t0 === _Utils_js__WEBPACK_IMPORTED_MODULE_48__["ScheduleRange"].currentview ? 7 : 11;
                  break;

                case 4:
                  config.rangeStart = client.startDate;
                  config.rangeEnd = client.endDate;
                  return _context3.abrupt("break", 11);

                case 7:
                  _client$visibleDateRa = client.visibleDateRange, startDate = _client$visibleDateRa.startDate, endDate = _client$visibleDateRa.endDate;
                  config.rangeStart = startDate;
                  config.rangeEnd = endDate;
                  return _context3.abrupt("break", 11);

                case 11:
                  _context3.next = 13;
                  return client.waitForTransition();

                case 13:
                  // Don't change timespan if time axis subgrid is not visible
                  if (includeTimeline) {
                    // set new timespan before calling parent to get proper scheduler header/content size
                    client.setTimeSpan(config.rangeStart, config.rangeEnd); // Access svgCanvas el to create dependency canvas early
                    // eslint-disable-next-line no-unused-expressions

                    client.svgCanvas;
                  } // Disable event animations during export


                  me._oldEnableEventAnimations = client.enableEventAnimations;
                  client.enableEventAnimations = false; // Add scroll buffer for the horizontal rendering

                  if (client.currentOrientation.isHorizontalRendering) {
                    me._oldScrollBuffer = client.currentOrientation.scrollBuffer;
                    client.currentOrientation.scrollBuffer = 100;
                  }

                  _context3.next = 19;
                  return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_40___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43___default()(SchedulerExporterMixin.prototype), "prepareComponent", this).call(this, config);

                case 19:
                  exportMeta = me.exportMeta, fgCanvasEl = me.element.querySelector('.b-sch-foreground-canvas'), timeAxisEl = me.element.querySelector('.b-horizontaltimeaxis');
                  exportMeta.includeTimeline = includeTimeline;

                  if (includeTimeline && config.scheduleRange !== _Utils_js__WEBPACK_IMPORTED_MODULE_48__["ScheduleRange"].completeview) {
                    // If we are exporting subrange of dates we need to change subgrid size accordingly
                    exportMeta.totalWidth -= exportMeta.subGrids.normal.width;
                    exportMeta.totalWidth += exportMeta.subGrids.normal.width = client.timeAxisViewModel.getDistanceBetweenDates(config.rangeStart, config.rangeEnd);
                    horizontalPages = Math.ceil(exportMeta.totalWidth / exportMeta.pageWidth), totalPages = horizontalPages * exportMeta.verticalPages;
                    exportMeta.horizontalPages = horizontalPages;
                    exportMeta.totalPages = totalPages; // store left scroll to imitate normal grid/header scroll using margin

                    exportMeta.subGrids.normal.scrollLeft = client.getCoordinateFromDate(config.rangeStart);
                  }

                  exportMeta.timeAxisHeaders = [];
                  exportMeta.timeAxisPlaceholders = [];
                  exportMeta.headersColleted = false;
                  _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"].forEachSelector(timeAxisEl, '.b-sch-header-row', function (headerRow) {
                    exportMeta.timeAxisPlaceholders.push(me.createPlaceholder(headerRow));
                    exportMeta.timeAxisHeaders.push(new Map());
                  }); // Add placeholder for events, clear all event elements, but not the entire elements as it contains svg canvas

                  exportMeta.subGrids.normal.eventsPlaceholder = me.createPlaceholder(fgCanvasEl, false);
                  _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"].removeEachSelector(fgCanvasEl, '.b-sch-event-wrap');
                  _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"].removeEachSelector(me.element, '.b-released');
                  exportMeta.eventsBoxes = new Map();
                  exportMeta.client = client;

                  if (client.features.columnLines && !client.features.columnLines.disabled) {
                    columnLinesCanvas = me.element.querySelector('.b-column-lines-canvas');
                    exportMeta.columnLinesPlaceholder = me.createPlaceholder(columnLinesCanvas);
                    exportMeta.columnLines = {
                      lines: new Map(),
                      majorLines: new Map()
                    };
                  }

                  if (client.features.dependencies && !client.features.dependencies.disabled) {
                    svgCanvasEl = me.element.querySelector("[id=\"".concat(client.svgCanvas.getAttribute('id'), "\"]")); // Same as above, clear only dependency lines, because there might be markers added by user

                    if (exportMeta.dependenciesPlaceholder = svgCanvasEl) {
                      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"].removeEachSelector(svgCanvasEl, '.b-sch-dependency');
                    }
                  } // We need to scroll component to date to calculate correct start margin


                  if (!(includeTimeline && !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].betweenLesser(config.rangeStart, client.startDate, client.endDate))) {
                    _context3.next = 36;
                    break;
                  }

                  _context3.next = 36;
                  return me.scrollToDate(client, config.rangeStart);

                case 36:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function prepareComponent(_x5) {
          return _prepareComponent.apply(this, arguments);
        }

        return prepareComponent;
      }()
    }, {
      key: "restoreState",
      value: function () {
        var _restoreState = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee4(config) {
          var waitForHorizontalScroll, client, promises, detacher;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  waitForHorizontalScroll = false;
                  client = config.client, promises = []; // If scroll will be changed during restoring state (and it will likely be), raise a flag that exporter should
                  // wait for scrollEnd event before releasing control

                  detacher = client.timeAxisSubGrid.scrollable.on({
                    scrollStart: function scrollStart(_ref3) {
                      var x = _ref3.x;

                      // HACK: scrollStart might actually fire when scroll is set to existing value
                      if (this.element.scrollLeft !== x) {
                        waitForHorizontalScroll = true;
                      }
                    }
                  });
                  promises.push(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_40___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43___default()(SchedulerExporterMixin.prototype), "restoreState", this).call(this, config)); // Scroll start will be fired synchronously

                  detacher();

                  if (waitForHorizontalScroll) {
                    promises.push(client.timeAxisSubGrid.header.scrollable.await('scrollEnd', {
                      checkLog: false
                    }));
                  }

                  _context4.next = 8;
                  return Promise.all(promises);

                case 8:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function restoreState(_x6) {
          return _restoreState.apply(this, arguments);
        }

        return restoreState;
      }()
    }, {
      key: "restoreComponent",
      value: function () {
        var _restoreComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee5(config) {
          var client;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  client = config.client;
                  client.enableEventAnimations = this._oldEnableEventAnimations;

                  if (client.currentOrientation.isHorizontalRendering) {
                    client.currentOrientation.scrollBuffer = this._oldScrollBuffer;
                  }

                  _context5.next = 5;
                  return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_40___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43___default()(SchedulerExporterMixin.prototype), "restoreComponent", this).call(this, config);

                case 5:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function restoreComponent(_x7) {
          return _restoreComponent.apply(this, arguments);
        }

        return restoreComponent;
      }()
    }, {
      key: "onRowsCollected",
      value: function () {
        var _onRowsCollected = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_37___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.mark(function _callee6(rows, config) {
          var me, client, timeView, _me$getCurrentPageDat, pageRangeStart, pageRangeEnd, rangeProcessed, endDate;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_35___default.a.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  me = this;
                  _context6.next = 3;
                  return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_40___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43___default()(SchedulerExporterMixin.prototype), "onRowsCollected", this).call(this, rows);

                case 3:
                  if (!me.exportMeta.includeTimeline) {
                    _context6.next = 29;
                    break;
                  }

                  client = config.client, timeView = client.timeView, _me$getCurrentPageDat = me.getCurrentPageDateRange(config), pageRangeStart = _me$getCurrentPageDat.pageRangeStart, pageRangeEnd = _me$getCurrentPageDat.pageRangeEnd;
                  rangeProcessed = false;
                  _context6.next = 8;
                  return me.scrollToDate(client, pageRangeStart);

                case 8:
                  if (rangeProcessed) {
                    _context6.next = 27;
                    break;
                  }

                  me.collectLines(config);
                  me.collectHeaders(config);
                  me.collectEvents(rows, config);

                  if (!_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].timeSpanContains(timeView.startDate, timeView.endDate, pageRangeStart, pageRangeEnd)) {
                    _context6.next = 16;
                    break;
                  }

                  rangeProcessed = true;
                  _context6.next = 25;
                  break;

                case 16:
                  if (!(timeView.endDate.getTime() >= pageRangeEnd.getTime())) {
                    _context6.next = 20;
                    break;
                  }

                  rangeProcessed = true;
                  _context6.next = 25;
                  break;

                case 20:
                  endDate = timeView.endDate;
                  _context6.next = 23;
                  return me.scrollToDate(client, timeView.endDate);

                case 23:
                  if (!(endDate.getTime() === timeView.endDate.getTime())) {
                    _context6.next = 25;
                    break;
                  }

                  throw new Error('Could not scroll to date');

                case 25:
                  _context6.next = 8;
                  break;

                case 27:
                  _context6.next = 29;
                  return me.scrollToDate(client, config.rangeStart);

                case 29:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function onRowsCollected(_x8, _x9) {
          return _onRowsCollected.apply(this, arguments);
        }

        return onRowsCollected;
      }()
    }, {
      key: "getCurrentPageDateRange",
      value: function getCurrentPageDateRange(_ref4) {
        var rangeStart = _ref4.rangeStart,
            rangeEnd = _ref4.rangeEnd,
            client = _ref4.client;
        var me = this,
            exportMeta = me.exportMeta,
            horizontalPages = exportMeta.horizontalPages,
            horizontalPosition = exportMeta.horizontalPosition,
            pageWidth = exportMeta.pageWidth,
            subGrids = exportMeta.subGrids;
        var pageRangeStart, pageRangeEnd; // when exporting to multiple pages we only need to scroll sub-range within visible time span

        if (horizontalPages > 1) {
          var pageStartX = horizontalPosition * pageWidth,
              pageEndX = (horizontalPosition + 1) * pageWidth,
              // Assuming normal grid is right next to right side of the locked grid
          // There is also a default splitter
          normalGridX = subGrids.locked.width + subGrids.locked.splitterWidth;

          if (pageEndX <= normalGridX) {
            pageRangeEnd = pageRangeStart = null;
          } else {
            pageRangeStart = client.getDateFromCoordinate(Math.max(pageStartX - normalGridX, 0)); // Extend visible schedule by 20% to cover up possible splitter

            pageRangeEnd = client.getDateFromCoordinate((pageEndX - normalGridX) * 1.2) || rangeEnd;
          }
        } else {
          pageRangeStart = rangeStart;
          pageRangeEnd = rangeEnd;
        }

        return {
          pageRangeStart: pageRangeStart,
          pageRangeEnd: pageRangeEnd
        };
      }
    }, {
      key: "prepareExportElement",
      value: function prepareExportElement() {
        var element = this.element,
            exportMeta = this.exportMeta,
            _exportMeta$subGrids$ = exportMeta.subGrids.normal,
            id = _exportMeta$subGrids$.id,
            headerId = _exportMeta$subGrids$.headerId,
            footerId = _exportMeta$subGrids$.footerId,
            scrollLeft = _exportMeta$subGrids$.scrollLeft,
            el = element.querySelector("[id=\"".concat(id, "\"]"));
        ['.b-sch-background-canvas', '.b-sch-foreground-canvas'].forEach(function (selector) {
          var canvasEl = el.querySelector(selector);

          if (canvasEl) {
            // Align canvases to last exported row bottom. If no such property exists - remove inline height
            if (exportMeta.lastExportedRowBottom) {
              canvasEl.style.height = "".concat(exportMeta.lastExportedRowBottom, "px");
            } else {
              canvasEl.style.height = '';
            } // Simulate horizontal scroll


            if (scrollLeft) {
              canvasEl.style.marginLeft = "-".concat(scrollLeft, "px");
            }
          }
        });

        if (scrollLeft) {
          [headerId, footerId].forEach(function (id) {
            var el = element.querySelector("[id=\"".concat(id, "\"] .b-widget-scroller"));

            if (el) {
              el.style.marginLeft = "-".concat(scrollLeft, "px");
            }
          });
        }

        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_40___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_43___default()(SchedulerExporterMixin.prototype), "prepareExportElement", this).call(this);
      }
    }, {
      key: "collectRow",
      value: function collectRow(row) {
        var me = this,
            subGrids = me.exportMeta.subGrids;
        Object.entries(row.elements).forEach(function (_ref5) {
          var _ref6 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34___default()(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];

          var rowConfig = [value.outerHTML, row.top, row.offsetHeight];

          if (key === 'normal') {
            rowConfig.push(new Map());
          }

          subGrids[key].rows.push(rowConfig);
        });
      }
    }, {
      key: "collectHeaders",
      value: function collectHeaders(config) {
        var me = this,
            client = config.client,
            exportMeta = me.exportMeta; // We only need to collect headers once, this flag is raised once they are collected along all exported range

        if (!exportMeta.headersCollected) {
          var timeAxisEl = client.timeView.element,
              timeAxisHeaders = exportMeta.timeAxisHeaders;
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"].forEachSelector(timeAxisEl, '.b-sch-header-row', function (headerRow, index, headerRows) {
            var headersMap = timeAxisHeaders[index];
            _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"].forEachSelector(headerRow, '.b-sch-header-timeaxis-cell', function (el) {
              if (!headersMap.has(el.dataset.tickIndex)) {
                headersMap.set(el.dataset.tickIndex, el.outerHTML);
              }
            });

            if (index === headerRows.length - 1 && headersMap.has(String(client.timeAxis.count - 1))) {
              exportMeta.headersCollected = true;
            }
          });
        }
      }
    }, {
      key: "collectLines",
      value: function collectLines(config) {
        var me = this,
            client = config.client,
            exportMeta = me.exportMeta,
            columnLines = exportMeta.columnLines; // We only need to collect headers once, this flag is raised once they are collected along all exported range

        if (!exportMeta.headersCollected && columnLines) {
          var bgCanvas = client.backgroundCanvas;
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"].forEachSelector(bgCanvas, '.b-column-line, .b-column-line-major', function (lineEl) {
            if (lineEl.classList.contains('b-column-line')) {
              var lineIndex = Number(lineEl.dataset.line.replace(/line-/, ''));
              columnLines.lines.set(lineIndex, lineEl.outerHTML);
            } else {
              var _lineIndex = Number(lineEl.dataset.line.replace(/major-/, ''));

              columnLines.majorLines.set(_lineIndex, lineEl.outerHTML);
            }
          });
        }
      }
    }, {
      key: "collectEvents",
      value: function collectEvents(rows, config) {
        var me = this,
            addedRows = rows.length,
            client = config.client,
            normalRows = me.exportMeta.subGrids.normal.rows;
        rows.forEach(function (row, index) {
          var rowConfig = normalRows[normalRows.length - addedRows + index],
              resource = client.store.getAt(row.dataIndex),
              eventsMap = rowConfig[3];
          resource.events && resource.events.forEach(function (event) {
            if (event.isScheduled) {
              var el = client.getElementFromEventRecord(event, resource);

              if (el && (el = el.parentElement) && !eventsMap.has(event.id)) {
                eventsMap.set(event.id, [el.outerHTML, _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_45__["default"].from(el, el.offsetParent)]);
              }
            }
          });
        });
      }
    }, {
      key: "buildPageHtml",
      value: function buildPageHtml() {
        var me = this,
            _me$exportMeta = me.exportMeta,
            subGrids = _me$exportMeta.subGrids,
            timeAxisHeaders = _me$exportMeta.timeAxisHeaders,
            timeAxisPlaceholders = _me$exportMeta.timeAxisPlaceholders,
            columnLines = _me$exportMeta.columnLines,
            columnLinesPlaceholder = _me$exportMeta.columnLinesPlaceholder; // Now when rows are collected, we need to add them to exported grid

        var html = me.prepareExportElement();
        Object.values(subGrids).forEach(function (_ref7) {
          var placeHolder = _ref7.placeHolder,
              eventsPlaceholder = _ref7.eventsPlaceholder,
              rows = _ref7.rows;

          var placeHolderText = placeHolder.outerHTML,
              _me$positionRows = me.positionRows(rows),
              resources = _me$positionRows.resources,
              events = _me$positionRows.events;

          html = html.replace(placeHolderText, resources.join(''));

          if (eventsPlaceholder) {
            html = html.replace(eventsPlaceholder.outerHTML, events.join(''));
          }
        });
        timeAxisHeaders.forEach(function (headers, index) {
          html = html.replace(timeAxisPlaceholders[index].outerHTML, Array.from(headers.values()).join(''));
        });

        if (columnLines) {
          var lineElements = Array.from(columnLines.lines.values()).concat(Array.from(columnLines.majorLines.values()));
          html = html.replace(columnLinesPlaceholder.outerHTML, lineElements.join(''));
        }

        html = me.buildDependenciesHtml(html);
        return html;
      } // outerHTML is not supported on SVG elements in IE11, using workaround

    }, {
      key: "getDependenciesOuterHTML",
      value: function getDependenciesOuterHTML() {
        var dependenciesPlaceholder = this.exportMeta.dependenciesPlaceholder;
        var result;

        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_47__["default"].isIE11) {
          var wrapper = document.createElement('div'),
              tmpEl = dependenciesPlaceholder.cloneNode(true);
          wrapper.appendChild(tmpEl);
          result = wrapper.innerHTML;
        } else {
          result = dependenciesPlaceholder.outerHTML;
        }

        return result;
      }
    }, {
      key: "renderDependencies",
      value: function renderDependencies() {
        var me = this,
            _me$exportMeta2 = me.exportMeta,
            client = _me$exportMeta2.client,
            dependenciesPlaceholder = _me$exportMeta2.dependenciesPlaceholder,
            eventsBoxes = _me$exportMeta2.eventsBoxes,
            dependencies = client.dependencies,
            dependencyFeature = client.features.dependencies,
            eventsInView = Array.from(eventsBoxes.keys());
        dependencies.filter(function (r) {
          return eventsInView.includes(String(r.from)) || eventsInView.includes(String(r.to));
        }).forEach(function (dependency) {
          var fromBox = eventsBoxes.get(String(dependency.from)),
              toBox = eventsBoxes.get(String(dependency.to));
          var assignments = dependencyFeature.getIteratableDependencyAssignments(dependency),
              fromEvent = dependency.fromEvent,
              toEvent = dependency.toEvent;
          assignments.forEach(function (assignmentData) {
            var _fromBox, _toBox;

            // In case of single page export from/to boxes will always be present, also we cannot trust boxes from cache
            // because single page exporter can possible change row/event vertical position
            // In case of multipage we will get box from the dependency feature
            if (!fromBox) {
              if (fromEvent) {
                var box = dependencyFeature.getBox(dependency, true, assignmentData);

                if (box) {
                  fromBox = box instanceof _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_45__["default"] ? box : new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_45__["default"](box.start, box.top, box.end - box.start, box.bottom - box.top);
                }
              }
            }

            if (!toBox) {
              if (toEvent) {
                var _box = dependencyFeature.getBox(dependency, false, assignmentData);

                if (_box) {
                  toBox = _box instanceof _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_45__["default"] ? _box : new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_45__["default"](_box.start, _box.top, _box.end - _box.start, _box.bottom - _box.top);
                }
              }
            } // Gantt dependencies feature modifies box size to point arrow to the top, clone box to keep original size


            var drawData = {
              startRectangle: (_fromBox = fromBox) === null || _fromBox === void 0 ? void 0 : _fromBox.clone(),
              endRectangle: (_toBox = toBox) === null || _toBox === void 0 ? void 0 : _toBox.clone()
            };

            if (fromBox && toBox) {
              dependencyFeature.drawDependency(dependency, drawData, assignmentData, dependenciesPlaceholder, false);
            }
          });
        });
        var result = me.getDependenciesOuterHTML();
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"].removeEachSelector(dependenciesPlaceholder, '.b-sch-dependency');
        return result;
      }
    }, {
      key: "buildDependenciesHtml",
      value: function buildDependenciesHtml(html) {
        var _this$exportMeta = this.exportMeta,
            dependenciesPlaceholder = _this$exportMeta.dependenciesPlaceholder,
            includeTimeline = _this$exportMeta.includeTimeline;

        if (dependenciesPlaceholder && includeTimeline) {
          var placeholder = this.getDependenciesOuterHTML();
          html = html.replace(placeholder, this.renderDependencies());
        }

        return html;
      }
    }]);

    return SchedulerExporterMixin;
  }(base);
});

/***/ }),

/***/ "./lib/Scheduler/feature/export/exporter/SinglePageExporter.js":
/*!*********************************************************************!*\
  !*** ./lib/Scheduler/feature/export/exporter/SinglePageExporter.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SinglePageExporter; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _Grid_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../../Grid/feature/export/exporter/SinglePageExporter.js */ "./lib/Grid/feature/export/exporter/SinglePageExporter.js");
/* harmony import */ var _SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./SchedulerExporterMixin.js */ "./lib/Scheduler/feature/export/exporter/SchedulerExporterMixin.js");


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var SinglePageExporter = /*#__PURE__*/function (_SchedulerExporterMix) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(SinglePageExporter, _SchedulerExporterMix);

  var _super = _createSuper(SinglePageExporter);

  function SinglePageExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default()(this, SinglePageExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default()(SinglePageExporter, [{
    key: "collectDependencies",
    // We should not collect dependencies per each page, instead we'd render them once
    value: function collectDependencies() {}
  }, {
    key: "positionRows",
    value: function positionRows(rows) {
      var _this = this;

      var currentTop = 0,
          resources = [],
          events = [],
          translateRe = /translate\((\d+.?\d*)px, (\d+.?\d*)px\)/; // In case of variable row height row vertical position is not guaranteed to increase
      // monotonously. Position row manually instead

      rows.forEach(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11___default()(_ref, 4),
            html = _ref2[0],
            top = _ref2[1],
            height = _ref2[2],
            eventsHtml = _ref2[3];

        resources.push(html.replace(translateRe, "translate($1px, ".concat(currentTop, "px)")));
        var rowTopDelta = currentTop - top;
        eventsHtml && Array.from(eventsHtml.entries()).forEach(function (_ref3) {
          var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11___default()(_ref3, 2),
              key = _ref4[0],
              _ref4$ = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_11___default()(_ref4[1], 2),
              html = _ref4$[0],
              box = _ref4$[1];

          // Fix event vertical position according to the row top
          box.translate(0, rowTopDelta); // Store event box to render dependencies later

          _this.exportMeta.eventsBoxes.set(String(key), box);

          events.push(html.replace(translateRe, "translate($1px, ".concat(box.y, "px)")));
        });
        currentTop += height;
      });
      return {
        resources: resources,
        events: events
      };
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'SinglePageExporter';
    }
  }]);

  return SinglePageExporter;
}(Object(_SchedulerExporterMixin_js__WEBPACK_IMPORTED_MODULE_18__["default"])(_Grid_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_17__["default"]));


SinglePageExporter._$name = 'SinglePageExporter';

/***/ }),

/***/ "./lib/Scheduler/feature/mixin/DependencyCreation.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/feature/mixin/DependencyCreation.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../model/DependencyBaseModel.js */ "./lib/Scheduler/model/DependencyBaseModel.js");




















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Scheduler/feature/mixin/DependencyCreation
 */
// TODO: refactor this class using StateChart utility to be implemented in Core/util/StateChart.js or XState library if allowed to be used

/**
 * Mixin for Dependencies feature that handles dependency creation (drag & drop from terminals which are shown on hover).
 * Requires {@link Core.mixin.Delayable} to be mixed in alongside.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(DependencyCreation, _ref);

    var _super = _createSuper(DependencyCreation);

    function DependencyCreation() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, DependencyCreation);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(DependencyCreation, [{
      key: "construct",
      //endregion
      //region Init & destroy
      value: function construct(view, config) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(DependencyCreation.prototype), "construct", this).call(this, view, config);

        var me = this;
        me.view = view;
        me.eventName = view.scheduledEventName;
        view.on('readOnly', function () {
          return me.updateCreateListeners();
        });
        me.updateCreateListeners();
      }
    }, {
      key: "doDestroy",
      value: function doDestroy() {
        var _me$mouseDetacher, _me$creationTooltip;

        var me = this;
        me.detachListeners('view');
        me.creationData = null;
        (_me$mouseDetacher = me.mouseDetacher) === null || _me$mouseDetacher === void 0 ? void 0 : _me$mouseDetacher.call(me);
        (_me$creationTooltip = me.creationTooltip) === null || _me$creationTooltip === void 0 ? void 0 : _me$creationTooltip.destroy();

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(DependencyCreation.prototype), "doDestroy", this).call(this);
      }
    }, {
      key: "updateCreateListeners",
      value: function updateCreateListeners() {
        var me = this;

        if (!me.view) {
          return;
        }

        me.detachListeners('view');

        if (me.isCreateAllowed) {
          var _me$view$on;

          me.view.on((_me$view$on = {
            name: 'view'
          }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_me$view$on, "".concat(me.eventName, "mouseenter"), 'onTimeSpanMouseEnter'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_me$view$on, "".concat(me.eventName, "mouseleave"), 'onTimeSpanMouseLeave'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_me$view$on, "thisObj", me), _me$view$on));
        }
      }
    }, {
      key: "onTimeSpanMouseEnter",
      //endregion
      //region Events

      /**
       * Show terminals when mouse enters event/task element
       * @private
       */
      value: function onTimeSpanMouseEnter(event) {
        var record = event["".concat(this.eventName, "Record")],
            element = event["".concat(this.eventName, "Element")];
        this.showTerminals(record, _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].down(element, event.source.eventInnerSelector));
      }
      /**
       * Hide terminals when mouse leaves event/task element
       * @private
       */

    }, {
      key: "onTimeSpanMouseLeave",
      value: function onTimeSpanMouseLeave(event) {
        var me = this,
            element = event["".concat(me.eventName, "Element")];

        if (!me.creationData || !_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].isDescendant(element, me.creationData.sourceTerminal.parentElement)) {
          me.hideTerminals(element);
        }
      }
      /**
       * Remove hover styling when mouse leaves terminal. Also hides terminals when mouse leaves one it and not creating a
       * dependency.
       * @private
       */

    }, {
      key: "onTerminalMouseOut",
      value: function onTerminalMouseOut(event) {
        var me = this,
            el = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].up(event.target, me.view.eventSelector);

        if (el && !_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].isDescendant(el, me.showingTerminalsFor) && (!me.creationData || el !== me.creationData.sourceTerminal.parentElement)) {
          me.hideTerminals(el);
          me.view.unhover(event);
        }
      }
      /**
       * Start creating a dependency when mouse is pressed over terminal
       * @private
       */

    }, {
      key: "onTerminalMouseDown",
      value: function onTerminalMouseDown(event) {
        var me = this; // ignore non-left button clicks

        if (event.button === 0 && !me.creationData) {
          var _view$resolveResource;

          var view = me.view,
              timeAxisSubGridElement = view.timeAxisSubGridElement,
              terminal = event.target,
              element = terminal.parentElement.closest(view.eventSelector),
              viewBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_22__["default"].from(view.element, document.body);
          event.preventDefault();
          event.stopPropagation();
          me.creationData = {
            source: view.resolveTimeSpanRecord(element),
            sourceTerminal: terminal,
            startPoint: _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_22__["default"].from(terminal, timeAxisSubGridElement).center,
            startX: event.pageX - viewBounds.x + view.scrollLeft,
            startY: event.pageY - viewBounds.y + view.scrollTop,
            valid: false,
            sourceResource: (_view$resolveResource = view.resolveResourceRecord) === null || _view$resolveResource === void 0 ? void 0 : _view$resolveResource.call(view, element)
          };
          me.mouseDetacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].on({
            mouseup: {
              element: me.listenersTarget,
              handler: 'onMouseUp'
            },
            mousemove: {
              element: timeAxisSubGridElement,
              handler: 'onMouseMove'
            },
            thisObj: me
          });
        }
      }
      /**
       * Update connector line showing dependency between source and target when mouse moves. Also check if mouse is over
       * a valid target terminal
       * @private
       */

    }, {
      key: "onMouseMove",
      value: function onMouseMove(event) {
        var me = this,
            view = me.view,
            data = me.creationData,
            viewBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_22__["default"].from(view.element, document.body),
            deltaX = event.pageX - viewBounds.x + view.scrollLeft - data.startX,
            deltaY = event.pageY - viewBounds.y + view.scrollTop - data.startY,
            length = Math.round(Math.sqrt(deltaX * deltaX + deltaY * deltaY)) - 3,
            angle = Math.atan2(deltaY, deltaX);
        var connector = me.connector;

        if (!connector) {
          if (me.onRequestDragCreate() === false) {
            return;
          }

          connector = me.connector;
        }

        connector.style.width = "".concat(length, "px");
        connector.style.transform = "rotate(".concat(angle, "rad)");
        me.lastMouseMoveEvent = event;
      }
    }, {
      key: "onRequestDragCreate",
      value: function onRequestDragCreate() {
        var me = this,
            view = me.view,
            data = me.creationData;
        /**
         * Fired on the owning Scheduler/Gantt before a dependency creation drag operation starts. Return `false to
         * prevent it
         * @event beforeDependencyCreateDrag
         * @param {Object} data
         * @param {Scheduler.model.TimeSpan} data.source The source task
         */

        if (view.trigger('beforeDependencyCreateDrag', {
          data: data
        }) === false) {
          me.abort();
          return false;
        }

        view.element.classList.add('b-creating-dependency');
        me.connector = me.createConnector(data.startPoint.x, data.startPoint.y);
        /**
         * Fired on the owning Scheduler/Gantt when a dependency creation drag operation starts
         * @event dependencyCreateDragStart
         * @param {Object} data
         */

        view.trigger('dependencyCreateDragStart', {
          data: data
        });

        if (me.showCreationTooltip) {
          me.creationTooltip = me.creationTooltip || me.createDragTooltip();
          me.creationTooltip.disabled = false;
          me.creationTooltip.show();
        }

        view.scrollManager.startMonitoring({
          element: view.timeAxisSubGridElement,
          callback: function callback() {
            return me.lastMouseMoveEvent && me.onMouseMove(me.lastMouseMoveEvent);
          },
          thisObj: me
        });
      }
    }, {
      key: "onOverTargetTerminal",
      value: function onOverTargetTerminal(event) {
        var me = this,
            target = event.target,
            view = me.view,
            data = me.creationData;
        var connector = me.connector;

        if (!_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isPromise(data.valid)) {
          if (target !== data.sourceTerminal) {
            if (target !== data.targetTerminal) {
              data.targetTerminal = target;
              data.target = view.resolveTimeSpanRecord(target);

              if (view.resolveResourceRecord) {
                data.targetResource = view.resolveResourceRecord(target);
              }

              var fromSide = data.sourceTerminal.dataset.side,
                  toSide = data.targetTerminal.dataset.side,
                  updateValidity = function updateValidity(valid) {
                if (!me.isDestroyed) {
                  data.valid = valid;
                  target.classList.add(valid ? 'b-valid' : 'b-invalid');
                  connector.classList.add(valid ? 'b-valid' : 'b-invalid');
                  /**
                   * Fired on the owning Scheduler/Gantt when asynchronous dependency validation completes
                   * @event dependencyValidationComplete
                   * @param {Object} data
                   */

                  view.trigger('dependencyValidationComplete', {
                    data: data
                  });
                }
              };

              var type; // NOTE: Top/Bottom sides are not taken into account due to
              //       scheduler doesn't check for type value anyway, whereas
              //       gantt will reject any other dependency types undefined in
              //       DependencyBaseModel.Type enumeration.

              switch (true) {
                case fromSide === 'left' && toSide === 'left':
                  type = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_25__["default"].Type.StartToStart;
                  break;

                case fromSide === 'left' && toSide === 'right':
                  type = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_25__["default"].Type.StartToEnd;
                  break;

                case fromSide === 'right' && toSide === 'left':
                  type = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_25__["default"].Type.EndToStart;
                  break;

                case fromSide === 'right' && toSide === 'right':
                  type = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_25__["default"].Type.EndToEnd;
                  break;
              }
              /**
               * Fired on the owning Scheduler/Gantt when asynchronous dependency validation starts
               * @event dependencyValidationStart
               * @param {Object} data
               */


              view.trigger('dependencyValidationStart', {
                data: data
              });
              data.valid = me.dependencyStore.isValidDependency(data.source, data.target, type); // Promise is returned when using the engine

              if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isPromise(data.valid)) {
                data.valid.then(updateValidity);
              } else {
                updateValidity(data.valid);
              }
            }
          } else {
            connector.classList.remove('b-valid');
            connector.classList.remove('b-invalid');
          }
        }
      }
      /**
       * Create a new dependency if mouse release over valid terminal. Hides connector
       * @private
       */

    }, {
      key: "onMouseUp",
      value: function onMouseUp(event) {
        var me = this,
            data = me.creationData,
            target = event.target;
        me.abort();

        var doDependencyDrop = /*#__PURE__*/function () {
          var _ref2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee() {
            var result;
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    data.targetTerminal = event.target;
                    result = me.createDependency(data);

                    if (!_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isPromise(result)) {
                      _context.next = 5;
                      break;
                    }

                    _context.next = 5;
                    return result;

                  case 5:
                    //data.valid = true; // TODO: remove this line if tests are fine

                    /**
                     * Fired on the owning Scheduler/Gantt when a dependency drag creation operation succeeds
                     * @event dependencyCreateDrop
                     * @param {Object} data
                     */
                    me.view.trigger('dependencyCreateDrop', {
                      data: data
                    });

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function doDependencyDrop() {
            return _ref2.apply(this, arguments);
          };
        }();

        var doAfterDependencyDrop = function doAfterDependencyDrop(data) {
          /**
           * Fired on the owning Scheduler/Gantt after a dependency drag creation operation finished, no matter to outcome
           * @event afterDependencyCreateDrop
           * @param {Object} data
           */
          me.view.trigger('afterDependencyCreateDrop', {
            data: data
          });
        }; // TODO: should call finalize and allow user to hook it (as in EventDrag, EventResize)


        if (data.valid && target.matches(".".concat(me.terminalCls))) {
          if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isPromise(data.valid)) {
            data.valid.then(function (valid) {
              data.valid = valid;

              if (valid) {
                doDependencyDrop().then(function () {
                  return doAfterDependencyDrop(data);
                });
              } else {
                doAfterDependencyDrop(data);
              }
            });
          } else {
            doDependencyDrop().then(function () {
              return doAfterDependencyDrop(data);
            });
          }
        } else {
          data.valid = false;
          doAfterDependencyDrop(data);
        }
      }
      /**
       * Aborts dependency creation, removes proxy and cleans up listeners
       */

    }, {
      key: "abort",
      value: function abort() {
        var _me$mouseDetacher2;

        var me = this,
            view = me.view,
            creationData = me.creationData; // Remove terminals from source and target events.

        if (creationData) {
          var source = creationData.source,
              sourceResource = creationData.sourceResource,
              target = creationData.target,
              targetResource = creationData.targetResource;

          if (source) {
            var el = view.getElementFromEventRecord(source, sourceResource);

            if (el) {
              me.hideTerminals(el);
            }
          }

          if (target) {
            var _el = view.getElementFromEventRecord(target, targetResource);

            if (_el) {
              me.hideTerminals(_el);
            }
          }
        }

        if (me.creationTooltip) {
          me.creationTooltip.disabled = true;
        }

        me.creationData = me.lastMouseMoveEvent = null;
        (_me$mouseDetacher2 = me.mouseDetacher) === null || _me$mouseDetacher2 === void 0 ? void 0 : _me$mouseDetacher2.call(me);
        me.removeConnector();
      } //endregion
      //region Connector

      /**
       * Creates a connector line that visualizes dependency source & target
       * @private
       */

    }, {
      key: "createConnector",
      value: function createConnector(x, y) {
        var me = this,
            view = me.view;
        me.connector = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].createElement({
          parent: view.timeAxisSubGridElement,
          className: "".concat(me.baseCls, "-connector"),
          style: "left:".concat(x, "px;top:").concat(y, "px")
        });
        view.element.classList.add('b-creating-dependency');
        return me.connector;
      }
    }, {
      key: "createDragTooltip",
      value: function createDragTooltip() {
        var me = this,
            view = me.view;
        return me.creationTooltip = new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_23__["default"](Object.assign({
          id: "".concat(view.id, "-dependency-drag-tip"),
          cls: 'b-sch-dependency-creation-tooltip',
          loadingMsg: '',
          autoShow: true,
          anchorToTarget: false,
          // Keep tip visible until drag drop operation is finalized
          forSelector: '.b-sch-terminal',
          forElement: view.timeAxisSubGridElement,
          trackMouse: true,
          // Do not constrain at all, want it to be able to go outside of the viewport to not get in the way
          constrainTo: null,
          getHtml: function getHtml(_ref3) {
            var tip = _ref3.tip,
                event = _ref3.event;

            if (me.creationData) {
              event && me.onOverTargetTerminal(event);
              return me.generateTooltipContent(tip, me.creationData);
            }
          },
          header: {
            dock: 'right'
          },
          listeners: {
            pointerout: function pointerout(_ref4) {
              var tip = _ref4.source;
              var data = me.creationData;
              data.target = data.targetTerminal = null;
              data.valid = false;
              tip.html = tip.getHtml({
                tip: tip
              });
              return false;
            },
            beforeShow: function beforeShow(_ref5) {
              var tip = _ref5.source;
              // Show initial content immediately
              tip.html = tip.getHtml({
                tip: tip
              });
            }
          }
        }, me.creationTooltip || {}));
      }
      /**
       * Remove connector
       * @private
       */

    }, {
      key: "removeConnector",
      value: function removeConnector(callback) {
        var me = this,
            connector = me.connector,
            view = me.view;

        if (connector) {
          connector.classList.add('b-removing');
          connector.style.width = '0';
          me.setTimeout(function () {
            connector.remove();
            me.connector = null;

            if (callback) {
              callback.call(me);
            }
          }, 200);
        }

        view.element.classList.remove('b-creating-dependency');
        me.creationTooltip && me.creationTooltip.hide();
        view.scrollManager.stopMonitoring(view.timeAxisSubGridElement);
      } //endregion
      //region Terminals

      /**
       * Show terminals for specified event at sides defined in #terminalSides.
       * @param {Scheduler.model.TimeSpan} timeSpanRecord Event/task to show terminals for
       * @param {HTMLElement} element Event/task element
       */

    }, {
      key: "showTerminals",
      value: function showTerminals(timeSpanRecord, element) {
        var me = this;

        if (!me.isCreateAllowed) {
          return;
        }

        var cls = me.terminalCls,
            terminalsVisibleCls = "".concat(cls, "s-visible"); // We operate on the event bar, not the wrap

        element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].down(element, me.view.eventInnerSelector); // bail out if terminals already shown or if view is readonly
        // do not draw new terminals if we are resizing event

        if (!element.classList.contains(terminalsVisibleCls) && !this.view.element.classList.contains('b-resizing-event') && !me.view.readOnly) {
          // create terminals for desired sides
          me.terminalSides.forEach(function (side) {
            var terminal = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].createElement({
              parent: element,
              className: "".concat(cls, " ").concat(cls, "-").concat(side),
              dataset: {
                side: side,
                feature: true
              }
            });
            terminal.detacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].on({
              element: terminal,
              mouseout: 'onTerminalMouseOut',
              mousedown: {
                handler: 'onTerminalMouseDown',
                capture: true
              },
              thisObj: me
            });
          });
          element.classList.add(terminalsVisibleCls);
          timeSpanRecord.cls.add(terminalsVisibleCls);
          me.showingTerminalsFor = element;
        }
      }
      /**
       * Hide terminals for specified event
       * @param {HTMLElement} eventElement Event element
       */

    }, {
      key: "hideTerminals",
      value: function hideTerminals(eventElement) {
        // remove all terminals
        var me = this,
            eventParams = me.client.getTimeSpanMouseEventParams(eventElement),
            timeSpanRecord = eventParams === null || eventParams === void 0 ? void 0 : eventParams["".concat(me.eventName, "Record")],
            terminalsVisibleCls = "".concat(me.terminalCls, "s-visible");
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].forEachSelector(eventElement, ".".concat(me.terminalCls), function (terminal) {
          terminal.detacher && terminal.detacher();
          terminal.remove();
        });
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].down(eventElement, me.view.eventInnerSelector).classList.remove(terminalsVisibleCls);
        timeSpanRecord.cls.remove(terminalsVisibleCls);
        me.showingTerminalsFor = null;
      } //endregion
      //region Dependency creation

      /**
       * Create a new dependency from source terminal to target terminal
       * @internal
       */

    }, {
      key: "createDependency",
      value: function createDependency(data) {
        var source = data.source,
            target = data.target,
            fromSide = data.sourceTerminal.dataset.side,
            toSide = data.targetTerminal.dataset.side,
            type = (fromSide === 'left' ? 0 : 2) + (toSide === 'right' ? 1 : 0);
        return this.dependencyStore.add({
          from: source.id,
          to: target.id,
          type: type,
          fromSide: fromSide,
          toSide: toSide
        })[0];
      } //endregion
      //region Tooltip

      /**
       * Update dependency creation tooltip
       * @private
       */

    }, {
      key: "generateTooltipContent",
      value: function generateTooltipContent(tip, data) {
        var _data$target$name, _data$target, _data$targetTerminal$, _data$targetTerminal;

        var me = this,
            valid = data.valid,
            classList = tip.element.classList;
        Object.assign(data, {
          fromText: data.source.name,
          toText: (_data$target$name = (_data$target = data.target) === null || _data$target === void 0 ? void 0 : _data$target.name) !== null && _data$target$name !== void 0 ? _data$target$name : '',
          fromSide: data.sourceTerminal.dataset.side,
          toSide: (_data$targetTerminal$ = (_data$targetTerminal = data.targetTerminal) === null || _data$targetTerminal === void 0 ? void 0 : _data$targetTerminal.dataset.side) !== null && _data$targetTerminal$ !== void 0 ? _data$targetTerminal$ : ''
        });
        var tipTitleIconClsSuffix, tipTitleText; // Promise, when using engine

        if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isPromise(valid)) {
          classList.remove('b-invalid');
          classList.add('b-checking');
          return new Promise(function (resolve) {
            return valid.then(function (valid) {
              data.valid = valid;

              if (!tip.isDestroyed) {
                resolve(me.generateTooltipContent(tip, data));
              }
            });
          });
        } // Valid
        else if (valid === true) {
            classList.remove('b-invalid');
            classList.remove('b-checking');
            tipTitleIconClsSuffix = 'valid';
            tipTitleText = me.L('L{Dependencies.valid}');
          } // Invalid
          else {
              classList.remove('b-checking');
              classList.add('b-invalid');
              tipTitleIconClsSuffix = 'invalid';
              tipTitleText = me.L('L{Dependencies.invalid}');
            }

        tip.title = "<i class=\"b-icon b-icon-".concat(tipTitleIconClsSuffix, "\"></i>").concat(tipTitleText);
        return "<table class=\"b-sch-dependency-creation-tooltip\">\n                        <tr><td>".concat(me.L('L{Dependencies.from}'), ": </td><td>").concat(data.fromText, "</td><td><div class=\"b-sch-box b-").concat(data.fromSide, "\"></div></td></tr>\n                        <tr><td>").concat(me.L('L{Dependencies.to}'), ": </td><td>").concat(data.toText, "</td><td><div class=\"b-sch-box b-").concat(data.toSide, "\"></div></td></tr>\n                    </table>");
      } //endregion

    }, {
      key: "allowCreate",
      set: function set(value) {
        this._allowCreate = value;
        this.updateCreateListeners();
      },
      get: function get() {
        return this._allowCreate;
      }
    }, {
      key: "isCreateAllowed",
      get: function get() {
        return this.allowCreate && !this.view.readOnly && !this.disabled;
      }
    }, {
      key: "listenersTarget",
      get: function get() {
        return document.body;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'DependencyCreation';
      } //region Config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * `false` to not show a tooltip while creating a dependency
           * @config {Boolean}
           * @default
           */
          showCreationTooltip: true,

          /**
           * A tooltip config object that will be applied to the dependency creation tooltip
           * @config {Object}
           */
          creationTooltip: null,

          /**
           * CSS class used for terminals
           * @config {String}
           * @default
           */
          terminalCls: 'b-sch-terminal',

          /**
           * Where (at events borders) to display terminals
           * @config {String[]}
           * @default
           */
          terminalSides: ['left', 'top', 'right', 'bottom'],

          /**
           * Set to `false` to not allow creating dependencies
           * @config {Boolean}
           * @default
           */
          allowCreate: true
        };
      }
    }]);

    return DependencyCreation;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_19__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/feature/mixin/RecurringEventEdit.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/feature/mixin/RecurringEventEdit.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _view_recurrence_RecurrenceConfirmationPopup_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../view/recurrence/RecurrenceConfirmationPopup.js */ "./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js");
/* harmony import */ var _view_recurrence_field_RecurrenceCombo_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../view/recurrence/field/RecurrenceCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceCombo.js");
/* harmony import */ var _view_recurrence_RecurrenceLegendButton_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../view/recurrence/RecurrenceLegendButton.js */ "./lib/Scheduler/view/recurrence/RecurrenceLegendButton.js");
/* harmony import */ var _view_recurrence_RecurrenceEditor_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../view/recurrence/RecurrenceEditor.js */ "./lib/Scheduler/view/recurrence/RecurrenceEditor.js");























function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_15___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Scheduler/feature/mixin/RecurringEventEdit
 */

/**
 * This mixin class provides recurring events functionality to the {@link Scheduler.feature.EventEdit event editor}.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default()(RecurringEventEdit, _ref);

    var _super = _createSuper(RecurringEventEdit);

    function RecurringEventEdit() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, RecurringEventEdit);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default()(RecurringEventEdit, [{
      key: "changeEditorConfig",
      value: function changeEditorConfig(editorConfig) {
        editorConfig.items = _objectSpread(_objectSpread({}, editorConfig.items), this.recurringEventsItems); // EditBase inserts extraItems *after* all default items are in

        editorConfig = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(RecurringEventEdit.prototype), "changeEditorConfig", this).call(this, editorConfig);
        return editorConfig;
      }
    }, {
      key: "construct",
      value: function construct(scheduler, config) {
        var me = this;

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(RecurringEventEdit.prototype), "construct", this).call(this, scheduler, config);

        me.scheduler.on({
          beforeEventDelete: me.onRecurrableEventBeforeDelete,
          beforeEventSave: me.onRecurrableEventBeforeSave,
          thisObj: me
        });
      }
    }, {
      key: "doDestroy",
      value: function doDestroy() {
        this._recurrenceConfirmation && this.recurrenceConfirmation.destroy();
        this._recurrenceEditor && this.recurrenceEditor.destroy();

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(RecurringEventEdit.prototype), "doDestroy", this).call(this);
      }
    }, {
      key: "onEditorConstructed",
      value: function onEditorConstructed(editor) {
        var me = this;
        editor.on('hide', me.onRecurringEventEditorHide, me);
        editor.widgetMap.editRecurrenceButton.menu = me.recurrenceEditor;
        me.recurrenceCombo.on('change', me.onRecurrenceComboChange.bind(me));
      }
    }, {
      key: "internalShowEditor",
      value: function internalShowEditor() {
        this.toggleRecurringFieldsVisibility(this.client.enableRecurringEvents && this.showRecurringUI !== false);
      }
    }, {
      key: "toggleRecurringFieldsVisibility",
      value: function toggleRecurringFieldsVisibility() {
        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var methodName = show ? 'show' : 'hide';
        this.editRecurrenceButton && this.editRecurrenceButton[methodName]();
        this.recurrenceCombo && this.recurrenceCombo[methodName]();
      }
    }, {
      key: "onRecurringEventEditorHide",
      value: function onRecurringEventEditorHide(_ref2) {
        var source = _ref2.source;
        var recurrenceEditor = this.recurrenceEditor,
            recurrenceConfirmation = this.recurrenceConfirmation;

        if (recurrenceEditor && recurrenceEditor.isVisible) {
          recurrenceEditor.hide();
        }

        if (recurrenceConfirmation && recurrenceConfirmation.isVisible) {
          recurrenceConfirmation.hide();
        }
      } // Builds RecurrenceModel to load into the recurrenceEditor
      // It builds the model based on either:
      // - recurrence rule string (if provided)
      // - or the event being edited recurrence (if the event is repeating)
      // - or simply make a recurrence model w/ default state (by default means: Frequency=Daily, Interval=1)

    }, {
      key: "makeRecurrence",
      value: function makeRecurrence(rule) {
        var event = this.eventRecord,
            eventCopy = event.copy();
        var recurrence = event.recurrence;

        if (!rule && recurrence) {
          recurrence = recurrence.copy();
        } else {
          recurrence = new event.recurrenceModel(rule ? {
            rule: rule
          } : {});
        } // bind cloned recurrence to the cloned event


        recurrence.timeSpan = eventCopy; // update cloned event w/ start date from the UI field

        eventCopy.setStartDate(this.values.startDate);
        recurrence.suspendTimeSpanNotifying();
        return recurrence;
      }
    }, {
      key: "onRecurrableEventBeforeSave",
      value: function onRecurrableEventBeforeSave(_ref3) {
        var eventRecord = _ref3.eventRecord,
            context = _ref3.context;
        var me = this;

        if (eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence)) {
          me.recurrenceConfirmation.confirm({
            actionType: 'update',
            eventRecord: eventRecord,
            changerFn: function changerFn() {
              context.finalize(true);
            },
            cancelFn: function cancelFn() {
              context.finalize(false);
            }
          }); // signalizes that we plan to decide save or not asynchronously

          context.async = true;
          return false;
        }
      }
    }, {
      key: "showDisplayConfirmationOnEventDelete",
      value: function showDisplayConfirmationOnEventDelete(eventRecord) {
        return this.isEditing && this.eventRecord === eventRecord && eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence);
      }
    }, {
      key: "onRecurrableEventBeforeDelete",
      value: function onRecurrableEventBeforeDelete(_ref4) {
        var eventRecords = _ref4.eventRecords,
            context = _ref4.context;

        var _eventRecords = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_14___default()(eventRecords, 1),
            eventRecord = _eventRecords[0];

        if (this.showDisplayConfirmationOnEventDelete(eventRecord)) {
          this.recurrenceConfirmation.confirm({
            actionType: 'delete',
            eventRecord: eventRecord,
            changerFn: function changerFn() {
              context.finalize(true);
            },
            cancelFn: function cancelFn() {
              context.finalize(false);
            }
          });
          return false;
        }
      }
    }, {
      key: "onBeforeShowRecurrenceEditor",
      value: function onBeforeShowRecurrenceEditor() {
        var me = this,
            recurrenceEditor = me.recurrenceEditor,
            eventRecord = me.eventRecord;

        if (recurrenceEditor && eventRecord && eventRecord.supportsRecurring) {
          // if the event has no recurrence yet ..initialize it before showing recurrence editor
          if (!me.recurrence) {
            me.recurrence = me.makeRecurrence();
          } // update the cloned recurrence w/ up to date start date value


          me.recurrence.timeSpan.setStartDate(me.values.startDate); // load RecurrenceModel record into the recurrence editor

          recurrenceEditor.record = me.recurrence; // In case they drag it. Centered falls off if the widget has position set.

          recurrenceEditor.centered = true;
        }
      }
    }, {
      key: "loadRecurrenceData",
      value: function loadRecurrenceData(recurrence) {
        this.recurrence = recurrence;
        this.updateRecurrenceFields(recurrence);
      }
    }, {
      key: "updateRecurrenceFields",
      value: function updateRecurrenceFields(recurrence) {
        var me = this,
            editRecurrenceButton = me.editRecurrenceButton;

        if (me.recurrenceCombo) {
          me.recurrenceCombo.recurrence = recurrence;
        } // update the recurrence legend


        if (editRecurrenceButton) {
          editRecurrenceButton.recurrence = recurrence;
          editRecurrenceButton.value = recurrence ? recurrence.rule : null;

          if (recurrence && me.client.enableRecurringEvents && me.showRecurringUI !== false) {
            editRecurrenceButton.show();
          } else {
            editRecurrenceButton.hide();
          }
        }
      }
    }, {
      key: "onRecurrenceComboChange",
      value: function onRecurrenceComboChange(_ref5) {
        var source = _ref5.source,
            value = _ref5.value,
            userAction = _ref5.userAction;
        var me = this,
            recurrenceEditor = me.recurrenceEditor;

        if (value == source.customValue) {
          // if user picked "Custom" - show recurrence editor
          if (userAction) {
            // This will recurse through the change event into the opposite side
            // of the value test which will call updateRecurrenceFields, where the
            // assignment to the value of the recurrenceCombo will be a non-change.
            // That will sync the state of the recurrenceButton.
            me.recurrenceCombo.recurrence = me.makeRecurrence();

            if (recurrenceEditor.centered) {
              recurrenceEditor.show();
            } else {
              recurrenceEditor.show((me.editRecurrenceButton || source).element);
            }
          }
        } // user has picked some frequency -> make a new recurrence based on it
        else {
            me.loadRecurrenceData(value ? me.makeRecurrence("FREQ=".concat(value)) : null);
          }
      }
    }, {
      key: "recurrenceEditorSaveHandler",
      value: function recurrenceEditorSaveHandler(editor, recurrence) {
        // apply changes to the kept recurrence
        editor.syncEventRecord(recurrence); // update the recurrence related UI

        this.updateRecurrenceFields(recurrence);
        editor.close();
      }
    }, {
      key: "onDatesChange",
      value: function onDatesChange() {
        var _get2;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(RecurringEventEdit.prototype), "onDatesChange", this)).call.apply(_get2, [this].concat(args));

        var me = this,
            editRecurrenceButton = me.editRecurrenceButton;

        if (!me.loadingRecord && editRecurrenceButton) {
          var startDate = me.values.startDate;
          if (startDate) editRecurrenceButton.eventStartDate = startDate;
        }
      }
    }, {
      key: "internalLoadRecord",
      value: function internalLoadRecord(eventRecord, resourceRecord) {
        if (this.recurrenceCombo && eventRecord && eventRecord.supportsRecurring) {
          this.loadRecurrenceData(eventRecord.recurrence ? this.makeRecurrence() : null);
        }
      }
    }, {
      key: "recurrenceConfirmation",
      set: function set(recurrenceConfirmation) {
        this._recurrenceConfirmation = recurrenceConfirmation;
      },
      get: function get() {
        var me = this;
        var recurrenceConfirmation = me._recurrenceConfirmation;

        if (!recurrenceConfirmation || !recurrenceConfirmation.$$name) {
          recurrenceConfirmation = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_22__["default"].create(Object.assign({
            type: 'recurrenceconfirmation',
            owner: me.getEditor()
          }, recurrenceConfirmation));
          me._recurrenceConfirmation = recurrenceConfirmation;
        }

        return recurrenceConfirmation;
      }
    }, {
      key: "recurrenceEditor",
      set: function set(recurrenceEditor) {
        this._recurrenceEditor = recurrenceEditor;
      },
      get: function get() {
        var me = this;
        var recurrenceEditor = me._recurrenceEditor; // Recurrence editor is centered and modal.

        if (!recurrenceEditor || !recurrenceEditor.$$name) {
          recurrenceEditor = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_22__["default"].create(Object.assign({
            type: 'recurrenceeditor',
            autoShow: false,
            clippedBy: [me.scheduler.timeAxisSubGridElement, me.scheduler.bodyContainer],
            centered: true,
            modal: true,
            constrainTo: window,
            anchor: false,
            saveHandler: me.recurrenceEditorSaveHandler,
            onBeforeShow: me.onBeforeShowRecurrenceEditor.bind(me),
            thisObj: me
          }, recurrenceEditor));
          me._recurrenceEditor = recurrenceEditor; // Must set *after* construction, otherwise it becomes the default state
          // to reset readOnly back to.  Must use direct property access because
          // getter consults state of editor.

          recurrenceEditor.readOnly = me._readOnly;
        }

        return recurrenceEditor;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'RecurringEventEdit';
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          recurringEventsItems: {
            /**
             * Reference to the `Repeat` event field, if used
             * @member {Scheduler.view.recurrence.field.RecurrenceCombo} recurrenceCombo
             * @readonly
             */
            recurrenceCombo: {
              type: 'recurrencecombo',
              label: 'L{EventEdit.Repeat}',
              ref: 'recurrenceCombo',
              weight: 700
            },

            /**
             * Reference to the button that opens the event repeat settings dialog, if used
             * @member {Scheduler.view.recurrence.RecurrenceLegendButton} editRecurrenceButton
             * @readonly
             */
            editRecurrenceButton: {
              type: 'recurrencelegendbutton',
              ref: 'editRecurrenceButton',
              name: 'recurrenceRule',
              color: 'b-gray',
              flex: '1',
              weight: 800
            }
          },

          /**
           * Set to `false` to hide recurring fields in event editor,
           * even if the {@link Scheduler.view.mixin.RecurringEvents#config-enableRecurringEvents Recurring Events} is `true`
           * and a recurring event is being edited.
           * @config {Boolean}
           * @category Recurring
           */
          showRecurringUI: null
        };
      }
    }]);

    return RecurringEventEdit;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_23__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/localization/En.js":
/*!******************************************!*\
  !*** ./lib/Scheduler/localization/En.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Grid_localization_En_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Grid/localization/En.js */ "./lib/Grid/localization/En.js");
/* harmony import */ var _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");

var productName = 'scheduler';
/* eslint-disable quote-props */

 //<umd>



var locale = _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].mergeLocales(_Grid_localization_En_js__WEBPACK_IMPORTED_MODULE_2__["default"], {
  ResourceInfoColumn: {
    eventCountText: function eventCountText(data) {
      return data + ' event' + (data !== 1 ? 's' : '');
    }
  },
  Dependencies: {
    from: 'From',
    to: 'To',
    valid: 'Valid',
    invalid: 'Invalid'
  },
  DependencyType: {
    SS: 'SS',
    SF: 'SF',
    FS: 'FS',
    FF: 'FF',
    StartToStart: 'Start-to-Start',
    StartToEnd: 'Start-to-End',
    EndToStart: 'End-to-Start',
    EndToEnd: 'End-to-End',
    short: ['SS', 'SF', 'FS', 'FF'],
    long: ['Start-to-Start', 'Start-to-End', 'End-to-Start', 'End-to-End']
  },
  DependencyEdit: {
    From: 'From',
    To: 'To',
    Type: 'Type',
    Lag: 'Lag',
    'Edit dependency': 'Edit dependency',
    Save: 'Save',
    Delete: 'Delete',
    Cancel: 'Cancel',
    StartToStart: 'Start to Start',
    StartToEnd: 'Start to End',
    EndToStart: 'End to Start',
    EndToEnd: 'End to End'
  },
  EventEdit: {
    Name: 'Name',
    Resource: 'Resource',
    Start: 'Start',
    End: 'End',
    Save: 'Save',
    Delete: 'Delete',
    Cancel: 'Cancel',
    'Edit event': 'Edit event',
    Repeat: 'Repeat'
  },
  EventDrag: {
    eventOverlapsExisting: 'Event overlaps existing event for this resource',
    noDropOutsideTimeline: 'Event may not be dropped completely outside the timeline'
  },
  SchedulerBase: {
    'Add event': 'Add event',
    'Delete event': 'Delete event',
    'Unassign event': 'Unassign event'
  },
  // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/4.0.0.md for more information.
  HeaderContextMenu: {
    pickZoomLevel: 'Zoom',
    activeDateRange: 'Date range',
    startText: 'Start date',
    endText: 'End date',
    todayText: 'Today'
  },
  TimeAxisHeaderMenu: {
    pickZoomLevel: 'Zoom',
    activeDateRange: 'Date range',
    startText: 'Start date',
    endText: 'End date',
    todayText: 'Today'
  },
  EventFilter: {
    filterEvents: 'Filter tasks',
    byName: 'By name'
  },
  TimeRanges: {
    showCurrentTimeLine: 'Show current timeline'
  },
  PresetManager: {
    secondAndMinute: {
      displayDateFormat: 'll LTS'
    },
    minuteAndHour: {
      topDateFormat: 'ddd MM/DD, hA',
      displayDateFormat: 'll LST'
    },
    hourAndDay: {
      topDateFormat: 'ddd MM/DD',
      middleDateFormat: 'LST',
      displayDateFormat: 'll LST'
    },
    weekAndDay: {
      displayDateFormat: 'll LST'
    },
    dayAndWeek: {
      displayDateFormat: 'll LST'
    }
  },
  RecurrenceConfirmationPopup: {
    'delete-title': 'You are deleting an event',
    'delete-all-message': 'Do you want to delete all occurrences of this event?',
    'delete-further-message': 'Do you want to delete this and all future occurrences of this event, or only the selected occurrence?',
    'delete-further-btn-text': 'Delete All Future Events',
    'delete-only-this-btn-text': 'Delete Only This Event',
    'update-title': 'You are changing a repeating event',
    'update-all-message': 'Do you want to change all occurrences of this event?',
    'update-further-message': 'Do you want to change only this occurrence of the event, or this and all future occurrences?',
    'update-further-btn-text': 'All Future Events',
    'update-only-this-btn-text': 'Only This Event',
    Yes: 'Yes',
    Cancel: 'Cancel',
    width: 600
  },
  RecurrenceLegend: {
    ' and ': ' and ',
    // frequency patterns
    Daily: 'Daily',
    // Weekly on Sunday
    // Weekly on Sun, Mon and Tue
    'Weekly on {1}': function WeeklyOn1(_ref) {
      var days = _ref.days;
      return "Weekly on ".concat(days);
    },
    // Monthly on 16
    // Monthly on the last weekday
    'Monthly on {1}': function MonthlyOn1(_ref2) {
      var days = _ref2.days;
      return "Monthly on ".concat(days);
    },
    // Yearly on 16 of January
    // Yearly on the last weekday of January and February
    'Yearly on {1} of {2}': function YearlyOn1Of2(_ref3) {
      var days = _ref3.days,
          months = _ref3.months;
      return "Yearly on ".concat(days, " of ").concat(months);
    },
    // Every 11 days
    'Every {0} days': function Every0Days(_ref4) {
      var interval = _ref4.interval;
      return "Every ".concat(interval, " days");
    },
    // Every 2 weeks on Sunday
    // Every 2 weeks on Sun, Mon and Tue
    'Every {0} weeks on {1}': function Every0WeeksOn1(_ref5) {
      var interval = _ref5.interval,
          days = _ref5.days;
      return "Every ".concat(interval, " weeks on ").concat(days);
    },
    // Every 2 months on 16
    // Every 2 months on the last weekday
    'Every {0} months on {1}': function Every0MonthsOn1(_ref6) {
      var interval = _ref6.interval,
          days = _ref6.days;
      return "Every ".concat(interval, " months on ").concat(days);
    },
    // Every 2 years on 16 of January
    // Every 2 years on the last weekday of January and February
    'Every {0} years on {1} of {2}': function Every0YearsOn1Of2(_ref7) {
      var interval = _ref7.interval,
          days = _ref7.days,
          months = _ref7.months;
      return "Every ".concat(interval, " years on ").concat(days, " of ").concat(months);
    },
    // day position translations
    position1: 'the first',
    position2: 'the second',
    position3: 'the third',
    position4: 'the fourth',
    position5: 'the fifth',
    'position-1': 'the last',
    // day options
    day: 'day',
    weekday: 'weekday',
    'weekend day': 'weekend day',
    // {0} - day position info ("the last"/"the first"/...)
    // {1} - day info ("Sunday"/"Monday"/.../"day"/"weekday"/"weekend day")
    // For example:
    //  "the last Sunday"
    //  "the first weekday"
    //  "the second weekend day"
    daysFormat: function daysFormat(_ref8) {
      var position = _ref8.position,
          days = _ref8.days;
      return "".concat(position, " ").concat(days);
    }
  },
  RecurrenceEditor: {
    'Repeat event': 'Repeat event',
    Cancel: 'Cancel',
    Save: 'Save',
    Frequency: 'Frequency',
    Every: 'Every',
    DAILYintervalUnit: 'day(s)',
    WEEKLYintervalUnit: 'week(s)',
    MONTHLYintervalUnit: 'month(s)',
    YEARLYintervalUnit: 'year(s)',
    Each: 'Each',
    'On the': 'On the',
    'End repeat': 'End repeat',
    'time(s)': 'time(s)'
  },
  RecurrenceDaysCombo: {
    day: 'day',
    weekday: 'weekday',
    'weekend day': 'weekend day'
  },
  RecurrencePositionsCombo: {
    position1: 'first',
    position2: 'second',
    position3: 'third',
    position4: 'fourth',
    position5: 'fifth',
    'position-1': 'last'
  },
  RecurrenceStopConditionCombo: {
    Never: 'Never',
    After: 'After',
    'On date': 'On date'
  },
  RecurrenceFrequencyCombo: {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
  },
  RecurrenceCombo: {
    None: 'None',
    Custom: 'Custom...'
  },
  //region Features
  Summary: {
    'Summary for': function SummaryFor(date) {
      return "Summary for ".concat(date);
    }
  },
  //endregion
  //region Export
  ScheduleRangeCombo: {
    completeview: 'Complete schedule',
    currentview: 'Visible schedule',
    daterange: 'Date range',
    completedata: 'Complete schedule (for all events)'
  },
  SchedulerExportDialog: {
    'Schedule range': 'Schedule range',
    'Export from': 'From',
    'Export to': 'To'
  },
  ExcelExporter: {
    'No resource assigned': 'No resource assigned'
  },
  //endregion
  CrudManagerView: {
    serverResponseLabel: 'Server response:'
  }
});
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].registerLocale('En', {
  desc: 'English',
  locale: locale
});

/***/ }),

/***/ "./lib/Scheduler/model/AssignmentModel.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/model/AssignmentModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentModel; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/AssignmentModelMixin.js */ "./lib/Scheduler/model/mixin/AssignmentModelMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_basic_BaseAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseAssignmentMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/CoreAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js");








var _window$bryntum;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/*  */


var EngineMixin =
/*  */
_Engine_quark_model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_11__["CoreAssignmentMixin"];
/**
 * @module Scheduler/model/AssignmentModel
 */

/**
 * This model represent a single assignment of a resource to an event in scheduler, usually added to a
 * {@link Scheduler.data.AssignmentStore}.
 *
 * It is a subclass of {@link Core.data.Model} class. Please refer to the documentation for that class to become
 * familiar with the base interface of this class.
 *
 * ## Fields and references
 *
 * An Assignment has the following fields:
 * - `id` - The id of the assignment
 * - `resourceId` - The id of the resource assigned (optionally replaced with `resource` for load)
 * - `eventId` - The id of the event to which the resource is assigned (optionally replaced with `event` for load)
 *
 * The data source for these fields can be customized by subclassing this class:
 *
 * ```javascript
 * class MyAssignment extends AssignmentModel {
 *   static get fields() {
 *       return [
 *          { name : 'resourceId', dataSource : 'linkedResource' }
 *       ];
 *   }
 * }
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `event` - The linked event record
 * - `resource` - The linked resource record
 *
 * ## Async resolving of references
 *
 * As described above, an assignment links an event to a resource. It holds references to an event record and a resource
 * record. These references are populated async, using the calculation engine of the project that the assignment via
 * its store is a part of. Because of this asyncness, references cannot be used immediately after modifications:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * // assignment.resource is not yet available
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * await assignment.project.commitAsync();
 * // assignment.resource is available
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await assignment.setAsync({ resourceId : 2});
 * // assignment.resource is available
 * ```
 *
 * @extends Core/data/Model
 * @mixes Scheduler/model/mixin/AssignmentModelMixin
 * @uninherit Core/data/mixin/TreeNode
 */

var AssignmentModel = /*#__PURE__*/function (_AssignmentModelMixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(AssignmentModel, _AssignmentModelMixin);

  var _super = _createSuper(AssignmentModel);

  function AssignmentModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, AssignmentModel);

    return _super.apply(this, arguments);
  }

  return AssignmentModel;
}(Object(_mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_8__["default"])(EngineMixin.derive(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_7__["default"]))));


AssignmentModel.exposeProperties();
AssignmentModel._$name = 'AssignmentModel';

/***/ }),

/***/ "./lib/Scheduler/model/DependencyBaseModel.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/model/DependencyBaseModel.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyBaseModel; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find-index */ "./node_modules/core-js/modules/es.array.find-index.js");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/data/Duration.js */ "./lib/Core/data/Duration.js");


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Scheduler/model/DependencyBaseModel
 */

var canonicalDependencyTypes = ['SS', 'SF', 'FS', 'FF'];
/**
 * Base class used for both Scheduler and Gantt. Not intended to be used directly
 *
 * @extends Core/data/Model
 */

var DependencyBaseModel = /*#__PURE__*/function (_Model) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(DependencyBaseModel, _Model);

  var _super = _createSuper(DependencyBaseModel);

  function DependencyBaseModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_11___default()(this, DependencyBaseModel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_12___default()(DependencyBaseModel, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(data) {
      // Engine expects fromEvent and toEvent, not from and to. We need to support both
      if (data.from != null) {
        data.fromEvent = data.from;
      }

      if (data.to != null) {
        data.toEvent = data.to;
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(DependencyBaseModel.prototype), "construct", this).apply(this, arguments); // if (data) {
      //     // Allow passing in event instances too
      //     if (data.from && data.from instanceof TimeSpan) {
      //         this.sourceEvent = data.from;
      //         delete data.from;
      //     }
      //
      //     if (data.to && data.to instanceof TimeSpan) {
      //         this.targetEvent = data.to;
      //         delete data.to;
      //     }
      // }

    } //endregion

  }, {
    key: "getHardType",

    /**
     * Returns dependency hard type, see {@link #property-hardType}.
     *
     * @return {Number}
     */
    value: function getHardType() {
      return this.get('type');
    }
    /**
     * Sets dependency {@link #field-type} and resets {@link #field-fromSide} and {@link #field-toSide} to null.
     *
     * @param {Number} type
     */

  }, {
    key: "setHardType",
    value: function setHardType(type) {
      var result;

      if (type !== this.getHardType()) {
        result = this.set({
          type: type,
          fromSide: null,
          toSide: null
        });
      }

      return result;
    }
  }, {
    key: "setLag",

    /**
     * Sets lag and lagUnit in one go. Only allowed way to change lagUnit, the lagUnit field is
     * readonly after creation
     * @param {Number|String|Object} lag The lag value. May be just a numeric magnitude, or a full string descriptor eg '1d'
     * @param {String} [lagUnit] Unit for numeric lag value, see {@link #field-lagUnit} for valid values
     */
    value: function setLag(lag, lagUnit) {
      // Either they're only setting the magnitude
      // or, if it's a string, parse the full duration.
      if (arguments.length === 1) {
        if (typeof lag === 'number') {
          this.lag = lag;
        } else {
          lag = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].parseDuration(lag);
          this.set({
            lag: lag.magnitude,
            lagUnit: lag.unit
          });
        }

        return;
      } // Must be a number


      lag = parseFloat(lag);
      this.set({
        lag: lag,
        lagUnit: lagUnit
      });
    }
  }, {
    key: "getLag",
    value: function getLag() {
      if (this.lag) {
        return "".concat(this.lag < 0 ? '-' : '+').concat(Math.abs(this.lag)).concat(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getShortNameOfUnit(this.lagUnit));
      }

      return '';
    }
    /**
     * Property which encapsulates the lag's magnitude and units.
     * An object which contains two properties:
     * - magnitude : [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The magnitude of the duration.
     * - unit : [String](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String) The unit in which the duration is measured, eg `'d'` for days.
     * @property {Core.data.Duration}
     */

  }, {
    key: "getSourceEvent",
    // TODO: Deprecate

    /**
     * Returns the source event of the dependency
     *
     * @return {Scheduler.model.EventModel} The source event of this dependency
     */
    value: function getSourceEvent() {
      return this.fromEvent;
    }
    /**
     * Gets/sets the dependency type
     *
     * @property {Number}
     */

    /**
     * Gets/sets the name of field holding the CSS class for each rendered dependency element
     *
     * @property {String} cls
     */
    // TODO: Deprecate

    /**
     * Returns the target event of the dependency
     *
     * @return {Scheduler.model.EventModel} The target event of this dependency
     */

  }, {
    key: "getTargetEvent",
    value: function getTargetEvent() {
      return this.toEvent;
    }
  }, {
    key: "getDateRange",
    value: function getDateRange() {
      var doNotNormalize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var fromEvent = this.fromEvent,
          toEvent = this.toEvent;

      if (fromEvent && toEvent && fromEvent.isScheduled && toEvent.isScheduled) {
        var Type = DependencyBaseModel.Type;
        var sourceDate, targetDate;

        switch (this.type) {
          case Type.StartToStart:
            sourceDate = fromEvent.startDate;
            targetDate = toEvent.startDate;
            break;

          case Type.StartToEnd:
            sourceDate = fromEvent.startDate;
            targetDate = toEvent.endDate;
            break;

          case Type.EndToEnd:
            sourceDate = fromEvent.endDate;
            targetDate = toEvent.endDate;
            break;

          case Type.EndToStart:
            sourceDate = fromEvent.endDate;
            targetDate = toEvent.startDate;
            break;
        }

        return {
          start: doNotNormalize ? sourceDate : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].min(sourceDate, targetDate),
          end: doNotNormalize ? targetDate : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].max(sourceDate, targetDate)
        };
      }

      return null;
    }
    /**
     * Applies given CSS class to dependency, the value doesn't persist
     *
     * @param {String} cls
     */

  }, {
    key: "highlight",
    value: function highlight(cls) {
      var h = this.highlighted ? this.highlighted.split(' ') : [];
      if (!h.includes(cls)) this.highlighted = h.concat(cls).join(' ');
    }
    /**
     * Removes given CSS class from dependency if applied, the value doesn't persist
     *
     * @param {String} cls
     */

  }, {
    key: "unhighlight",
    value: function unhighlight(cls) {
      var highlighted = this.highlighted;

      if (highlighted) {
        var h = highlighted.split(' '),
            idx = h.findIndex(function (i) {
          return i === cls;
        });

        if (idx >= 0) {
          h.splice(idx, 1);
          this.highlighted = h.join(' ');
        }
      }
    }
    /**
     * Checks if the given CSS class is applied to dependency.
     *
     * @param {String} cls
     * @return {Boolean}
     */

  }, {
    key: "isHighlightedWith",
    value: function isHighlightedWith(cls) {
      return this.highlighted && this.highlighted.split(' ').includes(cls);
    }
  }, {
    key: "getConnectorString",
    value: function getConnectorString(raw) {
      var rawValue = canonicalDependencyTypes[this.type];

      if (raw) {
        return rawValue;
      } // FS => empty string; it's the default


      if (this.type === DependencyBaseModel.Type.EndToStart) {
        return '';
      }

      return rawValue;
    } // getConnectorStringFromType(type, raw) {
    //     const rawValue = canonicalDependencyTypes[type];
    //
    //     if (raw) {
    //         return rawValue;
    //     }
    //
    //     // FS => empty string; it's the default
    //     if (type === DependencyBaseModel.Type.EndToStart) {
    //         return '';
    //     }
    //
    //     const locale = LocaleManager.locale;
    //
    //     // See if there is a local version of SS, SF or FF
    //     if (locale) {
    //         const localized = locale.Scheduler && locale.Scheduler[rawValue];
    //         if (localized) {
    //             return localized;
    //         }
    //     }
    //
    //     return rawValue;
    // }
    // getConnectorString(raw) {
    //     return this.getConnectorStringFromType(this.type);
    // }
    // * getConnectorStringGenerator(raw) {
    //     return this.getConnectorStringFromType(yield this.$.type);
    // }

  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.from).concat(this.getConnectorString()).concat(this.getLag());
    }
    /**
     * Returns `true` if the dependency is valid. Has valid type and both source and target ids set and not links to itself.
     *
     * @return {Boolean}
     * @typings ignore
     */

  }, {
    key: "sourceEvent",
    // fromEvent/toEvent defined in BaseDependencyMixin in engine

    /**
     * Gets/sets the source event of the dependency
     *
     * @property {Scheduler.model.EventModel}
     * @deprecated 4.0.0 Deprecated in favor of fromEvent
     */
    get: function get() {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of fromEvent');
      return this.fromEvent;
    },
    set: function set(event) {
      this.fromEvent = event;
    }
    /**
     * Gets/sets the target event of the dependency
     *
     * @property {Scheduler.model.EventModel}
     * @deprecated 4.0.0 Deprecated in favor of toEvent
     */

  }, {
    key: "targetEvent",
    get: function get() {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of toEvent');
      return this.toEvent;
    },
    set: function set(event) {
      this.targetEvent = event;
    }
  }, {
    key: "eventStore",
    get: function get() {
      var unjoinedStores = this.unjoinedStores;
      return this.eventStore || unjoinedStores[0] && unjoinedStores[0].eventStore;
    }
  }, {
    key: "from",
    set: function set(value) {
      var fromEvent = this.fromEvent; // When assigning a new id to an event, it will update the eventId of the assignment. But the assignments
      // event is still the same so we need to announce here

      if (fromEvent && fromEvent.isModel && fromEvent.id === value) {
        this.set('from', value);
      } else {
        this.fromEvent = value;
      }
    },
    get: function get() {
      return this.get('from');
    }
  }, {
    key: "to",
    set: function set(value) {
      var toEvent = this.toEvent; // When assigning a new id to an event, it will update the eventId of the assignment. But the assignments
      // event is still the same so we need to announce here

      if (toEvent && toEvent.isModel && toEvent.id === value) {
        this.set('to', value);
      } else {
        this.toEvent = value;
      }
    },
    get: function get() {
      return this.get('to');
    }
    /**
     * Alias to dependency type, but when set resets {@link #field-fromSide} {@link #field-toSide} to null as well.
     *
     * @property {Number}
     */

  }, {
    key: "hardType",
    get: function get() {
      return this.getHardType();
    },
    set: function set(type) {
      this.setHardType(type);
    }
  }, {
    key: "lag",
    get: function get() {
      return this.get('lag');
    },
    set: function set(lag) {
      if (typeof lag === 'number') {
        this.set({
          lag: lag
        });
      } else {
        this.setLag(lag);
      }
    }
  }, {
    key: "fullLag",
    get: function get() {
      return new _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_20__["default"]({
        unit: this.lagUnit,
        magnitude: this.lag
      });
    },
    set: function set(lag) {
      if (typeof lag === 'string') {
        this.setLag(lag);
      } else {
        this.setLag(lag.magnitude, lag.unit);
      }
    }
    /**
     * Returns true if the linked events have been persisted (e.g. neither of them are 'phantoms')
     *
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "isPersistable",
    get: function get() {
      var me = this,
          stores = me.stores,
          unjoinedStores = me.unjoinedStores,
          store = stores[0];
      var result;

      if (store) {
        var fromEvent = me.fromEvent,
            toEvent = me.toEvent,
            crudManager = store.crudManager; // if crud manager is used it can deal with phantom source/target since it persists all records in one batch
        // if no crud manager used we have to wait till source/target are persisted

        result = fromEvent && (crudManager || !fromEvent.hasGeneratedId) && toEvent && (crudManager || !toEvent.hasGeneratedId);
      } else {
        result = Boolean(unjoinedStores[0]);
      }

      return result;
    }
  }, {
    key: "isValid",
    get: function get() {
      var from = this.from,
          to = this.to,
          type = this.type;
      return typeof type === 'number' && from && from !== '' && to != null && to !== '' && from !== to;
    }
  }], [{
    key: "Type",

    /**
     * Set value for the specified field(s), triggering engine calculations immediately. See
     * {@link Core.data.Model#function-set Model#set()} for arguments.
     **
     * ```javascript
     * dependency.set('from', 2);
     * // dependency.fromEvent is not yet up to date
     *
     * await dependency.setAsync('from', 2);
     * // dependency.fromEvent is up to date
     * ```
     *
     * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
     * @param {*} value Value to set
     * @param {Boolean} [silent=false] Set to true to not trigger events
     * automatically.
     * @function setAsync
     * @category Editing
     * @async
     */
    //region Fields

    /**
     * An enumerable object, containing names for the dependency types integer constants.
     * - 0 StartToStart
     * - 1 StartToEnd
     * - 2 EndToStart
     * - 3 EndToEnd
     * @property {Object}
     * @readonly
     */
    get: function get() {
      return {
        StartToStart: 0,
        StartToEnd: 1,
        EndToStart: 2,
        EndToEnd: 3
      };
    }
  }, {
    key: "fields",
    get: function get() {
      return [// 3 mandatory fields

      /**
       * From event, id of source event
       * @field {String|number} from
       * @category Dependency
       */
      {
        name: 'from'
      },
      /**
       * To event, id of target event
       * @field {String|number} to
       * @category Dependency
       */
      {
        name: 'to'
      },
      /**
       * Dependency type, see static property Type
       * @field {Number} type
       * @default 2
       * @category Dependency
       */
      {
        name: 'type',
        type: 'int',
        defaultValue: 2
      },
      /**
       * CSS class to apply to lines drawn for the dependency
       * @field {String} cls
       * @category Styling
       */
      {
        name: 'cls',
        defaultValue: ''
      },
      /**
       * Bidirectional, drawn with arrows in both directions
       * @field {Boolean} bidirectional
       * @category Dependency
       */
      {
        name: 'bidirectional',
        type: 'boolean'
      },
      /**
       * Start side on source (top, left, bottom, right)
       * @field {String} fromSide
       * @category Dependency
       */
      {
        name: 'fromSide',
        type: 'string'
      },
      /**
       * End side on target (top, left, bottom, right)
       * @field {String} toSide
       * @category Dependency
       */
      {
        name: 'toSide',
        type: 'string'
      },
      /**
       * The magnitude of this dependency's lag (the number of units).
       * @field {Number} lag
       * @category Dependency
       */
      {
        name: 'lag',
        type: 'number',
        allowNull: true,
        defaultValue: 0
      },
      /**
       * The units of this dependency's lag, defaults to "d" (days). Valid values are:
       *
       * - "ms" (milliseconds)
       * - "s" (seconds)
       * - "m" (minutes)
       * - "h" (hours)
       * - "d" (days)
       * - "w" (weeks)
       * - "M" (months)
       * - "y" (years)
       *
       * This field is readonly after creation, to change lagUnit use #setlag().
       * @field {String} lagUnit
       * @category Dependency
       */
      {
        name: 'lagUnit',
        type: 'string',
        defaultValue: 'd'
      } //{ name : 'highlighted', type : 'string', persist : false }
      ];
    }
  }]);

  return DependencyBaseModel;
}(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_19__["default"]);


DependencyBaseModel.exposeProperties();
DependencyBaseModel._$name = 'DependencyBaseModel';

/***/ }),

/***/ "./lib/Scheduler/model/DependencyModel.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/model/DependencyModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyModel; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./DependencyBaseModel.js */ "./lib/Scheduler/model/DependencyBaseModel.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_model_scheduler_basic_BaseDependencyMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_basic/BaseDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseDependencyMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/CoreDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js");









var _window$bryntum;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/*  */


var EngineMixin =
/*  */
_Engine_quark_model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_11__["CoreDependencyMixin"];
/**
 * @module Scheduler/model/DependencyModel
 */

/**
 * This model represents a dependency between two events, usually added to a {@link Scheduler.data.DependencyStore}.
 *
 * It is a subclass of the {@link Scheduler.model.DependencyBaseModel} class, which in its turn subclasses
 * {@link Core.data.Model}. Please refer to documentation of those classes to become familiar with the base interface of
 * this class.
 *
 * ## Fields and references
 *
 * A Dependency has a few predefined fields, see Fields below.  The name of any fields data source can be customized in
 * the subclass, see the example below. Please also refer to {@link Core.data.Model} for details.
 *
 * ```javascript
 * class MyDependency extends DependencyModel {
 *   static get fields() {
 *     return [
 *       { name: 'to', dataSource: 'targetId' },
 *       { name: 'from', dataSource: 'sourceId' }
 *     ]);
 *   }
 * }
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `fromEvent` - The event on the start side of the dependency
 * - `toEvent` - The event on the end side of the dependency
 *
 * ## Async resolving of references
 *
 * As described above, a dependency has links to events. These references are populated async, using the calculation
 * engine of the project that the resource via its store is a part of. Because of this asyncness, references cannot be
 * used immediately after modifications:
 *
 * ```javascript
 * dependency.from = 2;
 * // dependency.fromEvent is not yet up to date
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * dependency.from = 2;
 * await dependency.project.commitAsync();
 * // dependency.fromEvent is up to date
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await dependency.setAsync({ from : 2});
 * // dependency.fromEvent is up to date
 * ```
 *
 * @extends Scheduler/model/DependencyBaseModel
 * @uninherit Core/data/mixin/TreeNode
 */

var DependencyModel = /*#__PURE__*/function (_PartOfProject) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DependencyModel, _PartOfProject);

  var _super = _createSuper(DependencyModel);

  function DependencyModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DependencyModel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DependencyModel, [{
    key: "getTypeFromSides",
    // Determines the type of dependency based on fromSide and toSide
    value: function getTypeFromSides(fromSide, toSide, rtl) {
      var types = _DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_8__["default"].Type,
          startSide = rtl ? 'right' : 'left',
          endSide = rtl ? 'left' : 'right';

      if (fromSide === startSide) {
        return toSide === startSide ? types.StartToStart : types.StartToEnd;
      }

      return toSide === endSide ? types.EndToEnd : types.EndToStart;
    }
  }]);

  return DependencyModel;
}(Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_9__["default"])(EngineMixin.derive(_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_8__["default"])));


DependencyModel.exposeProperties();
DependencyModel._$name = 'DependencyModel';

/***/ }),

/***/ "./lib/Scheduler/model/EventModel.js":
/*!*******************************************!*\
  !*** ./lib/Scheduler/model/EventModel.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventModel; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./mixin/RecurringTimeSpan.js */ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js");
/* harmony import */ var _mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/EventModelMixin.js */ "./lib/Scheduler/model/mixin/EventModelMixin.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_model_scheduler_basic_SchedulerBasicEvent_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js */ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicEvent.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/SchedulerCoreEvent.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js");








var _window$bryntum;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/*  */


var EngineMixin =
/*  */
_Engine_quark_model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_12__["SchedulerCoreEvent"];
/**
 * @module Scheduler/model/EventModel
 */

/**
 * This class represent a single event in your schedule, usually added to a {@link Scheduler.data.EventStore}.
 *
 * It is a subclass of the {@link Scheduler.model.TimeSpan}, which is in turn subclass of {@link Core.data.Model}.
 * Please refer to documentation of that class to become familiar with the base interface of the event.
 *
 * ## Async date calculations
 *
 * A record created from an `EventModel` is normally part of an `EventStore`, which in turn is part of a project. When
 * dates or the duration of an event is changed, the project performs async calculations to normalize the other fields.
 * For example if `duration` is change, it will calculate `endDate`.
 *
 * As a result of this being an async operation, the values of other fields are not guaranteed to be up to date
 * immediately after a change. To ensure data is up to date, await the calculations to finish.
 *
 * For example, `endDate` is not up to date after this operation:
 *
 * ```javascript
 * eventRecord.duration = 5;
 * // endDate not yet calculated
 * ```
 *
 * But if calculations are awaited it is up to date:
 *
 * ```javascript
 * eventRecord.duration = 5;
 * await eventRecord.project.commitAsync();
 * // endDate is calculated
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await eventRecord.setAsync({ duration : 5});
 * // endDate is calculated
 * ```
 *
 * ## Subclassing the Event model class
 * The Event model has a few predefined fields as seen below. If you want to add new fields or change the options for the existing fields,
 * you can do that by subclassing this class (see example below).
 *
 * ```
 * class MyEvent extends EventModel {
 *
 *     static get fields() {
 *         return [
 *            // Add new field
 *            { name: 'myField', type : 'number', defaultValue : 0 }
 *         ];
 *     },
 *
 *     myCheckMethod() {
 *         return this.myField > 0
 *     },
 *
 *     ...
 * });
 * ```
 * If you in your data want to use other names for the startDate, endDate, resourceId and name fields you can configure
 * them as seen below:
 * ```
 * class MyEvent extends EventModel {
 *
 *     static get fields() {
 *         return [
 *            { name: 'startDate', dataSource 'taskStart' },
 *            { name: 'endDate', dataSource 'taskEnd', format: 'YYYY-MM-DD' },
 *            { name: 'resourceId', dataSource 'userId' },
 *            { name: 'name', dataSource 'taskTitle' },
 *         ];
 *     },
 *     ...
 * });
 * ```
 *
 * Please refer to {@link Core.data.Model} for additional details.
 *
 * @extends Scheduler/model/TimeSpan
 * @mixes Scheduler/model/mixin/RecurringTimeSpan
 * @mixes Scheduler/model/mixin/EventModelMixin
 */

var EventModel = /*#__PURE__*/function (_EngineMixin$derive$m) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(EventModel, _EngineMixin$derive$m);

  var _super = _createSuper(EventModel);

  function EventModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, EventModel);

    return _super.apply(this, arguments);
  }

  return EventModel;
}(EngineMixin.derive(_TimeSpan_js__WEBPACK_IMPORTED_MODULE_7__["default"]).mixin(_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_8__["default"], _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_10__["default"], _mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_9__["default"]));


EventModel.exposeProperties();
EventModel._$name = 'EventModel';

/***/ }),

/***/ "./lib/Scheduler/model/ProjectModel.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/model/ProjectModel.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectModel; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/ProjectModelMixin.js */ "./lib/Scheduler/model/mixin/ProjectModelMixin.js");
/* harmony import */ var _data_util_ModelPersistencyManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../data/util/ModelPersistencyManager.js */ "./lib/Scheduler/data/util/ModelPersistencyManager.js");
/* harmony import */ var _Engine_quark_model_scheduler_basic_SchedulerBasicProjectMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_basic/SchedulerBasicProjectMixin.js */ "./lib/Engine/quark/model/scheduler_basic/SchedulerBasicProjectMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_SchedulerCoreProjectMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js");











var _window$bryntum;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/*  */


var EngineMixin =
/*  */
_Engine_quark_model_scheduler_core_SchedulerCoreProjectMixin_js__WEBPACK_IMPORTED_MODULE_14__["SchedulerCoreProjectMixin"];
/**
 * @module Scheduler/model/ProjectModel
 */

/**
 * This class represents a global project of your Scheduler - a central place for all data.
 *
 * It holds and links the stores usually used by Scheduler:
 *
 * - {@link Scheduler.data.AssignmentStore}
 * - {@link Scheduler.data.DependencyStore}
 * - {@link Scheduler.data.EventStore}
 * - {@link Scheduler.data.ResourceStore}
 *
 * The project uses a calculation engine to normalize dates and durations. It is also responsible for
 * handling references between models, for example to link an event via an assignment to a resource. These operations
 * are asynchronous, a fact that is hidden when working in the Scheduler UI but which you must know about when performing
 * more advanced operations on the data level.
 *
 * When there is a change to data that requires something else to be recalculated, the project schedules a calculation (a
 * commit) which happens moments later. It is also possible to trigger these calculations directly. This snippet illustrate
 * the process:
 *
 1. Something changes which requires the project to recalculate, for example adding a new task:
 *
 * ```javascript
 * const [event] = project.eventStore.add({ startDate, endDate });
 * ```
 *
 * 2. A recalculation is scheduled, thus:
 *
 * ```javascript
 * event.duration; // <- Not yet calculated
 * ```
 *
 * 3. Calculate now instead of waiting for the scheduled calculation
 *
 * ```javascript
 * await project.commitAsync();
 *
 * event.duration; // <- Now available
 * ```
 *
 * ## Built in StateTrackingManager
 *
 * The project also has a built in {@link Core.data.stm.StateTrackingManager StateTrackingManager} (STM for short), that
 * handles undo/redo for the project stores (additional stores can also be added). You can enable it to track all
 * project store changes:
 *
 * ```javascript
 * // Turn on auto recording when you create your Scheduler:
 * const scheduler = new Scheduler({
 *    project : {
 *        stm : {
 *            autoRecord : true
 *        }
 *    }
 * });
 *
 * // Undo a transaction
 * project.stm.undo();
 *
 * // Redo
 * project.stm.redo();
 * ```
 *
 * Check out the `undoredo` demo to see it in action.
 *
 * @extends Core/data/Model
 * @mixes Scheduler/model/mixin/ProjectModelMixin
 * @uninherit Core/data/mixin/TreeNode
 */

var ProjectModel = /*#__PURE__*/function (_ProjectModelMixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ProjectModel, _ProjectModelMixin);

  var _super = _createSuper(ProjectModel);

  function ProjectModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ProjectModel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ProjectModel, [{
    key: "construct",

    /**
     * Silences propagations caused by the project loading.
     *
     * Applying the loaded data to the project occurs in two basic stages:
     *
     * 1. Data gets into the engine graph which triggers changes propagation
     * 2. The changes caused by the propagation get written to related stores
     *
     * Setting this flag to `true` makes the component perform step 2 silently without triggering events causing reactions on those changes
     * (like sending changes back to the server if `autoSync` is enabled) and keeping stores in unmodified state.
     *
     * This is safe if the loaded data is consistent so propagation doesn't really do any adjustments.
     * By default the system treats the data as consistent so this option is `true`.
     *
     * ```js
     * new Scheduler({
     *     project : {
     *         // We want scheduling engine to recalculate the data properly
     *         // so then we could save it back to the server
     *         silenceInitialCommit : false
     *     }
     *     ...
     * })
     * ```
     *
     * @config {Boolean} silenceInitialCommit
     * @default true
     */
    value: function construct() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ProjectModel.prototype), "construct", this)).call.apply(_get2, [this].concat(args));

      if (_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isTestEnv) {
        window.bryntum.testProject = this;
      } // Moved here from EventStore, since project is now the container instead of it


      this.modelPersistencyManager = this.createModelPersistencyManager();
    }
    /**
     * Creates and returns model persistency manager
     *
     * @return {Scheduler.data.util.ModelPersistencyManager}
     * @internal
     */

  }, {
    key: "createModelPersistencyManager",
    value: function createModelPersistencyManager() {
      return new _data_util_ModelPersistencyManager_js__WEBPACK_IMPORTED_MODULE_12__["default"]({
        eventStore: this,
        resourceStore: this.resourceStore,
        assignmentStore: this.assignmentStore,
        dependencyStore: this.dependencyStore
      });
    }
  }]);

  return ProjectModel;
}(Object(_mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_11__["default"])(EngineMixin));


ProjectModel.applyConfigs = true;
ProjectModel._$name = 'ProjectModel';

/***/ }),

/***/ "./lib/Scheduler/model/RecurrenceModel.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/model/RecurrenceModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceModel; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony import */ var _data_util_recurrence_DailyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../data/util/recurrence/DailyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js");
/* harmony import */ var _data_util_recurrence_WeeklyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../data/util/recurrence/WeeklyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js");
/* harmony import */ var _data_util_recurrence_MonthlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../data/util/recurrence/MonthlyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js");
/* harmony import */ var _data_util_recurrence_YearlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../data/util/recurrence/YearlyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js");

















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';







/**
 * @module Scheduler/model/RecurrenceModel
 */

var recurrenceIterators = {};
[_data_util_recurrence_DailyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_19__["default"], _data_util_recurrence_WeeklyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_20__["default"], _data_util_recurrence_MonthlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_21__["default"], _data_util_recurrence_YearlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_22__["default"]].forEach(function (it) {
  recurrenceIterators[it.frequency] = it;
});

function convertStringOfIntegerItemsValue(value) {
  if (value) {
    if (typeof value == 'string') {
      value = value.split(',').map(function (item) {
        return parseInt(item, 10);
      });
    }
  } else {
    value = null;
  }

  return value;
}

function convertStringOfItemsValue(value) {
  if (value) {
    if (typeof value == 'string') {
      value = value.split(',');
    }
  } else {
    value = null;
  }

  return value;
}

function isEqualAsString(value1, value2) {
  return String(value1) === String(value2);
}

function convertInteger(value) {
  if (this.defaultValue && value === undefined) {
    return this.defaultValue;
  }

  if (this.allowNull && value == null) {
    return null;
  }

  value = parseInt(value);
  return isNaN(value) ? undefined : value;
}
/**
 * This class represents a timespan recurrence settings.
 * It is a subclass of {@link Core.data.Model} class.
 * Please refer to the documentation for that class to become familiar with the base interface of this class.
 *
 * The data source for these fields can be customized by subclassing this class.
 *
 * @extends Core/data/Model
 */


var RecurrenceModel = /*#__PURE__*/function (_Model) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(RecurrenceModel, _Model);

  var _super = _createSuper(RecurrenceModel);

  function RecurrenceModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, RecurrenceModel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(RecurrenceModel, [{
    key: "construct",
    value: function construct() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this,
          rule = data.rule,
          timeSpan = data.timeSpan;
      me._suspendedTimeSpanNotifying = 0;
      delete data.timeSpan;
      delete data.rule;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(RecurrenceModel.prototype), "construct", this).apply(this, arguments);

      if (rule) {
        me.suspendTimeSpanNotifying();
        me.rule = rule;
        me.resumeTimeSpanNotifying();
      }

      me.timeSpan = timeSpan;
    }
    /**
     * Iterate occurrences for the owning timespan across the specified date range. This method can be called even
     * if the timespan is not yet a member of a store, however, the occurrences returned will not be cached across
     * subsequent calls to this method.
     * @param {Date} startDate The start date of the iteration.
     * @param {Date} endDate The end date of the iteration.
     * @param {Function} fn The function to call for each occurrence.
     * @param {Scheduler.model.TimeSpan} fn.occurrence The occurrence.
     * @param {Boolean} fn.first A flag which is `true` for the first occurrence of this recurrence.
     * @param {Number} fn.counter A counter of how many dates have been visited in this iteration.
     * @param {Date} fn.date The occurrence date.
     * @internal
     */

  }, {
    key: "forEachOccurrence",
    value: function forEachOccurrence(startDate, endDate, _fn) {
      if (this.timeSpan.startDate) {
        this.recurrenceIterator.forEachDate({
          recurrence: this,
          startDate: startDate,
          endDate: endDate,
          fn: function fn(date, counter, first, timeSpan) {
            _fn(timeSpan.buildOccurrence(date, first), first, counter, date);
          }
        });
      }
    }
    /**
     * Cleans up fields that do not makes sense for the current {@link #field-frequency} value.
     * @private
     */

  }, {
    key: "sanitize",
    value: function sanitize() {
      var me = this,
          timeSpan = me.timeSpan,
          timeSpanStartDate = timeSpan && timeSpan.startDate;
      me.beginBatch();
      me.isSanitizing = true;

      switch (me.frequency) {
        case 'DAILY':
          me.positions = null;
          me.days = null;
          me.monthDays = null;
          me.months = null;
          break;

        case 'WEEKLY':
          me.positions = null;
          me.monthDays = null;
          me.months = null;
          var days = me.days;

          if (timeSpanStartDate && days && days.length == 1 && days[0] == _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_18__["default"].encodeDay(timeSpanStartDate.getDay())) {
            me.days = null;
          }

          break;

        case 'MONTHLY':
          if (me.monthDays && me.monthDays.length) {
            me.positions = null;
            me.days = null;
          }

          me.months = null;
          var monthDays = me.monthDays;

          if (timeSpanStartDate && monthDays && monthDays.length == 1 && monthDays[0] == timeSpanStartDate.getDate()) {
            me.monthDays = null;
          }

          break;

        case 'YEARLY':
          me.monthDays = null;
          var months = me.months;

          if (timeSpanStartDate && months && months.length == 1 && months[0] == timeSpanStartDate.getMonth() + 1) {
            me.months = null;
          }

          break;
      }

      me.isSanitizing = false;
      me.endBatch();
    }
  }, {
    key: "copy",
    value: function copy() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var result = (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(RecurrenceModel.prototype), "copy", this)).call.apply(_get2, [this].concat(args));

      result.dateFormat = this.dateFormat;
      result.timeSpan = this.timeSpan;
      return result;
    }
  }, {
    key: "afterChange",
    value: function afterChange(toSet, wasSet, silent) {
      var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(RecurrenceModel.prototype), "afterChange", this).call(this, toSet, wasSet, silent),
          timeSpan = this.timeSpan;

      if (!this.isSanitizing) {
        // cleanup data to match the chosen frequency
        this.sanitize();
      }

      if (timeSpan) {
        // Remove all exceptionsDates that our owning timeSpan had that are
        // now after our end date and therefore redundant.
        if ('endDate' in wasSet) {
          var endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].clearTime(wasSet.endDate.value),
              exceptionDates = timeSpan.exceptionDates; // Clear any now-invalid cached occurrences

          timeSpan.removeOccurrencesFrom(endDate); // If we had any exceptions on or after this date, remove them.

          if (exceptionDates) {
            for (var dateKey in exceptionDates) {
              var exceptionDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].parseKey(dateKey);

              if (exceptionDate >= endDate) {
                delete exceptionDates[dateKey];
              }
            }
          }
        }

        if (!this.isTimeSpanNotifyingSuspended) {
          timeSpan.onRecurrenceChanged();
        }
      }

      return result;
    }
  }, {
    key: "suspendTimeSpanNotifying",
    value: function suspendTimeSpanNotifying() {
      this._suspendedTimeSpanNotifying++;
    }
  }, {
    key: "resumeTimeSpanNotifying",
    value: function resumeTimeSpanNotifying() {
      if (this._suspendedTimeSpanNotifying) this._suspendedTimeSpanNotifying--;
    }
  }, {
    key: "isRecurrenceModel",

    /**
     * Indicates that this is a `RecurrenceModel` class instance
     * (allows to avoid using `instanceof`).
     * @property {Boolean} [isRecurrenceModel=true]
     * @readonly
     */
    get: function get() {
      return true;
    } //region Fields

  }, {
    key: "dateFormat",
    get: function get() {
      return this._dateFormat || 'YYYYMMDDTHHmmss';
    },
    set: function set(format) {
      this._dateFormat = format;
    }
  }, {
    key: "recurrenceIterator",
    get: function get() {
      return recurrenceIterators[this.frequency];
    }
    /**
     * The timespan this recurrence is associated with.
     */

  }, {
    key: "timeSpan",
    get: function get() {
      return this._timeSpan;
    },
    set: function set(value) {
      this._timeSpan = value;
    }
    /**
     * The recurrence rule. A string in [RFC-5545](https://tools.ietf.org/html/rfc5545#section-3.3.10) described format ("RRULE" expression).
     */

  }, {
    key: "rule",
    get: function get() {
      var me = this,
          result = [];

      if (me.frequency) {
        result.push("FREQ=".concat(me.frequency));

        if (me.interval > 1) {
          result.push("INTERVAL=".concat(me.interval));
        }

        if (me.days && me.days.length) {
          result.push('BYDAY=' + me.days.join(','));
        }

        if (me.monthDays && me.monthDays.length) {
          result.push('BYMONTHDAY=' + me.monthDays.join(','));
        }

        if (me.months && me.months.length) {
          result.push('BYMONTH=' + me.months.join(','));
        }

        if (me.count) {
          result.push("COUNT=".concat(me.count));
        }

        if (me.endDate) {
          result.push('UNTIL=' + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].format(me.endDate, me.dateFormat));
        }

        if (me.positions && me.positions.length) {
          result.push('BYSETPOS=' + me.positions.join(','));
        }
      }

      return result.join(';');
    },
    set: function set(rule) {
      var me = this;
      me.beginBatch();

      if (rule) {
        var parts = rule.split(';');

        for (var i = 0, len = parts.length; i < len; i++) {
          var part = parts[i].split('='),
              value = part[1];

          switch (part[0]) {
            case 'FREQ':
              me.frequency = value;
              break;

            case 'INTERVAL':
              me.interval = value;
              break;

            case 'COUNT':
              me.count = value;
              me.until = null;
              break;

            case 'UNTIL':
              if (value) {
                me.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].parse(value, me.dateFormat);
              } else {
                me.endDate = null;
              }

              me.count = null;
              break;

            case 'BYDAY':
              me.days = value;
              break;

            case 'BYMONTHDAY':
              me.monthDays = value;
              break;

            case 'BYMONTH':
              me.months = value;
              break;

            case 'BYSETPOS':
              me.positions = value;
              break;
          }
        }

        me.sanitize();
      } else {
        me.set({
          frequency: null,
          interval: null,
          count: null,
          endDate: null,
          days: null,
          monthDays: null,
          months: null,
          positions: null
        });
      }

      me.endBatch();
    }
  }, {
    key: "count",
    get: function get() {
      return this.get('count');
    },
    set: function set(value) {
      if (value) this.endDate = null;
      this.set('count', value);
    }
  }, {
    key: "endDate",
    get: function get() {
      return this.get('endDate');
    },
    set: function set(value) {
      if (value) this.count = null;
      this.set('endDate', value);
    }
  }, {
    key: "isTimeSpanNotifyingSuspended",
    get: function get() {
      return Boolean(this._suspendedTimeSpanNotifying);
    }
  }], [{
    key: "fields",
    get: function get() {
      return [
      /**
       * Field defines the recurrence frequency. Supported values are: `DAILY`, `WEEKLY`, `MONTHLY`, `YEARLY`.
       * @field {String} frequency
       */
      {
        name: 'frequency',
        defaultValue: 'DAILY'
      },
      /**
       * Field defines how often the recurrence repeats.
       * For example, if the recurrence is weekly its interval is 2, then the timespan repeats every two weeks.
       * @field {number} interval
       */
      {
        name: 'interval',
        defaultValue: 1,
        convert: convertInteger
      },
      /**
       * End date of the recurrence. Specifies when the recurrence ends.
       * The value is optional, the recurrence can as well be stopped using {@link #field-count} field value.
       * @field {Date} endDate
       */
      {
        name: 'endDate',
        type: 'date'
      },
      /**
       * Specifies the number of occurrences after which the recurrence ends.
       * The value includes the associated timespan itself so values less than 2 make no sense.
       * The field is optional, the recurrence as well can be stopped using {@link #field-endDate} field value.
       * @field {number} count
       */
      {
        name: 'count',
        allowNull: true,
        convert: convertInteger
      },
      /**
       * Specifies days of the week on which the timespan should occur.
       * An array of string values `SU`, `MO`, `TU`, `WE`, `TH`, `FR`, `SA`
       * corresponding to Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, and Saturday days of the week.
       * Each value can also be preceded by a positive (+n) or negative (-n) integer.
       * If present, this indicates the nth occurrence of a specific day within the monthly or yearly recurrence.
       *
       * **Not applicable** for daily {@link #field-frequency}.
       * @field {String[]} days
       */
      {
        name: 'days',
        convert: convertStringOfItemsValue,
        isEqual: isEqualAsString
      },
      /**
       * Specifies days of the month on which the timespan should occur.
       * An array of integer values (-31..-1 - +1..+31, negative values mean counting backwards from the month end).
       * **Applicable only** for monthly {@link #field-frequency}.
       * @field {number[]} monthDays
       */
      {
        name: 'monthDays',
        convert: convertStringOfIntegerItemsValue,
        isEqual: isEqualAsString
      },
      /**
       * Specifies months of the year on which the timespan should occur.
       * An array of integer values (1 - 12).
       * **Applicable only** for yearly {@link #field-frequency}.
       * @field {number[]} months
       */
      {
        name: 'months',
        convert: convertStringOfIntegerItemsValue,
        isEqual: isEqualAsString
      },
      /**
       * The positions to include in the recurrence. The values operate on a set of recurrence instances **in one interval** of the recurrence rule.
       * An array of integer values (valid values are 1 to 366 or -366 to -1, negative values mean counting backwards from the end of the built list of occurrences).
       * **Not applicable** for daily {@link #field-frequency}.
       * @field {number} positions
       */
      {
        name: 'positions',
        convert: convertStringOfIntegerItemsValue,
        isEqual: isEqualAsString
      }];
    }
  }]);

  return RecurrenceModel;
}(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_16__["default"]);


RecurrenceModel._$name = 'RecurrenceModel';

/***/ }),

/***/ "./lib/Scheduler/model/ResourceModel.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/model/ResourceModel.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceModel; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Grid/data/GridRowModel.js */ "./lib/Grid/data/GridRowModel.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/ResourceModelMixin.js */ "./lib/Scheduler/model/mixin/ResourceModelMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_basic_BaseResourceMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_basic/BaseResourceMixin.js */ "./lib/Engine/quark/model/scheduler_basic/BaseResourceMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");








var _window$bryntum;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/*  */


var EngineMixin =
/*  */
_Engine_quark_model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_11__["CoreResourceMixin"];
/**
 * @module Scheduler/model/ResourceModel
 */

/**
 * This class represent a single Resource in scheduler, usually added to a {@link Scheduler.data.ResourceStore}.
 *
 * It is a subclass of  {@link Core.data.Model}. Please refer to the documentation for that class to become familiar
 * with the base interface of the resource.
 *
 * ## Fields and references
 *
 * A resource has a few predefined fields, see Fields below. If you want to add more fields with meta data describing
 * your resources then you should subclass this class:
 *
 * ```javascript
 * class MyResource extends ResourceModel {
 *   static get fields() {
 *     return [
 *       // "id" and "name" fields are already provided by the superclass
 *       { name: 'company', type : 'string' }
 *     ];
 *   }
 * });
 * ```
 *
 * If you want to use other names in your data for the id and name fields you can configure them as seen below:
 *
 * ```javascript
 * class MyResource extends ResourceModel {
 *   static get fields() {
 *     return [
 *        { name: 'name', dataSource: 'userName' }
 *     ];
 *   },
 * });
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `assignments` - The linked assignment records
 * - `events` - The linked (through assignments) event records
 *
 * ## Async resolving of references
 *
 * As described above, a resource has links to assignments and events. These references are populated async, using the
 * calculation engine of the project that the resource via its store is a part of. Because of this asyncness, references
 * cannot be used immediately after assignment modifications:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * // resource.assignments is not yet up to date
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * await assignment.project.commitAsync();
 * // resource.assignments is up to date
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await assignment.setAsync({ resourceId : 2});
 * // resource.assignments is up to date
 * ```
 *
 * @extends Grid/data/GridRowModel
 * @mixes Scheduler/model/mixin/ResourceModelMixin
 */

var ResourceModel = /*#__PURE__*/function (_ResourceModelMixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ResourceModel, _ResourceModelMixin);

  var _super = _createSuper(ResourceModel);

  function ResourceModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ResourceModel);

    return _super.apply(this, arguments);
  }

  return ResourceModel;
}(Object(_mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_8__["default"])(EngineMixin.derive(_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_7__["default"]))));


ResourceModel.exposeProperties();
ResourceModel._$name = 'ResourceModel';

/***/ }),

/***/ "./lib/Scheduler/model/ResourceTimeRangeModel.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/model/ResourceTimeRangeModel.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRangeModel; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/model/ResourceTimeRangeModel
 */

/**
 * This class represent a single resource time range in your schedule. To style
 * the rendered elements, use the {@link Scheduler.model.TimeSpan#field-cls cls} field of the `TimeSpan` class, or use the {@link #field-timeRangeColor} field.
 *
 * @extends Scheduler/model/TimeSpan
 */

var ResourceTimeRangeModel = /*#__PURE__*/function (_TimeSpan) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ResourceTimeRangeModel, _TimeSpan);

  var _super = _createSuper(ResourceTimeRangeModel);

  function ResourceTimeRangeModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ResourceTimeRangeModel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ResourceTimeRangeModel, [{
    key: "isResourceTimeRange",
    //endregion
    // Used internally to differentiate between Event and ResourceTimeRange
    get: function get() {
      return true;
    } // To match EventModel API

  }, {
    key: "resources",
    get: function get() {
      return this.resource ? [this.resource] : [];
    }
  }], [{
    key: "fields",
    //region Fields
    get: function get() {
      return [
      /**
       * Id of the resource this time range is associated with
       * @field {String|Number} resourceId
       */
      'resourceId',
      /**
       * Controls this time ranges primary color, defaults to using current themes default time range color.
       * @field {String} timeRangeColor
       */
      'timeRangeColor'];
    }
  }, {
    key: "relationConfig",
    get: function get() {
      return [
      /**
       * The associated resource, retrieved using a relation to a ResourceStore determined by the value assigned
       * to `resourceId`. The relation also lets you access all time ranges on a resource through
       * `ResourceModel#timeRanges`.
       * @property {Scheduler.model.ResourceModel} resource
       */
      {
        relationName: 'resource',
        fieldName: 'resourceId',
        store: 'resourceStore',
        collectionName: 'timeRanges',
        nullFieldOnRemove: true
      }];
    }
  }]);

  return ResourceTimeRangeModel;
}(_TimeSpan_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


ResourceTimeRangeModel._$name = 'ResourceTimeRangeModel';

/***/ }),

/***/ "./lib/Scheduler/model/TimeSpan.js":
/*!*****************************************!*\
  !*** ./lib/Scheduler/model/TimeSpan.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeSpan; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Core/data/Duration.js */ "./lib/Core/data/Duration.js");


























function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_18___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Scheduler/model/TimeSpan
 */

/**
 * This class represent a simple date range. It is being used in various subclasses and plugins which operate on date ranges.
 *
 * Its a subclass of  {@link Core.data.Model}.
 * Please refer to documentation of those classes to become familiar with the base interface of this class.
 *
 * A TimeSpan has the following fields:
 *
 * - `startDate`    - start date of the task in the ISO 8601 format
 * - `endDate`      - end date of the task in the ISO 8601 format (not inclusive)
 * - `duration`     - duration, time between start date and end date
 * - `durationUnit` - unit used to express the duration
 * - `name`         - an optional name of the range
 * - `cls`          - an optional CSS class to be associated with the range.
 *
 * The data source of any field can be customized in the subclass. Please refer to {@link Core.data.Model} for details. To specify
 * another date format:
 *
 * ```javascript
 * class MyTimeSpan extends TimeSpan {
 *   static get fields() {
 *      { name: 'startDate', type: 'date', dateFormat: 'DD/MM/YY' }
 *   }
 * }
 * ```
 *
 * @extends Core/data/Model
 */

var TimeSpan = /*#__PURE__*/function (_Model) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22___default()(TimeSpan, _Model);

  var _super = _createSuper(TimeSpan);

  function TimeSpan() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_19___default()(this, TimeSpan);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_20___default()(TimeSpan, [{
    key: "afterConstruct",
    //endregion
    //region Init
    value: function afterConstruct() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(TimeSpan.prototype), "afterConstruct", this).call(this); // This should probably be a property setter of some mandatory config, then we would not need an afterConfigure implementation.


      this.normalize();
    }
    /**
     * Returns the event store this event is part of.
     *
     * @return {Scheduler.data.EventStore}
     * @readonly
     */

  }, {
    key: "normalize",
    value: function normalize() {
      var me = this,
          startDate = me.startDate,
          endDate = me.endDate,
          duration = me.duration,
          durationUnit = me.durationUnit,
          hasDuration = duration != null; // need to calculate duration (checking first since seemed most likely to happen)

      if (startDate && endDate && !hasDuration) {
        me.setData('duration', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].diff(startDate, endDate, durationUnit, true));
      } // need to calculate endDate?
      else if (startDate && !endDate && hasDuration) {
          me.setData('endDate', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(startDate, duration, durationUnit));
        } // need to calculate startDate
        else if (!startDate && endDate && hasDuration) {
            me.setData('startDate', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(endDate, -duration, durationUnit));
          }
    } //endregion
    //region Getters & Setters

  }, {
    key: "setDuration",

    /**
     * Sets duration and durationUnit in one go. Only allowed way to change durationUnit, the durationUnit field is
     * readonly after creation
     * @param {Number} duration Duration value
     * @param {String} durationUnit Unit for specified duration value, see {@link #field-durationUnit} for valid values
     */
    value: function setDuration(duration) {
      var durationUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.durationUnit;
      // Must be a number
      duration = parseFloat(duration);
      var toSet = {
        duration: duration,
        durationUnit: durationUnit
      };

      if (this.startDate) {
        toSet.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(this.startDate, duration, durationUnit);
      } else if (this.endDate) {
        toSet.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(this.endDate, -duration, durationUnit);
      }

      this.set(toSet);
    }
    /**
     * Property which encapsulates the duration's magnitude and units.
     */

  }, {
    key: "setStartDate",

    /**
     * Sets the range start date
     *
     * @param {Date} date The new start date
     * @param {Boolean} keepDuration Pass `true` to keep the duration of the task ("move" the event), `false` to change the duration ("resize" the event).
     * Defaults to `true`
     */
    value: function setStartDate(date) {
      var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var me = this,
          toSet = {
        startDate: date
      };

      if (date) {
        var calcEndDate;

        if (keepDuration) {
          calcEndDate = me.duration != null;
        } else {
          if (me.endDate) {
            toSet.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].diff(date, me.endDate, me.durationUnit, true);
            if (toSet.duration < 0) throw new Error('Negative duration');
          } else {
            calcEndDate = this.duration != null;
          }
        }

        if (calcEndDate) {
          toSet.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(date, me.duration, me.durationUnit);
        }
      } else {
        toSet.duration = null;
      }

      me.set(toSet);
    }
    /**
     * Sets the range end date
     *
     * @param {Date} date The new end date
     * @param {Boolean} keepDuration Pass `true` to keep the duration of the task ("move" the event), `false` to change the duration ("resize" the event).
     * Defaults to `false`
     */

  }, {
    key: "setEndDate",
    value: function setEndDate(date) {
      var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          toSet = {
        endDate: date
      };

      if (date) {
        var calcStartDate;

        if (keepDuration === true) {
          calcStartDate = me.duration != null;
        } else {
          if (me.startDate) {
            toSet.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].diff(me.startDate, date, me.durationUnit, true);
            if (toSet.duration < 0) throw new Error('Negative duration');
          } else {
            calcStartDate = this.duration != null;
          }
        }

        if (calcStartDate) {
          toSet.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(date, -me.duration, me.durationUnit);
        }
      }

      me.set(toSet);
    }
    /**
     * Sets the event start and end dates
     *
     * @param {Date} start The new start date
     * @param {Date} end The new end date
     * @param {Boolean} [silent] Pass `true` to not trigger events
     */

  }, {
    key: "setStartEndDate",
    value: function setStartEndDate(start, end, silent) {
      this.set({
        startDate: start,
        endDate: end
      }, null, silent);
    }
    /**
     * Returns an array of dates in this range. If the range starts/ends not at the beginning of day, the whole day will be included.
     * @return {Date[]}
     */

  }, {
    key: "inSetNormalize",
    value: function inSetNormalize(field) {
      if (typeof field !== 'string') {
        // If user is updating multiple properties in one go using an object, we help out
        // by filling out missing schedule related data
        var startDate = field.startDate,
            endDate = field.endDate,
            duration = field.duration,
            durationUnit = field.durationUnit; // Conversion is usually handled in inSet, but we are normalizing prior to that and have to handle it here

        if (typeof startDate === 'string') {
          startDate = this.getFieldDefinition('startDate').convert(startDate);
        }

        if (typeof endDate === 'string') {
          endDate = this.getFieldDefinition('endDate').convert(endDate);
        }

        if ('duration' in field) {
          if (startDate && !endDate) {
            endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(startDate, duration, durationUnit || this.durationUnit, true, true);
          }

          if (!startDate && endDate) {
            startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(endDate, -duration, durationUnit || this.durationUnit, true, true);
          }
        } else if (startDate && endDate) {
          duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].diff(startDate, endDate, durationUnit || this.durationUnit, true);
        }

        startDate && (field.startDate = startDate);
        endDate && (field.endDate = endDate);
        duration != null && (field.duration = duration);
        return field;
      }
    }
  }, {
    key: "inSet",
    value: function inSet(field, value, silent, fromRelationUpdate, skipAccessors) {
      if (!skipAccessors) {
        field = this.inSetNormalize(field) || field;
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(TimeSpan.prototype), "inSet", this).call(this, field, value, silent, fromRelationUpdate, skipAccessors);
    } //endregion
    //region Iteration

    /**
     * Iterates over the {@link #property-dates}
     * @param {Function} func The function to call for each date
     * @param {Object} thisObj `this` reference for the function
     */

  }, {
    key: "forEachDate",
    value: function forEachDate(func, thisObj) {
      return this.dates.forEach(func.bind(thisObj));
    } //endregion

    /**
     * Checks if the range record has both start and end dates set and start <= end
     *
     * @return {Boolean}
     */

  }, {
    key: "shift",

    /**
     * Shift the dates for the date range by the passed amount and unit
     * @param {String} unit The unit to shift by, see {@Core.helper.DateHelper} for more information on valid formats.
     * @param {Number} amount The amount to shift
     */
    value: function shift(amount) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.durationUnit;

      // TODO REMOVE FOR 2.0
      if (typeof amount === 'string') {
        var u = amount;
        amount = unit;
        unit = u;
      }

      return this.setStartDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(this.startDate, amount, unit, true), true);
    }
    /**
     * Returns the WBS code of this model (only relevant when part of a tree store, as in the Gantt chart).
     * @return {String} The WBS code (e.g '2.1.3')
     */

  }, {
    key: "fullCopy",
    value: function fullCopy() {
      //NOT PORTED
      return this.copy.apply(this, arguments);
    }
  }, {
    key: "intersects",
    value: function intersects(timeSpan) {
      return this.intersectsRange(timeSpan.startDate, timeSpan.endDate);
    }
  }, {
    key: "intersectsRange",
    value: function intersectsRange(start, end) {
      var myStart = this.startDate,
          myEnd = this.endDate;
      return myStart && myEnd && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].intersectSpans(myStart, myEnd, start, end);
    }
    /**
     * Splits this event into two pieces at the desired position.
     *
     * @param {Number} splitPoint A number greater than 0 and less than 1, indicating how this event will be split. 0.5 means cut it in half
     * @return {Scheduler.model.TimeSpan} The newly created split section of the timespan
     */

  }, {
    key: "split",
    value: function split() {
      var splitPoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
      var me = this,
          clone = me.copy(),
          eventStore = me.eventStore,
          assignmentStore = me.assignmentStore,
          ownNewDuration = me.duration * splitPoint,
          cloneDuration = me.duration - ownNewDuration;

      if (splitPoint <= 0 || splitPoint >= 1) {
        throw new Error('Split point must be > 0 and < 1');
      }

      clone.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(me.startDate, ownNewDuration, me.durationUnit);
      clone.duration = cloneDuration;
      me.duration = ownNewDuration;

      if (eventStore) {
        eventStore.add(clone);

        if (assignmentStore && !eventStore.usesSingleAssignment) {
          assignmentStore.add(me.assignments.map(function (assignment) {
            var clonedData = Object.assign({}, assignment.data, {
              eventId: clone.id,
              // From engine
              event: null,
              resource: null
            });
            delete clonedData.id;
            return clonedData;
          }));
        }
      }

      return clone;
    }
  }, {
    key: "toICSString",
    value: function toICSString() {
      var icsEventConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.isScheduled) {
        return '';
      }

      var nowAsUTC = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].toUTC(new Date()),
          startAsUTC = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].toUTC(this.startDate),
          endAsUTC = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].toUTC(this.endDate),
          fullDateFormat = 'YYYYMMDDTHHmmss',
          // To allow testing using a fixed timestamp value
      timestamp = icsEventConfig.DTSTAMP || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].format(nowAsUTC, fullDateFormat) + 'Z';
      delete icsEventConfig.DTSTAMP;
      var startEnd = {};

      if (this.allDay) {
        var dateFormat = 'YYYYMMDD';
        startEnd = {
          'DTSTART;VALUE=DATE': _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].format(startAsUTC, dateFormat),
          'DTEND;VALUE=DATE': _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].format(endAsUTC, dateFormat)
        };
      } else {
        startEnd = {
          DTSTART: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].format(startAsUTC, fullDateFormat) + 'Z',
          DTEND: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].format(endAsUTC, fullDateFormat) + 'Z'
        };
      }

      var version = _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].scheduler && _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].getVersion('scheduler') || _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].calendar && _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].getVersion('calendar') || '',
          icsWrapConfig = {
        BEGIN: 'VCALENDAR',
        VERSION: '2.0',
        CALSCALE: 'GREGORIAN',
        PRODID: "-//Bryntum AB//Bryntum Scheduler ".concat(version, " //EN"),
        END: 'VCALENDAR'
      },
          eventConfig = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        BEGIN: 'VEVENT',
        UID: this.id + '@bryntum.com',
        CLASS: 'PUBLIC',
        SUMMARY: this.name,
        DTSTAMP: timestamp
      }, startEnd), this.recurrenceRule ? {
        RRULE: this.recurrenceRule
      } : {}), icsEventConfig), {}, {
        END: 'VEVENT'
      }),
          icsItems = Object.keys(icsWrapConfig).map(function (key) {
        return "".concat(key, ":").concat(icsWrapConfig[key]);
      }),
          eventItems = Object.keys(eventConfig).map(function (key) {
        return "".concat(key, ":").concat(eventConfig[key]);
      }); // Inject event details before the closing VCALENDAR entry


      icsItems.splice.apply(icsItems, [icsItems.length - 1, 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default()(eventItems)));
      return icsItems.join('\n');
    }
    /**
     * Triggers a download of this time span in ICS format (for import in Outlook etc.)
     *
     * ```javascript
     * timeSpan.downloadAsICS({
     *      LOCATION : timeSpan.location
     *  });
     * ```
     * @param {Object} [icsEventConfig] A config object with properties to be added in to `BEGIN:VEVENT` section of the
     * exported event.
     */

  }, {
    key: "exportToICS",
    value: function exportToICS(icsEventConfig) {
      if (this.isScheduled) {
        var blob = new Blob([this.toICSString(icsEventConfig)], {
          type: 'text/calendar'
        });
        _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].downloadBlob(blob, (this.name || 'Event') + '.ics');
      }
    }
  }, {
    key: "eventStore",
    get: function get() {
      var me = this; // If we are an occurrence, return our base recurring event's store

      if (me.isOccurrence) {
        return me.recurringTimeSpan.eventStore;
      }

      if (!me._eventStore) {
        var _me$stores;

        me._eventStore = (_me$stores = me.stores) === null || _me$stores === void 0 ? void 0 : _me$stores.find(function (s) {
          return s.isEventStore;
        });
      }

      return me._eventStore;
    }
  }, {
    key: "cls",
    get: function get() {
      if (!this._cls) {
        this._cls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_26__["default"](_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(TimeSpan.prototype), "get", this).call(this, 'cls'));
      }

      return this._cls;
    },
    set: function set(cls) {
      var me = this;

      if (me._cls) {
        me._cls.value = cls;
      } else {
        me._cls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_26__["default"](cls);
      }

      me.set('cls', me._cls.value);
    }
  }, {
    key: "startDate",
    get: function get() {
      return this.get('startDate');
    },
    set: function set(date) {
      this.setStartDate(date);
    }
  }, {
    key: "endDate",
    get: function get() {
      return this.get('endDate');
    },
    set: function set(date) {
      this.setEndDate(date);
    }
  }, {
    key: "duration",
    get: function get() {
      return this.get('duration');
    },
    set: function set(duration) {
      this.setDuration(duration, this.durationUnit);
    }
  }, {
    key: "durationUnit",
    get: function get() {
      return this.get('durationUnit');
    }
  }, {
    key: "fullDuration",
    get: function get() {
      // Used for formatting during export
      return new _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_30__["default"]({
        unit: this.durationUnit,
        magnitude: this.duration
      });
    },
    set: function set(duration) {
      if (typeof duration === 'string') {
        duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].parseDuration(duration, true, this.durationUnit);
      }

      this.setDuration(duration.magnitude, duration.unit);
    }
  }, {
    key: "dates",
    get: function get() {
      var dates = [],
          startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].startOf(this.startDate, 'day'),
          endDate = this.endDate;

      for (var date = startDate; date < endDate; date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].add(date, 1, 'day')) {
        dates.push(date);
      }

      return dates;
    }
  }, {
    key: "startDateMS",
    get: function get() {
      var _this$startDate;

      return (_this$startDate = this.startDate) === null || _this$startDate === void 0 ? void 0 : _this$startDate.getTime();
    }
  }, {
    key: "endDateMS",
    get: function get() {
      var _this$endDate;

      return (_this$endDate = this.endDate) === null || _this$endDate === void 0 ? void 0 : _this$endDate.getTime();
    }
    /**
     * Returns the duration of this Event in milliseconds.
     * @private
     */

  }, {
    key: "durationMS",
    get: function get() {
      var me = this;

      if (me.endDate && me.startDate) {
        return me.endDateMS - me.startDateMS;
      } else {
        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].asMilliseconds(me.duration || 0, me.durationUnit);
      }
    }
  }, {
    key: "isMilestone",
    get: function get() {
      return this.durationMS === 0;
    }
  }, {
    key: "isScheduled",
    get: function get() {
      var me = this;
      return Boolean(me.startDate && me.endDate && me.hasValidDates);
    } // Simple check if end date is greater than start date

  }, {
    key: "isValid",
    get: function get() {
      var result = true; //super.isValid(),

      if (result) {
        var startDate = this.startDate,
            endDate = this.endDate;
        result = !startDate || !endDate || endDate - startDate >= 0;
      }

      return result;
    } // Simple check if just end date is greater than start date

  }, {
    key: "hasValidDates",
    get: function get() {
      var startDateMS = this.startDateMS,
          endDateMS = this.endDateMS;
      return !startDateMS || !endDateMS || endDateMS - startDateMS >= 0;
    }
  }, {
    key: "wbsCode",
    get: function get() {
      return this._wbsCode || this.indexPath.join('.');
    },
    set: function set(value) {
      // wbsCode needs to be writable to interop w/TaskModel and Baselines which copy this field value
      this._wbsCode = value;
    }
  }], [{
    key: "fields",
    //region Field definitions
    get: function get() {
      return [
      /**
       * The start date of a time span (or Event / Task).
       *
       * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
       * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
       * change the dateFormat for this field.
       *
       * @field {String|Date} startDate
       * @category Scheduling
       */
      {
        name: 'startDate',
        type: 'date'
      },
      /**
       * The end date of a time span (or Event / Task).
       *
       * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
       * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
       * change the dateFormat for this field.
       *
       * @field {String|Date} endDate
       * @category Scheduling
       */
      {
        name: 'endDate',
        type: 'date'
      },
      /**
       * The numeric part of the timespan's duration (the number of units).
       * @field {Number} duration
       * @category Scheduling
       */
      {
        name: 'duration',
        type: 'number',
        allowNull: true
      },
      /**
       * The unit part of the TimeSpan duration, defaults to "d" (days). Valid values are:
       *
       * - "ms" (milliseconds)
       * - "s" (seconds)
       * - "m" (minutes)
       * - "h" (hours)
       * - "d" (days)
       * - "w" (weeks)
       * - "M" (months)
       * - "y" (years)
       *
       * This field is readonly after creation, to change durationUnit use #setDuration().
       * @field {String} durationUnit
       * @category Scheduling
       */
      {
        name: 'durationUnit',
        type: 'string',
        defaultValue: 'd'
      }, {
        name: 'fullDuration',
        persist: false
      },
      /**
       * An encapsulation of the CSS classes to add to the rendered time span element.
       * @field {Core.helper.util.DomClassList|String} cls
       *
       * This may be accessed as a string, but for granular control of adding and
       * removing individual classes, it is recommended to use the
       * {@link Core.helper.util.DomClassList DomClassList} API.
       * @category Styling
       */
      {
        name: 'cls',
        defaultValue: ''
      },
      /**
       * CSS class specifying an icon to apply to the rendered time span element.
       * @field {String} iconCls
       * @category Styling
       */
      'iconCls',
      /**
       * A CSS style string (applied to `style.cssText`) or object (applied to `style`)
       * ```
       * record.style = 'color: red;font-weight: 800';
       * ```
       *
       * @field {String} style
       * @category Styling
       */
      {
        name: 'style',
        type: 'object'
      },
      /**
       * The name of the time span (or Event / Task)
       * @field {String} name
       * @category Common
       */
      {
        name: 'name',
        type: 'string',
        defaultValue: ''
      }];
    }
  }]);

  return TimeSpan;
}(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_25__["default"]);


TimeSpan._$name = 'TimeSpan';

/***/ }),

/***/ "./lib/Scheduler/model/mixin/AssignmentModelMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/AssignmentModelMixin.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Scheduler/model/mixin/AssignmentModelMixin
*/

/**
 * Mixin that holds configuration shared between assignments in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AssignmentModelMixin, _Target);

    var _super = _createSuper(AssignmentModelMixin);

    function AssignmentModelMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, AssignmentModelMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(AssignmentModelMixin, [{
      key: "construct",
      //endregion
      value: function construct(data) {
        var _get2;

        data = data || {}; // Engine expects event and resource, not eventId and resourceId. We need to support both

        if (data.eventId != null) {
          data.event = data.eventId;
        }

        if (data.resourceId != null) {
          data.resource = data.resourceId;
        }

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(AssignmentModelMixin.prototype), "construct", this)).call.apply(_get2, [this, data].concat(args));
      } //region Event & resource

      /**
       * A key made up from the event id and the id of the resource assigned to.
       * @property eventResourceKey
       * @readonly
       * @internal
       */

    }, {
      key: "set",
      value: function set(field, value) {
        var _get3;

        var toSet = this.fieldToKeys(field, value); // Resource was set, store its id as resourceId and announce it

        if ('resource' in toSet) {
          var _toSet$resource;

          toSet.resourceId = (_toSet$resource = toSet.resource) === null || _toSet$resource === void 0 ? void 0 : _toSet$resource.id;
        } // Same for event


        if ('event' in toSet) {
          var _toSet$event;

          toSet.eventId = (_toSet$event = toSet.event) === null || _toSet$event === void 0 ? void 0 : _toSet$event.id;
        }

        for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        (_get3 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(AssignmentModelMixin.prototype), "set", this)).call.apply(_get3, [this, toSet, null].concat(args));
      } // Settings resourceId relays to `resource`. Underlying data will be updated in `afterChange()` above

    }, {
      key: "getResource",
      // TODO : Deprecate in favor of `get resource`

      /**
       * Returns the resource associated with this assignment.
       *
       * @return {Scheduler.model.ResourceModel} Instance of resource
       */
      value: function getResource() {
        return this.resource;
      } //endregion
      // Convenience getter to not have to check `instanceof AssignmentModel`

    }, {
      key: "toString",
      value: function toString() {
        if (this.resourceName) {
          return "".concat(this.resourceName, " ").concat(this.units, "%");
        }

        return '';
      }
    }, {
      key: "eventResourceKey",
      get: function get() {
        var me = this;
        return "".concat(me.event ? me.eventId : me.getData('eventId') || me.internalId, "-").concat(me.resource ? me.resourceId : me.getData('resourceId') || me.internalId);
      }
    }, {
      key: "resourceId",
      set: function set(value) {
        var resource = this.resource; // When assigning a new id to a resource, it will update the resourceId of the assignment. But the assignments
        // resource is still the same so we need to announce here

        if ((resource === null || resource === void 0 ? void 0 : resource.isModel) && resource.id === value) {
          this.set('resourceId', value);
        } else {
          this.resource = value;
        }
      },
      get: function get() {
        var _this$resource;

        // If assigned using `resource` and not `resourceId` there will be no resourceId
        return this.get('resourceId') || ((_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.id);
      } // Same for event as for resourceId

    }, {
      key: "eventId",
      set: function set(value) {
        var event = this.event; // When assigning a new id to an event, it will update the eventId of the assignment. But the assignments
        // event is still the same so we need to announce here

        if ((event === null || event === void 0 ? void 0 : event.isModel) && event.id === value) {
          this.set('eventId', value);
        } else {
          this.event = value;
        }
      },
      get: function get() {
        var _this$event;

        // If assigned using `event` and not `eventId` there will be no eventId
        return this.get('eventId') || ((_this$event = this.event) === null || _this$event === void 0 ? void 0 : _this$event.id);
      }
      /**
       * Convenience property to get the name of the associated event.
       * @property {String}
       * @readonly
       */

    }, {
      key: "eventName",
      get: function get() {
        var _this$event2;

        return (_this$event2 = this.event) === null || _this$event2 === void 0 ? void 0 : _this$event2.name;
      }
      /**
       * Convenience property to get the name of the associated resource.
       * @property {String}
       * @readonly
       */

    }, {
      key: "resourceName",
      get: function get() {
        var _this$resource2;

        return (_this$resource2 = this.resource) === null || _this$resource2 === void 0 ? void 0 : _this$resource2.name;
      }
    }, {
      key: "isAssignment",
      get: function get() {
        return true;
      }
      /**
       * Returns true if the Assignment can be persisted (e.g. task and resource are not 'phantoms')
       *
       * @return {Boolean} true if this model can be persisted to server.
       */

    }, {
      key: "isPersistable",
      get: function get() {
        var event = this.event,
            resource = this.resource,
            unjoinedStores = this.unjoinedStores,
            assignmentStore = this.assignmentStore,
            crudManager = assignmentStore === null || assignmentStore === void 0 ? void 0 : assignmentStore.crudManager;
        var result;

        if (assignmentStore) {
          // if crud manager is used it can deal with phantom event/resource since it persists all records in one batch
          // if no crud manager used we have to wait till event/resource are persisted
          result = this.isValid && (crudManager || !event.hasGeneratedId && !resource.hasGeneratedId);
        } // if we remove the record
        else {
            result = Boolean(unjoinedStores[0]);
          }

        return result;
      }
    }, {
      key: "isValid",
      get: function get() {
        return this.resource != null && this.event != null;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'AssignmentModelMixin';
      }
      /**
       * Set value for the specified field(s), triggering engine calculations immediately. See
       * {@link Core.data.Model#function-set Model#set()} for arguments.
       *
       * ```javascript
       * assignment.set('resourceId', 2);
       * // assignment.resource is not yet resolved
       *
       * await assignment.setAsync('resourceId', 2);
       * // assignment.resource is resolved
       * ```
       *
       * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
       * @param {*} value Value to set
       * @param {Boolean} [silent=false] Set to true to not trigger events
       * automatically.
       * @function setAsync
       * @category Editing
       * @async
       */
      //region Fields

    }, {
      key: "fields",
      get: function get() {
        return [
        /**
         * Id for the resource to assign to
         * @field {String|Number} resourceId
         * @category Common
         */
        'resourceId',
        /**
         * Id for the event to assign
         * @field {String|Number} eventId
         * @category Common
         */
        'eventId',
        /**
         * Specify `false` to opt out of drawing dependencies from/to this assignment
         * @field {Boolean} drawDependencies
         * @category Common
         */
        {
          name: 'drawDependencies',
          type: 'boolean'
        },
        /**
         * Id for event to assign. Can be used as an alternative to `eventId`, but please note that after
         * load it will be populated with the actual event and not its id. This field is not persistable.
         * @field {String|Number} event
         * @category Common
         */
        'event',
        /**
         * Id for resource to assign to. Can be used as an alternative to `resourceId`, but please note that after
         * load it will be populated with the actual resource and not its id. This field is not persistable.
         * @field {String|Number} resource
         * @category Common
         */
        'resource'];
      }
    }]);

    return AssignmentModelMixin;
  }(Target);
});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/EventModelMixin.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/model/mixin/EventModelMixin.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");


























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_23___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/model/mixin/EventModelMixin
 */

var oneDayMS = 1000 * 60 * 60 * 24;
/**
 * Mixin that holds configuration shared between events in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22___default()(EventModelMixin, _Target);

    var _super = _createSuper(EventModelMixin);

    function EventModelMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, EventModelMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(EventModelMixin, [{
      key: "forEachResource",

      /**
       * Iterate over all associated resources
       * @private
       */
      value: function forEachResource(fn) {
        var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;

        var _iterator = _createForOfIteratorHelper(this.resources),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var resource = _step.value;
            if (fn.call(thisObj, resource) === false) return;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      /**
       * Returns either the resource associated with this event (when called w/o `resourceId`) or resource
       * with specified id.
       *
       * @param {String} [resourceId] To retrieve a specific resource
       * @return {Scheduler.model.ResourceModel}
       */

    }, {
      key: "getResource",
      value: function getResource(resourceId) {
        if (resourceId == null) {
          return this.resource;
        }

        return this.resourceStore ? this.resourceStore.getById(resourceId) : null;
      } //endregion
      //region Dates

    }, {
      key: "applyResourceId",
      value: function applyResourceId(resourceId) {
        var fromApplyValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var me = this,
            assignments = me.assignments,
            assignmentStore = me.assignmentStore,
            eventStore = me.eventStore; // When part of an EventStore, resourceIds are changed to be AssignmentModels

        if (eventStore) {
          if (resourceId != null) {
            if (!me.skipEnforcingSingleAssignment) {
              eventStore.usesSingleAssignment = true;
            } // Reassign if already assigned, only single assignment allowed


            if ((assignments === null || assignments === void 0 ? void 0 : assignments.length) && resourceId !== assignments[0].resourceId) {
              //assignments[0].set('resourceId', resourceId, Boolean(me.eventStore.eventsSuspended));
              // Silent reassign if events are suspended on event store, wont be expecting UI update then
              var eventsSuspended = Boolean(eventStore.eventsSuspended);
              eventsSuspended && assignmentStore.suspendEvents();
              assignments[0].resource = resourceId;
              eventsSuspended && assignmentStore.resumeEvents();
            } // Otherwise assign
            else {
                assignmentStore.assignEventToResource(me, resourceId);
              }
          } else {
            // Setting resourceId to null removes all assignments
            assignmentStore.remove(me.assignments);
          }
        } // Not part of an EventStore, edge case. Set to data unless we are in such operation already
        else if (!fromApplyValue) {
            me.set({
              resourceId: resourceId
            });
          }
      } // Special handling of setting resourceId, creates assignment

    }, {
      key: "applyValue",
      value: function applyValue(useProp, mapping, value, skipAccessors, field) {
        if (field && field.name === 'resourceId' && !this.meta.isAssigning) {
          var eventStore = this.eventStore;
          eventStore && (eventStore.isAssigning = true);
          this.applyResourceId(value, true);
          eventStore && (eventStore.isAssigning = false);
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(EventModelMixin.prototype), "applyValue", this).call(this, useProp, mapping, value, skipAccessors, field);
      } //endregion
      //region Assignment

      /**
       * Returns all assignments for the event. Event must be part of the store for this method to work.
       * @property {Scheduler.model.AssignmentModel[]}
       * @readonly
       */

    }, {
      key: "assign",

      /**
       * Assigns this event to the specified resource.
       *
       * *Note:* The event must be part of an EventStore for this to work. If the EventStore uses single assignment
       * (loaded using resourceId) existing assignments will always be removed.
       *
       * @param {Scheduler.model.ResourceModel|String|Number} resource A new resource for this event, either as a full
       *        Resource record or an id (or an array of such).
       * @param {Boolean} [removeExistingAssignments] `true` to first remove existing assignments
       */
      value: function assign(resource) {
        var removeExistingAssignments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var eventStore = this.eventStore;

        if (eventStore && !eventStore.usesSingleAssignment) {
          eventStore.assignEventToResource(this, resource, removeExistingAssignments);
        } else {
          // Remember what resource to assign,  directly in single assignment mode or for later when we are joined to
          // an EventStore
          this.resourceId = this.constructor.asId(resource);

          if (!eventStore) {
            // Prevent flagging EventStore as using single assignment when that happens, we cannot know that here
            this.meta.skipEnforcingSingleAssignment = true;
          }
        }
      }
      /**
       * Unassigns this event from the specified resource
       *
       * @param {Scheduler.model.ResourceModel|String|Number} [resource] The resource to unassign from.
       */

    }, {
      key: "unassign",
      value: function unassign(resource) {
        var _me$eventStore;

        var removingResource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var me = this;
        resource = me.constructor.asId(resource); // If unassigned is caused by removing the resource the UI should be able to find out to not do extra redraws etc.

        me.meta.removingResource = removingResource;
        (_me$eventStore = me.eventStore) === null || _me$eventStore === void 0 ? void 0 : _me$eventStore.unassignEventFromResource(me, resource);
        me.meta.removingResource = null;
      }
      /**
       * Reassigns an event from an old resource to a new resource
       *
       * @param {Scheduler.model.ResourceModel|String|Number} oldResourceId A resource to unassign from or its id
       * @param {Scheduler.model.ResourceModel|String|Number} newResourceId A resource to assign to or its id
       */

    }, {
      key: "reassign",
      value: function reassign(oldResourceId, newResourceId) {
        this.eventStore && this.eventStore.reassignEventFromResourceToResource(this, oldResourceId, newResourceId);
      }
      /**
       * Returns true if this event is assigned to a certain resource.
       *
       * @param {Scheduler.model.ResourceModel|String|Number} resource The resource to query for
       * @return {Boolean}
       */

    }, {
      key: "isAssignedTo",
      value: function isAssignedTo(resource) {
        var resourceId = this.constructor.asId(resource);
        return this.assignments.some(function (assignment) {
          return assignment.resourceId === resourceId;
        });
      } //endregion
      //region Dependencies

      /**
       * Returns all predecessor events of this event
       *
       * @return {SchedulerPro.model.EventModel[]}
       */

    }, {
      key: "normalize",
      //endregion
      value: function normalize() {// Normalization handled by SchedulingEngine
      }
    }, {
      key: "inSetNormalize",
      value: function inSetNormalize() {// Normalization handled by SchedulingEngine
      }
      /**
       * The "main" event this model is an occurrence of.
       * Returns `null` for non-occurrences.
       * @property {Scheduler.model.EventModel}
       * @alias #property-recurringTimeSpan
       * @readonly
       */

    }, {
      key: "resources",
      //endregion
      //region Resources

      /**
       * Returns all resources assigned to an event.
       *
       * @return {Scheduler.model.ResourceModel[]}
       * @readonly
       */
      get: function get() {
        // Only include valid resources, to not have nulls in the result
        return this.assignments.reduce(function (resources, assignment) {
          assignment.resource && resources.push(assignment.resource);
          return resources;
        }, []);
      },
      set: function set(resources) {
        if (!Array.isArray(resources)) {
          resources = [resources];
        }

        var me = this,
            newResourceIds = resources.map(me.constructor.asId),
            existingResourceIds = me.assignments.map(function (a) {
          return a.resource.id;
        }),
            _ArrayHelper$delta = _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].delta(newResourceIds, existingResourceIds),
            toAdd = _ArrayHelper$delta.onlyInA,
            toRemove = _ArrayHelper$delta.onlyInB; // Add first, remove after. Otherwise event might get removed with its last assignment


        me.assignmentStore.add(toAdd.map(function (resourceId) {
          return {
            resource: resourceId,
            event: me
          };
        }));
        me.assignmentStore.remove(toRemove.map(function (resourceId) {
          return me.assignments.find(function (a) {
            return a.resource.id === resourceId;
          });
        }));
      }
    }, {
      key: "startDate",
      get: function get() {
        var dt = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(EventModelMixin.prototype), "startDate", this);

        if (this.isOccurrence) {
          dt = this.get('startDate');
        }

        if (this.allDay) {
          dt = this.constructor.getAllDayStartDate(dt);
        }

        return dt;
      },
      set: function set(startDate) {
        if (this.batching) {
          this.set({
            startDate: startDate
          });
        } else {
          _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(EventModelMixin.prototype), "startDate", startDate, this, true);
        }
      }
    }, {
      key: "endDate",
      get: function get() {
        var dt = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(EventModelMixin.prototype), "endDate", this);

        if (this.isOccurrence) {
          dt = this.get('endDate');
        }

        if (this.allDay) {
          dt = this.constructor.getAllDayEndDate(dt);
        }

        return dt;
      },
      set: function set(endDate) {
        if (this.batching) {
          this.set({
            endDate: endDate
          });
        } else {
          _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(EventModelMixin.prototype), "endDate", endDate, this, true);
        }
      }
      /**
       * Shift the dates for the date range by the passed amount and unit
       * @param {String} unit The unit to shift by, see {@link Core.helper.DateHelper} for more information on valid formats.
       * @param {Number} amount The amount to shift
       * @returns {Promise} A promise which is resolved when shift calculations are done
       * @async
       * @method shift
       */
      //endregion
      //region Is
      // Used internally to differentiate between Event and ResourceTimeRange

    }, {
      key: "isEvent",
      get: function get() {
        return true;
      }
      /**
       * Returns true if event can be drag and dropped
       * @return {Boolean} The draggable state for the event.
       * @readonly
       */

    }, {
      key: "isDraggable",
      get: function get() {
        return this.draggable;
      }
      /**
       * Returns true if event can be resized, but can additionally return 'start' or 'end' indicating how this event can be resized.
       * @return {Boolean|String} true, false, 'start' or 'end'
       * @readonly
       */

    }, {
      key: "isResizable",
      get: function get() {
        return !this.isMilestone && this.resizable;
      }
      /**
       * Returns false if the event is not persistable. By default it always is, please override this getter if you need
       * custom logic.
       *
       * @return {Boolean} true if persistable (which is the default)
       * @readonly
       */

    }, {
      key: "isPersistable",
      get: function get() {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(EventModelMixin.prototype), "isPersistable", this);
      } //endregion
      //region Single assignment compatibility

    }, {
      key: "usesSingleAssignment",
      get: function get() {
        return !this.eventStore || this.eventStore.usesSingleAssignment;
      }
      /**
       * Override persistable getter to prevent sending resourceId when using multiple resource assignment mode
       * https://github.com/bryntum/support/issues/1345
       * @private
       */

    }, {
      key: "persistableData",
      get: function get() {
        var data = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_24___default()(EventModelMixin.prototype), "persistableData", this);

        if (!this.usesSingleAssignment) {
          delete data.resourceId;
        }

        return data;
      }
      /**
       * Returns the first assigned resource, or assigns a resource
       * @member {Scheduler.model.ResourceModel} resource
       */

    }, {
      key: "resource",
      get: function get() {
        var resources = this.resources;
        return resources.length ? resources[0] : null;
      },
      set: function set(resourceRecord) {
        // Use the resourceId setter for single assignment
        this.resourceId = this.constructor.asId(resourceRecord);
      }
    }, {
      key: "resourceId",
      get: function get() {
        var _this$resource;

        return this.usesSingleAssignment ? this.get('resourceId') : (_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.id;
      },
      set: function set(resourceId) {
        this.applyResourceId(resourceId);
      }
    }, {
      key: "assignments",
      get: function get() {
        return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default()(this.assigned || []);
      }
    }, {
      key: "predecessors",
      get: function get() {
        return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default()(this.incomingDeps);
      }
      /**
       * Returns all successor events of this event
       *
       * @return {SchedulerPro.model.EventModel[]}
       */

    }, {
      key: "successors",
      get: function get() {
        return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default()(this.outgoingDeps);
      }
    }, {
      key: "dependencies",
      get: function get() {
        return [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default()(this.incomingDeps), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_17___default()(this.outgoingDeps));
      }
    }, {
      key: "recurringEvent",
      get: function get() {
        return this.recurringTimeSpan;
      }
      /**
       * Flag which indicates that this event is an inter day event. This means that it spans
       * an entire day or multiple days.
       *
       * This is essentially used by the Calendar package to determine if an event should
       * go into the all day zone of a DayView.
       *
       * @return {Boolean} `true` if the event spans from one date to another.
       * @readonly
       */

    }, {
      key: "isInterDay",
      get: function get() {
        var durationMS = this.durationMS; // A full day (86400000 or more) marks as it as interDay,
        // which means it belongs in the all day row of a Calendar DayView

        if (durationMS >= oneDayMS) {
          return true;
        } // Working out whether it crosses midnight is a little more difficult


        var endDate = this.endDate,
            startDate = this.startDate,
            eventStartMidnight = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].clearTime(startDate);
        eventStartMidnight.setDate(eventStartMidnight.getDate() + 1); // If the endDate is past midnight, it's interDay and goes in the all day row of a Calendar DayView

        return (endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].add(startDate, durationMS)) > eventStartMidnight;
      } //region All day statics

    }], [{
      key: "getAllDayStartDate",
      value: function getAllDayStartDate(dt) {
        if (dt && dt.isEvent) {
          dt = dt.get('startDate');
        }

        if (dt) {
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].clearTime(dt, true);
        }

        return dt;
      }
    }, {
      key: "getAllDayEndDate",
      value: function getAllDayEndDate(dt) {
        if (dt && dt.isEvent) {
          dt = dt.get('endDate');
        }

        if (dt && (dt.getHours() > 0 || dt.getMinutes() > 0 || dt.getSeconds() > 0 || dt.getMilliseconds() > 0)) {
          dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].getNext(dt, 'd', 1);
        }

        return dt;
      }
    }, {
      key: "getAllDayDisplayStartDate",
      value: function getAllDayDisplayStartDate(dt) {
        if (dt && dt.isEvent) {
          dt = dt.get('startDate');
        }

        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].clearTime(dt, true);
      }
    }, {
      key: "getAllDayDisplayEndDate",
      value: function getAllDayDisplayEndDate(startDate, endDate) {
        if (startDate && startDate.isEvent) {
          endDate = startDate.get('endDate');
          startDate = startDate.get('startDate');
        }

        if (endDate) {
          startDate = this.constructor.getAllDayDisplayStartDate(startDate); // If date falls on start of the day - subtract one day to show end date correctly
          // e.g. event starts on 2017-01-01 00:00 and ends on 2017-01-02 00:00, editor should show
          // 2017-01-01 for both start and end

          if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].clearTime(endDate, true).valueOf() === endDate.valueOf()) {
            endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].add(endDate, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].DAY, -1);
          } else if (startDate.valueOf() !== endDate.valueOf()) {
            endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].clearTime(endDate, true);
          }
        }

        return endDate;
      } //endregion

    }, {
      key: "$name",
      get: function get() {
        return 'EventModelMixin';
      } // Flag checked by EventStore to make sure it uses a valid subclass

    }, {
      key: "isEventModel",
      get: function get() {
        return true;
      }
      /**
       * Set value for the specified field(s), triggering engine calculations immediately. See
       * {@link Core.data.Model#function-set Model#set()} for arguments.
       *
       * ```javascript
       * eventRecord.set('duration', 4);
       * // eventRecord.endDate is not yet calculated
       *
       * await eventRecord.setAsync('duration', 4);
       * // eventRecord.endDate is calculated
       * ```
       *
       * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
       * @param {*} value Value to set
       * @param {Boolean} [silent=false] Set to true to not trigger events. If event is recurring, occurrences won't be updated
       * automatically.
       * @function setAsync
       * @category Editing
       * @async
       */
      //region Fields

    }, {
      key: "fields",
      get: function get() {
        return [
        /**
         * The unique identifier of a task (mandatory)
         * @field {String|Number} id
         * @category Common
         */

        /**
         * Id of the resource this event is associated with (only usable for single assignments). We recommend
         * using assignments in an AssignmentStore over this approach. Internally any Event using `resourceId`
         * will have an assignment in AssignmentStore generated.
         * @field {String|Number} resourceId
         * @category Common
         */
        'resourceId',
        /**
         * Specify false to prevent the event from being dragged (if EventDrag feature is used)
         * @field {Boolean} draggable
         * @default true
         * @category Interaction
         */
        {
          name: 'draggable',
          type: 'boolean',
          persist: false,
          defaultValue: true
        }, // true or false

        /**
         * Specify false to prevent the event from being resized (if EventResize feature is used). You can also
         * specify 'start' or 'end' to only allow resizing in one direction
         * @field {boolean|String} resizable
         * @default true
         * @category Interaction
         */
        {
          name: 'resizable',
          persist: false,
          defaultValue: true
        }, // true, false, 'start' or 'end'

        /**
         * A field marking event as all day(s) spanning event.
         * For example, a holiday day may be represented by a `startDate`, and the `allDay` flag.
         * @field {Boolean} allDay
         * @category Scheduling
         */
        {
          name: 'allDay',
          defaultValue: false
        },
        /**
         * Controls this events appearance, see Schedulers
         * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle eventStyle config} for
         * available options.
         * @field {String} eventStyle
         * @category Styling
         */
        'eventStyle',
        /**
         * Controls the primary color of the event, see Schedulers
         * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor eventColor config} for
         * available colors.
         * @field {String} eventColor
         * @category Styling
         */
        'eventColor',
        /**
         * Width (in px) to use for this milestone when using Scheduler#milestoneLayoutMode 'data'.
         * @field {Number} milestoneWidth
         * @category Styling
         */
        'milestoneWidth'];
      }
    }]);

    return EventModelMixin;
  }(Target);
});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/ProjectModelMixin.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/ProjectModelMixin.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_url_to_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/web.url.to-json */ "./node_modules/core-js/modules/web.url.to-json.js");
/* harmony import */ var core_js_modules_web_url_to_json__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_to_json__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _EventModel_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../EventModel.js */ "./lib/Scheduler/model/EventModel.js");
/* harmony import */ var _DependencyModel_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony import */ var _ResourceModel_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../ResourceModel.js */ "./lib/Scheduler/model/ResourceModel.js");
/* harmony import */ var _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony import */ var _ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _data_EventStore_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../data/EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony import */ var _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../data/DependencyStore.js */ "./lib/Scheduler/data/DependencyStore.js");
/* harmony import */ var _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../data/ResourceStore.js */ "./lib/Scheduler/data/ResourceStore.js");
/* harmony import */ var _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../data/AssignmentStore.js */ "./lib/Scheduler/data/AssignmentStore.js");
/* harmony import */ var _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../data/ResourceTimeRangeStore.js */ "./lib/Scheduler/data/ResourceTimeRangeStore.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';














/**
 * @module Scheduler/model/mixin/ProjectModelMixin
 */

/**
 * Mixin that holds configuration shared between projects in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ProjectModelMixin, _ref);

    var _super = _createSuper(ProjectModelMixin);

    function ProjectModelMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ProjectModelMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ProjectModelMixin, [{
      key: "construct",
      //endregion
      //region Properties

      /**
       * State tracking manager instance the project relies on
       * @member {Core.data.stm.StateTrackingManager} stm
       */

      /**
       * The {@link Scheduler.data.EventStore store} holding the events information.
       *
       * See also {@link Scheduler.model.EventModel}
       *
       * @member {Scheduler.data.EventStore} eventStore
       * @category Models & Stores
       */

      /**
       * The {@link Scheduler.data.DependencyStore store} holding the dependencies information.
       *
       * See also {@link Scheduler.model.DependencyModel}
       *
       * @member {Scheduler.data.DependencyStore} dependencyStore
       * @category Models & Stores
       */

      /**
       * The {@link Scheduler.data.ResourceStore store} holding the resources that can be assigned to the events
       * in the event store.
       *
       * See also {@link Scheduler.model.ResourceModel}
       *
       * @member {Scheduler.data.ResourceStore} resourceStore
       * @category Models & Stores
       */

      /**
       * The {@link Scheduler.data.AssignmentStore store} holding the assignments information.
       *
       * See also {@link Scheduler.model.AssignmentModel}
       *
       * @member {Scheduler.data.AssignmentStore} assignmentStore
       * @category Models & Stores
       */

      /**
       * The {@link Core.data.Store store} holding the time ranges information.
       *
       * See also {@link Scheduler.model.TimeSpan}
       *
       * @member {Core.data.Store} timeRangeStore
       * @category Models & Stores
       */

      /**
       * The {@link Scheduler.data.ResourceTimeRangeStore store} holding the resource time ranges information.
       *
       * See also {@link Scheduler.model.ResourceTimeRangeModel}
       *
       * @member {Scheduler.data.ResourceTimeRangeStore} resourceTimeRangeStore
       * @category Models & Stores
       */
      //endregion
      //region Functions

      /**
       * Accepts a "data package" consisting of data for the projects stores, which is then loaded into the stores.
       *
       * The package can hold data for EventStore, AssignmentStore, ResourceStore and DependencyStore. It uses the same
       * format as when creating a project with inline data:
       *
       * ```javascript
       * await project.loadInlineData({
       *     eventsData       : [...],
       *     resourcesData    : [...],
       *     assignmentsData  : [...],
       *     dependenciesData : [...]
       * });
       * ```
       *
       * After populating the stores it commits the project, starting its calculations. By awaiting `loadInlineData()` you
       * can be sure that project calculations are finished.
       *
       * @function loadInlineData
       * @param {Object} dataPackage A data package as described above
       * @fires load
       * @async
       */

      /**
       * Project changes (CRUD operations to records in its stores) are automatically committed on a buffer to the
       * underlying graph based calculation engine. The engine performs it calculations async.
       *
       * By calling this function, the commit happens right away. And by awaiting it you are sure that project
       * calculations are finished and that references between records are up to date.
       *
       * ```javascript
       * // Move an event in time
       * eventStore.first.shift(1);
       * // Trigger calculations directly and wait for them to finish
       * await project.commitAsync();
       * ```
       *
       * @function commitAsync
       * @async
       */
      //endregion
      //region Init
      value: function construct() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ProjectModelMixin.prototype), "construct", this).apply(this, arguments); // These stores are not handled by engine, but still held on project


        var me = this;

        if (!me.timeRangeStore) {
          me.timeRangeStore = new me.timeRangeStoreClass({
            modelClass: me.timeRangeModelClass,
            storeId: 'timeRanges'
          });
        }

        if (!me.resourceTimeRangeStore) {
          me.resourceTimeRangeStore = new me.resourceTimeRangeStoreClass({
            modelClass: me.resourceTimeRangeModelClass
          });
        }

        if (me.resourceTimeRangesData) {
          me.resourceTimeRangeStore.data = me.resourceTimeRangesData;
        }

        if (me.timeRangesData) {
          me.timeRangeStore.data = me.timeRangesData;
        }
      } //endregion
      //region JSON

      /**
       * Returns the data from the records of the projects stores, in a format that can be consumed by `loadInlineData()`.
       *
       * Used by JSON.stringify to correctly convert this record to json.
       *
       *
       * ```javascript
       * const project = new ProjectModel({
       *     eventsData       : [...],
       *     resourcesData    : [...],
       *     assignmentsData  : [...],
       *     dependenciesData : [...]
       * });
       *
       * const json = project.toJSON();
       *
       * // json:
       * {
       *     eventsData : [...],
       *     resourcesData : [...],
       *     dependenciesData : [...],
       *     assignmentsData : [...]
       * }
       * ```
       *
       * Output can be consumed by `loadInlineData()`:
       *
       * ```javascript
       * const json = project.toJSON();
       *
       * // Plug it back in later
       * project.loadInlineData(json);
       * ```
       *
       * @returns {Object}
       * @category JSON
       */

    }, {
      key: "toJSON",
      value: function toJSON() {
        var me = this,
            result = {
          eventsData: me.eventStore.toJSON(),
          resourcesData: me.resourceStore.toJSON(),
          dependenciesData: me.dependencyStore.toJSON()
        };

        if (!me.eventStore.usesSingleAssignment) {
          result.assignmentsData = me.assignmentStore.toJSON();
        }

        return result;
      }
      /**
       * Get or set project data (records from its stores) as a JSON string.
       *
       * Get a JSON string:
       *
       * ```javascript
       * const project = new ProjectModel({
       *     eventsData       : [...],
       *     resourcesData    : [...],
       *     assignmentsData  : [...],
       *     dependenciesData : [...]
       * });
       *
       * const jsonString = project.json;
       *
       * // jsonString:
       * '{"eventsData":[...],"resourcesData":[...],...}'
       * ```
       *
       * Set a JSON string (to populate the project stores):
       *
       * ```javascript
       * project.json = '{"eventsData":[...],"resourcesData":[...],...}'
       * ```
       *
       * @property {String}
       */

    }, {
      key: "afterChange",
      //endregion
      value: function afterChange(toSet, wasSet) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ProjectModelMixin.prototype), "afterChange", this).apply(this, arguments);

        if (wasSet.calendar) {
          this.trigger('calendarChange');
        }
      }
    }, {
      key: "json",
      get: function get() {
        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(ProjectModelMixin.prototype), "json", this);
      },
      set: function set(json) {
        if (typeof json === 'string') {
          json = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].safeJsonParse(json);
        }

        this.loadInlineData(json);
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'ProjectModelMixin';
      } //region Config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Configuration options to provide to the STM manager
           *
           * @config {Object|Core.data.stm.StateTrackingManager}
           * @category Advanced
           */
          stm: {},

          /**
           * The constructor of the event model class, to be used in the project. Will be set as the
           * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-eventStore}
           *
           * @config {Scheduler.model.EventModel}
           * @category Models & Stores
           */
          eventModelClass: _EventModel_js__WEBPACK_IMPORTED_MODULE_11__["default"],

          /**
           * The constructor of the dependency model class, to be used in the project. Will be set as the
           * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-dependencyStore}
           *
           * @config {Scheduler.model.DependencyModel}
           * @category Models & Stores
           */
          dependencyModelClass: _DependencyModel_js__WEBPACK_IMPORTED_MODULE_12__["default"],
          timeRangeModelClass: _TimeSpan_js__WEBPACK_IMPORTED_MODULE_16__["default"],
          resourceTimeRangeModelClass: _ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_15__["default"],

          /**
           * The constructor of the resource model class, to be used in the project. Will be set as the
           * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-resourceStore}
           *
           * @config {Scheduler.model.ResourceModel}
           * @category Models & Stores
           */
          resourceModelClass: _ResourceModel_js__WEBPACK_IMPORTED_MODULE_13__["default"],

          /**
           * The constructor of the assignment model class, to be used in the project. Will be set as the
           * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-assignmentStore}
           *
           * @config {Scheduler.model.AssignmentModel}
           * @category Models & Stores
           */
          assignmentModelClass: _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_14__["default"],

          /**
           * The constructor to create an event store instance with. Should be a class, subclassing the
           * {@link Scheduler.data.EventStore}
           * @config {Scheduler.data.EventStore|Object}
           * @category Models & Stores
           */
          eventStoreClass: _data_EventStore_js__WEBPACK_IMPORTED_MODULE_19__["default"],

          /**
           * The constructor to create a dependency store instance with. Should be a class, subclassing the
           * {@link Scheduler.data.DependencyStore}
           * @config {Scheduler.data.DependencyStore|Object}
           * @category Models & Stores
           */
          dependencyStoreClass: _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_20__["default"],

          /**
           * The constructor to create a resource store instance with. Should be a class, subclassing the
           * {@link Scheduler.data.ResourceStore}
           * @config {Scheduler.data.ResourceStore|Object}
           * @category Models & Stores
           */
          resourceStoreClass: _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_21__["default"],

          /**
           * The constructor to create an assignment store instance with. Should be a class, subclassing the
           * {@link Scheduler.data.AssignmentStore}
           * @config {Scheduler.data.AssignmentStore|Object}
           * @category Models & Stores
           */
          assignmentStoreClass: _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_22__["default"],
          timeRangeStoreClass: _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_17__["default"],
          resourceTimeRangeStoreClass: _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_23__["default"],

          /**
           * The initial data, to fill the {@link #property-eventStore eventStore} with.
           * Should be an array of {@link Scheduler.model.EventModel EventModels} or it's configuration objects.
           *
           * @config {Scheduler.model.EventModel[]} eventsData
           * @category Inline data
           */

          /**
           * The initial data, to fill the {@link #property-dependencyStore dependencyStore} with.
           * Should be an array of {@link Scheduler.model.DependencyModel DependencyModels} or it's configuration
           * objects.
           *
           * @config {Scheduler.model.DependencyModel[]} [dependenciesData]
           * @category Inline data
           */

          /**
           * The initial data, to fill the {@link #property-resourceStore resourceStore} with.
           * Should be an array of {@link Scheduler.model.ResourceModel ResourceModels} or it's configuration objects.
           *
           * @config {Scheduler.model.ResourceModel[]} [resourcesData]
           * @category Inline data
           */

          /**
           * The initial data, to fill the {@link #property-assignmentStore assignmentStore} with.
           * Should be an array of {@link Scheduler.model.AssignmentModel AssignmentModels} or it's configuration objects.
           *
           * @config {Scheduler.model.AssignmentModel[]} [assignmentsData]
           * @category Inline data
           */

          /**
           * The initial data, to fill the {@link #property-timeRangeStore timeRangeStore} with.
           * Should be an array of {@link Scheduler.model.TimeSpan TimeSpan} or it's configuration objects.
           *
           * @config {Scheduler.model.TimeSpan[]} [timeRangesData]
           * @category Inline data
           */

          /**
           * The initial data, to fill the {@link #property-resourceTimeRangeStore resourceTimeRangeStore} with.
           * Should be an array of {@link Scheduler.model.ResourceTimeRangeModel ResourceTimeRangeModel} or it's configuration objects.
           *
           * @config {Scheduler.model.ResourceTimeRangeModel[]} [resourceTimeRangesData]
           * @category Inline data
           */
          eventStore: {},
          assignmentStore: {},
          dependencyStore: {},
          resourceStore: {},
          timeRangeStore: null,
          resourceTimeRangeStore: null
        };
      }
    }]);

    return ProjectModelMixin;
  }(Target || _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_10__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/RecurringTimeSpan.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../RecurrenceModel.js */ "./lib/Scheduler/model/RecurrenceModel.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");


































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_31___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




function convertExceptionDatesValue(value) {
  var result = {},
      dateFormat = this.dateFormat;

  if (value) {
    value = typeof value == 'string' ? value.split(',') : Array.isArray(value) ? value : [value];
    value.forEach(function (item) {
      if (typeof item == 'string') {
        item = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].parse(item, dateFormat);
      } // If we've got a valid date out of the incoming item, add an exception key


      if (!isNaN(item)) {
        result[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].makeKey(item)] = 1;
      }
    });
  }

  return result;
}

function serializeExceptionDatesValue(value) {
  var result = [],
      dateFormat = this.dateFormat;

  for (var date in value) {
    if (value[date]) {
      result.push(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].format(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].parseKey(date), dateFormat));
    }
  }

  return result;
}

var emptyArray = [];
/**
 * @module Scheduler/model/mixin/RecurringTimeSpan
 */

/**
 * This mixin class provides recurrence related fields and methods to a {@link Scheduler.model.TimeSpan timespan model}.
 *
 * The mixin introduces two types of timespans: __recurring timespan__ and its __occurrences__.
 * __Recurring timespan__ is a timespan having {@link #field-recurrenceRule recurrence rule} specified and its __occurrences__ are "fake" dynamically generated timespans.
 * Their set depends on the scheduler visible timespan and changes upon the timespan change.
 *
 * There are few methods allowing to distinguish a recurring event and an occurrence: {@link #property-isRecurring}, {@link #property-isOccurrence}
 * and {@link #property-recurringTimeSpan} (returns the event this record is an occurrence of).
 *
 * The {@link #field-recurrenceRule recurrence rule} defined for the event is parsed and
 * represented with {@link Scheduler.model.RecurrenceModel} class (can be changed by setting {@link #property-recurrenceModel} property) instance.
 * See: {@link #property-recurrence} property.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_30___default()(RecurringTimeSpan, _ref);

    var _super = _createSuper(RecurringTimeSpan);

    function RecurringTimeSpan() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_27___default()(this, RecurringTimeSpan);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_28___default()(RecurringTimeSpan, [{
      key: "remove",

      /**
       * Override of {@link Core.data.Model Model}'s method. If an {@link #property-isOccurrence}
       * is passed, it is detached from its parent recurring event. If it still has a recurrence
       * then the recurring event is changed to stop at the occurrence date. If it has no recurrence
       * an exception is added at the occurrence date.
       */
      value: function remove() {
        if (this.isOccurrence) {
          this.cancelBatch();
          this.detachFromRecurringEvent();
        } else {
          return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(RecurringTimeSpan.prototype), "remove", this).apply(this, arguments);
        }
      }
    }, {
      key: "setRecurrence",

      /**
       * Sets a recurrence for the timespan with a given frequency, interval, and end.
       * @param {Object|String|Scheduler.model.RecurrenceModel} recurrence A data object for an instance of {@link Scheduler.model.RecurrenceModel RecurrenceModel}.
       * May also be the frequency string: `DAILY`, `WEEKLY`, `MONTHLY`, or `YEARLY`.
       *
       * ```javascript
       * // repeat the event every other week till Jan 2 2039
       * event.setRecurrence({
       *     frequency : "WEEKLY",
       *     interval  : 2,
       *     endDate   : new Date(2039, 0, 2)
       * });
       * ```
       *
       * Also a {@link Scheduler.model.RecurrenceModel recurrence model} can be provided as the only argument for this method:
       *
       * ```javascript
       * const recurrence = new RecurrenceModel({ frequency : 'DAILY', interval : 5 });
       *
       * event.setRecurrence(recurrence);
       * ```
       *
       * or
       *
       * ```javascript
       * event.setRecurrence("WEEKLY", 2, new Date(2039, 0, 2));
       * ```
       * @param {Number} [interval] The interval between occurrences (instances of this recurrence). For example, a daily recurrence with an interval of 2 occurs every other day. Must be greater than 0.
       * @param {Number|Date} [recurrenceEnd] The end of the recurrence. The value can be specified by a date or by a maximum count of occurrences (has to greater than 1, since 1 means the event itself).
       */
      value: function setRecurrence(recurrence, interval, recurrenceEnd) {
        var me = this;
        var recurrenceRule;

        if (recurrence) {
          if (!recurrence.isRecurrenceModel) {
            if (typeof recurrence === 'string') {
              recurrence = {
                frequency: recurrence
              };

              if (interval) {
                recurrence.interval = interval;
              } // If the recurrence is limited


              if (recurrenceEnd) {
                if (recurrenceEnd instanceof Date) {
                  recurrence.endDate = recurrenceEnd;
                } else {
                  recurrence.count = recurrenceEnd;
                }
              }
            }

            recurrence = new me.recurrenceModel(recurrence);
          } // The RecurrenceModel has a reference to its owning recurring event.
          // It uses this to remove the owning event's exceptions after its new endDate
          // whenever its endDate is changed.


          recurrence.timeSpan = me;
          recurrenceRule = recurrence.rule;
        }

        me.recurrence = recurrence;
        me.recurrenceRule = recurrenceRule;
      }
      /**
       * The recurrence model used for the timespan.
       * @property {Scheduler.model.RecurrenceModel}
       */

    }, {
      key: "getOccurrencesForDateRange",

      /**
       * Returns the occurrences of this event over the specified time range. If the first
       * occurrence is in the time range `*this*` record is included in that position.
       * @param {Date} startDate The start date of the range for which to include occurrences.
       * @param {Date} [endDate] The end date of the range for which to include occurrences.
       * Defaults to the startDate.
       * @returns {Scheduler.model.TimeSpan[]} The array of occurrences which occur over the specified range.
       */
      value: function getOccurrencesForDateRange(startDate) {
        var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startDate;
        return this.eventStore.getOccurrencesForTimeSpan(this, startDate, endDate);
      }
      /**
       * Array of this recurring timespan's cached occurrences. __Not including the owning recurring
       * event__.
       *
       * Empty if the timespan is not recurring.
       *
       * __Note that this is an internal accessor and is cleared whenever changes are made to the
       * owning recurring event__.
       * @property {Scheduler.model.TimeSpan[]}
       * @readonly
       * @internal
       */

    }, {
      key: "removeOccurrence",

      /**
       * Removes an occurrence from this recurring timespan's cached occurrences.
       * @param dateOrTimeSpan occurrence date or occurrence TimeSpan
       * @internal
       */
      value: function removeOccurrence(dateOrTimeSpan) {
        var _this$eventStore;

        var date = dateOrTimeSpan.isTimeSpan ? dateOrTimeSpan.occurrenceDate : dateOrTimeSpan; // Clear the occurrences *is* we are in an EventStore.

        (_this$eventStore = this.eventStore) === null || _this$eventStore === void 0 ? void 0 : _this$eventStore.globalOccurrences.delete(this.createRecurrenceKey(date)); // Remove occurrence from its by-startDate cache

        this.occurrenceMap.delete(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].makeKey(date));
      }
      /**
       * Removes all cached occurrences on or after the passed date from this recurring timespan's cached occurrences.
       * @internal
       */

    }, {
      key: "removeOccurrencesFrom",
      value: function removeOccurrencesFrom(date) {
        var _this = this;

        this.occurrenceMap.forEach(function (occurrence, dateKey) {
          if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].parseKey(dateKey) >= date) {
            _this.removeOccurrence(occurrence);
          }
        });
      }
      /**
       * Removes this recurring timespan's cached occurrences.
       * @internal
       */

    }, {
      key: "removeOccurrences",
      value: function removeOccurrences() {
        var _this2 = this;

        // This recurring event must also be removed from the occurrenceMap if it's there
        // So insert it as the first element. Can also be found from the store's global occurrence
        // Map using [...this.eventStore.globalOccurrences.keys()].filter(e => e.startsWith(`_generated:${this.id}`))
        [this].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_26___default()(this.occurrences)).forEach(function (occurrence) {
          return _this2.removeOccurrence(occurrence);
        });
      }
      /**
       * The method is triggered when the timespan recurrence settings get changed.
       * It updates the {@link #field-recurrenceRule} field in this case.
       * @internal
       */

    }, {
      key: "onRecurrenceChanged",
      value: function onRecurrenceChanged() {
        var _this$recurrence;

        this.recurrenceRule = ((_this$recurrence = this.recurrence) === null || _this$recurrence === void 0 ? void 0 : _this$recurrence.rule) || null;
      }
      /**
       * The original {@lScheduler.model.TimeSpan#field-startDate startDate} of this event before any modifications
       * took place. Used by {@link #function-removeOccurrence} and {@link #function-detachFromRecurringEvent}
       * @internal
       * @readonly
       */

    }, {
      key: "buildOccurrence",

      /**
       * Builds an occurrence of this recurring event by cloning the timespan data.
       * The method is used internally by the __RecurringTimeSpans__ mixin.
       * Override it if you need to customize the generated occurrences.
       *
       * If the date requested is the start date of the event sequence, `this`
       * record is returned. All runs of recurring events begin with the base record.
       * @param  {Date} occurrenceDate The occurrence start date.
       * @param  {Boolean} isFirst `true` if this is the first occurrence.
       * @return {Scheduler.model.TimeSpan} The occurrence.
       * @internal
       */
      value: function buildOccurrence(occurrenceDate, isFirst) {
        var _me$eventStore;

        var me = this,
            occurrenceMap = me.occurrenceMap,
            recurrence = me.recurrence,
            meta = me.meta,
            globalOccurrences = (_me$eventStore = me.eventStore) === null || _me$eventStore === void 0 ? void 0 : _me$eventStore.globalOccurrences,
            id = me.createRecurrenceKey(occurrenceDate),
            onStartDate = !(occurrenceDate - me.startDate),
            fieldMap = me.constructor.fieldMap; // An occurrence has a unique ID which identifies it by its base recurring event and its time.

        var occurrence = globalOccurrences === null || globalOccurrences === void 0 ? void 0 : globalOccurrences.get(id),
            duration = me.duration; // If there's no duration, or it's an all day event (which makes the event ceil and floor its
        // start and end dates, but does *NOT* as of 27/5/2020 adjust its duration) then
        // we calculate the duration of the occurrence.

        if (me.endDate && (me.allDay || !duration)) {
          duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].as(me.durationUnit, me.endDate.getTime() - me.startDate.getTime());
        } // Don't let NaN in record data


        var occurrenceEndDate = duration !== undefined ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].add(occurrenceDate, duration, me.durationUnit) : undefined;

        if (!occurrence) {
          // If this is the first occurrence (start times may not match), or it's right on the start
          // then this recurring event *IS* the occurrence
          if (isFirst || onStartDate) {
            occurrence = me; // We are the first occurrence.
            // But if our start time is not as the rule requires, adjust ourself *silently*

            if (!onStartDate) {
              me.setStartEndDate(occurrenceDate, occurrenceEndDate, true); // Since we've changed the event start date the recurrence "Days"/"MonthDays"/"Months"
              // might get redundant in case the event start date matches the fields values
              // Calling recurrence sanitize() will clean the fields in this case.

              recurrence.suspendTimeSpanNotifying();
              recurrence.sanitize();
              recurrence.resumeTimeSpanNotifying();
            } // Either way, because of adjustment above, or initial correctness, we are in sync
            // with our recurrence rule. A RecurrenceIterator is now able to calculate a correct
            // UNTIL date from a COUNT value. See AbstractRecurrenceIterator#processIterationConfig


            meta.isSyncedWithRule = true;
          } // Generate an occurrence which references this as its parent
          else {
              var _me$copy;

              occurrence = me.copy((_me$copy = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default()(_me$copy, fieldMap.id.dataSource, id), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default()(_me$copy, fieldMap.startDate.dataSource, occurrenceDate), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default()(_me$copy, fieldMap.endDate.dataSource, occurrenceEndDate), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_25___default()(_me$copy, fieldMap.duration.dataSource, duration), _me$copy));
              occurrence.recurringTimeSpan = me;
            }

          globalOccurrences === null || globalOccurrences === void 0 ? void 0 : globalOccurrences.set(id, occurrence); // A recurring timespan keeps a by-startDate index of occurrences.
          // And itself will be among those.

          occurrenceMap.set(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].makeKey(occurrenceDate), occurrence);
        }

        return occurrence;
      }
    }, {
      key: "createRecurrenceKey",
      value: function createRecurrenceKey() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.startDate;
        return "_generated:".concat(this.id, ":").concat(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].format(date, 'YYYYMMDD'));
      }
    }, {
      key: "afterChange",
      value: function afterChange(toSet, wasSet, silent) {
        var _get2;

        var me = this,
            eventStore = me.eventStore; // reset cached recurrence instance in case "recurrenceRule" is changed

        if ('recurrenceRule' in wasSet) {
          me._recurrence = null; // If we are a recurring event, we must be in the recurringEvents cache.
          // If we are *not* a recurring event, we must *not* be in there.
          // An event not yet in a store (eg dragging to create) won't have an eventStore.
          // eslint-disable-next-line no-unused-expressions

          eventStore === null || eventStore === void 0 ? void 0 : eventStore.recurringEvents[wasSet.recurrenceRule.value ? 'add' : 'delete'](me);
        } // Any change to an occurrence adds it to an event store, at which point
        // it ceases to be an occurrence.
        //
        // If it has a recurrenceRule it becomes the start of a new recurring event series,
        // and the old owning recurring event stops on the day before.
        //
        // If it has no recurrenceRule, it becomes an exception to its owning recurring event.


        if (me.isOccurrence) {
          var _wasSet$startDate;

          var recurringTimeSpan = me.recurringTimeSpan,
              resource = me.resource,
              _startDate = ((_wasSet$startDate = wasSet.startDate) === null || _wasSet$startDate === void 0 ? void 0 : _wasSet$startDate.value) || me.startDate;

          recurringTimeSpan.beginBatch();
          me.detachFromRecurringEvent();
          me.clearChanges(); // Must silently set our own ID, not be the key generated from our parent id and occurrence date.
          // Must not result in the id field being in the modified state.

          me.setData('id', me.generateId(recurringTimeSpan.eventStore)); // Add to the store silently. We do not want a UI update now.
          // The impending changes to the former parent recurring event trigger a full refresh.

          recurringTimeSpan.eventStore.add(me, true);
          me.startDate = _startDate; // If not using single assignment mode, we also have to add an assignment

          if (!('resourceId' in me.data)) {
            me.assign(resource);
          } // Any change to a recurring events triggers a store refresh event.


          recurringTimeSpan.endBatch();
        } else {
          // Setting a newException date must mark the exceptionDates as modified
          if ('newExceptionDate' in wasSet) {
            me.meta.modified.exceptionDates = true;
            delete me.meta.modified.newExceptionDate; // Remove any occurrence on that date from our by-startDate cache
            // and from the global occurrences cache

            me.removeOccurrence(wasSet.newExceptionDate.value);
          }
        }

        for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          args[_key - 3] = arguments[_key];
        }

        return (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(RecurringTimeSpan.prototype), "afterChange", this)).call.apply(_get2, [this, toSet, wasSet, silent].concat(args));
      }
      /**
       * Detaches an occurrence from its owning recurring event so that it can be added to the eventStore
       * either as an exception, or as the start of a new recurring sequence.
       * @internal
       */

    }, {
      key: "detachFromRecurringEvent",
      value: function detachFromRecurringEvent() {
        var me = this,
            recurringTimeSpan = me.recurringTimeSpan,
            occurrenceDate = me.occurrenceDate,
            startDate = me.startDate; // Break the link

        me.recurringTimeSpan = null; // The occurrenceDate is injected into the data when an occurrence is created.
        // the recurringTimeSpan's afterChange will remove any cache occurrence
        // for this date; see above

        recurringTimeSpan.addExceptionDate(occurrenceDate); // If we still have a recurrenceRule, we're being promoted to be a new recurring event.
        // The recurrence setter applies the rule immediately to occurrences, so this will
        // always be correct.

        if (me.recurrenceRule) {
          // The RecurrenceModel removes occurrences and exceptions after this date
          recurringTimeSpan.recurrence.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].add(startDate, -1, 'minute');
        }
      }
      /**
       * The setter used by Model#inSet when {@link #function-addExceptionDate} is called.
       * Adding an exception must trigger change processing in a recurring event, so it must
       * be changed through a {@link Core.data.Model#function-set} call. Also, the change must be batchable
       * with other changes.
       * @private
       * @readonly
       */

    }, {
      key: "addExceptionDate",

      /**
       * Adds an exception date that should be skipped when generating occurrences for the timespan.
       * The methods adds an entry to the array kept in {@link #field-exceptionDates} field.
       * @param {Date} date Exception date.
       * @internal
       */
      value: function addExceptionDate(newExceptionDate) {
        return this.set({
          newExceptionDate: newExceptionDate
        });
      }
      /**
       * Does this recurring event have an exception on the passed date.
       * @param {Date} date The date to find an exception for.
       * @returns {Boolean} `true` if the event has an exception starting on the passed date.
       */

    }, {
      key: "hasException",
      value: function hasException(date) {
        var _this$exceptionDates;

        return (_this$exceptionDates = this.exceptionDates) === null || _this$exceptionDates === void 0 ? void 0 : _this$exceptionDates[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].makeKey(date)];
      }
    }, {
      key: "supportsRecurring",

      /**
       * Returns `true` indicating the timespan supports recurring.
       * @property {Boolean} true
       */
      get: function get() {
        return true;
      }
    }, {
      key: "eventStore",
      get: function get() {
        var _this$firstStore;

        var result = this.isOccurrence ? this.recurringEvent.eventStore : _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_29___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_32___default()(RecurringTimeSpan.prototype), "eventStore", this); // Recurrence methods are called on `eventStore`, but in case we have a regular
        // store with recurrence mixin, we won't event store and should return own
        // store instead

        if (!result && ((_this$firstStore = this.firstStore) === null || _this$firstStore === void 0 ? void 0 : _this$firstStore.isRecurringTimeSpansMixin)) {
          result = this.firstStore;
        }

        return result;
      }
      /**
       * Name of the class representing the recurrence model.
       * @property {String} [recurrenceModel=Scheduler.model.RecurrenceModel]
       */

    }, {
      key: "recurrenceModel",
      get: function get() {
        return this._recurrenceModel || _RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_34__["default"];
      },
      set: function set(model) {
        this._recurrenceModel = model;
      }
    }, {
      key: "recurrence",
      get: function get() {
        var me = this,
            rule = me.recurrenceRule;

        if (!me._recurrence && rule) {
          me._recurrence = new me.recurrenceModel({
            rule: rule,
            timeSpan: me,
            id: "".concat(me.id, "-recurrence")
          });
        }

        return me._recurrence;
      },
      set: function set(recurrence) {
        var me = this;
        me._recurrence = recurrence;

        if (recurrence) {
          // bind recurrence instance to the model
          recurrence.timeSpan = me;
          me.recurrenceRule = recurrence.rule;
        } else {
          // If this is being done to an occurrence, it's a signal that we are being
          // made an exception. Apply the change immediately, directly to the data.
          if (me.isOccurrence) {
            me.setData('recurrenceRule', null);
          } else {
            me.recurrenceRule = null;
          }
        }
      }
      /**
       * Indicates if the timespan is recurring.
       * @property {Boolean}
       * @readonly
       */

    }, {
      key: "isRecurring",
      get: function get() {
        // MUST evaluate in this order so that if it is an occurrence,
        // the recurrence getter does not refresh the rule
        return Boolean(!this.isOccurrence && this.recurrence);
      }
      /**
       * Indicates if the timespan is an occurrence of another recurring timespan.
       * @property {Boolean}
       * @readonly
       */

    }, {
      key: "isOccurrence",
      get: function get() {
        return Boolean(this.recurringTimeSpan);
      }
      /**
       * The "main" timespan this model is an occurrence of. For non-occurrences returns `null`.
       * @property {Scheduler.model.TimeSpan}
       * @readonly
       * @internal
       */

    }, {
      key: "recurringTimeSpan",
      get: function get() {
        return this._recurringTimeSpan;
      },
      set: function set(recurringTimeSpan) {
        this._recurringTimeSpan = recurringTimeSpan;
      }
    }, {
      key: "isPersistable",
      get: function get() {
        return !this.supportsRecurring || !this.isOccurrence;
      }
    }, {
      key: "occurrences",
      get: function get() {
        var _this3 = this;

        if (this.isRecurring) {
          var result = []; // The occurrencesMap contains entries for each occurrence date.

          this.occurrenceMap.forEach(function (occurrence) {
            if (occurrence !== _this3) {
              result.push(occurrence);
            }
          });
          return result;
        }

        return emptyArray;
      }
      /**
       * A Map, keyed by each date an occurrence intersects, of occurrences of this event.
       * @property {Map}
       * @readonly
       * @internal
       */

    }, {
      key: "occurrenceMap",
      get: function get() {
        return this._occurrencesMap || (this._occurrencesMap = new Map());
      }
    }, {
      key: "occurrenceDate",
      get: function get() {
        var _this$meta$modified;

        return ((_this$meta$modified = this.meta.modified) === null || _this$meta$modified === void 0 ? void 0 : _this$meta$modified.startDate) || this.startDate;
      }
    }, {
      key: "newExceptionDate",
      set: function set(date) {
        if (date) {
          var exceptionDates = this.exceptionDates || (this.exceptionDates = {});
          exceptionDates[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"].makeKey(date)] = 1;
        }
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'RecurringTimeSpan';
      }
    }, {
      key: "fields",
      get: function get() {
        return [
        /**
         * The timespan recurrence rule. A string in [RFC-5545](https://tools.ietf.org/html/rfc5545#section-3.3.10) described format ("RRULE" expression).
         * @field {String} recurrenceRule
         * @category Scheduling
         */
        {
          name: 'recurrenceRule'
        },
        /**
         * The timespan exception dates. The dates that must be skipped when generating occurrences for a repeating timespan.
         * This is used to modify only individual occurrences of the timespan so the further regenerations
         * won't create another copy of this occurrence again.
         * Use {@link #function-addExceptionDate} method to add an individual entry to the dates array:
         *
         * ```javascript
         * // Break the link between the occurrence and its base.
         * // This also adds the occurrence date as an {@config #exceptionDates exception date}
         * // so that the base timespan knows that this date should be skipped when regenerating its occurrences.
         * occurrence.recurringTimeSpan = null;
         *
         * // now the occurrence is an individual record that can be changed & persisted freely
         * occurrence.setStartEndDate(new Date(2018, 6, 2), new Date(2018, 6, 3));
         * ```
         * **Note:** The dates in this field get automatically removed when the event changes its {@link Scheduler.model.TimeSpan#field-startDate start date}.
         *
         * @field {Object} exceptionDates
         * @category Scheduling
         */
        {
          name: 'exceptionDates',
          convert: convertExceptionDatesValue,
          serialize: serializeExceptionDatesValue
        }];
      }
    }]);

    return RecurringTimeSpan;
  }(Target || _TimeSpan_js__WEBPACK_IMPORTED_MODULE_33__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/ResourceModelMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/ResourceModelMixin.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/**
* @module Scheduler/model/mixin/ResourceModelMixin
*/

/**
 * Mixin that holds configuration shared between resources in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Target) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(ResourceModelMixin, _Target);

    var _super = _createSuper(ResourceModelMixin);

    function ResourceModelMixin() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ResourceModelMixin);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(ResourceModelMixin, [{
      key: "updateAssignmentResourceIds",
      //endregion
      //region Id change
      value: function updateAssignmentResourceIds() {
        var _this = this;

        this.assigned.forEach(function (assignment) {
          assignment.resourceId = _this.id;
        });
      }
    }, {
      key: "syncId",
      value: function syncId(value) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(ResourceModelMixin.prototype), "syncId", this).call(this, value);

        this.updateAssignmentResourceIds();
      } //endregion
      //region Getters

      /**
       * Get associated events
       *
       * @returns {Scheduler.model.EventModel[]}
       * @readonly
       */

    }, {
      key: "getEvents",

      /**
       * Returns an array of events, associated with this resource
       *
       * @return {Scheduler.model.EventModel[]}
       */
      value: function getEvents() {
        // TODO: Deprecate in favor of .events
        return this.events;
      }
      /**
       * Returns true if the Resource can be persisted.
       * In a flat store resource is always considered to be persistable, in a tree store resource is considered to
       * be persistable if it's parent node is persistable.
       *
       * @return {Boolean} true if this model can be persisted to server.
       * @readonly
       */

    }, {
      key: "unassignAll",
      //endregion

      /**
       * Unassigns this Resource from all its Events
       */
      value: function unassignAll() {
        this.assignments && this.assignmentStore.remove(this.assignments);
      }
    }, {
      key: "events",
      get: function get() {
        return this.assignments.reduce(function (events, assignment) {
          if (assignment.event) {
            events.push(assignment.event);
          }

          return events;
        }, []);
      }
      /**
       * Returns all assignments for the resource
       *
       * @property {Scheduler.model.AssignmentModel[]}
       */

    }, {
      key: "assignments",
      get: function get() {
        return this.assigned ? _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6___default()(this.assigned) : [];
      },
      set: function set(assignments) {
        var _this2 = this;

        // Engine does not allow assigning to `assigned`, handle it here
        assignments.forEach(function (assignment) {
          assignment.resource = _this2;
        });
      }
    }, {
      key: "isPersistable",
      get: function get() {
        return !this.parent || this.parent.isPersistable;
      }
    }], [{
      key: "$name",
      get: function get() {
        return 'ResourceModelMixin';
      } // Flag checked by ResourceStore to make sure it uses a valid subclass

    }, {
      key: "isResourceModel",
      get: function get() {
        return true;
      }
      /**
       * Set value for the specified field(s), triggering engine calculations immediately. See
       * {@link Core.data.Model#function-set Model#set()} for arguments.
       *
       * This does not matter much on the resource itself, but is of importance when manipulating its references:
       *
       * ```javascript
       * assignment.set('resourceId', 2);
       * // resource.assignments is not yet up to date
       *
       * await assignment.setAsync('resourceId', 2);
       * // resource.assignments is up to date
       * ```
       *
       * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
       * @param {*} value Value to set
       * @param {Boolean} [silent=false] Set to true to not trigger events
       * automatically.
       * @function setAsync
       * @category Editing
       * @async
       */
      //region Fields

    }, {
      key: "fields",
      get: function get() {
        return [
        /**
         * Unique identifier
         * @field {String|Number} id
         * @category Common
         */

        /**
         * Get or set resource name
         * @field {String} name
         * @category Common
         */
        {
          name: 'name',
          type: 'string',
          persist: true
        },
        /**
         * Controls the primary color used for events assigned to this resource. Can be overridden per event using
         * EventModels {@link Scheduler/model/mixin/EventModelMixin#field-eventColor eventColor config}. See Schedulers
         * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor eventColor config} for available
         * colors.
         * @field {String} eventColor
         * @category Styling
         */
        'eventColor',
        /**
         * Controls the style used for events assigned to this resource. Can be overridden per event using
         * EventModels {@link Scheduler/model/mixin/EventModelMixin#field-eventStyle eventStyle config}. See Schedulers
         * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle eventStyle config} for available
         * options.
         * @field {String} eventStyle
         * @category Styling
         */
        'eventStyle',
        /**
         * Fully qualified image URL, used by `ResourceInfoColumn` and vertical modes `ResourceHeader` to display a miniature image
         * for the resource.
         * @field {String} imageUrl
         * @category Styling
         */
        'imageUrl',
        /**
         * Image name relative to {@link Scheduler/view/mixin/SchedulerEventRendering#config-resourceImagePath},
         * used by `ResourceInfoColumn` and vertical modes `ResourceHeader` to display a miniature image
         * for the resource.
         * @field {String} image
         * @category Styling
         */
        'image'];
      }
    }]);

    return ResourceModelMixin;
  }(Target);
});

/***/ }),

/***/ "./lib/Scheduler/preset/PresetManager.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/preset/PresetManager.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return pm; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _ViewPreset_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _PresetStore_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./PresetStore.js */ "./lib/Scheduler/preset/PresetStore.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



 // No module tag here. That stops the singleton from being included by the docs.

/**
 * ## Intro
 * This is a global Store of {@link Scheduler.preset.ViewPreset ViewPresets}, required to supply initial data to
 * Scheduler's {@link Scheduler.view.mixin.TimelineViewPresets#config-presets presets}.
 *
 * You can provide new view presets globally or for a specific scheduler.
 *
 * **NOTE:** You **cannot** modify existing records in the PresetManager store. You can either remove
 * preset records from the store or add new records to the store.
 * Also please keep in mind, all changes provided to the PresetManager store are not reflected to the
 * {@link Scheduler.view.mixin.TimelineViewPresets#config-presets presets} of schedulers that already exist!
 *
 * If you want to have just a few presets (also known as zoom levels) in your Scheduler, you can slice corresponding records
 * from the `PresetManager` and apply them to the Scheduler `presets` config.
 * ```javascript
 * const newPresets = PresetManager.records.slice(10, 12);
 *
 * const scheduler = new Scheduler({
 *     presets    : newPresets, // Only 2 zoom levels are available
 *     viewPreset : newPresets[0].id
 * });
 * ```
 *
 * If you want to adjust all default presets and assign to a specific scheduler you are going to create,
 * you can extend them and pass as an array to the Scheduler `presets` config.
 * Here is an example of how to set the same `timeResolution` to all `ViewPresets`.
 * ```javascript
 * const newPresets = PresetManager.map(preset => {
 *     return {
 *         id             : 'my_' + preset.id,
 *         base           : preset.id, // Based on an existing preset
 *         timeResolution : {
 *             unit      : 'day',
 *             increment : 1
 *         }
 *     };
 * });
 *
 * const scheduler = new Scheduler({
 *     presets     : newPresets,
 *     viewPreset : 'my_hourAndDay'
 * });
 * ```
 *
 * If you want to do the same for **all** schedulers which will be created next, you can register new presets in a loop.
 * ```javascript
 * PresetManager.records.forEach(preset => {
 *     // Pass the same ID, so when a new preset is added to the store, it will replace the current one.
 *     PresetManager.registerPreset(preset.id, {
 *        id             : preset.id,
 *        base           : preset.id,
 *        timeResolution : {
 *            unit      : 'day',
 *            increment : 1
 *        }
 *    });
 * });
 * ```
 *
 * Here is an example of how to add a new `ViewPreset` to the global `PresetManager` store and to the already created scheduler `presets`.
 * ```javascript
 * const scheduler = new Scheduler({...});
 *
 * const newGlobalPresets = PresetManager.add({
 *     id              : 'myNewPreset',
 *     base            : 'hourAndDay', // Based on an existing preset
 *     columnLinesFor  : 0,
 *     headers : [                         // Override headers
 *         {
 *             unit       : 'day',
 *             dateFormat : 'DD.MM.YYYY'   // Use different date format for top header 01.10.2020
 *         },
 *         {
 *             unit       : 'hour',
 *             dateFormat : 'LT'
 *         }
 *     ]
 * });
 *
 * scheduler.presets.add(newGlobalPresets); // Add new presets to the scheduler that has been created before changes to PresetManager are applied
 * ```
 *
 * Predefined presets are:
 *
 * - `secondAndMinute` - creates 2 level header - minute and seconds within it:
 * {@inlineexample scheduler/viewpresets/secondAndMinute.js}
 * - `minuteAndHour` - creates 2 level header - hour and minutes within it:
 * {@inlineexample scheduler/viewpresets/minuteAndHour.js}
 * - `hourAndDay` - creates 2 level header - day and hours within it:
 * {@inlineexample scheduler/viewpresets/hourAndDay.js}
 * - `dayAndWeek` - creates 2 level header - week and days within it:
 * {@inlineexample scheduler/viewpresets/dayAndWeek.js}
 * - `weekAndDay` - just like `dayAndWeek` but with different formatting:
 * {@inlineexample scheduler/viewpresets/weekAndDay.js}
 * - `weekAndDayLetter` - creates 2 level header - with weeks and day letters within it:
 * {@inlineexample scheduler/viewpresets/weekAndDayLetter.js}
 * - `weekAndMonth` - creates 2 level header - month and weeks within it:
 * {@inlineexample scheduler/viewpresets/weekAndMonth.js}
 * - `weekDateAndMonth` - creates 2 level header - month and weeks within it (weeks shown by first day only):
 * {@inlineexample scheduler/viewpresets/weekDateAndMonth.js}
 * - `monthAndYear` - creates 2 level header - year and months within it:
 * {@inlineexample scheduler/viewpresets/monthAndYear.js}
 * - `year` - creates 2 level header - year and quarters within it:
 * {@inlineexample scheduler/viewpresets/year.js}
 * - `manyYears` - creates 2 level header - 5-years and year within it:
 * {@inlineexample scheduler/viewpresets/manyYears.js}
 *
 * See the {@link Scheduler.preset.ViewPreset} and {@link Scheduler.preset.ViewPresetHeaderRow} classes for a description of the view preset properties.
 * 
 * {@region Localizing View Presets}
 * Bryntum Scheduler uses locales for translations including date formats for view presets.
 * 
 * To translate date format for view presets just define the date format for the specified region
 * for your locale file, like this:
 * ```javascript
 * const locale = {
 * 
 *     // ... Other translations here ...
 * 
 *     PresetManager : {
 *         // Translation for the "weekAndDay" ViewPreset
 *         weekAndDay : {
 *             // Change the date format for the top and middle levels
 *             topDateFormat    : 'MMM',
 *             middleDateFormat : 'D'
 *         },
 *         // Translation for the "dayAndWeek" ViewPreset
 *         dayAndWeek : {
 *             // Change the date format for the top level
 *             topDateFormat : 'MMMM YYYY'
 *         }
 *     }
 * }
 * 
 * LocaleManager.extendLocale('En', locale);
 * ```
 * 
 * Check the <a target="_blank" href="../examples/localization">localization demo</a> and [this guide](#guides/customization/localization.md) for more details.
 * {@endregion}
 * 
 * @singleton
 * @extends Scheduler/preset/PresetStore
 */

var PresetManager = /*#__PURE__*/function (_PresetStore) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(PresetManager, _PresetStore);

  var _super = _createSuper(PresetManager);

  function PresetManager() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, PresetManager);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(PresetManager, [{
    key: "getById",
    value: function getById(id) {
      // Look first in the default set, and if it's one of the base types that is not imported into the
      // default set, then look at the bases.
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(PresetManager.prototype), "getById", this).call(this, id) || this.basePresets[id];
    }
    /**
     * Registers a new view preset base to be used by any scheduler grid or tree on the page.
     * @param {String} id The unique identifier for this preset
     * @param {Object} config The configuration properties of the view preset (see {@link Scheduler.preset.ViewPreset} for more information)
     * @returns {Scheduler.preset.ViewPreset} A new ViewPreset based upon the passed configuration.
     */

  }, {
    key: "registerPreset",
    value: function registerPreset(id, config) {
      var preset = this.createRecord(Object.assign({
        id: id
      }, config)),
          existingDuplicate = this.find(function (p) {
        return p.equals(preset);
      });

      if (existingDuplicate) {
        return existingDuplicate;
      }

      if (preset.isValid) {
        this.add(preset);
      } else {
        throw new Error('Invalid preset, please check your configuration');
      }

      return preset;
    }
  }, {
    key: "getPreset",
    value: function getPreset(preset) {
      if (typeof preset === 'number') {
        preset = this.getAt(preset);
      }

      if (typeof preset === 'string') {
        preset = this.getById(preset);
      } else if (!(preset instanceof _ViewPreset_js__WEBPACK_IMPORTED_MODULE_15__["default"])) {
        preset = this.createRecord(preset);
      }

      return preset;
    }
    /**
     * Applies preset customizations or fetches a preset view preset using its name.
     * @param {String|Object} presetOrId Id of a predefined preset or a preset config object
     * @returns {Scheduler.preset.ViewPreset} Resulting ViewPreset instance
     */

  }, {
    key: "normalizePreset",
    value: function normalizePreset(preset) {
      var me = this;

      if (!(preset instanceof _ViewPreset_js__WEBPACK_IMPORTED_MODULE_15__["default"])) {
        if (typeof preset === 'string') {
          preset = me.getPreset(preset);

          if (!preset) {
            throw new Error('You must define a valid view preset. See PresetManager for reference');
          }
        } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default()(preset) === 'object') {
          // Look up any existing ViewPreset that it is based upon.
          if (preset.base) {
            var base = this.getById(preset.base);

            if (!base) {
              throw new Error("ViewPreset base '".concat(preset.base, "' does not exist"));
            } // The config is based upon the base's data with the new config object merged in.


            preset = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].merge(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].clone(base.data), preset);
          } // Ensure the new ViewPreset has a legible, logical id which does not already
          // exxist in our store.


          if (preset.id) {
            preset = me.createRecord(preset);
          } else {
            preset = me.createRecord(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].assign({}, preset));
            preset.id = preset.generateId(preset);
          }
        }
      }

      return preset;
    }
    /**
     * Deletes a view preset
     * @param {String} id The id of the preset, or the preset instance.
     */

  }, {
    key: "deletePreset",
    value: function deletePreset(presetOrId) {
      if (typeof presetOrId === 'string') {
        presetOrId = this.getById(presetOrId);
      } else if (typeof presetOrId === 'number') {
        presetOrId = this.getAt(presetOrId);
      }

      if (presetOrId) {
        this.remove(presetOrId); // ALso remove it from our base list

        delete this.basePresets[presetOrId.id];
      }
    }
  }, {
    key: "basePresets",
    set: function set(basePresets) {
      var presetCache = this._basePresets = {};

      for (var id in basePresets) {
        basePresets[id].id = id;
        presetCache[id] = this.createRecord(basePresets[id]);
      }
    },
    get: function get() {
      return this._basePresets;
    }
  }, {
    key: "defaultPresets",
    set: function set(defaultPresets) {
      for (var i = 0, length = defaultPresets.length; i < length; i++) {
        var presetAdjustment = defaultPresets[i],
            isBase = typeof presetAdjustment === 'string',
            baseType = isBase ? presetAdjustment : presetAdjustment.preset;
        var preset = void 0; // The default was just a string, so it's an unmodified instance of a base type.

        if (isBase) {
          preset = this.basePresets[baseType];
        } // If it's an object, it's an adjustment to a base tyope
        else {
            var config = Object.setPrototypeOf(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].clone(this.basePresets[baseType].data), {
              id: baseType
            }),
                timeResolution = config.timeResolution,
                bottomHeader = config.headers[config.headers.length - 1];
            config.id = undefined;

            if ('width' in presetAdjustment) {
              config.tickWidth = presetAdjustment.width;
            }

            if ('height' in presetAdjustment) {
              config.tickHeight = presetAdjustment.height;
            }

            if ('increment' in presetAdjustment) {
              bottomHeader.increment = presetAdjustment.increment;
            }

            if ('resolution' in presetAdjustment) {
              timeResolution.increment = presetAdjustment.resolution;
            }

            if ('resolutionUnit' in presetAdjustment) {
              timeResolution.unit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getUnitByName(presetAdjustment.resolutionUnit);
            }

            preset = this.createRecord(config); // Keep id of original preset around, used with localization in PresetStore

            preset.baseId = baseType;
          }

        this.add(preset);
      }
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        // To not break CSP demo
        preventSubClassingModel: true,
        basePresets: {
          // Do not remove. Assertion strings for Localization sanity check.
          // 'L{secondAndMinute}'
          // 'L{minuteAndHour}'
          // 'L{hourAndDay}'
          // 'L{dayAndWeek}'
          // 'L{weekAndDay}'
          secondAndMinute: {
            name: 'Seconds',
            tickWidth: 30,
            // Time column width
            tickHeight: 40,
            displayDateFormat: 'll LTS',
            // Controls how dates will be displayed in tooltips etc
            shiftIncrement: 10,
            // Controls how much time to skip when calling shiftNext and shiftPrevious.
            shiftUnit: 'minute',
            // Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
            defaultSpan: 24,
            // By default, if no end date is supplied to a view it will show 24 hours
            timeResolution: {
              // Dates will be snapped to this resolution
              unit: 'second',
              // Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
              increment: 5
            },
            // This defines your header rows.
            // For each row you can define "unit", "increment", "dateFormat", "renderer", "align", and "thisObj"
            headers: [{
              unit: 'minute',
              dateFormat: 'llll'
            }, {
              unit: 'second',
              increment: 10,
              dateFormat: 'ss'
            }]
          },
          minuteAndHour: {
            name: 'Minutes',
            tickWidth: 60,
            // Time column width
            tickHeight: 60,
            displayDateFormat: 'll LT',
            // Controls how dates will be displayed in tooltips etc
            shiftIncrement: 1,
            // Controls how much time to skip when calling shiftNext and shiftPrevious.
            shiftUnit: 'hour',
            // Valid values are "MILLI", "SECOND", "minute", "HOUR", "DAY", "WEEK", "MONTH", "QUARTER", "YEAR".
            defaultSpan: 24,
            // By default, if no end date is supplied to a view it will show 24 hours
            timeResolution: {
              // Dates will be snapped to this resolution
              unit: 'minute',
              // Valid values are "MILLI", "SECOND", "minute", "HOUR", "DAY", "WEEK", "MONTH", "QUARTER", "YEAR".
              increment: 30
            },
            headers: [{
              unit: 'hour',
              dateFormat: 'ddd MM/DD, hA'
            }, {
              unit: 'minute',
              increment: 30,
              dateFormat: 'mm'
            }]
          },
          hourAndDay: {
            name: 'Hours',
            tickWidth: 70,
            tickHeight: 40,
            displayDateFormat: 'll LT',
            shiftIncrement: 1,
            shiftUnit: 'day',
            defaultSpan: 24,
            timeResolution: {
              unit: 'minute',
              increment: 30
            },
            headers: [{
              unit: 'day',
              dateFormat: 'ddd DD/MM' //Mon 01/10

            }, {
              unit: 'hour',
              dateFormat: 'LT'
            }]
          },
          day: {
            name: 'Hours 2',
            displayDateFormat: 'LT',
            shiftIncrement: 1,
            shiftUnit: 'day',
            defaultSpan: 1,
            timeResolution: {
              unit: 'minute',
              increment: 30
            },
            mainHeaderLevel: 0,
            headers: [{
              unit: 'day',
              dateFormat: 'ddd DD/MM',
              // Mon 01/02
              splitUnit: 'day'
            }, {
              unit: 'hour',
              renderer: function renderer(value) {
                return "\n                                    <div class=\"b-sch-calendarcolumn-ct\"><span class=\"b-sch-calendarcolumn-hours\">".concat(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].format(value, 'HH'), "</span>\n                                    <span class=\"b-sch-calendarcolumn-minutes\">").concat(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].format(value, 'mm'), "</span></div>\n                                ");
              }
            }]
          },
          week: {
            name: 'Week/hours',
            displayDateFormat: 'LT',
            shiftIncrement: 1,
            shiftUnit: 'week',
            defaultSpan: 24,
            timeResolution: {
              unit: 'minute',
              increment: 30
            },
            mainHeaderLevel: 0,
            headers: [{
              unit: 'week',
              dateFormat: 'D d',
              splitUnit: 'day'
            }, {
              unit: 'hour',
              dateFormat: 'LT',
              // will be overridden by renderer
              renderer: function renderer(value) {
                return "\n                                    <div class=\"sch-calendarcolumn-ct\">\n                                    <span class=\"sch-calendarcolumn-hours\">".concat(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].format(value, 'HH'), "</span>\n                                    <span class=\"sch-calendarcolumn-minutes\">").concat(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].format(value, 'mm'), "</span>\n                                    </div>\n                                ");
              }
            }]
          },
          dayAndWeek: {
            name: 'Days 2',
            tickWidth: 100,
            tickHeight: 80,
            displayDateFormat: 'll LT',
            shiftUnit: 'day',
            shiftIncrement: 1,
            defaultSpan: 5,
            timeResolution: {
              unit: 'hour',
              increment: 1
            },
            headers: [{
              unit: 'week',
              renderer: function renderer(start) {
                return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getShortNameOfUnit('week') + '.' + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].format(start, 'WW MMM YYYY');
              }
            }, {
              unit: 'day',
              dateFormat: 'dd DD'
            }]
          },
          weekAndDay: {
            name: 'Days',
            tickWidth: 100,
            tickHeight: 80,
            displayDateFormat: 'll hh:mm A',
            shiftUnit: 'week',
            shiftIncrement: 1,
            defaultSpan: 1,
            timeResolution: {
              unit: 'day',
              increment: 1
            },
            mainHeaderLevel: 0,
            headers: [{
              unit: 'week',
              dateFormat: 'YYYY MMMM DD' // 2017 January 01

            }, {
              unit: 'day',
              increment: 1,
              dateFormat: 'DD MMM'
            }]
          },
          weekAndMonth: {
            name: 'Weeks',
            tickWidth: 100,
            tickHeight: 105,
            displayDateFormat: 'll',
            shiftUnit: 'week',
            shiftIncrement: 5,
            defaultSpan: 6,
            timeResolution: {
              unit: 'day',
              increment: 1
            },
            headers: [{
              unit: 'month',
              dateFormat: 'MMM YYYY' //Jan 2017

            }, {
              unit: 'week',
              dateFormat: 'DD MMM'
            }]
          },
          weekAndDayLetter: {
            name: 'Weeks 2',
            tickWidth: 20,
            tickHeight: 50,
            displayDateFormat: 'll',
            shiftUnit: 'week',
            shiftIncrement: 1,
            defaultSpan: 10,
            timeResolution: {
              unit: 'day',
              increment: 1
            },
            mainHeaderLevel: 0,
            headers: [{
              unit: 'week',
              dateFormat: 'ddd DD MMM YYYY',
              verticalColumnWidth: 115
            }, {
              unit: 'day',
              dateFormat: 'd1',
              verticalColumnWidth: 25
            }]
          },
          weekDateAndMonth: {
            name: 'Weeks 3',
            tickWidth: 30,
            tickHeight: 40,
            displayDateFormat: 'll',
            shiftUnit: 'week',
            shiftIncrement: 1,
            defaultSpan: 10,
            timeResolution: {
              unit: 'day',
              increment: 1
            },
            headers: [{
              unit: 'month',
              dateFormat: 'YYYY MMMM'
            }, {
              unit: 'week',
              dateFormat: 'DD'
            }]
          },
          monthAndYear: {
            name: 'Months',
            tickWidth: 110,
            tickHeight: 110,
            displayDateFormat: 'll',
            shiftIncrement: 3,
            shiftUnit: 'month',
            defaultSpan: 12,
            timeResolution: {
              unit: 'day',
              increment: 1
            },
            headers: [{
              unit: 'year',
              dateFormat: 'YYYY' //2017

            }, {
              unit: 'month',
              dateFormat: 'MMM YYYY' //Jan 2017

            }]
          },
          year: {
            name: 'Years',
            tickWidth: 100,
            tickHeight: 100,
            resourceColumnWidth: 100,
            displayDateFormat: 'll',
            shiftUnit: 'year',
            shiftIncrement: 1,
            defaultSpan: 1,
            timeResolution: {
              unit: 'month',
              increment: 1
            },
            headers: [{
              unit: 'year',
              dateFormat: 'YYYY'
            }, {
              unit: 'quarter',
              renderer: function renderer(start, end, cfg) {
                return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getShortNameOfUnit('quarter').toUpperCase() + (Math.floor(start.getMonth() / 3) + 1);
              }
            }]
          },
          manyYears: {
            name: 'Years 2',
            tickWidth: 40,
            tickHeight: 50,
            displayDateFormat: 'll',
            shiftUnit: 'year',
            shiftIncrement: 1,
            defaultSpan: 1,
            timeResolution: {
              unit: 'year',
              increment: 1
            },
            mainHeaderLevel: 0,
            headers: [{
              unit: 'year',
              dateFormat: 'YYYY',
              increment: 5
            }, {
              unit: 'year',
              dateFormat: 'YY',
              increment: 1
            }]
          }
        },
        // This is a list of bryntum-supplied preset adjustments used to create the Scheduler's
        // default initial set of ViewPresets.
        defaultPresets: [// Years over years
        'manyYears', {
          width: 80,
          increment: 1,
          resolution: 1,
          preset: 'manyYears',
          resolutionUnit: 'YEAR'
        }, // Years over quarters
        'year', {
          width: 30,
          increment: 1,
          resolution: 1,
          preset: 'year',
          resolutionUnit: 'MONTH'
        }, {
          width: 50,
          increment: 1,
          resolution: 1,
          preset: 'year',
          resolutionUnit: 'MONTH'
        }, {
          width: 200,
          increment: 1,
          resolution: 1,
          preset: 'year',
          resolutionUnit: 'MONTH'
        }, // Years over months
        'monthAndYear', // Months over weeks
        'weekDateAndMonth', // Months over weeks
        'weekAndMonth', // Months over weeks
        'weekAndDayLetter', // Weeks over days
        'weekAndDay', {
          width: 54,
          increment: 1,
          resolution: 1,
          preset: 'weekAndDay',
          resolutionUnit: 'HOUR'
        }, // Days over hours
        'hourAndDay', {
          width: 64,
          increment: 6,
          resolution: 30,
          preset: 'hourAndDay',
          resolutionUnit: 'MINUTE'
        }, {
          width: 100,
          increment: 6,
          resolution: 30,
          preset: 'hourAndDay',
          resolutionUnit: 'MINUTE'
        }, {
          width: 64,
          increment: 2,
          resolution: 30,
          preset: 'hourAndDay',
          resolutionUnit: 'MINUTE'
        }, // Hours over minutes
        'minuteAndHour', {
          width: 30,
          increment: 15,
          resolution: 5,
          preset: 'minuteAndHour'
        }, {
          width: 130,
          increment: 15,
          resolution: 5,
          preset: 'minuteAndHour'
        }, {
          width: 60,
          increment: 5,
          resolution: 5,
          preset: 'minuteAndHour'
        }, {
          width: 100,
          increment: 5,
          resolution: 5,
          preset: 'minuteAndHour'
        }, // Minutes over seconds
        'secondAndMinute', {
          width: 60,
          increment: 10,
          resolution: 5,
          preset: 'secondAndMinute'
        }, {
          width: 130,
          increment: 5,
          resolution: 5,
          preset: 'secondAndMinute'
        }],
        listeners: {
          locale: 'updateLocalization'
        }
      };
    }
  }]);

  return PresetManager;
}(_PresetStore_js__WEBPACK_IMPORTED_MODULE_16__["default"]);

var pm = new PresetManager();


/***/ }),

/***/ "./lib/Scheduler/preset/PresetStore.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/preset/PresetStore.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PresetStore; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.values */ "./node_modules/core-js/modules/es.object.values.js");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _ViewPreset_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _PresetManager_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");




































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/preset/PresetStore
 */

/**
 * A special Store subclass which holds {@link Scheduler.preset.ViewPreset ViewPresets}.
 * Each ViewPreset in this store represents a zoom level. The store data is sorted in special
 * zoom order. That is zoomed out to zoomed in. The first Preset will produce the narrowest event bars
 * the last one will produce the widest event bars.
 *
 * To specify view presets (zoom levels) please provide set of view presets to the scheduler:
 *
 * ```javascript
 * const myScheduler = new Scheduler({
 *     presets : [
 *         {
 *             base : 'hourAndDay',
 *             id   : 'MyHourAndDay',
 *             // other preset configs....
 *         },
 *         {
 *             base : 'weekAndMonth',
 *             id   : 'MyWeekAndMonth',
 *             // other preset configs....
 *         }
 *     ],
 *     viewPreset : 'MyHourAndDay',
 *     // other scheduler configs....
 *     });
 * ```
 *
 * @extends Core/data/Store
 */

var PresetStore = /*#__PURE__*/function (_Localizable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default()(PresetStore, _Localizable);

  var _super = _createSuper(PresetStore);

  function PresetStore() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_28___default()(this, PresetStore);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_29___default()(PresetStore, [{
    key: "createRecord",
    value: function createRecord(data) {
      if (data.base) {
        var base = this.getById(data.base) || _PresetManager_js__WEBPACK_IMPORTED_MODULE_39__["default"].getById(data.base);
        Object.setPrototypeOf(data, base.data);
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(PresetStore.prototype), "createRecord", this).apply(this, arguments);
    }
  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(PresetStore.prototype), "updateLocalization", this).call(this);

      var me = this; // Collect presets from store...

      var presets = me.allRecords; // and basePresets if we are the PresetManager

      if (me.isPresetManager) {
        presets = new Set(presets.concat(Object.values(me.basePresets)));
      }

      presets.forEach(function (preset) {
        var locale = me.optionalL(preset.id); // Default presets generated from base presets use localization of base if they have no own

        if (typeof locale === 'string' && preset.baseId) {
          locale = me.optionalL(preset.baseId);
        } // Apply any custom format defined in locale, or the original format if none exists


        if (locale && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_27___default()(locale) === 'object') {
          if (!preset.originalDisplayDateFormat) {
            preset.originalDisplayDateFormat = preset.displayDateFormat;
          } // TODO: work around to work topDateFormat for weekAndDay viewPreset localization.
          // it must be fixed on: https://github.com/bryntum/support/issues/1775
          // it there is a topDateFormat but preset.mainHeaderLevel is 0, means the middle header is the top header actually, so convert property to middle (if middle doesn't exists) to localization understand (topDateFormat for weekAndDay for example)
          // topDateFormat doesn't work when mainHeaderLevel is 0 because it doesn't have top config but has top header visually (Check on get headerConfig method in ViewPreset class)


          if (preset.mainHeaderLevel === 0 && locale.topDateFormat) {
            locale.middleDateFormat = locale.middleDateFormat || locale.topDateFormat;
          }

          preset.setData('displayDateFormat', locale.displayDateFormat || preset.originalDisplayDateFormat);
          ['top', 'middle', 'bottom'].forEach(function (level) {
            var levelConfig = preset.headerConfig[level],
                localeLevelDateFormat = locale[level + 'DateFormat'];

            if (levelConfig) {
              if (!levelConfig.originalDateFormat) {
                levelConfig.originalDateFormat = levelConfig.dateFormat;
              } // if there was defined topDateFormat on locale file for example, use it instead of renderer from basePresets (https://github.com/bryntum/support/issues/1307)


              if (localeLevelDateFormat && levelConfig.renderer) {
                levelConfig.renderer = null;
              }

              levelConfig.dateFormat = localeLevelDateFormat || levelConfig.originalDateFormat;
            }
          });
        }
      });
    }
  }, {
    key: "storage",
    set: function set(storage) {
      var _this = this;

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_31___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(PresetStore.prototype), "storage", storage, this, true); // Maintained in order automatically while adding.


      this.storage.addSorter(function (lhs, rhs) {
        var leftBottomHeader = lhs.bottomHeader,
            rightBottomHeader = rhs.bottomHeader; // Sort order:
        //  Milliseconds per pixel.
        //  Tick size.
        //  Unit magnitude.
        //  Increment size.

        var order = rhs.msPerPixel - lhs.msPerPixel || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["unitMagnitudes"][leftBottomHeader.unit] - _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_35__["unitMagnitudes"][rightBottomHeader.unit] || leftBottomHeader.increment - rightBottomHeader.increment;
        return order * _this.zoomOrder;
      });
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_30___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(PresetStore.prototype), "storage", this);
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        useRawData: true,
        modelClass: _ViewPreset_js__WEBPACK_IMPORTED_MODULE_36__["default"],

        /**
         * Specifies the sort order of the presets in the store.
         * By default they are in zoomed out to zoomed in order. That is
         * presets which will create widest event bars to presets
         * which will produce narrowest event bars.
         *
         * Configure this as `-1` to reverse this order.
         * @config {Number}
         * @default
         */
        zoomOrder: 1
      };
    }
  }]);

  return PresetStore;
}(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_37__["default"])(_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_38__["default"]));


PresetStore._$name = 'PresetStore';

/***/ }),

/***/ "./lib/Scheduler/preset/ViewPreset.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/preset/ViewPreset.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ViewPreset; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.object.get-prototype-of */ "./node_modules/core-js/modules/es.object.get-prototype-of.js");
/* harmony import */ var core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");

























function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_22___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Scheduler/preset/ViewPreset
 */

/**
 * A ViewPreset is a record of {@link Scheduler.preset.PresetStore PresetStore} which describes the granularity
 * of the timeline view of a {@link Scheduler.view.Scheduler Scheduler} and the layout and subdivisions of the timeline header.
 *
 * You can create a new instance by specifying all fields:
 * ```javascript
 * const myViewPreset = new ViewPreset({
 *     id   : 'myPreset',              // Unique id value provided to recognize your view preset. Not required, but having it you can simply set new view preset by id: scheduler.viewPreset = 'myPreset'
 *
 *     name : 'My view preset',        // A human-readable name provided to be used in GUI, e.i. preset picker, etc.
 *
 *     tickWidth  : 24,                // Time column width in horizontal mode
 *     tickHeight : 50,                // Time column height in vertical mode
 *     displayDateFormat : 'HH:mm',    // Controls how dates will be displayed in tooltips etc
 *
 *     shiftIncrement : 1,             // Controls how much time to skip when calling shiftNext and shiftPrevious.
 *     shiftUnit      : 'day',         // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
 *     defaultSpan    : 12,            // By default, if no end date is supplied to a view it will show 12 hours
 *
 *     timeResolution : {              // Dates will be snapped to this resolution
 *         unit      : 'minute',       // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
 *         increment : 15
 *     },
 *
 *     headers : [                     // This defines your header rows from top to bottom
 *         {                           // For each row you can define 'unit', 'increment', 'dateFormat', 'renderer', 'align', and 'thisObj'
 *             unit       : 'day',
 *             dateFormat : 'ddd DD/MM'
 *         },
 *         {
 *             unit       : 'hour',
 *             dateFormat : 'HH:mm'
 *         }
 *     ],
 *
 *     columnLinesFor : 1              // Defines header level column lines will be drawn for. Defaults to the last level.
 * });
 * ```
 *
 * Or you can extend one of view presets registered in {@link Scheduler.preset.PresetManager PresetManager}:
 *
 * ```javascript
 * const myViewPreset2 = new ViewPreset({
 *     id   : 'myPreset',                  // Unique id value provided to recognize your view preset. Not required, but having it you can simply set new view preset by id: scheduler.viewPreset = 'myPreset'
 *     name : 'My view preset',            // A human-readable name provided to be used in GUI, e.i. preset picker, etc.
 *     base : 'hourAndDay',                // Extends 'hourAndDay' view preset provided by PresetManager. You can pick out any of PresetManager's view presets: PresetManager.records
 *
 *     timeResolution : {                  // Override time resolution
 *         unit      : 'minute',
 *         increment : 15                  // Make it increment every 15 mins
 *     },
 *
 *     headers : [                         // Override headers
 *         {
 *             unit       : 'day',
 *             dateFormat : 'DD.MM.YYYY'   // Use different date format for top header 01.10.2020
 *         },
 *         {
 *             unit       : 'hour',
 *             dateFormat : 'LT'
 *         }
 *     ]
 * });
 * ```
 *
 * See {@link Scheduler.preset.PresetManager PresetManager} for the list of base presets. You may add your own
 * presets to this global list:
 *
 * ```javascript
 * PresetManager.add(myViewPreset);     // Adds new preset to the global scope. All newly created scheduler instances will have it too.
 *
 * const scheduler = new Scheduler({
 *     viewPreset : 'myPreset'
 *     // other configs...
 * });
 * ```
 *
 * Or add them on an individual basis to Scheduler instances:
 *
 * ```javascript
 * const scheduler = new Scheduler({...});
 *
 * scheduler.presets.add(myViewPreset); // Adds new preset to the scheduler instance only. All newly created scheduler instances will **not** have it.
 *
 * scheduler.viewPreset = 'myPreset';
 * ```
 *
 * This live demo shows a custom ViewPreset with AM/PM time format:
 * @externalexample scheduler/viewpresets/amPmPreset.js
 * @extends Core/data/Model
 */

var ViewPreset = /*#__PURE__*/function (_Model) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_21___default()(ViewPreset, _Model);

  var _super = _createSuper(ViewPreset);

  function ViewPreset() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, ViewPreset);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(ViewPreset, [{
    key: "construct",
    value: function construct(data) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_20___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_23___default()(ViewPreset.prototype), "construct", this).apply(this, arguments);

      this.normalizeUnits();
    }
  }, {
    key: "generateId",
    value: function generateId(owner) {
      var me = this,
          headers = me.headers,
          parts = []; // If we were subclassed from a base, use that id as the basis of oure.

      var result = Object.getPrototypeOf(me.data).id;

      if (!result) {
        for (var length = headers.length, i = length - 1; i >= 0; i--) {
          parts.push(i ? headers[i].unit : _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].capitalize(headers[i].unit));
        } // Use upwards header units at so eg "monthAndYear"


        result = parts.join('And');
      } // If duplicate, make it "hourAndDay-50by80"


      if (owner.includes(result)) {
        result += "-".concat(me.tickWidth, "by").concat(me.tickHeight || me.tickWidth); // If still duplicate use increment

        if (owner.includes(result)) {
          result += "-".concat(me.bottomHeader.increment); // And if STILL duplicate, make it unique with a suffix

          if (owner.includes(result)) {
            result = _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].generateId("".concat(result, "-"));
          }
        }
      }

      return result;
    }
  }, {
    key: "normalizeUnits",
    value: function normalizeUnits() {
      var me = this,
          timeResolution = me.timeResolution,
          headers = me.headers; // Make sure date "unit" constant specified in the preset are resolved

      for (var i = 0, length = headers.length; i < length; i++) {
        var header = headers[i];
        header.unit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].normalizeUnit(header.unit);

        if (header.splitUnit) {
          header.splitUnit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].normalizeUnit(header.splitUnit);
        }

        if (!('increment' in header)) {
          headers[i] = Object.assign({
            increment: 1
          }, header);
        }
      }

      if (timeResolution) {
        timeResolution.unit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].normalizeUnit(timeResolution.unit);
      }

      if (me.shiftUnit) {
        me.shiftUnit = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].normalizeUnit(me.shiftUnit);
      }
    } // Process legacy columnLines config into a headers array.

  }, {
    key: "set",
    // These are read-only once configured.
    value: function set() {}
  }, {
    key: "inSet",
    value: function inSet() {}
  }, {
    key: "columnLinesFor",
    get: function get() {
      return 'columnLinesFor' in this.data ? this.data.columnLinesFor : this.headers.length - 1;
    }
  }, {
    key: "tickSize",
    get: function get() {
      return this._tickSize || this.tickWidth;
    }
  }, {
    key: "tickWidth",
    get: function get() {
      return 'tickWidth' in this.data ? this.data.tickWidth : 50;
    }
  }, {
    key: "tickHeight",
    get: function get() {
      return 'tickHeight' in this.data ? this.data.tickHeight : 50;
    }
  }, {
    key: "headerConfig",
    get: function get() {
      // Configured in the legacy manner, just return the configured value.
      if (this.data.headerConfig) {
        return this.data.headerConfig;
      } // Rebuild the object based upon the configured headers array.


      var result = {},
          headers = this.headers,
          length = headers.length;

      switch (length) {
        case 1:
          result.middle = headers[0];
          break;

        case 2:
          if (this.mainHeaderLevel === 0) {
            result.middle = headers[0];
            result.bottom = headers[1];
          } else {
            result.top = headers[0];
            result.middle = headers[1];
          }

          break;

        case 3:
          result.top = headers[0];
          result.middle = headers[1];
          result.bottom = headers[2];
          break;

        default:
          throw new Error('headerConfig object not supported for >3 header levels');
      }

      return result;
    }
  }, {
    key: "mainHeaderLevel",
    set: function set(mainHeaderLevel) {
      this.data.mainHeaderLevel = mainHeaderLevel;
    },
    get: function get() {
      if ('mainHeaderLevel' in this.data) {
        return this.data.mainHeaderLevel;
      } // 3 headers, then it's the middle


      if (this.data.headers.length === 3) {
        return 1;
      }

      ; // Assume it goes top, middle.
      // If it's middle, top, use mainHeaderLevel : 0

      return this.headers.length - 1;
    }
  }, {
    key: "mainHeader",
    get: function get() {
      return this.headers[this.mainHeaderLevel];
    }
  }, {
    key: "bottomHeader",
    get: function get() {
      return this.headers[this.headers.length - 1];
    }
  }, {
    key: "leafUnit",
    get: function get() {
      return this.bottomHeader.unit;
    }
  }, {
    key: "mainUnit",
    get: function get() {
      return this.mainHeader;
    }
  }, {
    key: "msPerPixel",
    get: function get() {
      var bottomHeader = this.bottomHeader;
      return Math.round(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].asMilliseconds(bottomHeader.increment || 1, bottomHeader.unit) / this.tickWidth);
    }
  }, {
    key: "isValid",
    get: function get() {
      var me = this;
      var valid = true; // Make sure all date "unit" constants are valid

      var _iterator = _createForOfIteratorHelper(me.headers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var header = _step.value;
          valid = valid && Boolean(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].normalizeUnit(header.unit));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (me.timeResolution) {
        valid = valid && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].normalizeUnit(me.timeResolution.unit);
      }

      if (me.shiftUnit) {
        valid = valid && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].normalizeUnit(me.shiftUnit);
      }

      return valid;
    }
  }], [{
    key: "normalizeHeaderConfig",
    value: function normalizeHeaderConfig(data) {
      var headerConfig = data.headerConfig,
          columnLinesFor = data.columnLinesFor,
          mainHeaderLevel = data.mainHeaderLevel,
          headers = data.headers = [];

      if (headerConfig.top) {
        if (columnLinesFor == 'top') {
          data.columnLinesFor = 0;
        }

        if (mainHeaderLevel == 'top') {
          data.mainHeaderLevel = 0;
        }

        headers[0] = headerConfig.top;
      }

      if (headerConfig.middle) {
        if (columnLinesFor == 'middle') {
          data.columnLinesFor = headers.length;
        }

        if (mainHeaderLevel == 'middle') {
          data.mainHeaderLevel = headers.length;
        }

        headers.push(headerConfig.middle);
      } else {
        throw new Error('ViewPreset.headerConfig must be configured with a middle');
      }

      if (headerConfig.bottom) {
        // Main level is middle when using headerConfig object.
        data.mainHeaderLevel = headers.length - 1; // There *must* be a middle above this bottom header
        // so that is the columnLines one by default.

        if (columnLinesFor == null) {
          data.columnLinesFor = headers.length - 1;
        } else if (columnLinesFor == 'bottom') {
          data.columnLinesFor = headers.length;
        } // There *must* be a middle above this bottom header
        // so that is the main one by default.


        if (mainHeaderLevel == null) {
          data.mainHeaderLevel = headers.length - 1;
        }

        if (mainHeaderLevel == 'bottom') {
          data.mainHeaderLevel = headers.length;
        }

        headers.push(headerConfig.bottom);
      }
    }
  }, {
    key: "fields",
    get: function get() {
      return [
      /**
       * The name of the view preset
       * @field {String} name
       */
      {
        name: 'name',
        type: 'string'
      },
      /**
       * The height of the row in horizontal orientation
       * @field {Number} rowHeight
       * @default
       */
      {
        name: 'rowHeight',
        defaultValue: 24
      },
      /**
       * The width of the time tick column in horizontal orientation
       * @field {Number} tickWidth
       * @default
       */
      {
        name: 'tickWidth',
        defaultValue: 50
      },
      /**
       * The height of the time tick column in vertical orientation
       * @field {Number} tickHeight
       * @default
       */
      {
        name: 'tickHeight',
        defaultValue: 50
      },
      /**
       * Defines how dates will be formatted in tooltips etc
       * @field {String} displayDateFormat
       * @default
       */
      {
        name: 'displayDateFormat',
        defaultValue: 'HH:mm'
      },
      /**
       * The unit to shift when calling shiftNext/shiftPrevious to navigate in the chart.
       * Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
       * @field {String} shiftUnit
       * @default
       */
      {
        name: 'shiftUnit',
        defaultValue: 'hour'
      },
      /**
       * The amount to shift (in shiftUnits)
       * @field {Number} shiftIncrement
       * @default
       */
      {
        name: 'shiftIncrement',
        defaultValue: 1
      },
      /**
       * The amount of time to show by default in a view (in the unit defined by the middle header)
       * @field {Number} defaultSpan
       * @default
       */
      {
        name: 'defaultSpan',
        defaultValue: 12
      },
      /**
       * An object containing a unit identifier and an increment variable. This value means minimal task duration you can create using UI.
       * For example when you drag create a task or drag & drop a task, if increment is 5 and unit is 'minute'
       * that means that you can create a 5 min long task, or move it 5 min forward/backward. This config maps to
       * scheduler's {@link Scheduler.view.mixin.TimelineDateMapper#property-timeResolution timeResolution} config.
       *
       * ```javascript
       * timeResolution : {
       *   unit      : 'minute',  //Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
       *   increment : 5
       * }
       * ```
       *
       * @field {Object} timeResolution
       */
      'timeResolution',
      /**
       * An array containing one or more {@link Scheduler.preset.ViewPresetHeaderRow} config objects, each of which defines a level of headers for the scheduler.
       * The 'main' unit will be the last header's unit, but this can be changed using the `mainHeaderLevel` field.
       * @field {Object} headers
       */
      'headers',
      /**
       * Defines which {@link #field-headers header} level defines the 'main' header. Defaults to the bottom header.
       * @field {Number} mainHeaderLevel
       */
      'mainHeaderLevel',
      /**
       * Defines which {@link #field-headers header} level the column lines will be drawn for. See {@link Scheduler.feature.ColumnLines}.
       * Defaults to the bottom header.
       * @field {Number} columnLinesFor
       */
      'columnLinesFor'];
    }
  }]);

  return ViewPreset;
}(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_24__["default"]);


ViewPreset._$name = 'ViewPreset';

/***/ }),

/***/ "./lib/Scheduler/tooltip/ClockTemplate.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/tooltip/ClockTemplate.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ClockTemplate; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

 //import styles from '../../../resources/sass/tooltip/clocktemplate.scss';

/**
 * @module Scheduler/tooltip/ClockTemplate
 */

/**
 * A template showing a clock, it consumes an object containing a date and a text
 * @private
 */

var ClockTemplate = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ClockTemplate, _Base);

  var _super = _createSuper(ClockTemplate);

  function ClockTemplate() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ClockTemplate);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ClockTemplate, [{
    key: "generateContent",
    value: function generateContent(data) {
      var me = this,
          date = data.date,
          html = me.template(data),
          div = me.div;
      div.innerHTML = html;
      me.updateDateIndicator(div, date);
      return div.innerHTML;
    }
  }, {
    key: "updateDateIndicator",
    value: function updateDateIndicator(el, date) {
      var hourIndicatorEl = el.querySelector('.b-sch-hour-indicator'),
          minuteIndicatorEl = el.querySelector('.b-sch-minute-indicator');

      if (date && hourIndicatorEl && minuteIndicatorEl) {
        if (this.mode === 'hour') {
          hourIndicatorEl.style.transform = "rotate(".concat(date.getHours() % 12 * 30, "deg)");
          minuteIndicatorEl.style.transform = "rotate(".concat(date.getMinutes() * 6, "deg)");
        } else {
          hourIndicatorEl.style.transform = 'none';
          minuteIndicatorEl.style.transform = 'none';
        }
      }
    }
  }, {
    key: "mode",
    set: function set(mode) {
      this._mode = mode;
    } // `day` mode for calendar icon
    // `hour` mode for clock icon
    ,
    get: function get() {
      if (this._mode) {
        return this._mode;
      }

      var unitLessThanDay = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].compareUnits(this.scheduler.timeAxisViewModel.timeResolution.unit, 'day') < 0,
          formatContainsHourInfo = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].formatContainsHourInfo(this.scheduler.displayDateFormat);
      return unitLessThanDay && formatContainsHourInfo ? 'hour' : 'day';
    }
  }, {
    key: "template",
    set: function set(template) {
      this._template = template;
    }
    /**
     * Get the clock template, which accepts an object of format { date, text }
     * @returns {function(*): string}
     */
    ,
    get: function get() {
      return this._template;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        minuteHeight: 8,
        minuteTop: 2,
        hourHeight: 8,
        hourTop: 2,
        handLeft: 10,
        div: document.createElement('div'),
        scheduler: null,
        // may be passed to the constructor if needed
        // `b-sch-clock-day` for calendar icon
        // `b-sch-clock-hour` for clock icon
        template: function template(data) {
          return "<div class=\"b-sch-clockwrap b-sch-clock-".concat(data.mode || this.mode, " ").concat(data.cls || '', "\">\n                    <div class=\"b-sch-clock\">\n                        <div class=\"b-sch-hour-indicator\">").concat(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(data.date, 'MMM'), "</div>\n                        <div class=\"b-sch-minute-indicator\">").concat(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(data.date, 'D'), "</div>\n                        <div class=\"b-sch-clock-dot\"></div>\n                    </div>\n                    <span class=\"b-sch-clock-text\">").concat(data.text, "</span>\n                </div>");
        }
      };
    }
  }]);

  return ClockTemplate;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


ClockTemplate._$name = 'ClockTemplate';

/***/ }),

/***/ "./lib/Scheduler/util/RectangularPathFinder.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/util/RectangularPathFinder.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RectangularPathFinder; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../Core/helper/WalkHelper.js */ "./lib/Core/helper/WalkHelper.js");




































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_34___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_33___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/util/RectangularPathFinder
 */

/**
 * Class which finds rectangular path, i.e. path with 90 degrees turns, between two boxes.
 * @private
 */

var RectangularPathFinder = /*#__PURE__*/function (_Base) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_32___default()(RectangularPathFinder, _Base);

  var _super = _createSuper(RectangularPathFinder);

  function RectangularPathFinder() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_30___default()(this, RectangularPathFinder);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_31___default()(RectangularPathFinder, [{
    key: "findPath",

    /**
     * Returns list of horizontal and vertical segments connecting two boxes
     * <pre>
     *    |    | |  |    |       |
     *  --+----+----+----*-------*---
     *  --+=>Start  +----*-------*--
     *  --+----+----+----*-------*--
     *    |    | |  |    |       |
     *    |    | |  |    |       |
     *  --*----*-+-------+-------+--
     *  --*----*-+         End <=+--
     *  --*----*-+-------+-------+--
     *    |    | |  |    |       |
     * </pre>
     * Path goes by lines (-=) and turns at intersections (+), boxes depicted are adjusted by horizontal/vertical
     * margin and arrow margin, original boxes are smaller (path can't go at original box borders). Algorithm finds
     * the shortest path with minimum amount of turns. In short it's mix of "Lee" and "Dijkstra pathfinding"
     * with turns amount taken into account for distance calculation.
     *
     * The algorithm is not very performant though, it's O(N^2), where N is amount of
     * points in the grid, but since the maximum amount of points in the grid might be up to 34 (not 36 since
     * two box middle points are not permitted) that might be ok for now.
     *
     * @param {Object} lineDef An object containing any of the class configuration option overrides as well
     *                         as `startBox`, `endBox`, `startHorizontalMargin`, `startVerticalMargin`,
     *                         `endHorizontalMargin`, `endVerticalMargin` properties
     * @param {Object} lineDef.startBox An object containing `start`, `end`, `top`, `bottom` properties
     * @param {Object} lineDef.endBox   An object containing `start`, `end`, `top`, `bottom` properties
     * @param {Number} lineDef.startHorizontalMargin Horizontal margin override for start box
     * @param {Number} lineDef.startVerticalMargin   Vertical margin override for start box
     * @param {Number} lineDef.endHorizontalMargin   Horizontal margin override for end box
     * @param {Number} lineDef.endVerticalMargin     Vertical margin override for end box
     *
     *
     * @return {Object[]|Boolean} Array of line segments or false if path cannot be found
     * @return {Number} return.x1
     * @return {Number} return.y1
     * @return {Number} return.x2
     * @return {Number} return.y2
     */
    //
    //@ignore
    //@privateparam {Function[]|Function} noPathFallbackFn
    //     A function or array of functions which will be tried in case a path can't be found
    //     Each function will be given a line definition it might try to adjust somehow and return.
    //     The new line definition returned will be tried to find a path.
    //     If a function returns false, then next function will be called if any.
    //
    value: function findPath(lineDef, noPathFallbackFn) {
      var me = this,
          lineDefFull,
          startBox,
          endBox,
          startShift,
          endShift,
          startSide,
          endSide,
          startArrowSize,
          endArrowSize,
          startArrowMargin,
          endArrowMargin,
          horizontalMargin,
          verticalMargin,
          startHorizontalMargin,
          startVerticalMargin,
          endHorizontalMargin,
          endVerticalMargin,
          otherHorizontalMargin,
          otherVerticalMargin,
          otherBoxes,
          connStartPoint,
          connEndPoint,
          pathStartPoint,
          pathEndPoint,
          gridStartPoint,
          gridEndPoint,
          startGridBox,
          endGridBox,
          grid,
          path,
          tryNum;

      if (noPathFallbackFn && !Array.isArray(noPathFallbackFn)) {
        noPathFallbackFn = [noPathFallbackFn];
      }

      for (tryNum = 0; lineDef && !path;) {
        lineDefFull = Object.assign(me.config, lineDef);
        startBox = lineDefFull.startBox;
        endBox = lineDefFull.endBox;
        startShift = lineDefFull.startShift;
        endShift = lineDefFull.endShift;
        startSide = lineDefFull.startSide;
        endSide = lineDefFull.endSide;
        startArrowSize = lineDefFull.startArrowSize;
        endArrowSize = lineDefFull.endArrowSize;
        startArrowMargin = lineDefFull.startArrowMargin;
        endArrowMargin = lineDefFull.endArrowMargin;
        horizontalMargin = lineDefFull.horizontalMargin;
        verticalMargin = lineDefFull.verticalMargin;
        startHorizontalMargin = lineDefFull.hasOwnProperty('startHorizontalMargin') ? lineDefFull.startHorizontalMargin : horizontalMargin;
        startVerticalMargin = lineDefFull.hasOwnProperty('startVerticalMargin') ? lineDefFull.startVerticalMargin : verticalMargin;
        endHorizontalMargin = lineDefFull.hasOwnProperty('endHorizontalMargin') ? lineDefFull.endHorizontalMargin : horizontalMargin;
        endVerticalMargin = lineDefFull.hasOwnProperty('endVerticalMargin') ? lineDefFull.endVerticalMargin : verticalMargin;
        otherHorizontalMargin = lineDefFull.hasOwnProperty('otherHorizontalMargin') ? lineDefFull.otherHorizontalMargin : horizontalMargin;
        otherVerticalMargin = lineDefFull.hasOwnProperty('otherVerticalMargin') ? lineDefFull.otherVerticalMargin : verticalMargin;
        otherBoxes = lineDefFull.otherBoxes;
        startSide = me.normalizeSide(startSide);
        endSide = me.normalizeSide(endSide);
        connStartPoint = me.getConnectionCoordinatesFromBoxSideShift(startBox, startSide, startShift);
        connEndPoint = me.getConnectionCoordinatesFromBoxSideShift(endBox, endSide, endShift);
        startGridBox = me.calcGridBaseBoxFromBoxAndDrawParams(startBox, startSide, startArrowSize, startArrowMargin, startHorizontalMargin, startVerticalMargin);
        endGridBox = me.calcGridBaseBoxFromBoxAndDrawParams(endBox, endSide, endArrowSize, endArrowMargin, endHorizontalMargin, endVerticalMargin);
        otherBoxes = otherBoxes && otherBoxes.map(function (box) {
          return me.calcGridBaseBoxFromBoxAndDrawParams(box, false, 0, 0, otherHorizontalMargin, otherVerticalMargin);
        });
        pathStartPoint = me.getConnectionCoordinatesFromBoxSideShift(startGridBox, startSide, startShift);
        pathEndPoint = me.getConnectionCoordinatesFromBoxSideShift(endGridBox, endSide, endShift);
        grid = me.buildPathGrid(startGridBox, endGridBox, pathStartPoint, pathEndPoint, startSide, endSide, otherBoxes);
        gridStartPoint = me.convertDecartPointToGridPoint(grid, pathStartPoint);
        gridEndPoint = me.convertDecartPointToGridPoint(grid, pathEndPoint);
        path = me.findPathOnGrid(grid, gridStartPoint, gridEndPoint, startSide, endSide); // Loop if
        // - path is still not found
        // - have no next line definition (which should be obtained from call to one of the functions from noPathFallbackFn array
        // - have noPathFallBackFn array
        // - current try number is less then noPathFallBackFn array length

        for (lineDef = false; !path && !lineDef && noPathFallbackFn && tryNum < noPathFallbackFn.length; tryNum++) {
          lineDef = noPathFallbackFn[tryNum](lineDefFull);
        }
      }

      if (path) {
        path = me.prependPathWithArrowStaffSegment(path, connStartPoint, startArrowSize, startSide);
        path = me.appendPathWithArrowStaffSegment(path, connEndPoint, endArrowSize, endSide);
        path = me.optimizePath(path);
      }

      return path;
    }
  }, {
    key: "getConnectionCoordinatesFromBoxSideShift",
    value: function getConnectionCoordinatesFromBoxSideShift(box, side, shift) {
      var coords;

      switch (side) {
        case 'left':
          coords = {
            x: box.start,
            y: (box.top + box.bottom) / 2 + shift
          };
          break;

        case 'right':
          coords = {
            x: box.end,
            y: (box.top + box.bottom) / 2 + shift
          };
          break;

        case 'top':
          coords = {
            x: (box.start + box.end) / 2 + shift,
            y: box.top
          };
          break;

        case 'bottom':
          coords = {
            x: (box.start + box.end) / 2 + shift,
            y: box.bottom
          };
          break;
      }

      return coords;
    }
  }, {
    key: "calcGridBaseBoxFromBoxAndDrawParams",
    value: function calcGridBaseBoxFromBoxAndDrawParams(box, side, arrowSize, arrowMargin, horizontalMargin, verticalMargin) {
      var gridBox;

      switch (side) {
        case 'left':
          gridBox = {
            start: box.start - Math.max(arrowSize + arrowMargin, horizontalMargin),
            end: box.end + horizontalMargin,
            top: box.top - verticalMargin,
            bottom: box.bottom + verticalMargin
          };
          break;

        case 'right':
          gridBox = {
            start: box.start - horizontalMargin,
            end: box.end + Math.max(arrowSize + arrowMargin, horizontalMargin),
            top: box.top - verticalMargin,
            bottom: box.bottom + verticalMargin
          };
          break;

        case 'top':
          gridBox = {
            start: box.start - horizontalMargin,
            end: box.end + horizontalMargin,
            top: box.top - Math.max(arrowSize + arrowMargin, verticalMargin),
            bottom: box.bottom + verticalMargin
          };
          break;

        case 'bottom':
          gridBox = {
            start: box.start - horizontalMargin,
            end: box.end + horizontalMargin,
            top: box.top - verticalMargin,
            bottom: box.bottom + Math.max(arrowSize + arrowMargin, verticalMargin)
          };
          break;

        default:
          gridBox = {
            start: box.start - horizontalMargin,
            end: box.end + horizontalMargin,
            top: box.top - verticalMargin,
            bottom: box.bottom + verticalMargin
          };
      }

      return gridBox;
    }
  }, {
    key: "buildPathGrid",
    value: function buildPathGrid(startGridBox, endGridBox, pathStartPoint, pathEndPoint, startSide, endSide, otherGridBoxes) {
      var xs,
          ys,
          y,
          x,
          ix,
          iy,
          xslen,
          yslen,
          ib,
          blen,
          box,
          permitted,
          point,
          points = {},
          linearPoints = [];
      xs = [startGridBox.start, startSide === 'left' || startSide === 'right' ? (startGridBox.start + startGridBox.end) / 2 : pathStartPoint.x, startGridBox.end, endGridBox.start, endSide === 'left' || endSide === 'right' ? (endGridBox.start + endGridBox.end) / 2 : pathEndPoint.x, endGridBox.end];
      ys = [startGridBox.top, startSide === 'top' || startSide === 'bottom' ? (startGridBox.top + startGridBox.bottom) / 2 : pathStartPoint.y, startGridBox.bottom, endGridBox.top, endSide === 'top' || endSide === 'bottom' ? (endGridBox.top + endGridBox.bottom) / 2 : pathEndPoint.y, endGridBox.bottom];

      if (otherGridBoxes) {
        otherGridBoxes.forEach(function (box) {
          xs.push(box.start, (box.start + box.end) / 2, box.end);
          ys.push(box.top, (box.top + box.bottom) / 2, box.bottom);
        });
      }

      xs = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_29___default()(new Set(xs.sort(function (a, b) {
        return a - b;
      })));
      ys = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_29___default()(new Set(ys.sort(function (a, b) {
        return a - b;
      }))); // TODO: fastest way to make unique, Set is slower
      // for ( let i = 0, I = array.length; i < I; i++ ) {
      //     if ( ~array.indexOf( array[ i ], i + 1 ) ) {
      //         array.splice( i, 1 );
      //         i--;
      //         I--;
      //     }
      // }

      for (iy = 0, yslen = ys.length; iy < yslen; ++iy) {
        points[iy] = points[iy] || {};
        y = ys[iy];

        for (ix = 0, xslen = xs.length; ix < xslen; ++ix) {
          x = xs[ix];
          permitted = (x <= startGridBox.start || x >= startGridBox.end || y <= startGridBox.top || y >= startGridBox.bottom) && (x <= endGridBox.start || x >= endGridBox.end || y <= endGridBox.top || y >= endGridBox.bottom);

          if (otherGridBoxes) {
            for (ib = 0, blen = otherGridBoxes.length; permitted && ib < blen; ++ib) {
              box = otherGridBoxes[ib];
              permitted = x <= box.start || x >= box.end || y <= box.top || y >= box.bottom || // Allow point if it is a path start/end even if point is inside any box
              x === pathStartPoint.x && y === pathStartPoint.y || x === pathEndPoint.x && y === pathEndPoint.y;
            }
          }

          point = {
            distance: Math.pow(2, 53) - 1,
            // Number.MAX_SAFE_INTEGER (not supported in Opera/IE)
            permitted: permitted,
            x: x,
            y: y,
            ix: ix,
            iy: iy
          };
          points[iy][ix] = point;
          linearPoints.push(point);
        }
      }

      return {
        width: xs.length,
        height: ys.length,
        xs: xs,
        ys: ys,
        points: points,
        linearPoints: linearPoints
      };
    }
  }, {
    key: "convertDecartPointToGridPoint",
    value: function convertDecartPointToGridPoint(grid, point) {
      var x = grid.xs.indexOf(point.x),
          y = grid.ys.indexOf(point.y);
      return grid.points[y][x];
    }
  }, {
    key: "findPathOnGrid",
    value: function findPathOnGrid(grid, gridStartPoint, gridEndPoint, startSide, endSide) {
      var me = this,
          path = false;

      if (gridStartPoint.permitted && gridEndPoint.permitted) {
        grid = me.waveForward(grid, gridStartPoint, 0);
        path = me.collectPath(grid, gridEndPoint, endSide);
      }

      return path;
    } // Returns neighbors from Von Neiman ambit (see Lee pathfinding algorithm description)

  }, {
    key: "getGridPointNeighbors",
    value: function getGridPointNeighbors(grid, gridPoint, predicateFn) {
      var ix = gridPoint.ix,
          iy = gridPoint.iy,
          result = [],
          neighbor; // NOTE:
      // It's important to push bottom neighbors first since this method is used
      // in collectPath(), which reversively collects path from end to start node
      // and if bottom neighbors are pushed first in result array then collectPath()
      // will produce a line which is more suitable (pleasant looking) for our purposes.

      if (iy < grid.height - 1) {
        neighbor = grid.points[iy + 1][ix];
        (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
      }

      if (iy > 0) {
        neighbor = grid.points[iy - 1][ix];
        (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
      }

      if (ix < grid.width - 1) {
        neighbor = grid.points[iy][ix + 1];
        (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
      }

      if (ix > 0) {
        neighbor = grid.points[iy][ix - 1];
        (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
      }

      return result;
    }
  }, {
    key: "waveForward",
    value: function waveForward(grid, gridStartPoint, distance) {
      var me = this; // I use the WalkHelper here because a point on a grid and it's neighbors might be considered as a hierarchy.
      // The point is the parent node, and it's neighbors are the children nodes. Thus the grid here is hierarchical
      // data structure which can be walked. WalkHelper walks non-recursivelly which is exactly what I need as well.

      _Core_helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"].preWalkUnordered( // Walk starting point - a node is a grid point and it's distance from the starting point
      [gridStartPoint, distance], // Children query function
      // NOTE: It's important to fix neighbor distance first, before waving to a neighbor, otherwise waving might
      //       get through a neighbor point setting it's distance to a value more then (distance + 1) whereas we,
      //       at the children quering moment in time, already know that the possibly optimal distance is (distance + 1)
      function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default()(_ref, 2),
            point = _ref2[0],
            distance = _ref2[1];

        return me.getGridPointNeighbors(grid, point, function (neighborPoint) {
          return neighborPoint.permitted && neighborPoint.distance > distance + 1;
        }).map(function (neighborPoint) {
          return [neighborPoint, distance + 1];
        } // Neighbor distance fixation
        );
      }, // Walk step iterator function
      function (_ref3) {
        var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_28___default()(_ref3, 2),
            point = _ref4[0],
            distance = _ref4[1];

        return point.distance = distance;
      } // Neighbor distance applying
      );
      return grid;
    }
  }, {
    key: "collectPath",
    value: function collectPath(grid, gridEndPoint, endSide) {
      var me = this,
          pathFound = true,
          neighbors,
          lowestDistanceNeighbor,
          xDiff,
          yDiff,
          path = [];

      while (pathFound && gridEndPoint.distance) {
        neighbors = me.getGridPointNeighbors(grid, gridEndPoint, function (point) {
          return point.permitted && point.distance == gridEndPoint.distance - 1;
        });
        pathFound = neighbors.length > 0;

        if (pathFound) {
          // Prefer turnless neighbors first
          neighbors = neighbors.sort(function (a, b) {
            var xDiff, yDiff;
            xDiff = a.ix - gridEndPoint.ix;
            yDiff = a.iy - gridEndPoint.iy;
            var resultA = (endSide === 'left' || endSide === 'right') && yDiff === 0 || (endSide === 'top' || endSide === 'bottom') && xDiff === 0 ? -1 : 1;
            xDiff = b.ix - gridEndPoint.ix;
            yDiff = b.iy - gridEndPoint.iy;
            var resultB = (endSide === 'left' || endSide === 'right') && yDiff === 0 || (endSide === 'top' || endSide === 'bottom') && xDiff === 0 ? -1 : 1;
            if (resultA > resultB) return 1;
            if (resultA < resultB) return -1; // apply additional sorting to be sure to pick bottom path in IE

            if (resultA === resultB) return a.y > b.y ? -1 : 1;
          });
          lowestDistanceNeighbor = neighbors[0];
          path.push({
            x1: lowestDistanceNeighbor.x,
            y1: lowestDistanceNeighbor.y,
            x2: gridEndPoint.x,
            y2: gridEndPoint.y
          }); // Detecting new side, either xDiff or yDiff must be 0 (but not both)

          xDiff = lowestDistanceNeighbor.ix - gridEndPoint.ix;
          yDiff = lowestDistanceNeighbor.iy - gridEndPoint.iy;

          switch (true) {
            case !yDiff && xDiff > 0:
              endSide = 'left';
              break;

            case !yDiff && xDiff < 0:
              endSide = 'right';
              break;

            case !xDiff && yDiff > 0:
              endSide = 'top';
              break;

            case !xDiff && yDiff < 0:
              endSide = 'bottom';
              break;
          }

          gridEndPoint = lowestDistanceNeighbor;
        }
      }

      return pathFound && path.reverse() || false;
    }
  }, {
    key: "prependPathWithArrowStaffSegment",
    value: function prependPathWithArrowStaffSegment(path, connStartPoint, startArrowSize, startSide) {
      var prependSegment, firstSegment;

      if (path.length > 0) {
        firstSegment = path[0];
        prependSegment = {
          x2: firstSegment.x1,
          y2: firstSegment.y1
        };

        switch (startSide) {
          case 'left':
            prependSegment.x1 = connStartPoint.x - startArrowSize;
            prependSegment.y1 = firstSegment.y1;
            break;

          case 'right':
            prependSegment.x1 = connStartPoint.x + startArrowSize;
            prependSegment.y1 = firstSegment.y1;
            break;

          case 'top':
            prependSegment.x1 = firstSegment.x1;
            prependSegment.y1 = connStartPoint.y - startArrowSize;
            break;

          case 'bottom':
            prependSegment.x1 = firstSegment.x1;
            prependSegment.y1 = connStartPoint.y + startArrowSize;
            break;
        }

        path.unshift(prependSegment);
      }

      return path;
    }
  }, {
    key: "appendPathWithArrowStaffSegment",
    value: function appendPathWithArrowStaffSegment(path, connEndPoint, endArrowSize, endSide) {
      var appendSegment, lastSegment;

      if (path.length > 0) {
        lastSegment = path[path.length - 1];
        appendSegment = {
          x1: lastSegment.x2,
          y1: lastSegment.y2
        };

        switch (endSide) {
          case 'left':
            appendSegment.x2 = connEndPoint.x - endArrowSize;
            appendSegment.y2 = lastSegment.y2;
            break;

          case 'right':
            appendSegment.x2 = connEndPoint.x + endArrowSize;
            appendSegment.y2 = lastSegment.y2;
            break;

          case 'top':
            appendSegment.x2 = lastSegment.x2;
            appendSegment.y2 = connEndPoint.y - endArrowSize;
            break;

          case 'bottom':
            appendSegment.x2 = lastSegment.x2;
            appendSegment.y2 = connEndPoint.y + endArrowSize;
            break;
        }

        path.push(appendSegment);
      }

      return path;
    }
  }, {
    key: "optimizePath",
    value: function optimizePath(path) {
      var optPath = [],
          prevSegment,
          curSegment;

      if (path.length > 0) {
        prevSegment = path.shift();
        optPath.push(prevSegment);

        while (path.length > 0) {
          curSegment = path.shift(); // both segments are equal

          if (prevSegment.x1 == curSegment.x1 && prevSegment.y1 == curSegment.y1 && prevSegment.x2 == curSegment.x2 && prevSegment.y2 == curSegment.y2) {
            prevSegment = curSegment;
          } // both segments are horizontal
          else if (prevSegment.y1 - prevSegment.y2 === 0 && curSegment.y1 - curSegment.y2 === 0) {
              prevSegment.x2 = curSegment.x2;
            } // both segments are vertical
            else if (prevSegment.x1 - prevSegment.x2 === 0 && curSegment.x1 - curSegment.x2 === 0) {
                prevSegment.y2 = curSegment.y2;
              } // segments has different orientation (path turn)
              else {
                  optPath.push(curSegment);
                  prevSegment = curSegment;
                }
        }
      }

      return optPath;
    }
  }, {
    key: "normalizeSide",
    value: function normalizeSide(side) {
      return RectangularPathFinder.sideToSide[side] || side;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Default start connection side: 'left', 'right', 'top', 'bottom'
         * @config {String|Boolean}
         * @default
         */
        startSide: 'right',

        /**
         * Default start arrow size in pixels
         * @config {Number}
         * @default
         */
        startArrowSize: 0,

        /**
         * Default start arrow staff size in pixels
         * @config {Number}
         * @default
         */
        startArrowMargin: 12,

        /**
         * Default starting connection point shift from box's arrow pointing side middle point
         * @config {Number}
         * @default
         */
        startShift: 0,

        /**
         * Default end arrow pointing direction, possible values are: 'left', 'right', 'top', 'bottom'
         * @config {String|Boolean}
         * @default
         */
        endSide: 'left',

        /**
         * Default end arrow size in pixels
         * @config {Number}
         * @default
         */
        endArrowSize: 0,

        /**
         * Default end arrow staff size in pixels
         * @config {Number}
         * @default
         */
        endArrowMargin: 12,

        /**
         * Default ending connection point shift from box's arrow pointing side middle point
         * @config {Number}
         * @default
         */
        endShift: 0,

        /**
         * Start / End box vertical margin, the amount of pixels from top and bottom line of a box where drawing
         * is prohibited
         * @config {Number}
         * @default
         */
        verticalMargin: 2,

        /**
         * Start / End box horizontal margin, the amount of pixels from left and right line of a box where drawing
         * @config {Number}
         * @default
         */
        horizontalMargin: 5,

        /**
         * Other rectangular areas (obstacles) to search path through
         * @config {Object[]}
         * @default
         */
        otherBoxes: null
      };
    }
  }, {
    key: "sideToSide",
    get: function get() {
      return {
        l: 'left',
        r: 'right',
        t: 'top',
        b: 'bottom'
      };
    }
  }]);

  return RectangularPathFinder;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_35__["default"]);


RectangularPathFinder._$name = 'RectangularPathFinder';

/***/ }),

/***/ "./lib/Scheduler/util/ScheduleTableExporter.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/util/ScheduleTableExporter.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleTableExporter; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.fill */ "./node_modules/core-js/modules/es.array.fill.js");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _Grid_util_TableExporter_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Grid/util/TableExporter.js */ "./lib/Grid/util/TableExporter.js");
/* harmony import */ var _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../view/SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");

















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/util/ScheduleTableExporter
 */

/**
 * This class transforms scheduler component into two arrays: rows and columns. Columns array contains objects with
 * meta information about column: field name, column name, width and type of the rendered value, rows array contains
 * arrays of cell values.
 *
 * ```javascript
 * const exporter = new ScheduleTableExporter({ target : scheduler });
 * exporter.export()
 *
 * // Output
 * {
 *     columns : [
 *         { field : 'name',      value : 'First name', type : 'string',  width : 100 },
 *         { field : 'name',      value : 'Task',       type : 'string',  width : 100, eventColumn : true },
 *         { field : 'startDate', value : 'Starts',     type : 'date',    width : 100, eventColumn : true },
 *         { field : 'endDate',   value : 'Ends',       type : 'date',    width : 100, eventColumn : true }
 *     ],
 *     rows : [
 *         ['Michael', 'Hand out dundies',      Date, Date],
 *         ['Michael', 'Buy condo',             Date, Date],
 *         ['Jim',     'Close sale to library', Date, Date]
 *     ]
 * }
 * ```
 *
 * ## How data is exported
 *
 * Data is exported as in the base class with minor addition: every event is exported on a separate row, like
 * demonstrated above.
 *
 * In case there are unassigned events, by default they will be exported as well
 *
 * ```javascript
 * // output
 * {
 *     rows : [
 *         ['Michael', 'Hand out dundies',      Date, Date],
 *         ['Michael', 'Buy condo',             Date, Date],
 *         ['Jim',     'Close sale to library', Date, Date],
 *         ['',        'No resource assigned'],
 *         ['',        'Halloween prep',        Date, Date],
 *         ['',        'New year prep',         Date, Date]
 *     ]
 * }
 * ```
 *
 * @extends Grid/util/TableExporter
 * @mixes Core/localization/Localizable
 */

var ScheduleTableExporter = /*#__PURE__*/function (_Localizable) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ScheduleTableExporter, _Localizable);

  var _super = _createSuper(ScheduleTableExporter);

  function ScheduleTableExporter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, ScheduleTableExporter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(ScheduleTableExporter, [{
    key: "construct",
    value: function construct() {
      var _get2;

      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ScheduleTableExporter.prototype), "construct", this)).call.apply(_get2, [this, config].concat(args));

      if (!this.eventSortFn) {
        this.eventSortFn = function (a, b) {
          return a.internalId - b.internalId;
        };
      }
    }
  }, {
    key: "normalizeColumns",
    value: function normalizeColumns(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ScheduleTableExporter.prototype), "normalizeColumns", this).call(this, config);

      config.eventColumns = config.eventColumns.map(function (col) {
        if (typeof col === 'string') {
          return {
            field: col
          };
        } else {
          return col;
        }
      });
    }
  }, {
    key: "generateExportData",
    value: function generateExportData(config) {
      var me = this,
          isScheduler = this.target instanceof _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_18__["default"],
          resourceColumns = me.generateColumns(config),
          eventColumns = isScheduler ? me.generateEventColumns(config) : [],
          columns = resourceColumns.concat(eventColumns),
          rows = me.generateRows(config);
      return {
        columns: columns,
        rows: rows
      };
    }
  }, {
    key: "generateEventColumns",
    value: function generateEventColumns(config) {
      var _this = this;

      return config.eventColumns.map(function (column) {
        return _this.processEventColumn(column, config);
      });
    }
  }, {
    key: "processEventColumn",
    value: function processEventColumn(column, config) {
      var width = column.width,
          minWidth = column.minWidth,
          defaultColumnWidth = config.defaultColumnWidth;
      return {
        field: column.field,
        value: column.text,
        width: Math.max(width || defaultColumnWidth, minWidth || defaultColumnWidth),
        eventColumn: true,
        type: this.getColumnType(column, this.target.eventStore)
      };
    }
  }, {
    key: "generateRows",
    value: function generateRows(config) {
      var me = this,
          target = me.target;
      var result;

      if (!(target instanceof _view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_18__["default"])) {
        result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(ScheduleTableExporter.prototype), "generateRows", this).call(this, config);
      } else {
        result = []; // forEach skips group records, summary records etc

        target.resourceStore.map(function (resourceRecord) {
          // Get all events for resource (including assignment store)
          var events = resourceRecord.events || []; // Events order is not guaranteed, sort by internalId, that is guaranteed to grow with every new record

          events.sort(me.eventSortFn); // Set dummy event to have resource info printed without events

          if (!events.length) {
            events.push('');
          }

          events.forEach(function (eventRecord) {
            return result.push(me.getRowData(config, resourceRecord, eventRecord));
          });
        });

        if (config.includeUnassigned && config.eventColumns.length) {
          var notAssignedEvents = target.eventStore.query(function (eventRecord) {
            return !eventRecord.resources.length;
          });

          if (notAssignedEvents.length) {
            // Use offset to match first event column
            var cells = new Array(config.columns.length).fill('');
            cells.push(me.L('L{ExcelExporter.No resource assigned}'));
            result.push(cells); // Set dummy resource to have event info printed without resource

            notAssignedEvents.forEach(function (eventRecord) {
              return result.push(me.getRowData(config, null, eventRecord));
            });
          }
        } // filter out empty rows


        result = result.filter(function (cells) {
          return cells.length;
        });
      }

      return result;
    }
  }, {
    key: "getRowData",
    value: function getRowData(config, resource, event) {
      var columns = config.columns,
          eventColumns = config.eventColumns,
          cells = [],
          resourceCells = this.processRecord(resource, columns, config); // No cells from group footers (or from group headers if configured to not show them)

      resourceCells && cells.push.apply(cells, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9___default()(resourceCells));

      if (!resource || !resource.isSpecialRow) {
        var eventCells = this.processRecord(event, eventColumns, config); // No cells from group footers (or from group headers if configured to not show them)

        eventCells && cells.push.apply(cells, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_9___default()(eventCells));
      }

      return cells;
    }
  }], [{
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Set to `false` to not include unassigned events in the export. `true` by default.
         * @config {Boolean} includeUnassigned
         * @default
         */
        includeUnassigned: true,

        /**
         * An array of Event columns configuration used to specify columns width, headers name, and column fields to get the data from.
         * 'field' config is required. If 'text' is missing, the 'field' config will be used instead.
         *
         * For example:
         * ```javascript
         * eventColumns    : [
         *     { text : 'Task', field : 'name' },
         *     { text : 'Starts', field : 'startDate', width : 140 },
         *     { text : 'Ends', field : 'endDate', width : 140 }
         * ]
         * ```
         *
         * @config {String[]|Object[]} eventColumns
         * @default
         */
        eventColumns: [{
          text: 'Task',
          field: 'name'
        }, {
          text: 'Starts',
          field: 'startDate',
          width: 140
        }, {
          text: 'Ends',
          field: 'endDate',
          width: 140
        }],

        /**
         * Function to sort events for each resource. By default events are sorted in the order of appending to the
         * store.
         * For example:
         * ```javascript
         * // Sorting by start date
         * eventSortFn : (a, b) => a.startDate - b.startDate
         * ```
         * @config {Function}
         * @internal
         */
        eventSortFn: null
      };
    }
  }]);

  return ScheduleTableExporter;
}(Object(_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_16__["default"])(_Grid_util_TableExporter_js__WEBPACK_IMPORTED_MODULE_17__["default"]));


ScheduleTableExporter._$name = 'ScheduleTableExporter';

/***/ }),

/***/ "./lib/Scheduler/view/DependencyEditor.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/view/DependencyEditor.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyEditor; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/DependencyEditor
 */

/**
 * A dependency editor popup.
 *
 * @extends Core/widget/Popup
 * @private
 */

var DependencyEditor = /*#__PURE__*/function (_Popup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(DependencyEditor, _Popup);

  var _super = _createSuper(DependencyEditor);

  function DependencyEditor() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, DependencyEditor);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(DependencyEditor, [{
    key: "processWidgetConfig",
    value: function processWidgetConfig(widget) {
      var dependencyEditFeature = this.dependencyEditFeature;
      var fieldConfig = {};

      if (widget.ref === 'lagField' && !dependencyEditFeature.showLagField) {
        return false;
      }

      if (widget.ref === 'deleteButton' && !dependencyEditFeature.showDeleteButton) {
        return false;
      }

      Object.assign(widget, fieldConfig);
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(DependencyEditor.prototype), "processWidgetConfig", this).call(this, widget);
    }
  }, {
    key: "afterShow",
    value: function afterShow() {
      var _get2;

      var deleteButton = this.widgetMap.deleteButton; // Only show delete button if the dependency record belongs to a store

      if (deleteButton) {
        deleteButton.hidden = !this.record.isPartOfStore();
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(DependencyEditor.prototype), "afterShow", this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(event) {
      this.trigger('keyDown', {
        event: event
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(DependencyEditor.prototype), "onInternalKeyDown", this).call(this, event);
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'DependencyEditor';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        items: [],
        draggable: {
          handleSelector: ':not(button,.b-field-inner)' // blacklist buttons and field inners

        },
        axisLock: 'flexible'
      };
    }
  }]);

  return DependencyEditor;
}(_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_11__["default"]);


DependencyEditor._$name = 'DependencyEditor';

/***/ }),

/***/ "./lib/Scheduler/view/EventEditor.js":
/*!*******************************************!*\
  !*** ./lib/Scheduler/view/EventEditor.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventEditor; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/EventEditor
 */

/**
 * Provided event editor dialog.
 *
 * @extends Core/widget/Popup
 * @private
 */

var EventEditor = /*#__PURE__*/function (_Popup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(EventEditor, _Popup);

  var _super = _createSuper(EventEditor);

  function EventEditor() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, EventEditor);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(EventEditor, [{
    key: "updateLocalization",
    value: function updateLocalization() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(EventEditor.prototype), "updateLocalization", this).apply(this, arguments); // Use this if there's no titleRenderer


      this.initialTitle = this.title || '';
    }
  }, {
    key: "processWidgetConfig",
    value: function processWidgetConfig(widget) {
      var _widget$type;

      var me = this,
          eventEditFeature = me.eventEditFeature;

      if (((_widget$type = widget.type) === null || _widget$type === void 0 ? void 0 : _widget$type.includes('date')) && widget.weekStartDay == null) {
        widget.weekStartDay = me.weekStartDay;
      }

      if (widget.type === 'extraItems') {
        return false;
      }

      var fieldConfig = {};

      if (widget.ref === 'resourceField') {
        if (!eventEditFeature.showResourceField) {
          return false;
        } // Can't use store directly since it may be grouped and then contains irrelevant group records


        me.resourceStore = widget.store = eventEditFeature.resourceStore.makeChained(function (record) {
          return !record.isSpecialRow;
        }, null, {
          // Need to show all records in the combo. Required in case resource store is a tree.
          excludeCollapsedRecords: false
        }); // When events are loaded with resourceId, we should only support single select

        widget.multiSelect = !eventEditFeature.eventStore.usesSingleAssignment;

        if (eventEditFeature.resourceFieldConfig) {
          fieldConfig = eventEditFeature.resourceFieldConfig;
        }
      }

      if (widget.ref === 'nameField' && !eventEditFeature.showNameField) {
        return false;
      }

      if (widget.ref === 'deleteButton' && !eventEditFeature.showDeleteButton) {
        return false;
      }

      if ((widget.name === 'startDate' || widget.name === 'endDate') && widget.type === 'date') {
        fieldConfig.format = eventEditFeature.dateFormat;
      }

      if ((widget.name === 'startDate' || widget.name === 'endDate') && widget.type === 'time') {
        fieldConfig.format = eventEditFeature.timeFormat;
      }

      if (eventEditFeature.startDateConfig && widget.name === 'startDate' && widget.type === 'date') {
        fieldConfig = eventEditFeature.startDateConfig;
      }

      if (eventEditFeature.startTimeConfig && widget.name === 'startDate' && widget.type === 'time') {
        fieldConfig = eventEditFeature.startTimeConfig;
      }

      if (eventEditFeature.endDateConfig && widget.name === 'endDate' && widget.type === 'date') {
        fieldConfig = eventEditFeature.endDateConfig;
      }

      if (eventEditFeature.endTimeConfig && widget.name === 'endDate' && widget.type === 'time') {
        fieldConfig = eventEditFeature.endTimeConfig;
      }

      Object.assign(widget, fieldConfig);
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(EventEditor.prototype), "processWidgetConfig", this).call(this, widget);
    }
  }, {
    key: "show",
    value: function show() {
      var _get2;

      // Updated chained store. It is not done automatically for grouping/trees.
      if (this.resourceStore) {
        this.resourceStore.fillFromMaster();
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(EventEditor.prototype), "show", this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: "onBeforeShow",
    value: function onBeforeShow() {
      var _get3;

      var me = this,
          record = me.record,
          titleRenderer = me.titleRenderer,
          deleteButton = me.widgetMap.deleteButton; // Hide delete button if we are readOnly or the event does not belong to a store

      if (deleteButton) {
        deleteButton.hidden = me.readOnly || !record.stores.length && !record.isOccurrence;
      }

      if (titleRenderer) {
        me.title = me.callback(titleRenderer, me, [record]);
      } else {
        me.title = me.initialTitle;
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(EventEditor.prototype), "onBeforeShow", this) && (_get3 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(EventEditor.prototype), "onBeforeShow", this)).call.apply(_get3, [this].concat(args));
    }
  }, {
    key: "onInternalKeyDown",
    value: function onInternalKeyDown(event) {
      this.trigger('keyDown', {
        event: event
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(EventEditor.prototype), "onInternalKeyDown", this).call(this, event);
    }
  }, {
    key: "updateReadOnly",
    value: function updateReadOnly(readOnly) {
      var _this$widgetMap = this.widgetMap,
          deleteButton = _this$widgetMap.deleteButton,
          saveButton = _this$widgetMap.saveButton,
          cancelButton = _this$widgetMap.cancelButton;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(EventEditor.prototype), "updateReadOnly", this).call(this, readOnly);

      if (deleteButton) {
        deleteButton.hidden = readOnly;
      }

      if (saveButton) {
        saveButton.hidden = readOnly;
      }

      if (cancelButton) {
        cancelButton.hidden = readOnly;
      }
    }
  }], [{
    key: "type",
    // Factoryable type name
    get: function get() {
      return 'eventeditor';
    }
  }, {
    key: "$name",
    get: function get() {
      return 'EventEditor';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        items: [],
        draggable: {
          handleSelector: ':not(button,.b-field-inner)' // Ignore buttons and field inners

        },
        axisLock: 'flexible',
        scrollable: {
          // In case editor is very tall or window is small, make it scrollable
          overflowY: true
        },
        readOnly: null,

        /**
         * A Function (or *name* of a function) which produces a customized Panel header based upon the event being edited.
         * @config {Function|String}
         * @param {Scheduler.model.EventModel} eventRecord The record being edited
         * @returns {String} The Panel title.
         */
        titleRenderer: null
      };
    }
  }]);

  return EventEditor;
}(_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_14__["default"]); // Register this widget type with its Factory



EventEditor.initClass();
EventEditor._$name = 'EventEditor';

/***/ }),

/***/ "./lib/Scheduler/view/Header.js":
/*!**************************************!*\
  !*** ./lib/Scheduler/view/Header.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Header; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Grid/view/Header.js */ "./lib/Grid/view/Header.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/Header
 */

/**
 * Custom header subclass which handles the existence of the special TimeAxisColumn
 *
 * @extends Grid/view/Header
 * @private
 */

var Header = /*#__PURE__*/function (_GridHeader) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Header, _GridHeader);

  var _super = _createSuper(Header);

  function Header() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Header);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Header, [{
    key: "refreshContent",
    value: function refreshContent() {
      // Only render contents into the header once as it contains the special rendering of the TimeAxisColumn
      if (this.headersElement && this.headersElement.childNodes.length === 0) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Header.prototype), "refreshContent", this).call(this);
      }
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'SchedulerHeader';
    }
  }]);

  return Header;
}(_Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


Header._$name = 'Header';

/***/ }),

/***/ "./lib/Scheduler/view/HorizontalTimeAxis.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/view/HorizontalTimeAxis.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalTimeAxis; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _TimeAxisBase_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TimeAxisBase.js */ "./lib/Scheduler/view/TimeAxisBase.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/HorizontalTimeAxis
 */

/**
 * A visual horizontal representation of the time axis described in the
 * {@link Scheduler.preset.ViewPreset#field-headers headers}.
 * Normally you should not interact with this class directly.
 *
 * @extends Scheduler/view/TimeAxisBase
 * @private
 */

var HorizontalTimeAxis = /*#__PURE__*/function (_TimeAxisBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(HorizontalTimeAxis, _TimeAxisBase);

  var _super = _createSuper(HorizontalTimeAxis);

  function HorizontalTimeAxis() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, HorizontalTimeAxis);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(HorizontalTimeAxis, [{
    key: "construct",
    value: function construct() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(HorizontalTimeAxis.prototype), "construct", this).apply(this, arguments);

      this.model.on({
        update: this.onModelUpdate,
        thisObj: this
      });
    }
  }, {
    key: "onModelUpdate",
    value: function onModelUpdate() {
      // Force rebuild when availableSpace has changed, to recalculate width and maybe apply compact styling
      if (this.model.availableSpace !== this.width) {
        this.refresh(true);
      }
    }
  }, {
    key: "width",
    get: function get() {
      return this.size;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'HorizontalTimeAxis';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        cls: 'b-horizontaltimeaxis',
        sizeProperty: 'width',
        positionProperty: 'left',
        wrapText: false
      };
    }
  }]);

  return HorizontalTimeAxis;
}(_TimeAxisBase_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


HorizontalTimeAxis._$name = 'HorizontalTimeAxis';

/***/ }),

/***/ "./lib/Scheduler/view/ResourceHeader.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/view/ResourceHeader.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceHeader; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.ends-with */ "./node_modules/core-js/modules/es.string.ends-with.js");
/* harmony import */ var core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.replace */ "./node_modules/core-js/modules/es.string.replace.js");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");














function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Scheduler/view/ResourceHeader
 */

/**
 * Header widget that renders resource column headers and acts as the interaction point for resource columns in vertical
 * mode. Note that it uses virtual rendering and element reusage to gain performance, only headers in view are available
 * in DOM. Because of this you should avoid direct element manipulation, any such changes can be discarded at any time.
 *
 * By default it displays resources `name` and also applies its `iconCls` if any, like this:
 *
 * ```
 * <i class="iconCls">name</i>
 * ```
 *
 * If Scheduler is configured with a {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImagePath} the
 * header will render miniatures for the resources, using {@link Scheduler.model.mixin.ResourceModelMixin#field-imageUrl} or {@link Scheduler.model.mixin.ResourceModelMixin#field-image} with
 * fallback to {@link Scheduler.model.mixin.ResourceModelMixin#field-name} + {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImageExtension} for unset values.
 *
 * The contents and styling of the resource cells in the header can be customized using {@link #config-headerRenderer}:
 *
 * ```
 * new Scheduler({
 *     mode            : 'vertical',
 *     resourceColumns : {
 *         headerRenderer : ({ resourceRecord }) => `Hello ${resourceRecord.name}`
 *     }
 * }
 *```
 *
 * The width of the resource columns is determined by the {@link #config-columnWidth} config.
 *
 * @extends Core/widget/Widget
 */

var ResourceHeader = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(ResourceHeader, _Widget);

  var _super = _createSuper(ResourceHeader);

  function ResourceHeader() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ResourceHeader);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(ResourceHeader, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(ResourceHeader.prototype), "construct", this).call(this, config);

      var me = this;

      if (me.imagePath != null) {
        // Apply default image on load errors
        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].on({
          element: me.element,
          delegate: '.b-resource-image',
          capture: true,
          error: function error(event) {
            return me.setDefaultResourceImage(event.target);
          },
          thisObj: me
        }); // Need to gain some height when displaying images

        me.element.classList.add('b-has-images');
      }

      _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].on({
        element: me.element,
        delegate: '.b-resourceheader-cell',
        capture: true,
        click: 'onResourceMouseEvent',
        dblclick: 'onResourceMouseEvent',
        contextmenu: 'onResourceMouseEvent',
        thisObj: me
      });
    } //endregion
    //region ResourceStore

  }, {
    key: "onResourceStoreDataChange",
    // Redraw resource headers on any data change
    value: function onResourceStoreDataChange(_ref) {
      var action = _ref.action;
      var me = this,
          width = me.resourceStore.count * me.columnWidth;

      if (width !== me.width) {
        me.element.style.width = width + 'px'; // During setup, silently set the width. It will then render correctly. After setup, let the world know...

        me.column.set('width', width, me.column.grid.isConfiguring);
      }

      if (action === 'removeall') {
        // Keep nothing
        me.element.innerHTML = '';
      }

      if (action === 'remove' || action === 'add' || action === 'filter') {
        me.refreshWidths();
      }
    } //endregion
    //region Properties

  }, {
    key: "setDefaultResourceImage",
    value: function setDefaultResourceImage(target) {
      if (this.defaultImageName) {
        var defaultURL = this.getImageURL(this.defaultImageName); // Set image to defaultURL if it is not already set

        if (target.src && !target.src.endsWith(defaultURL.replace(/^[./]*/gm, ''))) {
          target.src = defaultURL;
        }
      }
    }
  }, {
    key: "getImageURL",
    value: function getImageURL(imageName) {
      return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].joinPaths([this.imagePath || '', imageName || '']);
    }
  }, {
    key: "refreshWidths",
    // Updates the column widths according to fill and fit settings
    value: function refreshWidths() {
      var me = this,
          availableWidth = me.availableWidth,
          _originalColumnWidth = me._originalColumnWidth,
          count = me.resourceStore && me.resourceStore.count; // Bail out if availableWidth not yet set or resource store not assigned/loaded

      if (!availableWidth || !count) {
        return;
      }

      me.refreshingWidths = true;
      var // Fit width if configured to do so or if configured to fill and used width is less than available width
      fit = me.fitWidth || me.fillWidth && _originalColumnWidth * count < availableWidth,
          useWidth = fit ? Math.floor(availableWidth / count) : _originalColumnWidth,
          shouldAnimate = me.column.grid.enableEventAnimations && Math.abs(me._columnWidth - useWidth) > 30;
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].addTemporaryClass(me.element, 'b-animating', shouldAnimate ? 300 : 0, me);
      me.columnWidth = useWidth;
      me.refreshingWidths = false;
    } //endregion
    //region Rendering
    // Visual resource range, set by VerticalRendering

  }, {
    key: "refresh",

    /**
     * Refreshes the visible headers
     */
    value: function refresh() {
      var me = this,
          firstResource = me.firstResource,
          lastResource = me.lastResource; // Bail out if we are configuring or have no resources to show

      if (me.column.grid.isConfiguring || firstResource === -1 || lastResource === -1 || lastResource >= me.resourceStore.count) {
        return;
      }

      var configs = []; // Gather element configs for resource headers in view

      for (var i = firstResource; i <= lastResource; i++) {
        var resourceRecord = me.resourceStore.getAt(i),
            elementConfig = {
          // Might look like overkill to use DomClassList here, but can be used in headerRenderer
          className: new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_17__["default"]({
            'b-resourceheader-cell': 1
          }),
          dataset: {
            resourceId: resourceRecord.id
          },
          style: {
            left: i * me.columnWidth,
            width: me.columnWidth
          },
          children: []
        }; // Let a configured headerRenderer have a go at it before applying

        if (me.headerRenderer) {
          var value = me.headerRenderer({
            elementConfig: elementConfig,
            resourceRecord: resourceRecord
          });

          if (value != null) {
            elementConfig.html = value;
          }
        } // No headerRenderer, apply default markup
        else {
            var imageUrl = void 0;

            if (resourceRecord.imageUrl) {
              imageUrl = resourceRecord.imageUrl;
            } else {
              if (me.imagePath != null) {
                var imageName = resourceRecord.image || resourceRecord.name && resourceRecord.name.toLowerCase() + me.imageExtension || me.defaultImageName;
                imageUrl = me.getImageURL(imageName);
              }
            } // Optionally displaying a miniature image


            if (imageUrl != null) {
              elementConfig.children.push({
                tag: 'img',
                className: 'b-resource-image',
                src: imageUrl
              });
            } // Optionally displaying an icon


            if (resourceRecord.iconCls) {
              elementConfig.children.push({
                tag: 'i',
                className: resourceRecord.iconCls
              });
            } // By default showing resource name


            elementConfig.children.push({
              tag: 'span',
              className: 'b-resource-name',
              html: resourceRecord.name
            });
          }

        configs.push(elementConfig);
      } // Sync changes to the header


      _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_15__["default"].sync({
        domConfig: {
          onlyChildren: true,
          children: configs
        },
        targetElement: me.element,
        syncIdField: 'resourceId' // TODO: Add callback here to trigger events when rendering/derendering header cells. Sooner or later
        //  someone is going to ask for a way to render JSX or what not to the header

      });
    } //endregion

  }, {
    key: "onResourceMouseEvent",
    value: function onResourceMouseEvent(event) {
      var resourceCell = event.target.closest('.b-resourceheader-cell'),
          resourceRecord = this.resourceStore.getById(resourceCell.dataset.resourceId);
      this.trigger('resourceHeader' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].capitalize(event.type), {
        resourceRecord: resourceRecord,
        event: event
      });
    }
  }, {
    key: "resourceStore",
    set: function set(store) {
      var me = this;

      if (store !== me._resourceStore) {
        var _me$resourceStoreDeta;

        (_me$resourceStoreDeta = me.resourceStoreDetacher) === null || _me$resourceStoreDeta === void 0 ? void 0 : _me$resourceStoreDeta.call(me);
        me._resourceStore = store;
        me.resourceStoreDetacher = store.on({
          changePreCommit: 'onResourceStoreDataChange',
          thisObj: me
        }); // Already have data? Update width etc

        if (store.count) {
          me.onResourceStoreDataChange({});
        }
      }
    },
    get: function get() {
      return this._resourceStore;
    }
  }, {
    key: "columnWidth",
    get: function get() {
      return this._columnWidth;
    },
    set: function set(width) {
      var me = this;

      if (width !== me._columnWidth) {
        var oldWidth = me._columnWidth;
        me._columnWidth = width; // Flag set in refreshWidths, do not want to create a loop

        if (!me.refreshingWidths) {
          me._originalColumnWidth = width;
          me.refreshWidths();
        }

        if (!me.isConfiguring) {
          me.refresh(); // Cannot trigger with requested width, might have changed because of fit/fill

          me.trigger('columnWidthChange', {
            width: me._columnWidth,
            oldWidth: oldWidth
          });
        }
      }
    }
    /**
     * Assign to toggle resource columns **fill* mode. `true` means they will stretch (grow) to fill viewport, `false`
     * that they will respect their configured `columnWidth`.
     * @property {Boolean}
     */

  }, {
    key: "fillWidth",
    get: function get() {
      return this._fillWidth;
    },
    set: function set(fill) {
      this._fillWidth = fill;
      this.refreshWidths();
    }
    /**
     * Assign to toggle resource columns **fit* mode. `true` means they will grow or shrink to always fit viewport,
     * `false` that they will respect their configured `columnWidth`.
     * @property {Boolean}
     */

  }, {
    key: "fitWidth",
    get: function get() {
      return this._fitWidth;
    },
    set: function set(fit) {
      this._fitWidth = fit;
      this.refreshWidths();
    }
  }, {
    key: "imagePath",
    get: function get() {
      return this._imagePath;
    },
    set: function set(path) {
      this._imagePath = path;
      this.refresh();
    } //endregion
    //region Fit to width

  }, {
    key: "availableWidth",
    get: function get() {
      return this._availableWidth;
    },
    set: function set(width) {
      this._availableWidth = width;
      this.refreshWidths();
    }
  }, {
    key: "range",
    set: function set(range) {
      var me = this;
      me.firstResource = range.firstResource;
      me.lastResource = range.lastResource;
      me.refresh();
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'ResourceHeader';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Resource store used to render resource headers. Assigned from Scheduler.
         * @config {Scheduler.data.ResourceStore}
         * @private
         */
        resourceStore: null,
        // TODO: Read this value from CSS as we do with rowHeight?

        /**
         * Width for each resource column
         * @config {Number}
         */
        columnWidth: 150,

        /**
         * Custom header renderer function. Can be used to manipulate the element config used to create the element
         * for the header:
         *
         * ```
         * new Scheduler({
         *   resourceColumns : {
         *     headerRenderer({ elementConfig, resourceRecord }) {
         *       elementConfig.dataset.myExtraData = 'extra';
         *       elementConfig.style.fontWeight = 'bold';
         *     }
         *   }
         * });
         * ```
         *
         * See {@link Core.helper.DomHelper#function-createElement-static DomHelper#createElement()} for more information.
         * Please take care to not break the default configs :)
         *
         * Or as a template by returning HTML from the function:
         *
         * ```
         * new Scheduler({
         *   resourceColumns : {
         *     headerRenderer : ({ resourceRecord }) => `
         *       <div class="my-custom-template">
         *       ${resourceRecord.firstName} {resourceRecord.surname}
         *       </div>
         *     `
         *   }
         * });
         * ```
         *
         * NOTE: When using `headerRenderer` no default internal markup is applied to the resource header cell,
         * `iconCls` and {@link Scheduler.model.mixin.ResourceModelMixin#field-imageUrl} or {@link Scheduler.model.mixin.ResourceModelMixin#field-image}
         * will have no effect unless you supply custom markup for them.
         *
         * @config {Function}
         * @param {Object} params Object containing the params below
         * @param {Scheduler.model.ResourceModel} resourceRecord Resource whose header is being rendered
         * @param {Object} elementConfig A {@link Core.helper.DomHelper#function-createElement-static} config object used to create the element for the resource
         */
        headerRenderer: null,

        /**
         * Automatically resize resource columns to **fill** available width. Set to `false` to always respect the
         * configured `columnWidth`
         * @config {Boolean}
         * @default
         */
        fillWidth: true,

        /**
         * Automatically resize resource columns to always **fit** available width
         * @config {Boolean}
         * @default
         */
        fitWidth: false,
        // Copied from Scheduler#resourceImagePath on creation in TimeAxisColumn.js
        imagePath: null,
        // Copied from Scheduler#resourceImageExtension on creation in TimeAxisColumn.js
        imageExtension: null,
        // Copied from Scheduler#defaultResourceImageName on creation in TimeAxisColumn.js
        defaultImageName: null
      };
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        firstResource: -1,
        lastResource: -1
      };
    }
  }]);

  return ResourceHeader;
}(_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


ResourceHeader._$name = 'ResourceHeader';

/***/ }),

/***/ "./lib/Scheduler/view/Scheduler.js":
/*!*****************************************!*\
  !*** ./lib/Scheduler/view/Scheduler.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Scheduler; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _SchedulerBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Scheduler/localization/En.js");
/* harmony import */ var _feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../feature/ColumnLines.js */ "./lib/Scheduler/feature/ColumnLines.js");
/* harmony import */ var _feature_EventContextMenu_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../feature/EventContextMenu.js */ "./lib/Scheduler/feature/EventContextMenu.js");
/* harmony import */ var _feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../feature/EventMenu.js */ "./lib/Scheduler/feature/EventMenu.js");
/* harmony import */ var _feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../feature/EventFilter.js */ "./lib/Scheduler/feature/EventFilter.js");
/* harmony import */ var _feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../feature/EventDrag.js */ "./lib/Scheduler/feature/EventDrag.js");
/* harmony import */ var _feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../feature/EventDragCreate.js */ "./lib/Scheduler/feature/EventDragCreate.js");
/* harmony import */ var _feature_EventEdit_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../feature/EventEdit.js */ "./lib/Scheduler/feature/EventEdit.js");
/* harmony import */ var _feature_EventResize_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../feature/EventResize.js */ "./lib/Scheduler/feature/EventResize.js");
/* harmony import */ var _feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../feature/EventTooltip.js */ "./lib/Scheduler/feature/EventTooltip.js");
/* harmony import */ var _feature_HeaderContextMenu_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../feature/HeaderContextMenu.js */ "./lib/Scheduler/feature/HeaderContextMenu.js");
/* harmony import */ var _feature_TimeAxisHeaderMenu_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../feature/TimeAxisHeaderMenu.js */ "./lib/Scheduler/feature/TimeAxisHeaderMenu.js");
/* harmony import */ var _feature_ScheduleContextMenu_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../feature/ScheduleContextMenu.js */ "./lib/Scheduler/feature/ScheduleContextMenu.js");
/* harmony import */ var _feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../feature/ScheduleMenu.js */ "./lib/Scheduler/feature/ScheduleMenu.js");
/* harmony import */ var _feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../feature/ScheduleTooltip.js */ "./lib/Scheduler/feature/ScheduleTooltip.js");
/* harmony import */ var _Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Grid/feature/CellEdit.js */ "./lib/Grid/feature/CellEdit.js");
/* harmony import */ var _Grid_feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Grid/feature/ColumnDragToolbar.js */ "./lib/Grid/feature/ColumnDragToolbar.js");
/* harmony import */ var _Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Grid/feature/ColumnPicker.js */ "./lib/Grid/feature/ColumnPicker.js");
/* harmony import */ var _Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Grid/feature/ColumnReorder.js */ "./lib/Grid/feature/ColumnReorder.js");
/* harmony import */ var _Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Grid/feature/ColumnResize.js */ "./lib/Grid/feature/ColumnResize.js");
/* harmony import */ var _Grid_feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../Grid/feature/ContextMenu.js */ "./lib/Grid/feature/ContextMenu.js");
/* harmony import */ var _Grid_feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Grid/feature/CellMenu.js */ "./lib/Grid/feature/CellMenu.js");
/* harmony import */ var _Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Grid/feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony import */ var _Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Grid/feature/Filter.js */ "./lib/Grid/feature/Filter.js");
/* harmony import */ var _Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../Grid/feature/FilterBar.js */ "./lib/Grid/feature/FilterBar.js");
/* harmony import */ var _Grid_feature_Group_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../../Grid/feature/Group.js */ "./lib/Grid/feature/Group.js");
/* harmony import */ var _Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../Grid/feature/Sort.js */ "./lib/Grid/feature/Sort.js");
/* harmony import */ var _Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../Grid/feature/Stripe.js */ "./lib/Grid/feature/Stripe.js");
/* harmony import */ var _Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

 // default features


 // TODO: 'eventContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/4.0.0.md for more information.








 // TODO: 'headerContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/4.0.0.md for more information.


 // TODO: 'scheduleContextMenu' is deprecated. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/4.0.0.md for more information.


 // Since Scheduler is based on SchedulerBase + GridBase, Grids default features needs to be pulled in here also






 // TODO: 'contextMenu' is deprecated. Please see https://bryntum.com/docs/grid/#guides/upgrades/4.0.0.md for more information.








 // For checkbox selection mode

/**
 * @module Scheduler/view/Scheduler
 */

/**
 * The Scheduler widget is a very powerful and performant UI component that displays an arbitrary number of "locked"
 * columns with a schedule occupying the remaining space. The schedule has a timeaxis at the top, one row per resource
 * and any number of events per resource.
 *
 * ## Intro
 * The Scheduler widget has a wide range of features and a large API to allow users to work with it efficiently in the
 * browser.
 *
 * The timeaxis displayed at the top of the Scheduler is configured using a {@link Scheduler.view.TimelineBase#config-startDate},
 * {@link Scheduler.view.TimelineBase#config-endDate} and a {@link Scheduler.view.mixin.TimelineViewPresets#config-viewPreset}. The dates
 * determine the outer limits of the range shown in the timeaxis while the {@link Scheduler.preset.ViewPreset} decides
 * the appearance and which dates are actually shown. The Scheduler ships with a selection of predefined view presets,
 * which can be found in {@link Scheduler.preset.PresetManager}. If you want to specify view presets for a specific scheduler only, please
 * see {@link Scheduler.view.mixin.TimelineViewPresets#config-presets} config.
 *
 * The Scheduler uses a {@link Scheduler.data.ResourceStore} to hold resources and an {@link Scheduler.data.EventStore}
 * to hold events. You can use inline data or load data using ajax, see the "Working with data" guides for more
 * information.
 *
 * The simplest schedule configured with inline data would look like this:
 *
 *      let scheduler = new Scheduler({
 *          appendTo : document.body,
 *
 *          startDate  : new Date(2018,4,6),
 *          endDate    : new Date(2018,4,12),
 *          viewPreset : 'dayAndWeek',
 *
 *           columns : [
 *              { field : 'name', text : 'Name', width: 100 }
 *          ],
 *
 *          resources : [
 *              { id : 1, name : 'Bernard' },
 *              { id : 2, name : 'Bianca' }
 *          ],
 *
 *          events : [
 *              { id : 1, resourceId : 1, name : 'Interview', startDate : '2018-05-06', endDate : '2018-05-07' },
 *              { id : 2, resourceId : 1, name : 'Press conference', startDate : '2018-05-08', endDate : '2018-05-09' },
 *              { id : 3, resourceId : 2, name : 'Audition', startDate : '2018-05-06', endDate : '2018-05-08' },
 *              { id : 4, resourceId : 2, name : 'Script deadline', startDate : '2018-05-11', endDate : '2018-05-11' }
 *          ]
 *      });
 *
 * {@inlineexample scheduler/Simplest.js}
 * ## Inheriting from Bryntum Grid
 * Bryntum Scheduler inherits from Bryntum Grid, meaning that most features available for the grid are also available
 * for the scheduler. Common features include columns, cell editing, context menus, row grouping, sorting and more.
 *
 * For more information on configuring columns, filtering, search etc. please see the {@link Grid.view.Grid Grid API docs}.
 * {@region Loading data}
 * As mentioned above Bryntum Scheduler uses an {@link Scheduler.data.EventStore} and a {@link Scheduler.data.ResourceStore}
 * to hold its data. Data is expected to be in JSON format and can be assigned inline (from memory) using the
 * {@link Scheduler.view.mixin.SchedulerStores#config-events} and
 * {@link Scheduler.view.mixin.SchedulerStores#config-resources} shortcuts:
 * ```
 * let scheduler = new Scheduler({
 *    events : myArrayOfEventData,
 *    resources : myArrayOfResourceData
 * });
 * ```
 * If you need to give additional store configuration, you can also specify store configs or instances:
 * ```
 * let resourceStore = new ResourceStore({
 *   // ResourceStore config object
 * })
 *
 * let scheduler = new Scheduler({
 *    // EventStore config object
 *    eventStore : {
 *       ...
 *    },
 *
 *    // Already existing ResourceStore instance
 *    resourceStore
 * });
 * ```
 * To use Ajax to fetch data from a server, specify {@link Core.data.AjaxStore#config-readUrl}:
 * ```
 * let scheduler = new Scheduler({
 *    eventStore : {
 *        readUrl  : 'backend/read_events.php',
 *        autoLoad : true
 *    }
 * });
 * // If you do not specify autoLoad, trigger loading manually:
 * scheduler.eventStore.load();
 * ```
 * For more information, see the "Working with data" guides.
 * {@endregion}
 * {@region Event styling}
 * Bryntum Schedulers appearance can be affected in a few different ways:
 *
 * * Switching themes
 * * Choosing event styles and colors
 * * Using renderer functions
 *
 * ### Switching themes
 * Scheduler ships with four different themes, simply include the css file for the theme you would like to use on your
 * page. The themes are located in the `/build` folder. For example to include the material theme:
 * ```
 * <link rel="stylesheet" href="build/scheduler.material.css" id="bryntum-theme">
 * ```
 * Included themes are (from left to right) classic-light, classic, classic-dark, stockholm and material:
 *
 * <img src="../examples/basic/meta/thumb.classic-light.png" alt="Classic-Light theme" width="300" style="margin-right: .5rem">
 * <img src="../examples/basic/meta/thumb.classic.png" alt="Classic theme" width="300" style="margin-right: .5rem">
 * <img src="../examples/basic/meta/thumb.classic-dark.png" alt="Classic-Dark theme" width="300" style="margin-right: .5rem">
 * <img src="../examples/basic/meta/thumb.stockholm.png" alt="Stockholm theme" width="300" style="margin-right: .5rem">
 * <img src="../examples/basic/meta/thumb.material.png" alt="Material theme" width="300">
 *
 * ### Choosing event styles and colors
 * The style and color of each event can be changed by assigning to the `eventStyle` and `eventColor` configs. These
 * configs are available at 3 different levels:
 *
 * * Scheduler level, affects all events (see {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle} and {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor}).
 * * Resource level, affects all events assigned to that resource (see {@link Scheduler.model.mixin.ResourceModelMixin#field-eventStyle}
 * and {@link Scheduler.model.mixin.ResourceModelMixin#field-eventColor}).
 * * Event level, affects that event (see {@link Scheduler/model/mixin/EventModelMixin#field-eventStyle} and
 * {@link Scheduler/model/mixin/EventModelMixin#field-eventColor}).
 *
 * {@inlineexample scheduler/Styles.js}
 *
 * For available styles, see {@link Scheduler.view.mixin/TimelineEventRendering#config-eventStyle}. For colors,
 * {@link Scheduler.view.mixin/TimelineEventRendering#config-eventColor}. Also take a look at the
 * <a href="../examples/eventstyles" target="_blank">eventstyles demo</a>.
 *
 * ### Using render functions
 * Render function can be used to manipulate the rendering of rows (resources) and events. For information on row
 * renderers, see {@link Grid.column.Column#config-renderer}.
 *
 * Event rendering can be manipulated by specifying an {@link Scheduler.view.mixin/SchedulerEventRendering#config-eventRenderer} function. The function is called
 * for each event before it is rendered to DOM. By using its arguments you can add CSS classes, modify styling and
 * determine the contents of the event:
 * ```
 * let scheduler = new Scheduler({
 *
 *   events    : [...],
 *   resources : [...],
 *
 *   ...,
 *
 *   eventRenderer({resourceRecord, eventRecord, renderData}) {
 *      // add css class to the event
 *      renderData.cls.add('my-css-class');
 *
 *      // use an icon
 *      renderData.iconCls = 'b-fa b-fa-some-nice-icon';
 *
 *      // returnvalue is used as events text
 *      return `${resourceRecord.name}: ${eventRecord.name}`;
 *   }
 * });
 * ```
 * {@endregion}
 * {@region Event manipulation}
 * You can programmatically manipulate the events using data operations, see the "Working with data" guides for more
 * information. Events are reactive, changes reflect on the UI automatically. A small example on manipulating events:
 * ```
 * // change startDate of first event
 * scheduler.eventStore.first.startDate = new Date(2018,5,10);
 *
 * // remove last event
 * scheduler.eventStore.last.remove();
 *
 * // reassign an event
 * scheduler.eventStore.getById(10).resourceId = 2;
 * ```
 *
 * You can also allow your users to manipulate the events using the following features:
 *
 * * {@link Scheduler.feature.EventDrag}, drag and drop events within the schedule
 * * {@link Scheduler.feature.EventDragCreate}, create new events by click-dragging an empty area
 * * {@link Scheduler.feature.EventEdit}, show an event editing form
 * * {@link Scheduler.feature.SimpleEventEdit}, edit the event name easily
 * * {@link Scheduler.feature.EventResize}, resize events by dragging resize handles
 *
 * All of the features mentioned above are enabled by default.
 * {@endregion}
 * {@region Default configs}
 * There is a myriad of configs and features available for Scheduler (browse the API docs to find them), some of them on
 * by default and some of them requiring extra configuration. The code below tries to illustrate the major things that
 * are used by default:
 *
 * ```javascript
 * let scheduler = new Scheduler({
 *    // The following features are enabled by default:
 *    features : {
 *        cellEdit            : true, // Cell editing in the columns part
 *        columnLines         : true, // Column lines in the schedule part
 *        columnPicker        : true, // Header context menu item to toggle visible columns
 *        columnReorder       : true, // Reorder columns in grid part using drag and drop
 *        columnResize        : true, // Resize columns in grid part using the mouse
 *        cellMenu            : true, // Context menu for cells in the grid part
 *        eventMenu           : true, // Context menu for events
 *        eventDrag           : true, // Dragging events
 *        eventDragCreate     : true, // Drag creating events
 *        eventEdit           : true, // Event editor dialog
 *        eventFilter         : true, // Filtering events using header context menu
 *        eventResize         : true, // Resizing events using the mouse
 *        eventTooltip        : true, // Tooltips for events
 *        group               : true, // Row grouping
 *        headerMenu          : true, // Context menu for headers in the grid part
 *        timeAxisHeaderMenu  : true, // Header context menu for schedule part
 *        scheduleMenu        : true, // Context menu for empty parts of the schedule
 *        scheduleTooltip     : true, // Tooltip for empty parts of the schedule
 *        sort                : true  // Row sorting
 *    },
 *
 *    // From Grid
 *    animateRemovingRows       : false, // Rows will not slide out on removal
 *    autoHeight                : false, // Grid needs to have a height supplied through CSS (strongly recommended) or by specifying `height
 *    columnLines               : true,  // Grid part, themes might override it to hide lines anyway
 *    emptyText                 : 'No rows to display',
 *    enableTextSelection       : false, // Not allowed to select text in cells by default,
 *    fillLastColumn            : true,  // By default the last column is stretched to fill the grid
 *    fullRowRefresh            : true,  // Refreshes entire row when a cell value changes
 *    loadMask                  : 'Loading...',
 *    resizeToFitIncludesHeader : true,  // Also measure header when auto resizing columns
 *    responsiveLevels : {
 *      small : 400,
 *      medium : 600,
 *      large : '*'
 *    },
 *    rowHeight                  : 60,    // Scheduler specifies a default rowHeight in pixels
 *    showDirty                  : false, // No indicator for changed cells
 *
 *    // Scheduler specific
 *    autoAdjustTimeAxis             : true,      // startDate & endDate will be adjusted to display a suitable range
 *    allowOverlap                   : true,      // Events are allowed to overlap (overlays, stacks or packs depending on eventLayout)
 *    barMargin                      : 10,        // Space above + below each event
 *    createEventOnDblClick          : true,      // Allow creating new events by double clicking empty space
 *    enableDeleteKey                : true,      // Allow deleting events with delete / backspace keys
 *    enableEventAnimations          : true,      // Animate event changes
 *    eventBarTextField              : 'name',    // Field on EventModel to display in events
 *    eventColor                     : 'green',   // Use green as default color for events
 *    eventLayout                    : 'stack',   // Stack overlapping events by default
 *    eventStyle                     : 'plain',   // Use plain as default style for events
 *    managedEventSizing             : true,      // Calculate event sizes based on rowHeight & barMargin
 *    milestoneCharWidth             : 10,
 *    milestoneLayoutMode            : 'default',
 *    removeUnassignedEvent          : true,      // Remove event when all assignments for it are removed
 *    useInitialAnimation            : true,      // Fade in events initially
 *    viewPreset                     : 'weekAndDayLetter',
 *    zoomOnMouseWheel               : true,
 *    zoomOnTimeAxisDoubleClick      : true
 * });
 * ```
 * {@endregion}
 * {@region Performance}
 * To make scheduler performance as good as possible it only renders the events and resources that are within view (plus
 * an additional buffer). Since adding to and removing from DOM comes with a performance penalty the elements are
 * instead repositioned and reused as you scroll. A side effect of this is that you cannot do direct DOM element
 * manipulation in a reliable way, instead you should use row and event renderer functions to achive what you want (see
 * the section on event styling above).
 *
 * To put the scheduler to the test, try our <a href="../examples/bigdataset" target="_blank">bigdataset demo</a>.
 * {@endregion}
 *
 * {@region Recurring Events}
 * From 4.0.0, there is no `RecurringEvents` Feature. There is an
 * {@link Scheduler.view.mixin.RecurringEvents#config-enableRecurringEvents enableRecurringEvents}
 * boolean config on the Scheduler. Occurrences of recurring events are provided on a "just in time"
 * basis by a new EventStore API which must now be used when interrogating an EventStore.
 *
 * {@link Scheduler.data.mixin.EventStoreMixin#function-getEvents} is a multipurpose event gathering method
 * which can be asked to return events which match a set of criteria including a date range and a
 * resource. By default, if the requested date range contains occurrences of a recurring event,
 * those occurrences are returned in the result array.
 *
 * ```
 * myEventStore.getEvents({
 *     resourceRecord : myResourceRecord,
 *     startDate      : myScheduler.timeAxis.startDate,
 *     endDate        : myScheduler.timeAxis.endDate
 * });
 * ```
 *
 * Occurrences are *not* present in the store's data collection.
 *
 * To directly access occurrences of a recurring event which *intersect* a date range, use:
 *
 * `recurringEvent.getOccurrencesForDateRange(startDate, endDate);`
 *
 * The `endDate` argument is optional if the occurrence for one date is required. This method always
 * returns an array. Note that it may be empty if no occurrences intersect the date range.
 *
 * ### Convert an occurrence to an exception
 * To programatically convert an occurrence to be a single exception to its owner's sequence use:
 *
 * ```
 * myOccurrence.beginBatch();
 * myOccurrence.startDate = DateHelper.add(myOccurrence.startDate, 1, 'day');
 * myOccurrence.name = 'Postponed to next day';
 * myOccurrence.recurrence = null; // This means it does NOT become a new recurring base event.
 * myOccurrence.endBatch();
 * ```
 *
 * That will cause that event to be inserted into the store as a concrete event defintion, firing
 * an `add` event as would be expected, and will add an `exceptionDate` to its owning recurring event.
 *
 * When syncing this change back to the server, the `exceptionDates` array for the modified
 * recurring event now contains the exception dates correctly serialized into string form using
 * the `dateFormat` of the EventModel. The system-supplied default value for this is
 * `'YYYY-MM-DDTHH:mm:ssZ'`
 *
 * ### Convert an occurrence to a new recurring event sequence.
 * To programatically convert an occurrence to be the start of a new recurring sequence, use:
 *
 * ```
 * myOccurrence.beginBatch();
 * myOccurrence.startDate = DateHelper.set(myOccurrence.startDate, 'hour', 14);
 * myOccurrence.name = 'Moved to 2pm from here on';
 * myOccurrence.endBatch();
 * ```
 *
 * That will cause that event to be inserted into the store as a concrete *recurring* event
 * defintion, firing an `add` event as would be expected, and will terminate the previous
 * recurring owner of that occurrence on the day before the new event.
 * {@endregion}
 *
 * @extends Scheduler/view/SchedulerBase
 */

var Scheduler = /*#__PURE__*/function (_SchedulerBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Scheduler, _SchedulerBase);

  var _super = _createSuper(Scheduler);

  function Scheduler() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Scheduler);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler, null, [{
    key: "$name",
    get: function get() {
      return 'Scheduler';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'scheduler';
    }
  }]);

  return Scheduler;
}(_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_8__["default"]); // Register this widget type with its Factory



Scheduler.initClass();
Scheduler._$name = 'Scheduler';

/***/ }),

/***/ "./lib/Scheduler/view/SchedulerBase.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/view/SchedulerBase.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerBase; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _TimelineBase_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./TimelineBase.js */ "./lib/Scheduler/view/TimelineBase.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _data_CrudManager_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../data/CrudManager.js */ "./lib/Scheduler/data/CrudManager.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Scheduler/localization/En.js");
/* harmony import */ var _mixin_SchedulerDom_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./mixin/SchedulerDom.js */ "./lib/Scheduler/view/mixin/SchedulerDom.js");
/* harmony import */ var _mixin_SchedulerDomEvents_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./mixin/SchedulerDomEvents.js */ "./lib/Scheduler/view/mixin/SchedulerDomEvents.js");
/* harmony import */ var _mixin_SchedulerDragResize_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./mixin/SchedulerDragResize.js */ "./lib/Scheduler/view/mixin/SchedulerDragResize.js");
/* harmony import */ var _mixin_SchedulerEventRendering_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./mixin/SchedulerEventRendering.js */ "./lib/Scheduler/view/mixin/SchedulerEventRendering.js");
/* harmony import */ var _mixin_SchedulerStores_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./mixin/SchedulerStores.js */ "./lib/Scheduler/view/mixin/SchedulerStores.js");
/* harmony import */ var _mixin_SchedulerScroll_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./mixin/SchedulerScroll.js */ "./lib/Scheduler/view/mixin/SchedulerScroll.js");
/* harmony import */ var _mixin_SchedulerRegions_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./mixin/SchedulerRegions.js */ "./lib/Scheduler/view/mixin/SchedulerRegions.js");
/* harmony import */ var _mixin_SchedulerState_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./mixin/SchedulerState.js */ "./lib/Scheduler/view/mixin/SchedulerState.js");
/* harmony import */ var _mixin_EventSelection_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./mixin/EventSelection.js */ "./lib/Scheduler/view/mixin/EventSelection.js");
/* harmony import */ var _mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./mixin/EventNavigation.js */ "./lib/Scheduler/view/mixin/EventNavigation.js");
/* harmony import */ var _crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../crud/mixin/CrudManagerView.js */ "./lib/Scheduler/crud/mixin/CrudManagerView.js");
/* harmony import */ var _orientation_HorizontalRendering_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./orientation/HorizontalRendering.js */ "./lib/Scheduler/view/orientation/HorizontalRendering.js");
/* harmony import */ var _orientation_VerticalRendering_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./orientation/VerticalRendering.js */ "./lib/Scheduler/view/orientation/VerticalRendering.js");
/* harmony import */ var _column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../column/TimeAxisColumn.js */ "./lib/Scheduler/column/TimeAxisColumn.js");
/* harmony import */ var _column_VerticalTimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../column/VerticalTimeAxisColumn.js */ "./lib/Scheduler/column/VerticalTimeAxisColumn.js");
/* harmony import */ var _Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../Grid/feature/RegionResize.js */ "./lib/Grid/feature/RegionResize.js");

















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



















 // Should always be present in Scheduler


/**
 * @module Scheduler/view/SchedulerBase
 */

/**
 * A thin base class for {@link Scheduler.view.Scheduler}. Does not include any features by default, allowing smaller
 * custom built bundles if used in place of {@link Scheduler.view.Scheduler}.
 *
 * **NOTE:** In most scenarios you do probably want to use Scheduler instead of SchedulerBase.
 *
 * @mixes Scheduler/view/mixin/EventNavigation
 * @mixes Scheduler/view/mixin/EventSelection
 * @mixes Scheduler/view/mixin/SchedulerDom
 * @mixes Scheduler/view/mixin/SchedulerDomEvents
 * @mixes Scheduler/view/mixin/SchedulerEventRendering
 * @mixes Scheduler/view/mixin/SchedulerRegions
 * @mixes Scheduler/view/mixin/SchedulerScroll
 * @mixes Scheduler/view/mixin/SchedulerState
 * @mixes Scheduler/view/mixin/SchedulerStores
 * @mixes Scheduler/view/mixin/TimelineDateMapper
 * @mixes Scheduler/view/mixin/TimelineDomEvents
 * @mixes Scheduler/view/mixin/TimelineEventRendering
 * @mixes Scheduler/view/mixin/TimelineScroll
 * @mixes Scheduler/view/mixin/TimelineViewPresets
 * @mixes Scheduler/view/mixin/TimelineZoomable
 * @mixes Scheduler/crud/mixin/CrudManagerView
 * @mixes Scheduler/data/mixin/ProjectConsumer
 *
 * @extends Scheduler/view/TimelineBase
 */
// SchedulerDragResize not included as @mixes above on purpose, since it is private

var SchedulerBase = /*#__PURE__*/function (_TimelineBase$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerBase, _TimelineBase$mixin);

  var _super = _createSuper(SchedulerBase);

  function SchedulerBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, SchedulerBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(SchedulerBase, [{
    key: "afterConstruct",
    //endregion
    //region Events

    /**
     * Fired after rendering an event, when its element is available in DOM.
     * @event renderEvent
     * @param {Scheduler.view.Scheduler} source This Scheduler
     * @param {Scheduler.model.EventModel} eventRecord The event record
     * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord The assignment record
     * @param {Object} renderData An object containing details about the event rendering, see
     *   {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventRenderer} for details
     * @param {Object} tplData DEPRECATED 4.0: Use renderData instead
     * @param {Boolean} isRepaint `true` if this render is a repaint of the event, updating its existing element
     * @param {Boolean} isReusingElement `true` if this render lead to the event reusing a released events element
     * @param {HTMLElement} element The events element
     */

    /**
     * Fired after releasing an event, useful to cleanup of custom content added on `renderEvent` or in `eventRenderer`.
     * @event releaseEvent
     * @param {Scheduler.view.Scheduler} source This Scheduler
     * @param {Scheduler.model.EventModel} eventRecord The event record
     * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
     * @param {Scheduler.model.AssignmentModel} assignmentRecord The assignment record
     * @param {Object} renderData An object containing details about the event rendering
     * @param {HTMLElement} element The events element
     */

    /**
     * Fired when clicking a resource header cell
     * @event resourceHeaderClick
     * @param {Scheduler.view.Scheduler} source This Scheduler
     * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
     * @param {Event} event The event
     */

    /**
     * Fired when double clicking a resource header cell
     * @event resourceHeaderDblclick
     * @param {Scheduler.view.Scheduler} source This Scheduler
     * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
     * @param {Event} event The event
     */

    /**
     * Fired when activating context menu on a resource header cell
     * @event resourceHeaderContextmenu
     * @param {Scheduler.view.Scheduler} source This Scheduler
     * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
     * @param {Event} event The event
     */
    //endregion
    //region Functions injected by features
    // For documentation & typings purposes

    /**
     * Opens an editor UI to edit the passed event.
     *
     * *NOTE: Only available when the {@link Scheduler/feature/EventEdit EventEdit} feature is enabled.*
     *
     * @function editEvent
     * @param {Scheduler.model.EventModel} eventRecord Event to edit
     * @param {Scheduler.model.ResourceModel} [resourceRecord] The Resource record for the event.
     * This parameter is needed if the event is newly created for a resource and has not been assigned, or when using
     * multi assignment.
     * @param {HTMLElement} [element] Element to anchor editor to (defaults to events element)
     * @category Feature shortcuts
     */

    /**
     * Returns the dependency record for a DOM element
     *
     * *NOTE: Only available when the {@link Scheduler/feature/Dependencies Dependencies} feature is enabled.*
     *
     * @function resolveDependencyRecord
     * @param {HTMLElement} element The dependency line element
     * @return {Scheduler.model.DependencyModel} The dependency record
     * @category Feature shortcuts
     */
    //endregion
    //region Init
    value: function afterConstruct() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "afterConstruct", this).call(this);

      if (this.createEventOnDblClick) {
        this.on('scheduledblclick', this.onSchedulerDblClick);
      }
    } //endregion
    //region Config getters/setters
    // Overrides TimelineBase to supply eventStore as its store (which is only used in passed events)

  }, {
    key: "onLocaleChange",
    //endregion
    //region Event handlers
    value: function onLocaleChange() {
      this.currentOrientation.onLocaleChange();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "onLocaleChange", this).call(this);
    }
  }, {
    key: "onSchedulerDblClick",
    value: function onSchedulerDblClick(_ref) {
      var startDate = _ref.date,
          resourceRecord = _ref.resourceRecord,
          row = _ref.row;
      var me = this;

      if (me.readOnly || resourceRecord.isSpecialRow) {
        return;
      }

      me.internalAddEvent(startDate, resourceRecord, row);
    }
  }, {
    key: "onColumnsChanged",
    value: function onColumnsChanged(_ref2) {
      var action = _ref2.action,
          changes = _ref2.changes,
          column = _ref2.record;

      // TODO: Have ResourceHeader call this directly instead of relying on event?
      if (column === this.timeAxisColumn && 'width' in changes) {
        this.updateCanvasSize();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "onColumnsChanged", this).apply(this, arguments);
    } // Only used in vertical mode

  }, {
    key: "onVerticalScroll",
    value: function onVerticalScroll(_ref3) {
      var scrollTop = _ref3.scrollTop;
      this.currentOrientation.updateFromVerticalScroll(scrollTop);
    }
    /**
     * Called when new event is created.
     * Сan be overriden to supply default record values etc.
     * @param {Scheduler.model.EventModel} eventRecord Newly created event
     */

  }, {
    key: "onEventCreated",
    value: function onEventCreated(eventRecord) {} //endregion
    //region Mode

    /**
     * Checks if scheduler is in horizontal mode
     * @returns {Boolean}
     * @readonly
     * @category Common
     * @private
     */

  }, {
    key: "onElementKeyDown",
    //endregion
    //region Dom event dummies
    // this is ugly, but needed since super cannot be called from SchedulerDomEvents mixin...
    value: function onElementKeyDown(event) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "onElementKeyDown", this).call(this, event);
    }
  }, {
    key: "onElementKeyUp",
    value: function onElementKeyUp(event) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "onElementKeyUp", this).call(this, event);
    }
  }, {
    key: "onElementMouseOver",
    value: function onElementMouseOver(event) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "onElementMouseOver", this).call(this, event);
    }
  }, {
    key: "onElementMouseOut",
    value: function onElementMouseOut(event) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "onElementMouseOut", this).call(this, event);
    } //endregion
    //region Feature hooks

    /**
     * Populates the event context menu. Chained in features to add menu items.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown.
     * @param {Scheduler.model.EventModel} options.eventRecord The context event.
     * @param {Scheduler.model.ResourceModel} options.resourceRecord The context resource.
     * @param {Scheduler.model.AssignmentModel} options.assignmentRecord The context assignment if any.
     * @param {Object} options.items A named object to describe menu items.
     * @internal
     */

  }, {
    key: "populateEventMenu",
    value: function populateEventMenu() {}
    /**
     * Populates the time axis context menu. Chained in features to add menu items.
     * @param {Object} options Contains menu items and extra data retrieved from the menu target.
     * @param {Grid.column.Column} options.column Column for which the menu will be shown.
     * @param {Scheduler.model.ResourceModel} options.resourceRecord The context resource.
     * @param {Date} options.date The Date corresponding to the mouse position in the time axis.
     * @param {Object} options.items A named object to describe menu items.
     * @internal
     */

  }, {
    key: "populateScheduleMenu",
    value: function populateScheduleMenu() {} //endregion
    //region Scheduler specific date mapping functions

  }, {
    key: "internalAddEvent",
    value: function () {
      var _internalAddEvent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee(startDate, resourceRecord, row) {
        var me, resourceRecords, eventRecord, eventData, proxyEl;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this, resourceRecords = [resourceRecord], eventRecord = new me.eventStore.modelClass({
                  startDate: startDate,
                  endDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].add(startDate, 1, me.timeAxis.unit)
                });
                me.onEventCreated(eventRecord);

                if (!me.eventEdit) {
                  _context.next = 9;
                  break;
                }

                eventData = me.currentOrientation.getTimeSpanRenderData(eventRecord, resourceRecord), proxyEl = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].createElement({
                  parent: me.foregroundCanvas,
                  className: 'b-sch-dragcreator-proxy',
                  style: "width:".concat(eventData.width, "px;height:").concat(eventData.height, "px")
                });
                _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].setTranslateXY(proxyEl, eventData.left, (row && row.top || 0) + eventData.top);
                me.editEvent(eventRecord, resourceRecord, proxyEl);
                return _context.abrupt("return");

              case 9:
                if (!me.taskEdit) {
                  _context.next = 12;
                  break;
                }

                me.editEvent(eventRecord, resourceRecord);
                return _context.abrupt("return");

              case 12:
                if (!(me.trigger('beforeEventAdd', {
                  eventRecord: eventRecord,
                  resourceRecords: resourceRecords,
                  resources: resourceRecords
                }) !== false)) {
                  _context.next = 19;
                  break;
                }

                me.eventStore.add(eventRecord);
                me.assignmentStore.assignEventToResource(eventRecord, resourceRecord);

                if (!me.taskEdit) {
                  _context.next = 19;
                  break;
                }

                _context.next = 18;
                return me.project.commitAsync();

              case 18:
                me.editEvent(eventRecord, resourceRecord);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function internalAddEvent(_x, _x2, _x3) {
        return _internalAddEvent.apply(this, arguments);
      }

      return internalAddEvent;
    }()
    /**
     * Checks if a date range is allocated or not for a given resource.
     * @param {Date} start The start date
     * @param {Date} end The end date
     * @param {Scheduler.model.EventModel|null} excludeEvent An event to exclude from the check (or null)
     * @param {Scheduler.model.ResourceModel} resource The resource
     * @return {Boolean} True if the timespan is available for the resource
     * @category Dates
     */

  }, {
    key: "isDateRangeAvailable",
    value: function isDateRangeAvailable(start, end, excludeEvent, resource) {
      return this.eventStore.isDateRangeAvailable(start, end, excludeEvent, resource);
    } //endregion

    /**
     * Suspends UI refresh on store operations.
     *
     * Multiple calls to `suspendRefresh` stack up, and will require an equal number of `resumeRefresh` calls to
     * actually resume UI refresh.
     *
     * @function suspendRefresh
     */

    /**
     * Resumes UI refresh on store operations.
     *
     * Multiple calls to `suspendRefresh` stack up, and will require an equal number of `resumeRefresh` calls to
     * actually resume UI refresh.
     *
     * Specify `true` as the first param to trigger a refresh if this call unblocked the refresh suspension.
     * If the underlying project is calculating changes, the refresh will be postponed until it is done.
     *
     * @param {Boolean} trigger `true` to trigger a refresh, if this resume unblocks the suspend
     * @returns {Promise}
     */

  }, {
    key: "resumeRefresh",
    value: function () {
      var _resumeRefresh = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee2(trigger) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "resumeRefresh", this).call(this, false);

                if (!(!this.refreshSuspended && trigger)) {
                  _context2.next = 6;
                  break;
                }

                if (this.isEngineReady) {
                  _context2.next = 5;
                  break;
                }

                // Refresh will happen because of the commit, bail out of this one after forcing rendering to consider
                // next one a full refresh
                this.currentOrientation.refreshAllWhenReady = true;
                return _context2.abrupt("return", this.project.commitAsync());

              case 5:
                // View could've been destroyed while we waited for engine
                if (!this.isDestroyed) {
                  // If it already is, refresh now
                  this.refreshWithTransition();
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function resumeRefresh(_x4) {
        return _resumeRefresh.apply(this, arguments);
      }

      return resumeRefresh;
    }() //region Appearance
    // Overrides grid to take crudManager loading into account

  }, {
    key: "toggleEmptyText",
    value: function toggleEmptyText() {
      var me = this;

      if (me.bodyContainer) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].toggleClasses(me.bodyContainer, 'b-grid-empty', !(me.rowManager.rowCount || me.crudManager && me.crudManager.isLoading));
      }
    } // Overrides Grids base implementation to return a correctly calculated height for the row. Also stores it in
    // RowManagers height map, which is used to calculate total height etc.

  }, {
    key: "getRowHeight",
    value: function getRowHeight(resourceRecord) {
      if (this.currentOrientation.calculateRowHeight) {
        var height = this.currentOrientation.calculateRowHeight(resourceRecord);
        this.rowManager.storeKnownHeight(resourceRecord.id, height);
        return height;
      }
    } // Calculates the height for specified rows. Call when changes potentially makes its height invalid

  }, {
    key: "calculateRowHeights",
    value: function calculateRowHeights(resourceRecords) {
      var _this = this;

      var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // Array allowed to have nulls in it for easier code when calling this fn
      resourceRecords.forEach(function (resourceRecord) {
        return resourceRecord && _this.getRowHeight(resourceRecord);
      });

      if (!silent) {
        this.rowManager.estimateTotalHeight(true);
      }
    } // Calculate heights for all rows (up to the preCalculateHeightLimit)

  }, {
    key: "calculateAllRowHeights",
    value: function calculateAllRowHeights() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var store = this.store,
          rowManager = this.rowManager,
          count = Math.min(store.count, this.preCalculateHeightLimit); // Allow opt out by specifying falsy value.

      if (count) {
        rowManager.clearKnownHeights();

        for (var i = 0; i < count; i++) {
          // This will both calculate and store the height
          this.getRowHeight(store.getAt(i));
        } // Make sure height is reflected on scroller etc.


        if (!silent) {
          rowManager.estimateTotalHeight(true);
        }
      }
    } //endregion

  }, {
    key: "timeAxisViewModel",
    set: function set(timeAxisViewModel) {
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "timeAxisViewModel", timeAxisViewModel, this, true);

      if (this.eventStore) {
        this.timeAxisViewModel.eventStore = this.eventStore;
      }
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "timeAxisViewModel", this);
    } // Placeholder getter/setter for mixins, please make any changes needed to SchedulerStores#store instead

  }, {
    key: "store",
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "store", this);
    },
    set: function set(store) {
      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerBase.prototype), "store", store, this, true);
    }
  }, {
    key: "isHorizontal",
    get: function get() {
      return this.mode === 'horizontal';
    }
    /**
     * Checks if scheduler is in vertical mode
     * @returns {Boolean}
     * @readonly
     * @category Common
     * @private
     */

  }, {
    key: "isVertical",
    get: function get() {
      return this.mode === 'vertical';
    }
    /**
     * Get/set mode (horizontal/vertical)
     * @property {String}
     * @private
     * @category Common
     */

  }, {
    key: "mode",
    get: function get() {
      return this._mode;
    },
    set: function set(mode) {
      var me = this;
      me._mode = mode;

      if (!me[mode]) {
        if (mode === 'horizontal') {
          me.horizontal = new _orientation_HorizontalRendering_js__WEBPACK_IMPORTED_MODULE_32__["default"](me);

          if (me.isPainted) {
            me.horizontal.init();
          }

          me.un('scroll', me.onVerticalScroll, me);
        } else if (mode === 'vertical') {
          // Zooming is not yet supported in vertical mode, disable it
          me.zoomOnTimeAxisDoubleClick = me.zoomOnMouseWheel = false;
          me.vertical = new _orientation_VerticalRendering_js__WEBPACK_IMPORTED_MODULE_33__["default"](me);

          if (me.rendered) {
            me.vertical.init();
          }

          me.on('scroll', me.onVerticalScroll, me);
        }
      }
    }
  }, {
    key: "currentOrientation",
    get: function get() {
      return this[this.mode];
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'SchedulerBase';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'schedulerbase';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * Scheduler mode. Supported values: horizontal, vertical
         * @config {String} mode
         * @default
         */
        mode: 'horizontal',

        /**
         * CSS class to add to rendered events
         * @config {String}
         * @category CSS
         * @private
         * @default
         */
        eventCls: 'b-sch-event',

        /**
         * CSS class to add to cells in the timeaxis column
         * @config {String}
         * @category CSS
         * @private
         * @default
         */
        timeCellCls: 'b-sch-timeaxis-cell',
        timeCellSelector: '.b-sch-timeaxis-cell',
        scheduledEventName: 'event',

        /**
         * A CSS class to apply to each event in the view on mouseover (defaults to 'b-sch-event-hover').
         * @config {String}
         * @default
         * @category CSS
         * @private
         */
        overScheduledEventClass: 'b-sch-event-hover',

        /**
         * Set to false if you don't want to allow events overlapping times for any one resource (defaults to true).
         * @config {Boolean}
         * @default
         * @category Scheduled events
         */
        allowOverlap: true,

        /**
         * The height in pixels of Scheduler rows.
         * @config {Number}
         * @default
         */
        rowHeight: 60,

        /**
         * Factor representing the average char width in pixels used to determine milestone width when configured
         * with `milestoneLayoutMode: 'estimate'`.
         * @config {Number}
         * @default
         */
        milestoneCharWidth: 10,

        /**
         * How to align milestones in relation to their startDate. Only applies when using a `milestoneLayoutMode`
         * other than `default`. Valid values are:
         * * start
         * * center (default)
         * * end
         */
        milestoneAlign: 'center',

        /**
         * Scheduler overrides Grids default implementation of {@link Grid.view.GridBase#config-getRowHeight} to
         * pre-calculate row heights based on events in the rows.
         *
         * The amount of rows that are pre-calculated is limited for performance reasons. The limit is configurable
         * by specifying the {@link Scheduler.view.SchedulerBase#config-preCalculateHeightLimit} config.
         *
         * The results of the calculation are cached internally.
         *
         * @config {Function} getRowHeight
         * @param {Scheduler.model.ResourceModel} getRowHeight.record Resource record to determine row height for
         * @returns {Number} Desired row height
         * @category Layout
         */

        /**
         * Maximum number of resources for which height is pre-calculated. If you have many events per
         * resource you might want to lower this number to gain some initial rendering performance.
         *
         * Specify a falsy value to opt out of row height pre-calculation.
         *
         * @config {Number}
         * @default
         * @category Layout
         */
        preCalculateHeightLimit: 10000,
        // This is determined by styling, in the future it should be measured
        milestoneMinWidth: 40,
        crudManagerClass: _data_CrudManager_js__WEBPACK_IMPORTED_MODULE_19__["default"],
        testConfig: {
          loadMaskError: {
            autoClose: 10,
            showDelay: 0
          }
        }
      };
    }
  }, {
    key: "deprecatedEvents",
    get: function get() {
      return {
        eventContextMenuBeforeShow: {
          product: 'Scheduler',
          invalidAsOfVersion: '5.0.0',
          message: '`eventContextMenuBeforeShow` event is deprecated, in favor of `eventMenuBeforeShow` event. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.'
        },
        eventContextMenuShow: {
          product: 'Scheduler',
          invalidAsOfVersion: '5.0.0',
          message: '`eventContextMenuShow` event is deprecated, in favor of `eventMenuShow` event. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.'
        },
        eventContextMenuItem: {
          product: 'Scheduler',
          invalidAsOfVersion: '5.0.0',
          message: '`eventContextMenuItem` event is deprecated, in favor of `eventMenuItem` event. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.'
        },
        scheduleContextMenuBeforeShow: {
          product: 'Scheduler',
          invalidAsOfVersion: '5.0.0',
          message: '`scheduleContextMenuBeforeShow` event is deprecated, in favor of `scheduleMenuBeforeShow` event. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.'
        },
        scheduleContextMenuShow: {
          product: 'Scheduler',
          invalidAsOfVersion: '5.0.0',
          message: '`scheduleContextMenuShow` event is deprecated, in favor of `scheduleMenuShow` event. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.'
        },
        scheduleContextMenuItem: {
          product: 'Scheduler',
          invalidAsOfVersion: '5.0.0',
          message: '`scheduleContextMenuItem` event is deprecated, in favor of `scheduleMenuItem` event. Please see https://bryntum.com/docs/scheduler/#guides/upgrades/3.1.0.md for more information.'
        }
      };
    }
  }]);

  return SchedulerBase;
}(_TimelineBase_js__WEBPACK_IMPORTED_MODULE_16__["default"].mixin(_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_31__["default"], _mixin_SchedulerDom_js__WEBPACK_IMPORTED_MODULE_21__["default"], _mixin_SchedulerDomEvents_js__WEBPACK_IMPORTED_MODULE_22__["default"], _mixin_SchedulerDragResize_js__WEBPACK_IMPORTED_MODULE_23__["default"], _mixin_SchedulerStores_js__WEBPACK_IMPORTED_MODULE_25__["default"], _mixin_SchedulerScroll_js__WEBPACK_IMPORTED_MODULE_26__["default"], _mixin_SchedulerState_js__WEBPACK_IMPORTED_MODULE_28__["default"], _mixin_SchedulerEventRendering_js__WEBPACK_IMPORTED_MODULE_24__["default"], _mixin_SchedulerRegions_js__WEBPACK_IMPORTED_MODULE_27__["default"], _mixin_EventSelection_js__WEBPACK_IMPORTED_MODULE_29__["default"], _mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_30__["default"])); // Register this widget type with its Factory



SchedulerBase.initClass(); // Scheduler version is specified in TimelineBase because Gantt extends it

SchedulerBase._$name = 'SchedulerBase';

/***/ }),

/***/ "./lib/Scheduler/view/TimeAxisBase.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/view/TimeAxisBase.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisBase; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");




















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/view/TimeAxisBase
 */

function isLastLevel(level, levels) {
  return level === levels.length - 1;
}

function isLastCell(level, cell) {
  return cell === level.cells[level.cells.length - 1];
}
/**
 * Base class for HorizontalTimeAxis and VerticalTimeAxis. Contains shared functionality to only render ticks in view,
 * should not be used directly.
 *
 * @extends Core/widget/Widget
 * @private
 * @abstract
 */


var TimeAxisBase = /*#__PURE__*/function (_Widget) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(TimeAxisBase, _Widget);

  var _super = _createSuper(TimeAxisBase);

  function TimeAxisBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, TimeAxisBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(TimeAxisBase, [{
    key: "buildCells",
    //endregion
    //region Html & rendering
    // Generates element configs for all levels defined by the current ViewPreset
    value: function buildCells() {
      var _me$client;

      var me = this,
          sizeProperty = me.sizeProperty,
          featureHeaderConfigs = [],
          cellConfigs = me.levels.map(function (level, i) {
        var _className, _level$cells;

        return {
          className: (_className = {
            'b-sch-header-row': 1
          }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_className, "b-sch-header-row-".concat(level.position), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_className, 'b-sch-header-row-main', i === me.model.viewPreset.mainHeaderLevel), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_className, 'b-lowest', isLastLevel(i, me.levels)), _className),
          syncOptions: {
            // Keep a maximum of 5 released cells. Might be fine with fewer since ticks are fixed width.
            // Prevents an unnecessary amount of cells from sticking around when switching from narrow to
            // wide tickSizes
            releaseThreshold: 5,
            syncIdField: 'tickIndex'
          },
          dataset: {
            headerFeature: "headerRow".concat(i),
            headerPosition: level.position
          },
          // Only include cells in view
          children: (_level$cells = level.cells) === null || _level$cells === void 0 ? void 0 : _level$cells.filter(function (cell) {
            return cell.start < me.endDate && cell.end > me.startDate;
          }).map(function (cell) {
            var _className2, _style;

            return {
              className: (_className2 = {
                'b-sch-header-timeaxis-cell': 1
              }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_className2, cell.headerCellCls, cell.headerCellCls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_className2, "b-align-".concat(cell.align), cell.align), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_className2, 'b-last', isLastCell(level, cell)), _className2),
              dataset: _objectSpread({
                tickIndex: cell.index
              }, window.DEBUG && {
                date: cell.start.getTime()
              }),
              style: (_style = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_style, me.positionProperty, cell.coord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_style, sizeProperty, cell.width), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_style, "min-".concat(sizeProperty), cell.width), _style),
              children: me.wrapText ? [{
                className: 'b-sch-header-text',
                html: cell.value
              }] : null,
              html: me.wrapText ? null : cell.value
            };
          })
        };
      }); // When tested in isolation there is no client

      (_me$client = me.client) === null || _me$client === void 0 ? void 0 : _me$client.getHeaderDomConfigs(featureHeaderConfigs);
      cellConfigs.push.apply(cellConfigs, featureHeaderConfigs); // noinspection JSSuspiciousNameCombination

      return {
        className: "b-widget ".concat(me.cls),
        syncOptions: {
          // Do not keep entire levels no longer used, for example after switching view preset
          releaseThreshold: 0
        },
        style: _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()({}, sizeProperty, me.size),
        children: cellConfigs
      };
    }
  }, {
    key: "render",
    value: function render(targetElement) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_15___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(TimeAxisBase.prototype), "render", this).call(this, targetElement);

      this.refresh(true);
    }
    /**
     * Refresh the UI
     * @param {Boolean} [rebuild] Specify `true` to force a rebuild of the underlying header level definitions
     */

  }, {
    key: "refresh",
    value: function refresh() {
      var rebuild = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.levels.length;
      var me = this,
          columnConfig = me.model.columnConfig,
          levels = me.levels,
          oldLevelsCount = levels.length;

      if (rebuild) {
        levels.length = 0;
        columnConfig.forEach(function (cells, position) {
          return levels[position] = {
            position: position,
            cells: cells
          };
        });
        me.size = levels[0].cells.reduce(function (sum, cell) {
          return sum += cell.width;
        }, 0); // TODO clean up when this is fixed: https://app.assembla.com/spaces/bryntum/tickets/8413-horizontaltimeaxis-should-not-completely-overwrite-contents-of-column-el/details#

        var parentEl = me.element.parentElement;

        if (parentEl) {
          parentEl.classList.remove("b-sch-timeaxiscolumn-levels-".concat(oldLevelsCount));
          parentEl.classList.add("b-sch-timeaxiscolumn-levels-".concat(levels.length));
        }
      }

      if (!me.startDate || !me.endDate) {
        return;
      } // Boil down levels to only show what is in view


      _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_20__["default"].sync({
        domConfig: me.buildCells(),
        targetElement: me.element,
        syncIdField: 'headerFeature'
      });
      me.trigger('refresh');
    } //endregion
    // This does not need a className on Widgets.
    // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
    // to the Widget it's mixed in to should implement thus.

  }, {
    key: "range",
    // Set visible date range
    set: function set(range) {
      this.startDate = range.startDate;
      this.endDate = range.endDate;
      this.refresh();
    }
  }, {
    key: "widgetClass",
    get: function get() {}
  }], [{
    key: "defaultConfig",
    //region Config
    get: function get() {
      return {
        /**
         * The minimum width for a bottom row header cell to be considered 'compact', which adds a special CSS class
         * to the row (for special styling). Copied from Scheduler/Gantt.
         * @config {Number}
         * @default
         */
        compactCellWidthThreshold: 15,
        // TimeAxisViewModel
        model: null,
        cls: null,

        /**
         * Style property to use as cell size. Either width or height depending on orientation
         * @config {String}
         * @private
         */
        sizeProperty: null,

        /**
         * Style property to use as cells position. Either left or top depending on orientation
         * @config {String}
         * @private
         */
        positionProperty: null,

        /**
         * Specify `true` to wrap header text in `.b-sch-header-text`
         * @config {String}
         * @private
         */
        wrapText: null
      };
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        startDate: null,
        endDate: null,
        levels: [],
        size: null
      };
    }
  }]);

  return TimeAxisBase;
}(_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_19__["default"]);


TimeAxisBase._$name = 'TimeAxisBase';

/***/ }),

/***/ "./lib/Scheduler/view/TimelineBase.js":
/*!********************************************!*\
  !*** ./lib/Scheduler/view/TimelineBase.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimelineBase; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _Grid_view_GridBase_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../Grid/view/GridBase.js */ "./lib/Grid/view/GridBase.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../Core/helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../Core/helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Header_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./Header.js */ "./lib/Scheduler/view/Header.js");
/* harmony import */ var _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../data/TimeAxis.js */ "./lib/Scheduler/data/TimeAxis.js");
/* harmony import */ var _model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./model/TimeAxisViewModel.js */ "./lib/Scheduler/view/model/TimeAxisViewModel.js");
/* harmony import */ var _mixin_TimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./mixin/TimelineDateMapper.js */ "./lib/Scheduler/view/mixin/TimelineDateMapper.js");
/* harmony import */ var _mixin_TimelineDomEvents_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./mixin/TimelineDomEvents.js */ "./lib/Scheduler/view/mixin/TimelineDomEvents.js");
/* harmony import */ var _mixin_TimelineViewPresets_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./mixin/TimelineViewPresets.js */ "./lib/Scheduler/view/mixin/TimelineViewPresets.js");
/* harmony import */ var _mixin_TimelineZoomable_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./mixin/TimelineZoomable.js */ "./lib/Scheduler/view/mixin/TimelineZoomable.js");
/* harmony import */ var _mixin_RecurringEvents_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./mixin/RecurringEvents.js */ "./lib/Scheduler/view/mixin/RecurringEvents.js");
/* harmony import */ var _mixin_TimelineEventRendering_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./mixin/TimelineEventRendering.js */ "./lib/Scheduler/view/mixin/TimelineEventRendering.js");
/* harmony import */ var _mixin_TimelineScroll_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./mixin/TimelineScroll.js */ "./lib/Scheduler/view/mixin/TimelineScroll.js");
























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_21___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




















var timeAxisColumnConfigs = ['viewPreset', 'eventBarTextField', 'eventRenderer', 'eventRendererThisObj', 'eventBodyTemplate'],
    exitTransition = {
  fn: 'exitTransition',
  delay: 0,
  cancelOutstanding: true
};
/**
 * @module Scheduler/view/TimelineBase
 */

/**
 * Abstract base class used by timeline based components such as Scheduler and Gantt. Based on Grid, supplies a "locked"
 * region for columns and a "normal" for rendering of events etc.
 * @abstract
 *
 * @mixes Scheduler/view/mixin/TimelineDateMapper
 * @mixes Scheduler/view/mixin/TimelineDomEvents
 * @mixes Scheduler/view/mixin/TimelineEventRendering
 * @mixes Scheduler/view/mixin/TimelineScroll
 * @mixes Scheduler/view/mixin/TimelineViewPresets
 * @mixes Scheduler/view/mixin/TimelineZoomable
 * @mixes Scheduler/view/mixin/RecurringEvents
 *
 * @extends Grid/view/Grid
 */

var TimelineBase = /*#__PURE__*/function (_GridBase$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(TimelineBase, _GridBase$mixin);

  var _super = _createSuper(TimelineBase);

  function TimelineBase() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_16___default()(this, TimelineBase);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_17___default()(TimelineBase, [{
    key: "construct",
    //endregion
    //region Init
    value: function construct() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this,
          region = config.schedulerRegion || 'normal',
          _config$subGridConfig = config.subGridConfigs,
          subGridConfigs = _config$subGridConfig === void 0 ? {} : _config$subGridConfig;
      config.subGridConfigs = subGridConfigs;
      subGridConfigs[region] = subGridConfigs[region] || {};
      subGridConfigs[region].headerClass = _Header_js__WEBPACK_IMPORTED_MODULE_33__["default"]; // If user have not specified a width or flex for scheduler region, default to flex=1

      if (!('flex' in subGridConfigs[region] || 'width' in subGridConfigs[region])) {
        subGridConfigs[region].flex = 1;
      } // Zooming falls back on config.startDate/endDate, make sure they are dates


      if (config.startDate) {
        config.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].parse(config.startDate);
      }

      if (config.endDate) {
        config.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].parse(config.endDate);
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "construct", this).call(this, config);

      me.$firstVerticalOverflow = true; // Buffer resize, since resize does full redraw it is costly

      me.onSchedulerViewportResize = me.throttle(me.onSchedulerViewportResize, 250);
      me.initDomEvents();
      me.currentOrientation.init();
      me.rowManager.on('refresh', function () {
        me.forceLayout = false;
      });
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      var me = this,
          currentOrientation = this.currentOrientation;

      if (currentOrientation) {
        currentOrientation.destroy();
      } // Break links between this TimeLine and any partners.


      if (me.partneredWith) {
        me.partneredWith.forEach(function (p) {
          me.removePartner(p);
        });
        me.partneredWith.destroy();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "doDestroy", this).call(this);
    }
  }, {
    key: "startConfigure",
    value: function startConfigure(config) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "startConfigure", this).call(this, config); // partner needs to be initialized first so that the various shared
      // configs are assigned first before we default them in.


      this._thisIsAUsedExpression(this.partner);
    }
  }, {
    key: "refreshVirtualScrollbars",
    value: function refreshVirtualScrollbars() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "refreshVirtualScrollbars", this).call(this);

      if (!this.hasVerticalOverflow) {
        var scrollable = this.scrollable;

        if (this.partners.some(function (p) {
          return p.hasVerticalOverflow;
        })) {
          scrollable.overflowY = 'scroll';
        } else {
          scrollable.overflowY = true;
        }
      }
    }
  }, {
    key: "onPaint",
    value: function onPaint(_ref) {
      var firstPaint = _ref.firstPaint;

      // Upon first paint we need to pass the forceUpdate flag in case we are sharing the TimAxisViewModel
      // with another Timeline which will already have done this.
      if (firstPaint) {
        // subGrid in IE11 doesn't have height at this point, but container element does so we take it from there
        // TODO: make flex element inherit height from parent (min-height: 100% doesn't work)
        var timeAxisSubGrid = this.timeAxisSubGrid,
            availableSpace = this.isVertical ? this.bodyContainer.offsetHeight : timeAxisSubGrid.width;
        this.timeAxisViewModel.update(availableSpace, false, true);
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "onPaint", this).call(this, Array.prototype.slice.call(arguments));
    }
  }, {
    key: "changeSubGridConfigs",
    value: function changeSubGridConfigs(configs) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "changeSubGridConfigs", this).call(this, configs);

      var me = this,
          timeAxisSubGrid = me.timeAxisSubGrid = me.subGrids[me.timeAxisColumn.region]; // Scheduler SubGrid doesn't accept external columns moving in

      timeAxisSubGrid.sealedColumns = true;
      timeAxisSubGrid.on({
        resize: me.onTimeAxisSubGridResize,
        thisObj: me
      });
    }
  }, {
    key: "onSchedulerHorizontalScroll",
    value: function onSchedulerHorizontalScroll(subGrid, scrollLeft) {
      // rerender cells in scheduler column on horizontal scroll to display events in view
      this.currentOrientation.updateFromHorizontalScroll(scrollLeft);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "onSchedulerHorizontalScroll", this).call(this, subGrid, scrollLeft);
    }
    /**
     * Overrides initScroll from Grid, listens for horizontal scroll to do virtual event rendering
     * @private
     */

  }, {
    key: "initScroll",
    value: function initScroll() {
      var me = this;
      var frameCount = 0;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "initScroll", this).call(this); // Fixes scroll freezing bug on iPad by putting scheduler scroller in its own layer


      if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isMobileSafari) {
        me.scrollable.element.style.transform = 'translate3d(0, 0, 0)';
      }

      me.on('horizontalscroll', function (_ref2) {
        var subGrid = _ref2.subGrid,
            scrollLeft = _ref2.scrollLeft;

        if (me.isPainted && subGrid === me.timeAxisSubGrid && !me.isDestroying && !me.refreshSuspended) {
          me.onSchedulerHorizontalScroll(subGrid, scrollLeft);
        }

        frameCount++;
      });

      if (me.testPerformance === 'horizontal') {
        me.setTimeout(function () {
          var start = performance.now(),
              // eslint-disable-line no-undef
          scrollSpeed = 5,
              direction = 1;
          var scrollInterval = me.setInterval(function () {
            scrollSpeed = scrollSpeed + 5;
            me.scrollLeft += (10 + Math.floor(scrollSpeed)) * direction;

            if (direction === 1 && me.scrollLeft > 5500) {
              direction = -1;
              scrollSpeed = 5;
            }

            if (direction === -1 && me.scrollLeft <= 0) {
              var done = performance.now(),
                  // eslint-disable-line no-undef
              elapsed = done - start;
              var timePerFrame = elapsed / frameCount,
                  fps = 1000 / timePerFrame;
              fps = Math.round(fps * 10) / 10;
              clearInterval(scrollInterval);
              console.log(me.eventPositionMode, me.eventScrollMode, fps + 'fps');
            }
          }, 0);
        }, 500);
      }
    } //endregion

    /**
     * Calls the specified function (returning its return value) and preserves the timeline center
     * point. This is a useful way of retaining the user's visual context while making updates
     * and changes to the view which require major changes or a full refresh.
     * @param {Function} fn The function to call.
     * @param {Object} thisObj The `this` context for the function.
     * @param {...*} args Parameters to the function.
     */

  }, {
    key: "preserveViewCenter",
    value: function preserveViewCenter(fn) {
      var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var me = this,
          centerDate = me.viewportCenterDate,
          result = fn.apply(thisObj, args);
      var isVertical = me.isVertical,
          scroller = isVertical ? me.scrollable : me.timeAxisSubGrid.scrollable,
          clientSize = scroller[isVertical ? 'clientHeight' : 'clientWidth'],
          scrollStart = Math.max(Math.floor(me.getCoordinateFromDate(centerDate, true) - clientSize / 2), 0);
      me.scrollingToCenter = true;
      me[isVertical ? 'scrollVerticallyTo' : 'scrollHorizontallyTo'](scrollStart, false).then(function () {
        return me.scrollingToCenter = false;
      });
      return result;
    } //region Config getters/setters

    /**
     * Returns `true` if any of the events/tasks or feature injected elements (such as ResourceTimeRanges) are within
     * the {@link #config-timeAxis}
     * @property {Boolean}
     * @readonly
     */

  }, {
    key: "noFeatureElementsInAxis",
    // Template function to be chained in features to determine if any elements are in time axis (needed since we cannot
    // currently chain getters). Negated to not break chain. First feature that has elements visible returns false,
    // which prevents other features from being queried.
    value: function noFeatureElementsInAxis() {} // Private getter used to piece togheter event names such as beforeEventDrag / beforeTaskDrag. Could also be used
    // in templates.

  }, {
    key: "removePartner",
    value: function removePartner(partner) {
      var me = this,
          partneredWith = me.partneredWith;

      if (partneredWith === null || partneredWith === void 0 ? void 0 : partneredWith.includes(partner)) {
        partneredWith.remove(partner);
        partner.partneredWith.remove(me);
        partner.scrollable.removePartner(me.scrollable);
        partner.un({
          presetchange: 'onPartnerPresetChange',
          thisObj: me
        });
        me.un({
          presetchange: 'onPartnerPresetChange',
          thisObj: partner
        });
      }
    }
  }, {
    key: "onPartnerPresetChange",
    value: function onPartnerPresetChange(_ref3) {
      var preset = _ref3.preset,
          startDate = _ref3.startDate,
          endDate = _ref3.endDate,
          centerDate = _ref3.centerDate;

      if (!this._viewPresetChanging && this.viewPreset !== preset) {
        // Passed through to the viewPreset changing method
        preset.options = {
          startDate: startDate,
          endDate: endDate,
          centerDate: centerDate
        };
        this.viewPreset = preset;
      }
    }
  }, {
    key: "applyWorkingTime",
    // Translates the workingTime configs into TimeAxis#include rules, applies them and then refreshes the header and
    // redraws the events
    value: function applyWorkingTime(timeAxis) {
      var me = this,
          config = me._workingTime;

      if (config) {
        var hour = null; // Only use valid values

        if (config.fromHour >= 0 && config.fromHour < 24 && config.toHour > config.fromHour && config.toHour <= 24 && config.toHour - config.fromHour < 24) {
          hour = {
            from: config.fromHour,
            to: config.toHour
          };
        }

        var day = null; // Only use valid values

        if (config.fromDay >= 0 && config.fromDay < 7 && config.toDay > config.fromDay && config.toDay <= 7 && config.toDay - config.fromDay < 7) {
          day = {
            from: config.fromDay,
            to: config.toDay
          };
        }

        if (hour || day) {
          timeAxis.include = {
            hour: hour,
            day: day
          };
        } else {
          // No valid rules, restore timeAxis
          timeAxis.include = null;
        }
      } else {
        // No rules, restore timeAxis
        timeAxis.include = null;
      }

      if (me.isPainted) {
        var _me$features$columnLi;

        // Refreshing header, which also recalculate tickSize and header data
        me.timeAxisColumn.refreshHeader(); // Update column lines

        (_me$features$columnLi = me.features.columnLines) === null || _me$features$columnLi === void 0 ? void 0 : _me$features$columnLi.refresh(); // Animate event changes

        me.refreshWithTransition();
      }
    }
    /**
     * Get/set startDate. Defaults to current date if none specified.
     *
     * **Note:** If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
     * @property {Date}
     * @category Common
     */

  }, {
    key: "setStartDate",

    /**
     * Sets the timeline start date.
     *
     * **Note:**
     * - If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
     * - If keepDuration is false and new start date is greater than end date, it will throw an exception.
     *
     * @param {Date} date The new start date
     * @param {Boolean} keepDuration Pass `true` to keep the duration of the timeline ("move" the timeline),
     * `false` to change the duration ("resize" the timeline). Defaults to `true`.
     */
    value: function setStartDate(date) {
      var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var me = this,
          ta = me._timeAxis || {},
          startDate = ta.startDate,
          endDate = ta.endDate,
          mainUnit = ta.mainUnit;

      if (typeof date === 'string') {
        date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].parse(date);
      }

      if (me._timeAxis && endDate) {
        if (date) {
          var calcEndDate = endDate;

          if (keepDuration && startDate) {
            var diff = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].diff(startDate, endDate, mainUnit, true);
            calcEndDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].add(date, diff, mainUnit);
          }

          ta.setTimeSpan(date, calcEndDate);
        }
      } else {
        me._tempStartDate = date;
      }
    }
  }, {
    key: "setEndDate",

    /**
     * Sets the timeline end date
     *
     * **Note:**
     * - If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
     * - If keepDuration is false and new end date is less than start date, it will throw an exception.
     *
     * @param {Date} date The new end date
     * @param {Boolean} keepDuration Pass `true` to keep the duration of the timeline ("move" the timeline),
     * `false` to change the duration ("resize" the timeline). Defaults to `false`.
     */
    value: function setEndDate(date) {
      var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          ta = me._timeAxis || {},
          startDate = ta.startDate,
          endDate = ta.endDate,
          mainUnit = ta.mainUnit;

      if (typeof date === 'string') {
        date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].parse(date);
      }

      if (me._timeAxis && startDate) {
        if (date) {
          var calcStartDate = startDate;

          if (keepDuration && endDate) {
            var diff = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].diff(startDate, endDate, mainUnit, true);
            calcStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].add(date, -diff, mainUnit);
          }

          ta.setTimeSpan(calcStartDate, date);
        }
      } else {
        me._tempEndDate = date;
      }
    }
  }, {
    key: "onLocaleChange",
    //endregion
    //region Event handlers
    value: function onLocaleChange() {
      // Clear events in case they use date as part of displayed info
      //        this.currentOrientation.cache.clear();
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "onLocaleChange", this).call(this);

      this.timeAxisColumn.refreshHeader();
    }
    /**
     * This is a template method called by Widget when the encapsulating Scheduler SubGrid size.
     * Width changes *might* affect the Scheduler SubGrid, and *that* will trigger its
     * handler below, if that is the case. Here, we are only interested in the height changing because the
     * encapsulating grid is what dictates the scrolling viewport height.
     * @param {HTMLElement} element
     * @param {Number} width
     * @param {Number} height
     * @param {Number} oldWidth
     * @param {Number} oldHeight
     * @private
     */

  }, {
    key: "onInternalResize",
    value: function onInternalResize(element, width, height, oldWidth, oldHeight) {
      // Cache before its updated by super call.
      var oldSchedulerBodyRect = this._bodyRectangle;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "onInternalResize", this).call(this, element, width, height, oldWidth, oldHeight); // The Scheduler (The Grid) dictates the viewport height.


      if (oldSchedulerBodyRect && (height !== oldHeight || width !== oldWidth)) {
        this.onSchedulerViewportResize(width, height, oldSchedulerBodyRect.width, oldSchedulerBodyRect.height);
      }
    }
    /**
     * This is an event handler triggered when the Scheduler SubGrid changes size.
     * Its height changes when content height changes, and that is not what we are
     * interested in here. If the *width* changes, that means the visible viewport
     * has changed size.
     * @param {HTMLElement} element
     * @param {Number} width
     * @param {Number} height
     * @param {Number} oldWidth
     * @param {Number} oldHeight
     * @private
     */

  }, {
    key: "onTimeAxisSubGridResize",
    value: function onTimeAxisSubGridResize(_ref4) {
      var width = _ref4.width,
          height = _ref4.height,
          oldWidth = _ref4.oldWidth,
          oldHeight = _ref4.oldHeight;
      var me = this; // The timeAxisSubGrid dictates the viewport width.

      if (me.isPainted && width !== oldWidth) {
        var schedulerBodyRect = me._bodyRectangle; // For the first vertical overflow (likely when rows are rendered the first time), we want to update size
        // immediately to reduce initial "jumpiness" a bit

        if (me.hasVerticalOverflow && me.$firstVerticalOverflow) {
          me.onSchedulerViewportResize.now(width, schedulerBodyRect.height, oldWidth, schedulerBodyRect.height);
          me.$firstVerticalOverflow = false;
        } else {
          me.onSchedulerViewportResize(width, schedulerBodyRect.height, oldWidth, schedulerBodyRect.height);
        }
      }
    } // Note: This function is throttled in construct(), since it will do a full redraw per call

  }, {
    key: "onSchedulerViewportResize",
    value: function onSchedulerViewportResize(width, height, oldWidth, oldHeight) {
      if (this.isPainted) {
        var me = this,
            subGrid = me.timeAxisSubGrid;
        me.currentOrientation.onViewportResize(width, height, oldWidth, oldHeight); // Ignore resize caused by toggling vertical scrollbar visibility, since those might otherwise lead to an
        // infinite loop when the difference between on/off causes horizontal scrolling to also toggle

        if (me._lastOverflow == null || me._lastOverflow === subGrid.overflowingHorizontally) {
          // Responding by triggering a layout in the same frame seems to trigger an infinite resize
          // loop when using ResizeObserver, so push the response out into the next frame.
          me.setTimeout(function () {
            me.timeAxisViewModel.availableSpace = me.isHorizontal ? subGrid.width : me._bodyRectangle.height;
          }, 0);
          me.partneredWith && !me.isSyncingFromPartner && me.partneredWith.forEach(function (p) {
            if (!p.isSyncingFromPartner) {
              p.isSyncingFromPartner = true;
              me.eachSubGrid(function (subGrid) {
                var partnerSubGrid = p.subGrids[subGrid.region]; // If there is a difference, sync the partner SubGrid state

                if (partnerSubGrid.width !== subGrid.width) {
                  if (subGrid.collapsed) {
                    partnerSubGrid.collapse();
                  } else {
                    if (partnerSubGrid.collapsed) {
                      partnerSubGrid.expand();
                    } // When using flexed subgrid, make sure flex values has prio over width


                    if (subGrid.flex) {
                      // If flex values match, resize should be fine without changing anything
                      if (subGrid.flex !== partnerSubGrid.flex) {
                        partnerSubGrid.flex = subGrid.flex;
                      }
                    } else {
                      partnerSubGrid.width = subGrid.width;
                    }
                  }
                }
              });
              p.isSyncingFromPartner = false;
            }
          });
        } // NOTE: Moved out of the if-statement above since that prevented event from being triggered in all
        // scenarios where size has changed

        /**
         * Fired when the *scheduler* viewport (not the overall Scheduler element) changes size.
         * This happens when the grid changes height, or when the subgrid which encapsulates the
         * scheduler column changes width.
         * @event timelineViewportResize
         * @param {Core.widget.Widget} source - This Scheduler
         * @param {Number} width The new width
         * @param {Number} height The new height
         * @param {Number} oldWidth The old width
         * @param {Number} oldHeight The old height
         */


        me.trigger('timelineViewportResize', {
          width: width,
          height: height,
          oldWidth: oldWidth,
          oldHeight: oldHeight
        });
        me._lastOverflow = subGrid.overflowingHorizontally;
      }
    }
  }, {
    key: "onTimeAxisViewModelUpdate",
    value: function onTimeAxisViewModelUpdate() {
      this.updateCanvasSize();
      this.currentOrientation.onTimeAxisViewModelUpdate();
    } //endregion
    //region Mode

  }, {
    key: "updateCanvasSize",
    value: function updateCanvasSize() {
      var me = this,
          width = me.isHorizontal ? me.timeAxisViewModel.totalSize : me.timeAxisColumn.width;
      var result = false; // Canvas might need a height in vertical mode, if ticks does not fill height (suppressFit : true)

      if (me.isVertical && me.suppressFit) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].setLength(me.foregroundCanvas, 'height', me.timeAxisViewModel.totalSize);
        result = true;
      }

      if (width !== me.$canvasWidth) {
        if (me.backgroundCanvas) {
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].setLength(me.backgroundCanvas, 'width', width);
        }

        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].setLength(me.foregroundCanvas, 'width', width);
        me.$canvasWidth = me.timeAxisViewModel.totalSize;
        result = true;
      }

      return result;
    }
    /**
     * A chainable function which Features may hook to add their own content to the timeaxis header.
     * @param {Array} configs An array of domConfigs, append to it to have the config applied to the header
     */

  }, {
    key: "getHeaderDomConfigs",
    value: function getHeaderDomConfigs(configs) {}
    /**
     * A chainable function which Features may hook to add their own content to the foreground canvas
     * @param {Array} configs An array of domConfigs, append to it to have the config applied to the foreground canvas
     */

  }, {
    key: "getForegroundDomConfigs",
    value: function getForegroundDomConfigs(configs) {} //endregion
    //region Grid overrides

  }, {
    key: "refresh",
    value: function refresh() {
      var forceLayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var me = this;

      if (me.isPainted && !me.refreshSuspended) {
        if (me.hasVisibleEvents) {
          if (me.isEngineReady) {
            me.refreshRows(false, forceLayout);
          } else {
            me.refreshAfterProjectRefresh = true;
            me.currentOrientation.refreshAllWhenReady = true;
          }
        } // Even if there are no events in our timeline, Features
        // assume there will be a refresh event from the RowManager
        // after a refresh request so fire it here.
        else {
            me.rowManager.trigger('refresh');
          }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var me = this,
          schedulerEl = me.timeAxisSubGridElement;

      if (me.useBackgroundCanvas) {
        me._backgroundCanvas = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].createElement({
          className: 'b-sch-background-canvas',
          parent: schedulerEl,
          nextSibling: schedulerEl.firstElementChild
        });
      }

      var fgCanvas = me._foregroundCanvas = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].createElement({
        className: 'b-sch-foreground-canvas',
        style: "font-size:".concat(me.rowHeight - me.resourceMargin * 2, "px"),
        parent: schedulerEl
      });
      me.timeAxisSubGrid.insertRowsBefore = fgCanvas; // Size correctly in case ticks does not fill height

      if (me.isVertical && me.suppressFit) {
        me.updateCanvasSize();
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "render", this).apply(this, arguments);
    } // TODO: refreshRows -> refresh in grid?

  }, {
    key: "refreshRows",
    value: function refreshRows() {
      var returnToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var reLayoutEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var me = this;

      if (me.isConfiguring) {
        return;
      }

      me.currentOrientation.refreshRows(reLayoutEvents);

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "refreshRows", this).call(this, returnToTop);
    } //endregion
    //region Other

  }, {
    key: "getDateConstraints",
    value: function getDateConstraints() {} // duration = false prevents transition

  }, {
    key: "runWithTransition",
    value: function runWithTransition(fn, duration) {
      var me = this; // Do not attempt to enter animating state if we are not visible

      if (me.isVisible) {
        // Allow calling with true/false to keep code simpler in other places
        if (duration == null || duration === true) {
          duration = me.transitionDuration;
        } // Ask Grid superclass to enter the animated state if requested and enabled.


        if (duration && me.enableEventAnimations) {
          me.isAnimating = true; // Exit animating state in duration milliseconds.
          // Cancel any previous outstanding exit timer.

          exitTransition.delay = duration;
          me.setTimeout(exitTransition);
        }
      }

      fn();
    }
  }, {
    key: "exitTransition",
    value: function exitTransition() {
      this.isAnimating = false;
      this.trigger('transitionend');
    }
  }, {
    key: "waitForTransition",
    value: function () {
      var _waitForTransition = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isAnimating) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.await('transitionend'));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function waitForTransition() {
        return _waitForTransition.apply(this, arguments);
      }

      return waitForTransition;
    }()
    /**
     * Refreshes the grid with transitions enabled.
     */

  }, {
    key: "refreshWithTransition",
    value: function refreshWithTransition(forceLayout, duration) {
      var _this = this;

      this.runWithTransition(function () {
        return _this.refresh(forceLayout);
      }, duration);
    }
    /**
     * Returns an object representing the visible date range, with `startDate` and `endDate` properties.
     * @deprecated 4.0.0 Deprecated in favor of `get visibleDateRange`
     * @return {Object} The date range
     * @return {Date} return.startDate Start date
     * @return {Date} return.endDate End date
     */

  }, {
    key: "getVisibleDateRange",
    value: function getVisibleDateRange() {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of `get visibleDateRange`');
      return this.visibleDateRange;
    }
    /**
     * Returns an object representing the visible date range, with `startDate` and `endDate` properties
     * @return {Object} The date range
     * @return {Date} return.startDate Start date
     * @return {Date} return.endDate End date
     */

  }, {
    key: "formatDuration",
    //endregion

    /**
     * Returns a rounded duration value to be displayed in UI (tooltips, labels etc)
     * @param {Number} The raw duration value
     * @param {Number} [nbrDecimals] The number of decimals, defaults to {@link #config-durationDisplayPrecision}
     * @return {Number} The rounded duration
     */
    value: function formatDuration(duration) {
      var nbrDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.durationDisplayPrecision;
      var multiplier = Math.pow(10, nbrDecimals);
      return Math.round(duration * multiplier) / multiplier;
    }
  }, {
    key: "hasVisibleEvents",
    get: function get() {
      var _this2 = this;

      return !this.noFeatureElementsInAxis() || this.eventStore.storage.values.some(function (t) {
        return _this2.timeAxis.isTimeSpanInAxis(t);
      });
    }
  }, {
    key: "capitalizedEventName",
    get: function get() {
      if (!this._capitalizedEventName) {
        this._capitalizedEventName = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].capitalize(this.scheduledEventName);
      }

      return this._capitalizedEventName;
    }
  }, {
    key: "partner",
    set: function set(partner) {
      var me = this,
          partneredWith = me.partneredWith || (me.partneredWith = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_29__["default"]());
      me._partner = partner;

      if (!partneredWith.includes(partner)) {
        // Each must know about the other so that they can sync others upon region resize
        partneredWith.add(partner);
        (partner.partneredWith || (partner.partneredWith = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_29__["default"]())).add(me); // Flush through viewPreset initGetter so that the setup in setConfig doesn't
        // take them to be the class's defined getters.

        me.getConfig('viewPreset');
        partner.on({
          presetchange: 'onPartnerPresetChange',
          thisObj: me
        }); // collect configs that are meant to be shared between partners

        var partnerSharedConfig = me.partnerSharedConfigs.reduce(function (config, configName) {
          config[configName] = partner[configName];
          return config;
        }, {});
        me.setConfig(partnerSharedConfig);
        me.on({
          presetchange: 'onPartnerPresetChange',
          thisObj: partner
        }); // When initScroll comes round, make sure it syncs with the partner

        me.initScroll = _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].createSequence(me.initScroll, function () {
          me.scrollable.addPartner(partner.scrollable, 'x');
        }, me);
      }
    },
    get: function get() {
      return this._partner;
    }
  }, {
    key: "partners",
    get: function get() {
      var partners = this.partner ? [this.partner] : [];

      if (this.partneredWith) {
        partners.push.apply(partners, this.partneredWith.all);
      }

      return partners;
    }
  }, {
    key: "timeAxisColumn",
    get: function get() {
      return this.columns && this._timeAxisColumn;
    }
  }, {
    key: "columns",
    get: function get() {
      // Maintainer. If we do not implement a getter to go along with our setter, this
      // property becomes unreadable at this class level.
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "columns", this);
    },
    set: function set(columns) {
      var me = this;
      var timeAxisColumnIndex, timeAxisColumnConfig, timeAxisColumn, value; // No columns means destroy

      if (columns) {
        var isArray = Array.isArray(columns);
        var cols = columns;

        if (!isArray) {
          cols = columns.data;
        }

        timeAxisColumnIndex = cols && cols.length;
        cols.some(function (col, index) {
          if (col.type === 'timeAxis') {
            timeAxisColumnIndex = index;
            timeAxisColumnConfig = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].assign(col, me.timeAxisColumn);
            return true;
          }
        }); // TODO : This is scheduler specific, override `set columns` instead
        // No additional columns allowed in vertical mode, but store the specified set in case we toggle mode later

        if (me.isVertical) {
          me._horizontalColumns = columns;
          cols = [_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].assign({
            type: 'verticalTimeAxis',
            locked: true,
            timeline: me
          }, me.verticalTimeAxisColumn), // Make space for a regular TimeAxisColumn after the VerticalTimeAxisColumn
          cols[timeAxisColumnIndex]];
          timeAxisColumnIndex = 1;
        } else {
          // We're going to mutate this array which we do not own, so copy it first.
          cols = cols.slice();
        } // Fix up the timeAxisColumn config in place


        timeAxisColumnConfig = cols[timeAxisColumnIndex] = Object.assign({
          type: 'timeAxis',
          locked: false,
          timeline: me,
          cellCls: me.timeCellCls,
          mode: me.mode
        }, timeAxisColumnConfig); // Pass these configs into the timeAxisColumnConfig

        timeAxisColumnConfigs.forEach(function (configName) {
          value = me[configName];

          if (value != null) {
            timeAxisColumnConfig[configName] = value;
          }
        });

        if (isArray) {
          columns = cols;
        } else {
          columns.data = cols;
        }
      } // Invoke Grid's setter. Will create a ColumnStore which is returned by the columns setter.


      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "columns", columns, this, true);

      if (columns) {
        timeAxisColumn = me._timeAxisColumn = me.columns.getAt(timeAxisColumnIndex);

        if (me.isVertical) {
          me.verticalTimeAxisColumn = me.columns.getAt(timeAxisColumnIndex - 1);
        } // Set up event relaying early


        timeAxisColumn.relayAll(me);
      }
    }
  }, {
    key: "timeView",
    get: function get() {
      var me = this; // Maintainer, we need to ensure that the columns property is initialized
      // if this getter is called at configuration time before columns have been ingested.

      return me.columns && me.isVertical ? me.verticalTimeAxisColumn && me.verticalTimeAxisColumn.view : me.timeAxisColumn && me.timeAxisColumn.timeAxisView;
    }
  }, {
    key: "eventCls",
    set: function set(eventCls) {
      var me = this;
      me._eventCls = eventCls;

      if (!me.eventSelector) {
        me.eventSelector = ".".concat(eventCls, "-wrap"); // No difference with new rendering, released have 'b-released' only

        me.unreleasedEventSelector = "".concat(me.eventSelector);
      }

      if (!me.eventInnerSelector) {
        me.eventInnerSelector = '.' + eventCls;
      }
    },
    get: function get() {
      return this._eventCls;
    }
  }, {
    key: "timeAxisViewModel",
    set: function set(timeAxisViewModel) {
      var me = this,
          tavmListeners = {
        update: 'onTimeAxisViewModelUpdate',
        prio: 100,
        thisObj: me
      };

      if (me.partner && !timeAxisViewModel) {
        return;
      } // Getting rid of instanceof check to allow using code from different bundles


      if (timeAxisViewModel && timeAxisViewModel.isTimeAxisViewModel) {
        timeAxisViewModel.on(tavmListeners);
      } else {
        timeAxisViewModel = Object.assign({
          mode: me._mode,
          snap: me.snap,
          forceFit: me.forceFit,
          timeAxis: me.timeAxis,
          suppressFit: me.suppressFit,
          listeners: tavmListeners
        }, timeAxisViewModel);
        timeAxisViewModel = new _model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_35__["default"](timeAxisViewModel);
      }

      me._timeAxisViewModel = timeAxisViewModel;
    }
    /**
     * The internal view model, describing the visual representation of the time axis.
     * @property {Scheduler.view.model.TimeAxisViewModel}
     * @readonly
     * @category Time axis
     */
    ,
    get: function get() {
      if (!this._timeAxisViewModel) {
        this.timeAxisViewModel = null;
      }

      return this._timeAxisViewModel;
    }
  }, {
    key: "suppressFit",
    get: function get() {
      var _this$_timeAxisViewMo, _this$_timeAxisViewMo2;

      return (_this$_timeAxisViewMo = (_this$_timeAxisViewMo2 = this._timeAxisViewModel) === null || _this$_timeAxisViewMo2 === void 0 ? void 0 : _this$_timeAxisViewMo2.suppressFit) !== null && _this$_timeAxisViewMo !== void 0 ? _this$_timeAxisViewMo : this._suppressFit;
    },
    set: function set(value) {
      if (this._timeAxisViewModel) {
        this.timeAxisViewModel.suppressFit = value;
      } else {
        this._suppressFit = value;
      }
    }
  }, {
    key: "timeAxis",
    set: function set(timeAxis) {
      var me = this;

      if (me.partner && !timeAxis) {
        return;
      }

      me.detachListeners('timeAxis'); // Getting rid of instanceof check to allow using code from different bundles

      if (!(timeAxis && timeAxis.isTimeAxis)) {
        timeAxis = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].assign({
          viewPreset: me.viewPreset,
          autoAdjust: me.autoAdjustTimeAxis,
          mode: 'plain',
          weekStartDay: me.weekStartDay
        }, timeAxis);

        if (me.startDate) {
          timeAxis.startDate = me.startDate;
        }

        if (me.endDate) {
          timeAxis.endDate = me.endDate;
        }

        if (me.workingTime) {
          me.applyWorkingTime(timeAxis);
        }

        timeAxis = new _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_34__["default"](timeAxis);
      } // Inform about reconfiguring the timeaxis, to allow users to react to start & end date changes


      timeAxis.on({
        name: 'timeAxis',
        reconfigure: function reconfigure(_ref5) {
          var config = _ref5.config;

          /**
           * Fired when the timeaxis has changed, for example by zooming or configuring a new time span.
           * @event timeAxisChange
           * @param {Scheduler.view.Scheduler} source - This Scheduler
           * @param {Object} config Config object used to reconfigure the time axis.
           * @param {Date} config.start New start date (if supplied)
           * @param {Date} config.end New end date (if supplied)
           */
          me.trigger('timeAxisChange', {
            config: config
          });
        },
        thisObj: me
      });
      me._timeAxis = timeAxis;
    },
    get: function get() {
      if (!this._timeAxis) {
        this.timeAxis = null;
      }

      return this._timeAxis;
    }
    /**
     * Get/set working time. Assign `null` to stop using working time. See {@link #config-workingTime} config for details.
     * @property {Object}
     */

  }, {
    key: "workingTime",
    set: function set(config) {
      this._workingTime = config;

      if (!this.isConfiguring) {
        this.applyWorkingTime(this.timeAxis);
      }
    },
    get: function get() {
      return this._workingTime;
    }
  }, {
    key: "startDate",
    set: function set(date) {
      this.setStartDate(date);
    },
    get: function get() {
      var me = this;

      if (me._timeAxis) {
        return me._timeAxis.startDate;
      }

      return me._tempStartDate || new Date();
    }
    /**
     * Get/set endDate. Defaults to startDate + default span of the used ViewPreset.
     *
     * **Note:** If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
     * @property {Date}
     * @category Common
     */

  }, {
    key: "endDate",
    set: function set(date) {
      this.setEndDate(date);
    },
    get: function get() {
      var me = this;

      if (me._timeAxis) {
        return me._timeAxis.endDate;
      }

      return me._tempEndDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].add(me.startDate, me.viewPreset.defaultSpan, me.viewPreset.mainHeader.unit);
    }
  }, {
    key: "features",
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "features", this);
    } // add region resize by default
    ,
    set: function set(features) {
      features = features === true ? {} : features;

      if (!('regionResize' in features)) {
        features.regionResize = true;
      }

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_22___default()(TimelineBase.prototype), "features", features, this, true);
    }
  }, {
    key: "eventStyle",
    get: function get() {
      return this._eventStyle;
    },
    set: function set(style) {
      var me = this;
      me._eventStyle = style;

      if (me.isPainted) {
        me.refreshWithTransition();
      }
    }
  }, {
    key: "eventColor",
    get: function get() {
      return this._eventColor;
    },
    set: function set(color) {
      var me = this;
      me._eventColor = color;

      if (me.isPainted) {
        me.refreshWithTransition();
      }
    }
  }, {
    key: "currentOrientation",
    get: function get() {
      throw new Error('Implement in subclass');
    } // Horizontal is the default, overridden in scheduler

  }, {
    key: "isHorizontal",
    get: function get() {
      return true;
    } //endregion
    //region Canvases and elements

  }, {
    key: "backgroundCanvas",
    get: function get() {
      return this._backgroundCanvas;
    }
  }, {
    key: "foregroundCanvas",
    get: function get() {
      return this._foregroundCanvas;
    }
  }, {
    key: "svgCanvas",
    get: function get() {
      var me = this;

      if (!me._svgCanvas) {
        var svg = me._svgCanvas = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('id', _Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"].generateId('svg')); // To not be recycled by DomSync

        svg.retainElement = true;
        me.foregroundCanvas.appendChild(svg);
        me.trigger('svgCanvasCreated');
      }

      return me._svgCanvas;
    }
    /**
     * Returns the subGrid containing the time axis
     * @property {Grid.view.SubGrid}
     * @readonly
     */

  }, {
    key: "timeAxisSubGridElement",
    get: function get() {
      // We need the TimeAxisSubGrid to exist, so regions must be inited
      this.getConfig('regions');
      return this.timeAxisColumn && this.timeAxisColumn.subGridElement;
    }
  }, {
    key: "visibleDateRange",
    get: function get() {
      return this.currentOrientation.visibleDateRange;
    }
  }], [{
    key: "$name",
    //region Config
    get: function get() {
      return 'TimelineBase';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'timelinebase';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        partnerSharedConfigs: {
          value: ['viewPreset', 'timeAxis', 'timeAxisViewModel'],
          $config: {
            merge: 'distinct'
          }
        }
      };
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        /**
         * A valid JS day index between 0-6 (0: Sunday, 1: Monday etc.) to be considered the start day of the week.
         * When omitted, the week start day is retrieved from the active locale class.
         * @config {Number} weekStartDay
         * @category Time axis
         */

        /**
         * An object with format `{ fromDay, toDay, fromHour, toHour }` that describes the working days and hours.
         * This object will be used to populate TimeAxis {@link Scheduler.data.TimeAxis#config-include} property.
         *
         * Using it results in a non-continuous time axis. Any ticks not covered by the working days and hours will
         * be excluded. Events within larger ticks (for example if using week as the unit for ticks) will be
         * stretched to fill the gap otherwise left by the non working hours.
         *
         * As with end dates, `toDay` and `toHour` are exclusive. Thus `toDay : 6` means that day 6 (saturday) will
         * not be included.
         *
         *
         * **NOTE:** When this feature is enabled {@link Scheduler.view.mixin.TimelineZoomable Zooming feature} is
         * not supported. It's recommended to disable zooming controls:
         *
         * ```javascript
         * new Scheduler({
         *     zoomOnMouseWheel          : false,
         *     zoomOnTimeAxisDoubleClick : false,
         *     ...
         * });
         * ```
         *
         * @config {Object}
         * @category Time axis
         */
        workingTime: null,

        /**
         * A backing data store of 'ticks' providing the input date data for the time axis of timeline panel.
         * @member {Scheduler.data.TimeAxis} timeAxis
         * @readonly
         * @category Time axis
         */

        /**
         * A {@link Scheduler.data.TimeAxis} config object or instance, used to create a backing data store of
         * 'ticks' providing the input date data for the time axis of timeline panel. Created automatically if none
         * supplied.
         * @config {Object|Scheduler.data.TimeAxis}
         * @category Time axis
         */
        timeAxis: null,

        /**
         * The time axis column config for vertical {@link Scheduler.view.SchedulerBase#config-mode}.
         *
         * Object with {@link Scheduler.column.VerticalTimeAxisColumn} configuration.
         *
         * This object will be used to configure the vertical time axis column instance.
         *
         * The config allows configuring the `VerticalTimeAxisColumn` instance used in vertical mode with any Column options that apply to it.
         *
         * Example:
         *
         * ```javascript
         * new Scheduler({
         *     mode     : 'vertical',
         *     features : {
         *         filterBar : true
         *     },
         *     verticalTimeAxisColumn : {
         *         text  : 'Filter by event name',
         *         width : 180,
         *         filterable : {
         *             // add a filter field to the vertical column access header
         *             filterField : {
         *                 type        : 'text',
         *                 placeholder : 'Type to search',
         *                 onChange    : ({ value }) => {
         *                     // filter event by name converting to lowerCase to be equal comparison
         *                     scheduler.eventStore.filter({
         *                         filters : event => event.name.toLowerCase().includes(value.toLowerCase()),
         *                         replace : true
         *                     });
         *                 }
         *             }
         *         }
         *     },
         *     ...
         * });
         * ```
         *
         * @config {Object}
         * @category Time axis
         */
        verticalTimeAxisColumn: {},

        /**
         * The backing view model for the visual representation of the time axis.
         * Either a real instance or a simple config object.
         * @private
         * @config {Scheduler.view.model.TimeAxisViewModel|Object}
         * @category Time axis
         */
        timeAxisViewModel: null,

        /**
         * You can set this option to `false` to make the timeline panel start and end on the exact provided
         * {@link #config-startDate}/{@link #config-endDate} w/o adjusting them.
         * @config {Boolean}
         * @default
         * @category Time axis
         */
        autoAdjustTimeAxis: true,

        /**
         * The start date of the timeline. If omitted, and a TimeAxis has been set, the start date of the provided
         * {@link Scheduler.data.TimeAxis} will be used. If no TimeAxis has been configured, it'll use the start/end
         * dates of the loaded event dataset. If no date information exists in the event data set, it defaults to
         * the current date and time.
         *
         * If a string is supplied, it will be parsed using
         * {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat}
         *
         * **Note:** If you need to set start and end date at the same time, use
         * {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
         * @config {Date|String}
         * @category Common
         */
        startDate: null,

        /**
         * The end date of the timeline. If omitted, it will be calculated based on the {@link #config-startDate}
         * setting and the 'defaultSpan' property of the current
         * {@link Scheduler.view.mixin.TimelineViewPresets#config-viewPreset}.
         *
         * If a string is supplied, it will be parsed using
         * {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat}
         *
         * **Note:** If you need to set start and end date at the same time, use
         * {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
         * @config {Date|String}
         * @category Common
         */
        endDate: null,

        /**
         * true to snap to resolution increment while interacting with scheduled events.
         * @config {Boolean}
         * @default
         * @category Scheduled events
         */
        snap: false,

        /**
         * Affects drag drop and resizing of events when {@link #config-snap} is enabled. If set to `true`, dates
         * will be snapped relative to event start. e.g. for a zoom level with timeResolution = { unit: "s",
         * increment: "20" }, an event that starts at 10:00:03 and is dragged would snap its start date to 10:00:23,
         * 10:00:43 etc. When set to `false`, dates will be snapped relative to the timeAxis startDate (tick start)
         * - 10:00:03, 10:00:20, 10:00:40 etc.
         * @config {Boolean}
         * @default
         * @category Scheduled events
         */
        snapRelativeToEventStartDate: false,

        /**
         * Set to `true` to force the time columns to fit to the available space (horizontal or vertical depends on mode).
         * Note that setting {@link Scheduler.view.TimelineBase#config-suppressFit} on `true`, will disable `forceFit` functionality.
         * @config {Boolean}
         * @default
         * @category Time axis
         */
        forceFit: false,

        /**
         * Set to `true` to prevent auto calculating of a minimal {@link Scheduler.view.mixin.TimelineEventRendering#property-tickSize}
         * to always fit the content to the screen size. Setting this property on `true` will disable {@link Scheduler.view.TimelineBase#config-forceFit} behaviour.
         * @config {Boolean}
         * @default false
         * @category Time axis
         */
        suppressFit: false,

        /**
         * CSS class to add to rendered events
         * @config {String}
         * @category CSS
         * @private
         */
        eventCls: null,

        /**
         * Returns dates that will constrain resize and drag operations. The method will be called with the
         * Resource, and for operations on existing events - the event. For drag create operation, the mousedown
         * date will be passed as the second parameter
         * @return {Object} Constraining object containing `start` and `end` constraints. Omitting either
         * will mean that end is not constrained. So you can prevent a resize or move from moving *before*
         * a certain time while not constraininhg the end date.
         * @return {Date} [return.start] Start date
         * @return {Date} [return.end] End date
         * @config {Function}
         * @category Scheduled events
         */
        getDateConstraints: null,

        /**
         * CSS class to add to cells in the timeaxis column
         * @config {String}
         * @category CSS
         * @private
         */
        timeCellCls: null,
        timeCellSelector: null,
        scheduledEventName: null,

        /**
         * Create event on double click if scheduler is not in read only mode.
         * Set to false to turn creating off.
         * @config {Boolean}
         * @default
         * @category Scheduled events
         */
        createEventOnDblClick: true,
        //dblClickTime : 200,

        /**
         * A CSS class to apply to each event in the view on mouseover.
         * @config {String}
         * @category CSS
         * @private
         */
        overScheduledEventClass: null,
        // allow the panel to prevent adding the hover CSS class in some cases - during drag drop operations
        preventOverCls: false,
        // The last hovered over event bar HTML node
        hoveredEventNode: null,
        // This setting is set to true by features that need it
        useBackgroundCanvas: false,

        /**
         * Set to `false` if you don't want event bar DOM updates to animate. Animations are disabled in IE11 by default.
         * @config {Boolean}
         * @default true
         * @category Scheduled events
         */
        enableEventAnimations: !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isIE11,
        disableGridRowModelWarning: true,
        // does not look good with locked columns and also interferes with event animations
        animateRemovingRows: false,

        /**
         * Partners this Timeline panel with another Timeline in order to sync their region sizes (sub-grids like locked, normal will get the same width),
         * start and end dates, view preset, zoom level and scrolling position. All these values will be synced with the timeline defined as the `partner`.
         * @config {Scheduler.view.TimelineBase}
         * @category Time axis
         */
        partner: null,
        schedulerRegion: 'normal',
        transitionDuration: 200,
        // internal timer id reference
        animationTimeout: null,

        /**
         * How to handle milestones during event layout. Options are:
         * * default - Milestones do not affect event layout
         * * estimate - Milestone width is estimated by multiplying text length with Scheduler#milestoneCharWidth
         * * data - Milestone width is determined by checking EventModel#milestoneWidth
         * * measure - Milestone width is determined by measuring label width
         * Please note that currently text width is always determined using EventModel#name.
         * Also note that only 'default' is supported by eventStyles line, dashed and minimal.
         * @config {String}
         * @default
         * @category Scheduled events
         */
        milestoneLayoutMode: 'default',

        /**
         * Region to which columns are added when they have none specified
         * @config {string}
         * @default
         * @category Misc
         */
        defaultRegion: 'locked',

        /**
         * Decimal precision used when displaying durations, used by tooltips and DurationColumn.
         * Specify `false` to use raw value
         * @config {Number|Boolean}
         * @default
         * @category Common
         */
        durationDisplayPrecision: 1,
        asyncEventSuffix: 'PreCommit'
      };
    }
  }]);

  return TimelineBase;
}(_Grid_view_GridBase_js__WEBPACK_IMPORTED_MODULE_23__["default"].mixin(_mixin_TimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_36__["default"], _mixin_TimelineDomEvents_js__WEBPACK_IMPORTED_MODULE_37__["default"], _mixin_TimelineEventRendering_js__WEBPACK_IMPORTED_MODULE_41__["default"], _mixin_TimelineScroll_js__WEBPACK_IMPORTED_MODULE_42__["default"], _mixin_TimelineViewPresets_js__WEBPACK_IMPORTED_MODULE_38__["default"], _mixin_TimelineZoomable_js__WEBPACK_IMPORTED_MODULE_39__["default"], _mixin_RecurringEvents_js__WEBPACK_IMPORTED_MODULE_40__["default"])); // Register this widget type with its Factory



TimelineBase.initClass(); // Has to be here because Gantt extends TimelineBase

_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_32__["default"].setVersion('scheduler', '4.0.3');
TimelineBase._$name = 'TimelineBase';

/***/ }),

/***/ "./lib/Scheduler/view/VerticalTimeAxis.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/view/VerticalTimeAxis.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VerticalTimeAxis; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _TimeAxisBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TimeAxisBase.js */ "./lib/Scheduler/view/TimeAxisBase.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/VerticalTimeAxis
 */

/**
 * Widget that renders a vertical time axis. Only renders ticks in view. Used in vertical mode.
 * @extends Core/widget/Widget
 * @private
 */

var VerticalTimeAxis = /*#__PURE__*/function (_TimeAxisBase) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(VerticalTimeAxis, _TimeAxisBase);

  var _super = _createSuper(VerticalTimeAxis);

  function VerticalTimeAxis() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, VerticalTimeAxis);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(VerticalTimeAxis, [{
    key: "height",
    get: function get() {
      return this.size;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'VerticalTimeAxis';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        cls: 'b-verticaltimeaxis',
        sizeProperty: 'height',
        positionProperty: 'top',
        wrapText: true
      };
    }
  }]);

  return VerticalTimeAxis;
}(_TimeAxisBase_js__WEBPACK_IMPORTED_MODULE_8__["default"]);


VerticalTimeAxis._$name = 'VerticalTimeAxis';

/***/ }),

/***/ "./lib/Scheduler/view/export/SchedulerExportDialog.js":
/*!************************************************************!*\
  !*** ./lib/Scheduler/view/export/SchedulerExportDialog.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SchedulerExportDialog; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Grid_view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Grid/view/export/ExportDialog.js */ "./lib/Grid/view/export/ExportDialog.js");
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../feature/export/Utils.js */ "./lib/Scheduler/feature/export/Utils.js");
/* harmony import */ var _view_export_field_ScheduleRangeCombo_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../view/export/field/ScheduleRangeCombo.js */ "./lib/Scheduler/view/export/field/ScheduleRangeCombo.js");
/* harmony import */ var _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../Core/widget/Field.js */ "./lib/Core/widget/Field.js");
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/view/export/SchedulerExportDialog
 */

/**
 * Similar to dialog in Grid, but with few extra fields specific to scheduler.
 * @extends Grid/view/export/ExportDialog
 */

var SchedulerExportDialog = /*#__PURE__*/function (_GridExportDialog) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(SchedulerExportDialog, _GridExportDialog);

  var _super = _createSuper(SchedulerExportDialog);

  function SchedulerExportDialog() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, SchedulerExportDialog);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(SchedulerExportDialog, [{
    key: "onLocaleChange",
    value: function onLocaleChange() {
      var labelWidth = this.L('labelWidth');
      this.width = this.L('L{width}');
      this.items.forEach(function (widget) {
        if (widget instanceof _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_19__["default"]) {
          widget.labelWidth = labelWidth;
        } else if (widget.ref === 'rangeFieldsContainer') {
          widget.items[0].width = labelWidth;
        }
      });
    }
  }, {
    key: "buildDialogItems",
    value: function buildDialogItems(config) {
      var me = this,
          client = config.client,
          _me$getDefaultFieldVa = me.getDefaultFieldValues(config),
          scheduleRange = _me$getDefaultFieldVa.scheduleRange,
          items = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(SchedulerExportDialog.prototype), "buildDialogItems", this).call(this, config),
          labelWidth = me.L('labelWidth');

      me.columnsStore = client.columns.chain(function (record) {
        return record.isLeaf && record.exportable;
      });
      var columnsField = items.find(function (item) {
        return item.ref === 'columnsField';
      });
      columnsField.store = me.columnsStore;
      columnsField.value = me.columnsStore.allRecords;
      items.splice(1, 0, {
        labelWidth: labelWidth,
        type: 'schedulerangecombo',
        ref: 'scheduleRangeField',
        label: 'L{Schedule range}',
        localeClass: me,
        value: scheduleRange,
        onChange: function onChange(_ref) {
          var value = _ref.value;
          var hidden = value !== _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_17__["ScheduleRange"].daterange,
              widgetMap = this.owner.widgetMap;
          widgetMap.rangeStartField.hidden = widgetMap.rangeEndField.hidden = hidden;
        }
      }, {
        type: 'container',
        ref: 'rangeFieldsContainer',
        flex: '1 0 100%',
        defaults: {
          localeClass: me
        },
        items: [{
          // Filler widget to align date fields
          type: 'widget',
          width: labelWidth
        }, {
          type: 'datefield',
          ref: 'rangeStartField',
          label: 'L{Export from}',
          labelWidth: '3em',
          hidden: true,
          flex: '1 0 25%',
          localeClass: me,
          value: client.startDate,
          max: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].max(client.startDate, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(client.endDate, -1, 'd')),
          onChange: function onChange(_ref2) {
            var value = _ref2.value;
            this.owner.widgetMap.rangeEndField.min = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(value, 1, 'd');
          }
        }, {
          // Another filler to move label further from previous field
          type: 'widget',
          width: '0.5em'
        }, {
          type: 'datefield',
          ref: 'rangeEndField',
          label: 'L{Export to}',
          labelWidth: '1em',
          hidden: true,
          flex: '1 0 25%',
          localeClass: me,
          value: client.endDate,
          min: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].min(client.endDate, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(client.startDate, 1, 'd')),
          onChange: function onChange(_ref3) {
            var value = _ref3.value;
            this.owner.widgetMap.rangeStartField.max = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].add(value, -1, 'd');
          }
        }]
      });
      return items;
    }
  }, {
    key: "fieldProperties",
    get: function get() {
      return ['scheduleRange'].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(SchedulerExportDialog.prototype), "fieldProperties", this)));
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'SchedulerExportDialog';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        scheduleRange: 'completeview'
      };
    }
  }]);

  return SchedulerExportDialog;
}(_Grid_view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_16__["default"]);


SchedulerExportDialog._$name = 'SchedulerExportDialog';

/***/ }),

/***/ "./lib/Scheduler/view/export/field/ScheduleRangeCombo.js":
/*!***************************************************************!*\
  !*** ./lib/Scheduler/view/export/field/ScheduleRangeCombo.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScheduleRangeCombo; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.entries */ "./node_modules/core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../feature/export/Utils.js */ "./lib/Scheduler/feature/export/Utils.js");
/* harmony import */ var _Grid_view_export_field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../Grid/view/export/field/LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



var ScheduleRangeCombo = /*#__PURE__*/function (_LocalizableCombo) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ScheduleRangeCombo, _LocalizableCombo);

  var _super = _createSuper(ScheduleRangeCombo);

  function ScheduleRangeCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, ScheduleRangeCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(ScheduleRangeCombo, [{
    key: "buildLocalizedItems",
    value: function buildLocalizedItems() {
      var _this = this;

      // Do not remove. Assertion strings for Localization sanity check.
      // 'L{completeview}'
      // 'L{currentview}'
      // 'L{daterange}'
      // 'L{completedata}'
      return Object.entries(_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_11__["ScheduleRange"]).map(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5___default()(_ref, 2),
            id = _ref2[0],
            text = _ref2[1];

        return {
          id: id,
          text: _this.L(text)
        };
      });
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ScheduleRangeCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'schedulerangecombo';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        editable: false
      };
    }
  }]);

  return ScheduleRangeCombo;
}(_Grid_view_export_field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_12__["default"]); // Register this widget type with its Factory



ScheduleRangeCombo.initClass();
ScheduleRangeCombo._$name = 'ScheduleRangeCombo';

/***/ }),

/***/ "./lib/Scheduler/view/mixin/EventNavigation.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/EventNavigation.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/helper/util/Navigator.js */ "./lib/Core/helper/util/Navigator.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");

















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Scheduler/view/mixin/EventNavigation
 */

var preventDefault = function preventDefault(e) {
  return e.preventDefault();
};
/**
 * Mixin that tracks event or assignment selection by clicking on one or more events in the scheduler.
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_Delayable) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(EventNavigation, _Delayable);

    var _super = _createSuper(EventNavigation);

    function EventNavigation() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, EventNavigation);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(EventNavigation, [{
      key: "construct",
      //endregion
      //region Events

      /**
       * Fired when a user gesture causes the active item to change.
       * @event navigate
       * @param {Event} event The browser event which instigated navigation. May be a click or key or focus event.
       * @param {HTMLElement} item The newly active item, or `null` if focus moved out.
       * @param {HTMLElement} oldItem The previously active item, or `null` if focus is moving in.
       */
      //endregion
      value: function construct(config) {
        var me = this;
        me.isInTimeAxis = me.isInTimeAxis.bind(me);
        me.onDeleteKey = me.throttle(me.onDeleteKey, me.onDeleteKeyBuffer, me);

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(EventNavigation.prototype), "construct", this).call(this, config);
      }
    }, {
      key: "changeNavigator",
      value: function changeNavigator(navigator) {
        var me = this;
        me.getConfig('subGridConfigs');
        return new _Core_helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_17__["default"](me.constructor.mergeConfigs({
          ownerCmp: me,
          target: me.timeAxisSubGridElement,
          processEvent: me.processEvent,
          itemSelector: ".".concat(me.eventCls, "-wrap"),
          focusCls: me.focusCls,
          navigatePrevious: me.throttle(me.navigatePrevious, {
            delay: me.navigatePreviousBuffer,
            throttled: preventDefault
          }),
          navigateNext: me.throttle(me.navigateNext, {
            delay: me.navigateNextBuffer,
            throttled: preventDefault
          })
        }, navigator));
      }
    }, {
      key: "doDestroy",
      value: function doDestroy() {
        this.navigator.destroy();

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(EventNavigation.prototype), "doDestroy", this).call(this);
      }
    }, {
      key: "isInTimeAxis",
      value: function isInTimeAxis(record) {
        // If event is hidden by workingTime configs, horizontal mapper would raise a flag on instance meta
        // We still need to check if time span is included in axis
        return !record.instanceMeta(this).excluded && this.timeAxis.isTimeSpanInAxis(record);
      }
      /*
       * Override of GridNavigation#focusCell method to handle the TimeAxisColumn.
       * Not needed until we implement full keyboard accessibiliy.
       */

    }, {
      key: "accessibleFocusCell",
      value: function accessibleFocusCell(cellSelector, options) {
        var me = this;
        cellSelector = me.normalizeCellContext(cellSelector);

        if (cellSelector.columnId === me.timeAxisColumn.id) {// const lastFocusedCell        = me.lastFocusedCell = me._focusedCell,
          //     lastFocusedCellElement = lastFocusedCell && me.getCell(lastFocusedCell),
          //     newCell = me.getCell(cellSelector),
          //     // Flag if the lastFocusedCellElement is DOCUMENT_POSITION_FOLLOWING newCell
          //     backwards = !!(lastFocusedCellElement && (newCell.compareDocumentPosition(lastFocusedCellElement) & 4));
          // // Navigating into the Sheduler, need to enable this back (for situations where we know focus was requested as a result of a keyboard input)...
          // let newEvent = me.getRecordFromElement(newCell);
          // me._focusedCell = cellSelector;
          // // Scheduler where row is a Resource which might have many events
          // // TODO: https://app.assembla.com/spaces/bryntum/tickets/6526 this class should
          // // not know about Gantt.
          // if (!newEvent.isTask) {
          //     const resourceEvents = newEvent.getEvents().filter(me.isInTimeAxis).sort(sortByStartDate);
          //     newEvent = resourceEvents[backwards ? resourceEvents.length - 1 : 0];
          // }
          // options.event.eventRecord = newEvent;
          // if (newEvent && me.activeEvent !== newEvent) {
          //     lastFocusedCellElement && lastFocusedCellElement.classList.remove('b-focused');
          //     me.scrollResourceEventIntoView(me.store.getById(cellSelector.id), newEvent, null, {
          //         animate : 100
          //     }).then(() => {
          //         me.activeEvent = newEvent;
          //     });
          // }
        } else {
          return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(EventNavigation.prototype), "focusCell", this).call(this, cellSelector, options);
        }
      } // Interface method to extract the navigated to record from a populated 'navigate' event.
      // Gantt, Scheduler and Calendar handle event differently, adding different properties to it.
      // This method is meant to be overridden to return correct target from event

    }, {
      key: "normalizeTarget",
      value: function normalizeTarget(event) {
        return event.assignmentRecord;
      }
    }, {
      key: "getPrevious",
      value: function getPrevious(assignmentRecord, isDelete) {
        var me = this,
            resourceStore = me.resourceStore,
            eventSorter = me.currentOrientation.eventSorter,
            _me$timeAxis = me.timeAxis,
            startDate = _me$timeAxis.startDate,
            endDate = _me$timeAxis.endDate,
            eventRecord = assignmentRecord.event,
            resourceEvents = me.eventStore.getEvents({
          resourceRecord: assignmentRecord.resource,
          startDate: startDate,
          endDate: endDate
        }).filter(this.isInTimeAxis).sort(eventSorter);
        var resourceRecord = assignmentRecord.resource,
            previousEvent = resourceEvents[resourceEvents.indexOf(eventRecord) - 1]; // At first event for resource, traverse up the resource store.

        if (!previousEvent) {
          // If we are deleting an event, skip other instances of the event which we may encounter
          // due to multi-assignment.
          for (var rowIdx = resourceStore.indexOf(resourceRecord) - 1; (!previousEvent || isDelete && previousEvent === eventRecord) && rowIdx >= 0; rowIdx--) {
            resourceRecord = resourceStore.getAt(rowIdx);
            var events = me.eventStore.getEvents({
              resourceRecord: resourceRecord,
              startDate: startDate,
              endDate: endDate
            }).filter(me.isInTimeAxis).sort(eventSorter);
            previousEvent = events.length && events[events.length - 1];
          }
        }

        return me.assignmentStore.getAssignmentForEventAndResource(previousEvent, resourceRecord);
      }
    }, {
      key: "navigatePrevious",
      value: function navigatePrevious(keyEvent) {
        var me = this,
            previousAssignment = me.getPrevious(me.normalizeTarget(keyEvent));
        keyEvent.preventDefault();

        if (previousAssignment) {
          if (!keyEvent.ctrlKey) {
            me.clearEventSelection();
          }

          return me.navigateTo(previousAssignment, keyEvent);
        }
      }
    }, {
      key: "getNext",
      value: function getNext(assignmentRecord, isDelete) {
        var me = this,
            resourceStore = me.resourceStore,
            eventSorter = me.currentOrientation.eventSorter,
            _me$timeAxis2 = me.timeAxis,
            startDate = _me$timeAxis2.startDate,
            endDate = _me$timeAxis2.endDate,
            eventRecord = assignmentRecord.event,
            resourceEvents = me.eventStore.getEvents({
          resourceRecord: assignmentRecord.resource,
          // start/end are required to limit time
          startDate: startDate,
          endDate: endDate
        }).filter(this.isInTimeAxis).sort(eventSorter);
        var resourceRecord = assignmentRecord.resource,
            nextEvent = resourceEvents[resourceEvents.indexOf(eventRecord) + 1]; // At last event for resource, traverse down the resource store

        if (!nextEvent) {
          // If we are deleting an event, skip other instances of the event which we may encounter
          // due to multi-assignment.
          for (var rowIdx = resourceStore.indexOf(resourceRecord) + 1; (!nextEvent || isDelete && nextEvent === eventRecord) && rowIdx < resourceStore.count; rowIdx++) {
            resourceRecord = resourceStore.getAt(rowIdx);
            var events = me.eventStore.getEvents({
              resourceRecord: resourceRecord,
              startDate: startDate,
              endDate: endDate
            }).filter(me.isInTimeAxis).sort(eventSorter);
            nextEvent = events[0];
          }
        }

        return me.assignmentStore.getAssignmentForEventAndResource(nextEvent, resourceRecord);
      }
    }, {
      key: "navigateNext",
      value: function navigateNext(keyEvent) {
        var me = this,
            nextAssignment = me.getNext(me.normalizeTarget(keyEvent));
        keyEvent.preventDefault();

        if (nextAssignment) {
          if (!keyEvent.ctrlKey) {
            me.clearEventSelection();
          }

          return me.navigateTo(nextAssignment, keyEvent);
        }
      }
    }, {
      key: "navigateTo",
      value: function () {
        var _navigateTo = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee(targetAssignment) {
          var uiEvent,
              me,
              _args = arguments;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  uiEvent = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                  me = this;

                  if (!targetAssignment) {
                    _context.next = 7;
                    break;
                  }

                  // No key processing during scroll
                  me.navigator.disabled = true;
                  _context.next = 6;
                  return me.scrollAssignmentIntoView(targetAssignment, null, {
                    animate: 100
                  });

                case 6:
                  // Panel can be destroyed before promise is resolved
                  if (!me.isDestroyed) {
                    me.navigator.disabled = false;
                    me.activeAssignment = targetAssignment;
                    me.navigator.trigger('navigate', {
                      event: uiEvent,
                      item: _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].up(me.getElementFromAssignmentRecord(targetAssignment), me.navigator.itemSelector)
                    });
                  }

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function navigateTo(_x) {
          return _navigateTo.apply(this, arguments);
        }

        return navigateTo;
      }()
    }, {
      key: "processEvent",
      value: function processEvent(keyEvent) {
        var me = this,
            eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].up(keyEvent.target, me.eventSelector);

        if (!me.navigator.disabled && eventElement) {
          keyEvent.assignmentRecord = me.resolveAssignmentRecord(eventElement);
          keyEvent.eventRecord = me.resolveEventRecord(eventElement);
          keyEvent.resourceRecord = me.resolveResourceRecord(eventElement);
        }

        return keyEvent;
      }
    }, {
      key: "onDeleteKey",
      value: function onDeleteKey(keyEvent) {
        var record = this.eventStore.usesSingleAssignment ? keyEvent.eventRecord : keyEvent.assignmentRecord;

        if (!this.readOnly && this.enableDeleteKey && record) {
          this.removeRecords([record]);
        }
      }
      /**
       * Internal utility function to remove events. Used when pressing [DELETE] or [BACKSPACE] or when clicking the
       * delete button in the event editor. Triggers a preventable `beforeEventDelete` or `beforeAssignmentDelete` event.
       * @param {Scheduler.model.EventModel[]|Scheduler.model.AssignmentModel[]} records Records to remove
       * @param {Function} [callback] Optional callback executed after triggering the event but before deletion
       * @returns {Boolean} Returns `false` if the operation was prevented, otherwise `true`
       * @internal
       * @fires beforeEventDelete
       * @fires beforeAssignmentDelete
       */

    }, {
      key: "removeRecords",
      value: function removeRecords(records) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (!this.readOnly && records.length) {
          var context = {
            finalize: function finalize() {
              var removeRecord = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

              if (callback) {
                callback(removeRecord);
              }

              if (removeRecord !== false) {
                records.forEach(function (r) {
                  if (r.isAssignment && r.isOccurrenceAssignment) {
                    r.event.remove();
                  } else {
                    r.remove();
                  }
                });
              }
            }
          };
          var shouldFinalize;

          if (records[0].isAssignment) {
            /**
             * Fires before an assignment is removed. Can be triggered by user pressing [DELETE] or [BACKSPACE] or
             * by the event editor. Can for example be used to display a custom dialog to confirm deletion, in which
             * case records should be "manually" removed after confirmation:
             *
             * ```javascript
             * scheduler.on({
             *    beforeAssignmentDelete({ assignmentRecords, context }) {
             *        // Show custom confirmation dialog (pseudo code)
             *        confirm.show({
             *            listeners : {
             *                onOk() {
             *                    // Remove the assignments on confirmation
             *                    context.finalize(true);
             *                },
             *                onCancel() {
             *                    // do not remove the assignments if "Cancel" clicked
             *                    context.finalize(false);
             *                }
             *            }
             *        });
             *
             *        // Prevent default behaviour
             *        return false;
             *    }
             * });
             * ```
             *
             * @event beforeAssignmentDelete
             * @param {Scheduler.view.Scheduler} source  The Scheduler instance
             * @param {Scheduler.model.EventModel[]} eventRecords  The records about to be deleted
             * @param {Object} context  Additional removal context:
             * @param {Function} context.finalize  Function to call to finalize the removal.
             *      Used to asynchronously decide to remove the records or not. Provide `false` to the function to
             *      prevent the removal.
             * @param {Boolean} [context.finalize.removeRecords = true]   Provide `false` to the function to prevent
             *      the removal.
             * @preventable
             */
            shouldFinalize = this.trigger('beforeAssignmentDelete', {
              assignmentRecords: records,
              context: context
            });
          } else {
            /**
             * Fires before an event is removed. Can be triggered by user pressing [DELETE] or [BACKSPACE] or by the
             * event editor. Can for example be used to display a custom dialog to confirm deletion, in which case
             * records should be "manually" removed after confirmation:
             *
             * ```javascript
             * scheduler.on({
             *    beforeEventDelete({ eventRecords, context }) {
             *        // Show custom confirmation dialog (pseudo code)
             *        confirm.show({
             *            listeners : {
             *                onOk() {
             *                    // Remove the events on confirmation
             *                    context.finalize(true);
             *                },
             *                onCancel() {
             *                    // do not remove the events if "Cancel" clicked
             *                    context.finalize(false);
             *                }
             *            }
             *        });
             *
             *        // Prevent default behaviour
             *        return false;
             *    }
             * });
             * ```
             *
             * @event beforeEventDelete
             * @param {Scheduler.view.Scheduler} source  The Scheduler instance
             * @param {Scheduler.model.EventModel[]} eventRecords  The records about to be deleted
             * @param {Object} context  Additional removal context:
             * @param {Function} context.finalize  Function to call to finalize the removal.
             *      Used to asynchronously decide to remove the records or not. Provide `false` to the function to
             *      prevent the removal.
             * @param {Boolean} [context.finalize.removeRecords = true]  Provide `false` to the function to prevent
             *      the removal.
             * @preventable
             */
            shouldFinalize = this.trigger('beforeEventDelete', {
              eventRecords: records,
              context: context
            });
          }

          if (shouldFinalize !== false) {
            context.finalize();
            return true;
          }
        }

        return false;
      }
    }, {
      key: "onEventSpaceKey",
      value: function onEventSpaceKey(keyEvent) {// Empty, to be chained by features
      }
    }, {
      key: "onEventEnterKey",
      value: function onEventEnterKey(keyEvent) {// Empty, to be chained by features
      }
    }, {
      key: "activeAssignment",
      set: function set(assignmentRecord) {
        var assignmentEl = this.getElementFromAssignmentRecord(assignmentRecord);
        this.navigator.activeItem = assignmentEl.parentNode;
      },
      get: function get() {
        var activeItem = this.navigator.activeItem;

        if (activeItem) {
          return this.resolveAssignmentRecord(activeItem);
        }
      }
    }, {
      key: "previousActiveEvent",
      get: function get() {
        var previousActiveItem = this.navigator.previousActiveItem;

        if (previousActiveItem) {
          return this.resolveEventRecord(previousActiveItem);
        }
      }
    }, {
      key: "isActionableLocation",
      get: function get() {
        // Override from grid if the Navigator's location is an event (or task if we're in Gantt)
        // Being focused on a task/event means that it's *not* actionable. It's not valid to report
        // that we're "inside" the cell in a TimeLine, so ESC must not attempt to focus the cell.
        if (!this.navigator.activeItem) {
          return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(EventNavigation.prototype), "isActionableLocation", this);
        }
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'EventNavigation';
      } //region Default config

    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * A config object to use when creating the {@link Core.helper.util.Navigator}
           * to use to perform keyboard navigation in the timeline.
           * @config {Object}
           * @default
           * @category Misc
           * @internal
           */
          navigator: {
            allowCtrlKey: true,
            scrollSilently: true,
            keys: {
              Space: 'onEventSpaceKey',
              Enter: 'onEventEnterKey',
              Delete: 'onDeleteKey',
              Backspace: 'onDeleteKey'
            }
          }
        };
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * A CSS class name to add to focused events.
           * @config {String}
           * @default
           * @category CSS
           * @private
           */
          focusCls: 'b-active',

          /**
           * Allow using [Delete] and [Backspace] to remove events/assignments
           * @config {Boolean}
           * @default
           * @category Misc
           */
          enableDeleteKey: true,
          // Number in milliseconds to buffer handlers execution. See `Delayable.throttle` function docs.
          onDeleteKeyBuffer: 500,
          navigatePreviousBuffer: 200,
          navigateNextBuffer: 200,
          testConfig: {
            onDeleteKeyBuffer: 1
          }
        };
      }
    }]);

    return EventNavigation;
  }(Object(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_19__["default"])(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_16__["default"]));
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/EventSelection.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/EventSelection.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.splice */ "./node_modules/core-js/modules/es.array.splice.js");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../../Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");





















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/view/mixin/EventSelection
 */

/**
 * Mixin that tracks event or assignment selection by clicking on one or more events in the scheduler.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_17___default()(EventSelection, _ref);

    var _super = _createSuper(EventSelection);

    function EventSelection() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, EventSelection);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(EventSelection, [{
      key: "afterConstruct",
      //endregion
      //region Events

      /**
       * Fired any time there is a change to the events selected in the Scheduler.
       * @event eventSelectionChange
       * @param {String} action One of the actions 'select', 'deselect', 'update', 'clear'
       * @param {Scheduler.model.EventModel[]} selected An array of the Events added to the selection.
       * @param {Scheduler.model.EventModel[]} deselected An array of the Event removed from the selection.
       * @param {Scheduler.model.EventModel[]} selection The new selection.
       */

      /**
       * Fired any time there is a change to the assignments selected in the Scheduler.
       * @event assignmentSelectionChange
       * @param {String} action One of the actions 'select', 'deselect', 'update', 'clear'
       * @param {Scheduler.model.AssignmentModel[]} selected An array of the Assignments added to the selection.
       * @param {Scheduler.model.AssignmentModel[]} deselected An array of the Assignments removed from the selection.
       * @param {Scheduler.model.AssignmentModel[]} selection The new selection.
       */
      //endregion
      //region Init
      value: function afterConstruct() {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(EventSelection.prototype), "afterConstruct", this).call(this);

        this.navigator.on({
          navigate: 'onEventNavigate',
          thisObj: this
        });
      } //endregion
      //region Selected Collection

    }, {
      key: "getEventsFromAssignments",
      //endregion
      //region Modify selection
      value: function getEventsFromAssignments(assignments) {
        return _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].unique(assignments.map(function (assignment) {
          return assignment.event;
        }));
      }
      /**
       * The {@link Scheduler.model.EventModel events} which are selected.
       * @property {Scheduler.model.EventModel[]}
       * @category Selection
       */

    }, {
      key: "isEventSelected",

      /**
       * Returns `true` if the {@link Scheduler.model.EventModel event} is selected.
       * @param {Scheduler.model.EventModel} event The event
       * @category Selection
       */
      value: function isEventSelected(event) {
        return this.selectedEvents.includes(event);
      }
      /**
       * Returns `true` if the {@link Scheduler.model.AssignmentModel assignment} is selected.
       * @param {Scheduler.model.AssignmentModel} assignment The assignment
       * @category Selection
       */

    }, {
      key: "isAssignmentSelected",
      value: function isAssignmentSelected(assignment) {
        return this.selectedCollection.includes(assignment);
      }
      /**
       * Selects the passed {@link Scheduler.model.EventModel event} or {@link Scheduler.model.AssignmentModel assignment}
       * *if it is not selected*. Selecting events results in all their assignments being selected.
       * @param {Scheduler.model.EventModel|Scheduler.model.AssignmentModel} eventOrAssignment The event or assignment to select
       * @param {Boolean} [preserveSelection] Pass `true` to preserve any other selected events or assignments
       * @category Selection
       */

    }, {
      key: "select",
      value: function select(eventOrAssignment) {
        var preserveSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (eventOrAssignment.isAssignment) {
          this.selectAssignment(eventOrAssignment, preserveSelection);
        } else {
          this.selectEvent(eventOrAssignment, preserveSelection);
        }
      }
      /**
       * Selects the passed {@link Scheduler.model.EventModel event} *if it is not selected*. Selecting an event will
       * select all its assignments.
       * @param {Scheduler.model.EventModel} event The event select
       * @param {Boolean} [preserveSelection] Pass `true` to preserve any other selected events
       * @category Selection
       */

    }, {
      key: "selectEvent",
      value: function selectEvent(event) {
        var preserveSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        // If the event is already selected, this is a no-op.
        // In this case, selection must not be cleared even in the absence of preserveSelection
        if (!this.isEventSelected(event)) {
          preserveSelection ? this.selectedCollection.add(event.assignments) : this.selectedEvents = event;
        }
      }
      /**
       * Selects the passed {@link Scheduler.model.AssignmentModel assignment} *if it is not selected*.
       * @param {Scheduler.model.AssignmentModel} assignment The assignment to select
       * @param {Boolean} [preserveSelection] Pass `true` to preserve any other selected assignments
       * @category Selection
       */

    }, {
      key: "selectAssignment",
      value: function selectAssignment(assignment) {
        var preserveSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        // If the event is already selected, this is a no-op.
        // In this case, selection must not be cleared even in the absence of preserveSelection
        if (!this.isAssignmentSelected(assignment)) {
          preserveSelection ? this.selectedCollection.add(assignment) : this.selectedAssignments = assignment;
        }
      }
      /**
       * Deselects the passed {@link Scheduler.model.EventModel event} or {@link Scheduler.model.AssignmentModel assignment}
       * *if it is selected*.
       * @param {Scheduler.model.EventModel|Scheduler.model.AssignmentModel} eventOrAssignment The event or assignment to deselect.
       * @category Selection
       */

    }, {
      key: "deselect",
      value: function deselect(eventOrAssignment) {
        if (eventOrAssignment.isAssignment) {
          this.deselectAssignment(eventOrAssignment);
        } else {
          this.deselectEvent(eventOrAssignment);
        }
      }
      /**
       * Deselects the passed {@link Scheduler.model.EventModel event} *if it is selected*.
       * @param {Scheduler.model.EventModel} event The event to deselect.
       * @category Selection
       */

    }, {
      key: "deselectEvent",
      value: function deselectEvent(event) {
        if (this.isEventSelected(event)) {
          var _this$selectedCollect;

          (_this$selectedCollect = this.selectedCollection).remove.apply(_this$selectedCollect, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13___default()(event.assignments));
        }
      }
      /**
       * Deselects the passed {@link Scheduler.model.AssignmentModel assignment} *if it is selected*.
       * @param {Scheduler.model.AssignmentModel} assignment The assignment to deselect
       * @category Selection
       */

    }, {
      key: "deselectAssignment",
      value: function deselectAssignment(assignment) {
        if (this.isAssignmentSelected(assignment)) {
          this.selectedCollection.remove(assignment);
        }
      }
      /**
       * Adds {@link Scheduler.model.EventModel events} to the selection.
       * @param {Scheduler.model.EventModel[]} events Events to be selected
       * @category Selection
       */

    }, {
      key: "selectEvents",
      value: function selectEvents(events) {
        this.selectedCollection.add(events.reduce(function (assignments, event) {
          assignments.push.apply(assignments, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13___default()(event.assignments));
          return assignments;
        }, []));
      }
      /**
       * Removes {@link Scheduler.model.EventModel events} from the selection.
       * @param {Scheduler.model.EventModel[]} events Events or assignments  to be deselected
       * @category Selection
       */

    }, {
      key: "deselectEvents",
      value: function deselectEvents(events) {
        this.selectedCollection.remove(events.reduce(function (assignments, event) {
          assignments.push.apply(assignments, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13___default()(event.assignments));
          return assignments;
        }, []));
      }
      /**
       * Adds {@link Scheduler.model.AssignmentModel assignments} to the selection.
       * @param {Scheduler.model.AssignmentModel[]} assignments Assignments to be selected
       * @category Selection
       */

    }, {
      key: "selectAssignments",
      value: function selectAssignments(assignments) {
        this.selectedCollection.add(assignments);
      }
      /**
       * Removes {@link Scheduler.model.AssignmentModel assignments} from the selection.
       * @param {Scheduler.model.AssignmentModel[]} assignments Assignments  to be deselected
       * @category Selection
       */

    }, {
      key: "deselectAssignments",
      value: function deselectAssignments(assignments) {
        this.selectedCollection.remove(assignments);
      }
      /**
       * Deselects all {@link Scheduler.model.EventModel events} and {@link Scheduler.model.AssignmentModel assignments}.
       * @category Selection
       */

    }, {
      key: "clearEventSelection",
      value: function clearEventSelection() {
        this.selectedAssignments = [];
      } //endregion
      //region Events

      /**
       * Responds to mutations of the underlying selection Collection.
       * Keeps the UI synced, eventSelectionChange and assignmentSelectionChange event is fired when `me.silent` is falsy.
       * @private
       */

    }, {
      key: "onSelectedCollectionChange",
      value: function onSelectedCollectionChange(_ref2) {
        var added = _ref2.added,
            removed = _ref2.removed;
        var me = this,
            selection = me.selectedAssignments,
            selected = added || [],
            deselected = removed || [];

        function updateSelection(assignmentRecord, select) {
          var eventRecord = assignmentRecord.event;

          if (eventRecord) {
            var element = me.getElementFromAssignmentRecord(assignmentRecord);
            me.currentOrientation.toggleCls(assignmentRecord, me.eventSelectedCls, select);
            me.getElementsFromEventRecord(eventRecord).forEach(function (el) {
              if (el !== element) {
                var otherAssignmentRecord = me.resolveAssignmentRecord(el);
                me.currentOrientation.toggleCls(otherAssignmentRecord, me.eventAssignHighlightCls, select);
                el.classList[select ? 'add' : 'remove'](me.eventAssignHighlightCls);
              }
            });
          }
        }

        selected.forEach(function (record) {
          return updateSelection(record, true);
        });
        deselected.forEach(function (record) {
          return updateSelection(record, false);
        }); // To be able to restore selection after reloading resources (which might lead to regenerated assignments in
        // the single assignment scenario, so cannot rely on records or ids)

        me.$selectedAssignments = selection.map(function (assignment) {
          return {
            eventId: assignment.eventId,
            resourceId: assignment.resourceId
          };
        });

        if (!me.silent) {
          var action = selection.length > 0 ? selected.length > 0 && deselected.length > 0 ? 'update' : selected.length > 0 ? 'select' : 'deselect' : 'clear';
          me.trigger('assignmentSelectionChange', {
            action: action,
            selection: selection,
            selected: selected,
            deselected: deselected
          });
          me.trigger('eventSelectionChange', {
            action: action,
            selection: me.selectedEvents,
            selected: me.getEventsFromAssignments(selected),
            deselected: me.getEventsFromAssignments(deselected)
          });
        }
      }
      /**
       * Assignment change listener to remove events from selection which are no longer in the assignments.
       * @private
       */

    }, {
      key: "onAssignmentChange",
      value: function onAssignmentChange(_ref3) {
        var action = _ref3.action,
            assignments = _ref3.records;
        var me = this;
        me.silent = !me.triggerSelectionChangeOnRemove;

        if (action === 'remove') {
          me.deselectAssignments(assignments);
        } else if (action === 'removeall' && !me.eventStore.isSettingData) {
          me.clearEventSelection();
        } else if (action === 'dataset' && me.$selectedAssignments) {
          if (!me.maintainSelectionOnDatasetChange) {
            me.clearEventSelection();
          } else {
            var newAssignments = me.$selectedAssignments.map(function (selector) {
              return assignments.find(function (a) {
                return a.eventId === selector.eventId && a.resourceId === selector.resourceId;
              });
            });
            me.selectedAssignments = _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].clean(newAssignments);
          }
        }

        me.silent = false;
      }
    }, {
      key: "onInternalEventStoreChange",
      value: function onInternalEventStoreChange(_ref4) {
        var action = _ref4.action,
            records = _ref4.records;

        // Setting empty event dataset cannot be handled in onAssignmentChange above, no assignments might be affected
        if (action === 'dataset' && !records.length) {
          this.clearEventSelection();
        }

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_16___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_19___default()(EventSelection.prototype), "onInternalEventStoreChange", this).apply(this, arguments);
      }
      /**
       * Mouse listener to update selection.
       * @private
       */

    }, {
      key: "onAssignmentSelectionClick",
      value: function onAssignmentSelectionClick(event, clickedRecord) {
        var me = this; // Multi selection: CTRL means preserve selection, just add or remove the event.
        // Single selection: CTRL deselects already selected event

        if (me.isAssignmentSelected(clickedRecord)) {
          event.ctrlKey && me.deselectAssignment(clickedRecord, me.multiEventSelect);
        } else {
          me.selectAssignment(clickedRecord, event.ctrlKey && me.multiEventSelect);
        }
      }
      /**
       * Navigation listener to update selection.
       * @private
       */

    }, {
      key: "onEventNavigate",
      value: function onEventNavigate(_ref5) {
        var event = _ref5.event,
            item = _ref5.item;

        if (!this.eventSelectionDisabled) {
          var assignment = item && (item.nodeType === 1 ? this.resolveAssignmentRecord(item) : item);

          if (assignment) {
            this.onAssignmentSelectionClick(event, assignment);
          } // Click outside of an event/assignment;
          else {
              this.clearEventSelection();
            }
        }
      } //endregion
      //region Getters/Setters
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "selectedCollection",
      set: function set(selectedCollection) {
        if (!(selectedCollection instanceof _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_21__["default"])) {
          selectedCollection = new _Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_21__["default"](selectedCollection);
        }

        this._selectedCollection = selectedCollection; // Fire row change events from onSelectedCollectionChange

        selectedCollection.on({
          change: 'onSelectedCollectionChange',
          thisObj: this
        });
      },
      get: function get() {
        return this._selectedCollection;
      }
    }, {
      key: "selectedEvents",
      get: function get() {
        return this.getEventsFromAssignments(this.selectedCollection.values);
      },
      set: function set(events) {
        // Select all assignments
        var assignments = [];

        if (events && !Array.isArray(events)) {
          events = [events];
        }

        events && events.forEach(function (event) {
          assignments.push.apply(assignments, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13___default()(event.assignments));
        }); // Replace the entire selected collection with the new record set

        this.selectedCollection.splice(0, this.selectedCollection.count, assignments);
      }
      /**
       * The {@link Scheduler.model.AssignmentModel events} which are selected.
       * @property {Scheduler.model.AssignmentModel[]}
       * @category Selection
       */

    }, {
      key: "selectedAssignments",
      get: function get() {
        return this.selectedCollection.values;
      },
      set: function set(assignments) {
        // Replace the entire selected collection with the new record set
        this.selectedCollection.splice(0, this.selectedCollection.count, assignments || []);
      }
    }, {
      key: "widgetClass",
      get: function get() {} //endregion

    }], [{
      key: "$name",
      get: function get() {
        return 'EventSelection';
      } //region Default config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Configure as `true` to allow `CTRL+click` to select multiple events in the scheduler.
           * @config {Boolean}
           * @category Selection
           */
          multiEventSelect: false,

          /**
           * Configure as `true`, or set property to `true` to disable event selection.
           * @config {Boolean}
           * @default
           * @category Selection
           */
          eventSelectionDisabled: false,

          /**
           * CSS class to add to selected events.
           * @config {String}
           * @default
           * @category CSS
           * @private
           */
          eventSelectedCls: 'b-sch-event-selected',

          /**
           * Configure as `true` to trigger `selectionChange` when removing a selected event/assignment.
           * @config {Boolean}
           * @default
           * @category Selection
           */
          triggerSelectionChangeOnRemove: false,

          /**
           * This flag controls whether Scheduler should maintain its selection of events when loading a new dataset (if selected event ids are included in the newly loaded dataset).
           * @config {Boolean}
           * @default
           * @category Selection
           */
          maintainSelectionOnDatasetChange: true,

          /**
           * CSS class to add to other instances of a selected event, to highlight them.
           * @config {String}
           * @default
           * @category CSS
           * @private
           */
          eventAssignHighlightCls: 'b-sch-event-assign-selected',

          /**
           * Collection to store selection.
           * @config {Core.util.Collection}
           * @private
           */
          selectedCollection: {}
        };
      }
    }]);

    return EventSelection;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_20__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/RecurringEvents.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/RecurringEvents.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _recurrence_RecurrenceConfirmationPopup_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../recurrence/RecurrenceConfirmationPopup.js */ "./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/view/mixin/RecurringEvents
 */

/**
 * A mixin that adds recurring events functionality to the Scheduler.
 *
 * The main purpose of the code in here is displaying  a {@link Scheduler.view.recurrence.RecurrenceConfirmationPopup special confirmation}
 * on user mouse dragging/resizing/deleting recurring events and their occurrences.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(RecurringEvents, _ref);

    var _super = _createSuper(RecurringEvents);

    function RecurringEvents() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, RecurringEvents);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(RecurringEvents, [{
      key: "construct",
      value: function construct(config) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(RecurringEvents.prototype), "construct", this).call(this, config);

        this.on({
          beforeeventdropfinalize: 'onBeforeEventDropFinalize',
          beforeeventresizefinalize: 'onBeforeEventResizeFinalize',
          beforeEventDelete: 'onRecurrableEventBeforeDelete',
          beforeAssignmentDelete: 'onRecurrableAssignmentBeforeDelete',
          thisObj: this
        });
      }
    }, {
      key: "changeRecurrenceConfirmationPopup",
      value: function changeRecurrenceConfirmationPopup(recurrenceConfirmationPopup, oldRecurrenceConfirmationPopup) {
        // Widget.reconfigure reither reconfigures an existing instance, or creates a new one, or,
        // if the configuration is null, destroys the existing instance.
        var result = this.constructor.reconfigure(oldRecurrenceConfirmationPopup, recurrenceConfirmationPopup, 'recurrenceconfirmation');
        result.owner = this;
        return result;
      }
    }, {
      key: "showDisplayConfirmationOnEventDelete",
      value: function showDisplayConfirmationOnEventDelete(eventRecord) {
        var eventEdit = this.features.eventEdit; // show confirmation if we deal with a recurring event (or its occurrence)
        // and if the record is not being edited by event editor (since event editor has its own confirmation)

        return eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence) && (!eventEdit || !eventEdit.isEditing || eventEdit.eventRecord !== eventRecord);
      }
    }, {
      key: "onRecurrableEventBeforeDelete",
      value: function onRecurrableEventBeforeDelete(_ref2) {
        var eventRecords = _ref2.eventRecords,
            context = _ref2.context;

        var _eventRecords = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4___default()(eventRecords, 1),
            eventRecord = _eventRecords[0];

        if (this.enableRecurringEvents && this.showDisplayConfirmationOnEventDelete(eventRecord)) {
          this.recurrenceConfirmationPopup.confirm({
            actionType: 'delete',
            eventRecord: eventRecord,
            changerFn: function changerFn() {
              context.finalize(true);
            },
            cancelFn: function cancelFn() {
              context.finalize(false);
            }
          });
          return false;
        }
      }
    }, {
      key: "onRecurrableAssignmentBeforeDelete",
      value: function onRecurrableAssignmentBeforeDelete(_ref3) {
        var assignmentRecords = _ref3.assignmentRecords,
            context = _ref3.context;
        var eventRecord = assignmentRecords[0].event;

        if (this.enableRecurringEvents && this.showDisplayConfirmationOnEventDelete(eventRecord)) {
          this.recurrenceConfirmationPopup.confirm({
            actionType: 'delete',
            eventRecord: eventRecord,
            changerFn: function changerFn() {
              context.finalize(true);
            },
            cancelFn: function cancelFn() {
              context.finalize(false);
            }
          });
          return false;
        }
      }
    }, {
      key: "onBeforeEventDropFinalize",
      value: function onBeforeEventDropFinalize(_ref4) {
        var context = _ref4.context;

        if (this.enableRecurringEvents) {
          var eventRecords = context.eventRecords,
              recurringEvents = eventRecords.filter(function (eventRecord) {
            return eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence);
          });

          if (recurringEvents.length) {
            context.async = true;
            this.recurrenceConfirmationPopup.confirm({
              actionType: 'update',
              eventRecord: recurringEvents[0],
              changerFn: function changerFn() {
                context.finalize(true);
              },
              cancelFn: function cancelFn() {
                context.finalize(false);
              }
            });
          }
        }
      }
    }, {
      key: "onBeforeEventResizeFinalize",
      value: function onBeforeEventResizeFinalize(_ref5) {
        var context = _ref5.context;

        if (this.enableRecurringEvents) {
          var eventRecord = context.eventRecord,
              isRecurring = eventRecord.supportsRecurring && (eventRecord.isRecurring || eventRecord.isOccurrence);

          if (isRecurring) {
            context.async = true;
            this.recurrenceConfirmationPopup.confirm({
              actionType: 'update',
              eventRecord: eventRecord,
              changerFn: function changerFn() {
                context.finalize(true);
              },
              cancelFn: function cancelFn() {
                context.finalize(false);
              }
            });
          }
        }
      }
      /**
       * Returns occurrences of the provided recurring event across the date range of this Scheduler.
       * @param  {Scheduler.model.TimeSpan} recurringEvent Recurring event for which occurrences should be retrieved.
       * @return {Scheduler.model.TimeSpan[]} Array of the provided timespans occurrences.
       *
       * __Empty if the passed event is not recurring, or has no occurrences in the date range.__
       *
       * __If the date range encompasses the start point, the recurring event itself will be the first entry.__
       */

    }, {
      key: "getOccurrencesFor",
      value: function getOccurrencesFor(recurringEvent) {
        return this.eventStore.getOccurrencesForTimeSpan(recurringEvent, this.timeAxis.startDate, this.timeAxis.endDate);
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'RecurringEvents';
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * Enables showing occurrences of recurring events across the scheduler's time axis.
           *
           * Enables extra recurrence UI fields in the system-provided event editor.
           * @config {Boolean}
           * @default false
           * @category Scheduled events
           */
          enableRecurringEvents: false,
          recurrenceConfirmationPopup: {
            $config: ['lazy'],
            value: {
              type: 'recurrenceconfirmation'
            }
          }
        };
      }
    }]);

    return RecurringEvents;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_11__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerDom.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerDom.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/view/mixin/SchedulerDom
 */

/**
 * Mixin with EventModel and ResourceModel <-> HTMLElement mapping functions
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(SchedulerDom, _ref);

    var _super = _createSuper(SchedulerDom);

    function SchedulerDom() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, SchedulerDom);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(SchedulerDom, [{
      key: "getElementFromAssignmentRecord",
      //region Get

      /**
       * Returns a single HTMLElement representing an event record assigned to a specific resource.
       * @param {Scheduler.model.AssignmentModel} assignmentRecord An assignment record
       * @return {HTMLElement} The element representing the event record
       */
      value: function getElementFromAssignmentRecord(assignmentRecord) {
        var returnWrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return this.currentOrientation.getElementFromAssignmentRecord(assignmentRecord, returnWrapper);
      }
      /**
       * Returns a single HTMLElement representing an event record assigned to a specific resource.
       * @param {Scheduler.model.EventModel} eventRecord An event record
       * @param {Scheduler.model.ResourceModel} resourceRecord A resource record
       * @return {HTMLElement} The element representing the event record
       */

    }, {
      key: "getElementFromEventRecord",
      value: function getElementFromEventRecord(eventRecord, resourceRecord) {
        var returnWrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return this.currentOrientation.getElementFromEventRecord(eventRecord, resourceRecord, returnWrapper);
      }
      /**
       * Returns all the HTMLElements representing an event record.
       *
       * @param {Scheduler.model.EventModel} eventRecord An event record
       * @param {Scheduler.model.ResourceModel} [resourceRecord] A resource record
       *
       * @return {HTMLElement[]} The element(s) representing the event record
       */

    }, {
      key: "getElementsFromEventRecord",
      value: function getElementsFromEventRecord(eventRecord, resourceRecord) {
        var returnWrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return this.currentOrientation.getElementsFromEventRecord(eventRecord, resourceRecord, returnWrapper);
      } //endregion
      //region Resolve

      /**
       * Resolves the resource based on a dom element or event. In vertical mode, if resolving from an element higher up in
       * the hierarchy than event elements, then it is required to supply an coordinates since resources are virtual
       * columns.
       * @param {HTMLElement|Event} elementOrEvent The HTML element or DOM event to resolve a resource from
       * @param {Number[]} [xy] X and Y coordinates, required in some cases in vertical mode, disregarded in horizontal
       * @return {Scheduler.model.ResourceModel} The resource corresponding to the element, or null if not found.
       */

    }, {
      key: "resolveResourceRecord",
      value: function resolveResourceRecord(elementOrEvent, xy) {
        return this.currentOrientation.resolveRowRecord(elementOrEvent, xy);
      }
      /**
       * Returns the event record for a DOM element
       * @param {HTMLElement} element The DOM node to lookup
       * @return {Scheduler.model.EventModel} The event record
       */

    }, {
      key: "resolveEventRecord",
      value: function resolveEventRecord(element) {
        element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(element, this.eventSelector);

        if (element) {
          if (element.dataset.eventId) {
            return this.eventStore.getById(element.dataset.eventId);
          }

          if (element.dataset.assignmentId) {
            return this.assignmentStore.getById(element.dataset.assignmentId).event;
          }
        }

        return null;
      } // Used by shared features to resolve an event or task

    }, {
      key: "resolveTimeSpanRecord",
      value: function resolveTimeSpanRecord(element) {
        return this.resolveEventRecord(element);
      }
      /**
       * Returns an assignment record for a DOM element
       * @param {HTMLElement} element The DOM node to lookup
       * @return {Scheduler.model.AssignmentModel} The assignment record
       */

    }, {
      key: "resolveAssignmentRecord",
      value: function resolveAssignmentRecord(element) {
        var eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(element, this.eventSelector),
            assignmentRecord = eventElement && this.assignmentStore.getById(eventElement.dataset.assignmentId),
            eventRecord = eventElement && this.eventStore.getById(eventElement.dataset.eventId); // When resolving a recurring event, we might be resolving an occurrence

        return this.assignmentStore.getOccurrence(assignmentRecord, eventRecord);
      } //endregion
      // Decide if a record is inside a collapsed tree node, or inside a collapsed group (using grouping feature)

    }, {
      key: "isRowVisible",
      value: function isRowVisible(resourceRecord) {
        // records in collapsed groups/brances etc are removed from processedRecords
        return this.store.indexOf(resourceRecord) >= 0;
      }
      /**
       * Determines width of a milestones label. How width is determined is decided by configuring Scheduler#milestoneLayoutMode.
       * Please note that currently text width is always determined using EventModel#name.
       * @param {Scheduler.model.EventModel} eventRecord
       * @returns {Number}
       */

    }, {
      key: "getMilestoneLabelWidth",
      value: function getMilestoneLabelWidth(eventRecord) {
        var me = this,
            mode = me.milestoneLayoutMode;

        if (mode === 'measure') {
          var element = me.milestoneMeasureElement || (me.milestoneMeasureElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].createElement({
            className: 'b-sch-event-wrap b-milestone-wrap b-measure',
            children: [{
              className: 'b-sch-event b-milestone',
              children: [{
                className: 'b-sch-event-content'
              }]
            }],
            parent: me.foregroundCanvas
          })); // DomSync should not touch

          element.retainElement = true;
          element.firstElementChild.firstElementChild.innerHTML = eventRecord.name;
          return element.offsetWidth;
        }

        if (mode === 'estimate') {
          return Math.max(eventRecord.name.length * me.milestoneCharWidth, me.milestoneMinWidth);
        }

        if (mode === 'data') {
          return Math.max(eventRecord.milestoneWidth, me.milestoneMinWidth);
        }

        return 0;
      }
    }, {
      key: "milestoneLayoutMode",
      set: function set(mode) {
        this._milestoneLayoutMode = mode;
        this.element.classList[mode !== 'default' ? 'add' : 'remove']('b-sch-layout-milestones');

        if (!this.isConfiguring) {
          this.refreshWithTransition();
        }
      },
      get: function get() {
        return this._milestoneLayoutMode;
      }
    }, {
      key: "milestoneAlign",
      set: function set(align) {
        this._milestoneAlign = align;

        if (!this.isConfiguring) {
          this.refreshWithTransition();
        }
      },
      get: function get() {
        return this._milestoneAlign;
      }
    }, {
      key: "milestoneCharWidth",
      set: function set(width) {
        this._milestoneCharWidth = width;

        if (!this.isConfiguring) {
          this.refreshWithTransition();
        }
      },
      get: function get() {
        return this._milestoneCharWidth;
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'SchedulerDom';
      }
    }]);

    return SchedulerDom;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerDomEvents.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerDomEvents.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/mixin/SchedulerDomEvents
 */

/**
 * Mixin that handles dom events (click etc) for scheduler and rendered events.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(SchedulerDomEvents, _ref);

    var _super = _createSuper(SchedulerDomEvents);

    function SchedulerDomEvents() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SchedulerDomEvents);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerDomEvents, [{
      key: "getTimeSpanMouseEventParams",
      //region Events

      /**
       * Triggered when user moves mouse over an empty area in the schedule.
       * @event scheduleMouseMove
       * @param {Scheduler.view.TimelineBase} source This TimelineBase
       * @param {Date} date Date at mouse position
       * @param {Date} tickStartDate The start date of the current time axis tick
       * @param {Date} tickEndDate The end date of the current time axis tick
       * @param {Grid.row.Row} row Clicked row (in horizontal mode only)
       * @param {Number} index Index of clicked resource
       * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered when user clicks an empty area in the schedule.
       * @event scheduleClick
       * @param {Scheduler.view.TimelineBase} source This TimelineBase
       * @param {Date} date Date at mouse position
       * @param {Date} tickStartDate The start date of the current time axis tick
       * @param {Date} tickEndDate The end date of the current time axis tick
       * @param {Grid.row.Row} row Clicked row (in horizontal mode only)
       * @param {Number} index Index of clicked resource
       * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered when user clicks an empty area in the schedule.
       * @event scheduleDblClick
       * @param {Scheduler.view.TimelineBase} source This TimelineBase
       * @param {Date} date Date at mouse position
       * @param {Date} tickStartDate The start date of the current time axis tick
       * @param {Date} tickEndDate The end date of the current time axis tick
       * @param {Grid.row.Row} row Double clicked row (in horizontal mode only)
       * @param {Number} index Index of double clicked resource
       * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered when user right clicks an empty area in the schedule.
       * @event scheduleContextMenu
       * @param {Scheduler.view.TimelineBase} source This TimelineBase
       * @param {Date} date Date at mouse position
       * @param {Date} tickStartDate The start date of the current time axis tick
       * @param {Date} tickEndDate The end date of the current time axis tick
       * @param {Grid.row.Row} row Clicked row (in horizontal mode only)
       * @param {Number} index Index of clicked resource
       * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered for mouse down on an event.
       * @event eventMouseDown
       * @param {Scheduler.view.Scheduler} source This Scheduler
       * @param {Scheduler.model.EventModel} eventRecord Event record
       * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered for mouse up on an event.
       * @event eventMouseUp
       * @param {Scheduler.view.Scheduler} source This Scheduler
       * @param {Scheduler.model.EventModel} eventRecord Event record
       * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered for click on an event.
       * @event eventClick
       * @param {Scheduler.view.Scheduler} source This Scheduler
       * @param {Scheduler.model.EventModel} eventRecord Event record
       * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered for double click on an event.
       * @event eventDblClick
       * @param {Scheduler.view.Scheduler} source This Scheduler
       * @param {Scheduler.model.EventModel} eventRecord Event record
       * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered for right click on an event.
       * @event eventContextMenu
       * @param {Scheduler.view.Scheduler} source This Scheduler
       * @param {Scheduler.model.EventModel} eventRecord Event record
       * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered for mouse over on an event.
       * @event eventMouseOver
       * @param {Scheduler.view.Scheduler} source This Scheduler
       * @param {Scheduler.model.EventModel} eventRecord Event record
       * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
       * @param {MouseEvent} event Browser event
       */

      /**
       * Triggered for mouse out from an event.
       * @event eventMouseOut
       * @param {Scheduler.view.Scheduler} source This Scheduler
       * @param {Scheduler.model.EventModel} eventRecord Event record
       * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record
       * @param {MouseEvent} event Browser event
       */
      //endregion
      //region Event handling
      value: function getTimeSpanMouseEventParams(eventElement, event) {
        // May have hovered a record being removed / faded out
        var eventRecord = this.resolveEventRecord(eventElement);
        return eventRecord && {
          eventRecord: eventRecord,
          resourceRecord: this.resolveResourceRecord(eventElement),
          assignmentRecord: this.resolveAssignmentRecord(eventElement),
          eventElement: eventElement,
          event: event
        };
      }
    }, {
      key: "getScheduleMouseEventParams",
      value: function getScheduleMouseEventParams(cellData, event) {
        var resourceRecord = this.isVertical ? this.resolveResourceRecord(event) : this.store.getById(cellData.id);
        return {
          resourceRecord: resourceRecord
        };
      }
      /**
       * Relays keydown events as eventkeydown if we have a selected task.
       * @private
       */

    }, {
      key: "onElementKeyDown",
      value: function onElementKeyDown(event) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(SchedulerDomEvents.prototype), "onElementKeyDown", this).call(this, event);

        var me = this;

        if (me.selectedEvents.length) {
          me.trigger(me.scheduledEventName + 'KeyDown', {
            eventRecord: me.selectedEvents,
            assignmentRecord: me.selectedAssignments
          });
        }
      }
      /**
       * Relays keyup events as eventkeyup if we have a selected task.
       * @private
       */

    }, {
      key: "onElementKeyUp",
      value: function onElementKeyUp(event) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(SchedulerDomEvents.prototype), "onElementKeyUp", this).call(this, event);

        var me = this;

        if (me.selectedEvents.length) {
          me.trigger(me.scheduledEventName + 'KeyUp', {
            eventRecord: me.selectedEvents,
            assignmentRecord: me.selectedAssignments
          });
        }
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'SchedulerDomEvents';
      }
    }]);

    return SchedulerDomEvents;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerDragResize.js":
/*!*********************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerDragResize.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/mixin/SchedulerDragResize
 */

/**
 * Mixin for triggering event editor on drag creation etc.
 * @private
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(SchedulerDragResize, _ref);

    var _super = _createSuper(SchedulerDragResize);

    function SchedulerDragResize() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SchedulerDragResize);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerDragResize, [{
      key: "construct",
      value: function construct(config) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(SchedulerDragResize.prototype), "construct", this).call(this, config);

        if (this.hasFeature('eventDragCreate')) {
          this.on({
            dragCreateEnd: 'internalOnDragCreateEnd',
            thisObj: this
          });
        }
      }
    }, {
      key: "internalOnDragCreateEnd",
      value: function internalOnDragCreateEnd(_ref2) {
        var eventRecord = _ref2.newEventRecord,
            resourceRecord = _ref2.resourceRecord;
        var me = this; // If an event editor is defined and enabled, it has to manage how/if/when the event is added to the event store

        if ( // Scheduler or Scheduler Pro using `eventEdit`
        (!me.hasFeature('eventEdit') || me.features.eventEdit.disabled) && ( // Scheduler Pro using `taskEdit`
        !me.hasFeature('taskEdit') || me.features.taskEdit.disabled)) {
          var resources = resourceRecord ? [resourceRecord] : []; // resources **Deprecated 4.0** Use `resourceRecords` instead

          if (me.trigger('beforeEventAdd', {
            eventRecord: eventRecord,
            resources: resources,
            resourceRecords: resources
          }) !== false) {
            me.onEventCreated(eventRecord);
            me.eventStore.add(eventRecord);
            eventRecord.assign(resourceRecord);
          }
        }
      }
    }, {
      key: "eventEditor",
      get: function get() {
        return this._eventEditor;
      },
      set: function set(editor) {
        this._eventEditor = editor;
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'SchedulerDragResize';
      }
    }]);

    return SchedulerDragResize;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerEventRendering.js":
/*!*************************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerEventRendering.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _eventlayout_HorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../eventlayout/HorizontalLayoutStack.js */ "./lib/Scheduler/eventlayout/HorizontalLayoutStack.js");
/* harmony import */ var _eventlayout_HorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../eventlayout/HorizontalLayoutPack.js */ "./lib/Scheduler/eventlayout/HorizontalLayoutPack.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");




















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';






/**
 * @module Scheduler/view/mixin/SchedulerEventRendering
 */

/**
 * Functions to handle event rendering (EventModel -> dom elements).
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_16___default()(SchedulerEventRendering, _ref);

    var _super = _createSuper(SchedulerEventRendering);

    function SchedulerEventRendering() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, SchedulerEventRendering);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerEventRendering, [{
      key: "getEventsToRender",
      //endregion
      //region Event rendering
      // Chainable function called with the events to render for a specific resource. Allows features to add/remove.
      // Chained by ResourceTimeRanges
      value: function getEventsToRender(resource, events) {
        return events;
      }
      /**
       * Rerenders events for specified resource (by rerendering the entire row).
       * @param {Scheduler.model.ResourceModel} resourceRecord
       */

    }, {
      key: "repaintEventsForResource",
      value: function repaintEventsForResource(resourceRecord) {
        this.currentOrientation.repaintEventsForResource(resourceRecord);
      }
      /**
       * Rerenders the events for all resources connected to the specified event
       * @param {Scheduler.model.EventModel} eventRecord
       * @private
       */

    }, {
      key: "repaintEvent",
      value: function repaintEvent(eventRecord) {
        var _this = this;

        var resources = this.eventStore.getResourcesForEvent(eventRecord);
        resources.forEach(function (resourceRecord) {
          return _this.repaintEventsForResource(resourceRecord);
        });
      } //endregion
      //region Template

      /**
       * Generates data used in the template when rendering an event. For example which css classes to use. Also applies
       * #eventBodyTemplate and calls the {@link #config-eventRenderer}.
       * @private
       * @param {Scheduler.model.EventModel} eventRecord Event to generate data for
       * @param {Scheduler.model.ResourceModel} resourceRecord Events resource
       * @param {Boolean|Object} includeOutside Specify true to get boxes for timespans outside of the rendered zone in both
       * dimensions. This option is used when calculating dependency lines, and we need to include routes from timespans
       * which may be outside the rendered zone.
       * @param {Boolean} includeOutside.timeAxis Pass as `true` to include timespans outside of the TimeAxis's bounds
       * @param {Boolean} includeOutside.viewport Pass as `true` to include timespans outside of the vertical timespan viewport's bounds.
       * @returns {Object} Data to use in event template, or `undefined` if the event is outside of the rendered zone.
       */

    }, {
      key: "generateRenderData",
      value: function generateRenderData(eventRecord, resourceRecord) {
        var includeOutside = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
          viewport: true
        };
        // TODO: Change this fn to accept an assignment instead of event + resource
        var me = this,
            renderData = me.currentOrientation.getTimeSpanRenderData(eventRecord, resourceRecord, includeOutside),
            isEvent = eventRecord.isEvent,
            isMilestone = eventRecord.isMilestone,
            assignmentRecord = isEvent && eventRecord.assignments.find(function (a) {
          return a.resourceId === resourceRecord.id;
        }),
            eventContent = {
          className: 'b-sch-event-content',
          dataset: {
            taskBarFeature: 'content'
          }
        };

        if (renderData) {
          var _Object$assign;

          var resizable = eventRecord.isResizable;

          if (renderData.startsOutsideView) {
            if (resizable === true) resizable = 'end';else if (resizable === 'start') resizable = false;
          }

          if (renderData.endsOutsideView) {
            if (resizable === true) resizable = 'start';else if (resizable === 'end') resizable = false;
          } // Event record cls properties are now DomClassList instances, so clone them
          // so that they can be manipulated here and by renderers.
          // Truthy value means the key will be added as a class name.
          // ResourceTimeRanges applies custom cls to wrapper.


          var clsList = eventRecord.isResourceTimeRange ? new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_20__["default"]() : eventRecord.cls.clone(),
              wrapperClsList = eventRecord.isResourceTimeRange ? eventRecord.cls.clone() : new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_20__["default"]();
          Object.assign(clsList, (_Object$assign = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, resourceRecord.cls, resourceRecord.cls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, me.generatedIdCls, eventRecord.hasGeneratedId), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, me.dirtyCls, Boolean(eventRecord.hasPersistableChanges || assignmentRecord && assignmentRecord.hasPersistableChanges)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, me.committingCls, eventRecord.isCommitting), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, me.endsOutsideViewCls, renderData.endsOutsideView), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, me.startsOutsideViewCls, renderData.startsOutsideView), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, 'b-clipped-start', renderData.clippedStart), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign, 'b-clipped-end', renderData.clippedEnd), _Object$assign));
          Object.assign(wrapperClsList, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()({}, "".concat(me.eventCls, "-parent"), resourceRecord.isParent));
          renderData.wrapperStyle = ''; // Event specifics, things that do not apply to ResourceTimeRanges

          if (isEvent) {
            var _Object$assign3, _Object$assign4;

            var selected = assignmentRecord && me.isAssignmentSelected(assignmentRecord);
            Object.assign(clsList, (_Object$assign3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign3, me.eventCls, 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign3, 'b-milestone', isMilestone), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign3, 'b-sch-event-narrow', renderData.width < 10), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign3, me.fixedEventCls, eventRecord.isDraggable === false), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign3, "b-sch-event-resizable-".concat(resizable), Boolean(me.features.eventResize)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign3, me.eventSelectedCls, selected), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign3, me.eventAssignHighlightCls, me.isEventSelected(eventRecord) && !selected), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign3, 'b-recurring', eventRecord.isRecurring), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign3, 'b-occurrence', eventRecord.isOccurrence), _Object$assign3));
            renderData.eventId = eventRecord.id;
            var eventStyle = eventRecord.eventStyle || resourceRecord.eventStyle || me.eventStyle,
                eventColor = eventRecord.eventColor || resourceRecord.eventColor || me.eventColor,
                hasAnimation = me.isFirstRender && me.useInitialAnimation;
            Object.assign(wrapperClsList, (_Object$assign4 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign4, "".concat(me.eventCls, "-wrap"), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_Object$assign4, 'b-milestone-wrap', isMilestone), _Object$assign4));

            if (hasAnimation) {
              var index = renderData.row ? renderData.row.index : renderData.top / me.tickSize;
              renderData.wrapperStyle = "animation-delay: ".concat(index / 20, "s;"); // Further initial animations are prevented when the first one has finished

              if (!me.initialAnimationDetacher) {
                me.initialAnimationDetacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].on({
                  element: me.foregroundCanvas,
                  delegate: me.eventSelector,
                  animationend: 'stopInitialAnimation',
                  // Fallback in case animation is interrupted
                  expires: {
                    alt: 'stopInitialAnimation',
                    delay: me.initialAnimationDuration
                  },
                  thisObj: me
                });
              }
            }

            renderData.eventColor = eventColor;
            renderData.eventStyle = eventStyle; // TODO: Deprecate assignment, use assignmentRecord

            renderData.assignmentRecord = renderData.assignment = assignmentRecord;
          } // If not using a wrapping div, this cls will be added to event div for correct rendering


          renderData.wrapperCls = wrapperClsList;
          renderData.cls = clsList;
          renderData.iconCls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_20__["default"](eventRecord.get(me.eventBarIconClsField) || eventRecord.iconCls); // ResourceTimeRanges applies custom style to the wrapper

          if (eventRecord.isResourceTimeRange) {
            renderData.style = '';
            renderData.wrapperStyle += eventRecord.style || '';
          } // Others to inner
          else {
              renderData.style = eventRecord.style || '';
            } // TODO: Deprecate resource in favor of resourceRecord


          renderData.resource = renderData.resourceRecord = resourceRecord;
          renderData.resourceId = renderData.rowId;

          if (isEvent) {
            var childContent = null,
                milestoneLabelConfig = null,
                value;

            if (me.eventRenderer) {
              // User has specified a renderer fn, either to return a simple string, or an object intended for the eventBodyTemplate
              var rendererValue = me.eventRenderer.call(me.eventRendererThisObj || me, {
                eventRecord: eventRecord,
                resourceRecord: resourceRecord,
                assignmentRecord: renderData.assignmentRecord,
                tplData: renderData,
                renderData: renderData
              }); // If the user's renderer coerced it into a string, recreate a DomClassList.

              if (typeof renderData.cls === 'string') {
                renderData.cls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_20__["default"](renderData.cls);
              }

              if (typeof renderData.wrapperCls === 'string') {
                renderData.wrapperCls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_20__["default"](renderData.wrapperCls);
              } // Same goes for iconCls


              if (typeof renderData.iconCls === 'string') {
                renderData.iconCls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_20__["default"](renderData.iconCls);
              }

              if (me.eventBodyTemplate) {
                value = me.eventBodyTemplate(rendererValue);
              } else {
                value = rendererValue;
              }
            } else if (me.eventBodyTemplate) {
              // User has specified an eventBodyTemplate, but no renderer - just apply the entire event record data.
              value = me.eventBodyTemplate(eventRecord);
            } else if (me.eventBarTextField) {
              // User has specified a field in the data model to read from
              value = eventRecord[me.eventBarTextField] || '';
            }

            if (!me.eventBodyTemplate) {
              var _renderData$iconCls;

              eventContent.children = []; // Give milestone a dedicated label element so we can use padding

              if (isMilestone && me.milestoneLayoutMode === 'default' && value != null && value !== '') {
                eventContent.children.unshift(milestoneLabelConfig = {
                  tag: 'label',
                  children: []
                });
              }

              if ((_renderData$iconCls = renderData.iconCls) === null || _renderData$iconCls === void 0 ? void 0 : _renderData$iconCls.length) {
                eventContent.children.unshift({
                  tag: 'i',
                  className: renderData.iconCls
                });
              } // Array, assumed to contain DOM configs for eventContent children (or milestone label)


              if (Array.isArray(value)) {
                var _children;

                (_children = (milestoneLabelConfig || eventContent).children).push.apply(_children, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12___default()(value));
              } // Likely HTML content
              else if (typeof value === 'string' && value.includes('<')) {
                  childContent = {
                    html: value
                  };
                } // DOM config or plain string can be used as is
                else if (typeof value === 'string' || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(value) === 'object') {
                    childContent = value;
                  } // Other, use string
                  else if (value != null) {
                      childContent = String(value);
                    } // Must allow empty string as valid content


              if (childContent != null) {
                // Milestones have content in their label, other events in their "body"
                (milestoneLabelConfig || eventContent).children.push(childContent);
                renderData.cls.add('b-has-content');
              }

              if (eventContent.children.length) {
                renderData.children.push(eventContent);
              }
            } else {
              eventContent.html = value;
              renderData.children.push(eventContent);
            }

            var _eventStyle = renderData.eventStyle,
                _eventColor = renderData.eventColor; // Renderers have last say on style & color

            renderData.wrapperCls["b-sch-style-".concat(_eventStyle)] = _eventStyle;

            if (_eventColor === null || _eventColor === void 0 ? void 0 : _eventColor.startsWith('#')) {
              var colorProp = _eventStyle ? 'color' : 'background-color';
              renderData.style = "".concat(colorProp, ":").concat(_eventColor, ";") + renderData.style;
              renderData.wrapperCls['b-sch-custom-color'] = 1;
            } // Normally the color is applied as a class to the wrapper
            else {
                renderData.wrapperCls["b-sch-color-".concat(_eventColor)] = _eventColor;
              } // Milestones has to apply styling to b-sch-event-content


            if (renderData.style && isMilestone && eventContent) {
              eventContent.style = renderData.style;
              delete renderData.style;
            }
          } // If there are any iconCls entries...


          renderData.cls['b-sch-event-withicon'] = renderData.iconCls.length; // For comparison in sync, cheaper than comparing DocumentFragments

          renderData.eventContent = eventContent;
          renderData.wrapperChildren = []; // Method which features may chain in to

          me.onEventDataGenerated(renderData);
        }

        return renderData;
      }
      /**
       * A method which may be chained by features. It is called when an event's render
       * data is calculated so that features may update the style, class list or body.
       * @param {Object} eventData
       */

    }, {
      key: "onEventDataGenerated",
      value: function onEventDataGenerated(eventData) {} //endregion
      //region Animation

      /**
       * Restarts initial events animation with new value {@link #config-useInitialAnimation}.
       * @param {Boolean|String} initialAnimation new initial animation value
       */

    }, {
      key: "restartInitialAnimation",
      value: function restartInitialAnimation(initialAnimation) {
        var _me$initialAnimationD;

        var me = this;
        (_me$initialAnimationD = me.initialAnimationDetacher) === null || _me$initialAnimationD === void 0 ? void 0 : _me$initialAnimationD.call(me);
        me.initialAnimationDetacher = null;
        me.useInitialAnimation = initialAnimation;
        me.isFirstRender = true;
        me.refresh();
      }
    }, {
      key: "stopInitialAnimation",
      value: function stopInitialAnimation() {
        var me = this;
        me.initialAnimationDetacher();
        me.isFirstRender = false; // Prevent any further initial animations

        me.useInitialAnimation = false; // Remove transition block for FF a bit later, to not interfere with animations

        if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isFirefox) {
          me.setTimeout(function () {
            return me.element.classList.remove('b-prevent-event-transitions');
          }, 100);
        }
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "eventPrefix",
      //endregion
      //region Properties

      /**
       * Property for {@link #config-useInitialAnimation useInitialAnimation}
       * @property {Boolean|String}
       * @name useInitialAnimation
       */
      //endregion
      //region Init
      get: function get() {
        return this._eventPrefix;
      },
      set: function set(eventPrefix) {
        this._eventPrefix = eventPrefix || this.id + '-';
      } //endregion
      //region Settings

    }, {
      key: "layouts",
      get: function get() {
        var me = this;

        if (!me._eventLayout) {
          me._eventLayout = {}; // pack, fit all events in available height by adjusting their height

          if (me.horizontalLayoutPackClass) {
            me._eventLayout.horizontalPack = new me.horizontalLayoutPackClass(Object.assign( // this is required for table layout
            {
              scheduler: me,
              timeAxisViewModel: me.timeAxisViewModel,
              bandIndexToPxConvertFn: me.horizontal.layoutEventVerticallyPack,
              bandIndexToPxConvertThisObj: me.horizontal
            }));
          } // stack, adjust row height to fit all events


          if (me.horizontalLayoutStackClass) {
            me._eventLayout.horizontalStack = new me.horizontalLayoutStackClass(Object.assign( // this is required for table layout
            {
              scheduler: me,
              timeAxisViewModel: me.timeAxisViewModel,
              bandIndexToPxConvertFn: me.horizontal.layoutEventVerticallyStack,
              bandIndexToPxConvertThisObj: me.horizontal
            }));
          }
        }

        return me._eventLayout;
      }
      /**
       * Get/set overlap mode. See config, valid values are stack (horizontal), pack, mixed (vertical) and none
       * @property {String}
       * @category Scheduled events
       */

    }, {
      key: "eventLayout",
      get: function get() {
        return this._overlapMode;
      },
      set: function set(eventLayout) {
        var me = this;

        if (eventLayout !== me._overlapMode) {
          me.element.classList.remove("b-eventlayout-".concat(me._overlapMode));
          me._overlapMode = eventLayout;
          me.element.classList.add("b-eventlayout-".concat(eventLayout));

          if (!me.isConfiguring) {
            me.refreshWithTransition();
          }
        }
      }
      /**
       * Get/set fillTicks setting. If set to true it forces the rendered events to fill entire ticks.
       * @property {String}
       * @category Scheduled events
       */

    }, {
      key: "fillTicks",
      get: function get() {
        return this._fillTicks;
      },
      set: function set(fill) {
        if (fill !== this._fillTicks) {
          this._fillTicks = fill;

          if (!this.isConfiguring) {
            this.refreshWithTransition();
          }
        }
      }
      /**
       * Control how much space to leave between the first event/last event and the resources edge (top/bottom margin within
       * the resource row in horizontal mode, left/right margin within the resource column in vertical mode),
       * in px. Defaults to the value of {@link Scheduler.view.mixin.TimelineEventRendering#config-barMargin}.
       * @member {Number} resourceMargin
       * @category Scheduled events
       */

      /**
       * Gets currently used event layout class. The event layout class decides the vertical placement of the events
       * within a resource. Returns null if no eventLayout is used (if Scheduler#eventLayout is set to "none")
       * @internal
       * @returns {*}
       * @readonly
       * @category Scheduled events
       */

    }, {
      key: "currentEventLayout",
      get: function get() {
        var me = this;
        if (!me.isHorizontal) return null;

        switch (me.eventLayout) {
          case 'stack':
            return me.layouts.horizontalStack;

          case 'pack':
            return me.layouts.horizontalPack;

          default:
            return null;
        }
      }
    }, {
      key: "useInitialAnimation",
      get: function get() {
        return this._useInitialAnimation;
      },
      set: function set(name) {
        var me = this;

        if (me._useInitialAnimation) {
          me.element.classList.remove("b-initial-".concat(me._useInitialAnimation));
        }

        me._useInitialAnimation = name === true ? 'fade-in' : name;

        if (name) {
          me.element.classList.add("b-initial-".concat(me._useInitialAnimation)); // Transition block for FF, to not interfere with animations

          if (_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isFirefox) {
            me.element.classList.add('b-prevent-event-transitions');
          }
        }
      }
    }, {
      key: "horizontalEventSorterFn",
      set: function set(fn) {
        this._horizontalEventSorterFn = fn;

        if (this.rendered) {
          this.refreshWithTransition();
        }
      },
      get: function get() {
        return this._horizontalEventSorterFn;
      } //endregion
      //region Resource header/columns
      // NOTE: The configs below are initially applied to the resource header in `TimeAxisColumn#set mode`

    }, {
      key: "resourceColumns",
      set: function set(config) {
        this._resourceColumns = config;
      }
      /**
       * Use it to manipulate resource column properties at runtime.
       * @property {Scheduler.view.ResourceHeader}
       * @readonly
       */
      ,
      get: function get() {
        var _this$timeAxisColumn;

        return ((_this$timeAxisColumn = this.timeAxisColumn) === null || _this$timeAxisColumn === void 0 ? void 0 : _this$timeAxisColumn.resourceColumns) || this._resourceColumns;
      }
      /**
       * Get resource column width. Only applies to vertical mode. To set it, assign to
       * `scheduler.resourceColumns.columnWidth`.
       * @property {Number}
       * @readonly
       */

    }, {
      key: "resourceColumnWidth",
      get: function get() {
        return this.resourceColumns ? this.resourceColumns.columnWidth : null;
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'SchedulerEventRendering';
      } //region Default config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * An empty function by default, but provided so that you can override it. This function is called each time
           * an event is rendered into the schedule to render the contents of the event. It's called with the event,
           * its resource and a `renderData` object which allows you to populate data placeholders inside the event
           * template. **IMPORTANT** You should never modify any data on the EventModel inside this method.
           *
           * By default, the DOM markup of an event bar includes placeholders for 'cls' and 'style'. The cls property
           * is a {@link Core.helper.util.DomClassList} which will be added to the event element. The style property
           * is an inline style declaration for the event element.
           *
           * IMPORTANT: When returning content, be sure to consider how that content should be encoded to avoid XSS
           * (Cross-Site Scripting) attacks. This is especially important when including user-controlled data such as
           * the event's `name`. The function {@link Core.helper.StringHelper#function-encodeHtml-static} as well as
           * {@link Core.helper.StringHelper#function-xss-static} can be helpful in these cases.
           *
           * ```javascript
           *  eventRenderer({ eventRecord, resourceRecord, renderData }) {
           *      renderData.style = 'color:white';                 // You can use inline styles too.
           *
           *      // Property names with truthy values are added to the resulting elements CSS class.
           *      renderData.cls.isImportant = this.isImportant(eventRecord);
           *      renderData.cls.isModified = eventRecord.isModified;
           *
           *      // Remove a class name by setting the property to false
           *      renderData.cls[scheduler.generatedIdCls] = false;
           *
           *      // Or, you can treat it as a string, but this is less efficient, especially
           *      // if your renderer wants to *remove* classes that may be there.
           *      renderData.cls += ' extra-class';
           *
           *      return StringHelper.xss`${DateHelper.format(eventRecord.startDate, 'YYYY-MM-DD')}: ${eventRecord.name}`;
           *  }
           * ```
           *
           * @param {Object} detail An object containing the information needed to render an Event.
           * @param {Scheduler.model.EventModel} detail.eventRecord The event record.
           * @param {Scheduler.model.ResourceModel} detail.resourceRecord The resource record.
           * @param {Scheduler.model.AssignmentModel} detail.assignmentRecord The assignment record.
           * @param {Object} detail.renderData An object containing details about the event rendering.
           * @param {Scheduler.model.EventModel} detail.renderData.event The event record.
           * @param {Core.helper.util.DomClassList|String} detail.renderData.cls An object whose property names
           * represent the CSS class names to be added to the event bar element. Set a property's value to truthy or
           * falsy to add or remove the class name based on the property name. Using this technique, you do not have
           * to know whether the class is already there, or deal with concatenation.
           * @param {Core.helper.util.DomClassList|String} detail.renderData.wrapperCls An object whose property names
           * represent the CSS class names to be added to the event wrapper element. Set a property's value to truthy
           * or falsy to add or remove the class name based on the property name. Using this technique, you do not
           * have to know whether the class is already there, or deal with concatenation.
           * @param {Core.helper.util.DomClassList|String} detail.renderData.iconCls An object whose property names
           * represent the CSS class names to be added to an event icon element.
           * @param {Number} detail.renderData.left Vertical offset position (in pixels) on the time axis.
           * @param {Number} detail.renderData.width Width in pixels of the event element.
           * @param {Number} detail.renderData.height Height in pixels of the event element.
           * @param {String} detail.renderData.eventStyle The `eventStyle` of the event. Use this to apply custom
           * styles to the event DOM element
           * @param {String} detail.renderData.eventColor The `eventColor` of the event. Use this to set a custom
           * color for the rendererd event
           * @param {Object[]} detail.renderData.children An array of DOM configs used as children to the
           * `b-sch-event` element. Can be populated with additional DOM configs to have more control over contents.
           * @returns {String|Object} A simple string, or a custom object which will be applied to the
           * {@link #config-eventBodyTemplate}, creating the actual HTML
           * @config {function}
           * @category Scheduled events
           */
          eventRenderer: null,

          /**
           * `this` reference for the {@link #config-eventRenderer} function
           * @config {Object}
           * @category Scheduled events
           */
          eventRendererThisObj: null,
          eventPrefix: '',

          /**
           * How to handle overlapping events. Valid values are:
           * - stack, adjusts row height (only horizontal)
           * - pack, adjusts event height
           * - mixed, allows two events to overlap, more packs (only vertical)
           * - none, allows events to overlap
           * @config {String}
           * @default
           * @category Scheduled events
           */
          eventLayout: 'stack',

          /**
           * The class responsible for the packing horizontal event layout process.
           * Override this to take control over the layout process.
           * @config {Scheduler.eventlayout.HorizontalLayout}
           * @default
           * @private
           * @category Misc
           */
          horizontalLayoutPackClass: _eventlayout_HorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_22__["default"],

          /**
           * The class name responsible for the stacking horizontal event layout process.
           * Override this to take control over the layout process.
           * @config {Scheduler.eventlayout.HorizontalLayout}
           * @default
           * @private
           * @category Misc
           */
          horizontalLayoutStackClass: _eventlayout_HorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_21__["default"],

          /**
           * Override this method to provide a custom sort function to sort any overlapping events. By default,
           * overlapping events are laid out based on the start date. If the start date is equal, events with earlier
           * end date go first.
           *
           * Here's a sample sort function, sorting on start- and end date. If this function returns -1, then event a
           * is placed above event b.
           * ```javascript
           * horizontalEventSorterFn(a, b) {
           *
           *   const startA = a.startDate, endA = a.endDate;
           *   const startB = b.startDate, endB = b.endDate;
           *
           *   const sameStart = (startA - startB === 0);
           *
           *   if (sameStart) {
           *     return endA > endB ? -1 : 1;
           *   } else {
           *     return (startA < startB) ? -1 : 1;
           *   }
           * }
           * ```
           * @param  {Scheduler.model.EventModel} a First event
           * @param  {Scheduler.model.EventModel} b Second event
           * @return {Number} Return -1 to display a above b, 1 for b above a
           * @config {function}
           * @category Misc
           */
          horizontalEventSorterFn: null,

          /**
           * Field from EventModel displayed as text in the bar when rendering
           * @config {String}
           * @default
           * @category Scheduled events
           */
          eventBarTextField: 'name',

          /**
           * The template used to generate the markup of your events in the scheduler. To 'populate' the
           * eventBodyTemplate with data, use the {@link #config-eventRenderer} method
           * @config {Function}
           * @category Scheduled events
           */
          eventBodyTemplate: null,
          eventPositionMode: 'translate',
          eventScrollMode: 'move',

          /**
           * Specify `true` to force rendered events to fill entire ticks. This only affects rendering, events retain
           * their set start and end dates on the data level. When enabling this config you should probably also
           * disable EventDrag and EventResize, otherwise their behaviour will not be what a user expects.
           * @config {Boolean}
           * @default
           * @category Scheduled events
           */
          fillTicks: false,

          /**
           * By default scheduler fades events in on load. Specify `false` to prevent this animation or specify one
           * of the available animation types to use it (`true` equals `'fade-in'`):
           * * fade-in (default)
           * * slide-from-left
           * * slide-from-top
           * ```
           * // Slide events in from the left on load
           * scheduler = new Scheduler({
           *     useInitialAnimation : 'slide-from-left'
           * });
           * ```
           * @config {Boolean|String}
           * @default
           * @category Misc
           */
          useInitialAnimation: true,

          /**
           * A config object used to configure the resource columns in vertical mode.
           * See {@link Scheduler.view.ResourceHeader} for more details on available properties.
           *
           * ```
           * new Scheduler({
           *   resourceColumns : {
           *     columnWidth    : 100,
           *     headerRenderer : ({ resourceRecord }) => `${resourceRecord.id} - ${resourceRecord.name}`
           *   }
           * })
           * ```
           * @config {Object}
           * @category Resources
           */
          resourceColumns: null,

          /**
           * Path to load resource images from. Used by the resource header in vertical mode and the
           * {@link Scheduler.column.ResourceInfoColumn} in horizontal mode. Set this to display miniature
           * images for each resource using their `image` or `imageUrl` fields.
           *
           * * `image` represents image name inside the specified `resourceImagePath`,
           * * `imageUrl` represents fully qualified image URL.
           *
           *  If set and a resource has no `imageUrl` or `image` specified it will try show miniature using
           *  the resource's name with {@link #config-resourceImageExtension} appended.
           *
           * **NOTE**: The path should end with a `/`:
           *
           * ```
           * new Scheduler({
           *   resourceImagePath : 'images/resources/'
           * });
           * ```
           * @config {String}
           * @category Resources
           */
          resourceImagePath: null,

          /**
           * Generic resource image, used when provided `imageUrl` or `image` fields or path calculated from resource name are all invalid.
           * @default
           * @config {String}
           * @category Resources
           */
          defaultResourceImageName: 'none.png',

          /**
           * Resource image extension, used when creating image path from resource name.
           * @default
           * @config {String}
           * @category Resources
           */
          resourceImageExtension: '.jpg',

          /**
           * Control how much space to leave between the first event/last event and the resources edge (top/bottom
           * margin within the resource row in horizontal mode, left/right margin within the resource column in
           * vertical mode), in px. Defaults to the value of {@link Scheduler.view.mixin.TimelineEventRendering#config-barMargin}.
           * @config {Number}
           * @category Scheduled events
           */
          resourceMargin: null,
          // Used to animate events on first render
          isFirstRender: true,
          initialAnimationDuration: 2000
        };
      }
    }]);

    return SchedulerEventRendering;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_19__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerRegions.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerRegions.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/mixin/SchedulerRegions
 */

/**
 * Functions to get regions (bounding boxes) for scheduler, events etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(SchedulerRegions, _ref);

    var _super = _createSuper(SchedulerRegions);

    function SchedulerRegions() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, SchedulerRegions);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(SchedulerRegions, [{
      key: "getScheduleRegion",
      //region Orientation depended regions

      /**
       * Gets the region represented by the schedule and optionally only for a single resource. The view will ask the
       * scheduler for the resource availability by calling getResourceAvailability. By overriding that method you can
       * constrain events differently for different resources.
       * @param {Scheduler.model.ResourceModel} resourceRecord (optional) The resource record
       * @param {Scheduler.model.EventModel} eventRecord (optional) The event record
       * @return {Core.helper.util.Rectangle} The region of the schedule
       */
      value: function getScheduleRegion(resourceRecord, eventRecord) {
        var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        return this.currentOrientation.getScheduleRegion(resourceRecord, eventRecord, local);
      }
      /**
       * Gets the region representing the passed resource and optionally just for a certain date interval.
       * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
       * @param {Date} startDate A start date constraining the region
       * @param {Date} endDate An end date constraining the region
       * @return {Core.helper.util.Rectangle} A Rectangle which encapsulates the resource time span
       */

    }, {
      key: "getResourceRegion",
      value: function getResourceRegion(resourceRecord, startDate, endDate) {
        return this.currentOrientation.getRowRegion(resourceRecord, startDate, endDate);
      } //endregion
      //region ResourceEventBox

    }, {
      key: "getAssignmentEventBox",
      value: function getAssignmentEventBox(assignmentRecord, includesOutside) {
        return this.getResourceEventBox(assignmentRecord.event, assignmentRecord.resource, includesOutside);
      }
      /**
       * Get the region for a specified resources specified event.
       * @param {Scheduler.model.EventModel} eventRecord
       * @param {Scheduler.model.ResourceModel} resourceRecord
       * @param {Boolean} includeOutside Specify true to get boxes for events outside of the rendered zone in both
       *   dimensions. This option is used when calculating dependency lines, and we need to include routes from events
       *   which may be outside the rendered zone.
       * @returns {Core.helper.util.Rectangle}
       */

    }, {
      key: "getResourceEventBox",
      value: function getResourceEventBox(eventRecord, resourceRecord) {
        var includeOutside = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var roughly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return this.currentOrientation.getResourceEventBox(eventRecord, resourceRecord, includeOutside, roughly);
      } //endregion
      //region Item box

      /**
       * Gets box for displayed item designated by the record. If several boxes are displayed for the given item
       * then the method returns all of them. Box coordinates are in view coordinate system.
       *
       * Boxes outside scheduling view timeaxis timespan and inside collapsed rows (if row defining store is a tree store)
       * will not be returned. Boxes outside scheduling view vertical visible area (i.e. boxes above currently visible
       * top row or below currently visible bottom row) will be calculated approximately.
       *
       * @param {Scheduler.model.EventModel} event
       * @return {Object|Object[]}
       * @return {Boolean} return.isPainted Whether the box was calculated for the rendered scheduled record or was
       *    approximately calculated for the scheduled record outside of the current vertical view area.
       * @return {Number} return.top
       * @return {Number} return.bottom
       * @return {Number} return.start
       * @return {Number} return.end
       * @return {String} return.relPos if the item is not rendered then provides a view relative position one of 'before', 'after'
       * @internal
       */

    }, {
      key: "getItemBox",
      value: function getItemBox(event) {
        var _this = this;

        var includeOutside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return event.resources.map(function (resource) {
          return _this.getResourceEventBox(event, resource, includeOutside);
        });
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'SchedulerRegions';
      }
    }]);

    return SchedulerRegions;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerScroll.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerScroll.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.promise */ "./node_modules/core-js/modules/es.promise.js");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/view/mixin/SchedulerScroll
 */

var immediatePromise = Promise.resolve(),
    defaultScrollOptions = {
  block: 'nearest',
  edgeOffset: 20
},
    unrenderedScrollOptions = {
  highlight: false,
  focus: false
};
/**
 * Functions for scrolling to events, dates etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(SchedulerScroll, _ref);

    var _super = _createSuper(SchedulerScroll);

    function SchedulerScroll() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, SchedulerScroll);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(SchedulerScroll, [{
      key: "scrollEventIntoView",
      //region Scroll to event

      /**
       * Scrolls an event record into the viewport.
       * If the resource store is a tree store, this method will also expand all relevant parent nodes to locate the event.
       *
       * @param {Scheduler.model.EventModel} eventRecord the event record to scroll into view
       * @param {Object} [options] How to scroll.
       * @param {String} [options.block=nearest] How far to scroll the event: `start/end/center/nearest`.
       * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the event to bring into view.
       * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
       * @param {Boolean} [options.highlight] Set to `true` to highlight the event element when it is in view.
       * @param {Boolean} [options.focus] Set to `true` to focus the event element when it is in view.
       * @returns {Promise} A Promise which resolves when the scrolling is complete.
       *
       * This function is not applicable for events with multiple assignments, please use #scrollResourceEventIntoView instead.
       */
      value: function scrollEventIntoView(eventRecord) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;
        var me = this,
            resources = eventRecord.resources || [eventRecord];

        if (resources.length > 1) {
          throw new Error('scrollEventIntoView() is not applicable for events with multiple assignments, please use scrollResourceEventIntoView() instead.');
        }

        if (!resources.length) {
          console.warn('You have asked to scroll to an event which is not assigned to a resource');
          return immediatePromise;
        }

        return me.scrollResourceEventIntoView(resources[0], eventRecord, null, options);
      }
      /**
       * Scrolls an assignment record into the viewport.
       *
       * If the resource store is a tree store, this method will also expand all relevant parent nodes
       * to locate the event.
       *
       * @param {Scheduler.model.AssignmentModel} assignmentRecord A resource record an event record is assigned to
       * @param {Number} index DOM node index, applicable only for weekview
       * @param {Object} [options] How to scroll.
       * @param {String} [options.block=nearest] How far to scroll the event: `start/end/center/nearest`.
       * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the event to bring into view.
       * @param {Boolean/Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
       * @param {Boolean} [options.extendTimeAxis=true] By default, if the requested event is outside the time axis, the time axis is extended.
       * @param {Boolean} [options.highlight] Set to `true` to highlight the event element when it is in view.
       * @param {Boolean} [options.focus] Set to `true` to focus the event element when it is in view.
       * @returns {Promise} A Promise which resolves when the scrolling is complete.
       */

    }, {
      key: "scrollAssignmentIntoView",
      value: function scrollAssignmentIntoView(assignmentRecord) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return this.scrollResourceEventIntoView.apply(this, [assignmentRecord.resource, assignmentRecord.event].concat(args));
      }
      /**
       * Scrolls a resource event record into the viewport.
       *
       * If the resource store is a tree store, this method will also expand all relevant parent nodes
       * to locate the event.
       *
       * @param {Scheduler.model.ResourceModel} resourceRecord A resource record an event record is assigned to
       * @param {Scheduler.model.EventModel} eventRecord An event record to scroll into view
       * @param {Number} index DOM node index, applicable only for weekview
       * @param {Object} [options] How to scroll.
       * @param {String} [options.block=nearest] How far to scroll the event: `start/end/center/nearest`.
       * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the event to bring into view.
       * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
       * @param {Boolean} [options.extendTimeAxis=true] By default, if the requested event is outside the time axis, the time axis is extended.
       * @param {Boolean} [options.highlight] Set to `true` to highlight the event element when it is in view.
       * @param {Boolean} [options.focus] Set to `true` to focus the event element when it is in view.
       * @returns {Promise} A Promise which resolves when the scrolling is complete.
       */

    }, {
      key: "scrollResourceEventIntoView",
      value: function scrollResourceEventIntoView(resourceRecord, eventRecord, index) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultScrollOptions;
        var me = this,
            eventStart = eventRecord.startDate,
            eventEnd = eventRecord.endDate,
            eventIsOutside = eventRecord.isScheduled && eventStart < me.timeAxis.startDate | (eventEnd > me.timeAxis.endDate) << 1;
        var el;

        if (options.edgeOffset == null) {
          options.edgeOffset = 20;
        } // Make sure event is within TimeAxis time span unless extendTimeAxis passed as false.
        // The EventEdit feature passes false because it must not mutate the TimeAxis.
        // Bitwise flag:
        //  1 === start is before TimeAxis start.
        //  2 === end is after TimeAxis end.


        if (eventIsOutside && options.extendTimeAxis !== false) {
          var currentTimeSpanRange = me.timeAxis.endDate - me.timeAxis.startDate,
              startAnchorPoint,
              endAnchorPoint; // Event is too wide, expand the range to encompass it.

          if (eventIsOutside === 3) {
            me.timeAxis.setTimeSpan(new Date(eventStart.valueOf() - currentTimeSpanRange / 2), new Date(eventEnd.getTime() + currentTimeSpanRange / 2));
          } // Event is partially or wholly outside but will fit.
          // Move the TimeAxis to include it. Attempt to maintain visual position.
          else {
              startAnchorPoint = eventIsOutside & 1 ? me.getCoordinateFromDate(eventRecord.endDate) : me.getCoordinateFromDate(eventRecord.startDate); // Event starts before

              if (eventIsOutside & 1) {
                me.timeAxis.setTimeSpan(new Date(eventStart), new Date(eventStart.valueOf() + currentTimeSpanRange));
              } // Event ends after
              else {
                  me.timeAxis.setTimeSpan(new Date(eventEnd.valueOf() - currentTimeSpanRange), new Date(eventEnd));
                } // Restore view to same relative scroll position.


              endAnchorPoint = eventIsOutside & 1 ? me.getCoordinateFromDate(eventRecord.endDate) : me.getCoordinateFromDate(eventRecord.startDate);
              me.timeAxisSubGrid.scrollable.scrollBy(endAnchorPoint - startAnchorPoint);
            }
        } // Establishing element to scroll to


        el = me.getElementFromEventRecord(eventRecord, resourceRecord);

        if (el) {
          // It's usually the event wrapper that holds focus
          if (!_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].isFocusable(el)) {
            el = el.parentNode;
          }

          var scroller = me.timeAxisSubGrid.scrollable; // Force horizontalscroll to be triggered directly on scroll instead of on next frame, to have events
          // already drawn when promise resolves

          me.timeAxisSubGrid.forceScrollUpdate = true; // Scroll into view with animation and highlighting if needed.

          return scroller.scrollIntoView(el, options);
        } else if (eventIsOutside && options.extendTimeAxis === false) {
          console.warn('You have asked to scroll to an event which is outside the current view and extending timeaxis is disabled');
          return immediatePromise;
        } else if (!eventRecord.isOccurrence && !me.eventStore.isAvailable(eventRecord)) {
          console.warn('You have asked to scroll to an event which is not available');
          return immediatePromise;
        } else if (eventRecord.isScheduled) {
          // Event scheduled but not rendered, scroll to calculated location
          return me.scrollUnrenderedEventIntoView(resourceRecord, eventRecord, options);
        } else {
          // Event not scheduled, just scroll resource row into view
          return me.scrollResourceIntoView(resourceRecord, options);
        }
      }
      /**
       * Scrolls an unrendered event into view. Internal function used from #scrollResourceEventIntoView.
       * @private
       */

    }, {
      key: "scrollUnrenderedEventIntoView",
      value: function scrollUnrenderedEventIntoView(resourceRec, eventRec) {
        var _this = this;

        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultScrollOptions;
        // We must only resolve when the event's element has been painted
        // *and* the scroll has fully completed.
        return new Promise(function (resolve) {
          var me = _this,
              // Knock out highlight and focus options. They must be applied after the scroll
          // has fully completed and we have an element. Use a default edgeOffset of 20.
          modifiedOptions = Object.assign({
            edgeOffset: 20
          }, options, unrenderedScrollOptions),
              scroller = me.timeAxisSubGrid.scrollable,
              box = me.getResourceEventBox(eventRec, resourceRec),
              scrollerViewport = scroller.viewport;

          if (!scrollerViewport) {
            resolve();
            return;
          }

          var targetRect = box.translate(scrollerViewport.x - scroller.x, scrollerViewport.y - scroller.y),
              delta = scroller.getDeltaTo(targetRect, modifiedOptions)[me.isHorizontal ? 'xDelta' : 'yDelta'],
              onEventRender = /*#__PURE__*/function () {
            var _ref3 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee(_ref2) {
              var eventRecord, element, targetElement, el;
              return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      eventRecord = _ref2.eventRecord, element = _ref2.element, targetElement = _ref2.targetElement;

                      if (!(eventRecord === eventRec)) {
                        _context.next = 12;
                        break;
                      }

                      // Vertical's renderEvent is different to eventPaint
                      el = element || targetElement;
                      detatcher(); // Don't resolve until the scroll has fully completed.

                      _context.next = 6;
                      return initialScrollPromise;

                    case 6:
                      if (!(delta > 0)) {
                        _context.next = 9;
                        break;
                      }

                      _context.next = 9;
                      return scroller.scrollIntoView(el, {
                        edgeOffset: options.edgeOffset
                      });

                    case 9:
                      options.highlight && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].highlight(el);
                      options.focus && el.focus();
                      resolve();

                    case 12:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function onEventRender(_x) {
              return _ref3.apply(this, arguments);
            };
          }(),
              // On either paint or repaint of the event, resolve the scroll promise and detach the listeners.
          detatcher = me.on({
            renderEvent: onEventRender
          }),
              initialScrollPromise = scroller.scrollIntoView(targetRect, modifiedOptions);
        });
      }
      /**
       * Scrolls the specified resource into view, works for both horizontal and vertical modes.
       * @param {Scheduler.model.ResourceModel} resourceRecord A resource record an event record is assigned to
       * @param {Object} [options] How to scroll.
       * @param {String} [options.column] Field name or ID of the column, or the Column instance to scroll to (in horizontal mode).
       * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
       * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
       * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
       * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
       * @returns {Promise} A promise which is resolved when the scrolling has finished.
       */

    }, {
      key: "scrollResourceIntoView",
      value: function scrollResourceIntoView(resourceRecord) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;

        if (this.isVertical) {
          return this.currentOrientation.scrollResourceIntoView(resourceRecord, options);
        } else {
          return this.scrollRowIntoView(resourceRecord, options);
        }
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'SchedulerScroll';
      }
    }]);

    return SchedulerScroll;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_14__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerState.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerState.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/view/mixin/SchedulerState
 */

var copyProperties = ['eventLayout', 'barMargin', 'mode', 'eventColor', 'eventStyle', 'fillTicks'];
/**
 * Mixin for Scheduler that handles state. It serializes the following scheduler properties:
 *
 * * eventLayout
 * * barMargin
 * * mode
 * * tickSize
 * * zoomLevel
 * * eventColor
 * * eventStyle
 *
 * See {@link Grid.view.mixin.GridState} and {@link Core.mixin.State} for more information on state.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(SchedulerState, _ref);

    var _super = _createSuper(SchedulerState);

    function SchedulerState() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SchedulerState);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerState, [{
      key: "getState",

      /**
       * Get schedulers current state for serialization. State includes rowHeight, headerHeight, readOnly, selectedCell,
       * selectedRecordId, column states and store state.
       * @returns {Object} State object to be serialized
       * @private
       */
      value: function getState() {
        var me = this,
            state = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].copyProperties(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(SchedulerState.prototype), "getState", this).call(this), me, copyProperties);
        state.zoomLevel = me.zoomLevel;
        state.zoomLevelOptions = {
          startDate: me.startDate,
          endDate: me.endDate,
          viewportCenterDate: me.viewportCenterDate,
          width: me.tickSize
        };
        return state;
      }
      /**
       * Apply previously stored state.
       * @param {Object} state
       * @private
       */

    }, {
      key: "applyState",
      value: function applyState(state) {
        this.suspendRefresh();

        if (state.zoomLevel) {
          this.zoomToLevel(state.zoomLevel, state.zoomLevelOptions);
        }

        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].copyProperties(this, state, copyProperties);

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(SchedulerState.prototype), "applyState", this).call(this, state);

        this.resumeRefresh(true);
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'SchedulerState';
      }
    }]);

    return SchedulerState;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/SchedulerStores.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/SchedulerStores.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../../Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../data/mixin/ProjectConsumer.js */ "./lib/Scheduler/data/mixin/ProjectConsumer.js");







































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_36___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/view/mixin/SchedulerStores
 */

/**
 * Functions for store assignment and store event listeners.
 *
 * @mixin
 * @extends Scheduler/data/mixin/ProjectConsumer
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ProjectConsumer) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_35___default()(SchedulerStores, _ProjectConsumer);

    var _super = _createSuper(SchedulerStores);

    function SchedulerStores() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_31___default()(this, SchedulerStores);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_32___default()(SchedulerStores, [{
      key: "updateProject",
      //endregion
      //region Project
      value: function updateProject(project, oldProject) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SchedulerStores.prototype), "updateProject", this).call(this, project, oldProject);

        this.detachListeners('schedulerStores');
        project.on({
          name: 'schedulerStores',
          refresh: 'onProjectRefresh',
          thisObj: this
        });
      } // Called when project changes are committed, before data is written back to records (but still ready to render
      // since data is fetched from engine)

    }, {
      key: "onProjectRefresh",
      value: function onProjectRefresh(_ref) {
        var isInitialCommit = _ref.isInitialCommit;
        var me = this;

        if (isInitialCommit) {
          if (me.isVertical) {
            me.refreshAfterProjectRefresh = false;
            me.refreshWithTransition();
          }
        }

        if (me.navigateToAfterRefresh) {
          me.navigateTo(me.navigateToAfterRefresh);
          me.navigateToAfterRefresh = null;
        }

        if (me.refreshAfterProjectRefresh) {
          me.refreshWithTransition();
          me.refreshAfterProjectRefresh = false;
        }
      } //endregion
      //region Row store

    }, {
      key: "refreshFromRowOnStoreAdd",
      // Wrap w/ transition refreshFromRowOnStoreAdd() inherited from Grid
      value: function refreshFromRowOnStoreAdd(row, _ref2) {
        var _this = this;

        var isExpand = _ref2.isExpand;
        var args = arguments;
        this.runWithTransition(function () {
          var _get2;

          // Postpone drawing of events for a new resource until the following project refresh. Previously the draw
          // would not happen because engine was not ready, but now when we allow commits and can read values during
          // commit that block is no longer there
          _this.currentOrientation.suspended = !isExpand;

          (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SchedulerStores.prototype), "refreshFromRowOnStoreAdd", _this)).call.apply(_get2, [_this, row].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(args)));

          _this.currentOrientation.suspended = false;
        }, !isExpand);
      }
    }, {
      key: "onStoreAdd",
      value: function onStoreAdd(event) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SchedulerStores.prototype), "onStoreAdd", this).call(this, event);

        this.calculateRowHeights(event.records);
      }
    }, {
      key: "onStoreUpdateRecord",
      value: function onStoreUpdateRecord(_ref3) {
        var store = _ref3.source,
            record = _ref3.record,
            changes = _ref3.changes;
        // Ignore engine changes that do not affect row rendering
        var ignoreCount = 0;

        if ('assigned' in changes) {
          ignoreCount++;
        }

        if ('calendar' in changes) {
          ignoreCount++;
        }

        if (ignoreCount !== Object.keys(changes).length) {
          _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SchedulerStores.prototype), "onStoreUpdateRecord", this).apply(this, arguments);
        }
      } //endregion
      //region ResourceStore

      /**
       * Get/set resources, applies to the backing project's ResourceStore.
       * @member {Scheduler.model.ResourceModel[]|Object[]} resources
       * @category Data
       */

      /**
       * Get/set the resource store instance of the backing project
       * @member {Scheduler.data.ResourceStore} resourceStore
       * @category Data
       */

    }, {
      key: "updateResourceStore",
      value: function updateResourceStore(resourceStore) {
        // Reconfigure grid if resourceStore is backing the rows
        if (resourceStore && this.isHorizontal) {
          resourceStore.metaMapId = this.id;
          this.store = resourceStore;
        }
      } //endregion
      //region EventStore

      /**
       * Get/set events, applies to the backing project's EventStore.
       * @member {Scheduler.model.EventModel[]|Object[]} events
       * @category Data
       */

      /**
       * Get/set the event store instance of the backing project.
       * @member {Scheduler.data.EventStore} eventStore
       * @category Data
       */
      //endregion
      //region AssignmentStore

      /**
       * Get/set assignments, applies to the backing project's AssignmentStore.
       * @member {Scheduler.model.AssignmentModel[]|Object[]} assignments
       * @category Data
       */

      /**
       * Get/set the event store instance of the backing project.
       * @member {Scheduler.data.AssignmentStore} assignmentStore
       * @category Data
       */
      //endregion
      //region DependencyStore

      /**
       * Get/set dependencies, applies to the backing projects DependencyStore.
       * @member {Scheduler.model.DependencyModel[]|Object[]} dependencies
       * @category Data
       */

      /**
       * Get/set the dependencies store instance of the backing project.
       * @member {Scheduler.data.DependencyStore} dependencyStore
       * @category Data
       */
      //endregion
      //region CalendarManagerStore
      // TODO: document it when it works. The build process throws with this documented.
      // /**
      //  * Get/set the calendar manager store instance of the backing project
      //  * @member {Engine.store.CalendarManagerStoreMixin} calendarManagerStore
      //  * @category Data
      //  */
      //endregion
      //region Events

    }, {
      key: "onEventIdChange",
      value: function onEventIdChange(params) {
        this.currentOrientation.onEventStoreIdChange && this.currentOrientation.onEventStoreIdChange(params);
      }
      /**
       * Calls appropriate functions for current event layout when the event store is modified.
       * @private
       */
      // Named as Internal to avoid naming collision with wrappers that relay events

    }, {
      key: "onInternalEventStoreChange",
      value: function onInternalEventStoreChange(params) {
        // Too early, bail out
        // Also bail out if this is a reassign using resourceId, any updates will be handled by AssignmentStore instead
        if (!this._mode || params.isAssign || this.assignmentStore.isRemovingAssignment) {
          return;
        }

        this.currentOrientation.onEventStoreChange(params);
      }
      /**
       * Refreshes committed events, to remove dirty/committing flag.
       * CSS is added
       * @private
       */

    }, {
      key: "onEventCommit",
      value: function onEventCommit(_ref4) {
        var _this2 = this;

        var changes = _ref4.changes;
        var resourcesToRepaint = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(changes.added), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(changes.modified)).map(function (eventRecord) {
          return _this2.eventStore.getResourcesForEvent(eventRecord);
        }); // flatten

        resourcesToRepaint = Array.prototype.concat.apply([], resourcesToRepaint); // repaint relevant resource rows

        new Set(resourcesToRepaint).forEach(function (resourceRecord) {
          return _this2.repaintEventsForResource(resourceRecord);
        });
      }
      /**
       * Adds the committing flag to changed events before commit.
       * @private
       */

    }, {
      key: "onEventBeforeCommit",
      value: function onEventBeforeCommit(_ref5) {
        var changes = _ref5.changes;
        var currentOrientation = this.currentOrientation,
            committingCls = this.committingCls; // Committing sets a flag in meta that during event rendering applies a CSS class. But to not mess up drag and
        // drop between resources no redraw is performed before committing, so class is never applied to the element(s).
        // Applying here instead

        [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(changes.added), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(changes.modified)).forEach(function (eventRecord) {
          return eventRecord.assignments.forEach(function (assignmentRecord) {
            return currentOrientation.toggleCls(assignmentRecord, committingCls, true);
          });
        });
      } // Clear committing flag

    }, {
      key: "onEventException",
      value: function onEventException(_ref6) {
        var _this3 = this;

        var action = _ref6.action;

        if (action === 'commit') {
          var changes = this.eventStore.changes;
          [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(changes.added), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(changes.modified), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30___default()(changes.removed)).forEach(function (eventRecord) {
            return _this3.repaintEvent(eventRecord);
          });
        }
      }
      /**
       * Refreshes scheduler when event changes are cleared.
       * @private
       */

    }, {
      key: "onEventClearChanges",
      value: function onEventClearChanges() {
        this.refresh();
      }
    }, {
      key: "onAssignmentBeforeRemove",
      value: function onAssignmentBeforeRemove(_ref7) {
        var source = _ref7.source,
            records = _ref7.records,
            removingAll = _ref7.removingAll;

        if (removingAll) {
          return;
        }

        var me = this;
        var moveTo; // Deassigning the active assignment

        if (!me.isConfiguring && me.activeAssignment && records.includes(me.activeAssignment)) {
          // If being done by a keyboard gesture then look for a close target
          // until we find an existing record, not scheduled for removal.
          // Otherwise, per Mats, push focus outside of the Scheduler.
          if (_Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_40__["default"].lastInteractionType === 'key') {
            // Look for a close target until we find an existing record, not scheduled for removal
            for (var i = 0, l = records.length; i < l && (!moveTo || records.includes(moveTo)); i++) {
              var assignment = records[i];

              if (assignment.resource && assignment.resource.isModel) {
                moveTo = me.getNext(assignment) || me.getPrevious(assignment);
              }
            }
          } // Move focus away from the element which will soon have no
          // backing data.


          if (moveTo) {
            me.navigateTo(moveTo);
            me.navigateToAfterRefresh = moveTo;
          } // Focus must exit the Scheduler's subgrid, otherwise, if a navigation
          // key gesture is delivered before the outgoing event's element has faded
          // out and been removed, navigation will be attempted from a deleted
          // event. Animated hiding is problematic.
          //
          // We cannot just revertFocus() because that might move focus back to an
          // element in a floating EventEditor which is not yet faded out and
          // been removed. Animated hiding is problematic.
          //
          // We cannot focus scheduler.timeAxisColumn.element because the browser
          // would scroll it in some way if we have horizontal overflow.
          //
          // The only thing we can know about to focus here is the Scheduler itself.
          else {
              _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_41__["default"].focusWithoutScrolling(me.focusElement);
            }
        }
      } // /**
      //  * Repaints affected resources when assignments are removed.
      //  * @private
      //  */
      // onAssignmentRemove({ records }) {
      //     if (this.isHorizontal) {
      //         records.forEach(assignment => {
      //             const resource = assignment.resource;
      //             // Removing a resource removes assignments, if resource is already removed no point in repainting here
      //             resource && !resource.isRemoved && this.repaintEventsForResource(resource);
      //         });
      //     }
      // }
      //
      // /**
      //  * Repaints resources when all assignments are removed.
      //  * @private
      //  */
      // onAssignmentRemoveAll() {
      //     if (this.isHorizontal) {
      //         this.currentOrientation.onAssignmentRemoveAll();
      //     }
      // }
      // /**
      //  * Refreshes scheduler when assignment store is filtered.
      //  */
      // onAssignmentFilter() {
      //     if (this.isHorizontal) {
      //         this.refresh();
      //     }
      // }
      //endregion
      //region TimeRangeStore

      /**
       * Get/set the time ranges store instance for {@link Scheduler.feature.TimeRanges} feature.
       * @property {Core.data.Store}
       * @category Data
       * @name timeRangeStore
       */
      //endregion
      //region ResourceTimeRangeStore

      /**
       * Get/set the resource time ranges store instance for {@link Scheduler.feature.ResourceTimeRanges} feature.
       * @property {Scheduler.data.ResourceTimeRangeStore}
       * @category Data
       * @name resourceTimeRangeStore
       */
      //endregion
      //region Other functions

      /**
       * Applies the start and end date to each event store request (formatted in the same way as the start date, defined
       * in the EventStore Model class).
       * @category Data
       */

    }, {
      key: "applyStartEndParameters",
      value: function applyStartEndParameters(_ref8) {
        var eventStore = _ref8.source,
            params = _ref8.params;
        var me = this,
            field = eventStore.modelClass.fieldMap.startDate;

        if (me.passStartEndParameters) {
          params[me.startParamName] = field.print(me.startDate);
          params[me.endParamName] = field.print(me.endDate);
        }
      } //endregion
      //region WidgetClass
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "store",
      get: function get() {
        // Vertical uses a dummy store
        if (!this._store && this.isVertical) {
          // TODO: Make this store readonly, since we are using single cell approach
          this._store = new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_39__["default"]({
            data: [{
              id: 'verticalTimeAxisRow'
            }]
          });
        }

        return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_34___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SchedulerStores.prototype), "store", this);
      },
      set: function set(store) {
        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_33___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_37___default()(SchedulerStores.prototype), "store", store, this, true);
      }
    }, {
      key: "widgetClass",
      get: function get() {} //endregion

    }], [{
      key: "$name",
      get: function get() {
        return 'SchedulerStores';
      } //region Default config
      // This is the static definition of the Stores we consume from the project, and
      // which we must provide *TO* the project if we or our CrudManager is configured
      // with them.
      // The property name is the store name, and within that there is the dataname which
      // is the property which provides static data definition. And there is a listeners
      // definition which specifies the listeners *on this object* for each store.
      //
      // To process incoming stores, implement an updateXxxxxStore method such
      // as `updateEventStore(eventStore)`.
      //
      // To process an incoming Project implement `updateProject`. __Note that
      // `super.updateProject(...arguments)` must be called first.__

    }, {
      key: "projectStores",
      get: function get() {
        return {
          resourceStore: {
            dataName: 'resources'
          },
          eventStore: {
            dataName: 'events',
            listeners: {
              changePreCommit: 'onInternalEventStoreChange',
              clearChanges: 'onEventClearChanges',
              beforeCommit: 'onEventBeforeCommit',
              commit: 'onEventCommit',
              exception: 'onEventException',
              idchange: 'onEventIdChange',
              beforeLoad: 'applyStartEndParameters'
            }
          },
          assignmentStore: {
            dataName: 'assignments',
            listeners: {
              changePreCommit: 'onAssignmentChange',
              // In EventSelection.js
              beforeRemove: {
                fn: 'onAssignmentBeforeRemove',
                // We must go last in case an app vetoes a remove
                // by returning false from a handler.
                prio: -1000
              }
            }
          },
          dependencyStore: {
            dataName: 'dependencies'
          },
          calendarManagerStore: {}
        };
      }
    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * Inline events, will be loaded into an internally created EventStore.
           * @config {Scheduler.model.EventModel[]|Object[]} events
           * @category Data events
           */

          /**
           * The {@link Scheduler.data.EventStore} holding the events to be rendered into the scheduler (required).
           * @config {Scheduler.data.EventStore|Object} eventStore
           * @category Data
           */

          /**
           * Inline resources, will be loaded into an internally created ResourceStore.
           * @config {Scheduler.model.ResourceModel[]|Object[]} resources
           * @category Data
           */

          /**
           * The {@link Scheduler.data.ResourceStore} holding the resources to be rendered into the scheduler (required).
           * @config {Scheduler.data.ResourceStore|Object} resourceStore
           * @category Data
           */

          /**
           * Inline assignments, will be loaded into an internally created AssignmentStore.
           * @config {Scheduler.model.AssignmentModel[]|Object[]} assignments
           * @category Data
           */

          /**
           * The optional {@link Scheduler.data.AssignmentStore}, holding assignments between resources and events.
           * Required for multi assignments.
           * @config {Scheduler.data.AssignmentStore|Object} assignmentStore
           * @category Data
           */

          /**
           * Inline dependencies, will be loaded into an internally created DependencyStore.
           * @config {Scheduler.model.DependencyModel[]|Object[]} dependencies
           * @category Data
           */

          /**
           * The optional {@link Scheduler.data.DependencyStore}.
           * @config {Scheduler.data.DependencyStore|Object} dependencyStore
           * @category Data
           */

          /**
           * Inline time ranges, will be loaded into an internally created store if {@link Scheduler.feature.TimeRanges}
           * is enabled.
           * @config {Scheduler.model.TimeSpan[]|Object[]}
           * @category Data
           */
          timeRanges: null,

          /**
           * Inline resource time ranges, will be loaded into an internally created store if
           * {@link Scheduler.feature.ResourceTimeRanges} is enabled.
           * @config {Scheduler.model.ResourceTimeRangeModel[]|Object[]}
           * @category Data
           */
          resourceTimeRanges: null,

          /**
           * Overridden to *not* auto create a store at the Scheduler level.
           * The store is the {@link #config-resourceStore} of the backing project
           * @config {Core.data.Store}
           * @private
           */
          store: null,

          /**
           * The name of the start date parameter that will be passed to in every `eventStore` load request.
           * @config {String}
           * @category Data
           */
          startParamName: 'startDate',

          /**
           * The name of the end date parameter that will be passed to in every `eventStore` load request.
           * @config {String}
           * @category Data
           */
          endParamName: 'endDate',

          /**
           * true to apply start and end dates of the current view to any `eventStore` load requests.
           * @config {Boolean}
           * @category Data
           */
          passStartEndParameters: false,

          /**
           * Configure with `true` to also remove the event when removing the last assignment.
           * @config {Boolean}
           * @default
           * @category Misc
           */
          removeUnassignedEvent: true
        };
      }
    }]);

    return SchedulerStores;
  }(Object(_data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_42__["default"])(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_38__["default"]));
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineDateMapper.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineDateMapper.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

 // Used to avoid having to create huge amounts of Date objects

var tempDate = new Date();
/**
 * @module Scheduler/view/mixin/TimelineDateMapper
 */

/**
 * Mixin that contains functionality to convert between coordinates and dates etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(TimelineDateMapper, _ref);

    var _super = _createSuper(TimelineDateMapper);

    function TimelineDateMapper() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TimelineDateMapper);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TimelineDateMapper, [{
      key: "getDateFromCoordinate",
      //region Coordinate <-> Date

      /**
       * Gets the date for an X or Y coordinate, either local to the view element or the page based on the 3rd argument.
       * If the coordinate is not in the currently rendered view, null will be returned unless the `allowOutOfRange`
       * parameter is passed a `true`.
       * @param {Number} coordinate The X or Y coordinate
       * @param {String} [roundingMethod] The rounding method to use
       * @param {Boolean} [local] true if the coordinate is local to the scheduler view element
       * @param {Boolean} [allowOutOfRange] By default, this returns `null` if the position is outside
       * of the time axis. Pass `true` to attempt to calculate a date outside of the time axis.
       * @returns {Date} The Date corresponding to the X or Y coordinate
       * @category Dates
       */
      value: function getDateFromCoordinate(coordinate, roundingMethod) {
        var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var allowOutOfRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        if (!local) {
          coordinate = this.currentOrientation.translateToScheduleCoordinate(coordinate);
        }

        return this.timeAxisViewModel.getDateFromPosition(coordinate, roundingMethod, allowOutOfRange);
      }
      /**
       * Gets the date for an XY coordinate regardless of the orientation of the time axis.
       * @param {Array} xy The page X and Y coordinates
       * @param {String} [roundingMethod] Optional, 'floor' to floor the value or 'round' to round the value to nearest increment
       * @param {Boolean} [local] true if the coordinate is local to the scheduler element
       * @param {Boolean} [allowOutOfRange] By default, this returns `null` if the position is outside
       * of the time axis. Pass `true` to attempt to calculate a date outside of the time axis.
       * @returns {Date} the Date corresponding to the xy coordinate
       * @category Dates
       */

    }, {
      key: "getDateFromXY",
      value: function getDateFromXY(xy, roundingMethod) {
        var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var allowOutOfRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return this.currentOrientation.getDateFromXY(xy, roundingMethod, local, allowOutOfRange);
      }
      /**
       * Gets the time for a DOM event such as 'mousemove' or 'click' regardless of the orientation of the time axis.
       * @param {Event} e the Event instance
       * @param {String} [roundingMethod] Optional, 'floor' to floor the value or 'round' to round the value to nearest increment
       * @param {Boolean} [allowOutOfRange] By default, this returns `null` if the position is outside
       * of the time axis. Pass `true` to attempt to calculate a date outside of the time axis.
       * @returns {Date} The date corresponding to the EventObject's position along the orientation of the time axis.
       * @category Dates
       */

    }, {
      key: "getDateFromDomEvent",
      value: function getDateFromDomEvent(e, roundingMethod) {
        var allowOutOfRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return this.getDateFromXY([e.pageX, e.pageY], roundingMethod, false, allowOutOfRange);
      }
      /**
       * Gets the start and end dates for an element Region
       * @param {Core.helper.util.Rectangle} rect The rectangle to map to start and end dates
       * @param {String} roundingMethod The rounding method to use
       * @param {Number} duration The duration in MS of the underlying event
       * @returns {Object} an object containing start/end properties
       */

    }, {
      key: "getStartEndDatesFromRectangle",
      value: function getStartEndDatesFromRectangle(rect, roundingMethod, duration) {
        var allowOutOfRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var me = this,
            isHorizontal = me.isHorizontal,
            timeSpanEnd = isHorizontal ? me.timeAxisSubGrid.width : me.timeAxisSubGrid.height,
            startPos = isHorizontal ? rect.x : rect.top,
            endPos = isHorizontal ? rect.right : rect.bottom;
        var start, end; // Element within bounds

        if (startPos >= 0 && endPos < timeSpanEnd) {
          start = me.getDateFromCoordinate(startPos, null, true);
          end = me.getDateFromCoordinate(endPos, null, true);
        } // Starts before, start is worked backwards from end
        else if (startPos < 0) {
            end = me.getDateFromCoordinate(endPos, roundingMethod, true, allowOutOfRange);
            start = end && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].add(end, -duration, 'ms');
          } // Ends after, end is calculated from the start
          else {
              start = me.getDateFromCoordinate(startPos, roundingMethod, true, allowOutOfRange);
              end = start && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].add(start, duration, 'ms');
            }

        return {
          start: start,
          end: end
        };
      } //endregion
      //region Date display

      /**
       * Get/set format to use when displaying dates. Usually set by specifying a view preset
       * @property {String}
       * @category Dates
       */

    }, {
      key: "getFormattedDate",

      /**
       * Method to get a formatted display date
       * @private
       * @param {Date} date The date
       * @return {String} The formatted date
       */
      value: function getFormattedDate(date) {
        return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].format(date, this.displayDateFormat);
      }
      /**
       * Method to get a displayed end date value, see {@link #function-getFormattedEndDate} for more info.
       * @private
       * @param {Date} endDate The date to format
       * @param {Date} startDate The start date
       * @return {Date} The date value to display
       */

    }, {
      key: "getDisplayEndDate",
      value: function getDisplayEndDate(endDate, startDate) {
        if ( // If time is midnight,
        endDate.getHours() === 0 && endDate.getMinutes() === 0 && ( // and end date is greater then start date
        !startDate || !(endDate.getYear() === startDate.getYear() && endDate.getMonth() === startDate.getMonth() && endDate.getDate() === startDate.getDate())) && // and UI display format doesn't contain hour info (in this case we'll just display the exact date)
        !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].formatContainsHourInfo(this.displayDateFormat)) {
          // format the date inclusively as 'the whole previous day'.
          endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].add(endDate, -1, 'day');
        }

        return endDate;
      }
      /**
       * Method to get a formatted end date for a scheduled event, the grid uses the "displayDateFormat" property defined in the current view preset.
       * End dates are formatted as 'inclusive', meaning when an end date falls on midnight and the date format doesn't involve any hour/minute information,
       * 1ms will be subtracted (e.g. 2010-01-08T00:00:00 will first be modified to 2010-01-07 before being formatted).
       * @private
       * @param {Date} endDate The date to format
       * @param {Date} startDate The start date
       * @return {String} The formatted date
       */

    }, {
      key: "getFormattedEndDate",
      value: function getFormattedEndDate(endDate, startDate) {
        return this.getFormattedDate(this.getDisplayEndDate(endDate, startDate));
      } //endregion
      //region Other date functions

      /**
       * Gets the x or y coordinate relative to the scheduler element, or page coordinate (based on the 'local' flag)
       * If the coordinate is not in the currently rendered view, -1 will be returned.
       * @param {Date|Number} date the date to query for (or a date as ms)
       * @param {Boolean|Object} options true to return a coordinate local to the scheduler view element (defaults to true),
       * also accepts a config object like { local : true }.
       * @returns {Number} the x or y position representing the date on the time axis
       * @category Dates
       */

    }, {
      key: "getCoordinateFromDate",
      value: function getCoordinateFromDate(date) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var me = this,
            timeAxisViewModel = me.timeAxisViewModel,
            _me$timeAxis = me.timeAxis,
            isContinuous = _me$timeAxis.isContinuous,
            startMS = _me$timeAxis.startMS,
            endMS = _me$timeAxis.endMS,
            startDate = _me$timeAxis.startDate,
            unit = _me$timeAxis.unit,
            dateMS = date.valueOf(); // Avoiding to break the API while allowing passing options through to getPositionFromDate()

        if (options === true) {
          options = {
            local: true
          };
        } else if (!options) {
          options = {
            local: false
          };
        } else if (!('local' in options)) {
          options.local = true;
        }

        var pos; // TODO for 2.0 try to normalize and just use dates as input for this method,
        // then this if-statement would not be needed

        if (!(date instanceof Date)) {
          tempDate.setTime(date);
          date = tempDate;
        } // Shortcut for continuous time axis that is using a unit that can be reliably translated to days (or smaller)


        if (isContinuous && date.getTimezoneOffset() === startDate.getTimezoneOffset() && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getUnitToBaseUnitRatio(unit, 'day') !== -1) {
          if (dateMS < startMS || dateMS > endMS) {
            return -1;
          }

          pos = Math.round((dateMS - startMS) / (endMS - startMS) * timeAxisViewModel.totalSize);
        } // Non-continuous or using for example months (vary in length)
        else {
            pos = timeAxisViewModel.getPositionFromDate(date, options);
          }

        if (!options.local) {
          pos = me.currentOrientation.translateToPageCoordinate(pos);
        }

        return pos;
      }
      /**
       * Returns the distance in pixels for the time span in the view.
       * @param {Date} startDate The start date of the span
       * @param {Date} endDate The end date of the span
       * @return {Number} The distance in pixels
       * @category Dates
       */

    }, {
      key: "getTimeSpanDistance",
      value: function getTimeSpanDistance(startDate, endDate) {
        return this.timeAxisViewModel.getDistanceBetweenDates(startDate, endDate);
      }
      /**
       * Returns the center date of the currently visible timespan of scheduler.
       *
       * @return {Date} date Center date for the viewport.
       * @readonly
       * @category Dates
       */

    }, {
      key: "onSchedulerHorizontalScroll",
      //endregion
      value: function onSchedulerHorizontalScroll(_ref2) {
        var subGrid = _ref2.subGrid,
            scrollLeft = _ref2.scrollLeft;

        // Invalidate cached center date unless we are scrolling to center on it.
        if (!this.scrollingToCenter) {
          this.cachedCenterDate = null;
        }
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "displayDateFormat",
      get: function get() {
        return this._displayDateFormat;
      },
      set: function set(format) {
        this._displayDateFormat = format; // Start/EndDateColumn listens for this to change their format to match

        this.trigger('displayDateFormatChange', {
          format: format
        });
      }
    }, {
      key: "viewportCenterDate",
      get: function get() {
        var me = this,
            isHorizontal = me.isHorizontal,
            timeAxis = me.timeAxis,
            scroller = isHorizontal ? me.timeAxisSubGrid.scrollable : me.scrollable,
            centerX = scroller.x + scroller.clientWidth / 2,
            centerY = scroller.y + scroller.clientHeight / 2;

        if (timeAxis.isContinuous) {
          // Calculate center pixel in the viewport.
          // Then Calculate how far through the axis range that is.
          var scrollCenter = isHorizontal ? centerX / scroller.scrollWidth : centerY / scroller.scrollHeight,
              centerMilli = timeAxis.startMS + (timeAxis.endMS - timeAxis.startMS) * scrollCenter;
          return new Date(centerMilli);
        } else {
          var xy = isHorizontal ? [centerX, 0] : [0, centerY];
          return me.getDateFromXY(xy, null, true);
        }
      }
    }, {
      key: "viewportCenterDateCached",
      get: function get() {
        return this.cachedCenterDate || (this.cachedCenterDate = this.viewportCenterDate);
      } //endregion
      //region TimeAxis getters/setters

      /**
       * Gets/sets the current time resolution object, which contains a unit identifier and an increment count { unit, increment }.
       * This value means minimal task duration you can create using UI.
       * For example when you drag create a task or drag & drop a task, if increment is 5 and unit is 'minute'
       * that means that you can create a 5 min long task, or move it 5 min forward/backward.
       * This value is taken from viewPreset {@link Scheduler.preset.ViewPreset#field-timeResolution timeResolution} config by default.
       * When supplying a `Number` to the setter only the `increment` is changed and the `unit` value remains untouched.
       *
       * ```javascript
       * timeResolution : {
       *   unit      : 'minute',  //Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
       *   increment : 5
       * }
       * ```
       *
       * @property {Object|Number}
       * @category Dates
       */

    }, {
      key: "timeResolution",
      get: function get() {
        return this.timeAxis.resolution;
      },
      set: function set(resolution) {
        this.timeAxis.resolution = typeof resolution === 'number' ? {
          increment: resolution,
          unit: this.timeAxis.resolution.unit
        } : resolution;
      } //endregion
      //region Snap

      /**
       * Controls whether the scheduler should snap to the resolution when interacting with it
       * @property {Boolean}
       * @category Dates
       */

    }, {
      key: "snap",
      set: function set(enabled) {
        // timeAxisViewModel is not created yet during configuration
        if (!this.isConfiguring) {
          this.timeAxisViewModel.snap = enabled;
        } else {
          this._snap = enabled;
        }
      },
      get: function get() {
        // timeAxisViewModel is not created yet during configuration
        if (this.isConfiguring) {
          return this._snap;
        }

        return this.timeAxisViewModel.snap;
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'TimelineDateMapper';
      }
    }]);

    return TimelineDateMapper;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineDomEvents.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineDomEvents.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/view/mixin/TimelineDomEvents
 */

var eventNameMap = {
  mousedown: 'MouseDown',
  mouseup: 'MouseUp',
  click: 'Click',
  dblclick: 'DblClick',
  contextmenu: 'ContextMenu',
  mouseover: 'MouseOver',
  mouseout: 'MouseOut'
};
/**
 * Mixin that handles dom events (click etc) for scheduler and rendered events.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TimelineDomEvents, _ref);

    var _super = _createSuper(TimelineDomEvents);

    function TimelineDomEvents() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, TimelineDomEvents);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(TimelineDomEvents, [{
      key: "initDomEvents",
      //endregion
      //region Init

      /**
       * Adds listeners for DOM events for the scheduler and its events.
       * Which events is specified in Scheduler#scheduledBarEvents and Scheduler#schedulerEvents.
       * @private
       */
      value: function initDomEvents() {
        var me = this; // Set thisObj and element of the configured listener specs.

        me.scheduledBarEvents.element = me.schedulerEvents.element = me.timeAxisSubGridElement;
        me.scheduledBarEvents.thisObj = me.schedulerEvents.thisObj = me; // same listener used for different events

        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on(me.scheduledBarEvents);
        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on(me.schedulerEvents);
      } //endregion
      //region Event handling

    }, {
      key: "getTimeSpanMouseEventParams",
      value: function getTimeSpanMouseEventParams(eventElement, event) {
        throw new Error('Implement in subclass');
      }
    }, {
      key: "getScheduleMouseEventParams",
      value: function getScheduleMouseEventParams(cellData, event) {
        throw new Error('Implement in subclass');
      }
      /**
       * Wraps dom Events for rendered scheduler EventModels and fires prefixed as our events.
       * For example click -> eventclick
       * @private
       * @param event
       */

    }, {
      key: "handleScheduledBarEvent",
      value: function handleScheduledBarEvent(event) {
        var me = this,
            eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(event.target, me.eventInnerSelector),
            eventName = eventNameMap[event.type] || _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].capitalize(event.type);

        if (eventElement) {
          me.trigger(me.scheduledEventName + eventName, me.getTimeSpanMouseEventParams(eventElement, event));
        }
      }
      /**
       * Wraps dom Events for the scheduler and fires as our events.
       * For example click -> scheduleClick
       * @private
       * @param event
       */

    }, {
      key: "handleScheduleEvent",
      value: function handleScheduleEvent(event) {
        var me = this,
            eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(event.target, me.eventSelector),
            cellElement = !eventElement && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(event.target, '.' + me.timeCellCls),
            eventName = eventNameMap[event.type] || _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].capitalize(event.type);

        if (cellElement) {
          var clickedDate = me.getDateFromDomEvent(event, 'floor');

          if (!clickedDate) {
            return;
          }

          var cellData = _Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_14__["default"].get(cellElement),
              index = cellData.row.dataIndex,
              tickIndex = me.timeAxis.getTickFromDate(clickedDate),
              tick = me.timeAxis.getAt(Math.floor(tickIndex));

          if (tick) {
            me.trigger('schedule' + eventName, Object.assign({
              date: clickedDate,
              tickStartDate: tick.startDate,
              tickEndDate: tick.endDate,
              row: cellData.row,
              index: index,
              event: event
            }, me.getScheduleMouseEventParams(cellData, event)));
          }
        }
      }
      /**
       * Relays mouseover events as eventmouseenter if over rendered event.
       * Also adds Scheduler#overScheduledEventClass to the hovered element.
       * @private
       */

    }, {
      key: "onElementMouseOver",
      value: function onElementMouseOver(event) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineDomEvents.prototype), "onElementMouseOver", this).call(this, event);

        var me = this,
            target = event.target; // We must be over the event bar

        if (target.closest(me.eventInnerSelector)) {
          var eventElement = target.closest(me.eventSelector);
          eventElement.classList.add(me.overScheduledEventClass);

          if (eventElement !== me.hoveredEventNode && !me.preventOverCls) {
            me.hoveredEventNode = eventElement;
            var params = me.getTimeSpanMouseEventParams(eventElement, event);

            if (params) {
              // do not fire this event if model cannot be found
              // this can be the case for "b-sch-dragcreator-proxy" elements for example
              me.trigger(me.scheduledEventName + 'MouseEnter', params);
            }
          }
        } else {
          me.hoveredEventNode = null;
        }
      }
      /**
       * Relays mouseout events as eventmouseleave if out from rendered event.
       * Also removes Scheduler#overScheduledEventClass from the hovered element.
       * @private
       */

    }, {
      key: "onElementMouseOut",
      value: function onElementMouseOut(event) {
        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineDomEvents.prototype), "onElementMouseOut", this).call(this, event);

        var me = this; // We must be over the event bar

        if (event.target.closest(me.eventInnerSelector) && me.resolveTimeSpanRecord(event.target) && me.hoveredEventNode) {
          // out to child shouldn't count...
          if (event.relatedTarget && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isDescendant(event.target.closest(me.eventInnerSelector), event.relatedTarget)) return;
          me.unhover(event);
        }
      }
    }, {
      key: "unhover",
      value: function unhover(event) {
        var me = this,
            eventElement = me.hoveredEventNode;

        if (eventElement) {
          eventElement.classList.remove(me.overScheduledEventClass);
          me.trigger(me.scheduledEventName + 'MouseLeave', me.getTimeSpanMouseEventParams(eventElement, event));
          me.hoveredEventNode = null;
        }
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'TimelineDomEvents';
      } //region Default config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          // TODO: PORT longpress missing
          scheduledBarEvents: {
            mousedown: 'handleScheduledBarEvent',
            mouseup: 'handleScheduledBarEvent',
            click: 'handleScheduledBarEvent',
            dblclick: 'handleScheduledBarEvent',
            contextmenu: 'handleScheduledBarEvent',
            mouseover: 'handleScheduledBarEvent',
            mouseout: 'handleScheduledBarEvent'
          },
          // TODO: PORT pinch, pinchstart, pinchend missing
          schedulerEvents: {
            click: 'handleScheduleEvent',
            dblclick: 'handleScheduleEvent',
            contextmenu: 'handleScheduleEvent',
            mousemove: 'handleScheduleEvent'
          }
        };
      }
    }]);

    return TimelineDomEvents;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineEventRendering.js":
/*!************************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineEventRendering.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/view/mixin/TimelineEventRendering
 */

/**
 * Functions to handle event rendering (EventModel -> dom elements).
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(TimelineEventRendering, _ref);

    var _super = _createSuper(TimelineEventRendering);

    function TimelineEventRendering() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TimelineEventRendering);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TimelineEventRendering, [{
      key: "barMargin",
      //endregion
      //region Settings

      /**
       * Control how much space to leave between stacked event bars in px. Value will be constrained by half the row height.
       * @property {Number}
       * @category Scheduled events
       */
      get: function get() {
        return this._barMargin;
      },
      set: function set(margin) {
        var me = this;
        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].assertNumber(margin, 'barMargin'); // bar margin should not exceed half of the row height

        if (me.isHorizontal && me.rowHeight) {
          margin = Math.min(Math.ceil(me.rowHeight / 2), margin);
        }

        if (me._barMargin !== margin) {
          me._barMargin = margin;

          if (me.rendered) {
            me.currentOrientation.onBeforeRowHeightChange();
            me.refreshWithTransition();
          }
        }
      } // Documented in SchedulerEventRendering to not show up in Gantt docs

    }, {
      key: "resourceMargin",
      get: function get() {
        return this._resourceMargin == null ? this.barMargin : this._resourceMargin;
      },
      set: function set(margin) {
        var me = this;
        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].assertNumber(margin, 'resourceMargin'); // bar margin should not exceed half of the row height

        if (me.isHorizontal && me.rowHeight) {
          margin = Math.min(Math.ceil(me.rowHeight / 2), margin);
        }

        if (me._resourceMargin !== margin) {
          me._resourceMargin = margin;

          if (me.rendered) {
            me.currentOrientation.onBeforeRowHeightChange();
            me.refreshWithTransition();
          }
        }
      } // /**
      //  * Distance between bars when using eventLayout pack
      //  * @property {Number}
      //  */
      // get barPackMargin() {
      //     return this._barPackMargin;
      // }
      //
      // set barPackMargin(margin) {
      //     if (this._barPackMargin !== margin) {
      //         this._barPackMargin = margin;
      //         this.refresh();
      //     }
      // }

      /**
       * Get/set the width/height (depending on mode) of all the time columns to the supplied value.
       * There is a limit for the tick size value. Its minimal allowed value is calculated so ticks would fit the available space.
       * Only applicable when {@link Scheduler.view.TimelineBase#config-forceFit} is set to `false`.
       * To set `tickSize` freely skipping that limitation please set {@link Scheduler.view.TimelineBase#config-suppressFit} to `true`.
       * @property {Number}
       * @category Scheduled events
       */

    }, {
      key: "tickSize",
      set: function set(width) {
        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].assertNumber(width, 'tickSize');
        this.timeAxisViewModel.tickSize = width;
      },
      get: function get() {
        return this.timeAxisViewModel.tickSize;
      }
      /**
       * Predefined event colors, useful in combos etc.
       * @type {String}
       * @category Scheduled events
       */

    }, {
      key: "widgetClass",
      //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'TimelineEventRendering';
      } //region Default config

    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Controls how much space to leave between stacked event bars in px
           * @config {Number}
           * @default
           * @category Scheduled events
           */
          barMargin: 10,
          resourceMargin: null,

          /**
           * True to size events based on the rowHeight and barMargin settings. Set this to false if you want to
           * control height and top properties via CSS instead.
           * @config {Boolean}
           * @default
           * @category Scheduled events
           */
          managedEventSizing: true,

          /**
           * The CSS class added to an event/assignment when it is newly created
           * in the UI and unsynced with the server.
           * @config {String}
           * @default
           * @private
           * @category CSS
           */
          generatedIdCls: 'b-sch-dirty-new',

          /**
           * The CSS class added to an event when it has unsaved modifications
           * @config {String}
           * @default
           * @private
           * @category CSS
           */
          dirtyCls: 'b-sch-dirty',

          /**
           * The CSS class added to an event when it is currently committing changes
           * @config {String}
           * @default
           * @private
           * @category CSS
           */
          committingCls: 'b-sch-committing',

          /**
           * The CSS class added to an event/assignment when it ends outside of the visible time range.
           * @config {String}
           * @default
           * @private
           * @category CSS
           */
          endsOutsideViewCls: 'b-sch-event-endsoutside',

          /**
           * The CSS class added to an event/assignment when it starts outside of the visible time range.
           * @config {String}
           * @default
           * @private
           * @category CSS
           */
          startsOutsideViewCls: 'b-sch-event-startsoutside',

          /**
           * The CSS class added to an event/assignment when it is not draggable.
           * @config {String}
           * @default
           * @private
           * @category CSS
           */
          fixedEventCls: 'b-sch-event-fixed',

          /**
           * Event style used by default. Events and resources can specify their own style, with priority order being:
           * Event -> Resource -> Scheduler default. Determines the appearance of the event by assigning a CSS class
           * to it. Available styles are:
           * * plain (default), flat look
           * * border, has border in darker shade of events color
           * * colored, has colored text and wide left border in same color
           * * hollow, only border + text until hovered
           * * line, as a line with the text below it
           * * dashed, as a dashed line with the text below it
           * * minimal, as a thin line with small text above it
           * * rounded, minimalistic style with rounded corners
           *
           * Specify `null` to not apply a default style and take control using custom CSS (easily overridden basic
           * styling will be used).
           *
           * @config {String}
           * @default
           * @category Scheduled events
           */
          eventStyle: 'plain',

          /**
           * Event color used by default. Events and resources can specify their own color, with priority order being:
           * Event -> Resource -> Scheduler default. Available colors are:
           * * red
           * * pink
           * * purple
           * * violet
           * * indigo
           * * blue
           * * cyan
           * * teal
           * * green
           * * lime
           * * yellow
           * * orange
           * * deep-orange
           * * gray
           * * gantt-green (Useful when you want to match the color to the default color in Gantt)
           *
           * Specify `null` to not apply a default color and take control using custom CSS (an easily overridden color
           * will be used to make sure events are still visible).
           *
           * @config {String}
           * @default
           * @category Scheduled events
           */
          eventColor: 'green'
        };
      }
    }, {
      key: "eventColors",
      get: function get() {
        return ['red', 'pink', 'purple', 'violet', 'indigo', 'blue', 'cyan', 'teal', 'green', 'lime', 'yellow', 'orange', 'deep-orange', 'gray'];
      }
      /**
       * Predefined event styles , useful in combos etc.
       * @type {String}
       * @category Scheduled events
       */

    }, {
      key: "eventStyles",
      get: function get() {
        return ['plain', 'border', 'hollow', 'colored', 'line', 'dashed', 'minimal', 'rounded'];
      }
    }]);

    return TimelineEventRendering;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineScroll.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineScroll.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/view/mixin/TimelineScroll
 */

/**
 * Functions for scrolling to events, dates etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(TimelineScroll, _ref);

    var _super = _createSuper(TimelineScroll);

    function TimelineScroll() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, TimelineScroll);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(TimelineScroll, [{
      key: "scrollToDate",
      //region Scroll to date

      /**
       * Scrolls the time line "tick" encapsulating the passed `Date` into view according to the passed options.
       * @param {Date} date The date to which to scroll the time line
       * @param {Object} [options] How to scroll.
       * @param {String} [options.block=nearest] How far to scroll the tick: `start/end/center/nearest`.
       * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the tick to bring into view.
       * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
       * @returns {Promise} A Promise which resolves when the scrolling is complete.
       */
      value: function scrollToDate(date) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var me = this,
            scroller = me.timeAxisSubGrid.scrollable,
            scrollerViewport = scroller.viewport,
            localCoordinate = me.getCoordinateFromDate(date, true),
            target = me.isHorizontal ? new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"](me.getCoordinateFromDate(date, false), scrollerViewport.y, me.timeAxisViewModel.tickSize, scrollerViewport.height) : new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"](scrollerViewport.x, me.getCoordinateFromDate(date, false), scrollerViewport.width, me.timeAxisViewModel.tickSize);
        return me.scrollToCoordinate(localCoordinate, target, date, options);
      }
      /**
       * Scrolls to current time.
       * @param {Object} [options] How to scroll.
       * @param {String} [options.block=nearest] How far to scroll the tick: `start/end/center/nearest`.
       * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the tick to bring into view.
       * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
       * @returns {Promise} A Promise which resolves when the scrolling is complete.
       */

    }, {
      key: "scrollToNow",
      value: function scrollToNow() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return this.scrollToDate(new Date(), options);
      }
      /**
       * Used by {@link #function-scrollToDate} to scroll to correct coordinate.
       * @param {Number} localCoordinate Coordinate to scroll to
       * @param {Date} date Date to scroll to, used for reconfiguring the time axis
       * @param {Object} [options] How to scroll.
       * @param {String} [options.block=nearest] How far to scroll the tick: `start/end/center/nearest`.
       * @param {Number} [options.edgeOffset] edgeOffset A margin *in pixels* around the tick to bring into view.
       * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
       * @returns {Promise} A Promise which resolves when the scrolling is complete.
       * @private
       */

    }, {
      key: "scrollToCoordinate",
      value: function () {
        var _scrollToCoordinate = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee(localCoordinate, target, date) {
          var options,
              me,
              halfVisibleSpan,
              _me$timeAxis,
              unit,
              increment,
              newStartDate,
              newEndDate,
              _args = arguments;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  options = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
                  me = this; // Not currently have this date in a timeaxis. Ignore negative scroll in weekview, it can be just 'filtered' with
                  // startTime/endTime config

                  if (!(localCoordinate < 0)) {
                    _context.next = 8;
                    break;
                  }

                  // adjust the timeaxis first
                  halfVisibleSpan = (me.timeAxis.endDate - me.timeAxis.startDate) / 2, _me$timeAxis = me.timeAxis, unit = _me$timeAxis.unit, increment = _me$timeAxis.increment, newStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].snap('floor', new Date(date.getTime() - halfVisibleSpan), increment + ' ' + unit), newEndDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].snap('ceil', new Date(date.getTime() + halfVisibleSpan), increment + ' ' + unit); // We're trying to reconfigure time span to current dates, which means we are as close to center as it
                  // could be. Do nothing then.
                  // covered by 1102_panel_api

                  if (!(newStartDate - me.startDate !== 0 && newEndDate - me.endDate !== 0)) {
                    _context.next = 7;
                    break;
                  }

                  me.setTimeSpan(newStartDate, newEndDate);
                  return _context.abrupt("return", me.scrollToDate(date, options));

                case 7:
                  return _context.abrupt("return");

                case 8:
                  _context.next = 10;
                  return me.timeAxisSubGrid.scrollable.scrollIntoView(target, options);

                case 10:
                  return _context.abrupt("return", me.nextAnimationFrame());

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function scrollToCoordinate(_x, _x2, _x3) {
          return _scrollToCoordinate.apply(this, arguments);
        }

        return scrollToCoordinate;
      }() //endregion
      //region Relative scrolling
      // These methods are important to users because although they are mixed into the top level Grid/Scheduler,
      // for X scrolling the explicitly target the SubGrid that holds the scheduler.

      /**
       * Get/set horizontal scroll. Applies to the SubGrid that holds the scheduler
       * @property {Number}
       * @category Scrolling
       */

    }, {
      key: "scrollHorizontallyTo",

      /**
       * Horizontal scrolling. Applies to the SubGrid that holds the scheduler
       * @param {Number} x
       * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
       * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
       * or the number of milliseconds to animate over, or an animation config object.
       * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
       * @param {String} [options.animate.easing] The name of an easing function.
       * @returns {Promise} A promise which is resolved when the scrolling has finished.
       */
      value: function scrollHorizontallyTo(coordinate) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return this.timeAxisSubGrid.scrollable.scrollTo(coordinate, null, options);
      }
      /**
       * Vertical scrolling
       * @param {Number} y
       * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
       * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
       * or the number of milliseconds to animate over, or an animation config object.
       * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
       * @param {String} [options.animate.easing] The name of an easing function.
       * @returns {Promise} A promise which is resolved when the scrolling has finished.
       */

    }, {
      key: "scrollVerticallyTo",
      value: function scrollVerticallyTo(y) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return this.scrollable.scrollTo(null, y, options);
      }
      /**
       * Scrolls the subgrid that contains the scheduler
       * @param {Number} x
       * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
       * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
       * or the number of milliseconds to animate over, or an animation config object.
       * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
       * @param {String} [options.animate.easing] The name of an easing function.
       * @returns {Promise} A promise which is resolved when the scrolling has finished.
       */

    }, {
      key: "scrollTo",
      value: function scrollTo(x) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return this.timeAxisSubGrid.scrollable.scrollTo(x, null, options);
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "scrollLeft",
      set: function set(left) {
        this.timeAxisSubGrid.scrollable.x = left;
      }
      /**
       * Get/set vertical scroll
       * @property {Number}
       * @category Scrolling
       */
      ,
      get: function get() {
        return this.timeAxisSubGrid.scrollable.x;
      }
    }, {
      key: "scrollTop",
      set: function set(top) {
        this.scrollable.y = top;
      },
      get: function get() {
        return this.scrollable.y;
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'TimelineScroll';
      }
    }]);

    return TimelineScroll;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_11__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineViewPresets.js":
/*!*********************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineViewPresets.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../preset/PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");
/* harmony import */ var _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../preset/ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _preset_PresetStore_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../preset/PresetStore.js */ "./lib/Scheduler/preset/PresetStore.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/view/mixin/TimelineViewPresets
 */

var datesDiffer = function datesDiffer() {
  var d1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var d2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return d2 - d1;
};
/**
 * View preset handling.
 *
 * A Scheduler's {@link #config-presets} are loaded with a default set of {@link Scheduler.preset.ViewPreset ViewPresets}
 * which are defined by the system in the {@link Scheduler.preset.PresetManager PresetManager}.
 *
 * The zooming feature works by reconfiguring the Scheduler with a new {@link Scheduler.preset.ViewPreset ViewPreset} selected
 * from the {@link #config-presets} store.
 *
 * {@link Scheduler.preset.ViewPreset ViewPresets} can be added and removed from the store to change the amount of available steps.
 * Range of zooming in/out can be also modified with {@link Scheduler.view.mixin.TimelineZoomable#config-maxZoomLevel} / {@link Scheduler.view.mixin.TimelineZoomable#config-minZoomLevel} properties.
 *
 * This mixin adds additional methods to the column : {@link Scheduler.view.mixin.TimelineZoomable#property-maxZoomLevel}, {@link Scheduler.view.mixin.TimelineZoomable#property-minZoomLevel}, {@link Scheduler.view.mixin.TimelineZoomable#function-zoomToLevel}, {@link Scheduler.view.mixin.TimelineZoomable#function-zoomIn},
 * {@link Scheduler.view.mixin.TimelineZoomable#function-zoomOut}, {@link Scheduler.view.mixin.TimelineZoomable#function-zoomInFull}, {@link Scheduler.view.mixin.TimelineZoomable#function-zoomOutFull}.
 *
 * **Notice**: Zooming is not supported when `forceFit` option is set to true for the Scheduler or for filtered timeaxis.
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TimelineViewPresets, _ref);

    var _super = _createSuper(TimelineViewPresets);

    function TimelineViewPresets() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, TimelineViewPresets);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(TimelineViewPresets, [{
      key: "normalizePreset",
      value: function normalizePreset(preset) {
        var me = this,
            input = preset,
            presets = me.presets; // They may have passed a string id, an number index, or ViewPreset config object.

        if (!(preset instanceof _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_12__["default"])) {
          // A config of a preset, instantiate it based upon any base that may be requested.
          // This may be one that's supplied by Bryntum in the PresetManager, or one that has been
          // previously added to this Scheduler's preset store.
          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default()(preset) === 'object') {
            // Look up any existing ViewPreset that it is based upon.
            if (preset.base) {
              // Look locally first, then in the PresetManager
              var base = presets.getById(preset.base) || _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_11__["default"].getById(preset.base);

              if (!base) {
                throw new Error("ViewPreset base '".concat(preset.base, "' does not exist"));
              } // The config is based upon the base's data with the new Preset type's normalized data object merged in.
              // MUST run the incoming data block through the constructor in order to apply the backward compatibility
              // processing to the data block to be merged with the base.


              preset = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].merge(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].clone(base.data), _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_11__["default"].createRecord(preset).data);
            } // Ensure the new ViewPreset has a legible, logical id which does not already
            // exist in our store.


            if (preset.id) {
              preset = presets.createRecord(preset);
            } else {
              preset = presets.createRecord(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].assign({}, preset));
              preset.id = preset.generateId(presets);
            }
          } // Must be an index or id
          else {
              if (typeof preset === 'number') {
                preset = presets.getAt(preset);
              } else {
                preset = presets.getById(preset) || _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_11__["default"].getById(preset);
              }
            }

          if (!preset) {
            throw new Error("Invalid ViewPreset requested: ".concat(input));
          }
        } // An instance.
        // If an existing id is used, this will replace it.


        return presets.add(preset)[0];
      }
    }, {
      key: "changeViewPreset",
      value: function changeViewPreset(viewPreset, oldViewPreset) {
        var me = this; // Throw on use of expired deprecated usage.

        if (!(viewPreset instanceof _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_12__["default"]) && viewPreset.name && !viewPreset.base) {
          throw new Error('ViewPreset name config replaced by base config. See https://www.bryntum.com/docs/scheduler/#guides/upgrades/3.0.0.md');
        }

        viewPreset = me.normalizePreset(viewPreset);
        var lastOpts = me.lastViewPresetOptions || {},
            options = viewPreset.options || (viewPreset.options = {}),
            event = options.event = {
          startDate: options.startDate,
          endDate: options.endDate,
          from: oldViewPreset,
          to: viewPreset,
          preset: viewPreset
        },
            presetChanged = !me._viewPreset || !me._viewPreset.equals(viewPreset),
            optionsChanged = datesDiffer(options.startDate, lastOpts.startDate) || datesDiffer(options.endDate, lastOpts.endDate) || datesDiffer(options.centerDate, lastOpts.centerDate) || options.startDate && datesDiffer(options.startDate, me.startDate) || options.endDate && datesDiffer(options.endDate, me.endDate); // Only return the value for onward processing if there's a change

        if (presetChanged || optionsChanged) {
          // Bypass the no-change check if the viewPreset is the same and we only got in here
          // because different options were asked for.
          if (!presetChanged) {
            me._viewPreset = null;
          }
          /**
           * Fired before the {@link #config-viewPreset} is changed.
           * @event beforePresetChange
           * @param {Scheduler.view.Scheduler} source This Scheduler instance.
           * @param {Date} startDate The new start date of the timeline.
           * @param {Date} endDate The new end date of the timeline.
           * @param {Scheduler.preset.ViewPreset} from The outgoing ViewPreset.
           * @param {Scheduler.preset.ViewPreset} to The ViewPreset being switched to.
           * @preventable
           */
          // Do not trigger events for the initial preset


          if (me.isConfiguring || me.trigger('beforePresetChange', event) !== false) {
            return viewPreset;
          }
        }
      }
    }, {
      key: "updateViewPreset",
      value: function updateViewPreset(preset) {
        var me = this,
            options = preset.options,
            event = options.event,
            startDate = options.startDate,
            endDate = options.endDate,
            isHorizontal = me.isHorizontal,
            timeAxis = me._timeAxis;
        var centerDate = options.centerDate; // Raise flag to prevent partner from changing view preset if one is in progress

        me._viewPresetChanging = true; // prefer to use displayDateFormat configured on the panel

        me.displayDateFormat = me.config.displayDateFormat || preset.displayDateFormat;

        if (timeAxis) {
          // Cache options only when they are applied so that non-change vetoing in changeViewPreset is accurate
          me.lastViewPresetOptions = options; // Timeaxis may already be configured (in case of sharing with the timeline partner), no need to reconfigure it

          if (timeAxis.isConfigured) {
            // None of this reconfiguring should cause a refresh
            me.suspendRefresh();
            var timeAxisCfg = {
              weekStartDay: me.weekStartDay,
              startTime: me.startTime,
              endTime: me.endTime
            }; // if startDate is provided we use it and the provided endDate

            if (startDate) {
              timeAxisCfg.startDate = startDate;
              timeAxisCfg.endDate = endDate; // if both dates are provided we can calculate centerDate for the viewport

              if (!centerDate && endDate) {
                // TODO: PORT infitieScroll stuff
                // if (me.infiniteScroll && view.cachedScrollDate && view.cachedScrollDateIsCentered) {
                //     centerDate = view.cachedScrollDate;
                // } else {
                centerDate = new Date((startDate.getTime() + endDate.getTime()) / 2); //}
              } // when no start/end dates are provided we use the current timespan

            } else {
              timeAxisCfg.startDate = timeAxis.startDate;
              timeAxisCfg.endDate = endDate || timeAxis.endDate;

              if (!centerDate) {
                // TODO: PORT inifiteScroll stuff
                // if (me.infiniteScroll && view.cachedScrollDate && view.cachedScrollDateIsCentered) {
                //     centerDate = view.cachedScrollDate;
                // } else {
                centerDate = me.viewportCenterDate;
              }
            }

            timeAxis.isConfigured = false;
            timeAxis.viewPreset = preset;
            timeAxis.reconfigure(timeAxisCfg, true);
            me.timeAxisViewModel.reconfigure({
              viewPreset: me.viewPreset,
              headers: preset.headers,
              // This was hardcoded to 'middle' prior to the Preset refactor.
              // In the old code, the default headers were 'top' and 'middle', which
              // meant that 'middle' meant the lowest header.
              // So this is now length - 1.
              columnLinesFor: preset.columnLinesFor != null ? preset.columnLinesFor : preset.headers.length - 1,
              // TODO: PORT rowHeightHorizontal??
              // rowHeightHorizontal : me.readRowHeightFromPreset ? preset.rowHeight : me.rowHeight,
              tickSize: isHorizontal ? preset.tickWidth : preset.tickHeight || preset.tickWidth || 60
            }); // Allow refresh to run after the reconfiguring

            me.resumeRefresh();
          }

          me.refresh(); // if view is rendered and scroll is not disabled by "notScroll" option

          if (!options.notScroll && me.isPainted) {
            // and we have centerDate to scroll to
            if (centerDate) {
              // remember the central date we scroll to (it gets reset after user scroll)
              me.cachedCenterDate = centerDate; // setViewPreset method on a partner panels should be executed with same arguments.
              // if one partner was provided with a centerDate, other one has to be too to generate exact
              // header and set same scroll

              event.centerDate = centerDate;
              var viewSize = me.isHorizontal ? me.timeAxisSubGrid.width : me.timeAxisSubGrid.height,
                  coord = Math.max(Math.floor(me.getCoordinateFromDate(centerDate, true) - viewSize / 2), 0);
              me.viewPresetActiveScroll = me.isHorizontal ? {
                left: coord
              } : {
                top: coord
              }; // The horizontal scroll handler must not invalidate the cached center
              // when this scroll event rolls round on the next frame.

              me.scrollingToCenter = true;

              if (me.isHorizontal) {
                me.scrollHorizontallyTo(coord, false);
              } else {
                me.scrollVerticallyTo(coord, false);
              } // Release the lock on scrolling invalidating the cached center.


              me.setTimeout(function () {
                me.scrollingToCenter = false;
              }, 100); // if we don't have a central date to scroll at we reset scroll (this is bw compatible behavior)
            } else {
              if (me.isHorizontal) {
                me.scrollHorizontallyTo(0, false);
              } else {
                me.scrollVerticallyTo(0, false);
              }
            }
          }
        }
        /**
         * Fired after the {@link #config-viewPreset} has changed.
         * @event presetChange
         * @param {Scheduler.view.Scheduler} source This Scheduler instance.
         * @param {Date} startDate The new start date of the timeline.
         * @param {Date} centerDate The new center date of the timeline.
         * @param {Date} endDate The new end date of the timeline.
         * @param {Scheduler.preset.ViewPreset} from The outgoing ViewPreset.
         * @param {Scheduler.preset.ViewPreset} to The ViewPreset being switched to.
         * @preventable
         */


        me.trigger('presetChange', event);
        me._viewPresetChanging = false;
      } //endregion
      // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "presets",
      //endregion

      /**
       * Get/set the current view preset
       * @member {Scheduler.preset.ViewPreset|String} viewPreset
       * @param [viewPreset.options]
       * @param {Date} [viewPreset.options.startDate] A new start date for the time axis
       * @param {Date} [viewPreset.options.endDate] A new end date for the time axis
       * @param {Date} [viewPreset.options.centerDate] Where to center the new time axis
       * @category Common
      */
      //region Get/set

      /**
       * Get the {@link Scheduler.preset.PresetStore PresetStore} created for the Scheduler,
       * or set an array of {@link Scheduler.preset.ViewPreset ViewPreset} config objects.
       * @property {Scheduler.preset.PresetStore|Object[]}
       * @category Common
       */
      set: function set(presets) {
        if (presets === true) {
          presets = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_11__["default"].allRecords;
        }

        this._presets = new _preset_PresetStore_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
          data: presets
        });
      },
      get: function get() {
        return this._presets;
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'TimelineViewPresets';
      } //region Default config

    }, {
      key: "configurable",
      get: function get() {
        return {
          /**
           * A string key used to lookup a predefined {@link Scheduler.preset.ViewPreset} (e.g. 'weekAndDay', 'hourAndDay'),
           * managed by {@link Scheduler.preset.PresetManager}. See {@link Scheduler.preset.PresetManager} for more information.
           * Or a config object for a viewPreset.
           *
           * Options:
           * - 'secondAndMinute'
           * - 'minuteAndHour'
           * - 'hourAndDay'
           * - 'dayAndWeek'
           * - 'weekAndDay'
           * - 'weekAndMonth',
           * - 'monthAndYear'
           * - 'year'
           * - 'manyYears'
           * - 'weekAndDayLetter'
           * - 'weekDateAndMonth'
           * - 'day'
           * - 'week'
           *
           * If passed as a config object, the settings from the viewPreset with the provided `base` property will be used along
           * with any overridden values in your object.
           *
           * To override:
           * ```javascript
           * viewPreset : {
           *   base    : 'hourAndDay',
           *   id      : 'myHourAndDayPreset',
           *   headers : [
           *       {
           *           unit      : "hour",
           *           increment : 12,
           *           renderer  : (startDate, endDate, headerConfig, cellIdx) => {
           *               return "";
           *           }
           *       }
           *   ]
           * }
           * ```
           * or set a new valid preset config if the preset is not registered in the {@link Scheduler.preset.PresetManager}.
           *
           * When you use scheduler in weekview mode, this config is used to pick view preset. If passed view preset is not
           * supported by weekview (only 2 supported by default - 'day' and 'week') default preset will be used - 'week'.
           * @config {String|Object}
           * @default
           * @category Common
           */
          viewPreset: 'weekAndDayLetter'
        };
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * Defines how dates will be formatted in tooltips etc. This config has priority over similar config on the
           * view preset. For allowed values see {@link Core.helper.DateHelper#function-format-static}.
           * @config {String}
           * @category Scheduled events
           */
          displayDateFormat: null,

          /**
           * An array of {@link Scheduler.preset.ViewPreset ViewPreset} config objects
           * which describes the available timeline layouts for this scheduler.
           *
           * By default, a predefined set is loaded from the {@link Scheduler.preset.PresetManager PresetManager}.
           *
           * A {@link Scheduler.preset.ViewPreset ViewPreset} describes the granularity of the
           * timeline view and the layout and subdivisions of the timeline header.
           * @config {Object[]} presets
           *
           * @category Common
           */
          presets: true
        };
      }
    }]);

    return TimelineViewPresets;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/mixin/TimelineZoomable.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/view/mixin/TimelineZoomable.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/view/mixin/TimelineZoomable
 */

/**
 * Mixin providing "zooming" functionality.
 *
 * The zoom levels are stored as instances of {@link Scheduler.preset.ViewPreset ViewPreset}s, and are
 * cached centrally in the {@link Scheduler.preset.PresetManager PresetManager}.
 *
 * The default presets are loaded into the {@link Scheduler.view.mixin.TimelineViewPresets#config-presets}
 * store upon Scheduler instantiation. Preset selection is covered in the
 * {@link Scheduler.view.mixin.TimelineViewPresets TimelineViewPresets} mixin.
 *
 * To specify custom zoom levels please provide a set of view presets to the global PresetManager store **before** scheduler creation,
 * or provide a set of view presets to a specific scheduler only:
 *
 * ```javascript
 * const myScheduler = new Scheduler({
 *     presets : [
 *         {
 *             base : 'hourAndDay',
 *             id   : 'MyHourAndDay',
 *             // other preset configs....
 *         },
 *         {
 *             base : 'weekAndMonth',
 *             id   : 'MyWeekAndMonth',
 *             // other preset configs....
 *         }
 *     ],
 *     viewPreset : 'MyHourAndDay',
 *     // other scheduler configs....
 *     });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(TimelineZoomable, _ref);

    var _super = _createSuper(TimelineZoomable);

    function TimelineZoomable() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, TimelineZoomable);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(TimelineZoomable, [{
      key: "construct",
      value: function construct(config) {
        var me = this;

        _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(TimelineZoomable.prototype), "construct", this).call(this, config);

        if (me.zoomOnMouseWheel) {
          _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
            element: me.timeAxisSubGridElement,
            wheel: 'onWheel',
            // Throttle zooming with the wheel a bit to have greater control of it
            throttled: {
              buffer: 100,
              // Prevent events from slipping through the throttle, causing scroll
              alt: function alt(event) {
                if (event.ctrlKey) {
                  event.preventDefault();
                }
              }
            },
            thisObj: me,
            capture: true,
            passive: false
          });
        }

        if (me.zoomOnTimeAxisDoubleClick) {
          me.on('timeaxisheaderdblclick', function (_ref2) {
            var startDate = _ref2.startDate,
                endDate = _ref2.endDate;

            if (!me.isVertical) {
              me.zoomToSpan({
                startDate: startDate,
                endDate: endDate
              });
            }
          });
        }
      }
    }, {
      key: "getMilliSecondsPerPixelForZoomLevel",

      /*
       * @private
       * Returns number of milliseconds per pixel.
       * @param {Object} level Element from array of {@link Scheduler.view.mixin.TimelineViewPresets#config-presets}.
       * @param {Boolean} ignoreActualWidth If true, then density will be calculated using default zoom level settings.
       * Otherwise density will be calculated for actual tick width.
       * @return {Number} Return number of milliseconds per pixel.
       */
      value: function getMilliSecondsPerPixelForZoomLevel(preset, ignoreActualWidth) {
        var bottomHeader = preset.bottomHeader,
            width = this.isHorizontal ? preset.tickWidth : preset.tickHeight; // trying to convert the unit + increment to a number of milliseconds
        // this number is not fixed (month can be 28, 30 or 31 day), but at least this conversion
        // will be consistent (should be no DST changes at year 1)

        return Math.round((_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].add(new Date(1, 0, 1), bottomHeader.increment || 1, bottomHeader.unit) - new Date(1, 0, 1)) / ( // `actualWidth` is a column width after view adjustments applied to it (see `calculateTickWidth`)
        // we use it if available to return the precise index value from `getCurrentZoomLevelIndex`
        ignoreActualWidth ? width : preset.actualWidth || width));
      }
      /**
       * Zooms to passed view preset, saving center date. Method accepts config object as a first argument, which can be
       * reduced to primitive type (string,number) when no additional options required. e.g.:
       * ```
       * // zooming to preset
       * scheduler.zoomTo({ preset : 'hourAndDay' })
       * // shorthand
       * scheduler.zoomTo('hourAndDay')
       *
       * // zooming to level
       * scheduler.zoomTo({ level : 0 })
       * // shorthand
       * scheduler.zoomTo(0)
       * ```
       *
       * It is also possible to zoom to a time span by omitting `preset` and `level` configs, in which case scheduler sets
       * the time frame to a specified range and applies zoom level which allows to fit all columns to this range. The
       * given time span will be centered in the scheduling view (unless `centerDate` config provided). In the same time,
       * the start/end date of the whole time axis will be extended to allow scrolling for user.
       * ```
       * // zooming to time span
       * scheduler.zoomTo({ startDate : new Date(..), endDate : new Date(...) })
       *
       * ```
       *
       * @param {Object|String|Number} config Config object, preset name or zoom level index.
       * @param {String} config.preset Preset name to zoom to. Ignores level config in this case
       * @param {Number} config.level Zoom level to zoom to. Is ignored, if preset config is provided
       * @param {Date} config.startDate New time frame start. If provided along with end, view will be centered in this time
       * interval (unless `centerDate` is present)
       * @param {Date} config.endDate New time frame end
       * @param {Date} config.centerDate Date that should be kept in the center. Has priority over start and end params
       * @param {Number} config.width Lowest tick width. Might be increased automatically
       * @param {Number} [config.leftMargin] Amount of pixels to extend span start on (used, when zooming to span)
       * @param {Number} [config.rightMargin] Amount of pixels to extend span end on (used, when zooming to span)
       * @param {Number} [config.adjustStart] Amount of units to extend span start on (used, when zooming to span)
       * @param {Number} [config.adjustEnd] Amount of units to extend span end on (used, when zooming to span)
       * @category Zoom
       */

    }, {
      key: "zoomTo",
      value: function zoomTo(config) {
        var me = this;

        if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default()(config) === 'object') {
          if (config.preset) {
            me.zoomToLevel(config.preset, config);
          } else if (config.level != null) {
            me.zoomToLevel(config.level, config);
          } else {
            me.zoomToSpan(config);
          }
        } else {
          me.zoomToLevel(config);
        }
      }
      /**
       * Allows zooming to certain level of {@link Scheduler.view.mixin.TimelineViewPresets#config-presets} array. Automatically limits zooming between {@link #config-maxZoomLevel}
       * and {@link #config-minZoomLevel}. Can also set time axis timespan to the supplied start and end dates.
       *
       * @param {Number} preset Level to zoom to.
       * @param {Object} [options] Object, containing options for this method
       * @param {Date} options.startDate New time frame start. If provided along with end, view will be centered in this time
       * interval, ignoring centerDate config.
       * @param {Date} options.endDate New time frame end.
       * @param {Date} options.centerDate Date that should be kept in center. Is ignored when start and end are provided.
       * @param {Number} options.width Lowest tick width. Might be increased automatically
       * @return {Number} level Current zoom level or null if it hasn't changed.
       * @category Zoom
       */

    }, {
      key: "zoomToLevel",
      value: function zoomToLevel(preset) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        // Sanitize numeric zooming.
        if (typeof preset === 'number') {
          preset = Math.min(Math.max(preset, this.minZoomLevel), this.maxZoomLevel);
        }

        var me = this,
            tickSizeProp = me.isVertical ? 'tickHeight' : 'tickWidth',
            newPreset = me.normalizePreset(preset),
            configuredTickSize = newPreset[tickSizeProp],
            startDate = options.startDate ? new Date(options.startDate) : null,
            endDate = options.endDate ? new Date(options.endDate) : null;
        var span = startDate && endDate ? {
          startDate: startDate,
          endDate: endDate
        } : null;
        var centerDate = options.centerDate || (span ? new Date((startDate.getTime() + endDate.getTime()) / 2) : me.viewportCenterDateCached),
            timeAxisSubGridWidth = me.timeAxisSubGrid.width;

        if (timeAxisSubGridWidth === 0) {
          return null;
        } // Always calculate an optimal date range for the new zoom level


        if (!span) {
          span = me.calculateOptimalDateRange(centerDate, timeAxisSubGridWidth, newPreset);
        } // Temporarily override tick size while reconfiguring the TimeAxisViewModel


        if ('width' in options) {
          newPreset.setData(tickSizeProp, options.width);
        }

        me.isZooming = true; // Passed through to the viewPreset changing method

        newPreset.options = {
          startDate: span.startDate || me.startDate,
          endDate: span.endDate || me.endDate,
          centerDate: centerDate
        };
        me.viewPreset = newPreset; // after switching the view preset the `width` config of the zoom level may change, because of adjustments
        // we will save the real value in the `actualWidth` property, so that `getCurrentZoomLevelIndex` method
        // will return the exact level index after zooming

        newPreset.actualWidth = me.timeAxisViewModel.tickSize;
        me.isZooming = false; // Restore the tick size because the default presets are shared.

        newPreset.setData(tickSizeProp, configuredTickSize);
      }
      /**
       * Changes the range of the scheduling chart to fit all the events in its event store.
       * @param {Object} [options] Options object for the zooming operation.
       * @param {Number} [options.leftMargin] Defines margin in pixel between the first event start date and first visible date
       * @param {Number} [options.rightMargin] Defines margin in pixel between the last event end date and last visible date
       */

    }, {
      key: "zoomToFit",
      value: function zoomToFit(options) {
        var eventStore = this.eventStore,
            span = eventStore.getTotalTimeSpan();
        options = Object.assign({
          leftMargin: 0,
          rightMargin: 0
        }, options, span); // Make sure we received a time span, event store might be empty

        if (options.startDate && options.endDate) {
          this.zoomToSpan(options);
        }
      }
      /**
       * Sets time frame to specified range and applies zoom level which allows to fit all columns to this range.
       *
       * The given time span will be centered in the scheduling view, in the same time, the start/end date of the whole time axis
       * will be extended in the same way as {@link #function-zoomToLevel} method does, to allow scrolling for user.
       *
       * @param {Object} config The time frame.
       * @param {Date} config.startDate The time frame start.
       * @param {Date} config.endDate The time frame end.
       * @param {Date} [config.centerDate] Date that should be kept in the center. Has priority over start and end params
       * @param {Number} [config.leftMargin] Amount of pixels to extend span start on
       * @param {Number} [config.rightMargin] Amount of pixels to extend span end on
       * @param {Number} [config.adjustStart] Amount of units to extend span start on
       * @param {Number} [config.adjustEnd] Amount of units to extend span end on
       *
       * @return {Number} level Current zoom level or null if it hasn't changed.
       * @category Zoom
       */

    }, {
      key: "zoomToSpan",
      value: function zoomToSpan() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (config.leftMargin || config.rightMargin) {
          config.adjustStart = 0;
          config.adjustEnd = 0;
        }

        if (!config.leftMargin) config.leftMargin = 0;
        if (!config.rightMargin) config.rightMargin = 0;
        if (!config.startDate || !config.endDate) throw new Error('zoomToSpan: must provide startDate + endDate dates');
        var me = this,
            // this config enables old zoomToSpan behavior which we want to use for zoomToFit in Gantt
        needToAdjust = config.adjustStart >= 0 || config.adjustEnd >= 0;
        var startDate = config.startDate,
            endDate = config.endDate;

        if (needToAdjust) {
          startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].add(startDate, -config.adjustStart, me.timeAxis.mainUnit);
          endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].add(endDate, config.adjustEnd, me.timeAxis.mainUnit);
        }

        if (startDate <= endDate) {
          // get scheduling view width
          var availableSpace = me.timeAxisViewModel.availableSpace,
              presets = me.presets.allRecords,
              diffMS = endDate - startDate || 1; // if potential width of col is less than col width provided by zoom level
          //   - we'll zoom out panel until col width fit into width from zoom level
          // and if width of column is more than width from zoom level
          //   - we'll zoom in until col width fit won't fit into width from zoom level

          var currLevel = me.zoomLevel,
              inc,
              range; // if we zoomed out even more than the highest zoom level - limit it to the highest zoom level

          if (currLevel === -1) currLevel = 0;
          var msPerPixel = me.getMilliSecondsPerPixelForZoomLevel(presets[currLevel], true),
              // increment to get next zoom level:
          // -1 means that given timespan won't fit the available width in the current zoom level, we need to zoom out,
          // so that more content will "fit" into 1 px
          //
          // +1 mean that given timespan will already fit into available width in the current zoom level, but,
          // perhaps if we'll zoom in a bit more, the fitting will be better
          candidateLevel = currLevel + (inc = diffMS / msPerPixel + config.leftMargin + config.rightMargin > availableSpace ? -1 : 1),
              zoomLevel,
              levelToZoom = null; // loop over zoom levels

          while (candidateLevel >= 0 && candidateLevel <= presets.length - 1) {
            // get zoom level
            zoomLevel = presets[candidateLevel];
            msPerPixel = me.getMilliSecondsPerPixelForZoomLevel(zoomLevel, true);
            var spanWidth = diffMS / msPerPixel + config.leftMargin + config.rightMargin; // if zooming out

            if (inc === -1) {
              // if columns fit into available space, then all is fine, we've found appropriate zoom level
              if (spanWidth <= availableSpace) {
                levelToZoom = candidateLevel; // stop searching

                break;
              } // if zooming in

            } else {
              // if columns still fits into available space, we need to remember the candidate zoom level as a potential
              // resulting zoom level, the indication that we've found correct zoom level will be that timespan won't fit
              // into available view
              if (spanWidth <= availableSpace) {
                // if it's not currently active level
                if (currLevel !== candidateLevel - inc) {
                  // remember this level as applicable
                  levelToZoom = candidateLevel;
                }
              } else {
                // Sanity check to find the following case:
                // If we're already zoomed in at the appropriate level, but the current zoomLevel is "too small" to fit and had to be expanded,
                // there is an edge case where we should actually just stop and use the currently selected zoomLevel
                break;
              }
            }

            candidateLevel += inc;
          } // If we didn't find a large/small enough zoom level, use the lowest/highest level


          levelToZoom = levelToZoom != null ? levelToZoom : candidateLevel - inc; // presets is the array of all ViewPresets this Scheduler is using

          zoomLevel = presets[levelToZoom];
          var unitToZoom = zoomLevel.bottomHeader.unit;

          if (config.leftMargin || config.rightMargin) {
            // time axis doesn't yet know about new view preset (zoom level) so it cannot round/ceil date correctly
            startDate = new Date(startDate.getTime() - msPerPixel * config.leftMargin);
            endDate = new Date(endDate.getTime() + msPerPixel * config.rightMargin);
          }

          var tickCount = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getDurationInUnit(startDate, endDate, unitToZoom, true) / zoomLevel.bottomHeader.increment;

          if (tickCount === 0) {
            return null;
          }

          var customWidth = Math.floor(availableSpace / tickCount),
              centerDate = config.centerDate || new Date((startDate.getTime() + endDate.getTime()) / 2);

          if (needToAdjust) {
            range = {
              startDate: startDate,
              endDate: endDate
            };
          } else {
            range = me.calculateOptimalDateRange(centerDate, availableSpace, zoomLevel);
          }

          return me.zoomToLevel(levelToZoom, Object.assign(range, {
            width: customWidth,
            centerDate: centerDate
          }));
        }

        return null;
      }
      /**
       * Zooms in the timeline according to the array of zoom levels. If the amount of levels to zoom is given, the view will zoom in by this value.
       * Otherwise a value of `1` will be used.
       *
       * @param {Number} levels (optional) amount of levels to zoom in
       *
       * @return {Number} currentLevel New zoom level of the panel or null if level hasn't changed.
       * @category Zoom
       */

    }, {
      key: "zoomIn",
      value: function zoomIn() {
        var levels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var currentZoomLevelIndex = this.zoomLevel;
        if (currentZoomLevelIndex >= this.maxZoomLevel) return null;
        return this.zoomToLevel(currentZoomLevelIndex + levels);
      }
      /**
       * Zooms out the timeline according to the array of zoom levels. If the amount of levels to zoom is given, the view will zoom out by this value.
       * Otherwise a value of `1` will be used.
       *
       * @param {Number} levels (optional) amount of levels to zoom out
       *
       * @return {Number} currentLevel New zoom level of the panel or null if level hasn't changed.
       * @category Zoom
       */

    }, {
      key: "zoomOut",
      value: function zoomOut() {
        var levels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var currentZoomLevelIndex = this.zoomLevel;
        if (currentZoomLevelIndex <= this.minZoomLevel) return null;
        return this.zoomToLevel(currentZoomLevelIndex - levels);
      }
      /**
       * Zooms in the timeline to the {@link #config-maxZoomLevel} according to the array of zoom levels.
       *
       * @return {Number} currentLevel New zoom level of the panel or null if level hasn't changed.
       * @category Zoom
       */

    }, {
      key: "zoomInFull",
      value: function zoomInFull() {
        return this.zoomToLevel(this.maxZoomLevel);
      }
      /**
       * Zooms out the timeline to the {@link #config-minZoomLevel} according to the array of zoom levels.
       *
       * @return {Number} currentLevel New zoom level of the panel or null if level hasn't changed.
       * @category Zoom
       */

    }, {
      key: "zoomOutFull",
      value: function zoomOutFull() {
        return this.zoomToLevel(this.minZoomLevel);
      }
      /*
       * Adjusts the timespan of the panel to the new zoom level. Used for performance reasons,
       * as rendering too many columns takes noticeable amount of time so their number is limited.
       * @category Zoom
       * @private
       */

    }, {
      key: "calculateOptimalDateRange",
      value: function calculateOptimalDateRange(centerDate, panelSize, viewPreset, userProvidedSpan) {
        // this line allows us to always use the `calculateOptimalDateRange` method when calculating date range for zooming
        // (even in case when user has provided own interval)
        // other methods may override/hook into `calculateOptimalDateRange` to insert own processing
        // (infinite scrolling feature does)
        if (userProvidedSpan) return userProvidedSpan;
        var me = this,
            timeAxis = me.timeAxis,
            bottomHeader = viewPreset.bottomHeader,
            tickWidth = me.isHorizontal ? viewPreset.tickWidth : viewPreset.tickHeight;

        if (me.zoomKeepsOriginalTimespan) {
          return {
            startDate: timeAxis.startDate,
            endDate: timeAxis.endDate
          };
        }

        var unit = bottomHeader.unit,
            difference = Math.ceil(panelSize / tickWidth * bottomHeader.increment * me.visibleZoomFactor / 2),
            startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].add(centerDate, -difference, unit),
            endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].add(centerDate, difference, unit);
        return {
          startDate: timeAxis.floorDate(startDate, false, unit, bottomHeader.increment),
          endDate: timeAxis.ceilDate(endDate, false, unit, bottomHeader.increment)
        };
      }
    }, {
      key: "onWheel",
      value: function onWheel(event) {
        var me = this;

        if (event.ctrlKey) {
          event.preventDefault();

          if (!me.preventScrollZoom) {
            if (event.deltaY > 0) {
              me.zoomOut();
            } else if (event.deltaY < 0) {
              me.zoomIn();
            }

            me.preventScrollZoom = true;
            me.setTimeout(function () {
              return me.preventScrollZoom = false;
            }, 30);
          }
        }
      }
      /**
       * Changes the time axis timespan to the supplied start and end dates.
       * @param {Date} startDate The new start date
       * @param {Date} endDate The new end date. If not supplied, the {@link Scheduler.preset.ViewPreset#field-defaultSpan} property of the current view preset will be used to calculate the new end date.
       */

    }, {
      key: "setTimeSpan",
      value: function setTimeSpan(startDate, endDate) {
        this.timeAxis.setTimeSpan(startDate, endDate);
      }
      /**
       * Moves the time axis by the passed amount and unit.
       *
       * NOTE: If using a filtered time axis, see {@link Scheduler.data.TimeAxis#function-shift} for more information.
       *
       * @param {Number} amount The number of units to jump
       * @param {String} [unit] The unit (Day, Week etc)
       */

    }, {
      key: "shift",
      value: function shift(amount, unit) {
        this.timeAxis.shift(amount, unit);
      }
      /**
       * Moves the time axis forward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement`
       * config of the current view preset.
       *
       * NOTE: If using a filtered time axis, see {@link Scheduler.data.TimeAxis#function-shiftNext} for more information.
       *
       * @param {Number} [amount] The number of units to jump forward
       */

    }, {
      key: "shiftNext",
      value: function shiftNext(amount) {
        this.timeAxis.shiftNext(amount);
      }
      /**
       * Moves the time axis backward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement` config of the current view preset.
       *
       * NOTE: If using a filtered time axis, see {@link Scheduler.data.TimeAxis#function-shiftPrevious} for more information.
       *
       * @param {Number} [amount] The number of units to jump backward
       */

    }, {
      key: "shiftPrevious",
      value: function shiftPrevious(amount) {
        this.timeAxis.shiftPrevious(amount);
      } // This does not need a className on Widgets.
      // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
      // to the Widget it's mixed in to should implement thus.

    }, {
      key: "maxZoomLevel",
      get: function get() {
        return this._maxZoomLevel || this.presets.count - 1;
      }
      /**
       * Get/set the {@link #config-maxZoomLevel} value
       * @property {Number}
       * @category Zoom
       */
      ,
      set: function set(level) {
        if (typeof level !== 'number') {
          level = this.presets.count - 1;
        }

        if (level < 0 || level >= this.presets.count) {
          throw new Error('Invalid range for `maxZoomLevel`');
        }

        this._maxZoomLevel = level;
      }
    }, {
      key: "minZoomLevel",
      get: function get() {
        return this._minZoomLevel || 0;
      }
      /**
       * Sets the {@link #config-minZoomLevel} value
       * @property {Number}
       * @category Zoom
       */
      ,
      set: function set(level) {
        if (typeof level !== 'number') {
          level = 0;
        }

        if (level < 0 || level >= this.presets.count) {
          throw new Error('Invalid range for `minZoomLevel`');
        }

        this._minZoomLevel = level;
      }
      /**
       * Current zoom level, which is equal to the {@link Scheduler.preset.ViewPreset ViewPreset} index
       * in the provided array of {@link Scheduler.view.mixin.TimelineViewPresets#config-presets zoom levels}.
       * @property {Number}
       * @category Zoom
       */

    }, {
      key: "zoomLevel",
      get: function get() {
        return this.presets.indexOf(this.viewPreset);
      } // noinspection JSAnnotator
      ,
      set: function set(level) {
        this.zoomToLevel(level);
      }
    }, {
      key: "widgetClass",
      get: function get() {}
    }], [{
      key: "$name",
      get: function get() {
        return 'TimelineZoomable';
      }
    }, {
      key: "defaultConfig",
      get: function get() {
        return {
          /**
           * If true, you can zoom in and out on the the time axis using CTRL-key + mouse wheel.
           * @config {Boolean}
           * @default
           * @category Zoom
           */
          zoomOnMouseWheel: true,

          /**
           * True to zoom to time span when double clicking a time axis cell.
           * @config {Boolean}
           * @default
           * @category Zoom
           */
          zoomOnTimeAxisDoubleClick: true,
          preventScrollZoom: null,

          /**
           * Minimal zoom level to which {@link #function-zoomOut} will work
           * @config {Number}
           * @category Zoom
           */
          minZoomLevel: null,

          /**
           * Maximal zoom level to which {@link #function-zoomIn} will work
           * @config {Number}
           * @category Zoom
           */
          maxZoomLevel: null,

          /**
           * Integer number indicating the size of timespan during zooming. When zooming, the timespan is adjusted to make the scrolling area `visibleZoomFactor` times
           * wider than the timeline area itself. Used in {@link #function-zoomToSpan} and {@link #function-zoomToLevel} functions.
           * @config {Number}
           * @default
           * @category Zoom
           */
          visibleZoomFactor: 5,

          /**
           * Whether the originally rendered timespan should be preserved while zooming. By default it is set to `false`,
           * meaning the timeline panel will adjust the currently rendered timespan to limit the amount of HTML content to render. When setting this option
           * to `true`, be careful not to allow to zoom a big timespan in seconds resolution for example. That will cause **a lot** of HTML content
           * to be rendered and affect performance. You can use {@link #config-minZoomLevel} and {@link #config-maxZoomLevel} config options for that.
           * @config {Boolean}
           * @default
           * @category Zoom
           */
          zoomKeepsOriginalTimespan: null
        };
      }
    }]);

    return TimelineZoomable;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/model/TimeAxisViewModel.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/view/model/TimeAxisViewModel.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeAxisViewModel; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.assign */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../preset/PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");
/* harmony import */ var _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../preset/ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony import */ var _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../data/TimeAxis.js */ "./lib/Scheduler/data/TimeAxis.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';





/**
 * @module Scheduler/view/model/TimeAxisViewModel
 */

/**
 * This class is an internal view model class, describing the visual representation of a {@link Scheduler.data.TimeAxis}.
 * The config for the header rows is described in the {@link Scheduler.preset.ViewPreset#field-headers headers}.
 * To calculate the size of each cell in the time axis, this class requires:
 *
 * - availableSpace  - The total width or height available for the rendering
 * - tickSize       - The fixed width or height of each cell in the lowest header row. This value is normally read from the
 * {@link Scheduler.preset.ViewPreset viewPreset} but this can also be updated programmatically using the {@link #property-tickSize} setter
 *
 * Normally you should not interact with this class directly.
 *
 * @extends Core/mixin/Events
 */

var TimeAxisViewModel = /*#__PURE__*/function (_Events) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(TimeAxisViewModel, _Events);

  var _super = _createSuper(TimeAxisViewModel);

  function TimeAxisViewModel() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, TimeAxisViewModel);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(TimeAxisViewModel, [{
    key: "construct",
    //endregion
    //region Init & destroy
    value: function construct(config) {
      var me = this; // getSingleUnitInPixels results are memoized because of frequent calls during rendering.

      me.unitToPixelsCache = {};

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(TimeAxisViewModel.prototype), "construct", this).call(this, config);

      var viewPreset = me.timeAxis.viewPreset || me.viewPreset;

      if (viewPreset) {
        if (viewPreset instanceof _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_15__["default"]) {
          me.consumeViewPreset(viewPreset);
        } else {
          var preset = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].getPreset(viewPreset);
          preset && me.consumeViewPreset(preset);
        }
      } // When time axis is changed, reconfigure the model


      me.timeAxis.on('reconfigure', me.onTimeAxisReconfigure, me);
      me.configured = true;
    }
  }, {
    key: "doDestroy",
    value: function doDestroy() {
      this.timeAxis.un('reconfigure', this.onTimeAxisReconfigure, this);
    }
    /**
     * Returns an array representing the headers of the current timeAxis. Each element is an array representing the cells for that level in the header.
     * @return {Object[]} An array of headers, each element being an array representing each cell (with start date and end date) in the timeline representation.
     * @internal
     */

  }, {
    key: "reconfigure",
    //endregion
    //region Reconfigure & update
    value: function reconfigure(config) {
      // clear the cached headers
      var me = this;
      me.headers = null; // Ensure correct ordering

      me.setConfig(config);
      me.trigger('reconfigure');
    }
  }, {
    key: "onTimeAxisReconfigure",
    value: function onTimeAxisReconfigure(_ref) {
      var timeAxis = _ref.source,
          suppressRefresh = _ref.suppressRefresh;

      if (this.viewPreset !== timeAxis.viewPreset) {
        this.consumeViewPreset(timeAxis.viewPreset);
      }

      if (!suppressRefresh) {
        this.update();
      }
    }
    /**
     * Updates the view model current timeAxis configuration and available space.
     * @param {Number} [availableSpace] The available space for the rendering of the axis (used in forceFit mode)
     * @param {Boolean} [silent] Pass `true` to suppress the firing of the `update` event.
     * @param {Boolean} [forceUpdate] Pass `true` to fire the `update` event even if the size has not changed.
     * @internal
     */

  }, {
    key: "update",
    value: function update(availableSpace) {
      var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          timeAxis = me.timeAxis,
          headers = me.headers; // We're in configuration, or no change, quit

      if (me.isConfiguring || me._availableSpace === availableSpace) {
        if (forceUpdate) {
          me.trigger('update');
        }

        return;
      }

      me._availableSpace = Math.max(availableSpace || me.availableSpace || 0, 0);

      if (typeof me.availableSpace !== 'number') {
        throw new Error('Invalid available space provided to TimeAxisModel');
      }

      me.columnConfig = []; // The "column width" is considered to be the width of each tick in the lowest header row and this width
      // has to be same for all cells in the lowest row.

      var tickSize = me._tickSize = me.calculateTickSize(me.originalTickSize);

      if (typeof tickSize !== 'number' || tickSize <= 0) {
        throw new Error('Invalid timeAxis tick size');
      } // getSingleUnitInPixels results are memoized because of frequent calls during rendering.


      me.unitToPixelsCache = {}; // totalSize is cached because of frequent calls which calculate it.

      me._totalSize = null; // Generate the underlying date ranges for each header row, which will provide input to the cell rendering

      for (var pos = 0, length = headers.length; pos < length; pos++) {
        var header = headers[pos];

        if (header.cellGenerator) {
          var headerCells = header.cellGenerator.call(me, timeAxis.startDate, timeAxis.endDate);
          me.columnConfig[pos] = me.createHeaderRow(pos, header, headerCells);
        } else {
          me.columnConfig[pos] = me.createHeaderRow(pos, header);
        }
      }

      if (!silent) {
        me.trigger('update');
      }
    } //endregion
    //region CalendarColumn
    // /**
    //  * Will update columns start/end dates to perform date/coordinate lookups
    //  * @param {Object[]} columns Array of column configs including start/end dates
    //  * @private
    //  */
    // updateCalendarColumnDates(columns) {
    //     this.calendarColumnDates = [];
    //
    //     for (let i = 0; i < columns.length; i++) {
    //         let obj = columns[i];
    //         this.calendarColumnDates.push([obj.start, obj.end]);
    //     }
    // }
    // // TODO: make getter
    // /**
    //  * Returns current column start/end dates array
    //  * @returns {Date[]}
    //  * @private
    //  */
    // getCalendarColumnDates() {
    //     return this.calendarColumnDates;
    // }
    //endregion
    //region Date / position mapping

    /**
     * Returns the distance in pixels for a timespan with the given start and end date.
     * @param {Date} start start date
     * @param {Date} end end date
     * @return {Number} The length of the time span
     * @category Date mapping
     */

  }, {
    key: "getDistanceBetweenDates",
    value: function getDistanceBetweenDates(start, end) {
      return Math.round(this.getPositionFromDate(end) - this.getPositionFromDate(start));
    }
    /**
     * Returns the distance in pixels for a time span
     * @param {Number} durationMS Time span duration in ms
     * @return {Number} The length of the time span
     * @category Date mapping
     */

  }, {
    key: "getDistanceForDuration",
    value: function getDistanceForDuration(durationMs) {
      var me = this,
          tick = this.timeAxis.getAt(0),
          pxPerMs = me.tickSize / (tick.endDate - tick.startDate);
      return pxPerMs * durationMs;
    }
    /**
     * Gets the position of a date on the projected time axis or -1 if the date is not in the timeAxis.
     * @param {Date} date the date to query for.
     * @returns {Number} the coordinate representing the date
     * @category Date mapping
     */

  }, {
    key: "getPositionFromDate",
    value: function getPositionFromDate(date) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var me = this,
          tick = me.getScaledTick(date, options);

      if (tick === -1) {
        return -1;
      }

      return Math.round(me.tickSize * (tick - me.timeAxis.visibleTickStart));
    } // Translates a tick along the time axis to facilitate scaling events when excluding certain days or hours

  }, {
    key: "getScaledTick",
    value: function getScaledTick(date, _ref2) {
      var respectExclusion = _ref2.respectExclusion,
          snapToNextIncluded = _ref2.snapToNextIncluded,
          isEnd = _ref2.isEnd,
          min = _ref2.min,
          max = _ref2.max;
      var timeAxis = this.timeAxis,
          include = timeAxis.include,
          unit = timeAxis.unit;
      var tick = timeAxis.getTickFromDate(date);

      if (tick !== -1 && respectExclusion && include) {
        var tickChanged = false; // Stretch if we are using a larger unit than 'hour', except if it is 'day'. If so, it is already handled
        // by a cheaper reconfiguration of the ticks in `generateTicks`

        if (include.hour && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].compareUnits(unit, 'hour') > 0 && unit !== 'day') {
          var _include$hour = include.hour,
              from = _include$hour.from,
              to = _include$hour.to,
              lengthFactor = _include$hour.lengthFactor,
              center = _include$hour.center,
              originalHours = date.getHours(),
              croppedHours = Math.min(Math.max(originalHours, from), to); // If we are not asked to snap (when other part of span is not included) any cropped away hour
          // should be considered excluded

          if (!snapToNextIncluded && croppedHours !== originalHours) {
            return -1;
          }

          var // Should scale hour and smaller units (seconds will hardly affect visible result...)
          fractionalHours = croppedHours + date.getMinutes() / 60,
              // Number of hours from the center    |xxxx|123c----|xxx|
          hoursFromCenter = center - fractionalHours,
              // Step from center to stretch event  |x|112233c----|xxx|
          newHours = center - hoursFromCenter * lengthFactor; // Adding instead of setting to get a clone of the date, to not affect the original

          date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(date, newHours - originalHours, 'h');
          tickChanged = true;
        }

        if (include.day && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].compareUnits(unit, 'day') > 0) {
          var _include$day = include.day,
              _from = _include$day.from,
              _to = _include$day.to,
              _lengthFactor = _include$day.lengthFactor,
              _center = _include$day.center; //region Crop

          var checkDay = date.getDay(); // End date is exclusive, check the day before if at 00:00

          if (isEnd && date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0 && date.getMilliseconds() === 0) {
            if (--checkDay < 0) {
              checkDay = 6;
            }
          }

          var addDays = 0;

          if (checkDay < _from || checkDay >= _to) {
            // If end date is in view but start date is excluded, snap to next included day
            if (snapToNextIncluded) {
              // Step back to "to-1" (not inclusive) for end date
              if (isEnd) {
                addDays = (_to - checkDay - 8) % 7;
              } // Step forward to "from" for start date
              else {
                  addDays = (_from - checkDay + 7) % 7;
                }

              date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(date, addDays, 'd');
              date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].startOf(date, 'd', false); // Keep end after start and vice versa

              if (max && date.getTime() >= max || min && date.getTime() <= min) {
                return -1;
              }
            } else {
              // day excluded at not snapping to next
              return -1;
            }
          } //endregion


          var weekStartDay = timeAxis.weekStartDay,
              fixedCenter = date.getDay() === 0 ? 0 : _center,
              fractionalDay = date.getDay() + date.getHours() / 24,
              daysFromCenter = fixedCenter - fractionalDay,
              newDay = fixedCenter - daysFromCenter * _lengthFactor; // Adding instead of setting to get a clone of the date, to not affect the original

          date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(date, newDay - fractionalDay + weekStartDay, 'd');
          tickChanged = true;
        } // Now the date might start somewhere else (fraction of ticks)


        if (tickChanged) {
          // When stretching date might end up outside of time axis, making it invalid to use. Clip it to time axis
          // to circumvent this
          date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].constrain(date, timeAxis.startDate, timeAxis.endDate); // Get a new tick based on the "scaled" date

          tick = timeAxis.getTickFromDate(date);
        }
      }

      return tick;
    }
    /**
     * Gets the date for a position on the time axis
     * @param {Number} position The page X or Y coordinate
     * @param {String} [roundingMethod] The rounding method to use
     * @param {Boolean} [allowOutOfRange=false] By default, this returns `null` if the position is outside
     * of the time axis. Pass `true` to attempt to calculate a date outside of the time axis.
     * @returns {Date} the Date corresponding to the xy coordinate
     * @category Date mapping
     */

  }, {
    key: "getDateFromPosition",
    value: function getDateFromPosition(position, roundingMethod) {
      var allowOutOfRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          timeAxis = me.timeAxis,
          tick = me.getScaledPosition(position) / me.tickSize + timeAxis.visibleTickStart;

      if (tick < 0 || tick > timeAxis.count) {
        if (allowOutOfRange) {
          // Subtract the correct number of tick units from the start date
          if (tick < 0) {
            return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(timeAxis.startDate, tick, timeAxis.unit);
          } // Add the correct number of tick units to the end date


          return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(timeAxis.endDate, tick - timeAxis.count, timeAxis.unit);
        }

        return null;
      }

      return timeAxis.getDateFromTick(tick, roundingMethod);
    } // Translates a position along the time axis to facilitate scaling events when excluding certain days or hours

  }, {
    key: "getScaledPosition",
    value: function getScaledPosition(position) {
      var _this$timeAxis = this.timeAxis,
          include = _this$timeAxis.include,
          unit = _this$timeAxis.unit,
          weekStartDay = _this$timeAxis.weekStartDay; // Calculations are

      if (include) {
        var dayWidth = this.getSingleUnitInPixels('day'); // Have to calculate day before hour to get end result correct

        if (include.day && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].compareUnits(unit, 'day') > 0) {
          var _include$day2 = include.day,
              from = _include$day2.from,
              lengthFactor = _include$day2.lengthFactor,
              positionInWeek = position % (dayWidth * 7),
              weekStartPosition = position - positionInWeek; // Scale position using calculated length per day factor, adding the width of excluded days

          position = positionInWeek / lengthFactor + (from - weekStartDay) * dayWidth + weekStartPosition;
        } // Hours are not taken into account when viewing days, since the day ticks are reconfigured in
        // `generateTicks` instead


        if (include.hour && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].compareUnits(unit, 'hour') > 0 && unit !== 'day') {
          var _include$hour2 = include.hour,
              _from2 = _include$hour2.from,
              lengthFactorExcl = _include$hour2.lengthFactorExcl,
              hourWidth = this.getSingleUnitInPixels('hour'),
              positionInDay = position % dayWidth,
              dayStartPosition = position - positionInDay; // Scale position using calculated length per day factor, adding the width of excluded hours

          position = positionInDay / lengthFactorExcl + _from2 * hourWidth + dayStartPosition;
        }
      }

      return position;
    }
    /**
     * Returns the amount of pixels for a single unit
     * @internal
     * @return {Number} The unit in pixel
     */

  }, {
    key: "getSingleUnitInPixels",
    value: function getSingleUnitInPixels(unit) {
      var me = this;
      return me.unitToPixelsCache[unit] || (me.unitToPixelsCache[unit] = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getUnitToBaseUnitRatio(me.timeAxis.unit, unit, true) * me.tickSize / me.timeAxis.increment);
    }
    /**
     * [Experimental] Returns the pixel increment for the current view resolution.
     * @internal
     * @return {Number} The increment
     */

  }, {
    key: "setTickSize",
    value: function setTickSize(size, suppressEvent) {
      this._tickSize = this.originalTickSize = size;
      this.update(undefined, suppressEvent);
    }
  }, {
    key: "calculateTickSize",
    // Calculates the time column width/height based on the value defined viewPreset "tickWidth/tickHeight". It also
    // checks for the forceFit view option and the snap, both of which impose constraints on the time column width
    // configuration.
    value: function calculateTickSize(proposedSize) {
      var me = this,
          forceFit = me.forceFit,
          timeAxis = me.timeAxis,
          suppressFit = me.suppressFit,
          timelineUnit = timeAxis.unit;
      var size = 0,
          ratio = 1; //Number.MAX_VALUE;

      if (me.snap) {
        var resolution = timeAxis.resolution;
        ratio = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getUnitToBaseUnitRatio(timelineUnit, resolution.unit) * resolution.increment;
      } // else {
      //     const measuringUnit = DH.getMeasuringUnit(timelineUnit);
      //     Math.min(ratio, DH.getUnitToBaseUnitRatio(timelineUnit, measuringUnit));
      // }


      if (!suppressFit) {
        var ticks = timeAxis.visibleTickTimeSpan,
            // TODO: change this to always floor if we want to prevent scheduler scroll when not really needed
        fittingSize = Math[forceFit ? 'floor' : 'round'](me.availableSpace / ticks);
        size = forceFit || proposedSize < fittingSize ? fittingSize : proposedSize;

        if (ratio > 0 && (!forceFit || ratio < 1)) {
          // For touch, make sure we always fill the available space with forceFit (to not show edges of side-time-pickers)
          var method = forceFit ? 'floor' : 'round';
          size = Math.round(Math.max(1, Math[method](ratio * size)) / ratio);
        }
      } else {
        size = proposedSize;
      }

      return size;
    }
    /**
     * Returns the total width/height of the time axis representation, depending on mode.
     * @return {Number} The width or height
     * @internal
     * @readonly
     */

  }, {
    key: "getDates",
    //endregion
    //region Fitting & snapping

    /**
     * Returns start dates for ticks at the specified level in format { date, isMajor }.
     * @param {Number} level Level in headers array, `0` meaning the topmost...
     * @param {Boolean} useLowestHeader Use lowest level
     * @param getEnd
     * @returns {Array}
     * @internal
     */
    value: function getDates() {
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.columnLinesFor;
      var useLowestHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var getEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          ticks = [],
          linesForLevel = useLowestHeader ? me.lowestHeader : level,
          majorLevel = me.majorHeaderLevel,
          levelUnit = me.headers && me.headers[level].unit,
          majorUnit = majorLevel != null && me.headers && me.headers[majorLevel].unit,
          validMajor = majorLevel != null && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].doesUnitsAlign(majorUnit, levelUnit),
          hasGenerator = !!(me.headers && me.headers[linesForLevel].cellGenerator);

      if (hasGenerator) {
        var cells = me.columnConfig[linesForLevel];

        for (var i = 1, l = cells.length; i < l; i++) {
          ticks.push({
            date: cells[i].startDate
          });
        }
      } else {
        me.forEachInterval(linesForLevel, function (start, end) {
          ticks.push({
            date: getEnd ? end : start,
            // do not want to consider tick to be major tick, hence the check for majorHeaderLevel
            isMajor: majorLevel !== level && validMajor && me.isMajorTick(getEnd ? end : start)
          });
        });
      }

      return ticks;
    }
  }, {
    key: "fitToAvailableSpace",

    /**
     * This function fits the time columns into the available space in the time axis column.
     * @param {Boolean} suppressEvent `true` to skip firing the 'update' event.
     * @internal
     */
    value: function fitToAvailableSpace(suppressEvent) {
      var proposedSize = Math.floor(this.availableSpace / this.timeAxis.visibleTickTimeSpan);
      this.setTickSize(proposedSize, suppressEvent);
    }
  }, {
    key: "createHeaderRow",
    //endregion
    //region Headers
    // private
    value: function createHeaderRow(position, headerRowConfig, headerCells) {
      var _this = this;

      var me = this,
          cells = [],
          align = headerRowConfig.align,
          today = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(new Date()),
          headerCellCls = headerRowConfig.headerCellCls || '',
          createCellContext = function createCellContext(start, end, i, data) {
        var value = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].format(start, headerRowConfig.dateFormat);
        var cellData = {
          align: align,
          start: start,
          end: end,
          value: data ? data.header : value,
          headerCellCls: headerCellCls,
          width: _this.getDistanceBetweenDates(start, end),
          index: i
        };

        if (cellData.width === 0) {
          return;
        } // Vertical mode uses absolute positioning for header cells


        cellData.coord = size;
        size += cellData.width;
        me.headersDatesCache[position][start.getTime()] = 1;

        if (headerRowConfig.renderer) {
          value = headerRowConfig.renderer.call(headerRowConfig.thisObj || me, start, end, cellData, i, me.eventStore);
          cellData.value = value == null ? '' : value;
        } // To be able to style individual day cells, weekends or other important days


        if (headerRowConfig.unit === 'day' && (!headerRowConfig.increment || headerRowConfig.increment === 1)) {
          cellData.headerCellCls += ' b-sch-dayheadercell-' + start.getDay();

          if (me.calendar && me.calendar.isWeekend(start)) {
            cellData.headerCellCls += ' b-sch-dayheadercell-nonworking';
          }

          if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(start, true) - today === 0) {
            cellData.headerCellCls += ' b-sch-dayheadercell-today';
          }
        }

        cells.push(cellData);
      };

      var size = 0;
      me.headersDatesCache[position] = {};

      if (headerCells) {
        headerCells.forEach(function (cellData, i) {
          return createCellContext(cellData.start, cellData.end, i, cellData);
        });
      } else {
        me.forEachInterval(position, createCellContext);
      }

      return cells;
    }
  }, {
    key: "isMajorTick",
    //endregion
    //region Ticks

    /**
     * For vertical view (and column lines plugin) we sometimes want to know if current tick starts along with the
     * upper header level.
     * @param {Date} date
     * @return {Boolean}
     * @private
     */
    value: function isMajorTick(date) {
      var nextLevel = this.majorHeaderLevel; // if forceFit is used headersDatesCache won´t have been generated yet on the first call here,
      // since no size is set yet

      return nextLevel != null && this.headersDatesCache[nextLevel] && this.headersDatesCache[nextLevel][date.getTime()] || false;
    }
    /**
     * Calls the supplied iterator function once per interval. The function will be called with three parameters, start date and end date and an index.
     * Return false to break the iteration.
     * @param {Number} position The index of the header in the headers array.
     * @param {Function} iteratorFn The function to call, will be called with start date, end date and "tick index"
     * @param {Object} [thisObj] `this` reference for the function
     * @internal
     */

  }, {
    key: "forEachInterval",
    value: function forEachInterval(position, iteratorFn) {
      var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
      var headers = this.headers;

      if (headers) {
        // This is the lowest header row, which should be fed the data in the tickStore (or a row above using same unit)
        if (position === headers.length - 1) {
          this.timeAxis.forEach(function (r, index) {
            return iteratorFn.call(thisObj, r.startDate, r.endDate, index);
          });
        } // All other rows
        else {
            var header = headers[position];
            this.timeAxis.forEachAuxInterval(header.unit, header.increment, iteratorFn, thisObj);
          }
      }
    }
    /**
     * Calls the supplied iterator function once per interval. The function will be called with three parameters, start date and end date and an index.
     * Return false to break the iteration.
     * @internal
     * @param {Function} iteratorFn The function to call
     * @param {Object} [thisObj] `this` reference for the function
     */

  }, {
    key: "forEachMainInterval",
    value: function forEachMainInterval(iteratorFn, thisObj) {
      this.forEachInterval(this.mainHeaderLevel, iteratorFn, thisObj);
    } //endregion
    //region ViewPreset

  }, {
    key: "consumeViewPreset",
    value: function consumeViewPreset(preset) {
      var me = this; // clear the cached headers

      me.headers = null;

      me._thisIsAUsedExpression(me.tickSize); // Since we are bypassing the tickSize setter below, ensure that
      // the config initial setter has been removed by referencing the property.
      // We only do this to avoid multiple updates from this. TODO: Fix this issue,
      // and do not bypass setters.


      me.viewPreset = preset;
      Object.assign(me, {
        headers: preset.headers,
        columnLinesFor: preset.columnLinesFor,
        mainHeaderLevel: preset.mainHeaderLevel,
        _tickSize: me.isHorizontal ? preset.tickWidth : preset.tickHeight
      });
      me.originalTickSize = me.tickSize;
    } //endregion
    // //region Calendar
    //
    // setCalendar(cal) {
    //     if (cal !== this.calendar) {
    //         this.calendar = cal;
    //
    //         if (cal) {
    //             this.update();
    //         }
    //     }
    // }
    //
    // //endregion

  }, {
    key: "columnConfig",
    get: function get() {
      return this._columnConfig;
    },
    set: function set(config) {
      this._columnConfig = config;
    }
  }, {
    key: "headers",
    get: function get() {
      return this._headers;
    },
    set: function set(headers) {
      if (headers && headers.length && headers[headers.length - 1].cellGenerator) {
        throw new Error('`cellGenerator` cannot be used for the bottom level of your headers. Use TimeAxis#generateTicks() instead.');
      }

      this._headers = headers;
    }
  }, {
    key: "isTimeAxisViewModel",
    get: function get() {
      return true;
    } //endregion
    //region Events

    /**
     * Fires after the model has been updated.
     * @event update
     * @param {Scheduler.view.model.TimeAxisViewModel} source The model instance
     */

    /**
     * Fires after the model has been reconfigured.
     * @event reconfigure
     * @param {Scheduler.view.model.TimeAxisViewModel} source The model instance
     */
    //endregion
    //region Mode

    /**
     * Using horizontal mode?
     * @returns {Boolean}
     * @readonly
     * @internal
     */

  }, {
    key: "isHorizontal",
    get: function get() {
      return this.mode !== 'vertical';
    }
    /**
     * Using vertical mode?
     * @returns {Boolean}
     * @readonly
     * @internal
     */

  }, {
    key: "isVertical",
    get: function get() {
      return this.mode === 'vertical';
    }
    /**
     * Gets/sets the forceFit value for the model. Setting it will cause it to update its contents and fire the
     * {@link #event-update} event.
     * @property {Boolean}
     * @internal
     */

  }, {
    key: "forceFit",
    set: function set(value) {
      if (value !== this._forceFit) {
        this._forceFit = value;
        this.update();
      }
    },
    get: function get() {
      return this._forceFit;
    }
  }, {
    key: "snapPixelAmount",
    get: function get() {
      if (this.snap) {
        var resolution = this.timeAxis.resolution;
        return (resolution.increment || 1) * this.getSingleUnitInPixels(resolution.unit);
      } else {
        return 1;
      }
    } //endregion
    //region Sizes

    /**
     * Get/set the current time column size (the width or height of a cell in the bottom-most time axis header row,
     * depending on mode)
     * @internal
     * @property {Number}
     */

  }, {
    key: "tickSize",
    get: function get() {
      return this._tickSize;
    },
    set: function set(size) {
      this.setTickSize(size, false);
    }
  }, {
    key: "timeResolution",
    get: function get() {
      return this.timeAxis.resolution;
    }
  }, {
    key: "totalSize",
    get: function get() {
      return this._totalSize || (this._totalSize = Math.round(this.tickSize * this.timeAxis.visibleTickTimeSpan));
    }
    /**
     * Get/set the available space for the time axis representation. If size changes it will cause it to update its
     * contents and fire the {@link #event-update} event.
     * @internal
     * @property {Number}
     */

  }, {
    key: "availableSpace",
    get: function get() {
      return this._availableSpace;
    },
    set: function set(space) {
      var me = this; // We should only need to repaint fully if the tick width has changed (which will happen if forceFit is set, or if the full size of the time axis doesn't
      // occupy the available space - and gets stretched

      me._availableSpace = Math.max(0, space);

      if (me._availableSpace > 0) {
        var newTickSize = me.calculateTickSize(me.originalTickSize);

        if (newTickSize > 0 && newTickSize !== me.tickSize) {
          me.update();
        }
      }
    }
  }, {
    key: "snap",
    get: function get() {
      return this._snap;
    }
    /**
     * Gets/sets the snap value for the model. Setting it will cause it to update its contents and fire the
     * {@link #event-update} event.
     * @property {Boolean}
     * @internal
     */
    ,
    set: function set(value) {
      if (value !== this._snap) {
        this._snap = value;
        if (this.configured) this.update();
      }
    }
  }, {
    key: "mainHeader",
    get: function get() {
      return 'mainHeaderLevel' in this ? this.headers[this.mainHeaderLevel] : this.bottomHeader;
    }
  }, {
    key: "bottomHeader",
    get: function get() {
      return this.headers[this.headers.length - 1];
    }
  }, {
    key: "lowestHeader",
    get: function get() {
      return this.headers.length - 1;
    }
    /**
     * This method is meant to return the level of the header which 2nd lowest.
     * It is used for {@link #function-isMajorTick} method
     * @return {String}
     * @private
     */

  }, {
    key: "majorHeaderLevel",
    get: function get() {
      var headers = this.headers;

      if (headers) {
        return Math.max(headers.length - 2, 0);
      }

      return null;
    }
  }], [{
    key: "defaultConfig",
    //region Default config
    // TODO: replace _availableSpace etc with availableSpace in config and make setters work during config phase
    get: function get() {
      return {
        /**
         * The time axis providing the underlying data to be visualized
         * @config {Scheduler.data.TimeAxis}
         * @internal
         */
        timeAxis: null,

        /**
         * The available width/height, this is normally not known by the consuming UI component using this model
         * class until it has been fully rendered. The consumer of this model should set
         * {@link #property-availableSpace} when its width has changed.
         * @config {Number}
         * @internal
         */
        availableSpace: null,

        /**
         * The "tick width" for horizontal mode or "tick height" for vertical mode, to use for the cells in the
         * bottom most header row.
         * This value is normally read from the {@link Scheduler.preset.ViewPreset viewPreset}
         * @config {Number}
         * @default
         * @internal
         */
        tickSize: 100,

        /**
         * true if there is a requirement to be able to snap events to a certain view resolution.
         * This has implications of the {@link #config-tickSize} that can be used, since all widths must be in even pixels.
         * @config {Boolean}
         * @default
         * @internal
         */
        snap: false,

        /**
         * true if cells in the bottom-most row should be fitted to the {@link #property-availableSpace available space}.
         * @config {Boolean}
         * @default
         * @internal
         */
        forceFit: false,
        headers: null,
        calendar: null,
        mode: 'horizontal',
        // or 'vertical'
        //used for Exporting. Make sure the tick columns are not recalculated when resizing.
        suppressFit: false,
        // cache of the config currently used.
        columnConfig: [],
        // the view preset name to apply initially
        viewPreset: null,
        // The default header level to draw column lines for
        columnLinesFor: null,
        // To give a link to the eventStore inside the header renderer if provided
        eventStore: null,
        originalTickSize: null,
        headersDatesCache: []
      };
    }
  }]);

  return TimeAxisViewModel;
}(Object(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_13__["default"])());


TimeAxisViewModel._$name = 'TimeAxisViewModel';

/***/ }),

/***/ "./lib/Scheduler/view/orientation/BaseRendering.js":
/*!*********************************************************!*\
  !*** ./lib/Scheduler/view/orientation/BaseRendering.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/* harmony default export */ __webpack_exports__["default"] = (function (Target) {
  return /*#__PURE__*/function (_ref) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(_class, _ref);

    var _super = _createSuper(_class);

    function _class() {
      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, _class);

      return _super.apply(this, arguments);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(_class, [{
      key: "getElementFromAssignmentRecord",
      value: function getElementFromAssignmentRecord(assignmentRecord) {
        var returnWrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (this.scheduler.isPainted && assignmentRecord) {
          var _wrapper$syncIdMap;

          var wrapper = this.scheduler.foregroundCanvas.syncIdMap[assignmentRecord.id]; // Wrapper wont have syncIdMap when saving dragcreated event from editor

          return returnWrapper ? wrapper : wrapper === null || wrapper === void 0 ? void 0 : (_wrapper$syncIdMap = wrapper.syncIdMap) === null || _wrapper$syncIdMap === void 0 ? void 0 : _wrapper$syncIdMap.event;
        }

        return null;
      }
    }, {
      key: "getElementFromEventRecord",
      value: function getElementFromEventRecord(eventRecord) {
        var resourceRecord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eventRecord.resource;
        var returnWrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var assignmentRecord = this.assignmentStore.getAssignmentForEventAndResource(eventRecord, resourceRecord);
        return this.getElementFromAssignmentRecord(assignmentRecord, returnWrapper);
      }
    }, {
      key: "getElementsFromEventRecord",
      value: function getElementsFromEventRecord(eventRecord, resourceRecord) {
        var returnWrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var me = this; // Single event instance, as array

        if (resourceRecord) {
          return [me.getElementFromEventRecord(eventRecord, resourceRecord, returnWrapper)];
        } // All instances
        else {
            return eventRecord.resources.reduce(function (result, resourceRecord) {
              var el = me.getElementFromEventRecord(eventRecord, resourceRecord, returnWrapper);
              el && result.push(el);
              return result;
            }, []);
          }
      }
    }]);

    return _class;
  }(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
});

/***/ }),

/***/ "./lib/Scheduler/view/orientation/HorizontalRendering.js":
/*!***************************************************************!*\
  !*** ./lib/Scheduler/view/orientation/HorizontalRendering.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HorizontalRendering; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.find */ "./node_modules/core-js/modules/es.array.find.js");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.map */ "./node_modules/core-js/modules/es.map.js");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.map.delete-all */ "./node_modules/core-js/modules/esnext.map.delete-all.js");
/* harmony import */ var core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.map.every */ "./node_modules/core-js/modules/esnext.map.every.js");
/* harmony import */ var core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.map.filter */ "./node_modules/core-js/modules/esnext.map.filter.js");
/* harmony import */ var core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.map.find */ "./node_modules/core-js/modules/esnext.map.find.js");
/* harmony import */ var core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.map.find-key */ "./node_modules/core-js/modules/esnext.map.find-key.js");
/* harmony import */ var core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.map.includes */ "./node_modules/core-js/modules/esnext.map.includes.js");
/* harmony import */ var core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.map.key-of */ "./node_modules/core-js/modules/esnext.map.key-of.js");
/* harmony import */ var core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.map.map-keys */ "./node_modules/core-js/modules/esnext.map.map-keys.js");
/* harmony import */ var core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.map.map-values */ "./node_modules/core-js/modules/esnext.map.map-values.js");
/* harmony import */ var core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.map.merge */ "./node_modules/core-js/modules/esnext.map.merge.js");
/* harmony import */ var core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.map.reduce */ "./node_modules/core-js/modules/esnext.map.reduce.js");
/* harmony import */ var core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/esnext.map.some */ "./node_modules/core-js/modules/esnext.map.some.js");
/* harmony import */ var core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/esnext.map.update */ "./node_modules/core-js/modules/esnext.map.update.js");
/* harmony import */ var core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
/* harmony import */ var _BaseRendering_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./BaseRendering.js */ "./lib/Scheduler/view/orientation/BaseRendering.js");




























































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_57___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';
/* eslint-disable no-unused-expressions */









/**
 * @module Scheduler/view/orientation/HorizontalRendering
 */

var releaseEventActions = {
  releaseElement: 1,
  // Not used at all at the moment
  reuseElement: 1 // Used by some other element

},
    renderEventActions = {
  newElement: 1,
  reuseOwnElement: 1,
  reuseElement: 1
},
    MAX_WIDTH = 9999999,
    heightEventSorter = function heightEventSorter(_ref, _ref2) {
  var lhs = _ref.startDateMS;
  var rhs = _ref2.startDateMS;
  return lhs - rhs;
},
    chronoFields = {
  startDate: 1,
  endDate: 1,
  duration: 1
};

function getStartEnd(view, timeAxis, date, dateMS, useEnd) {
  if (view.fillTicks) {
    var tick = timeAxis.getTickFromDate(date);

    if (tick >= 0) {
      // If date matches a tick start/end, use the earlier tick
      if (useEnd && tick === Math.round(tick) && tick > 0) {
        tick--;
      }

      var tickIndex = Math.floor(tick),
          tickRecord = timeAxis.getAt(tickIndex);
      return tickRecord[useEnd ? 'endDate' : 'startDate'].getTime();
    }
  }

  return dateMS;
}
/**
 * Handles event rendering in Schedulers horizontal mode. Reacts to project/store changes to keep the UI up to date.
 *
 * @internal
 */


var HorizontalRendering = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_56___default()(HorizontalRendering, _Base$mixin);

  var _super = _createSuper(HorizontalRendering);

  function HorizontalRendering() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_53___default()(this, HorizontalRendering);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_54___default()(HorizontalRendering, [{
    key: "construct",
    value: function construct(scheduler) {
      var me = this;
      me.client = me.scheduler = scheduler;
      me.eventSorter = me.eventSorter.bind(scheduler);
      scheduler.rowManager.on({
        name: 'rowManager',
        renderDone: 'onRenderDone',
        removeRows: 'onRemoveRows',
        translateRow: 'onTranslateRow',
        beforeRowHeight: 'onBeforeRowHeightChange',
        thisObj: me
      });
      me.toDrawOnProjectRefresh = new Set();
      me.toDrawOnDataReady = new Set();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_55___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58___default()(HorizontalRendering.prototype), "construct", this).call(this, {});
    }
  }, {
    key: "init",
    value: function init() {} //endregion
    //region Region, dates & coordinates

  }, {
    key: "getDateFromXY",
    value: function getDateFromXY(xy, roundingMethod, local) {
      var allowOutOfRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var coord = xy[0];

      if (!local) {
        coord = this.translateToScheduleCoordinate(coord);
      }

      return this.scheduler.timeAxisViewModel.getDateFromPosition(coord, roundingMethod, allowOutOfRange);
    }
  }, {
    key: "translateToScheduleCoordinate",
    value: function translateToScheduleCoordinate(x) {
      // Get rid of fractional pixels, to not end up with negative fractional values for pos
      var pos = x - Math.floor(this.scheduler.timeAxisSubGridElement.getBoundingClientRect().left);
      return pos + this.scheduler.scrollLeft;
    }
  }, {
    key: "translateToPageCoordinate",
    value: function translateToPageCoordinate(x) {
      var element = this.scheduler.timeAxisSubGridElement;
      return x + element.getBoundingClientRect().left - element.scrollLeft;
    }
    /**
     * Gets the region, relative to the page, represented by the schedule and optionally only for a single resource.
     * This method will call getDateConstraints to allow for additional resource/event based constraints. By overriding
     * that method you can constrain events differently for different resources.
     * @param {Core.data.Model} rowRecord (optional) The row record
     * @param {Scheduler.model.EventModel} eventRecord (optional) The event record
     * @return {Rectangle} The region of the schedule
     */

  }, {
    key: "getScheduleRegion",
    value: function getScheduleRegion(rowRecord, eventRecord) {
      var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var me = this,
          scheduler = me.scheduler,
          timeAxisSubGridElement = scheduler.timeAxisSubGridElement,
          timeAxis = scheduler.timeAxis;
      var region;

      if (rowRecord) {
        var eventElement = eventRecord && me.getElementsFromEventRecord(eventRecord, rowRecord)[0];
        region = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_63__["default"].from(scheduler.getRowById(rowRecord.id).getElement('locked'));

        if (eventElement) {
          var eventRegion = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_63__["default"].from(eventElement, timeAxisSubGridElement);
          region.y = eventRegion.y;
          region.bottom = eventRegion.bottom;
        } else {
          region.y = region.y + scheduler.resourceMargin;
          region.bottom = region.bottom - scheduler.resourceMargin;
        }
      } else {
        // TODO: This is what the bizarre function that was removed here did.
        // The coordinate space needs to be sorted out here!
        region = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_63__["default"].from(timeAxisSubGridElement).moveTo(null, 0);
        region.width = timeAxisSubGridElement.scrollWidth;
        region.y = region.y + scheduler.resourceMargin;
        region.bottom = region.bottom - scheduler.resourceMargin;
      }

      var taStart = timeAxis.startDate,
          taEnd = timeAxis.endDate,
          dateConstraints = scheduler.getDateConstraints(rowRecord, eventRecord) || {
        start: taStart,
        end: taEnd
      };
      var startX = scheduler.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_64__["default"].max(taStart, dateConstraints.start)),
          endX = scheduler.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_64__["default"].min(taEnd, dateConstraints.end));

      if (!local) {
        startX = me.translateToPageCoordinate(startX);
        endX = me.translateToPageCoordinate(endX);
      }

      region.left = Math.min(startX, endX);
      region.right = Math.max(startX, endX);
      return region;
    }
    /**
     * Gets the Region, relative to the timeline view element, representing the passed row and optionally just for a
     * certain date interval.
     * @param {Core.data.Model} rowRecord The row record
     * @param {Date} startDate A start date constraining the region
     * @param {Date} endDate An end date constraining the region
     * @return {Core.helper.util.Rectangle} The Rectangle which encapsulates the row
     */

  }, {
    key: "getRowRegion",
    value: function getRowRegion(rowRecord, startDate, endDate) {
      var scheduler = this.scheduler,
          timeAxis = scheduler.timeAxis,
          row = scheduler.getRowById(rowRecord.id); // might not be rendered

      if (!row) {
        return null;
      }

      var taStart = timeAxis.startDate,
          taEnd = timeAxis.endDate,
          start = startDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_64__["default"].max(taStart, startDate) : taStart,
          end = endDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_64__["default"].min(taEnd, endDate) : taEnd,
          startX = scheduler.getCoordinateFromDate(start),
          endX = scheduler.getCoordinateFromDate(end, true, true),
          y = row.top,
          x = Math.min(startX, endX),
          bottom = y + row.offsetHeight;
      return new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_63__["default"](x, y, Math.max(startX, endX) - x, bottom - y);
    }
  }, {
    key: "getResourceEventBox",
    value: function getResourceEventBox(eventRecord, resourceRecord, includeOutside) {
      var roughly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var resourceData = this.resourceMap.get(resourceRecord.id);
      var eventLayout = null,
          approx = false;

      if (resourceData) {
        eventLayout = resourceData.eventsData.find(function (d) {
          return d.eventRecord === eventRecord;
        });
      } // Outside of view, layout now if supposed to be included


      if (!eventLayout) {
        eventLayout = this.getTimeSpanRenderData(eventRecord, resourceRecord, {
          viewport: true,
          timeAxis: includeOutside
        });
        approx = true;
      }

      if (eventLayout) {
        // Event layout is relative to row, need to make to absolute before returning
        var rowBox = this.scheduler.getRecordCoords(resourceRecord, true, roughly),
            absoluteTop = eventLayout.top + rowBox.top,
            box = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_63__["default"](eventLayout.left, absoluteTop, eventLayout.width, eventLayout.height); // Flag informing other parts of the code that this box is approximated

        if (approx) {
          box.layout = false;
        }

        box.rowTop = rowBox.top;
        box.rowBottom = rowBox.bottom;
        return box;
      }

      return null;
    } //endregion
    //region Element <-> Record mapping

  }, {
    key: "resolveRowRecord",
    value: function resolveRowRecord(elementOrEvent) {
      var me = this,
          scheduler = me.scheduler,
          element = elementOrEvent instanceof Event ? elementOrEvent.target : elementOrEvent,
          el = element.nodeType === 3 ? element.parentElement : element,
          eventNode = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_62__["default"].up(el, scheduler.eventSelector);

      if (eventNode) {
        return me.resourceStore.getById(eventNode.dataset.resourceId);
      }

      return scheduler.getRecordFromElement(el);
    } //endregion
    //region Project

  }, {
    key: "attachToProject",
    value: function attachToProject(project) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_55___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58___default()(HorizontalRendering.prototype), "attachToProject", this).call(this, project);

      this.refreshAllWhenReady = true;

      if (project) {
        project.on({
          name: 'project',
          refresh: 'onProjectRefresh',
          dataReady: 'onProjectDataReady',
          thisObj: this
        });
      }
    }
  }, {
    key: "onProjectDataReady",
    value: function onProjectDataReady() {
      var me = this,
          scheduler = me.scheduler,
          toDrawOnDataReady = me.toDrawOnDataReady;

      if (!scheduler.refreshSuspended) {
        if (toDrawOnDataReady.size) {
          me.clearResources(toDrawOnDataReady);
          me.refreshResources(toDrawOnDataReady);
        }

        toDrawOnDataReady.clear();
      }
    }
  }, {
    key: "onProjectRefresh",
    value: function onProjectRefresh() {
      var me = this,
          scheduler = me.scheduler,
          toDrawOnProjectRefresh = me.toDrawOnProjectRefresh;

      if (!scheduler.refreshSuspended) {
        // Either refresh all rows (on for example dataset)
        if (me.refreshAllWhenReady) {
          scheduler.calculateAllRowHeights(true); // Rows rendered? Refresh

          if (scheduler.rowManager.topRow) {
            me.clearAll();
            scheduler.refreshWithTransition(false, !me.isFirstRefresh);
            me.isFirstRefresh = false;
          } // No rows yet, reinitialize (happens if initial project empty and then non empty project assigned)
          else {
              scheduler.rowManager.reinitialize();
            }

          me.refreshAllWhenReady = false;
        } // Or only affected rows (if any)
        else if (toDrawOnProjectRefresh.size) {
            //me.clearResources(toDrawOnProjectRefresh);
            me.refreshResources(toDrawOnProjectRefresh);
          }

        toDrawOnProjectRefresh.clear();
      }
    } //endregion
    //region AssignmentStore

  }, {
    key: "attachToAssignmentStore",
    value: function attachToAssignmentStore(assignmentStore) {
      this.refreshAllWhenReady = true;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_55___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58___default()(HorizontalRendering.prototype), "attachToAssignmentStore", this).call(this, assignmentStore);

      if (assignmentStore) {
        assignmentStore.on({
          name: 'assignmentStore',
          changePreCommit: 'onAssignmentStoreChange',
          refreshPreCommit: 'onAssignmentStoreRefresh',
          thisObj: this
        });
      }
    }
  }, {
    key: "onAssignmentStoreChange",
    value: function onAssignmentStoreChange(_ref3) {
      var action = _ref3.action,
          records = _ref3.records,
          replaced = _ref3.replaced,
          record = _ref3.record,
          changes = _ref3.changes;
      var me = this,
          assignmentRecords = records || (record ? [record] : []),
          resourceIds = new Set(assignmentRecords.map(function (assignmentRecord) {
        return assignmentRecord.resourceId;
      })); // Ignore assignment changes caused by removing resources, the remove will redraw things anyway
      // Also ignore case when resource id is changed. In this case row will be refreshed by the grid

      if (me.resourceStore.isRemoving || me.resourceStore.isChangingId) {
        return;
      }

      var transition = true;

      switch (action) {
        // These operations will invalidate the graph, need to draw later
        case 'dataset':
          {
            // Ignore dataset when using single assignment mode
            if (!me.eventStore.usesSingleAssignment) {
              me.refreshResourcesWhenReady(resourceIds);
            }

            return;
          }

        case 'add':
        case 'remove':
        case 'updateMultiple':
          // TODO: Dont think updateMultiple is covered by any test...
          me.refreshResourcesWhenReady(resourceIds);
          return;

        case 'removeall':
          me.refreshAllWhenReady = true;
          return;

        case 'replace':
          // Gather resources from both the old record and the new one
          replaced.forEach(function (_ref4) {
            var _ref5 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_52___default()(_ref4, 2),
                oldAssignment = _ref5[0],
                newAssignment = _ref5[1];

            resourceIds.add(oldAssignment.resourceId);
            resourceIds.add(newAssignment.resourceId);
          }); // And refresh them

          me.refreshResourcesWhenReady(resourceIds);
          return;
        // These operations wont invalidate the graph, redraw now

        case 'filter':
          me.clearAll();
          me.scheduler.calculateAllRowHeights(true);
          me.scheduler.refreshWithTransition();
          return;

        case 'update':
          {
            if ('eventId' in changes || 'resourceId' in changes) {
              // When reassigning, clear old resource also
              if ('resourceId' in changes) {
                resourceIds.add(changes.resourceId.oldValue);
              }

              me.refreshResources(resourceIds, transition);
            }
          }
      }
    }
  }, {
    key: "onAssignmentStoreRefresh",
    value: function onAssignmentStoreRefresh(_ref6) {
      var action = _ref6.action,
          records = _ref6.records;
    } //endregion
    //region EventStore

  }, {
    key: "attachToEventStore",
    value: function attachToEventStore(eventStore) {
      this.refreshAllWhenReady = true;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_55___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58___default()(HorizontalRendering.prototype), "attachToEventStore", this).call(this, eventStore);

      if (eventStore) {
        eventStore.on({
          name: 'eventStore',
          refreshPreCommit: 'onEventStoreRefresh',
          thisObj: this
        });
      }
    }
  }, {
    key: "onEventStoreRefresh",
    value: function onEventStoreRefresh(_ref7) {
      var action = _ref7.action;

      if (action === 'batch') {
        if (this.scheduler.isEngineReady) {
          this.clearAll();
          this.scheduler.refreshWithTransition();
        } // else {
        //     this.refreshAllWhenReady = true;
        // }

      }
    }
  }, {
    key: "onEventStoreChange",
    value: function onEventStoreChange(_ref8) {
      var action = _ref8.action,
          records = _ref8.records,
          record = _ref8.record,
          replaced = _ref8.replaced,
          changes = _ref8.changes;
      var me = this,
          eventRecords = records || (record ? [record] : []),
          isResourceTimeRange = eventRecords[0] && eventRecords[0].isResourceTimeRange,
          resourceIds = new Set();
      eventRecords.forEach(function (eventRecord) {
        var _eventRecord$resource;

        // When rendering a Gantt project, the project model also passes through here -> no `resources`
        (_eventRecord$resource = eventRecord.resources) === null || _eventRecord$resource === void 0 ? void 0 : _eventRecord$resource.forEach(function (resourceRecord) {
          return resourceIds.add(resourceRecord.id);
        });
      });

      if (isResourceTimeRange) {
        me.refreshResources(resourceIds);
      } else {
        switch (action) {
          // No-ops
          case 'batch': // Handled elsewhere, dont want it to clear again

          case 'sort': // Order in EventStore does not matter, so these actions are no-ops

          case 'group':
          case 'move':
            return;

          case 'remove':
            // Remove is a no-op since assignment will also be removed
            return;

          case 'clearchanges':
          case 'dataset':
            me.clearAll();
            me.refreshAllWhenReady = true;
            return;

          case 'add':
          case 'updateMultiple':
            // Just refresh below
            break;

          case 'replace':
            // Gather resources from both the old record and the new one
            replaced.forEach(function (_ref9) {
              var _ref10 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_52___default()(_ref9, 2),
                  newEvent = _ref10[1];

              // Old cleared by changed assignment
              newEvent.resources.map(function (resourceRecord) {
                return resourceIds.add(resourceRecord.id);
              });
            });
            break;

          case 'removeall':
          case 'filter':
            // Filter might be caused by add retriggering filters, in which case we need to refresh later
            if (!me.scheduler.isEngineReady) {
              me.refreshAllWhenReady = true;
              return;
            } // Clear all when filtering for simplicity. If that turns out to give bad performance, one would need to
            // figure out which events was filtered out and only clear their resources.


            me.clearAll();
            me.scheduler.calculateAllRowHeights(true);
            me.scheduler.refreshWithTransition();
            return;

          case 'update':
            {
              // Check if changes are graph related or not
              var allChrono = record.$entity ? !Object.keys(changes).some(function (name) {
                return !record.$entity.getField(name);
              }) : !Object.keys(changes).some(function (name) {
                return !chronoFields[name];
              });
              var dateChanges = 0;
              'startDate' in changes && dateChanges++;
              'endDate' in changes && dateChanges++;
              'duration' in changes && dateChanges++;

              if ('resourceId' in changes) {
                resourceIds.add(changes.resourceId.oldValue);
              } // Always redraw non chrono changes (name etc) and chrono changes that can affect appearance


              if (!allChrono || // skip case when changed "duration" only (w/o start/end affected)
              dateChanges && !('duration' in changes && dateChanges === 1) || 'percentDone' in changes) {
                var _me$project;

                // if we are finalizing data loading let's delay the resources refresh till all the
                // propagation results get into stores
                if ((_me$project = me.project) === null || _me$project === void 0 ? void 0 : _me$project.propagatingLoadChanges) {
                  resourceIds.forEach(function (id) {
                    return me.toDrawOnDataReady.add(id);
                  });
                } else {
                  me.refreshResources(resourceIds);
                }
              }

              return;
            }
        }

        me.refreshResourcesWhenReady(resourceIds);
      }
    } //endregion
    //region ResourceStore

  }, {
    key: "attachToResourceStore",
    value: function attachToResourceStore(resourceStore) {
      this.refreshAllWhenReady = true;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_55___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_58___default()(HorizontalRendering.prototype), "attachToResourceStore", this).call(this, resourceStore);

      if (resourceStore) {
        resourceStore.on({
          name: 'resourceStore',
          changePreCommit: 'onResourceStoreChange',
          thisObj: this
        });
      }
    }
  }, {
    key: "onResourceStoreChange",
    value: function onResourceStoreChange(_ref11) {
      var action = _ref11.action,
          isExpand = _ref11.isExpand,
          record = _ref11.record,
          records = _ref11.records,
          changes = _ref11.changes;
      var me = this,
          resourceIds = record ? [record.id] : records === null || records === void 0 ? void 0 : records.map(function (r) {
        return r.id;
      });

      switch (action) {
        case 'add':
          // #635 Events disappear when toggling other node
          // If we are expanding project won't fire refresh event
          if (!isExpand) {
            me.refreshResourcesWhenReady(resourceIds);
          }

          return;

        case 'update':
          {
            // Ignore changes from project commit, if they affect events they will be redrawn anyway
            // Also ignore explicit transformation of leaf <-> parent
            if (!me.project.isBatchingChanges && !changes.isLeaf) {
              // Resource changes might affect events, refresh
              me.refreshResources(resourceIds);
            }

            return;
          }

        case 'filter':
          // Bail out on filter action. Map was already updated on `refresh` event triggered before this `change`
          // one. And extra records are removed from rowMap by `onRemoveRows`
          return;

        case 'removeall':
          me.clearAll();
          return;
      }

      me.clearResources(resourceIds);
    } //endregion
    //region RowManager

  }, {
    key: "onTranslateRow",
    value: function onTranslateRow(_ref12) {
      var row = _ref12.row;

      // Newly added rows are translated prior to having an id, rule those out since they will be rendered later
      if (row.id != null) {
        // Event layouts are stored relative to the resource, only need to rerender the row to have its absolute
        // position updated to match new translation
        this.refreshRow(row, false);
      }
    } // Used to pre-calculate row heights

  }, {
    key: "calculateRowHeight",
    value: function calculateRowHeight(resourceRecord) {
      var scheduler = this.scheduler;

      if (scheduler.eventLayout === 'stack' && scheduler.isEngineReady && !resourceRecord.isSpecialRow && resourceRecord.events.length > 1) {
        var assignmentStore = scheduler.assignmentStore,
            eventStore = scheduler.eventStore,
            timeAxis = scheduler.timeAxis,
            resourceMargin = scheduler.resourceMargin,
            barMargin = scheduler.barMargin,
            heightPerEvent = scheduler.rowHeight - resourceMargin * 2,
            eventFilter = function eventFilter(eventRecord) {
          return eventRecord.assignments.some(function (a) {
            return a.resource === resourceRecord && assignmentStore.includes(a);
          });
        },
            events = eventStore.getEvents({
          resourceRecord: resourceRecord,
          includeOccurrences: scheduler.enableRecurringEvents,
          startDate: timeAxis.startDate,
          endDate: timeAxis.endDate,
          filter: eventFilter
        }).sort(heightEventSorter).map(function (eventRecord) {
          return {
            eventRecord: eventRecord,
            startMS: eventRecord.startDateMS,
            endMS: eventRecord.endDate ? eventRecord.endDateMS : eventRecord.startDateMS
          };
        }),
            nbrOfBandsRequired = scheduler.currentEventLayout.layoutEventsInBands(events);

        return nbrOfBandsRequired * heightPerEvent + (nbrOfBandsRequired - 1) * barMargin + resourceMargin * 2;
      } else {
        return scheduler.rowHeight;
      }
    } //endregion
    //region TimeAxis

  }, {
    key: "doUpdateTimeView",
    value: function doUpdateTimeView() {
      this.updateFromHorizontalScroll(this.scheduler.timeAxisSubGrid.scrollable.x);
    }
  }, {
    key: "onTimeAxisViewModelUpdate",
    value: function onTimeAxisViewModelUpdate() {
      this.clearAll(); // If refresh is suspended, update timeview as soon as refresh gets unsuspended

      if (this.scheduler.refreshSuspended) {
        this.scheduler.on({
          resumeRefresh: function resumeRefresh() {
            // This code will try to refresh rows, but resumeRefresh event doesn't guarantee rowManager rows are
            // in actual state. e.g. if resources were removed during a suspended refresh rowManager won't get a
            // chance to update them until `refresh` event from the project. We can safely update the view only
            // if engine in ready (not committing), otherwise we leave refresh a liability of normal project refresh
            // logic. Covered by SchedulerRendering.t.js
            // https://github.com/bryntum/support/issues/1462
            if (this.scheduler.isEngineReady) {
              this.doUpdateTimeView();
            }
          },
          thisObj: this,
          once: true
        });
      } // Call update anyway. If refresh is suspended this call will only update visible date range and will not redraw rows


      this.doUpdateTimeView();
    } //endregion
    //region Dependency connectors

    /**
     * Gets displaying item start side
     *
     * @param {Scheduler.model.EventModel} eventRecord
     * @return {String} 'left' / 'right' / 'top' / 'bottom'
     */

  }, {
    key: "getConnectorStartSide",
    value: function getConnectorStartSide(eventRecord) {
      return 'left';
    }
    /**
     * Gets displaying item end side
     *
     * @param {Scheduler.model.EventModel} eventRecord
     * @return {String} 'left' / 'right' / 'top' / 'bottom'
     */

  }, {
    key: "getConnectorEndSide",
    value: function getConnectorEndSide(eventRecord) {
      return 'right';
    } //endregion
    //region Scheduler hooks

  }, {
    key: "refreshRows",
    value: function refreshRows(reLayoutEvents) {
      if (reLayoutEvents) {
        this.clearAll();
      }
    } // Clear events in case they use date as part of displayed info

  }, {
    key: "onLocaleChange",
    value: function onLocaleChange() {
      this.clearAll();
    } // Called when viewport size changes

  }, {
    key: "onViewportResize",
    value: function onViewportResize() {// TODO: Could do something cheaper
      // Refresh without discarding any available layouts
      //        this.scheduler.refresh(); // Seems not needed? Will be updated by horizontal scroll anyway
    } // Called from EventDrag

  }, {
    key: "onDragAbort",
    value: function onDragAbort(_ref13) {
      var context = _ref13.context,
          dragData = _ref13.dragData;

      // Aborted a drag in a scrolled scheduler, with origin now out of view. Element is no longer needed
      if (this.resourceStore.indexOf(dragData.record.resource) < this.scheduler.topRow.dataIndex) {
        context.element.remove();
      }
    } // Called from EventSelection

  }, {
    key: "toggleCls",
    value: function toggleCls(assignmentRecord, cls) {
      var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var useWrapper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var element = this.getElementFromAssignmentRecord(assignmentRecord, useWrapper),
          // TODO: Should be assignmentRecord.resourceId, but breaks engine. Hoping https://github.com/bryntum/bryntum-suite/pull/1252 will fix it
      resourceData = this.resourceMap.get(assignmentRecord.isModel ? assignmentRecord.get('resourceId') : assignmentRecord.resourceId),
          eventData = resourceData === null || resourceData === void 0 ? void 0 : resourceData.eventsData.find(function (d) {
        return d.eventId === assignmentRecord.eventId;
      }); // Update cached config

      if (eventData) {
        eventData[useWrapper ? 'wrapperCls' : 'cls'][cls] = add;
      } // Live update element


      if (element) {
        // Update element
        element.classList[add ? 'add' : 'remove'](cls); // And its DOM config

        element.lastDomConfig.className[cls] = add;
      }
    } // React to rows being removed, refreshes view without any relayouting needed since layout is cached relative to row

  }, {
    key: "onRemoveRows",
    value: function onRemoveRows(_ref14) {
      var _this = this;

      var rows = _ref14.rows;
      rows.forEach(function (row) {
        return _this.rowMap.delete(row);
      });
      this.onRenderDone();
    } // Update header range on horizontal scroll. No need to draw any tasks, Gantt only cares about vertical scroll

  }, {
    key: "updateFromHorizontalScroll",
    value: function updateFromHorizontalScroll(scrollLeft) {
      var _this2 = this;

      var scheduler = this.scheduler,
          timeAxisSubGrid = scheduler.timeAxisSubGrid,
          timeAxis = scheduler.timeAxis,
          width = timeAxisSubGrid.width,
          returnEnd = timeAxisSubGrid.scrollable.maxX <= Math.round(scrollLeft) + 5,
          startDate = scheduler.getDateFromCoordinate(Math.max(0, scrollLeft - this.scrollBuffer)),
          endDate = returnEnd ? timeAxis.endDate : scheduler.getDateFromCoordinate(scrollLeft + width + this.scrollBuffer) || timeAxis.endDate;

      if (startDate) {
        this._visibleDateRange = {
          startDate: startDate,
          endDate: endDate,
          startMS: startDate.getTime(),
          endMS: endDate.getTime()
        }; // Update timeaxis header making it display the new dates

        scheduler.timeView.range = {
          startDate: startDate,
          endDate: endDate
        };
        scheduler.trigger('visibleRangeChange', {
          startDate: startDate,
          endDate: endDate
        }); // If refresh is suspended, someone else is responsible for updating the UI later

        if (!scheduler.refreshSuspended && scheduler.rowManager.rows.length) {
          // Gets here too early in Safari for ResourceHistogram. ResizeObserver triggers a scroll before rows are
          // rendered first time. Could not track down why, bailing out
          if (scheduler.rowManager.rows[0].id === null) {
            return;
          }

          scheduler.rowManager.rows.forEach(function (row) {
            return _this2.refreshRow(row, false);
          });
          this.onRenderDone();
        }
      }
    } // Called from SchedulerEventRendering

  }, {
    key: "repaintEventsForResource",
    value: function repaintEventsForResource(resourceRecord) {
      this.refreshResources([resourceRecord.id]);
    }
  }, {
    key: "onBeforeRowHeightChange",
    value: function onBeforeRowHeightChange(event) {
      var scheduler = this.scheduler,
          newHeight = event ? event.height : scheduler.rowHeight; // Row height is cached per resource, all have to be re-laid out

      this.clearAll(); // RowHeight could be set while scheduler.foregroundCanvas is not set yet

      if (scheduler.foregroundCanvas) {
        scheduler.foregroundCanvas.style.fontSize = "".concat(newHeight - scheduler.resourceMargin * 2, "px");
      }
    } //endregion
    //region Refresh resources

    /**
     * Clears resources directly and redraws them on next project refresh
     * @param {Number[]|String[]} resourceIds
     * @private
     */

  }, {
    key: "refreshResourcesWhenReady",
    value: function refreshResourcesWhenReady(resourceIds) {
      var _this3 = this;

      this.clearResources(resourceIds);
      resourceIds.forEach(function (id) {
        return _this3.toDrawOnProjectRefresh.add(id);
      });
    }
    /**
     * Clears and redraws resources directly. Respects schedulers refresh suspension
     * @param {Number[]|String[]} ids Resource ids
     * @param {Boolean} [transition] Use transition or not
     * @private
     */

  }, {
    key: "refreshResources",
    value: function refreshResources(ids) {
      var _this4 = this;

      var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var me = this,
          scheduler = me.scheduler,
          rows = [],
          noRows = [];
      me.clearResources(ids);

      if (!scheduler.refreshSuspended) {
        ids.forEach(function (id) {
          var row = scheduler.getRowById(id);

          if (row) {
            rows.push(row);
          } else {
            noRows.push(row);
          }
        });
        scheduler.runWithTransition(function () {
          // Rendering rows populates row heights, but not all resources might have a row in view
          scheduler.calculateRowHeights(noRows.map(function (id) {
            return _this4.resourceStore.getById(id);
          }), true); // Render those that do

          scheduler.rowManager.renderRows(rows);
        }, transition);
      }
    } //endregion
    //region Stack & pack

  }, {
    key: "layoutEventVerticallyStack",
    value: function layoutEventVerticallyStack(bandIndex) {
      var _this$scheduler = this.scheduler,
          resourceMargin = _this$scheduler.resourceMargin,
          rowHeight = _this$scheduler.rowHeight,
          barMargin = _this$scheduler.barMargin;
      return bandIndex === 0 ? resourceMargin : resourceMargin + bandIndex * (rowHeight - resourceMargin * 2) + bandIndex * barMargin;
    }
  }, {
    key: "layoutEventVerticallyPack",
    value: function layoutEventVerticallyPack(topFraction, heightFraction) {
      var _this$scheduler2 = this.scheduler,
          resourceMargin = _this$scheduler2.resourceMargin,
          rowHeight = _this$scheduler2.rowHeight,
          barMargin = _this$scheduler2.barMargin,
          availableHeight = rowHeight - 2 * resourceMargin,
          count = 1 / heightFraction,
          bandIndex = topFraction * count,
          height = (availableHeight - (count - 1) * barMargin) * heightFraction,
          top = resourceMargin + bandIndex * height + bandIndex * barMargin;
      return {
        top: top,
        height: height
      };
    } //endregion
    //region Render

    /**
     * Used by event drag features to bring into existence event elements that are outside of the rendered block.
     * @param {Scheduler.model.TimeSpan} eventRecord The event to render
     * @param {Scheduler.model.ResourceModel} [resourceRecord] The event to render
     * @private
     */

  }, {
    key: "addTemporaryDragElement",
    value: function addTemporaryDragElement(eventRecord) {
      var resourceRecord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eventRecord.resource;
      var scheduler = this.scheduler,
          renderData = scheduler.generateRenderData(eventRecord, resourceRecord, {
        timeAxis: true,
        viewport: true
      });
      renderData.absoluteTop = renderData.row ? renderData.top + renderData.row.top : scheduler.getResourceEventBox(eventRecord, resourceRecord, true).top;
      var domConfig = this.renderEvent(renderData),
          dataset = domConfig.dataset;
      delete domConfig.tabIndex;
      delete dataset.eventId;
      delete dataset.resourceId;
      delete dataset.syncId;
      dataset.transient = true;
      domConfig.parent = this.scheduler.foregroundCanvas; // So that the regular DomSyncing which may happen during scroll does not
      // sweep up and reuse the temporary element.

      domConfig.retainElement = true;
      var result = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_62__["default"].createElement(domConfig);
      result.innerElement = result.firstChild;
      eventRecord.instanceMeta(scheduler).hasTemporaryDragElement = true;
      return result;
    } // Earlier start dates are above later tasks
    // If same start date, longer tasks float to top
    // If same start + duration, sort by name
    // Fn can be called with layout date or event records (from EventNavigation)

  }, {
    key: "eventSorter",
    value: function eventSorter(a, b) {
      if (this.horizontalEventSorterFn) {
        return this.horizontalEventSorterFn(a.eventRecord || a, b.eventRecord || b);
      }

      var // TODO: Rename startMS -> startDateMS to not have to have isModel check here (and to be consistent)
      startA = a.isModel ? a.startDateMS : a.dataStartMS || a.startMS,
          // dataXX are used if configured with fillTicks
      endA = a.isModel ? a.endDateMS : a.dataEndMS || a.endMS,
          startB = b.isModel ? b.startDateMS : b.dataStartMS || b.startMS,
          endB = b.isModel ? b.endDateMS : b.dataEndMS || b.endMS,
          nameA = a.isModel ? a.name : a.eventRecord.name,
          nameB = b.isModel ? b.name : b.eventRecord.name;
      return startA - startB || endB - endA || (nameA < nameB ? -1 : nameA == nameB ? 0 : 1);
    }
    /**
     * Converts a start/endDate into a MS value used when rendering the event. If scheduler is configured with
     * `fillTicks: true` the value returned will be snapped to tick start/end.
     * @private
     * @param {Scheduler.model.EventModel} eventRecord
     * @returns {Object} Object of format { startMS, endMS, durationMS }
     */

  }, {
    key: "calculateMS",
    value: function calculateMS(eventRecord) {
      var me = this,
          scheduler = me.scheduler,
          timeAxis = scheduler.timeAxis,
          timeAxisViewModel = scheduler.timeAxisViewModel;
      var startMS = getStartEnd(scheduler, timeAxis, eventRecord.startDate, eventRecord.startDateMS, false),
          endMS = getStartEnd(scheduler, timeAxis, eventRecord.endDate, eventRecord.endDateMS, true),
          durationMS = endMS - startMS;

      if (scheduler.milestoneLayoutMode !== 'default' && durationMS === 0) {
        var pxPerMinute = timeAxisViewModel.getSingleUnitInPixels('minute'),
            lengthInPx = scheduler.getMilestoneLabelWidth(eventRecord),
            duration = lengthInPx * (1 / pxPerMinute);
        durationMS = duration * 60 * 1000;

        switch (scheduler.milestoneAlign) {
          case 'start':
          case 'left':
            endMS = startMS + durationMS;
            break;

          case 'end':
          case 'right':
            endMS = startMS;
            startMS = endMS - durationMS;
            break;

          default:
            // using center as default
            endMS = startMS + durationMS / 2;
            startMS = endMS - durationMS;
            break;
        }
      }

      return {
        startMS: startMS,
        endMS: endMS,
        durationMS: durationMS
      };
    }
    /**
     * Gets timespan coordinates etc. Relative to containing row. If the timespan is outside of the zone in
     * which timespans are rendered, that is outside of the TimeAxis, or outside of the vertical zone in which timespans
     * are rendered, then `undefined` is returned.
     * @private
     * @param {Scheduler.model.TimeSpan} timeSpan TimeSpan record
     * @param {Core.data.Model} rowRecord Row record
     * @param {Boolean|Object} includeOutside Specify true to get boxes for timespans outside of the rendered zone in both
     * dimensions. This option is used when calculating dependency lines, and we need to include routes from timespans
     * which may be outside the rendered zone.
     * @param {Boolean} includeOutside.timeAxis Pass as `true` to include timespans outside of the TimeAxis's bounds
     * @param {Boolean} includeOutside.viewport Pass as `true` to include timespans outside of the vertical timespan viewport's bounds.
     * @returns {{event/task: *, left: number, width: number, start: (Date), end: (Date), startMS: number, endMS: number, startsOutsideView: boolean, endsOutsideView: boolean}}
     */

  }, {
    key: "getTimeSpanRenderData",
    value: function getTimeSpanRenderData(timeSpan, rowRecord) {
      var includeOutside = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          scheduler = me.scheduler,
          timeAxis = scheduler.timeAxis,
          timeAxisViewModel = scheduler.timeAxisViewModel,
          includeOutsideTimeAxis = includeOutside === true || includeOutside.timeAxis,
          includeOutsideViewport = includeOutside === true || includeOutside.viewport; // If timespan is outside the TimeAxis, give up trying to calculate a layout (Unless we're including timespans
      // outside our zone)

      if (includeOutsideTimeAxis || timeAxis.isTimeSpanInAxis(timeSpan)) {
        var row = scheduler.getRowById(rowRecord);

        if (row || includeOutsideViewport) {
          var pxPerMinute = timeAxisViewModel.getSingleUnitInPixels('minute'),
              timespanStart = timeSpan.startDate,
              timespanEnd = timeSpan.endDate || timespanStart,
              viewStartMS = timeAxis.startMS,
              viewEndMS = timeAxis.endMS,
              _me$calculateMS = me.calculateMS(timeSpan),
              startMS = _me$calculateMS.startMS,
              endMS = _me$calculateMS.endMS,
              durationMS = _me$calculateMS.durationMS,
              startsOutsideView = startMS < viewStartMS | (startMS > viewEndMS) << 1,
              endsOutsideView = endMS > viewEndMS | (endMS <= viewStartMS) << 1,
              durationMinutes = durationMS / (1000 * 60),
              width = endsOutsideView ? pxPerMinute * durationMinutes : null;

          var endX = scheduler.getCoordinateFromDate(endMS, {
            local: true,
            respectExclusion: true,
            isEnd: true
          }),
              startX,
              clippedStart = false,
              clippedEnd = false; // If event starts outside of view, estimate where.

          if (startsOutsideView) {
            startX = (startMS - viewStartMS) / (1000 * 60) * pxPerMinute;
          } // Starts in view, calculate exactly
          else {
              // If end date is included in time axis but start date is not (when using time axis exclusions), snap start date to next included data
              startX = scheduler.getCoordinateFromDate(startMS, {
                local: true,
                respectExclusion: true,
                isEnd: false,
                snapToNextIncluded: endX !== -1
              });
              clippedStart = startX === -1;
            }

          if (endsOutsideView) {
            endX = startX + width;
          } else {
            clippedEnd = endX === -1;
          }

          if (clippedEnd && !clippedStart) {
            // We know where to start but not where to end, snap it (the opposite is already handled by the
            // snapToNextIncluded flag when calculating startX above)
            endX = scheduler.getCoordinateFromDate(endMS, {
              local: true,
              respectExclusion: true,
              isEnd: true,
              snapToNextIncluded: true
            });
          } // If the element is very wide there's no point in displaying it all.
          // Indeed the element may not be displayable at extremely large widths.


          if (width > MAX_WIDTH) {
            // The start is before the TimeAxis start
            if (startsOutsideView === 1) {
              // Both ends outside - spans TimeAxis
              if (endsOutsideView === 1) {
                startX = -100;
                endX = scheduler.timeAxisColumn.width + 100;
              } // End is in view
              else {
                  startX = endX - MAX_WIDTH;
                }
            } // The end is after, but the start is in view
            else if (endsOutsideView === 1) {
                endX = startX + MAX_WIDTH;
              }
          }

          if (clippedStart && clippedEnd) {
            // Both ends excluded, but there might be some part in between that should be displayed...
            startX = scheduler.getCoordinateFromDate(startMS, {
              local: true,
              respectExclusion: true,
              isEnd: false,
              snapToNextIncluded: true,
              max: endMS
            });
            endX = scheduler.getCoordinateFromDate(endMS, {
              local: true,
              respectExclusion: true,
              isEnd: true,
              snapToNextIncluded: true,
              min: startMS
            });

            if (startX === endX) {
              // Raise flag on instance meta to avoid duplicating this logic
              timeSpan.instanceMeta(scheduler).excluded = true; // Excluded by time axis exclusion rules, render nothing

              return null;
            }
          }

          var data = {
            eventRecord: timeSpan,
            taskRecord: timeSpan,
            // Helps with using Gantt projects in Scheduler Pro
            left: Math.min(startX, endX),
            // Use min width 1 for normal events, 0 for milestones (wont have width specified at all in the end)
            width: Math.abs(endX - startX) || (timeSpan.isMilestone ? 0 : 1),
            start: timespanStart,
            end: timespanEnd,
            rowId: rowRecord.id,
            children: [],
            startMS: startMS,
            endMS: endMS,
            startsOutsideView: startsOutsideView,
            endsOutsideView: endsOutsideView,
            clippedStart: clippedStart,
            clippedEnd: clippedEnd,
            row: row
          }; // If filling ticks we need to also keep datas MS values, since they are used for sorting timespans

          if (scheduler.fillTicks) {
            data.dataStartMS = data.start.getTime();
            data.dataEndMS = data.end.getTime();
          }

          data.top = Math.max(0, scheduler.resourceMargin);

          if (scheduler.managedEventSizing) {
            // Timespan height should be at least 1px
            data.height = Math.max(scheduler.rowManager.rowHeight - 2 * scheduler.resourceMargin, 1);
          }

          return data;
        }
      }
    } // Lay out events within a resource, relative to the resource

  }, {
    key: "layoutResourceEvents",
    value: function layoutResourceEvents(resourceRecord) {
      var includeOutside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var me = this,
          scheduler = me.scheduler,
          eventStore = scheduler.eventStore,
          assignmentStore = scheduler.assignmentStore,
          timeAxis = scheduler.timeAxis,
          resourceEvents = eventStore.getEvents({
        includeOccurrences: scheduler.enableRecurringEvents,
        resourceRecord: resourceRecord,
        startDate: timeAxis.startDate,
        endDate: timeAxis.endDate,
        filter: function filter(eventRecord) {
          return eventRecord.assignments.some(function (a) {
            return a.resource === resourceRecord && assignmentStore.includes(a);
          });
        }
      }),
          allEvents = scheduler.getEventsToRender(resourceRecord, resourceEvents) || [],
          eventsData = allEvents.reduce(function (result, eventRecord) {
        // Only those in time axis (by default)
        if (includeOutside || timeAxis.isTimeSpanInAxis(eventRecord)) {
          var eventBox = scheduler.generateRenderData(eventRecord, resourceRecord, false); // Collect layouts of visible events

          if (eventBox) {
            result.push(eventBox);
          }
        }

        return result;
      }, []); // Ensure the events are rendered in natural order so that navigation works.

      eventsData.sort(me.eventSorter);
      var rowHeight = scheduler.rowHeight;
      var layout = scheduler.currentEventLayout,
          // Only events and tasks should be considered during layout (not resource time ranges if any)
      layoutEventData = eventsData.filter(function (d) {
        return d.eventRecord.isEvent;
      }); // Event data is now gathered, calculate layout properties for each event

      if (scheduler.eventLayout === 'stack') {
        var nbrOfBandsRequired = layout.applyLayout(layoutEventData, resourceRecord),
            heightPerEvent = scheduler.rowHeight - scheduler.resourceMargin * 2;
        rowHeight = nbrOfBandsRequired * heightPerEvent + (nbrOfBandsRequired - 1) * scheduler.barMargin + scheduler.resourceMargin * 2;
      } else if (scheduler.eventLayout === 'pack') {
        layout.applyLayout(layoutEventData, resourceRecord);
      }

      return {
        rowHeight: rowHeight,
        eventsData: eventsData
      };
    } // Generates a DOMConfig for an EventRecord

  }, {
    key: "renderEvent",
    value: function renderEvent(data, rowHeight) {
      var scheduler = this.scheduler,
          resourceRecord = data.resourceRecord,
          assignmentRecord = data.assignmentRecord,
          eventRecord = data.eventRecord,
          syncId = assignmentRecord // Assignment, might be an occurrence
      ? this.assignmentStore.getOccurrence(assignmentRecord, eventRecord).id // Some thine else, probably a ResourceTimeRange
      : data.eventId,
          elementConfig = {
        className: data.wrapperCls,
        tabIndex: '0',
        children: [{
          className: data.cls,
          style: data.style || '',
          children: data.children,
          dataset: {
            // Each feature putting contents in the event wrap should have this to simplify syncing and
            // element retrieval after sync
            taskFeature: 'event'
          },
          syncOptions: {
            syncIdField: 'taskBarFeature'
          }
        }].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_51___default()(data.wrapperChildren)),
        style: {
          transform: "translate(".concat(data.left, "px, ").concat(data.absoluteTop, "px)"),
          // ResourceTimeRanges fill row height, cannot be done earlier than this since row height is not
          // known initially
          height: data.fillSize ? rowHeight : data.height,
          // DomHelper appends px to dimensions when using numbers. Ignore width for milestones
          width: data.width > 0 ? data.width : null,
          zIndex: data.zIndex,
          style: data.wrapperStyle
        },
        dataset: {
          resourceId: resourceRecord.id,
          eventId: data.eventId,
          // Not using eventRecord.id to distinguish between Event and ResourceTimeRange
          syncId: syncId
        },
        // Will not be part of DOM, but attached to the element
        elementData: data,
        // Dragging etc. flags element as retained, to not reuse/release it during that operation. Events
        // always use assignments, but ResourceTimeRanges does not
        retainElement: (assignmentRecord || eventRecord).instanceMeta(scheduler).retainElement,
        // Options for this level of sync, lower levels can have their own
        syncOptions: {
          syncIdField: 'taskFeature',
          // Remove instead of release when a feature is disabled
          releaseThreshold: 0
        }
      }; // Do not want to spam dataset with empty prop when not using assignments (ResourceTimeRanges)

      if (assignmentRecord) {
        elementConfig.dataset.assignmentId = assignmentRecord.id;
      }

      data.elementConfig = elementConfig;
      scheduler.trigger('beforeRenderEvent', {
        renderData: data,
        domConfig: elementConfig
      });
      return elementConfig;
    }
    /**
     * Refresh a row/record, clearing its cache and forcing DOM refresh.
     * @param {Scheduler.model.ResourceModel} recordOrRow Record or row to refresh
     * @param {Boolean} [force] Specify `false` to prevent clearing cache and forcing DOM refresh
     * @internal
     */

  }, {
    key: "refreshRow",
    value: function refreshRow(recordOrRow) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var row, record;

      if (recordOrRow.isModel) {
        row = this.scheduler.rowManager.getRowFor(recordOrRow);
        record = recordOrRow;
      } else {
        row = recordOrRow;
        record = this.resourceStore.getById(recordOrRow.id);
      }

      if (force) {
        this.clearResources([recordOrRow]);
      }

      if (row) {
        this.renderer({
          row: row,
          record: record
        });

        if (force) {
          this.onRenderDone();
        }
      }
    } // Called per row in "view", collect configs

  }, {
    key: "renderer",
    value: function renderer(_ref15) {
      var row = _ref15.row,
          resourceRecord = _ref15.record,
          _ref15$size = _ref15.size,
          size = _ref15$size === void 0 ? {} : _ref15$size;

      // Bail out for group headers/footers
      if (resourceRecord.isSpecialRow) {
        // Clear any cached layout for row retooled to special row, and bail out
        this.rowMap.delete(row);
        return;
      }

      var me = this,
          _me$visibleDateRange = me.visibleDateRange,
          startMS = _me$visibleDateRange.startMS,
          endMS = _me$visibleDateRange.endMS,
          eventDOMConfigs = []; // Used stored layouts if available

      var resourceLayout = me.resourceMap.get(resourceRecord.id);

      if (!resourceLayout || resourceLayout.invalid) {
        // Previously we would bail out here if engine wasn't ready. Now we instead allow drawing in most cases,
        // since data can be read and written during commit (previously it could not)
        if (me.suspended) {
          return;
        }

        resourceLayout = me.layoutResourceEvents(resourceRecord);
        me.resourceMap.set(resourceRecord.id, resourceLayout);
      } // Size row


      size.height = resourceLayout.rowHeight; // Only collect configs for those actually in view

      resourceLayout.eventsData.forEach(function (layout) {
        if (layout.endMS >= startMS && layout.startMS <= endMS) {
          layout.absoluteTop = layout.top + row.top;
          eventDOMConfigs.push(me.renderEvent(layout, resourceLayout.rowHeight));
        }
      });
      this.rowMap.set(row, eventDOMConfigs);
    } // Called when the current row rendering "pass" is complete, sync collected configs to DOM

  }, {
    key: "onRenderDone",
    value: function onRenderDone() {
      var scheduler = this.scheduler,
          rowMap = this.rowMap,
          visibleEventDOMConfigs = []; // Concat all rows event configs

      rowMap.forEach(function (eventDOMConfigs) {
        return visibleEventDOMConfigs.push.apply(visibleEventDOMConfigs, eventDOMConfigs);
      });
      _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_59__["default"].sync({
        domConfig: {
          onlyChildren: true,
          children: visibleEventDOMConfigs
        },
        targetElement: scheduler.foregroundCanvas,
        syncIdField: 'syncId',
        // Called by DomHelper when it creates, releases or reuses elements
        callback: function callback(_ref16) {
          var _domConfig$className;

          var action = _ref16.action,
              domConfig = _ref16.domConfig,
              lastDomConfig = _ref16.lastDomConfig,
              targetElement = _ref16.targetElement;

          // If element is a task wrap, trigger appropriate events
          if (action !== 'none' && (domConfig === null || domConfig === void 0 ? void 0 : (_domConfig$className = domConfig.className) === null || _domConfig$className === void 0 ? void 0 : _domConfig$className["".concat(scheduler.eventCls, "-wrap")])) {
            var // Some actions are considered first a release and then a render (reusing another element).
            // This gives clients code a chance to clean up before reusing an element
            isRelease = releaseEventActions[action],
                isRender = renderEventActions[action]; // Trigger release for events (it might be a proxy element, skip those)

            if (isRelease && (lastDomConfig === null || lastDomConfig === void 0 ? void 0 : lastDomConfig.elementData)) {
              var _lastDomConfig$elemen = lastDomConfig.elementData,
                  _eventRecord = _lastDomConfig$elemen.eventRecord,
                  resourceRecord = _lastDomConfig$elemen.resourceRecord,
                  assignmentRecord = _lastDomConfig$elemen.assignmentRecord,
                  event = {
                renderData: lastDomConfig.elementData,
                element: targetElement,
                eventRecord: _eventRecord,
                resourceRecord: resourceRecord,
                assignmentRecord: assignmentRecord
              }; // Some browsers do not blur on set to display:none, so releasing the active element
              // must *explicitly* move focus outwards to the view.

              if (targetElement === document.activeElement) {
                scheduler.focusElement.focus();
              } // This event is documented on Scheduler


              scheduler.trigger('releaseEvent', event);
            }

            if (isRender) {
              var _domConfig$elementDat = domConfig.elementData,
                  _eventRecord2 = _domConfig$elementDat.eventRecord,
                  _resourceRecord = _domConfig$elementDat.resourceRecord,
                  _assignmentRecord = _domConfig$elementDat.assignmentRecord,
                  _event = {
                renderData: domConfig.elementData,
                tplData: domConfig.elementData,
                // DEPRECATED IN 4.0
                element: targetElement,
                isReusingElement: action === 'reuseElement',
                isRepaint: action === 'reuseOwnElement',
                eventRecord: _eventRecord2,
                resourceRecord: _resourceRecord,
                assignmentRecord: _assignmentRecord
              }; // This event is documented on Scheduler

              scheduler.trigger('renderEvent', _event);
            }
          }
        }
      });
    } //endregion
    //region Cache
    // Clears cached resource layout

  }, {
    key: "clearResources",
    value: function clearResources(recordsOrIds) {
      var _this5 = this;

      if (recordsOrIds instanceof Set) {
        recordsOrIds = Array.from(recordsOrIds);
      } else if (!Array.isArray(recordsOrIds)) {
        recordsOrIds = [recordsOrIds];
      }

      var resourceIds = recordsOrIds.map(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_61__["default"].asId);
      resourceIds.forEach(function (resourceId) {
        // Invalidate resourceLayout, keeping it around in case we need it before next refresh
        var cached = _this5.resourceMap.get(resourceId);

        if (cached) {
          cached.invalid = true;
        }

        var row = _this5.scheduler.getRowById(resourceId);

        row && _this5.rowMap.delete(row);
      });
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.resourceMap.clear();
      this.rowMap.clear();
    } //endregion

  }, {
    key: "visibleDateRange",
    get: function get() {
      return this._visibleDateRange;
    }
  }], [{
    key: "configurable",
    //region Config & Init
    get: function get() {
      return {
        // It's needed to adjust visible date range in Export. Set to 100 to render additional 100px
        // worth of ticks which helps to scroll faster during export and fixes
        // issue when scrollToDate cannot reach panel end date on exceptionally narrow view
        scrollBuffer: 0
      };
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        // Map with event DOM configs, keyed by resource id
        resourceMap: new Map(),
        // Map with visible events DOM configs, keyed by row instance
        rowMap: new Map(),
        eventConfigs: [],
        // Flag to avoid transitioning on first refresh
        isFirstRefresh: true
      };
    }
  }]);

  return HorizontalRendering;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_60__["default"].mixin(_BaseRendering_js__WEBPACK_IMPORTED_MODULE_66__["default"], _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_65__["default"]));


HorizontalRendering._$name = 'HorizontalRendering';

/***/ }),

/***/ "./lib/Scheduler/view/orientation/VerticalRendering.js":
/*!*************************************************************!*\
  !*** ./lib/Scheduler/view/orientation/VerticalRendering.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VerticalRendering; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.array.reduce */ "./node_modules/core-js/modules/es.array.reduce.js");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.array.some */ "./node_modules/core-js/modules/es.array.some.js");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.object.keys */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/es.set */ "./node_modules/core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all */ "./node_modules/core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all */ "./node_modules/core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.difference */ "./node_modules/core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.every */ "./node_modules/core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.filter */ "./node_modules/core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.find */ "./node_modules/core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection */ "./node_modules/core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from */ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of */ "./node_modules/core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of */ "./node_modules/core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.join */ "./node_modules/core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.map */ "./node_modules/core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce */ "./node_modules/core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.some */ "./node_modules/core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference */ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.union */ "./node_modules/core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _eventlayout_VerticalLayout_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../../eventlayout/VerticalLayout.js */ "./lib/Scheduler/eventlayout/VerticalLayout.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../../data/mixin/AttachToProjectMixin.js */ "./lib/Scheduler/data/mixin/AttachToProjectMixin.js");
/* harmony import */ var _BaseRendering_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./BaseRendering.js */ "./lib/Scheduler/view/orientation/BaseRendering.js");










































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_39___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';










/**
 * @module Scheduler/view/orientation/VerticalRendering
 */

var releaseEventActions = {
  releaseElement: 1,
  // Not used at all at the moment
  reuseElement: 1 // Used by some other element

},
    renderEventActions = {
  newElement: 1,
  reuseOwnElement: 1,
  reuseElement: 1
},
    chronoFields = {
  startDate: 1,
  endDate: 1,
  duration: 1
};
/**
 * Handles event rendering in Schedulers vertical mode. Reacts to project/store changes to keep the UI up to date.
 *
 * @internal
 */

var VerticalRendering = /*#__PURE__*/function (_Base$mixin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_38___default()(VerticalRendering, _Base$mixin);

  var _super = _createSuper(VerticalRendering);

  function VerticalRendering() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_35___default()(this, VerticalRendering);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_36___default()(VerticalRendering, [{
    key: "construct",
    value: function construct(scheduler) {
      this.client = this.scheduler = scheduler;
      this.timeAxisViewModel = scheduler.timeAxisViewModel;
      this.verticalLayout = new _eventlayout_VerticalLayout_js__WEBPACK_IMPORTED_MODULE_46__["default"]({
        scheduler: scheduler
      });

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(VerticalRendering.prototype), "construct", this).call(this, {});
    }
  }, {
    key: "init",
    value: function init() {
      var me = this,
          scheduler = me.scheduler; // Resource header/columns

      me.resourceColumns = scheduler.timeAxisColumn.resourceColumns;
      me.resourceColumns.resourceStore = me.resourceStore;
      scheduler.element.classList.add('b-sch-vertical');
      me.resourceColumns.on({
        name: 'resourceColumns',
        columnWidthChange: 'onResourceColumnWidthChange',
        thisObj: me
      });
      me.initialized = true;

      if (scheduler.isPainted) {
        me.renderer();
      }

      me.resourceColumns.availableWidth = scheduler.timeAxisSubGridElement.offsetWidth;
    } //endregion
    //region Elements <-> Records

  }, {
    key: "resolveRowRecord",
    value: function resolveRowRecord(elementOrEvent, xy) {
      var me = this,
          scheduler = me.scheduler,
          event = elementOrEvent instanceof Event ? elementOrEvent : null,
          element = event ? event.target : elementOrEvent,
          coords = event ? [event.offsetX, event.offsetY] : xy,
          el = element.nodeType === 3 ? element.parentElement : element,
          eventElement = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].up(el, scheduler.eventSelector);

      if (eventElement) {
        return scheduler.resourceStore.getById(eventElement.dataset.resourceId);
      } // Need to be inside schedule at least


      if (!_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].up(element, '.b-sch-timeaxis-cell')) {
        return null;
      }

      if (!coords) {
        throw new Error("Vertical mode needs coordinates to resolve this element. Can also be called with a browser\n                event instead of element to extract element and coordinates from");
      }

      var index = Math.floor(coords[0] / me.resourceColumns.columnWidth);
      return scheduler.resourceStore.getAt(index);
    }
  }, {
    key: "toggleCls",
    value: function toggleCls(assignmentRecord, cls) {
      var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var useWrapper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var eventData = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"].getPath(this.eventMap, "".concat(assignmentRecord.eventId, ".").concat(assignmentRecord.resourceId));

      if (eventData) {
        eventData.renderData[useWrapper ? 'wrapperCls' : 'cls'][cls] = add; // Element from the map cannot be trusted, might be reused in which case map is not updated to reflect that.
        // To be safe, retrieve using `getElementFromAssignmentRecord`

        var element = this.getElementFromAssignmentRecord(assignmentRecord, useWrapper);

        if (element) {
          element.classList[add ? 'add' : 'remove'](cls);
        }
      }
    } //endregion
    //region Coordinate <-> Date

  }, {
    key: "getDateFromXY",
    value: function getDateFromXY(xy, roundingMethod, local) {
      var allowOutOfRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var coord = xy[1];

      if (!local) {
        coord = this.translateToScheduleCoordinate(coord);
      }

      return this.timeAxisViewModel.getDateFromPosition(coord, roundingMethod, allowOutOfRange);
    }
  }, {
    key: "translateToScheduleCoordinate",
    value: function translateToScheduleCoordinate(y) {
      return y - this.scheduler._bodyRectangle.y + this.scheduler.scrollTop;
    }
  }, {
    key: "translateToPageCoordinate",
    value: function translateToPageCoordinate(y) {
      return y + this.scheduler._bodyRectangle.y - this.scheduler.scrollTop;
    } //endregion
    //region Regions

  }, {
    key: "getResourceEventBox",
    value: function getResourceEventBox(event, resource) {
      var eventId = event.id,
          resourceId = resource.id;

      var _ref = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"].getPath(this.eventMap, "".concat(eventId, ".").concat(resourceId)) || {},
          renderData = _ref.renderData;

      if (!renderData) {
        // Never been in view, lay it out
        this.layoutResource(this.scheduler.resourceStore.getById(resourceId)); // Have another go at getting the layout data

        renderData = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"].getPath(this.eventMap, "".concat(eventId, ".").concat(resourceId)).renderData;
      }

      return renderData ? new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_47__["default"](renderData.left, renderData.top, renderData.width, renderData.bottom - renderData.top) : null;
    }
  }, {
    key: "getScheduleRegion",
    value: function getScheduleRegion(resourceRecord, eventRecord, local) {
      var me = this,
          scheduler = me.scheduler;
      var region = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_47__["default"].from(scheduler.timeAxisSubGridElement);

      if (resourceRecord) {
        // TODO: How to account for eventRecord here?
        region.left = me.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth;
        region.right = region.left + scheduler.resourceColumnWidth;
      }

      var start = scheduler.timeAxis.startDate,
          end = scheduler.timeAxis.endDate,
          dateConstraints = scheduler.getDateConstraints(resourceRecord, eventRecord) || {
        start: start,
        end: end
      },
          startY = scheduler.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].max(start, dateConstraints.start)),
          endY = scheduler.getCoordinateFromDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].min(end, dateConstraints.end));

      if (!local) {
        region.top = me.translateToPageCoordinate(startY);
        region.bottom = me.translateToPageCoordinate(endY);
      } else {
        region.top = startY;
        region.bottom = endY;
      }

      return region;
    }
  }, {
    key: "getRowRegion",
    value: function getRowRegion(resourceRecord, startDate, endDate) {
      var me = this,
          scheduler = me.scheduler,
          x = me.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth,
          taStart = scheduler.timeAxis.startDate,
          taEnd = scheduler.timeAxis.endDate,
          start = startDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].max(taStart, startDate) : taStart,
          end = endDate ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].min(taEnd, endDate) : taEnd,
          startY = scheduler.getCoordinateFromDate(start),
          endY = scheduler.getCoordinateFromDate(end, true, true),
          y = Math.min(startY, endY),
          height = Math.abs(startY - endY);
      return new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_47__["default"](x, y, scheduler.resourceColumnWidth, height);
    }
  }, {
    key: "onResourceColumnWidthChange",
    //endregion
    //region Events
    // Column width changed, rerender fully
    value: function onResourceColumnWidthChange(_ref2) {
      var width = _ref2.width,
          oldWidth = _ref2.oldWidth;
      var me = this,
          scheduler = me.scheduler; // Fix width of column & header

      me.resourceColumns.width = scheduler.timeAxisColumn.width = me.resourceStore.count * width;
      me.clearAll(); // Only transition large changes, otherwise it is janky when dragging slider in demo

      me.refresh(Math.abs(width - oldWidth) > 30); // Not detected by resizeobserver? Need to call this for virtual scrolling to react to update
      //        scheduler.callEachSubGrid('refreshFakeScroll');
      //        scheduler.refreshVirtualScrollbars();
    } //endregion
    //region Project

  }, {
    key: "attachToProject",
    value: function attachToProject(project) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(VerticalRendering.prototype), "attachToProject", this).call(this, project);

      if (project) {
        project.on({
          name: 'project',
          refresh: 'onProjectRefresh',
          thisObj: this
        });
      }
    }
  }, {
    key: "onProjectRefresh",
    value: function onProjectRefresh() {
      var me = this,
          scheduler = me.scheduler,
          toDrawOnProjectRefresh = me.toDrawOnProjectRefresh;

      if (scheduler.rendered && !scheduler.refreshSuspended) {
        // Either refresh all rows (on for example dataset)
        if (me.refreshAllWhenReady) {
          me.clearAll(); //scheduler.refreshWithTransition();

          me.refresh();
          me.refreshAllWhenReady = false;
        } // Or only affected rows (if any)
        else if (toDrawOnProjectRefresh.size) {
            me.refresh();
          }

        toDrawOnProjectRefresh.clear();
      }
    } //endregion
    //region EventStore

  }, {
    key: "attachToEventStore",
    value: function attachToEventStore(eventStore) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(VerticalRendering.prototype), "attachToEventStore", this).call(this, eventStore);

      this.refreshAllWhenReady = true;

      if (eventStore) {
        eventStore.on({
          name: 'eventStore',
          refreshPreCommit: 'onEventStoreRefresh',
          thisObj: this
        });
      }
    }
  }, {
    key: "onEventStoreRefresh",
    value: function onEventStoreRefresh(_ref3) {
      var action = _ref3.action;

      if (action === 'batch') {
        this.refreshAllWhenReady = true;
      }
    }
  }, {
    key: "onEventStoreChange",
    value: function onEventStoreChange(_ref4) {
      var action = _ref4.action,
          records = _ref4.records,
          record = _ref4.record,
          replaced = _ref4.replaced,
          changes = _ref4.changes,
          isAssign = _ref4.isAssign;
      var me = this,
          eventRecords = records || (record ? [record] : []),
          resourceIds = new Set();
      eventRecords.forEach(function (eventRecord) {
        eventRecord.resources.forEach(function (resourceRecord) {
          return resourceIds.add(resourceRecord.id);
        });
      });

      switch (action) {
        // No-ops
        case 'sort': // Order in EventStore does not matter, so these actions are no-ops

        case 'group':
        case 'move':
        case 'remove':
          // Remove is a no-op since assignment will also be removed
          return;

        case 'dataset':
          me.refreshAllResourcesWhenReady();
          return;

        case 'add':
        case 'updateMultiple':
          // Just refresh below
          break;

        case 'replace':
          // Gather resources from both the old record and the new one
          replaced.forEach(function (_ref5) {
            var _ref6 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34___default()(_ref5, 2),
                newEvent = _ref6[1];

            // Old cleared by changed assignment
            newEvent.resources.map(function (resourceRecord) {
              return resourceIds.add(resourceRecord.id);
            });
          }); // And clear them

          me.clearResources(resourceIds);
          break;

        case 'removeall':
        case 'filter':
          // Clear all when filtering for simplicity. If that turns out to give bad performance, one would need to
          // figure out which events was filtered out and only clear their resources.
          me.clearAll();
          me.refresh();
          return;

        case 'update':
          {
            // Check if changes are graph related or not
            var allChrono = record.$entity ? !Object.keys(changes).some(function (name) {
              return !record.$entity.getField(name);
            }) : !Object.keys(changes).some(function (name) {
              return !chronoFields[name];
            }); // If more than one of these in changes, it will affect visuals

            var changeCount = 0;
            if ('startDate' in changes) changeCount++;
            if ('endDate' in changes) changeCount++;
            if ('duration' in changes) changeCount++; // Always redraw non chrono changes (name etc)

            if (!allChrono || changeCount > 1) {
              me.clearResources(resourceIds);
              me.refresh();
            }

            return;
          }
      }

      me.refreshResourcesWhenReady(resourceIds);
    } //endregion
    //region ResourceStore

  }, {
    key: "attachToResourceStore",
    value: function attachToResourceStore(resourceStore) {
      var me = this;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(VerticalRendering.prototype), "attachToResourceStore", this).call(this, resourceStore);

      me.refreshAllWhenReady = true;

      if (me.resourceColumns) {
        me.resourceColumns.resourceStore = resourceStore;
      }

      resourceStore.on({
        name: 'resourceStore',
        changePreCommit: 'onResourceStoreChange',
        refreshPreCommit: 'onResourceStoreRefresh',
        // In vertical, resource store is not the row store but should toggle the load mask
        load: function load() {
          return me.scheduler.unmaskBody();
        },
        thisObj: me,
        prio: 1 // Call before others to clear cache before redraw

      });

      if (me.initialized) {
        // Invalidate resource range and events
        me.firstResource = me.lastResource = null;
        me.clearAll();
        me.renderer();
      }
    }
  }, {
    key: "onResourceStoreChange",
    value: function onResourceStoreChange(_ref7) {
      var resourceStore = _ref7.source,
          action = _ref7.action,
          records = _ref7.records,
          record = _ref7.record,
          replaced = _ref7.replaced,
          changes = _ref7.changes;
      var me = this,
          // records for add, record for update, replaced [[old, new]] for replace
      resourceRecords = records || (replaced ? replaced.map(function (r) {
        return r[1];
      }) : record ? [record] : []),
          resourceIds = new Set(resourceRecords.map(function (resourceRecord) {
        return resourceRecord.id;
      })); // Invalidate resource range

      me.firstResource = me.lastResource = null; // Operation that did not invalidate engine, refresh directly

      if (me.scheduler.isEngineReady) {
        switch (action) {
          case 'update':
            if (changes && changes.id) {
              me.clearResources([changes.id.oldValue, changes.id.value]);
            } // Only the invalidation above needed


            break;

          case 'filter':
            // All filtered out resources needs clearing and so does those not filtered out since they might have
            // moved horizontally when others hide
            me.clearAll();
            break;
        }

        me.refresh(true);
      } // Operation that did invalidate project, update on project refresh
      else {
          switch (action) {
            case 'dataset':
            case 'remove': // Cannot tell from which index it was removed

            case 'removeall':
              me.refreshAllResourcesWhenReady();
              return;

            case 'replace':
            case 'add':
              {
                // Make sure all existing events following added resources are offset correctly
                var firstIndex = resourceRecords.reduce(function (index, record) {
                  return Math.min(index, resourceStore.indexOf(record));
                }, resourceStore.count);

                for (var i = firstIndex; i < resourceStore.count; i++) {
                  resourceIds.add(resourceStore.getAt(i).id);
                }
              }
          }

          me.refreshResourcesWhenReady(resourceIds);
        }
    }
  }, {
    key: "onResourceStoreRefresh",
    value: function onResourceStoreRefresh(_ref8) {
      var action = _ref8.action;
      var me = this;

      if (action === 'group') {
        throw new Error('Grouping of resources not supported in vertical mode');
      }

      if (action === 'sort') {
        // Invalidate resource range
        me.firstResource = me.lastResource = null;
        me.clearAll();
        me.refresh();
      }
    } //endregion
    //region AssignmentStore

  }, {
    key: "attachToAssignmentStore",
    value: function attachToAssignmentStore(assignmentStore) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_37___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_40___default()(VerticalRendering.prototype), "attachToAssignmentStore", this).call(this, assignmentStore);

      this.refreshAllWhenReady = true;

      if (assignmentStore) {
        assignmentStore.on({
          name: 'assignmentStore',
          changePreCommit: 'onAssignmentStoreChange',
          refreshPreCommit: 'onAssignmentStoreRefresh',
          thisObj: this
        });
      }
    }
  }, {
    key: "onAssignmentStoreChange",
    value: function onAssignmentStoreChange(_ref9) {
      var action = _ref9.action,
          records = _ref9.records,
          replaced = _ref9.replaced,
          record = _ref9.record,
          changes = _ref9.changes;
      var me = this,
          assignmentRecords = records || (record ? [record] : []),
          resourceIds = new Set(assignmentRecords.map(function (assignmentRecord) {
        return assignmentRecord.resourceId;
      })); // Operation that did not invalidate engine, refresh directly

      if (me.scheduler.isEngineReady) {
        switch (action) {
          case 'filter':
            me.clearAll();
            break;

          case 'update':
            {
              // When reassigning, clear old resource also
              if ('resourceId' in changes) {
                resourceIds.add(changes.resourceId.oldValue);
              } // Ignore engine resolving resourceId -> resource, eventId -> event


              if (!Object.keys(changes).filter(function (field) {
                return field !== 'resource' && field !== 'event';
              }).length) {
                return;
              }

              me.clearResources(resourceIds);
            }
        }

        me.refresh(true);
      } // Operation that did invalidate project, update on project refresh
      else {
          switch (action) {
            case 'removeall':
              me.refreshAllResourcesWhenReady();
              return;

            case 'replace':
              // Gather resources from both the old record and the new one
              replaced.forEach(function (_ref10) {
                var _ref11 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_34___default()(_ref10, 2),
                    oldAssignment = _ref11[0],
                    newAssignment = _ref11[1];

                resourceIds.add(oldAssignment.resourceId);
                resourceIds.add(newAssignment.resourceId);
              });
          }

          me.refreshResourcesWhenReady(resourceIds);
        }
    }
  }, {
    key: "onAssignmentStoreRefresh",
    value: function onAssignmentStoreRefresh(_ref12) {
      var action = _ref12.action,
          records = _ref12.records;

      if (action === 'batch') {
        this.clearResources(records.map(function (assignment) {
          return assignment.resourceId;
        }));
        this.renderer();
      }
    } //endregion
    //region View hooks

  }, {
    key: "refreshRows",
    value: function refreshRows(reLayoutEvents) {
      if (reLayoutEvents) {
        this.clearAll();
        this.scheduler.refreshFromRerender = false;
      }
    } // Called from SchedulerEventRendering

  }, {
    key: "repaintEventsForResource",
    value: function repaintEventsForResource(resourceRecord) {
      this.renderResource(resourceRecord);
    }
  }, {
    key: "updateFromHorizontalScroll",
    value: function updateFromHorizontalScroll(scrollLeft) {
      if (scrollLeft !== this.prevScrollLeft) {
        this.renderer();
        this.prevScrollLeft = scrollLeft;
      }
    }
  }, {
    key: "updateFromVerticalScroll",
    value: function updateFromVerticalScroll() {
      this.renderer();
    }
  }, {
    key: "scrollResourceIntoView",
    value: function scrollResourceIntoView(resourceRecord, options) {
      var scheduler = this.scheduler,
          x = scheduler.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth;
      return scheduler.scrollHorizontallyTo(x, options);
    } // Called when viewport size changes

  }, {
    key: "onViewportResize",
    value: function onViewportResize(width) {
      this.resourceColumns.availableWidth = width;
      this.renderer();
    } // Clear events in case they use date as part of displayed info

  }, {
    key: "onLocaleChange",
    value: function onLocaleChange() {
      this.clearAll();
    } // No need to do anything special

  }, {
    key: "onDragAbort",
    value: function onDragAbort() {}
  }, {
    key: "onBeforeRowHeightChange",
    value: function onBeforeRowHeightChange() {}
  }, {
    key: "onTimeAxisViewModelUpdate",
    value: function onTimeAxisViewModelUpdate() {}
  }, {
    key: "updateElementId",
    value: function updateElementId() {}
  }, {
    key: "releaseTimeSpanDiv",
    value: function releaseTimeSpanDiv() {} //endregion
    //region Refresh resources

    /**
     * Clears resources directly and redraws them on next project refresh
     * @param {Number[]|String[]} resourceIds
     * @private
     */

  }, {
    key: "refreshResourcesWhenReady",
    value: function refreshResourcesWhenReady(resourceIds) {
      var _this = this;

      this.clearResources(resourceIds);
      resourceIds.forEach(function (id) {
        return _this.toDrawOnProjectRefresh.add(id);
      });
    }
    /**
     * Clears all resources directly and redraws them on next project refresh
     * @private
     */

  }, {
    key: "refreshAllResourcesWhenReady",
    value: function refreshAllResourcesWhenReady() {
      this.clearAll();
      this.refreshAllWhenReady = true;
    } //region Rendering
    // Resources in view + buffer

  }, {
    key: "getTimeSpanRenderData",
    value: function getTimeSpanRenderData(eventRecord, resourceRecord) {
      var includeOutside = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var me = this,
          scheduler = me.scheduler,
          startDate = eventRecord.startDate,
          endDate = eventRecord.endDate,
          top = scheduler.getCoordinateFromDate(startDate),
          left = me.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth,
          width = scheduler.resourceColumnWidth - scheduler.resourceMargin * 2,
          startDateMS = startDate.getTime(),
          endDateMS = endDate.getTime();
      var bottom = scheduler.getCoordinateFromDate(endDate),
          height = bottom - top; // Below, estimate height

      if (bottom === -1) {
        height = Math.round((endDateMS - startDateMS) * scheduler.timeAxisViewModel.getSingleUnitInPixels('ms'));
        bottom = top + height;
      }

      return {
        eventRecord: eventRecord,
        resourceRecord: resourceRecord,
        left: left,
        top: top,
        bottom: bottom,
        width: width,
        height: height,
        startDate: startDate,
        endDate: endDate,
        startDateMS: startDateMS,
        endDateMS: endDateMS,
        children: [],
        // to match horizontal, TODO: should change there
        start: startDate,
        end: endDate,
        startMs: startDateMS,
        endMs: endDateMS
      };
    } // Earlier start dates are above later tasks
    // If same start date, longer tasks float to top
    // If same start + duration, sort by name

  }, {
    key: "eventSorter",
    value: function eventSorter(a, b) {
      var startA = a.dataStartMs || a.startDateMS,
          // dataXX are used if configured with fillTicks
      endA = a.dataEndMs || a.endDateMS,
          startB = b.dataStartMs || b.startDateMS,
          endB = b.dataEndMs || b.endDateMS,
          nameA = a.isModel ? a.name : a.eventRecord.name,
          nameB = b.isModel ? b.name : b.eventRecord.name;
      return startA - startB || endB - endA || (nameA < nameB ? -1 : nameA == nameB ? 0 : 1);
    } // Calculate the layout for all events assigned to a resource. Since we are never stacking, the layout of one
    // resource will never affect the others

  }, {
    key: "layoutResource",
    value: function layoutResource(resourceRecord) {
      var me = this,
          scheduler = me.scheduler,
          assignmentStore = scheduler.assignmentStore,
          eventStore = scheduler.eventStore,
          cache = me.resourceMap[resourceRecord.id] = {},
          resourceIndex = scheduler.resourceStore.indexOf(resourceRecord); // Events for the resource, minus those that are filtered out by filtering assignments and events

      var events = resourceRecord.assignments.reduce(function (events, assignmentRecord) {
        if (assignmentStore.isAvailable(assignmentRecord) && eventStore.isAvailable(assignmentRecord.event)) {
          events.push(assignmentRecord.event);
        }

        return events;
      }, []); // Hook for features to inject additional timespans to render

      events = scheduler.getEventsToRender(resourceRecord, events); // Generate template data for all events, used for rendering and layout

      var layoutData = events.reduce(function (toLayout, eventRecord) {
        var renderData = scheduler.generateRenderData(eventRecord, resourceRecord),
            // Elements will be appended to eventData during syncing
        eventData = {
          renderData: renderData
        }; // Cache per event, { e1 : { r1 : { xxx }, r2 : ... }, e2 : ... }
        // Uses renderData.eventId in favor of eventRecord.id to work with ResourceTimeRanges

        _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"].setPath(me.eventMap, "".concat(renderData.eventId, ".").concat(resourceRecord.id), eventData); // Cache per resource

        cache[renderData.eventId] = eventData; // Position ResourceTimeRanges directly, they do not affect the layout of others

        if (renderData.fillSize) {
          renderData.left = resourceIndex * scheduler.resourceColumnWidth;
          renderData.width = scheduler.resourceColumnWidth;
        } // Anything not flagged with `fillSize` should take part in layout
        else {
            toLayout.push(renderData);
          }

        return toLayout;
      }, []); // Ensure the events are rendered in natural order so that navigation works.

      layoutData.sort(me.eventSorter); // Apply per resource event layout (pack, overlap or mixed)

      me.verticalLayout.applyLayout(layoutData, scheduler.resourceColumnWidth, scheduler.resourceMargin, scheduler.barMargin, resourceIndex);
      return cache;
    }
    /**
     * Used by event drag features to bring into existence event elements that are outside of the rendered block.
     * @param {Scheduler.model.TimeSpan} eventRecord The event to render
     * @private
     */

  }, {
    key: "addTemporaryDragElement",
    value: function addTemporaryDragElement(eventRecord) {
      var scheduler = this.scheduler,
          renderData = scheduler.generateRenderData(eventRecord, eventRecord.resource, {
        timeAxis: true,
        viewport: true
      });
      renderData.top = renderData.row ? renderData.top + renderData.row.top : scheduler.getResourceEventBox(eventRecord, eventRecord.resource, true).top;
      var domConfig = this.renderEvent({
        renderData: renderData
      }),
          dataset = domConfig.dataset;
      delete domConfig.tabIndex;
      delete dataset.eventId;
      delete dataset.resourceId;
      delete dataset.syncId;
      dataset.transient = true;
      domConfig.parent = this.scheduler.foregroundCanvas; // So that the regular DomSyncing which may happen during scroll does not
      // sweep up and reuse the temporary element.

      domConfig.retainElement = true;
      var result = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"].createElement(domConfig);
      result.innerElement = result.firstChild;
      eventRecord.instanceMeta(scheduler).hasTemporaryDragElement = true;
      return result;
    } // TODO: Pretty much identical to HorizontalRendering#renderEvent. Make shared base class
    // Render a single event, aborting if already in DOM. To update an event, first release its element and then render
    // it again. The element will be reused and updated. Keeps code simpler

  }, {
    key: "renderEvent",
    value: function renderEvent(eventData) {
      // No point in rendering event that already has an element
      var data = eventData.renderData,
          resourceRecord = data.resourceRecord,
          assignmentRecord = data.assignmentRecord,
          elementConfig = {
        className: data.wrapperCls,
        tabIndex: '0',
        children: [{
          className: data.cls,
          style: (data.internalStyle || '') + (data.style || ''),
          children: data.children,
          dataset: {
            // Each feature putting contents in the event wrap should have this to simplify syncing and
            // element retrieval after sync
            taskFeature: 'event'
          },
          syncOptions: {
            syncIdField: 'taskBarFeature'
          }
        }].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_33___default()(data.wrapperChildren)),
        style: {
          transform: "translate(".concat(data.left, "px, ").concat(data.top, "px)"),
          // DomHelper appends px to dimensions when using numbers
          height: data.height,
          width: data.width,
          zIndex: data.zIndex,
          style: data.wrapperStyle || ''
        },
        dataset: {
          resourceId: resourceRecord.id,
          eventId: data.eventId,
          // Not using eventRecord.id to distinguish between Event and ResourceTimeRange
          // Sync using assignment id for events and event id for ResourceTimeRanges
          syncId: assignmentRecord ? assignmentRecord.id : data.eventId
        },
        // Will not be part of DOM, but attached to the element
        elementData: eventData,
        // Dragging etc. flags element as retained, to not reuse/release it during that operation. Events
        // always use assignments, but ResourceTimeRanges does not
        retainElement: (assignmentRecord || data.eventRecord).instanceMeta(this.scheduler).retainElement,
        // Options for this level of sync, lower levels can have their own
        syncOptions: {
          syncIdField: 'taskFeature',
          // Remove instead of release when a feature is disabled
          releaseThreshold: 0
        }
      }; // Do not want to spam dataset with empty prop when not using assignments (ResourceTimeRanges)

      if (assignmentRecord) {
        elementConfig.dataset.assignmentId = assignmentRecord.id;
      }

      this.scheduler.trigger('beforeRenderEvent', {
        renderData: data,
        domConfig: elementConfig
      }); // Allows access to the used config later, for example to retrieve element

      eventData.elementConfig = elementConfig;
      return elementConfig;
    }
  }, {
    key: "renderResource",
    value: function renderResource(resourceRecord) {
      var me = this,
          topDateMS = me.topDateMS,
          bottomDateMS = me.bottomDateMS,
          syncConfigs = [];
      var resourceEntry = me.resourceMap[resourceRecord.id]; // Layout all events for the resource unless already done

      if (!resourceEntry) {
        resourceEntry = me.layoutResource(resourceRecord);
      } // Iterate over all events for the resource


      for (var eventId in resourceEntry) {
        var eventData = resourceEntry[eventId],
            _eventData$renderData = eventData.renderData,
            endDateMS = _eventData$renderData.endDateMS,
            startDateMS = _eventData$renderData.startDateMS,
            eventRecord = _eventData$renderData.eventRecord;

        if ( // Only collect configs for those actually in view
        endDateMS >= topDateMS && startDateMS <= bottomDateMS && // And not being dragged, those has a temporary element already
        !eventRecord.instanceMeta(me.scheduler).hasTemporaryDragElement) {
          syncConfigs.push(me.renderEvent(eventData));
        }
      }

      return syncConfigs;
    }
  }, {
    key: "isEventElement",
    value: function isEventElement(domConfig) {
      var className = domConfig && domConfig.className;
      return className && className[this.scheduler.eventCls + '-wrap'];
    } // Single cell so only one call to this renderer, determine which events are in view and draw them.
    // Drawing on scroll is triggered by `updateFromVerticalScroll()` and `updateFromHorizontalScroll()`

  }, {
    key: "renderer",
    value: function renderer() {
      var me = this,
          scheduler = me.scheduler,
          resourceStore = scheduler.resourceStore,
          _me$resourceRange = me.resourceRange,
          firstResource = _me$resourceRange.firstResource,
          lastResource = _me$resourceRange.lastResource,
          _me$dateRange = me.dateRange,
          topDate = _me$dateRange.topDate,
          bottomDate = _me$dateRange.bottomDate,
          syncConfigs = [],
          featureDomConfigs = [];

      if (!me.initialized || !me.scheduler.isEngineReady) {
        return;
      } // Update current time range, reflecting the change on the vertical time axis header


      if (!_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].isEqual(topDate, me.topDate) || !_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"].isEqual(bottomDate, me.bottomDate)) {
        // Calculated values used by `renderResource()`
        me.topDate = topDate;
        me.bottomDate = bottomDate;
        me.topDateMS = topDate.getTime();
        me.bottomDateMS = bottomDate.getTime();
        me.timeView.range = {
          startDate: topDate,
          endDate: bottomDate
        };
        scheduler.trigger('visibleRangeChange', {
          startDate: topDate,
          endDate: bottomDate
        });
      }

      if (firstResource !== -1 && lastResource !== -1) {
        // Collect all events for resources in view
        for (var i = firstResource; i <= lastResource; i++) {
          syncConfigs.push.apply(syncConfigs, me.renderResource(resourceStore.getAt(i)));
        }
      }

      scheduler.getForegroundDomConfigs(featureDomConfigs);
      syncConfigs.push.apply(syncConfigs, featureDomConfigs);
      _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_44__["default"].sync({
        domConfig: {
          onlyChildren: true,
          children: syncConfigs
        },
        targetElement: scheduler.foregroundCanvas,
        syncIdField: 'syncId',
        // Called by DomHelper when it creates, releases or reuses elements
        callback: function callback(_ref13) {
          var action = _ref13.action,
              domConfig = _ref13.domConfig,
              lastDomConfig = _ref13.lastDomConfig,
              targetElement = _ref13.targetElement;

          // If element is an event wrap, trigger appropriate events
          if (me.isEventElement(domConfig)) {
            var // Some actions are considered first a release and then a render (reusing another element).
            // This gives clients code a chance to clean up before reusing an element
            isRelease = releaseEventActions[action],
                isRender = renderEventActions[action]; // If we are reusing an element that was previously released we should not trigger again

            if (isRelease && me.isEventElement(lastDomConfig) && !lastDomConfig.isReleased) {
              var data = lastDomConfig.elementData.renderData,
                  event = {
                renderData: data,
                assignmentRecord: data.assignmentRecord,
                eventRecord: data.eventRecord,
                resourceRecord: data.resourceRecord,
                element: targetElement
              }; // Some browsers do not blur on set to display:none, so releasing the active element
              // must *explicitly* move focus outwards to the view.

              if (targetElement === document.activeElement) {
                scheduler.focusElement.focus();
              } // This event is documented on Scheduler


              scheduler.trigger('releaseEvent', event);
            }

            if (isRender) {
              var _data = domConfig.elementData.renderData,
                  _event = {
                renderData: _data,
                tplData: _data,
                // DEPRECATED IN 4.0
                assignmentRecord: _data.assignmentRecord,
                eventRecord: _data.eventRecord,
                resourceRecord: _data.resourceRecord,
                element: targetElement,
                isReusingElement: action === 'reuseElement',
                isRepaint: action === 'reuseOwnElement'
              };
              _event.reusingElement = action === 'reuseElement'; // This event is documented on Scheduler

              scheduler.trigger('renderEvent', _event);
            }
          }
        }
      }); // Change in displayed resources?

      if (me.firstResource !== firstResource || me.lastResource !== lastResource) {
        // Update header to match
        me.resourceColumns.range = {
          firstResource: firstResource,
          lastResource: lastResource
        }; // Store which resources are currently in view

        me.firstResource = firstResource;
        me.lastResource = lastResource;
      }
    }
  }, {
    key: "refresh",
    value: function refresh(transition) {
      var _this2 = this;

      this.scheduler.runWithTransition(function () {
        return _this2.renderer();
      }, transition);
    } // To match horizontals API, used from EventDrag

  }, {
    key: "refreshResources",
    value: function refreshResources(resourceIds) {
      this.clearResources(resourceIds);
      this.refresh();
    } //endregion
    //region Other

  }, {
    key: "clearResources",
    //endregion
    //region Cache
    // Clears cached resource layout
    value: function clearResources(resourceIds) {
      var _this3 = this;

      resourceIds.forEach(function (resourceId) {
        if (_this3.resourceMap[resourceId]) {
          Object.keys(_this3.resourceMap[resourceId]).forEach(function (eventId) {
            delete _this3.eventMap[eventId][resourceId];
          });
          delete _this3.resourceMap[resourceId];
        }
      });
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.resourceMap = {};
      this.eventMap = {};
    } //endregion

  }, {
    key: "visibleDateRange",
    get: function get() {
      var scheduler = this.scheduler,
          scrollPos = scheduler.scrollable.y,
          height = scheduler.scrollable.clientHeight;
      return {
        startDate: scheduler.getDateFromCoordinate(scrollPos),
        endDate: scheduler.getDateFromCoordinate(scrollPos + height) || scheduler.timeAxis.endDate
      };
    }
  }, {
    key: "resourceRange",
    get: function get() {
      var scheduler = this.scheduler,
          resourceStore = this.resourceStore;

      if (!resourceStore || !resourceStore.count) {
        return {
          firstResource: -1,
          lastResource: -1
        };
      }

      return {
        firstResource: Math.max(Math.floor(scheduler.scrollLeft / scheduler.resourceColumnWidth) - 1, 0),
        lastResource: Math.min(Math.floor((scheduler.scrollLeft + scheduler.timeAxisSubGrid.width) / scheduler.resourceColumnWidth) + 1, resourceStore.count - 1)
      };
    } // Dates in view + buffer

  }, {
    key: "dateRange",
    get: function get() {
      var scheduler = this.scheduler;
      var bottomDate = scheduler.getDateFromCoordinate(Math.min(scheduler.scrollTop + scheduler.bodyHeight + scheduler.tickSize - 1, (scheduler.virtualScrollHeight || scheduler.scrollable.scrollHeight) - 1)); // Might end up below time axis (out of ticks)
      // TODO: Change call order on refresh to make sure this is not needed?

      if (!bottomDate) {
        bottomDate = scheduler.timeAxis.last.endDate;
      }

      var topDate = scheduler.getDateFromCoordinate(Math.max(scheduler.scrollTop - scheduler.tickSize, 0)); // Might end up above time axis when reconfiguring (since this happens as part of rendering)

      if (!topDate) {
        topDate = scheduler.timeAxis.first.startDate;
        bottomDate = scheduler.getDateFromCoordinate(scheduler.bodyHeight + scheduler.tickSize - 1);
      }

      return {
        topDate: topDate,
        bottomDate: bottomDate
      };
    }
  }, {
    key: "timeView",
    get: function get() {
      return this.scheduler.timeView;
    }
  }], [{
    key: "properties",
    //region Config & Init
    get: function get() {
      return {
        eventMap: {},
        resourceMap: {},
        releasedElements: {},
        toDrawOnProjectRefresh: new Set()
      };
    }
  }]);

  return VerticalRendering;
}(_Core_Base_js__WEBPACK_IMPORTED_MODULE_41__["default"].mixin(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_42__["default"], _BaseRendering_js__WEBPACK_IMPORTED_MODULE_50__["default"], _data_mixin_AttachToProjectMixin_js__WEBPACK_IMPORTED_MODULE_49__["default"]));


VerticalRendering._$name = 'VerticalRendering';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js":
/*!**********************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceConfirmationPopup; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/recurrence/RecurrenceConfirmationPopup
 */

/**
 * Confirmation dialog showing up before modifying a recurring event or some of its occurrences.
 * For recurring events the dialog notifies user that the event change/removal will cause all its occurrences
 * change/removal and asks to confirm the action.
 *
 * And for occurrences the dialog allows to choose if user wants to affect all further occurrences, this occurrence only or cancel the change.
 *
 * Usage example:
 *
 * ```javascript
 * const confirmation = new RecurrenceConfirmationPopup();
 *
 * confirmation.confirm({
 *     eventRecord : recurringEvent,
 *     actionType  : "delete",
 *     changerFn   : () => recurringEvent.remove(event)
 * });
 * ```
 *
 * @classType recurrenceconfirmation
 * @extends Core/widget/Popup
 */

var RecurrenceConfirmationPopup = /*#__PURE__*/function (_Popup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(RecurrenceConfirmationPopup, _Popup);

  var _super = _createSuper(RecurrenceConfirmationPopup);

  function RecurrenceConfirmationPopup() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, RecurrenceConfirmationPopup);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(RecurrenceConfirmationPopup, [{
    key: "onChangeMultipleButtonClick",

    /**
     * Handler for "Apply changes to multiple occurrences" {@link #property-changeMultipleButton button}.
     * It calls {@link #function-processMultipleRecords} and then hides the dialog.
     */
    value: function onChangeMultipleButtonClick() {
      this.processMultipleRecords();
      this.hide();
    }
    /**
     * Handler for the {@link #property-changeSingleButton button} that causes changing of the event itself only.
     * It calls {@link #function-processSingleRecord} and then hides the dialog.
     */

  }, {
    key: "onChangeSingleButtonClick",
    value: function onChangeSingleButtonClick() {
      this.processSingleRecord();
      this.hide();
    }
    /**
     * Handler for {@link #property-cancelButton cancel button}.
     * It calls `cancelFn` provided to {@link #function-confirm} call and then hides the dialog.
     */

  }, {
    key: "onCancelButtonClick",
    value: function onCancelButtonClick() {
      this.cancelFn && this.cancelFn.call(this.thisObj);
      this.hide();
    }
  }, {
    key: "onRecurrenceClose",
    value: function onRecurrenceClose() {
      if (this.cancelFn) {
        this.cancelFn.call(this.thisObj);
      }

      this.hide();
    }
    /**
     * Displays the confirmation.
     * Usage example:
     *
     * ```javascript
     * const popup = new RecurrenceConfirmationPopup();
     *
     * popup.confirm({
     *     eventRecord,
     *     actionType : "delete",
     *     changerFn  : () => eventStore.remove(record)
     * });
     * ```
     *
     * @param {Object}                     config               The following config options are supported:
     * @param {Scheduler.model.EventModel} config.eventRecord   Event being modified.
     * @param {String}                     config.actionType    Type of modification to be applied to the event. Can be either "update" or "delete".
     * @param {Function}                   config.changerFn     A function that should be called to apply the change to the event upon user choice.
     * @param {Function}                   [config.thisObj]     `changerFn` and `cancelFn` functions scope.
     * @param {Function}                   [config.cancelFn]    Function called on `Cancel` button click.
     */

  }, {
    key: "confirm",
    value: function confirm() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this;
      ['actionType', 'eventRecord', 'title', 'html', 'changerFn', 'cancelFn', 'thisObj'].forEach(function (prop) {
        if (prop in config) me[prop] = config[prop];
      });
      me.updatePopupContent();
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(RecurrenceConfirmationPopup.prototype), "show", this).call(this, config);
    }
  }, {
    key: "updatePopupContent",
    value: function updatePopupContent() {
      var me = this,
          _me$widgetMap = me.widgetMap,
          changeMultipleButton = _me$widgetMap.changeMultipleButton,
          changeSingleButton = _me$widgetMap.changeSingleButton,
          cancelButton = _me$widgetMap.cancelButton,
          eventRecord = me.eventRecord,
          _me$actionType = me.actionType,
          actionType = _me$actionType === void 0 ? 'update' : _me$actionType,
          isMaster = eventRecord && eventRecord.isRecurring; // Do not remove. Assertion strings for Localization sanity check.
      // 'L{delete-further-message}'
      // 'L{update-further-message}'
      // 'L{delete-all-message}'
      // 'L{update-all-message}'
      // 'L{delete-further-btn-text}'
      // 'L{update-further-btn-text}'
      // 'L{delete-only-this-btn-text}'
      // 'L{update-only-this-btn-text}'

      if (isMaster) {
        changeMultipleButton.text = me.L('L{Object.Yes}');
        me.html = me.L("".concat(actionType, "-all-message"));
      } else {
        changeMultipleButton.text = me.L("".concat(actionType, "-further-btn-text"));
        me.html = me.L("".concat(actionType, "-further-message"));
      }

      changeSingleButton.text = me.L("".concat(actionType, "-only-this-btn-text"));
      cancelButton.text = me.L('L{Object.Cancel}'); // TODO: so far we hide 'Only this event' option for a recurring event itself until this case is supported

      if (isMaster) {
        changeSingleButton.hide();
      } else {
        changeSingleButton.show();
      }

      me.width = me.L('L{width}'); // the following lines are added to satisfy the 904_unused localization test
      // to let it know that these locales are used:
      // this.L('L{delete-title}') not found
      // this.L('L{update-title}') not found

      me.title = me.L("".concat(actionType, "-title"));
    }
    /**
     * Applies changes to multiple occurrences as reaction on "Apply changes to multiple occurrences"
     * {@link #property-changeMultipleButton button} click.
     */

  }, {
    key: "processMultipleRecords",
    value: function processMultipleRecords() {
      var eventRecord = this.eventRecord,
          changerFn = this.changerFn,
          thisObj = this.thisObj;
      eventRecord.beginBatch(); // Apply changes to the occurrence.
      // It is not joined to any stores, so this has no consequence.

      this.callback(changerFn, thisObj, [eventRecord]); // afterChange will promote it to being an new recurring base because there's still recurrence

      eventRecord.endBatch();
    }
    /**
     * Applies changes to a single record by making it a "real" event and adding an exception to the recurrence.
     * The method is called as reaction on clicking the {@link #property-changeSingleButton button} that causes changing of the event itself only.
     */

  }, {
    key: "processSingleRecord",
    value: function processSingleRecord() {
      var eventRecord = this.eventRecord,
          changerFn = this.changerFn,
          thisObj = this.thisObj;
      eventRecord.beginBatch(); // When the changes apply, because there's no recurrence, it will become an exception

      eventRecord.recurrence = null; // Apply changes to the occurrence.
      // It is not joined to any stores, so this has no consequence.

      this.callback(changerFn, thisObj, [eventRecord]); // Must also change after the callback in case the callback sets the rule.
      // This will update the batch update data block to prevent it being set back to recurring.

      eventRecord.recurrenceRule = null; // afterChange will promote it to being an exception because there's no recurrence

      eventRecord.endBatch();
    }
  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      this.updatePopupContent();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(RecurrenceConfirmationPopup.prototype), "updateLocalization", this).call(this);
    }
  }, {
    key: "changeMultipleButton",

    /**
     * Reference to the "Apply changes to multiple occurrences" button, if used
     * @property {Core.widget.Button} changeMultipleButton
     * @readonly
     */
    get: function get() {
      return this.widgetMap.changeMultipleButton;
    }
    /**
     * Reference to the button that causes changing of the event itself only, if used
     * @property {Core.widget.Button} changeSingleButton
     * @readonly
     */

  }, {
    key: "changeSingleButton",
    get: function get() {
      return this.widgetMap.changeSingleButton;
    }
    /**
     * Reference to the cancel button, if used
     * @property {Core.widget.Button} cancelButton
     * @readonly
     */

  }, {
    key: "cancelButton",
    get: function get() {
      return this.widgetMap.cancelButton;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceConfirmationPopup';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrenceconfirmation';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        localizableProperties: [],
        align: 'b-t',
        autoShow: false,
        autoClose: false,
        closeAction: 'onRecurrenceClose',
        modal: true,
        centered: true,
        scrollAction: 'realign',
        constrainTo: window,
        draggable: true,
        closable: true,
        floating: true,
        eventRecord: null,
        cls: 'b-sch-recurrenceconfirmation',
        bbar: {
          defaults: {
            localeClass: this
          },
          items: {
            changeMultipleButton: {
              weight: 100,
              color: 'b-green',
              text: 'L{Object.Yes}',
              onClick: 'up.onChangeMultipleButtonClick'
            },
            changeSingleButton: {
              weight: 200,
              color: 'b-gray',
              text: 'L{update-only-this-btn-text}',
              onClick: 'up.onChangeSingleButtonClick'
            },
            cancelButton: {
              weight: 300,
              color: 'b-gray',
              text: 'L{Object.Cancel}',
              onClick: 'up.onCancelButtonClick'
            }
          }
        }
      };
    }
  }]);

  return RecurrenceConfirmationPopup;
}(_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_10__["default"]);


; // Register this widget type with its Factory

RecurrenceConfirmationPopup.initClass();
RecurrenceConfirmationPopup._$name = 'RecurrenceConfirmationPopup';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/RecurrenceEditor.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/RecurrenceEditor.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceEditor; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.index-of */ "./node_modules/core-js/modules/es.array.index-of.js");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony import */ var _Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony import */ var _field_RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./field/RecurrenceFrequencyCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js");
/* harmony import */ var _field_RecurrenceDaysCombo_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./field/RecurrenceDaysCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js");
/* harmony import */ var _field_RecurrenceDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./field/RecurrenceDaysButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js");
/* harmony import */ var _field_RecurrenceMonthDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./field/RecurrenceMonthDaysButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js");
/* harmony import */ var _field_RecurrenceMonthsButtonGroup_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./field/RecurrenceMonthsButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js");
/* harmony import */ var _field_RecurrenceStopConditionCombo_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./field/RecurrenceStopConditionCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js");
/* harmony import */ var _field_RecurrencePositionsCombo_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./field/RecurrencePositionsCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';














/**
 * @module Scheduler/view/recurrence/RecurrenceEditor
 */

/**
 * Class implementing a dialog to edit {@link Scheduler.model.RecurrenceModel Recurrence model}.
 * The class is used by the {@link Scheduler.view.mixin.RecurringEvents recurring events} feature and you don't need to instantiate it normally.
 * Before showing the dialog need to use {@link Core.widget.Container#property-record} to load a {@link Scheduler.model.RecurrenceModel Recurrence model}
 * data into the editor fields. For example:
 *
 * ```javascript
 * // make the editor instance
 * const editor = new RecurrenceEditor();
 * // load recurrnce model into it
 * editor.record = new RecurrenceModel({ frequency : "WEEKLY" });
 * // display the editor
 * editor.show();
 * ```
 *
 * @extends Core/widget/Popup
 * @classType recurrenceeditor
 */

var RecurrenceEditor = /*#__PURE__*/function (_Popup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(RecurrenceEditor, _Popup);

  var _super = _createSuper(RecurrenceEditor);

  function RecurrenceEditor() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, RecurrenceEditor);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(RecurrenceEditor, [{
    key: "updateReadOnly",
    value: function updateReadOnly(readOnly) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(RecurrenceEditor.prototype), "updateReadOnly", this).call(this, readOnly); // No save or cancel buttons. It's purely for information display when in readOnly mode


      this.bbar.hidden = readOnly;
    }
  }, {
    key: "updateRecord",
    value: function updateRecord(record) {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(RecurrenceEditor.prototype), "updateRecord", this).call(this, record);

      var me = this,
          event = record.timeSpan,
          startDate = event && event.startDate,
          _me$widgetMap = me.widgetMap,
          daysButtonField = _me$widgetMap.daysButtonField,
          monthDaysButtonField = _me$widgetMap.monthDaysButtonField,
          monthsButtonField = _me$widgetMap.monthsButtonField,
          monthDaysRadioField = _me$widgetMap.monthDaysRadioField,
          positionAndDayRadioField = _me$widgetMap.positionAndDayRadioField,
          stopRecurrenceField = _me$widgetMap.stopRecurrenceField; // some fields default values are calculated based on event "startDate" value

      if (startDate) {
        // if no "days" value provided
        if (!record.days || !record.days.length) {
          daysButtonField.value = [_data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_11__["default"].encodeDay(startDate.getDay())];
        } // if no "monthDays" value provided


        if (!record.monthDays || !record.monthDays.length) {
          monthDaysButtonField.value = startDate.getDate();
        } // if no "months" value provided


        if (!record.months || !record.months.length) {
          monthsButtonField.value = startDate.getMonth() + 1;
        }
      } // if the record has both "days" & "positions" fields set check "On the" checkbox


      if (record.days && record.positions) {
        positionAndDayRadioField.check(); // TODO: if toggleGroup members are not painted automatic unchecking doesn't work

        if (!me.isPainted) {
          monthDaysRadioField.uncheck();
        }
      } else {
        monthDaysRadioField.check(); // TODO: if toggleGroup members are not painted automatic unchecking doesn't work

        if (!me.isPainted) {
          positionAndDayRadioField.uncheck();
        }
      }

      stopRecurrenceField.recurrence = record;
    }
  }, {
    key: "onSaveClick",
    value: function onSaveClick() {
      var me = this;

      if (me.saveHandler) {
        me.saveHandler.call(me.thisObj || me, me, me.record);
      } else {
        me.syncEventRecord();
        me.close();
      }
    }
  }, {
    key: "onCancelClick",
    value: function onCancelClick() {
      var me = this;

      if (me.cancelHandler) {
        me.cancelHandler.call(me.thisObj || me, me, me.record);
      } else {
        me.close();
      }
    }
    /**
     * Updates the provided recurrence model with the contained form data.
     * If recurrence model is not provided updates the last loaded recurrence model.
     */

  }, {
    key: "syncEventRecord",
    value: function syncEventRecord(recurrence) {
      // get values relevant to the RecurrenceModel (from enabled fields only)
      var values = this.getValues(function (w) {
        return w.name in recurrence && !w.disabled;
      });
      recurrence.set(values);
    }
  }, {
    key: "toggleStopFields",
    value: function toggleStopFields() {
      var me = this,
          _me$widgetMap2 = me.widgetMap,
          countField = _me$widgetMap2.countField,
          endDateField = _me$widgetMap2.endDateField;

      switch (me.widgetMap.stopRecurrenceField.value) {
        case 'count':
          countField.show();
          countField.enable();
          endDateField.hide();
          endDateField.disable();
          break;

        case 'date':
          countField.hide();
          countField.disable();
          endDateField.show();
          endDateField.enable();
          break;

        default:
          countField.hide();
          endDateField.hide();
          countField.disable();
          endDateField.disable();
      }
    }
  }, {
    key: "onMonthDaysRadioFieldChange",
    value: function onMonthDaysRadioFieldChange(_ref) {
      var checked = _ref.checked;
      var monthDaysButtonField = this.widgetMap.monthDaysButtonField;
      monthDaysButtonField.disabled = !checked || !this.isWidgetAvailableForFrequency(monthDaysButtonField);
    }
  }, {
    key: "onPositionAndDayRadioFieldChange",
    value: function onPositionAndDayRadioFieldChange(_ref2) {
      var checked = _ref2.checked;
      var _this$widgetMap = this.widgetMap,
          daysCombo = _this$widgetMap.daysCombo,
          positionsCombo = _this$widgetMap.positionsCombo; // toggle day & positions combos

      daysCombo.disabled = positionsCombo.disabled = !checked || !this.isWidgetAvailableForFrequency(daysCombo);
    }
  }, {
    key: "onStopRecurrenceFieldChange",
    value: function onStopRecurrenceFieldChange() {
      this.toggleStopFields();
    }
  }, {
    key: "isWidgetAvailableForFrequency",
    value: function isWidgetAvailableForFrequency(widget) {
      var frequency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.widgetMap.frequencyField.value;
      return !widget.forFrequency || widget.forFrequency.indexOf(frequency) > -1;
    }
  }, {
    key: "onFrequencyFieldChange",
    value: function onFrequencyFieldChange(_ref3) {
      var value = _ref3.value,
          valid = _ref3.valid;
      var me = this,
          items = me.queryAll(function (w) {
        return 'forFrequency' in w;
      });

      if (valid && value) {
        for (var i = 0; i < items.length; i++) {
          var item = items[i];

          if (me.isWidgetAvailableForFrequency(item, value)) {
            item.show();
            item.enable();
          } else {
            item.hide();
            item.disable();
          }
        } // The following lines are added to satisfy the 904_unused localization test
        // to let it know that these locales are used:
        // this.L('L{DAILYintervalUnit}')
        // this.L('L{WEEKLYintervalUnit}')
        // this.L('L{MONTHLYintervalUnit}')
        // this.L('L{YEARLYintervalUnit}')


        me.widgetMap.intervalField.hint = me.L("".concat(value, "intervalUnit"));
        me.toggleFieldsState();
      }
    }
  }, {
    key: "toggleFieldsState",
    value: function toggleFieldsState() {
      var me = this,
          widgetMap = this.widgetMap;
      me.onMonthDaysRadioFieldChange({
        checked: widgetMap.monthDaysRadioField.checked
      });
      me.onPositionAndDayRadioFieldChange({
        checked: widgetMap.positionAndDayRadioField.checked
      });
      me.onStopRecurrenceFieldChange();
    }
  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      // do extra labels translation (not auto-translated yet)
      var _this$widgetMap2 = this.widgetMap,
          countField = _this$widgetMap2.countField,
          intervalField = _this$widgetMap2.intervalField,
          frequencyField = _this$widgetMap2.frequencyField;
      countField.hint = this.L('L{time(s)}');

      if (frequencyField.value) {
        intervalField.hint = this.L("".concat(frequencyField.value, "intervalUnit"));
      }

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(RecurrenceEditor.prototype), "updateLocalization", this).call(this);
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceEditor';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrenceeditor';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        draggable: true,
        closable: true,
        floating: true,
        cls: 'b-recurrenceeditor',
        title: 'L{Repeat event}',
        autoClose: true,
        width: 400,
        defaults: {
          localeClass: this
        },
        items: {
          frequencyField: {
            type: 'recurrencefrequencycombo',
            name: 'frequency',
            label: 'L{Frequency}',
            weight: 10,
            onChange: 'up.onFrequencyFieldChange'
          },
          intervalField: {
            type: 'numberfield',
            weight: 15,
            name: 'interval',
            label: 'L{Every}',
            min: 1,
            required: true
          },
          daysButtonField: {
            type: 'recurrencedaysbuttongroup',
            weight: 20,
            name: 'days',
            forFrequency: 'WEEKLY'
          },
          // the radio button enabling "monthDaysButtonField" in MONTHLY mode
          monthDaysRadioField: {
            type: 'checkbox',
            weight: 30,
            toggleGroup: 'radio',
            forFrequency: 'MONTHLY',
            label: 'L{Each}',
            checked: true,
            onChange: 'up.onMonthDaysRadioFieldChange'
          },
          monthDaysButtonField: {
            type: 'recurrencemonthdaysbuttongroup',
            weight: 40,
            name: 'monthDays',
            forFrequency: 'MONTHLY'
          },
          monthsButtonField: {
            type: 'recurrencemonthsbuttongroup',
            weight: 50,
            name: 'months',
            forFrequency: 'YEARLY'
          },
          // the radio button enabling positions & days combos in MONTLY & YEARLY modes
          positionAndDayRadioField: {
            type: 'checkbox',
            weight: 60,
            toggleGroup: 'radio',
            forFrequency: 'MONTHLY|YEARLY',
            label: 'L{On the}',
            onChange: 'up.onPositionAndDayRadioFieldChange'
          },
          positionsCombo: {
            type: 'recurrencepositionscombo',
            weight: 80,
            name: 'positions',
            forFrequency: 'MONTHLY|YEARLY'
          },
          daysCombo: {
            type: 'recurrencedayscombo',
            weight: 90,
            name: 'days',
            forFrequency: 'MONTHLY|YEARLY',
            flex: 1
          },
          stopRecurrenceField: {
            type: 'recurrencestopconditioncombo',
            weight: 100,
            label: 'L{End repeat}',
            onChange: 'up.onStopRecurrenceFieldChange'
          },
          countField: {
            type: 'numberfield',
            weight: 110,
            name: 'count',
            min: 2,
            required: true,
            disabled: true,
            label: ' '
          },
          endDateField: {
            type: 'datefield',
            weight: 120,
            name: 'endDate',
            hidden: true,
            disabled: true,
            label: ' ',
            required: true
          }
        },
        bbar: {
          defaults: {
            localeClass: this
          },
          items: {
            foo: {
              type: 'widget',
              cls: 'b-label-filler',
              weight: 100
            },
            saveButton: {
              color: 'b-green',
              text: 'L{Save}',
              onClick: 'up.onSaveClick',
              weight: 200
            },
            cancelButton: {
              color: 'b-gray',
              text: 'L{Object.Cancel}',
              onClick: 'up.onCancelClick',
              weight: 300
            }
          }
        }
      };
    }
  }]);

  return RecurrenceEditor;
}(_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_12__["default"]); // Register this widget type with its Factory



RecurrenceEditor.initClass();
RecurrenceEditor._$name = 'RecurrenceEditor';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/RecurrenceLegendButton.js":
/*!*****************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/RecurrenceLegendButton.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceLegendButton; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _data_util_recurrence_RecurrenceLegend_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../data/util/recurrence/RecurrenceLegend.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceLegend.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/view/recurrence/RecurrenceLegendButton
 */

/**
 * Class implementing a button which text displays the associated recurrence info in a human readable form.
 * @extends Core/widget/Button
 * @classType recurrencelegendbutton
 */

var RecurrenceLegendButton = /*#__PURE__*/function (_Button) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(RecurrenceLegendButton, _Button);

  var _super = _createSuper(RecurrenceLegendButton);

  function RecurrenceLegendButton() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, RecurrenceLegendButton);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(RecurrenceLegendButton, [{
    key: "updateLegend",
    value: function updateLegend() {
      var me = this,
          recurrence = me.recurrence;
      me.text = recurrence ? _data_util_recurrence_RecurrenceLegend_js__WEBPACK_IMPORTED_MODULE_10__["default"].getLegend(recurrence, me.eventStartDate) : '';
    }
  }, {
    key: "onLocaleChange",
    value: function onLocaleChange() {
      // on locale switch we update the button text to use proper language
      this.updateLegend();
    }
  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      this.onLocaleChange();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(RecurrenceLegendButton.prototype), "updateLocalization", this).call(this);
    }
  }, {
    key: "recurrence",

    /**
     * Sets the recurrence to display description for.
     * @param {Scheduler.model.RecurrenceModel} recurrence Recurrence model.
     */
    set: function set(recurrence) {
      this._recurrence = recurrence;
      this.updateLegend();
    },
    get: function get() {
      return this._recurrence;
    }
  }, {
    key: "eventStartDate",
    set: function set(eventStartDate) {
      this._eventStartDate = eventStartDate;
      this.updateLegend();
    },
    get: function get() {
      return this._eventStartDate;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceLegendButton';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrencelegendbutton';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        localizableProperties: [],
        recurrence: null
      };
    }
  }]);

  return RecurrenceLegendButton;
}(_Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_9__["default"]); // Register this widget type with its Factory



RecurrenceLegendButton.initClass();
RecurrenceLegendButton._$name = 'RecurrenceLegendButton';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceCombo.js":
/*!****************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceCombo.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceCombo; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./RecurrenceFrequencyCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/view/recurrence/field/RecurrenceCombo
 */

/**
 * A combobox field displaying the recurrence by either mode: `Daily`, `Weekly`, `Monthly` or `Yearly` if the recurrence
 * has no other non-default settings, or `Custom...` if the recurrence has custom setting applied.
 *
 * @extends Scheduler/view/recurrence/field/RecurrenceFrequencyCombo
 * @classType recurrencecombo
 */

var RecurrenceCombo = /*#__PURE__*/function (_RecurrenceFrequencyC) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(RecurrenceCombo, _RecurrenceFrequencyC);

  var _super = _createSuper(RecurrenceCombo);

  function RecurrenceCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, RecurrenceCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(RecurrenceCombo, [{
    key: "buildLocalizedItems",
    value: function buildLocalizedItems() {
      var me = this;
      return [{
        value: 'none',
        text: me.L('L{None}')
      }].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(RecurrenceCombo.prototype), "buildLocalizedItems", this).call(this)), [{
        value: me.customValue,
        text: me.L('L{Custom}'),
        cls: me.splitCls
      }]);
    }
  }, {
    key: "isCustomRecurrence",
    value: function isCustomRecurrence(recurrence) {
      var interval = recurrence.interval,
          days = recurrence.days,
          monthDays = recurrence.monthDays,
          months = recurrence.months;
      return Boolean(interval > 1 || days && days.length || monthDays && monthDays.length || months && months.length);
    }
  }, {
    key: "value",
    set: function set(value) {
      // Use 'none' instead of falsy value
      value = value || 'none';

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(RecurrenceCombo.prototype), "value", value, this, true);
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(RecurrenceCombo.prototype), "value", this);
    }
  }, {
    key: "recurrence",
    set: function set(recurrence) {
      var me = this;

      if (recurrence) {
        me.value = me.isCustomRecurrence(recurrence) ? me.customValue : recurrence.frequency;
      } else {
        me.value = null;
      }
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrencecombo';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        customValue: 'custom',
        placeholder: 'None',
        // TODO: draw a splitting line
        splitCls: 'b-recurrencecombo-split',
        items: true,
        highlightExternalChange: false
      };
    }
  }]);

  return RecurrenceCombo;
}(_RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_12__["default"]);


; // Register this widget type with its Factory

RecurrenceCombo.initClass();
RecurrenceCombo._$name = 'RecurrenceCombo';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js":
/*!**************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceDaysButtonGroup; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../../Core/widget/ButtonGroup.js */ "./lib/Core/widget/ButtonGroup.js");
/* harmony import */ var _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");

















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_14___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup
 */

/**
 * A segmented button field allowing to pick days for the "Weekly" mode in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/ButtonGroup
 */

var RecurrenceDaysButtonGroup = /*#__PURE__*/function (_ButtonGroup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(RecurrenceDaysButtonGroup, _ButtonGroup);

  var _super = _createSuper(RecurrenceDaysButtonGroup);

  function RecurrenceDaysButtonGroup() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, RecurrenceDaysButtonGroup);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(RecurrenceDaysButtonGroup, [{
    key: "construct",
    value: function construct() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this;
      config.columns = 7;
      config.items = me.buildItems();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(RecurrenceDaysButtonGroup.prototype), "construct", this).call(this, config);
    }
  }, {
    key: "updateItemText",
    value: function updateItemText(item) {
      var day = _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_18__["default"].decodeDay(item.value)[0];
      item.text = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getDayName(day).substring(0, 3);
    }
  }, {
    key: "buildItems",
    value: function buildItems() {
      var me = this;

      if (!me.__items) {
        var weekStartDay = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].weekStartDay;
        var dayNames = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getDayNames().map(function (text, index) {
          return {
            text: text.substring(0, 3),
            value: _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_18__["default"].encodeDay(index)
          };
        }); // we should start week w/ weekStartDay

        me.__items = dayNames.slice(weekStartDay).concat(dayNames.slice(0, weekStartDay));
      }

      return me.__items;
    }
  }, {
    key: "onLocaleChange",
    value: function onLocaleChange() {
      // update button texts on locale switch
      this.items.forEach(this.updateItemText, this);
    }
  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      this.onLocaleChange();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(RecurrenceDaysButtonGroup.prototype), "updateLocalization", this).call(this);
    }
  }, {
    key: "value",
    set: function set(value) {
      if (value && Array.isArray(value)) {
        value = value.join(',');
      }

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(RecurrenceDaysButtonGroup.prototype), "value", value, this, true);
    },
    get: function get() {
      var value = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(RecurrenceDaysButtonGroup.prototype), "value", this);

      if (value && Array.isArray(value)) {
        value = value.join(',');
      }

      return value; // return value ? value.split(',') : [];
    }
  }, {
    key: "widgetClassList",
    get: function get() {
      var classList = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_15___default()(RecurrenceDaysButtonGroup.prototype), "widgetClassList", this); // to look more like a real field


      classList.push('b-field');
      return classList;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceDaysButtonGroup';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrencedaysbuttongroup';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        defaults: {
          cls: 'b-raised',
          toggleable: true
        }
      };
    }
  }]);

  return RecurrenceDaysButtonGroup;
}(_Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_17__["default"]);


; // Register this widget type with its Factory

RecurrenceDaysButtonGroup.initClass();
RecurrenceDaysButtonGroup._$name = 'RecurrenceDaysButtonGroup';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js":
/*!********************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceDaysCombo; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.slice */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';




/**
 * @module Scheduler/view/recurrence/field/RecurrenceDaysCombo
 */

/**
 * A combobox field allowing to pick days for the `Monthly` and `Yearly` mode in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/Combo
 * @classType recurrencedayscombo
 */

var RecurrenceDaysCombo = /*#__PURE__*/function (_LocalizableComboItem) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(RecurrenceDaysCombo, _LocalizableComboItem);

  var _super = _createSuper(RecurrenceDaysCombo);

  function RecurrenceDaysCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, RecurrenceDaysCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(RecurrenceDaysCombo, [{
    key: "buildLocalizedItems",
    value: function buildLocalizedItems() {
      var me = this;
      me._weekDays = null;
      return me.weekDays.concat([{
        value: me.allDaysValue,
        text: me.L('L{day}'),
        cls: me.splitCls
      }, {
        value: me.workingDaysValue,
        text: me.L('L{weekday}')
      }, {
        value: me.nonWorkingDaysValue,
        text: me.L('L{weekend day}')
      }]);
    }
  }, {
    key: "weekDays",
    get: function get() {
      var me = this;

      if (!me._weekDays) {
        var weekStartDay = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].weekStartDay;
        var dayNames = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getDayNames().map(function (text, index) {
          return {
            text: text,
            value: _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_16__["default"].encodeDay(index)
          };
        }); // we should start week w/ weekStartDay

        me._weekDays = dayNames.slice(weekStartDay).concat(dayNames.slice(0, weekStartDay));
      }

      return me._weekDays;
    }
  }, {
    key: "value",
    set: function set(value) {
      var me = this;

      if (value && Array.isArray(value)) {
        value = value.join(',');
      } // if the value has no matching option in the store we need to use default value


      if (!value || !me.store.findRecord('value', value)) {
        value = me.defaultValue;
      }

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(RecurrenceDaysCombo.prototype), "value", value, this, true);
    },
    get: function get() {
      var value = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(RecurrenceDaysCombo.prototype), "value", this);

      if (value && Array.isArray(value)) {
        value = value.join(',');
      }

      return value;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceDaysCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrencedayscombo';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      var allDaysValue = 'SU,MO,TU,WE,TH,FR,SA';
      return {
        allDaysValue: allDaysValue,
        editable: false,
        defaultValue: allDaysValue,
        workingDaysValue: 'MO,TU,WE,TH,FR',
        nonWorkingDaysValue: 'SU,SA',
        splitCls: 'b-recurrencedays-split',
        displayField: 'text',
        valueField: 'value'
      };
    }
  }]);

  return RecurrenceDaysCombo;
}(Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_17__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_15__["default"])); // Register this widget type with its Factory



RecurrenceDaysCombo.initClass();
RecurrenceDaysCombo._$name = 'RecurrenceDaysCombo';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js":
/*!*************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceFrequencyCombo; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/view/recurrence/field/RecurrenceFrequencyCombo
 */

/**
 * A combobox field allowing to pick frequency in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/Combo
 * @classType recurrencefrequencycombo
 */

var RecurrenceFrequencyCombo = /*#__PURE__*/function (_LocalizableComboItem) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(RecurrenceFrequencyCombo, _LocalizableComboItem);

  var _super = _createSuper(RecurrenceFrequencyCombo);

  function RecurrenceFrequencyCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, RecurrenceFrequencyCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(RecurrenceFrequencyCombo, [{
    key: "buildLocalizedItems",
    value: function buildLocalizedItems() {
      return [{
        value: 'DAILY',
        text: this.L('L{Daily}')
      }, {
        value: 'WEEKLY',
        text: this.L('L{Weekly}')
      }, {
        value: 'MONTHLY',
        text: this.L('L{Monthly}')
      }, {
        value: 'YEARLY',
        text: this.L('L{Yearly}')
      }];
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceFrequencyCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrencefrequencycombo';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        editable: false,
        displayField: 'text',
        valueField: 'value'
      };
    }
  }]);

  return RecurrenceFrequencyCombo;
}(Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_9__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_8__["default"]));


; // Register this widget type with its Factory

RecurrenceFrequencyCombo.initClass();
RecurrenceFrequencyCombo._$name = 'RecurrenceFrequencyCombo';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js":
/*!*******************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceMonthDaysButtonGroup; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../Core/widget/ButtonGroup.js */ "./lib/Core/widget/ButtonGroup.js");










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * A segmented button field allowing to pick month days for the `Monthly` mode in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/ButtonGroup
 */

var RecurrenceMonthDaysButtonGroup = /*#__PURE__*/function (_ButtonGroup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(RecurrenceMonthDaysButtonGroup, _ButtonGroup);

  var _super = _createSuper(RecurrenceMonthDaysButtonGroup);

  function RecurrenceMonthDaysButtonGroup() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, RecurrenceMonthDaysButtonGroup);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(RecurrenceMonthDaysButtonGroup, [{
    key: "construct",
    value: function construct() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this;
      config.columns = 7;
      config.items = me.buildItems();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(RecurrenceMonthDaysButtonGroup.prototype), "construct", this).call(this, config);
    }
  }, {
    key: "buildItems",
    value: function buildItems() {
      var me = this,
          items = [];

      for (var value = me.minValue; value <= me.maxValue; value++) {
        // button config
        items.push({
          text: value + '',
          value: value
        });
      }

      return items;
    }
  }, {
    key: "minValue",
    get: function get() {
      return 1;
    }
  }, {
    key: "maxValue",
    get: function get() {
      return 31;
    }
  }, {
    key: "widgetClassList",
    get: function get() {
      var classList = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(RecurrenceMonthDaysButtonGroup.prototype), "widgetClassList", this); // to look more like a real field


      classList.push('b-field');
      return classList;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceMonthDaysButtonGroup';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrencemonthdaysbuttongroup';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        defaults: {
          toggleable: true,
          cls: 'b-raised'
        }
      };
    }
  }]);

  return RecurrenceMonthDaysButtonGroup;
}(_Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_9__["default"]);


; // Register this widget type with its Factory

RecurrenceMonthDaysButtonGroup.initClass();
RecurrenceMonthDaysButtonGroup._$name = 'RecurrenceMonthDaysButtonGroup';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js":
/*!****************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceMonthsButtonGroup; });
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.for-each */ "./node_modules/core-js/modules/es.array.for-each.js");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../Core/widget/ButtonGroup.js */ "./lib/Core/widget/ButtonGroup.js");













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * A segmented button field allowing to pick months for the `Yearly` mode in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/ButtonGroup
 */

var RecurrenceMonthsButtonGroup = /*#__PURE__*/function (_ButtonGroup) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(RecurrenceMonthsButtonGroup, _ButtonGroup);

  var _super = _createSuper(RecurrenceMonthsButtonGroup);

  function RecurrenceMonthsButtonGroup() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, RecurrenceMonthsButtonGroup);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(RecurrenceMonthsButtonGroup, [{
    key: "construct",
    value: function construct() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var me = this;
      config.columns = 4;
      config.items = me.buildItems();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(RecurrenceMonthsButtonGroup.prototype), "construct", this).call(this, config);
    }
  }, {
    key: "buildItems",
    value: function buildItems() {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getMonthNames().map(function (item, index) {
        return {
          text: item.substring(0, 3),
          value: index + 1 // 1-based

        };
      });
    }
  }, {
    key: "updateItemText",
    value: function updateItemText(item) {
      item.text = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getMonthName(item.value - 1).substring(0, 3);
    }
  }, {
    key: "onLocaleChange",
    value: function onLocaleChange() {
      // update button texts on locale switch
      this.items.forEach(this.updateItemText, this);
    }
  }, {
    key: "updateLocalization",
    value: function updateLocalization() {
      this.onLocaleChange();

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(RecurrenceMonthsButtonGroup.prototype), "updateLocalization", this).call(this);
    }
  }, {
    key: "widgetClassList",
    get: function get() {
      var classList = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(RecurrenceMonthsButtonGroup.prototype), "widgetClassList", this); // to look more like a real field


      classList.push('b-field');
      return classList;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceMonthsButtonGroup';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrencemonthsbuttongroup';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        defaults: {
          toggleable: true,
          cls: 'b-raised'
        }
      };
    }
  }]);

  return RecurrenceMonthsButtonGroup;
}(_Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_13__["default"]);


; // Register this widget type with its Factory

RecurrenceMonthsButtonGroup.initClass();
RecurrenceMonthsButtonGroup._$name = 'RecurrenceMonthsButtonGroup';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js":
/*!*************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrencePositionsCombo; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.join */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.split */ "./node_modules/core-js/modules/es.string.split.js");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';



/**
 * @module Scheduler/view/recurrence/field/RecurrencePositionsCombo
 */

/**
 * A combobox field allowing to specify day positions in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence editor}.
 *
 * @extends Core/widget/Combo
 * @classType recurrencepositionscombo
 */

var RecurrencePositionsCombo = /*#__PURE__*/function (_LocalizableComboItem) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(RecurrencePositionsCombo, _LocalizableComboItem);

  var _super = _createSuper(RecurrencePositionsCombo);

  function RecurrencePositionsCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, RecurrencePositionsCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(RecurrencePositionsCombo, [{
    key: "buildLocalizedItems",
    value: function buildLocalizedItems() {
      var me = this;
      return me.buildDayNumbers().concat([// the following lines are added to satisfy the 904_unused localization test
      // to let it know that these locales are used:
      // this.L('L{position-1}')
      {
        value: '-1',
        text: me.L('L{position-1}'),
        cls: me.splitCls
      }]);
    }
  }, {
    key: "buildDayNumbers",
    value: function buildDayNumbers() {
      var me = this; // the following lines are added to satisfy the 904_unused localization test
      // to let it know that these locales are used:
      // this.L('L{position1}')
      // this.L('L{position2}')
      // this.L('L{position3}')
      // this.L('L{position4}')
      // this.L('L{position5}')

      return _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].populate(me.maxPosition, function (i) {
        return {
          value: i,
          text: me.L("position".concat(i + 1))
        };
      });
    }
  }, {
    key: "value",
    set: function set(value) {
      var me = this;

      if (value && Array.isArray(value)) {
        value = value.join(',');
      } // if the value has no matching option in the store we need to use default value


      if (!value || !me.store.findRecord('value', value)) {
        value = me.defaultValue;
      }

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(RecurrencePositionsCombo.prototype), "value", value, this, true);
    },
    get: function get() {
      var value = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(RecurrencePositionsCombo.prototype), "value", this);

      return value ? "".concat(value).split(',').map(function (item) {
        return parseInt(item, 10);
      }) : [];
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrencePositionsCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrencepositionscombo';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        editable: false,
        splitCls: 'b-sch-recurrencepositions-split',
        displayField: 'text',
        valueField: 'value',
        defaultValue: 1,
        maxPosition: 5
      };
    }
  }]);

  return RecurrencePositionsCombo;
}(Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_17__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_16__["default"]));


; // Register this widget type with its Factory

RecurrencePositionsCombo.initClass();
RecurrencePositionsCombo._$name = 'RecurrencePositionsCombo';

/***/ }),

/***/ "./lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js":
/*!*****************************************************************************!*\
  !*** ./lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceStopConditionCombo; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/set */ "./node_modules/@babel/runtime/helpers/set.js");
/* harmony import */ var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../Core/widget/mixin/LocalizableComboItems.js */ "./lib/Core/widget/mixin/LocalizableComboItems.js");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/view/recurrence/field/RecurrenceStopConditionCombo
 */

/**
 * A combobox field allowing to choose stop condition for the recurrence in the {@link Scheduler.view.recurrence.RecurrenceEditor recurrence dialog}.
 *
 * @extends Core/widget/Combo
 * @classType recurrencestopconditioncombo
 */

var RecurrenceStopConditionCombo = /*#__PURE__*/function (_LocalizableComboItem) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(RecurrenceStopConditionCombo, _LocalizableComboItem);

  var _super = _createSuper(RecurrenceStopConditionCombo);

  function RecurrenceStopConditionCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, RecurrenceStopConditionCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(RecurrenceStopConditionCombo, [{
    key: "buildLocalizedItems",
    value: function buildLocalizedItems() {
      return [{
        value: 'never',
        text: this.L('L{Never}')
      }, {
        value: 'count',
        text: this.L('L{After}')
      }, {
        value: 'date',
        text: this.L('L{On date}')
      }];
    }
  }, {
    key: "value",
    set: function set(value) {
      // Use 'never' instead of falsy value
      value = value || 'never';

      _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(RecurrenceStopConditionCombo.prototype), "value", value, this, true);
    },
    get: function get() {
      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(RecurrenceStopConditionCombo.prototype), "value", this);
    }
  }, {
    key: "recurrence",
    get: function get() {
      return this._recurrence;
    },
    set: function set(recurrence) {
      var value = null;

      if (recurrence.endDate) {
        value = 'date';
      } else if (recurrence.count) {
        value = 'count';
      }

      this._recurrence = recurrence;
      this.value = value;
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'RecurrenceStopConditionCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'recurrencestopconditioncombo';
    }
  }, {
    key: "defaultConfig",
    get: function get() {
      return {
        editable: false,
        placeholder: 'Never',
        displayField: 'text',
        valueField: 'value'
      };
    }
  }]);

  return RecurrenceStopConditionCombo;
}(Object(_Core_widget_mixin_LocalizableComboItems_js__WEBPACK_IMPORTED_MODULE_11__["default"])(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_10__["default"]));


; // Register this widget type with its Factory

RecurrenceStopConditionCombo.initClass();
RecurrenceStopConditionCombo._$name = 'RecurrenceStopConditionCombo';

/***/ }),

/***/ "./lib/Scheduler/widget/ResourceCombo.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/widget/ResourceCombo.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceCombo; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';

/**
 * @module Scheduler/widget/ResourceCombo
 */

/**
 * Combo subclass which selects resources, highlighting the `eventColor` of each resource in
 * the picker and in the input area.
 *
 * @extends Core/widget/List
 * @classType resourceCombo
 */

var ResourceCombo = /*#__PURE__*/function (_Combo) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ResourceCombo, _Combo);

  var _super = _createSuper(ResourceCombo);

  function ResourceCombo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ResourceCombo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(ResourceCombo, [{
    key: "changeShowEventColor",
    value: function changeShowEventColor(showEventColor) {
      return Boolean(showEventColor);
    }
  }, {
    key: "updateShowEventColor",
    value: function updateShowEventColor(showEventColor) {
      this.element.classList[showEventColor ? 'add' : 'remove']('b-show-event-color');
    }
  }, {
    key: "changePicker",
    value: function changePicker(picker, oldPicker) {
      picker = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(ResourceCombo.prototype), "changePicker", this).call(this, picker, oldPicker);

      if (picker) {
        picker.element.classList[this.showEventColor ? 'add' : 'remove']('b-show-event-color');
      }

      return picker;
    } // Implementation needed at this level because it has two inner elements in its inputWrap

  }, {
    key: "syncInputFieldValue",
    value: function syncInputFieldValue() {
      var _me$selected$eventCol, _me$selected;

      var me = this,
          resourceIcon = me.resourceIcon,
          lastResourceIconCls = me.lastResourceIconCls,
          classList = resourceIcon.classList,
          eventColor = (_me$selected$eventCol = (_me$selected = me.selected) === null || _me$selected === void 0 ? void 0 : _me$selected.eventColor) !== null && _me$selected$eventCol !== void 0 ? _me$selected$eventCol : '';

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(ResourceCombo.prototype), "syncInputFieldValue", this).call(this); // Remove last colour whichever way it was done


      resourceIcon.style.color = '';
      lastResourceIconCls && classList.remove(lastResourceIconCls);
      me.lastResourceIconCls = null;

      if (eventColor) {
        if (eventColor.startsWith('#')) {
          resourceIcon.style.color = eventColor;
        } else {
          me.lastResourceIconCls = "b-sch-foreground-".concat(eventColor);
          classList.add(me.lastResourceIconCls);
        }

        classList.remove('b-hide-display');
      } else {
        classList.add('b-hide-display');
      }
    }
  }, {
    key: "innerElements",
    get: function get() {
      return [{
        class: 'b-icon b-resource-icon b-icon-square b-hide-display',
        reference: 'resourceIcon'
      }, this.inputElement];
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ResourceCombo';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'resourcecombo';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        showEventColor: false,
        picker: {
          cls: 'b-resourcecombo-picker',
          itemIconTpl: function itemIconTpl(record, i) {
            var eventColor = record.eventColor,
                isColor = eventColor === null || eventColor === void 0 ? void 0 : eventColor.startsWith('#'),
                style = eventColor ? isColor ? " style=\"color:".concat(eventColor, "\"") : '' : ' style="display:none"',
                colorClass = !eventColor || isColor ? '' : " b-sch-foreground-".concat(eventColor);
            return "<div class=\"b-icon b-icon-square".concat(colorClass, "\"").concat(style, "></div>");
          }
        }
      };
    }
  }]);

  return ResourceCombo;
}(_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_11__["default"]); // Register this widget type with its Factory



ResourceCombo.initClass();
ResourceCombo._$name = 'ResourceCombo';

/***/ }),

/***/ "./lib/Scheduler/widget/ResourceFilter.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/widget/ResourceFilter.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceFilter; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.filter */ "./node_modules/core-js/modules/es.array.filter.js");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.includes */ "./node_modules/core-js/modules/es.array.includes.js");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.function.name */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es.string.includes */ "./node_modules/core-js/modules/es.string.includes.js");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.string.starts-with */ "./node_modules/core-js/modules/es.string.starts-with.js");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Core_widget_List_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/widget/List.js */ "./lib/Core/widget/List.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_13___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/widget/ResourceFilter
 */

/**
 * A List which allows selection of resources to filter a specified eventStore to only show
 * events for the selected resources.
 *
 * @extends Core/widget/List
 * @classType resourceFilter
 */

var ResourceFilter = /*#__PURE__*/function (_List) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(ResourceFilter, _List);

  var _super = _createSuper(ResourceFilter);

  function ResourceFilter() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, ResourceFilter);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(ResourceFilter, [{
    key: "itemIconTpl",
    value: function itemIconTpl(record, i) {
      var eventColor = record.eventColor,
          style = (eventColor === null || eventColor === void 0 ? void 0 : eventColor.startsWith('#')) ? " style=\"color:".concat(eventColor, "\"") : '',
          cls = !style && eventColor ? " b-sch-foreground-".concat(eventColor) : '';
      return this.multiSelect ? "<div class=\"b-selected-icon b-icon".concat(cls, "\"").concat(style, "></div>") : '';
    }
  }, {
    key: "updateEventStore",
    value: function updateEventStore(eventStore) {
      var resourceStore = eventStore.resourceStore,
          chainedStoreConfig = this.initialConfig.store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_16__["default"] ? this.initialConfig.store.initialConfig : this.store;
      this.store = resourceStore.makeChained(null, null, chainedStoreConfig);

      if (!resourceStore.count) {
        resourceStore.project.on({
          name: 'project',
          refresh: 'initFilter',
          thisObj: this
        });
      } else {
        this.initFilter();
      }
    }
  }, {
    key: "initFilter",
    value: function initFilter() {
      var eventStore = this.eventStore;

      if (eventStore.count && eventStore.resourceStore.count) {
        this.selected.add(this.store.getRange());
        this.detachListeners('project');
      }
    }
  }, {
    key: "onSelectionChange",
    value: function onSelectionChange(_ref) {
      var selected = _ref.source;
      // Filter disabled if all resources selected
      var me = this,
          disabled = selected.count === me.eventStore.resourceStore.count;

      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_14___default()(ResourceFilter.prototype), "onSelectionChange", this).apply(this, arguments); // If this is the first selection change triggered from the first project refresh
      // in which all the resources are selected, then we don't need to apply the filters.
      // because all resources are selected


      if (!me.resourceFilter) {
        // Our client EventStore is filtered to only show events for our selected resources.
        // Events without an associated resource are filtered into visibility.
        // The addFilter function with silent param adds the filter but don't reevaluate filtering.
        me.resourceFilter = me.eventStore.addFilter({
          id: "".concat(me.id, "-filter-instance"),
          filterBy: function filterBy(e) {
            return !e.resource || me.selected.includes(e.resource);
          },
          disabled: disabled
        }, true);
        return;
      } // Filter disabled if all resources selected


      me.resourceFilter.disabled = disabled; // Have the client EventStore refresh its filtering but after a small delay so the List UI updates immediately.

      me.applyFilter();
    }
  }, {
    key: "applyFilter",
    value: function applyFilter() {
      this.eventStore.filter();
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'ResourceFilter';
    } // Factoryable type name

  }, {
    key: "type",
    get: function get() {
      return 'resourcefilter';
    }
  }, {
    key: "delayable",
    get: function get() {
      return {
        applyFilter: 'raf'
      };
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * The {@link Scheduler.data.EventStore EventStore} to filter.
         * Events for resources which are deselected in this List will be filtered out.
         * @config {Scheduler.data.EventStore}
         */
        eventStore: null,
        multiSelect: true,
        toggleAllIfCtrlPressed: true,
        itemTpl: function itemTpl(record) {
          return record.name;
        }
      };
    }
  }]);

  return ResourceFilter;
}(_Core_widget_List_js__WEBPACK_IMPORTED_MODULE_15__["default"]); // Register this widget type with its Factory



ResourceFilter.initClass();
ResourceFilter._$name = 'ResourceFilter';

/***/ }),

/***/ "./lib/Scheduler/widget/UndoRedo.js":
/*!******************************************!*\
  !*** ./lib/Scheduler/widget/UndoRedo.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UndoRedo; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.reflect.construct */ "./node_modules/core-js/modules/es.reflect.construct.js");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../Core/widget/Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var productName = 'scheduler';


/**
 * @module Scheduler/widget/UndoRedo
 */

var isProjectConsumer = function isProjectConsumer(w) {
  return w.isProjectConsumer;
};
/**
 * A widget which encapsulates undo/redo functionality for the {@link Scheduler.model.ProjectModel project}
 * of a scheduling widget (`Scheduler`, `Gantt` or `Calendar`).
 *
 * To make use of this, the project must be configured with a
 * {@link Scheduler.model.mixin.ProjectModelMixin#config-stm State Tracking Manager}.
 *
 * If inserted into a scheduling widget (such as into a `tbar`, or `bbar`, or as an item in a context menu),
 * the project of the encapsulating scheduling widget will be used.
 *
 * If this widget is to be used "standalone" (rendered into the DOM outside of a scheduling widget),
 * this must be configured with a reference to the project, or the scheduling widget which is
 * using the project.
 *
 * There are three child widgets encapsulated which may be referenced through the {@link Core.widget.Container#property-widgetMap}:
 *
 * - `undoBtn` - The button which operates the undo operation
 * - `transactionsCombo` - A combobox into which is pushed the list of transactions,
 * - `redoBtn` - The button which operates the redo operation
 *
 * The transactionsCombo may be configured away if only the buttons are required:
 *
 * ```javascript
 * {
 *     type      : 'undoredo',
 *     items     : {
 *         transactionsCombo : null
 *     }
 * }
 * ```
 * The example below illustrated how to embed an `undoredo` widget in the top toolbar of a Scheduler.
 * @extends Core/widget/Container
 * @classType undoredo
 * @demo Scheduler/undoredo
 * @externalexample scheduler/UndoRedo.js
 */


var UndoRedo = /*#__PURE__*/function (_Container) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(UndoRedo, _Container);

  var _super = _createSuper(UndoRedo);

  function UndoRedo() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, UndoRedo);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(UndoRedo, [{
    key: "construct",
    value: function construct() {
      _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(UndoRedo.prototype), "construct", this).apply(this, arguments); // Look up a Project owner in our ancestors.


      if (!this.stm) {
        this.scheduler = this.up(isProjectConsumer);
      }

      this.stm.on({
        recordingstop: 'updateUndoRedoControls',
        restoringstop: 'updateUndoRedoControls',
        queueReset: 'updateUndoRedoControls',
        disabled: 'updateUndoRedoControls',
        thisObj: this
      });
    }
  }, {
    key: "changeItems",
    value: function changeItems(items) {
      var undoBtn = items.undoBtn,
          redoBtn = items.redoBtn;

      if (this.color) {
        undoBtn && (undoBtn.color = this.color);
        redoBtn && (redoBtn.color = this.color);
      }

      if (this.text) {
        undoBtn && (undoBtn.text = 'Undo');
        redoBtn && (redoBtn.text = 'Redo');
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(UndoRedo.prototype), "changeItems", this).call(this, items);
    }
  }, {
    key: "changeScheduler",
    value: function changeScheduler(scheduler) {
      return scheduler.isProjectConsumer ? scheduler : bryntum.get(scheduler);
    }
  }, {
    key: "updateScheduler",
    value: function updateScheduler(scheduler) {
      var crudManager = scheduler.crudManager;

      if (crudManager) {
        crudManager.on({
          load: 'onCrudManagerLoad',
          thisObj: this
        });
      } // No CrudManager, so it must be inline data, so we can start immediately
      else {
          this.onCrudManagerLoad();
        }

      this.stm = scheduler.project.stm;
    }
  }, {
    key: "updateProject",
    value: function updateProject(project) {
      this.stm = project.stm;
    }
  }, {
    key: "onCrudManagerLoad",
    value: function () {
      var _onCrudManagerLoad = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.scheduler.project.commitAsync();

              case 2:
                // Widget could be destroyed during async project commit
                if (!this.isDestroyed) {
                  this.stm.enable();
                  this.fillUndoRedoCombo();
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCrudManagerLoad() {
        return _onCrudManagerLoad.apply(this, arguments);
      }

      return onCrudManagerLoad;
    }()
  }, {
    key: "fillUndoRedoCombo",
    value: function fillUndoRedoCombo() {
      // The transactionsCombo may be configured away if only undo and redo buttons are wanted
      this.widgetMap.transactionsCombo && (this.widgetMap.transactionsCombo.items = this.stm.queue.map(function (title, idx) {
        return [idx, title || "Transaction ".concat(idx)];
      }));
    }
  }, {
    key: "updateUndoRedoControls",
    value: function updateUndoRedoControls() {
      var stm = this.stm,
          showZeroActionBadge = this.showZeroActionBadge,
          _this$widgetMap = this.widgetMap,
          undoBtn = _this$widgetMap.undoBtn,
          redoBtn = _this$widgetMap.redoBtn;
      undoBtn.badge = stm.position || (showZeroActionBadge ? '0' : '');
      redoBtn.badge = stm.length - stm.position || (showZeroActionBadge ? '0' : '');
      undoBtn.disabled = !stm.canUndo;
      redoBtn.disabled = !stm.canRedo;
      this.fillUndoRedoCombo();
    }
  }, {
    key: "transactionsDisplayValueRenderer",
    value: function transactionsDisplayValueRenderer(record, combo) {
      var _this$stm;

      var stmPos = ((_this$stm = this.stm) === null || _this$stm === void 0 ? void 0 : _this$stm.position) || 0;
      return "".concat(stmPos, " undo actions / ").concat(combo.store.count - stmPos, " redo actions");
    }
  }, {
    key: "onUndo",
    value: function onUndo() {
      this.stm.canUndo && this.stm.undo();
    }
  }, {
    key: "onRedo",
    value: function onRedo() {
      this.stm.canRedo && this.stm.redo();
    }
  }, {
    key: "onTransactionSelected",
    value: function onTransactionSelected(combo) {
      var stm = this.stm,
          value = combo.value;

      if (value >= 0) {
        if (stm.canUndo && value < stm.position) {
          stm.undo(stm.position - value);
        } else if (stm.canRedo && value >= stm.position) {
          stm.redo(value - stm.position + 1);
        }
      }
    }
  }], [{
    key: "$name",
    get: function get() {
      return 'UndoRedo';
    }
  }, {
    key: "type",
    get: function get() {
      return 'undoredo';
    }
  }, {
    key: "configurable",
    get: function get() {
      return {
        /**
         * The Scheduling Widget (or its `id`) whose transaction to track.
         *
         * This may be a `Scheduler`, a `Gantt` or a `Calendar`.
         *
         * ```javascript
         *     {
         *         type      : 'undoredo',
         *         scheduler : myCalendar
         *     }
         * ```
         * @config {Core.widget.Widget|String}
         */
        scheduler: null,

        /**
         * The Scheduling {@link Scheduler.model.ProjectModel project}'s whose
         * transaction to track.
         *
         * ```javascript
         *     {
         *         type    : 'undoredo',
         *         project : sheduler.project
         *     }
         * ```
         * @config {Scheduler.model.ProjectModel}
         */
        project: null,

        /**
         * Configure as `true` to show "Undo" and "Redo" as button texts. The buttons always have a tooltip
         * as a hint to the user as to their purpose.
         * @config {Boolean}
         */
        text: null,

        /**
         * Button color for the undo and redo buttons. See {@link Core.widget.Button#config-color}.
         * @config {String}
         */
        color: null,

        /**
         * Configure as `true` to show "0" badge on the undo and redo buttons when they have no actions
         * left to perform. By default when there are no actions, no badge is displayed.
         * @config {Boolean}
         */
        showZeroActionBadge: null,
        cls: 'b-undo-controls b-toolbar',
        layoutStyle: {
          alignItems: 'stretch',
          flexFlow: 'row nowrap',
          overflow: 'visible'
        },
        items: {
          undoBtn: {
            type: 'button',
            icon: 'b-fa-undo',
            tooltip: 'Undo last action',
            disabled: true,
            onAction: 'up.onUndo' // 'up.' means method is on a parent Widget.

          },
          transactionsCombo: {
            type: 'combo',
            valueField: 'idx',
            editable: false,
            store: {},
            emptyText: 'No items in the undo queue',
            onAction: 'up.onTransactionSelected',
            displayValueRenderer: 'up.transactionsDisplayValueRenderer'
          },
          redoBtn: {
            type: 'button',
            icon: 'b-fa-redo',
            tooltip: 'Redo last undone action',
            disabled: true,
            onAction: 'up.onRedo'
          }
        }
      };
    }
  }]);

  return UndoRedo;
}(_Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_14__["default"]);


UndoRedo.initClass();
UndoRedo._$name = 'UndoRedo';

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/AsyncGenerator.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/AsyncGenerator.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var AwaitValue = __webpack_require__(/*! ./AwaitValue */ "./node_modules/@babel/runtime/helpers/AwaitValue.js");

function AsyncGenerator(gen) {
  var front, back;

  function send(key, arg) {
    return new Promise(function (resolve, reject) {
      var request = {
        key: key,
        arg: arg,
        resolve: resolve,
        reject: reject,
        next: null
      };

      if (back) {
        back = back.next = request;
      } else {
        front = back = request;
        resume(key, arg);
      }
    });
  }

  function resume(key, arg) {
    try {
      var result = gen[key](arg);
      var value = result.value;
      var wrappedAwait = value instanceof AwaitValue;
      Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) {
        if (wrappedAwait) {
          resume(key === "return" ? "return" : "next", arg);
          return;
        }

        settle(result.done ? "return" : "normal", arg);
      }, function (err) {
        resume("throw", err);
      });
    } catch (err) {
      settle("throw", err);
    }
  }

  function settle(type, value) {
    switch (type) {
      case "return":
        front.resolve({
          value: value,
          done: true
        });
        break;

      case "throw":
        front.reject(value);
        break;

      default:
        front.resolve({
          value: value,
          done: false
        });
        break;
    }

    front = front.next;

    if (front) {
      resume(front.key, front.arg);
    } else {
      back = null;
    }
  }

  this._invoke = send;

  if (typeof gen["return"] !== "function") {
    this["return"] = undefined;
  }
}

if (typeof Symbol === "function" && Symbol.asyncIterator) {
  AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
    return this;
  };
}

AsyncGenerator.prototype.next = function (arg) {
  return this._invoke("next", arg);
};

AsyncGenerator.prototype["throw"] = function (arg) {
  return this._invoke("throw", arg);
};

AsyncGenerator.prototype["return"] = function (arg) {
  return this._invoke("return", arg);
};

module.exports = AsyncGenerator;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/AwaitValue.js":
/*!***********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/AwaitValue.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _AwaitValue(value) {
  this.wrapped = value;
}

module.exports = _AwaitValue;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayLikeToArray.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayWithHoles.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithHoles.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/assertThisInitialized.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/asyncToGenerator.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/awaitAsyncGenerator.js":
/*!********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/awaitAsyncGenerator.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var AwaitValue = __webpack_require__(/*! ./AwaitValue */ "./node_modules/@babel/runtime/helpers/AwaitValue.js");

function _awaitAsyncGenerator(value) {
  return new AwaitValue(value);
}

module.exports = _awaitAsyncGenerator;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/classCallCheck.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/construct.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/construct.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(/*! ./setPrototypeOf */ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js");

var isNativeReflectConstruct = __webpack_require__(/*! ./isNativeReflectConstruct */ "./node_modules/@babel/runtime/helpers/isNativeReflectConstruct.js");

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

module.exports = _construct;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/createClass.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/defineProperty.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/get.js":
/*!****************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/get.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var superPropBase = __webpack_require__(/*! ./superPropBase */ "./node_modules/@babel/runtime/helpers/superPropBase.js");

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/getPrototypeOf.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/inherits.js":
/*!*********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/inherits.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(/*! ./setPrototypeOf */ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/isNativeReflectConstruct.js":
/*!*************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/isNativeReflectConstruct.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

module.exports = _isNativeReflectConstruct;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArray.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArray.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableRest.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableRest.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js":
/*!**************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");

var assertThisInitialized = __webpack_require__(/*! ./assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/set.js":
/*!****************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/set.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var superPropBase = __webpack_require__(/*! ./superPropBase */ "./node_modules/@babel/runtime/helpers/superPropBase.js");

var defineProperty = __webpack_require__(/*! ./defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");

function set(target, property, value, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.set) {
    set = Reflect.set;
  } else {
    set = function set(target, property, value, receiver) {
      var base = superPropBase(target, property);
      var desc;

      if (base) {
        desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.set) {
          desc.set.call(receiver, value);
          return true;
        } else if (!desc.writable) {
          return false;
        }
      }

      desc = Object.getOwnPropertyDescriptor(receiver, property);

      if (desc) {
        if (!desc.writable) {
          return false;
        }

        desc.value = value;
        Object.defineProperty(receiver, property, desc);
      } else {
        defineProperty(receiver, property, value);
      }

      return true;
    };
  }

  return set(target, property, value, receiver);
}

function _set(target, property, value, receiver, isStrict) {
  var s = set(target, property, value, receiver || target);

  if (!s && isStrict) {
    throw new Error('failed to set property');
  }

  return value;
}

module.exports = _set;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/setPrototypeOf.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/slicedToArray.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/slicedToArray.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(/*! ./arrayWithHoles */ "./node_modules/@babel/runtime/helpers/arrayWithHoles.js");

var iterableToArrayLimit = __webpack_require__(/*! ./iterableToArrayLimit */ "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js");

var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");

var nonIterableRest = __webpack_require__(/*! ./nonIterableRest */ "./node_modules/@babel/runtime/helpers/nonIterableRest.js");

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/superPropBase.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/superPropBase.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(/*! ./getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

module.exports = _taggedTemplateLiteral;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toConsumableArray.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(/*! ./arrayWithoutHoles */ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");

var iterableToArray = __webpack_require__(/*! ./iterableToArray */ "./node_modules/@babel/runtime/helpers/iterableToArray.js");

var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");

var nonIterableSpread = __webpack_require__(/*! ./nonIterableSpread */ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/wrapAsyncGenerator.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/wrapAsyncGenerator.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var AsyncGenerator = __webpack_require__(/*! ./AsyncGenerator */ "./node_modules/@babel/runtime/helpers/AsyncGenerator.js");

function _wrapAsyncGenerator(fn) {
  return function () {
    return new AsyncGenerator(fn.apply(this, arguments));
  };
}

module.exports = _wrapAsyncGenerator;

/***/ }),

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! regenerator-runtime */ "./node_modules/regenerator-runtime/runtime.js");


/***/ }),

/***/ "./node_modules/abortcontroller-polyfill/dist/umd-polyfill.js":
/*!********************************************************************!*\
  !*** ./node_modules/abortcontroller-polyfill/dist/umd-polyfill.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) :
  undefined;
}((function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  var Emitter =
  /*#__PURE__*/
  function () {
    function Emitter() {
      _classCallCheck(this, Emitter);

      Object.defineProperty(this, 'listeners', {
        value: {},
        writable: true,
        configurable: true
      });
    }

    _createClass(Emitter, [{
      key: "addEventListener",
      value: function addEventListener(type, callback) {
        if (!(type in this.listeners)) {
          this.listeners[type] = [];
        }

        this.listeners[type].push(callback);
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(type, callback) {
        if (!(type in this.listeners)) {
          return;
        }

        var stack = this.listeners[type];

        for (var i = 0, l = stack.length; i < l; i++) {
          if (stack[i] === callback) {
            stack.splice(i, 1);
            return;
          }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        var _this = this;

        if (!(event.type in this.listeners)) {
          return;
        }

        var debounce = function debounce(callback) {
          setTimeout(function () {
            return callback.call(_this, event);
          });
        };

        var stack = this.listeners[event.type];

        for (var i = 0, l = stack.length; i < l; i++) {
          debounce(stack[i]);
        }

        return !event.defaultPrevented;
      }
    }]);

    return Emitter;
  }();

  var AbortSignal =
  /*#__PURE__*/
  function (_Emitter) {
    _inherits(AbortSignal, _Emitter);

    function AbortSignal() {
      var _this2;

      _classCallCheck(this, AbortSignal);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(AbortSignal).call(this)); // Some versions of babel does not transpile super() correctly for IE <= 10, if the parent
      // constructor has failed to run, then "this.listeners" will still be undefined and then we call
      // the parent constructor directly instead as a workaround. For general details, see babel bug:
      // https://github.com/babel/babel/issues/3041
      // This hack was added as a fix for the issue described here:
      // https://github.com/Financial-Times/polyfill-library/pull/59#issuecomment-477558042

      if (!_this2.listeners) {
        Emitter.call(_assertThisInitialized(_this2));
      } // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl


      Object.defineProperty(_assertThisInitialized(_this2), 'aborted', {
        value: false,
        writable: true,
        configurable: true
      });
      Object.defineProperty(_assertThisInitialized(_this2), 'onabort', {
        value: null,
        writable: true,
        configurable: true
      });
      return _this2;
    }

    _createClass(AbortSignal, [{
      key: "toString",
      value: function toString() {
        return '[object AbortSignal]';
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (event.type === 'abort') {
          this.aborted = true;

          if (typeof this.onabort === 'function') {
            this.onabort.call(this, event);
          }
        }

        _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
      }
    }]);

    return AbortSignal;
  }(Emitter);
  var AbortController =
  /*#__PURE__*/
  function () {
    function AbortController() {
      _classCallCheck(this, AbortController);

      // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController()) to be [] for compat with the native impl
      Object.defineProperty(this, 'signal', {
        value: new AbortSignal(),
        writable: true,
        configurable: true
      });
    }

    _createClass(AbortController, [{
      key: "abort",
      value: function abort() {
        var event;

        try {
          event = new Event('abort');
        } catch (e) {
          if (typeof document !== 'undefined') {
            if (!document.createEvent) {
              // For Internet Explorer 8:
              event = document.createEventObject();
              event.type = 'abort';
            } else {
              // For Internet Explorer 11:
              event = document.createEvent('Event');
              event.initEvent('abort', false, false);
            }
          } else {
            // Fallback where document isn't available:
            event = {
              type: 'abort',
              bubbles: false,
              cancelable: false
            };
          }
        }

        this.signal.dispatchEvent(event);
      }
    }, {
      key: "toString",
      value: function toString() {
        return '[object AbortController]';
      }
    }]);

    return AbortController;
  }();

  if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    // These are necessary to make sure that we get correct output for:
    // Object.prototype.toString.call(new AbortController())
    AbortController.prototype[Symbol.toStringTag] = 'AbortController';
    AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
  }

  function polyfillNeeded(self) {
    if (self.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      console.log('__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill');
      return true;
    } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // so the below feature detection needs the !self.AbortController part.
    // The Request.prototype check is also needed because Safari versions 11.1.2
    // up to and including 12.1.x has a window.AbortController present but still
    // does NOT correctly implement abortable fetch:
    // https://bugs.webkit.org/show_bug.cgi?id=174980#c2


    return typeof self.Request === 'function' && !self.Request.prototype.hasOwnProperty('signal') || !self.AbortController;
  }

  /**
   * Note: the "fetch.Request" default value is available for fetch imported from
   * the "node-fetch" package and not in browsers. This is OK since browsers
   * will be importing umd-polyfill.js from that path "self" is passed the
   * decorator so the default value will not be used (because browsers that define
   * fetch also has Request). One quirky setup where self.fetch exists but
   * self.Request does not is when the "unfetch" minimal fetch polyfill is used
   * on top of IE11; for this case the browser will try to use the fetch.Request
   * default value which in turn will be undefined but then then "if (Request)"
   * will ensure that you get a patched fetch but still no Request (as expected).
   * @param {fetch, Request = fetch.Request}
   * @returns {fetch: abortableFetch, Request: AbortableRequest}
   */

  function abortableFetchDecorator(patchTargets) {
    if ('function' === typeof patchTargets) {
      patchTargets = {
        fetch: patchTargets
      };
    }

    var _patchTargets = patchTargets,
        fetch = _patchTargets.fetch,
        _patchTargets$Request = _patchTargets.Request,
        NativeRequest = _patchTargets$Request === void 0 ? fetch.Request : _patchTargets$Request,
        NativeAbortController = _patchTargets.AbortController,
        _patchTargets$__FORCE = _patchTargets.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL,
        __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL = _patchTargets$__FORCE === void 0 ? false : _patchTargets$__FORCE;

    if (!polyfillNeeded({
      fetch: fetch,
      Request: NativeRequest,
      AbortController: NativeAbortController,
      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL
    })) {
      return {
        fetch: fetch,
        Request: Request
      };
    }

    var Request = NativeRequest; // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // hence we only patch it if it's available. Also we don't patch it if signal
    // is already available on the Request prototype because in this case support
    // is present and the patching below can cause a crash since it assigns to
    // request.signal which is technically a read-only property. This latter error
    // happens when you run the main5.js node-fetch example in the repo
    // "abortcontroller-polyfill-examples". The exact error is:
    //   request.signal = init.signal;
    //   ^
    // TypeError: Cannot set property signal of #<Request> which has only a getter

    if (Request && !Request.prototype.hasOwnProperty('signal') || __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      Request = function Request(input, init) {
        var signal;

        if (init && init.signal) {
          signal = init.signal; // Never pass init.signal to the native Request implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to construct 'Request': member signal is not of type AbortSignal.

          delete init.signal;
        }

        var request = new NativeRequest(input, init);

        if (signal) {
          Object.defineProperty(request, 'signal', {
            writable: false,
            enumerable: false,
            configurable: true,
            value: signal
          });
        }

        return request;
      };

      Request.prototype = NativeRequest.prototype;
    }

    var realFetch = fetch;

    var abortableFetch = function abortableFetch(input, init) {
      var signal = Request && Request.prototype.isPrototypeOf(input) ? input.signal : init ? init.signal : undefined;

      if (signal) {
        var abortError;

        try {
          abortError = new DOMException('Aborted', 'AbortError');
        } catch (err) {
          // IE 11 does not support calling the DOMException constructor, use a
          // regular error object on it instead.
          abortError = new Error('Aborted');
          abortError.name = 'AbortError';
        } // Return early if already aborted, thus avoiding making an HTTP request


        if (signal.aborted) {
          return Promise.reject(abortError);
        } // Turn an event into a promise, reject it once `abort` is dispatched


        var cancellation = new Promise(function (_, reject) {
          signal.addEventListener('abort', function () {
            return reject(abortError);
          }, {
            once: true
          });
        });

        if (init && init.signal) {
          // Never pass .signal to the native implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to execute 'fetch' on 'Window': member signal is not of type AbortSignal.
          delete init.signal;
        } // Return the fastest promise (don't need to wait for request to finish)


        return Promise.race([cancellation, realFetch(input, init)]);
      }

      return realFetch(input, init);
    };

    return {
      fetch: abortableFetch,
      Request: Request
    };
  }

  (function (self) {

    if (!polyfillNeeded(self)) {
      return;
    }

    if (!self.fetch) {
      console.warn('fetch() is not available, cannot install abortcontroller-polyfill');
      return;
    }

    var _abortableFetch = abortableFetchDecorator(self),
        fetch = _abortableFetch.fetch,
        Request = _abortableFetch.Request;

    self.fetch = fetch;
    self.Request = Request;
    Object.defineProperty(self, 'AbortController', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortController
    });
    Object.defineProperty(self, 'AbortSignal', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortSignal
    });
  })(typeof self !== 'undefined' ? self : global);

})));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../node_modules/webpack/buildin/global.js */ "../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/core-js/internals/a-function.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/a-function.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/a-possible-prototype.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/a-possible-prototype.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/add-to-unscopables.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/add-to-unscopables.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "./node_modules/core-js/internals/advance-string-index.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/advance-string-index.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "./node_modules/core-js/internals/an-instance.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/an-instance.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/an-object.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/an-object.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-fill.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/array-fill.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");

// `Array.prototype.fill` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-for-each.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-for-each.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").forEach;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "./node_modules/core-js/internals/array-from.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/array-from.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var callWithSafeIterationClosing = __webpack_require__(/*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js");
var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-includes.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-includes.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-iteration.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/array-iteration.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-method-has-species-support.js":
/*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/array-method-has-species-support.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js/internals/engine-v8-version.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-method-is-strict.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/array-method-is-strict.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-method-uses-to-length.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/array-method-uses-to-length.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-reduce.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/array-reduce.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-species-create.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/array-species-create.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js":
/*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/call-with-safe-iteration-closing.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/check-correctness-of-iteration.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/check-correctness-of-iteration.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "./node_modules/core-js/internals/classof-raw.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/classof-raw.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/internals/classof.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/internals/classof.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js");
var classofRaw = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/collection-add-all.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/collection-add-all.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");

// https://github.com/tc39/collection-methods
module.exports = function (/* ...elements */) {
  var set = anObject(this);
  var adder = aFunction(set.add);
  for (var k = 0, len = arguments.length; k < len; k++) {
    adder.call(set, arguments[k]);
  }
  return set;
};


/***/ }),

/***/ "./node_modules/core-js/internals/collection-delete-all.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/collection-delete-all.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");

// https://github.com/tc39/collection-methods
module.exports = function (/* ...elements */) {
  var collection = anObject(this);
  var remover = aFunction(collection['delete']);
  var allDeleted = true;
  var wasDeleted;
  for (var k = 0, len = arguments.length; k < len; k++) {
    wasDeleted = remover.call(collection, arguments[k]);
    allDeleted = allDeleted && wasDeleted;
  }
  return !!allDeleted;
};


/***/ }),

/***/ "./node_modules/core-js/internals/collection-strong.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/collection-strong.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js");
var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js/internals/set-species.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var fastKey = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js").fastKey;
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/collection-weak.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/collection-weak.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var getWeakData = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js").getWeakData;
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
var ArrayIterationModule = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js");
var $has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.3.3.3 WeakMap.prototype.get(key)
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // 23.3.3.5 WeakMap.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // 23.4.3.1 WeakSet.prototype.add(value)
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/collection.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/collection.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var InternalMetadataModule = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  // eslint-disable-next-line max-len
  if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  })))) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "./node_modules/core-js/internals/copy-constructor-properties.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/copy-constructor-properties.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var ownKeys = __webpack_require__(/*! ../internals/own-keys */ "./node_modules/core-js/internals/own-keys.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/correct-is-regexp-logic.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-is-regexp-logic.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "./node_modules/core-js/internals/correct-prototype-getter.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-prototype-getter.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "./node_modules/core-js/internals/create-html.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/create-html.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.github.io/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-iterator-constructor.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-iterator-constructor.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js").IteratorPrototype;
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-non-enumerable-property.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/create-non-enumerable-property.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-property-descriptor.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-property-descriptor.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-property.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/create-property.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "./node_modules/core-js/internals/define-iterator.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/define-iterator.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var createIteratorConstructor = __webpack_require__(/*! ../internals/create-iterator-constructor */ "./node_modules/core-js/internals/create-iterator-constructor.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
var IteratorsCore = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "./node_modules/core-js/internals/define-well-known-symbol.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/define-well-known-symbol.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js/internals/path.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var wrappedWellKnownSymbolModule = __webpack_require__(/*! ../internals/well-known-symbol-wrapped */ "./node_modules/core-js/internals/well-known-symbol-wrapped.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/descriptors.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/descriptors.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "./node_modules/core-js/internals/document-create-element.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/document-create-element.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/internals/dom-iterables.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/dom-iterables.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "./node_modules/core-js/internals/engine-is-ios.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/engine-is-ios.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__(/*! ../internals/engine-user-agent */ "./node_modules/core-js/internals/engine-user-agent.js");

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "./node_modules/core-js/internals/engine-user-agent.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/engine-user-agent.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "./node_modules/core-js/internals/engine-v8-version.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/engine-v8-version.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var userAgent = __webpack_require__(/*! ../internals/engine-user-agent */ "./node_modules/core-js/internals/engine-user-agent.js");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "./node_modules/core-js/internals/enum-bug-keys.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/enum-bug-keys.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "./node_modules/core-js/internals/export.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/internals/export.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");
var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/fails.js":
/*!*************************************************!*\
  !*** ./node_modules/core-js/internals/fails.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js":
/*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(/*! ../modules/es.regexp.exec */ "./node_modules/core-js/modules/es.regexp.exec.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var regexpExec = __webpack_require__(/*! ../internals/regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "./node_modules/core-js/internals/freezing.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/freezing.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "./node_modules/core-js/internals/function-bind-context.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/function-bind-context.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/internals/function-bind.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/function-bind.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "./node_modules/core-js/internals/get-built-in.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/get-built-in.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js/internals/path.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "./node_modules/core-js/internals/get-iterator-method.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator-method.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "./node_modules/core-js/internals/get-iterator.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),

/***/ "./node_modules/core-js/internals/get-map-iterator.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/internals/get-map-iterator.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getIterator = __webpack_require__(/*! ../internals/get-iterator */ "./node_modules/core-js/internals/get-iterator.js");

module.exports = IS_PURE ? getIterator : function (it) {
  // eslint-disable-next-line no-undef
  return Map.prototype.entries.call(it);
};


/***/ }),

/***/ "./node_modules/core-js/internals/get-set-iterator.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/internals/get-set-iterator.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getIterator = __webpack_require__(/*! ../internals/get-iterator */ "./node_modules/core-js/internals/get-iterator.js");

module.exports = IS_PURE ? getIterator : function (it) {
  // eslint-disable-next-line no-undef
  return Set.prototype.values.call(it);
};


/***/ }),

/***/ "./node_modules/core-js/internals/global.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/internals/global.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../node_modules/webpack/buildin/global.js */ "../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/core-js/internals/has.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/internals/has.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/internals/hidden-keys.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/hidden-keys.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/internals/host-report-errors.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/host-report-errors.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/html.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/internals/html.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "./node_modules/core-js/internals/ie8-dom-define.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/ie8-dom-define.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/internals/indexed-object.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/indexed-object.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "./node_modules/core-js/internals/inherit-if-required.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/inherit-if-required.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "./node_modules/core-js/internals/inspect-source.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/inspect-source.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "./node_modules/core-js/internals/internal-metadata.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/internal-metadata.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
var FREEZING = __webpack_require__(/*! ../internals/freezing */ "./node_modules/core-js/internals/freezing.js");

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "./node_modules/core-js/internals/internal-state.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/internal-state.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/native-weak-map */ "./node_modules/core-js/internals/native-weak-map.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var objectHas = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-array-iterator-method.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/is-array-iterator-method.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-array.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/is-array.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-forced.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-forced.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "./node_modules/core-js/internals/is-object.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-object.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-pure.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/internals/is-pure.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "./node_modules/core-js/internals/is-regexp.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-regexp.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "./node_modules/core-js/internals/iterate.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/internals/iterate.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");
var callWithSafeIterationClosing = __webpack_require__(/*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),

/***/ "./node_modules/core-js/internals/iterators-core.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterators-core.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "./node_modules/core-js/internals/iterators.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/iterators.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/internals/math-sign.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/math-sign.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// `Math.sign` method implementation
// https://tc39.github.io/ecma262/#sec-math.sign
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "./node_modules/core-js/internals/microtask.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/microtask.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var macrotask = __webpack_require__(/*! ../internals/task */ "./node_modules/core-js/internals/task.js").set;
var IS_IOS = __webpack_require__(/*! ../internals/engine-is-ios */ "./node_modules/core-js/internals/engine-is-ios.js");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var IS_NODE = classof(process) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "./node_modules/core-js/internals/native-promise-constructor.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/native-promise-constructor.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");

module.exports = global.Promise;


/***/ }),

/***/ "./node_modules/core-js/internals/native-symbol.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/native-symbol.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "./node_modules/core-js/internals/native-url.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/native-url.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ "./node_modules/core-js/internals/native-weak-map.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/native-weak-map.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "./node_modules/core-js/internals/new-promise-capability.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/new-promise-capability.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "./node_modules/core-js/internals/not-a-regexp.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/not-a-regexp.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__(/*! ../internals/is-regexp */ "./node_modules/core-js/internals/is-regexp.js");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/number-parse-int.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/internals/number-parse-int.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js/internals/string-trim.js").trim;
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js/internals/whitespaces.js");

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "./node_modules/core-js/internals/object-assign.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-assign.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "./node_modules/core-js/internals/object-create.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-create.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var defineProperties = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
var html = __webpack_require__(/*! ../internals/html */ "./node_modules/core-js/internals/html.js");
var documentCreateElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-define-properties.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-properties.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-define-property.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-property.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-descriptor.js":
/*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-names-external.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names-external.js ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var nativeGetOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-names.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-symbols.js":
/*!***************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-symbols.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-prototype-of.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-prototype-of.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/core-js/internals/correct-prototype-getter.js");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-keys-internal.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys-internal.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js").indexOf;
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-keys.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-property-is-enumerable.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-property-is-enumerable.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/internals/object-prototype-accessors-forced.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-prototype-accessors-forced.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

// Forced replacement object prototype accessors methods
module.exports = IS_PURE || !fails(function () {
  var key = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, key, function () { /* empty */ });
  delete global[key];
});


/***/ }),

/***/ "./node_modules/core-js/internals/object-set-prototype-of.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-set-prototype-of.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aPossiblePrototype = __webpack_require__(/*! ../internals/a-possible-prototype */ "./node_modules/core-js/internals/a-possible-prototype.js");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "./node_modules/core-js/internals/object-to-array.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/object-to-array.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var propertyIsEnumerable = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-to-string.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/internals/object-to-string.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js");
var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "./node_modules/core-js/internals/own-keys.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/own-keys.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "./node_modules/core-js/internals/path.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/internals/path.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");

module.exports = global;


/***/ }),

/***/ "./node_modules/core-js/internals/perform.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/internals/perform.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/promise-resolve.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/promise-resolve.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var newPromiseCapability = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js/internals/new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "./node_modules/core-js/internals/redefine-all.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/redefine-all.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "./node_modules/core-js/internals/redefine.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/redefine.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");
var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "./node_modules/core-js/internals/regexp-exec-abstract.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-exec-abstract.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(/*! ./classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var regexpExec = __webpack_require__(/*! ./regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "./node_modules/core-js/internals/regexp-exec.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-exec.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__(/*! ./regexp-flags */ "./node_modules/core-js/internals/regexp-flags.js");
var stickyHelpers = __webpack_require__(/*! ./regexp-sticky-helpers */ "./node_modules/core-js/internals/regexp-sticky-helpers.js");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "./node_modules/core-js/internals/regexp-flags.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-flags.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/regexp-sticky-helpers.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-sticky-helpers.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__(/*! ./fails */ "./node_modules/core-js/internals/fails.js");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "./node_modules/core-js/internals/require-object-coercible.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/require-object-coercible.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/same-value-zero.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/same-value-zero.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// `SameValueZero` abstract operation
// https://tc39.github.io/ecma262/#sec-samevaluezero
module.exports = function (x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y || x != x && y != y;
};


/***/ }),

/***/ "./node_modules/core-js/internals/same-value.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/same-value.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// `SameValue` abstract operation
// https://tc39.github.io/ecma262/#sec-samevalue
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "./node_modules/core-js/internals/set-global.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/set-global.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "./node_modules/core-js/internals/set-species.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/set-species.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/set-to-string-tag.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/set-to-string-tag.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/shared-key.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/shared-key.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/internals/shared-store.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/shared-store.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "./node_modules/core-js/internals/shared.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/internals/shared.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var store = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/core-js/internals/species-constructor.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/species-constructor.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-html-forced.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/string-html-forced.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-multibyte.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/internals/string-multibyte.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-pad-webkit-bug.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/string-pad-webkit-bug.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/zloirock/core-js/issues/280
var userAgent = __webpack_require__(/*! ../internals/engine-user-agent */ "./node_modules/core-js/internals/engine-user-agent.js");

// eslint-disable-next-line unicorn/no-unsafe-regex
module.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);


/***/ }),

/***/ "./node_modules/core-js/internals/string-pad.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/string-pad.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var repeat = __webpack_require__(/*! ../internals/string-repeat */ "./node_modules/core-js/internals/string-repeat.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = String(requireObjectCoercible($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = toLength(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-punycode-to-ascii.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/string-punycode-to-ascii.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line  max-statements
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

module.exports = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-repeat.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/string-repeat.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

// `String.prototype.repeat` method implementation
// https://tc39.github.io/ecma262/#sec-string.prototype.repeat
module.exports = ''.repeat || function repeat(count) {
  var str = String(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-trim-forced.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/string-trim-forced.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js/internals/whitespaces.js");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-trim.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/string-trim.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js/internals/whitespaces.js");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "./node_modules/core-js/internals/task.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/internals/task.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var html = __webpack_require__(/*! ../internals/html */ "./node_modules/core-js/internals/html.js");
var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
var IS_IOS = __webpack_require__(/*! ../internals/engine-is-ios */ "./node_modules/core-js/internals/engine-is-ios.js");

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof(process) == 'process') {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    !fails(post) &&
    location.protocol !== 'file:'
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "./node_modules/core-js/internals/this-number-value.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/this-number-value.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");

// `thisNumberValue` abstract operation
// https://tc39.github.io/ecma262/#sec-thisnumbervalue
module.exports = function (value) {
  if (typeof value != 'number' && classof(value) != 'Number') {
    throw TypeError('Incorrect invocation');
  }
  return +value;
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-absolute-index.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-absolute-index.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-indexed-object.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-indexed-object.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-integer.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/to-integer.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-length.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-length.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-object.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-object.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-primitive.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/to-primitive.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-string-tag-support.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/to-string-tag-support.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "./node_modules/core-js/internals/uid.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/internals/uid.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "./node_modules/core-js/internals/use-symbol-as-uid.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/use-symbol-as-uid.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js/internals/native-symbol.js");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "./node_modules/core-js/internals/well-known-symbol-wrapped.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol-wrapped.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "./node_modules/core-js/internals/well-known-symbol.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js/internals/native-symbol.js");
var USE_SYMBOL_AS_UID = __webpack_require__(/*! ../internals/use-symbol-as-uid */ "./node_modules/core-js/internals/use-symbol-as-uid.js");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "./node_modules/core-js/internals/whitespaces.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/whitespaces.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.concat.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.concat.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js/internals/engine-v8-version.js");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.every.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.every.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $every = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").every;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var STRICT_METHOD = arrayMethodIsStrict('every');
var USES_TO_LENGTH = arrayMethodUsesToLength('every');

// `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.fill.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.fill.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fill = __webpack_require__(/*! ../internals/array-fill */ "./node_modules/core-js/internals/array-fill.js");
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");

// `Array.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.filter.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.filter.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $filter = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.find-index.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.find-index.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $findIndex = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").findIndex;
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.find.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.find.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $find = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").find;
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.for-each.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.for-each.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var forEach = __webpack_require__(/*! ../internals/array-for-each */ "./node_modules/core-js/internals/array-for-each.js");

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.from.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.from.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var from = __webpack_require__(/*! ../internals/array-from */ "./node_modules/core-js/internals/array-from.js");
var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.includes.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.includes.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $includes = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js").includes;
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.index-of.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.index-of.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js").indexOf;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.iterator.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.iterator.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.join.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.join.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.map.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.map.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $map = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").map;
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.reduce-right.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.reduce-right.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $reduceRight = __webpack_require__(/*! ../internals/array-reduce */ "./node_modules/core-js/internals/array-reduce.js").right;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var STRICT_METHOD = arrayMethodIsStrict('reduceRight');
// For preventing possible almost infinite loop in non-standard implementations, test the forward version of the method
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduceRight` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.reduce.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.reduce.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $reduce = __webpack_require__(/*! ../internals/array-reduce */ "./node_modules/core-js/internals/array-reduce.js").left;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.slice.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.slice.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.some.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.some.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $some = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").some;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var STRICT_METHOD = arrayMethodIsStrict('some');
var USES_TO_LENGTH = arrayMethodUsesToLength('some');

// `Array.prototype.some` method
// https://tc39.github.io/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.splice.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.splice.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
var arrayMethodUsesToLength = __webpack_require__(/*! ../internals/array-method-uses-to-length */ "./node_modules/core-js/internals/array-method-uses-to-length.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.function.has-instance.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js/modules/es.function.has-instance.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var HAS_INSTANCE = wellKnownSymbol('hasInstance');
var FunctionPrototype = Function.prototype;

// `Function.prototype[@@hasInstance]` method
// https://tc39.github.io/ecma262/#sec-function.prototype-@@hasinstance
if (!(HAS_INSTANCE in FunctionPrototype)) {
  definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, { value: function (O) {
    if (typeof this != 'function' || !isObject(O)) return false;
    if (!isObject(this.prototype)) return O instanceof this;
    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
    while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
    return false;
  } });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.function.name.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.function.name.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.global-this.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.global-this.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");

// `globalThis` object
// https://github.com/tc39/proposal-global
$({ global: true }, {
  globalThis: global
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.map.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/modules/es.map.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/core-js/internals/collection.js");
var collectionStrong = __webpack_require__(/*! ../internals/collection-strong */ "./node_modules/core-js/internals/collection-strong.js");

// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "./node_modules/core-js/modules/es.math.sign.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/es.math.sign.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var sign = __webpack_require__(/*! ../internals/math-sign */ "./node_modules/core-js/internals/math-sign.js");

// `Math.sign` method
// https://tc39.github.io/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.math.trunc.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.math.trunc.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.github.io/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: function trunc(it) {
    return (it > 0 ? floor : ceil)(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.number.constructor.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.number.constructor.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js/internals/string-trim.js").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.number.is-nan.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.number.is-nan.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");

// `Number.isNaN` method
// https://tc39.github.io/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.number.max-safe-integer.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/modules/es.number.max-safe-integer.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.github.io/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.number.parse-int.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.number.parse-int.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var parseInt = __webpack_require__(/*! ../internals/number-parse-int */ "./node_modules/core-js/internals/number-parse-int.js");

// `Number.parseInt` method
// https://tc39.github.io/ecma262/#sec-number.parseint
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.number.to-fixed.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.number.to-fixed.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var thisNumberValue = __webpack_require__(/*! ../internals/this-number-value */ "./node_modules/core-js/internals/this-number-value.js");
var repeat = __webpack_require__(/*! ../internals/string-repeat */ "./node_modules/core-js/internals/string-repeat.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var nativeToFixed = 1.0.toFixed;
var floor = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var FORCED = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.github.io/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  // eslint-disable-next-line max-statements
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    var multiply = function (n, c) {
      var index = -1;
      var c2 = c;
      while (++index < 6) {
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = floor(c2 / 1e7);
      }
    };

    var divide = function (n) {
      var index = 6;
      var c = 0;
      while (--index >= 0) {
        c += data[index];
        data[index] = floor(c / n);
        c = (c % n) * 1e7;
      }
    };

    var dataToString = function () {
      var index = 6;
      var s = '';
      while (--index >= 0) {
        if (s !== '' || index === 0 || data[index] !== 0) {
          var t = String(data[index]);
          s = s === '' ? t : s + repeat.call('0', 7 - t.length) + t;
        }
      } return s;
    };

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        result = dataToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        result = dataToString() + repeat.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.assign.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.assign.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var assign = __webpack_require__(/*! ../internals/object-assign */ "./node_modules/core-js/internals/object-assign.js");

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.define-getter.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.define-getter.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var FORCED = __webpack_require__(/*! ../internals/object-prototype-accessors-forced */ "./node_modules/core-js/internals/object-prototype-accessors-forced.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");

// `Object.prototype.__defineGetter__` method
// https://tc39.github.io/ecma262/#sec-object.prototype.__defineGetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __defineGetter__: function __defineGetter__(P, getter) {
      definePropertyModule.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
    }
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.entries.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.entries.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $entries = __webpack_require__(/*! ../internals/object-to-array */ "./node_modules/core-js/internals/object-to-array.js").entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.freeze.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.freeze.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var FREEZING = __webpack_require__(/*! ../internals/freezing */ "./node_modules/core-js/internals/freezing.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var onFreeze = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js").onFreeze;

var nativeFreeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { nativeFreeze(1); });

// `Object.freeze` method
// https://tc39.github.io/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return nativeFreeze && isObject(it) ? nativeFreeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.from-entries.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.from-entries.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, undefined, true);
    return obj;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.get-own-property-descriptor.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var nativeGetOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.get-own-property-descriptors.js":
/*!********************************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var ownKeys = __webpack_require__(/*! ../internals/own-keys */ "./node_modules/core-js/internals/own-keys.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.get-own-property-names.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.get-own-property-names.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var nativeGetOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names-external */ "./node_modules/core-js/internals/object-get-own-property-names-external.js").f;

var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: nativeGetOwnPropertyNames
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.get-prototype-of.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.get-prototype-of.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var nativeGetPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/core-js/internals/correct-prototype-getter.js");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "./node_modules/core-js/modules/es.object.is-extensible.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.is-extensible.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

var nativeIsExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { nativeIsExtensible(1); });

// `Object.isExtensible` method
// https://tc39.github.io/ecma262/#sec-object.isextensible
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  isExtensible: function isExtensible(it) {
    return isObject(it) ? nativeIsExtensible ? nativeIsExtensible(it) : true : false;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.is-frozen.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.is-frozen.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

var nativeIsFrozen = Object.isFrozen;
var FAILS_ON_PRIMITIVES = fails(function () { nativeIsFrozen(1); });

// `Object.isFrozen` method
// https://tc39.github.io/ecma262/#sec-object.isfrozen
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  isFrozen: function isFrozen(it) {
    return isObject(it) ? nativeIsFrozen ? nativeIsFrozen(it) : false : true;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.keys.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.keys.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var nativeKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.to-string.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.to-string.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var toString = __webpack_require__(/*! ../internals/object-to-string */ "./node_modules/core-js/internals/object-to-string.js");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.values.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.values.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $values = __webpack_require__(/*! ../internals/object-to-array */ "./node_modules/core-js/internals/object-to-array.js").values;

// `Object.values` method
// https://tc39.github.io/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.promise.finally.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.promise.finally.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var NativePromise = __webpack_require__(/*! ../internals/native-promise-constructor */ "./node_modules/core-js/internals/native-promise-constructor.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var promiseResolve = __webpack_require__(/*! ../internals/promise-resolve */ "./node_modules/core-js/internals/promise-resolve.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// patch native Promise.prototype for native async functions
if (!IS_PURE && typeof NativePromise == 'function' && !NativePromise.prototype['finally']) {
  redefine(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.promise.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/modules/es.promise.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var NativePromise = __webpack_require__(/*! ../internals/native-promise-constructor */ "./node_modules/core-js/internals/native-promise-constructor.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js/internals/set-species.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");
var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var task = __webpack_require__(/*! ../internals/task */ "./node_modules/core-js/internals/task.js").set;
var microtask = __webpack_require__(/*! ../internals/microtask */ "./node_modules/core-js/internals/microtask.js");
var promiseResolve = __webpack_require__(/*! ../internals/promise-resolve */ "./node_modules/core-js/internals/promise-resolve.js");
var hostReportErrors = __webpack_require__(/*! ../internals/host-report-errors */ "./node_modules/core-js/internals/host-report-errors.js");
var newPromiseCapabilityModule = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js/internals/new-promise-capability.js");
var perform = __webpack_require__(/*! ../internals/perform */ "./node_modules/core-js/internals/perform.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js/internals/engine-v8-version.js");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof(process) == 'process';
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.reflect.construct.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/modules/es.reflect.construct.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var bind = __webpack_require__(/*! ../internals/function-bind */ "./node_modules/core-js/internals/function-bind.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.github.io/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.reflect.define-property.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/modules/es.reflect.define-property.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var ERROR_INSTEAD_OF_FALSE = fails(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(definePropertyModule.f({}, 1, { value: 1 }), 1, { value: 2 });
});

// `Reflect.defineProperty` method
// https://tc39.github.io/ecma262/#sec-reflect.defineproperty
$({ target: 'Reflect', stat: true, forced: ERROR_INSTEAD_OF_FALSE, sham: !DESCRIPTORS }, {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    var key = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      definePropertyModule.f(target, key, attributes);
      return true;
    } catch (error) {
      return false;
    }
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.reflect.delete-property.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/modules/es.reflect.delete-property.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;

// `Reflect.deleteProperty` method
// https://tc39.github.io/ecma262/#sec-reflect.deleteproperty
$({ target: 'Reflect', stat: true }, {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.reflect.get-own-property-descriptor.js":
/*!********************************************************************************!*\
  !*** ./node_modules/core-js/modules/es.reflect.get-own-property-descriptor.js ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");

// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-reflect.getownpropertydescriptor
$({ target: 'Reflect', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.reflect.get.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.reflect.get.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");

// `Reflect.get` method
// https://tc39.github.io/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  if (descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey)) return has(descriptor, 'value')
    ? descriptor.value
    : descriptor.get === undefined
      ? undefined
      : descriptor.get.call(receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.reflect.has.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.reflect.has.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");

// `Reflect.has` method
// https://tc39.github.io/ecma262/#sec-reflect.has
$({ target: 'Reflect', stat: true }, {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.reflect.own-keys.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.reflect.own-keys.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var ownKeys = __webpack_require__(/*! ../internals/own-keys */ "./node_modules/core-js/internals/own-keys.js");

// `Reflect.ownKeys` method
// https://tc39.github.io/ecma262/#sec-reflect.ownkeys
$({ target: 'Reflect', stat: true }, {
  ownKeys: ownKeys
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.reflect.set.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.reflect.set.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");

// `Reflect.set` method
// https://tc39.github.io/ecma262/#sec-reflect.set
function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDescriptor = getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
  var existingDescriptor, prototype;
  if (!ownDescriptor) {
    if (isObject(prototype = getPrototypeOf(target))) {
      return set(prototype, propertyKey, V, receiver);
    }
    ownDescriptor = createPropertyDescriptor(0);
  }
  if (has(ownDescriptor, 'value')) {
    if (ownDescriptor.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = getOwnPropertyDescriptorModule.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      definePropertyModule.f(receiver, propertyKey, existingDescriptor);
    } else definePropertyModule.f(receiver, propertyKey, createPropertyDescriptor(0, V));
    return true;
  }
  return ownDescriptor.set === undefined ? false : (ownDescriptor.set.call(receiver, V), true);
}

// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var MS_EDGE_BUG = fails(function () {
  var object = definePropertyModule.f({}, 'a', { configurable: true });
  // eslint-disable-next-line no-undef
  return Reflect.set(getPrototypeOf(object), 'a', 1, object) !== false;
});

$({ target: 'Reflect', stat: true, forced: MS_EDGE_BUG }, {
  set: set
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.regexp.constructor.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.regexp.constructor.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;
var isRegExp = __webpack_require__(/*! ../internals/is-regexp */ "./node_modules/core-js/internals/is-regexp.js");
var getFlags = __webpack_require__(/*! ../internals/regexp-flags */ "./node_modules/core-js/internals/regexp-flags.js");
var stickyHelpers = __webpack_require__(/*! ../internals/regexp-sticky-helpers */ "./node_modules/core-js/internals/regexp-sticky-helpers.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var setInternalState = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js").set;
var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js/internals/set-species.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || UNSUPPORTED_Y || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var sticky;

    if (!thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined) {
      return pattern;
    }

    if (CORRECT_NEW) {
      if (patternIsRegExp && !flagsAreUndefined) pattern = pattern.source;
    } else if (pattern instanceof RegExpWrapper) {
      if (flagsAreUndefined) flags = getFlags.call(pattern);
      pattern = pattern.source;
    }

    if (UNSUPPORTED_Y) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    var result = inheritIfRequired(
      CORRECT_NEW ? new NativeRegExp(pattern, flags) : NativeRegExp(pattern, flags),
      thisIsRegExp ? this : RegExpPrototype,
      RegExpWrapper
    );

    if (UNSUPPORTED_Y && sticky) setInternalState(result, { sticky: sticky });

    return result;
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "./node_modules/core-js/modules/es.regexp.exec.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.regexp.exec.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var exec = __webpack_require__(/*! ../internals/regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.regexp.to-string.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.regexp.to-string.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var flags = __webpack_require__(/*! ../internals/regexp-flags */ "./node_modules/core-js/internals/regexp-flags.js");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.set.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/modules/es.set.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/core-js/internals/collection.js");
var collectionStrong = __webpack_require__(/*! ../internals/collection-strong */ "./node_modules/core-js/internals/collection-strong.js");

// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.anchor.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.anchor.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var createHTML = __webpack_require__(/*! ../internals/create-html */ "./node_modules/core-js/internals/create-html.js");
var forcedStringHTMLMethod = __webpack_require__(/*! ../internals/string-html-forced */ "./node_modules/core-js/internals/string-html-forced.js");

// `String.prototype.anchor` method
// https://tc39.github.io/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.ends-with.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.ends-with.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js/internals/correct-is-regexp-logic.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");

var nativeEndsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = String(searchString);
    return nativeEndsWith
      ? nativeEndsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.includes.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.includes.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js/internals/correct-is-regexp-logic.js");

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.iterator.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.iterator.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").charAt;
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.match.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.match.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var advanceStringIndex = __webpack_require__(/*! ../internals/advance-string-index */ "./node_modules/core-js/internals/advance-string-index.js");
var regExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.pad-end.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.pad-end.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $padEnd = __webpack_require__(/*! ../internals/string-pad */ "./node_modules/core-js/internals/string-pad.js").end;
var WEBKIT_BUG = __webpack_require__(/*! ../internals/string-pad-webkit-bug */ "./node_modules/core-js/internals/string-pad-webkit-bug.js");

// `String.prototype.padEnd` method
// https://tc39.github.io/ecma262/#sec-string.prototype.padend
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.pad-start.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.pad-start.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $padStart = __webpack_require__(/*! ../internals/string-pad */ "./node_modules/core-js/internals/string-pad.js").start;
var WEBKIT_BUG = __webpack_require__(/*! ../internals/string-pad-webkit-bug */ "./node_modules/core-js/internals/string-pad-webkit-bug.js");

// `String.prototype.padStart` method
// https://tc39.github.io/ecma262/#sec-string.prototype.padstart
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.repeat.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.repeat.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var repeat = __webpack_require__(/*! ../internals/string-repeat */ "./node_modules/core-js/internals/string-repeat.js");

// `String.prototype.repeat` method
// https://tc39.github.io/ecma262/#sec-string.prototype.repeat
$({ target: 'String', proto: true }, {
  repeat: repeat
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.replace.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.replace.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var advanceStringIndex = __webpack_require__(/*! ../internals/advance-string-index */ "./node_modules/core-js/internals/advance-string-index.js");
var regExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.search.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.search.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var sameValue = __webpack_require__(/*! ../internals/same-value */ "./node_modules/core-js/internals/same-value.js");
var regExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");

// @@search logic
fixRegExpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.split.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.split.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(/*! ../internals/fix-regexp-well-known-symbol-logic */ "./node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var isRegExp = __webpack_require__(/*! ../internals/is-regexp */ "./node_modules/core-js/internals/is-regexp.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var advanceStringIndex = __webpack_require__(/*! ../internals/advance-string-index */ "./node_modules/core-js/internals/advance-string-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var callRegExpExec = __webpack_require__(/*! ../internals/regexp-exec-abstract */ "./node_modules/core-js/internals/regexp-exec-abstract.js");
var regexpExec = __webpack_require__(/*! ../internals/regexp-exec */ "./node_modules/core-js/internals/regexp-exec.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.starts-with.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.starts-with.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js/internals/correct-is-regexp-logic.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.trim.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.trim.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js/internals/string-trim.js").trim;
var forcedStringTrimMethod = __webpack_require__(/*! ../internals/string-trim-forced */ "./node_modules/core-js/internals/string-trim-forced.js");

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.symbol.description.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.description.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.symbol.has-instance.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.has-instance.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js/internals/define-well-known-symbol.js");

// `Symbol.hasInstance` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');


/***/ }),

/***/ "./node_modules/core-js/modules/es.symbol.iterator.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.iterator.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js/internals/define-well-known-symbol.js");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "./node_modules/core-js/modules/es.symbol.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js/internals/native-symbol.js");
var USE_SYMBOL_AS_UID = __webpack_require__(/*! ../internals/use-symbol-as-uid */ "./node_modules/core-js/internals/use-symbol-as-uid.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var nativeObjectCreate = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertyNamesExternal = __webpack_require__(/*! ../internals/object-get-own-property-names-external */ "./node_modules/core-js/internals/object-get-own-property-names-external.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var wrappedWellKnownSymbolModule = __webpack_require__(/*! ../internals/well-known-symbol-wrapped */ "./node_modules/core-js/internals/well-known-symbol-wrapped.js");
var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js/internals/define-well-known-symbol.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var $forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "./node_modules/core-js/modules/es.weak-map.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/modules/es.weak-map.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var InternalMetadataModule = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js/internals/internal-metadata.js");
var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/core-js/internals/collection.js");
var collectionWeak = __webpack_require__(/*! ../internals/collection-weak */ "./node_modules/core-js/internals/collection-weak.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var enforceIternalState = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js").enforce;
var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/native-weak-map */ "./node_modules/core-js/internals/native-weak-map.js");

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.github.io/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.REQUIRED = true;
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.global-this.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.global-this.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__(/*! ./es.global-this */ "./node_modules/core-js/modules/es.global-this.js");


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.delete-all.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.delete-all.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var collectionDeleteAll = __webpack_require__(/*! ../internals/collection-delete-all */ "./node_modules/core-js/internals/collection-delete-all.js");

// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  deleteAll: function deleteAll(/* ...elements */) {
    return collectionDeleteAll.apply(this, arguments);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.every.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.every.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  every: function every(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return !iterate(iterator, function (key, value) {
      if (!boundFunction(value, key, map)) return iterate.stop();
    }, undefined, true, true).stopped;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.filter.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.filter.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  filter: function filter(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aFunction(newMap.set);
    iterate(iterator, function (key, value) {
      if (boundFunction(value, key, map)) setter.call(newMap, key, value);
    }, undefined, true, true);
    return newMap;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.find-key.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.find-key.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  findKey: function findKey(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (key, value) {
      if (boundFunction(value, key, map)) return iterate.stop(key);
    }, undefined, true, true).result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.find.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.find.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  find: function find(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (key, value) {
      if (boundFunction(value, key, map)) return iterate.stop(value);
    }, undefined, true, true).result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.includes.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.includes.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var sameValueZero = __webpack_require__(/*! ../internals/same-value-zero */ "./node_modules/core-js/internals/same-value-zero.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  includes: function includes(searchElement) {
    return iterate(getMapIterator(anObject(this)), function (key, value) {
      if (sameValueZero(value, searchElement)) return iterate.stop();
    }, undefined, true, true).stopped;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.key-of.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.key-of.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  keyOf: function keyOf(searchElement) {
    return iterate(getMapIterator(anObject(this)), function (key, value) {
      if (value === searchElement) return iterate.stop(key);
    }, undefined, true, true).result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.map-keys.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.map-keys.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  mapKeys: function mapKeys(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aFunction(newMap.set);
    iterate(iterator, function (key, value) {
      setter.call(newMap, boundFunction(value, key, map), value);
    }, undefined, true, true);
    return newMap;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.map-values.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.map-values.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  mapValues: function mapValues(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aFunction(newMap.set);
    iterate(iterator, function (key, value) {
      setter.call(newMap, key, boundFunction(value, key, map));
    }, undefined, true, true);
    return newMap;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.merge.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.merge.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  // eslint-disable-next-line no-unused-vars
  merge: function merge(iterable /* ...iterbles */) {
    var map = anObject(this);
    var setter = aFunction(map.set);
    var i = 0;
    while (i < arguments.length) {
      iterate(arguments[i++], setter, map, true);
    }
    return map;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.reduce.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.reduce.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    aFunction(callbackfn);
    iterate(iterator, function (key, value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = callbackfn(accumulator, value, key, map);
      }
    }, undefined, true, true);
    if (noInitial) throw TypeError('Reduce of empty map with no initial value');
    return accumulator;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.some.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.some.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var getMapIterator = __webpack_require__(/*! ../internals/get-map-iterator */ "./node_modules/core-js/internals/get-map-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  some: function some(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (key, value) {
      if (boundFunction(value, key, map)) return iterate.stop();
    }, undefined, true, true).stopped;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.map.update.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.map.update.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");

// `Set.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  update: function update(key, callback /* , thunk */) {
    var map = anObject(this);
    var length = arguments.length;
    aFunction(callback);
    var isPresentInMap = map.has(key);
    if (!isPresentInMap && length < 3) {
      throw TypeError('Updating absent value');
    }
    var value = isPresentInMap ? map.get(key) : aFunction(length > 2 ? arguments[2] : undefined)(key, map);
    map.set(key, callback(value, key, map));
    return map;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.add-all.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.add-all.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var collectionAddAll = __webpack_require__(/*! ../internals/collection-add-all */ "./node_modules/core-js/internals/collection-add-all.js");

// `Set.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  addAll: function addAll(/* ...elements */) {
    return collectionAddAll.apply(this, arguments);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.delete-all.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.delete-all.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var collectionDeleteAll = __webpack_require__(/*! ../internals/collection-delete-all */ "./node_modules/core-js/internals/collection-delete-all.js");

// `Set.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  deleteAll: function deleteAll(/* ...elements */) {
    return collectionDeleteAll.apply(this, arguments);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.difference.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.difference.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  difference: function difference(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    var remover = aFunction(newSet['delete']);
    iterate(iterable, function (value) {
      remover.call(newSet, value);
    });
    return newSet;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.every.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.every.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var getSetIterator = __webpack_require__(/*! ../internals/get-set-iterator */ "./node_modules/core-js/internals/get-set-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  every: function every(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return !iterate(iterator, function (value) {
      if (!boundFunction(value, value, set)) return iterate.stop();
    }, undefined, false, true).stopped;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.filter.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.filter.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var getSetIterator = __webpack_require__(/*! ../internals/get-set-iterator */ "./node_modules/core-js/internals/get-set-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  filter: function filter(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
    var adder = aFunction(newSet.add);
    iterate(iterator, function (value) {
      if (boundFunction(value, value, set)) adder.call(newSet, value);
    }, undefined, false, true);
    return newSet;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.find.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.find.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var getSetIterator = __webpack_require__(/*! ../internals/get-set-iterator */ "./node_modules/core-js/internals/get-set-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  find: function find(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (value) {
      if (boundFunction(value, value, set)) return iterate.stop(value);
    }, undefined, false, true).result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.intersection.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.intersection.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  intersection: function intersection(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
    var hasCheck = aFunction(set.has);
    var adder = aFunction(newSet.add);
    iterate(iterable, function (value) {
      if (hasCheck.call(set, value)) adder.call(newSet, value);
    });
    return newSet;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.is-disjoint-from.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.is-disjoint-from.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  isDisjointFrom: function isDisjointFrom(iterable) {
    var set = anObject(this);
    var hasCheck = aFunction(set.has);
    return !iterate(iterable, function (value) {
      if (hasCheck.call(set, value) === true) return iterate.stop();
    }).stopped;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.is-subset-of.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.is-subset-of.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var getIterator = __webpack_require__(/*! ../internals/get-iterator */ "./node_modules/core-js/internals/get-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  isSubsetOf: function isSubsetOf(iterable) {
    var iterator = getIterator(this);
    var otherSet = anObject(iterable);
    var hasCheck = otherSet.has;
    if (typeof hasCheck != 'function') {
      otherSet = new (getBuiltIn('Set'))(iterable);
      hasCheck = aFunction(otherSet.has);
    }
    return !iterate(iterator, function (value) {
      if (hasCheck.call(otherSet, value) === false) return iterate.stop();
    }, undefined, false, true).stopped;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.is-superset-of.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.is-superset-of.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  isSupersetOf: function isSupersetOf(iterable) {
    var set = anObject(this);
    var hasCheck = aFunction(set.has);
    return !iterate(iterable, function (value) {
      if (hasCheck.call(set, value) === false) return iterate.stop();
    }).stopped;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.join.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.join.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var getSetIterator = __webpack_require__(/*! ../internals/get-set-iterator */ "./node_modules/core-js/internals/get-set-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.join` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  join: function join(separator) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var sep = separator === undefined ? ',' : String(separator);
    var result = [];
    iterate(iterator, result.push, result, false, true);
    return result.join(sep);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.map.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.map.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var getSetIterator = __webpack_require__(/*! ../internals/get-set-iterator */ "./node_modules/core-js/internals/get-set-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.map` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  map: function map(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
    var adder = aFunction(newSet.add);
    iterate(iterator, function (value) {
      adder.call(newSet, boundFunction(value, value, set));
    }, undefined, false, true);
    return newSet;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.reduce.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.reduce.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var getSetIterator = __webpack_require__(/*! ../internals/get-set-iterator */ "./node_modules/core-js/internals/get-set-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    aFunction(callbackfn);
    iterate(iterator, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = callbackfn(accumulator, value, value, set);
      }
    }, undefined, false, true);
    if (noInitial) throw TypeError('Reduce of empty set with no initial value');
    return accumulator;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.some.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.some.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var getSetIterator = __webpack_require__(/*! ../internals/get-set-iterator */ "./node_modules/core-js/internals/get-set-iterator.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  some: function some(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (value) {
      if (boundFunction(value, value, set)) return iterate.stop();
    }, undefined, false, true).stopped;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.symmetric-difference.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.symmetric-difference.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  symmetricDifference: function symmetricDifference(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    var remover = aFunction(newSet['delete']);
    var adder = aFunction(newSet.add);
    iterate(iterable, function (value) {
      remover.call(newSet, value) || adder.call(newSet, value);
    });
    return newSet;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.set.union.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.set.union.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js/internals/species-constructor.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js/internals/iterate.js");

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  union: function union(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    iterate(iterable, aFunction(newSet.add), newSet);
    return newSet;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.string.at.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.string.at.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var charAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").charAt;

// `String.prototype.at` method
// https://github.com/mathiasbynens/String.prototype.at
$({ target: 'String', proto: true }, {
  at: function at(pos) {
    return charAt(this, pos);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/esnext.weak-map.delete-all.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/modules/esnext.weak-map.delete-all.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var collectionDeleteAll = __webpack_require__(/*! ../internals/collection-delete-all */ "./node_modules/core-js/internals/collection-delete-all.js");

// `WeakMap.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'WeakMap', proto: true, real: true, forced: IS_PURE }, {
  deleteAll: function deleteAll(/* ...elements */) {
    return collectionDeleteAll.apply(this, arguments);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/web.dom-collections.for-each.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/modules/web.dom-collections.for-each.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var DOMIterables = __webpack_require__(/*! ../internals/dom-iterables */ "./node_modules/core-js/internals/dom-iterables.js");
var forEach = __webpack_require__(/*! ../internals/array-for-each */ "./node_modules/core-js/internals/array-for-each.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "./node_modules/core-js/modules/web.dom-collections.iterator.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/modules/web.dom-collections.iterator.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var DOMIterables = __webpack_require__(/*! ../internals/dom-iterables */ "./node_modules/core-js/internals/dom-iterables.js");
var ArrayIteratorMethods = __webpack_require__(/*! ../modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "./node_modules/core-js/modules/web.url-search-params.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/web.url-search-params.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(/*! ../modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var USE_NATIVE_URL = __webpack_require__(/*! ../internals/native-url */ "./node_modules/core-js/internals/native-url.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js/internals/redefine-all.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var createIteratorConstructor = __webpack_require__(/*! ../internals/create-iterator-constructor */ "./node_modules/core-js/internals/create-iterator-constructor.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var hasOwn = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var getIterator = __webpack_require__(/*! ../internals/get-iterator */ "./node_modules/core-js/internals/get-iterator.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.appent` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
  $({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject(init)) {
          body = init.body;
          if (classof(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch.apply(this, args);
    }
  });
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ "./node_modules/core-js/modules/web.url.js":
/*!*************************************************!*\
  !*** ./node_modules/core-js/modules/web.url.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(/*! ../modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var USE_NATIVE_URL = __webpack_require__(/*! ../internals/native-url */ "./node_modules/core-js/internals/native-url.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var defineProperties = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js/internals/an-instance.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var assign = __webpack_require__(/*! ../internals/object-assign */ "./node_modules/core-js/internals/object-assign.js");
var arrayFrom = __webpack_require__(/*! ../internals/array-from */ "./node_modules/core-js/internals/array-from.js");
var codeAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").codeAt;
var toASCII = __webpack_require__(/*! ../internals/string-punycode-to-ascii */ "./node_modules/core-js/internals/string-punycode-to-ascii.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var URLSearchParamsModule = __webpack_require__(/*! ../modules/web.url-search-params */ "./node_modules/core-js/modules/web.url-search-params.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
// eslint-disable-next-line no-control-regex
var TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g;
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(char())) return;
        while (DIGIT.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (char, set) {
  var code = codeAt(char, 0);
  return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (char && ALPHA.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial(url) != has(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (char == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (char == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (char == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (char != '/' && char != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += char;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT:
        if (DIGIT.test(char)) {
          buffer += char;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (char == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (char == '/' || char == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += char;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          state = PATH;
          if (char != '/') continue;
        } break;

      case PATH:
        if (
          char == EOF || char == '/' ||
          (char == '\\' && isSpecial(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(char, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (char == '?') {
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          if (char == "'" && isSpecial(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URL(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = String(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, String(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, pathname + '', PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ "./node_modules/core-js/modules/web.url.to-json.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/web.url.to-json.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return URL.prototype.toString.call(this);
  }
});


/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ "./node_modules/whatwg-fetch/fetch.js":
/*!********************************************!*\
  !*** ./node_modules/whatwg-fetch/fetch.js ***!
  \********************************************/
/*! exports provided: Headers, Request, Response, DOMException, fetch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Headers", function() { return Headers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Request", function() { return Request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Response", function() { return Response; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : ''
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && self.location.href ? self.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob'
      } else if (
        support.arrayBuffer &&
        request.headers.get('Content-Type') &&
        request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),

/***/ "./webpack.entry.js":
/*!**************************!*\
  !*** ./webpack.entry.js ***!
  \**************************/
/*! exports provided: Base, Config, GlobalEvents, AjaxStore, DomDataStore, Duration, DataField, BooleanDataField, DateDataField, IntegerDataField, ModelDataField, NumberDataField, ObjectDataField, StringDataField, Model, StateTrackingManager, Store, Transaction, AjaxHelper, ArrayHelper, AsyncHelper, BrowserHelper, CSSHelper, DateHelper, DomClassList, DomHelper, DomSync, DragHelper, EventHelper, FunctionHelper, IdHelper, ObjectHelper, RandomGenerator, ResizeHelper, ResizeMonitor, StringHelper, TemplateHelper, VersionHelper, WidgetHelper, DataGenerator, DemoBot, Formatter, Fullscreen, NumberFormat, Objects, Point, Promissory, Rectangle, Scroller, LocaleManager, Localizable, LocaleHelper, Delayable, Draggable, Droppable, Events, Factoryable, Featureable, Finalizable, Hoverable, InstancePlugin, Override, Pluggable, State, Bag, ClickRepeater, Collection, CollectionFilter, CollectionSorter, DragContext, DragProxy, DragTipProxy, DynamicObject, Month, Parser, Badge, BooleanCombo, Button, ButtonGroup, CalendarPanel, Checkbox, ChipView, Combo, Container, DateField, DatePicker, DateTimeField, DisplayField, DurationField, Editor, Field, FileField, FilePicker, FilterField, List, Mask, Menu, MenuItem, MessageDialog, NumberField, PagingToolbar, Panel, Popup, Renderable, Ripple, Slider, Splitter, TabPanel, TextAreaField, TextField, TimeField, TimePicker, Toast, Tool, Toolbar, Tooltip, Widget, ActionColumn, AggregateColumn, CheckColumn, Column, DateColumn, PercentColumn, RatingColumn, RowNumberColumn, TemplateColumn, TimeColumn, TreeColumn, WidgetColumn, ColumnStore, GridRowModel, CellEdit, CellMenu, CellTooltip, ColumnAutoWidth, ColumnDragToolbar, ColumnPicker, ColumnReorder, ColumnResize, ContextMenu, Filter, FilterBar, GridFeatureManager, Group, HeaderMenu, QuickFind, RegionResize, RowReorder, Search, Sort, Stripe, Tree, FileFormat, GridExportDialog, GridMultiPageExporter, GridMultiPageVerticalExporter, GridPdfExport, GridSinglePageExporter, ExportOrientationCombo, ExportRowsCombo, LocalizableCombo, Orientation, PaperFormat, RowsRange, GridExcelExporter, ScrollManager, TableExporter, Footer, Grid, GridBase, Header, RowManager, TreeGrid, AbstractCrudManager, AjaxTransport, CrudManagerView, JsonEncoder, AbstractRecurrenceIterator, AssignmentStore, CrudManager, ProjectCrudManager, DailyRecurrenceIterator, DependencyStore, EventStore, MonthlyRecurrenceIterator, RecurrenceDayRuleEncoder, RecurrenceLegend, ProjectConsumer, RecurringEventsMixin, RecurringTimeSpansMixin, ResourceStore, ResourceTimeRangeStore, TimeAxis, WeeklyRecurrenceIterator, YearlyRecurrenceIterator, ColumnLines, Dependencies, DependencyEdit, DragBase, DependencyCreation, EventContextMenu, EventDrag, EventDragCreate, EventDragSelect, EventEdit, EventFilter, EventMenu, EventResize, EventTooltip, GroupSummary, HeaderContextMenu, HeaderZoom, Labels, NonWorkingTime, Pan, RecurringEventEdit, ResourceTimeRanges, ScheduleContextMenu, ScheduleMenu, ScheduleTooltip, SimpleEventEdit, Summary, TimeAxisHeaderMenu, TimeRanges, TimeSpanMenuBase, TimeSpanRecordContextMenuBase, MultiPageExporter, MultiPageVerticalExporter, PdfExport, SchedulerExportDialog, SinglePageExporter, ScheduleRangeCombo, ScheduleRange, ExcelExporter, ResourceInfoColumn, TimeAxisColumn, AssignmentModel, DependencyBaseModel, DependencyModel, EventModel, ProjectModel, RecurrenceModel, RecurringTimeSpan, ResourceModel, ResourceTimeRangeModel, TimeSpan, PresetManager, PresetStore, ViewPreset, RectangularPathFinder, ScheduleTableExporter, HorizontalTimeAxis, RecurrenceCombo, RecurrenceConfirmationPopup, RecurrenceDaysButtonGroup, RecurrenceDaysCombo, RecurrenceEditor, RecurrenceFrequencyCombo, RecurrenceLegendButton, RecurrenceMonthDaysButtonGroup, RecurrenceMonthsButtonGroup, RecurrencePositionsCombo, RecurrenceStopConditionCombo, Scheduler, SchedulerBase, TimeAxisViewModel, ResourceFilter, ResourceCombo, UndoRedo, SchedulerTag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lib_Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./lib/Core/Base.js */ "./lib/Core/Base.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _lib_Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _lib_Core_Config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./lib/Core/Config.js */ "./lib/Core/Config.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return _lib_Core_Config_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _lib_Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./lib/Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GlobalEvents", function() { return _lib_Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _lib_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./lib/Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxStore", function() { return _lib_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _lib_Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./lib/Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomDataStore", function() { return _lib_Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _lib_Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./lib/Core/data/Duration.js */ "./lib/Core/data/Duration.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return _lib_Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _lib_Core_data_field_DataField_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./lib/Core/data/field/DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataField", function() { return _lib_Core_data_field_DataField_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _lib_Core_data_field_BooleanDataField_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./lib/Core/data/field/BooleanDataField.js */ "./lib/Core/data/field/BooleanDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanDataField", function() { return _lib_Core_data_field_BooleanDataField_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _lib_Core_data_field_DateDataField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./lib/Core/data/field/DateDataField.js */ "./lib/Core/data/field/DateDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateDataField", function() { return _lib_Core_data_field_DateDataField_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _lib_Core_data_field_IntegerDataField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./lib/Core/data/field/IntegerDataField.js */ "./lib/Core/data/field/IntegerDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntegerDataField", function() { return _lib_Core_data_field_IntegerDataField_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _lib_Core_data_field_ModelDataField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./lib/Core/data/field/ModelDataField.js */ "./lib/Core/data/field/ModelDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelDataField", function() { return _lib_Core_data_field_ModelDataField_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _lib_Core_data_field_NumberDataField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./lib/Core/data/field/NumberDataField.js */ "./lib/Core/data/field/NumberDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberDataField", function() { return _lib_Core_data_field_NumberDataField_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _lib_Core_data_field_ObjectDataField_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./lib/Core/data/field/ObjectDataField.js */ "./lib/Core/data/field/ObjectDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectDataField", function() { return _lib_Core_data_field_ObjectDataField_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _lib_Core_data_field_StringDataField_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./lib/Core/data/field/StringDataField.js */ "./lib/Core/data/field/StringDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringDataField", function() { return _lib_Core_data_field_StringDataField_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _lib_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./lib/Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return _lib_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _lib_Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./lib/Core/data/stm/StateTrackingManager.js */ "./lib/Core/data/stm/StateTrackingManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTrackingManager", function() { return _lib_Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _lib_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./lib/Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return _lib_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _lib_Core_data_stm_Transaction_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./lib/Core/data/stm/Transaction.js */ "./lib/Core/data/stm/Transaction.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return _lib_Core_data_stm_Transaction_js__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony import */ var _lib_Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./lib/Core/helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxHelper", function() { return _lib_Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _lib_Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./lib/Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayHelper", function() { return _lib_Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _lib_Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./lib/Core/helper/AsyncHelper.js */ "./lib/Core/helper/AsyncHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AsyncHelper", function() { return _lib_Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _lib_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./lib/Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BrowserHelper", function() { return _lib_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _lib_Core_helper_CSSHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./lib/Core/helper/CSSHelper.js */ "./lib/Core/helper/CSSHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CSSHelper", function() { return _lib_Core_helper_CSSHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _lib_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./lib/Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateHelper", function() { return _lib_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _lib_Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./lib/Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomClassList", function() { return _lib_Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/* harmony import */ var _lib_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./lib/Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomHelper", function() { return _lib_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"]; });

/* harmony import */ var _lib_Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./lib/Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomSync", function() { return _lib_Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_26__["default"]; });

/* harmony import */ var _lib_Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./lib/Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragHelper", function() { return _lib_Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"]; });

/* harmony import */ var _lib_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./lib/Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventHelper", function() { return _lib_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"]; });

/* harmony import */ var _lib_Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./lib/Core/helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionHelper", function() { return _lib_Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"]; });

/* harmony import */ var _lib_Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./lib/Core/helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IdHelper", function() { return _lib_Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_30__["default"]; });

/* harmony import */ var _lib_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./lib/Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectHelper", function() { return _lib_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"]; });

/* harmony import */ var _lib_Core_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./lib/Core/helper/util/RandomGenerator.js */ "./lib/Core/helper/util/RandomGenerator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RandomGenerator", function() { return _lib_Core_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_32__["default"]; });

/* harmony import */ var _lib_Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./lib/Core/helper/ResizeHelper.js */ "./lib/Core/helper/ResizeHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeHelper", function() { return _lib_Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_33__["default"]; });

/* harmony import */ var _lib_Core_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./lib/Core/helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeMonitor", function() { return _lib_Core_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_34__["default"]; });

/* harmony import */ var _lib_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./lib/Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringHelper", function() { return _lib_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_35__["default"]; });

/* harmony import */ var _lib_Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./lib/Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateHelper", function() { return _lib_Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_36__["default"]; });

/* harmony import */ var _lib_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./lib/Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VersionHelper", function() { return _lib_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"]; });

/* harmony import */ var _lib_Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./lib/Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetHelper", function() { return _lib_Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"]; });

/* harmony import */ var _lib_Core_helper_util_DataGenerator_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./lib/Core/helper/util/DataGenerator.js */ "./lib/Core/helper/util/DataGenerator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataGenerator", function() { return _lib_Core_helper_util_DataGenerator_js__WEBPACK_IMPORTED_MODULE_39__["default"]; });

/* harmony import */ var _lib_Core_helper_util_DemoBot_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./lib/Core/helper/util/DemoBot.js */ "./lib/Core/helper/util/DemoBot.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DemoBot", function() { return _lib_Core_helper_util_DemoBot_js__WEBPACK_IMPORTED_MODULE_40__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Formatter_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./lib/Core/helper/util/Formatter.js */ "./lib/Core/helper/util/Formatter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Formatter", function() { return _lib_Core_helper_util_Formatter_js__WEBPACK_IMPORTED_MODULE_41__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./lib/Core/helper/util/Fullscreen.js */ "./lib/Core/helper/util/Fullscreen.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fullscreen", function() { return _lib_Core_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_42__["default"]; });

/* harmony import */ var _lib_Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./lib/Core/helper/util/NumberFormat.js */ "./lib/Core/helper/util/NumberFormat.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberFormat", function() { return _lib_Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_43__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./lib/Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Objects", function() { return _lib_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_44__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Point_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./lib/Core/helper/util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return _lib_Core_helper_util_Point_js__WEBPACK_IMPORTED_MODULE_45__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./lib/Core/helper/util/Promissory.js */ "./lib/Core/helper/util/Promissory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Promissory", function() { return _lib_Core_helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_46__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./lib/Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rectangle", function() { return _lib_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_47__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./lib/Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scroller", function() { return _lib_Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_48__["default"]; });

/* harmony import */ var _lib_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./lib/Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleManager", function() { return _lib_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_49__["default"]; });

/* harmony import */ var _lib_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./lib/Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Localizable", function() { return _lib_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_50__["default"]; });

/* harmony import */ var _lib_Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./lib/Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleHelper", function() { return _lib_Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_51__["default"]; });

/* harmony import */ var _lib_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./lib/Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Delayable", function() { return _lib_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_52__["default"]; });

/* harmony import */ var _lib_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./lib/Core/mixin/Draggable.js */ "./lib/Core/mixin/Draggable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Draggable", function() { return _lib_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_53__["default"]; });

/* harmony import */ var _lib_Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./lib/Core/mixin/Droppable.js */ "./lib/Core/mixin/Droppable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Droppable", function() { return _lib_Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_54__["default"]; });

/* harmony import */ var _lib_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./lib/Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return _lib_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_55__["default"]; });

/* harmony import */ var _lib_Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./lib/Core/mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Factoryable", function() { return _lib_Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_56__["default"]; });

/* harmony import */ var _lib_Core_mixin_Featureable_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./lib/Core/mixin/Featureable.js */ "./lib/Core/mixin/Featureable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Featureable", function() { return _lib_Core_mixin_Featureable_js__WEBPACK_IMPORTED_MODULE_57__["default"]; });

/* harmony import */ var _lib_Core_mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./lib/Core/mixin/Finalizable.js */ "./lib/Core/mixin/Finalizable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Finalizable", function() { return _lib_Core_mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_58__["default"]; });

/* harmony import */ var _lib_Core_mixin_Hoverable_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./lib/Core/mixin/Hoverable.js */ "./lib/Core/mixin/Hoverable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hoverable", function() { return _lib_Core_mixin_Hoverable_js__WEBPACK_IMPORTED_MODULE_59__["default"]; });

/* harmony import */ var _lib_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./lib/Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InstancePlugin", function() { return _lib_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_60__["default"]; });

/* harmony import */ var _lib_Core_mixin_Override_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./lib/Core/mixin/Override.js */ "./lib/Core/mixin/Override.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Override", function() { return _lib_Core_mixin_Override_js__WEBPACK_IMPORTED_MODULE_61__["default"]; });

/* harmony import */ var _lib_Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./lib/Core/mixin/Pluggable.js */ "./lib/Core/mixin/Pluggable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pluggable", function() { return _lib_Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_62__["default"]; });

/* harmony import */ var _lib_Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./lib/Core/mixin/State.js */ "./lib/Core/mixin/State.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "State", function() { return _lib_Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_63__["default"]; });

/* harmony import */ var _lib_Core_util_Bag_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./lib/Core/util/Bag.js */ "./lib/Core/util/Bag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bag", function() { return _lib_Core_util_Bag_js__WEBPACK_IMPORTED_MODULE_64__["default"]; });

/* harmony import */ var _lib_Core_util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./lib/Core/util/ClickRepeater.js */ "./lib/Core/util/ClickRepeater.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickRepeater", function() { return _lib_Core_util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_65__["default"]; });

/* harmony import */ var _lib_Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./lib/Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return _lib_Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_66__["default"]; });

/* harmony import */ var _lib_Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ./lib/Core/util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionFilter", function() { return _lib_Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_67__["default"]; });

/* harmony import */ var _lib_Core_util_CollectionSorter_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ./lib/Core/util/CollectionSorter.js */ "./lib/Core/util/CollectionSorter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionSorter", function() { return _lib_Core_util_CollectionSorter_js__WEBPACK_IMPORTED_MODULE_68__["default"]; });

/* harmony import */ var _lib_Core_util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ./lib/Core/util/drag/DragContext.js */ "./lib/Core/util/drag/DragContext.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return _lib_Core_util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_69__["default"]; });

/* harmony import */ var _lib_Core_util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ./lib/Core/util/drag/DragProxy.js */ "./lib/Core/util/drag/DragProxy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragProxy", function() { return _lib_Core_util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_70__["default"]; });

/* harmony import */ var _lib_Core_util_drag_DragTipProxy_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ./lib/Core/util/drag/DragTipProxy.js */ "./lib/Core/util/drag/DragTipProxy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTipProxy", function() { return _lib_Core_util_drag_DragTipProxy_js__WEBPACK_IMPORTED_MODULE_71__["default"]; });

/* harmony import */ var _lib_Core_util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ./lib/Core/util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DynamicObject", function() { return _lib_Core_util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_72__["default"]; });

/* harmony import */ var _lib_Core_util_Month_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ./lib/Core/util/Month.js */ "./lib/Core/util/Month.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Month", function() { return _lib_Core_util_Month_js__WEBPACK_IMPORTED_MODULE_73__["default"]; });

/* harmony import */ var _lib_Core_util_Parser_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ./lib/Core/util/Parser.js */ "./lib/Core/util/Parser.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return _lib_Core_util_Parser_js__WEBPACK_IMPORTED_MODULE_74__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ./lib/Core/widget/mixin/Badge.js */ "./lib/Core/widget/mixin/Badge.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return _lib_Core_widget_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_75__["default"]; });

/* harmony import */ var _lib_Core_widget_BooleanCombo_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ./lib/Core/widget/BooleanCombo.js */ "./lib/Core/widget/BooleanCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanCombo", function() { return _lib_Core_widget_BooleanCombo_js__WEBPACK_IMPORTED_MODULE_76__["default"]; });

/* harmony import */ var _lib_Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ./lib/Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _lib_Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_77__["default"]; });

/* harmony import */ var _lib_Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ./lib/Core/widget/ButtonGroup.js */ "./lib/Core/widget/ButtonGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _lib_Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_78__["default"]; });

/* harmony import */ var _lib_Core_widget_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ./lib/Core/widget/CalendarPanel.js */ "./lib/Core/widget/CalendarPanel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarPanel", function() { return _lib_Core_widget_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_79__["default"]; });

/* harmony import */ var _lib_Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ./lib/Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _lib_Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_80__["default"]; });

/* harmony import */ var _lib_Core_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ./lib/Core/widget/ChipView.js */ "./lib/Core/widget/ChipView.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipView", function() { return _lib_Core_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_81__["default"]; });

/* harmony import */ var _lib_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ./lib/Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Combo", function() { return _lib_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_82__["default"]; });

/* harmony import */ var _lib_Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ./lib/Core/widget/Container.js */ "./lib/Core/widget/Container.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return _lib_Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_83__["default"]; });

/* harmony import */ var _lib_Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ./lib/Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateField", function() { return _lib_Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_84__["default"]; });

/* harmony import */ var _lib_Core_widget_DatePicker_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ./lib/Core/widget/DatePicker.js */ "./lib/Core/widget/DatePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return _lib_Core_widget_DatePicker_js__WEBPACK_IMPORTED_MODULE_85__["default"]; });

/* harmony import */ var _lib_Core_widget_DateTimeField_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ./lib/Core/widget/DateTimeField.js */ "./lib/Core/widget/DateTimeField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateTimeField", function() { return _lib_Core_widget_DateTimeField_js__WEBPACK_IMPORTED_MODULE_86__["default"]; });

/* harmony import */ var _lib_Core_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ./lib/Core/widget/DisplayField.js */ "./lib/Core/widget/DisplayField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DisplayField", function() { return _lib_Core_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_87__["default"]; });

/* harmony import */ var _lib_Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ./lib/Core/widget/DurationField.js */ "./lib/Core/widget/DurationField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationField", function() { return _lib_Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_88__["default"]; });

/* harmony import */ var _lib_Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ./lib/Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Editor", function() { return _lib_Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_89__["default"]; });

/* harmony import */ var _lib_Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ./lib/Core/widget/Field.js */ "./lib/Core/widget/Field.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return _lib_Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_90__["default"]; });

/* harmony import */ var _lib_Core_widget_FileField_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ./lib/Core/widget/FileField.js */ "./lib/Core/widget/FileField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileField", function() { return _lib_Core_widget_FileField_js__WEBPACK_IMPORTED_MODULE_91__["default"]; });

/* harmony import */ var _lib_Core_widget_FilePicker_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ./lib/Core/widget/FilePicker.js */ "./lib/Core/widget/FilePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return _lib_Core_widget_FilePicker_js__WEBPACK_IMPORTED_MODULE_92__["default"]; });

/* harmony import */ var _lib_Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ./lib/Core/widget/FilterField.js */ "./lib/Core/widget/FilterField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterField", function() { return _lib_Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_93__["default"]; });

/* harmony import */ var _lib_Core_widget_List_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ./lib/Core/widget/List.js */ "./lib/Core/widget/List.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() { return _lib_Core_widget_List_js__WEBPACK_IMPORTED_MODULE_94__["default"]; });

/* harmony import */ var _lib_Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ./lib/Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return _lib_Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_95__["default"]; });

/* harmony import */ var _lib_Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(/*! ./lib/Core/widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return _lib_Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_96__["default"]; });

/* harmony import */ var _lib_Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(/*! ./lib/Core/widget/MenuItem.js */ "./lib/Core/widget/MenuItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _lib_Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_97__["default"]; });

/* harmony import */ var _lib_Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(/*! ./lib/Core/widget/MessageDialog.js */ "./lib/Core/widget/MessageDialog.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MessageDialog", function() { return _lib_Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_98__["default"]; });

/* harmony import */ var _lib_Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(/*! ./lib/Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberField", function() { return _lib_Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_99__["default"]; });

/* harmony import */ var _lib_Core_widget_PagingToolbar_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(/*! ./lib/Core/widget/PagingToolbar.js */ "./lib/Core/widget/PagingToolbar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PagingToolbar", function() { return _lib_Core_widget_PagingToolbar_js__WEBPACK_IMPORTED_MODULE_100__["default"]; });

/* harmony import */ var _lib_Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(/*! ./lib/Core/widget/Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _lib_Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_101__["default"]; });

/* harmony import */ var _lib_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(/*! ./lib/Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return _lib_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_102__["default"]; });

/* harmony import */ var _lib_Core_widget_Renderable_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(/*! ./lib/Core/widget/Renderable.js */ "./lib/Core/widget/Renderable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Renderable", function() { return _lib_Core_widget_Renderable_js__WEBPACK_IMPORTED_MODULE_103__["default"]; });

/* harmony import */ var _lib_Core_widget_Ripple_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(/*! ./lib/Core/widget/Ripple.js */ "./lib/Core/widget/Ripple.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return _lib_Core_widget_Ripple_js__WEBPACK_IMPORTED_MODULE_104__["default"]; });

/* harmony import */ var _lib_Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(/*! ./lib/Core/widget/Slider.js */ "./lib/Core/widget/Slider.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return _lib_Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_105__["default"]; });

/* harmony import */ var _lib_Core_widget_Splitter_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(/*! ./lib/Core/widget/Splitter.js */ "./lib/Core/widget/Splitter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Splitter", function() { return _lib_Core_widget_Splitter_js__WEBPACK_IMPORTED_MODULE_106__["default"]; });

/* harmony import */ var _lib_Core_widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(/*! ./lib/Core/widget/TabPanel.js */ "./lib/Core/widget/TabPanel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return _lib_Core_widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_107__["default"]; });

/* harmony import */ var _lib_Core_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(/*! ./lib/Core/widget/TextAreaField.js */ "./lib/Core/widget/TextAreaField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextAreaField", function() { return _lib_Core_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_108__["default"]; });

/* harmony import */ var _lib_Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(/*! ./lib/Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return _lib_Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_109__["default"]; });

/* harmony import */ var _lib_Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(/*! ./lib/Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeField", function() { return _lib_Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_110__["default"]; });

/* harmony import */ var _lib_Core_widget_TimePicker_js__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(/*! ./lib/Core/widget/TimePicker.js */ "./lib/Core/widget/TimePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimePicker", function() { return _lib_Core_widget_TimePicker_js__WEBPACK_IMPORTED_MODULE_111__["default"]; });

/* harmony import */ var _lib_Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(/*! ./lib/Core/widget/Toast.js */ "./lib/Core/widget/Toast.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return _lib_Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_112__["default"]; });

/* harmony import */ var _lib_Core_widget_Tool_js__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(/*! ./lib/Core/widget/Tool.js */ "./lib/Core/widget/Tool.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tool", function() { return _lib_Core_widget_Tool_js__WEBPACK_IMPORTED_MODULE_113__["default"]; });

/* harmony import */ var _lib_Core_widget_Toolbar_js__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(/*! ./lib/Core/widget/Toolbar.js */ "./lib/Core/widget/Toolbar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return _lib_Core_widget_Toolbar_js__WEBPACK_IMPORTED_MODULE_114__["default"]; });

/* harmony import */ var _lib_Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(/*! ./lib/Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _lib_Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_115__["default"]; });

/* harmony import */ var _lib_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(/*! ./lib/Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Widget", function() { return _lib_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_116__["default"]; });

/* harmony import */ var _lib_Grid_column_ActionColumn_js__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(/*! ./lib/Grid/column/ActionColumn.js */ "./lib/Grid/column/ActionColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionColumn", function() { return _lib_Grid_column_ActionColumn_js__WEBPACK_IMPORTED_MODULE_117__["default"]; });

/* harmony import */ var _lib_Grid_column_AggregateColumn_js__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(/*! ./lib/Grid/column/AggregateColumn.js */ "./lib/Grid/column/AggregateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AggregateColumn", function() { return _lib_Grid_column_AggregateColumn_js__WEBPACK_IMPORTED_MODULE_118__["default"]; });

/* harmony import */ var _lib_Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(/*! ./lib/Grid/column/CheckColumn.js */ "./lib/Grid/column/CheckColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckColumn", function() { return _lib_Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_119__["default"]; });

/* harmony import */ var _lib_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(/*! ./lib/Grid/column/Column.js */ "./lib/Grid/column/Column.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return _lib_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_120__["default"]; });

/* harmony import */ var _lib_Grid_column_DateColumn_js__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(/*! ./lib/Grid/column/DateColumn.js */ "./lib/Grid/column/DateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateColumn", function() { return _lib_Grid_column_DateColumn_js__WEBPACK_IMPORTED_MODULE_121__["default"]; });

/* harmony import */ var _lib_Grid_column_PercentColumn_js__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(/*! ./lib/Grid/column/PercentColumn.js */ "./lib/Grid/column/PercentColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PercentColumn", function() { return _lib_Grid_column_PercentColumn_js__WEBPACK_IMPORTED_MODULE_122__["default"]; });

/* harmony import */ var _lib_Grid_column_RatingColumn_js__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(/*! ./lib/Grid/column/RatingColumn.js */ "./lib/Grid/column/RatingColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingColumn", function() { return _lib_Grid_column_RatingColumn_js__WEBPACK_IMPORTED_MODULE_123__["default"]; });

/* harmony import */ var _lib_Grid_column_RowNumberColumn_js__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(/*! ./lib/Grid/column/RowNumberColumn.js */ "./lib/Grid/column/RowNumberColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowNumberColumn", function() { return _lib_Grid_column_RowNumberColumn_js__WEBPACK_IMPORTED_MODULE_124__["default"]; });

/* harmony import */ var _lib_Grid_column_TemplateColumn_js__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(/*! ./lib/Grid/column/TemplateColumn.js */ "./lib/Grid/column/TemplateColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateColumn", function() { return _lib_Grid_column_TemplateColumn_js__WEBPACK_IMPORTED_MODULE_125__["default"]; });

/* harmony import */ var _lib_Grid_column_TimeColumn_js__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(/*! ./lib/Grid/column/TimeColumn.js */ "./lib/Grid/column/TimeColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeColumn", function() { return _lib_Grid_column_TimeColumn_js__WEBPACK_IMPORTED_MODULE_126__["default"]; });

/* harmony import */ var _lib_Grid_column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(/*! ./lib/Grid/column/TreeColumn.js */ "./lib/Grid/column/TreeColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeColumn", function() { return _lib_Grid_column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_127__["default"]; });

/* harmony import */ var _lib_Grid_column_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(/*! ./lib/Grid/column/WidgetColumn.js */ "./lib/Grid/column/WidgetColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetColumn", function() { return _lib_Grid_column_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_128__["default"]; });

/* harmony import */ var _lib_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(/*! ./lib/Grid/data/ColumnStore.js */ "./lib/Grid/data/ColumnStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnStore", function() { return _lib_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_129__["default"]; });

/* harmony import */ var _lib_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(/*! ./lib/Grid/data/GridRowModel.js */ "./lib/Grid/data/GridRowModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridRowModel", function() { return _lib_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_130__["default"]; });

/* harmony import */ var _lib_Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(/*! ./lib/Grid/feature/CellEdit.js */ "./lib/Grid/feature/CellEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CellEdit", function() { return _lib_Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_131__["default"]; });

/* harmony import */ var _lib_Grid_feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(/*! ./lib/Grid/feature/CellMenu.js */ "./lib/Grid/feature/CellMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CellMenu", function() { return _lib_Grid_feature_CellMenu_js__WEBPACK_IMPORTED_MODULE_132__["default"]; });

/* harmony import */ var _lib_Grid_feature_CellTooltip_js__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(/*! ./lib/Grid/feature/CellTooltip.js */ "./lib/Grid/feature/CellTooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CellTooltip", function() { return _lib_Grid_feature_CellTooltip_js__WEBPACK_IMPORTED_MODULE_133__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnAutoWidth_js__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(/*! ./lib/Grid/feature/ColumnAutoWidth.js */ "./lib/Grid/feature/ColumnAutoWidth.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnAutoWidth", function() { return _lib_Grid_feature_ColumnAutoWidth_js__WEBPACK_IMPORTED_MODULE_134__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(/*! ./lib/Grid/feature/ColumnDragToolbar.js */ "./lib/Grid/feature/ColumnDragToolbar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnDragToolbar", function() { return _lib_Grid_feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_135__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(/*! ./lib/Grid/feature/ColumnPicker.js */ "./lib/Grid/feature/ColumnPicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnPicker", function() { return _lib_Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_136__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(/*! ./lib/Grid/feature/ColumnReorder.js */ "./lib/Grid/feature/ColumnReorder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnReorder", function() { return _lib_Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_137__["default"]; });

/* harmony import */ var _lib_Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(/*! ./lib/Grid/feature/ColumnResize.js */ "./lib/Grid/feature/ColumnResize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnResize", function() { return _lib_Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_138__["default"]; });

/* harmony import */ var _lib_Grid_feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(/*! ./lib/Grid/feature/ContextMenu.js */ "./lib/Grid/feature/ContextMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenu", function() { return _lib_Grid_feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_139__["default"]; });

/* harmony import */ var _lib_Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(/*! ./lib/Grid/feature/Filter.js */ "./lib/Grid/feature/Filter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Filter", function() { return _lib_Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_140__["default"]; });

/* harmony import */ var _lib_Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(/*! ./lib/Grid/feature/FilterBar.js */ "./lib/Grid/feature/FilterBar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterBar", function() { return _lib_Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_141__["default"]; });

/* harmony import */ var _lib_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(/*! ./lib/Grid/feature/GridFeatureManager.js */ "./lib/Grid/feature/GridFeatureManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridFeatureManager", function() { return _lib_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_142__["default"]; });

/* harmony import */ var _lib_Grid_feature_Group_js__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(/*! ./lib/Grid/feature/Group.js */ "./lib/Grid/feature/Group.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Group", function() { return _lib_Grid_feature_Group_js__WEBPACK_IMPORTED_MODULE_143__["default"]; });

/* harmony import */ var _lib_Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(/*! ./lib/Grid/feature/HeaderMenu.js */ "./lib/Grid/feature/HeaderMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderMenu", function() { return _lib_Grid_feature_HeaderMenu_js__WEBPACK_IMPORTED_MODULE_144__["default"]; });

/* harmony import */ var _lib_Grid_feature_QuickFind_js__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(/*! ./lib/Grid/feature/QuickFind.js */ "./lib/Grid/feature/QuickFind.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuickFind", function() { return _lib_Grid_feature_QuickFind_js__WEBPACK_IMPORTED_MODULE_145__["default"]; });

/* harmony import */ var _lib_Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(/*! ./lib/Grid/feature/RegionResize.js */ "./lib/Grid/feature/RegionResize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RegionResize", function() { return _lib_Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_146__["default"]; });

/* harmony import */ var _lib_Grid_feature_RowReorder_js__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(/*! ./lib/Grid/feature/RowReorder.js */ "./lib/Grid/feature/RowReorder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowReorder", function() { return _lib_Grid_feature_RowReorder_js__WEBPACK_IMPORTED_MODULE_147__["default"]; });

/* harmony import */ var _lib_Grid_feature_Search_js__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(/*! ./lib/Grid/feature/Search.js */ "./lib/Grid/feature/Search.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Search", function() { return _lib_Grid_feature_Search_js__WEBPACK_IMPORTED_MODULE_148__["default"]; });

/* harmony import */ var _lib_Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(/*! ./lib/Grid/feature/Sort.js */ "./lib/Grid/feature/Sort.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Sort", function() { return _lib_Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_149__["default"]; });

/* harmony import */ var _lib_Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(/*! ./lib/Grid/feature/Stripe.js */ "./lib/Grid/feature/Stripe.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Stripe", function() { return _lib_Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_150__["default"]; });

/* harmony import */ var _lib_Grid_feature_Tree_js__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(/*! ./lib/Grid/feature/Tree.js */ "./lib/Grid/feature/Tree.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tree", function() { return _lib_Grid_feature_Tree_js__WEBPACK_IMPORTED_MODULE_151__["default"]; });

/* harmony import */ var _lib_Grid_view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(/*! ./lib/Grid/view/export/ExportDialog.js */ "./lib/Grid/view/export/ExportDialog.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridExportDialog", function() { return _lib_Grid_view_export_ExportDialog_js__WEBPACK_IMPORTED_MODULE_152__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(/*! ./lib/Grid/feature/export/exporter/MultiPageExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridMultiPageExporter", function() { return _lib_Grid_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_153__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(/*! ./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js */ "./lib/Grid/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridMultiPageVerticalExporter", function() { return _lib_Grid_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_154__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(/*! ./lib/Grid/feature/export/PdfExport.js */ "./lib/Grid/feature/export/PdfExport.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridPdfExport", function() { return _lib_Grid_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_155__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(/*! ./lib/Grid/feature/export/exporter/SinglePageExporter.js */ "./lib/Grid/feature/export/exporter/SinglePageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridSinglePageExporter", function() { return _lib_Grid_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_156__["default"]; });

/* harmony import */ var _lib_Grid_view_export_field_ExportOrientationCombo_js__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(/*! ./lib/Grid/view/export/field/ExportOrientationCombo.js */ "./lib/Grid/view/export/field/ExportOrientationCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExportOrientationCombo", function() { return _lib_Grid_view_export_field_ExportOrientationCombo_js__WEBPACK_IMPORTED_MODULE_157__["default"]; });

/* harmony import */ var _lib_Grid_view_export_field_ExportRowsCombo_js__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(/*! ./lib/Grid/view/export/field/ExportRowsCombo.js */ "./lib/Grid/view/export/field/ExportRowsCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExportRowsCombo", function() { return _lib_Grid_view_export_field_ExportRowsCombo_js__WEBPACK_IMPORTED_MODULE_158__["default"]; });

/* harmony import */ var _lib_Grid_view_export_field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(/*! ./lib/Grid/view/export/field/LocalizableCombo.js */ "./lib/Grid/view/export/field/LocalizableCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalizableCombo", function() { return _lib_Grid_view_export_field_LocalizableCombo_js__WEBPACK_IMPORTED_MODULE_159__["default"]; });

/* harmony import */ var _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(/*! ./lib/Grid/feature/export/Utils.js */ "./lib/Grid/feature/export/Utils.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileFormat", function() { return _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_160__["FileFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Orientation", function() { return _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_160__["Orientation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PaperFormat", function() { return _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_160__["PaperFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowsRange", function() { return _lib_Grid_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_160__["RowsRange"]; });

/* harmony import */ var _lib_Grid_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(/*! ./lib/Grid/feature/experimental/ExcelExporter.js */ "./lib/Grid/feature/experimental/ExcelExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridExcelExporter", function() { return _lib_Grid_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_161__["default"]; });

/* harmony import */ var _lib_Grid_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_162__ = __webpack_require__(/*! ./lib/Grid/util/ScrollManager.js */ "./lib/Grid/util/ScrollManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScrollManager", function() { return _lib_Grid_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_162__["default"]; });

/* harmony import */ var _lib_Grid_util_TableExporter_js__WEBPACK_IMPORTED_MODULE_163__ = __webpack_require__(/*! ./lib/Grid/util/TableExporter.js */ "./lib/Grid/util/TableExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableExporter", function() { return _lib_Grid_util_TableExporter_js__WEBPACK_IMPORTED_MODULE_163__["default"]; });

/* harmony import */ var _lib_Grid_view_Footer_js__WEBPACK_IMPORTED_MODULE_164__ = __webpack_require__(/*! ./lib/Grid/view/Footer.js */ "./lib/Grid/view/Footer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Footer", function() { return _lib_Grid_view_Footer_js__WEBPACK_IMPORTED_MODULE_164__["default"]; });

/* harmony import */ var _lib_Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_165__ = __webpack_require__(/*! ./lib/Grid/view/Grid.js */ "./lib/Grid/view/Grid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return _lib_Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_165__["default"]; });

/* harmony import */ var _lib_Grid_view_GridBase_js__WEBPACK_IMPORTED_MODULE_166__ = __webpack_require__(/*! ./lib/Grid/view/GridBase.js */ "./lib/Grid/view/GridBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridBase", function() { return _lib_Grid_view_GridBase_js__WEBPACK_IMPORTED_MODULE_166__["default"]; });

/* harmony import */ var _lib_Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_167__ = __webpack_require__(/*! ./lib/Grid/view/Header.js */ "./lib/Grid/view/Header.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return _lib_Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_167__["default"]; });

/* harmony import */ var _lib_Grid_row_RowManager_js__WEBPACK_IMPORTED_MODULE_168__ = __webpack_require__(/*! ./lib/Grid/row/RowManager.js */ "./lib/Grid/row/RowManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowManager", function() { return _lib_Grid_row_RowManager_js__WEBPACK_IMPORTED_MODULE_168__["default"]; });

/* harmony import */ var _lib_Grid_view_TreeGrid_js__WEBPACK_IMPORTED_MODULE_169__ = __webpack_require__(/*! ./lib/Grid/view/TreeGrid.js */ "./lib/Grid/view/TreeGrid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeGrid", function() { return _lib_Grid_view_TreeGrid_js__WEBPACK_IMPORTED_MODULE_169__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_170__ = __webpack_require__(/*! ./lib/Scheduler/crud/AbstractCrudManager.js */ "./lib/Scheduler/crud/AbstractCrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManager", function() { return _lib_Scheduler_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_170__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_171__ = __webpack_require__(/*! ./lib/Scheduler/crud/transport/AjaxTransport.js */ "./lib/Scheduler/crud/transport/AjaxTransport.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxTransport", function() { return _lib_Scheduler_crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_171__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_172__ = __webpack_require__(/*! ./lib/Scheduler/crud/mixin/CrudManagerView.js */ "./lib/Scheduler/crud/mixin/CrudManagerView.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManagerView", function() { return _lib_Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_172__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_173__ = __webpack_require__(/*! ./lib/Scheduler/crud/encoder/JsonEncoder.js */ "./lib/Scheduler/crud/encoder/JsonEncoder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonEncoder", function() { return _lib_Scheduler_crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_173__["default"]; });

/* harmony import */ var _lib_Scheduler_data_util_recurrence_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_174__ = __webpack_require__(/*! ./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractRecurrenceIterator", function() { return _lib_Scheduler_data_util_recurrence_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_174__["default"]; });

/* harmony import */ var _lib_Scheduler_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_175__ = __webpack_require__(/*! ./lib/Scheduler/data/AssignmentStore.js */ "./lib/Scheduler/data/AssignmentStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentStore", function() { return _lib_Scheduler_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_175__["default"]; });

/* harmony import */ var _lib_Scheduler_data_CrudManager_js__WEBPACK_IMPORTED_MODULE_176__ = __webpack_require__(/*! ./lib/Scheduler/data/CrudManager.js */ "./lib/Scheduler/data/CrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManager", function() { return _lib_Scheduler_data_CrudManager_js__WEBPACK_IMPORTED_MODULE_176__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_177__ = __webpack_require__(/*! ./lib/Scheduler/data/mixin/ProjectCrudManager.js */ "./lib/Scheduler/data/mixin/ProjectCrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectCrudManager", function() { return _lib_Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_177__["default"]; });

/* harmony import */ var _lib_Scheduler_data_util_recurrence_DailyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_178__ = __webpack_require__(/*! ./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DailyRecurrenceIterator", function() { return _lib_Scheduler_data_util_recurrence_DailyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_178__["default"]; });

/* harmony import */ var _lib_Scheduler_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_179__ = __webpack_require__(/*! ./lib/Scheduler/data/DependencyStore.js */ "./lib/Scheduler/data/DependencyStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyStore", function() { return _lib_Scheduler_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_179__["default"]; });

/* harmony import */ var _lib_Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_180__ = __webpack_require__(/*! ./lib/Scheduler/data/EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventStore", function() { return _lib_Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_180__["default"]; });

/* harmony import */ var _lib_Scheduler_data_util_recurrence_MonthlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_181__ = __webpack_require__(/*! ./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MonthlyRecurrenceIterator", function() { return _lib_Scheduler_data_util_recurrence_MonthlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_181__["default"]; });

/* harmony import */ var _lib_Scheduler_data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_182__ = __webpack_require__(/*! ./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceDayRuleEncoder", function() { return _lib_Scheduler_data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_182__["default"]; });

/* harmony import */ var _lib_Scheduler_data_util_recurrence_RecurrenceLegend_js__WEBPACK_IMPORTED_MODULE_183__ = __webpack_require__(/*! ./lib/Scheduler/data/util/recurrence/RecurrenceLegend.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceLegend.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceLegend", function() { return _lib_Scheduler_data_util_recurrence_RecurrenceLegend_js__WEBPACK_IMPORTED_MODULE_183__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_184__ = __webpack_require__(/*! ./lib/Scheduler/data/mixin/ProjectConsumer.js */ "./lib/Scheduler/data/mixin/ProjectConsumer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectConsumer", function() { return _lib_Scheduler_data_mixin_ProjectConsumer_js__WEBPACK_IMPORTED_MODULE_184__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_185__ = __webpack_require__(/*! ./lib/Scheduler/data/mixin/RecurringEventsMixin.js */ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringEventsMixin", function() { return _lib_Scheduler_data_mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_185__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_186__ = __webpack_require__(/*! ./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js */ "./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpansMixin", function() { return _lib_Scheduler_data_mixin_RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_186__["default"]; });

/* harmony import */ var _lib_Scheduler_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_187__ = __webpack_require__(/*! ./lib/Scheduler/data/ResourceStore.js */ "./lib/Scheduler/data/ResourceStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceStore", function() { return _lib_Scheduler_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_187__["default"]; });

/* harmony import */ var _lib_Scheduler_data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_188__ = __webpack_require__(/*! ./lib/Scheduler/data/ResourceTimeRangeStore.js */ "./lib/Scheduler/data/ResourceTimeRangeStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeStore", function() { return _lib_Scheduler_data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_188__["default"]; });

/* harmony import */ var _lib_Scheduler_data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_189__ = __webpack_require__(/*! ./lib/Scheduler/data/TimeAxis.js */ "./lib/Scheduler/data/TimeAxis.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxis", function() { return _lib_Scheduler_data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_189__["default"]; });

/* harmony import */ var _lib_Scheduler_data_util_recurrence_WeeklyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_190__ = __webpack_require__(/*! ./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WeeklyRecurrenceIterator", function() { return _lib_Scheduler_data_util_recurrence_WeeklyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_190__["default"]; });

/* harmony import */ var _lib_Scheduler_data_util_recurrence_YearlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_191__ = __webpack_require__(/*! ./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "YearlyRecurrenceIterator", function() { return _lib_Scheduler_data_util_recurrence_YearlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_191__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_192__ = __webpack_require__(/*! ./lib/Scheduler/feature/ColumnLines.js */ "./lib/Scheduler/feature/ColumnLines.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnLines", function() { return _lib_Scheduler_feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_192__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_193__ = __webpack_require__(/*! ./lib/Scheduler/feature/Dependencies.js */ "./lib/Scheduler/feature/Dependencies.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Dependencies", function() { return _lib_Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_193__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_194__ = __webpack_require__(/*! ./lib/Scheduler/feature/mixin/DependencyCreation.js */ "./lib/Scheduler/feature/mixin/DependencyCreation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyCreation", function() { return _lib_Scheduler_feature_mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_194__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_195__ = __webpack_require__(/*! ./lib/Scheduler/feature/DependencyEdit.js */ "./lib/Scheduler/feature/DependencyEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyEdit", function() { return _lib_Scheduler_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_195__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_DragBase_js__WEBPACK_IMPORTED_MODULE_196__ = __webpack_require__(/*! ./lib/Scheduler/feature/base/DragBase.js */ "./lib/Scheduler/feature/base/DragBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragBase", function() { return _lib_Scheduler_feature_base_DragBase_js__WEBPACK_IMPORTED_MODULE_196__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventContextMenu_js__WEBPACK_IMPORTED_MODULE_197__ = __webpack_require__(/*! ./lib/Scheduler/feature/EventContextMenu.js */ "./lib/Scheduler/feature/EventContextMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventContextMenu", function() { return _lib_Scheduler_feature_EventContextMenu_js__WEBPACK_IMPORTED_MODULE_197__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_198__ = __webpack_require__(/*! ./lib/Scheduler/feature/EventDrag.js */ "./lib/Scheduler/feature/EventDrag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventDrag", function() { return _lib_Scheduler_feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_198__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_199__ = __webpack_require__(/*! ./lib/Scheduler/feature/EventDragCreate.js */ "./lib/Scheduler/feature/EventDragCreate.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventDragCreate", function() { return _lib_Scheduler_feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_199__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventDragSelect_js__WEBPACK_IMPORTED_MODULE_200__ = __webpack_require__(/*! ./lib/Scheduler/feature/EventDragSelect.js */ "./lib/Scheduler/feature/EventDragSelect.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventDragSelect", function() { return _lib_Scheduler_feature_EventDragSelect_js__WEBPACK_IMPORTED_MODULE_200__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventEdit_js__WEBPACK_IMPORTED_MODULE_201__ = __webpack_require__(/*! ./lib/Scheduler/feature/EventEdit.js */ "./lib/Scheduler/feature/EventEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventEdit", function() { return _lib_Scheduler_feature_EventEdit_js__WEBPACK_IMPORTED_MODULE_201__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_202__ = __webpack_require__(/*! ./lib/Scheduler/feature/EventFilter.js */ "./lib/Scheduler/feature/EventFilter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventFilter", function() { return _lib_Scheduler_feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_202__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_203__ = __webpack_require__(/*! ./lib/Scheduler/feature/EventMenu.js */ "./lib/Scheduler/feature/EventMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventMenu", function() { return _lib_Scheduler_feature_EventMenu_js__WEBPACK_IMPORTED_MODULE_203__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_204__ = __webpack_require__(/*! ./lib/Scheduler/feature/EventResize.js */ "./lib/Scheduler/feature/EventResize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventResize", function() { return _lib_Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_204__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_205__ = __webpack_require__(/*! ./lib/Scheduler/feature/EventTooltip.js */ "./lib/Scheduler/feature/EventTooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventTooltip", function() { return _lib_Scheduler_feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_205__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_206__ = __webpack_require__(/*! ./lib/Scheduler/feature/GroupSummary.js */ "./lib/Scheduler/feature/GroupSummary.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GroupSummary", function() { return _lib_Scheduler_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_206__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_HeaderContextMenu_js__WEBPACK_IMPORTED_MODULE_207__ = __webpack_require__(/*! ./lib/Scheduler/feature/HeaderContextMenu.js */ "./lib/Scheduler/feature/HeaderContextMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderContextMenu", function() { return _lib_Scheduler_feature_HeaderContextMenu_js__WEBPACK_IMPORTED_MODULE_207__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_HeaderZoom_js__WEBPACK_IMPORTED_MODULE_208__ = __webpack_require__(/*! ./lib/Scheduler/feature/HeaderZoom.js */ "./lib/Scheduler/feature/HeaderZoom.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderZoom", function() { return _lib_Scheduler_feature_HeaderZoom_js__WEBPACK_IMPORTED_MODULE_208__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_Labels_js__WEBPACK_IMPORTED_MODULE_209__ = __webpack_require__(/*! ./lib/Scheduler/feature/Labels.js */ "./lib/Scheduler/feature/Labels.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Labels", function() { return _lib_Scheduler_feature_Labels_js__WEBPACK_IMPORTED_MODULE_209__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_NonWorkingTime_js__WEBPACK_IMPORTED_MODULE_210__ = __webpack_require__(/*! ./lib/Scheduler/feature/NonWorkingTime.js */ "./lib/Scheduler/feature/NonWorkingTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NonWorkingTime", function() { return _lib_Scheduler_feature_NonWorkingTime_js__WEBPACK_IMPORTED_MODULE_210__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_Pan_js__WEBPACK_IMPORTED_MODULE_211__ = __webpack_require__(/*! ./lib/Scheduler/feature/Pan.js */ "./lib/Scheduler/feature/Pan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pan", function() { return _lib_Scheduler_feature_Pan_js__WEBPACK_IMPORTED_MODULE_211__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_mixin_RecurringEventEdit_js__WEBPACK_IMPORTED_MODULE_212__ = __webpack_require__(/*! ./lib/Scheduler/feature/mixin/RecurringEventEdit.js */ "./lib/Scheduler/feature/mixin/RecurringEventEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringEventEdit", function() { return _lib_Scheduler_feature_mixin_RecurringEventEdit_js__WEBPACK_IMPORTED_MODULE_212__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ResourceTimeRanges_js__WEBPACK_IMPORTED_MODULE_213__ = __webpack_require__(/*! ./lib/Scheduler/feature/ResourceTimeRanges.js */ "./lib/Scheduler/feature/ResourceTimeRanges.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRanges", function() { return _lib_Scheduler_feature_ResourceTimeRanges_js__WEBPACK_IMPORTED_MODULE_213__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ScheduleContextMenu_js__WEBPACK_IMPORTED_MODULE_214__ = __webpack_require__(/*! ./lib/Scheduler/feature/ScheduleContextMenu.js */ "./lib/Scheduler/feature/ScheduleContextMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleContextMenu", function() { return _lib_Scheduler_feature_ScheduleContextMenu_js__WEBPACK_IMPORTED_MODULE_214__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_215__ = __webpack_require__(/*! ./lib/Scheduler/feature/ScheduleMenu.js */ "./lib/Scheduler/feature/ScheduleMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleMenu", function() { return _lib_Scheduler_feature_ScheduleMenu_js__WEBPACK_IMPORTED_MODULE_215__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_216__ = __webpack_require__(/*! ./lib/Scheduler/feature/ScheduleTooltip.js */ "./lib/Scheduler/feature/ScheduleTooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleTooltip", function() { return _lib_Scheduler_feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_216__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_SimpleEventEdit_js__WEBPACK_IMPORTED_MODULE_217__ = __webpack_require__(/*! ./lib/Scheduler/feature/SimpleEventEdit.js */ "./lib/Scheduler/feature/SimpleEventEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SimpleEventEdit", function() { return _lib_Scheduler_feature_SimpleEventEdit_js__WEBPACK_IMPORTED_MODULE_217__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_Summary_js__WEBPACK_IMPORTED_MODULE_218__ = __webpack_require__(/*! ./lib/Scheduler/feature/Summary.js */ "./lib/Scheduler/feature/Summary.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Summary", function() { return _lib_Scheduler_feature_Summary_js__WEBPACK_IMPORTED_MODULE_218__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_TimeAxisHeaderMenu_js__WEBPACK_IMPORTED_MODULE_219__ = __webpack_require__(/*! ./lib/Scheduler/feature/TimeAxisHeaderMenu.js */ "./lib/Scheduler/feature/TimeAxisHeaderMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisHeaderMenu", function() { return _lib_Scheduler_feature_TimeAxisHeaderMenu_js__WEBPACK_IMPORTED_MODULE_219__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_TimeRanges_js__WEBPACK_IMPORTED_MODULE_220__ = __webpack_require__(/*! ./lib/Scheduler/feature/TimeRanges.js */ "./lib/Scheduler/feature/TimeRanges.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeRanges", function() { return _lib_Scheduler_feature_TimeRanges_js__WEBPACK_IMPORTED_MODULE_220__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_221__ = __webpack_require__(/*! ./lib/Scheduler/feature/base/TimeSpanMenuBase.js */ "./lib/Scheduler/feature/base/TimeSpanMenuBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpanMenuBase", function() { return _lib_Scheduler_feature_base_TimeSpanMenuBase_js__WEBPACK_IMPORTED_MODULE_221__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_base_TimeSpanRecordContextMenuBase_js__WEBPACK_IMPORTED_MODULE_222__ = __webpack_require__(/*! ./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js */ "./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpanRecordContextMenuBase", function() { return _lib_Scheduler_feature_base_TimeSpanRecordContextMenuBase_js__WEBPACK_IMPORTED_MODULE_222__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_223__ = __webpack_require__(/*! ./lib/Scheduler/feature/export/exporter/MultiPageExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiPageExporter", function() { return _lib_Scheduler_feature_export_exporter_MultiPageExporter_js__WEBPACK_IMPORTED_MODULE_223__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_224__ = __webpack_require__(/*! ./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js */ "./lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiPageVerticalExporter", function() { return _lib_Scheduler_feature_export_exporter_MultiPageVerticalExporter_js__WEBPACK_IMPORTED_MODULE_224__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_225__ = __webpack_require__(/*! ./lib/Scheduler/feature/export/PdfExport.js */ "./lib/Scheduler/feature/export/PdfExport.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PdfExport", function() { return _lib_Scheduler_feature_export_PdfExport_js__WEBPACK_IMPORTED_MODULE_225__["default"]; });

/* harmony import */ var _lib_Scheduler_view_export_SchedulerExportDialog_js__WEBPACK_IMPORTED_MODULE_226__ = __webpack_require__(/*! ./lib/Scheduler/view/export/SchedulerExportDialog.js */ "./lib/Scheduler/view/export/SchedulerExportDialog.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerExportDialog", function() { return _lib_Scheduler_view_export_SchedulerExportDialog_js__WEBPACK_IMPORTED_MODULE_226__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_227__ = __webpack_require__(/*! ./lib/Scheduler/feature/export/exporter/SinglePageExporter.js */ "./lib/Scheduler/feature/export/exporter/SinglePageExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SinglePageExporter", function() { return _lib_Scheduler_feature_export_exporter_SinglePageExporter_js__WEBPACK_IMPORTED_MODULE_227__["default"]; });

/* harmony import */ var _lib_Scheduler_view_export_field_ScheduleRangeCombo_js__WEBPACK_IMPORTED_MODULE_228__ = __webpack_require__(/*! ./lib/Scheduler/view/export/field/ScheduleRangeCombo.js */ "./lib/Scheduler/view/export/field/ScheduleRangeCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleRangeCombo", function() { return _lib_Scheduler_view_export_field_ScheduleRangeCombo_js__WEBPACK_IMPORTED_MODULE_228__["default"]; });

/* harmony import */ var _lib_Scheduler_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_229__ = __webpack_require__(/*! ./lib/Scheduler/feature/export/Utils.js */ "./lib/Scheduler/feature/export/Utils.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleRange", function() { return _lib_Scheduler_feature_export_Utils_js__WEBPACK_IMPORTED_MODULE_229__["ScheduleRange"]; });

/* harmony import */ var _lib_Scheduler_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_230__ = __webpack_require__(/*! ./lib/Scheduler/feature/experimental/ExcelExporter.js */ "./lib/Scheduler/feature/experimental/ExcelExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExcelExporter", function() { return _lib_Scheduler_feature_experimental_ExcelExporter_js__WEBPACK_IMPORTED_MODULE_230__["default"]; });

/* harmony import */ var _lib_Scheduler_column_ResourceInfoColumn_js__WEBPACK_IMPORTED_MODULE_231__ = __webpack_require__(/*! ./lib/Scheduler/column/ResourceInfoColumn.js */ "./lib/Scheduler/column/ResourceInfoColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceInfoColumn", function() { return _lib_Scheduler_column_ResourceInfoColumn_js__WEBPACK_IMPORTED_MODULE_231__["default"]; });

/* harmony import */ var _lib_Scheduler_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_232__ = __webpack_require__(/*! ./lib/Scheduler/column/TimeAxisColumn.js */ "./lib/Scheduler/column/TimeAxisColumn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisColumn", function() { return _lib_Scheduler_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_232__["default"]; });

/* harmony import */ var _lib_Scheduler_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_233__ = __webpack_require__(/*! ./lib/Scheduler/model/AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentModel", function() { return _lib_Scheduler_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_233__["default"]; });

/* harmony import */ var _lib_Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_234__ = __webpack_require__(/*! ./lib/Scheduler/model/DependencyBaseModel.js */ "./lib/Scheduler/model/DependencyBaseModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyBaseModel", function() { return _lib_Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_234__["default"]; });

/* harmony import */ var _lib_Scheduler_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_235__ = __webpack_require__(/*! ./lib/Scheduler/model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyModel", function() { return _lib_Scheduler_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_235__["default"]; });

/* harmony import */ var _lib_Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_236__ = __webpack_require__(/*! ./lib/Scheduler/model/EventModel.js */ "./lib/Scheduler/model/EventModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventModel", function() { return _lib_Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_236__["default"]; });

/* harmony import */ var _lib_Scheduler_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_237__ = __webpack_require__(/*! ./lib/Scheduler/model/ProjectModel.js */ "./lib/Scheduler/model/ProjectModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectModel", function() { return _lib_Scheduler_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_237__["default"]; });

/* harmony import */ var _lib_Scheduler_model_RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_238__ = __webpack_require__(/*! ./lib/Scheduler/model/RecurrenceModel.js */ "./lib/Scheduler/model/RecurrenceModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceModel", function() { return _lib_Scheduler_model_RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_238__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_239__ = __webpack_require__(/*! ./lib/Scheduler/model/mixin/RecurringTimeSpan.js */ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpan", function() { return _lib_Scheduler_model_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_239__["default"]; });

/* harmony import */ var _lib_Scheduler_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_240__ = __webpack_require__(/*! ./lib/Scheduler/model/ResourceModel.js */ "./lib/Scheduler/model/ResourceModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceModel", function() { return _lib_Scheduler_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_240__["default"]; });

/* harmony import */ var _lib_Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_241__ = __webpack_require__(/*! ./lib/Scheduler/model/ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeModel", function() { return _lib_Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_241__["default"]; });

/* harmony import */ var _lib_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_242__ = __webpack_require__(/*! ./lib/Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpan", function() { return _lib_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_242__["default"]; });

/* harmony import */ var _lib_Scheduler_preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_243__ = __webpack_require__(/*! ./lib/Scheduler/preset/PresetManager.js */ "./lib/Scheduler/preset/PresetManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PresetManager", function() { return _lib_Scheduler_preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_243__["default"]; });

/* harmony import */ var _lib_Scheduler_preset_PresetStore_js__WEBPACK_IMPORTED_MODULE_244__ = __webpack_require__(/*! ./lib/Scheduler/preset/PresetStore.js */ "./lib/Scheduler/preset/PresetStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PresetStore", function() { return _lib_Scheduler_preset_PresetStore_js__WEBPACK_IMPORTED_MODULE_244__["default"]; });

/* harmony import */ var _lib_Scheduler_preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_245__ = __webpack_require__(/*! ./lib/Scheduler/preset/ViewPreset.js */ "./lib/Scheduler/preset/ViewPreset.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ViewPreset", function() { return _lib_Scheduler_preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_245__["default"]; });

/* harmony import */ var _lib_Scheduler_util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_246__ = __webpack_require__(/*! ./lib/Scheduler/util/RectangularPathFinder.js */ "./lib/Scheduler/util/RectangularPathFinder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RectangularPathFinder", function() { return _lib_Scheduler_util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_246__["default"]; });

/* harmony import */ var _lib_Scheduler_util_ScheduleTableExporter_js__WEBPACK_IMPORTED_MODULE_247__ = __webpack_require__(/*! ./lib/Scheduler/util/ScheduleTableExporter.js */ "./lib/Scheduler/util/ScheduleTableExporter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleTableExporter", function() { return _lib_Scheduler_util_ScheduleTableExporter_js__WEBPACK_IMPORTED_MODULE_247__["default"]; });

/* harmony import */ var _lib_Scheduler_view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_248__ = __webpack_require__(/*! ./lib/Scheduler/view/HorizontalTimeAxis.js */ "./lib/Scheduler/view/HorizontalTimeAxis.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HorizontalTimeAxis", function() { return _lib_Scheduler_view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_248__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceCombo_js__WEBPACK_IMPORTED_MODULE_249__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/field/RecurrenceCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceCombo_js__WEBPACK_IMPORTED_MODULE_249__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_RecurrenceConfirmationPopup_js__WEBPACK_IMPORTED_MODULE_250__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js */ "./lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceConfirmationPopup", function() { return _lib_Scheduler_view_recurrence_RecurrenceConfirmationPopup_js__WEBPACK_IMPORTED_MODULE_250__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_251__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceDaysButtonGroup", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_251__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceDaysCombo_js__WEBPACK_IMPORTED_MODULE_252__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceDaysCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceDaysCombo_js__WEBPACK_IMPORTED_MODULE_252__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_RecurrenceEditor_js__WEBPACK_IMPORTED_MODULE_253__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/RecurrenceEditor.js */ "./lib/Scheduler/view/recurrence/RecurrenceEditor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceEditor", function() { return _lib_Scheduler_view_recurrence_RecurrenceEditor_js__WEBPACK_IMPORTED_MODULE_253__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_254__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceFrequencyCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceFrequencyCombo_js__WEBPACK_IMPORTED_MODULE_254__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_RecurrenceLegendButton_js__WEBPACK_IMPORTED_MODULE_255__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/RecurrenceLegendButton.js */ "./lib/Scheduler/view/recurrence/RecurrenceLegendButton.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceLegendButton", function() { return _lib_Scheduler_view_recurrence_RecurrenceLegendButton_js__WEBPACK_IMPORTED_MODULE_255__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceMonthDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_256__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceMonthDaysButtonGroup", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceMonthDaysButtonGroup_js__WEBPACK_IMPORTED_MODULE_256__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceMonthsButtonGroup_js__WEBPACK_IMPORTED_MODULE_257__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceMonthsButtonGroup", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceMonthsButtonGroup_js__WEBPACK_IMPORTED_MODULE_257__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrencePositionsCombo_js__WEBPACK_IMPORTED_MODULE_258__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrencePositionsCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrencePositionsCombo_js__WEBPACK_IMPORTED_MODULE_258__["default"]; });

/* harmony import */ var _lib_Scheduler_view_recurrence_field_RecurrenceStopConditionCombo_js__WEBPACK_IMPORTED_MODULE_259__ = __webpack_require__(/*! ./lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js */ "./lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceStopConditionCombo", function() { return _lib_Scheduler_view_recurrence_field_RecurrenceStopConditionCombo_js__WEBPACK_IMPORTED_MODULE_259__["default"]; });

/* harmony import */ var _lib_Scheduler_view_Scheduler_js__WEBPACK_IMPORTED_MODULE_260__ = __webpack_require__(/*! ./lib/Scheduler/view/Scheduler.js */ "./lib/Scheduler/view/Scheduler.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function() { return _lib_Scheduler_view_Scheduler_js__WEBPACK_IMPORTED_MODULE_260__["default"]; });

/* harmony import */ var _lib_Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_261__ = __webpack_require__(/*! ./lib/Scheduler/view/SchedulerBase.js */ "./lib/Scheduler/view/SchedulerBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerBase", function() { return _lib_Scheduler_view_SchedulerBase_js__WEBPACK_IMPORTED_MODULE_261__["default"]; });

/* harmony import */ var _lib_Scheduler_view_model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_262__ = __webpack_require__(/*! ./lib/Scheduler/view/model/TimeAxisViewModel.js */ "./lib/Scheduler/view/model/TimeAxisViewModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisViewModel", function() { return _lib_Scheduler_view_model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_262__["default"]; });

/* harmony import */ var _lib_Scheduler_widget_ResourceFilter_js__WEBPACK_IMPORTED_MODULE_263__ = __webpack_require__(/*! ./lib/Scheduler/widget/ResourceFilter.js */ "./lib/Scheduler/widget/ResourceFilter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceFilter", function() { return _lib_Scheduler_widget_ResourceFilter_js__WEBPACK_IMPORTED_MODULE_263__["default"]; });

/* harmony import */ var _lib_Scheduler_widget_ResourceCombo_js__WEBPACK_IMPORTED_MODULE_264__ = __webpack_require__(/*! ./lib/Scheduler/widget/ResourceCombo.js */ "./lib/Scheduler/widget/ResourceCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceCombo", function() { return _lib_Scheduler_widget_ResourceCombo_js__WEBPACK_IMPORTED_MODULE_264__["default"]; });

/* harmony import */ var _lib_Scheduler_widget_UndoRedo_js__WEBPACK_IMPORTED_MODULE_265__ = __webpack_require__(/*! ./lib/Scheduler/widget/UndoRedo.js */ "./lib/Scheduler/widget/UndoRedo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedo", function() { return _lib_Scheduler_widget_UndoRedo_js__WEBPACK_IMPORTED_MODULE_265__["default"]; });

/* harmony import */ var _lib_Scheduler_customElements_SchedulerTag_js__WEBPACK_IMPORTED_MODULE_266__ = __webpack_require__(/*! ./lib/Scheduler/customElements/SchedulerTag.js */ "./lib/Scheduler/customElements/SchedulerTag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerTag", function() { return _lib_Scheduler_customElements_SchedulerTag_js__WEBPACK_IMPORTED_MODULE_266__["default"]; });

var productName = 'scheduler';
/* eslint-disable import/first */

if (!window.bryntum) window.bryntum = {};
/*
 IMPORTANT!
 This entry SHOULD NOT INCLUDE ANY POLYFILLS. It should merely list all our classes that we want to include to the bundle.
 Entry is shared between salesforce bundle which cannot use polyfills, and regular bundles which do require those.
 */
//region Core (import)
// core



 // data















 // helpers





















 // helper util










 // localization



 // mixin












 // util











 // widget










































 //endregion
//region Grid (import)
// columns












 // data


 // features





















 // export









 // feature experimental

 // util


 // view






 //endregion
//region Scheduler (import)
// crud




 // data


















 // features































 // export







 // features experimental

 // columns


 // model










 // preset



 // util


 //view















 // widget



 //endregion
//region Tag (import)
// IMPORTANT NOTE: Tag should be imported last to be last in the rolled up bundle. We rely on its position to embed
// See SchedulerPro/Gruntfile.js for Tag substitute

 //endregion



/***/ }),

/***/ "./webpack.entry.umd.js":
/*!******************************!*\
  !*** ./webpack.entry.umd.js ***!
  \******************************/
/*! exports provided: Base, Config, GlobalEvents, AjaxStore, DomDataStore, Duration, DataField, BooleanDataField, DateDataField, IntegerDataField, ModelDataField, NumberDataField, ObjectDataField, StringDataField, Model, StateTrackingManager, Store, Transaction, AjaxHelper, ArrayHelper, AsyncHelper, BrowserHelper, CSSHelper, DateHelper, DomClassList, DomHelper, DomSync, DragHelper, EventHelper, FunctionHelper, IdHelper, ObjectHelper, RandomGenerator, ResizeHelper, ResizeMonitor, StringHelper, TemplateHelper, VersionHelper, WidgetHelper, DataGenerator, DemoBot, Formatter, Fullscreen, NumberFormat, Objects, Point, Promissory, Rectangle, Scroller, LocaleManager, Localizable, LocaleHelper, Delayable, Draggable, Droppable, Events, Factoryable, Featureable, Finalizable, Hoverable, InstancePlugin, Override, Pluggable, State, Bag, ClickRepeater, Collection, CollectionFilter, CollectionSorter, DragContext, DragProxy, DragTipProxy, DynamicObject, Month, Parser, Badge, BooleanCombo, Button, ButtonGroup, CalendarPanel, Checkbox, ChipView, Combo, Container, DateField, DatePicker, DateTimeField, DisplayField, DurationField, Editor, Field, FileField, FilePicker, FilterField, List, Mask, Menu, MenuItem, MessageDialog, NumberField, PagingToolbar, Panel, Popup, Renderable, Ripple, Slider, Splitter, TabPanel, TextAreaField, TextField, TimeField, TimePicker, Toast, Tool, Toolbar, Tooltip, Widget, ActionColumn, AggregateColumn, CheckColumn, Column, DateColumn, PercentColumn, RatingColumn, RowNumberColumn, TemplateColumn, TimeColumn, TreeColumn, WidgetColumn, ColumnStore, GridRowModel, CellEdit, CellMenu, CellTooltip, ColumnAutoWidth, ColumnDragToolbar, ColumnPicker, ColumnReorder, ColumnResize, ContextMenu, Filter, FilterBar, GridFeatureManager, Group, HeaderMenu, QuickFind, RegionResize, RowReorder, Search, Sort, Stripe, Tree, FileFormat, GridExportDialog, GridMultiPageExporter, GridMultiPageVerticalExporter, GridPdfExport, GridSinglePageExporter, ExportOrientationCombo, ExportRowsCombo, LocalizableCombo, Orientation, PaperFormat, RowsRange, GridExcelExporter, ScrollManager, TableExporter, Footer, Grid, GridBase, Header, RowManager, TreeGrid, AbstractCrudManager, AjaxTransport, CrudManagerView, JsonEncoder, AbstractRecurrenceIterator, AssignmentStore, CrudManager, ProjectCrudManager, DailyRecurrenceIterator, DependencyStore, EventStore, MonthlyRecurrenceIterator, RecurrenceDayRuleEncoder, RecurrenceLegend, ProjectConsumer, RecurringEventsMixin, RecurringTimeSpansMixin, ResourceStore, ResourceTimeRangeStore, TimeAxis, WeeklyRecurrenceIterator, YearlyRecurrenceIterator, ColumnLines, Dependencies, DependencyEdit, DragBase, DependencyCreation, EventContextMenu, EventDrag, EventDragCreate, EventDragSelect, EventEdit, EventFilter, EventMenu, EventResize, EventTooltip, GroupSummary, HeaderContextMenu, HeaderZoom, Labels, NonWorkingTime, Pan, RecurringEventEdit, ResourceTimeRanges, ScheduleContextMenu, ScheduleMenu, ScheduleTooltip, SimpleEventEdit, Summary, TimeAxisHeaderMenu, TimeRanges, TimeSpanMenuBase, TimeSpanRecordContextMenuBase, MultiPageExporter, MultiPageVerticalExporter, PdfExport, SchedulerExportDialog, SinglePageExporter, ScheduleRangeCombo, ScheduleRange, ExcelExporter, ResourceInfoColumn, TimeAxisColumn, AssignmentModel, DependencyBaseModel, DependencyModel, EventModel, ProjectModel, RecurrenceModel, RecurringTimeSpan, ResourceModel, ResourceTimeRangeModel, TimeSpan, PresetManager, PresetStore, ViewPreset, RectangularPathFinder, ScheduleTableExporter, HorizontalTimeAxis, RecurrenceCombo, RecurrenceConfirmationPopup, RecurrenceDaysButtonGroup, RecurrenceDaysCombo, RecurrenceEditor, RecurrenceFrequencyCombo, RecurrenceLegendButton, RecurrenceMonthDaysButtonGroup, RecurrenceMonthsButtonGroup, RecurrencePositionsCombo, RecurrenceStopConditionCombo, Scheduler, SchedulerBase, TimeAxisViewModel, ResourceFilter, ResourceCombo, UndoRedo, SchedulerTag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_js_bundle_polyfills_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scripts/js/bundle-polyfills.js */ "../scripts/js/bundle-polyfills.js");
/* harmony import */ var _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./webpack.entry.js */ "./webpack.entry.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Base"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Config"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GlobalEvents", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GlobalEvents"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["AjaxStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomDataStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DomDataStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Duration"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["BooleanDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DateDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntegerDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["IntegerDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ModelDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["NumberDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ObjectDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["StringDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Model"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTrackingManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["StateTrackingManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Store"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Transaction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["AjaxHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ArrayHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AsyncHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["AsyncHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BrowserHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["BrowserHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CSSHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CSSHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DateHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomClassList", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DomClassList"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DomHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomSync", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DomSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DragHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["FunctionHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IdHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["IdHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ObjectHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RandomGenerator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RandomGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResizeHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeMonitor", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResizeMonitor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["StringHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TemplateHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VersionHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["VersionHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["WidgetHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataGenerator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DataGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DemoBot", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DemoBot"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Formatter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Formatter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fullscreen", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Fullscreen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberFormat", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["NumberFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Objects", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Objects"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Point"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Promissory", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Promissory"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rectangle", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Rectangle"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scroller", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Scroller"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["LocaleManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Localizable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Localizable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["LocaleHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Delayable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Delayable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Draggable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Draggable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Droppable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Droppable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Events"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Factoryable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Factoryable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Featureable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Featureable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Finalizable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Finalizable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hoverable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Hoverable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InstancePlugin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["InstancePlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Override", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Override"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pluggable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Pluggable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "State", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["State"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bag", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Bag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickRepeater", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ClickRepeater"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Collection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionFilter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CollectionFilter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionSorter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CollectionSorter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DragContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragProxy", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DragProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTipProxy", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DragTipProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DynamicObject", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DynamicObject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Month", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Month"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Parser"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Badge"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["BooleanCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Button"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ButtonGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarPanel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CalendarPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Checkbox"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipView", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ChipView"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Combo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Combo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Container"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DateField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DatePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateTimeField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DateTimeField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DisplayField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DisplayField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DurationField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Editor", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Editor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Field"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["FileField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["FilePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["FilterField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["List"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Mask"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Menu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["MenuItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MessageDialog", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["MessageDialog"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["NumberField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PagingToolbar", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["PagingToolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Panel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Popup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Renderable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Renderable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Ripple"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Slider"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Splitter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Splitter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TabPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextAreaField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TextAreaField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TextField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimePicker", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Toast"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tool", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Tool"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Toolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Tooltip"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Widget", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Widget"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ActionColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AggregateColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["AggregateColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CheckColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Column"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DateColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PercentColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["PercentColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RatingColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowNumberColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RowNumberColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TemplateColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TreeColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["WidgetColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ColumnStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridRowModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GridRowModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CellEdit", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CellEdit"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CellMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CellMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CellTooltip", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CellTooltip"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnAutoWidth", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ColumnAutoWidth"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnDragToolbar", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ColumnDragToolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnPicker", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ColumnPicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnReorder", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ColumnReorder"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnResize", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ColumnResize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ContextMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Filter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Filter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterBar", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["FilterBar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridFeatureManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GridFeatureManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Group", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Group"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["HeaderMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuickFind", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["QuickFind"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RegionResize", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RegionResize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowReorder", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RowReorder"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Search", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Search"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Sort", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Sort"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Stripe", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Stripe"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tree", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Tree"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileFormat", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["FileFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridExportDialog", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GridExportDialog"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridMultiPageExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GridMultiPageExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridMultiPageVerticalExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GridMultiPageVerticalExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridPdfExport", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GridPdfExport"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridSinglePageExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GridSinglePageExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExportOrientationCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ExportOrientationCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExportRowsCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ExportRowsCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalizableCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["LocalizableCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Orientation", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Orientation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PaperFormat", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["PaperFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowsRange", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RowsRange"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridExcelExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GridExcelExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScrollManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ScrollManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TableExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Footer", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Footer"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Grid"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GridBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Header"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RowManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RowManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeGrid", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TreeGrid"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["AbstractCrudManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxTransport", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["AjaxTransport"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManagerView", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CrudManagerView"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonEncoder", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["JsonEncoder"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractRecurrenceIterator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["AbstractRecurrenceIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["AssignmentStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["CrudManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectCrudManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ProjectCrudManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DailyRecurrenceIterator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DailyRecurrenceIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DependencyStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MonthlyRecurrenceIterator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["MonthlyRecurrenceIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceDayRuleEncoder", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceDayRuleEncoder"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceLegend", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceLegend"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectConsumer", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ProjectConsumer"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringEventsMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurringEventsMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpansMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurringTimeSpansMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResourceStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResourceTimeRangeStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxis", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeAxis"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WeeklyRecurrenceIterator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["WeeklyRecurrenceIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "YearlyRecurrenceIterator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["YearlyRecurrenceIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnLines", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ColumnLines"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Dependencies", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Dependencies"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyEdit", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DependencyEdit"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DragBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyCreation", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DependencyCreation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventContextMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventContextMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventDrag", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventDrag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventDragCreate", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventDragCreate"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventDragSelect", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventDragSelect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventEdit", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventEdit"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventFilter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventFilter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventResize", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventResize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventTooltip", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventTooltip"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GroupSummary", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["GroupSummary"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderContextMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["HeaderContextMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderZoom", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["HeaderZoom"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Labels", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Labels"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NonWorkingTime", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["NonWorkingTime"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pan", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Pan"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringEventEdit", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurringEventEdit"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRanges", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResourceTimeRanges"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleContextMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ScheduleContextMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ScheduleMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleTooltip", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ScheduleTooltip"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SimpleEventEdit", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["SimpleEventEdit"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Summary", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Summary"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisHeaderMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeAxisHeaderMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeRanges", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeRanges"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpanMenuBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeSpanMenuBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpanRecordContextMenuBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeSpanRecordContextMenuBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiPageExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["MultiPageExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiPageVerticalExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["MultiPageVerticalExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PdfExport", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["PdfExport"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerExportDialog", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerExportDialog"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SinglePageExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["SinglePageExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleRangeCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ScheduleRangeCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleRange", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ScheduleRange"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExcelExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ExcelExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceInfoColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResourceInfoColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisColumn", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeAxisColumn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["AssignmentModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyBaseModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DependencyBaseModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["DependencyModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["EventModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ProjectModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpan", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurringTimeSpan"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResourceModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResourceTimeRangeModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpan", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeSpan"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PresetManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["PresetManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PresetStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["PresetStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ViewPreset", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ViewPreset"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RectangularPathFinder", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RectangularPathFinder"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScheduleTableExporter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ScheduleTableExporter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HorizontalTimeAxis", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["HorizontalTimeAxis"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceConfirmationPopup", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceConfirmationPopup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceDaysButtonGroup", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceDaysButtonGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceDaysCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceDaysCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceEditor", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceEditor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceFrequencyCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceFrequencyCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceLegendButton", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceLegendButton"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceMonthDaysButtonGroup", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceMonthDaysButtonGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceMonthsButtonGroup", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceMonthsButtonGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrencePositionsCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrencePositionsCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceStopConditionCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["RecurrenceStopConditionCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["Scheduler"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeAxisViewModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["TimeAxisViewModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceFilter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResourceFilter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["ResourceCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["UndoRedo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerTag", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerTag"]; });

var productName = 'scheduler'; // Polyfills




/***/ })

/******/ });
});
//# sourceMappingURL=scheduler.umd.js.map